import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CustomGenericScalar: any;
  Date: any;
  DateTime: any;
  Decimal: any;
  GenericScalar: any;
  JSONScalar: any;
  JSONString: any;
  Time: any;
  UUID: any;
  _numeric: any;
  _varchar: any;
  bigint: any;
  date: any;
  float8: any;
  geography: any;
  geometry: any;
  jsonb: any;
  numeric: any;
  smallint: any;
  time: any;
  timestamptz: any;
  uuid: any;
};

export type AccountGlType = {
  __typename?: 'AccountGlType';
  account_type: AccountTypeGlType;
  /** Final Outstanding Amount */
  balance: Scalars['Float'];
  bank_detail?: Maybe<BankDetailGlType>;
  baseuser_set: Array<BaseUserGlType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by: BaseUserGlType;
  distributioncentre_set: Array<DistributionCentreGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  object_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserGlType>;
};

export type AccountTypeGlType = {
  __typename?: 'AccountTypeGlType';
  account_set: Array<AccountGlType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** An enumeration. */
export enum ActionLogActionFlag {
  /** Create */
  Create = 'CREATE',
  /** Delete */
  Delete = 'DELETE',
  /** Update */
  Update = 'UPDATE'
}

export type ActionLogType = {
  __typename?: 'ActionLogType';
  action_flag: ActionLogActionFlag;
  base_user: BaseUserType;
  change_message: Scalars['String'];
  change_object?: Maybe<Scalars['JSONScalar']>;
  content_type: GeneralContentType;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  object_id: Scalars['Int'];
  updated_at: Scalars['DateTime'];
};

export type AddAdvanceTransactionMutation = {
  __typename?: 'AddAdvanceTransactionMutation';
  transaction?: Maybe<TransactionType>;
};

export type AddResultComment = {
  __typename?: 'AddResultComment';
  result_comment?: Maybe<ResultCommentType>;
};

export type AddUpdateAgreementTransactionMutation = {
  __typename?: 'AddUpdateAgreementTransactionMutation';
  transaction_obj?: Maybe<AgreementTransactionType>;
};

export type AddUpdateBaseUser = {
  __typename?: 'AddUpdateBaseUser';
  base_user?: Maybe<BaseUserType>;
};

export type AddUpdateBusinessMutation = {
  __typename?: 'AddUpdateBusinessMutation';
  business?: Maybe<BusinessType>;
};

export type AddUpdateCreditMutation = {
  __typename?: 'AddUpdateCreditMutation';
  credit?: Maybe<CreditType>;
};

export type AddUpdateCreditMutationInput = {
  credit_limit_factor?: InputMaybe<Scalars['Float']>;
  financial_year_assessments?: InputMaybe<Array<InputMaybe<FinancialYearAssessmentInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  payment_cycle_days?: InputMaybe<Scalars['Int']>;
  projection_assessment?: InputMaybe<ProjectionAssessmentInput>;
  total_amount?: InputMaybe<Scalars['Float']>;
  trade_assessment?: InputMaybe<TradeAssessmentInput>;
  user_id?: InputMaybe<Scalars['Int']>;
  /** In days */
  validity?: InputMaybe<Scalars['Int']>;
};

export type AddUpdateDemandMutation = {
  __typename?: 'AddUpdateDemandMutation';
  demand?: Maybe<DemandType>;
};

export type AddUpdateDockDetailMutation = {
  __typename?: 'AddUpdateDockDetailMutation';
  dock_detail?: Maybe<DockDetailGlType>;
};

export type AddUpdateGeneralRequest = {
  __typename?: 'AddUpdateGeneralRequest';
  request?: Maybe<RequestType>;
};

export type AddUpdateInternalRequests = {
  __typename?: 'AddUpdateInternalRequests';
  internal_request?: Maybe<RequestType>;
};

export type AddUpdateIssuanceNoteMutation = {
  __typename?: 'AddUpdateIssuanceNoteMutation';
  issuance_note?: Maybe<IssuanceNoteType>;
};

export type AddUpdateOfferMutation = {
  __typename?: 'AddUpdateOfferMutation';
  offer?: Maybe<OfferType>;
};

export type AddUpdateOrderTransactionMutation = {
  __typename?: 'AddUpdateOrderTransactionMutation';
  order_transaction?: Maybe<OrderTransactionGlType>;
};

export type AddUpdateProductionTradeFinalMutation = {
  __typename?: 'AddUpdateProductionTradeFinalMutation';
  production_trade: ProductionTradeType;
};

export type AddUpdateProductionTradePlanningMutation = {
  __typename?: 'AddUpdateProductionTradePlanningMutation';
  production_trade: ProductionTradeType;
};

export type AddUpdateReceipt = {
  __typename?: 'AddUpdateReceipt';
  receipt: ReceiptType;
};

export type AddUpdateResultMutation = {
  __typename?: 'AddUpdateResultMutation';
  sample?: Maybe<SampleType>;
};

export type AddUpdateSampleObservations = {
  __typename?: 'AddUpdateSampleObservations';
  sample?: Maybe<SampleType>;
};

export type AddUpdateStorageLocationMutation = {
  __typename?: 'AddUpdateStorageLocationMutation';
  storage_location?: Maybe<StorageLocationType>;
};

export type AddUpdateTestRequests = {
  __typename?: 'AddUpdateTestRequests';
  sample_request?: Maybe<SampleRequestType>;
};

export type AddUpdateTradeMutation = {
  __typename?: 'AddUpdateTradeMutation';
  trade: TradeType;
};

export type AddUpdateTripMutation = {
  __typename?: 'AddUpdateTripMutation';
  trip?: Maybe<TripType>;
};

/** An enumeration. */
export enum AddressAddressKind {
  /** Collection Centre */
  Collection = 'COLLECTION',
  /** Depot */
  Depot = 'DEPOT',
  /** Distribution Centre */
  Distribution = 'DISTRIBUTION',
  /** Farm */
  Farm = 'FARM',
  /** Field */
  Field = 'FIELD',
  /** Home */
  Home = 'HOME',
  /** Market Yard */
  Market = 'MARKET',
  /** Other */
  Other = 'OTHER',
  /** Plot */
  Plot = 'PLOT',
  /** Work */
  Work = 'WORK'
}

export type AddressGlInput = {
  address?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  geofence_radius?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  pincode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type AddressGlType = {
  __typename?: 'AddressGlType';
  address?: Maybe<Scalars['String']>;
  billed_orders: Array<OrderGlType>;
  booking?: Maybe<BookingGlType>;
  depot_set: Array<DepotGlType>;
  distributioncentre_set: Array<DistributionCentreGlType>;
  district?: Maybe<Scalars['String']>;
  dock_set: Array<DockGlType>;
  /** Vendor's Business Address */
  familygroup_set: Array<FamilyGroupGlType>;
  /** Specify raduis if it is geofence */
  geofence_radius: Scalars['Int'];
  geopoint?: Maybe<GeometryObjectType>;
  geopoint_flipped?: Maybe<GeometryObjectType>;
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  mediaentity_set: Array<MediaGlType>;
  order_set: Array<OrderGlType>;
  pincode?: Maybe<Scalars['String']>;
  plot_set: Array<PlotGlType>;
  shipping_set: Array<ShippingGlType>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  users_located: Array<BaseUserGlType>;
  village: Scalars['String'];
  w3w_name?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  local_area?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type AddressQcType = {
  __typename?: 'AddressQCType';
  address_kind: AddressAddressKind;
  country: Scalars['String'];
  created_at: Scalars['DateTime'];
  district: Scalars['String'];
  id: Scalars['ID'];
  local_area: Scalars['String'];
  location: GeometryObjectType;
  media_set: Array<MediaQcType>;
  name: Scalars['String'];
  pincode: Scalars['String'];
  raw_address?: Maybe<Scalars['String']>;
  /** current gps location from where request is raised */
  request_set: Array<TestRequestType>;
  state: Scalars['String'];
  taluka: Scalars['String'];
  updated_at: Scalars['DateTime'];
  village: Scalars['String'];
};

export type AdvancePaymentInput = {
  amount: Scalars['Decimal'];
  bourn_by: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  parameter_id: Scalars['ID'];
};

export type AdvanceSummaryDashboardType = {
  __typename?: 'AdvanceSummaryDashboardType';
  advance_status_pending?: Maybe<Scalars['Int']>;
  released_advance_amount?: Maybe<Scalars['Float']>;
  requested_advance_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_amount?: Maybe<Scalars['Float']>;
};

export type AdvanceSummaryType = {
  __typename?: 'AdvanceSummaryType';
  advance_used_in_current_trade?: Maybe<Scalars['Float']>;
  advance_used_in_other_trades?: Maybe<Scalars['Float']>;
  released_advance?: Maybe<Scalars['Float']>;
  remaining_advance?: Maybe<Scalars['Float']>;
  requested_advance?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
};

export type AdvanceTransactionInput = {
  account_no?: InputMaybe<Scalars['String']>;
  advance_payment_id: Scalars['ID'];
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['ID']>;
  mode_id: Scalars['ID'];
  receipt_id?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['ID']>;
  transaction_id: Scalars['String'];
};

export type AgentCompanyType = {
  __typename?: 'AgentCompanyType';
  accepts_tnc: Scalars['Boolean'];
  agent: AgentType;
  company: CompanyType;
  id: Scalars['ID'];
};

export type AgentDepartmentType = {
  __typename?: 'AgentDepartmentType';
  agent?: Maybe<AgentType>;
  department?: Maybe<DepartmentType>;
  id: Scalars['ID'];
};

export type AgentLogin = {
  __typename?: 'AgentLogin';
  me?: Maybe<BaseUserType>;
  payload: Scalars['GenericScalar'];
  redirect_to?: Maybe<Scalars['String']>;
  refresh_expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token: Scalars['String'];
};

export type AgentType = {
  __typename?: 'AgentType';
  accepts_tnc: Scalars['Boolean'];
  codename: Scalars['String'];
  companies: Array<AgentCompanyType>;
  current_department?: Maybe<DepartmentType>;
  departments?: Maybe<Array<Maybe<AgentDepartmentType>>>;
  description?: Maybe<Scalars['String']>;
  /** Agents employee id */
  eid: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** Required. Company phone number. */
  number: Scalars['String'];
  organisation: OrganisationIdNameType;
  photo_url?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user: BaseUserType;
};

export type AggregateInvoiceSummaryType = {
  __typename?: 'AggregateInvoiceSummaryType';
  buyer_credit_note_amount?: Maybe<OperationValueType>;
  buyer_debit_note_amount?: Maybe<OperationValueType>;
  buyer_expense_amount?: Maybe<OperationValueType>;
  buyer_expense_tax_amount?: Maybe<OperationValueType>;
  buyer_tax_amount?: Maybe<OperationValueType>;
  deducted_amount?: Maybe<OperationValueType>;
  department_settlement_remaining_amount?: Maybe<Scalars['Float']>;
  department_settlement_settled_amount?: Maybe<Scalars['Float']>;
  department_settlement_total_amount?: Maybe<Scalars['Float']>;
  received_amount?: Maybe<OperationValueType>;
  total?: Maybe<Scalars['Float']>;
};

export type AggregateSupplierGroupPlot = {
  __typename?: 'AggregateSupplierGroupPlot';
  crop_count?: Maybe<Scalars['Int']>;
  farmer_document_count?: Maybe<Scalars['Int']>;
  mutual_group?: Maybe<MutualGroupType>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_document_count?: Maybe<Scalars['Int']>;
  supplier_count?: Maybe<Scalars['Int']>;
  tag_count?: Maybe<Scalars['Int']>;
  total_area?: Maybe<Scalars['Float']>;
  village_count?: Maybe<Scalars['Int']>;
};

export type AgreementDetailsType = {
  __typename?: 'AgreementDetailsType';
  attachments?: Maybe<Array<Maybe<AgreementMediaDetailsType>>>;
  end_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  is_active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  next_payment?: Maybe<NextPaymentType>;
  rent_amount?: Maybe<Scalars['Float']>;
  start_date?: Maybe<Scalars['String']>;
};

export type AgreementMediaDetailsType = {
  __typename?: 'AgreementMediaDetailsType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AgreementTransactionInput = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Float']>;
  attachments_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  bank_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  mode_of_payment?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  transaction_date?: InputMaybe<Scalars['Date']>;
  transaction_id?: InputMaybe<Scalars['String']>;
};

export type AgreementTransactionType = {
  __typename?: 'AgreementTransactionType';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  agreement: StorageLocationAgreementType;
  amount: Scalars['Float'];
  bank_name: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  id: Scalars['ID'];
  ifsc_code: Scalars['String'];
  mode_of_payment: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  transaction_date: Scalars['Date'];
  transaction_id: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type AllStorageLocationsFilterInput = {
  agreement_end_date_from?: InputMaybe<Scalars['Date']>;
  agreement_end_date_to?: InputMaybe<Scalars['Date']>;
  agreement_is_active?: InputMaybe<Scalars['Boolean']>;
  agreement_is_verified?: InputMaybe<Scalars['Boolean']>;
  agreement_lease_tenure_kind?: InputMaybe<Scalars['String']>;
  agreement_ownership_kind?: InputMaybe<Scalars['String']>;
  agreement_start_date_from?: InputMaybe<Scalars['Date']>;
  agreement_start_date_to?: InputMaybe<Scalars['Date']>;
  storage_location_created_at_from?: InputMaybe<Scalars['Date']>;
  storage_location_created_at_to?: InputMaybe<Scalars['Date']>;
  sub_location_kind?: InputMaybe<Scalars['ID']>;
};

export type AnalyticalDepartmentType = {
  __typename?: 'AnalyticalDepartmentType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  trades?: Maybe<Array<Maybe<AnalyticalTradeType>>>;
};

export type AnalyticalQueryFilterInput = {
  department_codenames?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type AnalyticalTradeType = {
  __typename?: 'AnalyticalTradeType';
  final_conversion_count?: Maybe<Scalars['Float']>;
  final_conversion_pending_count?: Maybe<Scalars['Float']>;
  /** In KG */
  invoice_quantity?: Maybe<Scalars['Float']>;
  invoice_value?: Maybe<Scalars['Float']>;
  /** In KG */
  inward_quantity?: Maybe<Scalars['Float']>;
  inward_value?: Maybe<Scalars['Float']>;
  kind?: Maybe<Scalars['String']>;
  pending_invoices?: Maybe<Scalars['Float']>;
  pending_inwards?: Maybe<Scalars['Float']>;
  total_invoices?: Maybe<Scalars['Float']>;
  total_inwards?: Maybe<Scalars['Float']>;
  /** In KG */
  total_quantity?: Maybe<Scalars['Float']>;
  total_transactions?: Maybe<Scalars['Float']>;
  total_value?: Maybe<Scalars['Float']>;
  /** In KG */
  unverified_quantity?: Maybe<Scalars['Float']>;
  unverified_transactions?: Maybe<Scalars['Float']>;
  unverified_value?: Maybe<Scalars['Float']>;
  /** In KG */
  verified_quantity?: Maybe<Scalars['Float']>;
  verified_transactions?: Maybe<Scalars['Float']>;
  verified_value?: Maybe<Scalars['Float']>;
};

export type ApproveCreditMutation = {
  __typename?: 'ApproveCreditMutation';
  credit?: Maybe<CreditType>;
};

export type ApproveCreditMutationInput = {
  id?: InputMaybe<Scalars['ID']>;
  is_approved?: InputMaybe<Scalars['Boolean']>;
  payment_cycle_days?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['Float']>;
  /** In days */
  validity?: InputMaybe<Scalars['Int']>;
};

export type ApproveCreditWalletRequestInput = {
  credit_wallet_request_id: Scalars['ID'];
  is_approved: Scalars['Boolean'];
  payment_cycle_days?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['Float']>;
  validity?: InputMaybe<Scalars['Int']>;
};

export type ApproveCreditWalletRequestMutation = {
  __typename?: 'ApproveCreditWalletRequestMutation';
  credit_wallet?: Maybe<CreditWalletType>;
};

export type ApproveOverDraftRequest = {
  __typename?: 'ApproveOverDraftRequest';
  over_draft?: Maybe<OverDraftType>;
};

export type AssociateBaseUserWithOrganisations = {
  __typename?: 'AssociateBaseUserWithOrganisations';
  redirect_to?: Maybe<Scalars['String']>;
  user?: Maybe<BaseUserType>;
};

export type BankDetailGlType = {
  __typename?: 'BankDetailGlType';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  account_set: Array<AccountGlType>;
  attachments: Array<MediaGlType>;
  branch_name: Scalars['String'];
  id: Scalars['ID'];
  ifsc_code: Scalars['String'];
  object_id?: Maybe<Scalars['Int']>;
  user?: Maybe<BaseUserGlType>;
};

export type BaseUserAggregationType = {
  __typename?: 'BaseUserAggregationType';
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<UserContactType>;
  country?: Maybe<RegionType>;
  date_of_birth?: Maybe<Scalars['Date']>;
  district?: Maybe<RegionType>;
  documents?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
  education?: Maybe<Scalars['String']>;
  farm_count?: Maybe<Scalars['Int']>;
  field_acreage?: Maybe<Scalars['Float']>;
  field_count?: Maybe<Scalars['Int']>;
  first_name?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_agent?: Maybe<Scalars['Boolean']>;
  is_shareholder?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  last_active_on_mobile?: Maybe<Scalars['DateTime']>;
  last_active_on_web?: Maybe<Scalars['DateTime']>;
  last_name?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['JSONScalar']>;
  metadata?: Maybe<Scalars['JSONScalar']>;
  mutual_group?: Maybe<MutualGroupType>;
  network_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  organisation_user_tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  organisations?: Maybe<Array<Maybe<OrganisationType>>>;
  photo?: Maybe<SetuMediaType>;
  pincode?: Maybe<Scalars['String']>;
  plot_acreage?: Maybe<Scalars['Float']>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
  primary_contact?: Maybe<UserContactTypeV2>;
  reference_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  secondary_contact?: Maybe<UserContactTypeV2>;
  state?: Maybe<RegionType>;
  taluka?: Maybe<RegionType>;
  teams?: Maybe<Array<Maybe<MutualGroupSummaryType>>>;
  user_documents_count?: Maybe<Scalars['Int']>;
  user_kind?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
  village?: Maybe<RegionType>;
};

export type BaseUserAggregationTypeWithTotal = {
  __typename?: 'BaseUserAggregationTypeWithTotal';
  records?: Maybe<Array<Maybe<BaseUserAggregationType>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BaseUserCreateEditMutation = {
  __typename?: 'BaseUserCreateEditMutation';
  current_address?: Maybe<KiteAddressType>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_shareholder?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  mutual_groups?: Maybe<Array<Maybe<MutualGroupType>>>;
  number?: Maybe<Scalars['String']>;
  number_country_code?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  secondary_number_country_code?: Maybe<Scalars['String']>;
  subscription_type?: Maybe<Scalars['String']>;
  to_extend_existing_user?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['String']>;
  village?: Maybe<VillageDataType>;
  village_codename?: Maybe<Scalars['String']>;
  village_id?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BaseUserGender {
  /** Female */
  Fm = 'FM',
  /** Male */
  Ml = 'ML'
}

export type BaseUserGlType = {
  __typename?: 'BaseUserGlType';
  address?: Maybe<AddressGlType>;
  current_department?: Maybe<FmsDepartmentType>;
  customer_id: Scalars['String'];
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  departments: Array<FmsDepartmentType>;
  distributioncentre_set: Array<DistributionCentreGlType>;
  documents?: Maybe<Array<Maybe<CertificationGlType>>>;
  email: Scalars['String'];
  family_group?: Maybe<FamilyGroupGlType>;
  full_name?: Maybe<Scalars['String']>;
  gender?: Maybe<BaseUserGender>;
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups: Array<GroupGlType>;
  id: Scalars['ID'];
  kite_reference_id?: Maybe<Scalars['String']>;
  /** Primary phone number user for contact purposes */
  number: Scalars['String'];
  primary_dcs: Array<DistributionCentreGlType>;
  reference_id: Scalars['String'];
};

export type BaseUserInput = {
  address?: InputMaybe<KiteAddressInput>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  companies_owned?: InputMaybe<Array<InputMaybe<CompaniesOwnedInput>>>;
  data_consent?: InputMaybe<KiteMediaInput>;
  date_of_birth?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  father_mother_spouse_name?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONString']>;
  mutual_group_id?: InputMaybe<Scalars['ID']>;
  name_as_per_pan?: InputMaybe<Scalars['String']>;
  nationality_id?: InputMaybe<Scalars['ID']>;
  networks?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  number?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  payment_options?: InputMaybe<Array<InputMaybe<PaymentDetailInput>>>;
  photo?: InputMaybe<KiteMediaInput>;
  preferred_language?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

/** An enumeration. */
export enum BaseUserPreferredLanguage {
  /** Afrikaans */
  Af = 'AF',
  /** Arabic */
  Ar = 'AR',
  /** Algerian Arabic */
  ArDz = 'AR_DZ',
  /** Asturian */
  Ast = 'AST',
  /** Azerbaijani */
  Az = 'AZ',
  /** Belarusian */
  Be = 'BE',
  /** Bulgarian */
  Bg = 'BG',
  /** Bengali */
  Bn = 'BN',
  /** Breton */
  Br = 'BR',
  /** Bosnian */
  Bs = 'BS',
  /** Catalan */
  Ca = 'CA',
  /** Czech */
  Cs = 'CS',
  /** Welsh */
  Cy = 'CY',
  /** Danish */
  Da = 'DA',
  /** German */
  De = 'DE',
  /** Lower Sorbian */
  Dsb = 'DSB',
  /** Greek */
  El = 'EL',
  /** English */
  En = 'EN',
  /** Australian English */
  EnAu = 'EN_AU',
  /** British English */
  EnGb = 'EN_GB',
  /** Esperanto */
  Eo = 'EO',
  /** Spanish */
  Es = 'ES',
  /** Argentinian Spanish */
  EsAr = 'ES_AR',
  /** Colombian Spanish */
  EsCo = 'ES_CO',
  /** Mexican Spanish */
  EsMx = 'ES_MX',
  /** Nicaraguan Spanish */
  EsNi = 'ES_NI',
  /** Venezuelan Spanish */
  EsVe = 'ES_VE',
  /** Estonian */
  Et = 'ET',
  /** Basque */
  Eu = 'EU',
  /** Persian */
  Fa = 'FA',
  /** Finnish */
  Fi = 'FI',
  /** French */
  Fr = 'FR',
  /** Frisian */
  Fy = 'FY',
  /** Irish */
  Ga = 'GA',
  /** Scottish Gaelic */
  Gd = 'GD',
  /** Galician */
  Gl = 'GL',
  /** Hebrew */
  He = 'HE',
  /** Hindi */
  Hi = 'HI',
  /** Croatian */
  Hr = 'HR',
  /** Upper Sorbian */
  Hsb = 'HSB',
  /** Hungarian */
  Hu = 'HU',
  /** Armenian */
  Hy = 'HY',
  /** Interlingua */
  Ia = 'IA',
  /** Indonesian */
  Id = 'ID',
  /** Igbo */
  Ig = 'IG',
  /** Ido */
  Io = 'IO',
  /** Icelandic */
  Is = 'IS',
  /** Italian */
  It = 'IT',
  /** Japanese */
  Ja = 'JA',
  /** Georgian */
  Ka = 'KA',
  /** Kabyle */
  Kab = 'KAB',
  /** Kazakh */
  Kk = 'KK',
  /** Khmer */
  Km = 'KM',
  /** Kannada */
  Kn = 'KN',
  /** Korean */
  Ko = 'KO',
  /** Kyrgyz */
  Ky = 'KY',
  /** Luxembourgish */
  Lb = 'LB',
  /** Lithuanian */
  Lt = 'LT',
  /** Latvian */
  Lv = 'LV',
  /** Macedonian */
  Mk = 'MK',
  /** Malayalam */
  Ml = 'ML',
  /** Mongolian */
  Mn = 'MN',
  /** Marathi */
  Mr = 'MR',
  /** Burmese */
  My = 'MY',
  /** Norwegian Bokmål */
  Nb = 'NB',
  /** Nepali */
  Ne = 'NE',
  /** Dutch */
  Nl = 'NL',
  /** Norwegian Nynorsk */
  Nn = 'NN',
  /** Ossetic */
  Os = 'OS',
  /** Punjabi */
  Pa = 'PA',
  /** Polish */
  Pl = 'PL',
  /** Portuguese */
  Pt = 'PT',
  /** Brazilian Portuguese */
  PtBr = 'PT_BR',
  /** Romanian */
  Ro = 'RO',
  /** Russian */
  Ru = 'RU',
  /** Slovak */
  Sk = 'SK',
  /** Slovenian */
  Sl = 'SL',
  /** Albanian */
  Sq = 'SQ',
  /** Serbian */
  Sr = 'SR',
  /** Serbian Latin */
  SrLatn = 'SR_LATN',
  /** Swedish */
  Sv = 'SV',
  /** Swahili */
  Sw = 'SW',
  /** Tamil */
  Ta = 'TA',
  /** Telugu */
  Te = 'TE',
  /** Tajik */
  Tg = 'TG',
  /** Thai */
  Th = 'TH',
  /** Turkmen */
  Tk = 'TK',
  /** Turkish */
  Tr = 'TR',
  /** Tatar */
  Tt = 'TT',
  /** Udmurt */
  Udm = 'UDM',
  /** Ukrainian */
  Uk = 'UK',
  /** Urdu */
  Ur = 'UR',
  /** Uzbek */
  Uz = 'UZ',
  /** Vietnamese */
  Vi = 'VI',
  /** Simplified Chinese */
  ZhHans = 'ZH_HANS',
  /** Traditional Chinese */
  ZhHant = 'ZH_HANT'
}

/** An enumeration. */
export enum BaseUserSendForVerificationStatus {
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Verified */
  Verified = 'VERIFIED'
}

/**
 * This mutation will mostly be used to quickly set and send passwords
 * to a user.
 */
export type BaseUserSendPasswordMutation = {
  __typename?: 'BaseUserSendPasswordMutation';
  id?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BaseUserStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Busy */
  Busy = 'BUSY',
  /** In Active */
  Inactive = 'INACTIVE'
}

/** An enumeration. */
export enum BaseUserSubscriptionType {
  /** Organisation Subscribed */
  OrganisationSubscribed = 'ORGANISATION_SUBSCRIBED',
  /** Self Onboarded */
  SelfOnboarded = 'SELF_ONBOARDED',
  /** Self Subscribed */
  SelfSubscribed = 'SELF_SUBSCRIBED',
  /** Soilometer App Subscribed */
  SoilometerAppSubscribed = 'SOILOMETER_APP_SUBSCRIBED'
}

export type BaseUserType = {
  __typename?: 'BaseUserType';
  actionlog_set: Array<ActionLogType>;
  address_book: Array<KiteAddressType>;
  agent?: Maybe<AgentType>;
  agents: Array<AgentType>;
  allowed_roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Level 1 Approval Done By */
  baseuser_set: Array<BaseUserType>;
  block_remark?: Maybe<Scalars['String']>;
  business_set: Array<BusinessType>;
  companies: Array<CompanyType>;
  companies_owned: Array<CompanyShareHolderType>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  current_address?: Maybe<KiteAddressType>;
  current_department?: Maybe<DepartmentType>;
  data_consent?: Maybe<MediaType>;
  date_joined: Scalars['DateTime'];
  date_of_birth: Scalars['Date'];
  departments: Array<DepartmentType>;
  devices: Array<DeviceType>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  documents_document_created: Array<DocumentType>;
  documents_document_updated: Array<DocumentType>;
  documents_document_verified: Array<DocumentType>;
  education: Scalars['String'];
  email: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  father_mother_spouse_name?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  full_name?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  groups: Array<UserGroupType>;
  id: Scalars['ID'];
  is_blocked?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  last_active_on_mobile?: Maybe<Scalars['DateTime']>;
  last_active_on_web?: Maybe<Scalars['DateTime']>;
  last_login?: Maybe<Scalars['DateTime']>;
  last_name: Scalars['String'];
  metadata: Scalars['JSONString'];
  mutual_groups: Array<MutualGroupType>;
  mutualgroupmembership_set: Array<MutualGroupMembersipType>;
  my_businesses: Array<BusinessType>;
  my_farms: Array<FarmType>;
  my_fields: Array<FieldType>;
  my_plot_crops: Array<PlotCropDetailType>;
  my_plots: Array<DjangoPlotType>;
  name_as_per_pan?: Maybe<Scalars['String']>;
  networks?: Maybe<Array<Maybe<NetworkType>>>;
  /** Required. 10-digit unique phone number. */
  number: Scalars['String'];
  number_country_code: Scalars['String'];
  occupation?: Maybe<Scalars['String']>;
  organisation_organisation_created: Array<OrganisationIdNameType>;
  organisation_organisation_updated: Array<OrganisationIdNameType>;
  payment_options?: Maybe<Array<Maybe<PaymentDetailType>>>;
  payment_paymentdetail_created: Array<PaymentDetailType>;
  payment_paymentdetail_updated: Array<PaymentDetailType>;
  payment_paymentdetail_verified: Array<PaymentDetailType>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  photo?: Maybe<MediaType>;
  /** Level 1 Approval Done By */
  plot_set: Array<DjangoPlotType>;
  /** Level 1 Approval Done By */
  plotcrop_set: Array<PlotCropDetailType>;
  preferred_language: BaseUserPreferredLanguage;
  preferred_payment_option?: Maybe<PaymentDetailType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  reference_id: Scalars['String'];
  secondary_number: Scalars['String'];
  secondary_number_country_code: Scalars['String'];
  /** Level 1 Approval Remark */
  send_for_verification_remark?: Maybe<Scalars['String']>;
  /** Level 1 Approval Status */
  send_for_verification_status?: Maybe<BaseUserSendForVerificationStatus>;
  status: BaseUserStatus;
  subscription_type: BaseUserSubscriptionType;
  /** System level verification based on Organisation specs on documents. */
  system_verified: Scalars['Boolean'];
  trade_business_created: Array<BusinessType>;
  trade_business_updated: Array<BusinessType>;
  trade_business_verified: Array<BusinessType>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  /** Level 1 Approval Done By */
  verification_done_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done On */
  verification_done_on?: Maybe<Scalars['DateTime']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** Level 1 Approval Done By */
  verified_businesses: Array<BusinessType>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
  /** Village of the user, if available */
  village?: Maybe<VillageDataType>;
  vt_core_baseuser_created: Array<BaseUserType>;
  vt_core_baseuser_updated: Array<BaseUserType>;
  vt_core_baseuser_verified: Array<BaseUserType>;
  vt_core_mutualgroup_created: Array<MutualGroupType>;
  vt_core_mutualgroup_updated: Array<MutualGroupType>;
  vt_core_mutualgroup_verified: Array<MutualGroupType>;
  vt_plot_farm_created: Array<FarmType>;
  vt_plot_farm_updated: Array<FarmType>;
  vt_plot_farm_verified: Array<FarmType>;
  vt_plot_field_created: Array<FieldType>;
  vt_plot_field_updated: Array<FieldType>;
  vt_plot_field_verified: Array<FieldType>;
  vt_plot_plot_created: Array<DjangoPlotType>;
  vt_plot_plot_updated: Array<DjangoPlotType>;
  vt_plot_plot_verified: Array<DjangoPlotType>;
  vt_plot_plotcrop_created: Array<PlotCropDetailType>;
  vt_plot_plotcrop_updated: Array<PlotCropDetailType>;
  vt_plot_plotcrop_verified: Array<PlotCropDetailType>;
  vt_plot_plotcropgrowthstage_created: Array<PlotCropGrowthStageType>;
  vt_plot_plotcropgrowthstage_updated: Array<PlotCropGrowthStageType>;
  vt_plot_plotcropmilestone_created: Array<PlotCropMilestoneType>;
  vt_plot_plotcropmilestone_updated: Array<PlotCropMilestoneType>;
};

export type BillingDocGlType = {
  __typename?: 'BillingDocGlType';
  billing_doc_number: Scalars['String'];
  erp_ref_code: Scalars['String'];
  id: Scalars['ID'];
  invoice?: Maybe<MediaGlType>;
  invoice_document_path?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONString'];
  order: OrderGlType;
  trip?: Maybe<TripGlType>;
};

export type BookingGlFilterInput = {
  approval_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  booking_id?: InputMaybe<Scalars['ID']>;
  date__gte?: InputMaybe<Scalars['Date']>;
  date__lte?: InputMaybe<Scalars['Date']>;
  destination_dc_id?: InputMaybe<Scalars['ID']>;
  gate_pass_no?: InputMaybe<Scalars['String']>;
  order_item_id?: InputMaybe<Scalars['ID']>;
  qc_request_created_by_id?: InputMaybe<Scalars['String']>;
  sellable_item_id?: InputMaybe<Scalars['ID']>;
  source_dc_id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trip_id?: InputMaybe<Scalars['ID']>;
  trip_status__nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BookingGlType = {
  __typename?: 'BookingGlType';
  accepted_qty_dev_sum?: Maybe<Scalars['Float']>;
  accepted_qty_sum?: Maybe<Scalars['Float']>;
  approval_status?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inwards: Array<InwardGlType>;
  loaded_skus: Scalars['Int'];
  order_item?: Maybe<OrderItemGlType>;
  procured_quantity: Scalars['Int'];
  qc_request_created_by_id?: Maybe<Scalars['String']>;
  quality_rejection_weight_sum?: Maybe<Scalars['Float']>;
  requests?: Maybe<Array<Maybe<RequestType>>>;
  required_quantity: Scalars['Int'];
  schedule: ScheduleGlType;
  status: BookingStatus;
  trip?: Maybe<TripGlType>;
  uom_count_sum?: Maybe<Scalars['Float']>;
};


export type BookingGlTypeRequestsArgs = {
  filter?: InputMaybe<RequestFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  primary_location_entity_type?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BookingStatus {
  /** Booked */
  Bkd = 'BKD',
  /** Confirmed by Aggregator */
  Cfa = 'CFA',
  /** Confirmed by Supplier */
  Cff = 'CFF',
  /** Completed */
  Cmp = 'CMP',
  /** Cancelled */
  Cnl = 'CNL',
  /** Inwarding */
  Inw = 'INW',
  /** Picked up */
  Pkd = 'PKD'
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BrandType = {
  __typename?: 'BrandType';
  codename: Scalars['String'];
  company: Array<ExternalEntityType>;
  created_at: Scalars['DateTime'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  templates: Array<TemplateType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type BroadcastConsents = {
  __typename?: 'BroadcastConsents';
  buyer_status?: Maybe<Scalars['Boolean']>;
  seller_status?: Maybe<Scalars['Boolean']>;
};

export type BulkMilestoneRecordInputType = {
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  plot_crop_milestone_id?: InputMaybe<Scalars['Int']>;
};

export type BulkUpdateBaseUserCompaniesMutation = {
  __typename?: 'BulkUpdateBaseUserCompaniesMutation';
  users?: Maybe<Array<Maybe<BaseUserType>>>;
};

export type BulkUpdateOrderMutation = {
  __typename?: 'BulkUpdateOrderMutation';
  order?: Maybe<Array<Maybe<OrderGlType>>>;
};

export type BulkUpdateResultGradesInput = {
  department_id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  result_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sample_id?: InputMaybe<Scalars['ID']>;
  template_id?: InputMaybe<Scalars['ID']>;
  test_request_id?: InputMaybe<Scalars['ID']>;
};

export type BulkUpdateResultGradesPayload = {
  __typename?: 'BulkUpdateResultGradesPayload';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  updated_count?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum BusinessCategory {
  /** Registered */
  Registered = 'REGISTERED',
  /** Unregistered */
  Unregistered = 'UNREGISTERED'
}

/** An enumeration. */
export enum BusinessKind {
  /** Cooperative */
  Cooperative = 'COOPERATIVE',
  /** Farmer Producer Organisation */
  Fpo = 'FPO',
  /** Other */
  Other = 'OTHER',
  /** Partnership Firm (LLP) */
  PartnershipLlp = 'PARTNERSHIP_LLP',
  /** Pvt. Ltd. Company */
  PrivateLimited = 'PRIVATE_LIMITED',
  /** Proprietor */
  Proprietor = 'PROPRIETOR',
  /** Public Ltd. Company */
  PublicLimited = 'PUBLIC_LIMITED',
  /** Section 8 Company (Foundation) */
  Section_8 = 'SECTION_8',
  /** Section 25 Company */
  Section_25 = 'SECTION_25'
}

/** An enumeration. */
export enum BusinessSendForVerificationStatus {
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Verified */
  Verified = 'VERIFIED'
}

export type BusinessType = {
  __typename?: 'BusinessType';
  address?: Maybe<KiteAddressType>;
  alternate_email: Scalars['String'];
  category?: Maybe<BusinessCategory>;
  codename: Scalars['String'];
  commodities_supplied: Array<CommodityType>;
  companies: Array<CompanyType>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  data_consent?: Maybe<MediaType>;
  description?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  incorporated_on?: Maybe<Scalars['Date']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  kind: BusinessKind;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  number: Scalars['String'];
  primary_poc?: Maybe<BaseUserType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  secondary_number: Scalars['String'];
  secondary_pocs: Array<BaseUserType>;
  /** Level 1 Approval Remark */
  send_for_verification_remark?: Maybe<Scalars['String']>;
  /** Level 1 Approval Status */
  send_for_verification_status?: Maybe<BusinessSendForVerificationStatus>;
  /** System level verification based on SOP mandatory fields for Trader/Dealer. */
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done By */
  verification_done_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done On */
  verification_done_on?: Maybe<Scalars['DateTime']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type BuyerBifurcationType = {
  __typename?: 'BuyerBifurcationType';
  buyer_credit_note_amount?: Maybe<OperationValueType>;
  buyer_debit_note_amount?: Maybe<OperationValueType>;
  buyer_expense_amount?: Maybe<OperationValueType>;
  buyer_expense_tax_amount?: Maybe<OperationValueType>;
  buyer_tax_amount?: Maybe<OperationValueType>;
  deducted_amount?: Maybe<OperationValueType>;
  received_amount?: Maybe<OperationValueType>;
  total?: Maybe<Scalars['Float']>;
};

export type BuyerCreditWalletInfoType = {
  __typename?: 'BuyerCreditWalletInfoType';
  actual_exposure?: Maybe<Scalars['Float']>;
  avg_overdue_days?: Maybe<Scalars['String']>;
  credit_limit?: Maybe<Scalars['Float']>;
  credit_limit_available?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['ID']>;
  current_trade_consumed?: Maybe<Scalars['Float']>;
  department_settlement_remaining_amount?: Maybe<Scalars['Float']>;
  department_settlement_settled_amount?: Maybe<Scalars['Float']>;
  department_settlement_total_amount?: Maybe<Scalars['Float']>;
  dynamic_available?: Maybe<Scalars['Float']>;
  last_overdue_approval_count?: Maybe<Scalars['Int']>;
  latest_verified_credit_wallet_request_id?: Maybe<Scalars['ID']>;
  overdraft_count?: Maybe<Scalars['Int']>;
  overdue_amount?: Maybe<Scalars['Float']>;
  overdue_count?: Maybe<Scalars['Int']>;
  parent_consumed?: Maybe<Scalars['Float']>;
  requested_overdraft_count?: Maybe<Scalars['Int']>;
  requested_overdue_approval_count?: Maybe<Scalars['Int']>;
  shadow_exposure?: Maybe<Scalars['Float']>;
  total_exposure?: Maybe<Scalars['Float']>;
  unsettled_overdraft_count?: Maybe<Scalars['Int']>;
  used_overdraft?: Maybe<Scalars['Float']>;
};

export type CancelInvoiceMutation = {
  __typename?: 'CancelInvoiceMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type CancelTransactionMutation = {
  __typename?: 'CancelTransactionMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type CapacityUsageType = {
  __typename?: 'CapacityUsageType';
  occupied_percentage?: Maybe<Scalars['Float']>;
  remaining_space?: Maybe<Scalars['String']>;
  sub_locations?: Maybe<Array<Maybe<SubLocationInfoType>>>;
  used_space?: Maybe<Scalars['String']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  display_value?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type CertificationGlType = {
  __typename?: 'CertificationGlType';
  attachments: Array<MediaGlType>;
  certification_type: CertificationGraphGlType;
  id: Scalars['ID'];
  id_number: Scalars['String'];
  is_verified: Scalars['Boolean'];
  issued_by: Scalars['String'];
  object_id: Scalars['Int'];
  photo?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  valid_from?: Maybe<Scalars['Date']>;
  valid_till?: Maybe<Scalars['Date']>;
};

export type CertificationGraphGlType = {
  __typename?: 'CertificationGraphGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  name: Scalars['String'];
};

export type ChangeCreditStatus = {
  __typename?: 'ChangeCreditStatus';
  credit?: Maybe<CreditType>;
};

export type ChangeCreditStatusInput = {
  id?: InputMaybe<Scalars['ID']>;
  status_id?: InputMaybe<Scalars['String']>;
};

export type ChemicalListData = {
  __typename?: 'ChemicalListData';
  chemical_id?: Maybe<Scalars['ID']>;
  chemical_name?: Maybe<Scalars['String']>;
};

export type ChemicalListOutput = {
  __typename?: 'ChemicalListOutput';
  data?: Maybe<Array<Maybe<ChemicalListData>>>;
  data_count?: Maybe<Scalars['Int']>;
};

export type ChemicalWiseCountData = {
  __typename?: 'ChemicalWiseCountData';
  chemical_id?: Maybe<Scalars['ID']>;
  chemical_name?: Maybe<Scalars['String']>;
  detection_count?: Maybe<Scalars['Int']>;
  detection_percent?: Maybe<Scalars['Float']>;
  fail_count?: Maybe<Scalars['Int']>;
  fail_percent?: Maybe<Scalars['Float']>;
  pass_count?: Maybe<Scalars['Int']>;
  pass_percent?: Maybe<Scalars['Float']>;
  sr_no?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
  trace_count?: Maybe<Scalars['Int']>;
  trace_percent?: Maybe<Scalars['Float']>;
};

export type ChemicalWiseCountInput = {
  first?: InputMaybe<Scalars['Int']>;
  result_filters?: InputMaybe<ResultFilters>;
  result_observation_filters?: InputMaybe<ResultObservationFilters>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type ChemicalWiseCountOutput = {
  __typename?: 'ChemicalWiseCountOutput';
  data?: Maybe<Array<Maybe<ChemicalWiseCountData>>>;
  data_count?: Maybe<Scalars['Int']>;
};

export type ChemicalWiseFailData = {
  __typename?: 'ChemicalWiseFailData';
  chemical_id?: Maybe<Scalars['ID']>;
  chemical_name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  percent?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['String']>;
};

export type ChemicalWiseFailInput = {
  first?: InputMaybe<Scalars['Int']>;
  result_filters?: InputMaybe<ResultFilters>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type ChemicalWiseFailOutput = {
  __typename?: 'ChemicalWiseFailOutput';
  data?: Maybe<Array<Maybe<ChemicalWiseFailData>>>;
  data_count?: Maybe<Scalars['Int']>;
};

export type ChemicalsListInput = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  result_observation_filters?: InputMaybe<ResultObservationFilters>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type CloseAdvancePaymentMutation = {
  __typename?: 'CloseAdvancePaymentMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type ClosePlotCrop = {
  __typename?: 'ClosePlotCrop';
  codename?: Maybe<Scalars['String']>;
  farm_codename?: Maybe<Scalars['String']>;
  field_codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_name?: Maybe<Scalars['String']>;
  plot_codename?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

export type CommodityGlType = {
  __typename?: 'CommodityGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  kite_codename?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CommodityGroupGlType = {
  __typename?: 'CommodityGroupGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  kite_codename?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sku_type?: Maybe<SkuTypeGlType>;
};

export type CommodityType = {
  __typename?: 'CommodityType';
  business_set: Array<BusinessType>;
  codename?: Maybe<Scalars['String']>;
  crop?: Maybe<CropType>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<MediaType>;
  private_metadata: Scalars['JSONString'];
  varieties: Array<CommodityVarietyType>;
};

export type CommodityVarietyGlType = {
  __typename?: 'CommodityVarietyGlType';
  commodity: CommodityGlType;
  groups: Array<CommodityGroupGlType>;
  id: Scalars['ID'];
  kite_codename?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  primary_group?: Maybe<CommodityGroupGlType>;
  reference_id: Scalars['String'];
};

export type CommodityVarietyType = {
  __typename?: 'CommodityVarietyType';
  codename?: Maybe<Scalars['String']>;
  commodity: CommodityType;
  created_at: Scalars['DateTime'];
  crop_variety?: Maybe<CropVarietyType>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<MediaType>;
  private_metadata: Scalars['JSONString'];
  updated_at: Scalars['DateTime'];
  variety_grades: Array<VarietyGradeType>;
};

export type CompaniesOwnedInput = {
  company_id: Scalars['ID'];
  shares: Scalars['Float'];
};

export type CompanyGlType = {
  __typename?: 'CompanyGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  display_name: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CompanyShareHolderType = {
  __typename?: 'CompanyShareHolderType';
  company: CompanyType;
  id: Scalars['ID'];
  share_holder: BaseUserType;
  /** This field is currently considered as share count, may be considered as percentage in future. */
  shares: Scalars['Float'];
};

export type CompanyType = {
  __typename?: 'CompanyType';
  /** Abbreviation for short name */
  abbreviation: Scalars['String'];
  /** The location details of the company, HQ or otherwise */
  address?: Maybe<KiteAddressType>;
  agents: Array<AgentCompanyType>;
  baseuser_set: Array<BaseUserType>;
  business_set: Array<BusinessType>;
  codename: Scalars['String'];
  departments: Array<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  /** Display name for showing on the website */
  display_name: Scalars['String'];
  fms_sync: Scalars['Boolean'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  networks: Array<NetworkType>;
  /** The company's phone number */
  number?: Maybe<Scalars['String']>;
  /** The organisation that manages the company */
  organisation?: Maybe<OrganisationIdNameType>;
  photo?: Maybe<MediaType>;
  purpose?: Maybe<Scalars['String']>;
  share_holders: Array<CompanyShareHolderType>;
  /** Terms and conditions */
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type CoordinatesType = {
  __typename?: 'CoordinatesType';
  coordinates?: Maybe<Scalars['JSONScalar']>;
};

export type CopyTradeToInwardMutation = {
  __typename?: 'CopyTradeToInwardMutation';
  trade?: Maybe<TradeType>;
};

export type CreateCreditWalletRequestInput = {
  financial_year_assessments?: InputMaybe<Array<InputMaybe<FinancialYearAssessmentCwInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  projection_assessment?: InputMaybe<ProjectionAssessmentCwInput>;
  remark?: InputMaybe<Scalars['String']>;
  requested_credit_limit_factor: Scalars['Float'];
  requested_payment_cycle_days: Scalars['Int'];
  requested_total_amount: Scalars['Float'];
  requested_validity: Scalars['Int'];
  trade_assessment?: InputMaybe<TradeAssessmentCwInput>;
  user_id: Scalars['ID'];
};

export type CreateCreditWalletRequestMutation = {
  __typename?: 'CreateCreditWalletRequestMutation';
  credit_wallet_request?: Maybe<CreditWalletRequestType>;
};

export type CreateExpenseConfigMutation = {
  __typename?: 'CreateExpenseConfigMutation';
  department_id?: Maybe<Scalars['Int']>;
  expenses_details?: Maybe<Array<Maybe<OrganisationTradeExpensesTemplateSchema>>>;
  trade_kind?: Maybe<Scalars['String']>;
  trade_mode?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type CreateGuarantorAgreement = {
  __typename?: 'CreateGuarantorAgreement';
  document?: Maybe<Scalars['String']>;
  guarantor_agreement_id?: Maybe<Scalars['ID']>;
  legal_agreement_id?: Maybe<Scalars['ID']>;
};

export type CreateOverDraftRequest = {
  __typename?: 'CreateOverDraftRequest';
  over_draft?: Maybe<OverDraftType>;
};

export type CreateTncConfigMutation = {
  __typename?: 'CreateTNCConfigMutation';
  conditions?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['Int']>;
  trade_kind?: Maybe<Scalars['String']>;
  trade_mode?: Maybe<Scalars['String']>;
  trade_party?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type CreditCustomType = {
  __typename?: 'CreditCustomType';
  avg_overdue_days?: Maybe<Scalars['String']>;
  last_transaction_date?: Maybe<Scalars['Date']>;
  last_transaction_value?: Maybe<Scalars['Float']>;
  overdue_amount?: Maybe<Scalars['Float']>;
  used_credit_booking_patti?: Maybe<Scalars['Float']>;
  used_credit_hishob_patti?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum CreditManagementOverDraftStatusChoices {
  /** Deviation Approved */
  DeviationApproved = 'DEVIATION_APPROVED',
  /** Deviation Rejected */
  DeviationRejected = 'DEVIATION_REJECTED',
  /** Deviation Requested */
  DeviationRequested = 'DEVIATION_REQUESTED',
  /** Final Approval */
  FinalApproval = 'FINAL_APPROVAL',
  /** Recommendation */
  Recommendation = 'RECOMMENDATION'
}

/** An enumeration. */
export enum CreditManagementOverDueApprovalLogFromStatusChoices {
  /** OverDue Approval Approved */
  OverdueApprovalApproved = 'OVERDUE_APPROVAL_APPROVED',
  /** OverDue Approval Final Approval */
  OverdueApprovalFinalApproval = 'OVERDUE_APPROVAL_FINAL_APPROVAL',
  /** OverDue Approval Recommendation */
  OverdueApprovalRecommendation = 'OVERDUE_APPROVAL_RECOMMENDATION',
  /** OverDue Approval Rejected */
  OverdueApprovalRejected = 'OVERDUE_APPROVAL_REJECTED',
  /** OverDue Approval Requested */
  OverdueApprovalRequested = 'OVERDUE_APPROVAL_REQUESTED',
  /** OverDue Approval Used */
  OverdueApprovalUsed = 'OVERDUE_APPROVAL_USED'
}

/** An enumeration. */
export enum CreditManagementOverDueApprovalLogStatusChoices {
  /** OverDue Approval Approved */
  OverdueApprovalApproved = 'OVERDUE_APPROVAL_APPROVED',
  /** OverDue Approval Final Approval */
  OverdueApprovalFinalApproval = 'OVERDUE_APPROVAL_FINAL_APPROVAL',
  /** OverDue Approval Recommendation */
  OverdueApprovalRecommendation = 'OVERDUE_APPROVAL_RECOMMENDATION',
  /** OverDue Approval Rejected */
  OverdueApprovalRejected = 'OVERDUE_APPROVAL_REJECTED',
  /** OverDue Approval Requested */
  OverdueApprovalRequested = 'OVERDUE_APPROVAL_REQUESTED',
  /** OverDue Approval Used */
  OverdueApprovalUsed = 'OVERDUE_APPROVAL_USED'
}

/** An enumeration. */
export enum CreditManagementOverDueApprovalStatusChoices {
  /** OverDue Approval Approved */
  OverdueApprovalApproved = 'OVERDUE_APPROVAL_APPROVED',
  /** OverDue Approval Final Approval */
  OverdueApprovalFinalApproval = 'OVERDUE_APPROVAL_FINAL_APPROVAL',
  /** OverDue Approval Recommendation */
  OverdueApprovalRecommendation = 'OVERDUE_APPROVAL_RECOMMENDATION',
  /** OverDue Approval Rejected */
  OverdueApprovalRejected = 'OVERDUE_APPROVAL_REJECTED',
  /** OverDue Approval Requested */
  OverdueApprovalRequested = 'OVERDUE_APPROVAL_REQUESTED',
  /** OverDue Approval Used */
  OverdueApprovalUsed = 'OVERDUE_APPROVAL_USED'
}

export type CreditNoteInput = {
  amount: Scalars['Decimal'];
  id?: InputMaybe<Scalars['ID']>;
  remarks?: InputMaybe<Scalars['String']>;
};

export type CreditRequestDetailType = {
  __typename?: 'CreditRequestDetailType';
  verified_by_custom?: Maybe<VerifiedByCustomType>;
};

export type CreditSummaryAggregatedInput = {
  /** Shared Entity ID */
  approved_by?: InputMaybe<Scalars['ID']>;
  created_from_date?: InputMaybe<Scalars['Date']>;
  created_to_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};

export type CreditSummaryAggregatedType = {
  __typename?: 'CreditSummaryAggregatedType';
  available_credit_limit?: Maybe<Scalars['Float']>;
  avg_overdue_days?: Maybe<Scalars['String']>;
  buyer_count?: Maybe<Scalars['Int']>;
  total_credit_limit?: Maybe<Scalars['Float']>;
  total_outstanding?: Maybe<Scalars['Float']>;
  used_credit_hishob_patti?: Maybe<Scalars['Float']>;
};

export type CreditSummaryType = {
  __typename?: 'CreditSummaryType';
  avg_payment_settlement_days?: Maybe<Scalars['Float']>;
  hishob_patti_count?: Maybe<Scalars['Float']>;
  hishob_patti_settled_count?: Maybe<Scalars['Float']>;
  hishob_patti_unsettled_count?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_hishob_patti_sale?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

export type CreditType = {
  __typename?: 'CreditType';
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  credit_limit_factor: Scalars['Float'];
  end_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  over_drafts: Array<OverDraftType>;
  over_due_approvals: Array<OverDueApprovalType>;
  payment_cycle_days: Scalars['Int'];
  remaining_amount: Scalars['Float'];
  start_date?: Maybe<Scalars['Date']>;
  total_amount: Scalars['Float'];
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount: Scalars['Float'];
  user: SharedEntityType;
  validity: Scalars['Int'];
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type CreditWalletInvoiceListCustomType = {
  __typename?: 'CreditWalletInvoiceListCustomType';
  created_on?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  invoice_no?: Maybe<Scalars['String']>;
  invoice_value?: Maybe<Scalars['Float']>;
  overdue_amount?: Maybe<Scalars['Float']>;
  overdue_days?: Maybe<Scalars['Int']>;
  placed_by?: Maybe<UserCustomType>;
  plant_name?: Maybe<Scalars['String']>;
  receivable_amount?: Maybe<Scalars['Float']>;
  received_amount?: Maybe<Scalars['Float']>;
  transaction_status?: Maybe<Scalars['String']>;
};

export type CreditWalletInvoiceSummaryType = {
  __typename?: 'CreditWalletInvoiceSummaryType';
  overdue_amount?: Maybe<Scalars['Float']>;
  overdue_days?: Maybe<Scalars['Int']>;
  payment_cleared_in_days?: Maybe<Scalars['Int']>;
  receivable_amount?: Maybe<Scalars['Float']>;
  received_amount?: Maybe<Scalars['Float']>;
  total_invoice_amount?: Maybe<Scalars['Float']>;
};

export type CreditWalletListCustomType = {
  __typename?: 'CreditWalletListCustomType';
  actual_exposure?: Maybe<Scalars['Float']>;
  avg_overdue_days?: Maybe<Scalars['String']>;
  buyer?: Maybe<UserCustomType>;
  created_on?: Maybe<Scalars['DateTime']>;
  credit_limit?: Maybe<Scalars['Float']>;
  credit_limit_approved_by?: Maybe<UserCustomType>;
  credit_limit_available?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['ID']>;
  deviation_amount_requested?: Maybe<Scalars['Float']>;
  deviation_os_approved?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  is_active?: Maybe<Scalars['Boolean']>;
  last_transaction_date?: Maybe<Scalars['Date']>;
  last_transaction_value?: Maybe<Scalars['Float']>;
  metadata?: Maybe<Scalars['GenericScalar']>;
  overdue_amount?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  shadow_exposure?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  status_metadata?: Maybe<Scalars['GenericScalar']>;
  total_exposure?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Int']>;
  validity_end_date?: Maybe<Scalars['Date']>;
  validity_start_date?: Maybe<Scalars['Date']>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type CreditWalletListResponseType = {
  __typename?: 'CreditWalletListResponseType';
  results?: Maybe<Array<Maybe<CreditWalletListCustomType>>>;
  total_records?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum CreditWalletOverDueApprovalCwStatusChoices {
  /** OverDue Approval Approved */
  OverdueApprovalApproved = 'OVERDUE_APPROVAL_APPROVED',
  /** OverDue Approval Final Approval */
  OverdueApprovalFinalApproval = 'OVERDUE_APPROVAL_FINAL_APPROVAL',
  /** OverDue Approval Recommendation */
  OverdueApprovalRecommendation = 'OVERDUE_APPROVAL_RECOMMENDATION',
  /** OverDue Approval Rejected */
  OverdueApprovalRejected = 'OVERDUE_APPROVAL_REJECTED',
  /** OverDue Approval Requested */
  OverdueApprovalRequested = 'OVERDUE_APPROVAL_REQUESTED'
}

/** An enumeration. */
export enum CreditWalletOverDueApprovalLogCwFromStatusChoices {
  /** OverDue Approval Approved */
  OverdueApprovalApproved = 'OVERDUE_APPROVAL_APPROVED',
  /** OverDue Approval Final Approval */
  OverdueApprovalFinalApproval = 'OVERDUE_APPROVAL_FINAL_APPROVAL',
  /** OverDue Approval Recommendation */
  OverdueApprovalRecommendation = 'OVERDUE_APPROVAL_RECOMMENDATION',
  /** OverDue Approval Rejected */
  OverdueApprovalRejected = 'OVERDUE_APPROVAL_REJECTED',
  /** OverDue Approval Requested */
  OverdueApprovalRequested = 'OVERDUE_APPROVAL_REQUESTED'
}

/** An enumeration. */
export enum CreditWalletOverDueApprovalLogCwStatusChoices {
  /** OverDue Approval Approved */
  OverdueApprovalApproved = 'OVERDUE_APPROVAL_APPROVED',
  /** OverDue Approval Final Approval */
  OverdueApprovalFinalApproval = 'OVERDUE_APPROVAL_FINAL_APPROVAL',
  /** OverDue Approval Recommendation */
  OverdueApprovalRecommendation = 'OVERDUE_APPROVAL_RECOMMENDATION',
  /** OverDue Approval Rejected */
  OverdueApprovalRejected = 'OVERDUE_APPROVAL_REJECTED',
  /** OverDue Approval Requested */
  OverdueApprovalRequested = 'OVERDUE_APPROVAL_REQUESTED'
}

export type CreditWalletRequestType = {
  __typename?: 'CreditWalletRequestType';
  approved_credit_limit_factor?: Maybe<Scalars['Decimal']>;
  approved_end_date?: Maybe<Scalars['Date']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_start_date?: Maybe<Scalars['Date']>;
  approved_total_amount?: Maybe<Scalars['Decimal']>;
  approved_validity?: Maybe<Scalars['Int']>;
  created_at: Scalars['DateTime'];
  credit_wallet: CreditWalletType;
  id: Scalars['ID'];
  is_verified?: Maybe<Scalars['Boolean']>;
  remark?: Maybe<Scalars['String']>;
  requested_by_id: Scalars['String'];
  requested_credit_limit_factor: Scalars['Decimal'];
  requested_date: Scalars['Date'];
  requested_payment_cycle_days: Scalars['Int'];
  requested_total_amount: Scalars['Decimal'];
  requested_validity: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['Date']>;
};

export type CreditWalletSummaryAggregatedInput = {
  /** Shared Entity ID */
  approved_by?: InputMaybe<Scalars['ID']>;
  created_from_date?: InputMaybe<Scalars['Date']>;
  created_to_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};

export type CreditWalletSummaryAggregatedType = {
  __typename?: 'CreditWalletSummaryAggregatedType';
  available_credit_limit?: Maybe<Scalars['Float']>;
  avg_overdue_days?: Maybe<Scalars['String']>;
  buyer_count?: Maybe<Scalars['Int']>;
  total_credit_limit?: Maybe<Scalars['Float']>;
  total_outstanding?: Maybe<Scalars['Float']>;
  used_credit_hishob_patti?: Maybe<Scalars['Float']>;
};

export type CreditWalletType = {
  __typename?: 'CreditWalletType';
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  credit_limit_factor: Scalars['Decimal'];
  end_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  over_due_approvals_cw: Array<OverDueApprovalCwType>;
  payment_cycle_days: Scalars['Int'];
  remaining_amount: Scalars['Decimal'];
  requests: Array<CreditWalletRequestType>;
  start_date?: Maybe<Scalars['Date']>;
  total_amount: Scalars['Decimal'];
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount: Scalars['Decimal'];
  used_overdraft: Scalars['Decimal'];
  user: SharedEntityType;
  validity: Scalars['Int'];
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type CropInfestationDetailType = {
  __typename?: 'CropInfestationDetailType';
  /** Affects */
  affects?: Maybe<Scalars['String']>;
  /** Biological measures */
  biological_measures?: Maybe<Scalars['String']>;
  category_name?: Maybe<Scalars['String']>;
  /** Chemical measures */
  chemical_measures?: Maybe<Scalars['String']>;
  crop: CropType;
  /** Cultural measures */
  cultural_measures?: Maybe<Scalars['String']>;
  /** Nature of damage */
  damage_nature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Calendar months of infestation */
  infestation_period?: Maybe<Scalars['String']>;
  /** Vegetative stage of infestation */
  infestation_stage?: Maybe<Scalars['String']>;
  /** Mechanical measures */
  mechanical_measures?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Feature photo */
  photo?: Maybe<MediaType>;
  /** Impact on produce quality */
  quality_impact?: Maybe<Scalars['String']>;
  /** Impact on produce quantity */
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  /** Symptoms */
  symptoms?: Maybe<Scalars['String']>;
  /** Favorable weather conditions */
  weather_conditions?: Maybe<Scalars['String']>;
};

export type CropInfestationListType = {
  __typename?: 'CropInfestationListType';
  category_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CropInfoType = {
  __typename?: 'CropInfoType';
  crop_image?: Maybe<Scalars['String']>;
  crop_name?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
};

export type CropMilestoneType = {
  __typename?: 'CropMilestoneType';
  crop: CropType;
  /** Whether this milestone should be used for day-based tracking (e.g. Days After Pruning) for a plot crop */
  day_tracking: Scalars['Boolean'];
  id?: Maybe<Scalars['Int']>;
  ignore_crop_year: Scalars['Boolean'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  milestone: MilestoneDetailType;
  /** Display order */
  order: Scalars['Int'];
  plotcropmilestone_set: Array<PlotCropMilestoneType>;
  /** Short label used when displaying day-tracking counts, e.g. 'DAP' */
  short_name: Scalars['String'];
};

export type CropType = {
  __typename?: 'CropType';
  codename: Scalars['String'];
  commodities: Array<CommodityType>;
  cropinfestation_set: Array<CropInfestationDetailType>;
  cropmilestone_set: Array<CropMilestoneType>;
  description?: Maybe<Scalars['String']>;
  /** The color representing a crop - used to visually represent crops in a plot */
  hex_color_code: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
  plotcrop_set: Array<PlotCropDetailType>;
  primarygrowthstage_set: Array<PrimaryGsType>;
  sowing_material_types?: Maybe<Array<Maybe<SowingMaterialTypeSchema>>>;
  sowingmaterialtype_set: Array<SowingMaterialTypeSchema>;
  varieties?: Maybe<Array<Maybe<CropVarietyType>>>;
};

export type CropVarietyType = {
  __typename?: 'CropVarietyType';
  codename: Scalars['String'];
  commodity_varieties: Array<CommodityVarietyType>;
  crop: CropType;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
  plotcrop_set: Array<PlotCropDetailType>;
};

export type CropYearType = {
  __typename?: 'CropYearType';
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  plotcrop_set: Array<PlotCropDetailType>;
  plotcropgrowthstage_set: Array<PlotCropGrowthStageType>;
  plotcropmilestone_set: Array<PlotCropMilestoneType>;
};

export type DemandAttachmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  media_id: Scalars['ID'];
  send_whatsapp?: InputMaybe<Scalars['Boolean']>;
};

export type DemandEnquiryInput = {
  id?: InputMaybe<Scalars['ID']>;
  seller_external_id?: InputMaybe<Scalars['ID']>;
  seller_id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  whatsapp_status?: InputMaybe<Scalars['String']>;
};

export type DemandExpenseInput = {
  expense_parameter_id: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  paid_by: Scalars['String'];
  value: Scalars['Decimal'];
};

export type DemandGlType = {
  __typename?: 'DemandGlType';
  broadcast_time: Scalars['DateTime'];
  created_at: Scalars['DateTime'];
  date: Scalars['Date'];
  id: Scalars['ID'];
  is_live: Scalars['Boolean'];
  name: Scalars['String'];
  updated_at: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type DemandType = {
  __typename?: 'DemandType';
  buyer?: Maybe<SharedEntityType>;
  buyer_expense: Scalars['Float'];
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity: SharedEntityType;
  commodity_variety?: Maybe<SharedEntityType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  deducted_amount: Scalars['Float'];
  department?: Maybe<SharedEntityType>;
  end_date_time: Scalars['DateTime'];
  facilitator?: Maybe<SharedEntityType>;
  id: Scalars['ID'];
  jr_officer?: Maybe<SharedEntityType>;
  material_kind?: Maybe<StockDemandMaterialKindChoices>;
  max_rate?: Maybe<Scalars['Float']>;
  mode: StockDemandModeChoices;
  packaging: StockDemandPackagingChoices;
  quantity: Scalars['Float'];
  /** Total quantity in kg */
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit?: Maybe<SharedEntityType>;
  rate: Scalars['Float'];
  rate_unit: SharedEntityType;
  seller_expense: Scalars['Float'];
  seller_groups: Array<SharedEntityType>;
  seller_source_kind: StockDemandSellerSourceKindChoices;
  seller_tnc?: Maybe<Scalars['String']>;
  sr_officer?: Maybe<SharedEntityType>;
  standard_deduction: Scalars['Float'];
  start_date_time: Scalars['DateTime'];
  status: StockDemandStatusChoices;
  total_amount: Scalars['Float'];
  trade_set: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  variety_grade?: Maybe<SharedEntityType>;
};

/** An enumeration. */
export enum DepartmentDepartmentType {
  /** Export Department */
  Ex = 'EX',
  /** Processing Department */
  Pr = 'PR',
  /** Retail Department */
  Rt = 'RT',
  /** Wholesale Department */
  Wh = 'WH'
}

export type DepartmentGlType = {
  __typename?: 'DepartmentGlType';
  active_members: Array<BaseUserGlType>;
  allowed_depots: Array<DepotGlType>;
  assigned_trips: Array<TripGlType>;
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  baseuser_set: Array<BaseUserGlType>;
  codename?: Maybe<Scalars['String']>;
  companies: Array<CompanyGlType>;
  control_pricing: Scalars['Boolean'];
  created_at: Scalars['DateTime'];
  default_per_unit: Array<SkuTypeGlType>;
  default_trader_varieties: Array<CommodityVarietyGlType>;
  demand_set: Array<DemandGlType>;
  demand_whatsapp_approval: Scalars['Boolean'];
  department_type: DepartmentDepartmentType;
  distributioncentre_set: Array<DistributionCentreGlType>;
  gate_entry_required: Scalars['Boolean'];
  generate_po_after_inward: Scalars['Boolean'];
  generate_po_plot_wise: Scalars['Boolean'];
  harvestprojection_set: Array<HarvestProjectionType>;
  has_dynamic_stock: Scalars['Boolean'];
  id: Scalars['ID'];
  invoice_type: DepartmentInvoiceType;
  inward_allocation: Scalars['Boolean'];
  kite_reference_id?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  new_gate_pass: Scalars['Boolean'];
  optional_pricing: Scalars['Boolean'];
  order_set: Array<OrderGlType>;
  packaging_material_flow: Scalars['Boolean'];
  photo?: Maybe<Scalars['String']>;
  preferred_depot?: Maybe<DepotGlType>;
  pricing_done_on?: Maybe<DepartmentPricingDoneOn>;
  purchase_under_zone_company: Scalars['Boolean'];
  qc_subscription: Scalars['Boolean'];
  schedule_set: Array<ScheduleGlType>;
  schedulerequest_set: Array<ScheduleRequestGlType>;
  sellableitem_set: Array<SellableItemGlType>;
  sellableitemstock_set: Array<SellableItemStockGlType>;
  send_inward_sms: Scalars['Boolean'];
  should_cross_po: Scalars['Boolean'];
  togo_subscription: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  varieties: Array<CommodityVarietyGlType>;
  vehicle_set: Array<VehicleGlType>;
  whatsapp_on_order_status: Scalars['Boolean'];
};

export type DepartmentInput = {
  codename?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum DepartmentInvoiceType {
  /** Sap Billing Doc */
  Spbd = 'SPBD',
  /** Sap Invoice */
  Spin = 'SPIN',
  /** Vesatogo Invoice */
  Vtin = 'VTIN'
}

/** An enumeration. */
export enum DepartmentPricingDoneOn {
  /** UOM Type */
  Qty = 'QTY',
  /** SKU Type */
  Sku = 'SKU'
}

/** An enumeration. */
export enum DepartmentSettlementKind {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type DepartmentType = {
  __typename?: 'DepartmentType';
  /** Abbreviation for short name */
  abbreviation: Scalars['String'];
  active_agents: Array<AgentType>;
  active_members: Array<BaseUserType>;
  /** The location details of the department, HQ or otherwise */
  address?: Maybe<KiteAddressType>;
  agents: Array<AgentDepartmentType>;
  baseuser_set: Array<BaseUserType>;
  codename: Scalars['String'];
  company?: Maybe<CompanyType>;
  description?: Maybe<Scalars['String']>;
  /** Display name for showing on the website */
  display_name: Scalars['String'];
  documents_document_created: Array<DocumentType>;
  external_reference_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  organisation_organisation_created: Array<OrganisationIdNameType>;
  payment_paymentdetail_created: Array<PaymentDetailType>;
  photo?: Maybe<MediaType>;
  trade_business_created: Array<BusinessType>;
  uid?: Maybe<Scalars['String']>;
  vt_core_baseuser_created: Array<BaseUserType>;
  vt_core_mutualgroup_created: Array<MutualGroupType>;
  vt_plot_farm_created: Array<FarmType>;
  vt_plot_field_created: Array<FieldType>;
  vt_plot_plot_created: Array<DjangoPlotType>;
  vt_plot_plotcrop_created: Array<PlotCropDetailType>;
  vt_plot_plotcropgrowthstage_created: Array<PlotCropGrowthStageType>;
  vt_plot_plotcropmilestone_created: Array<PlotCropMilestoneType>;
};

export type DepartmentUserAdvanceAggregateSummaryType = {
  __typename?: 'DepartmentUserAdvanceAggregateSummaryType';
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  unreleased_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
};

export type DepartmentUserAdvanceFilterInput = {
  created_from_date?: InputMaybe<Scalars['Date']>;
  created_to_date?: InputMaybe<Scalars['Date']>;
  department_codename?: InputMaybe<Scalars['ID']>;
  user_ref?: InputMaybe<Scalars['ID']>;
};

export type DepartmentUserAdvanceListWithSummaryType = {
  __typename?: 'DepartmentUserAdvanceListWithSummaryType';
  items?: Maybe<Array<Maybe<DepartmentUserAdvanceType>>>;
  summary?: Maybe<DepartmentUserAdvanceAggregateSummaryType>;
};

export type DepartmentUserAdvanceType = {
  __typename?: 'DepartmentUserAdvanceType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  department: SharedEntityType;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** amount in decimal */
  remaining_amount?: Maybe<Scalars['Decimal']>;
  /** amount in decimal */
  total_released_amount?: Maybe<Scalars['Decimal']>;
  /** amount in decimal */
  total_requested_amount?: Maybe<Scalars['Decimal']>;
  unreleased_amount?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
  /** amount in decimal */
  used_amount?: Maybe<Scalars['Decimal']>;
  user: SharedEntityType;
};

export type DepotGlInput = {
  codename?: InputMaybe<Scalars['String']>;
  /** EX(Export) / PR(Processing) / RT(Retail) / WH(Wholesale) */
  department_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DepotGlType = {
  __typename?: 'DepotGlType';
  codename: Scalars['String'];
  distribution_centre?: Maybe<DistributionCentreGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DetectionCountSummaryChartInput = {
  result_evaluation_filters?: InputMaybe<ResultEvaluationFilters>;
};

export type DetectionCountSummaryChartOutput = {
  __typename?: 'DetectionCountSummaryChartOutput';
  data?: Maybe<Scalars['GenericScalar']>;
};

export type DetectionCountSummaryGraphInput = {
  range?: InputMaybe<Array<InputMaybe<DetectionRangeInput>>>;
  result_evaluation_filters?: InputMaybe<ResultEvaluationFilters>;
};

export type DetectionCountSummaryGraphOutput = {
  __typename?: 'DetectionCountSummaryGraphOutput';
  range?: Maybe<Array<Maybe<DetectionCountSummaryGraphRangeOutput>>>;
  year?: Maybe<Scalars['String']>;
};

export type DetectionCountSummaryGraphRangeOutput = {
  __typename?: 'DetectionCountSummaryGraphRangeOutput';
  count?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type DetectionRangeInput = {
  from_count?: InputMaybe<Scalars['Int']>;
  to_count?: InputMaybe<Scalars['Int']>;
};

export type DeviceType = {
  __typename?: 'DeviceType';
  /** Version of the app */
  app_version?: Maybe<Scalars['String']>;
  base_user: BaseUserType;
  /** The name of the app package */
  bundle_id?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  /** The android device id */
  device_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  location?: Maybe<KiteAddressType>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  private_metadata: Scalars['JSONString'];
  token: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type DiscountGlType = {
  __typename?: 'DiscountGlType';
  banner?: Maybe<MediaGlType>;
  code: Scalars['String'];
  created_at: Scalars['DateTime'];
  discount_conditions: Scalars['JSONString'];
  end_date: Scalars['Date'];
  flat: Scalars['Float'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  order_set: Array<OrderGlType>;
  orderitem_set: Array<OrderItemGlType>;
  percentage: Scalars['Float'];
  start_date: Scalars['Date'];
  updated_at: Scalars['DateTime'];
};

export type DistributionCentreGlFilterInput = {
  assigned_cpc?: InputMaybe<Scalars['ID']>;
  assigned_cpc__isnull?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  department_codename?: InputMaybe<Scalars['String']>;
  is_manufacturing_plant?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DistributionCentreGlType = {
  __typename?: 'DistributionCentreGlType';
  address: AddressGlType;
  allowed_departments: Array<FmsDepartmentType>;
  assigned_cpc?: Maybe<DistributionCentreGlType>;
  codename: Scalars['String'];
  delivery_conditions?: Maybe<Scalars['JSONScalar']>;
  delivery_slots: Array<TimeSlotGlType>;
  depot?: Maybe<DepotGlType>;
  docks: Array<DockGlType>;
  id: Scalars['ID'];
  maintenance_slots: Array<TimeSlotGlType>;
  name: Scalars['String'];
  organisation?: Maybe<OrganisationGlObject>;
  photos: Array<MediaGlType>;
  pickup_slots: Array<TimeSlotGlType>;
  point_of_contacts: Array<BaseUserGlType>;
  primary_poc?: Maybe<BaseUserGlType>;
};

/**
 * PlotType is not compatible for accessing plots from
 * fields. This type helps to return the area_catered field in a consistent
 * format.
 */
export type DjangoPlotType = {
  __typename?: 'DjangoPlotType';
  area?: Maybe<Scalars['Float']>;
  area_unit?: Maybe<SiUnitType>;
  boundary?: Maybe<CoordinatesType>;
  /** Polygon centroid */
  centroid?: Maybe<GeometryObjectType>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  farmer: BaseUserType;
  field: FieldType;
  /** Internally used to filter fields to fix data */
  geo_area_remark?: Maybe<Scalars['Float']>;
  /** Area auto calculated by boundaries in acre */
  geo_bound_area?: Maybe<Scalars['Float']>;
  /** Geo bounds */
  geometry?: Maybe<GeometryObjectType>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this plot boundary */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  owner_name?: Maybe<Scalars['String']>;
  plotcrop_set: Array<PlotCropDetailType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** Level 1 Approval Remark */
  send_for_verification_remark?: Maybe<Scalars['String']>;
  /** Level 1 Approval Status */
  send_for_verification_status?: Maybe<PlotSendForVerificationStatus>;
  /** System level verification; set to False when geo boundary (area_catered) is missing. */
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done By */
  verification_done_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done On */
  verification_done_on?: Maybe<Scalars['DateTime']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type DockDetailGlType = {
  __typename?: 'DockDetailGlType';
  dock: DockGlType;
  id: Scalars['ID'];
  kind: DockDetailKind;
  supervisor: BaseUserGlType;
  trip: TripGlType;
};

/** An enumeration. */
export enum DockDetailKind {
  /** Delivery */
  Delivery = 'DELIVERY',
  /** Loading */
  Loading = 'LOADING',
  /** Unloading */
  Unloading = 'UNLOADING'
}

export type DockFilterGlInput = {
  depot_id__in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
};

export type DockGlType = {
  __typename?: 'DockGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  depot?: Maybe<DepotGlType>;
  distribution_centre?: Maybe<DistributionCentreGlType>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONScalar']>;
  name: Scalars['String'];
};

export type DocumentInput = {
  attachments?: InputMaybe<Array<InputMaybe<KiteMediaInput>>>;
  document_kind_codename?: InputMaybe<Scalars['String']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  document_kind_uid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_number?: InputMaybe<Scalars['String']>;
  issued_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  photo_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  remarks?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['Date']>;
  valid_till?: InputMaybe<Scalars['Date']>;
};

export type DocumentKindType = {
  __typename?: 'DocumentKindType';
  allowed_content_type: GeneralContentType;
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  document_set: Array<DocumentType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  /** Can Multiple Document be stored for a Content Type? */
  is_multiple: Scalars['Boolean'];
  /** The minimum number of attachements to be collected for thisdocument type */
  minimum_attachments?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  sequence_no: Scalars['Int'];
  /** Unique human readable name for particular document kind */
  uid?: Maybe<Scalars['String']>;
};

export type DocumentListResponseType = {
  __typename?: 'DocumentListResponseType';
  count?: Maybe<Scalars['Int']>;
  records?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  attachments: Array<MediaType>;
  content_type: GeneralContentType;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  document_kind: DocumentKindType;
  document_kind_name?: Maybe<Scalars['String']>;
  document_kind_uid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  id_number: Scalars['String'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  issued_by: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  object_id: Scalars['Int'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  /** System level verification based on Organisation specs on documents. */
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  valid_from?: Maybe<Scalars['Date']>;
  valid_till?: Maybe<Scalars['Date']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type DumpTradesMutation = {
  __typename?: 'DumpTradesMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
};

export type EcomMediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  media_type: Scalars['String'];
  url: Scalars['String'];
};

export type EmployeeOnboardMutation = {
  __typename?: 'EmployeeOnboardMutation';
  agent?: Maybe<AgentType>;
};

export type EntityAttributeObject = {
  __typename?: 'EntityAttributeObject';
  attribute_value?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
};

export type EntityStateType = {
  __typename?: 'EntityStateType';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  object_id: Scalars['Int'];
  state: StateType;
  updated_at: Scalars['DateTime'];
};

export enum EvaluationCriteriaCriteria {
  /** All */
  All = 'ALL',
  /** Any */
  Any = 'ANY'
}

export type EvaluationCriteriaType = {
  __typename?: 'EvaluationCriteriaType';
  created_at: Scalars['DateTime'];
  criteria: EvaluationCriteriaCriteria;
  id: Scalars['ID'];
  parameter_configurations: Array<TemplateParameterConfigType>;
  result: Scalars['Boolean'];
  tag: EvaluationTagType;
  updated_at: Scalars['DateTime'];
};

export type EvaluationTagType = {
  __typename?: 'EvaluationTagType';
  codename: Scalars['String'];
  color_code: Scalars['String'];
  company?: Maybe<ExternalEntityType>;
  criteria: Array<EvaluationCriteriaType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  resultobservation_set: Array<ResultObservationType>;
  sequence: Scalars['Int'];
};

export type ExpenseInput = {
  expense_parameter_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type ExpenseParameterType = {
  __typename?: 'ExpenseParameterType';
  codename: Scalars['String'];
  config_organisationtradeexpenseconfig_expense_parameters: Array<OrganisationTradeExpenseConfigType>;
  description: Scalars['String'];
  expenses: Array<ExpenseType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ExpenseType = {
  __typename?: 'ExpenseType';
  amount?: Maybe<Scalars['Decimal']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  expense_parameter: ExpenseParameterType;
  id: Scalars['ID'];
  kind: TradeExpenseKindChoices;
  paid_by: TradeExpensePaidByChoices;
  production_trade?: Maybe<ProductionTradeType>;
  receipt?: Maybe<ReceiptType>;
  trade?: Maybe<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
};

export type ExpensesConfigSchema = {
  expense_parameter_id: Scalars['Int'];
  kind: Scalars['String'];
  paid_by: Scalars['String'];
  value: Scalars['Float'];
};

export type ExportReportMutation = {
  __typename?: 'ExportReportMutation';
  export_url?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ExternalEntityInput = {
  entity_type: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  reference_id: Scalars['String'];
};

export type ExternalEntityType = {
  __typename?: 'ExternalEntityType';
  brand_set: Array<BrandType>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  departments_templates: Array<TemplateType>;
  description: Scalars['String'];
  entity_type: Scalars['String'];
  evaluation_tags: Array<EvaluationTagType>;
  grade_set: Array<GradeType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  location_requests: Array<TestRequestType>;
  markets: Array<MarketType>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  private_metadata: Scalars['JSONString'];
  quality_requests: Array<TestRequestType>;
  quality_templates: Array<TemplateType>;
  reference_id: Scalars['String'];
  request_set: Array<TestRequestType>;
  requests: Array<TestRequestType>;
  results: Array<ResultType>;
  samples: Array<SampleType>;
  template_set: Array<TemplateType>;
  templates: Array<TemplateType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type FmsDepartmentType = {
  __typename?: 'FMSDepartmentType';
  active_members: Array<BaseUserGlType>;
  allowed_depots: Array<DepotGlType>;
  assigned_trips: Array<TripGlType>;
  /** The department this user belongs to. A user will get all permissions for related commodities granted to each of their departments. */
  baseuser_set: Array<BaseUserGlType>;
  codename?: Maybe<Scalars['String']>;
  companies: Array<CompanyGlType>;
  control_pricing: Scalars['Boolean'];
  created_at: Scalars['DateTime'];
  default_per_unit: Array<SkuTypeGlType>;
  default_trader_varieties: Array<CommodityVarietyGlType>;
  demand_set: Array<DemandGlType>;
  demand_whatsapp_approval: Scalars['Boolean'];
  department_type: DepartmentDepartmentType;
  distributioncentre_set: Array<DistributionCentreGlType>;
  gate_entry_required: Scalars['Boolean'];
  generate_po_after_inward: Scalars['Boolean'];
  generate_po_plot_wise: Scalars['Boolean'];
  harvestprojection_set: Array<HarvestProjectionType>;
  has_dynamic_stock: Scalars['Boolean'];
  id: Scalars['ID'];
  invoice_type: DepartmentInvoiceType;
  inward_allocation: Scalars['Boolean'];
  kite_reference_id?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  new_gate_pass: Scalars['Boolean'];
  optional_pricing: Scalars['Boolean'];
  order_set: Array<OrderGlType>;
  packaging_material_flow: Scalars['Boolean'];
  photo?: Maybe<Scalars['String']>;
  preferred_depot?: Maybe<DepotGlType>;
  pricing_done_on?: Maybe<DepartmentPricingDoneOn>;
  purchase_under_zone_company: Scalars['Boolean'];
  qc_subscription: Scalars['Boolean'];
  schedule_set: Array<ScheduleGlType>;
  schedulerequest_set: Array<ScheduleRequestGlType>;
  sellableitem_set: Array<SellableItemGlType>;
  sellableitemstock_set: Array<SellableItemStockGlType>;
  send_inward_sms: Scalars['Boolean'];
  should_cross_po: Scalars['Boolean'];
  togo_subscription: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  varieties: Array<CommodityVarietyGlType>;
  vehicle_set: Array<VehicleGlType>;
  whatsapp_on_order_status: Scalars['Boolean'];
};

export type FamilyGroupGlType = {
  __typename?: 'FamilyGroupGlType';
  /** Vendor's Business Address */
  address?: Maybe<AddressGlType>;
  id: Scalars['ID'];
  leader?: Maybe<BaseUserGlType>;
  name: Scalars['String'];
};

export type FarmAggregationType = {
  __typename?: 'FarmAggregationType';
  codename?: Maybe<Scalars['String']>;
  farmer?: Maybe<BaseUserType>;
  field_count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
};

export type FarmType = {
  __typename?: 'FarmType';
  address: KiteAddressType;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  farmer: BaseUserType;
  field_set: Array<FieldType>;
  id?: Maybe<Scalars['Int']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  owner_name?: Maybe<Scalars['String']>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  /** System level verification flag. */
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type FieldRecordsType = {
  __typename?: 'FieldRecordsType';
  allow_field_creation?: Maybe<Scalars['Boolean']>;
  records?: Maybe<Array<Maybe<FieldType>>>;
};

export type FieldType = {
  __typename?: 'FieldType';
  address?: Maybe<KiteAddressType>;
  area?: Maybe<Scalars['Float']>;
  /** Geo bounds */
  area_catered?: Maybe<GeometryObjectType>;
  area_unit: SiUnitType;
  boundary?: Maybe<CoordinatesType>;
  /** Polygon centroid */
  centroid?: Maybe<GeometryObjectType>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  enable_plot_creation?: Maybe<Scalars['Boolean']>;
  farm: FarmType;
  farmer: BaseUserType;
  gat_no?: Maybe<Scalars['String']>;
  /** Internally used to filter fields to fix data */
  geo_area_remark?: Maybe<Scalars['Float']>;
  /** Area auto calculated by boundaries in acre */
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this field boundary */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_empty?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  mutual_group?: Maybe<MutualGroupType>;
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  owner_name?: Maybe<Scalars['String']>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
  plot_set: Array<DjangoPlotType>;
  plots?: Maybe<Array<Maybe<DjangoPlotType>>>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  region?: Maybe<VillageDataType>;
  soil: SoilType;
  /** System level verification; set to False when geo boundary (area_catered) is missing. */
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
  weather_reference_codename?: Maybe<Scalars['String']>;
};

export type FilterSampleInput = {
  detection_count?: InputMaybe<Scalars['Int']>;
  market_id?: InputMaybe<Scalars['Int']>;
  max_detection?: InputMaybe<Scalars['Float']>;
  sample_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  total_detection?: InputMaybe<Scalars['Float']>;
};

export type FinancialSummaryType = {
  __typename?: 'FinancialSummaryType';
  actual_expenses?: Maybe<Scalars['Float']>;
  actual_income?: Maybe<Scalars['Float']>;
  actual_profit?: Maybe<Scalars['Float']>;
  based_on_plot_crops?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['String']>;
  estimated_expenses?: Maybe<Scalars['Float']>;
  estimated_income?: Maybe<Scalars['Float']>;
  estimated_profit?: Maybe<Scalars['Float']>;
  exceeded_by?: Maybe<Scalars['Float']>;
  is_budget_low?: Maybe<Scalars['Boolean']>;
  is_expense_high?: Maybe<Scalars['Boolean']>;
  last_recorded_expense_date?: Maybe<Scalars['Date']>;
  last_recorded_expense_display_date?: Maybe<Scalars['String']>;
  last_recorded_income_date?: Maybe<Scalars['Date']>;
  last_recorded_income_display_date?: Maybe<Scalars['String']>;
  percent_actual_profit?: Maybe<Scalars['Float']>;
  percent_estimated_profit?: Maybe<Scalars['Float']>;
  percent_exceeded_by?: Maybe<Scalars['Float']>;
  percent_expenses_deviation?: Maybe<Scalars['Float']>;
  percent_income_deviation?: Maybe<Scalars['Float']>;
  percent_profit_deviation?: Maybe<Scalars['Float']>;
  percent_remaining_budget?: Maybe<Scalars['Float']>;
  remaining_budget?: Maybe<Scalars['Float']>;
  total_plot_crops?: Maybe<Scalars['Int']>;
};

export type FinancialTimelineTransactionType = {
  __typename?: 'FinancialTimelineTransactionType';
  activity_name?: Maybe<Scalars['String']>;
  activity_type?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<FinancialTransactionMediaType>>>;
  created_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['String']>;
  from_date?: Maybe<Scalars['Date']>;
  from_display_date?: Maybe<Scalars['String']>;
  hex_color_code?: Maybe<Scalars['String']>;
  icon_image_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_edited?: Maybe<Scalars['Boolean']>;
  purposes?: Maybe<Array<Maybe<PurposeAmountType>>>;
  record_date?: Maybe<Scalars['Date']>;
  record_display_date?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  transaction_category?: Maybe<Scalars['String']>;
  transaction_description?: Maybe<Scalars['String']>;
  transaction_notes?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
  transaction_type_display?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['String']>;
};

export type FinancialTransactionInsertType = {
  __typename?: 'FinancialTransactionInsertType';
  activity_id?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  from_date?: Maybe<Scalars['Date']>;
  from_display_date?: Maybe<Scalars['String']>;
  hons_earned?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['Date']>;
  record_display_date?: Maybe<Scalars['String']>;
  total_hons?: Maybe<Scalars['Int']>;
  transaction_description?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
};

export type FinancialTransactionMediaType = {
  __typename?: 'FinancialTransactionMediaType';
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
};

export type FinancialYearAssessmentCwInput = {
  attachment_id?: InputMaybe<Scalars['ID']>;
  capital?: InputMaybe<Scalars['Float']>;
  current_assets?: InputMaybe<Scalars['Float']>;
  current_liabilities?: InputMaybe<Scalars['Float']>;
  fixed_assets?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  profit_loss?: InputMaybe<Scalars['Float']>;
  total_sales?: InputMaybe<Scalars['Float']>;
  year_id?: InputMaybe<Scalars['ID']>;
};

export type FinancialYearAssessmentInput = {
  attachment_id?: InputMaybe<Scalars['ID']>;
  capital?: InputMaybe<Scalars['Float']>;
  current_assets?: InputMaybe<Scalars['Float']>;
  current_liabilities?: InputMaybe<Scalars['Float']>;
  fixed_assets?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  profit_loss?: InputMaybe<Scalars['Float']>;
  total_sales?: InputMaybe<Scalars['Float']>;
  year_id?: InputMaybe<Scalars['ID']>;
};

export type GeneralContentType = {
  __typename?: 'GeneralContentType';
  actionlog_set: Array<ActionLogType>;
  app_label: Scalars['String'];
  document_set: Array<DocumentType>;
  documentkind_set: Array<DocumentKindType>;
  id: Scalars['ID'];
  model: Scalars['String'];
  paymentdetail_set: Array<PaymentDetailType>;
};

export type GenerateAgentToken = {
  __typename?: 'GenerateAgentToken';
  token?: Maybe<Scalars['String']>;
};

export type GenerateBaseUserToken = {
  __typename?: 'GenerateBaseUserToken';
  token?: Maybe<Scalars['String']>;
};

export type GenerateEvaluations = {
  __typename?: 'GenerateEvaluations';
  results?: Maybe<Array<Maybe<ResultType>>>;
};

export type GenerateGenericToken = {
  __typename?: 'GenerateGenericToken';
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type GenerateInitialPalletRequest = {
  __typename?: 'GenerateInitialPalletRequest';
  request?: Maybe<RequestType>;
};

export type GenerateInvoiceMutation = {
  __typename?: 'GenerateInvoiceMutation';
  invoices?: Maybe<Array<Maybe<InvoiceType>>>;
};

export type GenerateOtp = {
  __typename?: 'GenerateOTP';
  status?: Maybe<Scalars['Boolean']>;
};

export type GenerateResults = {
  __typename?: 'GenerateResults';
  sample?: Maybe<SampleType>;
};

export type GenerateTradeOtp = {
  __typename?: 'GenerateTradeOTP';
  status?: Maybe<Scalars['Boolean']>;
};

/**
 *
 * `GeometryObjectType` represents a pair of values:
 * - Geometry `type`
 * - Geometry `coordinates`
 *
 */
export type GeometryObjectType = {
  __typename?: 'GeometryObjectType';
  coordinates?: Maybe<Scalars['GenericScalar']>;
  type?: Maybe<Scalars['String']>;
};

export type GradeType = {
  __typename?: 'GradeType';
  codename: Scalars['String'];
  company: Array<ExternalEntityType>;
  created_at: Scalars['DateTime'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  templates: Array<TemplateType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type GroupGlType = {
  __typename?: 'GroupGlType';
  allowed_dcs: Array<DistributionCentreGlType>;
  demand_set: Array<DemandGlType>;
  familygroup_set: Array<FamilyGroupGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  user_set: Array<BaseUserGlType>;
  /** Do not change! May result in inconsistencies. */
  visible_sellable_items: Array<SellableItemStockGlType>;
};

export type GroupType = {
  __typename?: 'GroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  user_set: Array<BaseUserType>;
};

export type GuarantorAreaExtensionDetailInput = {
  agreement_plot_id: Scalars['ID'];
  new_area: Scalars['Decimal'];
  nursery_amount: Scalars['Decimal'];
  old_area: Scalars['Decimal'];
  registration_amount: Scalars['Decimal'];
};

export type GuarantorPlotCoverageInput = {
  agreement_plot_id: Scalars['ID'];
  guarantee_nursery_fee: Scalars['Boolean'];
  guarantee_registration_fee: Scalars['Boolean'];
};

export type HarvestGradeGlType = {
  __typename?: 'HarvestGradeGlType';
  id: Scalars['ID'];
  name: Scalars['String'];
  specifications: Scalars['String'];
  variety?: Maybe<CommodityVarietyGlType>;
};

export type HarvestProjectionMetricsType = {
  __typename?: 'HarvestProjectionMetricsType';
  actual_containers: Scalars['Decimal'];
  actual_yield_mt: Scalars['Decimal'];
  area_acre: Scalars['Decimal'];
  estimated_containers: Scalars['Decimal'];
  estimated_yield_mt: Scalars['Decimal'];
  harvest_plots: Scalars['Int'];
  total_plots: Scalars['Int'];
  variety_count: Scalars['Int'];
  variety_group_count: Scalars['Int'];
};

export type HarvestProjectionPayloadType = {
  __typename?: 'HarvestProjectionPayloadType';
  count: Scalars['Int'];
  harvest_weeks: Array<Maybe<HarvestProjectionWeekType>>;
  pruning_weeks: Array<Maybe<HarvestProjectionWeekType>>;
  results: Array<Maybe<HarvestProjectionType>>;
  summary: HarvestProjectionMetricsType;
};

export type HarvestProjectionType = {
  __typename?: 'HarvestProjectionType';
  actual_containers?: Maybe<Scalars['Float']>;
  actual_yield_mt?: Maybe<Scalars['Float']>;
  codename: Scalars['String'];
  company?: Maybe<CompanyGlType>;
  created_at: Scalars['DateTime'];
  department?: Maybe<FmsDepartmentType>;
  description: Scalars['String'];
  estimated_containers?: Maybe<Scalars['Float']>;
  estimated_yield_mt: Scalars['Float'];
  harvesting_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  plot_commodity: PlotCommodityGlType;
  projected_area_acre: Scalars['Float'];
  pruning_date?: Maybe<Scalars['Date']>;
  quantity_unit?: Maybe<Scalars['String']>;
  season_name?: Maybe<Scalars['String']>;
  trade_year?: Maybe<TradeYearType>;
  updated_at: Scalars['DateTime'];
};

export type HarvestProjectionVarietyType = {
  __typename?: 'HarvestProjectionVarietyType';
  actual_containers: Scalars['Decimal'];
  actual_yield_mt: Scalars['Decimal'];
  area_acre: Scalars['Decimal'];
  estimated_containers: Scalars['Decimal'];
  estimated_yield_mt: Scalars['Decimal'];
  harvest_plots: Scalars['Int'];
  total_plots: Scalars['Int'];
  variety_count: Scalars['Int'];
  variety_group_count: Scalars['Int'];
  variety_id: Scalars['ID'];
  variety_name: Scalars['String'];
};

export type HarvestProjectionWeekType = {
  __typename?: 'HarvestProjectionWeekType';
  actual_containers: Scalars['Decimal'];
  actual_yield_mt: Scalars['Decimal'];
  area_acre: Scalars['Decimal'];
  estimated_containers: Scalars['Decimal'];
  estimated_yield_mt: Scalars['Decimal'];
  harvest_plots: Scalars['Int'];
  total_plots: Scalars['Int'];
  varieties: Array<Maybe<HarvestProjectionVarietyType>>;
  variety_count: Scalars['Int'];
  variety_group_count: Scalars['Int'];
  week_end: Scalars['Date'];
  week_number: Scalars['Int'];
  week_start: Scalars['Date'];
  year: Scalars['Int'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Packaging_Ordercreated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Packaging_Orderupdated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Tradecreated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Tradeupdated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Tripcreated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_Remote_Rel_Tripupdated_By = {
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InvoiceSummaryByUserType = {
  __typename?: 'InvoiceSummaryByUserType';
  department_settlement_remaining_amount?: Maybe<Scalars['Float']>;
  department_settlement_settled_amount?: Maybe<Scalars['Float']>;
  department_settlement_total_amount?: Maybe<Scalars['Float']>;
  overdue_amount?: Maybe<Scalars['Float']>;
  overdue_days?: Maybe<Scalars['Int']>;
  payment_cleared_in_days?: Maybe<Scalars['Int']>;
  received_amount?: Maybe<Scalars['Float']>;
  total_invoice_amount?: Maybe<Scalars['Float']>;
};

export type InvoiceSummaryType = {
  __typename?: 'InvoiceSummaryType';
  avg_overdue_days?: Maybe<Scalars['Int']>;
  buyer_credit_note_amount?: Maybe<Scalars['Float']>;
  buyer_debit_note_amount?: Maybe<Scalars['Float']>;
  overdue_amount?: Maybe<Scalars['Float']>;
  overdue_days?: Maybe<Scalars['Int']>;
  payment_cleared_in_days?: Maybe<Scalars['Int']>;
};

export type InvoiceType = {
  __typename?: 'InvoiceType';
  buyer?: Maybe<SharedEntityType>;
  /** Sum of buyer expense amount in trades */
  buyer_expense_amount?: Maybe<Scalars['Decimal']>;
  /** Final amount buyer has to pay */
  buyer_payable_amount?: Maybe<Scalars['Decimal']>;
  buyer_settlement_status?: Maybe<TradeInvoiceBuyerSettlementStatusChoices>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  current_status?: Maybe<TradeStatusType>;
  date?: Maybe<Scalars['Date']>;
  /** Sum of deducted amount in trades */
  deducted_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of deducted quantity in trades */
  deducted_quantity?: Maybe<Scalars['Decimal']>;
  department: SharedEntityType;
  /** Sum of expense amount in trades */
  expense_amount?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  invoice_transactions: Array<TransactionType>;
  issuance_notes: Array<IssuanceNoteType>;
  material_kind?: Maybe<TradeInvoiceMaterialKindChoices>;
  metadata?: Maybe<Scalars['JSONString']>;
  remark?: Maybe<Scalars['String']>;
  /** Quantity returned to parent trade */
  returned_quantity?: Maybe<Scalars['Decimal']>;
  reverse_status_mode: Scalars['Boolean'];
  standard_deduction?: Maybe<Scalars['Decimal']>;
  status_processing: Scalars['Boolean'];
  /** Sum of total amount in trades */
  total_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of total quantity in trades */
  total_quantity?: Maybe<Scalars['Decimal']>;
  tracking_code: Scalars['String'];
  trades: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type InwardBatchInput = {
  gross_weight?: InputMaybe<Scalars['Float']>;
  net_weight?: InputMaybe<Scalars['Float']>;
  sku_count?: InputMaybe<Scalars['Int']>;
  sku_tare_weight?: InputMaybe<Scalars['Float']>;
  sku_type?: InputMaybe<Scalars['Int']>;
  tare_weight?: InputMaybe<Scalars['Float']>;
};

export type InwardGlType = {
  __typename?: 'InwardGlType';
  booking: BookingGlType;
  date: Scalars['Date'];
  grade: HarvestGradeGlType;
  grn: Scalars['String'];
  id: Scalars['ID'];
  purchase_order?: Maybe<PurchaseOrderItemGlType>;
  quality?: Maybe<QualitySampleGlType>;
  status: InwardStatus;
  status_logs?: Maybe<Array<Maybe<InwardStatusLogGlType>>>;
  weigh: WeighGlType;
};


export type InwardGlTypeStatus_LogsArgs = {
  status?: InputMaybe<Scalars['String']>;
};

export type InwardInput = {
  batches?: InputMaybe<Array<InputMaybe<InwardBatchInput>>>;
  booking?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
  farm_weight?: InputMaybe<Scalars['Float']>;
  final_weight?: InputMaybe<Scalars['Float']>;
  grade?: InputMaybe<Scalars['String']>;
  gross_weight?: InputMaybe<Scalars['Float']>;
  invoicing_done_on?: InputMaybe<Scalars['String']>;
  inwarded_quantity?: InputMaybe<Scalars['Int']>;
  net_weight?: InputMaybe<Scalars['Float']>;
  tare_weight?: InputMaybe<Scalars['Float']>;
  weight_loss?: InputMaybe<Scalars['Float']>;
};

/** An enumeration. */
export enum InwardStatus {
  /** Completed */
  Cmp = 'CMP',
  /** On Hold */
  Hld = 'HLD',
  /** Not Started */
  Nst = 'NST',
  /** Rejected */
  Rjc = 'RJC'
}

export type InwardStatusLogGlType = {
  __typename?: 'InwardStatusLogGlType';
  created_at: Scalars['DateTime'];
  created_by: BaseUserGlType;
  from_status?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inward: InwardGlType;
  status: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type IssuanceNoteInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Provide ID to update an existing note, omit to create a new one. */
  id?: InputMaybe<Scalars['ID']>;
  input_value?: InputMaybe<Scalars['Decimal']>;
  invoice_id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<IssuanceNoteItemInput>>>;
  /** Options: ['flat', 'amount_percent', 'rate', 'quantity'] */
  kind: Scalars['String'];
  receipt_id?: InputMaybe<Scalars['ID']>;
  remarks?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['ID']>;
  /** Options: ['CREDIT', 'DEBIT'] */
  type: Scalars['String'];
  /** Options: ['buyer', 'seller', 'facilitator'] */
  user_role: Scalars['String'];
};

export type IssuanceNoteItemInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  input_value?: InputMaybe<Scalars['Decimal']>;
  remarks?: InputMaybe<Scalars['String']>;
  trade_item_id: Scalars['ID'];
};

export type IssuanceNoteType = {
  __typename?: 'IssuanceNoteType';
  amount: Scalars['Decimal'];
  base_amount?: Maybe<Scalars['Decimal']>;
  child_issuance_notes: Array<IssuanceNoteType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  id: Scalars['ID'];
  input_value?: Maybe<Scalars['Decimal']>;
  invoice?: Maybe<InvoiceType>;
  is_verified?: Maybe<Scalars['Boolean']>;
  kind: TradeIssuanceNoteKindChoices;
  parent_issuance_note?: Maybe<IssuanceNoteType>;
  receipt?: Maybe<ReceiptType>;
  remarks?: Maybe<Scalars['String']>;
  trade?: Maybe<TradeType>;
  type: TradeIssuanceNoteTypeChoices;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  user?: Maybe<SharedEntityType>;
  user_role: TradeIssuanceNoteUserRoleChoices;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type KeyNameSchema = {
  __typename?: 'KeyNameSchema';
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type KiteAddressInput = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  sub_region_id?: InputMaybe<Scalars['Int']>;
  taluka?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type KiteAddressType = {
  __typename?: 'KiteAddressType';
  address_kind: AddressAddressKind;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  baseuser_set: Array<BaseUserType>;
  business_address: Array<BusinessType>;
  /** The location details of the company, HQ or otherwise */
  company_address: Array<CompanyType>;
  country?: Maybe<Scalars['String']>;
  country_region?: Maybe<VillageDataType>;
  created_at: Scalars['DateTime'];
  /** The location details of the department, HQ or otherwise */
  department_address: Array<DepartmentType>;
  device_set: Array<DeviceType>;
  district?: Maybe<Scalars['String']>;
  district_region?: Maybe<VillageDataType>;
  farm_set: Array<FarmType>;
  field_set: Array<FieldType>;
  id: Scalars['ID'];
  local_area?: Maybe<Scalars['String']>;
  location?: Maybe<GeometryObjectType>;
  media_set: Array<MediaType>;
  /** An address of a mutual group depicts a location out of which these related users operate out of */
  mutualgroup_set: Array<MutualGroupType>;
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<OrganisationIdNameType>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_region?: Maybe<VillageDataType>;
  sub_region?: Maybe<VillageDataType>;
  taluka?: Maybe<Scalars['String']>;
  taluka_region?: Maybe<VillageDataType>;
  updated_at: Scalars['DateTime'];
  users_located: Array<BaseUserType>;
  village?: Maybe<Scalars['String']>;
  village_region?: Maybe<VillageDataType>;
  w3w_code: Scalars['String'];
};

export type KiteMediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  media_kind: Scalars['String'];
  url: Scalars['String'];
};

export type LocationData = {
  __typename?: 'LocationData';
  district?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_code?: Maybe<Scalars['String']>;
  talukas?: Maybe<Array<Maybe<Scalars['String']>>>;
  villages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Login = {
  __typename?: 'Login';
  me?: Maybe<BaseUserType>;
  payload: Scalars['GenericScalar'];
  redirect_to?: Maybe<Scalars['String']>;
  refresh_expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token: Scalars['String'];
};

export type LonLatInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type MakeTransitionMutation = {
  __typename?: 'MakeTransitionMutation';
  is_transition?: Maybe<Scalars['Boolean']>;
};

export type MapInvoiceTransactionManyInput = {
  invoice_id: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  transactions: Array<InputMaybe<Scalars['ID']>>;
};

export type MapInvoiceTransactionManyMutation = {
  __typename?: 'MapInvoiceTransactionManyMutation';
  invoices?: Maybe<Array<Maybe<InvoiceType>>>;
};

export type MapInvoiceTransactionMutation = {
  __typename?: 'MapInvoiceTransactionMutation';
  invoice?: Maybe<InvoiceType>;
};

export type MapReceiptTransactionManyInput = {
  receipt_id: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  transactions: Array<InputMaybe<Scalars['ID']>>;
};

export type MapReceiptTransactionManyMutation = {
  __typename?: 'MapReceiptTransactionManyMutation';
  receipts?: Maybe<Array<Maybe<ReceiptType>>>;
};

export type MapReceiptTransactionMutation = {
  __typename?: 'MapReceiptTransactionMutation';
  receipt?: Maybe<ReceiptType>;
};

export type MapTradeTransactionManyInput = {
  remark?: InputMaybe<Scalars['String']>;
  trade_id: Scalars['ID'];
  transactions: Array<InputMaybe<Scalars['ID']>>;
};

export type MapTradeTransactionManyMutation = {
  __typename?: 'MapTradeTransactionManyMutation';
  trades?: Maybe<Array<Maybe<TradeType>>>;
};

export type MapTradeTransactionMutation = {
  __typename?: 'MapTradeTransactionMutation';
  trade?: Maybe<TradeType>;
};

export type MarketGlType = {
  __typename?: 'MarketGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  plotcommoditysample_set: Array<PlotCommoditySampleGlType>;
};

export type MarketType = {
  __typename?: 'MarketType';
  allowed_departments: Array<ExternalEntityType>;
  codename: Scalars['String'];
  description: Scalars['String'];
  icon?: Maybe<MediaQcType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** Other templates for same market and test for will be deactivated if this one is active. */
  templates: Array<TemplateType>;
};

/** An enumeration. */
export enum MediaAccess {
  /** Private */
  Private = 'PRIVATE',
  /** Protected */
  Protected = 'PROTECTED',
  /** Public */
  Public = 'PUBLIC'
}

/** An enumeration. */
export enum MediaEntityMediaType {
  /** Folder */
  Fld = 'FLD',
  /** File */
  Fle = 'FLE',
  /** Photo */
  Pht = 'PHT',
  /** Video */
  Vdo = 'VDO'
}

export type MediaGlInput = {
  id?: InputMaybe<Scalars['ID']>;
  media_type: Scalars['String'];
  url: Scalars['String'];
};

export type MediaGlType = {
  __typename?: 'MediaGlType';
  id: Scalars['ID'];
  media_type: MediaEntityMediaType;
  url: Scalars['String'];
};

export type MediaInput = {
  id?: InputMaybe<Scalars['ID']>;
  media_kind: Scalars['String'];
  url: Scalars['String'];
};

export type MediaQcType = {
  __typename?: 'MediaQCType';
  access: MediaAccess;
  bucket?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_encrypted: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  location?: Maybe<AddressQcType>;
  market_set: Array<MarketType>;
  media_kind: Scalars['String'];
  media_set: Array<MediaQcType>;
  metadata?: Maybe<Scalars['JSONString']>;
  resultobservation_set: Array<ResultObservationType>;
  sampleobservation_set: Array<SampleObservationType>;
  size?: Maybe<Scalars['Int']>;
  thumbnail?: Maybe<MediaQcType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MediaType = {
  __typename?: 'MediaType';
  access: MediaAccess;
  baseuser_set: Array<BaseUserType>;
  business?: Maybe<BusinessType>;
  commodity_set: Array<CommodityType>;
  commodityvariety_set: Array<CommodityVarietyType>;
  company?: Maybe<CompanyType>;
  created_at: Scalars['DateTime'];
  crop_set: Array<CropType>;
  /** Feature photo */
  cropinfestation_set: Array<CropInfestationDetailType>;
  cropvariety_set: Array<CropVarietyType>;
  department?: Maybe<DepartmentType>;
  document_set: Array<DocumentType>;
  etag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_encrypted: Scalars['Boolean'];
  location?: Maybe<KiteAddressType>;
  media_kind?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  organisation?: Maybe<OrganisationIdNameType>;
  paymentdetail_set: Array<PaymentDetailType>;
  primarygrowthstage_set: Array<PrimaryGsType>;
  related_mutual_group?: Maybe<MutualGroupType>;
  related_user?: Maybe<BaseUserType>;
  size?: Maybe<Scalars['Int']>;
  soil_set: Array<SoilType>;
  thumbnail?: Maybe<Scalars['JSONString']>;
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
  varietygrade_set: Array<VarietyGradeType>;
};

export type MediaUrlType = {
  __typename?: 'MediaUrlType';
  preview_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MetabaseUrlInput = {
  dashboard?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['Int']>;
};

export type MetabaseUrlType = {
  __typename?: 'MetabaseURLType';
  iframe_url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum MilestoneDateFormat {
  /** Days */
  D = 'D',
  /** Month, Days */
  MD = 'M_D',
  /** Year, Month, Days */
  YMD = 'Y_M_D'
}

export type MilestoneDetailType = {
  __typename?: 'MilestoneDetailType';
  cropmilestone_set: Array<CropMilestoneType>;
  /** The representation of time elapsed */
  date_format: MilestoneDateFormat;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type MilestoneType = {
  __typename?: 'MilestoneType';
  crop_year?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  display_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_editable?: Maybe<Scalars['Boolean']>;
  iso_date?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  primary_milestone_name?: Maybe<Scalars['String']>;
  secondary_milestone_name?: Maybe<Scalars['String']>;
  time_elapsed?: Maybe<TimeElapsedObjectType>;
};

export type MutationUpdatePlotCropStatus = {
  __typename?: 'MutationUpdatePlotCropStatus';
  plot_crops?: Maybe<Array<Maybe<PlotCropType>>>;
};

export type MutationUpdatePlotStatusBulk = {
  __typename?: 'MutationUpdatePlotStatusBulk';
  plot_crops?: Maybe<Array<Maybe<PlotCropType>>>;
};

export type MutualGroupAggregationType = {
  __typename?: 'MutualGroupAggregationType';
  base_user_fullname?: Maybe<Scalars['String']>;
  farm_count?: Maybe<Scalars['Int']>;
  field_count?: Maybe<Scalars['Int']>;
  mutual_group?: Maybe<MutualGroupType>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
  user_count?: Maybe<Scalars['Int']>;
};

export type MutualGroupAggregationTypeWithTotal = {
  __typename?: 'MutualGroupAggregationTypeWithTotal';
  records?: Maybe<Array<Maybe<MutualGroupAggregationType>>>;
  total?: Maybe<Scalars['Int']>;
};

export type MutualGroupMembersipType = {
  __typename?: 'MutualGroupMembersipType';
  base_user: BaseUserType;
  created_at: Scalars['DateTime'];
  crop_count?: Maybe<Scalars['Int']>;
  farmer_document_count?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  mutual_group: MutualGroupType;
  plot_count?: Maybe<Scalars['Int']>;
  plot_document_count?: Maybe<Scalars['Int']>;
  remark: Scalars['String'];
  tag_count?: Maybe<Scalars['Int']>;
  total_area?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
  village_count?: Maybe<Scalars['Int']>;
};

export type MutualGroupNetworkAssignMutation = {
  __typename?: 'MutualGroupNetworkAssignMutation';
  mutual_groups?: Maybe<Array<Maybe<MutualGroupType>>>;
};

export type MutualGroupSchema = {
  __typename?: 'MutualGroupSchema';
  codename?: Maybe<Scalars['String']>;
  formatted_address?: Maybe<Scalars['String']>;
  formatted_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/**
 * This mutation will mostly be used to quickly set and send passwords
 * to all the users of a mutual group.
 */
export type MutualGroupSendPasswordMutation = {
  __typename?: 'MutualGroupSendPasswordMutation';
  id?: Maybe<Scalars['Int']>;
};

export type MutualGroupSummaryType = {
  __typename?: 'MutualGroupSummaryType';
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type MutualGroupType = {
  __typename?: 'MutualGroupType';
  address?: Maybe<KiteAddressType>;
  baseuser_set: Array<BaseUserType>;
  codename: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  data_consent?: Maybe<MediaType>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  field_set: Array<FieldType>;
  id: Scalars['ID'];
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_consent_provided?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  lead_farmer?: Maybe<BaseUserType>;
  /** Restricted to certain no of fields */
  max_field_assets?: Maybe<Scalars['Int']>;
  mutualgroupmembership_set: Array<MutualGroupMembersipType>;
  name: Scalars['String'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  region?: Maybe<RegionType>;
  updated_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type MutualGroupWeatherStationType = {
  __typename?: 'MutualGroupWeatherStationType';
  gateway_id?: Maybe<Scalars['String']>;
  is_public?: Maybe<Scalars['Boolean']>;
  location_text?: Maybe<Scalars['String']>;
  mutual_group?: Maybe<MutualGroupType>;
  name?: Maybe<Scalars['String']>;
  network?: Maybe<NetworkType>;
};

export type MySellableItemStockFilterInput = {
  discounted_rate__gte?: InputMaybe<Scalars['Float']>;
  discounted_rate__lte?: InputMaybe<Scalars['Float']>;
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  is_cod_available?: InputMaybe<Scalars['Boolean']>;
  is_home_delivery_available?: InputMaybe<Scalars['Boolean']>;
  item_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rejected_stock_count__gte?: InputMaybe<Scalars['Int']>;
  sellable_item_id?: InputMaybe<Scalars['ID']>;
};

export type NetworkType = {
  __typename?: 'NetworkType';
  codename: Scalars['String'];
  company: CompanyType;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_default: Scalars['Boolean'];
  name: Scalars['String'];
  valid_from?: Maybe<Scalars['DateTime']>;
  valid_till?: Maybe<Scalars['DateTime']>;
};

export type NextPaymentType = {
  __typename?: 'NextPaymentType';
  date?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['String']>;
};

export type NotificationContent = {
  body: Scalars['String'];
  extra_fields?: InputMaybe<Scalars['JSONScalar']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NotificationTemplateFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  value: Array<InputMaybe<Scalars['CustomGenericScalar']>>;
};

export type OfferAttachmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  media_id: Scalars['ID'];
  send_whatsapp?: InputMaybe<Scalars['Boolean']>;
};

export type OfferEnquiryInput = {
  buyer_external_id?: InputMaybe<Scalars['ID']>;
  buyer_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  whatsapp_status?: InputMaybe<Scalars['String']>;
};

export type OfferExpenseInput = {
  expense_parameter_id: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  paid_by: Scalars['String'];
  value: Scalars['Decimal'];
};

export type OfferType = {
  __typename?: 'OfferType';
  buyer_expense: Scalars['Float'];
  buyer_groups: Array<SharedEntityType>;
  buyer_source_kind: StockOfferBuyerSourceKindChoices;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity: SharedEntityType;
  commodity_variety?: Maybe<SharedEntityType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  deducted_amount: Scalars['Float'];
  department?: Maybe<SharedEntityType>;
  end_date_time: Scalars['DateTime'];
  facilitator?: Maybe<SharedEntityType>;
  id: Scalars['ID'];
  jr_officer?: Maybe<SharedEntityType>;
  material_kind?: Maybe<StockOfferMaterialKindChoices>;
  max_rate?: Maybe<Scalars['Float']>;
  mode: StockOfferModeChoices;
  packaging: StockOfferPackagingChoices;
  plot_crop?: Maybe<SharedEntityType>;
  quantity: Scalars['Float'];
  /** Total quantity in kg */
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit?: Maybe<SharedEntityType>;
  rate: Scalars['Float'];
  rate_unit: SharedEntityType;
  seller?: Maybe<SharedEntityType>;
  seller_expense: Scalars['Float'];
  seller_tnc?: Maybe<Scalars['String']>;
  sr_officer?: Maybe<SharedEntityType>;
  standard_deduction: Scalars['Float'];
  start_date_time: Scalars['DateTime'];
  status: StockOfferStatusChoices;
  total_amount: Scalars['Float'];
  trade_set: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  variety_grade?: Maybe<SharedEntityType>;
};

export type OfferUpdateStatus = {
  __typename?: 'OfferUpdateStatus';
  offer?: Maybe<OfferType>;
};

export type OnboardPlot = {
  __typename?: 'OnboardPlot';
  codename?: Maybe<Scalars['String']>;
  farm?: Maybe<FarmType>;
  field?: Maybe<FieldType>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_name?: Maybe<Scalars['String']>;
  plot_crops?: Maybe<Array<Maybe<PlotCropType>>>;
  tag?: Maybe<Scalars['String']>;
};

export type OnboardPlotType = {
  area: Scalars['Float'];
  area_catered?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']>>>>>;
  area_unit_codename: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  owner_reference_id: Scalars['String'];
  plot_crops: Array<InputMaybe<PlotCropInputType>>;
  soil_type_codename: Scalars['String'];
  tag: Scalars['String'];
};

export type OperationValueType = {
  __typename?: 'OperationValueType';
  op?: Maybe<Scalars['String']>;
  val?: Maybe<Scalars['Float']>;
};

export type OrderFilterInput = {
  aggregator_id?: InputMaybe<Scalars['ID']>;
  approval_statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  approved_by_id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  date__gte?: InputMaybe<Scalars['Date']>;
  date__lte?: InputMaybe<Scalars['Date']>;
  delivery_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Distribution centre ID */
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  distribution_centre_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  oib_return_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Valid only for pickup_date, date, pickup_slot_from_time, pickup_slot_to_time */
  order_by?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order_categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order_categories_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  outstanding_amount_remaining?: InputMaybe<Scalars['Boolean']>;
  /** 'COD | CHQ and more' orders will be filtered according to payment method */
  payment_methods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  payment_methods_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  payment_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  payment_status_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pickup_date?: InputMaybe<Scalars['Date']>;
  pickup_date__gte?: InputMaybe<Scalars['Date']>;
  pickup_date__lte?: InputMaybe<Scalars['Date']>;
  pincodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placed_by_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  placed_in_codename?: InputMaybe<Scalars['String']>;
  /** department ID */
  placed_in_id?: InputMaybe<Scalars['ID']>;
  salesman_id?: InputMaybe<Scalars['ID']>;
  sellable_item_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** 'settled' status shows : Settled Transactions, 'unsettled' status shows : Unsettled Transactions */
  settlement_status?: InputMaybe<Scalars['String']>;
  supplying_dc_id?: InputMaybe<Scalars['ID']>;
  target_dc_id?: InputMaybe<Scalars['ID']>;
  transaction_date__gte?: InputMaybe<Scalars['Date']>;
  transaction_date__lte?: InputMaybe<Scalars['Date']>;
  /** 'COD | CHQ and more' orders and transactions will be filtered according to payment method */
  transaction_payment_methods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transaction_recorded_by_group?: InputMaybe<Scalars['String']>;
  transaction_recorded_by_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type OrderGlType = {
  __typename?: 'OrderGlType';
  billing_address?: Maybe<AddressGlType>;
  billing_doc: Array<BillingDocGlType>;
  created_at: Scalars['DateTime'];
  date: Scalars['Date'];
  delivery_status?: Maybe<Scalars['String']>;
  discount?: Maybe<DiscountGlType>;
  id: Scalars['ID'];
  latest_transaction?: Maybe<OrderTransactionGlType>;
  order_category?: Maybe<Scalars['String']>;
  order_items: Array<OrderItemGlType>;
  order_status?: Maybe<Scalars['String']>;
  ordering_dc?: Maybe<DistributionCentreGlType>;
  otp: Scalars['Int'];
  outstanding_amount: Scalars['Float'];
  payment_method?: Maybe<Scalars['String']>;
  payment_status?: Maybe<Scalars['String']>;
  pickup_date?: Maybe<Scalars['Date']>;
  pickup_slot_from_time?: Maybe<Scalars['Time']>;
  pickup_slot_to_time?: Maybe<Scalars['Time']>;
  placed_by?: Maybe<BaseUserGlType>;
  placed_in?: Maybe<FmsDepartmentType>;
  poc_name: Scalars['String'];
  poc_number: Scalars['String'];
  remark: Scalars['String'];
  selected_pickup_slot?: Maybe<TimeSlotGlType>;
  shipping_address: AddressGlType;
  shipping_charges: Scalars['Float'];
  shipping_method?: Maybe<Scalars['String']>;
  status_logs: Array<OrderStatusLogGlType>;
  target_dc?: Maybe<DistributionCentreGlType>;
  taxes: Array<TaxGlType>;
  total_amount: Scalars['Float'];
  tracking_code: Scalars['String'];
  transactions: Array<OrderTransactionGlType>;
  updated_at: Scalars['DateTime'];
  user: BaseUserGlType;
};

export type OrderItemGlType = {
  __typename?: 'OrderItemGlType';
  actual_rate: Scalars['Float'];
  approved_rate: Scalars['Float'];
  created_at: Scalars['DateTime'];
  delivered_quantity?: Maybe<Scalars['Int']>;
  delivered_taxed_item_cost?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  item_actual_cost?: Maybe<Scalars['Float']>;
  item_cost?: Maybe<Scalars['Float']>;
  item_status?: Maybe<Scalars['String']>;
  item_stock?: Maybe<SellableItemStockGlType>;
  order: OrderGlType;
  quantity: Scalars['Int'];
  rate: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  sellable_item: SellableItemGlType;
  settled_quantity?: Maybe<Scalars['Int']>;
  settlement_remark?: Maybe<Scalars['String']>;
  shipping?: Maybe<ShippingGlType>;
  tax_rate: Scalars['Float'];
  taxed_item_cost?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
};

export type OrderItemStockInput = {
  actual_rate?: InputMaybe<Scalars['Float']>;
  approval_status?: InputMaybe<Scalars['String']>;
  approver_remark?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<EcomMediaInput>>>;
  batch_stock_codename?: InputMaybe<Scalars['String']>;
  batch_stock_rate_id?: InputMaybe<Scalars['ID']>;
  custom_discount_flat?: InputMaybe<Scalars['Float']>;
  custom_discount_percent?: InputMaybe<Scalars['Float']>;
  discount_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  ordering_item_stock_id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  rate?: InputMaybe<Scalars['Float']>;
  rejection_rate?: InputMaybe<Scalars['Float']>;
  remark?: InputMaybe<Scalars['String']>;
  requested_at?: InputMaybe<Scalars['Date']>;
  sellable_item_stock_id: Scalars['ID'];
};

export type OrderPickupSlotInput = {
  distribution_centre_id: Scalars['ID'];
  time_slot_id: Scalars['ID'];
};

export type OrderStatusLogGlType = {
  __typename?: 'OrderStatusLogGlType';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  order: OrderGlType;
  status?: Maybe<Scalars['String']>;
  status_type?: Maybe<Scalars['String']>;
  trip?: Maybe<TripGlType>;
  updated_at: Scalars['DateTime'];
};

export type OrderTransactionGlType = {
  __typename?: 'OrderTransactionGlType';
  amount: Scalars['Float'];
  attachment?: Maybe<MediaGlType>;
  billing_doc?: Maybe<Array<Maybe<BillingDocGlType>>>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  order: OrderGlType;
  payment_method?: Maybe<Scalars['String']>;
  recorded_by?: Maybe<BaseUserGlType>;
  reference_id: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  settled_for_transaction?: Maybe<OrderTransactionGlType>;
  settlement_remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trip?: Maybe<TripGlType>;
  /** Only captured transaction will have unsettled amount */
  unsettled_amount?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
  user: BaseUserGlType;
};

export type OrganisationGlObject = {
  __typename?: 'OrganisationGlObject';
  address?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
};

export type OrganisationIdNameType = {
  __typename?: 'OrganisationIdNameType';
  /** Abbreviation for short name */
  abbreviation: Scalars['String'];
  address: KiteAddressType;
  agents: Array<AgentType>;
  codename?: Maybe<Scalars['String']>;
  /** The organisation that manages the company */
  companies: Array<CompanyType>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  /** Display name for showing on the website */
  display_name: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  is_active: Scalars['Boolean'];
  level_1_approval_flow: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<MediaType>;
  private_metadata: Scalars['JSONString'];
  /** Terms and conditions */
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
};

export type OrganisationPricingGlType = {
  __typename?: 'OrganisationPricingGlType';
  created_at: Scalars['DateTime'];
  end_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  organisation_rate: Scalars['Float'];
  start_date?: Maybe<Scalars['Date']>;
  supplier_rate: Scalars['Float'];
  tax_percentage: Scalars['Float'];
  unit: SiUnitGlType;
  updated_at: Scalars['DateTime'];
};

export type OrganisationTradeExpenseConfigType = {
  __typename?: 'OrganisationTradeExpenseConfigType';
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  expense_parameter: ExpenseParameterType;
  id: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
  version: Scalars['Int'];
};

export type OrganisationTradeExpensesTemplateSchema = {
  __typename?: 'OrganisationTradeExpensesTemplateSchema';
  buyer_charge?: Maybe<Scalars['Decimal']>;
  expense_parameter?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  seller_charge?: Maybe<Scalars['Decimal']>;
};

export type OrganisationTradeExpensesVersionSchema = {
  __typename?: 'OrganisationTradeExpensesVersionSchema';
  default?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  version_id?: Maybe<Scalars['Int']>;
};

export type OrganisationTradeTnCsTemplateSchema = {
  __typename?: 'OrganisationTradeTNCsTemplateSchema';
  buyer?: Maybe<Scalars['String']>;
  facilitator?: Maybe<Scalars['String']>;
  seller?: Maybe<Scalars['String']>;
};

export type OrganisationTradeTnCsVersionSchema = {
  __typename?: 'OrganisationTradeTNCsVersionSchema';
  default?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  version_id?: Maybe<Scalars['Int']>;
};

export type OrganisationType = {
  __typename?: 'OrganisationType';
  /** Abbreviation for short name */
  abbreviation: Scalars['String'];
  address: KiteAddressType;
  agents: Array<AgentType>;
  codename: Scalars['String'];
  /** The organisation that manages the company */
  companies: Array<CompanyType>;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  /** Display name for showing on the website */
  display_name: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  level_1_approval_flow: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
  private_metadata: Scalars['JSONString'];
  /** Terms and conditions */
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
};

export type OverDraftType = {
  __typename?: 'OverDraftType';
  amount: Scalars['Float'];
  amount_from_credit: Scalars['Float'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  credit: CreditType;
  deviation_final_officer_one?: Maybe<SharedEntityType>;
  deviation_final_officer_one_remark?: Maybe<Scalars['String']>;
  deviation_final_officer_two?: Maybe<SharedEntityType>;
  deviation_final_officer_two_remark?: Maybe<Scalars['String']>;
  deviation_recommendation_officer?: Maybe<SharedEntityType>;
  deviation_recommendation_officer_remark?: Maybe<Scalars['String']>;
  deviation_senior_officer_remark?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Last whatsapp wati log */
  last_wati_log?: Maybe<Scalars['String']>;
  od_count: Scalars['Int'];
  outstanding_amount: Scalars['Float'];
  settled_amount: Scalars['Float'];
  status: CreditManagementOverDraftStatusChoices;
  trade: TradeType;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type OverDueApprovalCwType = {
  __typename?: 'OverDueApprovalCWType';
  count: Scalars['Int'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  credit_wallet: CreditWalletType;
  id: Scalars['ID'];
  logs: Array<OverDueApprovalLogCwType>;
  remark?: Maybe<Scalars['String']>;
  status: CreditWalletOverDueApprovalCwStatusChoices;
  /** Trade for which the over due approval is being used */
  trade: TradeType;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type OverDueApprovalLogCwType = {
  __typename?: 'OverDueApprovalLogCWType';
  created_at: Scalars['DateTime'];
  from_status?: Maybe<CreditWalletOverDueApprovalLogCwFromStatusChoices>;
  id: Scalars['ID'];
  over_due_approval: OverDueApprovalCwType;
  remark?: Maybe<Scalars['String']>;
  status: CreditWalletOverDueApprovalLogCwStatusChoices;
  updated_at: Scalars['DateTime'];
  user: SharedEntityType;
};

export type OverDueApprovalLogType = {
  __typename?: 'OverDueApprovalLogType';
  created_at: Scalars['DateTime'];
  from_status?: Maybe<CreditManagementOverDueApprovalLogFromStatusChoices>;
  id: Scalars['ID'];
  over_due_approval: OverDueApprovalType;
  remark?: Maybe<Scalars['String']>;
  status: CreditManagementOverDueApprovalLogStatusChoices;
  updated_at: Scalars['DateTime'];
  user: SharedEntityType;
};

export type OverDueApprovalType = {
  __typename?: 'OverDueApprovalType';
  count: Scalars['Int'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  credit: CreditType;
  department?: Maybe<SharedEntityType>;
  id: Scalars['ID'];
  logs: Array<OverDueApprovalLogType>;
  remark?: Maybe<Scalars['String']>;
  sr_officer: SharedEntityType;
  status: CreditManagementOverDueApprovalStatusChoices;
  /** Trade for which the over due approval is being used */
  trade?: Maybe<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  user: SharedEntityType;
};

/** An enumeration. */
export enum PackingMaterialType {
  /** Primary */
  Primary = 'PRIMARY',
  /** Secondary */
  Secondary = 'SECONDARY'
}

export type PartnerSchema = {
  __typename?: 'PartnerSchema';
  country_name?: Maybe<Scalars['String']>;
  district_name?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['JSONString']>;
  number?: Maybe<Scalars['String']>;
  partner_codename?: Maybe<Scalars['String']>;
  partner_name?: Maybe<Scalars['String']>;
  state_name?: Maybe<Scalars['String']>;
  taluka_name?: Maybe<Scalars['String']>;
  team_admin_id?: Maybe<Scalars['String']>;
  team_admin_name?: Maybe<Scalars['String']>;
  village_name?: Maybe<Scalars['String']>;
};

export type PayUHashType = {
  __typename?: 'PayUHashType';
  hash_value?: Maybe<Scalars['String']>;
};

export type PayUPayload = {
  __typename?: 'PayUPayload';
  data?: Maybe<Scalars['JSONScalar']>;
};

export type PaymentDetailInput = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<KiteMediaInput>>>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  method_id?: InputMaybe<Scalars['Int']>;
};

export type PaymentDetailType = {
  __typename?: 'PaymentDetailType';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  attachments: Array<MediaType>;
  bank_name: Scalars['String'];
  baseuser_set: Array<BaseUserType>;
  branch_name: Scalars['String'];
  content_type: GeneralContentType;
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  id: Scalars['ID'];
  ifsc_code: Scalars['String'];
  is_verified?: Maybe<Scalars['Boolean']>;
  method: PaymentMethodType;
  object_id: Scalars['Int'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** System level verification based on Organisation specs on documents. */
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  paymentdetail_set: Array<PaymentDetailType>;
};

/** An enumeration. */
export enum PaynoteTransactionRefChoices {
  /** advance_release */
  AdvanceRelease = 'ADVANCE_RELEASE',
  /** invoice_settlement */
  InvoiceSettlement = 'INVOICE_SETTLEMENT',
  /** receipt_settlement */
  ReceiptSettlement = 'RECEIPT_SETTLEMENT',
  /** settled_by_advance_payment */
  SettledByAdvancePayment = 'SETTLED_BY_ADVANCE_PAYMENT'
}

export type PlaceOrder = {
  __typename?: 'PlaceOrder';
  order?: Maybe<OrderGlType>;
};

export type PlotAssessmentGlType = {
  __typename?: 'PlotAssessmentGlType';
  id: Scalars['ID'];
  seal_number: Scalars['String'];
};

export type PlotCommodityFilterInput = {
  assigned_to?: InputMaybe<Scalars['Int']>;
  company_tags?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  crop?: InputMaybe<Scalars['String']>;
  harvesting_date?: InputMaybe<Scalars['Date']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  po_status?: InputMaybe<Scalars['Boolean']>;
  sampling_status?: InputMaybe<FilterSampleInput>;
  sowing_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updated_after?: InputMaybe<Scalars['DateTime']>;
  variety_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  village?: InputMaybe<Scalars['String']>;
};

export type PlotCommodityGlType = {
  __typename?: 'PlotCommodityGlType';
  agronomist?: Maybe<BaseUserGlType>;
  assessment?: Maybe<PlotAssessmentGlType>;
  growing_cycle: Scalars['Int'];
  harvesting_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plot: PlotGlType;
  reference_id: Scalars['String'];
  registration_code: Scalars['String'];
  samples?: Maybe<Array<Maybe<PlotCommoditySampleGlType>>>;
  sowing_date?: Maybe<Scalars['Date']>;
  status: PlotCommodityStatus;
  variety: CommodityVarietyGlType;
};


export type PlotCommodityGlTypeSamplesArgs = {
  date_gte?: InputMaybe<Scalars['Date']>;
  date_lte?: InputMaybe<Scalars['Date']>;
};

/** An enumeration. */
export enum PlotCommoditySampleChemicalStatus {
  /** Pass */
  Dn = 'DN',
  /** Not Sampled */
  Nd = 'ND',
  /** Fail */
  Rj = 'RJ',
  /** Waiting */
  Wt = 'WT'
}

export type PlotCommoditySampleGlType = {
  __typename?: 'PlotCommoditySampleGlType';
  chemical_status: PlotCommoditySampleChemicalStatus;
  chemical_test_date: Scalars['Date'];
  created: Scalars['DateTime'];
  detection_count: Scalars['Int'];
  id: Scalars['ID'];
  market?: Maybe<MarketGlType>;
  max_detection: Scalars['Float'];
  physical_status: PlotCommoditySamplePhysicalStatus;
  physical_test_date: Scalars['Date'];
  plot_commodity: PlotCommodityGlType;
  result_pdf_uid?: Maybe<Scalars['String']>;
  result_pdf_url?: Maybe<Scalars['String']>;
  total_detection: Scalars['Float'];
  updated: Scalars['DateTime'];
};

/** An enumeration. */
export enum PlotCommoditySamplePhysicalStatus {
  /** Pass */
  Dn = 'DN',
  /** Not Sampled */
  Nd = 'ND',
  /** Fail */
  Rj = 'RJ',
  /** Waiting */
  Wt = 'WT'
}

/** An enumeration. */
export enum PlotCommodityStatus {
  /** Harvesting Done */
  Cmp = 'CMP',
  /** Hold for Alert Chemical */
  Hac = 'HAC',
  /** On Hold */
  Hld = 'HLD',
  /** Not Ready for Harvest */
  Nrd = 'NRD',
  /** Ready for Harvest */
  Rdy = 'RDY',
  /** Scheduled for Harvest */
  Sch = 'SCH',
  /** Harvest in Progress */
  Wip = 'WIP'
}

export type PlotCropBudgetSetType = {
  __typename?: 'PlotCropBudgetSetType';
  codename?: Maybe<Scalars['String']>;
  crop?: Maybe<Scalars['String']>;
  farm_tag?: Maybe<Scalars['String']>;
  field_area?: Maybe<Scalars['Float']>;
  field_area_unit?: Maybe<Scalars['String']>;
  field_tag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_budget_set?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  plot_area?: Maybe<Scalars['Float']>;
  plot_area_unit?: Maybe<Scalars['String']>;
  plot_owner?: Maybe<Scalars['String']>;
  plot_tag?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  variety?: Maybe<Scalars['String']>;
};

export type PlotCropDetailType = {
  __typename?: 'PlotCropDetailType';
  agronomist?: Maybe<Array<Maybe<AgentType>>>;
  area?: Maybe<Scalars['Decimal']>;
  area_unit?: Maybe<SiUnitType>;
  centroid?: Maybe<Scalars['JSONScalar']>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  crop?: Maybe<CropType>;
  crop_variety?: Maybe<CropVarietyType>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year?: Maybe<CropYearType>;
  description?: Maybe<Scalars['String']>;
  estd_harvest_quantity?: Maybe<Scalars['Decimal']>;
  estd_harvest_quantity_unit?: Maybe<SiUnitType>;
  estd_harvesting_date?: Maybe<Scalars['Date']>;
  estd_sowing_date?: Maybe<Scalars['Date']>;
  farm_tag?: Maybe<Scalars['String']>;
  farmer: BaseUserType;
  field_tag?: Maybe<Scalars['String']>;
  growing_cycle: Scalars['Int'];
  harvest_quantity?: Maybe<Scalars['Decimal']>;
  harvest_quantity_unit?: Maybe<SiUnitType>;
  harvesting_date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this plot crop boundary */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_budget_set?: Maybe<Scalars['Boolean']>;
  is_seed: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  latest_milestone?: Maybe<MilestoneType>;
  latest_status?: Maybe<PlotStatusType>;
  metadata: Scalars['JSONString'];
  milestone_recording_enabled?: Maybe<Scalars['Boolean']>;
  milestones?: Maybe<Array<Maybe<MilestoneType>>>;
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['Decimal']>;
  p2p_distance_unit?: Maybe<SiUnitType>;
  plant_count: Scalars['Int'];
  plot?: Maybe<PlotType>;
  plot_area?: Maybe<Scalars['Float']>;
  plot_area_unit?: Maybe<Scalars['String']>;
  plot_tag?: Maybe<Scalars['String']>;
  plotcropgrowthstage_set: Array<PlotCropGrowthStageType>;
  plotcropmilestone_set: Array<PlotCropMilestoneType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  r2r_distance?: Maybe<Scalars['Decimal']>;
  r2r_distance_unit?: Maybe<SiUnitType>;
  /** Level 1 Approval Remark */
  send_for_verification_remark?: Maybe<Scalars['String']>;
  /** Level 1 Approval Status */
  send_for_verification_status?: Maybe<PlotCropSendForVerificationStatus>;
  sowing_date?: Maybe<Scalars['Date']>;
  sowing_material?: Maybe<SowingMaterialTypeSchema>;
  status: PlotStatusType;
  status_updated_date?: Maybe<Scalars['DateTime']>;
  /** System level verification; set to False when geo boundary (area_catered) is missing. */
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  user_preferred_name?: Maybe<Scalars['String']>;
  variety_name?: Maybe<Scalars['String']>;
  /** Level 1 Approval Done By */
  verification_done_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done On */
  verification_done_on?: Maybe<Scalars['DateTime']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type PlotCropDetailTypeWithTotal = {
  __typename?: 'PlotCropDetailTypeWithTotal';
  records?: Maybe<Array<Maybe<PlotCropDetailType>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PlotCropExpenseByDateType = {
  __typename?: 'PlotCropExpenseByDateType';
  details?: Maybe<Array<Maybe<PurposeAmountType>>>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type PlotCropGrowthStageType = {
  __typename?: 'PlotCropGrowthStageType';
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  crop_year: CropYearType;
  date: Scalars['Date'];
  id?: Maybe<Scalars['Int']>;
  plot_crop: PlotCropDetailType;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
};

export type PlotCropGrowthStagesType = {
  __typename?: 'PlotCropGrowthStagesType';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_milestone_stage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_current_stage?: Maybe<Scalars['Boolean']>;
  max_days_after?: Maybe<Scalars['Int']>;
  milestone_stage?: Maybe<Scalars['String']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  primary_growth_stage?: Maybe<PrimaryGsType>;
  stage_length?: Maybe<Scalars['String']>;
  stage_status?: Maybe<Scalars['String']>;
};

export type PlotCropIncomeByDateType = {
  __typename?: 'PlotCropIncomeByDateType';
  details?: Maybe<Array<Maybe<PurposeAmountType>>>;
  from_date?: Maybe<Scalars['String']>;
  to_date?: Maybe<Scalars['String']>;
};

export type PlotCropInputType = {
  area: Scalars['Float'];
  area_unit_codename: Scalars['String'];
  crop_codename: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  owner_reference_id: Scalars['String'];
  p2p_distance?: InputMaybe<Scalars['Float']>;
  p2p_distance_unit_codename?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantity_unit_codename?: InputMaybe<Scalars['String']>;
  r2r_distance?: InputMaybe<Scalars['Float']>;
  r2r_distance_unit_codename?: InputMaybe<Scalars['String']>;
  sowing_date: Scalars['Date'];
  sowing_material_codename?: InputMaybe<Scalars['String']>;
  tag: Scalars['String'];
  variety_codename?: InputMaybe<Scalars['String']>;
};

export type PlotCropMilestoneType = {
  __typename?: 'PlotCropMilestoneType';
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  crop_milestone: CropMilestoneType;
  crop_year: CropYearType;
  date: Scalars['Date'];
  id?: Maybe<Scalars['Int']>;
  plot_crop: PlotCropDetailType;
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
};

export type PlotCropSearchInput = {
  status__codename?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum PlotCropSendForVerificationStatus {
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Verified */
  Verified = 'VERIFIED'
}

export type PlotCropTimelineTransactionType = {
  __typename?: 'PlotCropTimelineTransactionType';
  area?: Maybe<UnitAndValueType>;
  crop_info?: Maybe<CropInfoType>;
  farm_tag?: Maybe<Scalars['String']>;
  field_tag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  latest_milestone?: Maybe<MilestoneType>;
  owner?: Maybe<Scalars['String']>;
  plot_crop_codename?: Maybe<Scalars['String']>;
  plot_crop_tag?: Maybe<Scalars['String']>;
  plot_tag?: Maybe<Scalars['String']>;
  transaction_history?: Maybe<Array<Maybe<FinancialTimelineTransactionType>>>;
};

export type PlotCropTransactionCategoryTypes = {
  __typename?: 'PlotCropTransactionCategoryTypes';
  expenses?: Maybe<Array<Maybe<CategoryType>>>;
  income?: Maybe<Array<Maybe<CategoryType>>>;
};

export type PlotCropTransactionInsertType = {
  __typename?: 'PlotCropTransactionInsertType';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  record_date?: Maybe<Scalars['Date']>;
  transaction_type?: Maybe<Scalars['String']>;
};

export type PlotCropType = {
  __typename?: 'PlotCropType';
  area?: Maybe<Scalars['Float']>;
  area_unit?: Maybe<SiUnitType>;
  boundary?: Maybe<CoordinatesType>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  crop: CropType;
  crop_variety?: Maybe<CropVarietyType>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year?: Maybe<CropYearType>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  estd_harvest_quantity?: Maybe<Scalars['Decimal']>;
  estd_harvest_quantity_unit?: Maybe<SiUnitType>;
  estd_harvesting_date?: Maybe<Scalars['Date']>;
  estd_sowing_date?: Maybe<Scalars['Date']>;
  external_reference_id?: Maybe<Scalars['String']>;
  farmer: BaseUserType;
  growing_cycle: Scalars['Int'];
  harvest_quantity?: Maybe<Scalars['Decimal']>;
  harvest_quantity_unit?: Maybe<SiUnitType>;
  harvesting_date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to this plot crop boundary */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_seed: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  owner_name?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['Decimal']>;
  p2p_distance_unit?: Maybe<SiUnitType>;
  plant_count: Scalars['Int'];
  plot: DjangoPlotType;
  plotcropgrowthstage_set: Array<PlotCropGrowthStageType>;
  plotcropmilestone_set: Array<PlotCropMilestoneType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  r2r_distance?: Maybe<Scalars['Decimal']>;
  r2r_distance_unit?: Maybe<SiUnitType>;
  /** Level 1 Approval Remark */
  send_for_verification_remark?: Maybe<Scalars['String']>;
  /** Level 1 Approval Status */
  send_for_verification_status?: Maybe<PlotCropSendForVerificationStatus>;
  sowing_date?: Maybe<Scalars['Date']>;
  status: PlotStatusType;
  /** System level verification; set to False when geo boundary (area_catered) is missing. */
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  user_preferred_name?: Maybe<Scalars['String']>;
  /** Level 1 Approval Done By */
  verification_done_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done On */
  verification_done_on?: Maybe<Scalars['DateTime']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type PlotGlType = {
  __typename?: 'PlotGlType';
  address: AddressGlType;
  area: Scalars['Float'];
  codename: Scalars['String'];
  farmer: BaseUserGlType;
  gat_number?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PlotProperties = {
  __typename?: 'PlotProperties';
  area?: Maybe<Scalars['Decimal']>;
  area_unit?: Maybe<SiUnitType>;
  /** Polygon centroid */
  centroid?: Maybe<GeometryObjectType>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<BaseUserType>;
  created_in?: Maybe<DepartmentType>;
  description?: Maybe<Scalars['String']>;
  farmer: BaseUserType;
  field: FieldType;
  /** Internally used to filter fields to fix data */
  geo_area_remark?: Maybe<Scalars['Float']>;
  /** Area auto calculated by boundaries in acre */
  geo_bound_area?: Maybe<Scalars['Float']>;
  /** URL of the image related to this plot boundary */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  /** Additional information */
  notes?: Maybe<Scalars['String']>;
  plotcrop_set: Array<PlotCropDetailType>;
  private_metadata: Scalars['JSONString'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** Level 1 Approval Remark */
  send_for_verification_remark?: Maybe<Scalars['String']>;
  /** Level 1 Approval Status */
  send_for_verification_status?: Maybe<PlotSendForVerificationStatus>;
  /** System level verification; set to False when geo boundary (area_catered) is missing. */
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done By */
  verification_done_by?: Maybe<BaseUserType>;
  /** Level 1 Approval Done On */
  verification_done_on?: Maybe<Scalars['DateTime']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<BaseUserType>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum PlotSendForVerificationStatus {
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Verified */
  Verified = 'VERIFIED'
}

export type PlotStatusType = {
  __typename?: 'PlotStatusType';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  plotcrop_set: Array<PlotCropDetailType>;
  private_metadata: Scalars['JSONString'];
  purpose?: Maybe<Scalars['String']>;
};

export type PlotType = {
  __typename?: 'PlotType';
  bbox?: Maybe<Scalars['GenericScalar']>;
  /** Geo bounds */
  geometry?: Maybe<GeometryObjectType>;
  id?: Maybe<Scalars['Int']>;
  properties?: Maybe<PlotProperties>;
  type?: Maybe<Scalars['String']>;
};

export type PrimaryGsType = {
  __typename?: 'PrimaryGSType';
  /** Base stage, Planting, Sowing, Pruning */
  base_stage: PrimaryGrowthStageBaseStage;
  /** PGS-0# */
  code: Scalars['String'];
  codename: Scalars['String'];
  crop: CropType;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** URL of the image related to this crop monitoring parameter */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  /** Maximum days after base stage */
  max_days_after: Scalars['Int'];
  /** Minimum days after base stage */
  min_days_after: Scalars['Int'];
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
};

/** An enumeration. */
export enum PrimaryGrowthStageBaseStage {
  /** Foundation Pruning */
  FoundationPruning = 'FOUNDATION_PRUNING',
  /** Fruit Pruning */
  FruitPruning = 'FRUIT_PRUNING',
  /** Planting */
  Planting = 'PLANTING',
  /** Sowing */
  Sowing = 'SOWING'
}

export type PrimaryGrowthStagesType = {
  __typename?: 'PrimaryGrowthStagesType';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_milestone_stage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_current_stage?: Maybe<Scalars['Boolean']>;
  max_days_after?: Maybe<Scalars['Int']>;
  milestone_stage?: Maybe<Scalars['String']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  secondary_growth_stages?: Maybe<Array<Maybe<SecondaryGrowthStagesType>>>;
  stage_length?: Maybe<Scalars['String']>;
  stage_status?: Maybe<Scalars['String']>;
};

export type ProductionBatchGlFilterInput = {
  codename?: InputMaybe<Scalars['String']>;
  date__gte?: InputMaybe<Scalars['Date']>;
  date__lte?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ProductionBatchGlType = {
  __typename?: 'ProductionBatchGlType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  date: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  requests?: Maybe<Array<Maybe<RequestType>>>;
  requests_summary?: Maybe<RequestSummaryType>;
  updated_at: Scalars['DateTime'];
  variety: CommodityVarietyGlType;
};


export type ProductionBatchGlTypeRequestsArgs = {
  filter?: InputMaybe<RequestFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProductionBatchGlTypeRequests_SummaryArgs = {
  filter?: InputMaybe<RequestFilterInput>;
};

export type ProductionFinalTradeInput = {
  buyer_id?: InputMaybe<Scalars['ID']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['ID']>;
  depot_id?: InputMaybe<Scalars['ID']>;
  end_datetime?: InputMaybe<Scalars['DateTime']>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  facilitator_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  inputs?: InputMaybe<Array<InputMaybe<ProductionFinalTradeItemInputInput>>>;
  mode: Scalars['String'];
  officer_id?: InputMaybe<Scalars['ID']>;
  order_trade_ref_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  outputs?: InputMaybe<Array<InputMaybe<ProductionFinalTradeItemOutputInput>>>;
  packaging?: InputMaybe<Array<InputMaybe<ProductionFinalTradeItemPackagingInput>>>;
  parent_trade_id: Scalars['ID'];
  start_datetime?: InputMaybe<Scalars['DateTime']>;
};

export type ProductionFinalTradeItemInputInput = {
  attachment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  grade_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  storage_picked_records?: InputMaybe<Array<InputMaybe<ProductionFinalTradeItemStoragePickedInput>>>;
  variety_id?: InputMaybe<Scalars['ID']>;
};

export type ProductionFinalTradeItemOutputInput = {
  attachment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  cost_per_unit?: InputMaybe<Scalars['Float']>;
  final_quantity?: InputMaybe<Scalars['Float']>;
  grade_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  total_cost?: InputMaybe<Scalars['Float']>;
  variety_id?: InputMaybe<Scalars['ID']>;
};

export type ProductionFinalTradeItemPackagingInput = {
  attachment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  grade_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  storage_picked_records?: InputMaybe<Array<InputMaybe<ProductionFinalTradeItemStoragePickedInput>>>;
  variety_id?: InputMaybe<Scalars['ID']>;
};

export type ProductionFinalTradeItemStoragePickedInput = {
  cost_per_unit?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  required_quantity?: InputMaybe<Scalars['Float']>;
  total_cost?: InputMaybe<Scalars['Float']>;
  trade_id?: InputMaybe<Scalars['ID']>;
  used_quantity?: InputMaybe<Scalars['Float']>;
  wastage_loss_quantity?: InputMaybe<Scalars['Float']>;
  weight_loss_quantity?: InputMaybe<Scalars['Float']>;
};

export type ProductionTradeInput = {
  buyer_id?: InputMaybe<Scalars['ID']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['ID']>;
  depot_id?: InputMaybe<Scalars['ID']>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  facilitator_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  inputs?: InputMaybe<Array<InputMaybe<ProductionTradeItemInputInput>>>;
  mode: Scalars['String'];
  officer_id?: InputMaybe<Scalars['ID']>;
  order_trade_ref_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  outputs?: InputMaybe<Array<InputMaybe<ProductionTradeItemOutputInput>>>;
  packaging?: InputMaybe<Array<InputMaybe<ProductionTradePackagingInput>>>;
  start_datetime?: InputMaybe<Scalars['DateTime']>;
};

export type ProductionTradeItemInputInput = {
  attachment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  grade_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  storage_picked_records?: InputMaybe<Array<InputMaybe<ProductionTradeItemStoragePickedInput>>>;
  variety_id?: InputMaybe<Scalars['ID']>;
};

export type ProductionTradeItemOutputInput = {
  attachment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  cost_per_unit?: InputMaybe<Scalars['Float']>;
  final_quantity?: InputMaybe<Scalars['Float']>;
  grade_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  total_cost?: InputMaybe<Scalars['Float']>;
  variety_id?: InputMaybe<Scalars['ID']>;
};

export type ProductionTradeItemStoragePickedInput = {
  cost_per_unit?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  required_quantity?: InputMaybe<Scalars['Float']>;
  total_cost?: InputMaybe<Scalars['Float']>;
  trade_id?: InputMaybe<Scalars['ID']>;
};

export type ProductionTradeItemType = {
  __typename?: 'ProductionTradeItemType';
  available_quantity?: Maybe<Scalars['Float']>;
  codename: Scalars['String'];
  commodity: SharedEntityType;
  cost_per_unit?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  final_quantity?: Maybe<Scalars['Float']>;
  grade?: Maybe<SharedEntityType>;
  id: Scalars['ID'];
  kind: TradeProductionTradeItemKindChoices;
  production_trade: ProductionTradeType;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  variety?: Maybe<SharedEntityType>;
};

export type ProductionTradePackagingInput = {
  attachment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  grade_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  storage_picked_records?: InputMaybe<Array<InputMaybe<ProductionTradeItemStoragePickedInput>>>;
  variety_id?: InputMaybe<Scalars['ID']>;
};

export type ProductionTradeToStorageMutation = {
  __typename?: 'ProductionTradeToStorageMutation';
  production_trade: ProductionTradeType;
};

export type ProductionTradeType = {
  __typename?: 'ProductionTradeType';
  associated_trades: Array<TradeType>;
  buyer?: Maybe<SharedEntityType>;
  buyer_tnc?: Maybe<Scalars['String']>;
  child_trades: Array<ProductionTradeType>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  department: SharedEntityType;
  depot?: Maybe<SharedEntityType>;
  /** Optional for planning patti */
  end_datetime?: Maybe<Scalars['DateTime']>;
  expenses: Array<ExpenseType>;
  facilitator?: Maybe<SharedEntityType>;
  id: Scalars['ID'];
  is_verified?: Maybe<Scalars['Boolean']>;
  items: Array<ProductionTradeItemType>;
  kind: TradeProductionTradeKindChoices;
  mode: TradeProductionTradeModeChoices;
  officer?: Maybe<SharedEntityType>;
  order_trade_refs: Array<TradeType>;
  output_cost_per_unit?: Maybe<Scalars['Float']>;
  output_total_cost?: Maybe<Scalars['Float']>;
  output_total_quantity?: Maybe<Scalars['Float']>;
  parent_trade?: Maybe<ProductionTradeType>;
  start_datetime?: Maybe<Scalars['DateTime']>;
  status: TradeProductionTradeStatusChoices;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type ProjectionAssessmentCwInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
  tenure?: InputMaybe<Scalars['Int']>;
  total_sales?: InputMaybe<Scalars['Float']>;
};

export type ProjectionAssessmentInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
  tenure?: InputMaybe<Scalars['Int']>;
  total_sales?: InputMaybe<Scalars['Float']>;
};

export type PurchaseOrderGlType = {
  __typename?: 'PurchaseOrderGlType';
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type PurchaseOrderItemGlType = {
  __typename?: 'PurchaseOrderItemGlType';
  id: Scalars['ID'];
  po: PurchaseOrderGlType;
};

export type PurposeAmountType = {
  __typename?: 'PurposeAmountType';
  amount?: Maybe<Scalars['Float']>;
  display_value?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type PurposeExpenseType = {
  amount: Scalars['Float'];
  purpose: Scalars['String'];
};

export enum QualityParameterKind {
  /** Date */
  Date = 'DATE',
  /** Datetime */
  Datetime = 'DATETIME',
  /** Qualitative */
  Qualitative = 'QUALITATIVE',
  /** Quantitative */
  Quantitative = 'QUANTITATIVE',
  /** Text */
  Text = 'TEXT',
  /** Time */
  Time = 'TIME'
}

export type QualityParameterType = {
  __typename?: 'QualityParameterType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  kind: QualityParameterKind;
  metadata?: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  /** Used to store Physical parameters qualitative fields variations e.g.Color:green,light green */
  options: Array<Scalars['String']>;
  request_set: Array<TestRequestType>;
  resultobservation_set: Array<ResultObservationType>;
  sampleobservation_set: Array<SampleObservationType>;
  template_items: Array<TemplateParameterType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type QualitySampleGlType = {
  __typename?: 'QualitySampleGlType';
  quality_rejection: Scalars['Float'];
};

export type QualityStageInput = {
  sequence?: InputMaybe<Scalars['Int']>;
  stage_id: Scalars['ID'];
};

export type QualityStageType = {
  __typename?: 'QualityStageType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  parent_stage?: Maybe<QualityStageType>;
  secondary_stages: Array<QualityStageType>;
  sequence: Scalars['String'];
  template_set: Array<TemplateType>;
  templates: Array<TemplateType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type ReceiptFinalTradesMutation = {
  __typename?: 'ReceiptFinalTradesMutation';
  affected_rows?: Maybe<Scalars['Int']>;
};

export type ReceiptInput = {
  advance_payments?: InputMaybe<Array<InputMaybe<AdvancePaymentInput>>>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  credit_notes?: InputMaybe<Array<InputMaybe<CreditNoteInput>>>;
  department_id?: InputMaybe<Scalars['ID']>;
  end_date?: InputMaybe<Scalars['String']>;
  expense_taxes?: InputMaybe<Array<InputMaybe<ReceiptTaxInput>>>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  expiry?: InputMaybe<Scalars['String']>;
  facilitator_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  is_multiple_commodity?: InputMaybe<Scalars['Boolean']>;
  junior_officer_id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  officer_id?: InputMaybe<Scalars['ID']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_receipt_id?: InputMaybe<Scalars['ID']>;
  seller_gst_attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  seller_id?: InputMaybe<Scalars['ID']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['Decimal']>;
  start_date?: InputMaybe<Scalars['String']>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  taxes?: InputMaybe<Array<InputMaybe<ReceiptTaxInput>>>;
  trades?: InputMaybe<Array<InputMaybe<ReceiptTradeInput>>>;
  vehicle_id?: InputMaybe<Scalars['ID']>;
};

export type ReceiptSummaryType = {
  __typename?: 'ReceiptSummaryType';
  overdue_amount?: Maybe<Scalars['Float']>;
  overdue_days?: Maybe<Scalars['Int']>;
};

export type ReceiptTaxInput = {
  percentage: Scalars['Decimal'];
  tax_name: Scalars['String'];
};

export type ReceiptTradeInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  buyer_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<TradeItemInput>>>;
};

export type ReceiptType = {
  __typename?: 'ReceiptType';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_expense_gst_auto_calculated: Scalars['Boolean'];
  buyer_gst_auto_calculated: Scalars['Boolean'];
  buyer_tnc?: Maybe<Scalars['String']>;
  child_receipts: Array<ReceiptType>;
  commodities: Array<SharedEntityType>;
  commodity?: Maybe<SharedEntityType>;
  commodity_varieties: Array<SharedEntityType>;
  commodity_variety?: Maybe<SharedEntityType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  /** Total amount reducing std. deduction */
  deducted_amount?: Maybe<Scalars['Decimal']>;
  /** Total quantity reducing std. deduction */
  deducted_quantity?: Maybe<Scalars['Decimal']>;
  /** Total quantity reducing std. deduction in kg */
  deducted_quantity_kg?: Maybe<Scalars['Decimal']>;
  /** Available quantity for child trades after deducting std. deduction */
  deducted_quantity_remaining?: Maybe<Scalars['Decimal']>;
  /** Available quantity for child trades after deducting std. deduction */
  deducted_quantity_remaining_kg?: Maybe<Scalars['Decimal']>;
  department: SharedEntityType;
  /** Expense that not calculated as profit */
  direct_cost?: Maybe<Scalars['Float']>;
  end_date?: Maybe<Scalars['Date']>;
  /** Only expense amount */
  expense_amount?: Maybe<Scalars['Decimal']>;
  expiry?: Maybe<Scalars['Date']>;
  facilitator?: Maybe<SharedEntityType>;
  group_expenses: Array<ExpenseType>;
  id: Scalars['ID'];
  is_multiple_commodity: Scalars['Boolean'];
  issuance_notes: Array<IssuanceNoteType>;
  junior_officer?: Maybe<SharedEntityType>;
  kind: TradeReceiptKindChoices;
  material_kind?: Maybe<TradeReceiptMaterialKindChoices>;
  metadata?: Maybe<Scalars['JSONString']>;
  mode: TradeReceiptModeChoices;
  officer?: Maybe<SharedEntityType>;
  packaging: TradeReceiptPackagingChoices;
  parent_receipt?: Maybe<ReceiptType>;
  plot_crop?: Maybe<SharedEntityType>;
  /** Calculated on Hishob Patti (Final) only. */
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_transactions: Array<TransactionType>;
  remark?: Maybe<Scalars['String']>;
  /** Quantity returned to parent trade */
  returned_quantity?: Maybe<Scalars['Decimal']>;
  /** Quantity returned to parent trade in kg */
  returned_quantity_kg?: Maybe<Scalars['Decimal']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller?: Maybe<SharedEntityType>;
  /** Sum of seller expense amount in trades */
  seller_expense_amount?: Maybe<Scalars['Decimal']>;
  /** Final amount seller can receive */
  seller_receivable_amount?: Maybe<Scalars['Decimal']>;
  seller_settlement_status?: Maybe<TradeReceiptSellerSettlementStatusChoices>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['Decimal']>;
  start_date?: Maybe<Scalars['Date']>;
  /** Calculated using platform_rate and quantity */
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_expense_gst_auto_calculated: Scalars['Boolean'];
  supplier_gst_auto_calculated: Scalars['Boolean'];
  /** Supplier rate at the time of trade creation */
  supplier_rate?: Maybe<Scalars['Float']>;
  /** Sum of total amount in trades */
  total_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of total amount in trades */
  total_quantity?: Maybe<Scalars['Decimal']>;
  tracking_code: Scalars['String'];
  trades: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle?: Maybe<SharedEntityType>;
};

export type RecordCropMilestone = {
  __typename?: 'RecordCropMilestone';
  plot_crop_milestones?: Maybe<Array<Maybe<PlotCropMilestoneType>>>;
};

export type RecordExpenseMutation = {
  __typename?: 'RecordExpenseMutation';
  plot_crop_transaction?: Maybe<PlotCropTransactionInsertType>;
};

export type RecordExpenseMutationV2 = {
  __typename?: 'RecordExpenseMutationV2';
  plot_crop_transaction?: Maybe<FinancialTransactionInsertType>;
};

export type RecordGrowthStage = {
  __typename?: 'RecordGrowthStage';
  growth_stage?: Maybe<PlotCropGrowthStageType>;
};

export type RecordIncomeMutation = {
  __typename?: 'RecordIncomeMutation';
  plot_crop_transaction?: Maybe<PlotCropTransactionInsertType>;
};

export type RecordIncomeMutationV2 = {
  __typename?: 'RecordIncomeMutationV2';
  plot_crop_transaction?: Maybe<FinancialTransactionInsertType>;
};

export type RecordReturnQuantityInput = {
  returned_quantity: Scalars['Decimal'];
  trade_item_id: Scalars['ID'];
};

export type RecordTradeReturnMutation = {
  __typename?: 'RecordTradeReturnMutation';
  affected_rows?: Maybe<Scalars['Int']>;
};

export type Refresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar'];
  refresh_expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token: Scalars['String'];
};

export type RegionType = {
  __typename?: 'RegionType';
  /** Village of the user, if available */
  baseuser_set: Array<BaseUserType>;
  code?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  country_addresses: Array<KiteAddressType>;
  description?: Maybe<Scalars['String']>;
  district_addresses: Array<KiteAddressType>;
  field_set: Array<FieldType>;
  geom?: Maybe<GeometryObjectType>;
  id?: Maybe<Scalars['Int']>;
  is_active: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  /** The region in which this mutual group is situated at */
  mutualgroup_set: Array<MutualGroupType>;
  name: Scalars['String'];
  parent_region?: Maybe<VillageDataType>;
  regions: Array<VillageDataType>;
  state_addresses: Array<KiteAddressType>;
  sub_region_addresses: Array<KiteAddressType>;
  taluka_addresses: Array<KiteAddressType>;
  village_addresses: Array<KiteAddressType>;
};

export type RequestAdvancePaymentMutation = {
  __typename?: 'RequestAdvancePaymentMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type RequestFilterInput = {
  category__codename?: InputMaybe<Scalars['String']>;
};

export type RequestSummaryType = {
  __typename?: 'RequestSummaryType';
  latest_request_date_time?: Maybe<Scalars['DateTime']>;
  request_cnt?: Maybe<Scalars['Int']>;
};

export type RequestType = {
  __typename?: 'RequestType';
  color_code?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  department?: Maybe<ExternalEntityType>;
  entity_state?: Maybe<EntityStateType>;
  id: Scalars['ID'];
  is_archived: Scalars['Boolean'];
  is_partial: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  parameters: Array<QualityParameterType>;
  parent_request?: Maybe<TestRequestType>;
  primary_location: ExternalEntityType;
  /** current gps location from where request is raised */
  recorded_at?: Maybe<AddressQcType>;
  rejection_percent?: Maybe<Scalars['Decimal']>;
  rejection_reason?: Maybe<Scalars['String']>;
  results: Array<ResultType>;
  sample?: Maybe<SampleType>;
  sampleobservation_set: Array<SampleObservationType>;
  secondary_locations: Array<ExternalEntityType>;
  templates: Array<TemplateType>;
  test_for: ExternalEntityType;
  test_requests: Array<TestRequestType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
  withdraw_sample_on?: Maybe<Scalars['DateTime']>;
};


export type RequestTypeEntity_StateArgs = {
  workflow_codename: Scalars['String'];
};

export type ResultCommentCreatedByPhotoType = {
  __typename?: 'ResultCommentCreatedByPhotoType';
  url?: Maybe<Scalars['String']>;
};

export type ResultCommentCreatedByType = {
  __typename?: 'ResultCommentCreatedByType';
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  photo?: Maybe<ResultCommentCreatedByPhotoType>;
};

export type ResultCommentType = {
  __typename?: 'ResultCommentType';
  comment: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<ResultCommentCreatedByType>;
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  result: ResultType;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type ResultEvaluationFilters = {
  result__department__reference_id?: InputMaybe<Scalars['String']>;
  result__sample__year__reference_id?: InputMaybe<Scalars['String']>;
  result__sample__year__reference_id__in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  result__test_request__category__codename?: InputMaybe<Scalars['String']>;
  result__test_request__laboratory__codename?: InputMaybe<Scalars['String']>;
  result__test_request__laboratory__codename__in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResultFilters = {
  department__reference_id?: InputMaybe<Scalars['String']>;
  observations__evaluated_tags__name__in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  observations__quality_parameter_id__in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sample__year__reference_id?: InputMaybe<Scalars['String']>;
  sample__year__reference_id__in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  test_request__category__codename?: InputMaybe<Scalars['String']>;
};

export type ResultObservationFilters = {
  evaluated_tags__name__in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  quality_parameter_id__in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  result__department__reference_id?: InputMaybe<Scalars['String']>;
  result__sample__year__reference_id?: InputMaybe<Scalars['String']>;
  result__sample__year__reference_id__in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  result__test_request__category__codename?: InputMaybe<Scalars['String']>;
};

export type ResultObservationType = {
  __typename?: 'ResultObservationType';
  attachments: Array<MediaQcType>;
  evaluated_tags: Array<EvaluationTagType>;
  evaluations?: Maybe<Array<Maybe<EvaluationTagType>>>;
  quality_parameter: QualityParameterType;
  result: ResultType;
  template_parameter?: Maybe<TemplateParameterType>;
  value: Scalars['Float'];
};

export type ResultObservationsFilterInput = {
  template?: InputMaybe<Scalars['String']>;
};

export type ResultSummaryData = {
  __typename?: 'ResultSummaryData';
  company?: Maybe<Scalars['String']>;
  fail_in_chemical?: Maybe<Scalars['String']>;
  farmer?: Maybe<Scalars['String']>;
  individual_percent?: Maybe<Scalars['String']>;
  mh_no?: Maybe<Scalars['String']>;
  mrl?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  sampling_date?: Maybe<Scalars['String']>;
  testing_lab?: Maybe<Scalars['String']>;
  variety?: Maybe<Scalars['String']>;
  village?: Maybe<Scalars['String']>;
};

export type ResultSummaryInput = {
  first?: InputMaybe<Scalars['Int']>;
  result_filters?: InputMaybe<ResultFilters>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type ResultSummaryOutput = {
  __typename?: 'ResultSummaryOutput';
  data?: Maybe<Array<Maybe<ResultSummaryData>>>;
  data_count?: Maybe<Scalars['Int']>;
};

export type ResultType = {
  __typename?: 'ResultType';
  codename: Scalars['String'];
  color_code?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<Maybe<ResultCommentType>>>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  department?: Maybe<ExternalEntityType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  observations: Array<ResultObservationType>;
  posted_on?: Maybe<Scalars['Date']>;
  rejection_percent?: Maybe<Scalars['Decimal']>;
  rejection_reason?: Maybe<Scalars['String']>;
  result_grade?: Maybe<Scalars['String']>;
  sample: SampleType;
  send_whatsapp_msg: Scalars['Boolean'];
  template: TemplateType;
  test_request: TestRequestType;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type SiUnitGlType = {
  __typename?: 'SIUnitGlType';
  base_conversion: Scalars['Float'];
  base_unit?: Maybe<SiUnitGlType>;
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SiUnitType = {
  __typename?: 'SIUnitType';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit?: Maybe<SiUnitType>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  field_set: Array<FieldType>;
  id?: Maybe<Scalars['Int']>;
  is_active: Scalars['Boolean'];
  long_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plot_set: Array<DjangoPlotType>;
  plotcrop_set: Array<PlotCropDetailType>;
  siunit_set: Array<SiUnitType>;
  symbol?: Maybe<Scalars['String']>;
  vt_plot_plotcrop_estd_harvest_quantity_unit: Array<PlotCropDetailType>;
  vt_plot_plotcrop_harvest_quantity_unit: Array<PlotCropDetailType>;
  vt_plot_plotcrop_p2p_distance_unit: Array<PlotCropDetailType>;
  vt_plot_plotcrop_r2r_distance_unit: Array<PlotCropDetailType>;
};

export type SkuPackingMaterialGlType = {
  __typename?: 'SKUPackingMaterialGlType';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  type: PackingMaterialType;
};

export type SkuTypeGlType = {
  __typename?: 'SKUTypeGlType';
  capacity: Scalars['Float'];
  capacity_unit: SiUnitGlType;
  codename: Scalars['UUID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SampleObservationInput = {
  help_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  instrument_id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  parameter_id: Scalars['ID'];
  photos?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  remark?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
  value_date?: InputMaybe<Scalars['Date']>;
  value_datetime?: InputMaybe<Scalars['DateTime']>;
  value_text?: InputMaybe<Scalars['String']>;
  value_time?: InputMaybe<Scalars['Time']>;
};

export type SampleObservationType = {
  __typename?: 'SampleObservationType';
  attachments: Array<MediaQcType>;
  created_at: Scalars['DateTime'];
  /** More info about observation */
  help_text?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** This is the value name used for qualitative fields */
  name?: Maybe<Scalars['String']>;
  observation_number: Scalars['Int'];
  quality_parameter: QualityParameterType;
  remark: Scalars['String'];
  result_observations: Array<ResultObservationType>;
  sample: SampleType;
  test_request: TestRequestType;
  updated_at: Scalars['DateTime'];
  value: Scalars['Float'];
  value_date?: Maybe<Scalars['Date']>;
  value_datetime?: Maybe<Scalars['DateTime']>;
  value_text?: Maybe<Scalars['String']>;
  value_time?: Maybe<Scalars['Time']>;
};

export type SampleRequestType = {
  __typename?: 'SampleRequestType';
  color_code?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  department?: Maybe<ExternalEntityType>;
  id: Scalars['ID'];
  is_archived: Scalars['Boolean'];
  is_partial: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  parameters: Array<QualityParameterType>;
  parent_request?: Maybe<TestRequestType>;
  primary_location: ExternalEntityType;
  /** current gps location from where request is raised */
  recorded_at?: Maybe<AddressQcType>;
  rejection_percent?: Maybe<Scalars['Decimal']>;
  rejection_reason?: Maybe<Scalars['String']>;
  results: Array<ResultType>;
  sample?: Maybe<SampleType>;
  sampleobservation_set: Array<SampleObservationType>;
  secondary_locations: Array<ExternalEntityType>;
  templates: Array<TemplateType>;
  test_for: ExternalEntityType;
  test_requests: Array<TestRequestType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
  withdraw_sample_on?: Maybe<Scalars['DateTime']>;
};

export type SampleSummaryChartInput = {
  result_evaluation_filters?: InputMaybe<ResultEvaluationFilters>;
};

export type SampleSummaryChartOutput = {
  __typename?: 'SampleSummaryChartOutput';
  fail_count?: Maybe<Scalars['Float']>;
  fail_percent?: Maybe<Scalars['Float']>;
  pass_count?: Maybe<Scalars['Float']>;
  total_count?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['String']>;
};

export type SampleType = {
  __typename?: 'SampleType';
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  drawn_on?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  observation_remark: Scalars['String'];
  observations: Array<SampleObservationType>;
  quantity: Scalars['Decimal'];
  recommendations: Scalars['String'];
  reference_id: Scalars['String'];
  results: Array<ResultType>;
  sample_request: TestRequestType;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  year?: Maybe<ExternalEntityType>;
};

export type ScheduleGlType = {
  __typename?: 'ScheduleGlType';
  aggregator?: Maybe<BaseUserGlType>;
  commodity_code?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyGlType>;
  crop_group?: Maybe<CommodityGroupGlType>;
  date: Scalars['Date'];
  destination_depot?: Maybe<DepotGlType>;
  gate_pass: Scalars['String'];
  id: Scalars['ID'];
  labour_count: Scalars['Int'];
  plot_commodity: PlotCommodityGlType;
  schedule_request?: Maybe<ScheduleRequestGlType>;
  scheduled_in?: Maybe<FmsDepartmentType>;
  sku_type?: Maybe<SkuTypeGlType>;
  source_depot?: Maybe<DepotGlType>;
  variety: CommodityVarietyGlType;
  vehicle?: Maybe<VehicleGlType>;
};

export type ScheduleRequestGlType = {
  __typename?: 'ScheduleRequestGlType';
  id: Scalars['ID'];
  raised_by: BaseUserGlType;
  raised_in: FmsDepartmentType;
  request_approved_by?: Maybe<BaseUserGlType>;
  sku_count: Scalars['Int'];
  sku_type: SkuTypeGlType;
  time_slot?: Maybe<TimeSlotRequirementGlType>;
};

export type SecondaryGrowthStagesType = {
  __typename?: 'SecondaryGrowthStagesType';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_milestone_stage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_current_stage?: Maybe<Scalars['Boolean']>;
  max_days_after?: Maybe<Scalars['Int']>;
  milestone_stage?: Maybe<Scalars['String']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  stage_length?: Maybe<Scalars['String']>;
  stage_status?: Maybe<Scalars['String']>;
};

export type SellableItemGlType = {
  __typename?: 'SellableItemGlType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  fscodename?: Maybe<Scalars['String']>;
  fsmeta?: Maybe<Scalars['JSONScalar']>;
  id: Scalars['ID'];
  long_description: Scalars['String'];
  name: Scalars['String'];
  overall_rating: Scalars['Float'];
  primary_photo: MediaGlType;
  related_item?: Maybe<SellableItemGlType>;
  related_quantity: Scalars['Int'];
  secondary_sku_type?: Maybe<SkuTypeGlType>;
  sellable_stocks: Array<SellableItemStockGlType>;
  short_description: Scalars['String'];
  taxes: Array<TaxGlType>;
  transportation_type: SellableItemTransportationType;
  updated_at: Scalars['DateTime'];
};

export type SellableItemStockGlType = {
  __typename?: 'SellableItemStockGlType';
  booked_stock_count: Scalars['Int'];
  created_at: Scalars['DateTime'];
  current_stock_count: Scalars['Int'];
  department?: Maybe<FmsDepartmentType>;
  discounted_rate: Scalars['Float'];
  distribution_centre: DistributionCentreGlType;
  dumped_stock_count: Scalars['Int'];
  expiry_date?: Maybe<Scalars['DateTime']>;
  hold_stock_count: Scalars['Int'];
  id: Scalars['ID'];
  intransit_stock_count: Scalars['Int'];
  is_live: Scalars['Boolean'];
  max_rate: Scalars['Float'];
  min_rate: Scalars['Float'];
  offer_stock_count: Scalars['Int'];
  ordering_conditions: Scalars['JSONString'];
  rejected_stock_count: Scalars['Int'];
  related_stock?: Maybe<SellableItemStockGlType>;
  sellable_item: SellableItemGlType;
  unit_rate: Scalars['Float'];
  updated_at: Scalars['DateTime'];
};

/** An enumeration. */
export enum SellableItemTransportationType {
  /** Normal */
  Nr = 'NR',
  /** Other */
  Ot = 'OT',
  /** Refrigerated */
  Rf = 'RF'
}

export type SellerBifurcationType = {
  __typename?: 'SellerBifurcationType';
  advance_amount?: Maybe<OperationValueType>;
  advance_remaining_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<OperationValueType>;
  paid_amount?: Maybe<OperationValueType>;
  seller_credit_note_amount?: Maybe<OperationValueType>;
  seller_debit_note_amount?: Maybe<OperationValueType>;
  seller_expense_amount?: Maybe<OperationValueType>;
  seller_expense_tax_amount?: Maybe<OperationValueType>;
  seller_tax_amount?: Maybe<OperationValueType>;
  seller_tds?: Maybe<OperationValueType>;
  supplier_charge?: Maybe<OperationValueType>;
  total?: Maybe<Scalars['Float']>;
};

export type SendNotification = {
  __typename?: 'SendNotification';
  success?: Maybe<Scalars['Boolean']>;
};

export type SetBaseUserFieldsMutation = {
  __typename?: 'SetBaseUserFieldsMutation';
  base_user?: Maybe<BaseUserType>;
};

export type SetBrandFieldsMutation = {
  __typename?: 'SetBrandFieldsMutation';
  brand?: Maybe<BrandType>;
};

export type SetBudgetMutation = {
  __typename?: 'SetBudgetMutation';
  plot_crop_transaction?: Maybe<PlotCropTransactionInsertType>;
};

export type SetBudgetMutationV2 = {
  __typename?: 'SetBudgetMutationV2';
  plot_crop_transaction?: Maybe<FinancialTransactionInsertType>;
};

export type SetBusinessFieldsMutation = {
  __typename?: 'SetBusinessFieldsMutation';
  business?: Maybe<BusinessType>;
};

export type SetDocumentAttachmentsMutation = {
  __typename?: 'SetDocumentAttachmentsMutation';
  document?: Maybe<DocumentType>;
};

export type SetGradeFieldsMutation = {
  __typename?: 'SetGradeFieldsMutation';
  grade?: Maybe<GradeType>;
};

export type SetPaymentDetailAttachmentsMutation = {
  __typename?: 'SetPaymentDetailAttachmentsMutation';
  payment_detail?: Maybe<PaymentDetailType>;
};

export type SetUserLanguage = {
  __typename?: 'SetUserLanguage';
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
};

export type SetuMediaType = {
  __typename?: 'SetuMediaType';
  access: MediaAccess;
  baseuser_set: Array<BaseUserType>;
  business?: Maybe<BusinessType>;
  commodity_set: Array<CommodityType>;
  commodityvariety_set: Array<CommodityVarietyType>;
  company?: Maybe<CompanyType>;
  created_at: Scalars['DateTime'];
  crop_set: Array<CropType>;
  /** Feature photo */
  cropinfestation_set: Array<CropInfestationDetailType>;
  cropvariety_set: Array<CropVarietyType>;
  department?: Maybe<DepartmentType>;
  document_set: Array<DocumentType>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_encrypted: Scalars['Boolean'];
  location?: Maybe<KiteAddressType>;
  media_kind?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  organisation?: Maybe<OrganisationIdNameType>;
  paymentdetail_set: Array<PaymentDetailType>;
  primarygrowthstage_set: Array<PrimaryGsType>;
  related_mutual_group?: Maybe<MutualGroupType>;
  related_user?: Maybe<BaseUserType>;
  size?: Maybe<Scalars['Int']>;
  soil_set: Array<SoilType>;
  thumbnail?: Maybe<Scalars['JSONString']>;
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
  varietygrade_set: Array<VarietyGradeType>;
};

export type SetuTradeAddressInput = {
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  village?: InputMaybe<Scalars['String']>;
};

export type SetuTradeAddressType = {
  __typename?: 'SetuTradeAddressType';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  district?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  local_area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storage_locations: Array<StorageLocationType>;
  taluka?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  village?: Maybe<Scalars['String']>;
};

export type SharedEntityType = {
  __typename?: 'SharedEntityType';
  bank_transactions: Array<TransactionType>;
  buyer_groups_offers: Array<OfferType>;
  buyer_invoices: Array<InvoiceType>;
  buyer_plot_crop_trades: Array<TradeType>;
  buyer_production_trades: Array<ProductionTradeType>;
  buyer_trades: Array<TradeType>;
  codename: Scalars['String'];
  commodities_receipts: Array<ReceiptType>;
  commodities_trades: Array<TradeType>;
  commodity_demands: Array<DemandType>;
  commodity_offers: Array<OfferType>;
  commodity_production_trade_items: Array<ProductionTradeItemType>;
  commodity_trade_groups: Array<ReceiptType>;
  commodity_trade_items: Array<TradeItemType>;
  commodity_trades: Array<TradeType>;
  commodity_varieties_receipts: Array<ReceiptType>;
  commodity_varieties_trades: Array<TradeType>;
  commodity_variety_demands: Array<DemandType>;
  commodity_variety_offers: Array<OfferType>;
  commodity_variety_trade_groups: Array<ReceiptType>;
  commodity_variety_trade_items: Array<TradeItemType>;
  commodity_variety_trades: Array<TradeType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  currency_trade_items: Array<TradeItemType>;
  demands: Array<DemandType>;
  demands_as_buyer: Array<DemandType>;
  demands_jr_officer: Array<DemandType>;
  demands_sr_officer: Array<DemandType>;
  department_demands: Array<DemandType>;
  department_invoices: Array<InvoiceType>;
  department_offers: Array<OfferType>;
  department_over_due_approvals: Array<OverDueApprovalType>;
  department_production_trades: Array<ProductionTradeType>;
  department_trade_groups: Array<ReceiptType>;
  department_trades: Array<TradeType>;
  department_transactions: Array<TransactionType>;
  department_trips: Array<TripType>;
  department_user_advance: Array<DepartmentUserAdvanceType>;
  depot_production_trades: Array<ProductionTradeType>;
  description: Scalars['String'];
  facilitator_demands: Array<DemandType>;
  facilitator_offers: Array<OfferType>;
  facilitator_production_trade: Array<ProductionTradeType>;
  facilitator_trade_groups: Array<ReceiptType>;
  facilitator_trades: Array<TradeType>;
  grade_production_trade_items: Array<ProductionTradeItemType>;
  group_name: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  issuance_notes: Array<IssuanceNoteType>;
  junior_officer_receipts: Array<ReceiptType>;
  junior_officer_trades: Array<TradeType>;
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  offers: Array<OfferType>;
  offers_as_seller: Array<OfferType>;
  offers_jr_officer: Array<OfferType>;
  offers_sr_officer: Array<OfferType>;
  officer_production_trades: Array<ProductionTradeType>;
  officer_receipts: Array<ReceiptType>;
  officer_trades: Array<TradeType>;
  over_draft_final_officer_one: Array<OverDraftType>;
  over_draft_final_officer_two: Array<OverDraftType>;
  over_draft_recommendation_officer: Array<OverDraftType>;
  over_due_approval_cw_logs: Array<OverDueApprovalLogCwType>;
  over_due_approval_logs: Array<OverDueApprovalLogType>;
  over_due_approvals: Array<OverDueApprovalType>;
  over_due_request_approvals: Array<OverDueApprovalType>;
  packaging_unit_trade_items: Array<TradeItemType>;
  plot_crop_offers: Array<OfferType>;
  plot_crop_trade_groups: Array<ReceiptType>;
  plot_crop_trade_items: Array<TradeItemType>;
  plot_crop_trades: Array<TradeType>;
  private_metadata: Scalars['JSONString'];
  quantity_unit_demands: Array<DemandType>;
  quantity_unit_offers: Array<OfferType>;
  quantity_unit_trade_items: Array<TradeItemType>;
  rate_unit_trade_items: Array<TradeItemType>;
  reference_id: Scalars['String'];
  result_trade_items: Array<TradeItemType>;
  seller_groups_demands: Array<DemandType>;
  seller_trade_groups: Array<ReceiptType>;
  seller_trades: Array<TradeType>;
  storage_location_pocs: Array<StorageLocationType>;
  storage_locations: Array<StorageLocationType>;
  storage_sub_locations: Array<StorageSubLocationType>;
  tradestatus_set: Array<TradeStatusType>;
  trip_set: Array<TripType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  user_credit_wallets: Array<CreditWalletType>;
  user_credits: Array<CreditType>;
  user_department_advances: Array<DepartmentUserAdvanceType>;
  user_transactions: Array<TransactionType>;
  variety_grade_demands: Array<DemandType>;
  variety_grade_offers: Array<OfferType>;
  variety_grade_trade_items: Array<TradeItemType>;
  variety_production_trade_items: Array<ProductionTradeItemType>;
  vehicle_receipts: Array<ReceiptType>;
  vehicle_trades: Array<TradeType>;
};

export type ShippingGlType = {
  __typename?: 'ShippingGlType';
  actual_delivery?: Maybe<Scalars['DateTime']>;
  charges: Scalars['Float'];
  created_at: Scalars['DateTime'];
  delivery_remark: Scalars['String'];
  delivery_status?: Maybe<Scalars['String']>;
  delivery_taxes: Array<TaxGlType>;
  distribution_centre: DistributionCentreGlType;
  estimated_delivery?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  poc_name: Scalars['String'];
  poc_number: Scalars['String'];
  shipment_slot_selected?: Maybe<TimeSlotGlType>;
  shipping_address?: Maybe<AddressGlType>;
  shipping_method?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type SoilType = {
  __typename?: 'SoilType';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** The field capacity of the soil type */
  field_capacity?: Maybe<Scalars['Float']>;
  field_set: Array<FieldType>;
  id?: Maybe<Scalars['Int']>;
  /** URL of the image related to soil type */
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  photo?: Maybe<MediaType>;
  /** The wilting point of the soil type */
  wilting_point?: Maybe<Scalars['Float']>;
};

export type SowingMaterialTypeSchema = {
  __typename?: 'SowingMaterialTypeSchema';
  codename: Scalars['String'];
  crop: CropType;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

export type StateType = {
  __typename?: 'StateType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  display_name: Scalars['String'];
  entities: Array<EntityStateType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['JSONString'];
  name: Scalars['String'];
  private_metadata: Scalars['JSONString'];
  sequence: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum StockDemandMaterialKindChoices {
  /** Commodity */
  Commodity = 'COMMODITY',
  /** Packaging */
  Packaging = 'PACKAGING'
}

/** An enumeration. */
export enum StockDemandModeChoices {
  /** Direct */
  Direct = 'DIRECT',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Non KYC */
  NonKyc = 'NON_KYC'
}

/** An enumeration. */
export enum StockDemandPackagingChoices {
  /** Finished Goods */
  FinishedGoods = 'FINISHED_GOODS',
  /** Raw Material */
  RawMaterial = 'RAW_MATERIAL'
}

/** An enumeration. */
export enum StockDemandSellerSourceKindChoices {
  /** External */
  External = 'EXTERNAL',
  /** Internal */
  Internal = 'INTERNAL'
}

/** An enumeration. */
export enum StockDemandStatusChoices {
  /** Closed */
  Closed = 'CLOSED',
  /** Created */
  Created = 'CREATED',
  /** Live */
  Live = 'LIVE',
  /** Uploading Enquiries */
  UploadingEnquiries = 'UPLOADING_ENQUIRIES',
  /** Uploading Enquiries Failed */
  UploadingEnquiriesFailed = 'UPLOADING_ENQUIRIES_FAILED'
}

/** An enumeration. */
export enum StockOfferBuyerSourceKindChoices {
  /** External */
  External = 'EXTERNAL',
  /** Internal */
  Internal = 'INTERNAL'
}

/** An enumeration. */
export enum StockOfferMaterialKindChoices {
  /** Commodity */
  Commodity = 'COMMODITY',
  /** Packaging */
  Packaging = 'PACKAGING'
}

/** An enumeration. */
export enum StockOfferModeChoices {
  /** Direct */
  Direct = 'DIRECT',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Non KYC */
  NonKyc = 'NON_KYC'
}

/** An enumeration. */
export enum StockOfferPackagingChoices {
  /** Finished Goods */
  FinishedGoods = 'FINISHED_GOODS',
  /** Raw Material */
  RawMaterial = 'RAW_MATERIAL'
}

/** An enumeration. */
export enum StockOfferStatusChoices {
  /** Closed */
  Closed = 'CLOSED',
  /** Created */
  Created = 'CREATED',
  /** Live */
  Live = 'LIVE',
  /** Uploading Enquiries */
  UploadingEnquiries = 'UPLOADING_ENQUIRIES',
  /** Uploading Enquiries Failed */
  UploadingEnquiriesFailed = 'UPLOADING_ENQUIRIES_FAILED'
}

/** An enumeration. */
export enum StockStorageLocationAgreementLeaseTenureKindChoices {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

/** An enumeration. */
export enum StockStorageLocationAgreementOwnershipKindChoices {
  /** Lease */
  Lease = 'LEASE',
  /** Own */
  Own = 'OWN'
}

export type StorageCommoditySummaryType = {
  __typename?: 'StorageCommoditySummaryType';
  actual_stock_kg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<SharedEntityType>;
  demands?: Maybe<Array<Maybe<DemandType>>>;
  grade?: Maybe<SharedEntityType>;
  last_updated?: Maybe<Scalars['Date']>;
  minimum_selling_quantity_kg?: Maybe<Scalars['Float']>;
  offers?: Maybe<Array<Maybe<OfferType>>>;
  pattis?: Maybe<Array<Maybe<StoragePattiType>>>;
  total_closing_stock_kg?: Maybe<Scalars['Float']>;
  total_consumed_stock_kg?: Maybe<Scalars['Float']>;
  total_opening_stock_kg?: Maybe<Scalars['Float']>;
  variety?: Maybe<SharedEntityType>;
  virtual_stock_kg?: Maybe<Scalars['Float']>;
};

export type StorageLocationAgreementInput = {
  agreement_no?: InputMaybe<Scalars['String']>;
  attachments_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['Date']>;
  expiry_alert_days?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  lease_amount?: InputMaybe<Scalars['Float']>;
  lease_tenure_kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership_kind?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['Date']>;
  tnc?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Array<InputMaybe<AgreementTransactionInput>>>;
};

export type StorageLocationAgreementType = {
  __typename?: 'StorageLocationAgreementType';
  agreement_no?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by?: Maybe<UserCustomType>;
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  end_date: Scalars['Date'];
  /** Number of days before expiry to send alert */
  expiry_alert_days: Scalars['Int'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  lease_amount?: Maybe<Scalars['Float']>;
  lease_tenure_kind?: Maybe<StockStorageLocationAgreementLeaseTenureKindChoices>;
  name: Scalars['String'];
  ownership_kind: StockStorageLocationAgreementOwnershipKindChoices;
  start_date: Scalars['Date'];
  storage_location?: Maybe<StorageLocationType>;
  tnc?: Maybe<Scalars['String']>;
  transactions: Array<AgreementTransactionType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
};

export type StorageLocationAlertsType = {
  __typename?: 'StorageLocationAlertsType';
  current_agreement?: Maybe<StorageLocationAgreementType>;
  icon?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  storage_location?: Maybe<StorageLocationType>;
  title?: Maybe<Scalars['String']>;
};

export type StorageLocationCustomListType = {
  __typename?: 'StorageLocationCustomListType';
  agreement_status?: Maybe<Scalars['String']>;
  alerts?: Maybe<Array<Maybe<StorageLocationAlertsType>>>;
  current_agreement?: Maybe<StorageLocationAgreementType>;
  pending_agreement?: Maybe<StorageLocationAgreementType>;
  storage_location?: Maybe<StorageLocationType>;
  total_capacity_quantity_metric_ton?: Maybe<Scalars['Float']>;
  trade_used_quantity_metric_ton?: Maybe<Scalars['Float']>;
};

export type StorageLocationDashboardType = {
  __typename?: 'StorageLocationDashboardType';
  approved_storage_locations?: Maybe<Scalars['Int']>;
  expired_agreement_storage_locations?: Maybe<Scalars['Int']>;
  expiring_soon_agreement_storage_locations?: Maybe<Scalars['Int']>;
  pending_storage_locations?: Maybe<Scalars['Int']>;
  storage_locations?: Maybe<Array<Maybe<StorageLocationCustomListType>>>;
  total_count?: Maybe<Scalars['Int']>;
  total_storage_locations?: Maybe<Scalars['Int']>;
  valid_agreement_storage_locations?: Maybe<Scalars['Int']>;
};

export type StorageLocationDetailType = {
  __typename?: 'StorageLocationDetailType';
  address?: Maybe<SetuTradeAddressType>;
  alerts?: Maybe<Array<Maybe<StorageLocationAlertsType>>>;
  capacity_usage?: Maybe<CapacityUsageType>;
  current_agreement?: Maybe<AgreementDetailsType>;
  previous_agreements?: Maybe<Array<Maybe<AgreementDetailsType>>>;
  storage_info?: Maybe<StorageLocationInfoType>;
  sub_locations?: Maybe<Array<Maybe<SubLocationInfoType>>>;
};

export type StorageLocationInfoType = {
  __typename?: 'StorageLocationInfoType';
  capacity?: Maybe<Scalars['String']>;
  capacity_unit?: Maybe<SharedEntityType>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  is_active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  storage_type?: Maybe<Scalars['String']>;
};

export type StorageLocationKindType = {
  __typename?: 'StorageLocationKindType';
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  sub_locations: Array<StorageSubLocationType>;
  updated_at: Scalars['DateTime'];
};

export type StorageLocationSummaryType = {
  __typename?: 'StorageLocationSummaryType';
  next_payment_date?: Maybe<Scalars['Date']>;
};

export type StorageLocationType = {
  __typename?: 'StorageLocationType';
  address?: Maybe<SetuTradeAddressType>;
  agreements: Array<StorageLocationAgreementType>;
  /** Capacity in kg */
  capacity: Scalars['Float'];
  /** Capacity in kg */
  capacity_kg?: Maybe<Scalars['Float']>;
  capacity_unit: SharedEntityType;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  pocs: Array<SharedEntityType>;
  storage_location_trades: Array<TradeType>;
  sub_locations: Array<StorageSubLocationType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type StoragePattiType = {
  __typename?: 'StoragePattiType';
  batch_number?: Maybe<Scalars['String']>;
  closing_stock_kg?: Maybe<Scalars['Float']>;
  consumed_stock_kg?: Maybe<Scalars['Float']>;
  created_on?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  material?: Maybe<Scalars['String']>;
  opening_stock_kg?: Maybe<Scalars['Float']>;
  outward_actions?: Maybe<Array<Maybe<Scalars['String']>>>;
  patti_ref?: Maybe<Scalars['String']>;
  ref_pattis?: Maybe<Scalars['String']>;
  std_holding_days?: Maybe<Scalars['Int']>;
  storage_location?: Maybe<Scalars['String']>;
  storage_status?: Maybe<Scalars['String']>;
};

export type StorageQueryFilterInput = {
  commodity_id?: InputMaybe<Scalars['ID']>;
  commodity_variety_id?: InputMaybe<Scalars['ID']>;
  department_codenames?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  grade_id?: InputMaybe<Scalars['ID']>;
  material_kind?: InputMaybe<Scalars['String']>;
  storage_location_id?: InputMaybe<Scalars['ID']>;
};

export type StorageSubLocationInput = {
  capacity?: InputMaybe<Scalars['Float']>;
  capacity_unit_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  kind_id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type StorageSubLocationType = {
  __typename?: 'StorageSubLocationType';
  /** Capacity in kg */
  capacity: Scalars['Float'];
  /** Capacity in kg */
  capacity_kg?: Maybe<Scalars['Float']>;
  capacity_unit: SharedEntityType;
  codename: Scalars['String'];
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  kind: StorageLocationKindType;
  name: Scalars['String'];
  storage_location: StorageLocationType;
  storage_sub_location_trades: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
};

export type StorageSummaryType = {
  __typename?: 'StorageSummaryType';
  expired_stock?: Maybe<Scalars['Int']>;
  expiring_soon?: Maybe<Scalars['Int']>;
  low_stock_items?: Maybe<Scalars['Int']>;
  out_of_stock?: Maybe<Scalars['Int']>;
  total_stock_items?: Maybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_External_Entitycrop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_External_Entitycrop_Variety = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_External_Entityplot_Crop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Requestcreated_By = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Requestupdated_By = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Result_Commentcreated_By = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity_Variety = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitydepartment = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityfacilitator = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitypackaging_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityplot_Crop = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityresult = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entitysi_Unit = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityuser = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Shared_Entityvariety_Grade = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_Remote_Rel_Transition_Historycreated_By = {
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SubLocationInfoType = {
  __typename?: 'SubLocationInfoType';
  capacity?: Maybe<Scalars['String']>;
  capacity_unit?: Maybe<SharedEntityType>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  storage_type?: Maybe<Scalars['String']>;
  used_capacity?: Maybe<Scalars['String']>;
  utilization_percentage?: Maybe<Scalars['Float']>;
};

export type SubmitObservations = {
  __typename?: 'SubmitObservations';
  sample?: Maybe<SampleType>;
};

export type SubmitObservationsInput = {
  created_in_id?: InputMaybe<Scalars['ID']>;
  department?: InputMaybe<DepartmentInput>;
  id?: InputMaybe<Scalars['ID']>;
  observation_remark?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Array<InputMaybe<SampleObservationInput>>>;
  primary_location: ExternalEntityInput;
  recommendations?: InputMaybe<Scalars['String']>;
  recorded_at?: InputMaybe<AddressInput>;
  rejection_percent?: InputMaybe<Scalars['Decimal']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  request_category_codename: Scalars['String'];
  request_id?: InputMaybe<Scalars['ID']>;
  request_is_verified?: InputMaybe<Scalars['Boolean']>;
  template_id: Scalars['ID'];
  unit_codename?: InputMaybe<Scalars['ID']>;
  weight?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<ExternalEntityInput>;
};

export type SupplierPlotAggregateInput = {
  mutual_group_id?: InputMaybe<Scalars['ID']>;
};

export type SwitchDepartmentMutation = {
  __typename?: 'SwitchDepartmentMutation';
  user?: Maybe<BaseUserGlType>;
};

export type TaxGlType = {
  __typename?: 'TaxGlType';
  codename: Scalars['String'];
  distributioncentre_set: Array<DistributionCentreGlType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  order_set: Array<OrderGlType>;
  percentage: Scalars['Float'];
  sellableitem_set: Array<SellableItemGlType>;
  shipping_set: Array<ShippingGlType>;
};

export type TemplateInput = {
  category_id?: InputMaybe<Scalars['ID']>;
  company_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  crop_reference_id?: InputMaybe<Scalars['String']>;
  department_reference_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['ID']>;
  market_id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['Date']>;
  valid_till?: InputMaybe<Scalars['Date']>;
};

export enum TemplateParameterConfigComparator {
  /** Equal */
  Eq = 'EQ',
  /** Greater Than Equal */
  Ge = 'GE',
  /** Greater Than */
  Gt = 'GT',
  /** Less Than Equal */
  Le = 'LE',
  /** Less Than */
  Lt = 'LT',
  /** Not Equal */
  Ne = 'NE'
}

export type TemplateParameterConfigInput = {
  is_alert?: InputMaybe<Scalars['Boolean']>;
  loq?: InputMaybe<Scalars['Float']>;
  mrl?: InputMaybe<Scalars['Float']>;
};

export type TemplateParameterConfigType = {
  __typename?: 'TemplateParameterConfigType';
  comparator: TemplateParameterConfigComparator;
  created_at: Scalars['DateTime'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  evaluation_criteria: EvaluationCriteriaType;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  template_parameter: TemplateParameterType;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['DateTime']>;
  valid_till?: Maybe<Scalars['DateTime']>;
  value: Scalars['Float'];
};

export type TemplateParameterInput = {
  id?: InputMaybe<Scalars['ID']>;
  quality_parameter_id?: InputMaybe<Scalars['ID']>;
  template_parameter_config?: InputMaybe<TemplateParameterConfigInput>;
  uid?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['ID']>;
};

export type TemplateParameterType = {
  __typename?: 'TemplateParameterType';
  configurations: Array<TemplateParameterConfigType>;
  created_at: Scalars['DateTime'];
  disable_config: Scalars['Boolean'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  /** Observation Count Validation */
  is_mandatory?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSONString']>;
  /** No. of observations on each sample */
  observation_count: Scalars['Int'];
  /** Used for Physical parameters qualitative fields variations e.g. Color:green,light green */
  options: Array<Scalars['String']>;
  parent_template_parameter?: Maybe<TemplateParameterType>;
  precision: Scalars['Int'];
  quality_parameter: QualityParameterType;
  resultobservation_set: Array<ResultObservationType>;
  sequence: Scalars['Int'];
  /** Human redable standard which should be followed */
  standard: Scalars['String'];
  template: TemplateType;
  template_parameters: Array<TemplateParameterType>;
  uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  valid_from?: Maybe<Scalars['DateTime']>;
  valid_till?: Maybe<Scalars['DateTime']>;
  /** Weightage of result value in overall score */
  weightage: Scalars['Float'];
};

export type TemplateToggleMutation = {
  __typename?: 'TemplateToggleMutation';
  template?: Maybe<TemplateType>;
};

export type TemplateType = {
  __typename?: 'TemplateType';
  brand?: Maybe<BrandType>;
  codename: Scalars['String'];
  company: Array<ExternalEntityType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  departments: Array<ExternalEntityType>;
  description: Scalars['String'];
  document_number?: Maybe<Scalars['String']>;
  grade?: Maybe<GradeType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  /** Other templates for same market and test for will be deactivated if this one is active. */
  market?: Maybe<MarketType>;
  metadata?: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  organisation?: Maybe<ExternalEntityType>;
  parameters: Array<TemplateParameterType>;
  parent_template?: Maybe<TemplateType>;
  quality_stage?: Maybe<QualityStageType>;
  quality_stages: Array<QualityStageType>;
  request_set: Array<TestRequestType>;
  results: Array<ResultType>;
  /** No. of physical samples to be assessed */
  sample_count: Scalars['Int'];
  templates: Array<TemplateType>;
  test_for: ExternalEntityType;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['DateTime']>;
  valid_till?: Maybe<Scalars['DateTime']>;
};

export type TemplateUpsertMutation = {
  __typename?: 'TemplateUpsertMutation';
  template?: Maybe<TemplateType>;
};

export type TestRequestInput = {
  department?: InputMaybe<DepartmentInput>;
  id?: InputMaybe<Scalars['ID']>;
  laboratory_id: Scalars['ID'];
  parameter_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  template_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type TestRequestType = {
  __typename?: 'TestRequestType';
  color_code?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  department?: Maybe<ExternalEntityType>;
  id: Scalars['ID'];
  is_archived: Scalars['Boolean'];
  is_partial: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  parameters: Array<QualityParameterType>;
  parent_request?: Maybe<TestRequestType>;
  primary_location: ExternalEntityType;
  /** current gps location from where request is raised */
  recorded_at?: Maybe<AddressQcType>;
  rejection_percent?: Maybe<Scalars['Decimal']>;
  rejection_reason?: Maybe<Scalars['String']>;
  results: Array<ResultType>;
  sample?: Maybe<SampleType>;
  sampleobservation_set: Array<SampleObservationType>;
  secondary_locations: Array<ExternalEntityType>;
  templates: Array<TemplateType>;
  test_for: ExternalEntityType;
  test_requests: Array<TestRequestType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['DateTime']>;
  withdraw_sample_on?: Maybe<Scalars['DateTime']>;
};

export type TimeElapsedObjectType = {
  __typename?: 'TimeElapsedObjectType';
  days?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  years?: Maybe<Scalars['Int']>;
};

export type TimeSlotGlType = {
  __typename?: 'TimeSlotGlType';
  dc_alternate_sales_slots: Array<DistributionCentreGlType>;
  dc_delivery_slots: Array<DistributionCentreGlType>;
  dc_maintenance_slots: Array<DistributionCentreGlType>;
  dc_pickup_slots: Array<DistributionCentreGlType>;
  estimated_delivery: Scalars['String'];
  from_time: Scalars['Time'];
  id: Scalars['ID'];
  maximum_orders: Scalars['Int'];
  name: Scalars['String'];
  order_set: Array<OrderGlType>;
  shipping_set: Array<ShippingGlType>;
  threshold_from?: Maybe<Scalars['Time']>;
  threshold_to?: Maybe<Scalars['Time']>;
  timeslotrequirement_set: Array<TimeSlotRequirementGlType>;
  to_time: Scalars['Time'];
};

export type TimeSlotRequirementGlType = {
  __typename?: 'TimeSlotRequirementGlType';
  booked_quantity: Scalars['Float'];
  demand: DemandGlType;
  id: Scalars['ID'];
  quantity: Scalars['Float'];
};

export type TimelineItemSchema = {
  __typename?: 'TimelineItemSchema';
  date?: Maybe<Scalars['String']>;
  is_current?: Maybe<Scalars['Boolean']>;
  msg?: Maybe<Scalars['String']>;
  parent_trade_id?: Maybe<Scalars['String']>;
  parent_trade_title?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type TradeAssessmentCwInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
  tenure?: InputMaybe<Scalars['Int']>;
};

export type TradeAssessmentDynamicInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
  tenure?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type TradeAssessmentDynamicType = {
  __typename?: 'TradeAssessmentDynamicType';
  assessed_limit?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

export type TradeAssessmentInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
  tenure?: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum TradeExpenseKindChoices {
  /** Amount Percent */
  AmountPercent = 'AMOUNT_PERCENT',
  /** Cost Per Unit */
  CostPerUnit = 'COST_PER_UNIT',
  /** Deducted Cost Per Unit */
  DeductedCostPerUnit = 'DEDUCTED_COST_PER_UNIT',
  /** Flat */
  Flat = 'FLAT'
}

/** An enumeration. */
export enum TradeExpensePaidByChoices {
  /** Buyer */
  Buyer = 'BUYER',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Seller */
  Seller = 'SELLER'
}

export type TradeExpenseTaxInput = {
  percentage: Scalars['Decimal'];
  role: Scalars['String'];
  tax_name: Scalars['String'];
};

export type TradeGradeSummaryReportSchema = {
  __typename?: 'TradeGradeSummaryReportSchema';
  grade_summary?: Maybe<Array<Maybe<TradeGradeSummarySchema>>>;
  more_trade?: Maybe<Scalars['Boolean']>;
};

export type TradeGradeSummarySchema = {
  __typename?: 'TradeGradeSummarySchema';
  booked_quantity?: Maybe<Scalars['Float']>;
  remaining_quantity?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Int']>;
  variety_grade_name?: Maybe<Scalars['String']>;
};

export type TradeInput = {
  advance_payments?: InputMaybe<Array<InputMaybe<AdvancePaymentInput>>>;
  advance_po?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  buyer_expense_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  buyer_gst_attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  buyer_id?: InputMaybe<Scalars['ID']>;
  buyer_plot_crop_id?: InputMaybe<Scalars['ID']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  credit_notes?: InputMaybe<Array<InputMaybe<CreditNoteInput>>>;
  current_status_id?: InputMaybe<Scalars['String']>;
  demand_id?: InputMaybe<Scalars['ID']>;
  department_id?: InputMaybe<Scalars['ID']>;
  end_date?: InputMaybe<Scalars['String']>;
  expense_taxes?: InputMaybe<Array<InputMaybe<TradeExpenseTaxInput>>>;
  expenses?: InputMaybe<Array<InputMaybe<ExpenseInput>>>;
  expiry?: InputMaybe<Scalars['String']>;
  facilitator_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  is_intercompany_transaction?: InputMaybe<Scalars['Boolean']>;
  is_multiple_commodity?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<TradeItemInput>>>;
  junior_officer_id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  material_kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  offer_id?: InputMaybe<Scalars['ID']>;
  officer_id?: InputMaybe<Scalars['ID']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_trade_id?: InputMaybe<Scalars['ID']>;
  production_trade_id?: InputMaybe<Scalars['ID']>;
  receipt_id?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
  seller_gst_attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  seller_id?: InputMaybe<Scalars['ID']>;
  seller_tds_percentage?: InputMaybe<Scalars['Decimal']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['Decimal']>;
  start_date?: InputMaybe<Scalars['String']>;
  storage_location_id?: InputMaybe<Scalars['ID']>;
  storage_sub_location_id?: InputMaybe<Scalars['ID']>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  trip_id?: InputMaybe<Scalars['ID']>;
  use_overdraft?: InputMaybe<Scalars['Boolean']>;
  use_overdue_approval?: InputMaybe<Scalars['Boolean']>;
  vehicle_id?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum TradeInvoiceBuyerSettlementStatusChoices {
  /** Partial */
  Partial = 'PARTIAL',
  /** Pending */
  Pending = 'PENDING',
  /** Settled */
  Settled = 'SETTLED'
}

/** An enumeration. */
export enum TradeInvoiceMaterialKindChoices {
  /** Commodity */
  Commodity = 'COMMODITY',
  /** Packaging */
  Packaging = 'PACKAGING'
}

/** An enumeration. */
export enum TradeIssuanceNoteKindChoices {
  /** Amount Percent */
  AmountPercent = 'AMOUNT_PERCENT',
  /** Flat */
  Flat = 'FLAT',
  /** Quantity */
  Quantity = 'QUANTITY',
  /** Rate */
  Rate = 'RATE'
}

/** An enumeration. */
export enum TradeIssuanceNoteTypeChoices {
  /** Credit */
  Credit = 'CREDIT',
  /** Debit */
  Debit = 'DEBIT'
}

/** An enumeration. */
export enum TradeIssuanceNoteUserRoleChoices {
  /** Buyer */
  Buyer = 'BUYER',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Seller */
  Seller = 'SELLER'
}

export type TradeItemInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  batch_number?: InputMaybe<Scalars['String']>;
  buyer_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  commodity_id?: InputMaybe<Scalars['ID']>;
  commodity_variety_id?: InputMaybe<Scalars['ID']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  parent_trade_item_id?: InputMaybe<Scalars['ID']>;
  plot_crop_id?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Decimal']>;
  rate?: InputMaybe<Scalars['Decimal']>;
  supplier_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  taxes?: InputMaybe<Array<InputMaybe<TradeTaxInput>>>;
  unit_id?: InputMaybe<Scalars['ID']>;
  variety_grade_id?: InputMaybe<Scalars['ID']>;
};

export type TradeItemType = {
  __typename?: 'TradeItemType';
  amount?: Maybe<Scalars['Decimal']>;
  batch_number?: Maybe<Scalars['String']>;
  buyer_gst_auto_calculated: Scalars['Boolean'];
  child_trade_items: Array<TradeItemType>;
  commodity?: Maybe<SharedEntityType>;
  commodity_variety?: Maybe<SharedEntityType>;
  created_at: Scalars['DateTime'];
  currency: SharedEntityType;
  /** standard rate for day */
  daily_rate?: Maybe<Scalars['Decimal']>;
  gate_pass?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  packaging_unit?: Maybe<SharedEntityType>;
  parent_trade_item?: Maybe<TradeItemType>;
  plot_crop?: Maybe<SharedEntityType>;
  /** rejection percentage received from qc */
  qc_rejection?: Maybe<Scalars['Decimal']>;
  quantity: Scalars['Decimal'];
  quantity_unit: SharedEntityType;
  /** rate after qc rejection */
  rate: Scalars['Decimal'];
  rate_unit: SharedEntityType;
  result?: Maybe<SharedEntityType>;
  /** Returned quantity */
  returned_quantity?: Maybe<Scalars['Decimal']>;
  supplier_gst_auto_calculated: Scalars['Boolean'];
  trade: TradeType;
  updated_at: Scalars['DateTime'];
  variety_grade?: Maybe<SharedEntityType>;
};

/** An enumeration. */
export enum TradeProductionTradeItemKindChoices {
  /** Input */
  Input = 'INPUT',
  /** Output */
  Output = 'OUTPUT',
  /** Packaging */
  Packaging = 'PACKAGING'
}

/** An enumeration. */
export enum TradeProductionTradeKindChoices {
  /** Final */
  Final = 'FINAL',
  /** Planning */
  Planning = 'PLANNING'
}

/** An enumeration. */
export enum TradeProductionTradeModeChoices {
  /** Direct */
  Direct = 'DIRECT',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Non KYC */
  NonKyc = 'NON_KYC'
}

/** An enumeration. */
export enum TradeProductionTradeStatusChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Draft */
  Draft = 'DRAFT',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Sent for Approval */
  SentForApproval = 'SENT_FOR_APPROVAL'
}

/** An enumeration. */
export enum TradeProfileCategory {
  /** Default */
  Default = 'DEFAULT',
  /** Domestic */
  Domestic = 'DOMESTIC',
  /** Export */
  Export = 'EXPORT',
  /** Organic */
  Organic = 'ORGANIC'
}

export type TradeProfileGlTYpe = {
  __typename?: 'TradeProfileGlTYpe';
  area: Scalars['Float'];
  available_yield: Scalars['Float'];
  category: TradeProfileCategory;
  certificate_number?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  description: Scalars['String'];
  extra_available_yield?: Maybe<Scalars['Float']>;
  extra_plot_yeild?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  plot_commodity: PlotCommodityGlType;
  plot_yeild: Scalars['Float'];
  reason?: Maybe<Scalars['String']>;
  trade_year?: Maybe<TradeYearType>;
  updated_at: Scalars['DateTime'];
};

/** An enumeration. */
export enum TradeReceiptKindChoices {
  /** Booking */
  Booking = 'BOOKING',
  /** Final */
  Final = 'FINAL',
  /** Inward */
  Inward = 'INWARD',
  /** order */
  Order = 'ORDER',
  /** Pro Forma */
  ProForma = 'PRO_FORMA',
  /** storage */
  Storage = 'STORAGE'
}

/** An enumeration. */
export enum TradeReceiptMaterialKindChoices {
  /** Commodity */
  Commodity = 'COMMODITY',
  /** Packaging */
  Packaging = 'PACKAGING'
}

/** An enumeration. */
export enum TradeReceiptModeChoices {
  /** Direct */
  Direct = 'DIRECT',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Non KYC */
  NonKyc = 'NON_KYC'
}

/** An enumeration. */
export enum TradeReceiptPackagingChoices {
  /** Finished Goods */
  FinishedGoods = 'FINISHED_GOODS',
  /** Raw Material */
  RawMaterial = 'RAW_MATERIAL'
}

/** An enumeration. */
export enum TradeReceiptSellerSettlementStatusChoices {
  /** Partial */
  Partial = 'PARTIAL',
  /** Pending */
  Pending = 'PENDING',
  /** Settled */
  Settled = 'SETTLED'
}

export type TradeStatusType = {
  __typename?: 'TradeStatusType';
  category: TradeTradeStatusCategoryChoices;
  children: Array<TradeStatusType>;
  departments: Array<SharedEntityType>;
  id: Scalars['String'];
  invoices: Array<InvoiceType>;
  is_data_editable: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONString']>;
  parents: Array<TradeStatusType>;
  sequence_no: Scalars['String'];
  trades: Array<TradeType>;
};

export type TradeSummaryType = {
  __typename?: 'TradeSummaryType';
  overdue_amount?: Maybe<Scalars['Float']>;
  overdue_days?: Maybe<Scalars['Int']>;
};

export type TradeTaxInput = {
  percentage: Scalars['Decimal'];
  role: Scalars['String'];
  tax_name: Scalars['String'];
};

/** An enumeration. */
export enum TradeTradeBuyerSettlementStatusChoices {
  /** Partial */
  Partial = 'PARTIAL',
  /** Pending */
  Pending = 'PENDING',
  /** Settled */
  Settled = 'SETTLED'
}

/** An enumeration. */
export enum TradeTradeKindChoices {
  /** Booking */
  Booking = 'BOOKING',
  /** Final */
  Final = 'FINAL',
  /** Inward */
  Inward = 'INWARD',
  /** order */
  Order = 'ORDER',
  /** Pro Forma */
  ProForma = 'PRO_FORMA',
  /** storage */
  Storage = 'STORAGE'
}

/** An enumeration. */
export enum TradeTradeMaterialKindChoices {
  /** Commodity */
  Commodity = 'COMMODITY',
  /** Packaging */
  Packaging = 'PACKAGING'
}

/** An enumeration. */
export enum TradeTradeModeChoices {
  /** Direct */
  Direct = 'DIRECT',
  /** Facilitator */
  Facilitator = 'FACILITATOR',
  /** Non KYC */
  NonKyc = 'NON_KYC'
}

/** An enumeration. */
export enum TradeTradePackagingChoices {
  /** Finished Goods */
  FinishedGoods = 'FINISHED_GOODS',
  /** Raw Material */
  RawMaterial = 'RAW_MATERIAL'
}

/** An enumeration. */
export enum TradeTradeSellerSettlementStatusChoices {
  /** Partial */
  Partial = 'PARTIAL',
  /** Pending */
  Pending = 'PENDING',
  /** Settled */
  Settled = 'SETTLED'
}

/** An enumeration. */
export enum TradeTradeStatusCategoryChoices {
  /** Dynamic */
  Dynamic = 'DYNAMIC',
  /** Fixed */
  Fixed = 'FIXED'
}

export type TradeTripMutationInput = {
  aggregator_name?: InputMaybe<Scalars['String']>;
  aggregator_number?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['ID']>;
  destination_location_name?: InputMaybe<Scalars['String']>;
  driver_name?: InputMaybe<Scalars['String']>;
  driver_number?: InputMaybe<Scalars['String']>;
  estimated_date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
  source_location_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trades: Array<InputMaybe<Scalars['ID']>>;
  vehicle_id?: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum TradeTripStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Draft */
  Draft = 'DRAFT',
  /** Started */
  Started = 'STARTED'
}

export type TradeType = {
  __typename?: 'TradeType';
  /** Generate PO on this trade in FMS, and use same PO for child trades */
  advance_po: Scalars['Boolean'];
  buyer?: Maybe<SharedEntityType>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_expense_gst_auto_calculated: Scalars['Boolean'];
  buyer_gst_auto_calculated: Scalars['Boolean'];
  /** Final amount buyer has to pay */
  buyer_payable_amount?: Maybe<Scalars['Decimal']>;
  /** Final amount buyer has to pay */
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Decimal']>;
  buyer_plot_crop?: Maybe<SharedEntityType>;
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_settlement_status?: Maybe<TradeTradeBuyerSettlementStatusChoices>;
  buyer_tnc?: Maybe<Scalars['String']>;
  buyer_verification?: Maybe<Scalars['Boolean']>;
  commodities: Array<SharedEntityType>;
  commodity?: Maybe<SharedEntityType>;
  commodity_varieties: Array<SharedEntityType>;
  commodity_variety?: Maybe<SharedEntityType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  current_status?: Maybe<TradeStatusType>;
  /** Total amount reducing std. deduction */
  deducted_amount?: Maybe<Scalars['Decimal']>;
  /** Total quantity reducing std. deduction */
  deducted_quantity?: Maybe<Scalars['Decimal']>;
  /** Total quantity reducing std. deduction in kg */
  deducted_quantity_kg?: Maybe<Scalars['Decimal']>;
  /** Available quantity for child trades after deducting std. deduction */
  deducted_quantity_remaining?: Maybe<Scalars['Decimal']>;
  /** Available quantity for child trades after deducting std. deduction */
  deducted_quantity_remaining_kg?: Maybe<Scalars['Decimal']>;
  demand?: Maybe<DemandType>;
  department: SharedEntityType;
  /** Expense that not calculated as profit */
  direct_cost?: Maybe<Scalars['Float']>;
  end_date?: Maybe<Scalars['Date']>;
  /** Only expense amount */
  expense_amount?: Maybe<Scalars['Decimal']>;
  expenses: Array<ExpenseType>;
  expiry?: Maybe<Scalars['Date']>;
  facilitator?: Maybe<SharedEntityType>;
  id: Scalars['ID'];
  invoice?: Maybe<InvoiceType>;
  is_deviation_draft?: Maybe<Scalars['Boolean']>;
  is_intercompany_transaction: Scalars['Boolean'];
  is_multiple_commodity: Scalars['Boolean'];
  issuance_notes: Array<IssuanceNoteType>;
  items: Array<TradeItemType>;
  junior_officer?: Maybe<SharedEntityType>;
  kind: TradeTradeKindChoices;
  material_kind?: Maybe<TradeTradeMaterialKindChoices>;
  metadata?: Maybe<Scalars['JSONString']>;
  mis_date_1?: Maybe<Scalars['Date']>;
  mode: TradeTradeModeChoices;
  offer?: Maybe<OfferType>;
  officer?: Maybe<SharedEntityType>;
  over_draft?: Maybe<OverDraftType>;
  over_due_approval?: Maybe<OverDueApprovalType>;
  over_due_approval_cw?: Maybe<OverDueApprovalCwType>;
  packaging: TradeTradePackagingChoices;
  parent_trade?: Maybe<TradeType>;
  plot_crop?: Maybe<SharedEntityType>;
  production_trade?: Maybe<ProductionTradeType>;
  production_trades: Array<ProductionTradeType>;
  /** Calculated on Hishob Patti (Final) only. */
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt?: Maybe<ReceiptType>;
  remark?: Maybe<Scalars['String']>;
  /** Quantity returned to parent trade */
  returned_quantity?: Maybe<Scalars['Decimal']>;
  /** Quantity returned to parent trade in kg */
  returned_quantity_kg?: Maybe<Scalars['Decimal']>;
  reverse_status_mode: Scalars['Boolean'];
  sales_value?: Maybe<Scalars['Float']>;
  seller?: Maybe<SharedEntityType>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  /** Final amount seller can receive */
  seller_receivable_amount?: Maybe<Scalars['Decimal']>;
  /** Final amount seller can receive */
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Decimal']>;
  seller_remark?: Maybe<Scalars['String']>;
  seller_settlement_status?: Maybe<TradeTradeSellerSettlementStatusChoices>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  seller_tnc?: Maybe<Scalars['String']>;
  seller_verification?: Maybe<Scalars['Boolean']>;
  standard_deduction?: Maybe<Scalars['Decimal']>;
  start_date?: Maybe<Scalars['Date']>;
  status_processing: Scalars['Boolean'];
  storage_location?: Maybe<StorageLocationType>;
  storage_sub_location?: Maybe<StorageSubLocationType>;
  /** Calculated using platform_rate and quantity */
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_expense_gst_auto_calculated: Scalars['Boolean'];
  supplier_gst_auto_calculated: Scalars['Boolean'];
  /** Supplier rate at the time of trade creation */
  supplier_rate?: Maybe<Scalars['Float']>;
  /** Sum of total amount in trades */
  total_amount?: Maybe<Scalars['Decimal']>;
  /** Sum of total amount in trades */
  total_quantity?: Maybe<Scalars['Decimal']>;
  tracking_code: Scalars['String'];
  trade_amounts_counter: Scalars['Int'];
  trade_transactions: Array<TransactionType>;
  trades: Array<TradeType>;
  trip?: Maybe<TripType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle?: Maybe<SharedEntityType>;
};

export type TradeYearType = {
  __typename?: 'TradeYearType';
  codename: Scalars['String'];
  description: Scalars['String'];
  from_year: Scalars['Int'];
  harvestprojection_set: Array<HarvestProjectionType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  to_year: Scalars['Int'];
  tradeprofile_set: Array<TradeProfileGlTYpe>;
};

export type TransactionType = {
  __typename?: 'TransactionType';
  account_no?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  bank?: Maybe<SharedEntityType>;
  child_transactions: Array<TransactionType>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  date: Scalars['Date'];
  department?: Maybe<SharedEntityType>;
  diff_child_amount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  invoice?: Maybe<InvoiceType>;
  parent_transaction?: Maybe<TransactionType>;
  receipt?: Maybe<ReceiptType>;
  ref?: Maybe<PaynoteTransactionRefChoices>;
  remaining_amount?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  trade?: Maybe<TradeType>;
  transaction_id: Scalars['String'];
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  user?: Maybe<SharedEntityType>;
};

/** columns and relationships of "Transaction_mode" */
export type Transaction_Mode = {
  __typename?: 'Transaction_mode';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "Transaction_mode" */
export type Transaction_Mode_Aggregate = {
  __typename?: 'Transaction_mode_aggregate';
  aggregate?: Maybe<Transaction_Mode_Aggregate_Fields>;
  nodes: Array<Transaction_Mode>;
};

/** aggregate fields of "Transaction_mode" */
export type Transaction_Mode_Aggregate_Fields = {
  __typename?: 'Transaction_mode_aggregate_fields';
  avg?: Maybe<Transaction_Mode_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transaction_Mode_Max_Fields>;
  min?: Maybe<Transaction_Mode_Min_Fields>;
  stddev?: Maybe<Transaction_Mode_Stddev_Fields>;
  stddev_pop?: Maybe<Transaction_Mode_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transaction_Mode_Stddev_Samp_Fields>;
  sum?: Maybe<Transaction_Mode_Sum_Fields>;
  var_pop?: Maybe<Transaction_Mode_Var_Pop_Fields>;
  var_samp?: Maybe<Transaction_Mode_Var_Samp_Fields>;
  variance?: Maybe<Transaction_Mode_Variance_Fields>;
};


/** aggregate fields of "Transaction_mode" */
export type Transaction_Mode_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Mode_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Transaction_Mode_Avg_Fields = {
  __typename?: 'Transaction_mode_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Transaction_mode". All fields are combined with a logical 'AND'. */
export type Transaction_Mode_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Mode_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Mode_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Mode_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Transaction_Mode_Max_Fields = {
  __typename?: 'Transaction_mode_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Transaction_Mode_Min_Fields = {
  __typename?: 'Transaction_mode_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "Transaction_mode". */
export type Transaction_Mode_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "Transaction_mode" */
export enum Transaction_Mode_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** aggregate stddev on columns */
export type Transaction_Mode_Stddev_Fields = {
  __typename?: 'Transaction_mode_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Transaction_Mode_Stddev_Pop_Fields = {
  __typename?: 'Transaction_mode_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Transaction_Mode_Stddev_Samp_Fields = {
  __typename?: 'Transaction_mode_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "Transaction_mode" */
export type Transaction_Mode_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transaction_Mode_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transaction_Mode_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Transaction_Mode_Sum_Fields = {
  __typename?: 'Transaction_mode_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Transaction_Mode_Var_Pop_Fields = {
  __typename?: 'Transaction_mode_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Transaction_Mode_Var_Samp_Fields = {
  __typename?: 'Transaction_mode_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Transaction_Mode_Variance_Fields = {
  __typename?: 'Transaction_mode_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type TransactionsCustomFilterInput = {
  department_codename?: InputMaybe<Scalars['ID']>;
  department_settlement_kind?: InputMaybe<DepartmentSettlementKind>;
  user_ref?: InputMaybe<Scalars['ID']>;
};

export type TripGlFilterInput = {
  booking_approval_status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  date__gte?: InputMaybe<Scalars['Date']>;
  date__lte?: InputMaybe<Scalars['Date']>;
  destination_dc_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  source_dc_id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status__nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TripGlType = {
  __typename?: 'TripGlType';
  aggregator: BaseUserGlType;
  booking_count?: Maybe<Scalars['Int']>;
  booking_status?: Maybe<Array<Maybe<Scalars['String']>>>;
  bookings?: Maybe<Array<Maybe<BookingGlType>>>;
  date: Scalars['Date'];
  department_assigned: FmsDepartmentType;
  destination_depot?: Maybe<DepotGlType>;
  dock?: Maybe<DockGlType>;
  dock_detail?: Maybe<DockDetailGlType>;
  dock_details?: Maybe<Array<Maybe<DockDetailGlType>>>;
  id: Scalars['ID'];
  labour_approval_status?: Maybe<Scalars['String']>;
  labour_count?: Maybe<Scalars['Int']>;
  source_depot?: Maybe<DepotGlType>;
  status: TripStatus;
  vehicle: VehicleGlType;
  vehicle_approval_status?: Maybe<Scalars['String']>;
};


export type TripGlTypeDock_DetailArgs = {
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
};


export type TripGlTypeDock_DetailsArgs = {
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum TripStatus {
  /** Completed */
  Cp = 'CP',
  /** Discarded */
  Ds = 'DS',
  /** Idle */
  Il = 'IL',
  /** Not Started */
  Ns = 'NS',
  /** On Trip */
  Ot = 'OT',
  /** Paused */
  Ps = 'PS',
  /** Settled */
  St = 'ST'
}

export type TripTraderSummaryType = {
  __typename?: 'TripTraderSummaryType';
  buyer_payable?: Maybe<Scalars['Float']>;
  commodities?: Maybe<Array<Maybe<SharedEntityType>>>;
  commodity_varieties?: Maybe<Array<Maybe<SharedEntityType>>>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Int']>;
  trader?: Maybe<SharedEntityType>;
};

export type TripType = {
  __typename?: 'TripType';
  aggregator_name?: Maybe<Scalars['String']>;
  aggregator_number?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  created_by_id: Scalars['String'];
  department: SharedEntityType;
  destination_location_name?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_number?: Maybe<Scalars['String']>;
  estimated_date?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSONString']>;
  remark?: Maybe<Scalars['String']>;
  source_location_name?: Maybe<Scalars['String']>;
  status: TradeTripStatusChoices;
  trades: Array<TradeType>;
  updated_at: Scalars['DateTime'];
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle: SharedEntityType;
};

export type UnitAndValueType = {
  __typename?: 'UnitAndValueType';
  unit_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type UpdateBookingStatus = {
  __typename?: 'UpdateBookingStatus';
  booking?: Maybe<BookingGlType>;
};

export type UpdatePasswordMutation = {
  __typename?: 'UpdatePasswordMutation';
  user?: Maybe<BaseUserType>;
};

export type UpdatePrimaryLocation = {
  __typename?: 'UpdatePrimaryLocation';
  result?: Maybe<ResultType>;
};

export type UpdateProductionTradeStatusMutation = {
  __typename?: 'UpdateProductionTradeStatusMutation';
  production_trade: ProductionTradeType;
};

export type UpdateQualityStagesSequence = {
  __typename?: 'UpdateQualityStagesSequence';
  quality_stage?: Maybe<QualityStageType>;
};

export type UpdateTradeAmountMutation = {
  __typename?: 'UpdateTradeAmountMutation';
  trade?: Maybe<TradeType>;
};

export type UpdateTripDetailsMutation = {
  __typename?: 'UpdateTripDetailsMutation';
  trip?: Maybe<TripGlType>;
};

export type UpsertDemandInput = {
  attachments?: InputMaybe<Array<InputMaybe<DemandAttachmentInput>>>;
  buyer_id?: InputMaybe<Scalars['ID']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id: Scalars['ID'];
  commodity_variety_id?: InputMaybe<Scalars['ID']>;
  department_id?: InputMaybe<Scalars['ID']>;
  end_date_time: Scalars['DateTime'];
  enquiries?: InputMaybe<Array<InputMaybe<DemandEnquiryInput>>>;
  expenses?: InputMaybe<Array<InputMaybe<DemandExpenseInput>>>;
  facilitator_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  jr_officer_id?: InputMaybe<Scalars['ID']>;
  material_kind: Scalars['String'];
  max_rate?: InputMaybe<Scalars['Float']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  quantity_unit_id: Scalars['ID'];
  rate: Scalars['Float'];
  rate_unit_id: Scalars['ID'];
  seller_file_id?: InputMaybe<Scalars['ID']>;
  seller_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  seller_source_kind: Scalars['String'];
  seller_tnc?: InputMaybe<Scalars['String']>;
  sr_officer_id?: InputMaybe<Scalars['ID']>;
  standard_deduction?: InputMaybe<Scalars['Float']>;
  start_date_time: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
  variety_grade_id?: InputMaybe<Scalars['ID']>;
};

export type UpsertOfferInput = {
  attachments?: InputMaybe<Array<InputMaybe<OfferAttachmentInput>>>;
  buyer_file_id?: InputMaybe<Scalars['ID']>;
  buyer_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  buyer_source_kind: Scalars['String'];
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id: Scalars['ID'];
  commodity_variety_id?: InputMaybe<Scalars['ID']>;
  department_id?: InputMaybe<Scalars['ID']>;
  end_date_time: Scalars['DateTime'];
  enquiries?: InputMaybe<Array<InputMaybe<OfferEnquiryInput>>>;
  expenses?: InputMaybe<Array<InputMaybe<OfferExpenseInput>>>;
  facilitator_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  jr_officer_id?: InputMaybe<Scalars['ID']>;
  material_kind: Scalars['String'];
  max_rate?: InputMaybe<Scalars['Float']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Float'];
  quantity_unit_id: Scalars['ID'];
  rate: Scalars['Float'];
  rate_unit_id: Scalars['ID'];
  seller_id?: InputMaybe<Scalars['ID']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  sr_officer_id?: InputMaybe<Scalars['ID']>;
  standard_deduction?: InputMaybe<Scalars['Float']>;
  start_date_time: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
  variety_grade_id?: InputMaybe<Scalars['ID']>;
};

export type UpsertStorageLocationInput = {
  address?: InputMaybe<SetuTradeAddressInput>;
  agreement?: InputMaybe<StorageLocationAgreementInput>;
  capacity: Scalars['Float'];
  capacity_unit_id: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  pocs_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sub_locations?: InputMaybe<Array<InputMaybe<StorageSubLocationInput>>>;
};

export type UseOfferStockMutation = {
  __typename?: 'UseOfferStockMutation';
  offer?: Maybe<OfferType>;
};

export type UserAssetAggregateType = {
  __typename?: 'UserAssetAggregateType';
  farm_count?: Maybe<Scalars['Int']>;
  field_count?: Maybe<Scalars['Int']>;
  plot_count?: Maybe<Scalars['Int']>;
  plot_crop_count?: Maybe<Scalars['Int']>;
};

export type UserContactType = {
  __typename?: 'UserContactType';
  email?: Maybe<Scalars['String']>;
  primary_number?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
};

export type UserContactTypeV2 = {
  __typename?: 'UserContactTypeV2';
  country_code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type UserContextType = {
  __typename?: 'UserContextType';
  agents?: Maybe<Array<Maybe<AgentType>>>;
  companies?: Maybe<Array<Maybe<CompanyType>>>;
  departments?: Maybe<Array<Maybe<DepartmentType>>>;
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  mutual_groups?: Maybe<Array<Maybe<MutualGroupType>>>;
  networks?: Maybe<Array<Maybe<NetworkType>>>;
  organisations?: Maybe<Array<Maybe<OrganisationType>>>;
  reference_id?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<GroupType>>>;
};

export type UserCustomType = {
  __typename?: 'UserCustomType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type UserGroupType = {
  __typename?: 'UserGroupType';
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** The groups this user belongs to. A user will get all permissions granted to each of their groups. */
  user_set: Array<BaseUserType>;
};

export type VarietyGradeType = {
  __typename?: 'VarietyGradeType';
  codename?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  photos: Array<MediaType>;
  /** short_name usage: sync trade_item from setutrade to schedule from starling */
  short_name?: Maybe<Scalars['String']>;
  specifications: Scalars['String'];
  updated_at: Scalars['DateTime'];
  variety: CommodityVarietyType;
};

export type VehicleGlInput = {
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  depot?: InputMaybe<Scalars['Int']>;
  registration_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  vehicle_kind?: InputMaybe<Scalars['String']>;
};

export type VehicleGlType = {
  __typename?: 'VehicleGlType';
  driver?: Maybe<BaseUserGlType>;
  id: Scalars['ID'];
  owner?: Maybe<BaseUserGlType>;
  registration_number: Scalars['String'];
  vehicle_kind?: Maybe<VehicleKindGlType>;
  vehicle_type: VehicleTypeGlType;
};

export type VehicleKindGlType = {
  __typename?: 'VehicleKindGlType';
  /** Code required to identify the entity uniquely. */
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type VehicleTypeGlType = {
  __typename?: 'VehicleTypeGlType';
  capacity: Scalars['Int'];
  category: Scalars['String'];
  id: Scalars['ID'];
  max_capacity: Scalars['Int'];
  name: Scalars['String'];
  passenger_capacity: Scalars['Int'];
};

export type VerifiedByCustomType = {
  __typename?: 'VerifiedByCustomType';
  name?: Maybe<Scalars['String']>;
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type VerifyOtp = {
  __typename?: 'VerifyOTP';
  me?: Maybe<BaseUserType>;
  payload?: Maybe<Scalars['GenericScalar']>;
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerifyOtpForExistingUser = {
  __typename?: 'VerifyOTPForExistingUser';
  me?: Maybe<BaseUserType>;
  redirect_to?: Maybe<Scalars['String']>;
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** This mutation will verify the OTP for new users */
export type VerifyOtpForNewUsers = {
  __typename?: 'VerifyOtpForNewUsers';
  me?: Maybe<BaseUserType>;
  redirect_to?: Maybe<Scalars['String']>;
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VerifyStorageLocationAgreementMutation = {
  __typename?: 'VerifyStorageLocationAgreementMutation';
  agreement?: Maybe<StorageLocationAgreementType>;
};

export type VerifyTradeOtp = {
  __typename?: 'VerifyTradeOTP';
  payload?: Maybe<Scalars['GenericScalar']>;
  refresh_expires_in?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VillageDataType = {
  __typename?: 'VillageDataType';
  /** Village of the user, if available */
  baseuser_set: Array<BaseUserType>;
  code?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  country?: Maybe<RegionType>;
  country_addresses: Array<KiteAddressType>;
  description?: Maybe<Scalars['String']>;
  district?: Maybe<RegionType>;
  district_addresses: Array<KiteAddressType>;
  field_set: Array<FieldType>;
  geom?: Maybe<GeometryObjectType>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  /** The region in which this mutual group is situated at */
  mutualgroup_set: Array<MutualGroupType>;
  name: Scalars['String'];
  parent_region?: Maybe<VillageDataType>;
  regions: Array<VillageDataType>;
  state?: Maybe<RegionType>;
  state_addresses: Array<KiteAddressType>;
  sub_region_addresses: Array<KiteAddressType>;
  taluka?: Maybe<RegionType>;
  taluka_addresses: Array<KiteAddressType>;
  village_addresses: Array<KiteAddressType>;
};

export type VillageWiseChemicalCountInput = {
  first?: InputMaybe<Scalars['Int']>;
  result_observation_filters?: InputMaybe<ResultObservationFilters>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type VillageWiseChemicalCountOutput = {
  __typename?: 'VillageWiseChemicalCountOutput';
  data?: Maybe<Scalars['GenericScalar']>;
  data_count?: Maybe<Scalars['Int']>;
};

export type VillageWiseDetectionCountInput = {
  first?: InputMaybe<Scalars['Int']>;
  result_evaluation_filters?: InputMaybe<ResultEvaluationFilters>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type VillageWiseDetectionCountOutput = {
  __typename?: 'VillageWiseDetectionCountOutput';
  data?: Maybe<Scalars['GenericScalar']>;
  data_count?: Maybe<Scalars['Int']>;
};

export type WeighGlType = {
  __typename?: 'WeighGlType';
  created_at: Scalars['DateTime'];
  date: Scalars['Date'];
  farm_weight: Scalars['Float'];
  /** Net - ((Std Deduct / 100) * Net) */
  final_weight: Scalars['Float'];
  grade?: Maybe<HarvestGradeGlType>;
  gross_weight: Scalars['Float'];
  id: Scalars['ID'];
  invoicing_done_on: WeighInvoicingDoneOn;
  inward?: Maybe<InwardGlType>;
  inwarded_quantity: Scalars['Int'];
  /** Gross - Tare */
  net_weight: Scalars['Float'];
  sku_type?: Maybe<SkuTypeGlType>;
  standard_deduction: Scalars['Float'];
  status: WeighStatus;
  tare_weight: Scalars['Float'];
  trip_set: Array<TripGlType>;
  uom_count: Scalars['Float'];
  uom_type?: Maybe<SiUnitGlType>;
  updated_at: Scalars['DateTime'];
  /** Farm Wt - Net Wt */
  weight_loss: Scalars['Float'];
};

/** An enumeration. */
export enum WeighInvoicingDoneOn {
  /** Quantity */
  Qty = 'QTY',
  /** SKU Count */
  Sku = 'SKU'
}

/** An enumeration. */
export enum WeighStatus {
  /** Completed */
  Cmp = 'CMP',
  /** On Hold */
  Hld = 'HLD',
  /** Not Started */
  Nst = 'NST',
  /** Rejected */
  Rjc = 'RJC',
  /** In Progress */
  Wip = 'WIP'
}

/** Boolean expression to compare columns of type "_numeric". All fields are combined with logical 'AND'. */
export type _Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_numeric']>;
  _gt?: InputMaybe<Scalars['_numeric']>;
  _gte?: InputMaybe<Scalars['_numeric']>;
  _in?: InputMaybe<Array<Scalars['_numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_numeric']>;
  _lte?: InputMaybe<Scalars['_numeric']>;
  _neq?: InputMaybe<Scalars['_numeric']>;
  _nin?: InputMaybe<Array<Scalars['_numeric']>>;
};

/** Boolean expression to compare columns of type "_varchar". All fields are combined with logical 'AND'. */
export type _Varchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_varchar']>;
  _gt?: InputMaybe<Scalars['_varchar']>;
  _gte?: InputMaybe<Scalars['_varchar']>;
  _in?: InputMaybe<Array<Scalars['_varchar']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_varchar']>;
  _lte?: InputMaybe<Scalars['_varchar']>;
  _neq?: InputMaybe<Scalars['_varchar']>;
  _nin?: InputMaybe<Array<Scalars['_varchar']>>;
};

/** columns and relationships of "action_log" */
export type Action_Log = {
  __typename?: 'action_log';
  action_flag: Scalars['String'];
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  change_message: Scalars['String'];
  change_object?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  object_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "action_log" */
export type Action_LogChange_ObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "action_log" */
export type Action_Log_Aggregate = {
  __typename?: 'action_log_aggregate';
  aggregate?: Maybe<Action_Log_Aggregate_Fields>;
  nodes: Array<Action_Log>;
};

/** aggregate fields of "action_log" */
export type Action_Log_Aggregate_Fields = {
  __typename?: 'action_log_aggregate_fields';
  avg?: Maybe<Action_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Action_Log_Max_Fields>;
  min?: Maybe<Action_Log_Min_Fields>;
  stddev?: Maybe<Action_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Action_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Action_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Action_Log_Sum_Fields>;
  var_pop?: Maybe<Action_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Action_Log_Var_Samp_Fields>;
  variance?: Maybe<Action_Log_Variance_Fields>;
};


/** aggregate fields of "action_log" */
export type Action_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Action_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Action_Log_Append_Input = {
  change_object?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Action_Log_Avg_Fields = {
  __typename?: 'action_log_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "action_log". All fields are combined with a logical 'AND'. */
export type Action_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Action_Log_Bool_Exp>>;
  _not?: InputMaybe<Action_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Action_Log_Bool_Exp>>;
  action_flag?: InputMaybe<String_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  change_message?: InputMaybe<String_Comparison_Exp>;
  change_object?: InputMaybe<Jsonb_Comparison_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "action_log" */
export enum Action_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActionLogPkey = 'action_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Action_Log_Delete_At_Path_Input = {
  change_object?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Action_Log_Delete_Elem_Input = {
  change_object?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Action_Log_Delete_Key_Input = {
  change_object?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "action_log" */
export type Action_Log_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "action_log" */
export type Action_Log_Insert_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Action_Log_Max_Fields = {
  __typename?: 'action_log_max_fields';
  action_flag?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  change_message?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Action_Log_Min_Fields = {
  __typename?: 'action_log_min_fields';
  action_flag?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  change_message?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "action_log" */
export type Action_Log_Mutation_Response = {
  __typename?: 'action_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Action_Log>;
};

/** on_conflict condition type for table "action_log" */
export type Action_Log_On_Conflict = {
  constraint: Action_Log_Constraint;
  update_columns?: Array<Action_Log_Update_Column>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "action_log". */
export type Action_Log_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_object?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: action_log */
export type Action_Log_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Action_Log_Prepend_Input = {
  change_object?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "action_log" */
export enum Action_Log_Select_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "action_log" */
export type Action_Log_Set_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Action_Log_Stddev_Fields = {
  __typename?: 'action_log_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Action_Log_Stddev_Pop_Fields = {
  __typename?: 'action_log_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Action_Log_Stddev_Samp_Fields = {
  __typename?: 'action_log_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "action_log" */
export type Action_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Action_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Action_Log_Stream_Cursor_Value_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Action_Log_Sum_Fields = {
  __typename?: 'action_log_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "action_log" */
export enum Action_Log_Update_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Action_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Action_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Action_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Action_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Action_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Action_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Action_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Action_Log_Set_Input>;
  where: Action_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Action_Log_Var_Pop_Fields = {
  __typename?: 'action_log_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Action_Log_Var_Samp_Fields = {
  __typename?: 'action_log_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Action_Log_Variance_Fields = {
  __typename?: 'action_log_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  address_kind: Scalars['String'];
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  /** An array relationship */
  base_users: Array<Base_User>;
  /** An aggregate relationship */
  base_users_aggregate: Base_User_Aggregate;
  country?: Maybe<Scalars['String']>;
  country_region_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  district?: Maybe<Scalars['String']>;
  /** An object relationship */
  district_region?: Maybe<Region>;
  district_region_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  farms: Array<Farm>;
  /** An aggregate relationship */
  farms_aggregate: Farm_Aggregate;
  /** An array relationship */
  fields: Array<Field>;
  /** An aggregate relationship */
  fields_aggregate: Field_Aggregate;
  id: Scalars['Int'];
  local_area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['geometry']>;
  /** An array relationship */
  mutual_groups: Array<Mutual_Group>;
  /** An aggregate relationship */
  mutual_groups_aggregate: Mutual_Group_Aggregate;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  /** An object relationship */
  region?: Maybe<Region>;
  /** SQL Short Address */
  short_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  state_region?: Maybe<Region>;
  state_region_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  sub_region?: Maybe<Region>;
  sub_region_id?: Maybe<Scalars['Int']>;
  taluka?: Maybe<Scalars['String']>;
  /** An object relationship */
  taluka_region?: Maybe<Region>;
  taluka_region_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  village?: Maybe<Scalars['String']>;
  /** An object relationship */
  village_region?: Maybe<Region>;
  village_region_id?: Maybe<Scalars['Int']>;
  w3w_code: Scalars['String'];
};


/** columns and relationships of "address" */
export type AddressBase_UsersArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressBase_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressMutual_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressMutual_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  avg?: Maybe<Address_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
  stddev?: Maybe<Address_Stddev_Fields>;
  stddev_pop?: Maybe<Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Address_Stddev_Samp_Fields>;
  sum?: Maybe<Address_Sum_Fields>;
  var_pop?: Maybe<Address_Var_Pop_Fields>;
  var_samp?: Maybe<Address_Var_Samp_Fields>;
  variance?: Maybe<Address_Variance_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Address_Avg_Fields = {
  __typename?: 'address_avg_fields';
  country_region_id?: Maybe<Scalars['Float']>;
  district_region_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  state_region_id?: Maybe<Scalars['Float']>;
  sub_region_id?: Maybe<Scalars['Float']>;
  taluka_region_id?: Maybe<Scalars['Float']>;
  village_region_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  address_kind?: InputMaybe<String_Comparison_Exp>;
  address_line_1?: InputMaybe<String_Comparison_Exp>;
  address_line_2?: InputMaybe<String_Comparison_Exp>;
  base_users?: InputMaybe<Base_User_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_region_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  district_region?: InputMaybe<Region_Bool_Exp>;
  district_region_id?: InputMaybe<Int_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  local_area?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pincode?: InputMaybe<String_Comparison_Exp>;
  raw_address?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  short_address?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_region?: InputMaybe<Region_Bool_Exp>;
  state_region_id?: InputMaybe<Int_Comparison_Exp>;
  sub_region?: InputMaybe<Region_Bool_Exp>;
  sub_region_id?: InputMaybe<Int_Comparison_Exp>;
  taluka?: InputMaybe<String_Comparison_Exp>;
  taluka_region?: InputMaybe<Region_Bool_Exp>;
  taluka_region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  village?: InputMaybe<String_Comparison_Exp>;
  village_region?: InputMaybe<Region_Bool_Exp>;
  village_region_id?: InputMaybe<Int_Comparison_Exp>;
  w3w_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  country_region_id?: InputMaybe<Scalars['Int']>;
  district_region_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  state_region_id?: InputMaybe<Scalars['Int']>;
  sub_region_id?: InputMaybe<Scalars['Int']>;
  taluka_region_id?: InputMaybe<Scalars['Int']>;
  village_region_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  base_users?: InputMaybe<Base_User_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Scalars['String']>;
  country_region_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  district_region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  district_region_id?: InputMaybe<Scalars['Int']>;
  farms?: InputMaybe<Farm_Arr_Rel_Insert_Input>;
  fields?: InputMaybe<Field_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  mutual_groups?: InputMaybe<Mutual_Group_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  state_region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  state_region_id?: InputMaybe<Scalars['Int']>;
  sub_region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  sub_region_id?: InputMaybe<Scalars['Int']>;
  taluka?: InputMaybe<Scalars['String']>;
  taluka_region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  taluka_region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
  village_region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  village_region_id?: InputMaybe<Scalars['Int']>;
  w3w_code?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  address_kind?: Maybe<Scalars['String']>;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  country_region_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  district_region_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_region_id?: Maybe<Scalars['Int']>;
  sub_region_id?: Maybe<Scalars['Int']>;
  taluka?: Maybe<Scalars['String']>;
  taluka_region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
  village_region_id?: Maybe<Scalars['Int']>;
  w3w_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  address_kind?: Maybe<Scalars['String']>;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  country_region_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  district_region_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_region_id?: Maybe<Scalars['Int']>;
  sub_region_id?: Maybe<Scalars['Int']>;
  taluka?: Maybe<Scalars['String']>;
  taluka_region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
  village_region_id?: Maybe<Scalars['Int']>;
  w3w_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  address_kind?: InputMaybe<Order_By>;
  address_line_1?: InputMaybe<Order_By>;
  address_line_2?: InputMaybe<Order_By>;
  base_users_aggregate?: InputMaybe<Base_User_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  country_region_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  district_region?: InputMaybe<Region_Order_By>;
  district_region_id?: InputMaybe<Order_By>;
  farms_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  fields_aggregate?: InputMaybe<Field_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  local_area?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  mutual_groups_aggregate?: InputMaybe<Mutual_Group_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  region?: InputMaybe<Region_Order_By>;
  short_address?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_region?: InputMaybe<Region_Order_By>;
  state_region_id?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Region_Order_By>;
  sub_region_id?: InputMaybe<Order_By>;
  taluka?: InputMaybe<Order_By>;
  taluka_region?: InputMaybe<Region_Order_By>;
  taluka_region_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  village?: InputMaybe<Order_By>;
  village_region?: InputMaybe<Region_Order_By>;
  village_region_id?: InputMaybe<Order_By>;
  w3w_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  AddressKind = 'address_kind',
  /** column name */
  AddressLine_1 = 'address_line_1',
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  Country = 'country',
  /** column name */
  CountryRegionId = 'country_region_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  DistrictRegionId = 'district_region_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocalArea = 'local_area',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  State = 'state',
  /** column name */
  StateRegionId = 'state_region_id',
  /** column name */
  SubRegionId = 'sub_region_id',
  /** column name */
  Taluka = 'taluka',
  /** column name */
  TalukaRegionId = 'taluka_region_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Village = 'village',
  /** column name */
  VillageRegionId = 'village_region_id',
  /** column name */
  W3wCode = 'w3w_code'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  country_region_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  district_region_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_region_id?: InputMaybe<Scalars['Int']>;
  sub_region_id?: InputMaybe<Scalars['Int']>;
  taluka?: InputMaybe<Scalars['String']>;
  taluka_region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
  village_region_id?: InputMaybe<Scalars['Int']>;
  w3w_code?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Address_Stddev_Fields = {
  __typename?: 'address_stddev_fields';
  country_region_id?: Maybe<Scalars['Float']>;
  district_region_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  state_region_id?: Maybe<Scalars['Float']>;
  sub_region_id?: Maybe<Scalars['Float']>;
  taluka_region_id?: Maybe<Scalars['Float']>;
  village_region_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Address_Stddev_Pop_Fields = {
  __typename?: 'address_stddev_pop_fields';
  country_region_id?: Maybe<Scalars['Float']>;
  district_region_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  state_region_id?: Maybe<Scalars['Float']>;
  sub_region_id?: Maybe<Scalars['Float']>;
  taluka_region_id?: Maybe<Scalars['Float']>;
  village_region_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Address_Stddev_Samp_Fields = {
  __typename?: 'address_stddev_samp_fields';
  country_region_id?: Maybe<Scalars['Float']>;
  district_region_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  state_region_id?: Maybe<Scalars['Float']>;
  sub_region_id?: Maybe<Scalars['Float']>;
  taluka_region_id?: Maybe<Scalars['Float']>;
  village_region_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  country_region_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  district_region_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_region_id?: InputMaybe<Scalars['Int']>;
  sub_region_id?: InputMaybe<Scalars['Int']>;
  taluka?: InputMaybe<Scalars['String']>;
  taluka_region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
  village_region_id?: InputMaybe<Scalars['Int']>;
  w3w_code?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Address_Sum_Fields = {
  __typename?: 'address_sum_fields';
  country_region_id?: Maybe<Scalars['Int']>;
  district_region_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  state_region_id?: Maybe<Scalars['Int']>;
  sub_region_id?: Maybe<Scalars['Int']>;
  taluka_region_id?: Maybe<Scalars['Int']>;
  village_region_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  AddressKind = 'address_kind',
  /** column name */
  AddressLine_1 = 'address_line_1',
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  Country = 'country',
  /** column name */
  CountryRegionId = 'country_region_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  DistrictRegionId = 'district_region_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocalArea = 'local_area',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  State = 'state',
  /** column name */
  StateRegionId = 'state_region_id',
  /** column name */
  SubRegionId = 'sub_region_id',
  /** column name */
  Taluka = 'taluka',
  /** column name */
  TalukaRegionId = 'taluka_region_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Village = 'village',
  /** column name */
  VillageRegionId = 'village_region_id',
  /** column name */
  W3wCode = 'w3w_code'
}

export type Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Address_Var_Pop_Fields = {
  __typename?: 'address_var_pop_fields';
  country_region_id?: Maybe<Scalars['Float']>;
  district_region_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  state_region_id?: Maybe<Scalars['Float']>;
  sub_region_id?: Maybe<Scalars['Float']>;
  taluka_region_id?: Maybe<Scalars['Float']>;
  village_region_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Address_Var_Samp_Fields = {
  __typename?: 'address_var_samp_fields';
  country_region_id?: Maybe<Scalars['Float']>;
  district_region_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  state_region_id?: Maybe<Scalars['Float']>;
  sub_region_id?: Maybe<Scalars['Float']>;
  taluka_region_id?: Maybe<Scalars['Float']>;
  village_region_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Address_Variance_Fields = {
  __typename?: 'address_variance_fields';
  country_region_id?: Maybe<Scalars['Float']>;
  district_region_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  state_region_id?: Maybe<Scalars['Float']>;
  sub_region_id?: Maybe<Scalars['Float']>;
  taluka_region_id?: Maybe<Scalars['Float']>;
  village_region_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "advance_payment" */
export type Advance_Payment = {
  __typename?: 'advance_payment';
  amount?: Maybe<Scalars['numeric']>;
  bourn_by?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  /** An object relationship */
  department_user_advance?: Maybe<Department_User_Advance>;
  department_user_advance_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  is_dumped: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  parameter: Advance_Payment_Parameters;
  parameter_id: Scalars['bigint'];
  /** An object relationship */
  receipt?: Maybe<Receipt>;
  receipt_id?: Maybe<Scalars['bigint']>;
  released_amount?: Maybe<Scalars['numeric']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  settled_amount?: Maybe<Scalars['numeric']>;
  settlement_status: Scalars['String'];
  status: Scalars['String'];
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  transactions: Array<Transaction>;
  /** An aggregate relationship */
  transactions_aggregate: Transaction_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "advance_payment" */
export type Advance_PaymentTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "advance_payment" */
export type Advance_PaymentTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

/** aggregated selection of "advance_payment" */
export type Advance_Payment_Aggregate = {
  __typename?: 'advance_payment_aggregate';
  aggregate?: Maybe<Advance_Payment_Aggregate_Fields>;
  nodes: Array<Advance_Payment>;
};

/** aggregate fields of "advance_payment" */
export type Advance_Payment_Aggregate_Fields = {
  __typename?: 'advance_payment_aggregate_fields';
  avg?: Maybe<Advance_Payment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Advance_Payment_Max_Fields>;
  min?: Maybe<Advance_Payment_Min_Fields>;
  stddev?: Maybe<Advance_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Advance_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advance_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Advance_Payment_Sum_Fields>;
  var_pop?: Maybe<Advance_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Advance_Payment_Var_Samp_Fields>;
  variance?: Maybe<Advance_Payment_Variance_Fields>;
};


/** aggregate fields of "advance_payment" */
export type Advance_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "advance_payment" */
export type Advance_Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Advance_Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Advance_Payment_Max_Order_By>;
  min?: InputMaybe<Advance_Payment_Min_Order_By>;
  stddev?: InputMaybe<Advance_Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Advance_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Advance_Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Advance_Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Advance_Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Advance_Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Advance_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "advance_payment" */
export type Advance_Payment_Arr_Rel_Insert_Input = {
  data: Array<Advance_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Advance_Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Advance_Payment_Avg_Fields = {
  __typename?: 'advance_payment_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  department_user_advance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parameter_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  released_amount?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "advance_payment" */
export type Advance_Payment_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "advance_payment". All fields are combined with a logical 'AND'. */
export type Advance_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Advance_Payment_Bool_Exp>>;
  _not?: InputMaybe<Advance_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Advance_Payment_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  bourn_by?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  department_user_advance?: InputMaybe<Department_User_Advance_Bool_Exp>;
  department_user_advance_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_dumped?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  parameter?: InputMaybe<Advance_Payment_Parameters_Bool_Exp>;
  parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  receipt_id?: InputMaybe<Bigint_Comparison_Exp>;
  released_amount?: InputMaybe<Numeric_Comparison_Exp>;
  remaining_amount?: InputMaybe<Numeric_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  settled_amount?: InputMaybe<Numeric_Comparison_Exp>;
  settlement_status?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  transactions?: InputMaybe<Transaction_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "advance_payment" */
export enum Advance_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdvancePaymentPkey = 'advance_payment_pkey'
}

/** input type for incrementing numeric columns in table "advance_payment" */
export type Advance_Payment_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  parameter_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "advance_payment" */
export type Advance_Payment_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  bourn_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parameter_id?: InputMaybe<Scalars['bigint']>;
  receipt?: InputMaybe<Receipt_Obj_Rel_Insert_Input>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  transactions?: InputMaybe<Transaction_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Advance_Payment_Max_Fields = {
  __typename?: 'advance_payment_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  bourn_by?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_user_advance_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  parameter_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  released_amount?: Maybe<Scalars['numeric']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  settled_amount?: Maybe<Scalars['numeric']>;
  settlement_status?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "advance_payment" */
export type Advance_Payment_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  bourn_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  settlement_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Advance_Payment_Min_Fields = {
  __typename?: 'advance_payment_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  bourn_by?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_user_advance_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  parameter_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  released_amount?: Maybe<Scalars['numeric']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  settled_amount?: Maybe<Scalars['numeric']>;
  settlement_status?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "advance_payment" */
export type Advance_Payment_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  bourn_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  settlement_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "advance_payment" */
export type Advance_Payment_Mutation_Response = {
  __typename?: 'advance_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Advance_Payment>;
};

/** input type for inserting object relation for remote table "advance_payment" */
export type Advance_Payment_Obj_Rel_Insert_Input = {
  data: Advance_Payment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Advance_Payment_On_Conflict>;
};

/** on_conflict condition type for table "advance_payment" */
export type Advance_Payment_On_Conflict = {
  constraint: Advance_Payment_Constraint;
  update_columns?: Array<Advance_Payment_Update_Column>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "advance_payment". */
export type Advance_Payment_Order_By = {
  amount?: InputMaybe<Order_By>;
  bourn_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department_user_advance?: InputMaybe<Department_User_Advance_Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_dumped?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  parameter?: InputMaybe<Advance_Payment_Parameters_Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  settlement_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "advance_payment_parameters" */
export type Advance_Payment_Parameters = {
  __typename?: 'advance_payment_parameters';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  name: Scalars['String'];
};

/** aggregated selection of "advance_payment_parameters" */
export type Advance_Payment_Parameters_Aggregate = {
  __typename?: 'advance_payment_parameters_aggregate';
  aggregate?: Maybe<Advance_Payment_Parameters_Aggregate_Fields>;
  nodes: Array<Advance_Payment_Parameters>;
};

/** aggregate fields of "advance_payment_parameters" */
export type Advance_Payment_Parameters_Aggregate_Fields = {
  __typename?: 'advance_payment_parameters_aggregate_fields';
  avg?: Maybe<Advance_Payment_Parameters_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Advance_Payment_Parameters_Max_Fields>;
  min?: Maybe<Advance_Payment_Parameters_Min_Fields>;
  stddev?: Maybe<Advance_Payment_Parameters_Stddev_Fields>;
  stddev_pop?: Maybe<Advance_Payment_Parameters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advance_Payment_Parameters_Stddev_Samp_Fields>;
  sum?: Maybe<Advance_Payment_Parameters_Sum_Fields>;
  var_pop?: Maybe<Advance_Payment_Parameters_Var_Pop_Fields>;
  var_samp?: Maybe<Advance_Payment_Parameters_Var_Samp_Fields>;
  variance?: Maybe<Advance_Payment_Parameters_Variance_Fields>;
};


/** aggregate fields of "advance_payment_parameters" */
export type Advance_Payment_Parameters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advance_Payment_Parameters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Advance_Payment_Parameters_Avg_Fields = {
  __typename?: 'advance_payment_parameters_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "advance_payment_parameters". All fields are combined with a logical 'AND'. */
export type Advance_Payment_Parameters_Bool_Exp = {
  _and?: InputMaybe<Array<Advance_Payment_Parameters_Bool_Exp>>;
  _not?: InputMaybe<Advance_Payment_Parameters_Bool_Exp>;
  _or?: InputMaybe<Array<Advance_Payment_Parameters_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Advance_Payment_Parameters_Max_Fields = {
  __typename?: 'advance_payment_parameters_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Advance_Payment_Parameters_Min_Fields = {
  __typename?: 'advance_payment_parameters_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "advance_payment_parameters". */
export type Advance_Payment_Parameters_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "advance_payment_parameters" */
export enum Advance_Payment_Parameters_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** aggregate stddev on columns */
export type Advance_Payment_Parameters_Stddev_Fields = {
  __typename?: 'advance_payment_parameters_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Advance_Payment_Parameters_Stddev_Pop_Fields = {
  __typename?: 'advance_payment_parameters_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Advance_Payment_Parameters_Stddev_Samp_Fields = {
  __typename?: 'advance_payment_parameters_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "advance_payment_parameters" */
export type Advance_Payment_Parameters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advance_Payment_Parameters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advance_Payment_Parameters_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Advance_Payment_Parameters_Sum_Fields = {
  __typename?: 'advance_payment_parameters_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Advance_Payment_Parameters_Var_Pop_Fields = {
  __typename?: 'advance_payment_parameters_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Advance_Payment_Parameters_Var_Samp_Fields = {
  __typename?: 'advance_payment_parameters_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Advance_Payment_Parameters_Variance_Fields = {
  __typename?: 'advance_payment_parameters_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** primary key columns input for table: advance_payment */
export type Advance_Payment_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "advance_payment" */
export enum Advance_Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BournBy = 'bourn_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DepartmentUserAdvanceId = 'department_user_advance_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDumped = 'is_dumped',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  ReleasedAmount = 'released_amount',
  /** column name */
  RemainingAmount = 'remaining_amount',
  /** column name */
  Remark = 'remark',
  /** column name */
  SettledAmount = 'settled_amount',
  /** column name */
  SettlementStatus = 'settlement_status',
  /** column name */
  Status = 'status',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "advance_payment" */
export type Advance_Payment_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  bourn_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parameter_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Advance_Payment_Stddev_Fields = {
  __typename?: 'advance_payment_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  department_user_advance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parameter_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  released_amount?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "advance_payment" */
export type Advance_Payment_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Advance_Payment_Stddev_Pop_Fields = {
  __typename?: 'advance_payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  department_user_advance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parameter_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  released_amount?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "advance_payment" */
export type Advance_Payment_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Advance_Payment_Stddev_Samp_Fields = {
  __typename?: 'advance_payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  department_user_advance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parameter_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  released_amount?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "advance_payment" */
export type Advance_Payment_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "advance_payment" */
export type Advance_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advance_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advance_Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  bourn_by?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  department_user_advance_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_dumped?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  parameter_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  released_amount?: InputMaybe<Scalars['numeric']>;
  remaining_amount?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  settled_amount?: InputMaybe<Scalars['numeric']>;
  settlement_status?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Advance_Payment_Sum_Fields = {
  __typename?: 'advance_payment_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  department_user_advance_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  parameter_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  released_amount?: Maybe<Scalars['numeric']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  settled_amount?: Maybe<Scalars['numeric']>;
  trade_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "advance_payment" */
export type Advance_Payment_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "advance_payment" */
export enum Advance_Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BournBy = 'bourn_by',
  /** column name */
  Id = 'id',
  /** column name */
  ParameterId = 'parameter_id',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UserId = 'user_id'
}

export type Advance_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advance_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advance_Payment_Set_Input>;
  where: Advance_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advance_Payment_Var_Pop_Fields = {
  __typename?: 'advance_payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  department_user_advance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parameter_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  released_amount?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "advance_payment" */
export type Advance_Payment_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Advance_Payment_Var_Samp_Fields = {
  __typename?: 'advance_payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  department_user_advance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parameter_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  released_amount?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "advance_payment" */
export type Advance_Payment_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Advance_Payment_Variance_Fields = {
  __typename?: 'advance_payment_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  department_user_advance_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parameter_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  released_amount?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "advance_payment" */
export type Advance_Payment_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  department_user_advance_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  released_amount?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "agent" */
export type Agent = {
  __typename?: 'agent';
  accepts_tnc: Scalars['Boolean'];
  /** An array relationship */
  agent_roles: Array<Agent_Role>;
  /** An aggregate relationship */
  agent_roles_aggregate: Agent_Role_Aggregate;
  /** An object relationship */
  base_user: Base_User;
  codename: Scalars['String'];
  /** An array relationship */
  companies: Array<Agent_Company>;
  /** An aggregate relationship */
  companies_aggregate: Agent_Company_Aggregate;
  current_department_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  department?: Maybe<Department>;
  description?: Maybe<Scalars['String']>;
  eid: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  number: Scalars['String'];
  /** An array relationship */
  org_team_user_bank_associations: Array<Org_Team_User_Bank_Association>;
  /** An aggregate relationship */
  org_team_user_bank_associations_aggregate: Org_Team_User_Bank_Association_Aggregate;
  /** An array relationship */
  org_team_user_document_associations: Array<Org_Team_User_Document_Association>;
  /** An aggregate relationship */
  org_team_user_document_associations_aggregate: Org_Team_User_Document_Association_Aggregate;
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** columns and relationships of "agent" */
export type AgentAgent_RolesArgs = {
  distinct_on?: InputMaybe<Array<Agent_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Role_Order_By>>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentAgent_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Role_Order_By>>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentOrg_Team_User_Bank_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentOrg_Team_User_Bank_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentOrg_Team_User_Document_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


/** columns and relationships of "agent" */
export type AgentOrg_Team_User_Document_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};

/** aggregated selection of "agent" */
export type Agent_Aggregate = {
  __typename?: 'agent_aggregate';
  aggregate?: Maybe<Agent_Aggregate_Fields>;
  nodes: Array<Agent>;
};

/** aggregate fields of "agent" */
export type Agent_Aggregate_Fields = {
  __typename?: 'agent_aggregate_fields';
  avg?: Maybe<Agent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agent_Max_Fields>;
  min?: Maybe<Agent_Min_Fields>;
  stddev?: Maybe<Agent_Stddev_Fields>;
  stddev_pop?: Maybe<Agent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agent_Stddev_Samp_Fields>;
  sum?: Maybe<Agent_Sum_Fields>;
  var_pop?: Maybe<Agent_Var_Pop_Fields>;
  var_samp?: Maybe<Agent_Var_Samp_Fields>;
  variance?: Maybe<Agent_Variance_Fields>;
};


/** aggregate fields of "agent" */
export type Agent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agent" */
export type Agent_Aggregate_Order_By = {
  avg?: InputMaybe<Agent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Max_Order_By>;
  min?: InputMaybe<Agent_Min_Order_By>;
  stddev?: InputMaybe<Agent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agent_Sum_Order_By>;
  var_pop?: InputMaybe<Agent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agent_Var_Samp_Order_By>;
  variance?: InputMaybe<Agent_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agent" */
export type Agent_Arr_Rel_Insert_Input = {
  data: Array<Agent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};

/** aggregate avg on columns */
export type Agent_Avg_Fields = {
  __typename?: 'agent_avg_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agent" */
export type Agent_Avg_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agent". All fields are combined with a logical 'AND'. */
export type Agent_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Bool_Exp>>;
  _not?: InputMaybe<Agent_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Bool_Exp>>;
  accepts_tnc?: InputMaybe<Boolean_Comparison_Exp>;
  agent_roles?: InputMaybe<Agent_Role_Bool_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Agent_Company_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  eid?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "agent_company" */
export type Agent_Company = {
  __typename?: 'agent_company';
  accepts_tnc: Scalars['Boolean'];
  /** An object relationship */
  agent: Agent;
  agent_id: Scalars['Int'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "agent_company" */
export type Agent_Company_Aggregate = {
  __typename?: 'agent_company_aggregate';
  aggregate?: Maybe<Agent_Company_Aggregate_Fields>;
  nodes: Array<Agent_Company>;
};

/** aggregate fields of "agent_company" */
export type Agent_Company_Aggregate_Fields = {
  __typename?: 'agent_company_aggregate_fields';
  avg?: Maybe<Agent_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agent_Company_Max_Fields>;
  min?: Maybe<Agent_Company_Min_Fields>;
  stddev?: Maybe<Agent_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Agent_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agent_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Agent_Company_Sum_Fields>;
  var_pop?: Maybe<Agent_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Agent_Company_Var_Samp_Fields>;
  variance?: Maybe<Agent_Company_Variance_Fields>;
};


/** aggregate fields of "agent_company" */
export type Agent_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agent_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agent_company" */
export type Agent_Company_Aggregate_Order_By = {
  avg?: InputMaybe<Agent_Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Company_Max_Order_By>;
  min?: InputMaybe<Agent_Company_Min_Order_By>;
  stddev?: InputMaybe<Agent_Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agent_Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agent_Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agent_Company_Sum_Order_By>;
  var_pop?: InputMaybe<Agent_Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agent_Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Agent_Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agent_company" */
export type Agent_Company_Arr_Rel_Insert_Input = {
  data: Array<Agent_Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Agent_Company_Avg_Fields = {
  __typename?: 'agent_company_avg_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agent_company" */
export type Agent_Company_Avg_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agent_company". All fields are combined with a logical 'AND'. */
export type Agent_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Company_Bool_Exp>>;
  _not?: InputMaybe<Agent_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Company_Bool_Exp>>;
  accepts_tnc?: InputMaybe<Boolean_Comparison_Exp>;
  agent?: InputMaybe<Agent_Bool_Exp>;
  agent_id?: InputMaybe<Int_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_company" */
export enum Agent_Company_Constraint {
  /** unique or primary key constraint on columns "agent_id", "company_id" */
  AgentCompanyAgentIdCompanyIdCc3e7b91Uniq = 'agent_company_agent_id_company_id_cc3e7b91_uniq',
  /** unique or primary key constraint on columns "id" */
  AgentCompanyPkey = 'agent_company_pkey'
}

/** input type for incrementing numeric columns in table "agent_company" */
export type Agent_Company_Inc_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agent_company" */
export type Agent_Company_Insert_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  agent?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  agent_id?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agent_Company_Max_Fields = {
  __typename?: 'agent_company_max_fields';
  agent_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agent_company" */
export type Agent_Company_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agent_Company_Min_Fields = {
  __typename?: 'agent_company_min_fields';
  agent_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agent_company" */
export type Agent_Company_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent_company" */
export type Agent_Company_Mutation_Response = {
  __typename?: 'agent_company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent_Company>;
};

/** on_conflict condition type for table "agent_company" */
export type Agent_Company_On_Conflict = {
  constraint: Agent_Company_Constraint;
  update_columns?: Array<Agent_Company_Update_Column>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_company". */
export type Agent_Company_Order_By = {
  accepts_tnc?: InputMaybe<Order_By>;
  agent?: InputMaybe<Agent_Order_By>;
  agent_id?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_company */
export type Agent_Company_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agent_company" */
export enum Agent_Company_Select_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "agent_company" */
export type Agent_Company_Set_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  agent_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agent_Company_Stddev_Fields = {
  __typename?: 'agent_company_stddev_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agent_company" */
export type Agent_Company_Stddev_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agent_Company_Stddev_Pop_Fields = {
  __typename?: 'agent_company_stddev_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agent_company" */
export type Agent_Company_Stddev_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agent_Company_Stddev_Samp_Fields = {
  __typename?: 'agent_company_stddev_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agent_company" */
export type Agent_Company_Stddev_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agent_company" */
export type Agent_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Company_Stream_Cursor_Value_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  agent_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agent_Company_Sum_Fields = {
  __typename?: 'agent_company_sum_fields';
  agent_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agent_company" */
export type Agent_Company_Sum_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "agent_company" */
export enum Agent_Company_Update_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

export type Agent_Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agent_Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Company_Set_Input>;
  where: Agent_Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agent_Company_Var_Pop_Fields = {
  __typename?: 'agent_company_var_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agent_company" */
export type Agent_Company_Var_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agent_Company_Var_Samp_Fields = {
  __typename?: 'agent_company_var_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agent_company" */
export type Agent_Company_Var_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agent_Company_Variance_Fields = {
  __typename?: 'agent_company_variance_fields';
  agent_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agent_company" */
export type Agent_Company_Variance_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "agent" */
export enum Agent_Constraint {
  /** unique or primary key constraint on columns "codename" */
  AgentCodenameKey = 'agent_codename_key',
  /** unique or primary key constraint on columns "organisation_id", "eid" */
  AgentOrganisationIdEid_6689a3f2Uniq = 'agent_organisation_id_eid_6689a3f2_uniq',
  /** unique or primary key constraint on columns "organisation_id", "user_id" */
  AgentOrganisationIdUserId_44d1bc58Uniq = 'agent_organisation_id_user_id_44d1bc58_uniq',
  /** unique or primary key constraint on columns "id" */
  AgentPkey = 'agent_pkey'
}

/** input type for incrementing numeric columns in table "agent" */
export type Agent_Inc_Input = {
  current_department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agent" */
export type Agent_Insert_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  agent_roles?: InputMaybe<Agent_Role_Arr_Rel_Insert_Input>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Agent_Company_Arr_Rel_Insert_Input>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  eid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Arr_Rel_Insert_Input>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Arr_Rel_Insert_Input>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agent_Max_Fields = {
  __typename?: 'agent_max_fields';
  codename?: Maybe<Scalars['String']>;
  current_department_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  eid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agent" */
export type Agent_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eid?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agent_Min_Fields = {
  __typename?: 'agent_min_fields';
  codename?: Maybe<Scalars['String']>;
  current_department_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  eid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agent" */
export type Agent_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eid?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent" */
export type Agent_Mutation_Response = {
  __typename?: 'agent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent>;
};

/** input type for inserting object relation for remote table "agent" */
export type Agent_Obj_Rel_Insert_Input = {
  data: Agent_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};

/** on_conflict condition type for table "agent" */
export type Agent_On_Conflict = {
  constraint: Agent_Constraint;
  update_columns?: Array<Agent_Update_Column>;
  where?: InputMaybe<Agent_Bool_Exp>;
};

/** Ordering options when selecting data from "agent". */
export type Agent_Order_By = {
  accepts_tnc?: InputMaybe<Order_By>;
  agent_roles_aggregate?: InputMaybe<Agent_Role_Aggregate_Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  codename?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Agent_Company_Aggregate_Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  description?: InputMaybe<Order_By>;
  eid?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  org_team_user_bank_associations_aggregate?: InputMaybe<Org_Team_User_Bank_Association_Aggregate_Order_By>;
  org_team_user_document_associations_aggregate?: InputMaybe<Org_Team_User_Document_Association_Aggregate_Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent */
export type Agent_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "agent_role" */
export type Agent_Role = {
  __typename?: 'agent_role';
  /** An object relationship */
  agent: Agent;
  agent_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  role: Role;
  role_id: Scalars['Int'];
};

/** aggregated selection of "agent_role" */
export type Agent_Role_Aggregate = {
  __typename?: 'agent_role_aggregate';
  aggregate?: Maybe<Agent_Role_Aggregate_Fields>;
  nodes: Array<Agent_Role>;
};

/** aggregate fields of "agent_role" */
export type Agent_Role_Aggregate_Fields = {
  __typename?: 'agent_role_aggregate_fields';
  avg?: Maybe<Agent_Role_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agent_Role_Max_Fields>;
  min?: Maybe<Agent_Role_Min_Fields>;
  stddev?: Maybe<Agent_Role_Stddev_Fields>;
  stddev_pop?: Maybe<Agent_Role_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agent_Role_Stddev_Samp_Fields>;
  sum?: Maybe<Agent_Role_Sum_Fields>;
  var_pop?: Maybe<Agent_Role_Var_Pop_Fields>;
  var_samp?: Maybe<Agent_Role_Var_Samp_Fields>;
  variance?: Maybe<Agent_Role_Variance_Fields>;
};


/** aggregate fields of "agent_role" */
export type Agent_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agent_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agent_role" */
export type Agent_Role_Aggregate_Order_By = {
  avg?: InputMaybe<Agent_Role_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agent_Role_Max_Order_By>;
  min?: InputMaybe<Agent_Role_Min_Order_By>;
  stddev?: InputMaybe<Agent_Role_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agent_Role_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agent_Role_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agent_Role_Sum_Order_By>;
  var_pop?: InputMaybe<Agent_Role_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agent_Role_Var_Samp_Order_By>;
  variance?: InputMaybe<Agent_Role_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agent_role" */
export type Agent_Role_Arr_Rel_Insert_Input = {
  data: Array<Agent_Role_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agent_Role_On_Conflict>;
};

/** aggregate avg on columns */
export type Agent_Role_Avg_Fields = {
  __typename?: 'agent_role_avg_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agent_role" */
export type Agent_Role_Avg_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agent_role". All fields are combined with a logical 'AND'. */
export type Agent_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Role_Bool_Exp>>;
  _not?: InputMaybe<Agent_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Role_Bool_Exp>>;
  agent?: InputMaybe<Agent_Bool_Exp>;
  agent_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  role_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agent_role" */
export enum Agent_Role_Constraint {
  /** unique or primary key constraint on columns "role_id", "agent_id" */
  AgentRoleAgentIdRoleId_13bae4ffUniq = 'agent_role_agent_id_role_id_13bae4ff_uniq',
  /** unique or primary key constraint on columns "id" */
  AgentRolePkey = 'agent_role_pkey'
}

/** input type for incrementing numeric columns in table "agent_role" */
export type Agent_Role_Inc_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agent_role" */
export type Agent_Role_Insert_Input = {
  agent?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agent_Role_Max_Fields = {
  __typename?: 'agent_role_max_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agent_role" */
export type Agent_Role_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agent_Role_Min_Fields = {
  __typename?: 'agent_role_min_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agent_role" */
export type Agent_Role_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agent_role" */
export type Agent_Role_Mutation_Response = {
  __typename?: 'agent_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agent_Role>;
};

/** on_conflict condition type for table "agent_role" */
export type Agent_Role_On_Conflict = {
  constraint: Agent_Role_Constraint;
  update_columns?: Array<Agent_Role_Update_Column>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "agent_role". */
export type Agent_Role_Order_By = {
  agent?: InputMaybe<Agent_Order_By>;
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agent_role */
export type Agent_Role_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agent_role" */
export enum Agent_Role_Select_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id'
}

/** input type for updating data in table "agent_role" */
export type Agent_Role_Set_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agent_Role_Stddev_Fields = {
  __typename?: 'agent_role_stddev_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agent_role" */
export type Agent_Role_Stddev_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agent_Role_Stddev_Pop_Fields = {
  __typename?: 'agent_role_stddev_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agent_role" */
export type Agent_Role_Stddev_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agent_Role_Stddev_Samp_Fields = {
  __typename?: 'agent_role_stddev_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agent_role" */
export type Agent_Role_Stddev_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agent_role" */
export type Agent_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Role_Stream_Cursor_Value_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  role_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agent_Role_Sum_Fields = {
  __typename?: 'agent_role_sum_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  role_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agent_role" */
export type Agent_Role_Sum_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** update columns of table "agent_role" */
export enum Agent_Role_Update_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  Id = 'id',
  /** column name */
  RoleId = 'role_id'
}

export type Agent_Role_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agent_Role_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Role_Set_Input>;
  where: Agent_Role_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agent_Role_Var_Pop_Fields = {
  __typename?: 'agent_role_var_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agent_role" */
export type Agent_Role_Var_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agent_Role_Var_Samp_Fields = {
  __typename?: 'agent_role_var_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agent_role" */
export type Agent_Role_Var_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agent_Role_Variance_Fields = {
  __typename?: 'agent_role_variance_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agent_role" */
export type Agent_Role_Variance_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** select columns of table "agent" */
export enum Agent_Select_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  Codename = 'codename',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  Description = 'description',
  /** column name */
  Eid = 'eid',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "agent" */
export type Agent_Set_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  eid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agent_Stddev_Fields = {
  __typename?: 'agent_stddev_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agent" */
export type Agent_Stddev_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agent_Stddev_Pop_Fields = {
  __typename?: 'agent_stddev_pop_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agent" */
export type Agent_Stddev_Pop_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agent_Stddev_Samp_Fields = {
  __typename?: 'agent_stddev_samp_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agent" */
export type Agent_Stddev_Samp_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agent" */
export type Agent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Stream_Cursor_Value_Input = {
  accepts_tnc?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  eid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agent_Sum_Fields = {
  __typename?: 'agent_sum_fields';
  current_department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agent" */
export type Agent_Sum_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "agent" */
export enum Agent_Update_Column {
  /** column name */
  AcceptsTnc = 'accepts_tnc',
  /** column name */
  Codename = 'codename',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  Description = 'description',
  /** column name */
  Eid = 'eid',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export type Agent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agent_Set_Input>;
  where: Agent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agent_Var_Pop_Fields = {
  __typename?: 'agent_var_pop_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agent" */
export type Agent_Var_Pop_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agent_Var_Samp_Fields = {
  __typename?: 'agent_var_samp_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agent" */
export type Agent_Var_Samp_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agent_Variance_Fields = {
  __typename?: 'agent_variance_fields';
  current_department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agent" */
export type Agent_Variance_Order_By = {
  current_department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_Owner = {
  __typename?: 'agreement_co_owner';
  /** An array relationship */
  agreement_co_owner: Array<Variety_Agreement_Agreement_Co_Owners>;
  /** An aggregate relationship */
  agreement_co_owner_aggregate: Variety_Agreement_Agreement_Co_Owners_Aggregate;
  /** An array relationship */
  agreement_invoices: Array<Agreement_Co_Owner_Agreement_Invoices>;
  /** An aggregate relationship */
  agreement_invoices_aggregate: Agreement_Co_Owner_Agreement_Invoices_Aggregate;
  /** An array relationship */
  agreement_plots: Array<Agreement_Co_Owner_Agreement_Plots>;
  /** An aggregate relationship */
  agreement_plots_aggregate: Agreement_Co_Owner_Agreement_Plots_Aggregate;
  agreement_year?: Maybe<Scalars['String']>;
  /** An object relationship */
  co_owner: Base_User;
  co_owner_id: Scalars['Int'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An array relationship */
  legal_agreements: Array<Agreement_Co_Owner_Legal_Agreement>;
  /** An aggregate relationship */
  legal_agreements_aggregate: Agreement_Co_Owner_Legal_Agreement_Aggregate;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerAgreement_Co_OwnerArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerAgreement_Co_Owner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerAgreement_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerAgreement_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerAgreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerAgreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerLegal_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


/** columns and relationships of "agreement_co_owner" */
export type Agreement_Co_OwnerLegal_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};

/** aggregated selection of "agreement_co_owner" */
export type Agreement_Co_Owner_Aggregate = {
  __typename?: 'agreement_co_owner_aggregate';
  aggregate?: Maybe<Agreement_Co_Owner_Aggregate_Fields>;
  nodes: Array<Agreement_Co_Owner>;
};

/** aggregate fields of "agreement_co_owner" */
export type Agreement_Co_Owner_Aggregate_Fields = {
  __typename?: 'agreement_co_owner_aggregate_fields';
  avg?: Maybe<Agreement_Co_Owner_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Co_Owner_Max_Fields>;
  min?: Maybe<Agreement_Co_Owner_Min_Fields>;
  stddev?: Maybe<Agreement_Co_Owner_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Co_Owner_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Co_Owner_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Co_Owner_Sum_Fields>;
  var_pop?: Maybe<Agreement_Co_Owner_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Co_Owner_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Co_Owner_Variance_Fields>;
};


/** aggregate fields of "agreement_co_owner" */
export type Agreement_Co_Owner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Co_Owner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices = {
  __typename?: 'agreement_co_owner_agreement_invoices';
  /** An object relationship */
  agreement_co_owner: Agreement_Co_Owner;
  /** An object relationship */
  agreement_invoice: Agreement_Invoice;
  agreementcoowner_id: Scalars['Int'];
  agreementinvoice_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Aggregate = {
  __typename?: 'agreement_co_owner_agreement_invoices_aggregate';
  aggregate?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Aggregate_Fields>;
  nodes: Array<Agreement_Co_Owner_Agreement_Invoices>;
};

/** aggregate fields of "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Aggregate_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_aggregate_fields';
  avg?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Max_Fields>;
  min?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Min_Fields>;
  stddev?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Sum_Fields>;
  var_pop?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Variance_Fields>;
};


/** aggregate fields of "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Max_Order_By>;
  min?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Co_Owner_Agreement_Invoices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Avg_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_avg_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Avg_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_co_owner_agreement_invoices". All fields are combined with a logical 'AND'. */
export type Agreement_Co_Owner_Agreement_Invoices_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>>;
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
  agreement_invoice?: InputMaybe<Agreement_Invoice_Bool_Exp>;
  agreementcoowner_id?: InputMaybe<Int_Comparison_Exp>;
  agreementinvoice_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_co_owner_agreement_invoices" */
export enum Agreement_Co_Owner_Agreement_Invoices_Constraint {
  /** unique or primary key constraint on columns "agreementcoowner_id", "agreementinvoice_id" */
  AgreementCoOwnerAgreeAgreementcoownerIdAgre_7cefba18Uniq = 'agreement_co_owner_agree_agreementcoowner_id_agre_7cefba18_uniq',
  /** unique or primary key constraint on columns "id" */
  AgreementCoOwnerAgreementInvoicesPkey = 'agreement_co_owner_agreement_invoices_pkey'
}

/** input type for incrementing numeric columns in table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Inc_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Insert_Input = {
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Obj_Rel_Insert_Input>;
  agreement_invoice?: InputMaybe<Agreement_Invoice_Obj_Rel_Insert_Input>;
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Max_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_max_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Max_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Min_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_min_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Min_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Mutation_Response = {
  __typename?: 'agreement_co_owner_agreement_invoices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Co_Owner_Agreement_Invoices>;
};

/** on_conflict condition type for table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_On_Conflict = {
  constraint: Agreement_Co_Owner_Agreement_Invoices_Constraint;
  update_columns?: Array<Agreement_Co_Owner_Agreement_Invoices_Update_Column>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_co_owner_agreement_invoices". */
export type Agreement_Co_Owner_Agreement_Invoices_Order_By = {
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Order_By>;
  agreement_invoice?: InputMaybe<Agreement_Invoice_Order_By>;
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_co_owner_agreement_invoices */
export type Agreement_Co_Owner_Agreement_Invoices_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_co_owner_agreement_invoices" */
export enum Agreement_Co_Owner_Agreement_Invoices_Select_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Set_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Stddev_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_stddev_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Stddev_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Stddev_Pop_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_stddev_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Stddev_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Stddev_Samp_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_stddev_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Stddev_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Co_Owner_Agreement_Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Co_Owner_Agreement_Invoices_Stream_Cursor_Value_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Sum_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_sum_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Sum_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_co_owner_agreement_invoices" */
export enum Agreement_Co_Owner_Agreement_Invoices_Update_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  Id = 'id'
}

export type Agreement_Co_Owner_Agreement_Invoices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Set_Input>;
  where: Agreement_Co_Owner_Agreement_Invoices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Var_Pop_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_var_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Var_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Var_Samp_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_var_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Var_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Co_Owner_Agreement_Invoices_Variance_Fields = {
  __typename?: 'agreement_co_owner_agreement_invoices_variance_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_co_owner_agreement_invoices" */
export type Agreement_Co_Owner_Agreement_Invoices_Variance_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots = {
  __typename?: 'agreement_co_owner_agreement_plots';
  /** An object relationship */
  agreement_co_owner_plot: Agreement_Co_Owner;
  /** An object relationship */
  agreement_plot: Agreement_Plot;
  agreementcoowner_id: Scalars['Int'];
  agreementplot_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Aggregate = {
  __typename?: 'agreement_co_owner_agreement_plots_aggregate';
  aggregate?: Maybe<Agreement_Co_Owner_Agreement_Plots_Aggregate_Fields>;
  nodes: Array<Agreement_Co_Owner_Agreement_Plots>;
};

/** aggregate fields of "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Aggregate_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_aggregate_fields';
  avg?: Maybe<Agreement_Co_Owner_Agreement_Plots_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Co_Owner_Agreement_Plots_Max_Fields>;
  min?: Maybe<Agreement_Co_Owner_Agreement_Plots_Min_Fields>;
  stddev?: Maybe<Agreement_Co_Owner_Agreement_Plots_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Co_Owner_Agreement_Plots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Co_Owner_Agreement_Plots_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Co_Owner_Agreement_Plots_Sum_Fields>;
  var_pop?: Maybe<Agreement_Co_Owner_Agreement_Plots_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Co_Owner_Agreement_Plots_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Co_Owner_Agreement_Plots_Variance_Fields>;
};


/** aggregate fields of "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Max_Order_By>;
  min?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Co_Owner_Agreement_Plots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreement_Co_Owner_Agreement_Plots_Avg_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_avg_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementplot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Avg_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_co_owner_agreement_plots". All fields are combined with a logical 'AND'. */
export type Agreement_Co_Owner_Agreement_Plots_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>>;
  agreement_co_owner_plot?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
  agreement_plot?: InputMaybe<Agreement_Plot_Bool_Exp>;
  agreementcoowner_id?: InputMaybe<Int_Comparison_Exp>;
  agreementplot_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_co_owner_agreement_plots" */
export enum Agreement_Co_Owner_Agreement_Plots_Constraint {
  /** unique or primary key constraint on columns "agreementplot_id", "agreementcoowner_id" */
  AgreementCoOwnerAgreeAgreementcoownerIdAgre_1df2a26bUniq = 'agreement_co_owner_agree_agreementcoowner_id_agre_1df2a26b_uniq',
  /** unique or primary key constraint on columns "id" */
  AgreementCoOwnerAgreementPlotsPkey = 'agreement_co_owner_agreement_plots_pkey'
}

/** input type for incrementing numeric columns in table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Inc_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Insert_Input = {
  agreement_co_owner_plot?: InputMaybe<Agreement_Co_Owner_Obj_Rel_Insert_Input>;
  agreement_plot?: InputMaybe<Agreement_Plot_Obj_Rel_Insert_Input>;
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agreement_Co_Owner_Agreement_Plots_Max_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_max_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  agreementplot_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Max_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Co_Owner_Agreement_Plots_Min_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_min_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  agreementplot_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Min_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Mutation_Response = {
  __typename?: 'agreement_co_owner_agreement_plots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Co_Owner_Agreement_Plots>;
};

/** on_conflict condition type for table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_On_Conflict = {
  constraint: Agreement_Co_Owner_Agreement_Plots_Constraint;
  update_columns?: Array<Agreement_Co_Owner_Agreement_Plots_Update_Column>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_co_owner_agreement_plots". */
export type Agreement_Co_Owner_Agreement_Plots_Order_By = {
  agreement_co_owner_plot?: InputMaybe<Agreement_Co_Owner_Order_By>;
  agreement_plot?: InputMaybe<Agreement_Plot_Order_By>;
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_co_owner_agreement_plots */
export type Agreement_Co_Owner_Agreement_Plots_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_co_owner_agreement_plots" */
export enum Agreement_Co_Owner_Agreement_Plots_Select_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  AgreementplotId = 'agreementplot_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Set_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agreement_Co_Owner_Agreement_Plots_Stddev_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_stddev_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementplot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Stddev_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Co_Owner_Agreement_Plots_Stddev_Pop_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_stddev_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementplot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Stddev_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Co_Owner_Agreement_Plots_Stddev_Samp_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_stddev_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementplot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Stddev_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Co_Owner_Agreement_Plots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Co_Owner_Agreement_Plots_Stream_Cursor_Value_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agreement_Co_Owner_Agreement_Plots_Sum_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_sum_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  agreementplot_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Sum_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_co_owner_agreement_plots" */
export enum Agreement_Co_Owner_Agreement_Plots_Update_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  AgreementplotId = 'agreementplot_id',
  /** column name */
  Id = 'id'
}

export type Agreement_Co_Owner_Agreement_Plots_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Set_Input>;
  where: Agreement_Co_Owner_Agreement_Plots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Co_Owner_Agreement_Plots_Var_Pop_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_var_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementplot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Var_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Co_Owner_Agreement_Plots_Var_Samp_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_var_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementplot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Var_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Co_Owner_Agreement_Plots_Variance_Fields = {
  __typename?: 'agreement_co_owner_agreement_plots_variance_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  agreementplot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_co_owner_agreement_plots" */
export type Agreement_Co_Owner_Agreement_Plots_Variance_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Agreement_Co_Owner_Avg_Fields = {
  __typename?: 'agreement_co_owner_avg_fields';
  co_owner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "agreement_co_owner". All fields are combined with a logical 'AND'. */
export type Agreement_Co_Owner_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Co_Owner_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Co_Owner_Bool_Exp>>;
  agreement_co_owner?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
  agreement_invoices?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
  agreement_plots?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
  agreement_year?: InputMaybe<String_Comparison_Exp>;
  co_owner?: InputMaybe<Base_User_Bool_Exp>;
  co_owner_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  legal_agreements?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_co_owner" */
export enum Agreement_Co_Owner_Constraint {
  /** unique or primary key constraint on columns "codename" */
  AgreementCoOwnerCodenameKey = 'agreement_co_owner_codename_key',
  /** unique or primary key constraint on columns "id" */
  AgreementCoOwnerPkey = 'agreement_co_owner_pkey'
}

/** input type for incrementing numeric columns in table "agreement_co_owner" */
export type Agreement_Co_Owner_Inc_Input = {
  co_owner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_co_owner" */
export type Agreement_Co_Owner_Insert_Input = {
  agreement_co_owner?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Arr_Rel_Insert_Input>;
  agreement_invoices?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Arr_Rel_Insert_Input>;
  agreement_plots?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Arr_Rel_Insert_Input>;
  agreement_year?: InputMaybe<Scalars['String']>;
  co_owner?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  co_owner_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  legal_agreements?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement = {
  __typename?: 'agreement_co_owner_legal_agreement';
  /** An object relationship */
  agreement_co_owner: Agreement_Co_Owner;
  agreementcoowner_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  legal_agreement: Legal_Agreement;
  legalagreement_id: Scalars['Int'];
};

/** aggregated selection of "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Aggregate = {
  __typename?: 'agreement_co_owner_legal_agreement_aggregate';
  aggregate?: Maybe<Agreement_Co_Owner_Legal_Agreement_Aggregate_Fields>;
  nodes: Array<Agreement_Co_Owner_Legal_Agreement>;
};

/** aggregate fields of "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Aggregate_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_aggregate_fields';
  avg?: Maybe<Agreement_Co_Owner_Legal_Agreement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Co_Owner_Legal_Agreement_Max_Fields>;
  min?: Maybe<Agreement_Co_Owner_Legal_Agreement_Min_Fields>;
  stddev?: Maybe<Agreement_Co_Owner_Legal_Agreement_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Co_Owner_Legal_Agreement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Co_Owner_Legal_Agreement_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Co_Owner_Legal_Agreement_Sum_Fields>;
  var_pop?: Maybe<Agreement_Co_Owner_Legal_Agreement_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Co_Owner_Legal_Agreement_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Co_Owner_Legal_Agreement_Variance_Fields>;
};


/** aggregate fields of "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Max_Order_By>;
  min?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Co_Owner_Legal_Agreement_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreement_Co_Owner_Legal_Agreement_Avg_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_avg_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legalagreement_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Avg_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_co_owner_legal_agreement". All fields are combined with a logical 'AND'. */
export type Agreement_Co_Owner_Legal_Agreement_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>>;
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
  agreementcoowner_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  legal_agreement?: InputMaybe<Legal_Agreement_Bool_Exp>;
  legalagreement_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_co_owner_legal_agreement" */
export enum Agreement_Co_Owner_Legal_Agreement_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgreementCoOwnerLegalAgreementPkey = 'agreement_co_owner_legal_agreement_pkey',
  /** unique or primary key constraint on columns "agreementcoowner_id", "legalagreement_id" */
  AgreementCoOwnerLegalAgreementcoownerIdLega_8fdb91a3Uniq = 'agreement_co_owner_legal_agreementcoowner_id_lega_8fdb91a3_uniq'
}

/** input type for incrementing numeric columns in table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Inc_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  legalagreement_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Insert_Input = {
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Obj_Rel_Insert_Input>;
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  legal_agreement?: InputMaybe<Legal_Agreement_Obj_Rel_Insert_Input>;
  legalagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agreement_Co_Owner_Legal_Agreement_Max_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_max_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  legalagreement_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Max_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Co_Owner_Legal_Agreement_Min_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_min_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  legalagreement_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Min_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Mutation_Response = {
  __typename?: 'agreement_co_owner_legal_agreement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Co_Owner_Legal_Agreement>;
};

/** on_conflict condition type for table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_On_Conflict = {
  constraint: Agreement_Co_Owner_Legal_Agreement_Constraint;
  update_columns?: Array<Agreement_Co_Owner_Legal_Agreement_Update_Column>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_co_owner_legal_agreement". */
export type Agreement_Co_Owner_Legal_Agreement_Order_By = {
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Order_By>;
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement?: InputMaybe<Legal_Agreement_Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_co_owner_legal_agreement */
export type Agreement_Co_Owner_Legal_Agreement_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_co_owner_legal_agreement" */
export enum Agreement_Co_Owner_Legal_Agreement_Select_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  Id = 'id',
  /** column name */
  LegalagreementId = 'legalagreement_id'
}

/** input type for updating data in table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Set_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  legalagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agreement_Co_Owner_Legal_Agreement_Stddev_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_stddev_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legalagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Stddev_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Co_Owner_Legal_Agreement_Stddev_Pop_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_stddev_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legalagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Stddev_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Co_Owner_Legal_Agreement_Stddev_Samp_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_stddev_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legalagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Stddev_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Co_Owner_Legal_Agreement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Co_Owner_Legal_Agreement_Stream_Cursor_Value_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  legalagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agreement_Co_Owner_Legal_Agreement_Sum_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_sum_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  legalagreement_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Sum_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_co_owner_legal_agreement" */
export enum Agreement_Co_Owner_Legal_Agreement_Update_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  Id = 'id',
  /** column name */
  LegalagreementId = 'legalagreement_id'
}

export type Agreement_Co_Owner_Legal_Agreement_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Set_Input>;
  where: Agreement_Co_Owner_Legal_Agreement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Co_Owner_Legal_Agreement_Var_Pop_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_var_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legalagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Var_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Co_Owner_Legal_Agreement_Var_Samp_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_var_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legalagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Var_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Co_Owner_Legal_Agreement_Variance_Fields = {
  __typename?: 'agreement_co_owner_legal_agreement_variance_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legalagreement_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_co_owner_legal_agreement" */
export type Agreement_Co_Owner_Legal_Agreement_Variance_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legalagreement_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Agreement_Co_Owner_Max_Fields = {
  __typename?: 'agreement_co_owner_max_fields';
  agreement_year?: Maybe<Scalars['String']>;
  co_owner_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Agreement_Co_Owner_Min_Fields = {
  __typename?: 'agreement_co_owner_min_fields';
  agreement_year?: Maybe<Scalars['String']>;
  co_owner_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "agreement_co_owner" */
export type Agreement_Co_Owner_Mutation_Response = {
  __typename?: 'agreement_co_owner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Co_Owner>;
};

/** input type for inserting object relation for remote table "agreement_co_owner" */
export type Agreement_Co_Owner_Obj_Rel_Insert_Input = {
  data: Agreement_Co_Owner_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Co_Owner_On_Conflict>;
};

/** on_conflict condition type for table "agreement_co_owner" */
export type Agreement_Co_Owner_On_Conflict = {
  constraint: Agreement_Co_Owner_Constraint;
  update_columns?: Array<Agreement_Co_Owner_Update_Column>;
  where?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_co_owner". */
export type Agreement_Co_Owner_Order_By = {
  agreement_co_owner_aggregate?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Aggregate_Order_By>;
  agreement_invoices_aggregate?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Aggregate_Order_By>;
  agreement_plots_aggregate?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Aggregate_Order_By>;
  agreement_year?: InputMaybe<Order_By>;
  co_owner?: InputMaybe<Base_User_Order_By>;
  co_owner_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreements_aggregate?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_co_owner */
export type Agreement_Co_Owner_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_co_owner" */
export enum Agreement_Co_Owner_Select_Column {
  /** column name */
  AgreementYear = 'agreement_year',
  /** column name */
  CoOwnerId = 'co_owner_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "agreement_co_owner" */
export type Agreement_Co_Owner_Set_Input = {
  agreement_year?: InputMaybe<Scalars['String']>;
  co_owner_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Agreement_Co_Owner_Stddev_Fields = {
  __typename?: 'agreement_co_owner_stddev_fields';
  co_owner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Co_Owner_Stddev_Pop_Fields = {
  __typename?: 'agreement_co_owner_stddev_pop_fields';
  co_owner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Co_Owner_Stddev_Samp_Fields = {
  __typename?: 'agreement_co_owner_stddev_samp_fields';
  co_owner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "agreement_co_owner" */
export type Agreement_Co_Owner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Co_Owner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Co_Owner_Stream_Cursor_Value_Input = {
  agreement_year?: InputMaybe<Scalars['String']>;
  co_owner_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Agreement_Co_Owner_Sum_Fields = {
  __typename?: 'agreement_co_owner_sum_fields';
  co_owner_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "agreement_co_owner" */
export enum Agreement_Co_Owner_Update_Column {
  /** column name */
  AgreementYear = 'agreement_year',
  /** column name */
  CoOwnerId = 'co_owner_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Agreement_Co_Owner_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Co_Owner_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Co_Owner_Set_Input>;
  where: Agreement_Co_Owner_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Co_Owner_Var_Pop_Fields = {
  __typename?: 'agreement_co_owner_var_pop_fields';
  co_owner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Agreement_Co_Owner_Var_Samp_Fields = {
  __typename?: 'agreement_co_owner_var_samp_fields';
  co_owner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Agreement_Co_Owner_Variance_Fields = {
  __typename?: 'agreement_co_owner_variance_fields';
  co_owner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "agreement_invoice" */
export type Agreement_Invoice = {
  __typename?: 'agreement_invoice';
  /** An array relationship */
  agreement_invoice_items: Array<Agreement_Invoice_Agreement_Invoice_Items>;
  /** An aggregate relationship */
  agreement_invoice_items_aggregate: Agreement_Invoice_Agreement_Invoice_Items_Aggregate;
  /** An array relationship */
  agreement_invoices: Array<Agreement_Co_Owner_Agreement_Invoices>;
  /** An aggregate relationship */
  agreement_invoices_aggregate: Agreement_Co_Owner_Agreement_Invoices_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  credit: Scalars['Boolean'];
  due_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  guarantor_agreements: Array<Guarantor_Agreement_Agreement_Invoices>;
  /** An aggregate relationship */
  guarantor_agreements_aggregate: Guarantor_Agreement_Agreement_Invoices_Aggregate;
  id: Scalars['Int'];
  invoice?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  status: Scalars['String'];
  total_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  transactions: Array<Agreement_Invoice_Transaction>;
  /** An aggregate relationship */
  transactions_aggregate: Agreement_Invoice_Transaction_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceAgreement_Invoice_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceAgreement_Invoice_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceAgreement_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceAgreement_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceGuarantor_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceGuarantor_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


/** columns and relationships of "agreement_invoice" */
export type Agreement_InvoiceTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};

/** aggregated selection of "agreement_invoice" */
export type Agreement_Invoice_Aggregate = {
  __typename?: 'agreement_invoice_aggregate';
  aggregate?: Maybe<Agreement_Invoice_Aggregate_Fields>;
  nodes: Array<Agreement_Invoice>;
};

/** aggregate fields of "agreement_invoice" */
export type Agreement_Invoice_Aggregate_Fields = {
  __typename?: 'agreement_invoice_aggregate_fields';
  avg?: Maybe<Agreement_Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Invoice_Max_Fields>;
  min?: Maybe<Agreement_Invoice_Min_Fields>;
  stddev?: Maybe<Agreement_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Invoice_Sum_Fields>;
  var_pop?: Maybe<Agreement_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Invoice_Variance_Fields>;
};


/** aggregate fields of "agreement_invoice" */
export type Agreement_Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items = {
  __typename?: 'agreement_invoice_agreement_invoice_items';
  /** An object relationship */
  agreement_invoice_item: Agreement_Invoice_Item;
  agreementinvoice_id: Scalars['Int'];
  agreementinvoiceitem_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Aggregate = {
  __typename?: 'agreement_invoice_agreement_invoice_items_aggregate';
  aggregate?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Aggregate_Fields>;
  nodes: Array<Agreement_Invoice_Agreement_Invoice_Items>;
};

/** aggregate fields of "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Aggregate_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_aggregate_fields';
  avg?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Max_Fields>;
  min?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Min_Fields>;
  stddev?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Sum_Fields>;
  var_pop?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Variance_Fields>;
};


/** aggregate fields of "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Max_Order_By>;
  min?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Invoice_Agreement_Invoice_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Avg_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_avg_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Avg_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_invoice_agreement_invoice_items". All fields are combined with a logical 'AND'. */
export type Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>>;
  agreement_invoice_item?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
  agreementinvoice_id?: InputMaybe<Int_Comparison_Exp>;
  agreementinvoiceitem_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_invoice_agreement_invoice_items" */
export enum Agreement_Invoice_Agreement_Invoice_Items_Constraint {
  /** unique or primary key constraint on columns "agreementinvoiceitem_id", "agreementinvoice_id" */
  AgreementInvoiceAgreemAgreementinvoiceIdAgre_63c77400Uniq = 'agreement_invoice_agreem_agreementinvoice_id_agre_63c77400_uniq',
  /** unique or primary key constraint on columns "id" */
  AgreementInvoiceAgreementInvoiceItemsPkey = 'agreement_invoice_agreement_invoice_items_pkey'
}

/** input type for incrementing numeric columns in table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Inc_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  agreementinvoiceitem_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Insert_Input = {
  agreement_invoice_item?: InputMaybe<Agreement_Invoice_Item_Obj_Rel_Insert_Input>;
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  agreementinvoiceitem_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Max_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_max_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Max_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Min_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_min_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Min_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Mutation_Response = {
  __typename?: 'agreement_invoice_agreement_invoice_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Invoice_Agreement_Invoice_Items>;
};

/** on_conflict condition type for table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_On_Conflict = {
  constraint: Agreement_Invoice_Agreement_Invoice_Items_Constraint;
  update_columns?: Array<Agreement_Invoice_Agreement_Invoice_Items_Update_Column>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_invoice_agreement_invoice_items". */
export type Agreement_Invoice_Agreement_Invoice_Items_Order_By = {
  agreement_invoice_item?: InputMaybe<Agreement_Invoice_Item_Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_invoice_agreement_invoice_items */
export type Agreement_Invoice_Agreement_Invoice_Items_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_invoice_agreement_invoice_items" */
export enum Agreement_Invoice_Agreement_Invoice_Items_Select_Column {
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  AgreementinvoiceitemId = 'agreementinvoiceitem_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Set_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  agreementinvoiceitem_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Stddev_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_stddev_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Stddev_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Stddev_Pop_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_stddev_pop_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Stddev_Pop_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Stddev_Samp_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_stddev_samp_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Stddev_Samp_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Invoice_Agreement_Invoice_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Invoice_Agreement_Invoice_Items_Stream_Cursor_Value_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  agreementinvoiceitem_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Sum_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_sum_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Sum_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_invoice_agreement_invoice_items" */
export enum Agreement_Invoice_Agreement_Invoice_Items_Update_Column {
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  AgreementinvoiceitemId = 'agreementinvoiceitem_id',
  /** column name */
  Id = 'id'
}

export type Agreement_Invoice_Agreement_Invoice_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Set_Input>;
  where: Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Var_Pop_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_var_pop_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Var_Pop_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Var_Samp_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_var_samp_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Var_Samp_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Invoice_Agreement_Invoice_Items_Variance_Fields = {
  __typename?: 'agreement_invoice_agreement_invoice_items_variance_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  agreementinvoiceitem_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_invoice_agreement_invoice_items" */
export type Agreement_Invoice_Agreement_Invoice_Items_Variance_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  agreementinvoiceitem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Agreement_Invoice_Avg_Fields = {
  __typename?: 'agreement_invoice_avg_fields';
  due_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "agreement_invoice". All fields are combined with a logical 'AND'. */
export type Agreement_Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Invoice_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Invoice_Bool_Exp>>;
  agreement_invoice_items?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
  agreement_invoices?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit?: InputMaybe<Boolean_Comparison_Exp>;
  due_amount?: InputMaybe<Numeric_Comparison_Exp>;
  guarantor_agreements?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice?: InputMaybe<String_Comparison_Exp>;
  invoice_id?: InputMaybe<String_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  transactions?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_invoice" */
export enum Agreement_Invoice_Constraint {
  /** unique or primary key constraint on columns "codename" */
  AgreementInvoiceCodenameKey = 'agreement_invoice_codename_key',
  /** unique or primary key constraint on columns "invoice_id" */
  AgreementInvoiceInvoiceIdKey = 'agreement_invoice_invoice_id_key',
  /** unique or primary key constraint on columns "id" */
  AgreementInvoicePkey = 'agreement_invoice_pkey'
}

/** input type for incrementing numeric columns in table "agreement_invoice" */
export type Agreement_Invoice_Inc_Input = {
  due_amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "agreement_invoice" */
export type Agreement_Invoice_Insert_Input = {
  agreement_invoice_items?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Arr_Rel_Insert_Input>;
  agreement_invoices?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit?: InputMaybe<Scalars['Boolean']>;
  due_amount?: InputMaybe<Scalars['numeric']>;
  guarantor_agreements?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  invoice?: InputMaybe<Scalars['String']>;
  invoice_id?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  transactions?: InputMaybe<Agreement_Invoice_Transaction_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "agreement_invoice_item" */
export type Agreement_Invoice_Item = {
  __typename?: 'agreement_invoice_item';
  /** An object relationship */
  agreement_plot: Agreement_Plot;
  agreement_plot_id: Scalars['Int'];
  amount: Scalars['numeric'];
  area?: Maybe<Scalars['numeric']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  cultivation_type?: Maybe<Cultivation_Type>;
  cultivation_type_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  no_of_sticks: Scalars['Int'];
  plant_count?: Maybe<Scalars['Int']>;
  rate: Scalars['numeric'];
  remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  rootstock?: Maybe<Rootstock>;
  rootstock_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "agreement_invoice_item" */
export type Agreement_Invoice_Item_Aggregate = {
  __typename?: 'agreement_invoice_item_aggregate';
  aggregate?: Maybe<Agreement_Invoice_Item_Aggregate_Fields>;
  nodes: Array<Agreement_Invoice_Item>;
};

/** aggregate fields of "agreement_invoice_item" */
export type Agreement_Invoice_Item_Aggregate_Fields = {
  __typename?: 'agreement_invoice_item_aggregate_fields';
  avg?: Maybe<Agreement_Invoice_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Invoice_Item_Max_Fields>;
  min?: Maybe<Agreement_Invoice_Item_Min_Fields>;
  stddev?: Maybe<Agreement_Invoice_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Invoice_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Invoice_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Invoice_Item_Sum_Fields>;
  var_pop?: Maybe<Agreement_Invoice_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Invoice_Item_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Invoice_Item_Variance_Fields>;
};


/** aggregate fields of "agreement_invoice_item" */
export type Agreement_Invoice_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Invoice_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Invoice_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Invoice_Item_Max_Order_By>;
  min?: InputMaybe<Agreement_Invoice_Item_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Invoice_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Invoice_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Invoice_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Invoice_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Invoice_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Invoice_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Invoice_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Invoice_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Invoice_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreement_Invoice_Item_Avg_Fields = {
  __typename?: 'agreement_invoice_item_avg_fields';
  agreement_plot_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  no_of_sticks?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Avg_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_invoice_item". All fields are combined with a logical 'AND'. */
export type Agreement_Invoice_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Invoice_Item_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Invoice_Item_Bool_Exp>>;
  agreement_plot?: InputMaybe<Agreement_Plot_Bool_Exp>;
  agreement_plot_id?: InputMaybe<Int_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cultivation_type?: InputMaybe<Cultivation_Type_Bool_Exp>;
  cultivation_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  no_of_sticks?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  rootstock?: InputMaybe<Rootstock_Bool_Exp>;
  rootstock_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_invoice_item" */
export enum Agreement_Invoice_Item_Constraint {
  /** unique or primary key constraint on columns "codename" */
  AgreementInvoiceItemCodenameKey = 'agreement_invoice_item_codename_key',
  /** unique or primary key constraint on columns "id" */
  AgreementInvoiceItemPkey = 'agreement_invoice_item_pkey'
}

/** input type for incrementing numeric columns in table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Inc_Input = {
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['numeric']>;
  area?: InputMaybe<Scalars['numeric']>;
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_sticks?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Insert_Input = {
  agreement_plot?: InputMaybe<Agreement_Plot_Obj_Rel_Insert_Input>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['numeric']>;
  area?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cultivation_type?: InputMaybe<Cultivation_Type_Obj_Rel_Insert_Input>;
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_sticks?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  rootstock?: InputMaybe<Rootstock_Obj_Rel_Insert_Input>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Agreement_Invoice_Item_Max_Fields = {
  __typename?: 'agreement_invoice_item_max_fields';
  agreement_plot_id?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['numeric']>;
  area?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cultivation_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  no_of_sticks?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  rootstock_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Max_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Invoice_Item_Min_Fields = {
  __typename?: 'agreement_invoice_item_min_fields';
  agreement_plot_id?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['numeric']>;
  area?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cultivation_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  no_of_sticks?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  rootstock_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Min_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Mutation_Response = {
  __typename?: 'agreement_invoice_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Invoice_Item>;
};

/** input type for inserting object relation for remote table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Obj_Rel_Insert_Input = {
  data: Agreement_Invoice_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Invoice_Item_On_Conflict>;
};

/** on_conflict condition type for table "agreement_invoice_item" */
export type Agreement_Invoice_Item_On_Conflict = {
  constraint: Agreement_Invoice_Item_Constraint;
  update_columns?: Array<Agreement_Invoice_Item_Update_Column>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_invoice_item". */
export type Agreement_Invoice_Item_Order_By = {
  agreement_plot?: InputMaybe<Agreement_Plot_Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  cultivation_type?: InputMaybe<Cultivation_Type_Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  rootstock?: InputMaybe<Rootstock_Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_invoice_item */
export type Agreement_Invoice_Item_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_invoice_item" */
export enum Agreement_Invoice_Item_Select_Column {
  /** column name */
  AgreementPlotId = 'agreement_plot_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  Area = 'area',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CultivationTypeId = 'cultivation_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoOfSticks = 'no_of_sticks',
  /** column name */
  PlantCount = 'plant_count',
  /** column name */
  Rate = 'rate',
  /** column name */
  Remark = 'remark',
  /** column name */
  RootstockId = 'rootstock_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Set_Input = {
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['numeric']>;
  area?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_sticks?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Agreement_Invoice_Item_Stddev_Fields = {
  __typename?: 'agreement_invoice_item_stddev_fields';
  agreement_plot_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  no_of_sticks?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Stddev_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Invoice_Item_Stddev_Pop_Fields = {
  __typename?: 'agreement_invoice_item_stddev_pop_fields';
  agreement_plot_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  no_of_sticks?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Stddev_Pop_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Invoice_Item_Stddev_Samp_Fields = {
  __typename?: 'agreement_invoice_item_stddev_samp_fields';
  agreement_plot_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  no_of_sticks?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Stddev_Samp_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Invoice_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Invoice_Item_Stream_Cursor_Value_Input = {
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['numeric']>;
  area?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_sticks?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Agreement_Invoice_Item_Sum_Fields = {
  __typename?: 'agreement_invoice_item_sum_fields';
  agreement_plot_id?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['numeric']>;
  area?: Maybe<Scalars['numeric']>;
  cultivation_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  no_of_sticks?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['numeric']>;
  rootstock_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Sum_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_invoice_item" */
export enum Agreement_Invoice_Item_Update_Column {
  /** column name */
  AgreementPlotId = 'agreement_plot_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  Area = 'area',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CultivationTypeId = 'cultivation_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoOfSticks = 'no_of_sticks',
  /** column name */
  PlantCount = 'plant_count',
  /** column name */
  Rate = 'rate',
  /** column name */
  Remark = 'remark',
  /** column name */
  RootstockId = 'rootstock_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Agreement_Invoice_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Invoice_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Invoice_Item_Set_Input>;
  where: Agreement_Invoice_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Invoice_Item_Var_Pop_Fields = {
  __typename?: 'agreement_invoice_item_var_pop_fields';
  agreement_plot_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  no_of_sticks?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Var_Pop_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Invoice_Item_Var_Samp_Fields = {
  __typename?: 'agreement_invoice_item_var_samp_fields';
  agreement_plot_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  no_of_sticks?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Var_Samp_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Invoice_Item_Variance_Fields = {
  __typename?: 'agreement_invoice_item_variance_fields';
  agreement_plot_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  no_of_sticks?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_invoice_item" */
export type Agreement_Invoice_Item_Variance_Order_By = {
  agreement_plot_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  no_of_sticks?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Agreement_Invoice_Max_Fields = {
  __typename?: 'agreement_invoice_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  invoice?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Agreement_Invoice_Min_Fields = {
  __typename?: 'agreement_invoice_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  due_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  invoice?: Maybe<Scalars['String']>;
  invoice_id?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "agreement_invoice" */
export type Agreement_Invoice_Mutation_Response = {
  __typename?: 'agreement_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Invoice>;
};

/** input type for inserting object relation for remote table "agreement_invoice" */
export type Agreement_Invoice_Obj_Rel_Insert_Input = {
  data: Agreement_Invoice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Invoice_On_Conflict>;
};

/** on_conflict condition type for table "agreement_invoice" */
export type Agreement_Invoice_On_Conflict = {
  constraint: Agreement_Invoice_Constraint;
  update_columns?: Array<Agreement_Invoice_Update_Column>;
  where?: InputMaybe<Agreement_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_invoice". */
export type Agreement_Invoice_Order_By = {
  agreement_invoice_items_aggregate?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Aggregate_Order_By>;
  agreement_invoices_aggregate?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  due_amount?: InputMaybe<Order_By>;
  guarantor_agreements_aggregate?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  transactions_aggregate?: InputMaybe<Agreement_Invoice_Transaction_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_invoice */
export type Agreement_Invoice_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_invoice" */
export enum Agreement_Invoice_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credit = 'credit',
  /** column name */
  DueAmount = 'due_amount',
  /** column name */
  Id = 'id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "agreement_invoice" */
export type Agreement_Invoice_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit?: InputMaybe<Scalars['Boolean']>;
  due_amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice?: InputMaybe<Scalars['String']>;
  invoice_id?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Agreement_Invoice_Stddev_Fields = {
  __typename?: 'agreement_invoice_stddev_fields';
  due_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Invoice_Stddev_Pop_Fields = {
  __typename?: 'agreement_invoice_stddev_pop_fields';
  due_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Invoice_Stddev_Samp_Fields = {
  __typename?: 'agreement_invoice_stddev_samp_fields';
  due_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "agreement_invoice" */
export type Agreement_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Invoice_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit?: InputMaybe<Scalars['Boolean']>;
  due_amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice?: InputMaybe<Scalars['String']>;
  invoice_id?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Agreement_Invoice_Sum_Fields = {
  __typename?: 'agreement_invoice_sum_fields';
  due_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction = {
  __typename?: 'agreement_invoice_transaction';
  /** An object relationship */
  agreement_invoice: Agreement_Invoice;
  agreementinvoice_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  transaction: Transactions;
  transaction_id: Scalars['Int'];
};

/** aggregated selection of "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Aggregate = {
  __typename?: 'agreement_invoice_transaction_aggregate';
  aggregate?: Maybe<Agreement_Invoice_Transaction_Aggregate_Fields>;
  nodes: Array<Agreement_Invoice_Transaction>;
};

/** aggregate fields of "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Aggregate_Fields = {
  __typename?: 'agreement_invoice_transaction_aggregate_fields';
  avg?: Maybe<Agreement_Invoice_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Invoice_Transaction_Max_Fields>;
  min?: Maybe<Agreement_Invoice_Transaction_Min_Fields>;
  stddev?: Maybe<Agreement_Invoice_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Invoice_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Invoice_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Invoice_Transaction_Sum_Fields>;
  var_pop?: Maybe<Agreement_Invoice_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Invoice_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Invoice_Transaction_Variance_Fields>;
};


/** aggregate fields of "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Invoice_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Invoice_Transaction_Max_Order_By>;
  min?: InputMaybe<Agreement_Invoice_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Invoice_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Invoice_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Invoice_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Invoice_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Invoice_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Invoice_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Invoice_Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Invoice_Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Invoice_Transaction_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreement_Invoice_Transaction_Avg_Fields = {
  __typename?: 'agreement_invoice_transaction_avg_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Avg_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_invoice_transaction". All fields are combined with a logical 'AND'. */
export type Agreement_Invoice_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Invoice_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Invoice_Transaction_Bool_Exp>>;
  agreement_invoice?: InputMaybe<Agreement_Invoice_Bool_Exp>;
  agreementinvoice_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  transaction?: InputMaybe<Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_invoice_transaction" */
export enum Agreement_Invoice_Transaction_Constraint {
  /** unique or primary key constraint on columns "transaction_id", "agreementinvoice_id" */
  AgreementInvoiceTransaAgreementinvoiceIdTran_854c3572Uniq = 'agreement_invoice_transa_agreementinvoice_id_tran_854c3572_uniq',
  /** unique or primary key constraint on columns "id" */
  AgreementInvoiceTransactionPkey = 'agreement_invoice_transaction_pkey'
}

/** input type for incrementing numeric columns in table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Inc_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Insert_Input = {
  agreement_invoice?: InputMaybe<Agreement_Invoice_Obj_Rel_Insert_Input>;
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  transaction?: InputMaybe<Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Agreement_Invoice_Transaction_Max_Fields = {
  __typename?: 'agreement_invoice_transaction_max_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Max_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Invoice_Transaction_Min_Fields = {
  __typename?: 'agreement_invoice_transaction_min_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Min_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Mutation_Response = {
  __typename?: 'agreement_invoice_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Invoice_Transaction>;
};

/** on_conflict condition type for table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_On_Conflict = {
  constraint: Agreement_Invoice_Transaction_Constraint;
  update_columns?: Array<Agreement_Invoice_Transaction_Update_Column>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_invoice_transaction". */
export type Agreement_Invoice_Transaction_Order_By = {
  agreement_invoice?: InputMaybe<Agreement_Invoice_Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_invoice_transaction */
export type Agreement_Invoice_Transaction_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreement_invoice_transaction" */
export enum Agreement_Invoice_Transaction_Select_Column {
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  Id = 'id',
  /** column name */
  TransactionId = 'transaction_id'
}

/** input type for updating data in table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Set_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Agreement_Invoice_Transaction_Stddev_Fields = {
  __typename?: 'agreement_invoice_transaction_stddev_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Stddev_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Invoice_Transaction_Stddev_Pop_Fields = {
  __typename?: 'agreement_invoice_transaction_stddev_pop_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Stddev_Pop_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Invoice_Transaction_Stddev_Samp_Fields = {
  __typename?: 'agreement_invoice_transaction_stddev_samp_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Stddev_Samp_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Invoice_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Invoice_Transaction_Stream_Cursor_Value_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Agreement_Invoice_Transaction_Sum_Fields = {
  __typename?: 'agreement_invoice_transaction_sum_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Sum_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_invoice_transaction" */
export enum Agreement_Invoice_Transaction_Update_Column {
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  Id = 'id',
  /** column name */
  TransactionId = 'transaction_id'
}

export type Agreement_Invoice_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Invoice_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Invoice_Transaction_Set_Input>;
  where: Agreement_Invoice_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Invoice_Transaction_Var_Pop_Fields = {
  __typename?: 'agreement_invoice_transaction_var_pop_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Var_Pop_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Invoice_Transaction_Var_Samp_Fields = {
  __typename?: 'agreement_invoice_transaction_var_samp_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Var_Samp_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Invoice_Transaction_Variance_Fields = {
  __typename?: 'agreement_invoice_transaction_variance_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_invoice_transaction" */
export type Agreement_Invoice_Transaction_Variance_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_invoice" */
export enum Agreement_Invoice_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credit = 'credit',
  /** column name */
  DueAmount = 'due_amount',
  /** column name */
  Id = 'id',
  /** column name */
  Invoice = 'invoice',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Agreement_Invoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Invoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Invoice_Set_Input>;
  where: Agreement_Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Invoice_Var_Pop_Fields = {
  __typename?: 'agreement_invoice_var_pop_fields';
  due_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Agreement_Invoice_Var_Samp_Fields = {
  __typename?: 'agreement_invoice_var_samp_fields';
  due_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Agreement_Invoice_Variance_Fields = {
  __typename?: 'agreement_invoice_variance_fields';
  due_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "agreement_plot" */
export type Agreement_Plot = {
  __typename?: 'agreement_plot';
  /** An array relationship */
  agreement_invoice_items: Array<Agreement_Invoice_Item>;
  /** An aggregate relationship */
  agreement_invoice_items_aggregate: Agreement_Invoice_Item_Aggregate;
  /** An array relationship */
  agreement_plots: Array<Agreement_Co_Owner_Agreement_Plots>;
  /** An aggregate relationship */
  agreement_plots_aggregate: Agreement_Co_Owner_Agreement_Plots_Aggregate;
  amendment: Scalars['Boolean'];
  /** An array relationship */
  amendment_cases: Array<Amendment_Case>;
  /** An aggregate relationship */
  amendment_cases_aggregate: Amendment_Case_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  guarantor_agreements: Array<Guarantor_Agreement_Agreement_Plots>;
  /** An aggregate relationship */
  guarantor_agreements_aggregate: Guarantor_Agreement_Agreement_Plots_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_leased: Scalars['Boolean'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  plot: Plot;
  plot_id: Scalars['Int'];
  send_to_breeder: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotAgreement_Invoice_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Item_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotAgreement_Invoice_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Item_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotAgreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotAgreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotAmendment_CasesArgs = {
  distinct_on?: InputMaybe<Array<Amendment_Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Amendment_Case_Order_By>>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotAmendment_Cases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Amendment_Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Amendment_Case_Order_By>>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotGuarantor_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotGuarantor_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "agreement_plot" */
export type Agreement_PlotMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "agreement_plot" */
export type Agreement_Plot_Aggregate = {
  __typename?: 'agreement_plot_aggregate';
  aggregate?: Maybe<Agreement_Plot_Aggregate_Fields>;
  nodes: Array<Agreement_Plot>;
};

/** aggregate fields of "agreement_plot" */
export type Agreement_Plot_Aggregate_Fields = {
  __typename?: 'agreement_plot_aggregate_fields';
  avg?: Maybe<Agreement_Plot_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Plot_Max_Fields>;
  min?: Maybe<Agreement_Plot_Min_Fields>;
  stddev?: Maybe<Agreement_Plot_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Plot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Plot_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Plot_Sum_Fields>;
  var_pop?: Maybe<Agreement_Plot_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Plot_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Plot_Variance_Fields>;
};


/** aggregate fields of "agreement_plot" */
export type Agreement_Plot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Plot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_plot" */
export type Agreement_Plot_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Plot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Plot_Max_Order_By>;
  min?: InputMaybe<Agreement_Plot_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Plot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Plot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Plot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Plot_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Plot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Plot_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Plot_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Agreement_Plot_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "agreement_plot" */
export type Agreement_Plot_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Plot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Plot_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreement_Plot_Avg_Fields = {
  __typename?: 'agreement_plot_avg_fields';
  id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_plot" */
export type Agreement_Plot_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_plot". All fields are combined with a logical 'AND'. */
export type Agreement_Plot_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Plot_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Plot_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Plot_Bool_Exp>>;
  agreement_invoice_items?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
  agreement_plots?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
  amendment?: InputMaybe<Boolean_Comparison_Exp>;
  amendment_cases?: InputMaybe<Amendment_Case_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  guarantor_agreements?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_leased?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  send_to_breeder?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreement_plot" */
export enum Agreement_Plot_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PlotDetailCodenameKey = 'plot_detail_codename_key',
  /** unique or primary key constraint on columns "id" */
  PlotDetailPkey = 'plot_detail_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Agreement_Plot_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Agreement_Plot_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Agreement_Plot_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "agreement_plot" */
export type Agreement_Plot_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreement_plot" */
export type Agreement_Plot_Insert_Input = {
  agreement_invoice_items?: InputMaybe<Agreement_Invoice_Item_Arr_Rel_Insert_Input>;
  agreement_plots?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Arr_Rel_Insert_Input>;
  amendment?: InputMaybe<Scalars['Boolean']>;
  amendment_cases?: InputMaybe<Amendment_Case_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guarantor_agreements?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_leased?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  plot?: InputMaybe<Plot_Obj_Rel_Insert_Input>;
  plot_id?: InputMaybe<Scalars['Int']>;
  send_to_breeder?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Agreement_Plot_Max_Fields = {
  __typename?: 'agreement_plot_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "agreement_plot" */
export type Agreement_Plot_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Plot_Min_Fields = {
  __typename?: 'agreement_plot_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "agreement_plot" */
export type Agreement_Plot_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreement_plot" */
export type Agreement_Plot_Mutation_Response = {
  __typename?: 'agreement_plot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreement_Plot>;
};

/** input type for inserting object relation for remote table "agreement_plot" */
export type Agreement_Plot_Obj_Rel_Insert_Input = {
  data: Agreement_Plot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_Plot_On_Conflict>;
};

/** on_conflict condition type for table "agreement_plot" */
export type Agreement_Plot_On_Conflict = {
  constraint: Agreement_Plot_Constraint;
  update_columns?: Array<Agreement_Plot_Update_Column>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};

/** Ordering options when selecting data from "agreement_plot". */
export type Agreement_Plot_Order_By = {
  agreement_invoice_items_aggregate?: InputMaybe<Agreement_Invoice_Item_Aggregate_Order_By>;
  agreement_plots_aggregate?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Aggregate_Order_By>;
  amendment?: InputMaybe<Order_By>;
  amendment_cases_aggregate?: InputMaybe<Amendment_Case_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guarantor_agreements_aggregate?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_leased?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  plot?: InputMaybe<Plot_Order_By>;
  plot_id?: InputMaybe<Order_By>;
  send_to_breeder?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreement_plot */
export type Agreement_Plot_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Agreement_Plot_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "agreement_plot" */
export enum Agreement_Plot_Select_Column {
  /** column name */
  Amendment = 'amendment',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsLeased = 'is_leased',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  SendToBreeder = 'send_to_breeder',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "agreement_plot" */
export type Agreement_Plot_Set_Input = {
  amendment?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_leased?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  send_to_breeder?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Agreement_Plot_Stddev_Fields = {
  __typename?: 'agreement_plot_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_plot" */
export type Agreement_Plot_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Plot_Stddev_Pop_Fields = {
  __typename?: 'agreement_plot_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_plot" */
export type Agreement_Plot_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Plot_Stddev_Samp_Fields = {
  __typename?: 'agreement_plot_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_plot" */
export type Agreement_Plot_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_plot" */
export type Agreement_Plot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Plot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Plot_Stream_Cursor_Value_Input = {
  amendment?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_leased?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  send_to_breeder?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Agreement_Plot_Sum_Fields = {
  __typename?: 'agreement_plot_sum_fields';
  id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "agreement_plot" */
export type Agreement_Plot_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** update columns of table "agreement_plot" */
export enum Agreement_Plot_Update_Column {
  /** column name */
  Amendment = 'amendment',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsLeased = 'is_leased',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  SendToBreeder = 'send_to_breeder',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Agreement_Plot_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Agreement_Plot_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Agreement_Plot_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Agreement_Plot_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Agreement_Plot_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Plot_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Agreement_Plot_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Plot_Set_Input>;
  where: Agreement_Plot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreement_Plot_Var_Pop_Fields = {
  __typename?: 'agreement_plot_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_plot" */
export type Agreement_Plot_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Plot_Var_Samp_Fields = {
  __typename?: 'agreement_plot_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_plot" */
export type Agreement_Plot_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Plot_Variance_Fields = {
  __typename?: 'agreement_plot_variance_fields';
  id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_plot" */
export type Agreement_Plot_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "agreement_transaction" */
export type Agreement_Transaction = {
  __typename?: 'agreement_transaction';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  agreement_id: Scalars['bigint'];
  amount: Scalars['float8'];
  /** An array relationship */
  attachments: Array<Agreement_Transaction_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Agreement_Transaction_Attachments_Aggregate;
  bank_name: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['bigint'];
  ifsc_code: Scalars['String'];
  mode_of_payment: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  /** An object relationship */
  storage_location_agreement: Storage_Location_Agreement;
  transaction_date: Scalars['date'];
  transaction_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "agreement_transaction" */
export type Agreement_TransactionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
};


/** columns and relationships of "agreement_transaction" */
export type Agreement_TransactionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
};

/** aggregated selection of "agreement_transaction" */
export type Agreement_Transaction_Aggregate = {
  __typename?: 'agreement_transaction_aggregate';
  aggregate?: Maybe<Agreement_Transaction_Aggregate_Fields>;
  nodes: Array<Agreement_Transaction>;
};

/** aggregate fields of "agreement_transaction" */
export type Agreement_Transaction_Aggregate_Fields = {
  __typename?: 'agreement_transaction_aggregate_fields';
  avg?: Maybe<Agreement_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Transaction_Max_Fields>;
  min?: Maybe<Agreement_Transaction_Min_Fields>;
  stddev?: Maybe<Agreement_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Transaction_Sum_Fields>;
  var_pop?: Maybe<Agreement_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Transaction_Variance_Fields>;
};


/** aggregate fields of "agreement_transaction" */
export type Agreement_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_transaction" */
export type Agreement_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Transaction_Max_Order_By>;
  min?: InputMaybe<Agreement_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Transaction_Variance_Order_By>;
};

/** columns and relationships of "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments = {
  __typename?: 'agreement_transaction_attachments';
  agreementtransaction_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
};

/** aggregated selection of "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Aggregate = {
  __typename?: 'agreement_transaction_attachments_aggregate';
  aggregate?: Maybe<Agreement_Transaction_Attachments_Aggregate_Fields>;
  nodes: Array<Agreement_Transaction_Attachments>;
};

/** aggregate fields of "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Aggregate_Fields = {
  __typename?: 'agreement_transaction_attachments_aggregate_fields';
  avg?: Maybe<Agreement_Transaction_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreement_Transaction_Attachments_Max_Fields>;
  min?: Maybe<Agreement_Transaction_Attachments_Min_Fields>;
  stddev?: Maybe<Agreement_Transaction_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Agreement_Transaction_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreement_Transaction_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Agreement_Transaction_Attachments_Sum_Fields>;
  var_pop?: Maybe<Agreement_Transaction_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Agreement_Transaction_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Agreement_Transaction_Attachments_Variance_Fields>;
};


/** aggregate fields of "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Transaction_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Transaction_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreement_Transaction_Attachments_Max_Order_By>;
  min?: InputMaybe<Agreement_Transaction_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Agreement_Transaction_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreement_Transaction_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreement_Transaction_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreement_Transaction_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Agreement_Transaction_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreement_Transaction_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreement_Transaction_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Agreement_Transaction_Attachments_Avg_Fields = {
  __typename?: 'agreement_transaction_attachments_avg_fields';
  agreementtransaction_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Avg_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_transaction_attachments". All fields are combined with a logical 'AND'. */
export type Agreement_Transaction_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Transaction_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Transaction_Attachments_Bool_Exp>>;
  agreementtransaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Agreement_Transaction_Attachments_Max_Fields = {
  __typename?: 'agreement_transaction_attachments_max_fields';
  agreementtransaction_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Max_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Transaction_Attachments_Min_Fields = {
  __typename?: 'agreement_transaction_attachments_min_fields';
  agreementtransaction_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Min_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "agreement_transaction_attachments". */
export type Agreement_Transaction_Attachments_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** select columns of table "agreement_transaction_attachments" */
export enum Agreement_Transaction_Attachments_Select_Column {
  /** column name */
  AgreementtransactionId = 'agreementtransaction_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id'
}

/** aggregate stddev on columns */
export type Agreement_Transaction_Attachments_Stddev_Fields = {
  __typename?: 'agreement_transaction_attachments_stddev_fields';
  agreementtransaction_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Stddev_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Transaction_Attachments_Stddev_Pop_Fields = {
  __typename?: 'agreement_transaction_attachments_stddev_pop_fields';
  agreementtransaction_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Stddev_Pop_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Transaction_Attachments_Stddev_Samp_Fields = {
  __typename?: 'agreement_transaction_attachments_stddev_samp_fields';
  agreementtransaction_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Stddev_Samp_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Transaction_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Transaction_Attachments_Stream_Cursor_Value_Input = {
  agreementtransaction_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Agreement_Transaction_Attachments_Sum_Fields = {
  __typename?: 'agreement_transaction_attachments_sum_fields';
  agreementtransaction_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Sum_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Agreement_Transaction_Attachments_Var_Pop_Fields = {
  __typename?: 'agreement_transaction_attachments_var_pop_fields';
  agreementtransaction_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Var_Pop_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Transaction_Attachments_Var_Samp_Fields = {
  __typename?: 'agreement_transaction_attachments_var_samp_fields';
  agreementtransaction_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Var_Samp_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Transaction_Attachments_Variance_Fields = {
  __typename?: 'agreement_transaction_attachments_variance_fields';
  agreementtransaction_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_transaction_attachments" */
export type Agreement_Transaction_Attachments_Variance_Order_By = {
  agreementtransaction_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Agreement_Transaction_Avg_Fields = {
  __typename?: 'agreement_transaction_avg_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Avg_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreement_transaction". All fields are combined with a logical 'AND'. */
export type Agreement_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Agreement_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Agreement_Transaction_Bool_Exp>>;
  account_holder_name?: InputMaybe<String_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  agreement_id?: InputMaybe<Bigint_Comparison_Exp>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  attachments?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
  bank_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ifsc_code?: InputMaybe<String_Comparison_Exp>;
  mode_of_payment?: InputMaybe<String_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  storage_location_agreement?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
  transaction_date?: InputMaybe<Date_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Agreement_Transaction_Max_Fields = {
  __typename?: 'agreement_transaction_max_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  agreement_id?: Maybe<Scalars['bigint']>;
  amount?: Maybe<Scalars['float8']>;
  bank_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  ifsc_code?: Maybe<Scalars['String']>;
  mode_of_payment?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Max_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  mode_of_payment?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreement_Transaction_Min_Fields = {
  __typename?: 'agreement_transaction_min_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  agreement_id?: Maybe<Scalars['bigint']>;
  amount?: Maybe<Scalars['float8']>;
  bank_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  ifsc_code?: Maybe<Scalars['String']>;
  mode_of_payment?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Min_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  mode_of_payment?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "agreement_transaction". */
export type Agreement_Transaction_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Agreement_Transaction_Attachments_Aggregate_Order_By>;
  bank_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  mode_of_payment?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  storage_location_agreement?: InputMaybe<Storage_Location_Agreement_Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "agreement_transaction" */
export enum Agreement_Transaction_Select_Column {
  /** column name */
  AccountHolderName = 'account_holder_name',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  ModeOfPayment = 'mode_of_payment',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** aggregate stddev on columns */
export type Agreement_Transaction_Stddev_Fields = {
  __typename?: 'agreement_transaction_stddev_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Stddev_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreement_Transaction_Stddev_Pop_Fields = {
  __typename?: 'agreement_transaction_stddev_pop_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Stddev_Pop_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreement_Transaction_Stddev_Samp_Fields = {
  __typename?: 'agreement_transaction_stddev_samp_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Stddev_Samp_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreement_transaction" */
export type Agreement_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreement_Transaction_Stream_Cursor_Value_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  agreement_id?: InputMaybe<Scalars['bigint']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  mode_of_payment?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<Scalars['String']>;
  transaction_date?: InputMaybe<Scalars['date']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Agreement_Transaction_Sum_Fields = {
  __typename?: 'agreement_transaction_sum_fields';
  agreement_id?: Maybe<Scalars['bigint']>;
  amount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Sum_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Agreement_Transaction_Var_Pop_Fields = {
  __typename?: 'agreement_transaction_var_pop_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Var_Pop_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreement_Transaction_Var_Samp_Fields = {
  __typename?: 'agreement_transaction_var_samp_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Var_Samp_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreement_Transaction_Variance_Fields = {
  __typename?: 'agreement_transaction_variance_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreement_transaction" */
export type Agreement_Transaction_Variance_Order_By = {
  agreement_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "amendment_case" */
export type Amendment_Case = {
  __typename?: 'amendment_case';
  agreement_doc_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  agreement_plot: Agreement_Plot;
  agreement_plot_id: Scalars['Int'];
  change_message?: Maybe<Scalars['String']>;
  change_object?: Maybe<Scalars['jsonb']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  legal_agreement?: Maybe<Legal_Agreement>;
  metadata?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "amendment_case" */
export type Amendment_CaseChange_ObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "amendment_case" */
export type Amendment_CaseMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "amendment_case" */
export type Amendment_Case_Aggregate = {
  __typename?: 'amendment_case_aggregate';
  aggregate?: Maybe<Amendment_Case_Aggregate_Fields>;
  nodes: Array<Amendment_Case>;
};

/** aggregate fields of "amendment_case" */
export type Amendment_Case_Aggregate_Fields = {
  __typename?: 'amendment_case_aggregate_fields';
  avg?: Maybe<Amendment_Case_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Amendment_Case_Max_Fields>;
  min?: Maybe<Amendment_Case_Min_Fields>;
  stddev?: Maybe<Amendment_Case_Stddev_Fields>;
  stddev_pop?: Maybe<Amendment_Case_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Amendment_Case_Stddev_Samp_Fields>;
  sum?: Maybe<Amendment_Case_Sum_Fields>;
  var_pop?: Maybe<Amendment_Case_Var_Pop_Fields>;
  var_samp?: Maybe<Amendment_Case_Var_Samp_Fields>;
  variance?: Maybe<Amendment_Case_Variance_Fields>;
};


/** aggregate fields of "amendment_case" */
export type Amendment_Case_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Amendment_Case_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "amendment_case" */
export type Amendment_Case_Aggregate_Order_By = {
  avg?: InputMaybe<Amendment_Case_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Amendment_Case_Max_Order_By>;
  min?: InputMaybe<Amendment_Case_Min_Order_By>;
  stddev?: InputMaybe<Amendment_Case_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Amendment_Case_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Amendment_Case_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Amendment_Case_Sum_Order_By>;
  var_pop?: InputMaybe<Amendment_Case_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Amendment_Case_Var_Samp_Order_By>;
  variance?: InputMaybe<Amendment_Case_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Amendment_Case_Append_Input = {
  change_object?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "amendment_case" */
export type Amendment_Case_Arr_Rel_Insert_Input = {
  data: Array<Amendment_Case_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Amendment_Case_On_Conflict>;
};

/** aggregate avg on columns */
export type Amendment_Case_Avg_Fields = {
  __typename?: 'amendment_case_avg_fields';
  agreement_doc_id?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "amendment_case" */
export type Amendment_Case_Avg_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "amendment_case". All fields are combined with a logical 'AND'. */
export type Amendment_Case_Bool_Exp = {
  _and?: InputMaybe<Array<Amendment_Case_Bool_Exp>>;
  _not?: InputMaybe<Amendment_Case_Bool_Exp>;
  _or?: InputMaybe<Array<Amendment_Case_Bool_Exp>>;
  agreement_doc_id?: InputMaybe<Int_Comparison_Exp>;
  agreement_plot?: InputMaybe<Agreement_Plot_Bool_Exp>;
  agreement_plot_id?: InputMaybe<Int_Comparison_Exp>;
  change_message?: InputMaybe<String_Comparison_Exp>;
  change_object?: InputMaybe<Jsonb_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  legal_agreement?: InputMaybe<Legal_Agreement_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "amendment_case" */
export enum Amendment_Case_Constraint {
  /** unique or primary key constraint on columns "codename" */
  AmendmentCaseCodenameKey = 'amendment_case_codename_key',
  /** unique or primary key constraint on columns "id" */
  AmendmentCasePkey = 'amendment_case_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Amendment_Case_Delete_At_Path_Input = {
  change_object?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Amendment_Case_Delete_Elem_Input = {
  change_object?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Amendment_Case_Delete_Key_Input = {
  change_object?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "amendment_case" */
export type Amendment_Case_Inc_Input = {
  agreement_doc_id?: InputMaybe<Scalars['Int']>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "amendment_case" */
export type Amendment_Case_Insert_Input = {
  agreement_doc_id?: InputMaybe<Scalars['Int']>;
  agreement_plot?: InputMaybe<Agreement_Plot_Obj_Rel_Insert_Input>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  legal_agreement?: InputMaybe<Legal_Agreement_Obj_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Amendment_Case_Max_Fields = {
  __typename?: 'amendment_case_max_fields';
  agreement_doc_id?: Maybe<Scalars['Int']>;
  agreement_plot_id?: Maybe<Scalars['Int']>;
  change_message?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "amendment_case" */
export type Amendment_Case_Max_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Amendment_Case_Min_Fields = {
  __typename?: 'amendment_case_min_fields';
  agreement_doc_id?: Maybe<Scalars['Int']>;
  agreement_plot_id?: Maybe<Scalars['Int']>;
  change_message?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "amendment_case" */
export type Amendment_Case_Min_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "amendment_case" */
export type Amendment_Case_Mutation_Response = {
  __typename?: 'amendment_case_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Amendment_Case>;
};

/** on_conflict condition type for table "amendment_case" */
export type Amendment_Case_On_Conflict = {
  constraint: Amendment_Case_Constraint;
  update_columns?: Array<Amendment_Case_Update_Column>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};

/** Ordering options when selecting data from "amendment_case". */
export type Amendment_Case_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot?: InputMaybe<Agreement_Plot_Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_object?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement?: InputMaybe<Legal_Agreement_Order_By>;
  metadata?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: amendment_case */
export type Amendment_Case_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Amendment_Case_Prepend_Input = {
  change_object?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "amendment_case" */
export enum Amendment_Case_Select_Column {
  /** column name */
  AgreementDocId = 'agreement_doc_id',
  /** column name */
  AgreementPlotId = 'agreement_plot_id',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "amendment_case" */
export type Amendment_Case_Set_Input = {
  agreement_doc_id?: InputMaybe<Scalars['Int']>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Amendment_Case_Stddev_Fields = {
  __typename?: 'amendment_case_stddev_fields';
  agreement_doc_id?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "amendment_case" */
export type Amendment_Case_Stddev_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Amendment_Case_Stddev_Pop_Fields = {
  __typename?: 'amendment_case_stddev_pop_fields';
  agreement_doc_id?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "amendment_case" */
export type Amendment_Case_Stddev_Pop_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Amendment_Case_Stddev_Samp_Fields = {
  __typename?: 'amendment_case_stddev_samp_fields';
  agreement_doc_id?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "amendment_case" */
export type Amendment_Case_Stddev_Samp_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "amendment_case" */
export type Amendment_Case_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Amendment_Case_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Amendment_Case_Stream_Cursor_Value_Input = {
  agreement_doc_id?: InputMaybe<Scalars['Int']>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Amendment_Case_Sum_Fields = {
  __typename?: 'amendment_case_sum_fields';
  agreement_doc_id?: Maybe<Scalars['Int']>;
  agreement_plot_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "amendment_case" */
export type Amendment_Case_Sum_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "amendment_case" */
export enum Amendment_Case_Update_Column {
  /** column name */
  AgreementDocId = 'agreement_doc_id',
  /** column name */
  AgreementPlotId = 'agreement_plot_id',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Amendment_Case_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Amendment_Case_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Amendment_Case_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Amendment_Case_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Amendment_Case_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Amendment_Case_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Amendment_Case_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Amendment_Case_Set_Input>;
  where: Amendment_Case_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Amendment_Case_Var_Pop_Fields = {
  __typename?: 'amendment_case_var_pop_fields';
  agreement_doc_id?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "amendment_case" */
export type Amendment_Case_Var_Pop_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Amendment_Case_Var_Samp_Fields = {
  __typename?: 'amendment_case_var_samp_fields';
  agreement_doc_id?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "amendment_case" */
export type Amendment_Case_Var_Samp_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Amendment_Case_Variance_Fields = {
  __typename?: 'amendment_case_variance_fields';
  agreement_doc_id?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "amendment_case" */
export type Amendment_Case_Variance_Order_By = {
  agreement_doc_id?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth_group" */
export type Auth_Group = {
  __typename?: 'auth_group';
  /** An array relationship */
  base_users: Array<Base_User_Groups>;
  /** An aggregate relationship */
  base_users_aggregate: Base_User_Groups_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** columns and relationships of "auth_group" */
export type Auth_GroupBase_UsersArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


/** columns and relationships of "auth_group" */
export type Auth_GroupBase_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};

/** aggregated selection of "auth_group" */
export type Auth_Group_Aggregate = {
  __typename?: 'auth_group_aggregate';
  aggregate?: Maybe<Auth_Group_Aggregate_Fields>;
  nodes: Array<Auth_Group>;
};

/** aggregate fields of "auth_group" */
export type Auth_Group_Aggregate_Fields = {
  __typename?: 'auth_group_aggregate_fields';
  avg?: Maybe<Auth_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Auth_Group_Max_Fields>;
  min?: Maybe<Auth_Group_Min_Fields>;
  stddev?: Maybe<Auth_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Group_Sum_Fields>;
  var_pop?: Maybe<Auth_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Group_Var_Samp_Fields>;
  variance?: Maybe<Auth_Group_Variance_Fields>;
};


/** aggregate fields of "auth_group" */
export type Auth_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Auth_Group_Avg_Fields = {
  __typename?: 'auth_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth_group". All fields are combined with a logical 'AND'. */
export type Auth_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Bool_Exp>>;
  base_users?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth_group" */
export enum Auth_Group_Constraint {
  /** unique or primary key constraint on columns "name" */
  AuthGroupNameKey = 'auth_group_name_key',
  /** unique or primary key constraint on columns "id" */
  AuthGroupPkey = 'auth_group_pkey'
}

/** input type for incrementing numeric columns in table "auth_group" */
export type Auth_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth_group" */
export type Auth_Group_Insert_Input = {
  base_users?: InputMaybe<Base_User_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Auth_Group_Max_Fields = {
  __typename?: 'auth_group_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Auth_Group_Min_Fields = {
  __typename?: 'auth_group_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth_group" */
export type Auth_Group_Mutation_Response = {
  __typename?: 'auth_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group>;
};

/** input type for inserting object relation for remote table "auth_group" */
export type Auth_Group_Obj_Rel_Insert_Input = {
  data: Auth_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};

/** on_conflict condition type for table "auth_group" */
export type Auth_Group_On_Conflict = {
  constraint: Auth_Group_Constraint;
  update_columns?: Array<Auth_Group_Update_Column>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_group". */
export type Auth_Group_Order_By = {
  base_users_aggregate?: InputMaybe<Base_User_Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth_group_permissions" */
export type Auth_Group_Permissions = {
  __typename?: 'auth_group_permissions';
  /** An object relationship */
  group: Auth_Group;
  group_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  permission: Auth_Permission;
  permission_id: Scalars['Int'];
};

/** aggregated selection of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate = {
  __typename?: 'auth_group_permissions_aggregate';
  aggregate?: Maybe<Auth_Group_Permissions_Aggregate_Fields>;
  nodes: Array<Auth_Group_Permissions>;
};

/** aggregate fields of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_Fields = {
  __typename?: 'auth_group_permissions_aggregate_fields';
  avg?: Maybe<Auth_Group_Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Auth_Group_Permissions_Max_Fields>;
  min?: Maybe<Auth_Group_Permissions_Min_Fields>;
  stddev?: Maybe<Auth_Group_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Group_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Group_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Group_Permissions_Sum_Fields>;
  var_pop?: Maybe<Auth_Group_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Group_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Auth_Group_Permissions_Variance_Fields>;
};


/** aggregate fields of "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth_group_permissions" */
export type Auth_Group_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Auth_Group_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Group_Permissions_Max_Order_By>;
  min?: InputMaybe<Auth_Group_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Auth_Group_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Auth_Group_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Auth_Group_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Auth_Group_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Auth_Group_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Auth_Group_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Auth_Group_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth_group_permissions" */
export type Auth_Group_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Auth_Group_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Auth_Group_Permissions_Avg_Fields = {
  __typename?: 'auth_group_permissions_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth_group_permissions". All fields are combined with a logical 'AND'. */
export type Auth_Group_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Group_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Group_Permissions_Bool_Exp>>;
  group?: InputMaybe<Auth_Group_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  permission?: InputMaybe<Auth_Permission_Bool_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth_group_permissions" */
export enum Auth_Group_Permissions_Constraint {
  /** unique or primary key constraint on columns "group_id", "permission_id" */
  AuthGroupPermissionsGroupIdPermissionId_0cd325b0Uniq = 'auth_group_permissions_group_id_permission_id_0cd325b0_uniq',
  /** unique or primary key constraint on columns "id" */
  AuthGroupPermissionsPkey = 'auth_group_permissions_pkey'
}

/** input type for incrementing numeric columns in table "auth_group_permissions" */
export type Auth_Group_Permissions_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth_group_permissions" */
export type Auth_Group_Permissions_Insert_Input = {
  group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Auth_Permission_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Auth_Group_Permissions_Max_Fields = {
  __typename?: 'auth_group_permissions_max_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Max_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Group_Permissions_Min_Fields = {
  __typename?: 'auth_group_permissions_min_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Min_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth_group_permissions" */
export type Auth_Group_Permissions_Mutation_Response = {
  __typename?: 'auth_group_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Group_Permissions>;
};

/** on_conflict condition type for table "auth_group_permissions" */
export type Auth_Group_Permissions_On_Conflict = {
  constraint: Auth_Group_Permissions_Constraint;
  update_columns?: Array<Auth_Group_Permissions_Update_Column>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_group_permissions". */
export type Auth_Group_Permissions_Order_By = {
  group?: InputMaybe<Auth_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Auth_Permission_Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth_group_permissions */
export type Auth_Group_Permissions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "auth_group_permissions" */
export enum Auth_Group_Permissions_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

/** input type for updating data in table "auth_group_permissions" */
export type Auth_Group_Permissions_Set_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Auth_Group_Permissions_Stddev_Fields = {
  __typename?: 'auth_group_permissions_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Auth_Group_Permissions_Stddev_Pop_Fields = {
  __typename?: 'auth_group_permissions_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Auth_Group_Permissions_Stddev_Samp_Fields = {
  __typename?: 'auth_group_permissions_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "auth_group_permissions" */
export type Auth_Group_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Permissions_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Auth_Group_Permissions_Sum_Fields = {
  __typename?: 'auth_group_permissions_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** update columns of table "auth_group_permissions" */
export enum Auth_Group_Permissions_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

export type Auth_Group_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  where: Auth_Group_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Group_Permissions_Var_Pop_Fields = {
  __typename?: 'auth_group_permissions_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Auth_Group_Permissions_Var_Samp_Fields = {
  __typename?: 'auth_group_permissions_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Auth_Group_Permissions_Variance_Fields = {
  __typename?: 'auth_group_permissions_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "auth_group_permissions" */
export type Auth_Group_Permissions_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth_group */
export type Auth_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "auth_group" */
export enum Auth_Group_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth_group" */
export type Auth_Group_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Auth_Group_Stddev_Fields = {
  __typename?: 'auth_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Auth_Group_Stddev_Pop_Fields = {
  __typename?: 'auth_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Auth_Group_Stddev_Samp_Fields = {
  __typename?: 'auth_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "auth_group" */
export type Auth_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Group_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Auth_Group_Sum_Fields = {
  __typename?: 'auth_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth_group" */
export enum Auth_Group_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Auth_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Group_Set_Input>;
  where: Auth_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Group_Var_Pop_Fields = {
  __typename?: 'auth_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Auth_Group_Var_Samp_Fields = {
  __typename?: 'auth_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Auth_Group_Variance_Fields = {
  __typename?: 'auth_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "auth_permission" */
export type Auth_Permission = {
  __typename?: 'auth_permission';
  codename: Scalars['String'];
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  permitted_base_users: Array<Base_User_User_Permissions>;
  /** An aggregate relationship */
  permitted_base_users_aggregate: Base_User_User_Permissions_Aggregate;
  /** An array relationship */
  permitted_groups: Array<Auth_Group_Permissions>;
  /** An aggregate relationship */
  permitted_groups_aggregate: Auth_Group_Permissions_Aggregate;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_Base_UsersArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_Base_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


/** columns and relationships of "auth_permission" */
export type Auth_PermissionPermitted_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};

/** aggregated selection of "auth_permission" */
export type Auth_Permission_Aggregate = {
  __typename?: 'auth_permission_aggregate';
  aggregate?: Maybe<Auth_Permission_Aggregate_Fields>;
  nodes: Array<Auth_Permission>;
};

/** aggregate fields of "auth_permission" */
export type Auth_Permission_Aggregate_Fields = {
  __typename?: 'auth_permission_aggregate_fields';
  avg?: Maybe<Auth_Permission_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Auth_Permission_Max_Fields>;
  min?: Maybe<Auth_Permission_Min_Fields>;
  stddev?: Maybe<Auth_Permission_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Permission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Permission_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Permission_Sum_Fields>;
  var_pop?: Maybe<Auth_Permission_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Permission_Var_Samp_Fields>;
  variance?: Maybe<Auth_Permission_Variance_Fields>;
};


/** aggregate fields of "auth_permission" */
export type Auth_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Auth_Permission_Avg_Fields = {
  __typename?: 'auth_permission_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "auth_permission". All fields are combined with a logical 'AND'. */
export type Auth_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Permission_Bool_Exp>>;
  _not?: InputMaybe<Auth_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Permission_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permitted_base_users?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
  permitted_groups?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};

/** unique or primary key constraints on table "auth_permission" */
export enum Auth_Permission_Constraint {
  /** unique or primary key constraint on columns "codename", "content_type_id" */
  AuthPermissionContentTypeIdCodename_01ab375aUniq = 'auth_permission_content_type_id_codename_01ab375a_uniq',
  /** unique or primary key constraint on columns "id" */
  AuthPermissionPkey = 'auth_permission_pkey'
}

/** input type for incrementing numeric columns in table "auth_permission" */
export type Auth_Permission_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "auth_permission" */
export type Auth_Permission_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  permitted_base_users?: InputMaybe<Base_User_User_Permissions_Arr_Rel_Insert_Input>;
  permitted_groups?: InputMaybe<Auth_Group_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_Permission_Max_Fields = {
  __typename?: 'auth_permission_max_fields';
  codename?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Auth_Permission_Min_Fields = {
  __typename?: 'auth_permission_min_fields';
  codename?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth_permission" */
export type Auth_Permission_Mutation_Response = {
  __typename?: 'auth_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Permission>;
};

/** input type for inserting object relation for remote table "auth_permission" */
export type Auth_Permission_Obj_Rel_Insert_Input = {
  data: Auth_Permission_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};

/** on_conflict condition type for table "auth_permission" */
export type Auth_Permission_On_Conflict = {
  constraint: Auth_Permission_Constraint;
  update_columns?: Array<Auth_Permission_Update_Column>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "auth_permission". */
export type Auth_Permission_Order_By = {
  codename?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permitted_base_users_aggregate?: InputMaybe<Base_User_User_Permissions_Aggregate_Order_By>;
  permitted_groups_aggregate?: InputMaybe<Auth_Group_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: auth_permission */
export type Auth_Permission_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "auth_permission" */
export enum Auth_Permission_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "auth_permission" */
export type Auth_Permission_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Auth_Permission_Stddev_Fields = {
  __typename?: 'auth_permission_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Auth_Permission_Stddev_Pop_Fields = {
  __typename?: 'auth_permission_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Auth_Permission_Stddev_Samp_Fields = {
  __typename?: 'auth_permission_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "auth_permission" */
export type Auth_Permission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Permission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Permission_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Auth_Permission_Sum_Fields = {
  __typename?: 'auth_permission_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "auth_permission" */
export enum Auth_Permission_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Auth_Permission_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  where: Auth_Permission_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Permission_Var_Pop_Fields = {
  __typename?: 'auth_permission_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Auth_Permission_Var_Samp_Fields = {
  __typename?: 'auth_permission_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Auth_Permission_Variance_Fields = {
  __typename?: 'auth_permission_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "base_user" */
export type Base_User = {
  __typename?: 'base_user';
  /** An array relationship */
  address_book: Array<Base_User_Address_Book>;
  /** An aggregate relationship */
  address_book_aggregate: Base_User_Address_Book_Aggregate;
  /** An array relationship */
  agents: Array<Agent>;
  /** An aggregate relationship */
  agents_aggregate: Agent_Aggregate;
  block_remark?: Maybe<Scalars['String']>;
  /** An array relationship */
  companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  companies_aggregate: Base_User_Companies_Aggregate;
  /** An array relationship */
  companies_owned: Array<Company_Share_Holder>;
  /** An aggregate relationship */
  companies_owned_aggregate: Company_Share_Holder_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  current_address?: Maybe<Address>;
  current_address_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  current_department?: Maybe<Department>;
  current_department_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  data_consent?: Maybe<Media>;
  data_consent_id?: Maybe<Scalars['Int']>;
  date_joined: Scalars['timestamptz'];
  date_of_birth: Scalars['date'];
  /** An array relationship */
  departments: Array<Base_User_Departments>;
  /** An aggregate relationship */
  departments_aggregate: Base_User_Departments_Aggregate;
  /** An array relationship */
  devices: Array<Device>;
  /** An aggregate relationship */
  devices_aggregate: Device_Aggregate;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  education: Scalars['String'];
  email: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  /** External Reference ID Lookup */
  external_reference_id2?: Maybe<Scalars['String']>;
  /** An array relationship */
  farms: Array<Farm>;
  /** An aggregate relationship */
  farms_aggregate: Farm_Aggregate;
  father_mother_spouse_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  fields: Array<Field>;
  /** An aggregate relationship */
  fields_aggregate: Field_Aggregate;
  first_name: Scalars['String'];
  /** SQL Full Name of User */
  full_name?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  /** An array relationship */
  groups: Array<Base_User_Groups>;
  /** An aggregate relationship */
  groups_aggregate: Base_User_Groups_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_blocked?: Maybe<Scalars['Boolean']>;
  is_staff: Scalars['Boolean'];
  is_superuser: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  last_active_on_mobile?: Maybe<Scalars['timestamptz']>;
  last_active_on_web?: Maybe<Scalars['timestamptz']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name: Scalars['String'];
  metadata: Scalars['jsonb'];
  /** An array relationship */
  mutual_group_memberships: Array<Mutual_Group_Membership>;
  /** An aggregate relationship */
  mutual_group_memberships_aggregate: Mutual_Group_Membership_Aggregate;
  /** An array relationship */
  my_businesses: Array<Business>;
  /** An aggregate relationship */
  my_businesses_aggregate: Business_Aggregate;
  name_as_per_pan?: Maybe<Scalars['String']>;
  /** An object relationship */
  nationality?: Maybe<Nationality>;
  nationality_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  networks: Array<Base_User_Network>;
  /** An aggregate relationship */
  networks_aggregate: Base_User_Network_Aggregate;
  number: Scalars['String'];
  number_country_code: Scalars['String'];
  occupation?: Maybe<Scalars['String']>;
  /** An array relationship */
  org_team_user_bank_associations: Array<Org_Team_User_Bank_Association>;
  /** An aggregate relationship */
  org_team_user_bank_associations_aggregate: Org_Team_User_Bank_Association_Aggregate;
  /** An array relationship */
  org_team_user_document_associations: Array<Org_Team_User_Document_Association>;
  /** An aggregate relationship */
  org_team_user_document_associations_aggregate: Org_Team_User_Document_Association_Aggregate;
  password: Scalars['String'];
  payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  plot_crops: Array<Plot_Crop>;
  /** An aggregate relationship */
  plot_crops_aggregate: Plot_Crop_Aggregate;
  /** An array relationship */
  plots: Array<Plot>;
  /** An aggregate relationship */
  plots_aggregate: Plot_Aggregate;
  preferred_language: Scalars['String'];
  /** An object relationship */
  preferred_payment_option?: Maybe<Payment_Detail>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  reference_id: Scalars['String'];
  /** An array relationship */
  responses: Array<Survey_Responses>;
  /** An aggregate relationship */
  responses_aggregate: Survey_Responses_Aggregate;
  secondary_number: Scalars['String'];
  secondary_number_country_code: Scalars['String'];
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  /** An array relationship */
  shareholders: Array<Shareholders>;
  /** An aggregate relationship */
  shareholders_aggregate: Shareholders_Aggregate;
  status: Scalars['String'];
  /** An array relationship */
  status_snapshots: Array<Org_User_Group_Status_Snapshot>;
  /** An aggregate relationship */
  status_snapshots_aggregate: Org_User_Group_Status_Snapshot_Aggregate;
  subscription_type: Scalars['String'];
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
  /** An object relationship */
  verification_done_by?: Maybe<Base_User>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  village_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "base_user" */
export type Base_UserAddress_BookArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserAddress_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserAgents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserCompanies_OwnedArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserCompanies_Owned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDepartments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDevicesArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDevices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_user" */
export type Base_UserExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_user" */
export type Base_UserFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserGroupsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_user" */
export type Base_UserMutual_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserMutual_Group_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserMy_BusinessesArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserMy_Businesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserNetworksArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserOrg_Team_User_Bank_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserOrg_Team_User_Bank_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserOrg_Team_User_Document_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserOrg_Team_User_Document_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlot_CropsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlot_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlotsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPlots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_user" */
export type Base_UserResponsesArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserResponses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserShareholdersArgs = {
  distinct_on?: InputMaybe<Array<Shareholders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholders_Order_By>>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserShareholders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholders_Order_By>>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserStatus_SnapshotsArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Order_By>>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};


/** columns and relationships of "base_user" */
export type Base_UserStatus_Snapshots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Order_By>>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};

/** columns and relationships of "base_user_address_book" */
export type Base_User_Address_Book = {
  __typename?: 'base_user_address_book';
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_address_book" */
export type Base_User_Address_Book_Aggregate = {
  __typename?: 'base_user_address_book_aggregate';
  aggregate?: Maybe<Base_User_Address_Book_Aggregate_Fields>;
  nodes: Array<Base_User_Address_Book>;
};

/** aggregate fields of "base_user_address_book" */
export type Base_User_Address_Book_Aggregate_Fields = {
  __typename?: 'base_user_address_book_aggregate_fields';
  avg?: Maybe<Base_User_Address_Book_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Address_Book_Max_Fields>;
  min?: Maybe<Base_User_Address_Book_Min_Fields>;
  stddev?: Maybe<Base_User_Address_Book_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Address_Book_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Address_Book_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Address_Book_Sum_Fields>;
  var_pop?: Maybe<Base_User_Address_Book_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Address_Book_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Address_Book_Variance_Fields>;
};


/** aggregate fields of "base_user_address_book" */
export type Base_User_Address_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_address_book" */
export type Base_User_Address_Book_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Address_Book_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Address_Book_Max_Order_By>;
  min?: InputMaybe<Base_User_Address_Book_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Address_Book_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Address_Book_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Address_Book_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Address_Book_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Address_Book_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Address_Book_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Address_Book_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_address_book" */
export type Base_User_Address_Book_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Address_Book_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Address_Book_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Address_Book_Avg_Fields = {
  __typename?: 'base_user_address_book_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_address_book". All fields are combined with a logical 'AND'. */
export type Base_User_Address_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Address_Book_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Address_Book_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_address_book" */
export enum Base_User_Address_Book_Constraint {
  /** unique or primary key constraint on columns "baseuser_id", "address_id" */
  BaseUserAddressBookBaseuserIdAddressId_6bae516aUniq = 'base_user_address_book_baseuser_id_address_id_6bae516a_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserAddressBookPkey = 'base_user_address_book_pkey'
}

/** input type for incrementing numeric columns in table "base_user_address_book" */
export type Base_User_Address_Book_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_address_book" */
export type Base_User_Address_Book_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Address_Book_Max_Fields = {
  __typename?: 'base_user_address_book_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Address_Book_Min_Fields = {
  __typename?: 'base_user_address_book_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_address_book" */
export type Base_User_Address_Book_Mutation_Response = {
  __typename?: 'base_user_address_book_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Address_Book>;
};

/** on_conflict condition type for table "base_user_address_book" */
export type Base_User_Address_Book_On_Conflict = {
  constraint: Base_User_Address_Book_Constraint;
  update_columns?: Array<Base_User_Address_Book_Update_Column>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_address_book". */
export type Base_User_Address_Book_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_address_book */
export type Base_User_Address_Book_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_address_book" */
export enum Base_User_Address_Book_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_address_book" */
export type Base_User_Address_Book_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Address_Book_Stddev_Fields = {
  __typename?: 'base_user_address_book_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Address_Book_Stddev_Pop_Fields = {
  __typename?: 'base_user_address_book_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Address_Book_Stddev_Samp_Fields = {
  __typename?: 'base_user_address_book_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_address_book" */
export type Base_User_Address_Book_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Address_Book_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Address_Book_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Address_Book_Sum_Fields = {
  __typename?: 'base_user_address_book_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_address_book" */
export enum Base_User_Address_Book_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Address_Book_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Address_Book_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Address_Book_Set_Input>;
  where: Base_User_Address_Book_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Address_Book_Var_Pop_Fields = {
  __typename?: 'base_user_address_book_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Address_Book_Var_Samp_Fields = {
  __typename?: 'base_user_address_book_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Address_Book_Variance_Fields = {
  __typename?: 'base_user_address_book_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_address_book" */
export type Base_User_Address_Book_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregated selection of "base_user" */
export type Base_User_Aggregate = {
  __typename?: 'base_user_aggregate';
  aggregate?: Maybe<Base_User_Aggregate_Fields>;
  nodes: Array<Base_User>;
};

/** aggregate fields of "base_user" */
export type Base_User_Aggregate_Fields = {
  __typename?: 'base_user_aggregate_fields';
  avg?: Maybe<Base_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Max_Fields>;
  min?: Maybe<Base_User_Min_Fields>;
  stddev?: Maybe<Base_User_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Sum_Fields>;
  var_pop?: Maybe<Base_User_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Variance_Fields>;
};


/** aggregate fields of "base_user" */
export type Base_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user" */
export type Base_User_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Max_Order_By>;
  min?: InputMaybe<Base_User_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Base_User_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "base_user" */
export type Base_User_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Avg_Fields = {
  __typename?: 'base_user_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
  village_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user" */
export type Base_User_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Packaging_Ordercreated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Packaging_Ordercreated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Packaging_Orderupdated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Packaging_Orderupdated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Requestcreated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Requestcreated_By>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Requestupdated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Requestupdated_By>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Result_Commentcreated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Result_Commentcreated_By>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Shared_Entityuser = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityuser>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Tradecreated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Tradecreated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Tradeupdated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Tradeupdated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Transition_Historycreated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp_Remote_Rel_Transition_Historycreated_By>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Tripcreated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Tripcreated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "base_user". All fields are combined with a logical 'AND'. */
export type Base_User_Bool_Exp_Remote_Rel_Tripupdated_By = {
  _and?: InputMaybe<Array<Base_User_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Bool_Exp>>;
  address_book?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
  agents?: InputMaybe<Agent_Bool_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  companies_owned?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_address?: InputMaybe<Address_Bool_Exp>;
  current_address_id?: InputMaybe<Int_Comparison_Exp>;
  current_department?: InputMaybe<Department_Bool_Exp>;
  current_department_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  date_joined?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  departments?: InputMaybe<Base_User_Departments_Bool_Exp>;
  devices?: InputMaybe<Device_Bool_Exp>;
  education?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Bool_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Base_User_Groups_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp_Remote_Rel_Tripupdated_By>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  is_staff?: InputMaybe<Boolean_Comparison_Exp>;
  is_superuser?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  last_active_on_mobile?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_active_on_web?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  my_businesses?: InputMaybe<Business_Bool_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Base_User_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  number_country_code?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  preferred_language?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Bool_Exp>;
  preferred_payment_option_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_number_country_code?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  shareholders?: InputMaybe<Shareholders_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  village_id?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "base_user_companies" */
export type Base_User_Companies = {
  __typename?: 'base_user_companies';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_companies" */
export type Base_User_Companies_Aggregate = {
  __typename?: 'base_user_companies_aggregate';
  aggregate?: Maybe<Base_User_Companies_Aggregate_Fields>;
  nodes: Array<Base_User_Companies>;
};

/** aggregate fields of "base_user_companies" */
export type Base_User_Companies_Aggregate_Fields = {
  __typename?: 'base_user_companies_aggregate_fields';
  avg?: Maybe<Base_User_Companies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Companies_Max_Fields>;
  min?: Maybe<Base_User_Companies_Min_Fields>;
  stddev?: Maybe<Base_User_Companies_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Companies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Companies_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Companies_Sum_Fields>;
  var_pop?: Maybe<Base_User_Companies_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Companies_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Companies_Variance_Fields>;
};


/** aggregate fields of "base_user_companies" */
export type Base_User_Companies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_companies" */
export type Base_User_Companies_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Companies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Companies_Max_Order_By>;
  min?: InputMaybe<Base_User_Companies_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Companies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Companies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Companies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Companies_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Companies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Companies_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Companies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_companies" */
export type Base_User_Companies_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Companies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Companies_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Companies_Avg_Fields = {
  __typename?: 'base_user_companies_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_companies" */
export type Base_User_Companies_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_companies". All fields are combined with a logical 'AND'. */
export type Base_User_Companies_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Companies_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Companies_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Companies_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_companies" */
export enum Base_User_Companies_Constraint {
  /** unique or primary key constraint on columns "baseuser_id", "company_id" */
  BaseUserCompaniesBaseuserIdCompanyId_69c93b6fUniq = 'base_user_companies_baseuser_id_company_id_69c93b6f_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserCompaniesPkey = 'base_user_companies_pkey'
}

/** input type for incrementing numeric columns in table "base_user_companies" */
export type Base_User_Companies_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_companies" */
export type Base_User_Companies_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Companies_Max_Fields = {
  __typename?: 'base_user_companies_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_companies" */
export type Base_User_Companies_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Companies_Min_Fields = {
  __typename?: 'base_user_companies_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_companies" */
export type Base_User_Companies_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_companies" */
export type Base_User_Companies_Mutation_Response = {
  __typename?: 'base_user_companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Companies>;
};

/** on_conflict condition type for table "base_user_companies" */
export type Base_User_Companies_On_Conflict = {
  constraint: Base_User_Companies_Constraint;
  update_columns?: Array<Base_User_Companies_Update_Column>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_companies". */
export type Base_User_Companies_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_companies */
export type Base_User_Companies_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_companies" */
export enum Base_User_Companies_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_companies" */
export type Base_User_Companies_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Companies_Stddev_Fields = {
  __typename?: 'base_user_companies_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_companies" */
export type Base_User_Companies_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Companies_Stddev_Pop_Fields = {
  __typename?: 'base_user_companies_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_companies" */
export type Base_User_Companies_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Companies_Stddev_Samp_Fields = {
  __typename?: 'base_user_companies_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_companies" */
export type Base_User_Companies_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_companies" */
export type Base_User_Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Companies_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Companies_Sum_Fields = {
  __typename?: 'base_user_companies_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_companies" */
export type Base_User_Companies_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_companies" */
export enum Base_User_Companies_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Companies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Companies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Companies_Set_Input>;
  where: Base_User_Companies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Companies_Var_Pop_Fields = {
  __typename?: 'base_user_companies_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_companies" */
export type Base_User_Companies_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Companies_Var_Samp_Fields = {
  __typename?: 'base_user_companies_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_companies" */
export type Base_User_Companies_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Companies_Variance_Fields = {
  __typename?: 'base_user_companies_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_companies" */
export type Base_User_Companies_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "base_user" */
export enum Base_User_Constraint {
  /** unique or primary key constraint on columns "data_consent_id" */
  BaseUserDataConsentIdKey = 'base_user_data_consent_id_key',
  /** unique or primary key constraint on columns "number" */
  BaseUserNumberKey = 'base_user_number_key',
  /** unique or primary key constraint on columns "id" */
  BaseUserPkey = 'base_user_pkey',
  /** unique or primary key constraint on columns "reference_id" */
  BaseUserReferenceIdKey = 'base_user_reference_id_key',
  /** unique or primary key constraint on columns "username" */
  BaseUserUsernameKey = 'base_user_username_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Base_User_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Base_User_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Base_User_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "base_user_departments" */
export type Base_User_Departments = {
  __typename?: 'base_user_departments';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  department: Department;
  department_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_departments" */
export type Base_User_Departments_Aggregate = {
  __typename?: 'base_user_departments_aggregate';
  aggregate?: Maybe<Base_User_Departments_Aggregate_Fields>;
  nodes: Array<Base_User_Departments>;
};

/** aggregate fields of "base_user_departments" */
export type Base_User_Departments_Aggregate_Fields = {
  __typename?: 'base_user_departments_aggregate_fields';
  avg?: Maybe<Base_User_Departments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Departments_Max_Fields>;
  min?: Maybe<Base_User_Departments_Min_Fields>;
  stddev?: Maybe<Base_User_Departments_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Departments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Departments_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Departments_Sum_Fields>;
  var_pop?: Maybe<Base_User_Departments_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Departments_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Departments_Variance_Fields>;
};


/** aggregate fields of "base_user_departments" */
export type Base_User_Departments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_departments" */
export type Base_User_Departments_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Departments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Departments_Max_Order_By>;
  min?: InputMaybe<Base_User_Departments_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Departments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Departments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Departments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Departments_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Departments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Departments_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Departments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_departments" */
export type Base_User_Departments_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Departments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Departments_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Departments_Avg_Fields = {
  __typename?: 'base_user_departments_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_departments" */
export type Base_User_Departments_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_departments". All fields are combined with a logical 'AND'. */
export type Base_User_Departments_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Departments_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Departments_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Departments_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  department_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_departments" */
export enum Base_User_Departments_Constraint {
  /** unique or primary key constraint on columns "department_id", "baseuser_id" */
  BaseUserDepartmentsBaseuserIdDepartmentId_5e55738fUniq = 'base_user_departments_baseuser_id_department_id_5e55738f_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserDepartmentsPkey = 'base_user_departments_pkey'
}

/** input type for incrementing numeric columns in table "base_user_departments" */
export type Base_User_Departments_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_departments" */
export type Base_User_Departments_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Departments_Max_Fields = {
  __typename?: 'base_user_departments_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_departments" */
export type Base_User_Departments_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Departments_Min_Fields = {
  __typename?: 'base_user_departments_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_departments" */
export type Base_User_Departments_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_departments" */
export type Base_User_Departments_Mutation_Response = {
  __typename?: 'base_user_departments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Departments>;
};

/** on_conflict condition type for table "base_user_departments" */
export type Base_User_Departments_On_Conflict = {
  constraint: Base_User_Departments_Constraint;
  update_columns?: Array<Base_User_Departments_Update_Column>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_departments". */
export type Base_User_Departments_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_departments */
export type Base_User_Departments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_departments" */
export enum Base_User_Departments_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_departments" */
export type Base_User_Departments_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Departments_Stddev_Fields = {
  __typename?: 'base_user_departments_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_departments" */
export type Base_User_Departments_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Departments_Stddev_Pop_Fields = {
  __typename?: 'base_user_departments_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_departments" */
export type Base_User_Departments_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Departments_Stddev_Samp_Fields = {
  __typename?: 'base_user_departments_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_departments" */
export type Base_User_Departments_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_departments" */
export type Base_User_Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Departments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Departments_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Departments_Sum_Fields = {
  __typename?: 'base_user_departments_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_departments" */
export type Base_User_Departments_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_departments" */
export enum Base_User_Departments_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Departments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Departments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Departments_Set_Input>;
  where: Base_User_Departments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Departments_Var_Pop_Fields = {
  __typename?: 'base_user_departments_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_departments" */
export type Base_User_Departments_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Departments_Var_Samp_Fields = {
  __typename?: 'base_user_departments_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_departments" */
export type Base_User_Departments_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Departments_Variance_Fields = {
  __typename?: 'base_user_departments_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_departments" */
export type Base_User_Departments_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "base_user_groups" */
export type Base_User_Groups = {
  __typename?: 'base_user_groups';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  group: Auth_Group;
  group_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "base_user_groups" */
export type Base_User_Groups_Aggregate = {
  __typename?: 'base_user_groups_aggregate';
  aggregate?: Maybe<Base_User_Groups_Aggregate_Fields>;
  nodes: Array<Base_User_Groups>;
};

/** aggregate fields of "base_user_groups" */
export type Base_User_Groups_Aggregate_Fields = {
  __typename?: 'base_user_groups_aggregate_fields';
  avg?: Maybe<Base_User_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Groups_Max_Fields>;
  min?: Maybe<Base_User_Groups_Min_Fields>;
  stddev?: Maybe<Base_User_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Groups_Sum_Fields>;
  var_pop?: Maybe<Base_User_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Groups_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Groups_Variance_Fields>;
};


/** aggregate fields of "base_user_groups" */
export type Base_User_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_groups" */
export type Base_User_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Groups_Max_Order_By>;
  min?: InputMaybe<Base_User_Groups_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_groups" */
export type Base_User_Groups_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Groups_Avg_Fields = {
  __typename?: 'base_user_groups_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_groups" */
export type Base_User_Groups_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_groups". All fields are combined with a logical 'AND'. */
export type Base_User_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Groups_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Groups_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  group?: InputMaybe<Auth_Group_Bool_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_groups" */
export enum Base_User_Groups_Constraint {
  /** unique or primary key constraint on columns "group_id", "baseuser_id" */
  BaseUserGroupsBaseuserIdGroupId_15e6ae17Uniq = 'base_user_groups_baseuser_id_group_id_15e6ae17_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserGroupsPkey = 'base_user_groups_pkey'
}

/** input type for incrementing numeric columns in table "base_user_groups" */
export type Base_User_Groups_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_groups" */
export type Base_User_Groups_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Auth_Group_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Groups_Max_Fields = {
  __typename?: 'base_user_groups_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_groups" */
export type Base_User_Groups_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Groups_Min_Fields = {
  __typename?: 'base_user_groups_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_groups" */
export type Base_User_Groups_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_groups" */
export type Base_User_Groups_Mutation_Response = {
  __typename?: 'base_user_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Groups>;
};

/** on_conflict condition type for table "base_user_groups" */
export type Base_User_Groups_On_Conflict = {
  constraint: Base_User_Groups_Constraint;
  update_columns?: Array<Base_User_Groups_Update_Column>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_groups". */
export type Base_User_Groups_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Auth_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_groups */
export type Base_User_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_groups" */
export enum Base_User_Groups_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base_user_groups" */
export type Base_User_Groups_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Groups_Stddev_Fields = {
  __typename?: 'base_user_groups_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_groups" */
export type Base_User_Groups_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Groups_Stddev_Pop_Fields = {
  __typename?: 'base_user_groups_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_groups" */
export type Base_User_Groups_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Groups_Stddev_Samp_Fields = {
  __typename?: 'base_user_groups_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_groups" */
export type Base_User_Groups_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_groups" */
export type Base_User_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Groups_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Groups_Sum_Fields = {
  __typename?: 'base_user_groups_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_groups" */
export type Base_User_Groups_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_groups" */
export enum Base_User_Groups_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id'
}

export type Base_User_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Groups_Set_Input>;
  where: Base_User_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Groups_Var_Pop_Fields = {
  __typename?: 'base_user_groups_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_groups" */
export type Base_User_Groups_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Groups_Var_Samp_Fields = {
  __typename?: 'base_user_groups_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_groups" */
export type Base_User_Groups_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Groups_Variance_Fields = {
  __typename?: 'base_user_groups_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_groups" */
export type Base_User_Groups_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "base_user" */
export type Base_User_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  village_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user" */
export type Base_User_Insert_Input = {
  address_book?: InputMaybe<Base_User_Address_Book_Arr_Rel_Insert_Input>;
  agents?: InputMaybe<Agent_Arr_Rel_Insert_Input>;
  block_remark?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Base_User_Companies_Arr_Rel_Insert_Input>;
  companies_owned?: InputMaybe<Company_Share_Holder_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  departments?: InputMaybe<Base_User_Departments_Arr_Rel_Insert_Input>;
  devices?: InputMaybe<Device_Arr_Rel_Insert_Input>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  farms?: InputMaybe<Farm_Arr_Rel_Insert_Input>;
  father_mother_spouse_name?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Field_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Base_User_Groups_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_active_on_mobile?: InputMaybe<Scalars['timestamptz']>;
  last_active_on_web?: InputMaybe<Scalars['timestamptz']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Arr_Rel_Insert_Input>;
  my_businesses?: InputMaybe<Business_Arr_Rel_Insert_Input>;
  name_as_per_pan?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Nationality_Obj_Rel_Insert_Input>;
  nationality_id?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Base_User_Network_Arr_Rel_Insert_Input>;
  number?: InputMaybe<Scalars['String']>;
  number_country_code?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Arr_Rel_Insert_Input>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Arr_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  plot_crops?: InputMaybe<Plot_Crop_Arr_Rel_Insert_Input>;
  plots?: InputMaybe<Plot_Arr_Rel_Insert_Input>;
  preferred_language?: InputMaybe<Scalars['String']>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Obj_Rel_Insert_Input>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  reference_id?: InputMaybe<Scalars['String']>;
  responses?: InputMaybe<Survey_Responses_Arr_Rel_Insert_Input>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_number_country_code?: InputMaybe<Scalars['String']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  shareholders?: InputMaybe<Shareholders_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  status_snapshots?: InputMaybe<Org_User_Group_Status_Snapshot_Arr_Rel_Insert_Input>;
  subscription_type?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  verification_done_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  village_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_Max_Fields = {
  __typename?: 'base_user_max_fields';
  block_remark?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  current_address_id?: Maybe<Scalars['Int']>;
  current_department_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  date_joined?: Maybe<Scalars['timestamptz']>;
  date_of_birth?: Maybe<Scalars['date']>;
  education?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  father_mother_spouse_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_active_on_mobile?: Maybe<Scalars['timestamptz']>;
  last_active_on_web?: Maybe<Scalars['timestamptz']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  name_as_per_pan?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_country_code?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  secondary_number_country_code?: Maybe<Scalars['String']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  village_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user" */
export type Base_User_Max_Order_By = {
  block_remark?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  education?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  father_mother_spouse_name?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_on_mobile?: InputMaybe<Order_By>;
  last_active_on_web?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  name_as_per_pan?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_country_code?: InputMaybe<Order_By>;
  occupation?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_number_country_code?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Min_Fields = {
  __typename?: 'base_user_min_fields';
  block_remark?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  current_address_id?: Maybe<Scalars['Int']>;
  current_department_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  date_joined?: Maybe<Scalars['timestamptz']>;
  date_of_birth?: Maybe<Scalars['date']>;
  education?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  father_mother_spouse_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_active_on_mobile?: Maybe<Scalars['timestamptz']>;
  last_active_on_web?: Maybe<Scalars['timestamptz']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  name_as_per_pan?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  number_country_code?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  secondary_number_country_code?: Maybe<Scalars['String']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  village_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user" */
export type Base_User_Min_Order_By = {
  block_remark?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  education?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  father_mother_spouse_name?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_active_on_mobile?: InputMaybe<Order_By>;
  last_active_on_web?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  name_as_per_pan?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_country_code?: InputMaybe<Order_By>;
  occupation?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_number_country_code?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user" */
export type Base_User_Mutation_Response = {
  __typename?: 'base_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User>;
};

/** columns and relationships of "base_user_network" */
export type Base_User_Network = {
  __typename?: 'base_user_network';
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  codename: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "base_user_network" */
export type Base_User_Network_Aggregate = {
  __typename?: 'base_user_network_aggregate';
  aggregate?: Maybe<Base_User_Network_Aggregate_Fields>;
  nodes: Array<Base_User_Network>;
};

/** aggregate fields of "base_user_network" */
export type Base_User_Network_Aggregate_Fields = {
  __typename?: 'base_user_network_aggregate_fields';
  avg?: Maybe<Base_User_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_Network_Max_Fields>;
  min?: Maybe<Base_User_Network_Min_Fields>;
  stddev?: Maybe<Base_User_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_Network_Sum_Fields>;
  var_pop?: Maybe<Base_User_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_Network_Var_Samp_Fields>;
  variance?: Maybe<Base_User_Network_Variance_Fields>;
};


/** aggregate fields of "base_user_network" */
export type Base_User_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_network" */
export type Base_User_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_Network_Max_Order_By>;
  min?: InputMaybe<Base_User_Network_Min_Order_By>;
  stddev?: InputMaybe<Base_User_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_network" */
export type Base_User_Network_Arr_Rel_Insert_Input = {
  data: Array<Base_User_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_Network_Avg_Fields = {
  __typename?: 'base_user_network_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_network" */
export type Base_User_Network_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_network". All fields are combined with a logical 'AND'. */
export type Base_User_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_Network_Bool_Exp>>;
  _not?: InputMaybe<Base_User_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_Network_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_network" */
export enum Base_User_Network_Constraint {
  /** unique or primary key constraint on columns "base_user_id", "network_id" */
  BaseUserNetworkNetworkIdBaseUserId_17c4e15eUniq = 'base_user_network_network_id_base_user_id_17c4e15e_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserNetworkPkey = 'base_user_network_pkey'
}

/** input type for incrementing numeric columns in table "base_user_network" */
export type Base_User_Network_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_network" */
export type Base_User_Network_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Base_User_Network_Max_Fields = {
  __typename?: 'base_user_network_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_network" */
export type Base_User_Network_Max_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_Network_Min_Fields = {
  __typename?: 'base_user_network_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_network" */
export type Base_User_Network_Min_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_network" */
export type Base_User_Network_Mutation_Response = {
  __typename?: 'base_user_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_Network>;
};

/** on_conflict condition type for table "base_user_network" */
export type Base_User_Network_On_Conflict = {
  constraint: Base_User_Network_Constraint;
  update_columns?: Array<Base_User_Network_Update_Column>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_network". */
export type Base_User_Network_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_network */
export type Base_User_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_network" */
export enum Base_User_Network_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "base_user_network" */
export type Base_User_Network_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Base_User_Network_Stddev_Fields = {
  __typename?: 'base_user_network_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_network" */
export type Base_User_Network_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Network_Stddev_Pop_Fields = {
  __typename?: 'base_user_network_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_network" */
export type Base_User_Network_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Network_Stddev_Samp_Fields = {
  __typename?: 'base_user_network_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_network" */
export type Base_User_Network_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_network" */
export type Base_User_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Network_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Base_User_Network_Sum_Fields = {
  __typename?: 'base_user_network_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_network" */
export type Base_User_Network_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_network" */
export enum Base_User_Network_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Base_User_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Network_Set_Input>;
  where: Base_User_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_Network_Var_Pop_Fields = {
  __typename?: 'base_user_network_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_network" */
export type Base_User_Network_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Network_Var_Samp_Fields = {
  __typename?: 'base_user_network_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_network" */
export type Base_User_Network_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Network_Variance_Fields = {
  __typename?: 'base_user_network_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_network" */
export type Base_User_Network_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "base_user" */
export type Base_User_Obj_Rel_Insert_Input = {
  data: Base_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};

/** on_conflict condition type for table "base_user" */
export type Base_User_On_Conflict = {
  constraint: Base_User_Constraint;
  update_columns?: Array<Base_User_Update_Column>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user". */
export type Base_User_Order_By = {
  address_book_aggregate?: InputMaybe<Base_User_Address_Book_Aggregate_Order_By>;
  agents_aggregate?: InputMaybe<Agent_Aggregate_Order_By>;
  block_remark?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Base_User_Companies_Aggregate_Order_By>;
  companies_owned_aggregate?: InputMaybe<Company_Share_Holder_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address?: InputMaybe<Address_Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department?: InputMaybe<Department_Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent?: InputMaybe<Media_Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  date_joined?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  departments_aggregate?: InputMaybe<Base_User_Departments_Aggregate_Order_By>;
  devices_aggregate?: InputMaybe<Device_Aggregate_Order_By>;
  education?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_reference_id2?: InputMaybe<Order_By>;
  farms_aggregate?: InputMaybe<Farm_Aggregate_Order_By>;
  father_mother_spouse_name?: InputMaybe<Order_By>;
  fields_aggregate?: InputMaybe<Field_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  groups_aggregate?: InputMaybe<Base_User_Groups_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  is_staff?: InputMaybe<Order_By>;
  is_superuser?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  last_active_on_mobile?: InputMaybe<Order_By>;
  last_active_on_web?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mutual_group_memberships_aggregate?: InputMaybe<Mutual_Group_Membership_Aggregate_Order_By>;
  my_businesses_aggregate?: InputMaybe<Business_Aggregate_Order_By>;
  name_as_per_pan?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Nationality_Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Base_User_Network_Aggregate_Order_By>;
  number?: InputMaybe<Order_By>;
  number_country_code?: InputMaybe<Order_By>;
  occupation?: InputMaybe<Order_By>;
  org_team_user_bank_associations_aggregate?: InputMaybe<Org_Team_User_Bank_Association_Aggregate_Order_By>;
  org_team_user_document_associations_aggregate?: InputMaybe<Org_Team_User_Document_Association_Aggregate_Order_By>;
  password?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  plot_crops_aggregate?: InputMaybe<Plot_Crop_Aggregate_Order_By>;
  plots_aggregate?: InputMaybe<Plot_Aggregate_Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  preferred_payment_option?: InputMaybe<Payment_Detail_Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  responses_aggregate?: InputMaybe<Survey_Responses_Aggregate_Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_number_country_code?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  shareholders_aggregate?: InputMaybe<Shareholders_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  status_snapshots_aggregate?: InputMaybe<Org_User_Group_Status_Snapshot_Aggregate_Order_By>;
  subscription_type?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  verification_done_by?: InputMaybe<Base_User_Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user */
export type Base_User_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Base_User_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "base_user" */
export enum Base_User_Select_Column {
  /** column name */
  BlockRemark = 'block_remark',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CurrentAddressId = 'current_address_id',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Education = 'education',
  /** column name */
  Email = 'email',
  /** column name */
  FatherMotherSpouseName = 'father_mother_spouse_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LastActiveOnMobile = 'last_active_on_mobile',
  /** column name */
  LastActiveOnWeb = 'last_active_on_web',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NameAsPerPan = 'name_as_per_pan',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  Number = 'number',
  /** column name */
  NumberCountryCode = 'number_country_code',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  Password = 'password',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  PreferredPaymentOptionId = 'preferred_payment_option_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  SecondaryNumberCountryCode = 'secondary_number_country_code',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  Status = 'status',
  /** column name */
  SubscriptionType = 'subscription_type',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on',
  /** column name */
  VillageId = 'village_id'
}

/** input type for updating data in table "base_user" */
export type Base_User_Set_Input = {
  block_remark?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  father_mother_spouse_name?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_active_on_mobile?: InputMaybe<Scalars['timestamptz']>;
  last_active_on_web?: InputMaybe<Scalars['timestamptz']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name_as_per_pan?: InputMaybe<Scalars['String']>;
  nationality_id?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  number_country_code?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  preferred_language?: InputMaybe<Scalars['String']>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  reference_id?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_number_country_code?: InputMaybe<Scalars['String']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subscription_type?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  village_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_Stddev_Fields = {
  __typename?: 'base_user_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
  village_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user" */
export type Base_User_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_Stddev_Pop_Fields = {
  __typename?: 'base_user_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
  village_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user" */
export type Base_User_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_Stddev_Samp_Fields = {
  __typename?: 'base_user_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
  village_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user" */
export type Base_User_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user" */
export type Base_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_Stream_Cursor_Value_Input = {
  block_remark?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_address_id?: InputMaybe<Scalars['Int']>;
  current_department_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  date_joined?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  father_mother_spouse_name?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_superuser?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_active_on_mobile?: InputMaybe<Scalars['timestamptz']>;
  last_active_on_web?: InputMaybe<Scalars['timestamptz']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name_as_per_pan?: InputMaybe<Scalars['String']>;
  nationality_id?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  number_country_code?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  preferred_language?: InputMaybe<Scalars['String']>;
  preferred_payment_option_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  reference_id?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_number_country_code?: InputMaybe<Scalars['String']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subscription_type?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  village_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_Sum_Fields = {
  __typename?: 'base_user_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  current_address_id?: Maybe<Scalars['Int']>;
  current_department_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  preferred_payment_option_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  village_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user" */
export type Base_User_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user" */
export enum Base_User_Update_Column {
  /** column name */
  BlockRemark = 'block_remark',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CurrentAddressId = 'current_address_id',
  /** column name */
  CurrentDepartmentId = 'current_department_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  DateJoined = 'date_joined',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Education = 'education',
  /** column name */
  Email = 'email',
  /** column name */
  FatherMotherSpouseName = 'father_mother_spouse_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  IsStaff = 'is_staff',
  /** column name */
  IsSuperuser = 'is_superuser',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LastActiveOnMobile = 'last_active_on_mobile',
  /** column name */
  LastActiveOnWeb = 'last_active_on_web',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NameAsPerPan = 'name_as_per_pan',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  Number = 'number',
  /** column name */
  NumberCountryCode = 'number_country_code',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  Password = 'password',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  PreferredPaymentOptionId = 'preferred_payment_option_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  SecondaryNumberCountryCode = 'secondary_number_country_code',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  Status = 'status',
  /** column name */
  SubscriptionType = 'subscription_type',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Username = 'username',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on',
  /** column name */
  VillageId = 'village_id'
}

export type Base_User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Base_User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Base_User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Base_User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Base_User_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Base_User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_Set_Input>;
  where: Base_User_Bool_Exp;
};

/** columns and relationships of "base_user_user_permissions" */
export type Base_User_User_Permissions = {
  __typename?: 'base_user_user_permissions';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  permission: Auth_Permission;
  permission_id: Scalars['Int'];
};

/** aggregated selection of "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate = {
  __typename?: 'base_user_user_permissions_aggregate';
  aggregate?: Maybe<Base_User_User_Permissions_Aggregate_Fields>;
  nodes: Array<Base_User_User_Permissions>;
};

/** aggregate fields of "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate_Fields = {
  __typename?: 'base_user_user_permissions_aggregate_fields';
  avg?: Maybe<Base_User_User_Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_User_User_Permissions_Max_Fields>;
  min?: Maybe<Base_User_User_Permissions_Min_Fields>;
  stddev?: Maybe<Base_User_User_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Base_User_User_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_User_User_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Base_User_User_Permissions_Sum_Fields>;
  var_pop?: Maybe<Base_User_User_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Base_User_User_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Base_User_User_Permissions_Variance_Fields>;
};


/** aggregate fields of "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Base_User_User_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_User_User_Permissions_Max_Order_By>;
  min?: InputMaybe<Base_User_User_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Base_User_User_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_User_User_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_User_User_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_User_User_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Base_User_User_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_User_User_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_User_User_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base_user_user_permissions" */
export type Base_User_User_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Base_User_User_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_User_User_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_User_User_Permissions_Avg_Fields = {
  __typename?: 'base_user_user_permissions_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_user_user_permissions". All fields are combined with a logical 'AND'. */
export type Base_User_User_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Base_User_User_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Base_User_User_Permissions_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  permission?: InputMaybe<Auth_Permission_Bool_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_user_user_permissions" */
export enum Base_User_User_Permissions_Constraint {
  /** unique or primary key constraint on columns "baseuser_id", "permission_id" */
  BaseUserUserPermissioBaseuserIdPermissionI_41dea9a5Uniq = 'base_user_user_permissio_baseuser_id_permission_i_41dea9a5_uniq',
  /** unique or primary key constraint on columns "id" */
  BaseUserUserPermissionsPkey = 'base_user_user_permissions_pkey'
}

/** input type for incrementing numeric columns in table "base_user_user_permissions" */
export type Base_User_User_Permissions_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_user_user_permissions" */
export type Base_User_User_Permissions_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Auth_Permission_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Base_User_User_Permissions_Max_Fields = {
  __typename?: 'base_user_user_permissions_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_User_User_Permissions_Min_Fields = {
  __typename?: 'base_user_user_permissions_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_user_user_permissions" */
export type Base_User_User_Permissions_Mutation_Response = {
  __typename?: 'base_user_user_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_User_User_Permissions>;
};

/** on_conflict condition type for table "base_user_user_permissions" */
export type Base_User_User_Permissions_On_Conflict = {
  constraint: Base_User_User_Permissions_Constraint;
  update_columns?: Array<Base_User_User_Permissions_Update_Column>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "base_user_user_permissions". */
export type Base_User_User_Permissions_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Auth_Permission_Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_user_user_permissions */
export type Base_User_User_Permissions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "base_user_user_permissions" */
export enum Base_User_User_Permissions_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

/** input type for updating data in table "base_user_user_permissions" */
export type Base_User_User_Permissions_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Base_User_User_Permissions_Stddev_Fields = {
  __typename?: 'base_user_user_permissions_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_User_User_Permissions_Stddev_Pop_Fields = {
  __typename?: 'base_user_user_permissions_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_User_User_Permissions_Stddev_Samp_Fields = {
  __typename?: 'base_user_user_permissions_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_user_user_permissions" */
export type Base_User_User_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_User_User_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_User_User_Permissions_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Base_User_User_Permissions_Sum_Fields = {
  __typename?: 'base_user_user_permissions_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** update columns of table "base_user_user_permissions" */
export enum Base_User_User_Permissions_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id'
}

export type Base_User_User_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_User_User_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_User_User_Permissions_Set_Input>;
  where: Base_User_User_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_User_User_Permissions_Var_Pop_Fields = {
  __typename?: 'base_user_user_permissions_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_User_Permissions_Var_Samp_Fields = {
  __typename?: 'base_user_user_permissions_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_User_Permissions_Variance_Fields = {
  __typename?: 'base_user_user_permissions_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user_user_permissions" */
export type Base_User_User_Permissions_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Base_User_Var_Pop_Fields = {
  __typename?: 'base_user_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
  village_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_user" */
export type Base_User_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_User_Var_Samp_Fields = {
  __typename?: 'base_user_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
  village_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_user" */
export type Base_User_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_User_Variance_Fields = {
  __typename?: 'base_user_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  current_address_id?: Maybe<Scalars['Float']>;
  current_department_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  preferred_payment_option_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
  village_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_user" */
export type Base_User_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_address_id?: InputMaybe<Order_By>;
  current_department_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  preferred_payment_option_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  village_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "brand" */
export type Brand = {
  __typename?: 'brand';
  codename: Scalars['String'];
  /** An array relationship */
  companies: Array<Brand_Company>;
  /** An aggregate relationship */
  companies_aggregate: Brand_Company_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  templates: Array<Template>;
  /** An aggregate relationship */
  templates_aggregate: Template_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "brand" */
export type BrandCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandTemplatesArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};

/** aggregated selection of "brand" */
export type Brand_Aggregate = {
  __typename?: 'brand_aggregate';
  aggregate?: Maybe<Brand_Aggregate_Fields>;
  nodes: Array<Brand>;
};

/** aggregate fields of "brand" */
export type Brand_Aggregate_Fields = {
  __typename?: 'brand_aggregate_fields';
  avg?: Maybe<Brand_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Brand_Max_Fields>;
  min?: Maybe<Brand_Min_Fields>;
  stddev?: Maybe<Brand_Stddev_Fields>;
  stddev_pop?: Maybe<Brand_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Brand_Stddev_Samp_Fields>;
  sum?: Maybe<Brand_Sum_Fields>;
  var_pop?: Maybe<Brand_Var_Pop_Fields>;
  var_samp?: Maybe<Brand_Var_Samp_Fields>;
  variance?: Maybe<Brand_Variance_Fields>;
};


/** aggregate fields of "brand" */
export type Brand_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Brand_Avg_Fields = {
  __typename?: 'brand_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "brand". All fields are combined with a logical 'AND'. */
export type Brand_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Bool_Exp>>;
  _not?: InputMaybe<Brand_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Brand_Company_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  templates?: InputMaybe<Template_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "brand_company" */
export type Brand_Company = {
  __typename?: 'brand_company';
  /** An object relationship */
  brand: Brand;
  brand_id: Scalars['bigint'];
  /** An object relationship */
  company: External_Entity;
  externalentity_id: Scalars['bigint'];
  id: Scalars['bigint'];
};

/** aggregated selection of "brand_company" */
export type Brand_Company_Aggregate = {
  __typename?: 'brand_company_aggregate';
  aggregate?: Maybe<Brand_Company_Aggregate_Fields>;
  nodes: Array<Brand_Company>;
};

/** aggregate fields of "brand_company" */
export type Brand_Company_Aggregate_Fields = {
  __typename?: 'brand_company_aggregate_fields';
  avg?: Maybe<Brand_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Brand_Company_Max_Fields>;
  min?: Maybe<Brand_Company_Min_Fields>;
  stddev?: Maybe<Brand_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Brand_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Brand_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Brand_Company_Sum_Fields>;
  var_pop?: Maybe<Brand_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Brand_Company_Var_Samp_Fields>;
  variance?: Maybe<Brand_Company_Variance_Fields>;
};


/** aggregate fields of "brand_company" */
export type Brand_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "brand_company" */
export type Brand_Company_Aggregate_Order_By = {
  avg?: InputMaybe<Brand_Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Company_Max_Order_By>;
  min?: InputMaybe<Brand_Company_Min_Order_By>;
  stddev?: InputMaybe<Brand_Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Brand_Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Brand_Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Brand_Company_Sum_Order_By>;
  var_pop?: InputMaybe<Brand_Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Brand_Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Brand_Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "brand_company" */
export type Brand_Company_Arr_Rel_Insert_Input = {
  data: Array<Brand_Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Brand_Company_Avg_Fields = {
  __typename?: 'brand_company_avg_fields';
  brand_id?: Maybe<Scalars['Float']>;
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "brand_company" */
export type Brand_Company_Avg_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "brand_company". All fields are combined with a logical 'AND'. */
export type Brand_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Company_Bool_Exp>>;
  _not?: InputMaybe<Brand_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Company_Bool_Exp>>;
  brand?: InputMaybe<Brand_Bool_Exp>;
  brand_id?: InputMaybe<Bigint_Comparison_Exp>;
  company?: InputMaybe<External_Entity_Bool_Exp>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_company" */
export enum Brand_Company_Constraint {
  /** unique or primary key constraint on columns "externalentity_id", "brand_id" */
  BrandCompanyBrandIdExternalentityIdE8676188Uniq = 'brand_company_brand_id_externalentity_id_e8676188_uniq',
  /** unique or primary key constraint on columns "id" */
  BrandCompanyPkey = 'brand_company_pkey'
}

/** input type for incrementing numeric columns in table "brand_company" */
export type Brand_Company_Inc_Input = {
  brand_id?: InputMaybe<Scalars['bigint']>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "brand_company" */
export type Brand_Company_Insert_Input = {
  brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['bigint']>;
  company?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Brand_Company_Max_Fields = {
  __typename?: 'brand_company_max_fields';
  brand_id?: Maybe<Scalars['bigint']>;
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "brand_company" */
export type Brand_Company_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Company_Min_Fields = {
  __typename?: 'brand_company_min_fields';
  brand_id?: Maybe<Scalars['bigint']>;
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "brand_company" */
export type Brand_Company_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_company" */
export type Brand_Company_Mutation_Response = {
  __typename?: 'brand_company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Company>;
};

/** on_conflict condition type for table "brand_company" */
export type Brand_Company_On_Conflict = {
  constraint: Brand_Company_Constraint;
  update_columns?: Array<Brand_Company_Update_Column>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_company". */
export type Brand_Company_Order_By = {
  brand?: InputMaybe<Brand_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  company?: InputMaybe<External_Entity_Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_company */
export type Brand_Company_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "brand_company" */
export enum Brand_Company_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "brand_company" */
export type Brand_Company_Set_Input = {
  brand_id?: InputMaybe<Scalars['bigint']>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Brand_Company_Stddev_Fields = {
  __typename?: 'brand_company_stddev_fields';
  brand_id?: Maybe<Scalars['Float']>;
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "brand_company" */
export type Brand_Company_Stddev_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Brand_Company_Stddev_Pop_Fields = {
  __typename?: 'brand_company_stddev_pop_fields';
  brand_id?: Maybe<Scalars['Float']>;
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "brand_company" */
export type Brand_Company_Stddev_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Brand_Company_Stddev_Samp_Fields = {
  __typename?: 'brand_company_stddev_samp_fields';
  brand_id?: Maybe<Scalars['Float']>;
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "brand_company" */
export type Brand_Company_Stddev_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "brand_company" */
export type Brand_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Company_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['bigint']>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Brand_Company_Sum_Fields = {
  __typename?: 'brand_company_sum_fields';
  brand_id?: Maybe<Scalars['bigint']>;
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "brand_company" */
export type Brand_Company_Sum_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "brand_company" */
export enum Brand_Company_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id'
}

export type Brand_Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Brand_Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Company_Set_Input>;
  where: Brand_Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Brand_Company_Var_Pop_Fields = {
  __typename?: 'brand_company_var_pop_fields';
  brand_id?: Maybe<Scalars['Float']>;
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "brand_company" */
export type Brand_Company_Var_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Brand_Company_Var_Samp_Fields = {
  __typename?: 'brand_company_var_samp_fields';
  brand_id?: Maybe<Scalars['Float']>;
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "brand_company" */
export type Brand_Company_Var_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Brand_Company_Variance_Fields = {
  __typename?: 'brand_company_variance_fields';
  brand_id?: Maybe<Scalars['Float']>;
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "brand_company" */
export type Brand_Company_Variance_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "brand" */
export enum Brand_Constraint {
  /** unique or primary key constraint on columns "codename" */
  BrandCodenameKey = 'brand_codename_key',
  /** unique or primary key constraint on columns "id" */
  BrandPkey = 'brand_pkey'
}

/** input type for incrementing numeric columns in table "brand" */
export type Brand_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "brand" */
export type Brand_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Brand_Company_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  templates?: InputMaybe<Template_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Brand_Max_Fields = {
  __typename?: 'brand_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Brand_Min_Fields = {
  __typename?: 'brand_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "brand" */
export type Brand_Mutation_Response = {
  __typename?: 'brand_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand>;
};

/** input type for inserting object relation for remote table "brand" */
export type Brand_Obj_Rel_Insert_Input = {
  data: Brand_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_On_Conflict>;
};

/** on_conflict condition type for table "brand" */
export type Brand_On_Conflict = {
  constraint: Brand_Constraint;
  update_columns?: Array<Brand_Update_Column>;
  where?: InputMaybe<Brand_Bool_Exp>;
};

/** Ordering options when selecting data from "brand". */
export type Brand_Order_By = {
  codename?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Brand_Company_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  templates_aggregate?: InputMaybe<Template_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand */
export type Brand_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "brand" */
export enum Brand_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "brand" */
export type Brand_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Brand_Stddev_Fields = {
  __typename?: 'brand_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Brand_Stddev_Pop_Fields = {
  __typename?: 'brand_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Brand_Stddev_Samp_Fields = {
  __typename?: 'brand_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "brand" */
export type Brand_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Brand_Sum_Fields = {
  __typename?: 'brand_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "brand" */
export enum Brand_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Brand_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Brand_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Set_Input>;
  where: Brand_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Brand_Var_Pop_Fields = {
  __typename?: 'brand_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Brand_Var_Samp_Fields = {
  __typename?: 'brand_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Brand_Variance_Fields = {
  __typename?: 'brand_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "breeder" */
export type Breeder = {
  __typename?: 'breeder';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  /** An array relationship */
  crop_variety_breeders: Array<Crop_Variety_Breeder>;
  /** An aggregate relationship */
  crop_variety_breeders_aggregate: Crop_Variety_Breeder_Aggregate;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};


/** columns and relationships of "breeder" */
export type BreederCrop_Variety_BreedersArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


/** columns and relationships of "breeder" */
export type BreederCrop_Variety_Breeders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};

/** aggregated selection of "breeder" */
export type Breeder_Aggregate = {
  __typename?: 'breeder_aggregate';
  aggregate?: Maybe<Breeder_Aggregate_Fields>;
  nodes: Array<Breeder>;
};

/** aggregate fields of "breeder" */
export type Breeder_Aggregate_Fields = {
  __typename?: 'breeder_aggregate_fields';
  avg?: Maybe<Breeder_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Breeder_Max_Fields>;
  min?: Maybe<Breeder_Min_Fields>;
  stddev?: Maybe<Breeder_Stddev_Fields>;
  stddev_pop?: Maybe<Breeder_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Breeder_Stddev_Samp_Fields>;
  sum?: Maybe<Breeder_Sum_Fields>;
  var_pop?: Maybe<Breeder_Var_Pop_Fields>;
  var_samp?: Maybe<Breeder_Var_Samp_Fields>;
  variance?: Maybe<Breeder_Variance_Fields>;
};


/** aggregate fields of "breeder" */
export type Breeder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Breeder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Breeder_Avg_Fields = {
  __typename?: 'breeder_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "breeder". All fields are combined with a logical 'AND'. */
export type Breeder_Bool_Exp = {
  _and?: InputMaybe<Array<Breeder_Bool_Exp>>;
  _not?: InputMaybe<Breeder_Bool_Exp>;
  _or?: InputMaybe<Array<Breeder_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  crop_variety_breeders?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "breeder" */
export enum Breeder_Constraint {
  /** unique or primary key constraint on columns "codename" */
  BreederCodenameKey = 'breeder_codename_key',
  /** unique or primary key constraint on columns "name", "address_id" */
  BreederNameAddressId_60383612Uniq = 'breeder_name_address_id_60383612_uniq',
  /** unique or primary key constraint on columns "id" */
  BreederPkey = 'breeder_pkey'
}

/** input type for incrementing numeric columns in table "breeder" */
export type Breeder_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "breeder" */
export type Breeder_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  crop_variety_breeders?: InputMaybe<Crop_Variety_Breeder_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Breeder_Max_Fields = {
  __typename?: 'breeder_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Breeder_Min_Fields = {
  __typename?: 'breeder_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "breeder" */
export type Breeder_Mutation_Response = {
  __typename?: 'breeder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Breeder>;
};

/** input type for inserting object relation for remote table "breeder" */
export type Breeder_Obj_Rel_Insert_Input = {
  data: Breeder_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Breeder_On_Conflict>;
};

/** on_conflict condition type for table "breeder" */
export type Breeder_On_Conflict = {
  constraint: Breeder_Constraint;
  update_columns?: Array<Breeder_Update_Column>;
  where?: InputMaybe<Breeder_Bool_Exp>;
};

/** Ordering options when selecting data from "breeder". */
export type Breeder_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  crop_variety_breeders_aggregate?: InputMaybe<Crop_Variety_Breeder_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: breeder */
export type Breeder_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "breeder" */
export enum Breeder_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "breeder" */
export type Breeder_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Breeder_Stddev_Fields = {
  __typename?: 'breeder_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Breeder_Stddev_Pop_Fields = {
  __typename?: 'breeder_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Breeder_Stddev_Samp_Fields = {
  __typename?: 'breeder_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "breeder" */
export type Breeder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Breeder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Breeder_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Breeder_Sum_Fields = {
  __typename?: 'breeder_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "breeder" */
export enum Breeder_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Breeder_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Breeder_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Breeder_Set_Input>;
  where: Breeder_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Breeder_Var_Pop_Fields = {
  __typename?: 'breeder_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Breeder_Var_Samp_Fields = {
  __typename?: 'breeder_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Breeder_Variance_Fields = {
  __typename?: 'breeder_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "business" */
export type Business = {
  __typename?: 'business';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  alternate_email: Scalars['String'];
  /** The business's own bank accounts (payment_detail owned by trade.Business) */
  bank_accounts?: Maybe<Array<Payment_Detail>>;
  /** The business's own documents (document owned by trade.Business) */
  business_documents?: Maybe<Array<Document>>;
  category?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  /** An array relationship */
  commodities_supplied: Array<Business_Commodities_Supplied>;
  /** An aggregate relationship */
  commodities_supplied_aggregate: Business_Commodities_Supplied_Aggregate;
  /** An array relationship */
  companies: Array<Business_Companies>;
  /** An aggregate relationship */
  companies_aggregate: Business_Companies_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  data_consent?: Maybe<Media>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  email: Scalars['String'];
  /** An array relationship */
  groups: Array<Business_Groups>;
  /** An aggregate relationship */
  groups_aggregate: Business_Groups_Aggregate;
  /** An object relationship */
  gst_vendor?: Maybe<Business_Field>;
  gst_vendor_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  incorporated_on?: Maybe<Scalars['date']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  kind: Scalars['String'];
  metadata: Scalars['jsonb'];
  /** An object relationship */
  msme_status?: Maybe<Business_Field>;
  msme_status_id?: Maybe<Scalars['Int']>;
  msme_type_id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Business_Network>;
  /** An aggregate relationship */
  networks_aggregate: Business_Network_Aggregate;
  number: Scalars['String'];
  payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** An object relationship */
  primary_poc?: Maybe<Base_User>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  secondary_number: Scalars['String'];
  /** An array relationship */
  secondary_pocs: Array<Business_Secondary_Pocs>;
  /** An aggregate relationship */
  secondary_pocs_aggregate: Business_Secondary_Pocs_Aggregate;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  verification_done_by?: Maybe<Base_User>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "business" */
export type BusinessBank_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessBusiness_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessCommodities_SuppliedArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessCommodities_Supplied_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business" */
export type BusinessGroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business" */
export type BusinessNetworksArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business" */
export type BusinessSecondary_PocsArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


/** columns and relationships of "business" */
export type BusinessSecondary_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};

/** aggregated selection of "business" */
export type Business_Aggregate = {
  __typename?: 'business_aggregate';
  aggregate?: Maybe<Business_Aggregate_Fields>;
  nodes: Array<Business>;
};

/** aggregate fields of "business" */
export type Business_Aggregate_Fields = {
  __typename?: 'business_aggregate_fields';
  avg?: Maybe<Business_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Max_Fields>;
  min?: Maybe<Business_Min_Fields>;
  stddev?: Maybe<Business_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Sum_Fields>;
  var_pop?: Maybe<Business_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Var_Samp_Fields>;
  variance?: Maybe<Business_Variance_Fields>;
};


/** aggregate fields of "business" */
export type Business_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business" */
export type Business_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Max_Order_By>;
  min?: InputMaybe<Business_Min_Order_By>;
  stddev?: InputMaybe<Business_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Business_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "business" */
export type Business_Arr_Rel_Insert_Input = {
  data: Array<Business_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Avg_Fields = {
  __typename?: 'business_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  gst_vendor_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  msme_status_id?: Maybe<Scalars['Float']>;
  msme_type_id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business" */
export type Business_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business". All fields are combined with a logical 'AND'. */
export type Business_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Bool_Exp>>;
  _not?: InputMaybe<Business_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  alternate_email?: InputMaybe<String_Comparison_Exp>;
  bank_accounts?: InputMaybe<Payment_Detail_Bool_Exp>;
  business_documents?: InputMaybe<Document_Bool_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodities_supplied?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
  companies?: InputMaybe<Business_Companies_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent?: InputMaybe<Media_Bool_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Business_Groups_Bool_Exp>;
  gst_vendor?: InputMaybe<Business_Field_Bool_Exp>;
  gst_vendor_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incorporated_on?: InputMaybe<Date_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  msme_status?: InputMaybe<Business_Field_Bool_Exp>;
  msme_status_id?: InputMaybe<Int_Comparison_Exp>;
  msme_type_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Business_Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  primary_poc?: InputMaybe<Base_User_Bool_Exp>;
  primary_poc_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  secondary_pocs?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "business_commodities_supplied" */
export type Business_Commodities_Supplied = {
  __typename?: 'business_commodities_supplied';
  /** An object relationship */
  business: Business;
  business_id: Scalars['Int'];
  /** An object relationship */
  commodity: Commodity;
  commodity_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate = {
  __typename?: 'business_commodities_supplied_aggregate';
  aggregate?: Maybe<Business_Commodities_Supplied_Aggregate_Fields>;
  nodes: Array<Business_Commodities_Supplied>;
};

/** aggregate fields of "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate_Fields = {
  __typename?: 'business_commodities_supplied_aggregate_fields';
  avg?: Maybe<Business_Commodities_Supplied_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Commodities_Supplied_Max_Fields>;
  min?: Maybe<Business_Commodities_Supplied_Min_Fields>;
  stddev?: Maybe<Business_Commodities_Supplied_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Commodities_Supplied_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Commodities_Supplied_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Commodities_Supplied_Sum_Fields>;
  var_pop?: Maybe<Business_Commodities_Supplied_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Commodities_Supplied_Var_Samp_Fields>;
  variance?: Maybe<Business_Commodities_Supplied_Variance_Fields>;
};


/** aggregate fields of "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Commodities_Supplied_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Commodities_Supplied_Max_Order_By>;
  min?: InputMaybe<Business_Commodities_Supplied_Min_Order_By>;
  stddev?: InputMaybe<Business_Commodities_Supplied_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Commodities_Supplied_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Commodities_Supplied_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Commodities_Supplied_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Commodities_Supplied_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Commodities_Supplied_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Commodities_Supplied_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Arr_Rel_Insert_Input = {
  data: Array<Business_Commodities_Supplied_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Commodities_Supplied_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Commodities_Supplied_Avg_Fields = {
  __typename?: 'business_commodities_supplied_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_commodities_supplied". All fields are combined with a logical 'AND'. */
export type Business_Commodities_Supplied_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Commodities_Supplied_Bool_Exp>>;
  _not?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Commodities_Supplied_Bool_Exp>>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  commodity?: InputMaybe<Commodity_Bool_Exp>;
  commodity_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_commodities_supplied" */
export enum Business_Commodities_Supplied_Constraint {
  /** unique or primary key constraint on columns "business_id", "commodity_id" */
  BusinessCommoditiesSupBusinessIdCommodityId_0723bd2cUniq = 'business_commodities_sup_business_id_commodity_id_0723bd2c_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessCommoditiesSuppliedPkey = 'business_commodities_supplied_pkey'
}

/** input type for incrementing numeric columns in table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Insert_Input = {
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  commodity?: InputMaybe<Commodity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Commodities_Supplied_Max_Fields = {
  __typename?: 'business_commodities_supplied_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  commodity_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Commodities_Supplied_Min_Fields = {
  __typename?: 'business_commodities_supplied_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  commodity_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Mutation_Response = {
  __typename?: 'business_commodities_supplied_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Commodities_Supplied>;
};

/** on_conflict condition type for table "business_commodities_supplied" */
export type Business_Commodities_Supplied_On_Conflict = {
  constraint: Business_Commodities_Supplied_Constraint;
  update_columns?: Array<Business_Commodities_Supplied_Update_Column>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};

/** Ordering options when selecting data from "business_commodities_supplied". */
export type Business_Commodities_Supplied_Order_By = {
  business?: InputMaybe<Business_Order_By>;
  business_id?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Commodity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_commodities_supplied */
export type Business_Commodities_Supplied_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_commodities_supplied" */
export enum Business_Commodities_Supplied_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Commodities_Supplied_Stddev_Fields = {
  __typename?: 'business_commodities_supplied_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Commodities_Supplied_Stddev_Pop_Fields = {
  __typename?: 'business_commodities_supplied_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Commodities_Supplied_Stddev_Samp_Fields = {
  __typename?: 'business_commodities_supplied_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Commodities_Supplied_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Commodities_Supplied_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Commodities_Supplied_Sum_Fields = {
  __typename?: 'business_commodities_supplied_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  commodity_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_commodities_supplied" */
export enum Business_Commodities_Supplied_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  Id = 'id'
}

export type Business_Commodities_Supplied_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Commodities_Supplied_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Commodities_Supplied_Set_Input>;
  where: Business_Commodities_Supplied_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Commodities_Supplied_Var_Pop_Fields = {
  __typename?: 'business_commodities_supplied_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Commodities_Supplied_Var_Samp_Fields = {
  __typename?: 'business_commodities_supplied_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Commodities_Supplied_Variance_Fields = {
  __typename?: 'business_commodities_supplied_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_commodities_supplied" */
export type Business_Commodities_Supplied_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "business_companies" */
export type Business_Companies = {
  __typename?: 'business_companies';
  /** An object relationship */
  business: Business;
  business_id: Scalars['Int'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_companies" */
export type Business_Companies_Aggregate = {
  __typename?: 'business_companies_aggregate';
  aggregate?: Maybe<Business_Companies_Aggregate_Fields>;
  nodes: Array<Business_Companies>;
};

/** aggregate fields of "business_companies" */
export type Business_Companies_Aggregate_Fields = {
  __typename?: 'business_companies_aggregate_fields';
  avg?: Maybe<Business_Companies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Companies_Max_Fields>;
  min?: Maybe<Business_Companies_Min_Fields>;
  stddev?: Maybe<Business_Companies_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Companies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Companies_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Companies_Sum_Fields>;
  var_pop?: Maybe<Business_Companies_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Companies_Var_Samp_Fields>;
  variance?: Maybe<Business_Companies_Variance_Fields>;
};


/** aggregate fields of "business_companies" */
export type Business_Companies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Companies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_companies" */
export type Business_Companies_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Companies_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Companies_Max_Order_By>;
  min?: InputMaybe<Business_Companies_Min_Order_By>;
  stddev?: InputMaybe<Business_Companies_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Companies_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Companies_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Companies_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Companies_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Companies_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Companies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_companies" */
export type Business_Companies_Arr_Rel_Insert_Input = {
  data: Array<Business_Companies_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Companies_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Companies_Avg_Fields = {
  __typename?: 'business_companies_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_companies" */
export type Business_Companies_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_companies". All fields are combined with a logical 'AND'. */
export type Business_Companies_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Companies_Bool_Exp>>;
  _not?: InputMaybe<Business_Companies_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Companies_Bool_Exp>>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_companies" */
export enum Business_Companies_Constraint {
  /** unique or primary key constraint on columns "business_id", "company_id" */
  BusinessCompaniesBusinessIdCompanyId_67e79b00Uniq = 'business_companies_business_id_company_id_67e79b00_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessCompaniesPkey = 'business_companies_pkey'
}

/** input type for incrementing numeric columns in table "business_companies" */
export type Business_Companies_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_companies" */
export type Business_Companies_Insert_Input = {
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Companies_Max_Fields = {
  __typename?: 'business_companies_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_companies" */
export type Business_Companies_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Companies_Min_Fields = {
  __typename?: 'business_companies_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_companies" */
export type Business_Companies_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_companies" */
export type Business_Companies_Mutation_Response = {
  __typename?: 'business_companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Companies>;
};

/** on_conflict condition type for table "business_companies" */
export type Business_Companies_On_Conflict = {
  constraint: Business_Companies_Constraint;
  update_columns?: Array<Business_Companies_Update_Column>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "business_companies". */
export type Business_Companies_Order_By = {
  business?: InputMaybe<Business_Order_By>;
  business_id?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_companies */
export type Business_Companies_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_companies" */
export enum Business_Companies_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_companies" */
export type Business_Companies_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Companies_Stddev_Fields = {
  __typename?: 'business_companies_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_companies" */
export type Business_Companies_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Companies_Stddev_Pop_Fields = {
  __typename?: 'business_companies_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_companies" */
export type Business_Companies_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Companies_Stddev_Samp_Fields = {
  __typename?: 'business_companies_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_companies" */
export type Business_Companies_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_companies" */
export type Business_Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Companies_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Companies_Sum_Fields = {
  __typename?: 'business_companies_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_companies" */
export type Business_Companies_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_companies" */
export enum Business_Companies_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id'
}

export type Business_Companies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Companies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Companies_Set_Input>;
  where: Business_Companies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Companies_Var_Pop_Fields = {
  __typename?: 'business_companies_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_companies" */
export type Business_Companies_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Companies_Var_Samp_Fields = {
  __typename?: 'business_companies_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_companies" */
export type Business_Companies_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Companies_Variance_Fields = {
  __typename?: 'business_companies_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_companies" */
export type Business_Companies_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "business" */
export enum Business_Constraint {
  /** unique or primary key constraint on columns "codename" */
  BusinessCodenameKey = 'business_codename_key',
  /** unique or primary key constraint on columns "data_consent_id" */
  BusinessDataConsentIdKey = 'business_data_consent_id_key',
  /** unique or primary key constraint on columns "id" */
  BusinessPkey = 'business_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Business_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Business_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Business_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "business_field" */
export type Business_Field = {
  __typename?: 'business_field';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  external_code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "business_field" */
export type Business_Field_Aggregate = {
  __typename?: 'business_field_aggregate';
  aggregate?: Maybe<Business_Field_Aggregate_Fields>;
  nodes: Array<Business_Field>;
};

/** aggregate fields of "business_field" */
export type Business_Field_Aggregate_Fields = {
  __typename?: 'business_field_aggregate_fields';
  avg?: Maybe<Business_Field_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Field_Max_Fields>;
  min?: Maybe<Business_Field_Min_Fields>;
  stddev?: Maybe<Business_Field_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Field_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Field_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Field_Sum_Fields>;
  var_pop?: Maybe<Business_Field_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Field_Var_Samp_Fields>;
  variance?: Maybe<Business_Field_Variance_Fields>;
};


/** aggregate fields of "business_field" */
export type Business_Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Business_Field_Avg_Fields = {
  __typename?: 'business_field_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "business_field". All fields are combined with a logical 'AND'. */
export type Business_Field_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Field_Bool_Exp>>;
  _not?: InputMaybe<Business_Field_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Field_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_field" */
export enum Business_Field_Constraint {
  /** unique or primary key constraint on columns "codename" */
  BusinessFieldCodenameKey = 'business_field_codename_key',
  /** unique or primary key constraint on columns "id" */
  BusinessFieldPkey = 'business_field_pkey'
}

/** input type for incrementing numeric columns in table "business_field" */
export type Business_Field_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_field" */
export type Business_Field_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Business_Field_Max_Fields = {
  __typename?: 'business_field_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Business_Field_Min_Fields = {
  __typename?: 'business_field_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "business_field" */
export type Business_Field_Mutation_Response = {
  __typename?: 'business_field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Field>;
};

/** input type for inserting object relation for remote table "business_field" */
export type Business_Field_Obj_Rel_Insert_Input = {
  data: Business_Field_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Field_On_Conflict>;
};

/** on_conflict condition type for table "business_field" */
export type Business_Field_On_Conflict = {
  constraint: Business_Field_Constraint;
  update_columns?: Array<Business_Field_Update_Column>;
  where?: InputMaybe<Business_Field_Bool_Exp>;
};

/** Ordering options when selecting data from "business_field". */
export type Business_Field_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_field */
export type Business_Field_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_field" */
export enum Business_Field_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalCode = 'external_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "business_field" */
export type Business_Field_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Business_Field_Stddev_Fields = {
  __typename?: 'business_field_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Business_Field_Stddev_Pop_Fields = {
  __typename?: 'business_field_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Business_Field_Stddev_Samp_Fields = {
  __typename?: 'business_field_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "business_field" */
export type Business_Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Field_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Business_Field_Sum_Fields = {
  __typename?: 'business_field_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "business_field" */
export enum Business_Field_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalCode = 'external_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

export type Business_Field_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Field_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Field_Set_Input>;
  where: Business_Field_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Field_Var_Pop_Fields = {
  __typename?: 'business_field_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Business_Field_Var_Samp_Fields = {
  __typename?: 'business_field_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Business_Field_Variance_Fields = {
  __typename?: 'business_field_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "business_group" */
export type Business_Group = {
  __typename?: 'business_group';
  /** An array relationship */
  businesses: Array<Business_Groups>;
  /** An aggregate relationship */
  businesses_aggregate: Business_Groups_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Business_Group_Network>;
  /** An aggregate relationship */
  networks_aggregate: Business_Group_Network_Aggregate;
  /** An object relationship */
  parent_business?: Maybe<Business>;
  parent_business_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "business_group" */
export type Business_GroupBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business_group" */
export type Business_GroupBusinesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


/** columns and relationships of "business_group" */
export type Business_GroupDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "business_group" */
export type Business_GroupNetworksArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


/** columns and relationships of "business_group" */
export type Business_GroupNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};

/** aggregated selection of "business_group" */
export type Business_Group_Aggregate = {
  __typename?: 'business_group_aggregate';
  aggregate?: Maybe<Business_Group_Aggregate_Fields>;
  nodes: Array<Business_Group>;
};

/** aggregate fields of "business_group" */
export type Business_Group_Aggregate_Fields = {
  __typename?: 'business_group_aggregate_fields';
  avg?: Maybe<Business_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Group_Max_Fields>;
  min?: Maybe<Business_Group_Min_Fields>;
  stddev?: Maybe<Business_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Group_Sum_Fields>;
  var_pop?: Maybe<Business_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Group_Var_Samp_Fields>;
  variance?: Maybe<Business_Group_Variance_Fields>;
};


/** aggregate fields of "business_group" */
export type Business_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Business_Group_Avg_Fields = {
  __typename?: 'business_group_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "business_group". All fields are combined with a logical 'AND'. */
export type Business_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Group_Bool_Exp>>;
  _not?: InputMaybe<Business_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Group_Bool_Exp>>;
  businesses?: InputMaybe<Business_Groups_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Business_Group_Network_Bool_Exp>;
  parent_business?: InputMaybe<Business_Bool_Exp>;
  parent_business_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_group" */
export enum Business_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  BusinessGroupCodenameKey = 'business_group_codename_key',
  /** unique or primary key constraint on columns "id" */
  BusinessGroupPkey = 'business_group_pkey'
}

/** input type for incrementing numeric columns in table "business_group" */
export type Business_Group_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_group" */
export type Business_Group_Insert_Input = {
  businesses?: InputMaybe<Business_Groups_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Business_Group_Network_Arr_Rel_Insert_Input>;
  parent_business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Group_Max_Fields = {
  __typename?: 'business_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_business_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Business_Group_Min_Fields = {
  __typename?: 'business_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_business_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "business_group" */
export type Business_Group_Mutation_Response = {
  __typename?: 'business_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Group>;
};

/** columns and relationships of "business_group_network" */
export type Business_Group_Network = {
  __typename?: 'business_group_network';
  business_group_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "business_group_network" */
export type Business_Group_Network_Aggregate = {
  __typename?: 'business_group_network_aggregate';
  aggregate?: Maybe<Business_Group_Network_Aggregate_Fields>;
  nodes: Array<Business_Group_Network>;
};

/** aggregate fields of "business_group_network" */
export type Business_Group_Network_Aggregate_Fields = {
  __typename?: 'business_group_network_aggregate_fields';
  avg?: Maybe<Business_Group_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Group_Network_Max_Fields>;
  min?: Maybe<Business_Group_Network_Min_Fields>;
  stddev?: Maybe<Business_Group_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Group_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Group_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Group_Network_Sum_Fields>;
  var_pop?: Maybe<Business_Group_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Group_Network_Var_Samp_Fields>;
  variance?: Maybe<Business_Group_Network_Variance_Fields>;
};


/** aggregate fields of "business_group_network" */
export type Business_Group_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_group_network" */
export type Business_Group_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Group_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Group_Network_Max_Order_By>;
  min?: InputMaybe<Business_Group_Network_Min_Order_By>;
  stddev?: InputMaybe<Business_Group_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Group_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Group_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Group_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Group_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Group_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Group_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_group_network" */
export type Business_Group_Network_Arr_Rel_Insert_Input = {
  data: Array<Business_Group_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Group_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Group_Network_Avg_Fields = {
  __typename?: 'business_group_network_avg_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_group_network" */
export type Business_Group_Network_Avg_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_group_network". All fields are combined with a logical 'AND'. */
export type Business_Group_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Group_Network_Bool_Exp>>;
  _not?: InputMaybe<Business_Group_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Group_Network_Bool_Exp>>;
  business_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_group_network" */
export enum Business_Group_Network_Constraint {
  /** unique or primary key constraint on columns "business_group_id", "network_id" */
  BusinessGroupNetworkNetworkIdBusinessGrouD4e88bbbUniq = 'business_group_network_network_id_business_grou_d4e88bbb_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessGroupNetworkPkey = 'business_group_network_pkey'
}

/** input type for incrementing numeric columns in table "business_group_network" */
export type Business_Group_Network_Inc_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_group_network" */
export type Business_Group_Network_Insert_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Business_Group_Network_Max_Fields = {
  __typename?: 'business_group_network_max_fields';
  business_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_group_network" */
export type Business_Group_Network_Max_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Group_Network_Min_Fields = {
  __typename?: 'business_group_network_min_fields';
  business_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_group_network" */
export type Business_Group_Network_Min_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_group_network" */
export type Business_Group_Network_Mutation_Response = {
  __typename?: 'business_group_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Group_Network>;
};

/** on_conflict condition type for table "business_group_network" */
export type Business_Group_Network_On_Conflict = {
  constraint: Business_Group_Network_Constraint;
  update_columns?: Array<Business_Group_Network_Update_Column>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "business_group_network". */
export type Business_Group_Network_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_group_network */
export type Business_Group_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_group_network" */
export enum Business_Group_Network_Select_Column {
  /** column name */
  BusinessGroupId = 'business_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "business_group_network" */
export type Business_Group_Network_Set_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Business_Group_Network_Stddev_Fields = {
  __typename?: 'business_group_network_stddev_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_group_network" */
export type Business_Group_Network_Stddev_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Group_Network_Stddev_Pop_Fields = {
  __typename?: 'business_group_network_stddev_pop_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_group_network" */
export type Business_Group_Network_Stddev_Pop_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Group_Network_Stddev_Samp_Fields = {
  __typename?: 'business_group_network_stddev_samp_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_group_network" */
export type Business_Group_Network_Stddev_Samp_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_group_network" */
export type Business_Group_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Group_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Group_Network_Stream_Cursor_Value_Input = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Business_Group_Network_Sum_Fields = {
  __typename?: 'business_group_network_sum_fields';
  business_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_group_network" */
export type Business_Group_Network_Sum_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "business_group_network" */
export enum Business_Group_Network_Update_Column {
  /** column name */
  BusinessGroupId = 'business_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Business_Group_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Group_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Group_Network_Set_Input>;
  where: Business_Group_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Group_Network_Var_Pop_Fields = {
  __typename?: 'business_group_network_var_pop_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_group_network" */
export type Business_Group_Network_Var_Pop_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Group_Network_Var_Samp_Fields = {
  __typename?: 'business_group_network_var_samp_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_group_network" */
export type Business_Group_Network_Var_Samp_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Group_Network_Variance_Fields = {
  __typename?: 'business_group_network_variance_fields';
  business_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_group_network" */
export type Business_Group_Network_Variance_Order_By = {
  business_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "business_group" */
export type Business_Group_Obj_Rel_Insert_Input = {
  data: Business_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Group_On_Conflict>;
};

/** on_conflict condition type for table "business_group" */
export type Business_Group_On_Conflict = {
  constraint: Business_Group_Constraint;
  update_columns?: Array<Business_Group_Update_Column>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "business_group". */
export type Business_Group_Order_By = {
  businesses_aggregate?: InputMaybe<Business_Groups_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Business_Group_Network_Aggregate_Order_By>;
  parent_business?: InputMaybe<Business_Order_By>;
  parent_business_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_group */
export type Business_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_group" */
export enum Business_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentBusinessId = 'parent_business_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "business_group" */
export type Business_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Group_Stddev_Fields = {
  __typename?: 'business_group_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Business_Group_Stddev_Pop_Fields = {
  __typename?: 'business_group_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Business_Group_Stddev_Samp_Fields = {
  __typename?: 'business_group_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "business_group" */
export type Business_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_business_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Group_Sum_Fields = {
  __typename?: 'business_group_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_business_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "business_group" */
export enum Business_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentBusinessId = 'parent_business_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Business_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Group_Set_Input>;
  where: Business_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Group_Var_Pop_Fields = {
  __typename?: 'business_group_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Business_Group_Var_Samp_Fields = {
  __typename?: 'business_group_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Business_Group_Variance_Fields = {
  __typename?: 'business_group_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_business_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "business_groups" */
export type Business_Groups = {
  __typename?: 'business_groups';
  /** An object relationship */
  business: Business;
  /** An object relationship */
  business_group: Business_Group;
  business_id: Scalars['Int'];
  businessgroup_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_groups" */
export type Business_Groups_Aggregate = {
  __typename?: 'business_groups_aggregate';
  aggregate?: Maybe<Business_Groups_Aggregate_Fields>;
  nodes: Array<Business_Groups>;
};

/** aggregate fields of "business_groups" */
export type Business_Groups_Aggregate_Fields = {
  __typename?: 'business_groups_aggregate_fields';
  avg?: Maybe<Business_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Groups_Max_Fields>;
  min?: Maybe<Business_Groups_Min_Fields>;
  stddev?: Maybe<Business_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Groups_Sum_Fields>;
  var_pop?: Maybe<Business_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Groups_Var_Samp_Fields>;
  variance?: Maybe<Business_Groups_Variance_Fields>;
};


/** aggregate fields of "business_groups" */
export type Business_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_groups" */
export type Business_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Groups_Max_Order_By>;
  min?: InputMaybe<Business_Groups_Min_Order_By>;
  stddev?: InputMaybe<Business_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_groups" */
export type Business_Groups_Arr_Rel_Insert_Input = {
  data: Array<Business_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Groups_Avg_Fields = {
  __typename?: 'business_groups_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_groups" */
export type Business_Groups_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_groups". All fields are combined with a logical 'AND'. */
export type Business_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Groups_Bool_Exp>>;
  _not?: InputMaybe<Business_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Groups_Bool_Exp>>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_group?: InputMaybe<Business_Group_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  businessgroup_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_groups" */
export enum Business_Groups_Constraint {
  /** unique or primary key constraint on columns "business_id", "businessgroup_id" */
  BusinessGroupsBusinessIdBusinessgroupIdC612bb8cUniq = 'business_groups_business_id_businessgroup_id_c612bb8c_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessGroupsPkey = 'business_groups_pkey'
}

/** input type for incrementing numeric columns in table "business_groups" */
export type Business_Groups_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_groups" */
export type Business_Groups_Insert_Input = {
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_group?: InputMaybe<Business_Group_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Groups_Max_Fields = {
  __typename?: 'business_groups_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  businessgroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_groups" */
export type Business_Groups_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Groups_Min_Fields = {
  __typename?: 'business_groups_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  businessgroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_groups" */
export type Business_Groups_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_groups" */
export type Business_Groups_Mutation_Response = {
  __typename?: 'business_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Groups>;
};

/** on_conflict condition type for table "business_groups" */
export type Business_Groups_On_Conflict = {
  constraint: Business_Groups_Constraint;
  update_columns?: Array<Business_Groups_Update_Column>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "business_groups". */
export type Business_Groups_Order_By = {
  business?: InputMaybe<Business_Order_By>;
  business_group?: InputMaybe<Business_Group_Order_By>;
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_groups */
export type Business_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_groups" */
export enum Business_Groups_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  BusinessgroupId = 'businessgroup_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_groups" */
export type Business_Groups_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Groups_Stddev_Fields = {
  __typename?: 'business_groups_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_groups" */
export type Business_Groups_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Groups_Stddev_Pop_Fields = {
  __typename?: 'business_groups_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_groups" */
export type Business_Groups_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Groups_Stddev_Samp_Fields = {
  __typename?: 'business_groups_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_groups" */
export type Business_Groups_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_groups" */
export type Business_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Groups_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  businessgroup_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Groups_Sum_Fields = {
  __typename?: 'business_groups_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  businessgroup_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_groups" */
export type Business_Groups_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_groups" */
export enum Business_Groups_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  BusinessgroupId = 'businessgroup_id',
  /** column name */
  Id = 'id'
}

export type Business_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Groups_Set_Input>;
  where: Business_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Groups_Var_Pop_Fields = {
  __typename?: 'business_groups_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_groups" */
export type Business_Groups_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Groups_Var_Samp_Fields = {
  __typename?: 'business_groups_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_groups" */
export type Business_Groups_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Groups_Variance_Fields = {
  __typename?: 'business_groups_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  businessgroup_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_groups" */
export type Business_Groups_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  businessgroup_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "business" */
export type Business_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  gst_vendor_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  msme_status_id?: InputMaybe<Scalars['Int']>;
  msme_type_id?: InputMaybe<Scalars['Int']>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business" */
export type Business_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  alternate_email?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  commodities_supplied?: InputMaybe<Business_Commodities_Supplied_Arr_Rel_Insert_Input>;
  companies?: InputMaybe<Business_Companies_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Business_Groups_Arr_Rel_Insert_Input>;
  gst_vendor?: InputMaybe<Business_Field_Obj_Rel_Insert_Input>;
  gst_vendor_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  incorporated_on?: InputMaybe<Scalars['date']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  msme_status?: InputMaybe<Business_Field_Obj_Rel_Insert_Input>;
  msme_status_id?: InputMaybe<Scalars['Int']>;
  msme_type_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Business_Network_Arr_Rel_Insert_Input>;
  number?: InputMaybe<Scalars['String']>;
  primary_poc?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_pocs?: InputMaybe<Business_Secondary_Pocs_Arr_Rel_Insert_Input>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Business_Max_Fields = {
  __typename?: 'business_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  alternate_email?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gst_vendor_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  incorporated_on?: Maybe<Scalars['date']>;
  kind?: Maybe<Scalars['String']>;
  msme_status_id?: Maybe<Scalars['Int']>;
  msme_type_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  secondary_number?: Maybe<Scalars['String']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "business" */
export type Business_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  alternate_email?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incorporated_on?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Min_Fields = {
  __typename?: 'business_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  alternate_email?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gst_vendor_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  incorporated_on?: Maybe<Scalars['date']>;
  kind?: Maybe<Scalars['String']>;
  msme_status_id?: Maybe<Scalars['Int']>;
  msme_type_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  secondary_number?: Maybe<Scalars['String']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "business" */
export type Business_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  alternate_email?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incorporated_on?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business" */
export type Business_Mutation_Response = {
  __typename?: 'business_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business>;
};

/** columns and relationships of "business_network" */
export type Business_Network = {
  __typename?: 'business_network';
  business_id: Scalars['Int'];
  id: Scalars['Int'];
  network_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "business_network" */
export type Business_Network_Aggregate = {
  __typename?: 'business_network_aggregate';
  aggregate?: Maybe<Business_Network_Aggregate_Fields>;
  nodes: Array<Business_Network>;
};

/** aggregate fields of "business_network" */
export type Business_Network_Aggregate_Fields = {
  __typename?: 'business_network_aggregate_fields';
  avg?: Maybe<Business_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Network_Max_Fields>;
  min?: Maybe<Business_Network_Min_Fields>;
  stddev?: Maybe<Business_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Network_Sum_Fields>;
  var_pop?: Maybe<Business_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Network_Var_Samp_Fields>;
  variance?: Maybe<Business_Network_Variance_Fields>;
};


/** aggregate fields of "business_network" */
export type Business_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_network" */
export type Business_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Network_Max_Order_By>;
  min?: InputMaybe<Business_Network_Min_Order_By>;
  stddev?: InputMaybe<Business_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_network" */
export type Business_Network_Arr_Rel_Insert_Input = {
  data: Array<Business_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Network_Avg_Fields = {
  __typename?: 'business_network_avg_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_network" */
export type Business_Network_Avg_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_network". All fields are combined with a logical 'AND'. */
export type Business_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Network_Bool_Exp>>;
  _not?: InputMaybe<Business_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Network_Bool_Exp>>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_network" */
export enum Business_Network_Constraint {
  /** unique or primary key constraint on columns "business_id", "network_id" */
  BusinessNetworkNetworkIdBusinessId_7b858af5Uniq = 'business_network_network_id_business_id_7b858af5_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessNetworkPkey = 'business_network_pkey'
}

/** input type for incrementing numeric columns in table "business_network" */
export type Business_Network_Inc_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_network" */
export type Business_Network_Insert_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Business_Network_Max_Fields = {
  __typename?: 'business_network_max_fields';
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_network" */
export type Business_Network_Max_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Network_Min_Fields = {
  __typename?: 'business_network_min_fields';
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_network" */
export type Business_Network_Min_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_network" */
export type Business_Network_Mutation_Response = {
  __typename?: 'business_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Network>;
};

/** on_conflict condition type for table "business_network" */
export type Business_Network_On_Conflict = {
  constraint: Business_Network_Constraint;
  update_columns?: Array<Business_Network_Update_Column>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "business_network". */
export type Business_Network_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_network */
export type Business_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_network" */
export enum Business_Network_Select_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "business_network" */
export type Business_Network_Set_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Business_Network_Stddev_Fields = {
  __typename?: 'business_network_stddev_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_network" */
export type Business_Network_Stddev_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Network_Stddev_Pop_Fields = {
  __typename?: 'business_network_stddev_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_network" */
export type Business_Network_Stddev_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Network_Stddev_Samp_Fields = {
  __typename?: 'business_network_stddev_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_network" */
export type Business_Network_Stddev_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_network" */
export type Business_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Network_Stream_Cursor_Value_Input = {
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Business_Network_Sum_Fields = {
  __typename?: 'business_network_sum_fields';
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_network" */
export type Business_Network_Sum_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "business_network" */
export enum Business_Network_Update_Column {
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Business_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Network_Set_Input>;
  where: Business_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Network_Var_Pop_Fields = {
  __typename?: 'business_network_var_pop_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_network" */
export type Business_Network_Var_Pop_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Network_Var_Samp_Fields = {
  __typename?: 'business_network_var_samp_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_network" */
export type Business_Network_Var_Samp_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Network_Variance_Fields = {
  __typename?: 'business_network_variance_fields';
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_network" */
export type Business_Network_Variance_Order_By = {
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "business" */
export type Business_Obj_Rel_Insert_Input = {
  data: Business_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_On_Conflict>;
};

/** on_conflict condition type for table "business" */
export type Business_On_Conflict = {
  constraint: Business_Constraint;
  update_columns?: Array<Business_Update_Column>;
  where?: InputMaybe<Business_Bool_Exp>;
};

/** Ordering options when selecting data from "business". */
export type Business_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  alternate_email?: InputMaybe<Order_By>;
  bank_accounts_aggregate?: InputMaybe<Payment_Detail_Aggregate_Order_By>;
  business_documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  category?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  commodities_supplied_aggregate?: InputMaybe<Business_Commodities_Supplied_Aggregate_Order_By>;
  companies_aggregate?: InputMaybe<Business_Companies_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent?: InputMaybe<Media_Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  groups_aggregate?: InputMaybe<Business_Groups_Aggregate_Order_By>;
  gst_vendor?: InputMaybe<Business_Field_Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incorporated_on?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  msme_status?: InputMaybe<Business_Field_Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Business_Network_Aggregate_Order_By>;
  number?: InputMaybe<Order_By>;
  primary_poc?: InputMaybe<Base_User_Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  secondary_pocs_aggregate?: InputMaybe<Business_Secondary_Pocs_Aggregate_Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by?: InputMaybe<Base_User_Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business */
export type Business_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Business_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "business_secondary_pocs" */
export type Business_Secondary_Pocs = {
  __typename?: 'business_secondary_pocs';
  /** An object relationship */
  base_user: Base_User;
  baseuser_id: Scalars['Int'];
  /** An object relationship */
  business: Business;
  business_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate = {
  __typename?: 'business_secondary_pocs_aggregate';
  aggregate?: Maybe<Business_Secondary_Pocs_Aggregate_Fields>;
  nodes: Array<Business_Secondary_Pocs>;
};

/** aggregate fields of "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate_Fields = {
  __typename?: 'business_secondary_pocs_aggregate_fields';
  avg?: Maybe<Business_Secondary_Pocs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Business_Secondary_Pocs_Max_Fields>;
  min?: Maybe<Business_Secondary_Pocs_Min_Fields>;
  stddev?: Maybe<Business_Secondary_Pocs_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Secondary_Pocs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Secondary_Pocs_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Secondary_Pocs_Sum_Fields>;
  var_pop?: Maybe<Business_Secondary_Pocs_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Secondary_Pocs_Var_Samp_Fields>;
  variance?: Maybe<Business_Secondary_Pocs_Variance_Fields>;
};


/** aggregate fields of "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Aggregate_Order_By = {
  avg?: InputMaybe<Business_Secondary_Pocs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Business_Secondary_Pocs_Max_Order_By>;
  min?: InputMaybe<Business_Secondary_Pocs_Min_Order_By>;
  stddev?: InputMaybe<Business_Secondary_Pocs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Business_Secondary_Pocs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Business_Secondary_Pocs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Business_Secondary_Pocs_Sum_Order_By>;
  var_pop?: InputMaybe<Business_Secondary_Pocs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Business_Secondary_Pocs_Var_Samp_Order_By>;
  variance?: InputMaybe<Business_Secondary_Pocs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Arr_Rel_Insert_Input = {
  data: Array<Business_Secondary_Pocs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Business_Secondary_Pocs_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Secondary_Pocs_Avg_Fields = {
  __typename?: 'business_secondary_pocs_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_secondary_pocs". All fields are combined with a logical 'AND'. */
export type Business_Secondary_Pocs_Bool_Exp = {
  _and?: InputMaybe<Array<Business_Secondary_Pocs_Bool_Exp>>;
  _not?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
  _or?: InputMaybe<Array<Business_Secondary_Pocs_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  business?: InputMaybe<Business_Bool_Exp>;
  business_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_secondary_pocs" */
export enum Business_Secondary_Pocs_Constraint {
  /** unique or primary key constraint on columns "business_id", "baseuser_id" */
  BusinessSecondaryPocsBusinessIdBaseuserId_3daa2e65Uniq = 'business_secondary_pocs_business_id_baseuser_id_3daa2e65_uniq',
  /** unique or primary key constraint on columns "id" */
  BusinessSecondaryPocsPkey = 'business_secondary_pocs_pkey'
}

/** input type for incrementing numeric columns in table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business?: InputMaybe<Business_Obj_Rel_Insert_Input>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Business_Secondary_Pocs_Max_Fields = {
  __typename?: 'business_secondary_pocs_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Secondary_Pocs_Min_Fields = {
  __typename?: 'business_secondary_pocs_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Mutation_Response = {
  __typename?: 'business_secondary_pocs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Business_Secondary_Pocs>;
};

/** on_conflict condition type for table "business_secondary_pocs" */
export type Business_Secondary_Pocs_On_Conflict = {
  constraint: Business_Secondary_Pocs_Constraint;
  update_columns?: Array<Business_Secondary_Pocs_Update_Column>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};

/** Ordering options when selecting data from "business_secondary_pocs". */
export type Business_Secondary_Pocs_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  baseuser_id?: InputMaybe<Order_By>;
  business?: InputMaybe<Business_Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: business_secondary_pocs */
export type Business_Secondary_Pocs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "business_secondary_pocs" */
export enum Business_Secondary_Pocs_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Business_Secondary_Pocs_Stddev_Fields = {
  __typename?: 'business_secondary_pocs_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Secondary_Pocs_Stddev_Pop_Fields = {
  __typename?: 'business_secondary_pocs_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Secondary_Pocs_Stddev_Samp_Fields = {
  __typename?: 'business_secondary_pocs_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Secondary_Pocs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Secondary_Pocs_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  business_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Business_Secondary_Pocs_Sum_Fields = {
  __typename?: 'business_secondary_pocs_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  business_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "business_secondary_pocs" */
export enum Business_Secondary_Pocs_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  BusinessId = 'business_id',
  /** column name */
  Id = 'id'
}

export type Business_Secondary_Pocs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Secondary_Pocs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Secondary_Pocs_Set_Input>;
  where: Business_Secondary_Pocs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Secondary_Pocs_Var_Pop_Fields = {
  __typename?: 'business_secondary_pocs_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Secondary_Pocs_Var_Samp_Fields = {
  __typename?: 'business_secondary_pocs_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Secondary_Pocs_Variance_Fields = {
  __typename?: 'business_secondary_pocs_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  business_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business_secondary_pocs" */
export type Business_Secondary_Pocs_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  business_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "business" */
export enum Business_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AlternateEmail = 'alternate_email',
  /** column name */
  Category = 'category',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  GstVendorId = 'gst_vendor_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncorporatedOn = 'incorporated_on',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Kind = 'kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MsmeStatusId = 'msme_status_id',
  /** column name */
  MsmeTypeId = 'msme_type_id',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  PrimaryPocId = 'primary_poc_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "business" */
export type Business_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  alternate_email?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gst_vendor_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  incorporated_on?: InputMaybe<Scalars['date']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  msme_status_id?: InputMaybe<Scalars['Int']>;
  msme_type_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Business_Stddev_Fields = {
  __typename?: 'business_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  gst_vendor_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  msme_status_id?: Maybe<Scalars['Float']>;
  msme_type_id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "business" */
export type Business_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Stddev_Pop_Fields = {
  __typename?: 'business_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  gst_vendor_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  msme_status_id?: Maybe<Scalars['Float']>;
  msme_type_id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "business" */
export type Business_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Stddev_Samp_Fields = {
  __typename?: 'business_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  gst_vendor_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  msme_status_id?: Maybe<Scalars['Float']>;
  msme_type_id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "business" */
export type Business_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "business" */
export type Business_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Business_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Business_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  alternate_email?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gst_vendor_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  incorporated_on?: InputMaybe<Scalars['date']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  msme_status_id?: InputMaybe<Scalars['Int']>;
  msme_type_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  primary_poc_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Business_Sum_Fields = {
  __typename?: 'business_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  gst_vendor_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  msme_status_id?: Maybe<Scalars['Int']>;
  msme_type_id?: Maybe<Scalars['Int']>;
  primary_poc_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "business" */
export type Business_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "business" */
export enum Business_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AlternateEmail = 'alternate_email',
  /** column name */
  Category = 'category',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  GstVendorId = 'gst_vendor_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncorporatedOn = 'incorporated_on',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Kind = 'kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MsmeStatusId = 'msme_status_id',
  /** column name */
  MsmeTypeId = 'msme_type_id',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  PrimaryPocId = 'primary_poc_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Business_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Business_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Business_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Business_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Business_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Business_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Business_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Business_Set_Input>;
  where: Business_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Business_Var_Pop_Fields = {
  __typename?: 'business_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  gst_vendor_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  msme_status_id?: Maybe<Scalars['Float']>;
  msme_type_id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "business" */
export type Business_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Var_Samp_Fields = {
  __typename?: 'business_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  gst_vendor_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  msme_status_id?: Maybe<Scalars['Float']>;
  msme_type_id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "business" */
export type Business_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Variance_Fields = {
  __typename?: 'business_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  gst_vendor_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  msme_status_id?: Maybe<Scalars['Float']>;
  msme_type_id?: Maybe<Scalars['Float']>;
  primary_poc_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "business" */
export type Business_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  gst_vendor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  msme_status_id?: InputMaybe<Order_By>;
  msme_type_id?: InputMaybe<Order_By>;
  primary_poc_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "commodity" */
export type Commodity = {
  __typename?: 'commodity';
  codename: Scalars['String'];
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  varieties: Array<Commodity_Variety>;
  /** An aggregate relationship */
  varieties_aggregate: Commodity_Variety_Aggregate;
};


/** columns and relationships of "commodity" */
export type CommodityMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity" */
export type CommodityPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity" */
export type CommodityVarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "commodity" */
export type CommodityVarieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** aggregated selection of "commodity" */
export type Commodity_Aggregate = {
  __typename?: 'commodity_aggregate';
  aggregate?: Maybe<Commodity_Aggregate_Fields>;
  nodes: Array<Commodity>;
};

/** aggregate fields of "commodity" */
export type Commodity_Aggregate_Fields = {
  __typename?: 'commodity_aggregate_fields';
  avg?: Maybe<Commodity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Commodity_Max_Fields>;
  min?: Maybe<Commodity_Min_Fields>;
  stddev?: Maybe<Commodity_Stddev_Fields>;
  stddev_pop?: Maybe<Commodity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commodity_Stddev_Samp_Fields>;
  sum?: Maybe<Commodity_Sum_Fields>;
  var_pop?: Maybe<Commodity_Var_Pop_Fields>;
  var_samp?: Maybe<Commodity_Var_Samp_Fields>;
  variance?: Maybe<Commodity_Variance_Fields>;
};


/** aggregate fields of "commodity" */
export type Commodity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commodity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "commodity" */
export type Commodity_Aggregate_Order_By = {
  avg?: InputMaybe<Commodity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commodity_Max_Order_By>;
  min?: InputMaybe<Commodity_Min_Order_By>;
  stddev?: InputMaybe<Commodity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commodity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commodity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commodity_Sum_Order_By>;
  var_pop?: InputMaybe<Commodity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commodity_Var_Samp_Order_By>;
  variance?: InputMaybe<Commodity_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "commodity" */
export type Commodity_Arr_Rel_Insert_Input = {
  data: Array<Commodity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Avg_Fields = {
  __typename?: 'commodity_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "commodity" */
export type Commodity_Avg_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity". All fields are combined with a logical 'AND'. */
export type Commodity_Bool_Exp = {
  _and?: InputMaybe<Array<Commodity_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "commodity". All fields are combined with a logical 'AND'. */
export type Commodity_Bool_Exp_Remote_Rel_Shared_Entitycommodity = {
  _and?: InputMaybe<Array<Commodity_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** unique or primary key constraints on table "commodity" */
export enum Commodity_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CommodityCodenameKey = 'commodity_codename_key',
  /** unique or primary key constraint on columns "id" */
  CommodityPkey = 'commodity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Commodity_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Commodity_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Commodity_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "commodity" */
export type Commodity_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "commodity" */
export type Commodity_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  varieties?: InputMaybe<Commodity_Variety_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Commodity_Max_Fields = {
  __typename?: 'commodity_max_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "commodity" */
export type Commodity_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Min_Fields = {
  __typename?: 'commodity_min_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "commodity" */
export type Commodity_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity" */
export type Commodity_Mutation_Response = {
  __typename?: 'commodity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Commodity>;
};

/** input type for inserting object relation for remote table "commodity" */
export type Commodity_Obj_Rel_Insert_Input = {
  data: Commodity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};

/** on_conflict condition type for table "commodity" */
export type Commodity_On_Conflict = {
  constraint: Commodity_Constraint;
  update_columns?: Array<Commodity_Update_Column>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity". */
export type Commodity_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  varieties_aggregate?: InputMaybe<Commodity_Variety_Aggregate_Order_By>;
};

/** primary key columns input for table: commodity */
export type Commodity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "commodity" */
export enum Commodity_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata'
}

/** input type for updating data in table "commodity" */
export type Commodity_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Commodity_Stddev_Fields = {
  __typename?: 'commodity_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "commodity" */
export type Commodity_Stddev_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Stddev_Pop_Fields = {
  __typename?: 'commodity_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "commodity" */
export type Commodity_Stddev_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Stddev_Samp_Fields = {
  __typename?: 'commodity_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "commodity" */
export type Commodity_Stddev_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity" */
export type Commodity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Commodity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Commodity_Sum_Fields = {
  __typename?: 'commodity_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "commodity" */
export type Commodity_Sum_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** update columns of table "commodity" */
export enum Commodity_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata'
}

export type Commodity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Commodity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Commodity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Commodity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Commodity_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commodity_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Commodity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commodity_Set_Input>;
  where: Commodity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Var_Pop_Fields = {
  __typename?: 'commodity_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "commodity" */
export type Commodity_Var_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Var_Samp_Fields = {
  __typename?: 'commodity_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "commodity" */
export type Commodity_Var_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Variance_Fields = {
  __typename?: 'commodity_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "commodity" */
export type Commodity_Variance_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "commodity_variety" */
export type Commodity_Variety = {
  __typename?: 'commodity_variety';
  codename: Scalars['String'];
  /** An object relationship */
  commodity: Commodity;
  commodity_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  crop_variety?: Maybe<Crop_Variety>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  default_sku?: Maybe<Sku>;
  default_sku_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  grades: Array<Variety_Grade>;
  /** An aggregate relationship */
  grades_aggregate: Variety_Grade_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  organisation_commodity_variety_configs: Array<Organisation_Commodity_Variety_Config>;
  /** An aggregate relationship */
  organisation_commodity_variety_configs_aggregate: Organisation_Commodity_Variety_Config_Aggregate;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  primary_group?: Maybe<Variety_Group>;
  primary_group_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  secondary_groups: Array<Commodity_Variety_Secondary_Groups>;
  /** An aggregate relationship */
  secondary_groups_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyGradesArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyGrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyOrganisation_Commodity_Variety_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyOrganisation_Commodity_Variety_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietyPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietySecondary_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


/** columns and relationships of "commodity_variety" */
export type Commodity_VarietySecondary_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};

/** aggregated selection of "commodity_variety" */
export type Commodity_Variety_Aggregate = {
  __typename?: 'commodity_variety_aggregate';
  aggregate?: Maybe<Commodity_Variety_Aggregate_Fields>;
  nodes: Array<Commodity_Variety>;
};

/** aggregate fields of "commodity_variety" */
export type Commodity_Variety_Aggregate_Fields = {
  __typename?: 'commodity_variety_aggregate_fields';
  avg?: Maybe<Commodity_Variety_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Commodity_Variety_Max_Fields>;
  min?: Maybe<Commodity_Variety_Min_Fields>;
  stddev?: Maybe<Commodity_Variety_Stddev_Fields>;
  stddev_pop?: Maybe<Commodity_Variety_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commodity_Variety_Stddev_Samp_Fields>;
  sum?: Maybe<Commodity_Variety_Sum_Fields>;
  var_pop?: Maybe<Commodity_Variety_Var_Pop_Fields>;
  var_samp?: Maybe<Commodity_Variety_Var_Samp_Fields>;
  variance?: Maybe<Commodity_Variety_Variance_Fields>;
};


/** aggregate fields of "commodity_variety" */
export type Commodity_Variety_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "commodity_variety" */
export type Commodity_Variety_Aggregate_Order_By = {
  avg?: InputMaybe<Commodity_Variety_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commodity_Variety_Max_Order_By>;
  min?: InputMaybe<Commodity_Variety_Min_Order_By>;
  stddev?: InputMaybe<Commodity_Variety_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commodity_Variety_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commodity_Variety_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commodity_Variety_Sum_Order_By>;
  var_pop?: InputMaybe<Commodity_Variety_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commodity_Variety_Var_Samp_Order_By>;
  variance?: InputMaybe<Commodity_Variety_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Variety_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "commodity_variety" */
export type Commodity_Variety_Arr_Rel_Insert_Input = {
  data: Array<Commodity_Variety_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Variety_Avg_Fields = {
  __typename?: 'commodity_variety_avg_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "commodity_variety" */
export type Commodity_Variety_Avg_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity_variety". All fields are combined with a logical 'AND'. */
export type Commodity_Variety_Bool_Exp = {
  _and?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodity?: InputMaybe<Commodity_Bool_Exp>;
  commodity_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  default_sku?: InputMaybe<Sku_Bool_Exp>;
  default_sku_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  grades?: InputMaybe<Variety_Grade_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_commodity_variety_configs?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_group?: InputMaybe<Variety_Group_Bool_Exp>;
  primary_group_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_groups?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "commodity_variety". All fields are combined with a logical 'AND'. */
export type Commodity_Variety_Bool_Exp_Remote_Rel_Shared_Entitycommodity_Variety = {
  _and?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Variety_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitycommodity_Variety>;
  commodity?: InputMaybe<Commodity_Bool_Exp>;
  commodity_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  default_sku?: InputMaybe<Sku_Bool_Exp>;
  default_sku_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  grades?: InputMaybe<Variety_Grade_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_commodity_variety_configs?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_group?: InputMaybe<Variety_Group_Bool_Exp>;
  primary_group_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_groups?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "commodity_variety" */
export enum Commodity_Variety_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CommodityVarietyCodenameKey = 'commodity_variety_codename_key',
  /** unique or primary key constraint on columns "name", "commodity_id" */
  CommodityVarietyNameCommodityId_334ca83bUniq = 'commodity_variety_name_commodity_id_334ca83b_uniq',
  /** unique or primary key constraint on columns "id" */
  CommodityVarietyPkey = 'commodity_variety_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Commodity_Variety_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Commodity_Variety_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Commodity_Variety_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "commodity_variety" */
export type Commodity_Variety_Inc_Input = {
  commodity_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "commodity_variety" */
export type Commodity_Variety_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodity?: InputMaybe<Commodity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crop_variety?: InputMaybe<Crop_Variety_Obj_Rel_Insert_Input>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku?: InputMaybe<Sku_Obj_Rel_Insert_Input>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  grades?: InputMaybe<Variety_Grade_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_commodity_variety_configs?: InputMaybe<Organisation_Commodity_Variety_Config_Arr_Rel_Insert_Input>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group?: InputMaybe<Variety_Group_Obj_Rel_Insert_Input>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  secondary_groups?: InputMaybe<Commodity_Variety_Secondary_Groups_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Commodity_Variety_Max_Fields = {
  __typename?: 'commodity_variety_max_fields';
  codename?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  default_sku_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_group_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "commodity_variety" */
export type Commodity_Variety_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Variety_Min_Fields = {
  __typename?: 'commodity_variety_min_fields';
  codename?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  default_sku_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_group_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "commodity_variety" */
export type Commodity_Variety_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity_variety" */
export type Commodity_Variety_Mutation_Response = {
  __typename?: 'commodity_variety_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Commodity_Variety>;
};

/** input type for inserting object relation for remote table "commodity_variety" */
export type Commodity_Variety_Obj_Rel_Insert_Input = {
  data: Commodity_Variety_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};

/** on_conflict condition type for table "commodity_variety" */
export type Commodity_Variety_On_Conflict = {
  constraint: Commodity_Variety_Constraint;
  update_columns?: Array<Commodity_Variety_Update_Column>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity_variety". */
export type Commodity_Variety_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Commodity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop_variety?: InputMaybe<Crop_Variety_Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku?: InputMaybe<Sku_Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  grades_aggregate?: InputMaybe<Variety_Grade_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_commodity_variety_configs_aggregate?: InputMaybe<Organisation_Commodity_Variety_Config_Aggregate_Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group?: InputMaybe<Variety_Group_Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  secondary_groups_aggregate?: InputMaybe<Commodity_Variety_Secondary_Groups_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commodity_variety */
export type Commodity_Variety_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Commodity_Variety_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups = {
  __typename?: 'commodity_variety_secondary_groups';
  /** An object relationship */
  commodity_variety: Commodity_Variety;
  commodityvariety_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  variety_group: Variety_Group;
  varietygroup_id: Scalars['Int'];
};

/** aggregated selection of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate = {
  __typename?: 'commodity_variety_secondary_groups_aggregate';
  aggregate?: Maybe<Commodity_Variety_Secondary_Groups_Aggregate_Fields>;
  nodes: Array<Commodity_Variety_Secondary_Groups>;
};

/** aggregate fields of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate_Fields = {
  __typename?: 'commodity_variety_secondary_groups_aggregate_fields';
  avg?: Maybe<Commodity_Variety_Secondary_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Commodity_Variety_Secondary_Groups_Max_Fields>;
  min?: Maybe<Commodity_Variety_Secondary_Groups_Min_Fields>;
  stddev?: Maybe<Commodity_Variety_Secondary_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Commodity_Variety_Secondary_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commodity_Variety_Secondary_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Commodity_Variety_Secondary_Groups_Sum_Fields>;
  var_pop?: Maybe<Commodity_Variety_Secondary_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Commodity_Variety_Secondary_Groups_Var_Samp_Fields>;
  variance?: Maybe<Commodity_Variety_Secondary_Groups_Variance_Fields>;
};


/** aggregate fields of "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Commodity_Variety_Secondary_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commodity_Variety_Secondary_Groups_Max_Order_By>;
  min?: InputMaybe<Commodity_Variety_Secondary_Groups_Min_Order_By>;
  stddev?: InputMaybe<Commodity_Variety_Secondary_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commodity_Variety_Secondary_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commodity_Variety_Secondary_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commodity_Variety_Secondary_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Commodity_Variety_Secondary_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commodity_Variety_Secondary_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Commodity_Variety_Secondary_Groups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Arr_Rel_Insert_Input = {
  data: Array<Commodity_Variety_Secondary_Groups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commodity_Variety_Secondary_Groups_On_Conflict>;
};

/** aggregate avg on columns */
export type Commodity_Variety_Secondary_Groups_Avg_Fields = {
  __typename?: 'commodity_variety_secondary_groups_avg_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Avg_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commodity_variety_secondary_groups". All fields are combined with a logical 'AND'. */
export type Commodity_Variety_Secondary_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Bool_Exp>>;
  _not?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Bool_Exp>>;
  commodity_variety?: InputMaybe<Commodity_Variety_Bool_Exp>;
  commodityvariety_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  variety_group?: InputMaybe<Variety_Group_Bool_Exp>;
  varietygroup_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "commodity_variety_secondary_groups" */
export enum Commodity_Variety_Secondary_Groups_Constraint {
  /** unique or primary key constraint on columns "varietygroup_id", "commodityvariety_id" */
  CommodityVarietySecondCommodityvarietyIdVari_098d67c7Uniq = 'commodity_variety_second_commodityvariety_id_vari_098d67c7_uniq',
  /** unique or primary key constraint on columns "id" */
  CommodityVarietySecondaryGroupsPkey = 'commodity_variety_secondary_groups_pkey'
}

/** input type for incrementing numeric columns in table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Inc_Input = {
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Insert_Input = {
  commodity_variety?: InputMaybe<Commodity_Variety_Obj_Rel_Insert_Input>;
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  variety_group?: InputMaybe<Variety_Group_Obj_Rel_Insert_Input>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Commodity_Variety_Secondary_Groups_Max_Fields = {
  __typename?: 'commodity_variety_secondary_groups_max_fields';
  commodityvariety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietygroup_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Max_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commodity_Variety_Secondary_Groups_Min_Fields = {
  __typename?: 'commodity_variety_secondary_groups_min_fields';
  commodityvariety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietygroup_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Min_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Mutation_Response = {
  __typename?: 'commodity_variety_secondary_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Commodity_Variety_Secondary_Groups>;
};

/** on_conflict condition type for table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_On_Conflict = {
  constraint: Commodity_Variety_Secondary_Groups_Constraint;
  update_columns?: Array<Commodity_Variety_Secondary_Groups_Update_Column>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "commodity_variety_secondary_groups". */
export type Commodity_Variety_Secondary_Groups_Order_By = {
  commodity_variety?: InputMaybe<Commodity_Variety_Order_By>;
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  variety_group?: InputMaybe<Variety_Group_Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commodity_variety_secondary_groups */
export type Commodity_Variety_Secondary_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "commodity_variety_secondary_groups" */
export enum Commodity_Variety_Secondary_Groups_Select_Column {
  /** column name */
  CommodityvarietyId = 'commodityvariety_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietygroupId = 'varietygroup_id'
}

/** input type for updating data in table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Set_Input = {
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Commodity_Variety_Secondary_Groups_Stddev_Fields = {
  __typename?: 'commodity_variety_secondary_groups_stddev_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stddev_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Variety_Secondary_Groups_Stddev_Pop_Fields = {
  __typename?: 'commodity_variety_secondary_groups_stddev_pop_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stddev_Pop_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Variety_Secondary_Groups_Stddev_Samp_Fields = {
  __typename?: 'commodity_variety_secondary_groups_stddev_samp_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stddev_Samp_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Commodity_Variety_Secondary_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Variety_Secondary_Groups_Stream_Cursor_Value_Input = {
  commodityvariety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietygroup_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Commodity_Variety_Secondary_Groups_Sum_Fields = {
  __typename?: 'commodity_variety_secondary_groups_sum_fields';
  commodityvariety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietygroup_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Sum_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** update columns of table "commodity_variety_secondary_groups" */
export enum Commodity_Variety_Secondary_Groups_Update_Column {
  /** column name */
  CommodityvarietyId = 'commodityvariety_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietygroupId = 'varietygroup_id'
}

export type Commodity_Variety_Secondary_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commodity_Variety_Secondary_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commodity_Variety_Secondary_Groups_Set_Input>;
  where: Commodity_Variety_Secondary_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Variety_Secondary_Groups_Var_Pop_Fields = {
  __typename?: 'commodity_variety_secondary_groups_var_pop_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Var_Pop_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Variety_Secondary_Groups_Var_Samp_Fields = {
  __typename?: 'commodity_variety_secondary_groups_var_samp_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Var_Samp_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Variety_Secondary_Groups_Variance_Fields = {
  __typename?: 'commodity_variety_secondary_groups_variance_fields';
  commodityvariety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietygroup_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "commodity_variety_secondary_groups" */
export type Commodity_Variety_Secondary_Groups_Variance_Order_By = {
  commodityvariety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietygroup_id?: InputMaybe<Order_By>;
};

/** select columns of table "commodity_variety" */
export enum Commodity_Variety_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  DefaultSkuId = 'default_sku_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGroupId = 'primary_group_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "commodity_variety" */
export type Commodity_Variety_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Commodity_Variety_Stddev_Fields = {
  __typename?: 'commodity_variety_stddev_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "commodity_variety" */
export type Commodity_Variety_Stddev_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commodity_Variety_Stddev_Pop_Fields = {
  __typename?: 'commodity_variety_stddev_pop_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "commodity_variety" */
export type Commodity_Variety_Stddev_Pop_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commodity_Variety_Stddev_Samp_Fields = {
  __typename?: 'commodity_variety_stddev_samp_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "commodity_variety" */
export type Commodity_Variety_Stddev_Samp_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "commodity_variety" */
export type Commodity_Variety_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Commodity_Variety_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Commodity_Variety_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  default_sku_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_group_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Commodity_Variety_Sum_Fields = {
  __typename?: 'commodity_variety_sum_fields';
  commodity_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  default_sku_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_group_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "commodity_variety" */
export type Commodity_Variety_Sum_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** update columns of table "commodity_variety" */
export enum Commodity_Variety_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  DefaultSkuId = 'default_sku_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGroupId = 'primary_group_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Commodity_Variety_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Commodity_Variety_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Commodity_Variety_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Commodity_Variety_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Commodity_Variety_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commodity_Variety_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Commodity_Variety_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commodity_Variety_Set_Input>;
  where: Commodity_Variety_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commodity_Variety_Var_Pop_Fields = {
  __typename?: 'commodity_variety_var_pop_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "commodity_variety" */
export type Commodity_Variety_Var_Pop_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commodity_Variety_Var_Samp_Fields = {
  __typename?: 'commodity_variety_var_samp_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "commodity_variety" */
export type Commodity_Variety_Var_Samp_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commodity_Variety_Variance_Fields = {
  __typename?: 'commodity_variety_variance_fields';
  commodity_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  default_sku_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_group_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "commodity_variety" */
export type Commodity_Variety_Variance_Order_By = {
  commodity_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  default_sku_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_group_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'company';
  abbreviation: Scalars['String'];
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  agents: Array<Agent_Company>;
  /** An aggregate relationship */
  agents_aggregate: Agent_Company_Aggregate;
  /** An array relationship */
  base_user_companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  base_user_companies_aggregate: Base_User_Companies_Aggregate;
  /** An array relationship */
  categories: Array<Company_Categories>;
  /** An aggregate relationship */
  categories_aggregate: Company_Categories_Aggregate;
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  fms_sync: Scalars['Boolean'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Network>;
  /** An aggregate relationship */
  networks_aggregate: Network_Aggregate;
  number?: Maybe<Scalars['String']>;
  /** An object relationship */
  organisation?: Maybe<Organisation>;
  organisation_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  /** An array relationship */
  share_holders: Array<Company_Share_Holder>;
  /** An aggregate relationship */
  share_holders_aggregate: Company_Share_Holder_Aggregate;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};


/** columns and relationships of "company" */
export type CompanyAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyAgents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyBase_User_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyBase_User_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "company" */
export type CompanyNetworksArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyShare_HoldersArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyShare_Holders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};

/** aggregated selection of "company" */
export type Company_Aggregate = {
  __typename?: 'company_aggregate';
  aggregate?: Maybe<Company_Aggregate_Fields>;
  nodes: Array<Company>;
};

/** aggregate fields of "company" */
export type Company_Aggregate_Fields = {
  __typename?: 'company_aggregate_fields';
  avg?: Maybe<Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Max_Fields>;
  min?: Maybe<Company_Min_Fields>;
  stddev?: Maybe<Company_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Sum_Fields>;
  var_pop?: Maybe<Company_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Var_Samp_Fields>;
  variance?: Maybe<Company_Variance_Fields>;
};


/** aggregate fields of "company" */
export type Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company" */
export type Company_Aggregate_Order_By = {
  avg?: InputMaybe<Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Company_Max_Order_By>;
  min?: InputMaybe<Company_Min_Order_By>;
  stddev?: InputMaybe<Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Company_Sum_Order_By>;
  var_pop?: InputMaybe<Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "company" */
export type Company_Arr_Rel_Insert_Input = {
  data: Array<Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Company_Avg_Fields = {
  __typename?: 'company_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company" */
export type Company_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp = {
  _and?: InputMaybe<Array<Company_Bool_Exp>>;
  _not?: InputMaybe<Company_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  agents?: InputMaybe<Agent_Company_Bool_Exp>;
  base_user_companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  categories?: InputMaybe<Company_Categories_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  fms_sync?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
  share_holders?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  tnc?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp_Remote_Rel_Shared_Entityfacilitator = {
  _and?: InputMaybe<Array<Company_Bool_Exp>>;
  _not?: InputMaybe<Company_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  agents?: InputMaybe<Agent_Company_Bool_Exp>;
  base_user_companies?: InputMaybe<Base_User_Companies_Bool_Exp>;
  categories?: InputMaybe<Company_Categories_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityfacilitator>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  fms_sync?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Network_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
  share_holders?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  tnc?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "company_categories" */
export type Company_Categories = {
  __typename?: 'company_categories';
  /** An object relationship */
  category: Company_Category;
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  companycategory_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "company_categories" */
export type Company_Categories_Aggregate = {
  __typename?: 'company_categories_aggregate';
  aggregate?: Maybe<Company_Categories_Aggregate_Fields>;
  nodes: Array<Company_Categories>;
};

/** aggregate fields of "company_categories" */
export type Company_Categories_Aggregate_Fields = {
  __typename?: 'company_categories_aggregate_fields';
  avg?: Maybe<Company_Categories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Categories_Max_Fields>;
  min?: Maybe<Company_Categories_Min_Fields>;
  stddev?: Maybe<Company_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Categories_Sum_Fields>;
  var_pop?: Maybe<Company_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Categories_Var_Samp_Fields>;
  variance?: Maybe<Company_Categories_Variance_Fields>;
};


/** aggregate fields of "company_categories" */
export type Company_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Company_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_categories" */
export type Company_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Company_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Company_Categories_Max_Order_By>;
  min?: InputMaybe<Company_Categories_Min_Order_By>;
  stddev?: InputMaybe<Company_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Company_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Company_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Company_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Company_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Company_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Company_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "company_categories" */
export type Company_Categories_Arr_Rel_Insert_Input = {
  data: Array<Company_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Company_Categories_Avg_Fields = {
  __typename?: 'company_categories_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  companycategory_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company_categories" */
export type Company_Categories_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "company_categories". All fields are combined with a logical 'AND'. */
export type Company_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Company_Categories_Bool_Exp>>;
  _not?: InputMaybe<Company_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Categories_Bool_Exp>>;
  category?: InputMaybe<Company_Category_Bool_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  companycategory_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_categories" */
export enum Company_Categories_Constraint {
  /** unique or primary key constraint on columns "companycategory_id", "company_id" */
  CompanyCategoriesCompanyIdCompanycategoryId_89f609f2Uniq = 'company_categories_company_id_companycategory_id_89f609f2_uniq',
  /** unique or primary key constraint on columns "id" */
  CompanyCategoriesPkey = 'company_categories_pkey'
}

/** input type for incrementing numeric columns in table "company_categories" */
export type Company_Categories_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  companycategory_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_categories" */
export type Company_Categories_Insert_Input = {
  category?: InputMaybe<Company_Category_Obj_Rel_Insert_Input>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  companycategory_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Company_Categories_Max_Fields = {
  __typename?: 'company_categories_max_fields';
  company_id?: Maybe<Scalars['Int']>;
  companycategory_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "company_categories" */
export type Company_Categories_Max_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Company_Categories_Min_Fields = {
  __typename?: 'company_categories_min_fields';
  company_id?: Maybe<Scalars['Int']>;
  companycategory_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "company_categories" */
export type Company_Categories_Min_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "company_categories" */
export type Company_Categories_Mutation_Response = {
  __typename?: 'company_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Categories>;
};

/** on_conflict condition type for table "company_categories" */
export type Company_Categories_On_Conflict = {
  constraint: Company_Categories_Constraint;
  update_columns?: Array<Company_Categories_Update_Column>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "company_categories". */
export type Company_Categories_Order_By = {
  category?: InputMaybe<Company_Category_Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: company_categories */
export type Company_Categories_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "company_categories" */
export enum Company_Categories_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanycategoryId = 'companycategory_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "company_categories" */
export type Company_Categories_Set_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  companycategory_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Company_Categories_Stddev_Fields = {
  __typename?: 'company_categories_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  companycategory_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company_categories" */
export type Company_Categories_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Company_Categories_Stddev_Pop_Fields = {
  __typename?: 'company_categories_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  companycategory_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company_categories" */
export type Company_Categories_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Company_Categories_Stddev_Samp_Fields = {
  __typename?: 'company_categories_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  companycategory_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company_categories" */
export type Company_Categories_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "company_categories" */
export type Company_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Categories_Stream_Cursor_Value_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  companycategory_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Company_Categories_Sum_Fields = {
  __typename?: 'company_categories_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  companycategory_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "company_categories" */
export type Company_Categories_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "company_categories" */
export enum Company_Categories_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanycategoryId = 'companycategory_id',
  /** column name */
  Id = 'id'
}

export type Company_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Company_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Company_Categories_Set_Input>;
  where: Company_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Company_Categories_Var_Pop_Fields = {
  __typename?: 'company_categories_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  companycategory_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company_categories" */
export type Company_Categories_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Company_Categories_Var_Samp_Fields = {
  __typename?: 'company_categories_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  companycategory_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company_categories" */
export type Company_Categories_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Company_Categories_Variance_Fields = {
  __typename?: 'company_categories_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  companycategory_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company_categories" */
export type Company_Categories_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  companycategory_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "company_category" */
export type Company_Category = {
  __typename?: 'company_category';
  /** An array relationship */
  categories: Array<Company_Categories>;
  /** An aggregate relationship */
  categories_aggregate: Company_Categories_Aggregate;
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};


/** columns and relationships of "company_category" */
export type Company_CategoryCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


/** columns and relationships of "company_category" */
export type Company_CategoryCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};

/** aggregated selection of "company_category" */
export type Company_Category_Aggregate = {
  __typename?: 'company_category_aggregate';
  aggregate?: Maybe<Company_Category_Aggregate_Fields>;
  nodes: Array<Company_Category>;
};

/** aggregate fields of "company_category" */
export type Company_Category_Aggregate_Fields = {
  __typename?: 'company_category_aggregate_fields';
  avg?: Maybe<Company_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Category_Max_Fields>;
  min?: Maybe<Company_Category_Min_Fields>;
  stddev?: Maybe<Company_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Category_Sum_Fields>;
  var_pop?: Maybe<Company_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Category_Var_Samp_Fields>;
  variance?: Maybe<Company_Category_Variance_Fields>;
};


/** aggregate fields of "company_category" */
export type Company_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Company_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Company_Category_Avg_Fields = {
  __typename?: 'company_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_category". All fields are combined with a logical 'AND'. */
export type Company_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Company_Category_Bool_Exp>>;
  _not?: InputMaybe<Company_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Category_Bool_Exp>>;
  categories?: InputMaybe<Company_Categories_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_category" */
export enum Company_Category_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CompanyCategoryCodenameKey = 'company_category_codename_key',
  /** unique or primary key constraint on columns "id" */
  CompanyCategoryPkey = 'company_category_pkey'
}

/** input type for incrementing numeric columns in table "company_category" */
export type Company_Category_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_category" */
export type Company_Category_Insert_Input = {
  categories?: InputMaybe<Company_Categories_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Company_Category_Max_Fields = {
  __typename?: 'company_category_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Company_Category_Min_Fields = {
  __typename?: 'company_category_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company_category" */
export type Company_Category_Mutation_Response = {
  __typename?: 'company_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Category>;
};

/** input type for inserting object relation for remote table "company_category" */
export type Company_Category_Obj_Rel_Insert_Input = {
  data: Company_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_Category_On_Conflict>;
};

/** on_conflict condition type for table "company_category" */
export type Company_Category_On_Conflict = {
  constraint: Company_Category_Constraint;
  update_columns?: Array<Company_Category_Update_Column>;
  where?: InputMaybe<Company_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "company_category". */
export type Company_Category_Order_By = {
  categories_aggregate?: InputMaybe<Company_Categories_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: company_category */
export type Company_Category_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "company_category" */
export enum Company_Category_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "company_category" */
export type Company_Category_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Company_Category_Stddev_Fields = {
  __typename?: 'company_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Company_Category_Stddev_Pop_Fields = {
  __typename?: 'company_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Company_Category_Stddev_Samp_Fields = {
  __typename?: 'company_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_category" */
export type Company_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Category_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Company_Category_Sum_Fields = {
  __typename?: 'company_category_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "company_category" */
export enum Company_Category_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Company_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Company_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Company_Category_Set_Input>;
  where: Company_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Company_Category_Var_Pop_Fields = {
  __typename?: 'company_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Company_Category_Var_Samp_Fields = {
  __typename?: 'company_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Company_Category_Variance_Fields = {
  __typename?: 'company_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "company" */
export enum Company_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CompanyCodenameKey = 'company_codename_key',
  /** unique or primary key constraint on columns "name", "organisation_id" */
  CompanyNameOrganisationIdC0e88d5cUniq = 'company_name_organisation_id_c0e88d5c_uniq',
  /** unique or primary key constraint on columns "photo_id" */
  CompanyPhotoId_6586c362Uniq = 'company_photo_id_6586c362_uniq',
  /** unique or primary key constraint on columns "id" */
  CompanyPkey = 'company_pkey',
  /** unique or primary key constraint on columns "uid" */
  CompanyUidKey = 'company_uid_key'
}

/** input type for incrementing numeric columns in table "company" */
export type Company_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company" */
export type Company_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  agents?: InputMaybe<Agent_Company_Arr_Rel_Insert_Input>;
  base_user_companies?: InputMaybe<Base_User_Companies_Arr_Rel_Insert_Input>;
  categories?: InputMaybe<Company_Categories_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  fms_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Network_Arr_Rel_Insert_Input>;
  number?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  share_holders?: InputMaybe<Company_Share_Holder_Arr_Rel_Insert_Input>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Company_Max_Fields = {
  __typename?: 'company_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "company" */
export type Company_Max_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Company_Min_Fields = {
  __typename?: 'company_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  purpose?: Maybe<Scalars['String']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "company" */
export type Company_Min_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "company" */
export type Company_Mutation_Response = {
  __typename?: 'company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type Company_Obj_Rel_Insert_Input = {
  data: Company_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_On_Conflict>;
};

/** on_conflict condition type for table "company" */
export type Company_On_Conflict = {
  constraint: Company_Constraint;
  update_columns?: Array<Company_Update_Column>;
  where?: InputMaybe<Company_Bool_Exp>;
};

/** Ordering options when selecting data from "company". */
export type Company_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  agents_aggregate?: InputMaybe<Agent_Company_Aggregate_Order_By>;
  base_user_companies_aggregate?: InputMaybe<Base_User_Companies_Aggregate_Order_By>;
  categories_aggregate?: InputMaybe<Company_Categories_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  fms_sync?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Network_Aggregate_Order_By>;
  number?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
  share_holders_aggregate?: InputMaybe<Company_Share_Holder_Aggregate_Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: company */
export type Company_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "company" */
export enum Company_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FmsSync = 'fms_sync',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid'
}

/** input type for updating data in table "company" */
export type Company_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  fms_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "company_share_holder" */
export type Company_Share_Holder = {
  __typename?: 'company_share_holder';
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  share_holder: Base_User;
  share_holder_id: Scalars['Int'];
  shares: Scalars['float8'];
};

/** aggregated selection of "company_share_holder" */
export type Company_Share_Holder_Aggregate = {
  __typename?: 'company_share_holder_aggregate';
  aggregate?: Maybe<Company_Share_Holder_Aggregate_Fields>;
  nodes: Array<Company_Share_Holder>;
};

/** aggregate fields of "company_share_holder" */
export type Company_Share_Holder_Aggregate_Fields = {
  __typename?: 'company_share_holder_aggregate_fields';
  avg?: Maybe<Company_Share_Holder_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Share_Holder_Max_Fields>;
  min?: Maybe<Company_Share_Holder_Min_Fields>;
  stddev?: Maybe<Company_Share_Holder_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Share_Holder_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Share_Holder_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Share_Holder_Sum_Fields>;
  var_pop?: Maybe<Company_Share_Holder_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Share_Holder_Var_Samp_Fields>;
  variance?: Maybe<Company_Share_Holder_Variance_Fields>;
};


/** aggregate fields of "company_share_holder" */
export type Company_Share_Holder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_share_holder" */
export type Company_Share_Holder_Aggregate_Order_By = {
  avg?: InputMaybe<Company_Share_Holder_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Company_Share_Holder_Max_Order_By>;
  min?: InputMaybe<Company_Share_Holder_Min_Order_By>;
  stddev?: InputMaybe<Company_Share_Holder_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Company_Share_Holder_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Company_Share_Holder_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Company_Share_Holder_Sum_Order_By>;
  var_pop?: InputMaybe<Company_Share_Holder_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Company_Share_Holder_Var_Samp_Order_By>;
  variance?: InputMaybe<Company_Share_Holder_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "company_share_holder" */
export type Company_Share_Holder_Arr_Rel_Insert_Input = {
  data: Array<Company_Share_Holder_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_Share_Holder_On_Conflict>;
};

/** aggregate avg on columns */
export type Company_Share_Holder_Avg_Fields = {
  __typename?: 'company_share_holder_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  shares?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company_share_holder" */
export type Company_Share_Holder_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "company_share_holder". All fields are combined with a logical 'AND'. */
export type Company_Share_Holder_Bool_Exp = {
  _and?: InputMaybe<Array<Company_Share_Holder_Bool_Exp>>;
  _not?: InputMaybe<Company_Share_Holder_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Share_Holder_Bool_Exp>>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  share_holder?: InputMaybe<Base_User_Bool_Exp>;
  share_holder_id?: InputMaybe<Int_Comparison_Exp>;
  shares?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_share_holder" */
export enum Company_Share_Holder_Constraint {
  /** unique or primary key constraint on columns "share_holder_id", "company_id" */
  CompanyShareHolderCompanyIdShareHolderId_4323f6e4Uniq = 'company_share_holder_company_id_share_holder_id_4323f6e4_uniq',
  /** unique or primary key constraint on columns "id" */
  CompanyShareHolderPkey = 'company_share_holder_pkey'
}

/** input type for incrementing numeric columns in table "company_share_holder" */
export type Company_Share_Holder_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  shares?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "company_share_holder" */
export type Company_Share_Holder_Insert_Input = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  share_holder?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  shares?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Company_Share_Holder_Max_Fields = {
  __typename?: 'company_share_holder_max_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  share_holder_id?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "company_share_holder" */
export type Company_Share_Holder_Max_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Company_Share_Holder_Min_Fields = {
  __typename?: 'company_share_holder_min_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  share_holder_id?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "company_share_holder" */
export type Company_Share_Holder_Min_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "company_share_holder" */
export type Company_Share_Holder_Mutation_Response = {
  __typename?: 'company_share_holder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Share_Holder>;
};

/** on_conflict condition type for table "company_share_holder" */
export type Company_Share_Holder_On_Conflict = {
  constraint: Company_Share_Holder_Constraint;
  update_columns?: Array<Company_Share_Holder_Update_Column>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};

/** Ordering options when selecting data from "company_share_holder". */
export type Company_Share_Holder_Order_By = {
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder?: InputMaybe<Base_User_Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** primary key columns input for table: company_share_holder */
export type Company_Share_Holder_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "company_share_holder" */
export enum Company_Share_Holder_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id',
  /** column name */
  ShareHolderId = 'share_holder_id',
  /** column name */
  Shares = 'shares'
}

/** input type for updating data in table "company_share_holder" */
export type Company_Share_Holder_Set_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  shares?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Company_Share_Holder_Stddev_Fields = {
  __typename?: 'company_share_holder_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  shares?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company_share_holder" */
export type Company_Share_Holder_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Company_Share_Holder_Stddev_Pop_Fields = {
  __typename?: 'company_share_holder_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  shares?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company_share_holder" */
export type Company_Share_Holder_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Company_Share_Holder_Stddev_Samp_Fields = {
  __typename?: 'company_share_holder_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  shares?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company_share_holder" */
export type Company_Share_Holder_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "company_share_holder" */
export type Company_Share_Holder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Share_Holder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Share_Holder_Stream_Cursor_Value_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  shares?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Company_Share_Holder_Sum_Fields = {
  __typename?: 'company_share_holder_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  share_holder_id?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "company_share_holder" */
export type Company_Share_Holder_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** update columns of table "company_share_holder" */
export enum Company_Share_Holder_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id',
  /** column name */
  ShareHolderId = 'share_holder_id',
  /** column name */
  Shares = 'shares'
}

export type Company_Share_Holder_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Company_Share_Holder_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Company_Share_Holder_Set_Input>;
  where: Company_Share_Holder_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Company_Share_Holder_Var_Pop_Fields = {
  __typename?: 'company_share_holder_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  shares?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company_share_holder" */
export type Company_Share_Holder_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Company_Share_Holder_Var_Samp_Fields = {
  __typename?: 'company_share_holder_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  shares?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company_share_holder" */
export type Company_Share_Holder_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Company_Share_Holder_Variance_Fields = {
  __typename?: 'company_share_holder_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  shares?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company_share_holder" */
export type Company_Share_Holder_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  shares?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Company_Stddev_Fields = {
  __typename?: 'company_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company" */
export type Company_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Company_Stddev_Pop_Fields = {
  __typename?: 'company_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company" */
export type Company_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Company_Stddev_Samp_Fields = {
  __typename?: 'company_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company" */
export type Company_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "company" */
export type Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  fms_sync?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Company_Sum_Fields = {
  __typename?: 'company_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "company" */
export type Company_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** update columns of table "company" */
export enum Company_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FmsSync = 'fms_sync',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Purpose = 'purpose',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid'
}

export type Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Company_Var_Pop_Fields = {
  __typename?: 'company_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company" */
export type Company_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Company_Var_Samp_Fields = {
  __typename?: 'company_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company" */
export type Company_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Company_Variance_Fields = {
  __typename?: 'company_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company" */
export type Company_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit" */
export type Credit = {
  __typename?: 'credit';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  credit_limit_factor: Scalars['float8'];
  /** An array relationship */
  credit_requests: Array<Credit_Request>;
  /** An aggregate relationship */
  credit_requests_aggregate: Credit_Request_Aggregate;
  /** An array relationship */
  credit_transactions: Array<Credit_Transaction>;
  /** An aggregate relationship */
  credit_transactions_aggregate: Credit_Transaction_Aggregate;
  end_date?: Maybe<Scalars['date']>;
  extra_data?: Maybe<Array<Maybe<CreditCustomType>>>;
  /** An array relationship */
  financial_year_assessments: Array<Financial_Year_Assessment>;
  /** An aggregate relationship */
  financial_year_assessments_aggregate: Financial_Year_Assessment_Aggregate;
  id: Scalars['bigint'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  /** An array relationship */
  over_drafts: Array<Over_Draft>;
  /** An aggregate relationship */
  over_drafts_aggregate: Over_Draft_Aggregate;
  payment_cycle_days: Scalars['Int'];
  /** An array relationship */
  projection_assessments: Array<Projection_Assessment>;
  /** An aggregate relationship */
  projection_assessments_aggregate: Projection_Assessment_Aggregate;
  remaining_amount: Scalars['float8'];
  start_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  status: Credit_Status;
  status_id: Scalars['String'];
  summary?: Maybe<Array<Maybe<CreditSummaryType>>>;
  total_amount: Scalars['float8'];
  /** An array relationship */
  trade_assessments: Array<Trade_Assessment>;
  /** An aggregate relationship */
  trade_assessments_aggregate: Trade_Assessment_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount: Scalars['float8'];
  /** An object relationship */
  user: Setu_Trade_Shared_Entity;
  user_id: Scalars['bigint'];
  validity: Scalars['Int'];
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "credit" */
export type CreditCredit_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Request_Order_By>>;
  where?: InputMaybe<Credit_Request_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditCredit_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Request_Order_By>>;
  where?: InputMaybe<Credit_Request_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditCredit_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditCredit_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditFinancial_Year_AssessmentsArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditFinancial_Year_Assessments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "credit" */
export type CreditOver_DraftsArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Order_By>>;
  where?: InputMaybe<Over_Draft_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditOver_Drafts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Order_By>>;
  where?: InputMaybe<Over_Draft_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditProjection_AssessmentsArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditProjection_Assessments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditTrade_AssessmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Bool_Exp>;
};


/** columns and relationships of "credit" */
export type CreditTrade_Assessments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Bool_Exp>;
};

/** aggregated selection of "credit" */
export type Credit_Aggregate = {
  __typename?: 'credit_aggregate';
  aggregate?: Maybe<Credit_Aggregate_Fields>;
  nodes: Array<Credit>;
};

/** aggregate fields of "credit" */
export type Credit_Aggregate_Fields = {
  __typename?: 'credit_aggregate_fields';
  avg?: Maybe<Credit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Max_Fields>;
  min?: Maybe<Credit_Min_Fields>;
  stddev?: Maybe<Credit_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Sum_Fields>;
  var_pop?: Maybe<Credit_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Var_Samp_Fields>;
  variance?: Maybe<Credit_Variance_Fields>;
};


/** aggregate fields of "credit" */
export type Credit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit" */
export type Credit_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Max_Order_By>;
  min?: InputMaybe<Credit_Min_Order_By>;
  stddev?: InputMaybe<Credit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Credit_Avg_Fields = {
  __typename?: 'credit_avg_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit" */
export type Credit_Avg_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit". All fields are combined with a logical 'AND'. */
export type Credit_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Bool_Exp>>;
  _not?: InputMaybe<Credit_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit_limit_factor?: InputMaybe<Float8_Comparison_Exp>;
  credit_requests?: InputMaybe<Credit_Request_Bool_Exp>;
  credit_transactions?: InputMaybe<Credit_Transaction_Bool_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  financial_year_assessments?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  over_drafts?: InputMaybe<Over_Draft_Bool_Exp>;
  payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  projection_assessments?: InputMaybe<Projection_Assessment_Bool_Exp>;
  remaining_amount?: InputMaybe<Float8_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Credit_Status_Bool_Exp>;
  status_id?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Float8_Comparison_Exp>;
  trade_assessments?: InputMaybe<Trade_Assessment_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  used_amount?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  validity?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Max_Fields = {
  __typename?: 'credit_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_limit_factor?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  remaining_amount?: Maybe<Scalars['float8']>;
  start_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['bigint']>;
  validity?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "credit" */
export type Credit_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_limit_factor?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Min_Fields = {
  __typename?: 'credit_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_limit_factor?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  remaining_amount?: Maybe<Scalars['float8']>;
  start_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['bigint']>;
  validity?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "credit" */
export type Credit_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_limit_factor?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_note" */
export type Credit_Note = {
  __typename?: 'credit_note';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['bigint'];
  is_verified?: Maybe<Scalars['Boolean']>;
  remarks?: Maybe<Scalars['String']>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "credit_note" */
export type Credit_Note_Aggregate = {
  __typename?: 'credit_note_aggregate';
  aggregate?: Maybe<Credit_Note_Aggregate_Fields>;
  nodes: Array<Credit_Note>;
};

/** aggregate fields of "credit_note" */
export type Credit_Note_Aggregate_Fields = {
  __typename?: 'credit_note_aggregate_fields';
  avg?: Maybe<Credit_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Note_Max_Fields>;
  min?: Maybe<Credit_Note_Min_Fields>;
  stddev?: Maybe<Credit_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Note_Sum_Fields>;
  var_pop?: Maybe<Credit_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Note_Var_Samp_Fields>;
  variance?: Maybe<Credit_Note_Variance_Fields>;
};


/** aggregate fields of "credit_note" */
export type Credit_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_note" */
export type Credit_Note_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Note_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Note_Max_Order_By>;
  min?: InputMaybe<Credit_Note_Min_Order_By>;
  stddev?: InputMaybe<Credit_Note_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Note_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Note_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Note_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Note_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Note_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Note_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "credit_note" */
export type Credit_Note_Arr_Rel_Insert_Input = {
  data: Array<Credit_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_Note_On_Conflict>;
};

/** aggregate avg on columns */
export type Credit_Note_Avg_Fields = {
  __typename?: 'credit_note_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit_note" */
export type Credit_Note_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_note". All fields are combined with a logical 'AND'. */
export type Credit_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Note_Bool_Exp>>;
  _not?: InputMaybe<Credit_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Note_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "credit_note" */
export enum Credit_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreditNotePkey = 'credit_note_pkey'
}

/** input type for incrementing numeric columns in table "credit_note" */
export type Credit_Note_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "credit_note" */
export type Credit_Note_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  remarks?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Credit_Note_Max_Fields = {
  __typename?: 'credit_note_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "credit_note" */
export type Credit_Note_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Note_Min_Fields = {
  __typename?: 'credit_note_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "credit_note" */
export type Credit_Note_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "credit_note" */
export type Credit_Note_Mutation_Response = {
  __typename?: 'credit_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Credit_Note>;
};

/** on_conflict condition type for table "credit_note" */
export type Credit_Note_On_Conflict = {
  constraint: Credit_Note_Constraint;
  update_columns?: Array<Credit_Note_Update_Column>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "credit_note". */
export type Credit_Note_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: credit_note */
export type Credit_Note_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "credit_note" */
export enum Credit_Note_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "credit_note" */
export type Credit_Note_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  remarks?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Credit_Note_Stddev_Fields = {
  __typename?: 'credit_note_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit_note" */
export type Credit_Note_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Note_Stddev_Pop_Fields = {
  __typename?: 'credit_note_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit_note" */
export type Credit_Note_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Note_Stddev_Samp_Fields = {
  __typename?: 'credit_note_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit_note" */
export type Credit_Note_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_note" */
export type Credit_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Note_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Credit_Note_Sum_Fields = {
  __typename?: 'credit_note_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "credit_note" */
export type Credit_Note_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "credit_note" */
export enum Credit_Note_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Id = 'id',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UserId = 'user_id'
}

export type Credit_Note_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Credit_Note_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credit_Note_Set_Input>;
  where: Credit_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Credit_Note_Var_Pop_Fields = {
  __typename?: 'credit_note_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit_note" */
export type Credit_Note_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Note_Var_Samp_Fields = {
  __typename?: 'credit_note_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit_note" */
export type Credit_Note_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Note_Variance_Fields = {
  __typename?: 'credit_note_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit_note" */
export type Credit_Note_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit". */
export type Credit_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_limit_factor?: InputMaybe<Order_By>;
  credit_requests_aggregate?: InputMaybe<Credit_Request_Aggregate_Order_By>;
  credit_transactions_aggregate?: InputMaybe<Credit_Transaction_Aggregate_Order_By>;
  end_date?: InputMaybe<Order_By>;
  financial_year_assessments_aggregate?: InputMaybe<Financial_Year_Assessment_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  over_drafts_aggregate?: InputMaybe<Over_Draft_Aggregate_Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  projection_assessments_aggregate?: InputMaybe<Projection_Assessment_Aggregate_Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Credit_Status_Order_By>;
  status_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  trade_assessments_aggregate?: InputMaybe<Trade_Assessment_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_request" */
export type Credit_Request = {
  __typename?: 'credit_request';
  approved_credit_limit_factor?: Maybe<Scalars['float8']>;
  approved_end_date?: Maybe<Scalars['date']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_start_date?: Maybe<Scalars['date']>;
  approved_total_amount?: Maybe<Scalars['float8']>;
  approved_validity?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  credit: Credit;
  credit_id: Scalars['bigint'];
  extra_data?: Maybe<Array<Maybe<CreditRequestDetailType>>>;
  id: Scalars['bigint'];
  is_verified?: Maybe<Scalars['Boolean']>;
  remark?: Maybe<Scalars['String']>;
  requested_by?: Maybe<Base_User>;
  requested_by_id: Scalars['String'];
  requested_credit_limit_factor: Scalars['float8'];
  requested_date: Scalars['date'];
  requested_payment_cycle_days: Scalars['Int'];
  requested_total_amount: Scalars['float8'];
  requested_validity: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['date']>;
};

/** aggregated selection of "credit_request" */
export type Credit_Request_Aggregate = {
  __typename?: 'credit_request_aggregate';
  aggregate?: Maybe<Credit_Request_Aggregate_Fields>;
  nodes: Array<Credit_Request>;
};

/** aggregate fields of "credit_request" */
export type Credit_Request_Aggregate_Fields = {
  __typename?: 'credit_request_aggregate_fields';
  avg?: Maybe<Credit_Request_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Request_Max_Fields>;
  min?: Maybe<Credit_Request_Min_Fields>;
  stddev?: Maybe<Credit_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Request_Sum_Fields>;
  var_pop?: Maybe<Credit_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Request_Var_Samp_Fields>;
  variance?: Maybe<Credit_Request_Variance_Fields>;
};


/** aggregate fields of "credit_request" */
export type Credit_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_request" */
export type Credit_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Request_Max_Order_By>;
  min?: InputMaybe<Credit_Request_Min_Order_By>;
  stddev?: InputMaybe<Credit_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Request_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Credit_Request_Avg_Fields = {
  __typename?: 'credit_request_avg_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit_request" */
export type Credit_Request_Avg_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_request". All fields are combined with a logical 'AND'. */
export type Credit_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Request_Bool_Exp>>;
  _not?: InputMaybe<Credit_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Request_Bool_Exp>>;
  approved_credit_limit_factor?: InputMaybe<Float8_Comparison_Exp>;
  approved_end_date?: InputMaybe<Date_Comparison_Exp>;
  approved_payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  approved_start_date?: InputMaybe<Date_Comparison_Exp>;
  approved_total_amount?: InputMaybe<Float8_Comparison_Exp>;
  approved_validity?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit?: InputMaybe<Credit_Bool_Exp>;
  credit_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  requested_by_id?: InputMaybe<String_Comparison_Exp>;
  requested_credit_limit_factor?: InputMaybe<Float8_Comparison_Exp>;
  requested_date?: InputMaybe<Date_Comparison_Exp>;
  requested_payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  requested_total_amount?: InputMaybe<Float8_Comparison_Exp>;
  requested_validity?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Date_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Request_Max_Fields = {
  __typename?: 'credit_request_max_fields';
  approved_credit_limit_factor?: Maybe<Scalars['float8']>;
  approved_end_date?: Maybe<Scalars['date']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_start_date?: Maybe<Scalars['date']>;
  approved_total_amount?: Maybe<Scalars['float8']>;
  approved_validity?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  requested_by_id?: Maybe<Scalars['String']>;
  requested_credit_limit_factor?: Maybe<Scalars['float8']>;
  requested_date?: Maybe<Scalars['date']>;
  requested_payment_cycle_days?: Maybe<Scalars['Int']>;
  requested_total_amount?: Maybe<Scalars['float8']>;
  requested_validity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "credit_request" */
export type Credit_Request_Max_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_end_date?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_start_date?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  requested_by_id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_date?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Request_Min_Fields = {
  __typename?: 'credit_request_min_fields';
  approved_credit_limit_factor?: Maybe<Scalars['float8']>;
  approved_end_date?: Maybe<Scalars['date']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_start_date?: Maybe<Scalars['date']>;
  approved_total_amount?: Maybe<Scalars['float8']>;
  approved_validity?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  requested_by_id?: Maybe<Scalars['String']>;
  requested_credit_limit_factor?: Maybe<Scalars['float8']>;
  requested_date?: Maybe<Scalars['date']>;
  requested_payment_cycle_days?: Maybe<Scalars['Int']>;
  requested_total_amount?: Maybe<Scalars['float8']>;
  requested_validity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "credit_request" */
export type Credit_Request_Min_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_end_date?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_start_date?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  requested_by_id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_date?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_request". */
export type Credit_Request_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_end_date?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_start_date?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit?: InputMaybe<Credit_Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  requested_by_id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_date?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** select columns of table "credit_request" */
export enum Credit_Request_Select_Column {
  /** column name */
  ApprovedCreditLimitFactor = 'approved_credit_limit_factor',
  /** column name */
  ApprovedEndDate = 'approved_end_date',
  /** column name */
  ApprovedPaymentCycleDays = 'approved_payment_cycle_days',
  /** column name */
  ApprovedStartDate = 'approved_start_date',
  /** column name */
  ApprovedTotalAmount = 'approved_total_amount',
  /** column name */
  ApprovedValidity = 'approved_validity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Remark = 'remark',
  /** column name */
  RequestedById = 'requested_by_id',
  /** column name */
  RequestedCreditLimitFactor = 'requested_credit_limit_factor',
  /** column name */
  RequestedDate = 'requested_date',
  /** column name */
  RequestedPaymentCycleDays = 'requested_payment_cycle_days',
  /** column name */
  RequestedTotalAmount = 'requested_total_amount',
  /** column name */
  RequestedValidity = 'requested_validity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** aggregate stddev on columns */
export type Credit_Request_Stddev_Fields = {
  __typename?: 'credit_request_stddev_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit_request" */
export type Credit_Request_Stddev_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Request_Stddev_Pop_Fields = {
  __typename?: 'credit_request_stddev_pop_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit_request" */
export type Credit_Request_Stddev_Pop_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Request_Stddev_Samp_Fields = {
  __typename?: 'credit_request_stddev_samp_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit_request" */
export type Credit_Request_Stddev_Samp_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_request" */
export type Credit_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Request_Stream_Cursor_Value_Input = {
  approved_credit_limit_factor?: InputMaybe<Scalars['float8']>;
  approved_end_date?: InputMaybe<Scalars['date']>;
  approved_payment_cycle_days?: InputMaybe<Scalars['Int']>;
  approved_start_date?: InputMaybe<Scalars['date']>;
  approved_total_amount?: InputMaybe<Scalars['float8']>;
  approved_validity?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  remark?: InputMaybe<Scalars['String']>;
  requested_by_id?: InputMaybe<Scalars['String']>;
  requested_credit_limit_factor?: InputMaybe<Scalars['float8']>;
  requested_date?: InputMaybe<Scalars['date']>;
  requested_payment_cycle_days?: InputMaybe<Scalars['Int']>;
  requested_total_amount?: InputMaybe<Scalars['float8']>;
  requested_validity?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Credit_Request_Sum_Fields = {
  __typename?: 'credit_request_sum_fields';
  approved_credit_limit_factor?: Maybe<Scalars['float8']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_total_amount?: Maybe<Scalars['float8']>;
  approved_validity?: Maybe<Scalars['Int']>;
  credit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  requested_credit_limit_factor?: Maybe<Scalars['float8']>;
  requested_payment_cycle_days?: Maybe<Scalars['Int']>;
  requested_total_amount?: Maybe<Scalars['float8']>;
  requested_validity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "credit_request" */
export type Credit_Request_Sum_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Credit_Request_Var_Pop_Fields = {
  __typename?: 'credit_request_var_pop_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit_request" */
export type Credit_Request_Var_Pop_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Request_Var_Samp_Fields = {
  __typename?: 'credit_request_var_samp_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit_request" */
export type Credit_Request_Var_Samp_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Request_Variance_Fields = {
  __typename?: 'credit_request_variance_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit_request" */
export type Credit_Request_Variance_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** select columns of table "credit" */
export enum Credit_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreditLimitFactor = 'credit_limit_factor',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PaymentCycleDays = 'payment_cycle_days',
  /** column name */
  RemainingAmount = 'remaining_amount',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UsedAmount = 'used_amount',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Validity = 'validity',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** columns and relationships of "credit_status" */
export type Credit_Status = {
  __typename?: 'credit_status';
  /** An array relationship */
  children: Array<Credit_Status_Parents>;
  /** An aggregate relationship */
  children_aggregate: Credit_Status_Parents_Aggregate;
  id: Scalars['String'];
  is_actionable: Scalars['Boolean'];
  is_credit_active: Scalars['Boolean'];
  is_data_editable: Scalars['Boolean'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  parents: Array<Credit_Status_Parents>;
  /** An aggregate relationship */
  parents_aggregate: Credit_Status_Parents_Aggregate;
};


/** columns and relationships of "credit_status" */
export type Credit_StatusChildrenArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


/** columns and relationships of "credit_status" */
export type Credit_StatusChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


/** columns and relationships of "credit_status" */
export type Credit_StatusMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "credit_status" */
export type Credit_StatusParentsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


/** columns and relationships of "credit_status" */
export type Credit_StatusParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};

/** aggregated selection of "credit_status" */
export type Credit_Status_Aggregate = {
  __typename?: 'credit_status_aggregate';
  aggregate?: Maybe<Credit_Status_Aggregate_Fields>;
  nodes: Array<Credit_Status>;
};

/** aggregate fields of "credit_status" */
export type Credit_Status_Aggregate_Fields = {
  __typename?: 'credit_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Credit_Status_Max_Fields>;
  min?: Maybe<Credit_Status_Min_Fields>;
};


/** aggregate fields of "credit_status" */
export type Credit_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "credit_status". All fields are combined with a logical 'AND'. */
export type Credit_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Status_Bool_Exp>>;
  _not?: InputMaybe<Credit_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Status_Bool_Exp>>;
  children?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_actionable?: InputMaybe<Boolean_Comparison_Exp>;
  is_credit_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_data_editable?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  parents?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};

/** aggregate max on columns */
export type Credit_Status_Max_Fields = {
  __typename?: 'credit_status_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Credit_Status_Min_Fields = {
  __typename?: 'credit_status_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "credit_status". */
export type Credit_Status_Order_By = {
  children_aggregate?: InputMaybe<Credit_Status_Parents_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_actionable?: InputMaybe<Order_By>;
  is_credit_active?: InputMaybe<Order_By>;
  is_data_editable?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  parents_aggregate?: InputMaybe<Credit_Status_Parents_Aggregate_Order_By>;
};

/** columns and relationships of "credit_status_parents" */
export type Credit_Status_Parents = {
  __typename?: 'credit_status_parents';
  from_creditstatus_id: Scalars['String'];
  id: Scalars['bigint'];
  to_creditstatus_id: Scalars['String'];
};

/** aggregated selection of "credit_status_parents" */
export type Credit_Status_Parents_Aggregate = {
  __typename?: 'credit_status_parents_aggregate';
  aggregate?: Maybe<Credit_Status_Parents_Aggregate_Fields>;
  nodes: Array<Credit_Status_Parents>;
};

/** aggregate fields of "credit_status_parents" */
export type Credit_Status_Parents_Aggregate_Fields = {
  __typename?: 'credit_status_parents_aggregate_fields';
  avg?: Maybe<Credit_Status_Parents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Status_Parents_Max_Fields>;
  min?: Maybe<Credit_Status_Parents_Min_Fields>;
  stddev?: Maybe<Credit_Status_Parents_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Status_Parents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Status_Parents_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Status_Parents_Sum_Fields>;
  var_pop?: Maybe<Credit_Status_Parents_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Status_Parents_Var_Samp_Fields>;
  variance?: Maybe<Credit_Status_Parents_Variance_Fields>;
};


/** aggregate fields of "credit_status_parents" */
export type Credit_Status_Parents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_status_parents" */
export type Credit_Status_Parents_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Status_Parents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Status_Parents_Max_Order_By>;
  min?: InputMaybe<Credit_Status_Parents_Min_Order_By>;
  stddev?: InputMaybe<Credit_Status_Parents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Status_Parents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Status_Parents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Status_Parents_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Status_Parents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Status_Parents_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Status_Parents_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Credit_Status_Parents_Avg_Fields = {
  __typename?: 'credit_status_parents_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_status_parents". All fields are combined with a logical 'AND'. */
export type Credit_Status_Parents_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Status_Parents_Bool_Exp>>;
  _not?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Status_Parents_Bool_Exp>>;
  from_creditstatus_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  to_creditstatus_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Status_Parents_Max_Fields = {
  __typename?: 'credit_status_parents_max_fields';
  from_creditstatus_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  to_creditstatus_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Max_Order_By = {
  from_creditstatus_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_creditstatus_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Status_Parents_Min_Fields = {
  __typename?: 'credit_status_parents_min_fields';
  from_creditstatus_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  to_creditstatus_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Min_Order_By = {
  from_creditstatus_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_creditstatus_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_status_parents". */
export type Credit_Status_Parents_Order_By = {
  from_creditstatus_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_creditstatus_id?: InputMaybe<Order_By>;
};

/** select columns of table "credit_status_parents" */
export enum Credit_Status_Parents_Select_Column {
  /** column name */
  FromCreditstatusId = 'from_creditstatus_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToCreditstatusId = 'to_creditstatus_id'
}

/** aggregate stddev on columns */
export type Credit_Status_Parents_Stddev_Fields = {
  __typename?: 'credit_status_parents_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Status_Parents_Stddev_Pop_Fields = {
  __typename?: 'credit_status_parents_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Status_Parents_Stddev_Samp_Fields = {
  __typename?: 'credit_status_parents_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_status_parents" */
export type Credit_Status_Parents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Status_Parents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Status_Parents_Stream_Cursor_Value_Input = {
  from_creditstatus_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  to_creditstatus_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Credit_Status_Parents_Sum_Fields = {
  __typename?: 'credit_status_parents_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Credit_Status_Parents_Var_Pop_Fields = {
  __typename?: 'credit_status_parents_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Status_Parents_Var_Samp_Fields = {
  __typename?: 'credit_status_parents_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Status_Parents_Variance_Fields = {
  __typename?: 'credit_status_parents_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit_status_parents" */
export type Credit_Status_Parents_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "credit_status" */
export enum Credit_Status_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActionable = 'is_actionable',
  /** column name */
  IsCreditActive = 'is_credit_active',
  /** column name */
  IsDataEditable = 'is_data_editable',
  /** column name */
  Metadata = 'metadata'
}

/** Streaming cursor of the table "credit_status" */
export type Credit_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Status_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  is_actionable?: InputMaybe<Scalars['Boolean']>;
  is_credit_active?: InputMaybe<Scalars['Boolean']>;
  is_data_editable?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Credit_Stddev_Fields = {
  __typename?: 'credit_stddev_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit" */
export type Credit_Stddev_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Stddev_Pop_Fields = {
  __typename?: 'credit_stddev_pop_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit" */
export type Credit_Stddev_Pop_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Stddev_Samp_Fields = {
  __typename?: 'credit_stddev_samp_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit" */
export type Credit_Stddev_Samp_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit" */
export type Credit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  credit_limit_factor?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payment_cycle_days?: InputMaybe<Scalars['Int']>;
  remaining_amount?: InputMaybe<Scalars['float8']>;
  start_date?: InputMaybe<Scalars['date']>;
  status_id?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  used_amount?: InputMaybe<Scalars['float8']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  validity?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Credit_Sum_Fields = {
  __typename?: 'credit_sum_fields';
  credit_limit_factor?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  remaining_amount?: Maybe<Scalars['float8']>;
  total_amount?: Maybe<Scalars['float8']>;
  used_amount?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['bigint']>;
  validity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "credit" */
export type Credit_Sum_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_transaction" */
export type Credit_Transaction = {
  __typename?: 'credit_transaction';
  amount: Scalars['float8'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  credit: Credit;
  credit_id: Scalars['bigint'];
  date?: Maybe<Scalars['date']>;
  id: Scalars['bigint'];
  is_dumped: Scalars['Boolean'];
  outstanding_amount: Scalars['float8'];
  settled_amount: Scalars['float8'];
  /** An array relationship */
  settled_by_transactions: Array<Transaction>;
  /** An aggregate relationship */
  settled_by_transactions_aggregate: Transaction_Aggregate;
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  transaction_kind: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "credit_transaction" */
export type Credit_TransactionSettled_By_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "credit_transaction" */
export type Credit_TransactionSettled_By_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

/** aggregated selection of "credit_transaction" */
export type Credit_Transaction_Aggregate = {
  __typename?: 'credit_transaction_aggregate';
  aggregate?: Maybe<Credit_Transaction_Aggregate_Fields>;
  nodes: Array<Credit_Transaction>;
};

/** aggregate fields of "credit_transaction" */
export type Credit_Transaction_Aggregate_Fields = {
  __typename?: 'credit_transaction_aggregate_fields';
  avg?: Maybe<Credit_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Transaction_Max_Fields>;
  min?: Maybe<Credit_Transaction_Min_Fields>;
  stddev?: Maybe<Credit_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Transaction_Sum_Fields>;
  var_pop?: Maybe<Credit_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Credit_Transaction_Variance_Fields>;
};


/** aggregate fields of "credit_transaction" */
export type Credit_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_transaction" */
export type Credit_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Transaction_Max_Order_By>;
  min?: InputMaybe<Credit_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Credit_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Transaction_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Credit_Transaction_Avg_Fields = {
  __typename?: 'credit_transaction_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit_transaction" */
export type Credit_Transaction_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_transaction". All fields are combined with a logical 'AND'. */
export type Credit_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Credit_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Transaction_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit?: InputMaybe<Credit_Bool_Exp>;
  credit_id?: InputMaybe<Bigint_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_dumped?: InputMaybe<Boolean_Comparison_Exp>;
  outstanding_amount?: InputMaybe<Float8_Comparison_Exp>;
  settled_amount?: InputMaybe<Float8_Comparison_Exp>;
  settled_by_transactions?: InputMaybe<Transaction_Bool_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  transaction_kind?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Transaction_Max_Fields = {
  __typename?: 'credit_transaction_max_fields';
  amount?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_id?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  outstanding_amount?: Maybe<Scalars['float8']>;
  settled_amount?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  transaction_kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "credit_transaction" */
export type Credit_Transaction_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  transaction_kind?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Transaction_Min_Fields = {
  __typename?: 'credit_transaction_min_fields';
  amount?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_id?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  outstanding_amount?: Maybe<Scalars['float8']>;
  settled_amount?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  transaction_kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "credit_transaction" */
export type Credit_Transaction_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  transaction_kind?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_transaction". */
export type Credit_Transaction_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit?: InputMaybe<Credit_Order_By>;
  credit_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_dumped?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  settled_by_transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  transaction_kind?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "credit_transaction" */
export enum Credit_Transaction_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsDumped = 'is_dumped',
  /** column name */
  OutstandingAmount = 'outstanding_amount',
  /** column name */
  SettledAmount = 'settled_amount',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  TransactionKind = 'transaction_kind',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Credit_Transaction_Stddev_Fields = {
  __typename?: 'credit_transaction_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit_transaction" */
export type Credit_Transaction_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Transaction_Stddev_Pop_Fields = {
  __typename?: 'credit_transaction_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit_transaction" */
export type Credit_Transaction_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Transaction_Stddev_Samp_Fields = {
  __typename?: 'credit_transaction_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit_transaction" */
export type Credit_Transaction_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_transaction" */
export type Credit_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Transaction_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_dumped?: InputMaybe<Scalars['Boolean']>;
  outstanding_amount?: InputMaybe<Scalars['float8']>;
  settled_amount?: InputMaybe<Scalars['float8']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  transaction_kind?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Credit_Transaction_Sum_Fields = {
  __typename?: 'credit_transaction_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  outstanding_amount?: Maybe<Scalars['float8']>;
  settled_amount?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "credit_transaction" */
export type Credit_Transaction_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Credit_Transaction_Var_Pop_Fields = {
  __typename?: 'credit_transaction_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit_transaction" */
export type Credit_Transaction_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Transaction_Var_Samp_Fields = {
  __typename?: 'credit_transaction_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit_transaction" */
export type Credit_Transaction_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Transaction_Variance_Fields = {
  __typename?: 'credit_transaction_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit_transaction" */
export type Credit_Transaction_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Credit_Var_Pop_Fields = {
  __typename?: 'credit_var_pop_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit" */
export type Credit_Var_Pop_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Var_Samp_Fields = {
  __typename?: 'credit_var_samp_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit" */
export type Credit_Var_Samp_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Variance_Fields = {
  __typename?: 'credit_variance_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit" */
export type Credit_Variance_Order_By = {
  credit_limit_factor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_wallet" */
export type Credit_Wallet = {
  __typename?: 'credit_wallet';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  credit_limit_factor: Scalars['numeric'];
  /** An array relationship */
  credit_wallet_requests: Array<Credit_Wallet_Request>;
  /** An aggregate relationship */
  credit_wallet_requests_aggregate: Credit_Wallet_Request_Aggregate;
  end_date?: Maybe<Scalars['date']>;
  id: Scalars['bigint'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  /** An array relationship */
  over_draft_cws: Array<Over_Draft_Cw>;
  /** An aggregate relationship */
  over_draft_cws_aggregate: Over_Draft_Cw_Aggregate;
  /** An array relationship */
  over_due_approval_cws: Array<Over_Due_Approval_Cw>;
  /** An aggregate relationship */
  over_due_approval_cws_aggregate: Over_Due_Approval_Cw_Aggregate;
  payment_cycle_days: Scalars['Int'];
  remaining_amount: Scalars['numeric'];
  start_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  status: Credit_Wallet_Status;
  status_id: Scalars['String'];
  total_amount: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount: Scalars['numeric'];
  used_overdraft: Scalars['numeric'];
  /** An object relationship */
  user: Setu_Trade_Shared_Entity;
  user_id: Scalars['bigint'];
  validity: Scalars['Int'];
  verification_remark?: Maybe<Scalars['String']>;
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "credit_wallet" */
export type Credit_WalletCredit_Wallet_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Request_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
};


/** columns and relationships of "credit_wallet" */
export type Credit_WalletCredit_Wallet_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Request_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
};


/** columns and relationships of "credit_wallet" */
export type Credit_WalletMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "credit_wallet" */
export type Credit_WalletOver_Draft_CwsArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet" */
export type Credit_WalletOver_Draft_Cws_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet" */
export type Credit_WalletOver_Due_Approval_CwsArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Cw_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet" */
export type Credit_WalletOver_Due_Approval_Cws_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Cw_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
};

/** aggregated selection of "credit_wallet" */
export type Credit_Wallet_Aggregate = {
  __typename?: 'credit_wallet_aggregate';
  aggregate?: Maybe<Credit_Wallet_Aggregate_Fields>;
  nodes: Array<Credit_Wallet>;
};

/** aggregate fields of "credit_wallet" */
export type Credit_Wallet_Aggregate_Fields = {
  __typename?: 'credit_wallet_aggregate_fields';
  avg?: Maybe<Credit_Wallet_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Wallet_Max_Fields>;
  min?: Maybe<Credit_Wallet_Min_Fields>;
  stddev?: Maybe<Credit_Wallet_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Wallet_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Wallet_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Wallet_Sum_Fields>;
  var_pop?: Maybe<Credit_Wallet_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Wallet_Var_Samp_Fields>;
  variance?: Maybe<Credit_Wallet_Variance_Fields>;
};


/** aggregate fields of "credit_wallet" */
export type Credit_Wallet_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Wallet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Credit_Wallet_Avg_Fields = {
  __typename?: 'credit_wallet_avg_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  used_overdraft?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "credit_wallet". All fields are combined with a logical 'AND'. */
export type Credit_Wallet_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Wallet_Bool_Exp>>;
  _not?: InputMaybe<Credit_Wallet_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Wallet_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit_limit_factor?: InputMaybe<Numeric_Comparison_Exp>;
  credit_wallet_requests?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  over_draft_cws?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
  over_due_approval_cws?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
  payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  remaining_amount?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Credit_Wallet_Status_Bool_Exp>;
  status_id?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  used_amount?: InputMaybe<Numeric_Comparison_Exp>;
  used_overdraft?: InputMaybe<Numeric_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  validity?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Wallet_Max_Fields = {
  __typename?: 'credit_wallet_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_limit_factor?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount?: Maybe<Scalars['numeric']>;
  used_overdraft?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['bigint']>;
  validity?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Credit_Wallet_Min_Fields = {
  __typename?: 'credit_wallet_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_limit_factor?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_amount?: Maybe<Scalars['numeric']>;
  used_overdraft?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['bigint']>;
  validity?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "credit_wallet". */
export type Credit_Wallet_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_limit_factor?: InputMaybe<Order_By>;
  credit_wallet_requests_aggregate?: InputMaybe<Credit_Wallet_Request_Aggregate_Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  over_draft_cws_aggregate?: InputMaybe<Over_Draft_Cw_Aggregate_Order_By>;
  over_due_approval_cws_aggregate?: InputMaybe<Over_Due_Approval_Cw_Aggregate_Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Credit_Wallet_Status_Order_By>;
  status_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  used_overdraft?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
  validity?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "credit_wallet_request" */
export type Credit_Wallet_Request = {
  __typename?: 'credit_wallet_request';
  approved_credit_limit_factor?: Maybe<Scalars['numeric']>;
  approved_end_date?: Maybe<Scalars['date']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_start_date?: Maybe<Scalars['date']>;
  approved_total_amount?: Maybe<Scalars['numeric']>;
  approved_validity?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  credit_wallet: Credit_Wallet;
  credit_wallet_id: Scalars['bigint'];
  /** An array relationship */
  financial_year_assessment_cw: Array<Financial_Year_Assessment_Cw>;
  /** An aggregate relationship */
  financial_year_assessment_cw_aggregate: Financial_Year_Assessment_Cw_Aggregate;
  id: Scalars['bigint'];
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  projection_assessment_cw: Array<Projection_Assessment_Cw>;
  /** An aggregate relationship */
  projection_assessment_cw_aggregate: Projection_Assessment_Cw_Aggregate;
  remark?: Maybe<Scalars['String']>;
  requested_by_id: Scalars['String'];
  requested_credit_limit_factor: Scalars['numeric'];
  requested_date: Scalars['date'];
  requested_payment_cycle_days: Scalars['Int'];
  requested_total_amount: Scalars['numeric'];
  requested_validity: Scalars['Int'];
  /** An array relationship */
  trade_assessment_cw: Array<Trade_Assessment_Cw>;
  /** An aggregate relationship */
  trade_assessment_cw_aggregate: Trade_Assessment_Cw_Aggregate;
  updated_at: Scalars['timestamptz'];
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['date']>;
};


/** columns and relationships of "credit_wallet_request" */
export type Credit_Wallet_RequestFinancial_Year_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet_request" */
export type Credit_Wallet_RequestFinancial_Year_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet_request" */
export type Credit_Wallet_RequestProjection_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet_request" */
export type Credit_Wallet_RequestProjection_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet_request" */
export type Credit_Wallet_RequestTrade_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
};


/** columns and relationships of "credit_wallet_request" */
export type Credit_Wallet_RequestTrade_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
};

/** aggregated selection of "credit_wallet_request" */
export type Credit_Wallet_Request_Aggregate = {
  __typename?: 'credit_wallet_request_aggregate';
  aggregate?: Maybe<Credit_Wallet_Request_Aggregate_Fields>;
  nodes: Array<Credit_Wallet_Request>;
};

/** aggregate fields of "credit_wallet_request" */
export type Credit_Wallet_Request_Aggregate_Fields = {
  __typename?: 'credit_wallet_request_aggregate_fields';
  avg?: Maybe<Credit_Wallet_Request_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Wallet_Request_Max_Fields>;
  min?: Maybe<Credit_Wallet_Request_Min_Fields>;
  stddev?: Maybe<Credit_Wallet_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Wallet_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Wallet_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Wallet_Request_Sum_Fields>;
  var_pop?: Maybe<Credit_Wallet_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Wallet_Request_Var_Samp_Fields>;
  variance?: Maybe<Credit_Wallet_Request_Variance_Fields>;
};


/** aggregate fields of "credit_wallet_request" */
export type Credit_Wallet_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Wallet_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "credit_wallet_request" */
export type Credit_Wallet_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Wallet_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Wallet_Request_Max_Order_By>;
  min?: InputMaybe<Credit_Wallet_Request_Min_Order_By>;
  stddev?: InputMaybe<Credit_Wallet_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Wallet_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Wallet_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Wallet_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Wallet_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Wallet_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Wallet_Request_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Credit_Wallet_Request_Avg_Fields = {
  __typename?: 'credit_wallet_request_avg_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Avg_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_wallet_request". All fields are combined with a logical 'AND'. */
export type Credit_Wallet_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Wallet_Request_Bool_Exp>>;
  _not?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Wallet_Request_Bool_Exp>>;
  approved_credit_limit_factor?: InputMaybe<Numeric_Comparison_Exp>;
  approved_end_date?: InputMaybe<Date_Comparison_Exp>;
  approved_payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  approved_start_date?: InputMaybe<Date_Comparison_Exp>;
  approved_total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  approved_validity?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_wallet?: InputMaybe<Credit_Wallet_Bool_Exp>;
  credit_wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
  financial_year_assessment_cw?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  projection_assessment_cw?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  requested_by_id?: InputMaybe<String_Comparison_Exp>;
  requested_credit_limit_factor?: InputMaybe<Numeric_Comparison_Exp>;
  requested_date?: InputMaybe<Date_Comparison_Exp>;
  requested_payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  requested_total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  requested_validity?: InputMaybe<Int_Comparison_Exp>;
  trade_assessment_cw?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Date_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Wallet_Request_Max_Fields = {
  __typename?: 'credit_wallet_request_max_fields';
  approved_credit_limit_factor?: Maybe<Scalars['numeric']>;
  approved_end_date?: Maybe<Scalars['date']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_start_date?: Maybe<Scalars['date']>;
  approved_total_amount?: Maybe<Scalars['numeric']>;
  approved_validity?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  requested_by_id?: Maybe<Scalars['String']>;
  requested_credit_limit_factor?: Maybe<Scalars['numeric']>;
  requested_date?: Maybe<Scalars['date']>;
  requested_payment_cycle_days?: Maybe<Scalars['Int']>;
  requested_total_amount?: Maybe<Scalars['numeric']>;
  requested_validity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Max_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_end_date?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_start_date?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  requested_by_id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_date?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Wallet_Request_Min_Fields = {
  __typename?: 'credit_wallet_request_min_fields';
  approved_credit_limit_factor?: Maybe<Scalars['numeric']>;
  approved_end_date?: Maybe<Scalars['date']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_start_date?: Maybe<Scalars['date']>;
  approved_total_amount?: Maybe<Scalars['numeric']>;
  approved_validity?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  requested_by_id?: Maybe<Scalars['String']>;
  requested_credit_limit_factor?: Maybe<Scalars['numeric']>;
  requested_date?: Maybe<Scalars['date']>;
  requested_payment_cycle_days?: Maybe<Scalars['Int']>;
  requested_total_amount?: Maybe<Scalars['numeric']>;
  requested_validity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Min_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_end_date?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_start_date?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  requested_by_id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_date?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "credit_wallet_request". */
export type Credit_Wallet_Request_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_end_date?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_start_date?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_wallet?: InputMaybe<Credit_Wallet_Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  financial_year_assessment_cw_aggregate?: InputMaybe<Financial_Year_Assessment_Cw_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  projection_assessment_cw_aggregate?: InputMaybe<Projection_Assessment_Cw_Aggregate_Order_By>;
  remark?: InputMaybe<Order_By>;
  requested_by_id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_date?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
  trade_assessment_cw_aggregate?: InputMaybe<Trade_Assessment_Cw_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** select columns of table "credit_wallet_request" */
export enum Credit_Wallet_Request_Select_Column {
  /** column name */
  ApprovedCreditLimitFactor = 'approved_credit_limit_factor',
  /** column name */
  ApprovedEndDate = 'approved_end_date',
  /** column name */
  ApprovedPaymentCycleDays = 'approved_payment_cycle_days',
  /** column name */
  ApprovedStartDate = 'approved_start_date',
  /** column name */
  ApprovedTotalAmount = 'approved_total_amount',
  /** column name */
  ApprovedValidity = 'approved_validity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditWalletId = 'credit_wallet_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Remark = 'remark',
  /** column name */
  RequestedById = 'requested_by_id',
  /** column name */
  RequestedCreditLimitFactor = 'requested_credit_limit_factor',
  /** column name */
  RequestedDate = 'requested_date',
  /** column name */
  RequestedPaymentCycleDays = 'requested_payment_cycle_days',
  /** column name */
  RequestedTotalAmount = 'requested_total_amount',
  /** column name */
  RequestedValidity = 'requested_validity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** aggregate stddev on columns */
export type Credit_Wallet_Request_Stddev_Fields = {
  __typename?: 'credit_wallet_request_stddev_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Stddev_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Wallet_Request_Stddev_Pop_Fields = {
  __typename?: 'credit_wallet_request_stddev_pop_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Stddev_Pop_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Wallet_Request_Stddev_Samp_Fields = {
  __typename?: 'credit_wallet_request_stddev_samp_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Stddev_Samp_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_wallet_request" */
export type Credit_Wallet_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Wallet_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Wallet_Request_Stream_Cursor_Value_Input = {
  approved_credit_limit_factor?: InputMaybe<Scalars['numeric']>;
  approved_end_date?: InputMaybe<Scalars['date']>;
  approved_payment_cycle_days?: InputMaybe<Scalars['Int']>;
  approved_start_date?: InputMaybe<Scalars['date']>;
  approved_total_amount?: InputMaybe<Scalars['numeric']>;
  approved_validity?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_wallet_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  remark?: InputMaybe<Scalars['String']>;
  requested_by_id?: InputMaybe<Scalars['String']>;
  requested_credit_limit_factor?: InputMaybe<Scalars['numeric']>;
  requested_date?: InputMaybe<Scalars['date']>;
  requested_payment_cycle_days?: InputMaybe<Scalars['Int']>;
  requested_total_amount?: InputMaybe<Scalars['numeric']>;
  requested_validity?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Credit_Wallet_Request_Sum_Fields = {
  __typename?: 'credit_wallet_request_sum_fields';
  approved_credit_limit_factor?: Maybe<Scalars['numeric']>;
  approved_payment_cycle_days?: Maybe<Scalars['Int']>;
  approved_total_amount?: Maybe<Scalars['numeric']>;
  approved_validity?: Maybe<Scalars['Int']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  requested_credit_limit_factor?: Maybe<Scalars['numeric']>;
  requested_payment_cycle_days?: Maybe<Scalars['Int']>;
  requested_total_amount?: Maybe<Scalars['numeric']>;
  requested_validity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Sum_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Credit_Wallet_Request_Var_Pop_Fields = {
  __typename?: 'credit_wallet_request_var_pop_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Var_Pop_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Wallet_Request_Var_Samp_Fields = {
  __typename?: 'credit_wallet_request_var_samp_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Var_Samp_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Wallet_Request_Variance_Fields = {
  __typename?: 'credit_wallet_request_variance_fields';
  approved_credit_limit_factor?: Maybe<Scalars['Float']>;
  approved_payment_cycle_days?: Maybe<Scalars['Float']>;
  approved_total_amount?: Maybe<Scalars['Float']>;
  approved_validity?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requested_credit_limit_factor?: Maybe<Scalars['Float']>;
  requested_payment_cycle_days?: Maybe<Scalars['Float']>;
  requested_total_amount?: Maybe<Scalars['Float']>;
  requested_validity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "credit_wallet_request" */
export type Credit_Wallet_Request_Variance_Order_By = {
  approved_credit_limit_factor?: InputMaybe<Order_By>;
  approved_payment_cycle_days?: InputMaybe<Order_By>;
  approved_total_amount?: InputMaybe<Order_By>;
  approved_validity?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  requested_credit_limit_factor?: InputMaybe<Order_By>;
  requested_payment_cycle_days?: InputMaybe<Order_By>;
  requested_total_amount?: InputMaybe<Order_By>;
  requested_validity?: InputMaybe<Order_By>;
};

/** select columns of table "credit_wallet" */
export enum Credit_Wallet_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreditLimitFactor = 'credit_limit_factor',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PaymentCycleDays = 'payment_cycle_days',
  /** column name */
  RemainingAmount = 'remaining_amount',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UsedAmount = 'used_amount',
  /** column name */
  UsedOverdraft = 'used_overdraft',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Validity = 'validity',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** columns and relationships of "credit_wallet_status" */
export type Credit_Wallet_Status = {
  __typename?: 'credit_wallet_status';
  id: Scalars['String'];
  is_actionable: Scalars['Boolean'];
  is_credit_active: Scalars['Boolean'];
  is_data_editable: Scalars['Boolean'];
  metadata?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "credit_wallet_status" */
export type Credit_Wallet_StatusMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "credit_wallet_status" */
export type Credit_Wallet_Status_Aggregate = {
  __typename?: 'credit_wallet_status_aggregate';
  aggregate?: Maybe<Credit_Wallet_Status_Aggregate_Fields>;
  nodes: Array<Credit_Wallet_Status>;
};

/** aggregate fields of "credit_wallet_status" */
export type Credit_Wallet_Status_Aggregate_Fields = {
  __typename?: 'credit_wallet_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Credit_Wallet_Status_Max_Fields>;
  min?: Maybe<Credit_Wallet_Status_Min_Fields>;
};


/** aggregate fields of "credit_wallet_status" */
export type Credit_Wallet_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Wallet_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "credit_wallet_status". All fields are combined with a logical 'AND'. */
export type Credit_Wallet_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Wallet_Status_Bool_Exp>>;
  _not?: InputMaybe<Credit_Wallet_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Wallet_Status_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_actionable?: InputMaybe<Boolean_Comparison_Exp>;
  is_credit_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_data_editable?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** aggregate max on columns */
export type Credit_Wallet_Status_Max_Fields = {
  __typename?: 'credit_wallet_status_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Credit_Wallet_Status_Min_Fields = {
  __typename?: 'credit_wallet_status_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "credit_wallet_status". */
export type Credit_Wallet_Status_Order_By = {
  id?: InputMaybe<Order_By>;
  is_actionable?: InputMaybe<Order_By>;
  is_credit_active?: InputMaybe<Order_By>;
  is_data_editable?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
};

/** select columns of table "credit_wallet_status" */
export enum Credit_Wallet_Status_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActionable = 'is_actionable',
  /** column name */
  IsCreditActive = 'is_credit_active',
  /** column name */
  IsDataEditable = 'is_data_editable',
  /** column name */
  Metadata = 'metadata'
}

/** Streaming cursor of the table "credit_wallet_status" */
export type Credit_Wallet_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Wallet_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Wallet_Status_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  is_actionable?: InputMaybe<Scalars['Boolean']>;
  is_credit_active?: InputMaybe<Scalars['Boolean']>;
  is_data_editable?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Credit_Wallet_Stddev_Fields = {
  __typename?: 'credit_wallet_stddev_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  used_overdraft?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Credit_Wallet_Stddev_Pop_Fields = {
  __typename?: 'credit_wallet_stddev_pop_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  used_overdraft?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Credit_Wallet_Stddev_Samp_Fields = {
  __typename?: 'credit_wallet_stddev_samp_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  used_overdraft?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "credit_wallet" */
export type Credit_Wallet_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Wallet_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Wallet_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  credit_limit_factor?: InputMaybe<Scalars['numeric']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payment_cycle_days?: InputMaybe<Scalars['Int']>;
  remaining_amount?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  status_id?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  used_amount?: InputMaybe<Scalars['numeric']>;
  used_overdraft?: InputMaybe<Scalars['numeric']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  validity?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Credit_Wallet_Sum_Fields = {
  __typename?: 'credit_wallet_sum_fields';
  credit_limit_factor?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  used_amount?: Maybe<Scalars['numeric']>;
  used_overdraft?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['bigint']>;
  validity?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Credit_Wallet_Var_Pop_Fields = {
  __typename?: 'credit_wallet_var_pop_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  used_overdraft?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Credit_Wallet_Var_Samp_Fields = {
  __typename?: 'credit_wallet_var_samp_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  used_overdraft?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Credit_Wallet_Variance_Fields = {
  __typename?: 'credit_wallet_variance_fields';
  credit_limit_factor?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  used_overdraft?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "crop" */
export type Crop = {
  __typename?: 'crop';
  codename: Scalars['String'];
  /** An array relationship */
  commodities: Array<Commodity>;
  /** An aggregate relationship */
  commodities_aggregate: Commodity_Aggregate;
  /** An object relationship */
  crop_group?: Maybe<Crop_Group>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hex_color_code: Scalars['String'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  name: Scalars['String'];
  /** An array relationship */
  organisation_crops: Array<Organisation_Crop>;
  /** An aggregate relationship */
  organisation_crops_aggregate: Organisation_Crop_Aggregate;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  varieties: Array<Crop_Variety>;
  /** An aggregate relationship */
  varieties_aggregate: Crop_Variety_Aggregate;
};


/** columns and relationships of "crop" */
export type CropCommoditiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropCommodities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropOrganisation_CropsArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Crop_Order_By>>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropOrganisation_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Crop_Order_By>>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropVarietiesArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


/** columns and relationships of "crop" */
export type CropVarieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** aggregated selection of "crop" */
export type Crop_Aggregate = {
  __typename?: 'crop_aggregate';
  aggregate?: Maybe<Crop_Aggregate_Fields>;
  nodes: Array<Crop>;
};

/** aggregate fields of "crop" */
export type Crop_Aggregate_Fields = {
  __typename?: 'crop_aggregate_fields';
  avg?: Maybe<Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Max_Fields>;
  min?: Maybe<Crop_Min_Fields>;
  stddev?: Maybe<Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Sum_Fields>;
  var_pop?: Maybe<Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Var_Samp_Fields>;
  variance?: Maybe<Crop_Variance_Fields>;
};


/** aggregate fields of "crop" */
export type Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Avg_Fields = {
  __typename?: 'crop_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  crop_group?: InputMaybe<Crop_Group_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  max_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  max_production_days?: InputMaybe<Int_Comparison_Exp>;
  max_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  min_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  min_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  min_production_days?: InputMaybe<Int_Comparison_Exp>;
  min_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_crops?: InputMaybe<Organisation_Crop_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop". All fields are combined with a logical 'AND'. */
export type Crop_Bool_Exp_Remote_Rel_External_Entitycrop = {
  _and?: InputMaybe<Array<Crop_Bool_Exp>>;
  _not?: InputMaybe<Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_External_Entitycrop>;
  commodities?: InputMaybe<Commodity_Bool_Exp>;
  crop_group?: InputMaybe<Crop_Group_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  hex_color_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  max_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  max_production_days?: InputMaybe<Int_Comparison_Exp>;
  max_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  min_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  min_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  min_production_days?: InputMaybe<Int_Comparison_Exp>;
  min_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_crops?: InputMaybe<Organisation_Crop_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  varieties?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** unique or primary key constraints on table "crop" */
export enum Crop_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CropCodenameKey = 'crop_codename_key',
  /** unique or primary key constraint on columns "id" */
  CropPkey = 'crop_pkey'
}

/** columns and relationships of "crop_group" */
export type Crop_Group = {
  __typename?: 'crop_group';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_perennial: Scalars['Boolean'];
  name: Scalars['String'];
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "crop_group" */
export type Crop_Group_Aggregate = {
  __typename?: 'crop_group_aggregate';
  aggregate?: Maybe<Crop_Group_Aggregate_Fields>;
  nodes: Array<Crop_Group>;
};

/** aggregate fields of "crop_group" */
export type Crop_Group_Aggregate_Fields = {
  __typename?: 'crop_group_aggregate_fields';
  avg?: Maybe<Crop_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Group_Max_Fields>;
  min?: Maybe<Crop_Group_Min_Fields>;
  stddev?: Maybe<Crop_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Group_Sum_Fields>;
  var_pop?: Maybe<Crop_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Group_Var_Samp_Fields>;
  variance?: Maybe<Crop_Group_Variance_Fields>;
};


/** aggregate fields of "crop_group" */
export type Crop_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Group_Avg_Fields = {
  __typename?: 'crop_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_group". All fields are combined with a logical 'AND'. */
export type Crop_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Group_Bool_Exp>>;
  _not?: InputMaybe<Crop_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_perennial?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_group" */
export enum Crop_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CropGroupCodenameKey = 'crop_group_codename_key',
  /** unique or primary key constraint on columns "name" */
  CropGroupNameKey = 'crop_group_name_key',
  /** unique or primary key constraint on columns "id" */
  CropGroupPkey = 'crop_group_pkey'
}

/** input type for incrementing numeric columns in table "crop_group" */
export type Crop_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_group" */
export type Crop_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_perennial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Crop_Group_Max_Fields = {
  __typename?: 'crop_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Crop_Group_Min_Fields = {
  __typename?: 'crop_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "crop_group" */
export type Crop_Group_Mutation_Response = {
  __typename?: 'crop_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Group>;
};

/** input type for inserting object relation for remote table "crop_group" */
export type Crop_Group_Obj_Rel_Insert_Input = {
  data: Crop_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Group_On_Conflict>;
};

/** on_conflict condition type for table "crop_group" */
export type Crop_Group_On_Conflict = {
  constraint: Crop_Group_Constraint;
  update_columns?: Array<Crop_Group_Update_Column>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_group". */
export type Crop_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_perennial?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_group */
export type Crop_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_group" */
export enum Crop_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPerennial = 'is_perennial',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "crop_group" */
export type Crop_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_perennial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Group_Stddev_Fields = {
  __typename?: 'crop_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Group_Stddev_Pop_Fields = {
  __typename?: 'crop_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Group_Stddev_Samp_Fields = {
  __typename?: 'crop_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_group" */
export type Crop_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_perennial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Group_Sum_Fields = {
  __typename?: 'crop_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_group" */
export enum Crop_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPerennial = 'is_perennial',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Crop_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Group_Set_Input>;
  where: Crop_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Group_Var_Pop_Fields = {
  __typename?: 'crop_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Group_Var_Samp_Fields = {
  __typename?: 'crop_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Group_Variance_Fields = {
  __typename?: 'crop_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "crop" */
export type Crop_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "crop_infestation" */
export type Crop_Infestation = {
  __typename?: 'crop_infestation';
  affects?: Maybe<Scalars['String']>;
  biological_measures?: Maybe<Scalars['String']>;
  chemical_measures?: Maybe<Scalars['String']>;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  /** An array relationship */
  crop_infestation_attachments: Array<Crop_Infestation_Attachment>;
  /** An aggregate relationship */
  crop_infestation_attachments_aggregate: Crop_Infestation_Attachment_Aggregate;
  cultural_measures?: Maybe<Scalars['String']>;
  damage_nature?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  infestation: Infestation;
  infestation_id: Scalars['Int'];
  infestation_period?: Maybe<Scalars['String']>;
  infestation_stage?: Maybe<Scalars['String']>;
  mechanical_measures?: Maybe<Scalars['String']>;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  quality_impact?: Maybe<Scalars['String']>;
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity: Scalars['String'];
  symptoms?: Maybe<Scalars['String']>;
  weather_conditions?: Maybe<Scalars['String']>;
};


/** columns and relationships of "crop_infestation" */
export type Crop_InfestationCrop_Infestation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


/** columns and relationships of "crop_infestation" */
export type Crop_InfestationCrop_Infestation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};

/** aggregated selection of "crop_infestation" */
export type Crop_Infestation_Aggregate = {
  __typename?: 'crop_infestation_aggregate';
  aggregate?: Maybe<Crop_Infestation_Aggregate_Fields>;
  nodes: Array<Crop_Infestation>;
};

/** aggregate fields of "crop_infestation" */
export type Crop_Infestation_Aggregate_Fields = {
  __typename?: 'crop_infestation_aggregate_fields';
  avg?: Maybe<Crop_Infestation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Infestation_Max_Fields>;
  min?: Maybe<Crop_Infestation_Min_Fields>;
  stddev?: Maybe<Crop_Infestation_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Infestation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Infestation_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Infestation_Sum_Fields>;
  var_pop?: Maybe<Crop_Infestation_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Infestation_Var_Samp_Fields>;
  variance?: Maybe<Crop_Infestation_Variance_Fields>;
};


/** aggregate fields of "crop_infestation" */
export type Crop_Infestation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment = {
  __typename?: 'crop_infestation_attachment';
  attachment_id: Scalars['Int'];
  /** An object relationship */
  crop_infestation: Crop_Infestation;
  crop_infestation_id: Scalars['Int'];
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  order: Scalars['smallint'];
  /** An object relationship */
  photo: Media;
};

/** aggregated selection of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate = {
  __typename?: 'crop_infestation_attachment_aggregate';
  aggregate?: Maybe<Crop_Infestation_Attachment_Aggregate_Fields>;
  nodes: Array<Crop_Infestation_Attachment>;
};

/** aggregate fields of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate_Fields = {
  __typename?: 'crop_infestation_attachment_aggregate_fields';
  avg?: Maybe<Crop_Infestation_Attachment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Infestation_Attachment_Max_Fields>;
  min?: Maybe<Crop_Infestation_Attachment_Min_Fields>;
  stddev?: Maybe<Crop_Infestation_Attachment_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Infestation_Attachment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Infestation_Attachment_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Infestation_Attachment_Sum_Fields>;
  var_pop?: Maybe<Crop_Infestation_Attachment_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Infestation_Attachment_Var_Samp_Fields>;
  variance?: Maybe<Crop_Infestation_Attachment_Variance_Fields>;
};


/** aggregate fields of "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Infestation_Attachment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Infestation_Attachment_Max_Order_By>;
  min?: InputMaybe<Crop_Infestation_Attachment_Min_Order_By>;
  stddev?: InputMaybe<Crop_Infestation_Attachment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Infestation_Attachment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Infestation_Attachment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Infestation_Attachment_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Infestation_Attachment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Infestation_Attachment_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Infestation_Attachment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Arr_Rel_Insert_Input = {
  data: Array<Crop_Infestation_Attachment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Infestation_Attachment_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Infestation_Attachment_Avg_Fields = {
  __typename?: 'crop_infestation_attachment_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_infestation_attachment". All fields are combined with a logical 'AND'. */
export type Crop_Infestation_Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Infestation_Attachment_Bool_Exp>>;
  _not?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Infestation_Attachment_Bool_Exp>>;
  attachment_id?: InputMaybe<Int_Comparison_Exp>;
  crop_infestation?: InputMaybe<Crop_Infestation_Bool_Exp>;
  crop_infestation_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Smallint_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
};

/** unique or primary key constraints on table "crop_infestation_attachment" */
export enum Crop_Infestation_Attachment_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropInfestationAttachmentPkey = 'crop_infestation_attachment_pkey'
}

/** input type for incrementing numeric columns in table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation?: InputMaybe<Crop_Infestation_Obj_Rel_Insert_Input>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Crop_Infestation_Attachment_Max_Fields = {
  __typename?: 'crop_infestation_attachment_max_fields';
  attachment_id?: Maybe<Scalars['Int']>;
  crop_infestation_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by max() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Infestation_Attachment_Min_Fields = {
  __typename?: 'crop_infestation_attachment_min_fields';
  attachment_id?: Maybe<Scalars['Int']>;
  crop_infestation_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by min() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Mutation_Response = {
  __typename?: 'crop_infestation_attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Infestation_Attachment>;
};

/** on_conflict condition type for table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_On_Conflict = {
  constraint: Crop_Infestation_Attachment_Constraint;
  update_columns?: Array<Crop_Infestation_Attachment_Update_Column>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_infestation_attachment". */
export type Crop_Infestation_Attachment_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation?: InputMaybe<Crop_Infestation_Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
};

/** primary key columns input for table: crop_infestation_attachment */
export type Crop_Infestation_Attachment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_infestation_attachment" */
export enum Crop_Infestation_Attachment_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  CropInfestationId = 'crop_infestation_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Set_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type Crop_Infestation_Attachment_Stddev_Fields = {
  __typename?: 'crop_infestation_attachment_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Infestation_Attachment_Stddev_Pop_Fields = {
  __typename?: 'crop_infestation_attachment_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Infestation_Attachment_Stddev_Samp_Fields = {
  __typename?: 'crop_infestation_attachment_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Infestation_Attachment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Infestation_Attachment_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['smallint']>;
};

/** aggregate sum on columns */
export type Crop_Infestation_Attachment_Sum_Fields = {
  __typename?: 'crop_infestation_attachment_sum_fields';
  attachment_id?: Maybe<Scalars['Int']>;
  crop_infestation_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "crop_infestation_attachment" */
export enum Crop_Infestation_Attachment_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  CropInfestationId = 'crop_infestation_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Order = 'order'
}

export type Crop_Infestation_Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Infestation_Attachment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Infestation_Attachment_Set_Input>;
  where: Crop_Infestation_Attachment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Infestation_Attachment_Var_Pop_Fields = {
  __typename?: 'crop_infestation_attachment_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Infestation_Attachment_Var_Samp_Fields = {
  __typename?: 'crop_infestation_attachment_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Infestation_Attachment_Variance_Fields = {
  __typename?: 'crop_infestation_attachment_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  crop_infestation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_infestation_attachment" */
export type Crop_Infestation_Attachment_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  crop_infestation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Crop_Infestation_Avg_Fields = {
  __typename?: 'crop_infestation_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_infestation". All fields are combined with a logical 'AND'. */
export type Crop_Infestation_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Infestation_Bool_Exp>>;
  _not?: InputMaybe<Crop_Infestation_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Infestation_Bool_Exp>>;
  affects?: InputMaybe<String_Comparison_Exp>;
  biological_measures?: InputMaybe<String_Comparison_Exp>;
  chemical_measures?: InputMaybe<String_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_infestation_attachments?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
  cultural_measures?: InputMaybe<String_Comparison_Exp>;
  damage_nature?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  infestation?: InputMaybe<Infestation_Bool_Exp>;
  infestation_id?: InputMaybe<Int_Comparison_Exp>;
  infestation_period?: InputMaybe<String_Comparison_Exp>;
  infestation_stage?: InputMaybe<String_Comparison_Exp>;
  mechanical_measures?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  quality_impact?: InputMaybe<String_Comparison_Exp>;
  quantity_impact?: InputMaybe<String_Comparison_Exp>;
  scientific_name?: InputMaybe<String_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  symptoms?: InputMaybe<String_Comparison_Exp>;
  weather_conditions?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_infestation" */
export enum Crop_Infestation_Constraint {
  /** unique or primary key constraint on columns "crop_id", "infestation_id" */
  CropInfestationInfestationIdCropId_71b16159Uniq = 'crop_infestation_infestation_id_crop_id_71b16159_uniq',
  /** unique or primary key constraint on columns "id" */
  CropInfestationPkey = 'crop_infestation_pkey'
}

/** input type for incrementing numeric columns in table "crop_infestation" */
export type Crop_Infestation_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_infestation" */
export type Crop_Infestation_Insert_Input = {
  affects?: InputMaybe<Scalars['String']>;
  biological_measures?: InputMaybe<Scalars['String']>;
  chemical_measures?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_infestation_attachments?: InputMaybe<Crop_Infestation_Attachment_Arr_Rel_Insert_Input>;
  cultural_measures?: InputMaybe<Scalars['String']>;
  damage_nature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  infestation?: InputMaybe<Infestation_Obj_Rel_Insert_Input>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  infestation_period?: InputMaybe<Scalars['String']>;
  infestation_stage?: InputMaybe<Scalars['String']>;
  mechanical_measures?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  quality_impact?: InputMaybe<Scalars['String']>;
  quantity_impact?: InputMaybe<Scalars['String']>;
  scientific_name?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  symptoms?: InputMaybe<Scalars['String']>;
  weather_conditions?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Crop_Infestation_Max_Fields = {
  __typename?: 'crop_infestation_max_fields';
  affects?: Maybe<Scalars['String']>;
  biological_measures?: Maybe<Scalars['String']>;
  chemical_measures?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  cultural_measures?: Maybe<Scalars['String']>;
  damage_nature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  infestation_id?: Maybe<Scalars['Int']>;
  infestation_period?: Maybe<Scalars['String']>;
  infestation_stage?: Maybe<Scalars['String']>;
  mechanical_measures?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  quality_impact?: Maybe<Scalars['String']>;
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  symptoms?: Maybe<Scalars['String']>;
  weather_conditions?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Crop_Infestation_Min_Fields = {
  __typename?: 'crop_infestation_min_fields';
  affects?: Maybe<Scalars['String']>;
  biological_measures?: Maybe<Scalars['String']>;
  chemical_measures?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  cultural_measures?: Maybe<Scalars['String']>;
  damage_nature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  infestation_id?: Maybe<Scalars['Int']>;
  infestation_period?: Maybe<Scalars['String']>;
  infestation_stage?: Maybe<Scalars['String']>;
  mechanical_measures?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  quality_impact?: Maybe<Scalars['String']>;
  quantity_impact?: Maybe<Scalars['String']>;
  scientific_name?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  symptoms?: Maybe<Scalars['String']>;
  weather_conditions?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "crop_infestation" */
export type Crop_Infestation_Mutation_Response = {
  __typename?: 'crop_infestation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Infestation>;
};

/** input type for inserting object relation for remote table "crop_infestation" */
export type Crop_Infestation_Obj_Rel_Insert_Input = {
  data: Crop_Infestation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Infestation_On_Conflict>;
};

/** on_conflict condition type for table "crop_infestation" */
export type Crop_Infestation_On_Conflict = {
  constraint: Crop_Infestation_Constraint;
  update_columns?: Array<Crop_Infestation_Update_Column>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_infestation". */
export type Crop_Infestation_Order_By = {
  affects?: InputMaybe<Order_By>;
  biological_measures?: InputMaybe<Order_By>;
  chemical_measures?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_infestation_attachments_aggregate?: InputMaybe<Crop_Infestation_Attachment_Aggregate_Order_By>;
  cultural_measures?: InputMaybe<Order_By>;
  damage_nature?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  infestation?: InputMaybe<Infestation_Order_By>;
  infestation_id?: InputMaybe<Order_By>;
  infestation_period?: InputMaybe<Order_By>;
  infestation_stage?: InputMaybe<Order_By>;
  mechanical_measures?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  quality_impact?: InputMaybe<Order_By>;
  quantity_impact?: InputMaybe<Order_By>;
  scientific_name?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  symptoms?: InputMaybe<Order_By>;
  weather_conditions?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_infestation */
export type Crop_Infestation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_infestation" */
export enum Crop_Infestation_Select_Column {
  /** column name */
  Affects = 'affects',
  /** column name */
  BiologicalMeasures = 'biological_measures',
  /** column name */
  ChemicalMeasures = 'chemical_measures',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CulturalMeasures = 'cultural_measures',
  /** column name */
  DamageNature = 'damage_nature',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InfestationId = 'infestation_id',
  /** column name */
  InfestationPeriod = 'infestation_period',
  /** column name */
  InfestationStage = 'infestation_stage',
  /** column name */
  MechanicalMeasures = 'mechanical_measures',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  QualityImpact = 'quality_impact',
  /** column name */
  QuantityImpact = 'quantity_impact',
  /** column name */
  ScientificName = 'scientific_name',
  /** column name */
  Severity = 'severity',
  /** column name */
  Symptoms = 'symptoms',
  /** column name */
  WeatherConditions = 'weather_conditions'
}

/** input type for updating data in table "crop_infestation" */
export type Crop_Infestation_Set_Input = {
  affects?: InputMaybe<Scalars['String']>;
  biological_measures?: InputMaybe<Scalars['String']>;
  chemical_measures?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  cultural_measures?: InputMaybe<Scalars['String']>;
  damage_nature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  infestation_period?: InputMaybe<Scalars['String']>;
  infestation_stage?: InputMaybe<Scalars['String']>;
  mechanical_measures?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  quality_impact?: InputMaybe<Scalars['String']>;
  quantity_impact?: InputMaybe<Scalars['String']>;
  scientific_name?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  symptoms?: InputMaybe<Scalars['String']>;
  weather_conditions?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Crop_Infestation_Stddev_Fields = {
  __typename?: 'crop_infestation_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Infestation_Stddev_Pop_Fields = {
  __typename?: 'crop_infestation_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Infestation_Stddev_Samp_Fields = {
  __typename?: 'crop_infestation_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_infestation" */
export type Crop_Infestation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Infestation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Infestation_Stream_Cursor_Value_Input = {
  affects?: InputMaybe<Scalars['String']>;
  biological_measures?: InputMaybe<Scalars['String']>;
  chemical_measures?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  cultural_measures?: InputMaybe<Scalars['String']>;
  damage_nature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  infestation_id?: InputMaybe<Scalars['Int']>;
  infestation_period?: InputMaybe<Scalars['String']>;
  infestation_stage?: InputMaybe<Scalars['String']>;
  mechanical_measures?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  quality_impact?: InputMaybe<Scalars['String']>;
  quantity_impact?: InputMaybe<Scalars['String']>;
  scientific_name?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  symptoms?: InputMaybe<Scalars['String']>;
  weather_conditions?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Crop_Infestation_Sum_Fields = {
  __typename?: 'crop_infestation_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  infestation_id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_infestation" */
export enum Crop_Infestation_Update_Column {
  /** column name */
  Affects = 'affects',
  /** column name */
  BiologicalMeasures = 'biological_measures',
  /** column name */
  ChemicalMeasures = 'chemical_measures',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CulturalMeasures = 'cultural_measures',
  /** column name */
  DamageNature = 'damage_nature',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InfestationId = 'infestation_id',
  /** column name */
  InfestationPeriod = 'infestation_period',
  /** column name */
  InfestationStage = 'infestation_stage',
  /** column name */
  MechanicalMeasures = 'mechanical_measures',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  QualityImpact = 'quality_impact',
  /** column name */
  QuantityImpact = 'quantity_impact',
  /** column name */
  ScientificName = 'scientific_name',
  /** column name */
  Severity = 'severity',
  /** column name */
  Symptoms = 'symptoms',
  /** column name */
  WeatherConditions = 'weather_conditions'
}

export type Crop_Infestation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Infestation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Infestation_Set_Input>;
  where: Crop_Infestation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Infestation_Var_Pop_Fields = {
  __typename?: 'crop_infestation_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Infestation_Var_Samp_Fields = {
  __typename?: 'crop_infestation_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Infestation_Variance_Fields = {
  __typename?: 'crop_infestation_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  infestation_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "crop" */
export type Crop_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  commodities?: InputMaybe<Commodity_Arr_Rel_Insert_Input>;
  crop_group?: InputMaybe<Crop_Group_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hex_color_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_crops?: InputMaybe<Organisation_Crop_Arr_Rel_Insert_Input>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  varieties?: InputMaybe<Crop_Variety_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Crop_Max_Fields = {
  __typename?: 'crop_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hex_color_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "crop_milestone" */
export type Crop_Milestone = {
  __typename?: 'crop_milestone';
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  day_tracking: Scalars['Boolean'];
  id: Scalars['Int'];
  ignore_crop_year: Scalars['Boolean'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  /** An object relationship */
  milestone: Milestone;
  milestone_id: Scalars['Int'];
  order: Scalars['Int'];
  short_name: Scalars['String'];
};

/** aggregated selection of "crop_milestone" */
export type Crop_Milestone_Aggregate = {
  __typename?: 'crop_milestone_aggregate';
  aggregate?: Maybe<Crop_Milestone_Aggregate_Fields>;
  nodes: Array<Crop_Milestone>;
};

/** aggregate fields of "crop_milestone" */
export type Crop_Milestone_Aggregate_Fields = {
  __typename?: 'crop_milestone_aggregate_fields';
  avg?: Maybe<Crop_Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Milestone_Max_Fields>;
  min?: Maybe<Crop_Milestone_Min_Fields>;
  stddev?: Maybe<Crop_Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Milestone_Sum_Fields>;
  var_pop?: Maybe<Crop_Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Milestone_Var_Samp_Fields>;
  variance?: Maybe<Crop_Milestone_Variance_Fields>;
};


/** aggregate fields of "crop_milestone" */
export type Crop_Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Milestone_Avg_Fields = {
  __typename?: 'crop_milestone_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_milestone". All fields are combined with a logical 'AND'. */
export type Crop_Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Milestone_Bool_Exp>>;
  _not?: InputMaybe<Crop_Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Milestone_Bool_Exp>>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  day_tracking?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ignore_crop_year?: InputMaybe<Boolean_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  milestone?: InputMaybe<Milestone_Bool_Exp>;
  milestone_id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_milestone" */
export enum Crop_Milestone_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropMilestonePkey = 'crop_milestone_pkey'
}

/** input type for incrementing numeric columns in table "crop_milestone" */
export type Crop_Milestone_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_milestone" */
export type Crop_Milestone_Insert_Input = {
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  day_tracking?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ignore_crop_year?: InputMaybe<Scalars['Boolean']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  milestone?: InputMaybe<Milestone_Obj_Rel_Insert_Input>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Crop_Milestone_Max_Fields = {
  __typename?: 'crop_milestone_max_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  milestone_id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  short_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Crop_Milestone_Min_Fields = {
  __typename?: 'crop_milestone_min_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  milestone_id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  short_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "crop_milestone" */
export type Crop_Milestone_Mutation_Response = {
  __typename?: 'crop_milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Milestone>;
};

/** input type for inserting object relation for remote table "crop_milestone" */
export type Crop_Milestone_Obj_Rel_Insert_Input = {
  data: Crop_Milestone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Milestone_On_Conflict>;
};

/** on_conflict condition type for table "crop_milestone" */
export type Crop_Milestone_On_Conflict = {
  constraint: Crop_Milestone_Constraint;
  update_columns?: Array<Crop_Milestone_Update_Column>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_milestone". */
export type Crop_Milestone_Order_By = {
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  day_tracking?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignore_crop_year?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  milestone?: InputMaybe<Milestone_Order_By>;
  milestone_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_milestone */
export type Crop_Milestone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_milestone" */
export enum Crop_Milestone_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DayTracking = 'day_tracking',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreCropYear = 'ignore_crop_year',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MilestoneId = 'milestone_id',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'short_name'
}

/** input type for updating data in table "crop_milestone" */
export type Crop_Milestone_Set_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  day_tracking?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ignore_crop_year?: InputMaybe<Scalars['Boolean']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Crop_Milestone_Stddev_Fields = {
  __typename?: 'crop_milestone_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Milestone_Stddev_Pop_Fields = {
  __typename?: 'crop_milestone_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Milestone_Stddev_Samp_Fields = {
  __typename?: 'crop_milestone_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_milestone" */
export type Crop_Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Milestone_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  day_tracking?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  ignore_crop_year?: InputMaybe<Scalars['Boolean']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  milestone_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  short_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Crop_Milestone_Sum_Fields = {
  __typename?: 'crop_milestone_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  milestone_id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_milestone" */
export enum Crop_Milestone_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  DayTracking = 'day_tracking',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreCropYear = 'ignore_crop_year',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MilestoneId = 'milestone_id',
  /** column name */
  Order = 'order',
  /** column name */
  ShortName = 'short_name'
}

export type Crop_Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Milestone_Set_Input>;
  where: Crop_Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Milestone_Var_Pop_Fields = {
  __typename?: 'crop_milestone_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Milestone_Var_Samp_Fields = {
  __typename?: 'crop_milestone_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Milestone_Variance_Fields = {
  __typename?: 'crop_milestone_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  milestone_id?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Crop_Min_Fields = {
  __typename?: 'crop_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  hex_color_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "crop" */
export type Crop_Mutation_Response = {
  __typename?: 'crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop>;
};

/** input type for inserting object relation for remote table "crop" */
export type Crop_Obj_Rel_Insert_Input = {
  data: Crop_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_On_Conflict>;
};

/** on_conflict condition type for table "crop" */
export type Crop_On_Conflict = {
  constraint: Crop_Constraint;
  update_columns?: Array<Crop_Update_Column>;
  where?: InputMaybe<Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "crop". */
export type Crop_Order_By = {
  codename?: InputMaybe<Order_By>;
  commodities_aggregate?: InputMaybe<Commodity_Aggregate_Order_By>;
  crop_group?: InputMaybe<Crop_Group_Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  hex_color_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_crops_aggregate?: InputMaybe<Organisation_Crop_Aggregate_Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  varieties_aggregate?: InputMaybe<Crop_Variety_Aggregate_Order_By>;
};

/** primary key columns input for table: crop */
export type Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "crop_rootstock" */
export type Crop_Rootstock = {
  __typename?: 'crop_rootstock';
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  rootstock: Rootstock;
  rootstock_id: Scalars['Int'];
};

/** aggregated selection of "crop_rootstock" */
export type Crop_Rootstock_Aggregate = {
  __typename?: 'crop_rootstock_aggregate';
  aggregate?: Maybe<Crop_Rootstock_Aggregate_Fields>;
  nodes: Array<Crop_Rootstock>;
};

/** aggregate fields of "crop_rootstock" */
export type Crop_Rootstock_Aggregate_Fields = {
  __typename?: 'crop_rootstock_aggregate_fields';
  avg?: Maybe<Crop_Rootstock_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Rootstock_Max_Fields>;
  min?: Maybe<Crop_Rootstock_Min_Fields>;
  stddev?: Maybe<Crop_Rootstock_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Rootstock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Rootstock_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Rootstock_Sum_Fields>;
  var_pop?: Maybe<Crop_Rootstock_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Rootstock_Var_Samp_Fields>;
  variance?: Maybe<Crop_Rootstock_Variance_Fields>;
};


/** aggregate fields of "crop_rootstock" */
export type Crop_Rootstock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Rootstock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Rootstock_Avg_Fields = {
  __typename?: 'crop_rootstock_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_rootstock". All fields are combined with a logical 'AND'. */
export type Crop_Rootstock_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Rootstock_Bool_Exp>>;
  _not?: InputMaybe<Crop_Rootstock_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Rootstock_Bool_Exp>>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  rootstock?: InputMaybe<Rootstock_Bool_Exp>;
  rootstock_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_rootstock" */
export enum Crop_Rootstock_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropRootstockPkey = 'crop_rootstock_pkey',
  /** unique or primary key constraint on columns "crop_id", "rootstock_id" */
  CropRootstockRootstockIdCropIdD9203a2bUniq = 'crop_rootstock_rootstock_id_crop_id_d9203a2b_uniq'
}

/** input type for incrementing numeric columns in table "crop_rootstock" */
export type Crop_Rootstock_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_rootstock" */
export type Crop_Rootstock_Insert_Input = {
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  rootstock?: InputMaybe<Rootstock_Obj_Rel_Insert_Input>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Crop_Rootstock_Max_Fields = {
  __typename?: 'crop_rootstock_max_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rootstock_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Crop_Rootstock_Min_Fields = {
  __typename?: 'crop_rootstock_min_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rootstock_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "crop_rootstock" */
export type Crop_Rootstock_Mutation_Response = {
  __typename?: 'crop_rootstock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Rootstock>;
};

/** input type for inserting object relation for remote table "crop_rootstock" */
export type Crop_Rootstock_Obj_Rel_Insert_Input = {
  data: Crop_Rootstock_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Rootstock_On_Conflict>;
};

/** on_conflict condition type for table "crop_rootstock" */
export type Crop_Rootstock_On_Conflict = {
  constraint: Crop_Rootstock_Constraint;
  update_columns?: Array<Crop_Rootstock_Update_Column>;
  where?: InputMaybe<Crop_Rootstock_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_rootstock". */
export type Crop_Rootstock_Order_By = {
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  rootstock?: InputMaybe<Rootstock_Order_By>;
  rootstock_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_rootstock */
export type Crop_Rootstock_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_rootstock" */
export enum Crop_Rootstock_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RootstockId = 'rootstock_id'
}

/** input type for updating data in table "crop_rootstock" */
export type Crop_Rootstock_Set_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Rootstock_Stddev_Fields = {
  __typename?: 'crop_rootstock_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Rootstock_Stddev_Pop_Fields = {
  __typename?: 'crop_rootstock_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Rootstock_Stddev_Samp_Fields = {
  __typename?: 'crop_rootstock_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_rootstock" */
export type Crop_Rootstock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Rootstock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Rootstock_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  rootstock_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Rootstock_Sum_Fields = {
  __typename?: 'crop_rootstock_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rootstock_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_rootstock" */
export enum Crop_Rootstock_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  RootstockId = 'rootstock_id'
}

export type Crop_Rootstock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Rootstock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Rootstock_Set_Input>;
  where: Crop_Rootstock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Rootstock_Var_Pop_Fields = {
  __typename?: 'crop_rootstock_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Rootstock_Var_Samp_Fields = {
  __typename?: 'crop_rootstock_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Rootstock_Variance_Fields = {
  __typename?: 'crop_rootstock_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rootstock_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "crop" */
export enum Crop_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HexColorCode = 'hex_color_code',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxBaseTempDegC = 'max_base_temp_deg_c',
  /** column name */
  MaxPotentialYieldKg = 'max_potential_yield_kg',
  /** column name */
  MaxProductionDays = 'max_production_days',
  /** column name */
  MaxProductionGdd = 'max_production_gdd',
  /** column name */
  MinBaseTempDegC = 'min_base_temp_deg_c',
  /** column name */
  MinPotentialYieldKg = 'min_potential_yield_kg',
  /** column name */
  MinProductionDays = 'min_production_days',
  /** column name */
  MinProductionGdd = 'min_production_gdd',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "crop" */
export type Crop_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hex_color_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Stddev_Fields = {
  __typename?: 'crop_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Stddev_Pop_Fields = {
  __typename?: 'crop_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Stddev_Samp_Fields = {
  __typename?: 'crop_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop" */
export type Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['Int']>;
  hex_color_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Sum_Fields = {
  __typename?: 'crop_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop" */
export enum Crop_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HexColorCode = 'hex_color_code',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxBaseTempDegC = 'max_base_temp_deg_c',
  /** column name */
  MaxPotentialYieldKg = 'max_potential_yield_kg',
  /** column name */
  MaxProductionDays = 'max_production_days',
  /** column name */
  MaxProductionGdd = 'max_production_gdd',
  /** column name */
  MinBaseTempDegC = 'min_base_temp_deg_c',
  /** column name */
  MinPotentialYieldKg = 'min_potential_yield_kg',
  /** column name */
  MinProductionDays = 'min_production_days',
  /** column name */
  MinProductionGdd = 'min_production_gdd',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Crop_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Set_Input>;
  where: Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Var_Pop_Fields = {
  __typename?: 'crop_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Var_Samp_Fields = {
  __typename?: 'crop_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Variance_Fields = {
  __typename?: 'crop_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "crop_variety" */
export type Crop_Variety = {
  __typename?: 'crop_variety';
  /** An array relationship */
  breeders: Array<Crop_Variety_Breeder>;
  /** An aggregate relationship */
  breeders_aggregate: Crop_Variety_Breeder_Aggregate;
  codename: Scalars['String'];
  /** An array relationship */
  commodity_varieties: Array<Commodity_Variety>;
  /** An aggregate relationship */
  commodity_varieties_aggregate: Commodity_Variety_Aggregate;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  external_reference_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  plot_crops: Array<Plot_Crop>;
  /** An aggregate relationship */
  plot_crops_aggregate: Plot_Crop_Aggregate;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyBreedersArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyBreeders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyCommodity_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyCommodity_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyPlot_CropsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "crop_variety" */
export type Crop_VarietyPlot_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};

/** aggregated selection of "crop_variety" */
export type Crop_Variety_Aggregate = {
  __typename?: 'crop_variety_aggregate';
  aggregate?: Maybe<Crop_Variety_Aggregate_Fields>;
  nodes: Array<Crop_Variety>;
};

/** aggregate fields of "crop_variety" */
export type Crop_Variety_Aggregate_Fields = {
  __typename?: 'crop_variety_aggregate_fields';
  avg?: Maybe<Crop_Variety_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Variety_Max_Fields>;
  min?: Maybe<Crop_Variety_Min_Fields>;
  stddev?: Maybe<Crop_Variety_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Variety_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Variety_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Variety_Sum_Fields>;
  var_pop?: Maybe<Crop_Variety_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Variety_Var_Samp_Fields>;
  variance?: Maybe<Crop_Variety_Variance_Fields>;
};


/** aggregate fields of "crop_variety" */
export type Crop_Variety_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_variety" */
export type Crop_Variety_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Variety_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Variety_Max_Order_By>;
  min?: InputMaybe<Crop_Variety_Min_Order_By>;
  stddev?: InputMaybe<Crop_Variety_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Variety_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Variety_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Variety_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Variety_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Variety_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Variety_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_variety" */
export type Crop_Variety_Arr_Rel_Insert_Input = {
  data: Array<Crop_Variety_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Variety_Avg_Fields = {
  __typename?: 'crop_variety_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_variety" */
export type Crop_Variety_Avg_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_variety". All fields are combined with a logical 'AND'. */
export type Crop_Variety_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  _not?: InputMaybe<Crop_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  breeders?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodity_varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  max_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  max_production_days?: InputMaybe<Int_Comparison_Exp>;
  max_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  min_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  min_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  min_production_days?: InputMaybe<Int_Comparison_Exp>;
  min_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "crop_variety". All fields are combined with a logical 'AND'. */
export type Crop_Variety_Bool_Exp_Remote_Rel_External_Entitycrop_Variety = {
  _and?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  _not?: InputMaybe<Crop_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Variety_Bool_Exp>>;
  breeders?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_External_Entitycrop_Variety>;
  commodity_varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  max_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  max_production_days?: InputMaybe<Int_Comparison_Exp>;
  max_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  min_base_temp_deg_c?: InputMaybe<Float8_Comparison_Exp>;
  min_potential_yield_kg?: InputMaybe<Float8_Comparison_Exp>;
  min_production_days?: InputMaybe<Int_Comparison_Exp>;
  min_production_gdd?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crops?: InputMaybe<Plot_Crop_Bool_Exp>;
};

/** columns and relationships of "crop_variety_breeder" */
export type Crop_Variety_Breeder = {
  __typename?: 'crop_variety_breeder';
  /** An object relationship */
  breeder: Breeder;
  breeder_id: Scalars['Int'];
  /** An object relationship */
  crop_variety: Crop_Variety;
  crop_variety_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
};

/** aggregated selection of "crop_variety_breeder" */
export type Crop_Variety_Breeder_Aggregate = {
  __typename?: 'crop_variety_breeder_aggregate';
  aggregate?: Maybe<Crop_Variety_Breeder_Aggregate_Fields>;
  nodes: Array<Crop_Variety_Breeder>;
};

/** aggregate fields of "crop_variety_breeder" */
export type Crop_Variety_Breeder_Aggregate_Fields = {
  __typename?: 'crop_variety_breeder_aggregate_fields';
  avg?: Maybe<Crop_Variety_Breeder_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Variety_Breeder_Max_Fields>;
  min?: Maybe<Crop_Variety_Breeder_Min_Fields>;
  stddev?: Maybe<Crop_Variety_Breeder_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Variety_Breeder_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Variety_Breeder_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Variety_Breeder_Sum_Fields>;
  var_pop?: Maybe<Crop_Variety_Breeder_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Variety_Breeder_Var_Samp_Fields>;
  variance?: Maybe<Crop_Variety_Breeder_Variance_Fields>;
};


/** aggregate fields of "crop_variety_breeder" */
export type Crop_Variety_Breeder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Aggregate_Order_By = {
  avg?: InputMaybe<Crop_Variety_Breeder_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Crop_Variety_Breeder_Max_Order_By>;
  min?: InputMaybe<Crop_Variety_Breeder_Min_Order_By>;
  stddev?: InputMaybe<Crop_Variety_Breeder_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Crop_Variety_Breeder_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Crop_Variety_Breeder_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Crop_Variety_Breeder_Sum_Order_By>;
  var_pop?: InputMaybe<Crop_Variety_Breeder_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Crop_Variety_Breeder_Var_Samp_Order_By>;
  variance?: InputMaybe<Crop_Variety_Breeder_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Arr_Rel_Insert_Input = {
  data: Array<Crop_Variety_Breeder_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Variety_Breeder_On_Conflict>;
};

/** aggregate avg on columns */
export type Crop_Variety_Breeder_Avg_Fields = {
  __typename?: 'crop_variety_breeder_avg_fields';
  breeder_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Avg_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "crop_variety_breeder". All fields are combined with a logical 'AND'. */
export type Crop_Variety_Breeder_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Variety_Breeder_Bool_Exp>>;
  _not?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Variety_Breeder_Bool_Exp>>;
  breeder?: InputMaybe<Breeder_Bool_Exp>;
  breeder_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_variety_breeder" */
export enum Crop_Variety_Breeder_Constraint {
  /** unique or primary key constraint on columns "breeder_id", "crop_variety_id" */
  CropVarietyBreederCropVarietyIdBreederId_5cd8d006Uniq = 'crop_variety_breeder_crop_variety_id_breeder_id_5cd8d006_uniq',
  /** unique or primary key constraint on columns "id" */
  CropVarietyBreederPkey = 'crop_variety_breeder_pkey'
}

/** input type for incrementing numeric columns in table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Inc_Input = {
  breeder_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Insert_Input = {
  breeder?: InputMaybe<Breeder_Obj_Rel_Insert_Input>;
  breeder_id?: InputMaybe<Scalars['Int']>;
  crop_variety?: InputMaybe<Crop_Variety_Obj_Rel_Insert_Input>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Crop_Variety_Breeder_Max_Fields = {
  __typename?: 'crop_variety_breeder_max_fields';
  breeder_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Max_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Variety_Breeder_Min_Fields = {
  __typename?: 'crop_variety_breeder_min_fields';
  breeder_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Min_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Mutation_Response = {
  __typename?: 'crop_variety_breeder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Variety_Breeder>;
};

/** on_conflict condition type for table "crop_variety_breeder" */
export type Crop_Variety_Breeder_On_Conflict = {
  constraint: Crop_Variety_Breeder_Constraint;
  update_columns?: Array<Crop_Variety_Breeder_Update_Column>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_variety_breeder". */
export type Crop_Variety_Breeder_Order_By = {
  breeder?: InputMaybe<Breeder_Order_By>;
  breeder_id?: InputMaybe<Order_By>;
  crop_variety?: InputMaybe<Crop_Variety_Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_variety_breeder */
export type Crop_Variety_Breeder_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_variety_breeder" */
export enum Crop_Variety_Breeder_Select_Column {
  /** column name */
  BreederId = 'breeder_id',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active'
}

/** input type for updating data in table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Set_Input = {
  breeder_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Crop_Variety_Breeder_Stddev_Fields = {
  __typename?: 'crop_variety_breeder_stddev_fields';
  breeder_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Stddev_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Variety_Breeder_Stddev_Pop_Fields = {
  __typename?: 'crop_variety_breeder_stddev_pop_fields';
  breeder_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Stddev_Pop_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Variety_Breeder_Stddev_Samp_Fields = {
  __typename?: 'crop_variety_breeder_stddev_samp_fields';
  breeder_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Stddev_Samp_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Variety_Breeder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Variety_Breeder_Stream_Cursor_Value_Input = {
  breeder_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Crop_Variety_Breeder_Sum_Fields = {
  __typename?: 'crop_variety_breeder_sum_fields';
  breeder_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Sum_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_variety_breeder" */
export enum Crop_Variety_Breeder_Update_Column {
  /** column name */
  BreederId = 'breeder_id',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active'
}

export type Crop_Variety_Breeder_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Variety_Breeder_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Variety_Breeder_Set_Input>;
  where: Crop_Variety_Breeder_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Variety_Breeder_Var_Pop_Fields = {
  __typename?: 'crop_variety_breeder_var_pop_fields';
  breeder_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Var_Pop_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Variety_Breeder_Var_Samp_Fields = {
  __typename?: 'crop_variety_breeder_var_samp_fields';
  breeder_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Var_Samp_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Variety_Breeder_Variance_Fields = {
  __typename?: 'crop_variety_breeder_variance_fields';
  breeder_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_variety_breeder" */
export type Crop_Variety_Breeder_Variance_Order_By = {
  breeder_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "crop_variety" */
export enum Crop_Variety_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CropVarietyCodenameKey = 'crop_variety_codename_key',
  /** unique or primary key constraint on columns "name", "crop_id" */
  CropVarietyNameCropIdFdc9c1f4Uniq = 'crop_variety_name_crop_id_fdc9c1f4_uniq',
  /** unique or primary key constraint on columns "id" */
  CropVarietyPkey = 'crop_variety_pkey'
}

/** input type for incrementing numeric columns in table "crop_variety" */
export type Crop_Variety_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_variety" */
export type Crop_Variety_Insert_Input = {
  breeders?: InputMaybe<Crop_Variety_Breeder_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  commodity_varieties?: InputMaybe<Commodity_Variety_Arr_Rel_Insert_Input>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  plot_crops?: InputMaybe<Plot_Crop_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Crop_Variety_Max_Fields = {
  __typename?: 'crop_variety_max_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "crop_variety" */
export type Crop_Variety_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Crop_Variety_Min_Fields = {
  __typename?: 'crop_variety_min_fields';
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "crop_variety" */
export type Crop_Variety_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "crop_variety" */
export type Crop_Variety_Mutation_Response = {
  __typename?: 'crop_variety_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Variety>;
};

/** input type for inserting object relation for remote table "crop_variety" */
export type Crop_Variety_Obj_Rel_Insert_Input = {
  data: Crop_Variety_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};

/** on_conflict condition type for table "crop_variety" */
export type Crop_Variety_On_Conflict = {
  constraint: Crop_Variety_Constraint;
  update_columns?: Array<Crop_Variety_Update_Column>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_variety". */
export type Crop_Variety_Order_By = {
  breeders_aggregate?: InputMaybe<Crop_Variety_Breeder_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  commodity_varieties_aggregate?: InputMaybe<Commodity_Variety_Aggregate_Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  plot_crops_aggregate?: InputMaybe<Plot_Crop_Aggregate_Order_By>;
};

/** primary key columns input for table: crop_variety */
export type Crop_Variety_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_variety" */
export enum Crop_Variety_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxBaseTempDegC = 'max_base_temp_deg_c',
  /** column name */
  MaxPotentialYieldKg = 'max_potential_yield_kg',
  /** column name */
  MaxProductionDays = 'max_production_days',
  /** column name */
  MaxProductionGdd = 'max_production_gdd',
  /** column name */
  MinBaseTempDegC = 'min_base_temp_deg_c',
  /** column name */
  MinPotentialYieldKg = 'min_potential_yield_kg',
  /** column name */
  MinProductionDays = 'min_production_days',
  /** column name */
  MinProductionGdd = 'min_production_gdd',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "crop_variety" */
export type Crop_Variety_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Crop_Variety_Stddev_Fields = {
  __typename?: 'crop_variety_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "crop_variety" */
export type Crop_Variety_Stddev_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Crop_Variety_Stddev_Pop_Fields = {
  __typename?: 'crop_variety_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "crop_variety" */
export type Crop_Variety_Stddev_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Crop_Variety_Stddev_Samp_Fields = {
  __typename?: 'crop_variety_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "crop_variety" */
export type Crop_Variety_Stddev_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "crop_variety" */
export type Crop_Variety_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Variety_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Variety_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  max_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  max_production_days?: InputMaybe<Scalars['Int']>;
  max_production_gdd?: InputMaybe<Scalars['float8']>;
  min_base_temp_deg_c?: InputMaybe<Scalars['float8']>;
  min_potential_yield_kg?: InputMaybe<Scalars['float8']>;
  min_production_days?: InputMaybe<Scalars['Int']>;
  min_production_gdd?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Crop_Variety_Sum_Fields = {
  __typename?: 'crop_variety_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_base_temp_deg_c?: Maybe<Scalars['float8']>;
  max_potential_yield_kg?: Maybe<Scalars['float8']>;
  max_production_days?: Maybe<Scalars['Int']>;
  max_production_gdd?: Maybe<Scalars['float8']>;
  min_base_temp_deg_c?: Maybe<Scalars['float8']>;
  min_potential_yield_kg?: Maybe<Scalars['float8']>;
  min_production_days?: Maybe<Scalars['Int']>;
  min_production_gdd?: Maybe<Scalars['float8']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "crop_variety" */
export type Crop_Variety_Sum_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** update columns of table "crop_variety" */
export enum Crop_Variety_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxBaseTempDegC = 'max_base_temp_deg_c',
  /** column name */
  MaxPotentialYieldKg = 'max_potential_yield_kg',
  /** column name */
  MaxProductionDays = 'max_production_days',
  /** column name */
  MaxProductionGdd = 'max_production_gdd',
  /** column name */
  MinBaseTempDegC = 'min_base_temp_deg_c',
  /** column name */
  MinPotentialYieldKg = 'min_potential_yield_kg',
  /** column name */
  MinProductionDays = 'min_production_days',
  /** column name */
  MinProductionGdd = 'min_production_gdd',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Crop_Variety_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Variety_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Variety_Set_Input>;
  where: Crop_Variety_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Variety_Var_Pop_Fields = {
  __typename?: 'crop_variety_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "crop_variety" */
export type Crop_Variety_Var_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Crop_Variety_Var_Samp_Fields = {
  __typename?: 'crop_variety_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "crop_variety" */
export type Crop_Variety_Var_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Crop_Variety_Variance_Fields = {
  __typename?: 'crop_variety_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_base_temp_deg_c?: Maybe<Scalars['Float']>;
  max_potential_yield_kg?: Maybe<Scalars['Float']>;
  max_production_days?: Maybe<Scalars['Float']>;
  max_production_gdd?: Maybe<Scalars['Float']>;
  min_base_temp_deg_c?: Maybe<Scalars['Float']>;
  min_potential_yield_kg?: Maybe<Scalars['Float']>;
  min_production_days?: Maybe<Scalars['Float']>;
  min_production_gdd?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "crop_variety" */
export type Crop_Variety_Variance_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_base_temp_deg_c?: InputMaybe<Order_By>;
  max_potential_yield_kg?: InputMaybe<Order_By>;
  max_production_days?: InputMaybe<Order_By>;
  max_production_gdd?: InputMaybe<Order_By>;
  min_base_temp_deg_c?: InputMaybe<Order_By>;
  min_potential_yield_kg?: InputMaybe<Order_By>;
  min_production_days?: InputMaybe<Order_By>;
  min_production_gdd?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "crop_year" */
export type Crop_Year = {
  __typename?: 'crop_year';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "crop_year" */
export type Crop_Year_Aggregate = {
  __typename?: 'crop_year_aggregate';
  aggregate?: Maybe<Crop_Year_Aggregate_Fields>;
  nodes: Array<Crop_Year>;
};

/** aggregate fields of "crop_year" */
export type Crop_Year_Aggregate_Fields = {
  __typename?: 'crop_year_aggregate_fields';
  avg?: Maybe<Crop_Year_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Crop_Year_Max_Fields>;
  min?: Maybe<Crop_Year_Min_Fields>;
  stddev?: Maybe<Crop_Year_Stddev_Fields>;
  stddev_pop?: Maybe<Crop_Year_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Crop_Year_Stddev_Samp_Fields>;
  sum?: Maybe<Crop_Year_Sum_Fields>;
  var_pop?: Maybe<Crop_Year_Var_Pop_Fields>;
  var_samp?: Maybe<Crop_Year_Var_Samp_Fields>;
  variance?: Maybe<Crop_Year_Variance_Fields>;
};


/** aggregate fields of "crop_year" */
export type Crop_Year_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Crop_Year_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Crop_Year_Avg_Fields = {
  __typename?: 'crop_year_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "crop_year". All fields are combined with a logical 'AND'. */
export type Crop_Year_Bool_Exp = {
  _and?: InputMaybe<Array<Crop_Year_Bool_Exp>>;
  _not?: InputMaybe<Crop_Year_Bool_Exp>;
  _or?: InputMaybe<Array<Crop_Year_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "crop_year" */
export enum Crop_Year_Constraint {
  /** unique or primary key constraint on columns "id" */
  CropYearPkey = 'crop_year_pkey'
}

/** input type for incrementing numeric columns in table "crop_year" */
export type Crop_Year_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "crop_year" */
export type Crop_Year_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Crop_Year_Max_Fields = {
  __typename?: 'crop_year_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Crop_Year_Min_Fields = {
  __typename?: 'crop_year_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "crop_year" */
export type Crop_Year_Mutation_Response = {
  __typename?: 'crop_year_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Crop_Year>;
};

/** input type for inserting object relation for remote table "crop_year" */
export type Crop_Year_Obj_Rel_Insert_Input = {
  data: Crop_Year_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Crop_Year_On_Conflict>;
};

/** on_conflict condition type for table "crop_year" */
export type Crop_Year_On_Conflict = {
  constraint: Crop_Year_Constraint;
  update_columns?: Array<Crop_Year_Update_Column>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};

/** Ordering options when selecting data from "crop_year". */
export type Crop_Year_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: crop_year */
export type Crop_Year_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "crop_year" */
export enum Crop_Year_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "crop_year" */
export type Crop_Year_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Crop_Year_Stddev_Fields = {
  __typename?: 'crop_year_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Crop_Year_Stddev_Pop_Fields = {
  __typename?: 'crop_year_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Crop_Year_Stddev_Samp_Fields = {
  __typename?: 'crop_year_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "crop_year" */
export type Crop_Year_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Crop_Year_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Crop_Year_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Crop_Year_Sum_Fields = {
  __typename?: 'crop_year_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "crop_year" */
export enum Crop_Year_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Crop_Year_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Crop_Year_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Crop_Year_Set_Input>;
  where: Crop_Year_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Crop_Year_Var_Pop_Fields = {
  __typename?: 'crop_year_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Crop_Year_Var_Samp_Fields = {
  __typename?: 'crop_year_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Crop_Year_Variance_Fields = {
  __typename?: 'crop_year_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cultivation_type" */
export type Cultivation_Type = {
  __typename?: 'cultivation_type';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "cultivation_type" */
export type Cultivation_Type_Aggregate = {
  __typename?: 'cultivation_type_aggregate';
  aggregate?: Maybe<Cultivation_Type_Aggregate_Fields>;
  nodes: Array<Cultivation_Type>;
};

/** aggregate fields of "cultivation_type" */
export type Cultivation_Type_Aggregate_Fields = {
  __typename?: 'cultivation_type_aggregate_fields';
  avg?: Maybe<Cultivation_Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Cultivation_Type_Max_Fields>;
  min?: Maybe<Cultivation_Type_Min_Fields>;
  stddev?: Maybe<Cultivation_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Cultivation_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cultivation_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Cultivation_Type_Sum_Fields>;
  var_pop?: Maybe<Cultivation_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Cultivation_Type_Var_Samp_Fields>;
  variance?: Maybe<Cultivation_Type_Variance_Fields>;
};


/** aggregate fields of "cultivation_type" */
export type Cultivation_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cultivation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Cultivation_Type_Avg_Fields = {
  __typename?: 'cultivation_type_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cultivation_type". All fields are combined with a logical 'AND'. */
export type Cultivation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Cultivation_Type_Bool_Exp>>;
  _not?: InputMaybe<Cultivation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Cultivation_Type_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cultivation_type" */
export enum Cultivation_Type_Constraint {
  /** unique or primary key constraint on columns "codename" */
  CultivationTypeCodenameKey = 'cultivation_type_codename_key',
  /** unique or primary key constraint on columns "id" */
  CultivationTypePkey = 'cultivation_type_pkey'
}

/** input type for incrementing numeric columns in table "cultivation_type" */
export type Cultivation_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cultivation_type" */
export type Cultivation_Type_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cultivation_Type_Max_Fields = {
  __typename?: 'cultivation_type_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cultivation_Type_Min_Fields = {
  __typename?: 'cultivation_type_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cultivation_type" */
export type Cultivation_Type_Mutation_Response = {
  __typename?: 'cultivation_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cultivation_Type>;
};

/** input type for inserting object relation for remote table "cultivation_type" */
export type Cultivation_Type_Obj_Rel_Insert_Input = {
  data: Cultivation_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cultivation_Type_On_Conflict>;
};

/** on_conflict condition type for table "cultivation_type" */
export type Cultivation_Type_On_Conflict = {
  constraint: Cultivation_Type_Constraint;
  update_columns?: Array<Cultivation_Type_Update_Column>;
  where?: InputMaybe<Cultivation_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "cultivation_type". */
export type Cultivation_Type_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cultivation_type */
export type Cultivation_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "cultivation_type" */
export enum Cultivation_Type_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "cultivation_type" */
export type Cultivation_Type_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Cultivation_Type_Stddev_Fields = {
  __typename?: 'cultivation_type_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Cultivation_Type_Stddev_Pop_Fields = {
  __typename?: 'cultivation_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Cultivation_Type_Stddev_Samp_Fields = {
  __typename?: 'cultivation_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cultivation_type" */
export type Cultivation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cultivation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cultivation_Type_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Cultivation_Type_Sum_Fields = {
  __typename?: 'cultivation_type_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "cultivation_type" */
export enum Cultivation_Type_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Cultivation_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cultivation_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cultivation_Type_Set_Input>;
  where: Cultivation_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cultivation_Type_Var_Pop_Fields = {
  __typename?: 'cultivation_type_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Cultivation_Type_Var_Samp_Fields = {
  __typename?: 'cultivation_type_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Cultivation_Type_Variance_Fields = {
  __typename?: 'cultivation_type_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "demand" */
export type Demand = {
  __typename?: 'demand';
  /** An array relationship */
  attachments: Array<Demand_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Demand_Attachments_Aggregate;
  /** An object relationship */
  buyer?: Maybe<Setu_Trade_Shared_Entity>;
  buyer_expense: Scalars['float8'];
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  /** An object relationship */
  commodity: Setu_Trade_Shared_Entity;
  commodity_id: Scalars['bigint'];
  /** An object relationship */
  commodity_variety?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  deducted_amount: Scalars['float8'];
  /** An array relationship */
  demand_seller_groups: Array<Demand_Seller_Groups>;
  /** An aggregate relationship */
  demand_seller_groups_aggregate: Demand_Seller_Groups_Aggregate;
  /** An object relationship */
  department?: Maybe<Setu_Trade_Shared_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date_time: Scalars['timestamptz'];
  /** An array relationship */
  enquiries: Array<Demand_Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Demand_Enquiries_Aggregate;
  /** An array relationship */
  expenses: Array<Demand_Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Demand_Expense_Aggregate;
  /** An object relationship */
  facilitator?: Maybe<Setu_Trade_Shared_Entity>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  /** An object relationship */
  jr_officer?: Maybe<Setu_Trade_Shared_Entity>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['float8']>;
  mode: Scalars['String'];
  packaging: Scalars['String'];
  quantity: Scalars['float8'];
  quantity_kg?: Maybe<Scalars['float8']>;
  /** An object relationship */
  quantity_unit?: Maybe<Setu_Trade_Shared_Entity>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate: Scalars['float8'];
  /** An object relationship */
  rate_unit: Setu_Trade_Shared_Entity;
  rate_unit_id: Scalars['bigint'];
  seller_expense: Scalars['float8'];
  /** An object relationship */
  seller_file?: Maybe<Setutrade_Media>;
  seller_file_id?: Maybe<Scalars['bigint']>;
  seller_source_kind: Scalars['String'];
  seller_tnc?: Maybe<Scalars['String']>;
  /** An object relationship */
  sr_officer?: Maybe<Setu_Trade_Shared_Entity>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction: Scalars['float8'];
  start_date_time: Scalars['timestamptz'];
  status: Scalars['String'];
  total_amount: Scalars['float8'];
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  variety_grade?: Maybe<Setu_Trade_Shared_Entity>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "demand" */
export type DemandAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Demand_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Attachments_Order_By>>;
  where?: InputMaybe<Demand_Attachments_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Attachments_Order_By>>;
  where?: InputMaybe<Demand_Attachments_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandDemand_Seller_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Demand_Seller_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Seller_Groups_Order_By>>;
  where?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandDemand_Seller_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Seller_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Seller_Groups_Order_By>>;
  where?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandExpensesArgs = {
  distinct_on?: InputMaybe<Array<Demand_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Expense_Order_By>>;
  where?: InputMaybe<Demand_Expense_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Expense_Order_By>>;
  where?: InputMaybe<Demand_Expense_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "demand" */
export type DemandTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** aggregated selection of "demand" */
export type Demand_Aggregate = {
  __typename?: 'demand_aggregate';
  aggregate?: Maybe<Demand_Aggregate_Fields>;
  nodes: Array<Demand>;
};

/** aggregate fields of "demand" */
export type Demand_Aggregate_Fields = {
  __typename?: 'demand_aggregate_fields';
  avg?: Maybe<Demand_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demand_Max_Fields>;
  min?: Maybe<Demand_Min_Fields>;
  stddev?: Maybe<Demand_Stddev_Fields>;
  stddev_pop?: Maybe<Demand_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demand_Stddev_Samp_Fields>;
  sum?: Maybe<Demand_Sum_Fields>;
  var_pop?: Maybe<Demand_Var_Pop_Fields>;
  var_samp?: Maybe<Demand_Var_Samp_Fields>;
  variance?: Maybe<Demand_Variance_Fields>;
};


/** aggregate fields of "demand" */
export type Demand_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demand_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "demand" */
export type Demand_Aggregate_Order_By = {
  avg?: InputMaybe<Demand_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Demand_Max_Order_By>;
  min?: InputMaybe<Demand_Min_Order_By>;
  stddev?: InputMaybe<Demand_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Demand_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Demand_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Demand_Sum_Order_By>;
  var_pop?: InputMaybe<Demand_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Demand_Var_Samp_Order_By>;
  variance?: InputMaybe<Demand_Variance_Order_By>;
};

/** columns and relationships of "demand_attachments" */
export type Demand_Attachments = {
  __typename?: 'demand_attachments';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  demand: Demand;
  demand_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  send_whatsapp: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "demand_attachments" */
export type Demand_Attachments_Aggregate = {
  __typename?: 'demand_attachments_aggregate';
  aggregate?: Maybe<Demand_Attachments_Aggregate_Fields>;
  nodes: Array<Demand_Attachments>;
};

/** aggregate fields of "demand_attachments" */
export type Demand_Attachments_Aggregate_Fields = {
  __typename?: 'demand_attachments_aggregate_fields';
  avg?: Maybe<Demand_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demand_Attachments_Max_Fields>;
  min?: Maybe<Demand_Attachments_Min_Fields>;
  stddev?: Maybe<Demand_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Demand_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demand_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Demand_Attachments_Sum_Fields>;
  var_pop?: Maybe<Demand_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Demand_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Demand_Attachments_Variance_Fields>;
};


/** aggregate fields of "demand_attachments" */
export type Demand_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demand_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "demand_attachments" */
export type Demand_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Demand_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Demand_Attachments_Max_Order_By>;
  min?: InputMaybe<Demand_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Demand_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Demand_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Demand_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Demand_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Demand_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Demand_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Demand_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Demand_Attachments_Avg_Fields = {
  __typename?: 'demand_attachments_avg_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "demand_attachments" */
export type Demand_Attachments_Avg_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "demand_attachments". All fields are combined with a logical 'AND'. */
export type Demand_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Demand_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Demand_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Demand_Attachments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  demand?: InputMaybe<Demand_Bool_Exp>;
  demand_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  send_whatsapp?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Demand_Attachments_Max_Fields = {
  __typename?: 'demand_attachments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "demand_attachments" */
export type Demand_Attachments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Demand_Attachments_Min_Fields = {
  __typename?: 'demand_attachments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "demand_attachments" */
export type Demand_Attachments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "demand_attachments". */
export type Demand_Attachments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand?: InputMaybe<Demand_Order_By>;
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  send_whatsapp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "demand_attachments" */
export enum Demand_Attachments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DemandId = 'demand_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  SendWhatsapp = 'send_whatsapp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Demand_Attachments_Stddev_Fields = {
  __typename?: 'demand_attachments_stddev_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "demand_attachments" */
export type Demand_Attachments_Stddev_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Demand_Attachments_Stddev_Pop_Fields = {
  __typename?: 'demand_attachments_stddev_pop_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "demand_attachments" */
export type Demand_Attachments_Stddev_Pop_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Demand_Attachments_Stddev_Samp_Fields = {
  __typename?: 'demand_attachments_stddev_samp_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "demand_attachments" */
export type Demand_Attachments_Stddev_Samp_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "demand_attachments" */
export type Demand_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demand_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demand_Attachments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  demand_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  send_whatsapp?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Demand_Attachments_Sum_Fields = {
  __typename?: 'demand_attachments_sum_fields';
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "demand_attachments" */
export type Demand_Attachments_Sum_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Demand_Attachments_Var_Pop_Fields = {
  __typename?: 'demand_attachments_var_pop_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "demand_attachments" */
export type Demand_Attachments_Var_Pop_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Demand_Attachments_Var_Samp_Fields = {
  __typename?: 'demand_attachments_var_samp_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "demand_attachments" */
export type Demand_Attachments_Var_Samp_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Demand_Attachments_Variance_Fields = {
  __typename?: 'demand_attachments_variance_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "demand_attachments" */
export type Demand_Attachments_Variance_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Demand_Avg_Fields = {
  __typename?: 'demand_avg_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_file_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "demand" */
export type Demand_Avg_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "demand". All fields are combined with a logical 'AND'. */
export type Demand_Bool_Exp = {
  _and?: InputMaybe<Array<Demand_Bool_Exp>>;
  _not?: InputMaybe<Demand_Bool_Exp>;
  _or?: InputMaybe<Array<Demand_Bool_Exp>>;
  attachments?: InputMaybe<Demand_Attachments_Bool_Exp>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_expense?: InputMaybe<Float8_Comparison_Exp>;
  buyer_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_tnc?: InputMaybe<String_Comparison_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  deducted_amount?: InputMaybe<Float8_Comparison_Exp>;
  demand_seller_groups?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  end_date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  enquiries?: InputMaybe<Demand_Enquiries_Bool_Exp>;
  expenses?: InputMaybe<Demand_Expense_Bool_Exp>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  facilitator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  jr_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  material_kind?: InputMaybe<String_Comparison_Exp>;
  max_rate?: InputMaybe<Float8_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  packaging?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_kg?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  rate?: InputMaybe<Float8_Comparison_Exp>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  rate_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_expense?: InputMaybe<Float8_Comparison_Exp>;
  seller_file?: InputMaybe<Setutrade_Media_Bool_Exp>;
  seller_file_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_source_kind?: InputMaybe<String_Comparison_Exp>;
  seller_tnc?: InputMaybe<String_Comparison_Exp>;
  sr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  sr_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  standard_deduction?: InputMaybe<Float8_Comparison_Exp>;
  start_date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Float8_Comparison_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  variety_grade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "demand_enquiries" */
export type Demand_Enquiries = {
  __typename?: 'demand_enquiries';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  demand: Demand;
  demand_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  seller?: Maybe<Setu_Trade_Shared_Entity>;
  /** An object relationship */
  seller_external?: Maybe<Unregistered_User>;
  seller_external_id?: Maybe<Scalars['bigint']>;
  seller_id?: Maybe<Scalars['bigint']>;
  status: Scalars['String'];
  /** An array relationship */
  status_logs: Array<Demand_Enquiry_Status_Log>;
  /** An aggregate relationship */
  status_logs_aggregate: Demand_Enquiry_Status_Log_Aggregate;
  /** An array relationship */
  twilio_messages: Array<Demand_Enquiries_Twilio_Message>;
  /** An aggregate relationship */
  twilio_messages_aggregate: Demand_Enquiries_Twilio_Message_Aggregate;
  updated_at: Scalars['timestamptz'];
  whatsapp_status: Scalars['String'];
};


/** columns and relationships of "demand_enquiries" */
export type Demand_EnquiriesStatus_LogsArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
};


/** columns and relationships of "demand_enquiries" */
export type Demand_EnquiriesStatus_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
};


/** columns and relationships of "demand_enquiries" */
export type Demand_EnquiriesTwilio_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
};


/** columns and relationships of "demand_enquiries" */
export type Demand_EnquiriesTwilio_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
};

/** aggregated selection of "demand_enquiries" */
export type Demand_Enquiries_Aggregate = {
  __typename?: 'demand_enquiries_aggregate';
  aggregate?: Maybe<Demand_Enquiries_Aggregate_Fields>;
  nodes: Array<Demand_Enquiries>;
};

/** aggregate fields of "demand_enquiries" */
export type Demand_Enquiries_Aggregate_Fields = {
  __typename?: 'demand_enquiries_aggregate_fields';
  avg?: Maybe<Demand_Enquiries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demand_Enquiries_Max_Fields>;
  min?: Maybe<Demand_Enquiries_Min_Fields>;
  stddev?: Maybe<Demand_Enquiries_Stddev_Fields>;
  stddev_pop?: Maybe<Demand_Enquiries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demand_Enquiries_Stddev_Samp_Fields>;
  sum?: Maybe<Demand_Enquiries_Sum_Fields>;
  var_pop?: Maybe<Demand_Enquiries_Var_Pop_Fields>;
  var_samp?: Maybe<Demand_Enquiries_Var_Samp_Fields>;
  variance?: Maybe<Demand_Enquiries_Variance_Fields>;
};


/** aggregate fields of "demand_enquiries" */
export type Demand_Enquiries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demand_Enquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "demand_enquiries" */
export type Demand_Enquiries_Aggregate_Order_By = {
  avg?: InputMaybe<Demand_Enquiries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Demand_Enquiries_Max_Order_By>;
  min?: InputMaybe<Demand_Enquiries_Min_Order_By>;
  stddev?: InputMaybe<Demand_Enquiries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Demand_Enquiries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Demand_Enquiries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Demand_Enquiries_Sum_Order_By>;
  var_pop?: InputMaybe<Demand_Enquiries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Demand_Enquiries_Var_Samp_Order_By>;
  variance?: InputMaybe<Demand_Enquiries_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Demand_Enquiries_Avg_Fields = {
  __typename?: 'demand_enquiries_avg_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  seller_external_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Avg_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "demand_enquiries". All fields are combined with a logical 'AND'. */
export type Demand_Enquiries_Bool_Exp = {
  _and?: InputMaybe<Array<Demand_Enquiries_Bool_Exp>>;
  _not?: InputMaybe<Demand_Enquiries_Bool_Exp>;
  _or?: InputMaybe<Array<Demand_Enquiries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  demand?: InputMaybe<Demand_Bool_Exp>;
  demand_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  seller_external?: InputMaybe<Unregistered_User_Bool_Exp>;
  seller_external_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_logs?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
  twilio_messages?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whatsapp_status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Demand_Enquiries_Max_Fields = {
  __typename?: 'demand_enquiries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  seller_external_id?: Maybe<Scalars['bigint']>;
  seller_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whatsapp_status?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whatsapp_status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Demand_Enquiries_Min_Fields = {
  __typename?: 'demand_enquiries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  seller_external_id?: Maybe<Scalars['bigint']>;
  seller_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whatsapp_status?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whatsapp_status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "demand_enquiries". */
export type Demand_Enquiries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand?: InputMaybe<Demand_Order_By>;
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  seller_external?: InputMaybe<Unregistered_User_Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_logs_aggregate?: InputMaybe<Demand_Enquiry_Status_Log_Aggregate_Order_By>;
  twilio_messages_aggregate?: InputMaybe<Demand_Enquiries_Twilio_Message_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whatsapp_status?: InputMaybe<Order_By>;
};

/** select columns of table "demand_enquiries" */
export enum Demand_Enquiries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DemandId = 'demand_id',
  /** column name */
  Id = 'id',
  /** column name */
  SellerExternalId = 'seller_external_id',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhatsappStatus = 'whatsapp_status'
}

/** aggregate stddev on columns */
export type Demand_Enquiries_Stddev_Fields = {
  __typename?: 'demand_enquiries_stddev_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  seller_external_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Stddev_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Demand_Enquiries_Stddev_Pop_Fields = {
  __typename?: 'demand_enquiries_stddev_pop_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  seller_external_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Stddev_Pop_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Demand_Enquiries_Stddev_Samp_Fields = {
  __typename?: 'demand_enquiries_stddev_samp_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  seller_external_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Stddev_Samp_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "demand_enquiries" */
export type Demand_Enquiries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demand_Enquiries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demand_Enquiries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  demand_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  seller_external_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whatsapp_status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Demand_Enquiries_Sum_Fields = {
  __typename?: 'demand_enquiries_sum_fields';
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  seller_external_id?: Maybe<Scalars['bigint']>;
  seller_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Sum_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message = {
  __typename?: 'demand_enquiries_twilio_message';
  demandenquiry_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  trade_twiliomessage: Trade_Twiliomessages;
  twiliomessages_id: Scalars['String'];
};

/** aggregated selection of "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Aggregate = {
  __typename?: 'demand_enquiries_twilio_message_aggregate';
  aggregate?: Maybe<Demand_Enquiries_Twilio_Message_Aggregate_Fields>;
  nodes: Array<Demand_Enquiries_Twilio_Message>;
};

/** aggregate fields of "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Aggregate_Fields = {
  __typename?: 'demand_enquiries_twilio_message_aggregate_fields';
  avg?: Maybe<Demand_Enquiries_Twilio_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demand_Enquiries_Twilio_Message_Max_Fields>;
  min?: Maybe<Demand_Enquiries_Twilio_Message_Min_Fields>;
  stddev?: Maybe<Demand_Enquiries_Twilio_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Demand_Enquiries_Twilio_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demand_Enquiries_Twilio_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Demand_Enquiries_Twilio_Message_Sum_Fields>;
  var_pop?: Maybe<Demand_Enquiries_Twilio_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Demand_Enquiries_Twilio_Message_Var_Samp_Fields>;
  variance?: Maybe<Demand_Enquiries_Twilio_Message_Variance_Fields>;
};


/** aggregate fields of "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Aggregate_Order_By = {
  avg?: InputMaybe<Demand_Enquiries_Twilio_Message_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Demand_Enquiries_Twilio_Message_Max_Order_By>;
  min?: InputMaybe<Demand_Enquiries_Twilio_Message_Min_Order_By>;
  stddev?: InputMaybe<Demand_Enquiries_Twilio_Message_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Demand_Enquiries_Twilio_Message_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Demand_Enquiries_Twilio_Message_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Demand_Enquiries_Twilio_Message_Sum_Order_By>;
  var_pop?: InputMaybe<Demand_Enquiries_Twilio_Message_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Demand_Enquiries_Twilio_Message_Var_Samp_Order_By>;
  variance?: InputMaybe<Demand_Enquiries_Twilio_Message_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Demand_Enquiries_Twilio_Message_Avg_Fields = {
  __typename?: 'demand_enquiries_twilio_message_avg_fields';
  demandenquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Avg_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "demand_enquiries_twilio_message". All fields are combined with a logical 'AND'. */
export type Demand_Enquiries_Twilio_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Bool_Exp>>;
  _not?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Bool_Exp>>;
  demandenquiry_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  trade_twiliomessage?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
  twiliomessages_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Demand_Enquiries_Twilio_Message_Max_Fields = {
  __typename?: 'demand_enquiries_twilio_message_max_fields';
  demandenquiry_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  twiliomessages_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Max_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  twiliomessages_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Demand_Enquiries_Twilio_Message_Min_Fields = {
  __typename?: 'demand_enquiries_twilio_message_min_fields';
  demandenquiry_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  twiliomessages_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Min_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  twiliomessages_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "demand_enquiries_twilio_message". */
export type Demand_Enquiries_Twilio_Message_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_twiliomessage?: InputMaybe<Trade_Twiliomessages_Order_By>;
  twiliomessages_id?: InputMaybe<Order_By>;
};

/** select columns of table "demand_enquiries_twilio_message" */
export enum Demand_Enquiries_Twilio_Message_Select_Column {
  /** column name */
  DemandenquiryId = 'demandenquiry_id',
  /** column name */
  Id = 'id',
  /** column name */
  TwiliomessagesId = 'twiliomessages_id'
}

/** aggregate stddev on columns */
export type Demand_Enquiries_Twilio_Message_Stddev_Fields = {
  __typename?: 'demand_enquiries_twilio_message_stddev_fields';
  demandenquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Stddev_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Demand_Enquiries_Twilio_Message_Stddev_Pop_Fields = {
  __typename?: 'demand_enquiries_twilio_message_stddev_pop_fields';
  demandenquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Stddev_Pop_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Demand_Enquiries_Twilio_Message_Stddev_Samp_Fields = {
  __typename?: 'demand_enquiries_twilio_message_stddev_samp_fields';
  demandenquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Stddev_Samp_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demand_Enquiries_Twilio_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demand_Enquiries_Twilio_Message_Stream_Cursor_Value_Input = {
  demandenquiry_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  twiliomessages_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Demand_Enquiries_Twilio_Message_Sum_Fields = {
  __typename?: 'demand_enquiries_twilio_message_sum_fields';
  demandenquiry_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Sum_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Demand_Enquiries_Twilio_Message_Var_Pop_Fields = {
  __typename?: 'demand_enquiries_twilio_message_var_pop_fields';
  demandenquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Var_Pop_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Demand_Enquiries_Twilio_Message_Var_Samp_Fields = {
  __typename?: 'demand_enquiries_twilio_message_var_samp_fields';
  demandenquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Var_Samp_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Demand_Enquiries_Twilio_Message_Variance_Fields = {
  __typename?: 'demand_enquiries_twilio_message_variance_fields';
  demandenquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "demand_enquiries_twilio_message" */
export type Demand_Enquiries_Twilio_Message_Variance_Order_By = {
  demandenquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Demand_Enquiries_Var_Pop_Fields = {
  __typename?: 'demand_enquiries_var_pop_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  seller_external_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Var_Pop_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Demand_Enquiries_Var_Samp_Fields = {
  __typename?: 'demand_enquiries_var_samp_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  seller_external_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Var_Samp_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Demand_Enquiries_Variance_Fields = {
  __typename?: 'demand_enquiries_variance_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  seller_external_id?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "demand_enquiries" */
export type Demand_Enquiries_Variance_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_external_id?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log = {
  __typename?: 'demand_enquiry_status_log';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  demand_enquiry: Demand_Enquiries;
  demand_enquiry_id: Scalars['bigint'];
  from_status?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Aggregate = {
  __typename?: 'demand_enquiry_status_log_aggregate';
  aggregate?: Maybe<Demand_Enquiry_Status_Log_Aggregate_Fields>;
  nodes: Array<Demand_Enquiry_Status_Log>;
};

/** aggregate fields of "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Aggregate_Fields = {
  __typename?: 'demand_enquiry_status_log_aggregate_fields';
  avg?: Maybe<Demand_Enquiry_Status_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demand_Enquiry_Status_Log_Max_Fields>;
  min?: Maybe<Demand_Enquiry_Status_Log_Min_Fields>;
  stddev?: Maybe<Demand_Enquiry_Status_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Demand_Enquiry_Status_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demand_Enquiry_Status_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Demand_Enquiry_Status_Log_Sum_Fields>;
  var_pop?: Maybe<Demand_Enquiry_Status_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Demand_Enquiry_Status_Log_Var_Samp_Fields>;
  variance?: Maybe<Demand_Enquiry_Status_Log_Variance_Fields>;
};


/** aggregate fields of "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demand_Enquiry_Status_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Demand_Enquiry_Status_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Demand_Enquiry_Status_Log_Max_Order_By>;
  min?: InputMaybe<Demand_Enquiry_Status_Log_Min_Order_By>;
  stddev?: InputMaybe<Demand_Enquiry_Status_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Demand_Enquiry_Status_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Demand_Enquiry_Status_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Demand_Enquiry_Status_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Demand_Enquiry_Status_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Demand_Enquiry_Status_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Demand_Enquiry_Status_Log_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Demand_Enquiry_Status_Log_Avg_Fields = {
  __typename?: 'demand_enquiry_status_log_avg_fields';
  demand_enquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Avg_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "demand_enquiry_status_log". All fields are combined with a logical 'AND'. */
export type Demand_Enquiry_Status_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Demand_Enquiry_Status_Log_Bool_Exp>>;
  _not?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Demand_Enquiry_Status_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  demand_enquiry?: InputMaybe<Demand_Enquiries_Bool_Exp>;
  demand_enquiry_id?: InputMaybe<Bigint_Comparison_Exp>;
  from_status?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Demand_Enquiry_Status_Log_Max_Fields = {
  __typename?: 'demand_enquiry_status_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  demand_enquiry_id?: Maybe<Scalars['bigint']>;
  from_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand_enquiry_id?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Demand_Enquiry_Status_Log_Min_Fields = {
  __typename?: 'demand_enquiry_status_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  demand_enquiry_id?: Maybe<Scalars['bigint']>;
  from_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand_enquiry_id?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "demand_enquiry_status_log". */
export type Demand_Enquiry_Status_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  demand_enquiry?: InputMaybe<Demand_Enquiries_Order_By>;
  demand_enquiry_id?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "demand_enquiry_status_log" */
export enum Demand_Enquiry_Status_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DemandEnquiryId = 'demand_enquiry_id',
  /** column name */
  FromStatus = 'from_status',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Demand_Enquiry_Status_Log_Stddev_Fields = {
  __typename?: 'demand_enquiry_status_log_stddev_fields';
  demand_enquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Stddev_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Demand_Enquiry_Status_Log_Stddev_Pop_Fields = {
  __typename?: 'demand_enquiry_status_log_stddev_pop_fields';
  demand_enquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Stddev_Pop_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Demand_Enquiry_Status_Log_Stddev_Samp_Fields = {
  __typename?: 'demand_enquiry_status_log_stddev_samp_fields';
  demand_enquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Stddev_Samp_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demand_Enquiry_Status_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demand_Enquiry_Status_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  demand_enquiry_id?: InputMaybe<Scalars['bigint']>;
  from_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Demand_Enquiry_Status_Log_Sum_Fields = {
  __typename?: 'demand_enquiry_status_log_sum_fields';
  demand_enquiry_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Sum_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Demand_Enquiry_Status_Log_Var_Pop_Fields = {
  __typename?: 'demand_enquiry_status_log_var_pop_fields';
  demand_enquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Var_Pop_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Demand_Enquiry_Status_Log_Var_Samp_Fields = {
  __typename?: 'demand_enquiry_status_log_var_samp_fields';
  demand_enquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Var_Samp_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Demand_Enquiry_Status_Log_Variance_Fields = {
  __typename?: 'demand_enquiry_status_log_variance_fields';
  demand_enquiry_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "demand_enquiry_status_log" */
export type Demand_Enquiry_Status_Log_Variance_Order_By = {
  demand_enquiry_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "demand_expense" */
export type Demand_Expense = {
  __typename?: 'demand_expense';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  demand?: Maybe<Demand>;
  demand_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  expense_parameter: Expense_Parameter;
  expense_parameter_id: Scalars['bigint'];
  id: Scalars['bigint'];
  kind: Scalars['String'];
  paid_by: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['numeric'];
};

/** aggregated selection of "demand_expense" */
export type Demand_Expense_Aggregate = {
  __typename?: 'demand_expense_aggregate';
  aggregate?: Maybe<Demand_Expense_Aggregate_Fields>;
  nodes: Array<Demand_Expense>;
};

/** aggregate fields of "demand_expense" */
export type Demand_Expense_Aggregate_Fields = {
  __typename?: 'demand_expense_aggregate_fields';
  avg?: Maybe<Demand_Expense_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demand_Expense_Max_Fields>;
  min?: Maybe<Demand_Expense_Min_Fields>;
  stddev?: Maybe<Demand_Expense_Stddev_Fields>;
  stddev_pop?: Maybe<Demand_Expense_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demand_Expense_Stddev_Samp_Fields>;
  sum?: Maybe<Demand_Expense_Sum_Fields>;
  var_pop?: Maybe<Demand_Expense_Var_Pop_Fields>;
  var_samp?: Maybe<Demand_Expense_Var_Samp_Fields>;
  variance?: Maybe<Demand_Expense_Variance_Fields>;
};


/** aggregate fields of "demand_expense" */
export type Demand_Expense_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demand_Expense_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "demand_expense" */
export type Demand_Expense_Aggregate_Order_By = {
  avg?: InputMaybe<Demand_Expense_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Demand_Expense_Max_Order_By>;
  min?: InputMaybe<Demand_Expense_Min_Order_By>;
  stddev?: InputMaybe<Demand_Expense_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Demand_Expense_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Demand_Expense_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Demand_Expense_Sum_Order_By>;
  var_pop?: InputMaybe<Demand_Expense_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Demand_Expense_Var_Samp_Order_By>;
  variance?: InputMaybe<Demand_Expense_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Demand_Expense_Avg_Fields = {
  __typename?: 'demand_expense_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "demand_expense" */
export type Demand_Expense_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "demand_expense". All fields are combined with a logical 'AND'. */
export type Demand_Expense_Bool_Exp = {
  _and?: InputMaybe<Array<Demand_Expense_Bool_Exp>>;
  _not?: InputMaybe<Demand_Expense_Bool_Exp>;
  _or?: InputMaybe<Array<Demand_Expense_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  demand?: InputMaybe<Demand_Bool_Exp>;
  demand_id?: InputMaybe<Bigint_Comparison_Exp>;
  expense_parameter?: InputMaybe<Expense_Parameter_Bool_Exp>;
  expense_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  paid_by?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Demand_Expense_Max_Fields = {
  __typename?: 'demand_expense_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  demand_id?: Maybe<Scalars['bigint']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "demand_expense" */
export type Demand_Expense_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Demand_Expense_Min_Fields = {
  __typename?: 'demand_expense_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  demand_id?: Maybe<Scalars['bigint']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "demand_expense" */
export type Demand_Expense_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "demand_expense". */
export type Demand_Expense_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  demand?: InputMaybe<Demand_Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter?: InputMaybe<Expense_Parameter_Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "demand_expense" */
export enum Demand_Expense_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DemandId = 'demand_id',
  /** column name */
  ExpenseParameterId = 'expense_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  PaidBy = 'paid_by',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Demand_Expense_Stddev_Fields = {
  __typename?: 'demand_expense_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "demand_expense" */
export type Demand_Expense_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Demand_Expense_Stddev_Pop_Fields = {
  __typename?: 'demand_expense_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "demand_expense" */
export type Demand_Expense_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Demand_Expense_Stddev_Samp_Fields = {
  __typename?: 'demand_expense_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "demand_expense" */
export type Demand_Expense_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "demand_expense" */
export type Demand_Expense_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demand_Expense_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demand_Expense_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  demand_id?: InputMaybe<Scalars['bigint']>;
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Demand_Expense_Sum_Fields = {
  __typename?: 'demand_expense_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  demand_id?: Maybe<Scalars['bigint']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "demand_expense" */
export type Demand_Expense_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Demand_Expense_Var_Pop_Fields = {
  __typename?: 'demand_expense_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "demand_expense" */
export type Demand_Expense_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Demand_Expense_Var_Samp_Fields = {
  __typename?: 'demand_expense_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "demand_expense" */
export type Demand_Expense_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Demand_Expense_Variance_Fields = {
  __typename?: 'demand_expense_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "demand_expense" */
export type Demand_Expense_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Demand_Max_Fields = {
  __typename?: 'demand_max_fields';
  buyer_expense?: Maybe<Scalars['float8']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['float8']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date_time?: Maybe<Scalars['timestamptz']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['float8']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_kg?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['float8']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  seller_expense?: Maybe<Scalars['float8']>;
  seller_file_id?: Maybe<Scalars['bigint']>;
  seller_source_kind?: Maybe<Scalars['String']>;
  seller_tnc?: Maybe<Scalars['String']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['float8']>;
  start_date_time?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "demand" */
export type Demand_Max_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date_time?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  seller_source_kind?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Demand_Min_Fields = {
  __typename?: 'demand_min_fields';
  buyer_expense?: Maybe<Scalars['float8']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['float8']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date_time?: Maybe<Scalars['timestamptz']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['float8']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_kg?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['float8']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  seller_expense?: Maybe<Scalars['float8']>;
  seller_file_id?: Maybe<Scalars['bigint']>;
  seller_source_kind?: Maybe<Scalars['String']>;
  seller_tnc?: Maybe<Scalars['String']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['float8']>;
  start_date_time?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "demand" */
export type Demand_Min_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date_time?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  seller_source_kind?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "demand" */
export type Demand_Mutation_Response = {
  __typename?: 'demand_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Demand>;
};

/** Ordering options when selecting data from "demand". */
export type Demand_Order_By = {
  attachments_aggregate?: InputMaybe<Demand_Attachments_Aggregate_Order_By>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  demand_seller_groups_aggregate?: InputMaybe<Demand_Seller_Groups_Aggregate_Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date_time?: InputMaybe<Order_By>;
  enquiries_aggregate?: InputMaybe<Demand_Enquiries_Aggregate_Order_By>;
  expenses_aggregate?: InputMaybe<Demand_Expense_Aggregate_Order_By>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file?: InputMaybe<Setutrade_Media_Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  seller_source_kind?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  sr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: demand */
export type Demand_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "demand" */
export enum Demand_Select_Column {
  /** column name */
  BuyerExpense = 'buyer_expense',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDateTime = 'end_date_time',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  JrOfficerId = 'jr_officer_id',
  /** column name */
  MaterialKind = 'material_kind',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  Mode = 'mode',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityKg = 'quantity_kg',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateUnitId = 'rate_unit_id',
  /** column name */
  SellerExpense = 'seller_expense',
  /** column name */
  SellerFileId = 'seller_file_id',
  /** column name */
  SellerSourceKind = 'seller_source_kind',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  SrOfficerId = 'sr_officer_id',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDateTime = 'start_date_time',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VarietyGradeId = 'variety_grade_id'
}

/** columns and relationships of "demand_seller_groups" */
export type Demand_Seller_Groups = {
  __typename?: 'demand_seller_groups';
  /** An object relationship */
  demand: Demand;
  demand_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  seller_groups: Setu_Trade_Shared_Entity;
  sharedentity_id: Scalars['bigint'];
};

/** aggregated selection of "demand_seller_groups" */
export type Demand_Seller_Groups_Aggregate = {
  __typename?: 'demand_seller_groups_aggregate';
  aggregate?: Maybe<Demand_Seller_Groups_Aggregate_Fields>;
  nodes: Array<Demand_Seller_Groups>;
};

/** aggregate fields of "demand_seller_groups" */
export type Demand_Seller_Groups_Aggregate_Fields = {
  __typename?: 'demand_seller_groups_aggregate_fields';
  avg?: Maybe<Demand_Seller_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Demand_Seller_Groups_Max_Fields>;
  min?: Maybe<Demand_Seller_Groups_Min_Fields>;
  stddev?: Maybe<Demand_Seller_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Demand_Seller_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Demand_Seller_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Demand_Seller_Groups_Sum_Fields>;
  var_pop?: Maybe<Demand_Seller_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Demand_Seller_Groups_Var_Samp_Fields>;
  variance?: Maybe<Demand_Seller_Groups_Variance_Fields>;
};


/** aggregate fields of "demand_seller_groups" */
export type Demand_Seller_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Demand_Seller_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "demand_seller_groups" */
export type Demand_Seller_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Demand_Seller_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Demand_Seller_Groups_Max_Order_By>;
  min?: InputMaybe<Demand_Seller_Groups_Min_Order_By>;
  stddev?: InputMaybe<Demand_Seller_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Demand_Seller_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Demand_Seller_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Demand_Seller_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Demand_Seller_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Demand_Seller_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Demand_Seller_Groups_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Demand_Seller_Groups_Avg_Fields = {
  __typename?: 'demand_seller_groups_avg_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Avg_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "demand_seller_groups". All fields are combined with a logical 'AND'. */
export type Demand_Seller_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Demand_Seller_Groups_Bool_Exp>>;
  _not?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Demand_Seller_Groups_Bool_Exp>>;
  demand?: InputMaybe<Demand_Bool_Exp>;
  demand_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_groups?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  sharedentity_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Demand_Seller_Groups_Max_Fields = {
  __typename?: 'demand_seller_groups_max_fields';
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Max_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Demand_Seller_Groups_Min_Fields = {
  __typename?: 'demand_seller_groups_min_fields';
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Min_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "demand_seller_groups". */
export type Demand_Seller_Groups_Order_By = {
  demand?: InputMaybe<Demand_Order_By>;
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seller_groups?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** select columns of table "demand_seller_groups" */
export enum Demand_Seller_Groups_Select_Column {
  /** column name */
  DemandId = 'demand_id',
  /** column name */
  Id = 'id',
  /** column name */
  SharedentityId = 'sharedentity_id'
}

/** aggregate stddev on columns */
export type Demand_Seller_Groups_Stddev_Fields = {
  __typename?: 'demand_seller_groups_stddev_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Stddev_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Demand_Seller_Groups_Stddev_Pop_Fields = {
  __typename?: 'demand_seller_groups_stddev_pop_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Stddev_Pop_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Demand_Seller_Groups_Stddev_Samp_Fields = {
  __typename?: 'demand_seller_groups_stddev_samp_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Stddev_Samp_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "demand_seller_groups" */
export type Demand_Seller_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demand_Seller_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demand_Seller_Groups_Stream_Cursor_Value_Input = {
  demand_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  sharedentity_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Demand_Seller_Groups_Sum_Fields = {
  __typename?: 'demand_seller_groups_sum_fields';
  demand_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Sum_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Demand_Seller_Groups_Var_Pop_Fields = {
  __typename?: 'demand_seller_groups_var_pop_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Var_Pop_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Demand_Seller_Groups_Var_Samp_Fields = {
  __typename?: 'demand_seller_groups_var_samp_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Var_Samp_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Demand_Seller_Groups_Variance_Fields = {
  __typename?: 'demand_seller_groups_variance_fields';
  demand_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "demand_seller_groups" */
export type Demand_Seller_Groups_Variance_Order_By = {
  demand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** input type for updating data in table "demand" */
export type Demand_Set_Input = {
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Demand_Stddev_Fields = {
  __typename?: 'demand_stddev_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_file_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "demand" */
export type Demand_Stddev_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Demand_Stddev_Pop_Fields = {
  __typename?: 'demand_stddev_pop_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_file_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "demand" */
export type Demand_Stddev_Pop_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Demand_Stddev_Samp_Fields = {
  __typename?: 'demand_stddev_samp_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_file_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "demand" */
export type Demand_Stddev_Samp_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "demand" */
export type Demand_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Demand_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Demand_Stream_Cursor_Value_Input = {
  buyer_expense?: InputMaybe<Scalars['float8']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  deducted_amount?: InputMaybe<Scalars['float8']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date_time?: InputMaybe<Scalars['timestamptz']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  jr_officer_id?: InputMaybe<Scalars['bigint']>;
  material_kind?: InputMaybe<Scalars['String']>;
  max_rate?: InputMaybe<Scalars['float8']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_kg?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['float8']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  seller_expense?: InputMaybe<Scalars['float8']>;
  seller_file_id?: InputMaybe<Scalars['bigint']>;
  seller_source_kind?: InputMaybe<Scalars['String']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  sr_officer_id?: InputMaybe<Scalars['bigint']>;
  standard_deduction?: InputMaybe<Scalars['float8']>;
  start_date_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Demand_Sum_Fields = {
  __typename?: 'demand_sum_fields';
  buyer_expense?: Maybe<Scalars['float8']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  deducted_amount?: Maybe<Scalars['float8']>;
  department_id?: Maybe<Scalars['bigint']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  max_rate?: Maybe<Scalars['float8']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_kg?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['float8']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  seller_expense?: Maybe<Scalars['float8']>;
  seller_file_id?: Maybe<Scalars['bigint']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['float8']>;
  total_amount?: Maybe<Scalars['float8']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "demand" */
export type Demand_Sum_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

export type Demand_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Demand_Set_Input>;
  where: Demand_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Demand_Var_Pop_Fields = {
  __typename?: 'demand_var_pop_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_file_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "demand" */
export type Demand_Var_Pop_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Demand_Var_Samp_Fields = {
  __typename?: 'demand_var_samp_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_file_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "demand" */
export type Demand_Var_Samp_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Demand_Variance_Fields = {
  __typename?: 'demand_variance_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_file_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "demand" */
export type Demand_Variance_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_file_id?: InputMaybe<Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "department" */
export type Department = {
  __typename?: 'department';
  abbreviation: Scalars['String'];
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  base_users: Array<Base_User>;
  /** An aggregate relationship */
  base_users_aggregate: Base_User_Aggregate;
  codename: Scalars['String'];
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
  external_reference_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  payment_details: Array<Department_Payment_Detail>;
  /** An aggregate relationship */
  payment_details_aggregate: Department_Payment_Detail_Aggregate;
  photo_id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};


/** columns and relationships of "department" */
export type DepartmentBase_UsersArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentBase_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "department" */
export type DepartmentPayment_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Department_Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Payment_Detail_Order_By>>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentPayment_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Payment_Detail_Order_By>>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};

/** aggregated selection of "department" */
export type Department_Aggregate = {
  __typename?: 'department_aggregate';
  aggregate?: Maybe<Department_Aggregate_Fields>;
  nodes: Array<Department>;
};

/** aggregate fields of "department" */
export type Department_Aggregate_Fields = {
  __typename?: 'department_aggregate_fields';
  avg?: Maybe<Department_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Department_Max_Fields>;
  min?: Maybe<Department_Min_Fields>;
  stddev?: Maybe<Department_Stddev_Fields>;
  stddev_pop?: Maybe<Department_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Department_Stddev_Samp_Fields>;
  sum?: Maybe<Department_Sum_Fields>;
  var_pop?: Maybe<Department_Var_Pop_Fields>;
  var_samp?: Maybe<Department_Var_Samp_Fields>;
  variance?: Maybe<Department_Variance_Fields>;
};


/** aggregate fields of "department" */
export type Department_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Department_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Department_Avg_Fields = {
  __typename?: 'department_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type Department_Bool_Exp = {
  _and?: InputMaybe<Array<Department_Bool_Exp>>;
  _not?: InputMaybe<Department_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  base_users?: InputMaybe<Base_User_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payment_details?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type Department_Bool_Exp_Remote_Rel_Shared_Entitydepartment = {
  _and?: InputMaybe<Array<Department_Bool_Exp>>;
  _not?: InputMaybe<Department_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  base_users?: InputMaybe<Base_User_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitydepartment>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  payment_details?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "department_config" */
export type Department_Config = {
  __typename?: 'department_config';
  actual_profit_share: Scalars['float8'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  include_in_mis: Scalars['Boolean'];
  payment_cycle_days: Scalars['Int'];
  seller_payment_cycle_days: Scalars['Int'];
  seller_tds_amount: Scalars['float8'];
  seller_tds_percentage: Scalars['float8'];
  sequence_in_report: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  use_credit: Scalars['Boolean'];
};

/** aggregated selection of "department_config" */
export type Department_Config_Aggregate = {
  __typename?: 'department_config_aggregate';
  aggregate?: Maybe<Department_Config_Aggregate_Fields>;
  nodes: Array<Department_Config>;
};

/** aggregate fields of "department_config" */
export type Department_Config_Aggregate_Fields = {
  __typename?: 'department_config_aggregate_fields';
  avg?: Maybe<Department_Config_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Department_Config_Max_Fields>;
  min?: Maybe<Department_Config_Min_Fields>;
  stddev?: Maybe<Department_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Department_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Department_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Department_Config_Sum_Fields>;
  var_pop?: Maybe<Department_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Department_Config_Var_Samp_Fields>;
  variance?: Maybe<Department_Config_Variance_Fields>;
};


/** aggregate fields of "department_config" */
export type Department_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Department_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Department_Config_Avg_Fields = {
  __typename?: 'department_config_avg_fields';
  actual_profit_share?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_tds_amount?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  sequence_in_report?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "department_config". All fields are combined with a logical 'AND'. */
export type Department_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Department_Config_Bool_Exp>>;
  _not?: InputMaybe<Department_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Config_Bool_Exp>>;
  actual_profit_share?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_one_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_two_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_recommendation_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  include_in_mis?: InputMaybe<Boolean_Comparison_Exp>;
  payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  seller_payment_cycle_days?: InputMaybe<Int_Comparison_Exp>;
  seller_tds_amount?: InputMaybe<Float8_Comparison_Exp>;
  seller_tds_percentage?: InputMaybe<Float8_Comparison_Exp>;
  sequence_in_report?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  use_credit?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Department_Config_Max_Fields = {
  __typename?: 'department_config_max_fields';
  actual_profit_share?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  seller_payment_cycle_days?: Maybe<Scalars['Int']>;
  seller_tds_amount?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  sequence_in_report?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Department_Config_Min_Fields = {
  __typename?: 'department_config_min_fields';
  actual_profit_share?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  seller_payment_cycle_days?: Maybe<Scalars['Int']>;
  seller_tds_amount?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  sequence_in_report?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "department_config". */
export type Department_Config_Order_By = {
  actual_profit_share?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_in_mis?: InputMaybe<Order_By>;
  payment_cycle_days?: InputMaybe<Order_By>;
  seller_payment_cycle_days?: InputMaybe<Order_By>;
  seller_tds_amount?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  sequence_in_report?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  use_credit?: InputMaybe<Order_By>;
};

/** select columns of table "department_config" */
export enum Department_Config_Select_Column {
  /** column name */
  ActualProfitShare = 'actual_profit_share',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  DeviationFinalOfficerOneId = 'deviation_final_officer_one_id',
  /** column name */
  DeviationFinalOfficerTwoId = 'deviation_final_officer_two_id',
  /** column name */
  DeviationRecommendationOfficerId = 'deviation_recommendation_officer_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeInMis = 'include_in_mis',
  /** column name */
  PaymentCycleDays = 'payment_cycle_days',
  /** column name */
  SellerPaymentCycleDays = 'seller_payment_cycle_days',
  /** column name */
  SellerTdsAmount = 'seller_tds_amount',
  /** column name */
  SellerTdsPercentage = 'seller_tds_percentage',
  /** column name */
  SequenceInReport = 'sequence_in_report',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UseCredit = 'use_credit'
}

/** aggregate stddev on columns */
export type Department_Config_Stddev_Fields = {
  __typename?: 'department_config_stddev_fields';
  actual_profit_share?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_tds_amount?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  sequence_in_report?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Department_Config_Stddev_Pop_Fields = {
  __typename?: 'department_config_stddev_pop_fields';
  actual_profit_share?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_tds_amount?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  sequence_in_report?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Department_Config_Stddev_Samp_Fields = {
  __typename?: 'department_config_stddev_samp_fields';
  actual_profit_share?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_tds_amount?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  sequence_in_report?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "department_config" */
export type Department_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Config_Stream_Cursor_Value_Input = {
  actual_profit_share?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_two_id?: InputMaybe<Scalars['bigint']>;
  deviation_recommendation_officer_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  include_in_mis?: InputMaybe<Scalars['Boolean']>;
  payment_cycle_days?: InputMaybe<Scalars['Int']>;
  seller_payment_cycle_days?: InputMaybe<Scalars['Int']>;
  seller_tds_amount?: InputMaybe<Scalars['float8']>;
  seller_tds_percentage?: InputMaybe<Scalars['float8']>;
  sequence_in_report?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  use_credit?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Department_Config_Sum_Fields = {
  __typename?: 'department_config_sum_fields';
  actual_profit_share?: Maybe<Scalars['float8']>;
  department_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle_days?: Maybe<Scalars['Int']>;
  seller_payment_cycle_days?: Maybe<Scalars['Int']>;
  seller_tds_amount?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  sequence_in_report?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Department_Config_Var_Pop_Fields = {
  __typename?: 'department_config_var_pop_fields';
  actual_profit_share?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_tds_amount?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  sequence_in_report?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Department_Config_Var_Samp_Fields = {
  __typename?: 'department_config_var_samp_fields';
  actual_profit_share?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_tds_amount?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  sequence_in_report?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Department_Config_Variance_Fields = {
  __typename?: 'department_config_variance_fields';
  actual_profit_share?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_payment_cycle_days?: Maybe<Scalars['Float']>;
  seller_tds_amount?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  sequence_in_report?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "department" */
export enum Department_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DepartmentCodenameKey = 'department_codename_key',
  /** unique or primary key constraint on columns "name", "company_id" */
  DepartmentNameCompanyIdE136414dUniq = 'department_name_company_id_e136414d_uniq',
  /** unique or primary key constraint on columns "photo_id" */
  DepartmentPhotoIdKey = 'department_photo_id_key',
  /** unique or primary key constraint on columns "id" */
  DepartmentPkey = 'department_pkey',
  /** unique or primary key constraint on columns "uid" */
  DepartmentUidKey = 'department_uid_key'
}

/** input type for incrementing numeric columns in table "department" */
export type Department_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "department" */
export type Department_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  base_users?: InputMaybe<Base_User_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  payment_details?: InputMaybe<Department_Payment_Detail_Arr_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Department_Max_Fields = {
  __typename?: 'department_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Department_Min_Fields = {
  __typename?: 'department_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "department" */
export type Department_Mutation_Response = {
  __typename?: 'department_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Department>;
};

/** input type for inserting object relation for remote table "department" */
export type Department_Obj_Rel_Insert_Input = {
  data: Department_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_On_Conflict>;
};

/** on_conflict condition type for table "department" */
export type Department_On_Conflict = {
  constraint: Department_Constraint;
  update_columns?: Array<Department_Update_Column>;
  where?: InputMaybe<Department_Bool_Exp>;
};

/** Ordering options when selecting data from "department". */
export type Department_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  base_users_aggregate?: InputMaybe<Base_User_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  payment_details_aggregate?: InputMaybe<Department_Payment_Detail_Aggregate_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** columns and relationships of "department_payment_detail" */
export type Department_Payment_Detail = {
  __typename?: 'department_payment_detail';
  /** An object relationship */
  department: Department;
  department_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  payment_detail: Payment_Detail;
  payment_detail_id: Scalars['Int'];
  priority: Scalars['Int'];
};

/** aggregated selection of "department_payment_detail" */
export type Department_Payment_Detail_Aggregate = {
  __typename?: 'department_payment_detail_aggregate';
  aggregate?: Maybe<Department_Payment_Detail_Aggregate_Fields>;
  nodes: Array<Department_Payment_Detail>;
};

/** aggregate fields of "department_payment_detail" */
export type Department_Payment_Detail_Aggregate_Fields = {
  __typename?: 'department_payment_detail_aggregate_fields';
  avg?: Maybe<Department_Payment_Detail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Department_Payment_Detail_Max_Fields>;
  min?: Maybe<Department_Payment_Detail_Min_Fields>;
  stddev?: Maybe<Department_Payment_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Department_Payment_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Department_Payment_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Department_Payment_Detail_Sum_Fields>;
  var_pop?: Maybe<Department_Payment_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Department_Payment_Detail_Var_Samp_Fields>;
  variance?: Maybe<Department_Payment_Detail_Variance_Fields>;
};


/** aggregate fields of "department_payment_detail" */
export type Department_Payment_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Department_Payment_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "department_payment_detail" */
export type Department_Payment_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Department_Payment_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Department_Payment_Detail_Max_Order_By>;
  min?: InputMaybe<Department_Payment_Detail_Min_Order_By>;
  stddev?: InputMaybe<Department_Payment_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Department_Payment_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Department_Payment_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Department_Payment_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Department_Payment_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Department_Payment_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Department_Payment_Detail_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "department_payment_detail" */
export type Department_Payment_Detail_Arr_Rel_Insert_Input = {
  data: Array<Department_Payment_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_Payment_Detail_On_Conflict>;
};

/** aggregate avg on columns */
export type Department_Payment_Detail_Avg_Fields = {
  __typename?: 'department_payment_detail_avg_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_detail_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Avg_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "department_payment_detail". All fields are combined with a logical 'AND'. */
export type Department_Payment_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Department_Payment_Detail_Bool_Exp>>;
  _not?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Payment_Detail_Bool_Exp>>;
  department?: InputMaybe<Department_Bool_Exp>;
  department_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payment_detail?: InputMaybe<Payment_Detail_Bool_Exp>;
  payment_detail_id?: InputMaybe<Int_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "department_payment_detail" */
export enum Department_Payment_Detail_Constraint {
  /** unique or primary key constraint on columns "department_id", "payment_detail_id" */
  DepartmentPaymentDetaiDepartmentIdPaymentDe_1eb7cf44Uniq = 'department_payment_detai_department_id_payment_de_1eb7cf44_uniq',
  /** unique or primary key constraint on columns "id" */
  DepartmentPaymentDetailPkey = 'department_payment_detail_pkey'
}

/** input type for incrementing numeric columns in table "department_payment_detail" */
export type Department_Payment_Detail_Inc_Input = {
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_detail_id?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "department_payment_detail" */
export type Department_Payment_Detail_Insert_Input = {
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_detail?: InputMaybe<Payment_Detail_Obj_Rel_Insert_Input>;
  payment_detail_id?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Department_Payment_Detail_Max_Fields = {
  __typename?: 'department_payment_detail_max_fields';
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_detail_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Max_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Department_Payment_Detail_Min_Fields = {
  __typename?: 'department_payment_detail_min_fields';
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_detail_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Min_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "department_payment_detail" */
export type Department_Payment_Detail_Mutation_Response = {
  __typename?: 'department_payment_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Department_Payment_Detail>;
};

/** on_conflict condition type for table "department_payment_detail" */
export type Department_Payment_Detail_On_Conflict = {
  constraint: Department_Payment_Detail_Constraint;
  update_columns?: Array<Department_Payment_Detail_Update_Column>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "department_payment_detail". */
export type Department_Payment_Detail_Order_By = {
  department?: InputMaybe<Department_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail?: InputMaybe<Payment_Detail_Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** primary key columns input for table: department_payment_detail */
export type Department_Payment_Detail_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "department_payment_detail" */
export enum Department_Payment_Detail_Select_Column {
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDetailId = 'payment_detail_id',
  /** column name */
  Priority = 'priority'
}

/** input type for updating data in table "department_payment_detail" */
export type Department_Payment_Detail_Set_Input = {
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_detail_id?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Department_Payment_Detail_Stddev_Fields = {
  __typename?: 'department_payment_detail_stddev_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_detail_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Stddev_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Department_Payment_Detail_Stddev_Pop_Fields = {
  __typename?: 'department_payment_detail_stddev_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_detail_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Stddev_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Department_Payment_Detail_Stddev_Samp_Fields = {
  __typename?: 'department_payment_detail_stddev_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_detail_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Stddev_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "department_payment_detail" */
export type Department_Payment_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Payment_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Payment_Detail_Stream_Cursor_Value_Input = {
  department_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_detail_id?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Department_Payment_Detail_Sum_Fields = {
  __typename?: 'department_payment_detail_sum_fields';
  department_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_detail_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Sum_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** update columns of table "department_payment_detail" */
export enum Department_Payment_Detail_Update_Column {
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDetailId = 'payment_detail_id',
  /** column name */
  Priority = 'priority'
}

export type Department_Payment_Detail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Department_Payment_Detail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Payment_Detail_Set_Input>;
  where: Department_Payment_Detail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Department_Payment_Detail_Var_Pop_Fields = {
  __typename?: 'department_payment_detail_var_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_detail_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Var_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Department_Payment_Detail_Var_Samp_Fields = {
  __typename?: 'department_payment_detail_var_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_detail_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Var_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Department_Payment_Detail_Variance_Fields = {
  __typename?: 'department_payment_detail_variance_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_detail_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "department_payment_detail" */
export type Department_Payment_Detail_Variance_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_detail_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
};

/** primary key columns input for table: department */
export type Department_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "department" */
export enum Department_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Uid = 'uid'
}

/** input type for updating data in table "department" */
export type Department_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "department_settlements" */
export type Department_Settlements = {
  __typename?: 'department_settlements';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  date: Scalars['date'];
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  kind: Scalars['String'];
  /** An array relationship */
  transactions: Array<Transaction>;
  /** An aggregate relationship */
  transactions_aggregate: Transaction_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "department_settlements" */
export type Department_SettlementsTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "department_settlements" */
export type Department_SettlementsTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

/** aggregated selection of "department_settlements" */
export type Department_Settlements_Aggregate = {
  __typename?: 'department_settlements_aggregate';
  aggregate?: Maybe<Department_Settlements_Aggregate_Fields>;
  nodes: Array<Department_Settlements>;
};

/** aggregate fields of "department_settlements" */
export type Department_Settlements_Aggregate_Fields = {
  __typename?: 'department_settlements_aggregate_fields';
  avg?: Maybe<Department_Settlements_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Department_Settlements_Max_Fields>;
  min?: Maybe<Department_Settlements_Min_Fields>;
  stddev?: Maybe<Department_Settlements_Stddev_Fields>;
  stddev_pop?: Maybe<Department_Settlements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Department_Settlements_Stddev_Samp_Fields>;
  sum?: Maybe<Department_Settlements_Sum_Fields>;
  var_pop?: Maybe<Department_Settlements_Var_Pop_Fields>;
  var_samp?: Maybe<Department_Settlements_Var_Samp_Fields>;
  variance?: Maybe<Department_Settlements_Variance_Fields>;
};


/** aggregate fields of "department_settlements" */
export type Department_Settlements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Department_Settlements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Department_Settlements_Avg_Fields = {
  __typename?: 'department_settlements_avg_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "department_settlements". All fields are combined with a logical 'AND'. */
export type Department_Settlements_Bool_Exp = {
  _and?: InputMaybe<Array<Department_Settlements_Bool_Exp>>;
  _not?: InputMaybe<Department_Settlements_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Settlements_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  transactions?: InputMaybe<Transaction_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "department_settlements" */
export enum Department_Settlements_Constraint {
  /** unique or primary key constraint on columns "id" */
  DepartmentSettlementsPkey = 'department_settlements_pkey'
}

/** input type for incrementing numeric columns in table "department_settlements" */
export type Department_Settlements_Inc_Input = {
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "department_settlements" */
export type Department_Settlements_Insert_Input = {
  date?: InputMaybe<Scalars['date']>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<Transaction_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Department_Settlements_Max_Fields = {
  __typename?: 'department_settlements_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Department_Settlements_Min_Fields = {
  __typename?: 'department_settlements_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "department_settlements" */
export type Department_Settlements_Mutation_Response = {
  __typename?: 'department_settlements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Department_Settlements>;
};

/** input type for inserting object relation for remote table "department_settlements" */
export type Department_Settlements_Obj_Rel_Insert_Input = {
  data: Department_Settlements_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Department_Settlements_On_Conflict>;
};

/** on_conflict condition type for table "department_settlements" */
export type Department_Settlements_On_Conflict = {
  constraint: Department_Settlements_Constraint;
  update_columns?: Array<Department_Settlements_Update_Column>;
  where?: InputMaybe<Department_Settlements_Bool_Exp>;
};

/** Ordering options when selecting data from "department_settlements". */
export type Department_Settlements_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: department_settlements */
export type Department_Settlements_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "department_settlements" */
export enum Department_Settlements_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Date = 'date',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "department_settlements" */
export type Department_Settlements_Set_Input = {
  date?: InputMaybe<Scalars['date']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Department_Settlements_Stddev_Fields = {
  __typename?: 'department_settlements_stddev_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Department_Settlements_Stddev_Pop_Fields = {
  __typename?: 'department_settlements_stddev_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Department_Settlements_Stddev_Samp_Fields = {
  __typename?: 'department_settlements_stddev_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "department_settlements" */
export type Department_Settlements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Settlements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Settlements_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Department_Settlements_Sum_Fields = {
  __typename?: 'department_settlements_sum_fields';
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "department_settlements" */
export enum Department_Settlements_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  UserId = 'user_id'
}

export type Department_Settlements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Department_Settlements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Settlements_Set_Input>;
  where: Department_Settlements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Department_Settlements_Var_Pop_Fields = {
  __typename?: 'department_settlements_var_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Department_Settlements_Var_Samp_Fields = {
  __typename?: 'department_settlements_var_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Department_Settlements_Variance_Fields = {
  __typename?: 'department_settlements_variance_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Department_Stddev_Fields = {
  __typename?: 'department_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Department_Stddev_Pop_Fields = {
  __typename?: 'department_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Department_Stddev_Samp_Fields = {
  __typename?: 'department_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "department" */
export type Department_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Department_Sum_Fields = {
  __typename?: 'department_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "department" */
export enum Department_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  Uid = 'uid'
}

export type Department_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Department_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Set_Input>;
  where: Department_Bool_Exp;
};

/** columns and relationships of "department_user_advance" */
export type Department_User_Advance = {
  __typename?: 'department_user_advance';
  /** An array relationship */
  advance_payments: Array<Advance_Payment>;
  /** An aggregate relationship */
  advance_payments_aggregate: Advance_Payment_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  remaining_amount?: Maybe<Scalars['numeric']>;
  total_released_amount?: Maybe<Scalars['numeric']>;
  total_requested_amount?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
  used_amount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  user: Setu_Trade_Shared_Entity;
  user_id: Scalars['bigint'];
};


/** columns and relationships of "department_user_advance" */
export type Department_User_AdvanceAdvance_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


/** columns and relationships of "department_user_advance" */
export type Department_User_AdvanceAdvance_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};

/** aggregated selection of "department_user_advance" */
export type Department_User_Advance_Aggregate = {
  __typename?: 'department_user_advance_aggregate';
  aggregate?: Maybe<Department_User_Advance_Aggregate_Fields>;
  nodes: Array<Department_User_Advance>;
};

/** aggregate fields of "department_user_advance" */
export type Department_User_Advance_Aggregate_Fields = {
  __typename?: 'department_user_advance_aggregate_fields';
  avg?: Maybe<Department_User_Advance_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Department_User_Advance_Max_Fields>;
  min?: Maybe<Department_User_Advance_Min_Fields>;
  stddev?: Maybe<Department_User_Advance_Stddev_Fields>;
  stddev_pop?: Maybe<Department_User_Advance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Department_User_Advance_Stddev_Samp_Fields>;
  sum?: Maybe<Department_User_Advance_Sum_Fields>;
  var_pop?: Maybe<Department_User_Advance_Var_Pop_Fields>;
  var_samp?: Maybe<Department_User_Advance_Var_Samp_Fields>;
  variance?: Maybe<Department_User_Advance_Variance_Fields>;
};


/** aggregate fields of "department_user_advance" */
export type Department_User_Advance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Department_User_Advance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "department_user_advance" */
export type Department_User_Advance_Aggregate_Order_By = {
  avg?: InputMaybe<Department_User_Advance_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Department_User_Advance_Max_Order_By>;
  min?: InputMaybe<Department_User_Advance_Min_Order_By>;
  stddev?: InputMaybe<Department_User_Advance_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Department_User_Advance_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Department_User_Advance_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Department_User_Advance_Sum_Order_By>;
  var_pop?: InputMaybe<Department_User_Advance_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Department_User_Advance_Var_Samp_Order_By>;
  variance?: InputMaybe<Department_User_Advance_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Department_User_Advance_Avg_Fields = {
  __typename?: 'department_user_advance_avg_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "department_user_advance" */
export type Department_User_Advance_Avg_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "department_user_advance". All fields are combined with a logical 'AND'. */
export type Department_User_Advance_Bool_Exp = {
  _and?: InputMaybe<Array<Department_User_Advance_Bool_Exp>>;
  _not?: InputMaybe<Department_User_Advance_Bool_Exp>;
  _or?: InputMaybe<Array<Department_User_Advance_Bool_Exp>>;
  advance_payments?: InputMaybe<Advance_Payment_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  remaining_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_released_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_requested_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  used_amount?: InputMaybe<Numeric_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Department_User_Advance_Max_Fields = {
  __typename?: 'department_user_advance_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  department_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  total_released_amount?: Maybe<Scalars['numeric']>;
  total_requested_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used_amount?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "department_user_advance" */
export type Department_User_Advance_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Department_User_Advance_Min_Fields = {
  __typename?: 'department_user_advance_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  department_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  total_released_amount?: Maybe<Scalars['numeric']>;
  total_requested_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used_amount?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "department_user_advance" */
export type Department_User_Advance_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "department_user_advance". */
export type Department_User_Advance_Order_By = {
  advance_payments_aggregate?: InputMaybe<Advance_Payment_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "department_user_advance" */
export enum Department_User_Advance_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  RemainingAmount = 'remaining_amount',
  /** column name */
  TotalReleasedAmount = 'total_released_amount',
  /** column name */
  TotalRequestedAmount = 'total_requested_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsedAmount = 'used_amount',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Department_User_Advance_Stddev_Fields = {
  __typename?: 'department_user_advance_stddev_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "department_user_advance" */
export type Department_User_Advance_Stddev_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Department_User_Advance_Stddev_Pop_Fields = {
  __typename?: 'department_user_advance_stddev_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "department_user_advance" */
export type Department_User_Advance_Stddev_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Department_User_Advance_Stddev_Samp_Fields = {
  __typename?: 'department_user_advance_stddev_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "department_user_advance" */
export type Department_User_Advance_Stddev_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "department_user_advance" */
export type Department_User_Advance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_User_Advance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_User_Advance_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remaining_amount?: InputMaybe<Scalars['numeric']>;
  total_released_amount?: InputMaybe<Scalars['numeric']>;
  total_requested_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_amount?: InputMaybe<Scalars['numeric']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Department_User_Advance_Sum_Fields = {
  __typename?: 'department_user_advance_sum_fields';
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remaining_amount?: Maybe<Scalars['numeric']>;
  total_released_amount?: Maybe<Scalars['numeric']>;
  total_requested_amount?: Maybe<Scalars['numeric']>;
  used_amount?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "department_user_advance" */
export type Department_User_Advance_Sum_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Department_User_Advance_Var_Pop_Fields = {
  __typename?: 'department_user_advance_var_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "department_user_advance" */
export type Department_User_Advance_Var_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Department_User_Advance_Var_Samp_Fields = {
  __typename?: 'department_user_advance_var_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "department_user_advance" */
export type Department_User_Advance_Var_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Department_User_Advance_Variance_Fields = {
  __typename?: 'department_user_advance_variance_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  remaining_amount?: Maybe<Scalars['Float']>;
  total_released_amount?: Maybe<Scalars['Float']>;
  total_requested_amount?: Maybe<Scalars['Float']>;
  used_amount?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "department_user_advance" */
export type Department_User_Advance_Variance_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remaining_amount?: InputMaybe<Order_By>;
  total_released_amount?: InputMaybe<Order_By>;
  total_requested_amount?: InputMaybe<Order_By>;
  used_amount?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Department_Var_Pop_Fields = {
  __typename?: 'department_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Department_Var_Samp_Fields = {
  __typename?: 'department_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Department_Variance_Fields = {
  __typename?: 'department_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "device" */
export type Device = {
  __typename?: 'device';
  /** An object relationship */
  address?: Maybe<Address>;
  app_version?: Maybe<Scalars['String']>;
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  bundle_id?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  device_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  location_id?: Maybe<Scalars['Int']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  token: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "device" */
export type DeviceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "device" */
export type DevicePrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "device" */
export type Device_Aggregate = {
  __typename?: 'device_aggregate';
  aggregate?: Maybe<Device_Aggregate_Fields>;
  nodes: Array<Device>;
};

/** aggregate fields of "device" */
export type Device_Aggregate_Fields = {
  __typename?: 'device_aggregate_fields';
  avg?: Maybe<Device_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Device_Max_Fields>;
  min?: Maybe<Device_Min_Fields>;
  stddev?: Maybe<Device_Stddev_Fields>;
  stddev_pop?: Maybe<Device_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Device_Stddev_Samp_Fields>;
  sum?: Maybe<Device_Sum_Fields>;
  var_pop?: Maybe<Device_Var_Pop_Fields>;
  var_samp?: Maybe<Device_Var_Samp_Fields>;
  variance?: Maybe<Device_Variance_Fields>;
};


/** aggregate fields of "device" */
export type Device_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Device_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "device" */
export type Device_Aggregate_Order_By = {
  avg?: InputMaybe<Device_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Device_Max_Order_By>;
  min?: InputMaybe<Device_Min_Order_By>;
  stddev?: InputMaybe<Device_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Device_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Device_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Device_Sum_Order_By>;
  var_pop?: InputMaybe<Device_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Device_Var_Samp_Order_By>;
  variance?: InputMaybe<Device_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Device_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "device" */
export type Device_Arr_Rel_Insert_Input = {
  data: Array<Device_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Device_On_Conflict>;
};

/** aggregate avg on columns */
export type Device_Avg_Fields = {
  __typename?: 'device_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "device" */
export type Device_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "device". All fields are combined with a logical 'AND'. */
export type Device_Bool_Exp = {
  _and?: InputMaybe<Array<Device_Bool_Exp>>;
  _not?: InputMaybe<Device_Bool_Exp>;
  _or?: InputMaybe<Array<Device_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  bundle_id?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  device_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  location_id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "device" */
export enum Device_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DeviceCodenameKey = 'device_codename_key',
  /** unique or primary key constraint on columns "id" */
  DevicePkey = 'device_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Device_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Device_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Device_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "device" */
export type Device_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "device" */
export type Device_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  app_version?: InputMaybe<Scalars['String']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Device_Max_Fields = {
  __typename?: 'device_max_fields';
  app_version?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  bundle_id?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  device_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "device" */
export type Device_Max_Order_By = {
  app_version?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  bundle_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Device_Min_Fields = {
  __typename?: 'device_min_fields';
  app_version?: Maybe<Scalars['String']>;
  base_user_id?: Maybe<Scalars['Int']>;
  bundle_id?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  device_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "device" */
export type Device_Min_Order_By = {
  app_version?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  bundle_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "device" */
export type Device_Mutation_Response = {
  __typename?: 'device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Device>;
};

/** on_conflict condition type for table "device" */
export type Device_On_Conflict = {
  constraint: Device_Constraint;
  update_columns?: Array<Device_Update_Column>;
  where?: InputMaybe<Device_Bool_Exp>;
};

/** Ordering options when selecting data from "device". */
export type Device_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  app_version?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  bundle_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: device */
export type Device_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Device_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "device" */
export enum Device_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  BundleId = 'bundle_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "device" */
export type Device_Set_Input = {
  app_version?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Device_Stddev_Fields = {
  __typename?: 'device_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "device" */
export type Device_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Device_Stddev_Pop_Fields = {
  __typename?: 'device_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "device" */
export type Device_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Device_Stddev_Samp_Fields = {
  __typename?: 'device_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "device" */
export type Device_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "device" */
export type Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Device_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Device_Sum_Fields = {
  __typename?: 'device_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "device" */
export type Device_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** update columns of table "device" */
export enum Device_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  BundleId = 'bundle_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Device_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Device_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Device_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Device_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Device_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Device_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Device_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Device_Set_Input>;
  where: Device_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Device_Var_Pop_Fields = {
  __typename?: 'device_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "device" */
export type Device_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Device_Var_Samp_Fields = {
  __typename?: 'device_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "device" */
export type Device_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Device_Variance_Fields = {
  __typename?: 'device_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "device" */
export type Device_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "django_celery_results_taskresult" */
export type Django_Celery_Results_Taskresult = {
  __typename?: 'django_celery_results_taskresult';
  content_encoding: Scalars['String'];
  content_type: Scalars['String'];
  date_created: Scalars['timestamptz'];
  date_done: Scalars['timestamptz'];
  id: Scalars['Int'];
  meta?: Maybe<Scalars['String']>;
  periodic_task_name?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  task_args?: Maybe<Scalars['String']>;
  task_id: Scalars['String'];
  task_kwargs?: Maybe<Scalars['String']>;
  task_name?: Maybe<Scalars['String']>;
  traceback?: Maybe<Scalars['String']>;
  worker?: Maybe<Scalars['String']>;
};

/** aggregated selection of "django_celery_results_taskresult" */
export type Django_Celery_Results_Taskresult_Aggregate = {
  __typename?: 'django_celery_results_taskresult_aggregate';
  aggregate?: Maybe<Django_Celery_Results_Taskresult_Aggregate_Fields>;
  nodes: Array<Django_Celery_Results_Taskresult>;
};

/** aggregate fields of "django_celery_results_taskresult" */
export type Django_Celery_Results_Taskresult_Aggregate_Fields = {
  __typename?: 'django_celery_results_taskresult_aggregate_fields';
  avg?: Maybe<Django_Celery_Results_Taskresult_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Django_Celery_Results_Taskresult_Max_Fields>;
  min?: Maybe<Django_Celery_Results_Taskresult_Min_Fields>;
  stddev?: Maybe<Django_Celery_Results_Taskresult_Stddev_Fields>;
  stddev_pop?: Maybe<Django_Celery_Results_Taskresult_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Django_Celery_Results_Taskresult_Stddev_Samp_Fields>;
  sum?: Maybe<Django_Celery_Results_Taskresult_Sum_Fields>;
  var_pop?: Maybe<Django_Celery_Results_Taskresult_Var_Pop_Fields>;
  var_samp?: Maybe<Django_Celery_Results_Taskresult_Var_Samp_Fields>;
  variance?: Maybe<Django_Celery_Results_Taskresult_Variance_Fields>;
};


/** aggregate fields of "django_celery_results_taskresult" */
export type Django_Celery_Results_Taskresult_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Celery_Results_Taskresult_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Django_Celery_Results_Taskresult_Avg_Fields = {
  __typename?: 'django_celery_results_taskresult_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "django_celery_results_taskresult". All fields are combined with a logical 'AND'. */
export type Django_Celery_Results_Taskresult_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Celery_Results_Taskresult_Bool_Exp>>;
  _not?: InputMaybe<Django_Celery_Results_Taskresult_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Celery_Results_Taskresult_Bool_Exp>>;
  content_encoding?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_done?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<String_Comparison_Exp>;
  periodic_task_name?: InputMaybe<String_Comparison_Exp>;
  result?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  task_args?: InputMaybe<String_Comparison_Exp>;
  task_id?: InputMaybe<String_Comparison_Exp>;
  task_kwargs?: InputMaybe<String_Comparison_Exp>;
  task_name?: InputMaybe<String_Comparison_Exp>;
  traceback?: InputMaybe<String_Comparison_Exp>;
  worker?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Django_Celery_Results_Taskresult_Max_Fields = {
  __typename?: 'django_celery_results_taskresult_max_fields';
  content_encoding?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_done?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  meta?: Maybe<Scalars['String']>;
  periodic_task_name?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  task_args?: Maybe<Scalars['String']>;
  task_id?: Maybe<Scalars['String']>;
  task_kwargs?: Maybe<Scalars['String']>;
  task_name?: Maybe<Scalars['String']>;
  traceback?: Maybe<Scalars['String']>;
  worker?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Django_Celery_Results_Taskresult_Min_Fields = {
  __typename?: 'django_celery_results_taskresult_min_fields';
  content_encoding?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_done?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  meta?: Maybe<Scalars['String']>;
  periodic_task_name?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  task_args?: Maybe<Scalars['String']>;
  task_id?: Maybe<Scalars['String']>;
  task_kwargs?: Maybe<Scalars['String']>;
  task_name?: Maybe<Scalars['String']>;
  traceback?: Maybe<Scalars['String']>;
  worker?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "django_celery_results_taskresult". */
export type Django_Celery_Results_Taskresult_Order_By = {
  content_encoding?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_done?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  periodic_task_name?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  task_args?: InputMaybe<Order_By>;
  task_id?: InputMaybe<Order_By>;
  task_kwargs?: InputMaybe<Order_By>;
  task_name?: InputMaybe<Order_By>;
  traceback?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** select columns of table "django_celery_results_taskresult" */
export enum Django_Celery_Results_Taskresult_Select_Column {
  /** column name */
  ContentEncoding = 'content_encoding',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateDone = 'date_done',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PeriodicTaskName = 'periodic_task_name',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  TaskArgs = 'task_args',
  /** column name */
  TaskId = 'task_id',
  /** column name */
  TaskKwargs = 'task_kwargs',
  /** column name */
  TaskName = 'task_name',
  /** column name */
  Traceback = 'traceback',
  /** column name */
  Worker = 'worker'
}

/** aggregate stddev on columns */
export type Django_Celery_Results_Taskresult_Stddev_Fields = {
  __typename?: 'django_celery_results_taskresult_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Django_Celery_Results_Taskresult_Stddev_Pop_Fields = {
  __typename?: 'django_celery_results_taskresult_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Django_Celery_Results_Taskresult_Stddev_Samp_Fields = {
  __typename?: 'django_celery_results_taskresult_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "django_celery_results_taskresult" */
export type Django_Celery_Results_Taskresult_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Celery_Results_Taskresult_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Celery_Results_Taskresult_Stream_Cursor_Value_Input = {
  content_encoding?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Scalars['String']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_done?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['String']>;
  periodic_task_name?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  task_args?: InputMaybe<Scalars['String']>;
  task_id?: InputMaybe<Scalars['String']>;
  task_kwargs?: InputMaybe<Scalars['String']>;
  task_name?: InputMaybe<Scalars['String']>;
  traceback?: InputMaybe<Scalars['String']>;
  worker?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Django_Celery_Results_Taskresult_Sum_Fields = {
  __typename?: 'django_celery_results_taskresult_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Django_Celery_Results_Taskresult_Var_Pop_Fields = {
  __typename?: 'django_celery_results_taskresult_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Django_Celery_Results_Taskresult_Var_Samp_Fields = {
  __typename?: 'django_celery_results_taskresult_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Django_Celery_Results_Taskresult_Variance_Fields = {
  __typename?: 'django_celery_results_taskresult_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "django_content_type" */
export type Django_Content_Type = {
  __typename?: 'django_content_type';
  app_label: Scalars['String'];
  id: Scalars['Int'];
  model: Scalars['String'];
};

/** aggregated selection of "django_content_type" */
export type Django_Content_Type_Aggregate = {
  __typename?: 'django_content_type_aggregate';
  aggregate?: Maybe<Django_Content_Type_Aggregate_Fields>;
  nodes: Array<Django_Content_Type>;
};

/** aggregate fields of "django_content_type" */
export type Django_Content_Type_Aggregate_Fields = {
  __typename?: 'django_content_type_aggregate_fields';
  avg?: Maybe<Django_Content_Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Django_Content_Type_Max_Fields>;
  min?: Maybe<Django_Content_Type_Min_Fields>;
  stddev?: Maybe<Django_Content_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Django_Content_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Django_Content_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Django_Content_Type_Sum_Fields>;
  var_pop?: Maybe<Django_Content_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Django_Content_Type_Var_Samp_Fields>;
  variance?: Maybe<Django_Content_Type_Variance_Fields>;
};


/** aggregate fields of "django_content_type" */
export type Django_Content_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Django_Content_Type_Avg_Fields = {
  __typename?: 'django_content_type_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "django_content_type". All fields are combined with a logical 'AND'. */
export type Django_Content_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Django_Content_Type_Bool_Exp>>;
  _not?: InputMaybe<Django_Content_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Django_Content_Type_Bool_Exp>>;
  app_label?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "django_content_type" */
export enum Django_Content_Type_Constraint {
  /** unique or primary key constraint on columns "model", "app_label" */
  DjangoContentTypeAppLabelModel_76bd3d3bUniq = 'django_content_type_app_label_model_76bd3d3b_uniq',
  /** unique or primary key constraint on columns "id" */
  DjangoContentTypePkey = 'django_content_type_pkey'
}

/** input type for incrementing numeric columns in table "django_content_type" */
export type Django_Content_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "django_content_type" */
export type Django_Content_Type_Insert_Input = {
  app_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Django_Content_Type_Max_Fields = {
  __typename?: 'django_content_type_max_fields';
  app_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Django_Content_Type_Min_Fields = {
  __typename?: 'django_content_type_min_fields';
  app_label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "django_content_type" */
export type Django_Content_Type_Mutation_Response = {
  __typename?: 'django_content_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Django_Content_Type>;
};

/** input type for inserting object relation for remote table "django_content_type" */
export type Django_Content_Type_Obj_Rel_Insert_Input = {
  data: Django_Content_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};

/** on_conflict condition type for table "django_content_type" */
export type Django_Content_Type_On_Conflict = {
  constraint: Django_Content_Type_Constraint;
  update_columns?: Array<Django_Content_Type_Update_Column>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "django_content_type". */
export type Django_Content_Type_Order_By = {
  app_label?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
};

/** primary key columns input for table: django_content_type */
export type Django_Content_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "django_content_type" */
export enum Django_Content_Type_Select_Column {
  /** column name */
  AppLabel = 'app_label',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model'
}

/** input type for updating data in table "django_content_type" */
export type Django_Content_Type_Set_Input = {
  app_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Django_Content_Type_Stddev_Fields = {
  __typename?: 'django_content_type_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Django_Content_Type_Stddev_Pop_Fields = {
  __typename?: 'django_content_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Django_Content_Type_Stddev_Samp_Fields = {
  __typename?: 'django_content_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "django_content_type" */
export type Django_Content_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Django_Content_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Django_Content_Type_Stream_Cursor_Value_Input = {
  app_label?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Django_Content_Type_Sum_Fields = {
  __typename?: 'django_content_type_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "django_content_type" */
export enum Django_Content_Type_Update_Column {
  /** column name */
  AppLabel = 'app_label',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model'
}

export type Django_Content_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  where: Django_Content_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Django_Content_Type_Var_Pop_Fields = {
  __typename?: 'django_content_type_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Django_Content_Type_Var_Samp_Fields = {
  __typename?: 'django_content_type_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Django_Content_Type_Variance_Fields = {
  __typename?: 'django_content_type_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "document" */
export type Document = {
  __typename?: 'document';
  /** An array relationship */
  attachments: Array<Document_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Document_Attachments_Aggregate;
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  document_data: Array<Document_Data>;
  /** An aggregate relationship */
  document_data_aggregate: Document_Data_Aggregate;
  document_kind_id: Scalars['Int'];
  entity_data?: Maybe<Scalars['JSONString']>;
  financial_year_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  id_number: Scalars['String'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  issued_by: Scalars['String'];
  /** An object relationship */
  kind: Document_Kind;
  notes?: Maybe<Scalars['String']>;
  object_id: Scalars['Int'];
  /** An array relationship */
  org_team_user_bank_associations: Array<Org_Team_User_Bank_Association>;
  /** An aggregate relationship */
  org_team_user_bank_associations_aggregate: Org_Team_User_Bank_Association_Aggregate;
  /** An array relationship */
  org_team_user_document_associations: Array<Org_Team_User_Document_Association>;
  /** An aggregate relationship */
  org_team_user_document_associations_aggregate: Org_Team_User_Document_Association_Aggregate;
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_till?: Maybe<Scalars['date']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "document" */
export type DocumentAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_DataArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentOrg_Team_User_Bank_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentOrg_Team_User_Bank_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentOrg_Team_User_Document_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentOrg_Team_User_Document_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};

/** aggregated selection of "document" */
export type Document_Aggregate = {
  __typename?: 'document_aggregate';
  aggregate?: Maybe<Document_Aggregate_Fields>;
  nodes: Array<Document>;
};

/** aggregate fields of "document" */
export type Document_Aggregate_Fields = {
  __typename?: 'document_aggregate_fields';
  avg?: Maybe<Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Max_Fields>;
  min?: Maybe<Document_Min_Fields>;
  stddev?: Maybe<Document_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Sum_Fields>;
  var_pop?: Maybe<Document_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Var_Samp_Fields>;
  variance?: Maybe<Document_Variance_Fields>;
};


/** aggregate fields of "document" */
export type Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document" */
export type Document_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Max_Order_By>;
  min?: InputMaybe<Document_Min_Order_By>;
  stddev?: InputMaybe<Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Variance_Order_By>;
};

/** columns and relationships of "document_attachments" */
export type Document_Attachments = {
  __typename?: 'document_attachments';
  /** An object relationship */
  attachment: Media;
  /** An object relationship */
  document: Document;
  document_id: Scalars['Int'];
  id: Scalars['Int'];
  media_id: Scalars['Int'];
};

/** aggregated selection of "document_attachments" */
export type Document_Attachments_Aggregate = {
  __typename?: 'document_attachments_aggregate';
  aggregate?: Maybe<Document_Attachments_Aggregate_Fields>;
  nodes: Array<Document_Attachments>;
};

/** aggregate fields of "document_attachments" */
export type Document_Attachments_Aggregate_Fields = {
  __typename?: 'document_attachments_aggregate_fields';
  avg?: Maybe<Document_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Attachments_Max_Fields>;
  min?: Maybe<Document_Attachments_Min_Fields>;
  stddev?: Maybe<Document_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Attachments_Sum_Fields>;
  var_pop?: Maybe<Document_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Document_Attachments_Variance_Fields>;
};


/** aggregate fields of "document_attachments" */
export type Document_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_attachments" */
export type Document_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Attachments_Max_Order_By>;
  min?: InputMaybe<Document_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Document_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "document_attachments" */
export type Document_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Document_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Document_Attachments_Avg_Fields = {
  __typename?: 'document_attachments_avg_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "document_attachments" */
export type Document_Attachments_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_attachments". All fields are combined with a logical 'AND'. */
export type Document_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Document_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Attachments_Bool_Exp>>;
  attachment?: InputMaybe<Media_Bool_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_attachments" */
export enum Document_Attachments_Constraint {
  /** unique or primary key constraint on columns "document_id", "media_id" */
  DocumentAttachmentsDocumentIdMediaId_86b65b40Uniq = 'document_attachments_document_id_media_id_86b65b40_uniq',
  /** unique or primary key constraint on columns "id" */
  DocumentAttachmentsPkey = 'document_attachments_pkey'
}

/** input type for incrementing numeric columns in table "document_attachments" */
export type Document_Attachments_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_attachments" */
export type Document_Attachments_Insert_Input = {
  attachment?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Document_Attachments_Max_Fields = {
  __typename?: 'document_attachments_max_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "document_attachments" */
export type Document_Attachments_Max_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Attachments_Min_Fields = {
  __typename?: 'document_attachments_min_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "document_attachments" */
export type Document_Attachments_Min_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "document_attachments" */
export type Document_Attachments_Mutation_Response = {
  __typename?: 'document_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Attachments>;
};

/** on_conflict condition type for table "document_attachments" */
export type Document_Attachments_On_Conflict = {
  constraint: Document_Attachments_Constraint;
  update_columns?: Array<Document_Attachments_Update_Column>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "document_attachments". */
export type Document_Attachments_Order_By = {
  attachment?: InputMaybe<Media_Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_attachments */
export type Document_Attachments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document_attachments" */
export enum Document_Attachments_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id'
}

/** input type for updating data in table "document_attachments" */
export type Document_Attachments_Set_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Document_Attachments_Stddev_Fields = {
  __typename?: 'document_attachments_stddev_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "document_attachments" */
export type Document_Attachments_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Attachments_Stddev_Pop_Fields = {
  __typename?: 'document_attachments_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "document_attachments" */
export type Document_Attachments_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Attachments_Stddev_Samp_Fields = {
  __typename?: 'document_attachments_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "document_attachments" */
export type Document_Attachments_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "document_attachments" */
export type Document_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Attachments_Stream_Cursor_Value_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Document_Attachments_Sum_Fields = {
  __typename?: 'document_attachments_sum_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "document_attachments" */
export type Document_Attachments_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** update columns of table "document_attachments" */
export enum Document_Attachments_Update_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id'
}

export type Document_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Attachments_Set_Input>;
  where: Document_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Attachments_Var_Pop_Fields = {
  __typename?: 'document_attachments_var_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "document_attachments" */
export type Document_Attachments_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Attachments_Var_Samp_Fields = {
  __typename?: 'document_attachments_var_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "document_attachments" */
export type Document_Attachments_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Attachments_Variance_Fields = {
  __typename?: 'document_attachments_variance_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "document_attachments" */
export type Document_Attachments_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Document_Avg_Fields = {
  __typename?: 'document_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  financial_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "document" */
export type Document_Avg_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Bool_Exp>>;
  attachments?: InputMaybe<Document_Attachments_Bool_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  document_data?: InputMaybe<Document_Data_Bool_Exp>;
  document_kind_id?: InputMaybe<Int_Comparison_Exp>;
  financial_year_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  id_number?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  issued_by?: InputMaybe<String_Comparison_Exp>;
  kind?: InputMaybe<Document_Kind_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_till?: InputMaybe<Date_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "document" */
export enum Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentPkey = 'document_pkey'
}

/** columns and relationships of "document_data" */
export type Document_Data = {
  __typename?: 'document_data';
  created_at: Scalars['timestamptz'];
  data_field_id: Scalars['Int'];
  document_id: Scalars['Int'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  value: Scalars['String'];
};

/** aggregated selection of "document_data" */
export type Document_Data_Aggregate = {
  __typename?: 'document_data_aggregate';
  aggregate?: Maybe<Document_Data_Aggregate_Fields>;
  nodes: Array<Document_Data>;
};

/** aggregate fields of "document_data" */
export type Document_Data_Aggregate_Fields = {
  __typename?: 'document_data_aggregate_fields';
  avg?: Maybe<Document_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Data_Max_Fields>;
  min?: Maybe<Document_Data_Min_Fields>;
  stddev?: Maybe<Document_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Data_Sum_Fields>;
  var_pop?: Maybe<Document_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Data_Var_Samp_Fields>;
  variance?: Maybe<Document_Data_Variance_Fields>;
};


/** aggregate fields of "document_data" */
export type Document_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_data" */
export type Document_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Data_Max_Order_By>;
  min?: InputMaybe<Document_Data_Min_Order_By>;
  stddev?: InputMaybe<Document_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Data_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "document_data" */
export type Document_Data_Arr_Rel_Insert_Input = {
  data: Array<Document_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Document_Data_Avg_Fields = {
  __typename?: 'document_data_avg_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "document_data" */
export type Document_Data_Avg_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_data". All fields are combined with a logical 'AND'. */
export type Document_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Data_Bool_Exp>>;
  _not?: InputMaybe<Document_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Data_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_field_id?: InputMaybe<Int_Comparison_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_data" */
export enum Document_Data_Constraint {
  /** unique or primary key constraint on columns "document_id", "data_field_id", "value" */
  DocumentDataDocumentIdDataFieldIdValueD675ef4eUniq = 'document_data_document_id_data_field_id_value_d675ef4e_uniq',
  /** unique or primary key constraint on columns "id" */
  DocumentDataPkey = 'document_data_pkey'
}

/** input type for incrementing numeric columns in table "document_data" */
export type Document_Data_Inc_Input = {
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_data" */
export type Document_Data_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Data_Max_Fields = {
  __typename?: 'document_data_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_field_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "document_data" */
export type Document_Data_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Data_Min_Fields = {
  __typename?: 'document_data_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  data_field_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "document_data" */
export type Document_Data_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "document_data" */
export type Document_Data_Mutation_Response = {
  __typename?: 'document_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Data>;
};

/** on_conflict condition type for table "document_data" */
export type Document_Data_On_Conflict = {
  constraint: Document_Data_Constraint;
  update_columns?: Array<Document_Data_Update_Column>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "document_data". */
export type Document_Data_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_data */
export type Document_Data_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document_data" */
export enum Document_Data_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFieldId = 'data_field_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "document_data" */
export type Document_Data_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Document_Data_Stddev_Fields = {
  __typename?: 'document_data_stddev_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "document_data" */
export type Document_Data_Stddev_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Data_Stddev_Pop_Fields = {
  __typename?: 'document_data_stddev_pop_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "document_data" */
export type Document_Data_Stddev_Pop_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Data_Stddev_Samp_Fields = {
  __typename?: 'document_data_stddev_samp_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "document_data" */
export type Document_Data_Stddev_Samp_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "document_data" */
export type Document_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Data_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_field_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Document_Data_Sum_Fields = {
  __typename?: 'document_data_sum_fields';
  data_field_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "document_data" */
export type Document_Data_Sum_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "document_data" */
export enum Document_Data_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataFieldId = 'data_field_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Document_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Data_Set_Input>;
  where: Document_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Data_Var_Pop_Fields = {
  __typename?: 'document_data_var_pop_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "document_data" */
export type Document_Data_Var_Pop_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Data_Var_Samp_Fields = {
  __typename?: 'document_data_var_samp_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "document_data" */
export type Document_Data_Var_Samp_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Data_Variance_Fields = {
  __typename?: 'document_data_variance_fields';
  data_field_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "document_data" */
export type Document_Data_Variance_Order_By = {
  data_field_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "document_export_log" */
export type Document_Export_Log = {
  __typename?: 'document_export_log';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  document: Document_Report;
  document_id: Scalars['bigint'];
  export_url: Scalars['String'];
  exported_at: Scalars['timestamptz'];
  exported_by_id: Scalars['String'];
  id: Scalars['bigint'];
  /** An array relationship */
  inspection_report_logs: Array<Pallet_Inspection_Reports>;
  /** An aggregate relationship */
  inspection_report_logs_aggregate: Pallet_Inspection_Reports_Aggregate;
  /** An array relationship */
  result_export_logs: Array<Result>;
  /** An aggregate relationship */
  result_export_logs_aggregate: Result_Aggregate;
  /** An object relationship */
  revision: Document_Revision;
  revision_id: Scalars['bigint'];
  uid: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "document_export_log" */
export type Document_Export_LogInspection_Report_LogsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


/** columns and relationships of "document_export_log" */
export type Document_Export_LogInspection_Report_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


/** columns and relationships of "document_export_log" */
export type Document_Export_LogResult_Export_LogsArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


/** columns and relationships of "document_export_log" */
export type Document_Export_LogResult_Export_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};

/** aggregated selection of "document_export_log" */
export type Document_Export_Log_Aggregate = {
  __typename?: 'document_export_log_aggregate';
  aggregate?: Maybe<Document_Export_Log_Aggregate_Fields>;
  nodes: Array<Document_Export_Log>;
};

/** aggregate fields of "document_export_log" */
export type Document_Export_Log_Aggregate_Fields = {
  __typename?: 'document_export_log_aggregate_fields';
  avg?: Maybe<Document_Export_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Export_Log_Max_Fields>;
  min?: Maybe<Document_Export_Log_Min_Fields>;
  stddev?: Maybe<Document_Export_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Export_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Export_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Export_Log_Sum_Fields>;
  var_pop?: Maybe<Document_Export_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Export_Log_Var_Samp_Fields>;
  variance?: Maybe<Document_Export_Log_Variance_Fields>;
};


/** aggregate fields of "document_export_log" */
export type Document_Export_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Export_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_export_log" */
export type Document_Export_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Export_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Export_Log_Max_Order_By>;
  min?: InputMaybe<Document_Export_Log_Min_Order_By>;
  stddev?: InputMaybe<Document_Export_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Export_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Export_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Export_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Export_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Export_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Export_Log_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "document_export_log" */
export type Document_Export_Log_Arr_Rel_Insert_Input = {
  data: Array<Document_Export_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Export_Log_On_Conflict>;
};

/** aggregate avg on columns */
export type Document_Export_Log_Avg_Fields = {
  __typename?: 'document_export_log_avg_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "document_export_log" */
export type Document_Export_Log_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_export_log". All fields are combined with a logical 'AND'. */
export type Document_Export_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Export_Log_Bool_Exp>>;
  _not?: InputMaybe<Document_Export_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Export_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Document_Report_Bool_Exp>;
  document_id?: InputMaybe<Bigint_Comparison_Exp>;
  export_url?: InputMaybe<String_Comparison_Exp>;
  exported_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exported_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  inspection_report_logs?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
  result_export_logs?: InputMaybe<Result_Bool_Exp>;
  revision?: InputMaybe<Document_Revision_Bool_Exp>;
  revision_id?: InputMaybe<Bigint_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_export_log" */
export enum Document_Export_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentExportLogPkey = 'document_export_log_pkey',
  /** unique or primary key constraint on columns "uid" */
  DocumentExportLogUidKey = 'document_export_log_uid_key'
}

/** input type for incrementing numeric columns in table "document_export_log" */
export type Document_Export_Log_Inc_Input = {
  document_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  revision_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "document_export_log" */
export type Document_Export_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Document_Report_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['bigint']>;
  export_url?: InputMaybe<Scalars['String']>;
  exported_at?: InputMaybe<Scalars['timestamptz']>;
  exported_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection_report_logs?: InputMaybe<Pallet_Inspection_Reports_Arr_Rel_Insert_Input>;
  result_export_logs?: InputMaybe<Result_Arr_Rel_Insert_Input>;
  revision?: InputMaybe<Document_Revision_Obj_Rel_Insert_Input>;
  revision_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Document_Export_Log_Max_Fields = {
  __typename?: 'document_export_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['bigint']>;
  export_url?: Maybe<Scalars['String']>;
  exported_at?: Maybe<Scalars['timestamptz']>;
  exported_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  revision_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "document_export_log" */
export type Document_Export_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  export_url?: InputMaybe<Order_By>;
  exported_at?: InputMaybe<Order_By>;
  exported_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Export_Log_Min_Fields = {
  __typename?: 'document_export_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['bigint']>;
  export_url?: Maybe<Scalars['String']>;
  exported_at?: Maybe<Scalars['timestamptz']>;
  exported_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  revision_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "document_export_log" */
export type Document_Export_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  export_url?: InputMaybe<Order_By>;
  exported_at?: InputMaybe<Order_By>;
  exported_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "document_export_log" */
export type Document_Export_Log_Mutation_Response = {
  __typename?: 'document_export_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Export_Log>;
};

/** input type for inserting object relation for remote table "document_export_log" */
export type Document_Export_Log_Obj_Rel_Insert_Input = {
  data: Document_Export_Log_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Export_Log_On_Conflict>;
};

/** on_conflict condition type for table "document_export_log" */
export type Document_Export_Log_On_Conflict = {
  constraint: Document_Export_Log_Constraint;
  update_columns?: Array<Document_Export_Log_Update_Column>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "document_export_log". */
export type Document_Export_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Report_Order_By>;
  document_id?: InputMaybe<Order_By>;
  export_url?: InputMaybe<Order_By>;
  exported_at?: InputMaybe<Order_By>;
  exported_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_report_logs_aggregate?: InputMaybe<Pallet_Inspection_Reports_Aggregate_Order_By>;
  result_export_logs_aggregate?: InputMaybe<Result_Aggregate_Order_By>;
  revision?: InputMaybe<Document_Revision_Order_By>;
  revision_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_export_log */
export type Document_Export_Log_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "document_export_log" */
export enum Document_Export_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  ExportUrl = 'export_url',
  /** column name */
  ExportedAt = 'exported_at',
  /** column name */
  ExportedById = 'exported_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RevisionId = 'revision_id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "document_export_log" */
export type Document_Export_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_id?: InputMaybe<Scalars['bigint']>;
  export_url?: InputMaybe<Scalars['String']>;
  exported_at?: InputMaybe<Scalars['timestamptz']>;
  exported_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  revision_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Document_Export_Log_Stddev_Fields = {
  __typename?: 'document_export_log_stddev_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "document_export_log" */
export type Document_Export_Log_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Export_Log_Stddev_Pop_Fields = {
  __typename?: 'document_export_log_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "document_export_log" */
export type Document_Export_Log_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Export_Log_Stddev_Samp_Fields = {
  __typename?: 'document_export_log_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "document_export_log" */
export type Document_Export_Log_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "document_export_log" */
export type Document_Export_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Export_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Export_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document_id?: InputMaybe<Scalars['bigint']>;
  export_url?: InputMaybe<Scalars['String']>;
  exported_at?: InputMaybe<Scalars['timestamptz']>;
  exported_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  revision_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Document_Export_Log_Sum_Fields = {
  __typename?: 'document_export_log_sum_fields';
  document_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  revision_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "document_export_log" */
export type Document_Export_Log_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** update columns of table "document_export_log" */
export enum Document_Export_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  ExportUrl = 'export_url',
  /** column name */
  ExportedAt = 'exported_at',
  /** column name */
  ExportedById = 'exported_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  RevisionId = 'revision_id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Document_Export_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Export_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Export_Log_Set_Input>;
  where: Document_Export_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Export_Log_Var_Pop_Fields = {
  __typename?: 'document_export_log_var_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "document_export_log" */
export type Document_Export_Log_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Export_Log_Var_Samp_Fields = {
  __typename?: 'document_export_log_var_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "document_export_log" */
export type Document_Export_Log_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Export_Log_Variance_Fields = {
  __typename?: 'document_export_log_variance_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "document_export_log" */
export type Document_Export_Log_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "document" */
export type Document_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  financial_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document" */
export type Document_Insert_Input = {
  attachments?: InputMaybe<Document_Attachments_Arr_Rel_Insert_Input>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_data?: InputMaybe<Document_Data_Arr_Rel_Insert_Input>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  financial_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  issued_by?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Document_Kind_Obj_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Arr_Rel_Insert_Input>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Arr_Rel_Insert_Input>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_till?: InputMaybe<Scalars['date']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "document_kind" */
export type Document_Kind = {
  __typename?: 'document_kind';
  /** An object relationship */
  allowed_content_type: Django_Content_Type;
  allowed_content_type_id: Scalars['Int'];
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  document_number_field_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_multiple: Scalars['Boolean'];
  minimum_attachments?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An array relationship */
  org_user_group_mandatory_documents: Array<Org_User_Group_Mandatory_Document>;
  /** An aggregate relationship */
  org_user_group_mandatory_documents_aggregate: Org_User_Group_Mandatory_Document_Aggregate;
  sequence_no: Scalars['Int'];
  uid?: Maybe<Scalars['String']>;
};


/** columns and relationships of "document_kind" */
export type Document_KindOrg_User_Group_Mandatory_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


/** columns and relationships of "document_kind" */
export type Document_KindOrg_User_Group_Mandatory_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};

/** aggregated selection of "document_kind" */
export type Document_Kind_Aggregate = {
  __typename?: 'document_kind_aggregate';
  aggregate?: Maybe<Document_Kind_Aggregate_Fields>;
  nodes: Array<Document_Kind>;
};

/** aggregate fields of "document_kind" */
export type Document_Kind_Aggregate_Fields = {
  __typename?: 'document_kind_aggregate_fields';
  avg?: Maybe<Document_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Kind_Max_Fields>;
  min?: Maybe<Document_Kind_Min_Fields>;
  stddev?: Maybe<Document_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Kind_Sum_Fields>;
  var_pop?: Maybe<Document_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Kind_Var_Samp_Fields>;
  variance?: Maybe<Document_Kind_Variance_Fields>;
};


/** aggregate fields of "document_kind" */
export type Document_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Kind_Avg_Fields = {
  __typename?: 'document_kind_avg_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  document_number_field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "document_kind". All fields are combined with a logical 'AND'. */
export type Document_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Kind_Bool_Exp>>;
  _not?: InputMaybe<Document_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Kind_Bool_Exp>>;
  allowed_content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  allowed_content_type_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  document_number_field_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_multiple?: InputMaybe<Boolean_Comparison_Exp>;
  minimum_attachments?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_user_group_mandatory_documents?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
  sequence_no?: InputMaybe<Int_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_kind" */
export enum Document_Kind_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DocumentKindCodenameKey = 'document_kind_codename_key',
  /** unique or primary key constraint on columns "id" */
  DocumentKindPkey = 'document_kind_pkey',
  /** unique or primary key constraint on columns "uid" */
  DocumentKindUidKey = 'document_kind_uid_key'
}

/** columns and relationships of "document_kind_data_field" */
export type Document_Kind_Data_Field = {
  __typename?: 'document_kind_data_field';
  /** An object relationship */
  document_kind: Document_Kind;
  document_kind_id: Scalars['Int'];
  field_type: Scalars['String'];
  id: Scalars['Int'];
  input_type: Scalars['String'];
  is_active: Scalars['Boolean'];
  is_applicable_to_all: Scalars['Boolean'];
  is_mandatory: Scalars['Boolean'];
  key: Scalars['String'];
  length: Scalars['Int'];
  metadata: Scalars['jsonb'];
  private_metadata: Scalars['jsonb'];
  regx?: Maybe<Scalars['String']>;
  sequence_no: Scalars['Int'];
  title: Scalars['String'];
  to_include_in_summary: Scalars['Boolean'];
};


/** columns and relationships of "document_kind_data_field" */
export type Document_Kind_Data_FieldMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "document_kind_data_field" */
export type Document_Kind_Data_FieldPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "document_kind_data_field" */
export type Document_Kind_Data_Field_Aggregate = {
  __typename?: 'document_kind_data_field_aggregate';
  aggregate?: Maybe<Document_Kind_Data_Field_Aggregate_Fields>;
  nodes: Array<Document_Kind_Data_Field>;
};

/** aggregate fields of "document_kind_data_field" */
export type Document_Kind_Data_Field_Aggregate_Fields = {
  __typename?: 'document_kind_data_field_aggregate_fields';
  avg?: Maybe<Document_Kind_Data_Field_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Kind_Data_Field_Max_Fields>;
  min?: Maybe<Document_Kind_Data_Field_Min_Fields>;
  stddev?: Maybe<Document_Kind_Data_Field_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Kind_Data_Field_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Kind_Data_Field_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Kind_Data_Field_Sum_Fields>;
  var_pop?: Maybe<Document_Kind_Data_Field_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Kind_Data_Field_Var_Samp_Fields>;
  variance?: Maybe<Document_Kind_Data_Field_Variance_Fields>;
};


/** aggregate fields of "document_kind_data_field" */
export type Document_Kind_Data_Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Kind_Data_Field_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Document_Kind_Data_Field_Avg_Fields = {
  __typename?: 'document_kind_data_field_avg_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "document_kind_data_field". All fields are combined with a logical 'AND'. */
export type Document_Kind_Data_Field_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Kind_Data_Field_Bool_Exp>>;
  _not?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Kind_Data_Field_Bool_Exp>>;
  document_kind?: InputMaybe<Document_Kind_Bool_Exp>;
  document_kind_id?: InputMaybe<Int_Comparison_Exp>;
  field_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  input_type?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_applicable_to_all?: InputMaybe<Boolean_Comparison_Exp>;
  is_mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  length?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  regx?: InputMaybe<String_Comparison_Exp>;
  sequence_no?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  to_include_in_summary?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_kind_data_field" */
export enum Document_Kind_Data_Field_Constraint {
  /** unique or primary key constraint on columns "key", "document_kind_id" */
  DocumentKindDataFieldDocumentKindIdKey_0df7d8c3Uniq = 'document_kind_data_field_document_kind_id_key_0df7d8c3_uniq',
  /** unique or primary key constraint on columns "id" */
  DocumentKindDataFieldPkey = 'document_kind_data_field_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Kind_Data_Field_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Kind_Data_Field_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Kind_Data_Field_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document_kind_data_field" */
export type Document_Kind_Data_Field_Inc_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  length?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_kind_data_field" */
export type Document_Kind_Data_Field_Insert_Input = {
  document_kind?: InputMaybe<Document_Kind_Obj_Rel_Insert_Input>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  field_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applicable_to_all?: InputMaybe<Scalars['Boolean']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  regx?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  to_include_in_summary?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Document_Kind_Data_Field_Max_Fields = {
  __typename?: 'document_kind_data_field_max_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  field_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  input_type?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Int']>;
  regx?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Kind_Data_Field_Min_Fields = {
  __typename?: 'document_kind_data_field_min_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  field_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  input_type?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Int']>;
  regx?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_kind_data_field" */
export type Document_Kind_Data_Field_Mutation_Response = {
  __typename?: 'document_kind_data_field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Kind_Data_Field>;
};

/** on_conflict condition type for table "document_kind_data_field" */
export type Document_Kind_Data_Field_On_Conflict = {
  constraint: Document_Kind_Data_Field_Constraint;
  update_columns?: Array<Document_Kind_Data_Field_Update_Column>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};

/** Ordering options when selecting data from "document_kind_data_field". */
export type Document_Kind_Data_Field_Order_By = {
  document_kind?: InputMaybe<Document_Kind_Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_type?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_applicable_to_all?: InputMaybe<Order_By>;
  is_mandatory?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  regx?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  to_include_in_summary?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_kind_data_field */
export type Document_Kind_Data_Field_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Kind_Data_Field_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "document_kind_data_field" */
export enum Document_Kind_Data_Field_Select_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Id = 'id',
  /** column name */
  InputType = 'input_type',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApplicableToAll = 'is_applicable_to_all',
  /** column name */
  IsMandatory = 'is_mandatory',
  /** column name */
  Key = 'key',
  /** column name */
  Length = 'length',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Regx = 'regx',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  Title = 'title',
  /** column name */
  ToIncludeInSummary = 'to_include_in_summary'
}

/** input type for updating data in table "document_kind_data_field" */
export type Document_Kind_Data_Field_Set_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  field_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applicable_to_all?: InputMaybe<Scalars['Boolean']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  regx?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  to_include_in_summary?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Document_Kind_Data_Field_Stddev_Fields = {
  __typename?: 'document_kind_data_field_stddev_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Kind_Data_Field_Stddev_Pop_Fields = {
  __typename?: 'document_kind_data_field_stddev_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Kind_Data_Field_Stddev_Samp_Fields = {
  __typename?: 'document_kind_data_field_stddev_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "document_kind_data_field" */
export type Document_Kind_Data_Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Kind_Data_Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Kind_Data_Field_Stream_Cursor_Value_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  field_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  input_type?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_applicable_to_all?: InputMaybe<Scalars['Boolean']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  regx?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  to_include_in_summary?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Document_Kind_Data_Field_Sum_Fields = {
  __typename?: 'document_kind_data_field_sum_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  length?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** update columns of table "document_kind_data_field" */
export enum Document_Kind_Data_Field_Update_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Id = 'id',
  /** column name */
  InputType = 'input_type',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsApplicableToAll = 'is_applicable_to_all',
  /** column name */
  IsMandatory = 'is_mandatory',
  /** column name */
  Key = 'key',
  /** column name */
  Length = 'length',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Regx = 'regx',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  Title = 'title',
  /** column name */
  ToIncludeInSummary = 'to_include_in_summary'
}

export type Document_Kind_Data_Field_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Kind_Data_Field_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Kind_Data_Field_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Kind_Data_Field_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Kind_Data_Field_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Kind_Data_Field_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Kind_Data_Field_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Kind_Data_Field_Set_Input>;
  where: Document_Kind_Data_Field_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Kind_Data_Field_Var_Pop_Fields = {
  __typename?: 'document_kind_data_field_var_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Kind_Data_Field_Var_Samp_Fields = {
  __typename?: 'document_kind_data_field_var_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Kind_Data_Field_Variance_Fields = {
  __typename?: 'document_kind_data_field_variance_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "document_kind" */
export type Document_Kind_Inc_Input = {
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  document_number_field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "document_kind" */
export type Document_Kind_Insert_Input = {
  allowed_content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  document_number_field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_multiple?: InputMaybe<Scalars['Boolean']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  org_user_group_mandatory_documents?: InputMaybe<Org_User_Group_Mandatory_Document_Arr_Rel_Insert_Input>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Kind_Max_Fields = {
  __typename?: 'document_kind_max_fields';
  allowed_content_type_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document_number_field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  minimum_attachments?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Kind_Min_Fields = {
  __typename?: 'document_kind_min_fields';
  allowed_content_type_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document_number_field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  minimum_attachments?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['Int']>;
  uid?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_kind" */
export type Document_Kind_Mutation_Response = {
  __typename?: 'document_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Kind>;
};

/** input type for inserting object relation for remote table "document_kind" */
export type Document_Kind_Obj_Rel_Insert_Input = {
  data: Document_Kind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Kind_On_Conflict>;
};

/** on_conflict condition type for table "document_kind" */
export type Document_Kind_On_Conflict = {
  constraint: Document_Kind_Constraint;
  update_columns?: Array<Document_Kind_Update_Column>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "document_kind". */
export type Document_Kind_Order_By = {
  allowed_content_type?: InputMaybe<Django_Content_Type_Order_By>;
  allowed_content_type_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_number_field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_multiple?: InputMaybe<Order_By>;
  minimum_attachments?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_user_group_mandatory_documents_aggregate?: InputMaybe<Org_User_Group_Mandatory_Document_Aggregate_Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_kind */
export type Document_Kind_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "document_kind" */
export enum Document_Kind_Select_Column {
  /** column name */
  AllowedContentTypeId = 'allowed_content_type_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentNumberFieldId = 'document_number_field_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMultiple = 'is_multiple',
  /** column name */
  MinimumAttachments = 'minimum_attachments',
  /** column name */
  Name = 'name',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  Uid = 'uid'
}

/** input type for updating data in table "document_kind" */
export type Document_Kind_Set_Input = {
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  document_number_field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_multiple?: InputMaybe<Scalars['Boolean']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Document_Kind_Stddev_Fields = {
  __typename?: 'document_kind_stddev_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  document_number_field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Kind_Stddev_Pop_Fields = {
  __typename?: 'document_kind_stddev_pop_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  document_number_field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Kind_Stddev_Samp_Fields = {
  __typename?: 'document_kind_stddev_samp_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  document_number_field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "document_kind" */
export type Document_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Kind_Stream_Cursor_Value_Input = {
  allowed_content_type_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  document_number_field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_multiple?: InputMaybe<Scalars['Boolean']>;
  minimum_attachments?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Document_Kind_Sum_Fields = {
  __typename?: 'document_kind_sum_fields';
  allowed_content_type_id?: Maybe<Scalars['Int']>;
  document_number_field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  minimum_attachments?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** update columns of table "document_kind" */
export enum Document_Kind_Update_Column {
  /** column name */
  AllowedContentTypeId = 'allowed_content_type_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentNumberFieldId = 'document_number_field_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMultiple = 'is_multiple',
  /** column name */
  MinimumAttachments = 'minimum_attachments',
  /** column name */
  Name = 'name',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  Uid = 'uid'
}

export type Document_Kind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Kind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Kind_Set_Input>;
  where: Document_Kind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Kind_Var_Pop_Fields = {
  __typename?: 'document_kind_var_pop_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  document_number_field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Kind_Var_Samp_Fields = {
  __typename?: 'document_kind_var_samp_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  document_number_field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Kind_Variance_Fields = {
  __typename?: 'document_kind_variance_fields';
  allowed_content_type_id?: Maybe<Scalars['Float']>;
  document_number_field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  minimum_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Document_Max_Fields = {
  __typename?: 'document_max_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  document_kind_id?: Maybe<Scalars['Int']>;
  financial_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  id_number?: Maybe<Scalars['String']>;
  issued_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  object_id?: Maybe<Scalars['Int']>;
  remarks?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_till?: Maybe<Scalars['date']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "document" */
export type Document_Max_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_number?: InputMaybe<Order_By>;
  issued_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Min_Fields = {
  __typename?: 'document_min_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  document_kind_id?: Maybe<Scalars['Int']>;
  financial_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  id_number?: Maybe<Scalars['String']>;
  issued_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  object_id?: Maybe<Scalars['Int']>;
  remarks?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  valid_from?: Maybe<Scalars['date']>;
  valid_till?: Maybe<Scalars['date']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "document" */
export type Document_Min_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_number?: InputMaybe<Order_By>;
  issued_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "document" */
export type Document_Mutation_Response = {
  __typename?: 'document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document>;
};

/** input type for inserting object relation for remote table "document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** on_conflict condition type for table "document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** Ordering options when selecting data from "document". */
export type Document_Order_By = {
  attachments_aggregate?: InputMaybe<Document_Attachments_Aggregate_Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_data_aggregate?: InputMaybe<Document_Data_Aggregate_Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_number?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  issued_by?: InputMaybe<Order_By>;
  kind?: InputMaybe<Document_Kind_Order_By>;
  notes?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  org_team_user_bank_associations_aggregate?: InputMaybe<Org_Team_User_Bank_Association_Aggregate_Order_By>;
  org_team_user_document_associations_aggregate?: InputMaybe<Org_Team_User_Document_Association_Aggregate_Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document */
export type Document_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "document_report" */
export type Document_Report = {
  __typename?: 'document_report';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  /** An array relationship */
  export_logs: Array<Document_Export_Log>;
  /** An aggregate relationship */
  export_logs_aggregate: Document_Export_Log_Aggregate;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  /** An object relationship */
  revision: Document_Revision;
  revision_id: Scalars['bigint'];
  uid: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "document_report" */
export type Document_ReportExport_LogsArgs = {
  distinct_on?: InputMaybe<Array<Document_Export_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Export_Log_Order_By>>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};


/** columns and relationships of "document_report" */
export type Document_ReportExport_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Export_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Export_Log_Order_By>>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};


/** columns and relationships of "document_report" */
export type Document_ReportMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "document_report" */
export type Document_ReportPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "document_report" */
export type Document_Report_Aggregate = {
  __typename?: 'document_report_aggregate';
  aggregate?: Maybe<Document_Report_Aggregate_Fields>;
  nodes: Array<Document_Report>;
};

/** aggregate fields of "document_report" */
export type Document_Report_Aggregate_Fields = {
  __typename?: 'document_report_aggregate_fields';
  avg?: Maybe<Document_Report_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Report_Max_Fields>;
  min?: Maybe<Document_Report_Min_Fields>;
  stddev?: Maybe<Document_Report_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Report_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Report_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Report_Sum_Fields>;
  var_pop?: Maybe<Document_Report_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Report_Var_Samp_Fields>;
  variance?: Maybe<Document_Report_Variance_Fields>;
};


/** aggregate fields of "document_report" */
export type Document_Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Report_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Document_Report_Avg_Fields = {
  __typename?: 'document_report_avg_fields';
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "document_report". All fields are combined with a logical 'AND'. */
export type Document_Report_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Report_Bool_Exp>>;
  _not?: InputMaybe<Document_Report_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Report_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  export_logs?: InputMaybe<Document_Export_Log_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  revision?: InputMaybe<Document_Revision_Bool_Exp>;
  revision_id?: InputMaybe<Bigint_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_report" */
export enum Document_Report_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DocumentReportCodenameKey = 'document_report_codename_key',
  /** unique or primary key constraint on columns "id" */
  DocumentReportPkey = 'document_report_pkey',
  /** unique or primary key constraint on columns "uid" */
  DocumentReportUidKey = 'document_report_uid_key',
  /** unique or primary key constraint on columns "revision_id", "uid" */
  DocumentReportUidRevisionId_1c7919c6Uniq = 'document_report_uid_revision_id_1c7919c6_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Report_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Report_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Report_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document_report" */
export type Document_Report_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  revision_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "document_report" */
export type Document_Report_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  export_logs?: InputMaybe<Document_Export_Log_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  revision?: InputMaybe<Document_Revision_Obj_Rel_Insert_Input>;
  revision_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Document_Report_Max_Fields = {
  __typename?: 'document_report_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  revision_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Document_Report_Min_Fields = {
  __typename?: 'document_report_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  revision_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "document_report" */
export type Document_Report_Mutation_Response = {
  __typename?: 'document_report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Report>;
};

/** input type for inserting object relation for remote table "document_report" */
export type Document_Report_Obj_Rel_Insert_Input = {
  data: Document_Report_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Report_On_Conflict>;
};

/** on_conflict condition type for table "document_report" */
export type Document_Report_On_Conflict = {
  constraint: Document_Report_Constraint;
  update_columns?: Array<Document_Report_Update_Column>;
  where?: InputMaybe<Document_Report_Bool_Exp>;
};

/** Ordering options when selecting data from "document_report". */
export type Document_Report_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  export_logs_aggregate?: InputMaybe<Document_Export_Log_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  revision?: InputMaybe<Document_Revision_Order_By>;
  revision_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_report */
export type Document_Report_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Report_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "document_report" */
export enum Document_Report_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  RevisionId = 'revision_id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "document_report" */
export type Document_Report_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  revision_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Document_Report_Stddev_Fields = {
  __typename?: 'document_report_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Report_Stddev_Pop_Fields = {
  __typename?: 'document_report_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Report_Stddev_Samp_Fields = {
  __typename?: 'document_report_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "document_report" */
export type Document_Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Report_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  revision_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Document_Report_Sum_Fields = {
  __typename?: 'document_report_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  revision_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "document_report" */
export enum Document_Report_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  RevisionId = 'revision_id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Document_Report_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Report_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Report_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Report_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Report_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Report_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Report_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Report_Set_Input>;
  where: Document_Report_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Report_Var_Pop_Fields = {
  __typename?: 'document_report_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Report_Var_Samp_Fields = {
  __typename?: 'document_report_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Report_Variance_Fields = {
  __typename?: 'document_report_variance_fields';
  id?: Maybe<Scalars['Float']>;
  revision_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "document_revision" */
export type Document_Revision = {
  __typename?: 'document_revision';
  codename: Scalars['String'];
  content: Scalars['String'];
  content_kind: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  style: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['String'];
};

/** aggregated selection of "document_revision" */
export type Document_Revision_Aggregate = {
  __typename?: 'document_revision_aggregate';
  aggregate?: Maybe<Document_Revision_Aggregate_Fields>;
  nodes: Array<Document_Revision>;
};

/** aggregate fields of "document_revision" */
export type Document_Revision_Aggregate_Fields = {
  __typename?: 'document_revision_aggregate_fields';
  avg?: Maybe<Document_Revision_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Document_Revision_Max_Fields>;
  min?: Maybe<Document_Revision_Min_Fields>;
  stddev?: Maybe<Document_Revision_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Revision_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Revision_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Revision_Sum_Fields>;
  var_pop?: Maybe<Document_Revision_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Revision_Var_Samp_Fields>;
  variance?: Maybe<Document_Revision_Variance_Fields>;
};


/** aggregate fields of "document_revision" */
export type Document_Revision_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Revision_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Revision_Avg_Fields = {
  __typename?: 'document_revision_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "document_revision". All fields are combined with a logical 'AND'. */
export type Document_Revision_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Revision_Bool_Exp>>;
  _not?: InputMaybe<Document_Revision_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Revision_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  content_kind?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  style?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_revision" */
export enum Document_Revision_Constraint {
  /** unique or primary key constraint on columns "codename" */
  DocumentRevisionCodenameKey = 'document_revision_codename_key',
  /** unique or primary key constraint on columns "content_kind", "version" */
  DocumentRevisionContentKindVersion_55a70dceUniq = 'document_revision_content_kind_version_55a70dce_uniq',
  /** unique or primary key constraint on columns "id" */
  DocumentRevisionPkey = 'document_revision_pkey'
}

/** input type for incrementing numeric columns in table "document_revision" */
export type Document_Revision_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "document_revision" */
export type Document_Revision_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  content_kind?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Document_Revision_Max_Fields = {
  __typename?: 'document_revision_max_fields';
  codename?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  content_kind?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Revision_Min_Fields = {
  __typename?: 'document_revision_min_fields';
  codename?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  content_kind?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "document_revision" */
export type Document_Revision_Mutation_Response = {
  __typename?: 'document_revision_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Revision>;
};

/** input type for inserting object relation for remote table "document_revision" */
export type Document_Revision_Obj_Rel_Insert_Input = {
  data: Document_Revision_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Revision_On_Conflict>;
};

/** on_conflict condition type for table "document_revision" */
export type Document_Revision_On_Conflict = {
  constraint: Document_Revision_Constraint;
  update_columns?: Array<Document_Revision_Update_Column>;
  where?: InputMaybe<Document_Revision_Bool_Exp>;
};

/** Ordering options when selecting data from "document_revision". */
export type Document_Revision_Order_By = {
  codename?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_kind?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  style?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_revision */
export type Document_Revision_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "document_revision" */
export enum Document_Revision_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Content = 'content',
  /** column name */
  ContentKind = 'content_kind',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Style = 'style',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "document_revision" */
export type Document_Revision_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  content_kind?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Document_Revision_Stddev_Fields = {
  __typename?: 'document_revision_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Revision_Stddev_Pop_Fields = {
  __typename?: 'document_revision_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Revision_Stddev_Samp_Fields = {
  __typename?: 'document_revision_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "document_revision" */
export type Document_Revision_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Revision_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Revision_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  content_kind?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Document_Revision_Sum_Fields = {
  __typename?: 'document_revision_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "document_revision" */
export enum Document_Revision_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Content = 'content',
  /** column name */
  ContentKind = 'content_kind',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Style = 'style',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

export type Document_Revision_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Revision_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Revision_Set_Input>;
  where: Document_Revision_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Revision_Var_Pop_Fields = {
  __typename?: 'document_revision_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Revision_Var_Samp_Fields = {
  __typename?: 'document_revision_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Revision_Variance_Fields = {
  __typename?: 'document_revision_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** select columns of table "document" */
export enum Document_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  FinancialYearId = 'financial_year_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdNumber = 'id_number',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  IssuedBy = 'issued_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "document" */
export type Document_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  financial_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  issued_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_till?: InputMaybe<Scalars['date']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Document_Stddev_Fields = {
  __typename?: 'document_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  financial_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "document" */
export type Document_Stddev_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Stddev_Pop_Fields = {
  __typename?: 'document_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  financial_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "document" */
export type Document_Stddev_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Stddev_Samp_Fields = {
  __typename?: 'document_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  financial_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "document" */
export type Document_Stddev_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  financial_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  id_number?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  issued_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_till?: InputMaybe<Scalars['date']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Document_Sum_Fields = {
  __typename?: 'document_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  document_kind_id?: Maybe<Scalars['Int']>;
  financial_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "document" */
export type Document_Sum_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "document" */
export enum Document_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  FinancialYearId = 'financial_year_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdNumber = 'id_number',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  IssuedBy = 'issued_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Document_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Var_Pop_Fields = {
  __typename?: 'document_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  financial_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "document" */
export type Document_Var_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Var_Samp_Fields = {
  __typename?: 'document_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  financial_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "document" */
export type Document_Var_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Variance_Fields = {
  __typename?: 'document_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  document_kind_id?: Maybe<Scalars['Float']>;
  financial_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "document" */
export type Document_Variance_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  financial_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "address" */
export type Eagle_Address = {
  __typename?: 'eagle_address';
  address_kind: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  district: Scalars['String'];
  id: Scalars['bigint'];
  local_area: Scalars['String'];
  location: Scalars['geometry'];
  name: Scalars['String'];
  pincode: Scalars['String'];
  raw_address?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  taluka: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  village: Scalars['String'];
};

/** aggregated selection of "address" */
export type Eagle_Address_Aggregate = {
  __typename?: 'eagle_address_aggregate';
  aggregate?: Maybe<Eagle_Address_Aggregate_Fields>;
  nodes: Array<Eagle_Address>;
};

/** aggregate fields of "address" */
export type Eagle_Address_Aggregate_Fields = {
  __typename?: 'eagle_address_aggregate_fields';
  avg?: Maybe<Eagle_Address_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Eagle_Address_Max_Fields>;
  min?: Maybe<Eagle_Address_Min_Fields>;
  stddev?: Maybe<Eagle_Address_Stddev_Fields>;
  stddev_pop?: Maybe<Eagle_Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eagle_Address_Stddev_Samp_Fields>;
  sum?: Maybe<Eagle_Address_Sum_Fields>;
  var_pop?: Maybe<Eagle_Address_Var_Pop_Fields>;
  var_samp?: Maybe<Eagle_Address_Var_Samp_Fields>;
  variance?: Maybe<Eagle_Address_Variance_Fields>;
};


/** aggregate fields of "address" */
export type Eagle_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eagle_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Eagle_Address_Avg_Fields = {
  __typename?: 'eagle_address_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Eagle_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Eagle_Address_Bool_Exp>>;
  _not?: InputMaybe<Eagle_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Eagle_Address_Bool_Exp>>;
  address_kind?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  local_area?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pincode?: InputMaybe<String_Comparison_Exp>;
  raw_address?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  taluka?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  village?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Eagle_Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for incrementing numeric columns in table "address" */
export type Eagle_Address_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "address" */
export type Eagle_Address_Insert_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Eagle_Address_Max_Fields = {
  __typename?: 'eagle_address_max_fields';
  address_kind?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Eagle_Address_Min_Fields = {
  __typename?: 'eagle_address_min_fields';
  address_kind?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Eagle_Address_Mutation_Response = {
  __typename?: 'eagle_address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Eagle_Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Eagle_Address_Obj_Rel_Insert_Input = {
  data: Eagle_Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eagle_Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Eagle_Address_On_Conflict = {
  constraint: Eagle_Address_Constraint;
  update_columns?: Array<Eagle_Address_Update_Column>;
  where?: InputMaybe<Eagle_Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Eagle_Address_Order_By = {
  address_kind?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_area?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  taluka?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  village?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Eagle_Address_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "address" */
export enum Eagle_Address_Select_Column {
  /** column name */
  AddressKind = 'address_kind',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  LocalArea = 'local_area',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  State = 'state',
  /** column name */
  Taluka = 'taluka',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Village = 'village'
}

/** input type for updating data in table "address" */
export type Eagle_Address_Set_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Eagle_Address_Stddev_Fields = {
  __typename?: 'eagle_address_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Eagle_Address_Stddev_Pop_Fields = {
  __typename?: 'eagle_address_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Eagle_Address_Stddev_Samp_Fields = {
  __typename?: 'eagle_address_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "eagle_address" */
export type Eagle_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eagle_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eagle_Address_Stream_Cursor_Value_Input = {
  address_kind?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Eagle_Address_Sum_Fields = {
  __typename?: 'eagle_address_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "address" */
export enum Eagle_Address_Update_Column {
  /** column name */
  AddressKind = 'address_kind',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  LocalArea = 'local_area',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  State = 'state',
  /** column name */
  Taluka = 'taluka',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Village = 'village'
}

export type Eagle_Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eagle_Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eagle_Address_Set_Input>;
  where: Eagle_Address_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eagle_Address_Var_Pop_Fields = {
  __typename?: 'eagle_address_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Eagle_Address_Var_Samp_Fields = {
  __typename?: 'eagle_address_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Eagle_Address_Variance_Fields = {
  __typename?: 'eagle_address_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "media" */
export type Eagle_Media = {
  __typename?: 'eagle_media';
  access: Scalars['String'];
  bucket?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  is_encrypted: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  /** An object relationship */
  location?: Maybe<Eagle_Address>;
  location_id?: Maybe<Scalars['bigint']>;
  media_kind: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  result_attachments: Array<Result_Media>;
  /** An aggregate relationship */
  result_attachments_aggregate: Result_Media_Aggregate;
  /** An array relationship */
  result_observation_media: Array<Result_Observation_Attachments>;
  /** An aggregate relationship */
  result_observation_media_aggregate: Result_Observation_Attachments_Aggregate;
  /** An array relationship */
  sample_attachments: Array<Sample_Media>;
  /** An aggregate relationship */
  sample_attachments_aggregate: Sample_Media_Aggregate;
  /** An array relationship */
  sample_observation_media: Array<Sample_Observation_Attachments>;
  /** An aggregate relationship */
  sample_observation_media_aggregate: Sample_Observation_Attachments_Aggregate;
  size?: Maybe<Scalars['Int']>;
  /** An object relationship */
  thumbnail?: Maybe<Eagle_Media>;
  thumbnail_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "media" */
export type Eagle_MediaMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "media" */
export type Eagle_MediaResult_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Eagle_MediaResult_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Eagle_MediaResult_Observation_MediaArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Eagle_MediaResult_Observation_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Eagle_MediaSample_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Eagle_MediaSample_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Eagle_MediaSample_Observation_MediaArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Eagle_MediaSample_Observation_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};

/** aggregated selection of "media" */
export type Eagle_Media_Aggregate = {
  __typename?: 'eagle_media_aggregate';
  aggregate?: Maybe<Eagle_Media_Aggregate_Fields>;
  nodes: Array<Eagle_Media>;
};

/** aggregate fields of "media" */
export type Eagle_Media_Aggregate_Fields = {
  __typename?: 'eagle_media_aggregate_fields';
  avg?: Maybe<Eagle_Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Eagle_Media_Max_Fields>;
  min?: Maybe<Eagle_Media_Min_Fields>;
  stddev?: Maybe<Eagle_Media_Stddev_Fields>;
  stddev_pop?: Maybe<Eagle_Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Eagle_Media_Stddev_Samp_Fields>;
  sum?: Maybe<Eagle_Media_Sum_Fields>;
  var_pop?: Maybe<Eagle_Media_Var_Pop_Fields>;
  var_samp?: Maybe<Eagle_Media_Var_Samp_Fields>;
  variance?: Maybe<Eagle_Media_Variance_Fields>;
};


/** aggregate fields of "media" */
export type Eagle_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Eagle_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Eagle_Media_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Eagle_Media_Avg_Fields = {
  __typename?: 'eagle_media_avg_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  thumbnail_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type Eagle_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Eagle_Media_Bool_Exp>>;
  _not?: InputMaybe<Eagle_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Eagle_Media_Bool_Exp>>;
  access?: InputMaybe<String_Comparison_Exp>;
  bucket?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_encrypted?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Eagle_Address_Bool_Exp>;
  location_id?: InputMaybe<Bigint_Comparison_Exp>;
  media_kind?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  result_attachments?: InputMaybe<Result_Media_Bool_Exp>;
  result_observation_media?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
  sample_attachments?: InputMaybe<Sample_Media_Bool_Exp>;
  sample_observation_media?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  thumbnail?: InputMaybe<Eagle_Media_Bool_Exp>;
  thumbnail_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "media" */
export enum Eagle_Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  MediaPkey = 'media_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Eagle_Media_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Eagle_Media_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Eagle_Media_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "media" */
export type Eagle_Media_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "media" */
export type Eagle_Media_Insert_Input = {
  access?: InputMaybe<Scalars['String']>;
  bucket?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Eagle_Address_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['bigint']>;
  media_kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  result_attachments?: InputMaybe<Result_Media_Arr_Rel_Insert_Input>;
  result_observation_media?: InputMaybe<Result_Observation_Attachments_Arr_Rel_Insert_Input>;
  sample_attachments?: InputMaybe<Sample_Media_Arr_Rel_Insert_Input>;
  sample_observation_media?: InputMaybe<Sample_Observation_Attachments_Arr_Rel_Insert_Input>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  thumbnail_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Eagle_Media_Max_Fields = {
  __typename?: 'eagle_media_max_fields';
  access?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  key?: Maybe<Scalars['String']>;
  location_id?: Maybe<Scalars['bigint']>;
  media_kind?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  thumbnail_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Eagle_Media_Min_Fields = {
  __typename?: 'eagle_media_min_fields';
  access?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  key?: Maybe<Scalars['String']>;
  location_id?: Maybe<Scalars['bigint']>;
  media_kind?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  thumbnail_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "media" */
export type Eagle_Media_Mutation_Response = {
  __typename?: 'eagle_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Eagle_Media>;
};

/** input type for inserting object relation for remote table "media" */
export type Eagle_Media_Obj_Rel_Insert_Input = {
  data: Eagle_Media_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Eagle_Media_On_Conflict>;
};

/** on_conflict condition type for table "media" */
export type Eagle_Media_On_Conflict = {
  constraint: Eagle_Media_Constraint;
  update_columns?: Array<Eagle_Media_Update_Column>;
  where?: InputMaybe<Eagle_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "media". */
export type Eagle_Media_Order_By = {
  access?: InputMaybe<Order_By>;
  bucket?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_encrypted?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  location?: InputMaybe<Eagle_Address_Order_By>;
  location_id?: InputMaybe<Order_By>;
  media_kind?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  result_attachments_aggregate?: InputMaybe<Result_Media_Aggregate_Order_By>;
  result_observation_media_aggregate?: InputMaybe<Result_Observation_Attachments_Aggregate_Order_By>;
  sample_attachments_aggregate?: InputMaybe<Sample_Media_Aggregate_Order_By>;
  sample_observation_media_aggregate?: InputMaybe<Sample_Observation_Attachments_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Eagle_Media_Order_By>;
  thumbnail_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: media */
export type Eagle_Media_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Eagle_Media_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "media" */
export enum Eagle_Media_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  Bucket = 'bucket',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  Key = 'key',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MediaKind = 'media_kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Size = 'size',
  /** column name */
  ThumbnailId = 'thumbnail_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "media" */
export type Eagle_Media_Set_Input = {
  access?: InputMaybe<Scalars['String']>;
  bucket?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  location_id?: InputMaybe<Scalars['bigint']>;
  media_kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Eagle_Media_Stddev_Fields = {
  __typename?: 'eagle_media_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  thumbnail_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Eagle_Media_Stddev_Pop_Fields = {
  __typename?: 'eagle_media_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  thumbnail_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Eagle_Media_Stddev_Samp_Fields = {
  __typename?: 'eagle_media_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  thumbnail_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "eagle_media" */
export type Eagle_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Eagle_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Eagle_Media_Stream_Cursor_Value_Input = {
  access?: InputMaybe<Scalars['String']>;
  bucket?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  location_id?: InputMaybe<Scalars['bigint']>;
  media_kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Eagle_Media_Sum_Fields = {
  __typename?: 'eagle_media_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['Int']>;
  thumbnail_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "media" */
export enum Eagle_Media_Update_Column {
  /** column name */
  Access = 'access',
  /** column name */
  Bucket = 'bucket',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  Key = 'key',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MediaKind = 'media_kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Size = 'size',
  /** column name */
  ThumbnailId = 'thumbnail_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export type Eagle_Media_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Eagle_Media_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Eagle_Media_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Eagle_Media_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Eagle_Media_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Eagle_Media_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Eagle_Media_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Eagle_Media_Set_Input>;
  where: Eagle_Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Eagle_Media_Var_Pop_Fields = {
  __typename?: 'eagle_media_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  thumbnail_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Eagle_Media_Var_Samp_Fields = {
  __typename?: 'eagle_media_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  thumbnail_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Eagle_Media_Variance_Fields = {
  __typename?: 'eagle_media_variance_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  thumbnail_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "entity_state" */
export type Entity_State = {
  __typename?: 'entity_state';
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  current_state: State;
  id: Scalars['bigint'];
  object_id: Scalars['Int'];
  state_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workflow: Workflow;
  workflow_id: Scalars['bigint'];
};

/** aggregated selection of "entity_state" */
export type Entity_State_Aggregate = {
  __typename?: 'entity_state_aggregate';
  aggregate?: Maybe<Entity_State_Aggregate_Fields>;
  nodes: Array<Entity_State>;
};

/** aggregate fields of "entity_state" */
export type Entity_State_Aggregate_Fields = {
  __typename?: 'entity_state_aggregate_fields';
  avg?: Maybe<Entity_State_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Entity_State_Max_Fields>;
  min?: Maybe<Entity_State_Min_Fields>;
  stddev?: Maybe<Entity_State_Stddev_Fields>;
  stddev_pop?: Maybe<Entity_State_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Entity_State_Stddev_Samp_Fields>;
  sum?: Maybe<Entity_State_Sum_Fields>;
  var_pop?: Maybe<Entity_State_Var_Pop_Fields>;
  var_samp?: Maybe<Entity_State_Var_Samp_Fields>;
  variance?: Maybe<Entity_State_Variance_Fields>;
};


/** aggregate fields of "entity_state" */
export type Entity_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_state" */
export type Entity_State_Aggregate_Order_By = {
  avg?: InputMaybe<Entity_State_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entity_State_Max_Order_By>;
  min?: InputMaybe<Entity_State_Min_Order_By>;
  stddev?: InputMaybe<Entity_State_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Entity_State_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Entity_State_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Entity_State_Sum_Order_By>;
  var_pop?: InputMaybe<Entity_State_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Entity_State_Var_Samp_Order_By>;
  variance?: InputMaybe<Entity_State_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "entity_state" */
export type Entity_State_Arr_Rel_Insert_Input = {
  data: Array<Entity_State_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_State_On_Conflict>;
};

/** aggregate avg on columns */
export type Entity_State_Avg_Fields = {
  __typename?: 'entity_state_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "entity_state" */
export type Entity_State_Avg_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entity_state". All fields are combined with a logical 'AND'. */
export type Entity_State_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_State_Bool_Exp>>;
  _not?: InputMaybe<Entity_State_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_State_Bool_Exp>>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_state?: InputMaybe<State_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  state_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workflow?: InputMaybe<Workflow_Bool_Exp>;
  workflow_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_state" */
export enum Entity_State_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityStatePkey = 'entity_state_pkey',
  /** unique or primary key constraint on columns "content_type_id", "workflow_id", "state_id", "object_id" */
  EntityStateWorkflowIdContentType_7d9072a0Uniq = 'entity_state_workflow_id_content_type_7d9072a0_uniq'
}

/** input type for incrementing numeric columns in table "entity_state" */
export type Entity_State_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['bigint']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "entity_state" */
export type Entity_State_Insert_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow?: InputMaybe<Workflow_Obj_Rel_Insert_Input>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Entity_State_Max_Fields = {
  __typename?: 'entity_state_max_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  object_id?: Maybe<Scalars['Int']>;
  state_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "entity_state" */
export type Entity_State_Max_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Entity_State_Min_Fields = {
  __typename?: 'entity_state_min_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  object_id?: Maybe<Scalars['Int']>;
  state_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "entity_state" */
export type Entity_State_Min_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_state" */
export type Entity_State_Mutation_Response = {
  __typename?: 'entity_state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_State>;
};

/** on_conflict condition type for table "entity_state" */
export type Entity_State_On_Conflict = {
  constraint: Entity_State_Constraint;
  update_columns?: Array<Entity_State_Update_Column>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_state". */
export type Entity_State_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_state?: InputMaybe<State_Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow?: InputMaybe<Workflow_Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_state */
export type Entity_State_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "entity_state" */
export enum Entity_State_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  StateId = 'state_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "entity_state" */
export type Entity_State_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Entity_State_Stddev_Fields = {
  __typename?: 'entity_state_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "entity_state" */
export type Entity_State_Stddev_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Entity_State_Stddev_Pop_Fields = {
  __typename?: 'entity_state_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "entity_state" */
export type Entity_State_Stddev_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Entity_State_Stddev_Samp_Fields = {
  __typename?: 'entity_state_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "entity_state" */
export type Entity_State_Stddev_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entity_state" */
export type Entity_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_State_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Entity_State_Sum_Fields = {
  __typename?: 'entity_state_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  object_id?: Maybe<Scalars['Int']>;
  state_id?: Maybe<Scalars['bigint']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "entity_state" */
export type Entity_State_Sum_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** update columns of table "entity_state" */
export enum Entity_State_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  StateId = 'state_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

export type Entity_State_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Entity_State_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_State_Set_Input>;
  where: Entity_State_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Entity_State_Var_Pop_Fields = {
  __typename?: 'entity_state_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "entity_state" */
export type Entity_State_Var_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Entity_State_Var_Samp_Fields = {
  __typename?: 'entity_state_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "entity_state" */
export type Entity_State_Var_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Entity_State_Variance_Fields = {
  __typename?: 'entity_state_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "entity_state" */
export type Entity_State_Variance_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "evaluation_criteria" */
export type Evaluation_Criteria = {
  __typename?: 'evaluation_criteria';
  created_at: Scalars['timestamptz'];
  criteria: Scalars['String'];
  id: Scalars['bigint'];
  /** An array relationship */
  parameter_configurations: Array<Template_Parameter_Config>;
  /** An aggregate relationship */
  parameter_configurations_aggregate: Template_Parameter_Config_Aggregate;
  result: Scalars['Boolean'];
  /** An object relationship */
  tag: Evaluation_Tag;
  tag_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "evaluation_criteria" */
export type Evaluation_CriteriaParameter_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


/** columns and relationships of "evaluation_criteria" */
export type Evaluation_CriteriaParameter_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};

/** aggregated selection of "evaluation_criteria" */
export type Evaluation_Criteria_Aggregate = {
  __typename?: 'evaluation_criteria_aggregate';
  aggregate?: Maybe<Evaluation_Criteria_Aggregate_Fields>;
  nodes: Array<Evaluation_Criteria>;
};

/** aggregate fields of "evaluation_criteria" */
export type Evaluation_Criteria_Aggregate_Fields = {
  __typename?: 'evaluation_criteria_aggregate_fields';
  avg?: Maybe<Evaluation_Criteria_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Evaluation_Criteria_Max_Fields>;
  min?: Maybe<Evaluation_Criteria_Min_Fields>;
  stddev?: Maybe<Evaluation_Criteria_Stddev_Fields>;
  stddev_pop?: Maybe<Evaluation_Criteria_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Evaluation_Criteria_Stddev_Samp_Fields>;
  sum?: Maybe<Evaluation_Criteria_Sum_Fields>;
  var_pop?: Maybe<Evaluation_Criteria_Var_Pop_Fields>;
  var_samp?: Maybe<Evaluation_Criteria_Var_Samp_Fields>;
  variance?: Maybe<Evaluation_Criteria_Variance_Fields>;
};


/** aggregate fields of "evaluation_criteria" */
export type Evaluation_Criteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Evaluation_Criteria_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Evaluation_Criteria_Avg_Fields = {
  __typename?: 'evaluation_criteria_avg_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "evaluation_criteria". All fields are combined with a logical 'AND'. */
export type Evaluation_Criteria_Bool_Exp = {
  _and?: InputMaybe<Array<Evaluation_Criteria_Bool_Exp>>;
  _not?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
  _or?: InputMaybe<Array<Evaluation_Criteria_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  criteria?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parameter_configurations?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
  result?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<Evaluation_Tag_Bool_Exp>;
  tag_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "evaluation_criteria" */
export enum Evaluation_Criteria_Constraint {
  /** unique or primary key constraint on columns "id" */
  EvaluationCriteriaPkey = 'evaluation_criteria_pkey',
  /** unique or primary key constraint on columns "tag_id", "criteria", "result" */
  EvaluationCriteriaTagIdCriteriaResult_7af1425bUniq = 'evaluation_criteria_tag_id_criteria_result_7af1425b_uniq'
}

/** input type for incrementing numeric columns in table "evaluation_criteria" */
export type Evaluation_Criteria_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  tag_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "evaluation_criteria" */
export type Evaluation_Criteria_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  criteria?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  parameter_configurations?: InputMaybe<Template_Parameter_Config_Arr_Rel_Insert_Input>;
  result?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Evaluation_Tag_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Evaluation_Criteria_Max_Fields = {
  __typename?: 'evaluation_criteria_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  criteria?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Evaluation_Criteria_Min_Fields = {
  __typename?: 'evaluation_criteria_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  criteria?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "evaluation_criteria" */
export type Evaluation_Criteria_Mutation_Response = {
  __typename?: 'evaluation_criteria_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Evaluation_Criteria>;
};

/** input type for inserting object relation for remote table "evaluation_criteria" */
export type Evaluation_Criteria_Obj_Rel_Insert_Input = {
  data: Evaluation_Criteria_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Evaluation_Criteria_On_Conflict>;
};

/** on_conflict condition type for table "evaluation_criteria" */
export type Evaluation_Criteria_On_Conflict = {
  constraint: Evaluation_Criteria_Constraint;
  update_columns?: Array<Evaluation_Criteria_Update_Column>;
  where?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
};

/** Ordering options when selecting data from "evaluation_criteria". */
export type Evaluation_Criteria_Order_By = {
  created_at?: InputMaybe<Order_By>;
  criteria?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter_configurations_aggregate?: InputMaybe<Template_Parameter_Config_Aggregate_Order_By>;
  result?: InputMaybe<Order_By>;
  tag?: InputMaybe<Evaluation_Tag_Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: evaluation_criteria */
export type Evaluation_Criteria_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "evaluation_criteria" */
export enum Evaluation_Criteria_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Criteria = 'criteria',
  /** column name */
  Id = 'id',
  /** column name */
  Result = 'result',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "evaluation_criteria" */
export type Evaluation_Criteria_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  criteria?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  result?: InputMaybe<Scalars['Boolean']>;
  tag_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Evaluation_Criteria_Stddev_Fields = {
  __typename?: 'evaluation_criteria_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Evaluation_Criteria_Stddev_Pop_Fields = {
  __typename?: 'evaluation_criteria_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Evaluation_Criteria_Stddev_Samp_Fields = {
  __typename?: 'evaluation_criteria_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "evaluation_criteria" */
export type Evaluation_Criteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Evaluation_Criteria_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Evaluation_Criteria_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  criteria?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  result?: InputMaybe<Scalars['Boolean']>;
  tag_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Evaluation_Criteria_Sum_Fields = {
  __typename?: 'evaluation_criteria_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "evaluation_criteria" */
export enum Evaluation_Criteria_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Criteria = 'criteria',
  /** column name */
  Id = 'id',
  /** column name */
  Result = 'result',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Evaluation_Criteria_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Evaluation_Criteria_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Evaluation_Criteria_Set_Input>;
  where: Evaluation_Criteria_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Evaluation_Criteria_Var_Pop_Fields = {
  __typename?: 'evaluation_criteria_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Evaluation_Criteria_Var_Samp_Fields = {
  __typename?: 'evaluation_criteria_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Evaluation_Criteria_Variance_Fields = {
  __typename?: 'evaluation_criteria_variance_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "evaluation_tag" */
export type Evaluation_Tag = {
  __typename?: 'evaluation_tag';
  codename: Scalars['String'];
  color_code: Scalars['String'];
  company_id?: Maybe<Scalars['bigint']>;
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  sequence: Scalars['Int'];
};

/** aggregated selection of "evaluation_tag" */
export type Evaluation_Tag_Aggregate = {
  __typename?: 'evaluation_tag_aggregate';
  aggregate?: Maybe<Evaluation_Tag_Aggregate_Fields>;
  nodes: Array<Evaluation_Tag>;
};

/** aggregate fields of "evaluation_tag" */
export type Evaluation_Tag_Aggregate_Fields = {
  __typename?: 'evaluation_tag_aggregate_fields';
  avg?: Maybe<Evaluation_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Evaluation_Tag_Max_Fields>;
  min?: Maybe<Evaluation_Tag_Min_Fields>;
  stddev?: Maybe<Evaluation_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Evaluation_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Evaluation_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Evaluation_Tag_Sum_Fields>;
  var_pop?: Maybe<Evaluation_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Evaluation_Tag_Var_Samp_Fields>;
  variance?: Maybe<Evaluation_Tag_Variance_Fields>;
};


/** aggregate fields of "evaluation_tag" */
export type Evaluation_Tag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Evaluation_Tag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Evaluation_Tag_Avg_Fields = {
  __typename?: 'evaluation_tag_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "evaluation_tag". All fields are combined with a logical 'AND'. */
export type Evaluation_Tag_Bool_Exp = {
  _and?: InputMaybe<Array<Evaluation_Tag_Bool_Exp>>;
  _not?: InputMaybe<Evaluation_Tag_Bool_Exp>;
  _or?: InputMaybe<Array<Evaluation_Tag_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  color_code?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "evaluation_tag" */
export enum Evaluation_Tag_Constraint {
  /** unique or primary key constraint on columns "codename" */
  EvaluationTagCodenameKey = 'evaluation_tag_codename_key',
  /** unique or primary key constraint on columns "id" */
  EvaluationTagPkey = 'evaluation_tag_pkey'
}

/** input type for incrementing numeric columns in table "evaluation_tag" */
export type Evaluation_Tag_Inc_Input = {
  company_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "evaluation_tag" */
export type Evaluation_Tag_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  color_code?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Evaluation_Tag_Max_Fields = {
  __typename?: 'evaluation_tag_max_fields';
  codename?: Maybe<Scalars['String']>;
  color_code?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Evaluation_Tag_Min_Fields = {
  __typename?: 'evaluation_tag_min_fields';
  codename?: Maybe<Scalars['String']>;
  color_code?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "evaluation_tag" */
export type Evaluation_Tag_Mutation_Response = {
  __typename?: 'evaluation_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Evaluation_Tag>;
};

/** input type for inserting object relation for remote table "evaluation_tag" */
export type Evaluation_Tag_Obj_Rel_Insert_Input = {
  data: Evaluation_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Evaluation_Tag_On_Conflict>;
};

/** on_conflict condition type for table "evaluation_tag" */
export type Evaluation_Tag_On_Conflict = {
  constraint: Evaluation_Tag_Constraint;
  update_columns?: Array<Evaluation_Tag_Update_Column>;
  where?: InputMaybe<Evaluation_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "evaluation_tag". */
export type Evaluation_Tag_Order_By = {
  codename?: InputMaybe<Order_By>;
  color_code?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** primary key columns input for table: evaluation_tag */
export type Evaluation_Tag_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "evaluation_tag" */
export enum Evaluation_Tag_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ColorCode = 'color_code',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Sequence = 'sequence'
}

/** input type for updating data in table "evaluation_tag" */
export type Evaluation_Tag_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  color_code?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Evaluation_Tag_Stddev_Fields = {
  __typename?: 'evaluation_tag_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Evaluation_Tag_Stddev_Pop_Fields = {
  __typename?: 'evaluation_tag_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Evaluation_Tag_Stddev_Samp_Fields = {
  __typename?: 'evaluation_tag_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "evaluation_tag" */
export type Evaluation_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Evaluation_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Evaluation_Tag_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  color_code?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Evaluation_Tag_Sum_Fields = {
  __typename?: 'evaluation_tag_sum_fields';
  company_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  sequence?: Maybe<Scalars['Int']>;
};

/** update columns of table "evaluation_tag" */
export enum Evaluation_Tag_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ColorCode = 'color_code',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Sequence = 'sequence'
}

export type Evaluation_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Evaluation_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Evaluation_Tag_Set_Input>;
  where: Evaluation_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Evaluation_Tag_Var_Pop_Fields = {
  __typename?: 'evaluation_tag_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Evaluation_Tag_Var_Samp_Fields = {
  __typename?: 'evaluation_tag_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Evaluation_Tag_Variance_Fields = {
  __typename?: 'evaluation_tag_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "expense" */
export type Expense = {
  __typename?: 'expense';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  expense_parameter: Expense_Parameter;
  expense_parameter_id: Scalars['bigint'];
  id: Scalars['bigint'];
  kind: Scalars['String'];
  paid_by: Scalars['String'];
  /** An object relationship */
  receipt?: Maybe<Receipt>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['numeric'];
};

/** aggregated selection of "expense" */
export type Expense_Aggregate = {
  __typename?: 'expense_aggregate';
  aggregate?: Maybe<Expense_Aggregate_Fields>;
  nodes: Array<Expense>;
};

/** aggregate fields of "expense" */
export type Expense_Aggregate_Fields = {
  __typename?: 'expense_aggregate_fields';
  avg?: Maybe<Expense_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Expense_Max_Fields>;
  min?: Maybe<Expense_Min_Fields>;
  stddev?: Maybe<Expense_Stddev_Fields>;
  stddev_pop?: Maybe<Expense_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Expense_Stddev_Samp_Fields>;
  sum?: Maybe<Expense_Sum_Fields>;
  var_pop?: Maybe<Expense_Var_Pop_Fields>;
  var_samp?: Maybe<Expense_Var_Samp_Fields>;
  variance?: Maybe<Expense_Variance_Fields>;
};


/** aggregate fields of "expense" */
export type Expense_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expense_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "expense" */
export type Expense_Aggregate_Order_By = {
  avg?: InputMaybe<Expense_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Expense_Max_Order_By>;
  min?: InputMaybe<Expense_Min_Order_By>;
  stddev?: InputMaybe<Expense_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Expense_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Expense_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Expense_Sum_Order_By>;
  var_pop?: InputMaybe<Expense_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Expense_Var_Samp_Order_By>;
  variance?: InputMaybe<Expense_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "expense" */
export type Expense_Arr_Rel_Insert_Input = {
  data: Array<Expense_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Expense_On_Conflict>;
};

/** aggregate avg on columns */
export type Expense_Avg_Fields = {
  __typename?: 'expense_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "expense" */
export type Expense_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "expense". All fields are combined with a logical 'AND'. */
export type Expense_Bool_Exp = {
  _and?: InputMaybe<Array<Expense_Bool_Exp>>;
  _not?: InputMaybe<Expense_Bool_Exp>;
  _or?: InputMaybe<Array<Expense_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  expense_parameter?: InputMaybe<Expense_Parameter_Bool_Exp>;
  expense_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  paid_by?: InputMaybe<String_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "expense" */
export enum Expense_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExpensePkey = 'expense_pkey'
}

/** input type for incrementing numeric columns in table "expense" */
export type Expense_Inc_Input = {
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "expense" */
export type Expense_Insert_Input = {
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  receipt?: InputMaybe<Receipt_Obj_Rel_Insert_Input>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Expense_Max_Fields = {
  __typename?: 'expense_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "expense" */
export type Expense_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Expense_Min_Fields = {
  __typename?: 'expense_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  paid_by?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "expense" */
export type Expense_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "expense" */
export type Expense_Mutation_Response = {
  __typename?: 'expense_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Expense>;
};

/** on_conflict condition type for table "expense" */
export type Expense_On_Conflict = {
  constraint: Expense_Constraint;
  update_columns?: Array<Expense_Update_Column>;
  where?: InputMaybe<Expense_Bool_Exp>;
};

/** Ordering options when selecting data from "expense". */
export type Expense_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter?: InputMaybe<Expense_Parameter_Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "expense_parameter" */
export type Expense_Parameter = {
  __typename?: 'expense_parameter';
  codename: Scalars['String'];
  description: Scalars['String'];
  /** An array relationship */
  expenses: Array<Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Expense_Aggregate;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};


/** columns and relationships of "expense_parameter" */
export type Expense_ParameterExpensesArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "expense_parameter" */
export type Expense_ParameterExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "expense_parameter". All fields are combined with a logical 'AND'. */
export type Expense_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Expense_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Expense_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Expense_Parameter_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expenses?: InputMaybe<Expense_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "expense_parameter". */
export type Expense_Parameter_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expenses_aggregate?: InputMaybe<Expense_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "expense_parameter" */
export enum Expense_Parameter_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "expense_parameter" */
export type Expense_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expense_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expense_Parameter_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: expense */
export type Expense_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "expense" */
export enum Expense_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  ExpenseParameterId = 'expense_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  PaidBy = 'paid_by',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "expense" */
export type Expense_Set_Input = {
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Expense_Stddev_Fields = {
  __typename?: 'expense_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "expense" */
export type Expense_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Expense_Stddev_Pop_Fields = {
  __typename?: 'expense_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "expense" */
export type Expense_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Expense_Stddev_Samp_Fields = {
  __typename?: 'expense_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "expense" */
export type Expense_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "expense" */
export type Expense_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expense_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expense_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  paid_by?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Expense_Sum_Fields = {
  __typename?: 'expense_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "expense" */
export type Expense_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "expense" */
export enum Expense_Update_Column {
  /** column name */
  ExpenseParameterId = 'expense_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  PaidBy = 'paid_by',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  Value = 'value'
}

export type Expense_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Expense_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Expense_Set_Input>;
  where: Expense_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Expense_Var_Pop_Fields = {
  __typename?: 'expense_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "expense" */
export type Expense_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Expense_Var_Samp_Fields = {
  __typename?: 'expense_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "expense" */
export type Expense_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Expense_Variance_Fields = {
  __typename?: 'expense_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "expense" */
export type Expense_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "external_application" */
export type External_Application = {
  __typename?: 'external_application';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
};


/** columns and relationships of "external_application" */
export type External_ApplicationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "external_application" */
export type External_ApplicationPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "external_application" */
export type External_Application_Aggregate = {
  __typename?: 'external_application_aggregate';
  aggregate?: Maybe<External_Application_Aggregate_Fields>;
  nodes: Array<External_Application>;
};

/** aggregate fields of "external_application" */
export type External_Application_Aggregate_Fields = {
  __typename?: 'external_application_aggregate_fields';
  avg?: Maybe<External_Application_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<External_Application_Max_Fields>;
  min?: Maybe<External_Application_Min_Fields>;
  stddev?: Maybe<External_Application_Stddev_Fields>;
  stddev_pop?: Maybe<External_Application_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Application_Stddev_Samp_Fields>;
  sum?: Maybe<External_Application_Sum_Fields>;
  var_pop?: Maybe<External_Application_Var_Pop_Fields>;
  var_samp?: Maybe<External_Application_Var_Samp_Fields>;
  variance?: Maybe<External_Application_Variance_Fields>;
};


/** aggregate fields of "external_application" */
export type External_Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type External_Application_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type External_Application_Avg_Fields = {
  __typename?: 'external_application_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "external_application". All fields are combined with a logical 'AND'. */
export type External_Application_Bool_Exp = {
  _and?: InputMaybe<Array<External_Application_Bool_Exp>>;
  _not?: InputMaybe<External_Application_Bool_Exp>;
  _or?: InputMaybe<Array<External_Application_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "external_application" */
export enum External_Application_Constraint {
  /** unique or primary key constraint on columns "codename" */
  ExternalApplicationCodenameKey = 'external_application_codename_key',
  /** unique or primary key constraint on columns "id" */
  ExternalApplicationPkey = 'external_application_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type External_Application_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type External_Application_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type External_Application_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "external_application" */
export type External_Application_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "external_application" */
export type External_Application_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type External_Application_Max_Fields = {
  __typename?: 'external_application_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type External_Application_Min_Fields = {
  __typename?: 'external_application_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "external_application" */
export type External_Application_Mutation_Response = {
  __typename?: 'external_application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<External_Application>;
};

/** input type for inserting object relation for remote table "external_application" */
export type External_Application_Obj_Rel_Insert_Input = {
  data: External_Application_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<External_Application_On_Conflict>;
};

/** on_conflict condition type for table "external_application" */
export type External_Application_On_Conflict = {
  constraint: External_Application_Constraint;
  update_columns?: Array<External_Application_Update_Column>;
  where?: InputMaybe<External_Application_Bool_Exp>;
};

/** Ordering options when selecting data from "external_application". */
export type External_Application_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
};

/** primary key columns input for table: external_application */
export type External_Application_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type External_Application_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "external_application" */
export enum External_Application_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata'
}

/** input type for updating data in table "external_application" */
export type External_Application_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type External_Application_Stddev_Fields = {
  __typename?: 'external_application_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type External_Application_Stddev_Pop_Fields = {
  __typename?: 'external_application_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type External_Application_Stddev_Samp_Fields = {
  __typename?: 'external_application_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "external_application" */
export type External_Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Application_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type External_Application_Sum_Fields = {
  __typename?: 'external_application_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "external_application" */
export enum External_Application_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata'
}

export type External_Application_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<External_Application_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<External_Application_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<External_Application_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<External_Application_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<External_Application_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<External_Application_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<External_Application_Set_Input>;
  where: External_Application_Bool_Exp;
};

/** aggregate var_pop on columns */
export type External_Application_Var_Pop_Fields = {
  __typename?: 'external_application_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type External_Application_Var_Samp_Fields = {
  __typename?: 'external_application_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type External_Application_Variance_Fields = {
  __typename?: 'external_application_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "external_entity" */
export type External_Entity = {
  __typename?: 'external_entity';
  /** An array relationship */
  brand_companies: Array<Brand_Company>;
  /** An aggregate relationship */
  brand_companies_aggregate: Brand_Company_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  crop: Array<Crop>;
  crop_variety: Array<Crop_Variety>;
  description: Scalars['String'];
  entity_group_id?: Maybe<Scalars['bigint']>;
  entity_type: Scalars['String'];
  /** An array relationship */
  grade_companies: Array<Grade_Company>;
  /** An aggregate relationship */
  grade_companies_aggregate: Grade_Company_Aggregate;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  markets: Array<Market_Allowed_Departments>;
  /** An aggregate relationship */
  markets_aggregate: Market_Allowed_Departments_Aggregate;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  plot_crop: Array<Plot_Crop>;
  private_metadata: Scalars['jsonb'];
  reference_id: Scalars['String'];
  /** An array relationship */
  requests: Array<Request>;
  /** An aggregate relationship */
  requests_aggregate: Request_Aggregate;
  /** An array relationship */
  template_companies: Array<Template_Company>;
  /** An aggregate relationship */
  template_companies_aggregate: Template_Company_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "external_entity" */
export type External_EntityBrand_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityBrand_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp_Remote_Rel_External_Entitycrop>;
};


/** columns and relationships of "external_entity" */
export type External_EntityCrop_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp_Remote_Rel_External_Entitycrop_Variety>;
};


/** columns and relationships of "external_entity" */
export type External_EntityGrade_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityGrade_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityMarketsArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityMarkets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "external_entity" */
export type External_EntityPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp_Remote_Rel_External_Entityplot_Crop>;
};


/** columns and relationships of "external_entity" */
export type External_EntityPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "external_entity" */
export type External_EntityRequestsArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityTemplate_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


/** columns and relationships of "external_entity" */
export type External_EntityTemplate_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};

/** aggregated selection of "external_entity" */
export type External_Entity_Aggregate = {
  __typename?: 'external_entity_aggregate';
  aggregate?: Maybe<External_Entity_Aggregate_Fields>;
  nodes: Array<External_Entity>;
};

/** aggregate fields of "external_entity" */
export type External_Entity_Aggregate_Fields = {
  __typename?: 'external_entity_aggregate_fields';
  avg?: Maybe<External_Entity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<External_Entity_Max_Fields>;
  min?: Maybe<External_Entity_Min_Fields>;
  stddev?: Maybe<External_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<External_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<External_Entity_Sum_Fields>;
  var_pop?: Maybe<External_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<External_Entity_Var_Samp_Fields>;
  variance?: Maybe<External_Entity_Variance_Fields>;
};


/** aggregate fields of "external_entity" */
export type External_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type External_Entity_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type External_Entity_Avg_Fields = {
  __typename?: 'external_entity_avg_fields';
  entity_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "external_entity". All fields are combined with a logical 'AND'. */
export type External_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<External_Entity_Bool_Exp>>;
  _not?: InputMaybe<External_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<External_Entity_Bool_Exp>>;
  brand_companies?: InputMaybe<Brand_Company_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entity_group_id?: InputMaybe<Bigint_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  grade_companies?: InputMaybe<Grade_Company_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  markets?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  requests?: InputMaybe<Request_Bool_Exp>;
  template_companies?: InputMaybe<Template_Company_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "external_entity" */
export enum External_Entity_Constraint {
  /** unique or primary key constraint on columns "codename" */
  ExternalEntityCodenameKey = 'external_entity_codename_key',
  /** unique or primary key constraint on columns "reference_id", "entity_type" */
  ExternalEntityEntityTypeReferenceIdF22c5e3cUniq = 'external_entity_entity_type_reference_id_f22c5e3c_uniq',
  /** unique or primary key constraint on columns "id" */
  ExternalEntityPkey = 'external_entity_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type External_Entity_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type External_Entity_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type External_Entity_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "external_entity_group" */
export type External_Entity_Group = {
  __typename?: 'external_entity_group';
  codename: Scalars['String'];
  description: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "external_entity_group" */
export type External_Entity_Group_Aggregate = {
  __typename?: 'external_entity_group_aggregate';
  aggregate?: Maybe<External_Entity_Group_Aggregate_Fields>;
  nodes: Array<External_Entity_Group>;
};

/** aggregate fields of "external_entity_group" */
export type External_Entity_Group_Aggregate_Fields = {
  __typename?: 'external_entity_group_aggregate_fields';
  avg?: Maybe<External_Entity_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<External_Entity_Group_Max_Fields>;
  min?: Maybe<External_Entity_Group_Min_Fields>;
  stddev?: Maybe<External_Entity_Group_Stddev_Fields>;
  stddev_pop?: Maybe<External_Entity_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Entity_Group_Stddev_Samp_Fields>;
  sum?: Maybe<External_Entity_Group_Sum_Fields>;
  var_pop?: Maybe<External_Entity_Group_Var_Pop_Fields>;
  var_samp?: Maybe<External_Entity_Group_Var_Samp_Fields>;
  variance?: Maybe<External_Entity_Group_Variance_Fields>;
};


/** aggregate fields of "external_entity_group" */
export type External_Entity_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Entity_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type External_Entity_Group_Avg_Fields = {
  __typename?: 'external_entity_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "external_entity_group". All fields are combined with a logical 'AND'. */
export type External_Entity_Group_Bool_Exp = {
  _and?: InputMaybe<Array<External_Entity_Group_Bool_Exp>>;
  _not?: InputMaybe<External_Entity_Group_Bool_Exp>;
  _or?: InputMaybe<Array<External_Entity_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "external_entity_group" */
export enum External_Entity_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  ExternalEntityGroupCodenameKey = 'external_entity_group_codename_key',
  /** unique or primary key constraint on columns "name" */
  ExternalEntityGroupNameKey = 'external_entity_group_name_key',
  /** unique or primary key constraint on columns "id" */
  ExternalEntityGroupPkey = 'external_entity_group_pkey'
}

/** input type for incrementing numeric columns in table "external_entity_group" */
export type External_Entity_Group_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "external_entity_group" */
export type External_Entity_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type External_Entity_Group_Max_Fields = {
  __typename?: 'external_entity_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type External_Entity_Group_Min_Fields = {
  __typename?: 'external_entity_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "external_entity_group" */
export type External_Entity_Group_Mutation_Response = {
  __typename?: 'external_entity_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<External_Entity_Group>;
};

/** on_conflict condition type for table "external_entity_group" */
export type External_Entity_Group_On_Conflict = {
  constraint: External_Entity_Group_Constraint;
  update_columns?: Array<External_Entity_Group_Update_Column>;
  where?: InputMaybe<External_Entity_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "external_entity_group". */
export type External_Entity_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: external_entity_group */
export type External_Entity_Group_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "external_entity_group" */
export enum External_Entity_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "external_entity_group" */
export type External_Entity_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type External_Entity_Group_Stddev_Fields = {
  __typename?: 'external_entity_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type External_Entity_Group_Stddev_Pop_Fields = {
  __typename?: 'external_entity_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type External_Entity_Group_Stddev_Samp_Fields = {
  __typename?: 'external_entity_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "external_entity_group" */
export type External_Entity_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Entity_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Entity_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type External_Entity_Group_Sum_Fields = {
  __typename?: 'external_entity_group_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "external_entity_group" */
export enum External_Entity_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type External_Entity_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<External_Entity_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<External_Entity_Group_Set_Input>;
  where: External_Entity_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type External_Entity_Group_Var_Pop_Fields = {
  __typename?: 'external_entity_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type External_Entity_Group_Var_Samp_Fields = {
  __typename?: 'external_entity_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type External_Entity_Group_Variance_Fields = {
  __typename?: 'external_entity_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "external_entity" */
export type External_Entity_Inc_Input = {
  entity_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "external_entity" */
export type External_Entity_Insert_Input = {
  brand_companies?: InputMaybe<Brand_Company_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  entity_group_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  grade_companies?: InputMaybe<Grade_Company_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  markets?: InputMaybe<Market_Allowed_Departments_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  requests?: InputMaybe<Request_Arr_Rel_Insert_Input>;
  template_companies?: InputMaybe<Template_Company_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type External_Entity_Max_Fields = {
  __typename?: 'external_entity_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  entity_group_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type External_Entity_Min_Fields = {
  __typename?: 'external_entity_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  entity_group_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "external_entity" */
export type External_Entity_Mutation_Response = {
  __typename?: 'external_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<External_Entity>;
};

/** input type for inserting object relation for remote table "external_entity" */
export type External_Entity_Obj_Rel_Insert_Input = {
  data: External_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<External_Entity_On_Conflict>;
};

/** on_conflict condition type for table "external_entity" */
export type External_Entity_On_Conflict = {
  constraint: External_Entity_Constraint;
  update_columns?: Array<External_Entity_Update_Column>;
  where?: InputMaybe<External_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "external_entity". */
export type External_Entity_Order_By = {
  brand_companies_aggregate?: InputMaybe<Brand_Company_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entity_group_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  grade_companies_aggregate?: InputMaybe<Grade_Company_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  markets_aggregate?: InputMaybe<Market_Allowed_Departments_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  requests_aggregate?: InputMaybe<Request_Aggregate_Order_By>;
  template_companies_aggregate?: InputMaybe<Template_Company_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: external_entity */
export type External_Entity_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type External_Entity_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "external_entity" */
export enum External_Entity_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  EntityGroupId = 'entity_group_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "external_entity" */
export type External_Entity_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  entity_group_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type External_Entity_Stddev_Fields = {
  __typename?: 'external_entity_stddev_fields';
  entity_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type External_Entity_Stddev_Pop_Fields = {
  __typename?: 'external_entity_stddev_pop_fields';
  entity_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type External_Entity_Stddev_Samp_Fields = {
  __typename?: 'external_entity_stddev_samp_fields';
  entity_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "external_entity" */
export type External_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Entity_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  entity_group_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type External_Entity_Sum_Fields = {
  __typename?: 'external_entity_sum_fields';
  entity_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "external_entity" */
export enum External_Entity_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  EntityGroupId = 'entity_group_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type External_Entity_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<External_Entity_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<External_Entity_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<External_Entity_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<External_Entity_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<External_Entity_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<External_Entity_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<External_Entity_Set_Input>;
  where: External_Entity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type External_Entity_Var_Pop_Fields = {
  __typename?: 'external_entity_var_pop_fields';
  entity_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type External_Entity_Var_Samp_Fields = {
  __typename?: 'external_entity_var_samp_fields';
  entity_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type External_Entity_Variance_Fields = {
  __typename?: 'external_entity_variance_fields';
  entity_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "external_reference" */
export type External_Reference = {
  __typename?: 'external_reference';
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  external_app_id: Scalars['Int'];
  /** An object relationship */
  external_application: External_Application;
  id: Scalars['Int'];
  metadata: Scalars['jsonb'];
  object_id: Scalars['Int'];
  /** An object relationship */
  organisation?: Maybe<Organisation>;
  organisation_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  reference_id: Scalars['String'];
};


/** columns and relationships of "external_reference" */
export type External_ReferenceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "external_reference" */
export type External_ReferencePrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "external_reference" */
export type External_Reference_Aggregate = {
  __typename?: 'external_reference_aggregate';
  aggregate?: Maybe<External_Reference_Aggregate_Fields>;
  nodes: Array<External_Reference>;
};

/** aggregate fields of "external_reference" */
export type External_Reference_Aggregate_Fields = {
  __typename?: 'external_reference_aggregate_fields';
  avg?: Maybe<External_Reference_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<External_Reference_Max_Fields>;
  min?: Maybe<External_Reference_Min_Fields>;
  stddev?: Maybe<External_Reference_Stddev_Fields>;
  stddev_pop?: Maybe<External_Reference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Reference_Stddev_Samp_Fields>;
  sum?: Maybe<External_Reference_Sum_Fields>;
  var_pop?: Maybe<External_Reference_Var_Pop_Fields>;
  var_samp?: Maybe<External_Reference_Var_Samp_Fields>;
  variance?: Maybe<External_Reference_Variance_Fields>;
};


/** aggregate fields of "external_reference" */
export type External_Reference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type External_Reference_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type External_Reference_Avg_Fields = {
  __typename?: 'external_reference_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "external_reference". All fields are combined with a logical 'AND'. */
export type External_Reference_Bool_Exp = {
  _and?: InputMaybe<Array<External_Reference_Bool_Exp>>;
  _not?: InputMaybe<External_Reference_Bool_Exp>;
  _or?: InputMaybe<Array<External_Reference_Bool_Exp>>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  external_app_id?: InputMaybe<Int_Comparison_Exp>;
  external_application?: InputMaybe<External_Application_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "external_reference" */
export enum External_Reference_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "external_app_id", "content_type_id", "object_id" */
  ExternalReferenceOrganisationIdExternal_25a164a7Uniq = 'external_reference_organisation_id_external_25a164a7_uniq',
  /** unique or primary key constraint on columns "id" */
  ExternalReferencePkey = 'external_reference_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type External_Reference_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type External_Reference_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type External_Reference_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "external_reference" */
export type External_Reference_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "external_reference" */
export type External_Reference_Insert_Input = {
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  external_application?: InputMaybe<External_Application_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type External_Reference_Max_Fields = {
  __typename?: 'external_reference_max_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  external_app_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type External_Reference_Min_Fields = {
  __typename?: 'external_reference_min_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  external_app_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  reference_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "external_reference" */
export type External_Reference_Mutation_Response = {
  __typename?: 'external_reference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<External_Reference>;
};

/** on_conflict condition type for table "external_reference" */
export type External_Reference_On_Conflict = {
  constraint: External_Reference_Constraint;
  update_columns?: Array<External_Reference_Update_Column>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};

/** Ordering options when selecting data from "external_reference". */
export type External_Reference_Order_By = {
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  external_app_id?: InputMaybe<Order_By>;
  external_application?: InputMaybe<External_Application_Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: external_reference */
export type External_Reference_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type External_Reference_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "external_reference" */
export enum External_Reference_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  ExternalAppId = 'external_app_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id'
}

/** input type for updating data in table "external_reference" */
export type External_Reference_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type External_Reference_Stddev_Fields = {
  __typename?: 'external_reference_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type External_Reference_Stddev_Pop_Fields = {
  __typename?: 'external_reference_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type External_Reference_Stddev_Samp_Fields = {
  __typename?: 'external_reference_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "external_reference" */
export type External_Reference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Reference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Reference_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  external_app_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type External_Reference_Sum_Fields = {
  __typename?: 'external_reference_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  external_app_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "external_reference" */
export enum External_Reference_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  ExternalAppId = 'external_app_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id'
}

export type External_Reference_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<External_Reference_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<External_Reference_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<External_Reference_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<External_Reference_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<External_Reference_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<External_Reference_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<External_Reference_Set_Input>;
  where: External_Reference_Bool_Exp;
};

/** aggregate var_pop on columns */
export type External_Reference_Var_Pop_Fields = {
  __typename?: 'external_reference_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type External_Reference_Var_Samp_Fields = {
  __typename?: 'external_reference_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type External_Reference_Variance_Fields = {
  __typename?: 'external_reference_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  external_app_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "farm" */
export type Farm = {
  __typename?: 'farm';
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  /** An array relationship */
  fields: Array<Field>;
  /** An aggregate relationship */
  fields_aggregate: Field_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Farm_Network>;
  /** An aggregate relationship */
  networks_aggregate: Farm_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  private_metadata?: Maybe<Scalars['jsonb']>;
  quality_checked?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "farm" */
export type FarmDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "farm" */
export type FarmExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "farm" */
export type FarmFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "farm" */
export type FarmNetworksArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "farm" */
export type FarmPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "farm" */
export type Farm_Aggregate = {
  __typename?: 'farm_aggregate';
  aggregate?: Maybe<Farm_Aggregate_Fields>;
  nodes: Array<Farm>;
};

/** aggregate fields of "farm" */
export type Farm_Aggregate_Fields = {
  __typename?: 'farm_aggregate_fields';
  avg?: Maybe<Farm_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Farm_Max_Fields>;
  min?: Maybe<Farm_Min_Fields>;
  stddev?: Maybe<Farm_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Sum_Fields>;
  var_pop?: Maybe<Farm_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Var_Samp_Fields>;
  variance?: Maybe<Farm_Variance_Fields>;
};


/** aggregate fields of "farm" */
export type Farm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "farm" */
export type Farm_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Max_Order_By>;
  min?: InputMaybe<Farm_Min_Order_By>;
  stddev?: InputMaybe<Farm_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Farm_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "farm" */
export type Farm_Arr_Rel_Insert_Input = {
  data: Array<Farm_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};

/** aggregate avg on columns */
export type Farm_Avg_Fields = {
  __typename?: 'farm_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "farm" */
export type Farm_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm". All fields are combined with a logical 'AND'. */
export type Farm_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Bool_Exp>>;
  _not?: InputMaybe<Farm_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Farm_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "farm" */
export enum Farm_Constraint {
  /** unique or primary key constraint on columns "codename" */
  FarmCodenameKey = 'farm_codename_key',
  /** unique or primary key constraint on columns "id" */
  FarmPkey = 'farm_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Farm_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Farm_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Farm_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "farm" */
export type Farm_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "farm" */
export type Farm_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  fields?: InputMaybe<Field_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Farm_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Farm_Max_Fields = {
  __typename?: 'farm_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "farm" */
export type Farm_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Min_Fields = {
  __typename?: 'farm_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "farm" */
export type Farm_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "farm" */
export type Farm_Mutation_Response = {
  __typename?: 'farm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Farm>;
};

/** columns and relationships of "farm_network" */
export type Farm_Network = {
  __typename?: 'farm_network';
  codename: Scalars['String'];
  /** An object relationship */
  farm: Farm;
  farm_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "farm_network" */
export type Farm_Network_Aggregate = {
  __typename?: 'farm_network_aggregate';
  aggregate?: Maybe<Farm_Network_Aggregate_Fields>;
  nodes: Array<Farm_Network>;
};

/** aggregate fields of "farm_network" */
export type Farm_Network_Aggregate_Fields = {
  __typename?: 'farm_network_aggregate_fields';
  avg?: Maybe<Farm_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Farm_Network_Max_Fields>;
  min?: Maybe<Farm_Network_Min_Fields>;
  stddev?: Maybe<Farm_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Farm_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farm_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Farm_Network_Sum_Fields>;
  var_pop?: Maybe<Farm_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Farm_Network_Var_Samp_Fields>;
  variance?: Maybe<Farm_Network_Variance_Fields>;
};


/** aggregate fields of "farm_network" */
export type Farm_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farm_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "farm_network" */
export type Farm_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Farm_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Farm_Network_Max_Order_By>;
  min?: InputMaybe<Farm_Network_Min_Order_By>;
  stddev?: InputMaybe<Farm_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Farm_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Farm_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Farm_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Farm_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Farm_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Farm_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "farm_network" */
export type Farm_Network_Arr_Rel_Insert_Input = {
  data: Array<Farm_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Farm_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Farm_Network_Avg_Fields = {
  __typename?: 'farm_network_avg_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "farm_network" */
export type Farm_Network_Avg_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "farm_network". All fields are combined with a logical 'AND'. */
export type Farm_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Farm_Network_Bool_Exp>>;
  _not?: InputMaybe<Farm_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Farm_Network_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  farm?: InputMaybe<Farm_Bool_Exp>;
  farm_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "farm_network" */
export enum Farm_Network_Constraint {
  /** unique or primary key constraint on columns "network_id", "farm_id" */
  FarmNetworkNetworkIdFarmId_9abac404Uniq = 'farm_network_network_id_farm_id_9abac404_uniq',
  /** unique or primary key constraint on columns "id" */
  FarmNetworkPkey = 'farm_network_pkey'
}

/** input type for incrementing numeric columns in table "farm_network" */
export type Farm_Network_Inc_Input = {
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "farm_network" */
export type Farm_Network_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  farm?: InputMaybe<Farm_Obj_Rel_Insert_Input>;
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Farm_Network_Max_Fields = {
  __typename?: 'farm_network_max_fields';
  codename?: Maybe<Scalars['String']>;
  farm_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "farm_network" */
export type Farm_Network_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Farm_Network_Min_Fields = {
  __typename?: 'farm_network_min_fields';
  codename?: Maybe<Scalars['String']>;
  farm_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "farm_network" */
export type Farm_Network_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "farm_network" */
export type Farm_Network_Mutation_Response = {
  __typename?: 'farm_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Farm_Network>;
};

/** on_conflict condition type for table "farm_network" */
export type Farm_Network_On_Conflict = {
  constraint: Farm_Network_Constraint;
  update_columns?: Array<Farm_Network_Update_Column>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "farm_network". */
export type Farm_Network_Order_By = {
  codename?: InputMaybe<Order_By>;
  farm?: InputMaybe<Farm_Order_By>;
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farm_network */
export type Farm_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "farm_network" */
export enum Farm_Network_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "farm_network" */
export type Farm_Network_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Farm_Network_Stddev_Fields = {
  __typename?: 'farm_network_stddev_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "farm_network" */
export type Farm_Network_Stddev_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Network_Stddev_Pop_Fields = {
  __typename?: 'farm_network_stddev_pop_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "farm_network" */
export type Farm_Network_Stddev_Pop_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Network_Stddev_Samp_Fields = {
  __typename?: 'farm_network_stddev_samp_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "farm_network" */
export type Farm_Network_Stddev_Samp_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm_network" */
export type Farm_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Network_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Farm_Network_Sum_Fields = {
  __typename?: 'farm_network_sum_fields';
  farm_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "farm_network" */
export type Farm_Network_Sum_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "farm_network" */
export enum Farm_Network_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Farm_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farm_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farm_Network_Set_Input>;
  where: Farm_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farm_Network_Var_Pop_Fields = {
  __typename?: 'farm_network_var_pop_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "farm_network" */
export type Farm_Network_Var_Pop_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Network_Var_Samp_Fields = {
  __typename?: 'farm_network_var_samp_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "farm_network" */
export type Farm_Network_Var_Samp_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Network_Variance_Fields = {
  __typename?: 'farm_network_variance_fields';
  farm_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "farm_network" */
export type Farm_Network_Variance_Order_By = {
  farm_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "farm" */
export type Farm_Obj_Rel_Insert_Input = {
  data: Farm_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};

/** on_conflict condition type for table "farm" */
export type Farm_On_Conflict = {
  constraint: Farm_Constraint;
  update_columns?: Array<Farm_Update_Column>;
  where?: InputMaybe<Farm_Bool_Exp>;
};

/** Ordering options when selecting data from "farm". */
export type Farm_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  fields_aggregate?: InputMaybe<Field_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Farm_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farm */
export type Farm_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Farm_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "farm" */
export enum Farm_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "farm" */
export type Farm_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Farm_Stddev_Fields = {
  __typename?: 'farm_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "farm" */
export type Farm_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Farm_Stddev_Pop_Fields = {
  __typename?: 'farm_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "farm" */
export type Farm_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Farm_Stddev_Samp_Fields = {
  __typename?: 'farm_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "farm" */
export type Farm_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "farm" */
export type Farm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farm_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  remarks?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Farm_Sum_Fields = {
  __typename?: 'farm_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "farm" */
export type Farm_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "farm" */
export enum Farm_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Farm_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Farm_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Farm_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Farm_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Farm_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farm_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Farm_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farm_Set_Input>;
  where: Farm_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farm_Var_Pop_Fields = {
  __typename?: 'farm_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "farm" */
export type Farm_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Farm_Var_Samp_Fields = {
  __typename?: 'farm_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "farm" */
export type Farm_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Farm_Variance_Fields = {
  __typename?: 'farm_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "farm" */
export type Farm_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "field" */
export type Field = {
  __typename?: 'field';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  area: Scalars['numeric'];
  area_catered?: Maybe<Scalars['geometry']>;
  /** An object relationship */
  area_unit: Si_Unit;
  area_unit_id: Scalars['Int'];
  centroid?: Maybe<Scalars['geometry']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farm: Farm;
  farm_id: Scalars['Int'];
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  /** An array relationship */
  field_weather_locations: Array<Field_Weather_Location>;
  /** An aggregate relationship */
  field_weather_locations_aggregate: Field_Weather_Location_Aggregate;
  gat_no?: Maybe<Scalars['String']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  /** An object relationship */
  mutual_group?: Maybe<Mutual_Group>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Field_Network>;
  /** An aggregate relationship */
  networks_aggregate: Field_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  /** An array relationship */
  plots: Array<Plot>;
  /** An aggregate relationship */
  plots_aggregate: Plot_Aggregate;
  private_metadata?: Maybe<Scalars['jsonb']>;
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  region?: Maybe<Region>;
  region_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  soil: Soil;
  soil_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "field" */
export type FieldExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "field" */
export type FieldField_Weather_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldField_Weather_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "field" */
export type FieldNetworksArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldPlotsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldPlots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


/** columns and relationships of "field" */
export type FieldPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "field" */
export type Field_Aggregate = {
  __typename?: 'field_aggregate';
  aggregate?: Maybe<Field_Aggregate_Fields>;
  nodes: Array<Field>;
};

/** aggregate fields of "field" */
export type Field_Aggregate_Fields = {
  __typename?: 'field_aggregate_fields';
  avg?: Maybe<Field_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Field_Max_Fields>;
  min?: Maybe<Field_Min_Fields>;
  stddev?: Maybe<Field_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Sum_Fields>;
  var_pop?: Maybe<Field_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Var_Samp_Fields>;
  variance?: Maybe<Field_Variance_Fields>;
};


/** aggregate fields of "field" */
export type Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "field" */
export type Field_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Max_Order_By>;
  min?: InputMaybe<Field_Min_Order_By>;
  stddev?: InputMaybe<Field_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Field_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "field" */
export type Field_Arr_Rel_Insert_Input = {
  data: Array<Field_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Avg_Fields = {
  __typename?: 'field_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "field" */
export type Field_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field". All fields are combined with a logical 'AND'. */
export type Field_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Bool_Exp>>;
  _not?: InputMaybe<Field_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farm?: InputMaybe<Farm_Bool_Exp>;
  farm_id?: InputMaybe<Int_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Bool_Exp>;
  gat_no?: InputMaybe<String_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Field_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  plots?: InputMaybe<Plot_Bool_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  soil?: InputMaybe<Soil_Bool_Exp>;
  soil_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "field" */
export enum Field_Constraint {
  /** unique or primary key constraint on columns "codename" */
  FieldCodenameKey = 'field_codename_key',
  /** unique or primary key constraint on columns "id" */
  FieldPkey = 'field_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Field_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Field_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Field_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "field" */
export type Field_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "field" */
export type Field_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  centroid?: InputMaybe<Scalars['geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farm?: InputMaybe<Farm_Obj_Rel_Insert_Input>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Arr_Rel_Insert_Input>;
  gat_no?: InputMaybe<Scalars['String']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Field_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  plots?: InputMaybe<Plot_Arr_Rel_Insert_Input>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil?: InputMaybe<Soil_Obj_Rel_Insert_Input>;
  soil_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Field_Max_Fields = {
  __typename?: 'field_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farm_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  gat_no?: Maybe<Scalars['String']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  soil_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "field" */
export type Field_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  gat_no?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Min_Fields = {
  __typename?: 'field_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farm_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  gat_no?: Maybe<Scalars['String']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  soil_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "field" */
export type Field_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  gat_no?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field" */
export type Field_Mutation_Response = {
  __typename?: 'field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Field>;
};

/** columns and relationships of "field_network" */
export type Field_Network = {
  __typename?: 'field_network';
  codename: Scalars['String'];
  /** An object relationship */
  field: Field;
  field_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "field_network" */
export type Field_Network_Aggregate = {
  __typename?: 'field_network_aggregate';
  aggregate?: Maybe<Field_Network_Aggregate_Fields>;
  nodes: Array<Field_Network>;
};

/** aggregate fields of "field_network" */
export type Field_Network_Aggregate_Fields = {
  __typename?: 'field_network_aggregate_fields';
  avg?: Maybe<Field_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Field_Network_Max_Fields>;
  min?: Maybe<Field_Network_Min_Fields>;
  stddev?: Maybe<Field_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Network_Sum_Fields>;
  var_pop?: Maybe<Field_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Network_Var_Samp_Fields>;
  variance?: Maybe<Field_Network_Variance_Fields>;
};


/** aggregate fields of "field_network" */
export type Field_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "field_network" */
export type Field_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Network_Max_Order_By>;
  min?: InputMaybe<Field_Network_Min_Order_By>;
  stddev?: InputMaybe<Field_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "field_network" */
export type Field_Network_Arr_Rel_Insert_Input = {
  data: Array<Field_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Network_Avg_Fields = {
  __typename?: 'field_network_avg_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "field_network" */
export type Field_Network_Avg_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field_network". All fields are combined with a logical 'AND'. */
export type Field_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Network_Bool_Exp>>;
  _not?: InputMaybe<Field_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Network_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "field_network" */
export enum Field_Network_Constraint {
  /** unique or primary key constraint on columns "field_id", "network_id" */
  FieldNetworkNetworkIdFieldIdB222e0b4Uniq = 'field_network_network_id_field_id_b222e0b4_uniq',
  /** unique or primary key constraint on columns "id" */
  FieldNetworkPkey = 'field_network_pkey'
}

/** input type for incrementing numeric columns in table "field_network" */
export type Field_Network_Inc_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "field_network" */
export type Field_Network_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Field_Obj_Rel_Insert_Input>;
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Field_Network_Max_Fields = {
  __typename?: 'field_network_max_fields';
  codename?: Maybe<Scalars['String']>;
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "field_network" */
export type Field_Network_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Network_Min_Fields = {
  __typename?: 'field_network_min_fields';
  codename?: Maybe<Scalars['String']>;
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "field_network" */
export type Field_Network_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_network" */
export type Field_Network_Mutation_Response = {
  __typename?: 'field_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Network>;
};

/** on_conflict condition type for table "field_network" */
export type Field_Network_On_Conflict = {
  constraint: Field_Network_Constraint;
  update_columns?: Array<Field_Network_Update_Column>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "field_network". */
export type Field_Network_Order_By = {
  codename?: InputMaybe<Order_By>;
  field?: InputMaybe<Field_Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: field_network */
export type Field_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "field_network" */
export enum Field_Network_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "field_network" */
export type Field_Network_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Field_Network_Stddev_Fields = {
  __typename?: 'field_network_stddev_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "field_network" */
export type Field_Network_Stddev_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Network_Stddev_Pop_Fields = {
  __typename?: 'field_network_stddev_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "field_network" */
export type Field_Network_Stddev_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Network_Stddev_Samp_Fields = {
  __typename?: 'field_network_stddev_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "field_network" */
export type Field_Network_Stddev_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field_network" */
export type Field_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Network_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Field_Network_Sum_Fields = {
  __typename?: 'field_network_sum_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "field_network" */
export type Field_Network_Sum_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "field_network" */
export enum Field_Network_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Field_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Network_Set_Input>;
  where: Field_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Network_Var_Pop_Fields = {
  __typename?: 'field_network_var_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "field_network" */
export type Field_Network_Var_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Network_Var_Samp_Fields = {
  __typename?: 'field_network_var_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "field_network" */
export type Field_Network_Var_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Network_Variance_Fields = {
  __typename?: 'field_network_variance_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "field_network" */
export type Field_Network_Variance_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "field" */
export type Field_Obj_Rel_Insert_Input = {
  data: Field_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_On_Conflict>;
};

/** on_conflict condition type for table "field" */
export type Field_On_Conflict = {
  constraint: Field_Constraint;
  update_columns?: Array<Field_Update_Column>;
  where?: InputMaybe<Field_Bool_Exp>;
};

/** Ordering options when selecting data from "field". */
export type Field_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_catered?: InputMaybe<Order_By>;
  area_unit?: InputMaybe<Si_Unit_Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  centroid?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farm?: InputMaybe<Farm_Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_weather_locations_aggregate?: InputMaybe<Field_Weather_Location_Aggregate_Order_By>;
  gat_no?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Field_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  plots_aggregate?: InputMaybe<Plot_Aggregate_Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  region?: InputMaybe<Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil?: InputMaybe<Soil_Order_By>;
  soil_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: field */
export type Field_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Field_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "field" */
export enum Field_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GatNo = 'gat_no',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SoilId = 'soil_id',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "field" */
export type Field_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  centroid?: InputMaybe<Scalars['geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  gat_no?: InputMaybe<Scalars['String']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Field_Stddev_Fields = {
  __typename?: 'field_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "field" */
export type Field_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Stddev_Pop_Fields = {
  __typename?: 'field_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "field" */
export type Field_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Stddev_Samp_Fields = {
  __typename?: 'field_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "field" */
export type Field_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field" */
export type Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  centroid?: InputMaybe<Scalars['geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  gat_no?: InputMaybe<Scalars['String']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  soil_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Field_Sum_Fields = {
  __typename?: 'field_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farm_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  soil_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "field" */
export type Field_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "field" */
export enum Field_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmId = 'farm_id',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GatNo = 'gat_no',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SoilId = 'soil_id',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Field_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Field_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Field_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Field_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Field_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Field_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Set_Input>;
  where: Field_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Var_Pop_Fields = {
  __typename?: 'field_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "field" */
export type Field_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Var_Samp_Fields = {
  __typename?: 'field_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "field" */
export type Field_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Variance_Fields = {
  __typename?: 'field_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farm_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  soil_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "field" */
export type Field_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farm_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  soil_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "field_weather_location" */
export type Field_Weather_Location = {
  __typename?: 'field_weather_location';
  /** An object relationship */
  field?: Maybe<Field>;
  field_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  last_activated_on?: Maybe<Scalars['date']>;
  /** An object relationship */
  weather_reference?: Maybe<Weather_Reference>;
  weather_reference_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "field_weather_location" */
export type Field_Weather_Location_Aggregate = {
  __typename?: 'field_weather_location_aggregate';
  aggregate?: Maybe<Field_Weather_Location_Aggregate_Fields>;
  nodes: Array<Field_Weather_Location>;
};

/** aggregate fields of "field_weather_location" */
export type Field_Weather_Location_Aggregate_Fields = {
  __typename?: 'field_weather_location_aggregate_fields';
  avg?: Maybe<Field_Weather_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Field_Weather_Location_Max_Fields>;
  min?: Maybe<Field_Weather_Location_Min_Fields>;
  stddev?: Maybe<Field_Weather_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Weather_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Weather_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Weather_Location_Sum_Fields>;
  var_pop?: Maybe<Field_Weather_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Weather_Location_Var_Samp_Fields>;
  variance?: Maybe<Field_Weather_Location_Variance_Fields>;
};


/** aggregate fields of "field_weather_location" */
export type Field_Weather_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "field_weather_location" */
export type Field_Weather_Location_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Weather_Location_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Weather_Location_Max_Order_By>;
  min?: InputMaybe<Field_Weather_Location_Min_Order_By>;
  stddev?: InputMaybe<Field_Weather_Location_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Weather_Location_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Weather_Location_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Weather_Location_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Weather_Location_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Weather_Location_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Weather_Location_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "field_weather_location" */
export type Field_Weather_Location_Arr_Rel_Insert_Input = {
  data: Array<Field_Weather_Location_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Weather_Location_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Weather_Location_Avg_Fields = {
  __typename?: 'field_weather_location_avg_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "field_weather_location" */
export type Field_Weather_Location_Avg_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field_weather_location". All fields are combined with a logical 'AND'. */
export type Field_Weather_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Weather_Location_Bool_Exp>>;
  _not?: InputMaybe<Field_Weather_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Weather_Location_Bool_Exp>>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_activated_on?: InputMaybe<Date_Comparison_Exp>;
  weather_reference?: InputMaybe<Weather_Reference_Bool_Exp>;
  weather_reference_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "field_weather_location" */
export enum Field_Weather_Location_Constraint {
  /** unique or primary key constraint on columns "weather_reference_id", "field_id" */
  FieldWeatherLocationFieldIdWeatherReferen_36801bf1Uniq = 'field_weather_location_field_id_weather_referen_36801bf1_uniq',
  /** unique or primary key constraint on columns "id" */
  FieldWeatherLocationPkey = 'field_weather_location_pkey'
}

/** input type for incrementing numeric columns in table "field_weather_location" */
export type Field_Weather_Location_Inc_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "field_weather_location" */
export type Field_Weather_Location_Insert_Input = {
  field?: InputMaybe<Field_Obj_Rel_Insert_Input>;
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_activated_on?: InputMaybe<Scalars['date']>;
  weather_reference?: InputMaybe<Weather_Reference_Obj_Rel_Insert_Input>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Field_Weather_Location_Max_Fields = {
  __typename?: 'field_weather_location_max_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last_activated_on?: Maybe<Scalars['date']>;
  weather_reference_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "field_weather_location" */
export type Field_Weather_Location_Max_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_activated_on?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Weather_Location_Min_Fields = {
  __typename?: 'field_weather_location_min_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last_activated_on?: Maybe<Scalars['date']>;
  weather_reference_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "field_weather_location" */
export type Field_Weather_Location_Min_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_activated_on?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_weather_location" */
export type Field_Weather_Location_Mutation_Response = {
  __typename?: 'field_weather_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Weather_Location>;
};

/** on_conflict condition type for table "field_weather_location" */
export type Field_Weather_Location_On_Conflict = {
  constraint: Field_Weather_Location_Constraint;
  update_columns?: Array<Field_Weather_Location_Update_Column>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "field_weather_location". */
export type Field_Weather_Location_Order_By = {
  field?: InputMaybe<Field_Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_activated_on?: InputMaybe<Order_By>;
  weather_reference?: InputMaybe<Weather_Reference_Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: field_weather_location */
export type Field_Weather_Location_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "field_weather_location" */
export enum Field_Weather_Location_Select_Column {
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastActivatedOn = 'last_activated_on',
  /** column name */
  WeatherReferenceId = 'weather_reference_id'
}

/** input type for updating data in table "field_weather_location" */
export type Field_Weather_Location_Set_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_activated_on?: InputMaybe<Scalars['date']>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Field_Weather_Location_Stddev_Fields = {
  __typename?: 'field_weather_location_stddev_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "field_weather_location" */
export type Field_Weather_Location_Stddev_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Weather_Location_Stddev_Pop_Fields = {
  __typename?: 'field_weather_location_stddev_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "field_weather_location" */
export type Field_Weather_Location_Stddev_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Weather_Location_Stddev_Samp_Fields = {
  __typename?: 'field_weather_location_stddev_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "field_weather_location" */
export type Field_Weather_Location_Stddev_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field_weather_location" */
export type Field_Weather_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Weather_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Weather_Location_Stream_Cursor_Value_Input = {
  field_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_activated_on?: InputMaybe<Scalars['date']>;
  weather_reference_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Field_Weather_Location_Sum_Fields = {
  __typename?: 'field_weather_location_sum_fields';
  field_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  weather_reference_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "field_weather_location" */
export type Field_Weather_Location_Sum_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** update columns of table "field_weather_location" */
export enum Field_Weather_Location_Update_Column {
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastActivatedOn = 'last_activated_on',
  /** column name */
  WeatherReferenceId = 'weather_reference_id'
}

export type Field_Weather_Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Weather_Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Weather_Location_Set_Input>;
  where: Field_Weather_Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Weather_Location_Var_Pop_Fields = {
  __typename?: 'field_weather_location_var_pop_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "field_weather_location" */
export type Field_Weather_Location_Var_Pop_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Weather_Location_Var_Samp_Fields = {
  __typename?: 'field_weather_location_var_samp_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "field_weather_location" */
export type Field_Weather_Location_Var_Samp_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Weather_Location_Variance_Fields = {
  __typename?: 'field_weather_location_variance_fields';
  field_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  weather_reference_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "field_weather_location" */
export type Field_Weather_Location_Variance_Order_By = {
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weather_reference_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "financial_year" */
export type Financial_Year = {
  __typename?: 'financial_year';
  end_date?: Maybe<Scalars['date']>;
  from_year: Scalars['Int'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  start_date?: Maybe<Scalars['date']>;
  to_year: Scalars['Int'];
};

/** aggregated selection of "financial_year" */
export type Financial_Year_Aggregate = {
  __typename?: 'financial_year_aggregate';
  aggregate?: Maybe<Financial_Year_Aggregate_Fields>;
  nodes: Array<Financial_Year>;
};

/** aggregate fields of "financial_year" */
export type Financial_Year_Aggregate_Fields = {
  __typename?: 'financial_year_aggregate_fields';
  avg?: Maybe<Financial_Year_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Financial_Year_Max_Fields>;
  min?: Maybe<Financial_Year_Min_Fields>;
  stddev?: Maybe<Financial_Year_Stddev_Fields>;
  stddev_pop?: Maybe<Financial_Year_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Financial_Year_Stddev_Samp_Fields>;
  sum?: Maybe<Financial_Year_Sum_Fields>;
  var_pop?: Maybe<Financial_Year_Var_Pop_Fields>;
  var_samp?: Maybe<Financial_Year_Var_Samp_Fields>;
  variance?: Maybe<Financial_Year_Variance_Fields>;
};


/** aggregate fields of "financial_year" */
export type Financial_Year_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financial_Year_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "financial_year_assessment" */
export type Financial_Year_Assessment = {
  __typename?: 'financial_year_assessment';
  assessed_limit?: Maybe<Scalars['float8']>;
  /** An object relationship */
  attachment?: Maybe<Setutrade_Media>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital: Scalars['float8'];
  /** An object relationship */
  credit: Credit;
  credit_id: Scalars['bigint'];
  current_assets: Scalars['float8'];
  current_liabilities: Scalars['float8'];
  fixed_assets: Scalars['float8'];
  id: Scalars['bigint'];
  profit_loss: Scalars['float8'];
  total_sales: Scalars['float8'];
  /** An object relationship */
  year: Financial_Year;
  year_id: Scalars['bigint'];
};

/** aggregated selection of "financial_year_assessment" */
export type Financial_Year_Assessment_Aggregate = {
  __typename?: 'financial_year_assessment_aggregate';
  aggregate?: Maybe<Financial_Year_Assessment_Aggregate_Fields>;
  nodes: Array<Financial_Year_Assessment>;
};

/** aggregate fields of "financial_year_assessment" */
export type Financial_Year_Assessment_Aggregate_Fields = {
  __typename?: 'financial_year_assessment_aggregate_fields';
  avg?: Maybe<Financial_Year_Assessment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Financial_Year_Assessment_Max_Fields>;
  min?: Maybe<Financial_Year_Assessment_Min_Fields>;
  stddev?: Maybe<Financial_Year_Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Financial_Year_Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Financial_Year_Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Financial_Year_Assessment_Sum_Fields>;
  var_pop?: Maybe<Financial_Year_Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Financial_Year_Assessment_Var_Samp_Fields>;
  variance?: Maybe<Financial_Year_Assessment_Variance_Fields>;
};


/** aggregate fields of "financial_year_assessment" */
export type Financial_Year_Assessment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financial_Year_Assessment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "financial_year_assessment" */
export type Financial_Year_Assessment_Aggregate_Order_By = {
  avg?: InputMaybe<Financial_Year_Assessment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Financial_Year_Assessment_Max_Order_By>;
  min?: InputMaybe<Financial_Year_Assessment_Min_Order_By>;
  stddev?: InputMaybe<Financial_Year_Assessment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Financial_Year_Assessment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Financial_Year_Assessment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Financial_Year_Assessment_Sum_Order_By>;
  var_pop?: InputMaybe<Financial_Year_Assessment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Financial_Year_Assessment_Var_Samp_Order_By>;
  variance?: InputMaybe<Financial_Year_Assessment_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Financial_Year_Assessment_Avg_Fields = {
  __typename?: 'financial_year_assessment_avg_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Avg_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "financial_year_assessment". All fields are combined with a logical 'AND'. */
export type Financial_Year_Assessment_Bool_Exp = {
  _and?: InputMaybe<Array<Financial_Year_Assessment_Bool_Exp>>;
  _not?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
  _or?: InputMaybe<Array<Financial_Year_Assessment_Bool_Exp>>;
  assessed_limit?: InputMaybe<Float8_Comparison_Exp>;
  attachment?: InputMaybe<Setutrade_Media_Bool_Exp>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  capital?: InputMaybe<Float8_Comparison_Exp>;
  credit?: InputMaybe<Credit_Bool_Exp>;
  credit_id?: InputMaybe<Bigint_Comparison_Exp>;
  current_assets?: InputMaybe<Float8_Comparison_Exp>;
  current_liabilities?: InputMaybe<Float8_Comparison_Exp>;
  fixed_assets?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  profit_loss?: InputMaybe<Float8_Comparison_Exp>;
  total_sales?: InputMaybe<Float8_Comparison_Exp>;
  year?: InputMaybe<Financial_Year_Bool_Exp>;
  year_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw = {
  __typename?: 'financial_year_assessment_cw';
  assessed_limit?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  attachment?: Maybe<Setutrade_Media>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital: Scalars['numeric'];
  credit_wallet_request_id: Scalars['bigint'];
  current_assets: Scalars['numeric'];
  current_liabilities: Scalars['numeric'];
  /** An object relationship */
  financial_year: Financial_Year_Cw;
  fixed_assets: Scalars['numeric'];
  id: Scalars['bigint'];
  profit_loss: Scalars['numeric'];
  total_sales: Scalars['numeric'];
  year_id: Scalars['bigint'];
};

/** aggregated selection of "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Aggregate = {
  __typename?: 'financial_year_assessment_cw_aggregate';
  aggregate?: Maybe<Financial_Year_Assessment_Cw_Aggregate_Fields>;
  nodes: Array<Financial_Year_Assessment_Cw>;
};

/** aggregate fields of "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Aggregate_Fields = {
  __typename?: 'financial_year_assessment_cw_aggregate_fields';
  avg?: Maybe<Financial_Year_Assessment_Cw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Financial_Year_Assessment_Cw_Max_Fields>;
  min?: Maybe<Financial_Year_Assessment_Cw_Min_Fields>;
  stddev?: Maybe<Financial_Year_Assessment_Cw_Stddev_Fields>;
  stddev_pop?: Maybe<Financial_Year_Assessment_Cw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Financial_Year_Assessment_Cw_Stddev_Samp_Fields>;
  sum?: Maybe<Financial_Year_Assessment_Cw_Sum_Fields>;
  var_pop?: Maybe<Financial_Year_Assessment_Cw_Var_Pop_Fields>;
  var_samp?: Maybe<Financial_Year_Assessment_Cw_Var_Samp_Fields>;
  variance?: Maybe<Financial_Year_Assessment_Cw_Variance_Fields>;
};


/** aggregate fields of "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financial_Year_Assessment_Cw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Aggregate_Order_By = {
  avg?: InputMaybe<Financial_Year_Assessment_Cw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Financial_Year_Assessment_Cw_Max_Order_By>;
  min?: InputMaybe<Financial_Year_Assessment_Cw_Min_Order_By>;
  stddev?: InputMaybe<Financial_Year_Assessment_Cw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Financial_Year_Assessment_Cw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Financial_Year_Assessment_Cw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Financial_Year_Assessment_Cw_Sum_Order_By>;
  var_pop?: InputMaybe<Financial_Year_Assessment_Cw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Financial_Year_Assessment_Cw_Var_Samp_Order_By>;
  variance?: InputMaybe<Financial_Year_Assessment_Cw_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Financial_Year_Assessment_Cw_Avg_Fields = {
  __typename?: 'financial_year_assessment_cw_avg_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Avg_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "financial_year_assessment_cw". All fields are combined with a logical 'AND'. */
export type Financial_Year_Assessment_Cw_Bool_Exp = {
  _and?: InputMaybe<Array<Financial_Year_Assessment_Cw_Bool_Exp>>;
  _not?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
  _or?: InputMaybe<Array<Financial_Year_Assessment_Cw_Bool_Exp>>;
  assessed_limit?: InputMaybe<Numeric_Comparison_Exp>;
  attachment?: InputMaybe<Setutrade_Media_Bool_Exp>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  capital?: InputMaybe<Numeric_Comparison_Exp>;
  credit_wallet_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  current_assets?: InputMaybe<Numeric_Comparison_Exp>;
  current_liabilities?: InputMaybe<Numeric_Comparison_Exp>;
  financial_year?: InputMaybe<Financial_Year_Cw_Bool_Exp>;
  fixed_assets?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  profit_loss?: InputMaybe<Numeric_Comparison_Exp>;
  total_sales?: InputMaybe<Numeric_Comparison_Exp>;
  year_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Financial_Year_Assessment_Cw_Max_Fields = {
  __typename?: 'financial_year_assessment_cw_max_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  current_assets?: Maybe<Scalars['numeric']>;
  current_liabilities?: Maybe<Scalars['numeric']>;
  fixed_assets?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  profit_loss?: Maybe<Scalars['numeric']>;
  total_sales?: Maybe<Scalars['numeric']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Max_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Financial_Year_Assessment_Cw_Min_Fields = {
  __typename?: 'financial_year_assessment_cw_min_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  current_assets?: Maybe<Scalars['numeric']>;
  current_liabilities?: Maybe<Scalars['numeric']>;
  fixed_assets?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  profit_loss?: Maybe<Scalars['numeric']>;
  total_sales?: Maybe<Scalars['numeric']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Min_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "financial_year_assessment_cw". */
export type Financial_Year_Assessment_Cw_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment?: InputMaybe<Setutrade_Media_Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  financial_year?: InputMaybe<Financial_Year_Cw_Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** select columns of table "financial_year_assessment_cw" */
export enum Financial_Year_Assessment_Cw_Select_Column {
  /** column name */
  AssessedLimit = 'assessed_limit',
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Capital = 'capital',
  /** column name */
  CreditWalletRequestId = 'credit_wallet_request_id',
  /** column name */
  CurrentAssets = 'current_assets',
  /** column name */
  CurrentLiabilities = 'current_liabilities',
  /** column name */
  FixedAssets = 'fixed_assets',
  /** column name */
  Id = 'id',
  /** column name */
  ProfitLoss = 'profit_loss',
  /** column name */
  TotalSales = 'total_sales',
  /** column name */
  YearId = 'year_id'
}

/** aggregate stddev on columns */
export type Financial_Year_Assessment_Cw_Stddev_Fields = {
  __typename?: 'financial_year_assessment_cw_stddev_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Stddev_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Financial_Year_Assessment_Cw_Stddev_Pop_Fields = {
  __typename?: 'financial_year_assessment_cw_stddev_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Stddev_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Financial_Year_Assessment_Cw_Stddev_Samp_Fields = {
  __typename?: 'financial_year_assessment_cw_stddev_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Stddev_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financial_Year_Assessment_Cw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Financial_Year_Assessment_Cw_Stream_Cursor_Value_Input = {
  assessed_limit?: InputMaybe<Scalars['numeric']>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  capital?: InputMaybe<Scalars['numeric']>;
  credit_wallet_request_id?: InputMaybe<Scalars['bigint']>;
  current_assets?: InputMaybe<Scalars['numeric']>;
  current_liabilities?: InputMaybe<Scalars['numeric']>;
  fixed_assets?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  profit_loss?: InputMaybe<Scalars['numeric']>;
  total_sales?: InputMaybe<Scalars['numeric']>;
  year_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Financial_Year_Assessment_Cw_Sum_Fields = {
  __typename?: 'financial_year_assessment_cw_sum_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  current_assets?: Maybe<Scalars['numeric']>;
  current_liabilities?: Maybe<Scalars['numeric']>;
  fixed_assets?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  profit_loss?: Maybe<Scalars['numeric']>;
  total_sales?: Maybe<Scalars['numeric']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Sum_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Financial_Year_Assessment_Cw_Var_Pop_Fields = {
  __typename?: 'financial_year_assessment_cw_var_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Var_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Financial_Year_Assessment_Cw_Var_Samp_Fields = {
  __typename?: 'financial_year_assessment_cw_var_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Var_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Financial_Year_Assessment_Cw_Variance_Fields = {
  __typename?: 'financial_year_assessment_cw_variance_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "financial_year_assessment_cw" */
export type Financial_Year_Assessment_Cw_Variance_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Financial_Year_Assessment_Max_Fields = {
  __typename?: 'financial_year_assessment_max_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  current_assets?: Maybe<Scalars['float8']>;
  current_liabilities?: Maybe<Scalars['float8']>;
  fixed_assets?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  profit_loss?: Maybe<Scalars['float8']>;
  total_sales?: Maybe<Scalars['float8']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Max_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Financial_Year_Assessment_Min_Fields = {
  __typename?: 'financial_year_assessment_min_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  current_assets?: Maybe<Scalars['float8']>;
  current_liabilities?: Maybe<Scalars['float8']>;
  fixed_assets?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  profit_loss?: Maybe<Scalars['float8']>;
  total_sales?: Maybe<Scalars['float8']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Min_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "financial_year_assessment". */
export type Financial_Year_Assessment_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment?: InputMaybe<Setutrade_Media_Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit?: InputMaybe<Credit_Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year?: InputMaybe<Financial_Year_Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** select columns of table "financial_year_assessment" */
export enum Financial_Year_Assessment_Select_Column {
  /** column name */
  AssessedLimit = 'assessed_limit',
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Capital = 'capital',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  CurrentAssets = 'current_assets',
  /** column name */
  CurrentLiabilities = 'current_liabilities',
  /** column name */
  FixedAssets = 'fixed_assets',
  /** column name */
  Id = 'id',
  /** column name */
  ProfitLoss = 'profit_loss',
  /** column name */
  TotalSales = 'total_sales',
  /** column name */
  YearId = 'year_id'
}

/** aggregate stddev on columns */
export type Financial_Year_Assessment_Stddev_Fields = {
  __typename?: 'financial_year_assessment_stddev_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Stddev_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Financial_Year_Assessment_Stddev_Pop_Fields = {
  __typename?: 'financial_year_assessment_stddev_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Stddev_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Financial_Year_Assessment_Stddev_Samp_Fields = {
  __typename?: 'financial_year_assessment_stddev_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Stddev_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "financial_year_assessment" */
export type Financial_Year_Assessment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financial_Year_Assessment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Financial_Year_Assessment_Stream_Cursor_Value_Input = {
  assessed_limit?: InputMaybe<Scalars['float8']>;
  attachment_id?: InputMaybe<Scalars['bigint']>;
  capital?: InputMaybe<Scalars['float8']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  current_assets?: InputMaybe<Scalars['float8']>;
  current_liabilities?: InputMaybe<Scalars['float8']>;
  fixed_assets?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  profit_loss?: InputMaybe<Scalars['float8']>;
  total_sales?: InputMaybe<Scalars['float8']>;
  year_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Financial_Year_Assessment_Sum_Fields = {
  __typename?: 'financial_year_assessment_sum_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  attachment_id?: Maybe<Scalars['bigint']>;
  capital?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  current_assets?: Maybe<Scalars['float8']>;
  current_liabilities?: Maybe<Scalars['float8']>;
  fixed_assets?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  profit_loss?: Maybe<Scalars['float8']>;
  total_sales?: Maybe<Scalars['float8']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Sum_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Financial_Year_Assessment_Var_Pop_Fields = {
  __typename?: 'financial_year_assessment_var_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Var_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Financial_Year_Assessment_Var_Samp_Fields = {
  __typename?: 'financial_year_assessment_var_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Var_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Financial_Year_Assessment_Variance_Fields = {
  __typename?: 'financial_year_assessment_variance_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  attachment_id?: Maybe<Scalars['Float']>;
  capital?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  current_assets?: Maybe<Scalars['Float']>;
  current_liabilities?: Maybe<Scalars['Float']>;
  fixed_assets?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  profit_loss?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "financial_year_assessment" */
export type Financial_Year_Assessment_Variance_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  attachment_id?: InputMaybe<Order_By>;
  capital?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  current_assets?: InputMaybe<Order_By>;
  current_liabilities?: InputMaybe<Order_By>;
  fixed_assets?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profit_loss?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Financial_Year_Avg_Fields = {
  __typename?: 'financial_year_avg_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "financial_year". All fields are combined with a logical 'AND'. */
export type Financial_Year_Bool_Exp = {
  _and?: InputMaybe<Array<Financial_Year_Bool_Exp>>;
  _not?: InputMaybe<Financial_Year_Bool_Exp>;
  _or?: InputMaybe<Array<Financial_Year_Bool_Exp>>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  from_year?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  to_year?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "financial_year_cw" */
export type Financial_Year_Cw = {
  __typename?: 'financial_year_cw';
  end_date?: Maybe<Scalars['date']>;
  from_year: Scalars['Int'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  start_date?: Maybe<Scalars['date']>;
  to_year: Scalars['Int'];
};

/** aggregated selection of "financial_year_cw" */
export type Financial_Year_Cw_Aggregate = {
  __typename?: 'financial_year_cw_aggregate';
  aggregate?: Maybe<Financial_Year_Cw_Aggregate_Fields>;
  nodes: Array<Financial_Year_Cw>;
};

/** aggregate fields of "financial_year_cw" */
export type Financial_Year_Cw_Aggregate_Fields = {
  __typename?: 'financial_year_cw_aggregate_fields';
  avg?: Maybe<Financial_Year_Cw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Financial_Year_Cw_Max_Fields>;
  min?: Maybe<Financial_Year_Cw_Min_Fields>;
  stddev?: Maybe<Financial_Year_Cw_Stddev_Fields>;
  stddev_pop?: Maybe<Financial_Year_Cw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Financial_Year_Cw_Stddev_Samp_Fields>;
  sum?: Maybe<Financial_Year_Cw_Sum_Fields>;
  var_pop?: Maybe<Financial_Year_Cw_Var_Pop_Fields>;
  var_samp?: Maybe<Financial_Year_Cw_Var_Samp_Fields>;
  variance?: Maybe<Financial_Year_Cw_Variance_Fields>;
};


/** aggregate fields of "financial_year_cw" */
export type Financial_Year_Cw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financial_Year_Cw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Financial_Year_Cw_Avg_Fields = {
  __typename?: 'financial_year_cw_avg_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "financial_year_cw". All fields are combined with a logical 'AND'. */
export type Financial_Year_Cw_Bool_Exp = {
  _and?: InputMaybe<Array<Financial_Year_Cw_Bool_Exp>>;
  _not?: InputMaybe<Financial_Year_Cw_Bool_Exp>;
  _or?: InputMaybe<Array<Financial_Year_Cw_Bool_Exp>>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  from_year?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  to_year?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Financial_Year_Cw_Max_Fields = {
  __typename?: 'financial_year_cw_max_fields';
  end_date?: Maybe<Scalars['date']>;
  from_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  to_year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Financial_Year_Cw_Min_Fields = {
  __typename?: 'financial_year_cw_min_fields';
  end_date?: Maybe<Scalars['date']>;
  from_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  to_year?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "financial_year_cw". */
export type Financial_Year_Cw_Order_By = {
  end_date?: InputMaybe<Order_By>;
  from_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  to_year?: InputMaybe<Order_By>;
};

/** select columns of table "financial_year_cw" */
export enum Financial_Year_Cw_Select_Column {
  /** column name */
  EndDate = 'end_date',
  /** column name */
  FromYear = 'from_year',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  ToYear = 'to_year'
}

/** aggregate stddev on columns */
export type Financial_Year_Cw_Stddev_Fields = {
  __typename?: 'financial_year_cw_stddev_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Financial_Year_Cw_Stddev_Pop_Fields = {
  __typename?: 'financial_year_cw_stddev_pop_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Financial_Year_Cw_Stddev_Samp_Fields = {
  __typename?: 'financial_year_cw_stddev_samp_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "financial_year_cw" */
export type Financial_Year_Cw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financial_Year_Cw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Financial_Year_Cw_Stream_Cursor_Value_Input = {
  end_date?: InputMaybe<Scalars['date']>;
  from_year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  to_year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Financial_Year_Cw_Sum_Fields = {
  __typename?: 'financial_year_cw_sum_fields';
  from_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  to_year?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Financial_Year_Cw_Var_Pop_Fields = {
  __typename?: 'financial_year_cw_var_pop_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Financial_Year_Cw_Var_Samp_Fields = {
  __typename?: 'financial_year_cw_var_samp_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Financial_Year_Cw_Variance_Fields = {
  __typename?: 'financial_year_cw_variance_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Financial_Year_Max_Fields = {
  __typename?: 'financial_year_max_fields';
  end_date?: Maybe<Scalars['date']>;
  from_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  to_year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Financial_Year_Min_Fields = {
  __typename?: 'financial_year_min_fields';
  end_date?: Maybe<Scalars['date']>;
  from_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  to_year?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "financial_year". */
export type Financial_Year_Order_By = {
  end_date?: InputMaybe<Order_By>;
  from_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  to_year?: InputMaybe<Order_By>;
};

/** select columns of table "financial_year" */
export enum Financial_Year_Select_Column {
  /** column name */
  EndDate = 'end_date',
  /** column name */
  FromYear = 'from_year',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  ToYear = 'to_year'
}

/** aggregate stddev on columns */
export type Financial_Year_Stddev_Fields = {
  __typename?: 'financial_year_stddev_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Financial_Year_Stddev_Pop_Fields = {
  __typename?: 'financial_year_stddev_pop_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Financial_Year_Stddev_Samp_Fields = {
  __typename?: 'financial_year_stddev_samp_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "financial_year" */
export type Financial_Year_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financial_Year_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Financial_Year_Stream_Cursor_Value_Input = {
  end_date?: InputMaybe<Scalars['date']>;
  from_year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  to_year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Financial_Year_Sum_Fields = {
  __typename?: 'financial_year_sum_fields';
  from_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  to_year?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Financial_Year_Var_Pop_Fields = {
  __typename?: 'financial_year_var_pop_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Financial_Year_Var_Samp_Fields = {
  __typename?: 'financial_year_var_samp_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Financial_Year_Variance_Fields = {
  __typename?: 'financial_year_variance_fields';
  from_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "grade" */
export type Grade = {
  __typename?: 'grade';
  codename: Scalars['String'];
  /** An array relationship */
  companies: Array<Grade_Company>;
  /** An aggregate relationship */
  companies_aggregate: Grade_Company_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  templates: Array<Template>;
  /** An aggregate relationship */
  templates_aggregate: Template_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "grade" */
export type GradeCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


/** columns and relationships of "grade" */
export type GradeCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


/** columns and relationships of "grade" */
export type GradeTemplatesArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


/** columns and relationships of "grade" */
export type GradeTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};

/** aggregated selection of "grade" */
export type Grade_Aggregate = {
  __typename?: 'grade_aggregate';
  aggregate?: Maybe<Grade_Aggregate_Fields>;
  nodes: Array<Grade>;
};

/** aggregate fields of "grade" */
export type Grade_Aggregate_Fields = {
  __typename?: 'grade_aggregate_fields';
  avg?: Maybe<Grade_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Max_Fields>;
  min?: Maybe<Grade_Min_Fields>;
  stddev?: Maybe<Grade_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Sum_Fields>;
  var_pop?: Maybe<Grade_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Var_Samp_Fields>;
  variance?: Maybe<Grade_Variance_Fields>;
};


/** aggregate fields of "grade" */
export type Grade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Grade_Avg_Fields = {
  __typename?: 'grade_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "grade". All fields are combined with a logical 'AND'. */
export type Grade_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Bool_Exp>>;
  _not?: InputMaybe<Grade_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Grade_Company_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  templates?: InputMaybe<Template_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "grade_company" */
export type Grade_Company = {
  __typename?: 'grade_company';
  /** An object relationship */
  company: External_Entity;
  externalentity_id: Scalars['bigint'];
  /** An object relationship */
  grade: Grade;
  grade_id: Scalars['bigint'];
  id: Scalars['bigint'];
};

/** aggregated selection of "grade_company" */
export type Grade_Company_Aggregate = {
  __typename?: 'grade_company_aggregate';
  aggregate?: Maybe<Grade_Company_Aggregate_Fields>;
  nodes: Array<Grade_Company>;
};

/** aggregate fields of "grade_company" */
export type Grade_Company_Aggregate_Fields = {
  __typename?: 'grade_company_aggregate_fields';
  avg?: Maybe<Grade_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Company_Max_Fields>;
  min?: Maybe<Grade_Company_Min_Fields>;
  stddev?: Maybe<Grade_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Company_Sum_Fields>;
  var_pop?: Maybe<Grade_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Company_Var_Samp_Fields>;
  variance?: Maybe<Grade_Company_Variance_Fields>;
};


/** aggregate fields of "grade_company" */
export type Grade_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grade_company" */
export type Grade_Company_Aggregate_Order_By = {
  avg?: InputMaybe<Grade_Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Grade_Company_Max_Order_By>;
  min?: InputMaybe<Grade_Company_Min_Order_By>;
  stddev?: InputMaybe<Grade_Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Grade_Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Grade_Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Grade_Company_Sum_Order_By>;
  var_pop?: InputMaybe<Grade_Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Grade_Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Grade_Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "grade_company" */
export type Grade_Company_Arr_Rel_Insert_Input = {
  data: Array<Grade_Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Grade_Company_Avg_Fields = {
  __typename?: 'grade_company_avg_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grade_company" */
export type Grade_Company_Avg_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "grade_company". All fields are combined with a logical 'AND'. */
export type Grade_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Company_Bool_Exp>>;
  _not?: InputMaybe<Grade_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Company_Bool_Exp>>;
  company?: InputMaybe<External_Entity_Bool_Exp>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  grade?: InputMaybe<Grade_Bool_Exp>;
  grade_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade_company" */
export enum Grade_Company_Constraint {
  /** unique or primary key constraint on columns "externalentity_id", "grade_id" */
  GradeCompanyGradeIdExternalentityIdEb9a1161Uniq = 'grade_company_grade_id_externalentity_id_eb9a1161_uniq',
  /** unique or primary key constraint on columns "id" */
  GradeCompanyPkey = 'grade_company_pkey'
}

/** input type for incrementing numeric columns in table "grade_company" */
export type Grade_Company_Inc_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "grade_company" */
export type Grade_Company_Insert_Input = {
  company?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  grade?: InputMaybe<Grade_Obj_Rel_Insert_Input>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Grade_Company_Max_Fields = {
  __typename?: 'grade_company_max_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "grade_company" */
export type Grade_Company_Max_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Grade_Company_Min_Fields = {
  __typename?: 'grade_company_min_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "grade_company" */
export type Grade_Company_Min_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "grade_company" */
export type Grade_Company_Mutation_Response = {
  __typename?: 'grade_company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade_Company>;
};

/** on_conflict condition type for table "grade_company" */
export type Grade_Company_On_Conflict = {
  constraint: Grade_Company_Constraint;
  update_columns?: Array<Grade_Company_Update_Column>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};

/** Ordering options when selecting data from "grade_company". */
export type Grade_Company_Order_By = {
  company?: InputMaybe<External_Entity_Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  grade?: InputMaybe<Grade_Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade_company */
export type Grade_Company_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "grade_company" */
export enum Grade_Company_Select_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "grade_company" */
export type Grade_Company_Set_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Grade_Company_Stddev_Fields = {
  __typename?: 'grade_company_stddev_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grade_company" */
export type Grade_Company_Stddev_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Grade_Company_Stddev_Pop_Fields = {
  __typename?: 'grade_company_stddev_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grade_company" */
export type Grade_Company_Stddev_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Grade_Company_Stddev_Samp_Fields = {
  __typename?: 'grade_company_stddev_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grade_company" */
export type Grade_Company_Stddev_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "grade_company" */
export type Grade_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Company_Stream_Cursor_Value_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Grade_Company_Sum_Fields = {
  __typename?: 'grade_company_sum_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "grade_company" */
export type Grade_Company_Sum_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "grade_company" */
export enum Grade_Company_Update_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id'
}

export type Grade_Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Company_Set_Input>;
  where: Grade_Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grade_Company_Var_Pop_Fields = {
  __typename?: 'grade_company_var_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grade_company" */
export type Grade_Company_Var_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Grade_Company_Var_Samp_Fields = {
  __typename?: 'grade_company_var_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grade_company" */
export type Grade_Company_Var_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Grade_Company_Variance_Fields = {
  __typename?: 'grade_company_variance_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grade_company" */
export type Grade_Company_Variance_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "grade" */
export enum Grade_Constraint {
  /** unique or primary key constraint on columns "codename" */
  GradeCodenameKey = 'grade_codename_key',
  /** unique or primary key constraint on columns "id" */
  GradePkey = 'grade_pkey'
}

/** input type for incrementing numeric columns in table "grade" */
export type Grade_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "grade" */
export type Grade_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Grade_Company_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  templates?: InputMaybe<Template_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Grade_Max_Fields = {
  __typename?: 'grade_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Grade_Min_Fields = {
  __typename?: 'grade_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "grade" */
export type Grade_Mutation_Response = {
  __typename?: 'grade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade>;
};

/** input type for inserting object relation for remote table "grade" */
export type Grade_Obj_Rel_Insert_Input = {
  data: Grade_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};

/** on_conflict condition type for table "grade" */
export type Grade_On_Conflict = {
  constraint: Grade_Constraint;
  update_columns?: Array<Grade_Update_Column>;
  where?: InputMaybe<Grade_Bool_Exp>;
};

/** Ordering options when selecting data from "grade". */
export type Grade_Order_By = {
  codename?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Grade_Company_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  templates_aggregate?: InputMaybe<Template_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade */
export type Grade_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** columns and relationships of "grade_price" */
export type Grade_Price = {
  __typename?: 'grade_price';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  grade: Variety_Grade;
  grade_id: Scalars['Int'];
  id: Scalars['Int'];
  price: Scalars['numeric'];
  price_limit: Scalars['numeric'];
  /** An object relationship */
  price_unit: Sku;
  price_unit_id: Scalars['Int'];
  rejection: Scalars['numeric'];
  remark: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "grade_price" */
export type Grade_Price_Aggregate = {
  __typename?: 'grade_price_aggregate';
  aggregate?: Maybe<Grade_Price_Aggregate_Fields>;
  nodes: Array<Grade_Price>;
};

/** aggregate fields of "grade_price" */
export type Grade_Price_Aggregate_Fields = {
  __typename?: 'grade_price_aggregate_fields';
  avg?: Maybe<Grade_Price_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Grade_Price_Max_Fields>;
  min?: Maybe<Grade_Price_Min_Fields>;
  stddev?: Maybe<Grade_Price_Stddev_Fields>;
  stddev_pop?: Maybe<Grade_Price_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Grade_Price_Stddev_Samp_Fields>;
  sum?: Maybe<Grade_Price_Sum_Fields>;
  var_pop?: Maybe<Grade_Price_Var_Pop_Fields>;
  var_samp?: Maybe<Grade_Price_Var_Samp_Fields>;
  variance?: Maybe<Grade_Price_Variance_Fields>;
};


/** aggregate fields of "grade_price" */
export type Grade_Price_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Grade_Price_Avg_Fields = {
  __typename?: 'grade_price_avg_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "grade_price". All fields are combined with a logical 'AND'. */
export type Grade_Price_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Price_Bool_Exp>>;
  _not?: InputMaybe<Grade_Price_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Price_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  grade?: InputMaybe<Variety_Grade_Bool_Exp>;
  grade_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  price_limit?: InputMaybe<Numeric_Comparison_Exp>;
  price_unit?: InputMaybe<Sku_Bool_Exp>;
  price_unit_id?: InputMaybe<Int_Comparison_Exp>;
  rejection?: InputMaybe<Numeric_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade_price" */
export enum Grade_Price_Constraint {
  /** unique or primary key constraint on columns "id" */
  GradePricePkey = 'grade_price_pkey'
}

/** input type for incrementing numeric columns in table "grade_price" */
export type Grade_Price_Inc_Input = {
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "grade_price" */
export type Grade_Price_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  grade?: InputMaybe<Variety_Grade_Obj_Rel_Insert_Input>;
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit?: InputMaybe<Sku_Obj_Rel_Insert_Input>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Grade_Price_Max_Fields = {
  __typename?: 'grade_price_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  grade_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_limit?: Maybe<Scalars['numeric']>;
  price_unit_id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Grade_Price_Min_Fields = {
  __typename?: 'grade_price_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  grade_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_limit?: Maybe<Scalars['numeric']>;
  price_unit_id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['numeric']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "grade_price" */
export type Grade_Price_Mutation_Response = {
  __typename?: 'grade_price_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade_Price>;
};

/** on_conflict condition type for table "grade_price" */
export type Grade_Price_On_Conflict = {
  constraint: Grade_Price_Constraint;
  update_columns?: Array<Grade_Price_Update_Column>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "grade_price". */
export type Grade_Price_Order_By = {
  created_at?: InputMaybe<Order_By>;
  grade?: InputMaybe<Variety_Grade_Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_limit?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Sku_Order_By>;
  price_unit_id?: InputMaybe<Order_By>;
  rejection?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade_price */
export type Grade_Price_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "grade_price" */
export enum Grade_Price_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceLimit = 'price_limit',
  /** column name */
  PriceUnitId = 'price_unit_id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "grade_price" */
export type Grade_Price_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Grade_Price_Stddev_Fields = {
  __typename?: 'grade_price_stddev_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Grade_Price_Stddev_Pop_Fields = {
  __typename?: 'grade_price_stddev_pop_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Grade_Price_Stddev_Samp_Fields = {
  __typename?: 'grade_price_stddev_samp_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "grade_price" */
export type Grade_Price_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Price_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Price_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  grade_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_limit?: InputMaybe<Scalars['numeric']>;
  price_unit_id?: InputMaybe<Scalars['Int']>;
  rejection?: InputMaybe<Scalars['numeric']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Grade_Price_Sum_Fields = {
  __typename?: 'grade_price_sum_fields';
  grade_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_limit?: Maybe<Scalars['numeric']>;
  price_unit_id?: Maybe<Scalars['Int']>;
  rejection?: Maybe<Scalars['numeric']>;
};

/** update columns of table "grade_price" */
export enum Grade_Price_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceLimit = 'price_limit',
  /** column name */
  PriceUnitId = 'price_unit_id',
  /** column name */
  Rejection = 'rejection',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Grade_Price_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Price_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Price_Set_Input>;
  where: Grade_Price_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grade_Price_Var_Pop_Fields = {
  __typename?: 'grade_price_var_pop_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Grade_Price_Var_Samp_Fields = {
  __typename?: 'grade_price_var_samp_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Grade_Price_Variance_Fields = {
  __typename?: 'grade_price_variance_fields';
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  price_limit?: Maybe<Scalars['Float']>;
  price_unit_id?: Maybe<Scalars['Float']>;
  rejection?: Maybe<Scalars['Float']>;
};

/** select columns of table "grade" */
export enum Grade_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "grade" */
export type Grade_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Grade_Stddev_Fields = {
  __typename?: 'grade_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Grade_Stddev_Pop_Fields = {
  __typename?: 'grade_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Grade_Stddev_Samp_Fields = {
  __typename?: 'grade_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "grade" */
export type Grade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Grade_Sum_Fields = {
  __typename?: 'grade_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "grade" */
export enum Grade_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Grade_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Grade_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Set_Input>;
  where: Grade_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Grade_Var_Pop_Fields = {
  __typename?: 'grade_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Grade_Var_Samp_Fields = {
  __typename?: 'grade_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Grade_Variance_Fields = {
  __typename?: 'grade_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "guarantor_agreement" */
export type Guarantor_Agreement = {
  __typename?: 'guarantor_agreement';
  /** An array relationship */
  agreement_invoices: Array<Guarantor_Agreement_Agreement_Invoices>;
  /** An aggregate relationship */
  agreement_invoices_aggregate: Guarantor_Agreement_Agreement_Invoices_Aggregate;
  /** An array relationship */
  agreement_plots: Array<Guarantor_Agreement_Agreement_Plots>;
  /** An aggregate relationship */
  agreement_plots_aggregate: Guarantor_Agreement_Agreement_Plots_Aggregate;
  agreement_type: Scalars['String'];
  amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  area_extension_details: Array<Guarantor_Agreement_Area_Extension_Detail>;
  /** An aggregate relationship */
  area_extension_details_aggregate: Guarantor_Agreement_Area_Extension_Detail_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  guarantee_nursery_fee: Scalars['Boolean'];
  guarantee_registration_fee: Scalars['Boolean'];
  guarantors: Scalars['jsonb'];
  id: Scalars['Int'];
  /** An object relationship */
  legal_agreement?: Maybe<Legal_Agreement>;
  legal_agreement_id?: Maybe<Scalars['Int']>;
  metadata: Scalars['jsonb'];
  payable_additional_amount?: Maybe<Scalars['numeric']>;
  plot_coverage: Scalars['jsonb'];
  previous_amount?: Maybe<Scalars['numeric']>;
  reason_for_amendment: Scalars['String'];
  status: Scalars['String'];
  total_agreement_amount?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  variety_agreements: Array<Variety_Agreement_Guarantor_Agreements>;
  /** An aggregate relationship */
  variety_agreements_aggregate: Variety_Agreement_Guarantor_Agreements_Aggregate;
  witnesses: Scalars['jsonb'];
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementAgreement_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementAgreement_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementAgreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementAgreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementArea_Extension_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementArea_Extension_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementGuarantorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementPlot_CoverageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementVariety_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementVariety_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


/** columns and relationships of "guarantor_agreement" */
export type Guarantor_AgreementWitnessesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "guarantor_agreement" */
export type Guarantor_Agreement_Aggregate = {
  __typename?: 'guarantor_agreement_aggregate';
  aggregate?: Maybe<Guarantor_Agreement_Aggregate_Fields>;
  nodes: Array<Guarantor_Agreement>;
};

/** aggregate fields of "guarantor_agreement" */
export type Guarantor_Agreement_Aggregate_Fields = {
  __typename?: 'guarantor_agreement_aggregate_fields';
  avg?: Maybe<Guarantor_Agreement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Guarantor_Agreement_Max_Fields>;
  min?: Maybe<Guarantor_Agreement_Min_Fields>;
  stddev?: Maybe<Guarantor_Agreement_Stddev_Fields>;
  stddev_pop?: Maybe<Guarantor_Agreement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Guarantor_Agreement_Stddev_Samp_Fields>;
  sum?: Maybe<Guarantor_Agreement_Sum_Fields>;
  var_pop?: Maybe<Guarantor_Agreement_Var_Pop_Fields>;
  var_samp?: Maybe<Guarantor_Agreement_Var_Samp_Fields>;
  variance?: Maybe<Guarantor_Agreement_Variance_Fields>;
};


/** aggregate fields of "guarantor_agreement" */
export type Guarantor_Agreement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Guarantor_Agreement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guarantor_agreement" */
export type Guarantor_Agreement_Aggregate_Order_By = {
  avg?: InputMaybe<Guarantor_Agreement_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Guarantor_Agreement_Max_Order_By>;
  min?: InputMaybe<Guarantor_Agreement_Min_Order_By>;
  stddev?: InputMaybe<Guarantor_Agreement_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Guarantor_Agreement_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Guarantor_Agreement_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Guarantor_Agreement_Sum_Order_By>;
  var_pop?: InputMaybe<Guarantor_Agreement_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Guarantor_Agreement_Var_Samp_Order_By>;
  variance?: InputMaybe<Guarantor_Agreement_Variance_Order_By>;
};

/** columns and relationships of "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices = {
  __typename?: 'guarantor_agreement_agreement_invoices';
  /** An object relationship */
  agreement_invoice: Agreement_Invoice;
  agreementinvoice_id: Scalars['Int'];
  /** An object relationship */
  guarantor_agreement: Guarantor_Agreement;
  guarantoragreement_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Aggregate = {
  __typename?: 'guarantor_agreement_agreement_invoices_aggregate';
  aggregate?: Maybe<Guarantor_Agreement_Agreement_Invoices_Aggregate_Fields>;
  nodes: Array<Guarantor_Agreement_Agreement_Invoices>;
};

/** aggregate fields of "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Aggregate_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_aggregate_fields';
  avg?: Maybe<Guarantor_Agreement_Agreement_Invoices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Guarantor_Agreement_Agreement_Invoices_Max_Fields>;
  min?: Maybe<Guarantor_Agreement_Agreement_Invoices_Min_Fields>;
  stddev?: Maybe<Guarantor_Agreement_Agreement_Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Guarantor_Agreement_Agreement_Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Guarantor_Agreement_Agreement_Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Guarantor_Agreement_Agreement_Invoices_Sum_Fields>;
  var_pop?: Maybe<Guarantor_Agreement_Agreement_Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Guarantor_Agreement_Agreement_Invoices_Var_Samp_Fields>;
  variance?: Maybe<Guarantor_Agreement_Agreement_Invoices_Variance_Fields>;
};


/** aggregate fields of "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Max_Order_By>;
  min?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Min_Order_By>;
  stddev?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Arr_Rel_Insert_Input = {
  data: Array<Guarantor_Agreement_Agreement_Invoices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_On_Conflict>;
};

/** aggregate avg on columns */
export type Guarantor_Agreement_Agreement_Invoices_Avg_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_avg_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Avg_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "guarantor_agreement_agreement_invoices". All fields are combined with a logical 'AND'. */
export type Guarantor_Agreement_Agreement_Invoices_Bool_Exp = {
  _and?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>>;
  _not?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>>;
  agreement_invoice?: InputMaybe<Agreement_Invoice_Bool_Exp>;
  agreementinvoice_id?: InputMaybe<Int_Comparison_Exp>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
  guarantoragreement_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "guarantor_agreement_agreement_invoices" */
export enum Guarantor_Agreement_Agreement_Invoices_Constraint {
  /** unique or primary key constraint on columns "guarantoragreement_id", "agreementinvoice_id" */
  GuarantorAgreementAgreGuarantoragreementIdAg_7c286e17Uniq = 'guarantor_agreement_agre_guarantoragreement_id_ag_7c286e17_uniq',
  /** unique or primary key constraint on columns "id" */
  GuarantorAgreementAgreementInvoicesPkey = 'guarantor_agreement_agreement_invoices_pkey'
}

/** input type for incrementing numeric columns in table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Inc_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Insert_Input = {
  agreement_invoice?: InputMaybe<Agreement_Invoice_Obj_Rel_Insert_Input>;
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Obj_Rel_Insert_Input>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Guarantor_Agreement_Agreement_Invoices_Max_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_max_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Max_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Guarantor_Agreement_Agreement_Invoices_Min_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_min_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Min_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Mutation_Response = {
  __typename?: 'guarantor_agreement_agreement_invoices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guarantor_Agreement_Agreement_Invoices>;
};

/** on_conflict condition type for table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_On_Conflict = {
  constraint: Guarantor_Agreement_Agreement_Invoices_Constraint;
  update_columns?: Array<Guarantor_Agreement_Agreement_Invoices_Update_Column>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};

/** Ordering options when selecting data from "guarantor_agreement_agreement_invoices". */
export type Guarantor_Agreement_Agreement_Invoices_Order_By = {
  agreement_invoice?: InputMaybe<Agreement_Invoice_Order_By>;
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guarantor_agreement_agreement_invoices */
export type Guarantor_Agreement_Agreement_Invoices_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "guarantor_agreement_agreement_invoices" */
export enum Guarantor_Agreement_Agreement_Invoices_Select_Column {
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  GuarantoragreementId = 'guarantoragreement_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Set_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Guarantor_Agreement_Agreement_Invoices_Stddev_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_stddev_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Stddev_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Guarantor_Agreement_Agreement_Invoices_Stddev_Pop_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_stddev_pop_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Stddev_Pop_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Guarantor_Agreement_Agreement_Invoices_Stddev_Samp_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_stddev_samp_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Stddev_Samp_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guarantor_Agreement_Agreement_Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guarantor_Agreement_Agreement_Invoices_Stream_Cursor_Value_Input = {
  agreementinvoice_id?: InputMaybe<Scalars['Int']>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Guarantor_Agreement_Agreement_Invoices_Sum_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_sum_fields';
  agreementinvoice_id?: Maybe<Scalars['Int']>;
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Sum_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "guarantor_agreement_agreement_invoices" */
export enum Guarantor_Agreement_Agreement_Invoices_Update_Column {
  /** column name */
  AgreementinvoiceId = 'agreementinvoice_id',
  /** column name */
  GuarantoragreementId = 'guarantoragreement_id',
  /** column name */
  Id = 'id'
}

export type Guarantor_Agreement_Agreement_Invoices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Set_Input>;
  where: Guarantor_Agreement_Agreement_Invoices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Guarantor_Agreement_Agreement_Invoices_Var_Pop_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_var_pop_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Var_Pop_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Guarantor_Agreement_Agreement_Invoices_Var_Samp_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_var_samp_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Var_Samp_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Guarantor_Agreement_Agreement_Invoices_Variance_Fields = {
  __typename?: 'guarantor_agreement_agreement_invoices_variance_fields';
  agreementinvoice_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "guarantor_agreement_agreement_invoices" */
export type Guarantor_Agreement_Agreement_Invoices_Variance_Order_By = {
  agreementinvoice_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots = {
  __typename?: 'guarantor_agreement_agreement_plots';
  /** An object relationship */
  agreement_plot: Agreement_Plot;
  agreementplot_id: Scalars['Int'];
  /** An object relationship */
  guarantor_agreement: Guarantor_Agreement;
  guarantoragreement_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Aggregate = {
  __typename?: 'guarantor_agreement_agreement_plots_aggregate';
  aggregate?: Maybe<Guarantor_Agreement_Agreement_Plots_Aggregate_Fields>;
  nodes: Array<Guarantor_Agreement_Agreement_Plots>;
};

/** aggregate fields of "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Aggregate_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_aggregate_fields';
  avg?: Maybe<Guarantor_Agreement_Agreement_Plots_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Guarantor_Agreement_Agreement_Plots_Max_Fields>;
  min?: Maybe<Guarantor_Agreement_Agreement_Plots_Min_Fields>;
  stddev?: Maybe<Guarantor_Agreement_Agreement_Plots_Stddev_Fields>;
  stddev_pop?: Maybe<Guarantor_Agreement_Agreement_Plots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Guarantor_Agreement_Agreement_Plots_Stddev_Samp_Fields>;
  sum?: Maybe<Guarantor_Agreement_Agreement_Plots_Sum_Fields>;
  var_pop?: Maybe<Guarantor_Agreement_Agreement_Plots_Var_Pop_Fields>;
  var_samp?: Maybe<Guarantor_Agreement_Agreement_Plots_Var_Samp_Fields>;
  variance?: Maybe<Guarantor_Agreement_Agreement_Plots_Variance_Fields>;
};


/** aggregate fields of "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Aggregate_Order_By = {
  avg?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Max_Order_By>;
  min?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Min_Order_By>;
  stddev?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Sum_Order_By>;
  var_pop?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Var_Samp_Order_By>;
  variance?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Arr_Rel_Insert_Input = {
  data: Array<Guarantor_Agreement_Agreement_Plots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Guarantor_Agreement_Agreement_Plots_On_Conflict>;
};

/** aggregate avg on columns */
export type Guarantor_Agreement_Agreement_Plots_Avg_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_avg_fields';
  agreementplot_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Avg_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "guarantor_agreement_agreement_plots". All fields are combined with a logical 'AND'. */
export type Guarantor_Agreement_Agreement_Plots_Bool_Exp = {
  _and?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Bool_Exp>>;
  _not?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
  _or?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Bool_Exp>>;
  agreement_plot?: InputMaybe<Agreement_Plot_Bool_Exp>;
  agreementplot_id?: InputMaybe<Int_Comparison_Exp>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
  guarantoragreement_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "guarantor_agreement_agreement_plots" */
export enum Guarantor_Agreement_Agreement_Plots_Constraint {
  /** unique or primary key constraint on columns "agreementplot_id", "guarantoragreement_id" */
  GuarantorAgreementAgreGuarantoragreementIdAg_7bd5dbbcUniq = 'guarantor_agreement_agre_guarantoragreement_id_ag_7bd5dbbc_uniq',
  /** unique or primary key constraint on columns "id" */
  GuarantorAgreementAgreementPlotsPkey = 'guarantor_agreement_agreement_plots_pkey'
}

/** input type for incrementing numeric columns in table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Inc_Input = {
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Insert_Input = {
  agreement_plot?: InputMaybe<Agreement_Plot_Obj_Rel_Insert_Input>;
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Obj_Rel_Insert_Input>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Guarantor_Agreement_Agreement_Plots_Max_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_max_fields';
  agreementplot_id?: Maybe<Scalars['Int']>;
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Max_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Guarantor_Agreement_Agreement_Plots_Min_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_min_fields';
  agreementplot_id?: Maybe<Scalars['Int']>;
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Min_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Mutation_Response = {
  __typename?: 'guarantor_agreement_agreement_plots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guarantor_Agreement_Agreement_Plots>;
};

/** on_conflict condition type for table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_On_Conflict = {
  constraint: Guarantor_Agreement_Agreement_Plots_Constraint;
  update_columns?: Array<Guarantor_Agreement_Agreement_Plots_Update_Column>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};

/** Ordering options when selecting data from "guarantor_agreement_agreement_plots". */
export type Guarantor_Agreement_Agreement_Plots_Order_By = {
  agreement_plot?: InputMaybe<Agreement_Plot_Order_By>;
  agreementplot_id?: InputMaybe<Order_By>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guarantor_agreement_agreement_plots */
export type Guarantor_Agreement_Agreement_Plots_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "guarantor_agreement_agreement_plots" */
export enum Guarantor_Agreement_Agreement_Plots_Select_Column {
  /** column name */
  AgreementplotId = 'agreementplot_id',
  /** column name */
  GuarantoragreementId = 'guarantoragreement_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Set_Input = {
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Guarantor_Agreement_Agreement_Plots_Stddev_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_stddev_fields';
  agreementplot_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Stddev_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Guarantor_Agreement_Agreement_Plots_Stddev_Pop_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_stddev_pop_fields';
  agreementplot_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Stddev_Pop_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Guarantor_Agreement_Agreement_Plots_Stddev_Samp_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_stddev_samp_fields';
  agreementplot_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Stddev_Samp_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guarantor_Agreement_Agreement_Plots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guarantor_Agreement_Agreement_Plots_Stream_Cursor_Value_Input = {
  agreementplot_id?: InputMaybe<Scalars['Int']>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Guarantor_Agreement_Agreement_Plots_Sum_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_sum_fields';
  agreementplot_id?: Maybe<Scalars['Int']>;
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Sum_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "guarantor_agreement_agreement_plots" */
export enum Guarantor_Agreement_Agreement_Plots_Update_Column {
  /** column name */
  AgreementplotId = 'agreementplot_id',
  /** column name */
  GuarantoragreementId = 'guarantoragreement_id',
  /** column name */
  Id = 'id'
}

export type Guarantor_Agreement_Agreement_Plots_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Set_Input>;
  where: Guarantor_Agreement_Agreement_Plots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Guarantor_Agreement_Agreement_Plots_Var_Pop_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_var_pop_fields';
  agreementplot_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Var_Pop_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Guarantor_Agreement_Agreement_Plots_Var_Samp_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_var_samp_fields';
  agreementplot_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Var_Samp_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Guarantor_Agreement_Agreement_Plots_Variance_Fields = {
  __typename?: 'guarantor_agreement_agreement_plots_variance_fields';
  agreementplot_id?: Maybe<Scalars['Float']>;
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "guarantor_agreement_agreement_plots" */
export type Guarantor_Agreement_Agreement_Plots_Variance_Order_By = {
  agreementplot_id?: InputMaybe<Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Guarantor_Agreement_Append_Input = {
  guarantors?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  plot_coverage?: InputMaybe<Scalars['jsonb']>;
  witnesses?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail = {
  __typename?: 'guarantor_agreement_area_extension_detail';
  additional_area: Scalars['numeric'];
  /** An object relationship */
  agreement_plot: Agreement_Plot;
  agreement_plot_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  guarantor_agreement: Guarantor_Agreement;
  guarantor_agreement_id: Scalars['Int'];
  id: Scalars['Int'];
  new_area: Scalars['numeric'];
  nursery_amount: Scalars['numeric'];
  old_area: Scalars['numeric'];
  registration_amount: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Aggregate = {
  __typename?: 'guarantor_agreement_area_extension_detail_aggregate';
  aggregate?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Aggregate_Fields>;
  nodes: Array<Guarantor_Agreement_Area_Extension_Detail>;
};

/** aggregate fields of "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Aggregate_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_aggregate_fields';
  avg?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Max_Fields>;
  min?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Min_Fields>;
  stddev?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Sum_Fields>;
  var_pop?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Var_Samp_Fields>;
  variance?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Variance_Fields>;
};


/** aggregate fields of "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Max_Order_By>;
  min?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Min_Order_By>;
  stddev?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Arr_Rel_Insert_Input = {
  data: Array<Guarantor_Agreement_Area_Extension_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_On_Conflict>;
};

/** aggregate avg on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Avg_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_avg_fields';
  additional_area?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  guarantor_agreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  new_area?: Maybe<Scalars['Float']>;
  nursery_amount?: Maybe<Scalars['Float']>;
  old_area?: Maybe<Scalars['Float']>;
  registration_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Avg_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "guarantor_agreement_area_extension_detail". All fields are combined with a logical 'AND'. */
export type Guarantor_Agreement_Area_Extension_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>>;
  _not?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>>;
  additional_area?: InputMaybe<Numeric_Comparison_Exp>;
  agreement_plot?: InputMaybe<Agreement_Plot_Bool_Exp>;
  agreement_plot_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
  guarantor_agreement_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  new_area?: InputMaybe<Numeric_Comparison_Exp>;
  nursery_amount?: InputMaybe<Numeric_Comparison_Exp>;
  old_area?: InputMaybe<Numeric_Comparison_Exp>;
  registration_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "guarantor_agreement_area_extension_detail" */
export enum Guarantor_Agreement_Area_Extension_Detail_Constraint {
  /** unique or primary key constraint on columns "id" */
  GuarantorAgreementAreaExtensionDetailPkey = 'guarantor_agreement_area_extension_detail_pkey',
  /** unique or primary key constraint on columns "agreement_plot_id", "guarantor_agreement_id" */
  UniqueGuarantorAgreementAreaExtensionPlot = 'unique_guarantor_agreement_area_extension_plot'
}

/** input type for incrementing numeric columns in table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Inc_Input = {
  additional_area?: InputMaybe<Scalars['numeric']>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  guarantor_agreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  new_area?: InputMaybe<Scalars['numeric']>;
  nursery_amount?: InputMaybe<Scalars['numeric']>;
  old_area?: InputMaybe<Scalars['numeric']>;
  registration_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Insert_Input = {
  additional_area?: InputMaybe<Scalars['numeric']>;
  agreement_plot?: InputMaybe<Agreement_Plot_Obj_Rel_Insert_Input>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Obj_Rel_Insert_Input>;
  guarantor_agreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  new_area?: InputMaybe<Scalars['numeric']>;
  nursery_amount?: InputMaybe<Scalars['numeric']>;
  old_area?: InputMaybe<Scalars['numeric']>;
  registration_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Max_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_max_fields';
  additional_area?: Maybe<Scalars['numeric']>;
  agreement_plot_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  guarantor_agreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  new_area?: Maybe<Scalars['numeric']>;
  nursery_amount?: Maybe<Scalars['numeric']>;
  old_area?: Maybe<Scalars['numeric']>;
  registration_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Max_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Min_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_min_fields';
  additional_area?: Maybe<Scalars['numeric']>;
  agreement_plot_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  guarantor_agreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  new_area?: Maybe<Scalars['numeric']>;
  nursery_amount?: Maybe<Scalars['numeric']>;
  old_area?: Maybe<Scalars['numeric']>;
  registration_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Min_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Mutation_Response = {
  __typename?: 'guarantor_agreement_area_extension_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guarantor_Agreement_Area_Extension_Detail>;
};

/** on_conflict condition type for table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_On_Conflict = {
  constraint: Guarantor_Agreement_Area_Extension_Detail_Constraint;
  update_columns?: Array<Guarantor_Agreement_Area_Extension_Detail_Update_Column>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "guarantor_agreement_area_extension_detail". */
export type Guarantor_Agreement_Area_Extension_Detail_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot?: InputMaybe<Agreement_Plot_Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guarantor_agreement_area_extension_detail */
export type Guarantor_Agreement_Area_Extension_Detail_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "guarantor_agreement_area_extension_detail" */
export enum Guarantor_Agreement_Area_Extension_Detail_Select_Column {
  /** column name */
  AdditionalArea = 'additional_area',
  /** column name */
  AgreementPlotId = 'agreement_plot_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuarantorAgreementId = 'guarantor_agreement_id',
  /** column name */
  Id = 'id',
  /** column name */
  NewArea = 'new_area',
  /** column name */
  NurseryAmount = 'nursery_amount',
  /** column name */
  OldArea = 'old_area',
  /** column name */
  RegistrationAmount = 'registration_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Set_Input = {
  additional_area?: InputMaybe<Scalars['numeric']>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guarantor_agreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  new_area?: InputMaybe<Scalars['numeric']>;
  nursery_amount?: InputMaybe<Scalars['numeric']>;
  old_area?: InputMaybe<Scalars['numeric']>;
  registration_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Stddev_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_stddev_fields';
  additional_area?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  guarantor_agreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  new_area?: Maybe<Scalars['Float']>;
  nursery_amount?: Maybe<Scalars['Float']>;
  old_area?: Maybe<Scalars['Float']>;
  registration_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Stddev_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Stddev_Pop_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_stddev_pop_fields';
  additional_area?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  guarantor_agreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  new_area?: Maybe<Scalars['Float']>;
  nursery_amount?: Maybe<Scalars['Float']>;
  old_area?: Maybe<Scalars['Float']>;
  registration_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Stddev_Pop_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Stddev_Samp_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_stddev_samp_fields';
  additional_area?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  guarantor_agreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  new_area?: Maybe<Scalars['Float']>;
  nursery_amount?: Maybe<Scalars['Float']>;
  old_area?: Maybe<Scalars['Float']>;
  registration_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Stddev_Samp_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guarantor_Agreement_Area_Extension_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guarantor_Agreement_Area_Extension_Detail_Stream_Cursor_Value_Input = {
  additional_area?: InputMaybe<Scalars['numeric']>;
  agreement_plot_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guarantor_agreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  new_area?: InputMaybe<Scalars['numeric']>;
  nursery_amount?: InputMaybe<Scalars['numeric']>;
  old_area?: InputMaybe<Scalars['numeric']>;
  registration_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Sum_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_sum_fields';
  additional_area?: Maybe<Scalars['numeric']>;
  agreement_plot_id?: Maybe<Scalars['Int']>;
  guarantor_agreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  new_area?: Maybe<Scalars['numeric']>;
  nursery_amount?: Maybe<Scalars['numeric']>;
  old_area?: Maybe<Scalars['numeric']>;
  registration_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Sum_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** update columns of table "guarantor_agreement_area_extension_detail" */
export enum Guarantor_Agreement_Area_Extension_Detail_Update_Column {
  /** column name */
  AdditionalArea = 'additional_area',
  /** column name */
  AgreementPlotId = 'agreement_plot_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuarantorAgreementId = 'guarantor_agreement_id',
  /** column name */
  Id = 'id',
  /** column name */
  NewArea = 'new_area',
  /** column name */
  NurseryAmount = 'nursery_amount',
  /** column name */
  OldArea = 'old_area',
  /** column name */
  RegistrationAmount = 'registration_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Guarantor_Agreement_Area_Extension_Detail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Set_Input>;
  where: Guarantor_Agreement_Area_Extension_Detail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Var_Pop_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_var_pop_fields';
  additional_area?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  guarantor_agreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  new_area?: Maybe<Scalars['Float']>;
  nursery_amount?: Maybe<Scalars['Float']>;
  old_area?: Maybe<Scalars['Float']>;
  registration_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Var_Pop_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Var_Samp_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_var_samp_fields';
  additional_area?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  guarantor_agreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  new_area?: Maybe<Scalars['Float']>;
  nursery_amount?: Maybe<Scalars['Float']>;
  old_area?: Maybe<Scalars['Float']>;
  registration_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Var_Samp_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Guarantor_Agreement_Area_Extension_Detail_Variance_Fields = {
  __typename?: 'guarantor_agreement_area_extension_detail_variance_fields';
  additional_area?: Maybe<Scalars['Float']>;
  agreement_plot_id?: Maybe<Scalars['Float']>;
  guarantor_agreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  new_area?: Maybe<Scalars['Float']>;
  nursery_amount?: Maybe<Scalars['Float']>;
  old_area?: Maybe<Scalars['Float']>;
  registration_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "guarantor_agreement_area_extension_detail" */
export type Guarantor_Agreement_Area_Extension_Detail_Variance_Order_By = {
  additional_area?: InputMaybe<Order_By>;
  agreement_plot_id?: InputMaybe<Order_By>;
  guarantor_agreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_area?: InputMaybe<Order_By>;
  nursery_amount?: InputMaybe<Order_By>;
  old_area?: InputMaybe<Order_By>;
  registration_amount?: InputMaybe<Order_By>;
};

/** input type for inserting array relation for remote table "guarantor_agreement" */
export type Guarantor_Agreement_Arr_Rel_Insert_Input = {
  data: Array<Guarantor_Agreement_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Guarantor_Agreement_On_Conflict>;
};

/** aggregate avg on columns */
export type Guarantor_Agreement_Avg_Fields = {
  __typename?: 'guarantor_agreement_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legal_agreement_id?: Maybe<Scalars['Float']>;
  payable_additional_amount?: Maybe<Scalars['Float']>;
  previous_amount?: Maybe<Scalars['Float']>;
  total_agreement_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "guarantor_agreement". All fields are combined with a logical 'AND'. */
export type Guarantor_Agreement_Bool_Exp = {
  _and?: InputMaybe<Array<Guarantor_Agreement_Bool_Exp>>;
  _not?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
  _or?: InputMaybe<Array<Guarantor_Agreement_Bool_Exp>>;
  agreement_invoices?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
  agreement_plots?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
  agreement_type?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  area_extension_details?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  guarantee_nursery_fee?: InputMaybe<Boolean_Comparison_Exp>;
  guarantee_registration_fee?: InputMaybe<Boolean_Comparison_Exp>;
  guarantors?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  legal_agreement?: InputMaybe<Legal_Agreement_Bool_Exp>;
  legal_agreement_id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  payable_additional_amount?: InputMaybe<Numeric_Comparison_Exp>;
  plot_coverage?: InputMaybe<Jsonb_Comparison_Exp>;
  previous_amount?: InputMaybe<Numeric_Comparison_Exp>;
  reason_for_amendment?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_agreement_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variety_agreements?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
  witnesses?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "guarantor_agreement" */
export enum Guarantor_Agreement_Constraint {
  /** unique or primary key constraint on columns "codename" */
  GuarantorAgreementCodenameKey = 'guarantor_agreement_codename_key',
  /** unique or primary key constraint on columns "id" */
  GuarantorAgreementPkey = 'guarantor_agreement_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Guarantor_Agreement_Delete_At_Path_Input = {
  guarantors?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
  plot_coverage?: InputMaybe<Array<Scalars['String']>>;
  witnesses?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Guarantor_Agreement_Delete_Elem_Input = {
  guarantors?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
  plot_coverage?: InputMaybe<Scalars['Int']>;
  witnesses?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Guarantor_Agreement_Delete_Key_Input = {
  guarantors?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
  plot_coverage?: InputMaybe<Scalars['String']>;
  witnesses?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "guarantor_agreement" */
export type Guarantor_Agreement_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  legal_agreement_id?: InputMaybe<Scalars['Int']>;
  payable_additional_amount?: InputMaybe<Scalars['numeric']>;
  previous_amount?: InputMaybe<Scalars['numeric']>;
  total_agreement_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "guarantor_agreement" */
export type Guarantor_Agreement_Insert_Input = {
  agreement_invoices?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Arr_Rel_Insert_Input>;
  agreement_plots?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Arr_Rel_Insert_Input>;
  agreement_type?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  area_extension_details?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guarantee_nursery_fee?: InputMaybe<Scalars['Boolean']>;
  guarantee_registration_fee?: InputMaybe<Scalars['Boolean']>;
  guarantors?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  legal_agreement?: InputMaybe<Legal_Agreement_Obj_Rel_Insert_Input>;
  legal_agreement_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payable_additional_amount?: InputMaybe<Scalars['numeric']>;
  plot_coverage?: InputMaybe<Scalars['jsonb']>;
  previous_amount?: InputMaybe<Scalars['numeric']>;
  reason_for_amendment?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_agreement_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety_agreements?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Arr_Rel_Insert_Input>;
  witnesses?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Guarantor_Agreement_Max_Fields = {
  __typename?: 'guarantor_agreement_max_fields';
  agreement_type?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  legal_agreement_id?: Maybe<Scalars['Int']>;
  payable_additional_amount?: Maybe<Scalars['numeric']>;
  previous_amount?: Maybe<Scalars['numeric']>;
  reason_for_amendment?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_agreement_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Max_Order_By = {
  agreement_type?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  reason_for_amendment?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Guarantor_Agreement_Min_Fields = {
  __typename?: 'guarantor_agreement_min_fields';
  agreement_type?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  legal_agreement_id?: Maybe<Scalars['Int']>;
  payable_additional_amount?: Maybe<Scalars['numeric']>;
  previous_amount?: Maybe<Scalars['numeric']>;
  reason_for_amendment?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_agreement_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Min_Order_By = {
  agreement_type?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  reason_for_amendment?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "guarantor_agreement" */
export type Guarantor_Agreement_Mutation_Response = {
  __typename?: 'guarantor_agreement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Guarantor_Agreement>;
};

/** input type for inserting object relation for remote table "guarantor_agreement" */
export type Guarantor_Agreement_Obj_Rel_Insert_Input = {
  data: Guarantor_Agreement_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Guarantor_Agreement_On_Conflict>;
};

/** on_conflict condition type for table "guarantor_agreement" */
export type Guarantor_Agreement_On_Conflict = {
  constraint: Guarantor_Agreement_Constraint;
  update_columns?: Array<Guarantor_Agreement_Update_Column>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};

/** Ordering options when selecting data from "guarantor_agreement". */
export type Guarantor_Agreement_Order_By = {
  agreement_invoices_aggregate?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Aggregate_Order_By>;
  agreement_plots_aggregate?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Aggregate_Order_By>;
  agreement_type?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  area_extension_details_aggregate?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  guarantee_nursery_fee?: InputMaybe<Order_By>;
  guarantee_registration_fee?: InputMaybe<Order_By>;
  guarantors?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement?: InputMaybe<Legal_Agreement_Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  plot_coverage?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  reason_for_amendment?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_agreements_aggregate?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Aggregate_Order_By>;
  witnesses?: InputMaybe<Order_By>;
};

/** primary key columns input for table: guarantor_agreement */
export type Guarantor_Agreement_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Guarantor_Agreement_Prepend_Input = {
  guarantors?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  plot_coverage?: InputMaybe<Scalars['jsonb']>;
  witnesses?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "guarantor_agreement" */
export enum Guarantor_Agreement_Select_Column {
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  Amount = 'amount',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuaranteeNurseryFee = 'guarantee_nursery_fee',
  /** column name */
  GuaranteeRegistrationFee = 'guarantee_registration_fee',
  /** column name */
  Guarantors = 'guarantors',
  /** column name */
  Id = 'id',
  /** column name */
  LegalAgreementId = 'legal_agreement_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PayableAdditionalAmount = 'payable_additional_amount',
  /** column name */
  PlotCoverage = 'plot_coverage',
  /** column name */
  PreviousAmount = 'previous_amount',
  /** column name */
  ReasonForAmendment = 'reason_for_amendment',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAgreementAmount = 'total_agreement_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Witnesses = 'witnesses'
}

/** input type for updating data in table "guarantor_agreement" */
export type Guarantor_Agreement_Set_Input = {
  agreement_type?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guarantee_nursery_fee?: InputMaybe<Scalars['Boolean']>;
  guarantee_registration_fee?: InputMaybe<Scalars['Boolean']>;
  guarantors?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  legal_agreement_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payable_additional_amount?: InputMaybe<Scalars['numeric']>;
  plot_coverage?: InputMaybe<Scalars['jsonb']>;
  previous_amount?: InputMaybe<Scalars['numeric']>;
  reason_for_amendment?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_agreement_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  witnesses?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Guarantor_Agreement_Stddev_Fields = {
  __typename?: 'guarantor_agreement_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legal_agreement_id?: Maybe<Scalars['Float']>;
  payable_additional_amount?: Maybe<Scalars['Float']>;
  previous_amount?: Maybe<Scalars['Float']>;
  total_agreement_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Guarantor_Agreement_Stddev_Pop_Fields = {
  __typename?: 'guarantor_agreement_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legal_agreement_id?: Maybe<Scalars['Float']>;
  payable_additional_amount?: Maybe<Scalars['Float']>;
  previous_amount?: Maybe<Scalars['Float']>;
  total_agreement_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Guarantor_Agreement_Stddev_Samp_Fields = {
  __typename?: 'guarantor_agreement_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legal_agreement_id?: Maybe<Scalars['Float']>;
  payable_additional_amount?: Maybe<Scalars['Float']>;
  previous_amount?: Maybe<Scalars['Float']>;
  total_agreement_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "guarantor_agreement" */
export type Guarantor_Agreement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Guarantor_Agreement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Guarantor_Agreement_Stream_Cursor_Value_Input = {
  agreement_type?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  guarantee_nursery_fee?: InputMaybe<Scalars['Boolean']>;
  guarantee_registration_fee?: InputMaybe<Scalars['Boolean']>;
  guarantors?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  legal_agreement_id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  payable_additional_amount?: InputMaybe<Scalars['numeric']>;
  plot_coverage?: InputMaybe<Scalars['jsonb']>;
  previous_amount?: InputMaybe<Scalars['numeric']>;
  reason_for_amendment?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_agreement_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  witnesses?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Guarantor_Agreement_Sum_Fields = {
  __typename?: 'guarantor_agreement_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  legal_agreement_id?: Maybe<Scalars['Int']>;
  payable_additional_amount?: Maybe<Scalars['numeric']>;
  previous_amount?: Maybe<Scalars['numeric']>;
  total_agreement_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** update columns of table "guarantor_agreement" */
export enum Guarantor_Agreement_Update_Column {
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  Amount = 'amount',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GuaranteeNurseryFee = 'guarantee_nursery_fee',
  /** column name */
  GuaranteeRegistrationFee = 'guarantee_registration_fee',
  /** column name */
  Guarantors = 'guarantors',
  /** column name */
  Id = 'id',
  /** column name */
  LegalAgreementId = 'legal_agreement_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  PayableAdditionalAmount = 'payable_additional_amount',
  /** column name */
  PlotCoverage = 'plot_coverage',
  /** column name */
  PreviousAmount = 'previous_amount',
  /** column name */
  ReasonForAmendment = 'reason_for_amendment',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAgreementAmount = 'total_agreement_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Witnesses = 'witnesses'
}

export type Guarantor_Agreement_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Guarantor_Agreement_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Guarantor_Agreement_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Guarantor_Agreement_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Guarantor_Agreement_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Guarantor_Agreement_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Guarantor_Agreement_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Guarantor_Agreement_Set_Input>;
  where: Guarantor_Agreement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Guarantor_Agreement_Var_Pop_Fields = {
  __typename?: 'guarantor_agreement_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legal_agreement_id?: Maybe<Scalars['Float']>;
  payable_additional_amount?: Maybe<Scalars['Float']>;
  previous_amount?: Maybe<Scalars['Float']>;
  total_agreement_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Guarantor_Agreement_Var_Samp_Fields = {
  __typename?: 'guarantor_agreement_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legal_agreement_id?: Maybe<Scalars['Float']>;
  payable_additional_amount?: Maybe<Scalars['Float']>;
  previous_amount?: Maybe<Scalars['Float']>;
  total_agreement_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Guarantor_Agreement_Variance_Fields = {
  __typename?: 'guarantor_agreement_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  legal_agreement_id?: Maybe<Scalars['Float']>;
  payable_additional_amount?: Maybe<Scalars['Float']>;
  previous_amount?: Maybe<Scalars['Float']>;
  total_agreement_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "guarantor_agreement" */
export type Guarantor_Agreement_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_agreement_id?: InputMaybe<Order_By>;
  payable_additional_amount?: InputMaybe<Order_By>;
  previous_amount?: InputMaybe<Order_By>;
  total_agreement_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "infestation" */
export type Infestation = {
  __typename?: 'infestation';
  category: Scalars['String'];
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  scientific_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "infestation" */
export type Infestation_Aggregate = {
  __typename?: 'infestation_aggregate';
  aggregate?: Maybe<Infestation_Aggregate_Fields>;
  nodes: Array<Infestation>;
};

/** aggregate fields of "infestation" */
export type Infestation_Aggregate_Fields = {
  __typename?: 'infestation_aggregate_fields';
  avg?: Maybe<Infestation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Infestation_Max_Fields>;
  min?: Maybe<Infestation_Min_Fields>;
  stddev?: Maybe<Infestation_Stddev_Fields>;
  stddev_pop?: Maybe<Infestation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Infestation_Stddev_Samp_Fields>;
  sum?: Maybe<Infestation_Sum_Fields>;
  var_pop?: Maybe<Infestation_Var_Pop_Fields>;
  var_samp?: Maybe<Infestation_Var_Samp_Fields>;
  variance?: Maybe<Infestation_Variance_Fields>;
};


/** aggregate fields of "infestation" */
export type Infestation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Infestation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Infestation_Avg_Fields = {
  __typename?: 'infestation_avg_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "infestation". All fields are combined with a logical 'AND'. */
export type Infestation_Bool_Exp = {
  _and?: InputMaybe<Array<Infestation_Bool_Exp>>;
  _not?: InputMaybe<Infestation_Bool_Exp>;
  _or?: InputMaybe<Array<Infestation_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  scientific_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "infestation" */
export enum Infestation_Constraint {
  /** unique or primary key constraint on columns "codename" */
  InfestationCodenameKey = 'infestation_codename_key',
  /** unique or primary key constraint on columns "name", "category" */
  InfestationNameCategory_8ba9554bUniq = 'infestation_name_category_8ba9554b_uniq',
  /** unique or primary key constraint on columns "id" */
  InfestationPkey = 'infestation_pkey'
}

/** input type for incrementing numeric columns in table "infestation" */
export type Infestation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "infestation" */
export type Infestation_Insert_Input = {
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  scientific_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Infestation_Max_Fields = {
  __typename?: 'infestation_max_fields';
  category?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  scientific_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Infestation_Min_Fields = {
  __typename?: 'infestation_min_fields';
  category?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  scientific_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "infestation" */
export type Infestation_Mutation_Response = {
  __typename?: 'infestation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Infestation>;
};

/** input type for inserting object relation for remote table "infestation" */
export type Infestation_Obj_Rel_Insert_Input = {
  data: Infestation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Infestation_On_Conflict>;
};

/** on_conflict condition type for table "infestation" */
export type Infestation_On_Conflict = {
  constraint: Infestation_Constraint;
  update_columns?: Array<Infestation_Update_Column>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};

/** Ordering options when selecting data from "infestation". */
export type Infestation_Order_By = {
  category?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  scientific_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: infestation */
export type Infestation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "infestation" */
export enum Infestation_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  ScientificName = 'scientific_name'
}

/** input type for updating data in table "infestation" */
export type Infestation_Set_Input = {
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  scientific_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Infestation_Stddev_Fields = {
  __typename?: 'infestation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Infestation_Stddev_Pop_Fields = {
  __typename?: 'infestation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Infestation_Stddev_Samp_Fields = {
  __typename?: 'infestation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "infestation" */
export type Infestation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Infestation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Infestation_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  scientific_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Infestation_Sum_Fields = {
  __typename?: 'infestation_sum_fields';
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "infestation" */
export enum Infestation_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  ScientificName = 'scientific_name'
}

export type Infestation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Infestation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Infestation_Set_Input>;
  where: Infestation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Infestation_Var_Pop_Fields = {
  __typename?: 'infestation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Infestation_Var_Samp_Fields = {
  __typename?: 'infestation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Infestation_Variance_Fields = {
  __typename?: 'infestation_variance_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "instrument" */
export type Instrument = {
  __typename?: 'instrument';
  codename: Scalars['String'];
  /** An array relationship */
  departments: Array<Instrument_Departments>;
  /** An aggregate relationship */
  departments_aggregate: Instrument_Departments_Aggregate;
  description: Scalars['String'];
  id: Scalars['bigint'];
  /** An object relationship */
  instrument_kind: Instrument_Kind;
  instrument_kind_id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  observations: Array<Sample_Observation>;
  /** An aggregate relationship */
  observations_aggregate: Sample_Observation_Aggregate;
  /** An object relationship */
  organisation?: Maybe<External_Entity>;
  organisation_id?: Maybe<Scalars['bigint']>;
  uid: Scalars['String'];
};


/** columns and relationships of "instrument" */
export type InstrumentDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Departments_Order_By>>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};


/** columns and relationships of "instrument" */
export type InstrumentDepartments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Departments_Order_By>>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};


/** columns and relationships of "instrument" */
export type InstrumentObservationsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


/** columns and relationships of "instrument" */
export type InstrumentObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};

/** aggregated selection of "instrument" */
export type Instrument_Aggregate = {
  __typename?: 'instrument_aggregate';
  aggregate?: Maybe<Instrument_Aggregate_Fields>;
  nodes: Array<Instrument>;
};

/** aggregate fields of "instrument" */
export type Instrument_Aggregate_Fields = {
  __typename?: 'instrument_aggregate_fields';
  avg?: Maybe<Instrument_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Instrument_Max_Fields>;
  min?: Maybe<Instrument_Min_Fields>;
  stddev?: Maybe<Instrument_Stddev_Fields>;
  stddev_pop?: Maybe<Instrument_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Instrument_Stddev_Samp_Fields>;
  sum?: Maybe<Instrument_Sum_Fields>;
  var_pop?: Maybe<Instrument_Var_Pop_Fields>;
  var_samp?: Maybe<Instrument_Var_Samp_Fields>;
  variance?: Maybe<Instrument_Variance_Fields>;
};


/** aggregate fields of "instrument" */
export type Instrument_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Instrument_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "instrument" */
export type Instrument_Aggregate_Order_By = {
  avg?: InputMaybe<Instrument_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Instrument_Max_Order_By>;
  min?: InputMaybe<Instrument_Min_Order_By>;
  stddev?: InputMaybe<Instrument_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Instrument_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Instrument_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Instrument_Sum_Order_By>;
  var_pop?: InputMaybe<Instrument_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Instrument_Var_Samp_Order_By>;
  variance?: InputMaybe<Instrument_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "instrument" */
export type Instrument_Arr_Rel_Insert_Input = {
  data: Array<Instrument_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Instrument_On_Conflict>;
};

/** aggregate avg on columns */
export type Instrument_Avg_Fields = {
  __typename?: 'instrument_avg_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "instrument" */
export type Instrument_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "instrument". All fields are combined with a logical 'AND'. */
export type Instrument_Bool_Exp = {
  _and?: InputMaybe<Array<Instrument_Bool_Exp>>;
  _not?: InputMaybe<Instrument_Bool_Exp>;
  _or?: InputMaybe<Array<Instrument_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  departments?: InputMaybe<Instrument_Departments_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  instrument_kind?: InputMaybe<Instrument_Kind_Bool_Exp>;
  instrument_kind_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<Sample_Observation_Bool_Exp>;
  organisation?: InputMaybe<External_Entity_Bool_Exp>;
  organisation_id?: InputMaybe<Bigint_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "instrument" */
export enum Instrument_Constraint {
  /** unique or primary key constraint on columns "codename" */
  InstrumentCodenameKey = 'instrument_codename_key',
  /** unique or primary key constraint on columns "organisation_id", "uid", "instrument_kind_id" */
  InstrumentInstrumentKindIdUidOrganisationId_85bcbee9Uniq = 'instrument_instrument_kind_id_uid_organisation_id_85bcbee9_uniq',
  /** unique or primary key constraint on columns "id" */
  InstrumentPkey = 'instrument_pkey'
}

/** columns and relationships of "instrument_departments" */
export type Instrument_Departments = {
  __typename?: 'instrument_departments';
  /** An object relationship */
  department: External_Entity;
  externalentity_id: Scalars['bigint'];
  id: Scalars['bigint'];
  instrument_id: Scalars['bigint'];
};

/** aggregated selection of "instrument_departments" */
export type Instrument_Departments_Aggregate = {
  __typename?: 'instrument_departments_aggregate';
  aggregate?: Maybe<Instrument_Departments_Aggregate_Fields>;
  nodes: Array<Instrument_Departments>;
};

/** aggregate fields of "instrument_departments" */
export type Instrument_Departments_Aggregate_Fields = {
  __typename?: 'instrument_departments_aggregate_fields';
  avg?: Maybe<Instrument_Departments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Instrument_Departments_Max_Fields>;
  min?: Maybe<Instrument_Departments_Min_Fields>;
  stddev?: Maybe<Instrument_Departments_Stddev_Fields>;
  stddev_pop?: Maybe<Instrument_Departments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Instrument_Departments_Stddev_Samp_Fields>;
  sum?: Maybe<Instrument_Departments_Sum_Fields>;
  var_pop?: Maybe<Instrument_Departments_Var_Pop_Fields>;
  var_samp?: Maybe<Instrument_Departments_Var_Samp_Fields>;
  variance?: Maybe<Instrument_Departments_Variance_Fields>;
};


/** aggregate fields of "instrument_departments" */
export type Instrument_Departments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Instrument_Departments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "instrument_departments" */
export type Instrument_Departments_Aggregate_Order_By = {
  avg?: InputMaybe<Instrument_Departments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Instrument_Departments_Max_Order_By>;
  min?: InputMaybe<Instrument_Departments_Min_Order_By>;
  stddev?: InputMaybe<Instrument_Departments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Instrument_Departments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Instrument_Departments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Instrument_Departments_Sum_Order_By>;
  var_pop?: InputMaybe<Instrument_Departments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Instrument_Departments_Var_Samp_Order_By>;
  variance?: InputMaybe<Instrument_Departments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "instrument_departments" */
export type Instrument_Departments_Arr_Rel_Insert_Input = {
  data: Array<Instrument_Departments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Instrument_Departments_On_Conflict>;
};

/** aggregate avg on columns */
export type Instrument_Departments_Avg_Fields = {
  __typename?: 'instrument_departments_avg_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "instrument_departments" */
export type Instrument_Departments_Avg_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "instrument_departments". All fields are combined with a logical 'AND'. */
export type Instrument_Departments_Bool_Exp = {
  _and?: InputMaybe<Array<Instrument_Departments_Bool_Exp>>;
  _not?: InputMaybe<Instrument_Departments_Bool_Exp>;
  _or?: InputMaybe<Array<Instrument_Departments_Bool_Exp>>;
  department?: InputMaybe<External_Entity_Bool_Exp>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  instrument_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "instrument_departments" */
export enum Instrument_Departments_Constraint {
  /** unique or primary key constraint on columns "externalentity_id", "instrument_id" */
  InstrumentDepartmentsInstrumentIdExternalenBd352b73Uniq = 'instrument_departments_instrument_id_externalen_bd352b73_uniq',
  /** unique or primary key constraint on columns "id" */
  InstrumentDepartmentsPkey = 'instrument_departments_pkey'
}

/** input type for incrementing numeric columns in table "instrument_departments" */
export type Instrument_Departments_Inc_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "instrument_departments" */
export type Instrument_Departments_Insert_Input = {
  department?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Instrument_Departments_Max_Fields = {
  __typename?: 'instrument_departments_max_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "instrument_departments" */
export type Instrument_Departments_Max_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Instrument_Departments_Min_Fields = {
  __typename?: 'instrument_departments_min_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "instrument_departments" */
export type Instrument_Departments_Min_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "instrument_departments" */
export type Instrument_Departments_Mutation_Response = {
  __typename?: 'instrument_departments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Instrument_Departments>;
};

/** on_conflict condition type for table "instrument_departments" */
export type Instrument_Departments_On_Conflict = {
  constraint: Instrument_Departments_Constraint;
  update_columns?: Array<Instrument_Departments_Update_Column>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};

/** Ordering options when selecting data from "instrument_departments". */
export type Instrument_Departments_Order_By = {
  department?: InputMaybe<External_Entity_Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: instrument_departments */
export type Instrument_Departments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "instrument_departments" */
export enum Instrument_Departments_Select_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentId = 'instrument_id'
}

/** input type for updating data in table "instrument_departments" */
export type Instrument_Departments_Set_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Instrument_Departments_Stddev_Fields = {
  __typename?: 'instrument_departments_stddev_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "instrument_departments" */
export type Instrument_Departments_Stddev_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Instrument_Departments_Stddev_Pop_Fields = {
  __typename?: 'instrument_departments_stddev_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "instrument_departments" */
export type Instrument_Departments_Stddev_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Instrument_Departments_Stddev_Samp_Fields = {
  __typename?: 'instrument_departments_stddev_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "instrument_departments" */
export type Instrument_Departments_Stddev_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "instrument_departments" */
export type Instrument_Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Instrument_Departments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Instrument_Departments_Stream_Cursor_Value_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Instrument_Departments_Sum_Fields = {
  __typename?: 'instrument_departments_sum_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "instrument_departments" */
export type Instrument_Departments_Sum_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** update columns of table "instrument_departments" */
export enum Instrument_Departments_Update_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentId = 'instrument_id'
}

export type Instrument_Departments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Instrument_Departments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Instrument_Departments_Set_Input>;
  where: Instrument_Departments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Instrument_Departments_Var_Pop_Fields = {
  __typename?: 'instrument_departments_var_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "instrument_departments" */
export type Instrument_Departments_Var_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Instrument_Departments_Var_Samp_Fields = {
  __typename?: 'instrument_departments_var_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "instrument_departments" */
export type Instrument_Departments_Var_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Instrument_Departments_Variance_Fields = {
  __typename?: 'instrument_departments_variance_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "instrument_departments" */
export type Instrument_Departments_Variance_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "instrument" */
export type Instrument_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "instrument" */
export type Instrument_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Instrument_Departments_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind?: InputMaybe<Instrument_Kind_Obj_Rel_Insert_Input>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Sample_Observation_Arr_Rel_Insert_Input>;
  organisation?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "instrument_kind" */
export type Instrument_Kind = {
  __typename?: 'instrument_kind';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  /** An array relationship */
  instruments: Array<Instrument>;
  /** An aggregate relationship */
  instruments_aggregate: Instrument_Aggregate;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  quality_parameters: Array<Quality_Parameter>;
  /** An aggregate relationship */
  quality_parameters_aggregate: Quality_Parameter_Aggregate;
};


/** columns and relationships of "instrument_kind" */
export type Instrument_KindInstrumentsArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Order_By>>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};


/** columns and relationships of "instrument_kind" */
export type Instrument_KindInstruments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Order_By>>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};


/** columns and relationships of "instrument_kind" */
export type Instrument_KindQuality_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};


/** columns and relationships of "instrument_kind" */
export type Instrument_KindQuality_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};

/** aggregated selection of "instrument_kind" */
export type Instrument_Kind_Aggregate = {
  __typename?: 'instrument_kind_aggregate';
  aggregate?: Maybe<Instrument_Kind_Aggregate_Fields>;
  nodes: Array<Instrument_Kind>;
};

/** aggregate fields of "instrument_kind" */
export type Instrument_Kind_Aggregate_Fields = {
  __typename?: 'instrument_kind_aggregate_fields';
  avg?: Maybe<Instrument_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Instrument_Kind_Max_Fields>;
  min?: Maybe<Instrument_Kind_Min_Fields>;
  stddev?: Maybe<Instrument_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Instrument_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Instrument_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Instrument_Kind_Sum_Fields>;
  var_pop?: Maybe<Instrument_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Instrument_Kind_Var_Samp_Fields>;
  variance?: Maybe<Instrument_Kind_Variance_Fields>;
};


/** aggregate fields of "instrument_kind" */
export type Instrument_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Instrument_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Instrument_Kind_Avg_Fields = {
  __typename?: 'instrument_kind_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "instrument_kind". All fields are combined with a logical 'AND'. */
export type Instrument_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Instrument_Kind_Bool_Exp>>;
  _not?: InputMaybe<Instrument_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Instrument_Kind_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  instruments?: InputMaybe<Instrument_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  quality_parameters?: InputMaybe<Quality_Parameter_Bool_Exp>;
};

/** unique or primary key constraints on table "instrument_kind" */
export enum Instrument_Kind_Constraint {
  /** unique or primary key constraint on columns "codename" */
  InstrumentKindCodenameKey = 'instrument_kind_codename_key',
  /** unique or primary key constraint on columns "name" */
  InstrumentKindNameKey = 'instrument_kind_name_key',
  /** unique or primary key constraint on columns "id" */
  InstrumentKindPkey = 'instrument_kind_pkey'
}

/** input type for incrementing numeric columns in table "instrument_kind" */
export type Instrument_Kind_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "instrument_kind" */
export type Instrument_Kind_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instruments?: InputMaybe<Instrument_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  quality_parameters?: InputMaybe<Quality_Parameter_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Instrument_Kind_Max_Fields = {
  __typename?: 'instrument_kind_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Instrument_Kind_Min_Fields = {
  __typename?: 'instrument_kind_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "instrument_kind" */
export type Instrument_Kind_Mutation_Response = {
  __typename?: 'instrument_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Instrument_Kind>;
};

/** input type for inserting object relation for remote table "instrument_kind" */
export type Instrument_Kind_Obj_Rel_Insert_Input = {
  data: Instrument_Kind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Instrument_Kind_On_Conflict>;
};

/** on_conflict condition type for table "instrument_kind" */
export type Instrument_Kind_On_Conflict = {
  constraint: Instrument_Kind_Constraint;
  update_columns?: Array<Instrument_Kind_Update_Column>;
  where?: InputMaybe<Instrument_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "instrument_kind". */
export type Instrument_Kind_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instruments_aggregate?: InputMaybe<Instrument_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  quality_parameters_aggregate?: InputMaybe<Quality_Parameter_Aggregate_Order_By>;
};

/** primary key columns input for table: instrument_kind */
export type Instrument_Kind_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "instrument_kind" */
export enum Instrument_Kind_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "instrument_kind" */
export type Instrument_Kind_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Instrument_Kind_Stddev_Fields = {
  __typename?: 'instrument_kind_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Instrument_Kind_Stddev_Pop_Fields = {
  __typename?: 'instrument_kind_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Instrument_Kind_Stddev_Samp_Fields = {
  __typename?: 'instrument_kind_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "instrument_kind" */
export type Instrument_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Instrument_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Instrument_Kind_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Instrument_Kind_Sum_Fields = {
  __typename?: 'instrument_kind_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "instrument_kind" */
export enum Instrument_Kind_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Instrument_Kind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Instrument_Kind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Instrument_Kind_Set_Input>;
  where: Instrument_Kind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Instrument_Kind_Var_Pop_Fields = {
  __typename?: 'instrument_kind_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Instrument_Kind_Var_Samp_Fields = {
  __typename?: 'instrument_kind_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Instrument_Kind_Variance_Fields = {
  __typename?: 'instrument_kind_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Instrument_Max_Fields = {
  __typename?: 'instrument_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_kind_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "instrument" */
export type Instrument_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Instrument_Min_Fields = {
  __typename?: 'instrument_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_kind_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "instrument" */
export type Instrument_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "instrument" */
export type Instrument_Mutation_Response = {
  __typename?: 'instrument_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Instrument>;
};

/** on_conflict condition type for table "instrument" */
export type Instrument_On_Conflict = {
  constraint: Instrument_Constraint;
  update_columns?: Array<Instrument_Update_Column>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};

/** Ordering options when selecting data from "instrument". */
export type Instrument_Order_By = {
  codename?: InputMaybe<Order_By>;
  departments_aggregate?: InputMaybe<Instrument_Departments_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind?: InputMaybe<Instrument_Kind_Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Sample_Observation_Aggregate_Order_By>;
  organisation?: InputMaybe<External_Entity_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: instrument */
export type Instrument_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "instrument" */
export enum Instrument_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentKindId = 'instrument_kind_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Uid = 'uid'
}

/** input type for updating data in table "instrument" */
export type Instrument_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Instrument_Stddev_Fields = {
  __typename?: 'instrument_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "instrument" */
export type Instrument_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Instrument_Stddev_Pop_Fields = {
  __typename?: 'instrument_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "instrument" */
export type Instrument_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Instrument_Stddev_Samp_Fields = {
  __typename?: 'instrument_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "instrument" */
export type Instrument_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "instrument" */
export type Instrument_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Instrument_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Instrument_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Instrument_Sum_Fields = {
  __typename?: 'instrument_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  instrument_kind_id?: Maybe<Scalars['bigint']>;
  organisation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "instrument" */
export type Instrument_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** update columns of table "instrument" */
export enum Instrument_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentKindId = 'instrument_kind_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Uid = 'uid'
}

export type Instrument_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Instrument_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Instrument_Set_Input>;
  where: Instrument_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Instrument_Var_Pop_Fields = {
  __typename?: 'instrument_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "instrument" */
export type Instrument_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Instrument_Var_Samp_Fields = {
  __typename?: 'instrument_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "instrument" */
export type Instrument_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Instrument_Variance_Fields = {
  __typename?: 'instrument_variance_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "instrument" */
export type Instrument_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  /** An object relationship */
  buyer?: Maybe<Setu_Trade_Shared_Entity>;
  buyer_bifurcation?: Maybe<BuyerBifurcationType>;
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  buyer_settlement_status?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  current_status_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  expense_amount?: Maybe<Scalars['numeric']>;
  id: Scalars['bigint'];
  /** An array relationship */
  issuance_notes: Array<Issuance_Note>;
  /** An aggregate relationship */
  issuance_notes_aggregate: Issuance_Note_Aggregate;
  material_kind?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  status_processing: Scalars['Boolean'];
  summary?: Maybe<Array<Maybe<InvoiceSummaryType>>>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code: Scalars['String'];
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  /** An array relationship */
  transactions: Array<Transaction>;
  /** An aggregate relationship */
  transactions_aggregate: Transaction_Aggregate;
  /** An object relationship */
  twilio_message?: Maybe<Trade_Twiliomessages>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "invoice" */
export type InvoiceIssuance_NotesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceIssuance_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "invoice" */
export type InvoiceTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  buyer_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_payable_amount?: InputMaybe<Numeric_Comparison_Exp>;
  buyer_settlement_status?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  current_status_id?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  deducted_amount?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  issuance_notes?: InputMaybe<Issuance_Note_Bool_Exp>;
  material_kind?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  returned_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  standard_deduction?: InputMaybe<Numeric_Comparison_Exp>;
  status_processing?: InputMaybe<Boolean_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_code?: InputMaybe<String_Comparison_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  transactions?: InputMaybe<Transaction_Bool_Exp>;
  twilio_message?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  buyer_settlement_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  buyer_settlement_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_settlement_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_notes_aggregate?: InputMaybe<Issuance_Note_Aggregate_Order_By>;
  material_kind?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  status_processing?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  twilio_message?: InputMaybe<Trade_Twiliomessages_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoice */
export type Invoice_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "invoice" */
export enum Invoice_Select_Column {
  /** column name */
  BuyerExpenseAmount = 'buyer_expense_amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerPayableAmount = 'buyer_payable_amount',
  /** column name */
  BuyerSettlementStatus = 'buyer_settlement_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CurrentStatusId = 'current_status_id',
  /** column name */
  Date = 'date',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DeductedQuantity = 'deducted_quantity',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  ExpenseAmount = 'expense_amount',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialKind = 'material_kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Remark = 'remark',
  /** column name */
  ReturnedQuantity = 'returned_quantity',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StatusProcessing = 'status_processing',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TrackingCode = 'tracking_code',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "invoice" */
export type Invoice_Set_Input = {
  current_status_id?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status_processing?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  buyer_expense_amount?: InputMaybe<Scalars['numeric']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_payable_amount?: InputMaybe<Scalars['numeric']>;
  buyer_settlement_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  current_status_id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  deducted_amount?: InputMaybe<Scalars['numeric']>;
  deducted_quantity?: InputMaybe<Scalars['numeric']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  expense_amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  material_kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  remark?: InputMaybe<Scalars['String']>;
  returned_quantity?: InputMaybe<Scalars['numeric']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  status_processing?: InputMaybe<Scalars['Boolean']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_quantity?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  buyer_expense_amount?: Maybe<Scalars['numeric']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
};

export type Invoice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "issuance_note" */
export type Issuance_Note = {
  __typename?: 'issuance_note';
  amount: Scalars['numeric'];
  /** An array relationship */
  attachments: Array<Issuance_Note_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Issuance_Note_Attachments_Aggregate;
  base_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  child_issuance_notes: Array<Issuance_Note>;
  /** An aggregate relationship */
  child_issuance_notes_aggregate: Issuance_Note_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['bigint'];
  input_value?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_id?: Maybe<Scalars['bigint']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  items: Array<Trade_Issuancenoteitems>;
  /** An aggregate relationship */
  items_aggregate: Trade_Issuancenoteitems_Aggregate;
  kind: Scalars['String'];
  /** An object relationship */
  parent_issuance_note?: Maybe<Issuance_Note>;
  parent_issuance_note_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  receipt?: Maybe<Receipt>;
  receipt_id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  /** An array relationship */
  taxes: Array<Issuance_Note_Taxes>;
  /** An aggregate relationship */
  taxes_aggregate: Issuance_Note_Taxes_Aggregate;
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
  user_role: Scalars['String'];
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Attachments_Order_By>>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Attachments_Order_By>>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteChild_Issuance_NotesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteChild_Issuance_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteItemsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteTaxesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
};


/** columns and relationships of "issuance_note" */
export type Issuance_NoteTaxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
};

/** aggregated selection of "issuance_note" */
export type Issuance_Note_Aggregate = {
  __typename?: 'issuance_note_aggregate';
  aggregate?: Maybe<Issuance_Note_Aggregate_Fields>;
  nodes: Array<Issuance_Note>;
};

/** aggregate fields of "issuance_note" */
export type Issuance_Note_Aggregate_Fields = {
  __typename?: 'issuance_note_aggregate_fields';
  avg?: Maybe<Issuance_Note_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Issuance_Note_Max_Fields>;
  min?: Maybe<Issuance_Note_Min_Fields>;
  stddev?: Maybe<Issuance_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Issuance_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issuance_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Issuance_Note_Sum_Fields>;
  var_pop?: Maybe<Issuance_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Issuance_Note_Var_Samp_Fields>;
  variance?: Maybe<Issuance_Note_Variance_Fields>;
};


/** aggregate fields of "issuance_note" */
export type Issuance_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "issuance_note" */
export type Issuance_Note_Aggregate_Order_By = {
  avg?: InputMaybe<Issuance_Note_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Issuance_Note_Max_Order_By>;
  min?: InputMaybe<Issuance_Note_Min_Order_By>;
  stddev?: InputMaybe<Issuance_Note_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Issuance_Note_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Issuance_Note_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Issuance_Note_Sum_Order_By>;
  var_pop?: InputMaybe<Issuance_Note_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Issuance_Note_Var_Samp_Order_By>;
  variance?: InputMaybe<Issuance_Note_Variance_Order_By>;
};

/** columns and relationships of "issuance_note_attachments" */
export type Issuance_Note_Attachments = {
  __typename?: 'issuance_note_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  issuance_note: Issuance_Note;
  issuancenote_id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
};

/** aggregated selection of "issuance_note_attachments" */
export type Issuance_Note_Attachments_Aggregate = {
  __typename?: 'issuance_note_attachments_aggregate';
  aggregate?: Maybe<Issuance_Note_Attachments_Aggregate_Fields>;
  nodes: Array<Issuance_Note_Attachments>;
};

/** aggregate fields of "issuance_note_attachments" */
export type Issuance_Note_Attachments_Aggregate_Fields = {
  __typename?: 'issuance_note_attachments_aggregate_fields';
  avg?: Maybe<Issuance_Note_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Issuance_Note_Attachments_Max_Fields>;
  min?: Maybe<Issuance_Note_Attachments_Min_Fields>;
  stddev?: Maybe<Issuance_Note_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Issuance_Note_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issuance_Note_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Issuance_Note_Attachments_Sum_Fields>;
  var_pop?: Maybe<Issuance_Note_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Issuance_Note_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Issuance_Note_Attachments_Variance_Fields>;
};


/** aggregate fields of "issuance_note_attachments" */
export type Issuance_Note_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issuance_Note_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Issuance_Note_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Issuance_Note_Attachments_Max_Order_By>;
  min?: InputMaybe<Issuance_Note_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Issuance_Note_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Issuance_Note_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Issuance_Note_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Issuance_Note_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Issuance_Note_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Issuance_Note_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Issuance_Note_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Issuance_Note_Attachments_Avg_Fields = {
  __typename?: 'issuance_note_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenote_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "issuance_note_attachments". All fields are combined with a logical 'AND'. */
export type Issuance_Note_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Issuance_Note_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Issuance_Note_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  issuance_note?: InputMaybe<Issuance_Note_Bool_Exp>;
  issuancenote_id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "issuance_note_attachments" */
export enum Issuance_Note_Attachments_Constraint {
  /** unique or primary key constraint on columns "issuancenote_id", "media_id" */
  IssuanceNoteAttachmentIssuancenoteIdMediaIdBcb4ee9dUniq = 'issuance_note_attachment_issuancenote_id_media_id_bcb4ee9d_uniq',
  /** unique or primary key constraint on columns "id" */
  IssuanceNoteAttachmentsPkey = 'issuance_note_attachments_pkey'
}

/** input type for incrementing numeric columns in table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  issuancenote_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  issuancenote_id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Setutrade_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Issuance_Note_Attachments_Max_Fields = {
  __typename?: 'issuance_note_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  issuancenote_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Issuance_Note_Attachments_Min_Fields = {
  __typename?: 'issuance_note_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  issuancenote_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Mutation_Response = {
  __typename?: 'issuance_note_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Issuance_Note_Attachments>;
};

/** on_conflict condition type for table "issuance_note_attachments" */
export type Issuance_Note_Attachments_On_Conflict = {
  constraint: Issuance_Note_Attachments_Constraint;
  update_columns?: Array<Issuance_Note_Attachments_Update_Column>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "issuance_note_attachments". */
export type Issuance_Note_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  issuance_note?: InputMaybe<Issuance_Note_Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: issuance_note_attachments */
export type Issuance_Note_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "issuance_note_attachments" */
export enum Issuance_Note_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IssuancenoteId = 'issuancenote_id',
  /** column name */
  MediaId = 'media_id'
}

/** input type for updating data in table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  issuancenote_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Issuance_Note_Attachments_Stddev_Fields = {
  __typename?: 'issuance_note_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenote_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Issuance_Note_Attachments_Stddev_Pop_Fields = {
  __typename?: 'issuance_note_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenote_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Issuance_Note_Attachments_Stddev_Samp_Fields = {
  __typename?: 'issuance_note_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenote_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issuance_Note_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issuance_Note_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  issuancenote_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Issuance_Note_Attachments_Sum_Fields = {
  __typename?: 'issuance_note_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  issuancenote_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** update columns of table "issuance_note_attachments" */
export enum Issuance_Note_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IssuancenoteId = 'issuancenote_id',
  /** column name */
  MediaId = 'media_id'
}

export type Issuance_Note_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Issuance_Note_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Issuance_Note_Attachments_Set_Input>;
  where: Issuance_Note_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Issuance_Note_Attachments_Var_Pop_Fields = {
  __typename?: 'issuance_note_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenote_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Issuance_Note_Attachments_Var_Samp_Fields = {
  __typename?: 'issuance_note_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenote_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Issuance_Note_Attachments_Variance_Fields = {
  __typename?: 'issuance_note_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenote_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "issuance_note_attachments" */
export type Issuance_Note_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenote_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Issuance_Note_Avg_Fields = {
  __typename?: 'issuance_note_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  base_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "issuance_note" */
export type Issuance_Note_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "issuance_note". All fields are combined with a logical 'AND'. */
export type Issuance_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Issuance_Note_Bool_Exp>>;
  _not?: InputMaybe<Issuance_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Issuance_Note_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  attachments?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
  base_amount?: InputMaybe<Numeric_Comparison_Exp>;
  child_issuance_notes?: InputMaybe<Issuance_Note_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  input_value?: InputMaybe<Numeric_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  items?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  parent_issuance_note?: InputMaybe<Issuance_Note_Bool_Exp>;
  parent_issuance_note_id?: InputMaybe<Bigint_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  receipt_id?: InputMaybe<Bigint_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  taxes?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_role?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes = {
  __typename?: 'issuance_note_item_taxes';
  amount?: Maybe<Scalars['numeric']>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  issuance_note_item: Trade_Issuancenoteitems;
  issuance_note_item_id: Scalars['bigint'];
  name: Scalars['String'];
  percentage: Scalars['numeric'];
  tax_name: Scalars['String'];
};

/** aggregated selection of "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Aggregate = {
  __typename?: 'issuance_note_item_taxes_aggregate';
  aggregate?: Maybe<Issuance_Note_Item_Taxes_Aggregate_Fields>;
  nodes: Array<Issuance_Note_Item_Taxes>;
};

/** aggregate fields of "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Aggregate_Fields = {
  __typename?: 'issuance_note_item_taxes_aggregate_fields';
  avg?: Maybe<Issuance_Note_Item_Taxes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Issuance_Note_Item_Taxes_Max_Fields>;
  min?: Maybe<Issuance_Note_Item_Taxes_Min_Fields>;
  stddev?: Maybe<Issuance_Note_Item_Taxes_Stddev_Fields>;
  stddev_pop?: Maybe<Issuance_Note_Item_Taxes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issuance_Note_Item_Taxes_Stddev_Samp_Fields>;
  sum?: Maybe<Issuance_Note_Item_Taxes_Sum_Fields>;
  var_pop?: Maybe<Issuance_Note_Item_Taxes_Var_Pop_Fields>;
  var_samp?: Maybe<Issuance_Note_Item_Taxes_Var_Samp_Fields>;
  variance?: Maybe<Issuance_Note_Item_Taxes_Variance_Fields>;
};


/** aggregate fields of "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issuance_Note_Item_Taxes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Aggregate_Order_By = {
  avg?: InputMaybe<Issuance_Note_Item_Taxes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Issuance_Note_Item_Taxes_Max_Order_By>;
  min?: InputMaybe<Issuance_Note_Item_Taxes_Min_Order_By>;
  stddev?: InputMaybe<Issuance_Note_Item_Taxes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Issuance_Note_Item_Taxes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Issuance_Note_Item_Taxes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Issuance_Note_Item_Taxes_Sum_Order_By>;
  var_pop?: InputMaybe<Issuance_Note_Item_Taxes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Issuance_Note_Item_Taxes_Var_Samp_Order_By>;
  variance?: InputMaybe<Issuance_Note_Item_Taxes_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Issuance_Note_Item_Taxes_Avg_Fields = {
  __typename?: 'issuance_note_item_taxes_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_item_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "issuance_note_item_taxes". All fields are combined with a logical 'AND'. */
export type Issuance_Note_Item_Taxes_Bool_Exp = {
  _and?: InputMaybe<Array<Issuance_Note_Item_Taxes_Bool_Exp>>;
  _not?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
  _or?: InputMaybe<Array<Issuance_Note_Item_Taxes_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  issuance_note_item?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
  issuance_note_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  tax_name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Issuance_Note_Item_Taxes_Max_Fields = {
  __typename?: 'issuance_note_item_taxes_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  issuance_note_item_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  tax_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Issuance_Note_Item_Taxes_Min_Fields = {
  __typename?: 'issuance_note_item_taxes_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  issuance_note_item_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  tax_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "issuance_note_item_taxes". */
export type Issuance_Note_Item_Taxes_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  issuance_note_item?: InputMaybe<Trade_Issuancenoteitems_Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
};

/** select columns of table "issuance_note_item_taxes" */
export enum Issuance_Note_Item_Taxes_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssuanceNoteItemId = 'issuance_note_item_id',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  TaxName = 'tax_name'
}

/** aggregate stddev on columns */
export type Issuance_Note_Item_Taxes_Stddev_Fields = {
  __typename?: 'issuance_note_item_taxes_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_item_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Issuance_Note_Item_Taxes_Stddev_Pop_Fields = {
  __typename?: 'issuance_note_item_taxes_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_item_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Issuance_Note_Item_Taxes_Stddev_Samp_Fields = {
  __typename?: 'issuance_note_item_taxes_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_item_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issuance_Note_Item_Taxes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issuance_Note_Item_Taxes_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issuance_note_item_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  tax_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Issuance_Note_Item_Taxes_Sum_Fields = {
  __typename?: 'issuance_note_item_taxes_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  issuance_note_item_id?: Maybe<Scalars['bigint']>;
  percentage?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Issuance_Note_Item_Taxes_Var_Pop_Fields = {
  __typename?: 'issuance_note_item_taxes_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_item_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Issuance_Note_Item_Taxes_Var_Samp_Fields = {
  __typename?: 'issuance_note_item_taxes_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_item_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Issuance_Note_Item_Taxes_Variance_Fields = {
  __typename?: 'issuance_note_item_taxes_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_item_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "issuance_note_item_taxes" */
export type Issuance_Note_Item_Taxes_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_item_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Issuance_Note_Max_Fields = {
  __typename?: 'issuance_note_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  base_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  input_value?: Maybe<Scalars['numeric']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  parent_issuance_note_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
  user_role?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "issuance_note" */
export type Issuance_Note_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_role?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Issuance_Note_Min_Fields = {
  __typename?: 'issuance_note_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  base_amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  input_value?: Maybe<Scalars['numeric']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  parent_issuance_note_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
  user_role?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "issuance_note" */
export type Issuance_Note_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_role?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "issuance_note". */
export type Issuance_Note_Order_By = {
  amount?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Issuance_Note_Attachments_Aggregate_Order_By>;
  base_amount?: InputMaybe<Order_By>;
  child_issuance_notes_aggregate?: InputMaybe<Issuance_Note_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Trade_Issuancenoteitems_Aggregate_Order_By>;
  kind?: InputMaybe<Order_By>;
  parent_issuance_note?: InputMaybe<Issuance_Note_Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  taxes_aggregate?: InputMaybe<Issuance_Note_Taxes_Aggregate_Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_role?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** select columns of table "issuance_note" */
export enum Issuance_Note_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BaseAmount = 'base_amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputValue = 'input_value',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Kind = 'kind',
  /** column name */
  ParentIssuanceNoteId = 'parent_issuance_note_id',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRole = 'user_role',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** aggregate stddev on columns */
export type Issuance_Note_Stddev_Fields = {
  __typename?: 'issuance_note_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  base_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "issuance_note" */
export type Issuance_Note_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Issuance_Note_Stddev_Pop_Fields = {
  __typename?: 'issuance_note_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  base_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "issuance_note" */
export type Issuance_Note_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Issuance_Note_Stddev_Samp_Fields = {
  __typename?: 'issuance_note_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  base_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "issuance_note" */
export type Issuance_Note_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "issuance_note" */
export type Issuance_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issuance_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issuance_Note_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  base_amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  input_value?: InputMaybe<Scalars['numeric']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  parent_issuance_note_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  remarks?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
  user_role?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Issuance_Note_Sum_Fields = {
  __typename?: 'issuance_note_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  base_amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  input_value?: Maybe<Scalars['numeric']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  parent_issuance_note_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "issuance_note" */
export type Issuance_Note_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "issuance_note_taxes" */
export type Issuance_Note_Taxes = {
  __typename?: 'issuance_note_taxes';
  amount?: Maybe<Scalars['numeric']>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  issuance_note: Issuance_Note;
  issuance_note_id: Scalars['bigint'];
  name: Scalars['String'];
  percentage: Scalars['numeric'];
  tax_name: Scalars['String'];
};

/** aggregated selection of "issuance_note_taxes" */
export type Issuance_Note_Taxes_Aggregate = {
  __typename?: 'issuance_note_taxes_aggregate';
  aggregate?: Maybe<Issuance_Note_Taxes_Aggregate_Fields>;
  nodes: Array<Issuance_Note_Taxes>;
};

/** aggregate fields of "issuance_note_taxes" */
export type Issuance_Note_Taxes_Aggregate_Fields = {
  __typename?: 'issuance_note_taxes_aggregate_fields';
  avg?: Maybe<Issuance_Note_Taxes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Issuance_Note_Taxes_Max_Fields>;
  min?: Maybe<Issuance_Note_Taxes_Min_Fields>;
  stddev?: Maybe<Issuance_Note_Taxes_Stddev_Fields>;
  stddev_pop?: Maybe<Issuance_Note_Taxes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issuance_Note_Taxes_Stddev_Samp_Fields>;
  sum?: Maybe<Issuance_Note_Taxes_Sum_Fields>;
  var_pop?: Maybe<Issuance_Note_Taxes_Var_Pop_Fields>;
  var_samp?: Maybe<Issuance_Note_Taxes_Var_Samp_Fields>;
  variance?: Maybe<Issuance_Note_Taxes_Variance_Fields>;
};


/** aggregate fields of "issuance_note_taxes" */
export type Issuance_Note_Taxes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issuance_Note_Taxes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Aggregate_Order_By = {
  avg?: InputMaybe<Issuance_Note_Taxes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Issuance_Note_Taxes_Max_Order_By>;
  min?: InputMaybe<Issuance_Note_Taxes_Min_Order_By>;
  stddev?: InputMaybe<Issuance_Note_Taxes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Issuance_Note_Taxes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Issuance_Note_Taxes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Issuance_Note_Taxes_Sum_Order_By>;
  var_pop?: InputMaybe<Issuance_Note_Taxes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Issuance_Note_Taxes_Var_Samp_Order_By>;
  variance?: InputMaybe<Issuance_Note_Taxes_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Issuance_Note_Taxes_Avg_Fields = {
  __typename?: 'issuance_note_taxes_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "issuance_note_taxes". All fields are combined with a logical 'AND'. */
export type Issuance_Note_Taxes_Bool_Exp = {
  _and?: InputMaybe<Array<Issuance_Note_Taxes_Bool_Exp>>;
  _not?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
  _or?: InputMaybe<Array<Issuance_Note_Taxes_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  issuance_note?: InputMaybe<Issuance_Note_Bool_Exp>;
  issuance_note_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  tax_name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Issuance_Note_Taxes_Max_Fields = {
  __typename?: 'issuance_note_taxes_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  issuance_note_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  tax_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Issuance_Note_Taxes_Min_Fields = {
  __typename?: 'issuance_note_taxes_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  issuance_note_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  tax_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "issuance_note_taxes". */
export type Issuance_Note_Taxes_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  issuance_note?: InputMaybe<Issuance_Note_Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
};

/** select columns of table "issuance_note_taxes" */
export enum Issuance_Note_Taxes_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IssuanceNoteId = 'issuance_note_id',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  TaxName = 'tax_name'
}

/** aggregate stddev on columns */
export type Issuance_Note_Taxes_Stddev_Fields = {
  __typename?: 'issuance_note_taxes_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Issuance_Note_Taxes_Stddev_Pop_Fields = {
  __typename?: 'issuance_note_taxes_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Issuance_Note_Taxes_Stddev_Samp_Fields = {
  __typename?: 'issuance_note_taxes_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issuance_Note_Taxes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issuance_Note_Taxes_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  issuance_note_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  tax_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Issuance_Note_Taxes_Sum_Fields = {
  __typename?: 'issuance_note_taxes_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  issuance_note_id?: Maybe<Scalars['bigint']>;
  percentage?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Issuance_Note_Taxes_Var_Pop_Fields = {
  __typename?: 'issuance_note_taxes_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Issuance_Note_Taxes_Var_Samp_Fields = {
  __typename?: 'issuance_note_taxes_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Issuance_Note_Taxes_Variance_Fields = {
  __typename?: 'issuance_note_taxes_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "issuance_note_taxes" */
export type Issuance_Note_Taxes_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Issuance_Note_Var_Pop_Fields = {
  __typename?: 'issuance_note_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  base_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "issuance_note" */
export type Issuance_Note_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Issuance_Note_Var_Samp_Fields = {
  __typename?: 'issuance_note_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  base_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "issuance_note" */
export type Issuance_Note_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Issuance_Note_Variance_Fields = {
  __typename?: 'issuance_note_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  base_amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "issuance_note" */
export type Issuance_Note_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  base_amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  parent_issuance_note_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "notification" */
export type Kite_Notification = {
  __typename?: 'kite_notification';
  body: Scalars['String'];
  created_at: Scalars['timestamptz'];
  extra_fields: Scalars['jsonb'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_read: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  sent_by_id: Scalars['Int'];
  title: Scalars['String'];
  trash: Scalars['Boolean'];
  /** An object relationship */
  trigger: Notification_Trigger;
  trigger_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Base_User;
  user_id: Scalars['Int'];
};


/** columns and relationships of "notification" */
export type Kite_NotificationExtra_FieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification" */
export type Kite_NotificationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification" */
export type Kite_Notification_Aggregate = {
  __typename?: 'kite_notification_aggregate';
  aggregate?: Maybe<Kite_Notification_Aggregate_Fields>;
  nodes: Array<Kite_Notification>;
};

/** aggregate fields of "notification" */
export type Kite_Notification_Aggregate_Fields = {
  __typename?: 'kite_notification_aggregate_fields';
  avg?: Maybe<Kite_Notification_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Kite_Notification_Max_Fields>;
  min?: Maybe<Kite_Notification_Min_Fields>;
  stddev?: Maybe<Kite_Notification_Stddev_Fields>;
  stddev_pop?: Maybe<Kite_Notification_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kite_Notification_Stddev_Samp_Fields>;
  sum?: Maybe<Kite_Notification_Sum_Fields>;
  var_pop?: Maybe<Kite_Notification_Var_Pop_Fields>;
  var_samp?: Maybe<Kite_Notification_Var_Samp_Fields>;
  variance?: Maybe<Kite_Notification_Variance_Fields>;
};


/** aggregate fields of "notification" */
export type Kite_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Kite_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Kite_Notification_Append_Input = {
  extra_fields?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Kite_Notification_Avg_Fields = {
  __typename?: 'kite_notification_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  trigger_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification". All fields are combined with a logical 'AND'. */
export type Kite_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Kite_Notification_Bool_Exp>>;
  _not?: InputMaybe<Kite_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Kite_Notification_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  extra_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_read?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  sent_by_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  trash?: InputMaybe<Boolean_Comparison_Exp>;
  trigger?: InputMaybe<Notification_Trigger_Bool_Exp>;
  trigger_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Base_User_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification" */
export enum Kite_Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationPkey = 'notification_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Kite_Notification_Delete_At_Path_Input = {
  extra_fields?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Kite_Notification_Delete_Elem_Input = {
  extra_fields?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Kite_Notification_Delete_Key_Input = {
  extra_fields?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification" */
export type Kite_Notification_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  trigger_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification" */
export type Kite_Notification_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  extra_fields?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_read?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  trash?: InputMaybe<Scalars['Boolean']>;
  trigger?: InputMaybe<Notification_Trigger_Obj_Rel_Insert_Input>;
  trigger_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Kite_Notification_Max_Fields = {
  __typename?: 'kite_notification_max_fields';
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  trigger_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Kite_Notification_Min_Fields = {
  __typename?: 'kite_notification_min_fields';
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  trigger_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "notification" */
export type Kite_Notification_Mutation_Response = {
  __typename?: 'kite_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Kite_Notification>;
};

/** on_conflict condition type for table "notification" */
export type Kite_Notification_On_Conflict = {
  constraint: Kite_Notification_Constraint;
  update_columns?: Array<Kite_Notification_Update_Column>;
  where?: InputMaybe<Kite_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "notification". */
export type Kite_Notification_Order_By = {
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  extra_fields?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_read?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  sent_by_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  trash?: InputMaybe<Order_By>;
  trigger?: InputMaybe<Notification_Trigger_Order_By>;
  trigger_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Base_User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification */
export type Kite_Notification_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Kite_Notification_Prepend_Input = {
  extra_fields?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification" */
export enum Kite_Notification_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtraFields = 'extra_fields',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SentById = 'sent_by_id',
  /** column name */
  Title = 'title',
  /** column name */
  Trash = 'trash',
  /** column name */
  TriggerId = 'trigger_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "notification" */
export type Kite_Notification_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  extra_fields?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_read?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  trash?: InputMaybe<Scalars['Boolean']>;
  trigger_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Kite_Notification_Stddev_Fields = {
  __typename?: 'kite_notification_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  trigger_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Kite_Notification_Stddev_Pop_Fields = {
  __typename?: 'kite_notification_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  trigger_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Kite_Notification_Stddev_Samp_Fields = {
  __typename?: 'kite_notification_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  trigger_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "kite_notification" */
export type Kite_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kite_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kite_Notification_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  extra_fields?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_read?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  trash?: InputMaybe<Scalars['Boolean']>;
  trigger_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Kite_Notification_Sum_Fields = {
  __typename?: 'kite_notification_sum_fields';
  id?: Maybe<Scalars['Int']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  trigger_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notification" */
export enum Kite_Notification_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExtraFields = 'extra_fields',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsRead = 'is_read',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SentById = 'sent_by_id',
  /** column name */
  Title = 'title',
  /** column name */
  Trash = 'trash',
  /** column name */
  TriggerId = 'trigger_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Kite_Notification_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Kite_Notification_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Kite_Notification_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Kite_Notification_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Kite_Notification_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Kite_Notification_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Kite_Notification_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Kite_Notification_Set_Input>;
  where: Kite_Notification_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Kite_Notification_Var_Pop_Fields = {
  __typename?: 'kite_notification_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  trigger_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Kite_Notification_Var_Samp_Fields = {
  __typename?: 'kite_notification_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  trigger_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Kite_Notification_Variance_Fields = {
  __typename?: 'kite_notification_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  trigger_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "quality_stage" */
export type Kite_Quality_Stage = {
  __typename?: 'kite_quality_stage';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "quality_stage" */
export type Kite_Quality_Stage_Aggregate = {
  __typename?: 'kite_quality_stage_aggregate';
  aggregate?: Maybe<Kite_Quality_Stage_Aggregate_Fields>;
  nodes: Array<Kite_Quality_Stage>;
};

/** aggregate fields of "quality_stage" */
export type Kite_Quality_Stage_Aggregate_Fields = {
  __typename?: 'kite_quality_stage_aggregate_fields';
  avg?: Maybe<Kite_Quality_Stage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Kite_Quality_Stage_Max_Fields>;
  min?: Maybe<Kite_Quality_Stage_Min_Fields>;
  stddev?: Maybe<Kite_Quality_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Kite_Quality_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kite_Quality_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Kite_Quality_Stage_Sum_Fields>;
  var_pop?: Maybe<Kite_Quality_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Kite_Quality_Stage_Var_Samp_Fields>;
  variance?: Maybe<Kite_Quality_Stage_Variance_Fields>;
};


/** aggregate fields of "quality_stage" */
export type Kite_Quality_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Kite_Quality_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Kite_Quality_Stage_Avg_Fields = {
  __typename?: 'kite_quality_stage_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "quality_stage". All fields are combined with a logical 'AND'. */
export type Kite_Quality_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Kite_Quality_Stage_Bool_Exp>>;
  _not?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Kite_Quality_Stage_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality_stage" */
export enum Kite_Quality_Stage_Constraint {
  /** unique or primary key constraint on columns "codename" */
  QualityStageCodenameKey = 'quality_stage_codename_key',
  /** unique or primary key constraint on columns "id" */
  QualityStagePkey = 'quality_stage_pkey'
}

/** input type for incrementing numeric columns in table "quality_stage" */
export type Kite_Quality_Stage_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "quality_stage" */
export type Kite_Quality_Stage_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Kite_Quality_Stage_Max_Fields = {
  __typename?: 'kite_quality_stage_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Kite_Quality_Stage_Min_Fields = {
  __typename?: 'kite_quality_stage_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quality_stage" */
export type Kite_Quality_Stage_Mutation_Response = {
  __typename?: 'kite_quality_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Kite_Quality_Stage>;
};

/** input type for inserting object relation for remote table "quality_stage" */
export type Kite_Quality_Stage_Obj_Rel_Insert_Input = {
  data: Kite_Quality_Stage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Kite_Quality_Stage_On_Conflict>;
};

/** on_conflict condition type for table "quality_stage" */
export type Kite_Quality_Stage_On_Conflict = {
  constraint: Kite_Quality_Stage_Constraint;
  update_columns?: Array<Kite_Quality_Stage_Update_Column>;
  where?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "quality_stage". */
export type Kite_Quality_Stage_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality_stage */
export type Kite_Quality_Stage_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "quality_stage" */
export enum Kite_Quality_Stage_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "quality_stage" */
export type Kite_Quality_Stage_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Kite_Quality_Stage_Stddev_Fields = {
  __typename?: 'kite_quality_stage_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Kite_Quality_Stage_Stddev_Pop_Fields = {
  __typename?: 'kite_quality_stage_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Kite_Quality_Stage_Stddev_Samp_Fields = {
  __typename?: 'kite_quality_stage_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "kite_quality_stage" */
export type Kite_Quality_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kite_Quality_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kite_Quality_Stage_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Kite_Quality_Stage_Sum_Fields = {
  __typename?: 'kite_quality_stage_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "quality_stage" */
export enum Kite_Quality_Stage_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Kite_Quality_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Kite_Quality_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Kite_Quality_Stage_Set_Input>;
  where: Kite_Quality_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Kite_Quality_Stage_Var_Pop_Fields = {
  __typename?: 'kite_quality_stage_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Kite_Quality_Stage_Var_Samp_Fields = {
  __typename?: 'kite_quality_stage_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Kite_Quality_Stage_Variance_Fields = {
  __typename?: 'kite_quality_stage_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "laboratory" */
export type Laboratory = {
  __typename?: 'laboratory';
  address_id?: Maybe<Scalars['bigint']>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  organisations: Array<Laboratory_Organisations>;
  /** An aggregate relationship */
  organisations_aggregate: Laboratory_Organisations_Aggregate;
  /** An array relationship */
  requests: Array<Request>;
  /** An aggregate relationship */
  requests_aggregate: Request_Aggregate;
};


/** columns and relationships of "laboratory" */
export type LaboratoryOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Organisations_Order_By>>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Organisations_Order_By>>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryRequestsArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


/** columns and relationships of "laboratory" */
export type LaboratoryRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};

/** aggregated selection of "laboratory" */
export type Laboratory_Aggregate = {
  __typename?: 'laboratory_aggregate';
  aggregate?: Maybe<Laboratory_Aggregate_Fields>;
  nodes: Array<Laboratory>;
};

/** aggregate fields of "laboratory" */
export type Laboratory_Aggregate_Fields = {
  __typename?: 'laboratory_aggregate_fields';
  avg?: Maybe<Laboratory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Laboratory_Max_Fields>;
  min?: Maybe<Laboratory_Min_Fields>;
  stddev?: Maybe<Laboratory_Stddev_Fields>;
  stddev_pop?: Maybe<Laboratory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Laboratory_Stddev_Samp_Fields>;
  sum?: Maybe<Laboratory_Sum_Fields>;
  var_pop?: Maybe<Laboratory_Var_Pop_Fields>;
  var_samp?: Maybe<Laboratory_Var_Samp_Fields>;
  variance?: Maybe<Laboratory_Variance_Fields>;
};


/** aggregate fields of "laboratory" */
export type Laboratory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Laboratory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Laboratory_Avg_Fields = {
  __typename?: 'laboratory_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "laboratory". All fields are combined with a logical 'AND'. */
export type Laboratory_Bool_Exp = {
  _and?: InputMaybe<Array<Laboratory_Bool_Exp>>;
  _not?: InputMaybe<Laboratory_Bool_Exp>;
  _or?: InputMaybe<Array<Laboratory_Bool_Exp>>;
  address_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisations?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
  requests?: InputMaybe<Request_Bool_Exp>;
};

/** unique or primary key constraints on table "laboratory" */
export enum Laboratory_Constraint {
  /** unique or primary key constraint on columns "codename" */
  LaboratoryCodenameKey = 'laboratory_codename_key',
  /** unique or primary key constraint on columns "id" */
  LaboratoryPkey = 'laboratory_pkey'
}

/** input type for incrementing numeric columns in table "laboratory" */
export type Laboratory_Inc_Input = {
  address_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "laboratory" */
export type Laboratory_Insert_Input = {
  address_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisations?: InputMaybe<Laboratory_Organisations_Arr_Rel_Insert_Input>;
  requests?: InputMaybe<Request_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Laboratory_Max_Fields = {
  __typename?: 'laboratory_max_fields';
  address_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Laboratory_Min_Fields = {
  __typename?: 'laboratory_min_fields';
  address_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "laboratory" */
export type Laboratory_Mutation_Response = {
  __typename?: 'laboratory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Laboratory>;
};

/** input type for inserting object relation for remote table "laboratory" */
export type Laboratory_Obj_Rel_Insert_Input = {
  data: Laboratory_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Laboratory_On_Conflict>;
};

/** on_conflict condition type for table "laboratory" */
export type Laboratory_On_Conflict = {
  constraint: Laboratory_Constraint;
  update_columns?: Array<Laboratory_Update_Column>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};

/** Ordering options when selecting data from "laboratory". */
export type Laboratory_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisations_aggregate?: InputMaybe<Laboratory_Organisations_Aggregate_Order_By>;
  requests_aggregate?: InputMaybe<Request_Aggregate_Order_By>;
};

/** columns and relationships of "laboratory_organisations" */
export type Laboratory_Organisations = {
  __typename?: 'laboratory_organisations';
  externalentity_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  laboratory: Laboratory;
  laboratory_id: Scalars['bigint'];
  /** An object relationship */
  organisation: External_Entity;
};

/** aggregated selection of "laboratory_organisations" */
export type Laboratory_Organisations_Aggregate = {
  __typename?: 'laboratory_organisations_aggregate';
  aggregate?: Maybe<Laboratory_Organisations_Aggregate_Fields>;
  nodes: Array<Laboratory_Organisations>;
};

/** aggregate fields of "laboratory_organisations" */
export type Laboratory_Organisations_Aggregate_Fields = {
  __typename?: 'laboratory_organisations_aggregate_fields';
  avg?: Maybe<Laboratory_Organisations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Laboratory_Organisations_Max_Fields>;
  min?: Maybe<Laboratory_Organisations_Min_Fields>;
  stddev?: Maybe<Laboratory_Organisations_Stddev_Fields>;
  stddev_pop?: Maybe<Laboratory_Organisations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Laboratory_Organisations_Stddev_Samp_Fields>;
  sum?: Maybe<Laboratory_Organisations_Sum_Fields>;
  var_pop?: Maybe<Laboratory_Organisations_Var_Pop_Fields>;
  var_samp?: Maybe<Laboratory_Organisations_Var_Samp_Fields>;
  variance?: Maybe<Laboratory_Organisations_Variance_Fields>;
};


/** aggregate fields of "laboratory_organisations" */
export type Laboratory_Organisations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Laboratory_Organisations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "laboratory_organisations" */
export type Laboratory_Organisations_Aggregate_Order_By = {
  avg?: InputMaybe<Laboratory_Organisations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Laboratory_Organisations_Max_Order_By>;
  min?: InputMaybe<Laboratory_Organisations_Min_Order_By>;
  stddev?: InputMaybe<Laboratory_Organisations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Laboratory_Organisations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Laboratory_Organisations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Laboratory_Organisations_Sum_Order_By>;
  var_pop?: InputMaybe<Laboratory_Organisations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Laboratory_Organisations_Var_Samp_Order_By>;
  variance?: InputMaybe<Laboratory_Organisations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "laboratory_organisations" */
export type Laboratory_Organisations_Arr_Rel_Insert_Input = {
  data: Array<Laboratory_Organisations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Laboratory_Organisations_On_Conflict>;
};

/** aggregate avg on columns */
export type Laboratory_Organisations_Avg_Fields = {
  __typename?: 'laboratory_organisations_avg_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Avg_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "laboratory_organisations". All fields are combined with a logical 'AND'. */
export type Laboratory_Organisations_Bool_Exp = {
  _and?: InputMaybe<Array<Laboratory_Organisations_Bool_Exp>>;
  _not?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
  _or?: InputMaybe<Array<Laboratory_Organisations_Bool_Exp>>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  laboratory?: InputMaybe<Laboratory_Bool_Exp>;
  laboratory_id?: InputMaybe<Bigint_Comparison_Exp>;
  organisation?: InputMaybe<External_Entity_Bool_Exp>;
};

/** unique or primary key constraints on table "laboratory_organisations" */
export enum Laboratory_Organisations_Constraint {
  /** unique or primary key constraint on columns "laboratory_id", "externalentity_id" */
  LaboratoryOrganisationsLaboratoryIdExternalen_423ee991Uniq = 'laboratory_organisations_laboratory_id_externalen_423ee991_uniq',
  /** unique or primary key constraint on columns "id" */
  LaboratoryOrganisationsPkey = 'laboratory_organisations_pkey'
}

/** input type for incrementing numeric columns in table "laboratory_organisations" */
export type Laboratory_Organisations_Inc_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "laboratory_organisations" */
export type Laboratory_Organisations_Insert_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  laboratory?: InputMaybe<Laboratory_Obj_Rel_Insert_Input>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
  organisation?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Laboratory_Organisations_Max_Fields = {
  __typename?: 'laboratory_organisations_max_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  laboratory_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Max_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Laboratory_Organisations_Min_Fields = {
  __typename?: 'laboratory_organisations_min_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  laboratory_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Min_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "laboratory_organisations" */
export type Laboratory_Organisations_Mutation_Response = {
  __typename?: 'laboratory_organisations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Laboratory_Organisations>;
};

/** on_conflict condition type for table "laboratory_organisations" */
export type Laboratory_Organisations_On_Conflict = {
  constraint: Laboratory_Organisations_Constraint;
  update_columns?: Array<Laboratory_Organisations_Update_Column>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};

/** Ordering options when selecting data from "laboratory_organisations". */
export type Laboratory_Organisations_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory?: InputMaybe<Laboratory_Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<External_Entity_Order_By>;
};

/** primary key columns input for table: laboratory_organisations */
export type Laboratory_Organisations_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "laboratory_organisations" */
export enum Laboratory_Organisations_Select_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  LaboratoryId = 'laboratory_id'
}

/** input type for updating data in table "laboratory_organisations" */
export type Laboratory_Organisations_Set_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Laboratory_Organisations_Stddev_Fields = {
  __typename?: 'laboratory_organisations_stddev_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Stddev_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Laboratory_Organisations_Stddev_Pop_Fields = {
  __typename?: 'laboratory_organisations_stddev_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Stddev_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Laboratory_Organisations_Stddev_Samp_Fields = {
  __typename?: 'laboratory_organisations_stddev_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Stddev_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "laboratory_organisations" */
export type Laboratory_Organisations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Laboratory_Organisations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Laboratory_Organisations_Stream_Cursor_Value_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Laboratory_Organisations_Sum_Fields = {
  __typename?: 'laboratory_organisations_sum_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  laboratory_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Sum_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** update columns of table "laboratory_organisations" */
export enum Laboratory_Organisations_Update_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  LaboratoryId = 'laboratory_id'
}

export type Laboratory_Organisations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Laboratory_Organisations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Laboratory_Organisations_Set_Input>;
  where: Laboratory_Organisations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Laboratory_Organisations_Var_Pop_Fields = {
  __typename?: 'laboratory_organisations_var_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Var_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Laboratory_Organisations_Var_Samp_Fields = {
  __typename?: 'laboratory_organisations_var_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Var_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Laboratory_Organisations_Variance_Fields = {
  __typename?: 'laboratory_organisations_variance_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "laboratory_organisations" */
export type Laboratory_Organisations_Variance_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: laboratory */
export type Laboratory_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "laboratory" */
export enum Laboratory_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "laboratory" */
export type Laboratory_Set_Input = {
  address_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Laboratory_Stddev_Fields = {
  __typename?: 'laboratory_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Laboratory_Stddev_Pop_Fields = {
  __typename?: 'laboratory_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Laboratory_Stddev_Samp_Fields = {
  __typename?: 'laboratory_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "laboratory" */
export type Laboratory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Laboratory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Laboratory_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Laboratory_Sum_Fields = {
  __typename?: 'laboratory_sum_fields';
  address_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "laboratory" */
export enum Laboratory_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Laboratory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Laboratory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Laboratory_Set_Input>;
  where: Laboratory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Laboratory_Var_Pop_Fields = {
  __typename?: 'laboratory_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Laboratory_Var_Samp_Fields = {
  __typename?: 'laboratory_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Laboratory_Variance_Fields = {
  __typename?: 'laboratory_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "legal_agreement" */
export type Legal_Agreement = {
  __typename?: 'legal_agreement';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  document?: Maybe<Scalars['String']>;
  /** An array relationship */
  guarantor_agreements: Array<Guarantor_Agreement>;
  /** An aggregate relationship */
  guarantor_agreements_aggregate: Guarantor_Agreement_Aggregate;
  id: Scalars['Int'];
  language: Scalars['String'];
  /** An array relationship */
  legal_agreements: Array<Agreement_Co_Owner_Legal_Agreement>;
  /** An aggregate relationship */
  legal_agreements_aggregate: Agreement_Co_Owner_Legal_Agreement_Aggregate;
  signed_by_details?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "legal_agreement" */
export type Legal_AgreementGuarantor_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};


/** columns and relationships of "legal_agreement" */
export type Legal_AgreementGuarantor_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};


/** columns and relationships of "legal_agreement" */
export type Legal_AgreementLegal_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


/** columns and relationships of "legal_agreement" */
export type Legal_AgreementLegal_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


/** columns and relationships of "legal_agreement" */
export type Legal_AgreementSigned_By_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "legal_agreement" */
export type Legal_Agreement_Aggregate = {
  __typename?: 'legal_agreement_aggregate';
  aggregate?: Maybe<Legal_Agreement_Aggregate_Fields>;
  nodes: Array<Legal_Agreement>;
};

/** aggregate fields of "legal_agreement" */
export type Legal_Agreement_Aggregate_Fields = {
  __typename?: 'legal_agreement_aggregate_fields';
  avg?: Maybe<Legal_Agreement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Legal_Agreement_Max_Fields>;
  min?: Maybe<Legal_Agreement_Min_Fields>;
  stddev?: Maybe<Legal_Agreement_Stddev_Fields>;
  stddev_pop?: Maybe<Legal_Agreement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legal_Agreement_Stddev_Samp_Fields>;
  sum?: Maybe<Legal_Agreement_Sum_Fields>;
  var_pop?: Maybe<Legal_Agreement_Var_Pop_Fields>;
  var_samp?: Maybe<Legal_Agreement_Var_Samp_Fields>;
  variance?: Maybe<Legal_Agreement_Variance_Fields>;
};


/** aggregate fields of "legal_agreement" */
export type Legal_Agreement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legal_Agreement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Legal_Agreement_Append_Input = {
  signed_by_details?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Legal_Agreement_Avg_Fields = {
  __typename?: 'legal_agreement_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "legal_agreement". All fields are combined with a logical 'AND'. */
export type Legal_Agreement_Bool_Exp = {
  _and?: InputMaybe<Array<Legal_Agreement_Bool_Exp>>;
  _not?: InputMaybe<Legal_Agreement_Bool_Exp>;
  _or?: InputMaybe<Array<Legal_Agreement_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<String_Comparison_Exp>;
  guarantor_agreements?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  legal_agreements?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
  signed_by_details?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "legal_agreement" */
export enum Legal_Agreement_Constraint {
  /** unique or primary key constraint on columns "codename" */
  LegalAgreementCodenameKey = 'legal_agreement_codename_key',
  /** unique or primary key constraint on columns "id" */
  LegalAgreementPkey = 'legal_agreement_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Legal_Agreement_Delete_At_Path_Input = {
  signed_by_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Legal_Agreement_Delete_Elem_Input = {
  signed_by_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Legal_Agreement_Delete_Key_Input = {
  signed_by_details?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "legal_agreement" */
export type Legal_Agreement_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "legal_agreement" */
export type Legal_Agreement_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Scalars['String']>;
  guarantor_agreements?: InputMaybe<Guarantor_Agreement_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  legal_agreements?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Arr_Rel_Insert_Input>;
  signed_by_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Legal_Agreement_Max_Fields = {
  __typename?: 'legal_agreement_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Legal_Agreement_Min_Fields = {
  __typename?: 'legal_agreement_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "legal_agreement" */
export type Legal_Agreement_Mutation_Response = {
  __typename?: 'legal_agreement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Legal_Agreement>;
};

/** input type for inserting object relation for remote table "legal_agreement" */
export type Legal_Agreement_Obj_Rel_Insert_Input = {
  data: Legal_Agreement_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Legal_Agreement_On_Conflict>;
};

/** on_conflict condition type for table "legal_agreement" */
export type Legal_Agreement_On_Conflict = {
  constraint: Legal_Agreement_Constraint;
  update_columns?: Array<Legal_Agreement_Update_Column>;
  where?: InputMaybe<Legal_Agreement_Bool_Exp>;
};

/** Ordering options when selecting data from "legal_agreement". */
export type Legal_Agreement_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Order_By>;
  guarantor_agreements_aggregate?: InputMaybe<Guarantor_Agreement_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  legal_agreements_aggregate?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Aggregate_Order_By>;
  signed_by_details?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: legal_agreement */
export type Legal_Agreement_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Legal_Agreement_Prepend_Input = {
  signed_by_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "legal_agreement" */
export enum Legal_Agreement_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Document = 'document',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  SignedByDetails = 'signed_by_details',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "legal_agreement" */
export type Legal_Agreement_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  signed_by_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Legal_Agreement_Stddev_Fields = {
  __typename?: 'legal_agreement_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Legal_Agreement_Stddev_Pop_Fields = {
  __typename?: 'legal_agreement_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Legal_Agreement_Stddev_Samp_Fields = {
  __typename?: 'legal_agreement_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "legal_agreement" */
export type Legal_Agreement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legal_Agreement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legal_Agreement_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  document?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  signed_by_details?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Legal_Agreement_Sum_Fields = {
  __typename?: 'legal_agreement_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "legal_agreement" */
export enum Legal_Agreement_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Document = 'document',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  SignedByDetails = 'signed_by_details',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Legal_Agreement_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Legal_Agreement_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Legal_Agreement_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Legal_Agreement_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Legal_Agreement_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legal_Agreement_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Legal_Agreement_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legal_Agreement_Set_Input>;
  where: Legal_Agreement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legal_Agreement_Var_Pop_Fields = {
  __typename?: 'legal_agreement_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Legal_Agreement_Var_Samp_Fields = {
  __typename?: 'legal_agreement_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Legal_Agreement_Variance_Fields = {
  __typename?: 'legal_agreement_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "market" */
export type Market = {
  __typename?: 'market';
  /** An array relationship */
  allowed_departments: Array<Market_Allowed_Departments>;
  /** An aggregate relationship */
  allowed_departments_aggregate: Market_Allowed_Departments_Aggregate;
  codename: Scalars['String'];
  description: Scalars['String'];
  /** An object relationship */
  icon?: Maybe<Eagle_Media>;
  icon_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  templates: Array<Template>;
  /** An aggregate relationship */
  templates_aggregate: Template_Aggregate;
};


/** columns and relationships of "market" */
export type MarketAllowed_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


/** columns and relationships of "market" */
export type MarketAllowed_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


/** columns and relationships of "market" */
export type MarketTemplatesArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


/** columns and relationships of "market" */
export type MarketTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};

/** aggregated selection of "market" */
export type Market_Aggregate = {
  __typename?: 'market_aggregate';
  aggregate?: Maybe<Market_Aggregate_Fields>;
  nodes: Array<Market>;
};

/** aggregate fields of "market" */
export type Market_Aggregate_Fields = {
  __typename?: 'market_aggregate_fields';
  avg?: Maybe<Market_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Market_Max_Fields>;
  min?: Maybe<Market_Min_Fields>;
  stddev?: Maybe<Market_Stddev_Fields>;
  stddev_pop?: Maybe<Market_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Market_Stddev_Samp_Fields>;
  sum?: Maybe<Market_Sum_Fields>;
  var_pop?: Maybe<Market_Var_Pop_Fields>;
  var_samp?: Maybe<Market_Var_Samp_Fields>;
  variance?: Maybe<Market_Variance_Fields>;
};


/** aggregate fields of "market" */
export type Market_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Market_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "market_allowed_departments" */
export type Market_Allowed_Departments = {
  __typename?: 'market_allowed_departments';
  /** An object relationship */
  department: External_Entity;
  externalentity_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  market: Market;
  market_id: Scalars['bigint'];
};

/** aggregated selection of "market_allowed_departments" */
export type Market_Allowed_Departments_Aggregate = {
  __typename?: 'market_allowed_departments_aggregate';
  aggregate?: Maybe<Market_Allowed_Departments_Aggregate_Fields>;
  nodes: Array<Market_Allowed_Departments>;
};

/** aggregate fields of "market_allowed_departments" */
export type Market_Allowed_Departments_Aggregate_Fields = {
  __typename?: 'market_allowed_departments_aggregate_fields';
  avg?: Maybe<Market_Allowed_Departments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Market_Allowed_Departments_Max_Fields>;
  min?: Maybe<Market_Allowed_Departments_Min_Fields>;
  stddev?: Maybe<Market_Allowed_Departments_Stddev_Fields>;
  stddev_pop?: Maybe<Market_Allowed_Departments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Market_Allowed_Departments_Stddev_Samp_Fields>;
  sum?: Maybe<Market_Allowed_Departments_Sum_Fields>;
  var_pop?: Maybe<Market_Allowed_Departments_Var_Pop_Fields>;
  var_samp?: Maybe<Market_Allowed_Departments_Var_Samp_Fields>;
  variance?: Maybe<Market_Allowed_Departments_Variance_Fields>;
};


/** aggregate fields of "market_allowed_departments" */
export type Market_Allowed_Departments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "market_allowed_departments" */
export type Market_Allowed_Departments_Aggregate_Order_By = {
  avg?: InputMaybe<Market_Allowed_Departments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Market_Allowed_Departments_Max_Order_By>;
  min?: InputMaybe<Market_Allowed_Departments_Min_Order_By>;
  stddev?: InputMaybe<Market_Allowed_Departments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Market_Allowed_Departments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Market_Allowed_Departments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Market_Allowed_Departments_Sum_Order_By>;
  var_pop?: InputMaybe<Market_Allowed_Departments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Market_Allowed_Departments_Var_Samp_Order_By>;
  variance?: InputMaybe<Market_Allowed_Departments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "market_allowed_departments" */
export type Market_Allowed_Departments_Arr_Rel_Insert_Input = {
  data: Array<Market_Allowed_Departments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Market_Allowed_Departments_On_Conflict>;
};

/** aggregate avg on columns */
export type Market_Allowed_Departments_Avg_Fields = {
  __typename?: 'market_allowed_departments_avg_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Avg_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "market_allowed_departments". All fields are combined with a logical 'AND'. */
export type Market_Allowed_Departments_Bool_Exp = {
  _and?: InputMaybe<Array<Market_Allowed_Departments_Bool_Exp>>;
  _not?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
  _or?: InputMaybe<Array<Market_Allowed_Departments_Bool_Exp>>;
  department?: InputMaybe<External_Entity_Bool_Exp>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  market?: InputMaybe<Market_Bool_Exp>;
  market_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "market_allowed_departments" */
export enum Market_Allowed_Departments_Constraint {
  /** unique or primary key constraint on columns "market_id", "externalentity_id" */
  MarketAllowedDepartmenMarketIdExternalentity_6fd7cb99Uniq = 'market_allowed_departmen_market_id_externalentity_6fd7cb99_uniq',
  /** unique or primary key constraint on columns "id" */
  MarketAllowedDepartmentsPkey = 'market_allowed_departments_pkey'
}

/** input type for incrementing numeric columns in table "market_allowed_departments" */
export type Market_Allowed_Departments_Inc_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  market_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "market_allowed_departments" */
export type Market_Allowed_Departments_Insert_Input = {
  department?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  market?: InputMaybe<Market_Obj_Rel_Insert_Input>;
  market_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Market_Allowed_Departments_Max_Fields = {
  __typename?: 'market_allowed_departments_max_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  market_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Max_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Market_Allowed_Departments_Min_Fields = {
  __typename?: 'market_allowed_departments_min_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  market_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Min_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "market_allowed_departments" */
export type Market_Allowed_Departments_Mutation_Response = {
  __typename?: 'market_allowed_departments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Market_Allowed_Departments>;
};

/** on_conflict condition type for table "market_allowed_departments" */
export type Market_Allowed_Departments_On_Conflict = {
  constraint: Market_Allowed_Departments_Constraint;
  update_columns?: Array<Market_Allowed_Departments_Update_Column>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};

/** Ordering options when selecting data from "market_allowed_departments". */
export type Market_Allowed_Departments_Order_By = {
  department?: InputMaybe<External_Entity_Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market?: InputMaybe<Market_Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: market_allowed_departments */
export type Market_Allowed_Departments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "market_allowed_departments" */
export enum Market_Allowed_Departments_Select_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  MarketId = 'market_id'
}

/** input type for updating data in table "market_allowed_departments" */
export type Market_Allowed_Departments_Set_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  market_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Market_Allowed_Departments_Stddev_Fields = {
  __typename?: 'market_allowed_departments_stddev_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Stddev_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Market_Allowed_Departments_Stddev_Pop_Fields = {
  __typename?: 'market_allowed_departments_stddev_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Stddev_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Market_Allowed_Departments_Stddev_Samp_Fields = {
  __typename?: 'market_allowed_departments_stddev_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Stddev_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "market_allowed_departments" */
export type Market_Allowed_Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Market_Allowed_Departments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Market_Allowed_Departments_Stream_Cursor_Value_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  market_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Market_Allowed_Departments_Sum_Fields = {
  __typename?: 'market_allowed_departments_sum_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  market_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Sum_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** update columns of table "market_allowed_departments" */
export enum Market_Allowed_Departments_Update_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  MarketId = 'market_id'
}

export type Market_Allowed_Departments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Market_Allowed_Departments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Market_Allowed_Departments_Set_Input>;
  where: Market_Allowed_Departments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Market_Allowed_Departments_Var_Pop_Fields = {
  __typename?: 'market_allowed_departments_var_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Var_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Market_Allowed_Departments_Var_Samp_Fields = {
  __typename?: 'market_allowed_departments_var_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Var_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Market_Allowed_Departments_Variance_Fields = {
  __typename?: 'market_allowed_departments_variance_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "market_allowed_departments" */
export type Market_Allowed_Departments_Variance_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Market_Avg_Fields = {
  __typename?: 'market_avg_fields';
  icon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "market". All fields are combined with a logical 'AND'. */
export type Market_Bool_Exp = {
  _and?: InputMaybe<Array<Market_Bool_Exp>>;
  _not?: InputMaybe<Market_Bool_Exp>;
  _or?: InputMaybe<Array<Market_Bool_Exp>>;
  allowed_departments?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<Eagle_Media_Bool_Exp>;
  icon_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  templates?: InputMaybe<Template_Bool_Exp>;
};

/** unique or primary key constraints on table "market" */
export enum Market_Constraint {
  /** unique or primary key constraint on columns "codename" */
  MarketCodenameKey = 'market_codename_key',
  /** unique or primary key constraint on columns "id" */
  MarketPkey = 'market_pkey'
}

/** input type for incrementing numeric columns in table "market" */
export type Market_Inc_Input = {
  icon_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "market" */
export type Market_Insert_Input = {
  allowed_departments?: InputMaybe<Market_Allowed_Departments_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  icon_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  templates?: InputMaybe<Template_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Market_Max_Fields = {
  __typename?: 'market_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Market_Min_Fields = {
  __typename?: 'market_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "market" */
export type Market_Mutation_Response = {
  __typename?: 'market_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Market>;
};

/** input type for inserting object relation for remote table "market" */
export type Market_Obj_Rel_Insert_Input = {
  data: Market_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Market_On_Conflict>;
};

/** on_conflict condition type for table "market" */
export type Market_On_Conflict = {
  constraint: Market_Constraint;
  update_columns?: Array<Market_Update_Column>;
  where?: InputMaybe<Market_Bool_Exp>;
};

/** Ordering options when selecting data from "market". */
export type Market_Order_By = {
  allowed_departments_aggregate?: InputMaybe<Market_Allowed_Departments_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  icon?: InputMaybe<Eagle_Media_Order_By>;
  icon_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  templates_aggregate?: InputMaybe<Template_Aggregate_Order_By>;
};

/** primary key columns input for table: market */
export type Market_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "market" */
export enum Market_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  IconId = 'icon_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "market" */
export type Market_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Market_Stddev_Fields = {
  __typename?: 'market_stddev_fields';
  icon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Market_Stddev_Pop_Fields = {
  __typename?: 'market_stddev_pop_fields';
  icon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Market_Stddev_Samp_Fields = {
  __typename?: 'market_stddev_samp_fields';
  icon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "market" */
export type Market_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Market_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Market_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  icon_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Market_Sum_Fields = {
  __typename?: 'market_sum_fields';
  icon_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "market" */
export enum Market_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  IconId = 'icon_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Market_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Market_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Market_Set_Input>;
  where: Market_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Market_Var_Pop_Fields = {
  __typename?: 'market_var_pop_fields';
  icon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Market_Var_Samp_Fields = {
  __typename?: 'market_var_samp_fields';
  icon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Market_Variance_Fields = {
  __typename?: 'market_variance_fields';
  icon_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "media" */
export type Media = {
  __typename?: 'media';
  access: Scalars['String'];
  created_at: Scalars['timestamptz'];
  etag?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_encrypted: Scalars['Boolean'];
  /** An object relationship */
  location?: Maybe<Address>;
  location_id?: Maybe<Scalars['Int']>;
  media_kind: Scalars['String'];
  mime_type?: Maybe<Scalars['String']>;
  signed_url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  thumbnail?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
};


/** columns and relationships of "media" */
export type MediaThumbnailArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "media" */
export type Media_Aggregate = {
  __typename?: 'media_aggregate';
  aggregate?: Maybe<Media_Aggregate_Fields>;
  nodes: Array<Media>;
};

/** aggregate fields of "media" */
export type Media_Aggregate_Fields = {
  __typename?: 'media_aggregate_fields';
  avg?: Maybe<Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Media_Max_Fields>;
  min?: Maybe<Media_Min_Fields>;
  stddev?: Maybe<Media_Stddev_Fields>;
  stddev_pop?: Maybe<Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Media_Stddev_Samp_Fields>;
  sum?: Maybe<Media_Sum_Fields>;
  var_pop?: Maybe<Media_Var_Pop_Fields>;
  var_samp?: Maybe<Media_Var_Samp_Fields>;
  variance?: Maybe<Media_Variance_Fields>;
};


/** aggregate fields of "media" */
export type Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Media_Append_Input = {
  thumbnail?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Media_Avg_Fields = {
  __typename?: 'media_avg_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type Media_Bool_Exp = {
  _and?: InputMaybe<Array<Media_Bool_Exp>>;
  _not?: InputMaybe<Media_Bool_Exp>;
  _or?: InputMaybe<Array<Media_Bool_Exp>>;
  access?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_encrypted?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<Address_Bool_Exp>;
  location_id?: InputMaybe<Int_Comparison_Exp>;
  media_kind?: InputMaybe<String_Comparison_Exp>;
  mime_type?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  thumbnail?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "media" */
export enum Media_Constraint {
  /** unique or primary key constraint on columns "id" */
  MediaPkey = 'media_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Media_Delete_At_Path_Input = {
  thumbnail?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Media_Delete_Elem_Input = {
  thumbnail?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Media_Delete_Key_Input = {
  thumbnail?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "media" */
export type Media_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "media" */
export type Media_Insert_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['Int']>;
  media_kind?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Media_Max_Fields = {
  __typename?: 'media_max_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  media_kind?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Media_Min_Fields = {
  __typename?: 'media_min_fields';
  access?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  media_kind?: Maybe<Scalars['String']>;
  mime_type?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "media" */
export type Media_Mutation_Response = {
  __typename?: 'media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Media>;
};

/** input type for inserting object relation for remote table "media" */
export type Media_Obj_Rel_Insert_Input = {
  data: Media_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Media_On_Conflict>;
};

/** on_conflict condition type for table "media" */
export type Media_On_Conflict = {
  constraint: Media_Constraint;
  update_columns?: Array<Media_Update_Column>;
  where?: InputMaybe<Media_Bool_Exp>;
};

/** Ordering options when selecting data from "media". */
export type Media_Order_By = {
  access?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_encrypted?: InputMaybe<Order_By>;
  location?: InputMaybe<Address_Order_By>;
  location_id?: InputMaybe<Order_By>;
  media_kind?: InputMaybe<Order_By>;
  mime_type?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  thumbnail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: media */
export type Media_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Media_Prepend_Input = {
  thumbnail?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "media" */
export enum Media_Select_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MediaKind = 'media_kind',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Size = 'size',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "media" */
export type Media_Set_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  media_kind?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Media_Stddev_Fields = {
  __typename?: 'media_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Media_Stddev_Pop_Fields = {
  __typename?: 'media_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Media_Stddev_Samp_Fields = {
  __typename?: 'media_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "media" */
export type Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Media_Stream_Cursor_Value_Input = {
  access?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  location_id?: InputMaybe<Scalars['Int']>;
  media_kind?: InputMaybe<Scalars['String']>;
  mime_type?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Media_Sum_Fields = {
  __typename?: 'media_sum_fields';
  id?: Maybe<Scalars['Int']>;
  location_id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};

/** update columns of table "media" */
export enum Media_Update_Column {
  /** column name */
  Access = 'access',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MediaKind = 'media_kind',
  /** column name */
  MimeType = 'mime_type',
  /** column name */
  Size = 'size',
  /** column name */
  Thumbnail = 'thumbnail',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Media_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Media_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Media_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Media_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Media_Set_Input>;
  where: Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Media_Var_Pop_Fields = {
  __typename?: 'media_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Media_Var_Samp_Fields = {
  __typename?: 'media_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Media_Variance_Fields = {
  __typename?: 'media_variance_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "milestone" */
export type Milestone = {
  __typename?: 'milestone';
  date_format: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  kind: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "milestone" */
export type Milestone_Aggregate = {
  __typename?: 'milestone_aggregate';
  aggregate?: Maybe<Milestone_Aggregate_Fields>;
  nodes: Array<Milestone>;
};

/** aggregate fields of "milestone" */
export type Milestone_Aggregate_Fields = {
  __typename?: 'milestone_aggregate_fields';
  avg?: Maybe<Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Milestone_Max_Fields>;
  min?: Maybe<Milestone_Min_Fields>;
  stddev?: Maybe<Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Milestone_Sum_Fields>;
  var_pop?: Maybe<Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Milestone_Var_Samp_Fields>;
  variance?: Maybe<Milestone_Variance_Fields>;
};


/** aggregate fields of "milestone" */
export type Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Milestone_Avg_Fields = {
  __typename?: 'milestone_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "milestone". All fields are combined with a logical 'AND'. */
export type Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Milestone_Bool_Exp>>;
  _not?: InputMaybe<Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Milestone_Bool_Exp>>;
  date_format?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "milestone" */
export enum Milestone_Constraint {
  /** unique or primary key constraint on columns "id" */
  MilestonePkey = 'milestone_pkey'
}

/** input type for incrementing numeric columns in table "milestone" */
export type Milestone_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "milestone" */
export type Milestone_Insert_Input = {
  date_format?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Milestone_Max_Fields = {
  __typename?: 'milestone_max_fields';
  date_format?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Milestone_Min_Fields = {
  __typename?: 'milestone_min_fields';
  date_format?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "milestone" */
export type Milestone_Mutation_Response = {
  __typename?: 'milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Milestone>;
};

/** input type for inserting object relation for remote table "milestone" */
export type Milestone_Obj_Rel_Insert_Input = {
  data: Milestone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};

/** on_conflict condition type for table "milestone" */
export type Milestone_On_Conflict = {
  constraint: Milestone_Constraint;
  update_columns?: Array<Milestone_Update_Column>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "milestone". */
export type Milestone_Order_By = {
  date_format?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: milestone */
export type Milestone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "milestone" */
export enum Milestone_Select_Column {
  /** column name */
  DateFormat = 'date_format',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "milestone" */
export type Milestone_Set_Input = {
  date_format?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Milestone_Stddev_Fields = {
  __typename?: 'milestone_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Milestone_Stddev_Pop_Fields = {
  __typename?: 'milestone_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Milestone_Stddev_Samp_Fields = {
  __typename?: 'milestone_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "milestone" */
export type Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Milestone_Stream_Cursor_Value_Input = {
  date_format?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Milestone_Sum_Fields = {
  __typename?: 'milestone_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "milestone" */
export enum Milestone_Update_Column {
  /** column name */
  DateFormat = 'date_format',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name'
}

export type Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Milestone_Set_Input>;
  where: Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Milestone_Var_Pop_Fields = {
  __typename?: 'milestone_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Milestone_Var_Samp_Fields = {
  __typename?: 'milestone_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Milestone_Variance_Fields = {
  __typename?: 'milestone_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  add_advance_transaction?: Maybe<AddAdvanceTransactionMutation>;
  add_result_comment?: Maybe<AddResultComment>;
  add_update_agreement_transaction?: Maybe<AddUpdateAgreementTransactionMutation>;
  add_update_base_user?: Maybe<AddUpdateBaseUser>;
  add_update_business?: Maybe<AddUpdateBusinessMutation>;
  add_update_credit_assessment?: Maybe<AddUpdateCreditMutation>;
  add_update_demand?: Maybe<AddUpdateDemandMutation>;
  add_update_dock_detail?: Maybe<AddUpdateDockDetailMutation>;
  add_update_general_request?: Maybe<AddUpdateGeneralRequest>;
  add_update_internal_requests?: Maybe<AddUpdateInternalRequests>;
  add_update_issuance_note?: Maybe<AddUpdateIssuanceNoteMutation>;
  add_update_offer?: Maybe<AddUpdateOfferMutation>;
  add_update_order_transaction?: Maybe<AddUpdateOrderTransactionMutation>;
  add_update_production_final_trade?: Maybe<AddUpdateProductionTradeFinalMutation>;
  add_update_production_planning_trade?: Maybe<AddUpdateProductionTradePlanningMutation>;
  add_update_receipt?: Maybe<AddUpdateReceipt>;
  add_update_result?: Maybe<AddUpdateResultMutation>;
  add_update_sample_observations?: Maybe<AddUpdateSampleObservations>;
  add_update_setutrade_trip?: Maybe<AddUpdateTripMutation>;
  add_update_storage_location?: Maybe<AddUpdateStorageLocationMutation>;
  add_update_test_requests?: Maybe<AddUpdateTestRequests>;
  add_update_trade?: Maybe<AddUpdateTradeMutation>;
  add_update_trip_detail?: Maybe<UpdateTripDetailsMutation>;
  agent_login?: Maybe<AgentLogin>;
  approve_credit?: Maybe<ApproveCreditMutation>;
  approve_credit_wallet_request?: Maybe<ApproveCreditWalletRequestMutation>;
  approve_over_draft_request?: Maybe<ApproveOverDraftRequest>;
  associate_user_with_organisations?: Maybe<AssociateBaseUserWithOrganisations>;
  broadcast_consents?: Maybe<BroadcastConsents>;
  bulk_update_base_user_companies?: Maybe<BulkUpdateBaseUserCompaniesMutation>;
  bulk_update_order?: Maybe<BulkUpdateOrderMutation>;
  bulk_update_result_grade?: Maybe<BulkUpdateResultGradesPayload>;
  cancel_invoice?: Maybe<CancelInvoiceMutation>;
  cancel_transaction?: Maybe<CancelTransactionMutation>;
  change_credit_status?: Maybe<ChangeCreditStatus>;
  close_advance_payment?: Maybe<CloseAdvancePaymentMutation>;
  close_plot_crop?: Maybe<ClosePlotCrop>;
  copy_trade_to_inward?: Maybe<CopyTradeToInwardMutation>;
  create_credit_wallet_request?: Maybe<CreateCreditWalletRequestMutation>;
  create_expenses_config?: Maybe<CreateExpenseConfigMutation>;
  create_guarantor_agreement?: Maybe<CreateGuarantorAgreement>;
  create_over_draft_request?: Maybe<CreateOverDraftRequest>;
  create_tnc_config?: Maybe<CreateTncConfigMutation>;
  create_update_base_user?: Maybe<BaseUserCreateEditMutation>;
  /** delete data from the table: "action_log" */
  delete_action_log?: Maybe<Action_Log_Mutation_Response>;
  /** delete single row from the table: "action_log" */
  delete_action_log_by_pk?: Maybe<Action_Log>;
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** delete data from the table: "agent" */
  delete_agent?: Maybe<Agent_Mutation_Response>;
  /** delete single row from the table: "agent" */
  delete_agent_by_pk?: Maybe<Agent>;
  /** delete data from the table: "agent_company" */
  delete_agent_company?: Maybe<Agent_Company_Mutation_Response>;
  /** delete single row from the table: "agent_company" */
  delete_agent_company_by_pk?: Maybe<Agent_Company>;
  /** delete data from the table: "agent_role" */
  delete_agent_role?: Maybe<Agent_Role_Mutation_Response>;
  /** delete single row from the table: "agent_role" */
  delete_agent_role_by_pk?: Maybe<Agent_Role>;
  /** delete data from the table: "agreement_co_owner" */
  delete_agreement_co_owner?: Maybe<Agreement_Co_Owner_Mutation_Response>;
  /** delete data from the table: "agreement_co_owner_agreement_invoices" */
  delete_agreement_co_owner_agreement_invoices?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Mutation_Response>;
  /** delete single row from the table: "agreement_co_owner_agreement_invoices" */
  delete_agreement_co_owner_agreement_invoices_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Invoices>;
  /** delete data from the table: "agreement_co_owner_agreement_plots" */
  delete_agreement_co_owner_agreement_plots?: Maybe<Agreement_Co_Owner_Agreement_Plots_Mutation_Response>;
  /** delete single row from the table: "agreement_co_owner_agreement_plots" */
  delete_agreement_co_owner_agreement_plots_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Plots>;
  /** delete single row from the table: "agreement_co_owner" */
  delete_agreement_co_owner_by_pk?: Maybe<Agreement_Co_Owner>;
  /** delete data from the table: "agreement_co_owner_legal_agreement" */
  delete_agreement_co_owner_legal_agreement?: Maybe<Agreement_Co_Owner_Legal_Agreement_Mutation_Response>;
  /** delete single row from the table: "agreement_co_owner_legal_agreement" */
  delete_agreement_co_owner_legal_agreement_by_pk?: Maybe<Agreement_Co_Owner_Legal_Agreement>;
  /** delete data from the table: "agreement_invoice" */
  delete_agreement_invoice?: Maybe<Agreement_Invoice_Mutation_Response>;
  /** delete data from the table: "agreement_invoice_agreement_invoice_items" */
  delete_agreement_invoice_agreement_invoice_items?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Mutation_Response>;
  /** delete single row from the table: "agreement_invoice_agreement_invoice_items" */
  delete_agreement_invoice_agreement_invoice_items_by_pk?: Maybe<Agreement_Invoice_Agreement_Invoice_Items>;
  /** delete single row from the table: "agreement_invoice" */
  delete_agreement_invoice_by_pk?: Maybe<Agreement_Invoice>;
  /** delete data from the table: "agreement_invoice_item" */
  delete_agreement_invoice_item?: Maybe<Agreement_Invoice_Item_Mutation_Response>;
  /** delete single row from the table: "agreement_invoice_item" */
  delete_agreement_invoice_item_by_pk?: Maybe<Agreement_Invoice_Item>;
  /** delete data from the table: "agreement_invoice_transaction" */
  delete_agreement_invoice_transaction?: Maybe<Agreement_Invoice_Transaction_Mutation_Response>;
  /** delete single row from the table: "agreement_invoice_transaction" */
  delete_agreement_invoice_transaction_by_pk?: Maybe<Agreement_Invoice_Transaction>;
  /** delete data from the table: "agreement_plot" */
  delete_agreement_plot?: Maybe<Agreement_Plot_Mutation_Response>;
  /** delete single row from the table: "agreement_plot" */
  delete_agreement_plot_by_pk?: Maybe<Agreement_Plot>;
  /** delete data from the table: "amendment_case" */
  delete_amendment_case?: Maybe<Amendment_Case_Mutation_Response>;
  /** delete single row from the table: "amendment_case" */
  delete_amendment_case_by_pk?: Maybe<Amendment_Case>;
  /** delete data from the table: "auth_group" */
  delete_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** delete single row from the table: "auth_group" */
  delete_auth_group_by_pk?: Maybe<Auth_Group>;
  /** delete data from the table: "auth_group_permissions" */
  delete_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** delete single row from the table: "auth_group_permissions" */
  delete_auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** delete data from the table: "auth_permission" */
  delete_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** delete single row from the table: "auth_permission" */
  delete_auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** delete data from the table: "base_user" */
  delete_base_user?: Maybe<Base_User_Mutation_Response>;
  /** delete data from the table: "base_user_address_book" */
  delete_base_user_address_book?: Maybe<Base_User_Address_Book_Mutation_Response>;
  /** delete single row from the table: "base_user_address_book" */
  delete_base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** delete single row from the table: "base_user" */
  delete_base_user_by_pk?: Maybe<Base_User>;
  /** delete data from the table: "base_user_companies" */
  delete_base_user_companies?: Maybe<Base_User_Companies_Mutation_Response>;
  /** delete single row from the table: "base_user_companies" */
  delete_base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  /** delete data from the table: "base_user_departments" */
  delete_base_user_departments?: Maybe<Base_User_Departments_Mutation_Response>;
  /** delete single row from the table: "base_user_departments" */
  delete_base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  /** delete data from the table: "base_user_groups" */
  delete_base_user_groups?: Maybe<Base_User_Groups_Mutation_Response>;
  /** delete single row from the table: "base_user_groups" */
  delete_base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** delete data from the table: "base_user_network" */
  delete_base_user_network?: Maybe<Base_User_Network_Mutation_Response>;
  /** delete single row from the table: "base_user_network" */
  delete_base_user_network_by_pk?: Maybe<Base_User_Network>;
  /** delete data from the table: "base_user_user_permissions" */
  delete_base_user_user_permissions?: Maybe<Base_User_User_Permissions_Mutation_Response>;
  /** delete single row from the table: "base_user_user_permissions" */
  delete_base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  /** delete data from the table: "brand" */
  delete_brand?: Maybe<Brand_Mutation_Response>;
  /** delete single row from the table: "brand" */
  delete_brand_by_pk?: Maybe<Brand>;
  /** delete data from the table: "brand_company" */
  delete_brand_company?: Maybe<Brand_Company_Mutation_Response>;
  /** delete single row from the table: "brand_company" */
  delete_brand_company_by_pk?: Maybe<Brand_Company>;
  /** delete data from the table: "breeder" */
  delete_breeder?: Maybe<Breeder_Mutation_Response>;
  /** delete single row from the table: "breeder" */
  delete_breeder_by_pk?: Maybe<Breeder>;
  /** delete data from the table: "business" */
  delete_business?: Maybe<Business_Mutation_Response>;
  /** delete single row from the table: "business" */
  delete_business_by_pk?: Maybe<Business>;
  /** delete data from the table: "business_commodities_supplied" */
  delete_business_commodities_supplied?: Maybe<Business_Commodities_Supplied_Mutation_Response>;
  /** delete single row from the table: "business_commodities_supplied" */
  delete_business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** delete data from the table: "business_companies" */
  delete_business_companies?: Maybe<Business_Companies_Mutation_Response>;
  /** delete single row from the table: "business_companies" */
  delete_business_companies_by_pk?: Maybe<Business_Companies>;
  /** delete data from the table: "business_field" */
  delete_business_field?: Maybe<Business_Field_Mutation_Response>;
  /** delete single row from the table: "business_field" */
  delete_business_field_by_pk?: Maybe<Business_Field>;
  /** delete data from the table: "business_group" */
  delete_business_group?: Maybe<Business_Group_Mutation_Response>;
  /** delete single row from the table: "business_group" */
  delete_business_group_by_pk?: Maybe<Business_Group>;
  /** delete data from the table: "business_group_network" */
  delete_business_group_network?: Maybe<Business_Group_Network_Mutation_Response>;
  /** delete single row from the table: "business_group_network" */
  delete_business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** delete data from the table: "business_groups" */
  delete_business_groups?: Maybe<Business_Groups_Mutation_Response>;
  /** delete single row from the table: "business_groups" */
  delete_business_groups_by_pk?: Maybe<Business_Groups>;
  /** delete data from the table: "business_network" */
  delete_business_network?: Maybe<Business_Network_Mutation_Response>;
  /** delete single row from the table: "business_network" */
  delete_business_network_by_pk?: Maybe<Business_Network>;
  /** delete data from the table: "business_secondary_pocs" */
  delete_business_secondary_pocs?: Maybe<Business_Secondary_Pocs_Mutation_Response>;
  /** delete single row from the table: "business_secondary_pocs" */
  delete_business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  /** delete single row from the table: "address" */
  delete_by_pk_eagle_address?: Maybe<Eagle_Address>;
  /** delete single row from the table: "media" */
  delete_by_pk_eagle_media?: Maybe<Eagle_Media>;
  /** delete data from the table: "commodity" */
  delete_commodity?: Maybe<Commodity_Mutation_Response>;
  /** delete single row from the table: "commodity" */
  delete_commodity_by_pk?: Maybe<Commodity>;
  /** delete data from the table: "commodity_variety" */
  delete_commodity_variety?: Maybe<Commodity_Variety_Mutation_Response>;
  /** delete single row from the table: "commodity_variety" */
  delete_commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** delete data from the table: "commodity_variety_secondary_groups" */
  delete_commodity_variety_secondary_groups?: Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>;
  /** delete single row from the table: "commodity_variety_secondary_groups" */
  delete_commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** delete data from the table: "company" */
  delete_company?: Maybe<Company_Mutation_Response>;
  /** delete single row from the table: "company" */
  delete_company_by_pk?: Maybe<Company>;
  /** delete data from the table: "company_categories" */
  delete_company_categories?: Maybe<Company_Categories_Mutation_Response>;
  /** delete single row from the table: "company_categories" */
  delete_company_categories_by_pk?: Maybe<Company_Categories>;
  /** delete data from the table: "company_category" */
  delete_company_category?: Maybe<Company_Category_Mutation_Response>;
  /** delete single row from the table: "company_category" */
  delete_company_category_by_pk?: Maybe<Company_Category>;
  /** delete data from the table: "company_share_holder" */
  delete_company_share_holder?: Maybe<Company_Share_Holder_Mutation_Response>;
  /** delete single row from the table: "company_share_holder" */
  delete_company_share_holder_by_pk?: Maybe<Company_Share_Holder>;
  /** delete data from the table: "crop" */
  delete_crop?: Maybe<Crop_Mutation_Response>;
  /** delete single row from the table: "crop" */
  delete_crop_by_pk?: Maybe<Crop>;
  /** delete data from the table: "crop_group" */
  delete_crop_group?: Maybe<Crop_Group_Mutation_Response>;
  /** delete single row from the table: "crop_group" */
  delete_crop_group_by_pk?: Maybe<Crop_Group>;
  /** delete data from the table: "crop_infestation" */
  delete_crop_infestation?: Maybe<Crop_Infestation_Mutation_Response>;
  /** delete data from the table: "crop_infestation_attachment" */
  delete_crop_infestation_attachment?: Maybe<Crop_Infestation_Attachment_Mutation_Response>;
  /** delete single row from the table: "crop_infestation_attachment" */
  delete_crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** delete single row from the table: "crop_infestation" */
  delete_crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  /** delete data from the table: "crop_milestone" */
  delete_crop_milestone?: Maybe<Crop_Milestone_Mutation_Response>;
  /** delete single row from the table: "crop_milestone" */
  delete_crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** delete data from the table: "crop_rootstock" */
  delete_crop_rootstock?: Maybe<Crop_Rootstock_Mutation_Response>;
  /** delete single row from the table: "crop_rootstock" */
  delete_crop_rootstock_by_pk?: Maybe<Crop_Rootstock>;
  /** delete data from the table: "crop_variety" */
  delete_crop_variety?: Maybe<Crop_Variety_Mutation_Response>;
  /** delete data from the table: "crop_variety_breeder" */
  delete_crop_variety_breeder?: Maybe<Crop_Variety_Breeder_Mutation_Response>;
  /** delete single row from the table: "crop_variety_breeder" */
  delete_crop_variety_breeder_by_pk?: Maybe<Crop_Variety_Breeder>;
  /** delete single row from the table: "crop_variety" */
  delete_crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** delete data from the table: "crop_year" */
  delete_crop_year?: Maybe<Crop_Year_Mutation_Response>;
  /** delete single row from the table: "crop_year" */
  delete_crop_year_by_pk?: Maybe<Crop_Year>;
  /** delete data from the table: "cultivation_type" */
  delete_cultivation_type?: Maybe<Cultivation_Type_Mutation_Response>;
  /** delete single row from the table: "cultivation_type" */
  delete_cultivation_type_by_pk?: Maybe<Cultivation_Type>;
  /** delete data from the table: "department" */
  delete_department?: Maybe<Department_Mutation_Response>;
  /** delete single row from the table: "department" */
  delete_department_by_pk?: Maybe<Department>;
  /** delete data from the table: "department_payment_detail" */
  delete_department_payment_detail?: Maybe<Department_Payment_Detail_Mutation_Response>;
  /** delete single row from the table: "department_payment_detail" */
  delete_department_payment_detail_by_pk?: Maybe<Department_Payment_Detail>;
  /** delete data from the table: "device" */
  delete_device?: Maybe<Device_Mutation_Response>;
  /** delete single row from the table: "device" */
  delete_device_by_pk?: Maybe<Device>;
  /** delete data from the table: "django_content_type" */
  delete_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** delete single row from the table: "django_content_type" */
  delete_django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** delete data from the table: "document" */
  delete_document?: Maybe<Document_Mutation_Response>;
  /** delete data from the table: "document_attachments" */
  delete_document_attachments?: Maybe<Document_Attachments_Mutation_Response>;
  /** delete single row from the table: "document_attachments" */
  delete_document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** delete single row from the table: "document" */
  delete_document_by_pk?: Maybe<Document>;
  /** delete data from the table: "document_data" */
  delete_document_data?: Maybe<Document_Data_Mutation_Response>;
  /** delete single row from the table: "document_data" */
  delete_document_data_by_pk?: Maybe<Document_Data>;
  /** delete data from the table: "document_export_log" */
  delete_document_export_log?: Maybe<Document_Export_Log_Mutation_Response>;
  /** delete single row from the table: "document_export_log" */
  delete_document_export_log_by_pk?: Maybe<Document_Export_Log>;
  /** delete data from the table: "document_kind" */
  delete_document_kind?: Maybe<Document_Kind_Mutation_Response>;
  /** delete single row from the table: "document_kind" */
  delete_document_kind_by_pk?: Maybe<Document_Kind>;
  /** delete data from the table: "document_kind_data_field" */
  delete_document_kind_data_field?: Maybe<Document_Kind_Data_Field_Mutation_Response>;
  /** delete single row from the table: "document_kind_data_field" */
  delete_document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** delete data from the table: "document_report" */
  delete_document_report?: Maybe<Document_Report_Mutation_Response>;
  /** delete single row from the table: "document_report" */
  delete_document_report_by_pk?: Maybe<Document_Report>;
  /** delete data from the table: "document_revision" */
  delete_document_revision?: Maybe<Document_Revision_Mutation_Response>;
  /** delete single row from the table: "document_revision" */
  delete_document_revision_by_pk?: Maybe<Document_Revision>;
  /** delete data from the table: "address" */
  delete_eagle_address?: Maybe<Eagle_Address_Mutation_Response>;
  /** delete data from the table: "media" */
  delete_eagle_media?: Maybe<Eagle_Media_Mutation_Response>;
  /** delete data from the table: "entity_state" */
  delete_entity_state?: Maybe<Entity_State_Mutation_Response>;
  /** delete single row from the table: "entity_state" */
  delete_entity_state_by_pk?: Maybe<Entity_State>;
  /** delete data from the table: "evaluation_criteria" */
  delete_evaluation_criteria?: Maybe<Evaluation_Criteria_Mutation_Response>;
  /** delete single row from the table: "evaluation_criteria" */
  delete_evaluation_criteria_by_pk?: Maybe<Evaluation_Criteria>;
  /** delete data from the table: "evaluation_tag" */
  delete_evaluation_tag?: Maybe<Evaluation_Tag_Mutation_Response>;
  /** delete single row from the table: "evaluation_tag" */
  delete_evaluation_tag_by_pk?: Maybe<Evaluation_Tag>;
  /** delete data from the table: "expense" */
  delete_expense?: Maybe<Expense_Mutation_Response>;
  /** delete single row from the table: "expense" */
  delete_expense_by_pk?: Maybe<Expense>;
  /** delete data from the table: "external_application" */
  delete_external_application?: Maybe<External_Application_Mutation_Response>;
  /** delete single row from the table: "external_application" */
  delete_external_application_by_pk?: Maybe<External_Application>;
  /** delete data from the table: "external_entity" */
  delete_external_entity?: Maybe<External_Entity_Mutation_Response>;
  /** delete single row from the table: "external_entity" */
  delete_external_entity_by_pk?: Maybe<External_Entity>;
  /** delete data from the table: "external_entity_group" */
  delete_external_entity_group?: Maybe<External_Entity_Group_Mutation_Response>;
  /** delete single row from the table: "external_entity_group" */
  delete_external_entity_group_by_pk?: Maybe<External_Entity_Group>;
  /** delete data from the table: "external_reference" */
  delete_external_reference?: Maybe<External_Reference_Mutation_Response>;
  /** delete single row from the table: "external_reference" */
  delete_external_reference_by_pk?: Maybe<External_Reference>;
  /** delete data from the table: "farm" */
  delete_farm?: Maybe<Farm_Mutation_Response>;
  /** delete single row from the table: "farm" */
  delete_farm_by_pk?: Maybe<Farm>;
  /** delete data from the table: "farm_network" */
  delete_farm_network?: Maybe<Farm_Network_Mutation_Response>;
  /** delete single row from the table: "farm_network" */
  delete_farm_network_by_pk?: Maybe<Farm_Network>;
  /** delete data from the table: "field" */
  delete_field?: Maybe<Field_Mutation_Response>;
  /** delete single row from the table: "field" */
  delete_field_by_pk?: Maybe<Field>;
  /** delete data from the table: "field_network" */
  delete_field_network?: Maybe<Field_Network_Mutation_Response>;
  /** delete single row from the table: "field_network" */
  delete_field_network_by_pk?: Maybe<Field_Network>;
  /** delete data from the table: "field_weather_location" */
  delete_field_weather_location?: Maybe<Field_Weather_Location_Mutation_Response>;
  /** delete single row from the table: "field_weather_location" */
  delete_field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  /** delete data from the table: "grade" */
  delete_grade?: Maybe<Grade_Mutation_Response>;
  /** delete single row from the table: "grade" */
  delete_grade_by_pk?: Maybe<Grade>;
  /** delete data from the table: "grade_company" */
  delete_grade_company?: Maybe<Grade_Company_Mutation_Response>;
  /** delete single row from the table: "grade_company" */
  delete_grade_company_by_pk?: Maybe<Grade_Company>;
  /** delete data from the table: "grade_price" */
  delete_grade_price?: Maybe<Grade_Price_Mutation_Response>;
  /** delete single row from the table: "grade_price" */
  delete_grade_price_by_pk?: Maybe<Grade_Price>;
  /** delete data from the table: "guarantor_agreement" */
  delete_guarantor_agreement?: Maybe<Guarantor_Agreement_Mutation_Response>;
  /** delete data from the table: "guarantor_agreement_agreement_invoices" */
  delete_guarantor_agreement_agreement_invoices?: Maybe<Guarantor_Agreement_Agreement_Invoices_Mutation_Response>;
  /** delete single row from the table: "guarantor_agreement_agreement_invoices" */
  delete_guarantor_agreement_agreement_invoices_by_pk?: Maybe<Guarantor_Agreement_Agreement_Invoices>;
  /** delete data from the table: "guarantor_agreement_agreement_plots" */
  delete_guarantor_agreement_agreement_plots?: Maybe<Guarantor_Agreement_Agreement_Plots_Mutation_Response>;
  /** delete single row from the table: "guarantor_agreement_agreement_plots" */
  delete_guarantor_agreement_agreement_plots_by_pk?: Maybe<Guarantor_Agreement_Agreement_Plots>;
  /** delete data from the table: "guarantor_agreement_area_extension_detail" */
  delete_guarantor_agreement_area_extension_detail?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Mutation_Response>;
  /** delete single row from the table: "guarantor_agreement_area_extension_detail" */
  delete_guarantor_agreement_area_extension_detail_by_pk?: Maybe<Guarantor_Agreement_Area_Extension_Detail>;
  /** delete single row from the table: "guarantor_agreement" */
  delete_guarantor_agreement_by_pk?: Maybe<Guarantor_Agreement>;
  /** delete data from the table: "infestation" */
  delete_infestation?: Maybe<Infestation_Mutation_Response>;
  /** delete single row from the table: "infestation" */
  delete_infestation_by_pk?: Maybe<Infestation>;
  /** delete data from the table: "instrument" */
  delete_instrument?: Maybe<Instrument_Mutation_Response>;
  /** delete single row from the table: "instrument" */
  delete_instrument_by_pk?: Maybe<Instrument>;
  /** delete data from the table: "instrument_departments" */
  delete_instrument_departments?: Maybe<Instrument_Departments_Mutation_Response>;
  /** delete single row from the table: "instrument_departments" */
  delete_instrument_departments_by_pk?: Maybe<Instrument_Departments>;
  /** delete data from the table: "instrument_kind" */
  delete_instrument_kind?: Maybe<Instrument_Kind_Mutation_Response>;
  /** delete single row from the table: "instrument_kind" */
  delete_instrument_kind_by_pk?: Maybe<Instrument_Kind>;
  /** delete data from the table: "issuance_note_attachments" */
  delete_issuance_note_attachments?: Maybe<Issuance_Note_Attachments_Mutation_Response>;
  /** delete single row from the table: "issuance_note_attachments" */
  delete_issuance_note_attachments_by_pk?: Maybe<Issuance_Note_Attachments>;
  /** delete data from the table: "notification" */
  delete_kite_notification?: Maybe<Kite_Notification_Mutation_Response>;
  /** delete single row from the table: "notification" */
  delete_kite_notification_by_pk?: Maybe<Kite_Notification>;
  /** delete data from the table: "quality_stage" */
  delete_kite_quality_stage?: Maybe<Kite_Quality_Stage_Mutation_Response>;
  /** delete single row from the table: "quality_stage" */
  delete_kite_quality_stage_by_pk?: Maybe<Kite_Quality_Stage>;
  /** delete data from the table: "laboratory" */
  delete_laboratory?: Maybe<Laboratory_Mutation_Response>;
  /** delete single row from the table: "laboratory" */
  delete_laboratory_by_pk?: Maybe<Laboratory>;
  /** delete data from the table: "laboratory_organisations" */
  delete_laboratory_organisations?: Maybe<Laboratory_Organisations_Mutation_Response>;
  /** delete single row from the table: "laboratory_organisations" */
  delete_laboratory_organisations_by_pk?: Maybe<Laboratory_Organisations>;
  /** delete data from the table: "legal_agreement" */
  delete_legal_agreement?: Maybe<Legal_Agreement_Mutation_Response>;
  /** delete single row from the table: "legal_agreement" */
  delete_legal_agreement_by_pk?: Maybe<Legal_Agreement>;
  /** delete data from the table: "market" */
  delete_market?: Maybe<Market_Mutation_Response>;
  /** delete data from the table: "market_allowed_departments" */
  delete_market_allowed_departments?: Maybe<Market_Allowed_Departments_Mutation_Response>;
  /** delete single row from the table: "market_allowed_departments" */
  delete_market_allowed_departments_by_pk?: Maybe<Market_Allowed_Departments>;
  /** delete single row from the table: "market" */
  delete_market_by_pk?: Maybe<Market>;
  /** delete data from the table: "media" */
  delete_media?: Maybe<Media_Mutation_Response>;
  /** delete single row from the table: "media" */
  delete_media_by_pk?: Maybe<Media>;
  /** delete data from the table: "milestone" */
  delete_milestone?: Maybe<Milestone_Mutation_Response>;
  /** delete single row from the table: "milestone" */
  delete_milestone_by_pk?: Maybe<Milestone>;
  /** delete data from the table: "mutual_group" */
  delete_mutual_group?: Maybe<Mutual_Group_Mutation_Response>;
  /** delete single row from the table: "mutual_group" */
  delete_mutual_group_by_pk?: Maybe<Mutual_Group>;
  /** delete data from the table: "mutual_group_membership" */
  delete_mutual_group_membership?: Maybe<Mutual_Group_Membership_Mutation_Response>;
  /** delete single row from the table: "mutual_group_membership" */
  delete_mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** delete data from the table: "mutual_group_network" */
  delete_mutual_group_network?: Maybe<Mutual_Group_Network_Mutation_Response>;
  /** delete single row from the table: "mutual_group_network" */
  delete_mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** delete data from the table: "mutual_group_role" */
  delete_mutual_group_role?: Maybe<Mutual_Group_Role_Mutation_Response>;
  /** delete single row from the table: "mutual_group_role" */
  delete_mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** delete data from the table: "mutual_group_weather_station" */
  delete_mutual_group_weather_station?: Maybe<Mutual_Group_Weather_Station_Mutation_Response>;
  /** delete single row from the table: "mutual_group_weather_station" */
  delete_mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  /** delete data from the table: "nationality" */
  delete_nationality?: Maybe<Nationality_Mutation_Response>;
  /** delete single row from the table: "nationality" */
  delete_nationality_by_pk?: Maybe<Nationality>;
  /** delete data from the table: "network" */
  delete_network?: Maybe<Network_Mutation_Response>;
  /** delete single row from the table: "network" */
  delete_network_by_pk?: Maybe<Network>;
  /** delete data from the table: "nominees" */
  delete_nominees?: Maybe<Nominees_Mutation_Response>;
  /** delete single row from the table: "nominees" */
  delete_nominees_by_pk?: Maybe<Nominees>;
  /** delete data from the table: "nominees_documents" */
  delete_nominees_documents?: Maybe<Nominees_Documents_Mutation_Response>;
  /** delete single row from the table: "nominees_documents" */
  delete_nominees_documents_by_pk?: Maybe<Nominees_Documents>;
  /** delete data from the table: "notification_provider" */
  delete_notification_provider?: Maybe<Notification_Provider_Mutation_Response>;
  /** delete single row from the table: "notification_provider" */
  delete_notification_provider_by_pk?: Maybe<Notification_Provider>;
  /** delete data from the table: "notification_trigger" */
  delete_notification_trigger?: Maybe<Notification_Trigger_Mutation_Response>;
  /** delete single row from the table: "notification_trigger" */
  delete_notification_trigger_by_pk?: Maybe<Notification_Trigger>;
  /** delete data from the table: "org_dashboard_stats" */
  delete_org_dashboard_stats?: Maybe<Org_Dashboard_Stats_Mutation_Response>;
  /** delete single row from the table: "org_dashboard_stats" */
  delete_org_dashboard_stats_by_pk?: Maybe<Org_Dashboard_Stats>;
  /** delete data from the table: "org_team_association" */
  delete_org_team_association?: Maybe<Org_Team_Association_Mutation_Response>;
  /** delete single row from the table: "org_team_association" */
  delete_org_team_association_by_pk?: Maybe<Org_Team_Association>;
  /** delete data from the table: "org_team_primary_crop" */
  delete_org_team_primary_crop?: Maybe<Org_Team_Primary_Crop_Mutation_Response>;
  /** delete single row from the table: "org_team_primary_crop" */
  delete_org_team_primary_crop_by_pk?: Maybe<Org_Team_Primary_Crop>;
  /** delete data from the table: "org_team_user_bank_association" */
  delete_org_team_user_bank_association?: Maybe<Org_Team_User_Bank_Association_Mutation_Response>;
  /** delete single row from the table: "org_team_user_bank_association" */
  delete_org_team_user_bank_association_by_pk?: Maybe<Org_Team_User_Bank_Association>;
  /** delete data from the table: "org_team_user_crop" */
  delete_org_team_user_crop?: Maybe<Org_Team_User_Crop_Mutation_Response>;
  /** delete single row from the table: "org_team_user_crop" */
  delete_org_team_user_crop_by_pk?: Maybe<Org_Team_User_Crop>;
  /** delete data from the table: "org_team_user_document_association" */
  delete_org_team_user_document_association?: Maybe<Org_Team_User_Document_Association_Mutation_Response>;
  /** delete single row from the table: "org_team_user_document_association" */
  delete_org_team_user_document_association_by_pk?: Maybe<Org_Team_User_Document_Association>;
  /** delete data from the table: "org_user_association" */
  delete_org_user_association?: Maybe<Org_User_Association_Mutation_Response>;
  /** delete single row from the table: "org_user_association" */
  delete_org_user_association_by_pk?: Maybe<Org_User_Association>;
  /** delete data from the table: "org_user_group_mandatory_document" */
  delete_org_user_group_mandatory_document?: Maybe<Org_User_Group_Mandatory_Document_Mutation_Response>;
  /** delete single row from the table: "org_user_group_mandatory_document" */
  delete_org_user_group_mandatory_document_by_pk?: Maybe<Org_User_Group_Mandatory_Document>;
  /** delete data from the table: "org_user_group_status_snapshot" */
  delete_org_user_group_status_snapshot?: Maybe<Org_User_Group_Status_Snapshot_Mutation_Response>;
  /** delete single row from the table: "org_user_group_status_snapshot" */
  delete_org_user_group_status_snapshot_by_pk?: Maybe<Org_User_Group_Status_Snapshot>;
  /** delete data from the table: "org_user_primary_crop" */
  delete_org_user_primary_crop?: Maybe<Org_User_Primary_Crop_Mutation_Response>;
  /** delete single row from the table: "org_user_primary_crop" */
  delete_org_user_primary_crop_by_pk?: Maybe<Org_User_Primary_Crop>;
  /** delete data from the table: "organisation" */
  delete_organisation?: Maybe<Organisation_Mutation_Response>;
  /** delete single row from the table: "organisation" */
  delete_organisation_by_pk?: Maybe<Organisation>;
  /** delete data from the table: "organisation_commodity_variety_config" */
  delete_organisation_commodity_variety_config?: Maybe<Organisation_Commodity_Variety_Config_Mutation_Response>;
  /** delete single row from the table: "organisation_commodity_variety_config" */
  delete_organisation_commodity_variety_config_by_pk?: Maybe<Organisation_Commodity_Variety_Config>;
  /** delete data from the table: "organisation_commodity_variety_config_taxes" */
  delete_organisation_commodity_variety_config_taxes?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Mutation_Response>;
  /** delete single row from the table: "organisation_commodity_variety_config_taxes" */
  delete_organisation_commodity_variety_config_taxes_by_pk?: Maybe<Organisation_Commodity_Variety_Config_Taxes>;
  /** delete data from the table: "organisation_crop" */
  delete_organisation_crop?: Maybe<Organisation_Crop_Mutation_Response>;
  /** delete single row from the table: "organisation_crop" */
  delete_organisation_crop_by_pk?: Maybe<Organisation_Crop>;
  /** delete data from the table: "organisation_document_kind" */
  delete_organisation_document_kind?: Maybe<Organisation_Document_Kind_Mutation_Response>;
  /** delete single row from the table: "organisation_document_kind" */
  delete_organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** delete data from the table: "organisation_preferences" */
  delete_organisation_preferences?: Maybe<Organisation_Preferences_Mutation_Response>;
  /** delete single row from the table: "organisation_preferences" */
  delete_organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  /** delete data from the table: "organisation_season" */
  delete_organisation_season?: Maybe<Organisation_Season_Mutation_Response>;
  /** delete single row from the table: "organisation_season" */
  delete_organisation_season_by_pk?: Maybe<Organisation_Season>;
  /** delete data from the table: "pallet_category" */
  delete_pallet_category?: Maybe<Pallet_Category_Mutation_Response>;
  /** delete single row from the table: "pallet_category" */
  delete_pallet_category_by_pk?: Maybe<Pallet_Category>;
  /** delete data from the table: "pallet_customer" */
  delete_pallet_customer?: Maybe<Pallet_Customer_Mutation_Response>;
  /** delete single row from the table: "pallet_customer" */
  delete_pallet_customer_by_pk?: Maybe<Pallet_Customer>;
  /** delete data from the table: "pallet_inspection" */
  delete_pallet_inspection?: Maybe<Pallet_Inspection_Mutation_Response>;
  /** delete data from the table: "pallet_inspection_attachments" */
  delete_pallet_inspection_attachments?: Maybe<Pallet_Inspection_Attachments_Mutation_Response>;
  /** delete single row from the table: "pallet_inspection_attachments" */
  delete_pallet_inspection_attachments_by_pk?: Maybe<Pallet_Inspection_Attachments>;
  /** delete single row from the table: "pallet_inspection" */
  delete_pallet_inspection_by_pk?: Maybe<Pallet_Inspection>;
  /** delete data from the table: "pallet_inspection_reports" */
  delete_pallet_inspection_reports?: Maybe<Pallet_Inspection_Reports_Mutation_Response>;
  /** delete single row from the table: "pallet_inspection_reports" */
  delete_pallet_inspection_reports_by_pk?: Maybe<Pallet_Inspection_Reports>;
  /** delete data from the table: "pallet_inspectionkind" */
  delete_pallet_inspectionkind?: Maybe<Pallet_Inspectionkind_Mutation_Response>;
  /** delete single row from the table: "pallet_inspectionkind" */
  delete_pallet_inspectionkind_by_pk?: Maybe<Pallet_Inspectionkind>;
  /** delete data from the table: "pallet_inspectionobservation" */
  delete_pallet_inspectionobservation?: Maybe<Pallet_Inspectionobservation_Mutation_Response>;
  /** delete data from the table: "pallet_inspectionobservation_attachments" */
  delete_pallet_inspectionobservation_attachments?: Maybe<Pallet_Inspectionobservation_Attachments_Mutation_Response>;
  /** delete single row from the table: "pallet_inspectionobservation_attachments" */
  delete_pallet_inspectionobservation_attachments_by_pk?: Maybe<Pallet_Inspectionobservation_Attachments>;
  /** delete single row from the table: "pallet_inspectionobservation" */
  delete_pallet_inspectionobservation_by_pk?: Maybe<Pallet_Inspectionobservation>;
  /** delete data from the table: "pallet_line" */
  delete_pallet_line?: Maybe<Pallet_Line_Mutation_Response>;
  /** delete single row from the table: "pallet_line" */
  delete_pallet_line_by_pk?: Maybe<Pallet_Line>;
  /** delete data from the table: "pallet_location" */
  delete_pallet_location?: Maybe<Pallet_Location_Mutation_Response>;
  /** delete single row from the table: "pallet_location" */
  delete_pallet_location_by_pk?: Maybe<Pallet_Location>;
  /** delete data from the table: "pallet_packaging" */
  delete_pallet_packaging?: Maybe<Pallet_Packaging_Mutation_Response>;
  /** delete single row from the table: "pallet_packaging" */
  delete_pallet_packaging_by_pk?: Maybe<Pallet_Packaging>;
  /** delete data from the table: "pallet_packagingkind" */
  delete_pallet_packagingkind?: Maybe<Pallet_Packagingkind_Mutation_Response>;
  /** delete single row from the table: "pallet_packagingkind" */
  delete_pallet_packagingkind_by_pk?: Maybe<Pallet_Packagingkind>;
  /** delete data from the table: "pallet_packing" */
  delete_pallet_packing?: Maybe<Pallet_Packing_Mutation_Response>;
  /** delete data from the table: "pallet_packing_attachments" */
  delete_pallet_packing_attachments?: Maybe<Pallet_Packing_Attachments_Mutation_Response>;
  /** delete single row from the table: "pallet_packing_attachments" */
  delete_pallet_packing_attachments_by_pk?: Maybe<Pallet_Packing_Attachments>;
  /** delete single row from the table: "pallet_packing" */
  delete_pallet_packing_by_pk?: Maybe<Pallet_Packing>;
  /** delete data from the table: "pallet_packing_weights" */
  delete_pallet_packing_weights?: Maybe<Pallet_Packing_Weights_Mutation_Response>;
  /** delete single row from the table: "pallet_packing_weights" */
  delete_pallet_packing_weights_by_pk?: Maybe<Pallet_Packing_Weights>;
  /** delete data from the table: "pallet_packingkind" */
  delete_pallet_packingkind?: Maybe<Pallet_Packingkind_Mutation_Response>;
  /** delete single row from the table: "pallet_packingkind" */
  delete_pallet_packingkind_by_pk?: Maybe<Pallet_Packingkind>;
  /** delete data from the table: "pallet_packingweight" */
  delete_pallet_packingweight?: Maybe<Pallet_Packingweight_Mutation_Response>;
  /** delete data from the table: "pallet_packingweight_attachments" */
  delete_pallet_packingweight_attachments?: Maybe<Pallet_Packingweight_Attachments_Mutation_Response>;
  /** delete single row from the table: "pallet_packingweight_attachments" */
  delete_pallet_packingweight_attachments_by_pk?: Maybe<Pallet_Packingweight_Attachments>;
  /** delete single row from the table: "pallet_packingweight" */
  delete_pallet_packingweight_by_pk?: Maybe<Pallet_Packingweight>;
  /** delete data from the table: "pallet_printingmatter" */
  delete_pallet_printingmatter?: Maybe<Pallet_Printingmatter_Mutation_Response>;
  /** delete single row from the table: "pallet_printingmatter" */
  delete_pallet_printingmatter_by_pk?: Maybe<Pallet_Printingmatter>;
  /** delete data from the table: "pallet_punnetcondition" */
  delete_pallet_punnetcondition?: Maybe<Pallet_Punnetcondition_Mutation_Response>;
  /** delete single row from the table: "pallet_punnetcondition" */
  delete_pallet_punnetcondition_by_pk?: Maybe<Pallet_Punnetcondition>;
  /** delete data from the table: "pallet_samplinglocation" */
  delete_pallet_samplinglocation?: Maybe<Pallet_Samplinglocation_Mutation_Response>;
  /** delete single row from the table: "pallet_samplinglocation" */
  delete_pallet_samplinglocation_by_pk?: Maybe<Pallet_Samplinglocation>;
  /** delete data from the table: "pallet_sku" */
  delete_pallet_sku?: Maybe<Pallet_Sku_Mutation_Response>;
  /** delete single row from the table: "pallet_sku" */
  delete_pallet_sku_by_pk?: Maybe<Pallet_Sku>;
  /** delete data from the table: "pallet_skutype" */
  delete_pallet_skutype?: Maybe<Pallet_Skutype_Mutation_Response>;
  /** delete single row from the table: "pallet_skutype" */
  delete_pallet_skutype_by_pk?: Maybe<Pallet_Skutype>;
  /** delete data from the table: "pallet_variety" */
  delete_pallet_variety?: Maybe<Pallet_Variety_Mutation_Response>;
  /** delete single row from the table: "pallet_variety" */
  delete_pallet_variety_by_pk?: Maybe<Pallet_Variety>;
  /** delete data from the table: "payment_detail" */
  delete_payment_detail?: Maybe<Payment_Detail_Mutation_Response>;
  /** delete data from the table: "payment_detail_attachments" */
  delete_payment_detail_attachments?: Maybe<Payment_Detail_Attachments_Mutation_Response>;
  /** delete single row from the table: "payment_detail_attachments" */
  delete_payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** delete single row from the table: "payment_detail" */
  delete_payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** delete data from the table: "payment_method" */
  delete_payment_method?: Maybe<Payment_Method_Mutation_Response>;
  /** delete single row from the table: "payment_method" */
  delete_payment_method_by_pk?: Maybe<Payment_Method>;
  /** delete data from the table: "plot" */
  delete_plot?: Maybe<Plot_Mutation_Response>;
  /** delete single row from the table: "plot" */
  delete_plot_by_pk?: Maybe<Plot>;
  /** delete data from the table: "plot_crop" */
  delete_plot_crop?: Maybe<Plot_Crop_Mutation_Response>;
  /** delete data from the table: "plot_crop_agent" */
  delete_plot_crop_agent?: Maybe<Plot_Crop_Agent_Mutation_Response>;
  /** delete single row from the table: "plot_crop_agent" */
  delete_plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** delete single row from the table: "plot_crop" */
  delete_plot_crop_by_pk?: Maybe<Plot_Crop>;
  /** delete data from the table: "plot_crop_cultivation_type" */
  delete_plot_crop_cultivation_type?: Maybe<Plot_Crop_Cultivation_Type_Mutation_Response>;
  /** delete single row from the table: "plot_crop_cultivation_type" */
  delete_plot_crop_cultivation_type_by_pk?: Maybe<Plot_Crop_Cultivation_Type>;
  /** delete data from the table: "plot_crop_historic_season" */
  delete_plot_crop_historic_season?: Maybe<Plot_Crop_Historic_Season_Mutation_Response>;
  /** delete single row from the table: "plot_crop_historic_season" */
  delete_plot_crop_historic_season_by_pk?: Maybe<Plot_Crop_Historic_Season>;
  /** delete data from the table: "plot_crop_milestone" */
  delete_plot_crop_milestone?: Maybe<Plot_Crop_Milestone_Mutation_Response>;
  /** delete single row from the table: "plot_crop_milestone" */
  delete_plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** delete data from the table: "plot_crop_network" */
  delete_plot_crop_network?: Maybe<Plot_Crop_Network_Mutation_Response>;
  /** delete single row from the table: "plot_crop_network" */
  delete_plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  /** delete data from the table: "plot_crop_rootstock" */
  delete_plot_crop_rootstock?: Maybe<Plot_Crop_Rootstock_Mutation_Response>;
  /** delete single row from the table: "plot_crop_rootstock" */
  delete_plot_crop_rootstock_by_pk?: Maybe<Plot_Crop_Rootstock>;
  /** delete data from the table: "plot_crop_status_history" */
  delete_plot_crop_status_history?: Maybe<Plot_Crop_Status_History_Mutation_Response>;
  /** delete single row from the table: "plot_crop_status_history" */
  delete_plot_crop_status_history_by_pk?: Maybe<Plot_Crop_Status_History>;
  /** delete data from the table: "plot_network" */
  delete_plot_network?: Maybe<Plot_Network_Mutation_Response>;
  /** delete single row from the table: "plot_network" */
  delete_plot_network_by_pk?: Maybe<Plot_Network>;
  /** delete data from the table: "plot_status" */
  delete_plot_status?: Maybe<Plot_Status_Mutation_Response>;
  /** delete single row from the table: "plot_status" */
  delete_plot_status_by_pk?: Maybe<Plot_Status>;
  /** delete data from the table: "plot_status_config" */
  delete_plot_status_config?: Maybe<Plot_Status_Config_Mutation_Response>;
  /** delete single row from the table: "plot_status_config" */
  delete_plot_status_config_by_pk?: Maybe<Plot_Status_Config>;
  /** delete data from the table: "plot_status_config_required_qc_stages" */
  delete_plot_status_config_required_qc_stages?: Maybe<Plot_Status_Config_Required_Qc_Stages_Mutation_Response>;
  /** delete single row from the table: "plot_status_config_required_qc_stages" */
  delete_plot_status_config_required_qc_stages_by_pk?: Maybe<Plot_Status_Config_Required_Qc_Stages>;
  /** delete data from the table: "primary_growth_stage" */
  delete_primary_growth_stage?: Maybe<Primary_Growth_Stage_Mutation_Response>;
  /** delete single row from the table: "primary_growth_stage" */
  delete_primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  /** delete data from the table: "quality_parameter" */
  delete_quality_parameter?: Maybe<Quality_Parameter_Mutation_Response>;
  /** delete single row from the table: "quality_parameter" */
  delete_quality_parameter_by_pk?: Maybe<Quality_Parameter>;
  /** delete data from the table: "quality_parameter_category" */
  delete_quality_parameter_category?: Maybe<Quality_Parameter_Category_Mutation_Response>;
  /** delete single row from the table: "quality_parameter_category" */
  delete_quality_parameter_category_by_pk?: Maybe<Quality_Parameter_Category>;
  /** delete data from the table: "quality_stage" */
  delete_quality_stage?: Maybe<Quality_Stage_Mutation_Response>;
  /** delete data from the table: "quality_stage_allowed_template_category" */
  delete_quality_stage_allowed_template_category?: Maybe<Quality_Stage_Allowed_Template_Category_Mutation_Response>;
  /** delete single row from the table: "quality_stage_allowed_template_category" */
  delete_quality_stage_allowed_template_category_by_pk?: Maybe<Quality_Stage_Allowed_Template_Category>;
  /** delete single row from the table: "quality_stage" */
  delete_quality_stage_by_pk?: Maybe<Quality_Stage>;
  /** delete data from the table: "region" */
  delete_region?: Maybe<Region_Mutation_Response>;
  /** delete single row from the table: "region" */
  delete_region_by_pk?: Maybe<Region>;
  /** delete data from the table: "region_group" */
  delete_region_group?: Maybe<Region_Group_Mutation_Response>;
  /** delete single row from the table: "region_group" */
  delete_region_group_by_pk?: Maybe<Region_Group>;
  /** delete data from the table: "request" */
  delete_request?: Maybe<Request_Mutation_Response>;
  /** delete single row from the table: "request" */
  delete_request_by_pk?: Maybe<Request>;
  /** delete data from the table: "request_category" */
  delete_request_category?: Maybe<Request_Category_Mutation_Response>;
  /** delete single row from the table: "request_category" */
  delete_request_category_by_pk?: Maybe<Request_Category>;
  /** delete data from the table: "request_parameters" */
  delete_request_parameters?: Maybe<Request_Parameters_Mutation_Response>;
  /** delete single row from the table: "request_parameters" */
  delete_request_parameters_by_pk?: Maybe<Request_Parameters>;
  /** delete data from the table: "request_secondary_locations" */
  delete_request_secondary_locations?: Maybe<Request_Secondary_Locations_Mutation_Response>;
  /** delete single row from the table: "request_secondary_locations" */
  delete_request_secondary_locations_by_pk?: Maybe<Request_Secondary_Locations>;
  /** delete data from the table: "request_templates" */
  delete_request_templates?: Maybe<Request_Templates_Mutation_Response>;
  /** delete single row from the table: "request_templates" */
  delete_request_templates_by_pk?: Maybe<Request_Templates>;
  /** delete data from the table: "result" */
  delete_result?: Maybe<Result_Mutation_Response>;
  /** delete single row from the table: "result" */
  delete_result_by_pk?: Maybe<Result>;
  /** delete data from the table: "result_comment" */
  delete_result_comment?: Maybe<Result_Comment_Mutation_Response>;
  /** delete single row from the table: "result_comment" */
  delete_result_comment_by_pk?: Maybe<Result_Comment>;
  /** delete data from the table: "result_evaluation" */
  delete_result_evaluation?: Maybe<Result_Evaluation_Mutation_Response>;
  /** delete single row from the table: "result_evaluation" */
  delete_result_evaluation_by_pk?: Maybe<Result_Evaluation>;
  /** delete data from the table: "result_evaluation_evaluated_tags" */
  delete_result_evaluation_evaluated_tags?: Maybe<Result_Evaluation_Evaluated_Tags_Mutation_Response>;
  /** delete single row from the table: "result_evaluation_evaluated_tags" */
  delete_result_evaluation_evaluated_tags_by_pk?: Maybe<Result_Evaluation_Evaluated_Tags>;
  /** delete data from the table: "result_media" */
  delete_result_media?: Maybe<Result_Media_Mutation_Response>;
  /** delete single row from the table: "result_media" */
  delete_result_media_by_pk?: Maybe<Result_Media>;
  /** delete data from the table: "result_observation" */
  delete_result_observation?: Maybe<Result_Observation_Mutation_Response>;
  /** delete data from the table: "result_observation_attachments" */
  delete_result_observation_attachments?: Maybe<Result_Observation_Attachments_Mutation_Response>;
  /** delete single row from the table: "result_observation_attachments" */
  delete_result_observation_attachments_by_pk?: Maybe<Result_Observation_Attachments>;
  /** delete single row from the table: "result_observation" */
  delete_result_observation_by_pk?: Maybe<Result_Observation>;
  /** delete data from the table: "result_observation_evaluated_tags" */
  delete_result_observation_evaluated_tags?: Maybe<Result_Observation_Evaluated_Tags_Mutation_Response>;
  /** delete single row from the table: "result_observation_evaluated_tags" */
  delete_result_observation_evaluated_tags_by_pk?: Maybe<Result_Observation_Evaluated_Tags>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "rootstock" */
  delete_rootstock?: Maybe<Rootstock_Mutation_Response>;
  /** delete single row from the table: "rootstock" */
  delete_rootstock_by_pk?: Maybe<Rootstock>;
  /** delete data from the table: "sample" */
  delete_sample?: Maybe<Sample_Mutation_Response>;
  /** delete single row from the table: "sample" */
  delete_sample_by_pk?: Maybe<Sample>;
  /** delete data from the table: "sample_media" */
  delete_sample_media?: Maybe<Sample_Media_Mutation_Response>;
  /** delete single row from the table: "sample_media" */
  delete_sample_media_by_pk?: Maybe<Sample_Media>;
  /** delete data from the table: "sample_observation" */
  delete_sample_observation?: Maybe<Sample_Observation_Mutation_Response>;
  /** delete data from the table: "sample_observation_attachments" */
  delete_sample_observation_attachments?: Maybe<Sample_Observation_Attachments_Mutation_Response>;
  /** delete single row from the table: "sample_observation_attachments" */
  delete_sample_observation_attachments_by_pk?: Maybe<Sample_Observation_Attachments>;
  /** delete single row from the table: "sample_observation" */
  delete_sample_observation_by_pk?: Maybe<Sample_Observation>;
  /** delete data from the table: "secondary_growth_stage" */
  delete_secondary_growth_stage?: Maybe<Secondary_Growth_Stage_Mutation_Response>;
  /** delete single row from the table: "secondary_growth_stage" */
  delete_secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  /** delete data from the table: "shareholder_applications" */
  delete_shareholder_applications?: Maybe<Shareholder_Applications_Mutation_Response>;
  /** delete single row from the table: "shareholder_applications" */
  delete_shareholder_applications_by_pk?: Maybe<Shareholder_Applications>;
  /** delete data from the table: "shareholders" */
  delete_shareholders?: Maybe<Shareholders_Mutation_Response>;
  /** delete single row from the table: "shareholders" */
  delete_shareholders_by_pk?: Maybe<Shareholders>;
  /** delete data from the table: "si_unit" */
  delete_si_unit?: Maybe<Si_Unit_Mutation_Response>;
  /** delete single row from the table: "si_unit" */
  delete_si_unit_by_pk?: Maybe<Si_Unit>;
  /** delete data from the table: "si_unit_measure" */
  delete_si_unit_measure?: Maybe<Si_Unit_Measure_Mutation_Response>;
  /** delete single row from the table: "si_unit_measure" */
  delete_si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  /** delete data from the table: "sku" */
  delete_sku?: Maybe<Sku_Mutation_Response>;
  /** delete single row from the table: "sku" */
  delete_sku_by_pk?: Maybe<Sku>;
  /** delete data from the table: "sku_kind" */
  delete_sku_kind?: Maybe<Sku_Kind_Mutation_Response>;
  /** delete single row from the table: "sku_kind" */
  delete_sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** delete data from the table: "soil" */
  delete_soil?: Maybe<Soil_Mutation_Response>;
  /** delete single row from the table: "soil" */
  delete_soil_by_pk?: Maybe<Soil>;
  /** delete data from the table: "stage_actions" */
  delete_stage_actions?: Maybe<Stage_Actions_Mutation_Response>;
  /** delete single row from the table: "stage_actions" */
  delete_stage_actions_by_pk?: Maybe<Stage_Actions>;
  /** delete data from the table: "stage_logs" */
  delete_stage_logs?: Maybe<Stage_Logs_Mutation_Response>;
  /** delete single row from the table: "stage_logs" */
  delete_stage_logs_by_pk?: Maybe<Stage_Logs>;
  /** delete data from the table: "stages" */
  delete_stages?: Maybe<Stages_Mutation_Response>;
  /** delete single row from the table: "stages" */
  delete_stages_by_pk?: Maybe<Stages>;
  /** delete data from the table: "stages_subscribers" */
  delete_stages_subscribers?: Maybe<Stages_Subscribers_Mutation_Response>;
  /** delete single row from the table: "stages_subscribers" */
  delete_stages_subscribers_by_pk?: Maybe<Stages_Subscribers>;
  /** delete data from the table: "state" */
  delete_state?: Maybe<State_Mutation_Response>;
  /** delete single row from the table: "state" */
  delete_state_by_pk?: Maybe<State>;
  /** delete data from the table: "survey_parameters" */
  delete_survey_parameters?: Maybe<Survey_Parameters_Mutation_Response>;
  /** delete single row from the table: "survey_parameters" */
  delete_survey_parameters_by_pk?: Maybe<Survey_Parameters>;
  /** delete data from the table: "survey_response_items" */
  delete_survey_response_items?: Maybe<Survey_Response_Items_Mutation_Response>;
  /** delete single row from the table: "survey_response_items" */
  delete_survey_response_items_by_pk?: Maybe<Survey_Response_Items>;
  /** delete data from the table: "survey_responses" */
  delete_survey_responses?: Maybe<Survey_Responses_Mutation_Response>;
  /** delete single row from the table: "survey_responses" */
  delete_survey_responses_by_pk?: Maybe<Survey_Responses>;
  /** delete data from the table: "survey_users" */
  delete_survey_users?: Maybe<Survey_Users_Mutation_Response>;
  /** delete single row from the table: "survey_users" */
  delete_survey_users_by_pk?: Maybe<Survey_Users>;
  /** delete data from the table: "survey_year" */
  delete_survey_year?: Maybe<Survey_Year_Mutation_Response>;
  /** delete single row from the table: "survey_year" */
  delete_survey_year_by_pk?: Maybe<Survey_Year>;
  /** delete data from the table: "surveys" */
  delete_surveys?: Maybe<Surveys_Mutation_Response>;
  /** delete single row from the table: "surveys" */
  delete_surveys_by_pk?: Maybe<Surveys>;
  /** delete data from the table: "template" */
  delete_template?: Maybe<Template_Mutation_Response>;
  /** delete single row from the table: "template" */
  delete_template_by_pk?: Maybe<Template>;
  /** delete data from the table: "template_category" */
  delete_template_category?: Maybe<Template_Category_Mutation_Response>;
  /** delete data from the table: "template_category_allowed_groups" */
  delete_template_category_allowed_groups?: Maybe<Template_Category_Allowed_Groups_Mutation_Response>;
  /** delete single row from the table: "template_category_allowed_groups" */
  delete_template_category_allowed_groups_by_pk?: Maybe<Template_Category_Allowed_Groups>;
  /** delete data from the table: "template_category_allowed_parameter_categories" */
  delete_template_category_allowed_parameter_categories?: Maybe<Template_Category_Allowed_Parameter_Categories_Mutation_Response>;
  /** delete single row from the table: "template_category_allowed_parameter_categories" */
  delete_template_category_allowed_parameter_categories_by_pk?: Maybe<Template_Category_Allowed_Parameter_Categories>;
  /** delete single row from the table: "template_category" */
  delete_template_category_by_pk?: Maybe<Template_Category>;
  /** delete data from the table: "template_company" */
  delete_template_company?: Maybe<Template_Company_Mutation_Response>;
  /** delete single row from the table: "template_company" */
  delete_template_company_by_pk?: Maybe<Template_Company>;
  /** delete data from the table: "template_departments" */
  delete_template_departments?: Maybe<Template_Departments_Mutation_Response>;
  /** delete single row from the table: "template_departments" */
  delete_template_departments_by_pk?: Maybe<Template_Departments>;
  /** delete data from the table: "template_evaluation" */
  delete_template_evaluation?: Maybe<Template_Evaluation_Mutation_Response>;
  /** delete single row from the table: "template_evaluation" */
  delete_template_evaluation_by_pk?: Maybe<Template_Evaluation>;
  /** delete data from the table: "template_evaluation_config" */
  delete_template_evaluation_config?: Maybe<Template_Evaluation_Config_Mutation_Response>;
  /** delete single row from the table: "template_evaluation_config" */
  delete_template_evaluation_config_by_pk?: Maybe<Template_Evaluation_Config>;
  /** delete data from the table: "template_evaluation_templates" */
  delete_template_evaluation_templates?: Maybe<Template_Evaluation_Templates_Mutation_Response>;
  /** delete single row from the table: "template_evaluation_templates" */
  delete_template_evaluation_templates_by_pk?: Maybe<Template_Evaluation_Templates>;
  /** delete data from the table: "template_parameter" */
  delete_template_parameter?: Maybe<Template_Parameter_Mutation_Response>;
  /** delete single row from the table: "template_parameter" */
  delete_template_parameter_by_pk?: Maybe<Template_Parameter>;
  /** delete data from the table: "template_parameter_config" */
  delete_template_parameter_config?: Maybe<Template_Parameter_Config_Mutation_Response>;
  /** delete single row from the table: "template_parameter_config" */
  delete_template_parameter_config_by_pk?: Maybe<Template_Parameter_Config>;
  /** delete data from the table: "template_parameter_standard" */
  delete_template_parameter_standard?: Maybe<Template_Parameter_Standard_Mutation_Response>;
  /** delete data from the table: "template_parameter_standard_attachments" */
  delete_template_parameter_standard_attachments?: Maybe<Template_Parameter_Standard_Attachments_Mutation_Response>;
  /** delete single row from the table: "template_parameter_standard_attachments" */
  delete_template_parameter_standard_attachments_by_pk?: Maybe<Template_Parameter_Standard_Attachments>;
  /** delete single row from the table: "template_parameter_standard" */
  delete_template_parameter_standard_by_pk?: Maybe<Template_Parameter_Standard>;
  /** delete data from the table: "template_parameter_standard_group" */
  delete_template_parameter_standard_group?: Maybe<Template_Parameter_Standard_Group_Mutation_Response>;
  /** delete single row from the table: "template_parameter_standard_group" */
  delete_template_parameter_standard_group_by_pk?: Maybe<Template_Parameter_Standard_Group>;
  /** delete data from the table: "template_quality_stages" */
  delete_template_quality_stages?: Maybe<Template_Quality_Stages_Mutation_Response>;
  /** delete single row from the table: "template_quality_stages" */
  delete_template_quality_stages_by_pk?: Maybe<Template_Quality_Stages>;
  /** delete data from the table: "trade_attachments" */
  delete_trade_attachments?: Maybe<Trade_Attachments_Mutation_Response>;
  /** delete single row from the table: "trade_attachments" */
  delete_trade_attachments_by_pk?: Maybe<Trade_Attachments>;
  /** delete data from the table: "trade_buyer_gst_attachments" */
  delete_trade_buyer_gst_attachments?: Maybe<Trade_Buyer_Gst_Attachments_Mutation_Response>;
  /** delete single row from the table: "trade_buyer_gst_attachments" */
  delete_trade_buyer_gst_attachments_by_pk?: Maybe<Trade_Buyer_Gst_Attachments>;
  /** delete data from the table: "trade_seller_gst_attachments" */
  delete_trade_seller_gst_attachments?: Maybe<Trade_Seller_Gst_Attachments_Mutation_Response>;
  /** delete single row from the table: "trade_seller_gst_attachments" */
  delete_trade_seller_gst_attachments_by_pk?: Maybe<Trade_Seller_Gst_Attachments>;
  /** delete data from the table: "transactions" */
  delete_transactions?: Maybe<Transactions_Mutation_Response>;
  /** delete data from the table: "transactions_attachments" */
  delete_transactions_attachments?: Maybe<Transactions_Attachments_Mutation_Response>;
  /** delete single row from the table: "transactions_attachments" */
  delete_transactions_attachments_by_pk?: Maybe<Transactions_Attachments>;
  /** delete single row from the table: "transactions" */
  delete_transactions_by_pk?: Maybe<Transactions>;
  /** delete data from the table: "transition" */
  delete_transition?: Maybe<Transition_Mutation_Response>;
  /** delete data from the table: "transition_access" */
  delete_transition_access?: Maybe<Transition_Access_Mutation_Response>;
  /** delete single row from the table: "transition_access" */
  delete_transition_access_by_pk?: Maybe<Transition_Access>;
  /** delete single row from the table: "transition" */
  delete_transition_by_pk?: Maybe<Transition>;
  /** delete data from the table: "transition_history" */
  delete_transition_history?: Maybe<Transition_History_Mutation_Response>;
  /** delete data from the table: "transition_history_attribute" */
  delete_transition_history_attribute?: Maybe<Transition_History_Attribute_Mutation_Response>;
  /** delete single row from the table: "transition_history_attribute" */
  delete_transition_history_attribute_by_pk?: Maybe<Transition_History_Attribute>;
  /** delete single row from the table: "transition_history" */
  delete_transition_history_by_pk?: Maybe<Transition_History>;
  /** delete data from the table: "unit" */
  delete_unit?: Maybe<Unit_Mutation_Response>;
  /** delete single row from the table: "unit" */
  delete_unit_by_pk?: Maybe<Unit>;
  /** delete data from the table: "unit_measure" */
  delete_unit_measure?: Maybe<Unit_Measure_Mutation_Response>;
  /** delete single row from the table: "unit_measure" */
  delete_unit_measure_by_pk?: Maybe<Unit_Measure>;
  /** delete data from the table: "variety_agreement" */
  delete_variety_agreement?: Maybe<Variety_Agreement_Mutation_Response>;
  /** delete data from the table: "variety_agreement_agreement_co_owners" */
  delete_variety_agreement_agreement_co_owners?: Maybe<Variety_Agreement_Agreement_Co_Owners_Mutation_Response>;
  /** delete single row from the table: "variety_agreement_agreement_co_owners" */
  delete_variety_agreement_agreement_co_owners_by_pk?: Maybe<Variety_Agreement_Agreement_Co_Owners>;
  /** delete single row from the table: "variety_agreement" */
  delete_variety_agreement_by_pk?: Maybe<Variety_Agreement>;
  /** delete data from the table: "variety_agreement_guarantor_agreements" */
  delete_variety_agreement_guarantor_agreements?: Maybe<Variety_Agreement_Guarantor_Agreements_Mutation_Response>;
  /** delete single row from the table: "variety_agreement_guarantor_agreements" */
  delete_variety_agreement_guarantor_agreements_by_pk?: Maybe<Variety_Agreement_Guarantor_Agreements>;
  /** delete data from the table: "variety_grade" */
  delete_variety_grade?: Maybe<Variety_Grade_Mutation_Response>;
  /** delete single row from the table: "variety_grade" */
  delete_variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** delete data from the table: "variety_grade_photos" */
  delete_variety_grade_photos?: Maybe<Variety_Grade_Photos_Mutation_Response>;
  /** delete single row from the table: "variety_grade_photos" */
  delete_variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** delete data from the table: "variety_group" */
  delete_variety_group?: Maybe<Variety_Group_Mutation_Response>;
  /** delete single row from the table: "variety_group" */
  delete_variety_group_by_pk?: Maybe<Variety_Group>;
  /** delete data from the table: "vt_core_tax" */
  delete_vt_core_tax?: Maybe<Vt_Core_Tax_Mutation_Response>;
  /** delete single row from the table: "vt_core_tax" */
  delete_vt_core_tax_by_pk?: Maybe<Vt_Core_Tax>;
  /** delete data from the table: "weather_reference" */
  delete_weather_reference?: Maybe<Weather_Reference_Mutation_Response>;
  /** delete single row from the table: "weather_reference" */
  delete_weather_reference_by_pk?: Maybe<Weather_Reference>;
  /** delete data from the table: "workflow" */
  delete_workflow?: Maybe<Workflow_Mutation_Response>;
  /** delete single row from the table: "workflow" */
  delete_workflow_by_pk?: Maybe<Workflow>;
  /** delete data from the table: "workflow_current_logs" */
  delete_workflow_current_logs?: Maybe<Workflow_Current_Logs_Mutation_Response>;
  /** delete single row from the table: "workflow_current_logs" */
  delete_workflow_current_logs_by_pk?: Maybe<Workflow_Current_Logs>;
  /** delete data from the table: "workflows" */
  delete_workflows?: Maybe<Workflows_Mutation_Response>;
  /** delete single row from the table: "workflows" */
  delete_workflows_by_pk?: Maybe<Workflows>;
  dump_trades?: Maybe<DumpTradesMutation>;
  employee_onboard?: Maybe<EmployeeOnboardMutation>;
  export_report?: Maybe<ExportReportMutation>;
  generate_agent_token?: Maybe<GenerateAgentToken>;
  generate_base_user_token?: Maybe<GenerateBaseUserToken>;
  generate_evaluations?: Maybe<GenerateEvaluations>;
  generate_generic_token?: Maybe<GenerateGenericToken>;
  generate_initial_pallet_request?: Maybe<GenerateInitialPalletRequest>;
  generate_invoices?: Maybe<GenerateInvoiceMutation>;
  generate_otp?: Maybe<GenerateOtp>;
  generate_results?: Maybe<GenerateResults>;
  generate_trade_otp?: Maybe<GenerateTradeOtp>;
  /** insert data into the table: "action_log" */
  insert_action_log?: Maybe<Action_Log_Mutation_Response>;
  /** insert a single row into the table: "action_log" */
  insert_action_log_one?: Maybe<Action_Log>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "advance_payment" */
  insert_advance_payment?: Maybe<Advance_Payment_Mutation_Response>;
  /** insert a single row into the table: "advance_payment" */
  insert_advance_payment_one?: Maybe<Advance_Payment>;
  /** insert data into the table: "agent" */
  insert_agent?: Maybe<Agent_Mutation_Response>;
  /** insert data into the table: "agent_company" */
  insert_agent_company?: Maybe<Agent_Company_Mutation_Response>;
  /** insert a single row into the table: "agent_company" */
  insert_agent_company_one?: Maybe<Agent_Company>;
  /** insert a single row into the table: "agent" */
  insert_agent_one?: Maybe<Agent>;
  /** insert data into the table: "agent_role" */
  insert_agent_role?: Maybe<Agent_Role_Mutation_Response>;
  /** insert a single row into the table: "agent_role" */
  insert_agent_role_one?: Maybe<Agent_Role>;
  /** insert data into the table: "agreement_co_owner" */
  insert_agreement_co_owner?: Maybe<Agreement_Co_Owner_Mutation_Response>;
  /** insert data into the table: "agreement_co_owner_agreement_invoices" */
  insert_agreement_co_owner_agreement_invoices?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Mutation_Response>;
  /** insert a single row into the table: "agreement_co_owner_agreement_invoices" */
  insert_agreement_co_owner_agreement_invoices_one?: Maybe<Agreement_Co_Owner_Agreement_Invoices>;
  /** insert data into the table: "agreement_co_owner_agreement_plots" */
  insert_agreement_co_owner_agreement_plots?: Maybe<Agreement_Co_Owner_Agreement_Plots_Mutation_Response>;
  /** insert a single row into the table: "agreement_co_owner_agreement_plots" */
  insert_agreement_co_owner_agreement_plots_one?: Maybe<Agreement_Co_Owner_Agreement_Plots>;
  /** insert data into the table: "agreement_co_owner_legal_agreement" */
  insert_agreement_co_owner_legal_agreement?: Maybe<Agreement_Co_Owner_Legal_Agreement_Mutation_Response>;
  /** insert a single row into the table: "agreement_co_owner_legal_agreement" */
  insert_agreement_co_owner_legal_agreement_one?: Maybe<Agreement_Co_Owner_Legal_Agreement>;
  /** insert a single row into the table: "agreement_co_owner" */
  insert_agreement_co_owner_one?: Maybe<Agreement_Co_Owner>;
  /** insert data into the table: "agreement_invoice" */
  insert_agreement_invoice?: Maybe<Agreement_Invoice_Mutation_Response>;
  /** insert data into the table: "agreement_invoice_agreement_invoice_items" */
  insert_agreement_invoice_agreement_invoice_items?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Mutation_Response>;
  /** insert a single row into the table: "agreement_invoice_agreement_invoice_items" */
  insert_agreement_invoice_agreement_invoice_items_one?: Maybe<Agreement_Invoice_Agreement_Invoice_Items>;
  /** insert data into the table: "agreement_invoice_item" */
  insert_agreement_invoice_item?: Maybe<Agreement_Invoice_Item_Mutation_Response>;
  /** insert a single row into the table: "agreement_invoice_item" */
  insert_agreement_invoice_item_one?: Maybe<Agreement_Invoice_Item>;
  /** insert a single row into the table: "agreement_invoice" */
  insert_agreement_invoice_one?: Maybe<Agreement_Invoice>;
  /** insert data into the table: "agreement_invoice_transaction" */
  insert_agreement_invoice_transaction?: Maybe<Agreement_Invoice_Transaction_Mutation_Response>;
  /** insert a single row into the table: "agreement_invoice_transaction" */
  insert_agreement_invoice_transaction_one?: Maybe<Agreement_Invoice_Transaction>;
  /** insert data into the table: "agreement_plot" */
  insert_agreement_plot?: Maybe<Agreement_Plot_Mutation_Response>;
  /** insert a single row into the table: "agreement_plot" */
  insert_agreement_plot_one?: Maybe<Agreement_Plot>;
  /** insert data into the table: "amendment_case" */
  insert_amendment_case?: Maybe<Amendment_Case_Mutation_Response>;
  /** insert a single row into the table: "amendment_case" */
  insert_amendment_case_one?: Maybe<Amendment_Case>;
  /** insert data into the table: "auth_group" */
  insert_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** insert a single row into the table: "auth_group" */
  insert_auth_group_one?: Maybe<Auth_Group>;
  /** insert data into the table: "auth_group_permissions" */
  insert_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** insert a single row into the table: "auth_group_permissions" */
  insert_auth_group_permissions_one?: Maybe<Auth_Group_Permissions>;
  /** insert data into the table: "auth_permission" */
  insert_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** insert a single row into the table: "auth_permission" */
  insert_auth_permission_one?: Maybe<Auth_Permission>;
  /** insert data into the table: "base_user" */
  insert_base_user?: Maybe<Base_User_Mutation_Response>;
  /** insert data into the table: "base_user_address_book" */
  insert_base_user_address_book?: Maybe<Base_User_Address_Book_Mutation_Response>;
  /** insert a single row into the table: "base_user_address_book" */
  insert_base_user_address_book_one?: Maybe<Base_User_Address_Book>;
  /** insert data into the table: "base_user_companies" */
  insert_base_user_companies?: Maybe<Base_User_Companies_Mutation_Response>;
  /** insert a single row into the table: "base_user_companies" */
  insert_base_user_companies_one?: Maybe<Base_User_Companies>;
  /** insert data into the table: "base_user_departments" */
  insert_base_user_departments?: Maybe<Base_User_Departments_Mutation_Response>;
  /** insert a single row into the table: "base_user_departments" */
  insert_base_user_departments_one?: Maybe<Base_User_Departments>;
  /** insert data into the table: "base_user_groups" */
  insert_base_user_groups?: Maybe<Base_User_Groups_Mutation_Response>;
  /** insert a single row into the table: "base_user_groups" */
  insert_base_user_groups_one?: Maybe<Base_User_Groups>;
  /** insert data into the table: "base_user_network" */
  insert_base_user_network?: Maybe<Base_User_Network_Mutation_Response>;
  /** insert a single row into the table: "base_user_network" */
  insert_base_user_network_one?: Maybe<Base_User_Network>;
  /** insert a single row into the table: "base_user" */
  insert_base_user_one?: Maybe<Base_User>;
  /** insert data into the table: "base_user_user_permissions" */
  insert_base_user_user_permissions?: Maybe<Base_User_User_Permissions_Mutation_Response>;
  /** insert a single row into the table: "base_user_user_permissions" */
  insert_base_user_user_permissions_one?: Maybe<Base_User_User_Permissions>;
  /** insert data into the table: "brand" */
  insert_brand?: Maybe<Brand_Mutation_Response>;
  /** insert data into the table: "brand_company" */
  insert_brand_company?: Maybe<Brand_Company_Mutation_Response>;
  /** insert a single row into the table: "brand_company" */
  insert_brand_company_one?: Maybe<Brand_Company>;
  /** insert a single row into the table: "brand" */
  insert_brand_one?: Maybe<Brand>;
  /** insert data into the table: "breeder" */
  insert_breeder?: Maybe<Breeder_Mutation_Response>;
  /** insert a single row into the table: "breeder" */
  insert_breeder_one?: Maybe<Breeder>;
  /** insert data into the table: "business" */
  insert_business?: Maybe<Business_Mutation_Response>;
  /** insert data into the table: "business_commodities_supplied" */
  insert_business_commodities_supplied?: Maybe<Business_Commodities_Supplied_Mutation_Response>;
  /** insert a single row into the table: "business_commodities_supplied" */
  insert_business_commodities_supplied_one?: Maybe<Business_Commodities_Supplied>;
  /** insert data into the table: "business_companies" */
  insert_business_companies?: Maybe<Business_Companies_Mutation_Response>;
  /** insert a single row into the table: "business_companies" */
  insert_business_companies_one?: Maybe<Business_Companies>;
  /** insert data into the table: "business_field" */
  insert_business_field?: Maybe<Business_Field_Mutation_Response>;
  /** insert a single row into the table: "business_field" */
  insert_business_field_one?: Maybe<Business_Field>;
  /** insert data into the table: "business_group" */
  insert_business_group?: Maybe<Business_Group_Mutation_Response>;
  /** insert data into the table: "business_group_network" */
  insert_business_group_network?: Maybe<Business_Group_Network_Mutation_Response>;
  /** insert a single row into the table: "business_group_network" */
  insert_business_group_network_one?: Maybe<Business_Group_Network>;
  /** insert a single row into the table: "business_group" */
  insert_business_group_one?: Maybe<Business_Group>;
  /** insert data into the table: "business_groups" */
  insert_business_groups?: Maybe<Business_Groups_Mutation_Response>;
  /** insert a single row into the table: "business_groups" */
  insert_business_groups_one?: Maybe<Business_Groups>;
  /** insert data into the table: "business_network" */
  insert_business_network?: Maybe<Business_Network_Mutation_Response>;
  /** insert a single row into the table: "business_network" */
  insert_business_network_one?: Maybe<Business_Network>;
  /** insert a single row into the table: "business" */
  insert_business_one?: Maybe<Business>;
  /** insert data into the table: "business_secondary_pocs" */
  insert_business_secondary_pocs?: Maybe<Business_Secondary_Pocs_Mutation_Response>;
  /** insert a single row into the table: "business_secondary_pocs" */
  insert_business_secondary_pocs_one?: Maybe<Business_Secondary_Pocs>;
  /** insert data into the table: "commodity" */
  insert_commodity?: Maybe<Commodity_Mutation_Response>;
  /** insert a single row into the table: "commodity" */
  insert_commodity_one?: Maybe<Commodity>;
  /** insert data into the table: "commodity_variety" */
  insert_commodity_variety?: Maybe<Commodity_Variety_Mutation_Response>;
  /** insert a single row into the table: "commodity_variety" */
  insert_commodity_variety_one?: Maybe<Commodity_Variety>;
  /** insert data into the table: "commodity_variety_secondary_groups" */
  insert_commodity_variety_secondary_groups?: Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>;
  /** insert a single row into the table: "commodity_variety_secondary_groups" */
  insert_commodity_variety_secondary_groups_one?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** insert data into the table: "company" */
  insert_company?: Maybe<Company_Mutation_Response>;
  /** insert data into the table: "company_categories" */
  insert_company_categories?: Maybe<Company_Categories_Mutation_Response>;
  /** insert a single row into the table: "company_categories" */
  insert_company_categories_one?: Maybe<Company_Categories>;
  /** insert data into the table: "company_category" */
  insert_company_category?: Maybe<Company_Category_Mutation_Response>;
  /** insert a single row into the table: "company_category" */
  insert_company_category_one?: Maybe<Company_Category>;
  /** insert a single row into the table: "company" */
  insert_company_one?: Maybe<Company>;
  /** insert data into the table: "company_share_holder" */
  insert_company_share_holder?: Maybe<Company_Share_Holder_Mutation_Response>;
  /** insert a single row into the table: "company_share_holder" */
  insert_company_share_holder_one?: Maybe<Company_Share_Holder>;
  /** insert data into the table: "credit_note" */
  insert_credit_note?: Maybe<Credit_Note_Mutation_Response>;
  /** insert a single row into the table: "credit_note" */
  insert_credit_note_one?: Maybe<Credit_Note>;
  /** insert data into the table: "crop" */
  insert_crop?: Maybe<Crop_Mutation_Response>;
  /** insert data into the table: "crop_group" */
  insert_crop_group?: Maybe<Crop_Group_Mutation_Response>;
  /** insert a single row into the table: "crop_group" */
  insert_crop_group_one?: Maybe<Crop_Group>;
  /** insert data into the table: "crop_infestation" */
  insert_crop_infestation?: Maybe<Crop_Infestation_Mutation_Response>;
  /** insert data into the table: "crop_infestation_attachment" */
  insert_crop_infestation_attachment?: Maybe<Crop_Infestation_Attachment_Mutation_Response>;
  /** insert a single row into the table: "crop_infestation_attachment" */
  insert_crop_infestation_attachment_one?: Maybe<Crop_Infestation_Attachment>;
  /** insert a single row into the table: "crop_infestation" */
  insert_crop_infestation_one?: Maybe<Crop_Infestation>;
  /** insert data into the table: "crop_milestone" */
  insert_crop_milestone?: Maybe<Crop_Milestone_Mutation_Response>;
  /** insert a single row into the table: "crop_milestone" */
  insert_crop_milestone_one?: Maybe<Crop_Milestone>;
  /** insert a single row into the table: "crop" */
  insert_crop_one?: Maybe<Crop>;
  /** insert data into the table: "crop_rootstock" */
  insert_crop_rootstock?: Maybe<Crop_Rootstock_Mutation_Response>;
  /** insert a single row into the table: "crop_rootstock" */
  insert_crop_rootstock_one?: Maybe<Crop_Rootstock>;
  /** insert data into the table: "crop_variety" */
  insert_crop_variety?: Maybe<Crop_Variety_Mutation_Response>;
  /** insert data into the table: "crop_variety_breeder" */
  insert_crop_variety_breeder?: Maybe<Crop_Variety_Breeder_Mutation_Response>;
  /** insert a single row into the table: "crop_variety_breeder" */
  insert_crop_variety_breeder_one?: Maybe<Crop_Variety_Breeder>;
  /** insert a single row into the table: "crop_variety" */
  insert_crop_variety_one?: Maybe<Crop_Variety>;
  /** insert data into the table: "crop_year" */
  insert_crop_year?: Maybe<Crop_Year_Mutation_Response>;
  /** insert a single row into the table: "crop_year" */
  insert_crop_year_one?: Maybe<Crop_Year>;
  /** insert data into the table: "cultivation_type" */
  insert_cultivation_type?: Maybe<Cultivation_Type_Mutation_Response>;
  /** insert a single row into the table: "cultivation_type" */
  insert_cultivation_type_one?: Maybe<Cultivation_Type>;
  /** insert data into the table: "department" */
  insert_department?: Maybe<Department_Mutation_Response>;
  /** insert a single row into the table: "department" */
  insert_department_one?: Maybe<Department>;
  /** insert data into the table: "department_payment_detail" */
  insert_department_payment_detail?: Maybe<Department_Payment_Detail_Mutation_Response>;
  /** insert a single row into the table: "department_payment_detail" */
  insert_department_payment_detail_one?: Maybe<Department_Payment_Detail>;
  /** insert data into the table: "department_settlements" */
  insert_department_settlements?: Maybe<Department_Settlements_Mutation_Response>;
  /** insert a single row into the table: "department_settlements" */
  insert_department_settlements_one?: Maybe<Department_Settlements>;
  /** insert data into the table: "device" */
  insert_device?: Maybe<Device_Mutation_Response>;
  /** insert a single row into the table: "device" */
  insert_device_one?: Maybe<Device>;
  /** insert data into the table: "django_content_type" */
  insert_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** insert a single row into the table: "django_content_type" */
  insert_django_content_type_one?: Maybe<Django_Content_Type>;
  /** insert data into the table: "document" */
  insert_document?: Maybe<Document_Mutation_Response>;
  /** insert data into the table: "document_attachments" */
  insert_document_attachments?: Maybe<Document_Attachments_Mutation_Response>;
  /** insert a single row into the table: "document_attachments" */
  insert_document_attachments_one?: Maybe<Document_Attachments>;
  /** insert data into the table: "document_data" */
  insert_document_data?: Maybe<Document_Data_Mutation_Response>;
  /** insert a single row into the table: "document_data" */
  insert_document_data_one?: Maybe<Document_Data>;
  /** insert data into the table: "document_export_log" */
  insert_document_export_log?: Maybe<Document_Export_Log_Mutation_Response>;
  /** insert a single row into the table: "document_export_log" */
  insert_document_export_log_one?: Maybe<Document_Export_Log>;
  /** insert data into the table: "document_kind" */
  insert_document_kind?: Maybe<Document_Kind_Mutation_Response>;
  /** insert data into the table: "document_kind_data_field" */
  insert_document_kind_data_field?: Maybe<Document_Kind_Data_Field_Mutation_Response>;
  /** insert a single row into the table: "document_kind_data_field" */
  insert_document_kind_data_field_one?: Maybe<Document_Kind_Data_Field>;
  /** insert a single row into the table: "document_kind" */
  insert_document_kind_one?: Maybe<Document_Kind>;
  /** insert a single row into the table: "document" */
  insert_document_one?: Maybe<Document>;
  /** insert data into the table: "document_report" */
  insert_document_report?: Maybe<Document_Report_Mutation_Response>;
  /** insert a single row into the table: "document_report" */
  insert_document_report_one?: Maybe<Document_Report>;
  /** insert data into the table: "document_revision" */
  insert_document_revision?: Maybe<Document_Revision_Mutation_Response>;
  /** insert a single row into the table: "document_revision" */
  insert_document_revision_one?: Maybe<Document_Revision>;
  /** insert data into the table: "address" */
  insert_eagle_address?: Maybe<Eagle_Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_eagle_address_one?: Maybe<Eagle_Address>;
  /** insert data into the table: "media" */
  insert_eagle_media?: Maybe<Eagle_Media_Mutation_Response>;
  /** insert a single row into the table: "media" */
  insert_eagle_media_one?: Maybe<Eagle_Media>;
  /** insert data into the table: "entity_state" */
  insert_entity_state?: Maybe<Entity_State_Mutation_Response>;
  /** insert a single row into the table: "entity_state" */
  insert_entity_state_one?: Maybe<Entity_State>;
  /** insert data into the table: "evaluation_criteria" */
  insert_evaluation_criteria?: Maybe<Evaluation_Criteria_Mutation_Response>;
  /** insert a single row into the table: "evaluation_criteria" */
  insert_evaluation_criteria_one?: Maybe<Evaluation_Criteria>;
  /** insert data into the table: "evaluation_tag" */
  insert_evaluation_tag?: Maybe<Evaluation_Tag_Mutation_Response>;
  /** insert a single row into the table: "evaluation_tag" */
  insert_evaluation_tag_one?: Maybe<Evaluation_Tag>;
  /** insert data into the table: "expense" */
  insert_expense?: Maybe<Expense_Mutation_Response>;
  /** insert a single row into the table: "expense" */
  insert_expense_one?: Maybe<Expense>;
  /** insert data into the table: "external_application" */
  insert_external_application?: Maybe<External_Application_Mutation_Response>;
  /** insert a single row into the table: "external_application" */
  insert_external_application_one?: Maybe<External_Application>;
  /** insert data into the table: "external_entity" */
  insert_external_entity?: Maybe<External_Entity_Mutation_Response>;
  /** insert data into the table: "external_entity_group" */
  insert_external_entity_group?: Maybe<External_Entity_Group_Mutation_Response>;
  /** insert a single row into the table: "external_entity_group" */
  insert_external_entity_group_one?: Maybe<External_Entity_Group>;
  /** insert a single row into the table: "external_entity" */
  insert_external_entity_one?: Maybe<External_Entity>;
  /** insert data into the table: "external_reference" */
  insert_external_reference?: Maybe<External_Reference_Mutation_Response>;
  /** insert a single row into the table: "external_reference" */
  insert_external_reference_one?: Maybe<External_Reference>;
  /** insert data into the table: "farm" */
  insert_farm?: Maybe<Farm_Mutation_Response>;
  /** insert data into the table: "farm_network" */
  insert_farm_network?: Maybe<Farm_Network_Mutation_Response>;
  /** insert a single row into the table: "farm_network" */
  insert_farm_network_one?: Maybe<Farm_Network>;
  /** insert a single row into the table: "farm" */
  insert_farm_one?: Maybe<Farm>;
  /** insert data into the table: "field" */
  insert_field?: Maybe<Field_Mutation_Response>;
  /** insert data into the table: "field_network" */
  insert_field_network?: Maybe<Field_Network_Mutation_Response>;
  /** insert a single row into the table: "field_network" */
  insert_field_network_one?: Maybe<Field_Network>;
  /** insert a single row into the table: "field" */
  insert_field_one?: Maybe<Field>;
  /** insert data into the table: "field_weather_location" */
  insert_field_weather_location?: Maybe<Field_Weather_Location_Mutation_Response>;
  /** insert a single row into the table: "field_weather_location" */
  insert_field_weather_location_one?: Maybe<Field_Weather_Location>;
  /** insert data into the table: "grade" */
  insert_grade?: Maybe<Grade_Mutation_Response>;
  /** insert data into the table: "grade_company" */
  insert_grade_company?: Maybe<Grade_Company_Mutation_Response>;
  /** insert a single row into the table: "grade_company" */
  insert_grade_company_one?: Maybe<Grade_Company>;
  /** insert a single row into the table: "grade" */
  insert_grade_one?: Maybe<Grade>;
  /** insert data into the table: "grade_price" */
  insert_grade_price?: Maybe<Grade_Price_Mutation_Response>;
  /** insert a single row into the table: "grade_price" */
  insert_grade_price_one?: Maybe<Grade_Price>;
  /** insert data into the table: "guarantor_agreement" */
  insert_guarantor_agreement?: Maybe<Guarantor_Agreement_Mutation_Response>;
  /** insert data into the table: "guarantor_agreement_agreement_invoices" */
  insert_guarantor_agreement_agreement_invoices?: Maybe<Guarantor_Agreement_Agreement_Invoices_Mutation_Response>;
  /** insert a single row into the table: "guarantor_agreement_agreement_invoices" */
  insert_guarantor_agreement_agreement_invoices_one?: Maybe<Guarantor_Agreement_Agreement_Invoices>;
  /** insert data into the table: "guarantor_agreement_agreement_plots" */
  insert_guarantor_agreement_agreement_plots?: Maybe<Guarantor_Agreement_Agreement_Plots_Mutation_Response>;
  /** insert a single row into the table: "guarantor_agreement_agreement_plots" */
  insert_guarantor_agreement_agreement_plots_one?: Maybe<Guarantor_Agreement_Agreement_Plots>;
  /** insert data into the table: "guarantor_agreement_area_extension_detail" */
  insert_guarantor_agreement_area_extension_detail?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Mutation_Response>;
  /** insert a single row into the table: "guarantor_agreement_area_extension_detail" */
  insert_guarantor_agreement_area_extension_detail_one?: Maybe<Guarantor_Agreement_Area_Extension_Detail>;
  /** insert a single row into the table: "guarantor_agreement" */
  insert_guarantor_agreement_one?: Maybe<Guarantor_Agreement>;
  /** insert data into the table: "infestation" */
  insert_infestation?: Maybe<Infestation_Mutation_Response>;
  /** insert a single row into the table: "infestation" */
  insert_infestation_one?: Maybe<Infestation>;
  /** insert data into the table: "instrument" */
  insert_instrument?: Maybe<Instrument_Mutation_Response>;
  /** insert data into the table: "instrument_departments" */
  insert_instrument_departments?: Maybe<Instrument_Departments_Mutation_Response>;
  /** insert a single row into the table: "instrument_departments" */
  insert_instrument_departments_one?: Maybe<Instrument_Departments>;
  /** insert data into the table: "instrument_kind" */
  insert_instrument_kind?: Maybe<Instrument_Kind_Mutation_Response>;
  /** insert a single row into the table: "instrument_kind" */
  insert_instrument_kind_one?: Maybe<Instrument_Kind>;
  /** insert a single row into the table: "instrument" */
  insert_instrument_one?: Maybe<Instrument>;
  /** insert data into the table: "issuance_note_attachments" */
  insert_issuance_note_attachments?: Maybe<Issuance_Note_Attachments_Mutation_Response>;
  /** insert a single row into the table: "issuance_note_attachments" */
  insert_issuance_note_attachments_one?: Maybe<Issuance_Note_Attachments>;
  /** insert data into the table: "notification" */
  insert_kite_notification?: Maybe<Kite_Notification_Mutation_Response>;
  /** insert a single row into the table: "notification" */
  insert_kite_notification_one?: Maybe<Kite_Notification>;
  /** insert data into the table: "quality_stage" */
  insert_kite_quality_stage?: Maybe<Kite_Quality_Stage_Mutation_Response>;
  /** insert a single row into the table: "quality_stage" */
  insert_kite_quality_stage_one?: Maybe<Kite_Quality_Stage>;
  /** insert data into the table: "laboratory" */
  insert_laboratory?: Maybe<Laboratory_Mutation_Response>;
  /** insert a single row into the table: "laboratory" */
  insert_laboratory_one?: Maybe<Laboratory>;
  /** insert data into the table: "laboratory_organisations" */
  insert_laboratory_organisations?: Maybe<Laboratory_Organisations_Mutation_Response>;
  /** insert a single row into the table: "laboratory_organisations" */
  insert_laboratory_organisations_one?: Maybe<Laboratory_Organisations>;
  /** insert data into the table: "legal_agreement" */
  insert_legal_agreement?: Maybe<Legal_Agreement_Mutation_Response>;
  /** insert a single row into the table: "legal_agreement" */
  insert_legal_agreement_one?: Maybe<Legal_Agreement>;
  /** insert data into the table: "market" */
  insert_market?: Maybe<Market_Mutation_Response>;
  /** insert data into the table: "market_allowed_departments" */
  insert_market_allowed_departments?: Maybe<Market_Allowed_Departments_Mutation_Response>;
  /** insert a single row into the table: "market_allowed_departments" */
  insert_market_allowed_departments_one?: Maybe<Market_Allowed_Departments>;
  /** insert a single row into the table: "market" */
  insert_market_one?: Maybe<Market>;
  /** insert data into the table: "media" */
  insert_media?: Maybe<Media_Mutation_Response>;
  /** insert a single row into the table: "media" */
  insert_media_one?: Maybe<Media>;
  /** insert data into the table: "milestone" */
  insert_milestone?: Maybe<Milestone_Mutation_Response>;
  /** insert a single row into the table: "milestone" */
  insert_milestone_one?: Maybe<Milestone>;
  /** insert data into the table: "mutual_group" */
  insert_mutual_group?: Maybe<Mutual_Group_Mutation_Response>;
  /** insert data into the table: "mutual_group_membership" */
  insert_mutual_group_membership?: Maybe<Mutual_Group_Membership_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_membership" */
  insert_mutual_group_membership_one?: Maybe<Mutual_Group_Membership>;
  /** insert data into the table: "mutual_group_network" */
  insert_mutual_group_network?: Maybe<Mutual_Group_Network_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_network" */
  insert_mutual_group_network_one?: Maybe<Mutual_Group_Network>;
  /** insert a single row into the table: "mutual_group" */
  insert_mutual_group_one?: Maybe<Mutual_Group>;
  /** insert data into the table: "mutual_group_role" */
  insert_mutual_group_role?: Maybe<Mutual_Group_Role_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_role" */
  insert_mutual_group_role_one?: Maybe<Mutual_Group_Role>;
  /** insert data into the table: "mutual_group_weather_station" */
  insert_mutual_group_weather_station?: Maybe<Mutual_Group_Weather_Station_Mutation_Response>;
  /** insert a single row into the table: "mutual_group_weather_station" */
  insert_mutual_group_weather_station_one?: Maybe<Mutual_Group_Weather_Station>;
  /** insert data into the table: "nationality" */
  insert_nationality?: Maybe<Nationality_Mutation_Response>;
  /** insert a single row into the table: "nationality" */
  insert_nationality_one?: Maybe<Nationality>;
  /** insert data into the table: "network" */
  insert_network?: Maybe<Network_Mutation_Response>;
  /** insert a single row into the table: "network" */
  insert_network_one?: Maybe<Network>;
  /** insert data into the table: "nominees" */
  insert_nominees?: Maybe<Nominees_Mutation_Response>;
  /** insert data into the table: "nominees_documents" */
  insert_nominees_documents?: Maybe<Nominees_Documents_Mutation_Response>;
  /** insert a single row into the table: "nominees_documents" */
  insert_nominees_documents_one?: Maybe<Nominees_Documents>;
  /** insert a single row into the table: "nominees" */
  insert_nominees_one?: Maybe<Nominees>;
  /** insert data into the table: "notification_provider" */
  insert_notification_provider?: Maybe<Notification_Provider_Mutation_Response>;
  /** insert a single row into the table: "notification_provider" */
  insert_notification_provider_one?: Maybe<Notification_Provider>;
  /** insert data into the table: "notification_trigger" */
  insert_notification_trigger?: Maybe<Notification_Trigger_Mutation_Response>;
  /** insert a single row into the table: "notification_trigger" */
  insert_notification_trigger_one?: Maybe<Notification_Trigger>;
  /** insert data into the table: "org_dashboard_stats" */
  insert_org_dashboard_stats?: Maybe<Org_Dashboard_Stats_Mutation_Response>;
  /** insert a single row into the table: "org_dashboard_stats" */
  insert_org_dashboard_stats_one?: Maybe<Org_Dashboard_Stats>;
  /** insert data into the table: "org_team_association" */
  insert_org_team_association?: Maybe<Org_Team_Association_Mutation_Response>;
  /** insert a single row into the table: "org_team_association" */
  insert_org_team_association_one?: Maybe<Org_Team_Association>;
  /** insert data into the table: "org_team_primary_crop" */
  insert_org_team_primary_crop?: Maybe<Org_Team_Primary_Crop_Mutation_Response>;
  /** insert a single row into the table: "org_team_primary_crop" */
  insert_org_team_primary_crop_one?: Maybe<Org_Team_Primary_Crop>;
  /** insert data into the table: "org_team_user_bank_association" */
  insert_org_team_user_bank_association?: Maybe<Org_Team_User_Bank_Association_Mutation_Response>;
  /** insert a single row into the table: "org_team_user_bank_association" */
  insert_org_team_user_bank_association_one?: Maybe<Org_Team_User_Bank_Association>;
  /** insert data into the table: "org_team_user_crop" */
  insert_org_team_user_crop?: Maybe<Org_Team_User_Crop_Mutation_Response>;
  /** insert a single row into the table: "org_team_user_crop" */
  insert_org_team_user_crop_one?: Maybe<Org_Team_User_Crop>;
  /** insert data into the table: "org_team_user_document_association" */
  insert_org_team_user_document_association?: Maybe<Org_Team_User_Document_Association_Mutation_Response>;
  /** insert a single row into the table: "org_team_user_document_association" */
  insert_org_team_user_document_association_one?: Maybe<Org_Team_User_Document_Association>;
  /** insert data into the table: "org_user_association" */
  insert_org_user_association?: Maybe<Org_User_Association_Mutation_Response>;
  /** insert a single row into the table: "org_user_association" */
  insert_org_user_association_one?: Maybe<Org_User_Association>;
  /** insert data into the table: "org_user_group_mandatory_document" */
  insert_org_user_group_mandatory_document?: Maybe<Org_User_Group_Mandatory_Document_Mutation_Response>;
  /** insert a single row into the table: "org_user_group_mandatory_document" */
  insert_org_user_group_mandatory_document_one?: Maybe<Org_User_Group_Mandatory_Document>;
  /** insert data into the table: "org_user_group_status_snapshot" */
  insert_org_user_group_status_snapshot?: Maybe<Org_User_Group_Status_Snapshot_Mutation_Response>;
  /** insert a single row into the table: "org_user_group_status_snapshot" */
  insert_org_user_group_status_snapshot_one?: Maybe<Org_User_Group_Status_Snapshot>;
  /** insert data into the table: "org_user_primary_crop" */
  insert_org_user_primary_crop?: Maybe<Org_User_Primary_Crop_Mutation_Response>;
  /** insert a single row into the table: "org_user_primary_crop" */
  insert_org_user_primary_crop_one?: Maybe<Org_User_Primary_Crop>;
  /** insert data into the table: "organisation" */
  insert_organisation?: Maybe<Organisation_Mutation_Response>;
  /** insert data into the table: "organisation_commodity_variety_config" */
  insert_organisation_commodity_variety_config?: Maybe<Organisation_Commodity_Variety_Config_Mutation_Response>;
  /** insert a single row into the table: "organisation_commodity_variety_config" */
  insert_organisation_commodity_variety_config_one?: Maybe<Organisation_Commodity_Variety_Config>;
  /** insert data into the table: "organisation_commodity_variety_config_taxes" */
  insert_organisation_commodity_variety_config_taxes?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Mutation_Response>;
  /** insert a single row into the table: "organisation_commodity_variety_config_taxes" */
  insert_organisation_commodity_variety_config_taxes_one?: Maybe<Organisation_Commodity_Variety_Config_Taxes>;
  /** insert data into the table: "organisation_crop" */
  insert_organisation_crop?: Maybe<Organisation_Crop_Mutation_Response>;
  /** insert a single row into the table: "organisation_crop" */
  insert_organisation_crop_one?: Maybe<Organisation_Crop>;
  /** insert data into the table: "organisation_document_kind" */
  insert_organisation_document_kind?: Maybe<Organisation_Document_Kind_Mutation_Response>;
  /** insert a single row into the table: "organisation_document_kind" */
  insert_organisation_document_kind_one?: Maybe<Organisation_Document_Kind>;
  /** insert a single row into the table: "organisation" */
  insert_organisation_one?: Maybe<Organisation>;
  /** insert data into the table: "organisation_preferences" */
  insert_organisation_preferences?: Maybe<Organisation_Preferences_Mutation_Response>;
  /** insert a single row into the table: "organisation_preferences" */
  insert_organisation_preferences_one?: Maybe<Organisation_Preferences>;
  /** insert data into the table: "organisation_season" */
  insert_organisation_season?: Maybe<Organisation_Season_Mutation_Response>;
  /** insert a single row into the table: "organisation_season" */
  insert_organisation_season_one?: Maybe<Organisation_Season>;
  /** insert data into the table: "over_due_approval" */
  insert_over_due_approval?: Maybe<Over_Due_Approval_Mutation_Response>;
  /** insert a single row into the table: "over_due_approval" */
  insert_over_due_approval_one?: Maybe<Over_Due_Approval>;
  /** insert data into the table: "packaging_order" */
  insert_packaging_order?: Maybe<Packaging_Order_Mutation_Response>;
  /** insert data into the table: "packaging_order_item" */
  insert_packaging_order_item?: Maybe<Packaging_Order_Item_Mutation_Response>;
  /** insert a single row into the table: "packaging_order_item" */
  insert_packaging_order_item_one?: Maybe<Packaging_Order_Item>;
  /** insert a single row into the table: "packaging_order" */
  insert_packaging_order_one?: Maybe<Packaging_Order>;
  /** insert data into the table: "pallet_category" */
  insert_pallet_category?: Maybe<Pallet_Category_Mutation_Response>;
  /** insert a single row into the table: "pallet_category" */
  insert_pallet_category_one?: Maybe<Pallet_Category>;
  /** insert data into the table: "pallet_customer" */
  insert_pallet_customer?: Maybe<Pallet_Customer_Mutation_Response>;
  /** insert a single row into the table: "pallet_customer" */
  insert_pallet_customer_one?: Maybe<Pallet_Customer>;
  /** insert data into the table: "pallet_inspection" */
  insert_pallet_inspection?: Maybe<Pallet_Inspection_Mutation_Response>;
  /** insert data into the table: "pallet_inspection_attachments" */
  insert_pallet_inspection_attachments?: Maybe<Pallet_Inspection_Attachments_Mutation_Response>;
  /** insert a single row into the table: "pallet_inspection_attachments" */
  insert_pallet_inspection_attachments_one?: Maybe<Pallet_Inspection_Attachments>;
  /** insert a single row into the table: "pallet_inspection" */
  insert_pallet_inspection_one?: Maybe<Pallet_Inspection>;
  /** insert data into the table: "pallet_inspection_reports" */
  insert_pallet_inspection_reports?: Maybe<Pallet_Inspection_Reports_Mutation_Response>;
  /** insert a single row into the table: "pallet_inspection_reports" */
  insert_pallet_inspection_reports_one?: Maybe<Pallet_Inspection_Reports>;
  /** insert data into the table: "pallet_inspectionkind" */
  insert_pallet_inspectionkind?: Maybe<Pallet_Inspectionkind_Mutation_Response>;
  /** insert a single row into the table: "pallet_inspectionkind" */
  insert_pallet_inspectionkind_one?: Maybe<Pallet_Inspectionkind>;
  /** insert data into the table: "pallet_inspectionobservation" */
  insert_pallet_inspectionobservation?: Maybe<Pallet_Inspectionobservation_Mutation_Response>;
  /** insert data into the table: "pallet_inspectionobservation_attachments" */
  insert_pallet_inspectionobservation_attachments?: Maybe<Pallet_Inspectionobservation_Attachments_Mutation_Response>;
  /** insert a single row into the table: "pallet_inspectionobservation_attachments" */
  insert_pallet_inspectionobservation_attachments_one?: Maybe<Pallet_Inspectionobservation_Attachments>;
  /** insert a single row into the table: "pallet_inspectionobservation" */
  insert_pallet_inspectionobservation_one?: Maybe<Pallet_Inspectionobservation>;
  /** insert data into the table: "pallet_line" */
  insert_pallet_line?: Maybe<Pallet_Line_Mutation_Response>;
  /** insert a single row into the table: "pallet_line" */
  insert_pallet_line_one?: Maybe<Pallet_Line>;
  /** insert data into the table: "pallet_location" */
  insert_pallet_location?: Maybe<Pallet_Location_Mutation_Response>;
  /** insert a single row into the table: "pallet_location" */
  insert_pallet_location_one?: Maybe<Pallet_Location>;
  /** insert data into the table: "pallet_packaging" */
  insert_pallet_packaging?: Maybe<Pallet_Packaging_Mutation_Response>;
  /** insert a single row into the table: "pallet_packaging" */
  insert_pallet_packaging_one?: Maybe<Pallet_Packaging>;
  /** insert data into the table: "pallet_packagingkind" */
  insert_pallet_packagingkind?: Maybe<Pallet_Packagingkind_Mutation_Response>;
  /** insert a single row into the table: "pallet_packagingkind" */
  insert_pallet_packagingkind_one?: Maybe<Pallet_Packagingkind>;
  /** insert data into the table: "pallet_packing" */
  insert_pallet_packing?: Maybe<Pallet_Packing_Mutation_Response>;
  /** insert data into the table: "pallet_packing_attachments" */
  insert_pallet_packing_attachments?: Maybe<Pallet_Packing_Attachments_Mutation_Response>;
  /** insert a single row into the table: "pallet_packing_attachments" */
  insert_pallet_packing_attachments_one?: Maybe<Pallet_Packing_Attachments>;
  /** insert a single row into the table: "pallet_packing" */
  insert_pallet_packing_one?: Maybe<Pallet_Packing>;
  /** insert data into the table: "pallet_packing_weights" */
  insert_pallet_packing_weights?: Maybe<Pallet_Packing_Weights_Mutation_Response>;
  /** insert a single row into the table: "pallet_packing_weights" */
  insert_pallet_packing_weights_one?: Maybe<Pallet_Packing_Weights>;
  /** insert data into the table: "pallet_packingkind" */
  insert_pallet_packingkind?: Maybe<Pallet_Packingkind_Mutation_Response>;
  /** insert a single row into the table: "pallet_packingkind" */
  insert_pallet_packingkind_one?: Maybe<Pallet_Packingkind>;
  /** insert data into the table: "pallet_packingweight" */
  insert_pallet_packingweight?: Maybe<Pallet_Packingweight_Mutation_Response>;
  /** insert data into the table: "pallet_packingweight_attachments" */
  insert_pallet_packingweight_attachments?: Maybe<Pallet_Packingweight_Attachments_Mutation_Response>;
  /** insert a single row into the table: "pallet_packingweight_attachments" */
  insert_pallet_packingweight_attachments_one?: Maybe<Pallet_Packingweight_Attachments>;
  /** insert a single row into the table: "pallet_packingweight" */
  insert_pallet_packingweight_one?: Maybe<Pallet_Packingweight>;
  /** insert data into the table: "pallet_printingmatter" */
  insert_pallet_printingmatter?: Maybe<Pallet_Printingmatter_Mutation_Response>;
  /** insert a single row into the table: "pallet_printingmatter" */
  insert_pallet_printingmatter_one?: Maybe<Pallet_Printingmatter>;
  /** insert data into the table: "pallet_punnetcondition" */
  insert_pallet_punnetcondition?: Maybe<Pallet_Punnetcondition_Mutation_Response>;
  /** insert a single row into the table: "pallet_punnetcondition" */
  insert_pallet_punnetcondition_one?: Maybe<Pallet_Punnetcondition>;
  /** insert data into the table: "pallet_samplinglocation" */
  insert_pallet_samplinglocation?: Maybe<Pallet_Samplinglocation_Mutation_Response>;
  /** insert a single row into the table: "pallet_samplinglocation" */
  insert_pallet_samplinglocation_one?: Maybe<Pallet_Samplinglocation>;
  /** insert data into the table: "pallet_sku" */
  insert_pallet_sku?: Maybe<Pallet_Sku_Mutation_Response>;
  /** insert a single row into the table: "pallet_sku" */
  insert_pallet_sku_one?: Maybe<Pallet_Sku>;
  /** insert data into the table: "pallet_skutype" */
  insert_pallet_skutype?: Maybe<Pallet_Skutype_Mutation_Response>;
  /** insert a single row into the table: "pallet_skutype" */
  insert_pallet_skutype_one?: Maybe<Pallet_Skutype>;
  /** insert data into the table: "pallet_variety" */
  insert_pallet_variety?: Maybe<Pallet_Variety_Mutation_Response>;
  /** insert a single row into the table: "pallet_variety" */
  insert_pallet_variety_one?: Maybe<Pallet_Variety>;
  /** insert data into the table: "payment" */
  insert_payment?: Maybe<Payment_Mutation_Response>;
  /** insert data into the table: "payment_detail" */
  insert_payment_detail?: Maybe<Payment_Detail_Mutation_Response>;
  /** insert data into the table: "payment_detail_attachments" */
  insert_payment_detail_attachments?: Maybe<Payment_Detail_Attachments_Mutation_Response>;
  /** insert a single row into the table: "payment_detail_attachments" */
  insert_payment_detail_attachments_one?: Maybe<Payment_Detail_Attachments>;
  /** insert a single row into the table: "payment_detail" */
  insert_payment_detail_one?: Maybe<Payment_Detail>;
  /** insert data into the table: "payment_method" */
  insert_payment_method?: Maybe<Payment_Method_Mutation_Response>;
  /** insert a single row into the table: "payment_method" */
  insert_payment_method_one?: Maybe<Payment_Method>;
  /** insert a single row into the table: "payment" */
  insert_payment_one?: Maybe<Payment>;
  /** insert data into the table: "plot" */
  insert_plot?: Maybe<Plot_Mutation_Response>;
  /** insert data into the table: "plot_crop" */
  insert_plot_crop?: Maybe<Plot_Crop_Mutation_Response>;
  /** insert data into the table: "plot_crop_agent" */
  insert_plot_crop_agent?: Maybe<Plot_Crop_Agent_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_agent" */
  insert_plot_crop_agent_one?: Maybe<Plot_Crop_Agent>;
  /** insert data into the table: "plot_crop_cultivation_type" */
  insert_plot_crop_cultivation_type?: Maybe<Plot_Crop_Cultivation_Type_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_cultivation_type" */
  insert_plot_crop_cultivation_type_one?: Maybe<Plot_Crop_Cultivation_Type>;
  /** insert data into the table: "plot_crop_historic_season" */
  insert_plot_crop_historic_season?: Maybe<Plot_Crop_Historic_Season_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_historic_season" */
  insert_plot_crop_historic_season_one?: Maybe<Plot_Crop_Historic_Season>;
  /** insert data into the table: "plot_crop_milestone" */
  insert_plot_crop_milestone?: Maybe<Plot_Crop_Milestone_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_milestone" */
  insert_plot_crop_milestone_one?: Maybe<Plot_Crop_Milestone>;
  /** insert data into the table: "plot_crop_network" */
  insert_plot_crop_network?: Maybe<Plot_Crop_Network_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_network" */
  insert_plot_crop_network_one?: Maybe<Plot_Crop_Network>;
  /** insert a single row into the table: "plot_crop" */
  insert_plot_crop_one?: Maybe<Plot_Crop>;
  /** insert data into the table: "plot_crop_rootstock" */
  insert_plot_crop_rootstock?: Maybe<Plot_Crop_Rootstock_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_rootstock" */
  insert_plot_crop_rootstock_one?: Maybe<Plot_Crop_Rootstock>;
  /** insert data into the table: "plot_crop_status_history" */
  insert_plot_crop_status_history?: Maybe<Plot_Crop_Status_History_Mutation_Response>;
  /** insert a single row into the table: "plot_crop_status_history" */
  insert_plot_crop_status_history_one?: Maybe<Plot_Crop_Status_History>;
  /** insert data into the table: "plot_network" */
  insert_plot_network?: Maybe<Plot_Network_Mutation_Response>;
  /** insert a single row into the table: "plot_network" */
  insert_plot_network_one?: Maybe<Plot_Network>;
  /** insert a single row into the table: "plot" */
  insert_plot_one?: Maybe<Plot>;
  /** insert data into the table: "plot_status" */
  insert_plot_status?: Maybe<Plot_Status_Mutation_Response>;
  /** insert data into the table: "plot_status_config" */
  insert_plot_status_config?: Maybe<Plot_Status_Config_Mutation_Response>;
  /** insert a single row into the table: "plot_status_config" */
  insert_plot_status_config_one?: Maybe<Plot_Status_Config>;
  /** insert data into the table: "plot_status_config_required_qc_stages" */
  insert_plot_status_config_required_qc_stages?: Maybe<Plot_Status_Config_Required_Qc_Stages_Mutation_Response>;
  /** insert a single row into the table: "plot_status_config_required_qc_stages" */
  insert_plot_status_config_required_qc_stages_one?: Maybe<Plot_Status_Config_Required_Qc_Stages>;
  /** insert a single row into the table: "plot_status" */
  insert_plot_status_one?: Maybe<Plot_Status>;
  /** insert data into the table: "primary_growth_stage" */
  insert_primary_growth_stage?: Maybe<Primary_Growth_Stage_Mutation_Response>;
  /** insert a single row into the table: "primary_growth_stage" */
  insert_primary_growth_stage_one?: Maybe<Primary_Growth_Stage>;
  /** insert data into the table: "quality_parameter" */
  insert_quality_parameter?: Maybe<Quality_Parameter_Mutation_Response>;
  /** insert data into the table: "quality_parameter_category" */
  insert_quality_parameter_category?: Maybe<Quality_Parameter_Category_Mutation_Response>;
  /** insert a single row into the table: "quality_parameter_category" */
  insert_quality_parameter_category_one?: Maybe<Quality_Parameter_Category>;
  /** insert a single row into the table: "quality_parameter" */
  insert_quality_parameter_one?: Maybe<Quality_Parameter>;
  /** insert data into the table: "quality_stage" */
  insert_quality_stage?: Maybe<Quality_Stage_Mutation_Response>;
  /** insert data into the table: "quality_stage_allowed_template_category" */
  insert_quality_stage_allowed_template_category?: Maybe<Quality_Stage_Allowed_Template_Category_Mutation_Response>;
  /** insert a single row into the table: "quality_stage_allowed_template_category" */
  insert_quality_stage_allowed_template_category_one?: Maybe<Quality_Stage_Allowed_Template_Category>;
  /** insert a single row into the table: "quality_stage" */
  insert_quality_stage_one?: Maybe<Quality_Stage>;
  /** insert data into the table: "receipt" */
  insert_receipt?: Maybe<Receipt_Mutation_Response>;
  /** insert a single row into the table: "receipt" */
  insert_receipt_one?: Maybe<Receipt>;
  /** insert data into the table: "region" */
  insert_region?: Maybe<Region_Mutation_Response>;
  /** insert data into the table: "region_group" */
  insert_region_group?: Maybe<Region_Group_Mutation_Response>;
  /** insert a single row into the table: "region_group" */
  insert_region_group_one?: Maybe<Region_Group>;
  /** insert a single row into the table: "region" */
  insert_region_one?: Maybe<Region>;
  /** insert data into the table: "request" */
  insert_request?: Maybe<Request_Mutation_Response>;
  /** insert data into the table: "request_category" */
  insert_request_category?: Maybe<Request_Category_Mutation_Response>;
  /** insert a single row into the table: "request_category" */
  insert_request_category_one?: Maybe<Request_Category>;
  /** insert a single row into the table: "request" */
  insert_request_one?: Maybe<Request>;
  /** insert data into the table: "request_parameters" */
  insert_request_parameters?: Maybe<Request_Parameters_Mutation_Response>;
  /** insert a single row into the table: "request_parameters" */
  insert_request_parameters_one?: Maybe<Request_Parameters>;
  /** insert data into the table: "request_secondary_locations" */
  insert_request_secondary_locations?: Maybe<Request_Secondary_Locations_Mutation_Response>;
  /** insert a single row into the table: "request_secondary_locations" */
  insert_request_secondary_locations_one?: Maybe<Request_Secondary_Locations>;
  /** insert data into the table: "request_templates" */
  insert_request_templates?: Maybe<Request_Templates_Mutation_Response>;
  /** insert a single row into the table: "request_templates" */
  insert_request_templates_one?: Maybe<Request_Templates>;
  /** insert data into the table: "result" */
  insert_result?: Maybe<Result_Mutation_Response>;
  /** insert data into the table: "result_comment" */
  insert_result_comment?: Maybe<Result_Comment_Mutation_Response>;
  /** insert a single row into the table: "result_comment" */
  insert_result_comment_one?: Maybe<Result_Comment>;
  /** insert data into the table: "result_evaluation" */
  insert_result_evaluation?: Maybe<Result_Evaluation_Mutation_Response>;
  /** insert data into the table: "result_evaluation_evaluated_tags" */
  insert_result_evaluation_evaluated_tags?: Maybe<Result_Evaluation_Evaluated_Tags_Mutation_Response>;
  /** insert a single row into the table: "result_evaluation_evaluated_tags" */
  insert_result_evaluation_evaluated_tags_one?: Maybe<Result_Evaluation_Evaluated_Tags>;
  /** insert a single row into the table: "result_evaluation" */
  insert_result_evaluation_one?: Maybe<Result_Evaluation>;
  /** insert data into the table: "result_media" */
  insert_result_media?: Maybe<Result_Media_Mutation_Response>;
  /** insert a single row into the table: "result_media" */
  insert_result_media_one?: Maybe<Result_Media>;
  /** insert data into the table: "result_observation" */
  insert_result_observation?: Maybe<Result_Observation_Mutation_Response>;
  /** insert data into the table: "result_observation_attachments" */
  insert_result_observation_attachments?: Maybe<Result_Observation_Attachments_Mutation_Response>;
  /** insert a single row into the table: "result_observation_attachments" */
  insert_result_observation_attachments_one?: Maybe<Result_Observation_Attachments>;
  /** insert data into the table: "result_observation_evaluated_tags" */
  insert_result_observation_evaluated_tags?: Maybe<Result_Observation_Evaluated_Tags_Mutation_Response>;
  /** insert a single row into the table: "result_observation_evaluated_tags" */
  insert_result_observation_evaluated_tags_one?: Maybe<Result_Observation_Evaluated_Tags>;
  /** insert a single row into the table: "result_observation" */
  insert_result_observation_one?: Maybe<Result_Observation>;
  /** insert a single row into the table: "result" */
  insert_result_one?: Maybe<Result>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<Role_Mutation_Response>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "rootstock" */
  insert_rootstock?: Maybe<Rootstock_Mutation_Response>;
  /** insert a single row into the table: "rootstock" */
  insert_rootstock_one?: Maybe<Rootstock>;
  /** insert data into the table: "sample" */
  insert_sample?: Maybe<Sample_Mutation_Response>;
  /** insert data into the table: "sample_media" */
  insert_sample_media?: Maybe<Sample_Media_Mutation_Response>;
  /** insert a single row into the table: "sample_media" */
  insert_sample_media_one?: Maybe<Sample_Media>;
  /** insert data into the table: "sample_observation" */
  insert_sample_observation?: Maybe<Sample_Observation_Mutation_Response>;
  /** insert data into the table: "sample_observation_attachments" */
  insert_sample_observation_attachments?: Maybe<Sample_Observation_Attachments_Mutation_Response>;
  /** insert a single row into the table: "sample_observation_attachments" */
  insert_sample_observation_attachments_one?: Maybe<Sample_Observation_Attachments>;
  /** insert a single row into the table: "sample_observation" */
  insert_sample_observation_one?: Maybe<Sample_Observation>;
  /** insert a single row into the table: "sample" */
  insert_sample_one?: Maybe<Sample>;
  /** insert data into the table: "secondary_growth_stage" */
  insert_secondary_growth_stage?: Maybe<Secondary_Growth_Stage_Mutation_Response>;
  /** insert a single row into the table: "secondary_growth_stage" */
  insert_secondary_growth_stage_one?: Maybe<Secondary_Growth_Stage>;
  /** insert data into the table: "shared_entity" */
  insert_setu_trade_shared_entity?: Maybe<Setu_Trade_Shared_Entity_Mutation_Response>;
  /** insert a single row into the table: "shared_entity" */
  insert_setu_trade_shared_entity_one?: Maybe<Setu_Trade_Shared_Entity>;
  /** insert data into the table: "media" */
  insert_setutrade_media?: Maybe<Setutrade_Media_Mutation_Response>;
  /** insert a single row into the table: "media" */
  insert_setutrade_media_one?: Maybe<Setutrade_Media>;
  /** insert data into the table: "shareholder_applications" */
  insert_shareholder_applications?: Maybe<Shareholder_Applications_Mutation_Response>;
  /** insert a single row into the table: "shareholder_applications" */
  insert_shareholder_applications_one?: Maybe<Shareholder_Applications>;
  /** insert data into the table: "shareholders" */
  insert_shareholders?: Maybe<Shareholders_Mutation_Response>;
  /** insert a single row into the table: "shareholders" */
  insert_shareholders_one?: Maybe<Shareholders>;
  /** insert data into the table: "si_unit" */
  insert_si_unit?: Maybe<Si_Unit_Mutation_Response>;
  /** insert data into the table: "si_unit_measure" */
  insert_si_unit_measure?: Maybe<Si_Unit_Measure_Mutation_Response>;
  /** insert a single row into the table: "si_unit_measure" */
  insert_si_unit_measure_one?: Maybe<Si_Unit_Measure>;
  /** insert a single row into the table: "si_unit" */
  insert_si_unit_one?: Maybe<Si_Unit>;
  /** insert data into the table: "sku" */
  insert_sku?: Maybe<Sku_Mutation_Response>;
  /** insert data into the table: "sku_kind" */
  insert_sku_kind?: Maybe<Sku_Kind_Mutation_Response>;
  /** insert a single row into the table: "sku_kind" */
  insert_sku_kind_one?: Maybe<Sku_Kind>;
  /** insert a single row into the table: "sku" */
  insert_sku_one?: Maybe<Sku>;
  /** insert data into the table: "soil" */
  insert_soil?: Maybe<Soil_Mutation_Response>;
  /** insert a single row into the table: "soil" */
  insert_soil_one?: Maybe<Soil>;
  /** insert data into the table: "stage_actions" */
  insert_stage_actions?: Maybe<Stage_Actions_Mutation_Response>;
  /** insert a single row into the table: "stage_actions" */
  insert_stage_actions_one?: Maybe<Stage_Actions>;
  /** insert data into the table: "stage_logs" */
  insert_stage_logs?: Maybe<Stage_Logs_Mutation_Response>;
  /** insert a single row into the table: "stage_logs" */
  insert_stage_logs_one?: Maybe<Stage_Logs>;
  /** insert data into the table: "stages" */
  insert_stages?: Maybe<Stages_Mutation_Response>;
  /** insert a single row into the table: "stages" */
  insert_stages_one?: Maybe<Stages>;
  /** insert data into the table: "stages_subscribers" */
  insert_stages_subscribers?: Maybe<Stages_Subscribers_Mutation_Response>;
  /** insert a single row into the table: "stages_subscribers" */
  insert_stages_subscribers_one?: Maybe<Stages_Subscribers>;
  /** insert data into the table: "state" */
  insert_state?: Maybe<State_Mutation_Response>;
  /** insert a single row into the table: "state" */
  insert_state_one?: Maybe<State>;
  /** insert data into the table: "survey_parameters" */
  insert_survey_parameters?: Maybe<Survey_Parameters_Mutation_Response>;
  /** insert a single row into the table: "survey_parameters" */
  insert_survey_parameters_one?: Maybe<Survey_Parameters>;
  /** insert data into the table: "survey_response_items" */
  insert_survey_response_items?: Maybe<Survey_Response_Items_Mutation_Response>;
  /** insert a single row into the table: "survey_response_items" */
  insert_survey_response_items_one?: Maybe<Survey_Response_Items>;
  /** insert data into the table: "survey_responses" */
  insert_survey_responses?: Maybe<Survey_Responses_Mutation_Response>;
  /** insert a single row into the table: "survey_responses" */
  insert_survey_responses_one?: Maybe<Survey_Responses>;
  /** insert data into the table: "survey_users" */
  insert_survey_users?: Maybe<Survey_Users_Mutation_Response>;
  /** insert a single row into the table: "survey_users" */
  insert_survey_users_one?: Maybe<Survey_Users>;
  /** insert data into the table: "survey_year" */
  insert_survey_year?: Maybe<Survey_Year_Mutation_Response>;
  /** insert a single row into the table: "survey_year" */
  insert_survey_year_one?: Maybe<Survey_Year>;
  /** insert data into the table: "surveys" */
  insert_surveys?: Maybe<Surveys_Mutation_Response>;
  /** insert a single row into the table: "surveys" */
  insert_surveys_one?: Maybe<Surveys>;
  /** insert data into the table: "template" */
  insert_template?: Maybe<Template_Mutation_Response>;
  /** insert data into the table: "template_category" */
  insert_template_category?: Maybe<Template_Category_Mutation_Response>;
  /** insert data into the table: "template_category_allowed_groups" */
  insert_template_category_allowed_groups?: Maybe<Template_Category_Allowed_Groups_Mutation_Response>;
  /** insert a single row into the table: "template_category_allowed_groups" */
  insert_template_category_allowed_groups_one?: Maybe<Template_Category_Allowed_Groups>;
  /** insert data into the table: "template_category_allowed_parameter_categories" */
  insert_template_category_allowed_parameter_categories?: Maybe<Template_Category_Allowed_Parameter_Categories_Mutation_Response>;
  /** insert a single row into the table: "template_category_allowed_parameter_categories" */
  insert_template_category_allowed_parameter_categories_one?: Maybe<Template_Category_Allowed_Parameter_Categories>;
  /** insert a single row into the table: "template_category" */
  insert_template_category_one?: Maybe<Template_Category>;
  /** insert data into the table: "template_company" */
  insert_template_company?: Maybe<Template_Company_Mutation_Response>;
  /** insert a single row into the table: "template_company" */
  insert_template_company_one?: Maybe<Template_Company>;
  /** insert data into the table: "template_departments" */
  insert_template_departments?: Maybe<Template_Departments_Mutation_Response>;
  /** insert a single row into the table: "template_departments" */
  insert_template_departments_one?: Maybe<Template_Departments>;
  /** insert data into the table: "template_evaluation" */
  insert_template_evaluation?: Maybe<Template_Evaluation_Mutation_Response>;
  /** insert data into the table: "template_evaluation_config" */
  insert_template_evaluation_config?: Maybe<Template_Evaluation_Config_Mutation_Response>;
  /** insert a single row into the table: "template_evaluation_config" */
  insert_template_evaluation_config_one?: Maybe<Template_Evaluation_Config>;
  /** insert a single row into the table: "template_evaluation" */
  insert_template_evaluation_one?: Maybe<Template_Evaluation>;
  /** insert data into the table: "template_evaluation_templates" */
  insert_template_evaluation_templates?: Maybe<Template_Evaluation_Templates_Mutation_Response>;
  /** insert a single row into the table: "template_evaluation_templates" */
  insert_template_evaluation_templates_one?: Maybe<Template_Evaluation_Templates>;
  /** insert a single row into the table: "template" */
  insert_template_one?: Maybe<Template>;
  /** insert data into the table: "template_parameter" */
  insert_template_parameter?: Maybe<Template_Parameter_Mutation_Response>;
  /** insert data into the table: "template_parameter_config" */
  insert_template_parameter_config?: Maybe<Template_Parameter_Config_Mutation_Response>;
  /** insert a single row into the table: "template_parameter_config" */
  insert_template_parameter_config_one?: Maybe<Template_Parameter_Config>;
  /** insert a single row into the table: "template_parameter" */
  insert_template_parameter_one?: Maybe<Template_Parameter>;
  /** insert data into the table: "template_parameter_standard" */
  insert_template_parameter_standard?: Maybe<Template_Parameter_Standard_Mutation_Response>;
  /** insert data into the table: "template_parameter_standard_attachments" */
  insert_template_parameter_standard_attachments?: Maybe<Template_Parameter_Standard_Attachments_Mutation_Response>;
  /** insert a single row into the table: "template_parameter_standard_attachments" */
  insert_template_parameter_standard_attachments_one?: Maybe<Template_Parameter_Standard_Attachments>;
  /** insert data into the table: "template_parameter_standard_group" */
  insert_template_parameter_standard_group?: Maybe<Template_Parameter_Standard_Group_Mutation_Response>;
  /** insert a single row into the table: "template_parameter_standard_group" */
  insert_template_parameter_standard_group_one?: Maybe<Template_Parameter_Standard_Group>;
  /** insert a single row into the table: "template_parameter_standard" */
  insert_template_parameter_standard_one?: Maybe<Template_Parameter_Standard>;
  /** insert data into the table: "template_quality_stages" */
  insert_template_quality_stages?: Maybe<Template_Quality_Stages_Mutation_Response>;
  /** insert a single row into the table: "template_quality_stages" */
  insert_template_quality_stages_one?: Maybe<Template_Quality_Stages>;
  /** insert data into the table: "trade" */
  insert_trade?: Maybe<Trade_Mutation_Response>;
  /** insert data into the table: "trade_attachments" */
  insert_trade_attachments?: Maybe<Trade_Attachments_Mutation_Response>;
  /** insert a single row into the table: "trade_attachments" */
  insert_trade_attachments_one?: Maybe<Trade_Attachments>;
  /** insert data into the table: "trade_buyer_gst_attachments" */
  insert_trade_buyer_gst_attachments?: Maybe<Trade_Buyer_Gst_Attachments_Mutation_Response>;
  /** insert a single row into the table: "trade_buyer_gst_attachments" */
  insert_trade_buyer_gst_attachments_one?: Maybe<Trade_Buyer_Gst_Attachments>;
  /** insert data into the table: "trade_item" */
  insert_trade_item?: Maybe<Trade_Item_Mutation_Response>;
  /** insert a single row into the table: "trade_item" */
  insert_trade_item_one?: Maybe<Trade_Item>;
  /** insert a single row into the table: "trade" */
  insert_trade_one?: Maybe<Trade>;
  /** insert data into the table: "trade_seller_gst_attachments" */
  insert_trade_seller_gst_attachments?: Maybe<Trade_Seller_Gst_Attachments_Mutation_Response>;
  /** insert a single row into the table: "trade_seller_gst_attachments" */
  insert_trade_seller_gst_attachments_one?: Maybe<Trade_Seller_Gst_Attachments>;
  /** insert data into the table: "trade_taxes" */
  insert_trade_taxes?: Maybe<Trade_Taxes_Mutation_Response>;
  /** insert a single row into the table: "trade_taxes" */
  insert_trade_taxes_one?: Maybe<Trade_Taxes>;
  /** insert data into the table: "transaction" */
  insert_transaction?: Maybe<Transaction_Mutation_Response>;
  /** insert data into the table: "transaction_attachments" */
  insert_transaction_attachments?: Maybe<Transaction_Attachments_Mutation_Response>;
  /** insert a single row into the table: "transaction_attachments" */
  insert_transaction_attachments_one?: Maybe<Transaction_Attachments>;
  /** insert a single row into the table: "transaction" */
  insert_transaction_one?: Maybe<Transaction>;
  /** insert data into the table: "transactions" */
  insert_transactions?: Maybe<Transactions_Mutation_Response>;
  /** insert data into the table: "transactions_attachments" */
  insert_transactions_attachments?: Maybe<Transactions_Attachments_Mutation_Response>;
  /** insert a single row into the table: "transactions_attachments" */
  insert_transactions_attachments_one?: Maybe<Transactions_Attachments>;
  /** insert a single row into the table: "transactions" */
  insert_transactions_one?: Maybe<Transactions>;
  /** insert data into the table: "transition" */
  insert_transition?: Maybe<Transition_Mutation_Response>;
  /** insert data into the table: "transition_access" */
  insert_transition_access?: Maybe<Transition_Access_Mutation_Response>;
  /** insert a single row into the table: "transition_access" */
  insert_transition_access_one?: Maybe<Transition_Access>;
  /** insert data into the table: "transition_history" */
  insert_transition_history?: Maybe<Transition_History_Mutation_Response>;
  /** insert data into the table: "transition_history_attribute" */
  insert_transition_history_attribute?: Maybe<Transition_History_Attribute_Mutation_Response>;
  /** insert a single row into the table: "transition_history_attribute" */
  insert_transition_history_attribute_one?: Maybe<Transition_History_Attribute>;
  /** insert a single row into the table: "transition_history" */
  insert_transition_history_one?: Maybe<Transition_History>;
  /** insert a single row into the table: "transition" */
  insert_transition_one?: Maybe<Transition>;
  /** insert data into the table: "unit" */
  insert_unit?: Maybe<Unit_Mutation_Response>;
  /** insert data into the table: "unit_measure" */
  insert_unit_measure?: Maybe<Unit_Measure_Mutation_Response>;
  /** insert a single row into the table: "unit_measure" */
  insert_unit_measure_one?: Maybe<Unit_Measure>;
  /** insert a single row into the table: "unit" */
  insert_unit_one?: Maybe<Unit>;
  /** insert data into the table: "variety_agreement" */
  insert_variety_agreement?: Maybe<Variety_Agreement_Mutation_Response>;
  /** insert data into the table: "variety_agreement_agreement_co_owners" */
  insert_variety_agreement_agreement_co_owners?: Maybe<Variety_Agreement_Agreement_Co_Owners_Mutation_Response>;
  /** insert a single row into the table: "variety_agreement_agreement_co_owners" */
  insert_variety_agreement_agreement_co_owners_one?: Maybe<Variety_Agreement_Agreement_Co_Owners>;
  /** insert data into the table: "variety_agreement_guarantor_agreements" */
  insert_variety_agreement_guarantor_agreements?: Maybe<Variety_Agreement_Guarantor_Agreements_Mutation_Response>;
  /** insert a single row into the table: "variety_agreement_guarantor_agreements" */
  insert_variety_agreement_guarantor_agreements_one?: Maybe<Variety_Agreement_Guarantor_Agreements>;
  /** insert a single row into the table: "variety_agreement" */
  insert_variety_agreement_one?: Maybe<Variety_Agreement>;
  /** insert data into the table: "variety_grade" */
  insert_variety_grade?: Maybe<Variety_Grade_Mutation_Response>;
  /** insert a single row into the table: "variety_grade" */
  insert_variety_grade_one?: Maybe<Variety_Grade>;
  /** insert data into the table: "variety_grade_photos" */
  insert_variety_grade_photos?: Maybe<Variety_Grade_Photos_Mutation_Response>;
  /** insert a single row into the table: "variety_grade_photos" */
  insert_variety_grade_photos_one?: Maybe<Variety_Grade_Photos>;
  /** insert data into the table: "variety_group" */
  insert_variety_group?: Maybe<Variety_Group_Mutation_Response>;
  /** insert a single row into the table: "variety_group" */
  insert_variety_group_one?: Maybe<Variety_Group>;
  /** insert data into the table: "vt_core_tax" */
  insert_vt_core_tax?: Maybe<Vt_Core_Tax_Mutation_Response>;
  /** insert a single row into the table: "vt_core_tax" */
  insert_vt_core_tax_one?: Maybe<Vt_Core_Tax>;
  /** insert data into the table: "weather_reference" */
  insert_weather_reference?: Maybe<Weather_Reference_Mutation_Response>;
  /** insert a single row into the table: "weather_reference" */
  insert_weather_reference_one?: Maybe<Weather_Reference>;
  /** insert data into the table: "workflow" */
  insert_workflow?: Maybe<Workflow_Mutation_Response>;
  /** insert data into the table: "workflow_current_logs" */
  insert_workflow_current_logs?: Maybe<Workflow_Current_Logs_Mutation_Response>;
  /** insert a single row into the table: "workflow_current_logs" */
  insert_workflow_current_logs_one?: Maybe<Workflow_Current_Logs>;
  /** insert a single row into the table: "workflow" */
  insert_workflow_one?: Maybe<Workflow>;
  /** insert data into the table: "workflows" */
  insert_workflows?: Maybe<Workflows_Mutation_Response>;
  /** insert a single row into the table: "workflows" */
  insert_workflows_one?: Maybe<Workflows>;
  /**
   * This mutation will mostly be used to quickly set and send passwords
   * to all the users of a mutual group.
   */
  invite_all_users_for_mutual_group?: Maybe<MutualGroupSendPasswordMutation>;
  /**
   * This mutation will mostly be used to quickly set and send passwords
   * to a user.
   */
  invite_user?: Maybe<BaseUserSendPasswordMutation>;
  login?: Maybe<Login>;
  make_transition?: Maybe<MakeTransitionMutation>;
  map_invoice_transaction?: Maybe<MapInvoiceTransactionMutation>;
  map_invoice_transaction_many?: Maybe<MapInvoiceTransactionManyMutation>;
  map_receipt_transaction?: Maybe<MapReceiptTransactionMutation>;
  map_receipt_transaction_many?: Maybe<MapReceiptTransactionManyMutation>;
  map_trade_transaction?: Maybe<MapTradeTransactionMutation>;
  map_trade_transaction_many?: Maybe<MapTradeTransactionManyMutation>;
  mutual_group_network_assign?: Maybe<MutualGroupNetworkAssignMutation>;
  onboard_plot_crop?: Maybe<OnboardPlot>;
  place_order?: Maybe<PlaceOrder>;
  receipt_final_trades?: Maybe<ReceiptFinalTradesMutation>;
  record_crop_milestone?: Maybe<RecordCropMilestone>;
  record_expense?: Maybe<RecordExpenseMutation>;
  record_expense_v2?: Maybe<RecordExpenseMutationV2>;
  record_growth_stage?: Maybe<RecordGrowthStage>;
  record_income?: Maybe<RecordIncomeMutation>;
  record_income_v2?: Maybe<RecordIncomeMutationV2>;
  record_trade_return?: Maybe<RecordTradeReturnMutation>;
  refresh_token?: Maybe<Refresh>;
  request_advance_payment?: Maybe<RequestAdvancePaymentMutation>;
  send_notification?: Maybe<SendNotification>;
  set_base_user_fields?: Maybe<SetBaseUserFieldsMutation>;
  set_brand_fields?: Maybe<SetBrandFieldsMutation>;
  set_budget?: Maybe<SetBudgetMutation>;
  set_budget_v2?: Maybe<SetBudgetMutationV2>;
  set_business_fields?: Maybe<SetBusinessFieldsMutation>;
  set_document_attachments?: Maybe<SetDocumentAttachmentsMutation>;
  set_grade_fields?: Maybe<SetGradeFieldsMutation>;
  set_payment_detail_attachments?: Maybe<SetPaymentDetailAttachmentsMutation>;
  set_user_language?: Maybe<SetUserLanguage>;
  shift_production_trade_to_storage?: Maybe<ProductionTradeToStorageMutation>;
  submit_observations?: Maybe<SubmitObservations>;
  switch_department?: Maybe<SwitchDepartmentMutation>;
  template_toggle?: Maybe<TemplateToggleMutation>;
  template_upsert?: Maybe<TemplateUpsertMutation>;
  /** update data of the table: "action_log" */
  update_action_log?: Maybe<Action_Log_Mutation_Response>;
  /** update single row of the table: "action_log" */
  update_action_log_by_pk?: Maybe<Action_Log>;
  /** update multiples rows of table: "action_log" */
  update_action_log_many?: Maybe<Array<Maybe<Action_Log_Mutation_Response>>>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "advance_payment" */
  update_advance_payment?: Maybe<Advance_Payment_Mutation_Response>;
  /** update single row of the table: "advance_payment" */
  update_advance_payment_by_pk?: Maybe<Advance_Payment>;
  /** update multiples rows of table: "advance_payment" */
  update_advance_payment_many?: Maybe<Array<Maybe<Advance_Payment_Mutation_Response>>>;
  /** update data of the table: "agent" */
  update_agent?: Maybe<Agent_Mutation_Response>;
  /** update single row of the table: "agent" */
  update_agent_by_pk?: Maybe<Agent>;
  /** update data of the table: "agent_company" */
  update_agent_company?: Maybe<Agent_Company_Mutation_Response>;
  /** update single row of the table: "agent_company" */
  update_agent_company_by_pk?: Maybe<Agent_Company>;
  /** update multiples rows of table: "agent_company" */
  update_agent_company_many?: Maybe<Array<Maybe<Agent_Company_Mutation_Response>>>;
  /** update multiples rows of table: "agent" */
  update_agent_many?: Maybe<Array<Maybe<Agent_Mutation_Response>>>;
  /** update data of the table: "agent_role" */
  update_agent_role?: Maybe<Agent_Role_Mutation_Response>;
  /** update single row of the table: "agent_role" */
  update_agent_role_by_pk?: Maybe<Agent_Role>;
  /** update multiples rows of table: "agent_role" */
  update_agent_role_many?: Maybe<Array<Maybe<Agent_Role_Mutation_Response>>>;
  /** update data of the table: "agreement_co_owner" */
  update_agreement_co_owner?: Maybe<Agreement_Co_Owner_Mutation_Response>;
  /** update data of the table: "agreement_co_owner_agreement_invoices" */
  update_agreement_co_owner_agreement_invoices?: Maybe<Agreement_Co_Owner_Agreement_Invoices_Mutation_Response>;
  /** update single row of the table: "agreement_co_owner_agreement_invoices" */
  update_agreement_co_owner_agreement_invoices_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Invoices>;
  /** update multiples rows of table: "agreement_co_owner_agreement_invoices" */
  update_agreement_co_owner_agreement_invoices_many?: Maybe<Array<Maybe<Agreement_Co_Owner_Agreement_Invoices_Mutation_Response>>>;
  /** update data of the table: "agreement_co_owner_agreement_plots" */
  update_agreement_co_owner_agreement_plots?: Maybe<Agreement_Co_Owner_Agreement_Plots_Mutation_Response>;
  /** update single row of the table: "agreement_co_owner_agreement_plots" */
  update_agreement_co_owner_agreement_plots_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Plots>;
  /** update multiples rows of table: "agreement_co_owner_agreement_plots" */
  update_agreement_co_owner_agreement_plots_many?: Maybe<Array<Maybe<Agreement_Co_Owner_Agreement_Plots_Mutation_Response>>>;
  /** update single row of the table: "agreement_co_owner" */
  update_agreement_co_owner_by_pk?: Maybe<Agreement_Co_Owner>;
  /** update data of the table: "agreement_co_owner_legal_agreement" */
  update_agreement_co_owner_legal_agreement?: Maybe<Agreement_Co_Owner_Legal_Agreement_Mutation_Response>;
  /** update single row of the table: "agreement_co_owner_legal_agreement" */
  update_agreement_co_owner_legal_agreement_by_pk?: Maybe<Agreement_Co_Owner_Legal_Agreement>;
  /** update multiples rows of table: "agreement_co_owner_legal_agreement" */
  update_agreement_co_owner_legal_agreement_many?: Maybe<Array<Maybe<Agreement_Co_Owner_Legal_Agreement_Mutation_Response>>>;
  /** update multiples rows of table: "agreement_co_owner" */
  update_agreement_co_owner_many?: Maybe<Array<Maybe<Agreement_Co_Owner_Mutation_Response>>>;
  /** update data of the table: "agreement_invoice" */
  update_agreement_invoice?: Maybe<Agreement_Invoice_Mutation_Response>;
  /** update data of the table: "agreement_invoice_agreement_invoice_items" */
  update_agreement_invoice_agreement_invoice_items?: Maybe<Agreement_Invoice_Agreement_Invoice_Items_Mutation_Response>;
  /** update single row of the table: "agreement_invoice_agreement_invoice_items" */
  update_agreement_invoice_agreement_invoice_items_by_pk?: Maybe<Agreement_Invoice_Agreement_Invoice_Items>;
  /** update multiples rows of table: "agreement_invoice_agreement_invoice_items" */
  update_agreement_invoice_agreement_invoice_items_many?: Maybe<Array<Maybe<Agreement_Invoice_Agreement_Invoice_Items_Mutation_Response>>>;
  /** update single row of the table: "agreement_invoice" */
  update_agreement_invoice_by_pk?: Maybe<Agreement_Invoice>;
  /** update data of the table: "agreement_invoice_item" */
  update_agreement_invoice_item?: Maybe<Agreement_Invoice_Item_Mutation_Response>;
  /** update single row of the table: "agreement_invoice_item" */
  update_agreement_invoice_item_by_pk?: Maybe<Agreement_Invoice_Item>;
  /** update multiples rows of table: "agreement_invoice_item" */
  update_agreement_invoice_item_many?: Maybe<Array<Maybe<Agreement_Invoice_Item_Mutation_Response>>>;
  /** update multiples rows of table: "agreement_invoice" */
  update_agreement_invoice_many?: Maybe<Array<Maybe<Agreement_Invoice_Mutation_Response>>>;
  /** update data of the table: "agreement_invoice_transaction" */
  update_agreement_invoice_transaction?: Maybe<Agreement_Invoice_Transaction_Mutation_Response>;
  /** update single row of the table: "agreement_invoice_transaction" */
  update_agreement_invoice_transaction_by_pk?: Maybe<Agreement_Invoice_Transaction>;
  /** update multiples rows of table: "agreement_invoice_transaction" */
  update_agreement_invoice_transaction_many?: Maybe<Array<Maybe<Agreement_Invoice_Transaction_Mutation_Response>>>;
  /** update data of the table: "agreement_plot" */
  update_agreement_plot?: Maybe<Agreement_Plot_Mutation_Response>;
  /** update single row of the table: "agreement_plot" */
  update_agreement_plot_by_pk?: Maybe<Agreement_Plot>;
  /** update multiples rows of table: "agreement_plot" */
  update_agreement_plot_many?: Maybe<Array<Maybe<Agreement_Plot_Mutation_Response>>>;
  /** update data of the table: "amendment_case" */
  update_amendment_case?: Maybe<Amendment_Case_Mutation_Response>;
  /** update single row of the table: "amendment_case" */
  update_amendment_case_by_pk?: Maybe<Amendment_Case>;
  /** update multiples rows of table: "amendment_case" */
  update_amendment_case_many?: Maybe<Array<Maybe<Amendment_Case_Mutation_Response>>>;
  /** update data of the table: "auth_group" */
  update_auth_group?: Maybe<Auth_Group_Mutation_Response>;
  /** update single row of the table: "auth_group" */
  update_auth_group_by_pk?: Maybe<Auth_Group>;
  /** update multiples rows of table: "auth_group" */
  update_auth_group_many?: Maybe<Array<Maybe<Auth_Group_Mutation_Response>>>;
  /** update data of the table: "auth_group_permissions" */
  update_auth_group_permissions?: Maybe<Auth_Group_Permissions_Mutation_Response>;
  /** update single row of the table: "auth_group_permissions" */
  update_auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** update multiples rows of table: "auth_group_permissions" */
  update_auth_group_permissions_many?: Maybe<Array<Maybe<Auth_Group_Permissions_Mutation_Response>>>;
  /** update data of the table: "auth_permission" */
  update_auth_permission?: Maybe<Auth_Permission_Mutation_Response>;
  /** update single row of the table: "auth_permission" */
  update_auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** update multiples rows of table: "auth_permission" */
  update_auth_permission_many?: Maybe<Array<Maybe<Auth_Permission_Mutation_Response>>>;
  /** update data of the table: "base_user" */
  update_base_user?: Maybe<Base_User_Mutation_Response>;
  /** update data of the table: "base_user_address_book" */
  update_base_user_address_book?: Maybe<Base_User_Address_Book_Mutation_Response>;
  /** update single row of the table: "base_user_address_book" */
  update_base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** update multiples rows of table: "base_user_address_book" */
  update_base_user_address_book_many?: Maybe<Array<Maybe<Base_User_Address_Book_Mutation_Response>>>;
  /** update single row of the table: "base_user" */
  update_base_user_by_pk?: Maybe<Base_User>;
  /** update data of the table: "base_user_companies" */
  update_base_user_companies?: Maybe<Base_User_Companies_Mutation_Response>;
  /** update single row of the table: "base_user_companies" */
  update_base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  /** update multiples rows of table: "base_user_companies" */
  update_base_user_companies_many?: Maybe<Array<Maybe<Base_User_Companies_Mutation_Response>>>;
  /** update data of the table: "base_user_departments" */
  update_base_user_departments?: Maybe<Base_User_Departments_Mutation_Response>;
  /** update single row of the table: "base_user_departments" */
  update_base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  /** update multiples rows of table: "base_user_departments" */
  update_base_user_departments_many?: Maybe<Array<Maybe<Base_User_Departments_Mutation_Response>>>;
  /** update data of the table: "base_user_groups" */
  update_base_user_groups?: Maybe<Base_User_Groups_Mutation_Response>;
  /** update single row of the table: "base_user_groups" */
  update_base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** update multiples rows of table: "base_user_groups" */
  update_base_user_groups_many?: Maybe<Array<Maybe<Base_User_Groups_Mutation_Response>>>;
  /** update multiples rows of table: "base_user" */
  update_base_user_many?: Maybe<Array<Maybe<Base_User_Mutation_Response>>>;
  /** update data of the table: "base_user_network" */
  update_base_user_network?: Maybe<Base_User_Network_Mutation_Response>;
  /** update single row of the table: "base_user_network" */
  update_base_user_network_by_pk?: Maybe<Base_User_Network>;
  /** update multiples rows of table: "base_user_network" */
  update_base_user_network_many?: Maybe<Array<Maybe<Base_User_Network_Mutation_Response>>>;
  /** update data of the table: "base_user_user_permissions" */
  update_base_user_user_permissions?: Maybe<Base_User_User_Permissions_Mutation_Response>;
  /** update single row of the table: "base_user_user_permissions" */
  update_base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  /** update multiples rows of table: "base_user_user_permissions" */
  update_base_user_user_permissions_many?: Maybe<Array<Maybe<Base_User_User_Permissions_Mutation_Response>>>;
  update_booking_status?: Maybe<UpdateBookingStatus>;
  /** update data of the table: "brand" */
  update_brand?: Maybe<Brand_Mutation_Response>;
  /** update single row of the table: "brand" */
  update_brand_by_pk?: Maybe<Brand>;
  /** update data of the table: "brand_company" */
  update_brand_company?: Maybe<Brand_Company_Mutation_Response>;
  /** update single row of the table: "brand_company" */
  update_brand_company_by_pk?: Maybe<Brand_Company>;
  /** update multiples rows of table: "brand_company" */
  update_brand_company_many?: Maybe<Array<Maybe<Brand_Company_Mutation_Response>>>;
  /** update multiples rows of table: "brand" */
  update_brand_many?: Maybe<Array<Maybe<Brand_Mutation_Response>>>;
  /** update data of the table: "breeder" */
  update_breeder?: Maybe<Breeder_Mutation_Response>;
  /** update single row of the table: "breeder" */
  update_breeder_by_pk?: Maybe<Breeder>;
  /** update multiples rows of table: "breeder" */
  update_breeder_many?: Maybe<Array<Maybe<Breeder_Mutation_Response>>>;
  /** update data of the table: "business" */
  update_business?: Maybe<Business_Mutation_Response>;
  /** update single row of the table: "business" */
  update_business_by_pk?: Maybe<Business>;
  /** update data of the table: "business_commodities_supplied" */
  update_business_commodities_supplied?: Maybe<Business_Commodities_Supplied_Mutation_Response>;
  /** update single row of the table: "business_commodities_supplied" */
  update_business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** update multiples rows of table: "business_commodities_supplied" */
  update_business_commodities_supplied_many?: Maybe<Array<Maybe<Business_Commodities_Supplied_Mutation_Response>>>;
  /** update data of the table: "business_companies" */
  update_business_companies?: Maybe<Business_Companies_Mutation_Response>;
  /** update single row of the table: "business_companies" */
  update_business_companies_by_pk?: Maybe<Business_Companies>;
  /** update multiples rows of table: "business_companies" */
  update_business_companies_many?: Maybe<Array<Maybe<Business_Companies_Mutation_Response>>>;
  /** update data of the table: "business_field" */
  update_business_field?: Maybe<Business_Field_Mutation_Response>;
  /** update single row of the table: "business_field" */
  update_business_field_by_pk?: Maybe<Business_Field>;
  /** update multiples rows of table: "business_field" */
  update_business_field_many?: Maybe<Array<Maybe<Business_Field_Mutation_Response>>>;
  /** update data of the table: "business_group" */
  update_business_group?: Maybe<Business_Group_Mutation_Response>;
  /** update single row of the table: "business_group" */
  update_business_group_by_pk?: Maybe<Business_Group>;
  /** update multiples rows of table: "business_group" */
  update_business_group_many?: Maybe<Array<Maybe<Business_Group_Mutation_Response>>>;
  /** update data of the table: "business_group_network" */
  update_business_group_network?: Maybe<Business_Group_Network_Mutation_Response>;
  /** update single row of the table: "business_group_network" */
  update_business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** update multiples rows of table: "business_group_network" */
  update_business_group_network_many?: Maybe<Array<Maybe<Business_Group_Network_Mutation_Response>>>;
  /** update data of the table: "business_groups" */
  update_business_groups?: Maybe<Business_Groups_Mutation_Response>;
  /** update single row of the table: "business_groups" */
  update_business_groups_by_pk?: Maybe<Business_Groups>;
  /** update multiples rows of table: "business_groups" */
  update_business_groups_many?: Maybe<Array<Maybe<Business_Groups_Mutation_Response>>>;
  /** update multiples rows of table: "business" */
  update_business_many?: Maybe<Array<Maybe<Business_Mutation_Response>>>;
  /** update data of the table: "business_network" */
  update_business_network?: Maybe<Business_Network_Mutation_Response>;
  /** update single row of the table: "business_network" */
  update_business_network_by_pk?: Maybe<Business_Network>;
  /** update multiples rows of table: "business_network" */
  update_business_network_many?: Maybe<Array<Maybe<Business_Network_Mutation_Response>>>;
  /** update data of the table: "business_secondary_pocs" */
  update_business_secondary_pocs?: Maybe<Business_Secondary_Pocs_Mutation_Response>;
  /** update single row of the table: "business_secondary_pocs" */
  update_business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  /** update multiples rows of table: "business_secondary_pocs" */
  update_business_secondary_pocs_many?: Maybe<Array<Maybe<Business_Secondary_Pocs_Mutation_Response>>>;
  /** update single row of the table: "address" */
  update_by_pk_eagle_address?: Maybe<Eagle_Address>;
  /** update single row of the table: "media" */
  update_by_pk_eagle_media?: Maybe<Eagle_Media>;
  /** update single row of the table: "shared_entity" */
  update_by_pk_setu_trade_shared_entity?: Maybe<Setu_Trade_Shared_Entity>;
  /** update single row of the table: "media" */
  update_by_pk_setutrade_media?: Maybe<Setutrade_Media>;
  /** update data of the table: "commodity" */
  update_commodity?: Maybe<Commodity_Mutation_Response>;
  /** update single row of the table: "commodity" */
  update_commodity_by_pk?: Maybe<Commodity>;
  /** update multiples rows of table: "commodity" */
  update_commodity_many?: Maybe<Array<Maybe<Commodity_Mutation_Response>>>;
  /** update data of the table: "commodity_variety" */
  update_commodity_variety?: Maybe<Commodity_Variety_Mutation_Response>;
  /** update single row of the table: "commodity_variety" */
  update_commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** update multiples rows of table: "commodity_variety" */
  update_commodity_variety_many?: Maybe<Array<Maybe<Commodity_Variety_Mutation_Response>>>;
  /** update data of the table: "commodity_variety_secondary_groups" */
  update_commodity_variety_secondary_groups?: Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>;
  /** update single row of the table: "commodity_variety_secondary_groups" */
  update_commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** update multiples rows of table: "commodity_variety_secondary_groups" */
  update_commodity_variety_secondary_groups_many?: Maybe<Array<Maybe<Commodity_Variety_Secondary_Groups_Mutation_Response>>>;
  /** update data of the table: "company" */
  update_company?: Maybe<Company_Mutation_Response>;
  /** update single row of the table: "company" */
  update_company_by_pk?: Maybe<Company>;
  /** update data of the table: "company_categories" */
  update_company_categories?: Maybe<Company_Categories_Mutation_Response>;
  /** update single row of the table: "company_categories" */
  update_company_categories_by_pk?: Maybe<Company_Categories>;
  /** update multiples rows of table: "company_categories" */
  update_company_categories_many?: Maybe<Array<Maybe<Company_Categories_Mutation_Response>>>;
  /** update data of the table: "company_category" */
  update_company_category?: Maybe<Company_Category_Mutation_Response>;
  /** update single row of the table: "company_category" */
  update_company_category_by_pk?: Maybe<Company_Category>;
  /** update multiples rows of table: "company_category" */
  update_company_category_many?: Maybe<Array<Maybe<Company_Category_Mutation_Response>>>;
  /** update multiples rows of table: "company" */
  update_company_many?: Maybe<Array<Maybe<Company_Mutation_Response>>>;
  /** update data of the table: "company_share_holder" */
  update_company_share_holder?: Maybe<Company_Share_Holder_Mutation_Response>;
  /** update single row of the table: "company_share_holder" */
  update_company_share_holder_by_pk?: Maybe<Company_Share_Holder>;
  /** update multiples rows of table: "company_share_holder" */
  update_company_share_holder_many?: Maybe<Array<Maybe<Company_Share_Holder_Mutation_Response>>>;
  /** update data of the table: "credit_note" */
  update_credit_note?: Maybe<Credit_Note_Mutation_Response>;
  /** update single row of the table: "credit_note" */
  update_credit_note_by_pk?: Maybe<Credit_Note>;
  /** update multiples rows of table: "credit_note" */
  update_credit_note_many?: Maybe<Array<Maybe<Credit_Note_Mutation_Response>>>;
  /** update data of the table: "crop" */
  update_crop?: Maybe<Crop_Mutation_Response>;
  /** update single row of the table: "crop" */
  update_crop_by_pk?: Maybe<Crop>;
  /** update data of the table: "crop_group" */
  update_crop_group?: Maybe<Crop_Group_Mutation_Response>;
  /** update single row of the table: "crop_group" */
  update_crop_group_by_pk?: Maybe<Crop_Group>;
  /** update multiples rows of table: "crop_group" */
  update_crop_group_many?: Maybe<Array<Maybe<Crop_Group_Mutation_Response>>>;
  /** update data of the table: "crop_infestation" */
  update_crop_infestation?: Maybe<Crop_Infestation_Mutation_Response>;
  /** update data of the table: "crop_infestation_attachment" */
  update_crop_infestation_attachment?: Maybe<Crop_Infestation_Attachment_Mutation_Response>;
  /** update single row of the table: "crop_infestation_attachment" */
  update_crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** update multiples rows of table: "crop_infestation_attachment" */
  update_crop_infestation_attachment_many?: Maybe<Array<Maybe<Crop_Infestation_Attachment_Mutation_Response>>>;
  /** update single row of the table: "crop_infestation" */
  update_crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  /** update multiples rows of table: "crop_infestation" */
  update_crop_infestation_many?: Maybe<Array<Maybe<Crop_Infestation_Mutation_Response>>>;
  /** update multiples rows of table: "crop" */
  update_crop_many?: Maybe<Array<Maybe<Crop_Mutation_Response>>>;
  /** update data of the table: "crop_milestone" */
  update_crop_milestone?: Maybe<Crop_Milestone_Mutation_Response>;
  /** update single row of the table: "crop_milestone" */
  update_crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** update multiples rows of table: "crop_milestone" */
  update_crop_milestone_many?: Maybe<Array<Maybe<Crop_Milestone_Mutation_Response>>>;
  /** update data of the table: "crop_rootstock" */
  update_crop_rootstock?: Maybe<Crop_Rootstock_Mutation_Response>;
  /** update single row of the table: "crop_rootstock" */
  update_crop_rootstock_by_pk?: Maybe<Crop_Rootstock>;
  /** update multiples rows of table: "crop_rootstock" */
  update_crop_rootstock_many?: Maybe<Array<Maybe<Crop_Rootstock_Mutation_Response>>>;
  /** update data of the table: "crop_variety" */
  update_crop_variety?: Maybe<Crop_Variety_Mutation_Response>;
  /** update data of the table: "crop_variety_breeder" */
  update_crop_variety_breeder?: Maybe<Crop_Variety_Breeder_Mutation_Response>;
  /** update single row of the table: "crop_variety_breeder" */
  update_crop_variety_breeder_by_pk?: Maybe<Crop_Variety_Breeder>;
  /** update multiples rows of table: "crop_variety_breeder" */
  update_crop_variety_breeder_many?: Maybe<Array<Maybe<Crop_Variety_Breeder_Mutation_Response>>>;
  /** update single row of the table: "crop_variety" */
  update_crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** update multiples rows of table: "crop_variety" */
  update_crop_variety_many?: Maybe<Array<Maybe<Crop_Variety_Mutation_Response>>>;
  /** update data of the table: "crop_year" */
  update_crop_year?: Maybe<Crop_Year_Mutation_Response>;
  /** update single row of the table: "crop_year" */
  update_crop_year_by_pk?: Maybe<Crop_Year>;
  /** update multiples rows of table: "crop_year" */
  update_crop_year_many?: Maybe<Array<Maybe<Crop_Year_Mutation_Response>>>;
  /** update data of the table: "cultivation_type" */
  update_cultivation_type?: Maybe<Cultivation_Type_Mutation_Response>;
  /** update single row of the table: "cultivation_type" */
  update_cultivation_type_by_pk?: Maybe<Cultivation_Type>;
  /** update multiples rows of table: "cultivation_type" */
  update_cultivation_type_many?: Maybe<Array<Maybe<Cultivation_Type_Mutation_Response>>>;
  /** update data of the table: "demand" */
  update_demand?: Maybe<Demand_Mutation_Response>;
  /** update single row of the table: "demand" */
  update_demand_by_pk?: Maybe<Demand>;
  /** update multiples rows of table: "demand" */
  update_demand_many?: Maybe<Array<Maybe<Demand_Mutation_Response>>>;
  /** update data of the table: "department" */
  update_department?: Maybe<Department_Mutation_Response>;
  /** update single row of the table: "department" */
  update_department_by_pk?: Maybe<Department>;
  /** update multiples rows of table: "department" */
  update_department_many?: Maybe<Array<Maybe<Department_Mutation_Response>>>;
  /** update data of the table: "department_payment_detail" */
  update_department_payment_detail?: Maybe<Department_Payment_Detail_Mutation_Response>;
  /** update single row of the table: "department_payment_detail" */
  update_department_payment_detail_by_pk?: Maybe<Department_Payment_Detail>;
  /** update multiples rows of table: "department_payment_detail" */
  update_department_payment_detail_many?: Maybe<Array<Maybe<Department_Payment_Detail_Mutation_Response>>>;
  /** update data of the table: "department_settlements" */
  update_department_settlements?: Maybe<Department_Settlements_Mutation_Response>;
  /** update single row of the table: "department_settlements" */
  update_department_settlements_by_pk?: Maybe<Department_Settlements>;
  /** update multiples rows of table: "department_settlements" */
  update_department_settlements_many?: Maybe<Array<Maybe<Department_Settlements_Mutation_Response>>>;
  /** update data of the table: "device" */
  update_device?: Maybe<Device_Mutation_Response>;
  /** update single row of the table: "device" */
  update_device_by_pk?: Maybe<Device>;
  /** update multiples rows of table: "device" */
  update_device_many?: Maybe<Array<Maybe<Device_Mutation_Response>>>;
  /** update data of the table: "django_content_type" */
  update_django_content_type?: Maybe<Django_Content_Type_Mutation_Response>;
  /** update single row of the table: "django_content_type" */
  update_django_content_type_by_pk?: Maybe<Django_Content_Type>;
  /** update multiples rows of table: "django_content_type" */
  update_django_content_type_many?: Maybe<Array<Maybe<Django_Content_Type_Mutation_Response>>>;
  /** update data of the table: "document" */
  update_document?: Maybe<Document_Mutation_Response>;
  /** update data of the table: "document_attachments" */
  update_document_attachments?: Maybe<Document_Attachments_Mutation_Response>;
  /** update single row of the table: "document_attachments" */
  update_document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** update multiples rows of table: "document_attachments" */
  update_document_attachments_many?: Maybe<Array<Maybe<Document_Attachments_Mutation_Response>>>;
  /** update single row of the table: "document" */
  update_document_by_pk?: Maybe<Document>;
  /** update data of the table: "document_data" */
  update_document_data?: Maybe<Document_Data_Mutation_Response>;
  /** update single row of the table: "document_data" */
  update_document_data_by_pk?: Maybe<Document_Data>;
  /** update multiples rows of table: "document_data" */
  update_document_data_many?: Maybe<Array<Maybe<Document_Data_Mutation_Response>>>;
  /** update data of the table: "document_export_log" */
  update_document_export_log?: Maybe<Document_Export_Log_Mutation_Response>;
  /** update single row of the table: "document_export_log" */
  update_document_export_log_by_pk?: Maybe<Document_Export_Log>;
  /** update multiples rows of table: "document_export_log" */
  update_document_export_log_many?: Maybe<Array<Maybe<Document_Export_Log_Mutation_Response>>>;
  /** update data of the table: "document_kind" */
  update_document_kind?: Maybe<Document_Kind_Mutation_Response>;
  /** update single row of the table: "document_kind" */
  update_document_kind_by_pk?: Maybe<Document_Kind>;
  /** update data of the table: "document_kind_data_field" */
  update_document_kind_data_field?: Maybe<Document_Kind_Data_Field_Mutation_Response>;
  /** update single row of the table: "document_kind_data_field" */
  update_document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** update multiples rows of table: "document_kind_data_field" */
  update_document_kind_data_field_many?: Maybe<Array<Maybe<Document_Kind_Data_Field_Mutation_Response>>>;
  /** update multiples rows of table: "document_kind" */
  update_document_kind_many?: Maybe<Array<Maybe<Document_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "document" */
  update_document_many?: Maybe<Array<Maybe<Document_Mutation_Response>>>;
  /** update data of the table: "document_report" */
  update_document_report?: Maybe<Document_Report_Mutation_Response>;
  /** update single row of the table: "document_report" */
  update_document_report_by_pk?: Maybe<Document_Report>;
  /** update multiples rows of table: "document_report" */
  update_document_report_many?: Maybe<Array<Maybe<Document_Report_Mutation_Response>>>;
  /** update data of the table: "document_revision" */
  update_document_revision?: Maybe<Document_Revision_Mutation_Response>;
  /** update single row of the table: "document_revision" */
  update_document_revision_by_pk?: Maybe<Document_Revision>;
  /** update multiples rows of table: "document_revision" */
  update_document_revision_many?: Maybe<Array<Maybe<Document_Revision_Mutation_Response>>>;
  /** update data of the table: "address" */
  update_eagle_address?: Maybe<Eagle_Address_Mutation_Response>;
  /** update multiples rows of table: "address" */
  update_eagle_address_many?: Maybe<Array<Maybe<Eagle_Address_Mutation_Response>>>;
  /** update data of the table: "media" */
  update_eagle_media?: Maybe<Eagle_Media_Mutation_Response>;
  /** update multiples rows of table: "media" */
  update_eagle_media_many?: Maybe<Array<Maybe<Eagle_Media_Mutation_Response>>>;
  /** update data of the table: "entity_state" */
  update_entity_state?: Maybe<Entity_State_Mutation_Response>;
  /** update single row of the table: "entity_state" */
  update_entity_state_by_pk?: Maybe<Entity_State>;
  /** update multiples rows of table: "entity_state" */
  update_entity_state_many?: Maybe<Array<Maybe<Entity_State_Mutation_Response>>>;
  /** update data of the table: "evaluation_criteria" */
  update_evaluation_criteria?: Maybe<Evaluation_Criteria_Mutation_Response>;
  /** update single row of the table: "evaluation_criteria" */
  update_evaluation_criteria_by_pk?: Maybe<Evaluation_Criteria>;
  /** update multiples rows of table: "evaluation_criteria" */
  update_evaluation_criteria_many?: Maybe<Array<Maybe<Evaluation_Criteria_Mutation_Response>>>;
  /** update data of the table: "evaluation_tag" */
  update_evaluation_tag?: Maybe<Evaluation_Tag_Mutation_Response>;
  /** update single row of the table: "evaluation_tag" */
  update_evaluation_tag_by_pk?: Maybe<Evaluation_Tag>;
  /** update multiples rows of table: "evaluation_tag" */
  update_evaluation_tag_many?: Maybe<Array<Maybe<Evaluation_Tag_Mutation_Response>>>;
  /** update data of the table: "expense" */
  update_expense?: Maybe<Expense_Mutation_Response>;
  /** update single row of the table: "expense" */
  update_expense_by_pk?: Maybe<Expense>;
  /** update multiples rows of table: "expense" */
  update_expense_many?: Maybe<Array<Maybe<Expense_Mutation_Response>>>;
  /** update data of the table: "external_application" */
  update_external_application?: Maybe<External_Application_Mutation_Response>;
  /** update single row of the table: "external_application" */
  update_external_application_by_pk?: Maybe<External_Application>;
  /** update multiples rows of table: "external_application" */
  update_external_application_many?: Maybe<Array<Maybe<External_Application_Mutation_Response>>>;
  /** update data of the table: "external_entity" */
  update_external_entity?: Maybe<External_Entity_Mutation_Response>;
  /** update single row of the table: "external_entity" */
  update_external_entity_by_pk?: Maybe<External_Entity>;
  /** update data of the table: "external_entity_group" */
  update_external_entity_group?: Maybe<External_Entity_Group_Mutation_Response>;
  /** update single row of the table: "external_entity_group" */
  update_external_entity_group_by_pk?: Maybe<External_Entity_Group>;
  /** update multiples rows of table: "external_entity_group" */
  update_external_entity_group_many?: Maybe<Array<Maybe<External_Entity_Group_Mutation_Response>>>;
  /** update multiples rows of table: "external_entity" */
  update_external_entity_many?: Maybe<Array<Maybe<External_Entity_Mutation_Response>>>;
  /** update data of the table: "external_reference" */
  update_external_reference?: Maybe<External_Reference_Mutation_Response>;
  /** update single row of the table: "external_reference" */
  update_external_reference_by_pk?: Maybe<External_Reference>;
  /** update multiples rows of table: "external_reference" */
  update_external_reference_many?: Maybe<Array<Maybe<External_Reference_Mutation_Response>>>;
  /** update data of the table: "farm" */
  update_farm?: Maybe<Farm_Mutation_Response>;
  /** update single row of the table: "farm" */
  update_farm_by_pk?: Maybe<Farm>;
  /** update multiples rows of table: "farm" */
  update_farm_many?: Maybe<Array<Maybe<Farm_Mutation_Response>>>;
  /** update data of the table: "farm_network" */
  update_farm_network?: Maybe<Farm_Network_Mutation_Response>;
  /** update single row of the table: "farm_network" */
  update_farm_network_by_pk?: Maybe<Farm_Network>;
  /** update multiples rows of table: "farm_network" */
  update_farm_network_many?: Maybe<Array<Maybe<Farm_Network_Mutation_Response>>>;
  /** update data of the table: "field" */
  update_field?: Maybe<Field_Mutation_Response>;
  /** update single row of the table: "field" */
  update_field_by_pk?: Maybe<Field>;
  /** update multiples rows of table: "field" */
  update_field_many?: Maybe<Array<Maybe<Field_Mutation_Response>>>;
  /** update data of the table: "field_network" */
  update_field_network?: Maybe<Field_Network_Mutation_Response>;
  /** update single row of the table: "field_network" */
  update_field_network_by_pk?: Maybe<Field_Network>;
  /** update multiples rows of table: "field_network" */
  update_field_network_many?: Maybe<Array<Maybe<Field_Network_Mutation_Response>>>;
  /** update data of the table: "field_weather_location" */
  update_field_weather_location?: Maybe<Field_Weather_Location_Mutation_Response>;
  /** update single row of the table: "field_weather_location" */
  update_field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  /** update multiples rows of table: "field_weather_location" */
  update_field_weather_location_many?: Maybe<Array<Maybe<Field_Weather_Location_Mutation_Response>>>;
  /** update data of the table: "grade" */
  update_grade?: Maybe<Grade_Mutation_Response>;
  /** update single row of the table: "grade" */
  update_grade_by_pk?: Maybe<Grade>;
  /** update data of the table: "grade_company" */
  update_grade_company?: Maybe<Grade_Company_Mutation_Response>;
  /** update single row of the table: "grade_company" */
  update_grade_company_by_pk?: Maybe<Grade_Company>;
  /** update multiples rows of table: "grade_company" */
  update_grade_company_many?: Maybe<Array<Maybe<Grade_Company_Mutation_Response>>>;
  /** update multiples rows of table: "grade" */
  update_grade_many?: Maybe<Array<Maybe<Grade_Mutation_Response>>>;
  /** update data of the table: "grade_price" */
  update_grade_price?: Maybe<Grade_Price_Mutation_Response>;
  /** update single row of the table: "grade_price" */
  update_grade_price_by_pk?: Maybe<Grade_Price>;
  /** update multiples rows of table: "grade_price" */
  update_grade_price_many?: Maybe<Array<Maybe<Grade_Price_Mutation_Response>>>;
  /** update data of the table: "guarantor_agreement" */
  update_guarantor_agreement?: Maybe<Guarantor_Agreement_Mutation_Response>;
  /** update data of the table: "guarantor_agreement_agreement_invoices" */
  update_guarantor_agreement_agreement_invoices?: Maybe<Guarantor_Agreement_Agreement_Invoices_Mutation_Response>;
  /** update single row of the table: "guarantor_agreement_agreement_invoices" */
  update_guarantor_agreement_agreement_invoices_by_pk?: Maybe<Guarantor_Agreement_Agreement_Invoices>;
  /** update multiples rows of table: "guarantor_agreement_agreement_invoices" */
  update_guarantor_agreement_agreement_invoices_many?: Maybe<Array<Maybe<Guarantor_Agreement_Agreement_Invoices_Mutation_Response>>>;
  /** update data of the table: "guarantor_agreement_agreement_plots" */
  update_guarantor_agreement_agreement_plots?: Maybe<Guarantor_Agreement_Agreement_Plots_Mutation_Response>;
  /** update single row of the table: "guarantor_agreement_agreement_plots" */
  update_guarantor_agreement_agreement_plots_by_pk?: Maybe<Guarantor_Agreement_Agreement_Plots>;
  /** update multiples rows of table: "guarantor_agreement_agreement_plots" */
  update_guarantor_agreement_agreement_plots_many?: Maybe<Array<Maybe<Guarantor_Agreement_Agreement_Plots_Mutation_Response>>>;
  /** update data of the table: "guarantor_agreement_area_extension_detail" */
  update_guarantor_agreement_area_extension_detail?: Maybe<Guarantor_Agreement_Area_Extension_Detail_Mutation_Response>;
  /** update single row of the table: "guarantor_agreement_area_extension_detail" */
  update_guarantor_agreement_area_extension_detail_by_pk?: Maybe<Guarantor_Agreement_Area_Extension_Detail>;
  /** update multiples rows of table: "guarantor_agreement_area_extension_detail" */
  update_guarantor_agreement_area_extension_detail_many?: Maybe<Array<Maybe<Guarantor_Agreement_Area_Extension_Detail_Mutation_Response>>>;
  /** update single row of the table: "guarantor_agreement" */
  update_guarantor_agreement_by_pk?: Maybe<Guarantor_Agreement>;
  /** update multiples rows of table: "guarantor_agreement" */
  update_guarantor_agreement_many?: Maybe<Array<Maybe<Guarantor_Agreement_Mutation_Response>>>;
  /** update data of the table: "infestation" */
  update_infestation?: Maybe<Infestation_Mutation_Response>;
  /** update single row of the table: "infestation" */
  update_infestation_by_pk?: Maybe<Infestation>;
  /** update multiples rows of table: "infestation" */
  update_infestation_many?: Maybe<Array<Maybe<Infestation_Mutation_Response>>>;
  /** update data of the table: "instrument" */
  update_instrument?: Maybe<Instrument_Mutation_Response>;
  /** update single row of the table: "instrument" */
  update_instrument_by_pk?: Maybe<Instrument>;
  /** update data of the table: "instrument_departments" */
  update_instrument_departments?: Maybe<Instrument_Departments_Mutation_Response>;
  /** update single row of the table: "instrument_departments" */
  update_instrument_departments_by_pk?: Maybe<Instrument_Departments>;
  /** update multiples rows of table: "instrument_departments" */
  update_instrument_departments_many?: Maybe<Array<Maybe<Instrument_Departments_Mutation_Response>>>;
  /** update data of the table: "instrument_kind" */
  update_instrument_kind?: Maybe<Instrument_Kind_Mutation_Response>;
  /** update single row of the table: "instrument_kind" */
  update_instrument_kind_by_pk?: Maybe<Instrument_Kind>;
  /** update multiples rows of table: "instrument_kind" */
  update_instrument_kind_many?: Maybe<Array<Maybe<Instrument_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "instrument" */
  update_instrument_many?: Maybe<Array<Maybe<Instrument_Mutation_Response>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<Invoice_Mutation_Response>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "issuance_note_attachments" */
  update_issuance_note_attachments?: Maybe<Issuance_Note_Attachments_Mutation_Response>;
  /** update single row of the table: "issuance_note_attachments" */
  update_issuance_note_attachments_by_pk?: Maybe<Issuance_Note_Attachments>;
  /** update multiples rows of table: "issuance_note_attachments" */
  update_issuance_note_attachments_many?: Maybe<Array<Maybe<Issuance_Note_Attachments_Mutation_Response>>>;
  /** update data of the table: "notification" */
  update_kite_notification?: Maybe<Kite_Notification_Mutation_Response>;
  /** update single row of the table: "notification" */
  update_kite_notification_by_pk?: Maybe<Kite_Notification>;
  /** update multiples rows of table: "notification" */
  update_kite_notification_many?: Maybe<Array<Maybe<Kite_Notification_Mutation_Response>>>;
  /** update data of the table: "quality_stage" */
  update_kite_quality_stage?: Maybe<Kite_Quality_Stage_Mutation_Response>;
  /** update single row of the table: "quality_stage" */
  update_kite_quality_stage_by_pk?: Maybe<Kite_Quality_Stage>;
  /** update multiples rows of table: "quality_stage" */
  update_kite_quality_stage_many?: Maybe<Array<Maybe<Kite_Quality_Stage_Mutation_Response>>>;
  /** update data of the table: "laboratory" */
  update_laboratory?: Maybe<Laboratory_Mutation_Response>;
  /** update single row of the table: "laboratory" */
  update_laboratory_by_pk?: Maybe<Laboratory>;
  /** update multiples rows of table: "laboratory" */
  update_laboratory_many?: Maybe<Array<Maybe<Laboratory_Mutation_Response>>>;
  /** update data of the table: "laboratory_organisations" */
  update_laboratory_organisations?: Maybe<Laboratory_Organisations_Mutation_Response>;
  /** update single row of the table: "laboratory_organisations" */
  update_laboratory_organisations_by_pk?: Maybe<Laboratory_Organisations>;
  /** update multiples rows of table: "laboratory_organisations" */
  update_laboratory_organisations_many?: Maybe<Array<Maybe<Laboratory_Organisations_Mutation_Response>>>;
  /** update data of the table: "legal_agreement" */
  update_legal_agreement?: Maybe<Legal_Agreement_Mutation_Response>;
  /** update single row of the table: "legal_agreement" */
  update_legal_agreement_by_pk?: Maybe<Legal_Agreement>;
  /** update multiples rows of table: "legal_agreement" */
  update_legal_agreement_many?: Maybe<Array<Maybe<Legal_Agreement_Mutation_Response>>>;
  /** update data of the table: "market" */
  update_market?: Maybe<Market_Mutation_Response>;
  /** update data of the table: "market_allowed_departments" */
  update_market_allowed_departments?: Maybe<Market_Allowed_Departments_Mutation_Response>;
  /** update single row of the table: "market_allowed_departments" */
  update_market_allowed_departments_by_pk?: Maybe<Market_Allowed_Departments>;
  /** update multiples rows of table: "market_allowed_departments" */
  update_market_allowed_departments_many?: Maybe<Array<Maybe<Market_Allowed_Departments_Mutation_Response>>>;
  /** update single row of the table: "market" */
  update_market_by_pk?: Maybe<Market>;
  /** update multiples rows of table: "market" */
  update_market_many?: Maybe<Array<Maybe<Market_Mutation_Response>>>;
  /** update data of the table: "media" */
  update_media?: Maybe<Media_Mutation_Response>;
  /** update single row of the table: "media" */
  update_media_by_pk?: Maybe<Media>;
  /** update multiples rows of table: "media" */
  update_media_many?: Maybe<Array<Maybe<Media_Mutation_Response>>>;
  /** update data of the table: "milestone" */
  update_milestone?: Maybe<Milestone_Mutation_Response>;
  /** update single row of the table: "milestone" */
  update_milestone_by_pk?: Maybe<Milestone>;
  /** update multiples rows of table: "milestone" */
  update_milestone_many?: Maybe<Array<Maybe<Milestone_Mutation_Response>>>;
  /** update data of the table: "mutual_group" */
  update_mutual_group?: Maybe<Mutual_Group_Mutation_Response>;
  /** update single row of the table: "mutual_group" */
  update_mutual_group_by_pk?: Maybe<Mutual_Group>;
  /** update multiples rows of table: "mutual_group" */
  update_mutual_group_many?: Maybe<Array<Maybe<Mutual_Group_Mutation_Response>>>;
  /** update data of the table: "mutual_group_membership" */
  update_mutual_group_membership?: Maybe<Mutual_Group_Membership_Mutation_Response>;
  /** update single row of the table: "mutual_group_membership" */
  update_mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** update multiples rows of table: "mutual_group_membership" */
  update_mutual_group_membership_many?: Maybe<Array<Maybe<Mutual_Group_Membership_Mutation_Response>>>;
  /** update data of the table: "mutual_group_network" */
  update_mutual_group_network?: Maybe<Mutual_Group_Network_Mutation_Response>;
  /** update single row of the table: "mutual_group_network" */
  update_mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** update multiples rows of table: "mutual_group_network" */
  update_mutual_group_network_many?: Maybe<Array<Maybe<Mutual_Group_Network_Mutation_Response>>>;
  /** update data of the table: "mutual_group_role" */
  update_mutual_group_role?: Maybe<Mutual_Group_Role_Mutation_Response>;
  /** update single row of the table: "mutual_group_role" */
  update_mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** update multiples rows of table: "mutual_group_role" */
  update_mutual_group_role_many?: Maybe<Array<Maybe<Mutual_Group_Role_Mutation_Response>>>;
  /** update data of the table: "mutual_group_weather_station" */
  update_mutual_group_weather_station?: Maybe<Mutual_Group_Weather_Station_Mutation_Response>;
  /** update single row of the table: "mutual_group_weather_station" */
  update_mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  /** update multiples rows of table: "mutual_group_weather_station" */
  update_mutual_group_weather_station_many?: Maybe<Array<Maybe<Mutual_Group_Weather_Station_Mutation_Response>>>;
  /** update data of the table: "nationality" */
  update_nationality?: Maybe<Nationality_Mutation_Response>;
  /** update single row of the table: "nationality" */
  update_nationality_by_pk?: Maybe<Nationality>;
  /** update multiples rows of table: "nationality" */
  update_nationality_many?: Maybe<Array<Maybe<Nationality_Mutation_Response>>>;
  /** update data of the table: "network" */
  update_network?: Maybe<Network_Mutation_Response>;
  /** update single row of the table: "network" */
  update_network_by_pk?: Maybe<Network>;
  /** update multiples rows of table: "network" */
  update_network_many?: Maybe<Array<Maybe<Network_Mutation_Response>>>;
  /** update data of the table: "nominees" */
  update_nominees?: Maybe<Nominees_Mutation_Response>;
  /** update single row of the table: "nominees" */
  update_nominees_by_pk?: Maybe<Nominees>;
  /** update data of the table: "nominees_documents" */
  update_nominees_documents?: Maybe<Nominees_Documents_Mutation_Response>;
  /** update single row of the table: "nominees_documents" */
  update_nominees_documents_by_pk?: Maybe<Nominees_Documents>;
  /** update multiples rows of table: "nominees_documents" */
  update_nominees_documents_many?: Maybe<Array<Maybe<Nominees_Documents_Mutation_Response>>>;
  /** update multiples rows of table: "nominees" */
  update_nominees_many?: Maybe<Array<Maybe<Nominees_Mutation_Response>>>;
  /** update data of the table: "notification_provider" */
  update_notification_provider?: Maybe<Notification_Provider_Mutation_Response>;
  /** update single row of the table: "notification_provider" */
  update_notification_provider_by_pk?: Maybe<Notification_Provider>;
  /** update multiples rows of table: "notification_provider" */
  update_notification_provider_many?: Maybe<Array<Maybe<Notification_Provider_Mutation_Response>>>;
  /** update data of the table: "notification_trigger" */
  update_notification_trigger?: Maybe<Notification_Trigger_Mutation_Response>;
  /** update single row of the table: "notification_trigger" */
  update_notification_trigger_by_pk?: Maybe<Notification_Trigger>;
  /** update multiples rows of table: "notification_trigger" */
  update_notification_trigger_many?: Maybe<Array<Maybe<Notification_Trigger_Mutation_Response>>>;
  update_offer_status?: Maybe<OfferUpdateStatus>;
  /** update data of the table: "offers" */
  update_offers?: Maybe<Offers_Mutation_Response>;
  /** update single row of the table: "offers" */
  update_offers_by_pk?: Maybe<Offers>;
  /** update multiples rows of table: "offers" */
  update_offers_many?: Maybe<Array<Maybe<Offers_Mutation_Response>>>;
  /** update data of the table: "org_dashboard_stats" */
  update_org_dashboard_stats?: Maybe<Org_Dashboard_Stats_Mutation_Response>;
  /** update single row of the table: "org_dashboard_stats" */
  update_org_dashboard_stats_by_pk?: Maybe<Org_Dashboard_Stats>;
  /** update multiples rows of table: "org_dashboard_stats" */
  update_org_dashboard_stats_many?: Maybe<Array<Maybe<Org_Dashboard_Stats_Mutation_Response>>>;
  /** update data of the table: "org_team_association" */
  update_org_team_association?: Maybe<Org_Team_Association_Mutation_Response>;
  /** update single row of the table: "org_team_association" */
  update_org_team_association_by_pk?: Maybe<Org_Team_Association>;
  /** update multiples rows of table: "org_team_association" */
  update_org_team_association_many?: Maybe<Array<Maybe<Org_Team_Association_Mutation_Response>>>;
  /** update data of the table: "org_team_primary_crop" */
  update_org_team_primary_crop?: Maybe<Org_Team_Primary_Crop_Mutation_Response>;
  /** update single row of the table: "org_team_primary_crop" */
  update_org_team_primary_crop_by_pk?: Maybe<Org_Team_Primary_Crop>;
  /** update multiples rows of table: "org_team_primary_crop" */
  update_org_team_primary_crop_many?: Maybe<Array<Maybe<Org_Team_Primary_Crop_Mutation_Response>>>;
  /** update data of the table: "org_team_user_bank_association" */
  update_org_team_user_bank_association?: Maybe<Org_Team_User_Bank_Association_Mutation_Response>;
  /** update single row of the table: "org_team_user_bank_association" */
  update_org_team_user_bank_association_by_pk?: Maybe<Org_Team_User_Bank_Association>;
  /** update multiples rows of table: "org_team_user_bank_association" */
  update_org_team_user_bank_association_many?: Maybe<Array<Maybe<Org_Team_User_Bank_Association_Mutation_Response>>>;
  /** update data of the table: "org_team_user_crop" */
  update_org_team_user_crop?: Maybe<Org_Team_User_Crop_Mutation_Response>;
  /** update single row of the table: "org_team_user_crop" */
  update_org_team_user_crop_by_pk?: Maybe<Org_Team_User_Crop>;
  /** update multiples rows of table: "org_team_user_crop" */
  update_org_team_user_crop_many?: Maybe<Array<Maybe<Org_Team_User_Crop_Mutation_Response>>>;
  /** update data of the table: "org_team_user_document_association" */
  update_org_team_user_document_association?: Maybe<Org_Team_User_Document_Association_Mutation_Response>;
  /** update single row of the table: "org_team_user_document_association" */
  update_org_team_user_document_association_by_pk?: Maybe<Org_Team_User_Document_Association>;
  /** update multiples rows of table: "org_team_user_document_association" */
  update_org_team_user_document_association_many?: Maybe<Array<Maybe<Org_Team_User_Document_Association_Mutation_Response>>>;
  /** update data of the table: "org_user_association" */
  update_org_user_association?: Maybe<Org_User_Association_Mutation_Response>;
  /** update single row of the table: "org_user_association" */
  update_org_user_association_by_pk?: Maybe<Org_User_Association>;
  /** update multiples rows of table: "org_user_association" */
  update_org_user_association_many?: Maybe<Array<Maybe<Org_User_Association_Mutation_Response>>>;
  /** update data of the table: "org_user_group_mandatory_document" */
  update_org_user_group_mandatory_document?: Maybe<Org_User_Group_Mandatory_Document_Mutation_Response>;
  /** update single row of the table: "org_user_group_mandatory_document" */
  update_org_user_group_mandatory_document_by_pk?: Maybe<Org_User_Group_Mandatory_Document>;
  /** update multiples rows of table: "org_user_group_mandatory_document" */
  update_org_user_group_mandatory_document_many?: Maybe<Array<Maybe<Org_User_Group_Mandatory_Document_Mutation_Response>>>;
  /** update data of the table: "org_user_group_status_snapshot" */
  update_org_user_group_status_snapshot?: Maybe<Org_User_Group_Status_Snapshot_Mutation_Response>;
  /** update single row of the table: "org_user_group_status_snapshot" */
  update_org_user_group_status_snapshot_by_pk?: Maybe<Org_User_Group_Status_Snapshot>;
  /** update multiples rows of table: "org_user_group_status_snapshot" */
  update_org_user_group_status_snapshot_many?: Maybe<Array<Maybe<Org_User_Group_Status_Snapshot_Mutation_Response>>>;
  /** update data of the table: "org_user_primary_crop" */
  update_org_user_primary_crop?: Maybe<Org_User_Primary_Crop_Mutation_Response>;
  /** update single row of the table: "org_user_primary_crop" */
  update_org_user_primary_crop_by_pk?: Maybe<Org_User_Primary_Crop>;
  /** update multiples rows of table: "org_user_primary_crop" */
  update_org_user_primary_crop_many?: Maybe<Array<Maybe<Org_User_Primary_Crop_Mutation_Response>>>;
  /** update data of the table: "organisation" */
  update_organisation?: Maybe<Organisation_Mutation_Response>;
  /** update single row of the table: "organisation" */
  update_organisation_by_pk?: Maybe<Organisation>;
  /** update data of the table: "organisation_commodity_variety_config" */
  update_organisation_commodity_variety_config?: Maybe<Organisation_Commodity_Variety_Config_Mutation_Response>;
  /** update single row of the table: "organisation_commodity_variety_config" */
  update_organisation_commodity_variety_config_by_pk?: Maybe<Organisation_Commodity_Variety_Config>;
  /** update multiples rows of table: "organisation_commodity_variety_config" */
  update_organisation_commodity_variety_config_many?: Maybe<Array<Maybe<Organisation_Commodity_Variety_Config_Mutation_Response>>>;
  /** update data of the table: "organisation_commodity_variety_config_taxes" */
  update_organisation_commodity_variety_config_taxes?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Mutation_Response>;
  /** update single row of the table: "organisation_commodity_variety_config_taxes" */
  update_organisation_commodity_variety_config_taxes_by_pk?: Maybe<Organisation_Commodity_Variety_Config_Taxes>;
  /** update multiples rows of table: "organisation_commodity_variety_config_taxes" */
  update_organisation_commodity_variety_config_taxes_many?: Maybe<Array<Maybe<Organisation_Commodity_Variety_Config_Taxes_Mutation_Response>>>;
  /** update data of the table: "organisation_crop" */
  update_organisation_crop?: Maybe<Organisation_Crop_Mutation_Response>;
  /** update single row of the table: "organisation_crop" */
  update_organisation_crop_by_pk?: Maybe<Organisation_Crop>;
  /** update multiples rows of table: "organisation_crop" */
  update_organisation_crop_many?: Maybe<Array<Maybe<Organisation_Crop_Mutation_Response>>>;
  /** update data of the table: "organisation_document_kind" */
  update_organisation_document_kind?: Maybe<Organisation_Document_Kind_Mutation_Response>;
  /** update single row of the table: "organisation_document_kind" */
  update_organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** update multiples rows of table: "organisation_document_kind" */
  update_organisation_document_kind_many?: Maybe<Array<Maybe<Organisation_Document_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "organisation" */
  update_organisation_many?: Maybe<Array<Maybe<Organisation_Mutation_Response>>>;
  /** update data of the table: "organisation_preferences" */
  update_organisation_preferences?: Maybe<Organisation_Preferences_Mutation_Response>;
  /** update single row of the table: "organisation_preferences" */
  update_organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  /** update multiples rows of table: "organisation_preferences" */
  update_organisation_preferences_many?: Maybe<Array<Maybe<Organisation_Preferences_Mutation_Response>>>;
  /** update data of the table: "organisation_season" */
  update_organisation_season?: Maybe<Organisation_Season_Mutation_Response>;
  /** update single row of the table: "organisation_season" */
  update_organisation_season_by_pk?: Maybe<Organisation_Season>;
  /** update multiples rows of table: "organisation_season" */
  update_organisation_season_many?: Maybe<Array<Maybe<Organisation_Season_Mutation_Response>>>;
  /** update data of the table: "over_due_approval" */
  update_over_due_approval?: Maybe<Over_Due_Approval_Mutation_Response>;
  /** update single row of the table: "over_due_approval" */
  update_over_due_approval_by_pk?: Maybe<Over_Due_Approval>;
  /** update multiples rows of table: "over_due_approval" */
  update_over_due_approval_many?: Maybe<Array<Maybe<Over_Due_Approval_Mutation_Response>>>;
  /** update data of the table: "packaging_order" */
  update_packaging_order?: Maybe<Packaging_Order_Mutation_Response>;
  /** update single row of the table: "packaging_order" */
  update_packaging_order_by_pk?: Maybe<Packaging_Order>;
  /** update data of the table: "packaging_order_item" */
  update_packaging_order_item?: Maybe<Packaging_Order_Item_Mutation_Response>;
  /** update single row of the table: "packaging_order_item" */
  update_packaging_order_item_by_pk?: Maybe<Packaging_Order_Item>;
  /** update multiples rows of table: "packaging_order_item" */
  update_packaging_order_item_many?: Maybe<Array<Maybe<Packaging_Order_Item_Mutation_Response>>>;
  /** update multiples rows of table: "packaging_order" */
  update_packaging_order_many?: Maybe<Array<Maybe<Packaging_Order_Mutation_Response>>>;
  /** update data of the table: "pallet_category" */
  update_pallet_category?: Maybe<Pallet_Category_Mutation_Response>;
  /** update single row of the table: "pallet_category" */
  update_pallet_category_by_pk?: Maybe<Pallet_Category>;
  /** update multiples rows of table: "pallet_category" */
  update_pallet_category_many?: Maybe<Array<Maybe<Pallet_Category_Mutation_Response>>>;
  /** update data of the table: "pallet_customer" */
  update_pallet_customer?: Maybe<Pallet_Customer_Mutation_Response>;
  /** update single row of the table: "pallet_customer" */
  update_pallet_customer_by_pk?: Maybe<Pallet_Customer>;
  /** update multiples rows of table: "pallet_customer" */
  update_pallet_customer_many?: Maybe<Array<Maybe<Pallet_Customer_Mutation_Response>>>;
  /** update data of the table: "pallet_inspection" */
  update_pallet_inspection?: Maybe<Pallet_Inspection_Mutation_Response>;
  /** update data of the table: "pallet_inspection_attachments" */
  update_pallet_inspection_attachments?: Maybe<Pallet_Inspection_Attachments_Mutation_Response>;
  /** update single row of the table: "pallet_inspection_attachments" */
  update_pallet_inspection_attachments_by_pk?: Maybe<Pallet_Inspection_Attachments>;
  /** update multiples rows of table: "pallet_inspection_attachments" */
  update_pallet_inspection_attachments_many?: Maybe<Array<Maybe<Pallet_Inspection_Attachments_Mutation_Response>>>;
  /** update single row of the table: "pallet_inspection" */
  update_pallet_inspection_by_pk?: Maybe<Pallet_Inspection>;
  /** update multiples rows of table: "pallet_inspection" */
  update_pallet_inspection_many?: Maybe<Array<Maybe<Pallet_Inspection_Mutation_Response>>>;
  /** update data of the table: "pallet_inspection_reports" */
  update_pallet_inspection_reports?: Maybe<Pallet_Inspection_Reports_Mutation_Response>;
  /** update single row of the table: "pallet_inspection_reports" */
  update_pallet_inspection_reports_by_pk?: Maybe<Pallet_Inspection_Reports>;
  /** update multiples rows of table: "pallet_inspection_reports" */
  update_pallet_inspection_reports_many?: Maybe<Array<Maybe<Pallet_Inspection_Reports_Mutation_Response>>>;
  /** update data of the table: "pallet_inspectionkind" */
  update_pallet_inspectionkind?: Maybe<Pallet_Inspectionkind_Mutation_Response>;
  /** update single row of the table: "pallet_inspectionkind" */
  update_pallet_inspectionkind_by_pk?: Maybe<Pallet_Inspectionkind>;
  /** update multiples rows of table: "pallet_inspectionkind" */
  update_pallet_inspectionkind_many?: Maybe<Array<Maybe<Pallet_Inspectionkind_Mutation_Response>>>;
  /** update data of the table: "pallet_inspectionobservation" */
  update_pallet_inspectionobservation?: Maybe<Pallet_Inspectionobservation_Mutation_Response>;
  /** update data of the table: "pallet_inspectionobservation_attachments" */
  update_pallet_inspectionobservation_attachments?: Maybe<Pallet_Inspectionobservation_Attachments_Mutation_Response>;
  /** update single row of the table: "pallet_inspectionobservation_attachments" */
  update_pallet_inspectionobservation_attachments_by_pk?: Maybe<Pallet_Inspectionobservation_Attachments>;
  /** update multiples rows of table: "pallet_inspectionobservation_attachments" */
  update_pallet_inspectionobservation_attachments_many?: Maybe<Array<Maybe<Pallet_Inspectionobservation_Attachments_Mutation_Response>>>;
  /** update single row of the table: "pallet_inspectionobservation" */
  update_pallet_inspectionobservation_by_pk?: Maybe<Pallet_Inspectionobservation>;
  /** update multiples rows of table: "pallet_inspectionobservation" */
  update_pallet_inspectionobservation_many?: Maybe<Array<Maybe<Pallet_Inspectionobservation_Mutation_Response>>>;
  /** update data of the table: "pallet_line" */
  update_pallet_line?: Maybe<Pallet_Line_Mutation_Response>;
  /** update single row of the table: "pallet_line" */
  update_pallet_line_by_pk?: Maybe<Pallet_Line>;
  /** update multiples rows of table: "pallet_line" */
  update_pallet_line_many?: Maybe<Array<Maybe<Pallet_Line_Mutation_Response>>>;
  /** update data of the table: "pallet_location" */
  update_pallet_location?: Maybe<Pallet_Location_Mutation_Response>;
  /** update single row of the table: "pallet_location" */
  update_pallet_location_by_pk?: Maybe<Pallet_Location>;
  /** update multiples rows of table: "pallet_location" */
  update_pallet_location_many?: Maybe<Array<Maybe<Pallet_Location_Mutation_Response>>>;
  /** update data of the table: "pallet_packaging" */
  update_pallet_packaging?: Maybe<Pallet_Packaging_Mutation_Response>;
  /** update single row of the table: "pallet_packaging" */
  update_pallet_packaging_by_pk?: Maybe<Pallet_Packaging>;
  /** update multiples rows of table: "pallet_packaging" */
  update_pallet_packaging_many?: Maybe<Array<Maybe<Pallet_Packaging_Mutation_Response>>>;
  /** update data of the table: "pallet_packagingkind" */
  update_pallet_packagingkind?: Maybe<Pallet_Packagingkind_Mutation_Response>;
  /** update single row of the table: "pallet_packagingkind" */
  update_pallet_packagingkind_by_pk?: Maybe<Pallet_Packagingkind>;
  /** update multiples rows of table: "pallet_packagingkind" */
  update_pallet_packagingkind_many?: Maybe<Array<Maybe<Pallet_Packagingkind_Mutation_Response>>>;
  /** update data of the table: "pallet_packing" */
  update_pallet_packing?: Maybe<Pallet_Packing_Mutation_Response>;
  /** update data of the table: "pallet_packing_attachments" */
  update_pallet_packing_attachments?: Maybe<Pallet_Packing_Attachments_Mutation_Response>;
  /** update single row of the table: "pallet_packing_attachments" */
  update_pallet_packing_attachments_by_pk?: Maybe<Pallet_Packing_Attachments>;
  /** update multiples rows of table: "pallet_packing_attachments" */
  update_pallet_packing_attachments_many?: Maybe<Array<Maybe<Pallet_Packing_Attachments_Mutation_Response>>>;
  /** update single row of the table: "pallet_packing" */
  update_pallet_packing_by_pk?: Maybe<Pallet_Packing>;
  /** update multiples rows of table: "pallet_packing" */
  update_pallet_packing_many?: Maybe<Array<Maybe<Pallet_Packing_Mutation_Response>>>;
  /** update data of the table: "pallet_packing_weights" */
  update_pallet_packing_weights?: Maybe<Pallet_Packing_Weights_Mutation_Response>;
  /** update single row of the table: "pallet_packing_weights" */
  update_pallet_packing_weights_by_pk?: Maybe<Pallet_Packing_Weights>;
  /** update multiples rows of table: "pallet_packing_weights" */
  update_pallet_packing_weights_many?: Maybe<Array<Maybe<Pallet_Packing_Weights_Mutation_Response>>>;
  /** update data of the table: "pallet_packingkind" */
  update_pallet_packingkind?: Maybe<Pallet_Packingkind_Mutation_Response>;
  /** update single row of the table: "pallet_packingkind" */
  update_pallet_packingkind_by_pk?: Maybe<Pallet_Packingkind>;
  /** update multiples rows of table: "pallet_packingkind" */
  update_pallet_packingkind_many?: Maybe<Array<Maybe<Pallet_Packingkind_Mutation_Response>>>;
  /** update data of the table: "pallet_packingweight" */
  update_pallet_packingweight?: Maybe<Pallet_Packingweight_Mutation_Response>;
  /** update data of the table: "pallet_packingweight_attachments" */
  update_pallet_packingweight_attachments?: Maybe<Pallet_Packingweight_Attachments_Mutation_Response>;
  /** update single row of the table: "pallet_packingweight_attachments" */
  update_pallet_packingweight_attachments_by_pk?: Maybe<Pallet_Packingweight_Attachments>;
  /** update multiples rows of table: "pallet_packingweight_attachments" */
  update_pallet_packingweight_attachments_many?: Maybe<Array<Maybe<Pallet_Packingweight_Attachments_Mutation_Response>>>;
  /** update single row of the table: "pallet_packingweight" */
  update_pallet_packingweight_by_pk?: Maybe<Pallet_Packingweight>;
  /** update multiples rows of table: "pallet_packingweight" */
  update_pallet_packingweight_many?: Maybe<Array<Maybe<Pallet_Packingweight_Mutation_Response>>>;
  /** update data of the table: "pallet_printingmatter" */
  update_pallet_printingmatter?: Maybe<Pallet_Printingmatter_Mutation_Response>;
  /** update single row of the table: "pallet_printingmatter" */
  update_pallet_printingmatter_by_pk?: Maybe<Pallet_Printingmatter>;
  /** update multiples rows of table: "pallet_printingmatter" */
  update_pallet_printingmatter_many?: Maybe<Array<Maybe<Pallet_Printingmatter_Mutation_Response>>>;
  /** update data of the table: "pallet_punnetcondition" */
  update_pallet_punnetcondition?: Maybe<Pallet_Punnetcondition_Mutation_Response>;
  /** update single row of the table: "pallet_punnetcondition" */
  update_pallet_punnetcondition_by_pk?: Maybe<Pallet_Punnetcondition>;
  /** update multiples rows of table: "pallet_punnetcondition" */
  update_pallet_punnetcondition_many?: Maybe<Array<Maybe<Pallet_Punnetcondition_Mutation_Response>>>;
  /** update data of the table: "pallet_samplinglocation" */
  update_pallet_samplinglocation?: Maybe<Pallet_Samplinglocation_Mutation_Response>;
  /** update single row of the table: "pallet_samplinglocation" */
  update_pallet_samplinglocation_by_pk?: Maybe<Pallet_Samplinglocation>;
  /** update multiples rows of table: "pallet_samplinglocation" */
  update_pallet_samplinglocation_many?: Maybe<Array<Maybe<Pallet_Samplinglocation_Mutation_Response>>>;
  /** update data of the table: "pallet_sku" */
  update_pallet_sku?: Maybe<Pallet_Sku_Mutation_Response>;
  /** update single row of the table: "pallet_sku" */
  update_pallet_sku_by_pk?: Maybe<Pallet_Sku>;
  /** update multiples rows of table: "pallet_sku" */
  update_pallet_sku_many?: Maybe<Array<Maybe<Pallet_Sku_Mutation_Response>>>;
  /** update data of the table: "pallet_skutype" */
  update_pallet_skutype?: Maybe<Pallet_Skutype_Mutation_Response>;
  /** update single row of the table: "pallet_skutype" */
  update_pallet_skutype_by_pk?: Maybe<Pallet_Skutype>;
  /** update multiples rows of table: "pallet_skutype" */
  update_pallet_skutype_many?: Maybe<Array<Maybe<Pallet_Skutype_Mutation_Response>>>;
  /** update data of the table: "pallet_variety" */
  update_pallet_variety?: Maybe<Pallet_Variety_Mutation_Response>;
  /** update single row of the table: "pallet_variety" */
  update_pallet_variety_by_pk?: Maybe<Pallet_Variety>;
  /** update multiples rows of table: "pallet_variety" */
  update_pallet_variety_many?: Maybe<Array<Maybe<Pallet_Variety_Mutation_Response>>>;
  update_password?: Maybe<UpdatePasswordMutation>;
  /** update data of the table: "payment" */
  update_payment?: Maybe<Payment_Mutation_Response>;
  /** update single row of the table: "payment" */
  update_payment_by_pk?: Maybe<Payment>;
  /** update data of the table: "payment_detail" */
  update_payment_detail?: Maybe<Payment_Detail_Mutation_Response>;
  /** update data of the table: "payment_detail_attachments" */
  update_payment_detail_attachments?: Maybe<Payment_Detail_Attachments_Mutation_Response>;
  /** update single row of the table: "payment_detail_attachments" */
  update_payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** update multiples rows of table: "payment_detail_attachments" */
  update_payment_detail_attachments_many?: Maybe<Array<Maybe<Payment_Detail_Attachments_Mutation_Response>>>;
  /** update single row of the table: "payment_detail" */
  update_payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** update multiples rows of table: "payment_detail" */
  update_payment_detail_many?: Maybe<Array<Maybe<Payment_Detail_Mutation_Response>>>;
  /** update multiples rows of table: "payment" */
  update_payment_many?: Maybe<Array<Maybe<Payment_Mutation_Response>>>;
  /** update data of the table: "payment_method" */
  update_payment_method?: Maybe<Payment_Method_Mutation_Response>;
  /** update single row of the table: "payment_method" */
  update_payment_method_by_pk?: Maybe<Payment_Method>;
  /** update multiples rows of table: "payment_method" */
  update_payment_method_many?: Maybe<Array<Maybe<Payment_Method_Mutation_Response>>>;
  /** update data of the table: "plot" */
  update_plot?: Maybe<Plot_Mutation_Response>;
  /** update single row of the table: "plot" */
  update_plot_by_pk?: Maybe<Plot>;
  /** update data of the table: "plot_crop" */
  update_plot_crop?: Maybe<Plot_Crop_Mutation_Response>;
  /** update data of the table: "plot_crop_agent" */
  update_plot_crop_agent?: Maybe<Plot_Crop_Agent_Mutation_Response>;
  /** update single row of the table: "plot_crop_agent" */
  update_plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** update multiples rows of table: "plot_crop_agent" */
  update_plot_crop_agent_many?: Maybe<Array<Maybe<Plot_Crop_Agent_Mutation_Response>>>;
  /** update single row of the table: "plot_crop" */
  update_plot_crop_by_pk?: Maybe<Plot_Crop>;
  /** update data of the table: "plot_crop_cultivation_type" */
  update_plot_crop_cultivation_type?: Maybe<Plot_Crop_Cultivation_Type_Mutation_Response>;
  /** update single row of the table: "plot_crop_cultivation_type" */
  update_plot_crop_cultivation_type_by_pk?: Maybe<Plot_Crop_Cultivation_Type>;
  /** update multiples rows of table: "plot_crop_cultivation_type" */
  update_plot_crop_cultivation_type_many?: Maybe<Array<Maybe<Plot_Crop_Cultivation_Type_Mutation_Response>>>;
  /** update data of the table: "plot_crop_historic_season" */
  update_plot_crop_historic_season?: Maybe<Plot_Crop_Historic_Season_Mutation_Response>;
  /** update single row of the table: "plot_crop_historic_season" */
  update_plot_crop_historic_season_by_pk?: Maybe<Plot_Crop_Historic_Season>;
  /** update multiples rows of table: "plot_crop_historic_season" */
  update_plot_crop_historic_season_many?: Maybe<Array<Maybe<Plot_Crop_Historic_Season_Mutation_Response>>>;
  /** update multiples rows of table: "plot_crop" */
  update_plot_crop_many?: Maybe<Array<Maybe<Plot_Crop_Mutation_Response>>>;
  /** update data of the table: "plot_crop_milestone" */
  update_plot_crop_milestone?: Maybe<Plot_Crop_Milestone_Mutation_Response>;
  /** update single row of the table: "plot_crop_milestone" */
  update_plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** update multiples rows of table: "plot_crop_milestone" */
  update_plot_crop_milestone_many?: Maybe<Array<Maybe<Plot_Crop_Milestone_Mutation_Response>>>;
  /** update data of the table: "plot_crop_network" */
  update_plot_crop_network?: Maybe<Plot_Crop_Network_Mutation_Response>;
  /** update single row of the table: "plot_crop_network" */
  update_plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  /** update multiples rows of table: "plot_crop_network" */
  update_plot_crop_network_many?: Maybe<Array<Maybe<Plot_Crop_Network_Mutation_Response>>>;
  /** update data of the table: "plot_crop_rootstock" */
  update_plot_crop_rootstock?: Maybe<Plot_Crop_Rootstock_Mutation_Response>;
  /** update single row of the table: "plot_crop_rootstock" */
  update_plot_crop_rootstock_by_pk?: Maybe<Plot_Crop_Rootstock>;
  /** update multiples rows of table: "plot_crop_rootstock" */
  update_plot_crop_rootstock_many?: Maybe<Array<Maybe<Plot_Crop_Rootstock_Mutation_Response>>>;
  update_plot_crop_status?: Maybe<MutationUpdatePlotCropStatus>;
  /** update data of the table: "plot_crop_status_history" */
  update_plot_crop_status_history?: Maybe<Plot_Crop_Status_History_Mutation_Response>;
  /** update single row of the table: "plot_crop_status_history" */
  update_plot_crop_status_history_by_pk?: Maybe<Plot_Crop_Status_History>;
  /** update multiples rows of table: "plot_crop_status_history" */
  update_plot_crop_status_history_many?: Maybe<Array<Maybe<Plot_Crop_Status_History_Mutation_Response>>>;
  /** update multiples rows of table: "plot" */
  update_plot_many?: Maybe<Array<Maybe<Plot_Mutation_Response>>>;
  /** update data of the table: "plot_network" */
  update_plot_network?: Maybe<Plot_Network_Mutation_Response>;
  /** update single row of the table: "plot_network" */
  update_plot_network_by_pk?: Maybe<Plot_Network>;
  /** update multiples rows of table: "plot_network" */
  update_plot_network_many?: Maybe<Array<Maybe<Plot_Network_Mutation_Response>>>;
  /** update data of the table: "plot_status" */
  update_plot_status?: Maybe<Plot_Status_Mutation_Response>;
  update_plot_status_bulk?: Maybe<MutationUpdatePlotStatusBulk>;
  /** update single row of the table: "plot_status" */
  update_plot_status_by_pk?: Maybe<Plot_Status>;
  /** update data of the table: "plot_status_config" */
  update_plot_status_config?: Maybe<Plot_Status_Config_Mutation_Response>;
  /** update single row of the table: "plot_status_config" */
  update_plot_status_config_by_pk?: Maybe<Plot_Status_Config>;
  /** update multiples rows of table: "plot_status_config" */
  update_plot_status_config_many?: Maybe<Array<Maybe<Plot_Status_Config_Mutation_Response>>>;
  /** update data of the table: "plot_status_config_required_qc_stages" */
  update_plot_status_config_required_qc_stages?: Maybe<Plot_Status_Config_Required_Qc_Stages_Mutation_Response>;
  /** update single row of the table: "plot_status_config_required_qc_stages" */
  update_plot_status_config_required_qc_stages_by_pk?: Maybe<Plot_Status_Config_Required_Qc_Stages>;
  /** update multiples rows of table: "plot_status_config_required_qc_stages" */
  update_plot_status_config_required_qc_stages_many?: Maybe<Array<Maybe<Plot_Status_Config_Required_Qc_Stages_Mutation_Response>>>;
  /** update multiples rows of table: "plot_status" */
  update_plot_status_many?: Maybe<Array<Maybe<Plot_Status_Mutation_Response>>>;
  /** update data of the table: "primary_growth_stage" */
  update_primary_growth_stage?: Maybe<Primary_Growth_Stage_Mutation_Response>;
  /** update single row of the table: "primary_growth_stage" */
  update_primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  /** update multiples rows of table: "primary_growth_stage" */
  update_primary_growth_stage_many?: Maybe<Array<Maybe<Primary_Growth_Stage_Mutation_Response>>>;
  update_primary_location?: Maybe<UpdatePrimaryLocation>;
  update_production_trade_status?: Maybe<UpdateProductionTradeStatusMutation>;
  /** update data of the table: "quality_parameter" */
  update_quality_parameter?: Maybe<Quality_Parameter_Mutation_Response>;
  /** update single row of the table: "quality_parameter" */
  update_quality_parameter_by_pk?: Maybe<Quality_Parameter>;
  /** update data of the table: "quality_parameter_category" */
  update_quality_parameter_category?: Maybe<Quality_Parameter_Category_Mutation_Response>;
  /** update single row of the table: "quality_parameter_category" */
  update_quality_parameter_category_by_pk?: Maybe<Quality_Parameter_Category>;
  /** update multiples rows of table: "quality_parameter_category" */
  update_quality_parameter_category_many?: Maybe<Array<Maybe<Quality_Parameter_Category_Mutation_Response>>>;
  /** update multiples rows of table: "quality_parameter" */
  update_quality_parameter_many?: Maybe<Array<Maybe<Quality_Parameter_Mutation_Response>>>;
  /** update data of the table: "quality_stage" */
  update_quality_stage?: Maybe<Quality_Stage_Mutation_Response>;
  /** update data of the table: "quality_stage_allowed_template_category" */
  update_quality_stage_allowed_template_category?: Maybe<Quality_Stage_Allowed_Template_Category_Mutation_Response>;
  /** update single row of the table: "quality_stage_allowed_template_category" */
  update_quality_stage_allowed_template_category_by_pk?: Maybe<Quality_Stage_Allowed_Template_Category>;
  /** update multiples rows of table: "quality_stage_allowed_template_category" */
  update_quality_stage_allowed_template_category_many?: Maybe<Array<Maybe<Quality_Stage_Allowed_Template_Category_Mutation_Response>>>;
  /** update single row of the table: "quality_stage" */
  update_quality_stage_by_pk?: Maybe<Quality_Stage>;
  /** update multiples rows of table: "quality_stage" */
  update_quality_stage_many?: Maybe<Array<Maybe<Quality_Stage_Mutation_Response>>>;
  update_quality_stages_sequence?: Maybe<UpdateQualityStagesSequence>;
  /** update data of the table: "receipt" */
  update_receipt?: Maybe<Receipt_Mutation_Response>;
  /** update single row of the table: "receipt" */
  update_receipt_by_pk?: Maybe<Receipt>;
  /** update multiples rows of table: "receipt" */
  update_receipt_many?: Maybe<Array<Maybe<Receipt_Mutation_Response>>>;
  /** update data of the table: "region" */
  update_region?: Maybe<Region_Mutation_Response>;
  /** update single row of the table: "region" */
  update_region_by_pk?: Maybe<Region>;
  /** update data of the table: "region_group" */
  update_region_group?: Maybe<Region_Group_Mutation_Response>;
  /** update single row of the table: "region_group" */
  update_region_group_by_pk?: Maybe<Region_Group>;
  /** update multiples rows of table: "region_group" */
  update_region_group_many?: Maybe<Array<Maybe<Region_Group_Mutation_Response>>>;
  /** update multiples rows of table: "region" */
  update_region_many?: Maybe<Array<Maybe<Region_Mutation_Response>>>;
  /** update data of the table: "request" */
  update_request?: Maybe<Request_Mutation_Response>;
  /** update single row of the table: "request" */
  update_request_by_pk?: Maybe<Request>;
  /** update data of the table: "request_category" */
  update_request_category?: Maybe<Request_Category_Mutation_Response>;
  /** update single row of the table: "request_category" */
  update_request_category_by_pk?: Maybe<Request_Category>;
  /** update multiples rows of table: "request_category" */
  update_request_category_many?: Maybe<Array<Maybe<Request_Category_Mutation_Response>>>;
  /** update multiples rows of table: "request" */
  update_request_many?: Maybe<Array<Maybe<Request_Mutation_Response>>>;
  /** update data of the table: "request_parameters" */
  update_request_parameters?: Maybe<Request_Parameters_Mutation_Response>;
  /** update single row of the table: "request_parameters" */
  update_request_parameters_by_pk?: Maybe<Request_Parameters>;
  /** update multiples rows of table: "request_parameters" */
  update_request_parameters_many?: Maybe<Array<Maybe<Request_Parameters_Mutation_Response>>>;
  /** update data of the table: "request_secondary_locations" */
  update_request_secondary_locations?: Maybe<Request_Secondary_Locations_Mutation_Response>;
  /** update single row of the table: "request_secondary_locations" */
  update_request_secondary_locations_by_pk?: Maybe<Request_Secondary_Locations>;
  /** update multiples rows of table: "request_secondary_locations" */
  update_request_secondary_locations_many?: Maybe<Array<Maybe<Request_Secondary_Locations_Mutation_Response>>>;
  /** update data of the table: "request_templates" */
  update_request_templates?: Maybe<Request_Templates_Mutation_Response>;
  /** update single row of the table: "request_templates" */
  update_request_templates_by_pk?: Maybe<Request_Templates>;
  /** update multiples rows of table: "request_templates" */
  update_request_templates_many?: Maybe<Array<Maybe<Request_Templates_Mutation_Response>>>;
  /** update data of the table: "result" */
  update_result?: Maybe<Result_Mutation_Response>;
  /** update single row of the table: "result" */
  update_result_by_pk?: Maybe<Result>;
  /** update data of the table: "result_comment" */
  update_result_comment?: Maybe<Result_Comment_Mutation_Response>;
  /** update single row of the table: "result_comment" */
  update_result_comment_by_pk?: Maybe<Result_Comment>;
  /** update multiples rows of table: "result_comment" */
  update_result_comment_many?: Maybe<Array<Maybe<Result_Comment_Mutation_Response>>>;
  /** update data of the table: "result_evaluation" */
  update_result_evaluation?: Maybe<Result_Evaluation_Mutation_Response>;
  /** update single row of the table: "result_evaluation" */
  update_result_evaluation_by_pk?: Maybe<Result_Evaluation>;
  /** update data of the table: "result_evaluation_evaluated_tags" */
  update_result_evaluation_evaluated_tags?: Maybe<Result_Evaluation_Evaluated_Tags_Mutation_Response>;
  /** update single row of the table: "result_evaluation_evaluated_tags" */
  update_result_evaluation_evaluated_tags_by_pk?: Maybe<Result_Evaluation_Evaluated_Tags>;
  /** update multiples rows of table: "result_evaluation_evaluated_tags" */
  update_result_evaluation_evaluated_tags_many?: Maybe<Array<Maybe<Result_Evaluation_Evaluated_Tags_Mutation_Response>>>;
  /** update multiples rows of table: "result_evaluation" */
  update_result_evaluation_many?: Maybe<Array<Maybe<Result_Evaluation_Mutation_Response>>>;
  /** update multiples rows of table: "result" */
  update_result_many?: Maybe<Array<Maybe<Result_Mutation_Response>>>;
  /** update data of the table: "result_media" */
  update_result_media?: Maybe<Result_Media_Mutation_Response>;
  /** update single row of the table: "result_media" */
  update_result_media_by_pk?: Maybe<Result_Media>;
  /** update multiples rows of table: "result_media" */
  update_result_media_many?: Maybe<Array<Maybe<Result_Media_Mutation_Response>>>;
  /** update data of the table: "result_observation" */
  update_result_observation?: Maybe<Result_Observation_Mutation_Response>;
  /** update data of the table: "result_observation_attachments" */
  update_result_observation_attachments?: Maybe<Result_Observation_Attachments_Mutation_Response>;
  /** update single row of the table: "result_observation_attachments" */
  update_result_observation_attachments_by_pk?: Maybe<Result_Observation_Attachments>;
  /** update multiples rows of table: "result_observation_attachments" */
  update_result_observation_attachments_many?: Maybe<Array<Maybe<Result_Observation_Attachments_Mutation_Response>>>;
  /** update single row of the table: "result_observation" */
  update_result_observation_by_pk?: Maybe<Result_Observation>;
  /** update data of the table: "result_observation_evaluated_tags" */
  update_result_observation_evaluated_tags?: Maybe<Result_Observation_Evaluated_Tags_Mutation_Response>;
  /** update single row of the table: "result_observation_evaluated_tags" */
  update_result_observation_evaluated_tags_by_pk?: Maybe<Result_Observation_Evaluated_Tags>;
  /** update multiples rows of table: "result_observation_evaluated_tags" */
  update_result_observation_evaluated_tags_many?: Maybe<Array<Maybe<Result_Observation_Evaluated_Tags_Mutation_Response>>>;
  /** update multiples rows of table: "result_observation" */
  update_result_observation_many?: Maybe<Array<Maybe<Result_Observation_Mutation_Response>>>;
  /** update data of the table: "role" */
  update_role?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update multiples rows of table: "role" */
  update_role_many?: Maybe<Array<Maybe<Role_Mutation_Response>>>;
  /** update data of the table: "rootstock" */
  update_rootstock?: Maybe<Rootstock_Mutation_Response>;
  /** update single row of the table: "rootstock" */
  update_rootstock_by_pk?: Maybe<Rootstock>;
  /** update multiples rows of table: "rootstock" */
  update_rootstock_many?: Maybe<Array<Maybe<Rootstock_Mutation_Response>>>;
  /** update data of the table: "sample" */
  update_sample?: Maybe<Sample_Mutation_Response>;
  /** update single row of the table: "sample" */
  update_sample_by_pk?: Maybe<Sample>;
  /** update multiples rows of table: "sample" */
  update_sample_many?: Maybe<Array<Maybe<Sample_Mutation_Response>>>;
  /** update data of the table: "sample_media" */
  update_sample_media?: Maybe<Sample_Media_Mutation_Response>;
  /** update single row of the table: "sample_media" */
  update_sample_media_by_pk?: Maybe<Sample_Media>;
  /** update multiples rows of table: "sample_media" */
  update_sample_media_many?: Maybe<Array<Maybe<Sample_Media_Mutation_Response>>>;
  /** update data of the table: "sample_observation" */
  update_sample_observation?: Maybe<Sample_Observation_Mutation_Response>;
  /** update data of the table: "sample_observation_attachments" */
  update_sample_observation_attachments?: Maybe<Sample_Observation_Attachments_Mutation_Response>;
  /** update single row of the table: "sample_observation_attachments" */
  update_sample_observation_attachments_by_pk?: Maybe<Sample_Observation_Attachments>;
  /** update multiples rows of table: "sample_observation_attachments" */
  update_sample_observation_attachments_many?: Maybe<Array<Maybe<Sample_Observation_Attachments_Mutation_Response>>>;
  /** update single row of the table: "sample_observation" */
  update_sample_observation_by_pk?: Maybe<Sample_Observation>;
  /** update multiples rows of table: "sample_observation" */
  update_sample_observation_many?: Maybe<Array<Maybe<Sample_Observation_Mutation_Response>>>;
  /** update data of the table: "secondary_growth_stage" */
  update_secondary_growth_stage?: Maybe<Secondary_Growth_Stage_Mutation_Response>;
  /** update single row of the table: "secondary_growth_stage" */
  update_secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  /** update multiples rows of table: "secondary_growth_stage" */
  update_secondary_growth_stage_many?: Maybe<Array<Maybe<Secondary_Growth_Stage_Mutation_Response>>>;
  /** update data of the table: "shared_entity" */
  update_setu_trade_shared_entity?: Maybe<Setu_Trade_Shared_Entity_Mutation_Response>;
  /** update multiples rows of table: "shared_entity" */
  update_setu_trade_shared_entity_many?: Maybe<Array<Maybe<Setu_Trade_Shared_Entity_Mutation_Response>>>;
  /** update data of the table: "media" */
  update_setutrade_media?: Maybe<Setutrade_Media_Mutation_Response>;
  /** update multiples rows of table: "media" */
  update_setutrade_media_many?: Maybe<Array<Maybe<Setutrade_Media_Mutation_Response>>>;
  /** update data of the table: "trip" */
  update_setutrade_trip?: Maybe<Setutrade_Trip_Mutation_Response>;
  /** update single row of the table: "trip" */
  update_setutrade_trip_by_pk?: Maybe<Setutrade_Trip>;
  /** update multiples rows of table: "trip" */
  update_setutrade_trip_many?: Maybe<Array<Maybe<Setutrade_Trip_Mutation_Response>>>;
  /** update data of the table: "shareholder_applications" */
  update_shareholder_applications?: Maybe<Shareholder_Applications_Mutation_Response>;
  /** update single row of the table: "shareholder_applications" */
  update_shareholder_applications_by_pk?: Maybe<Shareholder_Applications>;
  /** update multiples rows of table: "shareholder_applications" */
  update_shareholder_applications_many?: Maybe<Array<Maybe<Shareholder_Applications_Mutation_Response>>>;
  /** update data of the table: "shareholders" */
  update_shareholders?: Maybe<Shareholders_Mutation_Response>;
  /** update single row of the table: "shareholders" */
  update_shareholders_by_pk?: Maybe<Shareholders>;
  /** update multiples rows of table: "shareholders" */
  update_shareholders_many?: Maybe<Array<Maybe<Shareholders_Mutation_Response>>>;
  /** update data of the table: "si_unit" */
  update_si_unit?: Maybe<Si_Unit_Mutation_Response>;
  /** update single row of the table: "si_unit" */
  update_si_unit_by_pk?: Maybe<Si_Unit>;
  /** update multiples rows of table: "si_unit" */
  update_si_unit_many?: Maybe<Array<Maybe<Si_Unit_Mutation_Response>>>;
  /** update data of the table: "si_unit_measure" */
  update_si_unit_measure?: Maybe<Si_Unit_Measure_Mutation_Response>;
  /** update single row of the table: "si_unit_measure" */
  update_si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  /** update multiples rows of table: "si_unit_measure" */
  update_si_unit_measure_many?: Maybe<Array<Maybe<Si_Unit_Measure_Mutation_Response>>>;
  /** update data of the table: "sku" */
  update_sku?: Maybe<Sku_Mutation_Response>;
  /** update single row of the table: "sku" */
  update_sku_by_pk?: Maybe<Sku>;
  /** update data of the table: "sku_kind" */
  update_sku_kind?: Maybe<Sku_Kind_Mutation_Response>;
  /** update single row of the table: "sku_kind" */
  update_sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** update multiples rows of table: "sku_kind" */
  update_sku_kind_many?: Maybe<Array<Maybe<Sku_Kind_Mutation_Response>>>;
  /** update multiples rows of table: "sku" */
  update_sku_many?: Maybe<Array<Maybe<Sku_Mutation_Response>>>;
  /** update data of the table: "soil" */
  update_soil?: Maybe<Soil_Mutation_Response>;
  /** update single row of the table: "soil" */
  update_soil_by_pk?: Maybe<Soil>;
  /** update multiples rows of table: "soil" */
  update_soil_many?: Maybe<Array<Maybe<Soil_Mutation_Response>>>;
  /** update data of the table: "stage_actions" */
  update_stage_actions?: Maybe<Stage_Actions_Mutation_Response>;
  /** update single row of the table: "stage_actions" */
  update_stage_actions_by_pk?: Maybe<Stage_Actions>;
  /** update multiples rows of table: "stage_actions" */
  update_stage_actions_many?: Maybe<Array<Maybe<Stage_Actions_Mutation_Response>>>;
  /** update data of the table: "stage_logs" */
  update_stage_logs?: Maybe<Stage_Logs_Mutation_Response>;
  /** update single row of the table: "stage_logs" */
  update_stage_logs_by_pk?: Maybe<Stage_Logs>;
  /** update multiples rows of table: "stage_logs" */
  update_stage_logs_many?: Maybe<Array<Maybe<Stage_Logs_Mutation_Response>>>;
  /** update data of the table: "stages" */
  update_stages?: Maybe<Stages_Mutation_Response>;
  /** update single row of the table: "stages" */
  update_stages_by_pk?: Maybe<Stages>;
  /** update multiples rows of table: "stages" */
  update_stages_many?: Maybe<Array<Maybe<Stages_Mutation_Response>>>;
  /** update data of the table: "stages_subscribers" */
  update_stages_subscribers?: Maybe<Stages_Subscribers_Mutation_Response>;
  /** update single row of the table: "stages_subscribers" */
  update_stages_subscribers_by_pk?: Maybe<Stages_Subscribers>;
  /** update multiples rows of table: "stages_subscribers" */
  update_stages_subscribers_many?: Maybe<Array<Maybe<Stages_Subscribers_Mutation_Response>>>;
  /** update data of the table: "state" */
  update_state?: Maybe<State_Mutation_Response>;
  /** update single row of the table: "state" */
  update_state_by_pk?: Maybe<State>;
  /** update multiples rows of table: "state" */
  update_state_many?: Maybe<Array<Maybe<State_Mutation_Response>>>;
  /** update data of the table: "survey_parameters" */
  update_survey_parameters?: Maybe<Survey_Parameters_Mutation_Response>;
  /** update single row of the table: "survey_parameters" */
  update_survey_parameters_by_pk?: Maybe<Survey_Parameters>;
  /** update multiples rows of table: "survey_parameters" */
  update_survey_parameters_many?: Maybe<Array<Maybe<Survey_Parameters_Mutation_Response>>>;
  /** update data of the table: "survey_response_items" */
  update_survey_response_items?: Maybe<Survey_Response_Items_Mutation_Response>;
  /** update single row of the table: "survey_response_items" */
  update_survey_response_items_by_pk?: Maybe<Survey_Response_Items>;
  /** update multiples rows of table: "survey_response_items" */
  update_survey_response_items_many?: Maybe<Array<Maybe<Survey_Response_Items_Mutation_Response>>>;
  /** update data of the table: "survey_responses" */
  update_survey_responses?: Maybe<Survey_Responses_Mutation_Response>;
  /** update single row of the table: "survey_responses" */
  update_survey_responses_by_pk?: Maybe<Survey_Responses>;
  /** update multiples rows of table: "survey_responses" */
  update_survey_responses_many?: Maybe<Array<Maybe<Survey_Responses_Mutation_Response>>>;
  /** update data of the table: "survey_users" */
  update_survey_users?: Maybe<Survey_Users_Mutation_Response>;
  /** update single row of the table: "survey_users" */
  update_survey_users_by_pk?: Maybe<Survey_Users>;
  /** update multiples rows of table: "survey_users" */
  update_survey_users_many?: Maybe<Array<Maybe<Survey_Users_Mutation_Response>>>;
  /** update data of the table: "survey_year" */
  update_survey_year?: Maybe<Survey_Year_Mutation_Response>;
  /** update single row of the table: "survey_year" */
  update_survey_year_by_pk?: Maybe<Survey_Year>;
  /** update multiples rows of table: "survey_year" */
  update_survey_year_many?: Maybe<Array<Maybe<Survey_Year_Mutation_Response>>>;
  /** update data of the table: "surveys" */
  update_surveys?: Maybe<Surveys_Mutation_Response>;
  /** update single row of the table: "surveys" */
  update_surveys_by_pk?: Maybe<Surveys>;
  /** update multiples rows of table: "surveys" */
  update_surveys_many?: Maybe<Array<Maybe<Surveys_Mutation_Response>>>;
  /** update data of the table: "template" */
  update_template?: Maybe<Template_Mutation_Response>;
  /** update single row of the table: "template" */
  update_template_by_pk?: Maybe<Template>;
  /** update data of the table: "template_category" */
  update_template_category?: Maybe<Template_Category_Mutation_Response>;
  /** update data of the table: "template_category_allowed_groups" */
  update_template_category_allowed_groups?: Maybe<Template_Category_Allowed_Groups_Mutation_Response>;
  /** update single row of the table: "template_category_allowed_groups" */
  update_template_category_allowed_groups_by_pk?: Maybe<Template_Category_Allowed_Groups>;
  /** update multiples rows of table: "template_category_allowed_groups" */
  update_template_category_allowed_groups_many?: Maybe<Array<Maybe<Template_Category_Allowed_Groups_Mutation_Response>>>;
  /** update data of the table: "template_category_allowed_parameter_categories" */
  update_template_category_allowed_parameter_categories?: Maybe<Template_Category_Allowed_Parameter_Categories_Mutation_Response>;
  /** update single row of the table: "template_category_allowed_parameter_categories" */
  update_template_category_allowed_parameter_categories_by_pk?: Maybe<Template_Category_Allowed_Parameter_Categories>;
  /** update multiples rows of table: "template_category_allowed_parameter_categories" */
  update_template_category_allowed_parameter_categories_many?: Maybe<Array<Maybe<Template_Category_Allowed_Parameter_Categories_Mutation_Response>>>;
  /** update single row of the table: "template_category" */
  update_template_category_by_pk?: Maybe<Template_Category>;
  /** update multiples rows of table: "template_category" */
  update_template_category_many?: Maybe<Array<Maybe<Template_Category_Mutation_Response>>>;
  /** update data of the table: "template_company" */
  update_template_company?: Maybe<Template_Company_Mutation_Response>;
  /** update single row of the table: "template_company" */
  update_template_company_by_pk?: Maybe<Template_Company>;
  /** update multiples rows of table: "template_company" */
  update_template_company_many?: Maybe<Array<Maybe<Template_Company_Mutation_Response>>>;
  /** update data of the table: "template_departments" */
  update_template_departments?: Maybe<Template_Departments_Mutation_Response>;
  /** update single row of the table: "template_departments" */
  update_template_departments_by_pk?: Maybe<Template_Departments>;
  /** update multiples rows of table: "template_departments" */
  update_template_departments_many?: Maybe<Array<Maybe<Template_Departments_Mutation_Response>>>;
  /** update data of the table: "template_evaluation" */
  update_template_evaluation?: Maybe<Template_Evaluation_Mutation_Response>;
  /** update single row of the table: "template_evaluation" */
  update_template_evaluation_by_pk?: Maybe<Template_Evaluation>;
  /** update data of the table: "template_evaluation_config" */
  update_template_evaluation_config?: Maybe<Template_Evaluation_Config_Mutation_Response>;
  /** update single row of the table: "template_evaluation_config" */
  update_template_evaluation_config_by_pk?: Maybe<Template_Evaluation_Config>;
  /** update multiples rows of table: "template_evaluation_config" */
  update_template_evaluation_config_many?: Maybe<Array<Maybe<Template_Evaluation_Config_Mutation_Response>>>;
  /** update multiples rows of table: "template_evaluation" */
  update_template_evaluation_many?: Maybe<Array<Maybe<Template_Evaluation_Mutation_Response>>>;
  /** update data of the table: "template_evaluation_templates" */
  update_template_evaluation_templates?: Maybe<Template_Evaluation_Templates_Mutation_Response>;
  /** update single row of the table: "template_evaluation_templates" */
  update_template_evaluation_templates_by_pk?: Maybe<Template_Evaluation_Templates>;
  /** update multiples rows of table: "template_evaluation_templates" */
  update_template_evaluation_templates_many?: Maybe<Array<Maybe<Template_Evaluation_Templates_Mutation_Response>>>;
  /** update multiples rows of table: "template" */
  update_template_many?: Maybe<Array<Maybe<Template_Mutation_Response>>>;
  /** update data of the table: "template_parameter" */
  update_template_parameter?: Maybe<Template_Parameter_Mutation_Response>;
  /** update single row of the table: "template_parameter" */
  update_template_parameter_by_pk?: Maybe<Template_Parameter>;
  /** update data of the table: "template_parameter_config" */
  update_template_parameter_config?: Maybe<Template_Parameter_Config_Mutation_Response>;
  /** update single row of the table: "template_parameter_config" */
  update_template_parameter_config_by_pk?: Maybe<Template_Parameter_Config>;
  /** update multiples rows of table: "template_parameter_config" */
  update_template_parameter_config_many?: Maybe<Array<Maybe<Template_Parameter_Config_Mutation_Response>>>;
  /** update multiples rows of table: "template_parameter" */
  update_template_parameter_many?: Maybe<Array<Maybe<Template_Parameter_Mutation_Response>>>;
  /** update data of the table: "template_parameter_standard" */
  update_template_parameter_standard?: Maybe<Template_Parameter_Standard_Mutation_Response>;
  /** update data of the table: "template_parameter_standard_attachments" */
  update_template_parameter_standard_attachments?: Maybe<Template_Parameter_Standard_Attachments_Mutation_Response>;
  /** update single row of the table: "template_parameter_standard_attachments" */
  update_template_parameter_standard_attachments_by_pk?: Maybe<Template_Parameter_Standard_Attachments>;
  /** update multiples rows of table: "template_parameter_standard_attachments" */
  update_template_parameter_standard_attachments_many?: Maybe<Array<Maybe<Template_Parameter_Standard_Attachments_Mutation_Response>>>;
  /** update single row of the table: "template_parameter_standard" */
  update_template_parameter_standard_by_pk?: Maybe<Template_Parameter_Standard>;
  /** update data of the table: "template_parameter_standard_group" */
  update_template_parameter_standard_group?: Maybe<Template_Parameter_Standard_Group_Mutation_Response>;
  /** update single row of the table: "template_parameter_standard_group" */
  update_template_parameter_standard_group_by_pk?: Maybe<Template_Parameter_Standard_Group>;
  /** update multiples rows of table: "template_parameter_standard_group" */
  update_template_parameter_standard_group_many?: Maybe<Array<Maybe<Template_Parameter_Standard_Group_Mutation_Response>>>;
  /** update multiples rows of table: "template_parameter_standard" */
  update_template_parameter_standard_many?: Maybe<Array<Maybe<Template_Parameter_Standard_Mutation_Response>>>;
  /** update data of the table: "template_quality_stages" */
  update_template_quality_stages?: Maybe<Template_Quality_Stages_Mutation_Response>;
  /** update single row of the table: "template_quality_stages" */
  update_template_quality_stages_by_pk?: Maybe<Template_Quality_Stages>;
  /** update multiples rows of table: "template_quality_stages" */
  update_template_quality_stages_many?: Maybe<Array<Maybe<Template_Quality_Stages_Mutation_Response>>>;
  /** update data of the table: "trade" */
  update_trade?: Maybe<Trade_Mutation_Response>;
  update_trade_amounts?: Maybe<UpdateTradeAmountMutation>;
  /** update data of the table: "trade_attachments" */
  update_trade_attachments?: Maybe<Trade_Attachments_Mutation_Response>;
  /** update single row of the table: "trade_attachments" */
  update_trade_attachments_by_pk?: Maybe<Trade_Attachments>;
  /** update multiples rows of table: "trade_attachments" */
  update_trade_attachments_many?: Maybe<Array<Maybe<Trade_Attachments_Mutation_Response>>>;
  /** update data of the table: "trade_buyer_gst_attachments" */
  update_trade_buyer_gst_attachments?: Maybe<Trade_Buyer_Gst_Attachments_Mutation_Response>;
  /** update single row of the table: "trade_buyer_gst_attachments" */
  update_trade_buyer_gst_attachments_by_pk?: Maybe<Trade_Buyer_Gst_Attachments>;
  /** update multiples rows of table: "trade_buyer_gst_attachments" */
  update_trade_buyer_gst_attachments_many?: Maybe<Array<Maybe<Trade_Buyer_Gst_Attachments_Mutation_Response>>>;
  /** update single row of the table: "trade" */
  update_trade_by_pk?: Maybe<Trade>;
  /** update data of the table: "trade_item" */
  update_trade_item?: Maybe<Trade_Item_Mutation_Response>;
  /** update single row of the table: "trade_item" */
  update_trade_item_by_pk?: Maybe<Trade_Item>;
  /** update multiples rows of table: "trade_item" */
  update_trade_item_many?: Maybe<Array<Maybe<Trade_Item_Mutation_Response>>>;
  /** update multiples rows of table: "trade" */
  update_trade_many?: Maybe<Array<Maybe<Trade_Mutation_Response>>>;
  /** update data of the table: "trade_seller_gst_attachments" */
  update_trade_seller_gst_attachments?: Maybe<Trade_Seller_Gst_Attachments_Mutation_Response>;
  /** update single row of the table: "trade_seller_gst_attachments" */
  update_trade_seller_gst_attachments_by_pk?: Maybe<Trade_Seller_Gst_Attachments>;
  /** update multiples rows of table: "trade_seller_gst_attachments" */
  update_trade_seller_gst_attachments_many?: Maybe<Array<Maybe<Trade_Seller_Gst_Attachments_Mutation_Response>>>;
  /** update data of the table: "trade_taxes" */
  update_trade_taxes?: Maybe<Trade_Taxes_Mutation_Response>;
  /** update single row of the table: "trade_taxes" */
  update_trade_taxes_by_pk?: Maybe<Trade_Taxes>;
  /** update multiples rows of table: "trade_taxes" */
  update_trade_taxes_many?: Maybe<Array<Maybe<Trade_Taxes_Mutation_Response>>>;
  /** update data of the table: "transaction" */
  update_transaction?: Maybe<Transaction_Mutation_Response>;
  /** update data of the table: "transaction_attachments" */
  update_transaction_attachments?: Maybe<Transaction_Attachments_Mutation_Response>;
  /** update single row of the table: "transaction_attachments" */
  update_transaction_attachments_by_pk?: Maybe<Transaction_Attachments>;
  /** update multiples rows of table: "transaction_attachments" */
  update_transaction_attachments_many?: Maybe<Array<Maybe<Transaction_Attachments_Mutation_Response>>>;
  /** update single row of the table: "transaction" */
  update_transaction_by_pk?: Maybe<Transaction>;
  /** update multiples rows of table: "transaction" */
  update_transaction_many?: Maybe<Array<Maybe<Transaction_Mutation_Response>>>;
  /** update data of the table: "transactions" */
  update_transactions?: Maybe<Transactions_Mutation_Response>;
  /** update data of the table: "transactions_attachments" */
  update_transactions_attachments?: Maybe<Transactions_Attachments_Mutation_Response>;
  /** update single row of the table: "transactions_attachments" */
  update_transactions_attachments_by_pk?: Maybe<Transactions_Attachments>;
  /** update multiples rows of table: "transactions_attachments" */
  update_transactions_attachments_many?: Maybe<Array<Maybe<Transactions_Attachments_Mutation_Response>>>;
  /** update single row of the table: "transactions" */
  update_transactions_by_pk?: Maybe<Transactions>;
  /** update multiples rows of table: "transactions" */
  update_transactions_many?: Maybe<Array<Maybe<Transactions_Mutation_Response>>>;
  /** update data of the table: "transition" */
  update_transition?: Maybe<Transition_Mutation_Response>;
  /** update data of the table: "transition_access" */
  update_transition_access?: Maybe<Transition_Access_Mutation_Response>;
  /** update single row of the table: "transition_access" */
  update_transition_access_by_pk?: Maybe<Transition_Access>;
  /** update multiples rows of table: "transition_access" */
  update_transition_access_many?: Maybe<Array<Maybe<Transition_Access_Mutation_Response>>>;
  /** update single row of the table: "transition" */
  update_transition_by_pk?: Maybe<Transition>;
  /** update data of the table: "transition_history" */
  update_transition_history?: Maybe<Transition_History_Mutation_Response>;
  /** update data of the table: "transition_history_attribute" */
  update_transition_history_attribute?: Maybe<Transition_History_Attribute_Mutation_Response>;
  /** update single row of the table: "transition_history_attribute" */
  update_transition_history_attribute_by_pk?: Maybe<Transition_History_Attribute>;
  /** update multiples rows of table: "transition_history_attribute" */
  update_transition_history_attribute_many?: Maybe<Array<Maybe<Transition_History_Attribute_Mutation_Response>>>;
  /** update single row of the table: "transition_history" */
  update_transition_history_by_pk?: Maybe<Transition_History>;
  /** update multiples rows of table: "transition_history" */
  update_transition_history_many?: Maybe<Array<Maybe<Transition_History_Mutation_Response>>>;
  /** update multiples rows of table: "transition" */
  update_transition_many?: Maybe<Array<Maybe<Transition_Mutation_Response>>>;
  /** update data of the table: "unit" */
  update_unit?: Maybe<Unit_Mutation_Response>;
  /** update single row of the table: "unit" */
  update_unit_by_pk?: Maybe<Unit>;
  /** update multiples rows of table: "unit" */
  update_unit_many?: Maybe<Array<Maybe<Unit_Mutation_Response>>>;
  /** update data of the table: "unit_measure" */
  update_unit_measure?: Maybe<Unit_Measure_Mutation_Response>;
  /** update single row of the table: "unit_measure" */
  update_unit_measure_by_pk?: Maybe<Unit_Measure>;
  /** update multiples rows of table: "unit_measure" */
  update_unit_measure_many?: Maybe<Array<Maybe<Unit_Measure_Mutation_Response>>>;
  /** update data of the table: "unregistered_user" */
  update_unregistered_user?: Maybe<Unregistered_User_Mutation_Response>;
  /** update single row of the table: "unregistered_user" */
  update_unregistered_user_by_pk?: Maybe<Unregistered_User>;
  /** update multiples rows of table: "unregistered_user" */
  update_unregistered_user_many?: Maybe<Array<Maybe<Unregistered_User_Mutation_Response>>>;
  /** update data of the table: "variety_agreement" */
  update_variety_agreement?: Maybe<Variety_Agreement_Mutation_Response>;
  /** update data of the table: "variety_agreement_agreement_co_owners" */
  update_variety_agreement_agreement_co_owners?: Maybe<Variety_Agreement_Agreement_Co_Owners_Mutation_Response>;
  /** update single row of the table: "variety_agreement_agreement_co_owners" */
  update_variety_agreement_agreement_co_owners_by_pk?: Maybe<Variety_Agreement_Agreement_Co_Owners>;
  /** update multiples rows of table: "variety_agreement_agreement_co_owners" */
  update_variety_agreement_agreement_co_owners_many?: Maybe<Array<Maybe<Variety_Agreement_Agreement_Co_Owners_Mutation_Response>>>;
  /** update single row of the table: "variety_agreement" */
  update_variety_agreement_by_pk?: Maybe<Variety_Agreement>;
  /** update data of the table: "variety_agreement_guarantor_agreements" */
  update_variety_agreement_guarantor_agreements?: Maybe<Variety_Agreement_Guarantor_Agreements_Mutation_Response>;
  /** update single row of the table: "variety_agreement_guarantor_agreements" */
  update_variety_agreement_guarantor_agreements_by_pk?: Maybe<Variety_Agreement_Guarantor_Agreements>;
  /** update multiples rows of table: "variety_agreement_guarantor_agreements" */
  update_variety_agreement_guarantor_agreements_many?: Maybe<Array<Maybe<Variety_Agreement_Guarantor_Agreements_Mutation_Response>>>;
  /** update multiples rows of table: "variety_agreement" */
  update_variety_agreement_many?: Maybe<Array<Maybe<Variety_Agreement_Mutation_Response>>>;
  /** update data of the table: "variety_grade" */
  update_variety_grade?: Maybe<Variety_Grade_Mutation_Response>;
  /** update single row of the table: "variety_grade" */
  update_variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** update multiples rows of table: "variety_grade" */
  update_variety_grade_many?: Maybe<Array<Maybe<Variety_Grade_Mutation_Response>>>;
  /** update data of the table: "variety_grade_photos" */
  update_variety_grade_photos?: Maybe<Variety_Grade_Photos_Mutation_Response>;
  /** update single row of the table: "variety_grade_photos" */
  update_variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** update multiples rows of table: "variety_grade_photos" */
  update_variety_grade_photos_many?: Maybe<Array<Maybe<Variety_Grade_Photos_Mutation_Response>>>;
  /** update data of the table: "variety_group" */
  update_variety_group?: Maybe<Variety_Group_Mutation_Response>;
  /** update single row of the table: "variety_group" */
  update_variety_group_by_pk?: Maybe<Variety_Group>;
  /** update multiples rows of table: "variety_group" */
  update_variety_group_many?: Maybe<Array<Maybe<Variety_Group_Mutation_Response>>>;
  /** update data of the table: "vt_core_tax" */
  update_vt_core_tax?: Maybe<Vt_Core_Tax_Mutation_Response>;
  /** update single row of the table: "vt_core_tax" */
  update_vt_core_tax_by_pk?: Maybe<Vt_Core_Tax>;
  /** update multiples rows of table: "vt_core_tax" */
  update_vt_core_tax_many?: Maybe<Array<Maybe<Vt_Core_Tax_Mutation_Response>>>;
  /** update data of the table: "weather_reference" */
  update_weather_reference?: Maybe<Weather_Reference_Mutation_Response>;
  /** update single row of the table: "weather_reference" */
  update_weather_reference_by_pk?: Maybe<Weather_Reference>;
  /** update multiples rows of table: "weather_reference" */
  update_weather_reference_many?: Maybe<Array<Maybe<Weather_Reference_Mutation_Response>>>;
  /** update data of the table: "workflow" */
  update_workflow?: Maybe<Workflow_Mutation_Response>;
  /** update single row of the table: "workflow" */
  update_workflow_by_pk?: Maybe<Workflow>;
  /** update data of the table: "workflow_current_logs" */
  update_workflow_current_logs?: Maybe<Workflow_Current_Logs_Mutation_Response>;
  /** update single row of the table: "workflow_current_logs" */
  update_workflow_current_logs_by_pk?: Maybe<Workflow_Current_Logs>;
  /** update multiples rows of table: "workflow_current_logs" */
  update_workflow_current_logs_many?: Maybe<Array<Maybe<Workflow_Current_Logs_Mutation_Response>>>;
  /** update multiples rows of table: "workflow" */
  update_workflow_many?: Maybe<Array<Maybe<Workflow_Mutation_Response>>>;
  /** update data of the table: "workflows" */
  update_workflows?: Maybe<Workflows_Mutation_Response>;
  /** update single row of the table: "workflows" */
  update_workflows_by_pk?: Maybe<Workflows>;
  /** update multiples rows of table: "workflows" */
  update_workflows_many?: Maybe<Array<Maybe<Workflows_Mutation_Response>>>;
  use_offer_stock?: Maybe<UseOfferStockMutation>;
  verify_otp?: Maybe<VerifyOtp>;
  verify_otp_for_existing_user?: Maybe<VerifyOtpForExistingUser>;
  /** This mutation will verify the OTP for new users */
  verify_otp_for_new_users?: Maybe<VerifyOtpForNewUsers>;
  verify_storage_location_agreement?: Maybe<VerifyStorageLocationAgreementMutation>;
  verify_token?: Maybe<Verify>;
  verify_trade_otp?: Maybe<VerifyTradeOtp>;
};


/** mutation root */
export type Mutation_RootAdd_Advance_TransactionArgs = {
  input: AdvanceTransactionInput;
};


/** mutation root */
export type Mutation_RootAdd_Result_CommentArgs = {
  comment: Scalars['String'];
  created_by_id?: InputMaybe<Scalars['String']>;
  result_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootAdd_Update_Agreement_TransactionArgs = {
  agreement_id: Scalars['ID'];
  input: AgreementTransactionInput;
};


/** mutation root */
export type Mutation_RootAdd_Update_Base_UserArgs = {
  base_user?: InputMaybe<BaseUserInput>;
  create_team?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_BusinessArgs = {
  address?: InputMaybe<KiteAddressInput>;
  alternate_email?: InputMaybe<Scalars['String']>;
  business_documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  commodities_supplied?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  data_consent?: InputMaybe<KiteMediaInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  incorporated_on?: InputMaybe<Scalars['Date']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  payment_options?: InputMaybe<Array<InputMaybe<PaymentDetailInput>>>;
  photo?: InputMaybe<KiteMediaInput>;
  primary_poc?: InputMaybe<BaseUserInput>;
  secondary_number?: InputMaybe<Scalars['String']>;
  user_documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Credit_AssessmentArgs = {
  input?: InputMaybe<AddUpdateCreditMutationInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_DemandArgs = {
  input: UpsertDemandInput;
};


/** mutation root */
export type Mutation_RootAdd_Update_Dock_DetailArgs = {
  dock_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  supervisor_id?: InputMaybe<Scalars['ID']>;
  trip_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_General_RequestArgs = {
  created_in_id?: InputMaybe<Scalars['ID']>;
  department?: InputMaybe<DepartmentInput>;
  observation_remark?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Array<InputMaybe<SampleObservationInput>>>;
  primary_location_entity_type: Scalars['String'];
  primary_location_reference_id: Scalars['String'];
  recommendations?: InputMaybe<Scalars['String']>;
  recorded_at?: InputMaybe<AddressInput>;
  request_category_codename?: InputMaybe<Scalars['String']>;
  request_id?: InputMaybe<Scalars['ID']>;
  sample_id?: InputMaybe<Scalars['ID']>;
  sample_weight?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['ID']>;
  unit_codename?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Internal_RequestsArgs = {
  category_reference_id?: InputMaybe<Scalars['String']>;
  crop_reference_id: Scalars['String'];
  department?: InputMaybe<DepartmentInput>;
  observation_remark?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Array<InputMaybe<SampleObservationInput>>>;
  plot_crop_name: Scalars['String'];
  plot_crop_reference_id: Scalars['String'];
  quality_stage_reference_id?: InputMaybe<Scalars['String']>;
  recommendations?: InputMaybe<Scalars['String']>;
  recorded_at?: InputMaybe<AddressInput>;
  request_id?: InputMaybe<Scalars['ID']>;
  sample_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Issuance_NoteArgs = {
  input?: InputMaybe<IssuanceNoteInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_OfferArgs = {
  input: UpsertOfferInput;
};


/** mutation root */
export type Mutation_RootAdd_Update_Order_TransactionArgs = {
  amount: Scalars['Float'];
  attachment?: InputMaybe<MediaGlInput>;
  id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  order_id: Scalars['ID'];
  order_status?: InputMaybe<Scalars['String']>;
  payment_method?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  trip_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Production_Final_TradeArgs = {
  input?: InputMaybe<ProductionFinalTradeInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Production_Planning_TradeArgs = {
  input?: InputMaybe<ProductionTradeInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_ReceiptArgs = {
  input?: InputMaybe<ReceiptInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_ResultArgs = {
  test_request_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Sample_ObservationsArgs = {
  observations?: InputMaybe<Array<InputMaybe<SampleObservationInput>>>;
  sample_id: Scalars['ID'];
  test_request_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootAdd_Update_Setutrade_TripArgs = {
  input?: InputMaybe<TradeTripMutationInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Storage_LocationArgs = {
  input: UpsertStorageLocationInput;
};


/** mutation root */
export type Mutation_RootAdd_Update_Test_RequestsArgs = {
  parent_request_id: Scalars['ID'];
  test_requests: Array<InputMaybe<TestRequestInput>>;
};


/** mutation root */
export type Mutation_RootAdd_Update_TradeArgs = {
  input?: InputMaybe<TradeInput>;
};


/** mutation root */
export type Mutation_RootAdd_Update_Trip_DetailArgs = {
  date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  trip?: InputMaybe<Scalars['ID']>;
  vehicle_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAgent_LoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootApprove_CreditArgs = {
  input?: InputMaybe<ApproveCreditMutationInput>;
};


/** mutation root */
export type Mutation_RootApprove_Credit_Wallet_RequestArgs = {
  input: ApproveCreditWalletRequestInput;
};


/** mutation root */
export type Mutation_RootApprove_Over_Draft_RequestArgs = {
  flow_kind?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootAssociate_User_With_OrganisationsArgs = {
  organisation_ids: Array<InputMaybe<Scalars['String']>>;
  reference_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootBroadcast_ConsentsArgs = {
  send_to_buyer?: InputMaybe<Scalars['Boolean']>;
  send_to_seller?: InputMaybe<Scalars['Boolean']>;
  trade_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootBulk_Update_Base_User_CompaniesArgs = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  users: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootBulk_Update_OrderArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootBulk_Update_Result_GradeArgs = {
  input: BulkUpdateResultGradesInput;
};


/** mutation root */
export type Mutation_RootCancel_InvoiceArgs = {
  invoice_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootCancel_TransactionArgs = {
  transaction_ids: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootChange_Credit_StatusArgs = {
  input?: InputMaybe<ChangeCreditStatusInput>;
};


/** mutation root */
export type Mutation_RootClose_Advance_PaymentArgs = {
  advance_payment_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootClose_Plot_CropArgs = {
  plot_crop_codename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCopy_Trade_To_InwardArgs = {
  trade_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootCreate_Credit_Wallet_RequestArgs = {
  input: CreateCreditWalletRequestInput;
};


/** mutation root */
export type Mutation_RootCreate_Expenses_ConfigArgs = {
  department_id: Scalars['Int'];
  expenses_config: Array<InputMaybe<ExpensesConfigSchema>>;
  trade_kind: Scalars['String'];
  trade_mode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreate_Guarantor_AgreementArgs = {
  agreement_invoice_ids: Array<InputMaybe<Scalars['ID']>>;
  agreement_plot_ids: Array<InputMaybe<Scalars['ID']>>;
  agreement_type: Scalars['String'];
  amount?: InputMaybe<Scalars['Decimal']>;
  area_extension_details?: InputMaybe<Array<InputMaybe<GuarantorAreaExtensionDetailInput>>>;
  guarantee_nursery_fee?: InputMaybe<Scalars['Boolean']>;
  guarantee_registration_fee?: InputMaybe<Scalars['Boolean']>;
  guarantors: Scalars['GenericScalar'];
  metadata?: InputMaybe<Scalars['GenericScalar']>;
  payable_additional_amount?: InputMaybe<Scalars['Decimal']>;
  plot_coverage?: InputMaybe<Array<InputMaybe<GuarantorPlotCoverageInput>>>;
  previous_amount?: InputMaybe<Scalars['Decimal']>;
  reason_for_amendment?: InputMaybe<Scalars['String']>;
  signed_by_details?: InputMaybe<Scalars['GenericScalar']>;
  total_agreement_amount?: InputMaybe<Scalars['Decimal']>;
  variety_agreement_id: Scalars['ID'];
  witnesses: Scalars['GenericScalar'];
};


/** mutation root */
export type Mutation_RootCreate_Over_Draft_RequestArgs = {
  trade_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootCreate_Tnc_ConfigArgs = {
  conditions: Scalars['String'];
  department_id: Scalars['Int'];
  trade_kind: Scalars['String'];
  trade_mode: Scalars['String'];
  trade_party: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreate_Update_Base_UserArgs = {
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  business_type?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  date_of_birth?: InputMaybe<Scalars['Date']>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  education?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  gender?: InputMaybe<Scalars['String']>;
  is_shareholder?: InputMaybe<Scalars['Boolean']>;
  last_name: Scalars['String'];
  location?: InputMaybe<LonLatInput>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  number_country_code?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  pincode?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  secondary_number_country_code?: InputMaybe<Scalars['String']>;
  subscription_type?: InputMaybe<Scalars['String']>;
  user_network_codenames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  user_type?: InputMaybe<Scalars['String']>;
  village_codename?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootDelete_Action_LogArgs = {
  where: Action_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Action_Log_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AgentArgs = {
  where: Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agent_CompanyArgs = {
  where: Agent_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agent_Company_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agent_RoleArgs = {
  where: Agent_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agent_Role_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_OwnerArgs = {
  where: Agreement_Co_Owner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_Owner_Agreement_InvoicesArgs = {
  where: Agreement_Co_Owner_Agreement_Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_Owner_Agreement_Invoices_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_Owner_Agreement_PlotsArgs = {
  where: Agreement_Co_Owner_Agreement_Plots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_Owner_Agreement_Plots_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_Owner_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_Owner_Legal_AgreementArgs = {
  where: Agreement_Co_Owner_Legal_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Co_Owner_Legal_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_InvoiceArgs = {
  where: Agreement_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Invoice_Agreement_Invoice_ItemsArgs = {
  where: Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Invoice_Agreement_Invoice_Items_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Invoice_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Invoice_ItemArgs = {
  where: Agreement_Invoice_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Invoice_Item_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Invoice_TransactionArgs = {
  where: Agreement_Invoice_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Invoice_Transaction_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Agreement_PlotArgs = {
  where: Agreement_Plot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreement_Plot_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Amendment_CaseArgs = {
  where: Amendment_Case_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Amendment_Case_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_GroupArgs = {
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_PermissionsArgs = {
  where: Auth_Group_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_PermissionArgs = {
  where: Auth_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_UserArgs = {
  where: Base_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Address_BookArgs = {
  where: Base_User_Address_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Address_Book_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_CompaniesArgs = {
  where: Base_User_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_DepartmentsArgs = {
  where: Base_User_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Departments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_GroupsArgs = {
  where: Base_User_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_NetworkArgs = {
  where: Base_User_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Base_User_User_PermissionsArgs = {
  where: Base_User_User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BrandArgs = {
  where: Brand_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_CompanyArgs = {
  where: Brand_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_BreederArgs = {
  where: Breeder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Breeder_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BusinessArgs = {
  where: Business_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_Commodities_SuppliedArgs = {
  where: Business_Commodities_Supplied_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Commodities_Supplied_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_CompaniesArgs = {
  where: Business_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_FieldArgs = {
  where: Business_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Field_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_GroupArgs = {
  where: Business_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_Group_NetworkArgs = {
  where: Business_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_GroupsArgs = {
  where: Business_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_NetworkArgs = {
  where: Business_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Business_Secondary_PocsArgs = {
  where: Business_Secondary_Pocs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Business_Secondary_Pocs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_By_Pk_Eagle_AddressArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_By_Pk_Eagle_MediaArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_CommodityArgs = {
  where: Commodity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Commodity_VarietyArgs = {
  where: Commodity_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Variety_Secondary_GroupsArgs = {
  where: Commodity_Variety_Secondary_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commodity_Variety_Secondary_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyArgs = {
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Company_CategoriesArgs = {
  where: Company_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Categories_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Company_CategoryArgs = {
  where: Company_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Category_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Company_Share_HolderArgs = {
  where: Company_Share_Holder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Share_Holder_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CropArgs = {
  where: Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_GroupArgs = {
  where: Crop_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_InfestationArgs = {
  where: Crop_Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Infestation_AttachmentArgs = {
  where: Crop_Infestation_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Infestation_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_MilestoneArgs = {
  where: Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_RootstockArgs = {
  where: Crop_Rootstock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Rootstock_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_VarietyArgs = {
  where: Crop_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Variety_BreederArgs = {
  where: Crop_Variety_Breeder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Variety_Breeder_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Crop_YearArgs = {
  where: Crop_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Crop_Year_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Cultivation_TypeArgs = {
  where: Cultivation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cultivation_Type_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DepartmentArgs = {
  where: Department_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Department_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Department_Payment_DetailArgs = {
  where: Department_Payment_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Department_Payment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DeviceArgs = {
  where: Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Device_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Django_Content_TypeArgs = {
  where: Django_Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Django_Content_Type_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentArgs = {
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_AttachmentsArgs = {
  where: Document_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_DataArgs = {
  where: Document_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Export_LogArgs = {
  where: Document_Export_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Export_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Document_KindArgs = {
  where: Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Kind_Data_FieldArgs = {
  where: Document_Kind_Data_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Kind_Data_Field_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_ReportArgs = {
  where: Document_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Report_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Document_RevisionArgs = {
  where: Document_Revision_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Revision_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Eagle_AddressArgs = {
  where: Eagle_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Eagle_MediaArgs = {
  where: Eagle_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_StateArgs = {
  where: Entity_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_State_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Evaluation_CriteriaArgs = {
  where: Evaluation_Criteria_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Evaluation_Criteria_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Evaluation_TagArgs = {
  where: Evaluation_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Evaluation_Tag_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_ExpenseArgs = {
  where: Expense_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Expense_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_External_ApplicationArgs = {
  where: External_Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_External_Application_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_External_EntityArgs = {
  where: External_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_External_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_External_Entity_GroupArgs = {
  where: External_Entity_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_External_Entity_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_External_ReferenceArgs = {
  where: External_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_External_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FarmArgs = {
  where: Farm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farm_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Farm_NetworkArgs = {
  where: Farm_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farm_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FieldArgs = {
  where: Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Field_NetworkArgs = {
  where: Field_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Field_Weather_LocationArgs = {
  where: Field_Weather_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Weather_Location_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_GradeArgs = {
  where: Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Grade_CompanyArgs = {
  where: Grade_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Grade_PriceArgs = {
  where: Grade_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_Price_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_AgreementArgs = {
  where: Guarantor_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_Agreement_Agreement_InvoicesArgs = {
  where: Guarantor_Agreement_Agreement_Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_Agreement_Agreement_Invoices_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_Agreement_Agreement_PlotsArgs = {
  where: Guarantor_Agreement_Agreement_Plots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_Agreement_Agreement_Plots_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_Agreement_Area_Extension_DetailArgs = {
  where: Guarantor_Agreement_Area_Extension_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_Agreement_Area_Extension_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Guarantor_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InfestationArgs = {
  where: Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InstrumentArgs = {
  where: Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Instrument_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Instrument_DepartmentsArgs = {
  where: Instrument_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Instrument_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Instrument_KindArgs = {
  where: Instrument_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Instrument_Kind_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Issuance_Note_AttachmentsArgs = {
  where: Issuance_Note_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Issuance_Note_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Kite_NotificationArgs = {
  where: Kite_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kite_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Kite_Quality_StageArgs = {
  where: Kite_Quality_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kite_Quality_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LaboratoryArgs = {
  where: Laboratory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Laboratory_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Laboratory_OrganisationsArgs = {
  where: Laboratory_Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Laboratory_Organisations_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Legal_AgreementArgs = {
  where: Legal_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legal_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MarketArgs = {
  where: Market_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Market_Allowed_DepartmentsArgs = {
  where: Market_Allowed_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Market_Allowed_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Market_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_MediaArgs = {
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Media_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MilestoneArgs = {
  where: Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_GroupArgs = {
  where: Mutual_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_MembershipArgs = {
  where: Mutual_Group_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Membership_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_NetworkArgs = {
  where: Mutual_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_RoleArgs = {
  where: Mutual_Group_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Role_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Weather_StationArgs = {
  where: Mutual_Group_Weather_Station_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mutual_Group_Weather_Station_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_NationalityArgs = {
  where: Nationality_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nationality_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_NetworkArgs = {
  where: Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_NomineesArgs = {
  where: Nominees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nominees_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Nominees_DocumentsArgs = {
  where: Nominees_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nominees_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_ProviderArgs = {
  where: Notification_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Provider_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_TriggerArgs = {
  where: Notification_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Dashboard_StatsArgs = {
  where: Org_Dashboard_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Dashboard_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_AssociationArgs = {
  where: Org_Team_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_Primary_CropArgs = {
  where: Org_Team_Primary_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_Primary_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_User_Bank_AssociationArgs = {
  where: Org_Team_User_Bank_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_User_Bank_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_User_CropArgs = {
  where: Org_Team_User_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_User_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_User_Document_AssociationArgs = {
  where: Org_Team_User_Document_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Team_User_Document_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_User_AssociationArgs = {
  where: Org_User_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_User_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_User_Group_Mandatory_DocumentArgs = {
  where: Org_User_Group_Mandatory_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_User_Group_Mandatory_Document_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Org_User_Group_Status_SnapshotArgs = {
  where: Org_User_Group_Status_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_User_Group_Status_Snapshot_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Org_User_Primary_CropArgs = {
  where: Org_User_Primary_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_User_Primary_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationArgs = {
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Commodity_Variety_ConfigArgs = {
  where: Organisation_Commodity_Variety_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Commodity_Variety_Config_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Commodity_Variety_Config_TaxesArgs = {
  where: Organisation_Commodity_Variety_Config_Taxes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Commodity_Variety_Config_Taxes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_CropArgs = {
  where: Organisation_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Document_KindArgs = {
  where: Organisation_Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_PreferencesArgs = {
  where: Organisation_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Preferences_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_SeasonArgs = {
  where: Organisation_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Season_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_CategoryArgs = {
  where: Pallet_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_CustomerArgs = {
  where: Pallet_Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Customer_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_InspectionArgs = {
  where: Pallet_Inspection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspection_AttachmentsArgs = {
  where: Pallet_Inspection_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspection_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspection_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspection_ReportsArgs = {
  where: Pallet_Inspection_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspection_Reports_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_InspectionkindArgs = {
  where: Pallet_Inspectionkind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspectionkind_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_InspectionobservationArgs = {
  where: Pallet_Inspectionobservation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspectionobservation_AttachmentsArgs = {
  where: Pallet_Inspectionobservation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspectionobservation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Inspectionobservation_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_LineArgs = {
  where: Pallet_Line_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Line_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_LocationArgs = {
  where: Pallet_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Location_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_PackagingArgs = {
  where: Pallet_Packaging_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packaging_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_PackagingkindArgs = {
  where: Pallet_Packagingkind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packagingkind_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_PackingArgs = {
  where: Pallet_Packing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packing_AttachmentsArgs = {
  where: Pallet_Packing_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packing_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packing_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packing_WeightsArgs = {
  where: Pallet_Packing_Weights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packing_Weights_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_PackingkindArgs = {
  where: Pallet_Packingkind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packingkind_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_PackingweightArgs = {
  where: Pallet_Packingweight_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packingweight_AttachmentsArgs = {
  where: Pallet_Packingweight_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packingweight_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Packingweight_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_PrintingmatterArgs = {
  where: Pallet_Printingmatter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Printingmatter_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_PunnetconditionArgs = {
  where: Pallet_Punnetcondition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Punnetcondition_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_SamplinglocationArgs = {
  where: Pallet_Samplinglocation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Samplinglocation_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_SkuArgs = {
  where: Pallet_Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Sku_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_SkutypeArgs = {
  where: Pallet_Skutype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Skutype_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Pallet_VarietyArgs = {
  where: Pallet_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pallet_Variety_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_DetailArgs = {
  where: Payment_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Detail_AttachmentsArgs = {
  where: Payment_Detail_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Detail_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_MethodArgs = {
  where: Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Method_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PlotArgs = {
  where: Plot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_CropArgs = {
  where: Plot_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_AgentArgs = {
  where: Plot_Crop_Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Cultivation_TypeArgs = {
  where: Plot_Crop_Cultivation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Cultivation_Type_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Historic_SeasonArgs = {
  where: Plot_Crop_Historic_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Historic_Season_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_MilestoneArgs = {
  where: Plot_Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_NetworkArgs = {
  where: Plot_Crop_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_RootstockArgs = {
  where: Plot_Crop_Rootstock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Rootstock_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Status_HistoryArgs = {
  where: Plot_Crop_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Crop_Status_History_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_NetworkArgs = {
  where: Plot_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Network_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_StatusArgs = {
  where: Plot_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Status_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Status_ConfigArgs = {
  where: Plot_Status_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Status_Config_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Plot_Status_Config_Required_Qc_StagesArgs = {
  where: Plot_Status_Config_Required_Qc_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Plot_Status_Config_Required_Qc_Stages_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Primary_Growth_StageArgs = {
  where: Primary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Primary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ParameterArgs = {
  where: Quality_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_Parameter_CategoryArgs = {
  where: Quality_Parameter_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_Parameter_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_StageArgs = {
  where: Quality_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_Stage_Allowed_Template_CategoryArgs = {
  where: Quality_Stage_Allowed_Template_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_Stage_Allowed_Template_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_Stage_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_RegionArgs = {
  where: Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Region_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Region_GroupArgs = {
  where: Region_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Region_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RequestArgs = {
  where: Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Request_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Request_CategoryArgs = {
  where: Request_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Request_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Request_ParametersArgs = {
  where: Request_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Request_Parameters_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Request_Secondary_LocationsArgs = {
  where: Request_Secondary_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Request_Secondary_Locations_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Request_TemplatesArgs = {
  where: Request_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Request_Templates_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_ResultArgs = {
  where: Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Result_CommentArgs = {
  where: Result_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Comment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Result_EvaluationArgs = {
  where: Result_Evaluation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Evaluation_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Result_Evaluation_Evaluated_TagsArgs = {
  where: Result_Evaluation_Evaluated_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Evaluation_Evaluated_Tags_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Result_MediaArgs = {
  where: Result_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Result_ObservationArgs = {
  where: Result_Observation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Observation_AttachmentsArgs = {
  where: Result_Observation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Observation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Result_Observation_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Result_Observation_Evaluated_TagsArgs = {
  where: Result_Observation_Evaluated_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Result_Observation_Evaluated_Tags_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_RoleArgs = {
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RootstockArgs = {
  where: Rootstock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rootstock_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SampleArgs = {
  where: Sample_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sample_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Sample_MediaArgs = {
  where: Sample_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sample_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Sample_ObservationArgs = {
  where: Sample_Observation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sample_Observation_AttachmentsArgs = {
  where: Sample_Observation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sample_Observation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Sample_Observation_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Secondary_Growth_StageArgs = {
  where: Secondary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Secondary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shareholder_ApplicationsArgs = {
  where: Shareholder_Applications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shareholder_Applications_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ShareholdersArgs = {
  where: Shareholders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shareholders_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Si_UnitArgs = {
  where: Si_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Si_Unit_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Si_Unit_MeasureArgs = {
  where: Si_Unit_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Si_Unit_Measure_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SkuArgs = {
  where: Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sku_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Sku_KindArgs = {
  where: Sku_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sku_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SoilArgs = {
  where: Soil_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Soil_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stage_ActionsArgs = {
  where: Stage_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stage_Actions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stage_LogsArgs = {
  where: Stage_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stage_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_StagesArgs = {
  where: Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stages_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stages_SubscribersArgs = {
  where: Stages_Subscribers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stages_Subscribers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_StateArgs = {
  where: State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_State_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Survey_ParametersArgs = {
  where: Survey_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Survey_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Survey_Response_ItemsArgs = {
  where: Survey_Response_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Survey_Response_Items_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Survey_ResponsesArgs = {
  where: Survey_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Survey_Responses_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Survey_UsersArgs = {
  where: Survey_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Survey_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Survey_YearArgs = {
  where: Survey_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Survey_Year_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SurveysArgs = {
  where: Surveys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Surveys_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TemplateArgs = {
  where: Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_CategoryArgs = {
  where: Template_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Category_Allowed_GroupsArgs = {
  where: Template_Category_Allowed_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Category_Allowed_Groups_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Category_Allowed_Parameter_CategoriesArgs = {
  where: Template_Category_Allowed_Parameter_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Category_Allowed_Parameter_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_CompanyArgs = {
  where: Template_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_DepartmentsArgs = {
  where: Template_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_EvaluationArgs = {
  where: Template_Evaluation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Evaluation_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Evaluation_ConfigArgs = {
  where: Template_Evaluation_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Evaluation_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Evaluation_TemplatesArgs = {
  where: Template_Evaluation_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Evaluation_Templates_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_ParameterArgs = {
  where: Template_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_ConfigArgs = {
  where: Template_Parameter_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_StandardArgs = {
  where: Template_Parameter_Standard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_Standard_AttachmentsArgs = {
  where: Template_Parameter_Standard_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_Standard_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_Standard_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_Standard_GroupArgs = {
  where: Template_Parameter_Standard_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Parameter_Standard_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Template_Quality_StagesArgs = {
  where: Template_Quality_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Template_Quality_Stages_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_AttachmentsArgs = {
  where: Trade_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_Buyer_Gst_AttachmentsArgs = {
  where: Trade_Buyer_Gst_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Buyer_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Trade_Seller_Gst_AttachmentsArgs = {
  where: Trade_Seller_Gst_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trade_Seller_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_TransactionsArgs = {
  where: Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transactions_AttachmentsArgs = {
  where: Transactions_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transactions_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Transactions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TransitionArgs = {
  where: Transition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transition_AccessArgs = {
  where: Transition_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transition_Access_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Transition_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Transition_HistoryArgs = {
  where: Transition_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transition_History_AttributeArgs = {
  where: Transition_History_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transition_History_Attribute_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Transition_History_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_UnitArgs = {
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Unit_MeasureArgs = {
  where: Unit_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_Measure_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_AgreementArgs = {
  where: Variety_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Agreement_Agreement_Co_OwnersArgs = {
  where: Variety_Agreement_Agreement_Co_Owners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Agreement_Agreement_Co_Owners_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_Agreement_Guarantor_AgreementsArgs = {
  where: Variety_Agreement_Guarantor_Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Agreement_Guarantor_Agreements_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_GradeArgs = {
  where: Variety_Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Grade_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_Grade_PhotosArgs = {
  where: Variety_Grade_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Grade_Photos_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Variety_GroupArgs = {
  where: Variety_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variety_Group_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vt_Core_TaxArgs = {
  where: Vt_Core_Tax_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vt_Core_Tax_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Weather_ReferenceArgs = {
  where: Weather_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weather_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WorkflowArgs = {
  where: Workflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Current_LogsArgs = {
  where: Workflow_Current_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_Current_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_WorkflowsArgs = {
  where: Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflows_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDump_TradesArgs = {
  trade_ids: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootEmployee_OnboardArgs = {
  default_company_id: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last_name: Scalars['String'];
  number: Scalars['String'];
  organisation_uid: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootExport_ReportArgs = {
  params?: InputMaybe<Scalars['GenericScalar']>;
  reference_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootGenerate_Agent_TokenArgs = {
  agent_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootGenerate_EvaluationsArgs = {
  result_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootGenerate_Generic_TokenArgs = {
  agent_id?: InputMaybe<Scalars['ID']>;
  role?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootGenerate_Initial_Pallet_RequestArgs = {
  department?: InputMaybe<DepartmentInput>;
  pallet_no: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGenerate_InvoicesArgs = {
  department_id?: InputMaybe<Scalars['ID']>;
  trade_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootGenerate_OtpArgs = {
  extra_variables?: InputMaybe<Scalars['GenericScalar']>;
  number: Scalars['String'];
  provider_uid?: InputMaybe<Scalars['String']>;
  template_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootGenerate_ResultsArgs = {
  sample_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootGenerate_Trade_OtpArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootInsert_Action_LogArgs = {
  objects: Array<Action_Log_Insert_Input>;
  on_conflict?: InputMaybe<Action_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Action_Log_OneArgs = {
  object: Action_Log_Insert_Input;
  on_conflict?: InputMaybe<Action_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advance_PaymentArgs = {
  objects: Array<Advance_Payment_Insert_Input>;
  on_conflict?: InputMaybe<Advance_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advance_Payment_OneArgs = {
  object: Advance_Payment_Insert_Input;
  on_conflict?: InputMaybe<Advance_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgentArgs = {
  objects: Array<Agent_Insert_Input>;
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_CompanyArgs = {
  objects: Array<Agent_Company_Insert_Input>;
  on_conflict?: InputMaybe<Agent_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_Company_OneArgs = {
  object: Agent_Company_Insert_Input;
  on_conflict?: InputMaybe<Agent_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_OneArgs = {
  object: Agent_Insert_Input;
  on_conflict?: InputMaybe<Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_RoleArgs = {
  objects: Array<Agent_Role_Insert_Input>;
  on_conflict?: InputMaybe<Agent_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agent_Role_OneArgs = {
  object: Agent_Role_Insert_Input;
  on_conflict?: InputMaybe<Agent_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_OwnerArgs = {
  objects: Array<Agreement_Co_Owner_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Co_Owner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_Owner_Agreement_InvoicesArgs = {
  objects: Array<Agreement_Co_Owner_Agreement_Invoices_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_Owner_Agreement_Invoices_OneArgs = {
  object: Agreement_Co_Owner_Agreement_Invoices_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_Owner_Agreement_PlotsArgs = {
  objects: Array<Agreement_Co_Owner_Agreement_Plots_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_Owner_Agreement_Plots_OneArgs = {
  object: Agreement_Co_Owner_Agreement_Plots_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_Owner_Legal_AgreementArgs = {
  objects: Array<Agreement_Co_Owner_Legal_Agreement_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_Owner_Legal_Agreement_OneArgs = {
  object: Agreement_Co_Owner_Legal_Agreement_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Co_Owner_OneArgs = {
  object: Agreement_Co_Owner_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Co_Owner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_InvoiceArgs = {
  objects: Array<Agreement_Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Invoice_Agreement_Invoice_ItemsArgs = {
  objects: Array<Agreement_Invoice_Agreement_Invoice_Items_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Invoice_Agreement_Invoice_Items_OneArgs = {
  object: Agreement_Invoice_Agreement_Invoice_Items_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Invoice_ItemArgs = {
  objects: Array<Agreement_Invoice_Item_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Invoice_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Invoice_Item_OneArgs = {
  object: Agreement_Invoice_Item_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Invoice_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Invoice_OneArgs = {
  object: Agreement_Invoice_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Invoice_TransactionArgs = {
  objects: Array<Agreement_Invoice_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Invoice_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Invoice_Transaction_OneArgs = {
  object: Agreement_Invoice_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Invoice_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_PlotArgs = {
  objects: Array<Agreement_Plot_Insert_Input>;
  on_conflict?: InputMaybe<Agreement_Plot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreement_Plot_OneArgs = {
  object: Agreement_Plot_Insert_Input;
  on_conflict?: InputMaybe<Agreement_Plot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Amendment_CaseArgs = {
  objects: Array<Amendment_Case_Insert_Input>;
  on_conflict?: InputMaybe<Amendment_Case_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Amendment_Case_OneArgs = {
  object: Amendment_Case_Insert_Input;
  on_conflict?: InputMaybe<Amendment_Case_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_GroupArgs = {
  objects: Array<Auth_Group_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_OneArgs = {
  object: Auth_Group_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_PermissionsArgs = {
  objects: Array<Auth_Group_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Group_Permissions_OneArgs = {
  object: Auth_Group_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Auth_Group_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_PermissionArgs = {
  objects: Array<Auth_Permission_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Permission_OneArgs = {
  object: Auth_Permission_Insert_Input;
  on_conflict?: InputMaybe<Auth_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_UserArgs = {
  objects: Array<Base_User_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Address_BookArgs = {
  objects: Array<Base_User_Address_Book_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Address_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Address_Book_OneArgs = {
  object: Base_User_Address_Book_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Address_Book_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_CompaniesArgs = {
  objects: Array<Base_User_Companies_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Companies_OneArgs = {
  object: Base_User_Companies_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_DepartmentsArgs = {
  objects: Array<Base_User_Departments_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Departments_OneArgs = {
  object: Base_User_Departments_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_GroupsArgs = {
  objects: Array<Base_User_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Groups_OneArgs = {
  object: Base_User_Groups_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_NetworkArgs = {
  objects: Array<Base_User_Network_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_Network_OneArgs = {
  object: Base_User_Network_Insert_Input;
  on_conflict?: InputMaybe<Base_User_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_OneArgs = {
  object: Base_User_Insert_Input;
  on_conflict?: InputMaybe<Base_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_User_PermissionsArgs = {
  objects: Array<Base_User_User_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Base_User_User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_User_User_Permissions_OneArgs = {
  object: Base_User_User_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Base_User_User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BrandArgs = {
  objects: Array<Brand_Insert_Input>;
  on_conflict?: InputMaybe<Brand_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_CompanyArgs = {
  objects: Array<Brand_Company_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Company_OneArgs = {
  object: Brand_Company_Insert_Input;
  on_conflict?: InputMaybe<Brand_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_OneArgs = {
  object: Brand_Insert_Input;
  on_conflict?: InputMaybe<Brand_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BreederArgs = {
  objects: Array<Breeder_Insert_Input>;
  on_conflict?: InputMaybe<Breeder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Breeder_OneArgs = {
  object: Breeder_Insert_Input;
  on_conflict?: InputMaybe<Breeder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BusinessArgs = {
  objects: Array<Business_Insert_Input>;
  on_conflict?: InputMaybe<Business_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Commodities_SuppliedArgs = {
  objects: Array<Business_Commodities_Supplied_Insert_Input>;
  on_conflict?: InputMaybe<Business_Commodities_Supplied_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Commodities_Supplied_OneArgs = {
  object: Business_Commodities_Supplied_Insert_Input;
  on_conflict?: InputMaybe<Business_Commodities_Supplied_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_CompaniesArgs = {
  objects: Array<Business_Companies_Insert_Input>;
  on_conflict?: InputMaybe<Business_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Companies_OneArgs = {
  object: Business_Companies_Insert_Input;
  on_conflict?: InputMaybe<Business_Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_FieldArgs = {
  objects: Array<Business_Field_Insert_Input>;
  on_conflict?: InputMaybe<Business_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Field_OneArgs = {
  object: Business_Field_Insert_Input;
  on_conflict?: InputMaybe<Business_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_GroupArgs = {
  objects: Array<Business_Group_Insert_Input>;
  on_conflict?: InputMaybe<Business_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Group_NetworkArgs = {
  objects: Array<Business_Group_Network_Insert_Input>;
  on_conflict?: InputMaybe<Business_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Group_Network_OneArgs = {
  object: Business_Group_Network_Insert_Input;
  on_conflict?: InputMaybe<Business_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Group_OneArgs = {
  object: Business_Group_Insert_Input;
  on_conflict?: InputMaybe<Business_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_GroupsArgs = {
  objects: Array<Business_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Business_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Groups_OneArgs = {
  object: Business_Groups_Insert_Input;
  on_conflict?: InputMaybe<Business_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_NetworkArgs = {
  objects: Array<Business_Network_Insert_Input>;
  on_conflict?: InputMaybe<Business_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Network_OneArgs = {
  object: Business_Network_Insert_Input;
  on_conflict?: InputMaybe<Business_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_OneArgs = {
  object: Business_Insert_Input;
  on_conflict?: InputMaybe<Business_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Secondary_PocsArgs = {
  objects: Array<Business_Secondary_Pocs_Insert_Input>;
  on_conflict?: InputMaybe<Business_Secondary_Pocs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Business_Secondary_Pocs_OneArgs = {
  object: Business_Secondary_Pocs_Insert_Input;
  on_conflict?: InputMaybe<Business_Secondary_Pocs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommodityArgs = {
  objects: Array<Commodity_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_OneArgs = {
  object: Commodity_Insert_Input;
  on_conflict?: InputMaybe<Commodity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_VarietyArgs = {
  objects: Array<Commodity_Variety_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Variety_OneArgs = {
  object: Commodity_Variety_Insert_Input;
  on_conflict?: InputMaybe<Commodity_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Variety_Secondary_GroupsArgs = {
  objects: Array<Commodity_Variety_Secondary_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Commodity_Variety_Secondary_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commodity_Variety_Secondary_Groups_OneArgs = {
  object: Commodity_Variety_Secondary_Groups_Insert_Input;
  on_conflict?: InputMaybe<Commodity_Variety_Secondary_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyArgs = {
  objects: Array<Company_Insert_Input>;
  on_conflict?: InputMaybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_CategoriesArgs = {
  objects: Array<Company_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Company_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Categories_OneArgs = {
  object: Company_Categories_Insert_Input;
  on_conflict?: InputMaybe<Company_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_CategoryArgs = {
  objects: Array<Company_Category_Insert_Input>;
  on_conflict?: InputMaybe<Company_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Category_OneArgs = {
  object: Company_Category_Insert_Input;
  on_conflict?: InputMaybe<Company_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_OneArgs = {
  object: Company_Insert_Input;
  on_conflict?: InputMaybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Share_HolderArgs = {
  objects: Array<Company_Share_Holder_Insert_Input>;
  on_conflict?: InputMaybe<Company_Share_Holder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Share_Holder_OneArgs = {
  object: Company_Share_Holder_Insert_Input;
  on_conflict?: InputMaybe<Company_Share_Holder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_NoteArgs = {
  objects: Array<Credit_Note_Insert_Input>;
  on_conflict?: InputMaybe<Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_OneArgs = {
  object: Credit_Note_Insert_Input;
  on_conflict?: InputMaybe<Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CropArgs = {
  objects: Array<Crop_Insert_Input>;
  on_conflict?: InputMaybe<Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_GroupArgs = {
  objects: Array<Crop_Group_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Group_OneArgs = {
  object: Crop_Group_Insert_Input;
  on_conflict?: InputMaybe<Crop_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_InfestationArgs = {
  objects: Array<Crop_Infestation_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Infestation_AttachmentArgs = {
  objects: Array<Crop_Infestation_Attachment_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Infestation_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Infestation_Attachment_OneArgs = {
  object: Crop_Infestation_Attachment_Insert_Input;
  on_conflict?: InputMaybe<Crop_Infestation_Attachment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Infestation_OneArgs = {
  object: Crop_Infestation_Insert_Input;
  on_conflict?: InputMaybe<Crop_Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_MilestoneArgs = {
  objects: Array<Crop_Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Milestone_OneArgs = {
  object: Crop_Milestone_Insert_Input;
  on_conflict?: InputMaybe<Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_OneArgs = {
  object: Crop_Insert_Input;
  on_conflict?: InputMaybe<Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_RootstockArgs = {
  objects: Array<Crop_Rootstock_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Rootstock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Rootstock_OneArgs = {
  object: Crop_Rootstock_Insert_Input;
  on_conflict?: InputMaybe<Crop_Rootstock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_VarietyArgs = {
  objects: Array<Crop_Variety_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Variety_BreederArgs = {
  objects: Array<Crop_Variety_Breeder_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Variety_Breeder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Variety_Breeder_OneArgs = {
  object: Crop_Variety_Breeder_Insert_Input;
  on_conflict?: InputMaybe<Crop_Variety_Breeder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Variety_OneArgs = {
  object: Crop_Variety_Insert_Input;
  on_conflict?: InputMaybe<Crop_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_YearArgs = {
  objects: Array<Crop_Year_Insert_Input>;
  on_conflict?: InputMaybe<Crop_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Crop_Year_OneArgs = {
  object: Crop_Year_Insert_Input;
  on_conflict?: InputMaybe<Crop_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cultivation_TypeArgs = {
  objects: Array<Cultivation_Type_Insert_Input>;
  on_conflict?: InputMaybe<Cultivation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cultivation_Type_OneArgs = {
  object: Cultivation_Type_Insert_Input;
  on_conflict?: InputMaybe<Cultivation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DepartmentArgs = {
  objects: Array<Department_Insert_Input>;
  on_conflict?: InputMaybe<Department_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_OneArgs = {
  object: Department_Insert_Input;
  on_conflict?: InputMaybe<Department_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Payment_DetailArgs = {
  objects: Array<Department_Payment_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Department_Payment_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Payment_Detail_OneArgs = {
  object: Department_Payment_Detail_Insert_Input;
  on_conflict?: InputMaybe<Department_Payment_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_SettlementsArgs = {
  objects: Array<Department_Settlements_Insert_Input>;
  on_conflict?: InputMaybe<Department_Settlements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Department_Settlements_OneArgs = {
  object: Department_Settlements_Insert_Input;
  on_conflict?: InputMaybe<Department_Settlements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DeviceArgs = {
  objects: Array<Device_Insert_Input>;
  on_conflict?: InputMaybe<Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Device_OneArgs = {
  object: Device_Insert_Input;
  on_conflict?: InputMaybe<Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Django_Content_TypeArgs = {
  objects: Array<Django_Content_Type_Insert_Input>;
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Django_Content_Type_OneArgs = {
  object: Django_Content_Type_Insert_Input;
  on_conflict?: InputMaybe<Django_Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentArgs = {
  objects: Array<Document_Insert_Input>;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_AttachmentsArgs = {
  objects: Array<Document_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Document_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Attachments_OneArgs = {
  object: Document_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Document_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_DataArgs = {
  objects: Array<Document_Data_Insert_Input>;
  on_conflict?: InputMaybe<Document_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Data_OneArgs = {
  object: Document_Data_Insert_Input;
  on_conflict?: InputMaybe<Document_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Export_LogArgs = {
  objects: Array<Document_Export_Log_Insert_Input>;
  on_conflict?: InputMaybe<Document_Export_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Export_Log_OneArgs = {
  object: Document_Export_Log_Insert_Input;
  on_conflict?: InputMaybe<Document_Export_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_KindArgs = {
  objects: Array<Document_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Kind_Data_FieldArgs = {
  objects: Array<Document_Kind_Data_Field_Insert_Input>;
  on_conflict?: InputMaybe<Document_Kind_Data_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Kind_Data_Field_OneArgs = {
  object: Document_Kind_Data_Field_Insert_Input;
  on_conflict?: InputMaybe<Document_Kind_Data_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Kind_OneArgs = {
  object: Document_Kind_Insert_Input;
  on_conflict?: InputMaybe<Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_OneArgs = {
  object: Document_Insert_Input;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_ReportArgs = {
  objects: Array<Document_Report_Insert_Input>;
  on_conflict?: InputMaybe<Document_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Report_OneArgs = {
  object: Document_Report_Insert_Input;
  on_conflict?: InputMaybe<Document_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_RevisionArgs = {
  objects: Array<Document_Revision_Insert_Input>;
  on_conflict?: InputMaybe<Document_Revision_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Revision_OneArgs = {
  object: Document_Revision_Insert_Input;
  on_conflict?: InputMaybe<Document_Revision_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eagle_AddressArgs = {
  objects: Array<Eagle_Address_Insert_Input>;
  on_conflict?: InputMaybe<Eagle_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eagle_Address_OneArgs = {
  object: Eagle_Address_Insert_Input;
  on_conflict?: InputMaybe<Eagle_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eagle_MediaArgs = {
  objects: Array<Eagle_Media_Insert_Input>;
  on_conflict?: InputMaybe<Eagle_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Eagle_Media_OneArgs = {
  object: Eagle_Media_Insert_Input;
  on_conflict?: InputMaybe<Eagle_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_StateArgs = {
  objects: Array<Entity_State_Insert_Input>;
  on_conflict?: InputMaybe<Entity_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_State_OneArgs = {
  object: Entity_State_Insert_Input;
  on_conflict?: InputMaybe<Entity_State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Evaluation_CriteriaArgs = {
  objects: Array<Evaluation_Criteria_Insert_Input>;
  on_conflict?: InputMaybe<Evaluation_Criteria_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Evaluation_Criteria_OneArgs = {
  object: Evaluation_Criteria_Insert_Input;
  on_conflict?: InputMaybe<Evaluation_Criteria_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Evaluation_TagArgs = {
  objects: Array<Evaluation_Tag_Insert_Input>;
  on_conflict?: InputMaybe<Evaluation_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Evaluation_Tag_OneArgs = {
  object: Evaluation_Tag_Insert_Input;
  on_conflict?: InputMaybe<Evaluation_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExpenseArgs = {
  objects: Array<Expense_Insert_Input>;
  on_conflict?: InputMaybe<Expense_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expense_OneArgs = {
  object: Expense_Insert_Input;
  on_conflict?: InputMaybe<Expense_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_ApplicationArgs = {
  objects: Array<External_Application_Insert_Input>;
  on_conflict?: InputMaybe<External_Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Application_OneArgs = {
  object: External_Application_Insert_Input;
  on_conflict?: InputMaybe<External_Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_EntityArgs = {
  objects: Array<External_Entity_Insert_Input>;
  on_conflict?: InputMaybe<External_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Entity_GroupArgs = {
  objects: Array<External_Entity_Group_Insert_Input>;
  on_conflict?: InputMaybe<External_Entity_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Entity_Group_OneArgs = {
  object: External_Entity_Group_Insert_Input;
  on_conflict?: InputMaybe<External_Entity_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Entity_OneArgs = {
  object: External_Entity_Insert_Input;
  on_conflict?: InputMaybe<External_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_ReferenceArgs = {
  objects: Array<External_Reference_Insert_Input>;
  on_conflict?: InputMaybe<External_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Reference_OneArgs = {
  object: External_Reference_Insert_Input;
  on_conflict?: InputMaybe<External_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FarmArgs = {
  objects: Array<Farm_Insert_Input>;
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farm_NetworkArgs = {
  objects: Array<Farm_Network_Insert_Input>;
  on_conflict?: InputMaybe<Farm_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farm_Network_OneArgs = {
  object: Farm_Network_Insert_Input;
  on_conflict?: InputMaybe<Farm_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farm_OneArgs = {
  object: Farm_Insert_Input;
  on_conflict?: InputMaybe<Farm_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FieldArgs = {
  objects: Array<Field_Insert_Input>;
  on_conflict?: InputMaybe<Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_NetworkArgs = {
  objects: Array<Field_Network_Insert_Input>;
  on_conflict?: InputMaybe<Field_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Network_OneArgs = {
  object: Field_Network_Insert_Input;
  on_conflict?: InputMaybe<Field_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_OneArgs = {
  object: Field_Insert_Input;
  on_conflict?: InputMaybe<Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Weather_LocationArgs = {
  objects: Array<Field_Weather_Location_Insert_Input>;
  on_conflict?: InputMaybe<Field_Weather_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Weather_Location_OneArgs = {
  object: Field_Weather_Location_Insert_Input;
  on_conflict?: InputMaybe<Field_Weather_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GradeArgs = {
  objects: Array<Grade_Insert_Input>;
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_CompanyArgs = {
  objects: Array<Grade_Company_Insert_Input>;
  on_conflict?: InputMaybe<Grade_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_Company_OneArgs = {
  object: Grade_Company_Insert_Input;
  on_conflict?: InputMaybe<Grade_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_OneArgs = {
  object: Grade_Insert_Input;
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_PriceArgs = {
  objects: Array<Grade_Price_Insert_Input>;
  on_conflict?: InputMaybe<Grade_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_Price_OneArgs = {
  object: Grade_Price_Insert_Input;
  on_conflict?: InputMaybe<Grade_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_AgreementArgs = {
  objects: Array<Guarantor_Agreement_Insert_Input>;
  on_conflict?: InputMaybe<Guarantor_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_Agreement_Agreement_InvoicesArgs = {
  objects: Array<Guarantor_Agreement_Agreement_Invoices_Insert_Input>;
  on_conflict?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_Agreement_Agreement_Invoices_OneArgs = {
  object: Guarantor_Agreement_Agreement_Invoices_Insert_Input;
  on_conflict?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_Agreement_Agreement_PlotsArgs = {
  objects: Array<Guarantor_Agreement_Agreement_Plots_Insert_Input>;
  on_conflict?: InputMaybe<Guarantor_Agreement_Agreement_Plots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_Agreement_Agreement_Plots_OneArgs = {
  object: Guarantor_Agreement_Agreement_Plots_Insert_Input;
  on_conflict?: InputMaybe<Guarantor_Agreement_Agreement_Plots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_Agreement_Area_Extension_DetailArgs = {
  objects: Array<Guarantor_Agreement_Area_Extension_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_Agreement_Area_Extension_Detail_OneArgs = {
  object: Guarantor_Agreement_Area_Extension_Detail_Insert_Input;
  on_conflict?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Guarantor_Agreement_OneArgs = {
  object: Guarantor_Agreement_Insert_Input;
  on_conflict?: InputMaybe<Guarantor_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InfestationArgs = {
  objects: Array<Infestation_Insert_Input>;
  on_conflict?: InputMaybe<Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Infestation_OneArgs = {
  object: Infestation_Insert_Input;
  on_conflict?: InputMaybe<Infestation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InstrumentArgs = {
  objects: Array<Instrument_Insert_Input>;
  on_conflict?: InputMaybe<Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Instrument_DepartmentsArgs = {
  objects: Array<Instrument_Departments_Insert_Input>;
  on_conflict?: InputMaybe<Instrument_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Instrument_Departments_OneArgs = {
  object: Instrument_Departments_Insert_Input;
  on_conflict?: InputMaybe<Instrument_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Instrument_KindArgs = {
  objects: Array<Instrument_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Instrument_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Instrument_Kind_OneArgs = {
  object: Instrument_Kind_Insert_Input;
  on_conflict?: InputMaybe<Instrument_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Instrument_OneArgs = {
  object: Instrument_Insert_Input;
  on_conflict?: InputMaybe<Instrument_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issuance_Note_AttachmentsArgs = {
  objects: Array<Issuance_Note_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Issuance_Note_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issuance_Note_Attachments_OneArgs = {
  object: Issuance_Note_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Issuance_Note_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kite_NotificationArgs = {
  objects: Array<Kite_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Kite_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kite_Notification_OneArgs = {
  object: Kite_Notification_Insert_Input;
  on_conflict?: InputMaybe<Kite_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kite_Quality_StageArgs = {
  objects: Array<Kite_Quality_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Kite_Quality_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kite_Quality_Stage_OneArgs = {
  object: Kite_Quality_Stage_Insert_Input;
  on_conflict?: InputMaybe<Kite_Quality_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LaboratoryArgs = {
  objects: Array<Laboratory_Insert_Input>;
  on_conflict?: InputMaybe<Laboratory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_OneArgs = {
  object: Laboratory_Insert_Input;
  on_conflict?: InputMaybe<Laboratory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_OrganisationsArgs = {
  objects: Array<Laboratory_Organisations_Insert_Input>;
  on_conflict?: InputMaybe<Laboratory_Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Laboratory_Organisations_OneArgs = {
  object: Laboratory_Organisations_Insert_Input;
  on_conflict?: InputMaybe<Laboratory_Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_AgreementArgs = {
  objects: Array<Legal_Agreement_Insert_Input>;
  on_conflict?: InputMaybe<Legal_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_Agreement_OneArgs = {
  object: Legal_Agreement_Insert_Input;
  on_conflict?: InputMaybe<Legal_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MarketArgs = {
  objects: Array<Market_Insert_Input>;
  on_conflict?: InputMaybe<Market_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Market_Allowed_DepartmentsArgs = {
  objects: Array<Market_Allowed_Departments_Insert_Input>;
  on_conflict?: InputMaybe<Market_Allowed_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Market_Allowed_Departments_OneArgs = {
  object: Market_Allowed_Departments_Insert_Input;
  on_conflict?: InputMaybe<Market_Allowed_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Market_OneArgs = {
  object: Market_Insert_Input;
  on_conflict?: InputMaybe<Market_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MediaArgs = {
  objects: Array<Media_Insert_Input>;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Media_OneArgs = {
  object: Media_Insert_Input;
  on_conflict?: InputMaybe<Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MilestoneArgs = {
  objects: Array<Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Milestone_OneArgs = {
  object: Milestone_Insert_Input;
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_GroupArgs = {
  objects: Array<Mutual_Group_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_MembershipArgs = {
  objects: Array<Mutual_Group_Membership_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Membership_OneArgs = {
  object: Mutual_Group_Membership_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Membership_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_NetworkArgs = {
  objects: Array<Mutual_Group_Network_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Network_OneArgs = {
  object: Mutual_Group_Network_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_OneArgs = {
  object: Mutual_Group_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_RoleArgs = {
  objects: Array<Mutual_Group_Role_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Role_OneArgs = {
  object: Mutual_Group_Role_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Weather_StationArgs = {
  objects: Array<Mutual_Group_Weather_Station_Insert_Input>;
  on_conflict?: InputMaybe<Mutual_Group_Weather_Station_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mutual_Group_Weather_Station_OneArgs = {
  object: Mutual_Group_Weather_Station_Insert_Input;
  on_conflict?: InputMaybe<Mutual_Group_Weather_Station_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NationalityArgs = {
  objects: Array<Nationality_Insert_Input>;
  on_conflict?: InputMaybe<Nationality_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nationality_OneArgs = {
  object: Nationality_Insert_Input;
  on_conflict?: InputMaybe<Nationality_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NetworkArgs = {
  objects: Array<Network_Insert_Input>;
  on_conflict?: InputMaybe<Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Network_OneArgs = {
  object: Network_Insert_Input;
  on_conflict?: InputMaybe<Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NomineesArgs = {
  objects: Array<Nominees_Insert_Input>;
  on_conflict?: InputMaybe<Nominees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nominees_DocumentsArgs = {
  objects: Array<Nominees_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Nominees_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nominees_Documents_OneArgs = {
  object: Nominees_Documents_Insert_Input;
  on_conflict?: InputMaybe<Nominees_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nominees_OneArgs = {
  object: Nominees_Insert_Input;
  on_conflict?: InputMaybe<Nominees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_ProviderArgs = {
  objects: Array<Notification_Provider_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Provider_OneArgs = {
  object: Notification_Provider_Insert_Input;
  on_conflict?: InputMaybe<Notification_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_TriggerArgs = {
  objects: Array<Notification_Trigger_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Trigger_OneArgs = {
  object: Notification_Trigger_Insert_Input;
  on_conflict?: InputMaybe<Notification_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Dashboard_StatsArgs = {
  objects: Array<Org_Dashboard_Stats_Insert_Input>;
  on_conflict?: InputMaybe<Org_Dashboard_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Dashboard_Stats_OneArgs = {
  object: Org_Dashboard_Stats_Insert_Input;
  on_conflict?: InputMaybe<Org_Dashboard_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_AssociationArgs = {
  objects: Array<Org_Team_Association_Insert_Input>;
  on_conflict?: InputMaybe<Org_Team_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_Association_OneArgs = {
  object: Org_Team_Association_Insert_Input;
  on_conflict?: InputMaybe<Org_Team_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_Primary_CropArgs = {
  objects: Array<Org_Team_Primary_Crop_Insert_Input>;
  on_conflict?: InputMaybe<Org_Team_Primary_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_Primary_Crop_OneArgs = {
  object: Org_Team_Primary_Crop_Insert_Input;
  on_conflict?: InputMaybe<Org_Team_Primary_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_User_Bank_AssociationArgs = {
  objects: Array<Org_Team_User_Bank_Association_Insert_Input>;
  on_conflict?: InputMaybe<Org_Team_User_Bank_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_User_Bank_Association_OneArgs = {
  object: Org_Team_User_Bank_Association_Insert_Input;
  on_conflict?: InputMaybe<Org_Team_User_Bank_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_User_CropArgs = {
  objects: Array<Org_Team_User_Crop_Insert_Input>;
  on_conflict?: InputMaybe<Org_Team_User_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_User_Crop_OneArgs = {
  object: Org_Team_User_Crop_Insert_Input;
  on_conflict?: InputMaybe<Org_Team_User_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_User_Document_AssociationArgs = {
  objects: Array<Org_Team_User_Document_Association_Insert_Input>;
  on_conflict?: InputMaybe<Org_Team_User_Document_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Team_User_Document_Association_OneArgs = {
  object: Org_Team_User_Document_Association_Insert_Input;
  on_conflict?: InputMaybe<Org_Team_User_Document_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_AssociationArgs = {
  objects: Array<Org_User_Association_Insert_Input>;
  on_conflict?: InputMaybe<Org_User_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_Association_OneArgs = {
  object: Org_User_Association_Insert_Input;
  on_conflict?: InputMaybe<Org_User_Association_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_Group_Mandatory_DocumentArgs = {
  objects: Array<Org_User_Group_Mandatory_Document_Insert_Input>;
  on_conflict?: InputMaybe<Org_User_Group_Mandatory_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_Group_Mandatory_Document_OneArgs = {
  object: Org_User_Group_Mandatory_Document_Insert_Input;
  on_conflict?: InputMaybe<Org_User_Group_Mandatory_Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_Group_Status_SnapshotArgs = {
  objects: Array<Org_User_Group_Status_Snapshot_Insert_Input>;
  on_conflict?: InputMaybe<Org_User_Group_Status_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_Group_Status_Snapshot_OneArgs = {
  object: Org_User_Group_Status_Snapshot_Insert_Input;
  on_conflict?: InputMaybe<Org_User_Group_Status_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_Primary_CropArgs = {
  objects: Array<Org_User_Primary_Crop_Insert_Input>;
  on_conflict?: InputMaybe<Org_User_Primary_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_Primary_Crop_OneArgs = {
  object: Org_User_Primary_Crop_Insert_Input;
  on_conflict?: InputMaybe<Org_User_Primary_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationArgs = {
  objects: Array<Organisation_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Commodity_Variety_ConfigArgs = {
  objects: Array<Organisation_Commodity_Variety_Config_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Commodity_Variety_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Commodity_Variety_Config_OneArgs = {
  object: Organisation_Commodity_Variety_Config_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Commodity_Variety_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Commodity_Variety_Config_TaxesArgs = {
  objects: Array<Organisation_Commodity_Variety_Config_Taxes_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Commodity_Variety_Config_Taxes_OneArgs = {
  object: Organisation_Commodity_Variety_Config_Taxes_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_CropArgs = {
  objects: Array<Organisation_Crop_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Crop_OneArgs = {
  object: Organisation_Crop_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Document_KindArgs = {
  objects: Array<Organisation_Document_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Document_Kind_OneArgs = {
  object: Organisation_Document_Kind_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Document_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_OneArgs = {
  object: Organisation_Insert_Input;
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_PreferencesArgs = {
  objects: Array<Organisation_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Preferences_OneArgs = {
  object: Organisation_Preferences_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_SeasonArgs = {
  objects: Array<Organisation_Season_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Season_OneArgs = {
  object: Organisation_Season_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Over_Due_ApprovalArgs = {
  objects: Array<Over_Due_Approval_Insert_Input>;
  on_conflict?: InputMaybe<Over_Due_Approval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Over_Due_Approval_OneArgs = {
  object: Over_Due_Approval_Insert_Input;
  on_conflict?: InputMaybe<Over_Due_Approval_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Packaging_OrderArgs = {
  objects: Array<Packaging_Order_Insert_Input>;
  on_conflict?: InputMaybe<Packaging_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Packaging_Order_ItemArgs = {
  objects: Array<Packaging_Order_Item_Insert_Input>;
  on_conflict?: InputMaybe<Packaging_Order_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Packaging_Order_Item_OneArgs = {
  object: Packaging_Order_Item_Insert_Input;
  on_conflict?: InputMaybe<Packaging_Order_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Packaging_Order_OneArgs = {
  object: Packaging_Order_Insert_Input;
  on_conflict?: InputMaybe<Packaging_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_CategoryArgs = {
  objects: Array<Pallet_Category_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Category_OneArgs = {
  object: Pallet_Category_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_CustomerArgs = {
  objects: Array<Pallet_Customer_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Customer_OneArgs = {
  object: Pallet_Customer_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_InspectionArgs = {
  objects: Array<Pallet_Inspection_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Inspection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspection_AttachmentsArgs = {
  objects: Array<Pallet_Inspection_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Inspection_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspection_Attachments_OneArgs = {
  object: Pallet_Inspection_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Inspection_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspection_OneArgs = {
  object: Pallet_Inspection_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Inspection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspection_ReportsArgs = {
  objects: Array<Pallet_Inspection_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Inspection_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspection_Reports_OneArgs = {
  object: Pallet_Inspection_Reports_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Inspection_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_InspectionkindArgs = {
  objects: Array<Pallet_Inspectionkind_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Inspectionkind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspectionkind_OneArgs = {
  object: Pallet_Inspectionkind_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Inspectionkind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_InspectionobservationArgs = {
  objects: Array<Pallet_Inspectionobservation_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Inspectionobservation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspectionobservation_AttachmentsArgs = {
  objects: Array<Pallet_Inspectionobservation_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Inspectionobservation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspectionobservation_Attachments_OneArgs = {
  object: Pallet_Inspectionobservation_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Inspectionobservation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Inspectionobservation_OneArgs = {
  object: Pallet_Inspectionobservation_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Inspectionobservation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_LineArgs = {
  objects: Array<Pallet_Line_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Line_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Line_OneArgs = {
  object: Pallet_Line_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Line_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_LocationArgs = {
  objects: Array<Pallet_Location_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Location_OneArgs = {
  object: Pallet_Location_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Location_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_PackagingArgs = {
  objects: Array<Pallet_Packaging_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packaging_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packaging_OneArgs = {
  object: Pallet_Packaging_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packaging_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_PackagingkindArgs = {
  objects: Array<Pallet_Packagingkind_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packagingkind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packagingkind_OneArgs = {
  object: Pallet_Packagingkind_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packagingkind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_PackingArgs = {
  objects: Array<Pallet_Packing_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packing_AttachmentsArgs = {
  objects: Array<Pallet_Packing_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packing_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packing_Attachments_OneArgs = {
  object: Pallet_Packing_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packing_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packing_OneArgs = {
  object: Pallet_Packing_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packing_WeightsArgs = {
  objects: Array<Pallet_Packing_Weights_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packing_Weights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packing_Weights_OneArgs = {
  object: Pallet_Packing_Weights_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packing_Weights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_PackingkindArgs = {
  objects: Array<Pallet_Packingkind_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packingkind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packingkind_OneArgs = {
  object: Pallet_Packingkind_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packingkind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_PackingweightArgs = {
  objects: Array<Pallet_Packingweight_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packingweight_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packingweight_AttachmentsArgs = {
  objects: Array<Pallet_Packingweight_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Packingweight_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packingweight_Attachments_OneArgs = {
  object: Pallet_Packingweight_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packingweight_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Packingweight_OneArgs = {
  object: Pallet_Packingweight_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Packingweight_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_PrintingmatterArgs = {
  objects: Array<Pallet_Printingmatter_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Printingmatter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Printingmatter_OneArgs = {
  object: Pallet_Printingmatter_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Printingmatter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_PunnetconditionArgs = {
  objects: Array<Pallet_Punnetcondition_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Punnetcondition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Punnetcondition_OneArgs = {
  object: Pallet_Punnetcondition_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Punnetcondition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_SamplinglocationArgs = {
  objects: Array<Pallet_Samplinglocation_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Samplinglocation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Samplinglocation_OneArgs = {
  object: Pallet_Samplinglocation_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Samplinglocation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_SkuArgs = {
  objects: Array<Pallet_Sku_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Sku_OneArgs = {
  object: Pallet_Sku_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_SkutypeArgs = {
  objects: Array<Pallet_Skutype_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Skutype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Skutype_OneArgs = {
  object: Pallet_Skutype_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Skutype_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_VarietyArgs = {
  objects: Array<Pallet_Variety_Insert_Input>;
  on_conflict?: InputMaybe<Pallet_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pallet_Variety_OneArgs = {
  object: Pallet_Variety_Insert_Input;
  on_conflict?: InputMaybe<Pallet_Variety_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentArgs = {
  objects: Array<Payment_Insert_Input>;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_DetailArgs = {
  objects: Array<Payment_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Detail_AttachmentsArgs = {
  objects: Array<Payment_Detail_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Detail_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Detail_Attachments_OneArgs = {
  object: Payment_Detail_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Payment_Detail_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Detail_OneArgs = {
  object: Payment_Detail_Insert_Input;
  on_conflict?: InputMaybe<Payment_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_MethodArgs = {
  objects: Array<Payment_Method_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Method_OneArgs = {
  object: Payment_Method_Insert_Input;
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_OneArgs = {
  object: Payment_Insert_Input;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlotArgs = {
  objects: Array<Plot_Insert_Input>;
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_CropArgs = {
  objects: Array<Plot_Crop_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_AgentArgs = {
  objects: Array<Plot_Crop_Agent_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Agent_OneArgs = {
  object: Plot_Crop_Agent_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Agent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Cultivation_TypeArgs = {
  objects: Array<Plot_Crop_Cultivation_Type_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Cultivation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Cultivation_Type_OneArgs = {
  object: Plot_Crop_Cultivation_Type_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Cultivation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Historic_SeasonArgs = {
  objects: Array<Plot_Crop_Historic_Season_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Historic_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Historic_Season_OneArgs = {
  object: Plot_Crop_Historic_Season_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Historic_Season_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_MilestoneArgs = {
  objects: Array<Plot_Crop_Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Milestone_OneArgs = {
  object: Plot_Crop_Milestone_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_NetworkArgs = {
  objects: Array<Plot_Crop_Network_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Network_OneArgs = {
  object: Plot_Crop_Network_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_OneArgs = {
  object: Plot_Crop_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_RootstockArgs = {
  objects: Array<Plot_Crop_Rootstock_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Rootstock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Rootstock_OneArgs = {
  object: Plot_Crop_Rootstock_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Rootstock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Status_HistoryArgs = {
  objects: Array<Plot_Crop_Status_History_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Crop_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Crop_Status_History_OneArgs = {
  object: Plot_Crop_Status_History_Insert_Input;
  on_conflict?: InputMaybe<Plot_Crop_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_NetworkArgs = {
  objects: Array<Plot_Network_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Network_OneArgs = {
  object: Plot_Network_Insert_Input;
  on_conflict?: InputMaybe<Plot_Network_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_OneArgs = {
  object: Plot_Insert_Input;
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_StatusArgs = {
  objects: Array<Plot_Status_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Status_ConfigArgs = {
  objects: Array<Plot_Status_Config_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Status_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Status_Config_OneArgs = {
  object: Plot_Status_Config_Insert_Input;
  on_conflict?: InputMaybe<Plot_Status_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Status_Config_Required_Qc_StagesArgs = {
  objects: Array<Plot_Status_Config_Required_Qc_Stages_Insert_Input>;
  on_conflict?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Status_Config_Required_Qc_Stages_OneArgs = {
  object: Plot_Status_Config_Required_Qc_Stages_Insert_Input;
  on_conflict?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Plot_Status_OneArgs = {
  object: Plot_Status_Insert_Input;
  on_conflict?: InputMaybe<Plot_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Primary_Growth_StageArgs = {
  objects: Array<Primary_Growth_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Primary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Primary_Growth_Stage_OneArgs = {
  object: Primary_Growth_Stage_Insert_Input;
  on_conflict?: InputMaybe<Primary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ParameterArgs = {
  objects: Array<Quality_Parameter_Insert_Input>;
  on_conflict?: InputMaybe<Quality_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Parameter_CategoryArgs = {
  objects: Array<Quality_Parameter_Category_Insert_Input>;
  on_conflict?: InputMaybe<Quality_Parameter_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Parameter_Category_OneArgs = {
  object: Quality_Parameter_Category_Insert_Input;
  on_conflict?: InputMaybe<Quality_Parameter_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Parameter_OneArgs = {
  object: Quality_Parameter_Insert_Input;
  on_conflict?: InputMaybe<Quality_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_StageArgs = {
  objects: Array<Quality_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Quality_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Stage_Allowed_Template_CategoryArgs = {
  objects: Array<Quality_Stage_Allowed_Template_Category_Insert_Input>;
  on_conflict?: InputMaybe<Quality_Stage_Allowed_Template_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Stage_Allowed_Template_Category_OneArgs = {
  object: Quality_Stage_Allowed_Template_Category_Insert_Input;
  on_conflict?: InputMaybe<Quality_Stage_Allowed_Template_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Stage_OneArgs = {
  object: Quality_Stage_Insert_Input;
  on_conflict?: InputMaybe<Quality_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReceiptArgs = {
  objects: Array<Receipt_Insert_Input>;
  on_conflict?: InputMaybe<Receipt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Receipt_OneArgs = {
  object: Receipt_Insert_Input;
  on_conflict?: InputMaybe<Receipt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegionArgs = {
  objects: Array<Region_Insert_Input>;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Region_GroupArgs = {
  objects: Array<Region_Group_Insert_Input>;
  on_conflict?: InputMaybe<Region_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Region_Group_OneArgs = {
  object: Region_Group_Insert_Input;
  on_conflict?: InputMaybe<Region_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Region_OneArgs = {
  object: Region_Insert_Input;
  on_conflict?: InputMaybe<Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RequestArgs = {
  objects: Array<Request_Insert_Input>;
  on_conflict?: InputMaybe<Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_CategoryArgs = {
  objects: Array<Request_Category_Insert_Input>;
  on_conflict?: InputMaybe<Request_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Category_OneArgs = {
  object: Request_Category_Insert_Input;
  on_conflict?: InputMaybe<Request_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_OneArgs = {
  object: Request_Insert_Input;
  on_conflict?: InputMaybe<Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_ParametersArgs = {
  objects: Array<Request_Parameters_Insert_Input>;
  on_conflict?: InputMaybe<Request_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Parameters_OneArgs = {
  object: Request_Parameters_Insert_Input;
  on_conflict?: InputMaybe<Request_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Secondary_LocationsArgs = {
  objects: Array<Request_Secondary_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Request_Secondary_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Secondary_Locations_OneArgs = {
  object: Request_Secondary_Locations_Insert_Input;
  on_conflict?: InputMaybe<Request_Secondary_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_TemplatesArgs = {
  objects: Array<Request_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Request_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Templates_OneArgs = {
  object: Request_Templates_Insert_Input;
  on_conflict?: InputMaybe<Request_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ResultArgs = {
  objects: Array<Result_Insert_Input>;
  on_conflict?: InputMaybe<Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_CommentArgs = {
  objects: Array<Result_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Result_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Comment_OneArgs = {
  object: Result_Comment_Insert_Input;
  on_conflict?: InputMaybe<Result_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_EvaluationArgs = {
  objects: Array<Result_Evaluation_Insert_Input>;
  on_conflict?: InputMaybe<Result_Evaluation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Evaluation_Evaluated_TagsArgs = {
  objects: Array<Result_Evaluation_Evaluated_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Result_Evaluation_Evaluated_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Evaluation_Evaluated_Tags_OneArgs = {
  object: Result_Evaluation_Evaluated_Tags_Insert_Input;
  on_conflict?: InputMaybe<Result_Evaluation_Evaluated_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Evaluation_OneArgs = {
  object: Result_Evaluation_Insert_Input;
  on_conflict?: InputMaybe<Result_Evaluation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_MediaArgs = {
  objects: Array<Result_Media_Insert_Input>;
  on_conflict?: InputMaybe<Result_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Media_OneArgs = {
  object: Result_Media_Insert_Input;
  on_conflict?: InputMaybe<Result_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_ObservationArgs = {
  objects: Array<Result_Observation_Insert_Input>;
  on_conflict?: InputMaybe<Result_Observation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Observation_AttachmentsArgs = {
  objects: Array<Result_Observation_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Result_Observation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Observation_Attachments_OneArgs = {
  object: Result_Observation_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Result_Observation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Observation_Evaluated_TagsArgs = {
  objects: Array<Result_Observation_Evaluated_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Result_Observation_Evaluated_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Observation_Evaluated_Tags_OneArgs = {
  object: Result_Observation_Evaluated_Tags_Insert_Input;
  on_conflict?: InputMaybe<Result_Observation_Evaluated_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_Observation_OneArgs = {
  object: Result_Observation_Insert_Input;
  on_conflict?: InputMaybe<Result_Observation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Result_OneArgs = {
  object: Result_Insert_Input;
  on_conflict?: InputMaybe<Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoleArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_OneArgs = {
  object: Role_Insert_Input;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RootstockArgs = {
  objects: Array<Rootstock_Insert_Input>;
  on_conflict?: InputMaybe<Rootstock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rootstock_OneArgs = {
  object: Rootstock_Insert_Input;
  on_conflict?: InputMaybe<Rootstock_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleArgs = {
  objects: Array<Sample_Insert_Input>;
  on_conflict?: InputMaybe<Sample_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_MediaArgs = {
  objects: Array<Sample_Media_Insert_Input>;
  on_conflict?: InputMaybe<Sample_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_Media_OneArgs = {
  object: Sample_Media_Insert_Input;
  on_conflict?: InputMaybe<Sample_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_ObservationArgs = {
  objects: Array<Sample_Observation_Insert_Input>;
  on_conflict?: InputMaybe<Sample_Observation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_Observation_AttachmentsArgs = {
  objects: Array<Sample_Observation_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Sample_Observation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_Observation_Attachments_OneArgs = {
  object: Sample_Observation_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Sample_Observation_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_Observation_OneArgs = {
  object: Sample_Observation_Insert_Input;
  on_conflict?: InputMaybe<Sample_Observation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sample_OneArgs = {
  object: Sample_Insert_Input;
  on_conflict?: InputMaybe<Sample_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Secondary_Growth_StageArgs = {
  objects: Array<Secondary_Growth_Stage_Insert_Input>;
  on_conflict?: InputMaybe<Secondary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Secondary_Growth_Stage_OneArgs = {
  object: Secondary_Growth_Stage_Insert_Input;
  on_conflict?: InputMaybe<Secondary_Growth_Stage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setu_Trade_Shared_EntityArgs = {
  objects: Array<Setu_Trade_Shared_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Setu_Trade_Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setu_Trade_Shared_Entity_OneArgs = {
  object: Setu_Trade_Shared_Entity_Insert_Input;
  on_conflict?: InputMaybe<Setu_Trade_Shared_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setutrade_MediaArgs = {
  objects: Array<Setutrade_Media_Insert_Input>;
  on_conflict?: InputMaybe<Setutrade_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setutrade_Media_OneArgs = {
  object: Setutrade_Media_Insert_Input;
  on_conflict?: InputMaybe<Setutrade_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shareholder_ApplicationsArgs = {
  objects: Array<Shareholder_Applications_Insert_Input>;
  on_conflict?: InputMaybe<Shareholder_Applications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shareholder_Applications_OneArgs = {
  object: Shareholder_Applications_Insert_Input;
  on_conflict?: InputMaybe<Shareholder_Applications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShareholdersArgs = {
  objects: Array<Shareholders_Insert_Input>;
  on_conflict?: InputMaybe<Shareholders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shareholders_OneArgs = {
  object: Shareholders_Insert_Input;
  on_conflict?: InputMaybe<Shareholders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_UnitArgs = {
  objects: Array<Si_Unit_Insert_Input>;
  on_conflict?: InputMaybe<Si_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_Unit_MeasureArgs = {
  objects: Array<Si_Unit_Measure_Insert_Input>;
  on_conflict?: InputMaybe<Si_Unit_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_Unit_Measure_OneArgs = {
  object: Si_Unit_Measure_Insert_Input;
  on_conflict?: InputMaybe<Si_Unit_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Si_Unit_OneArgs = {
  object: Si_Unit_Insert_Input;
  on_conflict?: InputMaybe<Si_Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SkuArgs = {
  objects: Array<Sku_Insert_Input>;
  on_conflict?: InputMaybe<Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sku_KindArgs = {
  objects: Array<Sku_Kind_Insert_Input>;
  on_conflict?: InputMaybe<Sku_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sku_Kind_OneArgs = {
  object: Sku_Kind_Insert_Input;
  on_conflict?: InputMaybe<Sku_Kind_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sku_OneArgs = {
  object: Sku_Insert_Input;
  on_conflict?: InputMaybe<Sku_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SoilArgs = {
  objects: Array<Soil_Insert_Input>;
  on_conflict?: InputMaybe<Soil_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Soil_OneArgs = {
  object: Soil_Insert_Input;
  on_conflict?: InputMaybe<Soil_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stage_ActionsArgs = {
  objects: Array<Stage_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Stage_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stage_Actions_OneArgs = {
  object: Stage_Actions_Insert_Input;
  on_conflict?: InputMaybe<Stage_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stage_LogsArgs = {
  objects: Array<Stage_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Stage_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stage_Logs_OneArgs = {
  object: Stage_Logs_Insert_Input;
  on_conflict?: InputMaybe<Stage_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StagesArgs = {
  objects: Array<Stages_Insert_Input>;
  on_conflict?: InputMaybe<Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stages_OneArgs = {
  object: Stages_Insert_Input;
  on_conflict?: InputMaybe<Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stages_SubscribersArgs = {
  objects: Array<Stages_Subscribers_Insert_Input>;
  on_conflict?: InputMaybe<Stages_Subscribers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stages_Subscribers_OneArgs = {
  object: Stages_Subscribers_Insert_Input;
  on_conflict?: InputMaybe<Stages_Subscribers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StateArgs = {
  objects: Array<State_Insert_Input>;
  on_conflict?: InputMaybe<State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_State_OneArgs = {
  object: State_Insert_Input;
  on_conflict?: InputMaybe<State_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_ParametersArgs = {
  objects: Array<Survey_Parameters_Insert_Input>;
  on_conflict?: InputMaybe<Survey_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_Parameters_OneArgs = {
  object: Survey_Parameters_Insert_Input;
  on_conflict?: InputMaybe<Survey_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_Response_ItemsArgs = {
  objects: Array<Survey_Response_Items_Insert_Input>;
  on_conflict?: InputMaybe<Survey_Response_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_Response_Items_OneArgs = {
  object: Survey_Response_Items_Insert_Input;
  on_conflict?: InputMaybe<Survey_Response_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_ResponsesArgs = {
  objects: Array<Survey_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Survey_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_Responses_OneArgs = {
  object: Survey_Responses_Insert_Input;
  on_conflict?: InputMaybe<Survey_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_UsersArgs = {
  objects: Array<Survey_Users_Insert_Input>;
  on_conflict?: InputMaybe<Survey_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_Users_OneArgs = {
  object: Survey_Users_Insert_Input;
  on_conflict?: InputMaybe<Survey_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_YearArgs = {
  objects: Array<Survey_Year_Insert_Input>;
  on_conflict?: InputMaybe<Survey_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Survey_Year_OneArgs = {
  object: Survey_Year_Insert_Input;
  on_conflict?: InputMaybe<Survey_Year_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SurveysArgs = {
  objects: Array<Surveys_Insert_Input>;
  on_conflict?: InputMaybe<Surveys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Surveys_OneArgs = {
  object: Surveys_Insert_Input;
  on_conflict?: InputMaybe<Surveys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TemplateArgs = {
  objects: Array<Template_Insert_Input>;
  on_conflict?: InputMaybe<Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_CategoryArgs = {
  objects: Array<Template_Category_Insert_Input>;
  on_conflict?: InputMaybe<Template_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Category_Allowed_GroupsArgs = {
  objects: Array<Template_Category_Allowed_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Template_Category_Allowed_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Category_Allowed_Groups_OneArgs = {
  object: Template_Category_Allowed_Groups_Insert_Input;
  on_conflict?: InputMaybe<Template_Category_Allowed_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Category_Allowed_Parameter_CategoriesArgs = {
  objects: Array<Template_Category_Allowed_Parameter_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Template_Category_Allowed_Parameter_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Category_Allowed_Parameter_Categories_OneArgs = {
  object: Template_Category_Allowed_Parameter_Categories_Insert_Input;
  on_conflict?: InputMaybe<Template_Category_Allowed_Parameter_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Category_OneArgs = {
  object: Template_Category_Insert_Input;
  on_conflict?: InputMaybe<Template_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_CompanyArgs = {
  objects: Array<Template_Company_Insert_Input>;
  on_conflict?: InputMaybe<Template_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Company_OneArgs = {
  object: Template_Company_Insert_Input;
  on_conflict?: InputMaybe<Template_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_DepartmentsArgs = {
  objects: Array<Template_Departments_Insert_Input>;
  on_conflict?: InputMaybe<Template_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Departments_OneArgs = {
  object: Template_Departments_Insert_Input;
  on_conflict?: InputMaybe<Template_Departments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_EvaluationArgs = {
  objects: Array<Template_Evaluation_Insert_Input>;
  on_conflict?: InputMaybe<Template_Evaluation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Evaluation_ConfigArgs = {
  objects: Array<Template_Evaluation_Config_Insert_Input>;
  on_conflict?: InputMaybe<Template_Evaluation_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Evaluation_Config_OneArgs = {
  object: Template_Evaluation_Config_Insert_Input;
  on_conflict?: InputMaybe<Template_Evaluation_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Evaluation_OneArgs = {
  object: Template_Evaluation_Insert_Input;
  on_conflict?: InputMaybe<Template_Evaluation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Evaluation_TemplatesArgs = {
  objects: Array<Template_Evaluation_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Template_Evaluation_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Evaluation_Templates_OneArgs = {
  object: Template_Evaluation_Templates_Insert_Input;
  on_conflict?: InputMaybe<Template_Evaluation_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_OneArgs = {
  object: Template_Insert_Input;
  on_conflict?: InputMaybe<Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_ParameterArgs = {
  objects: Array<Template_Parameter_Insert_Input>;
  on_conflict?: InputMaybe<Template_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_ConfigArgs = {
  objects: Array<Template_Parameter_Config_Insert_Input>;
  on_conflict?: InputMaybe<Template_Parameter_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_Config_OneArgs = {
  object: Template_Parameter_Config_Insert_Input;
  on_conflict?: InputMaybe<Template_Parameter_Config_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_OneArgs = {
  object: Template_Parameter_Insert_Input;
  on_conflict?: InputMaybe<Template_Parameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_StandardArgs = {
  objects: Array<Template_Parameter_Standard_Insert_Input>;
  on_conflict?: InputMaybe<Template_Parameter_Standard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_Standard_AttachmentsArgs = {
  objects: Array<Template_Parameter_Standard_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Template_Parameter_Standard_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_Standard_Attachments_OneArgs = {
  object: Template_Parameter_Standard_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Template_Parameter_Standard_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_Standard_GroupArgs = {
  objects: Array<Template_Parameter_Standard_Group_Insert_Input>;
  on_conflict?: InputMaybe<Template_Parameter_Standard_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_Standard_Group_OneArgs = {
  object: Template_Parameter_Standard_Group_Insert_Input;
  on_conflict?: InputMaybe<Template_Parameter_Standard_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Parameter_Standard_OneArgs = {
  object: Template_Parameter_Standard_Insert_Input;
  on_conflict?: InputMaybe<Template_Parameter_Standard_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Quality_StagesArgs = {
  objects: Array<Template_Quality_Stages_Insert_Input>;
  on_conflict?: InputMaybe<Template_Quality_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Template_Quality_Stages_OneArgs = {
  object: Template_Quality_Stages_Insert_Input;
  on_conflict?: InputMaybe<Template_Quality_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TradeArgs = {
  objects: Array<Trade_Insert_Input>;
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_AttachmentsArgs = {
  objects: Array<Trade_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Attachments_OneArgs = {
  object: Trade_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Trade_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Buyer_Gst_AttachmentsArgs = {
  objects: Array<Trade_Buyer_Gst_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Buyer_Gst_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Buyer_Gst_Attachments_OneArgs = {
  object: Trade_Buyer_Gst_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Trade_Buyer_Gst_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_ItemArgs = {
  objects: Array<Trade_Item_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Item_OneArgs = {
  object: Trade_Item_Insert_Input;
  on_conflict?: InputMaybe<Trade_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_OneArgs = {
  object: Trade_Insert_Input;
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Seller_Gst_AttachmentsArgs = {
  objects: Array<Trade_Seller_Gst_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Seller_Gst_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Seller_Gst_Attachments_OneArgs = {
  object: Trade_Seller_Gst_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Trade_Seller_Gst_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_TaxesArgs = {
  objects: Array<Trade_Taxes_Insert_Input>;
  on_conflict?: InputMaybe<Trade_Taxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trade_Taxes_OneArgs = {
  object: Trade_Taxes_Insert_Input;
  on_conflict?: InputMaybe<Trade_Taxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransactionArgs = {
  objects: Array<Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_AttachmentsArgs = {
  objects: Array<Transaction_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Transaction_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Attachments_OneArgs = {
  object: Transaction_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Transaction_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_OneArgs = {
  object: Transaction_Insert_Input;
  on_conflict?: InputMaybe<Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransactionsArgs = {
  objects: Array<Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transactions_AttachmentsArgs = {
  objects: Array<Transactions_Attachments_Insert_Input>;
  on_conflict?: InputMaybe<Transactions_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transactions_Attachments_OneArgs = {
  object: Transactions_Attachments_Insert_Input;
  on_conflict?: InputMaybe<Transactions_Attachments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transactions_OneArgs = {
  object: Transactions_Insert_Input;
  on_conflict?: InputMaybe<Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TransitionArgs = {
  objects: Array<Transition_Insert_Input>;
  on_conflict?: InputMaybe<Transition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transition_AccessArgs = {
  objects: Array<Transition_Access_Insert_Input>;
  on_conflict?: InputMaybe<Transition_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transition_Access_OneArgs = {
  object: Transition_Access_Insert_Input;
  on_conflict?: InputMaybe<Transition_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transition_HistoryArgs = {
  objects: Array<Transition_History_Insert_Input>;
  on_conflict?: InputMaybe<Transition_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transition_History_AttributeArgs = {
  objects: Array<Transition_History_Attribute_Insert_Input>;
  on_conflict?: InputMaybe<Transition_History_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transition_History_Attribute_OneArgs = {
  object: Transition_History_Attribute_Insert_Input;
  on_conflict?: InputMaybe<Transition_History_Attribute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transition_History_OneArgs = {
  object: Transition_History_Insert_Input;
  on_conflict?: InputMaybe<Transition_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transition_OneArgs = {
  object: Transition_Insert_Input;
  on_conflict?: InputMaybe<Transition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UnitArgs = {
  objects: Array<Unit_Insert_Input>;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_MeasureArgs = {
  objects: Array<Unit_Measure_Insert_Input>;
  on_conflict?: InputMaybe<Unit_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Measure_OneArgs = {
  object: Unit_Measure_Insert_Input;
  on_conflict?: InputMaybe<Unit_Measure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_OneArgs = {
  object: Unit_Insert_Input;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_AgreementArgs = {
  objects: Array<Variety_Agreement_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Agreement_Agreement_Co_OwnersArgs = {
  objects: Array<Variety_Agreement_Agreement_Co_Owners_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Agreement_Agreement_Co_Owners_OneArgs = {
  object: Variety_Agreement_Agreement_Co_Owners_Insert_Input;
  on_conflict?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Agreement_Guarantor_AgreementsArgs = {
  objects: Array<Variety_Agreement_Guarantor_Agreements_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Agreement_Guarantor_Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Agreement_Guarantor_Agreements_OneArgs = {
  object: Variety_Agreement_Guarantor_Agreements_Insert_Input;
  on_conflict?: InputMaybe<Variety_Agreement_Guarantor_Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Agreement_OneArgs = {
  object: Variety_Agreement_Insert_Input;
  on_conflict?: InputMaybe<Variety_Agreement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_GradeArgs = {
  objects: Array<Variety_Grade_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Grade_OneArgs = {
  object: Variety_Grade_Insert_Input;
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Grade_PhotosArgs = {
  objects: Array<Variety_Grade_Photos_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Grade_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Grade_Photos_OneArgs = {
  object: Variety_Grade_Photos_Insert_Input;
  on_conflict?: InputMaybe<Variety_Grade_Photos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_GroupArgs = {
  objects: Array<Variety_Group_Insert_Input>;
  on_conflict?: InputMaybe<Variety_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variety_Group_OneArgs = {
  object: Variety_Group_Insert_Input;
  on_conflict?: InputMaybe<Variety_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vt_Core_TaxArgs = {
  objects: Array<Vt_Core_Tax_Insert_Input>;
  on_conflict?: InputMaybe<Vt_Core_Tax_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vt_Core_Tax_OneArgs = {
  object: Vt_Core_Tax_Insert_Input;
  on_conflict?: InputMaybe<Vt_Core_Tax_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_ReferenceArgs = {
  objects: Array<Weather_Reference_Insert_Input>;
  on_conflict?: InputMaybe<Weather_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weather_Reference_OneArgs = {
  object: Weather_Reference_Insert_Input;
  on_conflict?: InputMaybe<Weather_Reference_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WorkflowArgs = {
  objects: Array<Workflow_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Current_LogsArgs = {
  objects: Array<Workflow_Current_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_Current_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_Current_Logs_OneArgs = {
  object: Workflow_Current_Logs_Insert_Input;
  on_conflict?: InputMaybe<Workflow_Current_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_OneArgs = {
  object: Workflow_Insert_Input;
  on_conflict?: InputMaybe<Workflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WorkflowsArgs = {
  objects: Array<Workflows_Insert_Input>;
  on_conflict?: InputMaybe<Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflows_OneArgs = {
  object: Workflows_Insert_Input;
  on_conflict?: InputMaybe<Workflows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInvite_All_Users_For_Mutual_GroupArgs = {
  app_name: Scalars['String'];
  codename: Scalars['String'];
  organisation_name: Scalars['String'];
  template_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInvite_UserArgs = {
  app_name: Scalars['String'];
  organisation_name: Scalars['String'];
  reference_id: Scalars['String'];
  template_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootLoginArgs = {
  network_id?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};


/** mutation root */
export type Mutation_RootMake_TransitionArgs = {
  entity_id?: InputMaybe<Scalars['ID']>;
  from_state_codename?: InputMaybe<Scalars['String']>;
  skip_transition?: InputMaybe<Scalars['Boolean']>;
  to_state_codename?: InputMaybe<Scalars['String']>;
  workflow_codename?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootMap_Invoice_TransactionArgs = {
  invoice_id: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  transactions: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootMap_Invoice_Transaction_ManyArgs = {
  inputs: Array<InputMaybe<MapInvoiceTransactionManyInput>>;
};


/** mutation root */
export type Mutation_RootMap_Receipt_TransactionArgs = {
  receipt_id: Scalars['ID'];
  remark?: InputMaybe<Scalars['String']>;
  transactions: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootMap_Receipt_Transaction_ManyArgs = {
  inputs: Array<InputMaybe<MapReceiptTransactionManyInput>>;
};


/** mutation root */
export type Mutation_RootMap_Trade_TransactionArgs = {
  remark?: InputMaybe<Scalars['String']>;
  trade_id: Scalars['ID'];
  transactions: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootMap_Trade_Transaction_ManyArgs = {
  inputs: Array<InputMaybe<MapTradeTransactionManyInput>>;
};


/** mutation root */
export type Mutation_RootMutual_Group_Network_AssignArgs = {
  mutual_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  remove_network_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootOnboard_Plot_CropArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot: OnboardPlotType;
};


/** mutation root */
export type Mutation_RootPlace_OrderArgs = {
  billing_address?: InputMaybe<AddressGlInput>;
  discount_id?: InputMaybe<Scalars['ID']>;
  estimated_delivery?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  order_category?: InputMaybe<Scalars['String']>;
  order_items: Array<InputMaybe<OrderItemStockInput>>;
  payment_method?: InputMaybe<Scalars['String']>;
  pickup_slots?: InputMaybe<Array<InputMaybe<OrderPickupSlotInput>>>;
  poc_name?: InputMaybe<Scalars['String']>;
  poc_number?: InputMaybe<Scalars['String']>;
  shipping_address?: InputMaybe<AddressGlInput>;
  shipping_method: Scalars['String'];
  source_stock?: InputMaybe<Scalars['String']>;
  target_dc_id?: InputMaybe<Scalars['ID']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootReceipt_Final_TradesArgs = {
  receipt_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootRecord_Crop_MilestoneArgs = {
  crop_year?: InputMaybe<Scalars['Int']>;
  milestones: Array<InputMaybe<BulkMilestoneRecordInputType>>;
  plot_crop_codename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRecord_ExpenseArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purposes: Array<InputMaybe<PurposeExpenseType>>;
  record_date: Scalars['Date'];
  recorded_by_reference_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRecord_Expense_V2Args = {
  activity_id?: InputMaybe<Scalars['String']>;
  activity_name?: InputMaybe<Scalars['String']>;
  activity_type?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  from_date?: InputMaybe<Scalars['Date']>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purposes: Array<InputMaybe<PurposeExpenseType>>;
  record_date: Scalars['Date'];
  recorded_by_reference_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRecord_Growth_StageArgs = {
  date: Scalars['Date'];
  growth_stage_id: Scalars['Int'];
  plot_crop_codename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRecord_IncomeArgs = {
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purpose?: InputMaybe<Scalars['String']>;
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootRecord_Income_V2Args = {
  amount: Scalars['Float'];
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  from_date?: InputMaybe<Scalars['Date']>;
  is_actual?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
  purpose?: InputMaybe<Scalars['String']>;
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootRecord_Trade_ReturnArgs = {
  items: Array<InputMaybe<RecordReturnQuantityInput>>;
};


/** mutation root */
export type Mutation_RootRefresh_TokenArgs = {
  refresh_token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRequest_Advance_PaymentArgs = {
  advance_payment_ids: Array<InputMaybe<Scalars['ID']>>;
};


/** mutation root */
export type Mutation_RootSend_NotificationArgs = {
  broadcast_time?: InputMaybe<Scalars['DateTime']>;
  content?: InputMaybe<NotificationContent>;
  data_variables?: InputMaybe<Scalars['JSONString']>;
  extra_variables?: InputMaybe<Scalars['JSONString']>;
  filters?: InputMaybe<Array<InputMaybe<NotificationTemplateFilter>>>;
  is_background?: InputMaybe<Scalars['Boolean']>;
  provider_uid: Scalars['String'];
  provider_variables?: InputMaybe<Scalars['JSONString']>;
  template_uid?: InputMaybe<Scalars['String']>;
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user_query_uid?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootSet_Base_User_FieldsArgs = {
  base_user_id?: InputMaybe<Scalars['ID']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootSet_Brand_FieldsArgs = {
  brand_id?: InputMaybe<Scalars['ID']>;
  companies_codename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** mutation root */
export type Mutation_RootSet_BudgetArgs = {
  amount: Scalars['Float'];
  plot_crop_codename: Scalars['String'];
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootSet_Budget_V2Args = {
  amount: Scalars['Float'];
  plot_crop_codename: Scalars['String'];
  record_date: Scalars['Date'];
};


/** mutation root */
export type Mutation_RootSet_Business_FieldsArgs = {
  business_id?: InputMaybe<Scalars['ID']>;
  commodities_supplied?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  secondary_pocs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


/** mutation root */
export type Mutation_RootSet_Document_AttachmentsArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  document_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootSet_Grade_FieldsArgs = {
  companies_codename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  grade_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootSet_Payment_Detail_AttachmentsArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  payment_detail_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootSet_User_LanguageArgs = {
  language: Scalars['String'];
};


/** mutation root */
export type Mutation_RootShift_Production_Trade_To_StorageArgs = {
  trade_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootSubmit_ObservationsArgs = {
  async_result?: InputMaybe<Scalars['Boolean']>;
  generate_result?: InputMaybe<Scalars['Boolean']>;
  input: SubmitObservationsInput;
};


/** mutation root */
export type Mutation_RootSwitch_DepartmentArgs = {
  department?: InputMaybe<Scalars['String']>;
  user_reference_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootTemplate_ToggleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootTemplate_UpsertArgs = {
  template_input?: InputMaybe<TemplateInput>;
  template_parameters?: InputMaybe<Array<InputMaybe<TemplateParameterInput>>>;
};


/** mutation root */
export type Mutation_RootUpdate_Action_LogArgs = {
  _append?: InputMaybe<Action_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Action_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Action_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Action_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Action_Log_Inc_Input>;
  _prepend?: InputMaybe<Action_Log_Prepend_Input>;
  _set?: InputMaybe<Action_Log_Set_Input>;
  where: Action_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Log_By_PkArgs = {
  _append?: InputMaybe<Action_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Action_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Action_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Action_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Action_Log_Inc_Input>;
  _prepend?: InputMaybe<Action_Log_Prepend_Input>;
  _set?: InputMaybe<Action_Log_Set_Input>;
  pk_columns: Action_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Action_Log_ManyArgs = {
  updates: Array<Action_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Advance_PaymentArgs = {
  _inc?: InputMaybe<Advance_Payment_Inc_Input>;
  _set?: InputMaybe<Advance_Payment_Set_Input>;
  where: Advance_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advance_Payment_By_PkArgs = {
  _inc?: InputMaybe<Advance_Payment_Inc_Input>;
  _set?: InputMaybe<Advance_Payment_Set_Input>;
  pk_columns: Advance_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advance_Payment_ManyArgs = {
  updates: Array<Advance_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AgentArgs = {
  _inc?: InputMaybe<Agent_Inc_Input>;
  _set?: InputMaybe<Agent_Set_Input>;
  where: Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_By_PkArgs = {
  _inc?: InputMaybe<Agent_Inc_Input>;
  _set?: InputMaybe<Agent_Set_Input>;
  pk_columns: Agent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_CompanyArgs = {
  _inc?: InputMaybe<Agent_Company_Inc_Input>;
  _set?: InputMaybe<Agent_Company_Set_Input>;
  where: Agent_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Company_By_PkArgs = {
  _inc?: InputMaybe<Agent_Company_Inc_Input>;
  _set?: InputMaybe<Agent_Company_Set_Input>;
  pk_columns: Agent_Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Company_ManyArgs = {
  updates: Array<Agent_Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_ManyArgs = {
  updates: Array<Agent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_RoleArgs = {
  _inc?: InputMaybe<Agent_Role_Inc_Input>;
  _set?: InputMaybe<Agent_Role_Set_Input>;
  where: Agent_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Role_By_PkArgs = {
  _inc?: InputMaybe<Agent_Role_Inc_Input>;
  _set?: InputMaybe<Agent_Role_Set_Input>;
  pk_columns: Agent_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agent_Role_ManyArgs = {
  updates: Array<Agent_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_OwnerArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Set_Input>;
  where: Agreement_Co_Owner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Agreement_InvoicesArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Set_Input>;
  where: Agreement_Co_Owner_Agreement_Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Agreement_Invoices_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Set_Input>;
  pk_columns: Agreement_Co_Owner_Agreement_Invoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Agreement_Invoices_ManyArgs = {
  updates: Array<Agreement_Co_Owner_Agreement_Invoices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Agreement_PlotsArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Set_Input>;
  where: Agreement_Co_Owner_Agreement_Plots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Agreement_Plots_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Set_Input>;
  pk_columns: Agreement_Co_Owner_Agreement_Plots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Agreement_Plots_ManyArgs = {
  updates: Array<Agreement_Co_Owner_Agreement_Plots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Set_Input>;
  pk_columns: Agreement_Co_Owner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Legal_AgreementArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Set_Input>;
  where: Agreement_Co_Owner_Legal_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Legal_Agreement_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Inc_Input>;
  _set?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Set_Input>;
  pk_columns: Agreement_Co_Owner_Legal_Agreement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_Legal_Agreement_ManyArgs = {
  updates: Array<Agreement_Co_Owner_Legal_Agreement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Co_Owner_ManyArgs = {
  updates: Array<Agreement_Co_Owner_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_InvoiceArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Set_Input>;
  where: Agreement_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_Agreement_Invoice_ItemsArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Set_Input>;
  where: Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_Agreement_Invoice_Items_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Set_Input>;
  pk_columns: Agreement_Invoice_Agreement_Invoice_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_Agreement_Invoice_Items_ManyArgs = {
  updates: Array<Agreement_Invoice_Agreement_Invoice_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Set_Input>;
  pk_columns: Agreement_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_ItemArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Item_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Item_Set_Input>;
  where: Agreement_Invoice_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_Item_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Item_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Item_Set_Input>;
  pk_columns: Agreement_Invoice_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_Item_ManyArgs = {
  updates: Array<Agreement_Invoice_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_ManyArgs = {
  updates: Array<Agreement_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_TransactionArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Transaction_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Transaction_Set_Input>;
  where: Agreement_Invoice_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Invoice_Transaction_Inc_Input>;
  _set?: InputMaybe<Agreement_Invoice_Transaction_Set_Input>;
  pk_columns: Agreement_Invoice_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Invoice_Transaction_ManyArgs = {
  updates: Array<Agreement_Invoice_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_PlotArgs = {
  _append?: InputMaybe<Agreement_Plot_Append_Input>;
  _delete_at_path?: InputMaybe<Agreement_Plot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agreement_Plot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agreement_Plot_Delete_Key_Input>;
  _inc?: InputMaybe<Agreement_Plot_Inc_Input>;
  _prepend?: InputMaybe<Agreement_Plot_Prepend_Input>;
  _set?: InputMaybe<Agreement_Plot_Set_Input>;
  where: Agreement_Plot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Plot_By_PkArgs = {
  _append?: InputMaybe<Agreement_Plot_Append_Input>;
  _delete_at_path?: InputMaybe<Agreement_Plot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agreement_Plot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agreement_Plot_Delete_Key_Input>;
  _inc?: InputMaybe<Agreement_Plot_Inc_Input>;
  _prepend?: InputMaybe<Agreement_Plot_Prepend_Input>;
  _set?: InputMaybe<Agreement_Plot_Set_Input>;
  pk_columns: Agreement_Plot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreement_Plot_ManyArgs = {
  updates: Array<Agreement_Plot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Amendment_CaseArgs = {
  _append?: InputMaybe<Amendment_Case_Append_Input>;
  _delete_at_path?: InputMaybe<Amendment_Case_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Amendment_Case_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Amendment_Case_Delete_Key_Input>;
  _inc?: InputMaybe<Amendment_Case_Inc_Input>;
  _prepend?: InputMaybe<Amendment_Case_Prepend_Input>;
  _set?: InputMaybe<Amendment_Case_Set_Input>;
  where: Amendment_Case_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Amendment_Case_By_PkArgs = {
  _append?: InputMaybe<Amendment_Case_Append_Input>;
  _delete_at_path?: InputMaybe<Amendment_Case_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Amendment_Case_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Amendment_Case_Delete_Key_Input>;
  _inc?: InputMaybe<Amendment_Case_Inc_Input>;
  _prepend?: InputMaybe<Amendment_Case_Prepend_Input>;
  _set?: InputMaybe<Amendment_Case_Set_Input>;
  pk_columns: Amendment_Case_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Amendment_Case_ManyArgs = {
  updates: Array<Amendment_Case_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_GroupArgs = {
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Set_Input>;
  where: Auth_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_By_PkArgs = {
  _inc?: InputMaybe<Auth_Group_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Set_Input>;
  pk_columns: Auth_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_ManyArgs = {
  updates: Array<Auth_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_PermissionsArgs = {
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  where: Auth_Group_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Auth_Group_Permissions_Inc_Input>;
  _set?: InputMaybe<Auth_Group_Permissions_Set_Input>;
  pk_columns: Auth_Group_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Group_Permissions_ManyArgs = {
  updates: Array<Auth_Group_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_PermissionArgs = {
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  where: Auth_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Permission_By_PkArgs = {
  _inc?: InputMaybe<Auth_Permission_Inc_Input>;
  _set?: InputMaybe<Auth_Permission_Set_Input>;
  pk_columns: Auth_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Permission_ManyArgs = {
  updates: Array<Auth_Permission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_UserArgs = {
  _append?: InputMaybe<Base_User_Append_Input>;
  _delete_at_path?: InputMaybe<Base_User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Base_User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Base_User_Delete_Key_Input>;
  _inc?: InputMaybe<Base_User_Inc_Input>;
  _prepend?: InputMaybe<Base_User_Prepend_Input>;
  _set?: InputMaybe<Base_User_Set_Input>;
  where: Base_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Address_BookArgs = {
  _inc?: InputMaybe<Base_User_Address_Book_Inc_Input>;
  _set?: InputMaybe<Base_User_Address_Book_Set_Input>;
  where: Base_User_Address_Book_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Address_Book_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Address_Book_Inc_Input>;
  _set?: InputMaybe<Base_User_Address_Book_Set_Input>;
  pk_columns: Base_User_Address_Book_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Address_Book_ManyArgs = {
  updates: Array<Base_User_Address_Book_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_By_PkArgs = {
  _append?: InputMaybe<Base_User_Append_Input>;
  _delete_at_path?: InputMaybe<Base_User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Base_User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Base_User_Delete_Key_Input>;
  _inc?: InputMaybe<Base_User_Inc_Input>;
  _prepend?: InputMaybe<Base_User_Prepend_Input>;
  _set?: InputMaybe<Base_User_Set_Input>;
  pk_columns: Base_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_CompaniesArgs = {
  _inc?: InputMaybe<Base_User_Companies_Inc_Input>;
  _set?: InputMaybe<Base_User_Companies_Set_Input>;
  where: Base_User_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Companies_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Companies_Inc_Input>;
  _set?: InputMaybe<Base_User_Companies_Set_Input>;
  pk_columns: Base_User_Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Companies_ManyArgs = {
  updates: Array<Base_User_Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_DepartmentsArgs = {
  _inc?: InputMaybe<Base_User_Departments_Inc_Input>;
  _set?: InputMaybe<Base_User_Departments_Set_Input>;
  where: Base_User_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Departments_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Departments_Inc_Input>;
  _set?: InputMaybe<Base_User_Departments_Set_Input>;
  pk_columns: Base_User_Departments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Departments_ManyArgs = {
  updates: Array<Base_User_Departments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_GroupsArgs = {
  _inc?: InputMaybe<Base_User_Groups_Inc_Input>;
  _set?: InputMaybe<Base_User_Groups_Set_Input>;
  where: Base_User_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Groups_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Groups_Inc_Input>;
  _set?: InputMaybe<Base_User_Groups_Set_Input>;
  pk_columns: Base_User_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Groups_ManyArgs = {
  updates: Array<Base_User_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_ManyArgs = {
  updates: Array<Base_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_NetworkArgs = {
  _inc?: InputMaybe<Base_User_Network_Inc_Input>;
  _set?: InputMaybe<Base_User_Network_Set_Input>;
  where: Base_User_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Network_By_PkArgs = {
  _inc?: InputMaybe<Base_User_Network_Inc_Input>;
  _set?: InputMaybe<Base_User_Network_Set_Input>;
  pk_columns: Base_User_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_Network_ManyArgs = {
  updates: Array<Base_User_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_User_PermissionsArgs = {
  _inc?: InputMaybe<Base_User_User_Permissions_Inc_Input>;
  _set?: InputMaybe<Base_User_User_Permissions_Set_Input>;
  where: Base_User_User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_User_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Base_User_User_Permissions_Inc_Input>;
  _set?: InputMaybe<Base_User_User_Permissions_Set_Input>;
  pk_columns: Base_User_User_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_User_User_Permissions_ManyArgs = {
  updates: Array<Base_User_User_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_StatusArgs = {
  approval_status: Scalars['String'];
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootUpdate_BrandArgs = {
  _inc?: InputMaybe<Brand_Inc_Input>;
  _set?: InputMaybe<Brand_Set_Input>;
  where: Brand_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_By_PkArgs = {
  _inc?: InputMaybe<Brand_Inc_Input>;
  _set?: InputMaybe<Brand_Set_Input>;
  pk_columns: Brand_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_CompanyArgs = {
  _inc?: InputMaybe<Brand_Company_Inc_Input>;
  _set?: InputMaybe<Brand_Company_Set_Input>;
  where: Brand_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Company_By_PkArgs = {
  _inc?: InputMaybe<Brand_Company_Inc_Input>;
  _set?: InputMaybe<Brand_Company_Set_Input>;
  pk_columns: Brand_Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Company_ManyArgs = {
  updates: Array<Brand_Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_ManyArgs = {
  updates: Array<Brand_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BreederArgs = {
  _inc?: InputMaybe<Breeder_Inc_Input>;
  _set?: InputMaybe<Breeder_Set_Input>;
  where: Breeder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Breeder_By_PkArgs = {
  _inc?: InputMaybe<Breeder_Inc_Input>;
  _set?: InputMaybe<Breeder_Set_Input>;
  pk_columns: Breeder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Breeder_ManyArgs = {
  updates: Array<Breeder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BusinessArgs = {
  _append?: InputMaybe<Business_Append_Input>;
  _delete_at_path?: InputMaybe<Business_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Business_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Business_Delete_Key_Input>;
  _inc?: InputMaybe<Business_Inc_Input>;
  _prepend?: InputMaybe<Business_Prepend_Input>;
  _set?: InputMaybe<Business_Set_Input>;
  where: Business_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_By_PkArgs = {
  _append?: InputMaybe<Business_Append_Input>;
  _delete_at_path?: InputMaybe<Business_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Business_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Business_Delete_Key_Input>;
  _inc?: InputMaybe<Business_Inc_Input>;
  _prepend?: InputMaybe<Business_Prepend_Input>;
  _set?: InputMaybe<Business_Set_Input>;
  pk_columns: Business_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Commodities_SuppliedArgs = {
  _inc?: InputMaybe<Business_Commodities_Supplied_Inc_Input>;
  _set?: InputMaybe<Business_Commodities_Supplied_Set_Input>;
  where: Business_Commodities_Supplied_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Commodities_Supplied_By_PkArgs = {
  _inc?: InputMaybe<Business_Commodities_Supplied_Inc_Input>;
  _set?: InputMaybe<Business_Commodities_Supplied_Set_Input>;
  pk_columns: Business_Commodities_Supplied_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Commodities_Supplied_ManyArgs = {
  updates: Array<Business_Commodities_Supplied_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_CompaniesArgs = {
  _inc?: InputMaybe<Business_Companies_Inc_Input>;
  _set?: InputMaybe<Business_Companies_Set_Input>;
  where: Business_Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Companies_By_PkArgs = {
  _inc?: InputMaybe<Business_Companies_Inc_Input>;
  _set?: InputMaybe<Business_Companies_Set_Input>;
  pk_columns: Business_Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Companies_ManyArgs = {
  updates: Array<Business_Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_FieldArgs = {
  _inc?: InputMaybe<Business_Field_Inc_Input>;
  _set?: InputMaybe<Business_Field_Set_Input>;
  where: Business_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Field_By_PkArgs = {
  _inc?: InputMaybe<Business_Field_Inc_Input>;
  _set?: InputMaybe<Business_Field_Set_Input>;
  pk_columns: Business_Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Field_ManyArgs = {
  updates: Array<Business_Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_GroupArgs = {
  _inc?: InputMaybe<Business_Group_Inc_Input>;
  _set?: InputMaybe<Business_Group_Set_Input>;
  where: Business_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_By_PkArgs = {
  _inc?: InputMaybe<Business_Group_Inc_Input>;
  _set?: InputMaybe<Business_Group_Set_Input>;
  pk_columns: Business_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_ManyArgs = {
  updates: Array<Business_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_NetworkArgs = {
  _inc?: InputMaybe<Business_Group_Network_Inc_Input>;
  _set?: InputMaybe<Business_Group_Network_Set_Input>;
  where: Business_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_Network_By_PkArgs = {
  _inc?: InputMaybe<Business_Group_Network_Inc_Input>;
  _set?: InputMaybe<Business_Group_Network_Set_Input>;
  pk_columns: Business_Group_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Group_Network_ManyArgs = {
  updates: Array<Business_Group_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_GroupsArgs = {
  _inc?: InputMaybe<Business_Groups_Inc_Input>;
  _set?: InputMaybe<Business_Groups_Set_Input>;
  where: Business_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Groups_By_PkArgs = {
  _inc?: InputMaybe<Business_Groups_Inc_Input>;
  _set?: InputMaybe<Business_Groups_Set_Input>;
  pk_columns: Business_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Groups_ManyArgs = {
  updates: Array<Business_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_ManyArgs = {
  updates: Array<Business_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_NetworkArgs = {
  _inc?: InputMaybe<Business_Network_Inc_Input>;
  _set?: InputMaybe<Business_Network_Set_Input>;
  where: Business_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Network_By_PkArgs = {
  _inc?: InputMaybe<Business_Network_Inc_Input>;
  _set?: InputMaybe<Business_Network_Set_Input>;
  pk_columns: Business_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Network_ManyArgs = {
  updates: Array<Business_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Secondary_PocsArgs = {
  _inc?: InputMaybe<Business_Secondary_Pocs_Inc_Input>;
  _set?: InputMaybe<Business_Secondary_Pocs_Set_Input>;
  where: Business_Secondary_Pocs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Secondary_Pocs_By_PkArgs = {
  _inc?: InputMaybe<Business_Secondary_Pocs_Inc_Input>;
  _set?: InputMaybe<Business_Secondary_Pocs_Set_Input>;
  pk_columns: Business_Secondary_Pocs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Business_Secondary_Pocs_ManyArgs = {
  updates: Array<Business_Secondary_Pocs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_By_Pk_Eagle_AddressArgs = {
  _inc?: InputMaybe<Eagle_Address_Inc_Input>;
  _set?: InputMaybe<Eagle_Address_Set_Input>;
  pk_columns: Eagle_Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_By_Pk_Eagle_MediaArgs = {
  _append?: InputMaybe<Eagle_Media_Append_Input>;
  _delete_at_path?: InputMaybe<Eagle_Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Eagle_Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Eagle_Media_Delete_Key_Input>;
  _inc?: InputMaybe<Eagle_Media_Inc_Input>;
  _prepend?: InputMaybe<Eagle_Media_Prepend_Input>;
  _set?: InputMaybe<Eagle_Media_Set_Input>;
  pk_columns: Eagle_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_By_Pk_Setu_Trade_Shared_EntityArgs = {
  _set?: InputMaybe<Setu_Trade_Shared_Entity_Set_Input>;
  pk_columns: Setu_Trade_Shared_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_By_Pk_Setutrade_MediaArgs = {
  _inc?: InputMaybe<Setutrade_Media_Inc_Input>;
  _set?: InputMaybe<Setutrade_Media_Set_Input>;
  pk_columns: Setutrade_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CommodityArgs = {
  _append?: InputMaybe<Commodity_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Prepend_Input>;
  _set?: InputMaybe<Commodity_Set_Input>;
  where: Commodity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_By_PkArgs = {
  _append?: InputMaybe<Commodity_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Prepend_Input>;
  _set?: InputMaybe<Commodity_Set_Input>;
  pk_columns: Commodity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_ManyArgs = {
  updates: Array<Commodity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_VarietyArgs = {
  _append?: InputMaybe<Commodity_Variety_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Variety_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Variety_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Variety_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Variety_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Variety_Prepend_Input>;
  _set?: InputMaybe<Commodity_Variety_Set_Input>;
  where: Commodity_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_By_PkArgs = {
  _append?: InputMaybe<Commodity_Variety_Append_Input>;
  _delete_at_path?: InputMaybe<Commodity_Variety_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Commodity_Variety_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Commodity_Variety_Delete_Key_Input>;
  _inc?: InputMaybe<Commodity_Variety_Inc_Input>;
  _prepend?: InputMaybe<Commodity_Variety_Prepend_Input>;
  _set?: InputMaybe<Commodity_Variety_Set_Input>;
  pk_columns: Commodity_Variety_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_ManyArgs = {
  updates: Array<Commodity_Variety_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_Secondary_GroupsArgs = {
  _inc?: InputMaybe<Commodity_Variety_Secondary_Groups_Inc_Input>;
  _set?: InputMaybe<Commodity_Variety_Secondary_Groups_Set_Input>;
  where: Commodity_Variety_Secondary_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_Secondary_Groups_By_PkArgs = {
  _inc?: InputMaybe<Commodity_Variety_Secondary_Groups_Inc_Input>;
  _set?: InputMaybe<Commodity_Variety_Secondary_Groups_Set_Input>;
  pk_columns: Commodity_Variety_Secondary_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commodity_Variety_Secondary_Groups_ManyArgs = {
  updates: Array<Commodity_Variety_Secondary_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyArgs = {
  _inc?: InputMaybe<Company_Inc_Input>;
  _set?: InputMaybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_By_PkArgs = {
  _inc?: InputMaybe<Company_Inc_Input>;
  _set?: InputMaybe<Company_Set_Input>;
  pk_columns: Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_CategoriesArgs = {
  _inc?: InputMaybe<Company_Categories_Inc_Input>;
  _set?: InputMaybe<Company_Categories_Set_Input>;
  where: Company_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Categories_By_PkArgs = {
  _inc?: InputMaybe<Company_Categories_Inc_Input>;
  _set?: InputMaybe<Company_Categories_Set_Input>;
  pk_columns: Company_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Categories_ManyArgs = {
  updates: Array<Company_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_CategoryArgs = {
  _inc?: InputMaybe<Company_Category_Inc_Input>;
  _set?: InputMaybe<Company_Category_Set_Input>;
  where: Company_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Category_By_PkArgs = {
  _inc?: InputMaybe<Company_Category_Inc_Input>;
  _set?: InputMaybe<Company_Category_Set_Input>;
  pk_columns: Company_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Category_ManyArgs = {
  updates: Array<Company_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_ManyArgs = {
  updates: Array<Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Share_HolderArgs = {
  _inc?: InputMaybe<Company_Share_Holder_Inc_Input>;
  _set?: InputMaybe<Company_Share_Holder_Set_Input>;
  where: Company_Share_Holder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Share_Holder_By_PkArgs = {
  _inc?: InputMaybe<Company_Share_Holder_Inc_Input>;
  _set?: InputMaybe<Company_Share_Holder_Set_Input>;
  pk_columns: Company_Share_Holder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Share_Holder_ManyArgs = {
  updates: Array<Company_Share_Holder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_NoteArgs = {
  _inc?: InputMaybe<Credit_Note_Inc_Input>;
  _set?: InputMaybe<Credit_Note_Set_Input>;
  where: Credit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_By_PkArgs = {
  _inc?: InputMaybe<Credit_Note_Inc_Input>;
  _set?: InputMaybe<Credit_Note_Set_Input>;
  pk_columns: Credit_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_ManyArgs = {
  updates: Array<Credit_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CropArgs = {
  _inc?: InputMaybe<Crop_Inc_Input>;
  _set?: InputMaybe<Crop_Set_Input>;
  where: Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_By_PkArgs = {
  _inc?: InputMaybe<Crop_Inc_Input>;
  _set?: InputMaybe<Crop_Set_Input>;
  pk_columns: Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_GroupArgs = {
  _inc?: InputMaybe<Crop_Group_Inc_Input>;
  _set?: InputMaybe<Crop_Group_Set_Input>;
  where: Crop_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Group_By_PkArgs = {
  _inc?: InputMaybe<Crop_Group_Inc_Input>;
  _set?: InputMaybe<Crop_Group_Set_Input>;
  pk_columns: Crop_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Group_ManyArgs = {
  updates: Array<Crop_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_InfestationArgs = {
  _inc?: InputMaybe<Crop_Infestation_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Set_Input>;
  where: Crop_Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_AttachmentArgs = {
  _inc?: InputMaybe<Crop_Infestation_Attachment_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Attachment_Set_Input>;
  where: Crop_Infestation_Attachment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Crop_Infestation_Attachment_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Attachment_Set_Input>;
  pk_columns: Crop_Infestation_Attachment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_Attachment_ManyArgs = {
  updates: Array<Crop_Infestation_Attachment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_By_PkArgs = {
  _inc?: InputMaybe<Crop_Infestation_Inc_Input>;
  _set?: InputMaybe<Crop_Infestation_Set_Input>;
  pk_columns: Crop_Infestation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Infestation_ManyArgs = {
  updates: Array<Crop_Infestation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_ManyArgs = {
  updates: Array<Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_MilestoneArgs = {
  _inc?: InputMaybe<Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Crop_Milestone_Set_Input>;
  where: Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Milestone_By_PkArgs = {
  _inc?: InputMaybe<Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Crop_Milestone_Set_Input>;
  pk_columns: Crop_Milestone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Milestone_ManyArgs = {
  updates: Array<Crop_Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_RootstockArgs = {
  _inc?: InputMaybe<Crop_Rootstock_Inc_Input>;
  _set?: InputMaybe<Crop_Rootstock_Set_Input>;
  where: Crop_Rootstock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Rootstock_By_PkArgs = {
  _inc?: InputMaybe<Crop_Rootstock_Inc_Input>;
  _set?: InputMaybe<Crop_Rootstock_Set_Input>;
  pk_columns: Crop_Rootstock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Rootstock_ManyArgs = {
  updates: Array<Crop_Rootstock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_VarietyArgs = {
  _inc?: InputMaybe<Crop_Variety_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Set_Input>;
  where: Crop_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_BreederArgs = {
  _inc?: InputMaybe<Crop_Variety_Breeder_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Breeder_Set_Input>;
  where: Crop_Variety_Breeder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_Breeder_By_PkArgs = {
  _inc?: InputMaybe<Crop_Variety_Breeder_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Breeder_Set_Input>;
  pk_columns: Crop_Variety_Breeder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_Breeder_ManyArgs = {
  updates: Array<Crop_Variety_Breeder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_By_PkArgs = {
  _inc?: InputMaybe<Crop_Variety_Inc_Input>;
  _set?: InputMaybe<Crop_Variety_Set_Input>;
  pk_columns: Crop_Variety_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Variety_ManyArgs = {
  updates: Array<Crop_Variety_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_YearArgs = {
  _inc?: InputMaybe<Crop_Year_Inc_Input>;
  _set?: InputMaybe<Crop_Year_Set_Input>;
  where: Crop_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Year_By_PkArgs = {
  _inc?: InputMaybe<Crop_Year_Inc_Input>;
  _set?: InputMaybe<Crop_Year_Set_Input>;
  pk_columns: Crop_Year_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Crop_Year_ManyArgs = {
  updates: Array<Crop_Year_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cultivation_TypeArgs = {
  _inc?: InputMaybe<Cultivation_Type_Inc_Input>;
  _set?: InputMaybe<Cultivation_Type_Set_Input>;
  where: Cultivation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cultivation_Type_By_PkArgs = {
  _inc?: InputMaybe<Cultivation_Type_Inc_Input>;
  _set?: InputMaybe<Cultivation_Type_Set_Input>;
  pk_columns: Cultivation_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cultivation_Type_ManyArgs = {
  updates: Array<Cultivation_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DemandArgs = {
  _set?: InputMaybe<Demand_Set_Input>;
  where: Demand_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Demand_By_PkArgs = {
  _set?: InputMaybe<Demand_Set_Input>;
  pk_columns: Demand_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Demand_ManyArgs = {
  updates: Array<Demand_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DepartmentArgs = {
  _inc?: InputMaybe<Department_Inc_Input>;
  _set?: InputMaybe<Department_Set_Input>;
  where: Department_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_By_PkArgs = {
  _inc?: InputMaybe<Department_Inc_Input>;
  _set?: InputMaybe<Department_Set_Input>;
  pk_columns: Department_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Department_ManyArgs = {
  updates: Array<Department_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Payment_DetailArgs = {
  _inc?: InputMaybe<Department_Payment_Detail_Inc_Input>;
  _set?: InputMaybe<Department_Payment_Detail_Set_Input>;
  where: Department_Payment_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Payment_Detail_By_PkArgs = {
  _inc?: InputMaybe<Department_Payment_Detail_Inc_Input>;
  _set?: InputMaybe<Department_Payment_Detail_Set_Input>;
  pk_columns: Department_Payment_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Payment_Detail_ManyArgs = {
  updates: Array<Department_Payment_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Department_SettlementsArgs = {
  _inc?: InputMaybe<Department_Settlements_Inc_Input>;
  _set?: InputMaybe<Department_Settlements_Set_Input>;
  where: Department_Settlements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Settlements_By_PkArgs = {
  _inc?: InputMaybe<Department_Settlements_Inc_Input>;
  _set?: InputMaybe<Department_Settlements_Set_Input>;
  pk_columns: Department_Settlements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Department_Settlements_ManyArgs = {
  updates: Array<Department_Settlements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DeviceArgs = {
  _append?: InputMaybe<Device_Append_Input>;
  _delete_at_path?: InputMaybe<Device_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Device_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Device_Delete_Key_Input>;
  _inc?: InputMaybe<Device_Inc_Input>;
  _prepend?: InputMaybe<Device_Prepend_Input>;
  _set?: InputMaybe<Device_Set_Input>;
  where: Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Device_By_PkArgs = {
  _append?: InputMaybe<Device_Append_Input>;
  _delete_at_path?: InputMaybe<Device_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Device_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Device_Delete_Key_Input>;
  _inc?: InputMaybe<Device_Inc_Input>;
  _prepend?: InputMaybe<Device_Prepend_Input>;
  _set?: InputMaybe<Device_Set_Input>;
  pk_columns: Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Device_ManyArgs = {
  updates: Array<Device_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Django_Content_TypeArgs = {
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  where: Django_Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Django_Content_Type_By_PkArgs = {
  _inc?: InputMaybe<Django_Content_Type_Inc_Input>;
  _set?: InputMaybe<Django_Content_Type_Set_Input>;
  pk_columns: Django_Content_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Django_Content_Type_ManyArgs = {
  updates: Array<Django_Content_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentArgs = {
  _inc?: InputMaybe<Document_Inc_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_AttachmentsArgs = {
  _inc?: InputMaybe<Document_Attachments_Inc_Input>;
  _set?: InputMaybe<Document_Attachments_Set_Input>;
  where: Document_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Document_Attachments_Inc_Input>;
  _set?: InputMaybe<Document_Attachments_Set_Input>;
  pk_columns: Document_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Attachments_ManyArgs = {
  updates: Array<Document_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_By_PkArgs = {
  _inc?: InputMaybe<Document_Inc_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  pk_columns: Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_DataArgs = {
  _inc?: InputMaybe<Document_Data_Inc_Input>;
  _set?: InputMaybe<Document_Data_Set_Input>;
  where: Document_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Data_By_PkArgs = {
  _inc?: InputMaybe<Document_Data_Inc_Input>;
  _set?: InputMaybe<Document_Data_Set_Input>;
  pk_columns: Document_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Data_ManyArgs = {
  updates: Array<Document_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Export_LogArgs = {
  _inc?: InputMaybe<Document_Export_Log_Inc_Input>;
  _set?: InputMaybe<Document_Export_Log_Set_Input>;
  where: Document_Export_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Export_Log_By_PkArgs = {
  _inc?: InputMaybe<Document_Export_Log_Inc_Input>;
  _set?: InputMaybe<Document_Export_Log_Set_Input>;
  pk_columns: Document_Export_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Export_Log_ManyArgs = {
  updates: Array<Document_Export_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_KindArgs = {
  _inc?: InputMaybe<Document_Kind_Inc_Input>;
  _set?: InputMaybe<Document_Kind_Set_Input>;
  where: Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_By_PkArgs = {
  _inc?: InputMaybe<Document_Kind_Inc_Input>;
  _set?: InputMaybe<Document_Kind_Set_Input>;
  pk_columns: Document_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_Data_FieldArgs = {
  _append?: InputMaybe<Document_Kind_Data_Field_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Kind_Data_Field_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Kind_Data_Field_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Kind_Data_Field_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Kind_Data_Field_Inc_Input>;
  _prepend?: InputMaybe<Document_Kind_Data_Field_Prepend_Input>;
  _set?: InputMaybe<Document_Kind_Data_Field_Set_Input>;
  where: Document_Kind_Data_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_Data_Field_By_PkArgs = {
  _append?: InputMaybe<Document_Kind_Data_Field_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Kind_Data_Field_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Kind_Data_Field_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Kind_Data_Field_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Kind_Data_Field_Inc_Input>;
  _prepend?: InputMaybe<Document_Kind_Data_Field_Prepend_Input>;
  _set?: InputMaybe<Document_Kind_Data_Field_Set_Input>;
  pk_columns: Document_Kind_Data_Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_Data_Field_ManyArgs = {
  updates: Array<Document_Kind_Data_Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Kind_ManyArgs = {
  updates: Array<Document_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ManyArgs = {
  updates: Array<Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ReportArgs = {
  _append?: InputMaybe<Document_Report_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Report_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Report_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Report_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Report_Inc_Input>;
  _prepend?: InputMaybe<Document_Report_Prepend_Input>;
  _set?: InputMaybe<Document_Report_Set_Input>;
  where: Document_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Report_By_PkArgs = {
  _append?: InputMaybe<Document_Report_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Report_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Report_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Report_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Report_Inc_Input>;
  _prepend?: InputMaybe<Document_Report_Prepend_Input>;
  _set?: InputMaybe<Document_Report_Set_Input>;
  pk_columns: Document_Report_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Report_ManyArgs = {
  updates: Array<Document_Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_RevisionArgs = {
  _inc?: InputMaybe<Document_Revision_Inc_Input>;
  _set?: InputMaybe<Document_Revision_Set_Input>;
  where: Document_Revision_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Revision_By_PkArgs = {
  _inc?: InputMaybe<Document_Revision_Inc_Input>;
  _set?: InputMaybe<Document_Revision_Set_Input>;
  pk_columns: Document_Revision_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Revision_ManyArgs = {
  updates: Array<Document_Revision_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eagle_AddressArgs = {
  _inc?: InputMaybe<Eagle_Address_Inc_Input>;
  _set?: InputMaybe<Eagle_Address_Set_Input>;
  where: Eagle_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eagle_Address_ManyArgs = {
  updates: Array<Eagle_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Eagle_MediaArgs = {
  _append?: InputMaybe<Eagle_Media_Append_Input>;
  _delete_at_path?: InputMaybe<Eagle_Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Eagle_Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Eagle_Media_Delete_Key_Input>;
  _inc?: InputMaybe<Eagle_Media_Inc_Input>;
  _prepend?: InputMaybe<Eagle_Media_Prepend_Input>;
  _set?: InputMaybe<Eagle_Media_Set_Input>;
  where: Eagle_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Eagle_Media_ManyArgs = {
  updates: Array<Eagle_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_StateArgs = {
  _inc?: InputMaybe<Entity_State_Inc_Input>;
  _set?: InputMaybe<Entity_State_Set_Input>;
  where: Entity_State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_State_By_PkArgs = {
  _inc?: InputMaybe<Entity_State_Inc_Input>;
  _set?: InputMaybe<Entity_State_Set_Input>;
  pk_columns: Entity_State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_State_ManyArgs = {
  updates: Array<Entity_State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Evaluation_CriteriaArgs = {
  _inc?: InputMaybe<Evaluation_Criteria_Inc_Input>;
  _set?: InputMaybe<Evaluation_Criteria_Set_Input>;
  where: Evaluation_Criteria_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Evaluation_Criteria_By_PkArgs = {
  _inc?: InputMaybe<Evaluation_Criteria_Inc_Input>;
  _set?: InputMaybe<Evaluation_Criteria_Set_Input>;
  pk_columns: Evaluation_Criteria_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Evaluation_Criteria_ManyArgs = {
  updates: Array<Evaluation_Criteria_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Evaluation_TagArgs = {
  _inc?: InputMaybe<Evaluation_Tag_Inc_Input>;
  _set?: InputMaybe<Evaluation_Tag_Set_Input>;
  where: Evaluation_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Evaluation_Tag_By_PkArgs = {
  _inc?: InputMaybe<Evaluation_Tag_Inc_Input>;
  _set?: InputMaybe<Evaluation_Tag_Set_Input>;
  pk_columns: Evaluation_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Evaluation_Tag_ManyArgs = {
  updates: Array<Evaluation_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExpenseArgs = {
  _inc?: InputMaybe<Expense_Inc_Input>;
  _set?: InputMaybe<Expense_Set_Input>;
  where: Expense_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Expense_By_PkArgs = {
  _inc?: InputMaybe<Expense_Inc_Input>;
  _set?: InputMaybe<Expense_Set_Input>;
  pk_columns: Expense_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Expense_ManyArgs = {
  updates: Array<Expense_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_External_ApplicationArgs = {
  _append?: InputMaybe<External_Application_Append_Input>;
  _delete_at_path?: InputMaybe<External_Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Application_Delete_Key_Input>;
  _inc?: InputMaybe<External_Application_Inc_Input>;
  _prepend?: InputMaybe<External_Application_Prepend_Input>;
  _set?: InputMaybe<External_Application_Set_Input>;
  where: External_Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_External_Application_By_PkArgs = {
  _append?: InputMaybe<External_Application_Append_Input>;
  _delete_at_path?: InputMaybe<External_Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Application_Delete_Key_Input>;
  _inc?: InputMaybe<External_Application_Inc_Input>;
  _prepend?: InputMaybe<External_Application_Prepend_Input>;
  _set?: InputMaybe<External_Application_Set_Input>;
  pk_columns: External_Application_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_External_Application_ManyArgs = {
  updates: Array<External_Application_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_External_EntityArgs = {
  _append?: InputMaybe<External_Entity_Append_Input>;
  _delete_at_path?: InputMaybe<External_Entity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Entity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Entity_Delete_Key_Input>;
  _inc?: InputMaybe<External_Entity_Inc_Input>;
  _prepend?: InputMaybe<External_Entity_Prepend_Input>;
  _set?: InputMaybe<External_Entity_Set_Input>;
  where: External_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_External_Entity_By_PkArgs = {
  _append?: InputMaybe<External_Entity_Append_Input>;
  _delete_at_path?: InputMaybe<External_Entity_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Entity_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Entity_Delete_Key_Input>;
  _inc?: InputMaybe<External_Entity_Inc_Input>;
  _prepend?: InputMaybe<External_Entity_Prepend_Input>;
  _set?: InputMaybe<External_Entity_Set_Input>;
  pk_columns: External_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_External_Entity_GroupArgs = {
  _inc?: InputMaybe<External_Entity_Group_Inc_Input>;
  _set?: InputMaybe<External_Entity_Group_Set_Input>;
  where: External_Entity_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_External_Entity_Group_By_PkArgs = {
  _inc?: InputMaybe<External_Entity_Group_Inc_Input>;
  _set?: InputMaybe<External_Entity_Group_Set_Input>;
  pk_columns: External_Entity_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_External_Entity_Group_ManyArgs = {
  updates: Array<External_Entity_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_External_Entity_ManyArgs = {
  updates: Array<External_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_External_ReferenceArgs = {
  _append?: InputMaybe<External_Reference_Append_Input>;
  _delete_at_path?: InputMaybe<External_Reference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Reference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Reference_Delete_Key_Input>;
  _inc?: InputMaybe<External_Reference_Inc_Input>;
  _prepend?: InputMaybe<External_Reference_Prepend_Input>;
  _set?: InputMaybe<External_Reference_Set_Input>;
  where: External_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_External_Reference_By_PkArgs = {
  _append?: InputMaybe<External_Reference_Append_Input>;
  _delete_at_path?: InputMaybe<External_Reference_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Reference_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Reference_Delete_Key_Input>;
  _inc?: InputMaybe<External_Reference_Inc_Input>;
  _prepend?: InputMaybe<External_Reference_Prepend_Input>;
  _set?: InputMaybe<External_Reference_Set_Input>;
  pk_columns: External_Reference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_External_Reference_ManyArgs = {
  updates: Array<External_Reference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FarmArgs = {
  _append?: InputMaybe<Farm_Append_Input>;
  _delete_at_path?: InputMaybe<Farm_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farm_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farm_Delete_Key_Input>;
  _inc?: InputMaybe<Farm_Inc_Input>;
  _prepend?: InputMaybe<Farm_Prepend_Input>;
  _set?: InputMaybe<Farm_Set_Input>;
  where: Farm_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_By_PkArgs = {
  _append?: InputMaybe<Farm_Append_Input>;
  _delete_at_path?: InputMaybe<Farm_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Farm_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Farm_Delete_Key_Input>;
  _inc?: InputMaybe<Farm_Inc_Input>;
  _prepend?: InputMaybe<Farm_Prepend_Input>;
  _set?: InputMaybe<Farm_Set_Input>;
  pk_columns: Farm_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_ManyArgs = {
  updates: Array<Farm_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_NetworkArgs = {
  _inc?: InputMaybe<Farm_Network_Inc_Input>;
  _set?: InputMaybe<Farm_Network_Set_Input>;
  where: Farm_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_Network_By_PkArgs = {
  _inc?: InputMaybe<Farm_Network_Inc_Input>;
  _set?: InputMaybe<Farm_Network_Set_Input>;
  pk_columns: Farm_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farm_Network_ManyArgs = {
  updates: Array<Farm_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FieldArgs = {
  _append?: InputMaybe<Field_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Delete_Key_Input>;
  _inc?: InputMaybe<Field_Inc_Input>;
  _prepend?: InputMaybe<Field_Prepend_Input>;
  _set?: InputMaybe<Field_Set_Input>;
  where: Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_By_PkArgs = {
  _append?: InputMaybe<Field_Append_Input>;
  _delete_at_path?: InputMaybe<Field_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Field_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Field_Delete_Key_Input>;
  _inc?: InputMaybe<Field_Inc_Input>;
  _prepend?: InputMaybe<Field_Prepend_Input>;
  _set?: InputMaybe<Field_Set_Input>;
  pk_columns: Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_ManyArgs = {
  updates: Array<Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_NetworkArgs = {
  _inc?: InputMaybe<Field_Network_Inc_Input>;
  _set?: InputMaybe<Field_Network_Set_Input>;
  where: Field_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Network_By_PkArgs = {
  _inc?: InputMaybe<Field_Network_Inc_Input>;
  _set?: InputMaybe<Field_Network_Set_Input>;
  pk_columns: Field_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Network_ManyArgs = {
  updates: Array<Field_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Weather_LocationArgs = {
  _inc?: InputMaybe<Field_Weather_Location_Inc_Input>;
  _set?: InputMaybe<Field_Weather_Location_Set_Input>;
  where: Field_Weather_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Weather_Location_By_PkArgs = {
  _inc?: InputMaybe<Field_Weather_Location_Inc_Input>;
  _set?: InputMaybe<Field_Weather_Location_Set_Input>;
  pk_columns: Field_Weather_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Weather_Location_ManyArgs = {
  updates: Array<Field_Weather_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GradeArgs = {
  _inc?: InputMaybe<Grade_Inc_Input>;
  _set?: InputMaybe<Grade_Set_Input>;
  where: Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_By_PkArgs = {
  _inc?: InputMaybe<Grade_Inc_Input>;
  _set?: InputMaybe<Grade_Set_Input>;
  pk_columns: Grade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_CompanyArgs = {
  _inc?: InputMaybe<Grade_Company_Inc_Input>;
  _set?: InputMaybe<Grade_Company_Set_Input>;
  where: Grade_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Company_By_PkArgs = {
  _inc?: InputMaybe<Grade_Company_Inc_Input>;
  _set?: InputMaybe<Grade_Company_Set_Input>;
  pk_columns: Grade_Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Company_ManyArgs = {
  updates: Array<Grade_Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_ManyArgs = {
  updates: Array<Grade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_PriceArgs = {
  _inc?: InputMaybe<Grade_Price_Inc_Input>;
  _set?: InputMaybe<Grade_Price_Set_Input>;
  where: Grade_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Price_By_PkArgs = {
  _inc?: InputMaybe<Grade_Price_Inc_Input>;
  _set?: InputMaybe<Grade_Price_Set_Input>;
  pk_columns: Grade_Price_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_Price_ManyArgs = {
  updates: Array<Grade_Price_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_AgreementArgs = {
  _append?: InputMaybe<Guarantor_Agreement_Append_Input>;
  _delete_at_path?: InputMaybe<Guarantor_Agreement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Guarantor_Agreement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Guarantor_Agreement_Delete_Key_Input>;
  _inc?: InputMaybe<Guarantor_Agreement_Inc_Input>;
  _prepend?: InputMaybe<Guarantor_Agreement_Prepend_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Set_Input>;
  where: Guarantor_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Agreement_InvoicesArgs = {
  _inc?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Inc_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Set_Input>;
  where: Guarantor_Agreement_Agreement_Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Agreement_Invoices_By_PkArgs = {
  _inc?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Inc_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Set_Input>;
  pk_columns: Guarantor_Agreement_Agreement_Invoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Agreement_Invoices_ManyArgs = {
  updates: Array<Guarantor_Agreement_Agreement_Invoices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Agreement_PlotsArgs = {
  _inc?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Inc_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Set_Input>;
  where: Guarantor_Agreement_Agreement_Plots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Agreement_Plots_By_PkArgs = {
  _inc?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Inc_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Set_Input>;
  pk_columns: Guarantor_Agreement_Agreement_Plots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Agreement_Plots_ManyArgs = {
  updates: Array<Guarantor_Agreement_Agreement_Plots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Area_Extension_DetailArgs = {
  _inc?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Inc_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Set_Input>;
  where: Guarantor_Agreement_Area_Extension_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Area_Extension_Detail_By_PkArgs = {
  _inc?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Inc_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Set_Input>;
  pk_columns: Guarantor_Agreement_Area_Extension_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_Area_Extension_Detail_ManyArgs = {
  updates: Array<Guarantor_Agreement_Area_Extension_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_By_PkArgs = {
  _append?: InputMaybe<Guarantor_Agreement_Append_Input>;
  _delete_at_path?: InputMaybe<Guarantor_Agreement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Guarantor_Agreement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Guarantor_Agreement_Delete_Key_Input>;
  _inc?: InputMaybe<Guarantor_Agreement_Inc_Input>;
  _prepend?: InputMaybe<Guarantor_Agreement_Prepend_Input>;
  _set?: InputMaybe<Guarantor_Agreement_Set_Input>;
  pk_columns: Guarantor_Agreement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Guarantor_Agreement_ManyArgs = {
  updates: Array<Guarantor_Agreement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InfestationArgs = {
  _inc?: InputMaybe<Infestation_Inc_Input>;
  _set?: InputMaybe<Infestation_Set_Input>;
  where: Infestation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Infestation_By_PkArgs = {
  _inc?: InputMaybe<Infestation_Inc_Input>;
  _set?: InputMaybe<Infestation_Set_Input>;
  pk_columns: Infestation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Infestation_ManyArgs = {
  updates: Array<Infestation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InstrumentArgs = {
  _inc?: InputMaybe<Instrument_Inc_Input>;
  _set?: InputMaybe<Instrument_Set_Input>;
  where: Instrument_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_By_PkArgs = {
  _inc?: InputMaybe<Instrument_Inc_Input>;
  _set?: InputMaybe<Instrument_Set_Input>;
  pk_columns: Instrument_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_DepartmentsArgs = {
  _inc?: InputMaybe<Instrument_Departments_Inc_Input>;
  _set?: InputMaybe<Instrument_Departments_Set_Input>;
  where: Instrument_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_Departments_By_PkArgs = {
  _inc?: InputMaybe<Instrument_Departments_Inc_Input>;
  _set?: InputMaybe<Instrument_Departments_Set_Input>;
  pk_columns: Instrument_Departments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_Departments_ManyArgs = {
  updates: Array<Instrument_Departments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_KindArgs = {
  _inc?: InputMaybe<Instrument_Kind_Inc_Input>;
  _set?: InputMaybe<Instrument_Kind_Set_Input>;
  where: Instrument_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_Kind_By_PkArgs = {
  _inc?: InputMaybe<Instrument_Kind_Inc_Input>;
  _set?: InputMaybe<Instrument_Kind_Set_Input>;
  pk_columns: Instrument_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_Kind_ManyArgs = {
  updates: Array<Instrument_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Instrument_ManyArgs = {
  updates: Array<Instrument_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceArgs = {
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_By_PkArgs = {
  _set?: InputMaybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Issuance_Note_AttachmentsArgs = {
  _inc?: InputMaybe<Issuance_Note_Attachments_Inc_Input>;
  _set?: InputMaybe<Issuance_Note_Attachments_Set_Input>;
  where: Issuance_Note_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Issuance_Note_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Issuance_Note_Attachments_Inc_Input>;
  _set?: InputMaybe<Issuance_Note_Attachments_Set_Input>;
  pk_columns: Issuance_Note_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Issuance_Note_Attachments_ManyArgs = {
  updates: Array<Issuance_Note_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Kite_NotificationArgs = {
  _append?: InputMaybe<Kite_Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Kite_Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Kite_Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Kite_Notification_Delete_Key_Input>;
  _inc?: InputMaybe<Kite_Notification_Inc_Input>;
  _prepend?: InputMaybe<Kite_Notification_Prepend_Input>;
  _set?: InputMaybe<Kite_Notification_Set_Input>;
  where: Kite_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kite_Notification_By_PkArgs = {
  _append?: InputMaybe<Kite_Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Kite_Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Kite_Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Kite_Notification_Delete_Key_Input>;
  _inc?: InputMaybe<Kite_Notification_Inc_Input>;
  _prepend?: InputMaybe<Kite_Notification_Prepend_Input>;
  _set?: InputMaybe<Kite_Notification_Set_Input>;
  pk_columns: Kite_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kite_Notification_ManyArgs = {
  updates: Array<Kite_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Kite_Quality_StageArgs = {
  _inc?: InputMaybe<Kite_Quality_Stage_Inc_Input>;
  _set?: InputMaybe<Kite_Quality_Stage_Set_Input>;
  where: Kite_Quality_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kite_Quality_Stage_By_PkArgs = {
  _inc?: InputMaybe<Kite_Quality_Stage_Inc_Input>;
  _set?: InputMaybe<Kite_Quality_Stage_Set_Input>;
  pk_columns: Kite_Quality_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kite_Quality_Stage_ManyArgs = {
  updates: Array<Kite_Quality_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LaboratoryArgs = {
  _inc?: InputMaybe<Laboratory_Inc_Input>;
  _set?: InputMaybe<Laboratory_Set_Input>;
  where: Laboratory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_By_PkArgs = {
  _inc?: InputMaybe<Laboratory_Inc_Input>;
  _set?: InputMaybe<Laboratory_Set_Input>;
  pk_columns: Laboratory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_ManyArgs = {
  updates: Array<Laboratory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_OrganisationsArgs = {
  _inc?: InputMaybe<Laboratory_Organisations_Inc_Input>;
  _set?: InputMaybe<Laboratory_Organisations_Set_Input>;
  where: Laboratory_Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Organisations_By_PkArgs = {
  _inc?: InputMaybe<Laboratory_Organisations_Inc_Input>;
  _set?: InputMaybe<Laboratory_Organisations_Set_Input>;
  pk_columns: Laboratory_Organisations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Laboratory_Organisations_ManyArgs = {
  updates: Array<Laboratory_Organisations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_AgreementArgs = {
  _append?: InputMaybe<Legal_Agreement_Append_Input>;
  _delete_at_path?: InputMaybe<Legal_Agreement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Legal_Agreement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Legal_Agreement_Delete_Key_Input>;
  _inc?: InputMaybe<Legal_Agreement_Inc_Input>;
  _prepend?: InputMaybe<Legal_Agreement_Prepend_Input>;
  _set?: InputMaybe<Legal_Agreement_Set_Input>;
  where: Legal_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Agreement_By_PkArgs = {
  _append?: InputMaybe<Legal_Agreement_Append_Input>;
  _delete_at_path?: InputMaybe<Legal_Agreement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Legal_Agreement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Legal_Agreement_Delete_Key_Input>;
  _inc?: InputMaybe<Legal_Agreement_Inc_Input>;
  _prepend?: InputMaybe<Legal_Agreement_Prepend_Input>;
  _set?: InputMaybe<Legal_Agreement_Set_Input>;
  pk_columns: Legal_Agreement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Agreement_ManyArgs = {
  updates: Array<Legal_Agreement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MarketArgs = {
  _inc?: InputMaybe<Market_Inc_Input>;
  _set?: InputMaybe<Market_Set_Input>;
  where: Market_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Market_Allowed_DepartmentsArgs = {
  _inc?: InputMaybe<Market_Allowed_Departments_Inc_Input>;
  _set?: InputMaybe<Market_Allowed_Departments_Set_Input>;
  where: Market_Allowed_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Market_Allowed_Departments_By_PkArgs = {
  _inc?: InputMaybe<Market_Allowed_Departments_Inc_Input>;
  _set?: InputMaybe<Market_Allowed_Departments_Set_Input>;
  pk_columns: Market_Allowed_Departments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Market_Allowed_Departments_ManyArgs = {
  updates: Array<Market_Allowed_Departments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Market_By_PkArgs = {
  _inc?: InputMaybe<Market_Inc_Input>;
  _set?: InputMaybe<Market_Set_Input>;
  pk_columns: Market_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Market_ManyArgs = {
  updates: Array<Market_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MediaArgs = {
  _append?: InputMaybe<Media_Append_Input>;
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  _inc?: InputMaybe<Media_Inc_Input>;
  _prepend?: InputMaybe<Media_Prepend_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  where: Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Media_By_PkArgs = {
  _append?: InputMaybe<Media_Append_Input>;
  _delete_at_path?: InputMaybe<Media_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Media_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Media_Delete_Key_Input>;
  _inc?: InputMaybe<Media_Inc_Input>;
  _prepend?: InputMaybe<Media_Prepend_Input>;
  _set?: InputMaybe<Media_Set_Input>;
  pk_columns: Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Media_ManyArgs = {
  updates: Array<Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MilestoneArgs = {
  _inc?: InputMaybe<Milestone_Inc_Input>;
  _set?: InputMaybe<Milestone_Set_Input>;
  where: Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Milestone_By_PkArgs = {
  _inc?: InputMaybe<Milestone_Inc_Input>;
  _set?: InputMaybe<Milestone_Set_Input>;
  pk_columns: Milestone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Milestone_ManyArgs = {
  updates: Array<Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_GroupArgs = {
  _inc?: InputMaybe<Mutual_Group_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Set_Input>;
  where: Mutual_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Set_Input>;
  pk_columns: Mutual_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_ManyArgs = {
  updates: Array<Mutual_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_MembershipArgs = {
  _inc?: InputMaybe<Mutual_Group_Membership_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Membership_Set_Input>;
  where: Mutual_Group_Membership_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Membership_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Membership_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Membership_Set_Input>;
  pk_columns: Mutual_Group_Membership_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Membership_ManyArgs = {
  updates: Array<Mutual_Group_Membership_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_NetworkArgs = {
  _inc?: InputMaybe<Mutual_Group_Network_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Network_Set_Input>;
  where: Mutual_Group_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Network_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Network_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Network_Set_Input>;
  pk_columns: Mutual_Group_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Network_ManyArgs = {
  updates: Array<Mutual_Group_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_RoleArgs = {
  _inc?: InputMaybe<Mutual_Group_Role_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Role_Set_Input>;
  where: Mutual_Group_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Role_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Role_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Role_Set_Input>;
  pk_columns: Mutual_Group_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Role_ManyArgs = {
  updates: Array<Mutual_Group_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Weather_StationArgs = {
  _inc?: InputMaybe<Mutual_Group_Weather_Station_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Weather_Station_Set_Input>;
  where: Mutual_Group_Weather_Station_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Weather_Station_By_PkArgs = {
  _inc?: InputMaybe<Mutual_Group_Weather_Station_Inc_Input>;
  _set?: InputMaybe<Mutual_Group_Weather_Station_Set_Input>;
  pk_columns: Mutual_Group_Weather_Station_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mutual_Group_Weather_Station_ManyArgs = {
  updates: Array<Mutual_Group_Weather_Station_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NationalityArgs = {
  _set?: InputMaybe<Nationality_Set_Input>;
  where: Nationality_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nationality_By_PkArgs = {
  _set?: InputMaybe<Nationality_Set_Input>;
  pk_columns: Nationality_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nationality_ManyArgs = {
  updates: Array<Nationality_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NetworkArgs = {
  _inc?: InputMaybe<Network_Inc_Input>;
  _set?: InputMaybe<Network_Set_Input>;
  where: Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Network_By_PkArgs = {
  _inc?: InputMaybe<Network_Inc_Input>;
  _set?: InputMaybe<Network_Set_Input>;
  pk_columns: Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Network_ManyArgs = {
  updates: Array<Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NomineesArgs = {
  _append?: InputMaybe<Nominees_Append_Input>;
  _delete_at_path?: InputMaybe<Nominees_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Nominees_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Nominees_Delete_Key_Input>;
  _inc?: InputMaybe<Nominees_Inc_Input>;
  _prepend?: InputMaybe<Nominees_Prepend_Input>;
  _set?: InputMaybe<Nominees_Set_Input>;
  where: Nominees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nominees_By_PkArgs = {
  _append?: InputMaybe<Nominees_Append_Input>;
  _delete_at_path?: InputMaybe<Nominees_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Nominees_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Nominees_Delete_Key_Input>;
  _inc?: InputMaybe<Nominees_Inc_Input>;
  _prepend?: InputMaybe<Nominees_Prepend_Input>;
  _set?: InputMaybe<Nominees_Set_Input>;
  pk_columns: Nominees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nominees_DocumentsArgs = {
  _inc?: InputMaybe<Nominees_Documents_Inc_Input>;
  _set?: InputMaybe<Nominees_Documents_Set_Input>;
  where: Nominees_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nominees_Documents_By_PkArgs = {
  _inc?: InputMaybe<Nominees_Documents_Inc_Input>;
  _set?: InputMaybe<Nominees_Documents_Set_Input>;
  pk_columns: Nominees_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nominees_Documents_ManyArgs = {
  updates: Array<Nominees_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nominees_ManyArgs = {
  updates: Array<Nominees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ProviderArgs = {
  _append?: InputMaybe<Notification_Provider_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Provider_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Provider_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Provider_Delete_Key_Input>;
  _inc?: InputMaybe<Notification_Provider_Inc_Input>;
  _prepend?: InputMaybe<Notification_Provider_Prepend_Input>;
  _set?: InputMaybe<Notification_Provider_Set_Input>;
  where: Notification_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Provider_By_PkArgs = {
  _append?: InputMaybe<Notification_Provider_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Provider_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Provider_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Provider_Delete_Key_Input>;
  _inc?: InputMaybe<Notification_Provider_Inc_Input>;
  _prepend?: InputMaybe<Notification_Provider_Prepend_Input>;
  _set?: InputMaybe<Notification_Provider_Set_Input>;
  pk_columns: Notification_Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Provider_ManyArgs = {
  updates: Array<Notification_Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_TriggerArgs = {
  _append?: InputMaybe<Notification_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Trigger_Delete_Key_Input>;
  _inc?: InputMaybe<Notification_Trigger_Inc_Input>;
  _prepend?: InputMaybe<Notification_Trigger_Prepend_Input>;
  _set?: InputMaybe<Notification_Trigger_Set_Input>;
  where: Notification_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Trigger_By_PkArgs = {
  _append?: InputMaybe<Notification_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Trigger_Delete_Key_Input>;
  _inc?: InputMaybe<Notification_Trigger_Inc_Input>;
  _prepend?: InputMaybe<Notification_Trigger_Prepend_Input>;
  _set?: InputMaybe<Notification_Trigger_Set_Input>;
  pk_columns: Notification_Trigger_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Trigger_ManyArgs = {
  updates: Array<Notification_Trigger_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Offer_StatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_OffersArgs = {
  _set?: InputMaybe<Offers_Set_Input>;
  where: Offers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_By_PkArgs = {
  _set?: InputMaybe<Offers_Set_Input>;
  pk_columns: Offers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_ManyArgs = {
  updates: Array<Offers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Dashboard_StatsArgs = {
  _append?: InputMaybe<Org_Dashboard_Stats_Append_Input>;
  _delete_at_path?: InputMaybe<Org_Dashboard_Stats_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_Dashboard_Stats_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_Dashboard_Stats_Delete_Key_Input>;
  _inc?: InputMaybe<Org_Dashboard_Stats_Inc_Input>;
  _prepend?: InputMaybe<Org_Dashboard_Stats_Prepend_Input>;
  _set?: InputMaybe<Org_Dashboard_Stats_Set_Input>;
  where: Org_Dashboard_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Dashboard_Stats_By_PkArgs = {
  _append?: InputMaybe<Org_Dashboard_Stats_Append_Input>;
  _delete_at_path?: InputMaybe<Org_Dashboard_Stats_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_Dashboard_Stats_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_Dashboard_Stats_Delete_Key_Input>;
  _inc?: InputMaybe<Org_Dashboard_Stats_Inc_Input>;
  _prepend?: InputMaybe<Org_Dashboard_Stats_Prepend_Input>;
  _set?: InputMaybe<Org_Dashboard_Stats_Set_Input>;
  pk_columns: Org_Dashboard_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Dashboard_Stats_ManyArgs = {
  updates: Array<Org_Dashboard_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_AssociationArgs = {
  _inc?: InputMaybe<Org_Team_Association_Inc_Input>;
  _set?: InputMaybe<Org_Team_Association_Set_Input>;
  where: Org_Team_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_Association_By_PkArgs = {
  _inc?: InputMaybe<Org_Team_Association_Inc_Input>;
  _set?: InputMaybe<Org_Team_Association_Set_Input>;
  pk_columns: Org_Team_Association_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_Association_ManyArgs = {
  updates: Array<Org_Team_Association_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_Primary_CropArgs = {
  _inc?: InputMaybe<Org_Team_Primary_Crop_Inc_Input>;
  _set?: InputMaybe<Org_Team_Primary_Crop_Set_Input>;
  where: Org_Team_Primary_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_Primary_Crop_By_PkArgs = {
  _inc?: InputMaybe<Org_Team_Primary_Crop_Inc_Input>;
  _set?: InputMaybe<Org_Team_Primary_Crop_Set_Input>;
  pk_columns: Org_Team_Primary_Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_Primary_Crop_ManyArgs = {
  updates: Array<Org_Team_Primary_Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Bank_AssociationArgs = {
  _inc?: InputMaybe<Org_Team_User_Bank_Association_Inc_Input>;
  _set?: InputMaybe<Org_Team_User_Bank_Association_Set_Input>;
  where: Org_Team_User_Bank_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Bank_Association_By_PkArgs = {
  _inc?: InputMaybe<Org_Team_User_Bank_Association_Inc_Input>;
  _set?: InputMaybe<Org_Team_User_Bank_Association_Set_Input>;
  pk_columns: Org_Team_User_Bank_Association_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Bank_Association_ManyArgs = {
  updates: Array<Org_Team_User_Bank_Association_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_CropArgs = {
  _inc?: InputMaybe<Org_Team_User_Crop_Inc_Input>;
  _set?: InputMaybe<Org_Team_User_Crop_Set_Input>;
  where: Org_Team_User_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Crop_By_PkArgs = {
  _inc?: InputMaybe<Org_Team_User_Crop_Inc_Input>;
  _set?: InputMaybe<Org_Team_User_Crop_Set_Input>;
  pk_columns: Org_Team_User_Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Crop_ManyArgs = {
  updates: Array<Org_Team_User_Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Document_AssociationArgs = {
  _inc?: InputMaybe<Org_Team_User_Document_Association_Inc_Input>;
  _set?: InputMaybe<Org_Team_User_Document_Association_Set_Input>;
  where: Org_Team_User_Document_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Document_Association_By_PkArgs = {
  _inc?: InputMaybe<Org_Team_User_Document_Association_Inc_Input>;
  _set?: InputMaybe<Org_Team_User_Document_Association_Set_Input>;
  pk_columns: Org_Team_User_Document_Association_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Team_User_Document_Association_ManyArgs = {
  updates: Array<Org_Team_User_Document_Association_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_AssociationArgs = {
  _inc?: InputMaybe<Org_User_Association_Inc_Input>;
  _set?: InputMaybe<Org_User_Association_Set_Input>;
  where: Org_User_Association_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Association_By_PkArgs = {
  _inc?: InputMaybe<Org_User_Association_Inc_Input>;
  _set?: InputMaybe<Org_User_Association_Set_Input>;
  pk_columns: Org_User_Association_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Association_ManyArgs = {
  updates: Array<Org_User_Association_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Group_Mandatory_DocumentArgs = {
  _inc?: InputMaybe<Org_User_Group_Mandatory_Document_Inc_Input>;
  _set?: InputMaybe<Org_User_Group_Mandatory_Document_Set_Input>;
  where: Org_User_Group_Mandatory_Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Group_Mandatory_Document_By_PkArgs = {
  _inc?: InputMaybe<Org_User_Group_Mandatory_Document_Inc_Input>;
  _set?: InputMaybe<Org_User_Group_Mandatory_Document_Set_Input>;
  pk_columns: Org_User_Group_Mandatory_Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Group_Mandatory_Document_ManyArgs = {
  updates: Array<Org_User_Group_Mandatory_Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Group_Status_SnapshotArgs = {
  _append?: InputMaybe<Org_User_Group_Status_Snapshot_Append_Input>;
  _delete_at_path?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_Key_Input>;
  _inc?: InputMaybe<Org_User_Group_Status_Snapshot_Inc_Input>;
  _prepend?: InputMaybe<Org_User_Group_Status_Snapshot_Prepend_Input>;
  _set?: InputMaybe<Org_User_Group_Status_Snapshot_Set_Input>;
  where: Org_User_Group_Status_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Group_Status_Snapshot_By_PkArgs = {
  _append?: InputMaybe<Org_User_Group_Status_Snapshot_Append_Input>;
  _delete_at_path?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_Key_Input>;
  _inc?: InputMaybe<Org_User_Group_Status_Snapshot_Inc_Input>;
  _prepend?: InputMaybe<Org_User_Group_Status_Snapshot_Prepend_Input>;
  _set?: InputMaybe<Org_User_Group_Status_Snapshot_Set_Input>;
  pk_columns: Org_User_Group_Status_Snapshot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Group_Status_Snapshot_ManyArgs = {
  updates: Array<Org_User_Group_Status_Snapshot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Primary_CropArgs = {
  _inc?: InputMaybe<Org_User_Primary_Crop_Inc_Input>;
  _set?: InputMaybe<Org_User_Primary_Crop_Set_Input>;
  where: Org_User_Primary_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Primary_Crop_By_PkArgs = {
  _inc?: InputMaybe<Org_User_Primary_Crop_Inc_Input>;
  _set?: InputMaybe<Org_User_Primary_Crop_Set_Input>;
  pk_columns: Org_User_Primary_Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_Primary_Crop_ManyArgs = {
  updates: Array<Org_User_Primary_Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationArgs = {
  _append?: InputMaybe<Organisation_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Delete_Key_Input>;
  _inc?: InputMaybe<Organisation_Inc_Input>;
  _prepend?: InputMaybe<Organisation_Prepend_Input>;
  _set?: InputMaybe<Organisation_Set_Input>;
  where: Organisation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_By_PkArgs = {
  _append?: InputMaybe<Organisation_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Delete_Key_Input>;
  _inc?: InputMaybe<Organisation_Inc_Input>;
  _prepend?: InputMaybe<Organisation_Prepend_Input>;
  _set?: InputMaybe<Organisation_Set_Input>;
  pk_columns: Organisation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Commodity_Variety_ConfigArgs = {
  _inc?: InputMaybe<Organisation_Commodity_Variety_Config_Inc_Input>;
  _set?: InputMaybe<Organisation_Commodity_Variety_Config_Set_Input>;
  where: Organisation_Commodity_Variety_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Commodity_Variety_Config_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Commodity_Variety_Config_Inc_Input>;
  _set?: InputMaybe<Organisation_Commodity_Variety_Config_Set_Input>;
  pk_columns: Organisation_Commodity_Variety_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Commodity_Variety_Config_ManyArgs = {
  updates: Array<Organisation_Commodity_Variety_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Commodity_Variety_Config_TaxesArgs = {
  _inc?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Inc_Input>;
  _set?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Set_Input>;
  where: Organisation_Commodity_Variety_Config_Taxes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Commodity_Variety_Config_Taxes_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Inc_Input>;
  _set?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Set_Input>;
  pk_columns: Organisation_Commodity_Variety_Config_Taxes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Commodity_Variety_Config_Taxes_ManyArgs = {
  updates: Array<Organisation_Commodity_Variety_Config_Taxes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_CropArgs = {
  _inc?: InputMaybe<Organisation_Crop_Inc_Input>;
  _set?: InputMaybe<Organisation_Crop_Set_Input>;
  where: Organisation_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Crop_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Crop_Inc_Input>;
  _set?: InputMaybe<Organisation_Crop_Set_Input>;
  pk_columns: Organisation_Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Crop_ManyArgs = {
  updates: Array<Organisation_Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Document_KindArgs = {
  _inc?: InputMaybe<Organisation_Document_Kind_Inc_Input>;
  _set?: InputMaybe<Organisation_Document_Kind_Set_Input>;
  where: Organisation_Document_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Document_Kind_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Document_Kind_Inc_Input>;
  _set?: InputMaybe<Organisation_Document_Kind_Set_Input>;
  pk_columns: Organisation_Document_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Document_Kind_ManyArgs = {
  updates: Array<Organisation_Document_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ManyArgs = {
  updates: Array<Organisation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_PreferencesArgs = {
  _inc?: InputMaybe<Organisation_Preferences_Inc_Input>;
  _set?: InputMaybe<Organisation_Preferences_Set_Input>;
  where: Organisation_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Preferences_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Preferences_Inc_Input>;
  _set?: InputMaybe<Organisation_Preferences_Set_Input>;
  pk_columns: Organisation_Preferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Preferences_ManyArgs = {
  updates: Array<Organisation_Preferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_SeasonArgs = {
  _inc?: InputMaybe<Organisation_Season_Inc_Input>;
  _set?: InputMaybe<Organisation_Season_Set_Input>;
  where: Organisation_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Season_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Season_Inc_Input>;
  _set?: InputMaybe<Organisation_Season_Set_Input>;
  pk_columns: Organisation_Season_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Season_ManyArgs = {
  updates: Array<Organisation_Season_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Over_Due_ApprovalArgs = {
  _inc?: InputMaybe<Over_Due_Approval_Inc_Input>;
  _set?: InputMaybe<Over_Due_Approval_Set_Input>;
  where: Over_Due_Approval_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Over_Due_Approval_By_PkArgs = {
  _inc?: InputMaybe<Over_Due_Approval_Inc_Input>;
  _set?: InputMaybe<Over_Due_Approval_Set_Input>;
  pk_columns: Over_Due_Approval_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Over_Due_Approval_ManyArgs = {
  updates: Array<Over_Due_Approval_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Packaging_OrderArgs = {
  _inc?: InputMaybe<Packaging_Order_Inc_Input>;
  _set?: InputMaybe<Packaging_Order_Set_Input>;
  where: Packaging_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Packaging_Order_By_PkArgs = {
  _inc?: InputMaybe<Packaging_Order_Inc_Input>;
  _set?: InputMaybe<Packaging_Order_Set_Input>;
  pk_columns: Packaging_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Packaging_Order_ItemArgs = {
  _inc?: InputMaybe<Packaging_Order_Item_Inc_Input>;
  _set?: InputMaybe<Packaging_Order_Item_Set_Input>;
  where: Packaging_Order_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Packaging_Order_Item_By_PkArgs = {
  _inc?: InputMaybe<Packaging_Order_Item_Inc_Input>;
  _set?: InputMaybe<Packaging_Order_Item_Set_Input>;
  pk_columns: Packaging_Order_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Packaging_Order_Item_ManyArgs = {
  updates: Array<Packaging_Order_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Packaging_Order_ManyArgs = {
  updates: Array<Packaging_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_CategoryArgs = {
  _inc?: InputMaybe<Pallet_Category_Inc_Input>;
  _set?: InputMaybe<Pallet_Category_Set_Input>;
  where: Pallet_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Category_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Category_Inc_Input>;
  _set?: InputMaybe<Pallet_Category_Set_Input>;
  pk_columns: Pallet_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Category_ManyArgs = {
  updates: Array<Pallet_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_CustomerArgs = {
  _inc?: InputMaybe<Pallet_Customer_Inc_Input>;
  _set?: InputMaybe<Pallet_Customer_Set_Input>;
  where: Pallet_Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Customer_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Customer_Inc_Input>;
  _set?: InputMaybe<Pallet_Customer_Set_Input>;
  pk_columns: Pallet_Customer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Customer_ManyArgs = {
  updates: Array<Pallet_Customer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_InspectionArgs = {
  _append?: InputMaybe<Pallet_Inspection_Append_Input>;
  _delete_at_path?: InputMaybe<Pallet_Inspection_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pallet_Inspection_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pallet_Inspection_Delete_Key_Input>;
  _inc?: InputMaybe<Pallet_Inspection_Inc_Input>;
  _prepend?: InputMaybe<Pallet_Inspection_Prepend_Input>;
  _set?: InputMaybe<Pallet_Inspection_Set_Input>;
  where: Pallet_Inspection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_AttachmentsArgs = {
  _inc?: InputMaybe<Pallet_Inspection_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspection_Attachments_Set_Input>;
  where: Pallet_Inspection_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Inspection_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspection_Attachments_Set_Input>;
  pk_columns: Pallet_Inspection_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_Attachments_ManyArgs = {
  updates: Array<Pallet_Inspection_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_By_PkArgs = {
  _append?: InputMaybe<Pallet_Inspection_Append_Input>;
  _delete_at_path?: InputMaybe<Pallet_Inspection_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Pallet_Inspection_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Pallet_Inspection_Delete_Key_Input>;
  _inc?: InputMaybe<Pallet_Inspection_Inc_Input>;
  _prepend?: InputMaybe<Pallet_Inspection_Prepend_Input>;
  _set?: InputMaybe<Pallet_Inspection_Set_Input>;
  pk_columns: Pallet_Inspection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_ManyArgs = {
  updates: Array<Pallet_Inspection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_ReportsArgs = {
  _inc?: InputMaybe<Pallet_Inspection_Reports_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspection_Reports_Set_Input>;
  where: Pallet_Inspection_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_Reports_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Inspection_Reports_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspection_Reports_Set_Input>;
  pk_columns: Pallet_Inspection_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspection_Reports_ManyArgs = {
  updates: Array<Pallet_Inspection_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_InspectionkindArgs = {
  _inc?: InputMaybe<Pallet_Inspectionkind_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspectionkind_Set_Input>;
  where: Pallet_Inspectionkind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspectionkind_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Inspectionkind_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspectionkind_Set_Input>;
  pk_columns: Pallet_Inspectionkind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspectionkind_ManyArgs = {
  updates: Array<Pallet_Inspectionkind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_InspectionobservationArgs = {
  _inc?: InputMaybe<Pallet_Inspectionobservation_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspectionobservation_Set_Input>;
  where: Pallet_Inspectionobservation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspectionobservation_AttachmentsArgs = {
  _inc?: InputMaybe<Pallet_Inspectionobservation_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspectionobservation_Attachments_Set_Input>;
  where: Pallet_Inspectionobservation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspectionobservation_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Inspectionobservation_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspectionobservation_Attachments_Set_Input>;
  pk_columns: Pallet_Inspectionobservation_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspectionobservation_Attachments_ManyArgs = {
  updates: Array<Pallet_Inspectionobservation_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspectionobservation_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Inspectionobservation_Inc_Input>;
  _set?: InputMaybe<Pallet_Inspectionobservation_Set_Input>;
  pk_columns: Pallet_Inspectionobservation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Inspectionobservation_ManyArgs = {
  updates: Array<Pallet_Inspectionobservation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_LineArgs = {
  _inc?: InputMaybe<Pallet_Line_Inc_Input>;
  _set?: InputMaybe<Pallet_Line_Set_Input>;
  where: Pallet_Line_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Line_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Line_Inc_Input>;
  _set?: InputMaybe<Pallet_Line_Set_Input>;
  pk_columns: Pallet_Line_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Line_ManyArgs = {
  updates: Array<Pallet_Line_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_LocationArgs = {
  _inc?: InputMaybe<Pallet_Location_Inc_Input>;
  _set?: InputMaybe<Pallet_Location_Set_Input>;
  where: Pallet_Location_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Location_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Location_Inc_Input>;
  _set?: InputMaybe<Pallet_Location_Set_Input>;
  pk_columns: Pallet_Location_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Location_ManyArgs = {
  updates: Array<Pallet_Location_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_PackagingArgs = {
  _inc?: InputMaybe<Pallet_Packaging_Inc_Input>;
  _set?: InputMaybe<Pallet_Packaging_Set_Input>;
  where: Pallet_Packaging_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packaging_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packaging_Inc_Input>;
  _set?: InputMaybe<Pallet_Packaging_Set_Input>;
  pk_columns: Pallet_Packaging_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packaging_ManyArgs = {
  updates: Array<Pallet_Packaging_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_PackagingkindArgs = {
  _inc?: InputMaybe<Pallet_Packagingkind_Inc_Input>;
  _set?: InputMaybe<Pallet_Packagingkind_Set_Input>;
  where: Pallet_Packagingkind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packagingkind_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packagingkind_Inc_Input>;
  _set?: InputMaybe<Pallet_Packagingkind_Set_Input>;
  pk_columns: Pallet_Packagingkind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packagingkind_ManyArgs = {
  updates: Array<Pallet_Packagingkind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_PackingArgs = {
  _inc?: InputMaybe<Pallet_Packing_Inc_Input>;
  _set?: InputMaybe<Pallet_Packing_Set_Input>;
  where: Pallet_Packing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_AttachmentsArgs = {
  _inc?: InputMaybe<Pallet_Packing_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Packing_Attachments_Set_Input>;
  where: Pallet_Packing_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packing_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Packing_Attachments_Set_Input>;
  pk_columns: Pallet_Packing_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_Attachments_ManyArgs = {
  updates: Array<Pallet_Packing_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packing_Inc_Input>;
  _set?: InputMaybe<Pallet_Packing_Set_Input>;
  pk_columns: Pallet_Packing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_ManyArgs = {
  updates: Array<Pallet_Packing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_WeightsArgs = {
  _inc?: InputMaybe<Pallet_Packing_Weights_Inc_Input>;
  _set?: InputMaybe<Pallet_Packing_Weights_Set_Input>;
  where: Pallet_Packing_Weights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_Weights_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packing_Weights_Inc_Input>;
  _set?: InputMaybe<Pallet_Packing_Weights_Set_Input>;
  pk_columns: Pallet_Packing_Weights_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packing_Weights_ManyArgs = {
  updates: Array<Pallet_Packing_Weights_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_PackingkindArgs = {
  _inc?: InputMaybe<Pallet_Packingkind_Inc_Input>;
  _set?: InputMaybe<Pallet_Packingkind_Set_Input>;
  where: Pallet_Packingkind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packingkind_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packingkind_Inc_Input>;
  _set?: InputMaybe<Pallet_Packingkind_Set_Input>;
  pk_columns: Pallet_Packingkind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packingkind_ManyArgs = {
  updates: Array<Pallet_Packingkind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_PackingweightArgs = {
  _inc?: InputMaybe<Pallet_Packingweight_Inc_Input>;
  _set?: InputMaybe<Pallet_Packingweight_Set_Input>;
  where: Pallet_Packingweight_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packingweight_AttachmentsArgs = {
  _inc?: InputMaybe<Pallet_Packingweight_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Packingweight_Attachments_Set_Input>;
  where: Pallet_Packingweight_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packingweight_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packingweight_Attachments_Inc_Input>;
  _set?: InputMaybe<Pallet_Packingweight_Attachments_Set_Input>;
  pk_columns: Pallet_Packingweight_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packingweight_Attachments_ManyArgs = {
  updates: Array<Pallet_Packingweight_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packingweight_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Packingweight_Inc_Input>;
  _set?: InputMaybe<Pallet_Packingweight_Set_Input>;
  pk_columns: Pallet_Packingweight_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Packingweight_ManyArgs = {
  updates: Array<Pallet_Packingweight_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_PrintingmatterArgs = {
  _inc?: InputMaybe<Pallet_Printingmatter_Inc_Input>;
  _set?: InputMaybe<Pallet_Printingmatter_Set_Input>;
  where: Pallet_Printingmatter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Printingmatter_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Printingmatter_Inc_Input>;
  _set?: InputMaybe<Pallet_Printingmatter_Set_Input>;
  pk_columns: Pallet_Printingmatter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Printingmatter_ManyArgs = {
  updates: Array<Pallet_Printingmatter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_PunnetconditionArgs = {
  _inc?: InputMaybe<Pallet_Punnetcondition_Inc_Input>;
  _set?: InputMaybe<Pallet_Punnetcondition_Set_Input>;
  where: Pallet_Punnetcondition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Punnetcondition_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Punnetcondition_Inc_Input>;
  _set?: InputMaybe<Pallet_Punnetcondition_Set_Input>;
  pk_columns: Pallet_Punnetcondition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Punnetcondition_ManyArgs = {
  updates: Array<Pallet_Punnetcondition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_SamplinglocationArgs = {
  _inc?: InputMaybe<Pallet_Samplinglocation_Inc_Input>;
  _set?: InputMaybe<Pallet_Samplinglocation_Set_Input>;
  where: Pallet_Samplinglocation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Samplinglocation_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Samplinglocation_Inc_Input>;
  _set?: InputMaybe<Pallet_Samplinglocation_Set_Input>;
  pk_columns: Pallet_Samplinglocation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Samplinglocation_ManyArgs = {
  updates: Array<Pallet_Samplinglocation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_SkuArgs = {
  _inc?: InputMaybe<Pallet_Sku_Inc_Input>;
  _set?: InputMaybe<Pallet_Sku_Set_Input>;
  where: Pallet_Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Sku_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Sku_Inc_Input>;
  _set?: InputMaybe<Pallet_Sku_Set_Input>;
  pk_columns: Pallet_Sku_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Sku_ManyArgs = {
  updates: Array<Pallet_Sku_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_SkutypeArgs = {
  _set?: InputMaybe<Pallet_Skutype_Set_Input>;
  where: Pallet_Skutype_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Skutype_By_PkArgs = {
  _set?: InputMaybe<Pallet_Skutype_Set_Input>;
  pk_columns: Pallet_Skutype_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Skutype_ManyArgs = {
  updates: Array<Pallet_Skutype_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_VarietyArgs = {
  _inc?: InputMaybe<Pallet_Variety_Inc_Input>;
  _set?: InputMaybe<Pallet_Variety_Set_Input>;
  where: Pallet_Variety_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Variety_By_PkArgs = {
  _inc?: InputMaybe<Pallet_Variety_Inc_Input>;
  _set?: InputMaybe<Pallet_Variety_Set_Input>;
  pk_columns: Pallet_Variety_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pallet_Variety_ManyArgs = {
  updates: Array<Pallet_Variety_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PasswordArgs = {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_PaymentArgs = {
  _inc?: InputMaybe<Payment_Inc_Input>;
  _set?: InputMaybe<Payment_Set_Input>;
  where: Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_By_PkArgs = {
  _inc?: InputMaybe<Payment_Inc_Input>;
  _set?: InputMaybe<Payment_Set_Input>;
  pk_columns: Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_DetailArgs = {
  _inc?: InputMaybe<Payment_Detail_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Set_Input>;
  where: Payment_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_AttachmentsArgs = {
  _inc?: InputMaybe<Payment_Detail_Attachments_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Attachments_Set_Input>;
  where: Payment_Detail_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Payment_Detail_Attachments_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Attachments_Set_Input>;
  pk_columns: Payment_Detail_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_Attachments_ManyArgs = {
  updates: Array<Payment_Detail_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_By_PkArgs = {
  _inc?: InputMaybe<Payment_Detail_Inc_Input>;
  _set?: InputMaybe<Payment_Detail_Set_Input>;
  pk_columns: Payment_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Detail_ManyArgs = {
  updates: Array<Payment_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_ManyArgs = {
  updates: Array<Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_MethodArgs = {
  _inc?: InputMaybe<Payment_Method_Inc_Input>;
  _set?: InputMaybe<Payment_Method_Set_Input>;
  where: Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Method_By_PkArgs = {
  _inc?: InputMaybe<Payment_Method_Inc_Input>;
  _set?: InputMaybe<Payment_Method_Set_Input>;
  pk_columns: Payment_Method_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Method_ManyArgs = {
  updates: Array<Payment_Method_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlotArgs = {
  _append?: InputMaybe<Plot_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Inc_Input>;
  _prepend?: InputMaybe<Plot_Prepend_Input>;
  _set?: InputMaybe<Plot_Set_Input>;
  where: Plot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_By_PkArgs = {
  _append?: InputMaybe<Plot_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Inc_Input>;
  _prepend?: InputMaybe<Plot_Prepend_Input>;
  _set?: InputMaybe<Plot_Set_Input>;
  pk_columns: Plot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_CropArgs = {
  _append?: InputMaybe<Plot_Crop_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Crop_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Crop_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Crop_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Crop_Inc_Input>;
  _prepend?: InputMaybe<Plot_Crop_Prepend_Input>;
  _set?: InputMaybe<Plot_Crop_Set_Input>;
  where: Plot_Crop_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_AgentArgs = {
  _inc?: InputMaybe<Plot_Crop_Agent_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Agent_Set_Input>;
  where: Plot_Crop_Agent_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Agent_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Agent_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Agent_Set_Input>;
  pk_columns: Plot_Crop_Agent_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Agent_ManyArgs = {
  updates: Array<Plot_Crop_Agent_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_By_PkArgs = {
  _append?: InputMaybe<Plot_Crop_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Crop_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Crop_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Crop_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Crop_Inc_Input>;
  _prepend?: InputMaybe<Plot_Crop_Prepend_Input>;
  _set?: InputMaybe<Plot_Crop_Set_Input>;
  pk_columns: Plot_Crop_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Cultivation_TypeArgs = {
  _inc?: InputMaybe<Plot_Crop_Cultivation_Type_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Cultivation_Type_Set_Input>;
  where: Plot_Crop_Cultivation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Cultivation_Type_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Cultivation_Type_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Cultivation_Type_Set_Input>;
  pk_columns: Plot_Crop_Cultivation_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Cultivation_Type_ManyArgs = {
  updates: Array<Plot_Crop_Cultivation_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Historic_SeasonArgs = {
  _inc?: InputMaybe<Plot_Crop_Historic_Season_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Historic_Season_Set_Input>;
  where: Plot_Crop_Historic_Season_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Historic_Season_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Historic_Season_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Historic_Season_Set_Input>;
  pk_columns: Plot_Crop_Historic_Season_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Historic_Season_ManyArgs = {
  updates: Array<Plot_Crop_Historic_Season_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_ManyArgs = {
  updates: Array<Plot_Crop_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_MilestoneArgs = {
  _inc?: InputMaybe<Plot_Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Milestone_Set_Input>;
  where: Plot_Crop_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Milestone_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Milestone_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Milestone_Set_Input>;
  pk_columns: Plot_Crop_Milestone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Milestone_ManyArgs = {
  updates: Array<Plot_Crop_Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_NetworkArgs = {
  _inc?: InputMaybe<Plot_Crop_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Network_Set_Input>;
  where: Plot_Crop_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Network_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Network_Set_Input>;
  pk_columns: Plot_Crop_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Network_ManyArgs = {
  updates: Array<Plot_Crop_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_RootstockArgs = {
  _inc?: InputMaybe<Plot_Crop_Rootstock_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Rootstock_Set_Input>;
  where: Plot_Crop_Rootstock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Rootstock_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Rootstock_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Rootstock_Set_Input>;
  pk_columns: Plot_Crop_Rootstock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Rootstock_ManyArgs = {
  updates: Array<Plot_Crop_Rootstock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_StatusArgs = {
  department_codename?: InputMaybe<Scalars['String']>;
  plot_crop_id_list: Array<InputMaybe<Scalars['ID']>>;
  to_status_codename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Status_HistoryArgs = {
  _inc?: InputMaybe<Plot_Crop_Status_History_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Status_History_Set_Input>;
  where: Plot_Crop_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Status_History_By_PkArgs = {
  _inc?: InputMaybe<Plot_Crop_Status_History_Inc_Input>;
  _set?: InputMaybe<Plot_Crop_Status_History_Set_Input>;
  pk_columns: Plot_Crop_Status_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Crop_Status_History_ManyArgs = {
  updates: Array<Plot_Crop_Status_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_ManyArgs = {
  updates: Array<Plot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_NetworkArgs = {
  _inc?: InputMaybe<Plot_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Network_Set_Input>;
  where: Plot_Network_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Network_By_PkArgs = {
  _inc?: InputMaybe<Plot_Network_Inc_Input>;
  _set?: InputMaybe<Plot_Network_Set_Input>;
  pk_columns: Plot_Network_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Network_ManyArgs = {
  updates: Array<Plot_Network_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_StatusArgs = {
  _append?: InputMaybe<Plot_Status_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Status_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Status_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Status_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Status_Inc_Input>;
  _prepend?: InputMaybe<Plot_Status_Prepend_Input>;
  _set?: InputMaybe<Plot_Status_Set_Input>;
  where: Plot_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_BulkArgs = {
  crop_codename?: InputMaybe<Scalars['String']>;
  from_status_codename?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  plot_crop_id_list?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  to_status_codename?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_By_PkArgs = {
  _append?: InputMaybe<Plot_Status_Append_Input>;
  _delete_at_path?: InputMaybe<Plot_Status_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Plot_Status_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Plot_Status_Delete_Key_Input>;
  _inc?: InputMaybe<Plot_Status_Inc_Input>;
  _prepend?: InputMaybe<Plot_Status_Prepend_Input>;
  _set?: InputMaybe<Plot_Status_Set_Input>;
  pk_columns: Plot_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_ConfigArgs = {
  _inc?: InputMaybe<Plot_Status_Config_Inc_Input>;
  _set?: InputMaybe<Plot_Status_Config_Set_Input>;
  where: Plot_Status_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_Config_By_PkArgs = {
  _inc?: InputMaybe<Plot_Status_Config_Inc_Input>;
  _set?: InputMaybe<Plot_Status_Config_Set_Input>;
  pk_columns: Plot_Status_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_Config_ManyArgs = {
  updates: Array<Plot_Status_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_Config_Required_Qc_StagesArgs = {
  _inc?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Inc_Input>;
  _set?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Set_Input>;
  where: Plot_Status_Config_Required_Qc_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_Config_Required_Qc_Stages_By_PkArgs = {
  _inc?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Inc_Input>;
  _set?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Set_Input>;
  pk_columns: Plot_Status_Config_Required_Qc_Stages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_Config_Required_Qc_Stages_ManyArgs = {
  updates: Array<Plot_Status_Config_Required_Qc_Stages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Plot_Status_ManyArgs = {
  updates: Array<Plot_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Growth_StageArgs = {
  _inc?: InputMaybe<Primary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Primary_Growth_Stage_Set_Input>;
  where: Primary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Growth_Stage_By_PkArgs = {
  _inc?: InputMaybe<Primary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Primary_Growth_Stage_Set_Input>;
  pk_columns: Primary_Growth_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_Growth_Stage_ManyArgs = {
  updates: Array<Primary_Growth_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Primary_LocationArgs = {
  primary_location: ExternalEntityInput;
  result_codename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Production_Trade_StatusArgs = {
  status: Scalars['String'];
  trade_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ParameterArgs = {
  _append?: InputMaybe<Quality_Parameter_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_Parameter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_Parameter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_Parameter_Delete_Key_Input>;
  _inc?: InputMaybe<Quality_Parameter_Inc_Input>;
  _prepend?: InputMaybe<Quality_Parameter_Prepend_Input>;
  _set?: InputMaybe<Quality_Parameter_Set_Input>;
  where: Quality_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Parameter_By_PkArgs = {
  _append?: InputMaybe<Quality_Parameter_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_Parameter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_Parameter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_Parameter_Delete_Key_Input>;
  _inc?: InputMaybe<Quality_Parameter_Inc_Input>;
  _prepend?: InputMaybe<Quality_Parameter_Prepend_Input>;
  _set?: InputMaybe<Quality_Parameter_Set_Input>;
  pk_columns: Quality_Parameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Parameter_CategoryArgs = {
  _inc?: InputMaybe<Quality_Parameter_Category_Inc_Input>;
  _set?: InputMaybe<Quality_Parameter_Category_Set_Input>;
  where: Quality_Parameter_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Parameter_Category_By_PkArgs = {
  _inc?: InputMaybe<Quality_Parameter_Category_Inc_Input>;
  _set?: InputMaybe<Quality_Parameter_Category_Set_Input>;
  pk_columns: Quality_Parameter_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Parameter_Category_ManyArgs = {
  updates: Array<Quality_Parameter_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Parameter_ManyArgs = {
  updates: Array<Quality_Parameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_StageArgs = {
  _inc?: InputMaybe<Quality_Stage_Inc_Input>;
  _set?: InputMaybe<Quality_Stage_Set_Input>;
  where: Quality_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Stage_Allowed_Template_CategoryArgs = {
  _inc?: InputMaybe<Quality_Stage_Allowed_Template_Category_Inc_Input>;
  _set?: InputMaybe<Quality_Stage_Allowed_Template_Category_Set_Input>;
  where: Quality_Stage_Allowed_Template_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Stage_Allowed_Template_Category_By_PkArgs = {
  _inc?: InputMaybe<Quality_Stage_Allowed_Template_Category_Inc_Input>;
  _set?: InputMaybe<Quality_Stage_Allowed_Template_Category_Set_Input>;
  pk_columns: Quality_Stage_Allowed_Template_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Stage_Allowed_Template_Category_ManyArgs = {
  updates: Array<Quality_Stage_Allowed_Template_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Stage_By_PkArgs = {
  _inc?: InputMaybe<Quality_Stage_Inc_Input>;
  _set?: InputMaybe<Quality_Stage_Set_Input>;
  pk_columns: Quality_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Stage_ManyArgs = {
  updates: Array<Quality_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Stages_SequenceArgs = {
  parent_id: Scalars['ID'];
  secondary_stages?: InputMaybe<Array<InputMaybe<QualityStageInput>>>;
};


/** mutation root */
export type Mutation_RootUpdate_ReceiptArgs = {
  _inc?: InputMaybe<Receipt_Inc_Input>;
  _set?: InputMaybe<Receipt_Set_Input>;
  where: Receipt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Receipt_By_PkArgs = {
  _inc?: InputMaybe<Receipt_Inc_Input>;
  _set?: InputMaybe<Receipt_Set_Input>;
  pk_columns: Receipt_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Receipt_ManyArgs = {
  updates: Array<Receipt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RegionArgs = {
  _inc?: InputMaybe<Region_Inc_Input>;
  _set?: InputMaybe<Region_Set_Input>;
  where: Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Region_By_PkArgs = {
  _inc?: InputMaybe<Region_Inc_Input>;
  _set?: InputMaybe<Region_Set_Input>;
  pk_columns: Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Region_GroupArgs = {
  _inc?: InputMaybe<Region_Group_Inc_Input>;
  _set?: InputMaybe<Region_Group_Set_Input>;
  where: Region_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Region_Group_By_PkArgs = {
  _inc?: InputMaybe<Region_Group_Inc_Input>;
  _set?: InputMaybe<Region_Group_Set_Input>;
  pk_columns: Region_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Region_Group_ManyArgs = {
  updates: Array<Region_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Region_ManyArgs = {
  updates: Array<Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RequestArgs = {
  _inc?: InputMaybe<Request_Inc_Input>;
  _set?: InputMaybe<Request_Set_Input>;
  where: Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Request_By_PkArgs = {
  _inc?: InputMaybe<Request_Inc_Input>;
  _set?: InputMaybe<Request_Set_Input>;
  pk_columns: Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Request_CategoryArgs = {
  _inc?: InputMaybe<Request_Category_Inc_Input>;
  _set?: InputMaybe<Request_Category_Set_Input>;
  where: Request_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Category_By_PkArgs = {
  _inc?: InputMaybe<Request_Category_Inc_Input>;
  _set?: InputMaybe<Request_Category_Set_Input>;
  pk_columns: Request_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Category_ManyArgs = {
  updates: Array<Request_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Request_ManyArgs = {
  updates: Array<Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Request_ParametersArgs = {
  _inc?: InputMaybe<Request_Parameters_Inc_Input>;
  _set?: InputMaybe<Request_Parameters_Set_Input>;
  where: Request_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Parameters_By_PkArgs = {
  _inc?: InputMaybe<Request_Parameters_Inc_Input>;
  _set?: InputMaybe<Request_Parameters_Set_Input>;
  pk_columns: Request_Parameters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Parameters_ManyArgs = {
  updates: Array<Request_Parameters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Secondary_LocationsArgs = {
  _inc?: InputMaybe<Request_Secondary_Locations_Inc_Input>;
  _set?: InputMaybe<Request_Secondary_Locations_Set_Input>;
  where: Request_Secondary_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Secondary_Locations_By_PkArgs = {
  _inc?: InputMaybe<Request_Secondary_Locations_Inc_Input>;
  _set?: InputMaybe<Request_Secondary_Locations_Set_Input>;
  pk_columns: Request_Secondary_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Secondary_Locations_ManyArgs = {
  updates: Array<Request_Secondary_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Request_TemplatesArgs = {
  _inc?: InputMaybe<Request_Templates_Inc_Input>;
  _set?: InputMaybe<Request_Templates_Set_Input>;
  where: Request_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Templates_By_PkArgs = {
  _inc?: InputMaybe<Request_Templates_Inc_Input>;
  _set?: InputMaybe<Request_Templates_Set_Input>;
  pk_columns: Request_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Templates_ManyArgs = {
  updates: Array<Request_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ResultArgs = {
  _append?: InputMaybe<Result_Append_Input>;
  _delete_at_path?: InputMaybe<Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Result_Delete_Key_Input>;
  _inc?: InputMaybe<Result_Inc_Input>;
  _prepend?: InputMaybe<Result_Prepend_Input>;
  _set?: InputMaybe<Result_Set_Input>;
  where: Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_By_PkArgs = {
  _append?: InputMaybe<Result_Append_Input>;
  _delete_at_path?: InputMaybe<Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Result_Delete_Key_Input>;
  _inc?: InputMaybe<Result_Inc_Input>;
  _prepend?: InputMaybe<Result_Prepend_Input>;
  _set?: InputMaybe<Result_Set_Input>;
  pk_columns: Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_CommentArgs = {
  _inc?: InputMaybe<Result_Comment_Inc_Input>;
  _set?: InputMaybe<Result_Comment_Set_Input>;
  where: Result_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Comment_By_PkArgs = {
  _inc?: InputMaybe<Result_Comment_Inc_Input>;
  _set?: InputMaybe<Result_Comment_Set_Input>;
  pk_columns: Result_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Comment_ManyArgs = {
  updates: Array<Result_Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Result_EvaluationArgs = {
  _inc?: InputMaybe<Result_Evaluation_Inc_Input>;
  _set?: InputMaybe<Result_Evaluation_Set_Input>;
  where: Result_Evaluation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Evaluation_By_PkArgs = {
  _inc?: InputMaybe<Result_Evaluation_Inc_Input>;
  _set?: InputMaybe<Result_Evaluation_Set_Input>;
  pk_columns: Result_Evaluation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Evaluation_Evaluated_TagsArgs = {
  _inc?: InputMaybe<Result_Evaluation_Evaluated_Tags_Inc_Input>;
  _set?: InputMaybe<Result_Evaluation_Evaluated_Tags_Set_Input>;
  where: Result_Evaluation_Evaluated_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Evaluation_Evaluated_Tags_By_PkArgs = {
  _inc?: InputMaybe<Result_Evaluation_Evaluated_Tags_Inc_Input>;
  _set?: InputMaybe<Result_Evaluation_Evaluated_Tags_Set_Input>;
  pk_columns: Result_Evaluation_Evaluated_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Evaluation_Evaluated_Tags_ManyArgs = {
  updates: Array<Result_Evaluation_Evaluated_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Evaluation_ManyArgs = {
  updates: Array<Result_Evaluation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Result_ManyArgs = {
  updates: Array<Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Result_MediaArgs = {
  _inc?: InputMaybe<Result_Media_Inc_Input>;
  _set?: InputMaybe<Result_Media_Set_Input>;
  where: Result_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Media_By_PkArgs = {
  _inc?: InputMaybe<Result_Media_Inc_Input>;
  _set?: InputMaybe<Result_Media_Set_Input>;
  pk_columns: Result_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Media_ManyArgs = {
  updates: Array<Result_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Result_ObservationArgs = {
  _inc?: InputMaybe<Result_Observation_Inc_Input>;
  _set?: InputMaybe<Result_Observation_Set_Input>;
  where: Result_Observation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_AttachmentsArgs = {
  _inc?: InputMaybe<Result_Observation_Attachments_Inc_Input>;
  _set?: InputMaybe<Result_Observation_Attachments_Set_Input>;
  where: Result_Observation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Result_Observation_Attachments_Inc_Input>;
  _set?: InputMaybe<Result_Observation_Attachments_Set_Input>;
  pk_columns: Result_Observation_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_Attachments_ManyArgs = {
  updates: Array<Result_Observation_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_By_PkArgs = {
  _inc?: InputMaybe<Result_Observation_Inc_Input>;
  _set?: InputMaybe<Result_Observation_Set_Input>;
  pk_columns: Result_Observation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_Evaluated_TagsArgs = {
  _inc?: InputMaybe<Result_Observation_Evaluated_Tags_Inc_Input>;
  _set?: InputMaybe<Result_Observation_Evaluated_Tags_Set_Input>;
  where: Result_Observation_Evaluated_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_Evaluated_Tags_By_PkArgs = {
  _inc?: InputMaybe<Result_Observation_Evaluated_Tags_Inc_Input>;
  _set?: InputMaybe<Result_Observation_Evaluated_Tags_Set_Input>;
  pk_columns: Result_Observation_Evaluated_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_Evaluated_Tags_ManyArgs = {
  updates: Array<Result_Observation_Evaluated_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Result_Observation_ManyArgs = {
  updates: Array<Result_Observation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoleArgs = {
  _inc?: InputMaybe<Role_Inc_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_By_PkArgs = {
  _inc?: InputMaybe<Role_Inc_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_ManyArgs = {
  updates: Array<Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RootstockArgs = {
  _inc?: InputMaybe<Rootstock_Inc_Input>;
  _set?: InputMaybe<Rootstock_Set_Input>;
  where: Rootstock_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rootstock_By_PkArgs = {
  _inc?: InputMaybe<Rootstock_Inc_Input>;
  _set?: InputMaybe<Rootstock_Set_Input>;
  pk_columns: Rootstock_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rootstock_ManyArgs = {
  updates: Array<Rootstock_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SampleArgs = {
  _inc?: InputMaybe<Sample_Inc_Input>;
  _set?: InputMaybe<Sample_Set_Input>;
  where: Sample_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_By_PkArgs = {
  _inc?: InputMaybe<Sample_Inc_Input>;
  _set?: InputMaybe<Sample_Set_Input>;
  pk_columns: Sample_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_ManyArgs = {
  updates: Array<Sample_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_MediaArgs = {
  _inc?: InputMaybe<Sample_Media_Inc_Input>;
  _set?: InputMaybe<Sample_Media_Set_Input>;
  where: Sample_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_Media_By_PkArgs = {
  _inc?: InputMaybe<Sample_Media_Inc_Input>;
  _set?: InputMaybe<Sample_Media_Set_Input>;
  pk_columns: Sample_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_Media_ManyArgs = {
  updates: Array<Sample_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_ObservationArgs = {
  _inc?: InputMaybe<Sample_Observation_Inc_Input>;
  _set?: InputMaybe<Sample_Observation_Set_Input>;
  where: Sample_Observation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_Observation_AttachmentsArgs = {
  _inc?: InputMaybe<Sample_Observation_Attachments_Inc_Input>;
  _set?: InputMaybe<Sample_Observation_Attachments_Set_Input>;
  where: Sample_Observation_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_Observation_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Sample_Observation_Attachments_Inc_Input>;
  _set?: InputMaybe<Sample_Observation_Attachments_Set_Input>;
  pk_columns: Sample_Observation_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_Observation_Attachments_ManyArgs = {
  updates: Array<Sample_Observation_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_Observation_By_PkArgs = {
  _inc?: InputMaybe<Sample_Observation_Inc_Input>;
  _set?: InputMaybe<Sample_Observation_Set_Input>;
  pk_columns: Sample_Observation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sample_Observation_ManyArgs = {
  updates: Array<Sample_Observation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Secondary_Growth_StageArgs = {
  _inc?: InputMaybe<Secondary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Secondary_Growth_Stage_Set_Input>;
  where: Secondary_Growth_Stage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Secondary_Growth_Stage_By_PkArgs = {
  _inc?: InputMaybe<Secondary_Growth_Stage_Inc_Input>;
  _set?: InputMaybe<Secondary_Growth_Stage_Set_Input>;
  pk_columns: Secondary_Growth_Stage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Secondary_Growth_Stage_ManyArgs = {
  updates: Array<Secondary_Growth_Stage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Setu_Trade_Shared_EntityArgs = {
  _set?: InputMaybe<Setu_Trade_Shared_Entity_Set_Input>;
  where: Setu_Trade_Shared_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Setu_Trade_Shared_Entity_ManyArgs = {
  updates: Array<Setu_Trade_Shared_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Setutrade_MediaArgs = {
  _inc?: InputMaybe<Setutrade_Media_Inc_Input>;
  _set?: InputMaybe<Setutrade_Media_Set_Input>;
  where: Setutrade_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Setutrade_Media_ManyArgs = {
  updates: Array<Setutrade_Media_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Setutrade_TripArgs = {
  _set?: InputMaybe<Setutrade_Trip_Set_Input>;
  where: Setutrade_Trip_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Setutrade_Trip_By_PkArgs = {
  _set?: InputMaybe<Setutrade_Trip_Set_Input>;
  pk_columns: Setutrade_Trip_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Setutrade_Trip_ManyArgs = {
  updates: Array<Setutrade_Trip_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shareholder_ApplicationsArgs = {
  _append?: InputMaybe<Shareholder_Applications_Append_Input>;
  _delete_at_path?: InputMaybe<Shareholder_Applications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shareholder_Applications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shareholder_Applications_Delete_Key_Input>;
  _inc?: InputMaybe<Shareholder_Applications_Inc_Input>;
  _prepend?: InputMaybe<Shareholder_Applications_Prepend_Input>;
  _set?: InputMaybe<Shareholder_Applications_Set_Input>;
  where: Shareholder_Applications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shareholder_Applications_By_PkArgs = {
  _append?: InputMaybe<Shareholder_Applications_Append_Input>;
  _delete_at_path?: InputMaybe<Shareholder_Applications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Shareholder_Applications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Shareholder_Applications_Delete_Key_Input>;
  _inc?: InputMaybe<Shareholder_Applications_Inc_Input>;
  _prepend?: InputMaybe<Shareholder_Applications_Prepend_Input>;
  _set?: InputMaybe<Shareholder_Applications_Set_Input>;
  pk_columns: Shareholder_Applications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shareholder_Applications_ManyArgs = {
  updates: Array<Shareholder_Applications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ShareholdersArgs = {
  _inc?: InputMaybe<Shareholders_Inc_Input>;
  _set?: InputMaybe<Shareholders_Set_Input>;
  where: Shareholders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shareholders_By_PkArgs = {
  _inc?: InputMaybe<Shareholders_Inc_Input>;
  _set?: InputMaybe<Shareholders_Set_Input>;
  pk_columns: Shareholders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shareholders_ManyArgs = {
  updates: Array<Shareholders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Si_UnitArgs = {
  _inc?: InputMaybe<Si_Unit_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Set_Input>;
  where: Si_Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_By_PkArgs = {
  _inc?: InputMaybe<Si_Unit_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Set_Input>;
  pk_columns: Si_Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_ManyArgs = {
  updates: Array<Si_Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_MeasureArgs = {
  _inc?: InputMaybe<Si_Unit_Measure_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Measure_Set_Input>;
  where: Si_Unit_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_Measure_By_PkArgs = {
  _inc?: InputMaybe<Si_Unit_Measure_Inc_Input>;
  _set?: InputMaybe<Si_Unit_Measure_Set_Input>;
  pk_columns: Si_Unit_Measure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Si_Unit_Measure_ManyArgs = {
  updates: Array<Si_Unit_Measure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SkuArgs = {
  _inc?: InputMaybe<Sku_Inc_Input>;
  _set?: InputMaybe<Sku_Set_Input>;
  where: Sku_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_By_PkArgs = {
  _inc?: InputMaybe<Sku_Inc_Input>;
  _set?: InputMaybe<Sku_Set_Input>;
  pk_columns: Sku_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_KindArgs = {
  _inc?: InputMaybe<Sku_Kind_Inc_Input>;
  _set?: InputMaybe<Sku_Kind_Set_Input>;
  where: Sku_Kind_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_Kind_By_PkArgs = {
  _inc?: InputMaybe<Sku_Kind_Inc_Input>;
  _set?: InputMaybe<Sku_Kind_Set_Input>;
  pk_columns: Sku_Kind_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_Kind_ManyArgs = {
  updates: Array<Sku_Kind_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sku_ManyArgs = {
  updates: Array<Sku_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SoilArgs = {
  _inc?: InputMaybe<Soil_Inc_Input>;
  _set?: InputMaybe<Soil_Set_Input>;
  where: Soil_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Soil_By_PkArgs = {
  _inc?: InputMaybe<Soil_Inc_Input>;
  _set?: InputMaybe<Soil_Set_Input>;
  pk_columns: Soil_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Soil_ManyArgs = {
  updates: Array<Soil_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_ActionsArgs = {
  _append?: InputMaybe<Stage_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Stage_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Stage_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Stage_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Stage_Actions_Inc_Input>;
  _prepend?: InputMaybe<Stage_Actions_Prepend_Input>;
  _set?: InputMaybe<Stage_Actions_Set_Input>;
  where: Stage_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_Actions_By_PkArgs = {
  _append?: InputMaybe<Stage_Actions_Append_Input>;
  _delete_at_path?: InputMaybe<Stage_Actions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Stage_Actions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Stage_Actions_Delete_Key_Input>;
  _inc?: InputMaybe<Stage_Actions_Inc_Input>;
  _prepend?: InputMaybe<Stage_Actions_Prepend_Input>;
  _set?: InputMaybe<Stage_Actions_Set_Input>;
  pk_columns: Stage_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_Actions_ManyArgs = {
  updates: Array<Stage_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_LogsArgs = {
  _append?: InputMaybe<Stage_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Stage_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Stage_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Stage_Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Stage_Logs_Inc_Input>;
  _prepend?: InputMaybe<Stage_Logs_Prepend_Input>;
  _set?: InputMaybe<Stage_Logs_Set_Input>;
  where: Stage_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_Logs_By_PkArgs = {
  _append?: InputMaybe<Stage_Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Stage_Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Stage_Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Stage_Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Stage_Logs_Inc_Input>;
  _prepend?: InputMaybe<Stage_Logs_Prepend_Input>;
  _set?: InputMaybe<Stage_Logs_Set_Input>;
  pk_columns: Stage_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stage_Logs_ManyArgs = {
  updates: Array<Stage_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StagesArgs = {
  _inc?: InputMaybe<Stages_Inc_Input>;
  _set?: InputMaybe<Stages_Set_Input>;
  where: Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stages_By_PkArgs = {
  _inc?: InputMaybe<Stages_Inc_Input>;
  _set?: InputMaybe<Stages_Set_Input>;
  pk_columns: Stages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stages_ManyArgs = {
  updates: Array<Stages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stages_SubscribersArgs = {
  _inc?: InputMaybe<Stages_Subscribers_Inc_Input>;
  _set?: InputMaybe<Stages_Subscribers_Set_Input>;
  where: Stages_Subscribers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stages_Subscribers_By_PkArgs = {
  _inc?: InputMaybe<Stages_Subscribers_Inc_Input>;
  _set?: InputMaybe<Stages_Subscribers_Set_Input>;
  pk_columns: Stages_Subscribers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stages_Subscribers_ManyArgs = {
  updates: Array<Stages_Subscribers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StateArgs = {
  _append?: InputMaybe<State_Append_Input>;
  _delete_at_path?: InputMaybe<State_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<State_Delete_Elem_Input>;
  _delete_key?: InputMaybe<State_Delete_Key_Input>;
  _inc?: InputMaybe<State_Inc_Input>;
  _prepend?: InputMaybe<State_Prepend_Input>;
  _set?: InputMaybe<State_Set_Input>;
  where: State_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_State_By_PkArgs = {
  _append?: InputMaybe<State_Append_Input>;
  _delete_at_path?: InputMaybe<State_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<State_Delete_Elem_Input>;
  _delete_key?: InputMaybe<State_Delete_Key_Input>;
  _inc?: InputMaybe<State_Inc_Input>;
  _prepend?: InputMaybe<State_Prepend_Input>;
  _set?: InputMaybe<State_Set_Input>;
  pk_columns: State_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_State_ManyArgs = {
  updates: Array<State_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_ParametersArgs = {
  _append?: InputMaybe<Survey_Parameters_Append_Input>;
  _delete_at_path?: InputMaybe<Survey_Parameters_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Survey_Parameters_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Survey_Parameters_Delete_Key_Input>;
  _inc?: InputMaybe<Survey_Parameters_Inc_Input>;
  _prepend?: InputMaybe<Survey_Parameters_Prepend_Input>;
  _set?: InputMaybe<Survey_Parameters_Set_Input>;
  where: Survey_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Parameters_By_PkArgs = {
  _append?: InputMaybe<Survey_Parameters_Append_Input>;
  _delete_at_path?: InputMaybe<Survey_Parameters_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Survey_Parameters_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Survey_Parameters_Delete_Key_Input>;
  _inc?: InputMaybe<Survey_Parameters_Inc_Input>;
  _prepend?: InputMaybe<Survey_Parameters_Prepend_Input>;
  _set?: InputMaybe<Survey_Parameters_Set_Input>;
  pk_columns: Survey_Parameters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Parameters_ManyArgs = {
  updates: Array<Survey_Parameters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Response_ItemsArgs = {
  _inc?: InputMaybe<Survey_Response_Items_Inc_Input>;
  _set?: InputMaybe<Survey_Response_Items_Set_Input>;
  where: Survey_Response_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Response_Items_By_PkArgs = {
  _inc?: InputMaybe<Survey_Response_Items_Inc_Input>;
  _set?: InputMaybe<Survey_Response_Items_Set_Input>;
  pk_columns: Survey_Response_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Response_Items_ManyArgs = {
  updates: Array<Survey_Response_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_ResponsesArgs = {
  _inc?: InputMaybe<Survey_Responses_Inc_Input>;
  _set?: InputMaybe<Survey_Responses_Set_Input>;
  where: Survey_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Responses_By_PkArgs = {
  _inc?: InputMaybe<Survey_Responses_Inc_Input>;
  _set?: InputMaybe<Survey_Responses_Set_Input>;
  pk_columns: Survey_Responses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Responses_ManyArgs = {
  updates: Array<Survey_Responses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_UsersArgs = {
  _inc?: InputMaybe<Survey_Users_Inc_Input>;
  _set?: InputMaybe<Survey_Users_Set_Input>;
  where: Survey_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Users_By_PkArgs = {
  _inc?: InputMaybe<Survey_Users_Inc_Input>;
  _set?: InputMaybe<Survey_Users_Set_Input>;
  pk_columns: Survey_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Users_ManyArgs = {
  updates: Array<Survey_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_YearArgs = {
  _inc?: InputMaybe<Survey_Year_Inc_Input>;
  _set?: InputMaybe<Survey_Year_Set_Input>;
  where: Survey_Year_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Year_By_PkArgs = {
  _inc?: InputMaybe<Survey_Year_Inc_Input>;
  _set?: InputMaybe<Survey_Year_Set_Input>;
  pk_columns: Survey_Year_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Survey_Year_ManyArgs = {
  updates: Array<Survey_Year_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SurveysArgs = {
  _inc?: InputMaybe<Surveys_Inc_Input>;
  _set?: InputMaybe<Surveys_Set_Input>;
  where: Surveys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Surveys_By_PkArgs = {
  _inc?: InputMaybe<Surveys_Inc_Input>;
  _set?: InputMaybe<Surveys_Set_Input>;
  pk_columns: Surveys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Surveys_ManyArgs = {
  updates: Array<Surveys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TemplateArgs = {
  _append?: InputMaybe<Template_Append_Input>;
  _delete_at_path?: InputMaybe<Template_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Template_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Template_Delete_Key_Input>;
  _inc?: InputMaybe<Template_Inc_Input>;
  _prepend?: InputMaybe<Template_Prepend_Input>;
  _set?: InputMaybe<Template_Set_Input>;
  where: Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_By_PkArgs = {
  _append?: InputMaybe<Template_Append_Input>;
  _delete_at_path?: InputMaybe<Template_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Template_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Template_Delete_Key_Input>;
  _inc?: InputMaybe<Template_Inc_Input>;
  _prepend?: InputMaybe<Template_Prepend_Input>;
  _set?: InputMaybe<Template_Set_Input>;
  pk_columns: Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_CategoryArgs = {
  _inc?: InputMaybe<Template_Category_Inc_Input>;
  _set?: InputMaybe<Template_Category_Set_Input>;
  where: Template_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_Allowed_GroupsArgs = {
  _inc?: InputMaybe<Template_Category_Allowed_Groups_Inc_Input>;
  _set?: InputMaybe<Template_Category_Allowed_Groups_Set_Input>;
  where: Template_Category_Allowed_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_Allowed_Groups_By_PkArgs = {
  _inc?: InputMaybe<Template_Category_Allowed_Groups_Inc_Input>;
  _set?: InputMaybe<Template_Category_Allowed_Groups_Set_Input>;
  pk_columns: Template_Category_Allowed_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_Allowed_Groups_ManyArgs = {
  updates: Array<Template_Category_Allowed_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_Allowed_Parameter_CategoriesArgs = {
  _inc?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Inc_Input>;
  _set?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Set_Input>;
  where: Template_Category_Allowed_Parameter_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_Allowed_Parameter_Categories_By_PkArgs = {
  _inc?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Inc_Input>;
  _set?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Set_Input>;
  pk_columns: Template_Category_Allowed_Parameter_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_Allowed_Parameter_Categories_ManyArgs = {
  updates: Array<Template_Category_Allowed_Parameter_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_By_PkArgs = {
  _inc?: InputMaybe<Template_Category_Inc_Input>;
  _set?: InputMaybe<Template_Category_Set_Input>;
  pk_columns: Template_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Category_ManyArgs = {
  updates: Array<Template_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_CompanyArgs = {
  _inc?: InputMaybe<Template_Company_Inc_Input>;
  _set?: InputMaybe<Template_Company_Set_Input>;
  where: Template_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Company_By_PkArgs = {
  _inc?: InputMaybe<Template_Company_Inc_Input>;
  _set?: InputMaybe<Template_Company_Set_Input>;
  pk_columns: Template_Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Company_ManyArgs = {
  updates: Array<Template_Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_DepartmentsArgs = {
  _inc?: InputMaybe<Template_Departments_Inc_Input>;
  _set?: InputMaybe<Template_Departments_Set_Input>;
  where: Template_Departments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Departments_By_PkArgs = {
  _inc?: InputMaybe<Template_Departments_Inc_Input>;
  _set?: InputMaybe<Template_Departments_Set_Input>;
  pk_columns: Template_Departments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Departments_ManyArgs = {
  updates: Array<Template_Departments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_EvaluationArgs = {
  _inc?: InputMaybe<Template_Evaluation_Inc_Input>;
  _set?: InputMaybe<Template_Evaluation_Set_Input>;
  where: Template_Evaluation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_By_PkArgs = {
  _inc?: InputMaybe<Template_Evaluation_Inc_Input>;
  _set?: InputMaybe<Template_Evaluation_Set_Input>;
  pk_columns: Template_Evaluation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_ConfigArgs = {
  _inc?: InputMaybe<Template_Evaluation_Config_Inc_Input>;
  _set?: InputMaybe<Template_Evaluation_Config_Set_Input>;
  where: Template_Evaluation_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_Config_By_PkArgs = {
  _inc?: InputMaybe<Template_Evaluation_Config_Inc_Input>;
  _set?: InputMaybe<Template_Evaluation_Config_Set_Input>;
  pk_columns: Template_Evaluation_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_Config_ManyArgs = {
  updates: Array<Template_Evaluation_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_ManyArgs = {
  updates: Array<Template_Evaluation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_TemplatesArgs = {
  _inc?: InputMaybe<Template_Evaluation_Templates_Inc_Input>;
  _set?: InputMaybe<Template_Evaluation_Templates_Set_Input>;
  where: Template_Evaluation_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_Templates_By_PkArgs = {
  _inc?: InputMaybe<Template_Evaluation_Templates_Inc_Input>;
  _set?: InputMaybe<Template_Evaluation_Templates_Set_Input>;
  pk_columns: Template_Evaluation_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Evaluation_Templates_ManyArgs = {
  updates: Array<Template_Evaluation_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_ManyArgs = {
  updates: Array<Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_ParameterArgs = {
  _append?: InputMaybe<Template_Parameter_Append_Input>;
  _delete_at_path?: InputMaybe<Template_Parameter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Template_Parameter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Template_Parameter_Delete_Key_Input>;
  _inc?: InputMaybe<Template_Parameter_Inc_Input>;
  _prepend?: InputMaybe<Template_Parameter_Prepend_Input>;
  _set?: InputMaybe<Template_Parameter_Set_Input>;
  where: Template_Parameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_By_PkArgs = {
  _append?: InputMaybe<Template_Parameter_Append_Input>;
  _delete_at_path?: InputMaybe<Template_Parameter_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Template_Parameter_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Template_Parameter_Delete_Key_Input>;
  _inc?: InputMaybe<Template_Parameter_Inc_Input>;
  _prepend?: InputMaybe<Template_Parameter_Prepend_Input>;
  _set?: InputMaybe<Template_Parameter_Set_Input>;
  pk_columns: Template_Parameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_ConfigArgs = {
  _inc?: InputMaybe<Template_Parameter_Config_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Config_Set_Input>;
  where: Template_Parameter_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Config_By_PkArgs = {
  _inc?: InputMaybe<Template_Parameter_Config_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Config_Set_Input>;
  pk_columns: Template_Parameter_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Config_ManyArgs = {
  updates: Array<Template_Parameter_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_ManyArgs = {
  updates: Array<Template_Parameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_StandardArgs = {
  _inc?: InputMaybe<Template_Parameter_Standard_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Standard_Set_Input>;
  where: Template_Parameter_Standard_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_AttachmentsArgs = {
  _inc?: InputMaybe<Template_Parameter_Standard_Attachments_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Standard_Attachments_Set_Input>;
  where: Template_Parameter_Standard_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Template_Parameter_Standard_Attachments_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Standard_Attachments_Set_Input>;
  pk_columns: Template_Parameter_Standard_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_Attachments_ManyArgs = {
  updates: Array<Template_Parameter_Standard_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_By_PkArgs = {
  _inc?: InputMaybe<Template_Parameter_Standard_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Standard_Set_Input>;
  pk_columns: Template_Parameter_Standard_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_GroupArgs = {
  _inc?: InputMaybe<Template_Parameter_Standard_Group_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Standard_Group_Set_Input>;
  where: Template_Parameter_Standard_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_Group_By_PkArgs = {
  _inc?: InputMaybe<Template_Parameter_Standard_Group_Inc_Input>;
  _set?: InputMaybe<Template_Parameter_Standard_Group_Set_Input>;
  pk_columns: Template_Parameter_Standard_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_Group_ManyArgs = {
  updates: Array<Template_Parameter_Standard_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Parameter_Standard_ManyArgs = {
  updates: Array<Template_Parameter_Standard_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Quality_StagesArgs = {
  _inc?: InputMaybe<Template_Quality_Stages_Inc_Input>;
  _set?: InputMaybe<Template_Quality_Stages_Set_Input>;
  where: Template_Quality_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Quality_Stages_By_PkArgs = {
  _inc?: InputMaybe<Template_Quality_Stages_Inc_Input>;
  _set?: InputMaybe<Template_Quality_Stages_Set_Input>;
  pk_columns: Template_Quality_Stages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Template_Quality_Stages_ManyArgs = {
  updates: Array<Template_Quality_Stages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TradeArgs = {
  _inc?: InputMaybe<Trade_Inc_Input>;
  _set?: InputMaybe<Trade_Set_Input>;
  where: Trade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_AmountsArgs = {
  trade_id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_AttachmentsArgs = {
  _inc?: InputMaybe<Trade_Attachments_Inc_Input>;
  _set?: InputMaybe<Trade_Attachments_Set_Input>;
  where: Trade_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Trade_Attachments_Inc_Input>;
  _set?: InputMaybe<Trade_Attachments_Set_Input>;
  pk_columns: Trade_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Attachments_ManyArgs = {
  updates: Array<Trade_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Buyer_Gst_AttachmentsArgs = {
  _inc?: InputMaybe<Trade_Buyer_Gst_Attachments_Inc_Input>;
  _set?: InputMaybe<Trade_Buyer_Gst_Attachments_Set_Input>;
  where: Trade_Buyer_Gst_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Buyer_Gst_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Trade_Buyer_Gst_Attachments_Inc_Input>;
  _set?: InputMaybe<Trade_Buyer_Gst_Attachments_Set_Input>;
  pk_columns: Trade_Buyer_Gst_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Buyer_Gst_Attachments_ManyArgs = {
  updates: Array<Trade_Buyer_Gst_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_By_PkArgs = {
  _inc?: InputMaybe<Trade_Inc_Input>;
  _set?: InputMaybe<Trade_Set_Input>;
  pk_columns: Trade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_ItemArgs = {
  _inc?: InputMaybe<Trade_Item_Inc_Input>;
  _set?: InputMaybe<Trade_Item_Set_Input>;
  where: Trade_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Item_By_PkArgs = {
  _inc?: InputMaybe<Trade_Item_Inc_Input>;
  _set?: InputMaybe<Trade_Item_Set_Input>;
  pk_columns: Trade_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Item_ManyArgs = {
  updates: Array<Trade_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_ManyArgs = {
  updates: Array<Trade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Seller_Gst_AttachmentsArgs = {
  _inc?: InputMaybe<Trade_Seller_Gst_Attachments_Inc_Input>;
  _set?: InputMaybe<Trade_Seller_Gst_Attachments_Set_Input>;
  where: Trade_Seller_Gst_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Seller_Gst_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Trade_Seller_Gst_Attachments_Inc_Input>;
  _set?: InputMaybe<Trade_Seller_Gst_Attachments_Set_Input>;
  pk_columns: Trade_Seller_Gst_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Seller_Gst_Attachments_ManyArgs = {
  updates: Array<Trade_Seller_Gst_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_TaxesArgs = {
  _inc?: InputMaybe<Trade_Taxes_Inc_Input>;
  _set?: InputMaybe<Trade_Taxes_Set_Input>;
  where: Trade_Taxes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Taxes_By_PkArgs = {
  _inc?: InputMaybe<Trade_Taxes_Inc_Input>;
  _set?: InputMaybe<Trade_Taxes_Set_Input>;
  pk_columns: Trade_Taxes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trade_Taxes_ManyArgs = {
  updates: Array<Trade_Taxes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TransactionArgs = {
  _inc?: InputMaybe<Transaction_Inc_Input>;
  _set?: InputMaybe<Transaction_Set_Input>;
  where: Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_AttachmentsArgs = {
  _inc?: InputMaybe<Transaction_Attachments_Inc_Input>;
  _set?: InputMaybe<Transaction_Attachments_Set_Input>;
  where: Transaction_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Transaction_Attachments_Inc_Input>;
  _set?: InputMaybe<Transaction_Attachments_Set_Input>;
  pk_columns: Transaction_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_Attachments_ManyArgs = {
  updates: Array<Transaction_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Transaction_Inc_Input>;
  _set?: InputMaybe<Transaction_Set_Input>;
  pk_columns: Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transaction_ManyArgs = {
  updates: Array<Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TransactionsArgs = {
  _inc?: InputMaybe<Transactions_Inc_Input>;
  _set?: InputMaybe<Transactions_Set_Input>;
  where: Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transactions_AttachmentsArgs = {
  _inc?: InputMaybe<Transactions_Attachments_Inc_Input>;
  _set?: InputMaybe<Transactions_Attachments_Set_Input>;
  where: Transactions_Attachments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transactions_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Transactions_Attachments_Inc_Input>;
  _set?: InputMaybe<Transactions_Attachments_Set_Input>;
  pk_columns: Transactions_Attachments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transactions_Attachments_ManyArgs = {
  updates: Array<Transactions_Attachments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Transactions_Inc_Input>;
  _set?: InputMaybe<Transactions_Set_Input>;
  pk_columns: Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transactions_ManyArgs = {
  updates: Array<Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TransitionArgs = {
  _append?: InputMaybe<Transition_Append_Input>;
  _delete_at_path?: InputMaybe<Transition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transition_Delete_Key_Input>;
  _inc?: InputMaybe<Transition_Inc_Input>;
  _prepend?: InputMaybe<Transition_Prepend_Input>;
  _set?: InputMaybe<Transition_Set_Input>;
  where: Transition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_AccessArgs = {
  _inc?: InputMaybe<Transition_Access_Inc_Input>;
  _set?: InputMaybe<Transition_Access_Set_Input>;
  where: Transition_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_Access_By_PkArgs = {
  _inc?: InputMaybe<Transition_Access_Inc_Input>;
  _set?: InputMaybe<Transition_Access_Set_Input>;
  pk_columns: Transition_Access_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_Access_ManyArgs = {
  updates: Array<Transition_Access_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_By_PkArgs = {
  _append?: InputMaybe<Transition_Append_Input>;
  _delete_at_path?: InputMaybe<Transition_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transition_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transition_Delete_Key_Input>;
  _inc?: InputMaybe<Transition_Inc_Input>;
  _prepend?: InputMaybe<Transition_Prepend_Input>;
  _set?: InputMaybe<Transition_Set_Input>;
  pk_columns: Transition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_HistoryArgs = {
  _append?: InputMaybe<Transition_History_Append_Input>;
  _delete_at_path?: InputMaybe<Transition_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transition_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transition_History_Delete_Key_Input>;
  _inc?: InputMaybe<Transition_History_Inc_Input>;
  _prepend?: InputMaybe<Transition_History_Prepend_Input>;
  _set?: InputMaybe<Transition_History_Set_Input>;
  where: Transition_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_History_AttributeArgs = {
  _inc?: InputMaybe<Transition_History_Attribute_Inc_Input>;
  _set?: InputMaybe<Transition_History_Attribute_Set_Input>;
  where: Transition_History_Attribute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_History_Attribute_By_PkArgs = {
  _inc?: InputMaybe<Transition_History_Attribute_Inc_Input>;
  _set?: InputMaybe<Transition_History_Attribute_Set_Input>;
  pk_columns: Transition_History_Attribute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_History_Attribute_ManyArgs = {
  updates: Array<Transition_History_Attribute_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_History_By_PkArgs = {
  _append?: InputMaybe<Transition_History_Append_Input>;
  _delete_at_path?: InputMaybe<Transition_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transition_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transition_History_Delete_Key_Input>;
  _inc?: InputMaybe<Transition_History_Inc_Input>;
  _prepend?: InputMaybe<Transition_History_Prepend_Input>;
  _set?: InputMaybe<Transition_History_Set_Input>;
  pk_columns: Transition_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_History_ManyArgs = {
  updates: Array<Transition_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transition_ManyArgs = {
  updates: Array<Transition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UnitArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_By_PkArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  pk_columns: Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_ManyArgs = {
  updates: Array<Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_MeasureArgs = {
  _inc?: InputMaybe<Unit_Measure_Inc_Input>;
  _set?: InputMaybe<Unit_Measure_Set_Input>;
  where: Unit_Measure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Measure_By_PkArgs = {
  _inc?: InputMaybe<Unit_Measure_Inc_Input>;
  _set?: InputMaybe<Unit_Measure_Set_Input>;
  pk_columns: Unit_Measure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Measure_ManyArgs = {
  updates: Array<Unit_Measure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unregistered_UserArgs = {
  _inc?: InputMaybe<Unregistered_User_Inc_Input>;
  _set?: InputMaybe<Unregistered_User_Set_Input>;
  where: Unregistered_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unregistered_User_By_PkArgs = {
  _inc?: InputMaybe<Unregistered_User_Inc_Input>;
  _set?: InputMaybe<Unregistered_User_Set_Input>;
  pk_columns: Unregistered_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unregistered_User_ManyArgs = {
  updates: Array<Unregistered_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_AgreementArgs = {
  _append?: InputMaybe<Variety_Agreement_Append_Input>;
  _delete_at_path?: InputMaybe<Variety_Agreement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Variety_Agreement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Variety_Agreement_Delete_Key_Input>;
  _inc?: InputMaybe<Variety_Agreement_Inc_Input>;
  _prepend?: InputMaybe<Variety_Agreement_Prepend_Input>;
  _set?: InputMaybe<Variety_Agreement_Set_Input>;
  where: Variety_Agreement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_Agreement_Co_OwnersArgs = {
  _inc?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Inc_Input>;
  _set?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Set_Input>;
  where: Variety_Agreement_Agreement_Co_Owners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_Agreement_Co_Owners_By_PkArgs = {
  _inc?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Inc_Input>;
  _set?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Set_Input>;
  pk_columns: Variety_Agreement_Agreement_Co_Owners_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_Agreement_Co_Owners_ManyArgs = {
  updates: Array<Variety_Agreement_Agreement_Co_Owners_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_By_PkArgs = {
  _append?: InputMaybe<Variety_Agreement_Append_Input>;
  _delete_at_path?: InputMaybe<Variety_Agreement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Variety_Agreement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Variety_Agreement_Delete_Key_Input>;
  _inc?: InputMaybe<Variety_Agreement_Inc_Input>;
  _prepend?: InputMaybe<Variety_Agreement_Prepend_Input>;
  _set?: InputMaybe<Variety_Agreement_Set_Input>;
  pk_columns: Variety_Agreement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_Guarantor_AgreementsArgs = {
  _inc?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Inc_Input>;
  _set?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Set_Input>;
  where: Variety_Agreement_Guarantor_Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_Guarantor_Agreements_By_PkArgs = {
  _inc?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Inc_Input>;
  _set?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Set_Input>;
  pk_columns: Variety_Agreement_Guarantor_Agreements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_Guarantor_Agreements_ManyArgs = {
  updates: Array<Variety_Agreement_Guarantor_Agreements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Agreement_ManyArgs = {
  updates: Array<Variety_Agreement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_GradeArgs = {
  _inc?: InputMaybe<Variety_Grade_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Set_Input>;
  where: Variety_Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_By_PkArgs = {
  _inc?: InputMaybe<Variety_Grade_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Set_Input>;
  pk_columns: Variety_Grade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_ManyArgs = {
  updates: Array<Variety_Grade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_PhotosArgs = {
  _inc?: InputMaybe<Variety_Grade_Photos_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Photos_Set_Input>;
  where: Variety_Grade_Photos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_Photos_By_PkArgs = {
  _inc?: InputMaybe<Variety_Grade_Photos_Inc_Input>;
  _set?: InputMaybe<Variety_Grade_Photos_Set_Input>;
  pk_columns: Variety_Grade_Photos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Grade_Photos_ManyArgs = {
  updates: Array<Variety_Grade_Photos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_GroupArgs = {
  _append?: InputMaybe<Variety_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Variety_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Variety_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Variety_Group_Delete_Key_Input>;
  _inc?: InputMaybe<Variety_Group_Inc_Input>;
  _prepend?: InputMaybe<Variety_Group_Prepend_Input>;
  _set?: InputMaybe<Variety_Group_Set_Input>;
  where: Variety_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Group_By_PkArgs = {
  _append?: InputMaybe<Variety_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Variety_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Variety_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Variety_Group_Delete_Key_Input>;
  _inc?: InputMaybe<Variety_Group_Inc_Input>;
  _prepend?: InputMaybe<Variety_Group_Prepend_Input>;
  _set?: InputMaybe<Variety_Group_Set_Input>;
  pk_columns: Variety_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variety_Group_ManyArgs = {
  updates: Array<Variety_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vt_Core_TaxArgs = {
  _inc?: InputMaybe<Vt_Core_Tax_Inc_Input>;
  _set?: InputMaybe<Vt_Core_Tax_Set_Input>;
  where: Vt_Core_Tax_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vt_Core_Tax_By_PkArgs = {
  _inc?: InputMaybe<Vt_Core_Tax_Inc_Input>;
  _set?: InputMaybe<Vt_Core_Tax_Set_Input>;
  pk_columns: Vt_Core_Tax_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vt_Core_Tax_ManyArgs = {
  updates: Array<Vt_Core_Tax_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_ReferenceArgs = {
  _inc?: InputMaybe<Weather_Reference_Inc_Input>;
  _set?: InputMaybe<Weather_Reference_Set_Input>;
  where: Weather_Reference_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Reference_By_PkArgs = {
  _inc?: InputMaybe<Weather_Reference_Inc_Input>;
  _set?: InputMaybe<Weather_Reference_Set_Input>;
  pk_columns: Weather_Reference_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weather_Reference_ManyArgs = {
  updates: Array<Weather_Reference_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WorkflowArgs = {
  _append?: InputMaybe<Workflow_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Prepend_Input>;
  _set?: InputMaybe<Workflow_Set_Input>;
  where: Workflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_By_PkArgs = {
  _append?: InputMaybe<Workflow_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Prepend_Input>;
  _set?: InputMaybe<Workflow_Set_Input>;
  pk_columns: Workflow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Current_LogsArgs = {
  _inc?: InputMaybe<Workflow_Current_Logs_Inc_Input>;
  _set?: InputMaybe<Workflow_Current_Logs_Set_Input>;
  where: Workflow_Current_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Current_Logs_By_PkArgs = {
  _inc?: InputMaybe<Workflow_Current_Logs_Inc_Input>;
  _set?: InputMaybe<Workflow_Current_Logs_Set_Input>;
  pk_columns: Workflow_Current_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_Current_Logs_ManyArgs = {
  updates: Array<Workflow_Current_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_ManyArgs = {
  updates: Array<Workflow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WorkflowsArgs = {
  _inc?: InputMaybe<Workflows_Inc_Input>;
  _set?: InputMaybe<Workflows_Set_Input>;
  where: Workflows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflows_By_PkArgs = {
  _inc?: InputMaybe<Workflows_Inc_Input>;
  _set?: InputMaybe<Workflows_Set_Input>;
  pk_columns: Workflows_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflows_ManyArgs = {
  updates: Array<Workflows_Updates>;
};


/** mutation root */
export type Mutation_RootUse_Offer_StockArgs = {
  offer_id: Scalars['ID'];
  trade_id: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootVerify_OtpArgs = {
  number: Scalars['String'];
  otp: Scalars['String'];
};


/** mutation root */
export type Mutation_RootVerify_Otp_For_Existing_UserArgs = {
  country_code: Scalars['String'];
  network_id?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  otp: Scalars['String'];
};


/** mutation root */
export type Mutation_RootVerify_Otp_For_New_UsersArgs = {
  country_code: Scalars['String'];
  first_name: Scalars['String'];
  language: Scalars['String'];
  last_name: Scalars['String'];
  network_id?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  otp: Scalars['String'];
  pincode?: InputMaybe<Scalars['String']>;
  village_codename?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootVerify_Storage_Location_AgreementArgs = {
  agreement_id: Scalars['ID'];
  is_verified: Scalars['Boolean'];
  remarks?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootVerify_TokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootVerify_Trade_OtpArgs = {
  otp: Scalars['String'];
  token: Scalars['String'];
};

/** columns and relationships of "mutual_group" */
export type Mutual_Group = {
  __typename?: 'mutual_group';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  department?: Maybe<Department>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** A computed field, executes function "group_external_reference" */
  external_reference_id2?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  max_field_assets?: Maybe<Scalars['Int']>;
  /** An array relationship */
  mutual_group_memberships: Array<Mutual_Group_Membership>;
  /** An aggregate relationship */
  mutual_group_memberships_aggregate: Mutual_Group_Membership_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Mutual_Group_Network>;
  /** An aggregate relationship */
  networks_aggregate: Mutual_Group_Network_Aggregate;
  /** An array relationship */
  org_team_associations: Array<Org_Team_Association>;
  /** An aggregate relationship */
  org_team_associations_aggregate: Org_Team_Association_Aggregate;
  /** An array relationship */
  org_team_user_bank_associations: Array<Org_Team_User_Bank_Association>;
  /** An aggregate relationship */
  org_team_user_bank_associations_aggregate: Org_Team_User_Bank_Association_Aggregate;
  /** An array relationship */
  org_team_user_document_associations: Array<Org_Team_User_Document_Association>;
  /** An aggregate relationship */
  org_team_user_document_associations_aggregate: Org_Team_User_Document_Association_Aggregate;
  /** An object relationship */
  photo?: Maybe<Media>;
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  region?: Maybe<Region>;
  region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupMutual_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupMutual_Group_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupNetworksArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupOrg_Team_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Association_Order_By>>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupOrg_Team_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Association_Order_By>>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupOrg_Team_User_Bank_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupOrg_Team_User_Bank_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupOrg_Team_User_Document_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


/** columns and relationships of "mutual_group" */
export type Mutual_GroupOrg_Team_User_Document_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};

/** aggregated selection of "mutual_group" */
export type Mutual_Group_Aggregate = {
  __typename?: 'mutual_group_aggregate';
  aggregate?: Maybe<Mutual_Group_Aggregate_Fields>;
  nodes: Array<Mutual_Group>;
};

/** aggregate fields of "mutual_group" */
export type Mutual_Group_Aggregate_Fields = {
  __typename?: 'mutual_group_aggregate_fields';
  avg?: Maybe<Mutual_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Max_Fields>;
  min?: Maybe<Mutual_Group_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Variance_Fields>;
};


/** aggregate fields of "mutual_group" */
export type Mutual_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mutual_group" */
export type Mutual_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Mutual_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mutual_Group_Max_Order_By>;
  min?: InputMaybe<Mutual_Group_Min_Order_By>;
  stddev?: InputMaybe<Mutual_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mutual_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mutual_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mutual_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Mutual_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mutual_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Mutual_Group_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mutual_group" */
export type Mutual_Group_Arr_Rel_Insert_Input = {
  data: Array<Mutual_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};

/** aggregate avg on columns */
export type Mutual_Group_Avg_Fields = {
  __typename?: 'mutual_group_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_field_assets?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mutual_group" */
export type Mutual_Group_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mutual_group". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  data_consent_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_reference_id2?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  max_field_assets?: InputMaybe<Int_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  org_team_associations?: InputMaybe<Org_Team_Association_Bool_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<Region_Bool_Exp>;
  region_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group" */
export enum Mutual_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  MutualGroupCodenameKey = 'mutual_group_codename_key',
  /** unique or primary key constraint on columns "data_consent_id" */
  MutualGroupDataConsentIdKey = 'mutual_group_data_consent_id_key',
  /** unique or primary key constraint on columns "id" */
  MutualGroupPkey = 'mutual_group_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group" */
export type Mutual_Group_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_field_assets?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group" */
export type Mutual_Group_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  max_field_assets?: InputMaybe<Scalars['Int']>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Mutual_Group_Network_Arr_Rel_Insert_Input>;
  org_team_associations?: InputMaybe<Org_Team_Association_Arr_Rel_Insert_Input>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Arr_Rel_Insert_Input>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Arr_Rel_Insert_Input>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Mutual_Group_Max_Fields = {
  __typename?: 'mutual_group_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_field_assets?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "mutual_group" */
export type Mutual_Group_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "mutual_group_membership" */
export type Mutual_Group_Membership = {
  __typename?: 'mutual_group_membership';
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  mutual_group: Mutual_Group;
  mutual_group_id: Scalars['Int'];
  /** An object relationship */
  mutual_group_role: Mutual_Group_Role;
  mutual_group_role_id: Scalars['Int'];
  remark: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate = {
  __typename?: 'mutual_group_membership_aggregate';
  aggregate?: Maybe<Mutual_Group_Membership_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Membership>;
};

/** aggregate fields of "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate_Fields = {
  __typename?: 'mutual_group_membership_aggregate_fields';
  avg?: Maybe<Mutual_Group_Membership_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Membership_Max_Fields>;
  min?: Maybe<Mutual_Group_Membership_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Membership_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Membership_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Membership_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Membership_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Membership_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Membership_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Membership_Variance_Fields>;
};


/** aggregate fields of "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mutual_group_membership" */
export type Mutual_Group_Membership_Aggregate_Order_By = {
  avg?: InputMaybe<Mutual_Group_Membership_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mutual_Group_Membership_Max_Order_By>;
  min?: InputMaybe<Mutual_Group_Membership_Min_Order_By>;
  stddev?: InputMaybe<Mutual_Group_Membership_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mutual_Group_Membership_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mutual_Group_Membership_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mutual_Group_Membership_Sum_Order_By>;
  var_pop?: InputMaybe<Mutual_Group_Membership_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mutual_Group_Membership_Var_Samp_Order_By>;
  variance?: InputMaybe<Mutual_Group_Membership_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mutual_group_membership" */
export type Mutual_Group_Membership_Arr_Rel_Insert_Input = {
  data: Array<Mutual_Group_Membership_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_Membership_On_Conflict>;
};

/** aggregate avg on columns */
export type Mutual_Group_Membership_Avg_Fields = {
  __typename?: 'mutual_group_membership_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mutual_group_membership". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Membership_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Membership_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Membership_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  mutual_group_role?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
  mutual_group_role_id?: InputMaybe<Int_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_membership" */
export enum Mutual_Group_Membership_Constraint {
  /** unique or primary key constraint on columns "mutual_group_role_id", "base_user_id", "mutual_group_id" */
  MutualGroupMembershipBaseUserIdMutualGrou_58a16353Uniq = 'mutual_group_membership_base_user_id_mutual_grou_58a16353_uniq',
  /** unique or primary key constraint on columns "id" */
  MutualGroupMembershipPkey = 'mutual_group_membership_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_membership" */
export type Mutual_Group_Membership_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_membership" */
export type Mutual_Group_Membership_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role?: InputMaybe<Mutual_Group_Role_Obj_Rel_Insert_Input>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Mutual_Group_Membership_Max_Fields = {
  __typename?: 'mutual_group_membership_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  mutual_group_role_id?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Max_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mutual_Group_Membership_Min_Fields = {
  __typename?: 'mutual_group_membership_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  mutual_group_role_id?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Min_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mutual_group_membership" */
export type Mutual_Group_Membership_Mutation_Response = {
  __typename?: 'mutual_group_membership_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Membership>;
};

/** on_conflict condition type for table "mutual_group_membership" */
export type Mutual_Group_Membership_On_Conflict = {
  constraint: Mutual_Group_Membership_Constraint;
  update_columns?: Array<Mutual_Group_Membership_Update_Column>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_membership". */
export type Mutual_Group_Membership_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role?: InputMaybe<Mutual_Group_Role_Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_membership */
export type Mutual_Group_Membership_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_membership" */
export enum Mutual_Group_Membership_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  MutualGroupRoleId = 'mutual_group_role_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mutual_group_membership" */
export type Mutual_Group_Membership_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Membership_Stddev_Fields = {
  __typename?: 'mutual_group_membership_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Membership_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_membership_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Membership_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_membership_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mutual_group_membership" */
export type Mutual_Group_Membership_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Membership_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Membership_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  mutual_group_role_id?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Membership_Sum_Fields = {
  __typename?: 'mutual_group_membership_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  mutual_group_role_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** update columns of table "mutual_group_membership" */
export enum Mutual_Group_Membership_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  MutualGroupRoleId = 'mutual_group_role_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mutual_Group_Membership_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Membership_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Membership_Set_Input>;
  where: Mutual_Group_Membership_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Membership_Var_Pop_Fields = {
  __typename?: 'mutual_group_membership_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Membership_Var_Samp_Fields = {
  __typename?: 'mutual_group_membership_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mutual_Group_Membership_Variance_Fields = {
  __typename?: 'mutual_group_membership_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  mutual_group_role_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mutual_group_membership" */
export type Mutual_Group_Membership_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  mutual_group_role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mutual_Group_Min_Fields = {
  __typename?: 'mutual_group_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_field_assets?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "mutual_group" */
export type Mutual_Group_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mutual_group" */
export type Mutual_Group_Mutation_Response = {
  __typename?: 'mutual_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group>;
};

/** columns and relationships of "mutual_group_network" */
export type Mutual_Group_Network = {
  __typename?: 'mutual_group_network';
  codename: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  mutual_group: Mutual_Group;
  mutual_group_id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "mutual_group_network" */
export type Mutual_Group_Network_Aggregate = {
  __typename?: 'mutual_group_network_aggregate';
  aggregate?: Maybe<Mutual_Group_Network_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Network>;
};

/** aggregate fields of "mutual_group_network" */
export type Mutual_Group_Network_Aggregate_Fields = {
  __typename?: 'mutual_group_network_aggregate_fields';
  avg?: Maybe<Mutual_Group_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Network_Max_Fields>;
  min?: Maybe<Mutual_Group_Network_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Network_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Network_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Network_Variance_Fields>;
};


/** aggregate fields of "mutual_group_network" */
export type Mutual_Group_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "mutual_group_network" */
export type Mutual_Group_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Mutual_Group_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mutual_Group_Network_Max_Order_By>;
  min?: InputMaybe<Mutual_Group_Network_Min_Order_By>;
  stddev?: InputMaybe<Mutual_Group_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mutual_Group_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mutual_Group_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mutual_Group_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Mutual_Group_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mutual_Group_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Mutual_Group_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mutual_group_network" */
export type Mutual_Group_Network_Arr_Rel_Insert_Input = {
  data: Array<Mutual_Group_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Mutual_Group_Network_Avg_Fields = {
  __typename?: 'mutual_group_network_avg_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mutual_group_network". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Network_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Network_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_network" */
export enum Mutual_Group_Network_Constraint {
  /** unique or primary key constraint on columns "network_id", "mutual_group_id" */
  MutualGroupNetworkNetworkIdMutualGroupId_51f8b9abUniq = 'mutual_group_network_network_id_mutual_group_id_51f8b9ab_uniq',
  /** unique or primary key constraint on columns "id" */
  MutualGroupNetworkPkey = 'mutual_group_network_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_network" */
export type Mutual_Group_Network_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_network" */
export type Mutual_Group_Network_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Mutual_Group_Network_Max_Fields = {
  __typename?: 'mutual_group_network_max_fields';
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mutual_Group_Network_Min_Fields = {
  __typename?: 'mutual_group_network_min_fields';
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mutual_group_network" */
export type Mutual_Group_Network_Mutation_Response = {
  __typename?: 'mutual_group_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Network>;
};

/** on_conflict condition type for table "mutual_group_network" */
export type Mutual_Group_Network_On_Conflict = {
  constraint: Mutual_Group_Network_Constraint;
  update_columns?: Array<Mutual_Group_Network_Update_Column>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_network". */
export type Mutual_Group_Network_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_network */
export type Mutual_Group_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_network" */
export enum Mutual_Group_Network_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "mutual_group_network" */
export type Mutual_Group_Network_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Network_Stddev_Fields = {
  __typename?: 'mutual_group_network_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Network_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_network_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Network_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_network_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mutual_group_network" */
export type Mutual_Group_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Network_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Network_Sum_Fields = {
  __typename?: 'mutual_group_network_sum_fields';
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** update columns of table "mutual_group_network" */
export enum Mutual_Group_Network_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Mutual_Group_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Network_Set_Input>;
  where: Mutual_Group_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Network_Var_Pop_Fields = {
  __typename?: 'mutual_group_network_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Network_Var_Samp_Fields = {
  __typename?: 'mutual_group_network_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mutual_Group_Network_Variance_Fields = {
  __typename?: 'mutual_group_network_variance_fields';
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mutual_group_network" */
export type Mutual_Group_Network_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "mutual_group" */
export type Mutual_Group_Obj_Rel_Insert_Input = {
  data: Mutual_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_On_Conflict>;
};

/** on_conflict condition type for table "mutual_group" */
export type Mutual_Group_On_Conflict = {
  constraint: Mutual_Group_Constraint;
  update_columns?: Array<Mutual_Group_Update_Column>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group". */
export type Mutual_Group_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  description?: InputMaybe<Order_By>;
  external_reference_id2?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  mutual_group_memberships_aggregate?: InputMaybe<Mutual_Group_Membership_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Mutual_Group_Network_Aggregate_Order_By>;
  org_team_associations_aggregate?: InputMaybe<Org_Team_Association_Aggregate_Order_By>;
  org_team_user_bank_associations_aggregate?: InputMaybe<Org_Team_User_Bank_Association_Aggregate_Order_By>;
  org_team_user_document_associations_aggregate?: InputMaybe<Org_Team_User_Document_Association_Aggregate_Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  region?: InputMaybe<Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group */
export type Mutual_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "mutual_group_role" */
export type Mutual_Group_Role = {
  __typename?: 'mutual_group_role';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An array relationship */
  mutual_group_memberships: Array<Mutual_Group_Membership>;
  /** An aggregate relationship */
  mutual_group_memberships_aggregate: Mutual_Group_Membership_Aggregate;
  name: Scalars['String'];
};


/** columns and relationships of "mutual_group_role" */
export type Mutual_Group_RoleMutual_Group_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


/** columns and relationships of "mutual_group_role" */
export type Mutual_Group_RoleMutual_Group_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};

/** aggregated selection of "mutual_group_role" */
export type Mutual_Group_Role_Aggregate = {
  __typename?: 'mutual_group_role_aggregate';
  aggregate?: Maybe<Mutual_Group_Role_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Role>;
};

/** aggregate fields of "mutual_group_role" */
export type Mutual_Group_Role_Aggregate_Fields = {
  __typename?: 'mutual_group_role_aggregate_fields';
  avg?: Maybe<Mutual_Group_Role_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Role_Max_Fields>;
  min?: Maybe<Mutual_Group_Role_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Role_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Role_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Role_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Role_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Role_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Role_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Role_Variance_Fields>;
};


/** aggregate fields of "mutual_group_role" */
export type Mutual_Group_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mutual_Group_Role_Avg_Fields = {
  __typename?: 'mutual_group_role_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mutual_group_role". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Role_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Role_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_role" */
export enum Mutual_Group_Role_Constraint {
  /** unique or primary key constraint on columns "codename" */
  MutualGroupRoleCodenameKey = 'mutual_group_role_codename_key',
  /** unique or primary key constraint on columns "id" */
  MutualGroupRolePkey = 'mutual_group_role_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_role" */
export type Mutual_Group_Role_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_role" */
export type Mutual_Group_Role_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_memberships?: InputMaybe<Mutual_Group_Membership_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Mutual_Group_Role_Max_Fields = {
  __typename?: 'mutual_group_role_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mutual_Group_Role_Min_Fields = {
  __typename?: 'mutual_group_role_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "mutual_group_role" */
export type Mutual_Group_Role_Mutation_Response = {
  __typename?: 'mutual_group_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Role>;
};

/** input type for inserting object relation for remote table "mutual_group_role" */
export type Mutual_Group_Role_Obj_Rel_Insert_Input = {
  data: Mutual_Group_Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mutual_Group_Role_On_Conflict>;
};

/** on_conflict condition type for table "mutual_group_role" */
export type Mutual_Group_Role_On_Conflict = {
  constraint: Mutual_Group_Role_Constraint;
  update_columns?: Array<Mutual_Group_Role_Update_Column>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_role". */
export type Mutual_Group_Role_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_group_memberships_aggregate?: InputMaybe<Mutual_Group_Membership_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_role */
export type Mutual_Group_Role_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_role" */
export enum Mutual_Group_Role_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "mutual_group_role" */
export type Mutual_Group_Role_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Role_Stddev_Fields = {
  __typename?: 'mutual_group_role_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Role_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_role_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Role_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_role_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mutual_group_role" */
export type Mutual_Group_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Role_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Role_Sum_Fields = {
  __typename?: 'mutual_group_role_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "mutual_group_role" */
export enum Mutual_Group_Role_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Mutual_Group_Role_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Role_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Role_Set_Input>;
  where: Mutual_Group_Role_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Role_Var_Pop_Fields = {
  __typename?: 'mutual_group_role_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Role_Var_Samp_Fields = {
  __typename?: 'mutual_group_role_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mutual_Group_Role_Variance_Fields = {
  __typename?: 'mutual_group_role_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** select columns of table "mutual_group" */
export enum Mutual_Group_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  MaxFieldAssets = 'max_field_assets',
  /** column name */
  Name = 'name',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "mutual_group" */
export type Mutual_Group_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  max_field_assets?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Stddev_Fields = {
  __typename?: 'mutual_group_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_field_assets?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "mutual_group" */
export type Mutual_Group_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_field_assets?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "mutual_group" */
export type Mutual_Group_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_field_assets?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "mutual_group" */
export type Mutual_Group_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mutual_group" */
export type Mutual_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  data_consent_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  max_field_assets?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Sum_Fields = {
  __typename?: 'mutual_group_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  data_consent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_field_assets?: Maybe<Scalars['Int']>;
  region_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "mutual_group" */
export type Mutual_Group_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "mutual_group" */
export enum Mutual_Group_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DataConsentId = 'data_consent_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  MaxFieldAssets = 'max_field_assets',
  /** column name */
  Name = 'name',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Mutual_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Set_Input>;
  where: Mutual_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Var_Pop_Fields = {
  __typename?: 'mutual_group_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_field_assets?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "mutual_group" */
export type Mutual_Group_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Var_Samp_Fields = {
  __typename?: 'mutual_group_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_field_assets?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "mutual_group" */
export type Mutual_Group_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mutual_Group_Variance_Fields = {
  __typename?: 'mutual_group_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  data_consent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_field_assets?: Maybe<Scalars['Float']>;
  region_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "mutual_group" */
export type Mutual_Group_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  data_consent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_field_assets?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station = {
  __typename?: 'mutual_group_weather_station';
  /** An object relationship */
  base_user?: Maybe<Base_User>;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  department?: Maybe<Department>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_public: Scalars['Boolean'];
  location_text?: Maybe<Scalars['String']>;
  /** An object relationship */
  mutual_group?: Maybe<Mutual_Group>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
  weather_station_id: Scalars['String'];
};

/** aggregated selection of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Aggregate = {
  __typename?: 'mutual_group_weather_station_aggregate';
  aggregate?: Maybe<Mutual_Group_Weather_Station_Aggregate_Fields>;
  nodes: Array<Mutual_Group_Weather_Station>;
};

/** aggregate fields of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Aggregate_Fields = {
  __typename?: 'mutual_group_weather_station_aggregate_fields';
  avg?: Maybe<Mutual_Group_Weather_Station_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mutual_Group_Weather_Station_Max_Fields>;
  min?: Maybe<Mutual_Group_Weather_Station_Min_Fields>;
  stddev?: Maybe<Mutual_Group_Weather_Station_Stddev_Fields>;
  stddev_pop?: Maybe<Mutual_Group_Weather_Station_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mutual_Group_Weather_Station_Stddev_Samp_Fields>;
  sum?: Maybe<Mutual_Group_Weather_Station_Sum_Fields>;
  var_pop?: Maybe<Mutual_Group_Weather_Station_Var_Pop_Fields>;
  var_samp?: Maybe<Mutual_Group_Weather_Station_Var_Samp_Fields>;
  variance?: Maybe<Mutual_Group_Weather_Station_Variance_Fields>;
};


/** aggregate fields of "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mutual_Group_Weather_Station_Avg_Fields = {
  __typename?: 'mutual_group_weather_station_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mutual_group_weather_station". All fields are combined with a logical 'AND'. */
export type Mutual_Group_Weather_Station_Bool_Exp = {
  _and?: InputMaybe<Array<Mutual_Group_Weather_Station_Bool_Exp>>;
  _not?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
  _or?: InputMaybe<Array<Mutual_Group_Weather_Station_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_public?: InputMaybe<Boolean_Comparison_Exp>;
  location_text?: InputMaybe<String_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  weather_station_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mutual_group_weather_station" */
export enum Mutual_Group_Weather_Station_Constraint {
  /** unique or primary key constraint on columns "weather_station_id", "mutual_group_id" */
  MutualGroupWeatherStaWeatherStationIdMutua_250bb7deUniq = 'mutual_group_weather_sta_weather_station_id_mutua_250bb7de_uniq',
  /** unique or primary key constraint on columns "weather_station_id", "network_id" */
  MutualGroupWeatherStaWeatherStationIdNetwo_0849e1eaUniq = 'mutual_group_weather_sta_weather_station_id_netwo_0849e1ea_uniq',
  /** unique or primary key constraint on columns "id" */
  MutualGroupWeatherStationPkey = 'mutual_group_weather_station_pkey'
}

/** input type for incrementing numeric columns in table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  location_text?: InputMaybe<Scalars['String']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  weather_station_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Mutual_Group_Weather_Station_Max_Fields = {
  __typename?: 'mutual_group_weather_station_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location_text?: Maybe<Scalars['String']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  weather_station_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mutual_Group_Weather_Station_Min_Fields = {
  __typename?: 'mutual_group_weather_station_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location_text?: Maybe<Scalars['String']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  weather_station_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Mutation_Response = {
  __typename?: 'mutual_group_weather_station_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mutual_Group_Weather_Station>;
};

/** on_conflict condition type for table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_On_Conflict = {
  constraint: Mutual_Group_Weather_Station_Constraint;
  update_columns?: Array<Mutual_Group_Weather_Station_Update_Column>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};

/** Ordering options when selecting data from "mutual_group_weather_station". */
export type Mutual_Group_Weather_Station_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_public?: InputMaybe<Order_By>;
  location_text?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  weather_station_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mutual_group_weather_station */
export type Mutual_Group_Weather_Station_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "mutual_group_weather_station" */
export enum Mutual_Group_Weather_Station_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  LocationText = 'location_text',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WeatherStationId = 'weather_station_id'
}

/** input type for updating data in table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  location_text?: InputMaybe<Scalars['String']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  weather_station_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Mutual_Group_Weather_Station_Stddev_Fields = {
  __typename?: 'mutual_group_weather_station_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mutual_Group_Weather_Station_Stddev_Pop_Fields = {
  __typename?: 'mutual_group_weather_station_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mutual_Group_Weather_Station_Stddev_Samp_Fields = {
  __typename?: 'mutual_group_weather_station_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mutual_group_weather_station" */
export type Mutual_Group_Weather_Station_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mutual_Group_Weather_Station_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mutual_Group_Weather_Station_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  location_text?: InputMaybe<Scalars['String']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  network_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  weather_station_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mutual_Group_Weather_Station_Sum_Fields = {
  __typename?: 'mutual_group_weather_station_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "mutual_group_weather_station" */
export enum Mutual_Group_Weather_Station_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  LocationText = 'location_text',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WeatherStationId = 'weather_station_id'
}

export type Mutual_Group_Weather_Station_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mutual_Group_Weather_Station_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mutual_Group_Weather_Station_Set_Input>;
  where: Mutual_Group_Weather_Station_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mutual_Group_Weather_Station_Var_Pop_Fields = {
  __typename?: 'mutual_group_weather_station_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mutual_Group_Weather_Station_Var_Samp_Fields = {
  __typename?: 'mutual_group_weather_station_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mutual_Group_Weather_Station_Variance_Fields = {
  __typename?: 'mutual_group_weather_station_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "nationality" */
export type Nationality = {
  __typename?: 'nationality';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "nationality" */
export type Nationality_Aggregate = {
  __typename?: 'nationality_aggregate';
  aggregate?: Maybe<Nationality_Aggregate_Fields>;
  nodes: Array<Nationality>;
};

/** aggregate fields of "nationality" */
export type Nationality_Aggregate_Fields = {
  __typename?: 'nationality_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nationality_Max_Fields>;
  min?: Maybe<Nationality_Min_Fields>;
};


/** aggregate fields of "nationality" */
export type Nationality_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nationality_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nationality". All fields are combined with a logical 'AND'. */
export type Nationality_Bool_Exp = {
  _and?: InputMaybe<Array<Nationality_Bool_Exp>>;
  _not?: InputMaybe<Nationality_Bool_Exp>;
  _or?: InputMaybe<Array<Nationality_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nationality" */
export enum Nationality_Constraint {
  /** unique or primary key constraint on columns "id" */
  NationalityPkey = 'nationality_pkey'
}

/** input type for inserting data into table "nationality" */
export type Nationality_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Nationality_Max_Fields = {
  __typename?: 'nationality_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Nationality_Min_Fields = {
  __typename?: 'nationality_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "nationality" */
export type Nationality_Mutation_Response = {
  __typename?: 'nationality_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nationality>;
};

/** input type for inserting object relation for remote table "nationality" */
export type Nationality_Obj_Rel_Insert_Input = {
  data: Nationality_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Nationality_On_Conflict>;
};

/** on_conflict condition type for table "nationality" */
export type Nationality_On_Conflict = {
  constraint: Nationality_Constraint;
  update_columns?: Array<Nationality_Update_Column>;
  where?: InputMaybe<Nationality_Bool_Exp>;
};

/** Ordering options when selecting data from "nationality". */
export type Nationality_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nationality */
export type Nationality_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "nationality" */
export enum Nationality_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "nationality" */
export type Nationality_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "nationality" */
export type Nationality_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nationality_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nationality_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "nationality" */
export enum Nationality_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Nationality_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nationality_Set_Input>;
  where: Nationality_Bool_Exp;
};

/** columns and relationships of "network" */
export type Network = {
  __typename?: 'network';
  /** An array relationship */
  business_groups: Array<Business_Group_Network>;
  /** An aggregate relationship */
  business_groups_aggregate: Business_Group_Network_Aggregate;
  /** An array relationship */
  businesses: Array<Business_Network>;
  /** An aggregate relationship */
  businesses_aggregate: Business_Network_Aggregate;
  codename: Scalars['String'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  farms: Array<Farm_Network>;
  /** An aggregate relationship */
  farms_aggregate: Farm_Network_Aggregate;
  /** An array relationship */
  fields: Array<Field_Network>;
  /** An aggregate relationship */
  fields_aggregate: Field_Network_Aggregate;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_default: Scalars['Boolean'];
  /** An array relationship */
  mutual_groups: Array<Mutual_Group_Network>;
  /** An aggregate relationship */
  mutual_groups_aggregate: Mutual_Group_Network_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  plot_crop_networks: Array<Plot_Crop_Network>;
  /** An aggregate relationship */
  plot_crop_networks_aggregate: Plot_Crop_Network_Aggregate;
  /** An array relationship */
  plots: Array<Plot_Network>;
  /** An aggregate relationship */
  plots_aggregate: Plot_Network_Aggregate;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "network" */
export type NetworkBusiness_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkBusiness_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkBusinessesArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkBusinesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkMutual_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkMutual_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlot_Crop_NetworksArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlot_Crop_Networks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlotsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


/** columns and relationships of "network" */
export type NetworkPlots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};

/** aggregated selection of "network" */
export type Network_Aggregate = {
  __typename?: 'network_aggregate';
  aggregate?: Maybe<Network_Aggregate_Fields>;
  nodes: Array<Network>;
};

/** aggregate fields of "network" */
export type Network_Aggregate_Fields = {
  __typename?: 'network_aggregate_fields';
  avg?: Maybe<Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Network_Max_Fields>;
  min?: Maybe<Network_Min_Fields>;
  stddev?: Maybe<Network_Stddev_Fields>;
  stddev_pop?: Maybe<Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Network_Stddev_Samp_Fields>;
  sum?: Maybe<Network_Sum_Fields>;
  var_pop?: Maybe<Network_Var_Pop_Fields>;
  var_samp?: Maybe<Network_Var_Samp_Fields>;
  variance?: Maybe<Network_Variance_Fields>;
};


/** aggregate fields of "network" */
export type Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "network" */
export type Network_Aggregate_Order_By = {
  avg?: InputMaybe<Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Network_Max_Order_By>;
  min?: InputMaybe<Network_Min_Order_By>;
  stddev?: InputMaybe<Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Network_Sum_Order_By>;
  var_pop?: InputMaybe<Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "network" */
export type Network_Arr_Rel_Insert_Input = {
  data: Array<Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Network_Avg_Fields = {
  __typename?: 'network_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "network" */
export type Network_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "network". All fields are combined with a logical 'AND'. */
export type Network_Bool_Exp = {
  _and?: InputMaybe<Array<Network_Bool_Exp>>;
  _not?: InputMaybe<Network_Bool_Exp>;
  _or?: InputMaybe<Array<Network_Bool_Exp>>;
  business_groups?: InputMaybe<Business_Group_Network_Bool_Exp>;
  businesses?: InputMaybe<Business_Network_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farms?: InputMaybe<Farm_Network_Bool_Exp>;
  fields?: InputMaybe<Field_Network_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  plot_crop_networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  plots?: InputMaybe<Plot_Network_Bool_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_till?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "network" */
export enum Network_Constraint {
  /** unique or primary key constraint on columns "codename" */
  NetworkCodenameKey = 'network_codename_key',
  /** unique or primary key constraint on columns "name", "valid_till", "valid_from", "company_id" */
  NetworkNameCompanyIdValidFromValidTill_012f49eaUniq = 'network_name_company_id_valid_from_valid_till_012f49ea_uniq',
  /** unique or primary key constraint on columns "id" */
  NetworkPkey = 'network_pkey'
}

/** input type for incrementing numeric columns in table "network" */
export type Network_Inc_Input = {
  company_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "network" */
export type Network_Insert_Input = {
  business_groups?: InputMaybe<Business_Group_Network_Arr_Rel_Insert_Input>;
  businesses?: InputMaybe<Business_Network_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farms?: InputMaybe<Farm_Network_Arr_Rel_Insert_Input>;
  fields?: InputMaybe<Field_Network_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  mutual_groups?: InputMaybe<Mutual_Group_Network_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  plot_crop_networks?: InputMaybe<Plot_Crop_Network_Arr_Rel_Insert_Input>;
  plots?: InputMaybe<Plot_Network_Arr_Rel_Insert_Input>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Network_Max_Fields = {
  __typename?: 'network_max_fields';
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "network" */
export type Network_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Network_Min_Fields = {
  __typename?: 'network_min_fields';
  codename?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "network" */
export type Network_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "network" */
export type Network_Mutation_Response = {
  __typename?: 'network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Network>;
};

/** input type for inserting object relation for remote table "network" */
export type Network_Obj_Rel_Insert_Input = {
  data: Network_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Network_On_Conflict>;
};

/** on_conflict condition type for table "network" */
export type Network_On_Conflict = {
  constraint: Network_Constraint;
  update_columns?: Array<Network_Update_Column>;
  where?: InputMaybe<Network_Bool_Exp>;
};

/** Ordering options when selecting data from "network". */
export type Network_Order_By = {
  business_groups_aggregate?: InputMaybe<Business_Group_Network_Aggregate_Order_By>;
  businesses_aggregate?: InputMaybe<Business_Network_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farms_aggregate?: InputMaybe<Farm_Network_Aggregate_Order_By>;
  fields_aggregate?: InputMaybe<Field_Network_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  mutual_groups_aggregate?: InputMaybe<Mutual_Group_Network_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  plot_crop_networks_aggregate?: InputMaybe<Plot_Crop_Network_Aggregate_Order_By>;
  plots_aggregate?: InputMaybe<Plot_Network_Aggregate_Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** primary key columns input for table: network */
export type Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "network" */
export enum Network_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till'
}

/** input type for updating data in table "network" */
export type Network_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Network_Stddev_Fields = {
  __typename?: 'network_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "network" */
export type Network_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Network_Stddev_Pop_Fields = {
  __typename?: 'network_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "network" */
export type Network_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Network_Stddev_Samp_Fields = {
  __typename?: 'network_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "network" */
export type Network_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "network" */
export type Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Network_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Network_Sum_Fields = {
  __typename?: 'network_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "network" */
export type Network_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "network" */
export enum Network_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Name = 'name',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till'
}

export type Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Network_Set_Input>;
  where: Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Network_Var_Pop_Fields = {
  __typename?: 'network_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "network" */
export type Network_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Network_Var_Samp_Fields = {
  __typename?: 'network_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "network" */
export type Network_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Network_Variance_Fields = {
  __typename?: 'network_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "network" */
export type Network_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "nominees" */
export type Nominees = {
  __typename?: 'nominees';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  applications: Array<Shareholder_Applications>;
  /** An aggregate relationship */
  applications_aggregate: Shareholder_Applications_Aggregate;
  /** An object relationship */
  avatar?: Maybe<Media>;
  avatar_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  date_of_birth?: Maybe<Scalars['date']>;
  /** An array relationship */
  documents: Array<Nominees_Documents>;
  /** An aggregate relationship */
  documents_aggregate: Nominees_Documents_Aggregate;
  email?: Maybe<Scalars['String']>;
  father_mother_spouse_name?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  highest_education?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  last_name: Scalars['String'];
  metadata: Scalars['jsonb'];
  /** An object relationship */
  nationality?: Maybe<Nationality>;
  nationality_id?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  occupation?: Maybe<Scalars['String']>;
  private_metadata: Scalars['jsonb'];
  secondary_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "nominees" */
export type NomineesApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


/** columns and relationships of "nominees" */
export type NomineesApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


/** columns and relationships of "nominees" */
export type NomineesDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Documents_Order_By>>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};


/** columns and relationships of "nominees" */
export type NomineesDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Documents_Order_By>>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};


/** columns and relationships of "nominees" */
export type NomineesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "nominees" */
export type NomineesPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "nominees" */
export type Nominees_Aggregate = {
  __typename?: 'nominees_aggregate';
  aggregate?: Maybe<Nominees_Aggregate_Fields>;
  nodes: Array<Nominees>;
};

/** aggregate fields of "nominees" */
export type Nominees_Aggregate_Fields = {
  __typename?: 'nominees_aggregate_fields';
  avg?: Maybe<Nominees_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nominees_Max_Fields>;
  min?: Maybe<Nominees_Min_Fields>;
  stddev?: Maybe<Nominees_Stddev_Fields>;
  stddev_pop?: Maybe<Nominees_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nominees_Stddev_Samp_Fields>;
  sum?: Maybe<Nominees_Sum_Fields>;
  var_pop?: Maybe<Nominees_Var_Pop_Fields>;
  var_samp?: Maybe<Nominees_Var_Samp_Fields>;
  variance?: Maybe<Nominees_Variance_Fields>;
};


/** aggregate fields of "nominees" */
export type Nominees_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nominees_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Nominees_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Nominees_Avg_Fields = {
  __typename?: 'nominees_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  avatar_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nominees". All fields are combined with a logical 'AND'. */
export type Nominees_Bool_Exp = {
  _and?: InputMaybe<Array<Nominees_Bool_Exp>>;
  _not?: InputMaybe<Nominees_Bool_Exp>;
  _or?: InputMaybe<Array<Nominees_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  applications?: InputMaybe<Shareholder_Applications_Bool_Exp>;
  avatar?: InputMaybe<Media_Bool_Exp>;
  avatar_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  documents?: InputMaybe<Nominees_Documents_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  father_mother_spouse_name?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  highest_education?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  nationality?: InputMaybe<Nationality_Bool_Exp>;
  nationality_id?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  occupation?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "nominees" */
export enum Nominees_Constraint {
  /** unique or primary key constraint on columns "id" */
  NomineesPkey = 'nominees_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Nominees_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Nominees_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Nominees_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "nominees_documents" */
export type Nominees_Documents = {
  __typename?: 'nominees_documents';
  /** An object relationship */
  document: Document;
  document_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  nominee: Nominees;
  nominee_id: Scalars['Int'];
};

/** aggregated selection of "nominees_documents" */
export type Nominees_Documents_Aggregate = {
  __typename?: 'nominees_documents_aggregate';
  aggregate?: Maybe<Nominees_Documents_Aggregate_Fields>;
  nodes: Array<Nominees_Documents>;
};

/** aggregate fields of "nominees_documents" */
export type Nominees_Documents_Aggregate_Fields = {
  __typename?: 'nominees_documents_aggregate_fields';
  avg?: Maybe<Nominees_Documents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nominees_Documents_Max_Fields>;
  min?: Maybe<Nominees_Documents_Min_Fields>;
  stddev?: Maybe<Nominees_Documents_Stddev_Fields>;
  stddev_pop?: Maybe<Nominees_Documents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nominees_Documents_Stddev_Samp_Fields>;
  sum?: Maybe<Nominees_Documents_Sum_Fields>;
  var_pop?: Maybe<Nominees_Documents_Var_Pop_Fields>;
  var_samp?: Maybe<Nominees_Documents_Var_Samp_Fields>;
  variance?: Maybe<Nominees_Documents_Variance_Fields>;
};


/** aggregate fields of "nominees_documents" */
export type Nominees_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nominees_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nominees_documents" */
export type Nominees_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Nominees_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nominees_Documents_Max_Order_By>;
  min?: InputMaybe<Nominees_Documents_Min_Order_By>;
  stddev?: InputMaybe<Nominees_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nominees_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nominees_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nominees_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Nominees_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nominees_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Nominees_Documents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nominees_documents" */
export type Nominees_Documents_Arr_Rel_Insert_Input = {
  data: Array<Nominees_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nominees_Documents_On_Conflict>;
};

/** aggregate avg on columns */
export type Nominees_Documents_Avg_Fields = {
  __typename?: 'nominees_documents_avg_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nominees_documents" */
export type Nominees_Documents_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nominees_documents". All fields are combined with a logical 'AND'. */
export type Nominees_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Nominees_Documents_Bool_Exp>>;
  _not?: InputMaybe<Nominees_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Nominees_Documents_Bool_Exp>>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nominee?: InputMaybe<Nominees_Bool_Exp>;
  nominee_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "nominees_documents" */
export enum Nominees_Documents_Constraint {
  /** unique or primary key constraint on columns "nominee_id", "document_id" */
  NomineesDocumentsNomineeIdDocumentIdE72d2408Uniq = 'nominees_documents_nominee_id_document_id_e72d2408_uniq',
  /** unique or primary key constraint on columns "id" */
  NomineesDocumentsPkey = 'nominees_documents_pkey'
}

/** input type for incrementing numeric columns in table "nominees_documents" */
export type Nominees_Documents_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nominee_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nominees_documents" */
export type Nominees_Documents_Insert_Input = {
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nominee?: InputMaybe<Nominees_Obj_Rel_Insert_Input>;
  nominee_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Nominees_Documents_Max_Fields = {
  __typename?: 'nominees_documents_max_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nominee_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "nominees_documents" */
export type Nominees_Documents_Max_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nominees_Documents_Min_Fields = {
  __typename?: 'nominees_documents_min_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nominee_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "nominees_documents" */
export type Nominees_Documents_Min_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nominees_documents" */
export type Nominees_Documents_Mutation_Response = {
  __typename?: 'nominees_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nominees_Documents>;
};

/** on_conflict condition type for table "nominees_documents" */
export type Nominees_Documents_On_Conflict = {
  constraint: Nominees_Documents_Constraint;
  update_columns?: Array<Nominees_Documents_Update_Column>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "nominees_documents". */
export type Nominees_Documents_Order_By = {
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee?: InputMaybe<Nominees_Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nominees_documents */
export type Nominees_Documents_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "nominees_documents" */
export enum Nominees_Documents_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  NomineeId = 'nominee_id'
}

/** input type for updating data in table "nominees_documents" */
export type Nominees_Documents_Set_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nominee_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Nominees_Documents_Stddev_Fields = {
  __typename?: 'nominees_documents_stddev_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nominees_documents" */
export type Nominees_Documents_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nominees_Documents_Stddev_Pop_Fields = {
  __typename?: 'nominees_documents_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nominees_documents" */
export type Nominees_Documents_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nominees_Documents_Stddev_Samp_Fields = {
  __typename?: 'nominees_documents_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nominees_documents" */
export type Nominees_Documents_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nominees_documents" */
export type Nominees_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nominees_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nominees_Documents_Stream_Cursor_Value_Input = {
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nominee_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Nominees_Documents_Sum_Fields = {
  __typename?: 'nominees_documents_sum_fields';
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nominee_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "nominees_documents" */
export type Nominees_Documents_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** update columns of table "nominees_documents" */
export enum Nominees_Documents_Update_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  NomineeId = 'nominee_id'
}

export type Nominees_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nominees_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nominees_Documents_Set_Input>;
  where: Nominees_Documents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nominees_Documents_Var_Pop_Fields = {
  __typename?: 'nominees_documents_var_pop_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nominees_documents" */
export type Nominees_Documents_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nominees_Documents_Var_Samp_Fields = {
  __typename?: 'nominees_documents_var_samp_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nominees_documents" */
export type Nominees_Documents_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nominees_Documents_Variance_Fields = {
  __typename?: 'nominees_documents_variance_fields';
  document_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nominees_documents" */
export type Nominees_Documents_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "nominees" */
export type Nominees_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  avatar_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "nominees" */
export type Nominees_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  applications?: InputMaybe<Shareholder_Applications_Arr_Rel_Insert_Input>;
  avatar?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  avatar_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  documents?: InputMaybe<Nominees_Documents_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  father_mother_spouse_name?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  highest_education?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  nationality?: InputMaybe<Nationality_Obj_Rel_Insert_Input>;
  nationality_id?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Nominees_Max_Fields = {
  __typename?: 'nominees_max_fields';
  address_id?: Maybe<Scalars['Int']>;
  avatar_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_of_birth?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  father_mother_spouse_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  highest_education?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Nominees_Min_Fields = {
  __typename?: 'nominees_min_fields';
  address_id?: Maybe<Scalars['Int']>;
  avatar_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_of_birth?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  father_mother_spouse_name?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  highest_education?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "nominees" */
export type Nominees_Mutation_Response = {
  __typename?: 'nominees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nominees>;
};

/** input type for inserting object relation for remote table "nominees" */
export type Nominees_Obj_Rel_Insert_Input = {
  data: Nominees_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Nominees_On_Conflict>;
};

/** on_conflict condition type for table "nominees" */
export type Nominees_On_Conflict = {
  constraint: Nominees_Constraint;
  update_columns?: Array<Nominees_Update_Column>;
  where?: InputMaybe<Nominees_Bool_Exp>;
};

/** Ordering options when selecting data from "nominees". */
export type Nominees_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  applications_aggregate?: InputMaybe<Shareholder_Applications_Aggregate_Order_By>;
  avatar?: InputMaybe<Media_Order_By>;
  avatar_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Nominees_Documents_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  father_mother_spouse_name?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  highest_education?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Nationality_Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  occupation?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nominees */
export type Nominees_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Nominees_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "nominees" */
export enum Nominees_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AvatarId = 'avatar_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Email = 'email',
  /** column name */
  FatherMotherSpouseName = 'father_mother_spouse_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HighestEducation = 'highest_education',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  Number = 'number',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nominees" */
export type Nominees_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  avatar_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['String']>;
  father_mother_spouse_name?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  highest_education?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  nationality_id?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Nominees_Stddev_Fields = {
  __typename?: 'nominees_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  avatar_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Nominees_Stddev_Pop_Fields = {
  __typename?: 'nominees_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  avatar_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Nominees_Stddev_Samp_Fields = {
  __typename?: 'nominees_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  avatar_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "nominees" */
export type Nominees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nominees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nominees_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  avatar_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_of_birth?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['String']>;
  father_mother_spouse_name?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  highest_education?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  nationality_id?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Nominees_Sum_Fields = {
  __typename?: 'nominees_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  avatar_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "nominees" */
export enum Nominees_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AvatarId = 'avatar_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Email = 'email',
  /** column name */
  FatherMotherSpouseName = 'father_mother_spouse_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HighestEducation = 'highest_education',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  Number = 'number',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Nominees_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Nominees_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Nominees_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Nominees_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Nominees_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nominees_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Nominees_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nominees_Set_Input>;
  where: Nominees_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nominees_Var_Pop_Fields = {
  __typename?: 'nominees_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  avatar_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Nominees_Var_Samp_Fields = {
  __typename?: 'nominees_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  avatar_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Nominees_Variance_Fields = {
  __typename?: 'nominees_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  avatar_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "notification_provider" */
export type Notification_Provider = {
  __typename?: 'notification_provider';
  codename: Scalars['String'];
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  firebase_app_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  kind: Scalars['String'];
  name: Scalars['String'];
  request: Scalars['jsonb'];
  save_as_notification: Scalars['Boolean'];
  sms_payload_handler?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "notification_provider" */
export type Notification_ProviderConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_provider" */
export type Notification_ProviderRequestArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_provider" */
export type Notification_Provider_Aggregate = {
  __typename?: 'notification_provider_aggregate';
  aggregate?: Maybe<Notification_Provider_Aggregate_Fields>;
  nodes: Array<Notification_Provider>;
};

/** aggregate fields of "notification_provider" */
export type Notification_Provider_Aggregate_Fields = {
  __typename?: 'notification_provider_aggregate_fields';
  avg?: Maybe<Notification_Provider_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notification_Provider_Max_Fields>;
  min?: Maybe<Notification_Provider_Min_Fields>;
  stddev?: Maybe<Notification_Provider_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Provider_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Provider_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Provider_Sum_Fields>;
  var_pop?: Maybe<Notification_Provider_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Provider_Var_Samp_Fields>;
  variance?: Maybe<Notification_Provider_Variance_Fields>;
};


/** aggregate fields of "notification_provider" */
export type Notification_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notification_Provider_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  request?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Notification_Provider_Avg_Fields = {
  __typename?: 'notification_provider_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_provider". All fields are combined with a logical 'AND'. */
export type Notification_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Provider_Bool_Exp>>;
  _not?: InputMaybe<Notification_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Provider_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  firebase_app_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  request?: InputMaybe<Jsonb_Comparison_Exp>;
  save_as_notification?: InputMaybe<Boolean_Comparison_Exp>;
  sms_payload_handler?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_provider" */
export enum Notification_Provider_Constraint {
  /** unique or primary key constraint on columns "codename" */
  NotificationProviderCodenameKey = 'notification_provider_codename_key',
  /** unique or primary key constraint on columns "id" */
  NotificationProviderPkey = 'notification_provider_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notification_Provider_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
  request?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notification_Provider_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
  request?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notification_Provider_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification_provider" */
export type Notification_Provider_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification_provider" */
export type Notification_Provider_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firebase_app_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Scalars['jsonb']>;
  save_as_notification?: InputMaybe<Scalars['Boolean']>;
  sms_payload_handler?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Notification_Provider_Max_Fields = {
  __typename?: 'notification_provider_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firebase_app_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sms_payload_handler?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Notification_Provider_Min_Fields = {
  __typename?: 'notification_provider_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  firebase_app_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sms_payload_handler?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "notification_provider" */
export type Notification_Provider_Mutation_Response = {
  __typename?: 'notification_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Provider>;
};

/** input type for inserting object relation for remote table "notification_provider" */
export type Notification_Provider_Obj_Rel_Insert_Input = {
  data: Notification_Provider_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Provider_On_Conflict>;
};

/** on_conflict condition type for table "notification_provider" */
export type Notification_Provider_On_Conflict = {
  constraint: Notification_Provider_Constraint;
  update_columns?: Array<Notification_Provider_Update_Column>;
  where?: InputMaybe<Notification_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_provider". */
export type Notification_Provider_Order_By = {
  codename?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firebase_app_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  request?: InputMaybe<Order_By>;
  save_as_notification?: InputMaybe<Order_By>;
  sms_payload_handler?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_provider */
export type Notification_Provider_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notification_Provider_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  request?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_provider" */
export enum Notification_Provider_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FirebaseAppName = 'firebase_app_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  Request = 'request',
  /** column name */
  SaveAsNotification = 'save_as_notification',
  /** column name */
  SmsPayloadHandler = 'sms_payload_handler',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "notification_provider" */
export type Notification_Provider_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firebase_app_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Scalars['jsonb']>;
  save_as_notification?: InputMaybe<Scalars['Boolean']>;
  sms_payload_handler?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Notification_Provider_Stddev_Fields = {
  __typename?: 'notification_provider_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Notification_Provider_Stddev_Pop_Fields = {
  __typename?: 'notification_provider_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Notification_Provider_Stddev_Samp_Fields = {
  __typename?: 'notification_provider_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notification_provider" */
export type Notification_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Provider_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  firebase_app_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  request?: InputMaybe<Scalars['jsonb']>;
  save_as_notification?: InputMaybe<Scalars['Boolean']>;
  sms_payload_handler?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Notification_Provider_Sum_Fields = {
  __typename?: 'notification_provider_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notification_provider" */
export enum Notification_Provider_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FirebaseAppName = 'firebase_app_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  Request = 'request',
  /** column name */
  SaveAsNotification = 'save_as_notification',
  /** column name */
  SmsPayloadHandler = 'sms_payload_handler',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Notification_Provider_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Notification_Provider_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Notification_Provider_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Notification_Provider_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Notification_Provider_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Provider_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Notification_Provider_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Provider_Set_Input>;
  where: Notification_Provider_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notification_Provider_Var_Pop_Fields = {
  __typename?: 'notification_provider_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Notification_Provider_Var_Samp_Fields = {
  __typename?: 'notification_provider_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Notification_Provider_Variance_Fields = {
  __typename?: 'notification_provider_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "notification_trigger" */
export type Notification_Trigger = {
  __typename?: 'notification_trigger';
  broadcast_time?: Maybe<Scalars['timestamptz']>;
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_triggered: Scalars['Boolean'];
  /** An object relationship */
  provider: Notification_Provider;
  provider_id: Scalars['Int'];
  provider_variables: Scalars['jsonb'];
  sent_by_id: Scalars['Int'];
  template_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  user_query_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "notification_trigger" */
export type Notification_TriggerConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_trigger" */
export type Notification_TriggerProvider_VariablesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_trigger" */
export type Notification_Trigger_Aggregate = {
  __typename?: 'notification_trigger_aggregate';
  aggregate?: Maybe<Notification_Trigger_Aggregate_Fields>;
  nodes: Array<Notification_Trigger>;
};

/** aggregate fields of "notification_trigger" */
export type Notification_Trigger_Aggregate_Fields = {
  __typename?: 'notification_trigger_aggregate_fields';
  avg?: Maybe<Notification_Trigger_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notification_Trigger_Max_Fields>;
  min?: Maybe<Notification_Trigger_Min_Fields>;
  stddev?: Maybe<Notification_Trigger_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Trigger_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Trigger_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Trigger_Sum_Fields>;
  var_pop?: Maybe<Notification_Trigger_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Trigger_Var_Samp_Fields>;
  variance?: Maybe<Notification_Trigger_Variance_Fields>;
};


/** aggregate fields of "notification_trigger" */
export type Notification_Trigger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Trigger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notification_Trigger_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  provider_variables?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Notification_Trigger_Avg_Fields = {
  __typename?: 'notification_trigger_avg_fields';
  id?: Maybe<Scalars['Float']>;
  provider_id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  user_query_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_trigger". All fields are combined with a logical 'AND'. */
export type Notification_Trigger_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Trigger_Bool_Exp>>;
  _not?: InputMaybe<Notification_Trigger_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Trigger_Bool_Exp>>;
  broadcast_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_triggered?: InputMaybe<Boolean_Comparison_Exp>;
  provider?: InputMaybe<Notification_Provider_Bool_Exp>;
  provider_id?: InputMaybe<Int_Comparison_Exp>;
  provider_variables?: InputMaybe<Jsonb_Comparison_Exp>;
  sent_by_id?: InputMaybe<Int_Comparison_Exp>;
  template_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_query_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_trigger" */
export enum Notification_Trigger_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTriggerPkey = 'notification_trigger_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notification_Trigger_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
  provider_variables?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notification_Trigger_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
  provider_variables?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notification_Trigger_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
  provider_variables?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification_trigger" */
export type Notification_Trigger_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['Int']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['Int']>;
  user_query_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification_trigger" */
export type Notification_Trigger_Insert_Input = {
  broadcast_time?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_triggered?: InputMaybe<Scalars['Boolean']>;
  provider?: InputMaybe<Notification_Provider_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['Int']>;
  provider_variables?: InputMaybe<Scalars['jsonb']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_query_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Notification_Trigger_Max_Fields = {
  __typename?: 'notification_trigger_max_fields';
  broadcast_time?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['Int']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_query_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Notification_Trigger_Min_Fields = {
  __typename?: 'notification_trigger_min_fields';
  broadcast_time?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['Int']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_query_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "notification_trigger" */
export type Notification_Trigger_Mutation_Response = {
  __typename?: 'notification_trigger_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Trigger>;
};

/** input type for inserting object relation for remote table "notification_trigger" */
export type Notification_Trigger_Obj_Rel_Insert_Input = {
  data: Notification_Trigger_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Trigger_On_Conflict>;
};

/** on_conflict condition type for table "notification_trigger" */
export type Notification_Trigger_On_Conflict = {
  constraint: Notification_Trigger_Constraint;
  update_columns?: Array<Notification_Trigger_Update_Column>;
  where?: InputMaybe<Notification_Trigger_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_trigger". */
export type Notification_Trigger_Order_By = {
  broadcast_time?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_triggered?: InputMaybe<Order_By>;
  provider?: InputMaybe<Notification_Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  provider_variables?: InputMaybe<Order_By>;
  sent_by_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_query_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_trigger */
export type Notification_Trigger_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notification_Trigger_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  provider_variables?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_trigger" */
export enum Notification_Trigger_Select_Column {
  /** column name */
  BroadcastTime = 'broadcast_time',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsTriggered = 'is_triggered',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderVariables = 'provider_variables',
  /** column name */
  SentById = 'sent_by_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQueryId = 'user_query_id'
}

/** input type for updating data in table "notification_trigger" */
export type Notification_Trigger_Set_Input = {
  broadcast_time?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_triggered?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['Int']>;
  provider_variables?: InputMaybe<Scalars['jsonb']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_query_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Notification_Trigger_Stddev_Fields = {
  __typename?: 'notification_trigger_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  provider_id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  user_query_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Notification_Trigger_Stddev_Pop_Fields = {
  __typename?: 'notification_trigger_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  provider_id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  user_query_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Notification_Trigger_Stddev_Samp_Fields = {
  __typename?: 'notification_trigger_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  provider_id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  user_query_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notification_trigger" */
export type Notification_Trigger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Trigger_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Trigger_Stream_Cursor_Value_Input = {
  broadcast_time?: InputMaybe<Scalars['timestamptz']>;
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_triggered?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['Int']>;
  provider_variables?: InputMaybe<Scalars['jsonb']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_query_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Notification_Trigger_Sum_Fields = {
  __typename?: 'notification_trigger_sum_fields';
  id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['Int']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['Int']>;
  user_query_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notification_trigger" */
export enum Notification_Trigger_Update_Column {
  /** column name */
  BroadcastTime = 'broadcast_time',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsTriggered = 'is_triggered',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderVariables = 'provider_variables',
  /** column name */
  SentById = 'sent_by_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserQueryId = 'user_query_id'
}

export type Notification_Trigger_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Notification_Trigger_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Notification_Trigger_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Notification_Trigger_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Notification_Trigger_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Trigger_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Notification_Trigger_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Trigger_Set_Input>;
  where: Notification_Trigger_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notification_Trigger_Var_Pop_Fields = {
  __typename?: 'notification_trigger_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  provider_id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  user_query_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Notification_Trigger_Var_Samp_Fields = {
  __typename?: 'notification_trigger_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  provider_id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  user_query_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Notification_Trigger_Variance_Fields = {
  __typename?: 'notification_trigger_variance_fields';
  id?: Maybe<Scalars['Float']>;
  provider_id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  user_query_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "offer_attachments" */
export type Offer_Attachments = {
  __typename?: 'offer_attachments';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  offer: Offers;
  offer_id: Scalars['bigint'];
  send_whatsapp: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "offer_attachments" */
export type Offer_Attachments_Aggregate = {
  __typename?: 'offer_attachments_aggregate';
  aggregate?: Maybe<Offer_Attachments_Aggregate_Fields>;
  nodes: Array<Offer_Attachments>;
};

/** aggregate fields of "offer_attachments" */
export type Offer_Attachments_Aggregate_Fields = {
  __typename?: 'offer_attachments_aggregate_fields';
  avg?: Maybe<Offer_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offer_Attachments_Max_Fields>;
  min?: Maybe<Offer_Attachments_Min_Fields>;
  stddev?: Maybe<Offer_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Offer_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offer_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Offer_Attachments_Sum_Fields>;
  var_pop?: Maybe<Offer_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Offer_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Offer_Attachments_Variance_Fields>;
};


/** aggregate fields of "offer_attachments" */
export type Offer_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offer_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offer_attachments" */
export type Offer_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Offer_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offer_Attachments_Max_Order_By>;
  min?: InputMaybe<Offer_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Offer_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offer_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offer_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offer_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Offer_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offer_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Offer_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Offer_Attachments_Avg_Fields = {
  __typename?: 'offer_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "offer_attachments" */
export type Offer_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offer_attachments". All fields are combined with a logical 'AND'. */
export type Offer_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Offer_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Offer_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Offer_Attachments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  offer?: InputMaybe<Offers_Bool_Exp>;
  offer_id?: InputMaybe<Bigint_Comparison_Exp>;
  send_whatsapp?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offer_Attachments_Max_Fields = {
  __typename?: 'offer_attachments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "offer_attachments" */
export type Offer_Attachments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offer_Attachments_Min_Fields = {
  __typename?: 'offer_attachments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "offer_attachments" */
export type Offer_Attachments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "offer_attachments". */
export type Offer_Attachments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer?: InputMaybe<Offers_Order_By>;
  offer_id?: InputMaybe<Order_By>;
  send_whatsapp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "offer_attachments" */
export enum Offer_Attachments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  SendWhatsapp = 'send_whatsapp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Offer_Attachments_Stddev_Fields = {
  __typename?: 'offer_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "offer_attachments" */
export type Offer_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offer_Attachments_Stddev_Pop_Fields = {
  __typename?: 'offer_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "offer_attachments" */
export type Offer_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offer_Attachments_Stddev_Samp_Fields = {
  __typename?: 'offer_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "offer_attachments" */
export type Offer_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offer_attachments" */
export type Offer_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offer_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offer_Attachments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  send_whatsapp?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Offer_Attachments_Sum_Fields = {
  __typename?: 'offer_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "offer_attachments" */
export type Offer_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Offer_Attachments_Var_Pop_Fields = {
  __typename?: 'offer_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "offer_attachments" */
export type Offer_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offer_Attachments_Var_Samp_Fields = {
  __typename?: 'offer_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "offer_attachments" */
export type Offer_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offer_Attachments_Variance_Fields = {
  __typename?: 'offer_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "offer_attachments" */
export type Offer_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "offer_enquiries" */
export type Offer_Enquiries = {
  __typename?: 'offer_enquiries';
  /** An object relationship */
  buyer?: Maybe<Setu_Trade_Shared_Entity>;
  /** An object relationship */
  buyer_external?: Maybe<Unregistered_User>;
  buyer_external_id?: Maybe<Scalars['bigint']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  offer: Offers;
  offer_id: Scalars['bigint'];
  status: Scalars['String'];
  /** An array relationship */
  status_logs: Array<Offer_Enquiry_Status_Log>;
  /** An aggregate relationship */
  status_logs_aggregate: Offer_Enquiry_Status_Log_Aggregate;
  /** An array relationship */
  twilio_messages: Array<Offer_Enquiries_Twilio_Message>;
  /** An aggregate relationship */
  twilio_messages_aggregate: Offer_Enquiries_Twilio_Message_Aggregate;
  updated_at: Scalars['timestamptz'];
  whatsapp_status: Scalars['String'];
};


/** columns and relationships of "offer_enquiries" */
export type Offer_EnquiriesStatus_LogsArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
};


/** columns and relationships of "offer_enquiries" */
export type Offer_EnquiriesStatus_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
};


/** columns and relationships of "offer_enquiries" */
export type Offer_EnquiriesTwilio_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
};


/** columns and relationships of "offer_enquiries" */
export type Offer_EnquiriesTwilio_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
};

/** aggregated selection of "offer_enquiries" */
export type Offer_Enquiries_Aggregate = {
  __typename?: 'offer_enquiries_aggregate';
  aggregate?: Maybe<Offer_Enquiries_Aggregate_Fields>;
  nodes: Array<Offer_Enquiries>;
};

/** aggregate fields of "offer_enquiries" */
export type Offer_Enquiries_Aggregate_Fields = {
  __typename?: 'offer_enquiries_aggregate_fields';
  avg?: Maybe<Offer_Enquiries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offer_Enquiries_Max_Fields>;
  min?: Maybe<Offer_Enquiries_Min_Fields>;
  stddev?: Maybe<Offer_Enquiries_Stddev_Fields>;
  stddev_pop?: Maybe<Offer_Enquiries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offer_Enquiries_Stddev_Samp_Fields>;
  sum?: Maybe<Offer_Enquiries_Sum_Fields>;
  var_pop?: Maybe<Offer_Enquiries_Var_Pop_Fields>;
  var_samp?: Maybe<Offer_Enquiries_Var_Samp_Fields>;
  variance?: Maybe<Offer_Enquiries_Variance_Fields>;
};


/** aggregate fields of "offer_enquiries" */
export type Offer_Enquiries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offer_Enquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offer_enquiries" */
export type Offer_Enquiries_Aggregate_Order_By = {
  avg?: InputMaybe<Offer_Enquiries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offer_Enquiries_Max_Order_By>;
  min?: InputMaybe<Offer_Enquiries_Min_Order_By>;
  stddev?: InputMaybe<Offer_Enquiries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offer_Enquiries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offer_Enquiries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offer_Enquiries_Sum_Order_By>;
  var_pop?: InputMaybe<Offer_Enquiries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offer_Enquiries_Var_Samp_Order_By>;
  variance?: InputMaybe<Offer_Enquiries_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Offer_Enquiries_Avg_Fields = {
  __typename?: 'offer_enquiries_avg_fields';
  buyer_external_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Avg_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offer_enquiries". All fields are combined with a logical 'AND'. */
export type Offer_Enquiries_Bool_Exp = {
  _and?: InputMaybe<Array<Offer_Enquiries_Bool_Exp>>;
  _not?: InputMaybe<Offer_Enquiries_Bool_Exp>;
  _or?: InputMaybe<Array<Offer_Enquiries_Bool_Exp>>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_external?: InputMaybe<Unregistered_User_Bool_Exp>;
  buyer_external_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  offer?: InputMaybe<Offers_Bool_Exp>;
  offer_id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_logs?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
  twilio_messages?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  whatsapp_status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offer_Enquiries_Max_Fields = {
  __typename?: 'offer_enquiries_max_fields';
  buyer_external_id?: Maybe<Scalars['bigint']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whatsapp_status?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Max_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whatsapp_status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offer_Enquiries_Min_Fields = {
  __typename?: 'offer_enquiries_min_fields';
  buyer_external_id?: Maybe<Scalars['bigint']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whatsapp_status?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Min_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whatsapp_status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "offer_enquiries". */
export type Offer_Enquiries_Order_By = {
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_external?: InputMaybe<Unregistered_User_Order_By>;
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer?: InputMaybe<Offers_Order_By>;
  offer_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_logs_aggregate?: InputMaybe<Offer_Enquiry_Status_Log_Aggregate_Order_By>;
  twilio_messages_aggregate?: InputMaybe<Offer_Enquiries_Twilio_Message_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  whatsapp_status?: InputMaybe<Order_By>;
};

/** select columns of table "offer_enquiries" */
export enum Offer_Enquiries_Select_Column {
  /** column name */
  BuyerExternalId = 'buyer_external_id',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhatsappStatus = 'whatsapp_status'
}

/** aggregate stddev on columns */
export type Offer_Enquiries_Stddev_Fields = {
  __typename?: 'offer_enquiries_stddev_fields';
  buyer_external_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Stddev_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offer_Enquiries_Stddev_Pop_Fields = {
  __typename?: 'offer_enquiries_stddev_pop_fields';
  buyer_external_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Stddev_Pop_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offer_Enquiries_Stddev_Samp_Fields = {
  __typename?: 'offer_enquiries_stddev_samp_fields';
  buyer_external_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Stddev_Samp_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offer_enquiries" */
export type Offer_Enquiries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offer_Enquiries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offer_Enquiries_Stream_Cursor_Value_Input = {
  buyer_external_id?: InputMaybe<Scalars['bigint']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  whatsapp_status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Offer_Enquiries_Sum_Fields = {
  __typename?: 'offer_enquiries_sum_fields';
  buyer_external_id?: Maybe<Scalars['bigint']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Sum_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message = {
  __typename?: 'offer_enquiries_twilio_message';
  id: Scalars['bigint'];
  offerenquiry_id: Scalars['bigint'];
  /** An object relationship */
  trade_twiliomessage: Trade_Twiliomessages;
  twiliomessages_id: Scalars['String'];
};

/** aggregated selection of "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Aggregate = {
  __typename?: 'offer_enquiries_twilio_message_aggregate';
  aggregate?: Maybe<Offer_Enquiries_Twilio_Message_Aggregate_Fields>;
  nodes: Array<Offer_Enquiries_Twilio_Message>;
};

/** aggregate fields of "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Aggregate_Fields = {
  __typename?: 'offer_enquiries_twilio_message_aggregate_fields';
  avg?: Maybe<Offer_Enquiries_Twilio_Message_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offer_Enquiries_Twilio_Message_Max_Fields>;
  min?: Maybe<Offer_Enquiries_Twilio_Message_Min_Fields>;
  stddev?: Maybe<Offer_Enquiries_Twilio_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Offer_Enquiries_Twilio_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offer_Enquiries_Twilio_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Offer_Enquiries_Twilio_Message_Sum_Fields>;
  var_pop?: Maybe<Offer_Enquiries_Twilio_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Offer_Enquiries_Twilio_Message_Var_Samp_Fields>;
  variance?: Maybe<Offer_Enquiries_Twilio_Message_Variance_Fields>;
};


/** aggregate fields of "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Aggregate_Order_By = {
  avg?: InputMaybe<Offer_Enquiries_Twilio_Message_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offer_Enquiries_Twilio_Message_Max_Order_By>;
  min?: InputMaybe<Offer_Enquiries_Twilio_Message_Min_Order_By>;
  stddev?: InputMaybe<Offer_Enquiries_Twilio_Message_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offer_Enquiries_Twilio_Message_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offer_Enquiries_Twilio_Message_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offer_Enquiries_Twilio_Message_Sum_Order_By>;
  var_pop?: InputMaybe<Offer_Enquiries_Twilio_Message_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offer_Enquiries_Twilio_Message_Var_Samp_Order_By>;
  variance?: InputMaybe<Offer_Enquiries_Twilio_Message_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Offer_Enquiries_Twilio_Message_Avg_Fields = {
  __typename?: 'offer_enquiries_twilio_message_avg_fields';
  id?: Maybe<Scalars['Float']>;
  offerenquiry_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offer_enquiries_twilio_message". All fields are combined with a logical 'AND'. */
export type Offer_Enquiries_Twilio_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Bool_Exp>>;
  _not?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  offerenquiry_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade_twiliomessage?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
  twiliomessages_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offer_Enquiries_Twilio_Message_Max_Fields = {
  __typename?: 'offer_enquiries_twilio_message_max_fields';
  id?: Maybe<Scalars['bigint']>;
  offerenquiry_id?: Maybe<Scalars['bigint']>;
  twiliomessages_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
  twiliomessages_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offer_Enquiries_Twilio_Message_Min_Fields = {
  __typename?: 'offer_enquiries_twilio_message_min_fields';
  id?: Maybe<Scalars['bigint']>;
  offerenquiry_id?: Maybe<Scalars['bigint']>;
  twiliomessages_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
  twiliomessages_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "offer_enquiries_twilio_message". */
export type Offer_Enquiries_Twilio_Message_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
  trade_twiliomessage?: InputMaybe<Trade_Twiliomessages_Order_By>;
  twiliomessages_id?: InputMaybe<Order_By>;
};

/** select columns of table "offer_enquiries_twilio_message" */
export enum Offer_Enquiries_Twilio_Message_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OfferenquiryId = 'offerenquiry_id',
  /** column name */
  TwiliomessagesId = 'twiliomessages_id'
}

/** aggregate stddev on columns */
export type Offer_Enquiries_Twilio_Message_Stddev_Fields = {
  __typename?: 'offer_enquiries_twilio_message_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  offerenquiry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offer_Enquiries_Twilio_Message_Stddev_Pop_Fields = {
  __typename?: 'offer_enquiries_twilio_message_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offerenquiry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offer_Enquiries_Twilio_Message_Stddev_Samp_Fields = {
  __typename?: 'offer_enquiries_twilio_message_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offerenquiry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offer_Enquiries_Twilio_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offer_Enquiries_Twilio_Message_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  offerenquiry_id?: InputMaybe<Scalars['bigint']>;
  twiliomessages_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Offer_Enquiries_Twilio_Message_Sum_Fields = {
  __typename?: 'offer_enquiries_twilio_message_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  offerenquiry_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Offer_Enquiries_Twilio_Message_Var_Pop_Fields = {
  __typename?: 'offer_enquiries_twilio_message_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offerenquiry_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offer_Enquiries_Twilio_Message_Var_Samp_Fields = {
  __typename?: 'offer_enquiries_twilio_message_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offerenquiry_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offer_Enquiries_Twilio_Message_Variance_Fields = {
  __typename?: 'offer_enquiries_twilio_message_variance_fields';
  id?: Maybe<Scalars['Float']>;
  offerenquiry_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "offer_enquiries_twilio_message" */
export type Offer_Enquiries_Twilio_Message_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  offerenquiry_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Offer_Enquiries_Var_Pop_Fields = {
  __typename?: 'offer_enquiries_var_pop_fields';
  buyer_external_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Var_Pop_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offer_Enquiries_Var_Samp_Fields = {
  __typename?: 'offer_enquiries_var_samp_fields';
  buyer_external_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Var_Samp_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offer_Enquiries_Variance_Fields = {
  __typename?: 'offer_enquiries_variance_fields';
  buyer_external_id?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "offer_enquiries" */
export type Offer_Enquiries_Variance_Order_By = {
  buyer_external_id?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log = {
  __typename?: 'offer_enquiry_status_log';
  created_at: Scalars['timestamptz'];
  from_status?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  offer_enquiry: Offer_Enquiries;
  offer_enquiry_id: Scalars['bigint'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Aggregate = {
  __typename?: 'offer_enquiry_status_log_aggregate';
  aggregate?: Maybe<Offer_Enquiry_Status_Log_Aggregate_Fields>;
  nodes: Array<Offer_Enquiry_Status_Log>;
};

/** aggregate fields of "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Aggregate_Fields = {
  __typename?: 'offer_enquiry_status_log_aggregate_fields';
  avg?: Maybe<Offer_Enquiry_Status_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offer_Enquiry_Status_Log_Max_Fields>;
  min?: Maybe<Offer_Enquiry_Status_Log_Min_Fields>;
  stddev?: Maybe<Offer_Enquiry_Status_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Offer_Enquiry_Status_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offer_Enquiry_Status_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Offer_Enquiry_Status_Log_Sum_Fields>;
  var_pop?: Maybe<Offer_Enquiry_Status_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Offer_Enquiry_Status_Log_Var_Samp_Fields>;
  variance?: Maybe<Offer_Enquiry_Status_Log_Variance_Fields>;
};


/** aggregate fields of "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offer_Enquiry_Status_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Offer_Enquiry_Status_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offer_Enquiry_Status_Log_Max_Order_By>;
  min?: InputMaybe<Offer_Enquiry_Status_Log_Min_Order_By>;
  stddev?: InputMaybe<Offer_Enquiry_Status_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offer_Enquiry_Status_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offer_Enquiry_Status_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offer_Enquiry_Status_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Offer_Enquiry_Status_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offer_Enquiry_Status_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Offer_Enquiry_Status_Log_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Offer_Enquiry_Status_Log_Avg_Fields = {
  __typename?: 'offer_enquiry_status_log_avg_fields';
  id?: Maybe<Scalars['Float']>;
  offer_enquiry_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offer_enquiry_status_log". All fields are combined with a logical 'AND'. */
export type Offer_Enquiry_Status_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Offer_Enquiry_Status_Log_Bool_Exp>>;
  _not?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Offer_Enquiry_Status_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from_status?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  offer_enquiry?: InputMaybe<Offer_Enquiries_Bool_Exp>;
  offer_enquiry_id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offer_Enquiry_Status_Log_Max_Fields = {
  __typename?: 'offer_enquiry_status_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  from_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  offer_enquiry_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offer_Enquiry_Status_Log_Min_Fields = {
  __typename?: 'offer_enquiry_status_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  from_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  offer_enquiry_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "offer_enquiry_status_log". */
export type Offer_Enquiry_Status_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_enquiry?: InputMaybe<Offer_Enquiries_Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "offer_enquiry_status_log" */
export enum Offer_Enquiry_Status_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FromStatus = 'from_status',
  /** column name */
  Id = 'id',
  /** column name */
  OfferEnquiryId = 'offer_enquiry_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Offer_Enquiry_Status_Log_Stddev_Fields = {
  __typename?: 'offer_enquiry_status_log_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  offer_enquiry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offer_Enquiry_Status_Log_Stddev_Pop_Fields = {
  __typename?: 'offer_enquiry_status_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_enquiry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offer_Enquiry_Status_Log_Stddev_Samp_Fields = {
  __typename?: 'offer_enquiry_status_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_enquiry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offer_Enquiry_Status_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offer_Enquiry_Status_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  offer_enquiry_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Offer_Enquiry_Status_Log_Sum_Fields = {
  __typename?: 'offer_enquiry_status_log_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  offer_enquiry_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Offer_Enquiry_Status_Log_Var_Pop_Fields = {
  __typename?: 'offer_enquiry_status_log_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_enquiry_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offer_Enquiry_Status_Log_Var_Samp_Fields = {
  __typename?: 'offer_enquiry_status_log_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_enquiry_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offer_Enquiry_Status_Log_Variance_Fields = {
  __typename?: 'offer_enquiry_status_log_variance_fields';
  id?: Maybe<Scalars['Float']>;
  offer_enquiry_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "offer_enquiry_status_log" */
export type Offer_Enquiry_Status_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_enquiry_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "offer_expense" */
export type Offer_Expense = {
  __typename?: 'offer_expense';
  amount?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  expense_parameter: Expense_Parameter;
  expense_parameter_id: Scalars['bigint'];
  id: Scalars['bigint'];
  kind: Scalars['String'];
  /** An object relationship */
  offer?: Maybe<Offers>;
  offer_id?: Maybe<Scalars['bigint']>;
  paid_by: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['numeric'];
};

/** aggregated selection of "offer_expense" */
export type Offer_Expense_Aggregate = {
  __typename?: 'offer_expense_aggregate';
  aggregate?: Maybe<Offer_Expense_Aggregate_Fields>;
  nodes: Array<Offer_Expense>;
};

/** aggregate fields of "offer_expense" */
export type Offer_Expense_Aggregate_Fields = {
  __typename?: 'offer_expense_aggregate_fields';
  avg?: Maybe<Offer_Expense_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offer_Expense_Max_Fields>;
  min?: Maybe<Offer_Expense_Min_Fields>;
  stddev?: Maybe<Offer_Expense_Stddev_Fields>;
  stddev_pop?: Maybe<Offer_Expense_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offer_Expense_Stddev_Samp_Fields>;
  sum?: Maybe<Offer_Expense_Sum_Fields>;
  var_pop?: Maybe<Offer_Expense_Var_Pop_Fields>;
  var_samp?: Maybe<Offer_Expense_Var_Samp_Fields>;
  variance?: Maybe<Offer_Expense_Variance_Fields>;
};


/** aggregate fields of "offer_expense" */
export type Offer_Expense_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offer_Expense_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offer_expense" */
export type Offer_Expense_Aggregate_Order_By = {
  avg?: InputMaybe<Offer_Expense_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offer_Expense_Max_Order_By>;
  min?: InputMaybe<Offer_Expense_Min_Order_By>;
  stddev?: InputMaybe<Offer_Expense_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offer_Expense_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offer_Expense_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offer_Expense_Sum_Order_By>;
  var_pop?: InputMaybe<Offer_Expense_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offer_Expense_Var_Samp_Order_By>;
  variance?: InputMaybe<Offer_Expense_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Offer_Expense_Avg_Fields = {
  __typename?: 'offer_expense_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "offer_expense" */
export type Offer_Expense_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offer_expense". All fields are combined with a logical 'AND'. */
export type Offer_Expense_Bool_Exp = {
  _and?: InputMaybe<Array<Offer_Expense_Bool_Exp>>;
  _not?: InputMaybe<Offer_Expense_Bool_Exp>;
  _or?: InputMaybe<Array<Offer_Expense_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  expense_parameter?: InputMaybe<Expense_Parameter_Bool_Exp>;
  expense_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  offer?: InputMaybe<Offers_Bool_Exp>;
  offer_id?: InputMaybe<Bigint_Comparison_Exp>;
  paid_by?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offer_Expense_Max_Fields = {
  __typename?: 'offer_expense_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['bigint']>;
  paid_by?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "offer_expense" */
export type Offer_Expense_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offer_Expense_Min_Fields = {
  __typename?: 'offer_expense_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['bigint']>;
  paid_by?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "offer_expense" */
export type Offer_Expense_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "offer_expense". */
export type Offer_Expense_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  expense_parameter?: InputMaybe<Expense_Parameter_Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  offer?: InputMaybe<Offers_Order_By>;
  offer_id?: InputMaybe<Order_By>;
  paid_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "offer_expense" */
export enum Offer_Expense_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  ExpenseParameterId = 'expense_parameter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  PaidBy = 'paid_by',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Offer_Expense_Stddev_Fields = {
  __typename?: 'offer_expense_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "offer_expense" */
export type Offer_Expense_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offer_Expense_Stddev_Pop_Fields = {
  __typename?: 'offer_expense_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "offer_expense" */
export type Offer_Expense_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offer_Expense_Stddev_Samp_Fields = {
  __typename?: 'offer_expense_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "offer_expense" */
export type Offer_Expense_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offer_expense" */
export type Offer_Expense_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offer_Expense_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offer_Expense_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  expense_parameter_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  paid_by?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Offer_Expense_Sum_Fields = {
  __typename?: 'offer_expense_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  expense_parameter_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "offer_expense" */
export type Offer_Expense_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Offer_Expense_Var_Pop_Fields = {
  __typename?: 'offer_expense_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "offer_expense" */
export type Offer_Expense_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offer_Expense_Var_Samp_Fields = {
  __typename?: 'offer_expense_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "offer_expense" */
export type Offer_Expense_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offer_Expense_Variance_Fields = {
  __typename?: 'offer_expense_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  expense_parameter_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "offer_expense" */
export type Offer_Expense_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  expense_parameter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "offer_order_picked" */
export type Offer_Order_Picked = {
  __typename?: 'offer_order_picked';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  offer_storage_picked: Offer_Storage_Picked;
  offer_storage_picked_id: Scalars['bigint'];
  quantity: Scalars['float8'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "offer_order_picked" */
export type Offer_Order_Picked_Aggregate = {
  __typename?: 'offer_order_picked_aggregate';
  aggregate?: Maybe<Offer_Order_Picked_Aggregate_Fields>;
  nodes: Array<Offer_Order_Picked>;
};

/** aggregate fields of "offer_order_picked" */
export type Offer_Order_Picked_Aggregate_Fields = {
  __typename?: 'offer_order_picked_aggregate_fields';
  avg?: Maybe<Offer_Order_Picked_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offer_Order_Picked_Max_Fields>;
  min?: Maybe<Offer_Order_Picked_Min_Fields>;
  stddev?: Maybe<Offer_Order_Picked_Stddev_Fields>;
  stddev_pop?: Maybe<Offer_Order_Picked_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offer_Order_Picked_Stddev_Samp_Fields>;
  sum?: Maybe<Offer_Order_Picked_Sum_Fields>;
  var_pop?: Maybe<Offer_Order_Picked_Var_Pop_Fields>;
  var_samp?: Maybe<Offer_Order_Picked_Var_Samp_Fields>;
  variance?: Maybe<Offer_Order_Picked_Variance_Fields>;
};


/** aggregate fields of "offer_order_picked" */
export type Offer_Order_Picked_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offer_Order_Picked_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Offer_Order_Picked_Avg_Fields = {
  __typename?: 'offer_order_picked_avg_fields';
  id?: Maybe<Scalars['Float']>;
  offer_storage_picked_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "offer_order_picked". All fields are combined with a logical 'AND'. */
export type Offer_Order_Picked_Bool_Exp = {
  _and?: InputMaybe<Array<Offer_Order_Picked_Bool_Exp>>;
  _not?: InputMaybe<Offer_Order_Picked_Bool_Exp>;
  _or?: InputMaybe<Array<Offer_Order_Picked_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  offer_storage_picked?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
  offer_storage_picked_id?: InputMaybe<Bigint_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offer_Order_Picked_Max_Fields = {
  __typename?: 'offer_order_picked_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  offer_storage_picked_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Offer_Order_Picked_Min_Fields = {
  __typename?: 'offer_order_picked_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  offer_storage_picked_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "offer_order_picked". */
export type Offer_Order_Picked_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_storage_picked?: InputMaybe<Offer_Storage_Picked_Order_By>;
  offer_storage_picked_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "offer_order_picked" */
export enum Offer_Order_Picked_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OfferStoragePickedId = 'offer_storage_picked_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Offer_Order_Picked_Stddev_Fields = {
  __typename?: 'offer_order_picked_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  offer_storage_picked_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Offer_Order_Picked_Stddev_Pop_Fields = {
  __typename?: 'offer_order_picked_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_storage_picked_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Offer_Order_Picked_Stddev_Samp_Fields = {
  __typename?: 'offer_order_picked_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_storage_picked_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "offer_order_picked" */
export type Offer_Order_Picked_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offer_Order_Picked_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offer_Order_Picked_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  offer_storage_picked_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['float8']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Offer_Order_Picked_Sum_Fields = {
  __typename?: 'offer_order_picked_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  offer_storage_picked_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Offer_Order_Picked_Var_Pop_Fields = {
  __typename?: 'offer_order_picked_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_storage_picked_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Offer_Order_Picked_Var_Samp_Fields = {
  __typename?: 'offer_order_picked_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_storage_picked_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Offer_Order_Picked_Variance_Fields = {
  __typename?: 'offer_order_picked_variance_fields';
  id?: Maybe<Scalars['Float']>;
  offer_storage_picked_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "offer_storage_picked" */
export type Offer_Storage_Picked = {
  __typename?: 'offer_storage_picked';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  offer: Offers;
  offer_id: Scalars['bigint'];
  quantity: Scalars['float8'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "offer_storage_picked" */
export type Offer_Storage_Picked_Aggregate = {
  __typename?: 'offer_storage_picked_aggregate';
  aggregate?: Maybe<Offer_Storage_Picked_Aggregate_Fields>;
  nodes: Array<Offer_Storage_Picked>;
};

/** aggregate fields of "offer_storage_picked" */
export type Offer_Storage_Picked_Aggregate_Fields = {
  __typename?: 'offer_storage_picked_aggregate_fields';
  avg?: Maybe<Offer_Storage_Picked_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offer_Storage_Picked_Max_Fields>;
  min?: Maybe<Offer_Storage_Picked_Min_Fields>;
  stddev?: Maybe<Offer_Storage_Picked_Stddev_Fields>;
  stddev_pop?: Maybe<Offer_Storage_Picked_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offer_Storage_Picked_Stddev_Samp_Fields>;
  sum?: Maybe<Offer_Storage_Picked_Sum_Fields>;
  var_pop?: Maybe<Offer_Storage_Picked_Var_Pop_Fields>;
  var_samp?: Maybe<Offer_Storage_Picked_Var_Samp_Fields>;
  variance?: Maybe<Offer_Storage_Picked_Variance_Fields>;
};


/** aggregate fields of "offer_storage_picked" */
export type Offer_Storage_Picked_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offer_Storage_Picked_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offer_storage_picked" */
export type Offer_Storage_Picked_Aggregate_Order_By = {
  avg?: InputMaybe<Offer_Storage_Picked_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offer_Storage_Picked_Max_Order_By>;
  min?: InputMaybe<Offer_Storage_Picked_Min_Order_By>;
  stddev?: InputMaybe<Offer_Storage_Picked_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offer_Storage_Picked_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offer_Storage_Picked_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offer_Storage_Picked_Sum_Order_By>;
  var_pop?: InputMaybe<Offer_Storage_Picked_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offer_Storage_Picked_Var_Samp_Order_By>;
  variance?: InputMaybe<Offer_Storage_Picked_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Offer_Storage_Picked_Avg_Fields = {
  __typename?: 'offer_storage_picked_avg_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offer_storage_picked". All fields are combined with a logical 'AND'. */
export type Offer_Storage_Picked_Bool_Exp = {
  _and?: InputMaybe<Array<Offer_Storage_Picked_Bool_Exp>>;
  _not?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
  _or?: InputMaybe<Array<Offer_Storage_Picked_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  offer?: InputMaybe<Offers_Bool_Exp>;
  offer_id?: InputMaybe<Bigint_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offer_Storage_Picked_Max_Fields = {
  __typename?: 'offer_storage_picked_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offer_Storage_Picked_Min_Fields = {
  __typename?: 'offer_storage_picked_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "offer_storage_picked". */
export type Offer_Storage_Picked_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  offer?: InputMaybe<Offers_Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "offer_storage_picked" */
export enum Offer_Storage_Picked_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Offer_Storage_Picked_Stddev_Fields = {
  __typename?: 'offer_storage_picked_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offer_Storage_Picked_Stddev_Pop_Fields = {
  __typename?: 'offer_storage_picked_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offer_Storage_Picked_Stddev_Samp_Fields = {
  __typename?: 'offer_storage_picked_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offer_storage_picked" */
export type Offer_Storage_Picked_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offer_Storage_Picked_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offer_Storage_Picked_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['float8']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Offer_Storage_Picked_Sum_Fields = {
  __typename?: 'offer_storage_picked_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Offer_Storage_Picked_Var_Pop_Fields = {
  __typename?: 'offer_storage_picked_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offer_Storage_Picked_Var_Samp_Fields = {
  __typename?: 'offer_storage_picked_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offer_Storage_Picked_Variance_Fields = {
  __typename?: 'offer_storage_picked_variance_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "offer_storage_picked" */
export type Offer_Storage_Picked_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "offers" */
export type Offers = {
  __typename?: 'offers';
  buyer_expense: Scalars['float8'];
  /** An object relationship */
  buyer_file?: Maybe<Setutrade_Media>;
  buyer_file_id?: Maybe<Scalars['bigint']>;
  buyer_source_kind: Scalars['String'];
  buyer_tnc?: Maybe<Scalars['String']>;
  /** An object relationship */
  commodity: Setu_Trade_Shared_Entity;
  commodity_id: Scalars['bigint'];
  /** An object relationship */
  commodity_variety?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  deducted_amount: Scalars['float8'];
  /** An object relationship */
  department?: Maybe<Setu_Trade_Shared_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date_time: Scalars['timestamptz'];
  /** An object relationship */
  facilitator?: Maybe<Setu_Trade_Shared_Entity>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  /** An object relationship */
  jr_officer?: Maybe<Setu_Trade_Shared_Entity>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['float8']>;
  mode: Scalars['String'];
  /** An array relationship */
  offer_attachments: Array<Offer_Attachments>;
  /** An aggregate relationship */
  offer_attachments_aggregate: Offer_Attachments_Aggregate;
  /** An array relationship */
  offer_enquiries: Array<Offer_Enquiries>;
  /** An aggregate relationship */
  offer_enquiries_aggregate: Offer_Enquiries_Aggregate;
  /** An array relationship */
  offer_expenses: Array<Offer_Expense>;
  /** An aggregate relationship */
  offer_expenses_aggregate: Offer_Expense_Aggregate;
  /** An array relationship */
  offer_storage_pickeds: Array<Offer_Storage_Picked>;
  /** An aggregate relationship */
  offer_storage_pickeds_aggregate: Offer_Storage_Picked_Aggregate;
  /** An array relationship */
  offers_buyer_groups: Array<Offers_Buyer_Groups>;
  /** An aggregate relationship */
  offers_buyer_groups_aggregate: Offers_Buyer_Groups_Aggregate;
  packaging: Scalars['String'];
  /** An object relationship */
  plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  quantity: Scalars['float8'];
  quantity_kg?: Maybe<Scalars['float8']>;
  /** An object relationship */
  quantity_unit?: Maybe<Setu_Trade_Shared_Entity>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate: Scalars['float8'];
  /** An object relationship */
  rate_unit: Setu_Trade_Shared_Entity;
  rate_unit_id: Scalars['bigint'];
  /** An object relationship */
  seller?: Maybe<Setu_Trade_Shared_Entity>;
  seller_expense: Scalars['float8'];
  seller_id?: Maybe<Scalars['bigint']>;
  seller_tnc?: Maybe<Scalars['String']>;
  /** An object relationship */
  sr_officer?: Maybe<Setu_Trade_Shared_Entity>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction: Scalars['float8'];
  start_date_time: Scalars['timestamptz'];
  status: Scalars['String'];
  total_amount: Scalars['float8'];
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  variety_grade?: Maybe<Setu_Trade_Shared_Entity>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "offers" */
export type OffersOffer_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Offer_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Attachments_Order_By>>;
  where?: InputMaybe<Offer_Attachments_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffer_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Attachments_Order_By>>;
  where?: InputMaybe<Offer_Attachments_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffer_EnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffer_Enquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffer_ExpensesArgs = {
  distinct_on?: InputMaybe<Array<Offer_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Expense_Order_By>>;
  where?: InputMaybe<Offer_Expense_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffer_Expenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Expense_Order_By>>;
  where?: InputMaybe<Offer_Expense_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffer_Storage_PickedsArgs = {
  distinct_on?: InputMaybe<Array<Offer_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Storage_Picked_Order_By>>;
  where?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffer_Storage_Pickeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Storage_Picked_Order_By>>;
  where?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffers_Buyer_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Offers_Buyer_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Buyer_Groups_Order_By>>;
  where?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersOffers_Buyer_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Buyer_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Buyer_Groups_Order_By>>;
  where?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "offers" */
export type OffersTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** aggregated selection of "offers" */
export type Offers_Aggregate = {
  __typename?: 'offers_aggregate';
  aggregate?: Maybe<Offers_Aggregate_Fields>;
  nodes: Array<Offers>;
};

/** aggregate fields of "offers" */
export type Offers_Aggregate_Fields = {
  __typename?: 'offers_aggregate_fields';
  avg?: Maybe<Offers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offers_Max_Fields>;
  min?: Maybe<Offers_Min_Fields>;
  stddev?: Maybe<Offers_Stddev_Fields>;
  stddev_pop?: Maybe<Offers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offers_Stddev_Samp_Fields>;
  sum?: Maybe<Offers_Sum_Fields>;
  var_pop?: Maybe<Offers_Var_Pop_Fields>;
  var_samp?: Maybe<Offers_Var_Samp_Fields>;
  variance?: Maybe<Offers_Variance_Fields>;
};


/** aggregate fields of "offers" */
export type Offers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Offers_Avg_Fields = {
  __typename?: 'offers_avg_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_file_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "offers". All fields are combined with a logical 'AND'. */
export type Offers_Bool_Exp = {
  _and?: InputMaybe<Array<Offers_Bool_Exp>>;
  _not?: InputMaybe<Offers_Bool_Exp>;
  _or?: InputMaybe<Array<Offers_Bool_Exp>>;
  buyer_expense?: InputMaybe<Float8_Comparison_Exp>;
  buyer_file?: InputMaybe<Setutrade_Media_Bool_Exp>;
  buyer_file_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_source_kind?: InputMaybe<String_Comparison_Exp>;
  buyer_tnc?: InputMaybe<String_Comparison_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  deducted_amount?: InputMaybe<Float8_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  end_date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  facilitator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  jr_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  material_kind?: InputMaybe<String_Comparison_Exp>;
  max_rate?: InputMaybe<Float8_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  offer_attachments?: InputMaybe<Offer_Attachments_Bool_Exp>;
  offer_enquiries?: InputMaybe<Offer_Enquiries_Bool_Exp>;
  offer_expenses?: InputMaybe<Offer_Expense_Bool_Exp>;
  offer_storage_pickeds?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
  offers_buyer_groups?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
  packaging?: InputMaybe<String_Comparison_Exp>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quantity_kg?: InputMaybe<Float8_Comparison_Exp>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  rate?: InputMaybe<Float8_Comparison_Exp>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  rate_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  seller_expense?: InputMaybe<Float8_Comparison_Exp>;
  seller_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_tnc?: InputMaybe<String_Comparison_Exp>;
  sr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  sr_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  standard_deduction?: InputMaybe<Float8_Comparison_Exp>;
  start_date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Float8_Comparison_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  variety_grade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "offers_buyer_groups" */
export type Offers_Buyer_Groups = {
  __typename?: 'offers_buyer_groups';
  /** An object relationship */
  buyer_groups: Setu_Trade_Shared_Entity;
  id: Scalars['bigint'];
  /** An object relationship */
  offer: Offers;
  offer_id: Scalars['bigint'];
  sharedentity_id: Scalars['bigint'];
};

/** aggregated selection of "offers_buyer_groups" */
export type Offers_Buyer_Groups_Aggregate = {
  __typename?: 'offers_buyer_groups_aggregate';
  aggregate?: Maybe<Offers_Buyer_Groups_Aggregate_Fields>;
  nodes: Array<Offers_Buyer_Groups>;
};

/** aggregate fields of "offers_buyer_groups" */
export type Offers_Buyer_Groups_Aggregate_Fields = {
  __typename?: 'offers_buyer_groups_aggregate_fields';
  avg?: Maybe<Offers_Buyer_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offers_Buyer_Groups_Max_Fields>;
  min?: Maybe<Offers_Buyer_Groups_Min_Fields>;
  stddev?: Maybe<Offers_Buyer_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Offers_Buyer_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offers_Buyer_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Offers_Buyer_Groups_Sum_Fields>;
  var_pop?: Maybe<Offers_Buyer_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Offers_Buyer_Groups_Var_Samp_Fields>;
  variance?: Maybe<Offers_Buyer_Groups_Variance_Fields>;
};


/** aggregate fields of "offers_buyer_groups" */
export type Offers_Buyer_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offers_Buyer_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Aggregate_Order_By = {
  avg?: InputMaybe<Offers_Buyer_Groups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offers_Buyer_Groups_Max_Order_By>;
  min?: InputMaybe<Offers_Buyer_Groups_Min_Order_By>;
  stddev?: InputMaybe<Offers_Buyer_Groups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offers_Buyer_Groups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offers_Buyer_Groups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offers_Buyer_Groups_Sum_Order_By>;
  var_pop?: InputMaybe<Offers_Buyer_Groups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offers_Buyer_Groups_Var_Samp_Order_By>;
  variance?: InputMaybe<Offers_Buyer_Groups_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Offers_Buyer_Groups_Avg_Fields = {
  __typename?: 'offers_buyer_groups_avg_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offers_buyer_groups". All fields are combined with a logical 'AND'. */
export type Offers_Buyer_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Offers_Buyer_Groups_Bool_Exp>>;
  _not?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Offers_Buyer_Groups_Bool_Exp>>;
  buyer_groups?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  offer?: InputMaybe<Offers_Bool_Exp>;
  offer_id?: InputMaybe<Bigint_Comparison_Exp>;
  sharedentity_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Offers_Buyer_Groups_Max_Fields = {
  __typename?: 'offers_buyer_groups_max_fields';
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offers_Buyer_Groups_Min_Fields = {
  __typename?: 'offers_buyer_groups_min_fields';
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "offers_buyer_groups". */
export type Offers_Buyer_Groups_Order_By = {
  buyer_groups?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  id?: InputMaybe<Order_By>;
  offer?: InputMaybe<Offers_Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** select columns of table "offers_buyer_groups" */
export enum Offers_Buyer_Groups_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  SharedentityId = 'sharedentity_id'
}

/** aggregate stddev on columns */
export type Offers_Buyer_Groups_Stddev_Fields = {
  __typename?: 'offers_buyer_groups_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offers_Buyer_Groups_Stddev_Pop_Fields = {
  __typename?: 'offers_buyer_groups_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offers_Buyer_Groups_Stddev_Samp_Fields = {
  __typename?: 'offers_buyer_groups_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offers_Buyer_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offers_Buyer_Groups_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  sharedentity_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Offers_Buyer_Groups_Sum_Fields = {
  __typename?: 'offers_buyer_groups_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Offers_Buyer_Groups_Var_Pop_Fields = {
  __typename?: 'offers_buyer_groups_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offers_Buyer_Groups_Var_Samp_Fields = {
  __typename?: 'offers_buyer_groups_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offers_Buyer_Groups_Variance_Fields = {
  __typename?: 'offers_buyer_groups_variance_fields';
  id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "offers_buyer_groups" */
export type Offers_Buyer_Groups_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Offers_Max_Fields = {
  __typename?: 'offers_max_fields';
  buyer_expense?: Maybe<Scalars['float8']>;
  buyer_file_id?: Maybe<Scalars['bigint']>;
  buyer_source_kind?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['float8']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date_time?: Maybe<Scalars['timestamptz']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['float8']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_kg?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['float8']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  seller_expense?: Maybe<Scalars['float8']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_tnc?: Maybe<Scalars['String']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['float8']>;
  start_date_time?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Offers_Min_Fields = {
  __typename?: 'offers_min_fields';
  buyer_expense?: Maybe<Scalars['float8']>;
  buyer_file_id?: Maybe<Scalars['bigint']>;
  buyer_source_kind?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['float8']>;
  department_id?: Maybe<Scalars['bigint']>;
  end_date_time?: Maybe<Scalars['timestamptz']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  material_kind?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['float8']>;
  mode?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_kg?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['float8']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  seller_expense?: Maybe<Scalars['float8']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_tnc?: Maybe<Scalars['String']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['float8']>;
  start_date_time?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "offers" */
export type Offers_Mutation_Response = {
  __typename?: 'offers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Offers>;
};

/** Ordering options when selecting data from "offers". */
export type Offers_Order_By = {
  buyer_expense?: InputMaybe<Order_By>;
  buyer_file?: InputMaybe<Setutrade_Media_Order_By>;
  buyer_file_id?: InputMaybe<Order_By>;
  buyer_source_kind?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  end_date_time?: InputMaybe<Order_By>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  jr_officer_id?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  offer_attachments_aggregate?: InputMaybe<Offer_Attachments_Aggregate_Order_By>;
  offer_enquiries_aggregate?: InputMaybe<Offer_Enquiries_Aggregate_Order_By>;
  offer_expenses_aggregate?: InputMaybe<Offer_Expense_Aggregate_Order_By>;
  offer_storage_pickeds_aggregate?: InputMaybe<Offer_Storage_Picked_Aggregate_Order_By>;
  offers_buyer_groups_aggregate?: InputMaybe<Offers_Buyer_Groups_Aggregate_Order_By>;
  packaging?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_kg?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  seller_expense?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  sr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: offers */
export type Offers_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "offers" */
export enum Offers_Select_Column {
  /** column name */
  BuyerExpense = 'buyer_expense',
  /** column name */
  BuyerFileId = 'buyer_file_id',
  /** column name */
  BuyerSourceKind = 'buyer_source_kind',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDateTime = 'end_date_time',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  JrOfficerId = 'jr_officer_id',
  /** column name */
  MaterialKind = 'material_kind',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  Mode = 'mode',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityKg = 'quantity_kg',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateUnitId = 'rate_unit_id',
  /** column name */
  SellerExpense = 'seller_expense',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  SrOfficerId = 'sr_officer_id',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDateTime = 'start_date_time',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VarietyGradeId = 'variety_grade_id'
}

/** input type for updating data in table "offers" */
export type Offers_Set_Input = {
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Offers_Stddev_Fields = {
  __typename?: 'offers_stddev_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_file_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Offers_Stddev_Pop_Fields = {
  __typename?: 'offers_stddev_pop_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_file_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Offers_Stddev_Samp_Fields = {
  __typename?: 'offers_stddev_samp_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_file_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "offers" */
export type Offers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offers_Stream_Cursor_Value_Input = {
  buyer_expense?: InputMaybe<Scalars['float8']>;
  buyer_file_id?: InputMaybe<Scalars['bigint']>;
  buyer_source_kind?: InputMaybe<Scalars['String']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  deducted_amount?: InputMaybe<Scalars['float8']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date_time?: InputMaybe<Scalars['timestamptz']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  jr_officer_id?: InputMaybe<Scalars['bigint']>;
  material_kind?: InputMaybe<Scalars['String']>;
  max_rate?: InputMaybe<Scalars['float8']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['float8']>;
  quantity_kg?: InputMaybe<Scalars['float8']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['float8']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  seller_expense?: InputMaybe<Scalars['float8']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  sr_officer_id?: InputMaybe<Scalars['bigint']>;
  standard_deduction?: InputMaybe<Scalars['float8']>;
  start_date_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Offers_Sum_Fields = {
  __typename?: 'offers_sum_fields';
  buyer_expense?: Maybe<Scalars['float8']>;
  buyer_file_id?: Maybe<Scalars['bigint']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  deducted_amount?: Maybe<Scalars['float8']>;
  department_id?: Maybe<Scalars['bigint']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  jr_officer_id?: Maybe<Scalars['bigint']>;
  max_rate?: Maybe<Scalars['float8']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['float8']>;
  quantity_kg?: Maybe<Scalars['float8']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['float8']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  seller_expense?: Maybe<Scalars['float8']>;
  seller_id?: Maybe<Scalars['bigint']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  standard_deduction?: Maybe<Scalars['float8']>;
  total_amount?: Maybe<Scalars['float8']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

export type Offers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Offers_Set_Input>;
  where: Offers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Offers_Var_Pop_Fields = {
  __typename?: 'offers_var_pop_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_file_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Offers_Var_Samp_Fields = {
  __typename?: 'offers_var_samp_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_file_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Offers_Variance_Fields = {
  __typename?: 'offers_variance_fields';
  buyer_expense?: Maybe<Scalars['Float']>;
  buyer_file_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  jr_officer_id?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_kg?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  seller_expense?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "org_dashboard_stats" */
export type Org_Dashboard_Stats = {
  __typename?: 'org_dashboard_stats';
  id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  stats: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "org_dashboard_stats" */
export type Org_Dashboard_StatsStatsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "org_dashboard_stats" */
export type Org_Dashboard_Stats_Aggregate = {
  __typename?: 'org_dashboard_stats_aggregate';
  aggregate?: Maybe<Org_Dashboard_Stats_Aggregate_Fields>;
  nodes: Array<Org_Dashboard_Stats>;
};

/** aggregate fields of "org_dashboard_stats" */
export type Org_Dashboard_Stats_Aggregate_Fields = {
  __typename?: 'org_dashboard_stats_aggregate_fields';
  avg?: Maybe<Org_Dashboard_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Dashboard_Stats_Max_Fields>;
  min?: Maybe<Org_Dashboard_Stats_Min_Fields>;
  stddev?: Maybe<Org_Dashboard_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Dashboard_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Dashboard_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Dashboard_Stats_Sum_Fields>;
  var_pop?: Maybe<Org_Dashboard_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Dashboard_Stats_Var_Samp_Fields>;
  variance?: Maybe<Org_Dashboard_Stats_Variance_Fields>;
};


/** aggregate fields of "org_dashboard_stats" */
export type Org_Dashboard_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Dashboard_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Org_Dashboard_Stats_Append_Input = {
  stats?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Org_Dashboard_Stats_Avg_Fields = {
  __typename?: 'org_dashboard_stats_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "org_dashboard_stats". All fields are combined with a logical 'AND'. */
export type Org_Dashboard_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Dashboard_Stats_Bool_Exp>>;
  _not?: InputMaybe<Org_Dashboard_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Dashboard_Stats_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  stats?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_dashboard_stats" */
export enum Org_Dashboard_Stats_Constraint {
  /** unique or primary key constraint on columns "organisation_id" */
  OrgDashboardStatsOrganisationIdKey = 'org_dashboard_stats_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  OrgDashboardStatsPkey = 'org_dashboard_stats_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Org_Dashboard_Stats_Delete_At_Path_Input = {
  stats?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Org_Dashboard_Stats_Delete_Elem_Input = {
  stats?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Org_Dashboard_Stats_Delete_Key_Input = {
  stats?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "org_dashboard_stats" */
export type Org_Dashboard_Stats_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_dashboard_stats" */
export type Org_Dashboard_Stats_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  stats?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Org_Dashboard_Stats_Max_Fields = {
  __typename?: 'org_dashboard_stats_max_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Org_Dashboard_Stats_Min_Fields = {
  __typename?: 'org_dashboard_stats_min_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "org_dashboard_stats" */
export type Org_Dashboard_Stats_Mutation_Response = {
  __typename?: 'org_dashboard_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Dashboard_Stats>;
};

/** on_conflict condition type for table "org_dashboard_stats" */
export type Org_Dashboard_Stats_On_Conflict = {
  constraint: Org_Dashboard_Stats_Constraint;
  update_columns?: Array<Org_Dashboard_Stats_Update_Column>;
  where?: InputMaybe<Org_Dashboard_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "org_dashboard_stats". */
export type Org_Dashboard_Stats_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  stats?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_dashboard_stats */
export type Org_Dashboard_Stats_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Org_Dashboard_Stats_Prepend_Input = {
  stats?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "org_dashboard_stats" */
export enum Org_Dashboard_Stats_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Stats = 'stats',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "org_dashboard_stats" */
export type Org_Dashboard_Stats_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  stats?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Org_Dashboard_Stats_Stddev_Fields = {
  __typename?: 'org_dashboard_stats_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Org_Dashboard_Stats_Stddev_Pop_Fields = {
  __typename?: 'org_dashboard_stats_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Org_Dashboard_Stats_Stddev_Samp_Fields = {
  __typename?: 'org_dashboard_stats_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "org_dashboard_stats" */
export type Org_Dashboard_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Dashboard_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Dashboard_Stats_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  stats?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Org_Dashboard_Stats_Sum_Fields = {
  __typename?: 'org_dashboard_stats_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "org_dashboard_stats" */
export enum Org_Dashboard_Stats_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Stats = 'stats',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Org_Dashboard_Stats_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Org_Dashboard_Stats_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Org_Dashboard_Stats_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Org_Dashboard_Stats_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Org_Dashboard_Stats_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Dashboard_Stats_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Org_Dashboard_Stats_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Dashboard_Stats_Set_Input>;
  where: Org_Dashboard_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Dashboard_Stats_Var_Pop_Fields = {
  __typename?: 'org_dashboard_stats_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Org_Dashboard_Stats_Var_Samp_Fields = {
  __typename?: 'org_dashboard_stats_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Org_Dashboard_Stats_Variance_Fields = {
  __typename?: 'org_dashboard_stats_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "org_team_association" */
export type Org_Team_Association = {
  __typename?: 'org_team_association';
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  mutual_group: Mutual_Group;
  mutual_group_id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  /** An array relationship */
  primary_crops: Array<Org_Team_Primary_Crop>;
  /** An aggregate relationship */
  primary_crops_aggregate: Org_Team_Primary_Crop_Aggregate;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  system_verified: Scalars['Boolean'];
  /** An object relationship */
  verification_done_by?: Maybe<Agent>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "org_team_association" */
export type Org_Team_AssociationPrimary_CropsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};


/** columns and relationships of "org_team_association" */
export type Org_Team_AssociationPrimary_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};

/** aggregated selection of "org_team_association" */
export type Org_Team_Association_Aggregate = {
  __typename?: 'org_team_association_aggregate';
  aggregate?: Maybe<Org_Team_Association_Aggregate_Fields>;
  nodes: Array<Org_Team_Association>;
};

/** aggregate fields of "org_team_association" */
export type Org_Team_Association_Aggregate_Fields = {
  __typename?: 'org_team_association_aggregate_fields';
  avg?: Maybe<Org_Team_Association_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Team_Association_Max_Fields>;
  min?: Maybe<Org_Team_Association_Min_Fields>;
  stddev?: Maybe<Org_Team_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Team_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Team_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Team_Association_Sum_Fields>;
  var_pop?: Maybe<Org_Team_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Team_Association_Var_Samp_Fields>;
  variance?: Maybe<Org_Team_Association_Variance_Fields>;
};


/** aggregate fields of "org_team_association" */
export type Org_Team_Association_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Team_Association_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_team_association" */
export type Org_Team_Association_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Team_Association_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Team_Association_Max_Order_By>;
  min?: InputMaybe<Org_Team_Association_Min_Order_By>;
  stddev?: InputMaybe<Org_Team_Association_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Team_Association_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Team_Association_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Team_Association_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Team_Association_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Team_Association_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Team_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_team_association" */
export type Org_Team_Association_Arr_Rel_Insert_Input = {
  data: Array<Org_Team_Association_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_Team_Association_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_Team_Association_Avg_Fields = {
  __typename?: 'org_team_association_avg_fields';
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_team_association" */
export type Org_Team_Association_Avg_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_team_association". All fields are combined with a logical 'AND'. */
export type Org_Team_Association_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Team_Association_Bool_Exp>>;
  _not?: InputMaybe<Org_Team_Association_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Team_Association_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  primary_crops?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  verification_done_by?: InputMaybe<Agent_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_team_association" */
export enum Org_Team_Association_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "mutual_group_id" */
  OrgTeamAssociationOrganisationIdMutualG_1139e40dUniq = 'org_team_association_organisation_id_mutual_g_1139e40d_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgTeamAssociationPkey = 'org_team_association_pkey'
}

/** input type for incrementing numeric columns in table "org_team_association" */
export type Org_Team_Association_Inc_Input = {
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_team_association" */
export type Org_Team_Association_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  primary_crops?: InputMaybe<Org_Team_Primary_Crop_Arr_Rel_Insert_Input>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Org_Team_Association_Max_Fields = {
  __typename?: 'org_team_association_max_fields';
  id?: Maybe<Scalars['uuid']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "org_team_association" */
export type Org_Team_Association_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_Team_Association_Min_Fields = {
  __typename?: 'org_team_association_min_fields';
  id?: Maybe<Scalars['uuid']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "org_team_association" */
export type Org_Team_Association_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_team_association" */
export type Org_Team_Association_Mutation_Response = {
  __typename?: 'org_team_association_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Team_Association>;
};

/** input type for inserting object relation for remote table "org_team_association" */
export type Org_Team_Association_Obj_Rel_Insert_Input = {
  data: Org_Team_Association_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_Team_Association_On_Conflict>;
};

/** on_conflict condition type for table "org_team_association" */
export type Org_Team_Association_On_Conflict = {
  constraint: Org_Team_Association_Constraint;
  update_columns?: Array<Org_Team_Association_Update_Column>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};

/** Ordering options when selecting data from "org_team_association". */
export type Org_Team_Association_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  primary_crops_aggregate?: InputMaybe<Org_Team_Primary_Crop_Aggregate_Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  verification_done_by?: InputMaybe<Agent_Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_team_association */
export type Org_Team_Association_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "org_team_association" */
export enum Org_Team_Association_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

/** input type for updating data in table "org_team_association" */
export type Org_Team_Association_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Org_Team_Association_Stddev_Fields = {
  __typename?: 'org_team_association_stddev_fields';
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_team_association" */
export type Org_Team_Association_Stddev_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_Team_Association_Stddev_Pop_Fields = {
  __typename?: 'org_team_association_stddev_pop_fields';
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_team_association" */
export type Org_Team_Association_Stddev_Pop_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_Team_Association_Stddev_Samp_Fields = {
  __typename?: 'org_team_association_stddev_samp_fields';
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_team_association" */
export type Org_Team_Association_Stddev_Samp_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_team_association" */
export type Org_Team_Association_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Team_Association_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Team_Association_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Org_Team_Association_Sum_Fields = {
  __typename?: 'org_team_association_sum_fields';
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_team_association" */
export type Org_Team_Association_Sum_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "org_team_association" */
export enum Org_Team_Association_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

export type Org_Team_Association_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Team_Association_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Team_Association_Set_Input>;
  where: Org_Team_Association_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Team_Association_Var_Pop_Fields = {
  __typename?: 'org_team_association_var_pop_fields';
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_team_association" */
export type Org_Team_Association_Var_Pop_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_Team_Association_Var_Samp_Fields = {
  __typename?: 'org_team_association_var_samp_fields';
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_team_association" */
export type Org_Team_Association_Var_Samp_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_Team_Association_Variance_Fields = {
  __typename?: 'org_team_association_variance_fields';
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_team_association" */
export type Org_Team_Association_Variance_Order_By = {
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_team_primary_crop" */
export type Org_Team_Primary_Crop = {
  __typename?: 'org_team_primary_crop';
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  org_team: Org_Team_Association;
  org_team_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Aggregate = {
  __typename?: 'org_team_primary_crop_aggregate';
  aggregate?: Maybe<Org_Team_Primary_Crop_Aggregate_Fields>;
  nodes: Array<Org_Team_Primary_Crop>;
};

/** aggregate fields of "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Aggregate_Fields = {
  __typename?: 'org_team_primary_crop_aggregate_fields';
  avg?: Maybe<Org_Team_Primary_Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Team_Primary_Crop_Max_Fields>;
  min?: Maybe<Org_Team_Primary_Crop_Min_Fields>;
  stddev?: Maybe<Org_Team_Primary_Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Team_Primary_Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Team_Primary_Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Team_Primary_Crop_Sum_Fields>;
  var_pop?: Maybe<Org_Team_Primary_Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Team_Primary_Crop_Var_Samp_Fields>;
  variance?: Maybe<Org_Team_Primary_Crop_Variance_Fields>;
};


/** aggregate fields of "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Team_Primary_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Team_Primary_Crop_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Team_Primary_Crop_Max_Order_By>;
  min?: InputMaybe<Org_Team_Primary_Crop_Min_Order_By>;
  stddev?: InputMaybe<Org_Team_Primary_Crop_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Team_Primary_Crop_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Team_Primary_Crop_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Team_Primary_Crop_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Team_Primary_Crop_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Team_Primary_Crop_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Team_Primary_Crop_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Arr_Rel_Insert_Input = {
  data: Array<Org_Team_Primary_Crop_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_Team_Primary_Crop_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_Team_Primary_Crop_Avg_Fields = {
  __typename?: 'org_team_primary_crop_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_team_primary_crop". All fields are combined with a logical 'AND'. */
export type Org_Team_Primary_Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Team_Primary_Crop_Bool_Exp>>;
  _not?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Team_Primary_Crop_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  org_team?: InputMaybe<Org_Team_Association_Bool_Exp>;
  org_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_team_primary_crop" */
export enum Org_Team_Primary_Crop_Constraint {
  /** unique or primary key constraint on columns "crop_id", "org_team_id" */
  OrgTeamPrimaryCropOrgTeamIdCropId_53ba62c8Uniq = 'org_team_primary_crop_org_team_id_crop_id_53ba62c8_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgTeamPrimaryCropPkey = 'org_team_primary_crop_pkey'
}

/** input type for incrementing numeric columns in table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  org_team?: InputMaybe<Org_Team_Association_Obj_Rel_Insert_Input>;
  org_team_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Org_Team_Primary_Crop_Max_Fields = {
  __typename?: 'org_team_primary_crop_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  org_team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_Team_Primary_Crop_Min_Fields = {
  __typename?: 'org_team_primary_crop_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  org_team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Mutation_Response = {
  __typename?: 'org_team_primary_crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Team_Primary_Crop>;
};

/** on_conflict condition type for table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_On_Conflict = {
  constraint: Org_Team_Primary_Crop_Constraint;
  update_columns?: Array<Org_Team_Primary_Crop_Update_Column>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "org_team_primary_crop". */
export type Org_Team_Primary_Crop_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  org_team?: InputMaybe<Org_Team_Association_Order_By>;
  org_team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_team_primary_crop */
export type Org_Team_Primary_Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "org_team_primary_crop" */
export enum Org_Team_Primary_Crop_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrgTeamId = 'org_team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  org_team_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Org_Team_Primary_Crop_Stddev_Fields = {
  __typename?: 'org_team_primary_crop_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_Team_Primary_Crop_Stddev_Pop_Fields = {
  __typename?: 'org_team_primary_crop_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_Team_Primary_Crop_Stddev_Samp_Fields = {
  __typename?: 'org_team_primary_crop_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Team_Primary_Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Team_Primary_Crop_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  org_team_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Org_Team_Primary_Crop_Sum_Fields = {
  __typename?: 'org_team_primary_crop_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "org_team_primary_crop" */
export enum Org_Team_Primary_Crop_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrgTeamId = 'org_team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Org_Team_Primary_Crop_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Team_Primary_Crop_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Team_Primary_Crop_Set_Input>;
  where: Org_Team_Primary_Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Team_Primary_Crop_Var_Pop_Fields = {
  __typename?: 'org_team_primary_crop_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_Team_Primary_Crop_Var_Samp_Fields = {
  __typename?: 'org_team_primary_crop_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_Team_Primary_Crop_Variance_Fields = {
  __typename?: 'org_team_primary_crop_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_team_primary_crop" */
export type Org_Team_Primary_Crop_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association = {
  __typename?: 'org_team_user_bank_association';
  /** An object relationship */
  bank: Payment_Detail;
  bank_id: Scalars['Int'];
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  content_type_id: Scalars['Int'];
  custom_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  document?: Maybe<Document>;
  document_id?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  mutual_group: Mutual_Group;
  mutual_group_id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  reason_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  system_verified: Scalars['Boolean'];
  /** An object relationship */
  verification_done_by?: Maybe<Agent>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Aggregate = {
  __typename?: 'org_team_user_bank_association_aggregate';
  aggregate?: Maybe<Org_Team_User_Bank_Association_Aggregate_Fields>;
  nodes: Array<Org_Team_User_Bank_Association>;
};

/** aggregate fields of "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Aggregate_Fields = {
  __typename?: 'org_team_user_bank_association_aggregate_fields';
  avg?: Maybe<Org_Team_User_Bank_Association_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Team_User_Bank_Association_Max_Fields>;
  min?: Maybe<Org_Team_User_Bank_Association_Min_Fields>;
  stddev?: Maybe<Org_Team_User_Bank_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Team_User_Bank_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Team_User_Bank_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Team_User_Bank_Association_Sum_Fields>;
  var_pop?: Maybe<Org_Team_User_Bank_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Team_User_Bank_Association_Var_Samp_Fields>;
  variance?: Maybe<Org_Team_User_Bank_Association_Variance_Fields>;
};


/** aggregate fields of "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Team_User_Bank_Association_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Team_User_Bank_Association_Max_Order_By>;
  min?: InputMaybe<Org_Team_User_Bank_Association_Min_Order_By>;
  stddev?: InputMaybe<Org_Team_User_Bank_Association_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Team_User_Bank_Association_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Team_User_Bank_Association_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Team_User_Bank_Association_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Team_User_Bank_Association_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Team_User_Bank_Association_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Team_User_Bank_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Arr_Rel_Insert_Input = {
  data: Array<Org_Team_User_Bank_Association_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_Team_User_Bank_Association_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_Team_User_Bank_Association_Avg_Fields = {
  __typename?: 'org_team_user_bank_association_avg_fields';
  bank_id?: Maybe<Scalars['Float']>;
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  reason_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Avg_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_team_user_bank_association". All fields are combined with a logical 'AND'. */
export type Org_Team_User_Bank_Association_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Team_User_Bank_Association_Bool_Exp>>;
  _not?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Team_User_Bank_Association_Bool_Exp>>;
  bank?: InputMaybe<Payment_Detail_Bool_Exp>;
  bank_id?: InputMaybe<Int_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  custom_reason?: InputMaybe<String_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  reason_id?: InputMaybe<Int_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  verification_done_by?: InputMaybe<Agent_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_team_user_bank_association" */
export enum Org_Team_User_Bank_Association_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "bank_id", "base_user_id", "mutual_group_id" */
  OrgTeamUserBankAssocOrganisationIdMutualGC002af7aUniq = 'org_team_user_bank_assoc_organisation_id_mutual_g_c002af7a_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgTeamUserBankAssociationPkey = 'org_team_user_bank_association_pkey'
}

/** input type for incrementing numeric columns in table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Inc_Input = {
  bank_id?: InputMaybe<Scalars['Int']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  reason_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Insert_Input = {
  bank?: InputMaybe<Payment_Detail_Obj_Rel_Insert_Input>;
  bank_id?: InputMaybe<Scalars['Int']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  custom_reason?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  reason_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Org_Team_User_Bank_Association_Max_Fields = {
  __typename?: 'org_team_user_bank_association_max_fields';
  bank_id?: Maybe<Scalars['Int']>;
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  custom_reason?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  reason_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Max_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  custom_reason?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_Team_User_Bank_Association_Min_Fields = {
  __typename?: 'org_team_user_bank_association_min_fields';
  bank_id?: Maybe<Scalars['Int']>;
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  custom_reason?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  reason_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Min_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  custom_reason?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Mutation_Response = {
  __typename?: 'org_team_user_bank_association_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Team_User_Bank_Association>;
};

/** on_conflict condition type for table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_On_Conflict = {
  constraint: Org_Team_User_Bank_Association_Constraint;
  update_columns?: Array<Org_Team_User_Bank_Association_Update_Column>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};

/** Ordering options when selecting data from "org_team_user_bank_association". */
export type Org_Team_User_Bank_Association_Order_By = {
  bank?: InputMaybe<Payment_Detail_Order_By>;
  bank_id?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  custom_reason?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  verification_done_by?: InputMaybe<Agent_Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_team_user_bank_association */
export type Org_Team_User_Bank_Association_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "org_team_user_bank_association" */
export enum Org_Team_User_Bank_Association_Select_Column {
  /** column name */
  BankId = 'bank_id',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CustomReason = 'custom_reason',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

/** input type for updating data in table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Set_Input = {
  bank_id?: InputMaybe<Scalars['Int']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  custom_reason?: InputMaybe<Scalars['String']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  reason_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Org_Team_User_Bank_Association_Stddev_Fields = {
  __typename?: 'org_team_user_bank_association_stddev_fields';
  bank_id?: Maybe<Scalars['Float']>;
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  reason_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Stddev_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_Team_User_Bank_Association_Stddev_Pop_Fields = {
  __typename?: 'org_team_user_bank_association_stddev_pop_fields';
  bank_id?: Maybe<Scalars['Float']>;
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  reason_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Stddev_Pop_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_Team_User_Bank_Association_Stddev_Samp_Fields = {
  __typename?: 'org_team_user_bank_association_stddev_samp_fields';
  bank_id?: Maybe<Scalars['Float']>;
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  reason_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Stddev_Samp_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Team_User_Bank_Association_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Team_User_Bank_Association_Stream_Cursor_Value_Input = {
  bank_id?: InputMaybe<Scalars['Int']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  custom_reason?: InputMaybe<Scalars['String']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  reason_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Org_Team_User_Bank_Association_Sum_Fields = {
  __typename?: 'org_team_user_bank_association_sum_fields';
  bank_id?: Maybe<Scalars['Int']>;
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  reason_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Sum_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "org_team_user_bank_association" */
export enum Org_Team_User_Bank_Association_Update_Column {
  /** column name */
  BankId = 'bank_id',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CustomReason = 'custom_reason',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ReasonId = 'reason_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

export type Org_Team_User_Bank_Association_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Team_User_Bank_Association_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Team_User_Bank_Association_Set_Input>;
  where: Org_Team_User_Bank_Association_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Team_User_Bank_Association_Var_Pop_Fields = {
  __typename?: 'org_team_user_bank_association_var_pop_fields';
  bank_id?: Maybe<Scalars['Float']>;
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  reason_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Var_Pop_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_Team_User_Bank_Association_Var_Samp_Fields = {
  __typename?: 'org_team_user_bank_association_var_samp_fields';
  bank_id?: Maybe<Scalars['Float']>;
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  reason_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Var_Samp_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_Team_User_Bank_Association_Variance_Fields = {
  __typename?: 'org_team_user_bank_association_variance_fields';
  bank_id?: Maybe<Scalars['Float']>;
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  reason_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_team_user_bank_association" */
export type Org_Team_User_Bank_Association_Variance_Order_By = {
  bank_id?: InputMaybe<Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  reason_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_team_user_crop" */
export type Org_Team_User_Crop = {
  __typename?: 'org_team_user_crop';
  base_user_id: Scalars['Int'];
  crop_id: Scalars['Int'];
  id: Scalars['Int'];
  organisation_id: Scalars['Int'];
  total_acreage: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "org_team_user_crop" */
export type Org_Team_User_Crop_Aggregate = {
  __typename?: 'org_team_user_crop_aggregate';
  aggregate?: Maybe<Org_Team_User_Crop_Aggregate_Fields>;
  nodes: Array<Org_Team_User_Crop>;
};

/** aggregate fields of "org_team_user_crop" */
export type Org_Team_User_Crop_Aggregate_Fields = {
  __typename?: 'org_team_user_crop_aggregate_fields';
  avg?: Maybe<Org_Team_User_Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Team_User_Crop_Max_Fields>;
  min?: Maybe<Org_Team_User_Crop_Min_Fields>;
  stddev?: Maybe<Org_Team_User_Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Team_User_Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Team_User_Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Team_User_Crop_Sum_Fields>;
  var_pop?: Maybe<Org_Team_User_Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Team_User_Crop_Var_Samp_Fields>;
  variance?: Maybe<Org_Team_User_Crop_Variance_Fields>;
};


/** aggregate fields of "org_team_user_crop" */
export type Org_Team_User_Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Team_User_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Org_Team_User_Crop_Avg_Fields = {
  __typename?: 'org_team_user_crop_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_acreage?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "org_team_user_crop". All fields are combined with a logical 'AND'. */
export type Org_Team_User_Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Team_User_Crop_Bool_Exp>>;
  _not?: InputMaybe<Org_Team_User_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Team_User_Crop_Bool_Exp>>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  total_acreage?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_team_user_crop" */
export enum Org_Team_User_Crop_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "base_user_id" */
  OrgTeamUserCropOrganisationIdBaseUserIdD1e24a14Uniq = 'org_team_user_crop_organisation_id_base_user_id_d1e24a14_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgTeamUserCropPkey = 'org_team_user_crop_pkey'
}

/** input type for incrementing numeric columns in table "org_team_user_crop" */
export type Org_Team_User_Crop_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_acreage?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "org_team_user_crop" */
export type Org_Team_User_Crop_Insert_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_acreage?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Org_Team_User_Crop_Max_Fields = {
  __typename?: 'org_team_user_crop_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  total_acreage?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Org_Team_User_Crop_Min_Fields = {
  __typename?: 'org_team_user_crop_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  total_acreage?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "org_team_user_crop" */
export type Org_Team_User_Crop_Mutation_Response = {
  __typename?: 'org_team_user_crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Team_User_Crop>;
};

/** on_conflict condition type for table "org_team_user_crop" */
export type Org_Team_User_Crop_On_Conflict = {
  constraint: Org_Team_User_Crop_Constraint;
  update_columns?: Array<Org_Team_User_Crop_Update_Column>;
  where?: InputMaybe<Org_Team_User_Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "org_team_user_crop". */
export type Org_Team_User_Crop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_acreage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_team_user_crop */
export type Org_Team_User_Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "org_team_user_crop" */
export enum Org_Team_User_Crop_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  TotalAcreage = 'total_acreage',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "org_team_user_crop" */
export type Org_Team_User_Crop_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_acreage?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Org_Team_User_Crop_Stddev_Fields = {
  __typename?: 'org_team_user_crop_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_acreage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Org_Team_User_Crop_Stddev_Pop_Fields = {
  __typename?: 'org_team_user_crop_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_acreage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Org_Team_User_Crop_Stddev_Samp_Fields = {
  __typename?: 'org_team_user_crop_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_acreage?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "org_team_user_crop" */
export type Org_Team_User_Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Team_User_Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Team_User_Crop_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_acreage?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Org_Team_User_Crop_Sum_Fields = {
  __typename?: 'org_team_user_crop_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  total_acreage?: Maybe<Scalars['numeric']>;
};

/** update columns of table "org_team_user_crop" */
export enum Org_Team_User_Crop_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  TotalAcreage = 'total_acreage',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Org_Team_User_Crop_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Team_User_Crop_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Team_User_Crop_Set_Input>;
  where: Org_Team_User_Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Team_User_Crop_Var_Pop_Fields = {
  __typename?: 'org_team_user_crop_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_acreage?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Org_Team_User_Crop_Var_Samp_Fields = {
  __typename?: 'org_team_user_crop_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_acreage?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Org_Team_User_Crop_Variance_Fields = {
  __typename?: 'org_team_user_crop_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_acreage?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "org_team_user_document_association" */
export type Org_Team_User_Document_Association = {
  __typename?: 'org_team_user_document_association';
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  content_type_id: Scalars['Int'];
  /** An object relationship */
  document: Document;
  document_id: Scalars['Int'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  mutual_group: Mutual_Group;
  mutual_group_id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  system_verified: Scalars['Boolean'];
  /** An object relationship */
  verification_done_by?: Maybe<Agent>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Aggregate = {
  __typename?: 'org_team_user_document_association_aggregate';
  aggregate?: Maybe<Org_Team_User_Document_Association_Aggregate_Fields>;
  nodes: Array<Org_Team_User_Document_Association>;
};

/** aggregate fields of "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Aggregate_Fields = {
  __typename?: 'org_team_user_document_association_aggregate_fields';
  avg?: Maybe<Org_Team_User_Document_Association_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Team_User_Document_Association_Max_Fields>;
  min?: Maybe<Org_Team_User_Document_Association_Min_Fields>;
  stddev?: Maybe<Org_Team_User_Document_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Team_User_Document_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Team_User_Document_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Team_User_Document_Association_Sum_Fields>;
  var_pop?: Maybe<Org_Team_User_Document_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Team_User_Document_Association_Var_Samp_Fields>;
  variance?: Maybe<Org_Team_User_Document_Association_Variance_Fields>;
};


/** aggregate fields of "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Team_User_Document_Association_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Team_User_Document_Association_Max_Order_By>;
  min?: InputMaybe<Org_Team_User_Document_Association_Min_Order_By>;
  stddev?: InputMaybe<Org_Team_User_Document_Association_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Team_User_Document_Association_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Team_User_Document_Association_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Team_User_Document_Association_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Team_User_Document_Association_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Team_User_Document_Association_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Team_User_Document_Association_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Arr_Rel_Insert_Input = {
  data: Array<Org_Team_User_Document_Association_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_Team_User_Document_Association_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_Team_User_Document_Association_Avg_Fields = {
  __typename?: 'org_team_user_document_association_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_team_user_document_association". All fields are combined with a logical 'AND'. */
export type Org_Team_User_Document_Association_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Team_User_Document_Association_Bool_Exp>>;
  _not?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Team_User_Document_Association_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_group?: InputMaybe<Mutual_Group_Bool_Exp>;
  mutual_group_id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  verification_done_by?: InputMaybe<Agent_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_team_user_document_association" */
export enum Org_Team_User_Document_Association_Constraint {
  /** unique or primary key constraint on columns "document_id", "organisation_id", "base_user_id", "mutual_group_id" */
  OrgTeamUserDocumentAOrganisationIdMutualG_9a5290cbUniq = 'org_team_user_document_a_organisation_id_mutual_g_9a5290cb_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgTeamUserDocumentAssociationPkey = 'org_team_user_document_association_pkey'
}

/** input type for incrementing numeric columns in table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group?: InputMaybe<Mutual_Group_Obj_Rel_Insert_Input>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Org_Team_User_Document_Association_Max_Fields = {
  __typename?: 'org_team_user_document_association_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Max_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_Team_User_Document_Association_Min_Fields = {
  __typename?: 'org_team_user_document_association_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Min_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Mutation_Response = {
  __typename?: 'org_team_user_document_association_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Team_User_Document_Association>;
};

/** on_conflict condition type for table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_On_Conflict = {
  constraint: Org_Team_User_Document_Association_Constraint;
  update_columns?: Array<Org_Team_User_Document_Association_Update_Column>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};

/** Ordering options when selecting data from "org_team_user_document_association". */
export type Org_Team_User_Document_Association_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  mutual_group?: InputMaybe<Mutual_Group_Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  verification_done_by?: InputMaybe<Agent_Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_team_user_document_association */
export type Org_Team_User_Document_Association_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "org_team_user_document_association" */
export enum Org_Team_User_Document_Association_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

/** input type for updating data in table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Org_Team_User_Document_Association_Stddev_Fields = {
  __typename?: 'org_team_user_document_association_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_Team_User_Document_Association_Stddev_Pop_Fields = {
  __typename?: 'org_team_user_document_association_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_Team_User_Document_Association_Stddev_Samp_Fields = {
  __typename?: 'org_team_user_document_association_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Team_User_Document_Association_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Team_User_Document_Association_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  document_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Org_Team_User_Document_Association_Sum_Fields = {
  __typename?: 'org_team_user_document_association_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  content_type_id?: Maybe<Scalars['Int']>;
  document_id?: Maybe<Scalars['Int']>;
  mutual_group_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "org_team_user_document_association" */
export enum Org_Team_User_Document_Association_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MutualGroupId = 'mutual_group_id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

export type Org_Team_User_Document_Association_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Team_User_Document_Association_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Team_User_Document_Association_Set_Input>;
  where: Org_Team_User_Document_Association_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Team_User_Document_Association_Var_Pop_Fields = {
  __typename?: 'org_team_user_document_association_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_Team_User_Document_Association_Var_Samp_Fields = {
  __typename?: 'org_team_user_document_association_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_Team_User_Document_Association_Variance_Fields = {
  __typename?: 'org_team_user_document_association_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  document_id?: Maybe<Scalars['Float']>;
  mutual_group_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_team_user_document_association" */
export type Org_Team_User_Document_Association_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  mutual_group_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_user_association" */
export type Org_User_Association = {
  __typename?: 'org_user_association';
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  block_remark?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  is_blocked: Scalars['Boolean'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  /** An array relationship */
  primary_crops: Array<Org_User_Primary_Crop>;
  /** An aggregate relationship */
  primary_crops_aggregate: Org_User_Primary_Crop_Aggregate;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  verification_done_by?: Maybe<Agent>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "org_user_association" */
export type Org_User_AssociationPrimary_CropsArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};


/** columns and relationships of "org_user_association" */
export type Org_User_AssociationPrimary_Crops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};

/** aggregated selection of "org_user_association" */
export type Org_User_Association_Aggregate = {
  __typename?: 'org_user_association_aggregate';
  aggregate?: Maybe<Org_User_Association_Aggregate_Fields>;
  nodes: Array<Org_User_Association>;
};

/** aggregate fields of "org_user_association" */
export type Org_User_Association_Aggregate_Fields = {
  __typename?: 'org_user_association_aggregate_fields';
  avg?: Maybe<Org_User_Association_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_User_Association_Max_Fields>;
  min?: Maybe<Org_User_Association_Min_Fields>;
  stddev?: Maybe<Org_User_Association_Stddev_Fields>;
  stddev_pop?: Maybe<Org_User_Association_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_User_Association_Stddev_Samp_Fields>;
  sum?: Maybe<Org_User_Association_Sum_Fields>;
  var_pop?: Maybe<Org_User_Association_Var_Pop_Fields>;
  var_samp?: Maybe<Org_User_Association_Var_Samp_Fields>;
  variance?: Maybe<Org_User_Association_Variance_Fields>;
};


/** aggregate fields of "org_user_association" */
export type Org_User_Association_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_User_Association_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Org_User_Association_Avg_Fields = {
  __typename?: 'org_user_association_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "org_user_association". All fields are combined with a logical 'AND'. */
export type Org_User_Association_Bool_Exp = {
  _and?: InputMaybe<Array<Org_User_Association_Bool_Exp>>;
  _not?: InputMaybe<Org_User_Association_Bool_Exp>;
  _or?: InputMaybe<Array<Org_User_Association_Bool_Exp>>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  block_remark?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  primary_crops?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_done_by?: InputMaybe<Agent_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_user_association" */
export enum Org_User_Association_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "base_user_id" */
  OrgUserAssociationOrganisationIdBaseUserId_3b5bf86fUniq = 'org_user_association_organisation_id_base_user_id_3b5bf86f_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgUserAssociationPkey = 'org_user_association_pkey'
}

/** input type for incrementing numeric columns in table "org_user_association" */
export type Org_User_Association_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_user_association" */
export type Org_User_Association_Insert_Input = {
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  block_remark?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  primary_crops?: InputMaybe<Org_User_Primary_Crop_Arr_Rel_Insert_Input>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verification_done_by?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Org_User_Association_Max_Fields = {
  __typename?: 'org_user_association_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  block_remark?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Org_User_Association_Min_Fields = {
  __typename?: 'org_user_association_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  block_remark?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "org_user_association" */
export type Org_User_Association_Mutation_Response = {
  __typename?: 'org_user_association_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_User_Association>;
};

/** input type for inserting object relation for remote table "org_user_association" */
export type Org_User_Association_Obj_Rel_Insert_Input = {
  data: Org_User_Association_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_User_Association_On_Conflict>;
};

/** on_conflict condition type for table "org_user_association" */
export type Org_User_Association_On_Conflict = {
  constraint: Org_User_Association_Constraint;
  update_columns?: Array<Org_User_Association_Update_Column>;
  where?: InputMaybe<Org_User_Association_Bool_Exp>;
};

/** Ordering options when selecting data from "org_user_association". */
export type Org_User_Association_Order_By = {
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  block_remark?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  primary_crops_aggregate?: InputMaybe<Org_User_Primary_Crop_Aggregate_Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verification_done_by?: InputMaybe<Agent_Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_user_association */
export type Org_User_Association_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "org_user_association" */
export enum Org_User_Association_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  BlockRemark = 'block_remark',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

/** input type for updating data in table "org_user_association" */
export type Org_User_Association_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  block_remark?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Org_User_Association_Stddev_Fields = {
  __typename?: 'org_user_association_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Org_User_Association_Stddev_Pop_Fields = {
  __typename?: 'org_user_association_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Org_User_Association_Stddev_Samp_Fields = {
  __typename?: 'org_user_association_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "org_user_association" */
export type Org_User_Association_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_User_Association_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_User_Association_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  block_remark?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Org_User_Association_Sum_Fields = {
  __typename?: 'org_user_association_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "org_user_association" */
export enum Org_User_Association_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  BlockRemark = 'block_remark',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on'
}

export type Org_User_Association_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_User_Association_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_User_Association_Set_Input>;
  where: Org_User_Association_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_User_Association_Var_Pop_Fields = {
  __typename?: 'org_user_association_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Org_User_Association_Var_Samp_Fields = {
  __typename?: 'org_user_association_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Org_User_Association_Variance_Fields = {
  __typename?: 'org_user_association_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document = {
  __typename?: 'org_user_group_mandatory_document';
  bank_required: Scalars['Boolean'];
  /** An object relationship */
  document_kind?: Maybe<Document_Kind>;
  document_kind_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  user_group: Scalars['String'];
};

/** aggregated selection of "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Aggregate = {
  __typename?: 'org_user_group_mandatory_document_aggregate';
  aggregate?: Maybe<Org_User_Group_Mandatory_Document_Aggregate_Fields>;
  nodes: Array<Org_User_Group_Mandatory_Document>;
};

/** aggregate fields of "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Aggregate_Fields = {
  __typename?: 'org_user_group_mandatory_document_aggregate_fields';
  avg?: Maybe<Org_User_Group_Mandatory_Document_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_User_Group_Mandatory_Document_Max_Fields>;
  min?: Maybe<Org_User_Group_Mandatory_Document_Min_Fields>;
  stddev?: Maybe<Org_User_Group_Mandatory_Document_Stddev_Fields>;
  stddev_pop?: Maybe<Org_User_Group_Mandatory_Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_User_Group_Mandatory_Document_Stddev_Samp_Fields>;
  sum?: Maybe<Org_User_Group_Mandatory_Document_Sum_Fields>;
  var_pop?: Maybe<Org_User_Group_Mandatory_Document_Var_Pop_Fields>;
  var_samp?: Maybe<Org_User_Group_Mandatory_Document_Var_Samp_Fields>;
  variance?: Maybe<Org_User_Group_Mandatory_Document_Variance_Fields>;
};


/** aggregate fields of "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Aggregate_Order_By = {
  avg?: InputMaybe<Org_User_Group_Mandatory_Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_User_Group_Mandatory_Document_Max_Order_By>;
  min?: InputMaybe<Org_User_Group_Mandatory_Document_Min_Order_By>;
  stddev?: InputMaybe<Org_User_Group_Mandatory_Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_User_Group_Mandatory_Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_User_Group_Mandatory_Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_User_Group_Mandatory_Document_Sum_Order_By>;
  var_pop?: InputMaybe<Org_User_Group_Mandatory_Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_User_Group_Mandatory_Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_User_Group_Mandatory_Document_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Arr_Rel_Insert_Input = {
  data: Array<Org_User_Group_Mandatory_Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_User_Group_Mandatory_Document_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_User_Group_Mandatory_Document_Avg_Fields = {
  __typename?: 'org_user_group_mandatory_document_avg_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Avg_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_user_group_mandatory_document". All fields are combined with a logical 'AND'. */
export type Org_User_Group_Mandatory_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Bool_Exp>>;
  _not?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Bool_Exp>>;
  bank_required?: InputMaybe<Boolean_Comparison_Exp>;
  document_kind?: InputMaybe<Document_Kind_Bool_Exp>;
  document_kind_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  user_group?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_user_group_mandatory_document" */
export enum Org_User_Group_Mandatory_Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgUserGroupMandatoryDocumentPkey = 'org_user_group_mandatory_document_pkey',
  /** unique or primary key constraint on columns "user_group", "organisation_id" */
  UqOrgUserGroupBankRequired = 'uq_org_user_group_bank_required',
  /** unique or primary key constraint on columns "user_group", "document_kind_id", "organisation_id" */
  UqOrgUserGroupDocumentKind = 'uq_org_user_group_document_kind'
}

/** input type for incrementing numeric columns in table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Inc_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Insert_Input = {
  bank_required?: InputMaybe<Scalars['Boolean']>;
  document_kind?: InputMaybe<Document_Kind_Obj_Rel_Insert_Input>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_group?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Org_User_Group_Mandatory_Document_Max_Fields = {
  __typename?: 'org_user_group_mandatory_document_max_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_group?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Max_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_group?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_User_Group_Mandatory_Document_Min_Fields = {
  __typename?: 'org_user_group_mandatory_document_min_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  user_group?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Min_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_group?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Mutation_Response = {
  __typename?: 'org_user_group_mandatory_document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_User_Group_Mandatory_Document>;
};

/** on_conflict condition type for table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_On_Conflict = {
  constraint: Org_User_Group_Mandatory_Document_Constraint;
  update_columns?: Array<Org_User_Group_Mandatory_Document_Update_Column>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};

/** Ordering options when selecting data from "org_user_group_mandatory_document". */
export type Org_User_Group_Mandatory_Document_Order_By = {
  bank_required?: InputMaybe<Order_By>;
  document_kind?: InputMaybe<Document_Kind_Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  user_group?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_user_group_mandatory_document */
export type Org_User_Group_Mandatory_Document_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "org_user_group_mandatory_document" */
export enum Org_User_Group_Mandatory_Document_Select_Column {
  /** column name */
  BankRequired = 'bank_required',
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserGroup = 'user_group'
}

/** input type for updating data in table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Set_Input = {
  bank_required?: InputMaybe<Scalars['Boolean']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_group?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Org_User_Group_Mandatory_Document_Stddev_Fields = {
  __typename?: 'org_user_group_mandatory_document_stddev_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Stddev_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_User_Group_Mandatory_Document_Stddev_Pop_Fields = {
  __typename?: 'org_user_group_mandatory_document_stddev_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Stddev_Pop_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_User_Group_Mandatory_Document_Stddev_Samp_Fields = {
  __typename?: 'org_user_group_mandatory_document_stddev_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Stddev_Samp_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_User_Group_Mandatory_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_User_Group_Mandatory_Document_Stream_Cursor_Value_Input = {
  bank_required?: InputMaybe<Scalars['Boolean']>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  user_group?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Org_User_Group_Mandatory_Document_Sum_Fields = {
  __typename?: 'org_user_group_mandatory_document_sum_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Sum_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** update columns of table "org_user_group_mandatory_document" */
export enum Org_User_Group_Mandatory_Document_Update_Column {
  /** column name */
  BankRequired = 'bank_required',
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserGroup = 'user_group'
}

export type Org_User_Group_Mandatory_Document_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_User_Group_Mandatory_Document_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_User_Group_Mandatory_Document_Set_Input>;
  where: Org_User_Group_Mandatory_Document_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_User_Group_Mandatory_Document_Var_Pop_Fields = {
  __typename?: 'org_user_group_mandatory_document_var_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Var_Pop_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_User_Group_Mandatory_Document_Var_Samp_Fields = {
  __typename?: 'org_user_group_mandatory_document_var_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Var_Samp_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_User_Group_Mandatory_Document_Variance_Fields = {
  __typename?: 'org_user_group_mandatory_document_variance_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_user_group_mandatory_document" */
export type Org_User_Group_Mandatory_Document_Variance_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot = {
  __typename?: 'org_user_group_status_snapshot';
  bank_verified: Scalars['Boolean'];
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_blocked: Scalars['Boolean'];
  mandatory_docs_complete: Scalars['Boolean'];
  missing_document_kinds: Scalars['jsonb'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  send_for_verification_status?: Maybe<Scalars['String']>;
  status_update_at?: Maybe<Scalars['timestamptz']>;
  status_update_by_id?: Maybe<Scalars['Int']>;
  system_unverified_invalid_email: Scalars['Boolean'];
  system_unverified_invalid_gender: Scalars['Boolean'];
  system_unverified_missing_bank: Scalars['Boolean'];
  system_unverified_missing_company: Scalars['Boolean'];
  system_unverified_missing_documents: Scalars['Boolean'];
  system_unverified_missing_primary_crop: Scalars['Boolean'];
  system_unverified_missing_valid_shareholder_application: Scalars['Boolean'];
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  user_group: Scalars['String'];
};


/** columns and relationships of "org_user_group_status_snapshot" */
export type Org_User_Group_Status_SnapshotMissing_Document_KindsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Aggregate = {
  __typename?: 'org_user_group_status_snapshot_aggregate';
  aggregate?: Maybe<Org_User_Group_Status_Snapshot_Aggregate_Fields>;
  nodes: Array<Org_User_Group_Status_Snapshot>;
};

/** aggregate fields of "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Aggregate_Fields = {
  __typename?: 'org_user_group_status_snapshot_aggregate_fields';
  avg?: Maybe<Org_User_Group_Status_Snapshot_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_User_Group_Status_Snapshot_Max_Fields>;
  min?: Maybe<Org_User_Group_Status_Snapshot_Min_Fields>;
  stddev?: Maybe<Org_User_Group_Status_Snapshot_Stddev_Fields>;
  stddev_pop?: Maybe<Org_User_Group_Status_Snapshot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_User_Group_Status_Snapshot_Stddev_Samp_Fields>;
  sum?: Maybe<Org_User_Group_Status_Snapshot_Sum_Fields>;
  var_pop?: Maybe<Org_User_Group_Status_Snapshot_Var_Pop_Fields>;
  var_samp?: Maybe<Org_User_Group_Status_Snapshot_Var_Samp_Fields>;
  variance?: Maybe<Org_User_Group_Status_Snapshot_Variance_Fields>;
};


/** aggregate fields of "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Aggregate_Order_By = {
  avg?: InputMaybe<Org_User_Group_Status_Snapshot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_User_Group_Status_Snapshot_Max_Order_By>;
  min?: InputMaybe<Org_User_Group_Status_Snapshot_Min_Order_By>;
  stddev?: InputMaybe<Org_User_Group_Status_Snapshot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_User_Group_Status_Snapshot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_User_Group_Status_Snapshot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_User_Group_Status_Snapshot_Sum_Order_By>;
  var_pop?: InputMaybe<Org_User_Group_Status_Snapshot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_User_Group_Status_Snapshot_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_User_Group_Status_Snapshot_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Org_User_Group_Status_Snapshot_Append_Input = {
  missing_document_kinds?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Arr_Rel_Insert_Input = {
  data: Array<Org_User_Group_Status_Snapshot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_User_Group_Status_Snapshot_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_User_Group_Status_Snapshot_Avg_Fields = {
  __typename?: 'org_user_group_status_snapshot_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  status_update_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_user_group_status_snapshot". All fields are combined with a logical 'AND'. */
export type Org_User_Group_Status_Snapshot_Bool_Exp = {
  _and?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Bool_Exp>>;
  _not?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
  _or?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Bool_Exp>>;
  bank_verified?: InputMaybe<Boolean_Comparison_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_blocked?: InputMaybe<Boolean_Comparison_Exp>;
  mandatory_docs_complete?: InputMaybe<Boolean_Comparison_Exp>;
  missing_document_kinds?: InputMaybe<Jsonb_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  status_update_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status_update_by_id?: InputMaybe<Int_Comparison_Exp>;
  system_unverified_invalid_email?: InputMaybe<Boolean_Comparison_Exp>;
  system_unverified_invalid_gender?: InputMaybe<Boolean_Comparison_Exp>;
  system_unverified_missing_bank?: InputMaybe<Boolean_Comparison_Exp>;
  system_unverified_missing_company?: InputMaybe<Boolean_Comparison_Exp>;
  system_unverified_missing_documents?: InputMaybe<Boolean_Comparison_Exp>;
  system_unverified_missing_primary_crop?: InputMaybe<Boolean_Comparison_Exp>;
  system_unverified_missing_valid_shareholder_application?: InputMaybe<Boolean_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_group?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_user_group_status_snapshot" */
export enum Org_User_Group_Status_Snapshot_Constraint {
  /** unique or primary key constraint on columns "user_group", "organisation_id", "base_user_id" */
  OrgUserGroupStatusSnOrganisationIdBaseUse_3d5f6e74Uniq = 'org_user_group_status_sn_organisation_id_base_use_3d5f6e74_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgUserGroupStatusSnapshotPkey = 'org_user_group_status_snapshot_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Org_User_Group_Status_Snapshot_Delete_At_Path_Input = {
  missing_document_kinds?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Org_User_Group_Status_Snapshot_Delete_Elem_Input = {
  missing_document_kinds?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Org_User_Group_Status_Snapshot_Delete_Key_Input = {
  missing_document_kinds?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  status_update_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Insert_Input = {
  bank_verified?: InputMaybe<Scalars['Boolean']>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  mandatory_docs_complete?: InputMaybe<Scalars['Boolean']>;
  missing_document_kinds?: InputMaybe<Scalars['jsonb']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  status_update_at?: InputMaybe<Scalars['timestamptz']>;
  status_update_by_id?: InputMaybe<Scalars['Int']>;
  system_unverified_invalid_email?: InputMaybe<Scalars['Boolean']>;
  system_unverified_invalid_gender?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_bank?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_company?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_documents?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_primary_crop?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_valid_shareholder_application?: InputMaybe<Scalars['Boolean']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_group?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Org_User_Group_Status_Snapshot_Max_Fields = {
  __typename?: 'org_user_group_status_snapshot_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  status_update_at?: Maybe<Scalars['timestamptz']>;
  status_update_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_group?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Max_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  status_update_at?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_group?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_User_Group_Status_Snapshot_Min_Fields = {
  __typename?: 'org_user_group_status_snapshot_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  status_update_at?: Maybe<Scalars['timestamptz']>;
  status_update_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_group?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Min_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  status_update_at?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_group?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Mutation_Response = {
  __typename?: 'org_user_group_status_snapshot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_User_Group_Status_Snapshot>;
};

/** on_conflict condition type for table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_On_Conflict = {
  constraint: Org_User_Group_Status_Snapshot_Constraint;
  update_columns?: Array<Org_User_Group_Status_Snapshot_Update_Column>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};

/** Ordering options when selecting data from "org_user_group_status_snapshot". */
export type Org_User_Group_Status_Snapshot_Order_By = {
  bank_verified?: InputMaybe<Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_blocked?: InputMaybe<Order_By>;
  mandatory_docs_complete?: InputMaybe<Order_By>;
  missing_document_kinds?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  status_update_at?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
  system_unverified_invalid_email?: InputMaybe<Order_By>;
  system_unverified_invalid_gender?: InputMaybe<Order_By>;
  system_unverified_missing_bank?: InputMaybe<Order_By>;
  system_unverified_missing_company?: InputMaybe<Order_By>;
  system_unverified_missing_documents?: InputMaybe<Order_By>;
  system_unverified_missing_primary_crop?: InputMaybe<Order_By>;
  system_unverified_missing_valid_shareholder_application?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_group?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_user_group_status_snapshot */
export type Org_User_Group_Status_Snapshot_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Org_User_Group_Status_Snapshot_Prepend_Input = {
  missing_document_kinds?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "org_user_group_status_snapshot" */
export enum Org_User_Group_Status_Snapshot_Select_Column {
  /** column name */
  BankVerified = 'bank_verified',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  MandatoryDocsComplete = 'mandatory_docs_complete',
  /** column name */
  MissingDocumentKinds = 'missing_document_kinds',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  StatusUpdateAt = 'status_update_at',
  /** column name */
  StatusUpdateById = 'status_update_by_id',
  /** column name */
  SystemUnverifiedInvalidEmail = 'system_unverified_invalid_email',
  /** column name */
  SystemUnverifiedInvalidGender = 'system_unverified_invalid_gender',
  /** column name */
  SystemUnverifiedMissingBank = 'system_unverified_missing_bank',
  /** column name */
  SystemUnverifiedMissingCompany = 'system_unverified_missing_company',
  /** column name */
  SystemUnverifiedMissingDocuments = 'system_unverified_missing_documents',
  /** column name */
  SystemUnverifiedMissingPrimaryCrop = 'system_unverified_missing_primary_crop',
  /** column name */
  SystemUnverifiedMissingValidShareholderApplication = 'system_unverified_missing_valid_shareholder_application',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserGroup = 'user_group'
}

/** input type for updating data in table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Set_Input = {
  bank_verified?: InputMaybe<Scalars['Boolean']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  mandatory_docs_complete?: InputMaybe<Scalars['Boolean']>;
  missing_document_kinds?: InputMaybe<Scalars['jsonb']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  status_update_at?: InputMaybe<Scalars['timestamptz']>;
  status_update_by_id?: InputMaybe<Scalars['Int']>;
  system_unverified_invalid_email?: InputMaybe<Scalars['Boolean']>;
  system_unverified_invalid_gender?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_bank?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_company?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_documents?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_primary_crop?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_valid_shareholder_application?: InputMaybe<Scalars['Boolean']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_group?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Org_User_Group_Status_Snapshot_Stddev_Fields = {
  __typename?: 'org_user_group_status_snapshot_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  status_update_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_User_Group_Status_Snapshot_Stddev_Pop_Fields = {
  __typename?: 'org_user_group_status_snapshot_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  status_update_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_User_Group_Status_Snapshot_Stddev_Samp_Fields = {
  __typename?: 'org_user_group_status_snapshot_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  status_update_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_User_Group_Status_Snapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_User_Group_Status_Snapshot_Stream_Cursor_Value_Input = {
  bank_verified?: InputMaybe<Scalars['Boolean']>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_blocked?: InputMaybe<Scalars['Boolean']>;
  mandatory_docs_complete?: InputMaybe<Scalars['Boolean']>;
  missing_document_kinds?: InputMaybe<Scalars['jsonb']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  status_update_at?: InputMaybe<Scalars['timestamptz']>;
  status_update_by_id?: InputMaybe<Scalars['Int']>;
  system_unverified_invalid_email?: InputMaybe<Scalars['Boolean']>;
  system_unverified_invalid_gender?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_bank?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_company?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_documents?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_primary_crop?: InputMaybe<Scalars['Boolean']>;
  system_unverified_missing_valid_shareholder_application?: InputMaybe<Scalars['Boolean']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_group?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Org_User_Group_Status_Snapshot_Sum_Fields = {
  __typename?: 'org_user_group_status_snapshot_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  status_update_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "org_user_group_status_snapshot" */
export enum Org_User_Group_Status_Snapshot_Update_Column {
  /** column name */
  BankVerified = 'bank_verified',
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsBlocked = 'is_blocked',
  /** column name */
  MandatoryDocsComplete = 'mandatory_docs_complete',
  /** column name */
  MissingDocumentKinds = 'missing_document_kinds',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  StatusUpdateAt = 'status_update_at',
  /** column name */
  StatusUpdateById = 'status_update_by_id',
  /** column name */
  SystemUnverifiedInvalidEmail = 'system_unverified_invalid_email',
  /** column name */
  SystemUnverifiedInvalidGender = 'system_unverified_invalid_gender',
  /** column name */
  SystemUnverifiedMissingBank = 'system_unverified_missing_bank',
  /** column name */
  SystemUnverifiedMissingCompany = 'system_unverified_missing_company',
  /** column name */
  SystemUnverifiedMissingDocuments = 'system_unverified_missing_documents',
  /** column name */
  SystemUnverifiedMissingPrimaryCrop = 'system_unverified_missing_primary_crop',
  /** column name */
  SystemUnverifiedMissingValidShareholderApplication = 'system_unverified_missing_valid_shareholder_application',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserGroup = 'user_group'
}

export type Org_User_Group_Status_Snapshot_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Org_User_Group_Status_Snapshot_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Org_User_Group_Status_Snapshot_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_User_Group_Status_Snapshot_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Org_User_Group_Status_Snapshot_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_User_Group_Status_Snapshot_Set_Input>;
  where: Org_User_Group_Status_Snapshot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_User_Group_Status_Snapshot_Var_Pop_Fields = {
  __typename?: 'org_user_group_status_snapshot_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  status_update_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_User_Group_Status_Snapshot_Var_Samp_Fields = {
  __typename?: 'org_user_group_status_snapshot_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  status_update_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_User_Group_Status_Snapshot_Variance_Fields = {
  __typename?: 'org_user_group_status_snapshot_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  status_update_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_user_group_status_snapshot" */
export type Org_User_Group_Status_Snapshot_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  status_update_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_user_primary_crop" */
export type Org_User_Primary_Crop = {
  __typename?: 'org_user_primary_crop';
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  org_user: Org_User_Association;
  org_user_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "org_user_primary_crop" */
export type Org_User_Primary_Crop_Aggregate = {
  __typename?: 'org_user_primary_crop_aggregate';
  aggregate?: Maybe<Org_User_Primary_Crop_Aggregate_Fields>;
  nodes: Array<Org_User_Primary_Crop>;
};

/** aggregate fields of "org_user_primary_crop" */
export type Org_User_Primary_Crop_Aggregate_Fields = {
  __typename?: 'org_user_primary_crop_aggregate_fields';
  avg?: Maybe<Org_User_Primary_Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_User_Primary_Crop_Max_Fields>;
  min?: Maybe<Org_User_Primary_Crop_Min_Fields>;
  stddev?: Maybe<Org_User_Primary_Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Org_User_Primary_Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_User_Primary_Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Org_User_Primary_Crop_Sum_Fields>;
  var_pop?: Maybe<Org_User_Primary_Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Org_User_Primary_Crop_Var_Samp_Fields>;
  variance?: Maybe<Org_User_Primary_Crop_Variance_Fields>;
};


/** aggregate fields of "org_user_primary_crop" */
export type Org_User_Primary_Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_User_Primary_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Aggregate_Order_By = {
  avg?: InputMaybe<Org_User_Primary_Crop_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_User_Primary_Crop_Max_Order_By>;
  min?: InputMaybe<Org_User_Primary_Crop_Min_Order_By>;
  stddev?: InputMaybe<Org_User_Primary_Crop_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_User_Primary_Crop_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_User_Primary_Crop_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_User_Primary_Crop_Sum_Order_By>;
  var_pop?: InputMaybe<Org_User_Primary_Crop_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_User_Primary_Crop_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_User_Primary_Crop_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Arr_Rel_Insert_Input = {
  data: Array<Org_User_Primary_Crop_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_User_Primary_Crop_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_User_Primary_Crop_Avg_Fields = {
  __typename?: 'org_user_primary_crop_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_user_primary_crop". All fields are combined with a logical 'AND'. */
export type Org_User_Primary_Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Org_User_Primary_Crop_Bool_Exp>>;
  _not?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Org_User_Primary_Crop_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  org_user?: InputMaybe<Org_User_Association_Bool_Exp>;
  org_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_user_primary_crop" */
export enum Org_User_Primary_Crop_Constraint {
  /** unique or primary key constraint on columns "crop_id", "org_user_id" */
  OrgUserPrimaryCropOrgUserIdCropIdC4124f73Uniq = 'org_user_primary_crop_org_user_id_crop_id_c4124f73_uniq',
  /** unique or primary key constraint on columns "id" */
  OrgUserPrimaryCropPkey = 'org_user_primary_crop_pkey'
}

/** input type for incrementing numeric columns in table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  org_user?: InputMaybe<Org_User_Association_Obj_Rel_Insert_Input>;
  org_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Org_User_Primary_Crop_Max_Fields = {
  __typename?: 'org_user_primary_crop_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  org_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_User_Primary_Crop_Min_Fields = {
  __typename?: 'org_user_primary_crop_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  org_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Mutation_Response = {
  __typename?: 'org_user_primary_crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_User_Primary_Crop>;
};

/** on_conflict condition type for table "org_user_primary_crop" */
export type Org_User_Primary_Crop_On_Conflict = {
  constraint: Org_User_Primary_Crop_Constraint;
  update_columns?: Array<Org_User_Primary_Crop_Update_Column>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "org_user_primary_crop". */
export type Org_User_Primary_Crop_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  org_user?: InputMaybe<Org_User_Association_Order_By>;
  org_user_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_user_primary_crop */
export type Org_User_Primary_Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "org_user_primary_crop" */
export enum Org_User_Primary_Crop_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrgUserId = 'org_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  org_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Org_User_Primary_Crop_Stddev_Fields = {
  __typename?: 'org_user_primary_crop_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_User_Primary_Crop_Stddev_Pop_Fields = {
  __typename?: 'org_user_primary_crop_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_User_Primary_Crop_Stddev_Samp_Fields = {
  __typename?: 'org_user_primary_crop_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_User_Primary_Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_User_Primary_Crop_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  org_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Org_User_Primary_Crop_Sum_Fields = {
  __typename?: 'org_user_primary_crop_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "org_user_primary_crop" */
export enum Org_User_Primary_Crop_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrgUserId = 'org_user_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Org_User_Primary_Crop_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_User_Primary_Crop_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_User_Primary_Crop_Set_Input>;
  where: Org_User_Primary_Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_User_Primary_Crop_Var_Pop_Fields = {
  __typename?: 'org_user_primary_crop_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_User_Primary_Crop_Var_Samp_Fields = {
  __typename?: 'org_user_primary_crop_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_User_Primary_Crop_Variance_Fields = {
  __typename?: 'org_user_primary_crop_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_user_primary_crop" */
export type Org_User_Primary_Crop_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisation" */
export type Organisation = {
  __typename?: 'organisation';
  abbreviation: Scalars['String'];
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  codename: Scalars['String'];
  /** An array relationship */
  companies: Array<Company>;
  /** An aggregate relationship */
  companies_aggregate: Company_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name: Scalars['String'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  level_1_approval_flow: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  org_team_user_bank_associations: Array<Org_Team_User_Bank_Association>;
  /** An aggregate relationship */
  org_team_user_bank_associations_aggregate: Org_Team_User_Bank_Association_Aggregate;
  /** An array relationship */
  org_team_user_document_associations: Array<Org_Team_User_Document_Association>;
  /** An aggregate relationship */
  org_team_user_document_associations_aggregate: Org_Team_User_Document_Association_Aggregate;
  /** An array relationship */
  org_user_group_mandatory_documents: Array<Org_User_Group_Mandatory_Document>;
  /** An aggregate relationship */
  org_user_group_mandatory_documents_aggregate: Org_User_Group_Mandatory_Document_Aggregate;
  /** An array relationship */
  organisation_document_kinds: Array<Organisation_Document_Kind>;
  /** An aggregate relationship */
  organisation_document_kinds_aggregate: Organisation_Document_Kind_Aggregate;
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  private_metadata: Scalars['jsonb'];
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "organisation" */
export type OrganisationCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrg_Team_User_Bank_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrg_Team_User_Bank_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrg_Team_User_Document_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrg_Team_User_Document_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrg_User_Group_Mandatory_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrg_User_Group_Mandatory_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Document_KindsArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationOrganisation_Document_Kinds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


/** columns and relationships of "organisation" */
export type OrganisationPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "organisation" */
export type Organisation_Aggregate = {
  __typename?: 'organisation_aggregate';
  aggregate?: Maybe<Organisation_Aggregate_Fields>;
  nodes: Array<Organisation>;
};

/** aggregate fields of "organisation" */
export type Organisation_Aggregate_Fields = {
  __typename?: 'organisation_aggregate_fields';
  avg?: Maybe<Organisation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Max_Fields>;
  min?: Maybe<Organisation_Min_Fields>;
  stddev?: Maybe<Organisation_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Sum_Fields>;
  var_pop?: Maybe<Organisation_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Variance_Fields>;
};


/** aggregate fields of "organisation" */
export type Organisation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Organisation_Avg_Fields = {
  __typename?: 'organisation_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organisation". All fields are combined with a logical 'AND'. */
export type Organisation_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Company_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  level_1_approval_flow?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
  org_user_group_mandatory_documents?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
  organisation_document_kinds?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  tnc?: InputMaybe<String_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config = {
  __typename?: 'organisation_commodity_variety_config';
  /** An object relationship */
  commodity_variety?: Maybe<Commodity_Variety>;
  commodity_variety_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  /** An array relationship */
  taxes: Array<Organisation_Commodity_Variety_Config_Taxes>;
  /** An aggregate relationship */
  taxes_aggregate: Organisation_Commodity_Variety_Config_Taxes_Aggregate;
};


/** columns and relationships of "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_ConfigTaxesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};


/** columns and relationships of "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_ConfigTaxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};

/** aggregated selection of "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Aggregate = {
  __typename?: 'organisation_commodity_variety_config_aggregate';
  aggregate?: Maybe<Organisation_Commodity_Variety_Config_Aggregate_Fields>;
  nodes: Array<Organisation_Commodity_Variety_Config>;
};

/** aggregate fields of "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Aggregate_Fields = {
  __typename?: 'organisation_commodity_variety_config_aggregate_fields';
  avg?: Maybe<Organisation_Commodity_Variety_Config_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Commodity_Variety_Config_Max_Fields>;
  min?: Maybe<Organisation_Commodity_Variety_Config_Min_Fields>;
  stddev?: Maybe<Organisation_Commodity_Variety_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Commodity_Variety_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Commodity_Variety_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Commodity_Variety_Config_Sum_Fields>;
  var_pop?: Maybe<Organisation_Commodity_Variety_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Commodity_Variety_Config_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Commodity_Variety_Config_Variance_Fields>;
};


/** aggregate fields of "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Aggregate_Order_By = {
  avg?: InputMaybe<Organisation_Commodity_Variety_Config_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Commodity_Variety_Config_Max_Order_By>;
  min?: InputMaybe<Organisation_Commodity_Variety_Config_Min_Order_By>;
  stddev?: InputMaybe<Organisation_Commodity_Variety_Config_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organisation_Commodity_Variety_Config_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organisation_Commodity_Variety_Config_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organisation_Commodity_Variety_Config_Sum_Order_By>;
  var_pop?: InputMaybe<Organisation_Commodity_Variety_Config_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organisation_Commodity_Variety_Config_Var_Samp_Order_By>;
  variance?: InputMaybe<Organisation_Commodity_Variety_Config_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Commodity_Variety_Config_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Commodity_Variety_Config_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Commodity_Variety_Config_Avg_Fields = {
  __typename?: 'organisation_commodity_variety_config_avg_fields';
  commodity_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Avg_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_commodity_variety_config". All fields are combined with a logical 'AND'. */
export type Organisation_Commodity_Variety_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Bool_Exp>>;
  commodity_variety?: InputMaybe<Commodity_Variety_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  taxes?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};

/** unique or primary key constraints on table "organisation_commodity_variety_config" */
export enum Organisation_Commodity_Variety_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganisationCommodityVarietyConfigPkey = 'organisation_commodity_variety_config_pkey'
}

/** input type for incrementing numeric columns in table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Inc_Input = {
  commodity_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Insert_Input = {
  commodity_variety?: InputMaybe<Commodity_Variety_Obj_Rel_Insert_Input>;
  commodity_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  taxes?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organisation_Commodity_Variety_Config_Max_Fields = {
  __typename?: 'organisation_commodity_variety_config_max_fields';
  commodity_variety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Max_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Commodity_Variety_Config_Min_Fields = {
  __typename?: 'organisation_commodity_variety_config_min_fields';
  commodity_variety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Min_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Mutation_Response = {
  __typename?: 'organisation_commodity_variety_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Commodity_Variety_Config>;
};

/** on_conflict condition type for table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_On_Conflict = {
  constraint: Organisation_Commodity_Variety_Config_Constraint;
  update_columns?: Array<Organisation_Commodity_Variety_Config_Update_Column>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_commodity_variety_config". */
export type Organisation_Commodity_Variety_Config_Order_By = {
  commodity_variety?: InputMaybe<Commodity_Variety_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  taxes_aggregate?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Aggregate_Order_By>;
};

/** primary key columns input for table: organisation_commodity_variety_config */
export type Organisation_Commodity_Variety_Config_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_commodity_variety_config" */
export enum Organisation_Commodity_Variety_Config_Select_Column {
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id'
}

/** input type for updating data in table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Set_Input = {
  commodity_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Commodity_Variety_Config_Stddev_Fields = {
  __typename?: 'organisation_commodity_variety_config_stddev_fields';
  commodity_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Stddev_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Commodity_Variety_Config_Stddev_Pop_Fields = {
  __typename?: 'organisation_commodity_variety_config_stddev_pop_fields';
  commodity_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Stddev_Pop_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Commodity_Variety_Config_Stddev_Samp_Fields = {
  __typename?: 'organisation_commodity_variety_config_stddev_samp_fields';
  commodity_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Stddev_Samp_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Commodity_Variety_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Commodity_Variety_Config_Stream_Cursor_Value_Input = {
  commodity_variety_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Commodity_Variety_Config_Sum_Fields = {
  __typename?: 'organisation_commodity_variety_config_sum_fields';
  commodity_variety_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Sum_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes = {
  __typename?: 'organisation_commodity_variety_config_taxes';
  id: Scalars['Int'];
  organisationcommodityvarietyconfig_id: Scalars['Int'];
  /** An object relationship */
  tax: Vt_Core_Tax;
  tax_id: Scalars['Int'];
};

/** aggregated selection of "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Aggregate = {
  __typename?: 'organisation_commodity_variety_config_taxes_aggregate';
  aggregate?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Aggregate_Fields>;
  nodes: Array<Organisation_Commodity_Variety_Config_Taxes>;
};

/** aggregate fields of "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Aggregate_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_aggregate_fields';
  avg?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Max_Fields>;
  min?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Min_Fields>;
  stddev?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Sum_Fields>;
  var_pop?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Commodity_Variety_Config_Taxes_Variance_Fields>;
};


/** aggregate fields of "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Aggregate_Order_By = {
  avg?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Max_Order_By>;
  min?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Min_Order_By>;
  stddev?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Sum_Order_By>;
  var_pop?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Var_Samp_Order_By>;
  variance?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Commodity_Variety_Config_Taxes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Avg_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Float']>;
  tax_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_commodity_variety_config_taxes". All fields are combined with a logical 'AND'. */
export type Organisation_Commodity_Variety_Config_Taxes_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Int_Comparison_Exp>;
  tax?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
  tax_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_commodity_variety_config_taxes" */
export enum Organisation_Commodity_Variety_Config_Taxes_Constraint {
  /** unique or primary key constraint on columns "tax_id", "organisationcommodityvarietyconfig_id" */
  OrganisationCommodityVOrganisationcommodityvar_5144b3f1Uniq = 'organisation_commodity_v_organisationcommodityvar_5144b3f1_uniq',
  /** unique or primary key constraint on columns "id" */
  OrganisationCommodityVarietyConfigTaxesPkey = 'organisation_commodity_variety_config_taxes_pkey'
}

/** input type for incrementing numeric columns in table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Scalars['Int']>;
  tax_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Vt_Core_Tax_Obj_Rel_Insert_Input>;
  tax_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Max_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_max_fields';
  id?: Maybe<Scalars['Int']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Int']>;
  tax_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Min_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_min_fields';
  id?: Maybe<Scalars['Int']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Int']>;
  tax_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Mutation_Response = {
  __typename?: 'organisation_commodity_variety_config_taxes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Commodity_Variety_Config_Taxes>;
};

/** on_conflict condition type for table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_On_Conflict = {
  constraint: Organisation_Commodity_Variety_Config_Taxes_Constraint;
  update_columns?: Array<Organisation_Commodity_Variety_Config_Taxes_Update_Column>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_commodity_variety_config_taxes". */
export type Organisation_Commodity_Variety_Config_Taxes_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax?: InputMaybe<Vt_Core_Tax_Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_commodity_variety_config_taxes */
export type Organisation_Commodity_Variety_Config_Taxes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_commodity_variety_config_taxes" */
export enum Organisation_Commodity_Variety_Config_Taxes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationcommodityvarietyconfigId = 'organisationcommodityvarietyconfig_id',
  /** column name */
  TaxId = 'tax_id'
}

/** input type for updating data in table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Scalars['Int']>;
  tax_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Stddev_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Float']>;
  tax_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Stddev_Pop_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Float']>;
  tax_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Stddev_Samp_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Float']>;
  tax_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Commodity_Variety_Config_Taxes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Commodity_Variety_Config_Taxes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Scalars['Int']>;
  tax_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Sum_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Int']>;
  tax_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** update columns of table "organisation_commodity_variety_config_taxes" */
export enum Organisation_Commodity_Variety_Config_Taxes_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationcommodityvarietyconfigId = 'organisationcommodityvarietyconfig_id',
  /** column name */
  TaxId = 'tax_id'
}

export type Organisation_Commodity_Variety_Config_Taxes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Set_Input>;
  where: Organisation_Commodity_Variety_Config_Taxes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Var_Pop_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Float']>;
  tax_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Var_Samp_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Float']>;
  tax_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Commodity_Variety_Config_Taxes_Variance_Fields = {
  __typename?: 'organisation_commodity_variety_config_taxes_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organisationcommodityvarietyconfig_id?: Maybe<Scalars['Float']>;
  tax_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organisation_commodity_variety_config_taxes" */
export type Organisation_Commodity_Variety_Config_Taxes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationcommodityvarietyconfig_id?: InputMaybe<Order_By>;
  tax_id?: InputMaybe<Order_By>;
};

/** update columns of table "organisation_commodity_variety_config" */
export enum Organisation_Commodity_Variety_Config_Update_Column {
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id'
}

export type Organisation_Commodity_Variety_Config_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Commodity_Variety_Config_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Commodity_Variety_Config_Set_Input>;
  where: Organisation_Commodity_Variety_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Commodity_Variety_Config_Var_Pop_Fields = {
  __typename?: 'organisation_commodity_variety_config_var_pop_fields';
  commodity_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Var_Pop_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Commodity_Variety_Config_Var_Samp_Fields = {
  __typename?: 'organisation_commodity_variety_config_var_samp_fields';
  commodity_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Var_Samp_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Commodity_Variety_Config_Variance_Fields = {
  __typename?: 'organisation_commodity_variety_config_variance_fields';
  commodity_variety_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organisation_commodity_variety_config" */
export type Organisation_Commodity_Variety_Config_Variance_Order_By = {
  commodity_variety_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "organisation" */
export enum Organisation_Constraint {
  /** unique or primary key constraint on columns "address_id" */
  OrganisationAddressIdKey = 'organisation_address_id_key',
  /** unique or primary key constraint on columns "codename" */
  OrganisationCodenameKey = 'organisation_codename_key',
  /** unique or primary key constraint on columns "name", "abbreviation", "address_id" */
  OrganisationNameAbbreviationAddressId_90c82dfeUniq = 'organisation_name_abbreviation_address_id_90c82dfe_uniq',
  /** unique or primary key constraint on columns "photo_id" */
  OrganisationPhotoIdKey = 'organisation_photo_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganisationPkey = 'organisation_pkey',
  /** unique or primary key constraint on columns "uid" */
  OrganisationUidKey = 'organisation_uid_key'
}

/** columns and relationships of "organisation_crop" */
export type Organisation_Crop = {
  __typename?: 'organisation_crop';
  crop_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  use_production_flow: Scalars['Boolean'];
};

/** aggregated selection of "organisation_crop" */
export type Organisation_Crop_Aggregate = {
  __typename?: 'organisation_crop_aggregate';
  aggregate?: Maybe<Organisation_Crop_Aggregate_Fields>;
  nodes: Array<Organisation_Crop>;
};

/** aggregate fields of "organisation_crop" */
export type Organisation_Crop_Aggregate_Fields = {
  __typename?: 'organisation_crop_aggregate_fields';
  avg?: Maybe<Organisation_Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Crop_Max_Fields>;
  min?: Maybe<Organisation_Crop_Min_Fields>;
  stddev?: Maybe<Organisation_Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Crop_Sum_Fields>;
  var_pop?: Maybe<Organisation_Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Crop_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Crop_Variance_Fields>;
};


/** aggregate fields of "organisation_crop" */
export type Organisation_Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organisation_crop" */
export type Organisation_Crop_Aggregate_Order_By = {
  avg?: InputMaybe<Organisation_Crop_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Crop_Max_Order_By>;
  min?: InputMaybe<Organisation_Crop_Min_Order_By>;
  stddev?: InputMaybe<Organisation_Crop_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organisation_Crop_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organisation_Crop_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organisation_Crop_Sum_Order_By>;
  var_pop?: InputMaybe<Organisation_Crop_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organisation_Crop_Var_Samp_Order_By>;
  variance?: InputMaybe<Organisation_Crop_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_crop" */
export type Organisation_Crop_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Crop_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Crop_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Crop_Avg_Fields = {
  __typename?: 'organisation_crop_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organisation_crop" */
export type Organisation_Crop_Avg_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_crop". All fields are combined with a logical 'AND'. */
export type Organisation_Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Crop_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Crop_Bool_Exp>>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  use_production_flow?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_crop" */
export enum Organisation_Crop_Constraint {
  /** unique or primary key constraint on columns "crop_id", "organisation_id" */
  OrganisationCropOrganisationIdCropId_22c3dc90Uniq = 'organisation_crop_organisation_id_crop_id_22c3dc90_uniq',
  /** unique or primary key constraint on columns "id" */
  OrganisationCropPkey = 'organisation_crop_pkey'
}

/** input type for incrementing numeric columns in table "organisation_crop" */
export type Organisation_Crop_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_crop" */
export type Organisation_Crop_Insert_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  use_production_flow?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Organisation_Crop_Max_Fields = {
  __typename?: 'organisation_crop_max_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "organisation_crop" */
export type Organisation_Crop_Max_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Crop_Min_Fields = {
  __typename?: 'organisation_crop_min_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "organisation_crop" */
export type Organisation_Crop_Min_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_crop" */
export type Organisation_Crop_Mutation_Response = {
  __typename?: 'organisation_crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Crop>;
};

/** on_conflict condition type for table "organisation_crop" */
export type Organisation_Crop_On_Conflict = {
  constraint: Organisation_Crop_Constraint;
  update_columns?: Array<Organisation_Crop_Update_Column>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_crop". */
export type Organisation_Crop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  use_production_flow?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_crop */
export type Organisation_Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_crop" */
export enum Organisation_Crop_Select_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UseProductionFlow = 'use_production_flow'
}

/** input type for updating data in table "organisation_crop" */
export type Organisation_Crop_Set_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  use_production_flow?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Organisation_Crop_Stddev_Fields = {
  __typename?: 'organisation_crop_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organisation_crop" */
export type Organisation_Crop_Stddev_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Crop_Stddev_Pop_Fields = {
  __typename?: 'organisation_crop_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organisation_crop" */
export type Organisation_Crop_Stddev_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Crop_Stddev_Samp_Fields = {
  __typename?: 'organisation_crop_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organisation_crop" */
export type Organisation_Crop_Stddev_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation_crop" */
export type Organisation_Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Crop_Stream_Cursor_Value_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  use_production_flow?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Organisation_Crop_Sum_Fields = {
  __typename?: 'organisation_crop_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organisation_crop" */
export type Organisation_Crop_Sum_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** update columns of table "organisation_crop" */
export enum Organisation_Crop_Update_Column {
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UseProductionFlow = 'use_production_flow'
}

export type Organisation_Crop_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Crop_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Crop_Set_Input>;
  where: Organisation_Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Crop_Var_Pop_Fields = {
  __typename?: 'organisation_crop_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organisation_crop" */
export type Organisation_Crop_Var_Pop_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Crop_Var_Samp_Fields = {
  __typename?: 'organisation_crop_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organisation_crop" */
export type Organisation_Crop_Var_Samp_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Crop_Variance_Fields = {
  __typename?: 'organisation_crop_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organisation_crop" */
export type Organisation_Crop_Variance_Order_By = {
  crop_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organisation_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organisation_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organisation_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "organisation_document_kind" */
export type Organisation_Document_Kind = {
  __typename?: 'organisation_document_kind';
  /** An object relationship */
  document_kind: Document_Kind;
  document_kind_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  sequence_no: Scalars['Int'];
};

/** aggregated selection of "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate = {
  __typename?: 'organisation_document_kind_aggregate';
  aggregate?: Maybe<Organisation_Document_Kind_Aggregate_Fields>;
  nodes: Array<Organisation_Document_Kind>;
};

/** aggregate fields of "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate_Fields = {
  __typename?: 'organisation_document_kind_aggregate_fields';
  avg?: Maybe<Organisation_Document_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Document_Kind_Max_Fields>;
  min?: Maybe<Organisation_Document_Kind_Min_Fields>;
  stddev?: Maybe<Organisation_Document_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Document_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Document_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Document_Kind_Sum_Fields>;
  var_pop?: Maybe<Organisation_Document_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Document_Kind_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Document_Kind_Variance_Fields>;
};


/** aggregate fields of "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organisation_document_kind" */
export type Organisation_Document_Kind_Aggregate_Order_By = {
  avg?: InputMaybe<Organisation_Document_Kind_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Document_Kind_Max_Order_By>;
  min?: InputMaybe<Organisation_Document_Kind_Min_Order_By>;
  stddev?: InputMaybe<Organisation_Document_Kind_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organisation_Document_Kind_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organisation_Document_Kind_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organisation_Document_Kind_Sum_Order_By>;
  var_pop?: InputMaybe<Organisation_Document_Kind_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organisation_Document_Kind_Var_Samp_Order_By>;
  variance?: InputMaybe<Organisation_Document_Kind_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_document_kind" */
export type Organisation_Document_Kind_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Document_Kind_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Document_Kind_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Document_Kind_Avg_Fields = {
  __typename?: 'organisation_document_kind_avg_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Avg_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_document_kind". All fields are combined with a logical 'AND'. */
export type Organisation_Document_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Document_Kind_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Document_Kind_Bool_Exp>>;
  document_kind?: InputMaybe<Document_Kind_Bool_Exp>;
  document_kind_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  sequence_no?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_document_kind" */
export enum Organisation_Document_Kind_Constraint {
  /** unique or primary key constraint on columns "document_kind_id", "organisation_id" */
  OrganisationDocumentKiOrganisationIdDocument_4449ee3fUniq = 'organisation_document_ki_organisation_id_document_4449ee3f_uniq',
  /** unique or primary key constraint on columns "id" */
  OrganisationDocumentKindPkey = 'organisation_document_kind_pkey'
}

/** input type for incrementing numeric columns in table "organisation_document_kind" */
export type Organisation_Document_Kind_Inc_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_document_kind" */
export type Organisation_Document_Kind_Insert_Input = {
  document_kind?: InputMaybe<Document_Kind_Obj_Rel_Insert_Input>;
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Organisation_Document_Kind_Max_Fields = {
  __typename?: 'organisation_document_kind_max_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Max_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Document_Kind_Min_Fields = {
  __typename?: 'organisation_document_kind_min_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Min_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_document_kind" */
export type Organisation_Document_Kind_Mutation_Response = {
  __typename?: 'organisation_document_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Document_Kind>;
};

/** on_conflict condition type for table "organisation_document_kind" */
export type Organisation_Document_Kind_On_Conflict = {
  constraint: Organisation_Document_Kind_Constraint;
  update_columns?: Array<Organisation_Document_Kind_Update_Column>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_document_kind". */
export type Organisation_Document_Kind_Order_By = {
  document_kind?: InputMaybe<Document_Kind_Order_By>;
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_document_kind */
export type Organisation_Document_Kind_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_document_kind" */
export enum Organisation_Document_Kind_Select_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SequenceNo = 'sequence_no'
}

/** input type for updating data in table "organisation_document_kind" */
export type Organisation_Document_Kind_Set_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Document_Kind_Stddev_Fields = {
  __typename?: 'organisation_document_kind_stddev_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Stddev_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Document_Kind_Stddev_Pop_Fields = {
  __typename?: 'organisation_document_kind_stddev_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Stddev_Pop_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Document_Kind_Stddev_Samp_Fields = {
  __typename?: 'organisation_document_kind_stddev_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Stddev_Samp_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation_document_kind" */
export type Organisation_Document_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Document_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Document_Kind_Stream_Cursor_Value_Input = {
  document_kind_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Document_Kind_Sum_Fields = {
  __typename?: 'organisation_document_kind_sum_fields';
  document_kind_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Sum_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** update columns of table "organisation_document_kind" */
export enum Organisation_Document_Kind_Update_Column {
  /** column name */
  DocumentKindId = 'document_kind_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  SequenceNo = 'sequence_no'
}

export type Organisation_Document_Kind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Document_Kind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Document_Kind_Set_Input>;
  where: Organisation_Document_Kind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Document_Kind_Var_Pop_Fields = {
  __typename?: 'organisation_document_kind_var_pop_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Var_Pop_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Document_Kind_Var_Samp_Fields = {
  __typename?: 'organisation_document_kind_var_samp_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Var_Samp_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Document_Kind_Variance_Fields = {
  __typename?: 'organisation_document_kind_variance_fields';
  document_kind_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organisation_document_kind" */
export type Organisation_Document_Kind_Variance_Order_By = {
  document_kind_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "organisation" */
export type Organisation_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation" */
export type Organisation_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Company_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  level_1_approval_flow?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Arr_Rel_Insert_Input>;
  org_team_user_document_associations?: InputMaybe<Org_Team_User_Document_Association_Arr_Rel_Insert_Input>;
  org_user_group_mandatory_documents?: InputMaybe<Org_User_Group_Mandatory_Document_Arr_Rel_Insert_Input>;
  organisation_document_kinds?: InputMaybe<Organisation_Document_Kind_Arr_Rel_Insert_Input>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Organisation_Max_Fields = {
  __typename?: 'organisation_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Organisation_Min_Fields = {
  __typename?: 'organisation_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  tnc?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "organisation" */
export type Organisation_Mutation_Response = {
  __typename?: 'organisation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation>;
};

/** input type for inserting object relation for remote table "organisation" */
export type Organisation_Obj_Rel_Insert_Input = {
  data: Organisation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_On_Conflict>;
};

/** on_conflict condition type for table "organisation" */
export type Organisation_On_Conflict = {
  constraint: Organisation_Constraint;
  update_columns?: Array<Organisation_Update_Column>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation". */
export type Organisation_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Company_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  level_1_approval_flow?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_team_user_bank_associations_aggregate?: InputMaybe<Org_Team_User_Bank_Association_Aggregate_Order_By>;
  org_team_user_document_associations_aggregate?: InputMaybe<Org_Team_User_Document_Association_Aggregate_Order_By>;
  org_user_group_mandatory_documents_aggregate?: InputMaybe<Org_User_Group_Mandatory_Document_Aggregate_Order_By>;
  organisation_document_kinds_aggregate?: InputMaybe<Organisation_Document_Kind_Aggregate_Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation */
export type Organisation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "organisation_preferences" */
export type Organisation_Preferences = {
  __typename?: 'organisation_preferences';
  farm_suffix: Scalars['String'];
  field_suffix: Scalars['String'];
  id: Scalars['Int'];
  organisation_id: Scalars['Int'];
  plot_crop_suffix: Scalars['String'];
  plot_suffix: Scalars['String'];
};

/** aggregated selection of "organisation_preferences" */
export type Organisation_Preferences_Aggregate = {
  __typename?: 'organisation_preferences_aggregate';
  aggregate?: Maybe<Organisation_Preferences_Aggregate_Fields>;
  nodes: Array<Organisation_Preferences>;
};

/** aggregate fields of "organisation_preferences" */
export type Organisation_Preferences_Aggregate_Fields = {
  __typename?: 'organisation_preferences_aggregate_fields';
  avg?: Maybe<Organisation_Preferences_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Preferences_Max_Fields>;
  min?: Maybe<Organisation_Preferences_Min_Fields>;
  stddev?: Maybe<Organisation_Preferences_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Preferences_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Preferences_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Preferences_Sum_Fields>;
  var_pop?: Maybe<Organisation_Preferences_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Preferences_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Preferences_Variance_Fields>;
};


/** aggregate fields of "organisation_preferences" */
export type Organisation_Preferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Organisation_Preferences_Avg_Fields = {
  __typename?: 'organisation_preferences_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organisation_preferences". All fields are combined with a logical 'AND'. */
export type Organisation_Preferences_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Preferences_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Preferences_Bool_Exp>>;
  farm_suffix?: InputMaybe<String_Comparison_Exp>;
  field_suffix?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop_suffix?: InputMaybe<String_Comparison_Exp>;
  plot_suffix?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_preferences" */
export enum Organisation_Preferences_Constraint {
  /** unique or primary key constraint on columns "organisation_id" */
  OrganisationPreferencesOrganisationIdKey = 'organisation_preferences_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganisationPreferencesPkey = 'organisation_preferences_pkey'
}

/** input type for incrementing numeric columns in table "organisation_preferences" */
export type Organisation_Preferences_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_preferences" */
export type Organisation_Preferences_Insert_Input = {
  farm_suffix?: InputMaybe<Scalars['String']>;
  field_suffix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_crop_suffix?: InputMaybe<Scalars['String']>;
  plot_suffix?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organisation_Preferences_Max_Fields = {
  __typename?: 'organisation_preferences_max_fields';
  farm_suffix?: Maybe<Scalars['String']>;
  field_suffix?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  plot_crop_suffix?: Maybe<Scalars['String']>;
  plot_suffix?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organisation_Preferences_Min_Fields = {
  __typename?: 'organisation_preferences_min_fields';
  farm_suffix?: Maybe<Scalars['String']>;
  field_suffix?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  plot_crop_suffix?: Maybe<Scalars['String']>;
  plot_suffix?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organisation_preferences" */
export type Organisation_Preferences_Mutation_Response = {
  __typename?: 'organisation_preferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Preferences>;
};

/** on_conflict condition type for table "organisation_preferences" */
export type Organisation_Preferences_On_Conflict = {
  constraint: Organisation_Preferences_Constraint;
  update_columns?: Array<Organisation_Preferences_Update_Column>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_preferences". */
export type Organisation_Preferences_Order_By = {
  farm_suffix?: InputMaybe<Order_By>;
  field_suffix?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_crop_suffix?: InputMaybe<Order_By>;
  plot_suffix?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_preferences */
export type Organisation_Preferences_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_preferences" */
export enum Organisation_Preferences_Select_Column {
  /** column name */
  FarmSuffix = 'farm_suffix',
  /** column name */
  FieldSuffix = 'field_suffix',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PlotCropSuffix = 'plot_crop_suffix',
  /** column name */
  PlotSuffix = 'plot_suffix'
}

/** input type for updating data in table "organisation_preferences" */
export type Organisation_Preferences_Set_Input = {
  farm_suffix?: InputMaybe<Scalars['String']>;
  field_suffix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_crop_suffix?: InputMaybe<Scalars['String']>;
  plot_suffix?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Organisation_Preferences_Stddev_Fields = {
  __typename?: 'organisation_preferences_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Preferences_Stddev_Pop_Fields = {
  __typename?: 'organisation_preferences_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Preferences_Stddev_Samp_Fields = {
  __typename?: 'organisation_preferences_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organisation_preferences" */
export type Organisation_Preferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Preferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Preferences_Stream_Cursor_Value_Input = {
  farm_suffix?: InputMaybe<Scalars['String']>;
  field_suffix?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_crop_suffix?: InputMaybe<Scalars['String']>;
  plot_suffix?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Organisation_Preferences_Sum_Fields = {
  __typename?: 'organisation_preferences_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "organisation_preferences" */
export enum Organisation_Preferences_Update_Column {
  /** column name */
  FarmSuffix = 'farm_suffix',
  /** column name */
  FieldSuffix = 'field_suffix',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PlotCropSuffix = 'plot_crop_suffix',
  /** column name */
  PlotSuffix = 'plot_suffix'
}

export type Organisation_Preferences_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Preferences_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Preferences_Set_Input>;
  where: Organisation_Preferences_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Preferences_Var_Pop_Fields = {
  __typename?: 'organisation_preferences_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organisation_Preferences_Var_Samp_Fields = {
  __typename?: 'organisation_preferences_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organisation_Preferences_Variance_Fields = {
  __typename?: 'organisation_preferences_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "organisation_season" */
export type Organisation_Season = {
  __typename?: 'organisation_season';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
};

/** aggregated selection of "organisation_season" */
export type Organisation_Season_Aggregate = {
  __typename?: 'organisation_season_aggregate';
  aggregate?: Maybe<Organisation_Season_Aggregate_Fields>;
  nodes: Array<Organisation_Season>;
};

/** aggregate fields of "organisation_season" */
export type Organisation_Season_Aggregate_Fields = {
  __typename?: 'organisation_season_aggregate_fields';
  avg?: Maybe<Organisation_Season_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organisation_Season_Max_Fields>;
  min?: Maybe<Organisation_Season_Min_Fields>;
  stddev?: Maybe<Organisation_Season_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Season_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Season_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Season_Sum_Fields>;
  var_pop?: Maybe<Organisation_Season_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Season_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Season_Variance_Fields>;
};


/** aggregate fields of "organisation_season" */
export type Organisation_Season_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Organisation_Season_Avg_Fields = {
  __typename?: 'organisation_season_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organisation_season". All fields are combined with a logical 'AND'. */
export type Organisation_Season_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Season_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Season_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Season_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_season" */
export enum Organisation_Season_Constraint {
  /** unique or primary key constraint on columns "codename" */
  OrganisationSeasonCodenameKey = 'organisation_season_codename_key',
  /** unique or primary key constraint on columns "id" */
  OrganisationSeasonPkey = 'organisation_season_pkey'
}

/** input type for incrementing numeric columns in table "organisation_season" */
export type Organisation_Season_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organisation_season" */
export type Organisation_Season_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Organisation_Season_Max_Fields = {
  __typename?: 'organisation_season_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Organisation_Season_Min_Fields = {
  __typename?: 'organisation_season_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "organisation_season" */
export type Organisation_Season_Mutation_Response = {
  __typename?: 'organisation_season_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Season>;
};

/** on_conflict condition type for table "organisation_season" */
export type Organisation_Season_On_Conflict = {
  constraint: Organisation_Season_Constraint;
  update_columns?: Array<Organisation_Season_Update_Column>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_season". */
export type Organisation_Season_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_season */
export type Organisation_Season_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "organisation_season" */
export enum Organisation_Season_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id'
}

/** input type for updating data in table "organisation_season" */
export type Organisation_Season_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Season_Stddev_Fields = {
  __typename?: 'organisation_season_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Season_Stddev_Pop_Fields = {
  __typename?: 'organisation_season_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Season_Stddev_Samp_Fields = {
  __typename?: 'organisation_season_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organisation_season" */
export type Organisation_Season_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Season_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Season_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Season_Sum_Fields = {
  __typename?: 'organisation_season_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "organisation_season" */
export enum Organisation_Season_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id'
}

export type Organisation_Season_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Season_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Season_Set_Input>;
  where: Organisation_Season_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Season_Var_Pop_Fields = {
  __typename?: 'organisation_season_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organisation_Season_Var_Samp_Fields = {
  __typename?: 'organisation_season_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organisation_Season_Variance_Fields = {
  __typename?: 'organisation_season_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "organisation" */
export enum Organisation_Select_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Level_1ApprovalFlow = 'level_1_approval_flow',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "organisation" */
export type Organisation_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  level_1_approval_flow?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Organisation_Stddev_Fields = {
  __typename?: 'organisation_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Stddev_Pop_Fields = {
  __typename?: 'organisation_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Stddev_Samp_Fields = {
  __typename?: 'organisation_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organisation" */
export type Organisation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  level_1_approval_flow?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  tnc?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Organisation_Sum_Fields = {
  __typename?: 'organisation_sum_fields';
  address_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "organisation" */
export enum Organisation_Update_Column {
  /** column name */
  Abbreviation = 'abbreviation',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Level_1ApprovalFlow = 'level_1_approval_flow',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  Uid = 'uid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Organisation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organisation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organisation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organisation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organisation_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organisation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Set_Input>;
  where: Organisation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisation_Var_Pop_Fields = {
  __typename?: 'organisation_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organisation_Var_Samp_Fields = {
  __typename?: 'organisation_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organisation_Variance_Fields = {
  __typename?: 'organisation_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "over_draft" */
export type Over_Draft = {
  __typename?: 'over_draft';
  amount: Scalars['float8'];
  amount_from_credit: Scalars['float8'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  credit: Credit;
  credit_id: Scalars['bigint'];
  /** An object relationship */
  deviation_final_officer_one?: Maybe<Setu_Trade_Shared_Entity>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  deviation_final_officer_two?: Maybe<Setu_Trade_Shared_Entity>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  deviation_recommendation_officer?: Maybe<Setu_Trade_Shared_Entity>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: Maybe<Scalars['String']>;
  deviation_senior_officer_remark?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  last_wati_log?: Maybe<Scalars['String']>;
  /** An array relationship */
  logs: Array<Over_Draft_Log>;
  /** An aggregate relationship */
  logs_aggregate: Over_Draft_Log_Aggregate;
  od_count: Scalars['Int'];
  outstanding_amount: Scalars['float8'];
  settled_amount: Scalars['float8'];
  status: Scalars['String'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "over_draft" */
export type Over_DraftLogsArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Bool_Exp>;
};


/** columns and relationships of "over_draft" */
export type Over_DraftLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Bool_Exp>;
};

/** aggregated selection of "over_draft" */
export type Over_Draft_Aggregate = {
  __typename?: 'over_draft_aggregate';
  aggregate?: Maybe<Over_Draft_Aggregate_Fields>;
  nodes: Array<Over_Draft>;
};

/** aggregate fields of "over_draft" */
export type Over_Draft_Aggregate_Fields = {
  __typename?: 'over_draft_aggregate_fields';
  avg?: Maybe<Over_Draft_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Over_Draft_Max_Fields>;
  min?: Maybe<Over_Draft_Min_Fields>;
  stddev?: Maybe<Over_Draft_Stddev_Fields>;
  stddev_pop?: Maybe<Over_Draft_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Over_Draft_Stddev_Samp_Fields>;
  sum?: Maybe<Over_Draft_Sum_Fields>;
  var_pop?: Maybe<Over_Draft_Var_Pop_Fields>;
  var_samp?: Maybe<Over_Draft_Var_Samp_Fields>;
  variance?: Maybe<Over_Draft_Variance_Fields>;
};


/** aggregate fields of "over_draft" */
export type Over_Draft_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Over_Draft_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "over_draft" */
export type Over_Draft_Aggregate_Order_By = {
  avg?: InputMaybe<Over_Draft_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Over_Draft_Max_Order_By>;
  min?: InputMaybe<Over_Draft_Min_Order_By>;
  stddev?: InputMaybe<Over_Draft_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Over_Draft_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Over_Draft_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Over_Draft_Sum_Order_By>;
  var_pop?: InputMaybe<Over_Draft_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Over_Draft_Var_Samp_Order_By>;
  variance?: InputMaybe<Over_Draft_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Over_Draft_Avg_Fields = {
  __typename?: 'over_draft_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_from_credit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "over_draft" */
export type Over_Draft_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "over_draft". All fields are combined with a logical 'AND'. */
export type Over_Draft_Bool_Exp = {
  _and?: InputMaybe<Array<Over_Draft_Bool_Exp>>;
  _not?: InputMaybe<Over_Draft_Bool_Exp>;
  _or?: InputMaybe<Array<Over_Draft_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  amount_from_credit?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit?: InputMaybe<Credit_Bool_Exp>;
  credit_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_one?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  deviation_final_officer_one_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_one_remark?: InputMaybe<String_Comparison_Exp>;
  deviation_final_officer_two?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  deviation_final_officer_two_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_two_remark?: InputMaybe<String_Comparison_Exp>;
  deviation_recommendation_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  deviation_recommendation_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_recommendation_officer_remark?: InputMaybe<String_Comparison_Exp>;
  deviation_senior_officer_remark?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_wati_log?: InputMaybe<String_Comparison_Exp>;
  logs?: InputMaybe<Over_Draft_Log_Bool_Exp>;
  od_count?: InputMaybe<Int_Comparison_Exp>;
  outstanding_amount?: InputMaybe<Float8_Comparison_Exp>;
  settled_amount?: InputMaybe<Float8_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "over_draft_cw" */
export type Over_Draft_Cw = {
  __typename?: 'over_draft_cw';
  amount: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  credit_wallet_id: Scalars['bigint'];
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: Maybe<Scalars['String']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: Maybe<Scalars['String']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: Maybe<Scalars['String']>;
  deviation_senior_officer_remark?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  last_wati_log?: Maybe<Scalars['String']>;
  /** An array relationship */
  logs: Array<Over_Draft_Log_Cw>;
  /** An aggregate relationship */
  logs_aggregate: Over_Draft_Log_Cw_Aggregate;
  od_count: Scalars['Int'];
  status: Scalars['String'];
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "over_draft_cw" */
export type Over_Draft_CwLogsArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
};


/** columns and relationships of "over_draft_cw" */
export type Over_Draft_CwLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
};

/** aggregated selection of "over_draft_cw" */
export type Over_Draft_Cw_Aggregate = {
  __typename?: 'over_draft_cw_aggregate';
  aggregate?: Maybe<Over_Draft_Cw_Aggregate_Fields>;
  nodes: Array<Over_Draft_Cw>;
};

/** aggregate fields of "over_draft_cw" */
export type Over_Draft_Cw_Aggregate_Fields = {
  __typename?: 'over_draft_cw_aggregate_fields';
  avg?: Maybe<Over_Draft_Cw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Over_Draft_Cw_Max_Fields>;
  min?: Maybe<Over_Draft_Cw_Min_Fields>;
  stddev?: Maybe<Over_Draft_Cw_Stddev_Fields>;
  stddev_pop?: Maybe<Over_Draft_Cw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Over_Draft_Cw_Stddev_Samp_Fields>;
  sum?: Maybe<Over_Draft_Cw_Sum_Fields>;
  var_pop?: Maybe<Over_Draft_Cw_Var_Pop_Fields>;
  var_samp?: Maybe<Over_Draft_Cw_Var_Samp_Fields>;
  variance?: Maybe<Over_Draft_Cw_Variance_Fields>;
};


/** aggregate fields of "over_draft_cw" */
export type Over_Draft_Cw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Over_Draft_Cw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "over_draft_cw" */
export type Over_Draft_Cw_Aggregate_Order_By = {
  avg?: InputMaybe<Over_Draft_Cw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Over_Draft_Cw_Max_Order_By>;
  min?: InputMaybe<Over_Draft_Cw_Min_Order_By>;
  stddev?: InputMaybe<Over_Draft_Cw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Over_Draft_Cw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Over_Draft_Cw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Over_Draft_Cw_Sum_Order_By>;
  var_pop?: InputMaybe<Over_Draft_Cw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Over_Draft_Cw_Var_Samp_Order_By>;
  variance?: InputMaybe<Over_Draft_Cw_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Over_Draft_Cw_Avg_Fields = {
  __typename?: 'over_draft_cw_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "over_draft_cw". All fields are combined with a logical 'AND'. */
export type Over_Draft_Cw_Bool_Exp = {
  _and?: InputMaybe<Array<Over_Draft_Cw_Bool_Exp>>;
  _not?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
  _or?: InputMaybe<Array<Over_Draft_Cw_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit_wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_one_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_one_remark?: InputMaybe<String_Comparison_Exp>;
  deviation_final_officer_two_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_final_officer_two_remark?: InputMaybe<String_Comparison_Exp>;
  deviation_recommendation_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  deviation_recommendation_officer_remark?: InputMaybe<String_Comparison_Exp>;
  deviation_senior_officer_remark?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_wati_log?: InputMaybe<String_Comparison_Exp>;
  logs?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
  od_count?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Over_Draft_Cw_Max_Fields = {
  __typename?: 'over_draft_cw_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: Maybe<Scalars['String']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: Maybe<Scalars['String']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: Maybe<Scalars['String']>;
  deviation_senior_officer_remark?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_wati_log?: Maybe<Scalars['String']>;
  od_count?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_remark?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_remark?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_remark?: InputMaybe<Order_By>;
  deviation_senior_officer_remark?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_wati_log?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Over_Draft_Cw_Min_Fields = {
  __typename?: 'over_draft_cw_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: Maybe<Scalars['String']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: Maybe<Scalars['String']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: Maybe<Scalars['String']>;
  deviation_senior_officer_remark?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_wati_log?: Maybe<Scalars['String']>;
  od_count?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_remark?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_remark?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_remark?: InputMaybe<Order_By>;
  deviation_senior_officer_remark?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_wati_log?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "over_draft_cw". */
export type Over_Draft_Cw_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_remark?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_remark?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_remark?: InputMaybe<Order_By>;
  deviation_senior_officer_remark?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_wati_log?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Over_Draft_Log_Cw_Aggregate_Order_By>;
  od_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "over_draft_cw" */
export enum Over_Draft_Cw_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreditWalletId = 'credit_wallet_id',
  /** column name */
  DeviationFinalOfficerOneId = 'deviation_final_officer_one_id',
  /** column name */
  DeviationFinalOfficerOneRemark = 'deviation_final_officer_one_remark',
  /** column name */
  DeviationFinalOfficerTwoId = 'deviation_final_officer_two_id',
  /** column name */
  DeviationFinalOfficerTwoRemark = 'deviation_final_officer_two_remark',
  /** column name */
  DeviationRecommendationOfficerId = 'deviation_recommendation_officer_id',
  /** column name */
  DeviationRecommendationOfficerRemark = 'deviation_recommendation_officer_remark',
  /** column name */
  DeviationSeniorOfficerRemark = 'deviation_senior_officer_remark',
  /** column name */
  Id = 'id',
  /** column name */
  LastWatiLog = 'last_wati_log',
  /** column name */
  OdCount = 'od_count',
  /** column name */
  Status = 'status',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** aggregate stddev on columns */
export type Over_Draft_Cw_Stddev_Fields = {
  __typename?: 'over_draft_cw_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Over_Draft_Cw_Stddev_Pop_Fields = {
  __typename?: 'over_draft_cw_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Over_Draft_Cw_Stddev_Samp_Fields = {
  __typename?: 'over_draft_cw_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "over_draft_cw" */
export type Over_Draft_Cw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Over_Draft_Cw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Over_Draft_Cw_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  credit_wallet_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: InputMaybe<Scalars['String']>;
  deviation_final_officer_two_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: InputMaybe<Scalars['String']>;
  deviation_recommendation_officer_id?: InputMaybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: InputMaybe<Scalars['String']>;
  deviation_senior_officer_remark?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_wati_log?: InputMaybe<Scalars['String']>;
  od_count?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Over_Draft_Cw_Sum_Fields = {
  __typename?: 'over_draft_cw_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  od_count?: Maybe<Scalars['Int']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Over_Draft_Cw_Var_Pop_Fields = {
  __typename?: 'over_draft_cw_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Over_Draft_Cw_Var_Samp_Fields = {
  __typename?: 'over_draft_cw_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Over_Draft_Cw_Variance_Fields = {
  __typename?: 'over_draft_cw_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "over_draft_cw" */
export type Over_Draft_Cw_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "over_draft_log" */
export type Over_Draft_Log = {
  __typename?: 'over_draft_log';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  over_draft: Over_Draft;
  over_draft_id: Scalars['bigint'];
  remark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "over_draft_log" */
export type Over_Draft_Log_Aggregate = {
  __typename?: 'over_draft_log_aggregate';
  aggregate?: Maybe<Over_Draft_Log_Aggregate_Fields>;
  nodes: Array<Over_Draft_Log>;
};

/** aggregate fields of "over_draft_log" */
export type Over_Draft_Log_Aggregate_Fields = {
  __typename?: 'over_draft_log_aggregate_fields';
  avg?: Maybe<Over_Draft_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Over_Draft_Log_Max_Fields>;
  min?: Maybe<Over_Draft_Log_Min_Fields>;
  stddev?: Maybe<Over_Draft_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Over_Draft_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Over_Draft_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Over_Draft_Log_Sum_Fields>;
  var_pop?: Maybe<Over_Draft_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Over_Draft_Log_Var_Samp_Fields>;
  variance?: Maybe<Over_Draft_Log_Variance_Fields>;
};


/** aggregate fields of "over_draft_log" */
export type Over_Draft_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Over_Draft_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "over_draft_log" */
export type Over_Draft_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Over_Draft_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Over_Draft_Log_Max_Order_By>;
  min?: InputMaybe<Over_Draft_Log_Min_Order_By>;
  stddev?: InputMaybe<Over_Draft_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Over_Draft_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Over_Draft_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Over_Draft_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Over_Draft_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Over_Draft_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Over_Draft_Log_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Over_Draft_Log_Avg_Fields = {
  __typename?: 'over_draft_log_avg_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "over_draft_log" */
export type Over_Draft_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "over_draft_log". All fields are combined with a logical 'AND'. */
export type Over_Draft_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Over_Draft_Log_Bool_Exp>>;
  _not?: InputMaybe<Over_Draft_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Over_Draft_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  over_draft?: InputMaybe<Over_Draft_Bool_Exp>;
  over_draft_id?: InputMaybe<Bigint_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "over_draft_log_cw" */
export type Over_Draft_Log_Cw = {
  __typename?: 'over_draft_log_cw';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  over_draft: Over_Draft_Cw;
  over_draft_id: Scalars['bigint'];
  remark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Aggregate = {
  __typename?: 'over_draft_log_cw_aggregate';
  aggregate?: Maybe<Over_Draft_Log_Cw_Aggregate_Fields>;
  nodes: Array<Over_Draft_Log_Cw>;
};

/** aggregate fields of "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Aggregate_Fields = {
  __typename?: 'over_draft_log_cw_aggregate_fields';
  avg?: Maybe<Over_Draft_Log_Cw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Over_Draft_Log_Cw_Max_Fields>;
  min?: Maybe<Over_Draft_Log_Cw_Min_Fields>;
  stddev?: Maybe<Over_Draft_Log_Cw_Stddev_Fields>;
  stddev_pop?: Maybe<Over_Draft_Log_Cw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Over_Draft_Log_Cw_Stddev_Samp_Fields>;
  sum?: Maybe<Over_Draft_Log_Cw_Sum_Fields>;
  var_pop?: Maybe<Over_Draft_Log_Cw_Var_Pop_Fields>;
  var_samp?: Maybe<Over_Draft_Log_Cw_Var_Samp_Fields>;
  variance?: Maybe<Over_Draft_Log_Cw_Variance_Fields>;
};


/** aggregate fields of "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Over_Draft_Log_Cw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Aggregate_Order_By = {
  avg?: InputMaybe<Over_Draft_Log_Cw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Over_Draft_Log_Cw_Max_Order_By>;
  min?: InputMaybe<Over_Draft_Log_Cw_Min_Order_By>;
  stddev?: InputMaybe<Over_Draft_Log_Cw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Over_Draft_Log_Cw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Over_Draft_Log_Cw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Over_Draft_Log_Cw_Sum_Order_By>;
  var_pop?: InputMaybe<Over_Draft_Log_Cw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Over_Draft_Log_Cw_Var_Samp_Order_By>;
  variance?: InputMaybe<Over_Draft_Log_Cw_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Over_Draft_Log_Cw_Avg_Fields = {
  __typename?: 'over_draft_log_cw_avg_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "over_draft_log_cw". All fields are combined with a logical 'AND'. */
export type Over_Draft_Log_Cw_Bool_Exp = {
  _and?: InputMaybe<Array<Over_Draft_Log_Cw_Bool_Exp>>;
  _not?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
  _or?: InputMaybe<Array<Over_Draft_Log_Cw_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  over_draft?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
  over_draft_id?: InputMaybe<Bigint_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Over_Draft_Log_Cw_Max_Fields = {
  __typename?: 'over_draft_log_cw_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  over_draft_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Over_Draft_Log_Cw_Min_Fields = {
  __typename?: 'over_draft_log_cw_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  over_draft_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "over_draft_log_cw". */
export type Over_Draft_Log_Cw_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_draft?: InputMaybe<Over_Draft_Cw_Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "over_draft_log_cw" */
export enum Over_Draft_Log_Cw_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OverDraftId = 'over_draft_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Over_Draft_Log_Cw_Stddev_Fields = {
  __typename?: 'over_draft_log_cw_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Over_Draft_Log_Cw_Stddev_Pop_Fields = {
  __typename?: 'over_draft_log_cw_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Over_Draft_Log_Cw_Stddev_Samp_Fields = {
  __typename?: 'over_draft_log_cw_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Over_Draft_Log_Cw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Over_Draft_Log_Cw_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  over_draft_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Over_Draft_Log_Cw_Sum_Fields = {
  __typename?: 'over_draft_log_cw_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  over_draft_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Over_Draft_Log_Cw_Var_Pop_Fields = {
  __typename?: 'over_draft_log_cw_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Over_Draft_Log_Cw_Var_Samp_Fields = {
  __typename?: 'over_draft_log_cw_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Over_Draft_Log_Cw_Variance_Fields = {
  __typename?: 'over_draft_log_cw_variance_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "over_draft_log_cw" */
export type Over_Draft_Log_Cw_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Over_Draft_Log_Max_Fields = {
  __typename?: 'over_draft_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  over_draft_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "over_draft_log" */
export type Over_Draft_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Over_Draft_Log_Min_Fields = {
  __typename?: 'over_draft_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  over_draft_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "over_draft_log" */
export type Over_Draft_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "over_draft_log". */
export type Over_Draft_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_draft?: InputMaybe<Over_Draft_Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "over_draft_log" */
export enum Over_Draft_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OverDraftId = 'over_draft_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Over_Draft_Log_Stddev_Fields = {
  __typename?: 'over_draft_log_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "over_draft_log" */
export type Over_Draft_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Over_Draft_Log_Stddev_Pop_Fields = {
  __typename?: 'over_draft_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "over_draft_log" */
export type Over_Draft_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Over_Draft_Log_Stddev_Samp_Fields = {
  __typename?: 'over_draft_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "over_draft_log" */
export type Over_Draft_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "over_draft_log" */
export type Over_Draft_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Over_Draft_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Over_Draft_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  over_draft_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Over_Draft_Log_Sum_Fields = {
  __typename?: 'over_draft_log_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  over_draft_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "over_draft_log" */
export type Over_Draft_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Over_Draft_Log_Var_Pop_Fields = {
  __typename?: 'over_draft_log_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "over_draft_log" */
export type Over_Draft_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Over_Draft_Log_Var_Samp_Fields = {
  __typename?: 'over_draft_log_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "over_draft_log" */
export type Over_Draft_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Over_Draft_Log_Variance_Fields = {
  __typename?: 'over_draft_log_variance_fields';
  id?: Maybe<Scalars['Float']>;
  over_draft_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "over_draft_log" */
export type Over_Draft_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  over_draft_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Over_Draft_Max_Fields = {
  __typename?: 'over_draft_max_fields';
  amount?: Maybe<Scalars['float8']>;
  amount_from_credit?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: Maybe<Scalars['String']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: Maybe<Scalars['String']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: Maybe<Scalars['String']>;
  deviation_senior_officer_remark?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_wati_log?: Maybe<Scalars['String']>;
  od_count?: Maybe<Scalars['Int']>;
  outstanding_amount?: Maybe<Scalars['float8']>;
  settled_amount?: Maybe<Scalars['float8']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "over_draft" */
export type Over_Draft_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_remark?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_remark?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_remark?: InputMaybe<Order_By>;
  deviation_senior_officer_remark?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_wati_log?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Over_Draft_Min_Fields = {
  __typename?: 'over_draft_min_fields';
  amount?: Maybe<Scalars['float8']>;
  amount_from_credit?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: Maybe<Scalars['String']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: Maybe<Scalars['String']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: Maybe<Scalars['String']>;
  deviation_senior_officer_remark?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_wati_log?: Maybe<Scalars['String']>;
  od_count?: Maybe<Scalars['Int']>;
  outstanding_amount?: Maybe<Scalars['float8']>;
  settled_amount?: Maybe<Scalars['float8']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "over_draft" */
export type Over_Draft_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_remark?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_remark?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_remark?: InputMaybe<Order_By>;
  deviation_senior_officer_remark?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_wati_log?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "over_draft". */
export type Over_Draft_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit?: InputMaybe<Credit_Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_remark?: InputMaybe<Order_By>;
  deviation_final_officer_two?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_remark?: InputMaybe<Order_By>;
  deviation_recommendation_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_remark?: InputMaybe<Order_By>;
  deviation_senior_officer_remark?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_wati_log?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Over_Draft_Log_Aggregate_Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "over_draft" */
export enum Over_Draft_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountFromCredit = 'amount_from_credit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  DeviationFinalOfficerOneId = 'deviation_final_officer_one_id',
  /** column name */
  DeviationFinalOfficerOneRemark = 'deviation_final_officer_one_remark',
  /** column name */
  DeviationFinalOfficerTwoId = 'deviation_final_officer_two_id',
  /** column name */
  DeviationFinalOfficerTwoRemark = 'deviation_final_officer_two_remark',
  /** column name */
  DeviationRecommendationOfficerId = 'deviation_recommendation_officer_id',
  /** column name */
  DeviationRecommendationOfficerRemark = 'deviation_recommendation_officer_remark',
  /** column name */
  DeviationSeniorOfficerRemark = 'deviation_senior_officer_remark',
  /** column name */
  Id = 'id',
  /** column name */
  LastWatiLog = 'last_wati_log',
  /** column name */
  OdCount = 'od_count',
  /** column name */
  OutstandingAmount = 'outstanding_amount',
  /** column name */
  SettledAmount = 'settled_amount',
  /** column name */
  Status = 'status',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** aggregate stddev on columns */
export type Over_Draft_Stddev_Fields = {
  __typename?: 'over_draft_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_from_credit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "over_draft" */
export type Over_Draft_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Over_Draft_Stddev_Pop_Fields = {
  __typename?: 'over_draft_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_from_credit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "over_draft" */
export type Over_Draft_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Over_Draft_Stddev_Samp_Fields = {
  __typename?: 'over_draft_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_from_credit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "over_draft" */
export type Over_Draft_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "over_draft" */
export type Over_Draft_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Over_Draft_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Over_Draft_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  amount_from_credit?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_one_remark?: InputMaybe<Scalars['String']>;
  deviation_final_officer_two_id?: InputMaybe<Scalars['bigint']>;
  deviation_final_officer_two_remark?: InputMaybe<Scalars['String']>;
  deviation_recommendation_officer_id?: InputMaybe<Scalars['bigint']>;
  deviation_recommendation_officer_remark?: InputMaybe<Scalars['String']>;
  deviation_senior_officer_remark?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_wati_log?: InputMaybe<Scalars['String']>;
  od_count?: InputMaybe<Scalars['Int']>;
  outstanding_amount?: InputMaybe<Scalars['float8']>;
  settled_amount?: InputMaybe<Scalars['float8']>;
  status?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Over_Draft_Sum_Fields = {
  __typename?: 'over_draft_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  amount_from_credit?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_one_id?: Maybe<Scalars['bigint']>;
  deviation_final_officer_two_id?: Maybe<Scalars['bigint']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  od_count?: Maybe<Scalars['Int']>;
  outstanding_amount?: Maybe<Scalars['float8']>;
  settled_amount?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "over_draft" */
export type Over_Draft_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Over_Draft_Var_Pop_Fields = {
  __typename?: 'over_draft_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_from_credit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "over_draft" */
export type Over_Draft_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Over_Draft_Var_Samp_Fields = {
  __typename?: 'over_draft_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_from_credit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "over_draft" */
export type Over_Draft_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Over_Draft_Variance_Fields = {
  __typename?: 'over_draft_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_from_credit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_one_id?: Maybe<Scalars['Float']>;
  deviation_final_officer_two_id?: Maybe<Scalars['Float']>;
  deviation_recommendation_officer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  od_count?: Maybe<Scalars['Float']>;
  outstanding_amount?: Maybe<Scalars['Float']>;
  settled_amount?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "over_draft" */
export type Over_Draft_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_from_credit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  deviation_final_officer_one_id?: InputMaybe<Order_By>;
  deviation_final_officer_two_id?: InputMaybe<Order_By>;
  deviation_recommendation_officer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  od_count?: InputMaybe<Order_By>;
  outstanding_amount?: InputMaybe<Order_By>;
  settled_amount?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "over_due_approval" */
export type Over_Due_Approval = {
  __typename?: 'over_due_approval';
  count: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  credit: Credit;
  credit_id: Scalars['bigint'];
  /** An object relationship */
  department?: Maybe<Setu_Trade_Shared_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  /** An array relationship */
  logs: Array<Over_Due_Approval_Log>;
  /** An aggregate relationship */
  logs_aggregate: Over_Due_Approval_Log_Aggregate;
  remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  sr_officer: Setu_Trade_Shared_Entity;
  sr_officer_id: Scalars['bigint'];
  status: Scalars['String'];
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Setu_Trade_Shared_Entity;
  user_id: Scalars['bigint'];
};


/** columns and relationships of "over_due_approval" */
export type Over_Due_ApprovalLogsArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Log_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
};


/** columns and relationships of "over_due_approval" */
export type Over_Due_ApprovalLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Log_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
};

/** aggregated selection of "over_due_approval" */
export type Over_Due_Approval_Aggregate = {
  __typename?: 'over_due_approval_aggregate';
  aggregate?: Maybe<Over_Due_Approval_Aggregate_Fields>;
  nodes: Array<Over_Due_Approval>;
};

/** aggregate fields of "over_due_approval" */
export type Over_Due_Approval_Aggregate_Fields = {
  __typename?: 'over_due_approval_aggregate_fields';
  avg?: Maybe<Over_Due_Approval_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Over_Due_Approval_Max_Fields>;
  min?: Maybe<Over_Due_Approval_Min_Fields>;
  stddev?: Maybe<Over_Due_Approval_Stddev_Fields>;
  stddev_pop?: Maybe<Over_Due_Approval_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Over_Due_Approval_Stddev_Samp_Fields>;
  sum?: Maybe<Over_Due_Approval_Sum_Fields>;
  var_pop?: Maybe<Over_Due_Approval_Var_Pop_Fields>;
  var_samp?: Maybe<Over_Due_Approval_Var_Samp_Fields>;
  variance?: Maybe<Over_Due_Approval_Variance_Fields>;
};


/** aggregate fields of "over_due_approval" */
export type Over_Due_Approval_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Over_Due_Approval_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Over_Due_Approval_Avg_Fields = {
  __typename?: 'over_due_approval_avg_fields';
  count?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "over_due_approval". All fields are combined with a logical 'AND'. */
export type Over_Due_Approval_Bool_Exp = {
  _and?: InputMaybe<Array<Over_Due_Approval_Bool_Exp>>;
  _not?: InputMaybe<Over_Due_Approval_Bool_Exp>;
  _or?: InputMaybe<Array<Over_Due_Approval_Bool_Exp>>;
  count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit?: InputMaybe<Credit_Bool_Exp>;
  credit_id?: InputMaybe<Bigint_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  logs?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  sr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  sr_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "over_due_approval" */
export enum Over_Due_Approval_Constraint {
  /** unique or primary key constraint on columns "id" */
  OverDueApprovalPkey = 'over_due_approval_pkey',
  /** unique or primary key constraint on columns "trade_id" */
  OverDueApprovalTradeIdKey = 'over_due_approval_trade_id_key'
}

/** columns and relationships of "over_due_approval_cw" */
export type Over_Due_Approval_Cw = {
  __typename?: 'over_due_approval_cw';
  count: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An object relationship */
  credit_wallet: Credit_Wallet;
  credit_wallet_id: Scalars['bigint'];
  id: Scalars['bigint'];
  remark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Aggregate = {
  __typename?: 'over_due_approval_cw_aggregate';
  aggregate?: Maybe<Over_Due_Approval_Cw_Aggregate_Fields>;
  nodes: Array<Over_Due_Approval_Cw>;
};

/** aggregate fields of "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Aggregate_Fields = {
  __typename?: 'over_due_approval_cw_aggregate_fields';
  avg?: Maybe<Over_Due_Approval_Cw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Over_Due_Approval_Cw_Max_Fields>;
  min?: Maybe<Over_Due_Approval_Cw_Min_Fields>;
  stddev?: Maybe<Over_Due_Approval_Cw_Stddev_Fields>;
  stddev_pop?: Maybe<Over_Due_Approval_Cw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Over_Due_Approval_Cw_Stddev_Samp_Fields>;
  sum?: Maybe<Over_Due_Approval_Cw_Sum_Fields>;
  var_pop?: Maybe<Over_Due_Approval_Cw_Var_Pop_Fields>;
  var_samp?: Maybe<Over_Due_Approval_Cw_Var_Samp_Fields>;
  variance?: Maybe<Over_Due_Approval_Cw_Variance_Fields>;
};


/** aggregate fields of "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Over_Due_Approval_Cw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Aggregate_Order_By = {
  avg?: InputMaybe<Over_Due_Approval_Cw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Over_Due_Approval_Cw_Max_Order_By>;
  min?: InputMaybe<Over_Due_Approval_Cw_Min_Order_By>;
  stddev?: InputMaybe<Over_Due_Approval_Cw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Over_Due_Approval_Cw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Over_Due_Approval_Cw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Over_Due_Approval_Cw_Sum_Order_By>;
  var_pop?: InputMaybe<Over_Due_Approval_Cw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Over_Due_Approval_Cw_Var_Samp_Order_By>;
  variance?: InputMaybe<Over_Due_Approval_Cw_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Over_Due_Approval_Cw_Avg_Fields = {
  __typename?: 'over_due_approval_cw_avg_fields';
  count?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "over_due_approval_cw". All fields are combined with a logical 'AND'. */
export type Over_Due_Approval_Cw_Bool_Exp = {
  _and?: InputMaybe<Array<Over_Due_Approval_Cw_Bool_Exp>>;
  _not?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
  _or?: InputMaybe<Array<Over_Due_Approval_Cw_Bool_Exp>>;
  count?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit_wallet?: InputMaybe<Credit_Wallet_Bool_Exp>;
  credit_wallet_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Over_Due_Approval_Cw_Max_Fields = {
  __typename?: 'over_due_approval_cw_max_fields';
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Over_Due_Approval_Cw_Min_Fields = {
  __typename?: 'over_due_approval_cw_min_fields';
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "over_due_approval_cw". */
export type Over_Due_Approval_Cw_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_wallet?: InputMaybe<Credit_Wallet_Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "over_due_approval_cw" */
export enum Over_Due_Approval_Cw_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreditWalletId = 'credit_wallet_id',
  /** column name */
  Id = 'id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Status = 'status',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** aggregate stddev on columns */
export type Over_Due_Approval_Cw_Stddev_Fields = {
  __typename?: 'over_due_approval_cw_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Over_Due_Approval_Cw_Stddev_Pop_Fields = {
  __typename?: 'over_due_approval_cw_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Over_Due_Approval_Cw_Stddev_Samp_Fields = {
  __typename?: 'over_due_approval_cw_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Over_Due_Approval_Cw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Over_Due_Approval_Cw_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  credit_wallet_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Over_Due_Approval_Cw_Sum_Fields = {
  __typename?: 'over_due_approval_cw_sum_fields';
  count?: Maybe<Scalars['Int']>;
  credit_wallet_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Over_Due_Approval_Cw_Var_Pop_Fields = {
  __typename?: 'over_due_approval_cw_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Over_Due_Approval_Cw_Var_Samp_Fields = {
  __typename?: 'over_due_approval_cw_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Over_Due_Approval_Cw_Variance_Fields = {
  __typename?: 'over_due_approval_cw_variance_fields';
  count?: Maybe<Scalars['Float']>;
  credit_wallet_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "over_due_approval_cw" */
export type Over_Due_Approval_Cw_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  credit_wallet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "over_due_approval" */
export type Over_Due_Approval_Inc_Input = {
  count?: InputMaybe<Scalars['Int']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  sr_officer_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "over_due_approval" */
export type Over_Due_Approval_Insert_Input = {
  credit_id?: InputMaybe<Scalars['bigint']>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  sr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  sr_officer_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "over_due_approval_log" */
export type Over_Due_Approval_Log = {
  __typename?: 'over_due_approval_log';
  created_at: Scalars['timestamptz'];
  from_status?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  officer: Setu_Trade_Shared_Entity;
  /** An object relationship */
  over_due_approval: Over_Due_Approval;
  over_due_approval_id: Scalars['bigint'];
  remark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['bigint'];
};

/** aggregated selection of "over_due_approval_log" */
export type Over_Due_Approval_Log_Aggregate = {
  __typename?: 'over_due_approval_log_aggregate';
  aggregate?: Maybe<Over_Due_Approval_Log_Aggregate_Fields>;
  nodes: Array<Over_Due_Approval_Log>;
};

/** aggregate fields of "over_due_approval_log" */
export type Over_Due_Approval_Log_Aggregate_Fields = {
  __typename?: 'over_due_approval_log_aggregate_fields';
  avg?: Maybe<Over_Due_Approval_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Over_Due_Approval_Log_Max_Fields>;
  min?: Maybe<Over_Due_Approval_Log_Min_Fields>;
  stddev?: Maybe<Over_Due_Approval_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Over_Due_Approval_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Over_Due_Approval_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Over_Due_Approval_Log_Sum_Fields>;
  var_pop?: Maybe<Over_Due_Approval_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Over_Due_Approval_Log_Var_Samp_Fields>;
  variance?: Maybe<Over_Due_Approval_Log_Variance_Fields>;
};


/** aggregate fields of "over_due_approval_log" */
export type Over_Due_Approval_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Over_Due_Approval_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Over_Due_Approval_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Over_Due_Approval_Log_Max_Order_By>;
  min?: InputMaybe<Over_Due_Approval_Log_Min_Order_By>;
  stddev?: InputMaybe<Over_Due_Approval_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Over_Due_Approval_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Over_Due_Approval_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Over_Due_Approval_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Over_Due_Approval_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Over_Due_Approval_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Over_Due_Approval_Log_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Over_Due_Approval_Log_Avg_Fields = {
  __typename?: 'over_due_approval_log_avg_fields';
  id?: Maybe<Scalars['Float']>;
  over_due_approval_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "over_due_approval_log". All fields are combined with a logical 'AND'. */
export type Over_Due_Approval_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Over_Due_Approval_Log_Bool_Exp>>;
  _not?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Over_Due_Approval_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from_status?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  over_due_approval?: InputMaybe<Over_Due_Approval_Bool_Exp>;
  over_due_approval_id?: InputMaybe<Bigint_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Over_Due_Approval_Log_Max_Fields = {
  __typename?: 'over_due_approval_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  from_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  over_due_approval_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Over_Due_Approval_Log_Min_Fields = {
  __typename?: 'over_due_approval_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  from_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  over_due_approval_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "over_due_approval_log". */
export type Over_Due_Approval_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  over_due_approval?: InputMaybe<Over_Due_Approval_Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "over_due_approval_log" */
export enum Over_Due_Approval_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FromStatus = 'from_status',
  /** column name */
  Id = 'id',
  /** column name */
  OverDueApprovalId = 'over_due_approval_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Over_Due_Approval_Log_Stddev_Fields = {
  __typename?: 'over_due_approval_log_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  over_due_approval_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Over_Due_Approval_Log_Stddev_Pop_Fields = {
  __typename?: 'over_due_approval_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  over_due_approval_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Over_Due_Approval_Log_Stddev_Samp_Fields = {
  __typename?: 'over_due_approval_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  over_due_approval_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "over_due_approval_log" */
export type Over_Due_Approval_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Over_Due_Approval_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Over_Due_Approval_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  over_due_approval_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Over_Due_Approval_Log_Sum_Fields = {
  __typename?: 'over_due_approval_log_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  over_due_approval_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Over_Due_Approval_Log_Var_Pop_Fields = {
  __typename?: 'over_due_approval_log_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  over_due_approval_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Over_Due_Approval_Log_Var_Samp_Fields = {
  __typename?: 'over_due_approval_log_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  over_due_approval_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Over_Due_Approval_Log_Variance_Fields = {
  __typename?: 'over_due_approval_log_variance_fields';
  id?: Maybe<Scalars['Float']>;
  over_due_approval_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "over_due_approval_log" */
export type Over_Due_Approval_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  over_due_approval_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Over_Due_Approval_Max_Fields = {
  __typename?: 'over_due_approval_max_fields';
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Over_Due_Approval_Min_Fields = {
  __typename?: 'over_due_approval_min_fields';
  count?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  credit_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "over_due_approval" */
export type Over_Due_Approval_Mutation_Response = {
  __typename?: 'over_due_approval_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Over_Due_Approval>;
};

/** on_conflict condition type for table "over_due_approval" */
export type Over_Due_Approval_On_Conflict = {
  constraint: Over_Due_Approval_Constraint;
  update_columns?: Array<Over_Due_Approval_Update_Column>;
  where?: InputMaybe<Over_Due_Approval_Bool_Exp>;
};

/** Ordering options when selecting data from "over_due_approval". */
export type Over_Due_Approval_Order_By = {
  count?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit?: InputMaybe<Credit_Order_By>;
  credit_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Over_Due_Approval_Log_Aggregate_Order_By>;
  remark?: InputMaybe<Order_By>;
  sr_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  sr_officer_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: over_due_approval */
export type Over_Due_Approval_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "over_due_approval" */
export enum Over_Due_Approval_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SrOfficerId = 'sr_officer_id',
  /** column name */
  Status = 'status',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "over_due_approval" */
export type Over_Due_Approval_Set_Input = {
  count?: InputMaybe<Scalars['Int']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  sr_officer_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Over_Due_Approval_Stddev_Fields = {
  __typename?: 'over_due_approval_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Over_Due_Approval_Stddev_Pop_Fields = {
  __typename?: 'over_due_approval_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Over_Due_Approval_Stddev_Samp_Fields = {
  __typename?: 'over_due_approval_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "over_due_approval" */
export type Over_Due_Approval_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Over_Due_Approval_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Over_Due_Approval_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  sr_officer_id?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Over_Due_Approval_Sum_Fields = {
  __typename?: 'over_due_approval_sum_fields';
  count?: Maybe<Scalars['Int']>;
  credit_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  sr_officer_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "over_due_approval" */
export enum Over_Due_Approval_Update_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SrOfficerId = 'sr_officer_id',
  /** column name */
  Status = 'status',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UserId = 'user_id'
}

export type Over_Due_Approval_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Over_Due_Approval_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Over_Due_Approval_Set_Input>;
  where: Over_Due_Approval_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Over_Due_Approval_Var_Pop_Fields = {
  __typename?: 'over_due_approval_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Over_Due_Approval_Var_Samp_Fields = {
  __typename?: 'over_due_approval_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Over_Due_Approval_Variance_Fields = {
  __typename?: 'over_due_approval_variance_fields';
  count?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sr_officer_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "packaging" */
export type Packaging = {
  __typename?: 'packaging';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  material_code: Scalars['String'];
  name: Scalars['String'];
  rate: Scalars['float8'];
};

/** aggregated selection of "packaging" */
export type Packaging_Aggregate = {
  __typename?: 'packaging_aggregate';
  aggregate?: Maybe<Packaging_Aggregate_Fields>;
  nodes: Array<Packaging>;
};

/** aggregate fields of "packaging" */
export type Packaging_Aggregate_Fields = {
  __typename?: 'packaging_aggregate_fields';
  avg?: Maybe<Packaging_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Packaging_Max_Fields>;
  min?: Maybe<Packaging_Min_Fields>;
  stddev?: Maybe<Packaging_Stddev_Fields>;
  stddev_pop?: Maybe<Packaging_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packaging_Stddev_Samp_Fields>;
  sum?: Maybe<Packaging_Sum_Fields>;
  var_pop?: Maybe<Packaging_Var_Pop_Fields>;
  var_samp?: Maybe<Packaging_Var_Samp_Fields>;
  variance?: Maybe<Packaging_Variance_Fields>;
};


/** aggregate fields of "packaging" */
export type Packaging_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packaging_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Packaging_Avg_Fields = {
  __typename?: 'packaging_avg_fields';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "packaging". All fields are combined with a logical 'AND'. */
export type Packaging_Bool_Exp = {
  _and?: InputMaybe<Array<Packaging_Bool_Exp>>;
  _not?: InputMaybe<Packaging_Bool_Exp>;
  _or?: InputMaybe<Array<Packaging_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  material_code?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rate?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Packaging_Max_Fields = {
  __typename?: 'packaging_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  material_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Packaging_Min_Fields = {
  __typename?: 'packaging_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  material_code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['float8']>;
};

/** columns and relationships of "packaging_order" */
export type Packaging_Order = {
  __typename?: 'packaging_order';
  created_at: Scalars['timestamptz'];
  created_by: Array<Base_User>;
  created_by_id: Scalars['String'];
  date: Scalars['date'];
  id: Scalars['bigint'];
  /** An array relationship */
  packaging_order_items: Array<Packaging_Order_Item>;
  /** An aggregate relationship */
  packaging_order_items_aggregate: Packaging_Order_Item_Aggregate;
  payment_status: Scalars['String'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  /** An object relationship */
  plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_amount_paid?: Maybe<Scalars['float8']>;
  total_amount_pending?: Maybe<Scalars['float8']>;
  total_quantity?: Maybe<Scalars['Int']>;
  /** An object relationship */
  transaction_attachment?: Maybe<Setutrade_Media>;
  transaction_attachment_id?: Maybe<Scalars['bigint']>;
  transaction_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by: Array<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "packaging_order" */
export type Packaging_OrderCreated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Packaging_Ordercreated_By>;
};


/** columns and relationships of "packaging_order" */
export type Packaging_OrderPackaging_Order_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Item_Order_By>>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};


/** columns and relationships of "packaging_order" */
export type Packaging_OrderPackaging_Order_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Item_Order_By>>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};


/** columns and relationships of "packaging_order" */
export type Packaging_OrderPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "packaging_order" */
export type Packaging_OrderPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "packaging_order" */
export type Packaging_OrderUpdated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Packaging_Orderupdated_By>;
};

/** aggregated selection of "packaging_order" */
export type Packaging_Order_Aggregate = {
  __typename?: 'packaging_order_aggregate';
  aggregate?: Maybe<Packaging_Order_Aggregate_Fields>;
  nodes: Array<Packaging_Order>;
};

/** aggregate fields of "packaging_order" */
export type Packaging_Order_Aggregate_Fields = {
  __typename?: 'packaging_order_aggregate_fields';
  avg?: Maybe<Packaging_Order_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Packaging_Order_Max_Fields>;
  min?: Maybe<Packaging_Order_Min_Fields>;
  stddev?: Maybe<Packaging_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Packaging_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packaging_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Packaging_Order_Sum_Fields>;
  var_pop?: Maybe<Packaging_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Packaging_Order_Var_Samp_Fields>;
  variance?: Maybe<Packaging_Order_Variance_Fields>;
};


/** aggregate fields of "packaging_order" */
export type Packaging_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packaging_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Packaging_Order_Avg_Fields = {
  __typename?: 'packaging_order_avg_fields';
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_paid?: Maybe<Scalars['Float']>;
  total_amount_pending?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  transaction_attachment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "packaging_order". All fields are combined with a logical 'AND'. */
export type Packaging_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Packaging_Order_Bool_Exp>>;
  _not?: InputMaybe<Packaging_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Packaging_Order_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  packaging_order_items?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
  payment_status?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_amount?: InputMaybe<Float8_Comparison_Exp>;
  total_amount_paid?: InputMaybe<Float8_Comparison_Exp>;
  total_amount_pending?: InputMaybe<Float8_Comparison_Exp>;
  total_quantity?: InputMaybe<Int_Comparison_Exp>;
  transaction_attachment?: InputMaybe<Setutrade_Media_Bool_Exp>;
  transaction_attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  transaction_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "packaging". */
export type Packaging_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  material_code?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "packaging_order" */
export enum Packaging_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagingOrderPkey = 'packaging_order_pkey'
}

/** input type for incrementing numeric columns in table "packaging_order" */
export type Packaging_Order_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  transaction_attachment_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "packaging_order" */
export type Packaging_Order_Insert_Input = {
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_order_items?: InputMaybe<Packaging_Order_Item_Arr_Rel_Insert_Input>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  transaction_attachment?: InputMaybe<Setutrade_Media_Obj_Rel_Insert_Input>;
  transaction_attachment_id?: InputMaybe<Scalars['bigint']>;
  transaction_number?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "packaging_order_item" */
export type Packaging_Order_Item = {
  __typename?: 'packaging_order_item';
  amount?: Maybe<Scalars['float8']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  packaging: Packaging;
  packaging_id: Scalars['bigint'];
  /** An object relationship */
  packaging_order: Packaging_Order;
  packaging_order_id: Scalars['bigint'];
  quantity: Scalars['Int'];
  rate: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "packaging_order_item" */
export type Packaging_Order_Item_Aggregate = {
  __typename?: 'packaging_order_item_aggregate';
  aggregate?: Maybe<Packaging_Order_Item_Aggregate_Fields>;
  nodes: Array<Packaging_Order_Item>;
};

/** aggregate fields of "packaging_order_item" */
export type Packaging_Order_Item_Aggregate_Fields = {
  __typename?: 'packaging_order_item_aggregate_fields';
  avg?: Maybe<Packaging_Order_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Packaging_Order_Item_Max_Fields>;
  min?: Maybe<Packaging_Order_Item_Min_Fields>;
  stddev?: Maybe<Packaging_Order_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Packaging_Order_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Packaging_Order_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Packaging_Order_Item_Sum_Fields>;
  var_pop?: Maybe<Packaging_Order_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Packaging_Order_Item_Var_Samp_Fields>;
  variance?: Maybe<Packaging_Order_Item_Variance_Fields>;
};


/** aggregate fields of "packaging_order_item" */
export type Packaging_Order_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packaging_Order_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "packaging_order_item" */
export type Packaging_Order_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Packaging_Order_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packaging_Order_Item_Max_Order_By>;
  min?: InputMaybe<Packaging_Order_Item_Min_Order_By>;
  stddev?: InputMaybe<Packaging_Order_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packaging_Order_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packaging_Order_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packaging_Order_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Packaging_Order_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packaging_Order_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Packaging_Order_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "packaging_order_item" */
export type Packaging_Order_Item_Arr_Rel_Insert_Input = {
  data: Array<Packaging_Order_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packaging_Order_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Packaging_Order_Item_Avg_Fields = {
  __typename?: 'packaging_order_item_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "packaging_order_item". All fields are combined with a logical 'AND'. */
export type Packaging_Order_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Packaging_Order_Item_Bool_Exp>>;
  _not?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Packaging_Order_Item_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  packaging?: InputMaybe<Packaging_Bool_Exp>;
  packaging_id?: InputMaybe<Bigint_Comparison_Exp>;
  packaging_order?: InputMaybe<Packaging_Order_Bool_Exp>;
  packaging_order_id?: InputMaybe<Bigint_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  rate?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "packaging_order_item" */
export enum Packaging_Order_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagingOrderItemPkey = 'packaging_order_item_pkey'
}

/** input type for incrementing numeric columns in table "packaging_order_item" */
export type Packaging_Order_Item_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "packaging_order_item" */
export type Packaging_Order_Item_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  packaging_order?: InputMaybe<Packaging_Order_Obj_Rel_Insert_Input>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Packaging_Order_Item_Max_Fields = {
  __typename?: 'packaging_order_item_max_fields';
  amount?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_id?: Maybe<Scalars['bigint']>;
  packaging_order_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Packaging_Order_Item_Min_Fields = {
  __typename?: 'packaging_order_item_min_fields';
  amount?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_id?: Maybe<Scalars['bigint']>;
  packaging_order_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "packaging_order_item" */
export type Packaging_Order_Item_Mutation_Response = {
  __typename?: 'packaging_order_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Packaging_Order_Item>;
};

/** on_conflict condition type for table "packaging_order_item" */
export type Packaging_Order_Item_On_Conflict = {
  constraint: Packaging_Order_Item_Constraint;
  update_columns?: Array<Packaging_Order_Item_Update_Column>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "packaging_order_item". */
export type Packaging_Order_Item_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Packaging_Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order?: InputMaybe<Packaging_Order_Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: packaging_order_item */
export type Packaging_Order_Item_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "packaging_order_item" */
export enum Packaging_Order_Item_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingId = 'packaging_id',
  /** column name */
  PackagingOrderId = 'packaging_order_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Rate = 'rate',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "packaging_order_item" */
export type Packaging_Order_Item_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Packaging_Order_Item_Stddev_Fields = {
  __typename?: 'packaging_order_item_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Packaging_Order_Item_Stddev_Pop_Fields = {
  __typename?: 'packaging_order_item_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Packaging_Order_Item_Stddev_Samp_Fields = {
  __typename?: 'packaging_order_item_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "packaging_order_item" */
export type Packaging_Order_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packaging_Order_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packaging_Order_Item_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Packaging_Order_Item_Sum_Fields = {
  __typename?: 'packaging_order_item_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_id?: Maybe<Scalars['bigint']>;
  packaging_order_id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** update columns of table "packaging_order_item" */
export enum Packaging_Order_Item_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PackagingId = 'packaging_id',
  /** column name */
  PackagingOrderId = 'packaging_order_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Rate = 'rate'
}

export type Packaging_Order_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packaging_Order_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packaging_Order_Item_Set_Input>;
  where: Packaging_Order_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packaging_Order_Item_Var_Pop_Fields = {
  __typename?: 'packaging_order_item_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Packaging_Order_Item_Var_Samp_Fields = {
  __typename?: 'packaging_order_item_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Packaging_Order_Item_Variance_Fields = {
  __typename?: 'packaging_order_item_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "packaging_order_item" */
export type Packaging_Order_Item_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Packaging_Order_Max_Fields = {
  __typename?: 'packaging_order_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_status?: Maybe<Scalars['String']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_amount_paid?: Maybe<Scalars['float8']>;
  total_amount_pending?: Maybe<Scalars['float8']>;
  total_quantity?: Maybe<Scalars['Int']>;
  transaction_attachment_id?: Maybe<Scalars['bigint']>;
  transaction_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Packaging_Order_Min_Fields = {
  __typename?: 'packaging_order_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_status?: Maybe<Scalars['String']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_amount_paid?: Maybe<Scalars['float8']>;
  total_amount_pending?: Maybe<Scalars['float8']>;
  total_quantity?: Maybe<Scalars['Int']>;
  transaction_attachment_id?: Maybe<Scalars['bigint']>;
  transaction_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "packaging_order" */
export type Packaging_Order_Mutation_Response = {
  __typename?: 'packaging_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Packaging_Order>;
};

/** input type for inserting object relation for remote table "packaging_order" */
export type Packaging_Order_Obj_Rel_Insert_Input = {
  data: Packaging_Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Packaging_Order_On_Conflict>;
};

/** on_conflict condition type for table "packaging_order" */
export type Packaging_Order_On_Conflict = {
  constraint: Packaging_Order_Constraint;
  update_columns?: Array<Packaging_Order_Update_Column>;
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "packaging_order". */
export type Packaging_Order_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_items_aggregate?: InputMaybe<Packaging_Order_Item_Aggregate_Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_paid?: InputMaybe<Order_By>;
  total_amount_pending?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  transaction_attachment?: InputMaybe<Setutrade_Media_Order_By>;
  transaction_attachment_id?: InputMaybe<Order_By>;
  transaction_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: packaging_order */
export type Packaging_Order_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "packaging_order" */
export enum Packaging_Order_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalAmountPaid = 'total_amount_paid',
  /** column name */
  TotalAmountPending = 'total_amount_pending',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TransactionAttachmentId = 'transaction_attachment_id',
  /** column name */
  TransactionNumber = 'transaction_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "packaging_order" */
export type Packaging_Order_Set_Input = {
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  transaction_attachment_id?: InputMaybe<Scalars['bigint']>;
  transaction_number?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Packaging_Order_Stddev_Fields = {
  __typename?: 'packaging_order_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_paid?: Maybe<Scalars['Float']>;
  total_amount_pending?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  transaction_attachment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Packaging_Order_Stddev_Pop_Fields = {
  __typename?: 'packaging_order_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_paid?: Maybe<Scalars['Float']>;
  total_amount_pending?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  transaction_attachment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Packaging_Order_Stddev_Samp_Fields = {
  __typename?: 'packaging_order_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_paid?: Maybe<Scalars['Float']>;
  total_amount_pending?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  transaction_attachment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "packaging_order" */
export type Packaging_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packaging_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packaging_Order_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_status?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  total_amount?: InputMaybe<Scalars['float8']>;
  total_amount_paid?: InputMaybe<Scalars['float8']>;
  total_amount_pending?: InputMaybe<Scalars['float8']>;
  total_quantity?: InputMaybe<Scalars['Int']>;
  transaction_attachment_id?: InputMaybe<Scalars['bigint']>;
  transaction_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Packaging_Order_Sum_Fields = {
  __typename?: 'packaging_order_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_amount_paid?: Maybe<Scalars['float8']>;
  total_amount_pending?: Maybe<Scalars['float8']>;
  total_quantity?: Maybe<Scalars['Int']>;
  transaction_attachment_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "packaging_order" */
export enum Packaging_Order_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  TransactionAttachmentId = 'transaction_attachment_id',
  /** column name */
  TransactionNumber = 'transaction_number',
  /** column name */
  UserId = 'user_id'
}

export type Packaging_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packaging_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packaging_Order_Set_Input>;
  where: Packaging_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Packaging_Order_Var_Pop_Fields = {
  __typename?: 'packaging_order_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_paid?: Maybe<Scalars['Float']>;
  total_amount_pending?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  transaction_attachment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Packaging_Order_Var_Samp_Fields = {
  __typename?: 'packaging_order_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_paid?: Maybe<Scalars['Float']>;
  total_amount_pending?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  transaction_attachment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Packaging_Order_Variance_Fields = {
  __typename?: 'packaging_order_variance_fields';
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_paid?: Maybe<Scalars['Float']>;
  total_amount_pending?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  transaction_attachment_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** select columns of table "packaging" */
export enum Packaging_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaterialCode = 'material_code',
  /** column name */
  Name = 'name',
  /** column name */
  Rate = 'rate'
}

/** aggregate stddev on columns */
export type Packaging_Stddev_Fields = {
  __typename?: 'packaging_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Packaging_Stddev_Pop_Fields = {
  __typename?: 'packaging_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Packaging_Stddev_Samp_Fields = {
  __typename?: 'packaging_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "packaging" */
export type Packaging_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packaging_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packaging_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  material_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Packaging_Sum_Fields = {
  __typename?: 'packaging_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type Packaging_Var_Pop_Fields = {
  __typename?: 'packaging_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Packaging_Var_Samp_Fields = {
  __typename?: 'packaging_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Packaging_Variance_Fields = {
  __typename?: 'packaging_variance_fields';
  id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_category" */
export type Pallet_Category = {
  __typename?: 'pallet_category';
  codename?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_category" */
export type Pallet_Category_Aggregate = {
  __typename?: 'pallet_category_aggregate';
  aggregate?: Maybe<Pallet_Category_Aggregate_Fields>;
  nodes: Array<Pallet_Category>;
};

/** aggregate fields of "pallet_category" */
export type Pallet_Category_Aggregate_Fields = {
  __typename?: 'pallet_category_aggregate_fields';
  avg?: Maybe<Pallet_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Category_Max_Fields>;
  min?: Maybe<Pallet_Category_Min_Fields>;
  stddev?: Maybe<Pallet_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Category_Sum_Fields>;
  var_pop?: Maybe<Pallet_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Category_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Category_Variance_Fields>;
};


/** aggregate fields of "pallet_category" */
export type Pallet_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Category_Avg_Fields = {
  __typename?: 'pallet_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_category". All fields are combined with a logical 'AND'. */
export type Pallet_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Category_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Category_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_category" */
export enum Pallet_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletCategoryPkey = 'pallet_category_pkey'
}

/** input type for incrementing numeric columns in table "pallet_category" */
export type Pallet_Category_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_category" */
export type Pallet_Category_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Category_Max_Fields = {
  __typename?: 'pallet_category_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Category_Min_Fields = {
  __typename?: 'pallet_category_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_category" */
export type Pallet_Category_Mutation_Response = {
  __typename?: 'pallet_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Category>;
};

/** input type for inserting object relation for remote table "pallet_category" */
export type Pallet_Category_Obj_Rel_Insert_Input = {
  data: Pallet_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Category_On_Conflict>;
};

/** on_conflict condition type for table "pallet_category" */
export type Pallet_Category_On_Conflict = {
  constraint: Pallet_Category_Constraint;
  update_columns?: Array<Pallet_Category_Update_Column>;
  where?: InputMaybe<Pallet_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_category". */
export type Pallet_Category_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_category */
export type Pallet_Category_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_category" */
export enum Pallet_Category_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_category" */
export type Pallet_Category_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Category_Stddev_Fields = {
  __typename?: 'pallet_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Category_Stddev_Pop_Fields = {
  __typename?: 'pallet_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Category_Stddev_Samp_Fields = {
  __typename?: 'pallet_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_category" */
export type Pallet_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Category_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Category_Sum_Fields = {
  __typename?: 'pallet_category_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_category" */
export enum Pallet_Category_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Category_Set_Input>;
  where: Pallet_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Category_Var_Pop_Fields = {
  __typename?: 'pallet_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Category_Var_Samp_Fields = {
  __typename?: 'pallet_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Category_Variance_Fields = {
  __typename?: 'pallet_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_customer" */
export type Pallet_Customer = {
  __typename?: 'pallet_customer';
  codename: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_customer" */
export type Pallet_Customer_Aggregate = {
  __typename?: 'pallet_customer_aggregate';
  aggregate?: Maybe<Pallet_Customer_Aggregate_Fields>;
  nodes: Array<Pallet_Customer>;
};

/** aggregate fields of "pallet_customer" */
export type Pallet_Customer_Aggregate_Fields = {
  __typename?: 'pallet_customer_aggregate_fields';
  avg?: Maybe<Pallet_Customer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Customer_Max_Fields>;
  min?: Maybe<Pallet_Customer_Min_Fields>;
  stddev?: Maybe<Pallet_Customer_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Customer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Customer_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Customer_Sum_Fields>;
  var_pop?: Maybe<Pallet_Customer_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Customer_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Customer_Variance_Fields>;
};


/** aggregate fields of "pallet_customer" */
export type Pallet_Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Customer_Avg_Fields = {
  __typename?: 'pallet_customer_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_customer". All fields are combined with a logical 'AND'. */
export type Pallet_Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Customer_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Customer_Bool_Exp>>;
  codename?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_customer" */
export enum Pallet_Customer_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PalletCustomerCodenameKey = 'pallet_customer_codename_key',
  /** unique or primary key constraint on columns "id" */
  PalletCustomerPkey = 'pallet_customer_pkey'
}

/** input type for incrementing numeric columns in table "pallet_customer" */
export type Pallet_Customer_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_customer" */
export type Pallet_Customer_Insert_Input = {
  codename?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Customer_Max_Fields = {
  __typename?: 'pallet_customer_max_fields';
  codename?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Customer_Min_Fields = {
  __typename?: 'pallet_customer_min_fields';
  codename?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_customer" */
export type Pallet_Customer_Mutation_Response = {
  __typename?: 'pallet_customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Customer>;
};

/** input type for inserting object relation for remote table "pallet_customer" */
export type Pallet_Customer_Obj_Rel_Insert_Input = {
  data: Pallet_Customer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Customer_On_Conflict>;
};

/** on_conflict condition type for table "pallet_customer" */
export type Pallet_Customer_On_Conflict = {
  constraint: Pallet_Customer_Constraint;
  update_columns?: Array<Pallet_Customer_Update_Column>;
  where?: InputMaybe<Pallet_Customer_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_customer". */
export type Pallet_Customer_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_customer */
export type Pallet_Customer_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_customer" */
export enum Pallet_Customer_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_customer" */
export type Pallet_Customer_Set_Input = {
  codename?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Customer_Stddev_Fields = {
  __typename?: 'pallet_customer_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Customer_Stddev_Pop_Fields = {
  __typename?: 'pallet_customer_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Customer_Stddev_Samp_Fields = {
  __typename?: 'pallet_customer_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_customer" */
export type Pallet_Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Customer_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Customer_Sum_Fields = {
  __typename?: 'pallet_customer_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_customer" */
export enum Pallet_Customer_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Customer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Customer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Customer_Set_Input>;
  where: Pallet_Customer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Customer_Var_Pop_Fields = {
  __typename?: 'pallet_customer_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Customer_Var_Samp_Fields = {
  __typename?: 'pallet_customer_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Customer_Variance_Fields = {
  __typename?: 'pallet_customer_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_inspection" */
export type Pallet_Inspection = {
  __typename?: 'pallet_inspection';
  arrival_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  attachments: Array<Pallet_Inspection_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Pallet_Inspection_Attachments_Aggregate;
  /** An object relationship */
  base_user_1?: Maybe<External_Entity>;
  base_user_1_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  base_user_2?: Maybe<External_Entity>;
  base_user_2_id?: Maybe<Scalars['bigint']>;
  batch_code?: Maybe<Scalars['String']>;
  belongs_to_date?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  box_net_weight?: Maybe<Pallet_Sku>;
  box_net_weight_id?: Maybe<Scalars['bigint']>;
  chemist_remarks?: Maybe<Scalars['String']>;
  codename: Scalars['uuid'];
  container_number?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  customer?: Maybe<Pallet_Customer>;
  customer_id?: Maybe<Scalars['bigint']>;
  date_of_checking?: Maybe<Scalars['date']>;
  date_of_packing?: Maybe<Scalars['date']>;
  id: Scalars['bigint'];
  layer_no?: Maybe<Scalars['String']>;
  level_1_approval?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  level_1_approved_by?: Maybe<External_Entity>;
  level_1_approved_by_id?: Maybe<Scalars['bigint']>;
  level_1_approved_on?: Maybe<Scalars['timestamptz']>;
  level_1_remarks?: Maybe<Scalars['String']>;
  level_2_approval?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  level_2_approved_by?: Maybe<External_Entity>;
  level_2_approved_by_id?: Maybe<Scalars['bigint']>;
  level_2_approved_on?: Maybe<Scalars['timestamptz']>;
  level_2_remarks?: Maybe<Scalars['String']>;
  /** An object relationship */
  line?: Maybe<Pallet_Line>;
  line_id?: Maybe<Scalars['bigint']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An array relationship */
  observations: Array<Pallet_Inspectionobservation>;
  /** An aggregate relationship */
  observations_aggregate: Pallet_Inspectionobservation_Aggregate;
  pallet_no?: Maybe<Scalars['Int']>;
  /** An object relationship */
  plot_crop_1?: Maybe<External_Entity>;
  plot_crop_1_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  plot_crop_2?: Maybe<External_Entity>;
  plot_crop_2_id?: Maybe<Scalars['bigint']>;
  prev_rm_clearance?: Maybe<Scalars['String']>;
  /** An object relationship */
  primary_packaging?: Maybe<Pallet_Packaging>;
  primary_packaging_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  primary_packing?: Maybe<Pallet_Packing>;
  primary_packing_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  punnet_condition?: Maybe<Pallet_Punnetcondition>;
  punnet_condition_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  reports: Array<Pallet_Inspection_Reports>;
  /** An aggregate relationship */
  reports_aggregate: Pallet_Inspection_Reports_Aggregate;
  /** An object relationship */
  result_template_1?: Maybe<Template>;
  result_template_1_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  result_template_2?: Maybe<Template>;
  result_template_2_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sampling_location?: Maybe<Pallet_Samplinglocation>;
  sampling_location_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  secondary_packing?: Maybe<Pallet_Packing>;
  secondary_packing_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  sku?: Maybe<Pallet_Sku>;
  sku_id?: Maybe<Scalars['bigint']>;
  so_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  template?: Maybe<Template>;
  template_id?: Maybe<Scalars['bigint']>;
  total_sample_boxes?: Maybe<Scalars['Int']>;
  /** An object relationship */
  type?: Maybe<Pallet_Inspectionkind>;
  type_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  variety_1?: Maybe<Pallet_Variety>;
  variety_1_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  variety_2?: Maybe<Pallet_Variety>;
  variety_2_id?: Maybe<Scalars['bigint']>;
  wooden_pallet_condition?: Maybe<Scalars['String']>;
};


/** columns and relationships of "pallet_inspection" */
export type Pallet_InspectionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};


/** columns and relationships of "pallet_inspection" */
export type Pallet_InspectionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};


/** columns and relationships of "pallet_inspection" */
export type Pallet_InspectionMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "pallet_inspection" */
export type Pallet_InspectionObservationsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};


/** columns and relationships of "pallet_inspection" */
export type Pallet_InspectionObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};


/** columns and relationships of "pallet_inspection" */
export type Pallet_InspectionReportsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


/** columns and relationships of "pallet_inspection" */
export type Pallet_InspectionReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};

/** aggregated selection of "pallet_inspection" */
export type Pallet_Inspection_Aggregate = {
  __typename?: 'pallet_inspection_aggregate';
  aggregate?: Maybe<Pallet_Inspection_Aggregate_Fields>;
  nodes: Array<Pallet_Inspection>;
};

/** aggregate fields of "pallet_inspection" */
export type Pallet_Inspection_Aggregate_Fields = {
  __typename?: 'pallet_inspection_aggregate_fields';
  avg?: Maybe<Pallet_Inspection_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Inspection_Max_Fields>;
  min?: Maybe<Pallet_Inspection_Min_Fields>;
  stddev?: Maybe<Pallet_Inspection_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Inspection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Inspection_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Inspection_Sum_Fields>;
  var_pop?: Maybe<Pallet_Inspection_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Inspection_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Inspection_Variance_Fields>;
};


/** aggregate fields of "pallet_inspection" */
export type Pallet_Inspection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_inspection" */
export type Pallet_Inspection_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Inspection_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Inspection_Max_Order_By>;
  min?: InputMaybe<Pallet_Inspection_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Inspection_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Inspection_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Inspection_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Inspection_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Inspection_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Inspection_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Inspection_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Pallet_Inspection_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "pallet_inspection" */
export type Pallet_Inspection_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Inspection_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspection_On_Conflict>;
};

/** columns and relationships of "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments = {
  __typename?: 'pallet_inspection_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  inspection: Pallet_Inspection;
  inspection_id: Scalars['bigint'];
  /** An object relationship */
  media: Eagle_Media;
  media_id: Scalars['bigint'];
};

/** aggregated selection of "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Aggregate = {
  __typename?: 'pallet_inspection_attachments_aggregate';
  aggregate?: Maybe<Pallet_Inspection_Attachments_Aggregate_Fields>;
  nodes: Array<Pallet_Inspection_Attachments>;
};

/** aggregate fields of "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Aggregate_Fields = {
  __typename?: 'pallet_inspection_attachments_aggregate_fields';
  avg?: Maybe<Pallet_Inspection_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Inspection_Attachments_Max_Fields>;
  min?: Maybe<Pallet_Inspection_Attachments_Min_Fields>;
  stddev?: Maybe<Pallet_Inspection_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Inspection_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Inspection_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Inspection_Attachments_Sum_Fields>;
  var_pop?: Maybe<Pallet_Inspection_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Inspection_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Inspection_Attachments_Variance_Fields>;
};


/** aggregate fields of "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Inspection_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Inspection_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Inspection_Attachments_Max_Order_By>;
  min?: InputMaybe<Pallet_Inspection_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Inspection_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Inspection_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Inspection_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Inspection_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Inspection_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Inspection_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Inspection_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Inspection_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspection_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Pallet_Inspection_Attachments_Avg_Fields = {
  __typename?: 'pallet_inspection_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_inspection_attachments". All fields are combined with a logical 'AND'. */
export type Pallet_Inspection_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Inspection_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Inspection_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  inspection?: InputMaybe<Pallet_Inspection_Bool_Exp>;
  inspection_id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_inspection_attachments" */
export enum Pallet_Inspection_Attachments_Constraint {
  /** unique or primary key constraint on columns "inspection_id", "media_id" */
  PalletInspectionAttachInspectionIdMediaId_3c497406Uniq = 'pallet_inspection_attach_inspection_id_media_id_3c497406_uniq',
  /** unique or primary key constraint on columns "id" */
  PalletInspectionAttachmentsPkey = 'pallet_inspection_attachments_pkey'
}

/** input type for incrementing numeric columns in table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspection?: InputMaybe<Pallet_Inspection_Obj_Rel_Insert_Input>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Pallet_Inspection_Attachments_Max_Fields = {
  __typename?: 'pallet_inspection_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Inspection_Attachments_Min_Fields = {
  __typename?: 'pallet_inspection_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Mutation_Response = {
  __typename?: 'pallet_inspection_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Inspection_Attachments>;
};

/** on_conflict condition type for table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_On_Conflict = {
  constraint: Pallet_Inspection_Attachments_Constraint;
  update_columns?: Array<Pallet_Inspection_Attachments_Update_Column>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_inspection_attachments". */
export type Pallet_Inspection_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection?: InputMaybe<Pallet_Inspection_Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_inspection_attachments */
export type Pallet_Inspection_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_inspection_attachments" */
export enum Pallet_Inspection_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id',
  /** column name */
  MediaId = 'media_id'
}

/** input type for updating data in table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Pallet_Inspection_Attachments_Stddev_Fields = {
  __typename?: 'pallet_inspection_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Inspection_Attachments_Stddev_Pop_Fields = {
  __typename?: 'pallet_inspection_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Inspection_Attachments_Stddev_Samp_Fields = {
  __typename?: 'pallet_inspection_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Inspection_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Inspection_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Pallet_Inspection_Attachments_Sum_Fields = {
  __typename?: 'pallet_inspection_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_inspection_attachments" */
export enum Pallet_Inspection_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id',
  /** column name */
  MediaId = 'media_id'
}

export type Pallet_Inspection_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Inspection_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Inspection_Attachments_Set_Input>;
  where: Pallet_Inspection_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Inspection_Attachments_Var_Pop_Fields = {
  __typename?: 'pallet_inspection_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Inspection_Attachments_Var_Samp_Fields = {
  __typename?: 'pallet_inspection_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Inspection_Attachments_Variance_Fields = {
  __typename?: 'pallet_inspection_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_inspection_attachments" */
export type Pallet_Inspection_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Pallet_Inspection_Avg_Fields = {
  __typename?: 'pallet_inspection_avg_fields';
  base_user_1_id?: Maybe<Scalars['Float']>;
  base_user_2_id?: Maybe<Scalars['Float']>;
  box_net_weight_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level_1_approved_by_id?: Maybe<Scalars['Float']>;
  level_2_approved_by_id?: Maybe<Scalars['Float']>;
  line_id?: Maybe<Scalars['Float']>;
  pallet_no?: Maybe<Scalars['Float']>;
  plot_crop_1_id?: Maybe<Scalars['Float']>;
  plot_crop_2_id?: Maybe<Scalars['Float']>;
  primary_packaging_id?: Maybe<Scalars['Float']>;
  primary_packing_id?: Maybe<Scalars['Float']>;
  punnet_condition_id?: Maybe<Scalars['Float']>;
  result_template_1_id?: Maybe<Scalars['Float']>;
  result_template_2_id?: Maybe<Scalars['Float']>;
  sampling_location_id?: Maybe<Scalars['Float']>;
  secondary_packing_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  total_sample_boxes?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
  variety_1_id?: Maybe<Scalars['Float']>;
  variety_2_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Avg_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_inspection". All fields are combined with a logical 'AND'. */
export type Pallet_Inspection_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Inspection_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Inspection_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Inspection_Bool_Exp>>;
  arrival_date?: InputMaybe<Date_Comparison_Exp>;
  attachments?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
  base_user_1?: InputMaybe<External_Entity_Bool_Exp>;
  base_user_1_id?: InputMaybe<Bigint_Comparison_Exp>;
  base_user_2?: InputMaybe<External_Entity_Bool_Exp>;
  base_user_2_id?: InputMaybe<Bigint_Comparison_Exp>;
  batch_code?: InputMaybe<String_Comparison_Exp>;
  belongs_to_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  box_net_weight?: InputMaybe<Pallet_Sku_Bool_Exp>;
  box_net_weight_id?: InputMaybe<Bigint_Comparison_Exp>;
  chemist_remarks?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<Uuid_Comparison_Exp>;
  container_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Pallet_Customer_Bool_Exp>;
  customer_id?: InputMaybe<Bigint_Comparison_Exp>;
  date_of_checking?: InputMaybe<Date_Comparison_Exp>;
  date_of_packing?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  layer_no?: InputMaybe<String_Comparison_Exp>;
  level_1_approval?: InputMaybe<Boolean_Comparison_Exp>;
  level_1_approved_by?: InputMaybe<External_Entity_Bool_Exp>;
  level_1_approved_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  level_1_approved_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  level_1_remarks?: InputMaybe<String_Comparison_Exp>;
  level_2_approval?: InputMaybe<Boolean_Comparison_Exp>;
  level_2_approved_by?: InputMaybe<External_Entity_Bool_Exp>;
  level_2_approved_by_id?: InputMaybe<Bigint_Comparison_Exp>;
  level_2_approved_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  level_2_remarks?: InputMaybe<String_Comparison_Exp>;
  line?: InputMaybe<Pallet_Line_Bool_Exp>;
  line_id?: InputMaybe<Bigint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
  pallet_no?: InputMaybe<Int_Comparison_Exp>;
  plot_crop_1?: InputMaybe<External_Entity_Bool_Exp>;
  plot_crop_1_id?: InputMaybe<Bigint_Comparison_Exp>;
  plot_crop_2?: InputMaybe<External_Entity_Bool_Exp>;
  plot_crop_2_id?: InputMaybe<Bigint_Comparison_Exp>;
  prev_rm_clearance?: InputMaybe<String_Comparison_Exp>;
  primary_packaging?: InputMaybe<Pallet_Packaging_Bool_Exp>;
  primary_packaging_id?: InputMaybe<Bigint_Comparison_Exp>;
  primary_packing?: InputMaybe<Pallet_Packing_Bool_Exp>;
  primary_packing_id?: InputMaybe<Bigint_Comparison_Exp>;
  punnet_condition?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
  punnet_condition_id?: InputMaybe<Bigint_Comparison_Exp>;
  reports?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
  result_template_1?: InputMaybe<Template_Bool_Exp>;
  result_template_1_id?: InputMaybe<Bigint_Comparison_Exp>;
  result_template_2?: InputMaybe<Template_Bool_Exp>;
  result_template_2_id?: InputMaybe<Bigint_Comparison_Exp>;
  sampling_location?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
  sampling_location_id?: InputMaybe<Bigint_Comparison_Exp>;
  secondary_packing?: InputMaybe<Pallet_Packing_Bool_Exp>;
  secondary_packing_id?: InputMaybe<Bigint_Comparison_Exp>;
  sku?: InputMaybe<Pallet_Sku_Bool_Exp>;
  sku_id?: InputMaybe<Bigint_Comparison_Exp>;
  so_number?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
  total_sample_boxes?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
  type_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  variety_1?: InputMaybe<Pallet_Variety_Bool_Exp>;
  variety_1_id?: InputMaybe<Bigint_Comparison_Exp>;
  variety_2?: InputMaybe<Pallet_Variety_Bool_Exp>;
  variety_2_id?: InputMaybe<Bigint_Comparison_Exp>;
  wooden_pallet_condition?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_inspection" */
export enum Pallet_Inspection_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PalletInspectionCodenameKey = 'pallet_inspection_codename_key',
  /** unique or primary key constraint on columns "id" */
  PalletInspectionPkey = 'pallet_inspection_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Pallet_Inspection_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Pallet_Inspection_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Pallet_Inspection_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "pallet_inspection" */
export type Pallet_Inspection_Inc_Input = {
  base_user_1_id?: InputMaybe<Scalars['bigint']>;
  base_user_2_id?: InputMaybe<Scalars['bigint']>;
  box_net_weight_id?: InputMaybe<Scalars['bigint']>;
  customer_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  level_1_approved_by_id?: InputMaybe<Scalars['bigint']>;
  level_2_approved_by_id?: InputMaybe<Scalars['bigint']>;
  line_id?: InputMaybe<Scalars['bigint']>;
  pallet_no?: InputMaybe<Scalars['Int']>;
  plot_crop_1_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_2_id?: InputMaybe<Scalars['bigint']>;
  primary_packaging_id?: InputMaybe<Scalars['bigint']>;
  primary_packing_id?: InputMaybe<Scalars['bigint']>;
  punnet_condition_id?: InputMaybe<Scalars['bigint']>;
  result_template_1_id?: InputMaybe<Scalars['bigint']>;
  result_template_2_id?: InputMaybe<Scalars['bigint']>;
  sampling_location_id?: InputMaybe<Scalars['bigint']>;
  secondary_packing_id?: InputMaybe<Scalars['bigint']>;
  sku_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  total_sample_boxes?: InputMaybe<Scalars['Int']>;
  type_id?: InputMaybe<Scalars['bigint']>;
  variety_1_id?: InputMaybe<Scalars['bigint']>;
  variety_2_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_inspection" */
export type Pallet_Inspection_Insert_Input = {
  arrival_date?: InputMaybe<Scalars['date']>;
  attachments?: InputMaybe<Pallet_Inspection_Attachments_Arr_Rel_Insert_Input>;
  base_user_1?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  base_user_1_id?: InputMaybe<Scalars['bigint']>;
  base_user_2?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  base_user_2_id?: InputMaybe<Scalars['bigint']>;
  batch_code?: InputMaybe<Scalars['String']>;
  belongs_to_date?: InputMaybe<Scalars['timestamptz']>;
  box_net_weight?: InputMaybe<Pallet_Sku_Obj_Rel_Insert_Input>;
  box_net_weight_id?: InputMaybe<Scalars['bigint']>;
  chemist_remarks?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['uuid']>;
  container_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Pallet_Customer_Obj_Rel_Insert_Input>;
  customer_id?: InputMaybe<Scalars['bigint']>;
  date_of_checking?: InputMaybe<Scalars['date']>;
  date_of_packing?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  layer_no?: InputMaybe<Scalars['String']>;
  level_1_approval?: InputMaybe<Scalars['Boolean']>;
  level_1_approved_by?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  level_1_approved_by_id?: InputMaybe<Scalars['bigint']>;
  level_1_approved_on?: InputMaybe<Scalars['timestamptz']>;
  level_1_remarks?: InputMaybe<Scalars['String']>;
  level_2_approval?: InputMaybe<Scalars['Boolean']>;
  level_2_approved_by?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  level_2_approved_by_id?: InputMaybe<Scalars['bigint']>;
  level_2_approved_on?: InputMaybe<Scalars['timestamptz']>;
  level_2_remarks?: InputMaybe<Scalars['String']>;
  line?: InputMaybe<Pallet_Line_Obj_Rel_Insert_Input>;
  line_id?: InputMaybe<Scalars['bigint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Pallet_Inspectionobservation_Arr_Rel_Insert_Input>;
  pallet_no?: InputMaybe<Scalars['Int']>;
  plot_crop_1?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  plot_crop_1_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_2?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  plot_crop_2_id?: InputMaybe<Scalars['bigint']>;
  prev_rm_clearance?: InputMaybe<Scalars['String']>;
  primary_packaging?: InputMaybe<Pallet_Packaging_Obj_Rel_Insert_Input>;
  primary_packaging_id?: InputMaybe<Scalars['bigint']>;
  primary_packing?: InputMaybe<Pallet_Packing_Obj_Rel_Insert_Input>;
  primary_packing_id?: InputMaybe<Scalars['bigint']>;
  punnet_condition?: InputMaybe<Pallet_Punnetcondition_Obj_Rel_Insert_Input>;
  punnet_condition_id?: InputMaybe<Scalars['bigint']>;
  reports?: InputMaybe<Pallet_Inspection_Reports_Arr_Rel_Insert_Input>;
  result_template_1?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  result_template_1_id?: InputMaybe<Scalars['bigint']>;
  result_template_2?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  result_template_2_id?: InputMaybe<Scalars['bigint']>;
  sampling_location?: InputMaybe<Pallet_Samplinglocation_Obj_Rel_Insert_Input>;
  sampling_location_id?: InputMaybe<Scalars['bigint']>;
  secondary_packing?: InputMaybe<Pallet_Packing_Obj_Rel_Insert_Input>;
  secondary_packing_id?: InputMaybe<Scalars['bigint']>;
  sku?: InputMaybe<Pallet_Sku_Obj_Rel_Insert_Input>;
  sku_id?: InputMaybe<Scalars['bigint']>;
  so_number?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['bigint']>;
  total_sample_boxes?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Pallet_Inspectionkind_Obj_Rel_Insert_Input>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  variety_1?: InputMaybe<Pallet_Variety_Obj_Rel_Insert_Input>;
  variety_1_id?: InputMaybe<Scalars['bigint']>;
  variety_2?: InputMaybe<Pallet_Variety_Obj_Rel_Insert_Input>;
  variety_2_id?: InputMaybe<Scalars['bigint']>;
  wooden_pallet_condition?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Pallet_Inspection_Max_Fields = {
  __typename?: 'pallet_inspection_max_fields';
  arrival_date?: Maybe<Scalars['date']>;
  base_user_1_id?: Maybe<Scalars['bigint']>;
  base_user_2_id?: Maybe<Scalars['bigint']>;
  batch_code?: Maybe<Scalars['String']>;
  belongs_to_date?: Maybe<Scalars['timestamptz']>;
  box_net_weight_id?: Maybe<Scalars['bigint']>;
  chemist_remarks?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['uuid']>;
  container_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['bigint']>;
  date_of_checking?: Maybe<Scalars['date']>;
  date_of_packing?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  layer_no?: Maybe<Scalars['String']>;
  level_1_approved_by_id?: Maybe<Scalars['bigint']>;
  level_1_approved_on?: Maybe<Scalars['timestamptz']>;
  level_1_remarks?: Maybe<Scalars['String']>;
  level_2_approved_by_id?: Maybe<Scalars['bigint']>;
  level_2_approved_on?: Maybe<Scalars['timestamptz']>;
  level_2_remarks?: Maybe<Scalars['String']>;
  line_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  pallet_no?: Maybe<Scalars['Int']>;
  plot_crop_1_id?: Maybe<Scalars['bigint']>;
  plot_crop_2_id?: Maybe<Scalars['bigint']>;
  prev_rm_clearance?: Maybe<Scalars['String']>;
  primary_packaging_id?: Maybe<Scalars['bigint']>;
  primary_packing_id?: Maybe<Scalars['bigint']>;
  punnet_condition_id?: Maybe<Scalars['bigint']>;
  result_template_1_id?: Maybe<Scalars['bigint']>;
  result_template_2_id?: Maybe<Scalars['bigint']>;
  sampling_location_id?: Maybe<Scalars['bigint']>;
  secondary_packing_id?: Maybe<Scalars['bigint']>;
  sku_id?: Maybe<Scalars['bigint']>;
  so_number?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['bigint']>;
  total_sample_boxes?: Maybe<Scalars['Int']>;
  type_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_1_id?: Maybe<Scalars['bigint']>;
  variety_2_id?: Maybe<Scalars['bigint']>;
  wooden_pallet_condition?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Max_Order_By = {
  arrival_date?: InputMaybe<Order_By>;
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  batch_code?: InputMaybe<Order_By>;
  belongs_to_date?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  chemist_remarks?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  container_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  date_of_checking?: InputMaybe<Order_By>;
  date_of_packing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  layer_no?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_1_approved_on?: InputMaybe<Order_By>;
  level_1_remarks?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_on?: InputMaybe<Order_By>;
  level_2_remarks?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  prev_rm_clearance?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  so_number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
  wooden_pallet_condition?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Inspection_Min_Fields = {
  __typename?: 'pallet_inspection_min_fields';
  arrival_date?: Maybe<Scalars['date']>;
  base_user_1_id?: Maybe<Scalars['bigint']>;
  base_user_2_id?: Maybe<Scalars['bigint']>;
  batch_code?: Maybe<Scalars['String']>;
  belongs_to_date?: Maybe<Scalars['timestamptz']>;
  box_net_weight_id?: Maybe<Scalars['bigint']>;
  chemist_remarks?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['uuid']>;
  container_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['bigint']>;
  date_of_checking?: Maybe<Scalars['date']>;
  date_of_packing?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  layer_no?: Maybe<Scalars['String']>;
  level_1_approved_by_id?: Maybe<Scalars['bigint']>;
  level_1_approved_on?: Maybe<Scalars['timestamptz']>;
  level_1_remarks?: Maybe<Scalars['String']>;
  level_2_approved_by_id?: Maybe<Scalars['bigint']>;
  level_2_approved_on?: Maybe<Scalars['timestamptz']>;
  level_2_remarks?: Maybe<Scalars['String']>;
  line_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  pallet_no?: Maybe<Scalars['Int']>;
  plot_crop_1_id?: Maybe<Scalars['bigint']>;
  plot_crop_2_id?: Maybe<Scalars['bigint']>;
  prev_rm_clearance?: Maybe<Scalars['String']>;
  primary_packaging_id?: Maybe<Scalars['bigint']>;
  primary_packing_id?: Maybe<Scalars['bigint']>;
  punnet_condition_id?: Maybe<Scalars['bigint']>;
  result_template_1_id?: Maybe<Scalars['bigint']>;
  result_template_2_id?: Maybe<Scalars['bigint']>;
  sampling_location_id?: Maybe<Scalars['bigint']>;
  secondary_packing_id?: Maybe<Scalars['bigint']>;
  sku_id?: Maybe<Scalars['bigint']>;
  so_number?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['bigint']>;
  total_sample_boxes?: Maybe<Scalars['Int']>;
  type_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_1_id?: Maybe<Scalars['bigint']>;
  variety_2_id?: Maybe<Scalars['bigint']>;
  wooden_pallet_condition?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Min_Order_By = {
  arrival_date?: InputMaybe<Order_By>;
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  batch_code?: InputMaybe<Order_By>;
  belongs_to_date?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  chemist_remarks?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  container_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  date_of_checking?: InputMaybe<Order_By>;
  date_of_packing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  layer_no?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_1_approved_on?: InputMaybe<Order_By>;
  level_1_remarks?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_on?: InputMaybe<Order_By>;
  level_2_remarks?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  prev_rm_clearance?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  so_number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
  wooden_pallet_condition?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_inspection" */
export type Pallet_Inspection_Mutation_Response = {
  __typename?: 'pallet_inspection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Inspection>;
};

/** input type for inserting object relation for remote table "pallet_inspection" */
export type Pallet_Inspection_Obj_Rel_Insert_Input = {
  data: Pallet_Inspection_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspection_On_Conflict>;
};

/** on_conflict condition type for table "pallet_inspection" */
export type Pallet_Inspection_On_Conflict = {
  constraint: Pallet_Inspection_Constraint;
  update_columns?: Array<Pallet_Inspection_Update_Column>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_inspection". */
export type Pallet_Inspection_Order_By = {
  arrival_date?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Pallet_Inspection_Attachments_Aggregate_Order_By>;
  base_user_1?: InputMaybe<External_Entity_Order_By>;
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2?: InputMaybe<External_Entity_Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  batch_code?: InputMaybe<Order_By>;
  belongs_to_date?: InputMaybe<Order_By>;
  box_net_weight?: InputMaybe<Pallet_Sku_Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  chemist_remarks?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  container_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  customer?: InputMaybe<Pallet_Customer_Order_By>;
  customer_id?: InputMaybe<Order_By>;
  date_of_checking?: InputMaybe<Order_By>;
  date_of_packing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  layer_no?: InputMaybe<Order_By>;
  level_1_approval?: InputMaybe<Order_By>;
  level_1_approved_by?: InputMaybe<External_Entity_Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_1_approved_on?: InputMaybe<Order_By>;
  level_1_remarks?: InputMaybe<Order_By>;
  level_2_approval?: InputMaybe<Order_By>;
  level_2_approved_by?: InputMaybe<External_Entity_Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_on?: InputMaybe<Order_By>;
  level_2_remarks?: InputMaybe<Order_By>;
  line?: InputMaybe<Pallet_Line_Order_By>;
  line_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Pallet_Inspectionobservation_Aggregate_Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1?: InputMaybe<External_Entity_Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2?: InputMaybe<External_Entity_Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  prev_rm_clearance?: InputMaybe<Order_By>;
  primary_packaging?: InputMaybe<Pallet_Packaging_Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing?: InputMaybe<Pallet_Packing_Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition?: InputMaybe<Pallet_Punnetcondition_Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  reports_aggregate?: InputMaybe<Pallet_Inspection_Reports_Aggregate_Order_By>;
  result_template_1?: InputMaybe<Template_Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2?: InputMaybe<Template_Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location?: InputMaybe<Pallet_Samplinglocation_Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing?: InputMaybe<Pallet_Packing_Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Pallet_Sku_Order_By>;
  sku_id?: InputMaybe<Order_By>;
  so_number?: InputMaybe<Order_By>;
  template?: InputMaybe<Template_Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type?: InputMaybe<Pallet_Inspectionkind_Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_1?: InputMaybe<Pallet_Variety_Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2?: InputMaybe<Pallet_Variety_Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
  wooden_pallet_condition?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_inspection */
export type Pallet_Inspection_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Pallet_Inspection_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "pallet_inspection_reports" */
export type Pallet_Inspection_Reports = {
  __typename?: 'pallet_inspection_reports';
  /** An object relationship */
  document_export_log: Document_Export_Log;
  documentexportlog_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  inspection: Pallet_Inspection;
  inspection_id: Scalars['bigint'];
};

/** aggregated selection of "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Aggregate = {
  __typename?: 'pallet_inspection_reports_aggregate';
  aggregate?: Maybe<Pallet_Inspection_Reports_Aggregate_Fields>;
  nodes: Array<Pallet_Inspection_Reports>;
};

/** aggregate fields of "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Aggregate_Fields = {
  __typename?: 'pallet_inspection_reports_aggregate_fields';
  avg?: Maybe<Pallet_Inspection_Reports_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Inspection_Reports_Max_Fields>;
  min?: Maybe<Pallet_Inspection_Reports_Min_Fields>;
  stddev?: Maybe<Pallet_Inspection_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Inspection_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Inspection_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Inspection_Reports_Sum_Fields>;
  var_pop?: Maybe<Pallet_Inspection_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Inspection_Reports_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Inspection_Reports_Variance_Fields>;
};


/** aggregate fields of "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Inspection_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Inspection_Reports_Max_Order_By>;
  min?: InputMaybe<Pallet_Inspection_Reports_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Inspection_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Inspection_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Inspection_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Inspection_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Inspection_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Inspection_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Inspection_Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Inspection_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspection_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Pallet_Inspection_Reports_Avg_Fields = {
  __typename?: 'pallet_inspection_reports_avg_fields';
  documentexportlog_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Avg_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_inspection_reports". All fields are combined with a logical 'AND'. */
export type Pallet_Inspection_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Inspection_Reports_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Inspection_Reports_Bool_Exp>>;
  document_export_log?: InputMaybe<Document_Export_Log_Bool_Exp>;
  documentexportlog_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  inspection?: InputMaybe<Pallet_Inspection_Bool_Exp>;
  inspection_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_inspection_reports" */
export enum Pallet_Inspection_Reports_Constraint {
  /** unique or primary key constraint on columns "inspection_id", "documentexportlog_id" */
  PalletInspectionReportInspectionIdDocumentreAe72552fUniq = 'pallet_inspection_report_inspection_id_documentre_ae72552f_uniq',
  /** unique or primary key constraint on columns "id" */
  PalletInspectionReportsPkey = 'pallet_inspection_reports_pkey'
}

/** input type for incrementing numeric columns in table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Inc_Input = {
  documentexportlog_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Insert_Input = {
  document_export_log?: InputMaybe<Document_Export_Log_Obj_Rel_Insert_Input>;
  documentexportlog_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection?: InputMaybe<Pallet_Inspection_Obj_Rel_Insert_Input>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Pallet_Inspection_Reports_Max_Fields = {
  __typename?: 'pallet_inspection_reports_max_fields';
  documentexportlog_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Max_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Inspection_Reports_Min_Fields = {
  __typename?: 'pallet_inspection_reports_min_fields';
  documentexportlog_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Min_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Mutation_Response = {
  __typename?: 'pallet_inspection_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Inspection_Reports>;
};

/** on_conflict condition type for table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_On_Conflict = {
  constraint: Pallet_Inspection_Reports_Constraint;
  update_columns?: Array<Pallet_Inspection_Reports_Update_Column>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_inspection_reports". */
export type Pallet_Inspection_Reports_Order_By = {
  document_export_log?: InputMaybe<Document_Export_Log_Order_By>;
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection?: InputMaybe<Pallet_Inspection_Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_inspection_reports */
export type Pallet_Inspection_Reports_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_inspection_reports" */
export enum Pallet_Inspection_Reports_Select_Column {
  /** column name */
  DocumentexportlogId = 'documentexportlog_id',
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id'
}

/** input type for updating data in table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Set_Input = {
  documentexportlog_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Pallet_Inspection_Reports_Stddev_Fields = {
  __typename?: 'pallet_inspection_reports_stddev_fields';
  documentexportlog_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Stddev_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Inspection_Reports_Stddev_Pop_Fields = {
  __typename?: 'pallet_inspection_reports_stddev_pop_fields';
  documentexportlog_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Stddev_Pop_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Inspection_Reports_Stddev_Samp_Fields = {
  __typename?: 'pallet_inspection_reports_stddev_samp_fields';
  documentexportlog_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Stddev_Samp_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Inspection_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Inspection_Reports_Stream_Cursor_Value_Input = {
  documentexportlog_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Pallet_Inspection_Reports_Sum_Fields = {
  __typename?: 'pallet_inspection_reports_sum_fields';
  documentexportlog_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Sum_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_inspection_reports" */
export enum Pallet_Inspection_Reports_Update_Column {
  /** column name */
  DocumentexportlogId = 'documentexportlog_id',
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id'
}

export type Pallet_Inspection_Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Inspection_Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Inspection_Reports_Set_Input>;
  where: Pallet_Inspection_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Inspection_Reports_Var_Pop_Fields = {
  __typename?: 'pallet_inspection_reports_var_pop_fields';
  documentexportlog_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Var_Pop_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Inspection_Reports_Var_Samp_Fields = {
  __typename?: 'pallet_inspection_reports_var_samp_fields';
  documentexportlog_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Var_Samp_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Inspection_Reports_Variance_Fields = {
  __typename?: 'pallet_inspection_reports_variance_fields';
  documentexportlog_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_inspection_reports" */
export type Pallet_Inspection_Reports_Variance_Order_By = {
  documentexportlog_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
};

/** select columns of table "pallet_inspection" */
export enum Pallet_Inspection_Select_Column {
  /** column name */
  ArrivalDate = 'arrival_date',
  /** column name */
  BaseUser_1Id = 'base_user_1_id',
  /** column name */
  BaseUser_2Id = 'base_user_2_id',
  /** column name */
  BatchCode = 'batch_code',
  /** column name */
  BelongsToDate = 'belongs_to_date',
  /** column name */
  BoxNetWeightId = 'box_net_weight_id',
  /** column name */
  ChemistRemarks = 'chemist_remarks',
  /** column name */
  Codename = 'codename',
  /** column name */
  ContainerNumber = 'container_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DateOfChecking = 'date_of_checking',
  /** column name */
  DateOfPacking = 'date_of_packing',
  /** column name */
  Id = 'id',
  /** column name */
  LayerNo = 'layer_no',
  /** column name */
  Level_1Approval = 'level_1_approval',
  /** column name */
  Level_1ApprovedById = 'level_1_approved_by_id',
  /** column name */
  Level_1ApprovedOn = 'level_1_approved_on',
  /** column name */
  Level_1Remarks = 'level_1_remarks',
  /** column name */
  Level_2Approval = 'level_2_approval',
  /** column name */
  Level_2ApprovedById = 'level_2_approved_by_id',
  /** column name */
  Level_2ApprovedOn = 'level_2_approved_on',
  /** column name */
  Level_2Remarks = 'level_2_remarks',
  /** column name */
  LineId = 'line_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PalletNo = 'pallet_no',
  /** column name */
  PlotCrop_1Id = 'plot_crop_1_id',
  /** column name */
  PlotCrop_2Id = 'plot_crop_2_id',
  /** column name */
  PrevRmClearance = 'prev_rm_clearance',
  /** column name */
  PrimaryPackagingId = 'primary_packaging_id',
  /** column name */
  PrimaryPackingId = 'primary_packing_id',
  /** column name */
  PunnetConditionId = 'punnet_condition_id',
  /** column name */
  ResultTemplate_1Id = 'result_template_1_id',
  /** column name */
  ResultTemplate_2Id = 'result_template_2_id',
  /** column name */
  SamplingLocationId = 'sampling_location_id',
  /** column name */
  SecondaryPackingId = 'secondary_packing_id',
  /** column name */
  SkuId = 'sku_id',
  /** column name */
  SoNumber = 'so_number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TotalSampleBoxes = 'total_sample_boxes',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Variety_1Id = 'variety_1_id',
  /** column name */
  Variety_2Id = 'variety_2_id',
  /** column name */
  WoodenPalletCondition = 'wooden_pallet_condition'
}

/** input type for updating data in table "pallet_inspection" */
export type Pallet_Inspection_Set_Input = {
  arrival_date?: InputMaybe<Scalars['date']>;
  base_user_1_id?: InputMaybe<Scalars['bigint']>;
  base_user_2_id?: InputMaybe<Scalars['bigint']>;
  batch_code?: InputMaybe<Scalars['String']>;
  belongs_to_date?: InputMaybe<Scalars['timestamptz']>;
  box_net_weight_id?: InputMaybe<Scalars['bigint']>;
  chemist_remarks?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['uuid']>;
  container_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['bigint']>;
  date_of_checking?: InputMaybe<Scalars['date']>;
  date_of_packing?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  layer_no?: InputMaybe<Scalars['String']>;
  level_1_approval?: InputMaybe<Scalars['Boolean']>;
  level_1_approved_by_id?: InputMaybe<Scalars['bigint']>;
  level_1_approved_on?: InputMaybe<Scalars['timestamptz']>;
  level_1_remarks?: InputMaybe<Scalars['String']>;
  level_2_approval?: InputMaybe<Scalars['Boolean']>;
  level_2_approved_by_id?: InputMaybe<Scalars['bigint']>;
  level_2_approved_on?: InputMaybe<Scalars['timestamptz']>;
  level_2_remarks?: InputMaybe<Scalars['String']>;
  line_id?: InputMaybe<Scalars['bigint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  pallet_no?: InputMaybe<Scalars['Int']>;
  plot_crop_1_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_2_id?: InputMaybe<Scalars['bigint']>;
  prev_rm_clearance?: InputMaybe<Scalars['String']>;
  primary_packaging_id?: InputMaybe<Scalars['bigint']>;
  primary_packing_id?: InputMaybe<Scalars['bigint']>;
  punnet_condition_id?: InputMaybe<Scalars['bigint']>;
  result_template_1_id?: InputMaybe<Scalars['bigint']>;
  result_template_2_id?: InputMaybe<Scalars['bigint']>;
  sampling_location_id?: InputMaybe<Scalars['bigint']>;
  secondary_packing_id?: InputMaybe<Scalars['bigint']>;
  sku_id?: InputMaybe<Scalars['bigint']>;
  so_number?: InputMaybe<Scalars['String']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  total_sample_boxes?: InputMaybe<Scalars['Int']>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  variety_1_id?: InputMaybe<Scalars['bigint']>;
  variety_2_id?: InputMaybe<Scalars['bigint']>;
  wooden_pallet_condition?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Pallet_Inspection_Stddev_Fields = {
  __typename?: 'pallet_inspection_stddev_fields';
  base_user_1_id?: Maybe<Scalars['Float']>;
  base_user_2_id?: Maybe<Scalars['Float']>;
  box_net_weight_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level_1_approved_by_id?: Maybe<Scalars['Float']>;
  level_2_approved_by_id?: Maybe<Scalars['Float']>;
  line_id?: Maybe<Scalars['Float']>;
  pallet_no?: Maybe<Scalars['Float']>;
  plot_crop_1_id?: Maybe<Scalars['Float']>;
  plot_crop_2_id?: Maybe<Scalars['Float']>;
  primary_packaging_id?: Maybe<Scalars['Float']>;
  primary_packing_id?: Maybe<Scalars['Float']>;
  punnet_condition_id?: Maybe<Scalars['Float']>;
  result_template_1_id?: Maybe<Scalars['Float']>;
  result_template_2_id?: Maybe<Scalars['Float']>;
  sampling_location_id?: Maybe<Scalars['Float']>;
  secondary_packing_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  total_sample_boxes?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
  variety_1_id?: Maybe<Scalars['Float']>;
  variety_2_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Stddev_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Inspection_Stddev_Pop_Fields = {
  __typename?: 'pallet_inspection_stddev_pop_fields';
  base_user_1_id?: Maybe<Scalars['Float']>;
  base_user_2_id?: Maybe<Scalars['Float']>;
  box_net_weight_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level_1_approved_by_id?: Maybe<Scalars['Float']>;
  level_2_approved_by_id?: Maybe<Scalars['Float']>;
  line_id?: Maybe<Scalars['Float']>;
  pallet_no?: Maybe<Scalars['Float']>;
  plot_crop_1_id?: Maybe<Scalars['Float']>;
  plot_crop_2_id?: Maybe<Scalars['Float']>;
  primary_packaging_id?: Maybe<Scalars['Float']>;
  primary_packing_id?: Maybe<Scalars['Float']>;
  punnet_condition_id?: Maybe<Scalars['Float']>;
  result_template_1_id?: Maybe<Scalars['Float']>;
  result_template_2_id?: Maybe<Scalars['Float']>;
  sampling_location_id?: Maybe<Scalars['Float']>;
  secondary_packing_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  total_sample_boxes?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
  variety_1_id?: Maybe<Scalars['Float']>;
  variety_2_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Stddev_Pop_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Inspection_Stddev_Samp_Fields = {
  __typename?: 'pallet_inspection_stddev_samp_fields';
  base_user_1_id?: Maybe<Scalars['Float']>;
  base_user_2_id?: Maybe<Scalars['Float']>;
  box_net_weight_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level_1_approved_by_id?: Maybe<Scalars['Float']>;
  level_2_approved_by_id?: Maybe<Scalars['Float']>;
  line_id?: Maybe<Scalars['Float']>;
  pallet_no?: Maybe<Scalars['Float']>;
  plot_crop_1_id?: Maybe<Scalars['Float']>;
  plot_crop_2_id?: Maybe<Scalars['Float']>;
  primary_packaging_id?: Maybe<Scalars['Float']>;
  primary_packing_id?: Maybe<Scalars['Float']>;
  punnet_condition_id?: Maybe<Scalars['Float']>;
  result_template_1_id?: Maybe<Scalars['Float']>;
  result_template_2_id?: Maybe<Scalars['Float']>;
  sampling_location_id?: Maybe<Scalars['Float']>;
  secondary_packing_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  total_sample_boxes?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
  variety_1_id?: Maybe<Scalars['Float']>;
  variety_2_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Stddev_Samp_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_inspection" */
export type Pallet_Inspection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Inspection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Inspection_Stream_Cursor_Value_Input = {
  arrival_date?: InputMaybe<Scalars['date']>;
  base_user_1_id?: InputMaybe<Scalars['bigint']>;
  base_user_2_id?: InputMaybe<Scalars['bigint']>;
  batch_code?: InputMaybe<Scalars['String']>;
  belongs_to_date?: InputMaybe<Scalars['timestamptz']>;
  box_net_weight_id?: InputMaybe<Scalars['bigint']>;
  chemist_remarks?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['uuid']>;
  container_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['bigint']>;
  date_of_checking?: InputMaybe<Scalars['date']>;
  date_of_packing?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  layer_no?: InputMaybe<Scalars['String']>;
  level_1_approval?: InputMaybe<Scalars['Boolean']>;
  level_1_approved_by_id?: InputMaybe<Scalars['bigint']>;
  level_1_approved_on?: InputMaybe<Scalars['timestamptz']>;
  level_1_remarks?: InputMaybe<Scalars['String']>;
  level_2_approval?: InputMaybe<Scalars['Boolean']>;
  level_2_approved_by_id?: InputMaybe<Scalars['bigint']>;
  level_2_approved_on?: InputMaybe<Scalars['timestamptz']>;
  level_2_remarks?: InputMaybe<Scalars['String']>;
  line_id?: InputMaybe<Scalars['bigint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  pallet_no?: InputMaybe<Scalars['Int']>;
  plot_crop_1_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_2_id?: InputMaybe<Scalars['bigint']>;
  prev_rm_clearance?: InputMaybe<Scalars['String']>;
  primary_packaging_id?: InputMaybe<Scalars['bigint']>;
  primary_packing_id?: InputMaybe<Scalars['bigint']>;
  punnet_condition_id?: InputMaybe<Scalars['bigint']>;
  result_template_1_id?: InputMaybe<Scalars['bigint']>;
  result_template_2_id?: InputMaybe<Scalars['bigint']>;
  sampling_location_id?: InputMaybe<Scalars['bigint']>;
  secondary_packing_id?: InputMaybe<Scalars['bigint']>;
  sku_id?: InputMaybe<Scalars['bigint']>;
  so_number?: InputMaybe<Scalars['String']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  total_sample_boxes?: InputMaybe<Scalars['Int']>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  variety_1_id?: InputMaybe<Scalars['bigint']>;
  variety_2_id?: InputMaybe<Scalars['bigint']>;
  wooden_pallet_condition?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Pallet_Inspection_Sum_Fields = {
  __typename?: 'pallet_inspection_sum_fields';
  base_user_1_id?: Maybe<Scalars['bigint']>;
  base_user_2_id?: Maybe<Scalars['bigint']>;
  box_net_weight_id?: Maybe<Scalars['bigint']>;
  customer_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  level_1_approved_by_id?: Maybe<Scalars['bigint']>;
  level_2_approved_by_id?: Maybe<Scalars['bigint']>;
  line_id?: Maybe<Scalars['bigint']>;
  pallet_no?: Maybe<Scalars['Int']>;
  plot_crop_1_id?: Maybe<Scalars['bigint']>;
  plot_crop_2_id?: Maybe<Scalars['bigint']>;
  primary_packaging_id?: Maybe<Scalars['bigint']>;
  primary_packing_id?: Maybe<Scalars['bigint']>;
  punnet_condition_id?: Maybe<Scalars['bigint']>;
  result_template_1_id?: Maybe<Scalars['bigint']>;
  result_template_2_id?: Maybe<Scalars['bigint']>;
  sampling_location_id?: Maybe<Scalars['bigint']>;
  secondary_packing_id?: Maybe<Scalars['bigint']>;
  sku_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  total_sample_boxes?: Maybe<Scalars['Int']>;
  type_id?: Maybe<Scalars['bigint']>;
  variety_1_id?: Maybe<Scalars['bigint']>;
  variety_2_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Sum_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_inspection" */
export enum Pallet_Inspection_Update_Column {
  /** column name */
  ArrivalDate = 'arrival_date',
  /** column name */
  BaseUser_1Id = 'base_user_1_id',
  /** column name */
  BaseUser_2Id = 'base_user_2_id',
  /** column name */
  BatchCode = 'batch_code',
  /** column name */
  BelongsToDate = 'belongs_to_date',
  /** column name */
  BoxNetWeightId = 'box_net_weight_id',
  /** column name */
  ChemistRemarks = 'chemist_remarks',
  /** column name */
  Codename = 'codename',
  /** column name */
  ContainerNumber = 'container_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DateOfChecking = 'date_of_checking',
  /** column name */
  DateOfPacking = 'date_of_packing',
  /** column name */
  Id = 'id',
  /** column name */
  LayerNo = 'layer_no',
  /** column name */
  Level_1Approval = 'level_1_approval',
  /** column name */
  Level_1ApprovedById = 'level_1_approved_by_id',
  /** column name */
  Level_1ApprovedOn = 'level_1_approved_on',
  /** column name */
  Level_1Remarks = 'level_1_remarks',
  /** column name */
  Level_2Approval = 'level_2_approval',
  /** column name */
  Level_2ApprovedById = 'level_2_approved_by_id',
  /** column name */
  Level_2ApprovedOn = 'level_2_approved_on',
  /** column name */
  Level_2Remarks = 'level_2_remarks',
  /** column name */
  LineId = 'line_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PalletNo = 'pallet_no',
  /** column name */
  PlotCrop_1Id = 'plot_crop_1_id',
  /** column name */
  PlotCrop_2Id = 'plot_crop_2_id',
  /** column name */
  PrevRmClearance = 'prev_rm_clearance',
  /** column name */
  PrimaryPackagingId = 'primary_packaging_id',
  /** column name */
  PrimaryPackingId = 'primary_packing_id',
  /** column name */
  PunnetConditionId = 'punnet_condition_id',
  /** column name */
  ResultTemplate_1Id = 'result_template_1_id',
  /** column name */
  ResultTemplate_2Id = 'result_template_2_id',
  /** column name */
  SamplingLocationId = 'sampling_location_id',
  /** column name */
  SecondaryPackingId = 'secondary_packing_id',
  /** column name */
  SkuId = 'sku_id',
  /** column name */
  SoNumber = 'so_number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TotalSampleBoxes = 'total_sample_boxes',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Variety_1Id = 'variety_1_id',
  /** column name */
  Variety_2Id = 'variety_2_id',
  /** column name */
  WoodenPalletCondition = 'wooden_pallet_condition'
}

export type Pallet_Inspection_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Pallet_Inspection_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Pallet_Inspection_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Pallet_Inspection_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Pallet_Inspection_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Inspection_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Pallet_Inspection_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Inspection_Set_Input>;
  where: Pallet_Inspection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Inspection_Var_Pop_Fields = {
  __typename?: 'pallet_inspection_var_pop_fields';
  base_user_1_id?: Maybe<Scalars['Float']>;
  base_user_2_id?: Maybe<Scalars['Float']>;
  box_net_weight_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level_1_approved_by_id?: Maybe<Scalars['Float']>;
  level_2_approved_by_id?: Maybe<Scalars['Float']>;
  line_id?: Maybe<Scalars['Float']>;
  pallet_no?: Maybe<Scalars['Float']>;
  plot_crop_1_id?: Maybe<Scalars['Float']>;
  plot_crop_2_id?: Maybe<Scalars['Float']>;
  primary_packaging_id?: Maybe<Scalars['Float']>;
  primary_packing_id?: Maybe<Scalars['Float']>;
  punnet_condition_id?: Maybe<Scalars['Float']>;
  result_template_1_id?: Maybe<Scalars['Float']>;
  result_template_2_id?: Maybe<Scalars['Float']>;
  sampling_location_id?: Maybe<Scalars['Float']>;
  secondary_packing_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  total_sample_boxes?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
  variety_1_id?: Maybe<Scalars['Float']>;
  variety_2_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Var_Pop_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Inspection_Var_Samp_Fields = {
  __typename?: 'pallet_inspection_var_samp_fields';
  base_user_1_id?: Maybe<Scalars['Float']>;
  base_user_2_id?: Maybe<Scalars['Float']>;
  box_net_weight_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level_1_approved_by_id?: Maybe<Scalars['Float']>;
  level_2_approved_by_id?: Maybe<Scalars['Float']>;
  line_id?: Maybe<Scalars['Float']>;
  pallet_no?: Maybe<Scalars['Float']>;
  plot_crop_1_id?: Maybe<Scalars['Float']>;
  plot_crop_2_id?: Maybe<Scalars['Float']>;
  primary_packaging_id?: Maybe<Scalars['Float']>;
  primary_packing_id?: Maybe<Scalars['Float']>;
  punnet_condition_id?: Maybe<Scalars['Float']>;
  result_template_1_id?: Maybe<Scalars['Float']>;
  result_template_2_id?: Maybe<Scalars['Float']>;
  sampling_location_id?: Maybe<Scalars['Float']>;
  secondary_packing_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  total_sample_boxes?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
  variety_1_id?: Maybe<Scalars['Float']>;
  variety_2_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Var_Samp_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Inspection_Variance_Fields = {
  __typename?: 'pallet_inspection_variance_fields';
  base_user_1_id?: Maybe<Scalars['Float']>;
  base_user_2_id?: Maybe<Scalars['Float']>;
  box_net_weight_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  level_1_approved_by_id?: Maybe<Scalars['Float']>;
  level_2_approved_by_id?: Maybe<Scalars['Float']>;
  line_id?: Maybe<Scalars['Float']>;
  pallet_no?: Maybe<Scalars['Float']>;
  plot_crop_1_id?: Maybe<Scalars['Float']>;
  plot_crop_2_id?: Maybe<Scalars['Float']>;
  primary_packaging_id?: Maybe<Scalars['Float']>;
  primary_packing_id?: Maybe<Scalars['Float']>;
  punnet_condition_id?: Maybe<Scalars['Float']>;
  result_template_1_id?: Maybe<Scalars['Float']>;
  result_template_2_id?: Maybe<Scalars['Float']>;
  sampling_location_id?: Maybe<Scalars['Float']>;
  secondary_packing_id?: Maybe<Scalars['Float']>;
  sku_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  total_sample_boxes?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
  variety_1_id?: Maybe<Scalars['Float']>;
  variety_2_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_inspection" */
export type Pallet_Inspection_Variance_Order_By = {
  base_user_1_id?: InputMaybe<Order_By>;
  base_user_2_id?: InputMaybe<Order_By>;
  box_net_weight_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level_1_approved_by_id?: InputMaybe<Order_By>;
  level_2_approved_by_id?: InputMaybe<Order_By>;
  line_id?: InputMaybe<Order_By>;
  pallet_no?: InputMaybe<Order_By>;
  plot_crop_1_id?: InputMaybe<Order_By>;
  plot_crop_2_id?: InputMaybe<Order_By>;
  primary_packaging_id?: InputMaybe<Order_By>;
  primary_packing_id?: InputMaybe<Order_By>;
  punnet_condition_id?: InputMaybe<Order_By>;
  result_template_1_id?: InputMaybe<Order_By>;
  result_template_2_id?: InputMaybe<Order_By>;
  sampling_location_id?: InputMaybe<Order_By>;
  secondary_packing_id?: InputMaybe<Order_By>;
  sku_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  total_sample_boxes?: InputMaybe<Order_By>;
  type_id?: InputMaybe<Order_By>;
  variety_1_id?: InputMaybe<Order_By>;
  variety_2_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "pallet_inspectionkind" */
export type Pallet_Inspectionkind = {
  __typename?: 'pallet_inspectionkind';
  codename: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Aggregate = {
  __typename?: 'pallet_inspectionkind_aggregate';
  aggregate?: Maybe<Pallet_Inspectionkind_Aggregate_Fields>;
  nodes: Array<Pallet_Inspectionkind>;
};

/** aggregate fields of "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Aggregate_Fields = {
  __typename?: 'pallet_inspectionkind_aggregate_fields';
  avg?: Maybe<Pallet_Inspectionkind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Inspectionkind_Max_Fields>;
  min?: Maybe<Pallet_Inspectionkind_Min_Fields>;
  stddev?: Maybe<Pallet_Inspectionkind_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Inspectionkind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Inspectionkind_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Inspectionkind_Sum_Fields>;
  var_pop?: Maybe<Pallet_Inspectionkind_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Inspectionkind_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Inspectionkind_Variance_Fields>;
};


/** aggregate fields of "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Inspectionkind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Inspectionkind_Avg_Fields = {
  __typename?: 'pallet_inspectionkind_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_inspectionkind". All fields are combined with a logical 'AND'. */
export type Pallet_Inspectionkind_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Inspectionkind_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Inspectionkind_Bool_Exp>>;
  codename?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_inspectionkind" */
export enum Pallet_Inspectionkind_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PalletInspectiontypeCodenameKey = 'pallet_inspectiontype_codename_key',
  /** unique or primary key constraint on columns "id" */
  PalletInspectiontypePkey = 'pallet_inspectiontype_pkey'
}

/** input type for incrementing numeric columns in table "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Insert_Input = {
  codename?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Inspectionkind_Max_Fields = {
  __typename?: 'pallet_inspectionkind_max_fields';
  codename?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Inspectionkind_Min_Fields = {
  __typename?: 'pallet_inspectionkind_min_fields';
  codename?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Mutation_Response = {
  __typename?: 'pallet_inspectionkind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Inspectionkind>;
};

/** input type for inserting object relation for remote table "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Obj_Rel_Insert_Input = {
  data: Pallet_Inspectionkind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspectionkind_On_Conflict>;
};

/** on_conflict condition type for table "pallet_inspectionkind" */
export type Pallet_Inspectionkind_On_Conflict = {
  constraint: Pallet_Inspectionkind_Constraint;
  update_columns?: Array<Pallet_Inspectionkind_Update_Column>;
  where?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_inspectionkind". */
export type Pallet_Inspectionkind_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_inspectionkind */
export type Pallet_Inspectionkind_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_inspectionkind" */
export enum Pallet_Inspectionkind_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Set_Input = {
  codename?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Inspectionkind_Stddev_Fields = {
  __typename?: 'pallet_inspectionkind_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Inspectionkind_Stddev_Pop_Fields = {
  __typename?: 'pallet_inspectionkind_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Inspectionkind_Stddev_Samp_Fields = {
  __typename?: 'pallet_inspectionkind_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_inspectionkind" */
export type Pallet_Inspectionkind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Inspectionkind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Inspectionkind_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Inspectionkind_Sum_Fields = {
  __typename?: 'pallet_inspectionkind_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_inspectionkind" */
export enum Pallet_Inspectionkind_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Inspectionkind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Inspectionkind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Inspectionkind_Set_Input>;
  where: Pallet_Inspectionkind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Inspectionkind_Var_Pop_Fields = {
  __typename?: 'pallet_inspectionkind_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Inspectionkind_Var_Samp_Fields = {
  __typename?: 'pallet_inspectionkind_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Inspectionkind_Variance_Fields = {
  __typename?: 'pallet_inspectionkind_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation = {
  __typename?: 'pallet_inspectionobservation';
  /** An array relationship */
  attachments: Array<Pallet_Inspectionobservation_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Pallet_Inspectionobservation_Attachments_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  inspection: Pallet_Inspection;
  inspection_id: Scalars['bigint'];
  observation_number: Scalars['Int'];
  remark: Scalars['String'];
  /** An object relationship */
  template_parameter: Template_Parameter;
  template_parameter_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['numeric']>;
  value_text?: Maybe<Scalars['String']>;
};


/** columns and relationships of "pallet_inspectionobservation" */
export type Pallet_InspectionobservationAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};


/** columns and relationships of "pallet_inspectionobservation" */
export type Pallet_InspectionobservationAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};

/** aggregated selection of "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Aggregate = {
  __typename?: 'pallet_inspectionobservation_aggregate';
  aggregate?: Maybe<Pallet_Inspectionobservation_Aggregate_Fields>;
  nodes: Array<Pallet_Inspectionobservation>;
};

/** aggregate fields of "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Aggregate_Fields = {
  __typename?: 'pallet_inspectionobservation_aggregate_fields';
  avg?: Maybe<Pallet_Inspectionobservation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Inspectionobservation_Max_Fields>;
  min?: Maybe<Pallet_Inspectionobservation_Min_Fields>;
  stddev?: Maybe<Pallet_Inspectionobservation_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Inspectionobservation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Inspectionobservation_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Inspectionobservation_Sum_Fields>;
  var_pop?: Maybe<Pallet_Inspectionobservation_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Inspectionobservation_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Inspectionobservation_Variance_Fields>;
};


/** aggregate fields of "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Inspectionobservation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Inspectionobservation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Inspectionobservation_Max_Order_By>;
  min?: InputMaybe<Pallet_Inspectionobservation_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Inspectionobservation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Inspectionobservation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Inspectionobservation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Inspectionobservation_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Inspectionobservation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Inspectionobservation_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Inspectionobservation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Inspectionobservation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspectionobservation_On_Conflict>;
};

/** columns and relationships of "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments = {
  __typename?: 'pallet_inspectionobservation_attachments';
  id: Scalars['bigint'];
  inspectionobservation_id: Scalars['bigint'];
  /** An object relationship */
  media: Eagle_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  observation: Pallet_Inspectionobservation;
};

/** aggregated selection of "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Aggregate = {
  __typename?: 'pallet_inspectionobservation_attachments_aggregate';
  aggregate?: Maybe<Pallet_Inspectionobservation_Attachments_Aggregate_Fields>;
  nodes: Array<Pallet_Inspectionobservation_Attachments>;
};

/** aggregate fields of "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Aggregate_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_aggregate_fields';
  avg?: Maybe<Pallet_Inspectionobservation_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Inspectionobservation_Attachments_Max_Fields>;
  min?: Maybe<Pallet_Inspectionobservation_Attachments_Min_Fields>;
  stddev?: Maybe<Pallet_Inspectionobservation_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Inspectionobservation_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Inspectionobservation_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Inspectionobservation_Attachments_Sum_Fields>;
  var_pop?: Maybe<Pallet_Inspectionobservation_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Inspectionobservation_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Inspectionobservation_Attachments_Variance_Fields>;
};


/** aggregate fields of "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Inspectionobservation_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Inspectionobservation_Attachments_Max_Order_By>;
  min?: InputMaybe<Pallet_Inspectionobservation_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Inspectionobservation_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Inspectionobservation_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Inspectionobservation_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Inspectionobservation_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Inspectionobservation_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Inspectionobservation_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Inspectionobservation_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Inspectionobservation_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspectionobservation_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Pallet_Inspectionobservation_Attachments_Avg_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  inspectionobservation_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_inspectionobservation_attachments". All fields are combined with a logical 'AND'. */
export type Pallet_Inspectionobservation_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  inspectionobservation_id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  observation?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};

/** unique or primary key constraints on table "pallet_inspectionobservation_attachments" */
export enum Pallet_Inspectionobservation_Attachments_Constraint {
  /** unique or primary key constraint on columns "inspectionobservation_id", "media_id" */
  PalletInspectionobservaInspectionobservationIdBc829327Uniq = 'pallet_inspectionobserva_inspectionobservation_id_bc829327_uniq',
  /** unique or primary key constraint on columns "id" */
  PalletInspectionobservationAttachmentsPkey = 'pallet_inspectionobservation_attachments_pkey'
}

/** input type for incrementing numeric columns in table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspectionobservation_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspectionobservation_id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  observation?: InputMaybe<Pallet_Inspectionobservation_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pallet_Inspectionobservation_Attachments_Max_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  inspectionobservation_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Inspectionobservation_Attachments_Min_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  inspectionobservation_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Mutation_Response = {
  __typename?: 'pallet_inspectionobservation_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Inspectionobservation_Attachments>;
};

/** on_conflict condition type for table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_On_Conflict = {
  constraint: Pallet_Inspectionobservation_Attachments_Constraint;
  update_columns?: Array<Pallet_Inspectionobservation_Attachments_Update_Column>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_inspectionobservation_attachments". */
export type Pallet_Inspectionobservation_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  observation?: InputMaybe<Pallet_Inspectionobservation_Order_By>;
};

/** primary key columns input for table: pallet_inspectionobservation_attachments */
export type Pallet_Inspectionobservation_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_inspectionobservation_attachments" */
export enum Pallet_Inspectionobservation_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InspectionobservationId = 'inspectionobservation_id',
  /** column name */
  MediaId = 'media_id'
}

/** input type for updating data in table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspectionobservation_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Pallet_Inspectionobservation_Attachments_Stddev_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  inspectionobservation_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Inspectionobservation_Attachments_Stddev_Pop_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  inspectionobservation_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Inspectionobservation_Attachments_Stddev_Samp_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  inspectionobservation_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Inspectionobservation_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Inspectionobservation_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspectionobservation_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Pallet_Inspectionobservation_Attachments_Sum_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  inspectionobservation_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_inspectionobservation_attachments" */
export enum Pallet_Inspectionobservation_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InspectionobservationId = 'inspectionobservation_id',
  /** column name */
  MediaId = 'media_id'
}

export type Pallet_Inspectionobservation_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Inspectionobservation_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Inspectionobservation_Attachments_Set_Input>;
  where: Pallet_Inspectionobservation_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Inspectionobservation_Attachments_Var_Pop_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  inspectionobservation_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Inspectionobservation_Attachments_Var_Samp_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  inspectionobservation_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Inspectionobservation_Attachments_Variance_Fields = {
  __typename?: 'pallet_inspectionobservation_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  inspectionobservation_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_inspectionobservation_attachments" */
export type Pallet_Inspectionobservation_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  inspectionobservation_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Pallet_Inspectionobservation_Avg_Fields = {
  __typename?: 'pallet_inspectionobservation_avg_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_inspectionobservation". All fields are combined with a logical 'AND'. */
export type Pallet_Inspectionobservation_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Inspectionobservation_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Inspectionobservation_Bool_Exp>>;
  attachments?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  inspection?: InputMaybe<Pallet_Inspection_Bool_Exp>;
  inspection_id?: InputMaybe<Bigint_Comparison_Exp>;
  observation_number?: InputMaybe<Int_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  template_parameter?: InputMaybe<Template_Parameter_Bool_Exp>;
  template_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
  value_text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_inspectionobservation" */
export enum Pallet_Inspectionobservation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletInspectionobservationPkey = 'pallet_inspectionobservation_pkey'
}

/** input type for incrementing numeric columns in table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Insert_Input = {
  attachments?: InputMaybe<Pallet_Inspectionobservation_Attachments_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection?: InputMaybe<Pallet_Inspection_Obj_Rel_Insert_Input>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  template_parameter?: InputMaybe<Template_Parameter_Obj_Rel_Insert_Input>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
  value_text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Pallet_Inspectionobservation_Max_Fields = {
  __typename?: 'pallet_inspectionobservation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
  observation_number?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
  value_text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Inspectionobservation_Min_Fields = {
  __typename?: 'pallet_inspectionobservation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
  observation_number?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
  value_text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Mutation_Response = {
  __typename?: 'pallet_inspectionobservation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Inspectionobservation>;
};

/** input type for inserting object relation for remote table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Obj_Rel_Insert_Input = {
  data: Pallet_Inspectionobservation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Inspectionobservation_On_Conflict>;
};

/** on_conflict condition type for table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_On_Conflict = {
  constraint: Pallet_Inspectionobservation_Constraint;
  update_columns?: Array<Pallet_Inspectionobservation_Update_Column>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_inspectionobservation". */
export type Pallet_Inspectionobservation_Order_By = {
  attachments_aggregate?: InputMaybe<Pallet_Inspectionobservation_Attachments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspection?: InputMaybe<Pallet_Inspection_Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  template_parameter?: InputMaybe<Template_Parameter_Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_inspectionobservation */
export type Pallet_Inspectionobservation_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_inspectionobservation" */
export enum Pallet_Inspectionobservation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id',
  /** column name */
  ObservationNumber = 'observation_number',
  /** column name */
  Remark = 'remark',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueText = 'value_text'
}

/** input type for updating data in table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
  value_text?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Pallet_Inspectionobservation_Stddev_Fields = {
  __typename?: 'pallet_inspectionobservation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Inspectionobservation_Stddev_Pop_Fields = {
  __typename?: 'pallet_inspectionobservation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Inspectionobservation_Stddev_Samp_Fields = {
  __typename?: 'pallet_inspectionobservation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Inspectionobservation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Inspectionobservation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  inspection_id?: InputMaybe<Scalars['bigint']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
  value_text?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Pallet_Inspectionobservation_Sum_Fields = {
  __typename?: 'pallet_inspectionobservation_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  inspection_id?: Maybe<Scalars['bigint']>;
  observation_number?: Maybe<Scalars['Int']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_inspectionobservation" */
export enum Pallet_Inspectionobservation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InspectionId = 'inspection_id',
  /** column name */
  ObservationNumber = 'observation_number',
  /** column name */
  Remark = 'remark',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueText = 'value_text'
}

export type Pallet_Inspectionobservation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Inspectionobservation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Inspectionobservation_Set_Input>;
  where: Pallet_Inspectionobservation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Inspectionobservation_Var_Pop_Fields = {
  __typename?: 'pallet_inspectionobservation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Inspectionobservation_Var_Samp_Fields = {
  __typename?: 'pallet_inspectionobservation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Inspectionobservation_Variance_Fields = {
  __typename?: 'pallet_inspectionobservation_variance_fields';
  id?: Maybe<Scalars['Float']>;
  inspection_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_inspectionobservation" */
export type Pallet_Inspectionobservation_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  inspection_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "pallet_line" */
export type Pallet_Line = {
  __typename?: 'pallet_line';
  created_at: Scalars['timestamptz'];
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An object relationship */
  location: Pallet_Location;
  location_id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_line" */
export type Pallet_Line_Aggregate = {
  __typename?: 'pallet_line_aggregate';
  aggregate?: Maybe<Pallet_Line_Aggregate_Fields>;
  nodes: Array<Pallet_Line>;
};

/** aggregate fields of "pallet_line" */
export type Pallet_Line_Aggregate_Fields = {
  __typename?: 'pallet_line_aggregate_fields';
  avg?: Maybe<Pallet_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Line_Max_Fields>;
  min?: Maybe<Pallet_Line_Min_Fields>;
  stddev?: Maybe<Pallet_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Line_Sum_Fields>;
  var_pop?: Maybe<Pallet_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Line_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Line_Variance_Fields>;
};


/** aggregate fields of "pallet_line" */
export type Pallet_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Line_Avg_Fields = {
  __typename?: 'pallet_line_avg_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_line". All fields are combined with a logical 'AND'. */
export type Pallet_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Line_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Line_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  location?: InputMaybe<Pallet_Location_Bool_Exp>;
  location_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_line" */
export enum Pallet_Line_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletLinePkey = 'pallet_line_pkey'
}

/** input type for incrementing numeric columns in table "pallet_line" */
export type Pallet_Line_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_line" */
export type Pallet_Line_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  location?: InputMaybe<Pallet_Location_Obj_Rel_Insert_Input>;
  location_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Line_Max_Fields = {
  __typename?: 'pallet_line_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Line_Min_Fields = {
  __typename?: 'pallet_line_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_line" */
export type Pallet_Line_Mutation_Response = {
  __typename?: 'pallet_line_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Line>;
};

/** input type for inserting object relation for remote table "pallet_line" */
export type Pallet_Line_Obj_Rel_Insert_Input = {
  data: Pallet_Line_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Line_On_Conflict>;
};

/** on_conflict condition type for table "pallet_line" */
export type Pallet_Line_On_Conflict = {
  constraint: Pallet_Line_Constraint;
  update_columns?: Array<Pallet_Line_Update_Column>;
  where?: InputMaybe<Pallet_Line_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_line". */
export type Pallet_Line_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Pallet_Location_Order_By>;
  location_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_line */
export type Pallet_Line_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_line" */
export enum Pallet_Line_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_line" */
export type Pallet_Line_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Line_Stddev_Fields = {
  __typename?: 'pallet_line_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Line_Stddev_Pop_Fields = {
  __typename?: 'pallet_line_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Line_Stddev_Samp_Fields = {
  __typename?: 'pallet_line_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_line" */
export type Pallet_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Line_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  location_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Line_Sum_Fields = {
  __typename?: 'pallet_line_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  location_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_line" */
export enum Pallet_Line_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Line_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Line_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Line_Set_Input>;
  where: Pallet_Line_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Line_Var_Pop_Fields = {
  __typename?: 'pallet_line_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Line_Var_Samp_Fields = {
  __typename?: 'pallet_line_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Line_Variance_Fields = {
  __typename?: 'pallet_line_variance_fields';
  id?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_location" */
export type Pallet_Location = {
  __typename?: 'pallet_location';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_location" */
export type Pallet_Location_Aggregate = {
  __typename?: 'pallet_location_aggregate';
  aggregate?: Maybe<Pallet_Location_Aggregate_Fields>;
  nodes: Array<Pallet_Location>;
};

/** aggregate fields of "pallet_location" */
export type Pallet_Location_Aggregate_Fields = {
  __typename?: 'pallet_location_aggregate_fields';
  avg?: Maybe<Pallet_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Location_Max_Fields>;
  min?: Maybe<Pallet_Location_Min_Fields>;
  stddev?: Maybe<Pallet_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Location_Sum_Fields>;
  var_pop?: Maybe<Pallet_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Location_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Location_Variance_Fields>;
};


/** aggregate fields of "pallet_location" */
export type Pallet_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Location_Avg_Fields = {
  __typename?: 'pallet_location_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_location". All fields are combined with a logical 'AND'. */
export type Pallet_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Location_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Location_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_location" */
export enum Pallet_Location_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletLocationPkey = 'pallet_location_pkey'
}

/** input type for incrementing numeric columns in table "pallet_location" */
export type Pallet_Location_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_location" */
export type Pallet_Location_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Location_Max_Fields = {
  __typename?: 'pallet_location_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Location_Min_Fields = {
  __typename?: 'pallet_location_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_location" */
export type Pallet_Location_Mutation_Response = {
  __typename?: 'pallet_location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Location>;
};

/** input type for inserting object relation for remote table "pallet_location" */
export type Pallet_Location_Obj_Rel_Insert_Input = {
  data: Pallet_Location_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Location_On_Conflict>;
};

/** on_conflict condition type for table "pallet_location" */
export type Pallet_Location_On_Conflict = {
  constraint: Pallet_Location_Constraint;
  update_columns?: Array<Pallet_Location_Update_Column>;
  where?: InputMaybe<Pallet_Location_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_location". */
export type Pallet_Location_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_location */
export type Pallet_Location_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_location" */
export enum Pallet_Location_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_location" */
export type Pallet_Location_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Location_Stddev_Fields = {
  __typename?: 'pallet_location_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Location_Stddev_Pop_Fields = {
  __typename?: 'pallet_location_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Location_Stddev_Samp_Fields = {
  __typename?: 'pallet_location_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_location" */
export type Pallet_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Location_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Location_Sum_Fields = {
  __typename?: 'pallet_location_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_location" */
export enum Pallet_Location_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Location_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Location_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Location_Set_Input>;
  where: Pallet_Location_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Location_Var_Pop_Fields = {
  __typename?: 'pallet_location_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Location_Var_Samp_Fields = {
  __typename?: 'pallet_location_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Location_Variance_Fields = {
  __typename?: 'pallet_location_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_packaging" */
export type Pallet_Packaging = {
  __typename?: 'pallet_packaging';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  /** An object relationship */
  type: Pallet_Packagingkind;
  type_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_packaging" */
export type Pallet_Packaging_Aggregate = {
  __typename?: 'pallet_packaging_aggregate';
  aggregate?: Maybe<Pallet_Packaging_Aggregate_Fields>;
  nodes: Array<Pallet_Packaging>;
};

/** aggregate fields of "pallet_packaging" */
export type Pallet_Packaging_Aggregate_Fields = {
  __typename?: 'pallet_packaging_aggregate_fields';
  avg?: Maybe<Pallet_Packaging_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packaging_Max_Fields>;
  min?: Maybe<Pallet_Packaging_Min_Fields>;
  stddev?: Maybe<Pallet_Packaging_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packaging_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packaging_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packaging_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packaging_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packaging_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packaging_Variance_Fields>;
};


/** aggregate fields of "pallet_packaging" */
export type Pallet_Packaging_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packaging_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Packaging_Avg_Fields = {
  __typename?: 'pallet_packaging_avg_fields';
  id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_packaging". All fields are combined with a logical 'AND'. */
export type Pallet_Packaging_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packaging_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packaging_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packaging_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
  type_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_packaging" */
export enum Pallet_Packaging_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletPackagingPkey = 'pallet_packaging_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packaging" */
export type Pallet_Packaging_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  type_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_packaging" */
export type Pallet_Packaging_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Pallet_Packagingkind_Obj_Rel_Insert_Input>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Packaging_Max_Fields = {
  __typename?: 'pallet_packaging_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Packaging_Min_Fields = {
  __typename?: 'pallet_packaging_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_packaging" */
export type Pallet_Packaging_Mutation_Response = {
  __typename?: 'pallet_packaging_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packaging>;
};

/** input type for inserting object relation for remote table "pallet_packaging" */
export type Pallet_Packaging_Obj_Rel_Insert_Input = {
  data: Pallet_Packaging_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packaging_On_Conflict>;
};

/** on_conflict condition type for table "pallet_packaging" */
export type Pallet_Packaging_On_Conflict = {
  constraint: Pallet_Packaging_Constraint;
  update_columns?: Array<Pallet_Packaging_Update_Column>;
  where?: InputMaybe<Pallet_Packaging_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packaging". */
export type Pallet_Packaging_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Pallet_Packagingkind_Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_packaging */
export type Pallet_Packaging_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packaging" */
export enum Pallet_Packaging_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_packaging" */
export type Pallet_Packaging_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Packaging_Stddev_Fields = {
  __typename?: 'pallet_packaging_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packaging_Stddev_Pop_Fields = {
  __typename?: 'pallet_packaging_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packaging_Stddev_Samp_Fields = {
  __typename?: 'pallet_packaging_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_packaging" */
export type Pallet_Packaging_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packaging_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packaging_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Packaging_Sum_Fields = {
  __typename?: 'pallet_packaging_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  type_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_packaging" */
export enum Pallet_Packaging_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Packaging_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packaging_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packaging_Set_Input>;
  where: Pallet_Packaging_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packaging_Var_Pop_Fields = {
  __typename?: 'pallet_packaging_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Packaging_Var_Samp_Fields = {
  __typename?: 'pallet_packaging_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Packaging_Variance_Fields = {
  __typename?: 'pallet_packaging_variance_fields';
  id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_packagingkind" */
export type Pallet_Packagingkind = {
  __typename?: 'pallet_packagingkind';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_packagingkind" */
export type Pallet_Packagingkind_Aggregate = {
  __typename?: 'pallet_packagingkind_aggregate';
  aggregate?: Maybe<Pallet_Packagingkind_Aggregate_Fields>;
  nodes: Array<Pallet_Packagingkind>;
};

/** aggregate fields of "pallet_packagingkind" */
export type Pallet_Packagingkind_Aggregate_Fields = {
  __typename?: 'pallet_packagingkind_aggregate_fields';
  avg?: Maybe<Pallet_Packagingkind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packagingkind_Max_Fields>;
  min?: Maybe<Pallet_Packagingkind_Min_Fields>;
  stddev?: Maybe<Pallet_Packagingkind_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packagingkind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packagingkind_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packagingkind_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packagingkind_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packagingkind_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packagingkind_Variance_Fields>;
};


/** aggregate fields of "pallet_packagingkind" */
export type Pallet_Packagingkind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packagingkind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Packagingkind_Avg_Fields = {
  __typename?: 'pallet_packagingkind_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_packagingkind". All fields are combined with a logical 'AND'. */
export type Pallet_Packagingkind_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packagingkind_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packagingkind_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_packagingkind" */
export enum Pallet_Packagingkind_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletPackagingtypePkey = 'pallet_packagingtype_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packagingkind" */
export type Pallet_Packagingkind_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_packagingkind" */
export type Pallet_Packagingkind_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Packagingkind_Max_Fields = {
  __typename?: 'pallet_packagingkind_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Packagingkind_Min_Fields = {
  __typename?: 'pallet_packagingkind_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_packagingkind" */
export type Pallet_Packagingkind_Mutation_Response = {
  __typename?: 'pallet_packagingkind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packagingkind>;
};

/** input type for inserting object relation for remote table "pallet_packagingkind" */
export type Pallet_Packagingkind_Obj_Rel_Insert_Input = {
  data: Pallet_Packagingkind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packagingkind_On_Conflict>;
};

/** on_conflict condition type for table "pallet_packagingkind" */
export type Pallet_Packagingkind_On_Conflict = {
  constraint: Pallet_Packagingkind_Constraint;
  update_columns?: Array<Pallet_Packagingkind_Update_Column>;
  where?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packagingkind". */
export type Pallet_Packagingkind_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_packagingkind */
export type Pallet_Packagingkind_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packagingkind" */
export enum Pallet_Packagingkind_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_packagingkind" */
export type Pallet_Packagingkind_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Packagingkind_Stddev_Fields = {
  __typename?: 'pallet_packagingkind_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packagingkind_Stddev_Pop_Fields = {
  __typename?: 'pallet_packagingkind_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packagingkind_Stddev_Samp_Fields = {
  __typename?: 'pallet_packagingkind_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_packagingkind" */
export type Pallet_Packagingkind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packagingkind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packagingkind_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Packagingkind_Sum_Fields = {
  __typename?: 'pallet_packagingkind_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_packagingkind" */
export enum Pallet_Packagingkind_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Packagingkind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packagingkind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packagingkind_Set_Input>;
  where: Pallet_Packagingkind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packagingkind_Var_Pop_Fields = {
  __typename?: 'pallet_packagingkind_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Packagingkind_Var_Samp_Fields = {
  __typename?: 'pallet_packagingkind_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Packagingkind_Variance_Fields = {
  __typename?: 'pallet_packagingkind_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_packing" */
export type Pallet_Packing = {
  __typename?: 'pallet_packing';
  action_in_case_deviation?: Maybe<Scalars['String']>;
  /** An array relationship */
  attachments: Array<Pallet_Packing_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Pallet_Packing_Attachments_Aggregate;
  bunches_per_pack?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  packaging: Pallet_Packaging;
  packaging_id: Scalars['bigint'];
  pm_clearance?: Maybe<Scalars['String']>;
  prev_customer_labels_clearance: Scalars['String'];
  /** An array relationship */
  primary_inspections: Array<Pallet_Inspection>;
  /** An aggregate relationship */
  primary_inspections_aggregate: Pallet_Inspection_Aggregate;
  /** An object relationship */
  printing_matter?: Maybe<Pallet_Printingmatter>;
  printing_matter_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  secondary_inspections: Array<Pallet_Inspection>;
  /** An aggregate relationship */
  secondary_inspections_aggregate: Pallet_Inspection_Aggregate;
  /** An object relationship */
  type: Pallet_Packingkind;
  type_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  weights: Array<Pallet_Packing_Weights>;
  /** An aggregate relationship */
  weights_aggregate: Pallet_Packing_Weights_Aggregate;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingPrimary_InspectionsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingPrimary_Inspections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingSecondary_InspectionsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingSecondary_Inspections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingWeightsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};


/** columns and relationships of "pallet_packing" */
export type Pallet_PackingWeights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};

/** aggregated selection of "pallet_packing" */
export type Pallet_Packing_Aggregate = {
  __typename?: 'pallet_packing_aggregate';
  aggregate?: Maybe<Pallet_Packing_Aggregate_Fields>;
  nodes: Array<Pallet_Packing>;
};

/** aggregate fields of "pallet_packing" */
export type Pallet_Packing_Aggregate_Fields = {
  __typename?: 'pallet_packing_aggregate_fields';
  avg?: Maybe<Pallet_Packing_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packing_Max_Fields>;
  min?: Maybe<Pallet_Packing_Min_Fields>;
  stddev?: Maybe<Pallet_Packing_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packing_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packing_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packing_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packing_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packing_Variance_Fields>;
};


/** aggregate fields of "pallet_packing" */
export type Pallet_Packing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "pallet_packing_attachments" */
export type Pallet_Packing_Attachments = {
  __typename?: 'pallet_packing_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Eagle_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  packing: Pallet_Packing;
  packing_id: Scalars['bigint'];
};

/** aggregated selection of "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Aggregate = {
  __typename?: 'pallet_packing_attachments_aggregate';
  aggregate?: Maybe<Pallet_Packing_Attachments_Aggregate_Fields>;
  nodes: Array<Pallet_Packing_Attachments>;
};

/** aggregate fields of "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Aggregate_Fields = {
  __typename?: 'pallet_packing_attachments_aggregate_fields';
  avg?: Maybe<Pallet_Packing_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packing_Attachments_Max_Fields>;
  min?: Maybe<Pallet_Packing_Attachments_Min_Fields>;
  stddev?: Maybe<Pallet_Packing_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packing_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packing_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packing_Attachments_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packing_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packing_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packing_Attachments_Variance_Fields>;
};


/** aggregate fields of "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packing_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Packing_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Packing_Attachments_Max_Order_By>;
  min?: InputMaybe<Pallet_Packing_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Packing_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Packing_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Packing_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Packing_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Packing_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Packing_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Packing_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Packing_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packing_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Pallet_Packing_Attachments_Avg_Fields = {
  __typename?: 'pallet_packing_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_packing_attachments". All fields are combined with a logical 'AND'. */
export type Pallet_Packing_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packing_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packing_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  packing?: InputMaybe<Pallet_Packing_Bool_Exp>;
  packing_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_packing_attachments" */
export enum Pallet_Packing_Attachments_Constraint {
  /** unique or primary key constraint on columns "packing_id", "media_id" */
  PalletPackingAttachmentsPackingIdMediaIdDc9ec739Uniq = 'pallet_packing_attachments_packing_id_media_id_dc9ec739_uniq',
  /** unique or primary key constraint on columns "id" */
  PalletPackingAttachmentsPkey = 'pallet_packing_attachments_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packing_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packing?: InputMaybe<Pallet_Packing_Obj_Rel_Insert_Input>;
  packing_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Pallet_Packing_Attachments_Max_Fields = {
  __typename?: 'pallet_packing_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  packing_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Packing_Attachments_Min_Fields = {
  __typename?: 'pallet_packing_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  packing_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Mutation_Response = {
  __typename?: 'pallet_packing_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packing_Attachments>;
};

/** on_conflict condition type for table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_On_Conflict = {
  constraint: Pallet_Packing_Attachments_Constraint;
  update_columns?: Array<Pallet_Packing_Attachments_Update_Column>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packing_attachments". */
export type Pallet_Packing_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing?: InputMaybe<Pallet_Packing_Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_packing_attachments */
export type Pallet_Packing_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packing_attachments" */
export enum Pallet_Packing_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PackingId = 'packing_id'
}

/** input type for updating data in table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packing_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Pallet_Packing_Attachments_Stddev_Fields = {
  __typename?: 'pallet_packing_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packing_Attachments_Stddev_Pop_Fields = {
  __typename?: 'pallet_packing_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packing_Attachments_Stddev_Samp_Fields = {
  __typename?: 'pallet_packing_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packing_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packing_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packing_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Pallet_Packing_Attachments_Sum_Fields = {
  __typename?: 'pallet_packing_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  packing_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_packing_attachments" */
export enum Pallet_Packing_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PackingId = 'packing_id'
}

export type Pallet_Packing_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packing_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packing_Attachments_Set_Input>;
  where: Pallet_Packing_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packing_Attachments_Var_Pop_Fields = {
  __typename?: 'pallet_packing_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Packing_Attachments_Var_Samp_Fields = {
  __typename?: 'pallet_packing_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Packing_Attachments_Variance_Fields = {
  __typename?: 'pallet_packing_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_packing_attachments" */
export type Pallet_Packing_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Pallet_Packing_Avg_Fields = {
  __typename?: 'pallet_packing_avg_fields';
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  printing_matter_id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_packing". All fields are combined with a logical 'AND'. */
export type Pallet_Packing_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packing_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packing_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packing_Bool_Exp>>;
  action_in_case_deviation?: InputMaybe<String_Comparison_Exp>;
  attachments?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
  bunches_per_pack?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  packaging?: InputMaybe<Pallet_Packaging_Bool_Exp>;
  packaging_id?: InputMaybe<Bigint_Comparison_Exp>;
  pm_clearance?: InputMaybe<String_Comparison_Exp>;
  prev_customer_labels_clearance?: InputMaybe<String_Comparison_Exp>;
  primary_inspections?: InputMaybe<Pallet_Inspection_Bool_Exp>;
  printing_matter?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
  printing_matter_id?: InputMaybe<Bigint_Comparison_Exp>;
  secondary_inspections?: InputMaybe<Pallet_Inspection_Bool_Exp>;
  type?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
  type_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weights?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};

/** unique or primary key constraints on table "pallet_packing" */
export enum Pallet_Packing_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletPackingPkey = 'pallet_packing_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packing" */
export type Pallet_Packing_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  printing_matter_id?: InputMaybe<Scalars['bigint']>;
  type_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_packing" */
export type Pallet_Packing_Insert_Input = {
  action_in_case_deviation?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Pallet_Packing_Attachments_Arr_Rel_Insert_Input>;
  bunches_per_pack?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Pallet_Packaging_Obj_Rel_Insert_Input>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  pm_clearance?: InputMaybe<Scalars['String']>;
  prev_customer_labels_clearance?: InputMaybe<Scalars['String']>;
  primary_inspections?: InputMaybe<Pallet_Inspection_Arr_Rel_Insert_Input>;
  printing_matter?: InputMaybe<Pallet_Printingmatter_Obj_Rel_Insert_Input>;
  printing_matter_id?: InputMaybe<Scalars['bigint']>;
  secondary_inspections?: InputMaybe<Pallet_Inspection_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Pallet_Packingkind_Obj_Rel_Insert_Input>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weights?: InputMaybe<Pallet_Packing_Weights_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pallet_Packing_Max_Fields = {
  __typename?: 'pallet_packing_max_fields';
  action_in_case_deviation?: Maybe<Scalars['String']>;
  bunches_per_pack?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  packaging_id?: Maybe<Scalars['bigint']>;
  pm_clearance?: Maybe<Scalars['String']>;
  prev_customer_labels_clearance?: Maybe<Scalars['String']>;
  printing_matter_id?: Maybe<Scalars['bigint']>;
  type_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Packing_Min_Fields = {
  __typename?: 'pallet_packing_min_fields';
  action_in_case_deviation?: Maybe<Scalars['String']>;
  bunches_per_pack?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  packaging_id?: Maybe<Scalars['bigint']>;
  pm_clearance?: Maybe<Scalars['String']>;
  prev_customer_labels_clearance?: Maybe<Scalars['String']>;
  printing_matter_id?: Maybe<Scalars['bigint']>;
  type_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_packing" */
export type Pallet_Packing_Mutation_Response = {
  __typename?: 'pallet_packing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packing>;
};

/** input type for inserting object relation for remote table "pallet_packing" */
export type Pallet_Packing_Obj_Rel_Insert_Input = {
  data: Pallet_Packing_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packing_On_Conflict>;
};

/** on_conflict condition type for table "pallet_packing" */
export type Pallet_Packing_On_Conflict = {
  constraint: Pallet_Packing_Constraint;
  update_columns?: Array<Pallet_Packing_Update_Column>;
  where?: InputMaybe<Pallet_Packing_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packing". */
export type Pallet_Packing_Order_By = {
  action_in_case_deviation?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Pallet_Packing_Attachments_Aggregate_Order_By>;
  bunches_per_pack?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Pallet_Packaging_Order_By>;
  packaging_id?: InputMaybe<Order_By>;
  pm_clearance?: InputMaybe<Order_By>;
  prev_customer_labels_clearance?: InputMaybe<Order_By>;
  primary_inspections_aggregate?: InputMaybe<Pallet_Inspection_Aggregate_Order_By>;
  printing_matter?: InputMaybe<Pallet_Printingmatter_Order_By>;
  printing_matter_id?: InputMaybe<Order_By>;
  secondary_inspections_aggregate?: InputMaybe<Pallet_Inspection_Aggregate_Order_By>;
  type?: InputMaybe<Pallet_Packingkind_Order_By>;
  type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weights_aggregate?: InputMaybe<Pallet_Packing_Weights_Aggregate_Order_By>;
};

/** primary key columns input for table: pallet_packing */
export type Pallet_Packing_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packing" */
export enum Pallet_Packing_Select_Column {
  /** column name */
  ActionInCaseDeviation = 'action_in_case_deviation',
  /** column name */
  BunchesPerPack = 'bunches_per_pack',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PackagingId = 'packaging_id',
  /** column name */
  PmClearance = 'pm_clearance',
  /** column name */
  PrevCustomerLabelsClearance = 'prev_customer_labels_clearance',
  /** column name */
  PrintingMatterId = 'printing_matter_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_packing" */
export type Pallet_Packing_Set_Input = {
  action_in_case_deviation?: InputMaybe<Scalars['String']>;
  bunches_per_pack?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  pm_clearance?: InputMaybe<Scalars['String']>;
  prev_customer_labels_clearance?: InputMaybe<Scalars['String']>;
  printing_matter_id?: InputMaybe<Scalars['bigint']>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Packing_Stddev_Fields = {
  __typename?: 'pallet_packing_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  printing_matter_id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packing_Stddev_Pop_Fields = {
  __typename?: 'pallet_packing_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  printing_matter_id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packing_Stddev_Samp_Fields = {
  __typename?: 'pallet_packing_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  printing_matter_id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_packing" */
export type Pallet_Packing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packing_Stream_Cursor_Value_Input = {
  action_in_case_deviation?: InputMaybe<Scalars['String']>;
  bunches_per_pack?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  packaging_id?: InputMaybe<Scalars['bigint']>;
  pm_clearance?: InputMaybe<Scalars['String']>;
  prev_customer_labels_clearance?: InputMaybe<Scalars['String']>;
  printing_matter_id?: InputMaybe<Scalars['bigint']>;
  type_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Packing_Sum_Fields = {
  __typename?: 'pallet_packing_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  packaging_id?: Maybe<Scalars['bigint']>;
  printing_matter_id?: Maybe<Scalars['bigint']>;
  type_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_packing" */
export enum Pallet_Packing_Update_Column {
  /** column name */
  ActionInCaseDeviation = 'action_in_case_deviation',
  /** column name */
  BunchesPerPack = 'bunches_per_pack',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PackagingId = 'packaging_id',
  /** column name */
  PmClearance = 'pm_clearance',
  /** column name */
  PrevCustomerLabelsClearance = 'prev_customer_labels_clearance',
  /** column name */
  PrintingMatterId = 'printing_matter_id',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Packing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packing_Set_Input>;
  where: Pallet_Packing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packing_Var_Pop_Fields = {
  __typename?: 'pallet_packing_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  printing_matter_id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Packing_Var_Samp_Fields = {
  __typename?: 'pallet_packing_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  printing_matter_id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Packing_Variance_Fields = {
  __typename?: 'pallet_packing_variance_fields';
  id?: Maybe<Scalars['Float']>;
  packaging_id?: Maybe<Scalars['Float']>;
  printing_matter_id?: Maybe<Scalars['Float']>;
  type_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_packing_weights" */
export type Pallet_Packing_Weights = {
  __typename?: 'pallet_packing_weights';
  id: Scalars['bigint'];
  /** An object relationship */
  packing: Pallet_Packing;
  packing_id: Scalars['bigint'];
  packingweight_id: Scalars['bigint'];
  /** An object relationship */
  weight: Pallet_Packingweight;
};

/** aggregated selection of "pallet_packing_weights" */
export type Pallet_Packing_Weights_Aggregate = {
  __typename?: 'pallet_packing_weights_aggregate';
  aggregate?: Maybe<Pallet_Packing_Weights_Aggregate_Fields>;
  nodes: Array<Pallet_Packing_Weights>;
};

/** aggregate fields of "pallet_packing_weights" */
export type Pallet_Packing_Weights_Aggregate_Fields = {
  __typename?: 'pallet_packing_weights_aggregate_fields';
  avg?: Maybe<Pallet_Packing_Weights_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packing_Weights_Max_Fields>;
  min?: Maybe<Pallet_Packing_Weights_Min_Fields>;
  stddev?: Maybe<Pallet_Packing_Weights_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packing_Weights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packing_Weights_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packing_Weights_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packing_Weights_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packing_Weights_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packing_Weights_Variance_Fields>;
};


/** aggregate fields of "pallet_packing_weights" */
export type Pallet_Packing_Weights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Packing_Weights_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Packing_Weights_Max_Order_By>;
  min?: InputMaybe<Pallet_Packing_Weights_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Packing_Weights_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Packing_Weights_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Packing_Weights_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Packing_Weights_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Packing_Weights_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Packing_Weights_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Packing_Weights_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Packing_Weights_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packing_Weights_On_Conflict>;
};

/** aggregate avg on columns */
export type Pallet_Packing_Weights_Avg_Fields = {
  __typename?: 'pallet_packing_weights_avg_fields';
  id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_packing_weights". All fields are combined with a logical 'AND'. */
export type Pallet_Packing_Weights_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packing_Weights_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packing_Weights_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  packing?: InputMaybe<Pallet_Packing_Bool_Exp>;
  packing_id?: InputMaybe<Bigint_Comparison_Exp>;
  packingweight_id?: InputMaybe<Bigint_Comparison_Exp>;
  weight?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
};

/** unique or primary key constraints on table "pallet_packing_weights" */
export enum Pallet_Packing_Weights_Constraint {
  /** unique or primary key constraint on columns "packingweight_id", "packing_id" */
  PalletPackingWeightsPackingIdPackingweightDd463a8cUniq = 'pallet_packing_weights_packing_id_packingweight_dd463a8c_uniq',
  /** unique or primary key constraint on columns "id" */
  PalletPackingWeightsPkey = 'pallet_packing_weights_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packing_id?: InputMaybe<Scalars['bigint']>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packing?: InputMaybe<Pallet_Packing_Obj_Rel_Insert_Input>;
  packing_id?: InputMaybe<Scalars['bigint']>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
  weight?: InputMaybe<Pallet_Packingweight_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pallet_Packing_Weights_Max_Fields = {
  __typename?: 'pallet_packing_weights_max_fields';
  id?: Maybe<Scalars['bigint']>;
  packing_id?: Maybe<Scalars['bigint']>;
  packingweight_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Packing_Weights_Min_Fields = {
  __typename?: 'pallet_packing_weights_min_fields';
  id?: Maybe<Scalars['bigint']>;
  packing_id?: Maybe<Scalars['bigint']>;
  packingweight_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Mutation_Response = {
  __typename?: 'pallet_packing_weights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packing_Weights>;
};

/** on_conflict condition type for table "pallet_packing_weights" */
export type Pallet_Packing_Weights_On_Conflict = {
  constraint: Pallet_Packing_Weights_Constraint;
  update_columns?: Array<Pallet_Packing_Weights_Update_Column>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packing_weights". */
export type Pallet_Packing_Weights_Order_By = {
  id?: InputMaybe<Order_By>;
  packing?: InputMaybe<Pallet_Packing_Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
  weight?: InputMaybe<Pallet_Packingweight_Order_By>;
};

/** primary key columns input for table: pallet_packing_weights */
export type Pallet_Packing_Weights_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packing_weights" */
export enum Pallet_Packing_Weights_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PackingId = 'packing_id',
  /** column name */
  PackingweightId = 'packingweight_id'
}

/** input type for updating data in table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packing_id?: InputMaybe<Scalars['bigint']>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Pallet_Packing_Weights_Stddev_Fields = {
  __typename?: 'pallet_packing_weights_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packing_Weights_Stddev_Pop_Fields = {
  __typename?: 'pallet_packing_weights_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packing_Weights_Stddev_Samp_Fields = {
  __typename?: 'pallet_packing_weights_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packing_Weights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packing_Weights_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  packing_id?: InputMaybe<Scalars['bigint']>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Pallet_Packing_Weights_Sum_Fields = {
  __typename?: 'pallet_packing_weights_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  packing_id?: Maybe<Scalars['bigint']>;
  packingweight_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_packing_weights" */
export enum Pallet_Packing_Weights_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PackingId = 'packing_id',
  /** column name */
  PackingweightId = 'packingweight_id'
}

export type Pallet_Packing_Weights_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packing_Weights_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packing_Weights_Set_Input>;
  where: Pallet_Packing_Weights_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packing_Weights_Var_Pop_Fields = {
  __typename?: 'pallet_packing_weights_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Packing_Weights_Var_Samp_Fields = {
  __typename?: 'pallet_packing_weights_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Packing_Weights_Variance_Fields = {
  __typename?: 'pallet_packing_weights_variance_fields';
  id?: Maybe<Scalars['Float']>;
  packing_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_packing_weights" */
export type Pallet_Packing_Weights_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  packing_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "pallet_packingkind" */
export type Pallet_Packingkind = {
  __typename?: 'pallet_packingkind';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_packingkind" */
export type Pallet_Packingkind_Aggregate = {
  __typename?: 'pallet_packingkind_aggregate';
  aggregate?: Maybe<Pallet_Packingkind_Aggregate_Fields>;
  nodes: Array<Pallet_Packingkind>;
};

/** aggregate fields of "pallet_packingkind" */
export type Pallet_Packingkind_Aggregate_Fields = {
  __typename?: 'pallet_packingkind_aggregate_fields';
  avg?: Maybe<Pallet_Packingkind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packingkind_Max_Fields>;
  min?: Maybe<Pallet_Packingkind_Min_Fields>;
  stddev?: Maybe<Pallet_Packingkind_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packingkind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packingkind_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packingkind_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packingkind_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packingkind_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packingkind_Variance_Fields>;
};


/** aggregate fields of "pallet_packingkind" */
export type Pallet_Packingkind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packingkind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Packingkind_Avg_Fields = {
  __typename?: 'pallet_packingkind_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_packingkind". All fields are combined with a logical 'AND'. */
export type Pallet_Packingkind_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packingkind_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packingkind_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_packingkind" */
export enum Pallet_Packingkind_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletPackingkindPkey = 'pallet_packingkind_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packingkind" */
export type Pallet_Packingkind_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_packingkind" */
export type Pallet_Packingkind_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Packingkind_Max_Fields = {
  __typename?: 'pallet_packingkind_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Packingkind_Min_Fields = {
  __typename?: 'pallet_packingkind_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_packingkind" */
export type Pallet_Packingkind_Mutation_Response = {
  __typename?: 'pallet_packingkind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packingkind>;
};

/** input type for inserting object relation for remote table "pallet_packingkind" */
export type Pallet_Packingkind_Obj_Rel_Insert_Input = {
  data: Pallet_Packingkind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packingkind_On_Conflict>;
};

/** on_conflict condition type for table "pallet_packingkind" */
export type Pallet_Packingkind_On_Conflict = {
  constraint: Pallet_Packingkind_Constraint;
  update_columns?: Array<Pallet_Packingkind_Update_Column>;
  where?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packingkind". */
export type Pallet_Packingkind_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_packingkind */
export type Pallet_Packingkind_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packingkind" */
export enum Pallet_Packingkind_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_packingkind" */
export type Pallet_Packingkind_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Packingkind_Stddev_Fields = {
  __typename?: 'pallet_packingkind_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packingkind_Stddev_Pop_Fields = {
  __typename?: 'pallet_packingkind_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packingkind_Stddev_Samp_Fields = {
  __typename?: 'pallet_packingkind_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_packingkind" */
export type Pallet_Packingkind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packingkind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packingkind_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Packingkind_Sum_Fields = {
  __typename?: 'pallet_packingkind_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_packingkind" */
export enum Pallet_Packingkind_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Packingkind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packingkind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packingkind_Set_Input>;
  where: Pallet_Packingkind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packingkind_Var_Pop_Fields = {
  __typename?: 'pallet_packingkind_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Packingkind_Var_Samp_Fields = {
  __typename?: 'pallet_packingkind_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Packingkind_Variance_Fields = {
  __typename?: 'pallet_packingkind_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_packingweight" */
export type Pallet_Packingweight = {
  __typename?: 'pallet_packingweight';
  /** An array relationship */
  attachments: Array<Pallet_Packingweight_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Pallet_Packingweight_Attachments_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An array relationship */
  packing_weight: Array<Pallet_Packing_Weights>;
  /** An aggregate relationship */
  packing_weight_aggregate: Pallet_Packing_Weights_Aggregate;
  sequence_no: Scalars['Int'];
  /** An object relationship */
  unit: Unit;
  unit_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  value: Scalars['numeric'];
};


/** columns and relationships of "pallet_packingweight" */
export type Pallet_PackingweightAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};


/** columns and relationships of "pallet_packingweight" */
export type Pallet_PackingweightAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};


/** columns and relationships of "pallet_packingweight" */
export type Pallet_PackingweightPacking_WeightArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};


/** columns and relationships of "pallet_packingweight" */
export type Pallet_PackingweightPacking_Weight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};

/** aggregated selection of "pallet_packingweight" */
export type Pallet_Packingweight_Aggregate = {
  __typename?: 'pallet_packingweight_aggregate';
  aggregate?: Maybe<Pallet_Packingweight_Aggregate_Fields>;
  nodes: Array<Pallet_Packingweight>;
};

/** aggregate fields of "pallet_packingweight" */
export type Pallet_Packingweight_Aggregate_Fields = {
  __typename?: 'pallet_packingweight_aggregate_fields';
  avg?: Maybe<Pallet_Packingweight_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packingweight_Max_Fields>;
  min?: Maybe<Pallet_Packingweight_Min_Fields>;
  stddev?: Maybe<Pallet_Packingweight_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packingweight_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packingweight_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packingweight_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packingweight_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packingweight_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packingweight_Variance_Fields>;
};


/** aggregate fields of "pallet_packingweight" */
export type Pallet_Packingweight_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packingweight_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments = {
  __typename?: 'pallet_packingweight_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Eagle_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  packingweight: Pallet_Packingweight;
  packingweight_id: Scalars['bigint'];
};

/** aggregated selection of "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Aggregate = {
  __typename?: 'pallet_packingweight_attachments_aggregate';
  aggregate?: Maybe<Pallet_Packingweight_Attachments_Aggregate_Fields>;
  nodes: Array<Pallet_Packingweight_Attachments>;
};

/** aggregate fields of "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Aggregate_Fields = {
  __typename?: 'pallet_packingweight_attachments_aggregate_fields';
  avg?: Maybe<Pallet_Packingweight_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Packingweight_Attachments_Max_Fields>;
  min?: Maybe<Pallet_Packingweight_Attachments_Min_Fields>;
  stddev?: Maybe<Pallet_Packingweight_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Packingweight_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Packingweight_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Packingweight_Attachments_Sum_Fields>;
  var_pop?: Maybe<Pallet_Packingweight_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Packingweight_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Packingweight_Attachments_Variance_Fields>;
};


/** aggregate fields of "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Packingweight_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Pallet_Packingweight_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pallet_Packingweight_Attachments_Max_Order_By>;
  min?: InputMaybe<Pallet_Packingweight_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Pallet_Packingweight_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pallet_Packingweight_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pallet_Packingweight_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pallet_Packingweight_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Pallet_Packingweight_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pallet_Packingweight_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Pallet_Packingweight_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Pallet_Packingweight_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packingweight_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Pallet_Packingweight_Attachments_Avg_Fields = {
  __typename?: 'pallet_packingweight_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pallet_packingweight_attachments". All fields are combined with a logical 'AND'. */
export type Pallet_Packingweight_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packingweight_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packingweight_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  packingweight?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
  packingweight_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_packingweight_attachments" */
export enum Pallet_Packingweight_Attachments_Constraint {
  /** unique or primary key constraint on columns "packingweight_id", "media_id" */
  PalletPackingweightAttPackingweightIdMediaI_32827c71Uniq = 'pallet_packingweight_att_packingweight_id_media_i_32827c71_uniq',
  /** unique or primary key constraint on columns "id" */
  PalletPackingweightAttachmentsPkey = 'pallet_packingweight_attachments_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packingweight?: InputMaybe<Pallet_Packingweight_Obj_Rel_Insert_Input>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Pallet_Packingweight_Attachments_Max_Fields = {
  __typename?: 'pallet_packingweight_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  packingweight_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pallet_Packingweight_Attachments_Min_Fields = {
  __typename?: 'pallet_packingweight_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  packingweight_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Mutation_Response = {
  __typename?: 'pallet_packingweight_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packingweight_Attachments>;
};

/** on_conflict condition type for table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_On_Conflict = {
  constraint: Pallet_Packingweight_Attachments_Constraint;
  update_columns?: Array<Pallet_Packingweight_Attachments_Update_Column>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packingweight_attachments". */
export type Pallet_Packingweight_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight?: InputMaybe<Pallet_Packingweight_Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_packingweight_attachments */
export type Pallet_Packingweight_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packingweight_attachments" */
export enum Pallet_Packingweight_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PackingweightId = 'packingweight_id'
}

/** input type for updating data in table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Pallet_Packingweight_Attachments_Stddev_Fields = {
  __typename?: 'pallet_packingweight_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packingweight_Attachments_Stddev_Pop_Fields = {
  __typename?: 'pallet_packingweight_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packingweight_Attachments_Stddev_Samp_Fields = {
  __typename?: 'pallet_packingweight_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packingweight_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packingweight_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  packingweight_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Pallet_Packingweight_Attachments_Sum_Fields = {
  __typename?: 'pallet_packingweight_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  packingweight_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** update columns of table "pallet_packingweight_attachments" */
export enum Pallet_Packingweight_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PackingweightId = 'packingweight_id'
}

export type Pallet_Packingweight_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packingweight_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packingweight_Attachments_Set_Input>;
  where: Pallet_Packingweight_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packingweight_Attachments_Var_Pop_Fields = {
  __typename?: 'pallet_packingweight_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pallet_Packingweight_Attachments_Var_Samp_Fields = {
  __typename?: 'pallet_packingweight_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pallet_Packingweight_Attachments_Variance_Fields = {
  __typename?: 'pallet_packingweight_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  packingweight_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pallet_packingweight_attachments" */
export type Pallet_Packingweight_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  packingweight_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Pallet_Packingweight_Avg_Fields = {
  __typename?: 'pallet_packingweight_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_packingweight". All fields are combined with a logical 'AND'. */
export type Pallet_Packingweight_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Packingweight_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Packingweight_Bool_Exp>>;
  attachments?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  packing_weight?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
  sequence_no?: InputMaybe<Int_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_packingweight" */
export enum Pallet_Packingweight_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletPackingweightPkey = 'pallet_packingweight_pkey'
}

/** input type for incrementing numeric columns in table "pallet_packingweight" */
export type Pallet_Packingweight_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "pallet_packingweight" */
export type Pallet_Packingweight_Insert_Input = {
  attachments?: InputMaybe<Pallet_Packingweight_Attachments_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  packing_weight?: InputMaybe<Pallet_Packing_Weights_Arr_Rel_Insert_Input>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Pallet_Packingweight_Max_Fields = {
  __typename?: 'pallet_packingweight_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  sequence_no?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Pallet_Packingweight_Min_Fields = {
  __typename?: 'pallet_packingweight_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  sequence_no?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "pallet_packingweight" */
export type Pallet_Packingweight_Mutation_Response = {
  __typename?: 'pallet_packingweight_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Packingweight>;
};

/** input type for inserting object relation for remote table "pallet_packingweight" */
export type Pallet_Packingweight_Obj_Rel_Insert_Input = {
  data: Pallet_Packingweight_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Packingweight_On_Conflict>;
};

/** on_conflict condition type for table "pallet_packingweight" */
export type Pallet_Packingweight_On_Conflict = {
  constraint: Pallet_Packingweight_Constraint;
  update_columns?: Array<Pallet_Packingweight_Update_Column>;
  where?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_packingweight". */
export type Pallet_Packingweight_Order_By = {
  attachments_aggregate?: InputMaybe<Pallet_Packingweight_Attachments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packing_weight_aggregate?: InputMaybe<Pallet_Packing_Weights_Aggregate_Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_packingweight */
export type Pallet_Packingweight_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_packingweight" */
export enum Pallet_Packingweight_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "pallet_packingweight" */
export type Pallet_Packingweight_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Pallet_Packingweight_Stddev_Fields = {
  __typename?: 'pallet_packingweight_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Packingweight_Stddev_Pop_Fields = {
  __typename?: 'pallet_packingweight_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Packingweight_Stddev_Samp_Fields = {
  __typename?: 'pallet_packingweight_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_packingweight" */
export type Pallet_Packingweight_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Packingweight_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Packingweight_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Pallet_Packingweight_Sum_Fields = {
  __typename?: 'pallet_packingweight_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  sequence_no?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** update columns of table "pallet_packingweight" */
export enum Pallet_Packingweight_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Pallet_Packingweight_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Packingweight_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Packingweight_Set_Input>;
  where: Pallet_Packingweight_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Packingweight_Var_Pop_Fields = {
  __typename?: 'pallet_packingweight_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Packingweight_Var_Samp_Fields = {
  __typename?: 'pallet_packingweight_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Packingweight_Variance_Fields = {
  __typename?: 'pallet_packingweight_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_printingmatter" */
export type Pallet_Printingmatter = {
  __typename?: 'pallet_printingmatter';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_printingmatter" */
export type Pallet_Printingmatter_Aggregate = {
  __typename?: 'pallet_printingmatter_aggregate';
  aggregate?: Maybe<Pallet_Printingmatter_Aggregate_Fields>;
  nodes: Array<Pallet_Printingmatter>;
};

/** aggregate fields of "pallet_printingmatter" */
export type Pallet_Printingmatter_Aggregate_Fields = {
  __typename?: 'pallet_printingmatter_aggregate_fields';
  avg?: Maybe<Pallet_Printingmatter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Printingmatter_Max_Fields>;
  min?: Maybe<Pallet_Printingmatter_Min_Fields>;
  stddev?: Maybe<Pallet_Printingmatter_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Printingmatter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Printingmatter_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Printingmatter_Sum_Fields>;
  var_pop?: Maybe<Pallet_Printingmatter_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Printingmatter_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Printingmatter_Variance_Fields>;
};


/** aggregate fields of "pallet_printingmatter" */
export type Pallet_Printingmatter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Printingmatter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Printingmatter_Avg_Fields = {
  __typename?: 'pallet_printingmatter_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_printingmatter". All fields are combined with a logical 'AND'. */
export type Pallet_Printingmatter_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Printingmatter_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Printingmatter_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_printingmatter" */
export enum Pallet_Printingmatter_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletPrintingmatterPkey = 'pallet_printingmatter_pkey'
}

/** input type for incrementing numeric columns in table "pallet_printingmatter" */
export type Pallet_Printingmatter_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_printingmatter" */
export type Pallet_Printingmatter_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Printingmatter_Max_Fields = {
  __typename?: 'pallet_printingmatter_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Printingmatter_Min_Fields = {
  __typename?: 'pallet_printingmatter_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_printingmatter" */
export type Pallet_Printingmatter_Mutation_Response = {
  __typename?: 'pallet_printingmatter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Printingmatter>;
};

/** input type for inserting object relation for remote table "pallet_printingmatter" */
export type Pallet_Printingmatter_Obj_Rel_Insert_Input = {
  data: Pallet_Printingmatter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Printingmatter_On_Conflict>;
};

/** on_conflict condition type for table "pallet_printingmatter" */
export type Pallet_Printingmatter_On_Conflict = {
  constraint: Pallet_Printingmatter_Constraint;
  update_columns?: Array<Pallet_Printingmatter_Update_Column>;
  where?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_printingmatter". */
export type Pallet_Printingmatter_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_printingmatter */
export type Pallet_Printingmatter_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_printingmatter" */
export enum Pallet_Printingmatter_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_printingmatter" */
export type Pallet_Printingmatter_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Printingmatter_Stddev_Fields = {
  __typename?: 'pallet_printingmatter_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Printingmatter_Stddev_Pop_Fields = {
  __typename?: 'pallet_printingmatter_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Printingmatter_Stddev_Samp_Fields = {
  __typename?: 'pallet_printingmatter_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_printingmatter" */
export type Pallet_Printingmatter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Printingmatter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Printingmatter_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Printingmatter_Sum_Fields = {
  __typename?: 'pallet_printingmatter_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_printingmatter" */
export enum Pallet_Printingmatter_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Printingmatter_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Printingmatter_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Printingmatter_Set_Input>;
  where: Pallet_Printingmatter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Printingmatter_Var_Pop_Fields = {
  __typename?: 'pallet_printingmatter_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Printingmatter_Var_Samp_Fields = {
  __typename?: 'pallet_printingmatter_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Printingmatter_Variance_Fields = {
  __typename?: 'pallet_printingmatter_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_punnetcondition" */
export type Pallet_Punnetcondition = {
  __typename?: 'pallet_punnetcondition';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Aggregate = {
  __typename?: 'pallet_punnetcondition_aggregate';
  aggregate?: Maybe<Pallet_Punnetcondition_Aggregate_Fields>;
  nodes: Array<Pallet_Punnetcondition>;
};

/** aggregate fields of "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Aggregate_Fields = {
  __typename?: 'pallet_punnetcondition_aggregate_fields';
  avg?: Maybe<Pallet_Punnetcondition_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Punnetcondition_Max_Fields>;
  min?: Maybe<Pallet_Punnetcondition_Min_Fields>;
  stddev?: Maybe<Pallet_Punnetcondition_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Punnetcondition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Punnetcondition_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Punnetcondition_Sum_Fields>;
  var_pop?: Maybe<Pallet_Punnetcondition_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Punnetcondition_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Punnetcondition_Variance_Fields>;
};


/** aggregate fields of "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Punnetcondition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Punnetcondition_Avg_Fields = {
  __typename?: 'pallet_punnetcondition_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_punnetcondition". All fields are combined with a logical 'AND'. */
export type Pallet_Punnetcondition_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Punnetcondition_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Punnetcondition_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_punnetcondition" */
export enum Pallet_Punnetcondition_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletPunnetconditionPkey = 'pallet_punnetcondition_pkey'
}

/** input type for incrementing numeric columns in table "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Punnetcondition_Max_Fields = {
  __typename?: 'pallet_punnetcondition_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Punnetcondition_Min_Fields = {
  __typename?: 'pallet_punnetcondition_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Mutation_Response = {
  __typename?: 'pallet_punnetcondition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Punnetcondition>;
};

/** input type for inserting object relation for remote table "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Obj_Rel_Insert_Input = {
  data: Pallet_Punnetcondition_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Punnetcondition_On_Conflict>;
};

/** on_conflict condition type for table "pallet_punnetcondition" */
export type Pallet_Punnetcondition_On_Conflict = {
  constraint: Pallet_Punnetcondition_Constraint;
  update_columns?: Array<Pallet_Punnetcondition_Update_Column>;
  where?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_punnetcondition". */
export type Pallet_Punnetcondition_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_punnetcondition */
export type Pallet_Punnetcondition_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_punnetcondition" */
export enum Pallet_Punnetcondition_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Punnetcondition_Stddev_Fields = {
  __typename?: 'pallet_punnetcondition_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Punnetcondition_Stddev_Pop_Fields = {
  __typename?: 'pallet_punnetcondition_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Punnetcondition_Stddev_Samp_Fields = {
  __typename?: 'pallet_punnetcondition_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_punnetcondition" */
export type Pallet_Punnetcondition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Punnetcondition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Punnetcondition_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Punnetcondition_Sum_Fields = {
  __typename?: 'pallet_punnetcondition_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_punnetcondition" */
export enum Pallet_Punnetcondition_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Punnetcondition_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Punnetcondition_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Punnetcondition_Set_Input>;
  where: Pallet_Punnetcondition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Punnetcondition_Var_Pop_Fields = {
  __typename?: 'pallet_punnetcondition_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Punnetcondition_Var_Samp_Fields = {
  __typename?: 'pallet_punnetcondition_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Punnetcondition_Variance_Fields = {
  __typename?: 'pallet_punnetcondition_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_samplinglocation" */
export type Pallet_Samplinglocation = {
  __typename?: 'pallet_samplinglocation';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Aggregate = {
  __typename?: 'pallet_samplinglocation_aggregate';
  aggregate?: Maybe<Pallet_Samplinglocation_Aggregate_Fields>;
  nodes: Array<Pallet_Samplinglocation>;
};

/** aggregate fields of "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Aggregate_Fields = {
  __typename?: 'pallet_samplinglocation_aggregate_fields';
  avg?: Maybe<Pallet_Samplinglocation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Samplinglocation_Max_Fields>;
  min?: Maybe<Pallet_Samplinglocation_Min_Fields>;
  stddev?: Maybe<Pallet_Samplinglocation_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Samplinglocation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Samplinglocation_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Samplinglocation_Sum_Fields>;
  var_pop?: Maybe<Pallet_Samplinglocation_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Samplinglocation_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Samplinglocation_Variance_Fields>;
};


/** aggregate fields of "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Samplinglocation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Samplinglocation_Avg_Fields = {
  __typename?: 'pallet_samplinglocation_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_samplinglocation". All fields are combined with a logical 'AND'. */
export type Pallet_Samplinglocation_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Samplinglocation_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Samplinglocation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_samplinglocation" */
export enum Pallet_Samplinglocation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletSamplinglocationPkey = 'pallet_samplinglocation_pkey'
}

/** input type for incrementing numeric columns in table "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Samplinglocation_Max_Fields = {
  __typename?: 'pallet_samplinglocation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Samplinglocation_Min_Fields = {
  __typename?: 'pallet_samplinglocation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Mutation_Response = {
  __typename?: 'pallet_samplinglocation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Samplinglocation>;
};

/** input type for inserting object relation for remote table "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Obj_Rel_Insert_Input = {
  data: Pallet_Samplinglocation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Samplinglocation_On_Conflict>;
};

/** on_conflict condition type for table "pallet_samplinglocation" */
export type Pallet_Samplinglocation_On_Conflict = {
  constraint: Pallet_Samplinglocation_Constraint;
  update_columns?: Array<Pallet_Samplinglocation_Update_Column>;
  where?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_samplinglocation". */
export type Pallet_Samplinglocation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_samplinglocation */
export type Pallet_Samplinglocation_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_samplinglocation" */
export enum Pallet_Samplinglocation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Samplinglocation_Stddev_Fields = {
  __typename?: 'pallet_samplinglocation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Samplinglocation_Stddev_Pop_Fields = {
  __typename?: 'pallet_samplinglocation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Samplinglocation_Stddev_Samp_Fields = {
  __typename?: 'pallet_samplinglocation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_samplinglocation" */
export type Pallet_Samplinglocation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Samplinglocation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Samplinglocation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Samplinglocation_Sum_Fields = {
  __typename?: 'pallet_samplinglocation_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_samplinglocation" */
export enum Pallet_Samplinglocation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Samplinglocation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Samplinglocation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Samplinglocation_Set_Input>;
  where: Pallet_Samplinglocation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Samplinglocation_Var_Pop_Fields = {
  __typename?: 'pallet_samplinglocation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Samplinglocation_Var_Samp_Fields = {
  __typename?: 'pallet_samplinglocation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Samplinglocation_Variance_Fields = {
  __typename?: 'pallet_samplinglocation_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_sku" */
export type Pallet_Sku = {
  __typename?: 'pallet_sku';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  /** An object relationship */
  type?: Maybe<Pallet_Skutype>;
  type_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  unit: Unit;
  unit_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  weight: Scalars['numeric'];
};

/** aggregated selection of "pallet_sku" */
export type Pallet_Sku_Aggregate = {
  __typename?: 'pallet_sku_aggregate';
  aggregate?: Maybe<Pallet_Sku_Aggregate_Fields>;
  nodes: Array<Pallet_Sku>;
};

/** aggregate fields of "pallet_sku" */
export type Pallet_Sku_Aggregate_Fields = {
  __typename?: 'pallet_sku_aggregate_fields';
  avg?: Maybe<Pallet_Sku_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Sku_Max_Fields>;
  min?: Maybe<Pallet_Sku_Min_Fields>;
  stddev?: Maybe<Pallet_Sku_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Sku_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Sku_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Sku_Sum_Fields>;
  var_pop?: Maybe<Pallet_Sku_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Sku_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Sku_Variance_Fields>;
};


/** aggregate fields of "pallet_sku" */
export type Pallet_Sku_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Sku_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Sku_Avg_Fields = {
  __typename?: 'pallet_sku_avg_fields';
  id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_sku". All fields are combined with a logical 'AND'. */
export type Pallet_Sku_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Sku_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Sku_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Sku_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Pallet_Skutype_Bool_Exp>;
  type_id?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_sku" */
export enum Pallet_Sku_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletSkuPkey = 'pallet_sku_pkey'
}

/** input type for incrementing numeric columns in table "pallet_sku" */
export type Pallet_Sku_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "pallet_sku" */
export type Pallet_Sku_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Pallet_Skutype_Obj_Rel_Insert_Input>;
  type_id?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Pallet_Sku_Max_Fields = {
  __typename?: 'pallet_sku_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Pallet_Sku_Min_Fields = {
  __typename?: 'pallet_sku_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "pallet_sku" */
export type Pallet_Sku_Mutation_Response = {
  __typename?: 'pallet_sku_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Sku>;
};

/** input type for inserting object relation for remote table "pallet_sku" */
export type Pallet_Sku_Obj_Rel_Insert_Input = {
  data: Pallet_Sku_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Sku_On_Conflict>;
};

/** on_conflict condition type for table "pallet_sku" */
export type Pallet_Sku_On_Conflict = {
  constraint: Pallet_Sku_Constraint;
  update_columns?: Array<Pallet_Sku_Update_Column>;
  where?: InputMaybe<Pallet_Sku_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_sku". */
export type Pallet_Sku_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Pallet_Skutype_Order_By>;
  type_id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_sku */
export type Pallet_Sku_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_sku" */
export enum Pallet_Sku_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "pallet_sku" */
export type Pallet_Sku_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Pallet_Sku_Stddev_Fields = {
  __typename?: 'pallet_sku_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Sku_Stddev_Pop_Fields = {
  __typename?: 'pallet_sku_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Sku_Stddev_Samp_Fields = {
  __typename?: 'pallet_sku_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_sku" */
export type Pallet_Sku_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Sku_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Sku_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  type_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Pallet_Sku_Sum_Fields = {
  __typename?: 'pallet_sku_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['bigint']>;
  weight?: Maybe<Scalars['numeric']>;
};

/** update columns of table "pallet_sku" */
export enum Pallet_Sku_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TypeId = 'type_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Weight = 'weight'
}

export type Pallet_Sku_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Sku_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Sku_Set_Input>;
  where: Pallet_Sku_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Sku_Var_Pop_Fields = {
  __typename?: 'pallet_sku_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Sku_Var_Samp_Fields = {
  __typename?: 'pallet_sku_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Sku_Variance_Fields = {
  __typename?: 'pallet_sku_variance_fields';
  id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pallet_skutype" */
export type Pallet_Skutype = {
  __typename?: 'pallet_skutype';
  created_at: Scalars['timestamptz'];
  display_name?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_skutype" */
export type Pallet_Skutype_Aggregate = {
  __typename?: 'pallet_skutype_aggregate';
  aggregate?: Maybe<Pallet_Skutype_Aggregate_Fields>;
  nodes: Array<Pallet_Skutype>;
};

/** aggregate fields of "pallet_skutype" */
export type Pallet_Skutype_Aggregate_Fields = {
  __typename?: 'pallet_skutype_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Pallet_Skutype_Max_Fields>;
  min?: Maybe<Pallet_Skutype_Min_Fields>;
};


/** aggregate fields of "pallet_skutype" */
export type Pallet_Skutype_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Skutype_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "pallet_skutype". All fields are combined with a logical 'AND'. */
export type Pallet_Skutype_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Skutype_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Skutype_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Skutype_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_skutype" */
export enum Pallet_Skutype_Constraint {
  /** unique or primary key constraint on columns "name" */
  PalletSkutypePkey = 'pallet_skutype_pkey'
}

/** input type for inserting data into table "pallet_skutype" */
export type Pallet_Skutype_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Skutype_Max_Fields = {
  __typename?: 'pallet_skutype_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Skutype_Min_Fields = {
  __typename?: 'pallet_skutype_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_skutype" */
export type Pallet_Skutype_Mutation_Response = {
  __typename?: 'pallet_skutype_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Skutype>;
};

/** input type for inserting object relation for remote table "pallet_skutype" */
export type Pallet_Skutype_Obj_Rel_Insert_Input = {
  data: Pallet_Skutype_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Skutype_On_Conflict>;
};

/** on_conflict condition type for table "pallet_skutype" */
export type Pallet_Skutype_On_Conflict = {
  constraint: Pallet_Skutype_Constraint;
  update_columns?: Array<Pallet_Skutype_Update_Column>;
  where?: InputMaybe<Pallet_Skutype_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_skutype". */
export type Pallet_Skutype_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_skutype */
export type Pallet_Skutype_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "pallet_skutype" */
export enum Pallet_Skutype_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_skutype" */
export type Pallet_Skutype_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "pallet_skutype" */
export type Pallet_Skutype_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Skutype_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Skutype_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "pallet_skutype" */
export enum Pallet_Skutype_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Skutype_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Skutype_Set_Input>;
  where: Pallet_Skutype_Bool_Exp;
};

/** columns and relationships of "pallet_variety" */
export type Pallet_Variety = {
  __typename?: 'pallet_variety';
  /** An object relationship */
  category: Pallet_Category;
  category_id: Scalars['bigint'];
  codename?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "pallet_variety" */
export type Pallet_Variety_Aggregate = {
  __typename?: 'pallet_variety_aggregate';
  aggregate?: Maybe<Pallet_Variety_Aggregate_Fields>;
  nodes: Array<Pallet_Variety>;
};

/** aggregate fields of "pallet_variety" */
export type Pallet_Variety_Aggregate_Fields = {
  __typename?: 'pallet_variety_aggregate_fields';
  avg?: Maybe<Pallet_Variety_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pallet_Variety_Max_Fields>;
  min?: Maybe<Pallet_Variety_Min_Fields>;
  stddev?: Maybe<Pallet_Variety_Stddev_Fields>;
  stddev_pop?: Maybe<Pallet_Variety_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pallet_Variety_Stddev_Samp_Fields>;
  sum?: Maybe<Pallet_Variety_Sum_Fields>;
  var_pop?: Maybe<Pallet_Variety_Var_Pop_Fields>;
  var_samp?: Maybe<Pallet_Variety_Var_Samp_Fields>;
  variance?: Maybe<Pallet_Variety_Variance_Fields>;
};


/** aggregate fields of "pallet_variety" */
export type Pallet_Variety_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pallet_Variety_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pallet_Variety_Avg_Fields = {
  __typename?: 'pallet_variety_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pallet_variety". All fields are combined with a logical 'AND'. */
export type Pallet_Variety_Bool_Exp = {
  _and?: InputMaybe<Array<Pallet_Variety_Bool_Exp>>;
  _not?: InputMaybe<Pallet_Variety_Bool_Exp>;
  _or?: InputMaybe<Array<Pallet_Variety_Bool_Exp>>;
  category?: InputMaybe<Pallet_Category_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pallet_variety" */
export enum Pallet_Variety_Constraint {
  /** unique or primary key constraint on columns "id" */
  PalletVarietyPkey = 'pallet_variety_pkey'
}

/** input type for incrementing numeric columns in table "pallet_variety" */
export type Pallet_Variety_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pallet_variety" */
export type Pallet_Variety_Insert_Input = {
  category?: InputMaybe<Pallet_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Pallet_Variety_Max_Fields = {
  __typename?: 'pallet_variety_max_fields';
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Pallet_Variety_Min_Fields = {
  __typename?: 'pallet_variety_min_fields';
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pallet_variety" */
export type Pallet_Variety_Mutation_Response = {
  __typename?: 'pallet_variety_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pallet_Variety>;
};

/** input type for inserting object relation for remote table "pallet_variety" */
export type Pallet_Variety_Obj_Rel_Insert_Input = {
  data: Pallet_Variety_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pallet_Variety_On_Conflict>;
};

/** on_conflict condition type for table "pallet_variety" */
export type Pallet_Variety_On_Conflict = {
  constraint: Pallet_Variety_Constraint;
  update_columns?: Array<Pallet_Variety_Update_Column>;
  where?: InputMaybe<Pallet_Variety_Bool_Exp>;
};

/** Ordering options when selecting data from "pallet_variety". */
export type Pallet_Variety_Order_By = {
  category?: InputMaybe<Pallet_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pallet_variety */
export type Pallet_Variety_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "pallet_variety" */
export enum Pallet_Variety_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pallet_variety" */
export type Pallet_Variety_Set_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Pallet_Variety_Stddev_Fields = {
  __typename?: 'pallet_variety_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pallet_Variety_Stddev_Pop_Fields = {
  __typename?: 'pallet_variety_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pallet_Variety_Stddev_Samp_Fields = {
  __typename?: 'pallet_variety_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pallet_variety" */
export type Pallet_Variety_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pallet_Variety_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pallet_Variety_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Pallet_Variety_Sum_Fields = {
  __typename?: 'pallet_variety_sum_fields';
  category_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pallet_variety" */
export enum Pallet_Variety_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Pallet_Variety_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pallet_Variety_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pallet_Variety_Set_Input>;
  where: Pallet_Variety_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pallet_Variety_Var_Pop_Fields = {
  __typename?: 'pallet_variety_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pallet_Variety_Var_Samp_Fields = {
  __typename?: 'pallet_variety_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pallet_Variety_Variance_Fields = {
  __typename?: 'pallet_variety_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "payment" */
export type Payment = {
  __typename?: 'payment';
  account_number: Scalars['String'];
  acount_holder: Scalars['String'];
  amount: Scalars['float8'];
  bank_name: Scalars['String'];
  branch_name: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  date: Scalars['date'];
  id: Scalars['bigint'];
  ifsc_code: Scalars['String'];
  mode: Scalars['String'];
  /** An object relationship */
  packaging_order: Packaging_Order;
  packaging_order_id: Scalars['bigint'];
  /** An object relationship */
  photo?: Maybe<Setutrade_Media>;
  photo_id?: Maybe<Scalars['bigint']>;
  transaction_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "payment" */
export type Payment_Aggregate = {
  __typename?: 'payment_aggregate';
  aggregate?: Maybe<Payment_Aggregate_Fields>;
  nodes: Array<Payment>;
};

/** aggregate fields of "payment" */
export type Payment_Aggregate_Fields = {
  __typename?: 'payment_aggregate_fields';
  avg?: Maybe<Payment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Max_Fields>;
  min?: Maybe<Payment_Min_Fields>;
  stddev?: Maybe<Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Sum_Fields>;
  var_pop?: Maybe<Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Var_Samp_Fields>;
  variance?: Maybe<Payment_Variance_Fields>;
};


/** aggregate fields of "payment" */
export type Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment" */
export type Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Max_Order_By>;
  min?: InputMaybe<Payment_Min_Order_By>;
  stddev?: InputMaybe<Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment" */
export type Payment_Arr_Rel_Insert_Input = {
  data: Array<Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Avg_Fields = {
  __typename?: 'payment_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment" */
export type Payment_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment". All fields are combined with a logical 'AND'. */
export type Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Bool_Exp>>;
  _not?: InputMaybe<Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Bool_Exp>>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  acount_holder?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bank_name?: InputMaybe<String_Comparison_Exp>;
  branch_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ifsc_code?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  packaging_order?: InputMaybe<Packaging_Order_Bool_Exp>;
  packaging_order_id?: InputMaybe<Bigint_Comparison_Exp>;
  photo?: InputMaybe<Setutrade_Media_Bool_Exp>;
  photo_id?: InputMaybe<Bigint_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment" */
export enum Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentPkey = 'payment_pkey'
}

/** columns and relationships of "payment_detail" */
export type Payment_Detail = {
  __typename?: 'payment_detail';
  account_holder_name: Scalars['String'];
  account_number: Scalars['String'];
  /** An array relationship */
  attachments: Array<Payment_Detail_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Payment_Detail_Attachments_Aggregate;
  bank_name: Scalars['String'];
  branch_name: Scalars['String'];
  /** An object relationship */
  content_type: Django_Content_Type;
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  ifsc_code: Scalars['String'];
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  method: Payment_Method;
  method_id: Scalars['Int'];
  object_id: Scalars['Int'];
  /** An array relationship */
  org_team_user_bank_associations: Array<Org_Team_User_Bank_Association>;
  /** An aggregate relationship */
  org_team_user_bank_associations_aggregate: Org_Team_User_Bank_Association_Aggregate;
  quality_checked?: Maybe<Scalars['Boolean']>;
  system_verified: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "payment_detail" */
export type Payment_DetailAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


/** columns and relationships of "payment_detail" */
export type Payment_DetailAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


/** columns and relationships of "payment_detail" */
export type Payment_DetailOrg_Team_User_Bank_AssociationsArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


/** columns and relationships of "payment_detail" */
export type Payment_DetailOrg_Team_User_Bank_Associations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};

/** aggregated selection of "payment_detail" */
export type Payment_Detail_Aggregate = {
  __typename?: 'payment_detail_aggregate';
  aggregate?: Maybe<Payment_Detail_Aggregate_Fields>;
  nodes: Array<Payment_Detail>;
};

/** aggregate fields of "payment_detail" */
export type Payment_Detail_Aggregate_Fields = {
  __typename?: 'payment_detail_aggregate_fields';
  avg?: Maybe<Payment_Detail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Detail_Max_Fields>;
  min?: Maybe<Payment_Detail_Min_Fields>;
  stddev?: Maybe<Payment_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Detail_Sum_Fields>;
  var_pop?: Maybe<Payment_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Detail_Var_Samp_Fields>;
  variance?: Maybe<Payment_Detail_Variance_Fields>;
};


/** aggregate fields of "payment_detail" */
export type Payment_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_detail" */
export type Payment_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Detail_Max_Order_By>;
  min?: InputMaybe<Payment_Detail_Min_Order_By>;
  stddev?: InputMaybe<Payment_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Detail_Variance_Order_By>;
};

/** columns and relationships of "payment_detail_attachments" */
export type Payment_Detail_Attachments = {
  __typename?: 'payment_detail_attachments';
  /** An object relationship */
  attachment: Media;
  id: Scalars['Int'];
  media_id: Scalars['Int'];
  /** An object relationship */
  payment_detail: Payment_Detail;
  paymentdetail_id: Scalars['Int'];
};

/** aggregated selection of "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate = {
  __typename?: 'payment_detail_attachments_aggregate';
  aggregate?: Maybe<Payment_Detail_Attachments_Aggregate_Fields>;
  nodes: Array<Payment_Detail_Attachments>;
};

/** aggregate fields of "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate_Fields = {
  __typename?: 'payment_detail_attachments_aggregate_fields';
  avg?: Maybe<Payment_Detail_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Detail_Attachments_Max_Fields>;
  min?: Maybe<Payment_Detail_Attachments_Min_Fields>;
  stddev?: Maybe<Payment_Detail_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Detail_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Detail_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Detail_Attachments_Sum_Fields>;
  var_pop?: Maybe<Payment_Detail_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Detail_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Payment_Detail_Attachments_Variance_Fields>;
};


/** aggregate fields of "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Detail_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Detail_Attachments_Max_Order_By>;
  min?: InputMaybe<Payment_Detail_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Payment_Detail_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Detail_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Detail_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Detail_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Detail_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Detail_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Detail_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Payment_Detail_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Detail_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Detail_Attachments_Avg_Fields = {
  __typename?: 'payment_detail_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_detail_attachments". All fields are combined with a logical 'AND'. */
export type Payment_Detail_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Detail_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Detail_Attachments_Bool_Exp>>;
  attachment?: InputMaybe<Media_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media_id?: InputMaybe<Int_Comparison_Exp>;
  payment_detail?: InputMaybe<Payment_Detail_Bool_Exp>;
  paymentdetail_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_detail_attachments" */
export enum Payment_Detail_Attachments_Constraint {
  /** unique or primary key constraint on columns "media_id", "paymentdetail_id" */
  PaymentDetailAttachmenPaymentdetailIdMediaI_891b8897Uniq = 'payment_detail_attachmen_paymentdetail_id_media_i_891b8897_uniq',
  /** unique or primary key constraint on columns "id" */
  PaymentDetailAttachmentsPkey = 'payment_detail_attachments_pkey'
}

/** input type for incrementing numeric columns in table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Insert_Input = {
  attachment?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  payment_detail?: InputMaybe<Payment_Detail_Obj_Rel_Insert_Input>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Payment_Detail_Attachments_Max_Fields = {
  __typename?: 'payment_detail_attachments_max_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  paymentdetail_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Detail_Attachments_Min_Fields = {
  __typename?: 'payment_detail_attachments_min_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  paymentdetail_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Mutation_Response = {
  __typename?: 'payment_detail_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Detail_Attachments>;
};

/** on_conflict condition type for table "payment_detail_attachments" */
export type Payment_Detail_Attachments_On_Conflict = {
  constraint: Payment_Detail_Attachments_Constraint;
  update_columns?: Array<Payment_Detail_Attachments_Update_Column>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_detail_attachments". */
export type Payment_Detail_Attachments_Order_By = {
  attachment?: InputMaybe<Media_Order_By>;
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  payment_detail?: InputMaybe<Payment_Detail_Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_detail_attachments */
export type Payment_Detail_Attachments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment_detail_attachments" */
export enum Payment_Detail_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PaymentdetailId = 'paymentdetail_id'
}

/** input type for updating data in table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Payment_Detail_Attachments_Stddev_Fields = {
  __typename?: 'payment_detail_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Detail_Attachments_Stddev_Pop_Fields = {
  __typename?: 'payment_detail_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Detail_Attachments_Stddev_Samp_Fields = {
  __typename?: 'payment_detail_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Detail_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Detail_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  paymentdetail_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Payment_Detail_Attachments_Sum_Fields = {
  __typename?: 'payment_detail_attachments_sum_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  paymentdetail_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** update columns of table "payment_detail_attachments" */
export enum Payment_Detail_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  PaymentdetailId = 'paymentdetail_id'
}

export type Payment_Detail_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Detail_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Detail_Attachments_Set_Input>;
  where: Payment_Detail_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Detail_Attachments_Var_Pop_Fields = {
  __typename?: 'payment_detail_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Detail_Attachments_Var_Samp_Fields = {
  __typename?: 'payment_detail_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Detail_Attachments_Variance_Fields = {
  __typename?: 'payment_detail_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  paymentdetail_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_detail_attachments" */
export type Payment_Detail_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  paymentdetail_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Payment_Detail_Avg_Fields = {
  __typename?: 'payment_detail_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_detail" */
export type Payment_Detail_Avg_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_detail". All fields are combined with a logical 'AND'. */
export type Payment_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Detail_Bool_Exp>>;
  _not?: InputMaybe<Payment_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Detail_Bool_Exp>>;
  account_holder_name?: InputMaybe<String_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  attachments?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
  bank_name?: InputMaybe<String_Comparison_Exp>;
  branch_name?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<Django_Content_Type_Bool_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ifsc_code?: InputMaybe<String_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  method?: InputMaybe<Payment_Method_Bool_Exp>;
  method_id?: InputMaybe<Int_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_detail" */
export enum Payment_Detail_Constraint {
  /** unique or primary key constraint on columns "account_number", "ifsc_code" */
  PaymentDetailAccountNumberIfscCodeB7a708d5Uniq = 'payment_detail_account_number_ifsc_code_b7a708d5_uniq',
  /** unique or primary key constraint on columns "id" */
  PaymentDetailPkey = 'payment_detail_pkey'
}

/** input type for incrementing numeric columns in table "payment_detail" */
export type Payment_Detail_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment_detail" */
export type Payment_Detail_Insert_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Payment_Detail_Attachments_Arr_Rel_Insert_Input>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Django_Content_Type_Obj_Rel_Insert_Input>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Payment_Method_Obj_Rel_Insert_Input>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  org_team_user_bank_associations?: InputMaybe<Org_Team_User_Bank_Association_Arr_Rel_Insert_Input>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Payment_Detail_Max_Fields = {
  __typename?: 'payment_detail_max_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  ifsc_code?: Maybe<Scalars['String']>;
  method_id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "payment_detail" */
export type Payment_Detail_Max_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Detail_Min_Fields = {
  __typename?: 'payment_detail_min_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  ifsc_code?: Maybe<Scalars['String']>;
  method_id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "payment_detail" */
export type Payment_Detail_Min_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_detail" */
export type Payment_Detail_Mutation_Response = {
  __typename?: 'payment_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Detail>;
};

/** input type for inserting object relation for remote table "payment_detail" */
export type Payment_Detail_Obj_Rel_Insert_Input = {
  data: Payment_Detail_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Detail_On_Conflict>;
};

/** on_conflict condition type for table "payment_detail" */
export type Payment_Detail_On_Conflict = {
  constraint: Payment_Detail_Constraint;
  update_columns?: Array<Payment_Detail_Update_Column>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_detail". */
export type Payment_Detail_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Payment_Detail_Attachments_Aggregate_Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Django_Content_Type_Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  method?: InputMaybe<Payment_Method_Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  org_team_user_bank_associations_aggregate?: InputMaybe<Org_Team_User_Bank_Association_Aggregate_Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_detail */
export type Payment_Detail_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment_detail" */
export enum Payment_Detail_Select_Column {
  /** column name */
  AccountHolderName = 'account_holder_name',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "payment_detail" */
export type Payment_Detail_Set_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Payment_Detail_Stddev_Fields = {
  __typename?: 'payment_detail_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_detail" */
export type Payment_Detail_Stddev_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Detail_Stddev_Pop_Fields = {
  __typename?: 'payment_detail_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment_detail" */
export type Payment_Detail_Stddev_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Detail_Stddev_Samp_Fields = {
  __typename?: 'payment_detail_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment_detail" */
export type Payment_Detail_Stddev_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_detail" */
export type Payment_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Detail_Stream_Cursor_Value_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  method_id?: InputMaybe<Scalars['Int']>;
  object_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Payment_Detail_Sum_Fields = {
  __typename?: 'payment_detail_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  method_id?: Maybe<Scalars['Int']>;
  object_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "payment_detail" */
export type Payment_Detail_Sum_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "payment_detail" */
export enum Payment_Detail_Update_Column {
  /** column name */
  AccountHolderName = 'account_holder_name',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  MethodId = 'method_id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Payment_Detail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Detail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Detail_Set_Input>;
  where: Payment_Detail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Detail_Var_Pop_Fields = {
  __typename?: 'payment_detail_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment_detail" */
export type Payment_Detail_Var_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Detail_Var_Samp_Fields = {
  __typename?: 'payment_detail_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment_detail" */
export type Payment_Detail_Var_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Detail_Variance_Fields = {
  __typename?: 'payment_detail_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  method_id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_detail" */
export type Payment_Detail_Variance_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method_id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "payment" */
export type Payment_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  photo_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "payment" */
export type Payment_Insert_Input = {
  account_number?: InputMaybe<Scalars['String']>;
  acount_holder?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging_order?: InputMaybe<Packaging_Order_Obj_Rel_Insert_Input>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  photo?: InputMaybe<Setutrade_Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Payment_Max_Fields = {
  __typename?: 'payment_max_fields';
  account_number?: Maybe<Scalars['String']>;
  acount_holder?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['float8']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  ifsc_code?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  packaging_order_id?: Maybe<Scalars['bigint']>;
  photo_id?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "payment" */
export type Payment_Max_Order_By = {
  account_number?: InputMaybe<Order_By>;
  acount_holder?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_method" */
export type Payment_Method = {
  __typename?: 'payment_method';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "payment_method" */
export type Payment_Method_Aggregate = {
  __typename?: 'payment_method_aggregate';
  aggregate?: Maybe<Payment_Method_Aggregate_Fields>;
  nodes: Array<Payment_Method>;
};

/** aggregate fields of "payment_method" */
export type Payment_Method_Aggregate_Fields = {
  __typename?: 'payment_method_aggregate_fields';
  avg?: Maybe<Payment_Method_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Method_Max_Fields>;
  min?: Maybe<Payment_Method_Min_Fields>;
  stddev?: Maybe<Payment_Method_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Method_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Method_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Method_Sum_Fields>;
  var_pop?: Maybe<Payment_Method_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Method_Var_Samp_Fields>;
  variance?: Maybe<Payment_Method_Variance_Fields>;
};


/** aggregate fields of "payment_method" */
export type Payment_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Payment_Method_Avg_Fields = {
  __typename?: 'payment_method_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "payment_method". All fields are combined with a logical 'AND'. */
export type Payment_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Method_Bool_Exp>>;
  _not?: InputMaybe<Payment_Method_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Method_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_method" */
export enum Payment_Method_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PaymentMethodCodenameKey = 'payment_method_codename_key',
  /** unique or primary key constraint on columns "id" */
  PaymentMethodPkey = 'payment_method_pkey'
}

/** input type for incrementing numeric columns in table "payment_method" */
export type Payment_Method_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment_method" */
export type Payment_Method_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Payment_Method_Max_Fields = {
  __typename?: 'payment_method_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Payment_Method_Min_Fields = {
  __typename?: 'payment_method_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "payment_method" */
export type Payment_Method_Mutation_Response = {
  __typename?: 'payment_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Method>;
};

/** input type for inserting object relation for remote table "payment_method" */
export type Payment_Method_Obj_Rel_Insert_Input = {
  data: Payment_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>;
};

/** on_conflict condition type for table "payment_method" */
export type Payment_Method_On_Conflict = {
  constraint: Payment_Method_Constraint;
  update_columns?: Array<Payment_Method_Update_Column>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_method". */
export type Payment_Method_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_method */
export type Payment_Method_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment_method" */
export enum Payment_Method_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "payment_method" */
export type Payment_Method_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Payment_Method_Stddev_Fields = {
  __typename?: 'payment_method_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Payment_Method_Stddev_Pop_Fields = {
  __typename?: 'payment_method_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Payment_Method_Stddev_Samp_Fields = {
  __typename?: 'payment_method_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "payment_method" */
export type Payment_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Method_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Payment_Method_Sum_Fields = {
  __typename?: 'payment_method_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "payment_method" */
export enum Payment_Method_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Payment_Method_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Method_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Method_Set_Input>;
  where: Payment_Method_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Method_Var_Pop_Fields = {
  __typename?: 'payment_method_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Payment_Method_Var_Samp_Fields = {
  __typename?: 'payment_method_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Payment_Method_Variance_Fields = {
  __typename?: 'payment_method_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Payment_Min_Fields = {
  __typename?: 'payment_min_fields';
  account_number?: Maybe<Scalars['String']>;
  acount_holder?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['float8']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  ifsc_code?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  packaging_order_id?: Maybe<Scalars['bigint']>;
  photo_id?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "payment" */
export type Payment_Min_Order_By = {
  account_number?: InputMaybe<Order_By>;
  acount_holder?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment" */
export type Payment_Mutation_Response = {
  __typename?: 'payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment>;
};

/** on_conflict condition type for table "payment" */
export type Payment_On_Conflict = {
  constraint: Payment_Constraint;
  update_columns?: Array<Payment_Update_Column>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "payment". */
export type Payment_Order_By = {
  account_number?: InputMaybe<Order_By>;
  acount_holder?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc_code?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  packaging_order?: InputMaybe<Packaging_Order_Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Setutrade_Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment */
export type Payment_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "payment" */
export enum Payment_Select_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AcountHolder = 'acount_holder',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  Mode = 'mode',
  /** column name */
  PackagingOrderId = 'packaging_order_id',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "payment" */
export type Payment_Set_Input = {
  account_number?: InputMaybe<Scalars['String']>;
  acount_holder?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  photo_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Payment_Stddev_Fields = {
  __typename?: 'payment_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment" */
export type Payment_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Stddev_Pop_Fields = {
  __typename?: 'payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment" */
export type Payment_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Stddev_Samp_Fields = {
  __typename?: 'payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment" */
export type Payment_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment" */
export type Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars['String']>;
  acount_holder?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  ifsc_code?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  packaging_order_id?: InputMaybe<Scalars['bigint']>;
  photo_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Payment_Sum_Fields = {
  __typename?: 'payment_sum_fields';
  amount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_order_id?: Maybe<Scalars['bigint']>;
  photo_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "payment" */
export type Payment_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** update columns of table "payment" */
export enum Payment_Update_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AcountHolder = 'acount_holder',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IfscCode = 'ifsc_code',
  /** column name */
  Mode = 'mode',
  /** column name */
  PackagingOrderId = 'packaging_order_id',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  TransactionId = 'transaction_id'
}

export type Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Set_Input>;
  where: Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Var_Pop_Fields = {
  __typename?: 'payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment" */
export type Payment_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Var_Samp_Fields = {
  __typename?: 'payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment" */
export type Payment_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Variance_Fields = {
  __typename?: 'payment_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_order_id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment" */
export type Payment_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_order_id?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "plot" */
export type Plot = {
  __typename?: 'plot';
  /** An array relationship */
  agreement_plots: Array<Agreement_Plot>;
  /** An aggregate relationship */
  agreement_plots_aggregate: Agreement_Plot_Aggregate;
  area?: Maybe<Scalars['numeric']>;
  area_catered?: Maybe<Scalars['geometry']>;
  /** An object relationship */
  area_unit?: Maybe<Si_Unit>;
  area_unit_id?: Maybe<Scalars['Int']>;
  centroid?: Maybe<Scalars['geometry']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  crops: Array<Plot_Crop>;
  /** An aggregate relationship */
  crops_aggregate: Plot_Crop_Aggregate;
  description?: Maybe<Scalars['String']>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  /** An object relationship */
  field: Field;
  field_id: Scalars['Int'];
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Plot_Network>;
  /** An aggregate relationship */
  networks_aggregate: Plot_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  private_metadata?: Maybe<Scalars['jsonb']>;
  quality_checked?: Maybe<Scalars['Boolean']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  verification_done_by?: Maybe<Base_User>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "plot" */
export type PlotAgreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Plot_Order_By>>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotAgreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Plot_Order_By>>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotCropsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotCrops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot" */
export type PlotMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot" */
export type PlotNetworksArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


/** columns and relationships of "plot" */
export type PlotPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "plot" */
export type Plot_Aggregate = {
  __typename?: 'plot_aggregate';
  aggregate?: Maybe<Plot_Aggregate_Fields>;
  nodes: Array<Plot>;
};

/** aggregate fields of "plot" */
export type Plot_Aggregate_Fields = {
  __typename?: 'plot_aggregate_fields';
  avg?: Maybe<Plot_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Max_Fields>;
  min?: Maybe<Plot_Min_Fields>;
  stddev?: Maybe<Plot_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Sum_Fields>;
  var_pop?: Maybe<Plot_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Var_Samp_Fields>;
  variance?: Maybe<Plot_Variance_Fields>;
};


/** aggregate fields of "plot" */
export type Plot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot" */
export type Plot_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Max_Order_By>;
  min?: InputMaybe<Plot_Min_Order_By>;
  stddev?: InputMaybe<Plot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Plot_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "plot" */
export type Plot_Arr_Rel_Insert_Input = {
  data: Array<Plot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Avg_Fields = {
  __typename?: 'plot_avg_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot" */
export type Plot_Avg_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot". All fields are combined with a logical 'AND'. */
export type Plot_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Bool_Exp>>;
  _not?: InputMaybe<Plot_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Bool_Exp>>;
  agreement_plots?: InputMaybe<Agreement_Plot_Bool_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_catered?: InputMaybe<Geometry_Comparison_Exp>;
  area_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crops?: InputMaybe<Plot_Crop_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  field?: InputMaybe<Field_Bool_Exp>;
  field_id?: InputMaybe<Int_Comparison_Exp>;
  geo_area_remark?: InputMaybe<Float8_Comparison_Exp>;
  geo_bound_area?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_by?: InputMaybe<Base_User_Bool_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot" */
export enum Plot_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PlotCodenameKey = 'plot_codename_key',
  /** unique or primary key constraint on columns "id" */
  PlotPkey = 'plot_pkey'
}

/** columns and relationships of "plot_crop" */
export type Plot_Crop = {
  __typename?: 'plot_crop';
  /** An array relationship */
  agents: Array<Plot_Crop_Agent>;
  /** An aggregate relationship */
  agents_aggregate: Plot_Crop_Agent_Aggregate;
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  created_in?: Maybe<Department>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  /** An object relationship */
  crop_variety?: Maybe<Crop_Variety>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  /** An array relationship */
  cultivation_types: Array<Plot_Crop_Cultivation_Type>;
  /** An aggregate relationship */
  cultivation_types_aggregate: Plot_Crop_Cultivation_Type_Aggregate;
  /** An object relationship */
  current_crop_year?: Maybe<Crop_Year>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  estd_harvest_quantity_unit?: Maybe<Si_Unit>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  estd_harvesting_date?: Maybe<Scalars['date']>;
  estd_sowing_date?: Maybe<Scalars['date']>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  growing_cycle: Scalars['Int'];
  harvest_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  harvest_quantity_unit?: Maybe<Si_Unit>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  harvesting_date?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  is_archived: Scalars['Boolean'];
  is_seed: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  networks: Array<Plot_Crop_Network>;
  /** An aggregate relationship */
  networks_aggregate: Plot_Crop_Network_Aggregate;
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  p2p_distance_unit?: Maybe<Si_Unit>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count: Scalars['Int'];
  /** An object relationship */
  plot: Plot;
  /** An array relationship */
  plot_crop_historic_seasons: Array<Plot_Crop_Historic_Season>;
  /** An aggregate relationship */
  plot_crop_historic_seasons_aggregate: Plot_Crop_Historic_Season_Aggregate;
  plot_id: Scalars['Int'];
  private_metadata: Scalars['jsonb'];
  quality_checked?: Maybe<Scalars['Boolean']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  r2r_distance_unit?: Maybe<Si_Unit>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  rootstocks: Array<Plot_Crop_Rootstock>;
  /** An aggregate relationship */
  rootstocks_aggregate: Plot_Crop_Rootstock_Aggregate;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  sowing_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  status: Plot_Status;
  /** An array relationship */
  status_histories: Array<Plot_Crop_Status_History>;
  /** An aggregate relationship */
  status_histories_aggregate: Plot_Crop_Status_History_Aggregate;
  status_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
  tag: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  user_preferred_name?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropAgentsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropAgents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropCultivation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Order_By>>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropCultivation_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Order_By>>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropDocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropExternal_Reference_IdArgs = {
  organisation_uid?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropNetworksArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropNetworks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropPlot_Crop_Historic_SeasonsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Historic_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Historic_Season_Order_By>>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropPlot_Crop_Historic_Seasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Historic_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Historic_Season_Order_By>>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropRootstocksArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropRootstocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropStatus_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Status_History_Order_By>>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};


/** columns and relationships of "plot_crop" */
export type Plot_CropStatus_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Status_History_Order_By>>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};

/** columns and relationships of "plot_crop_agent" */
export type Plot_Crop_Agent = {
  __typename?: 'plot_crop_agent';
  /** An object relationship */
  agent: Agent;
  agent_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
};

/** aggregated selection of "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate = {
  __typename?: 'plot_crop_agent_aggregate';
  aggregate?: Maybe<Plot_Crop_Agent_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Agent>;
};

/** aggregate fields of "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate_Fields = {
  __typename?: 'plot_crop_agent_aggregate_fields';
  avg?: Maybe<Plot_Crop_Agent_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Agent_Max_Fields>;
  min?: Maybe<Plot_Crop_Agent_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Agent_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Agent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Agent_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Agent_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Agent_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Agent_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Agent_Variance_Fields>;
};


/** aggregate fields of "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_agent" */
export type Plot_Crop_Agent_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Agent_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Agent_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Agent_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Agent_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Agent_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Agent_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Agent_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Agent_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Agent_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Agent_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_agent" */
export type Plot_Crop_Agent_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Agent_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Agent_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Agent_Avg_Fields = {
  __typename?: 'plot_crop_agent_avg_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Avg_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_agent". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Agent_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Agent_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Agent_Bool_Exp>>;
  agent?: InputMaybe<Agent_Bool_Exp>;
  agent_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_agent" */
export enum Plot_Crop_Agent_Constraint {
  /** unique or primary key constraint on columns "agent_id", "plot_crop_id" */
  PlotCropAgentAgentIdPlotCropIdC0ad918bUniq = 'plot_crop_agent_agent_id_plot_crop_id_c0ad918b_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotCropAgentPkey = 'plot_crop_agent_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_agent" */
export type Plot_Crop_Agent_Inc_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_agent" */
export type Plot_Crop_Agent_Insert_Input = {
  agent?: InputMaybe<Agent_Obj_Rel_Insert_Input>;
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Agent_Max_Fields = {
  __typename?: 'plot_crop_agent_max_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Agent_Min_Fields = {
  __typename?: 'plot_crop_agent_min_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_agent" */
export type Plot_Crop_Agent_Mutation_Response = {
  __typename?: 'plot_crop_agent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Agent>;
};

/** on_conflict condition type for table "plot_crop_agent" */
export type Plot_Crop_Agent_On_Conflict = {
  constraint: Plot_Crop_Agent_Constraint;
  update_columns?: Array<Plot_Crop_Agent_Update_Column>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_agent". */
export type Plot_Crop_Agent_Order_By = {
  agent?: InputMaybe<Agent_Order_By>;
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_agent */
export type Plot_Crop_Agent_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_agent" */
export enum Plot_Crop_Agent_Select_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

/** input type for updating data in table "plot_crop_agent" */
export type Plot_Crop_Agent_Set_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Agent_Stddev_Fields = {
  __typename?: 'plot_crop_agent_stddev_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Stddev_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Agent_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_agent_stddev_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Stddev_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Agent_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_agent_stddev_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Stddev_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_agent" */
export type Plot_Crop_Agent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Agent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Agent_Stream_Cursor_Value_Input = {
  agent_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Agent_Sum_Fields = {
  __typename?: 'plot_crop_agent_sum_fields';
  agent_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Sum_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_agent" */
export enum Plot_Crop_Agent_Update_Column {
  /** column name */
  AgentId = 'agent_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

export type Plot_Crop_Agent_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Agent_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Agent_Set_Input>;
  where: Plot_Crop_Agent_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Agent_Var_Pop_Fields = {
  __typename?: 'plot_crop_agent_var_pop_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Var_Pop_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Agent_Var_Samp_Fields = {
  __typename?: 'plot_crop_agent_var_samp_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Var_Samp_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Agent_Variance_Fields = {
  __typename?: 'plot_crop_agent_variance_fields';
  agent_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_agent" */
export type Plot_Crop_Agent_Variance_Order_By = {
  agent_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "plot_crop" */
export type Plot_Crop_Aggregate = {
  __typename?: 'plot_crop_aggregate';
  aggregate?: Maybe<Plot_Crop_Aggregate_Fields>;
  nodes: Array<Plot_Crop>;
};

/** aggregate fields of "plot_crop" */
export type Plot_Crop_Aggregate_Fields = {
  __typename?: 'plot_crop_aggregate_fields';
  avg?: Maybe<Plot_Crop_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Max_Fields>;
  min?: Maybe<Plot_Crop_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Variance_Fields>;
};


/** aggregate fields of "plot_crop" */
export type Plot_Crop_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop" */
export type Plot_Crop_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Plot_Crop_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "plot_crop" */
export type Plot_Crop_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Avg_Fields = {
  __typename?: 'plot_crop_avg_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop" */
export type Plot_Crop_Avg_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  cultivation_types?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_crop_historic_seasons?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  rootstocks?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_histories?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  user_preferred_name?: InputMaybe<String_Comparison_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp_Remote_Rel_External_Entityplot_Crop = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_External_Entityplot_Crop>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  cultivation_types?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_crop_historic_seasons?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  rootstocks?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_histories?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  user_preferred_name?: InputMaybe<String_Comparison_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "plot_crop". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Bool_Exp_Remote_Rel_Shared_Entityplot_Crop = {
  _and?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Bool_Exp>>;
  agents?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
  area?: InputMaybe<Numeric_Comparison_Exp>;
  area_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityplot_Crop>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in?: InputMaybe<Department_Bool_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  crop_variety?: InputMaybe<Crop_Variety_Bool_Exp>;
  crop_variety_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Int_Comparison_Exp>;
  cultivation_types?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
  current_crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  current_crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  estd_harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  estd_harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  estd_harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  estd_sowing_date?: InputMaybe<Date_Comparison_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  growing_cycle?: InputMaybe<Int_Comparison_Exp>;
  harvest_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  harvest_quantity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  harvesting_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_seed?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  networks?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  p2p_distance?: InputMaybe<Numeric_Comparison_Exp>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  p2p_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  plant_count?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_crop_historic_seasons?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  r2r_distance?: InputMaybe<Numeric_Comparison_Exp>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  r2r_distance_unit_id?: InputMaybe<Int_Comparison_Exp>;
  rootstocks?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
  send_for_verification_remark?: InputMaybe<String_Comparison_Exp>;
  send_for_verification_status?: InputMaybe<String_Comparison_Exp>;
  sowing_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Plot_Status_Bool_Exp>;
  status_histories?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  user_preferred_name?: InputMaybe<String_Comparison_Exp>;
  verification_done_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_done_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop" */
export enum Plot_Crop_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PlotCropCodenameKey = 'plot_crop_codename_key',
  /** unique or primary key constraint on columns "id" */
  PlotCropPkey = 'plot_crop_pkey'
}

/** columns and relationships of "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type = {
  __typename?: 'plot_crop_cultivation_type';
  /** An object relationship */
  cultivation_type: Cultivation_Type;
  cultivation_type_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
};

/** aggregated selection of "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Aggregate = {
  __typename?: 'plot_crop_cultivation_type_aggregate';
  aggregate?: Maybe<Plot_Crop_Cultivation_Type_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Cultivation_Type>;
};

/** aggregate fields of "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Aggregate_Fields = {
  __typename?: 'plot_crop_cultivation_type_aggregate_fields';
  avg?: Maybe<Plot_Crop_Cultivation_Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Cultivation_Type_Max_Fields>;
  min?: Maybe<Plot_Crop_Cultivation_Type_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Cultivation_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Cultivation_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Cultivation_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Cultivation_Type_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Cultivation_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Cultivation_Type_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Cultivation_Type_Variance_Fields>;
};


/** aggregate fields of "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Cultivation_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Cultivation_Type_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Cultivation_Type_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Cultivation_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Cultivation_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Cultivation_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Cultivation_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Cultivation_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Cultivation_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Cultivation_Type_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Cultivation_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Cultivation_Type_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Cultivation_Type_Avg_Fields = {
  __typename?: 'plot_crop_cultivation_type_avg_fields';
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Avg_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_cultivation_type". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Cultivation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Bool_Exp>>;
  cultivation_type?: InputMaybe<Cultivation_Type_Bool_Exp>;
  cultivation_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_cultivation_type" */
export enum Plot_Crop_Cultivation_Type_Constraint {
  /** unique or primary key constraint on columns "cultivation_type_id", "plot_crop_id" */
  PlotCropCultivationTyCultivationTypeIdPlot_122b3ee1Uniq = 'plot_crop_cultivation_ty_cultivation_type_id_plot_122b3ee1_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotCropCultivationTypePkey = 'plot_crop_cultivation_type_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Inc_Input = {
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Insert_Input = {
  cultivation_type?: InputMaybe<Cultivation_Type_Obj_Rel_Insert_Input>;
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Cultivation_Type_Max_Fields = {
  __typename?: 'plot_crop_cultivation_type_max_fields';
  cultivation_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Max_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Cultivation_Type_Min_Fields = {
  __typename?: 'plot_crop_cultivation_type_min_fields';
  cultivation_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Min_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Mutation_Response = {
  __typename?: 'plot_crop_cultivation_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Cultivation_Type>;
};

/** on_conflict condition type for table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_On_Conflict = {
  constraint: Plot_Crop_Cultivation_Type_Constraint;
  update_columns?: Array<Plot_Crop_Cultivation_Type_Update_Column>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_cultivation_type". */
export type Plot_Crop_Cultivation_Type_Order_By = {
  cultivation_type?: InputMaybe<Cultivation_Type_Order_By>;
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_cultivation_type */
export type Plot_Crop_Cultivation_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_cultivation_type" */
export enum Plot_Crop_Cultivation_Type_Select_Column {
  /** column name */
  CultivationTypeId = 'cultivation_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

/** input type for updating data in table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Set_Input = {
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Cultivation_Type_Stddev_Fields = {
  __typename?: 'plot_crop_cultivation_type_stddev_fields';
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Stddev_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Cultivation_Type_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_cultivation_type_stddev_pop_fields';
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Stddev_Pop_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Cultivation_Type_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_cultivation_type_stddev_samp_fields';
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Stddev_Samp_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Cultivation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Cultivation_Type_Stream_Cursor_Value_Input = {
  cultivation_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Cultivation_Type_Sum_Fields = {
  __typename?: 'plot_crop_cultivation_type_sum_fields';
  cultivation_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Sum_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_cultivation_type" */
export enum Plot_Crop_Cultivation_Type_Update_Column {
  /** column name */
  CultivationTypeId = 'cultivation_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

export type Plot_Crop_Cultivation_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Cultivation_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Cultivation_Type_Set_Input>;
  where: Plot_Crop_Cultivation_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Cultivation_Type_Var_Pop_Fields = {
  __typename?: 'plot_crop_cultivation_type_var_pop_fields';
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Var_Pop_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Cultivation_Type_Var_Samp_Fields = {
  __typename?: 'plot_crop_cultivation_type_var_samp_fields';
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Var_Samp_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Cultivation_Type_Variance_Fields = {
  __typename?: 'plot_crop_cultivation_type_variance_fields';
  cultivation_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_cultivation_type" */
export type Plot_Crop_Cultivation_Type_Variance_Order_By = {
  cultivation_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Plot_Crop_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Plot_Crop_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Plot_Crop_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season = {
  __typename?: 'plot_crop_historic_season';
  /** An object relationship */
  crop_year?: Maybe<Crop_Year>;
  crop_year_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
};

/** aggregated selection of "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Aggregate = {
  __typename?: 'plot_crop_historic_season_aggregate';
  aggregate?: Maybe<Plot_Crop_Historic_Season_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Historic_Season>;
};

/** aggregate fields of "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Aggregate_Fields = {
  __typename?: 'plot_crop_historic_season_aggregate_fields';
  avg?: Maybe<Plot_Crop_Historic_Season_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Historic_Season_Max_Fields>;
  min?: Maybe<Plot_Crop_Historic_Season_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Historic_Season_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Historic_Season_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Historic_Season_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Historic_Season_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Historic_Season_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Historic_Season_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Historic_Season_Variance_Fields>;
};


/** aggregate fields of "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Historic_Season_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Historic_Season_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Historic_Season_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Historic_Season_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Historic_Season_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Historic_Season_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Historic_Season_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Historic_Season_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Historic_Season_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Historic_Season_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Historic_Season_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Historic_Season_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Historic_Season_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Historic_Season_Avg_Fields = {
  __typename?: 'plot_crop_historic_season_avg_fields';
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Avg_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_historic_season". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Historic_Season_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Historic_Season_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Historic_Season_Bool_Exp>>;
  crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_historic_season" */
export enum Plot_Crop_Historic_Season_Constraint {
  /** unique or primary key constraint on columns "crop_year_id", "plot_crop_id" */
  PlotCropHistoricSeasoPlotCropIdCropYearI_4eaad7a8Uniq = 'plot_crop_historic_seaso_plot_crop_id_crop_year_i_4eaad7a8_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotCropHistoricSeasonPkey = 'plot_crop_historic_season_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Inc_Input = {
  crop_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Insert_Input = {
  crop_year?: InputMaybe<Crop_Year_Obj_Rel_Insert_Input>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Historic_Season_Max_Fields = {
  __typename?: 'plot_crop_historic_season_max_fields';
  crop_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Max_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Historic_Season_Min_Fields = {
  __typename?: 'plot_crop_historic_season_min_fields';
  crop_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Min_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Mutation_Response = {
  __typename?: 'plot_crop_historic_season_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Historic_Season>;
};

/** on_conflict condition type for table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_On_Conflict = {
  constraint: Plot_Crop_Historic_Season_Constraint;
  update_columns?: Array<Plot_Crop_Historic_Season_Update_Column>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_historic_season". */
export type Plot_Crop_Historic_Season_Order_By = {
  crop_year?: InputMaybe<Crop_Year_Order_By>;
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_historic_season */
export type Plot_Crop_Historic_Season_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_historic_season" */
export enum Plot_Crop_Historic_Season_Select_Column {
  /** column name */
  CropYearId = 'crop_year_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

/** input type for updating data in table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Set_Input = {
  crop_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Historic_Season_Stddev_Fields = {
  __typename?: 'plot_crop_historic_season_stddev_fields';
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Stddev_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Historic_Season_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_historic_season_stddev_pop_fields';
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Stddev_Pop_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Historic_Season_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_historic_season_stddev_samp_fields';
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Stddev_Samp_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Historic_Season_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Historic_Season_Stream_Cursor_Value_Input = {
  crop_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Historic_Season_Sum_Fields = {
  __typename?: 'plot_crop_historic_season_sum_fields';
  crop_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Sum_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_historic_season" */
export enum Plot_Crop_Historic_Season_Update_Column {
  /** column name */
  CropYearId = 'crop_year_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

export type Plot_Crop_Historic_Season_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Historic_Season_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Historic_Season_Set_Input>;
  where: Plot_Crop_Historic_Season_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Historic_Season_Var_Pop_Fields = {
  __typename?: 'plot_crop_historic_season_var_pop_fields';
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Var_Pop_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Historic_Season_Var_Samp_Fields = {
  __typename?: 'plot_crop_historic_season_var_samp_fields';
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Var_Samp_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Historic_Season_Variance_Fields = {
  __typename?: 'plot_crop_historic_season_variance_fields';
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_historic_season" */
export type Plot_Crop_Historic_Season_Variance_Order_By = {
  crop_year_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "plot_crop" */
export type Plot_Crop_Inc_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  status_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop" */
export type Plot_Crop_Insert_Input = {
  agents?: InputMaybe<Plot_Crop_Agent_Arr_Rel_Insert_Input>;
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety?: InputMaybe<Crop_Variety_Obj_Rel_Insert_Input>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  cultivation_types?: InputMaybe<Plot_Crop_Cultivation_Type_Arr_Rel_Insert_Input>;
  current_crop_year?: InputMaybe<Crop_Year_Obj_Rel_Insert_Input>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  estd_harvesting_date?: InputMaybe<Scalars['date']>;
  estd_sowing_date?: InputMaybe<Scalars['date']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  harvesting_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_seed?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Plot_Crop_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot?: InputMaybe<Plot_Obj_Rel_Insert_Input>;
  plot_crop_historic_seasons?: InputMaybe<Plot_Crop_Historic_Season_Arr_Rel_Insert_Input>;
  plot_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  rootstocks?: InputMaybe<Plot_Crop_Rootstock_Arr_Rel_Insert_Input>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  sowing_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Plot_Status_Obj_Rel_Insert_Input>;
  status_histories?: InputMaybe<Plot_Crop_Status_History_Arr_Rel_Insert_Input>;
  status_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  user_preferred_name?: InputMaybe<Scalars['String']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Plot_Crop_Max_Fields = {
  __typename?: 'plot_crop_max_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  estd_harvesting_date?: Maybe<Scalars['date']>;
  estd_sowing_date?: Maybe<Scalars['date']>;
  farmer_id?: Maybe<Scalars['Int']>;
  growing_cycle?: Maybe<Scalars['Int']>;
  harvest_quantity?: Maybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  harvesting_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  sowing_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  user_preferred_name?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "plot_crop" */
export type Plot_Crop_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  estd_harvesting_date?: InputMaybe<Order_By>;
  estd_sowing_date?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  harvesting_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  sowing_date?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_preferred_name?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "plot_crop_milestone" */
export type Plot_Crop_Milestone = {
  __typename?: 'plot_crop_milestone';
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  crop_milestone: Crop_Milestone;
  crop_milestone_id: Scalars['Int'];
  /** An object relationship */
  crop_year: Crop_Year;
  crop_year_id: Scalars['Int'];
  date: Scalars['date'];
  id: Scalars['Int'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "plot_crop_milestone" */
export type Plot_Crop_Milestone_Aggregate = {
  __typename?: 'plot_crop_milestone_aggregate';
  aggregate?: Maybe<Plot_Crop_Milestone_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Milestone>;
};

/** aggregate fields of "plot_crop_milestone" */
export type Plot_Crop_Milestone_Aggregate_Fields = {
  __typename?: 'plot_crop_milestone_aggregate_fields';
  avg?: Maybe<Plot_Crop_Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Milestone_Max_Fields>;
  min?: Maybe<Plot_Crop_Milestone_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Milestone_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Milestone_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Milestone_Variance_Fields>;
};


/** aggregate fields of "plot_crop_milestone" */
export type Plot_Crop_Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Plot_Crop_Milestone_Avg_Fields = {
  __typename?: 'plot_crop_milestone_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "plot_crop_milestone". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Milestone_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Milestone_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  crop_milestone?: InputMaybe<Crop_Milestone_Bool_Exp>;
  crop_milestone_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  crop_year_id?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_milestone" */
export enum Plot_Crop_Milestone_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlotCropMilestonePkey = 'plot_crop_milestone_pkey',
  /** unique or primary key constraint on columns "crop_milestone_id", "crop_year_id", "plot_crop_id" */
  PlotCropMilestonePlotCropIdCropMilest_8e9ba356Uniq = 'plot_crop_milestone_plot_crop_id_crop_milest_8e9ba356_uniq'
}

/** input type for incrementing numeric columns in table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone?: InputMaybe<Crop_Milestone_Obj_Rel_Insert_Input>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Crop_Year_Obj_Rel_Insert_Input>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Milestone_Max_Fields = {
  __typename?: 'plot_crop_milestone_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_milestone_id?: Maybe<Scalars['Int']>;
  crop_year_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Plot_Crop_Milestone_Min_Fields = {
  __typename?: 'plot_crop_milestone_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_milestone_id?: Maybe<Scalars['Int']>;
  crop_year_id?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Mutation_Response = {
  __typename?: 'plot_crop_milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Milestone>;
};

/** on_conflict condition type for table "plot_crop_milestone" */
export type Plot_Crop_Milestone_On_Conflict = {
  constraint: Plot_Crop_Milestone_Constraint;
  update_columns?: Array<Plot_Crop_Milestone_Update_Column>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_milestone". */
export type Plot_Crop_Milestone_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_milestone?: InputMaybe<Crop_Milestone_Order_By>;
  crop_milestone_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Crop_Year_Order_By>;
  crop_year_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_milestone */
export type Plot_Crop_Milestone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_milestone" */
export enum Plot_Crop_Milestone_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropMilestoneId = 'crop_milestone_id',
  /** column name */
  CropYearId = 'crop_year_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Milestone_Stddev_Fields = {
  __typename?: 'plot_crop_milestone_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Milestone_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_milestone_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Milestone_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_milestone_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "plot_crop_milestone" */
export type Plot_Crop_Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Milestone_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_milestone_id?: InputMaybe<Scalars['Int']>;
  crop_year_id?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Milestone_Sum_Fields = {
  __typename?: 'plot_crop_milestone_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_milestone_id?: Maybe<Scalars['Int']>;
  crop_year_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "plot_crop_milestone" */
export enum Plot_Crop_Milestone_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropMilestoneId = 'crop_milestone_id',
  /** column name */
  CropYearId = 'crop_year_id',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Plot_Crop_Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Milestone_Set_Input>;
  where: Plot_Crop_Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Milestone_Var_Pop_Fields = {
  __typename?: 'plot_crop_milestone_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Milestone_Var_Samp_Fields = {
  __typename?: 'plot_crop_milestone_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plot_Crop_Milestone_Variance_Fields = {
  __typename?: 'plot_crop_milestone_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_milestone_id?: Maybe<Scalars['Float']>;
  crop_year_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Plot_Crop_Min_Fields = {
  __typename?: 'plot_crop_min_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  estd_harvesting_date?: Maybe<Scalars['date']>;
  estd_sowing_date?: Maybe<Scalars['date']>;
  farmer_id?: Maybe<Scalars['Int']>;
  growing_cycle?: Maybe<Scalars['Int']>;
  harvest_quantity?: Maybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  harvesting_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  sowing_date?: Maybe<Scalars['date']>;
  status_id?: Maybe<Scalars['Int']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  user_preferred_name?: Maybe<Scalars['String']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "plot_crop" */
export type Plot_Crop_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  estd_harvesting_date?: InputMaybe<Order_By>;
  estd_sowing_date?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  harvesting_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  sowing_date?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_preferred_name?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop" */
export type Plot_Crop_Mutation_Response = {
  __typename?: 'plot_crop_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop>;
};

/** columns and relationships of "plot_crop_network" */
export type Plot_Crop_Network = {
  __typename?: 'plot_crop_network';
  codename: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "plot_crop_network" */
export type Plot_Crop_Network_Aggregate = {
  __typename?: 'plot_crop_network_aggregate';
  aggregate?: Maybe<Plot_Crop_Network_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Network>;
};

/** aggregate fields of "plot_crop_network" */
export type Plot_Crop_Network_Aggregate_Fields = {
  __typename?: 'plot_crop_network_aggregate_fields';
  avg?: Maybe<Plot_Crop_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Network_Max_Fields>;
  min?: Maybe<Plot_Crop_Network_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Network_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Network_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Network_Variance_Fields>;
};


/** aggregate fields of "plot_crop_network" */
export type Plot_Crop_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_network" */
export type Plot_Crop_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Network_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Network_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_network" */
export type Plot_Crop_Network_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Network_Avg_Fields = {
  __typename?: 'plot_crop_network_avg_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_network". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Network_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Network_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_network" */
export enum Plot_Crop_Network_Constraint {
  /** unique or primary key constraint on columns "plot_crop_id", "network_id" */
  PlotCropNetworkNetworkIdPlotCropId_907e1999Uniq = 'plot_crop_network_network_id_plot_crop_id_907e1999_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotCropNetworkPkey = 'plot_crop_network_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_network" */
export type Plot_Crop_Network_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_network" */
export type Plot_Crop_Network_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Plot_Crop_Network_Max_Fields = {
  __typename?: 'plot_crop_network_max_fields';
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Network_Min_Fields = {
  __typename?: 'plot_crop_network_min_fields';
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_network" */
export type Plot_Crop_Network_Mutation_Response = {
  __typename?: 'plot_crop_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Network>;
};

/** on_conflict condition type for table "plot_crop_network" */
export type Plot_Crop_Network_On_Conflict = {
  constraint: Plot_Crop_Network_Constraint;
  update_columns?: Array<Plot_Crop_Network_Update_Column>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_network". */
export type Plot_Crop_Network_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_network */
export type Plot_Crop_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_network" */
export enum Plot_Crop_Network_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "plot_crop_network" */
export type Plot_Crop_Network_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Network_Stddev_Fields = {
  __typename?: 'plot_crop_network_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Network_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_network_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Network_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_network_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_network" */
export type Plot_Crop_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Network_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Network_Sum_Fields = {
  __typename?: 'plot_crop_network_sum_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_network" */
export enum Plot_Crop_Network_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Plot_Crop_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Network_Set_Input>;
  where: Plot_Crop_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Network_Var_Pop_Fields = {
  __typename?: 'plot_crop_network_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Network_Var_Samp_Fields = {
  __typename?: 'plot_crop_network_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Network_Variance_Fields = {
  __typename?: 'plot_crop_network_variance_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_network" */
export type Plot_Crop_Network_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "plot_crop" */
export type Plot_Crop_Obj_Rel_Insert_Input = {
  data: Plot_Crop_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_On_Conflict>;
};

/** on_conflict condition type for table "plot_crop" */
export type Plot_Crop_On_Conflict = {
  constraint: Plot_Crop_Constraint;
  update_columns?: Array<Plot_Crop_Update_Column>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop". */
export type Plot_Crop_Order_By = {
  agents_aggregate?: InputMaybe<Plot_Crop_Agent_Aggregate_Order_By>;
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety?: InputMaybe<Crop_Variety_Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  cultivation_types_aggregate?: InputMaybe<Plot_Crop_Cultivation_Type_Aggregate_Order_By>;
  current_crop_year?: InputMaybe<Crop_Year_Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit?: InputMaybe<Si_Unit_Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  estd_harvesting_date?: InputMaybe<Order_By>;
  estd_sowing_date?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit?: InputMaybe<Si_Unit_Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  harvesting_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_seed?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Plot_Crop_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit?: InputMaybe<Si_Unit_Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot?: InputMaybe<Plot_Order_By>;
  plot_crop_historic_seasons_aggregate?: InputMaybe<Plot_Crop_Historic_Season_Aggregate_Order_By>;
  plot_id?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit?: InputMaybe<Si_Unit_Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  rootstocks_aggregate?: InputMaybe<Plot_Crop_Rootstock_Aggregate_Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  sowing_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Plot_Status_Order_By>;
  status_histories_aggregate?: InputMaybe<Plot_Crop_Status_History_Aggregate_Order_By>;
  status_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_preferred_name?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop */
export type Plot_Crop_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Plot_Crop_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "plot_crop_rootstock" */
export type Plot_Crop_Rootstock = {
  __typename?: 'plot_crop_rootstock';
  /** An object relationship */
  crop_rootstock: Crop_Rootstock;
  crop_rootstock_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  plot_crop: Plot_Crop;
  plot_crop_id: Scalars['Int'];
};

/** aggregated selection of "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Aggregate = {
  __typename?: 'plot_crop_rootstock_aggregate';
  aggregate?: Maybe<Plot_Crop_Rootstock_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Rootstock>;
};

/** aggregate fields of "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Aggregate_Fields = {
  __typename?: 'plot_crop_rootstock_aggregate_fields';
  avg?: Maybe<Plot_Crop_Rootstock_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Rootstock_Max_Fields>;
  min?: Maybe<Plot_Crop_Rootstock_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Rootstock_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Rootstock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Rootstock_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Rootstock_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Rootstock_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Rootstock_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Rootstock_Variance_Fields>;
};


/** aggregate fields of "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Rootstock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Rootstock_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Rootstock_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Rootstock_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Rootstock_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Rootstock_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Rootstock_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Rootstock_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Rootstock_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Rootstock_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Rootstock_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Rootstock_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Rootstock_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Rootstock_Avg_Fields = {
  __typename?: 'plot_crop_rootstock_avg_fields';
  crop_rootstock_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Avg_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_rootstock". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Rootstock_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Rootstock_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Rootstock_Bool_Exp>>;
  crop_rootstock?: InputMaybe<Crop_Rootstock_Bool_Exp>;
  crop_rootstock_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  plot_crop?: InputMaybe<Plot_Crop_Bool_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_rootstock" */
export enum Plot_Crop_Rootstock_Constraint {
  /** unique or primary key constraint on columns "crop_rootstock_id", "plot_crop_id" */
  PlotCropRootstockCropRootstockIdPlotCCb18795fUniq = 'plot_crop_rootstock_crop_rootstock_id_plot_c_cb18795f_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotCropRootstockPkey = 'plot_crop_rootstock_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Inc_Input = {
  crop_rootstock_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Insert_Input = {
  crop_rootstock?: InputMaybe<Crop_Rootstock_Obj_Rel_Insert_Input>;
  crop_rootstock_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Rootstock_Max_Fields = {
  __typename?: 'plot_crop_rootstock_max_fields';
  crop_rootstock_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Max_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Rootstock_Min_Fields = {
  __typename?: 'plot_crop_rootstock_min_fields';
  crop_rootstock_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Min_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Mutation_Response = {
  __typename?: 'plot_crop_rootstock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Rootstock>;
};

/** on_conflict condition type for table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_On_Conflict = {
  constraint: Plot_Crop_Rootstock_Constraint;
  update_columns?: Array<Plot_Crop_Rootstock_Update_Column>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_rootstock". */
export type Plot_Crop_Rootstock_Order_By = {
  crop_rootstock?: InputMaybe<Crop_Rootstock_Order_By>;
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Plot_Crop_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_rootstock */
export type Plot_Crop_Rootstock_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_rootstock" */
export enum Plot_Crop_Rootstock_Select_Column {
  /** column name */
  CropRootstockId = 'crop_rootstock_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

/** input type for updating data in table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Set_Input = {
  crop_rootstock_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Rootstock_Stddev_Fields = {
  __typename?: 'plot_crop_rootstock_stddev_fields';
  crop_rootstock_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Stddev_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Rootstock_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_rootstock_stddev_pop_fields';
  crop_rootstock_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Stddev_Pop_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Rootstock_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_rootstock_stddev_samp_fields';
  crop_rootstock_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Stddev_Samp_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Rootstock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Rootstock_Stream_Cursor_Value_Input = {
  crop_rootstock_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Rootstock_Sum_Fields = {
  __typename?: 'plot_crop_rootstock_sum_fields';
  crop_rootstock_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Sum_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_rootstock" */
export enum Plot_Crop_Rootstock_Update_Column {
  /** column name */
  CropRootstockId = 'crop_rootstock_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  PlotCropId = 'plot_crop_id'
}

export type Plot_Crop_Rootstock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Rootstock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Rootstock_Set_Input>;
  where: Plot_Crop_Rootstock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Rootstock_Var_Pop_Fields = {
  __typename?: 'plot_crop_rootstock_var_pop_fields';
  crop_rootstock_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Var_Pop_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Rootstock_Var_Samp_Fields = {
  __typename?: 'plot_crop_rootstock_var_samp_fields';
  crop_rootstock_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Var_Samp_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Rootstock_Variance_Fields = {
  __typename?: 'plot_crop_rootstock_variance_fields';
  crop_rootstock_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_rootstock" */
export type Plot_Crop_Rootstock_Variance_Order_By = {
  crop_rootstock_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
};

/** select columns of table "plot_crop" */
export enum Plot_Crop_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  CurrentCropYearId = 'current_crop_year_id',
  /** column name */
  Description = 'description',
  /** column name */
  EstdHarvestQuantity = 'estd_harvest_quantity',
  /** column name */
  EstdHarvestQuantityUnitId = 'estd_harvest_quantity_unit_id',
  /** column name */
  EstdHarvestingDate = 'estd_harvesting_date',
  /** column name */
  EstdSowingDate = 'estd_sowing_date',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GrowingCycle = 'growing_cycle',
  /** column name */
  HarvestQuantity = 'harvest_quantity',
  /** column name */
  HarvestQuantityUnitId = 'harvest_quantity_unit_id',
  /** column name */
  HarvestingDate = 'harvesting_date',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsSeed = 'is_seed',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  P2pDistance = 'p2p_distance',
  /** column name */
  P2pDistanceUnitId = 'p2p_distance_unit_id',
  /** column name */
  PlantCount = 'plant_count',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  R2rDistance = 'r2r_distance',
  /** column name */
  R2rDistanceUnitId = 'r2r_distance_unit_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SowingDate = 'sowing_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserPreferredName = 'user_preferred_name',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "plot_crop" */
export type Plot_Crop_Set_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  estd_harvesting_date?: InputMaybe<Scalars['date']>;
  estd_sowing_date?: InputMaybe<Scalars['date']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  harvesting_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_seed?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  sowing_date?: InputMaybe<Scalars['date']>;
  status_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  user_preferred_name?: InputMaybe<Scalars['String']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "plot_crop_status_history" */
export type Plot_Crop_Status_History = {
  __typename?: 'plot_crop_status_history';
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  crop_year?: Maybe<Crop_Year>;
  id: Scalars['Int'];
  plot_crop_id: Scalars['Int'];
  /** An object relationship */
  plot_status: Plot_Status;
  /** An object relationship */
  season: Plot_Crop;
  season_id?: Maybe<Scalars['Int']>;
  status_id: Scalars['Int'];
};

/** aggregated selection of "plot_crop_status_history" */
export type Plot_Crop_Status_History_Aggregate = {
  __typename?: 'plot_crop_status_history_aggregate';
  aggregate?: Maybe<Plot_Crop_Status_History_Aggregate_Fields>;
  nodes: Array<Plot_Crop_Status_History>;
};

/** aggregate fields of "plot_crop_status_history" */
export type Plot_Crop_Status_History_Aggregate_Fields = {
  __typename?: 'plot_crop_status_history_aggregate_fields';
  avg?: Maybe<Plot_Crop_Status_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Crop_Status_History_Max_Fields>;
  min?: Maybe<Plot_Crop_Status_History_Min_Fields>;
  stddev?: Maybe<Plot_Crop_Status_History_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Crop_Status_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Crop_Status_History_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Crop_Status_History_Sum_Fields>;
  var_pop?: Maybe<Plot_Crop_Status_History_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Crop_Status_History_Var_Samp_Fields>;
  variance?: Maybe<Plot_Crop_Status_History_Variance_Fields>;
};


/** aggregate fields of "plot_crop_status_history" */
export type Plot_Crop_Status_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Crop_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Crop_Status_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Crop_Status_History_Max_Order_By>;
  min?: InputMaybe<Plot_Crop_Status_History_Min_Order_By>;
  stddev?: InputMaybe<Plot_Crop_Status_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Crop_Status_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Crop_Status_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Crop_Status_History_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Crop_Status_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Crop_Status_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Crop_Status_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Arr_Rel_Insert_Input = {
  data: Array<Plot_Crop_Status_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Crop_Status_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Crop_Status_History_Avg_Fields = {
  __typename?: 'plot_crop_status_history_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  season_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_crop_status_history". All fields are combined with a logical 'AND'. */
export type Plot_Crop_Status_History_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Crop_Status_History_Bool_Exp>>;
  _not?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Crop_Status_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  crop_year?: InputMaybe<Crop_Year_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  plot_crop_id?: InputMaybe<Int_Comparison_Exp>;
  plot_status?: InputMaybe<Plot_Status_Bool_Exp>;
  season?: InputMaybe<Plot_Crop_Bool_Exp>;
  season_id?: InputMaybe<Int_Comparison_Exp>;
  status_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_crop_status_history" */
export enum Plot_Crop_Status_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlotCropStatusHistoryPkey = 'plot_crop_status_history_pkey'
}

/** input type for incrementing numeric columns in table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  season_id?: InputMaybe<Scalars['Int']>;
  status_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Crop_Year_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  plot_status?: InputMaybe<Plot_Status_Obj_Rel_Insert_Input>;
  season?: InputMaybe<Plot_Crop_Obj_Rel_Insert_Input>;
  season_id?: InputMaybe<Scalars['Int']>;
  status_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Crop_Status_History_Max_Fields = {
  __typename?: 'plot_crop_status_history_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  season_id?: Maybe<Scalars['Int']>;
  status_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Crop_Status_History_Min_Fields = {
  __typename?: 'plot_crop_status_history_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  season_id?: Maybe<Scalars['Int']>;
  status_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Mutation_Response = {
  __typename?: 'plot_crop_status_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Crop_Status_History>;
};

/** on_conflict condition type for table "plot_crop_status_history" */
export type Plot_Crop_Status_History_On_Conflict = {
  constraint: Plot_Crop_Status_History_Constraint;
  update_columns?: Array<Plot_Crop_Status_History_Update_Column>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_crop_status_history". */
export type Plot_Crop_Status_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Crop_Year_Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  plot_status?: InputMaybe<Plot_Status_Order_By>;
  season?: InputMaybe<Plot_Crop_Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_crop_status_history */
export type Plot_Crop_Status_History_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_crop_status_history" */
export enum Plot_Crop_Status_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  SeasonId = 'season_id',
  /** column name */
  StatusId = 'status_id'
}

/** input type for updating data in table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  season_id?: InputMaybe<Scalars['Int']>;
  status_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Status_History_Stddev_Fields = {
  __typename?: 'plot_crop_status_history_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  season_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Status_History_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_status_history_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  season_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Status_History_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_status_history_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  season_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Status_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Status_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
  season_id?: InputMaybe<Scalars['Int']>;
  status_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Status_History_Sum_Fields = {
  __typename?: 'plot_crop_status_history_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  plot_crop_id?: Maybe<Scalars['Int']>;
  season_id?: Maybe<Scalars['Int']>;
  status_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop_status_history" */
export enum Plot_Crop_Status_History_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  SeasonId = 'season_id',
  /** column name */
  StatusId = 'status_id'
}

export type Plot_Crop_Status_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Status_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Status_History_Set_Input>;
  where: Plot_Crop_Status_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Status_History_Var_Pop_Fields = {
  __typename?: 'plot_crop_status_history_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  season_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Status_History_Var_Samp_Fields = {
  __typename?: 'plot_crop_status_history_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  season_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Status_History_Variance_Fields = {
  __typename?: 'plot_crop_status_history_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  season_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop_status_history" */
export type Plot_Crop_Status_History_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  season_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Plot_Crop_Stddev_Fields = {
  __typename?: 'plot_crop_stddev_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_crop" */
export type Plot_Crop_Stddev_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Crop_Stddev_Pop_Fields = {
  __typename?: 'plot_crop_stddev_pop_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_crop" */
export type Plot_Crop_Stddev_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Crop_Stddev_Samp_Fields = {
  __typename?: 'plot_crop_stddev_samp_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_crop" */
export type Plot_Crop_Stddev_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_crop" */
export type Plot_Crop_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Crop_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Crop_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  crop_variety_id?: InputMaybe<Scalars['Int']>;
  crop_year?: InputMaybe<Scalars['Int']>;
  current_crop_year_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  estd_harvest_quantity?: InputMaybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  estd_harvesting_date?: InputMaybe<Scalars['date']>;
  estd_sowing_date?: InputMaybe<Scalars['date']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  growing_cycle?: InputMaybe<Scalars['Int']>;
  harvest_quantity?: InputMaybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: InputMaybe<Scalars['Int']>;
  harvesting_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_seed?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  p2p_distance?: InputMaybe<Scalars['numeric']>;
  p2p_distance_unit_id?: InputMaybe<Scalars['Int']>;
  plant_count?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  r2r_distance?: InputMaybe<Scalars['numeric']>;
  r2r_distance_unit_id?: InputMaybe<Scalars['Int']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  sowing_date?: InputMaybe<Scalars['date']>;
  status_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  user_preferred_name?: InputMaybe<Scalars['String']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Plot_Crop_Sum_Fields = {
  __typename?: 'plot_crop_sum_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  crop_id?: Maybe<Scalars['Int']>;
  crop_variety_id?: Maybe<Scalars['Int']>;
  crop_year?: Maybe<Scalars['Int']>;
  current_crop_year_id?: Maybe<Scalars['Int']>;
  estd_harvest_quantity?: Maybe<Scalars['numeric']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  growing_cycle?: Maybe<Scalars['Int']>;
  harvest_quantity?: Maybe<Scalars['numeric']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  p2p_distance?: Maybe<Scalars['numeric']>;
  p2p_distance_unit_id?: Maybe<Scalars['Int']>;
  plant_count?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
  r2r_distance?: Maybe<Scalars['numeric']>;
  r2r_distance_unit_id?: Maybe<Scalars['Int']>;
  status_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_crop" */
export type Plot_Crop_Sum_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_crop" */
export enum Plot_Crop_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  CropVarietyId = 'crop_variety_id',
  /** column name */
  CropYear = 'crop_year',
  /** column name */
  CurrentCropYearId = 'current_crop_year_id',
  /** column name */
  Description = 'description',
  /** column name */
  EstdHarvestQuantity = 'estd_harvest_quantity',
  /** column name */
  EstdHarvestQuantityUnitId = 'estd_harvest_quantity_unit_id',
  /** column name */
  EstdHarvestingDate = 'estd_harvesting_date',
  /** column name */
  EstdSowingDate = 'estd_sowing_date',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  GrowingCycle = 'growing_cycle',
  /** column name */
  HarvestQuantity = 'harvest_quantity',
  /** column name */
  HarvestQuantityUnitId = 'harvest_quantity_unit_id',
  /** column name */
  HarvestingDate = 'harvesting_date',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsSeed = 'is_seed',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  P2pDistance = 'p2p_distance',
  /** column name */
  P2pDistanceUnitId = 'p2p_distance_unit_id',
  /** column name */
  PlantCount = 'plant_count',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  R2rDistance = 'r2r_distance',
  /** column name */
  R2rDistanceUnitId = 'r2r_distance_unit_id',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SowingDate = 'sowing_date',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserPreferredName = 'user_preferred_name',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Plot_Crop_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Plot_Crop_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Plot_Crop_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Plot_Crop_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Plot_Crop_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Crop_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Plot_Crop_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Crop_Set_Input>;
  where: Plot_Crop_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Crop_Var_Pop_Fields = {
  __typename?: 'plot_crop_var_pop_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_crop" */
export type Plot_Crop_Var_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Crop_Var_Samp_Fields = {
  __typename?: 'plot_crop_var_samp_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_crop" */
export type Plot_Crop_Var_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Crop_Variance_Fields = {
  __typename?: 'plot_crop_variance_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  crop_id?: Maybe<Scalars['Float']>;
  crop_variety_id?: Maybe<Scalars['Float']>;
  crop_year?: Maybe<Scalars['Float']>;
  current_crop_year_id?: Maybe<Scalars['Float']>;
  estd_harvest_quantity?: Maybe<Scalars['Float']>;
  estd_harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  growing_cycle?: Maybe<Scalars['Float']>;
  harvest_quantity?: Maybe<Scalars['Float']>;
  harvest_quantity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  p2p_distance?: Maybe<Scalars['Float']>;
  p2p_distance_unit_id?: Maybe<Scalars['Float']>;
  plant_count?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
  r2r_distance?: Maybe<Scalars['Float']>;
  r2r_distance_unit_id?: Maybe<Scalars['Float']>;
  status_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_crop" */
export type Plot_Crop_Variance_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crop_id?: InputMaybe<Order_By>;
  crop_variety_id?: InputMaybe<Order_By>;
  crop_year?: InputMaybe<Order_By>;
  current_crop_year_id?: InputMaybe<Order_By>;
  estd_harvest_quantity?: InputMaybe<Order_By>;
  estd_harvest_quantity_unit_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  growing_cycle?: InputMaybe<Order_By>;
  harvest_quantity?: InputMaybe<Order_By>;
  harvest_quantity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  p2p_distance?: InputMaybe<Order_By>;
  p2p_distance_unit_id?: InputMaybe<Order_By>;
  plant_count?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  r2r_distance?: InputMaybe<Order_By>;
  r2r_distance_unit_id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Plot_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Plot_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Plot_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "plot" */
export type Plot_Inc_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot" */
export type Plot_Insert_Input = {
  agreement_plots?: InputMaybe<Agreement_Plot_Arr_Rel_Insert_Input>;
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  centroid?: InputMaybe<Scalars['geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  crops?: InputMaybe<Plot_Crop_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Field_Obj_Rel_Insert_Input>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  networks?: InputMaybe<Plot_Network_Arr_Rel_Insert_Input>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Plot_Max_Fields = {
  __typename?: 'plot_max_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  field_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "plot" */
export type Plot_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Min_Fields = {
  __typename?: 'plot_min_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  farmer_id?: Maybe<Scalars['Int']>;
  field_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  send_for_verification_remark?: Maybe<Scalars['String']>;
  send_for_verification_status?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verification_done_on?: Maybe<Scalars['timestamptz']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "plot" */
export type Plot_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot" */
export type Plot_Mutation_Response = {
  __typename?: 'plot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot>;
};

/** columns and relationships of "plot_network" */
export type Plot_Network = {
  __typename?: 'plot_network';
  codename: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  network: Network;
  network_id: Scalars['Int'];
  /** An object relationship */
  plot: Plot;
  plot_id: Scalars['Int'];
  system_verified: Scalars['Boolean'];
};

/** aggregated selection of "plot_network" */
export type Plot_Network_Aggregate = {
  __typename?: 'plot_network_aggregate';
  aggregate?: Maybe<Plot_Network_Aggregate_Fields>;
  nodes: Array<Plot_Network>;
};

/** aggregate fields of "plot_network" */
export type Plot_Network_Aggregate_Fields = {
  __typename?: 'plot_network_aggregate_fields';
  avg?: Maybe<Plot_Network_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Network_Max_Fields>;
  min?: Maybe<Plot_Network_Min_Fields>;
  stddev?: Maybe<Plot_Network_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Network_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Network_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Network_Sum_Fields>;
  var_pop?: Maybe<Plot_Network_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Network_Var_Samp_Fields>;
  variance?: Maybe<Plot_Network_Variance_Fields>;
};


/** aggregate fields of "plot_network" */
export type Plot_Network_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Network_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_network" */
export type Plot_Network_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Network_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Network_Max_Order_By>;
  min?: InputMaybe<Plot_Network_Min_Order_By>;
  stddev?: InputMaybe<Plot_Network_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Network_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Network_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Network_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Network_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Network_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Network_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_network" */
export type Plot_Network_Arr_Rel_Insert_Input = {
  data: Array<Plot_Network_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Network_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Network_Avg_Fields = {
  __typename?: 'plot_network_avg_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_network" */
export type Plot_Network_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_network". All fields are combined with a logical 'AND'. */
export type Plot_Network_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Network_Bool_Exp>>;
  _not?: InputMaybe<Plot_Network_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Network_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  network?: InputMaybe<Network_Bool_Exp>;
  network_id?: InputMaybe<Int_Comparison_Exp>;
  plot?: InputMaybe<Plot_Bool_Exp>;
  plot_id?: InputMaybe<Int_Comparison_Exp>;
  system_verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_network" */
export enum Plot_Network_Constraint {
  /** unique or primary key constraint on columns "plot_id", "network_id" */
  PlotNetworkNetworkIdPlotIdEfce5249Uniq = 'plot_network_network_id_plot_id_efce5249_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotNetworkPkey = 'plot_network_pkey'
}

/** input type for incrementing numeric columns in table "plot_network" */
export type Plot_Network_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_network" */
export type Plot_Network_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network?: InputMaybe<Network_Obj_Rel_Insert_Input>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot?: InputMaybe<Plot_Obj_Rel_Insert_Input>;
  plot_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Plot_Network_Max_Fields = {
  __typename?: 'plot_network_max_fields';
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_network" */
export type Plot_Network_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Network_Min_Fields = {
  __typename?: 'plot_network_min_fields';
  codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_network" */
export type Plot_Network_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_network" */
export type Plot_Network_Mutation_Response = {
  __typename?: 'plot_network_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Network>;
};

/** on_conflict condition type for table "plot_network" */
export type Plot_Network_On_Conflict = {
  constraint: Plot_Network_Constraint;
  update_columns?: Array<Plot_Network_Update_Column>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_network". */
export type Plot_Network_Order_By = {
  codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  network?: InputMaybe<Network_Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot?: InputMaybe<Plot_Order_By>;
  plot_id?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_network */
export type Plot_Network_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_network" */
export enum Plot_Network_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  SystemVerified = 'system_verified'
}

/** input type for updating data in table "plot_network" */
export type Plot_Network_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Plot_Network_Stddev_Fields = {
  __typename?: 'plot_network_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_network" */
export type Plot_Network_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Network_Stddev_Pop_Fields = {
  __typename?: 'plot_network_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_network" */
export type Plot_Network_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Network_Stddev_Samp_Fields = {
  __typename?: 'plot_network_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_network" */
export type Plot_Network_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_network" */
export type Plot_Network_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Network_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Network_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  network_id?: InputMaybe<Scalars['Int']>;
  plot_id?: InputMaybe<Scalars['Int']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Plot_Network_Sum_Fields = {
  __typename?: 'plot_network_sum_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  plot_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_network" */
export type Plot_Network_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_network" */
export enum Plot_Network_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  SystemVerified = 'system_verified'
}

export type Plot_Network_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Network_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Network_Set_Input>;
  where: Plot_Network_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Network_Var_Pop_Fields = {
  __typename?: 'plot_network_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_network" */
export type Plot_Network_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Network_Var_Samp_Fields = {
  __typename?: 'plot_network_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_network" */
export type Plot_Network_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Network_Variance_Fields = {
  __typename?: 'plot_network_variance_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  plot_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_network" */
export type Plot_Network_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  network_id?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "plot" */
export type Plot_Obj_Rel_Insert_Input = {
  data: Plot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_On_Conflict>;
};

/** on_conflict condition type for table "plot" */
export type Plot_On_Conflict = {
  constraint: Plot_Constraint;
  update_columns?: Array<Plot_Update_Column>;
  where?: InputMaybe<Plot_Bool_Exp>;
};

/** Ordering options when selecting data from "plot". */
export type Plot_Order_By = {
  agreement_plots_aggregate?: InputMaybe<Agreement_Plot_Aggregate_Order_By>;
  area?: InputMaybe<Order_By>;
  area_catered?: InputMaybe<Order_By>;
  area_unit?: InputMaybe<Si_Unit_Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  centroid?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in?: InputMaybe<Department_Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  crops_aggregate?: InputMaybe<Plot_Crop_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Field_Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  networks_aggregate?: InputMaybe<Plot_Network_Aggregate_Order_By>;
  notes?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  send_for_verification_remark?: InputMaybe<Order_By>;
  send_for_verification_status?: InputMaybe<Order_By>;
  system_verified?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by?: InputMaybe<Base_User_Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verification_done_on?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot */
export type Plot_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Plot_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "plot" */
export enum Plot_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** input type for updating data in table "plot" */
export type Plot_Set_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  centroid?: InputMaybe<Scalars['geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "plot_status" */
export type Plot_Status = {
  __typename?: 'plot_status';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  plot_status_configs: Array<Plot_Status_Config>;
  /** An aggregate relationship */
  plot_status_configs_aggregate: Plot_Status_Config_Aggregate;
  private_metadata: Scalars['jsonb'];
  purpose?: Maybe<Scalars['String']>;
};


/** columns and relationships of "plot_status" */
export type Plot_StatusMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "plot_status" */
export type Plot_StatusPlot_Status_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};


/** columns and relationships of "plot_status" */
export type Plot_StatusPlot_Status_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};


/** columns and relationships of "plot_status" */
export type Plot_StatusPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "plot_status" */
export type Plot_Status_Aggregate = {
  __typename?: 'plot_status_aggregate';
  aggregate?: Maybe<Plot_Status_Aggregate_Fields>;
  nodes: Array<Plot_Status>;
};

/** aggregate fields of "plot_status" */
export type Plot_Status_Aggregate_Fields = {
  __typename?: 'plot_status_aggregate_fields';
  avg?: Maybe<Plot_Status_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Status_Max_Fields>;
  min?: Maybe<Plot_Status_Min_Fields>;
  stddev?: Maybe<Plot_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Status_Sum_Fields>;
  var_pop?: Maybe<Plot_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Status_Var_Samp_Fields>;
  variance?: Maybe<Plot_Status_Variance_Fields>;
};


/** aggregate fields of "plot_status" */
export type Plot_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Plot_Status_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Plot_Status_Avg_Fields = {
  __typename?: 'plot_status_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "plot_status". All fields are combined with a logical 'AND'. */
export type Plot_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Status_Bool_Exp>>;
  _not?: InputMaybe<Plot_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Status_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  plot_status_configs?: InputMaybe<Plot_Status_Config_Bool_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  purpose?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "plot_status_config" */
export type Plot_Status_Config = {
  __typename?: 'plot_status_config';
  id: Scalars['Int'];
  /** An object relationship */
  organisation: Organisation;
  organisation_id: Scalars['Int'];
  /** An object relationship */
  plot_status: Plot_Status;
  plot_status_id: Scalars['Int'];
  /** An array relationship */
  required_qc_stages: Array<Plot_Status_Config_Required_Qc_Stages>;
  /** An aggregate relationship */
  required_qc_stages_aggregate: Plot_Status_Config_Required_Qc_Stages_Aggregate;
  sequence_no: Scalars['Int'];
};


/** columns and relationships of "plot_status_config" */
export type Plot_Status_ConfigRequired_Qc_StagesArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};


/** columns and relationships of "plot_status_config" */
export type Plot_Status_ConfigRequired_Qc_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};

/** aggregated selection of "plot_status_config" */
export type Plot_Status_Config_Aggregate = {
  __typename?: 'plot_status_config_aggregate';
  aggregate?: Maybe<Plot_Status_Config_Aggregate_Fields>;
  nodes: Array<Plot_Status_Config>;
};

/** aggregate fields of "plot_status_config" */
export type Plot_Status_Config_Aggregate_Fields = {
  __typename?: 'plot_status_config_aggregate_fields';
  avg?: Maybe<Plot_Status_Config_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Status_Config_Max_Fields>;
  min?: Maybe<Plot_Status_Config_Min_Fields>;
  stddev?: Maybe<Plot_Status_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Status_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Status_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Status_Config_Sum_Fields>;
  var_pop?: Maybe<Plot_Status_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Status_Config_Var_Samp_Fields>;
  variance?: Maybe<Plot_Status_Config_Variance_Fields>;
};


/** aggregate fields of "plot_status_config" */
export type Plot_Status_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Status_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_status_config" */
export type Plot_Status_Config_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Status_Config_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Status_Config_Max_Order_By>;
  min?: InputMaybe<Plot_Status_Config_Min_Order_By>;
  stddev?: InputMaybe<Plot_Status_Config_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Status_Config_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Status_Config_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Status_Config_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Status_Config_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Status_Config_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Status_Config_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_status_config" */
export type Plot_Status_Config_Arr_Rel_Insert_Input = {
  data: Array<Plot_Status_Config_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Status_Config_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Status_Config_Avg_Fields = {
  __typename?: 'plot_status_config_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  plot_status_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_status_config" */
export type Plot_Status_Config_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_status_config". All fields are combined with a logical 'AND'. */
export type Plot_Status_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Status_Config_Bool_Exp>>;
  _not?: InputMaybe<Plot_Status_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Status_Config_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisation_Bool_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  plot_status?: InputMaybe<Plot_Status_Bool_Exp>;
  plot_status_id?: InputMaybe<Int_Comparison_Exp>;
  required_qc_stages?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
  sequence_no?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_status_config" */
export enum Plot_Status_Config_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "plot_status_id" */
  PlotStatusConfigOrganisationIdPlotStatusId_5dfaab70Uniq = 'plot_status_config_organisation_id_plot_status_id_5dfaab70_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotStatusConfigPkey = 'plot_status_config_pkey'
}

/** input type for incrementing numeric columns in table "plot_status_config" */
export type Plot_Status_Config_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_status_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_status_config" */
export type Plot_Status_Config_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation?: InputMaybe<Organisation_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_status?: InputMaybe<Plot_Status_Obj_Rel_Insert_Input>;
  plot_status_id?: InputMaybe<Scalars['Int']>;
  required_qc_stages?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Arr_Rel_Insert_Input>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Status_Config_Max_Fields = {
  __typename?: 'plot_status_config_max_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  plot_status_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_status_config" */
export type Plot_Status_Config_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Status_Config_Min_Fields = {
  __typename?: 'plot_status_config_min_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  plot_status_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_status_config" */
export type Plot_Status_Config_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_status_config" */
export type Plot_Status_Config_Mutation_Response = {
  __typename?: 'plot_status_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Status_Config>;
};

/** on_conflict condition type for table "plot_status_config" */
export type Plot_Status_Config_On_Conflict = {
  constraint: Plot_Status_Config_Constraint;
  update_columns?: Array<Plot_Status_Config_Update_Column>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_status_config". */
export type Plot_Status_Config_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisation_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status?: InputMaybe<Plot_Status_Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  required_qc_stages_aggregate?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Aggregate_Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_status_config */
export type Plot_Status_Config_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages = {
  __typename?: 'plot_status_config_required_qc_stages';
  id: Scalars['Int'];
  plotstatusconfig_id: Scalars['Int'];
  /** An object relationship */
  quality_stage: Kite_Quality_Stage;
  qualitystage_id: Scalars['Int'];
};

/** aggregated selection of "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Aggregate = {
  __typename?: 'plot_status_config_required_qc_stages_aggregate';
  aggregate?: Maybe<Plot_Status_Config_Required_Qc_Stages_Aggregate_Fields>;
  nodes: Array<Plot_Status_Config_Required_Qc_Stages>;
};

/** aggregate fields of "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Aggregate_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_aggregate_fields';
  avg?: Maybe<Plot_Status_Config_Required_Qc_Stages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Plot_Status_Config_Required_Qc_Stages_Max_Fields>;
  min?: Maybe<Plot_Status_Config_Required_Qc_Stages_Min_Fields>;
  stddev?: Maybe<Plot_Status_Config_Required_Qc_Stages_Stddev_Fields>;
  stddev_pop?: Maybe<Plot_Status_Config_Required_Qc_Stages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Plot_Status_Config_Required_Qc_Stages_Stddev_Samp_Fields>;
  sum?: Maybe<Plot_Status_Config_Required_Qc_Stages_Sum_Fields>;
  var_pop?: Maybe<Plot_Status_Config_Required_Qc_Stages_Var_Pop_Fields>;
  var_samp?: Maybe<Plot_Status_Config_Required_Qc_Stages_Var_Samp_Fields>;
  variance?: Maybe<Plot_Status_Config_Required_Qc_Stages_Variance_Fields>;
};


/** aggregate fields of "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Aggregate_Order_By = {
  avg?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Max_Order_By>;
  min?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Min_Order_By>;
  stddev?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Sum_Order_By>;
  var_pop?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Var_Samp_Order_By>;
  variance?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Arr_Rel_Insert_Input = {
  data: Array<Plot_Status_Config_Required_Qc_Stages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_On_Conflict>;
};

/** aggregate avg on columns */
export type Plot_Status_Config_Required_Qc_Stages_Avg_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_avg_fields';
  id?: Maybe<Scalars['Float']>;
  plotstatusconfig_id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "plot_status_config_required_qc_stages". All fields are combined with a logical 'AND'. */
export type Plot_Status_Config_Required_Qc_Stages_Bool_Exp = {
  _and?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>>;
  _not?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
  _or?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  plotstatusconfig_id?: InputMaybe<Int_Comparison_Exp>;
  quality_stage?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
  qualitystage_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "plot_status_config_required_qc_stages" */
export enum Plot_Status_Config_Required_Qc_Stages_Constraint {
  /** unique or primary key constraint on columns "qualitystage_id", "plotstatusconfig_id" */
  PlotStatusConfigRequiPlotstatusconfigIdQual_2fae36dfUniq = 'plot_status_config_requi_plotstatusconfig_id_qual_2fae36df_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotStatusConfigRequiredQcStagesPkey = 'plot_status_config_required_qc_stages_pkey'
}

/** input type for incrementing numeric columns in table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  plotstatusconfig_id?: InputMaybe<Scalars['Int']>;
  qualitystage_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  plotstatusconfig_id?: InputMaybe<Scalars['Int']>;
  quality_stage?: InputMaybe<Kite_Quality_Stage_Obj_Rel_Insert_Input>;
  qualitystage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Plot_Status_Config_Required_Qc_Stages_Max_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_max_fields';
  id?: Maybe<Scalars['Int']>;
  plotstatusconfig_id?: Maybe<Scalars['Int']>;
  qualitystage_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Plot_Status_Config_Required_Qc_Stages_Min_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_min_fields';
  id?: Maybe<Scalars['Int']>;
  plotstatusconfig_id?: Maybe<Scalars['Int']>;
  qualitystage_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Mutation_Response = {
  __typename?: 'plot_status_config_required_qc_stages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Status_Config_Required_Qc_Stages>;
};

/** on_conflict condition type for table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_On_Conflict = {
  constraint: Plot_Status_Config_Required_Qc_Stages_Constraint;
  update_columns?: Array<Plot_Status_Config_Required_Qc_Stages_Update_Column>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_status_config_required_qc_stages". */
export type Plot_Status_Config_Required_Qc_Stages_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  quality_stage?: InputMaybe<Kite_Quality_Stage_Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_status_config_required_qc_stages */
export type Plot_Status_Config_Required_Qc_Stages_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "plot_status_config_required_qc_stages" */
export enum Plot_Status_Config_Required_Qc_Stages_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PlotstatusconfigId = 'plotstatusconfig_id',
  /** column name */
  QualitystageId = 'qualitystage_id'
}

/** input type for updating data in table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  plotstatusconfig_id?: InputMaybe<Scalars['Int']>;
  qualitystage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Status_Config_Required_Qc_Stages_Stddev_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  plotstatusconfig_id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Status_Config_Required_Qc_Stages_Stddev_Pop_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  plotstatusconfig_id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Status_Config_Required_Qc_Stages_Stddev_Samp_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  plotstatusconfig_id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Status_Config_Required_Qc_Stages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Status_Config_Required_Qc_Stages_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  plotstatusconfig_id?: InputMaybe<Scalars['Int']>;
  qualitystage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Status_Config_Required_Qc_Stages_Sum_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_sum_fields';
  id?: Maybe<Scalars['Int']>;
  plotstatusconfig_id?: Maybe<Scalars['Int']>;
  qualitystage_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot_status_config_required_qc_stages" */
export enum Plot_Status_Config_Required_Qc_Stages_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PlotstatusconfigId = 'plotstatusconfig_id',
  /** column name */
  QualitystageId = 'qualitystage_id'
}

export type Plot_Status_Config_Required_Qc_Stages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Set_Input>;
  where: Plot_Status_Config_Required_Qc_Stages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Status_Config_Required_Qc_Stages_Var_Pop_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  plotstatusconfig_id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Status_Config_Required_Qc_Stages_Var_Samp_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  plotstatusconfig_id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Status_Config_Required_Qc_Stages_Variance_Fields = {
  __typename?: 'plot_status_config_required_qc_stages_variance_fields';
  id?: Maybe<Scalars['Float']>;
  plotstatusconfig_id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_status_config_required_qc_stages" */
export type Plot_Status_Config_Required_Qc_Stages_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  plotstatusconfig_id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
};

/** select columns of table "plot_status_config" */
export enum Plot_Status_Config_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PlotStatusId = 'plot_status_id',
  /** column name */
  SequenceNo = 'sequence_no'
}

/** input type for updating data in table "plot_status_config" */
export type Plot_Status_Config_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_status_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Plot_Status_Config_Stddev_Fields = {
  __typename?: 'plot_status_config_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  plot_status_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot_status_config" */
export type Plot_Status_Config_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Status_Config_Stddev_Pop_Fields = {
  __typename?: 'plot_status_config_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  plot_status_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot_status_config" */
export type Plot_Status_Config_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Status_Config_Stddev_Samp_Fields = {
  __typename?: 'plot_status_config_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  plot_status_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot_status_config" */
export type Plot_Status_Config_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot_status_config" */
export type Plot_Status_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Status_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Status_Config_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  plot_status_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Plot_Status_Config_Sum_Fields = {
  __typename?: 'plot_status_config_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  plot_status_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot_status_config" */
export type Plot_Status_Config_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** update columns of table "plot_status_config" */
export enum Plot_Status_Config_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  PlotStatusId = 'plot_status_id',
  /** column name */
  SequenceNo = 'sequence_no'
}

export type Plot_Status_Config_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Status_Config_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Status_Config_Set_Input>;
  where: Plot_Status_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Status_Config_Var_Pop_Fields = {
  __typename?: 'plot_status_config_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  plot_status_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot_status_config" */
export type Plot_Status_Config_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Status_Config_Var_Samp_Fields = {
  __typename?: 'plot_status_config_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  plot_status_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot_status_config" */
export type Plot_Status_Config_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Status_Config_Variance_Fields = {
  __typename?: 'plot_status_config_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  plot_status_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot_status_config" */
export type Plot_Status_Config_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  plot_status_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "plot_status" */
export enum Plot_Status_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PlotStatusCodenameKey = 'plot_status_codename_key',
  /** unique or primary key constraint on columns "name" */
  PlotStatusNameBc4ea916Uniq = 'plot_status_name_bc4ea916_uniq',
  /** unique or primary key constraint on columns "id" */
  PlotStatusPkey = 'plot_status_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Plot_Status_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Plot_Status_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Plot_Status_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "plot_status" */
export type Plot_Status_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "plot_status" */
export type Plot_Status_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  plot_status_configs?: InputMaybe<Plot_Status_Config_Arr_Rel_Insert_Input>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Plot_Status_Max_Fields = {
  __typename?: 'plot_status_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Plot_Status_Min_Fields = {
  __typename?: 'plot_status_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "plot_status" */
export type Plot_Status_Mutation_Response = {
  __typename?: 'plot_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Plot_Status>;
};

/** input type for inserting object relation for remote table "plot_status" */
export type Plot_Status_Obj_Rel_Insert_Input = {
  data: Plot_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plot_Status_On_Conflict>;
};

/** on_conflict condition type for table "plot_status" */
export type Plot_Status_On_Conflict = {
  constraint: Plot_Status_Constraint;
  update_columns?: Array<Plot_Status_Update_Column>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "plot_status". */
export type Plot_Status_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  plot_status_configs_aggregate?: InputMaybe<Plot_Status_Config_Aggregate_Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  purpose?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plot_status */
export type Plot_Status_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Plot_Status_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "plot_status" */
export enum Plot_Status_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Purpose = 'purpose'
}

/** input type for updating data in table "plot_status" */
export type Plot_Status_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Plot_Status_Stddev_Fields = {
  __typename?: 'plot_status_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Plot_Status_Stddev_Pop_Fields = {
  __typename?: 'plot_status_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Plot_Status_Stddev_Samp_Fields = {
  __typename?: 'plot_status_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "plot_status" */
export type Plot_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Status_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  purpose?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Plot_Status_Sum_Fields = {
  __typename?: 'plot_status_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "plot_status" */
export enum Plot_Status_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Purpose = 'purpose'
}

export type Plot_Status_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Plot_Status_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Plot_Status_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Plot_Status_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Plot_Status_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Status_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Plot_Status_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Status_Set_Input>;
  where: Plot_Status_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Status_Var_Pop_Fields = {
  __typename?: 'plot_status_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Plot_Status_Var_Samp_Fields = {
  __typename?: 'plot_status_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Plot_Status_Variance_Fields = {
  __typename?: 'plot_status_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Plot_Stddev_Fields = {
  __typename?: 'plot_stddev_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "plot" */
export type Plot_Stddev_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Plot_Stddev_Pop_Fields = {
  __typename?: 'plot_stddev_pop_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "plot" */
export type Plot_Stddev_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Plot_Stddev_Samp_Fields = {
  __typename?: 'plot_stddev_samp_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "plot" */
export type Plot_Stddev_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "plot" */
export type Plot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plot_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['numeric']>;
  area_catered?: InputMaybe<Scalars['geometry']>;
  area_unit_id?: InputMaybe<Scalars['Int']>;
  centroid?: InputMaybe<Scalars['geometry']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  field_id?: InputMaybe<Scalars['Int']>;
  geo_area_remark?: InputMaybe<Scalars['float8']>;
  geo_bound_area?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  send_for_verification_remark?: InputMaybe<Scalars['String']>;
  send_for_verification_status?: InputMaybe<Scalars['String']>;
  system_verified?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_by_id?: InputMaybe<Scalars['Int']>;
  verification_done_on?: InputMaybe<Scalars['timestamptz']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Plot_Sum_Fields = {
  __typename?: 'plot_sum_fields';
  area?: Maybe<Scalars['numeric']>;
  area_unit_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  field_id?: Maybe<Scalars['Int']>;
  geo_area_remark?: Maybe<Scalars['float8']>;
  geo_bound_area?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_done_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "plot" */
export type Plot_Sum_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "plot" */
export enum Plot_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  AreaCatered = 'area_catered',
  /** column name */
  AreaUnitId = 'area_unit_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  GeoAreaRemark = 'geo_area_remark',
  /** column name */
  GeoBoundArea = 'geo_bound_area',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  SendForVerificationRemark = 'send_for_verification_remark',
  /** column name */
  SendForVerificationStatus = 'send_for_verification_status',
  /** column name */
  SystemVerified = 'system_verified',
  /** column name */
  Tag = 'tag',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationDoneById = 'verification_done_by_id',
  /** column name */
  VerificationDoneOn = 'verification_done_on',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

export type Plot_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Plot_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Plot_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Plot_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Plot_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Plot_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Plot_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plot_Set_Input>;
  where: Plot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Plot_Var_Pop_Fields = {
  __typename?: 'plot_var_pop_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "plot" */
export type Plot_Var_Pop_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Plot_Var_Samp_Fields = {
  __typename?: 'plot_var_samp_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "plot" */
export type Plot_Var_Samp_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Plot_Variance_Fields = {
  __typename?: 'plot_variance_fields';
  area?: Maybe<Scalars['Float']>;
  area_unit_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  field_id?: Maybe<Scalars['Float']>;
  geo_area_remark?: Maybe<Scalars['Float']>;
  geo_bound_area?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verification_done_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "plot" */
export type Plot_Variance_Order_By = {
  area?: InputMaybe<Order_By>;
  area_unit_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  geo_area_remark?: InputMaybe<Order_By>;
  geo_bound_area?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_done_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "primary_growth_stage" */
export type Primary_Growth_Stage = {
  __typename?: 'primary_growth_stage';
  base_stage: Scalars['String'];
  code: Scalars['String'];
  codename: Scalars['String'];
  /** An object relationship */
  crop: Crop;
  crop_id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_days_after: Scalars['Int'];
  min_days_after: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  secondary_growth_stages: Array<Secondary_Growth_Stage>;
  /** An aggregate relationship */
  secondary_growth_stages_aggregate: Secondary_Growth_Stage_Aggregate;
};


/** columns and relationships of "primary_growth_stage" */
export type Primary_Growth_StageSecondary_Growth_StagesArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


/** columns and relationships of "primary_growth_stage" */
export type Primary_Growth_StageSecondary_Growth_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};

/** aggregated selection of "primary_growth_stage" */
export type Primary_Growth_Stage_Aggregate = {
  __typename?: 'primary_growth_stage_aggregate';
  aggregate?: Maybe<Primary_Growth_Stage_Aggregate_Fields>;
  nodes: Array<Primary_Growth_Stage>;
};

/** aggregate fields of "primary_growth_stage" */
export type Primary_Growth_Stage_Aggregate_Fields = {
  __typename?: 'primary_growth_stage_aggregate_fields';
  avg?: Maybe<Primary_Growth_Stage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Primary_Growth_Stage_Max_Fields>;
  min?: Maybe<Primary_Growth_Stage_Min_Fields>;
  stddev?: Maybe<Primary_Growth_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Primary_Growth_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Primary_Growth_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Primary_Growth_Stage_Sum_Fields>;
  var_pop?: Maybe<Primary_Growth_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Primary_Growth_Stage_Var_Samp_Fields>;
  variance?: Maybe<Primary_Growth_Stage_Variance_Fields>;
};


/** aggregate fields of "primary_growth_stage" */
export type Primary_Growth_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Primary_Growth_Stage_Avg_Fields = {
  __typename?: 'primary_growth_stage_avg_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "primary_growth_stage". All fields are combined with a logical 'AND'. */
export type Primary_Growth_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Primary_Growth_Stage_Bool_Exp>>;
  _not?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Primary_Growth_Stage_Bool_Exp>>;
  base_stage?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  crop?: InputMaybe<Crop_Bool_Exp>;
  crop_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_days_after?: InputMaybe<Int_Comparison_Exp>;
  min_days_after?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  secondary_growth_stages?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};

/** unique or primary key constraints on table "primary_growth_stage" */
export enum Primary_Growth_Stage_Constraint {
  /** unique or primary key constraint on columns "codename" */
  PrimaryGrowthStageCodenameKey = 'primary_growth_stage_codename_key',
  /** unique or primary key constraint on columns "crop_id", "code" */
  PrimaryGrowthStageCropIdCode_390ea762Uniq = 'primary_growth_stage_crop_id_code_390ea762_uniq',
  /** unique or primary key constraint on columns "id" */
  PrimaryGrowthStagePkey = 'primary_growth_stage_pkey'
}

/** input type for incrementing numeric columns in table "primary_growth_stage" */
export type Primary_Growth_Stage_Inc_Input = {
  crop_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "primary_growth_stage" */
export type Primary_Growth_Stage_Insert_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<Crop_Obj_Rel_Insert_Input>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  secondary_growth_stages?: InputMaybe<Secondary_Growth_Stage_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Primary_Growth_Stage_Max_Fields = {
  __typename?: 'primary_growth_stage_max_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Primary_Growth_Stage_Min_Fields = {
  __typename?: 'primary_growth_stage_min_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  crop_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "primary_growth_stage" */
export type Primary_Growth_Stage_Mutation_Response = {
  __typename?: 'primary_growth_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Primary_Growth_Stage>;
};

/** input type for inserting object relation for remote table "primary_growth_stage" */
export type Primary_Growth_Stage_Obj_Rel_Insert_Input = {
  data: Primary_Growth_Stage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Primary_Growth_Stage_On_Conflict>;
};

/** on_conflict condition type for table "primary_growth_stage" */
export type Primary_Growth_Stage_On_Conflict = {
  constraint: Primary_Growth_Stage_Constraint;
  update_columns?: Array<Primary_Growth_Stage_Update_Column>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "primary_growth_stage". */
export type Primary_Growth_Stage_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  crop?: InputMaybe<Crop_Order_By>;
  crop_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  secondary_growth_stages_aggregate?: InputMaybe<Secondary_Growth_Stage_Aggregate_Order_By>;
};

/** primary key columns input for table: primary_growth_stage */
export type Primary_Growth_Stage_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "primary_growth_stage" */
export enum Primary_Growth_Stage_Select_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

/** input type for updating data in table "primary_growth_stage" */
export type Primary_Growth_Stage_Set_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Primary_Growth_Stage_Stddev_Fields = {
  __typename?: 'primary_growth_stage_stddev_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Primary_Growth_Stage_Stddev_Pop_Fields = {
  __typename?: 'primary_growth_stage_stddev_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Primary_Growth_Stage_Stddev_Samp_Fields = {
  __typename?: 'primary_growth_stage_stddev_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "primary_growth_stage" */
export type Primary_Growth_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Primary_Growth_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Primary_Growth_Stage_Stream_Cursor_Value_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  crop_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Primary_Growth_Stage_Sum_Fields = {
  __typename?: 'primary_growth_stage_sum_fields';
  crop_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "primary_growth_stage" */
export enum Primary_Growth_Stage_Update_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  CropId = 'crop_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id'
}

export type Primary_Growth_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Primary_Growth_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Primary_Growth_Stage_Set_Input>;
  where: Primary_Growth_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Primary_Growth_Stage_Var_Pop_Fields = {
  __typename?: 'primary_growth_stage_var_pop_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Primary_Growth_Stage_Var_Samp_Fields = {
  __typename?: 'primary_growth_stage_var_samp_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Primary_Growth_Stage_Variance_Fields = {
  __typename?: 'primary_growth_stage_variance_fields';
  crop_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "production_trade" */
export type Production_Trade = {
  __typename?: 'production_trade';
  /** An array relationship */
  associated_trades: Array<Trade>;
  /** An aggregate relationship */
  associated_trades_aggregate: Trade_Aggregate;
  /** An object relationship */
  buyer?: Maybe<Setu_Trade_Shared_Entity>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  /** An array relationship */
  child_trades: Array<Production_Trade>;
  /** An aggregate relationship */
  child_trades_aggregate: Production_Trade_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  /** An object relationship */
  depot?: Maybe<Setu_Trade_Shared_Entity>;
  depot_id?: Maybe<Scalars['bigint']>;
  end_datetime?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  expenses: Array<Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Expense_Aggregate;
  /** An object relationship */
  facilitator?: Maybe<Setu_Trade_Shared_Entity>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id: Scalars['Int'];
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  items: Array<Production_Trade_Item>;
  /** An aggregate relationship */
  items_aggregate: Production_Trade_Item_Aggregate;
  kind: Scalars['String'];
  mode: Scalars['String'];
  /** An object relationship */
  officer?: Maybe<Setu_Trade_Shared_Entity>;
  officer_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  order_trade_refs: Array<Production_Trade_Order_Trade_Refs>;
  /** An aggregate relationship */
  order_trade_refs_aggregate: Production_Trade_Order_Trade_Refs_Aggregate;
  parent_trade_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  production_trade?: Maybe<Production_Trade>;
  start_datetime?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeAssociated_TradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeAssociated_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeChild_TradesArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_By>>;
  where?: InputMaybe<Production_Trade_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeChild_Trades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_By>>;
  where?: InputMaybe<Production_Trade_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeExpensesArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeItemsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeOrder_Trade_RefsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Order_By>>;
  where?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
};


/** columns and relationships of "production_trade" */
export type Production_TradeOrder_Trade_Refs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Order_By>>;
  where?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
};

/** aggregated selection of "production_trade" */
export type Production_Trade_Aggregate = {
  __typename?: 'production_trade_aggregate';
  aggregate?: Maybe<Production_Trade_Aggregate_Fields>;
  nodes: Array<Production_Trade>;
};

/** aggregate fields of "production_trade" */
export type Production_Trade_Aggregate_Fields = {
  __typename?: 'production_trade_aggregate_fields';
  avg?: Maybe<Production_Trade_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Production_Trade_Max_Fields>;
  min?: Maybe<Production_Trade_Min_Fields>;
  stddev?: Maybe<Production_Trade_Stddev_Fields>;
  stddev_pop?: Maybe<Production_Trade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Production_Trade_Stddev_Samp_Fields>;
  sum?: Maybe<Production_Trade_Sum_Fields>;
  var_pop?: Maybe<Production_Trade_Var_Pop_Fields>;
  var_samp?: Maybe<Production_Trade_Var_Samp_Fields>;
  variance?: Maybe<Production_Trade_Variance_Fields>;
};


/** aggregate fields of "production_trade" */
export type Production_Trade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Production_Trade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "production_trade" */
export type Production_Trade_Aggregate_Order_By = {
  avg?: InputMaybe<Production_Trade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Production_Trade_Max_Order_By>;
  min?: InputMaybe<Production_Trade_Min_Order_By>;
  stddev?: InputMaybe<Production_Trade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Production_Trade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Production_Trade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Production_Trade_Sum_Order_By>;
  var_pop?: InputMaybe<Production_Trade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Production_Trade_Var_Samp_Order_By>;
  variance?: InputMaybe<Production_Trade_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Production_Trade_Avg_Fields = {
  __typename?: 'production_trade_avg_fields';
  buyer_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  depot_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "production_trade" */
export type Production_Trade_Avg_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "production_trade". All fields are combined with a logical 'AND'. */
export type Production_Trade_Bool_Exp = {
  _and?: InputMaybe<Array<Production_Trade_Bool_Exp>>;
  _not?: InputMaybe<Production_Trade_Bool_Exp>;
  _or?: InputMaybe<Array<Production_Trade_Bool_Exp>>;
  associated_trades?: InputMaybe<Trade_Bool_Exp>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_tnc?: InputMaybe<String_Comparison_Exp>;
  child_trades?: InputMaybe<Production_Trade_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  depot?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  depot_id?: InputMaybe<Bigint_Comparison_Exp>;
  end_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  expenses?: InputMaybe<Expense_Bool_Exp>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  facilitator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  items?: InputMaybe<Production_Trade_Item_Bool_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  order_trade_refs?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
  parent_trade_id?: InputMaybe<Int_Comparison_Exp>;
  production_trade?: InputMaybe<Production_Trade_Bool_Exp>;
  start_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "production_trade_item" */
export type Production_Trade_Item = {
  __typename?: 'production_trade_item';
  /** An array relationship */
  attachments: Array<Production_Trade_Item_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Production_Trade_Item_Attachments_Aggregate;
  available_quantity?: Maybe<Scalars['float8']>;
  codename: Scalars['String'];
  /** An object relationship */
  commodity: Setu_Trade_Shared_Entity;
  commodity_id: Scalars['bigint'];
  cost_per_unit?: Maybe<Scalars['float8']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  final_quantity?: Maybe<Scalars['float8']>;
  /** An object relationship */
  grade?: Maybe<Setu_Trade_Shared_Entity>;
  grade_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  kind: Scalars['String'];
  /** An object relationship */
  production_trade: Production_Trade;
  production_trade_id: Scalars['Int'];
  required_quantity?: Maybe<Scalars['float8']>;
  /** An array relationship */
  storage_picked: Array<Production_Trade_Item_Storage_Picked>;
  /** An aggregate relationship */
  storage_picked_aggregate: Production_Trade_Item_Storage_Picked_Aggregate;
  total_cost?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  variety?: Maybe<Setu_Trade_Shared_Entity>;
  variety_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "production_trade_item" */
export type Production_Trade_ItemAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
};


/** columns and relationships of "production_trade_item" */
export type Production_Trade_ItemAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
};


/** columns and relationships of "production_trade_item" */
export type Production_Trade_ItemStorage_PickedArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


/** columns and relationships of "production_trade_item" */
export type Production_Trade_ItemStorage_Picked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};

/** aggregated selection of "production_trade_item" */
export type Production_Trade_Item_Aggregate = {
  __typename?: 'production_trade_item_aggregate';
  aggregate?: Maybe<Production_Trade_Item_Aggregate_Fields>;
  nodes: Array<Production_Trade_Item>;
};

/** aggregate fields of "production_trade_item" */
export type Production_Trade_Item_Aggregate_Fields = {
  __typename?: 'production_trade_item_aggregate_fields';
  avg?: Maybe<Production_Trade_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Production_Trade_Item_Max_Fields>;
  min?: Maybe<Production_Trade_Item_Min_Fields>;
  stddev?: Maybe<Production_Trade_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Production_Trade_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Production_Trade_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Production_Trade_Item_Sum_Fields>;
  var_pop?: Maybe<Production_Trade_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Production_Trade_Item_Var_Samp_Fields>;
  variance?: Maybe<Production_Trade_Item_Variance_Fields>;
};


/** aggregate fields of "production_trade_item" */
export type Production_Trade_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Production_Trade_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "production_trade_item" */
export type Production_Trade_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Production_Trade_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Production_Trade_Item_Max_Order_By>;
  min?: InputMaybe<Production_Trade_Item_Min_Order_By>;
  stddev?: InputMaybe<Production_Trade_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Production_Trade_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Production_Trade_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Production_Trade_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Production_Trade_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Production_Trade_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Production_Trade_Item_Variance_Order_By>;
};

/** columns and relationships of "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments = {
  __typename?: 'production_trade_item_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  productiontradeitem_id: Scalars['bigint'];
};

/** aggregated selection of "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Aggregate = {
  __typename?: 'production_trade_item_attachments_aggregate';
  aggregate?: Maybe<Production_Trade_Item_Attachments_Aggregate_Fields>;
  nodes: Array<Production_Trade_Item_Attachments>;
};

/** aggregate fields of "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Aggregate_Fields = {
  __typename?: 'production_trade_item_attachments_aggregate_fields';
  avg?: Maybe<Production_Trade_Item_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Production_Trade_Item_Attachments_Max_Fields>;
  min?: Maybe<Production_Trade_Item_Attachments_Min_Fields>;
  stddev?: Maybe<Production_Trade_Item_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Production_Trade_Item_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Production_Trade_Item_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Production_Trade_Item_Attachments_Sum_Fields>;
  var_pop?: Maybe<Production_Trade_Item_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Production_Trade_Item_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Production_Trade_Item_Attachments_Variance_Fields>;
};


/** aggregate fields of "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Production_Trade_Item_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Production_Trade_Item_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Production_Trade_Item_Attachments_Max_Order_By>;
  min?: InputMaybe<Production_Trade_Item_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Production_Trade_Item_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Production_Trade_Item_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Production_Trade_Item_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Production_Trade_Item_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Production_Trade_Item_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Production_Trade_Item_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Production_Trade_Item_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Production_Trade_Item_Attachments_Avg_Fields = {
  __typename?: 'production_trade_item_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  productiontradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "production_trade_item_attachments". All fields are combined with a logical 'AND'. */
export type Production_Trade_Item_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Production_Trade_Item_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Production_Trade_Item_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  productiontradeitem_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Production_Trade_Item_Attachments_Max_Fields = {
  __typename?: 'production_trade_item_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  productiontradeitem_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Production_Trade_Item_Attachments_Min_Fields = {
  __typename?: 'production_trade_item_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  productiontradeitem_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "production_trade_item_attachments". */
export type Production_Trade_Item_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** select columns of table "production_trade_item_attachments" */
export enum Production_Trade_Item_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  ProductiontradeitemId = 'productiontradeitem_id'
}

/** aggregate stddev on columns */
export type Production_Trade_Item_Attachments_Stddev_Fields = {
  __typename?: 'production_trade_item_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  productiontradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Production_Trade_Item_Attachments_Stddev_Pop_Fields = {
  __typename?: 'production_trade_item_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  productiontradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Production_Trade_Item_Attachments_Stddev_Samp_Fields = {
  __typename?: 'production_trade_item_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  productiontradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Production_Trade_Item_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Production_Trade_Item_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  productiontradeitem_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Production_Trade_Item_Attachments_Sum_Fields = {
  __typename?: 'production_trade_item_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  productiontradeitem_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Production_Trade_Item_Attachments_Var_Pop_Fields = {
  __typename?: 'production_trade_item_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  productiontradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Production_Trade_Item_Attachments_Var_Samp_Fields = {
  __typename?: 'production_trade_item_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  productiontradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Production_Trade_Item_Attachments_Variance_Fields = {
  __typename?: 'production_trade_item_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  productiontradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "production_trade_item_attachments" */
export type Production_Trade_Item_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  productiontradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Production_Trade_Item_Avg_Fields = {
  __typename?: 'production_trade_item_avg_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  cost_per_unit?: Maybe<Scalars['Float']>;
  final_quantity?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "production_trade_item" */
export type Production_Trade_Item_Avg_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "production_trade_item". All fields are combined with a logical 'AND'. */
export type Production_Trade_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Production_Trade_Item_Bool_Exp>>;
  _not?: InputMaybe<Production_Trade_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Production_Trade_Item_Bool_Exp>>;
  attachments?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
  available_quantity?: InputMaybe<Float8_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  cost_per_unit?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  final_quantity?: InputMaybe<Float8_Comparison_Exp>;
  grade?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  grade_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  production_trade?: InputMaybe<Production_Trade_Bool_Exp>;
  production_trade_id?: InputMaybe<Int_Comparison_Exp>;
  required_quantity?: InputMaybe<Float8_Comparison_Exp>;
  storage_picked?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
  total_cost?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  variety_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Production_Trade_Item_Max_Fields = {
  __typename?: 'production_trade_item_max_fields';
  available_quantity?: Maybe<Scalars['float8']>;
  codename?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  cost_per_unit?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  final_quantity?: Maybe<Scalars['float8']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  production_trade_id?: Maybe<Scalars['Int']>;
  required_quantity?: Maybe<Scalars['float8']>;
  total_cost?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "production_trade_item" */
export type Production_Trade_Item_Max_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Production_Trade_Item_Min_Fields = {
  __typename?: 'production_trade_item_min_fields';
  available_quantity?: Maybe<Scalars['float8']>;
  codename?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  cost_per_unit?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  final_quantity?: Maybe<Scalars['float8']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  production_trade_id?: Maybe<Scalars['Int']>;
  required_quantity?: Maybe<Scalars['float8']>;
  total_cost?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  variety_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "production_trade_item" */
export type Production_Trade_Item_Min_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "production_trade_item". */
export type Production_Trade_Item_Order_By = {
  attachments_aggregate?: InputMaybe<Production_Trade_Item_Attachments_Aggregate_Order_By>;
  available_quantity?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  production_trade?: InputMaybe<Production_Trade_Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  storage_picked_aggregate?: InputMaybe<Production_Trade_Item_Storage_Picked_Aggregate_Order_By>;
  total_cost?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** select columns of table "production_trade_item" */
export enum Production_Trade_Item_Select_Column {
  /** column name */
  AvailableQuantity = 'available_quantity',
  /** column name */
  Codename = 'codename',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CostPerUnit = 'cost_per_unit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FinalQuantity = 'final_quantity',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  ProductionTradeId = 'production_trade_id',
  /** column name */
  RequiredQuantity = 'required_quantity',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VarietyId = 'variety_id'
}

/** aggregate stddev on columns */
export type Production_Trade_Item_Stddev_Fields = {
  __typename?: 'production_trade_item_stddev_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  cost_per_unit?: Maybe<Scalars['Float']>;
  final_quantity?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "production_trade_item" */
export type Production_Trade_Item_Stddev_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Production_Trade_Item_Stddev_Pop_Fields = {
  __typename?: 'production_trade_item_stddev_pop_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  cost_per_unit?: Maybe<Scalars['Float']>;
  final_quantity?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "production_trade_item" */
export type Production_Trade_Item_Stddev_Pop_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Production_Trade_Item_Stddev_Samp_Fields = {
  __typename?: 'production_trade_item_stddev_samp_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  cost_per_unit?: Maybe<Scalars['Float']>;
  final_quantity?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "production_trade_item" */
export type Production_Trade_Item_Stddev_Samp_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked = {
  __typename?: 'production_trade_item_storage_picked';
  cost_per_unit?: Maybe<Scalars['float8']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  production_trade_item?: Maybe<Production_Trade_Item>;
  production_trade_item_id?: Maybe<Scalars['bigint']>;
  required_quantity?: Maybe<Scalars['float8']>;
  total_cost?: Maybe<Scalars['float8']>;
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  used_quantity?: Maybe<Scalars['float8']>;
  wastage_loss_quantity?: Maybe<Scalars['float8']>;
  weight_loss_quantity?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Aggregate = {
  __typename?: 'production_trade_item_storage_picked_aggregate';
  aggregate?: Maybe<Production_Trade_Item_Storage_Picked_Aggregate_Fields>;
  nodes: Array<Production_Trade_Item_Storage_Picked>;
};

/** aggregate fields of "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Aggregate_Fields = {
  __typename?: 'production_trade_item_storage_picked_aggregate_fields';
  avg?: Maybe<Production_Trade_Item_Storage_Picked_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Production_Trade_Item_Storage_Picked_Max_Fields>;
  min?: Maybe<Production_Trade_Item_Storage_Picked_Min_Fields>;
  stddev?: Maybe<Production_Trade_Item_Storage_Picked_Stddev_Fields>;
  stddev_pop?: Maybe<Production_Trade_Item_Storage_Picked_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Production_Trade_Item_Storage_Picked_Stddev_Samp_Fields>;
  sum?: Maybe<Production_Trade_Item_Storage_Picked_Sum_Fields>;
  var_pop?: Maybe<Production_Trade_Item_Storage_Picked_Var_Pop_Fields>;
  var_samp?: Maybe<Production_Trade_Item_Storage_Picked_Var_Samp_Fields>;
  variance?: Maybe<Production_Trade_Item_Storage_Picked_Variance_Fields>;
};


/** aggregate fields of "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Aggregate_Order_By = {
  avg?: InputMaybe<Production_Trade_Item_Storage_Picked_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Production_Trade_Item_Storage_Picked_Max_Order_By>;
  min?: InputMaybe<Production_Trade_Item_Storage_Picked_Min_Order_By>;
  stddev?: InputMaybe<Production_Trade_Item_Storage_Picked_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Production_Trade_Item_Storage_Picked_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Production_Trade_Item_Storage_Picked_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Production_Trade_Item_Storage_Picked_Sum_Order_By>;
  var_pop?: InputMaybe<Production_Trade_Item_Storage_Picked_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Production_Trade_Item_Storage_Picked_Var_Samp_Order_By>;
  variance?: InputMaybe<Production_Trade_Item_Storage_Picked_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Production_Trade_Item_Storage_Picked_Avg_Fields = {
  __typename?: 'production_trade_item_storage_picked_avg_fields';
  cost_per_unit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_item_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  used_quantity?: Maybe<Scalars['Float']>;
  wastage_loss_quantity?: Maybe<Scalars['Float']>;
  weight_loss_quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Avg_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "production_trade_item_storage_picked". All fields are combined with a logical 'AND'. */
export type Production_Trade_Item_Storage_Picked_Bool_Exp = {
  _and?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Bool_Exp>>;
  _not?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
  _or?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Bool_Exp>>;
  cost_per_unit?: InputMaybe<Float8_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  production_trade_item?: InputMaybe<Production_Trade_Item_Bool_Exp>;
  production_trade_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  required_quantity?: InputMaybe<Float8_Comparison_Exp>;
  total_cost?: InputMaybe<Float8_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  used_quantity?: InputMaybe<Float8_Comparison_Exp>;
  wastage_loss_quantity?: InputMaybe<Float8_Comparison_Exp>;
  weight_loss_quantity?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Production_Trade_Item_Storage_Picked_Max_Fields = {
  __typename?: 'production_trade_item_storage_picked_max_fields';
  cost_per_unit?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  production_trade_item_id?: Maybe<Scalars['bigint']>;
  required_quantity?: Maybe<Scalars['float8']>;
  total_cost?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_quantity?: Maybe<Scalars['float8']>;
  wastage_loss_quantity?: Maybe<Scalars['float8']>;
  weight_loss_quantity?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Max_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Production_Trade_Item_Storage_Picked_Min_Fields = {
  __typename?: 'production_trade_item_storage_picked_min_fields';
  cost_per_unit?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  production_trade_item_id?: Maybe<Scalars['bigint']>;
  required_quantity?: Maybe<Scalars['float8']>;
  total_cost?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  used_quantity?: Maybe<Scalars['float8']>;
  wastage_loss_quantity?: Maybe<Scalars['float8']>;
  weight_loss_quantity?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Min_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "production_trade_item_storage_picked". */
export type Production_Trade_Item_Storage_Picked_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item?: InputMaybe<Production_Trade_Item_Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** select columns of table "production_trade_item_storage_picked" */
export enum Production_Trade_Item_Storage_Picked_Select_Column {
  /** column name */
  CostPerUnit = 'cost_per_unit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProductionTradeItemId = 'production_trade_item_id',
  /** column name */
  RequiredQuantity = 'required_quantity',
  /** column name */
  TotalCost = 'total_cost',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UsedQuantity = 'used_quantity',
  /** column name */
  WastageLossQuantity = 'wastage_loss_quantity',
  /** column name */
  WeightLossQuantity = 'weight_loss_quantity'
}

/** aggregate stddev on columns */
export type Production_Trade_Item_Storage_Picked_Stddev_Fields = {
  __typename?: 'production_trade_item_storage_picked_stddev_fields';
  cost_per_unit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_item_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  used_quantity?: Maybe<Scalars['Float']>;
  wastage_loss_quantity?: Maybe<Scalars['Float']>;
  weight_loss_quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Stddev_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Production_Trade_Item_Storage_Picked_Stddev_Pop_Fields = {
  __typename?: 'production_trade_item_storage_picked_stddev_pop_fields';
  cost_per_unit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_item_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  used_quantity?: Maybe<Scalars['Float']>;
  wastage_loss_quantity?: Maybe<Scalars['Float']>;
  weight_loss_quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Stddev_Pop_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Production_Trade_Item_Storage_Picked_Stddev_Samp_Fields = {
  __typename?: 'production_trade_item_storage_picked_stddev_samp_fields';
  cost_per_unit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_item_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  used_quantity?: Maybe<Scalars['Float']>;
  wastage_loss_quantity?: Maybe<Scalars['Float']>;
  weight_loss_quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Stddev_Samp_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Production_Trade_Item_Storage_Picked_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Production_Trade_Item_Storage_Picked_Stream_Cursor_Value_Input = {
  cost_per_unit?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  production_trade_item_id?: InputMaybe<Scalars['bigint']>;
  required_quantity?: InputMaybe<Scalars['float8']>;
  total_cost?: InputMaybe<Scalars['float8']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  used_quantity?: InputMaybe<Scalars['float8']>;
  wastage_loss_quantity?: InputMaybe<Scalars['float8']>;
  weight_loss_quantity?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Production_Trade_Item_Storage_Picked_Sum_Fields = {
  __typename?: 'production_trade_item_storage_picked_sum_fields';
  cost_per_unit?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  production_trade_item_id?: Maybe<Scalars['bigint']>;
  required_quantity?: Maybe<Scalars['float8']>;
  total_cost?: Maybe<Scalars['float8']>;
  trade_id?: Maybe<Scalars['bigint']>;
  used_quantity?: Maybe<Scalars['float8']>;
  wastage_loss_quantity?: Maybe<Scalars['float8']>;
  weight_loss_quantity?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Sum_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Production_Trade_Item_Storage_Picked_Var_Pop_Fields = {
  __typename?: 'production_trade_item_storage_picked_var_pop_fields';
  cost_per_unit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_item_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  used_quantity?: Maybe<Scalars['Float']>;
  wastage_loss_quantity?: Maybe<Scalars['Float']>;
  weight_loss_quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Var_Pop_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Production_Trade_Item_Storage_Picked_Var_Samp_Fields = {
  __typename?: 'production_trade_item_storage_picked_var_samp_fields';
  cost_per_unit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_item_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  used_quantity?: Maybe<Scalars['Float']>;
  wastage_loss_quantity?: Maybe<Scalars['Float']>;
  weight_loss_quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Var_Samp_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Production_Trade_Item_Storage_Picked_Variance_Fields = {
  __typename?: 'production_trade_item_storage_picked_variance_fields';
  cost_per_unit?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_item_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  used_quantity?: Maybe<Scalars['Float']>;
  wastage_loss_quantity?: Maybe<Scalars['Float']>;
  weight_loss_quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "production_trade_item_storage_picked" */
export type Production_Trade_Item_Storage_Picked_Variance_Order_By = {
  cost_per_unit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_item_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  used_quantity?: InputMaybe<Order_By>;
  wastage_loss_quantity?: InputMaybe<Order_By>;
  weight_loss_quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "production_trade_item" */
export type Production_Trade_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Production_Trade_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Production_Trade_Item_Stream_Cursor_Value_Input = {
  available_quantity?: InputMaybe<Scalars['float8']>;
  codename?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  cost_per_unit?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  final_quantity?: InputMaybe<Scalars['float8']>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  production_trade_id?: InputMaybe<Scalars['Int']>;
  required_quantity?: InputMaybe<Scalars['float8']>;
  total_cost?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  variety_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Production_Trade_Item_Sum_Fields = {
  __typename?: 'production_trade_item_sum_fields';
  available_quantity?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  cost_per_unit?: Maybe<Scalars['float8']>;
  final_quantity?: Maybe<Scalars['float8']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  production_trade_id?: Maybe<Scalars['Int']>;
  required_quantity?: Maybe<Scalars['float8']>;
  total_cost?: Maybe<Scalars['float8']>;
  variety_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "production_trade_item" */
export type Production_Trade_Item_Sum_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Production_Trade_Item_Var_Pop_Fields = {
  __typename?: 'production_trade_item_var_pop_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  cost_per_unit?: Maybe<Scalars['Float']>;
  final_quantity?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "production_trade_item" */
export type Production_Trade_Item_Var_Pop_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Production_Trade_Item_Var_Samp_Fields = {
  __typename?: 'production_trade_item_var_samp_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  cost_per_unit?: Maybe<Scalars['Float']>;
  final_quantity?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "production_trade_item" */
export type Production_Trade_Item_Var_Samp_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Production_Trade_Item_Variance_Fields = {
  __typename?: 'production_trade_item_variance_fields';
  available_quantity?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  cost_per_unit?: Maybe<Scalars['Float']>;
  final_quantity?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  required_quantity?: Maybe<Scalars['Float']>;
  total_cost?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "production_trade_item" */
export type Production_Trade_Item_Variance_Order_By = {
  available_quantity?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  cost_per_unit?: InputMaybe<Order_By>;
  final_quantity?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  required_quantity?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Production_Trade_Max_Fields = {
  __typename?: 'production_trade_max_fields';
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  depot_id?: Maybe<Scalars['bigint']>;
  end_datetime?: Maybe<Scalars['timestamptz']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  officer_id?: Maybe<Scalars['bigint']>;
  parent_trade_id?: Maybe<Scalars['Int']>;
  start_datetime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "production_trade" */
export type Production_Trade_Max_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Production_Trade_Min_Fields = {
  __typename?: 'production_trade_min_fields';
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  depot_id?: Maybe<Scalars['bigint']>;
  end_datetime?: Maybe<Scalars['timestamptz']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  officer_id?: Maybe<Scalars['bigint']>;
  parent_trade_id?: Maybe<Scalars['Int']>;
  start_datetime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "production_trade" */
export type Production_Trade_Min_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "production_trade". */
export type Production_Trade_Order_By = {
  associated_trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  child_trades_aggregate?: InputMaybe<Production_Trade_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  depot_id?: InputMaybe<Order_By>;
  end_datetime?: InputMaybe<Order_By>;
  expenses_aggregate?: InputMaybe<Expense_Aggregate_Order_By>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Production_Trade_Item_Aggregate_Order_By>;
  kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  officer_id?: InputMaybe<Order_By>;
  order_trade_refs_aggregate?: InputMaybe<Production_Trade_Order_Trade_Refs_Aggregate_Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  production_trade?: InputMaybe<Production_Trade_Order_By>;
  start_datetime?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** columns and relationships of "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs = {
  __typename?: 'production_trade_order_trade_refs';
  id: Scalars['bigint'];
  /** An object relationship */
  production_trade: Production_Trade;
  productiontrade_id: Scalars['Int'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
};

/** aggregated selection of "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Aggregate = {
  __typename?: 'production_trade_order_trade_refs_aggregate';
  aggregate?: Maybe<Production_Trade_Order_Trade_Refs_Aggregate_Fields>;
  nodes: Array<Production_Trade_Order_Trade_Refs>;
};

/** aggregate fields of "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Aggregate_Fields = {
  __typename?: 'production_trade_order_trade_refs_aggregate_fields';
  avg?: Maybe<Production_Trade_Order_Trade_Refs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Production_Trade_Order_Trade_Refs_Max_Fields>;
  min?: Maybe<Production_Trade_Order_Trade_Refs_Min_Fields>;
  stddev?: Maybe<Production_Trade_Order_Trade_Refs_Stddev_Fields>;
  stddev_pop?: Maybe<Production_Trade_Order_Trade_Refs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Production_Trade_Order_Trade_Refs_Stddev_Samp_Fields>;
  sum?: Maybe<Production_Trade_Order_Trade_Refs_Sum_Fields>;
  var_pop?: Maybe<Production_Trade_Order_Trade_Refs_Var_Pop_Fields>;
  var_samp?: Maybe<Production_Trade_Order_Trade_Refs_Var_Samp_Fields>;
  variance?: Maybe<Production_Trade_Order_Trade_Refs_Variance_Fields>;
};


/** aggregate fields of "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Aggregate_Order_By = {
  avg?: InputMaybe<Production_Trade_Order_Trade_Refs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Production_Trade_Order_Trade_Refs_Max_Order_By>;
  min?: InputMaybe<Production_Trade_Order_Trade_Refs_Min_Order_By>;
  stddev?: InputMaybe<Production_Trade_Order_Trade_Refs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Production_Trade_Order_Trade_Refs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Production_Trade_Order_Trade_Refs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Production_Trade_Order_Trade_Refs_Sum_Order_By>;
  var_pop?: InputMaybe<Production_Trade_Order_Trade_Refs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Production_Trade_Order_Trade_Refs_Var_Samp_Order_By>;
  variance?: InputMaybe<Production_Trade_Order_Trade_Refs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Production_Trade_Order_Trade_Refs_Avg_Fields = {
  __typename?: 'production_trade_order_trade_refs_avg_fields';
  id?: Maybe<Scalars['Float']>;
  productiontrade_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "production_trade_order_trade_refs". All fields are combined with a logical 'AND'. */
export type Production_Trade_Order_Trade_Refs_Bool_Exp = {
  _and?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Bool_Exp>>;
  _not?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
  _or?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  production_trade?: InputMaybe<Production_Trade_Bool_Exp>;
  productiontrade_id?: InputMaybe<Int_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Production_Trade_Order_Trade_Refs_Max_Fields = {
  __typename?: 'production_trade_order_trade_refs_max_fields';
  id?: Maybe<Scalars['bigint']>;
  productiontrade_id?: Maybe<Scalars['Int']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Production_Trade_Order_Trade_Refs_Min_Fields = {
  __typename?: 'production_trade_order_trade_refs_min_fields';
  id?: Maybe<Scalars['bigint']>;
  productiontrade_id?: Maybe<Scalars['Int']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "production_trade_order_trade_refs". */
export type Production_Trade_Order_Trade_Refs_Order_By = {
  id?: InputMaybe<Order_By>;
  production_trade?: InputMaybe<Production_Trade_Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** select columns of table "production_trade_order_trade_refs" */
export enum Production_Trade_Order_Trade_Refs_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProductiontradeId = 'productiontrade_id',
  /** column name */
  TradeId = 'trade_id'
}

/** aggregate stddev on columns */
export type Production_Trade_Order_Trade_Refs_Stddev_Fields = {
  __typename?: 'production_trade_order_trade_refs_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  productiontrade_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Production_Trade_Order_Trade_Refs_Stddev_Pop_Fields = {
  __typename?: 'production_trade_order_trade_refs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  productiontrade_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Production_Trade_Order_Trade_Refs_Stddev_Samp_Fields = {
  __typename?: 'production_trade_order_trade_refs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  productiontrade_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Production_Trade_Order_Trade_Refs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Production_Trade_Order_Trade_Refs_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  productiontrade_id?: InputMaybe<Scalars['Int']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Production_Trade_Order_Trade_Refs_Sum_Fields = {
  __typename?: 'production_trade_order_trade_refs_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  productiontrade_id?: Maybe<Scalars['Int']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Production_Trade_Order_Trade_Refs_Var_Pop_Fields = {
  __typename?: 'production_trade_order_trade_refs_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  productiontrade_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Production_Trade_Order_Trade_Refs_Var_Samp_Fields = {
  __typename?: 'production_trade_order_trade_refs_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  productiontrade_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Production_Trade_Order_Trade_Refs_Variance_Fields = {
  __typename?: 'production_trade_order_trade_refs_variance_fields';
  id?: Maybe<Scalars['Float']>;
  productiontrade_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "production_trade_order_trade_refs" */
export type Production_Trade_Order_Trade_Refs_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  productiontrade_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** select columns of table "production_trade" */
export enum Production_Trade_Select_Column {
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  DepotId = 'depot_id',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Kind = 'kind',
  /** column name */
  Mode = 'mode',
  /** column name */
  OfficerId = 'officer_id',
  /** column name */
  ParentTradeId = 'parent_trade_id',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** aggregate stddev on columns */
export type Production_Trade_Stddev_Fields = {
  __typename?: 'production_trade_stddev_fields';
  buyer_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  depot_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "production_trade" */
export type Production_Trade_Stddev_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Production_Trade_Stddev_Pop_Fields = {
  __typename?: 'production_trade_stddev_pop_fields';
  buyer_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  depot_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "production_trade" */
export type Production_Trade_Stddev_Pop_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Production_Trade_Stddev_Samp_Fields = {
  __typename?: 'production_trade_stddev_samp_fields';
  buyer_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  depot_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "production_trade" */
export type Production_Trade_Stddev_Samp_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "production_trade" */
export type Production_Trade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Production_Trade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Production_Trade_Stream_Cursor_Value_Input = {
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  depot_id?: InputMaybe<Scalars['bigint']>;
  end_datetime?: InputMaybe<Scalars['timestamptz']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['Int']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  parent_trade_id?: InputMaybe<Scalars['Int']>;
  start_datetime?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Production_Trade_Sum_Fields = {
  __typename?: 'production_trade_sum_fields';
  buyer_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  depot_id?: Maybe<Scalars['bigint']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  officer_id?: Maybe<Scalars['bigint']>;
  parent_trade_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "production_trade" */
export type Production_Trade_Sum_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Production_Trade_Var_Pop_Fields = {
  __typename?: 'production_trade_var_pop_fields';
  buyer_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  depot_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "production_trade" */
export type Production_Trade_Var_Pop_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Production_Trade_Var_Samp_Fields = {
  __typename?: 'production_trade_var_samp_fields';
  buyer_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  depot_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "production_trade" */
export type Production_Trade_Var_Samp_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Production_Trade_Variance_Fields = {
  __typename?: 'production_trade_variance_fields';
  buyer_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  depot_id?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "production_trade" */
export type Production_Trade_Variance_Order_By = {
  buyer_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  depot_id?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "projection_assessment" */
export type Projection_Assessment = {
  __typename?: 'projection_assessment';
  assessed_limit?: Maybe<Scalars['float8']>;
  /** An object relationship */
  credit: Credit;
  credit_id: Scalars['bigint'];
  daily_average_sale?: Maybe<Scalars['float8']>;
  end_date: Scalars['date'];
  id: Scalars['bigint'];
  payment_cycle: Scalars['Int'];
  start_date: Scalars['date'];
  tenure: Scalars['Int'];
  total_sales?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "projection_assessment" */
export type Projection_Assessment_Aggregate = {
  __typename?: 'projection_assessment_aggregate';
  aggregate?: Maybe<Projection_Assessment_Aggregate_Fields>;
  nodes: Array<Projection_Assessment>;
};

/** aggregate fields of "projection_assessment" */
export type Projection_Assessment_Aggregate_Fields = {
  __typename?: 'projection_assessment_aggregate_fields';
  avg?: Maybe<Projection_Assessment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Projection_Assessment_Max_Fields>;
  min?: Maybe<Projection_Assessment_Min_Fields>;
  stddev?: Maybe<Projection_Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Projection_Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projection_Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Projection_Assessment_Sum_Fields>;
  var_pop?: Maybe<Projection_Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Projection_Assessment_Var_Samp_Fields>;
  variance?: Maybe<Projection_Assessment_Variance_Fields>;
};


/** aggregate fields of "projection_assessment" */
export type Projection_Assessment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projection_Assessment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "projection_assessment" */
export type Projection_Assessment_Aggregate_Order_By = {
  avg?: InputMaybe<Projection_Assessment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projection_Assessment_Max_Order_By>;
  min?: InputMaybe<Projection_Assessment_Min_Order_By>;
  stddev?: InputMaybe<Projection_Assessment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Projection_Assessment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Projection_Assessment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Projection_Assessment_Sum_Order_By>;
  var_pop?: InputMaybe<Projection_Assessment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Projection_Assessment_Var_Samp_Order_By>;
  variance?: InputMaybe<Projection_Assessment_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Projection_Assessment_Avg_Fields = {
  __typename?: 'projection_assessment_avg_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "projection_assessment" */
export type Projection_Assessment_Avg_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "projection_assessment". All fields are combined with a logical 'AND'. */
export type Projection_Assessment_Bool_Exp = {
  _and?: InputMaybe<Array<Projection_Assessment_Bool_Exp>>;
  _not?: InputMaybe<Projection_Assessment_Bool_Exp>;
  _or?: InputMaybe<Array<Projection_Assessment_Bool_Exp>>;
  assessed_limit?: InputMaybe<Float8_Comparison_Exp>;
  credit?: InputMaybe<Credit_Bool_Exp>;
  credit_id?: InputMaybe<Bigint_Comparison_Exp>;
  daily_average_sale?: InputMaybe<Float8_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_cycle?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenure?: InputMaybe<Int_Comparison_Exp>;
  total_sales?: InputMaybe<Float8_Comparison_Exp>;
};

/** columns and relationships of "projection_assessment_cw" */
export type Projection_Assessment_Cw = {
  __typename?: 'projection_assessment_cw';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id: Scalars['bigint'];
  daily_average_sale?: Maybe<Scalars['numeric']>;
  end_date: Scalars['date'];
  id: Scalars['bigint'];
  payment_cycle: Scalars['Int'];
  start_date: Scalars['date'];
  tenure: Scalars['Int'];
  total_sales?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "projection_assessment_cw" */
export type Projection_Assessment_Cw_Aggregate = {
  __typename?: 'projection_assessment_cw_aggregate';
  aggregate?: Maybe<Projection_Assessment_Cw_Aggregate_Fields>;
  nodes: Array<Projection_Assessment_Cw>;
};

/** aggregate fields of "projection_assessment_cw" */
export type Projection_Assessment_Cw_Aggregate_Fields = {
  __typename?: 'projection_assessment_cw_aggregate_fields';
  avg?: Maybe<Projection_Assessment_Cw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Projection_Assessment_Cw_Max_Fields>;
  min?: Maybe<Projection_Assessment_Cw_Min_Fields>;
  stddev?: Maybe<Projection_Assessment_Cw_Stddev_Fields>;
  stddev_pop?: Maybe<Projection_Assessment_Cw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projection_Assessment_Cw_Stddev_Samp_Fields>;
  sum?: Maybe<Projection_Assessment_Cw_Sum_Fields>;
  var_pop?: Maybe<Projection_Assessment_Cw_Var_Pop_Fields>;
  var_samp?: Maybe<Projection_Assessment_Cw_Var_Samp_Fields>;
  variance?: Maybe<Projection_Assessment_Cw_Variance_Fields>;
};


/** aggregate fields of "projection_assessment_cw" */
export type Projection_Assessment_Cw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projection_Assessment_Cw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Aggregate_Order_By = {
  avg?: InputMaybe<Projection_Assessment_Cw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projection_Assessment_Cw_Max_Order_By>;
  min?: InputMaybe<Projection_Assessment_Cw_Min_Order_By>;
  stddev?: InputMaybe<Projection_Assessment_Cw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Projection_Assessment_Cw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Projection_Assessment_Cw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Projection_Assessment_Cw_Sum_Order_By>;
  var_pop?: InputMaybe<Projection_Assessment_Cw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Projection_Assessment_Cw_Var_Samp_Order_By>;
  variance?: InputMaybe<Projection_Assessment_Cw_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Projection_Assessment_Cw_Avg_Fields = {
  __typename?: 'projection_assessment_cw_avg_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Avg_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "projection_assessment_cw". All fields are combined with a logical 'AND'. */
export type Projection_Assessment_Cw_Bool_Exp = {
  _and?: InputMaybe<Array<Projection_Assessment_Cw_Bool_Exp>>;
  _not?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
  _or?: InputMaybe<Array<Projection_Assessment_Cw_Bool_Exp>>;
  assessed_limit?: InputMaybe<Numeric_Comparison_Exp>;
  credit_wallet_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  daily_average_sale?: InputMaybe<Numeric_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_cycle?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenure?: InputMaybe<Int_Comparison_Exp>;
  total_sales?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Projection_Assessment_Cw_Max_Fields = {
  __typename?: 'projection_assessment_cw_max_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Max_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Projection_Assessment_Cw_Min_Fields = {
  __typename?: 'projection_assessment_cw_min_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Min_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "projection_assessment_cw". */
export type Projection_Assessment_Cw_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** select columns of table "projection_assessment_cw" */
export enum Projection_Assessment_Cw_Select_Column {
  /** column name */
  AssessedLimit = 'assessed_limit',
  /** column name */
  CreditWalletRequestId = 'credit_wallet_request_id',
  /** column name */
  DailyAverageSale = 'daily_average_sale',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCycle = 'payment_cycle',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Tenure = 'tenure',
  /** column name */
  TotalSales = 'total_sales'
}

/** aggregate stddev on columns */
export type Projection_Assessment_Cw_Stddev_Fields = {
  __typename?: 'projection_assessment_cw_stddev_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Stddev_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Projection_Assessment_Cw_Stddev_Pop_Fields = {
  __typename?: 'projection_assessment_cw_stddev_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Stddev_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Projection_Assessment_Cw_Stddev_Samp_Fields = {
  __typename?: 'projection_assessment_cw_stddev_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Stddev_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projection_Assessment_Cw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projection_Assessment_Cw_Stream_Cursor_Value_Input = {
  assessed_limit?: InputMaybe<Scalars['numeric']>;
  credit_wallet_request_id?: InputMaybe<Scalars['bigint']>;
  daily_average_sale?: InputMaybe<Scalars['numeric']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenure?: InputMaybe<Scalars['Int']>;
  total_sales?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Projection_Assessment_Cw_Sum_Fields = {
  __typename?: 'projection_assessment_cw_sum_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Sum_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Projection_Assessment_Cw_Var_Pop_Fields = {
  __typename?: 'projection_assessment_cw_var_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Var_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Projection_Assessment_Cw_Var_Samp_Fields = {
  __typename?: 'projection_assessment_cw_var_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Var_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Projection_Assessment_Cw_Variance_Fields = {
  __typename?: 'projection_assessment_cw_variance_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "projection_assessment_cw" */
export type Projection_Assessment_Cw_Variance_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Projection_Assessment_Max_Fields = {
  __typename?: 'projection_assessment_max_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "projection_assessment" */
export type Projection_Assessment_Max_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Projection_Assessment_Min_Fields = {
  __typename?: 'projection_assessment_min_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "projection_assessment" */
export type Projection_Assessment_Min_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "projection_assessment". */
export type Projection_Assessment_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit?: InputMaybe<Credit_Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** select columns of table "projection_assessment" */
export enum Projection_Assessment_Select_Column {
  /** column name */
  AssessedLimit = 'assessed_limit',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  DailyAverageSale = 'daily_average_sale',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCycle = 'payment_cycle',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Tenure = 'tenure',
  /** column name */
  TotalSales = 'total_sales'
}

/** aggregate stddev on columns */
export type Projection_Assessment_Stddev_Fields = {
  __typename?: 'projection_assessment_stddev_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "projection_assessment" */
export type Projection_Assessment_Stddev_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Projection_Assessment_Stddev_Pop_Fields = {
  __typename?: 'projection_assessment_stddev_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "projection_assessment" */
export type Projection_Assessment_Stddev_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Projection_Assessment_Stddev_Samp_Fields = {
  __typename?: 'projection_assessment_stddev_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "projection_assessment" */
export type Projection_Assessment_Stddev_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "projection_assessment" */
export type Projection_Assessment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projection_Assessment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projection_Assessment_Stream_Cursor_Value_Input = {
  assessed_limit?: InputMaybe<Scalars['float8']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  daily_average_sale?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenure?: InputMaybe<Scalars['Int']>;
  total_sales?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Projection_Assessment_Sum_Fields = {
  __typename?: 'projection_assessment_sum_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "projection_assessment" */
export type Projection_Assessment_Sum_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Projection_Assessment_Var_Pop_Fields = {
  __typename?: 'projection_assessment_var_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "projection_assessment" */
export type Projection_Assessment_Var_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Projection_Assessment_Var_Samp_Fields = {
  __typename?: 'projection_assessment_var_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "projection_assessment" */
export type Projection_Assessment_Var_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Projection_Assessment_Variance_Fields = {
  __typename?: 'projection_assessment_variance_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "projection_assessment" */
export type Projection_Assessment_Variance_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
};

/** columns and relationships of "quality_parameter" */
export type Quality_Parameter = {
  __typename?: 'quality_parameter';
  /** An object relationship */
  category: Quality_Parameter_Category;
  category_id: Scalars['bigint'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['bigint'];
  /** An object relationship */
  instrument_kind?: Maybe<Instrument_Kind>;
  instrument_kind_id?: Maybe<Scalars['bigint']>;
  is_active: Scalars['Boolean'];
  kind: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  options: Scalars['_varchar'];
  /** An array relationship */
  request_parameters: Array<Request_Parameters>;
  /** An aggregate relationship */
  request_parameters_aggregate: Request_Parameters_Aggregate;
  /** An array relationship */
  template_parameters: Array<Template_Parameter>;
  /** An aggregate relationship */
  template_parameters_aggregate: Template_Parameter_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "quality_parameter" */
export type Quality_ParameterMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "quality_parameter" */
export type Quality_ParameterRequest_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


/** columns and relationships of "quality_parameter" */
export type Quality_ParameterRequest_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


/** columns and relationships of "quality_parameter" */
export type Quality_ParameterTemplate_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};


/** columns and relationships of "quality_parameter" */
export type Quality_ParameterTemplate_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};

/** aggregated selection of "quality_parameter" */
export type Quality_Parameter_Aggregate = {
  __typename?: 'quality_parameter_aggregate';
  aggregate?: Maybe<Quality_Parameter_Aggregate_Fields>;
  nodes: Array<Quality_Parameter>;
};

/** aggregate fields of "quality_parameter" */
export type Quality_Parameter_Aggregate_Fields = {
  __typename?: 'quality_parameter_aggregate_fields';
  avg?: Maybe<Quality_Parameter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quality_Parameter_Max_Fields>;
  min?: Maybe<Quality_Parameter_Min_Fields>;
  stddev?: Maybe<Quality_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_Parameter_Sum_Fields>;
  var_pop?: Maybe<Quality_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Quality_Parameter_Variance_Fields>;
};


/** aggregate fields of "quality_parameter" */
export type Quality_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quality_parameter" */
export type Quality_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Quality_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_Parameter_Max_Order_By>;
  min?: InputMaybe<Quality_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Quality_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quality_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quality_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quality_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Quality_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quality_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Quality_Parameter_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quality_Parameter_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "quality_parameter" */
export type Quality_Parameter_Arr_Rel_Insert_Input = {
  data: Array<Quality_Parameter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Parameter_On_Conflict>;
};

/** aggregate avg on columns */
export type Quality_Parameter_Avg_Fields = {
  __typename?: 'quality_parameter_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quality_parameter" */
export type Quality_Parameter_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quality_parameter". All fields are combined with a logical 'AND'. */
export type Quality_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Quality_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_Parameter_Bool_Exp>>;
  category?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  instrument_kind?: InputMaybe<Instrument_Kind_Bool_Exp>;
  instrument_kind_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<_Varchar_Comparison_Exp>;
  request_parameters?: InputMaybe<Request_Parameters_Bool_Exp>;
  template_parameters?: InputMaybe<Template_Parameter_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "quality_parameter_category" */
export type Quality_Parameter_Category = {
  __typename?: 'quality_parameter_category';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "quality_parameter_category" */
export type Quality_Parameter_Category_Aggregate = {
  __typename?: 'quality_parameter_category_aggregate';
  aggregate?: Maybe<Quality_Parameter_Category_Aggregate_Fields>;
  nodes: Array<Quality_Parameter_Category>;
};

/** aggregate fields of "quality_parameter_category" */
export type Quality_Parameter_Category_Aggregate_Fields = {
  __typename?: 'quality_parameter_category_aggregate_fields';
  avg?: Maybe<Quality_Parameter_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quality_Parameter_Category_Max_Fields>;
  min?: Maybe<Quality_Parameter_Category_Min_Fields>;
  stddev?: Maybe<Quality_Parameter_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_Parameter_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_Parameter_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_Parameter_Category_Sum_Fields>;
  var_pop?: Maybe<Quality_Parameter_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_Parameter_Category_Var_Samp_Fields>;
  variance?: Maybe<Quality_Parameter_Category_Variance_Fields>;
};


/** aggregate fields of "quality_parameter_category" */
export type Quality_Parameter_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_Parameter_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Quality_Parameter_Category_Avg_Fields = {
  __typename?: 'quality_parameter_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "quality_parameter_category". All fields are combined with a logical 'AND'. */
export type Quality_Parameter_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_Parameter_Category_Bool_Exp>>;
  _not?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_Parameter_Category_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality_parameter_category" */
export enum Quality_Parameter_Category_Constraint {
  /** unique or primary key constraint on columns "codename" */
  QualityParameterCategoryCodenameKey = 'quality_parameter_category_codename_key',
  /** unique or primary key constraint on columns "id" */
  QualityParameterCategoryPkey = 'quality_parameter_category_pkey'
}

/** input type for incrementing numeric columns in table "quality_parameter_category" */
export type Quality_Parameter_Category_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "quality_parameter_category" */
export type Quality_Parameter_Category_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quality_Parameter_Category_Max_Fields = {
  __typename?: 'quality_parameter_category_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Quality_Parameter_Category_Min_Fields = {
  __typename?: 'quality_parameter_category_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "quality_parameter_category" */
export type Quality_Parameter_Category_Mutation_Response = {
  __typename?: 'quality_parameter_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_Parameter_Category>;
};

/** input type for inserting object relation for remote table "quality_parameter_category" */
export type Quality_Parameter_Category_Obj_Rel_Insert_Input = {
  data: Quality_Parameter_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Parameter_Category_On_Conflict>;
};

/** on_conflict condition type for table "quality_parameter_category" */
export type Quality_Parameter_Category_On_Conflict = {
  constraint: Quality_Parameter_Category_Constraint;
  update_columns?: Array<Quality_Parameter_Category_Update_Column>;
  where?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "quality_parameter_category". */
export type Quality_Parameter_Category_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality_parameter_category */
export type Quality_Parameter_Category_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "quality_parameter_category" */
export enum Quality_Parameter_Category_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "quality_parameter_category" */
export type Quality_Parameter_Category_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Quality_Parameter_Category_Stddev_Fields = {
  __typename?: 'quality_parameter_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Quality_Parameter_Category_Stddev_Pop_Fields = {
  __typename?: 'quality_parameter_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Quality_Parameter_Category_Stddev_Samp_Fields = {
  __typename?: 'quality_parameter_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "quality_parameter_category" */
export type Quality_Parameter_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_Parameter_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_Parameter_Category_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quality_Parameter_Category_Sum_Fields = {
  __typename?: 'quality_parameter_category_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "quality_parameter_category" */
export enum Quality_Parameter_Category_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Quality_Parameter_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_Parameter_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_Parameter_Category_Set_Input>;
  where: Quality_Parameter_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_Parameter_Category_Var_Pop_Fields = {
  __typename?: 'quality_parameter_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Quality_Parameter_Category_Var_Samp_Fields = {
  __typename?: 'quality_parameter_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Quality_Parameter_Category_Variance_Fields = {
  __typename?: 'quality_parameter_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "quality_parameter" */
export enum Quality_Parameter_Constraint {
  /** unique or primary key constraint on columns "codename" */
  QualityParameterCodenameKey = 'quality_parameter_codename_key',
  /** unique or primary key constraint on columns "name", "kind", "category_id" */
  QualityParameterNameKindCategoryId_86bba0d5Uniq = 'quality_parameter_name_kind_category_id_86bba0d5_uniq',
  /** unique or primary key constraint on columns "id" */
  QualityParameterPkey = 'quality_parameter_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quality_Parameter_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quality_Parameter_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quality_Parameter_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "quality_parameter" */
export type Quality_Parameter_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "quality_parameter" */
export type Quality_Parameter_Insert_Input = {
  category?: InputMaybe<Quality_Parameter_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind?: InputMaybe<Instrument_Kind_Obj_Rel_Insert_Input>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['_varchar']>;
  request_parameters?: InputMaybe<Request_Parameters_Arr_Rel_Insert_Input>;
  template_parameters?: InputMaybe<Template_Parameter_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quality_Parameter_Max_Fields = {
  __typename?: 'quality_parameter_max_fields';
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_kind_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "quality_parameter" */
export type Quality_Parameter_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_Parameter_Min_Fields = {
  __typename?: 'quality_parameter_min_fields';
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_kind_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "quality_parameter" */
export type Quality_Parameter_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality_parameter" */
export type Quality_Parameter_Mutation_Response = {
  __typename?: 'quality_parameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_Parameter>;
};

/** input type for inserting object relation for remote table "quality_parameter" */
export type Quality_Parameter_Obj_Rel_Insert_Input = {
  data: Quality_Parameter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Parameter_On_Conflict>;
};

/** on_conflict condition type for table "quality_parameter" */
export type Quality_Parameter_On_Conflict = {
  constraint: Quality_Parameter_Constraint;
  update_columns?: Array<Quality_Parameter_Update_Column>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};

/** Ordering options when selecting data from "quality_parameter". */
export type Quality_Parameter_Order_By = {
  category?: InputMaybe<Quality_Parameter_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind?: InputMaybe<Instrument_Kind_Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  request_parameters_aggregate?: InputMaybe<Request_Parameters_Aggregate_Order_By>;
  template_parameters_aggregate?: InputMaybe<Template_Parameter_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality_parameter */
export type Quality_Parameter_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quality_Parameter_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "quality_parameter" */
export enum Quality_Parameter_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentKindId = 'instrument_kind_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "quality_parameter" */
export type Quality_Parameter_Set_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['_varchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Quality_Parameter_Stddev_Fields = {
  __typename?: 'quality_parameter_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quality_parameter" */
export type Quality_Parameter_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quality_Parameter_Stddev_Pop_Fields = {
  __typename?: 'quality_parameter_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quality_parameter" */
export type Quality_Parameter_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quality_Parameter_Stddev_Samp_Fields = {
  __typename?: 'quality_parameter_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quality_parameter" */
export type Quality_Parameter_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quality_parameter" */
export type Quality_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_Parameter_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_kind_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['_varchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quality_Parameter_Sum_Fields = {
  __typename?: 'quality_parameter_sum_fields';
  category_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_kind_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "quality_parameter" */
export type Quality_Parameter_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** update columns of table "quality_parameter" */
export enum Quality_Parameter_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentKindId = 'instrument_kind_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Options = 'options',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Quality_Parameter_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quality_Parameter_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quality_Parameter_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quality_Parameter_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quality_Parameter_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_Parameter_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quality_Parameter_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_Parameter_Set_Input>;
  where: Quality_Parameter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_Parameter_Var_Pop_Fields = {
  __typename?: 'quality_parameter_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quality_parameter" */
export type Quality_Parameter_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quality_Parameter_Var_Samp_Fields = {
  __typename?: 'quality_parameter_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quality_parameter" */
export type Quality_Parameter_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quality_Parameter_Variance_Fields = {
  __typename?: 'quality_parameter_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  instrument_kind_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quality_parameter" */
export type Quality_Parameter_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_kind_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "quality_stage" */
export type Quality_Stage = {
  __typename?: 'quality_stage';
  /** An array relationship */
  allowed_template_categories: Array<Quality_Stage_Allowed_Template_Category>;
  /** An aggregate relationship */
  allowed_template_categories_aggregate: Quality_Stage_Allowed_Template_Category_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  parent_stage?: Maybe<Quality_Stage>;
  parent_stage_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  secondary_stages: Array<Quality_Stage>;
  /** An aggregate relationship */
  secondary_stages_aggregate: Quality_Stage_Aggregate;
  sequence: Scalars['String'];
  /** A computed field, executes function "get_sequence_int" */
  sequence_int?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "quality_stage" */
export type Quality_StageAllowed_Template_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


/** columns and relationships of "quality_stage" */
export type Quality_StageAllowed_Template_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


/** columns and relationships of "quality_stage" */
export type Quality_StageSecondary_StagesArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Order_By>>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};


/** columns and relationships of "quality_stage" */
export type Quality_StageSecondary_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Order_By>>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};

/** aggregated selection of "quality_stage" */
export type Quality_Stage_Aggregate = {
  __typename?: 'quality_stage_aggregate';
  aggregate?: Maybe<Quality_Stage_Aggregate_Fields>;
  nodes: Array<Quality_Stage>;
};

/** aggregate fields of "quality_stage" */
export type Quality_Stage_Aggregate_Fields = {
  __typename?: 'quality_stage_aggregate_fields';
  avg?: Maybe<Quality_Stage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quality_Stage_Max_Fields>;
  min?: Maybe<Quality_Stage_Min_Fields>;
  stddev?: Maybe<Quality_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_Stage_Sum_Fields>;
  var_pop?: Maybe<Quality_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_Stage_Var_Samp_Fields>;
  variance?: Maybe<Quality_Stage_Variance_Fields>;
};


/** aggregate fields of "quality_stage" */
export type Quality_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quality_stage" */
export type Quality_Stage_Aggregate_Order_By = {
  avg?: InputMaybe<Quality_Stage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_Stage_Max_Order_By>;
  min?: InputMaybe<Quality_Stage_Min_Order_By>;
  stddev?: InputMaybe<Quality_Stage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quality_Stage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quality_Stage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quality_Stage_Sum_Order_By>;
  var_pop?: InputMaybe<Quality_Stage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quality_Stage_Var_Samp_Order_By>;
  variance?: InputMaybe<Quality_Stage_Variance_Order_By>;
};

/** columns and relationships of "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category = {
  __typename?: 'quality_stage_allowed_template_category';
  id: Scalars['bigint'];
  /** An object relationship */
  quality_stage: Quality_Stage;
  qualitystage_id: Scalars['bigint'];
  /** An object relationship */
  template_category: Template_Category;
  templatecategory_id: Scalars['bigint'];
};

/** aggregated selection of "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Aggregate = {
  __typename?: 'quality_stage_allowed_template_category_aggregate';
  aggregate?: Maybe<Quality_Stage_Allowed_Template_Category_Aggregate_Fields>;
  nodes: Array<Quality_Stage_Allowed_Template_Category>;
};

/** aggregate fields of "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Aggregate_Fields = {
  __typename?: 'quality_stage_allowed_template_category_aggregate_fields';
  avg?: Maybe<Quality_Stage_Allowed_Template_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quality_Stage_Allowed_Template_Category_Max_Fields>;
  min?: Maybe<Quality_Stage_Allowed_Template_Category_Min_Fields>;
  stddev?: Maybe<Quality_Stage_Allowed_Template_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_Stage_Allowed_Template_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_Stage_Allowed_Template_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_Stage_Allowed_Template_Category_Sum_Fields>;
  var_pop?: Maybe<Quality_Stage_Allowed_Template_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_Stage_Allowed_Template_Category_Var_Samp_Fields>;
  variance?: Maybe<Quality_Stage_Allowed_Template_Category_Variance_Fields>;
};


/** aggregate fields of "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Quality_Stage_Allowed_Template_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_Stage_Allowed_Template_Category_Max_Order_By>;
  min?: InputMaybe<Quality_Stage_Allowed_Template_Category_Min_Order_By>;
  stddev?: InputMaybe<Quality_Stage_Allowed_Template_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quality_Stage_Allowed_Template_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quality_Stage_Allowed_Template_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quality_Stage_Allowed_Template_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Quality_Stage_Allowed_Template_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quality_Stage_Allowed_Template_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Quality_Stage_Allowed_Template_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Arr_Rel_Insert_Input = {
  data: Array<Quality_Stage_Allowed_Template_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Stage_Allowed_Template_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Quality_Stage_Allowed_Template_Category_Avg_Fields = {
  __typename?: 'quality_stage_allowed_template_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quality_stage_allowed_template_category". All fields are combined with a logical 'AND'. */
export type Quality_Stage_Allowed_Template_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Bool_Exp>>;
  _not?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_stage?: InputMaybe<Quality_Stage_Bool_Exp>;
  qualitystage_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_category?: InputMaybe<Template_Category_Bool_Exp>;
  templatecategory_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality_stage_allowed_template_category" */
export enum Quality_Stage_Allowed_Template_Category_Constraint {
  /** unique or primary key constraint on columns "templatecategory_id", "qualitystage_id" */
  QualityStageAllowedTeQualitystageIdTemplate_00c87a07Uniq = 'quality_stage_allowed_te_qualitystage_id_template_00c87a07_uniq',
  /** unique or primary key constraint on columns "id" */
  QualityStageAllowedTemplateCategoryPkey = 'quality_stage_allowed_template_category_pkey'
}

/** input type for incrementing numeric columns in table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  quality_stage?: InputMaybe<Quality_Stage_Obj_Rel_Insert_Input>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  template_category?: InputMaybe<Template_Category_Obj_Rel_Insert_Input>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Quality_Stage_Allowed_Template_Category_Max_Fields = {
  __typename?: 'quality_stage_allowed_template_category_max_fields';
  id?: Maybe<Scalars['bigint']>;
  qualitystage_id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_Stage_Allowed_Template_Category_Min_Fields = {
  __typename?: 'quality_stage_allowed_template_category_min_fields';
  id?: Maybe<Scalars['bigint']>;
  qualitystage_id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Mutation_Response = {
  __typename?: 'quality_stage_allowed_template_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_Stage_Allowed_Template_Category>;
};

/** on_conflict condition type for table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_On_Conflict = {
  constraint: Quality_Stage_Allowed_Template_Category_Constraint;
  update_columns?: Array<Quality_Stage_Allowed_Template_Category_Update_Column>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "quality_stage_allowed_template_category". */
export type Quality_Stage_Allowed_Template_Category_Order_By = {
  id?: InputMaybe<Order_By>;
  quality_stage?: InputMaybe<Quality_Stage_Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_category?: InputMaybe<Template_Category_Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality_stage_allowed_template_category */
export type Quality_Stage_Allowed_Template_Category_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "quality_stage_allowed_template_category" */
export enum Quality_Stage_Allowed_Template_Category_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualitystageId = 'qualitystage_id',
  /** column name */
  TemplatecategoryId = 'templatecategory_id'
}

/** input type for updating data in table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Quality_Stage_Allowed_Template_Category_Stddev_Fields = {
  __typename?: 'quality_stage_allowed_template_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quality_Stage_Allowed_Template_Category_Stddev_Pop_Fields = {
  __typename?: 'quality_stage_allowed_template_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quality_Stage_Allowed_Template_Category_Stddev_Samp_Fields = {
  __typename?: 'quality_stage_allowed_template_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_Stage_Allowed_Template_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_Stage_Allowed_Template_Category_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Quality_Stage_Allowed_Template_Category_Sum_Fields = {
  __typename?: 'quality_stage_allowed_template_category_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  qualitystage_id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** update columns of table "quality_stage_allowed_template_category" */
export enum Quality_Stage_Allowed_Template_Category_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualitystageId = 'qualitystage_id',
  /** column name */
  TemplatecategoryId = 'templatecategory_id'
}

export type Quality_Stage_Allowed_Template_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_Stage_Allowed_Template_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_Stage_Allowed_Template_Category_Set_Input>;
  where: Quality_Stage_Allowed_Template_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_Stage_Allowed_Template_Category_Var_Pop_Fields = {
  __typename?: 'quality_stage_allowed_template_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quality_Stage_Allowed_Template_Category_Var_Samp_Fields = {
  __typename?: 'quality_stage_allowed_template_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quality_Stage_Allowed_Template_Category_Variance_Fields = {
  __typename?: 'quality_stage_allowed_template_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quality_stage_allowed_template_category" */
export type Quality_Stage_Allowed_Template_Category_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** input type for inserting array relation for remote table "quality_stage" */
export type Quality_Stage_Arr_Rel_Insert_Input = {
  data: Array<Quality_Stage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Stage_On_Conflict>;
};

/** aggregate avg on columns */
export type Quality_Stage_Avg_Fields = {
  __typename?: 'quality_stage_avg_fields';
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quality_stage" */
export type Quality_Stage_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quality_stage". All fields are combined with a logical 'AND'. */
export type Quality_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_Stage_Bool_Exp>>;
  _not?: InputMaybe<Quality_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_Stage_Bool_Exp>>;
  allowed_template_categories?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_stage?: InputMaybe<Quality_Stage_Bool_Exp>;
  parent_stage_id?: InputMaybe<Bigint_Comparison_Exp>;
  secondary_stages?: InputMaybe<Quality_Stage_Bool_Exp>;
  sequence?: InputMaybe<String_Comparison_Exp>;
  sequence_int?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality_stage" */
export enum Quality_Stage_Constraint {
  /** unique or primary key constraint on columns "codename" */
  QualityStageCodenameKey = 'quality_stage_codename_key',
  /** unique or primary key constraint on columns "id", "parent_stage_id" */
  QualityStageIdParentStageIdB7ded63dUniq = 'quality_stage_id_parent_stage_id_b7ded63d_uniq',
  /** unique or primary key constraint on columns "id" */
  QualityStagePkey = 'quality_stage_pkey'
}

/** input type for incrementing numeric columns in table "quality_stage" */
export type Quality_Stage_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  parent_stage_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "quality_stage" */
export type Quality_Stage_Insert_Input = {
  allowed_template_categories?: InputMaybe<Quality_Stage_Allowed_Template_Category_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_stage?: InputMaybe<Quality_Stage_Obj_Rel_Insert_Input>;
  parent_stage_id?: InputMaybe<Scalars['bigint']>;
  secondary_stages?: InputMaybe<Quality_Stage_Arr_Rel_Insert_Input>;
  sequence?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Quality_Stage_Max_Fields = {
  __typename?: 'quality_stage_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  parent_stage_id?: Maybe<Scalars['bigint']>;
  sequence?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "quality_stage" */
export type Quality_Stage_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_Stage_Min_Fields = {
  __typename?: 'quality_stage_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  parent_stage_id?: Maybe<Scalars['bigint']>;
  sequence?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "quality_stage" */
export type Quality_Stage_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality_stage" */
export type Quality_Stage_Mutation_Response = {
  __typename?: 'quality_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_Stage>;
};

/** input type for inserting object relation for remote table "quality_stage" */
export type Quality_Stage_Obj_Rel_Insert_Input = {
  data: Quality_Stage_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Stage_On_Conflict>;
};

/** on_conflict condition type for table "quality_stage" */
export type Quality_Stage_On_Conflict = {
  constraint: Quality_Stage_Constraint;
  update_columns?: Array<Quality_Stage_Update_Column>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "quality_stage". */
export type Quality_Stage_Order_By = {
  allowed_template_categories_aggregate?: InputMaybe<Quality_Stage_Allowed_Template_Category_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_stage?: InputMaybe<Quality_Stage_Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  secondary_stages_aggregate?: InputMaybe<Quality_Stage_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
  sequence_int?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality_stage */
export type Quality_Stage_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "quality_stage" */
export enum Quality_Stage_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentStageId = 'parent_stage_id',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "quality_stage" */
export type Quality_Stage_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_stage_id?: InputMaybe<Scalars['bigint']>;
  sequence?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Quality_Stage_Stddev_Fields = {
  __typename?: 'quality_stage_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quality_stage" */
export type Quality_Stage_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quality_Stage_Stddev_Pop_Fields = {
  __typename?: 'quality_stage_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quality_stage" */
export type Quality_Stage_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quality_Stage_Stddev_Samp_Fields = {
  __typename?: 'quality_stage_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quality_stage" */
export type Quality_Stage_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quality_stage" */
export type Quality_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_Stage_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_stage_id?: InputMaybe<Scalars['bigint']>;
  sequence?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quality_Stage_Sum_Fields = {
  __typename?: 'quality_stage_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  parent_stage_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "quality_stage" */
export type Quality_Stage_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

/** update columns of table "quality_stage" */
export enum Quality_Stage_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ParentStageId = 'parent_stage_id',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Quality_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_Stage_Set_Input>;
  where: Quality_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_Stage_Var_Pop_Fields = {
  __typename?: 'quality_stage_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quality_stage" */
export type Quality_Stage_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quality_Stage_Var_Samp_Fields = {
  __typename?: 'quality_stage_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quality_stage" */
export type Quality_Stage_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quality_Stage_Variance_Fields = {
  __typename?: 'quality_stage_variance_fields';
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quality_stage" */
export type Quality_Stage_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "Transaction_mode" */
  Transaction_mode: Array<Transaction_Mode>;
  /** fetch aggregated fields from the table: "Transaction_mode" */
  Transaction_mode_aggregate: Transaction_Mode_Aggregate;
  /** fetch data from the table: "Transaction_mode" using primary key columns */
  Transaction_mode_by_pk?: Maybe<Transaction_Mode>;
  /** fetch data from the table: "action_log" */
  action_log: Array<Action_Log>;
  /** fetch aggregated fields from the table: "action_log" */
  action_log_aggregate: Action_Log_Aggregate;
  /** fetch data from the table: "action_log" using primary key columns */
  action_log_by_pk?: Maybe<Action_Log>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "advance_payment" */
  advance_payment: Array<Advance_Payment>;
  /** fetch aggregated fields from the table: "advance_payment" */
  advance_payment_aggregate: Advance_Payment_Aggregate;
  /** fetch data from the table: "advance_payment" using primary key columns */
  advance_payment_by_pk?: Maybe<Advance_Payment>;
  /** fetch data from the table: "advance_payment_parameters" */
  advance_payment_parameters: Array<Advance_Payment_Parameters>;
  /** fetch aggregated fields from the table: "advance_payment_parameters" */
  advance_payment_parameters_aggregate: Advance_Payment_Parameters_Aggregate;
  /** fetch data from the table: "advance_payment_parameters" using primary key columns */
  advance_payment_parameters_by_pk?: Maybe<Advance_Payment_Parameters>;
  advance_summary_by_receipt?: Maybe<AdvanceSummaryType>;
  advance_summary_by_trade?: Maybe<AdvanceSummaryType>;
  advance_summary_dashboard?: Maybe<AdvanceSummaryDashboardType>;
  advance_summary_dashboard_receipt?: Maybe<AdvanceSummaryDashboardType>;
  /** fetch data from the table: "agent" */
  agent: Array<Agent>;
  /** fetch aggregated fields from the table: "agent" */
  agent_aggregate: Agent_Aggregate;
  /** fetch data from the table: "agent" using primary key columns */
  agent_by_pk?: Maybe<Agent>;
  /** fetch data from the table: "agent_company" */
  agent_company: Array<Agent_Company>;
  /** fetch aggregated fields from the table: "agent_company" */
  agent_company_aggregate: Agent_Company_Aggregate;
  /** fetch data from the table: "agent_company" using primary key columns */
  agent_company_by_pk?: Maybe<Agent_Company>;
  /** fetch data from the table: "agent_role" */
  agent_role: Array<Agent_Role>;
  /** fetch aggregated fields from the table: "agent_role" */
  agent_role_aggregate: Agent_Role_Aggregate;
  /** fetch data from the table: "agent_role" using primary key columns */
  agent_role_by_pk?: Maybe<Agent_Role>;
  aggregate_invoice_summary?: Maybe<AggregateInvoiceSummaryType>;
  aggregate_receipt_seller_summary?: Maybe<SellerBifurcationType>;
  aggregate_trade_seller_summary?: Maybe<SellerBifurcationType>;
  /** fetch data from the table: "agreement_co_owner" */
  agreement_co_owner: Array<Agreement_Co_Owner>;
  /** fetch aggregated fields from the table: "agreement_co_owner" */
  agreement_co_owner_aggregate: Agreement_Co_Owner_Aggregate;
  /** fetch data from the table: "agreement_co_owner_agreement_invoices" */
  agreement_co_owner_agreement_invoices: Array<Agreement_Co_Owner_Agreement_Invoices>;
  /** fetch aggregated fields from the table: "agreement_co_owner_agreement_invoices" */
  agreement_co_owner_agreement_invoices_aggregate: Agreement_Co_Owner_Agreement_Invoices_Aggregate;
  /** fetch data from the table: "agreement_co_owner_agreement_invoices" using primary key columns */
  agreement_co_owner_agreement_invoices_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Invoices>;
  /** fetch data from the table: "agreement_co_owner_agreement_plots" */
  agreement_co_owner_agreement_plots: Array<Agreement_Co_Owner_Agreement_Plots>;
  /** fetch aggregated fields from the table: "agreement_co_owner_agreement_plots" */
  agreement_co_owner_agreement_plots_aggregate: Agreement_Co_Owner_Agreement_Plots_Aggregate;
  /** fetch data from the table: "agreement_co_owner_agreement_plots" using primary key columns */
  agreement_co_owner_agreement_plots_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Plots>;
  /** fetch data from the table: "agreement_co_owner" using primary key columns */
  agreement_co_owner_by_pk?: Maybe<Agreement_Co_Owner>;
  /** fetch data from the table: "agreement_co_owner_legal_agreement" */
  agreement_co_owner_legal_agreement: Array<Agreement_Co_Owner_Legal_Agreement>;
  /** fetch aggregated fields from the table: "agreement_co_owner_legal_agreement" */
  agreement_co_owner_legal_agreement_aggregate: Agreement_Co_Owner_Legal_Agreement_Aggregate;
  /** fetch data from the table: "agreement_co_owner_legal_agreement" using primary key columns */
  agreement_co_owner_legal_agreement_by_pk?: Maybe<Agreement_Co_Owner_Legal_Agreement>;
  /** fetch data from the table: "agreement_invoice" */
  agreement_invoice: Array<Agreement_Invoice>;
  /** fetch aggregated fields from the table: "agreement_invoice" */
  agreement_invoice_aggregate: Agreement_Invoice_Aggregate;
  /** fetch data from the table: "agreement_invoice_agreement_invoice_items" */
  agreement_invoice_agreement_invoice_items: Array<Agreement_Invoice_Agreement_Invoice_Items>;
  /** fetch aggregated fields from the table: "agreement_invoice_agreement_invoice_items" */
  agreement_invoice_agreement_invoice_items_aggregate: Agreement_Invoice_Agreement_Invoice_Items_Aggregate;
  /** fetch data from the table: "agreement_invoice_agreement_invoice_items" using primary key columns */
  agreement_invoice_agreement_invoice_items_by_pk?: Maybe<Agreement_Invoice_Agreement_Invoice_Items>;
  /** fetch data from the table: "agreement_invoice" using primary key columns */
  agreement_invoice_by_pk?: Maybe<Agreement_Invoice>;
  /** fetch data from the table: "agreement_invoice_item" */
  agreement_invoice_item: Array<Agreement_Invoice_Item>;
  /** fetch aggregated fields from the table: "agreement_invoice_item" */
  agreement_invoice_item_aggregate: Agreement_Invoice_Item_Aggregate;
  /** fetch data from the table: "agreement_invoice_item" using primary key columns */
  agreement_invoice_item_by_pk?: Maybe<Agreement_Invoice_Item>;
  /** fetch data from the table: "agreement_invoice_transaction" */
  agreement_invoice_transaction: Array<Agreement_Invoice_Transaction>;
  /** fetch aggregated fields from the table: "agreement_invoice_transaction" */
  agreement_invoice_transaction_aggregate: Agreement_Invoice_Transaction_Aggregate;
  /** fetch data from the table: "agreement_invoice_transaction" using primary key columns */
  agreement_invoice_transaction_by_pk?: Maybe<Agreement_Invoice_Transaction>;
  /** fetch data from the table: "agreement_plot" */
  agreement_plot: Array<Agreement_Plot>;
  /** fetch aggregated fields from the table: "agreement_plot" */
  agreement_plot_aggregate: Agreement_Plot_Aggregate;
  /** fetch data from the table: "agreement_plot" using primary key columns */
  agreement_plot_by_pk?: Maybe<Agreement_Plot>;
  /** fetch data from the table: "agreement_transaction" */
  agreement_transaction: Array<Agreement_Transaction>;
  /** fetch aggregated fields from the table: "agreement_transaction" */
  agreement_transaction_aggregate: Agreement_Transaction_Aggregate;
  /** fetch data from the table: "agreement_transaction_attachments" */
  agreement_transaction_attachments: Array<Agreement_Transaction_Attachments>;
  /** fetch aggregated fields from the table: "agreement_transaction_attachments" */
  agreement_transaction_attachments_aggregate: Agreement_Transaction_Attachments_Aggregate;
  /** fetch data from the table: "agreement_transaction_attachments" using primary key columns */
  agreement_transaction_attachments_by_pk?: Maybe<Agreement_Transaction_Attachments>;
  /** fetch data from the table: "agreement_transaction" using primary key columns */
  agreement_transaction_by_pk?: Maybe<Agreement_Transaction>;
  all_bookings?: Maybe<Array<Maybe<BookingGlType>>>;
  all_companies?: Maybe<Array<Maybe<CompanyGlType>>>;
  all_departments?: Maybe<Array<Maybe<DepartmentGlType>>>;
  all_depots?: Maybe<Array<Maybe<DepotGlType>>>;
  all_distribution_centres?: Maybe<Array<Maybe<DistributionCentreGlType>>>;
  all_docks?: Maybe<Array<Maybe<DockGlType>>>;
  all_harvest_seasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  all_inwards?: Maybe<Array<Maybe<InwardGlType>>>;
  all_my_orders?: Maybe<Array<Maybe<OrderGlType>>>;
  all_my_plot_summarys?: Maybe<Array<Maybe<PlotCommodityGlType>>>;
  all_packing_materials?: Maybe<Array<Maybe<SkuPackingMaterialGlType>>>;
  all_production_batchs?: Maybe<Array<Maybe<ProductionBatchGlType>>>;
  all_sellable_item_stocks?: Maybe<Array<Maybe<SellableItemStockGlType>>>;
  all_storage_location_alerts?: Maybe<Array<Maybe<StorageLocationAlertsType>>>;
  all_storage_locations?: Maybe<StorageLocationDashboardType>;
  all_trade_years?: Maybe<Array<Maybe<TradeYearType>>>;
  all_trips?: Maybe<Array<Maybe<TripGlType>>>;
  all_varieties?: Maybe<Array<Maybe<CommodityVarietyGlType>>>;
  all_variety_groups?: Maybe<Array<Maybe<CommodityGroupGlType>>>;
  all_vehicles?: Maybe<Array<Maybe<VehicleGlType>>>;
  /** fetch data from the table: "amendment_case" */
  amendment_case: Array<Amendment_Case>;
  /** fetch aggregated fields from the table: "amendment_case" */
  amendment_case_aggregate: Amendment_Case_Aggregate;
  /** fetch data from the table: "amendment_case" using primary key columns */
  amendment_case_by_pk?: Maybe<Amendment_Case>;
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch aggregated fields from the table: "auth_group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table: "auth_group_permissions" */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** fetch aggregated fields from the table: "auth_group_permissions" */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  /** fetch data from the table: "auth_group_permissions" using primary key columns */
  auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** fetch data from the table: "auth_permission" */
  auth_permission: Array<Auth_Permission>;
  /** fetch aggregated fields from the table: "auth_permission" */
  auth_permission_aggregate: Auth_Permission_Aggregate;
  /** fetch data from the table: "auth_permission" using primary key columns */
  auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** fetch data from the table: "base_user" */
  base_user: Array<Base_User>;
  /** fetch data from the table: "base_user_address_book" */
  base_user_address_book: Array<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user_address_book" */
  base_user_address_book_aggregate: Base_User_Address_Book_Aggregate;
  /** fetch data from the table: "base_user_address_book" using primary key columns */
  base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user" */
  base_user_aggregate: Base_User_Aggregate;
  base_user_by_group?: Maybe<Array<Maybe<BaseUserGlType>>>;
  /** fetch data from the table: "base_user" using primary key columns */
  base_user_by_pk?: Maybe<Base_User>;
  /** An array relationship */
  base_user_companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  base_user_companies_aggregate: Base_User_Companies_Aggregate;
  /** fetch data from the table: "base_user_companies" using primary key columns */
  base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  base_user_context?: Maybe<UserContextType>;
  /** fetch data from the table: "base_user_departments" */
  base_user_departments: Array<Base_User_Departments>;
  /** fetch aggregated fields from the table: "base_user_departments" */
  base_user_departments_aggregate: Base_User_Departments_Aggregate;
  /** fetch data from the table: "base_user_departments" using primary key columns */
  base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  base_user_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "base_user_groups" */
  base_user_groups: Array<Base_User_Groups>;
  /** fetch aggregated fields from the table: "base_user_groups" */
  base_user_groups_aggregate: Base_User_Groups_Aggregate;
  /** fetch data from the table: "base_user_groups" using primary key columns */
  base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** fetch data from the table: "base_user_network" */
  base_user_network: Array<Base_User_Network>;
  /** fetch aggregated fields from the table: "base_user_network" */
  base_user_network_aggregate: Base_User_Network_Aggregate;
  /** fetch data from the table: "base_user_network" using primary key columns */
  base_user_network_by_pk?: Maybe<Base_User_Network>;
  base_user_payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** fetch data from the table: "base_user_user_permissions" */
  base_user_user_permissions: Array<Base_User_User_Permissions>;
  /** fetch aggregated fields from the table: "base_user_user_permissions" */
  base_user_user_permissions_aggregate: Base_User_User_Permissions_Aggregate;
  /** fetch data from the table: "base_user_user_permissions" using primary key columns */
  base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  booking_detail?: Maybe<BookingGlType>;
  /** fetch data from the table: "brand" */
  brand: Array<Brand>;
  /** fetch aggregated fields from the table: "brand" */
  brand_aggregate: Brand_Aggregate;
  /** fetch data from the table: "brand" using primary key columns */
  brand_by_pk?: Maybe<Brand>;
  /** fetch data from the table: "brand_company" */
  brand_company: Array<Brand_Company>;
  /** fetch aggregated fields from the table: "brand_company" */
  brand_company_aggregate: Brand_Company_Aggregate;
  /** fetch data from the table: "brand_company" using primary key columns */
  brand_company_by_pk?: Maybe<Brand_Company>;
  /** fetch data from the table: "breeder" */
  breeder: Array<Breeder>;
  /** fetch aggregated fields from the table: "breeder" */
  breeder_aggregate: Breeder_Aggregate;
  /** fetch data from the table: "breeder" using primary key columns */
  breeder_by_pk?: Maybe<Breeder>;
  /** fetch data from the table: "business" */
  business: Array<Business>;
  /** fetch aggregated fields from the table: "business" */
  business_aggregate: Business_Aggregate;
  /** fetch data from the table: "business" using primary key columns */
  business_by_pk?: Maybe<Business>;
  /** fetch data from the table: "business_commodities_supplied" */
  business_commodities_supplied: Array<Business_Commodities_Supplied>;
  /** fetch aggregated fields from the table: "business_commodities_supplied" */
  business_commodities_supplied_aggregate: Business_Commodities_Supplied_Aggregate;
  /** fetch data from the table: "business_commodities_supplied" using primary key columns */
  business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** fetch data from the table: "business_companies" */
  business_companies: Array<Business_Companies>;
  /** fetch aggregated fields from the table: "business_companies" */
  business_companies_aggregate: Business_Companies_Aggregate;
  /** fetch data from the table: "business_companies" using primary key columns */
  business_companies_by_pk?: Maybe<Business_Companies>;
  business_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "business_field" */
  business_field: Array<Business_Field>;
  /** fetch aggregated fields from the table: "business_field" */
  business_field_aggregate: Business_Field_Aggregate;
  /** fetch data from the table: "business_field" using primary key columns */
  business_field_by_pk?: Maybe<Business_Field>;
  /** fetch data from the table: "business_group" */
  business_group: Array<Business_Group>;
  /** fetch aggregated fields from the table: "business_group" */
  business_group_aggregate: Business_Group_Aggregate;
  /** fetch data from the table: "business_group" using primary key columns */
  business_group_by_pk?: Maybe<Business_Group>;
  business_group_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "business_group_network" */
  business_group_network: Array<Business_Group_Network>;
  /** fetch aggregated fields from the table: "business_group_network" */
  business_group_network_aggregate: Business_Group_Network_Aggregate;
  /** fetch data from the table: "business_group_network" using primary key columns */
  business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** fetch data from the table: "business_groups" */
  business_groups: Array<Business_Groups>;
  /** fetch aggregated fields from the table: "business_groups" */
  business_groups_aggregate: Business_Groups_Aggregate;
  /** fetch data from the table: "business_groups" using primary key columns */
  business_groups_by_pk?: Maybe<Business_Groups>;
  /** fetch data from the table: "business_network" */
  business_network: Array<Business_Network>;
  /** fetch aggregated fields from the table: "business_network" */
  business_network_aggregate: Business_Network_Aggregate;
  /** fetch data from the table: "business_network" using primary key columns */
  business_network_by_pk?: Maybe<Business_Network>;
  business_payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** fetch data from the table: "business_secondary_pocs" */
  business_secondary_pocs: Array<Business_Secondary_Pocs>;
  /** fetch aggregated fields from the table: "business_secondary_pocs" */
  business_secondary_pocs_aggregate: Business_Secondary_Pocs_Aggregate;
  /** fetch data from the table: "business_secondary_pocs" using primary key columns */
  business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  buyer_credit_wallet_info?: Maybe<BuyerCreditWalletInfoType>;
  buyer_hash?: Maybe<Scalars['String']>;
  chemical_wise_count?: Maybe<ChemicalWiseCountOutput>;
  chemical_wise_fail?: Maybe<ChemicalWiseFailOutput>;
  chemicals_list?: Maybe<ChemicalListOutput>;
  /** fetch data from the table: "commodity" */
  commodity: Array<Commodity>;
  /** fetch aggregated fields from the table: "commodity" */
  commodity_aggregate: Commodity_Aggregate;
  /** fetch data from the table: "commodity" using primary key columns */
  commodity_by_pk?: Maybe<Commodity>;
  commodity_si_unit?: Maybe<Array<Maybe<SiUnitType>>>;
  /** fetch data from the table: "commodity_variety" */
  commodity_variety: Array<Commodity_Variety>;
  /** fetch aggregated fields from the table: "commodity_variety" */
  commodity_variety_aggregate: Commodity_Variety_Aggregate;
  /** fetch data from the table: "commodity_variety" using primary key columns */
  commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** fetch data from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups: Array<Commodity_Variety_Secondary_Groups>;
  /** fetch aggregated fields from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  /** fetch data from the table: "commodity_variety_secondary_groups" using primary key columns */
  commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_categories" */
  company_categories: Array<Company_Categories>;
  /** fetch aggregated fields from the table: "company_categories" */
  company_categories_aggregate: Company_Categories_Aggregate;
  /** fetch data from the table: "company_categories" using primary key columns */
  company_categories_by_pk?: Maybe<Company_Categories>;
  /** fetch data from the table: "company_category" */
  company_category: Array<Company_Category>;
  /** fetch aggregated fields from the table: "company_category" */
  company_category_aggregate: Company_Category_Aggregate;
  /** fetch data from the table: "company_category" using primary key columns */
  company_category_by_pk?: Maybe<Company_Category>;
  company_documents?: Maybe<Array<Maybe<DocumentType>>>;
  company_payment_details?: Maybe<Array<Maybe<PaymentDetailType>>>;
  /** fetch data from the table: "company_share_holder" */
  company_share_holder: Array<Company_Share_Holder>;
  /** fetch aggregated fields from the table: "company_share_holder" */
  company_share_holder_aggregate: Company_Share_Holder_Aggregate;
  /** fetch data from the table: "company_share_holder" using primary key columns */
  company_share_holder_by_pk?: Maybe<Company_Share_Holder>;
  /** fetch data from the table: "django_content_type" */
  content_type: Array<Django_Content_Type>;
  /** fetch aggregated fields from the table: "django_content_type" */
  content_type_aggregate: Django_Content_Type_Aggregate;
  /** fetch data from the table: "django_content_type" using primary key columns */
  content_type_by_pk?: Maybe<Django_Content_Type>;
  /** fetch data from the table: "credit" */
  credit: Array<Credit>;
  /** fetch aggregated fields from the table: "credit" */
  credit_aggregate: Credit_Aggregate;
  /** fetch data from the table: "credit" using primary key columns */
  credit_by_pk?: Maybe<Credit>;
  credit_detail?: Maybe<Array<Maybe<CreditCustomType>>>;
  /** fetch data from the table: "credit_note" */
  credit_note: Array<Credit_Note>;
  /** fetch aggregated fields from the table: "credit_note" */
  credit_note_aggregate: Credit_Note_Aggregate;
  /** fetch data from the table: "credit_note" using primary key columns */
  credit_note_by_pk?: Maybe<Credit_Note>;
  /** fetch data from the table: "credit_request" */
  credit_request: Array<Credit_Request>;
  /** fetch aggregated fields from the table: "credit_request" */
  credit_request_aggregate: Credit_Request_Aggregate;
  /** fetch data from the table: "credit_request" using primary key columns */
  credit_request_by_pk?: Maybe<Credit_Request>;
  credit_request_detail?: Maybe<Array<Maybe<CreditRequestDetailType>>>;
  /** fetch data from the table: "credit_status" */
  credit_status: Array<Credit_Status>;
  /** fetch aggregated fields from the table: "credit_status" */
  credit_status_aggregate: Credit_Status_Aggregate;
  /** fetch data from the table: "credit_status" using primary key columns */
  credit_status_by_pk?: Maybe<Credit_Status>;
  /** fetch data from the table: "credit_status_parents" */
  credit_status_parents: Array<Credit_Status_Parents>;
  /** fetch aggregated fields from the table: "credit_status_parents" */
  credit_status_parents_aggregate: Credit_Status_Parents_Aggregate;
  /** fetch data from the table: "credit_status_parents" using primary key columns */
  credit_status_parents_by_pk?: Maybe<Credit_Status_Parents>;
  credit_summary?: Maybe<Array<Maybe<CreditSummaryType>>>;
  credit_summary_aggregated?: Maybe<CreditSummaryAggregatedType>;
  /** fetch data from the table: "credit_transaction" */
  credit_transaction: Array<Credit_Transaction>;
  /** fetch aggregated fields from the table: "credit_transaction" */
  credit_transaction_aggregate: Credit_Transaction_Aggregate;
  /** fetch data from the table: "credit_transaction" using primary key columns */
  credit_transaction_by_pk?: Maybe<Credit_Transaction>;
  /** fetch data from the table: "credit_wallet" */
  credit_wallet: Array<Credit_Wallet>;
  /** fetch aggregated fields from the table: "credit_wallet" */
  credit_wallet_aggregate: Credit_Wallet_Aggregate;
  /** fetch data from the table: "credit_wallet" using primary key columns */
  credit_wallet_by_pk?: Maybe<Credit_Wallet>;
  credit_wallet_invoice_list?: Maybe<Array<Maybe<CreditWalletInvoiceListCustomType>>>;
  credit_wallet_invoice_summary?: Maybe<CreditWalletInvoiceSummaryType>;
  credit_wallet_list?: Maybe<CreditWalletListResponseType>;
  /** fetch data from the table: "credit_wallet_request" */
  credit_wallet_request: Array<Credit_Wallet_Request>;
  /** fetch aggregated fields from the table: "credit_wallet_request" */
  credit_wallet_request_aggregate: Credit_Wallet_Request_Aggregate;
  /** fetch data from the table: "credit_wallet_request" using primary key columns */
  credit_wallet_request_by_pk?: Maybe<Credit_Wallet_Request>;
  /** fetch data from the table: "credit_wallet_status" */
  credit_wallet_status: Array<Credit_Wallet_Status>;
  /** fetch aggregated fields from the table: "credit_wallet_status" */
  credit_wallet_status_aggregate: Credit_Wallet_Status_Aggregate;
  /** fetch data from the table: "credit_wallet_status" using primary key columns */
  credit_wallet_status_by_pk?: Maybe<Credit_Wallet_Status>;
  credit_wallet_summary_aggregated?: Maybe<CreditWalletSummaryAggregatedType>;
  /** fetch data from the table: "crop" */
  crop: Array<Crop>;
  /** fetch aggregated fields from the table: "crop" */
  crop_aggregate: Crop_Aggregate;
  /** fetch data from the table: "crop" using primary key columns */
  crop_by_pk?: Maybe<Crop>;
  /** fetch data from the table: "crop_group" */
  crop_group: Array<Crop_Group>;
  /** fetch aggregated fields from the table: "crop_group" */
  crop_group_aggregate: Crop_Group_Aggregate;
  /** fetch data from the table: "crop_group" using primary key columns */
  crop_group_by_pk?: Maybe<Crop_Group>;
  crop_growth_stages_by_plot_crop_codename?: Maybe<Array<Maybe<PrimaryGrowthStagesType>>>;
  /** fetch data from the table: "crop_infestation" */
  crop_infestation: Array<Crop_Infestation>;
  /** fetch aggregated fields from the table: "crop_infestation" */
  crop_infestation_aggregate: Crop_Infestation_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" */
  crop_infestation_attachment: Array<Crop_Infestation_Attachment>;
  /** fetch aggregated fields from the table: "crop_infestation_attachment" */
  crop_infestation_attachment_aggregate: Crop_Infestation_Attachment_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" using primary key columns */
  crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** fetch data from the table: "crop_infestation" using primary key columns */
  crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  crop_infestation_details_by_pk?: Maybe<CropInfestationDetailType>;
  crop_infestations_by_crop_codename?: Maybe<Array<Maybe<CropInfestationListType>>>;
  crop_infestations_by_plot_crop_codename?: Maybe<Array<Maybe<CropInfestationListType>>>;
  /** fetch data from the table: "crop_milestone" */
  crop_milestone: Array<Crop_Milestone>;
  /** fetch aggregated fields from the table: "crop_milestone" */
  crop_milestone_aggregate: Crop_Milestone_Aggregate;
  /** fetch data from the table: "crop_milestone" using primary key columns */
  crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** fetch data from the table: "crop_rootstock" */
  crop_rootstock: Array<Crop_Rootstock>;
  /** fetch aggregated fields from the table: "crop_rootstock" */
  crop_rootstock_aggregate: Crop_Rootstock_Aggregate;
  /** fetch data from the table: "crop_rootstock" using primary key columns */
  crop_rootstock_by_pk?: Maybe<Crop_Rootstock>;
  /** fetch data from the table: "crop_variety" */
  crop_variety: Array<Crop_Variety>;
  /** fetch aggregated fields from the table: "crop_variety" */
  crop_variety_aggregate: Crop_Variety_Aggregate;
  /** fetch data from the table: "crop_variety_breeder" */
  crop_variety_breeder: Array<Crop_Variety_Breeder>;
  /** fetch aggregated fields from the table: "crop_variety_breeder" */
  crop_variety_breeder_aggregate: Crop_Variety_Breeder_Aggregate;
  /** fetch data from the table: "crop_variety_breeder" using primary key columns */
  crop_variety_breeder_by_pk?: Maybe<Crop_Variety_Breeder>;
  /** fetch data from the table: "crop_variety" using primary key columns */
  crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** fetch data from the table: "crop_year" */
  crop_year: Array<Crop_Year>;
  /** fetch aggregated fields from the table: "crop_year" */
  crop_year_aggregate: Crop_Year_Aggregate;
  /** fetch data from the table: "crop_year" using primary key columns */
  crop_year_by_pk?: Maybe<Crop_Year>;
  /** fetch data from the table: "cultivation_type" */
  cultivation_type: Array<Cultivation_Type>;
  /** fetch aggregated fields from the table: "cultivation_type" */
  cultivation_type_aggregate: Cultivation_Type_Aggregate;
  /** fetch data from the table: "cultivation_type" using primary key columns */
  cultivation_type_by_pk?: Maybe<Cultivation_Type>;
  current_entity_state?: Maybe<EntityStateType>;
  decrypted_url?: Maybe<MediaUrlType>;
  /** fetch data from the table: "demand" */
  demand: Array<Demand>;
  /** fetch aggregated fields from the table: "demand" */
  demand_aggregate: Demand_Aggregate;
  /** fetch data from the table: "demand_attachments" */
  demand_attachments: Array<Demand_Attachments>;
  /** fetch aggregated fields from the table: "demand_attachments" */
  demand_attachments_aggregate: Demand_Attachments_Aggregate;
  /** fetch data from the table: "demand_attachments" using primary key columns */
  demand_attachments_by_pk?: Maybe<Demand_Attachments>;
  /** fetch data from the table: "demand" using primary key columns */
  demand_by_pk?: Maybe<Demand>;
  /** fetch data from the table: "demand_enquiries" */
  demand_enquiries: Array<Demand_Enquiries>;
  /** fetch aggregated fields from the table: "demand_enquiries" */
  demand_enquiries_aggregate: Demand_Enquiries_Aggregate;
  /** fetch data from the table: "demand_enquiries" using primary key columns */
  demand_enquiries_by_pk?: Maybe<Demand_Enquiries>;
  /** fetch data from the table: "demand_enquiries_twilio_message" */
  demand_enquiries_twilio_message: Array<Demand_Enquiries_Twilio_Message>;
  /** fetch aggregated fields from the table: "demand_enquiries_twilio_message" */
  demand_enquiries_twilio_message_aggregate: Demand_Enquiries_Twilio_Message_Aggregate;
  /** fetch data from the table: "demand_enquiries_twilio_message" using primary key columns */
  demand_enquiries_twilio_message_by_pk?: Maybe<Demand_Enquiries_Twilio_Message>;
  /** fetch data from the table: "demand_enquiry_status_log" */
  demand_enquiry_status_log: Array<Demand_Enquiry_Status_Log>;
  /** fetch aggregated fields from the table: "demand_enquiry_status_log" */
  demand_enquiry_status_log_aggregate: Demand_Enquiry_Status_Log_Aggregate;
  /** fetch data from the table: "demand_enquiry_status_log" using primary key columns */
  demand_enquiry_status_log_by_pk?: Maybe<Demand_Enquiry_Status_Log>;
  /** fetch data from the table: "demand_expense" */
  demand_expense: Array<Demand_Expense>;
  /** fetch aggregated fields from the table: "demand_expense" */
  demand_expense_aggregate: Demand_Expense_Aggregate;
  /** fetch data from the table: "demand_expense" using primary key columns */
  demand_expense_by_pk?: Maybe<Demand_Expense>;
  /** An array relationship */
  demand_seller_groups: Array<Demand_Seller_Groups>;
  /** An aggregate relationship */
  demand_seller_groups_aggregate: Demand_Seller_Groups_Aggregate;
  /** fetch data from the table: "demand_seller_groups" using primary key columns */
  demand_seller_groups_by_pk?: Maybe<Demand_Seller_Groups>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: Department_Aggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** fetch data from the table: "department_config" */
  department_config: Array<Department_Config>;
  /** fetch aggregated fields from the table: "department_config" */
  department_config_aggregate: Department_Config_Aggregate;
  /** fetch data from the table: "department_config" using primary key columns */
  department_config_by_pk?: Maybe<Department_Config>;
  /** fetch data from the table: "department_payment_detail" */
  department_payment_detail: Array<Department_Payment_Detail>;
  /** fetch aggregated fields from the table: "department_payment_detail" */
  department_payment_detail_aggregate: Department_Payment_Detail_Aggregate;
  /** fetch data from the table: "department_payment_detail" using primary key columns */
  department_payment_detail_by_pk?: Maybe<Department_Payment_Detail>;
  /** fetch data from the table: "department_settlements" */
  department_settlements: Array<Department_Settlements>;
  /** fetch aggregated fields from the table: "department_settlements" */
  department_settlements_aggregate: Department_Settlements_Aggregate;
  /** fetch data from the table: "department_settlements" using primary key columns */
  department_settlements_by_pk?: Maybe<Department_Settlements>;
  /** fetch data from the table: "department_user_advance" */
  department_user_advance: Array<Department_User_Advance>;
  /** fetch aggregated fields from the table: "department_user_advance" */
  department_user_advance_aggregate: Department_User_Advance_Aggregate;
  /** fetch data from the table: "department_user_advance" using primary key columns */
  department_user_advance_by_pk?: Maybe<Department_User_Advance>;
  department_user_advances?: Maybe<DepartmentUserAdvanceListWithSummaryType>;
  depot_detail?: Maybe<DepotGlType>;
  detection_count_summary_chart?: Maybe<DetectionCountSummaryChartOutput>;
  detection_count_summary_graph?: Maybe<Array<Maybe<DetectionCountSummaryGraphOutput>>>;
  /** fetch data from the table: "device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "device" */
  device_aggregate: Device_Aggregate;
  /** fetch data from the table: "device" using primary key columns */
  device_by_pk?: Maybe<Device>;
  distribution_centre_by_user?: Maybe<Array<Maybe<DistributionCentreGlType>>>;
  distribution_centre_detail?: Maybe<DistributionCentreGlType>;
  /** fetch data from the table: "django_celery_results_taskresult" */
  django_celery_results_taskresult: Array<Django_Celery_Results_Taskresult>;
  /** fetch aggregated fields from the table: "django_celery_results_taskresult" */
  django_celery_results_taskresult_aggregate: Django_Celery_Results_Taskresult_Aggregate;
  /** fetch data from the table: "django_celery_results_taskresult" using primary key columns */
  django_celery_results_taskresult_by_pk?: Maybe<Django_Celery_Results_Taskresult>;
  dock_detail?: Maybe<DockGlType>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document_attachments" */
  document_attachments: Array<Document_Attachments>;
  /** fetch aggregated fields from the table: "document_attachments" */
  document_attachments_aggregate: Document_Attachments_Aggregate;
  /** fetch data from the table: "document_attachments" using primary key columns */
  document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** An array relationship */
  document_data: Array<Document_Data>;
  /** An aggregate relationship */
  document_data_aggregate: Document_Data_Aggregate;
  /** fetch data from the table: "document_data" using primary key columns */
  document_data_by_pk?: Maybe<Document_Data>;
  document_entity_data?: Maybe<Scalars['JSONString']>;
  /** fetch data from the table: "document_export_log" */
  document_export_log: Array<Document_Export_Log>;
  /** fetch aggregated fields from the table: "document_export_log" */
  document_export_log_aggregate: Document_Export_Log_Aggregate;
  /** fetch data from the table: "document_export_log" using primary key columns */
  document_export_log_by_pk?: Maybe<Document_Export_Log>;
  /** fetch data from the table: "document_kind" */
  document_kind: Array<Document_Kind>;
  /** fetch aggregated fields from the table: "document_kind" */
  document_kind_aggregate: Document_Kind_Aggregate;
  /** fetch data from the table: "document_kind" using primary key columns */
  document_kind_by_pk?: Maybe<Document_Kind>;
  /** fetch data from the table: "document_kind_data_field" */
  document_kind_data_field: Array<Document_Kind_Data_Field>;
  /** fetch aggregated fields from the table: "document_kind_data_field" */
  document_kind_data_field_aggregate: Document_Kind_Data_Field_Aggregate;
  /** fetch data from the table: "document_kind_data_field" using primary key columns */
  document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** fetch data from the table: "document_report" */
  document_report: Array<Document_Report>;
  /** fetch aggregated fields from the table: "document_report" */
  document_report_aggregate: Document_Report_Aggregate;
  /** fetch data from the table: "document_report" using primary key columns */
  document_report_by_pk?: Maybe<Document_Report>;
  /** fetch data from the table: "document_revision" */
  document_revision: Array<Document_Revision>;
  /** fetch aggregated fields from the table: "document_revision" */
  document_revision_aggregate: Document_Revision_Aggregate;
  /** fetch data from the table: "document_revision" using primary key columns */
  document_revision_by_pk?: Maybe<Document_Revision>;
  /** fetch data from the table: "address" */
  eagle_address: Array<Eagle_Address>;
  /** fetch aggregated fields from the table: "address" */
  eagle_address_aggregate: Eagle_Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  eagle_address_by_pk?: Maybe<Eagle_Address>;
  /** fetch data from the table: "media" */
  eagle_media: Array<Eagle_Media>;
  /** fetch aggregated fields from the table: "media" */
  eagle_media_aggregate: Eagle_Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  eagle_media_by_pk?: Maybe<Eagle_Media>;
  /** fetch data from the table: "entity_state" */
  entity_state: Array<Entity_State>;
  /** fetch aggregated fields from the table: "entity_state" */
  entity_state_aggregate: Entity_State_Aggregate;
  /** fetch data from the table: "entity_state" using primary key columns */
  entity_state_by_pk?: Maybe<Entity_State>;
  /** fetch data from the table: "evaluation_criteria" */
  evaluation_criteria: Array<Evaluation_Criteria>;
  /** fetch aggregated fields from the table: "evaluation_criteria" */
  evaluation_criteria_aggregate: Evaluation_Criteria_Aggregate;
  /** fetch data from the table: "evaluation_criteria" using primary key columns */
  evaluation_criteria_by_pk?: Maybe<Evaluation_Criteria>;
  /** fetch data from the table: "evaluation_tag" */
  evaluation_tag: Array<Evaluation_Tag>;
  /** fetch aggregated fields from the table: "evaluation_tag" */
  evaluation_tag_aggregate: Evaluation_Tag_Aggregate;
  /** fetch data from the table: "evaluation_tag" using primary key columns */
  evaluation_tag_by_pk?: Maybe<Evaluation_Tag>;
  excluded_departments?: Maybe<Array<Maybe<FmsDepartmentType>>>;
  /** fetch data from the table: "expense" */
  expense: Array<Expense>;
  /** fetch aggregated fields from the table: "expense" */
  expense_aggregate: Expense_Aggregate;
  /** fetch data from the table: "expense" using primary key columns */
  expense_by_pk?: Maybe<Expense>;
  expense_config_template_detail?: Maybe<Array<Maybe<OrganisationTradeExpensesTemplateSchema>>>;
  expense_config_versions?: Maybe<Array<Maybe<OrganisationTradeExpensesVersionSchema>>>;
  expense_configs?: Maybe<Array<Maybe<OrganisationTradeExpenseConfigType>>>;
  /** fetch data from the table: "expense_parameter" */
  expense_parameter: Array<Expense_Parameter>;
  /** fetch data from the table: "expense_parameter" using primary key columns */
  expense_parameter_by_pk?: Maybe<Expense_Parameter>;
  expense_timeline_details?: Maybe<Array<Maybe<PlotCropExpenseByDateType>>>;
  expense_timeline_details_v2?: Maybe<Array<Maybe<PlotCropExpenseByDateType>>>;
  /** fetch data from the table: "external_application" */
  external_application: Array<External_Application>;
  /** fetch aggregated fields from the table: "external_application" */
  external_application_aggregate: External_Application_Aggregate;
  /** fetch data from the table: "external_application" using primary key columns */
  external_application_by_pk?: Maybe<External_Application>;
  /** fetch data from the table: "external_entity" */
  external_entity: Array<External_Entity>;
  /** fetch aggregated fields from the table: "external_entity" */
  external_entity_aggregate: External_Entity_Aggregate;
  /** fetch data from the table: "external_entity" using primary key columns */
  external_entity_by_pk?: Maybe<External_Entity>;
  /** fetch data from the table: "external_entity_group" */
  external_entity_group: Array<External_Entity_Group>;
  /** fetch aggregated fields from the table: "external_entity_group" */
  external_entity_group_aggregate: External_Entity_Group_Aggregate;
  /** fetch data from the table: "external_entity_group" using primary key columns */
  external_entity_group_by_pk?: Maybe<External_Entity_Group>;
  /** fetch data from the table: "external_reference" */
  external_reference: Array<External_Reference>;
  /** fetch aggregated fields from the table: "external_reference" */
  external_reference_aggregate: External_Reference_Aggregate;
  /** fetch data from the table: "external_reference" using primary key columns */
  external_reference_by_pk?: Maybe<External_Reference>;
  external_reference_id?: Maybe<Scalars['String']>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  farm_aggregate_details?: Maybe<Array<Maybe<FarmAggregationType>>>;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  farm_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "farm_network" */
  farm_network: Array<Farm_Network>;
  /** fetch aggregated fields from the table: "farm_network" */
  farm_network_aggregate: Farm_Network_Aggregate;
  /** fetch data from the table: "farm_network" using primary key columns */
  farm_network_by_pk?: Maybe<Farm_Network>;
  /** fetch data from the table: "field" */
  field: Array<Field>;
  /** fetch aggregated fields from the table: "field" */
  field_aggregate: Field_Aggregate;
  /** fetch data from the table: "field" using primary key columns */
  field_by_pk?: Maybe<Field>;
  /** fetch data from the table: "field_network" */
  field_network: Array<Field_Network>;
  /** fetch aggregated fields from the table: "field_network" */
  field_network_aggregate: Field_Network_Aggregate;
  /** fetch data from the table: "field_network" using primary key columns */
  field_network_by_pk?: Maybe<Field_Network>;
  /** fetch data from the table: "field_weather_location" */
  field_weather_location: Array<Field_Weather_Location>;
  /** fetch aggregated fields from the table: "field_weather_location" */
  field_weather_location_aggregate: Field_Weather_Location_Aggregate;
  /** fetch data from the table: "field_weather_location" using primary key columns */
  field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  final_analytics?: Maybe<Array<Maybe<AnalyticalDepartmentType>>>;
  financial_summary?: Maybe<FinancialSummaryType>;
  financial_summary_v2?: Maybe<FinancialSummaryType>;
  financial_timeline_v2?: Maybe<PlotCropTimelineTransactionType>;
  /** fetch data from the table: "financial_year" */
  financial_year: Array<Financial_Year>;
  /** fetch aggregated fields from the table: "financial_year" */
  financial_year_aggregate: Financial_Year_Aggregate;
  /** fetch data from the table: "financial_year_assessment" */
  financial_year_assessment: Array<Financial_Year_Assessment>;
  /** fetch aggregated fields from the table: "financial_year_assessment" */
  financial_year_assessment_aggregate: Financial_Year_Assessment_Aggregate;
  /** fetch data from the table: "financial_year_assessment" using primary key columns */
  financial_year_assessment_by_pk?: Maybe<Financial_Year_Assessment>;
  /** An array relationship */
  financial_year_assessment_cw: Array<Financial_Year_Assessment_Cw>;
  /** An aggregate relationship */
  financial_year_assessment_cw_aggregate: Financial_Year_Assessment_Cw_Aggregate;
  /** fetch data from the table: "financial_year_assessment_cw" using primary key columns */
  financial_year_assessment_cw_by_pk?: Maybe<Financial_Year_Assessment_Cw>;
  /** fetch data from the table: "financial_year" using primary key columns */
  financial_year_by_pk?: Maybe<Financial_Year>;
  /** fetch data from the table: "financial_year_cw" */
  financial_year_cw: Array<Financial_Year_Cw>;
  /** fetch aggregated fields from the table: "financial_year_cw" */
  financial_year_cw_aggregate: Financial_Year_Cw_Aggregate;
  /** fetch data from the table: "financial_year_cw" using primary key columns */
  financial_year_cw_by_pk?: Maybe<Financial_Year_Cw>;
  get_advance_amount?: Maybe<Scalars['Float']>;
  get_buyer_payable?: Maybe<Scalars['Float']>;
  get_regions?: Maybe<Array<Maybe<RegionType>>>;
  get_seller_payable?: Maybe<Scalars['Float']>;
  /** fetch data from the table: "grade" */
  grade: Array<Grade>;
  /** fetch aggregated fields from the table: "grade" */
  grade_aggregate: Grade_Aggregate;
  /** fetch data from the table: "grade" using primary key columns */
  grade_by_pk?: Maybe<Grade>;
  /** fetch data from the table: "grade_company" */
  grade_company: Array<Grade_Company>;
  /** fetch aggregated fields from the table: "grade_company" */
  grade_company_aggregate: Grade_Company_Aggregate;
  /** fetch data from the table: "grade_company" using primary key columns */
  grade_company_by_pk?: Maybe<Grade_Company>;
  /** fetch data from the table: "grade_price" */
  grade_price: Array<Grade_Price>;
  /** fetch aggregated fields from the table: "grade_price" */
  grade_price_aggregate: Grade_Price_Aggregate;
  /** fetch data from the table: "grade_price" using primary key columns */
  grade_price_by_pk?: Maybe<Grade_Price>;
  /** fetch data from the table: "guarantor_agreement" */
  guarantor_agreement: Array<Guarantor_Agreement>;
  /** fetch aggregated fields from the table: "guarantor_agreement" */
  guarantor_agreement_aggregate: Guarantor_Agreement_Aggregate;
  /** fetch data from the table: "guarantor_agreement_agreement_invoices" */
  guarantor_agreement_agreement_invoices: Array<Guarantor_Agreement_Agreement_Invoices>;
  /** fetch aggregated fields from the table: "guarantor_agreement_agreement_invoices" */
  guarantor_agreement_agreement_invoices_aggregate: Guarantor_Agreement_Agreement_Invoices_Aggregate;
  /** fetch data from the table: "guarantor_agreement_agreement_invoices" using primary key columns */
  guarantor_agreement_agreement_invoices_by_pk?: Maybe<Guarantor_Agreement_Agreement_Invoices>;
  /** fetch data from the table: "guarantor_agreement_agreement_plots" */
  guarantor_agreement_agreement_plots: Array<Guarantor_Agreement_Agreement_Plots>;
  /** fetch aggregated fields from the table: "guarantor_agreement_agreement_plots" */
  guarantor_agreement_agreement_plots_aggregate: Guarantor_Agreement_Agreement_Plots_Aggregate;
  /** fetch data from the table: "guarantor_agreement_agreement_plots" using primary key columns */
  guarantor_agreement_agreement_plots_by_pk?: Maybe<Guarantor_Agreement_Agreement_Plots>;
  /** fetch data from the table: "guarantor_agreement_area_extension_detail" */
  guarantor_agreement_area_extension_detail: Array<Guarantor_Agreement_Area_Extension_Detail>;
  /** fetch aggregated fields from the table: "guarantor_agreement_area_extension_detail" */
  guarantor_agreement_area_extension_detail_aggregate: Guarantor_Agreement_Area_Extension_Detail_Aggregate;
  /** fetch data from the table: "guarantor_agreement_area_extension_detail" using primary key columns */
  guarantor_agreement_area_extension_detail_by_pk?: Maybe<Guarantor_Agreement_Area_Extension_Detail>;
  /** fetch data from the table: "guarantor_agreement" using primary key columns */
  guarantor_agreement_by_pk?: Maybe<Guarantor_Agreement>;
  harvest_projection?: Maybe<HarvestProjectionPayloadType>;
  has_advance_release_pending?: Maybe<Scalars['Boolean']>;
  has_verification_pending_advance?: Maybe<Scalars['Boolean']>;
  income_timeline_details?: Maybe<Array<Maybe<PlotCropIncomeByDateType>>>;
  income_timeline_details_v2?: Maybe<Array<Maybe<PlotCropIncomeByDateType>>>;
  /** fetch data from the table: "infestation" */
  infestation: Array<Infestation>;
  /** fetch aggregated fields from the table: "infestation" */
  infestation_aggregate: Infestation_Aggregate;
  /** fetch data from the table: "infestation" using primary key columns */
  infestation_by_pk?: Maybe<Infestation>;
  /** fetch data from the table: "instrument" */
  instrument: Array<Instrument>;
  /** fetch aggregated fields from the table: "instrument" */
  instrument_aggregate: Instrument_Aggregate;
  /** fetch data from the table: "instrument" using primary key columns */
  instrument_by_pk?: Maybe<Instrument>;
  /** fetch data from the table: "instrument_departments" */
  instrument_departments: Array<Instrument_Departments>;
  /** fetch aggregated fields from the table: "instrument_departments" */
  instrument_departments_aggregate: Instrument_Departments_Aggregate;
  /** fetch data from the table: "instrument_departments" using primary key columns */
  instrument_departments_by_pk?: Maybe<Instrument_Departments>;
  /** fetch data from the table: "instrument_kind" */
  instrument_kind: Array<Instrument_Kind>;
  /** fetch aggregated fields from the table: "instrument_kind" */
  instrument_kind_aggregate: Instrument_Kind_Aggregate;
  /** fetch data from the table: "instrument_kind" using primary key columns */
  instrument_kind_by_pk?: Maybe<Instrument_Kind>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  invoice_buyer_bifurcation?: Maybe<BuyerBifurcationType>;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  invoice_summary?: Maybe<Array<Maybe<InvoiceSummaryType>>>;
  invoice_summary_by_user?: Maybe<InvoiceSummaryByUserType>;
  inward_detail?: Maybe<InwardGlType>;
  /** fetch data from the table: "issuance_note" */
  issuance_note: Array<Issuance_Note>;
  /** fetch aggregated fields from the table: "issuance_note" */
  issuance_note_aggregate: Issuance_Note_Aggregate;
  /** fetch data from the table: "issuance_note_attachments" */
  issuance_note_attachments: Array<Issuance_Note_Attachments>;
  /** fetch aggregated fields from the table: "issuance_note_attachments" */
  issuance_note_attachments_aggregate: Issuance_Note_Attachments_Aggregate;
  /** fetch data from the table: "issuance_note_attachments" using primary key columns */
  issuance_note_attachments_by_pk?: Maybe<Issuance_Note_Attachments>;
  /** fetch data from the table: "issuance_note" using primary key columns */
  issuance_note_by_pk?: Maybe<Issuance_Note>;
  /** fetch data from the table: "issuance_note_item_taxes" */
  issuance_note_item_taxes: Array<Issuance_Note_Item_Taxes>;
  /** fetch aggregated fields from the table: "issuance_note_item_taxes" */
  issuance_note_item_taxes_aggregate: Issuance_Note_Item_Taxes_Aggregate;
  /** fetch data from the table: "issuance_note_item_taxes" using primary key columns */
  issuance_note_item_taxes_by_pk?: Maybe<Issuance_Note_Item_Taxes>;
  /** fetch data from the table: "issuance_note_taxes" */
  issuance_note_taxes: Array<Issuance_Note_Taxes>;
  /** fetch aggregated fields from the table: "issuance_note_taxes" */
  issuance_note_taxes_aggregate: Issuance_Note_Taxes_Aggregate;
  /** fetch data from the table: "issuance_note_taxes" using primary key columns */
  issuance_note_taxes_by_pk?: Maybe<Issuance_Note_Taxes>;
  kite_entities_attribute?: Maybe<Array<Maybe<EntityAttributeObject>>>;
  kite_entity_attribute?: Maybe<Scalars['String']>;
  /** fetch data from the table: "notification" */
  kite_notification: Array<Kite_Notification>;
  /** fetch aggregated fields from the table: "notification" */
  kite_notification_aggregate: Kite_Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  kite_notification_by_pk?: Maybe<Kite_Notification>;
  /** fetch data from the table: "quality_stage" */
  kite_quality_stage: Array<Kite_Quality_Stage>;
  /** fetch aggregated fields from the table: "quality_stage" */
  kite_quality_stage_aggregate: Kite_Quality_Stage_Aggregate;
  /** fetch data from the table: "quality_stage" using primary key columns */
  kite_quality_stage_by_pk?: Maybe<Kite_Quality_Stage>;
  /** fetch data from the table: "laboratory" */
  laboratory: Array<Laboratory>;
  /** fetch aggregated fields from the table: "laboratory" */
  laboratory_aggregate: Laboratory_Aggregate;
  /** fetch data from the table: "laboratory" using primary key columns */
  laboratory_by_pk?: Maybe<Laboratory>;
  /** fetch data from the table: "laboratory_organisations" */
  laboratory_organisations: Array<Laboratory_Organisations>;
  /** fetch aggregated fields from the table: "laboratory_organisations" */
  laboratory_organisations_aggregate: Laboratory_Organisations_Aggregate;
  /** fetch data from the table: "laboratory_organisations" using primary key columns */
  laboratory_organisations_by_pk?: Maybe<Laboratory_Organisations>;
  /** fetch data from the table: "legal_agreement" */
  legal_agreement: Array<Legal_Agreement>;
  /** fetch aggregated fields from the table: "legal_agreement" */
  legal_agreement_aggregate: Legal_Agreement_Aggregate;
  /** fetch data from the table: "legal_agreement" using primary key columns */
  legal_agreement_by_pk?: Maybe<Legal_Agreement>;
  location_by_pincode?: Maybe<LocationData>;
  /** fetch data from the table: "market" */
  market: Array<Market>;
  /** fetch aggregated fields from the table: "market" */
  market_aggregate: Market_Aggregate;
  /** fetch data from the table: "market_allowed_departments" */
  market_allowed_departments: Array<Market_Allowed_Departments>;
  /** fetch aggregated fields from the table: "market_allowed_departments" */
  market_allowed_departments_aggregate: Market_Allowed_Departments_Aggregate;
  /** fetch data from the table: "market_allowed_departments" using primary key columns */
  market_allowed_departments_by_pk?: Maybe<Market_Allowed_Departments>;
  /** fetch data from the table: "market" using primary key columns */
  market_by_pk?: Maybe<Market>;
  match_profiles_by_cust_id?: Maybe<Array<Maybe<TradeProfileGlTYpe>>>;
  me?: Maybe<BaseUserType>;
  me_global?: Maybe<BaseUserGlType>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  metabase_url?: Maybe<MetabaseUrlType>;
  migrate_financial_data?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "milestone" */
  milestone: Array<Milestone>;
  /** fetch aggregated fields from the table: "milestone" */
  milestone_aggregate: Milestone_Aggregate;
  /** fetch data from the table: "milestone" using primary key columns */
  milestone_by_pk?: Maybe<Milestone>;
  milestones_for_plotcrop?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
  mix_analytics?: Maybe<Array<Maybe<AnalyticalDepartmentType>>>;
  /** fetch data from the table: "mutual_group" */
  mutual_group: Array<Mutual_Group>;
  /** fetch aggregated fields from the table: "mutual_group" */
  mutual_group_aggregate: Mutual_Group_Aggregate;
  /** fetch data from the table: "mutual_group" using primary key columns */
  mutual_group_by_pk?: Maybe<Mutual_Group>;
  mutual_group_documents?: Maybe<Array<Maybe<DocumentType>>>;
  mutual_group_kind_list?: Maybe<Array<Maybe<KeyNameSchema>>>;
  /** fetch data from the table: "mutual_group_membership" */
  mutual_group_membership: Array<Mutual_Group_Membership>;
  /** fetch aggregated fields from the table: "mutual_group_membership" */
  mutual_group_membership_aggregate: Mutual_Group_Membership_Aggregate;
  /** fetch data from the table: "mutual_group_membership" using primary key columns */
  mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** fetch data from the table: "mutual_group_network" */
  mutual_group_network: Array<Mutual_Group_Network>;
  /** fetch aggregated fields from the table: "mutual_group_network" */
  mutual_group_network_aggregate: Mutual_Group_Network_Aggregate;
  /** fetch data from the table: "mutual_group_network" using primary key columns */
  mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** fetch data from the table: "mutual_group_role" */
  mutual_group_role: Array<Mutual_Group_Role>;
  /** fetch aggregated fields from the table: "mutual_group_role" */
  mutual_group_role_aggregate: Mutual_Group_Role_Aggregate;
  /** fetch data from the table: "mutual_group_role" using primary key columns */
  mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** fetch data from the table: "mutual_group_weather_station" */
  mutual_group_weather_station: Array<Mutual_Group_Weather_Station>;
  /** fetch aggregated fields from the table: "mutual_group_weather_station" */
  mutual_group_weather_station_aggregate: Mutual_Group_Weather_Station_Aggregate;
  /** fetch data from the table: "mutual_group_weather_station" using primary key columns */
  mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  mutual_group_weatherstations?: Maybe<Array<Maybe<MutualGroupWeatherStationType>>>;
  my_assets?: Maybe<UserAssetAggregateType>;
  my_fields?: Maybe<FieldRecordsType>;
  my_network_documents?: Maybe<DocumentListResponseType>;
  my_network_users?: Maybe<Array<Maybe<BaseUserAggregationType>>>;
  my_network_users_with_total?: Maybe<BaseUserAggregationTypeWithTotal>;
  my_order_detail?: Maybe<OrderGlType>;
  my_plot_crops?: Maybe<Array<Maybe<PlotCropDetailType>>>;
  my_plot_crops_with_total?: Maybe<PlotCropDetailTypeWithTotal>;
  my_plot_summary_detail?: Maybe<PlotCommodityGlType>;
  /** fetch data from the table: "nationality" */
  nationality: Array<Nationality>;
  /** fetch aggregated fields from the table: "nationality" */
  nationality_aggregate: Nationality_Aggregate;
  /** fetch data from the table: "nationality" using primary key columns */
  nationality_by_pk?: Maybe<Nationality>;
  /** fetch data from the table: "network" */
  network: Array<Network>;
  /** fetch aggregated fields from the table: "network" */
  network_aggregate: Network_Aggregate;
  /** fetch data from the table: "network" using primary key columns */
  network_by_pk?: Maybe<Network>;
  network_list?: Maybe<Array<Maybe<NetworkType>>>;
  /** fetch data from the table: "nominees" */
  nominees: Array<Nominees>;
  /** fetch aggregated fields from the table: "nominees" */
  nominees_aggregate: Nominees_Aggregate;
  /** fetch data from the table: "nominees" using primary key columns */
  nominees_by_pk?: Maybe<Nominees>;
  /** fetch data from the table: "nominees_documents" */
  nominees_documents: Array<Nominees_Documents>;
  /** fetch aggregated fields from the table: "nominees_documents" */
  nominees_documents_aggregate: Nominees_Documents_Aggregate;
  /** fetch data from the table: "nominees_documents" using primary key columns */
  nominees_documents_by_pk?: Maybe<Nominees_Documents>;
  /** fetch data from the table: "notification_provider" */
  notification_provider: Array<Notification_Provider>;
  /** fetch aggregated fields from the table: "notification_provider" */
  notification_provider_aggregate: Notification_Provider_Aggregate;
  /** fetch data from the table: "notification_provider" using primary key columns */
  notification_provider_by_pk?: Maybe<Notification_Provider>;
  /** fetch data from the table: "notification_trigger" */
  notification_trigger: Array<Notification_Trigger>;
  /** fetch aggregated fields from the table: "notification_trigger" */
  notification_trigger_aggregate: Notification_Trigger_Aggregate;
  /** fetch data from the table: "notification_trigger" using primary key columns */
  notification_trigger_by_pk?: Maybe<Notification_Trigger>;
  /** An array relationship */
  offer_attachments: Array<Offer_Attachments>;
  /** An aggregate relationship */
  offer_attachments_aggregate: Offer_Attachments_Aggregate;
  /** fetch data from the table: "offer_attachments" using primary key columns */
  offer_attachments_by_pk?: Maybe<Offer_Attachments>;
  /** An array relationship */
  offer_enquiries: Array<Offer_Enquiries>;
  /** An aggregate relationship */
  offer_enquiries_aggregate: Offer_Enquiries_Aggregate;
  /** fetch data from the table: "offer_enquiries" using primary key columns */
  offer_enquiries_by_pk?: Maybe<Offer_Enquiries>;
  /** fetch data from the table: "offer_enquiries_twilio_message" */
  offer_enquiries_twilio_message: Array<Offer_Enquiries_Twilio_Message>;
  /** fetch aggregated fields from the table: "offer_enquiries_twilio_message" */
  offer_enquiries_twilio_message_aggregate: Offer_Enquiries_Twilio_Message_Aggregate;
  /** fetch data from the table: "offer_enquiries_twilio_message" using primary key columns */
  offer_enquiries_twilio_message_by_pk?: Maybe<Offer_Enquiries_Twilio_Message>;
  /** fetch data from the table: "offer_enquiry_status_log" */
  offer_enquiry_status_log: Array<Offer_Enquiry_Status_Log>;
  /** fetch aggregated fields from the table: "offer_enquiry_status_log" */
  offer_enquiry_status_log_aggregate: Offer_Enquiry_Status_Log_Aggregate;
  /** fetch data from the table: "offer_enquiry_status_log" using primary key columns */
  offer_enquiry_status_log_by_pk?: Maybe<Offer_Enquiry_Status_Log>;
  /** fetch data from the table: "offer_expense" */
  offer_expense: Array<Offer_Expense>;
  /** fetch aggregated fields from the table: "offer_expense" */
  offer_expense_aggregate: Offer_Expense_Aggregate;
  /** fetch data from the table: "offer_expense" using primary key columns */
  offer_expense_by_pk?: Maybe<Offer_Expense>;
  /** fetch data from the table: "offer_order_picked" */
  offer_order_picked: Array<Offer_Order_Picked>;
  /** fetch aggregated fields from the table: "offer_order_picked" */
  offer_order_picked_aggregate: Offer_Order_Picked_Aggregate;
  /** fetch data from the table: "offer_order_picked" using primary key columns */
  offer_order_picked_by_pk?: Maybe<Offer_Order_Picked>;
  /** fetch data from the table: "offer_storage_picked" */
  offer_storage_picked: Array<Offer_Storage_Picked>;
  /** fetch aggregated fields from the table: "offer_storage_picked" */
  offer_storage_picked_aggregate: Offer_Storage_Picked_Aggregate;
  /** fetch data from the table: "offer_storage_picked" using primary key columns */
  offer_storage_picked_by_pk?: Maybe<Offer_Storage_Picked>;
  /** fetch data from the table: "offers" */
  offers: Array<Offers>;
  /** fetch aggregated fields from the table: "offers" */
  offers_aggregate: Offers_Aggregate;
  /** An array relationship */
  offers_buyer_groups: Array<Offers_Buyer_Groups>;
  /** An aggregate relationship */
  offers_buyer_groups_aggregate: Offers_Buyer_Groups_Aggregate;
  /** fetch data from the table: "offers_buyer_groups" using primary key columns */
  offers_buyer_groups_by_pk?: Maybe<Offers_Buyer_Groups>;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  operation_products_si_units?: Maybe<Array<Maybe<SiUnitType>>>;
  /** fetch data from the table: "org_dashboard_stats" */
  org_dashboard_stats: Array<Org_Dashboard_Stats>;
  /** fetch aggregated fields from the table: "org_dashboard_stats" */
  org_dashboard_stats_aggregate: Org_Dashboard_Stats_Aggregate;
  /** fetch data from the table: "org_dashboard_stats" using primary key columns */
  org_dashboard_stats_by_pk?: Maybe<Org_Dashboard_Stats>;
  /** fetch data from the table: "org_team_association" */
  org_team_association: Array<Org_Team_Association>;
  /** fetch aggregated fields from the table: "org_team_association" */
  org_team_association_aggregate: Org_Team_Association_Aggregate;
  /** fetch data from the table: "org_team_association" using primary key columns */
  org_team_association_by_pk?: Maybe<Org_Team_Association>;
  /** fetch data from the table: "org_team_primary_crop" */
  org_team_primary_crop: Array<Org_Team_Primary_Crop>;
  /** fetch aggregated fields from the table: "org_team_primary_crop" */
  org_team_primary_crop_aggregate: Org_Team_Primary_Crop_Aggregate;
  /** fetch data from the table: "org_team_primary_crop" using primary key columns */
  org_team_primary_crop_by_pk?: Maybe<Org_Team_Primary_Crop>;
  /** fetch data from the table: "org_team_user_bank_association" */
  org_team_user_bank_association: Array<Org_Team_User_Bank_Association>;
  /** fetch aggregated fields from the table: "org_team_user_bank_association" */
  org_team_user_bank_association_aggregate: Org_Team_User_Bank_Association_Aggregate;
  /** fetch data from the table: "org_team_user_bank_association" using primary key columns */
  org_team_user_bank_association_by_pk?: Maybe<Org_Team_User_Bank_Association>;
  /** fetch data from the table: "org_team_user_crop" */
  org_team_user_crop: Array<Org_Team_User_Crop>;
  /** fetch aggregated fields from the table: "org_team_user_crop" */
  org_team_user_crop_aggregate: Org_Team_User_Crop_Aggregate;
  /** fetch data from the table: "org_team_user_crop" using primary key columns */
  org_team_user_crop_by_pk?: Maybe<Org_Team_User_Crop>;
  /** fetch data from the table: "org_team_user_document_association" */
  org_team_user_document_association: Array<Org_Team_User_Document_Association>;
  /** fetch aggregated fields from the table: "org_team_user_document_association" */
  org_team_user_document_association_aggregate: Org_Team_User_Document_Association_Aggregate;
  /** fetch data from the table: "org_team_user_document_association" using primary key columns */
  org_team_user_document_association_by_pk?: Maybe<Org_Team_User_Document_Association>;
  /** fetch data from the table: "org_user_association" */
  org_user_association: Array<Org_User_Association>;
  /** fetch aggregated fields from the table: "org_user_association" */
  org_user_association_aggregate: Org_User_Association_Aggregate;
  /** fetch data from the table: "org_user_association" using primary key columns */
  org_user_association_by_pk?: Maybe<Org_User_Association>;
  /** fetch data from the table: "org_user_group_mandatory_document" */
  org_user_group_mandatory_document: Array<Org_User_Group_Mandatory_Document>;
  /** fetch aggregated fields from the table: "org_user_group_mandatory_document" */
  org_user_group_mandatory_document_aggregate: Org_User_Group_Mandatory_Document_Aggregate;
  /** fetch data from the table: "org_user_group_mandatory_document" using primary key columns */
  org_user_group_mandatory_document_by_pk?: Maybe<Org_User_Group_Mandatory_Document>;
  /** fetch data from the table: "org_user_group_status_snapshot" */
  org_user_group_status_snapshot: Array<Org_User_Group_Status_Snapshot>;
  /** fetch aggregated fields from the table: "org_user_group_status_snapshot" */
  org_user_group_status_snapshot_aggregate: Org_User_Group_Status_Snapshot_Aggregate;
  /** fetch data from the table: "org_user_group_status_snapshot" using primary key columns */
  org_user_group_status_snapshot_by_pk?: Maybe<Org_User_Group_Status_Snapshot>;
  /** fetch data from the table: "org_user_primary_crop" */
  org_user_primary_crop: Array<Org_User_Primary_Crop>;
  /** fetch aggregated fields from the table: "org_user_primary_crop" */
  org_user_primary_crop_aggregate: Org_User_Primary_Crop_Aggregate;
  /** fetch data from the table: "org_user_primary_crop" using primary key columns */
  org_user_primary_crop_by_pk?: Maybe<Org_User_Primary_Crop>;
  /** fetch data from the table: "organisation" */
  organisation: Array<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  organisation_aggregate: Organisation_Aggregate;
  organisation_app_configuration?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "organisation" using primary key columns */
  organisation_by_pk?: Maybe<Organisation>;
  organisation_commodity?: Maybe<Array<Maybe<CommodityType>>>;
  organisation_commodity_variety?: Maybe<Array<Maybe<CommodityVarietyType>>>;
  /** fetch data from the table: "organisation_commodity_variety_config" */
  organisation_commodity_variety_config: Array<Organisation_Commodity_Variety_Config>;
  /** fetch aggregated fields from the table: "organisation_commodity_variety_config" */
  organisation_commodity_variety_config_aggregate: Organisation_Commodity_Variety_Config_Aggregate;
  /** fetch data from the table: "organisation_commodity_variety_config" using primary key columns */
  organisation_commodity_variety_config_by_pk?: Maybe<Organisation_Commodity_Variety_Config>;
  /** fetch data from the table: "organisation_commodity_variety_config_taxes" */
  organisation_commodity_variety_config_taxes: Array<Organisation_Commodity_Variety_Config_Taxes>;
  /** fetch aggregated fields from the table: "organisation_commodity_variety_config_taxes" */
  organisation_commodity_variety_config_taxes_aggregate: Organisation_Commodity_Variety_Config_Taxes_Aggregate;
  /** fetch data from the table: "organisation_commodity_variety_config_taxes" using primary key columns */
  organisation_commodity_variety_config_taxes_by_pk?: Maybe<Organisation_Commodity_Variety_Config_Taxes>;
  /** fetch data from the table: "organisation_crop" */
  organisation_crop: Array<Organisation_Crop>;
  /** fetch aggregated fields from the table: "organisation_crop" */
  organisation_crop_aggregate: Organisation_Crop_Aggregate;
  organisation_crop_and_varieties?: Maybe<Array<Maybe<CropType>>>;
  /** fetch data from the table: "organisation_crop" using primary key columns */
  organisation_crop_by_pk?: Maybe<Organisation_Crop>;
  /** fetch data from the table: "organisation_document_kind" */
  organisation_document_kind: Array<Organisation_Document_Kind>;
  /** fetch aggregated fields from the table: "organisation_document_kind" */
  organisation_document_kind_aggregate: Organisation_Document_Kind_Aggregate;
  /** fetch data from the table: "organisation_document_kind" using primary key columns */
  organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** fetch data from the table: "organisation_preferences" */
  organisation_preferences: Array<Organisation_Preferences>;
  /** fetch aggregated fields from the table: "organisation_preferences" */
  organisation_preferences_aggregate: Organisation_Preferences_Aggregate;
  /** fetch data from the table: "organisation_preferences" using primary key columns */
  organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  organisation_pricing?: Maybe<OrganisationPricingGlType>;
  /** fetch data from the table: "organisation_season" */
  organisation_season: Array<Organisation_Season>;
  /** fetch aggregated fields from the table: "organisation_season" */
  organisation_season_aggregate: Organisation_Season_Aggregate;
  /** fetch data from the table: "organisation_season" using primary key columns */
  organisation_season_by_pk?: Maybe<Organisation_Season>;
  organisation_si_units?: Maybe<Array<Maybe<SiUnitType>>>;
  organisation_variety_grade?: Maybe<Array<Maybe<VarietyGradeType>>>;
  /** fetch data from the table: "over_draft" */
  over_draft: Array<Over_Draft>;
  /** fetch aggregated fields from the table: "over_draft" */
  over_draft_aggregate: Over_Draft_Aggregate;
  /** fetch data from the table: "over_draft" using primary key columns */
  over_draft_by_pk?: Maybe<Over_Draft>;
  /** fetch data from the table: "over_draft_cw" */
  over_draft_cw: Array<Over_Draft_Cw>;
  /** fetch aggregated fields from the table: "over_draft_cw" */
  over_draft_cw_aggregate: Over_Draft_Cw_Aggregate;
  /** fetch data from the table: "over_draft_cw" using primary key columns */
  over_draft_cw_by_pk?: Maybe<Over_Draft_Cw>;
  /** fetch data from the table: "over_draft_log" */
  over_draft_log: Array<Over_Draft_Log>;
  /** fetch aggregated fields from the table: "over_draft_log" */
  over_draft_log_aggregate: Over_Draft_Log_Aggregate;
  /** fetch data from the table: "over_draft_log" using primary key columns */
  over_draft_log_by_pk?: Maybe<Over_Draft_Log>;
  /** fetch data from the table: "over_draft_log_cw" */
  over_draft_log_cw: Array<Over_Draft_Log_Cw>;
  /** fetch aggregated fields from the table: "over_draft_log_cw" */
  over_draft_log_cw_aggregate: Over_Draft_Log_Cw_Aggregate;
  /** fetch data from the table: "over_draft_log_cw" using primary key columns */
  over_draft_log_cw_by_pk?: Maybe<Over_Draft_Log_Cw>;
  /** fetch data from the table: "over_due_approval" */
  over_due_approval: Array<Over_Due_Approval>;
  /** fetch aggregated fields from the table: "over_due_approval" */
  over_due_approval_aggregate: Over_Due_Approval_Aggregate;
  /** fetch data from the table: "over_due_approval" using primary key columns */
  over_due_approval_by_pk?: Maybe<Over_Due_Approval>;
  /** fetch data from the table: "over_due_approval_cw" */
  over_due_approval_cw: Array<Over_Due_Approval_Cw>;
  /** fetch aggregated fields from the table: "over_due_approval_cw" */
  over_due_approval_cw_aggregate: Over_Due_Approval_Cw_Aggregate;
  /** fetch data from the table: "over_due_approval_cw" using primary key columns */
  over_due_approval_cw_by_pk?: Maybe<Over_Due_Approval_Cw>;
  /** fetch data from the table: "over_due_approval_log" */
  over_due_approval_log: Array<Over_Due_Approval_Log>;
  /** fetch aggregated fields from the table: "over_due_approval_log" */
  over_due_approval_log_aggregate: Over_Due_Approval_Log_Aggregate;
  /** fetch data from the table: "over_due_approval_log" using primary key columns */
  over_due_approval_log_by_pk?: Maybe<Over_Due_Approval_Log>;
  /** fetch data from the table: "packaging" */
  packaging: Array<Packaging>;
  /** fetch aggregated fields from the table: "packaging" */
  packaging_aggregate: Packaging_Aggregate;
  /** fetch data from the table: "packaging" using primary key columns */
  packaging_by_pk?: Maybe<Packaging>;
  /** fetch data from the table: "packaging_order" */
  packaging_order: Array<Packaging_Order>;
  /** fetch aggregated fields from the table: "packaging_order" */
  packaging_order_aggregate: Packaging_Order_Aggregate;
  /** fetch data from the table: "packaging_order" using primary key columns */
  packaging_order_by_pk?: Maybe<Packaging_Order>;
  /** fetch data from the table: "packaging_order_item" */
  packaging_order_item: Array<Packaging_Order_Item>;
  /** fetch aggregated fields from the table: "packaging_order_item" */
  packaging_order_item_aggregate: Packaging_Order_Item_Aggregate;
  /** fetch data from the table: "packaging_order_item" using primary key columns */
  packaging_order_item_by_pk?: Maybe<Packaging_Order_Item>;
  /** fetch data from the table: "pallet_category" */
  pallet_category: Array<Pallet_Category>;
  /** fetch aggregated fields from the table: "pallet_category" */
  pallet_category_aggregate: Pallet_Category_Aggregate;
  /** fetch data from the table: "pallet_category" using primary key columns */
  pallet_category_by_pk?: Maybe<Pallet_Category>;
  /** fetch data from the table: "pallet_customer" */
  pallet_customer: Array<Pallet_Customer>;
  /** fetch aggregated fields from the table: "pallet_customer" */
  pallet_customer_aggregate: Pallet_Customer_Aggregate;
  /** fetch data from the table: "pallet_customer" using primary key columns */
  pallet_customer_by_pk?: Maybe<Pallet_Customer>;
  /** fetch data from the table: "pallet_inspection" */
  pallet_inspection: Array<Pallet_Inspection>;
  /** fetch aggregated fields from the table: "pallet_inspection" */
  pallet_inspection_aggregate: Pallet_Inspection_Aggregate;
  /** fetch data from the table: "pallet_inspection_attachments" */
  pallet_inspection_attachments: Array<Pallet_Inspection_Attachments>;
  /** fetch aggregated fields from the table: "pallet_inspection_attachments" */
  pallet_inspection_attachments_aggregate: Pallet_Inspection_Attachments_Aggregate;
  /** fetch data from the table: "pallet_inspection_attachments" using primary key columns */
  pallet_inspection_attachments_by_pk?: Maybe<Pallet_Inspection_Attachments>;
  /** fetch data from the table: "pallet_inspection" using primary key columns */
  pallet_inspection_by_pk?: Maybe<Pallet_Inspection>;
  /** fetch data from the table: "pallet_inspection_reports" */
  pallet_inspection_reports: Array<Pallet_Inspection_Reports>;
  /** fetch aggregated fields from the table: "pallet_inspection_reports" */
  pallet_inspection_reports_aggregate: Pallet_Inspection_Reports_Aggregate;
  /** fetch data from the table: "pallet_inspection_reports" using primary key columns */
  pallet_inspection_reports_by_pk?: Maybe<Pallet_Inspection_Reports>;
  /** fetch data from the table: "pallet_inspectionkind" */
  pallet_inspectionkind: Array<Pallet_Inspectionkind>;
  /** fetch aggregated fields from the table: "pallet_inspectionkind" */
  pallet_inspectionkind_aggregate: Pallet_Inspectionkind_Aggregate;
  /** fetch data from the table: "pallet_inspectionkind" using primary key columns */
  pallet_inspectionkind_by_pk?: Maybe<Pallet_Inspectionkind>;
  /** fetch data from the table: "pallet_inspectionobservation" */
  pallet_inspectionobservation: Array<Pallet_Inspectionobservation>;
  /** fetch aggregated fields from the table: "pallet_inspectionobservation" */
  pallet_inspectionobservation_aggregate: Pallet_Inspectionobservation_Aggregate;
  /** fetch data from the table: "pallet_inspectionobservation_attachments" */
  pallet_inspectionobservation_attachments: Array<Pallet_Inspectionobservation_Attachments>;
  /** fetch aggregated fields from the table: "pallet_inspectionobservation_attachments" */
  pallet_inspectionobservation_attachments_aggregate: Pallet_Inspectionobservation_Attachments_Aggregate;
  /** fetch data from the table: "pallet_inspectionobservation_attachments" using primary key columns */
  pallet_inspectionobservation_attachments_by_pk?: Maybe<Pallet_Inspectionobservation_Attachments>;
  /** fetch data from the table: "pallet_inspectionobservation" using primary key columns */
  pallet_inspectionobservation_by_pk?: Maybe<Pallet_Inspectionobservation>;
  /** fetch data from the table: "pallet_line" */
  pallet_line: Array<Pallet_Line>;
  /** fetch aggregated fields from the table: "pallet_line" */
  pallet_line_aggregate: Pallet_Line_Aggregate;
  /** fetch data from the table: "pallet_line" using primary key columns */
  pallet_line_by_pk?: Maybe<Pallet_Line>;
  /** fetch data from the table: "pallet_location" */
  pallet_location: Array<Pallet_Location>;
  /** fetch aggregated fields from the table: "pallet_location" */
  pallet_location_aggregate: Pallet_Location_Aggregate;
  /** fetch data from the table: "pallet_location" using primary key columns */
  pallet_location_by_pk?: Maybe<Pallet_Location>;
  /** fetch data from the table: "pallet_packaging" */
  pallet_packaging: Array<Pallet_Packaging>;
  /** fetch aggregated fields from the table: "pallet_packaging" */
  pallet_packaging_aggregate: Pallet_Packaging_Aggregate;
  /** fetch data from the table: "pallet_packaging" using primary key columns */
  pallet_packaging_by_pk?: Maybe<Pallet_Packaging>;
  /** fetch data from the table: "pallet_packagingkind" */
  pallet_packagingkind: Array<Pallet_Packagingkind>;
  /** fetch aggregated fields from the table: "pallet_packagingkind" */
  pallet_packagingkind_aggregate: Pallet_Packagingkind_Aggregate;
  /** fetch data from the table: "pallet_packagingkind" using primary key columns */
  pallet_packagingkind_by_pk?: Maybe<Pallet_Packagingkind>;
  /** fetch data from the table: "pallet_packing" */
  pallet_packing: Array<Pallet_Packing>;
  /** fetch aggregated fields from the table: "pallet_packing" */
  pallet_packing_aggregate: Pallet_Packing_Aggregate;
  /** fetch data from the table: "pallet_packing_attachments" */
  pallet_packing_attachments: Array<Pallet_Packing_Attachments>;
  /** fetch aggregated fields from the table: "pallet_packing_attachments" */
  pallet_packing_attachments_aggregate: Pallet_Packing_Attachments_Aggregate;
  /** fetch data from the table: "pallet_packing_attachments" using primary key columns */
  pallet_packing_attachments_by_pk?: Maybe<Pallet_Packing_Attachments>;
  /** fetch data from the table: "pallet_packing" using primary key columns */
  pallet_packing_by_pk?: Maybe<Pallet_Packing>;
  /** fetch data from the table: "pallet_packing_weights" */
  pallet_packing_weights: Array<Pallet_Packing_Weights>;
  /** fetch aggregated fields from the table: "pallet_packing_weights" */
  pallet_packing_weights_aggregate: Pallet_Packing_Weights_Aggregate;
  /** fetch data from the table: "pallet_packing_weights" using primary key columns */
  pallet_packing_weights_by_pk?: Maybe<Pallet_Packing_Weights>;
  /** fetch data from the table: "pallet_packingkind" */
  pallet_packingkind: Array<Pallet_Packingkind>;
  /** fetch aggregated fields from the table: "pallet_packingkind" */
  pallet_packingkind_aggregate: Pallet_Packingkind_Aggregate;
  /** fetch data from the table: "pallet_packingkind" using primary key columns */
  pallet_packingkind_by_pk?: Maybe<Pallet_Packingkind>;
  /** fetch data from the table: "pallet_packingweight" */
  pallet_packingweight: Array<Pallet_Packingweight>;
  /** fetch aggregated fields from the table: "pallet_packingweight" */
  pallet_packingweight_aggregate: Pallet_Packingweight_Aggregate;
  /** fetch data from the table: "pallet_packingweight_attachments" */
  pallet_packingweight_attachments: Array<Pallet_Packingweight_Attachments>;
  /** fetch aggregated fields from the table: "pallet_packingweight_attachments" */
  pallet_packingweight_attachments_aggregate: Pallet_Packingweight_Attachments_Aggregate;
  /** fetch data from the table: "pallet_packingweight_attachments" using primary key columns */
  pallet_packingweight_attachments_by_pk?: Maybe<Pallet_Packingweight_Attachments>;
  /** fetch data from the table: "pallet_packingweight" using primary key columns */
  pallet_packingweight_by_pk?: Maybe<Pallet_Packingweight>;
  /** fetch data from the table: "pallet_printingmatter" */
  pallet_printingmatter: Array<Pallet_Printingmatter>;
  /** fetch aggregated fields from the table: "pallet_printingmatter" */
  pallet_printingmatter_aggregate: Pallet_Printingmatter_Aggregate;
  /** fetch data from the table: "pallet_printingmatter" using primary key columns */
  pallet_printingmatter_by_pk?: Maybe<Pallet_Printingmatter>;
  /** fetch data from the table: "pallet_punnetcondition" */
  pallet_punnetcondition: Array<Pallet_Punnetcondition>;
  /** fetch aggregated fields from the table: "pallet_punnetcondition" */
  pallet_punnetcondition_aggregate: Pallet_Punnetcondition_Aggregate;
  /** fetch data from the table: "pallet_punnetcondition" using primary key columns */
  pallet_punnetcondition_by_pk?: Maybe<Pallet_Punnetcondition>;
  /** fetch data from the table: "pallet_samplinglocation" */
  pallet_samplinglocation: Array<Pallet_Samplinglocation>;
  /** fetch aggregated fields from the table: "pallet_samplinglocation" */
  pallet_samplinglocation_aggregate: Pallet_Samplinglocation_Aggregate;
  /** fetch data from the table: "pallet_samplinglocation" using primary key columns */
  pallet_samplinglocation_by_pk?: Maybe<Pallet_Samplinglocation>;
  /** fetch data from the table: "pallet_sku" */
  pallet_sku: Array<Pallet_Sku>;
  /** fetch aggregated fields from the table: "pallet_sku" */
  pallet_sku_aggregate: Pallet_Sku_Aggregate;
  /** fetch data from the table: "pallet_sku" using primary key columns */
  pallet_sku_by_pk?: Maybe<Pallet_Sku>;
  /** fetch data from the table: "pallet_skutype" */
  pallet_skutype: Array<Pallet_Skutype>;
  /** fetch aggregated fields from the table: "pallet_skutype" */
  pallet_skutype_aggregate: Pallet_Skutype_Aggregate;
  /** fetch data from the table: "pallet_skutype" using primary key columns */
  pallet_skutype_by_pk?: Maybe<Pallet_Skutype>;
  /** fetch data from the table: "pallet_variety" */
  pallet_variety: Array<Pallet_Variety>;
  /** fetch aggregated fields from the table: "pallet_variety" */
  pallet_variety_aggregate: Pallet_Variety_Aggregate;
  /** fetch data from the table: "pallet_variety" using primary key columns */
  pallet_variety_by_pk?: Maybe<Pallet_Variety>;
  partner_detail?: Maybe<PartnerSchema>;
  partner_list?: Maybe<Array<Maybe<PartnerSchema>>>;
  /** fetch data from the table: "payment" */
  payment: Array<Payment>;
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate;
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>;
  /** fetch data from the table: "payment_detail" */
  payment_detail: Array<Payment_Detail>;
  /** fetch aggregated fields from the table: "payment_detail" */
  payment_detail_aggregate: Payment_Detail_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" */
  payment_detail_attachments: Array<Payment_Detail_Attachments>;
  /** fetch aggregated fields from the table: "payment_detail_attachments" */
  payment_detail_attachments_aggregate: Payment_Detail_Attachments_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" using primary key columns */
  payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** fetch data from the table: "payment_detail" using primary key columns */
  payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** fetch data from the table: "payment_method" */
  payment_method: Array<Payment_Method>;
  /** fetch aggregated fields from the table: "payment_method" */
  payment_method_aggregate: Payment_Method_Aggregate;
  /** fetch data from the table: "payment_method" using primary key columns */
  payment_method_by_pk?: Maybe<Payment_Method>;
  payu_hash?: Maybe<PayUHashType>;
  payu_transaction_hash?: Maybe<PayUPayload>;
  /** fetch data from the table: "plot" */
  plot: Array<Plot>;
  /** fetch aggregated fields from the table: "plot" */
  plot_aggregate: Plot_Aggregate;
  /** fetch data from the table: "plot" using primary key columns */
  plot_by_pk?: Maybe<Plot>;
  /** fetch data from the table: "plot_crop" */
  plot_crop: Array<Plot_Crop>;
  /** fetch data from the table: "plot_crop_agent" */
  plot_crop_agent: Array<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop_agent" */
  plot_crop_agent_aggregate: Plot_Crop_Agent_Aggregate;
  /** fetch data from the table: "plot_crop_agent" using primary key columns */
  plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop" */
  plot_crop_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "plot_crop" using primary key columns */
  plot_crop_by_pk?: Maybe<Plot_Crop>;
  /** fetch data from the table: "plot_crop_cultivation_type" */
  plot_crop_cultivation_type: Array<Plot_Crop_Cultivation_Type>;
  /** fetch aggregated fields from the table: "plot_crop_cultivation_type" */
  plot_crop_cultivation_type_aggregate: Plot_Crop_Cultivation_Type_Aggregate;
  /** fetch data from the table: "plot_crop_cultivation_type" using primary key columns */
  plot_crop_cultivation_type_by_pk?: Maybe<Plot_Crop_Cultivation_Type>;
  plot_crop_detail?: Maybe<PlotCropDetailType>;
  plot_crop_documents?: Maybe<Array<Maybe<DocumentType>>>;
  plot_crop_growth_stages_by_plot_crop_codename?: Maybe<Array<Maybe<PlotCropGrowthStagesType>>>;
  /** fetch data from the table: "plot_crop_historic_season" */
  plot_crop_historic_season: Array<Plot_Crop_Historic_Season>;
  /** fetch aggregated fields from the table: "plot_crop_historic_season" */
  plot_crop_historic_season_aggregate: Plot_Crop_Historic_Season_Aggregate;
  /** fetch data from the table: "plot_crop_historic_season" using primary key columns */
  plot_crop_historic_season_by_pk?: Maybe<Plot_Crop_Historic_Season>;
  plot_crop_list_with_budget?: Maybe<Array<Maybe<PlotCropBudgetSetType>>>;
  plot_crop_list_with_budget_v2?: Maybe<Array<Maybe<PlotCropBudgetSetType>>>;
  /** fetch data from the table: "plot_crop_milestone" */
  plot_crop_milestone: Array<Plot_Crop_Milestone>;
  /** fetch aggregated fields from the table: "plot_crop_milestone" */
  plot_crop_milestone_aggregate: Plot_Crop_Milestone_Aggregate;
  /** fetch data from the table: "plot_crop_milestone" using primary key columns */
  plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** fetch data from the table: "plot_crop_network" */
  plot_crop_network: Array<Plot_Crop_Network>;
  /** fetch aggregated fields from the table: "plot_crop_network" */
  plot_crop_network_aggregate: Plot_Crop_Network_Aggregate;
  /** fetch data from the table: "plot_crop_network" using primary key columns */
  plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  plot_crop_reference_by_codename?: Maybe<Scalars['String']>;
  /** fetch data from the table: "plot_crop_rootstock" */
  plot_crop_rootstock: Array<Plot_Crop_Rootstock>;
  /** fetch aggregated fields from the table: "plot_crop_rootstock" */
  plot_crop_rootstock_aggregate: Plot_Crop_Rootstock_Aggregate;
  /** fetch data from the table: "plot_crop_rootstock" using primary key columns */
  plot_crop_rootstock_by_pk?: Maybe<Plot_Crop_Rootstock>;
  plot_crop_search?: Maybe<Array<Maybe<PlotCropType>>>;
  plot_crop_sowing_material?: Maybe<Scalars['JSONScalar']>;
  /** fetch data from the table: "plot_crop_status_history" */
  plot_crop_status_history: Array<Plot_Crop_Status_History>;
  /** fetch aggregated fields from the table: "plot_crop_status_history" */
  plot_crop_status_history_aggregate: Plot_Crop_Status_History_Aggregate;
  /** fetch data from the table: "plot_crop_status_history" using primary key columns */
  plot_crop_status_history_by_pk?: Maybe<Plot_Crop_Status_History>;
  plot_crop_transaction_categories?: Maybe<PlotCropTransactionCategoryTypes>;
  plot_documents?: Maybe<Array<Maybe<DocumentType>>>;
  /** fetch data from the table: "plot_network" */
  plot_network: Array<Plot_Network>;
  /** fetch aggregated fields from the table: "plot_network" */
  plot_network_aggregate: Plot_Network_Aggregate;
  /** fetch data from the table: "plot_network" using primary key columns */
  plot_network_by_pk?: Maybe<Plot_Network>;
  /** fetch data from the table: "plot_status" */
  plot_status: Array<Plot_Status>;
  /** fetch aggregated fields from the table: "plot_status" */
  plot_status_aggregate: Plot_Status_Aggregate;
  /** fetch data from the table: "plot_status" using primary key columns */
  plot_status_by_pk?: Maybe<Plot_Status>;
  /** fetch data from the table: "plot_status_config" */
  plot_status_config: Array<Plot_Status_Config>;
  /** fetch aggregated fields from the table: "plot_status_config" */
  plot_status_config_aggregate: Plot_Status_Config_Aggregate;
  /** fetch data from the table: "plot_status_config" using primary key columns */
  plot_status_config_by_pk?: Maybe<Plot_Status_Config>;
  /** fetch data from the table: "plot_status_config_required_qc_stages" */
  plot_status_config_required_qc_stages: Array<Plot_Status_Config_Required_Qc_Stages>;
  /** fetch aggregated fields from the table: "plot_status_config_required_qc_stages" */
  plot_status_config_required_qc_stages_aggregate: Plot_Status_Config_Required_Qc_Stages_Aggregate;
  /** fetch data from the table: "plot_status_config_required_qc_stages" using primary key columns */
  plot_status_config_required_qc_stages_by_pk?: Maybe<Plot_Status_Config_Required_Qc_Stages>;
  /** fetch data from the table: "primary_growth_stage" */
  primary_growth_stage: Array<Primary_Growth_Stage>;
  /** fetch aggregated fields from the table: "primary_growth_stage" */
  primary_growth_stage_aggregate: Primary_Growth_Stage_Aggregate;
  /** fetch data from the table: "primary_growth_stage" using primary key columns */
  primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  production_batch_detail?: Maybe<ProductionBatchGlType>;
  /** fetch data from the table: "production_trade" */
  production_trade: Array<Production_Trade>;
  /** fetch aggregated fields from the table: "production_trade" */
  production_trade_aggregate: Production_Trade_Aggregate;
  /** fetch data from the table: "production_trade" using primary key columns */
  production_trade_by_pk?: Maybe<Production_Trade>;
  /** fetch data from the table: "production_trade_item" */
  production_trade_item: Array<Production_Trade_Item>;
  /** fetch aggregated fields from the table: "production_trade_item" */
  production_trade_item_aggregate: Production_Trade_Item_Aggregate;
  /** fetch data from the table: "production_trade_item_attachments" */
  production_trade_item_attachments: Array<Production_Trade_Item_Attachments>;
  /** fetch aggregated fields from the table: "production_trade_item_attachments" */
  production_trade_item_attachments_aggregate: Production_Trade_Item_Attachments_Aggregate;
  /** fetch data from the table: "production_trade_item_attachments" using primary key columns */
  production_trade_item_attachments_by_pk?: Maybe<Production_Trade_Item_Attachments>;
  /** fetch data from the table: "production_trade_item" using primary key columns */
  production_trade_item_by_pk?: Maybe<Production_Trade_Item>;
  /** fetch data from the table: "production_trade_item_storage_picked" */
  production_trade_item_storage_picked: Array<Production_Trade_Item_Storage_Picked>;
  /** fetch aggregated fields from the table: "production_trade_item_storage_picked" */
  production_trade_item_storage_picked_aggregate: Production_Trade_Item_Storage_Picked_Aggregate;
  /** fetch data from the table: "production_trade_item_storage_picked" using primary key columns */
  production_trade_item_storage_picked_by_pk?: Maybe<Production_Trade_Item_Storage_Picked>;
  /** fetch data from the table: "production_trade_order_trade_refs" */
  production_trade_order_trade_refs: Array<Production_Trade_Order_Trade_Refs>;
  /** fetch aggregated fields from the table: "production_trade_order_trade_refs" */
  production_trade_order_trade_refs_aggregate: Production_Trade_Order_Trade_Refs_Aggregate;
  /** fetch data from the table: "production_trade_order_trade_refs" using primary key columns */
  production_trade_order_trade_refs_by_pk?: Maybe<Production_Trade_Order_Trade_Refs>;
  /** fetch data from the table: "projection_assessment" */
  projection_assessment: Array<Projection_Assessment>;
  /** fetch aggregated fields from the table: "projection_assessment" */
  projection_assessment_aggregate: Projection_Assessment_Aggregate;
  /** fetch data from the table: "projection_assessment" using primary key columns */
  projection_assessment_by_pk?: Maybe<Projection_Assessment>;
  /** An array relationship */
  projection_assessment_cw: Array<Projection_Assessment_Cw>;
  /** An aggregate relationship */
  projection_assessment_cw_aggregate: Projection_Assessment_Cw_Aggregate;
  /** fetch data from the table: "projection_assessment_cw" using primary key columns */
  projection_assessment_cw_by_pk?: Maybe<Projection_Assessment_Cw>;
  /** fetch data from the table: "quality_parameter" */
  quality_parameter: Array<Quality_Parameter>;
  /** fetch aggregated fields from the table: "quality_parameter" */
  quality_parameter_aggregate: Quality_Parameter_Aggregate;
  /** fetch data from the table: "quality_parameter" using primary key columns */
  quality_parameter_by_pk?: Maybe<Quality_Parameter>;
  /** fetch data from the table: "quality_parameter_category" */
  quality_parameter_category: Array<Quality_Parameter_Category>;
  /** fetch aggregated fields from the table: "quality_parameter_category" */
  quality_parameter_category_aggregate: Quality_Parameter_Category_Aggregate;
  /** fetch data from the table: "quality_parameter_category" using primary key columns */
  quality_parameter_category_by_pk?: Maybe<Quality_Parameter_Category>;
  /** fetch data from the table: "quality_stage" */
  quality_stage: Array<Quality_Stage>;
  /** fetch aggregated fields from the table: "quality_stage" */
  quality_stage_aggregate: Quality_Stage_Aggregate;
  /** fetch data from the table: "quality_stage_allowed_template_category" */
  quality_stage_allowed_template_category: Array<Quality_Stage_Allowed_Template_Category>;
  /** fetch aggregated fields from the table: "quality_stage_allowed_template_category" */
  quality_stage_allowed_template_category_aggregate: Quality_Stage_Allowed_Template_Category_Aggregate;
  /** fetch data from the table: "quality_stage_allowed_template_category" using primary key columns */
  quality_stage_allowed_template_category_by_pk?: Maybe<Quality_Stage_Allowed_Template_Category>;
  /** fetch data from the table: "quality_stage" using primary key columns */
  quality_stage_by_pk?: Maybe<Quality_Stage>;
  /** fetch data from the table: "receipt" */
  receipt: Array<Receipt>;
  /** fetch aggregated fields from the table: "receipt" */
  receipt_aggregate: Receipt_Aggregate;
  /** fetch data from the table: "receipt" using primary key columns */
  receipt_by_pk?: Maybe<Receipt>;
  receipt_seller_bifurcation?: Maybe<SellerBifurcationType>;
  /** fetch data from the table: "receipt_seller_gst_attachments" */
  receipt_seller_gst_attachments: Array<Receipt_Seller_Gst_Attachments>;
  /** fetch aggregated fields from the table: "receipt_seller_gst_attachments" */
  receipt_seller_gst_attachments_aggregate: Receipt_Seller_Gst_Attachments_Aggregate;
  /** fetch data from the table: "receipt_seller_gst_attachments" using primary key columns */
  receipt_seller_gst_attachments_by_pk?: Maybe<Receipt_Seller_Gst_Attachments>;
  receipt_summary?: Maybe<ReceiptSummaryType>;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  region_aggregate: Region_Aggregate;
  /** fetch data from the table: "region" using primary key columns */
  region_by_pk?: Maybe<Region>;
  /** fetch data from the table: "region_group" */
  region_group: Array<Region_Group>;
  /** fetch aggregated fields from the table: "region_group" */
  region_group_aggregate: Region_Group_Aggregate;
  /** fetch data from the table: "region_group" using primary key columns */
  region_group_by_pk?: Maybe<Region_Group>;
  registration_mutual_group_list?: Maybe<Array<Maybe<MutualGroupAggregationType>>>;
  registration_mutual_group_list_with_total?: Maybe<MutualGroupAggregationTypeWithTotal>;
  /** fetch data from the table: "request" */
  request: Array<Request>;
  /** fetch aggregated fields from the table: "request" */
  request_aggregate: Request_Aggregate;
  /** fetch data from the table: "request" using primary key columns */
  request_by_pk?: Maybe<Request>;
  /** fetch data from the table: "request_category" */
  request_category: Array<Request_Category>;
  /** fetch aggregated fields from the table: "request_category" */
  request_category_aggregate: Request_Category_Aggregate;
  /** fetch data from the table: "request_category" using primary key columns */
  request_category_by_pk?: Maybe<Request_Category>;
  /** An array relationship */
  request_parameters: Array<Request_Parameters>;
  /** An aggregate relationship */
  request_parameters_aggregate: Request_Parameters_Aggregate;
  /** fetch data from the table: "request_parameters" using primary key columns */
  request_parameters_by_pk?: Maybe<Request_Parameters>;
  /** fetch data from the table: "request_secondary_locations" */
  request_secondary_locations: Array<Request_Secondary_Locations>;
  /** fetch aggregated fields from the table: "request_secondary_locations" */
  request_secondary_locations_aggregate: Request_Secondary_Locations_Aggregate;
  /** fetch data from the table: "request_secondary_locations" using primary key columns */
  request_secondary_locations_by_pk?: Maybe<Request_Secondary_Locations>;
  /** fetch data from the table: "request_templates" */
  request_templates: Array<Request_Templates>;
  /** fetch aggregated fields from the table: "request_templates" */
  request_templates_aggregate: Request_Templates_Aggregate;
  /** fetch data from the table: "request_templates" using primary key columns */
  request_templates_by_pk?: Maybe<Request_Templates>;
  requests_by_primary_location?: Maybe<Array<Maybe<RequestType>>>;
  requests_summary_by_primary_location?: Maybe<RequestSummaryType>;
  /** fetch data from the table: "result" */
  result: Array<Result>;
  /** fetch aggregated fields from the table: "result" */
  result_aggregate: Result_Aggregate;
  /** fetch data from the table: "result" using primary key columns */
  result_by_pk?: Maybe<Result>;
  /** fetch data from the table: "result_comment" */
  result_comment: Array<Result_Comment>;
  /** fetch aggregated fields from the table: "result_comment" */
  result_comment_aggregate: Result_Comment_Aggregate;
  /** fetch data from the table: "result_comment" using primary key columns */
  result_comment_by_pk?: Maybe<Result_Comment>;
  /** fetch data from the table: "result_evaluation" */
  result_evaluation: Array<Result_Evaluation>;
  /** fetch aggregated fields from the table: "result_evaluation" */
  result_evaluation_aggregate: Result_Evaluation_Aggregate;
  /** fetch data from the table: "result_evaluation" using primary key columns */
  result_evaluation_by_pk?: Maybe<Result_Evaluation>;
  /** fetch data from the table: "result_evaluation_evaluated_tags" */
  result_evaluation_evaluated_tags: Array<Result_Evaluation_Evaluated_Tags>;
  /** fetch aggregated fields from the table: "result_evaluation_evaluated_tags" */
  result_evaluation_evaluated_tags_aggregate: Result_Evaluation_Evaluated_Tags_Aggregate;
  /** fetch data from the table: "result_evaluation_evaluated_tags" using primary key columns */
  result_evaluation_evaluated_tags_by_pk?: Maybe<Result_Evaluation_Evaluated_Tags>;
  /** An array relationship */
  result_media: Array<Result_Media>;
  /** An aggregate relationship */
  result_media_aggregate: Result_Media_Aggregate;
  /** fetch data from the table: "result_media" using primary key columns */
  result_media_by_pk?: Maybe<Result_Media>;
  /** fetch data from the table: "result_observation" */
  result_observation: Array<Result_Observation>;
  /** fetch aggregated fields from the table: "result_observation" */
  result_observation_aggregate: Result_Observation_Aggregate;
  /** fetch data from the table: "result_observation_attachments" */
  result_observation_attachments: Array<Result_Observation_Attachments>;
  /** fetch aggregated fields from the table: "result_observation_attachments" */
  result_observation_attachments_aggregate: Result_Observation_Attachments_Aggregate;
  /** fetch data from the table: "result_observation_attachments" using primary key columns */
  result_observation_attachments_by_pk?: Maybe<Result_Observation_Attachments>;
  /** fetch data from the table: "result_observation" using primary key columns */
  result_observation_by_pk?: Maybe<Result_Observation>;
  /** fetch data from the table: "result_observation_evaluated_tags" */
  result_observation_evaluated_tags: Array<Result_Observation_Evaluated_Tags>;
  /** fetch aggregated fields from the table: "result_observation_evaluated_tags" */
  result_observation_evaluated_tags_aggregate: Result_Observation_Evaluated_Tags_Aggregate;
  /** fetch data from the table: "result_observation_evaluated_tags" using primary key columns */
  result_observation_evaluated_tags_by_pk?: Maybe<Result_Observation_Evaluated_Tags>;
  result_observations?: Maybe<Array<Maybe<ResultObservationType>>>;
  result_summary?: Maybe<ResultSummaryOutput>;
  results?: Maybe<ResultType>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "rootstock" */
  rootstock: Array<Rootstock>;
  /** fetch aggregated fields from the table: "rootstock" */
  rootstock_aggregate: Rootstock_Aggregate;
  /** fetch data from the table: "rootstock" using primary key columns */
  rootstock_by_pk?: Maybe<Rootstock>;
  /** fetch data from the table: "sample" */
  sample: Array<Sample>;
  /** fetch aggregated fields from the table: "sample" */
  sample_aggregate: Sample_Aggregate;
  /** fetch data from the table: "sample" using primary key columns */
  sample_by_pk?: Maybe<Sample>;
  /** An array relationship */
  sample_media: Array<Sample_Media>;
  /** An aggregate relationship */
  sample_media_aggregate: Sample_Media_Aggregate;
  /** fetch data from the table: "sample_media" using primary key columns */
  sample_media_by_pk?: Maybe<Sample_Media>;
  /** fetch data from the table: "sample_observation" */
  sample_observation: Array<Sample_Observation>;
  /** fetch aggregated fields from the table: "sample_observation" */
  sample_observation_aggregate: Sample_Observation_Aggregate;
  /** fetch data from the table: "sample_observation_attachments" */
  sample_observation_attachments: Array<Sample_Observation_Attachments>;
  /** fetch aggregated fields from the table: "sample_observation_attachments" */
  sample_observation_attachments_aggregate: Sample_Observation_Attachments_Aggregate;
  /** fetch data from the table: "sample_observation_attachments" using primary key columns */
  sample_observation_attachments_by_pk?: Maybe<Sample_Observation_Attachments>;
  /** fetch data from the table: "sample_observation" using primary key columns */
  sample_observation_by_pk?: Maybe<Sample_Observation>;
  sample_summary_chart?: Maybe<Array<Maybe<SampleSummaryChartOutput>>>;
  /** execute function "search_base_users" which returns "base_user" */
  search_base_users: Array<Base_User>;
  /** execute function "search_base_users" and query aggregates on result of table type "base_user" */
  search_base_users_aggregate: Base_User_Aggregate;
  /** execute function "search_businesses" which returns "business" */
  search_businesses: Array<Business>;
  /** execute function "search_businesses" and query aggregates on result of table type "business" */
  search_businesses_aggregate: Business_Aggregate;
  /** execute function "search_businesses_groups" which returns "business_group" */
  search_businesses_groups: Array<Business_Group>;
  /** execute function "search_businesses_groups" and query aggregates on result of table type "business_group" */
  search_businesses_groups_aggregate: Business_Group_Aggregate;
  /** execute function "search_mutual_groups" which returns "mutual_group" */
  search_mutual_groups: Array<Mutual_Group>;
  /** execute function "search_mutual_groups" and query aggregates on result of table type "mutual_group" */
  search_mutual_groups_aggregate: Mutual_Group_Aggregate;
  /** execute function "search_plot_crops" which returns "plot_crop" */
  search_plot_crops: Array<Plot_Crop>;
  /** execute function "search_plot_crops" and query aggregates on result of table type "plot_crop" */
  search_plot_crops_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" */
  secondary_growth_stage: Array<Secondary_Growth_Stage>;
  /** fetch aggregated fields from the table: "secondary_growth_stage" */
  secondary_growth_stage_aggregate: Secondary_Growth_Stage_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" using primary key columns */
  secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  sellable_item_stock_detail?: Maybe<SellableItemStockGlType>;
  seller_hash?: Maybe<Scalars['String']>;
  seller_receivable_amount_current_year?: Maybe<Scalars['Float']>;
  /** fetch data from the table: "setu_trade_address" */
  setu_trade_address: Array<Setu_Trade_Address>;
  /** fetch aggregated fields from the table: "setu_trade_address" */
  setu_trade_address_aggregate: Setu_Trade_Address_Aggregate;
  /** fetch data from the table: "setu_trade_address" using primary key columns */
  setu_trade_address_by_pk?: Maybe<Setu_Trade_Address>;
  /** fetch data from the table: "shared_entity" */
  setu_trade_shared_entity: Array<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "shared_entity" using primary key columns */
  setu_trade_shared_entity_by_pk?: Maybe<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "media" */
  setutrade_media: Array<Setutrade_Media>;
  /** fetch aggregated fields from the table: "media" */
  setutrade_media_aggregate: Setutrade_Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  setutrade_media_by_pk?: Maybe<Setutrade_Media>;
  /** fetch data from the table: "trip" */
  setutrade_trip: Array<Setutrade_Trip>;
  /** fetch aggregated fields from the table: "trip" */
  setutrade_trip_aggregate: Setutrade_Trip_Aggregate;
  /** fetch data from the table: "trip" using primary key columns */
  setutrade_trip_by_pk?: Maybe<Setutrade_Trip>;
  /** An array relationship */
  shareholder_applications: Array<Shareholder_Applications>;
  /** An aggregate relationship */
  shareholder_applications_aggregate: Shareholder_Applications_Aggregate;
  /** fetch data from the table: "shareholder_applications" using primary key columns */
  shareholder_applications_by_pk?: Maybe<Shareholder_Applications>;
  /** An array relationship */
  shareholders: Array<Shareholders>;
  /** An aggregate relationship */
  shareholders_aggregate: Shareholders_Aggregate;
  /** fetch data from the table: "shareholders" using primary key columns */
  shareholders_by_pk?: Maybe<Shareholders>;
  /** fetch data from the table: "si_unit" */
  si_unit: Array<Si_Unit>;
  /** fetch aggregated fields from the table: "si_unit" */
  si_unit_aggregate: Si_Unit_Aggregate;
  /** fetch data from the table: "si_unit" using primary key columns */
  si_unit_by_pk?: Maybe<Si_Unit>;
  /** fetch data from the table: "si_unit_measure" */
  si_unit_measure: Array<Si_Unit_Measure>;
  /** fetch aggregated fields from the table: "si_unit_measure" */
  si_unit_measure_aggregate: Si_Unit_Measure_Aggregate;
  /** fetch data from the table: "si_unit_measure" using primary key columns */
  si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  signed_url?: Maybe<Scalars['String']>;
  /** fetch data from the table: "sku" */
  sku: Array<Sku>;
  /** fetch aggregated fields from the table: "sku" */
  sku_aggregate: Sku_Aggregate;
  /** fetch data from the table: "sku" using primary key columns */
  sku_by_pk?: Maybe<Sku>;
  /** fetch data from the table: "sku_kind" */
  sku_kind: Array<Sku_Kind>;
  /** fetch aggregated fields from the table: "sku_kind" */
  sku_kind_aggregate: Sku_Kind_Aggregate;
  /** fetch data from the table: "sku_kind" using primary key columns */
  sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** fetch data from the table: "soil" */
  soil: Array<Soil>;
  /** fetch aggregated fields from the table: "soil" */
  soil_aggregate: Soil_Aggregate;
  /** fetch data from the table: "soil" using primary key columns */
  soil_by_pk?: Maybe<Soil>;
  soil_types?: Maybe<Array<Maybe<SoilType>>>;
  /** fetch data from the table: "stage_actions" */
  stage_actions: Array<Stage_Actions>;
  /** fetch aggregated fields from the table: "stage_actions" */
  stage_actions_aggregate: Stage_Actions_Aggregate;
  /** fetch data from the table: "stage_actions" using primary key columns */
  stage_actions_by_pk?: Maybe<Stage_Actions>;
  /** fetch data from the table: "stage_logs" */
  stage_logs: Array<Stage_Logs>;
  /** fetch aggregated fields from the table: "stage_logs" */
  stage_logs_aggregate: Stage_Logs_Aggregate;
  /** fetch data from the table: "stage_logs" using primary key columns */
  stage_logs_by_pk?: Maybe<Stage_Logs>;
  /** An array relationship */
  stages: Array<Stages>;
  /** An aggregate relationship */
  stages_aggregate: Stages_Aggregate;
  /** fetch data from the table: "stages" using primary key columns */
  stages_by_pk?: Maybe<Stages>;
  /** fetch data from the table: "stages_subscribers" */
  stages_subscribers: Array<Stages_Subscribers>;
  /** fetch aggregated fields from the table: "stages_subscribers" */
  stages_subscribers_aggregate: Stages_Subscribers_Aggregate;
  /** fetch data from the table: "stages_subscribers" using primary key columns */
  stages_subscribers_by_pk?: Maybe<Stages_Subscribers>;
  /** fetch data from the table: "state" */
  state: Array<State>;
  /** fetch aggregated fields from the table: "state" */
  state_aggregate: State_Aggregate;
  /** fetch data from the table: "state" using primary key columns */
  state_by_pk?: Maybe<State>;
  storage_dashboard?: Maybe<Array<Maybe<StorageCommoditySummaryType>>>;
  /** fetch data from the table: "storage_location" */
  storage_location: Array<Storage_Location>;
  /** fetch aggregated fields from the table: "storage_location" */
  storage_location_aggregate: Storage_Location_Aggregate;
  /** fetch data from the table: "storage_location_agreement" */
  storage_location_agreement: Array<Storage_Location_Agreement>;
  /** fetch aggregated fields from the table: "storage_location_agreement" */
  storage_location_agreement_aggregate: Storage_Location_Agreement_Aggregate;
  /** fetch data from the table: "storage_location_agreement_attachments" */
  storage_location_agreement_attachments: Array<Storage_Location_Agreement_Attachments>;
  /** fetch aggregated fields from the table: "storage_location_agreement_attachments" */
  storage_location_agreement_attachments_aggregate: Storage_Location_Agreement_Attachments_Aggregate;
  /** fetch data from the table: "storage_location_agreement_attachments" using primary key columns */
  storage_location_agreement_attachments_by_pk?: Maybe<Storage_Location_Agreement_Attachments>;
  /** fetch data from the table: "storage_location_agreement" using primary key columns */
  storage_location_agreement_by_pk?: Maybe<Storage_Location_Agreement>;
  /** fetch data from the table: "storage_location" using primary key columns */
  storage_location_by_pk?: Maybe<Storage_Location>;
  storage_location_detail?: Maybe<StorageLocationDetailType>;
  /** fetch data from the table: "storage_location_kind" */
  storage_location_kind: Array<Storage_Location_Kind>;
  /** fetch aggregated fields from the table: "storage_location_kind" */
  storage_location_kind_aggregate: Storage_Location_Kind_Aggregate;
  /** fetch data from the table: "storage_location_kind" using primary key columns */
  storage_location_kind_by_pk?: Maybe<Storage_Location_Kind>;
  /** fetch data from the table: "storage_location_pocs" */
  storage_location_pocs: Array<Storage_Location_Pocs>;
  /** fetch aggregated fields from the table: "storage_location_pocs" */
  storage_location_pocs_aggregate: Storage_Location_Pocs_Aggregate;
  /** fetch data from the table: "storage_location_pocs" using primary key columns */
  storage_location_pocs_by_pk?: Maybe<Storage_Location_Pocs>;
  storage_location_summary?: Maybe<StorageLocationSummaryType>;
  /** fetch data from the table: "storage_sub_location" */
  storage_sub_location: Array<Storage_Sub_Location>;
  /** fetch aggregated fields from the table: "storage_sub_location" */
  storage_sub_location_aggregate: Storage_Sub_Location_Aggregate;
  /** fetch data from the table: "storage_sub_location" using primary key columns */
  storage_sub_location_by_pk?: Maybe<Storage_Sub_Location>;
  storage_summary?: Maybe<StorageSummaryType>;
  supplier_groups_plot_aggreagte?: Maybe<Array<Maybe<AggregateSupplierGroupPlot>>>;
  supplier_plot_aggreagte?: Maybe<Array<Maybe<MutualGroupMembersipType>>>;
  /** fetch data from the table: "survey_parameters" */
  survey_parameters: Array<Survey_Parameters>;
  /** fetch aggregated fields from the table: "survey_parameters" */
  survey_parameters_aggregate: Survey_Parameters_Aggregate;
  /** fetch data from the table: "survey_parameters" using primary key columns */
  survey_parameters_by_pk?: Maybe<Survey_Parameters>;
  /** fetch data from the table: "survey_response_items" */
  survey_response_items: Array<Survey_Response_Items>;
  /** fetch aggregated fields from the table: "survey_response_items" */
  survey_response_items_aggregate: Survey_Response_Items_Aggregate;
  /** fetch data from the table: "survey_response_items" using primary key columns */
  survey_response_items_by_pk?: Maybe<Survey_Response_Items>;
  /** An array relationship */
  survey_responses: Array<Survey_Responses>;
  /** An aggregate relationship */
  survey_responses_aggregate: Survey_Responses_Aggregate;
  /** fetch data from the table: "survey_responses" using primary key columns */
  survey_responses_by_pk?: Maybe<Survey_Responses>;
  /** fetch data from the table: "survey_users" */
  survey_users: Array<Survey_Users>;
  /** fetch aggregated fields from the table: "survey_users" */
  survey_users_aggregate: Survey_Users_Aggregate;
  /** fetch data from the table: "survey_users" using primary key columns */
  survey_users_by_pk?: Maybe<Survey_Users>;
  /** fetch data from the table: "survey_year" */
  survey_year: Array<Survey_Year>;
  /** fetch aggregated fields from the table: "survey_year" */
  survey_year_aggregate: Survey_Year_Aggregate;
  /** fetch data from the table: "survey_year" using primary key columns */
  survey_year_by_pk?: Maybe<Survey_Year>;
  /** fetch data from the table: "surveys" */
  surveys: Array<Surveys>;
  /** fetch aggregated fields from the table: "surveys" */
  surveys_aggregate: Surveys_Aggregate;
  /** fetch data from the table: "surveys" using primary key columns */
  surveys_by_pk?: Maybe<Surveys>;
  team_document_count?: Maybe<Scalars['Int']>;
  /** fetch data from the table: "template" */
  template: Array<Template>;
  /** fetch aggregated fields from the table: "template" */
  template_aggregate: Template_Aggregate;
  /** fetch data from the table: "template" using primary key columns */
  template_by_pk?: Maybe<Template>;
  /** fetch data from the table: "template_category" */
  template_category: Array<Template_Category>;
  /** fetch aggregated fields from the table: "template_category" */
  template_category_aggregate: Template_Category_Aggregate;
  /** fetch data from the table: "template_category_allowed_groups" */
  template_category_allowed_groups: Array<Template_Category_Allowed_Groups>;
  /** fetch aggregated fields from the table: "template_category_allowed_groups" */
  template_category_allowed_groups_aggregate: Template_Category_Allowed_Groups_Aggregate;
  /** fetch data from the table: "template_category_allowed_groups" using primary key columns */
  template_category_allowed_groups_by_pk?: Maybe<Template_Category_Allowed_Groups>;
  /** fetch data from the table: "template_category_allowed_parameter_categories" */
  template_category_allowed_parameter_categories: Array<Template_Category_Allowed_Parameter_Categories>;
  /** fetch aggregated fields from the table: "template_category_allowed_parameter_categories" */
  template_category_allowed_parameter_categories_aggregate: Template_Category_Allowed_Parameter_Categories_Aggregate;
  /** fetch data from the table: "template_category_allowed_parameter_categories" using primary key columns */
  template_category_allowed_parameter_categories_by_pk?: Maybe<Template_Category_Allowed_Parameter_Categories>;
  /** fetch data from the table: "template_category" using primary key columns */
  template_category_by_pk?: Maybe<Template_Category>;
  /** fetch data from the table: "template_company" */
  template_company: Array<Template_Company>;
  /** fetch aggregated fields from the table: "template_company" */
  template_company_aggregate: Template_Company_Aggregate;
  /** fetch data from the table: "template_company" using primary key columns */
  template_company_by_pk?: Maybe<Template_Company>;
  /** fetch data from the table: "template_departments" */
  template_departments: Array<Template_Departments>;
  /** fetch aggregated fields from the table: "template_departments" */
  template_departments_aggregate: Template_Departments_Aggregate;
  /** fetch data from the table: "template_departments" using primary key columns */
  template_departments_by_pk?: Maybe<Template_Departments>;
  /** fetch data from the table: "template_evaluation" */
  template_evaluation: Array<Template_Evaluation>;
  /** fetch aggregated fields from the table: "template_evaluation" */
  template_evaluation_aggregate: Template_Evaluation_Aggregate;
  /** fetch data from the table: "template_evaluation" using primary key columns */
  template_evaluation_by_pk?: Maybe<Template_Evaluation>;
  /** fetch data from the table: "template_evaluation_config" */
  template_evaluation_config: Array<Template_Evaluation_Config>;
  /** fetch aggregated fields from the table: "template_evaluation_config" */
  template_evaluation_config_aggregate: Template_Evaluation_Config_Aggregate;
  /** fetch data from the table: "template_evaluation_config" using primary key columns */
  template_evaluation_config_by_pk?: Maybe<Template_Evaluation_Config>;
  /** fetch data from the table: "template_evaluation_templates" */
  template_evaluation_templates: Array<Template_Evaluation_Templates>;
  /** fetch aggregated fields from the table: "template_evaluation_templates" */
  template_evaluation_templates_aggregate: Template_Evaluation_Templates_Aggregate;
  /** fetch data from the table: "template_evaluation_templates" using primary key columns */
  template_evaluation_templates_by_pk?: Maybe<Template_Evaluation_Templates>;
  /** fetch data from the table: "template_parameter" */
  template_parameter: Array<Template_Parameter>;
  /** fetch aggregated fields from the table: "template_parameter" */
  template_parameter_aggregate: Template_Parameter_Aggregate;
  /** fetch data from the table: "template_parameter" using primary key columns */
  template_parameter_by_pk?: Maybe<Template_Parameter>;
  /** fetch data from the table: "template_parameter_config" */
  template_parameter_config: Array<Template_Parameter_Config>;
  /** fetch aggregated fields from the table: "template_parameter_config" */
  template_parameter_config_aggregate: Template_Parameter_Config_Aggregate;
  /** fetch data from the table: "template_parameter_config" using primary key columns */
  template_parameter_config_by_pk?: Maybe<Template_Parameter_Config>;
  /** fetch data from the table: "template_parameter_standard" */
  template_parameter_standard: Array<Template_Parameter_Standard>;
  /** fetch aggregated fields from the table: "template_parameter_standard" */
  template_parameter_standard_aggregate: Template_Parameter_Standard_Aggregate;
  /** fetch data from the table: "template_parameter_standard_attachments" */
  template_parameter_standard_attachments: Array<Template_Parameter_Standard_Attachments>;
  /** fetch aggregated fields from the table: "template_parameter_standard_attachments" */
  template_parameter_standard_attachments_aggregate: Template_Parameter_Standard_Attachments_Aggregate;
  /** fetch data from the table: "template_parameter_standard_attachments" using primary key columns */
  template_parameter_standard_attachments_by_pk?: Maybe<Template_Parameter_Standard_Attachments>;
  /** fetch data from the table: "template_parameter_standard" using primary key columns */
  template_parameter_standard_by_pk?: Maybe<Template_Parameter_Standard>;
  /** fetch data from the table: "template_parameter_standard_group" */
  template_parameter_standard_group: Array<Template_Parameter_Standard_Group>;
  /** fetch aggregated fields from the table: "template_parameter_standard_group" */
  template_parameter_standard_group_aggregate: Template_Parameter_Standard_Group_Aggregate;
  /** fetch data from the table: "template_parameter_standard_group" using primary key columns */
  template_parameter_standard_group_by_pk?: Maybe<Template_Parameter_Standard_Group>;
  /** fetch data from the table: "template_quality_stages" */
  template_quality_stages: Array<Template_Quality_Stages>;
  /** fetch aggregated fields from the table: "template_quality_stages" */
  template_quality_stages_aggregate: Template_Quality_Stages_Aggregate;
  /** fetch data from the table: "template_quality_stages" using primary key columns */
  template_quality_stages_by_pk?: Maybe<Template_Quality_Stages>;
  /** fetch data from the table: "trade" */
  trade: Array<Trade>;
  /** fetch data from the table: "action_log" */
  trade_action_log: Array<Trade_Action_Log>;
  /** fetch data from the table: "action_log" using primary key columns */
  trade_action_log_by_pk?: Maybe<Trade_Action_Log>;
  /** fetch aggregated fields from the table: "trade" */
  trade_aggregate: Trade_Aggregate;
  /** fetch data from the table: "trade_assessment" */
  trade_assessment: Array<Trade_Assessment>;
  /** fetch aggregated fields from the table: "trade_assessment" */
  trade_assessment_aggregate: Trade_Assessment_Aggregate;
  /** fetch data from the table: "trade_assessment" using primary key columns */
  trade_assessment_by_pk?: Maybe<Trade_Assessment>;
  /** An array relationship */
  trade_assessment_cw: Array<Trade_Assessment_Cw>;
  /** An aggregate relationship */
  trade_assessment_cw_aggregate: Trade_Assessment_Cw_Aggregate;
  /** fetch data from the table: "trade_assessment_cw" using primary key columns */
  trade_assessment_cw_by_pk?: Maybe<Trade_Assessment_Cw>;
  trade_assessment_dynamic?: Maybe<TradeAssessmentDynamicType>;
  /** fetch data from the table: "trade_attachments" */
  trade_attachments: Array<Trade_Attachments>;
  /** fetch aggregated fields from the table: "trade_attachments" */
  trade_attachments_aggregate: Trade_Attachments_Aggregate;
  /** fetch data from the table: "trade_attachments" using primary key columns */
  trade_attachments_by_pk?: Maybe<Trade_Attachments>;
  trade_buyer_bifurcation?: Maybe<BuyerBifurcationType>;
  /** fetch data from the table: "trade_buyer_gst_attachments" */
  trade_buyer_gst_attachments: Array<Trade_Buyer_Gst_Attachments>;
  /** fetch aggregated fields from the table: "trade_buyer_gst_attachments" */
  trade_buyer_gst_attachments_aggregate: Trade_Buyer_Gst_Attachments_Aggregate;
  /** fetch data from the table: "trade_buyer_gst_attachments" using primary key columns */
  trade_buyer_gst_attachments_by_pk?: Maybe<Trade_Buyer_Gst_Attachments>;
  /** fetch data from the table: "trade" using primary key columns */
  trade_by_pk?: Maybe<Trade>;
  /** fetch data from the table: "trade_expense_tax" */
  trade_expense_tax: Array<Trade_Expense_Tax>;
  /** fetch aggregated fields from the table: "trade_expense_tax" */
  trade_expense_tax_aggregate: Trade_Expense_Tax_Aggregate;
  /** fetch data from the table: "trade_expense_tax" using primary key columns */
  trade_expense_tax_by_pk?: Maybe<Trade_Expense_Tax>;
  trade_grade_quantity_summary?: Maybe<Array<Maybe<TradeGradeSummarySchema>>>;
  trade_grade_quantity_summary_report?: Maybe<TradeGradeSummaryReportSchema>;
  /** fetch data from the table: "trade_issuancenoteitems" */
  trade_issuancenoteitems: Array<Trade_Issuancenoteitems>;
  /** fetch aggregated fields from the table: "trade_issuancenoteitems" */
  trade_issuancenoteitems_aggregate: Trade_Issuancenoteitems_Aggregate;
  /** fetch data from the table: "trade_issuancenoteitems_attachments" */
  trade_issuancenoteitems_attachments: Array<Trade_Issuancenoteitems_Attachments>;
  /** fetch aggregated fields from the table: "trade_issuancenoteitems_attachments" */
  trade_issuancenoteitems_attachments_aggregate: Trade_Issuancenoteitems_Attachments_Aggregate;
  /** fetch data from the table: "trade_issuancenoteitems_attachments" using primary key columns */
  trade_issuancenoteitems_attachments_by_pk?: Maybe<Trade_Issuancenoteitems_Attachments>;
  /** fetch data from the table: "trade_issuancenoteitems" using primary key columns */
  trade_issuancenoteitems_by_pk?: Maybe<Trade_Issuancenoteitems>;
  /** fetch data from the table: "trade_item" */
  trade_item: Array<Trade_Item>;
  /** fetch aggregated fields from the table: "trade_item" */
  trade_item_aggregate: Trade_Item_Aggregate;
  /** fetch data from the table: "trade_item_attachments" */
  trade_item_attachments: Array<Trade_Item_Attachments>;
  /** fetch aggregated fields from the table: "trade_item_attachments" */
  trade_item_attachments_aggregate: Trade_Item_Attachments_Aggregate;
  /** fetch data from the table: "trade_item_attachments" using primary key columns */
  trade_item_attachments_by_pk?: Maybe<Trade_Item_Attachments>;
  /** fetch data from the table: "trade_item" using primary key columns */
  trade_item_by_pk?: Maybe<Trade_Item>;
  trade_seller_bifurcation?: Maybe<SellerBifurcationType>;
  /** fetch data from the table: "trade_seller_gst_attachments" */
  trade_seller_gst_attachments: Array<Trade_Seller_Gst_Attachments>;
  /** fetch aggregated fields from the table: "trade_seller_gst_attachments" */
  trade_seller_gst_attachments_aggregate: Trade_Seller_Gst_Attachments_Aggregate;
  /** fetch data from the table: "trade_seller_gst_attachments" using primary key columns */
  trade_seller_gst_attachments_by_pk?: Maybe<Trade_Seller_Gst_Attachments>;
  /** fetch data from the table: "trade_status" */
  trade_status: Array<Trade_Status>;
  /** fetch aggregated fields from the table: "trade_status" */
  trade_status_aggregate: Trade_Status_Aggregate;
  /** fetch data from the table: "trade_status" using primary key columns */
  trade_status_by_pk?: Maybe<Trade_Status>;
  /** fetch data from the table: "trade_status_parents" */
  trade_status_parents: Array<Trade_Status_Parents>;
  /** fetch aggregated fields from the table: "trade_status_parents" */
  trade_status_parents_aggregate: Trade_Status_Parents_Aggregate;
  /** fetch data from the table: "trade_status_parents" using primary key columns */
  trade_status_parents_by_pk?: Maybe<Trade_Status_Parents>;
  trade_summary?: Maybe<TradeSummaryType>;
  /** fetch data from the table: "trade_taxes" */
  trade_taxes: Array<Trade_Taxes>;
  /** fetch aggregated fields from the table: "trade_taxes" */
  trade_taxes_aggregate: Trade_Taxes_Aggregate;
  /** fetch data from the table: "trade_taxes" using primary key columns */
  trade_taxes_by_pk?: Maybe<Trade_Taxes>;
  trade_timeline?: Maybe<Array<Maybe<TimelineItemSchema>>>;
  trade_tnc_template_detail?: Maybe<OrganisationTradeTnCsTemplateSchema>;
  trade_tnc_versions?: Maybe<Array<Maybe<OrganisationTradeTnCsVersionSchema>>>;
  /** fetch data from the table: "trade_tradestatusaccess" */
  trade_tradestatusaccess: Array<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_tradestatusaccess" using primary key columns */
  trade_tradestatusaccess_by_pk?: Maybe<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_twiliomessages" */
  trade_twiliomessages: Array<Trade_Twiliomessages>;
  /** fetch data from the table: "trade_twiliomessages" using primary key columns */
  trade_twiliomessages_by_pk?: Maybe<Trade_Twiliomessages>;
  trading_party_detail?: Maybe<MutualGroupSchema>;
  trading_party_list?: Maybe<Array<Maybe<MutualGroupSchema>>>;
  /** fetch data from the table: "transaction" */
  transaction: Array<Transaction>;
  /** fetch aggregated fields from the table: "transaction" */
  transaction_aggregate: Transaction_Aggregate;
  /** fetch data from the table: "transaction_attachments" */
  transaction_attachments: Array<Transaction_Attachments>;
  /** fetch aggregated fields from the table: "transaction_attachments" */
  transaction_attachments_aggregate: Transaction_Attachments_Aggregate;
  /** fetch data from the table: "transaction_attachments" using primary key columns */
  transaction_attachments_by_pk?: Maybe<Transaction_Attachments>;
  /** fetch data from the table: "transaction" using primary key columns */
  transaction_by_pk?: Maybe<Transaction>;
  /** fetch data from the table: "transactions" */
  transactions: Array<Transactions>;
  /** fetch aggregated fields from the table: "transactions" */
  transactions_aggregate: Transactions_Aggregate;
  /** fetch data from the table: "transactions_attachments" */
  transactions_attachments: Array<Transactions_Attachments>;
  /** fetch aggregated fields from the table: "transactions_attachments" */
  transactions_attachments_aggregate: Transactions_Attachments_Aggregate;
  /** fetch data from the table: "transactions_attachments" using primary key columns */
  transactions_attachments_by_pk?: Maybe<Transactions_Attachments>;
  /** fetch data from the table: "transactions" using primary key columns */
  transactions_by_pk?: Maybe<Transactions>;
  transactions_for_invoice_settlement?: Maybe<Array<Maybe<TransactionType>>>;
  /** fetch data from the table: "transition" */
  transition: Array<Transition>;
  /** fetch data from the table: "transition_access" */
  transition_access: Array<Transition_Access>;
  /** fetch aggregated fields from the table: "transition_access" */
  transition_access_aggregate: Transition_Access_Aggregate;
  /** fetch data from the table: "transition_access" using primary key columns */
  transition_access_by_pk?: Maybe<Transition_Access>;
  /** fetch aggregated fields from the table: "transition" */
  transition_aggregate: Transition_Aggregate;
  /** fetch data from the table: "transition" using primary key columns */
  transition_by_pk?: Maybe<Transition>;
  /** fetch data from the table: "transition_history" */
  transition_history: Array<Transition_History>;
  /** fetch aggregated fields from the table: "transition_history" */
  transition_history_aggregate: Transition_History_Aggregate;
  /** fetch data from the table: "transition_history_attribute" */
  transition_history_attribute: Array<Transition_History_Attribute>;
  /** fetch aggregated fields from the table: "transition_history_attribute" */
  transition_history_attribute_aggregate: Transition_History_Attribute_Aggregate;
  /** fetch data from the table: "transition_history_attribute" using primary key columns */
  transition_history_attribute_by_pk?: Maybe<Transition_History_Attribute>;
  /** fetch data from the table: "transition_history" using primary key columns */
  transition_history_by_pk?: Maybe<Transition_History>;
  trip_detail?: Maybe<TripGlType>;
  trip_trader_summary?: Maybe<Array<Maybe<TripTraderSummaryType>>>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table: "unit_measure" */
  unit_measure: Array<Unit_Measure>;
  /** fetch aggregated fields from the table: "unit_measure" */
  unit_measure_aggregate: Unit_Measure_Aggregate;
  /** fetch data from the table: "unit_measure" using primary key columns */
  unit_measure_by_pk?: Maybe<Unit_Measure>;
  /** fetch data from the table: "unregistered_user" */
  unregistered_user: Array<Unregistered_User>;
  /** fetch aggregated fields from the table: "unregistered_user" */
  unregistered_user_aggregate: Unregistered_User_Aggregate;
  /** fetch data from the table: "unregistered_user" using primary key columns */
  unregistered_user_by_pk?: Maybe<Unregistered_User>;
  user_accounts?: Maybe<Array<Maybe<AccountGlType>>>;
  user_by_username?: Maybe<BaseUserType>;
  user_kind_list?: Maybe<Array<Maybe<KeyNameSchema>>>;
  user_permission_groups?: Maybe<Array<Maybe<UserGroupType>>>;
  user_profile?: Maybe<BaseUserAggregationType>;
  /** fetch data from the table: "variety_agreement" */
  variety_agreement: Array<Variety_Agreement>;
  /** fetch aggregated fields from the table: "variety_agreement" */
  variety_agreement_aggregate: Variety_Agreement_Aggregate;
  /** fetch data from the table: "variety_agreement_agreement_co_owners" */
  variety_agreement_agreement_co_owners: Array<Variety_Agreement_Agreement_Co_Owners>;
  /** fetch aggregated fields from the table: "variety_agreement_agreement_co_owners" */
  variety_agreement_agreement_co_owners_aggregate: Variety_Agreement_Agreement_Co_Owners_Aggregate;
  /** fetch data from the table: "variety_agreement_agreement_co_owners" using primary key columns */
  variety_agreement_agreement_co_owners_by_pk?: Maybe<Variety_Agreement_Agreement_Co_Owners>;
  /** fetch data from the table: "variety_agreement" using primary key columns */
  variety_agreement_by_pk?: Maybe<Variety_Agreement>;
  /** fetch data from the table: "variety_agreement_guarantor_agreements" */
  variety_agreement_guarantor_agreements: Array<Variety_Agreement_Guarantor_Agreements>;
  /** fetch aggregated fields from the table: "variety_agreement_guarantor_agreements" */
  variety_agreement_guarantor_agreements_aggregate: Variety_Agreement_Guarantor_Agreements_Aggregate;
  /** fetch data from the table: "variety_agreement_guarantor_agreements" using primary key columns */
  variety_agreement_guarantor_agreements_by_pk?: Maybe<Variety_Agreement_Guarantor_Agreements>;
  /** fetch data from the table: "variety_grade" */
  variety_grade: Array<Variety_Grade>;
  /** fetch aggregated fields from the table: "variety_grade" */
  variety_grade_aggregate: Variety_Grade_Aggregate;
  /** fetch data from the table: "variety_grade" using primary key columns */
  variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** fetch data from the table: "variety_grade_photos" */
  variety_grade_photos: Array<Variety_Grade_Photos>;
  /** fetch aggregated fields from the table: "variety_grade_photos" */
  variety_grade_photos_aggregate: Variety_Grade_Photos_Aggregate;
  /** fetch data from the table: "variety_grade_photos" using primary key columns */
  variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** fetch data from the table: "variety_group" */
  variety_group: Array<Variety_Group>;
  /** fetch aggregated fields from the table: "variety_group" */
  variety_group_aggregate: Variety_Group_Aggregate;
  /** fetch data from the table: "variety_group" using primary key columns */
  variety_group_by_pk?: Maybe<Variety_Group>;
  vehicle_detail?: Maybe<VehicleGlType>;
  village_wise_chemical_count?: Maybe<VillageWiseChemicalCountOutput>;
  village_wise_detection_count?: Maybe<VillageWiseDetectionCountOutput>;
  /** fetch data from the table: "vt_core_tax" */
  vt_core_tax: Array<Vt_Core_Tax>;
  /** fetch aggregated fields from the table: "vt_core_tax" */
  vt_core_tax_aggregate: Vt_Core_Tax_Aggregate;
  /** fetch data from the table: "vt_core_tax" using primary key columns */
  vt_core_tax_by_pk?: Maybe<Vt_Core_Tax>;
  /** fetch data from the table: "weather_reference" */
  weather_reference: Array<Weather_Reference>;
  /** fetch aggregated fields from the table: "weather_reference" */
  weather_reference_aggregate: Weather_Reference_Aggregate;
  /** fetch data from the table: "weather_reference" using primary key columns */
  weather_reference_by_pk?: Maybe<Weather_Reference>;
  /** fetch data from the table: "workflow" */
  workflow: Array<Workflow>;
  /** fetch aggregated fields from the table: "workflow" */
  workflow_aggregate: Workflow_Aggregate;
  /** fetch data from the table: "workflow" using primary key columns */
  workflow_by_pk?: Maybe<Workflow>;
  /** fetch data from the table: "workflow_current_logs" */
  workflow_current_logs: Array<Workflow_Current_Logs>;
  /** fetch aggregated fields from the table: "workflow_current_logs" */
  workflow_current_logs_aggregate: Workflow_Current_Logs_Aggregate;
  /** fetch data from the table: "workflow_current_logs" using primary key columns */
  workflow_current_logs_by_pk?: Maybe<Workflow_Current_Logs>;
  /** fetch data from the table: "workflows" */
  workflows: Array<Workflows>;
  /** fetch aggregated fields from the table: "workflows" */
  workflows_aggregate: Workflows_Aggregate;
  /** fetch data from the table: "workflows" using primary key columns */
  workflows_by_pk?: Maybe<Workflows>;
};


export type Query_RootTransaction_ModeArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Mode_Order_By>>;
  where?: InputMaybe<Transaction_Mode_Bool_Exp>;
};


export type Query_RootTransaction_Mode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Mode_Order_By>>;
  where?: InputMaybe<Transaction_Mode_Bool_Exp>;
};


export type Query_RootTransaction_Mode_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAction_LogArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Query_RootAction_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Query_RootAction_Log_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAdvance_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


export type Query_RootAdvance_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


export type Query_RootAdvance_Payment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAdvance_Payment_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Parameters_Order_By>>;
  where?: InputMaybe<Advance_Payment_Parameters_Bool_Exp>;
};


export type Query_RootAdvance_Payment_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Parameters_Order_By>>;
  where?: InputMaybe<Advance_Payment_Parameters_Bool_Exp>;
};


export type Query_RootAdvance_Payment_Parameters_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAdvance_Summary_By_ReceiptArgs = {
  receipt_id: Scalars['ID'];
};


export type Query_RootAdvance_Summary_By_TradeArgs = {
  trade_id: Scalars['ID'];
};


export type Query_RootAdvance_Summary_DashboardArgs = {
  created_by_id?: InputMaybe<Scalars['ID']>;
  created_from?: InputMaybe<Scalars['Date']>;
  created_till?: InputMaybe<Scalars['Date']>;
  department_id?: InputMaybe<Scalars['ID']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  parameter_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  settlement_status?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trade_kind?: InputMaybe<Scalars['String']>;
  user_reference_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootAdvance_Summary_Dashboard_ReceiptArgs = {
  created_by_id?: InputMaybe<Scalars['ID']>;
  created_from?: InputMaybe<Scalars['Date']>;
  created_till?: InputMaybe<Scalars['Date']>;
  department_id?: InputMaybe<Scalars['ID']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  parameter_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  settlement_status?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  user_reference_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootAgentArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Query_RootAgent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Query_RootAgent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgent_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Query_RootAgent_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Query_RootAgent_Company_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgent_RoleArgs = {
  distinct_on?: InputMaybe<Array<Agent_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Role_Order_By>>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};


export type Query_RootAgent_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Role_Order_By>>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};


export type Query_RootAgent_Role_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAggregate_Invoice_SummaryArgs = {
  buyer_reference_id?: InputMaybe<Scalars['String']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_from?: InputMaybe<Scalars['Date']>;
  created_till?: InputMaybe<Scalars['Date']>;
  department_reference_id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootAggregate_Receipt_Seller_SummaryArgs = {
  created_by_id?: InputMaybe<Scalars['String']>;
  created_from?: InputMaybe<Scalars['Date']>;
  created_till?: InputMaybe<Scalars['Date']>;
  department_reference_id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  seller_reference_id?: InputMaybe<Scalars['String']>;
  trade_kind_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootAggregate_Trade_Seller_SummaryArgs = {
  created_by_id?: InputMaybe<Scalars['String']>;
  created_from?: InputMaybe<Scalars['Date']>;
  created_till?: InputMaybe<Scalars['Date']>;
  department_reference_id_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  seller_reference_id?: InputMaybe<Scalars['String']>;
  trade_kind_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootAgreement_Co_OwnerArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_Agreement_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_Agreement_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_Agreement_Invoices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_Co_Owner_Agreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_Agreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_Agreement_Plots_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_Co_Owner_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_Co_Owner_Legal_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_Legal_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


export type Query_RootAgreement_Co_Owner_Legal_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_Agreement_Invoice_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_Agreement_Invoice_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_Agreement_Invoice_Items_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_Invoice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_Invoice_ItemArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Item_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Item_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_Item_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_Invoice_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


export type Query_RootAgreement_Invoice_Transaction_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_PlotArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Plot_Order_By>>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};


export type Query_RootAgreement_Plot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Plot_Order_By>>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};


export type Query_RootAgreement_Plot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreement_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Bool_Exp>;
};


export type Query_RootAgreement_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Bool_Exp>;
};


export type Query_RootAgreement_Transaction_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
};


export type Query_RootAgreement_Transaction_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
};


export type Query_RootAgreement_Transaction_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAgreement_Transaction_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAll_BookingsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  department_id?: InputMaybe<Scalars['ID']>;
  department_kite_codename?: InputMaybe<Scalars['String']>;
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<BookingGlFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_CompaniesArgs = {
  department_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_DepartmentsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_DepotsArgs = {
  filter?: InputMaybe<DepotGlInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_Distribution_CentresArgs = {
  filter?: InputMaybe<DistributionCentreGlFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_DocksArgs = {
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<DockFilterGlInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_InwardsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  distribution_centre_id?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<InwardInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_My_OrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootAll_My_Plot_SummarysArgs = {
  filter?: InputMaybe<PlotCommodityFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_Packing_MaterialsArgs = {
  type_name: Scalars['String'];
};


export type Query_RootAll_Production_BatchsArgs = {
  filter?: InputMaybe<ProductionBatchGlFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_Sellable_Item_StocksArgs = {
  filter?: InputMaybe<MySellableItemStockFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_Storage_LocationsArgs = {
  filters?: InputMaybe<AllStorageLocationsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootAll_TripsArgs = {
  department_id?: InputMaybe<Scalars['ID']>;
  department_kite_codename?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TripGlFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_VarietiesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_Variety_GroupsArgs = {
  department_id?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAll_VehiclesArgs = {
  filter?: InputMaybe<VehicleGlInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAmendment_CaseArgs = {
  distinct_on?: InputMaybe<Array<Amendment_Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Amendment_Case_Order_By>>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};


export type Query_RootAmendment_Case_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Amendment_Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Amendment_Case_Order_By>>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};


export type Query_RootAmendment_Case_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Query_RootAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Query_RootAuth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Query_RootAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Query_RootAuth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuth_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Query_RootAuth_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Query_RootAuth_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_UserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootBase_User_Address_BookArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Query_RootBase_User_Address_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Query_RootBase_User_Address_Book_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootBase_User_By_GroupArgs = {
  distribution_centre_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootBase_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Query_RootBase_User_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Query_RootBase_User_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_ContextArgs = {
  reference_id: Scalars['String'];
};


export type Query_RootBase_User_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Query_RootBase_User_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Query_RootBase_User_Departments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_DocumentsArgs = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootBase_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Query_RootBase_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Query_RootBase_User_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Query_RootBase_User_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Query_RootBase_User_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBase_User_Payment_DetailsArgs = {
  base_user_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootBase_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Query_RootBase_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Query_RootBase_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBooking_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootBrandArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Query_RootBrand_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Query_RootBrand_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootBrand_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


export type Query_RootBrand_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


export type Query_RootBrand_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootBreederArgs = {
  distinct_on?: InputMaybe<Array<Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Breeder_Order_By>>;
  where?: InputMaybe<Breeder_Bool_Exp>;
};


export type Query_RootBreeder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Breeder_Order_By>>;
  where?: InputMaybe<Breeder_Bool_Exp>;
};


export type Query_RootBreeder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusinessArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Query_RootBusiness_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Query_RootBusiness_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_Commodities_SuppliedArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Query_RootBusiness_Commodities_Supplied_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Query_RootBusiness_Commodities_Supplied_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Query_RootBusiness_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Query_RootBusiness_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_DocumentsArgs = {
  business_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootBusiness_FieldArgs = {
  distinct_on?: InputMaybe<Array<Business_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Field_Order_By>>;
  where?: InputMaybe<Business_Field_Bool_Exp>;
};


export type Query_RootBusiness_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Field_Order_By>>;
  where?: InputMaybe<Business_Field_Bool_Exp>;
};


export type Query_RootBusiness_Field_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_GroupArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Query_RootBusiness_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Query_RootBusiness_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_Group_DocumentsArgs = {
  business_group_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootBusiness_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Query_RootBusiness_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Query_RootBusiness_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Query_RootBusiness_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Query_RootBusiness_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Query_RootBusiness_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Query_RootBusiness_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBusiness_Payment_DetailsArgs = {
  business_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootBusiness_Secondary_PocsArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Query_RootBusiness_Secondary_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Query_RootBusiness_Secondary_Pocs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBuyer_Credit_Wallet_InfoArgs = {
  department_id?: InputMaybe<Scalars['ID']>;
  trade_id?: InputMaybe<Scalars['ID']>;
  user_id: Scalars['ID'];
};


export type Query_RootBuyer_HashArgs = {
  trade_id: Scalars['ID'];
};


export type Query_RootChemical_Wise_CountArgs = {
  inputs?: InputMaybe<ChemicalWiseCountInput>;
};


export type Query_RootChemical_Wise_FailArgs = {
  inputs?: InputMaybe<ChemicalWiseFailInput>;
};


export type Query_RootChemicals_ListArgs = {
  inputs?: InputMaybe<ChemicalsListInput>;
};


export type Query_RootCommodityArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Query_RootCommodity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Query_RootCommodity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommodity_Si_UnitArgs = {
  commodity_codename: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootCommodity_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Query_RootCommodity_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Query_RootCommodity_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommodity_Variety_Secondary_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Query_RootCommodity_Variety_Secondary_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Query_RootCommodity_Variety_Secondary_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompanyArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Query_RootCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Query_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompany_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


export type Query_RootCompany_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


export type Query_RootCompany_Categories_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompany_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Company_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Category_Order_By>>;
  where?: InputMaybe<Company_Category_Bool_Exp>;
};


export type Query_RootCompany_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Category_Order_By>>;
  where?: InputMaybe<Company_Category_Bool_Exp>;
};


export type Query_RootCompany_Category_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompany_DocumentsArgs = {
  company_id?: InputMaybe<Scalars['Int']>;
  document_kind__codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootCompany_Payment_DetailsArgs = {
  company_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootCompany_Share_HolderArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


export type Query_RootCompany_Share_Holder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


export type Query_RootCompany_Share_Holder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootContent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Query_RootContent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Query_RootContent_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCreditArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Query_RootCredit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Query_RootCredit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCredit_DetailArgs = {
  credit_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootCredit_NoteArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Query_RootCredit_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Query_RootCredit_Note_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCredit_RequestArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Request_Order_By>>;
  where?: InputMaybe<Credit_Request_Bool_Exp>;
};


export type Query_RootCredit_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Request_Order_By>>;
  where?: InputMaybe<Credit_Request_Bool_Exp>;
};


export type Query_RootCredit_Request_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCredit_Request_DetailArgs = {
  credit_request_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootCredit_StatusArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Order_By>>;
  where?: InputMaybe<Credit_Status_Bool_Exp>;
};


export type Query_RootCredit_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Order_By>>;
  where?: InputMaybe<Credit_Status_Bool_Exp>;
};


export type Query_RootCredit_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCredit_Status_ParentsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


export type Query_RootCredit_Status_Parents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


export type Query_RootCredit_Status_Parents_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCredit_SummaryArgs = {
  credit_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootCredit_Summary_AggregatedArgs = {
  input?: InputMaybe<CreditSummaryAggregatedInput>;
};


export type Query_RootCredit_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Query_RootCredit_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Query_RootCredit_Transaction_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCredit_WalletArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Bool_Exp>;
};


export type Query_RootCredit_Wallet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Bool_Exp>;
};


export type Query_RootCredit_Wallet_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCredit_Wallet_Invoice_ListArgs = {
  from_date?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  placed_by?: InputMaybe<Scalars['ID']>;
  to_date?: InputMaybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};


export type Query_RootCredit_Wallet_Invoice_SummaryArgs = {
  from_date?: InputMaybe<Scalars['Date']>;
  placed_by?: InputMaybe<Scalars['ID']>;
  to_date?: InputMaybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};


export type Query_RootCredit_Wallet_ListArgs = {
  created_from_date?: InputMaybe<Scalars['Date']>;
  created_to_date?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootCredit_Wallet_RequestArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Request_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
};


export type Query_RootCredit_Wallet_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Request_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
};


export type Query_RootCredit_Wallet_Request_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCredit_Wallet_StatusArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Status_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Status_Bool_Exp>;
};


export type Query_RootCredit_Wallet_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Status_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Status_Bool_Exp>;
};


export type Query_RootCredit_Wallet_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCredit_Wallet_Summary_AggregatedArgs = {
  input?: InputMaybe<CreditWalletSummaryAggregatedInput>;
};


export type Query_RootCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Query_RootCrop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Query_RootCrop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_GroupArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Query_RootCrop_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Query_RootCrop_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Growth_Stages_By_Plot_Crop_CodenameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  plot_crop_codename: Scalars['String'];
};


export type Query_RootCrop_InfestationArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Query_RootCrop_Infestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Query_RootCrop_Infestation_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Query_RootCrop_Infestation_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Query_RootCrop_Infestation_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Infestation_Details_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Infestations_By_Crop_CodenameArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crop_codename: Scalars['String'];
  search_string?: InputMaybe<Scalars['String']>;
};


export type Query_RootCrop_Infestations_By_Plot_Crop_CodenameArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  plot_crop_codename: Scalars['String'];
  search_string?: InputMaybe<Scalars['String']>;
};


export type Query_RootCrop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Query_RootCrop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Query_RootCrop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_RootstockArgs = {
  distinct_on?: InputMaybe<Array<Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Crop_Rootstock_Bool_Exp>;
};


export type Query_RootCrop_Rootstock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Crop_Rootstock_Bool_Exp>;
};


export type Query_RootCrop_Rootstock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Query_RootCrop_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Query_RootCrop_Variety_BreederArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


export type Query_RootCrop_Variety_Breeder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


export type Query_RootCrop_Variety_Breeder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCrop_YearArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Query_RootCrop_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Query_RootCrop_Year_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCultivation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cultivation_Type_Order_By>>;
  where?: InputMaybe<Cultivation_Type_Bool_Exp>;
};


export type Query_RootCultivation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cultivation_Type_Order_By>>;
  where?: InputMaybe<Cultivation_Type_Bool_Exp>;
};


export type Query_RootCultivation_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCurrent_Entity_StateArgs = {
  entity_id: Scalars['Int'];
  entity_type: Scalars['String'];
  workflow_codename: Scalars['String'];
};


export type Query_RootDecrypted_UrlArgs = {
  file_path?: InputMaybe<Scalars['String']>;
};


export type Query_RootDemandArgs = {
  distinct_on?: InputMaybe<Array<Demand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Order_By>>;
  where?: InputMaybe<Demand_Bool_Exp>;
};


export type Query_RootDemand_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Order_By>>;
  where?: InputMaybe<Demand_Bool_Exp>;
};


export type Query_RootDemand_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Demand_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Attachments_Order_By>>;
  where?: InputMaybe<Demand_Attachments_Bool_Exp>;
};


export type Query_RootDemand_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Attachments_Order_By>>;
  where?: InputMaybe<Demand_Attachments_Bool_Exp>;
};


export type Query_RootDemand_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDemand_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDemand_EnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
};


export type Query_RootDemand_Enquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
};


export type Query_RootDemand_Enquiries_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDemand_Enquiries_Twilio_MessageArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Query_RootDemand_Enquiries_Twilio_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Query_RootDemand_Enquiries_Twilio_Message_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDemand_Enquiry_Status_LogArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
};


export type Query_RootDemand_Enquiry_Status_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
};


export type Query_RootDemand_Enquiry_Status_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDemand_ExpenseArgs = {
  distinct_on?: InputMaybe<Array<Demand_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Expense_Order_By>>;
  where?: InputMaybe<Demand_Expense_Bool_Exp>;
};


export type Query_RootDemand_Expense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Expense_Order_By>>;
  where?: InputMaybe<Demand_Expense_Bool_Exp>;
};


export type Query_RootDemand_Expense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDemand_Seller_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Demand_Seller_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Seller_Groups_Order_By>>;
  where?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
};


export type Query_RootDemand_Seller_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Seller_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Seller_Groups_Order_By>>;
  where?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
};


export type Query_RootDemand_Seller_Groups_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Query_RootDepartment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Query_RootDepartment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDepartment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Department_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Config_Order_By>>;
  where?: InputMaybe<Department_Config_Bool_Exp>;
};


export type Query_RootDepartment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Config_Order_By>>;
  where?: InputMaybe<Department_Config_Bool_Exp>;
};


export type Query_RootDepartment_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDepartment_Payment_DetailArgs = {
  distinct_on?: InputMaybe<Array<Department_Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Payment_Detail_Order_By>>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};


export type Query_RootDepartment_Payment_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Payment_Detail_Order_By>>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};


export type Query_RootDepartment_Payment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDepartment_SettlementsArgs = {
  distinct_on?: InputMaybe<Array<Department_Settlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Settlements_Order_By>>;
  where?: InputMaybe<Department_Settlements_Bool_Exp>;
};


export type Query_RootDepartment_Settlements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Settlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Settlements_Order_By>>;
  where?: InputMaybe<Department_Settlements_Bool_Exp>;
};


export type Query_RootDepartment_Settlements_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDepartment_User_AdvanceArgs = {
  distinct_on?: InputMaybe<Array<Department_User_Advance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_User_Advance_Order_By>>;
  where?: InputMaybe<Department_User_Advance_Bool_Exp>;
};


export type Query_RootDepartment_User_Advance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_User_Advance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_User_Advance_Order_By>>;
  where?: InputMaybe<Department_User_Advance_Bool_Exp>;
};


export type Query_RootDepartment_User_Advance_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDepartment_User_AdvancesArgs = {
  filters?: InputMaybe<DepartmentUserAdvanceFilterInput>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootDepot_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootDetection_Count_Summary_ChartArgs = {
  inputs?: InputMaybe<DetectionCountSummaryChartInput>;
};


export type Query_RootDetection_Count_Summary_GraphArgs = {
  inputs?: InputMaybe<DetectionCountSummaryGraphInput>;
};


export type Query_RootDeviceArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Query_RootDevice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Query_RootDevice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDistribution_Centre_By_UserArgs = {
  user_ref_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootDistribution_Centre_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootDjango_Celery_Results_TaskresultArgs = {
  distinct_on?: InputMaybe<Array<Django_Celery_Results_Taskresult_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Celery_Results_Taskresult_Order_By>>;
  where?: InputMaybe<Django_Celery_Results_Taskresult_Bool_Exp>;
};


export type Query_RootDjango_Celery_Results_Taskresult_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Celery_Results_Taskresult_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Celery_Results_Taskresult_Order_By>>;
  where?: InputMaybe<Django_Celery_Results_Taskresult_Bool_Exp>;
};


export type Query_RootDjango_Celery_Results_Taskresult_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDock_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Query_RootDocument_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Query_RootDocument_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_DataArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Query_RootDocument_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Query_RootDocument_Data_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_Entity_DataArgs = {
  document_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootDocument_Export_LogArgs = {
  distinct_on?: InputMaybe<Array<Document_Export_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Export_Log_Order_By>>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};


export type Query_RootDocument_Export_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Export_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Export_Log_Order_By>>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};


export type Query_RootDocument_Export_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDocument_KindArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Query_RootDocument_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Query_RootDocument_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_Kind_Data_FieldArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Query_RootDocument_Kind_Data_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Query_RootDocument_Kind_Data_Field_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_ReportArgs = {
  distinct_on?: InputMaybe<Array<Document_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Report_Order_By>>;
  where?: InputMaybe<Document_Report_Bool_Exp>;
};


export type Query_RootDocument_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Report_Order_By>>;
  where?: InputMaybe<Document_Report_Bool_Exp>;
};


export type Query_RootDocument_Report_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDocument_RevisionArgs = {
  distinct_on?: InputMaybe<Array<Document_Revision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Revision_Order_By>>;
  where?: InputMaybe<Document_Revision_Bool_Exp>;
};


export type Query_RootDocument_Revision_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Revision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Revision_Order_By>>;
  where?: InputMaybe<Document_Revision_Bool_Exp>;
};


export type Query_RootDocument_Revision_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootEagle_AddressArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Address_Order_By>>;
  where?: InputMaybe<Eagle_Address_Bool_Exp>;
};


export type Query_RootEagle_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Address_Order_By>>;
  where?: InputMaybe<Eagle_Address_Bool_Exp>;
};


export type Query_RootEagle_Address_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootEagle_MediaArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Media_Order_By>>;
  where?: InputMaybe<Eagle_Media_Bool_Exp>;
};


export type Query_RootEagle_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Media_Order_By>>;
  where?: InputMaybe<Eagle_Media_Bool_Exp>;
};


export type Query_RootEagle_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootEntity_StateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


export type Query_RootEntity_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


export type Query_RootEntity_State_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootEvaluation_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Criteria_Order_By>>;
  where?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
};


export type Query_RootEvaluation_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Criteria_Order_By>>;
  where?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
};


export type Query_RootEvaluation_Criteria_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootEvaluation_TagArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Tag_Order_By>>;
  where?: InputMaybe<Evaluation_Tag_Bool_Exp>;
};


export type Query_RootEvaluation_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Tag_Order_By>>;
  where?: InputMaybe<Evaluation_Tag_Bool_Exp>;
};


export type Query_RootEvaluation_Tag_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootExcluded_DepartmentsArgs = {
  codename_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootExpenseArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Query_RootExpense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Query_RootExpense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootExpense_Config_Template_DetailArgs = {
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  version: Scalars['ID'];
};


export type Query_RootExpense_Config_VersionsArgs = {
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
};


export type Query_RootExpense_ConfigsArgs = {
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  version?: InputMaybe<Scalars['ID']>;
};


export type Query_RootExpense_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Expense_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Parameter_Order_By>>;
  where?: InputMaybe<Expense_Parameter_Bool_Exp>;
};


export type Query_RootExpense_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootExpense_Timeline_DetailsArgs = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootExpense_Timeline_Details_V2Args = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootExternal_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<External_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Application_Order_By>>;
  where?: InputMaybe<External_Application_Bool_Exp>;
};


export type Query_RootExternal_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Application_Order_By>>;
  where?: InputMaybe<External_Application_Bool_Exp>;
};


export type Query_RootExternal_Application_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootExternal_EntityArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Order_By>>;
  where?: InputMaybe<External_Entity_Bool_Exp>;
};


export type Query_RootExternal_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Order_By>>;
  where?: InputMaybe<External_Entity_Bool_Exp>;
};


export type Query_RootExternal_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootExternal_Entity_GroupArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Group_Order_By>>;
  where?: InputMaybe<External_Entity_Group_Bool_Exp>;
};


export type Query_RootExternal_Entity_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Group_Order_By>>;
  where?: InputMaybe<External_Entity_Group_Bool_Exp>;
};


export type Query_RootExternal_Entity_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootExternal_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Query_RootExternal_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Query_RootExternal_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootExternal_Reference_IdArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  object_id?: InputMaybe<Scalars['Int']>;
  organisation_uid?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootFarmArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Query_RootFarm_Aggregate_DetailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_codenames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mutual_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootFarm_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFarm_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  farm_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootFarm_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Query_RootFarm_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Query_RootFarm_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFieldArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Query_RootField_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Query_RootField_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootField_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Query_RootField_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Query_RootField_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootField_Weather_LocationArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Query_RootField_Weather_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Query_RootField_Weather_Location_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFinal_AnalyticsArgs = {
  filters?: InputMaybe<AnalyticalQueryFilterInput>;
  from_date?: InputMaybe<Scalars['Date']>;
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootFinancial_SummaryArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  plot_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootFinancial_Summary_V2Args = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  plot_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootFinancial_Timeline_V2Args = {
  plot_crop_codename: Scalars['String'];
  transaction_type?: InputMaybe<Scalars['String']>;
};


export type Query_RootFinancial_YearArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Order_By>>;
  where?: InputMaybe<Financial_Year_Bool_Exp>;
};


export type Query_RootFinancial_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Order_By>>;
  where?: InputMaybe<Financial_Year_Bool_Exp>;
};


export type Query_RootFinancial_Year_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
};


export type Query_RootFinancial_Year_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
};


export type Query_RootFinancial_Year_Assessment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootFinancial_Year_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
};


export type Query_RootFinancial_Year_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
};


export type Query_RootFinancial_Year_Assessment_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootFinancial_Year_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootFinancial_Year_CwArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Cw_Bool_Exp>;
};


export type Query_RootFinancial_Year_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Cw_Bool_Exp>;
};


export type Query_RootFinancial_Year_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootGet_Advance_AmountArgs = {
  id?: InputMaybe<Scalars['ID']>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootGet_Buyer_PayableArgs = {
  id?: InputMaybe<Scalars['ID']>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootGet_RegionsArgs = {
  parent_region_codename?: InputMaybe<Scalars['String']>;
  region_type: Scalars['String'];
  search_string?: InputMaybe<Scalars['String']>;
};


export type Query_RootGet_Seller_PayableArgs = {
  id?: InputMaybe<Scalars['ID']>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootGradeArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Query_RootGrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Query_RootGrade_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootGrade_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


export type Query_RootGrade_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


export type Query_RootGrade_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootGrade_PriceArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Query_RootGrade_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Query_RootGrade_Price_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGuarantor_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_Agreement_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_Agreement_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_Agreement_Invoices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGuarantor_Agreement_Agreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_Agreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_Agreement_Plots_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGuarantor_Agreement_Area_Extension_DetailArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_Area_Extension_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};


export type Query_RootGuarantor_Agreement_Area_Extension_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGuarantor_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHarvest_ProjectionArgs = {
  company_id?: InputMaybe<Scalars['ID']>;
  department_id?: InputMaybe<Scalars['ID']>;
  harvest_date_from?: InputMaybe<Scalars['Date']>;
  harvest_date_to?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pruning_date_from?: InputMaybe<Scalars['Date']>;
  pruning_date_to?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
  season_name?: InputMaybe<Scalars['String']>;
  trade_year_id?: InputMaybe<Scalars['ID']>;
  variety_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  variety_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type Query_RootHas_Advance_Release_PendingArgs = {
  trade_id: Scalars['ID'];
};


export type Query_RootHas_Verification_Pending_AdvanceArgs = {
  trade_id: Scalars['ID'];
};


export type Query_RootIncome_Timeline_DetailsArgs = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootIncome_Timeline_Details_V2Args = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootInfestationArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Query_RootInfestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Query_RootInfestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInstrumentArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Order_By>>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};


export type Query_RootInstrument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Order_By>>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};


export type Query_RootInstrument_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootInstrument_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Departments_Order_By>>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};


export type Query_RootInstrument_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Departments_Order_By>>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};


export type Query_RootInstrument_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootInstrument_KindArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Kind_Order_By>>;
  where?: InputMaybe<Instrument_Kind_Bool_Exp>;
};


export type Query_RootInstrument_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Kind_Order_By>>;
  where?: InputMaybe<Instrument_Kind_Bool_Exp>;
};


export type Query_RootInstrument_Kind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_Buyer_BifurcationArgs = {
  invoice_id: Scalars['Int'];
};


export type Query_RootInvoice_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootInvoice_SummaryArgs = {
  invoice_id: Scalars['ID'];
};


export type Query_RootInvoice_Summary_By_UserArgs = {
  credit_wallet_only?: InputMaybe<Scalars['Boolean']>;
  from_date?: InputMaybe<Scalars['Date']>;
  placed_by?: InputMaybe<Scalars['ID']>;
  till_date?: InputMaybe<Scalars['Date']>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootInward_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootIssuance_NoteArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


export type Query_RootIssuance_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


export type Query_RootIssuance_Note_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Attachments_Order_By>>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};


export type Query_RootIssuance_Note_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Attachments_Order_By>>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};


export type Query_RootIssuance_Note_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootIssuance_Note_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootIssuance_Note_Item_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Item_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Item_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
};


export type Query_RootIssuance_Note_Item_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Item_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Item_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
};


export type Query_RootIssuance_Note_Item_Taxes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootIssuance_Note_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
};


export type Query_RootIssuance_Note_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
};


export type Query_RootIssuance_Note_Taxes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootKite_Entities_AttributeArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  attribute_key?: InputMaybe<Scalars['String']>;
  organisation_uid?: InputMaybe<Scalars['String']>;
  reference_ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootKite_Entity_AttributeArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  attribute_key?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootKite_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Kite_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Notification_Order_By>>;
  where?: InputMaybe<Kite_Notification_Bool_Exp>;
};


export type Query_RootKite_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kite_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Notification_Order_By>>;
  where?: InputMaybe<Kite_Notification_Bool_Exp>;
};


export type Query_RootKite_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootKite_Quality_StageArgs = {
  distinct_on?: InputMaybe<Array<Kite_Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Quality_Stage_Order_By>>;
  where?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
};


export type Query_RootKite_Quality_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kite_Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Quality_Stage_Order_By>>;
  where?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
};


export type Query_RootKite_Quality_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLaboratoryArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootLaboratory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Query_RootLaboratory_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootLaboratory_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Organisations_Order_By>>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};


export type Query_RootLaboratory_Organisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Organisations_Order_By>>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};


export type Query_RootLaboratory_Organisations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootLegal_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Agreement_Order_By>>;
  where?: InputMaybe<Legal_Agreement_Bool_Exp>;
};


export type Query_RootLegal_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Agreement_Order_By>>;
  where?: InputMaybe<Legal_Agreement_Bool_Exp>;
};


export type Query_RootLegal_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLocation_By_PincodeArgs = {
  pincode?: InputMaybe<Scalars['String']>;
};


export type Query_RootMarketArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Query_RootMarket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Query_RootMarket_Allowed_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


export type Query_RootMarket_Allowed_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


export type Query_RootMarket_Allowed_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootMarket_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootMatch_Profiles_By_Cust_IdArgs = {
  cust_id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootMe_GlobalArgs = {
  reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Query_RootMedia_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMetabase_UrlArgs = {
  filter?: InputMaybe<MetabaseUrlInput>;
};


export type Query_RootMilestoneArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Query_RootMilestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Query_RootMilestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMilestones_For_PlotcropArgs = {
  crop_year?: InputMaybe<Scalars['String']>;
  plot_crop_codename: Scalars['String'];
};


export type Query_RootMix_AnalyticsArgs = {
  filters?: InputMaybe<AnalyticalQueryFilterInput>;
  from_date?: InputMaybe<Scalars['Date']>;
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootMutual_GroupArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootMutual_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootMutual_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootMutual_Group_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Query_RootMutual_Group_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Query_RootMutual_Group_Membership_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Query_RootMutual_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Query_RootMutual_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_RoleArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Query_RootMutual_Group_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Query_RootMutual_Group_Role_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMutual_Group_Weather_StationArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Query_RootMutual_Group_Weather_Station_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Query_RootMutual_Group_Weather_Station_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMy_AssetsArgs = {
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootMy_FieldsArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  is_empty?: InputMaybe<Scalars['Boolean']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootMy_Network_DocumentsArgs = {
  entity_type: Scalars['String'];
};


export type Query_RootMy_Network_UsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootMy_Network_Users_With_TotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_codenames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mutual_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mutual_group_kinds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  user_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootMy_Order_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootMy_Plot_CropsArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  plot_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootMy_Plot_Crops_With_TotalArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  plot_codename?: InputMaybe<Scalars['String']>;
  plot_crop_codename?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootMy_Plot_Summary_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootNationalityArgs = {
  distinct_on?: InputMaybe<Array<Nationality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nationality_Order_By>>;
  where?: InputMaybe<Nationality_Bool_Exp>;
};


export type Query_RootNationality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nationality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nationality_Order_By>>;
  where?: InputMaybe<Nationality_Bool_Exp>;
};


export type Query_RootNationality_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootNetworkArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Query_RootNetwork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Query_RootNetwork_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNetwork_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootNomineesArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Order_By>>;
  where?: InputMaybe<Nominees_Bool_Exp>;
};


export type Query_RootNominees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Order_By>>;
  where?: InputMaybe<Nominees_Bool_Exp>;
};


export type Query_RootNominees_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNominees_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Documents_Order_By>>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};


export type Query_RootNominees_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Documents_Order_By>>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};


export type Query_RootNominees_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNotification_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Notification_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Provider_Order_By>>;
  where?: InputMaybe<Notification_Provider_Bool_Exp>;
};


export type Query_RootNotification_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Provider_Order_By>>;
  where?: InputMaybe<Notification_Provider_Bool_Exp>;
};


export type Query_RootNotification_Provider_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNotification_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Notification_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Trigger_Order_By>>;
  where?: InputMaybe<Notification_Trigger_Bool_Exp>;
};


export type Query_RootNotification_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Trigger_Order_By>>;
  where?: InputMaybe<Notification_Trigger_Bool_Exp>;
};


export type Query_RootNotification_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOffer_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Offer_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Attachments_Order_By>>;
  where?: InputMaybe<Offer_Attachments_Bool_Exp>;
};


export type Query_RootOffer_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Attachments_Order_By>>;
  where?: InputMaybe<Offer_Attachments_Bool_Exp>;
};


export type Query_RootOffer_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffer_EnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
};


export type Query_RootOffer_Enquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
};


export type Query_RootOffer_Enquiries_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffer_Enquiries_Twilio_MessageArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Query_RootOffer_Enquiries_Twilio_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Query_RootOffer_Enquiries_Twilio_Message_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffer_Enquiry_Status_LogArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
};


export type Query_RootOffer_Enquiry_Status_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
};


export type Query_RootOffer_Enquiry_Status_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffer_ExpenseArgs = {
  distinct_on?: InputMaybe<Array<Offer_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Expense_Order_By>>;
  where?: InputMaybe<Offer_Expense_Bool_Exp>;
};


export type Query_RootOffer_Expense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Expense_Order_By>>;
  where?: InputMaybe<Offer_Expense_Bool_Exp>;
};


export type Query_RootOffer_Expense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffer_Order_PickedArgs = {
  distinct_on?: InputMaybe<Array<Offer_Order_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Order_Picked_Order_By>>;
  where?: InputMaybe<Offer_Order_Picked_Bool_Exp>;
};


export type Query_RootOffer_Order_Picked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Order_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Order_Picked_Order_By>>;
  where?: InputMaybe<Offer_Order_Picked_Bool_Exp>;
};


export type Query_RootOffer_Order_Picked_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffer_Storage_PickedArgs = {
  distinct_on?: InputMaybe<Array<Offer_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Storage_Picked_Order_By>>;
  where?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
};


export type Query_RootOffer_Storage_Picked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Storage_Picked_Order_By>>;
  where?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
};


export type Query_RootOffer_Storage_Picked_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_Buyer_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Offers_Buyer_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Buyer_Groups_Order_By>>;
  where?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
};


export type Query_RootOffers_Buyer_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Buyer_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Buyer_Groups_Order_By>>;
  where?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
};


export type Query_RootOffers_Buyer_Groups_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOffers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOrg_Dashboard_StatsArgs = {
  distinct_on?: InputMaybe<Array<Org_Dashboard_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dashboard_Stats_Order_By>>;
  where?: InputMaybe<Org_Dashboard_Stats_Bool_Exp>;
};


export type Query_RootOrg_Dashboard_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Dashboard_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dashboard_Stats_Order_By>>;
  where?: InputMaybe<Org_Dashboard_Stats_Bool_Exp>;
};


export type Query_RootOrg_Dashboard_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrg_Team_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Association_Order_By>>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};


export type Query_RootOrg_Team_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Association_Order_By>>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};


export type Query_RootOrg_Team_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_Team_Primary_CropArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};


export type Query_RootOrg_Team_Primary_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};


export type Query_RootOrg_Team_Primary_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrg_Team_User_Bank_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


export type Query_RootOrg_Team_User_Bank_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


export type Query_RootOrg_Team_User_Bank_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_Team_User_CropArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_User_Crop_Bool_Exp>;
};


export type Query_RootOrg_Team_User_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_User_Crop_Bool_Exp>;
};


export type Query_RootOrg_Team_User_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrg_Team_User_Document_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


export type Query_RootOrg_Team_User_Document_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


export type Query_RootOrg_Team_User_Document_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_User_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Association_Order_By>>;
  where?: InputMaybe<Org_User_Association_Bool_Exp>;
};


export type Query_RootOrg_User_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Association_Order_By>>;
  where?: InputMaybe<Org_User_Association_Bool_Exp>;
};


export type Query_RootOrg_User_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_User_Group_Mandatory_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


export type Query_RootOrg_User_Group_Mandatory_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


export type Query_RootOrg_User_Group_Mandatory_Document_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrg_User_Group_Status_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Order_By>>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};


export type Query_RootOrg_User_Group_Status_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Order_By>>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};


export type Query_RootOrg_User_Group_Status_Snapshot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrg_User_Primary_CropArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};


export type Query_RootOrg_User_Primary_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};


export type Query_RootOrg_User_Primary_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisationArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Query_RootOrganisation_App_ConfigurationArgs = {
  bundle_id: Scalars['String'];
  codename?: InputMaybe<Scalars['String']>;
  device_id?: InputMaybe<Scalars['String']>;
  firebase_token?: InputMaybe<Scalars['String']>;
  install_version: Scalars['String'];
  platform: Scalars['String'];
};


export type Query_RootOrganisation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_CommodityArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootOrganisation_Commodity_VarietyArgs = {
  commodity_codename?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootOrganisation_Commodity_Variety_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};


export type Query_RootOrganisation_Commodity_Variety_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};


export type Query_RootOrganisation_Commodity_Variety_Config_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_Commodity_Variety_Config_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};


export type Query_RootOrganisation_Commodity_Variety_Config_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};


export type Query_RootOrganisation_Commodity_Variety_Config_Taxes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_CropArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Crop_Order_By>>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};


export type Query_RootOrganisation_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Crop_Order_By>>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};


export type Query_RootOrganisation_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_Document_KindArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Query_RootOrganisation_Document_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Query_RootOrganisation_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Query_RootOrganisation_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Query_RootOrganisation_Preferences_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_PricingArgs = {
  schema_name?: InputMaybe<Scalars['String']>;
};


export type Query_RootOrganisation_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Query_RootOrganisation_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Query_RootOrganisation_Season_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrganisation_Si_UnitsArgs = {
  unit_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Query_RootOrganisation_Variety_GradeArgs = {
  commodity_variety_codename?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootOver_DraftArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Order_By>>;
  where?: InputMaybe<Over_Draft_Bool_Exp>;
};


export type Query_RootOver_Draft_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Order_By>>;
  where?: InputMaybe<Over_Draft_Bool_Exp>;
};


export type Query_RootOver_Draft_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOver_Draft_CwArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
};


export type Query_RootOver_Draft_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
};


export type Query_RootOver_Draft_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOver_Draft_LogArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Bool_Exp>;
};


export type Query_RootOver_Draft_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Bool_Exp>;
};


export type Query_RootOver_Draft_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOver_Draft_Log_CwArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
};


export type Query_RootOver_Draft_Log_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
};


export type Query_RootOver_Draft_Log_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOver_Due_ApprovalArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Bool_Exp>;
};


export type Query_RootOver_Due_Approval_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Bool_Exp>;
};


export type Query_RootOver_Due_Approval_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOver_Due_Approval_CwArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Cw_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
};


export type Query_RootOver_Due_Approval_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Cw_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
};


export type Query_RootOver_Due_Approval_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOver_Due_Approval_LogArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Log_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
};


export type Query_RootOver_Due_Approval_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Log_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
};


export type Query_RootOver_Due_Approval_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPackagingArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_By>>;
  where?: InputMaybe<Packaging_Bool_Exp>;
};


export type Query_RootPackaging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_By>>;
  where?: InputMaybe<Packaging_Bool_Exp>;
};


export type Query_RootPackaging_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPackaging_OrderArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Order_By>>;
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
};


export type Query_RootPackaging_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Order_By>>;
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
};


export type Query_RootPackaging_Order_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPackaging_Order_ItemArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Item_Order_By>>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};


export type Query_RootPackaging_Order_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Item_Order_By>>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};


export type Query_RootPackaging_Order_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Category_Order_By>>;
  where?: InputMaybe<Pallet_Category_Bool_Exp>;
};


export type Query_RootPallet_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Category_Order_By>>;
  where?: InputMaybe<Pallet_Category_Bool_Exp>;
};


export type Query_RootPallet_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_CustomerArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Customer_Order_By>>;
  where?: InputMaybe<Pallet_Customer_Bool_Exp>;
};


export type Query_RootPallet_Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Customer_Order_By>>;
  where?: InputMaybe<Pallet_Customer_Bool_Exp>;
};


export type Query_RootPallet_Customer_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_InspectionArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


export type Query_RootPallet_Inspection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


export type Query_RootPallet_Inspection_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Inspection_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Inspection_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_Inspection_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_Inspection_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


export type Query_RootPallet_Inspection_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


export type Query_RootPallet_Inspection_Reports_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_InspectionkindArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionkind_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
};


export type Query_RootPallet_Inspectionkind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionkind_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
};


export type Query_RootPallet_Inspectionkind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_InspectionobservationArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};


export type Query_RootPallet_Inspectionobservation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};


export type Query_RootPallet_Inspectionobservation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Inspectionobservation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Inspectionobservation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_Inspectionobservation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_LineArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Line_Order_By>>;
  where?: InputMaybe<Pallet_Line_Bool_Exp>;
};


export type Query_RootPallet_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Line_Order_By>>;
  where?: InputMaybe<Pallet_Line_Bool_Exp>;
};


export type Query_RootPallet_Line_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_LocationArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Location_Order_By>>;
  where?: InputMaybe<Pallet_Location_Bool_Exp>;
};


export type Query_RootPallet_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Location_Order_By>>;
  where?: InputMaybe<Pallet_Location_Bool_Exp>;
};


export type Query_RootPallet_Location_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_PackagingArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packaging_Order_By>>;
  where?: InputMaybe<Pallet_Packaging_Bool_Exp>;
};


export type Query_RootPallet_Packaging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packaging_Order_By>>;
  where?: InputMaybe<Pallet_Packaging_Bool_Exp>;
};


export type Query_RootPallet_Packaging_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_PackagingkindArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packagingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packagingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
};


export type Query_RootPallet_Packagingkind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packagingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packagingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
};


export type Query_RootPallet_Packagingkind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_PackingArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Bool_Exp>;
};


export type Query_RootPallet_Packing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Bool_Exp>;
};


export type Query_RootPallet_Packing_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Packing_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Packing_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_Packing_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_Packing_WeightsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};


export type Query_RootPallet_Packing_Weights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};


export type Query_RootPallet_Packing_Weights_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_PackingkindArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
};


export type Query_RootPallet_Packingkind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
};


export type Query_RootPallet_Packingkind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_PackingweightArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
};


export type Query_RootPallet_Packingweight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
};


export type Query_RootPallet_Packingweight_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Packingweight_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};


export type Query_RootPallet_Packingweight_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_Packingweight_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_PrintingmatterArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Printingmatter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Printingmatter_Order_By>>;
  where?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
};


export type Query_RootPallet_Printingmatter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Printingmatter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Printingmatter_Order_By>>;
  where?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
};


export type Query_RootPallet_Printingmatter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_PunnetconditionArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Punnetcondition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Punnetcondition_Order_By>>;
  where?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
};


export type Query_RootPallet_Punnetcondition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Punnetcondition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Punnetcondition_Order_By>>;
  where?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
};


export type Query_RootPallet_Punnetcondition_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_SamplinglocationArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Samplinglocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Samplinglocation_Order_By>>;
  where?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
};


export type Query_RootPallet_Samplinglocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Samplinglocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Samplinglocation_Order_By>>;
  where?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
};


export type Query_RootPallet_Samplinglocation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_SkuArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Sku_Order_By>>;
  where?: InputMaybe<Pallet_Sku_Bool_Exp>;
};


export type Query_RootPallet_Sku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Sku_Order_By>>;
  where?: InputMaybe<Pallet_Sku_Bool_Exp>;
};


export type Query_RootPallet_Sku_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPallet_SkutypeArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Skutype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Skutype_Order_By>>;
  where?: InputMaybe<Pallet_Skutype_Bool_Exp>;
};


export type Query_RootPallet_Skutype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Skutype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Skutype_Order_By>>;
  where?: InputMaybe<Pallet_Skutype_Bool_Exp>;
};


export type Query_RootPallet_Skutype_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootPallet_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Variety_Order_By>>;
  where?: InputMaybe<Pallet_Variety_Bool_Exp>;
};


export type Query_RootPallet_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Variety_Order_By>>;
  where?: InputMaybe<Pallet_Variety_Bool_Exp>;
};


export type Query_RootPallet_Variety_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPartner_DetailArgs = {
  partner_codename: Scalars['String'];
};


export type Query_RootPartner_ListArgs = {
  business_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootPayment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootPayment_DetailArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Query_RootPayment_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Query_RootPayment_Detail_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Query_RootPayment_Detail_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Query_RootPayment_Detail_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Query_RootPayment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Query_RootPayment_Method_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayu_HashArgs = {
  key?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootPayu_Transaction_HashArgs = {
  amount_for_payment: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  reference_id: Scalars['ID'];
  tracking_code: Scalars['ID'];
};


export type Query_RootPlotArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Query_RootPlot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Query_RootPlot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootPlot_Crop_AgentArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Query_RootPlot_Crop_Agent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Query_RootPlot_Crop_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootPlot_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_Cultivation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Order_By>>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};


export type Query_RootPlot_Crop_Cultivation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Order_By>>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};


export type Query_RootPlot_Crop_Cultivation_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_DetailArgs = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootPlot_Crop_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  plot_crop_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootPlot_Crop_Growth_Stages_By_Plot_Crop_CodenameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  plot_crop_codename: Scalars['String'];
};


export type Query_RootPlot_Crop_Historic_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Historic_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Historic_Season_Order_By>>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};


export type Query_RootPlot_Crop_Historic_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Historic_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Historic_Season_Order_By>>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};


export type Query_RootPlot_Crop_Historic_Season_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_List_With_BudgetArgs = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootPlot_Crop_List_With_Budget_V2Args = {
  farm_codename?: InputMaybe<Scalars['String']>;
  field_codename?: InputMaybe<Scalars['String']>;
  mutual_group_codename?: InputMaybe<Scalars['String']>;
};


export type Query_RootPlot_Crop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Query_RootPlot_Crop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Query_RootPlot_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Query_RootPlot_Crop_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Query_RootPlot_Crop_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_Reference_By_CodenameArgs = {
  app_name?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  organisation_uid?: InputMaybe<Scalars['String']>;
};


export type Query_RootPlot_Crop_RootstockArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};


export type Query_RootPlot_Crop_Rootstock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};


export type Query_RootPlot_Crop_Rootstock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Crop_SearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PlotCropSearchInput>;
};


export type Query_RootPlot_Crop_Sowing_MaterialArgs = {
  plot_crop_codename: Scalars['String'];
};


export type Query_RootPlot_Crop_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Status_History_Order_By>>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};


export type Query_RootPlot_Crop_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Status_History_Order_By>>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};


export type Query_RootPlot_Crop_Status_History_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_DocumentsArgs = {
  document_kind__codename?: InputMaybe<Scalars['String']>;
  plot_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootPlot_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Query_RootPlot_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Query_RootPlot_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_StatusArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Query_RootPlot_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Query_RootPlot_Status_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Status_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};


export type Query_RootPlot_Status_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};


export type Query_RootPlot_Status_Config_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlot_Status_Config_Required_Qc_StagesArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};


export type Query_RootPlot_Status_Config_Required_Qc_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};


export type Query_RootPlot_Status_Config_Required_Qc_Stages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPrimary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Query_RootPrimary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Query_RootPrimary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProduction_Batch_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootProduction_TradeArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_By>>;
  where?: InputMaybe<Production_Trade_Bool_Exp>;
};


export type Query_RootProduction_Trade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_By>>;
  where?: InputMaybe<Production_Trade_Bool_Exp>;
};


export type Query_RootProduction_Trade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProduction_Trade_ItemArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Bool_Exp>;
};


export type Query_RootProduction_Trade_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Bool_Exp>;
};


export type Query_RootProduction_Trade_Item_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
};


export type Query_RootProduction_Trade_Item_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
};


export type Query_RootProduction_Trade_Item_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootProduction_Trade_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootProduction_Trade_Item_Storage_PickedArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


export type Query_RootProduction_Trade_Item_Storage_Picked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


export type Query_RootProduction_Trade_Item_Storage_Picked_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProduction_Trade_Order_Trade_RefsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Order_By>>;
  where?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
};


export type Query_RootProduction_Trade_Order_Trade_Refs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Order_By>>;
  where?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
};


export type Query_RootProduction_Trade_Order_Trade_Refs_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootProjection_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Bool_Exp>;
};


export type Query_RootProjection_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Bool_Exp>;
};


export type Query_RootProjection_Assessment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootProjection_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
};


export type Query_RootProjection_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
};


export type Query_RootProjection_Assessment_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootQuality_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};


export type Query_RootQuality_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};


export type Query_RootQuality_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootQuality_Parameter_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Category_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
};


export type Query_RootQuality_Parameter_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Category_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
};


export type Query_RootQuality_Parameter_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootQuality_StageArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Order_By>>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};


export type Query_RootQuality_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Order_By>>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};


export type Query_RootQuality_Stage_Allowed_Template_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


export type Query_RootQuality_Stage_Allowed_Template_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


export type Query_RootQuality_Stage_Allowed_Template_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootQuality_Stage_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootReceiptArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Query_RootReceipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Query_RootReceipt_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootReceipt_Seller_BifurcationArgs = {
  receipt_id: Scalars['Int'];
};


export type Query_RootReceipt_Seller_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
};


export type Query_RootReceipt_Seller_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
};


export type Query_RootReceipt_Seller_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootReceipt_SummaryArgs = {
  receipt_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Query_RootRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Query_RootRegion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRegion_GroupArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Query_RootRegion_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Query_RootRegion_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRegistration_Mutual_Group_ListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_id?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verification_status?: InputMaybe<Scalars['String']>;
};


export type Query_RootRegistration_Mutual_Group_List_With_TotalArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mutual_group_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  network_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  search_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  verification_status?: InputMaybe<Scalars['String']>;
};


export type Query_RootRequestArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


export type Query_RootRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


export type Query_RootRequest_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootRequest_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Request_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Category_Order_By>>;
  where?: InputMaybe<Request_Category_Bool_Exp>;
};


export type Query_RootRequest_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Category_Order_By>>;
  where?: InputMaybe<Request_Category_Bool_Exp>;
};


export type Query_RootRequest_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootRequest_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


export type Query_RootRequest_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


export type Query_RootRequest_Parameters_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootRequest_Secondary_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Request_Secondary_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Secondary_Locations_Order_By>>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};


export type Query_RootRequest_Secondary_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Secondary_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Secondary_Locations_Order_By>>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};


export type Query_RootRequest_Secondary_Locations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootRequest_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


export type Query_RootRequest_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


export type Query_RootRequest_Templates_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootRequests_By_Primary_LocationArgs = {
  filter?: InputMaybe<RequestFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  primary_location_entity_type?: InputMaybe<Scalars['String']>;
  primary_location_reference_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootRequests_Summary_By_Primary_LocationArgs = {
  filter?: InputMaybe<RequestFilterInput>;
  primary_location_entity_type?: InputMaybe<Scalars['String']>;
  primary_location_reference_id: Scalars['String'];
};


export type Query_RootResultArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


export type Query_RootResult_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


export type Query_RootResult_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootResult_CommentArgs = {
  distinct_on?: InputMaybe<Array<Result_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Comment_Order_By>>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};


export type Query_RootResult_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Comment_Order_By>>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};


export type Query_RootResult_Comment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootResult_EvaluationArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


export type Query_RootResult_Evaluation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


export type Query_RootResult_Evaluation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootResult_Evaluation_Evaluated_TagsArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};


export type Query_RootResult_Evaluation_Evaluated_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};


export type Query_RootResult_Evaluation_Evaluated_Tags_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootResult_MediaArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


export type Query_RootResult_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


export type Query_RootResult_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootResult_ObservationArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


export type Query_RootResult_Observation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


export type Query_RootResult_Observation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


export type Query_RootResult_Observation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


export type Query_RootResult_Observation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootResult_Observation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootResult_Observation_Evaluated_TagsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};


export type Query_RootResult_Observation_Evaluated_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};


export type Query_RootResult_Observation_Evaluated_Tags_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootResult_ObservationsArgs = {
  filter?: InputMaybe<ResultObservationsFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type Query_RootResult_SummaryArgs = {
  inputs?: InputMaybe<ResultSummaryInput>;
};


export type Query_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRootstockArgs = {
  distinct_on?: InputMaybe<Array<Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rootstock_Order_By>>;
  where?: InputMaybe<Rootstock_Bool_Exp>;
};


export type Query_RootRootstock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rootstock_Order_By>>;
  where?: InputMaybe<Rootstock_Bool_Exp>;
};


export type Query_RootRootstock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSampleArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Query_RootSample_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Query_RootSample_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSample_MediaArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


export type Query_RootSample_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


export type Query_RootSample_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSample_ObservationArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


export type Query_RootSample_Observation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


export type Query_RootSample_Observation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


export type Query_RootSample_Observation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


export type Query_RootSample_Observation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSample_Observation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSample_Summary_ChartArgs = {
  inputs?: InputMaybe<SampleSummaryChartInput>;
};


export type Query_RootSearch_Base_UsersArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootSearch_Base_Users_AggregateArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Query_RootSearch_BusinessesArgs = {
  args: Search_Businesses_Args;
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Query_RootSearch_Businesses_AggregateArgs = {
  args: Search_Businesses_Args;
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Query_RootSearch_Businesses_GroupsArgs = {
  args: Search_Businesses_Groups_Args;
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Query_RootSearch_Businesses_Groups_AggregateArgs = {
  args: Search_Businesses_Groups_Args;
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Query_RootSearch_Mutual_GroupsArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootSearch_Mutual_Groups_AggregateArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Query_RootSearch_Plot_CropsArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootSearch_Plot_Crops_AggregateArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Query_RootSecondary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Query_RootSecondary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Query_RootSecondary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSellable_Item_Stock_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootSeller_HashArgs = {
  trade_id: Scalars['ID'];
};


export type Query_RootSeller_Receivable_Amount_Current_YearArgs = {
  seller_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootSetu_Trade_AddressArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Address_Order_By>>;
  where?: InputMaybe<Setu_Trade_Address_Bool_Exp>;
};


export type Query_RootSetu_Trade_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Address_Order_By>>;
  where?: InputMaybe<Setu_Trade_Address_Bool_Exp>;
};


export type Query_RootSetu_Trade_Address_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSetu_Trade_Shared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Shared_Entity_Order_By>>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};


export type Query_RootSetu_Trade_Shared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSetutrade_MediaArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Media_Order_By>>;
  where?: InputMaybe<Setutrade_Media_Bool_Exp>;
};


export type Query_RootSetutrade_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Media_Order_By>>;
  where?: InputMaybe<Setutrade_Media_Bool_Exp>;
};


export type Query_RootSetutrade_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSetutrade_TripArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Trip_Order_By>>;
  where?: InputMaybe<Setutrade_Trip_Bool_Exp>;
};


export type Query_RootSetutrade_Trip_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Trip_Order_By>>;
  where?: InputMaybe<Setutrade_Trip_Bool_Exp>;
};


export type Query_RootSetutrade_Trip_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShareholder_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


export type Query_RootShareholder_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


export type Query_RootShareholder_Applications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShareholdersArgs = {
  distinct_on?: InputMaybe<Array<Shareholders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholders_Order_By>>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};


export type Query_RootShareholders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholders_Order_By>>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};


export type Query_RootShareholders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSi_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Query_RootSi_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Query_RootSi_Unit_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSi_Unit_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Query_RootSi_Unit_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Query_RootSi_Unit_Measure_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSigned_UrlArgs = {
  url?: InputMaybe<Scalars['String']>;
};


export type Query_RootSkuArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Query_RootSku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Query_RootSku_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSku_KindArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Query_RootSku_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Query_RootSku_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSoilArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Query_RootSoil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Query_RootSoil_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSoil_TypesArgs = {
  search_string?: InputMaybe<Scalars['String']>;
};


export type Query_RootStage_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Actions_Order_By>>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};


export type Query_RootStage_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Actions_Order_By>>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};


export type Query_RootStage_Actions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStage_LogsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


export type Query_RootStage_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


export type Query_RootStage_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStagesArgs = {
  distinct_on?: InputMaybe<Array<Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Order_By>>;
  where?: InputMaybe<Stages_Bool_Exp>;
};


export type Query_RootStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Order_By>>;
  where?: InputMaybe<Stages_Bool_Exp>;
};


export type Query_RootStages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStages_SubscribersArgs = {
  distinct_on?: InputMaybe<Array<Stages_Subscribers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Subscribers_Order_By>>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};


export type Query_RootStages_Subscribers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stages_Subscribers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Subscribers_Order_By>>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};


export type Query_RootStages_Subscribers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Query_RootState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Query_RootState_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootStorage_DashboardArgs = {
  filters?: InputMaybe<StorageQueryFilterInput>;
  from_date?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootStorage_LocationArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Order_By>>;
  where?: InputMaybe<Storage_Location_Bool_Exp>;
};


export type Query_RootStorage_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Order_By>>;
  where?: InputMaybe<Storage_Location_Bool_Exp>;
};


export type Query_RootStorage_Location_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
};


export type Query_RootStorage_Location_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
};


export type Query_RootStorage_Location_Agreement_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
};


export type Query_RootStorage_Location_Agreement_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
};


export type Query_RootStorage_Location_Agreement_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootStorage_Location_Agreement_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootStorage_Location_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootStorage_Location_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootStorage_Location_KindArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Kind_Order_By>>;
  where?: InputMaybe<Storage_Location_Kind_Bool_Exp>;
};


export type Query_RootStorage_Location_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Kind_Order_By>>;
  where?: InputMaybe<Storage_Location_Kind_Bool_Exp>;
};


export type Query_RootStorage_Location_Kind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootStorage_Location_PocsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Pocs_Order_By>>;
  where?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
};


export type Query_RootStorage_Location_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Pocs_Order_By>>;
  where?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
};


export type Query_RootStorage_Location_Pocs_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootStorage_Location_SummaryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootStorage_Sub_LocationArgs = {
  distinct_on?: InputMaybe<Array<Storage_Sub_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Sub_Location_Order_By>>;
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
};


export type Query_RootStorage_Sub_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Sub_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Sub_Location_Order_By>>;
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
};


export type Query_RootStorage_Sub_Location_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootStorage_SummaryArgs = {
  filters?: InputMaybe<StorageQueryFilterInput>;
  from_date?: InputMaybe<Scalars['Date']>;
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootSupplier_Groups_Plot_AggreagteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type Query_RootSupplier_Plot_AggreagteArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<SupplierPlotAggregateInput>;
};


export type Query_RootSurvey_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Survey_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Parameters_Order_By>>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};


export type Query_RootSurvey_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Parameters_Order_By>>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};


export type Query_RootSurvey_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSurvey_Response_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


export type Query_RootSurvey_Response_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


export type Query_RootSurvey_Response_Items_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSurvey_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


export type Query_RootSurvey_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


export type Query_RootSurvey_Responses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSurvey_UsersArgs = {
  distinct_on?: InputMaybe<Array<Survey_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Users_Order_By>>;
  where?: InputMaybe<Survey_Users_Bool_Exp>;
};


export type Query_RootSurvey_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Users_Order_By>>;
  where?: InputMaybe<Survey_Users_Bool_Exp>;
};


export type Query_RootSurvey_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSurvey_YearArgs = {
  distinct_on?: InputMaybe<Array<Survey_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Year_Order_By>>;
  where?: InputMaybe<Survey_Year_Bool_Exp>;
};


export type Query_RootSurvey_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Year_Order_By>>;
  where?: InputMaybe<Survey_Year_Bool_Exp>;
};


export type Query_RootSurvey_Year_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSurveysArgs = {
  distinct_on?: InputMaybe<Array<Surveys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Surveys_Order_By>>;
  where?: InputMaybe<Surveys_Bool_Exp>;
};


export type Query_RootSurveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Surveys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Surveys_Order_By>>;
  where?: InputMaybe<Surveys_Bool_Exp>;
};


export type Query_RootSurveys_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTeam_Document_CountArgs = {
  mutual_group_id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootTemplateArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


export type Query_RootTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


export type Query_RootTemplate_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Order_By>>;
  where?: InputMaybe<Template_Category_Bool_Exp>;
};


export type Query_RootTemplate_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Order_By>>;
  where?: InputMaybe<Template_Category_Bool_Exp>;
};


export type Query_RootTemplate_Category_Allowed_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Groups_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Groups_Bool_Exp>;
};


export type Query_RootTemplate_Category_Allowed_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Groups_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Groups_Bool_Exp>;
};


export type Query_RootTemplate_Category_Allowed_Groups_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Category_Allowed_Parameter_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};


export type Query_RootTemplate_Category_Allowed_Parameter_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};


export type Query_RootTemplate_Category_Allowed_Parameter_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


export type Query_RootTemplate_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


export type Query_RootTemplate_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Template_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Departments_Order_By>>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};


export type Query_RootTemplate_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Departments_Order_By>>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};


export type Query_RootTemplate_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_EvaluationArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Bool_Exp>;
};


export type Query_RootTemplate_Evaluation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Bool_Exp>;
};


export type Query_RootTemplate_Evaluation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Evaluation_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Config_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Config_Bool_Exp>;
};


export type Query_RootTemplate_Evaluation_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Config_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Config_Bool_Exp>;
};


export type Query_RootTemplate_Evaluation_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Evaluation_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Templates_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Templates_Bool_Exp>;
};


export type Query_RootTemplate_Evaluation_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Templates_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Templates_Bool_Exp>;
};


export type Query_RootTemplate_Evaluation_Templates_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Parameter_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Parameter_StandardArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Standard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Standard_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Standard_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Standard_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Parameter_Standard_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Parameter_Standard_GroupArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Group_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Standard_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Group_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
};


export type Query_RootTemplate_Parameter_Standard_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTemplate_Quality_StagesArgs = {
  distinct_on?: InputMaybe<Array<Template_Quality_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Quality_Stages_Order_By>>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};


export type Query_RootTemplate_Quality_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Quality_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Quality_Stages_Order_By>>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};


export type Query_RootTemplate_Quality_Stages_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTradeArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Query_RootTrade_Action_LogArgs = {
  distinct_on?: InputMaybe<Array<Trade_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Action_Log_Order_By>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


export type Query_RootTrade_Action_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Query_RootTrade_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Bool_Exp>;
};


export type Query_RootTrade_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Bool_Exp>;
};


export type Query_RootTrade_Assessment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
};


export type Query_RootTrade_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
};


export type Query_RootTrade_Assessment_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Assessment_DynamicArgs = {
  input?: InputMaybe<TradeAssessmentDynamicInput>;
};


export type Query_RootTrade_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Buyer_BifurcationArgs = {
  trade_id: Scalars['Int'];
};


export type Query_RootTrade_Buyer_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Buyer_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Buyer_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Expense_TaxArgs = {
  distinct_on?: InputMaybe<Array<Trade_Expense_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Expense_Tax_Order_By>>;
  where?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
};


export type Query_RootTrade_Expense_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Expense_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Expense_Tax_Order_By>>;
  where?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
};


export type Query_RootTrade_Expense_Tax_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Grade_Quantity_SummaryArgs = {
  trade_id: Scalars['Int'];
};


export type Query_RootTrade_Grade_Quantity_Summary_ReportArgs = {
  trade_id: Scalars['Int'];
};


export type Query_RootTrade_IssuancenoteitemsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


export type Query_RootTrade_Issuancenoteitems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


export type Query_RootTrade_Issuancenoteitems_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Issuancenoteitems_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Issuancenoteitems_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Issuancenoteitems_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_ItemArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Query_RootTrade_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Query_RootTrade_Item_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Item_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Item_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_Seller_BifurcationArgs = {
  trade_id: Scalars['Int'];
};


export type Query_RootTrade_Seller_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Seller_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};


export type Query_RootTrade_Seller_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_StatusArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Order_By>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Query_RootTrade_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Order_By>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Query_RootTrade_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootTrade_Status_ParentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


export type Query_RootTrade_Status_Parents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


export type Query_RootTrade_Status_Parents_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_SummaryArgs = {
  trade_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootTrade_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


export type Query_RootTrade_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


export type Query_RootTrade_Taxes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_TimelineArgs = {
  production_trade_id?: InputMaybe<Scalars['ID']>;
  trade_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootTrade_Tnc_Template_DetailArgs = {
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  version: Scalars['ID'];
};


export type Query_RootTrade_Tnc_VersionsArgs = {
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};


export type Query_RootTrade_TradestatusaccessArgs = {
  distinct_on?: InputMaybe<Array<Trade_Tradestatusaccess_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Tradestatusaccess_Order_By>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};


export type Query_RootTrade_Tradestatusaccess_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrade_TwiliomessagesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Twiliomessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Twiliomessages_Order_By>>;
  where?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
};


export type Query_RootTrade_Twiliomessages_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootTrading_Party_DetailArgs = {
  party_codename: Scalars['String'];
};


export type Query_RootTrading_Party_ListArgs = {
  exclude_party_codename?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootTransactionArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


export type Query_RootTransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


export type Query_RootTransaction_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};


export type Query_RootTransaction_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};


export type Query_RootTransaction_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTransaction_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Order_By>>;
  where?: InputMaybe<Transactions_Bool_Exp>;
};


export type Query_RootTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Order_By>>;
  where?: InputMaybe<Transactions_Bool_Exp>;
};


export type Query_RootTransactions_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Attachments_Order_By>>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};


export type Query_RootTransactions_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Attachments_Order_By>>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};


export type Query_RootTransactions_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTransactions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTransactions_For_Invoice_SettlementArgs = {
  filters?: InputMaybe<TransactionsCustomFilterInput>;
  from_date?: InputMaybe<Scalars['Date']>;
  till_date?: InputMaybe<Scalars['Date']>;
};


export type Query_RootTransitionArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


export type Query_RootTransition_AccessArgs = {
  distinct_on?: InputMaybe<Array<Transition_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Access_Order_By>>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};


export type Query_RootTransition_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Access_Order_By>>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};


export type Query_RootTransition_Access_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTransition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


export type Query_RootTransition_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTransition_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


export type Query_RootTransition_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


export type Query_RootTransition_History_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Attribute_Order_By>>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};


export type Query_RootTransition_History_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Attribute_Order_By>>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};


export type Query_RootTransition_History_Attribute_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTransition_History_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootTrip_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootTrip_Trader_SummaryArgs = {
  trip_id?: InputMaybe<Scalars['ID']>;
};


export type Query_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootUnit_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Measure_Order_By>>;
  where?: InputMaybe<Unit_Measure_Bool_Exp>;
};


export type Query_RootUnit_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Measure_Order_By>>;
  where?: InputMaybe<Unit_Measure_Bool_Exp>;
};


export type Query_RootUnit_Measure_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootUnregistered_UserArgs = {
  distinct_on?: InputMaybe<Array<Unregistered_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unregistered_User_Order_By>>;
  where?: InputMaybe<Unregistered_User_Bool_Exp>;
};


export type Query_RootUnregistered_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unregistered_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unregistered_User_Order_By>>;
  where?: InputMaybe<Unregistered_User_Bool_Exp>;
};


export type Query_RootUnregistered_User_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootUser_AccountsArgs = {
  account_type_codename?: InputMaybe<Scalars['String']>;
  kite_reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootUser_By_UsernameArgs = {
  username: Scalars['String'];
};


export type Query_RootUser_Permission_GroupsArgs = {
  all_roles?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootUser_ProfileArgs = {
  reference_id?: InputMaybe<Scalars['String']>;
};


export type Query_RootVariety_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Bool_Exp>;
};


export type Query_RootVariety_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Bool_Exp>;
};


export type Query_RootVariety_Agreement_Agreement_Co_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


export type Query_RootVariety_Agreement_Agreement_Co_Owners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


export type Query_RootVariety_Agreement_Agreement_Co_Owners_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVariety_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVariety_Agreement_Guarantor_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


export type Query_RootVariety_Agreement_Guarantor_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


export type Query_RootVariety_Agreement_Guarantor_Agreements_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVariety_GradeArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Query_RootVariety_Grade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Query_RootVariety_Grade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVariety_Grade_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Query_RootVariety_Grade_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Query_RootVariety_Grade_Photos_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVariety_GroupArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Query_RootVariety_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Query_RootVariety_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVehicle_DetailArgs = {
  id: Scalars['ID'];
};


export type Query_RootVillage_Wise_Chemical_CountArgs = {
  inputs?: InputMaybe<VillageWiseChemicalCountInput>;
};


export type Query_RootVillage_Wise_Detection_CountArgs = {
  inputs?: InputMaybe<VillageWiseDetectionCountInput>;
};


export type Query_RootVt_Core_TaxArgs = {
  distinct_on?: InputMaybe<Array<Vt_Core_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vt_Core_Tax_Order_By>>;
  where?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
};


export type Query_RootVt_Core_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vt_Core_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vt_Core_Tax_Order_By>>;
  where?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
};


export type Query_RootVt_Core_Tax_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWeather_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Query_RootWeather_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Query_RootWeather_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWorkflowArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Query_RootWorkflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Query_RootWorkflow_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootWorkflow_Current_LogsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


export type Query_RootWorkflow_Current_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


export type Query_RootWorkflow_Current_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootWorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflows_Order_By>>;
  where?: InputMaybe<Workflows_Bool_Exp>;
};


export type Query_RootWorkflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflows_Order_By>>;
  where?: InputMaybe<Workflows_Bool_Exp>;
};


export type Query_RootWorkflows_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "receipt" */
export type Receipt = {
  __typename?: 'receipt';
  /** An array relationship */
  advance_payments: Array<Advance_Payment>;
  /** An aggregate relationship */
  advance_payments_aggregate: Advance_Payment_Aggregate;
  advance_summary?: Maybe<AdvanceSummaryType>;
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  buyer_expense_gst_auto_calculated: Scalars['Boolean'];
  buyer_tnc?: Maybe<Scalars['String']>;
  /** An array relationship */
  child_receipts: Array<Receipt>;
  /** An aggregate relationship */
  child_receipts_aggregate: Receipt_Aggregate;
  /** An object relationship */
  commodity?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  commodity_variety?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  /** An array relationship */
  credit_notes: Array<Credit_Note>;
  /** An aggregate relationship */
  credit_notes_aggregate: Credit_Note_Aggregate;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  direct_cost?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  expenses: Array<Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Expense_Aggregate;
  expiry?: Maybe<Scalars['date']>;
  /** An object relationship */
  facilitator?: Maybe<Setu_Trade_Shared_Entity>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  is_multiple_commodity: Scalars['Boolean'];
  /** An object relationship */
  junior_officer?: Maybe<Setu_Trade_Shared_Entity>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  kind: Scalars['String'];
  material_kind?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  mode: Scalars['String'];
  /** An object relationship */
  officer?: Maybe<Setu_Trade_Shared_Entity>;
  officer_id?: Maybe<Scalars['bigint']>;
  packaging: Scalars['String'];
  /** An object relationship */
  parent_receipt?: Maybe<Receipt>;
  parent_receipt_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  sales_value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  seller?: Maybe<Setu_Trade_Shared_Entity>;
  seller_bifurcation?: Maybe<SellerBifurcationType>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  seller_gst_attachments: Array<Receipt_Seller_Gst_Attachments>;
  /** An aggregate relationship */
  seller_gst_attachments_aggregate: Receipt_Seller_Gst_Attachments_Aggregate;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_payable?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_settlement_status?: Maybe<Scalars['String']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<ReceiptSummaryType>;
  supplier_expense_gst_auto_calculated: Scalars['Boolean'];
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code: Scalars['String'];
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  /** An array relationship */
  transactions: Array<Transaction>;
  /** An aggregate relationship */
  transactions_aggregate: Transaction_Aggregate;
  /** An object relationship */
  twilio_message?: Maybe<Trade_Twiliomessages>;
  twilio_message_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  vehicle?: Maybe<Setu_Trade_Shared_Entity>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "receipt" */
export type ReceiptAdvance_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptAdvance_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptChild_ReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptChild_Receipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptCredit_NotesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptCredit_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptExpensesArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "receipt" */
export type ReceiptSeller_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptSeller_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "receipt" */
export type ReceiptTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

/** aggregated selection of "receipt" */
export type Receipt_Aggregate = {
  __typename?: 'receipt_aggregate';
  aggregate?: Maybe<Receipt_Aggregate_Fields>;
  nodes: Array<Receipt>;
};

/** aggregate fields of "receipt" */
export type Receipt_Aggregate_Fields = {
  __typename?: 'receipt_aggregate_fields';
  avg?: Maybe<Receipt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Receipt_Max_Fields>;
  min?: Maybe<Receipt_Min_Fields>;
  stddev?: Maybe<Receipt_Stddev_Fields>;
  stddev_pop?: Maybe<Receipt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Receipt_Stddev_Samp_Fields>;
  sum?: Maybe<Receipt_Sum_Fields>;
  var_pop?: Maybe<Receipt_Var_Pop_Fields>;
  var_samp?: Maybe<Receipt_Var_Samp_Fields>;
  variance?: Maybe<Receipt_Variance_Fields>;
};


/** aggregate fields of "receipt" */
export type Receipt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Receipt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "receipt" */
export type Receipt_Aggregate_Order_By = {
  avg?: InputMaybe<Receipt_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Receipt_Max_Order_By>;
  min?: InputMaybe<Receipt_Min_Order_By>;
  stddev?: InputMaybe<Receipt_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Receipt_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Receipt_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Receipt_Sum_Order_By>;
  var_pop?: InputMaybe<Receipt_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Receipt_Var_Samp_Order_By>;
  variance?: InputMaybe<Receipt_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "receipt" */
export type Receipt_Arr_Rel_Insert_Input = {
  data: Array<Receipt_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Receipt_On_Conflict>;
};

/** aggregate avg on columns */
export type Receipt_Avg_Fields = {
  __typename?: 'receipt_avg_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_receipt_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "receipt" */
export type Receipt_Avg_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "receipt". All fields are combined with a logical 'AND'. */
export type Receipt_Bool_Exp = {
  _and?: InputMaybe<Array<Receipt_Bool_Exp>>;
  _not?: InputMaybe<Receipt_Bool_Exp>;
  _or?: InputMaybe<Array<Receipt_Bool_Exp>>;
  advance_payments?: InputMaybe<Advance_Payment_Bool_Exp>;
  buyer_expense_amount?: InputMaybe<Float8_Comparison_Exp>;
  buyer_expense_gst_auto_calculated?: InputMaybe<Boolean_Comparison_Exp>;
  buyer_tnc?: InputMaybe<String_Comparison_Exp>;
  child_receipts?: InputMaybe<Receipt_Bool_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit_notes?: InputMaybe<Credit_Note_Bool_Exp>;
  deducted_amount?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity_kg?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity_remaining?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity_remaining_kg?: InputMaybe<Numeric_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  direct_cost?: InputMaybe<Float8_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  expenses?: InputMaybe<Expense_Bool_Exp>;
  expiry?: InputMaybe<Date_Comparison_Exp>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  facilitator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_multiple_commodity?: InputMaybe<Boolean_Comparison_Exp>;
  junior_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  junior_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  material_kind?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  packaging?: InputMaybe<String_Comparison_Exp>;
  parent_receipt?: InputMaybe<Receipt_Bool_Exp>;
  parent_receipt_id?: InputMaybe<Bigint_Comparison_Exp>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  profit?: InputMaybe<Float8_Comparison_Exp>;
  purchase_value?: InputMaybe<Float8_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  returned_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  returned_quantity_kg?: InputMaybe<Numeric_Comparison_Exp>;
  sales_value?: InputMaybe<Float8_Comparison_Exp>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  seller_expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  seller_gst_attachments?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
  seller_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_receivable_amount?: InputMaybe<Numeric_Comparison_Exp>;
  seller_settlement_status?: InputMaybe<String_Comparison_Exp>;
  seller_tds?: InputMaybe<Float8_Comparison_Exp>;
  seller_tds_percentage?: InputMaybe<Float8_Comparison_Exp>;
  seller_tnc?: InputMaybe<String_Comparison_Exp>;
  standard_deduction?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Boolean_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_code?: InputMaybe<String_Comparison_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  transactions?: InputMaybe<Transaction_Bool_Exp>;
  twilio_message?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
  twilio_message_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  vehicle_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "receipt" */
export enum Receipt_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReceiptPkey = 'receipt_pkey',
  /** unique or primary key constraint on columns "tracking_code" */
  ReceiptTrackingCodeKey = 'receipt_tracking_code_key'
}

/** input type for incrementing numeric columns in table "receipt" */
export type Receipt_Inc_Input = {
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  parent_receipt_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "receipt" */
export type Receipt_Insert_Input = {
  advance_payments?: InputMaybe<Advance_Payment_Arr_Rel_Insert_Input>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  child_receipts?: InputMaybe<Receipt_Arr_Rel_Insert_Input>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  credit_notes?: InputMaybe<Credit_Note_Arr_Rel_Insert_Input>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expenses?: InputMaybe<Expense_Arr_Rel_Insert_Input>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  junior_officer?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_receipt?: InputMaybe<Receipt_Obj_Rel_Insert_Input>;
  parent_receipt_id?: InputMaybe<Scalars['bigint']>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_receivable_amount?: InputMaybe<Scalars['numeric']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  trades?: InputMaybe<Trade_Arr_Rel_Insert_Input>;
  transactions?: InputMaybe<Transaction_Arr_Rel_Insert_Input>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Receipt_Max_Fields = {
  __typename?: 'receipt_max_fields';
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  direct_cost?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  material_kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  officer_id?: Maybe<Scalars['bigint']>;
  packaging?: Maybe<Scalars['String']>;
  parent_receipt_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  sales_value?: Maybe<Scalars['float8']>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_settlement_status?: Maybe<Scalars['String']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  twilio_message_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "receipt" */
export type Receipt_Max_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_settlement_status?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  twilio_message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Receipt_Min_Fields = {
  __typename?: 'receipt_min_fields';
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  direct_cost?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  material_kind?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  officer_id?: Maybe<Scalars['bigint']>;
  packaging?: Maybe<Scalars['String']>;
  parent_receipt_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  sales_value?: Maybe<Scalars['float8']>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_settlement_status?: Maybe<Scalars['String']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  twilio_message_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "receipt" */
export type Receipt_Min_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_settlement_status?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  twilio_message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "receipt" */
export type Receipt_Mutation_Response = {
  __typename?: 'receipt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Receipt>;
};

/** input type for inserting object relation for remote table "receipt" */
export type Receipt_Obj_Rel_Insert_Input = {
  data: Receipt_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Receipt_On_Conflict>;
};

/** on_conflict condition type for table "receipt" */
export type Receipt_On_Conflict = {
  constraint: Receipt_Constraint;
  update_columns?: Array<Receipt_Update_Column>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};

/** Ordering options when selecting data from "receipt". */
export type Receipt_Order_By = {
  advance_payments_aggregate?: InputMaybe<Advance_Payment_Aggregate_Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_expense_gst_auto_calculated?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  child_receipts_aggregate?: InputMaybe<Receipt_Aggregate_Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_notes_aggregate?: InputMaybe<Credit_Note_Aggregate_Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expenses_aggregate?: InputMaybe<Expense_Aggregate_Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_multiple_commodity?: InputMaybe<Order_By>;
  junior_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  officer_id?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_receipt?: InputMaybe<Receipt_Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_gst_attachments_aggregate?: InputMaybe<Receipt_Seller_Gst_Attachments_Aggregate_Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_settlement_status?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  twilio_message?: InputMaybe<Trade_Twiliomessages_Order_By>;
  twilio_message_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: receipt */
export type Receipt_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "receipt" */
export enum Receipt_Select_Column {
  /** column name */
  BuyerExpenseAmount = 'buyer_expense_amount',
  /** column name */
  BuyerExpenseGstAutoCalculated = 'buyer_expense_gst_auto_calculated',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DeductedQuantity = 'deducted_quantity',
  /** column name */
  DeductedQuantityKg = 'deducted_quantity_kg',
  /** column name */
  DeductedQuantityRemaining = 'deducted_quantity_remaining',
  /** column name */
  DeductedQuantityRemainingKg = 'deducted_quantity_remaining_kg',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  DirectCost = 'direct_cost',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExpenseAmount = 'expense_amount',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsMultipleCommodity = 'is_multiple_commodity',
  /** column name */
  JuniorOfficerId = 'junior_officer_id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialKind = 'material_kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Mode = 'mode',
  /** column name */
  OfficerId = 'officer_id',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  ParentReceiptId = 'parent_receipt_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  Profit = 'profit',
  /** column name */
  PurchaseValue = 'purchase_value',
  /** column name */
  Remark = 'remark',
  /** column name */
  ReturnedQuantity = 'returned_quantity',
  /** column name */
  ReturnedQuantityKg = 'returned_quantity_kg',
  /** column name */
  SalesValue = 'sales_value',
  /** column name */
  SellerExpenseAmount = 'seller_expense_amount',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerReceivableAmount = 'seller_receivable_amount',
  /** column name */
  SellerSettlementStatus = 'seller_settlement_status',
  /** column name */
  SellerTds = 'seller_tds',
  /** column name */
  SellerTdsPercentage = 'seller_tds_percentage',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SupplierExpenseGstAutoCalculated = 'supplier_expense_gst_auto_calculated',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TrackingCode = 'tracking_code',
  /** column name */
  TwilioMessageId = 'twilio_message_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** columns and relationships of "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments = {
  __typename?: 'receipt_seller_gst_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  receipt: Receipt;
  receipt_id: Scalars['bigint'];
};

/** aggregated selection of "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Aggregate = {
  __typename?: 'receipt_seller_gst_attachments_aggregate';
  aggregate?: Maybe<Receipt_Seller_Gst_Attachments_Aggregate_Fields>;
  nodes: Array<Receipt_Seller_Gst_Attachments>;
};

/** aggregate fields of "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Aggregate_Fields = {
  __typename?: 'receipt_seller_gst_attachments_aggregate_fields';
  avg?: Maybe<Receipt_Seller_Gst_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Receipt_Seller_Gst_Attachments_Max_Fields>;
  min?: Maybe<Receipt_Seller_Gst_Attachments_Min_Fields>;
  stddev?: Maybe<Receipt_Seller_Gst_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Receipt_Seller_Gst_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Receipt_Seller_Gst_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Receipt_Seller_Gst_Attachments_Sum_Fields>;
  var_pop?: Maybe<Receipt_Seller_Gst_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Receipt_Seller_Gst_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Receipt_Seller_Gst_Attachments_Variance_Fields>;
};


/** aggregate fields of "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Receipt_Seller_Gst_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Receipt_Seller_Gst_Attachments_Max_Order_By>;
  min?: InputMaybe<Receipt_Seller_Gst_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Receipt_Seller_Gst_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Receipt_Seller_Gst_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Receipt_Seller_Gst_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Receipt_Seller_Gst_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Receipt_Seller_Gst_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Receipt_Seller_Gst_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Receipt_Seller_Gst_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Receipt_Seller_Gst_Attachments_Avg_Fields = {
  __typename?: 'receipt_seller_gst_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "receipt_seller_gst_attachments". All fields are combined with a logical 'AND'. */
export type Receipt_Seller_Gst_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  receipt_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Receipt_Seller_Gst_Attachments_Max_Fields = {
  __typename?: 'receipt_seller_gst_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Receipt_Seller_Gst_Attachments_Min_Fields = {
  __typename?: 'receipt_seller_gst_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "receipt_seller_gst_attachments". */
export type Receipt_Seller_Gst_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** select columns of table "receipt_seller_gst_attachments" */
export enum Receipt_Seller_Gst_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  ReceiptId = 'receipt_id'
}

/** aggregate stddev on columns */
export type Receipt_Seller_Gst_Attachments_Stddev_Fields = {
  __typename?: 'receipt_seller_gst_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Receipt_Seller_Gst_Attachments_Stddev_Pop_Fields = {
  __typename?: 'receipt_seller_gst_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Receipt_Seller_Gst_Attachments_Stddev_Samp_Fields = {
  __typename?: 'receipt_seller_gst_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Receipt_Seller_Gst_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Receipt_Seller_Gst_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Receipt_Seller_Gst_Attachments_Sum_Fields = {
  __typename?: 'receipt_seller_gst_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Receipt_Seller_Gst_Attachments_Var_Pop_Fields = {
  __typename?: 'receipt_seller_gst_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Receipt_Seller_Gst_Attachments_Var_Samp_Fields = {
  __typename?: 'receipt_seller_gst_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Receipt_Seller_Gst_Attachments_Variance_Fields = {
  __typename?: 'receipt_seller_gst_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "receipt_seller_gst_attachments" */
export type Receipt_Seller_Gst_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
};

/** input type for updating data in table "receipt" */
export type Receipt_Set_Input = {
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_receipt_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Receipt_Stddev_Fields = {
  __typename?: 'receipt_stddev_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_receipt_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "receipt" */
export type Receipt_Stddev_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Receipt_Stddev_Pop_Fields = {
  __typename?: 'receipt_stddev_pop_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_receipt_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "receipt" */
export type Receipt_Stddev_Pop_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Receipt_Stddev_Samp_Fields = {
  __typename?: 'receipt_stddev_samp_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_receipt_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "receipt" */
export type Receipt_Stddev_Samp_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "receipt" */
export type Receipt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Receipt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Receipt_Stream_Cursor_Value_Input = {
  buyer_expense_amount?: InputMaybe<Scalars['float8']>;
  buyer_expense_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  deducted_amount?: InputMaybe<Scalars['numeric']>;
  deducted_quantity?: InputMaybe<Scalars['numeric']>;
  deducted_quantity_kg?: InputMaybe<Scalars['numeric']>;
  deducted_quantity_remaining?: InputMaybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: InputMaybe<Scalars['numeric']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  direct_cost?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['date']>;
  expense_amount?: InputMaybe<Scalars['numeric']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_multiple_commodity?: InputMaybe<Scalars['Boolean']>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  material_kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mode?: InputMaybe<Scalars['String']>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_receipt_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  profit?: InputMaybe<Scalars['float8']>;
  purchase_value?: InputMaybe<Scalars['float8']>;
  remark?: InputMaybe<Scalars['String']>;
  returned_quantity?: InputMaybe<Scalars['numeric']>;
  returned_quantity_kg?: InputMaybe<Scalars['numeric']>;
  sales_value?: InputMaybe<Scalars['float8']>;
  seller_expense_amount?: InputMaybe<Scalars['numeric']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_receivable_amount?: InputMaybe<Scalars['numeric']>;
  seller_settlement_status?: InputMaybe<Scalars['String']>;
  seller_tds?: InputMaybe<Scalars['float8']>;
  seller_tds_percentage?: InputMaybe<Scalars['float8']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_quantity?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  twilio_message_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Receipt_Sum_Fields = {
  __typename?: 'receipt_sum_fields';
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  department_id?: Maybe<Scalars['bigint']>;
  direct_cost?: Maybe<Scalars['float8']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  officer_id?: Maybe<Scalars['bigint']>;
  parent_receipt_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  sales_value?: Maybe<Scalars['float8']>;
  seller_expense_amount?: Maybe<Scalars['numeric']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "receipt" */
export type Receipt_Sum_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** update columns of table "receipt" */
export enum Receipt_Update_Column {
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  JuniorOfficerId = 'junior_officer_id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Mode = 'mode',
  /** column name */
  OfficerId = 'officer_id',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  ParentReceiptId = 'parent_receipt_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TrackingCode = 'tracking_code',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Receipt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Receipt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Receipt_Set_Input>;
  where: Receipt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Receipt_Var_Pop_Fields = {
  __typename?: 'receipt_var_pop_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_receipt_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "receipt" */
export type Receipt_Var_Pop_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Receipt_Var_Samp_Fields = {
  __typename?: 'receipt_var_samp_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_receipt_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "receipt" */
export type Receipt_Var_Samp_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Receipt_Variance_Fields = {
  __typename?: 'receipt_variance_fields';
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_receipt_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "receipt" */
export type Receipt_Variance_Order_By = {
  buyer_expense_amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_receipt_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "region" */
export type Region = {
  __typename?: 'region';
  code?: Maybe<Scalars['String']>;
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  fields: Array<Field>;
  /** An aggregate relationship */
  fields_aggregate: Field_Aggregate;
  geom?: Maybe<Scalars['geometry']>;
  group_id: Scalars['Int'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  /** An array relationship */
  mutual_groups: Array<Mutual_Group>;
  /** An aggregate relationship */
  mutual_groups_aggregate: Mutual_Group_Aggregate;
  name: Scalars['String'];
  /** An object relationship */
  parent_region?: Maybe<Region>;
  parent_region_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  region_group: Region_Group;
  /** An array relationship */
  regions: Array<Region>;
  /** An aggregate relationship */
  regions_aggregate: Region_Aggregate;
};


/** columns and relationships of "region" */
export type RegionFieldsArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionMutual_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionMutual_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionRegionsArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


/** columns and relationships of "region" */
export type RegionRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};

/** aggregated selection of "region" */
export type Region_Aggregate = {
  __typename?: 'region_aggregate';
  aggregate?: Maybe<Region_Aggregate_Fields>;
  nodes: Array<Region>;
};

/** aggregate fields of "region" */
export type Region_Aggregate_Fields = {
  __typename?: 'region_aggregate_fields';
  avg?: Maybe<Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Region_Max_Fields>;
  min?: Maybe<Region_Min_Fields>;
  stddev?: Maybe<Region_Stddev_Fields>;
  stddev_pop?: Maybe<Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Region_Stddev_Samp_Fields>;
  sum?: Maybe<Region_Sum_Fields>;
  var_pop?: Maybe<Region_Var_Pop_Fields>;
  var_samp?: Maybe<Region_Var_Samp_Fields>;
  variance?: Maybe<Region_Variance_Fields>;
};


/** aggregate fields of "region" */
export type Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "region" */
export type Region_Aggregate_Order_By = {
  avg?: InputMaybe<Region_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Region_Max_Order_By>;
  min?: InputMaybe<Region_Min_Order_By>;
  stddev?: InputMaybe<Region_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Region_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Region_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Region_Sum_Order_By>;
  var_pop?: InputMaybe<Region_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Region_Var_Samp_Order_By>;
  variance?: InputMaybe<Region_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "region" */
export type Region_Arr_Rel_Insert_Input = {
  data: Array<Region_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_On_Conflict>;
};

/** aggregate avg on columns */
export type Region_Avg_Fields = {
  __typename?: 'region_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "region" */
export type Region_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "region". All fields are combined with a logical 'AND'. */
export type Region_Bool_Exp = {
  _and?: InputMaybe<Array<Region_Bool_Exp>>;
  _not?: InputMaybe<Region_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  fields?: InputMaybe<Field_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  mutual_groups?: InputMaybe<Mutual_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_region?: InputMaybe<Region_Bool_Exp>;
  parent_region_id?: InputMaybe<Int_Comparison_Exp>;
  region_group?: InputMaybe<Region_Group_Bool_Exp>;
  regions?: InputMaybe<Region_Bool_Exp>;
};

/** unique or primary key constraints on table "region" */
export enum Region_Constraint {
  /** unique or primary key constraint on columns "codename" */
  RegionCodenameKey = 'region_codename_key',
  /** unique or primary key constraint on columns "name", "parent_region_id", "group_id" */
  RegionGroupIdNameParentRegionIdD398bc0cUniq = 'region_group_id_name_parent_region_id_d398bc0c_uniq',
  /** unique or primary key constraint on columns "id" */
  RegionPkey = 'region_pkey'
}

/** columns and relationships of "region_group" */
export type Region_Group = {
  __typename?: 'region_group';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "region_group" */
export type Region_Group_Aggregate = {
  __typename?: 'region_group_aggregate';
  aggregate?: Maybe<Region_Group_Aggregate_Fields>;
  nodes: Array<Region_Group>;
};

/** aggregate fields of "region_group" */
export type Region_Group_Aggregate_Fields = {
  __typename?: 'region_group_aggregate_fields';
  avg?: Maybe<Region_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Region_Group_Max_Fields>;
  min?: Maybe<Region_Group_Min_Fields>;
  stddev?: Maybe<Region_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Region_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Region_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Region_Group_Sum_Fields>;
  var_pop?: Maybe<Region_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Region_Group_Var_Samp_Fields>;
  variance?: Maybe<Region_Group_Variance_Fields>;
};


/** aggregate fields of "region_group" */
export type Region_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Region_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Region_Group_Avg_Fields = {
  __typename?: 'region_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "region_group". All fields are combined with a logical 'AND'. */
export type Region_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Region_Group_Bool_Exp>>;
  _not?: InputMaybe<Region_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Region_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "region_group" */
export enum Region_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  RegionGroupCodenameKey = 'region_group_codename_key',
  /** unique or primary key constraint on columns "name" */
  RegionGroupNameKey = 'region_group_name_key',
  /** unique or primary key constraint on columns "id" */
  RegionGroupPkey = 'region_group_pkey'
}

/** input type for incrementing numeric columns in table "region_group" */
export type Region_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "region_group" */
export type Region_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Region_Group_Max_Fields = {
  __typename?: 'region_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Region_Group_Min_Fields = {
  __typename?: 'region_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "region_group" */
export type Region_Group_Mutation_Response = {
  __typename?: 'region_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Region_Group>;
};

/** input type for inserting object relation for remote table "region_group" */
export type Region_Group_Obj_Rel_Insert_Input = {
  data: Region_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_Group_On_Conflict>;
};

/** on_conflict condition type for table "region_group" */
export type Region_Group_On_Conflict = {
  constraint: Region_Group_Constraint;
  update_columns?: Array<Region_Group_Update_Column>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "region_group". */
export type Region_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: region_group */
export type Region_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "region_group" */
export enum Region_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "region_group" */
export type Region_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Region_Group_Stddev_Fields = {
  __typename?: 'region_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Region_Group_Stddev_Pop_Fields = {
  __typename?: 'region_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Region_Group_Stddev_Samp_Fields = {
  __typename?: 'region_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "region_group" */
export type Region_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Region_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Region_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Region_Group_Sum_Fields = {
  __typename?: 'region_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "region_group" */
export enum Region_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Region_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Region_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Region_Group_Set_Input>;
  where: Region_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Region_Group_Var_Pop_Fields = {
  __typename?: 'region_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Region_Group_Var_Samp_Fields = {
  __typename?: 'region_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Region_Group_Variance_Fields = {
  __typename?: 'region_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "region" */
export type Region_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "region" */
export type Region_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Field_Arr_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  mutual_groups?: InputMaybe<Mutual_Group_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  parent_region?: InputMaybe<Region_Obj_Rel_Insert_Input>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
  region_group?: InputMaybe<Region_Group_Obj_Rel_Insert_Input>;
  regions?: InputMaybe<Region_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Region_Max_Fields = {
  __typename?: 'region_max_fields';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_region_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "region" */
export type Region_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Region_Min_Fields = {
  __typename?: 'region_min_fields';
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_region_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "region" */
export type Region_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "region" */
export type Region_Mutation_Response = {
  __typename?: 'region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Region>;
};

/** input type for inserting object relation for remote table "region" */
export type Region_Obj_Rel_Insert_Input = {
  data: Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Region_On_Conflict>;
};

/** on_conflict condition type for table "region" */
export type Region_On_Conflict = {
  constraint: Region_Constraint;
  update_columns?: Array<Region_Update_Column>;
  where?: InputMaybe<Region_Bool_Exp>;
};

/** Ordering options when selecting data from "region". */
export type Region_Order_By = {
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fields_aggregate?: InputMaybe<Field_Aggregate_Order_By>;
  geom?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  mutual_groups_aggregate?: InputMaybe<Mutual_Group_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  parent_region?: InputMaybe<Region_Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
  region_group?: InputMaybe<Region_Group_Order_By>;
  regions_aggregate?: InputMaybe<Region_Aggregate_Order_By>;
};

/** primary key columns input for table: region */
export type Region_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "region" */
export enum Region_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  ParentRegionId = 'parent_region_id'
}

/** input type for updating data in table "region" */
export type Region_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Region_Stddev_Fields = {
  __typename?: 'region_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "region" */
export type Region_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Region_Stddev_Pop_Fields = {
  __typename?: 'region_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "region" */
export type Region_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Region_Stddev_Samp_Fields = {
  __typename?: 'region_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "region" */
export type Region_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "region" */
export type Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Region_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_region_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Region_Sum_Fields = {
  __typename?: 'region_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_region_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "region" */
export type Region_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** update columns of table "region" */
export enum Region_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  ParentRegionId = 'parent_region_id'
}

export type Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Region_Set_Input>;
  where: Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Region_Var_Pop_Fields = {
  __typename?: 'region_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "region" */
export type Region_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Region_Var_Samp_Fields = {
  __typename?: 'region_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "region" */
export type Region_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Region_Variance_Fields = {
  __typename?: 'region_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_region_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "region" */
export type Region_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_region_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "request" */
export type Request = {
  __typename?: 'request';
  /** An object relationship */
  category: Request_Category;
  category_id: Scalars['bigint'];
  color_code?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by: Array<Base_User>;
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  department?: Maybe<External_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  is_archived: Scalars['Boolean'];
  is_partial: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  /** An object relationship */
  laboratory?: Maybe<Laboratory>;
  laboratory_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  parameters: Array<Request_Parameters>;
  /** An aggregate relationship */
  parameters_aggregate: Request_Parameters_Aggregate;
  parent_request_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  primary_location: External_Entity;
  primary_location_id: Scalars['bigint'];
  /** An object relationship */
  recorded_at?: Maybe<Eagle_Address>;
  recorded_at_id?: Maybe<Scalars['bigint']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  rejection_reason?: Maybe<Scalars['String']>;
  /** An array relationship */
  results: Array<Result>;
  /** An aggregate relationship */
  results_aggregate: Result_Aggregate;
  /** An object relationship */
  sample?: Maybe<Sample>;
  /** An array relationship */
  sample_observations: Array<Sample_Observation>;
  /** An aggregate relationship */
  sample_observations_aggregate: Sample_Observation_Aggregate;
  /** An object relationship */
  sample_request?: Maybe<Request>;
  /** An array relationship */
  secondary_locations: Array<Request_Secondary_Locations>;
  /** An aggregate relationship */
  secondary_locations_aggregate: Request_Secondary_Locations_Aggregate;
  /** An array relationship */
  templates: Array<Request_Templates>;
  /** An aggregate relationship */
  templates_aggregate: Request_Templates_Aggregate;
  /** An object relationship */
  test_for: External_Entity;
  test_for_id: Scalars['bigint'];
  /** An array relationship */
  test_requests: Array<Request>;
  /** An aggregate relationship */
  test_requests_aggregate: Request_Aggregate;
  /** An array relationship */
  transition_logs: Array<Transition_History>;
  /** An aggregate relationship */
  transition_logs_aggregate: Transition_History_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by: Array<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  withdraw_sample_on?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  workflow_states: Array<Entity_State>;
  /** An aggregate relationship */
  workflow_states_aggregate: Entity_State_Aggregate;
};


/** columns and relationships of "request" */
export type RequestCreated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Requestcreated_By>;
};


/** columns and relationships of "request" */
export type RequestParametersArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestResultsArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestSample_ObservationsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestSample_Observations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestSecondary_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Request_Secondary_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Secondary_Locations_Order_By>>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestSecondary_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Secondary_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Secondary_Locations_Order_By>>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestTemplatesArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestTest_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestTest_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestTransition_LogsArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestTransition_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestUpdated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Requestupdated_By>;
};


/** columns and relationships of "request" */
export type RequestWorkflow_StatesArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


/** columns and relationships of "request" */
export type RequestWorkflow_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};

/** aggregated selection of "request" */
export type Request_Aggregate = {
  __typename?: 'request_aggregate';
  aggregate?: Maybe<Request_Aggregate_Fields>;
  nodes: Array<Request>;
};

/** aggregate fields of "request" */
export type Request_Aggregate_Fields = {
  __typename?: 'request_aggregate_fields';
  avg?: Maybe<Request_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Request_Max_Fields>;
  min?: Maybe<Request_Min_Fields>;
  stddev?: Maybe<Request_Stddev_Fields>;
  stddev_pop?: Maybe<Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Request_Stddev_Samp_Fields>;
  sum?: Maybe<Request_Sum_Fields>;
  var_pop?: Maybe<Request_Var_Pop_Fields>;
  var_samp?: Maybe<Request_Var_Samp_Fields>;
  variance?: Maybe<Request_Variance_Fields>;
};


/** aggregate fields of "request" */
export type Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "request" */
export type Request_Aggregate_Order_By = {
  avg?: InputMaybe<Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Request_Max_Order_By>;
  min?: InputMaybe<Request_Min_Order_By>;
  stddev?: InputMaybe<Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Request_Sum_Order_By>;
  var_pop?: InputMaybe<Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Request_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "request" */
export type Request_Arr_Rel_Insert_Input = {
  data: Array<Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Request_On_Conflict>;
};

/** aggregate avg on columns */
export type Request_Avg_Fields = {
  __typename?: 'request_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
  parent_request_id?: Maybe<Scalars['Float']>;
  primary_location_id?: Maybe<Scalars['Float']>;
  recorded_at_id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "request" */
export type Request_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "request". All fields are combined with a logical 'AND'. */
export type Request_Bool_Exp = {
  _and?: InputMaybe<Array<Request_Bool_Exp>>;
  _not?: InputMaybe<Request_Bool_Exp>;
  _or?: InputMaybe<Array<Request_Bool_Exp>>;
  category?: InputMaybe<Request_Category_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  color_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<External_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_partial?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  laboratory?: InputMaybe<Laboratory_Bool_Exp>;
  laboratory_id?: InputMaybe<Bigint_Comparison_Exp>;
  parameters?: InputMaybe<Request_Parameters_Bool_Exp>;
  parent_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  primary_location?: InputMaybe<External_Entity_Bool_Exp>;
  primary_location_id?: InputMaybe<Bigint_Comparison_Exp>;
  recorded_at?: InputMaybe<Eagle_Address_Bool_Exp>;
  recorded_at_id?: InputMaybe<Bigint_Comparison_Exp>;
  rejection_percent?: InputMaybe<Numeric_Comparison_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  results?: InputMaybe<Result_Bool_Exp>;
  sample?: InputMaybe<Sample_Bool_Exp>;
  sample_observations?: InputMaybe<Sample_Observation_Bool_Exp>;
  sample_request?: InputMaybe<Request_Bool_Exp>;
  secondary_locations?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
  templates?: InputMaybe<Request_Templates_Bool_Exp>;
  test_for?: InputMaybe<External_Entity_Bool_Exp>;
  test_for_id?: InputMaybe<Bigint_Comparison_Exp>;
  test_requests?: InputMaybe<Request_Bool_Exp>;
  transition_logs?: InputMaybe<Transition_History_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  withdraw_sample_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  workflow_states?: InputMaybe<Entity_State_Bool_Exp>;
};

/** columns and relationships of "request_category" */
export type Request_Category = {
  __typename?: 'request_category';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  includes_result: Scalars['Boolean'];
  includes_sample: Scalars['Boolean'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  requests: Array<Request>;
  /** An aggregate relationship */
  requests_aggregate: Request_Aggregate;
};


/** columns and relationships of "request_category" */
export type Request_CategoryRequestsArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


/** columns and relationships of "request_category" */
export type Request_CategoryRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};

/** aggregated selection of "request_category" */
export type Request_Category_Aggregate = {
  __typename?: 'request_category_aggregate';
  aggregate?: Maybe<Request_Category_Aggregate_Fields>;
  nodes: Array<Request_Category>;
};

/** aggregate fields of "request_category" */
export type Request_Category_Aggregate_Fields = {
  __typename?: 'request_category_aggregate_fields';
  avg?: Maybe<Request_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Request_Category_Max_Fields>;
  min?: Maybe<Request_Category_Min_Fields>;
  stddev?: Maybe<Request_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Request_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Request_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Request_Category_Sum_Fields>;
  var_pop?: Maybe<Request_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Request_Category_Var_Samp_Fields>;
  variance?: Maybe<Request_Category_Variance_Fields>;
};


/** aggregate fields of "request_category" */
export type Request_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Request_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Request_Category_Avg_Fields = {
  __typename?: 'request_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "request_category". All fields are combined with a logical 'AND'. */
export type Request_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Request_Category_Bool_Exp>>;
  _not?: InputMaybe<Request_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Request_Category_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  includes_result?: InputMaybe<Boolean_Comparison_Exp>;
  includes_sample?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  requests?: InputMaybe<Request_Bool_Exp>;
};

/** unique or primary key constraints on table "request_category" */
export enum Request_Category_Constraint {
  /** unique or primary key constraint on columns "codename" */
  RequestCategoryCodenameKey = 'request_category_codename_key',
  /** unique or primary key constraint on columns "id" */
  RequestCategoryPkey = 'request_category_pkey'
}

/** input type for incrementing numeric columns in table "request_category" */
export type Request_Category_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "request_category" */
export type Request_Category_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  includes_result?: InputMaybe<Scalars['Boolean']>;
  includes_sample?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  requests?: InputMaybe<Request_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Request_Category_Max_Fields = {
  __typename?: 'request_category_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Request_Category_Min_Fields = {
  __typename?: 'request_category_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "request_category" */
export type Request_Category_Mutation_Response = {
  __typename?: 'request_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Request_Category>;
};

/** input type for inserting object relation for remote table "request_category" */
export type Request_Category_Obj_Rel_Insert_Input = {
  data: Request_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Request_Category_On_Conflict>;
};

/** on_conflict condition type for table "request_category" */
export type Request_Category_On_Conflict = {
  constraint: Request_Category_Constraint;
  update_columns?: Array<Request_Category_Update_Column>;
  where?: InputMaybe<Request_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "request_category". */
export type Request_Category_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  includes_result?: InputMaybe<Order_By>;
  includes_sample?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  requests_aggregate?: InputMaybe<Request_Aggregate_Order_By>;
};

/** primary key columns input for table: request_category */
export type Request_Category_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "request_category" */
export enum Request_Category_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IncludesResult = 'includes_result',
  /** column name */
  IncludesSample = 'includes_sample',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "request_category" */
export type Request_Category_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  includes_result?: InputMaybe<Scalars['Boolean']>;
  includes_sample?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Request_Category_Stddev_Fields = {
  __typename?: 'request_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Request_Category_Stddev_Pop_Fields = {
  __typename?: 'request_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Request_Category_Stddev_Samp_Fields = {
  __typename?: 'request_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "request_category" */
export type Request_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Request_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Request_Category_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  includes_result?: InputMaybe<Scalars['Boolean']>;
  includes_sample?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Request_Category_Sum_Fields = {
  __typename?: 'request_category_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "request_category" */
export enum Request_Category_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IncludesResult = 'includes_result',
  /** column name */
  IncludesSample = 'includes_sample',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Request_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Request_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Request_Category_Set_Input>;
  where: Request_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Request_Category_Var_Pop_Fields = {
  __typename?: 'request_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Request_Category_Var_Samp_Fields = {
  __typename?: 'request_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Request_Category_Variance_Fields = {
  __typename?: 'request_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "request" */
export enum Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequestPkey = 'request_pkey'
}

/** input type for incrementing numeric columns in table "request" */
export type Request_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
  parent_request_id?: InputMaybe<Scalars['bigint']>;
  primary_location_id?: InputMaybe<Scalars['bigint']>;
  recorded_at_id?: InputMaybe<Scalars['bigint']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "request" */
export type Request_Insert_Input = {
  category?: InputMaybe<Request_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']>;
  color_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_partial?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  laboratory?: InputMaybe<Laboratory_Obj_Rel_Insert_Input>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
  parameters?: InputMaybe<Request_Parameters_Arr_Rel_Insert_Input>;
  parent_request_id?: InputMaybe<Scalars['bigint']>;
  primary_location?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  primary_location_id?: InputMaybe<Scalars['bigint']>;
  recorded_at?: InputMaybe<Eagle_Address_Obj_Rel_Insert_Input>;
  recorded_at_id?: InputMaybe<Scalars['bigint']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Result_Arr_Rel_Insert_Input>;
  sample?: InputMaybe<Sample_Obj_Rel_Insert_Input>;
  sample_observations?: InputMaybe<Sample_Observation_Arr_Rel_Insert_Input>;
  sample_request?: InputMaybe<Request_Obj_Rel_Insert_Input>;
  secondary_locations?: InputMaybe<Request_Secondary_Locations_Arr_Rel_Insert_Input>;
  templates?: InputMaybe<Request_Templates_Arr_Rel_Insert_Input>;
  test_for?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
  test_requests?: InputMaybe<Request_Arr_Rel_Insert_Input>;
  transition_logs?: InputMaybe<Transition_History_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  withdraw_sample_on?: InputMaybe<Scalars['timestamptz']>;
  workflow_states?: InputMaybe<Entity_State_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Request_Max_Fields = {
  __typename?: 'request_max_fields';
  category_id?: Maybe<Scalars['bigint']>;
  color_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  laboratory_id?: Maybe<Scalars['bigint']>;
  parent_request_id?: Maybe<Scalars['bigint']>;
  primary_location_id?: Maybe<Scalars['bigint']>;
  recorded_at_id?: Maybe<Scalars['bigint']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  rejection_reason?: Maybe<Scalars['String']>;
  test_for_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  withdraw_sample_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "request" */
export type Request_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  color_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  withdraw_sample_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Request_Min_Fields = {
  __typename?: 'request_min_fields';
  category_id?: Maybe<Scalars['bigint']>;
  color_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  laboratory_id?: Maybe<Scalars['bigint']>;
  parent_request_id?: Maybe<Scalars['bigint']>;
  primary_location_id?: Maybe<Scalars['bigint']>;
  recorded_at_id?: Maybe<Scalars['bigint']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  rejection_reason?: Maybe<Scalars['String']>;
  test_for_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  withdraw_sample_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "request" */
export type Request_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  color_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  withdraw_sample_on?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "request" */
export type Request_Mutation_Response = {
  __typename?: 'request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Request>;
};

/** input type for inserting object relation for remote table "request" */
export type Request_Obj_Rel_Insert_Input = {
  data: Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Request_On_Conflict>;
};

/** on_conflict condition type for table "request" */
export type Request_On_Conflict = {
  constraint: Request_Constraint;
  update_columns?: Array<Request_Update_Column>;
  where?: InputMaybe<Request_Bool_Exp>;
};

/** Ordering options when selecting data from "request". */
export type Request_Order_By = {
  category?: InputMaybe<Request_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  color_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department?: InputMaybe<External_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_partial?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  laboratory?: InputMaybe<Laboratory_Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parameters_aggregate?: InputMaybe<Request_Parameters_Aggregate_Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location?: InputMaybe<External_Entity_Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at?: InputMaybe<Eagle_Address_Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  results_aggregate?: InputMaybe<Result_Aggregate_Order_By>;
  sample?: InputMaybe<Sample_Order_By>;
  sample_observations_aggregate?: InputMaybe<Sample_Observation_Aggregate_Order_By>;
  sample_request?: InputMaybe<Request_Order_By>;
  secondary_locations_aggregate?: InputMaybe<Request_Secondary_Locations_Aggregate_Order_By>;
  templates_aggregate?: InputMaybe<Request_Templates_Aggregate_Order_By>;
  test_for?: InputMaybe<External_Entity_Order_By>;
  test_for_id?: InputMaybe<Order_By>;
  test_requests_aggregate?: InputMaybe<Request_Aggregate_Order_By>;
  transition_logs_aggregate?: InputMaybe<Transition_History_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  withdraw_sample_on?: InputMaybe<Order_By>;
  workflow_states_aggregate?: InputMaybe<Entity_State_Aggregate_Order_By>;
};

/** columns and relationships of "request_parameters" */
export type Request_Parameters = {
  __typename?: 'request_parameters';
  id: Scalars['bigint'];
  /** An object relationship */
  quality_parameter: Quality_Parameter;
  qualityparameter_id: Scalars['bigint'];
  /** An object relationship */
  request: Request;
  request_id: Scalars['bigint'];
};

/** aggregated selection of "request_parameters" */
export type Request_Parameters_Aggregate = {
  __typename?: 'request_parameters_aggregate';
  aggregate?: Maybe<Request_Parameters_Aggregate_Fields>;
  nodes: Array<Request_Parameters>;
};

/** aggregate fields of "request_parameters" */
export type Request_Parameters_Aggregate_Fields = {
  __typename?: 'request_parameters_aggregate_fields';
  avg?: Maybe<Request_Parameters_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Request_Parameters_Max_Fields>;
  min?: Maybe<Request_Parameters_Min_Fields>;
  stddev?: Maybe<Request_Parameters_Stddev_Fields>;
  stddev_pop?: Maybe<Request_Parameters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Request_Parameters_Stddev_Samp_Fields>;
  sum?: Maybe<Request_Parameters_Sum_Fields>;
  var_pop?: Maybe<Request_Parameters_Var_Pop_Fields>;
  var_samp?: Maybe<Request_Parameters_Var_Samp_Fields>;
  variance?: Maybe<Request_Parameters_Variance_Fields>;
};


/** aggregate fields of "request_parameters" */
export type Request_Parameters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "request_parameters" */
export type Request_Parameters_Aggregate_Order_By = {
  avg?: InputMaybe<Request_Parameters_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Request_Parameters_Max_Order_By>;
  min?: InputMaybe<Request_Parameters_Min_Order_By>;
  stddev?: InputMaybe<Request_Parameters_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Request_Parameters_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Request_Parameters_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Request_Parameters_Sum_Order_By>;
  var_pop?: InputMaybe<Request_Parameters_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Request_Parameters_Var_Samp_Order_By>;
  variance?: InputMaybe<Request_Parameters_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "request_parameters" */
export type Request_Parameters_Arr_Rel_Insert_Input = {
  data: Array<Request_Parameters_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Request_Parameters_On_Conflict>;
};

/** aggregate avg on columns */
export type Request_Parameters_Avg_Fields = {
  __typename?: 'request_parameters_avg_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparameter_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "request_parameters" */
export type Request_Parameters_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "request_parameters". All fields are combined with a logical 'AND'. */
export type Request_Parameters_Bool_Exp = {
  _and?: InputMaybe<Array<Request_Parameters_Bool_Exp>>;
  _not?: InputMaybe<Request_Parameters_Bool_Exp>;
  _or?: InputMaybe<Array<Request_Parameters_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_parameter?: InputMaybe<Quality_Parameter_Bool_Exp>;
  qualityparameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  request?: InputMaybe<Request_Bool_Exp>;
  request_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "request_parameters" */
export enum Request_Parameters_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequestParametersPkey = 'request_parameters_pkey',
  /** unique or primary key constraint on columns "request_id", "qualityparameter_id" */
  RequestParametersRequestIdQualityparameterId_0180f920Uniq = 'request_parameters_request_id_qualityparameter_id_0180f920_uniq'
}

/** input type for incrementing numeric columns in table "request_parameters" */
export type Request_Parameters_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualityparameter_id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "request_parameters" */
export type Request_Parameters_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  quality_parameter?: InputMaybe<Quality_Parameter_Obj_Rel_Insert_Input>;
  qualityparameter_id?: InputMaybe<Scalars['bigint']>;
  request?: InputMaybe<Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Request_Parameters_Max_Fields = {
  __typename?: 'request_parameters_max_fields';
  id?: Maybe<Scalars['bigint']>;
  qualityparameter_id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "request_parameters" */
export type Request_Parameters_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Request_Parameters_Min_Fields = {
  __typename?: 'request_parameters_min_fields';
  id?: Maybe<Scalars['bigint']>;
  qualityparameter_id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "request_parameters" */
export type Request_Parameters_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "request_parameters" */
export type Request_Parameters_Mutation_Response = {
  __typename?: 'request_parameters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Request_Parameters>;
};

/** on_conflict condition type for table "request_parameters" */
export type Request_Parameters_On_Conflict = {
  constraint: Request_Parameters_Constraint;
  update_columns?: Array<Request_Parameters_Update_Column>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};

/** Ordering options when selecting data from "request_parameters". */
export type Request_Parameters_Order_By = {
  id?: InputMaybe<Order_By>;
  quality_parameter?: InputMaybe<Quality_Parameter_Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request?: InputMaybe<Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request_parameters */
export type Request_Parameters_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "request_parameters" */
export enum Request_Parameters_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualityparameterId = 'qualityparameter_id',
  /** column name */
  RequestId = 'request_id'
}

/** input type for updating data in table "request_parameters" */
export type Request_Parameters_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualityparameter_id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Request_Parameters_Stddev_Fields = {
  __typename?: 'request_parameters_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparameter_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "request_parameters" */
export type Request_Parameters_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Request_Parameters_Stddev_Pop_Fields = {
  __typename?: 'request_parameters_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparameter_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "request_parameters" */
export type Request_Parameters_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Request_Parameters_Stddev_Samp_Fields = {
  __typename?: 'request_parameters_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparameter_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "request_parameters" */
export type Request_Parameters_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "request_parameters" */
export type Request_Parameters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Request_Parameters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Request_Parameters_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualityparameter_id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Request_Parameters_Sum_Fields = {
  __typename?: 'request_parameters_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  qualityparameter_id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "request_parameters" */
export type Request_Parameters_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** update columns of table "request_parameters" */
export enum Request_Parameters_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualityparameterId = 'qualityparameter_id',
  /** column name */
  RequestId = 'request_id'
}

export type Request_Parameters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Request_Parameters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Request_Parameters_Set_Input>;
  where: Request_Parameters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Request_Parameters_Var_Pop_Fields = {
  __typename?: 'request_parameters_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparameter_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "request_parameters" */
export type Request_Parameters_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Request_Parameters_Var_Samp_Fields = {
  __typename?: 'request_parameters_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparameter_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "request_parameters" */
export type Request_Parameters_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Request_Parameters_Variance_Fields = {
  __typename?: 'request_parameters_variance_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparameter_id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "request_parameters" */
export type Request_Parameters_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparameter_id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request */
export type Request_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** columns and relationships of "request_secondary_locations" */
export type Request_Secondary_Locations = {
  __typename?: 'request_secondary_locations';
  /** An object relationship */
  external_entity: External_Entity;
  externalentity_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  request: Request;
  request_id: Scalars['bigint'];
};

/** aggregated selection of "request_secondary_locations" */
export type Request_Secondary_Locations_Aggregate = {
  __typename?: 'request_secondary_locations_aggregate';
  aggregate?: Maybe<Request_Secondary_Locations_Aggregate_Fields>;
  nodes: Array<Request_Secondary_Locations>;
};

/** aggregate fields of "request_secondary_locations" */
export type Request_Secondary_Locations_Aggregate_Fields = {
  __typename?: 'request_secondary_locations_aggregate_fields';
  avg?: Maybe<Request_Secondary_Locations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Request_Secondary_Locations_Max_Fields>;
  min?: Maybe<Request_Secondary_Locations_Min_Fields>;
  stddev?: Maybe<Request_Secondary_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Request_Secondary_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Request_Secondary_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Request_Secondary_Locations_Sum_Fields>;
  var_pop?: Maybe<Request_Secondary_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Request_Secondary_Locations_Var_Samp_Fields>;
  variance?: Maybe<Request_Secondary_Locations_Variance_Fields>;
};


/** aggregate fields of "request_secondary_locations" */
export type Request_Secondary_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Request_Secondary_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "request_secondary_locations" */
export type Request_Secondary_Locations_Aggregate_Order_By = {
  avg?: InputMaybe<Request_Secondary_Locations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Request_Secondary_Locations_Max_Order_By>;
  min?: InputMaybe<Request_Secondary_Locations_Min_Order_By>;
  stddev?: InputMaybe<Request_Secondary_Locations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Request_Secondary_Locations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Request_Secondary_Locations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Request_Secondary_Locations_Sum_Order_By>;
  var_pop?: InputMaybe<Request_Secondary_Locations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Request_Secondary_Locations_Var_Samp_Order_By>;
  variance?: InputMaybe<Request_Secondary_Locations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "request_secondary_locations" */
export type Request_Secondary_Locations_Arr_Rel_Insert_Input = {
  data: Array<Request_Secondary_Locations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Request_Secondary_Locations_On_Conflict>;
};

/** aggregate avg on columns */
export type Request_Secondary_Locations_Avg_Fields = {
  __typename?: 'request_secondary_locations_avg_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Avg_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "request_secondary_locations". All fields are combined with a logical 'AND'. */
export type Request_Secondary_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Request_Secondary_Locations_Bool_Exp>>;
  _not?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Request_Secondary_Locations_Bool_Exp>>;
  external_entity?: InputMaybe<External_Entity_Bool_Exp>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  request?: InputMaybe<Request_Bool_Exp>;
  request_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "request_secondary_locations" */
export enum Request_Secondary_Locations_Constraint {
  /** unique or primary key constraint on columns "request_id", "externalentity_id" */
  RequestSecondaryLocatiRequestIdExternalentit_2cec62f9Uniq = 'request_secondary_locati_request_id_externalentit_2cec62f9_uniq',
  /** unique or primary key constraint on columns "id" */
  RequestSecondaryLocationsPkey = 'request_secondary_locations_pkey'
}

/** input type for incrementing numeric columns in table "request_secondary_locations" */
export type Request_Secondary_Locations_Inc_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "request_secondary_locations" */
export type Request_Secondary_Locations_Insert_Input = {
  external_entity?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  request?: InputMaybe<Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Request_Secondary_Locations_Max_Fields = {
  __typename?: 'request_secondary_locations_max_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Max_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Request_Secondary_Locations_Min_Fields = {
  __typename?: 'request_secondary_locations_min_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Min_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "request_secondary_locations" */
export type Request_Secondary_Locations_Mutation_Response = {
  __typename?: 'request_secondary_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Request_Secondary_Locations>;
};

/** on_conflict condition type for table "request_secondary_locations" */
export type Request_Secondary_Locations_On_Conflict = {
  constraint: Request_Secondary_Locations_Constraint;
  update_columns?: Array<Request_Secondary_Locations_Update_Column>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "request_secondary_locations". */
export type Request_Secondary_Locations_Order_By = {
  external_entity?: InputMaybe<External_Entity_Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request?: InputMaybe<Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request_secondary_locations */
export type Request_Secondary_Locations_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "request_secondary_locations" */
export enum Request_Secondary_Locations_Select_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id'
}

/** input type for updating data in table "request_secondary_locations" */
export type Request_Secondary_Locations_Set_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Request_Secondary_Locations_Stddev_Fields = {
  __typename?: 'request_secondary_locations_stddev_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Stddev_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Request_Secondary_Locations_Stddev_Pop_Fields = {
  __typename?: 'request_secondary_locations_stddev_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Stddev_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Request_Secondary_Locations_Stddev_Samp_Fields = {
  __typename?: 'request_secondary_locations_stddev_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Stddev_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "request_secondary_locations" */
export type Request_Secondary_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Request_Secondary_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Request_Secondary_Locations_Stream_Cursor_Value_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Request_Secondary_Locations_Sum_Fields = {
  __typename?: 'request_secondary_locations_sum_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Sum_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** update columns of table "request_secondary_locations" */
export enum Request_Secondary_Locations_Update_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id'
}

export type Request_Secondary_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Request_Secondary_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Request_Secondary_Locations_Set_Input>;
  where: Request_Secondary_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Request_Secondary_Locations_Var_Pop_Fields = {
  __typename?: 'request_secondary_locations_var_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Var_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Request_Secondary_Locations_Var_Samp_Fields = {
  __typename?: 'request_secondary_locations_var_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Var_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Request_Secondary_Locations_Variance_Fields = {
  __typename?: 'request_secondary_locations_variance_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "request_secondary_locations" */
export type Request_Secondary_Locations_Variance_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
};

/** select columns of table "request" */
export enum Request_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ColorCode = 'color_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsPartial = 'is_partial',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LaboratoryId = 'laboratory_id',
  /** column name */
  ParentRequestId = 'parent_request_id',
  /** column name */
  PrimaryLocationId = 'primary_location_id',
  /** column name */
  RecordedAtId = 'recorded_at_id',
  /** column name */
  RejectionPercent = 'rejection_percent',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  TestForId = 'test_for_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on',
  /** column name */
  WithdrawSampleOn = 'withdraw_sample_on'
}

/** input type for updating data in table "request" */
export type Request_Set_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  color_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_partial?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
  parent_request_id?: InputMaybe<Scalars['bigint']>;
  primary_location_id?: InputMaybe<Scalars['bigint']>;
  recorded_at_id?: InputMaybe<Scalars['bigint']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  withdraw_sample_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Request_Stddev_Fields = {
  __typename?: 'request_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
  parent_request_id?: Maybe<Scalars['Float']>;
  primary_location_id?: Maybe<Scalars['Float']>;
  recorded_at_id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "request" */
export type Request_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Request_Stddev_Pop_Fields = {
  __typename?: 'request_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
  parent_request_id?: Maybe<Scalars['Float']>;
  primary_location_id?: Maybe<Scalars['Float']>;
  recorded_at_id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "request" */
export type Request_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Request_Stddev_Samp_Fields = {
  __typename?: 'request_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
  parent_request_id?: Maybe<Scalars['Float']>;
  primary_location_id?: Maybe<Scalars['Float']>;
  recorded_at_id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "request" */
export type Request_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "request" */
export type Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Request_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  color_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_partial?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  laboratory_id?: InputMaybe<Scalars['bigint']>;
  parent_request_id?: InputMaybe<Scalars['bigint']>;
  primary_location_id?: InputMaybe<Scalars['bigint']>;
  recorded_at_id?: InputMaybe<Scalars['bigint']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  withdraw_sample_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Request_Sum_Fields = {
  __typename?: 'request_sum_fields';
  category_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  laboratory_id?: Maybe<Scalars['bigint']>;
  parent_request_id?: Maybe<Scalars['bigint']>;
  primary_location_id?: Maybe<Scalars['bigint']>;
  recorded_at_id?: Maybe<Scalars['bigint']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  test_for_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "request" */
export type Request_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "request_templates" */
export type Request_Templates = {
  __typename?: 'request_templates';
  id: Scalars['bigint'];
  /** An object relationship */
  request: Request;
  request_id: Scalars['bigint'];
  /** An object relationship */
  template: Template;
  template_id: Scalars['bigint'];
};

/** aggregated selection of "request_templates" */
export type Request_Templates_Aggregate = {
  __typename?: 'request_templates_aggregate';
  aggregate?: Maybe<Request_Templates_Aggregate_Fields>;
  nodes: Array<Request_Templates>;
};

/** aggregate fields of "request_templates" */
export type Request_Templates_Aggregate_Fields = {
  __typename?: 'request_templates_aggregate_fields';
  avg?: Maybe<Request_Templates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Request_Templates_Max_Fields>;
  min?: Maybe<Request_Templates_Min_Fields>;
  stddev?: Maybe<Request_Templates_Stddev_Fields>;
  stddev_pop?: Maybe<Request_Templates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Request_Templates_Stddev_Samp_Fields>;
  sum?: Maybe<Request_Templates_Sum_Fields>;
  var_pop?: Maybe<Request_Templates_Var_Pop_Fields>;
  var_samp?: Maybe<Request_Templates_Var_Samp_Fields>;
  variance?: Maybe<Request_Templates_Variance_Fields>;
};


/** aggregate fields of "request_templates" */
export type Request_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Request_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "request_templates" */
export type Request_Templates_Aggregate_Order_By = {
  avg?: InputMaybe<Request_Templates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Request_Templates_Max_Order_By>;
  min?: InputMaybe<Request_Templates_Min_Order_By>;
  stddev?: InputMaybe<Request_Templates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Request_Templates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Request_Templates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Request_Templates_Sum_Order_By>;
  var_pop?: InputMaybe<Request_Templates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Request_Templates_Var_Samp_Order_By>;
  variance?: InputMaybe<Request_Templates_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "request_templates" */
export type Request_Templates_Arr_Rel_Insert_Input = {
  data: Array<Request_Templates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Request_Templates_On_Conflict>;
};

/** aggregate avg on columns */
export type Request_Templates_Avg_Fields = {
  __typename?: 'request_templates_avg_fields';
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "request_templates" */
export type Request_Templates_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "request_templates". All fields are combined with a logical 'AND'. */
export type Request_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Request_Templates_Bool_Exp>>;
  _not?: InputMaybe<Request_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Request_Templates_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  request?: InputMaybe<Request_Bool_Exp>;
  request_id?: InputMaybe<Bigint_Comparison_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "request_templates" */
export enum Request_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequestTemplatesPkey = 'request_templates_pkey',
  /** unique or primary key constraint on columns "template_id", "request_id" */
  RequestTemplatesRequestIdTemplateId_5c2a2805Uniq = 'request_templates_request_id_template_id_5c2a2805_uniq'
}

/** input type for incrementing numeric columns in table "request_templates" */
export type Request_Templates_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "request_templates" */
export type Request_Templates_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  request?: InputMaybe<Request_Obj_Rel_Insert_Input>;
  request_id?: InputMaybe<Scalars['bigint']>;
  template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Request_Templates_Max_Fields = {
  __typename?: 'request_templates_max_fields';
  id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "request_templates" */
export type Request_Templates_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Request_Templates_Min_Fields = {
  __typename?: 'request_templates_min_fields';
  id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "request_templates" */
export type Request_Templates_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "request_templates" */
export type Request_Templates_Mutation_Response = {
  __typename?: 'request_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Request_Templates>;
};

/** on_conflict condition type for table "request_templates" */
export type Request_Templates_On_Conflict = {
  constraint: Request_Templates_Constraint;
  update_columns?: Array<Request_Templates_Update_Column>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "request_templates". */
export type Request_Templates_Order_By = {
  id?: InputMaybe<Order_By>;
  request?: InputMaybe<Request_Order_By>;
  request_id?: InputMaybe<Order_By>;
  template?: InputMaybe<Template_Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request_templates */
export type Request_Templates_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "request_templates" */
export enum Request_Templates_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  TemplateId = 'template_id'
}

/** input type for updating data in table "request_templates" */
export type Request_Templates_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Request_Templates_Stddev_Fields = {
  __typename?: 'request_templates_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "request_templates" */
export type Request_Templates_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Request_Templates_Stddev_Pop_Fields = {
  __typename?: 'request_templates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "request_templates" */
export type Request_Templates_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Request_Templates_Stddev_Samp_Fields = {
  __typename?: 'request_templates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "request_templates" */
export type Request_Templates_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "request_templates" */
export type Request_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Request_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Request_Templates_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  request_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Request_Templates_Sum_Fields = {
  __typename?: 'request_templates_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  request_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "request_templates" */
export type Request_Templates_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "request_templates" */
export enum Request_Templates_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RequestId = 'request_id',
  /** column name */
  TemplateId = 'template_id'
}

export type Request_Templates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Request_Templates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Request_Templates_Set_Input>;
  where: Request_Templates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Request_Templates_Var_Pop_Fields = {
  __typename?: 'request_templates_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "request_templates" */
export type Request_Templates_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Request_Templates_Var_Samp_Fields = {
  __typename?: 'request_templates_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "request_templates" */
export type Request_Templates_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Request_Templates_Variance_Fields = {
  __typename?: 'request_templates_variance_fields';
  id?: Maybe<Scalars['Float']>;
  request_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "request_templates" */
export type Request_Templates_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  request_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "request" */
export enum Request_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ColorCode = 'color_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsPartial = 'is_partial',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LaboratoryId = 'laboratory_id',
  /** column name */
  ParentRequestId = 'parent_request_id',
  /** column name */
  PrimaryLocationId = 'primary_location_id',
  /** column name */
  RecordedAtId = 'recorded_at_id',
  /** column name */
  RejectionPercent = 'rejection_percent',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  TestForId = 'test_for_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on',
  /** column name */
  WithdrawSampleOn = 'withdraw_sample_on'
}

export type Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Request_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Request_Set_Input>;
  where: Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Request_Var_Pop_Fields = {
  __typename?: 'request_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
  parent_request_id?: Maybe<Scalars['Float']>;
  primary_location_id?: Maybe<Scalars['Float']>;
  recorded_at_id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "request" */
export type Request_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Request_Var_Samp_Fields = {
  __typename?: 'request_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
  parent_request_id?: Maybe<Scalars['Float']>;
  primary_location_id?: Maybe<Scalars['Float']>;
  recorded_at_id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "request" */
export type Request_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Request_Variance_Fields = {
  __typename?: 'request_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  laboratory_id?: Maybe<Scalars['Float']>;
  parent_request_id?: Maybe<Scalars['Float']>;
  primary_location_id?: Maybe<Scalars['Float']>;
  recorded_at_id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "request" */
export type Request_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  laboratory_id?: InputMaybe<Order_By>;
  parent_request_id?: InputMaybe<Order_By>;
  primary_location_id?: InputMaybe<Order_By>;
  recorded_at_id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "result" */
export type Result = {
  __typename?: 'result';
  codename: Scalars['String'];
  color_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  comments: Array<Result_Comment>;
  /** An aggregate relationship */
  comments_aggregate: Result_Comment_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  department?: Maybe<External_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  description: Scalars['String'];
  /** An array relationship */
  evaluations: Array<Result_Evaluation>;
  /** An aggregate relationship */
  evaluations_aggregate: Result_Evaluation_Aggregate;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An array relationship */
  observations: Array<Result_Observation>;
  /** An aggregate relationship */
  observations_aggregate: Result_Observation_Aggregate;
  posted_on?: Maybe<Scalars['date']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  rejection_reason?: Maybe<Scalars['String']>;
  report_id?: Maybe<Scalars['bigint']>;
  result_grade?: Maybe<Scalars['String']>;
  /** An array relationship */
  result_media: Array<Result_Media>;
  /** An aggregate relationship */
  result_media_aggregate: Result_Media_Aggregate;
  /** An object relationship */
  sample: Sample;
  sample_id: Scalars['bigint'];
  send_whatsapp_msg: Scalars['Boolean'];
  /** An object relationship */
  template: Template;
  template_id: Scalars['bigint'];
  /** An object relationship */
  test_request: Request;
  test_request_id: Scalars['bigint'];
  /** An array relationship */
  transition_logs: Array<Transition_History>;
  /** An aggregate relationship */
  transition_logs_aggregate: Transition_History_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  workflow_states: Array<Entity_State>;
  /** An aggregate relationship */
  workflow_states_aggregate: Entity_State_Aggregate;
};


/** columns and relationships of "result" */
export type ResultCommentsArgs = {
  distinct_on?: InputMaybe<Array<Result_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Comment_Order_By>>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Comment_Order_By>>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultEvaluationsArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultEvaluations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "result" */
export type ResultObservationsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultResult_MediaArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultResult_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultTransition_LogsArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultTransition_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultWorkflow_StatesArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


/** columns and relationships of "result" */
export type ResultWorkflow_States_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};

/** aggregated selection of "result" */
export type Result_Aggregate = {
  __typename?: 'result_aggregate';
  aggregate?: Maybe<Result_Aggregate_Fields>;
  nodes: Array<Result>;
};

/** aggregate fields of "result" */
export type Result_Aggregate_Fields = {
  __typename?: 'result_aggregate_fields';
  avg?: Maybe<Result_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Max_Fields>;
  min?: Maybe<Result_Min_Fields>;
  stddev?: Maybe<Result_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Sum_Fields>;
  var_pop?: Maybe<Result_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Var_Samp_Fields>;
  variance?: Maybe<Result_Variance_Fields>;
};


/** aggregate fields of "result" */
export type Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result" */
export type Result_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Max_Order_By>;
  min?: InputMaybe<Result_Min_Order_By>;
  stddev?: InputMaybe<Result_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Result_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "result" */
export type Result_Arr_Rel_Insert_Input = {
  data: Array<Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Avg_Fields = {
  __typename?: 'result_avg_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result" */
export type Result_Avg_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result". All fields are combined with a logical 'AND'. */
export type Result_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Bool_Exp>>;
  _not?: InputMaybe<Result_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  color_code?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Result_Comment_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<External_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  evaluations?: InputMaybe<Result_Evaluation_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<Result_Observation_Bool_Exp>;
  posted_on?: InputMaybe<Date_Comparison_Exp>;
  rejection_percent?: InputMaybe<Numeric_Comparison_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  report_id?: InputMaybe<Bigint_Comparison_Exp>;
  result_grade?: InputMaybe<String_Comparison_Exp>;
  result_media?: InputMaybe<Result_Media_Bool_Exp>;
  sample?: InputMaybe<Sample_Bool_Exp>;
  sample_id?: InputMaybe<Bigint_Comparison_Exp>;
  send_whatsapp_msg?: InputMaybe<Boolean_Comparison_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
  test_request?: InputMaybe<Request_Bool_Exp>;
  test_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  transition_logs?: InputMaybe<Transition_History_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  workflow_states?: InputMaybe<Entity_State_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "result". All fields are combined with a logical 'AND'. */
export type Result_Bool_Exp_Remote_Rel_Shared_Entityresult = {
  _and?: InputMaybe<Array<Result_Bool_Exp>>;
  _not?: InputMaybe<Result_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityresult>;
  color_code?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Result_Comment_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<External_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  evaluations?: InputMaybe<Result_Evaluation_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<Result_Observation_Bool_Exp>;
  posted_on?: InputMaybe<Date_Comparison_Exp>;
  rejection_percent?: InputMaybe<Numeric_Comparison_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  report_id?: InputMaybe<Bigint_Comparison_Exp>;
  result_grade?: InputMaybe<String_Comparison_Exp>;
  result_media?: InputMaybe<Result_Media_Bool_Exp>;
  sample?: InputMaybe<Sample_Bool_Exp>;
  sample_id?: InputMaybe<Bigint_Comparison_Exp>;
  send_whatsapp_msg?: InputMaybe<Boolean_Comparison_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
  test_request?: InputMaybe<Request_Bool_Exp>;
  test_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  transition_logs?: InputMaybe<Transition_History_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  workflow_states?: InputMaybe<Entity_State_Bool_Exp>;
};

/** columns and relationships of "result_comment" */
export type Result_Comment = {
  __typename?: 'result_comment';
  comment: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by: Array<Base_User>;
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  result: Result;
  result_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "result_comment" */
export type Result_CommentCreated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Result_Commentcreated_By>;
};

/** aggregated selection of "result_comment" */
export type Result_Comment_Aggregate = {
  __typename?: 'result_comment_aggregate';
  aggregate?: Maybe<Result_Comment_Aggregate_Fields>;
  nodes: Array<Result_Comment>;
};

/** aggregate fields of "result_comment" */
export type Result_Comment_Aggregate_Fields = {
  __typename?: 'result_comment_aggregate_fields';
  avg?: Maybe<Result_Comment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Comment_Max_Fields>;
  min?: Maybe<Result_Comment_Min_Fields>;
  stddev?: Maybe<Result_Comment_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Comment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Comment_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Comment_Sum_Fields>;
  var_pop?: Maybe<Result_Comment_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Comment_Var_Samp_Fields>;
  variance?: Maybe<Result_Comment_Variance_Fields>;
};


/** aggregate fields of "result_comment" */
export type Result_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_comment" */
export type Result_Comment_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Comment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Comment_Max_Order_By>;
  min?: InputMaybe<Result_Comment_Min_Order_By>;
  stddev?: InputMaybe<Result_Comment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Comment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Comment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Comment_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Comment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Comment_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Comment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_comment" */
export type Result_Comment_Arr_Rel_Insert_Input = {
  data: Array<Result_Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Comment_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Comment_Avg_Fields = {
  __typename?: 'result_comment_avg_fields';
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_comment" */
export type Result_Comment_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_comment". All fields are combined with a logical 'AND'. */
export type Result_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Comment_Bool_Exp>>;
  _not?: InputMaybe<Result_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Comment_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  result?: InputMaybe<Result_Bool_Exp>;
  result_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_comment" */
export enum Result_Comment_Constraint {
  /** unique or primary key constraint on columns "id" */
  ResultCommentPkey = 'result_comment_pkey'
}

/** input type for incrementing numeric columns in table "result_comment" */
export type Result_Comment_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  result_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "result_comment" */
export type Result_Comment_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Result_Obj_Rel_Insert_Input>;
  result_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Result_Comment_Max_Fields = {
  __typename?: 'result_comment_max_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "result_comment" */
export type Result_Comment_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Comment_Min_Fields = {
  __typename?: 'result_comment_min_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "result_comment" */
export type Result_Comment_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result_comment" */
export type Result_Comment_Mutation_Response = {
  __typename?: 'result_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result_Comment>;
};

/** on_conflict condition type for table "result_comment" */
export type Result_Comment_On_Conflict = {
  constraint: Result_Comment_Constraint;
  update_columns?: Array<Result_Comment_Update_Column>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "result_comment". */
export type Result_Comment_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result?: InputMaybe<Result_Order_By>;
  result_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: result_comment */
export type Result_Comment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "result_comment" */
export enum Result_Comment_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "result_comment" */
export type Result_Comment_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Result_Comment_Stddev_Fields = {
  __typename?: 'result_comment_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_comment" */
export type Result_Comment_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Comment_Stddev_Pop_Fields = {
  __typename?: 'result_comment_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_comment" */
export type Result_Comment_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Comment_Stddev_Samp_Fields = {
  __typename?: 'result_comment_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_comment" */
export type Result_Comment_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result_comment" */
export type Result_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Comment_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Result_Comment_Sum_Fields = {
  __typename?: 'result_comment_sum_fields';
  id?: Maybe<Scalars['Int']>;
  result_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "result_comment" */
export type Result_Comment_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** update columns of table "result_comment" */
export enum Result_Comment_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Result_Comment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Comment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Comment_Set_Input>;
  where: Result_Comment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Comment_Var_Pop_Fields = {
  __typename?: 'result_comment_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_comment" */
export type Result_Comment_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Comment_Var_Samp_Fields = {
  __typename?: 'result_comment_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_comment" */
export type Result_Comment_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Comment_Variance_Fields = {
  __typename?: 'result_comment_variance_fields';
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_comment" */
export type Result_Comment_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "result" */
export enum Result_Constraint {
  /** unique or primary key constraint on columns "codename" */
  ResultCodenameKey = 'result_codename_key',
  /** unique or primary key constraint on columns "id" */
  ResultPkey = 'result_pkey',
  /** unique or primary key constraint on columns "template_id", "sample_id", "test_request_id" */
  ResultSampleIdTemplateIdTestRequestIdA9d19a84Uniq = 'result_sample_id_template_id_test_request_id_a9d19a84_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Result_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Result_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Result_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "result_evaluation" */
export type Result_Evaluation = {
  __typename?: 'result_evaluation';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  evaluated_tags: Array<Result_Evaluation_Evaluated_Tags>;
  /** An aggregate relationship */
  evaluated_tags_aggregate: Result_Evaluation_Evaluated_Tags_Aggregate;
  id: Scalars['bigint'];
  is_valid?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  observation?: Maybe<Result_Observation>;
  observation_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  quality_parameter?: Maybe<Quality_Parameter>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  result: Result;
  result_id: Scalars['bigint'];
  /** An object relationship */
  template_evaluation: Template_Evaluation;
  template_evaluation_id: Scalars['bigint'];
  /** An object relationship */
  template_parameter?: Maybe<Template_Parameter>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  value: Scalars['float8'];
};


/** columns and relationships of "result_evaluation" */
export type Result_EvaluationEvaluated_TagsArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};


/** columns and relationships of "result_evaluation" */
export type Result_EvaluationEvaluated_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};

/** aggregated selection of "result_evaluation" */
export type Result_Evaluation_Aggregate = {
  __typename?: 'result_evaluation_aggregate';
  aggregate?: Maybe<Result_Evaluation_Aggregate_Fields>;
  nodes: Array<Result_Evaluation>;
};

/** aggregate fields of "result_evaluation" */
export type Result_Evaluation_Aggregate_Fields = {
  __typename?: 'result_evaluation_aggregate_fields';
  avg?: Maybe<Result_Evaluation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Evaluation_Max_Fields>;
  min?: Maybe<Result_Evaluation_Min_Fields>;
  stddev?: Maybe<Result_Evaluation_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Evaluation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Evaluation_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Evaluation_Sum_Fields>;
  var_pop?: Maybe<Result_Evaluation_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Evaluation_Var_Samp_Fields>;
  variance?: Maybe<Result_Evaluation_Variance_Fields>;
};


/** aggregate fields of "result_evaluation" */
export type Result_Evaluation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_evaluation" */
export type Result_Evaluation_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Evaluation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Evaluation_Max_Order_By>;
  min?: InputMaybe<Result_Evaluation_Min_Order_By>;
  stddev?: InputMaybe<Result_Evaluation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Evaluation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Evaluation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Evaluation_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Evaluation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Evaluation_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Evaluation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_evaluation" */
export type Result_Evaluation_Arr_Rel_Insert_Input = {
  data: Array<Result_Evaluation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Evaluation_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Evaluation_Avg_Fields = {
  __typename?: 'result_evaluation_avg_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_evaluation" */
export type Result_Evaluation_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_evaluation". All fields are combined with a logical 'AND'. */
export type Result_Evaluation_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Evaluation_Bool_Exp>>;
  _not?: InputMaybe<Result_Evaluation_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Evaluation_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evaluated_tags?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_valid?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  observation?: InputMaybe<Result_Observation_Bool_Exp>;
  observation_id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_parameter?: InputMaybe<Quality_Parameter_Bool_Exp>;
  quality_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  result?: InputMaybe<Result_Bool_Exp>;
  result_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_evaluation?: InputMaybe<Template_Evaluation_Bool_Exp>;
  template_evaluation_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_parameter?: InputMaybe<Template_Parameter_Bool_Exp>;
  template_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_evaluation" */
export enum Result_Evaluation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ResultEvaluationPkey = 'result_evaluation_pkey'
}

/** columns and relationships of "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags = {
  __typename?: 'result_evaluation_evaluated_tags';
  /** An object relationship */
  evaluation_tag: Evaluation_Tag;
  evaluationtag_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  result_evaluation: Result_Evaluation;
  resultevaluation_id: Scalars['bigint'];
};

/** aggregated selection of "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Aggregate = {
  __typename?: 'result_evaluation_evaluated_tags_aggregate';
  aggregate?: Maybe<Result_Evaluation_Evaluated_Tags_Aggregate_Fields>;
  nodes: Array<Result_Evaluation_Evaluated_Tags>;
};

/** aggregate fields of "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Aggregate_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_aggregate_fields';
  avg?: Maybe<Result_Evaluation_Evaluated_Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Evaluation_Evaluated_Tags_Max_Fields>;
  min?: Maybe<Result_Evaluation_Evaluated_Tags_Min_Fields>;
  stddev?: Maybe<Result_Evaluation_Evaluated_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Evaluation_Evaluated_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Evaluation_Evaluated_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Evaluation_Evaluated_Tags_Sum_Fields>;
  var_pop?: Maybe<Result_Evaluation_Evaluated_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Evaluation_Evaluated_Tags_Var_Samp_Fields>;
  variance?: Maybe<Result_Evaluation_Evaluated_Tags_Variance_Fields>;
};


/** aggregate fields of "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Evaluation_Evaluated_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Evaluation_Evaluated_Tags_Max_Order_By>;
  min?: InputMaybe<Result_Evaluation_Evaluated_Tags_Min_Order_By>;
  stddev?: InputMaybe<Result_Evaluation_Evaluated_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Evaluation_Evaluated_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Evaluation_Evaluated_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Evaluation_Evaluated_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Evaluation_Evaluated_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Evaluation_Evaluated_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Evaluation_Evaluated_Tags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Arr_Rel_Insert_Input = {
  data: Array<Result_Evaluation_Evaluated_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Evaluation_Evaluated_Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Evaluation_Evaluated_Tags_Avg_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_avg_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultevaluation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Avg_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_evaluation_evaluated_tags". All fields are combined with a logical 'AND'. */
export type Result_Evaluation_Evaluated_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Bool_Exp>>;
  _not?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Bool_Exp>>;
  evaluation_tag?: InputMaybe<Evaluation_Tag_Bool_Exp>;
  evaluationtag_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  result_evaluation?: InputMaybe<Result_Evaluation_Bool_Exp>;
  resultevaluation_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_evaluation_evaluated_tags" */
export enum Result_Evaluation_Evaluated_Tags_Constraint {
  /** unique or primary key constraint on columns "evaluationtag_id", "resultevaluation_id" */
  ResultEvaluationEvaluaResultevaluationIdEvalEf332c02Uniq = 'result_evaluation_evalua_resultevaluation_id_eval_ef332c02_uniq',
  /** unique or primary key constraint on columns "id" */
  ResultEvaluationEvaluatedTagsPkey = 'result_evaluation_evaluated_tags_pkey'
}

/** input type for incrementing numeric columns in table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Inc_Input = {
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  resultevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Insert_Input = {
  evaluation_tag?: InputMaybe<Evaluation_Tag_Obj_Rel_Insert_Input>;
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  result_evaluation?: InputMaybe<Result_Evaluation_Obj_Rel_Insert_Input>;
  resultevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Result_Evaluation_Evaluated_Tags_Max_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_max_fields';
  evaluationtag_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  resultevaluation_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Max_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Evaluation_Evaluated_Tags_Min_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_min_fields';
  evaluationtag_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  resultevaluation_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Min_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Mutation_Response = {
  __typename?: 'result_evaluation_evaluated_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result_Evaluation_Evaluated_Tags>;
};

/** on_conflict condition type for table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_On_Conflict = {
  constraint: Result_Evaluation_Evaluated_Tags_Constraint;
  update_columns?: Array<Result_Evaluation_Evaluated_Tags_Update_Column>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "result_evaluation_evaluated_tags". */
export type Result_Evaluation_Evaluated_Tags_Order_By = {
  evaluation_tag?: InputMaybe<Evaluation_Tag_Order_By>;
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_evaluation?: InputMaybe<Result_Evaluation_Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: result_evaluation_evaluated_tags */
export type Result_Evaluation_Evaluated_Tags_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "result_evaluation_evaluated_tags" */
export enum Result_Evaluation_Evaluated_Tags_Select_Column {
  /** column name */
  EvaluationtagId = 'evaluationtag_id',
  /** column name */
  Id = 'id',
  /** column name */
  ResultevaluationId = 'resultevaluation_id'
}

/** input type for updating data in table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Set_Input = {
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  resultevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Result_Evaluation_Evaluated_Tags_Stddev_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_stddev_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultevaluation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Stddev_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Evaluation_Evaluated_Tags_Stddev_Pop_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_stddev_pop_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultevaluation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Stddev_Pop_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Evaluation_Evaluated_Tags_Stddev_Samp_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_stddev_samp_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultevaluation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Stddev_Samp_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Evaluation_Evaluated_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Evaluation_Evaluated_Tags_Stream_Cursor_Value_Input = {
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  resultevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Result_Evaluation_Evaluated_Tags_Sum_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_sum_fields';
  evaluationtag_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  resultevaluation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Sum_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** update columns of table "result_evaluation_evaluated_tags" */
export enum Result_Evaluation_Evaluated_Tags_Update_Column {
  /** column name */
  EvaluationtagId = 'evaluationtag_id',
  /** column name */
  Id = 'id',
  /** column name */
  ResultevaluationId = 'resultevaluation_id'
}

export type Result_Evaluation_Evaluated_Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Evaluation_Evaluated_Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Evaluation_Evaluated_Tags_Set_Input>;
  where: Result_Evaluation_Evaluated_Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Evaluation_Evaluated_Tags_Var_Pop_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_var_pop_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultevaluation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Var_Pop_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Evaluation_Evaluated_Tags_Var_Samp_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_var_samp_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultevaluation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Var_Samp_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Evaluation_Evaluated_Tags_Variance_Fields = {
  __typename?: 'result_evaluation_evaluated_tags_variance_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultevaluation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_evaluation_evaluated_tags" */
export type Result_Evaluation_Evaluated_Tags_Variance_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultevaluation_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "result_evaluation" */
export type Result_Evaluation_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "result_evaluation" */
export type Result_Evaluation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  evaluated_tags?: InputMaybe<Result_Evaluation_Evaluated_Tags_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Result_Observation_Obj_Rel_Insert_Input>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter?: InputMaybe<Quality_Parameter_Obj_Rel_Insert_Input>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result?: InputMaybe<Result_Obj_Rel_Insert_Input>;
  result_id?: InputMaybe<Scalars['bigint']>;
  template_evaluation?: InputMaybe<Template_Evaluation_Obj_Rel_Insert_Input>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_parameter?: InputMaybe<Template_Parameter_Obj_Rel_Insert_Input>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Result_Evaluation_Max_Fields = {
  __typename?: 'result_evaluation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['bigint']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  template_evaluation_id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "result_evaluation" */
export type Result_Evaluation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Evaluation_Min_Fields = {
  __typename?: 'result_evaluation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['bigint']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  template_evaluation_id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "result_evaluation" */
export type Result_Evaluation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result_evaluation" */
export type Result_Evaluation_Mutation_Response = {
  __typename?: 'result_evaluation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result_Evaluation>;
};

/** input type for inserting object relation for remote table "result_evaluation" */
export type Result_Evaluation_Obj_Rel_Insert_Input = {
  data: Result_Evaluation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Evaluation_On_Conflict>;
};

/** on_conflict condition type for table "result_evaluation" */
export type Result_Evaluation_On_Conflict = {
  constraint: Result_Evaluation_Constraint;
  update_columns?: Array<Result_Evaluation_Update_Column>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};

/** Ordering options when selecting data from "result_evaluation". */
export type Result_Evaluation_Order_By = {
  created_at?: InputMaybe<Order_By>;
  evaluated_tags_aggregate?: InputMaybe<Result_Evaluation_Evaluated_Tags_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_valid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation?: InputMaybe<Result_Observation_Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter?: InputMaybe<Quality_Parameter_Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result?: InputMaybe<Result_Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation?: InputMaybe<Template_Evaluation_Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter?: InputMaybe<Template_Parameter_Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: result_evaluation */
export type Result_Evaluation_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "result_evaluation" */
export enum Result_Evaluation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  Name = 'name',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  TemplateEvaluationId = 'template_evaluation_id',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "result_evaluation" */
export type Result_Evaluation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Result_Evaluation_Stddev_Fields = {
  __typename?: 'result_evaluation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_evaluation" */
export type Result_Evaluation_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Evaluation_Stddev_Pop_Fields = {
  __typename?: 'result_evaluation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_evaluation" */
export type Result_Evaluation_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Evaluation_Stddev_Samp_Fields = {
  __typename?: 'result_evaluation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_evaluation" */
export type Result_Evaluation_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result_evaluation" */
export type Result_Evaluation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Evaluation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Evaluation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Result_Evaluation_Sum_Fields = {
  __typename?: 'result_evaluation_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  observation_id?: Maybe<Scalars['bigint']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  template_evaluation_id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "result_evaluation" */
export type Result_Evaluation_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "result_evaluation" */
export enum Result_Evaluation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  Name = 'name',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  TemplateEvaluationId = 'template_evaluation_id',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Result_Evaluation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Evaluation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Evaluation_Set_Input>;
  where: Result_Evaluation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Evaluation_Var_Pop_Fields = {
  __typename?: 'result_evaluation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_evaluation" */
export type Result_Evaluation_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Evaluation_Var_Samp_Fields = {
  __typename?: 'result_evaluation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_evaluation" */
export type Result_Evaluation_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Evaluation_Variance_Fields = {
  __typename?: 'result_evaluation_variance_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_evaluation" */
export type Result_Evaluation_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "result" */
export type Result_Inc_Input = {
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  report_id?: InputMaybe<Scalars['bigint']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "result" */
export type Result_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  color_code?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Result_Comment_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  evaluations?: InputMaybe<Result_Evaluation_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Result_Observation_Arr_Rel_Insert_Input>;
  posted_on?: InputMaybe<Scalars['date']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  report_id?: InputMaybe<Scalars['bigint']>;
  result_grade?: InputMaybe<Scalars['String']>;
  result_media?: InputMaybe<Result_Media_Arr_Rel_Insert_Input>;
  sample?: InputMaybe<Sample_Obj_Rel_Insert_Input>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  send_whatsapp_msg?: InputMaybe<Scalars['Boolean']>;
  template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['bigint']>;
  test_request?: InputMaybe<Request_Obj_Rel_Insert_Input>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
  transition_logs?: InputMaybe<Transition_History_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  workflow_states?: InputMaybe<Entity_State_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Result_Max_Fields = {
  __typename?: 'result_max_fields';
  codename?: Maybe<Scalars['String']>;
  color_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  posted_on?: Maybe<Scalars['date']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  rejection_reason?: Maybe<Scalars['String']>;
  report_id?: Maybe<Scalars['bigint']>;
  result_grade?: Maybe<Scalars['String']>;
  sample_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  test_request_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "result" */
export type Result_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  color_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posted_on?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  result_grade?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "result_media" */
export type Result_Media = {
  __typename?: 'result_media';
  attachment_id: Scalars['bigint'];
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  media: Eagle_Media;
  name: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  result: Result;
  result_id: Scalars['bigint'];
};

/** aggregated selection of "result_media" */
export type Result_Media_Aggregate = {
  __typename?: 'result_media_aggregate';
  aggregate?: Maybe<Result_Media_Aggregate_Fields>;
  nodes: Array<Result_Media>;
};

/** aggregate fields of "result_media" */
export type Result_Media_Aggregate_Fields = {
  __typename?: 'result_media_aggregate_fields';
  avg?: Maybe<Result_Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Media_Max_Fields>;
  min?: Maybe<Result_Media_Min_Fields>;
  stddev?: Maybe<Result_Media_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Media_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Media_Sum_Fields>;
  var_pop?: Maybe<Result_Media_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Media_Var_Samp_Fields>;
  variance?: Maybe<Result_Media_Variance_Fields>;
};


/** aggregate fields of "result_media" */
export type Result_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_media" */
export type Result_Media_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Media_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Media_Max_Order_By>;
  min?: InputMaybe<Result_Media_Min_Order_By>;
  stddev?: InputMaybe<Result_Media_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Media_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Media_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Media_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Media_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Media_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Media_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_media" */
export type Result_Media_Arr_Rel_Insert_Input = {
  data: Array<Result_Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Media_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Media_Avg_Fields = {
  __typename?: 'result_media_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_media" */
export type Result_Media_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_media". All fields are combined with a logical 'AND'. */
export type Result_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Media_Bool_Exp>>;
  _not?: InputMaybe<Result_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Media_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  result?: InputMaybe<Result_Bool_Exp>;
  result_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_media" */
export enum Result_Media_Constraint {
  /** unique or primary key constraint on columns "codename" */
  ResultMediaCodenameKey = 'result_media_codename_key',
  /** unique or primary key constraint on columns "id" */
  ResultMediaPkey = 'result_media_pkey'
}

/** input type for incrementing numeric columns in table "result_media" */
export type Result_Media_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "result_media" */
export type Result_Media_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Result_Obj_Rel_Insert_Input>;
  result_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Result_Media_Max_Fields = {
  __typename?: 'result_media_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  result_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "result_media" */
export type Result_Media_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Media_Min_Fields = {
  __typename?: 'result_media_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  result_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "result_media" */
export type Result_Media_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result_media" */
export type Result_Media_Mutation_Response = {
  __typename?: 'result_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result_Media>;
};

/** on_conflict condition type for table "result_media" */
export type Result_Media_On_Conflict = {
  constraint: Result_Media_Constraint;
  update_columns?: Array<Result_Media_Update_Column>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "result_media". */
export type Result_Media_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  result?: InputMaybe<Result_Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: result_media */
export type Result_Media_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "result_media" */
export enum Result_Media_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Remark = 'remark',
  /** column name */
  ResultId = 'result_id'
}

/** input type for updating data in table "result_media" */
export type Result_Media_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  result_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Result_Media_Stddev_Fields = {
  __typename?: 'result_media_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_media" */
export type Result_Media_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Media_Stddev_Pop_Fields = {
  __typename?: 'result_media_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_media" */
export type Result_Media_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Media_Stddev_Samp_Fields = {
  __typename?: 'result_media_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_media" */
export type Result_Media_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result_media" */
export type Result_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Media_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  result_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Result_Media_Sum_Fields = {
  __typename?: 'result_media_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "result_media" */
export type Result_Media_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** update columns of table "result_media" */
export enum Result_Media_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Remark = 'remark',
  /** column name */
  ResultId = 'result_id'
}

export type Result_Media_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Media_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Media_Set_Input>;
  where: Result_Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Media_Var_Pop_Fields = {
  __typename?: 'result_media_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_media" */
export type Result_Media_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Media_Var_Samp_Fields = {
  __typename?: 'result_media_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_media" */
export type Result_Media_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Media_Variance_Fields = {
  __typename?: 'result_media_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_media" */
export type Result_Media_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Min_Fields = {
  __typename?: 'result_min_fields';
  codename?: Maybe<Scalars['String']>;
  color_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  posted_on?: Maybe<Scalars['date']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  rejection_reason?: Maybe<Scalars['String']>;
  report_id?: Maybe<Scalars['bigint']>;
  result_grade?: Maybe<Scalars['String']>;
  sample_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  test_request_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "result" */
export type Result_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  color_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posted_on?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  result_grade?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result" */
export type Result_Mutation_Response = {
  __typename?: 'result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result>;
};

/** input type for inserting object relation for remote table "result" */
export type Result_Obj_Rel_Insert_Input = {
  data: Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_On_Conflict>;
};

/** columns and relationships of "result_observation" */
export type Result_Observation = {
  __typename?: 'result_observation';
  /** An array relationship */
  attachments: Array<Result_Observation_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Result_Observation_Attachments_Aggregate;
  /** An object relationship */
  config_value?: Maybe<Template_Parameter_Config>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  evaluated_tags: Array<Result_Observation_Evaluated_Tags>;
  /** An aggregate relationship */
  evaluated_tags_aggregate: Result_Observation_Evaluated_Tags_Aggregate;
  id: Scalars['bigint'];
  is_valid?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  observation?: Maybe<Sample_Observation>;
  observation_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  quality_parameter: Quality_Parameter;
  quality_parameter_id: Scalars['bigint'];
  /** An object relationship */
  result: Result;
  result_id: Scalars['bigint'];
  /** An array relationship */
  row_evaluations: Array<Result_Evaluation>;
  /** An aggregate relationship */
  row_evaluations_aggregate: Result_Evaluation_Aggregate;
  /** An object relationship */
  template_parameter?: Maybe<Template_Parameter>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
  value: Scalars['float8'];
  value_date?: Maybe<Scalars['date']>;
  value_datetime?: Maybe<Scalars['timestamptz']>;
  value_text?: Maybe<Scalars['String']>;
  value_time?: Maybe<Scalars['time']>;
};


/** columns and relationships of "result_observation" */
export type Result_ObservationAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


/** columns and relationships of "result_observation" */
export type Result_ObservationAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


/** columns and relationships of "result_observation" */
export type Result_ObservationEvaluated_TagsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};


/** columns and relationships of "result_observation" */
export type Result_ObservationEvaluated_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};


/** columns and relationships of "result_observation" */
export type Result_ObservationRow_EvaluationsArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


/** columns and relationships of "result_observation" */
export type Result_ObservationRow_Evaluations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};

/** aggregated selection of "result_observation" */
export type Result_Observation_Aggregate = {
  __typename?: 'result_observation_aggregate';
  aggregate?: Maybe<Result_Observation_Aggregate_Fields>;
  nodes: Array<Result_Observation>;
};

/** aggregate fields of "result_observation" */
export type Result_Observation_Aggregate_Fields = {
  __typename?: 'result_observation_aggregate_fields';
  avg?: Maybe<Result_Observation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Observation_Max_Fields>;
  min?: Maybe<Result_Observation_Min_Fields>;
  stddev?: Maybe<Result_Observation_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Observation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Observation_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Observation_Sum_Fields>;
  var_pop?: Maybe<Result_Observation_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Observation_Var_Samp_Fields>;
  variance?: Maybe<Result_Observation_Variance_Fields>;
};


/** aggregate fields of "result_observation" */
export type Result_Observation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Observation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_observation" */
export type Result_Observation_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Observation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Observation_Max_Order_By>;
  min?: InputMaybe<Result_Observation_Min_Order_By>;
  stddev?: InputMaybe<Result_Observation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Observation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Observation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Observation_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Observation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Observation_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Observation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_observation" */
export type Result_Observation_Arr_Rel_Insert_Input = {
  data: Array<Result_Observation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Observation_On_Conflict>;
};

/** columns and relationships of "result_observation_attachments" */
export type Result_Observation_Attachments = {
  __typename?: 'result_observation_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Eagle_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  result_observation: Result_Observation;
  resultobservation_id: Scalars['bigint'];
};

/** aggregated selection of "result_observation_attachments" */
export type Result_Observation_Attachments_Aggregate = {
  __typename?: 'result_observation_attachments_aggregate';
  aggregate?: Maybe<Result_Observation_Attachments_Aggregate_Fields>;
  nodes: Array<Result_Observation_Attachments>;
};

/** aggregate fields of "result_observation_attachments" */
export type Result_Observation_Attachments_Aggregate_Fields = {
  __typename?: 'result_observation_attachments_aggregate_fields';
  avg?: Maybe<Result_Observation_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Observation_Attachments_Max_Fields>;
  min?: Maybe<Result_Observation_Attachments_Min_Fields>;
  stddev?: Maybe<Result_Observation_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Observation_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Observation_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Observation_Attachments_Sum_Fields>;
  var_pop?: Maybe<Result_Observation_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Observation_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Result_Observation_Attachments_Variance_Fields>;
};


/** aggregate fields of "result_observation_attachments" */
export type Result_Observation_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_observation_attachments" */
export type Result_Observation_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Observation_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Observation_Attachments_Max_Order_By>;
  min?: InputMaybe<Result_Observation_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Result_Observation_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Observation_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Observation_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Observation_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Observation_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Observation_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Observation_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_observation_attachments" */
export type Result_Observation_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Result_Observation_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Observation_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Observation_Attachments_Avg_Fields = {
  __typename?: 'result_observation_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_observation_attachments". All fields are combined with a logical 'AND'. */
export type Result_Observation_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Observation_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Observation_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  result_observation?: InputMaybe<Result_Observation_Bool_Exp>;
  resultobservation_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_observation_attachments" */
export enum Result_Observation_Attachments_Constraint {
  /** unique or primary key constraint on columns "resultobservation_id", "media_id" */
  ResultObservationAttacResultobservationIdMed_219345fdUniq = 'result_observation_attac_resultobservation_id_med_219345fd_uniq',
  /** unique or primary key constraint on columns "id" */
  ResultObservationAttachmentsPkey = 'result_observation_attachments_pkey'
}

/** input type for incrementing numeric columns in table "result_observation_attachments" */
export type Result_Observation_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "result_observation_attachments" */
export type Result_Observation_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  result_observation?: InputMaybe<Result_Observation_Obj_Rel_Insert_Input>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Result_Observation_Attachments_Max_Fields = {
  __typename?: 'result_observation_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  resultobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Observation_Attachments_Min_Fields = {
  __typename?: 'result_observation_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  resultobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result_observation_attachments" */
export type Result_Observation_Attachments_Mutation_Response = {
  __typename?: 'result_observation_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result_Observation_Attachments>;
};

/** on_conflict condition type for table "result_observation_attachments" */
export type Result_Observation_Attachments_On_Conflict = {
  constraint: Result_Observation_Attachments_Constraint;
  update_columns?: Array<Result_Observation_Attachments_Update_Column>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "result_observation_attachments". */
export type Result_Observation_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  result_observation?: InputMaybe<Result_Observation_Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: result_observation_attachments */
export type Result_Observation_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "result_observation_attachments" */
export enum Result_Observation_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  ResultobservationId = 'resultobservation_id'
}

/** input type for updating data in table "result_observation_attachments" */
export type Result_Observation_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Result_Observation_Attachments_Stddev_Fields = {
  __typename?: 'result_observation_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Observation_Attachments_Stddev_Pop_Fields = {
  __typename?: 'result_observation_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Observation_Attachments_Stddev_Samp_Fields = {
  __typename?: 'result_observation_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result_observation_attachments" */
export type Result_Observation_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Observation_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Observation_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Result_Observation_Attachments_Sum_Fields = {
  __typename?: 'result_observation_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  resultobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** update columns of table "result_observation_attachments" */
export enum Result_Observation_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  ResultobservationId = 'resultobservation_id'
}

export type Result_Observation_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Observation_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Observation_Attachments_Set_Input>;
  where: Result_Observation_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Observation_Attachments_Var_Pop_Fields = {
  __typename?: 'result_observation_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Observation_Attachments_Var_Samp_Fields = {
  __typename?: 'result_observation_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Observation_Attachments_Variance_Fields = {
  __typename?: 'result_observation_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_observation_attachments" */
export type Result_Observation_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Result_Observation_Avg_Fields = {
  __typename?: 'result_observation_avg_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_observation" */
export type Result_Observation_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_observation". All fields are combined with a logical 'AND'. */
export type Result_Observation_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Observation_Bool_Exp>>;
  _not?: InputMaybe<Result_Observation_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Observation_Bool_Exp>>;
  attachments?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
  config_value?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  evaluated_tags?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_valid?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  observation?: InputMaybe<Sample_Observation_Bool_Exp>;
  observation_id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_parameter?: InputMaybe<Quality_Parameter_Bool_Exp>;
  quality_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  result?: InputMaybe<Result_Bool_Exp>;
  result_id?: InputMaybe<Bigint_Comparison_Exp>;
  row_evaluations?: InputMaybe<Result_Evaluation_Bool_Exp>;
  template_parameter?: InputMaybe<Template_Parameter_Bool_Exp>;
  template_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
  value_date?: InputMaybe<Date_Comparison_Exp>;
  value_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  value_text?: InputMaybe<String_Comparison_Exp>;
  value_time?: InputMaybe<Time_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_observation" */
export enum Result_Observation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ResultObservationPkey = 'result_observation_pkey'
}

/** columns and relationships of "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags = {
  __typename?: 'result_observation_evaluated_tags';
  /** An object relationship */
  evaluation_tag: Evaluation_Tag;
  evaluationtag_id: Scalars['bigint'];
  id: Scalars['bigint'];
  resultobservation_id: Scalars['bigint'];
};

/** aggregated selection of "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Aggregate = {
  __typename?: 'result_observation_evaluated_tags_aggregate';
  aggregate?: Maybe<Result_Observation_Evaluated_Tags_Aggregate_Fields>;
  nodes: Array<Result_Observation_Evaluated_Tags>;
};

/** aggregate fields of "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Aggregate_Fields = {
  __typename?: 'result_observation_evaluated_tags_aggregate_fields';
  avg?: Maybe<Result_Observation_Evaluated_Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Result_Observation_Evaluated_Tags_Max_Fields>;
  min?: Maybe<Result_Observation_Evaluated_Tags_Min_Fields>;
  stddev?: Maybe<Result_Observation_Evaluated_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Result_Observation_Evaluated_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Result_Observation_Evaluated_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Result_Observation_Evaluated_Tags_Sum_Fields>;
  var_pop?: Maybe<Result_Observation_Evaluated_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Result_Observation_Evaluated_Tags_Var_Samp_Fields>;
  variance?: Maybe<Result_Observation_Evaluated_Tags_Variance_Fields>;
};


/** aggregate fields of "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Aggregate_Order_By = {
  avg?: InputMaybe<Result_Observation_Evaluated_Tags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Result_Observation_Evaluated_Tags_Max_Order_By>;
  min?: InputMaybe<Result_Observation_Evaluated_Tags_Min_Order_By>;
  stddev?: InputMaybe<Result_Observation_Evaluated_Tags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Result_Observation_Evaluated_Tags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Result_Observation_Evaluated_Tags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Result_Observation_Evaluated_Tags_Sum_Order_By>;
  var_pop?: InputMaybe<Result_Observation_Evaluated_Tags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Result_Observation_Evaluated_Tags_Var_Samp_Order_By>;
  variance?: InputMaybe<Result_Observation_Evaluated_Tags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Arr_Rel_Insert_Input = {
  data: Array<Result_Observation_Evaluated_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Observation_Evaluated_Tags_On_Conflict>;
};

/** aggregate avg on columns */
export type Result_Observation_Evaluated_Tags_Avg_Fields = {
  __typename?: 'result_observation_evaluated_tags_avg_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Avg_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "result_observation_evaluated_tags". All fields are combined with a logical 'AND'. */
export type Result_Observation_Evaluated_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Bool_Exp>>;
  _not?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Bool_Exp>>;
  evaluation_tag?: InputMaybe<Evaluation_Tag_Bool_Exp>;
  evaluationtag_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  resultobservation_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "result_observation_evaluated_tags" */
export enum Result_Observation_Evaluated_Tags_Constraint {
  /** unique or primary key constraint on columns "evaluationtag_id", "resultobservation_id" */
  ResultObservationEvaluResultobservationIdEva_8af6a31eUniq = 'result_observation_evalu_resultobservation_id_eva_8af6a31e_uniq',
  /** unique or primary key constraint on columns "id" */
  ResultObservationEvaluatedTagsPkey = 'result_observation_evaluated_tags_pkey'
}

/** input type for incrementing numeric columns in table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Inc_Input = {
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Insert_Input = {
  evaluation_tag?: InputMaybe<Evaluation_Tag_Obj_Rel_Insert_Input>;
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Result_Observation_Evaluated_Tags_Max_Fields = {
  __typename?: 'result_observation_evaluated_tags_max_fields';
  evaluationtag_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  resultobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Max_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Observation_Evaluated_Tags_Min_Fields = {
  __typename?: 'result_observation_evaluated_tags_min_fields';
  evaluationtag_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  resultobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Min_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Mutation_Response = {
  __typename?: 'result_observation_evaluated_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result_Observation_Evaluated_Tags>;
};

/** on_conflict condition type for table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_On_Conflict = {
  constraint: Result_Observation_Evaluated_Tags_Constraint;
  update_columns?: Array<Result_Observation_Evaluated_Tags_Update_Column>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "result_observation_evaluated_tags". */
export type Result_Observation_Evaluated_Tags_Order_By = {
  evaluation_tag?: InputMaybe<Evaluation_Tag_Order_By>;
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: result_observation_evaluated_tags */
export type Result_Observation_Evaluated_Tags_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "result_observation_evaluated_tags" */
export enum Result_Observation_Evaluated_Tags_Select_Column {
  /** column name */
  EvaluationtagId = 'evaluationtag_id',
  /** column name */
  Id = 'id',
  /** column name */
  ResultobservationId = 'resultobservation_id'
}

/** input type for updating data in table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Set_Input = {
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Result_Observation_Evaluated_Tags_Stddev_Fields = {
  __typename?: 'result_observation_evaluated_tags_stddev_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Stddev_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Observation_Evaluated_Tags_Stddev_Pop_Fields = {
  __typename?: 'result_observation_evaluated_tags_stddev_pop_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Stddev_Pop_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Observation_Evaluated_Tags_Stddev_Samp_Fields = {
  __typename?: 'result_observation_evaluated_tags_stddev_samp_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Stddev_Samp_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Observation_Evaluated_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Observation_Evaluated_Tags_Stream_Cursor_Value_Input = {
  evaluationtag_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  resultobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Result_Observation_Evaluated_Tags_Sum_Fields = {
  __typename?: 'result_observation_evaluated_tags_sum_fields';
  evaluationtag_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  resultobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Sum_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** update columns of table "result_observation_evaluated_tags" */
export enum Result_Observation_Evaluated_Tags_Update_Column {
  /** column name */
  EvaluationtagId = 'evaluationtag_id',
  /** column name */
  Id = 'id',
  /** column name */
  ResultobservationId = 'resultobservation_id'
}

export type Result_Observation_Evaluated_Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Observation_Evaluated_Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Observation_Evaluated_Tags_Set_Input>;
  where: Result_Observation_Evaluated_Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Observation_Evaluated_Tags_Var_Pop_Fields = {
  __typename?: 'result_observation_evaluated_tags_var_pop_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Var_Pop_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Observation_Evaluated_Tags_Var_Samp_Fields = {
  __typename?: 'result_observation_evaluated_tags_var_samp_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Var_Samp_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Observation_Evaluated_Tags_Variance_Fields = {
  __typename?: 'result_observation_evaluated_tags_variance_fields';
  evaluationtag_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  resultobservation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_observation_evaluated_tags" */
export type Result_Observation_Evaluated_Tags_Variance_Order_By = {
  evaluationtag_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resultobservation_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "result_observation" */
export type Result_Observation_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "result_observation" */
export type Result_Observation_Insert_Input = {
  attachments?: InputMaybe<Result_Observation_Attachments_Arr_Rel_Insert_Input>;
  config_value?: InputMaybe<Template_Parameter_Config_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  evaluated_tags?: InputMaybe<Result_Observation_Evaluated_Tags_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Sample_Observation_Obj_Rel_Insert_Input>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter?: InputMaybe<Quality_Parameter_Obj_Rel_Insert_Input>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result?: InputMaybe<Result_Obj_Rel_Insert_Input>;
  result_id?: InputMaybe<Scalars['bigint']>;
  row_evaluations?: InputMaybe<Result_Evaluation_Arr_Rel_Insert_Input>;
  template_parameter?: InputMaybe<Template_Parameter_Obj_Rel_Insert_Input>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  value_date?: InputMaybe<Scalars['date']>;
  value_datetime?: InputMaybe<Scalars['timestamptz']>;
  value_text?: InputMaybe<Scalars['String']>;
  value_time?: InputMaybe<Scalars['time']>;
};

/** aggregate max on columns */
export type Result_Observation_Max_Fields = {
  __typename?: 'result_observation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['bigint']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
  value_date?: Maybe<Scalars['date']>;
  value_datetime?: Maybe<Scalars['timestamptz']>;
  value_text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "result_observation" */
export type Result_Observation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_date?: InputMaybe<Order_By>;
  value_datetime?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Result_Observation_Min_Fields = {
  __typename?: 'result_observation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['bigint']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
  value_date?: Maybe<Scalars['date']>;
  value_datetime?: Maybe<Scalars['timestamptz']>;
  value_text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "result_observation" */
export type Result_Observation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_date?: InputMaybe<Order_By>;
  value_datetime?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "result_observation" */
export type Result_Observation_Mutation_Response = {
  __typename?: 'result_observation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Result_Observation>;
};

/** input type for inserting object relation for remote table "result_observation" */
export type Result_Observation_Obj_Rel_Insert_Input = {
  data: Result_Observation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Result_Observation_On_Conflict>;
};

/** on_conflict condition type for table "result_observation" */
export type Result_Observation_On_Conflict = {
  constraint: Result_Observation_Constraint;
  update_columns?: Array<Result_Observation_Update_Column>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};

/** Ordering options when selecting data from "result_observation". */
export type Result_Observation_Order_By = {
  attachments_aggregate?: InputMaybe<Result_Observation_Attachments_Aggregate_Order_By>;
  config_value?: InputMaybe<Template_Parameter_Config_Order_By>;
  created_at?: InputMaybe<Order_By>;
  evaluated_tags_aggregate?: InputMaybe<Result_Observation_Evaluated_Tags_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_valid?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation?: InputMaybe<Sample_Observation_Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter?: InputMaybe<Quality_Parameter_Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result?: InputMaybe<Result_Order_By>;
  result_id?: InputMaybe<Order_By>;
  row_evaluations_aggregate?: InputMaybe<Result_Evaluation_Aggregate_Order_By>;
  template_parameter?: InputMaybe<Template_Parameter_Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_date?: InputMaybe<Order_By>;
  value_datetime?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
  value_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: result_observation */
export type Result_Observation_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "result_observation" */
export enum Result_Observation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  Name = 'name',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueDate = 'value_date',
  /** column name */
  ValueDatetime = 'value_datetime',
  /** column name */
  ValueText = 'value_text',
  /** column name */
  ValueTime = 'value_time'
}

/** input type for updating data in table "result_observation" */
export type Result_Observation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  value_date?: InputMaybe<Scalars['date']>;
  value_datetime?: InputMaybe<Scalars['timestamptz']>;
  value_text?: InputMaybe<Scalars['String']>;
  value_time?: InputMaybe<Scalars['time']>;
};

/** aggregate stddev on columns */
export type Result_Observation_Stddev_Fields = {
  __typename?: 'result_observation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result_observation" */
export type Result_Observation_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Observation_Stddev_Pop_Fields = {
  __typename?: 'result_observation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result_observation" */
export type Result_Observation_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Observation_Stddev_Samp_Fields = {
  __typename?: 'result_observation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result_observation" */
export type Result_Observation_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result_observation" */
export type Result_Observation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Observation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Observation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  observation_id?: InputMaybe<Scalars['bigint']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  value_date?: InputMaybe<Scalars['date']>;
  value_datetime?: InputMaybe<Scalars['timestamptz']>;
  value_text?: InputMaybe<Scalars['String']>;
  value_time?: InputMaybe<Scalars['time']>;
};

/** aggregate sum on columns */
export type Result_Observation_Sum_Fields = {
  __typename?: 'result_observation_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  observation_id?: Maybe<Scalars['bigint']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "result_observation" */
export type Result_Observation_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "result_observation" */
export enum Result_Observation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  Name = 'name',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueDate = 'value_date',
  /** column name */
  ValueDatetime = 'value_datetime',
  /** column name */
  ValueText = 'value_text',
  /** column name */
  ValueTime = 'value_time'
}

export type Result_Observation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Observation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Observation_Set_Input>;
  where: Result_Observation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Observation_Var_Pop_Fields = {
  __typename?: 'result_observation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result_observation" */
export type Result_Observation_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Observation_Var_Samp_Fields = {
  __typename?: 'result_observation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result_observation" */
export type Result_Observation_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Observation_Variance_Fields = {
  __typename?: 'result_observation_variance_fields';
  id?: Maybe<Scalars['Float']>;
  observation_id?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result_observation" */
export type Result_Observation_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_id?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "result" */
export type Result_On_Conflict = {
  constraint: Result_Constraint;
  update_columns?: Array<Result_Update_Column>;
  where?: InputMaybe<Result_Bool_Exp>;
};

/** Ordering options when selecting data from "result". */
export type Result_Order_By = {
  codename?: InputMaybe<Order_By>;
  color_code?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Result_Comment_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department?: InputMaybe<External_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  evaluations_aggregate?: InputMaybe<Result_Evaluation_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Result_Observation_Aggregate_Order_By>;
  posted_on?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  result_grade?: InputMaybe<Order_By>;
  result_media_aggregate?: InputMaybe<Result_Media_Aggregate_Order_By>;
  sample?: InputMaybe<Sample_Order_By>;
  sample_id?: InputMaybe<Order_By>;
  send_whatsapp_msg?: InputMaybe<Order_By>;
  template?: InputMaybe<Template_Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request?: InputMaybe<Request_Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  transition_logs_aggregate?: InputMaybe<Transition_History_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  workflow_states_aggregate?: InputMaybe<Entity_State_Aggregate_Order_By>;
};

/** primary key columns input for table: result */
export type Result_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Result_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "result" */
export enum Result_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ColorCode = 'color_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PostedOn = 'posted_on',
  /** column name */
  RejectionPercent = 'rejection_percent',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ResultGrade = 'result_grade',
  /** column name */
  SampleId = 'sample_id',
  /** column name */
  SendWhatsappMsg = 'send_whatsapp_msg',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TestRequestId = 'test_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "result" */
export type Result_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  color_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  posted_on?: InputMaybe<Scalars['date']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  report_id?: InputMaybe<Scalars['bigint']>;
  result_grade?: InputMaybe<Scalars['String']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  send_whatsapp_msg?: InputMaybe<Scalars['Boolean']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Result_Stddev_Fields = {
  __typename?: 'result_stddev_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "result" */
export type Result_Stddev_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Result_Stddev_Pop_Fields = {
  __typename?: 'result_stddev_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "result" */
export type Result_Stddev_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Result_Stddev_Samp_Fields = {
  __typename?: 'result_stddev_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "result" */
export type Result_Stddev_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "result" */
export type Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Result_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  color_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  posted_on?: InputMaybe<Scalars['date']>;
  rejection_percent?: InputMaybe<Scalars['numeric']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  report_id?: InputMaybe<Scalars['bigint']>;
  result_grade?: InputMaybe<Scalars['String']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  send_whatsapp_msg?: InputMaybe<Scalars['Boolean']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Result_Sum_Fields = {
  __typename?: 'result_sum_fields';
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  rejection_percent?: Maybe<Scalars['numeric']>;
  report_id?: Maybe<Scalars['bigint']>;
  sample_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  test_request_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "result" */
export type Result_Sum_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** update columns of table "result" */
export enum Result_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  ColorCode = 'color_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PostedOn = 'posted_on',
  /** column name */
  RejectionPercent = 'rejection_percent',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ResultGrade = 'result_grade',
  /** column name */
  SampleId = 'sample_id',
  /** column name */
  SendWhatsappMsg = 'send_whatsapp_msg',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TestRequestId = 'test_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Result_Set_Input>;
  where: Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Result_Var_Pop_Fields = {
  __typename?: 'result_var_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "result" */
export type Result_Var_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Result_Var_Samp_Fields = {
  __typename?: 'result_var_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "result" */
export type Result_Var_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Result_Variance_Fields = {
  __typename?: 'result_variance_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rejection_percent?: Maybe<Scalars['Float']>;
  report_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "result" */
export type Result_Variance_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rejection_percent?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "role" */
export type Role = {
  __typename?: 'role';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  key: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  avg?: Maybe<Role_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
  stddev?: Maybe<Role_Stddev_Fields>;
  stddev_pop?: Maybe<Role_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Role_Stddev_Samp_Fields>;
  sum?: Maybe<Role_Sum_Fields>;
  var_pop?: Maybe<Role_Var_Pop_Fields>;
  var_samp?: Maybe<Role_Var_Samp_Fields>;
  variance?: Maybe<Role_Variance_Fields>;
};


/** aggregate fields of "role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Role_Avg_Fields = {
  __typename?: 'role_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Bool_Exp>>;
  _not?: InputMaybe<Role_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "role" */
export enum Role_Constraint {
  /** unique or primary key constraint on columns "codename" */
  RoleCodenameKey = 'role_codename_key',
  /** unique or primary key constraint on columns "key" */
  RoleKeyKey = 'role_key_key',
  /** unique or primary key constraint on columns "id" */
  RolePkey = 'role_pkey'
}

/** input type for incrementing numeric columns in table "role" */
export type Role_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** input type for inserting object relation for remote table "role" */
export type Role_Obj_Rel_Insert_Input = {
  data: Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_On_Conflict>;
};

/** on_conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: InputMaybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "role". */
export type Role_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role */
export type Role_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "role" */
export enum Role_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "role" */
export type Role_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Role_Stddev_Fields = {
  __typename?: 'role_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Role_Stddev_Pop_Fields = {
  __typename?: 'role_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Role_Stddev_Samp_Fields = {
  __typename?: 'role_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "role" */
export type Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Role_Sum_Fields = {
  __typename?: 'role_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "role" */
export enum Role_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name'
}

export type Role_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Role_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Role_Var_Pop_Fields = {
  __typename?: 'role_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Role_Var_Samp_Fields = {
  __typename?: 'role_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Role_Variance_Fields = {
  __typename?: 'role_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "rootstock" */
export type Rootstock = {
  __typename?: 'rootstock';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "rootstock" */
export type Rootstock_Aggregate = {
  __typename?: 'rootstock_aggregate';
  aggregate?: Maybe<Rootstock_Aggregate_Fields>;
  nodes: Array<Rootstock>;
};

/** aggregate fields of "rootstock" */
export type Rootstock_Aggregate_Fields = {
  __typename?: 'rootstock_aggregate_fields';
  avg?: Maybe<Rootstock_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Rootstock_Max_Fields>;
  min?: Maybe<Rootstock_Min_Fields>;
  stddev?: Maybe<Rootstock_Stddev_Fields>;
  stddev_pop?: Maybe<Rootstock_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rootstock_Stddev_Samp_Fields>;
  sum?: Maybe<Rootstock_Sum_Fields>;
  var_pop?: Maybe<Rootstock_Var_Pop_Fields>;
  var_samp?: Maybe<Rootstock_Var_Samp_Fields>;
  variance?: Maybe<Rootstock_Variance_Fields>;
};


/** aggregate fields of "rootstock" */
export type Rootstock_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rootstock_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Rootstock_Avg_Fields = {
  __typename?: 'rootstock_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rootstock". All fields are combined with a logical 'AND'. */
export type Rootstock_Bool_Exp = {
  _and?: InputMaybe<Array<Rootstock_Bool_Exp>>;
  _not?: InputMaybe<Rootstock_Bool_Exp>;
  _or?: InputMaybe<Array<Rootstock_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "rootstock" */
export enum Rootstock_Constraint {
  /** unique or primary key constraint on columns "codename" */
  RootstockCodenameKey = 'rootstock_codename_key',
  /** unique or primary key constraint on columns "id" */
  RootstockPkey = 'rootstock_pkey'
}

/** input type for incrementing numeric columns in table "rootstock" */
export type Rootstock_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rootstock" */
export type Rootstock_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Rootstock_Max_Fields = {
  __typename?: 'rootstock_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Rootstock_Min_Fields = {
  __typename?: 'rootstock_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "rootstock" */
export type Rootstock_Mutation_Response = {
  __typename?: 'rootstock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rootstock>;
};

/** input type for inserting object relation for remote table "rootstock" */
export type Rootstock_Obj_Rel_Insert_Input = {
  data: Rootstock_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rootstock_On_Conflict>;
};

/** on_conflict condition type for table "rootstock" */
export type Rootstock_On_Conflict = {
  constraint: Rootstock_Constraint;
  update_columns?: Array<Rootstock_Update_Column>;
  where?: InputMaybe<Rootstock_Bool_Exp>;
};

/** Ordering options when selecting data from "rootstock". */
export type Rootstock_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rootstock */
export type Rootstock_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "rootstock" */
export enum Rootstock_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "rootstock" */
export type Rootstock_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Rootstock_Stddev_Fields = {
  __typename?: 'rootstock_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Rootstock_Stddev_Pop_Fields = {
  __typename?: 'rootstock_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Rootstock_Stddev_Samp_Fields = {
  __typename?: 'rootstock_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rootstock" */
export type Rootstock_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rootstock_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rootstock_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Rootstock_Sum_Fields = {
  __typename?: 'rootstock_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "rootstock" */
export enum Rootstock_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Rootstock_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rootstock_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rootstock_Set_Input>;
  where: Rootstock_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rootstock_Var_Pop_Fields = {
  __typename?: 'rootstock_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Rootstock_Var_Samp_Fields = {
  __typename?: 'rootstock_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Rootstock_Variance_Fields = {
  __typename?: 'rootstock_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sample" */
export type Sample = {
  __typename?: 'sample';
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  drawn_on?: Maybe<Scalars['date']>;
  id: Scalars['bigint'];
  observation_remark: Scalars['String'];
  /** An array relationship */
  observations: Array<Sample_Observation>;
  /** An aggregate relationship */
  observations_aggregate: Sample_Observation_Aggregate;
  quantity: Scalars['numeric'];
  recommendations: Scalars['String'];
  reference_id: Scalars['String'];
  /** An array relationship */
  results: Array<Result>;
  /** An aggregate relationship */
  results_aggregate: Result_Aggregate;
  /** An array relationship */
  sample_media: Array<Sample_Media>;
  /** An aggregate relationship */
  sample_media_aggregate: Sample_Media_Aggregate;
  /** An object relationship */
  sample_request: Request;
  sample_request_id: Scalars['bigint'];
  /** An object relationship */
  unit: Unit;
  unit_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  year?: Maybe<External_Entity>;
  year_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "sample" */
export type SampleObservationsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


/** columns and relationships of "sample" */
export type SampleObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


/** columns and relationships of "sample" */
export type SampleResultsArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


/** columns and relationships of "sample" */
export type SampleResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


/** columns and relationships of "sample" */
export type SampleSample_MediaArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


/** columns and relationships of "sample" */
export type SampleSample_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};

/** aggregated selection of "sample" */
export type Sample_Aggregate = {
  __typename?: 'sample_aggregate';
  aggregate?: Maybe<Sample_Aggregate_Fields>;
  nodes: Array<Sample>;
};

/** aggregate fields of "sample" */
export type Sample_Aggregate_Fields = {
  __typename?: 'sample_aggregate_fields';
  avg?: Maybe<Sample_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sample_Max_Fields>;
  min?: Maybe<Sample_Min_Fields>;
  stddev?: Maybe<Sample_Stddev_Fields>;
  stddev_pop?: Maybe<Sample_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sample_Stddev_Samp_Fields>;
  sum?: Maybe<Sample_Sum_Fields>;
  var_pop?: Maybe<Sample_Var_Pop_Fields>;
  var_samp?: Maybe<Sample_Var_Samp_Fields>;
  variance?: Maybe<Sample_Variance_Fields>;
};


/** aggregate fields of "sample" */
export type Sample_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sample_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sample_Avg_Fields = {
  __typename?: 'sample_avg_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sample_request_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sample". All fields are combined with a logical 'AND'. */
export type Sample_Bool_Exp = {
  _and?: InputMaybe<Array<Sample_Bool_Exp>>;
  _not?: InputMaybe<Sample_Bool_Exp>;
  _or?: InputMaybe<Array<Sample_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  drawn_on?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  observation_remark?: InputMaybe<String_Comparison_Exp>;
  observations?: InputMaybe<Sample_Observation_Bool_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  recommendations?: InputMaybe<String_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  results?: InputMaybe<Result_Bool_Exp>;
  sample_media?: InputMaybe<Sample_Media_Bool_Exp>;
  sample_request?: InputMaybe<Request_Bool_Exp>;
  sample_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<External_Entity_Bool_Exp>;
  year_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sample" */
export enum Sample_Constraint {
  /** unique or primary key constraint on columns "id" */
  SamplePkey = 'sample_pkey',
  /** unique or primary key constraint on columns "sample_request_id" */
  SampleSampleRequestIdKey = 'sample_sample_request_id_key'
}

/** input type for incrementing numeric columns in table "sample" */
export type Sample_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  sample_request_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  year_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sample" */
export type Sample_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  drawn_on?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  observation_remark?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Sample_Observation_Arr_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['numeric']>;
  recommendations?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Result_Arr_Rel_Insert_Input>;
  sample_media?: InputMaybe<Sample_Media_Arr_Rel_Insert_Input>;
  sample_request?: InputMaybe<Request_Obj_Rel_Insert_Input>;
  sample_request_id?: InputMaybe<Scalars['bigint']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  year_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Sample_Max_Fields = {
  __typename?: 'sample_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  drawn_on?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  observation_remark?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  recommendations?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  sample_request_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "sample_media" */
export type Sample_Media = {
  __typename?: 'sample_media';
  attachment_id: Scalars['bigint'];
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  media: Eagle_Media;
  name: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  sample: Sample;
  sample_id: Scalars['bigint'];
};

/** aggregated selection of "sample_media" */
export type Sample_Media_Aggregate = {
  __typename?: 'sample_media_aggregate';
  aggregate?: Maybe<Sample_Media_Aggregate_Fields>;
  nodes: Array<Sample_Media>;
};

/** aggregate fields of "sample_media" */
export type Sample_Media_Aggregate_Fields = {
  __typename?: 'sample_media_aggregate_fields';
  avg?: Maybe<Sample_Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sample_Media_Max_Fields>;
  min?: Maybe<Sample_Media_Min_Fields>;
  stddev?: Maybe<Sample_Media_Stddev_Fields>;
  stddev_pop?: Maybe<Sample_Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sample_Media_Stddev_Samp_Fields>;
  sum?: Maybe<Sample_Media_Sum_Fields>;
  var_pop?: Maybe<Sample_Media_Var_Pop_Fields>;
  var_samp?: Maybe<Sample_Media_Var_Samp_Fields>;
  variance?: Maybe<Sample_Media_Variance_Fields>;
};


/** aggregate fields of "sample_media" */
export type Sample_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sample_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sample_media" */
export type Sample_Media_Aggregate_Order_By = {
  avg?: InputMaybe<Sample_Media_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sample_Media_Max_Order_By>;
  min?: InputMaybe<Sample_Media_Min_Order_By>;
  stddev?: InputMaybe<Sample_Media_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sample_Media_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sample_Media_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sample_Media_Sum_Order_By>;
  var_pop?: InputMaybe<Sample_Media_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sample_Media_Var_Samp_Order_By>;
  variance?: InputMaybe<Sample_Media_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sample_media" */
export type Sample_Media_Arr_Rel_Insert_Input = {
  data: Array<Sample_Media_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sample_Media_On_Conflict>;
};

/** aggregate avg on columns */
export type Sample_Media_Avg_Fields = {
  __typename?: 'sample_media_avg_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sample_media" */
export type Sample_Media_Avg_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sample_media". All fields are combined with a logical 'AND'. */
export type Sample_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Sample_Media_Bool_Exp>>;
  _not?: InputMaybe<Sample_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Sample_Media_Bool_Exp>>;
  attachment_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  sample?: InputMaybe<Sample_Bool_Exp>;
  sample_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sample_media" */
export enum Sample_Media_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SampleMediaCodenameKey = 'sample_media_codename_key',
  /** unique or primary key constraint on columns "id" */
  SampleMediaPkey = 'sample_media_pkey'
}

/** input type for incrementing numeric columns in table "sample_media" */
export type Sample_Media_Inc_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sample_media" */
export type Sample_Media_Insert_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  sample?: InputMaybe<Sample_Obj_Rel_Insert_Input>;
  sample_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Sample_Media_Max_Fields = {
  __typename?: 'sample_media_max_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sample_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "sample_media" */
export type Sample_Media_Max_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sample_Media_Min_Fields = {
  __typename?: 'sample_media_min_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  sample_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "sample_media" */
export type Sample_Media_Min_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sample_media" */
export type Sample_Media_Mutation_Response = {
  __typename?: 'sample_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sample_Media>;
};

/** on_conflict condition type for table "sample_media" */
export type Sample_Media_On_Conflict = {
  constraint: Sample_Media_Constraint;
  update_columns?: Array<Sample_Media_Update_Column>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "sample_media". */
export type Sample_Media_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  sample?: InputMaybe<Sample_Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sample_media */
export type Sample_Media_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "sample_media" */
export enum Sample_Media_Select_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Remark = 'remark',
  /** column name */
  SampleId = 'sample_id'
}

/** input type for updating data in table "sample_media" */
export type Sample_Media_Set_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Sample_Media_Stddev_Fields = {
  __typename?: 'sample_media_stddev_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sample_media" */
export type Sample_Media_Stddev_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sample_Media_Stddev_Pop_Fields = {
  __typename?: 'sample_media_stddev_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sample_media" */
export type Sample_Media_Stddev_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sample_Media_Stddev_Samp_Fields = {
  __typename?: 'sample_media_stddev_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sample_media" */
export type Sample_Media_Stddev_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sample_media" */
export type Sample_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sample_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sample_Media_Stream_Cursor_Value_Input = {
  attachment_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Sample_Media_Sum_Fields = {
  __typename?: 'sample_media_sum_fields';
  attachment_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  sample_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sample_media" */
export type Sample_Media_Sum_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** update columns of table "sample_media" */
export enum Sample_Media_Update_Column {
  /** column name */
  AttachmentId = 'attachment_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Remark = 'remark',
  /** column name */
  SampleId = 'sample_id'
}

export type Sample_Media_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sample_Media_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sample_Media_Set_Input>;
  where: Sample_Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sample_Media_Var_Pop_Fields = {
  __typename?: 'sample_media_var_pop_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sample_media" */
export type Sample_Media_Var_Pop_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sample_Media_Var_Samp_Fields = {
  __typename?: 'sample_media_var_samp_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sample_media" */
export type Sample_Media_Var_Samp_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sample_Media_Variance_Fields = {
  __typename?: 'sample_media_variance_fields';
  attachment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sample_media" */
export type Sample_Media_Variance_Order_By = {
  attachment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sample_Min_Fields = {
  __typename?: 'sample_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  drawn_on?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  observation_remark?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  recommendations?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  sample_request_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "sample" */
export type Sample_Mutation_Response = {
  __typename?: 'sample_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sample>;
};

/** input type for inserting object relation for remote table "sample" */
export type Sample_Obj_Rel_Insert_Input = {
  data: Sample_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sample_On_Conflict>;
};

/** columns and relationships of "sample_observation" */
export type Sample_Observation = {
  __typename?: 'sample_observation';
  /** An array relationship */
  attachments: Array<Sample_Observation_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Sample_Observation_Attachments_Aggregate;
  created_at: Scalars['timestamptz'];
  help_text?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  instrument_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  observation_number: Scalars['Int'];
  /** An object relationship */
  quality_parameter: Quality_Parameter;
  quality_parameter_id: Scalars['bigint'];
  remark: Scalars['String'];
  /** An array relationship */
  result_observations: Array<Result_Observation>;
  /** An aggregate relationship */
  result_observations_aggregate: Result_Observation_Aggregate;
  /** An object relationship */
  sample: Sample;
  sample_id: Scalars['bigint'];
  /** An object relationship */
  test_request: Request;
  test_request_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  value: Scalars['float8'];
  value_date?: Maybe<Scalars['date']>;
  value_datetime?: Maybe<Scalars['timestamptz']>;
  value_text?: Maybe<Scalars['String']>;
  value_time?: Maybe<Scalars['time']>;
};


/** columns and relationships of "sample_observation" */
export type Sample_ObservationAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


/** columns and relationships of "sample_observation" */
export type Sample_ObservationAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


/** columns and relationships of "sample_observation" */
export type Sample_ObservationResult_ObservationsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


/** columns and relationships of "sample_observation" */
export type Sample_ObservationResult_Observations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};

/** aggregated selection of "sample_observation" */
export type Sample_Observation_Aggregate = {
  __typename?: 'sample_observation_aggregate';
  aggregate?: Maybe<Sample_Observation_Aggregate_Fields>;
  nodes: Array<Sample_Observation>;
};

/** aggregate fields of "sample_observation" */
export type Sample_Observation_Aggregate_Fields = {
  __typename?: 'sample_observation_aggregate_fields';
  avg?: Maybe<Sample_Observation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sample_Observation_Max_Fields>;
  min?: Maybe<Sample_Observation_Min_Fields>;
  stddev?: Maybe<Sample_Observation_Stddev_Fields>;
  stddev_pop?: Maybe<Sample_Observation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sample_Observation_Stddev_Samp_Fields>;
  sum?: Maybe<Sample_Observation_Sum_Fields>;
  var_pop?: Maybe<Sample_Observation_Var_Pop_Fields>;
  var_samp?: Maybe<Sample_Observation_Var_Samp_Fields>;
  variance?: Maybe<Sample_Observation_Variance_Fields>;
};


/** aggregate fields of "sample_observation" */
export type Sample_Observation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sample_observation" */
export type Sample_Observation_Aggregate_Order_By = {
  avg?: InputMaybe<Sample_Observation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sample_Observation_Max_Order_By>;
  min?: InputMaybe<Sample_Observation_Min_Order_By>;
  stddev?: InputMaybe<Sample_Observation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sample_Observation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sample_Observation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sample_Observation_Sum_Order_By>;
  var_pop?: InputMaybe<Sample_Observation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sample_Observation_Var_Samp_Order_By>;
  variance?: InputMaybe<Sample_Observation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sample_observation" */
export type Sample_Observation_Arr_Rel_Insert_Input = {
  data: Array<Sample_Observation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sample_Observation_On_Conflict>;
};

/** columns and relationships of "sample_observation_attachments" */
export type Sample_Observation_Attachments = {
  __typename?: 'sample_observation_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Eagle_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  sample_observation: Sample_Observation;
  sampleobservation_id: Scalars['bigint'];
};

/** aggregated selection of "sample_observation_attachments" */
export type Sample_Observation_Attachments_Aggregate = {
  __typename?: 'sample_observation_attachments_aggregate';
  aggregate?: Maybe<Sample_Observation_Attachments_Aggregate_Fields>;
  nodes: Array<Sample_Observation_Attachments>;
};

/** aggregate fields of "sample_observation_attachments" */
export type Sample_Observation_Attachments_Aggregate_Fields = {
  __typename?: 'sample_observation_attachments_aggregate_fields';
  avg?: Maybe<Sample_Observation_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sample_Observation_Attachments_Max_Fields>;
  min?: Maybe<Sample_Observation_Attachments_Min_Fields>;
  stddev?: Maybe<Sample_Observation_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Sample_Observation_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sample_Observation_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Sample_Observation_Attachments_Sum_Fields>;
  var_pop?: Maybe<Sample_Observation_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Sample_Observation_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Sample_Observation_Attachments_Variance_Fields>;
};


/** aggregate fields of "sample_observation_attachments" */
export type Sample_Observation_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Sample_Observation_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sample_Observation_Attachments_Max_Order_By>;
  min?: InputMaybe<Sample_Observation_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Sample_Observation_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sample_Observation_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sample_Observation_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sample_Observation_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Sample_Observation_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sample_Observation_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Sample_Observation_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Sample_Observation_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sample_Observation_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Sample_Observation_Attachments_Avg_Fields = {
  __typename?: 'sample_observation_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  sampleobservation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sample_observation_attachments". All fields are combined with a logical 'AND'. */
export type Sample_Observation_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Sample_Observation_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Sample_Observation_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  sample_observation?: InputMaybe<Sample_Observation_Bool_Exp>;
  sampleobservation_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sample_observation_attachments" */
export enum Sample_Observation_Attachments_Constraint {
  /** unique or primary key constraint on columns "sampleobservation_id", "media_id" */
  SampleObservationAttacSampleobservationIdMed_9b3137c5Uniq = 'sample_observation_attac_sampleobservation_id_med_9b3137c5_uniq',
  /** unique or primary key constraint on columns "id" */
  SampleObservationAttachmentsPkey = 'sample_observation_attachments_pkey'
}

/** input type for incrementing numeric columns in table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  sampleobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  sample_observation?: InputMaybe<Sample_Observation_Obj_Rel_Insert_Input>;
  sampleobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Sample_Observation_Attachments_Max_Fields = {
  __typename?: 'sample_observation_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  sampleobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sample_Observation_Attachments_Min_Fields = {
  __typename?: 'sample_observation_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  sampleobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Mutation_Response = {
  __typename?: 'sample_observation_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sample_Observation_Attachments>;
};

/** on_conflict condition type for table "sample_observation_attachments" */
export type Sample_Observation_Attachments_On_Conflict = {
  constraint: Sample_Observation_Attachments_Constraint;
  update_columns?: Array<Sample_Observation_Attachments_Update_Column>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "sample_observation_attachments". */
export type Sample_Observation_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  sample_observation?: InputMaybe<Sample_Observation_Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sample_observation_attachments */
export type Sample_Observation_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "sample_observation_attachments" */
export enum Sample_Observation_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  SampleobservationId = 'sampleobservation_id'
}

/** input type for updating data in table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  sampleobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Sample_Observation_Attachments_Stddev_Fields = {
  __typename?: 'sample_observation_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  sampleobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sample_Observation_Attachments_Stddev_Pop_Fields = {
  __typename?: 'sample_observation_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  sampleobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sample_Observation_Attachments_Stddev_Samp_Fields = {
  __typename?: 'sample_observation_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  sampleobservation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sample_Observation_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sample_Observation_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  sampleobservation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Sample_Observation_Attachments_Sum_Fields = {
  __typename?: 'sample_observation_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  sampleobservation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** update columns of table "sample_observation_attachments" */
export enum Sample_Observation_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  SampleobservationId = 'sampleobservation_id'
}

export type Sample_Observation_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sample_Observation_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sample_Observation_Attachments_Set_Input>;
  where: Sample_Observation_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sample_Observation_Attachments_Var_Pop_Fields = {
  __typename?: 'sample_observation_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  sampleobservation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sample_Observation_Attachments_Var_Samp_Fields = {
  __typename?: 'sample_observation_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  sampleobservation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sample_Observation_Attachments_Variance_Fields = {
  __typename?: 'sample_observation_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  sampleobservation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sample_observation_attachments" */
export type Sample_Observation_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  sampleobservation_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Sample_Observation_Avg_Fields = {
  __typename?: 'sample_observation_avg_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sample_observation" */
export type Sample_Observation_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sample_observation". All fields are combined with a logical 'AND'. */
export type Sample_Observation_Bool_Exp = {
  _and?: InputMaybe<Array<Sample_Observation_Bool_Exp>>;
  _not?: InputMaybe<Sample_Observation_Bool_Exp>;
  _or?: InputMaybe<Array<Sample_Observation_Bool_Exp>>;
  attachments?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  help_text?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  instrument_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  observation_number?: InputMaybe<Int_Comparison_Exp>;
  quality_parameter?: InputMaybe<Quality_Parameter_Bool_Exp>;
  quality_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  result_observations?: InputMaybe<Result_Observation_Bool_Exp>;
  sample?: InputMaybe<Sample_Bool_Exp>;
  sample_id?: InputMaybe<Bigint_Comparison_Exp>;
  test_request?: InputMaybe<Request_Bool_Exp>;
  test_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
  value_date?: InputMaybe<Date_Comparison_Exp>;
  value_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  value_text?: InputMaybe<String_Comparison_Exp>;
  value_time?: InputMaybe<Time_Comparison_Exp>;
};

/** unique or primary key constraints on table "sample_observation" */
export enum Sample_Observation_Constraint {
  /** unique or primary key constraint on columns "id" */
  SampleObservationPkey = 'sample_observation_pkey',
  /** unique or primary key constraint on columns "sample_id", "test_request_id", "quality_parameter_id", "observation_number" */
  SampleObservationTestRequestIdQualityFcb726a5Uniq = 'sample_observation_test_request_id_quality__fcb726a5_uniq'
}

/** input type for incrementing numeric columns in table "sample_observation" */
export type Sample_Observation_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "sample_observation" */
export type Sample_Observation_Insert_Input = {
  attachments?: InputMaybe<Sample_Observation_Attachments_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  help_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  quality_parameter?: InputMaybe<Quality_Parameter_Obj_Rel_Insert_Input>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  result_observations?: InputMaybe<Result_Observation_Arr_Rel_Insert_Input>;
  sample?: InputMaybe<Sample_Obj_Rel_Insert_Input>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  test_request?: InputMaybe<Request_Obj_Rel_Insert_Input>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  value_date?: InputMaybe<Scalars['date']>;
  value_datetime?: InputMaybe<Scalars['timestamptz']>;
  value_text?: InputMaybe<Scalars['String']>;
  value_time?: InputMaybe<Scalars['time']>;
};

/** aggregate max on columns */
export type Sample_Observation_Max_Fields = {
  __typename?: 'sample_observation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  help_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  observation_number?: Maybe<Scalars['Int']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  sample_id?: Maybe<Scalars['bigint']>;
  test_request_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
  value_date?: Maybe<Scalars['date']>;
  value_datetime?: Maybe<Scalars['timestamptz']>;
  value_text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sample_observation" */
export type Sample_Observation_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_date?: InputMaybe<Order_By>;
  value_datetime?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sample_Observation_Min_Fields = {
  __typename?: 'sample_observation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  help_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  instrument_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  observation_number?: Maybe<Scalars['Int']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  sample_id?: Maybe<Scalars['bigint']>;
  test_request_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
  value_date?: Maybe<Scalars['date']>;
  value_datetime?: Maybe<Scalars['timestamptz']>;
  value_text?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sample_observation" */
export type Sample_Observation_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_date?: InputMaybe<Order_By>;
  value_datetime?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sample_observation" */
export type Sample_Observation_Mutation_Response = {
  __typename?: 'sample_observation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sample_Observation>;
};

/** input type for inserting object relation for remote table "sample_observation" */
export type Sample_Observation_Obj_Rel_Insert_Input = {
  data: Sample_Observation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sample_Observation_On_Conflict>;
};

/** on_conflict condition type for table "sample_observation" */
export type Sample_Observation_On_Conflict = {
  constraint: Sample_Observation_Constraint;
  update_columns?: Array<Sample_Observation_Update_Column>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};

/** Ordering options when selecting data from "sample_observation". */
export type Sample_Observation_Order_By = {
  attachments_aggregate?: InputMaybe<Sample_Observation_Attachments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter?: InputMaybe<Quality_Parameter_Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  result_observations_aggregate?: InputMaybe<Result_Observation_Aggregate_Order_By>;
  sample?: InputMaybe<Sample_Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request?: InputMaybe<Request_Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_date?: InputMaybe<Order_By>;
  value_datetime?: InputMaybe<Order_By>;
  value_text?: InputMaybe<Order_By>;
  value_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sample_observation */
export type Sample_Observation_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "sample_observation" */
export enum Sample_Observation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HelpText = 'help_text',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentId = 'instrument_id',
  /** column name */
  Name = 'name',
  /** column name */
  ObservationNumber = 'observation_number',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SampleId = 'sample_id',
  /** column name */
  TestRequestId = 'test_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueDate = 'value_date',
  /** column name */
  ValueDatetime = 'value_datetime',
  /** column name */
  ValueText = 'value_text',
  /** column name */
  ValueTime = 'value_time'
}

/** input type for updating data in table "sample_observation" */
export type Sample_Observation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  help_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  value_date?: InputMaybe<Scalars['date']>;
  value_datetime?: InputMaybe<Scalars['timestamptz']>;
  value_text?: InputMaybe<Scalars['String']>;
  value_time?: InputMaybe<Scalars['time']>;
};

/** aggregate stddev on columns */
export type Sample_Observation_Stddev_Fields = {
  __typename?: 'sample_observation_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sample_observation" */
export type Sample_Observation_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sample_Observation_Stddev_Pop_Fields = {
  __typename?: 'sample_observation_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sample_observation" */
export type Sample_Observation_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sample_Observation_Stddev_Samp_Fields = {
  __typename?: 'sample_observation_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sample_observation" */
export type Sample_Observation_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sample_observation" */
export type Sample_Observation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sample_Observation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sample_Observation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  help_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  instrument_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  observation_number?: InputMaybe<Scalars['Int']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  sample_id?: InputMaybe<Scalars['bigint']>;
  test_request_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
  value_date?: InputMaybe<Scalars['date']>;
  value_datetime?: InputMaybe<Scalars['timestamptz']>;
  value_text?: InputMaybe<Scalars['String']>;
  value_time?: InputMaybe<Scalars['time']>;
};

/** aggregate sum on columns */
export type Sample_Observation_Sum_Fields = {
  __typename?: 'sample_observation_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  instrument_id?: Maybe<Scalars['bigint']>;
  observation_number?: Maybe<Scalars['Int']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  sample_id?: Maybe<Scalars['bigint']>;
  test_request_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "sample_observation" */
export type Sample_Observation_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "sample_observation" */
export enum Sample_Observation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HelpText = 'help_text',
  /** column name */
  Id = 'id',
  /** column name */
  InstrumentId = 'instrument_id',
  /** column name */
  Name = 'name',
  /** column name */
  ObservationNumber = 'observation_number',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SampleId = 'sample_id',
  /** column name */
  TestRequestId = 'test_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueDate = 'value_date',
  /** column name */
  ValueDatetime = 'value_datetime',
  /** column name */
  ValueText = 'value_text',
  /** column name */
  ValueTime = 'value_time'
}

export type Sample_Observation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sample_Observation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sample_Observation_Set_Input>;
  where: Sample_Observation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sample_Observation_Var_Pop_Fields = {
  __typename?: 'sample_observation_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sample_observation" */
export type Sample_Observation_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sample_Observation_Var_Samp_Fields = {
  __typename?: 'sample_observation_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sample_observation" */
export type Sample_Observation_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sample_Observation_Variance_Fields = {
  __typename?: 'sample_observation_variance_fields';
  id?: Maybe<Scalars['Float']>;
  instrument_id?: Maybe<Scalars['Float']>;
  observation_number?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sample_id?: Maybe<Scalars['Float']>;
  test_request_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sample_observation" */
export type Sample_Observation_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  instrument_id?: InputMaybe<Order_By>;
  observation_number?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_id?: InputMaybe<Order_By>;
  test_request_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "sample" */
export type Sample_On_Conflict = {
  constraint: Sample_Constraint;
  update_columns?: Array<Sample_Update_Column>;
  where?: InputMaybe<Sample_Bool_Exp>;
};

/** Ordering options when selecting data from "sample". */
export type Sample_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  drawn_on?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  observation_remark?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Sample_Observation_Aggregate_Order_By>;
  quantity?: InputMaybe<Order_By>;
  recommendations?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  results_aggregate?: InputMaybe<Result_Aggregate_Order_By>;
  sample_media_aggregate?: InputMaybe<Sample_Media_Aggregate_Order_By>;
  sample_request?: InputMaybe<Request_Order_By>;
  sample_request_id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  year?: InputMaybe<External_Entity_Order_By>;
  year_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sample */
export type Sample_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "sample" */
export enum Sample_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DrawnOn = 'drawn_on',
  /** column name */
  Id = 'id',
  /** column name */
  ObservationRemark = 'observation_remark',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Recommendations = 'recommendations',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  SampleRequestId = 'sample_request_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  YearId = 'year_id'
}

/** input type for updating data in table "sample" */
export type Sample_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  drawn_on?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  observation_remark?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  recommendations?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  sample_request_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  year_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Sample_Stddev_Fields = {
  __typename?: 'sample_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sample_request_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sample_Stddev_Pop_Fields = {
  __typename?: 'sample_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sample_request_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sample_Stddev_Samp_Fields = {
  __typename?: 'sample_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sample_request_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sample" */
export type Sample_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sample_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sample_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  drawn_on?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  observation_remark?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  recommendations?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
  sample_request_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  year_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Sample_Sum_Fields = {
  __typename?: 'sample_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['numeric']>;
  sample_request_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['bigint']>;
  year_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sample" */
export enum Sample_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  DrawnOn = 'drawn_on',
  /** column name */
  Id = 'id',
  /** column name */
  ObservationRemark = 'observation_remark',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Recommendations = 'recommendations',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  SampleRequestId = 'sample_request_id',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  YearId = 'year_id'
}

export type Sample_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sample_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sample_Set_Input>;
  where: Sample_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sample_Var_Pop_Fields = {
  __typename?: 'sample_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sample_request_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sample_Var_Samp_Fields = {
  __typename?: 'sample_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sample_request_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sample_Variance_Fields = {
  __typename?: 'sample_variance_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  sample_request_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  year_id?: Maybe<Scalars['Float']>;
};

export type Search_Base_Users_Args = {
  query?: InputMaybe<Scalars['String']>;
};

export type Search_Businesses_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Businesses_Groups_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Mutual_Groups_Args = {
  query?: InputMaybe<Scalars['String']>;
};

export type Search_Plot_Crops_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "secondary_growth_stage" */
export type Secondary_Growth_Stage = {
  __typename?: 'secondary_growth_stage';
  base_stage: Scalars['String'];
  code: Scalars['String'];
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  max_days_after: Scalars['Int'];
  min_days_after: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  primary_growth_stage: Primary_Growth_Stage;
  primary_growth_stage_id: Scalars['Int'];
};

/** aggregated selection of "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate = {
  __typename?: 'secondary_growth_stage_aggregate';
  aggregate?: Maybe<Secondary_Growth_Stage_Aggregate_Fields>;
  nodes: Array<Secondary_Growth_Stage>;
};

/** aggregate fields of "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate_Fields = {
  __typename?: 'secondary_growth_stage_aggregate_fields';
  avg?: Maybe<Secondary_Growth_Stage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Secondary_Growth_Stage_Max_Fields>;
  min?: Maybe<Secondary_Growth_Stage_Min_Fields>;
  stddev?: Maybe<Secondary_Growth_Stage_Stddev_Fields>;
  stddev_pop?: Maybe<Secondary_Growth_Stage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Secondary_Growth_Stage_Stddev_Samp_Fields>;
  sum?: Maybe<Secondary_Growth_Stage_Sum_Fields>;
  var_pop?: Maybe<Secondary_Growth_Stage_Var_Pop_Fields>;
  var_samp?: Maybe<Secondary_Growth_Stage_Var_Samp_Fields>;
  variance?: Maybe<Secondary_Growth_Stage_Variance_Fields>;
};


/** aggregate fields of "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Aggregate_Order_By = {
  avg?: InputMaybe<Secondary_Growth_Stage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Secondary_Growth_Stage_Max_Order_By>;
  min?: InputMaybe<Secondary_Growth_Stage_Min_Order_By>;
  stddev?: InputMaybe<Secondary_Growth_Stage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Secondary_Growth_Stage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Secondary_Growth_Stage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Secondary_Growth_Stage_Sum_Order_By>;
  var_pop?: InputMaybe<Secondary_Growth_Stage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Secondary_Growth_Stage_Var_Samp_Order_By>;
  variance?: InputMaybe<Secondary_Growth_Stage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Arr_Rel_Insert_Input = {
  data: Array<Secondary_Growth_Stage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Secondary_Growth_Stage_On_Conflict>;
};

/** aggregate avg on columns */
export type Secondary_Growth_Stage_Avg_Fields = {
  __typename?: 'secondary_growth_stage_avg_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "secondary_growth_stage". All fields are combined with a logical 'AND'. */
export type Secondary_Growth_Stage_Bool_Exp = {
  _and?: InputMaybe<Array<Secondary_Growth_Stage_Bool_Exp>>;
  _not?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
  _or?: InputMaybe<Array<Secondary_Growth_Stage_Bool_Exp>>;
  base_stage?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  max_days_after?: InputMaybe<Int_Comparison_Exp>;
  min_days_after?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_growth_stage?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
  primary_growth_stage_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "secondary_growth_stage" */
export enum Secondary_Growth_Stage_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SecondaryGrowthStageCodenameKey = 'secondary_growth_stage_codename_key',
  /** unique or primary key constraint on columns "id" */
  SecondaryGrowthStagePkey = 'secondary_growth_stage_pkey',
  /** unique or primary key constraint on columns "code", "primary_growth_stage_id" */
  SecondaryGrowthStagePrimaryGrowthStageId_0004b9f6Uniq = 'secondary_growth_stage_primary_growth_stage_id__0004b9f6_uniq'
}

/** input type for incrementing numeric columns in table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Insert_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage?: InputMaybe<Primary_Growth_Stage_Obj_Rel_Insert_Input>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Secondary_Growth_Stage_Max_Fields = {
  __typename?: 'secondary_growth_stage_max_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Max_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Secondary_Growth_Stage_Min_Fields = {
  __typename?: 'secondary_growth_stage_min_fields';
  base_stage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Min_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Mutation_Response = {
  __typename?: 'secondary_growth_stage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Secondary_Growth_Stage>;
};

/** on_conflict condition type for table "secondary_growth_stage" */
export type Secondary_Growth_Stage_On_Conflict = {
  constraint: Secondary_Growth_Stage_Constraint;
  update_columns?: Array<Secondary_Growth_Stage_Update_Column>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};

/** Ordering options when selecting data from "secondary_growth_stage". */
export type Secondary_Growth_Stage_Order_By = {
  base_stage?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage?: InputMaybe<Primary_Growth_Stage_Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: secondary_growth_stage */
export type Secondary_Growth_Stage_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "secondary_growth_stage" */
export enum Secondary_Growth_Stage_Select_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id'
}

/** input type for updating data in table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Set_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Secondary_Growth_Stage_Stddev_Fields = {
  __typename?: 'secondary_growth_stage_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Secondary_Growth_Stage_Stddev_Pop_Fields = {
  __typename?: 'secondary_growth_stage_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Secondary_Growth_Stage_Stddev_Samp_Fields = {
  __typename?: 'secondary_growth_stage_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Secondary_Growth_Stage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Secondary_Growth_Stage_Stream_Cursor_Value_Input = {
  base_stage?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  max_days_after?: InputMaybe<Scalars['Int']>;
  min_days_after?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_growth_stage_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Secondary_Growth_Stage_Sum_Fields = {
  __typename?: 'secondary_growth_stage_sum_fields';
  id?: Maybe<Scalars['Int']>;
  max_days_after?: Maybe<Scalars['Int']>;
  min_days_after?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  primary_growth_stage_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** update columns of table "secondary_growth_stage" */
export enum Secondary_Growth_Stage_Update_Column {
  /** column name */
  BaseStage = 'base_stage',
  /** column name */
  Code = 'code',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MaxDaysAfter = 'max_days_after',
  /** column name */
  MinDaysAfter = 'min_days_after',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrimaryGrowthStageId = 'primary_growth_stage_id'
}

export type Secondary_Growth_Stage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Secondary_Growth_Stage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Secondary_Growth_Stage_Set_Input>;
  where: Secondary_Growth_Stage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Secondary_Growth_Stage_Var_Pop_Fields = {
  __typename?: 'secondary_growth_stage_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Secondary_Growth_Stage_Var_Samp_Fields = {
  __typename?: 'secondary_growth_stage_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Secondary_Growth_Stage_Variance_Fields = {
  __typename?: 'secondary_growth_stage_variance_fields';
  id?: Maybe<Scalars['Float']>;
  max_days_after?: Maybe<Scalars['Float']>;
  min_days_after?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  primary_growth_stage_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "secondary_growth_stage" */
export type Secondary_Growth_Stage_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  max_days_after?: InputMaybe<Order_By>;
  min_days_after?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_growth_stage_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "setu_trade_address" */
export type Setu_Trade_Address = {
  __typename?: 'setu_trade_address';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  district?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  local_area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['geometry']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** An array relationship */
  storage_locations: Array<Storage_Location>;
  /** An aggregate relationship */
  storage_locations_aggregate: Storage_Location_Aggregate;
  taluka?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  village?: Maybe<Scalars['String']>;
};


/** columns and relationships of "setu_trade_address" */
export type Setu_Trade_AddressStorage_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Order_By>>;
  where?: InputMaybe<Storage_Location_Bool_Exp>;
};


/** columns and relationships of "setu_trade_address" */
export type Setu_Trade_AddressStorage_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Order_By>>;
  where?: InputMaybe<Storage_Location_Bool_Exp>;
};

/** aggregated selection of "setu_trade_address" */
export type Setu_Trade_Address_Aggregate = {
  __typename?: 'setu_trade_address_aggregate';
  aggregate?: Maybe<Setu_Trade_Address_Aggregate_Fields>;
  nodes: Array<Setu_Trade_Address>;
};

/** aggregate fields of "setu_trade_address" */
export type Setu_Trade_Address_Aggregate_Fields = {
  __typename?: 'setu_trade_address_aggregate_fields';
  avg?: Maybe<Setu_Trade_Address_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Setu_Trade_Address_Max_Fields>;
  min?: Maybe<Setu_Trade_Address_Min_Fields>;
  stddev?: Maybe<Setu_Trade_Address_Stddev_Fields>;
  stddev_pop?: Maybe<Setu_Trade_Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Setu_Trade_Address_Stddev_Samp_Fields>;
  sum?: Maybe<Setu_Trade_Address_Sum_Fields>;
  var_pop?: Maybe<Setu_Trade_Address_Var_Pop_Fields>;
  var_samp?: Maybe<Setu_Trade_Address_Var_Samp_Fields>;
  variance?: Maybe<Setu_Trade_Address_Variance_Fields>;
};


/** aggregate fields of "setu_trade_address" */
export type Setu_Trade_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Setu_Trade_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Setu_Trade_Address_Avg_Fields = {
  __typename?: 'setu_trade_address_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "setu_trade_address". All fields are combined with a logical 'AND'. */
export type Setu_Trade_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Setu_Trade_Address_Bool_Exp>>;
  _not?: InputMaybe<Setu_Trade_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Setu_Trade_Address_Bool_Exp>>;
  address_line_1?: InputMaybe<String_Comparison_Exp>;
  address_line_2?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  local_area?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geometry_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pincode?: InputMaybe<String_Comparison_Exp>;
  raw_address?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  storage_locations?: InputMaybe<Storage_Location_Bool_Exp>;
  taluka?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  village?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Setu_Trade_Address_Max_Fields = {
  __typename?: 'setu_trade_address_max_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Setu_Trade_Address_Min_Fields = {
  __typename?: 'setu_trade_address_min_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  local_area?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pincode?: Maybe<Scalars['String']>;
  raw_address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taluka?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  village?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "setu_trade_address". */
export type Setu_Trade_Address_Order_By = {
  address_line_1?: InputMaybe<Order_By>;
  address_line_2?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_area?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pincode?: InputMaybe<Order_By>;
  raw_address?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  storage_locations_aggregate?: InputMaybe<Storage_Location_Aggregate_Order_By>;
  taluka?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  village?: InputMaybe<Order_By>;
};

/** select columns of table "setu_trade_address" */
export enum Setu_Trade_Address_Select_Column {
  /** column name */
  AddressLine_1 = 'address_line_1',
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  LocalArea = 'local_area',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Pincode = 'pincode',
  /** column name */
  RawAddress = 'raw_address',
  /** column name */
  State = 'state',
  /** column name */
  Taluka = 'taluka',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Village = 'village'
}

/** aggregate stddev on columns */
export type Setu_Trade_Address_Stddev_Fields = {
  __typename?: 'setu_trade_address_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Setu_Trade_Address_Stddev_Pop_Fields = {
  __typename?: 'setu_trade_address_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Setu_Trade_Address_Stddev_Samp_Fields = {
  __typename?: 'setu_trade_address_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "setu_trade_address" */
export type Setu_Trade_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setu_Trade_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setu_Trade_Address_Stream_Cursor_Value_Input = {
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  local_area?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geometry']>;
  name?: InputMaybe<Scalars['String']>;
  pincode?: InputMaybe<Scalars['String']>;
  raw_address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taluka?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  village?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Setu_Trade_Address_Sum_Fields = {
  __typename?: 'setu_trade_address_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Setu_Trade_Address_Var_Pop_Fields = {
  __typename?: 'setu_trade_address_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Setu_Trade_Address_Var_Samp_Fields = {
  __typename?: 'setu_trade_address_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Setu_Trade_Address_Variance_Fields = {
  __typename?: 'setu_trade_address_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_Entity = {
  __typename?: 'setu_trade_shared_entity';
  codename: Scalars['String'];
  commodity: Array<Commodity>;
  commodity_variety: Array<Commodity_Variety>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  /** An array relationship */
  credits: Array<Credit>;
  /** An aggregate relationship */
  credits_aggregate: Credit_Aggregate;
  /** An array relationship */
  demands_variety_grade: Array<Demand>;
  /** An aggregate relationship */
  demands_variety_grade_aggregate: Demand_Aggregate;
  department: Array<Department>;
  /** An object relationship */
  department_config?: Maybe<Department_Config>;
  /** An object relationship */
  department_user_advance?: Maybe<Department_User_Advance>;
  /** An array relationship */
  department_user_advances: Array<Department_User_Advance>;
  /** An aggregate relationship */
  department_user_advances_aggregate: Department_User_Advance_Aggregate;
  description: Scalars['String'];
  facilitator: Array<Company>;
  group_id?: Maybe<Scalars['bigint']>;
  group_name: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  packaging_unit: Array<Sku>;
  payment_detail?: Maybe<Payment_Detail>;
  plot_crop: Array<Plot_Crop>;
  private_metadata: Scalars['jsonb'];
  reference_id: Scalars['String'];
  result: Array<Result>;
  seller_receivable_amount_current_year?: Maybe<Scalars['Float']>;
  si_unit: Array<Si_Unit>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  user: Array<Base_User>;
  variety_grade: Array<Variety_Grade>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityCommodityArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp_Remote_Rel_Shared_Entitycommodity>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityCommodity_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp_Remote_Rel_Shared_Entitycommodity_Variety>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityCreditsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityCredits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityDemands_Variety_GradeArgs = {
  distinct_on?: InputMaybe<Array<Demand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Order_By>>;
  where?: InputMaybe<Demand_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityDemands_Variety_Grade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Order_By>>;
  where?: InputMaybe<Demand_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp_Remote_Rel_Shared_Entitydepartment>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityDepartment_User_AdvancesArgs = {
  distinct_on?: InputMaybe<Array<Department_User_Advance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_User_Advance_Order_By>>;
  where?: InputMaybe<Department_User_Advance_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityDepartment_User_Advances_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_User_Advance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_User_Advance_Order_By>>;
  where?: InputMaybe<Department_User_Advance_Bool_Exp>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityFacilitatorArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp_Remote_Rel_Shared_Entityfacilitator>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityPackaging_UnitArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp_Remote_Rel_Shared_Entitypackaging_Unit>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp_Remote_Rel_Shared_Entityplot_Crop>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityResultArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp_Remote_Rel_Shared_Entityresult>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntitySi_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp_Remote_Rel_Shared_Entitysi_Unit>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityUserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Shared_Entityuser>;
};


/** columns and relationships of "shared_entity" */
export type Setu_Trade_Shared_EntityVariety_GradeArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp_Remote_Rel_Shared_Entityvariety_Grade>;
};

/** Boolean expression to filter rows from the table "shared_entity". All fields are combined with a logical 'AND'. */
export type Setu_Trade_Shared_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Setu_Trade_Shared_Entity_Bool_Exp>>;
  _not?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Setu_Trade_Shared_Entity_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credits?: InputMaybe<Credit_Bool_Exp>;
  demands_variety_grade?: InputMaybe<Demand_Bool_Exp>;
  department_config?: InputMaybe<Department_Config_Bool_Exp>;
  department_user_advance?: InputMaybe<Department_User_Advance_Bool_Exp>;
  department_user_advances?: InputMaybe<Department_User_Advance_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Bigint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shared_entity" */
export enum Setu_Trade_Shared_Entity_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SharedEntityCodenameKey = 'shared_entity_codename_key',
  /** unique or primary key constraint on columns "reference_id", "group_name" */
  SharedEntityGroupNameReferenceId_4db210e6Uniq = 'shared_entity_group_name_reference_id_4db210e6_uniq',
  /** unique or primary key constraint on columns "id" */
  SharedEntityPkey = 'shared_entity_pkey'
}

/** input type for inserting data into table "shared_entity" */
export type Setu_Trade_Shared_Entity_Insert_Input = {
  group_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "shared_entity" */
export type Setu_Trade_Shared_Entity_Mutation_Response = {
  __typename?: 'setu_trade_shared_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setu_Trade_Shared_Entity>;
};

/** input type for inserting object relation for remote table "shared_entity" */
export type Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input = {
  data: Setu_Trade_Shared_Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Setu_Trade_Shared_Entity_On_Conflict>;
};

/** on_conflict condition type for table "shared_entity" */
export type Setu_Trade_Shared_Entity_On_Conflict = {
  constraint: Setu_Trade_Shared_Entity_Constraint;
  update_columns?: Array<Setu_Trade_Shared_Entity_Update_Column>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "shared_entity". */
export type Setu_Trade_Shared_Entity_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credits_aggregate?: InputMaybe<Credit_Aggregate_Order_By>;
  demands_variety_grade_aggregate?: InputMaybe<Demand_Aggregate_Order_By>;
  department_config?: InputMaybe<Department_Config_Order_By>;
  department_user_advance?: InputMaybe<Department_User_Advance_Order_By>;
  department_user_advances_aggregate?: InputMaybe<Department_User_Advance_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shared_entity */
export type Setu_Trade_Shared_Entity_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "shared_entity" */
export enum Setu_Trade_Shared_Entity_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "shared_entity" */
export type Setu_Trade_Shared_Entity_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "setu_trade_shared_entity" */
export type Setu_Trade_Shared_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setu_Trade_Shared_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setu_Trade_Shared_Entity_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  group_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  reference_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "shared_entity" */
export enum Setu_Trade_Shared_Entity_Update_Column {
  /** column name */
  Name = 'name'
}

export type Setu_Trade_Shared_Entity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Setu_Trade_Shared_Entity_Set_Input>;
  where: Setu_Trade_Shared_Entity_Bool_Exp;
};

/** columns and relationships of "media" */
export type Setutrade_Media = {
  __typename?: 'setutrade_media';
  created_at: Scalars['timestamptz'];
  etag?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  is_encrypted: Scalars['Boolean'];
  key: Scalars['String'];
  kind: Scalars['String'];
  /** An array relationship */
  media: Array<Trade_Attachments>;
  /** An aggregate relationship */
  media_aggregate: Trade_Attachments_Aggregate;
  updated_at: Scalars['timestamptz'];
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "media" */
export type Setutrade_MediaMediaArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


/** columns and relationships of "media" */
export type Setutrade_MediaMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};

/** aggregated selection of "media" */
export type Setutrade_Media_Aggregate = {
  __typename?: 'setutrade_media_aggregate';
  aggregate?: Maybe<Setutrade_Media_Aggregate_Fields>;
  nodes: Array<Setutrade_Media>;
};

/** aggregate fields of "media" */
export type Setutrade_Media_Aggregate_Fields = {
  __typename?: 'setutrade_media_aggregate_fields';
  avg?: Maybe<Setutrade_Media_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Setutrade_Media_Max_Fields>;
  min?: Maybe<Setutrade_Media_Min_Fields>;
  stddev?: Maybe<Setutrade_Media_Stddev_Fields>;
  stddev_pop?: Maybe<Setutrade_Media_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Setutrade_Media_Stddev_Samp_Fields>;
  sum?: Maybe<Setutrade_Media_Sum_Fields>;
  var_pop?: Maybe<Setutrade_Media_Var_Pop_Fields>;
  var_samp?: Maybe<Setutrade_Media_Var_Samp_Fields>;
  variance?: Maybe<Setutrade_Media_Variance_Fields>;
};


/** aggregate fields of "media" */
export type Setutrade_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Setutrade_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Setutrade_Media_Avg_Fields = {
  __typename?: 'setutrade_media_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "media". All fields are combined with a logical 'AND'. */
export type Setutrade_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Setutrade_Media_Bool_Exp>>;
  _not?: InputMaybe<Setutrade_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Setutrade_Media_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  etag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_encrypted?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  media?: InputMaybe<Trade_Attachments_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "media" */
export enum Setutrade_Media_Constraint {
  /** unique or primary key constraint on columns "key" */
  MediaKeyKey = 'media_key_key',
  /** unique or primary key constraint on columns "id" */
  MediaPkey = 'media_pkey'
}

/** input type for incrementing numeric columns in table "media" */
export type Setutrade_Media_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "media" */
export type Setutrade_Media_Insert_Input = {
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Trade_Attachments_Arr_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Setutrade_Media_Max_Fields = {
  __typename?: 'setutrade_media_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  key?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Setutrade_Media_Min_Fields = {
  __typename?: 'setutrade_media_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  key?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "media" */
export type Setutrade_Media_Mutation_Response = {
  __typename?: 'setutrade_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setutrade_Media>;
};

/** input type for inserting object relation for remote table "media" */
export type Setutrade_Media_Obj_Rel_Insert_Input = {
  data: Setutrade_Media_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Setutrade_Media_On_Conflict>;
};

/** on_conflict condition type for table "media" */
export type Setutrade_Media_On_Conflict = {
  constraint: Setutrade_Media_Constraint;
  update_columns?: Array<Setutrade_Media_Update_Column>;
  where?: InputMaybe<Setutrade_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "media". */
export type Setutrade_Media_Order_By = {
  created_at?: InputMaybe<Order_By>;
  etag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_encrypted?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  media_aggregate?: InputMaybe<Trade_Attachments_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: media */
export type Setutrade_Media_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "media" */
export enum Setutrade_Media_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  Key = 'key',
  /** column name */
  Kind = 'kind',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "media" */
export type Setutrade_Media_Set_Input = {
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Setutrade_Media_Stddev_Fields = {
  __typename?: 'setutrade_media_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Setutrade_Media_Stddev_Pop_Fields = {
  __typename?: 'setutrade_media_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Setutrade_Media_Stddev_Samp_Fields = {
  __typename?: 'setutrade_media_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "setutrade_media" */
export type Setutrade_Media_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setutrade_Media_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setutrade_Media_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_encrypted?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Setutrade_Media_Sum_Fields = {
  __typename?: 'setutrade_media_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "media" */
export enum Setutrade_Media_Update_Column {
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'is_encrypted',
  /** column name */
  Key = 'key',
  /** column name */
  Kind = 'kind',
  /** column name */
  Url = 'url'
}

export type Setutrade_Media_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Setutrade_Media_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Setutrade_Media_Set_Input>;
  where: Setutrade_Media_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Setutrade_Media_Var_Pop_Fields = {
  __typename?: 'setutrade_media_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Setutrade_Media_Var_Samp_Fields = {
  __typename?: 'setutrade_media_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Setutrade_Media_Variance_Fields = {
  __typename?: 'setutrade_media_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "trip" */
export type Setutrade_Trip = {
  __typename?: 'setutrade_trip';
  aggregator_name?: Maybe<Scalars['String']>;
  aggregator_number?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by: Array<Base_User>;
  created_by_id: Scalars['String'];
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  destination_location_name?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_number?: Maybe<Scalars['String']>;
  estimated_date?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['jsonb']>;
  remark?: Maybe<Scalars['String']>;
  source_location_name?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by: Array<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  vehicle: Setu_Trade_Shared_Entity;
  vehicle_id: Scalars['bigint'];
};


/** columns and relationships of "trip" */
export type Setutrade_TripCreated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Tripcreated_By>;
};


/** columns and relationships of "trip" */
export type Setutrade_TripMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "trip" */
export type Setutrade_TripTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "trip" */
export type Setutrade_TripTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "trip" */
export type Setutrade_TripUpdated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Tripupdated_By>;
};

/** aggregated selection of "trip" */
export type Setutrade_Trip_Aggregate = {
  __typename?: 'setutrade_trip_aggregate';
  aggregate?: Maybe<Setutrade_Trip_Aggregate_Fields>;
  nodes: Array<Setutrade_Trip>;
};

/** aggregate fields of "trip" */
export type Setutrade_Trip_Aggregate_Fields = {
  __typename?: 'setutrade_trip_aggregate_fields';
  avg?: Maybe<Setutrade_Trip_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Setutrade_Trip_Max_Fields>;
  min?: Maybe<Setutrade_Trip_Min_Fields>;
  stddev?: Maybe<Setutrade_Trip_Stddev_Fields>;
  stddev_pop?: Maybe<Setutrade_Trip_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Setutrade_Trip_Stddev_Samp_Fields>;
  sum?: Maybe<Setutrade_Trip_Sum_Fields>;
  var_pop?: Maybe<Setutrade_Trip_Var_Pop_Fields>;
  var_samp?: Maybe<Setutrade_Trip_Var_Samp_Fields>;
  variance?: Maybe<Setutrade_Trip_Variance_Fields>;
};


/** aggregate fields of "trip" */
export type Setutrade_Trip_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Setutrade_Trip_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Setutrade_Trip_Avg_Fields = {
  __typename?: 'setutrade_trip_avg_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "trip". All fields are combined with a logical 'AND'. */
export type Setutrade_Trip_Bool_Exp = {
  _and?: InputMaybe<Array<Setutrade_Trip_Bool_Exp>>;
  _not?: InputMaybe<Setutrade_Trip_Bool_Exp>;
  _or?: InputMaybe<Array<Setutrade_Trip_Bool_Exp>>;
  aggregator_name?: InputMaybe<String_Comparison_Exp>;
  aggregator_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  destination_location_name?: InputMaybe<String_Comparison_Exp>;
  driver_name?: InputMaybe<String_Comparison_Exp>;
  driver_number?: InputMaybe<String_Comparison_Exp>;
  estimated_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  source_location_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  vehicle_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Setutrade_Trip_Max_Fields = {
  __typename?: 'setutrade_trip_max_fields';
  aggregator_name?: Maybe<Scalars['String']>;
  aggregator_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  destination_location_name?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_number?: Maybe<Scalars['String']>;
  estimated_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  source_location_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Setutrade_Trip_Min_Fields = {
  __typename?: 'setutrade_trip_min_fields';
  aggregator_name?: Maybe<Scalars['String']>;
  aggregator_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  department_id?: Maybe<Scalars['bigint']>;
  destination_location_name?: Maybe<Scalars['String']>;
  driver_name?: Maybe<Scalars['String']>;
  driver_number?: Maybe<Scalars['String']>;
  estimated_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  source_location_name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "trip" */
export type Setutrade_Trip_Mutation_Response = {
  __typename?: 'setutrade_trip_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setutrade_Trip>;
};

/** Ordering options when selecting data from "trip". */
export type Setutrade_Trip_Order_By = {
  aggregator_name?: InputMaybe<Order_By>;
  aggregator_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  destination_location_name?: InputMaybe<Order_By>;
  driver_name?: InputMaybe<Order_By>;
  driver_number?: InputMaybe<Order_By>;
  estimated_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  source_location_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trip */
export type Setutrade_Trip_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "trip" */
export enum Setutrade_Trip_Select_Column {
  /** column name */
  AggregatorName = 'aggregator_name',
  /** column name */
  AggregatorNumber = 'aggregator_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  DestinationLocationName = 'destination_location_name',
  /** column name */
  DriverName = 'driver_name',
  /** column name */
  DriverNumber = 'driver_number',
  /** column name */
  EstimatedDate = 'estimated_date',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Remark = 'remark',
  /** column name */
  SourceLocationName = 'source_location_name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** input type for updating data in table "trip" */
export type Setutrade_Trip_Set_Input = {
  remark?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Setutrade_Trip_Stddev_Fields = {
  __typename?: 'setutrade_trip_stddev_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Setutrade_Trip_Stddev_Pop_Fields = {
  __typename?: 'setutrade_trip_stddev_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Setutrade_Trip_Stddev_Samp_Fields = {
  __typename?: 'setutrade_trip_stddev_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "setutrade_trip" */
export type Setutrade_Trip_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setutrade_Trip_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setutrade_Trip_Stream_Cursor_Value_Input = {
  aggregator_name?: InputMaybe<Scalars['String']>;
  aggregator_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  destination_location_name?: InputMaybe<Scalars['String']>;
  driver_name?: InputMaybe<Scalars['String']>;
  driver_number?: InputMaybe<Scalars['String']>;
  estimated_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  remark?: InputMaybe<Scalars['String']>;
  source_location_name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Setutrade_Trip_Sum_Fields = {
  __typename?: 'setutrade_trip_sum_fields';
  department_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

export type Setutrade_Trip_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Setutrade_Trip_Set_Input>;
  where: Setutrade_Trip_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Setutrade_Trip_Var_Pop_Fields = {
  __typename?: 'setutrade_trip_var_pop_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Setutrade_Trip_Var_Samp_Fields = {
  __typename?: 'setutrade_trip_var_samp_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Setutrade_Trip_Variance_Fields = {
  __typename?: 'setutrade_trip_variance_fields';
  department_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shareholder_applications" */
export type Shareholder_Applications = {
  __typename?: 'shareholder_applications';
  allocated_land: Scalars['numeric'];
  applying_as: Scalars['String'];
  co_owner?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Company;
  company_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  department?: Maybe<Department>;
  id: Scalars['Int'];
  is_archived?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name_as_per_pan?: Maybe<Scalars['String']>;
  /** An object relationship */
  nominee?: Maybe<Nominees>;
  nominee_id?: Maybe<Scalars['Int']>;
  quality_checked?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  relationship_with_nominee?: Maybe<Mutual_Group_Role>;
  relationship_with_nominee_id?: Maybe<Scalars['Int']>;
  send_for_verification?: Maybe<Scalars['Boolean']>;
  share_certificate_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  share_holder: Shareholders;
  share_holder_id: Scalars['Int'];
  share_issued_date?: Maybe<Scalars['date']>;
  share_number_from?: Maybe<Scalars['String']>;
  share_number_to?: Maybe<Scalars['String']>;
  share_price: Scalars['numeric'];
  shareholding_mode: Scalars['String'];
  signed_by_applicant: Scalars['Boolean'];
  signed_by_witness: Scalars['Boolean'];
  signed_document?: Maybe<Scalars['String']>;
  total_amount: Scalars['numeric'];
  total_shares: Scalars['bigint'];
  /** An object relationship */
  transaction?: Maybe<Transactions>;
  transaction_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  verified_by?: Maybe<Base_User>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  witness_aadhar_uid?: Maybe<Scalars['String']>;
  witness_email?: Maybe<Scalars['String']>;
  witness_mobile?: Maybe<Scalars['String']>;
  witness_name?: Maybe<Scalars['String']>;
};


/** columns and relationships of "shareholder_applications" */
export type Shareholder_ApplicationsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "shareholder_applications" */
export type Shareholder_Applications_Aggregate = {
  __typename?: 'shareholder_applications_aggregate';
  aggregate?: Maybe<Shareholder_Applications_Aggregate_Fields>;
  nodes: Array<Shareholder_Applications>;
};

/** aggregate fields of "shareholder_applications" */
export type Shareholder_Applications_Aggregate_Fields = {
  __typename?: 'shareholder_applications_aggregate_fields';
  avg?: Maybe<Shareholder_Applications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shareholder_Applications_Max_Fields>;
  min?: Maybe<Shareholder_Applications_Min_Fields>;
  stddev?: Maybe<Shareholder_Applications_Stddev_Fields>;
  stddev_pop?: Maybe<Shareholder_Applications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shareholder_Applications_Stddev_Samp_Fields>;
  sum?: Maybe<Shareholder_Applications_Sum_Fields>;
  var_pop?: Maybe<Shareholder_Applications_Var_Pop_Fields>;
  var_samp?: Maybe<Shareholder_Applications_Var_Samp_Fields>;
  variance?: Maybe<Shareholder_Applications_Variance_Fields>;
};


/** aggregate fields of "shareholder_applications" */
export type Shareholder_Applications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shareholder_applications" */
export type Shareholder_Applications_Aggregate_Order_By = {
  avg?: InputMaybe<Shareholder_Applications_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shareholder_Applications_Max_Order_By>;
  min?: InputMaybe<Shareholder_Applications_Min_Order_By>;
  stddev?: InputMaybe<Shareholder_Applications_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shareholder_Applications_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shareholder_Applications_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shareholder_Applications_Sum_Order_By>;
  var_pop?: InputMaybe<Shareholder_Applications_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shareholder_Applications_Var_Samp_Order_By>;
  variance?: InputMaybe<Shareholder_Applications_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Shareholder_Applications_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shareholder_applications" */
export type Shareholder_Applications_Arr_Rel_Insert_Input = {
  data: Array<Shareholder_Applications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shareholder_Applications_On_Conflict>;
};

/** aggregate avg on columns */
export type Shareholder_Applications_Avg_Fields = {
  __typename?: 'shareholder_applications_avg_fields';
  allocated_land?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
  relationship_with_nominee_id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  share_price?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_shares?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Avg_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shareholder_applications". All fields are combined with a logical 'AND'. */
export type Shareholder_Applications_Bool_Exp = {
  _and?: InputMaybe<Array<Shareholder_Applications_Bool_Exp>>;
  _not?: InputMaybe<Shareholder_Applications_Bool_Exp>;
  _or?: InputMaybe<Array<Shareholder_Applications_Bool_Exp>>;
  allocated_land?: InputMaybe<Numeric_Comparison_Exp>;
  applying_as?: InputMaybe<String_Comparison_Exp>;
  co_owner?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Company_Bool_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name_as_per_pan?: InputMaybe<String_Comparison_Exp>;
  nominee?: InputMaybe<Nominees_Bool_Exp>;
  nominee_id?: InputMaybe<Int_Comparison_Exp>;
  quality_checked?: InputMaybe<Boolean_Comparison_Exp>;
  relationship_with_nominee?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
  relationship_with_nominee_id?: InputMaybe<Int_Comparison_Exp>;
  send_for_verification?: InputMaybe<Boolean_Comparison_Exp>;
  share_certificate_number?: InputMaybe<String_Comparison_Exp>;
  share_holder?: InputMaybe<Shareholders_Bool_Exp>;
  share_holder_id?: InputMaybe<Int_Comparison_Exp>;
  share_issued_date?: InputMaybe<Date_Comparison_Exp>;
  share_number_from?: InputMaybe<String_Comparison_Exp>;
  share_number_to?: InputMaybe<String_Comparison_Exp>;
  share_price?: InputMaybe<Numeric_Comparison_Exp>;
  shareholding_mode?: InputMaybe<String_Comparison_Exp>;
  signed_by_applicant?: InputMaybe<Boolean_Comparison_Exp>;
  signed_by_witness?: InputMaybe<Boolean_Comparison_Exp>;
  signed_document?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_shares?: InputMaybe<Bigint_Comparison_Exp>;
  transaction?: InputMaybe<Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Base_User_Bool_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by?: InputMaybe<Base_User_Bool_Exp>;
  verified_by_id?: InputMaybe<Int_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  witness_aadhar_uid?: InputMaybe<String_Comparison_Exp>;
  witness_email?: InputMaybe<String_Comparison_Exp>;
  witness_mobile?: InputMaybe<String_Comparison_Exp>;
  witness_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shareholder_applications" */
export enum Shareholder_Applications_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShareholderApplicationsPkey = 'shareholder_applications_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Shareholder_Applications_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Shareholder_Applications_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Shareholder_Applications_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shareholder_applications" */
export type Shareholder_Applications_Inc_Input = {
  allocated_land?: InputMaybe<Scalars['numeric']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nominee_id?: InputMaybe<Scalars['Int']>;
  relationship_with_nominee_id?: InputMaybe<Scalars['Int']>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  share_price?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_shares?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shareholder_applications" */
export type Shareholder_Applications_Insert_Input = {
  allocated_land?: InputMaybe<Scalars['numeric']>;
  applying_as?: InputMaybe<Scalars['String']>;
  co_owner?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  department?: InputMaybe<Department_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name_as_per_pan?: InputMaybe<Scalars['String']>;
  nominee?: InputMaybe<Nominees_Obj_Rel_Insert_Input>;
  nominee_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  relationship_with_nominee?: InputMaybe<Mutual_Group_Role_Obj_Rel_Insert_Input>;
  relationship_with_nominee_id?: InputMaybe<Scalars['Int']>;
  send_for_verification?: InputMaybe<Scalars['Boolean']>;
  share_certificate_number?: InputMaybe<Scalars['String']>;
  share_holder?: InputMaybe<Shareholders_Obj_Rel_Insert_Input>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  share_issued_date?: InputMaybe<Scalars['date']>;
  share_number_from?: InputMaybe<Scalars['String']>;
  share_number_to?: InputMaybe<Scalars['String']>;
  share_price?: InputMaybe<Scalars['numeric']>;
  shareholding_mode?: InputMaybe<Scalars['String']>;
  signed_by_applicant?: InputMaybe<Scalars['Boolean']>;
  signed_by_witness?: InputMaybe<Scalars['Boolean']>;
  signed_document?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_shares?: InputMaybe<Scalars['bigint']>;
  transaction?: InputMaybe<Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  witness_aadhar_uid?: InputMaybe<Scalars['String']>;
  witness_email?: InputMaybe<Scalars['String']>;
  witness_mobile?: InputMaybe<Scalars['String']>;
  witness_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Shareholder_Applications_Max_Fields = {
  __typename?: 'shareholder_applications_max_fields';
  allocated_land?: Maybe<Scalars['numeric']>;
  applying_as?: Maybe<Scalars['String']>;
  co_owner?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name_as_per_pan?: Maybe<Scalars['String']>;
  nominee_id?: Maybe<Scalars['Int']>;
  relationship_with_nominee_id?: Maybe<Scalars['Int']>;
  share_certificate_number?: Maybe<Scalars['String']>;
  share_holder_id?: Maybe<Scalars['Int']>;
  share_issued_date?: Maybe<Scalars['date']>;
  share_number_from?: Maybe<Scalars['String']>;
  share_number_to?: Maybe<Scalars['String']>;
  share_price?: Maybe<Scalars['numeric']>;
  shareholding_mode?: Maybe<Scalars['String']>;
  signed_document?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_shares?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  witness_aadhar_uid?: Maybe<Scalars['String']>;
  witness_email?: Maybe<Scalars['String']>;
  witness_mobile?: Maybe<Scalars['String']>;
  witness_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Max_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  applying_as?: InputMaybe<Order_By>;
  co_owner?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_as_per_pan?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_certificate_number?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_issued_date?: InputMaybe<Order_By>;
  share_number_from?: InputMaybe<Order_By>;
  share_number_to?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  shareholding_mode?: InputMaybe<Order_By>;
  signed_document?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  witness_aadhar_uid?: InputMaybe<Order_By>;
  witness_email?: InputMaybe<Order_By>;
  witness_mobile?: InputMaybe<Order_By>;
  witness_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shareholder_Applications_Min_Fields = {
  __typename?: 'shareholder_applications_min_fields';
  allocated_land?: Maybe<Scalars['numeric']>;
  applying_as?: Maybe<Scalars['String']>;
  co_owner?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name_as_per_pan?: Maybe<Scalars['String']>;
  nominee_id?: Maybe<Scalars['Int']>;
  relationship_with_nominee_id?: Maybe<Scalars['Int']>;
  share_certificate_number?: Maybe<Scalars['String']>;
  share_holder_id?: Maybe<Scalars['Int']>;
  share_issued_date?: Maybe<Scalars['date']>;
  share_number_from?: Maybe<Scalars['String']>;
  share_number_to?: Maybe<Scalars['String']>;
  share_price?: Maybe<Scalars['numeric']>;
  shareholding_mode?: Maybe<Scalars['String']>;
  signed_document?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_shares?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['Int']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
  witness_aadhar_uid?: Maybe<Scalars['String']>;
  witness_email?: Maybe<Scalars['String']>;
  witness_mobile?: Maybe<Scalars['String']>;
  witness_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Min_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  applying_as?: InputMaybe<Order_By>;
  co_owner?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_as_per_pan?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_certificate_number?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_issued_date?: InputMaybe<Order_By>;
  share_number_from?: InputMaybe<Order_By>;
  share_number_to?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  shareholding_mode?: InputMaybe<Order_By>;
  signed_document?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  witness_aadhar_uid?: InputMaybe<Order_By>;
  witness_email?: InputMaybe<Order_By>;
  witness_mobile?: InputMaybe<Order_By>;
  witness_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shareholder_applications" */
export type Shareholder_Applications_Mutation_Response = {
  __typename?: 'shareholder_applications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shareholder_Applications>;
};

/** on_conflict condition type for table "shareholder_applications" */
export type Shareholder_Applications_On_Conflict = {
  constraint: Shareholder_Applications_Constraint;
  update_columns?: Array<Shareholder_Applications_Update_Column>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};

/** Ordering options when selecting data from "shareholder_applications". */
export type Shareholder_Applications_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  applying_as?: InputMaybe<Order_By>;
  co_owner?: InputMaybe<Order_By>;
  company?: InputMaybe<Company_Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name_as_per_pan?: InputMaybe<Order_By>;
  nominee?: InputMaybe<Nominees_Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  quality_checked?: InputMaybe<Order_By>;
  relationship_with_nominee?: InputMaybe<Mutual_Group_Role_Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  send_for_verification?: InputMaybe<Order_By>;
  share_certificate_number?: InputMaybe<Order_By>;
  share_holder?: InputMaybe<Shareholders_Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_issued_date?: InputMaybe<Order_By>;
  share_number_from?: InputMaybe<Order_By>;
  share_number_to?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  shareholding_mode?: InputMaybe<Order_By>;
  signed_by_applicant?: InputMaybe<Order_By>;
  signed_by_witness?: InputMaybe<Order_By>;
  signed_document?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Base_User_Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by?: InputMaybe<Base_User_Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
  witness_aadhar_uid?: InputMaybe<Order_By>;
  witness_email?: InputMaybe<Order_By>;
  witness_mobile?: InputMaybe<Order_By>;
  witness_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shareholder_applications */
export type Shareholder_Applications_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Shareholder_Applications_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shareholder_applications" */
export enum Shareholder_Applications_Select_Column {
  /** column name */
  AllocatedLand = 'allocated_land',
  /** column name */
  ApplyingAs = 'applying_as',
  /** column name */
  CoOwner = 'co_owner',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NameAsPerPan = 'name_as_per_pan',
  /** column name */
  NomineeId = 'nominee_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RelationshipWithNomineeId = 'relationship_with_nominee_id',
  /** column name */
  SendForVerification = 'send_for_verification',
  /** column name */
  ShareCertificateNumber = 'share_certificate_number',
  /** column name */
  ShareHolderId = 'share_holder_id',
  /** column name */
  ShareIssuedDate = 'share_issued_date',
  /** column name */
  ShareNumberFrom = 'share_number_from',
  /** column name */
  ShareNumberTo = 'share_number_to',
  /** column name */
  SharePrice = 'share_price',
  /** column name */
  ShareholdingMode = 'shareholding_mode',
  /** column name */
  SignedByApplicant = 'signed_by_applicant',
  /** column name */
  SignedByWitness = 'signed_by_witness',
  /** column name */
  SignedDocument = 'signed_document',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalShares = 'total_shares',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on',
  /** column name */
  WitnessAadharUid = 'witness_aadhar_uid',
  /** column name */
  WitnessEmail = 'witness_email',
  /** column name */
  WitnessMobile = 'witness_mobile',
  /** column name */
  WitnessName = 'witness_name'
}

/** input type for updating data in table "shareholder_applications" */
export type Shareholder_Applications_Set_Input = {
  allocated_land?: InputMaybe<Scalars['numeric']>;
  applying_as?: InputMaybe<Scalars['String']>;
  co_owner?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name_as_per_pan?: InputMaybe<Scalars['String']>;
  nominee_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  relationship_with_nominee_id?: InputMaybe<Scalars['Int']>;
  send_for_verification?: InputMaybe<Scalars['Boolean']>;
  share_certificate_number?: InputMaybe<Scalars['String']>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  share_issued_date?: InputMaybe<Scalars['date']>;
  share_number_from?: InputMaybe<Scalars['String']>;
  share_number_to?: InputMaybe<Scalars['String']>;
  share_price?: InputMaybe<Scalars['numeric']>;
  shareholding_mode?: InputMaybe<Scalars['String']>;
  signed_by_applicant?: InputMaybe<Scalars['Boolean']>;
  signed_by_witness?: InputMaybe<Scalars['Boolean']>;
  signed_document?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_shares?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  witness_aadhar_uid?: InputMaybe<Scalars['String']>;
  witness_email?: InputMaybe<Scalars['String']>;
  witness_mobile?: InputMaybe<Scalars['String']>;
  witness_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Shareholder_Applications_Stddev_Fields = {
  __typename?: 'shareholder_applications_stddev_fields';
  allocated_land?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
  relationship_with_nominee_id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  share_price?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_shares?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Stddev_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shareholder_Applications_Stddev_Pop_Fields = {
  __typename?: 'shareholder_applications_stddev_pop_fields';
  allocated_land?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
  relationship_with_nominee_id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  share_price?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_shares?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Stddev_Pop_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shareholder_Applications_Stddev_Samp_Fields = {
  __typename?: 'shareholder_applications_stddev_samp_fields';
  allocated_land?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
  relationship_with_nominee_id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  share_price?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_shares?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Stddev_Samp_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shareholder_applications" */
export type Shareholder_Applications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shareholder_Applications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shareholder_Applications_Stream_Cursor_Value_Input = {
  allocated_land?: InputMaybe<Scalars['numeric']>;
  applying_as?: InputMaybe<Scalars['String']>;
  co_owner?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name_as_per_pan?: InputMaybe<Scalars['String']>;
  nominee_id?: InputMaybe<Scalars['Int']>;
  quality_checked?: InputMaybe<Scalars['Boolean']>;
  relationship_with_nominee_id?: InputMaybe<Scalars['Int']>;
  send_for_verification?: InputMaybe<Scalars['Boolean']>;
  share_certificate_number?: InputMaybe<Scalars['String']>;
  share_holder_id?: InputMaybe<Scalars['Int']>;
  share_issued_date?: InputMaybe<Scalars['date']>;
  share_number_from?: InputMaybe<Scalars['String']>;
  share_number_to?: InputMaybe<Scalars['String']>;
  share_price?: InputMaybe<Scalars['numeric']>;
  shareholding_mode?: InputMaybe<Scalars['String']>;
  signed_by_applicant?: InputMaybe<Scalars['Boolean']>;
  signed_by_witness?: InputMaybe<Scalars['Boolean']>;
  signed_document?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_shares?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['Int']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
  witness_aadhar_uid?: InputMaybe<Scalars['String']>;
  witness_email?: InputMaybe<Scalars['String']>;
  witness_mobile?: InputMaybe<Scalars['String']>;
  witness_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Shareholder_Applications_Sum_Fields = {
  __typename?: 'shareholder_applications_sum_fields';
  allocated_land?: Maybe<Scalars['numeric']>;
  company_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nominee_id?: Maybe<Scalars['Int']>;
  relationship_with_nominee_id?: Maybe<Scalars['Int']>;
  share_holder_id?: Maybe<Scalars['Int']>;
  share_price?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_shares?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
  verified_by_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Sum_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** update columns of table "shareholder_applications" */
export enum Shareholder_Applications_Update_Column {
  /** column name */
  AllocatedLand = 'allocated_land',
  /** column name */
  ApplyingAs = 'applying_as',
  /** column name */
  CoOwner = 'co_owner',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NameAsPerPan = 'name_as_per_pan',
  /** column name */
  NomineeId = 'nominee_id',
  /** column name */
  QualityChecked = 'quality_checked',
  /** column name */
  RelationshipWithNomineeId = 'relationship_with_nominee_id',
  /** column name */
  SendForVerification = 'send_for_verification',
  /** column name */
  ShareCertificateNumber = 'share_certificate_number',
  /** column name */
  ShareHolderId = 'share_holder_id',
  /** column name */
  ShareIssuedDate = 'share_issued_date',
  /** column name */
  ShareNumberFrom = 'share_number_from',
  /** column name */
  ShareNumberTo = 'share_number_to',
  /** column name */
  SharePrice = 'share_price',
  /** column name */
  ShareholdingMode = 'shareholding_mode',
  /** column name */
  SignedByApplicant = 'signed_by_applicant',
  /** column name */
  SignedByWitness = 'signed_by_witness',
  /** column name */
  SignedDocument = 'signed_document',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalShares = 'total_shares',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on',
  /** column name */
  WitnessAadharUid = 'witness_aadhar_uid',
  /** column name */
  WitnessEmail = 'witness_email',
  /** column name */
  WitnessMobile = 'witness_mobile',
  /** column name */
  WitnessName = 'witness_name'
}

export type Shareholder_Applications_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Shareholder_Applications_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Shareholder_Applications_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Shareholder_Applications_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Shareholder_Applications_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shareholder_Applications_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Shareholder_Applications_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shareholder_Applications_Set_Input>;
  where: Shareholder_Applications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shareholder_Applications_Var_Pop_Fields = {
  __typename?: 'shareholder_applications_var_pop_fields';
  allocated_land?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
  relationship_with_nominee_id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  share_price?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_shares?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Var_Pop_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shareholder_Applications_Var_Samp_Fields = {
  __typename?: 'shareholder_applications_var_samp_fields';
  allocated_land?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
  relationship_with_nominee_id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  share_price?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_shares?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Var_Samp_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shareholder_Applications_Variance_Fields = {
  __typename?: 'shareholder_applications_variance_fields';
  allocated_land?: Maybe<Scalars['Float']>;
  company_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nominee_id?: Maybe<Scalars['Float']>;
  relationship_with_nominee_id?: Maybe<Scalars['Float']>;
  share_holder_id?: Maybe<Scalars['Float']>;
  share_price?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_shares?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
  verified_by_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shareholder_applications" */
export type Shareholder_Applications_Variance_Order_By = {
  allocated_land?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nominee_id?: InputMaybe<Order_By>;
  relationship_with_nominee_id?: InputMaybe<Order_By>;
  share_holder_id?: InputMaybe<Order_By>;
  share_price?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_shares?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "shareholders" */
export type Shareholders = {
  __typename?: 'shareholders';
  /** An array relationship */
  applications: Array<Shareholder_Applications>;
  /** An aggregate relationship */
  applications_aggregate: Shareholder_Applications_Aggregate;
  /** An object relationship */
  base_user: Base_User;
  base_user_id: Scalars['Int'];
  folio_number?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  organisation_id?: Maybe<Scalars['Int']>;
  total_land: Scalars['numeric'];
};


/** columns and relationships of "shareholders" */
export type ShareholdersApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


/** columns and relationships of "shareholders" */
export type ShareholdersApplications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};

/** aggregated selection of "shareholders" */
export type Shareholders_Aggregate = {
  __typename?: 'shareholders_aggregate';
  aggregate?: Maybe<Shareholders_Aggregate_Fields>;
  nodes: Array<Shareholders>;
};

/** aggregate fields of "shareholders" */
export type Shareholders_Aggregate_Fields = {
  __typename?: 'shareholders_aggregate_fields';
  avg?: Maybe<Shareholders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shareholders_Max_Fields>;
  min?: Maybe<Shareholders_Min_Fields>;
  stddev?: Maybe<Shareholders_Stddev_Fields>;
  stddev_pop?: Maybe<Shareholders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shareholders_Stddev_Samp_Fields>;
  sum?: Maybe<Shareholders_Sum_Fields>;
  var_pop?: Maybe<Shareholders_Var_Pop_Fields>;
  var_samp?: Maybe<Shareholders_Var_Samp_Fields>;
  variance?: Maybe<Shareholders_Variance_Fields>;
};


/** aggregate fields of "shareholders" */
export type Shareholders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shareholders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shareholders" */
export type Shareholders_Aggregate_Order_By = {
  avg?: InputMaybe<Shareholders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Shareholders_Max_Order_By>;
  min?: InputMaybe<Shareholders_Min_Order_By>;
  stddev?: InputMaybe<Shareholders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Shareholders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Shareholders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Shareholders_Sum_Order_By>;
  var_pop?: InputMaybe<Shareholders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Shareholders_Var_Samp_Order_By>;
  variance?: InputMaybe<Shareholders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shareholders" */
export type Shareholders_Arr_Rel_Insert_Input = {
  data: Array<Shareholders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Shareholders_On_Conflict>;
};

/** aggregate avg on columns */
export type Shareholders_Avg_Fields = {
  __typename?: 'shareholders_avg_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_land?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shareholders" */
export type Shareholders_Avg_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shareholders". All fields are combined with a logical 'AND'. */
export type Shareholders_Bool_Exp = {
  _and?: InputMaybe<Array<Shareholders_Bool_Exp>>;
  _not?: InputMaybe<Shareholders_Bool_Exp>;
  _or?: InputMaybe<Array<Shareholders_Bool_Exp>>;
  applications?: InputMaybe<Shareholder_Applications_Bool_Exp>;
  base_user?: InputMaybe<Base_User_Bool_Exp>;
  base_user_id?: InputMaybe<Int_Comparison_Exp>;
  folio_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  organisation_id?: InputMaybe<Int_Comparison_Exp>;
  total_land?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "shareholders" */
export enum Shareholders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShareholdersPkey = 'shareholders_pkey'
}

/** input type for incrementing numeric columns in table "shareholders" */
export type Shareholders_Inc_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_land?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "shareholders" */
export type Shareholders_Insert_Input = {
  applications?: InputMaybe<Shareholder_Applications_Arr_Rel_Insert_Input>;
  base_user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  base_user_id?: InputMaybe<Scalars['Int']>;
  folio_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_land?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Shareholders_Max_Fields = {
  __typename?: 'shareholders_max_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  folio_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  total_land?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "shareholders" */
export type Shareholders_Max_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  folio_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Shareholders_Min_Fields = {
  __typename?: 'shareholders_min_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  folio_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  total_land?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "shareholders" */
export type Shareholders_Min_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  folio_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shareholders" */
export type Shareholders_Mutation_Response = {
  __typename?: 'shareholders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shareholders>;
};

/** input type for inserting object relation for remote table "shareholders" */
export type Shareholders_Obj_Rel_Insert_Input = {
  data: Shareholders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shareholders_On_Conflict>;
};

/** on_conflict condition type for table "shareholders" */
export type Shareholders_On_Conflict = {
  constraint: Shareholders_Constraint;
  update_columns?: Array<Shareholders_Update_Column>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};

/** Ordering options when selecting data from "shareholders". */
export type Shareholders_Order_By = {
  applications_aggregate?: InputMaybe<Shareholder_Applications_Aggregate_Order_By>;
  base_user?: InputMaybe<Base_User_Order_By>;
  base_user_id?: InputMaybe<Order_By>;
  folio_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shareholders */
export type Shareholders_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shareholders" */
export enum Shareholders_Select_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  FolioNumber = 'folio_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  TotalLand = 'total_land'
}

/** input type for updating data in table "shareholders" */
export type Shareholders_Set_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  folio_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_land?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Shareholders_Stddev_Fields = {
  __typename?: 'shareholders_stddev_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_land?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shareholders" */
export type Shareholders_Stddev_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Shareholders_Stddev_Pop_Fields = {
  __typename?: 'shareholders_stddev_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_land?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shareholders" */
export type Shareholders_Stddev_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Shareholders_Stddev_Samp_Fields = {
  __typename?: 'shareholders_stddev_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_land?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shareholders" */
export type Shareholders_Stddev_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shareholders" */
export type Shareholders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shareholders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shareholders_Stream_Cursor_Value_Input = {
  base_user_id?: InputMaybe<Scalars['Int']>;
  folio_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  organisation_id?: InputMaybe<Scalars['Int']>;
  total_land?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Shareholders_Sum_Fields = {
  __typename?: 'shareholders_sum_fields';
  base_user_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organisation_id?: Maybe<Scalars['Int']>;
  total_land?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "shareholders" */
export type Shareholders_Sum_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** update columns of table "shareholders" */
export enum Shareholders_Update_Column {
  /** column name */
  BaseUserId = 'base_user_id',
  /** column name */
  FolioNumber = 'folio_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  TotalLand = 'total_land'
}

export type Shareholders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shareholders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shareholders_Set_Input>;
  where: Shareholders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shareholders_Var_Pop_Fields = {
  __typename?: 'shareholders_var_pop_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_land?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shareholders" */
export type Shareholders_Var_Pop_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Shareholders_Var_Samp_Fields = {
  __typename?: 'shareholders_var_samp_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_land?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shareholders" */
export type Shareholders_Var_Samp_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Shareholders_Variance_Fields = {
  __typename?: 'shareholders_variance_fields';
  base_user_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  total_land?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shareholders" */
export type Shareholders_Variance_Order_By = {
  base_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  total_land?: InputMaybe<Order_By>;
};

/** columns and relationships of "si_unit" */
export type Si_Unit = {
  __typename?: 'si_unit';
  base_conversion: Scalars['numeric'];
  /** An object relationship */
  base_unit?: Maybe<Si_Unit>;
  base_unit_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  long_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  measure_of?: Maybe<Si_Unit_Measure>;
  measure_of_id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  symbol?: Maybe<Scalars['String']>;
};

/** aggregated selection of "si_unit" */
export type Si_Unit_Aggregate = {
  __typename?: 'si_unit_aggregate';
  aggregate?: Maybe<Si_Unit_Aggregate_Fields>;
  nodes: Array<Si_Unit>;
};

/** aggregate fields of "si_unit" */
export type Si_Unit_Aggregate_Fields = {
  __typename?: 'si_unit_aggregate_fields';
  avg?: Maybe<Si_Unit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Si_Unit_Max_Fields>;
  min?: Maybe<Si_Unit_Min_Fields>;
  stddev?: Maybe<Si_Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Si_Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Si_Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Si_Unit_Sum_Fields>;
  var_pop?: Maybe<Si_Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Si_Unit_Var_Samp_Fields>;
  variance?: Maybe<Si_Unit_Variance_Fields>;
};


/** aggregate fields of "si_unit" */
export type Si_Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Si_Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Si_Unit_Avg_Fields = {
  __typename?: 'si_unit_avg_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  long_name?: InputMaybe<String_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  symbol?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "si_unit". All fields are combined with a logical 'AND'. */
export type Si_Unit_Bool_Exp_Remote_Rel_Shared_Entitysi_Unit = {
  _and?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  base_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitysi_Unit>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  long_name?: InputMaybe<String_Comparison_Exp>;
  measure_of?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  symbol?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "si_unit" */
export enum Si_Unit_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SiUnitCodenameKey = 'si_unit_codename_key',
  /** unique or primary key constraint on columns "id" */
  SiUnitPkey = 'si_unit_pkey'
}

/** input type for incrementing numeric columns in table "si_unit" */
export type Si_Unit_Inc_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "si_unit" */
export type Si_Unit_Insert_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  long_name?: InputMaybe<Scalars['String']>;
  measure_of?: InputMaybe<Si_Unit_Measure_Obj_Rel_Insert_Input>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Si_Unit_Max_Fields = {
  __typename?: 'si_unit_max_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  long_name?: Maybe<Scalars['String']>;
  measure_of_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

/** columns and relationships of "si_unit_measure" */
export type Si_Unit_Measure = {
  __typename?: 'si_unit_measure';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "si_unit_measure" */
export type Si_Unit_Measure_Aggregate = {
  __typename?: 'si_unit_measure_aggregate';
  aggregate?: Maybe<Si_Unit_Measure_Aggregate_Fields>;
  nodes: Array<Si_Unit_Measure>;
};

/** aggregate fields of "si_unit_measure" */
export type Si_Unit_Measure_Aggregate_Fields = {
  __typename?: 'si_unit_measure_aggregate_fields';
  avg?: Maybe<Si_Unit_Measure_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Si_Unit_Measure_Max_Fields>;
  min?: Maybe<Si_Unit_Measure_Min_Fields>;
  stddev?: Maybe<Si_Unit_Measure_Stddev_Fields>;
  stddev_pop?: Maybe<Si_Unit_Measure_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Si_Unit_Measure_Stddev_Samp_Fields>;
  sum?: Maybe<Si_Unit_Measure_Sum_Fields>;
  var_pop?: Maybe<Si_Unit_Measure_Var_Pop_Fields>;
  var_samp?: Maybe<Si_Unit_Measure_Var_Samp_Fields>;
  variance?: Maybe<Si_Unit_Measure_Variance_Fields>;
};


/** aggregate fields of "si_unit_measure" */
export type Si_Unit_Measure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Si_Unit_Measure_Avg_Fields = {
  __typename?: 'si_unit_measure_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "si_unit_measure". All fields are combined with a logical 'AND'. */
export type Si_Unit_Measure_Bool_Exp = {
  _and?: InputMaybe<Array<Si_Unit_Measure_Bool_Exp>>;
  _not?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
  _or?: InputMaybe<Array<Si_Unit_Measure_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "si_unit_measure" */
export enum Si_Unit_Measure_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SiUnitMeasureCodenameKey = 'si_unit_measure_codename_key',
  /** unique or primary key constraint on columns "id" */
  SiUnitMeasurePkey = 'si_unit_measure_pkey'
}

/** input type for incrementing numeric columns in table "si_unit_measure" */
export type Si_Unit_Measure_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "si_unit_measure" */
export type Si_Unit_Measure_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Si_Unit_Measure_Max_Fields = {
  __typename?: 'si_unit_measure_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Si_Unit_Measure_Min_Fields = {
  __typename?: 'si_unit_measure_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "si_unit_measure" */
export type Si_Unit_Measure_Mutation_Response = {
  __typename?: 'si_unit_measure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Si_Unit_Measure>;
};

/** input type for inserting object relation for remote table "si_unit_measure" */
export type Si_Unit_Measure_Obj_Rel_Insert_Input = {
  data: Si_Unit_Measure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Si_Unit_Measure_On_Conflict>;
};

/** on_conflict condition type for table "si_unit_measure" */
export type Si_Unit_Measure_On_Conflict = {
  constraint: Si_Unit_Measure_Constraint;
  update_columns?: Array<Si_Unit_Measure_Update_Column>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};

/** Ordering options when selecting data from "si_unit_measure". */
export type Si_Unit_Measure_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: si_unit_measure */
export type Si_Unit_Measure_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "si_unit_measure" */
export enum Si_Unit_Measure_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "si_unit_measure" */
export type Si_Unit_Measure_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Si_Unit_Measure_Stddev_Fields = {
  __typename?: 'si_unit_measure_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Si_Unit_Measure_Stddev_Pop_Fields = {
  __typename?: 'si_unit_measure_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Si_Unit_Measure_Stddev_Samp_Fields = {
  __typename?: 'si_unit_measure_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "si_unit_measure" */
export type Si_Unit_Measure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Si_Unit_Measure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Si_Unit_Measure_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Si_Unit_Measure_Sum_Fields = {
  __typename?: 'si_unit_measure_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "si_unit_measure" */
export enum Si_Unit_Measure_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Si_Unit_Measure_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Si_Unit_Measure_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Si_Unit_Measure_Set_Input>;
  where: Si_Unit_Measure_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Si_Unit_Measure_Var_Pop_Fields = {
  __typename?: 'si_unit_measure_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Si_Unit_Measure_Var_Samp_Fields = {
  __typename?: 'si_unit_measure_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Si_Unit_Measure_Variance_Fields = {
  __typename?: 'si_unit_measure_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Si_Unit_Min_Fields = {
  __typename?: 'si_unit_min_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  long_name?: Maybe<Scalars['String']>;
  measure_of_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "si_unit" */
export type Si_Unit_Mutation_Response = {
  __typename?: 'si_unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Si_Unit>;
};

/** input type for inserting object relation for remote table "si_unit" */
export type Si_Unit_Obj_Rel_Insert_Input = {
  data: Si_Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Si_Unit_On_Conflict>;
};

/** on_conflict condition type for table "si_unit" */
export type Si_Unit_On_Conflict = {
  constraint: Si_Unit_Constraint;
  update_columns?: Array<Si_Unit_Update_Column>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "si_unit". */
export type Si_Unit_Order_By = {
  base_conversion?: InputMaybe<Order_By>;
  base_unit?: InputMaybe<Si_Unit_Order_By>;
  base_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  long_name?: InputMaybe<Order_By>;
  measure_of?: InputMaybe<Si_Unit_Measure_Order_By>;
  measure_of_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  symbol?: InputMaybe<Order_By>;
};

/** primary key columns input for table: si_unit */
export type Si_Unit_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "si_unit" */
export enum Si_Unit_Select_Column {
  /** column name */
  BaseConversion = 'base_conversion',
  /** column name */
  BaseUnitId = 'base_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LongName = 'long_name',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name',
  /** column name */
  Symbol = 'symbol'
}

/** input type for updating data in table "si_unit" */
export type Si_Unit_Set_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  long_name?: InputMaybe<Scalars['String']>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Si_Unit_Stddev_Fields = {
  __typename?: 'si_unit_stddev_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Si_Unit_Stddev_Pop_Fields = {
  __typename?: 'si_unit_stddev_pop_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Si_Unit_Stddev_Samp_Fields = {
  __typename?: 'si_unit_stddev_samp_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "si_unit" */
export type Si_Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Si_Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Si_Unit_Stream_Cursor_Value_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  long_name?: InputMaybe<Scalars['String']>;
  measure_of_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Si_Unit_Sum_Fields = {
  __typename?: 'si_unit_sum_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  measure_of_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "si_unit" */
export enum Si_Unit_Update_Column {
  /** column name */
  BaseConversion = 'base_conversion',
  /** column name */
  BaseUnitId = 'base_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LongName = 'long_name',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name',
  /** column name */
  Symbol = 'symbol'
}

export type Si_Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Si_Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Si_Unit_Set_Input>;
  where: Si_Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Si_Unit_Var_Pop_Fields = {
  __typename?: 'si_unit_var_pop_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Si_Unit_Var_Samp_Fields = {
  __typename?: 'si_unit_var_samp_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Si_Unit_Variance_Fields = {
  __typename?: 'si_unit_variance_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sku" */
export type Sku = {
  __typename?: 'sku';
  capacity: Scalars['numeric'];
  /** An object relationship */
  capacity_unit: Si_Unit;
  capacity_unit_id: Scalars['Int'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  dimension_unit?: Maybe<Si_Unit>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  dimensions?: Maybe<Scalars['_numeric']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight: Scalars['numeric'];
  /** An object relationship */
  sku_kind: Sku_Kind;
  sku_kind_id: Scalars['Int'];
  unit_price: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "sku" */
export type Sku_Aggregate = {
  __typename?: 'sku_aggregate';
  aggregate?: Maybe<Sku_Aggregate_Fields>;
  nodes: Array<Sku>;
};

/** aggregate fields of "sku" */
export type Sku_Aggregate_Fields = {
  __typename?: 'sku_aggregate_fields';
  avg?: Maybe<Sku_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sku_Max_Fields>;
  min?: Maybe<Sku_Min_Fields>;
  stddev?: Maybe<Sku_Stddev_Fields>;
  stddev_pop?: Maybe<Sku_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sku_Stddev_Samp_Fields>;
  sum?: Maybe<Sku_Sum_Fields>;
  var_pop?: Maybe<Sku_Var_Pop_Fields>;
  var_samp?: Maybe<Sku_Var_Samp_Fields>;
  variance?: Maybe<Sku_Variance_Fields>;
};


/** aggregate fields of "sku" */
export type Sku_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sku_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sku_Avg_Fields = {
  __typename?: 'sku_avg_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sku". All fields are combined with a logical 'AND'. */
export type Sku_Bool_Exp = {
  _and?: InputMaybe<Array<Sku_Bool_Exp>>;
  _not?: InputMaybe<Sku_Bool_Exp>;
  _or?: InputMaybe<Array<Sku_Bool_Exp>>;
  capacity?: InputMaybe<Numeric_Comparison_Exp>;
  capacity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  capacity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dimension_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  dimension_unit_id?: InputMaybe<Int_Comparison_Exp>;
  dimensions?: InputMaybe<_Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  self_weight?: InputMaybe<Numeric_Comparison_Exp>;
  sku_kind?: InputMaybe<Sku_Kind_Bool_Exp>;
  sku_kind_id?: InputMaybe<Int_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "sku". All fields are combined with a logical 'AND'. */
export type Sku_Bool_Exp_Remote_Rel_Shared_Entitypackaging_Unit = {
  _and?: InputMaybe<Array<Sku_Bool_Exp>>;
  _not?: InputMaybe<Sku_Bool_Exp>;
  _or?: InputMaybe<Array<Sku_Bool_Exp>>;
  capacity?: InputMaybe<Numeric_Comparison_Exp>;
  capacity_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  capacity_unit_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entitypackaging_Unit>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dimension_unit?: InputMaybe<Si_Unit_Bool_Exp>;
  dimension_unit_id?: InputMaybe<Int_Comparison_Exp>;
  dimensions?: InputMaybe<_Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  self_weight?: InputMaybe<Numeric_Comparison_Exp>;
  sku_kind?: InputMaybe<Sku_Kind_Bool_Exp>;
  sku_kind_id?: InputMaybe<Int_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sku" */
export enum Sku_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SkuCodenameKey = 'sku_codename_key',
  /** unique or primary key constraint on columns "id" */
  SkuPkey = 'sku_pkey'
}

/** input type for incrementing numeric columns in table "sku" */
export type Sku_Inc_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sku" */
export type Sku_Insert_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dimension_unit?: InputMaybe<Si_Unit_Obj_Rel_Insert_Input>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<Scalars['_numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind?: InputMaybe<Sku_Kind_Obj_Rel_Insert_Input>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "sku_kind" */
export type Sku_Kind = {
  __typename?: 'sku_kind';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "sku_kind" */
export type Sku_Kind_Aggregate = {
  __typename?: 'sku_kind_aggregate';
  aggregate?: Maybe<Sku_Kind_Aggregate_Fields>;
  nodes: Array<Sku_Kind>;
};

/** aggregate fields of "sku_kind" */
export type Sku_Kind_Aggregate_Fields = {
  __typename?: 'sku_kind_aggregate_fields';
  avg?: Maybe<Sku_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sku_Kind_Max_Fields>;
  min?: Maybe<Sku_Kind_Min_Fields>;
  stddev?: Maybe<Sku_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Sku_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sku_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Sku_Kind_Sum_Fields>;
  var_pop?: Maybe<Sku_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Sku_Kind_Var_Samp_Fields>;
  variance?: Maybe<Sku_Kind_Variance_Fields>;
};


/** aggregate fields of "sku_kind" */
export type Sku_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sku_Kind_Avg_Fields = {
  __typename?: 'sku_kind_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sku_kind". All fields are combined with a logical 'AND'. */
export type Sku_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Sku_Kind_Bool_Exp>>;
  _not?: InputMaybe<Sku_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Sku_Kind_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sku_kind" */
export enum Sku_Kind_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SkuKindCodenameKey = 'sku_kind_codename_key',
  /** unique or primary key constraint on columns "id" */
  SkuKindPkey = 'sku_kind_pkey'
}

/** input type for incrementing numeric columns in table "sku_kind" */
export type Sku_Kind_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sku_kind" */
export type Sku_Kind_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Sku_Kind_Max_Fields = {
  __typename?: 'sku_kind_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sku_Kind_Min_Fields = {
  __typename?: 'sku_kind_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sku_kind" */
export type Sku_Kind_Mutation_Response = {
  __typename?: 'sku_kind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sku_Kind>;
};

/** input type for inserting object relation for remote table "sku_kind" */
export type Sku_Kind_Obj_Rel_Insert_Input = {
  data: Sku_Kind_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sku_Kind_On_Conflict>;
};

/** on_conflict condition type for table "sku_kind" */
export type Sku_Kind_On_Conflict = {
  constraint: Sku_Kind_Constraint;
  update_columns?: Array<Sku_Kind_Update_Column>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};

/** Ordering options when selecting data from "sku_kind". */
export type Sku_Kind_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sku_kind */
export type Sku_Kind_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sku_kind" */
export enum Sku_Kind_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "sku_kind" */
export type Sku_Kind_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Sku_Kind_Stddev_Fields = {
  __typename?: 'sku_kind_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sku_Kind_Stddev_Pop_Fields = {
  __typename?: 'sku_kind_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sku_Kind_Stddev_Samp_Fields = {
  __typename?: 'sku_kind_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sku_kind" */
export type Sku_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sku_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sku_Kind_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Sku_Kind_Sum_Fields = {
  __typename?: 'sku_kind_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "sku_kind" */
export enum Sku_Kind_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Sku_Kind_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sku_Kind_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sku_Kind_Set_Input>;
  where: Sku_Kind_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sku_Kind_Var_Pop_Fields = {
  __typename?: 'sku_kind_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sku_Kind_Var_Samp_Fields = {
  __typename?: 'sku_kind_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sku_Kind_Variance_Fields = {
  __typename?: 'sku_kind_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Sku_Max_Fields = {
  __typename?: 'sku_max_fields';
  capacity?: Maybe<Scalars['numeric']>;
  capacity_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight?: Maybe<Scalars['numeric']>;
  sku_kind_id?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Sku_Min_Fields = {
  __typename?: 'sku_min_fields';
  capacity?: Maybe<Scalars['numeric']>;
  capacity_unit_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight?: Maybe<Scalars['numeric']>;
  sku_kind_id?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sku" */
export type Sku_Mutation_Response = {
  __typename?: 'sku_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sku>;
};

/** input type for inserting object relation for remote table "sku" */
export type Sku_Obj_Rel_Insert_Input = {
  data: Sku_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sku_On_Conflict>;
};

/** on_conflict condition type for table "sku" */
export type Sku_On_Conflict = {
  constraint: Sku_Constraint;
  update_columns?: Array<Sku_Update_Column>;
  where?: InputMaybe<Sku_Bool_Exp>;
};

/** Ordering options when selecting data from "sku". */
export type Sku_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit?: InputMaybe<Si_Unit_Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dimension_unit?: InputMaybe<Si_Unit_Order_By>;
  dimension_unit_id?: InputMaybe<Order_By>;
  dimensions?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  self_weight?: InputMaybe<Order_By>;
  sku_kind?: InputMaybe<Sku_Kind_Order_By>;
  sku_kind_id?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sku */
export type Sku_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sku" */
export enum Sku_Select_Column {
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CapacityUnitId = 'capacity_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DimensionUnitId = 'dimension_unit_id',
  /** column name */
  Dimensions = 'dimensions',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  SelfWeight = 'self_weight',
  /** column name */
  SkuKindId = 'sku_kind_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sku" */
export type Sku_Set_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<Scalars['_numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Sku_Stddev_Fields = {
  __typename?: 'sku_stddev_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sku_Stddev_Pop_Fields = {
  __typename?: 'sku_stddev_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sku_Stddev_Samp_Fields = {
  __typename?: 'sku_stddev_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sku" */
export type Sku_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sku_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sku_Stream_Cursor_Value_Input = {
  capacity?: InputMaybe<Scalars['numeric']>;
  capacity_unit_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  dimension_unit_id?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<Scalars['_numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  self_weight?: InputMaybe<Scalars['numeric']>;
  sku_kind_id?: InputMaybe<Scalars['Int']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Sku_Sum_Fields = {
  __typename?: 'sku_sum_fields';
  capacity?: Maybe<Scalars['numeric']>;
  capacity_unit_id?: Maybe<Scalars['Int']>;
  dimension_unit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  self_weight?: Maybe<Scalars['numeric']>;
  sku_kind_id?: Maybe<Scalars['Int']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "sku" */
export enum Sku_Update_Column {
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CapacityUnitId = 'capacity_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DimensionUnitId = 'dimension_unit_id',
  /** column name */
  Dimensions = 'dimensions',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  SelfWeight = 'self_weight',
  /** column name */
  SkuKindId = 'sku_kind_id',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sku_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sku_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sku_Set_Input>;
  where: Sku_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sku_Var_Pop_Fields = {
  __typename?: 'sku_var_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sku_Var_Samp_Fields = {
  __typename?: 'sku_var_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sku_Variance_Fields = {
  __typename?: 'sku_variance_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  dimension_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  self_weight?: Maybe<Scalars['Float']>;
  sku_kind_id?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "soil" */
export type Soil = {
  __typename?: 'soil';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  field_capacity?: Maybe<Scalars['float8']>;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  photo_id?: Maybe<Scalars['Int']>;
  wilting_point?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "soil" */
export type Soil_Aggregate = {
  __typename?: 'soil_aggregate';
  aggregate?: Maybe<Soil_Aggregate_Fields>;
  nodes: Array<Soil>;
};

/** aggregate fields of "soil" */
export type Soil_Aggregate_Fields = {
  __typename?: 'soil_aggregate_fields';
  avg?: Maybe<Soil_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Soil_Max_Fields>;
  min?: Maybe<Soil_Min_Fields>;
  stddev?: Maybe<Soil_Stddev_Fields>;
  stddev_pop?: Maybe<Soil_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Soil_Stddev_Samp_Fields>;
  sum?: Maybe<Soil_Sum_Fields>;
  var_pop?: Maybe<Soil_Var_Pop_Fields>;
  var_samp?: Maybe<Soil_Var_Samp_Fields>;
  variance?: Maybe<Soil_Variance_Fields>;
};


/** aggregate fields of "soil" */
export type Soil_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Soil_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Soil_Avg_Fields = {
  __typename?: 'soil_avg_fields';
  field_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  wilting_point?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "soil". All fields are combined with a logical 'AND'. */
export type Soil_Bool_Exp = {
  _and?: InputMaybe<Array<Soil_Bool_Exp>>;
  _not?: InputMaybe<Soil_Bool_Exp>;
  _or?: InputMaybe<Array<Soil_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  field_capacity?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  wilting_point?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "soil" */
export enum Soil_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SoilCodenameKey = 'soil_codename_key',
  /** unique or primary key constraint on columns "id" */
  SoilPkey = 'soil_pkey'
}

/** input type for incrementing numeric columns in table "soil" */
export type Soil_Inc_Input = {
  field_capacity?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  wilting_point?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "soil" */
export type Soil_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  field_capacity?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  wilting_point?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Soil_Max_Fields = {
  __typename?: 'soil_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  field_capacity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  wilting_point?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Soil_Min_Fields = {
  __typename?: 'soil_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  field_capacity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  wilting_point?: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "soil" */
export type Soil_Mutation_Response = {
  __typename?: 'soil_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Soil>;
};

/** input type for inserting object relation for remote table "soil" */
export type Soil_Obj_Rel_Insert_Input = {
  data: Soil_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Soil_On_Conflict>;
};

/** on_conflict condition type for table "soil" */
export type Soil_On_Conflict = {
  constraint: Soil_Constraint;
  update_columns?: Array<Soil_Update_Column>;
  where?: InputMaybe<Soil_Bool_Exp>;
};

/** Ordering options when selecting data from "soil". */
export type Soil_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  field_capacity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo_id?: InputMaybe<Order_By>;
  wilting_point?: InputMaybe<Order_By>;
};

/** primary key columns input for table: soil */
export type Soil_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "soil" */
export enum Soil_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  FieldCapacity = 'field_capacity',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  WiltingPoint = 'wilting_point'
}

/** input type for updating data in table "soil" */
export type Soil_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  field_capacity?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  wilting_point?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Soil_Stddev_Fields = {
  __typename?: 'soil_stddev_fields';
  field_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  wilting_point?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Soil_Stddev_Pop_Fields = {
  __typename?: 'soil_stddev_pop_fields';
  field_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  wilting_point?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Soil_Stddev_Samp_Fields = {
  __typename?: 'soil_stddev_samp_fields';
  field_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  wilting_point?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "soil" */
export type Soil_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Soil_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Soil_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  field_capacity?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  wilting_point?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Soil_Sum_Fields = {
  __typename?: 'soil_sum_fields';
  field_capacity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
  wilting_point?: Maybe<Scalars['float8']>;
};

/** update columns of table "soil" */
export enum Soil_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  FieldCapacity = 'field_capacity',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  WiltingPoint = 'wilting_point'
}

export type Soil_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Soil_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Soil_Set_Input>;
  where: Soil_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Soil_Var_Pop_Fields = {
  __typename?: 'soil_var_pop_fields';
  field_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  wilting_point?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Soil_Var_Samp_Fields = {
  __typename?: 'soil_var_samp_fields';
  field_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  wilting_point?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Soil_Variance_Fields = {
  __typename?: 'soil_variance_fields';
  field_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
  wilting_point?: Maybe<Scalars['Float']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

/** columns and relationships of "stage_actions" */
export type Stage_Actions = {
  __typename?: 'stage_actions';
  content_template_sid?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An array relationship */
  logs: Array<Stage_Logs>;
  /** An aggregate relationship */
  logs_aggregate: Stage_Logs_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  stage: Stages;
  stage_id: Scalars['Int'];
  trigger_url?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "stage_actions" */
export type Stage_ActionsLogsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


/** columns and relationships of "stage_actions" */
export type Stage_ActionsLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


/** columns and relationships of "stage_actions" */
export type Stage_ActionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "stage_actions" */
export type Stage_Actions_Aggregate = {
  __typename?: 'stage_actions_aggregate';
  aggregate?: Maybe<Stage_Actions_Aggregate_Fields>;
  nodes: Array<Stage_Actions>;
};

/** aggregate fields of "stage_actions" */
export type Stage_Actions_Aggregate_Fields = {
  __typename?: 'stage_actions_aggregate_fields';
  avg?: Maybe<Stage_Actions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stage_Actions_Max_Fields>;
  min?: Maybe<Stage_Actions_Min_Fields>;
  stddev?: Maybe<Stage_Actions_Stddev_Fields>;
  stddev_pop?: Maybe<Stage_Actions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stage_Actions_Stddev_Samp_Fields>;
  sum?: Maybe<Stage_Actions_Sum_Fields>;
  var_pop?: Maybe<Stage_Actions_Var_Pop_Fields>;
  var_samp?: Maybe<Stage_Actions_Var_Samp_Fields>;
  variance?: Maybe<Stage_Actions_Variance_Fields>;
};


/** aggregate fields of "stage_actions" */
export type Stage_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stage_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stage_actions" */
export type Stage_Actions_Aggregate_Order_By = {
  avg?: InputMaybe<Stage_Actions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stage_Actions_Max_Order_By>;
  min?: InputMaybe<Stage_Actions_Min_Order_By>;
  stddev?: InputMaybe<Stage_Actions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stage_Actions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stage_Actions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stage_Actions_Sum_Order_By>;
  var_pop?: InputMaybe<Stage_Actions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stage_Actions_Var_Samp_Order_By>;
  variance?: InputMaybe<Stage_Actions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Stage_Actions_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "stage_actions" */
export type Stage_Actions_Arr_Rel_Insert_Input = {
  data: Array<Stage_Actions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stage_Actions_On_Conflict>;
};

/** aggregate avg on columns */
export type Stage_Actions_Avg_Fields = {
  __typename?: 'stage_actions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stage_actions" */
export type Stage_Actions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stage_actions". All fields are combined with a logical 'AND'. */
export type Stage_Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Stage_Actions_Bool_Exp>>;
  _not?: InputMaybe<Stage_Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Stage_Actions_Bool_Exp>>;
  content_template_sid?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logs?: InputMaybe<Stage_Logs_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stage?: InputMaybe<Stages_Bool_Exp>;
  stage_id?: InputMaybe<Int_Comparison_Exp>;
  trigger_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "stage_actions" */
export enum Stage_Actions_Constraint {
  /** unique or primary key constraint on columns "id" */
  StageActionsPkey = 'stage_actions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Stage_Actions_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Stage_Actions_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Stage_Actions_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "stage_actions" */
export type Stage_Actions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  stage_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stage_actions" */
export type Stage_Actions_Insert_Input = {
  content_template_sid?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logs?: InputMaybe<Stage_Logs_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Stages_Obj_Rel_Insert_Input>;
  stage_id?: InputMaybe<Scalars['Int']>;
  trigger_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Stage_Actions_Max_Fields = {
  __typename?: 'stage_actions_max_fields';
  content_template_sid?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  stage_id?: Maybe<Scalars['Int']>;
  trigger_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "stage_actions" */
export type Stage_Actions_Max_Order_By = {
  content_template_sid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  trigger_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stage_Actions_Min_Fields = {
  __typename?: 'stage_actions_min_fields';
  content_template_sid?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  stage_id?: Maybe<Scalars['Int']>;
  trigger_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "stage_actions" */
export type Stage_Actions_Min_Order_By = {
  content_template_sid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  trigger_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stage_actions" */
export type Stage_Actions_Mutation_Response = {
  __typename?: 'stage_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stage_Actions>;
};

/** input type for inserting object relation for remote table "stage_actions" */
export type Stage_Actions_Obj_Rel_Insert_Input = {
  data: Stage_Actions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stage_Actions_On_Conflict>;
};

/** on_conflict condition type for table "stage_actions" */
export type Stage_Actions_On_Conflict = {
  constraint: Stage_Actions_Constraint;
  update_columns?: Array<Stage_Actions_Update_Column>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "stage_actions". */
export type Stage_Actions_Order_By = {
  content_template_sid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Stage_Logs_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stage?: InputMaybe<Stages_Order_By>;
  stage_id?: InputMaybe<Order_By>;
  trigger_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stage_actions */
export type Stage_Actions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Stage_Actions_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "stage_actions" */
export enum Stage_Actions_Select_Column {
  /** column name */
  ContentTemplateSid = 'content_template_sid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TriggerUrl = 'trigger_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "stage_actions" */
export type Stage_Actions_Set_Input = {
  content_template_sid?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  stage_id?: InputMaybe<Scalars['Int']>;
  trigger_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Stage_Actions_Stddev_Fields = {
  __typename?: 'stage_actions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stage_actions" */
export type Stage_Actions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stage_Actions_Stddev_Pop_Fields = {
  __typename?: 'stage_actions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stage_actions" */
export type Stage_Actions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stage_Actions_Stddev_Samp_Fields = {
  __typename?: 'stage_actions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stage_actions" */
export type Stage_Actions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stage_actions" */
export type Stage_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stage_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stage_Actions_Stream_Cursor_Value_Input = {
  content_template_sid?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  stage_id?: InputMaybe<Scalars['Int']>;
  trigger_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stage_Actions_Sum_Fields = {
  __typename?: 'stage_actions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  stage_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stage_actions" */
export type Stage_Actions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** update columns of table "stage_actions" */
export enum Stage_Actions_Update_Column {
  /** column name */
  ContentTemplateSid = 'content_template_sid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TriggerUrl = 'trigger_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Stage_Actions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Stage_Actions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Stage_Actions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Stage_Actions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Stage_Actions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stage_Actions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Stage_Actions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stage_Actions_Set_Input>;
  where: Stage_Actions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stage_Actions_Var_Pop_Fields = {
  __typename?: 'stage_actions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stage_actions" */
export type Stage_Actions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stage_Actions_Var_Samp_Fields = {
  __typename?: 'stage_actions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stage_actions" */
export type Stage_Actions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stage_Actions_Variance_Fields = {
  __typename?: 'stage_actions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  stage_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stage_actions" */
export type Stage_Actions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "stage_logs" */
export type Stage_Logs = {
  __typename?: 'stage_logs';
  /** An object relationship */
  action: Stage_Actions;
  action_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  entity_codename?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  metadata: Scalars['jsonb'];
  notified_subscribers: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "stage_logs" */
export type Stage_LogsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "stage_logs" */
export type Stage_Logs_Aggregate = {
  __typename?: 'stage_logs_aggregate';
  aggregate?: Maybe<Stage_Logs_Aggregate_Fields>;
  nodes: Array<Stage_Logs>;
};

/** aggregate fields of "stage_logs" */
export type Stage_Logs_Aggregate_Fields = {
  __typename?: 'stage_logs_aggregate_fields';
  avg?: Maybe<Stage_Logs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stage_Logs_Max_Fields>;
  min?: Maybe<Stage_Logs_Min_Fields>;
  stddev?: Maybe<Stage_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Stage_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stage_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Stage_Logs_Sum_Fields>;
  var_pop?: Maybe<Stage_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Stage_Logs_Var_Samp_Fields>;
  variance?: Maybe<Stage_Logs_Variance_Fields>;
};


/** aggregate fields of "stage_logs" */
export type Stage_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stage_logs" */
export type Stage_Logs_Aggregate_Order_By = {
  avg?: InputMaybe<Stage_Logs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stage_Logs_Max_Order_By>;
  min?: InputMaybe<Stage_Logs_Min_Order_By>;
  stddev?: InputMaybe<Stage_Logs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stage_Logs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stage_Logs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stage_Logs_Sum_Order_By>;
  var_pop?: InputMaybe<Stage_Logs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stage_Logs_Var_Samp_Order_By>;
  variance?: InputMaybe<Stage_Logs_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Stage_Logs_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "stage_logs" */
export type Stage_Logs_Arr_Rel_Insert_Input = {
  data: Array<Stage_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stage_Logs_On_Conflict>;
};

/** aggregate avg on columns */
export type Stage_Logs_Avg_Fields = {
  __typename?: 'stage_logs_avg_fields';
  action_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stage_logs" */
export type Stage_Logs_Avg_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stage_logs". All fields are combined with a logical 'AND'. */
export type Stage_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Stage_Logs_Bool_Exp>>;
  _not?: InputMaybe<Stage_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Stage_Logs_Bool_Exp>>;
  action?: InputMaybe<Stage_Actions_Bool_Exp>;
  action_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  entity_codename?: InputMaybe<String_Comparison_Exp>;
  entity_id?: InputMaybe<Bigint_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  notified_subscribers?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "stage_logs" */
export enum Stage_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  StageLogsPkey = 'stage_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Stage_Logs_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Stage_Logs_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Stage_Logs_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "stage_logs" */
export type Stage_Logs_Inc_Input = {
  action_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stage_logs" */
export type Stage_Logs_Insert_Input = {
  action?: InputMaybe<Stage_Actions_Obj_Rel_Insert_Input>;
  action_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  notified_subscribers?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Stage_Logs_Max_Fields = {
  __typename?: 'stage_logs_max_fields';
  action_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  entity_codename?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "stage_logs" */
export type Stage_Logs_Max_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stage_Logs_Min_Fields = {
  __typename?: 'stage_logs_min_fields';
  action_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  entity_codename?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "stage_logs" */
export type Stage_Logs_Min_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stage_logs" */
export type Stage_Logs_Mutation_Response = {
  __typename?: 'stage_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stage_Logs>;
};

/** input type for inserting object relation for remote table "stage_logs" */
export type Stage_Logs_Obj_Rel_Insert_Input = {
  data: Stage_Logs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stage_Logs_On_Conflict>;
};

/** on_conflict condition type for table "stage_logs" */
export type Stage_Logs_On_Conflict = {
  constraint: Stage_Logs_Constraint;
  update_columns?: Array<Stage_Logs_Update_Column>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "stage_logs". */
export type Stage_Logs_Order_By = {
  action?: InputMaybe<Stage_Actions_Order_By>;
  action_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  notified_subscribers?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stage_logs */
export type Stage_Logs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Stage_Logs_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "stage_logs" */
export enum Stage_Logs_Select_Column {
  /** column name */
  ActionId = 'action_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EntityCodename = 'entity_codename',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NotifiedSubscribers = 'notified_subscribers',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "stage_logs" */
export type Stage_Logs_Set_Input = {
  action_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  notified_subscribers?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Stage_Logs_Stddev_Fields = {
  __typename?: 'stage_logs_stddev_fields';
  action_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stage_logs" */
export type Stage_Logs_Stddev_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stage_Logs_Stddev_Pop_Fields = {
  __typename?: 'stage_logs_stddev_pop_fields';
  action_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stage_logs" */
export type Stage_Logs_Stddev_Pop_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stage_Logs_Stddev_Samp_Fields = {
  __typename?: 'stage_logs_stddev_samp_fields';
  action_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stage_logs" */
export type Stage_Logs_Stddev_Samp_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stage_logs" */
export type Stage_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stage_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stage_Logs_Stream_Cursor_Value_Input = {
  action_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  notified_subscribers?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stage_Logs_Sum_Fields = {
  __typename?: 'stage_logs_sum_fields';
  action_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  entity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stage_logs" */
export type Stage_Logs_Sum_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "stage_logs" */
export enum Stage_Logs_Update_Column {
  /** column name */
  ActionId = 'action_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EntityCodename = 'entity_codename',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NotifiedSubscribers = 'notified_subscribers',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Stage_Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Stage_Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Stage_Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Stage_Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Stage_Logs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stage_Logs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Stage_Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stage_Logs_Set_Input>;
  where: Stage_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stage_Logs_Var_Pop_Fields = {
  __typename?: 'stage_logs_var_pop_fields';
  action_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stage_logs" */
export type Stage_Logs_Var_Pop_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stage_Logs_Var_Samp_Fields = {
  __typename?: 'stage_logs_var_samp_fields';
  action_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stage_logs" */
export type Stage_Logs_Var_Samp_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stage_Logs_Variance_Fields = {
  __typename?: 'stage_logs_variance_fields';
  action_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stage_logs" */
export type Stage_Logs_Variance_Order_By = {
  action_id?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "stages" */
export type Stages = {
  __typename?: 'stages';
  /** An array relationship */
  actions: Array<Stage_Actions>;
  /** An aggregate relationship */
  actions_aggregate: Stage_Actions_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_automated: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  parent_stage?: Maybe<Stages>;
  parent_stage_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  permission?: Maybe<Auth_Permission>;
  permission_id?: Maybe<Scalars['Int']>;
  sequence_no: Scalars['smallint'];
  /** An array relationship */
  stage_subscribers: Array<Stages_Subscribers>;
  /** An aggregate relationship */
  stage_subscribers_aggregate: Stages_Subscribers_Aggregate;
  /** An object relationship */
  subscribers?: Maybe<Stages_Subscribers>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workflow: Workflows;
  workflow_id: Scalars['Int'];
};


/** columns and relationships of "stages" */
export type StagesActionsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Actions_Order_By>>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};


/** columns and relationships of "stages" */
export type StagesActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Actions_Order_By>>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};


/** columns and relationships of "stages" */
export type StagesStage_SubscribersArgs = {
  distinct_on?: InputMaybe<Array<Stages_Subscribers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Subscribers_Order_By>>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};


/** columns and relationships of "stages" */
export type StagesStage_Subscribers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stages_Subscribers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Subscribers_Order_By>>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};

/** aggregated selection of "stages" */
export type Stages_Aggregate = {
  __typename?: 'stages_aggregate';
  aggregate?: Maybe<Stages_Aggregate_Fields>;
  nodes: Array<Stages>;
};

/** aggregate fields of "stages" */
export type Stages_Aggregate_Fields = {
  __typename?: 'stages_aggregate_fields';
  avg?: Maybe<Stages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stages_Max_Fields>;
  min?: Maybe<Stages_Min_Fields>;
  stddev?: Maybe<Stages_Stddev_Fields>;
  stddev_pop?: Maybe<Stages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stages_Stddev_Samp_Fields>;
  sum?: Maybe<Stages_Sum_Fields>;
  var_pop?: Maybe<Stages_Var_Pop_Fields>;
  var_samp?: Maybe<Stages_Var_Samp_Fields>;
  variance?: Maybe<Stages_Variance_Fields>;
};


/** aggregate fields of "stages" */
export type Stages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stages" */
export type Stages_Aggregate_Order_By = {
  avg?: InputMaybe<Stages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stages_Max_Order_By>;
  min?: InputMaybe<Stages_Min_Order_By>;
  stddev?: InputMaybe<Stages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stages_Sum_Order_By>;
  var_pop?: InputMaybe<Stages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stages_Var_Samp_Order_By>;
  variance?: InputMaybe<Stages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stages" */
export type Stages_Arr_Rel_Insert_Input = {
  data: Array<Stages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stages_On_Conflict>;
};

/** aggregate avg on columns */
export type Stages_Avg_Fields = {
  __typename?: 'stages_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stages" */
export type Stages_Avg_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stages". All fields are combined with a logical 'AND'. */
export type Stages_Bool_Exp = {
  _and?: InputMaybe<Array<Stages_Bool_Exp>>;
  _not?: InputMaybe<Stages_Bool_Exp>;
  _or?: InputMaybe<Array<Stages_Bool_Exp>>;
  actions?: InputMaybe<Stage_Actions_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_automated?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_stage?: InputMaybe<Stages_Bool_Exp>;
  parent_stage_id?: InputMaybe<Int_Comparison_Exp>;
  permission?: InputMaybe<Auth_Permission_Bool_Exp>;
  permission_id?: InputMaybe<Int_Comparison_Exp>;
  sequence_no?: InputMaybe<Smallint_Comparison_Exp>;
  stage_subscribers?: InputMaybe<Stages_Subscribers_Bool_Exp>;
  subscribers?: InputMaybe<Stages_Subscribers_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workflow?: InputMaybe<Workflows_Bool_Exp>;
  workflow_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "stages" */
export enum Stages_Constraint {
  /** unique or primary key constraint on columns "codename" */
  StagesCodename_11cb6b3cUniq = 'stages_codename_11cb6b3c_uniq',
  /** unique or primary key constraint on columns "id" */
  StagesPkey = 'stages_pkey'
}

/** input type for incrementing numeric columns in table "stages" */
export type Stages_Inc_Input = {
  created_by_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_stage_id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stages" */
export type Stages_Insert_Input = {
  actions?: InputMaybe<Stage_Actions_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_automated?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_stage?: InputMaybe<Stages_Obj_Rel_Insert_Input>;
  parent_stage_id?: InputMaybe<Scalars['Int']>;
  permission?: InputMaybe<Auth_Permission_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  stage_subscribers?: InputMaybe<Stages_Subscribers_Arr_Rel_Insert_Input>;
  subscribers?: InputMaybe<Stages_Subscribers_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow?: InputMaybe<Workflows_Obj_Rel_Insert_Input>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Stages_Max_Fields = {
  __typename?: 'stages_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_stage_id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "stages" */
export type Stages_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stages_Min_Fields = {
  __typename?: 'stages_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parent_stage_id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "stages" */
export type Stages_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stages" */
export type Stages_Mutation_Response = {
  __typename?: 'stages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stages>;
};

/** input type for inserting object relation for remote table "stages" */
export type Stages_Obj_Rel_Insert_Input = {
  data: Stages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stages_On_Conflict>;
};

/** on_conflict condition type for table "stages" */
export type Stages_On_Conflict = {
  constraint: Stages_Constraint;
  update_columns?: Array<Stages_Update_Column>;
  where?: InputMaybe<Stages_Bool_Exp>;
};

/** Ordering options when selecting data from "stages". */
export type Stages_Order_By = {
  actions_aggregate?: InputMaybe<Stage_Actions_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_automated?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_stage?: InputMaybe<Stages_Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Auth_Permission_Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  stage_subscribers_aggregate?: InputMaybe<Stages_Subscribers_Aggregate_Order_By>;
  subscribers?: InputMaybe<Stages_Subscribers_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow?: InputMaybe<Workflows_Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stages */
export type Stages_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stages" */
export enum Stages_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsAutomated = 'is_automated',
  /** column name */
  Name = 'name',
  /** column name */
  ParentStageId = 'parent_stage_id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "stages" */
export type Stages_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_automated?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_stage_id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Stages_Stddev_Fields = {
  __typename?: 'stages_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stages" */
export type Stages_Stddev_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stages_Stddev_Pop_Fields = {
  __typename?: 'stages_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stages" */
export type Stages_Stddev_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stages_Stddev_Samp_Fields = {
  __typename?: 'stages_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stages" */
export type Stages_Stddev_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stages" */
export type Stages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stages_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_automated?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parent_stage_id?: InputMaybe<Scalars['Int']>;
  permission_id?: InputMaybe<Scalars['Int']>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "stages_subscribers" */
export type Stages_Subscribers = {
  __typename?: 'stages_subscribers';
  baseuser_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  stage: Stages;
  stages_id: Scalars['Int'];
  /** An object relationship */
  user: Base_User;
};

/** aggregated selection of "stages_subscribers" */
export type Stages_Subscribers_Aggregate = {
  __typename?: 'stages_subscribers_aggregate';
  aggregate?: Maybe<Stages_Subscribers_Aggregate_Fields>;
  nodes: Array<Stages_Subscribers>;
};

/** aggregate fields of "stages_subscribers" */
export type Stages_Subscribers_Aggregate_Fields = {
  __typename?: 'stages_subscribers_aggregate_fields';
  avg?: Maybe<Stages_Subscribers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stages_Subscribers_Max_Fields>;
  min?: Maybe<Stages_Subscribers_Min_Fields>;
  stddev?: Maybe<Stages_Subscribers_Stddev_Fields>;
  stddev_pop?: Maybe<Stages_Subscribers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stages_Subscribers_Stddev_Samp_Fields>;
  sum?: Maybe<Stages_Subscribers_Sum_Fields>;
  var_pop?: Maybe<Stages_Subscribers_Var_Pop_Fields>;
  var_samp?: Maybe<Stages_Subscribers_Var_Samp_Fields>;
  variance?: Maybe<Stages_Subscribers_Variance_Fields>;
};


/** aggregate fields of "stages_subscribers" */
export type Stages_Subscribers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stages_Subscribers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stages_subscribers" */
export type Stages_Subscribers_Aggregate_Order_By = {
  avg?: InputMaybe<Stages_Subscribers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stages_Subscribers_Max_Order_By>;
  min?: InputMaybe<Stages_Subscribers_Min_Order_By>;
  stddev?: InputMaybe<Stages_Subscribers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stages_Subscribers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stages_Subscribers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stages_Subscribers_Sum_Order_By>;
  var_pop?: InputMaybe<Stages_Subscribers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stages_Subscribers_Var_Samp_Order_By>;
  variance?: InputMaybe<Stages_Subscribers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stages_subscribers" */
export type Stages_Subscribers_Arr_Rel_Insert_Input = {
  data: Array<Stages_Subscribers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stages_Subscribers_On_Conflict>;
};

/** aggregate avg on columns */
export type Stages_Subscribers_Avg_Fields = {
  __typename?: 'stages_subscribers_avg_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  stages_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Avg_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stages_subscribers". All fields are combined with a logical 'AND'. */
export type Stages_Subscribers_Bool_Exp = {
  _and?: InputMaybe<Array<Stages_Subscribers_Bool_Exp>>;
  _not?: InputMaybe<Stages_Subscribers_Bool_Exp>;
  _or?: InputMaybe<Array<Stages_Subscribers_Bool_Exp>>;
  baseuser_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  stage?: InputMaybe<Stages_Bool_Exp>;
  stages_id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Base_User_Bool_Exp>;
};

/** unique or primary key constraints on table "stages_subscribers" */
export enum Stages_Subscribers_Constraint {
  /** unique or primary key constraint on columns "id" */
  StagesSubscribersPkey = 'stages_subscribers_pkey',
  /** unique or primary key constraint on columns "baseuser_id", "stages_id" */
  StagesSubscribersStagesIdBaseuserId_981f4dceUniq = 'stages_subscribers_stages_id_baseuser_id_981f4dce_uniq'
}

/** input type for incrementing numeric columns in table "stages_subscribers" */
export type Stages_Subscribers_Inc_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  stages_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stages_subscribers" */
export type Stages_Subscribers_Insert_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stages_Obj_Rel_Insert_Input>;
  stages_id?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Stages_Subscribers_Max_Fields = {
  __typename?: 'stages_subscribers_max_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  stages_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Max_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stages_Subscribers_Min_Fields = {
  __typename?: 'stages_subscribers_min_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  stages_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Min_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stages_subscribers" */
export type Stages_Subscribers_Mutation_Response = {
  __typename?: 'stages_subscribers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stages_Subscribers>;
};

/** input type for inserting object relation for remote table "stages_subscribers" */
export type Stages_Subscribers_Obj_Rel_Insert_Input = {
  data: Stages_Subscribers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stages_Subscribers_On_Conflict>;
};

/** on_conflict condition type for table "stages_subscribers" */
export type Stages_Subscribers_On_Conflict = {
  constraint: Stages_Subscribers_Constraint;
  update_columns?: Array<Stages_Subscribers_Update_Column>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};

/** Ordering options when selecting data from "stages_subscribers". */
export type Stages_Subscribers_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Stages_Order_By>;
  stages_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Base_User_Order_By>;
};

/** primary key columns input for table: stages_subscribers */
export type Stages_Subscribers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stages_subscribers" */
export enum Stages_Subscribers_Select_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id',
  /** column name */
  StagesId = 'stages_id'
}

/** input type for updating data in table "stages_subscribers" */
export type Stages_Subscribers_Set_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  stages_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Stages_Subscribers_Stddev_Fields = {
  __typename?: 'stages_subscribers_stddev_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  stages_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Stddev_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stages_Subscribers_Stddev_Pop_Fields = {
  __typename?: 'stages_subscribers_stddev_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  stages_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Stddev_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stages_Subscribers_Stddev_Samp_Fields = {
  __typename?: 'stages_subscribers_stddev_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  stages_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Stddev_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stages_subscribers" */
export type Stages_Subscribers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stages_Subscribers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stages_Subscribers_Stream_Cursor_Value_Input = {
  baseuser_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  stages_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Stages_Subscribers_Sum_Fields = {
  __typename?: 'stages_subscribers_sum_fields';
  baseuser_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  stages_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Sum_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** update columns of table "stages_subscribers" */
export enum Stages_Subscribers_Update_Column {
  /** column name */
  BaseuserId = 'baseuser_id',
  /** column name */
  Id = 'id',
  /** column name */
  StagesId = 'stages_id'
}

export type Stages_Subscribers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stages_Subscribers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stages_Subscribers_Set_Input>;
  where: Stages_Subscribers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stages_Subscribers_Var_Pop_Fields = {
  __typename?: 'stages_subscribers_var_pop_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  stages_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Var_Pop_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stages_Subscribers_Var_Samp_Fields = {
  __typename?: 'stages_subscribers_var_samp_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  stages_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Var_Samp_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stages_Subscribers_Variance_Fields = {
  __typename?: 'stages_subscribers_variance_fields';
  baseuser_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  stages_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stages_subscribers" */
export type Stages_Subscribers_Variance_Order_By = {
  baseuser_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stages_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Stages_Sum_Fields = {
  __typename?: 'stages_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_stage_id?: Maybe<Scalars['Int']>;
  permission_id?: Maybe<Scalars['Int']>;
  sequence_no?: Maybe<Scalars['smallint']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stages" */
export type Stages_Sum_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** update columns of table "stages" */
export enum Stages_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsAutomated = 'is_automated',
  /** column name */
  Name = 'name',
  /** column name */
  ParentStageId = 'parent_stage_id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

export type Stages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stages_Set_Input>;
  where: Stages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stages_Var_Pop_Fields = {
  __typename?: 'stages_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stages" */
export type Stages_Var_Pop_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stages_Var_Samp_Fields = {
  __typename?: 'stages_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stages" */
export type Stages_Var_Samp_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stages_Variance_Fields = {
  __typename?: 'stages_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_stage_id?: Maybe<Scalars['Float']>;
  permission_id?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stages" */
export type Stages_Variance_Order_By = {
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_stage_id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "state" */
export type State = {
  __typename?: 'state';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  display_name: Scalars['String'];
  /** An array relationship */
  entities: Array<Entity_State>;
  /** An aggregate relationship */
  entities_aggregate: Entity_State_Aggregate;
  /** An array relationship */
  from_transition_logs: Array<Transition_History>;
  /** An aggregate relationship */
  from_transition_logs_aggregate: Transition_History_Aggregate;
  /** An array relationship */
  from_transitions: Array<Transition>;
  /** An aggregate relationship */
  from_transitions_aggregate: Transition_Aggregate;
  id: Scalars['bigint'];
  /** An array relationship */
  initiates: Array<Workflow>;
  /** An aggregate relationship */
  initiates_aggregate: Workflow_Aggregate;
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  sequence: Scalars['String'];
  /** An array relationship */
  to_transition_logs: Array<Transition_History>;
  /** An aggregate relationship */
  to_transition_logs_aggregate: Transition_History_Aggregate;
  /** An array relationship */
  to_transitions: Array<Transition>;
  /** An aggregate relationship */
  to_transitions_aggregate: Transition_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "state" */
export type StateEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateFrom_Transition_LogsArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateFrom_Transition_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateFrom_TransitionsArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateFrom_Transitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateInitiatesArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateInitiates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "state" */
export type StatePrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "state" */
export type StateTo_Transition_LogsArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateTo_Transition_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateTo_TransitionsArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


/** columns and relationships of "state" */
export type StateTo_Transitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};

/** aggregated selection of "state" */
export type State_Aggregate = {
  __typename?: 'state_aggregate';
  aggregate?: Maybe<State_Aggregate_Fields>;
  nodes: Array<State>;
};

/** aggregate fields of "state" */
export type State_Aggregate_Fields = {
  __typename?: 'state_aggregate_fields';
  avg?: Maybe<State_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<State_Max_Fields>;
  min?: Maybe<State_Min_Fields>;
  stddev?: Maybe<State_Stddev_Fields>;
  stddev_pop?: Maybe<State_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<State_Stddev_Samp_Fields>;
  sum?: Maybe<State_Sum_Fields>;
  var_pop?: Maybe<State_Var_Pop_Fields>;
  var_samp?: Maybe<State_Var_Samp_Fields>;
  variance?: Maybe<State_Variance_Fields>;
};


/** aggregate fields of "state" */
export type State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<State_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type State_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type State_Avg_Fields = {
  __typename?: 'state_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "state". All fields are combined with a logical 'AND'. */
export type State_Bool_Exp = {
  _and?: InputMaybe<Array<State_Bool_Exp>>;
  _not?: InputMaybe<State_Bool_Exp>;
  _or?: InputMaybe<Array<State_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  entities?: InputMaybe<Entity_State_Bool_Exp>;
  from_transition_logs?: InputMaybe<Transition_History_Bool_Exp>;
  from_transitions?: InputMaybe<Transition_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  initiates?: InputMaybe<Workflow_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  sequence?: InputMaybe<String_Comparison_Exp>;
  to_transition_logs?: InputMaybe<Transition_History_Bool_Exp>;
  to_transitions?: InputMaybe<Transition_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "state" */
export enum State_Constraint {
  /** unique or primary key constraint on columns "codename" */
  StateCodenameKey = 'state_codename_key',
  /** unique or primary key constraint on columns "name" */
  StateNameKey = 'state_name_key',
  /** unique or primary key constraint on columns "id" */
  StatePkey = 'state_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type State_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type State_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type State_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "state" */
export type State_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "state" */
export type State_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  entities?: InputMaybe<Entity_State_Arr_Rel_Insert_Input>;
  from_transition_logs?: InputMaybe<Transition_History_Arr_Rel_Insert_Input>;
  from_transitions?: InputMaybe<Transition_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  initiates?: InputMaybe<Workflow_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  sequence?: InputMaybe<Scalars['String']>;
  to_transition_logs?: InputMaybe<Transition_History_Arr_Rel_Insert_Input>;
  to_transitions?: InputMaybe<Transition_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type State_Max_Fields = {
  __typename?: 'state_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type State_Min_Fields = {
  __typename?: 'state_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "state" */
export type State_Mutation_Response = {
  __typename?: 'state_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<State>;
};

/** input type for inserting object relation for remote table "state" */
export type State_Obj_Rel_Insert_Input = {
  data: State_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<State_On_Conflict>;
};

/** on_conflict condition type for table "state" */
export type State_On_Conflict = {
  constraint: State_Constraint;
  update_columns?: Array<State_Update_Column>;
  where?: InputMaybe<State_Bool_Exp>;
};

/** Ordering options when selecting data from "state". */
export type State_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  entities_aggregate?: InputMaybe<Entity_State_Aggregate_Order_By>;
  from_transition_logs_aggregate?: InputMaybe<Transition_History_Aggregate_Order_By>;
  from_transitions_aggregate?: InputMaybe<Transition_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  initiates_aggregate?: InputMaybe<Workflow_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  to_transition_logs_aggregate?: InputMaybe<Transition_History_Aggregate_Order_By>;
  to_transitions_aggregate?: InputMaybe<Transition_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: state */
export type State_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type State_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "state" */
export enum State_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "state" */
export type State_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  sequence?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type State_Stddev_Fields = {
  __typename?: 'state_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type State_Stddev_Pop_Fields = {
  __typename?: 'state_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type State_Stddev_Samp_Fields = {
  __typename?: 'state_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "state" */
export type State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: State_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type State_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  sequence?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type State_Sum_Fields = {
  __typename?: 'state_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "state" */
export enum State_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type State_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<State_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<State_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<State_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<State_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<State_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<State_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<State_Set_Input>;
  where: State_Bool_Exp;
};

/** aggregate var_pop on columns */
export type State_Var_Pop_Fields = {
  __typename?: 'state_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type State_Var_Samp_Fields = {
  __typename?: 'state_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type State_Variance_Fields = {
  __typename?: 'state_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "storage_location" */
export type Storage_Location = {
  __typename?: 'storage_location';
  address_id?: Maybe<Scalars['bigint']>;
  capacity: Scalars['float8'];
  /** An object relationship */
  capacity_unit: Setu_Trade_Shared_Entity;
  capacity_unit_id: Scalars['bigint'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  pocs: Array<Storage_Location_Pocs>;
  /** An aggregate relationship */
  pocs_aggregate: Storage_Location_Pocs_Aggregate;
  /** An object relationship */
  setu_trade_address?: Maybe<Setu_Trade_Address>;
  /** An array relationship */
  storage_location_agreements: Array<Storage_Location_Agreement>;
  /** An aggregate relationship */
  storage_location_agreements_aggregate: Storage_Location_Agreement_Aggregate;
  /** An array relationship */
  storage_sub_locations: Array<Storage_Sub_Location>;
  /** An aggregate relationship */
  storage_sub_locations_aggregate: Storage_Sub_Location_Aggregate;
  summary?: Maybe<StorageLocationSummaryType>;
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationPocsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Pocs_Order_By>>;
  where?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationPocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Pocs_Order_By>>;
  where?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationStorage_Location_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationStorage_Location_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationStorage_Sub_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Sub_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Sub_Location_Order_By>>;
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationStorage_Sub_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Sub_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Sub_Location_Order_By>>;
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "storage_location" */
export type Storage_LocationTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** aggregated selection of "storage_location" */
export type Storage_Location_Aggregate = {
  __typename?: 'storage_location_aggregate';
  aggregate?: Maybe<Storage_Location_Aggregate_Fields>;
  nodes: Array<Storage_Location>;
};

/** aggregate fields of "storage_location" */
export type Storage_Location_Aggregate_Fields = {
  __typename?: 'storage_location_aggregate_fields';
  avg?: Maybe<Storage_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Storage_Location_Max_Fields>;
  min?: Maybe<Storage_Location_Min_Fields>;
  stddev?: Maybe<Storage_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Location_Sum_Fields>;
  var_pop?: Maybe<Storage_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Location_Var_Samp_Fields>;
  variance?: Maybe<Storage_Location_Variance_Fields>;
};


/** aggregate fields of "storage_location" */
export type Storage_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "storage_location" */
export type Storage_Location_Aggregate_Order_By = {
  avg?: InputMaybe<Storage_Location_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Storage_Location_Max_Order_By>;
  min?: InputMaybe<Storage_Location_Min_Order_By>;
  stddev?: InputMaybe<Storage_Location_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Storage_Location_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Storage_Location_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Storage_Location_Sum_Order_By>;
  var_pop?: InputMaybe<Storage_Location_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Storage_Location_Var_Samp_Order_By>;
  variance?: InputMaybe<Storage_Location_Variance_Order_By>;
};

/** columns and relationships of "storage_location_agreement" */
export type Storage_Location_Agreement = {
  __typename?: 'storage_location_agreement';
  agreement_no?: Maybe<Scalars['String']>;
  /** An array relationship */
  agreement_transactions: Array<Agreement_Transaction>;
  /** An aggregate relationship */
  agreement_transactions_aggregate: Agreement_Transaction_Aggregate;
  /** An array relationship */
  attachments: Array<Storage_Location_Agreement_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Storage_Location_Agreement_Attachments_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  end_date: Scalars['date'];
  expiry_alert_days: Scalars['Int'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  is_verified?: Maybe<Scalars['Boolean']>;
  lease_amount?: Maybe<Scalars['float8']>;
  lease_tenure_kind?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownership_kind: Scalars['String'];
  start_date: Scalars['date'];
  /** An object relationship */
  storage_location?: Maybe<Storage_Location>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  tnc?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "storage_location_agreement" */
export type Storage_Location_AgreementAgreement_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Bool_Exp>;
};


/** columns and relationships of "storage_location_agreement" */
export type Storage_Location_AgreementAgreement_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Bool_Exp>;
};


/** columns and relationships of "storage_location_agreement" */
export type Storage_Location_AgreementAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
};


/** columns and relationships of "storage_location_agreement" */
export type Storage_Location_AgreementAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
};

/** aggregated selection of "storage_location_agreement" */
export type Storage_Location_Agreement_Aggregate = {
  __typename?: 'storage_location_agreement_aggregate';
  aggregate?: Maybe<Storage_Location_Agreement_Aggregate_Fields>;
  nodes: Array<Storage_Location_Agreement>;
};

/** aggregate fields of "storage_location_agreement" */
export type Storage_Location_Agreement_Aggregate_Fields = {
  __typename?: 'storage_location_agreement_aggregate_fields';
  avg?: Maybe<Storage_Location_Agreement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Storage_Location_Agreement_Max_Fields>;
  min?: Maybe<Storage_Location_Agreement_Min_Fields>;
  stddev?: Maybe<Storage_Location_Agreement_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Location_Agreement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Location_Agreement_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Location_Agreement_Sum_Fields>;
  var_pop?: Maybe<Storage_Location_Agreement_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Location_Agreement_Var_Samp_Fields>;
  variance?: Maybe<Storage_Location_Agreement_Variance_Fields>;
};


/** aggregate fields of "storage_location_agreement" */
export type Storage_Location_Agreement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Location_Agreement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "storage_location_agreement" */
export type Storage_Location_Agreement_Aggregate_Order_By = {
  avg?: InputMaybe<Storage_Location_Agreement_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Storage_Location_Agreement_Max_Order_By>;
  min?: InputMaybe<Storage_Location_Agreement_Min_Order_By>;
  stddev?: InputMaybe<Storage_Location_Agreement_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Storage_Location_Agreement_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Storage_Location_Agreement_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Storage_Location_Agreement_Sum_Order_By>;
  var_pop?: InputMaybe<Storage_Location_Agreement_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Storage_Location_Agreement_Var_Samp_Order_By>;
  variance?: InputMaybe<Storage_Location_Agreement_Variance_Order_By>;
};

/** columns and relationships of "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments = {
  __typename?: 'storage_location_agreement_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  storage_location_agreement: Storage_Location_Agreement;
  storagelocationagreement_id: Scalars['bigint'];
};

/** aggregated selection of "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Aggregate = {
  __typename?: 'storage_location_agreement_attachments_aggregate';
  aggregate?: Maybe<Storage_Location_Agreement_Attachments_Aggregate_Fields>;
  nodes: Array<Storage_Location_Agreement_Attachments>;
};

/** aggregate fields of "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Aggregate_Fields = {
  __typename?: 'storage_location_agreement_attachments_aggregate_fields';
  avg?: Maybe<Storage_Location_Agreement_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Storage_Location_Agreement_Attachments_Max_Fields>;
  min?: Maybe<Storage_Location_Agreement_Attachments_Min_Fields>;
  stddev?: Maybe<Storage_Location_Agreement_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Location_Agreement_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Location_Agreement_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Location_Agreement_Attachments_Sum_Fields>;
  var_pop?: Maybe<Storage_Location_Agreement_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Location_Agreement_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Storage_Location_Agreement_Attachments_Variance_Fields>;
};


/** aggregate fields of "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Storage_Location_Agreement_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Storage_Location_Agreement_Attachments_Max_Order_By>;
  min?: InputMaybe<Storage_Location_Agreement_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Storage_Location_Agreement_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Storage_Location_Agreement_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Storage_Location_Agreement_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Storage_Location_Agreement_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Storage_Location_Agreement_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Storage_Location_Agreement_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Storage_Location_Agreement_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Storage_Location_Agreement_Attachments_Avg_Fields = {
  __typename?: 'storage_location_agreement_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  storagelocationagreement_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage_location_agreement_attachments". All fields are combined with a logical 'AND'. */
export type Storage_Location_Agreement_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  storage_location_agreement?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
  storagelocationagreement_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Storage_Location_Agreement_Attachments_Max_Fields = {
  __typename?: 'storage_location_agreement_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  storagelocationagreement_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Storage_Location_Agreement_Attachments_Min_Fields = {
  __typename?: 'storage_location_agreement_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  storagelocationagreement_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "storage_location_agreement_attachments". */
export type Storage_Location_Agreement_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  storage_location_agreement?: InputMaybe<Storage_Location_Agreement_Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** select columns of table "storage_location_agreement_attachments" */
export enum Storage_Location_Agreement_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  StoragelocationagreementId = 'storagelocationagreement_id'
}

/** aggregate stddev on columns */
export type Storage_Location_Agreement_Attachments_Stddev_Fields = {
  __typename?: 'storage_location_agreement_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  storagelocationagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Storage_Location_Agreement_Attachments_Stddev_Pop_Fields = {
  __typename?: 'storage_location_agreement_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  storagelocationagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Storage_Location_Agreement_Attachments_Stddev_Samp_Fields = {
  __typename?: 'storage_location_agreement_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  storagelocationagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Location_Agreement_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Location_Agreement_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  storagelocationagreement_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Storage_Location_Agreement_Attachments_Sum_Fields = {
  __typename?: 'storage_location_agreement_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  storagelocationagreement_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Storage_Location_Agreement_Attachments_Var_Pop_Fields = {
  __typename?: 'storage_location_agreement_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  storagelocationagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Storage_Location_Agreement_Attachments_Var_Samp_Fields = {
  __typename?: 'storage_location_agreement_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  storagelocationagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Storage_Location_Agreement_Attachments_Variance_Fields = {
  __typename?: 'storage_location_agreement_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  storagelocationagreement_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "storage_location_agreement_attachments" */
export type Storage_Location_Agreement_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  storagelocationagreement_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Storage_Location_Agreement_Avg_Fields = {
  __typename?: 'storage_location_agreement_avg_fields';
  expiry_alert_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lease_amount?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Avg_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage_location_agreement". All fields are combined with a logical 'AND'. */
export type Storage_Location_Agreement_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Location_Agreement_Bool_Exp>>;
  _not?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Location_Agreement_Bool_Exp>>;
  agreement_no?: InputMaybe<String_Comparison_Exp>;
  agreement_transactions?: InputMaybe<Agreement_Transaction_Bool_Exp>;
  attachments?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  expiry_alert_days?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  lease_amount?: InputMaybe<Float8_Comparison_Exp>;
  lease_tenure_kind?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownership_kind?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  storage_location?: InputMaybe<Storage_Location_Bool_Exp>;
  storage_location_id?: InputMaybe<Bigint_Comparison_Exp>;
  tnc?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  verification_remark?: InputMaybe<String_Comparison_Exp>;
  verified_by_id?: InputMaybe<String_Comparison_Exp>;
  verified_on?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Storage_Location_Agreement_Max_Fields = {
  __typename?: 'storage_location_agreement_max_fields';
  agreement_no?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  expiry_alert_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  lease_amount?: Maybe<Scalars['float8']>;
  lease_tenure_kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownership_kind?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  tnc?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Max_Order_By = {
  agreement_no?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  lease_tenure_kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership_kind?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Storage_Location_Agreement_Min_Fields = {
  __typename?: 'storage_location_agreement_min_fields';
  agreement_no?: Maybe<Scalars['String']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  expiry_alert_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  lease_amount?: Maybe<Scalars['float8']>;
  lease_tenure_kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownership_kind?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  tnc?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  verification_remark?: Maybe<Scalars['String']>;
  verified_by_id?: Maybe<Scalars['String']>;
  verified_on?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Min_Order_By = {
  agreement_no?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  lease_tenure_kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership_kind?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "storage_location_agreement". */
export type Storage_Location_Agreement_Order_By = {
  agreement_no?: InputMaybe<Order_By>;
  agreement_transactions_aggregate?: InputMaybe<Agreement_Transaction_Aggregate_Order_By>;
  attachments_aggregate?: InputMaybe<Storage_Location_Agreement_Attachments_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  lease_tenure_kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership_kind?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  storage_location?: InputMaybe<Storage_Location_Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  tnc?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  verification_remark?: InputMaybe<Order_By>;
  verified_by_id?: InputMaybe<Order_By>;
  verified_on?: InputMaybe<Order_By>;
};

/** select columns of table "storage_location_agreement" */
export enum Storage_Location_Agreement_Select_Column {
  /** column name */
  AgreementNo = 'agreement_no',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExpiryAlertDays = 'expiry_alert_days',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LeaseAmount = 'lease_amount',
  /** column name */
  LeaseTenureKind = 'lease_tenure_kind',
  /** column name */
  Name = 'name',
  /** column name */
  OwnershipKind = 'ownership_kind',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StorageLocationId = 'storage_location_id',
  /** column name */
  Tnc = 'tnc',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VerificationRemark = 'verification_remark',
  /** column name */
  VerifiedById = 'verified_by_id',
  /** column name */
  VerifiedOn = 'verified_on'
}

/** aggregate stddev on columns */
export type Storage_Location_Agreement_Stddev_Fields = {
  __typename?: 'storage_location_agreement_stddev_fields';
  expiry_alert_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lease_amount?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Stddev_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Storage_Location_Agreement_Stddev_Pop_Fields = {
  __typename?: 'storage_location_agreement_stddev_pop_fields';
  expiry_alert_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lease_amount?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Stddev_Pop_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Storage_Location_Agreement_Stddev_Samp_Fields = {
  __typename?: 'storage_location_agreement_stddev_samp_fields';
  expiry_alert_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lease_amount?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Stddev_Samp_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storage_location_agreement" */
export type Storage_Location_Agreement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Location_Agreement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Location_Agreement_Stream_Cursor_Value_Input = {
  agreement_no?: InputMaybe<Scalars['String']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['date']>;
  expiry_alert_days?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  lease_amount?: InputMaybe<Scalars['float8']>;
  lease_tenure_kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership_kind?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  storage_location_id?: InputMaybe<Scalars['bigint']>;
  tnc?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  verification_remark?: InputMaybe<Scalars['String']>;
  verified_by_id?: InputMaybe<Scalars['String']>;
  verified_on?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Storage_Location_Agreement_Sum_Fields = {
  __typename?: 'storage_location_agreement_sum_fields';
  expiry_alert_days?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  lease_amount?: Maybe<Scalars['float8']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Sum_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Storage_Location_Agreement_Var_Pop_Fields = {
  __typename?: 'storage_location_agreement_var_pop_fields';
  expiry_alert_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lease_amount?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Var_Pop_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Storage_Location_Agreement_Var_Samp_Fields = {
  __typename?: 'storage_location_agreement_var_samp_fields';
  expiry_alert_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lease_amount?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Var_Samp_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Storage_Location_Agreement_Variance_Fields = {
  __typename?: 'storage_location_agreement_variance_fields';
  expiry_alert_days?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lease_amount?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "storage_location_agreement" */
export type Storage_Location_Agreement_Variance_Order_By = {
  expiry_alert_days?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lease_amount?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Storage_Location_Avg_Fields = {
  __typename?: 'storage_location_avg_fields';
  address_id?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "storage_location" */
export type Storage_Location_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage_location". All fields are combined with a logical 'AND'. */
export type Storage_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Location_Bool_Exp>>;
  _not?: InputMaybe<Storage_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Location_Bool_Exp>>;
  address_id?: InputMaybe<Bigint_Comparison_Exp>;
  capacity?: InputMaybe<Float8_Comparison_Exp>;
  capacity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  capacity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pocs?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
  setu_trade_address?: InputMaybe<Setu_Trade_Address_Bool_Exp>;
  storage_location_agreements?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
  storage_sub_locations?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "storage_location_kind" */
export type Storage_Location_Kind = {
  __typename?: 'storage_location_kind';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "storage_location_kind" */
export type Storage_Location_Kind_Aggregate = {
  __typename?: 'storage_location_kind_aggregate';
  aggregate?: Maybe<Storage_Location_Kind_Aggregate_Fields>;
  nodes: Array<Storage_Location_Kind>;
};

/** aggregate fields of "storage_location_kind" */
export type Storage_Location_Kind_Aggregate_Fields = {
  __typename?: 'storage_location_kind_aggregate_fields';
  avg?: Maybe<Storage_Location_Kind_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Storage_Location_Kind_Max_Fields>;
  min?: Maybe<Storage_Location_Kind_Min_Fields>;
  stddev?: Maybe<Storage_Location_Kind_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Location_Kind_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Location_Kind_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Location_Kind_Sum_Fields>;
  var_pop?: Maybe<Storage_Location_Kind_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Location_Kind_Var_Samp_Fields>;
  variance?: Maybe<Storage_Location_Kind_Variance_Fields>;
};


/** aggregate fields of "storage_location_kind" */
export type Storage_Location_Kind_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Location_Kind_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Storage_Location_Kind_Avg_Fields = {
  __typename?: 'storage_location_kind_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "storage_location_kind". All fields are combined with a logical 'AND'. */
export type Storage_Location_Kind_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Location_Kind_Bool_Exp>>;
  _not?: InputMaybe<Storage_Location_Kind_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Location_Kind_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Storage_Location_Kind_Max_Fields = {
  __typename?: 'storage_location_kind_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Storage_Location_Kind_Min_Fields = {
  __typename?: 'storage_location_kind_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "storage_location_kind". */
export type Storage_Location_Kind_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "storage_location_kind" */
export enum Storage_Location_Kind_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Storage_Location_Kind_Stddev_Fields = {
  __typename?: 'storage_location_kind_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Storage_Location_Kind_Stddev_Pop_Fields = {
  __typename?: 'storage_location_kind_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Storage_Location_Kind_Stddev_Samp_Fields = {
  __typename?: 'storage_location_kind_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "storage_location_kind" */
export type Storage_Location_Kind_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Location_Kind_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Location_Kind_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Storage_Location_Kind_Sum_Fields = {
  __typename?: 'storage_location_kind_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Storage_Location_Kind_Var_Pop_Fields = {
  __typename?: 'storage_location_kind_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Storage_Location_Kind_Var_Samp_Fields = {
  __typename?: 'storage_location_kind_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Storage_Location_Kind_Variance_Fields = {
  __typename?: 'storage_location_kind_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Storage_Location_Max_Fields = {
  __typename?: 'storage_location_max_fields';
  address_id?: Maybe<Scalars['bigint']>;
  capacity?: Maybe<Scalars['float8']>;
  capacity_unit_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "storage_location" */
export type Storage_Location_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Storage_Location_Min_Fields = {
  __typename?: 'storage_location_min_fields';
  address_id?: Maybe<Scalars['bigint']>;
  capacity?: Maybe<Scalars['float8']>;
  capacity_unit_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "storage_location" */
export type Storage_Location_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "storage_location". */
export type Storage_Location_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pocs_aggregate?: InputMaybe<Storage_Location_Pocs_Aggregate_Order_By>;
  setu_trade_address?: InputMaybe<Setu_Trade_Address_Order_By>;
  storage_location_agreements_aggregate?: InputMaybe<Storage_Location_Agreement_Aggregate_Order_By>;
  storage_sub_locations_aggregate?: InputMaybe<Storage_Sub_Location_Aggregate_Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "storage_location_pocs" */
export type Storage_Location_Pocs = {
  __typename?: 'storage_location_pocs';
  id: Scalars['bigint'];
  sharedentity_id: Scalars['bigint'];
  /** An object relationship */
  storage_location: Storage_Location;
  storagelocation_id: Scalars['bigint'];
  /** An object relationship */
  user: Setu_Trade_Shared_Entity;
};

/** aggregated selection of "storage_location_pocs" */
export type Storage_Location_Pocs_Aggregate = {
  __typename?: 'storage_location_pocs_aggregate';
  aggregate?: Maybe<Storage_Location_Pocs_Aggregate_Fields>;
  nodes: Array<Storage_Location_Pocs>;
};

/** aggregate fields of "storage_location_pocs" */
export type Storage_Location_Pocs_Aggregate_Fields = {
  __typename?: 'storage_location_pocs_aggregate_fields';
  avg?: Maybe<Storage_Location_Pocs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Storage_Location_Pocs_Max_Fields>;
  min?: Maybe<Storage_Location_Pocs_Min_Fields>;
  stddev?: Maybe<Storage_Location_Pocs_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Location_Pocs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Location_Pocs_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Location_Pocs_Sum_Fields>;
  var_pop?: Maybe<Storage_Location_Pocs_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Location_Pocs_Var_Samp_Fields>;
  variance?: Maybe<Storage_Location_Pocs_Variance_Fields>;
};


/** aggregate fields of "storage_location_pocs" */
export type Storage_Location_Pocs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Location_Pocs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "storage_location_pocs" */
export type Storage_Location_Pocs_Aggregate_Order_By = {
  avg?: InputMaybe<Storage_Location_Pocs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Storage_Location_Pocs_Max_Order_By>;
  min?: InputMaybe<Storage_Location_Pocs_Min_Order_By>;
  stddev?: InputMaybe<Storage_Location_Pocs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Storage_Location_Pocs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Storage_Location_Pocs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Storage_Location_Pocs_Sum_Order_By>;
  var_pop?: InputMaybe<Storage_Location_Pocs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Storage_Location_Pocs_Var_Samp_Order_By>;
  variance?: InputMaybe<Storage_Location_Pocs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Storage_Location_Pocs_Avg_Fields = {
  __typename?: 'storage_location_pocs_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
  storagelocation_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage_location_pocs". All fields are combined with a logical 'AND'. */
export type Storage_Location_Pocs_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Location_Pocs_Bool_Exp>>;
  _not?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Location_Pocs_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  sharedentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  storage_location?: InputMaybe<Storage_Location_Bool_Exp>;
  storagelocation_id?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};

/** aggregate max on columns */
export type Storage_Location_Pocs_Max_Fields = {
  __typename?: 'storage_location_pocs_max_fields';
  id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
  storagelocation_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Storage_Location_Pocs_Min_Fields = {
  __typename?: 'storage_location_pocs_min_fields';
  id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
  storagelocation_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "storage_location_pocs". */
export type Storage_Location_Pocs_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storage_location?: InputMaybe<Storage_Location_Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
};

/** select columns of table "storage_location_pocs" */
export enum Storage_Location_Pocs_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SharedentityId = 'sharedentity_id',
  /** column name */
  StoragelocationId = 'storagelocation_id'
}

/** aggregate stddev on columns */
export type Storage_Location_Pocs_Stddev_Fields = {
  __typename?: 'storage_location_pocs_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
  storagelocation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Storage_Location_Pocs_Stddev_Pop_Fields = {
  __typename?: 'storage_location_pocs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
  storagelocation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Storage_Location_Pocs_Stddev_Samp_Fields = {
  __typename?: 'storage_location_pocs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
  storagelocation_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storage_location_pocs" */
export type Storage_Location_Pocs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Location_Pocs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Location_Pocs_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  sharedentity_id?: InputMaybe<Scalars['bigint']>;
  storagelocation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Storage_Location_Pocs_Sum_Fields = {
  __typename?: 'storage_location_pocs_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  sharedentity_id?: Maybe<Scalars['bigint']>;
  storagelocation_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Storage_Location_Pocs_Var_Pop_Fields = {
  __typename?: 'storage_location_pocs_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
  storagelocation_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Storage_Location_Pocs_Var_Samp_Fields = {
  __typename?: 'storage_location_pocs_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
  storagelocation_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Storage_Location_Pocs_Variance_Fields = {
  __typename?: 'storage_location_pocs_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sharedentity_id?: Maybe<Scalars['Float']>;
  storagelocation_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "storage_location_pocs" */
export type Storage_Location_Pocs_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  sharedentity_id?: InputMaybe<Order_By>;
  storagelocation_id?: InputMaybe<Order_By>;
};

/** select columns of table "storage_location" */
export enum Storage_Location_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CapacityUnitId = 'capacity_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** aggregate stddev on columns */
export type Storage_Location_Stddev_Fields = {
  __typename?: 'storage_location_stddev_fields';
  address_id?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "storage_location" */
export type Storage_Location_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Storage_Location_Stddev_Pop_Fields = {
  __typename?: 'storage_location_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "storage_location" */
export type Storage_Location_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Storage_Location_Stddev_Samp_Fields = {
  __typename?: 'storage_location_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "storage_location" */
export type Storage_Location_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storage_location" */
export type Storage_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Location_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['bigint']>;
  capacity?: InputMaybe<Scalars['float8']>;
  capacity_unit_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Storage_Location_Sum_Fields = {
  __typename?: 'storage_location_sum_fields';
  address_id?: Maybe<Scalars['bigint']>;
  capacity?: Maybe<Scalars['float8']>;
  capacity_unit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "storage_location" */
export type Storage_Location_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Storage_Location_Var_Pop_Fields = {
  __typename?: 'storage_location_var_pop_fields';
  address_id?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "storage_location" */
export type Storage_Location_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Storage_Location_Var_Samp_Fields = {
  __typename?: 'storage_location_var_samp_fields';
  address_id?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "storage_location" */
export type Storage_Location_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Storage_Location_Variance_Fields = {
  __typename?: 'storage_location_variance_fields';
  address_id?: Maybe<Scalars['Float']>;
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "storage_location" */
export type Storage_Location_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "storage_sub_location" */
export type Storage_Sub_Location = {
  __typename?: 'storage_sub_location';
  capacity: Scalars['float8'];
  /** An object relationship */
  capacity_unit: Setu_Trade_Shared_Entity;
  capacity_unit_id: Scalars['bigint'];
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  kind_id: Scalars['bigint'];
  name: Scalars['String'];
  /** An object relationship */
  storage_location: Storage_Location;
  storage_location_id: Scalars['bigint'];
  /** An object relationship */
  storage_location_kind: Storage_Location_Kind;
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "storage_sub_location" */
export type Storage_Sub_LocationTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "storage_sub_location" */
export type Storage_Sub_LocationTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** aggregated selection of "storage_sub_location" */
export type Storage_Sub_Location_Aggregate = {
  __typename?: 'storage_sub_location_aggregate';
  aggregate?: Maybe<Storage_Sub_Location_Aggregate_Fields>;
  nodes: Array<Storage_Sub_Location>;
};

/** aggregate fields of "storage_sub_location" */
export type Storage_Sub_Location_Aggregate_Fields = {
  __typename?: 'storage_sub_location_aggregate_fields';
  avg?: Maybe<Storage_Sub_Location_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Storage_Sub_Location_Max_Fields>;
  min?: Maybe<Storage_Sub_Location_Min_Fields>;
  stddev?: Maybe<Storage_Sub_Location_Stddev_Fields>;
  stddev_pop?: Maybe<Storage_Sub_Location_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Storage_Sub_Location_Stddev_Samp_Fields>;
  sum?: Maybe<Storage_Sub_Location_Sum_Fields>;
  var_pop?: Maybe<Storage_Sub_Location_Var_Pop_Fields>;
  var_samp?: Maybe<Storage_Sub_Location_Var_Samp_Fields>;
  variance?: Maybe<Storage_Sub_Location_Variance_Fields>;
};


/** aggregate fields of "storage_sub_location" */
export type Storage_Sub_Location_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Storage_Sub_Location_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "storage_sub_location" */
export type Storage_Sub_Location_Aggregate_Order_By = {
  avg?: InputMaybe<Storage_Sub_Location_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Storage_Sub_Location_Max_Order_By>;
  min?: InputMaybe<Storage_Sub_Location_Min_Order_By>;
  stddev?: InputMaybe<Storage_Sub_Location_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Storage_Sub_Location_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Storage_Sub_Location_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Storage_Sub_Location_Sum_Order_By>;
  var_pop?: InputMaybe<Storage_Sub_Location_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Storage_Sub_Location_Var_Samp_Order_By>;
  variance?: InputMaybe<Storage_Sub_Location_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Storage_Sub_Location_Avg_Fields = {
  __typename?: 'storage_sub_location_avg_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kind_id?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Avg_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage_sub_location". All fields are combined with a logical 'AND'. */
export type Storage_Sub_Location_Bool_Exp = {
  _and?: InputMaybe<Array<Storage_Sub_Location_Bool_Exp>>;
  _not?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
  _or?: InputMaybe<Array<Storage_Sub_Location_Bool_Exp>>;
  capacity?: InputMaybe<Float8_Comparison_Exp>;
  capacity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  capacity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  kind_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  storage_location?: InputMaybe<Storage_Location_Bool_Exp>;
  storage_location_id?: InputMaybe<Bigint_Comparison_Exp>;
  storage_location_kind?: InputMaybe<Storage_Location_Kind_Bool_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Storage_Sub_Location_Max_Fields = {
  __typename?: 'storage_sub_location_max_fields';
  capacity?: Maybe<Scalars['float8']>;
  capacity_unit_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  kind_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Max_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Storage_Sub_Location_Min_Fields = {
  __typename?: 'storage_sub_location_min_fields';
  capacity?: Maybe<Scalars['float8']>;
  capacity_unit_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  kind_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Min_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "storage_sub_location". */
export type Storage_Sub_Location_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  storage_location?: InputMaybe<Storage_Location_Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_location_kind?: InputMaybe<Storage_Location_Kind_Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "storage_sub_location" */
export enum Storage_Sub_Location_Select_Column {
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CapacityUnitId = 'capacity_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  KindId = 'kind_id',
  /** column name */
  Name = 'name',
  /** column name */
  StorageLocationId = 'storage_location_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** aggregate stddev on columns */
export type Storage_Sub_Location_Stddev_Fields = {
  __typename?: 'storage_sub_location_stddev_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kind_id?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Stddev_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Storage_Sub_Location_Stddev_Pop_Fields = {
  __typename?: 'storage_sub_location_stddev_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kind_id?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Stddev_Pop_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Storage_Sub_Location_Stddev_Samp_Fields = {
  __typename?: 'storage_sub_location_stddev_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kind_id?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Stddev_Samp_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "storage_sub_location" */
export type Storage_Sub_Location_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Storage_Sub_Location_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Storage_Sub_Location_Stream_Cursor_Value_Input = {
  capacity?: InputMaybe<Scalars['float8']>;
  capacity_unit_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  storage_location_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Storage_Sub_Location_Sum_Fields = {
  __typename?: 'storage_sub_location_sum_fields';
  capacity?: Maybe<Scalars['float8']>;
  capacity_unit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind_id?: Maybe<Scalars['bigint']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Sum_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Storage_Sub_Location_Var_Pop_Fields = {
  __typename?: 'storage_sub_location_var_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kind_id?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Var_Pop_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Storage_Sub_Location_Var_Samp_Fields = {
  __typename?: 'storage_sub_location_var_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kind_id?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Var_Samp_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Storage_Sub_Location_Variance_Fields = {
  __typename?: 'storage_sub_location_variance_fields';
  capacity?: Maybe<Scalars['Float']>;
  capacity_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kind_id?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "storage_sub_location" */
export type Storage_Sub_Location_Variance_Order_By = {
  capacity?: InputMaybe<Order_By>;
  capacity_unit_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind_id?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "Transaction_mode" */
  Transaction_mode: Array<Transaction_Mode>;
  /** fetch aggregated fields from the table: "Transaction_mode" */
  Transaction_mode_aggregate: Transaction_Mode_Aggregate;
  /** fetch data from the table: "Transaction_mode" using primary key columns */
  Transaction_mode_by_pk?: Maybe<Transaction_Mode>;
  /** fetch data from the table in a streaming manner : "Transaction_mode" */
  Transaction_mode_stream: Array<Transaction_Mode>;
  /** fetch data from the table: "action_log" */
  action_log: Array<Action_Log>;
  /** fetch aggregated fields from the table: "action_log" */
  action_log_aggregate: Action_Log_Aggregate;
  /** fetch data from the table: "action_log" using primary key columns */
  action_log_by_pk?: Maybe<Action_Log>;
  /** fetch data from the table in a streaming manner : "action_log" */
  action_log_stream: Array<Action_Log>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner : "address" */
  address_stream: Array<Address>;
  /** fetch data from the table: "advance_payment" */
  advance_payment: Array<Advance_Payment>;
  /** fetch aggregated fields from the table: "advance_payment" */
  advance_payment_aggregate: Advance_Payment_Aggregate;
  /** fetch data from the table: "advance_payment" using primary key columns */
  advance_payment_by_pk?: Maybe<Advance_Payment>;
  /** fetch data from the table: "advance_payment_parameters" */
  advance_payment_parameters: Array<Advance_Payment_Parameters>;
  /** fetch aggregated fields from the table: "advance_payment_parameters" */
  advance_payment_parameters_aggregate: Advance_Payment_Parameters_Aggregate;
  /** fetch data from the table: "advance_payment_parameters" using primary key columns */
  advance_payment_parameters_by_pk?: Maybe<Advance_Payment_Parameters>;
  /** fetch data from the table in a streaming manner : "advance_payment_parameters" */
  advance_payment_parameters_stream: Array<Advance_Payment_Parameters>;
  /** fetch data from the table in a streaming manner : "advance_payment" */
  advance_payment_stream: Array<Advance_Payment>;
  /** fetch data from the table: "agent" */
  agent: Array<Agent>;
  /** fetch aggregated fields from the table: "agent" */
  agent_aggregate: Agent_Aggregate;
  /** fetch data from the table: "agent" using primary key columns */
  agent_by_pk?: Maybe<Agent>;
  /** fetch data from the table: "agent_company" */
  agent_company: Array<Agent_Company>;
  /** fetch aggregated fields from the table: "agent_company" */
  agent_company_aggregate: Agent_Company_Aggregate;
  /** fetch data from the table: "agent_company" using primary key columns */
  agent_company_by_pk?: Maybe<Agent_Company>;
  /** fetch data from the table in a streaming manner : "agent_company" */
  agent_company_stream: Array<Agent_Company>;
  /** fetch data from the table: "agent_role" */
  agent_role: Array<Agent_Role>;
  /** fetch aggregated fields from the table: "agent_role" */
  agent_role_aggregate: Agent_Role_Aggregate;
  /** fetch data from the table: "agent_role" using primary key columns */
  agent_role_by_pk?: Maybe<Agent_Role>;
  /** fetch data from the table in a streaming manner : "agent_role" */
  agent_role_stream: Array<Agent_Role>;
  /** fetch data from the table in a streaming manner : "agent" */
  agent_stream: Array<Agent>;
  /** fetch data from the table: "agreement_co_owner" */
  agreement_co_owner: Array<Agreement_Co_Owner>;
  /** fetch aggregated fields from the table: "agreement_co_owner" */
  agreement_co_owner_aggregate: Agreement_Co_Owner_Aggregate;
  /** fetch data from the table: "agreement_co_owner_agreement_invoices" */
  agreement_co_owner_agreement_invoices: Array<Agreement_Co_Owner_Agreement_Invoices>;
  /** fetch aggregated fields from the table: "agreement_co_owner_agreement_invoices" */
  agreement_co_owner_agreement_invoices_aggregate: Agreement_Co_Owner_Agreement_Invoices_Aggregate;
  /** fetch data from the table: "agreement_co_owner_agreement_invoices" using primary key columns */
  agreement_co_owner_agreement_invoices_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Invoices>;
  /** fetch data from the table in a streaming manner : "agreement_co_owner_agreement_invoices" */
  agreement_co_owner_agreement_invoices_stream: Array<Agreement_Co_Owner_Agreement_Invoices>;
  /** fetch data from the table: "agreement_co_owner_agreement_plots" */
  agreement_co_owner_agreement_plots: Array<Agreement_Co_Owner_Agreement_Plots>;
  /** fetch aggregated fields from the table: "agreement_co_owner_agreement_plots" */
  agreement_co_owner_agreement_plots_aggregate: Agreement_Co_Owner_Agreement_Plots_Aggregate;
  /** fetch data from the table: "agreement_co_owner_agreement_plots" using primary key columns */
  agreement_co_owner_agreement_plots_by_pk?: Maybe<Agreement_Co_Owner_Agreement_Plots>;
  /** fetch data from the table in a streaming manner : "agreement_co_owner_agreement_plots" */
  agreement_co_owner_agreement_plots_stream: Array<Agreement_Co_Owner_Agreement_Plots>;
  /** fetch data from the table: "agreement_co_owner" using primary key columns */
  agreement_co_owner_by_pk?: Maybe<Agreement_Co_Owner>;
  /** fetch data from the table: "agreement_co_owner_legal_agreement" */
  agreement_co_owner_legal_agreement: Array<Agreement_Co_Owner_Legal_Agreement>;
  /** fetch aggregated fields from the table: "agreement_co_owner_legal_agreement" */
  agreement_co_owner_legal_agreement_aggregate: Agreement_Co_Owner_Legal_Agreement_Aggregate;
  /** fetch data from the table: "agreement_co_owner_legal_agreement" using primary key columns */
  agreement_co_owner_legal_agreement_by_pk?: Maybe<Agreement_Co_Owner_Legal_Agreement>;
  /** fetch data from the table in a streaming manner : "agreement_co_owner_legal_agreement" */
  agreement_co_owner_legal_agreement_stream: Array<Agreement_Co_Owner_Legal_Agreement>;
  /** fetch data from the table in a streaming manner : "agreement_co_owner" */
  agreement_co_owner_stream: Array<Agreement_Co_Owner>;
  /** fetch data from the table: "agreement_invoice" */
  agreement_invoice: Array<Agreement_Invoice>;
  /** fetch aggregated fields from the table: "agreement_invoice" */
  agreement_invoice_aggregate: Agreement_Invoice_Aggregate;
  /** fetch data from the table: "agreement_invoice_agreement_invoice_items" */
  agreement_invoice_agreement_invoice_items: Array<Agreement_Invoice_Agreement_Invoice_Items>;
  /** fetch aggregated fields from the table: "agreement_invoice_agreement_invoice_items" */
  agreement_invoice_agreement_invoice_items_aggregate: Agreement_Invoice_Agreement_Invoice_Items_Aggregate;
  /** fetch data from the table: "agreement_invoice_agreement_invoice_items" using primary key columns */
  agreement_invoice_agreement_invoice_items_by_pk?: Maybe<Agreement_Invoice_Agreement_Invoice_Items>;
  /** fetch data from the table in a streaming manner : "agreement_invoice_agreement_invoice_items" */
  agreement_invoice_agreement_invoice_items_stream: Array<Agreement_Invoice_Agreement_Invoice_Items>;
  /** fetch data from the table: "agreement_invoice" using primary key columns */
  agreement_invoice_by_pk?: Maybe<Agreement_Invoice>;
  /** fetch data from the table: "agreement_invoice_item" */
  agreement_invoice_item: Array<Agreement_Invoice_Item>;
  /** fetch aggregated fields from the table: "agreement_invoice_item" */
  agreement_invoice_item_aggregate: Agreement_Invoice_Item_Aggregate;
  /** fetch data from the table: "agreement_invoice_item" using primary key columns */
  agreement_invoice_item_by_pk?: Maybe<Agreement_Invoice_Item>;
  /** fetch data from the table in a streaming manner : "agreement_invoice_item" */
  agreement_invoice_item_stream: Array<Agreement_Invoice_Item>;
  /** fetch data from the table in a streaming manner : "agreement_invoice" */
  agreement_invoice_stream: Array<Agreement_Invoice>;
  /** fetch data from the table: "agreement_invoice_transaction" */
  agreement_invoice_transaction: Array<Agreement_Invoice_Transaction>;
  /** fetch aggregated fields from the table: "agreement_invoice_transaction" */
  agreement_invoice_transaction_aggregate: Agreement_Invoice_Transaction_Aggregate;
  /** fetch data from the table: "agreement_invoice_transaction" using primary key columns */
  agreement_invoice_transaction_by_pk?: Maybe<Agreement_Invoice_Transaction>;
  /** fetch data from the table in a streaming manner : "agreement_invoice_transaction" */
  agreement_invoice_transaction_stream: Array<Agreement_Invoice_Transaction>;
  /** fetch data from the table: "agreement_plot" */
  agreement_plot: Array<Agreement_Plot>;
  /** fetch aggregated fields from the table: "agreement_plot" */
  agreement_plot_aggregate: Agreement_Plot_Aggregate;
  /** fetch data from the table: "agreement_plot" using primary key columns */
  agreement_plot_by_pk?: Maybe<Agreement_Plot>;
  /** fetch data from the table in a streaming manner : "agreement_plot" */
  agreement_plot_stream: Array<Agreement_Plot>;
  /** fetch data from the table: "agreement_transaction" */
  agreement_transaction: Array<Agreement_Transaction>;
  /** fetch aggregated fields from the table: "agreement_transaction" */
  agreement_transaction_aggregate: Agreement_Transaction_Aggregate;
  /** fetch data from the table: "agreement_transaction_attachments" */
  agreement_transaction_attachments: Array<Agreement_Transaction_Attachments>;
  /** fetch aggregated fields from the table: "agreement_transaction_attachments" */
  agreement_transaction_attachments_aggregate: Agreement_Transaction_Attachments_Aggregate;
  /** fetch data from the table: "agreement_transaction_attachments" using primary key columns */
  agreement_transaction_attachments_by_pk?: Maybe<Agreement_Transaction_Attachments>;
  /** fetch data from the table in a streaming manner : "agreement_transaction_attachments" */
  agreement_transaction_attachments_stream: Array<Agreement_Transaction_Attachments>;
  /** fetch data from the table: "agreement_transaction" using primary key columns */
  agreement_transaction_by_pk?: Maybe<Agreement_Transaction>;
  /** fetch data from the table in a streaming manner : "agreement_transaction" */
  agreement_transaction_stream: Array<Agreement_Transaction>;
  /** fetch data from the table: "amendment_case" */
  amendment_case: Array<Amendment_Case>;
  /** fetch aggregated fields from the table: "amendment_case" */
  amendment_case_aggregate: Amendment_Case_Aggregate;
  /** fetch data from the table: "amendment_case" using primary key columns */
  amendment_case_by_pk?: Maybe<Amendment_Case>;
  /** fetch data from the table in a streaming manner : "amendment_case" */
  amendment_case_stream: Array<Amendment_Case>;
  /** fetch data from the table: "auth_group" */
  auth_group: Array<Auth_Group>;
  /** fetch aggregated fields from the table: "auth_group" */
  auth_group_aggregate: Auth_Group_Aggregate;
  /** fetch data from the table: "auth_group" using primary key columns */
  auth_group_by_pk?: Maybe<Auth_Group>;
  /** fetch data from the table: "auth_group_permissions" */
  auth_group_permissions: Array<Auth_Group_Permissions>;
  /** fetch aggregated fields from the table: "auth_group_permissions" */
  auth_group_permissions_aggregate: Auth_Group_Permissions_Aggregate;
  /** fetch data from the table: "auth_group_permissions" using primary key columns */
  auth_group_permissions_by_pk?: Maybe<Auth_Group_Permissions>;
  /** fetch data from the table in a streaming manner : "auth_group_permissions" */
  auth_group_permissions_stream: Array<Auth_Group_Permissions>;
  /** fetch data from the table in a streaming manner : "auth_group" */
  auth_group_stream: Array<Auth_Group>;
  /** fetch data from the table: "auth_permission" */
  auth_permission: Array<Auth_Permission>;
  /** fetch aggregated fields from the table: "auth_permission" */
  auth_permission_aggregate: Auth_Permission_Aggregate;
  /** fetch data from the table: "auth_permission" using primary key columns */
  auth_permission_by_pk?: Maybe<Auth_Permission>;
  /** fetch data from the table in a streaming manner : "auth_permission" */
  auth_permission_stream: Array<Auth_Permission>;
  /** fetch data from the table: "base_user" */
  base_user: Array<Base_User>;
  /** fetch data from the table: "base_user_address_book" */
  base_user_address_book: Array<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user_address_book" */
  base_user_address_book_aggregate: Base_User_Address_Book_Aggregate;
  /** fetch data from the table: "base_user_address_book" using primary key columns */
  base_user_address_book_by_pk?: Maybe<Base_User_Address_Book>;
  /** fetch data from the table in a streaming manner : "base_user_address_book" */
  base_user_address_book_stream: Array<Base_User_Address_Book>;
  /** fetch aggregated fields from the table: "base_user" */
  base_user_aggregate: Base_User_Aggregate;
  /** fetch data from the table: "base_user" using primary key columns */
  base_user_by_pk?: Maybe<Base_User>;
  /** An array relationship */
  base_user_companies: Array<Base_User_Companies>;
  /** An aggregate relationship */
  base_user_companies_aggregate: Base_User_Companies_Aggregate;
  /** fetch data from the table: "base_user_companies" using primary key columns */
  base_user_companies_by_pk?: Maybe<Base_User_Companies>;
  /** fetch data from the table in a streaming manner : "base_user_companies" */
  base_user_companies_stream: Array<Base_User_Companies>;
  /** fetch data from the table: "base_user_departments" */
  base_user_departments: Array<Base_User_Departments>;
  /** fetch aggregated fields from the table: "base_user_departments" */
  base_user_departments_aggregate: Base_User_Departments_Aggregate;
  /** fetch data from the table: "base_user_departments" using primary key columns */
  base_user_departments_by_pk?: Maybe<Base_User_Departments>;
  /** fetch data from the table in a streaming manner : "base_user_departments" */
  base_user_departments_stream: Array<Base_User_Departments>;
  /** fetch data from the table: "base_user_groups" */
  base_user_groups: Array<Base_User_Groups>;
  /** fetch aggregated fields from the table: "base_user_groups" */
  base_user_groups_aggregate: Base_User_Groups_Aggregate;
  /** fetch data from the table: "base_user_groups" using primary key columns */
  base_user_groups_by_pk?: Maybe<Base_User_Groups>;
  /** fetch data from the table in a streaming manner : "base_user_groups" */
  base_user_groups_stream: Array<Base_User_Groups>;
  /** fetch data from the table: "base_user_network" */
  base_user_network: Array<Base_User_Network>;
  /** fetch aggregated fields from the table: "base_user_network" */
  base_user_network_aggregate: Base_User_Network_Aggregate;
  /** fetch data from the table: "base_user_network" using primary key columns */
  base_user_network_by_pk?: Maybe<Base_User_Network>;
  /** fetch data from the table in a streaming manner : "base_user_network" */
  base_user_network_stream: Array<Base_User_Network>;
  /** fetch data from the table in a streaming manner : "base_user" */
  base_user_stream: Array<Base_User>;
  /** fetch data from the table: "base_user_user_permissions" */
  base_user_user_permissions: Array<Base_User_User_Permissions>;
  /** fetch aggregated fields from the table: "base_user_user_permissions" */
  base_user_user_permissions_aggregate: Base_User_User_Permissions_Aggregate;
  /** fetch data from the table: "base_user_user_permissions" using primary key columns */
  base_user_user_permissions_by_pk?: Maybe<Base_User_User_Permissions>;
  /** fetch data from the table in a streaming manner : "base_user_user_permissions" */
  base_user_user_permissions_stream: Array<Base_User_User_Permissions>;
  /** fetch data from the table: "brand" */
  brand: Array<Brand>;
  /** fetch aggregated fields from the table: "brand" */
  brand_aggregate: Brand_Aggregate;
  /** fetch data from the table: "brand" using primary key columns */
  brand_by_pk?: Maybe<Brand>;
  /** fetch data from the table: "brand_company" */
  brand_company: Array<Brand_Company>;
  /** fetch aggregated fields from the table: "brand_company" */
  brand_company_aggregate: Brand_Company_Aggregate;
  /** fetch data from the table: "brand_company" using primary key columns */
  brand_company_by_pk?: Maybe<Brand_Company>;
  /** fetch data from the table in a streaming manner : "brand_company" */
  brand_company_stream: Array<Brand_Company>;
  /** fetch data from the table in a streaming manner : "brand" */
  brand_stream: Array<Brand>;
  /** fetch data from the table: "breeder" */
  breeder: Array<Breeder>;
  /** fetch aggregated fields from the table: "breeder" */
  breeder_aggregate: Breeder_Aggregate;
  /** fetch data from the table: "breeder" using primary key columns */
  breeder_by_pk?: Maybe<Breeder>;
  /** fetch data from the table in a streaming manner : "breeder" */
  breeder_stream: Array<Breeder>;
  /** fetch data from the table: "business" */
  business: Array<Business>;
  /** fetch aggregated fields from the table: "business" */
  business_aggregate: Business_Aggregate;
  /** fetch data from the table: "business" using primary key columns */
  business_by_pk?: Maybe<Business>;
  /** fetch data from the table: "business_commodities_supplied" */
  business_commodities_supplied: Array<Business_Commodities_Supplied>;
  /** fetch aggregated fields from the table: "business_commodities_supplied" */
  business_commodities_supplied_aggregate: Business_Commodities_Supplied_Aggregate;
  /** fetch data from the table: "business_commodities_supplied" using primary key columns */
  business_commodities_supplied_by_pk?: Maybe<Business_Commodities_Supplied>;
  /** fetch data from the table in a streaming manner : "business_commodities_supplied" */
  business_commodities_supplied_stream: Array<Business_Commodities_Supplied>;
  /** fetch data from the table: "business_companies" */
  business_companies: Array<Business_Companies>;
  /** fetch aggregated fields from the table: "business_companies" */
  business_companies_aggregate: Business_Companies_Aggregate;
  /** fetch data from the table: "business_companies" using primary key columns */
  business_companies_by_pk?: Maybe<Business_Companies>;
  /** fetch data from the table in a streaming manner : "business_companies" */
  business_companies_stream: Array<Business_Companies>;
  /** fetch data from the table: "business_field" */
  business_field: Array<Business_Field>;
  /** fetch aggregated fields from the table: "business_field" */
  business_field_aggregate: Business_Field_Aggregate;
  /** fetch data from the table: "business_field" using primary key columns */
  business_field_by_pk?: Maybe<Business_Field>;
  /** fetch data from the table in a streaming manner : "business_field" */
  business_field_stream: Array<Business_Field>;
  /** fetch data from the table: "business_group" */
  business_group: Array<Business_Group>;
  /** fetch aggregated fields from the table: "business_group" */
  business_group_aggregate: Business_Group_Aggregate;
  /** fetch data from the table: "business_group" using primary key columns */
  business_group_by_pk?: Maybe<Business_Group>;
  /** fetch data from the table: "business_group_network" */
  business_group_network: Array<Business_Group_Network>;
  /** fetch aggregated fields from the table: "business_group_network" */
  business_group_network_aggregate: Business_Group_Network_Aggregate;
  /** fetch data from the table: "business_group_network" using primary key columns */
  business_group_network_by_pk?: Maybe<Business_Group_Network>;
  /** fetch data from the table in a streaming manner : "business_group_network" */
  business_group_network_stream: Array<Business_Group_Network>;
  /** fetch data from the table in a streaming manner : "business_group" */
  business_group_stream: Array<Business_Group>;
  /** fetch data from the table: "business_groups" */
  business_groups: Array<Business_Groups>;
  /** fetch aggregated fields from the table: "business_groups" */
  business_groups_aggregate: Business_Groups_Aggregate;
  /** fetch data from the table: "business_groups" using primary key columns */
  business_groups_by_pk?: Maybe<Business_Groups>;
  /** fetch data from the table in a streaming manner : "business_groups" */
  business_groups_stream: Array<Business_Groups>;
  /** fetch data from the table: "business_network" */
  business_network: Array<Business_Network>;
  /** fetch aggregated fields from the table: "business_network" */
  business_network_aggregate: Business_Network_Aggregate;
  /** fetch data from the table: "business_network" using primary key columns */
  business_network_by_pk?: Maybe<Business_Network>;
  /** fetch data from the table in a streaming manner : "business_network" */
  business_network_stream: Array<Business_Network>;
  /** fetch data from the table: "business_secondary_pocs" */
  business_secondary_pocs: Array<Business_Secondary_Pocs>;
  /** fetch aggregated fields from the table: "business_secondary_pocs" */
  business_secondary_pocs_aggregate: Business_Secondary_Pocs_Aggregate;
  /** fetch data from the table: "business_secondary_pocs" using primary key columns */
  business_secondary_pocs_by_pk?: Maybe<Business_Secondary_Pocs>;
  /** fetch data from the table in a streaming manner : "business_secondary_pocs" */
  business_secondary_pocs_stream: Array<Business_Secondary_Pocs>;
  /** fetch data from the table in a streaming manner : "business" */
  business_stream: Array<Business>;
  /** fetch data from the table: "commodity" */
  commodity: Array<Commodity>;
  /** fetch aggregated fields from the table: "commodity" */
  commodity_aggregate: Commodity_Aggregate;
  /** fetch data from the table: "commodity" using primary key columns */
  commodity_by_pk?: Maybe<Commodity>;
  /** fetch data from the table in a streaming manner : "commodity" */
  commodity_stream: Array<Commodity>;
  /** fetch data from the table: "commodity_variety" */
  commodity_variety: Array<Commodity_Variety>;
  /** fetch aggregated fields from the table: "commodity_variety" */
  commodity_variety_aggregate: Commodity_Variety_Aggregate;
  /** fetch data from the table: "commodity_variety" using primary key columns */
  commodity_variety_by_pk?: Maybe<Commodity_Variety>;
  /** fetch data from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups: Array<Commodity_Variety_Secondary_Groups>;
  /** fetch aggregated fields from the table: "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  /** fetch data from the table: "commodity_variety_secondary_groups" using primary key columns */
  commodity_variety_secondary_groups_by_pk?: Maybe<Commodity_Variety_Secondary_Groups>;
  /** fetch data from the table in a streaming manner : "commodity_variety_secondary_groups" */
  commodity_variety_secondary_groups_stream: Array<Commodity_Variety_Secondary_Groups>;
  /** fetch data from the table in a streaming manner : "commodity_variety" */
  commodity_variety_stream: Array<Commodity_Variety>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_categories" */
  company_categories: Array<Company_Categories>;
  /** fetch aggregated fields from the table: "company_categories" */
  company_categories_aggregate: Company_Categories_Aggregate;
  /** fetch data from the table: "company_categories" using primary key columns */
  company_categories_by_pk?: Maybe<Company_Categories>;
  /** fetch data from the table in a streaming manner : "company_categories" */
  company_categories_stream: Array<Company_Categories>;
  /** fetch data from the table: "company_category" */
  company_category: Array<Company_Category>;
  /** fetch aggregated fields from the table: "company_category" */
  company_category_aggregate: Company_Category_Aggregate;
  /** fetch data from the table: "company_category" using primary key columns */
  company_category_by_pk?: Maybe<Company_Category>;
  /** fetch data from the table in a streaming manner : "company_category" */
  company_category_stream: Array<Company_Category>;
  /** fetch data from the table: "company_share_holder" */
  company_share_holder: Array<Company_Share_Holder>;
  /** fetch aggregated fields from the table: "company_share_holder" */
  company_share_holder_aggregate: Company_Share_Holder_Aggregate;
  /** fetch data from the table: "company_share_holder" using primary key columns */
  company_share_holder_by_pk?: Maybe<Company_Share_Holder>;
  /** fetch data from the table in a streaming manner : "company_share_holder" */
  company_share_holder_stream: Array<Company_Share_Holder>;
  /** fetch data from the table in a streaming manner : "company" */
  company_stream: Array<Company>;
  /** fetch data from the table: "django_content_type" */
  content_type: Array<Django_Content_Type>;
  /** fetch aggregated fields from the table: "django_content_type" */
  content_type_aggregate: Django_Content_Type_Aggregate;
  /** fetch data from the table: "django_content_type" using primary key columns */
  content_type_by_pk?: Maybe<Django_Content_Type>;
  /** fetch data from the table: "credit" */
  credit: Array<Credit>;
  /** fetch aggregated fields from the table: "credit" */
  credit_aggregate: Credit_Aggregate;
  /** fetch data from the table: "credit" using primary key columns */
  credit_by_pk?: Maybe<Credit>;
  /** fetch data from the table: "credit_note" */
  credit_note: Array<Credit_Note>;
  /** fetch aggregated fields from the table: "credit_note" */
  credit_note_aggregate: Credit_Note_Aggregate;
  /** fetch data from the table: "credit_note" using primary key columns */
  credit_note_by_pk?: Maybe<Credit_Note>;
  /** fetch data from the table in a streaming manner : "credit_note" */
  credit_note_stream: Array<Credit_Note>;
  /** fetch data from the table: "credit_request" */
  credit_request: Array<Credit_Request>;
  /** fetch aggregated fields from the table: "credit_request" */
  credit_request_aggregate: Credit_Request_Aggregate;
  /** fetch data from the table: "credit_request" using primary key columns */
  credit_request_by_pk?: Maybe<Credit_Request>;
  /** fetch data from the table in a streaming manner : "credit_request" */
  credit_request_stream: Array<Credit_Request>;
  /** fetch data from the table: "credit_status" */
  credit_status: Array<Credit_Status>;
  /** fetch aggregated fields from the table: "credit_status" */
  credit_status_aggregate: Credit_Status_Aggregate;
  /** fetch data from the table: "credit_status" using primary key columns */
  credit_status_by_pk?: Maybe<Credit_Status>;
  /** fetch data from the table: "credit_status_parents" */
  credit_status_parents: Array<Credit_Status_Parents>;
  /** fetch aggregated fields from the table: "credit_status_parents" */
  credit_status_parents_aggregate: Credit_Status_Parents_Aggregate;
  /** fetch data from the table: "credit_status_parents" using primary key columns */
  credit_status_parents_by_pk?: Maybe<Credit_Status_Parents>;
  /** fetch data from the table in a streaming manner : "credit_status_parents" */
  credit_status_parents_stream: Array<Credit_Status_Parents>;
  /** fetch data from the table in a streaming manner : "credit_status" */
  credit_status_stream: Array<Credit_Status>;
  /** fetch data from the table in a streaming manner : "credit" */
  credit_stream: Array<Credit>;
  /** fetch data from the table: "credit_transaction" */
  credit_transaction: Array<Credit_Transaction>;
  /** fetch aggregated fields from the table: "credit_transaction" */
  credit_transaction_aggregate: Credit_Transaction_Aggregate;
  /** fetch data from the table: "credit_transaction" using primary key columns */
  credit_transaction_by_pk?: Maybe<Credit_Transaction>;
  /** fetch data from the table in a streaming manner : "credit_transaction" */
  credit_transaction_stream: Array<Credit_Transaction>;
  /** fetch data from the table: "credit_wallet" */
  credit_wallet: Array<Credit_Wallet>;
  /** fetch aggregated fields from the table: "credit_wallet" */
  credit_wallet_aggregate: Credit_Wallet_Aggregate;
  /** fetch data from the table: "credit_wallet" using primary key columns */
  credit_wallet_by_pk?: Maybe<Credit_Wallet>;
  /** fetch data from the table: "credit_wallet_request" */
  credit_wallet_request: Array<Credit_Wallet_Request>;
  /** fetch aggregated fields from the table: "credit_wallet_request" */
  credit_wallet_request_aggregate: Credit_Wallet_Request_Aggregate;
  /** fetch data from the table: "credit_wallet_request" using primary key columns */
  credit_wallet_request_by_pk?: Maybe<Credit_Wallet_Request>;
  /** fetch data from the table in a streaming manner : "credit_wallet_request" */
  credit_wallet_request_stream: Array<Credit_Wallet_Request>;
  /** fetch data from the table: "credit_wallet_status" */
  credit_wallet_status: Array<Credit_Wallet_Status>;
  /** fetch aggregated fields from the table: "credit_wallet_status" */
  credit_wallet_status_aggregate: Credit_Wallet_Status_Aggregate;
  /** fetch data from the table: "credit_wallet_status" using primary key columns */
  credit_wallet_status_by_pk?: Maybe<Credit_Wallet_Status>;
  /** fetch data from the table in a streaming manner : "credit_wallet_status" */
  credit_wallet_status_stream: Array<Credit_Wallet_Status>;
  /** fetch data from the table in a streaming manner : "credit_wallet" */
  credit_wallet_stream: Array<Credit_Wallet>;
  /** fetch data from the table: "crop" */
  crop: Array<Crop>;
  /** fetch aggregated fields from the table: "crop" */
  crop_aggregate: Crop_Aggregate;
  /** fetch data from the table: "crop" using primary key columns */
  crop_by_pk?: Maybe<Crop>;
  /** fetch data from the table: "crop_group" */
  crop_group: Array<Crop_Group>;
  /** fetch aggregated fields from the table: "crop_group" */
  crop_group_aggregate: Crop_Group_Aggregate;
  /** fetch data from the table: "crop_group" using primary key columns */
  crop_group_by_pk?: Maybe<Crop_Group>;
  /** fetch data from the table in a streaming manner : "crop_group" */
  crop_group_stream: Array<Crop_Group>;
  /** fetch data from the table: "crop_infestation" */
  crop_infestation: Array<Crop_Infestation>;
  /** fetch aggregated fields from the table: "crop_infestation" */
  crop_infestation_aggregate: Crop_Infestation_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" */
  crop_infestation_attachment: Array<Crop_Infestation_Attachment>;
  /** fetch aggregated fields from the table: "crop_infestation_attachment" */
  crop_infestation_attachment_aggregate: Crop_Infestation_Attachment_Aggregate;
  /** fetch data from the table: "crop_infestation_attachment" using primary key columns */
  crop_infestation_attachment_by_pk?: Maybe<Crop_Infestation_Attachment>;
  /** fetch data from the table in a streaming manner : "crop_infestation_attachment" */
  crop_infestation_attachment_stream: Array<Crop_Infestation_Attachment>;
  /** fetch data from the table: "crop_infestation" using primary key columns */
  crop_infestation_by_pk?: Maybe<Crop_Infestation>;
  /** fetch data from the table in a streaming manner : "crop_infestation" */
  crop_infestation_stream: Array<Crop_Infestation>;
  /** fetch data from the table: "crop_milestone" */
  crop_milestone: Array<Crop_Milestone>;
  /** fetch aggregated fields from the table: "crop_milestone" */
  crop_milestone_aggregate: Crop_Milestone_Aggregate;
  /** fetch data from the table: "crop_milestone" using primary key columns */
  crop_milestone_by_pk?: Maybe<Crop_Milestone>;
  /** fetch data from the table in a streaming manner : "crop_milestone" */
  crop_milestone_stream: Array<Crop_Milestone>;
  /** fetch data from the table: "crop_rootstock" */
  crop_rootstock: Array<Crop_Rootstock>;
  /** fetch aggregated fields from the table: "crop_rootstock" */
  crop_rootstock_aggregate: Crop_Rootstock_Aggregate;
  /** fetch data from the table: "crop_rootstock" using primary key columns */
  crop_rootstock_by_pk?: Maybe<Crop_Rootstock>;
  /** fetch data from the table in a streaming manner : "crop_rootstock" */
  crop_rootstock_stream: Array<Crop_Rootstock>;
  /** fetch data from the table in a streaming manner : "crop" */
  crop_stream: Array<Crop>;
  /** fetch data from the table: "crop_variety" */
  crop_variety: Array<Crop_Variety>;
  /** fetch aggregated fields from the table: "crop_variety" */
  crop_variety_aggregate: Crop_Variety_Aggregate;
  /** fetch data from the table: "crop_variety_breeder" */
  crop_variety_breeder: Array<Crop_Variety_Breeder>;
  /** fetch aggregated fields from the table: "crop_variety_breeder" */
  crop_variety_breeder_aggregate: Crop_Variety_Breeder_Aggregate;
  /** fetch data from the table: "crop_variety_breeder" using primary key columns */
  crop_variety_breeder_by_pk?: Maybe<Crop_Variety_Breeder>;
  /** fetch data from the table in a streaming manner : "crop_variety_breeder" */
  crop_variety_breeder_stream: Array<Crop_Variety_Breeder>;
  /** fetch data from the table: "crop_variety" using primary key columns */
  crop_variety_by_pk?: Maybe<Crop_Variety>;
  /** fetch data from the table in a streaming manner : "crop_variety" */
  crop_variety_stream: Array<Crop_Variety>;
  /** fetch data from the table: "crop_year" */
  crop_year: Array<Crop_Year>;
  /** fetch aggregated fields from the table: "crop_year" */
  crop_year_aggregate: Crop_Year_Aggregate;
  /** fetch data from the table: "crop_year" using primary key columns */
  crop_year_by_pk?: Maybe<Crop_Year>;
  /** fetch data from the table in a streaming manner : "crop_year" */
  crop_year_stream: Array<Crop_Year>;
  /** fetch data from the table: "cultivation_type" */
  cultivation_type: Array<Cultivation_Type>;
  /** fetch aggregated fields from the table: "cultivation_type" */
  cultivation_type_aggregate: Cultivation_Type_Aggregate;
  /** fetch data from the table: "cultivation_type" using primary key columns */
  cultivation_type_by_pk?: Maybe<Cultivation_Type>;
  /** fetch data from the table in a streaming manner : "cultivation_type" */
  cultivation_type_stream: Array<Cultivation_Type>;
  /** fetch data from the table: "demand" */
  demand: Array<Demand>;
  /** fetch aggregated fields from the table: "demand" */
  demand_aggregate: Demand_Aggregate;
  /** fetch data from the table: "demand_attachments" */
  demand_attachments: Array<Demand_Attachments>;
  /** fetch aggregated fields from the table: "demand_attachments" */
  demand_attachments_aggregate: Demand_Attachments_Aggregate;
  /** fetch data from the table: "demand_attachments" using primary key columns */
  demand_attachments_by_pk?: Maybe<Demand_Attachments>;
  /** fetch data from the table in a streaming manner : "demand_attachments" */
  demand_attachments_stream: Array<Demand_Attachments>;
  /** fetch data from the table: "demand" using primary key columns */
  demand_by_pk?: Maybe<Demand>;
  /** fetch data from the table: "demand_enquiries" */
  demand_enquiries: Array<Demand_Enquiries>;
  /** fetch aggregated fields from the table: "demand_enquiries" */
  demand_enquiries_aggregate: Demand_Enquiries_Aggregate;
  /** fetch data from the table: "demand_enquiries" using primary key columns */
  demand_enquiries_by_pk?: Maybe<Demand_Enquiries>;
  /** fetch data from the table in a streaming manner : "demand_enquiries" */
  demand_enquiries_stream: Array<Demand_Enquiries>;
  /** fetch data from the table: "demand_enquiries_twilio_message" */
  demand_enquiries_twilio_message: Array<Demand_Enquiries_Twilio_Message>;
  /** fetch aggregated fields from the table: "demand_enquiries_twilio_message" */
  demand_enquiries_twilio_message_aggregate: Demand_Enquiries_Twilio_Message_Aggregate;
  /** fetch data from the table: "demand_enquiries_twilio_message" using primary key columns */
  demand_enquiries_twilio_message_by_pk?: Maybe<Demand_Enquiries_Twilio_Message>;
  /** fetch data from the table in a streaming manner : "demand_enquiries_twilio_message" */
  demand_enquiries_twilio_message_stream: Array<Demand_Enquiries_Twilio_Message>;
  /** fetch data from the table: "demand_enquiry_status_log" */
  demand_enquiry_status_log: Array<Demand_Enquiry_Status_Log>;
  /** fetch aggregated fields from the table: "demand_enquiry_status_log" */
  demand_enquiry_status_log_aggregate: Demand_Enquiry_Status_Log_Aggregate;
  /** fetch data from the table: "demand_enquiry_status_log" using primary key columns */
  demand_enquiry_status_log_by_pk?: Maybe<Demand_Enquiry_Status_Log>;
  /** fetch data from the table in a streaming manner : "demand_enquiry_status_log" */
  demand_enquiry_status_log_stream: Array<Demand_Enquiry_Status_Log>;
  /** fetch data from the table: "demand_expense" */
  demand_expense: Array<Demand_Expense>;
  /** fetch aggregated fields from the table: "demand_expense" */
  demand_expense_aggregate: Demand_Expense_Aggregate;
  /** fetch data from the table: "demand_expense" using primary key columns */
  demand_expense_by_pk?: Maybe<Demand_Expense>;
  /** fetch data from the table in a streaming manner : "demand_expense" */
  demand_expense_stream: Array<Demand_Expense>;
  /** An array relationship */
  demand_seller_groups: Array<Demand_Seller_Groups>;
  /** An aggregate relationship */
  demand_seller_groups_aggregate: Demand_Seller_Groups_Aggregate;
  /** fetch data from the table: "demand_seller_groups" using primary key columns */
  demand_seller_groups_by_pk?: Maybe<Demand_Seller_Groups>;
  /** fetch data from the table in a streaming manner : "demand_seller_groups" */
  demand_seller_groups_stream: Array<Demand_Seller_Groups>;
  /** fetch data from the table in a streaming manner : "demand" */
  demand_stream: Array<Demand>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: Department_Aggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** fetch data from the table: "department_config" */
  department_config: Array<Department_Config>;
  /** fetch aggregated fields from the table: "department_config" */
  department_config_aggregate: Department_Config_Aggregate;
  /** fetch data from the table: "department_config" using primary key columns */
  department_config_by_pk?: Maybe<Department_Config>;
  /** fetch data from the table in a streaming manner : "department_config" */
  department_config_stream: Array<Department_Config>;
  /** fetch data from the table: "department_payment_detail" */
  department_payment_detail: Array<Department_Payment_Detail>;
  /** fetch aggregated fields from the table: "department_payment_detail" */
  department_payment_detail_aggregate: Department_Payment_Detail_Aggregate;
  /** fetch data from the table: "department_payment_detail" using primary key columns */
  department_payment_detail_by_pk?: Maybe<Department_Payment_Detail>;
  /** fetch data from the table in a streaming manner : "department_payment_detail" */
  department_payment_detail_stream: Array<Department_Payment_Detail>;
  /** fetch data from the table: "department_settlements" */
  department_settlements: Array<Department_Settlements>;
  /** fetch aggregated fields from the table: "department_settlements" */
  department_settlements_aggregate: Department_Settlements_Aggregate;
  /** fetch data from the table: "department_settlements" using primary key columns */
  department_settlements_by_pk?: Maybe<Department_Settlements>;
  /** fetch data from the table in a streaming manner : "department_settlements" */
  department_settlements_stream: Array<Department_Settlements>;
  /** fetch data from the table in a streaming manner : "department" */
  department_stream: Array<Department>;
  /** fetch data from the table: "department_user_advance" */
  department_user_advance: Array<Department_User_Advance>;
  /** fetch aggregated fields from the table: "department_user_advance" */
  department_user_advance_aggregate: Department_User_Advance_Aggregate;
  /** fetch data from the table: "department_user_advance" using primary key columns */
  department_user_advance_by_pk?: Maybe<Department_User_Advance>;
  /** fetch data from the table in a streaming manner : "department_user_advance" */
  department_user_advance_stream: Array<Department_User_Advance>;
  /** fetch data from the table: "device" */
  device: Array<Device>;
  /** fetch aggregated fields from the table: "device" */
  device_aggregate: Device_Aggregate;
  /** fetch data from the table: "device" using primary key columns */
  device_by_pk?: Maybe<Device>;
  /** fetch data from the table in a streaming manner : "device" */
  device_stream: Array<Device>;
  /** fetch data from the table: "django_celery_results_taskresult" */
  django_celery_results_taskresult: Array<Django_Celery_Results_Taskresult>;
  /** fetch aggregated fields from the table: "django_celery_results_taskresult" */
  django_celery_results_taskresult_aggregate: Django_Celery_Results_Taskresult_Aggregate;
  /** fetch data from the table: "django_celery_results_taskresult" using primary key columns */
  django_celery_results_taskresult_by_pk?: Maybe<Django_Celery_Results_Taskresult>;
  /** fetch data from the table in a streaming manner : "django_celery_results_taskresult" */
  django_celery_results_taskresult_stream: Array<Django_Celery_Results_Taskresult>;
  /** fetch data from the table in a streaming manner : "django_content_type" */
  django_content_type_stream: Array<Django_Content_Type>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document_attachments" */
  document_attachments: Array<Document_Attachments>;
  /** fetch aggregated fields from the table: "document_attachments" */
  document_attachments_aggregate: Document_Attachments_Aggregate;
  /** fetch data from the table: "document_attachments" using primary key columns */
  document_attachments_by_pk?: Maybe<Document_Attachments>;
  /** fetch data from the table in a streaming manner : "document_attachments" */
  document_attachments_stream: Array<Document_Attachments>;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** An array relationship */
  document_data: Array<Document_Data>;
  /** An aggregate relationship */
  document_data_aggregate: Document_Data_Aggregate;
  /** fetch data from the table: "document_data" using primary key columns */
  document_data_by_pk?: Maybe<Document_Data>;
  /** fetch data from the table in a streaming manner : "document_data" */
  document_data_stream: Array<Document_Data>;
  /** fetch data from the table: "document_export_log" */
  document_export_log: Array<Document_Export_Log>;
  /** fetch aggregated fields from the table: "document_export_log" */
  document_export_log_aggregate: Document_Export_Log_Aggregate;
  /** fetch data from the table: "document_export_log" using primary key columns */
  document_export_log_by_pk?: Maybe<Document_Export_Log>;
  /** fetch data from the table in a streaming manner : "document_export_log" */
  document_export_log_stream: Array<Document_Export_Log>;
  /** fetch data from the table: "document_kind" */
  document_kind: Array<Document_Kind>;
  /** fetch aggregated fields from the table: "document_kind" */
  document_kind_aggregate: Document_Kind_Aggregate;
  /** fetch data from the table: "document_kind" using primary key columns */
  document_kind_by_pk?: Maybe<Document_Kind>;
  /** fetch data from the table: "document_kind_data_field" */
  document_kind_data_field: Array<Document_Kind_Data_Field>;
  /** fetch aggregated fields from the table: "document_kind_data_field" */
  document_kind_data_field_aggregate: Document_Kind_Data_Field_Aggregate;
  /** fetch data from the table: "document_kind_data_field" using primary key columns */
  document_kind_data_field_by_pk?: Maybe<Document_Kind_Data_Field>;
  /** fetch data from the table in a streaming manner : "document_kind_data_field" */
  document_kind_data_field_stream: Array<Document_Kind_Data_Field>;
  /** fetch data from the table in a streaming manner : "document_kind" */
  document_kind_stream: Array<Document_Kind>;
  /** fetch data from the table: "document_report" */
  document_report: Array<Document_Report>;
  /** fetch aggregated fields from the table: "document_report" */
  document_report_aggregate: Document_Report_Aggregate;
  /** fetch data from the table: "document_report" using primary key columns */
  document_report_by_pk?: Maybe<Document_Report>;
  /** fetch data from the table in a streaming manner : "document_report" */
  document_report_stream: Array<Document_Report>;
  /** fetch data from the table: "document_revision" */
  document_revision: Array<Document_Revision>;
  /** fetch aggregated fields from the table: "document_revision" */
  document_revision_aggregate: Document_Revision_Aggregate;
  /** fetch data from the table: "document_revision" using primary key columns */
  document_revision_by_pk?: Maybe<Document_Revision>;
  /** fetch data from the table in a streaming manner : "document_revision" */
  document_revision_stream: Array<Document_Revision>;
  /** fetch data from the table in a streaming manner : "document" */
  document_stream: Array<Document>;
  /** fetch data from the table: "address" */
  eagle_address: Array<Eagle_Address>;
  /** fetch aggregated fields from the table: "address" */
  eagle_address_aggregate: Eagle_Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  eagle_address_by_pk?: Maybe<Eagle_Address>;
  /** fetch data from the table in a streaming manner : "address" */
  eagle_address_stream: Array<Eagle_Address>;
  /** fetch data from the table: "media" */
  eagle_media: Array<Eagle_Media>;
  /** fetch aggregated fields from the table: "media" */
  eagle_media_aggregate: Eagle_Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  eagle_media_by_pk?: Maybe<Eagle_Media>;
  /** fetch data from the table in a streaming manner : "media" */
  eagle_media_stream: Array<Eagle_Media>;
  /** fetch data from the table: "entity_state" */
  entity_state: Array<Entity_State>;
  /** fetch aggregated fields from the table: "entity_state" */
  entity_state_aggregate: Entity_State_Aggregate;
  /** fetch data from the table: "entity_state" using primary key columns */
  entity_state_by_pk?: Maybe<Entity_State>;
  /** fetch data from the table in a streaming manner : "entity_state" */
  entity_state_stream: Array<Entity_State>;
  /** fetch data from the table: "evaluation_criteria" */
  evaluation_criteria: Array<Evaluation_Criteria>;
  /** fetch aggregated fields from the table: "evaluation_criteria" */
  evaluation_criteria_aggregate: Evaluation_Criteria_Aggregate;
  /** fetch data from the table: "evaluation_criteria" using primary key columns */
  evaluation_criteria_by_pk?: Maybe<Evaluation_Criteria>;
  /** fetch data from the table in a streaming manner : "evaluation_criteria" */
  evaluation_criteria_stream: Array<Evaluation_Criteria>;
  /** fetch data from the table: "evaluation_tag" */
  evaluation_tag: Array<Evaluation_Tag>;
  /** fetch aggregated fields from the table: "evaluation_tag" */
  evaluation_tag_aggregate: Evaluation_Tag_Aggregate;
  /** fetch data from the table: "evaluation_tag" using primary key columns */
  evaluation_tag_by_pk?: Maybe<Evaluation_Tag>;
  /** fetch data from the table in a streaming manner : "evaluation_tag" */
  evaluation_tag_stream: Array<Evaluation_Tag>;
  /** fetch data from the table: "expense" */
  expense: Array<Expense>;
  /** fetch aggregated fields from the table: "expense" */
  expense_aggregate: Expense_Aggregate;
  /** fetch data from the table: "expense" using primary key columns */
  expense_by_pk?: Maybe<Expense>;
  /** fetch data from the table: "expense_parameter" */
  expense_parameter: Array<Expense_Parameter>;
  /** fetch data from the table: "expense_parameter" using primary key columns */
  expense_parameter_by_pk?: Maybe<Expense_Parameter>;
  /** fetch data from the table in a streaming manner : "expense_parameter" */
  expense_parameter_stream: Array<Expense_Parameter>;
  /** fetch data from the table in a streaming manner : "expense" */
  expense_stream: Array<Expense>;
  /** fetch data from the table: "external_application" */
  external_application: Array<External_Application>;
  /** fetch aggregated fields from the table: "external_application" */
  external_application_aggregate: External_Application_Aggregate;
  /** fetch data from the table: "external_application" using primary key columns */
  external_application_by_pk?: Maybe<External_Application>;
  /** fetch data from the table in a streaming manner : "external_application" */
  external_application_stream: Array<External_Application>;
  /** fetch data from the table: "external_entity" */
  external_entity: Array<External_Entity>;
  /** fetch aggregated fields from the table: "external_entity" */
  external_entity_aggregate: External_Entity_Aggregate;
  /** fetch data from the table: "external_entity" using primary key columns */
  external_entity_by_pk?: Maybe<External_Entity>;
  /** fetch data from the table: "external_entity_group" */
  external_entity_group: Array<External_Entity_Group>;
  /** fetch aggregated fields from the table: "external_entity_group" */
  external_entity_group_aggregate: External_Entity_Group_Aggregate;
  /** fetch data from the table: "external_entity_group" using primary key columns */
  external_entity_group_by_pk?: Maybe<External_Entity_Group>;
  /** fetch data from the table in a streaming manner : "external_entity_group" */
  external_entity_group_stream: Array<External_Entity_Group>;
  /** fetch data from the table in a streaming manner : "external_entity" */
  external_entity_stream: Array<External_Entity>;
  /** fetch data from the table: "external_reference" */
  external_reference: Array<External_Reference>;
  /** fetch aggregated fields from the table: "external_reference" */
  external_reference_aggregate: External_Reference_Aggregate;
  /** fetch data from the table: "external_reference" using primary key columns */
  external_reference_by_pk?: Maybe<External_Reference>;
  /** fetch data from the table in a streaming manner : "external_reference" */
  external_reference_stream: Array<External_Reference>;
  /** fetch data from the table: "farm" */
  farm: Array<Farm>;
  /** fetch aggregated fields from the table: "farm" */
  farm_aggregate: Farm_Aggregate;
  /** fetch data from the table: "farm" using primary key columns */
  farm_by_pk?: Maybe<Farm>;
  /** fetch data from the table: "farm_network" */
  farm_network: Array<Farm_Network>;
  /** fetch aggregated fields from the table: "farm_network" */
  farm_network_aggregate: Farm_Network_Aggregate;
  /** fetch data from the table: "farm_network" using primary key columns */
  farm_network_by_pk?: Maybe<Farm_Network>;
  /** fetch data from the table in a streaming manner : "farm_network" */
  farm_network_stream: Array<Farm_Network>;
  /** fetch data from the table in a streaming manner : "farm" */
  farm_stream: Array<Farm>;
  /** fetch data from the table: "field" */
  field: Array<Field>;
  /** fetch aggregated fields from the table: "field" */
  field_aggregate: Field_Aggregate;
  /** fetch data from the table: "field" using primary key columns */
  field_by_pk?: Maybe<Field>;
  /** fetch data from the table: "field_network" */
  field_network: Array<Field_Network>;
  /** fetch aggregated fields from the table: "field_network" */
  field_network_aggregate: Field_Network_Aggregate;
  /** fetch data from the table: "field_network" using primary key columns */
  field_network_by_pk?: Maybe<Field_Network>;
  /** fetch data from the table in a streaming manner : "field_network" */
  field_network_stream: Array<Field_Network>;
  /** fetch data from the table in a streaming manner : "field" */
  field_stream: Array<Field>;
  /** fetch data from the table: "field_weather_location" */
  field_weather_location: Array<Field_Weather_Location>;
  /** fetch aggregated fields from the table: "field_weather_location" */
  field_weather_location_aggregate: Field_Weather_Location_Aggregate;
  /** fetch data from the table: "field_weather_location" using primary key columns */
  field_weather_location_by_pk?: Maybe<Field_Weather_Location>;
  /** fetch data from the table in a streaming manner : "field_weather_location" */
  field_weather_location_stream: Array<Field_Weather_Location>;
  /** fetch data from the table: "financial_year" */
  financial_year: Array<Financial_Year>;
  /** fetch aggregated fields from the table: "financial_year" */
  financial_year_aggregate: Financial_Year_Aggregate;
  /** fetch data from the table: "financial_year_assessment" */
  financial_year_assessment: Array<Financial_Year_Assessment>;
  /** fetch aggregated fields from the table: "financial_year_assessment" */
  financial_year_assessment_aggregate: Financial_Year_Assessment_Aggregate;
  /** fetch data from the table: "financial_year_assessment" using primary key columns */
  financial_year_assessment_by_pk?: Maybe<Financial_Year_Assessment>;
  /** An array relationship */
  financial_year_assessment_cw: Array<Financial_Year_Assessment_Cw>;
  /** An aggregate relationship */
  financial_year_assessment_cw_aggregate: Financial_Year_Assessment_Cw_Aggregate;
  /** fetch data from the table: "financial_year_assessment_cw" using primary key columns */
  financial_year_assessment_cw_by_pk?: Maybe<Financial_Year_Assessment_Cw>;
  /** fetch data from the table in a streaming manner : "financial_year_assessment_cw" */
  financial_year_assessment_cw_stream: Array<Financial_Year_Assessment_Cw>;
  /** fetch data from the table in a streaming manner : "financial_year_assessment" */
  financial_year_assessment_stream: Array<Financial_Year_Assessment>;
  /** fetch data from the table: "financial_year" using primary key columns */
  financial_year_by_pk?: Maybe<Financial_Year>;
  /** fetch data from the table: "financial_year_cw" */
  financial_year_cw: Array<Financial_Year_Cw>;
  /** fetch aggregated fields from the table: "financial_year_cw" */
  financial_year_cw_aggregate: Financial_Year_Cw_Aggregate;
  /** fetch data from the table: "financial_year_cw" using primary key columns */
  financial_year_cw_by_pk?: Maybe<Financial_Year_Cw>;
  /** fetch data from the table in a streaming manner : "financial_year_cw" */
  financial_year_cw_stream: Array<Financial_Year_Cw>;
  /** fetch data from the table in a streaming manner : "financial_year" */
  financial_year_stream: Array<Financial_Year>;
  /** fetch data from the table: "grade" */
  grade: Array<Grade>;
  /** fetch aggregated fields from the table: "grade" */
  grade_aggregate: Grade_Aggregate;
  /** fetch data from the table: "grade" using primary key columns */
  grade_by_pk?: Maybe<Grade>;
  /** fetch data from the table: "grade_company" */
  grade_company: Array<Grade_Company>;
  /** fetch aggregated fields from the table: "grade_company" */
  grade_company_aggregate: Grade_Company_Aggregate;
  /** fetch data from the table: "grade_company" using primary key columns */
  grade_company_by_pk?: Maybe<Grade_Company>;
  /** fetch data from the table in a streaming manner : "grade_company" */
  grade_company_stream: Array<Grade_Company>;
  /** fetch data from the table: "grade_price" */
  grade_price: Array<Grade_Price>;
  /** fetch aggregated fields from the table: "grade_price" */
  grade_price_aggregate: Grade_Price_Aggregate;
  /** fetch data from the table: "grade_price" using primary key columns */
  grade_price_by_pk?: Maybe<Grade_Price>;
  /** fetch data from the table in a streaming manner : "grade_price" */
  grade_price_stream: Array<Grade_Price>;
  /** fetch data from the table in a streaming manner : "grade" */
  grade_stream: Array<Grade>;
  /** fetch data from the table: "guarantor_agreement" */
  guarantor_agreement: Array<Guarantor_Agreement>;
  /** fetch aggregated fields from the table: "guarantor_agreement" */
  guarantor_agreement_aggregate: Guarantor_Agreement_Aggregate;
  /** fetch data from the table: "guarantor_agreement_agreement_invoices" */
  guarantor_agreement_agreement_invoices: Array<Guarantor_Agreement_Agreement_Invoices>;
  /** fetch aggregated fields from the table: "guarantor_agreement_agreement_invoices" */
  guarantor_agreement_agreement_invoices_aggregate: Guarantor_Agreement_Agreement_Invoices_Aggregate;
  /** fetch data from the table: "guarantor_agreement_agreement_invoices" using primary key columns */
  guarantor_agreement_agreement_invoices_by_pk?: Maybe<Guarantor_Agreement_Agreement_Invoices>;
  /** fetch data from the table in a streaming manner : "guarantor_agreement_agreement_invoices" */
  guarantor_agreement_agreement_invoices_stream: Array<Guarantor_Agreement_Agreement_Invoices>;
  /** fetch data from the table: "guarantor_agreement_agreement_plots" */
  guarantor_agreement_agreement_plots: Array<Guarantor_Agreement_Agreement_Plots>;
  /** fetch aggregated fields from the table: "guarantor_agreement_agreement_plots" */
  guarantor_agreement_agreement_plots_aggregate: Guarantor_Agreement_Agreement_Plots_Aggregate;
  /** fetch data from the table: "guarantor_agreement_agreement_plots" using primary key columns */
  guarantor_agreement_agreement_plots_by_pk?: Maybe<Guarantor_Agreement_Agreement_Plots>;
  /** fetch data from the table in a streaming manner : "guarantor_agreement_agreement_plots" */
  guarantor_agreement_agreement_plots_stream: Array<Guarantor_Agreement_Agreement_Plots>;
  /** fetch data from the table: "guarantor_agreement_area_extension_detail" */
  guarantor_agreement_area_extension_detail: Array<Guarantor_Agreement_Area_Extension_Detail>;
  /** fetch aggregated fields from the table: "guarantor_agreement_area_extension_detail" */
  guarantor_agreement_area_extension_detail_aggregate: Guarantor_Agreement_Area_Extension_Detail_Aggregate;
  /** fetch data from the table: "guarantor_agreement_area_extension_detail" using primary key columns */
  guarantor_agreement_area_extension_detail_by_pk?: Maybe<Guarantor_Agreement_Area_Extension_Detail>;
  /** fetch data from the table in a streaming manner : "guarantor_agreement_area_extension_detail" */
  guarantor_agreement_area_extension_detail_stream: Array<Guarantor_Agreement_Area_Extension_Detail>;
  /** fetch data from the table: "guarantor_agreement" using primary key columns */
  guarantor_agreement_by_pk?: Maybe<Guarantor_Agreement>;
  /** fetch data from the table in a streaming manner : "guarantor_agreement" */
  guarantor_agreement_stream: Array<Guarantor_Agreement>;
  /** fetch data from the table: "infestation" */
  infestation: Array<Infestation>;
  /** fetch aggregated fields from the table: "infestation" */
  infestation_aggregate: Infestation_Aggregate;
  /** fetch data from the table: "infestation" using primary key columns */
  infestation_by_pk?: Maybe<Infestation>;
  /** fetch data from the table in a streaming manner : "infestation" */
  infestation_stream: Array<Infestation>;
  /** fetch data from the table: "instrument" */
  instrument: Array<Instrument>;
  /** fetch aggregated fields from the table: "instrument" */
  instrument_aggregate: Instrument_Aggregate;
  /** fetch data from the table: "instrument" using primary key columns */
  instrument_by_pk?: Maybe<Instrument>;
  /** fetch data from the table: "instrument_departments" */
  instrument_departments: Array<Instrument_Departments>;
  /** fetch aggregated fields from the table: "instrument_departments" */
  instrument_departments_aggregate: Instrument_Departments_Aggregate;
  /** fetch data from the table: "instrument_departments" using primary key columns */
  instrument_departments_by_pk?: Maybe<Instrument_Departments>;
  /** fetch data from the table in a streaming manner : "instrument_departments" */
  instrument_departments_stream: Array<Instrument_Departments>;
  /** fetch data from the table: "instrument_kind" */
  instrument_kind: Array<Instrument_Kind>;
  /** fetch aggregated fields from the table: "instrument_kind" */
  instrument_kind_aggregate: Instrument_Kind_Aggregate;
  /** fetch data from the table: "instrument_kind" using primary key columns */
  instrument_kind_by_pk?: Maybe<Instrument_Kind>;
  /** fetch data from the table in a streaming manner : "instrument_kind" */
  instrument_kind_stream: Array<Instrument_Kind>;
  /** fetch data from the table in a streaming manner : "instrument" */
  instrument_stream: Array<Instrument>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table in a streaming manner : "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "issuance_note" */
  issuance_note: Array<Issuance_Note>;
  /** fetch aggregated fields from the table: "issuance_note" */
  issuance_note_aggregate: Issuance_Note_Aggregate;
  /** fetch data from the table: "issuance_note_attachments" */
  issuance_note_attachments: Array<Issuance_Note_Attachments>;
  /** fetch aggregated fields from the table: "issuance_note_attachments" */
  issuance_note_attachments_aggregate: Issuance_Note_Attachments_Aggregate;
  /** fetch data from the table: "issuance_note_attachments" using primary key columns */
  issuance_note_attachments_by_pk?: Maybe<Issuance_Note_Attachments>;
  /** fetch data from the table in a streaming manner : "issuance_note_attachments" */
  issuance_note_attachments_stream: Array<Issuance_Note_Attachments>;
  /** fetch data from the table: "issuance_note" using primary key columns */
  issuance_note_by_pk?: Maybe<Issuance_Note>;
  /** fetch data from the table: "issuance_note_item_taxes" */
  issuance_note_item_taxes: Array<Issuance_Note_Item_Taxes>;
  /** fetch aggregated fields from the table: "issuance_note_item_taxes" */
  issuance_note_item_taxes_aggregate: Issuance_Note_Item_Taxes_Aggregate;
  /** fetch data from the table: "issuance_note_item_taxes" using primary key columns */
  issuance_note_item_taxes_by_pk?: Maybe<Issuance_Note_Item_Taxes>;
  /** fetch data from the table in a streaming manner : "issuance_note_item_taxes" */
  issuance_note_item_taxes_stream: Array<Issuance_Note_Item_Taxes>;
  /** fetch data from the table in a streaming manner : "issuance_note" */
  issuance_note_stream: Array<Issuance_Note>;
  /** fetch data from the table: "issuance_note_taxes" */
  issuance_note_taxes: Array<Issuance_Note_Taxes>;
  /** fetch aggregated fields from the table: "issuance_note_taxes" */
  issuance_note_taxes_aggregate: Issuance_Note_Taxes_Aggregate;
  /** fetch data from the table: "issuance_note_taxes" using primary key columns */
  issuance_note_taxes_by_pk?: Maybe<Issuance_Note_Taxes>;
  /** fetch data from the table in a streaming manner : "issuance_note_taxes" */
  issuance_note_taxes_stream: Array<Issuance_Note_Taxes>;
  /** fetch data from the table: "notification" */
  kite_notification: Array<Kite_Notification>;
  /** fetch aggregated fields from the table: "notification" */
  kite_notification_aggregate: Kite_Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  kite_notification_by_pk?: Maybe<Kite_Notification>;
  /** fetch data from the table in a streaming manner : "notification" */
  kite_notification_stream: Array<Kite_Notification>;
  /** fetch data from the table: "quality_stage" */
  kite_quality_stage: Array<Kite_Quality_Stage>;
  /** fetch aggregated fields from the table: "quality_stage" */
  kite_quality_stage_aggregate: Kite_Quality_Stage_Aggregate;
  /** fetch data from the table: "quality_stage" using primary key columns */
  kite_quality_stage_by_pk?: Maybe<Kite_Quality_Stage>;
  /** fetch data from the table in a streaming manner : "quality_stage" */
  kite_quality_stage_stream: Array<Kite_Quality_Stage>;
  /** fetch data from the table: "laboratory" */
  laboratory: Array<Laboratory>;
  /** fetch aggregated fields from the table: "laboratory" */
  laboratory_aggregate: Laboratory_Aggregate;
  /** fetch data from the table: "laboratory" using primary key columns */
  laboratory_by_pk?: Maybe<Laboratory>;
  /** fetch data from the table: "laboratory_organisations" */
  laboratory_organisations: Array<Laboratory_Organisations>;
  /** fetch aggregated fields from the table: "laboratory_organisations" */
  laboratory_organisations_aggregate: Laboratory_Organisations_Aggregate;
  /** fetch data from the table: "laboratory_organisations" using primary key columns */
  laboratory_organisations_by_pk?: Maybe<Laboratory_Organisations>;
  /** fetch data from the table in a streaming manner : "laboratory_organisations" */
  laboratory_organisations_stream: Array<Laboratory_Organisations>;
  /** fetch data from the table in a streaming manner : "laboratory" */
  laboratory_stream: Array<Laboratory>;
  /** fetch data from the table: "legal_agreement" */
  legal_agreement: Array<Legal_Agreement>;
  /** fetch aggregated fields from the table: "legal_agreement" */
  legal_agreement_aggregate: Legal_Agreement_Aggregate;
  /** fetch data from the table: "legal_agreement" using primary key columns */
  legal_agreement_by_pk?: Maybe<Legal_Agreement>;
  /** fetch data from the table in a streaming manner : "legal_agreement" */
  legal_agreement_stream: Array<Legal_Agreement>;
  /** fetch data from the table: "market" */
  market: Array<Market>;
  /** fetch aggregated fields from the table: "market" */
  market_aggregate: Market_Aggregate;
  /** fetch data from the table: "market_allowed_departments" */
  market_allowed_departments: Array<Market_Allowed_Departments>;
  /** fetch aggregated fields from the table: "market_allowed_departments" */
  market_allowed_departments_aggregate: Market_Allowed_Departments_Aggregate;
  /** fetch data from the table: "market_allowed_departments" using primary key columns */
  market_allowed_departments_by_pk?: Maybe<Market_Allowed_Departments>;
  /** fetch data from the table in a streaming manner : "market_allowed_departments" */
  market_allowed_departments_stream: Array<Market_Allowed_Departments>;
  /** fetch data from the table: "market" using primary key columns */
  market_by_pk?: Maybe<Market>;
  /** fetch data from the table in a streaming manner : "market" */
  market_stream: Array<Market>;
  /** fetch data from the table: "media" */
  media: Array<Media>;
  /** fetch aggregated fields from the table: "media" */
  media_aggregate: Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  media_by_pk?: Maybe<Media>;
  /** fetch data from the table in a streaming manner : "media" */
  media_stream: Array<Media>;
  /** fetch data from the table: "milestone" */
  milestone: Array<Milestone>;
  /** fetch aggregated fields from the table: "milestone" */
  milestone_aggregate: Milestone_Aggregate;
  /** fetch data from the table: "milestone" using primary key columns */
  milestone_by_pk?: Maybe<Milestone>;
  /** fetch data from the table in a streaming manner : "milestone" */
  milestone_stream: Array<Milestone>;
  /** fetch data from the table: "mutual_group" */
  mutual_group: Array<Mutual_Group>;
  /** fetch aggregated fields from the table: "mutual_group" */
  mutual_group_aggregate: Mutual_Group_Aggregate;
  /** fetch data from the table: "mutual_group" using primary key columns */
  mutual_group_by_pk?: Maybe<Mutual_Group>;
  /** fetch data from the table: "mutual_group_membership" */
  mutual_group_membership: Array<Mutual_Group_Membership>;
  /** fetch aggregated fields from the table: "mutual_group_membership" */
  mutual_group_membership_aggregate: Mutual_Group_Membership_Aggregate;
  /** fetch data from the table: "mutual_group_membership" using primary key columns */
  mutual_group_membership_by_pk?: Maybe<Mutual_Group_Membership>;
  /** fetch data from the table in a streaming manner : "mutual_group_membership" */
  mutual_group_membership_stream: Array<Mutual_Group_Membership>;
  /** fetch data from the table: "mutual_group_network" */
  mutual_group_network: Array<Mutual_Group_Network>;
  /** fetch aggregated fields from the table: "mutual_group_network" */
  mutual_group_network_aggregate: Mutual_Group_Network_Aggregate;
  /** fetch data from the table: "mutual_group_network" using primary key columns */
  mutual_group_network_by_pk?: Maybe<Mutual_Group_Network>;
  /** fetch data from the table in a streaming manner : "mutual_group_network" */
  mutual_group_network_stream: Array<Mutual_Group_Network>;
  /** fetch data from the table: "mutual_group_role" */
  mutual_group_role: Array<Mutual_Group_Role>;
  /** fetch aggregated fields from the table: "mutual_group_role" */
  mutual_group_role_aggregate: Mutual_Group_Role_Aggregate;
  /** fetch data from the table: "mutual_group_role" using primary key columns */
  mutual_group_role_by_pk?: Maybe<Mutual_Group_Role>;
  /** fetch data from the table in a streaming manner : "mutual_group_role" */
  mutual_group_role_stream: Array<Mutual_Group_Role>;
  /** fetch data from the table in a streaming manner : "mutual_group" */
  mutual_group_stream: Array<Mutual_Group>;
  /** fetch data from the table: "mutual_group_weather_station" */
  mutual_group_weather_station: Array<Mutual_Group_Weather_Station>;
  /** fetch aggregated fields from the table: "mutual_group_weather_station" */
  mutual_group_weather_station_aggregate: Mutual_Group_Weather_Station_Aggregate;
  /** fetch data from the table: "mutual_group_weather_station" using primary key columns */
  mutual_group_weather_station_by_pk?: Maybe<Mutual_Group_Weather_Station>;
  /** fetch data from the table in a streaming manner : "mutual_group_weather_station" */
  mutual_group_weather_station_stream: Array<Mutual_Group_Weather_Station>;
  /** fetch data from the table: "nationality" */
  nationality: Array<Nationality>;
  /** fetch aggregated fields from the table: "nationality" */
  nationality_aggregate: Nationality_Aggregate;
  /** fetch data from the table: "nationality" using primary key columns */
  nationality_by_pk?: Maybe<Nationality>;
  /** fetch data from the table in a streaming manner : "nationality" */
  nationality_stream: Array<Nationality>;
  /** fetch data from the table: "network" */
  network: Array<Network>;
  /** fetch aggregated fields from the table: "network" */
  network_aggregate: Network_Aggregate;
  /** fetch data from the table: "network" using primary key columns */
  network_by_pk?: Maybe<Network>;
  /** fetch data from the table in a streaming manner : "network" */
  network_stream: Array<Network>;
  /** fetch data from the table: "nominees" */
  nominees: Array<Nominees>;
  /** fetch aggregated fields from the table: "nominees" */
  nominees_aggregate: Nominees_Aggregate;
  /** fetch data from the table: "nominees" using primary key columns */
  nominees_by_pk?: Maybe<Nominees>;
  /** fetch data from the table: "nominees_documents" */
  nominees_documents: Array<Nominees_Documents>;
  /** fetch aggregated fields from the table: "nominees_documents" */
  nominees_documents_aggregate: Nominees_Documents_Aggregate;
  /** fetch data from the table: "nominees_documents" using primary key columns */
  nominees_documents_by_pk?: Maybe<Nominees_Documents>;
  /** fetch data from the table in a streaming manner : "nominees_documents" */
  nominees_documents_stream: Array<Nominees_Documents>;
  /** fetch data from the table in a streaming manner : "nominees" */
  nominees_stream: Array<Nominees>;
  /** fetch data from the table: "notification_provider" */
  notification_provider: Array<Notification_Provider>;
  /** fetch aggregated fields from the table: "notification_provider" */
  notification_provider_aggregate: Notification_Provider_Aggregate;
  /** fetch data from the table: "notification_provider" using primary key columns */
  notification_provider_by_pk?: Maybe<Notification_Provider>;
  /** fetch data from the table in a streaming manner : "notification_provider" */
  notification_provider_stream: Array<Notification_Provider>;
  /** fetch data from the table: "notification_trigger" */
  notification_trigger: Array<Notification_Trigger>;
  /** fetch aggregated fields from the table: "notification_trigger" */
  notification_trigger_aggregate: Notification_Trigger_Aggregate;
  /** fetch data from the table: "notification_trigger" using primary key columns */
  notification_trigger_by_pk?: Maybe<Notification_Trigger>;
  /** fetch data from the table in a streaming manner : "notification_trigger" */
  notification_trigger_stream: Array<Notification_Trigger>;
  /** An array relationship */
  offer_attachments: Array<Offer_Attachments>;
  /** An aggregate relationship */
  offer_attachments_aggregate: Offer_Attachments_Aggregate;
  /** fetch data from the table: "offer_attachments" using primary key columns */
  offer_attachments_by_pk?: Maybe<Offer_Attachments>;
  /** fetch data from the table in a streaming manner : "offer_attachments" */
  offer_attachments_stream: Array<Offer_Attachments>;
  /** An array relationship */
  offer_enquiries: Array<Offer_Enquiries>;
  /** An aggregate relationship */
  offer_enquiries_aggregate: Offer_Enquiries_Aggregate;
  /** fetch data from the table: "offer_enquiries" using primary key columns */
  offer_enquiries_by_pk?: Maybe<Offer_Enquiries>;
  /** fetch data from the table in a streaming manner : "offer_enquiries" */
  offer_enquiries_stream: Array<Offer_Enquiries>;
  /** fetch data from the table: "offer_enquiries_twilio_message" */
  offer_enquiries_twilio_message: Array<Offer_Enquiries_Twilio_Message>;
  /** fetch aggregated fields from the table: "offer_enquiries_twilio_message" */
  offer_enquiries_twilio_message_aggregate: Offer_Enquiries_Twilio_Message_Aggregate;
  /** fetch data from the table: "offer_enquiries_twilio_message" using primary key columns */
  offer_enquiries_twilio_message_by_pk?: Maybe<Offer_Enquiries_Twilio_Message>;
  /** fetch data from the table in a streaming manner : "offer_enquiries_twilio_message" */
  offer_enquiries_twilio_message_stream: Array<Offer_Enquiries_Twilio_Message>;
  /** fetch data from the table: "offer_enquiry_status_log" */
  offer_enquiry_status_log: Array<Offer_Enquiry_Status_Log>;
  /** fetch aggregated fields from the table: "offer_enquiry_status_log" */
  offer_enquiry_status_log_aggregate: Offer_Enquiry_Status_Log_Aggregate;
  /** fetch data from the table: "offer_enquiry_status_log" using primary key columns */
  offer_enquiry_status_log_by_pk?: Maybe<Offer_Enquiry_Status_Log>;
  /** fetch data from the table in a streaming manner : "offer_enquiry_status_log" */
  offer_enquiry_status_log_stream: Array<Offer_Enquiry_Status_Log>;
  /** fetch data from the table: "offer_expense" */
  offer_expense: Array<Offer_Expense>;
  /** fetch aggregated fields from the table: "offer_expense" */
  offer_expense_aggregate: Offer_Expense_Aggregate;
  /** fetch data from the table: "offer_expense" using primary key columns */
  offer_expense_by_pk?: Maybe<Offer_Expense>;
  /** fetch data from the table in a streaming manner : "offer_expense" */
  offer_expense_stream: Array<Offer_Expense>;
  /** fetch data from the table: "offer_order_picked" */
  offer_order_picked: Array<Offer_Order_Picked>;
  /** fetch aggregated fields from the table: "offer_order_picked" */
  offer_order_picked_aggregate: Offer_Order_Picked_Aggregate;
  /** fetch data from the table: "offer_order_picked" using primary key columns */
  offer_order_picked_by_pk?: Maybe<Offer_Order_Picked>;
  /** fetch data from the table in a streaming manner : "offer_order_picked" */
  offer_order_picked_stream: Array<Offer_Order_Picked>;
  /** fetch data from the table: "offer_storage_picked" */
  offer_storage_picked: Array<Offer_Storage_Picked>;
  /** fetch aggregated fields from the table: "offer_storage_picked" */
  offer_storage_picked_aggregate: Offer_Storage_Picked_Aggregate;
  /** fetch data from the table: "offer_storage_picked" using primary key columns */
  offer_storage_picked_by_pk?: Maybe<Offer_Storage_Picked>;
  /** fetch data from the table in a streaming manner : "offer_storage_picked" */
  offer_storage_picked_stream: Array<Offer_Storage_Picked>;
  /** fetch data from the table: "offers" */
  offers: Array<Offers>;
  /** fetch aggregated fields from the table: "offers" */
  offers_aggregate: Offers_Aggregate;
  /** An array relationship */
  offers_buyer_groups: Array<Offers_Buyer_Groups>;
  /** An aggregate relationship */
  offers_buyer_groups_aggregate: Offers_Buyer_Groups_Aggregate;
  /** fetch data from the table: "offers_buyer_groups" using primary key columns */
  offers_buyer_groups_by_pk?: Maybe<Offers_Buyer_Groups>;
  /** fetch data from the table in a streaming manner : "offers_buyer_groups" */
  offers_buyer_groups_stream: Array<Offers_Buyer_Groups>;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  /** fetch data from the table in a streaming manner : "offers" */
  offers_stream: Array<Offers>;
  /** fetch data from the table: "org_dashboard_stats" */
  org_dashboard_stats: Array<Org_Dashboard_Stats>;
  /** fetch aggregated fields from the table: "org_dashboard_stats" */
  org_dashboard_stats_aggregate: Org_Dashboard_Stats_Aggregate;
  /** fetch data from the table: "org_dashboard_stats" using primary key columns */
  org_dashboard_stats_by_pk?: Maybe<Org_Dashboard_Stats>;
  /** fetch data from the table in a streaming manner : "org_dashboard_stats" */
  org_dashboard_stats_stream: Array<Org_Dashboard_Stats>;
  /** fetch data from the table: "org_team_association" */
  org_team_association: Array<Org_Team_Association>;
  /** fetch aggregated fields from the table: "org_team_association" */
  org_team_association_aggregate: Org_Team_Association_Aggregate;
  /** fetch data from the table: "org_team_association" using primary key columns */
  org_team_association_by_pk?: Maybe<Org_Team_Association>;
  /** fetch data from the table in a streaming manner : "org_team_association" */
  org_team_association_stream: Array<Org_Team_Association>;
  /** fetch data from the table: "org_team_primary_crop" */
  org_team_primary_crop: Array<Org_Team_Primary_Crop>;
  /** fetch aggregated fields from the table: "org_team_primary_crop" */
  org_team_primary_crop_aggregate: Org_Team_Primary_Crop_Aggregate;
  /** fetch data from the table: "org_team_primary_crop" using primary key columns */
  org_team_primary_crop_by_pk?: Maybe<Org_Team_Primary_Crop>;
  /** fetch data from the table in a streaming manner : "org_team_primary_crop" */
  org_team_primary_crop_stream: Array<Org_Team_Primary_Crop>;
  /** fetch data from the table: "org_team_user_bank_association" */
  org_team_user_bank_association: Array<Org_Team_User_Bank_Association>;
  /** fetch aggregated fields from the table: "org_team_user_bank_association" */
  org_team_user_bank_association_aggregate: Org_Team_User_Bank_Association_Aggregate;
  /** fetch data from the table: "org_team_user_bank_association" using primary key columns */
  org_team_user_bank_association_by_pk?: Maybe<Org_Team_User_Bank_Association>;
  /** fetch data from the table in a streaming manner : "org_team_user_bank_association" */
  org_team_user_bank_association_stream: Array<Org_Team_User_Bank_Association>;
  /** fetch data from the table: "org_team_user_crop" */
  org_team_user_crop: Array<Org_Team_User_Crop>;
  /** fetch aggregated fields from the table: "org_team_user_crop" */
  org_team_user_crop_aggregate: Org_Team_User_Crop_Aggregate;
  /** fetch data from the table: "org_team_user_crop" using primary key columns */
  org_team_user_crop_by_pk?: Maybe<Org_Team_User_Crop>;
  /** fetch data from the table in a streaming manner : "org_team_user_crop" */
  org_team_user_crop_stream: Array<Org_Team_User_Crop>;
  /** fetch data from the table: "org_team_user_document_association" */
  org_team_user_document_association: Array<Org_Team_User_Document_Association>;
  /** fetch aggregated fields from the table: "org_team_user_document_association" */
  org_team_user_document_association_aggregate: Org_Team_User_Document_Association_Aggregate;
  /** fetch data from the table: "org_team_user_document_association" using primary key columns */
  org_team_user_document_association_by_pk?: Maybe<Org_Team_User_Document_Association>;
  /** fetch data from the table in a streaming manner : "org_team_user_document_association" */
  org_team_user_document_association_stream: Array<Org_Team_User_Document_Association>;
  /** fetch data from the table: "org_user_association" */
  org_user_association: Array<Org_User_Association>;
  /** fetch aggregated fields from the table: "org_user_association" */
  org_user_association_aggregate: Org_User_Association_Aggregate;
  /** fetch data from the table: "org_user_association" using primary key columns */
  org_user_association_by_pk?: Maybe<Org_User_Association>;
  /** fetch data from the table in a streaming manner : "org_user_association" */
  org_user_association_stream: Array<Org_User_Association>;
  /** fetch data from the table: "org_user_group_mandatory_document" */
  org_user_group_mandatory_document: Array<Org_User_Group_Mandatory_Document>;
  /** fetch aggregated fields from the table: "org_user_group_mandatory_document" */
  org_user_group_mandatory_document_aggregate: Org_User_Group_Mandatory_Document_Aggregate;
  /** fetch data from the table: "org_user_group_mandatory_document" using primary key columns */
  org_user_group_mandatory_document_by_pk?: Maybe<Org_User_Group_Mandatory_Document>;
  /** fetch data from the table in a streaming manner : "org_user_group_mandatory_document" */
  org_user_group_mandatory_document_stream: Array<Org_User_Group_Mandatory_Document>;
  /** fetch data from the table: "org_user_group_status_snapshot" */
  org_user_group_status_snapshot: Array<Org_User_Group_Status_Snapshot>;
  /** fetch aggregated fields from the table: "org_user_group_status_snapshot" */
  org_user_group_status_snapshot_aggregate: Org_User_Group_Status_Snapshot_Aggregate;
  /** fetch data from the table: "org_user_group_status_snapshot" using primary key columns */
  org_user_group_status_snapshot_by_pk?: Maybe<Org_User_Group_Status_Snapshot>;
  /** fetch data from the table in a streaming manner : "org_user_group_status_snapshot" */
  org_user_group_status_snapshot_stream: Array<Org_User_Group_Status_Snapshot>;
  /** fetch data from the table: "org_user_primary_crop" */
  org_user_primary_crop: Array<Org_User_Primary_Crop>;
  /** fetch aggregated fields from the table: "org_user_primary_crop" */
  org_user_primary_crop_aggregate: Org_User_Primary_Crop_Aggregate;
  /** fetch data from the table: "org_user_primary_crop" using primary key columns */
  org_user_primary_crop_by_pk?: Maybe<Org_User_Primary_Crop>;
  /** fetch data from the table in a streaming manner : "org_user_primary_crop" */
  org_user_primary_crop_stream: Array<Org_User_Primary_Crop>;
  /** fetch data from the table: "organisation" */
  organisation: Array<Organisation>;
  /** fetch aggregated fields from the table: "organisation" */
  organisation_aggregate: Organisation_Aggregate;
  /** fetch data from the table: "organisation" using primary key columns */
  organisation_by_pk?: Maybe<Organisation>;
  /** fetch data from the table: "organisation_commodity_variety_config" */
  organisation_commodity_variety_config: Array<Organisation_Commodity_Variety_Config>;
  /** fetch aggregated fields from the table: "organisation_commodity_variety_config" */
  organisation_commodity_variety_config_aggregate: Organisation_Commodity_Variety_Config_Aggregate;
  /** fetch data from the table: "organisation_commodity_variety_config" using primary key columns */
  organisation_commodity_variety_config_by_pk?: Maybe<Organisation_Commodity_Variety_Config>;
  /** fetch data from the table in a streaming manner : "organisation_commodity_variety_config" */
  organisation_commodity_variety_config_stream: Array<Organisation_Commodity_Variety_Config>;
  /** fetch data from the table: "organisation_commodity_variety_config_taxes" */
  organisation_commodity_variety_config_taxes: Array<Organisation_Commodity_Variety_Config_Taxes>;
  /** fetch aggregated fields from the table: "organisation_commodity_variety_config_taxes" */
  organisation_commodity_variety_config_taxes_aggregate: Organisation_Commodity_Variety_Config_Taxes_Aggregate;
  /** fetch data from the table: "organisation_commodity_variety_config_taxes" using primary key columns */
  organisation_commodity_variety_config_taxes_by_pk?: Maybe<Organisation_Commodity_Variety_Config_Taxes>;
  /** fetch data from the table in a streaming manner : "organisation_commodity_variety_config_taxes" */
  organisation_commodity_variety_config_taxes_stream: Array<Organisation_Commodity_Variety_Config_Taxes>;
  /** fetch data from the table: "organisation_crop" */
  organisation_crop: Array<Organisation_Crop>;
  /** fetch aggregated fields from the table: "organisation_crop" */
  organisation_crop_aggregate: Organisation_Crop_Aggregate;
  /** fetch data from the table: "organisation_crop" using primary key columns */
  organisation_crop_by_pk?: Maybe<Organisation_Crop>;
  /** fetch data from the table in a streaming manner : "organisation_crop" */
  organisation_crop_stream: Array<Organisation_Crop>;
  /** fetch data from the table: "organisation_document_kind" */
  organisation_document_kind: Array<Organisation_Document_Kind>;
  /** fetch aggregated fields from the table: "organisation_document_kind" */
  organisation_document_kind_aggregate: Organisation_Document_Kind_Aggregate;
  /** fetch data from the table: "organisation_document_kind" using primary key columns */
  organisation_document_kind_by_pk?: Maybe<Organisation_Document_Kind>;
  /** fetch data from the table in a streaming manner : "organisation_document_kind" */
  organisation_document_kind_stream: Array<Organisation_Document_Kind>;
  /** fetch data from the table: "organisation_preferences" */
  organisation_preferences: Array<Organisation_Preferences>;
  /** fetch aggregated fields from the table: "organisation_preferences" */
  organisation_preferences_aggregate: Organisation_Preferences_Aggregate;
  /** fetch data from the table: "organisation_preferences" using primary key columns */
  organisation_preferences_by_pk?: Maybe<Organisation_Preferences>;
  /** fetch data from the table in a streaming manner : "organisation_preferences" */
  organisation_preferences_stream: Array<Organisation_Preferences>;
  /** fetch data from the table: "organisation_season" */
  organisation_season: Array<Organisation_Season>;
  /** fetch aggregated fields from the table: "organisation_season" */
  organisation_season_aggregate: Organisation_Season_Aggregate;
  /** fetch data from the table: "organisation_season" using primary key columns */
  organisation_season_by_pk?: Maybe<Organisation_Season>;
  /** fetch data from the table in a streaming manner : "organisation_season" */
  organisation_season_stream: Array<Organisation_Season>;
  /** fetch data from the table in a streaming manner : "organisation" */
  organisation_stream: Array<Organisation>;
  /** fetch data from the table: "over_draft" */
  over_draft: Array<Over_Draft>;
  /** fetch aggregated fields from the table: "over_draft" */
  over_draft_aggregate: Over_Draft_Aggregate;
  /** fetch data from the table: "over_draft" using primary key columns */
  over_draft_by_pk?: Maybe<Over_Draft>;
  /** fetch data from the table: "over_draft_cw" */
  over_draft_cw: Array<Over_Draft_Cw>;
  /** fetch aggregated fields from the table: "over_draft_cw" */
  over_draft_cw_aggregate: Over_Draft_Cw_Aggregate;
  /** fetch data from the table: "over_draft_cw" using primary key columns */
  over_draft_cw_by_pk?: Maybe<Over_Draft_Cw>;
  /** fetch data from the table in a streaming manner : "over_draft_cw" */
  over_draft_cw_stream: Array<Over_Draft_Cw>;
  /** fetch data from the table: "over_draft_log" */
  over_draft_log: Array<Over_Draft_Log>;
  /** fetch aggregated fields from the table: "over_draft_log" */
  over_draft_log_aggregate: Over_Draft_Log_Aggregate;
  /** fetch data from the table: "over_draft_log" using primary key columns */
  over_draft_log_by_pk?: Maybe<Over_Draft_Log>;
  /** fetch data from the table: "over_draft_log_cw" */
  over_draft_log_cw: Array<Over_Draft_Log_Cw>;
  /** fetch aggregated fields from the table: "over_draft_log_cw" */
  over_draft_log_cw_aggregate: Over_Draft_Log_Cw_Aggregate;
  /** fetch data from the table: "over_draft_log_cw" using primary key columns */
  over_draft_log_cw_by_pk?: Maybe<Over_Draft_Log_Cw>;
  /** fetch data from the table in a streaming manner : "over_draft_log_cw" */
  over_draft_log_cw_stream: Array<Over_Draft_Log_Cw>;
  /** fetch data from the table in a streaming manner : "over_draft_log" */
  over_draft_log_stream: Array<Over_Draft_Log>;
  /** fetch data from the table in a streaming manner : "over_draft" */
  over_draft_stream: Array<Over_Draft>;
  /** fetch data from the table: "over_due_approval" */
  over_due_approval: Array<Over_Due_Approval>;
  /** fetch aggregated fields from the table: "over_due_approval" */
  over_due_approval_aggregate: Over_Due_Approval_Aggregate;
  /** fetch data from the table: "over_due_approval" using primary key columns */
  over_due_approval_by_pk?: Maybe<Over_Due_Approval>;
  /** fetch data from the table: "over_due_approval_cw" */
  over_due_approval_cw: Array<Over_Due_Approval_Cw>;
  /** fetch aggregated fields from the table: "over_due_approval_cw" */
  over_due_approval_cw_aggregate: Over_Due_Approval_Cw_Aggregate;
  /** fetch data from the table: "over_due_approval_cw" using primary key columns */
  over_due_approval_cw_by_pk?: Maybe<Over_Due_Approval_Cw>;
  /** fetch data from the table in a streaming manner : "over_due_approval_cw" */
  over_due_approval_cw_stream: Array<Over_Due_Approval_Cw>;
  /** fetch data from the table: "over_due_approval_log" */
  over_due_approval_log: Array<Over_Due_Approval_Log>;
  /** fetch aggregated fields from the table: "over_due_approval_log" */
  over_due_approval_log_aggregate: Over_Due_Approval_Log_Aggregate;
  /** fetch data from the table: "over_due_approval_log" using primary key columns */
  over_due_approval_log_by_pk?: Maybe<Over_Due_Approval_Log>;
  /** fetch data from the table in a streaming manner : "over_due_approval_log" */
  over_due_approval_log_stream: Array<Over_Due_Approval_Log>;
  /** fetch data from the table in a streaming manner : "over_due_approval" */
  over_due_approval_stream: Array<Over_Due_Approval>;
  /** fetch data from the table: "packaging" */
  packaging: Array<Packaging>;
  /** fetch aggregated fields from the table: "packaging" */
  packaging_aggregate: Packaging_Aggregate;
  /** fetch data from the table: "packaging" using primary key columns */
  packaging_by_pk?: Maybe<Packaging>;
  /** fetch data from the table: "packaging_order" */
  packaging_order: Array<Packaging_Order>;
  /** fetch aggregated fields from the table: "packaging_order" */
  packaging_order_aggregate: Packaging_Order_Aggregate;
  /** fetch data from the table: "packaging_order" using primary key columns */
  packaging_order_by_pk?: Maybe<Packaging_Order>;
  /** fetch data from the table: "packaging_order_item" */
  packaging_order_item: Array<Packaging_Order_Item>;
  /** fetch aggregated fields from the table: "packaging_order_item" */
  packaging_order_item_aggregate: Packaging_Order_Item_Aggregate;
  /** fetch data from the table: "packaging_order_item" using primary key columns */
  packaging_order_item_by_pk?: Maybe<Packaging_Order_Item>;
  /** fetch data from the table in a streaming manner : "packaging_order_item" */
  packaging_order_item_stream: Array<Packaging_Order_Item>;
  /** fetch data from the table in a streaming manner : "packaging_order" */
  packaging_order_stream: Array<Packaging_Order>;
  /** fetch data from the table in a streaming manner : "packaging" */
  packaging_stream: Array<Packaging>;
  /** fetch data from the table: "pallet_category" */
  pallet_category: Array<Pallet_Category>;
  /** fetch aggregated fields from the table: "pallet_category" */
  pallet_category_aggregate: Pallet_Category_Aggregate;
  /** fetch data from the table: "pallet_category" using primary key columns */
  pallet_category_by_pk?: Maybe<Pallet_Category>;
  /** fetch data from the table in a streaming manner : "pallet_category" */
  pallet_category_stream: Array<Pallet_Category>;
  /** fetch data from the table: "pallet_customer" */
  pallet_customer: Array<Pallet_Customer>;
  /** fetch aggregated fields from the table: "pallet_customer" */
  pallet_customer_aggregate: Pallet_Customer_Aggregate;
  /** fetch data from the table: "pallet_customer" using primary key columns */
  pallet_customer_by_pk?: Maybe<Pallet_Customer>;
  /** fetch data from the table in a streaming manner : "pallet_customer" */
  pallet_customer_stream: Array<Pallet_Customer>;
  /** fetch data from the table: "pallet_inspection" */
  pallet_inspection: Array<Pallet_Inspection>;
  /** fetch aggregated fields from the table: "pallet_inspection" */
  pallet_inspection_aggregate: Pallet_Inspection_Aggregate;
  /** fetch data from the table: "pallet_inspection_attachments" */
  pallet_inspection_attachments: Array<Pallet_Inspection_Attachments>;
  /** fetch aggregated fields from the table: "pallet_inspection_attachments" */
  pallet_inspection_attachments_aggregate: Pallet_Inspection_Attachments_Aggregate;
  /** fetch data from the table: "pallet_inspection_attachments" using primary key columns */
  pallet_inspection_attachments_by_pk?: Maybe<Pallet_Inspection_Attachments>;
  /** fetch data from the table in a streaming manner : "pallet_inspection_attachments" */
  pallet_inspection_attachments_stream: Array<Pallet_Inspection_Attachments>;
  /** fetch data from the table: "pallet_inspection" using primary key columns */
  pallet_inspection_by_pk?: Maybe<Pallet_Inspection>;
  /** fetch data from the table: "pallet_inspection_reports" */
  pallet_inspection_reports: Array<Pallet_Inspection_Reports>;
  /** fetch aggregated fields from the table: "pallet_inspection_reports" */
  pallet_inspection_reports_aggregate: Pallet_Inspection_Reports_Aggregate;
  /** fetch data from the table: "pallet_inspection_reports" using primary key columns */
  pallet_inspection_reports_by_pk?: Maybe<Pallet_Inspection_Reports>;
  /** fetch data from the table in a streaming manner : "pallet_inspection_reports" */
  pallet_inspection_reports_stream: Array<Pallet_Inspection_Reports>;
  /** fetch data from the table in a streaming manner : "pallet_inspection" */
  pallet_inspection_stream: Array<Pallet_Inspection>;
  /** fetch data from the table: "pallet_inspectionkind" */
  pallet_inspectionkind: Array<Pallet_Inspectionkind>;
  /** fetch aggregated fields from the table: "pallet_inspectionkind" */
  pallet_inspectionkind_aggregate: Pallet_Inspectionkind_Aggregate;
  /** fetch data from the table: "pallet_inspectionkind" using primary key columns */
  pallet_inspectionkind_by_pk?: Maybe<Pallet_Inspectionkind>;
  /** fetch data from the table in a streaming manner : "pallet_inspectionkind" */
  pallet_inspectionkind_stream: Array<Pallet_Inspectionkind>;
  /** fetch data from the table: "pallet_inspectionobservation" */
  pallet_inspectionobservation: Array<Pallet_Inspectionobservation>;
  /** fetch aggregated fields from the table: "pallet_inspectionobservation" */
  pallet_inspectionobservation_aggregate: Pallet_Inspectionobservation_Aggregate;
  /** fetch data from the table: "pallet_inspectionobservation_attachments" */
  pallet_inspectionobservation_attachments: Array<Pallet_Inspectionobservation_Attachments>;
  /** fetch aggregated fields from the table: "pallet_inspectionobservation_attachments" */
  pallet_inspectionobservation_attachments_aggregate: Pallet_Inspectionobservation_Attachments_Aggregate;
  /** fetch data from the table: "pallet_inspectionobservation_attachments" using primary key columns */
  pallet_inspectionobservation_attachments_by_pk?: Maybe<Pallet_Inspectionobservation_Attachments>;
  /** fetch data from the table in a streaming manner : "pallet_inspectionobservation_attachments" */
  pallet_inspectionobservation_attachments_stream: Array<Pallet_Inspectionobservation_Attachments>;
  /** fetch data from the table: "pallet_inspectionobservation" using primary key columns */
  pallet_inspectionobservation_by_pk?: Maybe<Pallet_Inspectionobservation>;
  /** fetch data from the table in a streaming manner : "pallet_inspectionobservation" */
  pallet_inspectionobservation_stream: Array<Pallet_Inspectionobservation>;
  /** fetch data from the table: "pallet_line" */
  pallet_line: Array<Pallet_Line>;
  /** fetch aggregated fields from the table: "pallet_line" */
  pallet_line_aggregate: Pallet_Line_Aggregate;
  /** fetch data from the table: "pallet_line" using primary key columns */
  pallet_line_by_pk?: Maybe<Pallet_Line>;
  /** fetch data from the table in a streaming manner : "pallet_line" */
  pallet_line_stream: Array<Pallet_Line>;
  /** fetch data from the table: "pallet_location" */
  pallet_location: Array<Pallet_Location>;
  /** fetch aggregated fields from the table: "pallet_location" */
  pallet_location_aggregate: Pallet_Location_Aggregate;
  /** fetch data from the table: "pallet_location" using primary key columns */
  pallet_location_by_pk?: Maybe<Pallet_Location>;
  /** fetch data from the table in a streaming manner : "pallet_location" */
  pallet_location_stream: Array<Pallet_Location>;
  /** fetch data from the table: "pallet_packaging" */
  pallet_packaging: Array<Pallet_Packaging>;
  /** fetch aggregated fields from the table: "pallet_packaging" */
  pallet_packaging_aggregate: Pallet_Packaging_Aggregate;
  /** fetch data from the table: "pallet_packaging" using primary key columns */
  pallet_packaging_by_pk?: Maybe<Pallet_Packaging>;
  /** fetch data from the table in a streaming manner : "pallet_packaging" */
  pallet_packaging_stream: Array<Pallet_Packaging>;
  /** fetch data from the table: "pallet_packagingkind" */
  pallet_packagingkind: Array<Pallet_Packagingkind>;
  /** fetch aggregated fields from the table: "pallet_packagingkind" */
  pallet_packagingkind_aggregate: Pallet_Packagingkind_Aggregate;
  /** fetch data from the table: "pallet_packagingkind" using primary key columns */
  pallet_packagingkind_by_pk?: Maybe<Pallet_Packagingkind>;
  /** fetch data from the table in a streaming manner : "pallet_packagingkind" */
  pallet_packagingkind_stream: Array<Pallet_Packagingkind>;
  /** fetch data from the table: "pallet_packing" */
  pallet_packing: Array<Pallet_Packing>;
  /** fetch aggregated fields from the table: "pallet_packing" */
  pallet_packing_aggregate: Pallet_Packing_Aggregate;
  /** fetch data from the table: "pallet_packing_attachments" */
  pallet_packing_attachments: Array<Pallet_Packing_Attachments>;
  /** fetch aggregated fields from the table: "pallet_packing_attachments" */
  pallet_packing_attachments_aggregate: Pallet_Packing_Attachments_Aggregate;
  /** fetch data from the table: "pallet_packing_attachments" using primary key columns */
  pallet_packing_attachments_by_pk?: Maybe<Pallet_Packing_Attachments>;
  /** fetch data from the table in a streaming manner : "pallet_packing_attachments" */
  pallet_packing_attachments_stream: Array<Pallet_Packing_Attachments>;
  /** fetch data from the table: "pallet_packing" using primary key columns */
  pallet_packing_by_pk?: Maybe<Pallet_Packing>;
  /** fetch data from the table in a streaming manner : "pallet_packing" */
  pallet_packing_stream: Array<Pallet_Packing>;
  /** fetch data from the table: "pallet_packing_weights" */
  pallet_packing_weights: Array<Pallet_Packing_Weights>;
  /** fetch aggregated fields from the table: "pallet_packing_weights" */
  pallet_packing_weights_aggregate: Pallet_Packing_Weights_Aggregate;
  /** fetch data from the table: "pallet_packing_weights" using primary key columns */
  pallet_packing_weights_by_pk?: Maybe<Pallet_Packing_Weights>;
  /** fetch data from the table in a streaming manner : "pallet_packing_weights" */
  pallet_packing_weights_stream: Array<Pallet_Packing_Weights>;
  /** fetch data from the table: "pallet_packingkind" */
  pallet_packingkind: Array<Pallet_Packingkind>;
  /** fetch aggregated fields from the table: "pallet_packingkind" */
  pallet_packingkind_aggregate: Pallet_Packingkind_Aggregate;
  /** fetch data from the table: "pallet_packingkind" using primary key columns */
  pallet_packingkind_by_pk?: Maybe<Pallet_Packingkind>;
  /** fetch data from the table in a streaming manner : "pallet_packingkind" */
  pallet_packingkind_stream: Array<Pallet_Packingkind>;
  /** fetch data from the table: "pallet_packingweight" */
  pallet_packingweight: Array<Pallet_Packingweight>;
  /** fetch aggregated fields from the table: "pallet_packingweight" */
  pallet_packingweight_aggregate: Pallet_Packingweight_Aggregate;
  /** fetch data from the table: "pallet_packingweight_attachments" */
  pallet_packingweight_attachments: Array<Pallet_Packingweight_Attachments>;
  /** fetch aggregated fields from the table: "pallet_packingweight_attachments" */
  pallet_packingweight_attachments_aggregate: Pallet_Packingweight_Attachments_Aggregate;
  /** fetch data from the table: "pallet_packingweight_attachments" using primary key columns */
  pallet_packingweight_attachments_by_pk?: Maybe<Pallet_Packingweight_Attachments>;
  /** fetch data from the table in a streaming manner : "pallet_packingweight_attachments" */
  pallet_packingweight_attachments_stream: Array<Pallet_Packingweight_Attachments>;
  /** fetch data from the table: "pallet_packingweight" using primary key columns */
  pallet_packingweight_by_pk?: Maybe<Pallet_Packingweight>;
  /** fetch data from the table in a streaming manner : "pallet_packingweight" */
  pallet_packingweight_stream: Array<Pallet_Packingweight>;
  /** fetch data from the table: "pallet_printingmatter" */
  pallet_printingmatter: Array<Pallet_Printingmatter>;
  /** fetch aggregated fields from the table: "pallet_printingmatter" */
  pallet_printingmatter_aggregate: Pallet_Printingmatter_Aggregate;
  /** fetch data from the table: "pallet_printingmatter" using primary key columns */
  pallet_printingmatter_by_pk?: Maybe<Pallet_Printingmatter>;
  /** fetch data from the table in a streaming manner : "pallet_printingmatter" */
  pallet_printingmatter_stream: Array<Pallet_Printingmatter>;
  /** fetch data from the table: "pallet_punnetcondition" */
  pallet_punnetcondition: Array<Pallet_Punnetcondition>;
  /** fetch aggregated fields from the table: "pallet_punnetcondition" */
  pallet_punnetcondition_aggregate: Pallet_Punnetcondition_Aggregate;
  /** fetch data from the table: "pallet_punnetcondition" using primary key columns */
  pallet_punnetcondition_by_pk?: Maybe<Pallet_Punnetcondition>;
  /** fetch data from the table in a streaming manner : "pallet_punnetcondition" */
  pallet_punnetcondition_stream: Array<Pallet_Punnetcondition>;
  /** fetch data from the table: "pallet_samplinglocation" */
  pallet_samplinglocation: Array<Pallet_Samplinglocation>;
  /** fetch aggregated fields from the table: "pallet_samplinglocation" */
  pallet_samplinglocation_aggregate: Pallet_Samplinglocation_Aggregate;
  /** fetch data from the table: "pallet_samplinglocation" using primary key columns */
  pallet_samplinglocation_by_pk?: Maybe<Pallet_Samplinglocation>;
  /** fetch data from the table in a streaming manner : "pallet_samplinglocation" */
  pallet_samplinglocation_stream: Array<Pallet_Samplinglocation>;
  /** fetch data from the table: "pallet_sku" */
  pallet_sku: Array<Pallet_Sku>;
  /** fetch aggregated fields from the table: "pallet_sku" */
  pallet_sku_aggregate: Pallet_Sku_Aggregate;
  /** fetch data from the table: "pallet_sku" using primary key columns */
  pallet_sku_by_pk?: Maybe<Pallet_Sku>;
  /** fetch data from the table in a streaming manner : "pallet_sku" */
  pallet_sku_stream: Array<Pallet_Sku>;
  /** fetch data from the table: "pallet_skutype" */
  pallet_skutype: Array<Pallet_Skutype>;
  /** fetch aggregated fields from the table: "pallet_skutype" */
  pallet_skutype_aggregate: Pallet_Skutype_Aggregate;
  /** fetch data from the table: "pallet_skutype" using primary key columns */
  pallet_skutype_by_pk?: Maybe<Pallet_Skutype>;
  /** fetch data from the table in a streaming manner : "pallet_skutype" */
  pallet_skutype_stream: Array<Pallet_Skutype>;
  /** fetch data from the table: "pallet_variety" */
  pallet_variety: Array<Pallet_Variety>;
  /** fetch aggregated fields from the table: "pallet_variety" */
  pallet_variety_aggregate: Pallet_Variety_Aggregate;
  /** fetch data from the table: "pallet_variety" using primary key columns */
  pallet_variety_by_pk?: Maybe<Pallet_Variety>;
  /** fetch data from the table in a streaming manner : "pallet_variety" */
  pallet_variety_stream: Array<Pallet_Variety>;
  /** fetch data from the table: "payment" */
  payment: Array<Payment>;
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate;
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>;
  /** fetch data from the table: "payment_detail" */
  payment_detail: Array<Payment_Detail>;
  /** fetch aggregated fields from the table: "payment_detail" */
  payment_detail_aggregate: Payment_Detail_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" */
  payment_detail_attachments: Array<Payment_Detail_Attachments>;
  /** fetch aggregated fields from the table: "payment_detail_attachments" */
  payment_detail_attachments_aggregate: Payment_Detail_Attachments_Aggregate;
  /** fetch data from the table: "payment_detail_attachments" using primary key columns */
  payment_detail_attachments_by_pk?: Maybe<Payment_Detail_Attachments>;
  /** fetch data from the table in a streaming manner : "payment_detail_attachments" */
  payment_detail_attachments_stream: Array<Payment_Detail_Attachments>;
  /** fetch data from the table: "payment_detail" using primary key columns */
  payment_detail_by_pk?: Maybe<Payment_Detail>;
  /** fetch data from the table in a streaming manner : "payment_detail" */
  payment_detail_stream: Array<Payment_Detail>;
  /** fetch data from the table: "payment_method" */
  payment_method: Array<Payment_Method>;
  /** fetch aggregated fields from the table: "payment_method" */
  payment_method_aggregate: Payment_Method_Aggregate;
  /** fetch data from the table: "payment_method" using primary key columns */
  payment_method_by_pk?: Maybe<Payment_Method>;
  /** fetch data from the table in a streaming manner : "payment_method" */
  payment_method_stream: Array<Payment_Method>;
  /** fetch data from the table in a streaming manner : "payment" */
  payment_stream: Array<Payment>;
  /** fetch data from the table: "plot" */
  plot: Array<Plot>;
  /** fetch aggregated fields from the table: "plot" */
  plot_aggregate: Plot_Aggregate;
  /** fetch data from the table: "plot" using primary key columns */
  plot_by_pk?: Maybe<Plot>;
  /** fetch data from the table: "plot_crop" */
  plot_crop: Array<Plot_Crop>;
  /** fetch data from the table: "plot_crop_agent" */
  plot_crop_agent: Array<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop_agent" */
  plot_crop_agent_aggregate: Plot_Crop_Agent_Aggregate;
  /** fetch data from the table: "plot_crop_agent" using primary key columns */
  plot_crop_agent_by_pk?: Maybe<Plot_Crop_Agent>;
  /** fetch data from the table in a streaming manner : "plot_crop_agent" */
  plot_crop_agent_stream: Array<Plot_Crop_Agent>;
  /** fetch aggregated fields from the table: "plot_crop" */
  plot_crop_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "plot_crop" using primary key columns */
  plot_crop_by_pk?: Maybe<Plot_Crop>;
  /** fetch data from the table: "plot_crop_cultivation_type" */
  plot_crop_cultivation_type: Array<Plot_Crop_Cultivation_Type>;
  /** fetch aggregated fields from the table: "plot_crop_cultivation_type" */
  plot_crop_cultivation_type_aggregate: Plot_Crop_Cultivation_Type_Aggregate;
  /** fetch data from the table: "plot_crop_cultivation_type" using primary key columns */
  plot_crop_cultivation_type_by_pk?: Maybe<Plot_Crop_Cultivation_Type>;
  /** fetch data from the table in a streaming manner : "plot_crop_cultivation_type" */
  plot_crop_cultivation_type_stream: Array<Plot_Crop_Cultivation_Type>;
  /** fetch data from the table: "plot_crop_historic_season" */
  plot_crop_historic_season: Array<Plot_Crop_Historic_Season>;
  /** fetch aggregated fields from the table: "plot_crop_historic_season" */
  plot_crop_historic_season_aggregate: Plot_Crop_Historic_Season_Aggregate;
  /** fetch data from the table: "plot_crop_historic_season" using primary key columns */
  plot_crop_historic_season_by_pk?: Maybe<Plot_Crop_Historic_Season>;
  /** fetch data from the table in a streaming manner : "plot_crop_historic_season" */
  plot_crop_historic_season_stream: Array<Plot_Crop_Historic_Season>;
  /** fetch data from the table: "plot_crop_milestone" */
  plot_crop_milestone: Array<Plot_Crop_Milestone>;
  /** fetch aggregated fields from the table: "plot_crop_milestone" */
  plot_crop_milestone_aggregate: Plot_Crop_Milestone_Aggregate;
  /** fetch data from the table: "plot_crop_milestone" using primary key columns */
  plot_crop_milestone_by_pk?: Maybe<Plot_Crop_Milestone>;
  /** fetch data from the table in a streaming manner : "plot_crop_milestone" */
  plot_crop_milestone_stream: Array<Plot_Crop_Milestone>;
  /** fetch data from the table: "plot_crop_network" */
  plot_crop_network: Array<Plot_Crop_Network>;
  /** fetch aggregated fields from the table: "plot_crop_network" */
  plot_crop_network_aggregate: Plot_Crop_Network_Aggregate;
  /** fetch data from the table: "plot_crop_network" using primary key columns */
  plot_crop_network_by_pk?: Maybe<Plot_Crop_Network>;
  /** fetch data from the table in a streaming manner : "plot_crop_network" */
  plot_crop_network_stream: Array<Plot_Crop_Network>;
  /** fetch data from the table: "plot_crop_rootstock" */
  plot_crop_rootstock: Array<Plot_Crop_Rootstock>;
  /** fetch aggregated fields from the table: "plot_crop_rootstock" */
  plot_crop_rootstock_aggregate: Plot_Crop_Rootstock_Aggregate;
  /** fetch data from the table: "plot_crop_rootstock" using primary key columns */
  plot_crop_rootstock_by_pk?: Maybe<Plot_Crop_Rootstock>;
  /** fetch data from the table in a streaming manner : "plot_crop_rootstock" */
  plot_crop_rootstock_stream: Array<Plot_Crop_Rootstock>;
  /** fetch data from the table: "plot_crop_status_history" */
  plot_crop_status_history: Array<Plot_Crop_Status_History>;
  /** fetch aggregated fields from the table: "plot_crop_status_history" */
  plot_crop_status_history_aggregate: Plot_Crop_Status_History_Aggregate;
  /** fetch data from the table: "plot_crop_status_history" using primary key columns */
  plot_crop_status_history_by_pk?: Maybe<Plot_Crop_Status_History>;
  /** fetch data from the table in a streaming manner : "plot_crop_status_history" */
  plot_crop_status_history_stream: Array<Plot_Crop_Status_History>;
  /** fetch data from the table in a streaming manner : "plot_crop" */
  plot_crop_stream: Array<Plot_Crop>;
  /** fetch data from the table: "plot_network" */
  plot_network: Array<Plot_Network>;
  /** fetch aggregated fields from the table: "plot_network" */
  plot_network_aggregate: Plot_Network_Aggregate;
  /** fetch data from the table: "plot_network" using primary key columns */
  plot_network_by_pk?: Maybe<Plot_Network>;
  /** fetch data from the table in a streaming manner : "plot_network" */
  plot_network_stream: Array<Plot_Network>;
  /** fetch data from the table: "plot_status" */
  plot_status: Array<Plot_Status>;
  /** fetch aggregated fields from the table: "plot_status" */
  plot_status_aggregate: Plot_Status_Aggregate;
  /** fetch data from the table: "plot_status" using primary key columns */
  plot_status_by_pk?: Maybe<Plot_Status>;
  /** fetch data from the table: "plot_status_config" */
  plot_status_config: Array<Plot_Status_Config>;
  /** fetch aggregated fields from the table: "plot_status_config" */
  plot_status_config_aggregate: Plot_Status_Config_Aggregate;
  /** fetch data from the table: "plot_status_config" using primary key columns */
  plot_status_config_by_pk?: Maybe<Plot_Status_Config>;
  /** fetch data from the table: "plot_status_config_required_qc_stages" */
  plot_status_config_required_qc_stages: Array<Plot_Status_Config_Required_Qc_Stages>;
  /** fetch aggregated fields from the table: "plot_status_config_required_qc_stages" */
  plot_status_config_required_qc_stages_aggregate: Plot_Status_Config_Required_Qc_Stages_Aggregate;
  /** fetch data from the table: "plot_status_config_required_qc_stages" using primary key columns */
  plot_status_config_required_qc_stages_by_pk?: Maybe<Plot_Status_Config_Required_Qc_Stages>;
  /** fetch data from the table in a streaming manner : "plot_status_config_required_qc_stages" */
  plot_status_config_required_qc_stages_stream: Array<Plot_Status_Config_Required_Qc_Stages>;
  /** fetch data from the table in a streaming manner : "plot_status_config" */
  plot_status_config_stream: Array<Plot_Status_Config>;
  /** fetch data from the table in a streaming manner : "plot_status" */
  plot_status_stream: Array<Plot_Status>;
  /** fetch data from the table in a streaming manner : "plot" */
  plot_stream: Array<Plot>;
  /** fetch data from the table: "primary_growth_stage" */
  primary_growth_stage: Array<Primary_Growth_Stage>;
  /** fetch aggregated fields from the table: "primary_growth_stage" */
  primary_growth_stage_aggregate: Primary_Growth_Stage_Aggregate;
  /** fetch data from the table: "primary_growth_stage" using primary key columns */
  primary_growth_stage_by_pk?: Maybe<Primary_Growth_Stage>;
  /** fetch data from the table in a streaming manner : "primary_growth_stage" */
  primary_growth_stage_stream: Array<Primary_Growth_Stage>;
  /** fetch data from the table: "production_trade" */
  production_trade: Array<Production_Trade>;
  /** fetch aggregated fields from the table: "production_trade" */
  production_trade_aggregate: Production_Trade_Aggregate;
  /** fetch data from the table: "production_trade" using primary key columns */
  production_trade_by_pk?: Maybe<Production_Trade>;
  /** fetch data from the table: "production_trade_item" */
  production_trade_item: Array<Production_Trade_Item>;
  /** fetch aggregated fields from the table: "production_trade_item" */
  production_trade_item_aggregate: Production_Trade_Item_Aggregate;
  /** fetch data from the table: "production_trade_item_attachments" */
  production_trade_item_attachments: Array<Production_Trade_Item_Attachments>;
  /** fetch aggregated fields from the table: "production_trade_item_attachments" */
  production_trade_item_attachments_aggregate: Production_Trade_Item_Attachments_Aggregate;
  /** fetch data from the table: "production_trade_item_attachments" using primary key columns */
  production_trade_item_attachments_by_pk?: Maybe<Production_Trade_Item_Attachments>;
  /** fetch data from the table in a streaming manner : "production_trade_item_attachments" */
  production_trade_item_attachments_stream: Array<Production_Trade_Item_Attachments>;
  /** fetch data from the table: "production_trade_item" using primary key columns */
  production_trade_item_by_pk?: Maybe<Production_Trade_Item>;
  /** fetch data from the table: "production_trade_item_storage_picked" */
  production_trade_item_storage_picked: Array<Production_Trade_Item_Storage_Picked>;
  /** fetch aggregated fields from the table: "production_trade_item_storage_picked" */
  production_trade_item_storage_picked_aggregate: Production_Trade_Item_Storage_Picked_Aggregate;
  /** fetch data from the table: "production_trade_item_storage_picked" using primary key columns */
  production_trade_item_storage_picked_by_pk?: Maybe<Production_Trade_Item_Storage_Picked>;
  /** fetch data from the table in a streaming manner : "production_trade_item_storage_picked" */
  production_trade_item_storage_picked_stream: Array<Production_Trade_Item_Storage_Picked>;
  /** fetch data from the table in a streaming manner : "production_trade_item" */
  production_trade_item_stream: Array<Production_Trade_Item>;
  /** fetch data from the table: "production_trade_order_trade_refs" */
  production_trade_order_trade_refs: Array<Production_Trade_Order_Trade_Refs>;
  /** fetch aggregated fields from the table: "production_trade_order_trade_refs" */
  production_trade_order_trade_refs_aggregate: Production_Trade_Order_Trade_Refs_Aggregate;
  /** fetch data from the table: "production_trade_order_trade_refs" using primary key columns */
  production_trade_order_trade_refs_by_pk?: Maybe<Production_Trade_Order_Trade_Refs>;
  /** fetch data from the table in a streaming manner : "production_trade_order_trade_refs" */
  production_trade_order_trade_refs_stream: Array<Production_Trade_Order_Trade_Refs>;
  /** fetch data from the table in a streaming manner : "production_trade" */
  production_trade_stream: Array<Production_Trade>;
  /** fetch data from the table: "projection_assessment" */
  projection_assessment: Array<Projection_Assessment>;
  /** fetch aggregated fields from the table: "projection_assessment" */
  projection_assessment_aggregate: Projection_Assessment_Aggregate;
  /** fetch data from the table: "projection_assessment" using primary key columns */
  projection_assessment_by_pk?: Maybe<Projection_Assessment>;
  /** An array relationship */
  projection_assessment_cw: Array<Projection_Assessment_Cw>;
  /** An aggregate relationship */
  projection_assessment_cw_aggregate: Projection_Assessment_Cw_Aggregate;
  /** fetch data from the table: "projection_assessment_cw" using primary key columns */
  projection_assessment_cw_by_pk?: Maybe<Projection_Assessment_Cw>;
  /** fetch data from the table in a streaming manner : "projection_assessment_cw" */
  projection_assessment_cw_stream: Array<Projection_Assessment_Cw>;
  /** fetch data from the table in a streaming manner : "projection_assessment" */
  projection_assessment_stream: Array<Projection_Assessment>;
  /** fetch data from the table: "quality_parameter" */
  quality_parameter: Array<Quality_Parameter>;
  /** fetch aggregated fields from the table: "quality_parameter" */
  quality_parameter_aggregate: Quality_Parameter_Aggregate;
  /** fetch data from the table: "quality_parameter" using primary key columns */
  quality_parameter_by_pk?: Maybe<Quality_Parameter>;
  /** fetch data from the table: "quality_parameter_category" */
  quality_parameter_category: Array<Quality_Parameter_Category>;
  /** fetch aggregated fields from the table: "quality_parameter_category" */
  quality_parameter_category_aggregate: Quality_Parameter_Category_Aggregate;
  /** fetch data from the table: "quality_parameter_category" using primary key columns */
  quality_parameter_category_by_pk?: Maybe<Quality_Parameter_Category>;
  /** fetch data from the table in a streaming manner : "quality_parameter_category" */
  quality_parameter_category_stream: Array<Quality_Parameter_Category>;
  /** fetch data from the table in a streaming manner : "quality_parameter" */
  quality_parameter_stream: Array<Quality_Parameter>;
  /** fetch data from the table: "quality_stage" */
  quality_stage: Array<Quality_Stage>;
  /** fetch aggregated fields from the table: "quality_stage" */
  quality_stage_aggregate: Quality_Stage_Aggregate;
  /** fetch data from the table: "quality_stage_allowed_template_category" */
  quality_stage_allowed_template_category: Array<Quality_Stage_Allowed_Template_Category>;
  /** fetch aggregated fields from the table: "quality_stage_allowed_template_category" */
  quality_stage_allowed_template_category_aggregate: Quality_Stage_Allowed_Template_Category_Aggregate;
  /** fetch data from the table: "quality_stage_allowed_template_category" using primary key columns */
  quality_stage_allowed_template_category_by_pk?: Maybe<Quality_Stage_Allowed_Template_Category>;
  /** fetch data from the table in a streaming manner : "quality_stage_allowed_template_category" */
  quality_stage_allowed_template_category_stream: Array<Quality_Stage_Allowed_Template_Category>;
  /** fetch data from the table: "quality_stage" using primary key columns */
  quality_stage_by_pk?: Maybe<Quality_Stage>;
  /** fetch data from the table in a streaming manner : "quality_stage" */
  quality_stage_stream: Array<Quality_Stage>;
  /** fetch data from the table: "receipt" */
  receipt: Array<Receipt>;
  /** fetch aggregated fields from the table: "receipt" */
  receipt_aggregate: Receipt_Aggregate;
  /** fetch data from the table: "receipt" using primary key columns */
  receipt_by_pk?: Maybe<Receipt>;
  /** fetch data from the table: "receipt_seller_gst_attachments" */
  receipt_seller_gst_attachments: Array<Receipt_Seller_Gst_Attachments>;
  /** fetch aggregated fields from the table: "receipt_seller_gst_attachments" */
  receipt_seller_gst_attachments_aggregate: Receipt_Seller_Gst_Attachments_Aggregate;
  /** fetch data from the table: "receipt_seller_gst_attachments" using primary key columns */
  receipt_seller_gst_attachments_by_pk?: Maybe<Receipt_Seller_Gst_Attachments>;
  /** fetch data from the table in a streaming manner : "receipt_seller_gst_attachments" */
  receipt_seller_gst_attachments_stream: Array<Receipt_Seller_Gst_Attachments>;
  /** fetch data from the table in a streaming manner : "receipt" */
  receipt_stream: Array<Receipt>;
  /** fetch data from the table: "region" */
  region: Array<Region>;
  /** fetch aggregated fields from the table: "region" */
  region_aggregate: Region_Aggregate;
  /** fetch data from the table: "region" using primary key columns */
  region_by_pk?: Maybe<Region>;
  /** fetch data from the table: "region_group" */
  region_group: Array<Region_Group>;
  /** fetch aggregated fields from the table: "region_group" */
  region_group_aggregate: Region_Group_Aggregate;
  /** fetch data from the table: "region_group" using primary key columns */
  region_group_by_pk?: Maybe<Region_Group>;
  /** fetch data from the table in a streaming manner : "region_group" */
  region_group_stream: Array<Region_Group>;
  /** fetch data from the table in a streaming manner : "region" */
  region_stream: Array<Region>;
  /** fetch data from the table: "request" */
  request: Array<Request>;
  /** fetch aggregated fields from the table: "request" */
  request_aggregate: Request_Aggregate;
  /** fetch data from the table: "request" using primary key columns */
  request_by_pk?: Maybe<Request>;
  /** fetch data from the table: "request_category" */
  request_category: Array<Request_Category>;
  /** fetch aggregated fields from the table: "request_category" */
  request_category_aggregate: Request_Category_Aggregate;
  /** fetch data from the table: "request_category" using primary key columns */
  request_category_by_pk?: Maybe<Request_Category>;
  /** fetch data from the table in a streaming manner : "request_category" */
  request_category_stream: Array<Request_Category>;
  /** An array relationship */
  request_parameters: Array<Request_Parameters>;
  /** An aggregate relationship */
  request_parameters_aggregate: Request_Parameters_Aggregate;
  /** fetch data from the table: "request_parameters" using primary key columns */
  request_parameters_by_pk?: Maybe<Request_Parameters>;
  /** fetch data from the table in a streaming manner : "request_parameters" */
  request_parameters_stream: Array<Request_Parameters>;
  /** fetch data from the table: "request_secondary_locations" */
  request_secondary_locations: Array<Request_Secondary_Locations>;
  /** fetch aggregated fields from the table: "request_secondary_locations" */
  request_secondary_locations_aggregate: Request_Secondary_Locations_Aggregate;
  /** fetch data from the table: "request_secondary_locations" using primary key columns */
  request_secondary_locations_by_pk?: Maybe<Request_Secondary_Locations>;
  /** fetch data from the table in a streaming manner : "request_secondary_locations" */
  request_secondary_locations_stream: Array<Request_Secondary_Locations>;
  /** fetch data from the table in a streaming manner : "request" */
  request_stream: Array<Request>;
  /** fetch data from the table: "request_templates" */
  request_templates: Array<Request_Templates>;
  /** fetch aggregated fields from the table: "request_templates" */
  request_templates_aggregate: Request_Templates_Aggregate;
  /** fetch data from the table: "request_templates" using primary key columns */
  request_templates_by_pk?: Maybe<Request_Templates>;
  /** fetch data from the table in a streaming manner : "request_templates" */
  request_templates_stream: Array<Request_Templates>;
  /** fetch data from the table: "result" */
  result: Array<Result>;
  /** fetch aggregated fields from the table: "result" */
  result_aggregate: Result_Aggregate;
  /** fetch data from the table: "result" using primary key columns */
  result_by_pk?: Maybe<Result>;
  /** fetch data from the table: "result_comment" */
  result_comment: Array<Result_Comment>;
  /** fetch aggregated fields from the table: "result_comment" */
  result_comment_aggregate: Result_Comment_Aggregate;
  /** fetch data from the table: "result_comment" using primary key columns */
  result_comment_by_pk?: Maybe<Result_Comment>;
  /** fetch data from the table in a streaming manner : "result_comment" */
  result_comment_stream: Array<Result_Comment>;
  /** fetch data from the table: "result_evaluation" */
  result_evaluation: Array<Result_Evaluation>;
  /** fetch aggregated fields from the table: "result_evaluation" */
  result_evaluation_aggregate: Result_Evaluation_Aggregate;
  /** fetch data from the table: "result_evaluation" using primary key columns */
  result_evaluation_by_pk?: Maybe<Result_Evaluation>;
  /** fetch data from the table: "result_evaluation_evaluated_tags" */
  result_evaluation_evaluated_tags: Array<Result_Evaluation_Evaluated_Tags>;
  /** fetch aggregated fields from the table: "result_evaluation_evaluated_tags" */
  result_evaluation_evaluated_tags_aggregate: Result_Evaluation_Evaluated_Tags_Aggregate;
  /** fetch data from the table: "result_evaluation_evaluated_tags" using primary key columns */
  result_evaluation_evaluated_tags_by_pk?: Maybe<Result_Evaluation_Evaluated_Tags>;
  /** fetch data from the table in a streaming manner : "result_evaluation_evaluated_tags" */
  result_evaluation_evaluated_tags_stream: Array<Result_Evaluation_Evaluated_Tags>;
  /** fetch data from the table in a streaming manner : "result_evaluation" */
  result_evaluation_stream: Array<Result_Evaluation>;
  /** An array relationship */
  result_media: Array<Result_Media>;
  /** An aggregate relationship */
  result_media_aggregate: Result_Media_Aggregate;
  /** fetch data from the table: "result_media" using primary key columns */
  result_media_by_pk?: Maybe<Result_Media>;
  /** fetch data from the table in a streaming manner : "result_media" */
  result_media_stream: Array<Result_Media>;
  /** fetch data from the table: "result_observation" */
  result_observation: Array<Result_Observation>;
  /** fetch aggregated fields from the table: "result_observation" */
  result_observation_aggregate: Result_Observation_Aggregate;
  /** fetch data from the table: "result_observation_attachments" */
  result_observation_attachments: Array<Result_Observation_Attachments>;
  /** fetch aggregated fields from the table: "result_observation_attachments" */
  result_observation_attachments_aggregate: Result_Observation_Attachments_Aggregate;
  /** fetch data from the table: "result_observation_attachments" using primary key columns */
  result_observation_attachments_by_pk?: Maybe<Result_Observation_Attachments>;
  /** fetch data from the table in a streaming manner : "result_observation_attachments" */
  result_observation_attachments_stream: Array<Result_Observation_Attachments>;
  /** fetch data from the table: "result_observation" using primary key columns */
  result_observation_by_pk?: Maybe<Result_Observation>;
  /** fetch data from the table: "result_observation_evaluated_tags" */
  result_observation_evaluated_tags: Array<Result_Observation_Evaluated_Tags>;
  /** fetch aggregated fields from the table: "result_observation_evaluated_tags" */
  result_observation_evaluated_tags_aggregate: Result_Observation_Evaluated_Tags_Aggregate;
  /** fetch data from the table: "result_observation_evaluated_tags" using primary key columns */
  result_observation_evaluated_tags_by_pk?: Maybe<Result_Observation_Evaluated_Tags>;
  /** fetch data from the table in a streaming manner : "result_observation_evaluated_tags" */
  result_observation_evaluated_tags_stream: Array<Result_Observation_Evaluated_Tags>;
  /** fetch data from the table in a streaming manner : "result_observation" */
  result_observation_stream: Array<Result_Observation>;
  /** fetch data from the table in a streaming manner : "result" */
  result_stream: Array<Result>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table in a streaming manner : "role" */
  role_stream: Array<Role>;
  /** fetch data from the table: "rootstock" */
  rootstock: Array<Rootstock>;
  /** fetch aggregated fields from the table: "rootstock" */
  rootstock_aggregate: Rootstock_Aggregate;
  /** fetch data from the table: "rootstock" using primary key columns */
  rootstock_by_pk?: Maybe<Rootstock>;
  /** fetch data from the table in a streaming manner : "rootstock" */
  rootstock_stream: Array<Rootstock>;
  /** fetch data from the table: "sample" */
  sample: Array<Sample>;
  /** fetch aggregated fields from the table: "sample" */
  sample_aggregate: Sample_Aggregate;
  /** fetch data from the table: "sample" using primary key columns */
  sample_by_pk?: Maybe<Sample>;
  /** An array relationship */
  sample_media: Array<Sample_Media>;
  /** An aggregate relationship */
  sample_media_aggregate: Sample_Media_Aggregate;
  /** fetch data from the table: "sample_media" using primary key columns */
  sample_media_by_pk?: Maybe<Sample_Media>;
  /** fetch data from the table in a streaming manner : "sample_media" */
  sample_media_stream: Array<Sample_Media>;
  /** fetch data from the table: "sample_observation" */
  sample_observation: Array<Sample_Observation>;
  /** fetch aggregated fields from the table: "sample_observation" */
  sample_observation_aggregate: Sample_Observation_Aggregate;
  /** fetch data from the table: "sample_observation_attachments" */
  sample_observation_attachments: Array<Sample_Observation_Attachments>;
  /** fetch aggregated fields from the table: "sample_observation_attachments" */
  sample_observation_attachments_aggregate: Sample_Observation_Attachments_Aggregate;
  /** fetch data from the table: "sample_observation_attachments" using primary key columns */
  sample_observation_attachments_by_pk?: Maybe<Sample_Observation_Attachments>;
  /** fetch data from the table in a streaming manner : "sample_observation_attachments" */
  sample_observation_attachments_stream: Array<Sample_Observation_Attachments>;
  /** fetch data from the table: "sample_observation" using primary key columns */
  sample_observation_by_pk?: Maybe<Sample_Observation>;
  /** fetch data from the table in a streaming manner : "sample_observation" */
  sample_observation_stream: Array<Sample_Observation>;
  /** fetch data from the table in a streaming manner : "sample" */
  sample_stream: Array<Sample>;
  /** execute function "search_base_users" which returns "base_user" */
  search_base_users: Array<Base_User>;
  /** execute function "search_base_users" and query aggregates on result of table type "base_user" */
  search_base_users_aggregate: Base_User_Aggregate;
  /** execute function "search_businesses" which returns "business" */
  search_businesses: Array<Business>;
  /** execute function "search_businesses" and query aggregates on result of table type "business" */
  search_businesses_aggregate: Business_Aggregate;
  /** execute function "search_businesses_groups" which returns "business_group" */
  search_businesses_groups: Array<Business_Group>;
  /** execute function "search_businesses_groups" and query aggregates on result of table type "business_group" */
  search_businesses_groups_aggregate: Business_Group_Aggregate;
  /** execute function "search_mutual_groups" which returns "mutual_group" */
  search_mutual_groups: Array<Mutual_Group>;
  /** execute function "search_mutual_groups" and query aggregates on result of table type "mutual_group" */
  search_mutual_groups_aggregate: Mutual_Group_Aggregate;
  /** execute function "search_plot_crops" which returns "plot_crop" */
  search_plot_crops: Array<Plot_Crop>;
  /** execute function "search_plot_crops" and query aggregates on result of table type "plot_crop" */
  search_plot_crops_aggregate: Plot_Crop_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" */
  secondary_growth_stage: Array<Secondary_Growth_Stage>;
  /** fetch aggregated fields from the table: "secondary_growth_stage" */
  secondary_growth_stage_aggregate: Secondary_Growth_Stage_Aggregate;
  /** fetch data from the table: "secondary_growth_stage" using primary key columns */
  secondary_growth_stage_by_pk?: Maybe<Secondary_Growth_Stage>;
  /** fetch data from the table in a streaming manner : "secondary_growth_stage" */
  secondary_growth_stage_stream: Array<Secondary_Growth_Stage>;
  /** fetch data from the table: "setu_trade_address" */
  setu_trade_address: Array<Setu_Trade_Address>;
  /** fetch aggregated fields from the table: "setu_trade_address" */
  setu_trade_address_aggregate: Setu_Trade_Address_Aggregate;
  /** fetch data from the table: "setu_trade_address" using primary key columns */
  setu_trade_address_by_pk?: Maybe<Setu_Trade_Address>;
  /** fetch data from the table in a streaming manner : "setu_trade_address" */
  setu_trade_address_stream: Array<Setu_Trade_Address>;
  /** fetch data from the table: "shared_entity" */
  setu_trade_shared_entity: Array<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "shared_entity" using primary key columns */
  setu_trade_shared_entity_by_pk?: Maybe<Setu_Trade_Shared_Entity>;
  /** fetch data from the table in a streaming manner : "shared_entity" */
  setu_trade_shared_entity_stream: Array<Setu_Trade_Shared_Entity>;
  /** fetch data from the table: "media" */
  setutrade_media: Array<Setutrade_Media>;
  /** fetch aggregated fields from the table: "media" */
  setutrade_media_aggregate: Setutrade_Media_Aggregate;
  /** fetch data from the table: "media" using primary key columns */
  setutrade_media_by_pk?: Maybe<Setutrade_Media>;
  /** fetch data from the table in a streaming manner : "media" */
  setutrade_media_stream: Array<Setutrade_Media>;
  /** fetch data from the table: "trip" */
  setutrade_trip: Array<Setutrade_Trip>;
  /** fetch aggregated fields from the table: "trip" */
  setutrade_trip_aggregate: Setutrade_Trip_Aggregate;
  /** fetch data from the table: "trip" using primary key columns */
  setutrade_trip_by_pk?: Maybe<Setutrade_Trip>;
  /** fetch data from the table in a streaming manner : "trip" */
  setutrade_trip_stream: Array<Setutrade_Trip>;
  /** An array relationship */
  shareholder_applications: Array<Shareholder_Applications>;
  /** An aggregate relationship */
  shareholder_applications_aggregate: Shareholder_Applications_Aggregate;
  /** fetch data from the table: "shareholder_applications" using primary key columns */
  shareholder_applications_by_pk?: Maybe<Shareholder_Applications>;
  /** fetch data from the table in a streaming manner : "shareholder_applications" */
  shareholder_applications_stream: Array<Shareholder_Applications>;
  /** An array relationship */
  shareholders: Array<Shareholders>;
  /** An aggregate relationship */
  shareholders_aggregate: Shareholders_Aggregate;
  /** fetch data from the table: "shareholders" using primary key columns */
  shareholders_by_pk?: Maybe<Shareholders>;
  /** fetch data from the table in a streaming manner : "shareholders" */
  shareholders_stream: Array<Shareholders>;
  /** fetch data from the table: "si_unit" */
  si_unit: Array<Si_Unit>;
  /** fetch aggregated fields from the table: "si_unit" */
  si_unit_aggregate: Si_Unit_Aggregate;
  /** fetch data from the table: "si_unit" using primary key columns */
  si_unit_by_pk?: Maybe<Si_Unit>;
  /** fetch data from the table: "si_unit_measure" */
  si_unit_measure: Array<Si_Unit_Measure>;
  /** fetch aggregated fields from the table: "si_unit_measure" */
  si_unit_measure_aggregate: Si_Unit_Measure_Aggregate;
  /** fetch data from the table: "si_unit_measure" using primary key columns */
  si_unit_measure_by_pk?: Maybe<Si_Unit_Measure>;
  /** fetch data from the table in a streaming manner : "si_unit_measure" */
  si_unit_measure_stream: Array<Si_Unit_Measure>;
  /** fetch data from the table in a streaming manner : "si_unit" */
  si_unit_stream: Array<Si_Unit>;
  /** fetch data from the table: "sku" */
  sku: Array<Sku>;
  /** fetch aggregated fields from the table: "sku" */
  sku_aggregate: Sku_Aggregate;
  /** fetch data from the table: "sku" using primary key columns */
  sku_by_pk?: Maybe<Sku>;
  /** fetch data from the table: "sku_kind" */
  sku_kind: Array<Sku_Kind>;
  /** fetch aggregated fields from the table: "sku_kind" */
  sku_kind_aggregate: Sku_Kind_Aggregate;
  /** fetch data from the table: "sku_kind" using primary key columns */
  sku_kind_by_pk?: Maybe<Sku_Kind>;
  /** fetch data from the table in a streaming manner : "sku_kind" */
  sku_kind_stream: Array<Sku_Kind>;
  /** fetch data from the table in a streaming manner : "sku" */
  sku_stream: Array<Sku>;
  /** fetch data from the table: "soil" */
  soil: Array<Soil>;
  /** fetch aggregated fields from the table: "soil" */
  soil_aggregate: Soil_Aggregate;
  /** fetch data from the table: "soil" using primary key columns */
  soil_by_pk?: Maybe<Soil>;
  /** fetch data from the table in a streaming manner : "soil" */
  soil_stream: Array<Soil>;
  /** fetch data from the table: "stage_actions" */
  stage_actions: Array<Stage_Actions>;
  /** fetch aggregated fields from the table: "stage_actions" */
  stage_actions_aggregate: Stage_Actions_Aggregate;
  /** fetch data from the table: "stage_actions" using primary key columns */
  stage_actions_by_pk?: Maybe<Stage_Actions>;
  /** fetch data from the table in a streaming manner : "stage_actions" */
  stage_actions_stream: Array<Stage_Actions>;
  /** fetch data from the table: "stage_logs" */
  stage_logs: Array<Stage_Logs>;
  /** fetch aggregated fields from the table: "stage_logs" */
  stage_logs_aggregate: Stage_Logs_Aggregate;
  /** fetch data from the table: "stage_logs" using primary key columns */
  stage_logs_by_pk?: Maybe<Stage_Logs>;
  /** fetch data from the table in a streaming manner : "stage_logs" */
  stage_logs_stream: Array<Stage_Logs>;
  /** An array relationship */
  stages: Array<Stages>;
  /** An aggregate relationship */
  stages_aggregate: Stages_Aggregate;
  /** fetch data from the table: "stages" using primary key columns */
  stages_by_pk?: Maybe<Stages>;
  /** fetch data from the table in a streaming manner : "stages" */
  stages_stream: Array<Stages>;
  /** fetch data from the table: "stages_subscribers" */
  stages_subscribers: Array<Stages_Subscribers>;
  /** fetch aggregated fields from the table: "stages_subscribers" */
  stages_subscribers_aggregate: Stages_Subscribers_Aggregate;
  /** fetch data from the table: "stages_subscribers" using primary key columns */
  stages_subscribers_by_pk?: Maybe<Stages_Subscribers>;
  /** fetch data from the table in a streaming manner : "stages_subscribers" */
  stages_subscribers_stream: Array<Stages_Subscribers>;
  /** fetch data from the table: "state" */
  state: Array<State>;
  /** fetch aggregated fields from the table: "state" */
  state_aggregate: State_Aggregate;
  /** fetch data from the table: "state" using primary key columns */
  state_by_pk?: Maybe<State>;
  /** fetch data from the table in a streaming manner : "state" */
  state_stream: Array<State>;
  /** fetch data from the table: "storage_location" */
  storage_location: Array<Storage_Location>;
  /** fetch aggregated fields from the table: "storage_location" */
  storage_location_aggregate: Storage_Location_Aggregate;
  /** fetch data from the table: "storage_location_agreement" */
  storage_location_agreement: Array<Storage_Location_Agreement>;
  /** fetch aggregated fields from the table: "storage_location_agreement" */
  storage_location_agreement_aggregate: Storage_Location_Agreement_Aggregate;
  /** fetch data from the table: "storage_location_agreement_attachments" */
  storage_location_agreement_attachments: Array<Storage_Location_Agreement_Attachments>;
  /** fetch aggregated fields from the table: "storage_location_agreement_attachments" */
  storage_location_agreement_attachments_aggregate: Storage_Location_Agreement_Attachments_Aggregate;
  /** fetch data from the table: "storage_location_agreement_attachments" using primary key columns */
  storage_location_agreement_attachments_by_pk?: Maybe<Storage_Location_Agreement_Attachments>;
  /** fetch data from the table in a streaming manner : "storage_location_agreement_attachments" */
  storage_location_agreement_attachments_stream: Array<Storage_Location_Agreement_Attachments>;
  /** fetch data from the table: "storage_location_agreement" using primary key columns */
  storage_location_agreement_by_pk?: Maybe<Storage_Location_Agreement>;
  /** fetch data from the table in a streaming manner : "storage_location_agreement" */
  storage_location_agreement_stream: Array<Storage_Location_Agreement>;
  /** fetch data from the table: "storage_location" using primary key columns */
  storage_location_by_pk?: Maybe<Storage_Location>;
  /** fetch data from the table: "storage_location_kind" */
  storage_location_kind: Array<Storage_Location_Kind>;
  /** fetch aggregated fields from the table: "storage_location_kind" */
  storage_location_kind_aggregate: Storage_Location_Kind_Aggregate;
  /** fetch data from the table: "storage_location_kind" using primary key columns */
  storage_location_kind_by_pk?: Maybe<Storage_Location_Kind>;
  /** fetch data from the table in a streaming manner : "storage_location_kind" */
  storage_location_kind_stream: Array<Storage_Location_Kind>;
  /** fetch data from the table: "storage_location_pocs" */
  storage_location_pocs: Array<Storage_Location_Pocs>;
  /** fetch aggregated fields from the table: "storage_location_pocs" */
  storage_location_pocs_aggregate: Storage_Location_Pocs_Aggregate;
  /** fetch data from the table: "storage_location_pocs" using primary key columns */
  storage_location_pocs_by_pk?: Maybe<Storage_Location_Pocs>;
  /** fetch data from the table in a streaming manner : "storage_location_pocs" */
  storage_location_pocs_stream: Array<Storage_Location_Pocs>;
  /** fetch data from the table in a streaming manner : "storage_location" */
  storage_location_stream: Array<Storage_Location>;
  /** fetch data from the table: "storage_sub_location" */
  storage_sub_location: Array<Storage_Sub_Location>;
  /** fetch aggregated fields from the table: "storage_sub_location" */
  storage_sub_location_aggregate: Storage_Sub_Location_Aggregate;
  /** fetch data from the table: "storage_sub_location" using primary key columns */
  storage_sub_location_by_pk?: Maybe<Storage_Sub_Location>;
  /** fetch data from the table in a streaming manner : "storage_sub_location" */
  storage_sub_location_stream: Array<Storage_Sub_Location>;
  /** fetch data from the table: "survey_parameters" */
  survey_parameters: Array<Survey_Parameters>;
  /** fetch aggregated fields from the table: "survey_parameters" */
  survey_parameters_aggregate: Survey_Parameters_Aggregate;
  /** fetch data from the table: "survey_parameters" using primary key columns */
  survey_parameters_by_pk?: Maybe<Survey_Parameters>;
  /** fetch data from the table in a streaming manner : "survey_parameters" */
  survey_parameters_stream: Array<Survey_Parameters>;
  /** fetch data from the table: "survey_response_items" */
  survey_response_items: Array<Survey_Response_Items>;
  /** fetch aggregated fields from the table: "survey_response_items" */
  survey_response_items_aggregate: Survey_Response_Items_Aggregate;
  /** fetch data from the table: "survey_response_items" using primary key columns */
  survey_response_items_by_pk?: Maybe<Survey_Response_Items>;
  /** fetch data from the table in a streaming manner : "survey_response_items" */
  survey_response_items_stream: Array<Survey_Response_Items>;
  /** An array relationship */
  survey_responses: Array<Survey_Responses>;
  /** An aggregate relationship */
  survey_responses_aggregate: Survey_Responses_Aggregate;
  /** fetch data from the table: "survey_responses" using primary key columns */
  survey_responses_by_pk?: Maybe<Survey_Responses>;
  /** fetch data from the table in a streaming manner : "survey_responses" */
  survey_responses_stream: Array<Survey_Responses>;
  /** fetch data from the table: "survey_users" */
  survey_users: Array<Survey_Users>;
  /** fetch aggregated fields from the table: "survey_users" */
  survey_users_aggregate: Survey_Users_Aggregate;
  /** fetch data from the table: "survey_users" using primary key columns */
  survey_users_by_pk?: Maybe<Survey_Users>;
  /** fetch data from the table in a streaming manner : "survey_users" */
  survey_users_stream: Array<Survey_Users>;
  /** fetch data from the table: "survey_year" */
  survey_year: Array<Survey_Year>;
  /** fetch aggregated fields from the table: "survey_year" */
  survey_year_aggregate: Survey_Year_Aggregate;
  /** fetch data from the table: "survey_year" using primary key columns */
  survey_year_by_pk?: Maybe<Survey_Year>;
  /** fetch data from the table in a streaming manner : "survey_year" */
  survey_year_stream: Array<Survey_Year>;
  /** fetch data from the table: "surveys" */
  surveys: Array<Surveys>;
  /** fetch aggregated fields from the table: "surveys" */
  surveys_aggregate: Surveys_Aggregate;
  /** fetch data from the table: "surveys" using primary key columns */
  surveys_by_pk?: Maybe<Surveys>;
  /** fetch data from the table in a streaming manner : "surveys" */
  surveys_stream: Array<Surveys>;
  /** fetch data from the table: "template" */
  template: Array<Template>;
  /** fetch aggregated fields from the table: "template" */
  template_aggregate: Template_Aggregate;
  /** fetch data from the table: "template" using primary key columns */
  template_by_pk?: Maybe<Template>;
  /** fetch data from the table: "template_category" */
  template_category: Array<Template_Category>;
  /** fetch aggregated fields from the table: "template_category" */
  template_category_aggregate: Template_Category_Aggregate;
  /** fetch data from the table: "template_category_allowed_groups" */
  template_category_allowed_groups: Array<Template_Category_Allowed_Groups>;
  /** fetch aggregated fields from the table: "template_category_allowed_groups" */
  template_category_allowed_groups_aggregate: Template_Category_Allowed_Groups_Aggregate;
  /** fetch data from the table: "template_category_allowed_groups" using primary key columns */
  template_category_allowed_groups_by_pk?: Maybe<Template_Category_Allowed_Groups>;
  /** fetch data from the table in a streaming manner : "template_category_allowed_groups" */
  template_category_allowed_groups_stream: Array<Template_Category_Allowed_Groups>;
  /** fetch data from the table: "template_category_allowed_parameter_categories" */
  template_category_allowed_parameter_categories: Array<Template_Category_Allowed_Parameter_Categories>;
  /** fetch aggregated fields from the table: "template_category_allowed_parameter_categories" */
  template_category_allowed_parameter_categories_aggregate: Template_Category_Allowed_Parameter_Categories_Aggregate;
  /** fetch data from the table: "template_category_allowed_parameter_categories" using primary key columns */
  template_category_allowed_parameter_categories_by_pk?: Maybe<Template_Category_Allowed_Parameter_Categories>;
  /** fetch data from the table in a streaming manner : "template_category_allowed_parameter_categories" */
  template_category_allowed_parameter_categories_stream: Array<Template_Category_Allowed_Parameter_Categories>;
  /** fetch data from the table: "template_category" using primary key columns */
  template_category_by_pk?: Maybe<Template_Category>;
  /** fetch data from the table in a streaming manner : "template_category" */
  template_category_stream: Array<Template_Category>;
  /** fetch data from the table: "template_company" */
  template_company: Array<Template_Company>;
  /** fetch aggregated fields from the table: "template_company" */
  template_company_aggregate: Template_Company_Aggregate;
  /** fetch data from the table: "template_company" using primary key columns */
  template_company_by_pk?: Maybe<Template_Company>;
  /** fetch data from the table in a streaming manner : "template_company" */
  template_company_stream: Array<Template_Company>;
  /** fetch data from the table: "template_departments" */
  template_departments: Array<Template_Departments>;
  /** fetch aggregated fields from the table: "template_departments" */
  template_departments_aggregate: Template_Departments_Aggregate;
  /** fetch data from the table: "template_departments" using primary key columns */
  template_departments_by_pk?: Maybe<Template_Departments>;
  /** fetch data from the table in a streaming manner : "template_departments" */
  template_departments_stream: Array<Template_Departments>;
  /** fetch data from the table: "template_evaluation" */
  template_evaluation: Array<Template_Evaluation>;
  /** fetch aggregated fields from the table: "template_evaluation" */
  template_evaluation_aggregate: Template_Evaluation_Aggregate;
  /** fetch data from the table: "template_evaluation" using primary key columns */
  template_evaluation_by_pk?: Maybe<Template_Evaluation>;
  /** fetch data from the table: "template_evaluation_config" */
  template_evaluation_config: Array<Template_Evaluation_Config>;
  /** fetch aggregated fields from the table: "template_evaluation_config" */
  template_evaluation_config_aggregate: Template_Evaluation_Config_Aggregate;
  /** fetch data from the table: "template_evaluation_config" using primary key columns */
  template_evaluation_config_by_pk?: Maybe<Template_Evaluation_Config>;
  /** fetch data from the table in a streaming manner : "template_evaluation_config" */
  template_evaluation_config_stream: Array<Template_Evaluation_Config>;
  /** fetch data from the table in a streaming manner : "template_evaluation" */
  template_evaluation_stream: Array<Template_Evaluation>;
  /** fetch data from the table: "template_evaluation_templates" */
  template_evaluation_templates: Array<Template_Evaluation_Templates>;
  /** fetch aggregated fields from the table: "template_evaluation_templates" */
  template_evaluation_templates_aggregate: Template_Evaluation_Templates_Aggregate;
  /** fetch data from the table: "template_evaluation_templates" using primary key columns */
  template_evaluation_templates_by_pk?: Maybe<Template_Evaluation_Templates>;
  /** fetch data from the table in a streaming manner : "template_evaluation_templates" */
  template_evaluation_templates_stream: Array<Template_Evaluation_Templates>;
  /** fetch data from the table: "template_parameter" */
  template_parameter: Array<Template_Parameter>;
  /** fetch aggregated fields from the table: "template_parameter" */
  template_parameter_aggregate: Template_Parameter_Aggregate;
  /** fetch data from the table: "template_parameter" using primary key columns */
  template_parameter_by_pk?: Maybe<Template_Parameter>;
  /** fetch data from the table: "template_parameter_config" */
  template_parameter_config: Array<Template_Parameter_Config>;
  /** fetch aggregated fields from the table: "template_parameter_config" */
  template_parameter_config_aggregate: Template_Parameter_Config_Aggregate;
  /** fetch data from the table: "template_parameter_config" using primary key columns */
  template_parameter_config_by_pk?: Maybe<Template_Parameter_Config>;
  /** fetch data from the table in a streaming manner : "template_parameter_config" */
  template_parameter_config_stream: Array<Template_Parameter_Config>;
  /** fetch data from the table: "template_parameter_standard" */
  template_parameter_standard: Array<Template_Parameter_Standard>;
  /** fetch aggregated fields from the table: "template_parameter_standard" */
  template_parameter_standard_aggregate: Template_Parameter_Standard_Aggregate;
  /** fetch data from the table: "template_parameter_standard_attachments" */
  template_parameter_standard_attachments: Array<Template_Parameter_Standard_Attachments>;
  /** fetch aggregated fields from the table: "template_parameter_standard_attachments" */
  template_parameter_standard_attachments_aggregate: Template_Parameter_Standard_Attachments_Aggregate;
  /** fetch data from the table: "template_parameter_standard_attachments" using primary key columns */
  template_parameter_standard_attachments_by_pk?: Maybe<Template_Parameter_Standard_Attachments>;
  /** fetch data from the table in a streaming manner : "template_parameter_standard_attachments" */
  template_parameter_standard_attachments_stream: Array<Template_Parameter_Standard_Attachments>;
  /** fetch data from the table: "template_parameter_standard" using primary key columns */
  template_parameter_standard_by_pk?: Maybe<Template_Parameter_Standard>;
  /** fetch data from the table: "template_parameter_standard_group" */
  template_parameter_standard_group: Array<Template_Parameter_Standard_Group>;
  /** fetch aggregated fields from the table: "template_parameter_standard_group" */
  template_parameter_standard_group_aggregate: Template_Parameter_Standard_Group_Aggregate;
  /** fetch data from the table: "template_parameter_standard_group" using primary key columns */
  template_parameter_standard_group_by_pk?: Maybe<Template_Parameter_Standard_Group>;
  /** fetch data from the table in a streaming manner : "template_parameter_standard_group" */
  template_parameter_standard_group_stream: Array<Template_Parameter_Standard_Group>;
  /** fetch data from the table in a streaming manner : "template_parameter_standard" */
  template_parameter_standard_stream: Array<Template_Parameter_Standard>;
  /** fetch data from the table in a streaming manner : "template_parameter" */
  template_parameter_stream: Array<Template_Parameter>;
  /** fetch data from the table: "template_quality_stages" */
  template_quality_stages: Array<Template_Quality_Stages>;
  /** fetch aggregated fields from the table: "template_quality_stages" */
  template_quality_stages_aggregate: Template_Quality_Stages_Aggregate;
  /** fetch data from the table: "template_quality_stages" using primary key columns */
  template_quality_stages_by_pk?: Maybe<Template_Quality_Stages>;
  /** fetch data from the table in a streaming manner : "template_quality_stages" */
  template_quality_stages_stream: Array<Template_Quality_Stages>;
  /** fetch data from the table in a streaming manner : "template" */
  template_stream: Array<Template>;
  /** fetch data from the table: "trade" */
  trade: Array<Trade>;
  /** fetch data from the table: "action_log" */
  trade_action_log: Array<Trade_Action_Log>;
  /** fetch data from the table: "action_log" using primary key columns */
  trade_action_log_by_pk?: Maybe<Trade_Action_Log>;
  /** fetch data from the table in a streaming manner : "action_log" */
  trade_action_log_stream: Array<Trade_Action_Log>;
  /** fetch aggregated fields from the table: "trade" */
  trade_aggregate: Trade_Aggregate;
  /** fetch data from the table: "trade_assessment" */
  trade_assessment: Array<Trade_Assessment>;
  /** fetch aggregated fields from the table: "trade_assessment" */
  trade_assessment_aggregate: Trade_Assessment_Aggregate;
  /** fetch data from the table: "trade_assessment" using primary key columns */
  trade_assessment_by_pk?: Maybe<Trade_Assessment>;
  /** An array relationship */
  trade_assessment_cw: Array<Trade_Assessment_Cw>;
  /** An aggregate relationship */
  trade_assessment_cw_aggregate: Trade_Assessment_Cw_Aggregate;
  /** fetch data from the table: "trade_assessment_cw" using primary key columns */
  trade_assessment_cw_by_pk?: Maybe<Trade_Assessment_Cw>;
  /** fetch data from the table in a streaming manner : "trade_assessment_cw" */
  trade_assessment_cw_stream: Array<Trade_Assessment_Cw>;
  /** fetch data from the table in a streaming manner : "trade_assessment" */
  trade_assessment_stream: Array<Trade_Assessment>;
  /** fetch data from the table: "trade_attachments" */
  trade_attachments: Array<Trade_Attachments>;
  /** fetch aggregated fields from the table: "trade_attachments" */
  trade_attachments_aggregate: Trade_Attachments_Aggregate;
  /** fetch data from the table: "trade_attachments" using primary key columns */
  trade_attachments_by_pk?: Maybe<Trade_Attachments>;
  /** fetch data from the table in a streaming manner : "trade_attachments" */
  trade_attachments_stream: Array<Trade_Attachments>;
  /** fetch data from the table: "trade_buyer_gst_attachments" */
  trade_buyer_gst_attachments: Array<Trade_Buyer_Gst_Attachments>;
  /** fetch aggregated fields from the table: "trade_buyer_gst_attachments" */
  trade_buyer_gst_attachments_aggregate: Trade_Buyer_Gst_Attachments_Aggregate;
  /** fetch data from the table: "trade_buyer_gst_attachments" using primary key columns */
  trade_buyer_gst_attachments_by_pk?: Maybe<Trade_Buyer_Gst_Attachments>;
  /** fetch data from the table in a streaming manner : "trade_buyer_gst_attachments" */
  trade_buyer_gst_attachments_stream: Array<Trade_Buyer_Gst_Attachments>;
  /** fetch data from the table: "trade" using primary key columns */
  trade_by_pk?: Maybe<Trade>;
  /** fetch data from the table: "trade_expense_tax" */
  trade_expense_tax: Array<Trade_Expense_Tax>;
  /** fetch aggregated fields from the table: "trade_expense_tax" */
  trade_expense_tax_aggregate: Trade_Expense_Tax_Aggregate;
  /** fetch data from the table: "trade_expense_tax" using primary key columns */
  trade_expense_tax_by_pk?: Maybe<Trade_Expense_Tax>;
  /** fetch data from the table in a streaming manner : "trade_expense_tax" */
  trade_expense_tax_stream: Array<Trade_Expense_Tax>;
  /** fetch data from the table: "trade_issuancenoteitems" */
  trade_issuancenoteitems: Array<Trade_Issuancenoteitems>;
  /** fetch aggregated fields from the table: "trade_issuancenoteitems" */
  trade_issuancenoteitems_aggregate: Trade_Issuancenoteitems_Aggregate;
  /** fetch data from the table: "trade_issuancenoteitems_attachments" */
  trade_issuancenoteitems_attachments: Array<Trade_Issuancenoteitems_Attachments>;
  /** fetch aggregated fields from the table: "trade_issuancenoteitems_attachments" */
  trade_issuancenoteitems_attachments_aggregate: Trade_Issuancenoteitems_Attachments_Aggregate;
  /** fetch data from the table: "trade_issuancenoteitems_attachments" using primary key columns */
  trade_issuancenoteitems_attachments_by_pk?: Maybe<Trade_Issuancenoteitems_Attachments>;
  /** fetch data from the table in a streaming manner : "trade_issuancenoteitems_attachments" */
  trade_issuancenoteitems_attachments_stream: Array<Trade_Issuancenoteitems_Attachments>;
  /** fetch data from the table: "trade_issuancenoteitems" using primary key columns */
  trade_issuancenoteitems_by_pk?: Maybe<Trade_Issuancenoteitems>;
  /** fetch data from the table in a streaming manner : "trade_issuancenoteitems" */
  trade_issuancenoteitems_stream: Array<Trade_Issuancenoteitems>;
  /** fetch data from the table: "trade_item" */
  trade_item: Array<Trade_Item>;
  /** fetch aggregated fields from the table: "trade_item" */
  trade_item_aggregate: Trade_Item_Aggregate;
  /** fetch data from the table: "trade_item_attachments" */
  trade_item_attachments: Array<Trade_Item_Attachments>;
  /** fetch aggregated fields from the table: "trade_item_attachments" */
  trade_item_attachments_aggregate: Trade_Item_Attachments_Aggregate;
  /** fetch data from the table: "trade_item_attachments" using primary key columns */
  trade_item_attachments_by_pk?: Maybe<Trade_Item_Attachments>;
  /** fetch data from the table in a streaming manner : "trade_item_attachments" */
  trade_item_attachments_stream: Array<Trade_Item_Attachments>;
  /** fetch data from the table: "trade_item" using primary key columns */
  trade_item_by_pk?: Maybe<Trade_Item>;
  /** fetch data from the table in a streaming manner : "trade_item" */
  trade_item_stream: Array<Trade_Item>;
  /** fetch data from the table: "trade_seller_gst_attachments" */
  trade_seller_gst_attachments: Array<Trade_Seller_Gst_Attachments>;
  /** fetch aggregated fields from the table: "trade_seller_gst_attachments" */
  trade_seller_gst_attachments_aggregate: Trade_Seller_Gst_Attachments_Aggregate;
  /** fetch data from the table: "trade_seller_gst_attachments" using primary key columns */
  trade_seller_gst_attachments_by_pk?: Maybe<Trade_Seller_Gst_Attachments>;
  /** fetch data from the table in a streaming manner : "trade_seller_gst_attachments" */
  trade_seller_gst_attachments_stream: Array<Trade_Seller_Gst_Attachments>;
  /** fetch data from the table: "trade_status" */
  trade_status: Array<Trade_Status>;
  /** fetch aggregated fields from the table: "trade_status" */
  trade_status_aggregate: Trade_Status_Aggregate;
  /** fetch data from the table: "trade_status" using primary key columns */
  trade_status_by_pk?: Maybe<Trade_Status>;
  /** fetch data from the table: "trade_status_parents" */
  trade_status_parents: Array<Trade_Status_Parents>;
  /** fetch aggregated fields from the table: "trade_status_parents" */
  trade_status_parents_aggregate: Trade_Status_Parents_Aggregate;
  /** fetch data from the table: "trade_status_parents" using primary key columns */
  trade_status_parents_by_pk?: Maybe<Trade_Status_Parents>;
  /** fetch data from the table in a streaming manner : "trade_status_parents" */
  trade_status_parents_stream: Array<Trade_Status_Parents>;
  /** fetch data from the table in a streaming manner : "trade_status" */
  trade_status_stream: Array<Trade_Status>;
  /** fetch data from the table in a streaming manner : "trade" */
  trade_stream: Array<Trade>;
  /** fetch data from the table: "trade_taxes" */
  trade_taxes: Array<Trade_Taxes>;
  /** fetch aggregated fields from the table: "trade_taxes" */
  trade_taxes_aggregate: Trade_Taxes_Aggregate;
  /** fetch data from the table: "trade_taxes" using primary key columns */
  trade_taxes_by_pk?: Maybe<Trade_Taxes>;
  /** fetch data from the table in a streaming manner : "trade_taxes" */
  trade_taxes_stream: Array<Trade_Taxes>;
  /** fetch data from the table: "trade_tradestatusaccess" */
  trade_tradestatusaccess: Array<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_tradestatusaccess" using primary key columns */
  trade_tradestatusaccess_by_pk?: Maybe<Trade_Tradestatusaccess>;
  /** fetch data from the table in a streaming manner : "trade_tradestatusaccess" */
  trade_tradestatusaccess_stream: Array<Trade_Tradestatusaccess>;
  /** fetch data from the table: "trade_twiliomessages" */
  trade_twiliomessages: Array<Trade_Twiliomessages>;
  /** fetch data from the table: "trade_twiliomessages" using primary key columns */
  trade_twiliomessages_by_pk?: Maybe<Trade_Twiliomessages>;
  /** fetch data from the table in a streaming manner : "trade_twiliomessages" */
  trade_twiliomessages_stream: Array<Trade_Twiliomessages>;
  /** fetch data from the table: "transaction" */
  transaction: Array<Transaction>;
  /** fetch aggregated fields from the table: "transaction" */
  transaction_aggregate: Transaction_Aggregate;
  /** fetch data from the table: "transaction_attachments" */
  transaction_attachments: Array<Transaction_Attachments>;
  /** fetch aggregated fields from the table: "transaction_attachments" */
  transaction_attachments_aggregate: Transaction_Attachments_Aggregate;
  /** fetch data from the table: "transaction_attachments" using primary key columns */
  transaction_attachments_by_pk?: Maybe<Transaction_Attachments>;
  /** fetch data from the table in a streaming manner : "transaction_attachments" */
  transaction_attachments_stream: Array<Transaction_Attachments>;
  /** fetch data from the table: "transaction" using primary key columns */
  transaction_by_pk?: Maybe<Transaction>;
  /** fetch data from the table in a streaming manner : "transaction" */
  transaction_stream: Array<Transaction>;
  /** fetch data from the table: "transactions" */
  transactions: Array<Transactions>;
  /** fetch aggregated fields from the table: "transactions" */
  transactions_aggregate: Transactions_Aggregate;
  /** fetch data from the table: "transactions_attachments" */
  transactions_attachments: Array<Transactions_Attachments>;
  /** fetch aggregated fields from the table: "transactions_attachments" */
  transactions_attachments_aggregate: Transactions_Attachments_Aggregate;
  /** fetch data from the table: "transactions_attachments" using primary key columns */
  transactions_attachments_by_pk?: Maybe<Transactions_Attachments>;
  /** fetch data from the table in a streaming manner : "transactions_attachments" */
  transactions_attachments_stream: Array<Transactions_Attachments>;
  /** fetch data from the table: "transactions" using primary key columns */
  transactions_by_pk?: Maybe<Transactions>;
  /** fetch data from the table in a streaming manner : "transactions" */
  transactions_stream: Array<Transactions>;
  /** fetch data from the table: "transition" */
  transition: Array<Transition>;
  /** fetch data from the table: "transition_access" */
  transition_access: Array<Transition_Access>;
  /** fetch aggregated fields from the table: "transition_access" */
  transition_access_aggregate: Transition_Access_Aggregate;
  /** fetch data from the table: "transition_access" using primary key columns */
  transition_access_by_pk?: Maybe<Transition_Access>;
  /** fetch data from the table in a streaming manner : "transition_access" */
  transition_access_stream: Array<Transition_Access>;
  /** fetch aggregated fields from the table: "transition" */
  transition_aggregate: Transition_Aggregate;
  /** fetch data from the table: "transition" using primary key columns */
  transition_by_pk?: Maybe<Transition>;
  /** fetch data from the table: "transition_history" */
  transition_history: Array<Transition_History>;
  /** fetch aggregated fields from the table: "transition_history" */
  transition_history_aggregate: Transition_History_Aggregate;
  /** fetch data from the table: "transition_history_attribute" */
  transition_history_attribute: Array<Transition_History_Attribute>;
  /** fetch aggregated fields from the table: "transition_history_attribute" */
  transition_history_attribute_aggregate: Transition_History_Attribute_Aggregate;
  /** fetch data from the table: "transition_history_attribute" using primary key columns */
  transition_history_attribute_by_pk?: Maybe<Transition_History_Attribute>;
  /** fetch data from the table in a streaming manner : "transition_history_attribute" */
  transition_history_attribute_stream: Array<Transition_History_Attribute>;
  /** fetch data from the table: "transition_history" using primary key columns */
  transition_history_by_pk?: Maybe<Transition_History>;
  /** fetch data from the table in a streaming manner : "transition_history" */
  transition_history_stream: Array<Transition_History>;
  /** fetch data from the table in a streaming manner : "transition" */
  transition_stream: Array<Transition>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table: "unit_measure" */
  unit_measure: Array<Unit_Measure>;
  /** fetch aggregated fields from the table: "unit_measure" */
  unit_measure_aggregate: Unit_Measure_Aggregate;
  /** fetch data from the table: "unit_measure" using primary key columns */
  unit_measure_by_pk?: Maybe<Unit_Measure>;
  /** fetch data from the table in a streaming manner : "unit_measure" */
  unit_measure_stream: Array<Unit_Measure>;
  /** fetch data from the table in a streaming manner : "unit" */
  unit_stream: Array<Unit>;
  /** fetch data from the table: "unregistered_user" */
  unregistered_user: Array<Unregistered_User>;
  /** fetch aggregated fields from the table: "unregistered_user" */
  unregistered_user_aggregate: Unregistered_User_Aggregate;
  /** fetch data from the table: "unregistered_user" using primary key columns */
  unregistered_user_by_pk?: Maybe<Unregistered_User>;
  /** fetch data from the table in a streaming manner : "unregistered_user" */
  unregistered_user_stream: Array<Unregistered_User>;
  /** fetch data from the table: "variety_agreement" */
  variety_agreement: Array<Variety_Agreement>;
  /** fetch aggregated fields from the table: "variety_agreement" */
  variety_agreement_aggregate: Variety_Agreement_Aggregate;
  /** fetch data from the table: "variety_agreement_agreement_co_owners" */
  variety_agreement_agreement_co_owners: Array<Variety_Agreement_Agreement_Co_Owners>;
  /** fetch aggregated fields from the table: "variety_agreement_agreement_co_owners" */
  variety_agreement_agreement_co_owners_aggregate: Variety_Agreement_Agreement_Co_Owners_Aggregate;
  /** fetch data from the table: "variety_agreement_agreement_co_owners" using primary key columns */
  variety_agreement_agreement_co_owners_by_pk?: Maybe<Variety_Agreement_Agreement_Co_Owners>;
  /** fetch data from the table in a streaming manner : "variety_agreement_agreement_co_owners" */
  variety_agreement_agreement_co_owners_stream: Array<Variety_Agreement_Agreement_Co_Owners>;
  /** fetch data from the table: "variety_agreement" using primary key columns */
  variety_agreement_by_pk?: Maybe<Variety_Agreement>;
  /** fetch data from the table: "variety_agreement_guarantor_agreements" */
  variety_agreement_guarantor_agreements: Array<Variety_Agreement_Guarantor_Agreements>;
  /** fetch aggregated fields from the table: "variety_agreement_guarantor_agreements" */
  variety_agreement_guarantor_agreements_aggregate: Variety_Agreement_Guarantor_Agreements_Aggregate;
  /** fetch data from the table: "variety_agreement_guarantor_agreements" using primary key columns */
  variety_agreement_guarantor_agreements_by_pk?: Maybe<Variety_Agreement_Guarantor_Agreements>;
  /** fetch data from the table in a streaming manner : "variety_agreement_guarantor_agreements" */
  variety_agreement_guarantor_agreements_stream: Array<Variety_Agreement_Guarantor_Agreements>;
  /** fetch data from the table in a streaming manner : "variety_agreement" */
  variety_agreement_stream: Array<Variety_Agreement>;
  /** fetch data from the table: "variety_grade" */
  variety_grade: Array<Variety_Grade>;
  /** fetch aggregated fields from the table: "variety_grade" */
  variety_grade_aggregate: Variety_Grade_Aggregate;
  /** fetch data from the table: "variety_grade" using primary key columns */
  variety_grade_by_pk?: Maybe<Variety_Grade>;
  /** fetch data from the table: "variety_grade_photos" */
  variety_grade_photos: Array<Variety_Grade_Photos>;
  /** fetch aggregated fields from the table: "variety_grade_photos" */
  variety_grade_photos_aggregate: Variety_Grade_Photos_Aggregate;
  /** fetch data from the table: "variety_grade_photos" using primary key columns */
  variety_grade_photos_by_pk?: Maybe<Variety_Grade_Photos>;
  /** fetch data from the table in a streaming manner : "variety_grade_photos" */
  variety_grade_photos_stream: Array<Variety_Grade_Photos>;
  /** fetch data from the table in a streaming manner : "variety_grade" */
  variety_grade_stream: Array<Variety_Grade>;
  /** fetch data from the table: "variety_group" */
  variety_group: Array<Variety_Group>;
  /** fetch aggregated fields from the table: "variety_group" */
  variety_group_aggregate: Variety_Group_Aggregate;
  /** fetch data from the table: "variety_group" using primary key columns */
  variety_group_by_pk?: Maybe<Variety_Group>;
  /** fetch data from the table in a streaming manner : "variety_group" */
  variety_group_stream: Array<Variety_Group>;
  /** fetch data from the table: "vt_core_tax" */
  vt_core_tax: Array<Vt_Core_Tax>;
  /** fetch aggregated fields from the table: "vt_core_tax" */
  vt_core_tax_aggregate: Vt_Core_Tax_Aggregate;
  /** fetch data from the table: "vt_core_tax" using primary key columns */
  vt_core_tax_by_pk?: Maybe<Vt_Core_Tax>;
  /** fetch data from the table in a streaming manner : "vt_core_tax" */
  vt_core_tax_stream: Array<Vt_Core_Tax>;
  /** fetch data from the table: "weather_reference" */
  weather_reference: Array<Weather_Reference>;
  /** fetch aggregated fields from the table: "weather_reference" */
  weather_reference_aggregate: Weather_Reference_Aggregate;
  /** fetch data from the table: "weather_reference" using primary key columns */
  weather_reference_by_pk?: Maybe<Weather_Reference>;
  /** fetch data from the table in a streaming manner : "weather_reference" */
  weather_reference_stream: Array<Weather_Reference>;
  /** fetch data from the table: "workflow" */
  workflow: Array<Workflow>;
  /** fetch aggregated fields from the table: "workflow" */
  workflow_aggregate: Workflow_Aggregate;
  /** fetch data from the table: "workflow" using primary key columns */
  workflow_by_pk?: Maybe<Workflow>;
  /** fetch data from the table: "workflow_current_logs" */
  workflow_current_logs: Array<Workflow_Current_Logs>;
  /** fetch aggregated fields from the table: "workflow_current_logs" */
  workflow_current_logs_aggregate: Workflow_Current_Logs_Aggregate;
  /** fetch data from the table: "workflow_current_logs" using primary key columns */
  workflow_current_logs_by_pk?: Maybe<Workflow_Current_Logs>;
  /** fetch data from the table in a streaming manner : "workflow_current_logs" */
  workflow_current_logs_stream: Array<Workflow_Current_Logs>;
  /** fetch data from the table in a streaming manner : "workflow" */
  workflow_stream: Array<Workflow>;
  /** fetch data from the table: "workflows" */
  workflows: Array<Workflows>;
  /** fetch aggregated fields from the table: "workflows" */
  workflows_aggregate: Workflows_Aggregate;
  /** fetch data from the table: "workflows" using primary key columns */
  workflows_by_pk?: Maybe<Workflows>;
  /** fetch data from the table in a streaming manner : "workflows" */
  workflows_stream: Array<Workflows>;
};


export type Subscription_RootTransaction_ModeArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Mode_Order_By>>;
  where?: InputMaybe<Transaction_Mode_Bool_Exp>;
};


export type Subscription_RootTransaction_Mode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Mode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Mode_Order_By>>;
  where?: InputMaybe<Transaction_Mode_Bool_Exp>;
};


export type Subscription_RootTransaction_Mode_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTransaction_Mode_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transaction_Mode_Stream_Cursor_Input>>;
  where?: InputMaybe<Transaction_Mode_Bool_Exp>;
};


export type Subscription_RootAction_LogArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Subscription_RootAction_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Action_Log_Order_By>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Subscription_RootAction_Log_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAction_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Action_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Action_Log_Bool_Exp>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAdvance_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


export type Subscription_RootAdvance_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


export type Subscription_RootAdvance_Payment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootAdvance_Payment_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Parameters_Order_By>>;
  where?: InputMaybe<Advance_Payment_Parameters_Bool_Exp>;
};


export type Subscription_RootAdvance_Payment_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Parameters_Order_By>>;
  where?: InputMaybe<Advance_Payment_Parameters_Bool_Exp>;
};


export type Subscription_RootAdvance_Payment_Parameters_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootAdvance_Payment_Parameters_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Advance_Payment_Parameters_Stream_Cursor_Input>>;
  where?: InputMaybe<Advance_Payment_Parameters_Bool_Exp>;
};


export type Subscription_RootAdvance_Payment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Advance_Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


export type Subscription_RootAgentArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Subscription_RootAgent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Order_By>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Subscription_RootAgent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgent_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Subscription_RootAgent_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Company_Order_By>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Subscription_RootAgent_Company_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgent_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agent_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Company_Bool_Exp>;
};


export type Subscription_RootAgent_RoleArgs = {
  distinct_on?: InputMaybe<Array<Agent_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Role_Order_By>>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};


export type Subscription_RootAgent_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agent_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agent_Role_Order_By>>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};


export type Subscription_RootAgent_Role_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgent_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agent_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Role_Bool_Exp>;
};


export type Subscription_RootAgent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agent_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_OwnerArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Agreement_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Agreement_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Agreement_Invoices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Co_Owner_Agreement_Invoices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Invoices_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Agreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Agreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Agreement_Plots_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Co_Owner_Agreement_Plots_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Co_Owner_Agreement_Plots_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Co_Owner_Agreement_Plots_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Co_Owner_Legal_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Legal_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Co_Owner_Legal_Agreement_Order_By>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_Legal_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Co_Owner_Legal_Agreement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Co_Owner_Legal_Agreement_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Co_Owner_Legal_Agreement_Bool_Exp>;
};


export type Subscription_RootAgreement_Co_Owner_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Co_Owner_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
};


export type Subscription_RootAgreement_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_Agreement_Invoice_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_Agreement_Invoice_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Agreement_Invoice_Items_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_Agreement_Invoice_Items_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Invoice_Agreement_Invoice_Items_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Invoice_Agreement_Invoice_Items_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Invoice_ItemArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Item_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Item_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_Item_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Invoice_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Invoice_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Invoice_Item_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Invoice_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


export type Subscription_RootAgreement_Invoice_Transaction_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Invoice_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Invoice_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


export type Subscription_RootAgreement_PlotArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Plot_Order_By>>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};


export type Subscription_RootAgreement_Plot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Plot_Order_By>>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};


export type Subscription_RootAgreement_Plot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreement_Plot_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Plot_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Plot_Bool_Exp>;
};


export type Subscription_RootAgreement_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Bool_Exp>;
};


export type Subscription_RootAgreement_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Bool_Exp>;
};


export type Subscription_RootAgreement_Transaction_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
};


export type Subscription_RootAgreement_Transaction_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
};


export type Subscription_RootAgreement_Transaction_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootAgreement_Transaction_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Transaction_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Transaction_Attachments_Bool_Exp>;
};


export type Subscription_RootAgreement_Transaction_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootAgreement_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreement_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreement_Transaction_Bool_Exp>;
};


export type Subscription_RootAmendment_CaseArgs = {
  distinct_on?: InputMaybe<Array<Amendment_Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Amendment_Case_Order_By>>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};


export type Subscription_RootAmendment_Case_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Amendment_Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Amendment_Case_Order_By>>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};


export type Subscription_RootAmendment_Case_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAmendment_Case_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Amendment_Case_Stream_Cursor_Input>>;
  where?: InputMaybe<Amendment_Case_Bool_Exp>;
};


export type Subscription_RootAuth_GroupArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Order_By>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_Group_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Group_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Group_Permissions_Order_By>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_Group_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Group_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Permissions_Bool_Exp>;
};


export type Subscription_RootAuth_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Group_Bool_Exp>;
};


export type Subscription_RootAuth_PermissionArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Subscription_RootAuth_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Auth_Permission_Order_By>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Subscription_RootAuth_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuth_Permission_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Auth_Permission_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Permission_Bool_Exp>;
};


export type Subscription_RootBase_UserArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootBase_User_Address_BookArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Subscription_RootBase_User_Address_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Address_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Address_Book_Order_By>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Subscription_RootBase_User_Address_Book_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Address_Book_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Address_Book_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Address_Book_Bool_Exp>;
};


export type Subscription_RootBase_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootBase_User_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Subscription_RootBase_User_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Companies_Order_By>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Subscription_RootBase_User_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Companies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Companies_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Companies_Bool_Exp>;
};


export type Subscription_RootBase_User_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Subscription_RootBase_User_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Departments_Order_By>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Subscription_RootBase_User_Departments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Departments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Departments_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Departments_Bool_Exp>;
};


export type Subscription_RootBase_User_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Subscription_RootBase_User_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Groups_Order_By>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Subscription_RootBase_User_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Groups_Bool_Exp>;
};


export type Subscription_RootBase_User_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Subscription_RootBase_User_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Network_Order_By>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Subscription_RootBase_User_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Network_Bool_Exp>;
};


export type Subscription_RootBase_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootBase_User_User_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Subscription_RootBase_User_User_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_User_User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_User_Permissions_Order_By>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Subscription_RootBase_User_User_Permissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBase_User_User_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_User_User_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_User_User_Permissions_Bool_Exp>;
};


export type Subscription_RootBrandArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Subscription_RootBrand_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Subscription_RootBrand_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootBrand_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


export type Subscription_RootBrand_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Brand_Company_Order_By>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


export type Subscription_RootBrand_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootBrand_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Brand_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Company_Bool_Exp>;
};


export type Subscription_RootBrand_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Brand_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Subscription_RootBreederArgs = {
  distinct_on?: InputMaybe<Array<Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Breeder_Order_By>>;
  where?: InputMaybe<Breeder_Bool_Exp>;
};


export type Subscription_RootBreeder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Breeder_Order_By>>;
  where?: InputMaybe<Breeder_Bool_Exp>;
};


export type Subscription_RootBreeder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBreeder_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Breeder_Stream_Cursor_Input>>;
  where?: InputMaybe<Breeder_Bool_Exp>;
};


export type Subscription_RootBusinessArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootBusiness_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootBusiness_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Commodities_SuppliedArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Subscription_RootBusiness_Commodities_Supplied_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Commodities_Supplied_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Commodities_Supplied_Order_By>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Subscription_RootBusiness_Commodities_Supplied_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Commodities_Supplied_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Commodities_Supplied_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Commodities_Supplied_Bool_Exp>;
};


export type Subscription_RootBusiness_CompaniesArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Subscription_RootBusiness_Companies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Companies_Order_By>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Subscription_RootBusiness_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Companies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Companies_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Companies_Bool_Exp>;
};


export type Subscription_RootBusiness_FieldArgs = {
  distinct_on?: InputMaybe<Array<Business_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Field_Order_By>>;
  where?: InputMaybe<Business_Field_Bool_Exp>;
};


export type Subscription_RootBusiness_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Field_Order_By>>;
  where?: InputMaybe<Business_Field_Bool_Exp>;
};


export type Subscription_RootBusiness_Field_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Field_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Field_Bool_Exp>;
};


export type Subscription_RootBusiness_GroupArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Network_Order_By>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Group_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Group_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Group_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootBusiness_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Subscription_RootBusiness_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Groups_Order_By>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Subscription_RootBusiness_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Groups_Bool_Exp>;
};


export type Subscription_RootBusiness_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Network_Order_By>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Network_Bool_Exp>;
};


export type Subscription_RootBusiness_Secondary_PocsArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Subscription_RootBusiness_Secondary_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Business_Secondary_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Secondary_Pocs_Order_By>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Subscription_RootBusiness_Secondary_Pocs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBusiness_Secondary_Pocs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Secondary_Pocs_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Secondary_Pocs_Bool_Exp>;
};


export type Subscription_RootBusiness_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Business_Stream_Cursor_Input>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootCommodityArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Subscription_RootCommodity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Order_By>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Subscription_RootCommodity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommodity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Commodity_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Bool_Exp>;
};


export type Subscription_RootCommodity_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommodity_Variety_Secondary_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_Secondary_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_Secondary_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommodity_Variety_Secondary_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Commodity_Variety_Secondary_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


export type Subscription_RootCommodity_Variety_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Commodity_Variety_Stream_Cursor_Input>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


export type Subscription_RootCompanyArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Order_By>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompany_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


export type Subscription_RootCompany_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Categories_Order_By>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


export type Subscription_RootCompany_Categories_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompany_Categories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Company_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Company_Categories_Bool_Exp>;
};


export type Subscription_RootCompany_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Company_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Category_Order_By>>;
  where?: InputMaybe<Company_Category_Bool_Exp>;
};


export type Subscription_RootCompany_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Category_Order_By>>;
  where?: InputMaybe<Company_Category_Bool_Exp>;
};


export type Subscription_RootCompany_Category_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompany_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Company_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Company_Category_Bool_Exp>;
};


export type Subscription_RootCompany_Share_HolderArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


export type Subscription_RootCompany_Share_Holder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Share_Holder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Share_Holder_Order_By>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


export type Subscription_RootCompany_Share_Holder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompany_Share_Holder_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Company_Share_Holder_Stream_Cursor_Input>>;
  where?: InputMaybe<Company_Share_Holder_Bool_Exp>;
};


export type Subscription_RootCompany_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Company_Bool_Exp>;
};


export type Subscription_RootContent_TypeArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Subscription_RootContent_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Content_Type_Order_By>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Subscription_RootContent_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCreditArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Subscription_RootCredit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Order_By>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Subscription_RootCredit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCredit_NoteArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Subscription_RootCredit_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Subscription_RootCredit_Note_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCredit_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Subscription_RootCredit_RequestArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Request_Order_By>>;
  where?: InputMaybe<Credit_Request_Bool_Exp>;
};


export type Subscription_RootCredit_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Request_Order_By>>;
  where?: InputMaybe<Credit_Request_Bool_Exp>;
};


export type Subscription_RootCredit_Request_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCredit_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Request_Bool_Exp>;
};


export type Subscription_RootCredit_StatusArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Order_By>>;
  where?: InputMaybe<Credit_Status_Bool_Exp>;
};


export type Subscription_RootCredit_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Order_By>>;
  where?: InputMaybe<Credit_Status_Bool_Exp>;
};


export type Subscription_RootCredit_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCredit_Status_ParentsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


export type Subscription_RootCredit_Status_Parents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Status_Parents_Order_By>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


export type Subscription_RootCredit_Status_Parents_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCredit_Status_Parents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Status_Parents_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Status_Parents_Bool_Exp>;
};


export type Subscription_RootCredit_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Status_Bool_Exp>;
};


export type Subscription_RootCredit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Bool_Exp>;
};


export type Subscription_RootCredit_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Subscription_RootCredit_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Transaction_Order_By>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Subscription_RootCredit_Transaction_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCredit_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Transaction_Bool_Exp>;
};


export type Subscription_RootCredit_WalletArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCredit_Wallet_RequestArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Request_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Request_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_Request_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCredit_Wallet_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Wallet_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Wallet_Request_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_StatusArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Status_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Status_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Wallet_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Wallet_Status_Order_By>>;
  where?: InputMaybe<Credit_Wallet_Status_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCredit_Wallet_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Wallet_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Wallet_Status_Bool_Exp>;
};


export type Subscription_RootCredit_Wallet_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Wallet_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Wallet_Bool_Exp>;
};


export type Subscription_RootCropArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Subscription_RootCrop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Order_By>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Subscription_RootCrop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_GroupArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Subscription_RootCrop_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Group_Order_By>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Subscription_RootCrop_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Group_Bool_Exp>;
};


export type Subscription_RootCrop_InfestationArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_AttachmentArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_Attachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Infestation_Attachment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Infestation_Attachment_Order_By>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_Attachment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Infestation_Attachment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Infestation_Attachment_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Infestation_Attachment_Bool_Exp>;
};


export type Subscription_RootCrop_Infestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Infestation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Infestation_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Infestation_Bool_Exp>;
};


export type Subscription_RootCrop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootCrop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Milestone_Order_By>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootCrop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Milestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootCrop_RootstockArgs = {
  distinct_on?: InputMaybe<Array<Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Crop_Rootstock_Bool_Exp>;
};


export type Subscription_RootCrop_Rootstock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Crop_Rootstock_Bool_Exp>;
};


export type Subscription_RootCrop_Rootstock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Rootstock_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Rootstock_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Rootstock_Bool_Exp>;
};


export type Subscription_RootCrop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Bool_Exp>;
};


export type Subscription_RootCrop_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Order_By>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_BreederArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_Breeder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Variety_Breeder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Variety_Breeder_Order_By>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_Breeder_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Variety_Breeder_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Variety_Breeder_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Variety_Breeder_Bool_Exp>;
};


export type Subscription_RootCrop_Variety_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Variety_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Variety_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Variety_Bool_Exp>;
};


export type Subscription_RootCrop_YearArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Subscription_RootCrop_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Crop_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Crop_Year_Order_By>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Subscription_RootCrop_Year_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCrop_Year_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Crop_Year_Stream_Cursor_Input>>;
  where?: InputMaybe<Crop_Year_Bool_Exp>;
};


export type Subscription_RootCultivation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cultivation_Type_Order_By>>;
  where?: InputMaybe<Cultivation_Type_Bool_Exp>;
};


export type Subscription_RootCultivation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cultivation_Type_Order_By>>;
  where?: InputMaybe<Cultivation_Type_Bool_Exp>;
};


export type Subscription_RootCultivation_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCultivation_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cultivation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Cultivation_Type_Bool_Exp>;
};


export type Subscription_RootDemandArgs = {
  distinct_on?: InputMaybe<Array<Demand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Order_By>>;
  where?: InputMaybe<Demand_Bool_Exp>;
};


export type Subscription_RootDemand_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Order_By>>;
  where?: InputMaybe<Demand_Bool_Exp>;
};


export type Subscription_RootDemand_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Demand_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Attachments_Order_By>>;
  where?: InputMaybe<Demand_Attachments_Bool_Exp>;
};


export type Subscription_RootDemand_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Attachments_Order_By>>;
  where?: InputMaybe<Demand_Attachments_Bool_Exp>;
};


export type Subscription_RootDemand_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDemand_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demand_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Demand_Attachments_Bool_Exp>;
};


export type Subscription_RootDemand_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDemand_EnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiries_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDemand_Enquiries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demand_Enquiries_Stream_Cursor_Input>>;
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiries_Twilio_MessageArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiries_Twilio_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiries_Twilio_Message_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDemand_Enquiries_Twilio_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demand_Enquiries_Twilio_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Demand_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiry_Status_LogArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiry_Status_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
};


export type Subscription_RootDemand_Enquiry_Status_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDemand_Enquiry_Status_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demand_Enquiry_Status_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Demand_Enquiry_Status_Log_Bool_Exp>;
};


export type Subscription_RootDemand_ExpenseArgs = {
  distinct_on?: InputMaybe<Array<Demand_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Expense_Order_By>>;
  where?: InputMaybe<Demand_Expense_Bool_Exp>;
};


export type Subscription_RootDemand_Expense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Expense_Order_By>>;
  where?: InputMaybe<Demand_Expense_Bool_Exp>;
};


export type Subscription_RootDemand_Expense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDemand_Expense_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demand_Expense_Stream_Cursor_Input>>;
  where?: InputMaybe<Demand_Expense_Bool_Exp>;
};


export type Subscription_RootDemand_Seller_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Demand_Seller_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Seller_Groups_Order_By>>;
  where?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
};


export type Subscription_RootDemand_Seller_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Demand_Seller_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Demand_Seller_Groups_Order_By>>;
  where?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
};


export type Subscription_RootDemand_Seller_Groups_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDemand_Seller_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demand_Seller_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Demand_Seller_Groups_Bool_Exp>;
};


export type Subscription_RootDemand_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Demand_Stream_Cursor_Input>>;
  where?: InputMaybe<Demand_Bool_Exp>;
};


export type Subscription_RootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDepartment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDepartment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDepartment_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Department_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Config_Order_By>>;
  where?: InputMaybe<Department_Config_Bool_Exp>;
};


export type Subscription_RootDepartment_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Config_Order_By>>;
  where?: InputMaybe<Department_Config_Bool_Exp>;
};


export type Subscription_RootDepartment_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDepartment_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Department_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Config_Bool_Exp>;
};


export type Subscription_RootDepartment_Payment_DetailArgs = {
  distinct_on?: InputMaybe<Array<Department_Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Payment_Detail_Order_By>>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};


export type Subscription_RootDepartment_Payment_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Payment_Detail_Order_By>>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};


export type Subscription_RootDepartment_Payment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDepartment_Payment_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Department_Payment_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Payment_Detail_Bool_Exp>;
};


export type Subscription_RootDepartment_SettlementsArgs = {
  distinct_on?: InputMaybe<Array<Department_Settlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Settlements_Order_By>>;
  where?: InputMaybe<Department_Settlements_Bool_Exp>;
};


export type Subscription_RootDepartment_Settlements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_Settlements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_Settlements_Order_By>>;
  where?: InputMaybe<Department_Settlements_Bool_Exp>;
};


export type Subscription_RootDepartment_Settlements_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDepartment_Settlements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Department_Settlements_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Settlements_Bool_Exp>;
};


export type Subscription_RootDepartment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Department_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDepartment_User_AdvanceArgs = {
  distinct_on?: InputMaybe<Array<Department_User_Advance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_User_Advance_Order_By>>;
  where?: InputMaybe<Department_User_Advance_Bool_Exp>;
};


export type Subscription_RootDepartment_User_Advance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Department_User_Advance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Department_User_Advance_Order_By>>;
  where?: InputMaybe<Department_User_Advance_Bool_Exp>;
};


export type Subscription_RootDepartment_User_Advance_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDepartment_User_Advance_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Department_User_Advance_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_User_Advance_Bool_Exp>;
};


export type Subscription_RootDeviceArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Subscription_RootDevice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Device_Order_By>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Subscription_RootDevice_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDevice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Device_Bool_Exp>;
};


export type Subscription_RootDjango_Celery_Results_TaskresultArgs = {
  distinct_on?: InputMaybe<Array<Django_Celery_Results_Taskresult_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Celery_Results_Taskresult_Order_By>>;
  where?: InputMaybe<Django_Celery_Results_Taskresult_Bool_Exp>;
};


export type Subscription_RootDjango_Celery_Results_Taskresult_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Django_Celery_Results_Taskresult_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Django_Celery_Results_Taskresult_Order_By>>;
  where?: InputMaybe<Django_Celery_Results_Taskresult_Bool_Exp>;
};


export type Subscription_RootDjango_Celery_Results_Taskresult_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDjango_Celery_Results_Taskresult_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Django_Celery_Results_Taskresult_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Celery_Results_Taskresult_Bool_Exp>;
};


export type Subscription_RootDjango_Content_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Django_Content_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Django_Content_Type_Bool_Exp>;
};


export type Subscription_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Subscription_RootDocument_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Attachments_Order_By>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Subscription_RootDocument_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Attachments_Bool_Exp>;
};


export type Subscription_RootDocument_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_DataArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Subscription_RootDocument_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Data_Order_By>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Subscription_RootDocument_Data_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Data_Bool_Exp>;
};


export type Subscription_RootDocument_Export_LogArgs = {
  distinct_on?: InputMaybe<Array<Document_Export_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Export_Log_Order_By>>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};


export type Subscription_RootDocument_Export_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Export_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Export_Log_Order_By>>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};


export type Subscription_RootDocument_Export_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDocument_Export_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Export_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Export_Log_Bool_Exp>;
};


export type Subscription_RootDocument_KindArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Order_By>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Kind_Data_FieldArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_Data_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Kind_Data_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Kind_Data_Field_Order_By>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_Data_Field_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Kind_Data_Field_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Kind_Data_Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Kind_Data_Field_Bool_Exp>;
};


export type Subscription_RootDocument_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Kind_Bool_Exp>;
};


export type Subscription_RootDocument_ReportArgs = {
  distinct_on?: InputMaybe<Array<Document_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Report_Order_By>>;
  where?: InputMaybe<Document_Report_Bool_Exp>;
};


export type Subscription_RootDocument_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Report_Order_By>>;
  where?: InputMaybe<Document_Report_Bool_Exp>;
};


export type Subscription_RootDocument_Report_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDocument_Report_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Report_Bool_Exp>;
};


export type Subscription_RootDocument_RevisionArgs = {
  distinct_on?: InputMaybe<Array<Document_Revision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Revision_Order_By>>;
  where?: InputMaybe<Document_Revision_Bool_Exp>;
};


export type Subscription_RootDocument_Revision_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Revision_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Revision_Order_By>>;
  where?: InputMaybe<Document_Revision_Bool_Exp>;
};


export type Subscription_RootDocument_Revision_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDocument_Revision_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Revision_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Revision_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootEagle_AddressArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Address_Order_By>>;
  where?: InputMaybe<Eagle_Address_Bool_Exp>;
};


export type Subscription_RootEagle_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Address_Order_By>>;
  where?: InputMaybe<Eagle_Address_Bool_Exp>;
};


export type Subscription_RootEagle_Address_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootEagle_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Eagle_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Eagle_Address_Bool_Exp>;
};


export type Subscription_RootEagle_MediaArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Media_Order_By>>;
  where?: InputMaybe<Eagle_Media_Bool_Exp>;
};


export type Subscription_RootEagle_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Eagle_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Eagle_Media_Order_By>>;
  where?: InputMaybe<Eagle_Media_Bool_Exp>;
};


export type Subscription_RootEagle_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootEagle_Media_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Eagle_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Eagle_Media_Bool_Exp>;
};


export type Subscription_RootEntity_StateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


export type Subscription_RootEntity_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


export type Subscription_RootEntity_State_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootEntity_State_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Entity_State_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


export type Subscription_RootEvaluation_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Criteria_Order_By>>;
  where?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
};


export type Subscription_RootEvaluation_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Criteria_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Criteria_Order_By>>;
  where?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
};


export type Subscription_RootEvaluation_Criteria_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootEvaluation_Criteria_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Evaluation_Criteria_Stream_Cursor_Input>>;
  where?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
};


export type Subscription_RootEvaluation_TagArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Tag_Order_By>>;
  where?: InputMaybe<Evaluation_Tag_Bool_Exp>;
};


export type Subscription_RootEvaluation_Tag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Evaluation_Tag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Evaluation_Tag_Order_By>>;
  where?: InputMaybe<Evaluation_Tag_Bool_Exp>;
};


export type Subscription_RootEvaluation_Tag_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootEvaluation_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Evaluation_Tag_Stream_Cursor_Input>>;
  where?: InputMaybe<Evaluation_Tag_Bool_Exp>;
};


export type Subscription_RootExpenseArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Subscription_RootExpense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Subscription_RootExpense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootExpense_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Expense_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Parameter_Order_By>>;
  where?: InputMaybe<Expense_Parameter_Bool_Exp>;
};


export type Subscription_RootExpense_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootExpense_Parameter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Expense_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Expense_Parameter_Bool_Exp>;
};


export type Subscription_RootExpense_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Expense_Stream_Cursor_Input>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


export type Subscription_RootExternal_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<External_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Application_Order_By>>;
  where?: InputMaybe<External_Application_Bool_Exp>;
};


export type Subscription_RootExternal_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Application_Order_By>>;
  where?: InputMaybe<External_Application_Bool_Exp>;
};


export type Subscription_RootExternal_Application_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootExternal_Application_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<External_Application_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Application_Bool_Exp>;
};


export type Subscription_RootExternal_EntityArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Order_By>>;
  where?: InputMaybe<External_Entity_Bool_Exp>;
};


export type Subscription_RootExternal_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Order_By>>;
  where?: InputMaybe<External_Entity_Bool_Exp>;
};


export type Subscription_RootExternal_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootExternal_Entity_GroupArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Group_Order_By>>;
  where?: InputMaybe<External_Entity_Group_Bool_Exp>;
};


export type Subscription_RootExternal_Entity_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Entity_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Entity_Group_Order_By>>;
  where?: InputMaybe<External_Entity_Group_Bool_Exp>;
};


export type Subscription_RootExternal_Entity_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootExternal_Entity_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<External_Entity_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Entity_Group_Bool_Exp>;
};


export type Subscription_RootExternal_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<External_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Entity_Bool_Exp>;
};


export type Subscription_RootExternal_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Subscription_RootExternal_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<External_Reference_Order_By>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Subscription_RootExternal_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootExternal_Reference_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<External_Reference_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Reference_Bool_Exp>;
};


export type Subscription_RootFarmArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Order_By>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFarm_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFarm_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Subscription_RootFarm_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farm_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farm_Network_Order_By>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Subscription_RootFarm_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFarm_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Farm_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Network_Bool_Exp>;
};


export type Subscription_RootFarm_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Farm_Stream_Cursor_Input>>;
  where?: InputMaybe<Farm_Bool_Exp>;
};


export type Subscription_RootFieldArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Subscription_RootField_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Order_By>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Subscription_RootField_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootField_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Subscription_RootField_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Network_Order_By>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Subscription_RootField_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootField_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Field_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Network_Bool_Exp>;
};


export type Subscription_RootField_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Bool_Exp>;
};


export type Subscription_RootField_Weather_LocationArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Subscription_RootField_Weather_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Subscription_RootField_Weather_Location_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootField_Weather_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Field_Weather_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


export type Subscription_RootFinancial_YearArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Order_By>>;
  where?: InputMaybe<Financial_Year_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Order_By>>;
  where?: InputMaybe<Financial_Year_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_Assessment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFinancial_Year_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_Assessment_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFinancial_Year_Assessment_Cw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Financial_Year_Assessment_Cw_Stream_Cursor_Input>>;
  where?: InputMaybe<Financial_Year_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_Assessment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Financial_Year_Assessment_Stream_Cursor_Input>>;
  where?: InputMaybe<Financial_Year_Assessment_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFinancial_Year_CwArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Cw_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financial_Year_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Financial_Year_Cw_Order_By>>;
  where?: InputMaybe<Financial_Year_Cw_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFinancial_Year_Cw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Financial_Year_Cw_Stream_Cursor_Input>>;
  where?: InputMaybe<Financial_Year_Cw_Bool_Exp>;
};


export type Subscription_RootFinancial_Year_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Financial_Year_Stream_Cursor_Input>>;
  where?: InputMaybe<Financial_Year_Bool_Exp>;
};


export type Subscription_RootGradeArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGrade_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootGrade_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


export type Subscription_RootGrade_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Company_Order_By>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


export type Subscription_RootGrade_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootGrade_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Company_Bool_Exp>;
};


export type Subscription_RootGrade_PriceArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Subscription_RootGrade_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Price_Order_By>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Subscription_RootGrade_Price_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGrade_Price_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Price_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Price_Bool_Exp>;
};


export type Subscription_RootGrade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGuarantor_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Agreement_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Agreement_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Invoices_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Agreement_Invoices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGuarantor_Agreement_Agreement_Invoices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Guarantor_Agreement_Agreement_Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Invoices_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Agreement_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Agreement_Plots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Agreement_Plots_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Agreement_Plots_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGuarantor_Agreement_Agreement_Plots_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Guarantor_Agreement_Agreement_Plots_Stream_Cursor_Input>>;
  where?: InputMaybe<Guarantor_Agreement_Agreement_Plots_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Area_Extension_DetailArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Area_Extension_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Guarantor_Agreement_Area_Extension_Detail_Order_By>>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_Area_Extension_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGuarantor_Agreement_Area_Extension_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Guarantor_Agreement_Area_Extension_Detail_Bool_Exp>;
};


export type Subscription_RootGuarantor_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGuarantor_Agreement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Guarantor_Agreement_Stream_Cursor_Input>>;
  where?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
};


export type Subscription_RootInfestationArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Subscription_RootInfestation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Infestation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Infestation_Order_By>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Subscription_RootInfestation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootInfestation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Infestation_Stream_Cursor_Input>>;
  where?: InputMaybe<Infestation_Bool_Exp>;
};


export type Subscription_RootInstrumentArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Order_By>>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};


export type Subscription_RootInstrument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Order_By>>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};


export type Subscription_RootInstrument_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInstrument_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Departments_Order_By>>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};


export type Subscription_RootInstrument_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Departments_Order_By>>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};


export type Subscription_RootInstrument_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInstrument_Departments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Instrument_Departments_Stream_Cursor_Input>>;
  where?: InputMaybe<Instrument_Departments_Bool_Exp>;
};


export type Subscription_RootInstrument_KindArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Kind_Order_By>>;
  where?: InputMaybe<Instrument_Kind_Bool_Exp>;
};


export type Subscription_RootInstrument_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Instrument_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Instrument_Kind_Order_By>>;
  where?: InputMaybe<Instrument_Kind_Bool_Exp>;
};


export type Subscription_RootInstrument_Kind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInstrument_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Instrument_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Instrument_Kind_Bool_Exp>;
};


export type Subscription_RootInstrument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Instrument_Stream_Cursor_Input>>;
  where?: InputMaybe<Instrument_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootIssuance_NoteArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Attachments_Order_By>>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Attachments_Order_By>>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootIssuance_Note_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Issuance_Note_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Issuance_Note_Attachments_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootIssuance_Note_Item_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Item_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Item_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_Item_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Item_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Item_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_Item_Taxes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootIssuance_Note_Item_Taxes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Issuance_Note_Item_Taxes_Stream_Cursor_Input>>;
  where?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Issuance_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
};


export type Subscription_RootIssuance_Note_Taxes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootIssuance_Note_Taxes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Issuance_Note_Taxes_Stream_Cursor_Input>>;
  where?: InputMaybe<Issuance_Note_Taxes_Bool_Exp>;
};


export type Subscription_RootKite_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Kite_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Notification_Order_By>>;
  where?: InputMaybe<Kite_Notification_Bool_Exp>;
};


export type Subscription_RootKite_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kite_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Notification_Order_By>>;
  where?: InputMaybe<Kite_Notification_Bool_Exp>;
};


export type Subscription_RootKite_Notification_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootKite_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Kite_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Kite_Notification_Bool_Exp>;
};


export type Subscription_RootKite_Quality_StageArgs = {
  distinct_on?: InputMaybe<Array<Kite_Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Quality_Stage_Order_By>>;
  where?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
};


export type Subscription_RootKite_Quality_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kite_Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kite_Quality_Stage_Order_By>>;
  where?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
};


export type Subscription_RootKite_Quality_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootKite_Quality_Stage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Kite_Quality_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Kite_Quality_Stage_Bool_Exp>;
};


export type Subscription_RootLaboratoryArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootLaboratory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Order_By>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootLaboratory_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootLaboratory_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Organisations_Order_By>>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};


export type Subscription_RootLaboratory_Organisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Laboratory_Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Laboratory_Organisations_Order_By>>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};


export type Subscription_RootLaboratory_Organisations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootLaboratory_Organisations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Laboratory_Organisations_Stream_Cursor_Input>>;
  where?: InputMaybe<Laboratory_Organisations_Bool_Exp>;
};


export type Subscription_RootLaboratory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Laboratory_Stream_Cursor_Input>>;
  where?: InputMaybe<Laboratory_Bool_Exp>;
};


export type Subscription_RootLegal_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Agreement_Order_By>>;
  where?: InputMaybe<Legal_Agreement_Bool_Exp>;
};


export type Subscription_RootLegal_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Agreement_Order_By>>;
  where?: InputMaybe<Legal_Agreement_Bool_Exp>;
};


export type Subscription_RootLegal_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLegal_Agreement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legal_Agreement_Stream_Cursor_Input>>;
  where?: InputMaybe<Legal_Agreement_Bool_Exp>;
};


export type Subscription_RootMarketArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Subscription_RootMarket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Order_By>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Subscription_RootMarket_Allowed_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


export type Subscription_RootMarket_Allowed_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Market_Allowed_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Market_Allowed_Departments_Order_By>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


export type Subscription_RootMarket_Allowed_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootMarket_Allowed_Departments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Market_Allowed_Departments_Stream_Cursor_Input>>;
  where?: InputMaybe<Market_Allowed_Departments_Bool_Exp>;
};


export type Subscription_RootMarket_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootMarket_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Market_Stream_Cursor_Input>>;
  where?: InputMaybe<Market_Bool_Exp>;
};


export type Subscription_RootMediaArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Order_By>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMedia_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMedia_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Media_Bool_Exp>;
};


export type Subscription_RootMilestoneArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMilestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMilestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMilestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMutual_GroupArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootMutual_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootMutual_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_MembershipArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Membership_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Membership_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Membership_Order_By>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Membership_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Membership_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Membership_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Membership_Bool_Exp>;
};


export type Subscription_RootMutual_Group_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Network_Order_By>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Network_Bool_Exp>;
};


export type Subscription_RootMutual_Group_RoleArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Role_Order_By>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Role_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Role_Bool_Exp>;
};


export type Subscription_RootMutual_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Weather_StationArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Weather_Station_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mutual_Group_Weather_Station_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Weather_Station_Order_By>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Subscription_RootMutual_Group_Weather_Station_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMutual_Group_Weather_Station_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mutual_Group_Weather_Station_Stream_Cursor_Input>>;
  where?: InputMaybe<Mutual_Group_Weather_Station_Bool_Exp>;
};


export type Subscription_RootNationalityArgs = {
  distinct_on?: InputMaybe<Array<Nationality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nationality_Order_By>>;
  where?: InputMaybe<Nationality_Bool_Exp>;
};


export type Subscription_RootNationality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nationality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nationality_Order_By>>;
  where?: InputMaybe<Nationality_Bool_Exp>;
};


export type Subscription_RootNationality_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNationality_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nationality_Stream_Cursor_Input>>;
  where?: InputMaybe<Nationality_Bool_Exp>;
};


export type Subscription_RootNetworkArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Subscription_RootNetwork_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Network_Order_By>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Subscription_RootNetwork_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNetwork_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Network_Bool_Exp>;
};


export type Subscription_RootNomineesArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Order_By>>;
  where?: InputMaybe<Nominees_Bool_Exp>;
};


export type Subscription_RootNominees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Order_By>>;
  where?: InputMaybe<Nominees_Bool_Exp>;
};


export type Subscription_RootNominees_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNominees_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Documents_Order_By>>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};


export type Subscription_RootNominees_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominees_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominees_Documents_Order_By>>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};


export type Subscription_RootNominees_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNominees_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nominees_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Nominees_Documents_Bool_Exp>;
};


export type Subscription_RootNominees_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nominees_Stream_Cursor_Input>>;
  where?: InputMaybe<Nominees_Bool_Exp>;
};


export type Subscription_RootNotification_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Notification_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Provider_Order_By>>;
  where?: InputMaybe<Notification_Provider_Bool_Exp>;
};


export type Subscription_RootNotification_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Provider_Order_By>>;
  where?: InputMaybe<Notification_Provider_Bool_Exp>;
};


export type Subscription_RootNotification_Provider_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNotification_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Provider_Bool_Exp>;
};


export type Subscription_RootNotification_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Notification_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Trigger_Order_By>>;
  where?: InputMaybe<Notification_Trigger_Bool_Exp>;
};


export type Subscription_RootNotification_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Trigger_Order_By>>;
  where?: InputMaybe<Notification_Trigger_Bool_Exp>;
};


export type Subscription_RootNotification_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNotification_Trigger_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Trigger_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Trigger_Bool_Exp>;
};


export type Subscription_RootOffer_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Offer_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Attachments_Order_By>>;
  where?: InputMaybe<Offer_Attachments_Bool_Exp>;
};


export type Subscription_RootOffer_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Attachments_Order_By>>;
  where?: InputMaybe<Offer_Attachments_Bool_Exp>;
};


export type Subscription_RootOffer_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffer_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offer_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Offer_Attachments_Bool_Exp>;
};


export type Subscription_RootOffer_EnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiries_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffer_Enquiries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offer_Enquiries_Stream_Cursor_Input>>;
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiries_Twilio_MessageArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiries_Twilio_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiries_Twilio_Message_Order_By>>;
  where?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiries_Twilio_Message_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffer_Enquiries_Twilio_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offer_Enquiries_Twilio_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Offer_Enquiries_Twilio_Message_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiry_Status_LogArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiry_Status_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Enquiry_Status_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Enquiry_Status_Log_Order_By>>;
  where?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
};


export type Subscription_RootOffer_Enquiry_Status_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffer_Enquiry_Status_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offer_Enquiry_Status_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Offer_Enquiry_Status_Log_Bool_Exp>;
};


export type Subscription_RootOffer_ExpenseArgs = {
  distinct_on?: InputMaybe<Array<Offer_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Expense_Order_By>>;
  where?: InputMaybe<Offer_Expense_Bool_Exp>;
};


export type Subscription_RootOffer_Expense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Expense_Order_By>>;
  where?: InputMaybe<Offer_Expense_Bool_Exp>;
};


export type Subscription_RootOffer_Expense_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffer_Expense_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offer_Expense_Stream_Cursor_Input>>;
  where?: InputMaybe<Offer_Expense_Bool_Exp>;
};


export type Subscription_RootOffer_Order_PickedArgs = {
  distinct_on?: InputMaybe<Array<Offer_Order_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Order_Picked_Order_By>>;
  where?: InputMaybe<Offer_Order_Picked_Bool_Exp>;
};


export type Subscription_RootOffer_Order_Picked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Order_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Order_Picked_Order_By>>;
  where?: InputMaybe<Offer_Order_Picked_Bool_Exp>;
};


export type Subscription_RootOffer_Order_Picked_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffer_Order_Picked_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offer_Order_Picked_Stream_Cursor_Input>>;
  where?: InputMaybe<Offer_Order_Picked_Bool_Exp>;
};


export type Subscription_RootOffer_Storage_PickedArgs = {
  distinct_on?: InputMaybe<Array<Offer_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Storage_Picked_Order_By>>;
  where?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
};


export type Subscription_RootOffer_Storage_Picked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offer_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offer_Storage_Picked_Order_By>>;
  where?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
};


export type Subscription_RootOffer_Storage_Picked_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffer_Storage_Picked_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offer_Storage_Picked_Stream_Cursor_Input>>;
  where?: InputMaybe<Offer_Storage_Picked_Bool_Exp>;
};


export type Subscription_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_Buyer_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Offers_Buyer_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Buyer_Groups_Order_By>>;
  where?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
};


export type Subscription_RootOffers_Buyer_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Buyer_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offers_Buyer_Groups_Order_By>>;
  where?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
};


export type Subscription_RootOffers_Buyer_Groups_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffers_Buyer_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offers_Buyer_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Offers_Buyer_Groups_Bool_Exp>;
};


export type Subscription_RootOffers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOffers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offers_Stream_Cursor_Input>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOrg_Dashboard_StatsArgs = {
  distinct_on?: InputMaybe<Array<Org_Dashboard_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dashboard_Stats_Order_By>>;
  where?: InputMaybe<Org_Dashboard_Stats_Bool_Exp>;
};


export type Subscription_RootOrg_Dashboard_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Dashboard_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dashboard_Stats_Order_By>>;
  where?: InputMaybe<Org_Dashboard_Stats_Bool_Exp>;
};


export type Subscription_RootOrg_Dashboard_Stats_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrg_Dashboard_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Dashboard_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Dashboard_Stats_Bool_Exp>;
};


export type Subscription_RootOrg_Team_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Association_Order_By>>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Association_Order_By>>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_Team_Association_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Team_Association_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Team_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_Primary_CropArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_Team_Primary_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_Team_Primary_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrg_Team_Primary_Crop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Team_Primary_Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Team_Primary_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Bank_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Bank_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Bank_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Bank_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Bank_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_Team_User_Bank_Association_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Team_User_Bank_Association_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Team_User_Bank_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_CropArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_User_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Crop_Order_By>>;
  where?: InputMaybe<Org_Team_User_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrg_Team_User_Crop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Team_User_Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Team_User_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Document_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Document_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Team_User_Document_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Team_User_Document_Association_Order_By>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


export type Subscription_RootOrg_Team_User_Document_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_Team_User_Document_Association_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Team_User_Document_Association_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Team_User_Document_Association_Bool_Exp>;
};


export type Subscription_RootOrg_User_AssociationArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Association_Order_By>>;
  where?: InputMaybe<Org_User_Association_Bool_Exp>;
};


export type Subscription_RootOrg_User_Association_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Association_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Association_Order_By>>;
  where?: InputMaybe<Org_User_Association_Bool_Exp>;
};


export type Subscription_RootOrg_User_Association_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_User_Association_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_User_Association_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_User_Association_Bool_Exp>;
};


export type Subscription_RootOrg_User_Group_Mandatory_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


export type Subscription_RootOrg_User_Group_Mandatory_Document_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Mandatory_Document_Order_By>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


export type Subscription_RootOrg_User_Group_Mandatory_Document_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrg_User_Group_Mandatory_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_User_Group_Mandatory_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_User_Group_Mandatory_Document_Bool_Exp>;
};


export type Subscription_RootOrg_User_Group_Status_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Order_By>>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};


export type Subscription_RootOrg_User_Group_Status_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Group_Status_Snapshot_Order_By>>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};


export type Subscription_RootOrg_User_Group_Status_Snapshot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrg_User_Group_Status_Snapshot_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_User_Group_Status_Snapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_User_Group_Status_Snapshot_Bool_Exp>;
};


export type Subscription_RootOrg_User_Primary_CropArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_User_Primary_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Primary_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Primary_Crop_Order_By>>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};


export type Subscription_RootOrg_User_Primary_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrg_User_Primary_Crop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_User_Primary_Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_User_Primary_Crop_Bool_Exp>;
};


export type Subscription_RootOrganisationArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Order_By>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOrganisation_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Commodity_Variety_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};


export type Subscription_RootOrganisation_Commodity_Variety_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};


export type Subscription_RootOrganisation_Commodity_Variety_Config_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Commodity_Variety_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Commodity_Variety_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Bool_Exp>;
};


export type Subscription_RootOrganisation_Commodity_Variety_Config_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};


export type Subscription_RootOrganisation_Commodity_Variety_Config_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Commodity_Variety_Config_Taxes_Order_By>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};


export type Subscription_RootOrganisation_Commodity_Variety_Config_Taxes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Commodity_Variety_Config_Taxes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Commodity_Variety_Config_Taxes_Bool_Exp>;
};


export type Subscription_RootOrganisation_CropArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Crop_Order_By>>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};


export type Subscription_RootOrganisation_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Crop_Order_By>>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};


export type Subscription_RootOrganisation_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Crop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Crop_Bool_Exp>;
};


export type Subscription_RootOrganisation_Document_KindArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Subscription_RootOrganisation_Document_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Document_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Document_Kind_Order_By>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Subscription_RootOrganisation_Document_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Document_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Document_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Document_Kind_Bool_Exp>;
};


export type Subscription_RootOrganisation_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Subscription_RootOrganisation_Preferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Preferences_Order_By>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Subscription_RootOrganisation_Preferences_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Preferences_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Preferences_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Preferences_Bool_Exp>;
};


export type Subscription_RootOrganisation_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Subscription_RootOrganisation_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Season_Order_By>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Subscription_RootOrganisation_Season_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrganisation_Season_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Season_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Season_Bool_Exp>;
};


export type Subscription_RootOrganisation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Bool_Exp>;
};


export type Subscription_RootOver_DraftArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Order_By>>;
  where?: InputMaybe<Over_Draft_Bool_Exp>;
};


export type Subscription_RootOver_Draft_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Order_By>>;
  where?: InputMaybe<Over_Draft_Bool_Exp>;
};


export type Subscription_RootOver_Draft_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOver_Draft_CwArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Draft_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Draft_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOver_Draft_Cw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Over_Draft_Cw_Stream_Cursor_Input>>;
  where?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Draft_LogArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Bool_Exp>;
};


export type Subscription_RootOver_Draft_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Bool_Exp>;
};


export type Subscription_RootOver_Draft_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOver_Draft_Log_CwArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Draft_Log_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Draft_Log_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Draft_Log_Cw_Order_By>>;
  where?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Draft_Log_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOver_Draft_Log_Cw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Over_Draft_Log_Cw_Stream_Cursor_Input>>;
  where?: InputMaybe<Over_Draft_Log_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Draft_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Over_Draft_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Over_Draft_Log_Bool_Exp>;
};


export type Subscription_RootOver_Draft_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Over_Draft_Stream_Cursor_Input>>;
  where?: InputMaybe<Over_Draft_Bool_Exp>;
};


export type Subscription_RootOver_Due_ApprovalArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOver_Due_Approval_CwArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Cw_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Cw_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOver_Due_Approval_Cw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Over_Due_Approval_Cw_Stream_Cursor_Input>>;
  where?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_LogArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Log_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Over_Due_Approval_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Over_Due_Approval_Log_Order_By>>;
  where?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOver_Due_Approval_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Over_Due_Approval_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Over_Due_Approval_Log_Bool_Exp>;
};


export type Subscription_RootOver_Due_Approval_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Over_Due_Approval_Stream_Cursor_Input>>;
  where?: InputMaybe<Over_Due_Approval_Bool_Exp>;
};


export type Subscription_RootPackagingArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_By>>;
  where?: InputMaybe<Packaging_Bool_Exp>;
};


export type Subscription_RootPackaging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_By>>;
  where?: InputMaybe<Packaging_Bool_Exp>;
};


export type Subscription_RootPackaging_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPackaging_OrderArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Order_By>>;
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
};


export type Subscription_RootPackaging_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Order_By>>;
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
};


export type Subscription_RootPackaging_Order_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPackaging_Order_ItemArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Item_Order_By>>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};


export type Subscription_RootPackaging_Order_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packaging_Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Item_Order_By>>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};


export type Subscription_RootPackaging_Order_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPackaging_Order_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Packaging_Order_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Packaging_Order_Item_Bool_Exp>;
};


export type Subscription_RootPackaging_Order_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Packaging_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
};


export type Subscription_RootPackaging_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Packaging_Stream_Cursor_Input>>;
  where?: InputMaybe<Packaging_Bool_Exp>;
};


export type Subscription_RootPallet_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Category_Order_By>>;
  where?: InputMaybe<Pallet_Category_Bool_Exp>;
};


export type Subscription_RootPallet_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Category_Order_By>>;
  where?: InputMaybe<Pallet_Category_Bool_Exp>;
};


export type Subscription_RootPallet_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Category_Bool_Exp>;
};


export type Subscription_RootPallet_CustomerArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Customer_Order_By>>;
  where?: InputMaybe<Pallet_Customer_Bool_Exp>;
};


export type Subscription_RootPallet_Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Customer_Order_By>>;
  where?: InputMaybe<Pallet_Customer_Bool_Exp>;
};


export type Subscription_RootPallet_Customer_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Customer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Customer_Bool_Exp>;
};


export type Subscription_RootPallet_InspectionArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Inspection_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Inspection_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Inspection_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Inspection_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspection_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspection_Reports_Order_By>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_Reports_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Inspection_Reports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Inspection_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Inspection_Reports_Bool_Exp>;
};


export type Subscription_RootPallet_Inspection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Inspection_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Inspection_Bool_Exp>;
};


export type Subscription_RootPallet_InspectionkindArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionkind_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
};


export type Subscription_RootPallet_Inspectionkind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionkind_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
};


export type Subscription_RootPallet_Inspectionkind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Inspectionkind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Inspectionkind_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Inspectionkind_Bool_Exp>;
};


export type Subscription_RootPallet_InspectionobservationArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};


export type Subscription_RootPallet_Inspectionobservation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};


export type Subscription_RootPallet_Inspectionobservation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Inspectionobservation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Inspectionobservation_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Inspectionobservation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Inspectionobservation_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Inspectionobservation_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Inspectionobservation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Inspectionobservation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Inspectionobservation_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Inspectionobservation_Bool_Exp>;
};


export type Subscription_RootPallet_LineArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Line_Order_By>>;
  where?: InputMaybe<Pallet_Line_Bool_Exp>;
};


export type Subscription_RootPallet_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Line_Order_By>>;
  where?: InputMaybe<Pallet_Line_Bool_Exp>;
};


export type Subscription_RootPallet_Line_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Line_Bool_Exp>;
};


export type Subscription_RootPallet_LocationArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Location_Order_By>>;
  where?: InputMaybe<Pallet_Location_Bool_Exp>;
};


export type Subscription_RootPallet_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Location_Order_By>>;
  where?: InputMaybe<Pallet_Location_Bool_Exp>;
};


export type Subscription_RootPallet_Location_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Location_Bool_Exp>;
};


export type Subscription_RootPallet_PackagingArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packaging_Order_By>>;
  where?: InputMaybe<Pallet_Packaging_Bool_Exp>;
};


export type Subscription_RootPallet_Packaging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packaging_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packaging_Order_By>>;
  where?: InputMaybe<Pallet_Packaging_Bool_Exp>;
};


export type Subscription_RootPallet_Packaging_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packaging_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packaging_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packaging_Bool_Exp>;
};


export type Subscription_RootPallet_PackagingkindArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packagingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packagingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
};


export type Subscription_RootPallet_Packagingkind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packagingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packagingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
};


export type Subscription_RootPallet_Packagingkind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packagingkind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packagingkind_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packagingkind_Bool_Exp>;
};


export type Subscription_RootPallet_PackingArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packing_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packing_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packing_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packing_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packing_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packing_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_WeightsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_Weights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packing_Weights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packing_Weights_Order_By>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};


export type Subscription_RootPallet_Packing_Weights_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packing_Weights_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packing_Weights_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packing_Weights_Bool_Exp>;
};


export type Subscription_RootPallet_PackingkindArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
};


export type Subscription_RootPallet_Packingkind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingkind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingkind_Order_By>>;
  where?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
};


export type Subscription_RootPallet_Packingkind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packingkind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packingkind_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packingkind_Bool_Exp>;
};


export type Subscription_RootPallet_PackingweightArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
};


export type Subscription_RootPallet_Packingweight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
};


export type Subscription_RootPallet_Packingweight_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Packingweight_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Packingweight_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Packingweight_Attachments_Order_By>>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Packingweight_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packingweight_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packingweight_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packingweight_Attachments_Bool_Exp>;
};


export type Subscription_RootPallet_Packingweight_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Packingweight_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Packingweight_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Packingweight_Bool_Exp>;
};


export type Subscription_RootPallet_PrintingmatterArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Printingmatter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Printingmatter_Order_By>>;
  where?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
};


export type Subscription_RootPallet_Printingmatter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Printingmatter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Printingmatter_Order_By>>;
  where?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
};


export type Subscription_RootPallet_Printingmatter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Printingmatter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Printingmatter_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Printingmatter_Bool_Exp>;
};


export type Subscription_RootPallet_PunnetconditionArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Punnetcondition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Punnetcondition_Order_By>>;
  where?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
};


export type Subscription_RootPallet_Punnetcondition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Punnetcondition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Punnetcondition_Order_By>>;
  where?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
};


export type Subscription_RootPallet_Punnetcondition_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Punnetcondition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Punnetcondition_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Punnetcondition_Bool_Exp>;
};


export type Subscription_RootPallet_SamplinglocationArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Samplinglocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Samplinglocation_Order_By>>;
  where?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
};


export type Subscription_RootPallet_Samplinglocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Samplinglocation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Samplinglocation_Order_By>>;
  where?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
};


export type Subscription_RootPallet_Samplinglocation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Samplinglocation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Samplinglocation_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Samplinglocation_Bool_Exp>;
};


export type Subscription_RootPallet_SkuArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Sku_Order_By>>;
  where?: InputMaybe<Pallet_Sku_Bool_Exp>;
};


export type Subscription_RootPallet_Sku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Sku_Order_By>>;
  where?: InputMaybe<Pallet_Sku_Bool_Exp>;
};


export type Subscription_RootPallet_Sku_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Sku_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Sku_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Sku_Bool_Exp>;
};


export type Subscription_RootPallet_SkutypeArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Skutype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Skutype_Order_By>>;
  where?: InputMaybe<Pallet_Skutype_Bool_Exp>;
};


export type Subscription_RootPallet_Skutype_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Skutype_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Skutype_Order_By>>;
  where?: InputMaybe<Pallet_Skutype_Bool_Exp>;
};


export type Subscription_RootPallet_Skutype_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPallet_Skutype_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Skutype_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Skutype_Bool_Exp>;
};


export type Subscription_RootPallet_VarietyArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Variety_Order_By>>;
  where?: InputMaybe<Pallet_Variety_Bool_Exp>;
};


export type Subscription_RootPallet_Variety_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pallet_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pallet_Variety_Order_By>>;
  where?: InputMaybe<Pallet_Variety_Bool_Exp>;
};


export type Subscription_RootPallet_Variety_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPallet_Variety_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pallet_Variety_Stream_Cursor_Input>>;
  where?: InputMaybe<Pallet_Variety_Bool_Exp>;
};


export type Subscription_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPayment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPayment_DetailArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Order_By>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Detail_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Detail_Attachments_Order_By>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_Detail_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Detail_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Detail_Attachments_Bool_Exp>;
};


export type Subscription_RootPayment_Detail_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Detail_Bool_Exp>;
};


export type Subscription_RootPayment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Subscription_RootPayment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Subscription_RootPayment_Method_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_Method_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Method_Bool_Exp>;
};


export type Subscription_RootPayment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPlotArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Subscription_RootPlot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Order_By>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Subscription_RootPlot_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_CropArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_AgentArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Agent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Agent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Agent_Order_By>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Agent_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Agent_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Agent_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Agent_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Cultivation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Order_By>>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Cultivation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Cultivation_Type_Order_By>>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Cultivation_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Cultivation_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Cultivation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Cultivation_Type_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Historic_SeasonArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Historic_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Historic_Season_Order_By>>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Historic_Season_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Historic_Season_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Historic_Season_Order_By>>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Historic_Season_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Historic_Season_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Historic_Season_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Historic_Season_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Milestone_Order_By>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Milestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Milestone_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Network_Order_By>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_RootstockArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Rootstock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Rootstock_Order_By>>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Rootstock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Rootstock_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Rootstock_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Rootstock_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Status_History_Order_By>>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Crop_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Status_History_Order_By>>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_Status_History_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Crop_Status_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Status_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Status_History_Bool_Exp>;
};


export type Subscription_RootPlot_Crop_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Crop_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootPlot_NetworkArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Network_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Network_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Network_Order_By>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Subscription_RootPlot_Network_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Network_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Network_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Network_Bool_Exp>;
};


export type Subscription_RootPlot_StatusArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Subscription_RootPlot_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Order_By>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Subscription_RootPlot_Status_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Status_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};


export type Subscription_RootPlot_Status_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};


export type Subscription_RootPlot_Status_Config_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Status_Config_Required_Qc_StagesArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};


export type Subscription_RootPlot_Status_Config_Required_Qc_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Status_Config_Required_Qc_Stages_Order_By>>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};


export type Subscription_RootPlot_Status_Config_Required_Qc_Stages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlot_Status_Config_Required_Qc_Stages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Status_Config_Required_Qc_Stages_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Status_Config_Required_Qc_Stages_Bool_Exp>;
};


export type Subscription_RootPlot_Status_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Status_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Status_Config_Bool_Exp>;
};


export type Subscription_RootPlot_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Status_Bool_Exp>;
};


export type Subscription_RootPlot_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Plot_Stream_Cursor_Input>>;
  where?: InputMaybe<Plot_Bool_Exp>;
};


export type Subscription_RootPrimary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootPrimary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Primary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Primary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootPrimary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPrimary_Growth_Stage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Primary_Growth_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Primary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootProduction_TradeArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_By>>;
  where?: InputMaybe<Production_Trade_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_By>>;
  where?: InputMaybe<Production_Trade_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProduction_Trade_ItemArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootProduction_Trade_Item_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Production_Trade_Item_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Production_Trade_Item_Attachments_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootProduction_Trade_Item_Storage_PickedArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_Storage_Picked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_Storage_Picked_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProduction_Trade_Item_Storage_Picked_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Production_Trade_Item_Storage_Picked_Stream_Cursor_Input>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Production_Trade_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Production_Trade_Item_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Order_Trade_RefsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Order_By>>;
  where?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Order_Trade_Refs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Order_Trade_Refs_Order_By>>;
  where?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_Order_Trade_Refs_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootProduction_Trade_Order_Trade_Refs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Production_Trade_Order_Trade_Refs_Stream_Cursor_Input>>;
  where?: InputMaybe<Production_Trade_Order_Trade_Refs_Bool_Exp>;
};


export type Subscription_RootProduction_Trade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Production_Trade_Stream_Cursor_Input>>;
  where?: InputMaybe<Production_Trade_Bool_Exp>;
};


export type Subscription_RootProjection_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Bool_Exp>;
};


export type Subscription_RootProjection_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Bool_Exp>;
};


export type Subscription_RootProjection_Assessment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootProjection_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootProjection_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projection_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projection_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootProjection_Assessment_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootProjection_Assessment_Cw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Projection_Assessment_Cw_Stream_Cursor_Input>>;
  where?: InputMaybe<Projection_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootProjection_Assessment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Projection_Assessment_Stream_Cursor_Input>>;
  where?: InputMaybe<Projection_Assessment_Bool_Exp>;
};


export type Subscription_RootQuality_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};


export type Subscription_RootQuality_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};


export type Subscription_RootQuality_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootQuality_Parameter_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Category_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
};


export type Subscription_RootQuality_Parameter_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Parameter_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Parameter_Category_Order_By>>;
  where?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
};


export type Subscription_RootQuality_Parameter_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootQuality_Parameter_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quality_Parameter_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
};


export type Subscription_RootQuality_Parameter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quality_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_Parameter_Bool_Exp>;
};


export type Subscription_RootQuality_StageArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Order_By>>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};


export type Subscription_RootQuality_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Order_By>>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};


export type Subscription_RootQuality_Stage_Allowed_Template_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


export type Subscription_RootQuality_Stage_Allowed_Template_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


export type Subscription_RootQuality_Stage_Allowed_Template_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootQuality_Stage_Allowed_Template_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quality_Stage_Allowed_Template_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


export type Subscription_RootQuality_Stage_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootQuality_Stage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quality_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_Stage_Bool_Exp>;
};


export type Subscription_RootReceiptArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Subscription_RootReceipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Subscription_RootReceipt_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootReceipt_Seller_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootReceipt_Seller_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootReceipt_Seller_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootReceipt_Seller_Gst_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Receipt_Seller_Gst_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Receipt_Seller_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootReceipt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Receipt_Stream_Cursor_Input>>;
  where?: InputMaybe<Receipt_Bool_Exp>;
};


export type Subscription_RootRegionArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Order_By>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRegion_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRegion_GroupArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Subscription_RootRegion_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Region_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Region_Group_Order_By>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Subscription_RootRegion_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRegion_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Region_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Region_Group_Bool_Exp>;
};


export type Subscription_RootRegion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Region_Bool_Exp>;
};


export type Subscription_RootRequestArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


export type Subscription_RootRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Order_By>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


export type Subscription_RootRequest_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootRequest_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Request_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Category_Order_By>>;
  where?: InputMaybe<Request_Category_Bool_Exp>;
};


export type Subscription_RootRequest_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Category_Order_By>>;
  where?: InputMaybe<Request_Category_Bool_Exp>;
};


export type Subscription_RootRequest_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootRequest_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Request_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Request_Category_Bool_Exp>;
};


export type Subscription_RootRequest_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


export type Subscription_RootRequest_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Parameters_Order_By>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


export type Subscription_RootRequest_Parameters_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootRequest_Parameters_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Request_Parameters_Stream_Cursor_Input>>;
  where?: InputMaybe<Request_Parameters_Bool_Exp>;
};


export type Subscription_RootRequest_Secondary_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Request_Secondary_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Secondary_Locations_Order_By>>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};


export type Subscription_RootRequest_Secondary_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Secondary_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Secondary_Locations_Order_By>>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};


export type Subscription_RootRequest_Secondary_Locations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootRequest_Secondary_Locations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Request_Secondary_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Request_Secondary_Locations_Bool_Exp>;
};


export type Subscription_RootRequest_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Request_Bool_Exp>;
};


export type Subscription_RootRequest_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


export type Subscription_RootRequest_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


export type Subscription_RootRequest_Templates_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootRequest_Templates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Request_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


export type Subscription_RootResultArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


export type Subscription_RootResult_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


export type Subscription_RootResult_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootResult_CommentArgs = {
  distinct_on?: InputMaybe<Array<Result_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Comment_Order_By>>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};


export type Subscription_RootResult_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Comment_Order_By>>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};


export type Subscription_RootResult_Comment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootResult_Comment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Comment_Bool_Exp>;
};


export type Subscription_RootResult_EvaluationArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


export type Subscription_RootResult_Evaluation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


export type Subscription_RootResult_Evaluation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootResult_Evaluation_Evaluated_TagsArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};


export type Subscription_RootResult_Evaluation_Evaluated_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};


export type Subscription_RootResult_Evaluation_Evaluated_Tags_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootResult_Evaluation_Evaluated_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Evaluation_Evaluated_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Evaluation_Evaluated_Tags_Bool_Exp>;
};


export type Subscription_RootResult_Evaluation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Evaluation_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


export type Subscription_RootResult_MediaArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


export type Subscription_RootResult_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Media_Order_By>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


export type Subscription_RootResult_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootResult_Media_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Media_Bool_Exp>;
};


export type Subscription_RootResult_ObservationArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


export type Subscription_RootResult_Observation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


export type Subscription_RootResult_Observation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


export type Subscription_RootResult_Observation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


export type Subscription_RootResult_Observation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootResult_Observation_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Observation_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Observation_Attachments_Bool_Exp>;
};


export type Subscription_RootResult_Observation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootResult_Observation_Evaluated_TagsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};


export type Subscription_RootResult_Observation_Evaluated_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Evaluated_Tags_Order_By>>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};


export type Subscription_RootResult_Observation_Evaluated_Tags_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootResult_Observation_Evaluated_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Observation_Evaluated_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Observation_Evaluated_Tags_Bool_Exp>;
};


export type Subscription_RootResult_Observation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Observation_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


export type Subscription_RootResult_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


export type Subscription_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRole_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRootstockArgs = {
  distinct_on?: InputMaybe<Array<Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rootstock_Order_By>>;
  where?: InputMaybe<Rootstock_Bool_Exp>;
};


export type Subscription_RootRootstock_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rootstock_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rootstock_Order_By>>;
  where?: InputMaybe<Rootstock_Bool_Exp>;
};


export type Subscription_RootRootstock_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRootstock_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Rootstock_Stream_Cursor_Input>>;
  where?: InputMaybe<Rootstock_Bool_Exp>;
};


export type Subscription_RootSampleArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Subscription_RootSample_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Order_By>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Subscription_RootSample_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSample_MediaArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


export type Subscription_RootSample_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Media_Order_By>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


export type Subscription_RootSample_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSample_Media_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sample_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Sample_Media_Bool_Exp>;
};


export type Subscription_RootSample_ObservationArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


export type Subscription_RootSample_Observation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


export type Subscription_RootSample_Observation_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


export type Subscription_RootSample_Observation_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Attachments_Order_By>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


export type Subscription_RootSample_Observation_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSample_Observation_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sample_Observation_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Sample_Observation_Attachments_Bool_Exp>;
};


export type Subscription_RootSample_Observation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSample_Observation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sample_Observation_Stream_Cursor_Input>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


export type Subscription_RootSample_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sample_Stream_Cursor_Input>>;
  where?: InputMaybe<Sample_Bool_Exp>;
};


export type Subscription_RootSearch_Base_UsersArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootSearch_Base_Users_AggregateArgs = {
  args: Search_Base_Users_Args;
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp>;
};


export type Subscription_RootSearch_BusinessesArgs = {
  args: Search_Businesses_Args;
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootSearch_Businesses_AggregateArgs = {
  args: Search_Businesses_Args;
  distinct_on?: InputMaybe<Array<Business_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Order_By>>;
  where?: InputMaybe<Business_Bool_Exp>;
};


export type Subscription_RootSearch_Businesses_GroupsArgs = {
  args: Search_Businesses_Groups_Args;
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootSearch_Businesses_Groups_AggregateArgs = {
  args: Search_Businesses_Groups_Args;
  distinct_on?: InputMaybe<Array<Business_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Business_Group_Order_By>>;
  where?: InputMaybe<Business_Group_Bool_Exp>;
};


export type Subscription_RootSearch_Mutual_GroupsArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootSearch_Mutual_Groups_AggregateArgs = {
  args: Search_Mutual_Groups_Args;
  distinct_on?: InputMaybe<Array<Mutual_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mutual_Group_Order_By>>;
  where?: InputMaybe<Mutual_Group_Bool_Exp>;
};


export type Subscription_RootSearch_Plot_CropsArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootSearch_Plot_Crops_AggregateArgs = {
  args: Search_Plot_Crops_Args;
  distinct_on?: InputMaybe<Array<Plot_Crop_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Plot_Crop_Order_By>>;
  where?: InputMaybe<Plot_Crop_Bool_Exp>;
};


export type Subscription_RootSecondary_Growth_StageArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootSecondary_Growth_Stage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Secondary_Growth_Stage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Secondary_Growth_Stage_Order_By>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootSecondary_Growth_Stage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSecondary_Growth_Stage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Secondary_Growth_Stage_Stream_Cursor_Input>>;
  where?: InputMaybe<Secondary_Growth_Stage_Bool_Exp>;
};


export type Subscription_RootSetu_Trade_AddressArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Address_Order_By>>;
  where?: InputMaybe<Setu_Trade_Address_Bool_Exp>;
};


export type Subscription_RootSetu_Trade_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Address_Order_By>>;
  where?: InputMaybe<Setu_Trade_Address_Bool_Exp>;
};


export type Subscription_RootSetu_Trade_Address_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSetu_Trade_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setu_Trade_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Setu_Trade_Address_Bool_Exp>;
};


export type Subscription_RootSetu_Trade_Shared_EntityArgs = {
  distinct_on?: InputMaybe<Array<Setu_Trade_Shared_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setu_Trade_Shared_Entity_Order_By>>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};


export type Subscription_RootSetu_Trade_Shared_Entity_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSetu_Trade_Shared_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setu_Trade_Shared_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
};


export type Subscription_RootSetutrade_MediaArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Media_Order_By>>;
  where?: InputMaybe<Setutrade_Media_Bool_Exp>;
};


export type Subscription_RootSetutrade_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Media_Order_By>>;
  where?: InputMaybe<Setutrade_Media_Bool_Exp>;
};


export type Subscription_RootSetutrade_Media_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSetutrade_Media_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setutrade_Media_Stream_Cursor_Input>>;
  where?: InputMaybe<Setutrade_Media_Bool_Exp>;
};


export type Subscription_RootSetutrade_TripArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Trip_Order_By>>;
  where?: InputMaybe<Setutrade_Trip_Bool_Exp>;
};


export type Subscription_RootSetutrade_Trip_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Setutrade_Trip_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setutrade_Trip_Order_By>>;
  where?: InputMaybe<Setutrade_Trip_Bool_Exp>;
};


export type Subscription_RootSetutrade_Trip_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSetutrade_Trip_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setutrade_Trip_Stream_Cursor_Input>>;
  where?: InputMaybe<Setutrade_Trip_Bool_Exp>;
};


export type Subscription_RootShareholder_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


export type Subscription_RootShareholder_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


export type Subscription_RootShareholder_Applications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShareholder_Applications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shareholder_Applications_Stream_Cursor_Input>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


export type Subscription_RootShareholdersArgs = {
  distinct_on?: InputMaybe<Array<Shareholders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholders_Order_By>>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};


export type Subscription_RootShareholders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholders_Order_By>>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};


export type Subscription_RootShareholders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShareholders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shareholders_Stream_Cursor_Input>>;
  where?: InputMaybe<Shareholders_Bool_Exp>;
};


export type Subscription_RootSi_UnitArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Subscription_RootSi_Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Order_By>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Subscription_RootSi_Unit_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSi_Unit_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Subscription_RootSi_Unit_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Si_Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Si_Unit_Measure_Order_By>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Subscription_RootSi_Unit_Measure_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSi_Unit_Measure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Si_Unit_Measure_Stream_Cursor_Input>>;
  where?: InputMaybe<Si_Unit_Measure_Bool_Exp>;
};


export type Subscription_RootSi_Unit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Si_Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Si_Unit_Bool_Exp>;
};


export type Subscription_RootSkuArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Subscription_RootSku_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Order_By>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Subscription_RootSku_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSku_KindArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Subscription_RootSku_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sku_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sku_Kind_Order_By>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Subscription_RootSku_Kind_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSku_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sku_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Sku_Kind_Bool_Exp>;
};


export type Subscription_RootSku_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sku_Stream_Cursor_Input>>;
  where?: InputMaybe<Sku_Bool_Exp>;
};


export type Subscription_RootSoilArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Subscription_RootSoil_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Soil_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Soil_Order_By>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Subscription_RootSoil_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSoil_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Soil_Stream_Cursor_Input>>;
  where?: InputMaybe<Soil_Bool_Exp>;
};


export type Subscription_RootStage_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Actions_Order_By>>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};


export type Subscription_RootStage_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Actions_Order_By>>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};


export type Subscription_RootStage_Actions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStage_Actions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stage_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Stage_Actions_Bool_Exp>;
};


export type Subscription_RootStage_LogsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


export type Subscription_RootStage_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


export type Subscription_RootStage_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStage_Logs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stage_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


export type Subscription_RootStagesArgs = {
  distinct_on?: InputMaybe<Array<Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Order_By>>;
  where?: InputMaybe<Stages_Bool_Exp>;
};


export type Subscription_RootStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Order_By>>;
  where?: InputMaybe<Stages_Bool_Exp>;
};


export type Subscription_RootStages_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stages_Stream_Cursor_Input>>;
  where?: InputMaybe<Stages_Bool_Exp>;
};


export type Subscription_RootStages_SubscribersArgs = {
  distinct_on?: InputMaybe<Array<Stages_Subscribers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Subscribers_Order_By>>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};


export type Subscription_RootStages_Subscribers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stages_Subscribers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Subscribers_Order_By>>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};


export type Subscription_RootStages_Subscribers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStages_Subscribers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stages_Subscribers_Stream_Cursor_Input>>;
  where?: InputMaybe<Stages_Subscribers_Bool_Exp>;
};


export type Subscription_RootStateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<State_Order_By>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootState_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootState_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<State_Stream_Cursor_Input>>;
  where?: InputMaybe<State_Bool_Exp>;
};


export type Subscription_RootStorage_LocationArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Order_By>>;
  where?: InputMaybe<Storage_Location_Bool_Exp>;
};


export type Subscription_RootStorage_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Order_By>>;
  where?: InputMaybe<Storage_Location_Bool_Exp>;
};


export type Subscription_RootStorage_Location_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Agreement_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Agreement_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Agreement_Attachments_Order_By>>;
  where?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Agreement_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootStorage_Location_Agreement_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Storage_Location_Agreement_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Location_Agreement_Attachments_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Agreement_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootStorage_Location_Agreement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Storage_Location_Agreement_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Location_Agreement_Bool_Exp>;
};


export type Subscription_RootStorage_Location_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootStorage_Location_KindArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Kind_Order_By>>;
  where?: InputMaybe<Storage_Location_Kind_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Kind_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Kind_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Kind_Order_By>>;
  where?: InputMaybe<Storage_Location_Kind_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Kind_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootStorage_Location_Kind_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Storage_Location_Kind_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Location_Kind_Bool_Exp>;
};


export type Subscription_RootStorage_Location_PocsArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Pocs_Order_By>>;
  where?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Pocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Location_Pocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Location_Pocs_Order_By>>;
  where?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
};


export type Subscription_RootStorage_Location_Pocs_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootStorage_Location_Pocs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Storage_Location_Pocs_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Location_Pocs_Bool_Exp>;
};


export type Subscription_RootStorage_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Storage_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Location_Bool_Exp>;
};


export type Subscription_RootStorage_Sub_LocationArgs = {
  distinct_on?: InputMaybe<Array<Storage_Sub_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Sub_Location_Order_By>>;
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
};


export type Subscription_RootStorage_Sub_Location_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Storage_Sub_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Storage_Sub_Location_Order_By>>;
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
};


export type Subscription_RootStorage_Sub_Location_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootStorage_Sub_Location_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Storage_Sub_Location_Stream_Cursor_Input>>;
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
};


export type Subscription_RootSurvey_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Survey_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Parameters_Order_By>>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};


export type Subscription_RootSurvey_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Parameters_Order_By>>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};


export type Subscription_RootSurvey_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSurvey_Parameters_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Survey_Parameters_Stream_Cursor_Input>>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};


export type Subscription_RootSurvey_Response_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


export type Subscription_RootSurvey_Response_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


export type Subscription_RootSurvey_Response_Items_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSurvey_Response_Items_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Survey_Response_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


export type Subscription_RootSurvey_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


export type Subscription_RootSurvey_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


export type Subscription_RootSurvey_Responses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSurvey_Responses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Survey_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


export type Subscription_RootSurvey_UsersArgs = {
  distinct_on?: InputMaybe<Array<Survey_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Users_Order_By>>;
  where?: InputMaybe<Survey_Users_Bool_Exp>;
};


export type Subscription_RootSurvey_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Users_Order_By>>;
  where?: InputMaybe<Survey_Users_Bool_Exp>;
};


export type Subscription_RootSurvey_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSurvey_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Survey_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Survey_Users_Bool_Exp>;
};


export type Subscription_RootSurvey_YearArgs = {
  distinct_on?: InputMaybe<Array<Survey_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Year_Order_By>>;
  where?: InputMaybe<Survey_Year_Bool_Exp>;
};


export type Subscription_RootSurvey_Year_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Year_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Year_Order_By>>;
  where?: InputMaybe<Survey_Year_Bool_Exp>;
};


export type Subscription_RootSurvey_Year_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSurvey_Year_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Survey_Year_Stream_Cursor_Input>>;
  where?: InputMaybe<Survey_Year_Bool_Exp>;
};


export type Subscription_RootSurveysArgs = {
  distinct_on?: InputMaybe<Array<Surveys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Surveys_Order_By>>;
  where?: InputMaybe<Surveys_Bool_Exp>;
};


export type Subscription_RootSurveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Surveys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Surveys_Order_By>>;
  where?: InputMaybe<Surveys_Bool_Exp>;
};


export type Subscription_RootSurveys_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSurveys_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Surveys_Stream_Cursor_Input>>;
  where?: InputMaybe<Surveys_Bool_Exp>;
};


export type Subscription_RootTemplateArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


export type Subscription_RootTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


export type Subscription_RootTemplate_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Order_By>>;
  where?: InputMaybe<Template_Category_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Order_By>>;
  where?: InputMaybe<Template_Category_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_Allowed_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Groups_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Groups_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_Allowed_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Groups_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Groups_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_Allowed_Groups_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Category_Allowed_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Category_Allowed_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Category_Allowed_Groups_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_Allowed_Parameter_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_Allowed_Parameter_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_Allowed_Parameter_Categories_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Category_Allowed_Parameter_Categories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Category_Allowed_Parameter_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};


export type Subscription_RootTemplate_Category_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Category_Bool_Exp>;
};


export type Subscription_RootTemplate_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


export type Subscription_RootTemplate_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


export type Subscription_RootTemplate_Company_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


export type Subscription_RootTemplate_DepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Template_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Departments_Order_By>>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};


export type Subscription_RootTemplate_Departments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Departments_Order_By>>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};


export type Subscription_RootTemplate_Departments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Departments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Departments_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};


export type Subscription_RootTemplate_EvaluationArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Evaluation_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Config_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Config_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Config_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Config_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Evaluation_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Evaluation_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Evaluation_Config_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Evaluation_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Evaluation_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Templates_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Templates_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Evaluation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Evaluation_Templates_Order_By>>;
  where?: InputMaybe<Template_Evaluation_Templates_Bool_Exp>;
};


export type Subscription_RootTemplate_Evaluation_Templates_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Evaluation_Templates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Evaluation_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Evaluation_Templates_Bool_Exp>;
};


export type Subscription_RootTemplate_ParameterArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Parameter_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Config_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Parameter_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Parameter_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_StandardArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Parameter_Standard_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Parameter_Standard_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Parameter_Standard_GroupArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Group_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Group_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_Group_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Parameter_Standard_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Parameter_Standard_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_Standard_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Parameter_Standard_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};


export type Subscription_RootTemplate_Parameter_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Parameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};


export type Subscription_RootTemplate_Quality_StagesArgs = {
  distinct_on?: InputMaybe<Array<Template_Quality_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Quality_Stages_Order_By>>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};


export type Subscription_RootTemplate_Quality_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Quality_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Quality_Stages_Order_By>>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};


export type Subscription_RootTemplate_Quality_Stages_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTemplate_Quality_Stages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Quality_Stages_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};


export type Subscription_RootTemplate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Template_Bool_Exp>;
};


export type Subscription_RootTradeArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Subscription_RootTrade_Action_LogArgs = {
  distinct_on?: InputMaybe<Array<Trade_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Action_Log_Order_By>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


export type Subscription_RootTrade_Action_Log_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Action_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Action_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


export type Subscription_RootTrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Subscription_RootTrade_AssessmentArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Bool_Exp>;
};


export type Subscription_RootTrade_Assessment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Bool_Exp>;
};


export type Subscription_RootTrade_Assessment_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Assessment_CwArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootTrade_Assessment_Cw_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Assessment_Cw_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Assessment_Cw_Order_By>>;
  where?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootTrade_Assessment_Cw_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Assessment_Cw_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Assessment_Cw_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
};


export type Subscription_RootTrade_Assessment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Assessment_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Assessment_Bool_Exp>;
};


export type Subscription_RootTrade_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Buyer_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Buyer_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Buyer_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Buyer_Gst_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Buyer_Gst_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Expense_TaxArgs = {
  distinct_on?: InputMaybe<Array<Trade_Expense_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Expense_Tax_Order_By>>;
  where?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
};


export type Subscription_RootTrade_Expense_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Expense_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Expense_Tax_Order_By>>;
  where?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
};


export type Subscription_RootTrade_Expense_Tax_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Expense_Tax_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Expense_Tax_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
};


export type Subscription_RootTrade_IssuancenoteitemsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


export type Subscription_RootTrade_Issuancenoteitems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


export type Subscription_RootTrade_Issuancenoteitems_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Issuancenoteitems_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Issuancenoteitems_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Issuancenoteitems_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Issuancenoteitems_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Issuancenoteitems_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Issuancenoteitems_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Issuancenoteitems_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


export type Subscription_RootTrade_ItemArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Subscription_RootTrade_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Subscription_RootTrade_Item_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Item_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Item_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Item_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Item_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Item_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


export type Subscription_RootTrade_Seller_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Seller_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_Seller_Gst_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Seller_Gst_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Seller_Gst_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};


export type Subscription_RootTrade_StatusArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Order_By>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Subscription_RootTrade_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Order_By>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Subscription_RootTrade_Status_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTrade_Status_ParentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


export type Subscription_RootTrade_Status_Parents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


export type Subscription_RootTrade_Status_Parents_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Status_Parents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Status_Parents_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


export type Subscription_RootTrade_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Status_Bool_Exp>;
};


export type Subscription_RootTrade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


export type Subscription_RootTrade_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


export type Subscription_RootTrade_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


export type Subscription_RootTrade_Taxes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Taxes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Taxes_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


export type Subscription_RootTrade_TradestatusaccessArgs = {
  distinct_on?: InputMaybe<Array<Trade_Tradestatusaccess_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Tradestatusaccess_Order_By>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};


export type Subscription_RootTrade_Tradestatusaccess_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTrade_Tradestatusaccess_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Tradestatusaccess_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};


export type Subscription_RootTrade_TwiliomessagesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Twiliomessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Twiliomessages_Order_By>>;
  where?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
};


export type Subscription_RootTrade_Twiliomessages_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTrade_Twiliomessages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trade_Twiliomessages_Stream_Cursor_Input>>;
  where?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
};


export type Subscription_RootTransactionArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


export type Subscription_RootTransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


export type Subscription_RootTransaction_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};


export type Subscription_RootTransaction_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};


export type Subscription_RootTransaction_Attachments_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTransaction_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transaction_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};


export type Subscription_RootTransaction_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTransaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


export type Subscription_RootTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Order_By>>;
  where?: InputMaybe<Transactions_Bool_Exp>;
};


export type Subscription_RootTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Order_By>>;
  where?: InputMaybe<Transactions_Bool_Exp>;
};


export type Subscription_RootTransactions_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Attachments_Order_By>>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};


export type Subscription_RootTransactions_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Attachments_Order_By>>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};


export type Subscription_RootTransactions_Attachments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTransactions_Attachments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transactions_Attachments_Stream_Cursor_Input>>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};


export type Subscription_RootTransactions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTransactions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Transactions_Bool_Exp>;
};


export type Subscription_RootTransitionArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


export type Subscription_RootTransition_AccessArgs = {
  distinct_on?: InputMaybe<Array<Transition_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Access_Order_By>>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};


export type Subscription_RootTransition_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Access_Order_By>>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};


export type Subscription_RootTransition_Access_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTransition_Access_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transition_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};


export type Subscription_RootTransition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


export type Subscription_RootTransition_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTransition_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


export type Subscription_RootTransition_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


export type Subscription_RootTransition_History_AttributeArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Attribute_Order_By>>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};


export type Subscription_RootTransition_History_Attribute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Attribute_Order_By>>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};


export type Subscription_RootTransition_History_Attribute_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTransition_History_Attribute_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transition_History_Attribute_Stream_Cursor_Input>>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};


export type Subscription_RootTransition_History_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootTransition_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transition_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


export type Subscription_RootTransition_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transition_Stream_Cursor_Input>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


export type Subscription_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUnit_MeasureArgs = {
  distinct_on?: InputMaybe<Array<Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Measure_Order_By>>;
  where?: InputMaybe<Unit_Measure_Bool_Exp>;
};


export type Subscription_RootUnit_Measure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Measure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Measure_Order_By>>;
  where?: InputMaybe<Unit_Measure_Bool_Exp>;
};


export type Subscription_RootUnit_Measure_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUnit_Measure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Measure_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Measure_Bool_Exp>;
};


export type Subscription_RootUnit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnregistered_UserArgs = {
  distinct_on?: InputMaybe<Array<Unregistered_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unregistered_User_Order_By>>;
  where?: InputMaybe<Unregistered_User_Bool_Exp>;
};


export type Subscription_RootUnregistered_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unregistered_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unregistered_User_Order_By>>;
  where?: InputMaybe<Unregistered_User_Bool_Exp>;
};


export type Subscription_RootUnregistered_User_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUnregistered_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unregistered_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Unregistered_User_Bool_Exp>;
};


export type Subscription_RootVariety_AgreementArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_Agreement_Co_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_Agreement_Co_Owners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_Agreement_Co_Owners_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Agreement_Agreement_Co_Owners_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Agreement_Agreement_Co_Owners_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Agreement_Guarantor_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_Guarantor_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_Guarantor_Agreements_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Agreement_Guarantor_Agreements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Agreement_Guarantor_Agreements_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


export type Subscription_RootVariety_Agreement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Agreement_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Agreement_Bool_Exp>;
};


export type Subscription_RootVariety_GradeArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Order_By>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Grade_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_Photos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_Photos_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Grade_Photos_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Grade_Photos_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


export type Subscription_RootVariety_Grade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Grade_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};


export type Subscription_RootVariety_GroupArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Subscription_RootVariety_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Group_Order_By>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Subscription_RootVariety_Group_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVariety_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Variety_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};


export type Subscription_RootVt_Core_TaxArgs = {
  distinct_on?: InputMaybe<Array<Vt_Core_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vt_Core_Tax_Order_By>>;
  where?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
};


export type Subscription_RootVt_Core_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vt_Core_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vt_Core_Tax_Order_By>>;
  where?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
};


export type Subscription_RootVt_Core_Tax_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVt_Core_Tax_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vt_Core_Tax_Stream_Cursor_Input>>;
  where?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
};


export type Subscription_RootWeather_ReferenceArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Subscription_RootWeather_Reference_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Weather_Reference_Order_By>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Subscription_RootWeather_Reference_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWeather_Reference_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Weather_Reference_Stream_Cursor_Input>>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};


export type Subscription_RootWorkflowArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Subscription_RootWorkflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Subscription_RootWorkflow_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootWorkflow_Current_LogsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


export type Subscription_RootWorkflow_Current_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


export type Subscription_RootWorkflow_Current_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWorkflow_Current_Logs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Workflow_Current_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


export type Subscription_RootWorkflow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Workflow_Stream_Cursor_Input>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Subscription_RootWorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflows_Order_By>>;
  where?: InputMaybe<Workflows_Bool_Exp>;
};


export type Subscription_RootWorkflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflows_Order_By>>;
  where?: InputMaybe<Workflows_Bool_Exp>;
};


export type Subscription_RootWorkflows_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWorkflows_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Workflows_Stream_Cursor_Input>>;
  where?: InputMaybe<Workflows_Bool_Exp>;
};

/** columns and relationships of "survey_parameters" */
export type Survey_Parameters = {
  __typename?: 'survey_parameters';
  codename: Scalars['String'];
  creatable_options: Scalars['Boolean'];
  disabled: Scalars['Boolean'];
  group?: Maybe<Scalars['String']>;
  group_icon?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_required: Scalars['Boolean'];
  label: Scalars['String'];
  max_attachments: Scalars['smallint'];
  metadata?: Maybe<Scalars['jsonb']>;
  min_attachments: Scalars['smallint'];
  options?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  /** An array relationship */
  response_items: Array<Survey_Response_Items>;
  /** An aggregate relationship */
  response_items_aggregate: Survey_Response_Items_Aggregate;
  sequence_no: Scalars['smallint'];
  sub_group?: Maybe<Scalars['String']>;
  sub_group_icon?: Maybe<Scalars['String']>;
  /** An object relationship */
  survey: Surveys;
  survey_id: Scalars['Int'];
  type: Scalars['String'];
  validation_regex?: Maybe<Scalars['String']>;
};


/** columns and relationships of "survey_parameters" */
export type Survey_ParametersMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "survey_parameters" */
export type Survey_ParametersResponse_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


/** columns and relationships of "survey_parameters" */
export type Survey_ParametersResponse_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};

/** aggregated selection of "survey_parameters" */
export type Survey_Parameters_Aggregate = {
  __typename?: 'survey_parameters_aggregate';
  aggregate?: Maybe<Survey_Parameters_Aggregate_Fields>;
  nodes: Array<Survey_Parameters>;
};

/** aggregate fields of "survey_parameters" */
export type Survey_Parameters_Aggregate_Fields = {
  __typename?: 'survey_parameters_aggregate_fields';
  avg?: Maybe<Survey_Parameters_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Survey_Parameters_Max_Fields>;
  min?: Maybe<Survey_Parameters_Min_Fields>;
  stddev?: Maybe<Survey_Parameters_Stddev_Fields>;
  stddev_pop?: Maybe<Survey_Parameters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Survey_Parameters_Stddev_Samp_Fields>;
  sum?: Maybe<Survey_Parameters_Sum_Fields>;
  var_pop?: Maybe<Survey_Parameters_Var_Pop_Fields>;
  var_samp?: Maybe<Survey_Parameters_Var_Samp_Fields>;
  variance?: Maybe<Survey_Parameters_Variance_Fields>;
};


/** aggregate fields of "survey_parameters" */
export type Survey_Parameters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Survey_Parameters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "survey_parameters" */
export type Survey_Parameters_Aggregate_Order_By = {
  avg?: InputMaybe<Survey_Parameters_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Survey_Parameters_Max_Order_By>;
  min?: InputMaybe<Survey_Parameters_Min_Order_By>;
  stddev?: InputMaybe<Survey_Parameters_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Survey_Parameters_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Survey_Parameters_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Survey_Parameters_Sum_Order_By>;
  var_pop?: InputMaybe<Survey_Parameters_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Survey_Parameters_Var_Samp_Order_By>;
  variance?: InputMaybe<Survey_Parameters_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Survey_Parameters_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "survey_parameters" */
export type Survey_Parameters_Arr_Rel_Insert_Input = {
  data: Array<Survey_Parameters_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Survey_Parameters_On_Conflict>;
};

/** aggregate avg on columns */
export type Survey_Parameters_Avg_Fields = {
  __typename?: 'survey_parameters_avg_fields';
  id?: Maybe<Scalars['Float']>;
  max_attachments?: Maybe<Scalars['Float']>;
  min_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "survey_parameters" */
export type Survey_Parameters_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "survey_parameters". All fields are combined with a logical 'AND'. */
export type Survey_Parameters_Bool_Exp = {
  _and?: InputMaybe<Array<Survey_Parameters_Bool_Exp>>;
  _not?: InputMaybe<Survey_Parameters_Bool_Exp>;
  _or?: InputMaybe<Array<Survey_Parameters_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  creatable_options?: InputMaybe<Boolean_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  group_icon?: InputMaybe<String_Comparison_Exp>;
  helper_text?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_required?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  max_attachments?: InputMaybe<Smallint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  min_attachments?: InputMaybe<Smallint_Comparison_Exp>;
  options?: InputMaybe<String_Comparison_Exp>;
  query?: InputMaybe<String_Comparison_Exp>;
  response_items?: InputMaybe<Survey_Response_Items_Bool_Exp>;
  sequence_no?: InputMaybe<Smallint_Comparison_Exp>;
  sub_group?: InputMaybe<String_Comparison_Exp>;
  sub_group_icon?: InputMaybe<String_Comparison_Exp>;
  survey?: InputMaybe<Surveys_Bool_Exp>;
  survey_id?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  validation_regex?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "survey_parameters" */
export enum Survey_Parameters_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SurveyParametersCodenameKey = 'survey_parameters_codename_key',
  /** unique or primary key constraint on columns "id" */
  SurveyParametersPkey = 'survey_parameters_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Survey_Parameters_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Survey_Parameters_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Survey_Parameters_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "survey_parameters" */
export type Survey_Parameters_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  max_attachments?: InputMaybe<Scalars['smallint']>;
  min_attachments?: InputMaybe<Scalars['smallint']>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  survey_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "survey_parameters" */
export type Survey_Parameters_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  creatable_options?: InputMaybe<Scalars['Boolean']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Scalars['String']>;
  group_icon?: InputMaybe<Scalars['String']>;
  helper_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  max_attachments?: InputMaybe<Scalars['smallint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  min_attachments?: InputMaybe<Scalars['smallint']>;
  options?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  response_items?: InputMaybe<Survey_Response_Items_Arr_Rel_Insert_Input>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  sub_group?: InputMaybe<Scalars['String']>;
  sub_group_icon?: InputMaybe<Scalars['String']>;
  survey?: InputMaybe<Surveys_Obj_Rel_Insert_Input>;
  survey_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  validation_regex?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Survey_Parameters_Max_Fields = {
  __typename?: 'survey_parameters_max_fields';
  codename?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  group_icon?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  max_attachments?: Maybe<Scalars['smallint']>;
  min_attachments?: Maybe<Scalars['smallint']>;
  options?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['smallint']>;
  sub_group?: Maybe<Scalars['String']>;
  sub_group_icon?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  validation_regex?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "survey_parameters" */
export type Survey_Parameters_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_icon?: InputMaybe<Order_By>;
  helper_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  sub_group_icon?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  validation_regex?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Survey_Parameters_Min_Fields = {
  __typename?: 'survey_parameters_min_fields';
  codename?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  group_icon?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  max_attachments?: Maybe<Scalars['smallint']>;
  min_attachments?: Maybe<Scalars['smallint']>;
  options?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['smallint']>;
  sub_group?: Maybe<Scalars['String']>;
  sub_group_icon?: Maybe<Scalars['String']>;
  survey_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  validation_regex?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "survey_parameters" */
export type Survey_Parameters_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_icon?: InputMaybe<Order_By>;
  helper_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  sub_group_icon?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  validation_regex?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "survey_parameters" */
export type Survey_Parameters_Mutation_Response = {
  __typename?: 'survey_parameters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Survey_Parameters>;
};

/** input type for inserting object relation for remote table "survey_parameters" */
export type Survey_Parameters_Obj_Rel_Insert_Input = {
  data: Survey_Parameters_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Survey_Parameters_On_Conflict>;
};

/** on_conflict condition type for table "survey_parameters" */
export type Survey_Parameters_On_Conflict = {
  constraint: Survey_Parameters_Constraint;
  update_columns?: Array<Survey_Parameters_Update_Column>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};

/** Ordering options when selecting data from "survey_parameters". */
export type Survey_Parameters_Order_By = {
  codename?: InputMaybe<Order_By>;
  creatable_options?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_icon?: InputMaybe<Order_By>;
  helper_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_required?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  response_items_aggregate?: InputMaybe<Survey_Response_Items_Aggregate_Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  sub_group_icon?: InputMaybe<Order_By>;
  survey?: InputMaybe<Surveys_Order_By>;
  survey_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  validation_regex?: InputMaybe<Order_By>;
};

/** primary key columns input for table: survey_parameters */
export type Survey_Parameters_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Survey_Parameters_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "survey_parameters" */
export enum Survey_Parameters_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatableOptions = 'creatable_options',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Group = 'group',
  /** column name */
  GroupIcon = 'group_icon',
  /** column name */
  HelperText = 'helper_text',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequired = 'is_required',
  /** column name */
  Label = 'label',
  /** column name */
  MaxAttachments = 'max_attachments',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinAttachments = 'min_attachments',
  /** column name */
  Options = 'options',
  /** column name */
  Query = 'query',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  SubGroup = 'sub_group',
  /** column name */
  SubGroupIcon = 'sub_group_icon',
  /** column name */
  SurveyId = 'survey_id',
  /** column name */
  Type = 'type',
  /** column name */
  ValidationRegex = 'validation_regex'
}

/** input type for updating data in table "survey_parameters" */
export type Survey_Parameters_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  creatable_options?: InputMaybe<Scalars['Boolean']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Scalars['String']>;
  group_icon?: InputMaybe<Scalars['String']>;
  helper_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  max_attachments?: InputMaybe<Scalars['smallint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  min_attachments?: InputMaybe<Scalars['smallint']>;
  options?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  sub_group?: InputMaybe<Scalars['String']>;
  sub_group_icon?: InputMaybe<Scalars['String']>;
  survey_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  validation_regex?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Survey_Parameters_Stddev_Fields = {
  __typename?: 'survey_parameters_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  max_attachments?: Maybe<Scalars['Float']>;
  min_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "survey_parameters" */
export type Survey_Parameters_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Survey_Parameters_Stddev_Pop_Fields = {
  __typename?: 'survey_parameters_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_attachments?: Maybe<Scalars['Float']>;
  min_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "survey_parameters" */
export type Survey_Parameters_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Survey_Parameters_Stddev_Samp_Fields = {
  __typename?: 'survey_parameters_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_attachments?: Maybe<Scalars['Float']>;
  min_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "survey_parameters" */
export type Survey_Parameters_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "survey_parameters" */
export type Survey_Parameters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Survey_Parameters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Survey_Parameters_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  creatable_options?: InputMaybe<Scalars['Boolean']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Scalars['String']>;
  group_icon?: InputMaybe<Scalars['String']>;
  helper_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_required?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  max_attachments?: InputMaybe<Scalars['smallint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  min_attachments?: InputMaybe<Scalars['smallint']>;
  options?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sequence_no?: InputMaybe<Scalars['smallint']>;
  sub_group?: InputMaybe<Scalars['String']>;
  sub_group_icon?: InputMaybe<Scalars['String']>;
  survey_id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  validation_regex?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Survey_Parameters_Sum_Fields = {
  __typename?: 'survey_parameters_sum_fields';
  id?: Maybe<Scalars['Int']>;
  max_attachments?: Maybe<Scalars['smallint']>;
  min_attachments?: Maybe<Scalars['smallint']>;
  sequence_no?: Maybe<Scalars['smallint']>;
  survey_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "survey_parameters" */
export type Survey_Parameters_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** update columns of table "survey_parameters" */
export enum Survey_Parameters_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatableOptions = 'creatable_options',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Group = 'group',
  /** column name */
  GroupIcon = 'group_icon',
  /** column name */
  HelperText = 'helper_text',
  /** column name */
  Id = 'id',
  /** column name */
  IsRequired = 'is_required',
  /** column name */
  Label = 'label',
  /** column name */
  MaxAttachments = 'max_attachments',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MinAttachments = 'min_attachments',
  /** column name */
  Options = 'options',
  /** column name */
  Query = 'query',
  /** column name */
  SequenceNo = 'sequence_no',
  /** column name */
  SubGroup = 'sub_group',
  /** column name */
  SubGroupIcon = 'sub_group_icon',
  /** column name */
  SurveyId = 'survey_id',
  /** column name */
  Type = 'type',
  /** column name */
  ValidationRegex = 'validation_regex'
}

export type Survey_Parameters_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Survey_Parameters_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Survey_Parameters_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Survey_Parameters_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Survey_Parameters_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Survey_Parameters_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Survey_Parameters_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Survey_Parameters_Set_Input>;
  where: Survey_Parameters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Survey_Parameters_Var_Pop_Fields = {
  __typename?: 'survey_parameters_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_attachments?: Maybe<Scalars['Float']>;
  min_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "survey_parameters" */
export type Survey_Parameters_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Survey_Parameters_Var_Samp_Fields = {
  __typename?: 'survey_parameters_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_attachments?: Maybe<Scalars['Float']>;
  min_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "survey_parameters" */
export type Survey_Parameters_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Survey_Parameters_Variance_Fields = {
  __typename?: 'survey_parameters_variance_fields';
  id?: Maybe<Scalars['Float']>;
  max_attachments?: Maybe<Scalars['Float']>;
  min_attachments?: Maybe<Scalars['Float']>;
  sequence_no?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "survey_parameters" */
export type Survey_Parameters_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  max_attachments?: InputMaybe<Order_By>;
  min_attachments?: InputMaybe<Order_By>;
  sequence_no?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "survey_response_items" */
export type Survey_Response_Items = {
  __typename?: 'survey_response_items';
  created_at: Scalars['timestamptz'];
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  parameter: Survey_Parameters;
  /** An object relationship */
  response: Survey_Responses;
  response_id: Scalars['Int'];
  sub_group?: Maybe<Scalars['String']>;
  survey_parameter_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  value: Scalars['String'];
};

/** aggregated selection of "survey_response_items" */
export type Survey_Response_Items_Aggregate = {
  __typename?: 'survey_response_items_aggregate';
  aggregate?: Maybe<Survey_Response_Items_Aggregate_Fields>;
  nodes: Array<Survey_Response_Items>;
};

/** aggregate fields of "survey_response_items" */
export type Survey_Response_Items_Aggregate_Fields = {
  __typename?: 'survey_response_items_aggregate_fields';
  avg?: Maybe<Survey_Response_Items_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Survey_Response_Items_Max_Fields>;
  min?: Maybe<Survey_Response_Items_Min_Fields>;
  stddev?: Maybe<Survey_Response_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Survey_Response_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Survey_Response_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Survey_Response_Items_Sum_Fields>;
  var_pop?: Maybe<Survey_Response_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Survey_Response_Items_Var_Samp_Fields>;
  variance?: Maybe<Survey_Response_Items_Variance_Fields>;
};


/** aggregate fields of "survey_response_items" */
export type Survey_Response_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "survey_response_items" */
export type Survey_Response_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Survey_Response_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Survey_Response_Items_Max_Order_By>;
  min?: InputMaybe<Survey_Response_Items_Min_Order_By>;
  stddev?: InputMaybe<Survey_Response_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Survey_Response_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Survey_Response_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Survey_Response_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Survey_Response_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Survey_Response_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Survey_Response_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "survey_response_items" */
export type Survey_Response_Items_Arr_Rel_Insert_Input = {
  data: Array<Survey_Response_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Survey_Response_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Survey_Response_Items_Avg_Fields = {
  __typename?: 'survey_response_items_avg_fields';
  id?: Maybe<Scalars['Float']>;
  response_id?: Maybe<Scalars['Float']>;
  survey_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "survey_response_items" */
export type Survey_Response_Items_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "survey_response_items". All fields are combined with a logical 'AND'. */
export type Survey_Response_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Survey_Response_Items_Bool_Exp>>;
  _not?: InputMaybe<Survey_Response_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Survey_Response_Items_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  parameter?: InputMaybe<Survey_Parameters_Bool_Exp>;
  response?: InputMaybe<Survey_Responses_Bool_Exp>;
  response_id?: InputMaybe<Int_Comparison_Exp>;
  sub_group?: InputMaybe<String_Comparison_Exp>;
  survey_parameter_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "survey_response_items" */
export enum Survey_Response_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  SurveyResponseItemsPkey = 'survey_response_items_pkey'
}

/** input type for incrementing numeric columns in table "survey_response_items" */
export type Survey_Response_Items_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  response_id?: InputMaybe<Scalars['Int']>;
  survey_parameter_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "survey_response_items" */
export type Survey_Response_Items_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  parameter?: InputMaybe<Survey_Parameters_Obj_Rel_Insert_Input>;
  response?: InputMaybe<Survey_Responses_Obj_Rel_Insert_Input>;
  response_id?: InputMaybe<Scalars['Int']>;
  sub_group?: InputMaybe<Scalars['String']>;
  survey_parameter_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Survey_Response_Items_Max_Fields = {
  __typename?: 'survey_response_items_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  response_id?: Maybe<Scalars['Int']>;
  sub_group?: Maybe<Scalars['String']>;
  survey_parameter_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "survey_response_items" */
export type Survey_Response_Items_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Survey_Response_Items_Min_Fields = {
  __typename?: 'survey_response_items_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  response_id?: Maybe<Scalars['Int']>;
  sub_group?: Maybe<Scalars['String']>;
  survey_parameter_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "survey_response_items" */
export type Survey_Response_Items_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "survey_response_items" */
export type Survey_Response_Items_Mutation_Response = {
  __typename?: 'survey_response_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Survey_Response_Items>;
};

/** on_conflict condition type for table "survey_response_items" */
export type Survey_Response_Items_On_Conflict = {
  constraint: Survey_Response_Items_Constraint;
  update_columns?: Array<Survey_Response_Items_Update_Column>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "survey_response_items". */
export type Survey_Response_Items_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameter?: InputMaybe<Survey_Parameters_Order_By>;
  response?: InputMaybe<Survey_Responses_Order_By>;
  response_id?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: survey_response_items */
export type Survey_Response_Items_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "survey_response_items" */
export enum Survey_Response_Items_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  ResponseId = 'response_id',
  /** column name */
  SubGroup = 'sub_group',
  /** column name */
  SurveyParameterId = 'survey_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "survey_response_items" */
export type Survey_Response_Items_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  response_id?: InputMaybe<Scalars['Int']>;
  sub_group?: InputMaybe<Scalars['String']>;
  survey_parameter_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Survey_Response_Items_Stddev_Fields = {
  __typename?: 'survey_response_items_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  response_id?: Maybe<Scalars['Float']>;
  survey_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "survey_response_items" */
export type Survey_Response_Items_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Survey_Response_Items_Stddev_Pop_Fields = {
  __typename?: 'survey_response_items_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  response_id?: Maybe<Scalars['Float']>;
  survey_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "survey_response_items" */
export type Survey_Response_Items_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Survey_Response_Items_Stddev_Samp_Fields = {
  __typename?: 'survey_response_items_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  response_id?: Maybe<Scalars['Float']>;
  survey_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "survey_response_items" */
export type Survey_Response_Items_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "survey_response_items" */
export type Survey_Response_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Survey_Response_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Survey_Response_Items_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  response_id?: InputMaybe<Scalars['Int']>;
  sub_group?: InputMaybe<Scalars['String']>;
  survey_parameter_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Survey_Response_Items_Sum_Fields = {
  __typename?: 'survey_response_items_sum_fields';
  id?: Maybe<Scalars['Int']>;
  response_id?: Maybe<Scalars['Int']>;
  survey_parameter_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "survey_response_items" */
export type Survey_Response_Items_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** update columns of table "survey_response_items" */
export enum Survey_Response_Items_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  ResponseId = 'response_id',
  /** column name */
  SubGroup = 'sub_group',
  /** column name */
  SurveyParameterId = 'survey_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Survey_Response_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Survey_Response_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Survey_Response_Items_Set_Input>;
  where: Survey_Response_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Survey_Response_Items_Var_Pop_Fields = {
  __typename?: 'survey_response_items_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  response_id?: Maybe<Scalars['Float']>;
  survey_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "survey_response_items" */
export type Survey_Response_Items_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Survey_Response_Items_Var_Samp_Fields = {
  __typename?: 'survey_response_items_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  response_id?: Maybe<Scalars['Float']>;
  survey_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "survey_response_items" */
export type Survey_Response_Items_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Survey_Response_Items_Variance_Fields = {
  __typename?: 'survey_response_items_variance_fields';
  id?: Maybe<Scalars['Float']>;
  response_id?: Maybe<Scalars['Float']>;
  survey_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "survey_response_items" */
export type Survey_Response_Items_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  response_id?: InputMaybe<Order_By>;
  survey_parameter_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "survey_responses" */
export type Survey_Responses = {
  __typename?: 'survey_responses';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<Base_User>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  current_logs: Array<Workflow_Current_Logs>;
  /** An aggregate relationship */
  current_logs_aggregate: Workflow_Current_Logs_Aggregate;
  entity_codename?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An array relationship */
  items: Array<Survey_Response_Items>;
  /** An aggregate relationship */
  items_aggregate: Survey_Response_Items_Aggregate;
  /** An array relationship */
  logs: Array<Stage_Logs>;
  /** An aggregate relationship */
  logs_aggregate: Stage_Logs_Aggregate;
  /** An object relationship */
  survey: Surveys;
  survey_id: Scalars['Int'];
  /** An object relationship */
  survey_year?: Maybe<Survey_Year>;
  survey_year_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Survey_Users>;
  user_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "survey_responses" */
export type Survey_ResponsesCurrent_LogsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


/** columns and relationships of "survey_responses" */
export type Survey_ResponsesCurrent_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


/** columns and relationships of "survey_responses" */
export type Survey_ResponsesItemsArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


/** columns and relationships of "survey_responses" */
export type Survey_ResponsesItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Response_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Response_Items_Order_By>>;
  where?: InputMaybe<Survey_Response_Items_Bool_Exp>;
};


/** columns and relationships of "survey_responses" */
export type Survey_ResponsesLogsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


/** columns and relationships of "survey_responses" */
export type Survey_ResponsesLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};

/** aggregated selection of "survey_responses" */
export type Survey_Responses_Aggregate = {
  __typename?: 'survey_responses_aggregate';
  aggregate?: Maybe<Survey_Responses_Aggregate_Fields>;
  nodes: Array<Survey_Responses>;
};

/** aggregate fields of "survey_responses" */
export type Survey_Responses_Aggregate_Fields = {
  __typename?: 'survey_responses_aggregate_fields';
  avg?: Maybe<Survey_Responses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Survey_Responses_Max_Fields>;
  min?: Maybe<Survey_Responses_Min_Fields>;
  stddev?: Maybe<Survey_Responses_Stddev_Fields>;
  stddev_pop?: Maybe<Survey_Responses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Survey_Responses_Stddev_Samp_Fields>;
  sum?: Maybe<Survey_Responses_Sum_Fields>;
  var_pop?: Maybe<Survey_Responses_Var_Pop_Fields>;
  var_samp?: Maybe<Survey_Responses_Var_Samp_Fields>;
  variance?: Maybe<Survey_Responses_Variance_Fields>;
};


/** aggregate fields of "survey_responses" */
export type Survey_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "survey_responses" */
export type Survey_Responses_Aggregate_Order_By = {
  avg?: InputMaybe<Survey_Responses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Survey_Responses_Max_Order_By>;
  min?: InputMaybe<Survey_Responses_Min_Order_By>;
  stddev?: InputMaybe<Survey_Responses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Survey_Responses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Survey_Responses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Survey_Responses_Sum_Order_By>;
  var_pop?: InputMaybe<Survey_Responses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Survey_Responses_Var_Samp_Order_By>;
  variance?: InputMaybe<Survey_Responses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "survey_responses" */
export type Survey_Responses_Arr_Rel_Insert_Input = {
  data: Array<Survey_Responses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Survey_Responses_On_Conflict>;
};

/** aggregate avg on columns */
export type Survey_Responses_Avg_Fields = {
  __typename?: 'survey_responses_avg_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
  survey_year_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "survey_responses" */
export type Survey_Responses_Avg_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "survey_responses". All fields are combined with a logical 'AND'. */
export type Survey_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Survey_Responses_Bool_Exp>>;
  _not?: InputMaybe<Survey_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Survey_Responses_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Base_User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Int_Comparison_Exp>;
  current_logs?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
  entity_codename?: InputMaybe<String_Comparison_Exp>;
  entity_id?: InputMaybe<Bigint_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  items?: InputMaybe<Survey_Response_Items_Bool_Exp>;
  logs?: InputMaybe<Stage_Logs_Bool_Exp>;
  survey?: InputMaybe<Surveys_Bool_Exp>;
  survey_id?: InputMaybe<Int_Comparison_Exp>;
  survey_year?: InputMaybe<Survey_Year_Bool_Exp>;
  survey_year_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Survey_Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "survey_responses" */
export enum Survey_Responses_Constraint {
  /** unique or primary key constraint on columns "codename" */
  SurveyResponsesCodenameEc38f921Uniq = 'survey_responses_codename_ec38f921_uniq',
  /** unique or primary key constraint on columns "id" */
  SurveyResponsesPkey = 'survey_responses_pkey'
}

/** input type for incrementing numeric columns in table "survey_responses" */
export type Survey_Responses_Inc_Input = {
  created_by_user_id?: InputMaybe<Scalars['Int']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['Int']>;
  survey_id?: InputMaybe<Scalars['Int']>;
  survey_year_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "survey_responses" */
export type Survey_Responses_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['Int']>;
  current_logs?: InputMaybe<Workflow_Current_Logs_Arr_Rel_Insert_Input>;
  entity_codename?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  items?: InputMaybe<Survey_Response_Items_Arr_Rel_Insert_Input>;
  logs?: InputMaybe<Stage_Logs_Arr_Rel_Insert_Input>;
  survey?: InputMaybe<Surveys_Obj_Rel_Insert_Input>;
  survey_id?: InputMaybe<Scalars['Int']>;
  survey_year?: InputMaybe<Survey_Year_Obj_Rel_Insert_Input>;
  survey_year_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Survey_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Survey_Responses_Max_Fields = {
  __typename?: 'survey_responses_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  entity_codename?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  survey_id?: Maybe<Scalars['Int']>;
  survey_year_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "survey_responses" */
export type Survey_Responses_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Survey_Responses_Min_Fields = {
  __typename?: 'survey_responses_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_user_id?: Maybe<Scalars['Int']>;
  entity_codename?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['bigint']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  survey_id?: Maybe<Scalars['Int']>;
  survey_year_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "survey_responses" */
export type Survey_Responses_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "survey_responses" */
export type Survey_Responses_Mutation_Response = {
  __typename?: 'survey_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Survey_Responses>;
};

/** input type for inserting object relation for remote table "survey_responses" */
export type Survey_Responses_Obj_Rel_Insert_Input = {
  data: Survey_Responses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Survey_Responses_On_Conflict>;
};

/** on_conflict condition type for table "survey_responses" */
export type Survey_Responses_On_Conflict = {
  constraint: Survey_Responses_Constraint;
  update_columns?: Array<Survey_Responses_Update_Column>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "survey_responses". */
export type Survey_Responses_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Base_User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  current_logs_aggregate?: InputMaybe<Workflow_Current_Logs_Aggregate_Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Survey_Response_Items_Aggregate_Order_By>;
  logs_aggregate?: InputMaybe<Stage_Logs_Aggregate_Order_By>;
  survey?: InputMaybe<Surveys_Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year?: InputMaybe<Survey_Year_Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Survey_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: survey_responses */
export type Survey_Responses_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "survey_responses" */
export enum Survey_Responses_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  EntityCodename = 'entity_codename',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  SurveyId = 'survey_id',
  /** column name */
  SurveyYearId = 'survey_year_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "survey_responses" */
export type Survey_Responses_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['Int']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  survey_id?: InputMaybe<Scalars['Int']>;
  survey_year_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Survey_Responses_Stddev_Fields = {
  __typename?: 'survey_responses_stddev_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
  survey_year_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "survey_responses" */
export type Survey_Responses_Stddev_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Survey_Responses_Stddev_Pop_Fields = {
  __typename?: 'survey_responses_stddev_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
  survey_year_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "survey_responses" */
export type Survey_Responses_Stddev_Pop_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Survey_Responses_Stddev_Samp_Fields = {
  __typename?: 'survey_responses_stddev_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
  survey_year_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "survey_responses" */
export type Survey_Responses_Stddev_Samp_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "survey_responses" */
export type Survey_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Survey_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Survey_Responses_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_user_id?: InputMaybe<Scalars['Int']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['bigint']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  survey_id?: InputMaybe<Scalars['Int']>;
  survey_year_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Survey_Responses_Sum_Fields = {
  __typename?: 'survey_responses_sum_fields';
  created_by_user_id?: Maybe<Scalars['Int']>;
  entity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['Int']>;
  survey_id?: Maybe<Scalars['Int']>;
  survey_year_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "survey_responses" */
export type Survey_Responses_Sum_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "survey_responses" */
export enum Survey_Responses_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  EntityCodename = 'entity_codename',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  SurveyId = 'survey_id',
  /** column name */
  SurveyYearId = 'survey_year_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Survey_Responses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Survey_Responses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Survey_Responses_Set_Input>;
  where: Survey_Responses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Survey_Responses_Var_Pop_Fields = {
  __typename?: 'survey_responses_var_pop_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
  survey_year_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "survey_responses" */
export type Survey_Responses_Var_Pop_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Survey_Responses_Var_Samp_Fields = {
  __typename?: 'survey_responses_var_samp_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
  survey_year_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "survey_responses" */
export type Survey_Responses_Var_Samp_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Survey_Responses_Variance_Fields = {
  __typename?: 'survey_responses_variance_fields';
  created_by_user_id?: Maybe<Scalars['Float']>;
  entity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  survey_id?: Maybe<Scalars['Float']>;
  survey_year_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "survey_responses" */
export type Survey_Responses_Variance_Order_By = {
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey_id?: InputMaybe<Order_By>;
  survey_year_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "survey_users" */
export type Survey_Users = {
  __typename?: 'survey_users';
  created_at: Scalars['timestamptz'];
  first_name: Scalars['String'];
  id: Scalars['Int'];
  last_name: Scalars['String'];
  number: Scalars['String'];
  /** An array relationship */
  responses: Array<Survey_Responses>;
  /** An aggregate relationship */
  responses_aggregate: Survey_Responses_Aggregate;
  secondary_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "survey_users" */
export type Survey_UsersResponsesArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


/** columns and relationships of "survey_users" */
export type Survey_UsersResponses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};

/** aggregated selection of "survey_users" */
export type Survey_Users_Aggregate = {
  __typename?: 'survey_users_aggregate';
  aggregate?: Maybe<Survey_Users_Aggregate_Fields>;
  nodes: Array<Survey_Users>;
};

/** aggregate fields of "survey_users" */
export type Survey_Users_Aggregate_Fields = {
  __typename?: 'survey_users_aggregate_fields';
  avg?: Maybe<Survey_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Survey_Users_Max_Fields>;
  min?: Maybe<Survey_Users_Min_Fields>;
  stddev?: Maybe<Survey_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Survey_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Survey_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Survey_Users_Sum_Fields>;
  var_pop?: Maybe<Survey_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Survey_Users_Var_Samp_Fields>;
  variance?: Maybe<Survey_Users_Variance_Fields>;
};


/** aggregate fields of "survey_users" */
export type Survey_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Survey_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Survey_Users_Avg_Fields = {
  __typename?: 'survey_users_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "survey_users". All fields are combined with a logical 'AND'. */
export type Survey_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Survey_Users_Bool_Exp>>;
  _not?: InputMaybe<Survey_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Survey_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  secondary_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "survey_users" */
export enum Survey_Users_Constraint {
  /** unique or primary key constraint on columns "number" */
  SurveyUsersNumberKey = 'survey_users_number_key',
  /** unique or primary key constraint on columns "id" */
  SurveyUsersPkey = 'survey_users_pkey'
}

/** input type for incrementing numeric columns in table "survey_users" */
export type Survey_Users_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "survey_users" */
export type Survey_Users_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  responses?: InputMaybe<Survey_Responses_Arr_Rel_Insert_Input>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Survey_Users_Max_Fields = {
  __typename?: 'survey_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Survey_Users_Min_Fields = {
  __typename?: 'survey_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  secondary_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "survey_users" */
export type Survey_Users_Mutation_Response = {
  __typename?: 'survey_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Survey_Users>;
};

/** input type for inserting object relation for remote table "survey_users" */
export type Survey_Users_Obj_Rel_Insert_Input = {
  data: Survey_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Survey_Users_On_Conflict>;
};

/** on_conflict condition type for table "survey_users" */
export type Survey_Users_On_Conflict = {
  constraint: Survey_Users_Constraint;
  update_columns?: Array<Survey_Users_Update_Column>;
  where?: InputMaybe<Survey_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "survey_users". */
export type Survey_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  responses_aggregate?: InputMaybe<Survey_Responses_Aggregate_Order_By>;
  secondary_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: survey_users */
export type Survey_Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "survey_users" */
export enum Survey_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Number = 'number',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "survey_users" */
export type Survey_Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Survey_Users_Stddev_Fields = {
  __typename?: 'survey_users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Survey_Users_Stddev_Pop_Fields = {
  __typename?: 'survey_users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Survey_Users_Stddev_Samp_Fields = {
  __typename?: 'survey_users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "survey_users" */
export type Survey_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Survey_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Survey_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  secondary_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Survey_Users_Sum_Fields = {
  __typename?: 'survey_users_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "survey_users" */
export enum Survey_Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Number = 'number',
  /** column name */
  SecondaryNumber = 'secondary_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Survey_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Survey_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Survey_Users_Set_Input>;
  where: Survey_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Survey_Users_Var_Pop_Fields = {
  __typename?: 'survey_users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Survey_Users_Var_Samp_Fields = {
  __typename?: 'survey_users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Survey_Users_Variance_Fields = {
  __typename?: 'survey_users_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "survey_year" */
export type Survey_Year = {
  __typename?: 'survey_year';
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  survey_responses: Array<Survey_Responses>;
  /** An aggregate relationship */
  survey_responses_aggregate: Survey_Responses_Aggregate;
};


/** columns and relationships of "survey_year" */
export type Survey_YearSurvey_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


/** columns and relationships of "survey_year" */
export type Survey_YearSurvey_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};

/** aggregated selection of "survey_year" */
export type Survey_Year_Aggregate = {
  __typename?: 'survey_year_aggregate';
  aggregate?: Maybe<Survey_Year_Aggregate_Fields>;
  nodes: Array<Survey_Year>;
};

/** aggregate fields of "survey_year" */
export type Survey_Year_Aggregate_Fields = {
  __typename?: 'survey_year_aggregate_fields';
  avg?: Maybe<Survey_Year_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Survey_Year_Max_Fields>;
  min?: Maybe<Survey_Year_Min_Fields>;
  stddev?: Maybe<Survey_Year_Stddev_Fields>;
  stddev_pop?: Maybe<Survey_Year_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Survey_Year_Stddev_Samp_Fields>;
  sum?: Maybe<Survey_Year_Sum_Fields>;
  var_pop?: Maybe<Survey_Year_Var_Pop_Fields>;
  var_samp?: Maybe<Survey_Year_Var_Samp_Fields>;
  variance?: Maybe<Survey_Year_Variance_Fields>;
};


/** aggregate fields of "survey_year" */
export type Survey_Year_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Survey_Year_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Survey_Year_Avg_Fields = {
  __typename?: 'survey_year_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "survey_year". All fields are combined with a logical 'AND'. */
export type Survey_Year_Bool_Exp = {
  _and?: InputMaybe<Array<Survey_Year_Bool_Exp>>;
  _not?: InputMaybe<Survey_Year_Bool_Exp>;
  _or?: InputMaybe<Array<Survey_Year_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  survey_responses?: InputMaybe<Survey_Responses_Bool_Exp>;
};

/** unique or primary key constraints on table "survey_year" */
export enum Survey_Year_Constraint {
  /** unique or primary key constraint on columns "id" */
  SurveyYearPkey = 'survey_year_pkey'
}

/** input type for incrementing numeric columns in table "survey_year" */
export type Survey_Year_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "survey_year" */
export type Survey_Year_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  survey_responses?: InputMaybe<Survey_Responses_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Survey_Year_Max_Fields = {
  __typename?: 'survey_year_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Survey_Year_Min_Fields = {
  __typename?: 'survey_year_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "survey_year" */
export type Survey_Year_Mutation_Response = {
  __typename?: 'survey_year_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Survey_Year>;
};

/** input type for inserting object relation for remote table "survey_year" */
export type Survey_Year_Obj_Rel_Insert_Input = {
  data: Survey_Year_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Survey_Year_On_Conflict>;
};

/** on_conflict condition type for table "survey_year" */
export type Survey_Year_On_Conflict = {
  constraint: Survey_Year_Constraint;
  update_columns?: Array<Survey_Year_Update_Column>;
  where?: InputMaybe<Survey_Year_Bool_Exp>;
};

/** Ordering options when selecting data from "survey_year". */
export type Survey_Year_Order_By = {
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  survey_responses_aggregate?: InputMaybe<Survey_Responses_Aggregate_Order_By>;
};

/** primary key columns input for table: survey_year */
export type Survey_Year_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "survey_year" */
export enum Survey_Year_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "survey_year" */
export type Survey_Year_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Survey_Year_Stddev_Fields = {
  __typename?: 'survey_year_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Survey_Year_Stddev_Pop_Fields = {
  __typename?: 'survey_year_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Survey_Year_Stddev_Samp_Fields = {
  __typename?: 'survey_year_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "survey_year" */
export type Survey_Year_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Survey_Year_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Survey_Year_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Survey_Year_Sum_Fields = {
  __typename?: 'survey_year_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "survey_year" */
export enum Survey_Year_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Survey_Year_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Survey_Year_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Survey_Year_Set_Input>;
  where: Survey_Year_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Survey_Year_Var_Pop_Fields = {
  __typename?: 'survey_year_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Survey_Year_Var_Samp_Fields = {
  __typename?: 'survey_year_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Survey_Year_Variance_Fields = {
  __typename?: 'survey_year_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "surveys" */
export type Surveys = {
  __typename?: 'surveys';
  cover_image?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object relationship */
  next_survey?: Maybe<Surveys>;
  next_survey_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  parameters: Array<Survey_Parameters>;
  /** An aggregate relationship */
  parameters_aggregate: Survey_Parameters_Aggregate;
  /** An object relationship */
  prev_survey?: Maybe<Surveys>;
  prev_survey_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  responses: Array<Survey_Responses>;
  /** An aggregate relationship */
  responses_aggregate: Survey_Responses_Aggregate;
  slug: Scalars['String'];
  unique_user: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workflow?: Maybe<Workflows>;
  workflow_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "surveys" */
export type SurveysParametersArgs = {
  distinct_on?: InputMaybe<Array<Survey_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Parameters_Order_By>>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};


/** columns and relationships of "surveys" */
export type SurveysParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Parameters_Order_By>>;
  where?: InputMaybe<Survey_Parameters_Bool_Exp>;
};


/** columns and relationships of "surveys" */
export type SurveysResponsesArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};


/** columns and relationships of "surveys" */
export type SurveysResponses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Survey_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Survey_Responses_Order_By>>;
  where?: InputMaybe<Survey_Responses_Bool_Exp>;
};

/** aggregated selection of "surveys" */
export type Surveys_Aggregate = {
  __typename?: 'surveys_aggregate';
  aggregate?: Maybe<Surveys_Aggregate_Fields>;
  nodes: Array<Surveys>;
};

/** aggregate fields of "surveys" */
export type Surveys_Aggregate_Fields = {
  __typename?: 'surveys_aggregate_fields';
  avg?: Maybe<Surveys_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Surveys_Max_Fields>;
  min?: Maybe<Surveys_Min_Fields>;
  stddev?: Maybe<Surveys_Stddev_Fields>;
  stddev_pop?: Maybe<Surveys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Surveys_Stddev_Samp_Fields>;
  sum?: Maybe<Surveys_Sum_Fields>;
  var_pop?: Maybe<Surveys_Var_Pop_Fields>;
  var_samp?: Maybe<Surveys_Var_Samp_Fields>;
  variance?: Maybe<Surveys_Variance_Fields>;
};


/** aggregate fields of "surveys" */
export type Surveys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Surveys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Surveys_Avg_Fields = {
  __typename?: 'surveys_avg_fields';
  id?: Maybe<Scalars['Float']>;
  next_survey_id?: Maybe<Scalars['Float']>;
  prev_survey_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "surveys". All fields are combined with a logical 'AND'. */
export type Surveys_Bool_Exp = {
  _and?: InputMaybe<Array<Surveys_Bool_Exp>>;
  _not?: InputMaybe<Surveys_Bool_Exp>;
  _or?: InputMaybe<Array<Surveys_Bool_Exp>>;
  cover_image?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  next_survey?: InputMaybe<Surveys_Bool_Exp>;
  next_survey_id?: InputMaybe<Int_Comparison_Exp>;
  parameters?: InputMaybe<Survey_Parameters_Bool_Exp>;
  prev_survey?: InputMaybe<Surveys_Bool_Exp>;
  prev_survey_id?: InputMaybe<Int_Comparison_Exp>;
  responses?: InputMaybe<Survey_Responses_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  unique_user?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workflow?: InputMaybe<Workflows_Bool_Exp>;
  workflow_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "surveys" */
export enum Surveys_Constraint {
  /** unique or primary key constraint on columns "id" */
  SurveysPkey = 'surveys_pkey',
  /** unique or primary key constraint on columns "slug" */
  SurveysSlugKey = 'surveys_slug_key'
}

/** input type for incrementing numeric columns in table "surveys" */
export type Surveys_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  next_survey_id?: InputMaybe<Scalars['Int']>;
  prev_survey_id?: InputMaybe<Scalars['Int']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "surveys" */
export type Surveys_Insert_Input = {
  cover_image?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  next_survey?: InputMaybe<Surveys_Obj_Rel_Insert_Input>;
  next_survey_id?: InputMaybe<Scalars['Int']>;
  parameters?: InputMaybe<Survey_Parameters_Arr_Rel_Insert_Input>;
  prev_survey?: InputMaybe<Surveys_Obj_Rel_Insert_Input>;
  prev_survey_id?: InputMaybe<Scalars['Int']>;
  responses?: InputMaybe<Survey_Responses_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']>;
  unique_user?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow?: InputMaybe<Workflows_Obj_Rel_Insert_Input>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Surveys_Max_Fields = {
  __typename?: 'surveys_max_fields';
  cover_image?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  next_survey_id?: Maybe<Scalars['Int']>;
  prev_survey_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Surveys_Min_Fields = {
  __typename?: 'surveys_min_fields';
  cover_image?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  next_survey_id?: Maybe<Scalars['Int']>;
  prev_survey_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "surveys" */
export type Surveys_Mutation_Response = {
  __typename?: 'surveys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Surveys>;
};

/** input type for inserting object relation for remote table "surveys" */
export type Surveys_Obj_Rel_Insert_Input = {
  data: Surveys_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Surveys_On_Conflict>;
};

/** on_conflict condition type for table "surveys" */
export type Surveys_On_Conflict = {
  constraint: Surveys_Constraint;
  update_columns?: Array<Surveys_Update_Column>;
  where?: InputMaybe<Surveys_Bool_Exp>;
};

/** Ordering options when selecting data from "surveys". */
export type Surveys_Order_By = {
  cover_image?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_survey?: InputMaybe<Surveys_Order_By>;
  next_survey_id?: InputMaybe<Order_By>;
  parameters_aggregate?: InputMaybe<Survey_Parameters_Aggregate_Order_By>;
  prev_survey?: InputMaybe<Surveys_Order_By>;
  prev_survey_id?: InputMaybe<Order_By>;
  responses_aggregate?: InputMaybe<Survey_Responses_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  unique_user?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow?: InputMaybe<Workflows_Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: surveys */
export type Surveys_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "surveys" */
export enum Surveys_Select_Column {
  /** column name */
  CoverImage = 'cover_image',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  NextSurveyId = 'next_survey_id',
  /** column name */
  PrevSurveyId = 'prev_survey_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UniqueUser = 'unique_user',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "surveys" */
export type Surveys_Set_Input = {
  cover_image?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  next_survey_id?: InputMaybe<Scalars['Int']>;
  prev_survey_id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  unique_user?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Surveys_Stddev_Fields = {
  __typename?: 'surveys_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  next_survey_id?: Maybe<Scalars['Float']>;
  prev_survey_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Surveys_Stddev_Pop_Fields = {
  __typename?: 'surveys_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  next_survey_id?: Maybe<Scalars['Float']>;
  prev_survey_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Surveys_Stddev_Samp_Fields = {
  __typename?: 'surveys_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  next_survey_id?: Maybe<Scalars['Float']>;
  prev_survey_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "surveys" */
export type Surveys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Surveys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Surveys_Stream_Cursor_Value_Input = {
  cover_image?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  next_survey_id?: InputMaybe<Scalars['Int']>;
  prev_survey_id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  unique_user?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Surveys_Sum_Fields = {
  __typename?: 'surveys_sum_fields';
  id?: Maybe<Scalars['Int']>;
  next_survey_id?: Maybe<Scalars['Int']>;
  prev_survey_id?: Maybe<Scalars['Int']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "surveys" */
export enum Surveys_Update_Column {
  /** column name */
  CoverImage = 'cover_image',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  NextSurveyId = 'next_survey_id',
  /** column name */
  PrevSurveyId = 'prev_survey_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  UniqueUser = 'unique_user',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

export type Surveys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Surveys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Surveys_Set_Input>;
  where: Surveys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Surveys_Var_Pop_Fields = {
  __typename?: 'surveys_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  next_survey_id?: Maybe<Scalars['Float']>;
  prev_survey_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Surveys_Var_Samp_Fields = {
  __typename?: 'surveys_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  next_survey_id?: Maybe<Scalars['Float']>;
  prev_survey_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Surveys_Variance_Fields = {
  __typename?: 'surveys_variance_fields';
  id?: Maybe<Scalars['Float']>;
  next_survey_id?: Maybe<Scalars['Float']>;
  prev_survey_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "template" */
export type Template = {
  __typename?: 'template';
  brand_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  category: Template_Category;
  category_id: Scalars['bigint'];
  codename: Scalars['String'];
  /** An array relationship */
  companies: Array<Template_Company>;
  /** An aggregate relationship */
  companies_aggregate: Template_Company_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  created_in_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  departments: Array<Template_Departments>;
  /** An aggregate relationship */
  departments_aggregate: Template_Departments_Aggregate;
  description: Scalars['String'];
  document_number?: Maybe<Scalars['String']>;
  document_revision_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  grade?: Maybe<Grade>;
  grade_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  market?: Maybe<Market>;
  market_id?: Maybe<Scalars['bigint']>;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  organisation_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  parent_template?: Maybe<Template>;
  parent_template_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  quality_stage?: Maybe<Quality_Stage>;
  quality_stage_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  quality_stages: Array<Template_Quality_Stages>;
  /** An aggregate relationship */
  quality_stages_aggregate: Template_Quality_Stages_Aggregate;
  /** An array relationship */
  requests: Array<Request_Templates>;
  /** An aggregate relationship */
  requests_aggregate: Request_Templates_Aggregate;
  /** An array relationship */
  results: Array<Result>;
  /** An aggregate relationship */
  results_aggregate: Result_Aggregate;
  sample_count: Scalars['Int'];
  /** An array relationship */
  template_parameters: Array<Template_Parameter>;
  /** An aggregate relationship */
  template_parameters_aggregate: Template_Parameter_Aggregate;
  /** An object relationship */
  test_for: External_Entity;
  test_for_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "template" */
export type TemplateCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Company_Order_By>>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Template_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Departments_Order_By>>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateDepartments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Departments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Departments_Order_By>>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "template" */
export type TemplateQuality_StagesArgs = {
  distinct_on?: InputMaybe<Array<Template_Quality_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Quality_Stages_Order_By>>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateQuality_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Quality_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Quality_Stages_Order_By>>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateRequestsArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Templates_Order_By>>;
  where?: InputMaybe<Request_Templates_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateResultsArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateResults_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Order_By>>;
  where?: InputMaybe<Result_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateTemplate_ParametersArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};


/** columns and relationships of "template" */
export type TemplateTemplate_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Order_By>>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};

/** aggregated selection of "template" */
export type Template_Aggregate = {
  __typename?: 'template_aggregate';
  aggregate?: Maybe<Template_Aggregate_Fields>;
  nodes: Array<Template>;
};

/** aggregate fields of "template" */
export type Template_Aggregate_Fields = {
  __typename?: 'template_aggregate_fields';
  avg?: Maybe<Template_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Max_Fields>;
  min?: Maybe<Template_Min_Fields>;
  stddev?: Maybe<Template_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Sum_Fields>;
  var_pop?: Maybe<Template_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Var_Samp_Fields>;
  variance?: Maybe<Template_Variance_Fields>;
};


/** aggregate fields of "template" */
export type Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template" */
export type Template_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Max_Order_By>;
  min?: InputMaybe<Template_Min_Order_By>;
  stddev?: InputMaybe<Template_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Template_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "template" */
export type Template_Arr_Rel_Insert_Input = {
  data: Array<Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Avg_Fields = {
  __typename?: 'template_avg_fields';
  brand_id?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  document_revision_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  parent_template_id?: Maybe<Scalars['Float']>;
  quality_stage_id?: Maybe<Scalars['Float']>;
  sample_count?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template" */
export type Template_Avg_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template". All fields are combined with a logical 'AND'. */
export type Template_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Bool_Exp>>;
  _not?: InputMaybe<Template_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Bool_Exp>>;
  brand_id?: InputMaybe<Bigint_Comparison_Exp>;
  category?: InputMaybe<Template_Category_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  companies?: InputMaybe<Template_Company_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  departments?: InputMaybe<Template_Departments_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  document_number?: InputMaybe<String_Comparison_Exp>;
  document_revision_id?: InputMaybe<Bigint_Comparison_Exp>;
  grade?: InputMaybe<Grade_Bool_Exp>;
  grade_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  market?: InputMaybe<Market_Bool_Exp>;
  market_id?: InputMaybe<Bigint_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Bigint_Comparison_Exp>;
  parent_template?: InputMaybe<Template_Bool_Exp>;
  parent_template_id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_stage?: InputMaybe<Quality_Stage_Bool_Exp>;
  quality_stage_id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_stages?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
  requests?: InputMaybe<Request_Templates_Bool_Exp>;
  results?: InputMaybe<Result_Bool_Exp>;
  sample_count?: InputMaybe<Int_Comparison_Exp>;
  template_parameters?: InputMaybe<Template_Parameter_Bool_Exp>;
  test_for?: InputMaybe<External_Entity_Bool_Exp>;
  test_for_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_till?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "template_category" */
export type Template_Category = {
  __typename?: 'template_category';
  /** An array relationship */
  allowed_parameter_categories: Array<Template_Category_Allowed_Parameter_Categories>;
  /** An aggregate relationship */
  allowed_parameter_categories_aggregate: Template_Category_Allowed_Parameter_Categories_Aggregate;
  /** An array relationship */
  allowed_template_categories: Array<Quality_Stage_Allowed_Template_Category>;
  /** An aggregate relationship */
  allowed_template_categories_aggregate: Quality_Stage_Allowed_Template_Category_Aggregate;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};


/** columns and relationships of "template_category" */
export type Template_CategoryAllowed_Parameter_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};


/** columns and relationships of "template_category" */
export type Template_CategoryAllowed_Parameter_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Order_By>>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};


/** columns and relationships of "template_category" */
export type Template_CategoryAllowed_Template_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};


/** columns and relationships of "template_category" */
export type Template_CategoryAllowed_Template_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quality_Stage_Allowed_Template_Category_Order_By>>;
  where?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
};

/** aggregated selection of "template_category" */
export type Template_Category_Aggregate = {
  __typename?: 'template_category_aggregate';
  aggregate?: Maybe<Template_Category_Aggregate_Fields>;
  nodes: Array<Template_Category>;
};

/** aggregate fields of "template_category" */
export type Template_Category_Aggregate_Fields = {
  __typename?: 'template_category_aggregate_fields';
  avg?: Maybe<Template_Category_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Category_Max_Fields>;
  min?: Maybe<Template_Category_Min_Fields>;
  stddev?: Maybe<Template_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Category_Sum_Fields>;
  var_pop?: Maybe<Template_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Category_Var_Samp_Fields>;
  variance?: Maybe<Template_Category_Variance_Fields>;
};


/** aggregate fields of "template_category" */
export type Template_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups = {
  __typename?: 'template_category_allowed_groups';
  group_id: Scalars['Int'];
  id: Scalars['bigint'];
  templatecategory_id: Scalars['bigint'];
};

/** aggregated selection of "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Aggregate = {
  __typename?: 'template_category_allowed_groups_aggregate';
  aggregate?: Maybe<Template_Category_Allowed_Groups_Aggregate_Fields>;
  nodes: Array<Template_Category_Allowed_Groups>;
};

/** aggregate fields of "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Aggregate_Fields = {
  __typename?: 'template_category_allowed_groups_aggregate_fields';
  avg?: Maybe<Template_Category_Allowed_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Category_Allowed_Groups_Max_Fields>;
  min?: Maybe<Template_Category_Allowed_Groups_Min_Fields>;
  stddev?: Maybe<Template_Category_Allowed_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Category_Allowed_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Category_Allowed_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Category_Allowed_Groups_Sum_Fields>;
  var_pop?: Maybe<Template_Category_Allowed_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Category_Allowed_Groups_Var_Samp_Fields>;
  variance?: Maybe<Template_Category_Allowed_Groups_Variance_Fields>;
};


/** aggregate fields of "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Category_Allowed_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Template_Category_Allowed_Groups_Avg_Fields = {
  __typename?: 'template_category_allowed_groups_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "template_category_allowed_groups". All fields are combined with a logical 'AND'. */
export type Template_Category_Allowed_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Category_Allowed_Groups_Bool_Exp>>;
  _not?: InputMaybe<Template_Category_Allowed_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Category_Allowed_Groups_Bool_Exp>>;
  group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  templatecategory_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_category_allowed_groups" */
export enum Template_Category_Allowed_Groups_Constraint {
  /** unique or primary key constraint on columns "templatecategory_id", "group_id" */
  TemplateCategoryAlloweTemplatecategoryIdGrou_0638aab0Uniq = 'template_category_allowe_templatecategory_id_grou_0638aab0_uniq',
  /** unique or primary key constraint on columns "id" */
  TemplateCategoryAllowedGroupsPkey = 'template_category_allowed_groups_pkey'
}

/** input type for incrementing numeric columns in table "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Inc_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Insert_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Category_Allowed_Groups_Max_Fields = {
  __typename?: 'template_category_allowed_groups_max_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Template_Category_Allowed_Groups_Min_Fields = {
  __typename?: 'template_category_allowed_groups_min_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Mutation_Response = {
  __typename?: 'template_category_allowed_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Category_Allowed_Groups>;
};

/** on_conflict condition type for table "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_On_Conflict = {
  constraint: Template_Category_Allowed_Groups_Constraint;
  update_columns?: Array<Template_Category_Allowed_Groups_Update_Column>;
  where?: InputMaybe<Template_Category_Allowed_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "template_category_allowed_groups". */
export type Template_Category_Allowed_Groups_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_category_allowed_groups */
export type Template_Category_Allowed_Groups_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_category_allowed_groups" */
export enum Template_Category_Allowed_Groups_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  TemplatecategoryId = 'templatecategory_id'
}

/** input type for updating data in table "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Set_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Category_Allowed_Groups_Stddev_Fields = {
  __typename?: 'template_category_allowed_groups_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Template_Category_Allowed_Groups_Stddev_Pop_Fields = {
  __typename?: 'template_category_allowed_groups_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Template_Category_Allowed_Groups_Stddev_Samp_Fields = {
  __typename?: 'template_category_allowed_groups_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "template_category_allowed_groups" */
export type Template_Category_Allowed_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Category_Allowed_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Category_Allowed_Groups_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Category_Allowed_Groups_Sum_Fields = {
  __typename?: 'template_category_allowed_groups_sum_fields';
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "template_category_allowed_groups" */
export enum Template_Category_Allowed_Groups_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  TemplatecategoryId = 'templatecategory_id'
}

export type Template_Category_Allowed_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Category_Allowed_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Category_Allowed_Groups_Set_Input>;
  where: Template_Category_Allowed_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Category_Allowed_Groups_Var_Pop_Fields = {
  __typename?: 'template_category_allowed_groups_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Template_Category_Allowed_Groups_Var_Samp_Fields = {
  __typename?: 'template_category_allowed_groups_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Template_Category_Allowed_Groups_Variance_Fields = {
  __typename?: 'template_category_allowed_groups_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories = {
  __typename?: 'template_category_allowed_parameter_categories';
  id: Scalars['bigint'];
  /** An object relationship */
  quality_parameter_category: Quality_Parameter_Category;
  qualityparametercategory_id: Scalars['bigint'];
  templatecategory_id: Scalars['bigint'];
};

/** aggregated selection of "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Aggregate = {
  __typename?: 'template_category_allowed_parameter_categories_aggregate';
  aggregate?: Maybe<Template_Category_Allowed_Parameter_Categories_Aggregate_Fields>;
  nodes: Array<Template_Category_Allowed_Parameter_Categories>;
};

/** aggregate fields of "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Aggregate_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_aggregate_fields';
  avg?: Maybe<Template_Category_Allowed_Parameter_Categories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Category_Allowed_Parameter_Categories_Max_Fields>;
  min?: Maybe<Template_Category_Allowed_Parameter_Categories_Min_Fields>;
  stddev?: Maybe<Template_Category_Allowed_Parameter_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Category_Allowed_Parameter_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Category_Allowed_Parameter_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Category_Allowed_Parameter_Categories_Sum_Fields>;
  var_pop?: Maybe<Template_Category_Allowed_Parameter_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Category_Allowed_Parameter_Categories_Var_Samp_Fields>;
  variance?: Maybe<Template_Category_Allowed_Parameter_Categories_Variance_Fields>;
};


/** aggregate fields of "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Max_Order_By>;
  min?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Min_Order_By>;
  stddev?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Arr_Rel_Insert_Input = {
  data: Array<Template_Category_Allowed_Parameter_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Category_Allowed_Parameter_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Category_Allowed_Parameter_Categories_Avg_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_avg_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparametercategory_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_category_allowed_parameter_categories". All fields are combined with a logical 'AND'. */
export type Template_Category_Allowed_Parameter_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Bool_Exp>>;
  _not?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Category_Allowed_Parameter_Categories_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_parameter_category?: InputMaybe<Quality_Parameter_Category_Bool_Exp>;
  qualityparametercategory_id?: InputMaybe<Bigint_Comparison_Exp>;
  templatecategory_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_category_allowed_parameter_categories" */
export enum Template_Category_Allowed_Parameter_Categories_Constraint {
  /** unique or primary key constraint on columns "templatecategory_id", "qualityparametercategory_id" */
  TemplateCategoryAlloweTemplatecategoryIdQual_8bba0d75Uniq = 'template_category_allowe_templatecategory_id_qual_8bba0d75_uniq',
  /** unique or primary key constraint on columns "id" */
  TemplateCategoryAllowedParameterCategoriesPkey = 'template_category_allowed_parameter_categories_pkey'
}

/** input type for incrementing numeric columns in table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualityparametercategory_id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  quality_parameter_category?: InputMaybe<Quality_Parameter_Category_Obj_Rel_Insert_Input>;
  qualityparametercategory_id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Category_Allowed_Parameter_Categories_Max_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_max_fields';
  id?: Maybe<Scalars['bigint']>;
  qualityparametercategory_id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Category_Allowed_Parameter_Categories_Min_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_min_fields';
  id?: Maybe<Scalars['bigint']>;
  qualityparametercategory_id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Mutation_Response = {
  __typename?: 'template_category_allowed_parameter_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Category_Allowed_Parameter_Categories>;
};

/** on_conflict condition type for table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_On_Conflict = {
  constraint: Template_Category_Allowed_Parameter_Categories_Constraint;
  update_columns?: Array<Template_Category_Allowed_Parameter_Categories_Update_Column>;
  where?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "template_category_allowed_parameter_categories". */
export type Template_Category_Allowed_Parameter_Categories_Order_By = {
  id?: InputMaybe<Order_By>;
  quality_parameter_category?: InputMaybe<Quality_Parameter_Category_Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_category_allowed_parameter_categories */
export type Template_Category_Allowed_Parameter_Categories_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_category_allowed_parameter_categories" */
export enum Template_Category_Allowed_Parameter_Categories_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualityparametercategoryId = 'qualityparametercategory_id',
  /** column name */
  TemplatecategoryId = 'templatecategory_id'
}

/** input type for updating data in table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualityparametercategory_id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Category_Allowed_Parameter_Categories_Stddev_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparametercategory_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Category_Allowed_Parameter_Categories_Stddev_Pop_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparametercategory_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Category_Allowed_Parameter_Categories_Stddev_Samp_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparametercategory_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Category_Allowed_Parameter_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Category_Allowed_Parameter_Categories_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualityparametercategory_id?: InputMaybe<Scalars['bigint']>;
  templatecategory_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Category_Allowed_Parameter_Categories_Sum_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  qualityparametercategory_id?: Maybe<Scalars['bigint']>;
  templatecategory_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** update columns of table "template_category_allowed_parameter_categories" */
export enum Template_Category_Allowed_Parameter_Categories_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualityparametercategoryId = 'qualityparametercategory_id',
  /** column name */
  TemplatecategoryId = 'templatecategory_id'
}

export type Template_Category_Allowed_Parameter_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Set_Input>;
  where: Template_Category_Allowed_Parameter_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Category_Allowed_Parameter_Categories_Var_Pop_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparametercategory_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Category_Allowed_Parameter_Categories_Var_Samp_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparametercategory_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Category_Allowed_Parameter_Categories_Variance_Fields = {
  __typename?: 'template_category_allowed_parameter_categories_variance_fields';
  id?: Maybe<Scalars['Float']>;
  qualityparametercategory_id?: Maybe<Scalars['Float']>;
  templatecategory_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_category_allowed_parameter_categories" */
export type Template_Category_Allowed_Parameter_Categories_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  qualityparametercategory_id?: InputMaybe<Order_By>;
  templatecategory_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Template_Category_Avg_Fields = {
  __typename?: 'template_category_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "template_category". All fields are combined with a logical 'AND'. */
export type Template_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Category_Bool_Exp>>;
  _not?: InputMaybe<Template_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Category_Bool_Exp>>;
  allowed_parameter_categories?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Bool_Exp>;
  allowed_template_categories?: InputMaybe<Quality_Stage_Allowed_Template_Category_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_category" */
export enum Template_Category_Constraint {
  /** unique or primary key constraint on columns "codename" */
  TemplateCategoryCodenameKey = 'template_category_codename_key',
  /** unique or primary key constraint on columns "id" */
  TemplateCategoryPkey = 'template_category_pkey'
}

/** input type for incrementing numeric columns in table "template_category" */
export type Template_Category_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_category" */
export type Template_Category_Insert_Input = {
  allowed_parameter_categories?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Arr_Rel_Insert_Input>;
  allowed_template_categories?: InputMaybe<Quality_Stage_Allowed_Template_Category_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Template_Category_Max_Fields = {
  __typename?: 'template_category_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Template_Category_Min_Fields = {
  __typename?: 'template_category_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "template_category" */
export type Template_Category_Mutation_Response = {
  __typename?: 'template_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Category>;
};

/** input type for inserting object relation for remote table "template_category" */
export type Template_Category_Obj_Rel_Insert_Input = {
  data: Template_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Category_On_Conflict>;
};

/** on_conflict condition type for table "template_category" */
export type Template_Category_On_Conflict = {
  constraint: Template_Category_Constraint;
  update_columns?: Array<Template_Category_Update_Column>;
  where?: InputMaybe<Template_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "template_category". */
export type Template_Category_Order_By = {
  allowed_parameter_categories_aggregate?: InputMaybe<Template_Category_Allowed_Parameter_Categories_Aggregate_Order_By>;
  allowed_template_categories_aggregate?: InputMaybe<Quality_Stage_Allowed_Template_Category_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_category */
export type Template_Category_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_category" */
export enum Template_Category_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "template_category" */
export type Template_Category_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Template_Category_Stddev_Fields = {
  __typename?: 'template_category_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Template_Category_Stddev_Pop_Fields = {
  __typename?: 'template_category_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Template_Category_Stddev_Samp_Fields = {
  __typename?: 'template_category_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "template_category" */
export type Template_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Category_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Template_Category_Sum_Fields = {
  __typename?: 'template_category_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "template_category" */
export enum Template_Category_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Template_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Category_Set_Input>;
  where: Template_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Category_Var_Pop_Fields = {
  __typename?: 'template_category_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Template_Category_Var_Samp_Fields = {
  __typename?: 'template_category_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Template_Category_Variance_Fields = {
  __typename?: 'template_category_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "template_company" */
export type Template_Company = {
  __typename?: 'template_company';
  /** An object relationship */
  external_entity: External_Entity;
  externalentity_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  template: Template;
  template_id: Scalars['bigint'];
};

/** aggregated selection of "template_company" */
export type Template_Company_Aggregate = {
  __typename?: 'template_company_aggregate';
  aggregate?: Maybe<Template_Company_Aggregate_Fields>;
  nodes: Array<Template_Company>;
};

/** aggregate fields of "template_company" */
export type Template_Company_Aggregate_Fields = {
  __typename?: 'template_company_aggregate_fields';
  avg?: Maybe<Template_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Company_Max_Fields>;
  min?: Maybe<Template_Company_Min_Fields>;
  stddev?: Maybe<Template_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Company_Sum_Fields>;
  var_pop?: Maybe<Template_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Company_Var_Samp_Fields>;
  variance?: Maybe<Template_Company_Variance_Fields>;
};


/** aggregate fields of "template_company" */
export type Template_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_company" */
export type Template_Company_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Company_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Company_Max_Order_By>;
  min?: InputMaybe<Template_Company_Min_Order_By>;
  stddev?: InputMaybe<Template_Company_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Company_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Company_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Company_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Company_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Company_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "template_company" */
export type Template_Company_Arr_Rel_Insert_Input = {
  data: Array<Template_Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Company_Avg_Fields = {
  __typename?: 'template_company_avg_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_company" */
export type Template_Company_Avg_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_company". All fields are combined with a logical 'AND'. */
export type Template_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Company_Bool_Exp>>;
  _not?: InputMaybe<Template_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Company_Bool_Exp>>;
  external_entity?: InputMaybe<External_Entity_Bool_Exp>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_company" */
export enum Template_Company_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemplateCompanyPkey = 'template_company_pkey',
  /** unique or primary key constraint on columns "template_id", "externalentity_id" */
  TemplateCompanyTemplateIdExternalentityIdC1633a07Uniq = 'template_company_template_id_externalentity_id_c1633a07_uniq'
}

/** input type for incrementing numeric columns in table "template_company" */
export type Template_Company_Inc_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_company" */
export type Template_Company_Insert_Input = {
  external_entity?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Company_Max_Fields = {
  __typename?: 'template_company_max_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "template_company" */
export type Template_Company_Max_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Company_Min_Fields = {
  __typename?: 'template_company_min_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "template_company" */
export type Template_Company_Min_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_company" */
export type Template_Company_Mutation_Response = {
  __typename?: 'template_company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Company>;
};

/** on_conflict condition type for table "template_company" */
export type Template_Company_On_Conflict = {
  constraint: Template_Company_Constraint;
  update_columns?: Array<Template_Company_Update_Column>;
  where?: InputMaybe<Template_Company_Bool_Exp>;
};

/** Ordering options when selecting data from "template_company". */
export type Template_Company_Order_By = {
  external_entity?: InputMaybe<External_Entity_Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template?: InputMaybe<Template_Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_company */
export type Template_Company_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_company" */
export enum Template_Company_Select_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  TemplateId = 'template_id'
}

/** input type for updating data in table "template_company" */
export type Template_Company_Set_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Company_Stddev_Fields = {
  __typename?: 'template_company_stddev_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_company" */
export type Template_Company_Stddev_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Company_Stddev_Pop_Fields = {
  __typename?: 'template_company_stddev_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_company" */
export type Template_Company_Stddev_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Company_Stddev_Samp_Fields = {
  __typename?: 'template_company_stddev_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_company" */
export type Template_Company_Stddev_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_company" */
export type Template_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Company_Stream_Cursor_Value_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Company_Sum_Fields = {
  __typename?: 'template_company_sum_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "template_company" */
export type Template_Company_Sum_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "template_company" */
export enum Template_Company_Update_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  TemplateId = 'template_id'
}

export type Template_Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Company_Set_Input>;
  where: Template_Company_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Company_Var_Pop_Fields = {
  __typename?: 'template_company_var_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_company" */
export type Template_Company_Var_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Company_Var_Samp_Fields = {
  __typename?: 'template_company_var_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_company" */
export type Template_Company_Var_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Company_Variance_Fields = {
  __typename?: 'template_company_variance_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_company" */
export type Template_Company_Variance_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "template" */
export enum Template_Constraint {
  /** unique or primary key constraint on columns "codename" */
  TemplateCodenameKey = 'template_codename_key',
  /** unique or primary key constraint on columns "id" */
  TemplatePkey = 'template_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Template_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Template_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Template_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "template_departments" */
export type Template_Departments = {
  __typename?: 'template_departments';
  /** An object relationship */
  department: External_Entity;
  externalentity_id: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An object relationship */
  template: Template;
  template_id: Scalars['bigint'];
};

/** aggregated selection of "template_departments" */
export type Template_Departments_Aggregate = {
  __typename?: 'template_departments_aggregate';
  aggregate?: Maybe<Template_Departments_Aggregate_Fields>;
  nodes: Array<Template_Departments>;
};

/** aggregate fields of "template_departments" */
export type Template_Departments_Aggregate_Fields = {
  __typename?: 'template_departments_aggregate_fields';
  avg?: Maybe<Template_Departments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Departments_Max_Fields>;
  min?: Maybe<Template_Departments_Min_Fields>;
  stddev?: Maybe<Template_Departments_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Departments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Departments_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Departments_Sum_Fields>;
  var_pop?: Maybe<Template_Departments_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Departments_Var_Samp_Fields>;
  variance?: Maybe<Template_Departments_Variance_Fields>;
};


/** aggregate fields of "template_departments" */
export type Template_Departments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Departments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_departments" */
export type Template_Departments_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Departments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Departments_Max_Order_By>;
  min?: InputMaybe<Template_Departments_Min_Order_By>;
  stddev?: InputMaybe<Template_Departments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Departments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Departments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Departments_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Departments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Departments_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Departments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "template_departments" */
export type Template_Departments_Arr_Rel_Insert_Input = {
  data: Array<Template_Departments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Departments_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Departments_Avg_Fields = {
  __typename?: 'template_departments_avg_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_departments" */
export type Template_Departments_Avg_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_departments". All fields are combined with a logical 'AND'. */
export type Template_Departments_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Departments_Bool_Exp>>;
  _not?: InputMaybe<Template_Departments_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Departments_Bool_Exp>>;
  department?: InputMaybe<External_Entity_Bool_Exp>;
  externalentity_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_departments" */
export enum Template_Departments_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemplateDepartmentsPkey = 'template_departments_pkey',
  /** unique or primary key constraint on columns "template_id", "externalentity_id" */
  TemplateDepartmentsTemplateIdExternalenti_1669a1a6Uniq = 'template_departments_template_id_externalenti_1669a1a6_uniq'
}

/** input type for incrementing numeric columns in table "template_departments" */
export type Template_Departments_Inc_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_departments" */
export type Template_Departments_Insert_Input = {
  department?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Departments_Max_Fields = {
  __typename?: 'template_departments_max_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "template_departments" */
export type Template_Departments_Max_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Departments_Min_Fields = {
  __typename?: 'template_departments_min_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "template_departments" */
export type Template_Departments_Min_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_departments" */
export type Template_Departments_Mutation_Response = {
  __typename?: 'template_departments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Departments>;
};

/** on_conflict condition type for table "template_departments" */
export type Template_Departments_On_Conflict = {
  constraint: Template_Departments_Constraint;
  update_columns?: Array<Template_Departments_Update_Column>;
  where?: InputMaybe<Template_Departments_Bool_Exp>;
};

/** Ordering options when selecting data from "template_departments". */
export type Template_Departments_Order_By = {
  department?: InputMaybe<External_Entity_Order_By>;
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template?: InputMaybe<Template_Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_departments */
export type Template_Departments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_departments" */
export enum Template_Departments_Select_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  TemplateId = 'template_id'
}

/** input type for updating data in table "template_departments" */
export type Template_Departments_Set_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Departments_Stddev_Fields = {
  __typename?: 'template_departments_stddev_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_departments" */
export type Template_Departments_Stddev_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Departments_Stddev_Pop_Fields = {
  __typename?: 'template_departments_stddev_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_departments" */
export type Template_Departments_Stddev_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Departments_Stddev_Samp_Fields = {
  __typename?: 'template_departments_stddev_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_departments" */
export type Template_Departments_Stddev_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_departments" */
export type Template_Departments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Departments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Departments_Stream_Cursor_Value_Input = {
  externalentity_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Departments_Sum_Fields = {
  __typename?: 'template_departments_sum_fields';
  externalentity_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "template_departments" */
export type Template_Departments_Sum_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "template_departments" */
export enum Template_Departments_Update_Column {
  /** column name */
  ExternalentityId = 'externalentity_id',
  /** column name */
  Id = 'id',
  /** column name */
  TemplateId = 'template_id'
}

export type Template_Departments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Departments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Departments_Set_Input>;
  where: Template_Departments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Departments_Var_Pop_Fields = {
  __typename?: 'template_departments_var_pop_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_departments" */
export type Template_Departments_Var_Pop_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Departments_Var_Samp_Fields = {
  __typename?: 'template_departments_var_samp_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_departments" */
export type Template_Departments_Var_Samp_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Departments_Variance_Fields = {
  __typename?: 'template_departments_variance_fields';
  externalentity_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_departments" */
export type Template_Departments_Variance_Order_By = {
  externalentity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "template_evaluation" */
export type Template_Evaluation = {
  __typename?: 'template_evaluation';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  evaluate_on_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  evaluations: Array<Result_Evaluation>;
  /** An aggregate relationship */
  evaluations_aggregate: Result_Evaluation_Aggregate;
  expression_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  kind: Scalars['String'];
  name: Scalars['String'];
  precision: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "template_evaluation" */
export type Template_EvaluationEvaluationsArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


/** columns and relationships of "template_evaluation" */
export type Template_EvaluationEvaluations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};

/** aggregated selection of "template_evaluation" */
export type Template_Evaluation_Aggregate = {
  __typename?: 'template_evaluation_aggregate';
  aggregate?: Maybe<Template_Evaluation_Aggregate_Fields>;
  nodes: Array<Template_Evaluation>;
};

/** aggregate fields of "template_evaluation" */
export type Template_Evaluation_Aggregate_Fields = {
  __typename?: 'template_evaluation_aggregate_fields';
  avg?: Maybe<Template_Evaluation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Evaluation_Max_Fields>;
  min?: Maybe<Template_Evaluation_Min_Fields>;
  stddev?: Maybe<Template_Evaluation_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Evaluation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Evaluation_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Evaluation_Sum_Fields>;
  var_pop?: Maybe<Template_Evaluation_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Evaluation_Var_Samp_Fields>;
  variance?: Maybe<Template_Evaluation_Variance_Fields>;
};


/** aggregate fields of "template_evaluation" */
export type Template_Evaluation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Evaluation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Template_Evaluation_Avg_Fields = {
  __typename?: 'template_evaluation_avg_fields';
  evaluate_on_id?: Maybe<Scalars['Float']>;
  expression_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "template_evaluation". All fields are combined with a logical 'AND'. */
export type Template_Evaluation_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Evaluation_Bool_Exp>>;
  _not?: InputMaybe<Template_Evaluation_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Evaluation_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  evaluate_on_id?: InputMaybe<Bigint_Comparison_Exp>;
  evaluations?: InputMaybe<Result_Evaluation_Bool_Exp>;
  expression_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  precision?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "template_evaluation_config" */
export type Template_Evaluation_Config = {
  __typename?: 'template_evaluation_config';
  comparator: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  evaluation_criteria_id: Scalars['bigint'];
  id: Scalars['bigint'];
  name?: Maybe<Scalars['String']>;
  template_evaluation_id: Scalars['bigint'];
  template_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  value: Scalars['float8'];
};

/** aggregated selection of "template_evaluation_config" */
export type Template_Evaluation_Config_Aggregate = {
  __typename?: 'template_evaluation_config_aggregate';
  aggregate?: Maybe<Template_Evaluation_Config_Aggregate_Fields>;
  nodes: Array<Template_Evaluation_Config>;
};

/** aggregate fields of "template_evaluation_config" */
export type Template_Evaluation_Config_Aggregate_Fields = {
  __typename?: 'template_evaluation_config_aggregate_fields';
  avg?: Maybe<Template_Evaluation_Config_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Evaluation_Config_Max_Fields>;
  min?: Maybe<Template_Evaluation_Config_Min_Fields>;
  stddev?: Maybe<Template_Evaluation_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Evaluation_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Evaluation_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Evaluation_Config_Sum_Fields>;
  var_pop?: Maybe<Template_Evaluation_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Evaluation_Config_Var_Samp_Fields>;
  variance?: Maybe<Template_Evaluation_Config_Variance_Fields>;
};


/** aggregate fields of "template_evaluation_config" */
export type Template_Evaluation_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Evaluation_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Template_Evaluation_Config_Avg_Fields = {
  __typename?: 'template_evaluation_config_avg_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "template_evaluation_config". All fields are combined with a logical 'AND'. */
export type Template_Evaluation_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Evaluation_Config_Bool_Exp>>;
  _not?: InputMaybe<Template_Evaluation_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Evaluation_Config_Bool_Exp>>;
  comparator?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  evaluation_criteria_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  template_evaluation_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_evaluation_config" */
export enum Template_Evaluation_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemplateEvaluationConfigPkey = 'template_evaluation_config_pkey'
}

/** input type for incrementing numeric columns in table "template_evaluation_config" */
export type Template_Evaluation_Config_Inc_Input = {
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "template_evaluation_config" */
export type Template_Evaluation_Config_Insert_Input = {
  comparator?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Template_Evaluation_Config_Max_Fields = {
  __typename?: 'template_evaluation_config_max_fields';
  comparator?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  evaluation_criteria_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  template_evaluation_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Template_Evaluation_Config_Min_Fields = {
  __typename?: 'template_evaluation_config_min_fields';
  comparator?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  evaluation_criteria_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  template_evaluation_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "template_evaluation_config" */
export type Template_Evaluation_Config_Mutation_Response = {
  __typename?: 'template_evaluation_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Evaluation_Config>;
};

/** on_conflict condition type for table "template_evaluation_config" */
export type Template_Evaluation_Config_On_Conflict = {
  constraint: Template_Evaluation_Config_Constraint;
  update_columns?: Array<Template_Evaluation_Config_Update_Column>;
  where?: InputMaybe<Template_Evaluation_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "template_evaluation_config". */
export type Template_Evaluation_Config_Order_By = {
  comparator?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  template_evaluation_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_evaluation_config */
export type Template_Evaluation_Config_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_evaluation_config" */
export enum Template_Evaluation_Config_Select_Column {
  /** column name */
  Comparator = 'comparator',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  EvaluationCriteriaId = 'evaluation_criteria_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TemplateEvaluationId = 'template_evaluation_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "template_evaluation_config" */
export type Template_Evaluation_Config_Set_Input = {
  comparator?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Template_Evaluation_Config_Stddev_Fields = {
  __typename?: 'template_evaluation_config_stddev_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Template_Evaluation_Config_Stddev_Pop_Fields = {
  __typename?: 'template_evaluation_config_stddev_pop_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Template_Evaluation_Config_Stddev_Samp_Fields = {
  __typename?: 'template_evaluation_config_stddev_samp_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "template_evaluation_config" */
export type Template_Evaluation_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Evaluation_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Evaluation_Config_Stream_Cursor_Value_Input = {
  comparator?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  template_evaluation_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Template_Evaluation_Config_Sum_Fields = {
  __typename?: 'template_evaluation_config_sum_fields';
  evaluation_criteria_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_evaluation_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['float8']>;
};

/** update columns of table "template_evaluation_config" */
export enum Template_Evaluation_Config_Update_Column {
  /** column name */
  Comparator = 'comparator',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  EvaluationCriteriaId = 'evaluation_criteria_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TemplateEvaluationId = 'template_evaluation_id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Value = 'value'
}

export type Template_Evaluation_Config_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Evaluation_Config_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Evaluation_Config_Set_Input>;
  where: Template_Evaluation_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Evaluation_Config_Var_Pop_Fields = {
  __typename?: 'template_evaluation_config_var_pop_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Template_Evaluation_Config_Var_Samp_Fields = {
  __typename?: 'template_evaluation_config_var_samp_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Template_Evaluation_Config_Variance_Fields = {
  __typename?: 'template_evaluation_config_variance_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_evaluation_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "template_evaluation" */
export enum Template_Evaluation_Constraint {
  /** unique or primary key constraint on columns "codename" */
  TemplateEvaluationCodenameKey = 'template_evaluation_codename_key',
  /** unique or primary key constraint on columns "id" */
  TemplateEvaluationPkey = 'template_evaluation_pkey'
}

/** input type for incrementing numeric columns in table "template_evaluation" */
export type Template_Evaluation_Inc_Input = {
  evaluate_on_id?: InputMaybe<Scalars['bigint']>;
  expression_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  precision?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "template_evaluation" */
export type Template_Evaluation_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  evaluate_on_id?: InputMaybe<Scalars['bigint']>;
  evaluations?: InputMaybe<Result_Evaluation_Arr_Rel_Insert_Input>;
  expression_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Template_Evaluation_Max_Fields = {
  __typename?: 'template_evaluation_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  evaluate_on_id?: Maybe<Scalars['bigint']>;
  expression_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  precision?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Template_Evaluation_Min_Fields = {
  __typename?: 'template_evaluation_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  evaluate_on_id?: Maybe<Scalars['bigint']>;
  expression_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  precision?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "template_evaluation" */
export type Template_Evaluation_Mutation_Response = {
  __typename?: 'template_evaluation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Evaluation>;
};

/** input type for inserting object relation for remote table "template_evaluation" */
export type Template_Evaluation_Obj_Rel_Insert_Input = {
  data: Template_Evaluation_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Evaluation_On_Conflict>;
};

/** on_conflict condition type for table "template_evaluation" */
export type Template_Evaluation_On_Conflict = {
  constraint: Template_Evaluation_Constraint;
  update_columns?: Array<Template_Evaluation_Update_Column>;
  where?: InputMaybe<Template_Evaluation_Bool_Exp>;
};

/** Ordering options when selecting data from "template_evaluation". */
export type Template_Evaluation_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  evaluate_on_id?: InputMaybe<Order_By>;
  evaluations_aggregate?: InputMaybe<Result_Evaluation_Aggregate_Order_By>;
  expression_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_evaluation */
export type Template_Evaluation_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_evaluation" */
export enum Template_Evaluation_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EvaluateOnId = 'evaluate_on_id',
  /** column name */
  ExpressionId = 'expression_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  Precision = 'precision',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "template_evaluation" */
export type Template_Evaluation_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  evaluate_on_id?: InputMaybe<Scalars['bigint']>;
  expression_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Template_Evaluation_Stddev_Fields = {
  __typename?: 'template_evaluation_stddev_fields';
  evaluate_on_id?: Maybe<Scalars['Float']>;
  expression_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Template_Evaluation_Stddev_Pop_Fields = {
  __typename?: 'template_evaluation_stddev_pop_fields';
  evaluate_on_id?: Maybe<Scalars['Float']>;
  expression_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Template_Evaluation_Stddev_Samp_Fields = {
  __typename?: 'template_evaluation_stddev_samp_fields';
  evaluate_on_id?: Maybe<Scalars['Float']>;
  expression_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "template_evaluation" */
export type Template_Evaluation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Evaluation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Evaluation_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  evaluate_on_id?: InputMaybe<Scalars['bigint']>;
  expression_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Template_Evaluation_Sum_Fields = {
  __typename?: 'template_evaluation_sum_fields';
  evaluate_on_id?: Maybe<Scalars['bigint']>;
  expression_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  precision?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "template_evaluation_templates" */
export type Template_Evaluation_Templates = {
  __typename?: 'template_evaluation_templates';
  id: Scalars['bigint'];
  template_id: Scalars['bigint'];
  templateevaluation_id: Scalars['bigint'];
};

/** aggregated selection of "template_evaluation_templates" */
export type Template_Evaluation_Templates_Aggregate = {
  __typename?: 'template_evaluation_templates_aggregate';
  aggregate?: Maybe<Template_Evaluation_Templates_Aggregate_Fields>;
  nodes: Array<Template_Evaluation_Templates>;
};

/** aggregate fields of "template_evaluation_templates" */
export type Template_Evaluation_Templates_Aggregate_Fields = {
  __typename?: 'template_evaluation_templates_aggregate_fields';
  avg?: Maybe<Template_Evaluation_Templates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Evaluation_Templates_Max_Fields>;
  min?: Maybe<Template_Evaluation_Templates_Min_Fields>;
  stddev?: Maybe<Template_Evaluation_Templates_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Evaluation_Templates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Evaluation_Templates_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Evaluation_Templates_Sum_Fields>;
  var_pop?: Maybe<Template_Evaluation_Templates_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Evaluation_Templates_Var_Samp_Fields>;
  variance?: Maybe<Template_Evaluation_Templates_Variance_Fields>;
};


/** aggregate fields of "template_evaluation_templates" */
export type Template_Evaluation_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Evaluation_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Template_Evaluation_Templates_Avg_Fields = {
  __typename?: 'template_evaluation_templates_avg_fields';
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  templateevaluation_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "template_evaluation_templates". All fields are combined with a logical 'AND'. */
export type Template_Evaluation_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Evaluation_Templates_Bool_Exp>>;
  _not?: InputMaybe<Template_Evaluation_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Evaluation_Templates_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
  templateevaluation_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_evaluation_templates" */
export enum Template_Evaluation_Templates_Constraint {
  /** unique or primary key constraint on columns "template_id", "templateevaluation_id" */
  TemplateEvaluationTempTemplateevaluationIdTe_6cfda5dfUniq = 'template_evaluation_temp_templateevaluation_id_te_6cfda5df_uniq',
  /** unique or primary key constraint on columns "id" */
  TemplateEvaluationTemplatePkey = 'template_evaluation_template_pkey'
}

/** input type for incrementing numeric columns in table "template_evaluation_templates" */
export type Template_Evaluation_Templates_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  templateevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_evaluation_templates" */
export type Template_Evaluation_Templates_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  templateevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Evaluation_Templates_Max_Fields = {
  __typename?: 'template_evaluation_templates_max_fields';
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  templateevaluation_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Template_Evaluation_Templates_Min_Fields = {
  __typename?: 'template_evaluation_templates_min_fields';
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  templateevaluation_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "template_evaluation_templates" */
export type Template_Evaluation_Templates_Mutation_Response = {
  __typename?: 'template_evaluation_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Evaluation_Templates>;
};

/** on_conflict condition type for table "template_evaluation_templates" */
export type Template_Evaluation_Templates_On_Conflict = {
  constraint: Template_Evaluation_Templates_Constraint;
  update_columns?: Array<Template_Evaluation_Templates_Update_Column>;
  where?: InputMaybe<Template_Evaluation_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "template_evaluation_templates". */
export type Template_Evaluation_Templates_Order_By = {
  id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  templateevaluation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_evaluation_templates */
export type Template_Evaluation_Templates_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_evaluation_templates" */
export enum Template_Evaluation_Templates_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateevaluationId = 'templateevaluation_id'
}

/** input type for updating data in table "template_evaluation_templates" */
export type Template_Evaluation_Templates_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  templateevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Evaluation_Templates_Stddev_Fields = {
  __typename?: 'template_evaluation_templates_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  templateevaluation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Template_Evaluation_Templates_Stddev_Pop_Fields = {
  __typename?: 'template_evaluation_templates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  templateevaluation_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Template_Evaluation_Templates_Stddev_Samp_Fields = {
  __typename?: 'template_evaluation_templates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  templateevaluation_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "template_evaluation_templates" */
export type Template_Evaluation_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Evaluation_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Evaluation_Templates_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  templateevaluation_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Evaluation_Templates_Sum_Fields = {
  __typename?: 'template_evaluation_templates_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
  templateevaluation_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "template_evaluation_templates" */
export enum Template_Evaluation_Templates_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateevaluationId = 'templateevaluation_id'
}

export type Template_Evaluation_Templates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Evaluation_Templates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Evaluation_Templates_Set_Input>;
  where: Template_Evaluation_Templates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Evaluation_Templates_Var_Pop_Fields = {
  __typename?: 'template_evaluation_templates_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  templateevaluation_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Template_Evaluation_Templates_Var_Samp_Fields = {
  __typename?: 'template_evaluation_templates_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  templateevaluation_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Template_Evaluation_Templates_Variance_Fields = {
  __typename?: 'template_evaluation_templates_variance_fields';
  id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  templateevaluation_id?: Maybe<Scalars['Float']>;
};

/** update columns of table "template_evaluation" */
export enum Template_Evaluation_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EvaluateOnId = 'evaluate_on_id',
  /** column name */
  ExpressionId = 'expression_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Kind = 'kind',
  /** column name */
  Name = 'name',
  /** column name */
  Precision = 'precision',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Template_Evaluation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Evaluation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Evaluation_Set_Input>;
  where: Template_Evaluation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Evaluation_Var_Pop_Fields = {
  __typename?: 'template_evaluation_var_pop_fields';
  evaluate_on_id?: Maybe<Scalars['Float']>;
  expression_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Template_Evaluation_Var_Samp_Fields = {
  __typename?: 'template_evaluation_var_samp_fields';
  evaluate_on_id?: Maybe<Scalars['Float']>;
  expression_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Template_Evaluation_Variance_Fields = {
  __typename?: 'template_evaluation_variance_fields';
  evaluate_on_id?: Maybe<Scalars['Float']>;
  expression_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "template" */
export type Template_Inc_Input = {
  brand_id?: InputMaybe<Scalars['bigint']>;
  category_id?: InputMaybe<Scalars['bigint']>;
  document_revision_id?: InputMaybe<Scalars['bigint']>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  market_id?: InputMaybe<Scalars['bigint']>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
  parent_template_id?: InputMaybe<Scalars['bigint']>;
  quality_stage_id?: InputMaybe<Scalars['bigint']>;
  sample_count?: InputMaybe<Scalars['Int']>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template" */
export type Template_Insert_Input = {
  brand_id?: InputMaybe<Scalars['bigint']>;
  category?: InputMaybe<Template_Category_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Template_Company_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  departments?: InputMaybe<Template_Departments_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  document_number?: InputMaybe<Scalars['String']>;
  document_revision_id?: InputMaybe<Scalars['bigint']>;
  grade?: InputMaybe<Grade_Obj_Rel_Insert_Input>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<Market_Obj_Rel_Insert_Input>;
  market_id?: InputMaybe<Scalars['bigint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
  parent_template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  parent_template_id?: InputMaybe<Scalars['bigint']>;
  quality_stage?: InputMaybe<Quality_Stage_Obj_Rel_Insert_Input>;
  quality_stage_id?: InputMaybe<Scalars['bigint']>;
  quality_stages?: InputMaybe<Template_Quality_Stages_Arr_Rel_Insert_Input>;
  requests?: InputMaybe<Request_Templates_Arr_Rel_Insert_Input>;
  results?: InputMaybe<Result_Arr_Rel_Insert_Input>;
  sample_count?: InputMaybe<Scalars['Int']>;
  template_parameters?: InputMaybe<Template_Parameter_Arr_Rel_Insert_Input>;
  test_for?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Template_Max_Fields = {
  __typename?: 'template_max_fields';
  brand_id?: Maybe<Scalars['bigint']>;
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document_number?: Maybe<Scalars['String']>;
  document_revision_id?: Maybe<Scalars['bigint']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  market_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['bigint']>;
  parent_template_id?: Maybe<Scalars['bigint']>;
  quality_stage_id?: Maybe<Scalars['bigint']>;
  sample_count?: Maybe<Scalars['Int']>;
  test_for_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "template" */
export type Template_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_number?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Min_Fields = {
  __typename?: 'template_min_fields';
  brand_id?: Maybe<Scalars['bigint']>;
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document_number?: Maybe<Scalars['String']>;
  document_revision_id?: Maybe<Scalars['bigint']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  market_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  organisation_id?: Maybe<Scalars['bigint']>;
  parent_template_id?: Maybe<Scalars['bigint']>;
  quality_stage_id?: Maybe<Scalars['bigint']>;
  sample_count?: Maybe<Scalars['Int']>;
  test_for_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "template" */
export type Template_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_number?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template" */
export type Template_Mutation_Response = {
  __typename?: 'template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template>;
};

/** input type for inserting object relation for remote table "template" */
export type Template_Obj_Rel_Insert_Input = {
  data: Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_On_Conflict>;
};

/** on_conflict condition type for table "template" */
export type Template_On_Conflict = {
  constraint: Template_Constraint;
  update_columns?: Array<Template_Update_Column>;
  where?: InputMaybe<Template_Bool_Exp>;
};

/** Ordering options when selecting data from "template". */
export type Template_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Template_Category_Order_By>;
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  companies_aggregate?: InputMaybe<Template_Company_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  departments_aggregate?: InputMaybe<Template_Departments_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  document_number?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade?: InputMaybe<Grade_Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  market?: InputMaybe<Market_Order_By>;
  market_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template?: InputMaybe<Template_Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage?: InputMaybe<Quality_Stage_Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  quality_stages_aggregate?: InputMaybe<Template_Quality_Stages_Aggregate_Order_By>;
  requests_aggregate?: InputMaybe<Request_Templates_Aggregate_Order_By>;
  results_aggregate?: InputMaybe<Result_Aggregate_Order_By>;
  sample_count?: InputMaybe<Order_By>;
  template_parameters_aggregate?: InputMaybe<Template_Parameter_Aggregate_Order_By>;
  test_for?: InputMaybe<External_Entity_Order_By>;
  test_for_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
};

/** columns and relationships of "template_parameter" */
export type Template_Parameter = {
  __typename?: 'template_parameter';
  /** An array relationship */
  configurations: Array<Template_Parameter_Config>;
  /** An aggregate relationship */
  configurations_aggregate: Template_Parameter_Config_Aggregate;
  created_at: Scalars['timestamptz'];
  disable_config: Scalars['Boolean'];
  /** An array relationship */
  evaluations: Array<Result_Evaluation>;
  /** An aggregate relationship */
  evaluations_aggregate: Result_Evaluation_Aggregate;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  is_mandatory?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['jsonb']>;
  observation_count: Scalars['Int'];
  /** An array relationship */
  observations: Array<Result_Observation>;
  /** An aggregate relationship */
  observations_aggregate: Result_Observation_Aggregate;
  options: Scalars['_varchar'];
  parent_template_parameter_id?: Maybe<Scalars['bigint']>;
  precision: Scalars['Int'];
  /** An object relationship */
  quality_parameter: Quality_Parameter;
  quality_parameter_id: Scalars['bigint'];
  /** An array relationship */
  sample_observations: Array<Sample_Observation>;
  /** An aggregate relationship */
  sample_observations_aggregate: Sample_Observation_Aggregate;
  sequence: Scalars['Int'];
  standard: Scalars['String'];
  /** An array relationship */
  standards: Array<Template_Parameter_Standard>;
  /** An aggregate relationship */
  standards_aggregate: Template_Parameter_Standard_Aggregate;
  /** An object relationship */
  template: Template;
  template_id: Scalars['bigint'];
  uid?: Maybe<Scalars['String']>;
  /** An object relationship */
  unit: Unit;
  unit_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
  weightage: Scalars['float8'];
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterConfigurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Config_Order_By>>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterEvaluationsArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterEvaluations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Evaluation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Evaluation_Order_By>>;
  where?: InputMaybe<Result_Evaluation_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterObservationsArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterObservations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Result_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Result_Observation_Order_By>>;
  where?: InputMaybe<Result_Observation_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterSample_ObservationsArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterSample_Observations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sample_Observation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sample_Observation_Order_By>>;
  where?: InputMaybe<Sample_Observation_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterStandardsArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};


/** columns and relationships of "template_parameter" */
export type Template_ParameterStandards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};

/** aggregated selection of "template_parameter" */
export type Template_Parameter_Aggregate = {
  __typename?: 'template_parameter_aggregate';
  aggregate?: Maybe<Template_Parameter_Aggregate_Fields>;
  nodes: Array<Template_Parameter>;
};

/** aggregate fields of "template_parameter" */
export type Template_Parameter_Aggregate_Fields = {
  __typename?: 'template_parameter_aggregate_fields';
  avg?: Maybe<Template_Parameter_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Parameter_Max_Fields>;
  min?: Maybe<Template_Parameter_Min_Fields>;
  stddev?: Maybe<Template_Parameter_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Parameter_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Parameter_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Parameter_Sum_Fields>;
  var_pop?: Maybe<Template_Parameter_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Parameter_Var_Samp_Fields>;
  variance?: Maybe<Template_Parameter_Variance_Fields>;
};


/** aggregate fields of "template_parameter" */
export type Template_Parameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Parameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_parameter" */
export type Template_Parameter_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Parameter_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Parameter_Max_Order_By>;
  min?: InputMaybe<Template_Parameter_Min_Order_By>;
  stddev?: InputMaybe<Template_Parameter_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Parameter_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Parameter_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Parameter_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Parameter_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Parameter_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Parameter_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Template_Parameter_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "template_parameter" */
export type Template_Parameter_Arr_Rel_Insert_Input = {
  data: Array<Template_Parameter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Parameter_Avg_Fields = {
  __typename?: 'template_parameter_avg_fields';
  id?: Maybe<Scalars['Float']>;
  observation_count?: Maybe<Scalars['Float']>;
  parent_template_parameter_id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weightage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_parameter" */
export type Template_Parameter_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_parameter". All fields are combined with a logical 'AND'. */
export type Template_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Parameter_Bool_Exp>>;
  _not?: InputMaybe<Template_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Parameter_Bool_Exp>>;
  configurations?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  disable_config?: InputMaybe<Boolean_Comparison_Exp>;
  evaluations?: InputMaybe<Result_Evaluation_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  observation_count?: InputMaybe<Int_Comparison_Exp>;
  observations?: InputMaybe<Result_Observation_Bool_Exp>;
  options?: InputMaybe<_Varchar_Comparison_Exp>;
  parent_template_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  precision?: InputMaybe<Int_Comparison_Exp>;
  quality_parameter?: InputMaybe<Quality_Parameter_Bool_Exp>;
  quality_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  sample_observations?: InputMaybe<Sample_Observation_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  standard?: InputMaybe<String_Comparison_Exp>;
  standards?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
  uid?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_till?: InputMaybe<Timestamptz_Comparison_Exp>;
  weightage?: InputMaybe<Float8_Comparison_Exp>;
};

/** columns and relationships of "template_parameter_config" */
export type Template_Parameter_Config = {
  __typename?: 'template_parameter_config';
  comparator: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  evaluation_criteria: Evaluation_Criteria;
  evaluation_criteria_id: Scalars['bigint'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  template_parameter: Template_Parameter;
  template_parameter_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
  value: Scalars['float8'];
};

/** aggregated selection of "template_parameter_config" */
export type Template_Parameter_Config_Aggregate = {
  __typename?: 'template_parameter_config_aggregate';
  aggregate?: Maybe<Template_Parameter_Config_Aggregate_Fields>;
  nodes: Array<Template_Parameter_Config>;
};

/** aggregate fields of "template_parameter_config" */
export type Template_Parameter_Config_Aggregate_Fields = {
  __typename?: 'template_parameter_config_aggregate_fields';
  avg?: Maybe<Template_Parameter_Config_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Parameter_Config_Max_Fields>;
  min?: Maybe<Template_Parameter_Config_Min_Fields>;
  stddev?: Maybe<Template_Parameter_Config_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Parameter_Config_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Parameter_Config_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Parameter_Config_Sum_Fields>;
  var_pop?: Maybe<Template_Parameter_Config_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Parameter_Config_Var_Samp_Fields>;
  variance?: Maybe<Template_Parameter_Config_Variance_Fields>;
};


/** aggregate fields of "template_parameter_config" */
export type Template_Parameter_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Parameter_Config_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_parameter_config" */
export type Template_Parameter_Config_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Parameter_Config_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Parameter_Config_Max_Order_By>;
  min?: InputMaybe<Template_Parameter_Config_Min_Order_By>;
  stddev?: InputMaybe<Template_Parameter_Config_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Parameter_Config_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Parameter_Config_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Parameter_Config_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Parameter_Config_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Parameter_Config_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Parameter_Config_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "template_parameter_config" */
export type Template_Parameter_Config_Arr_Rel_Insert_Input = {
  data: Array<Template_Parameter_Config_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_Config_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Parameter_Config_Avg_Fields = {
  __typename?: 'template_parameter_config_avg_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Avg_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_parameter_config". All fields are combined with a logical 'AND'. */
export type Template_Parameter_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Parameter_Config_Bool_Exp>>;
  _not?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Parameter_Config_Bool_Exp>>;
  comparator?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  created_in_id?: InputMaybe<String_Comparison_Exp>;
  evaluation_criteria?: InputMaybe<Evaluation_Criteria_Bool_Exp>;
  evaluation_criteria_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  template_parameter?: InputMaybe<Template_Parameter_Bool_Exp>;
  template_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_till?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_parameter_config" */
export enum Template_Parameter_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemplateParameterConfigPkey = 'template_parameter_config_pkey'
}

/** input type for incrementing numeric columns in table "template_parameter_config" */
export type Template_Parameter_Config_Inc_Input = {
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "template_parameter_config" */
export type Template_Parameter_Config_Insert_Input = {
  comparator?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  evaluation_criteria?: InputMaybe<Evaluation_Criteria_Obj_Rel_Insert_Input>;
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  template_parameter?: InputMaybe<Template_Parameter_Obj_Rel_Insert_Input>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Template_Parameter_Config_Max_Fields = {
  __typename?: 'template_parameter_config_max_fields';
  comparator?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  evaluation_criteria_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Max_Order_By = {
  comparator?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Parameter_Config_Min_Fields = {
  __typename?: 'template_parameter_config_min_fields';
  comparator?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  created_in_id?: Maybe<Scalars['String']>;
  evaluation_criteria_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Min_Order_By = {
  comparator?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_parameter_config" */
export type Template_Parameter_Config_Mutation_Response = {
  __typename?: 'template_parameter_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Parameter_Config>;
};

/** input type for inserting object relation for remote table "template_parameter_config" */
export type Template_Parameter_Config_Obj_Rel_Insert_Input = {
  data: Template_Parameter_Config_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_Config_On_Conflict>;
};

/** on_conflict condition type for table "template_parameter_config" */
export type Template_Parameter_Config_On_Conflict = {
  constraint: Template_Parameter_Config_Constraint;
  update_columns?: Array<Template_Parameter_Config_Update_Column>;
  where?: InputMaybe<Template_Parameter_Config_Bool_Exp>;
};

/** Ordering options when selecting data from "template_parameter_config". */
export type Template_Parameter_Config_Order_By = {
  comparator?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  evaluation_criteria?: InputMaybe<Evaluation_Criteria_Order_By>;
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  template_parameter?: InputMaybe<Template_Parameter_Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_parameter_config */
export type Template_Parameter_Config_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_parameter_config" */
export enum Template_Parameter_Config_Select_Column {
  /** column name */
  Comparator = 'comparator',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  EvaluationCriteriaId = 'evaluation_criteria_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "template_parameter_config" */
export type Template_Parameter_Config_Set_Input = {
  comparator?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Template_Parameter_Config_Stddev_Fields = {
  __typename?: 'template_parameter_config_stddev_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Stddev_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Parameter_Config_Stddev_Pop_Fields = {
  __typename?: 'template_parameter_config_stddev_pop_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Stddev_Pop_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Parameter_Config_Stddev_Samp_Fields = {
  __typename?: 'template_parameter_config_stddev_samp_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Stddev_Samp_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_parameter_config" */
export type Template_Parameter_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Parameter_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Parameter_Config_Stream_Cursor_Value_Input = {
  comparator?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  evaluation_criteria_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Template_Parameter_Config_Sum_Fields = {
  __typename?: 'template_parameter_config_sum_fields';
  evaluation_criteria_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Sum_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "template_parameter_config" */
export enum Template_Parameter_Config_Update_Column {
  /** column name */
  Comparator = 'comparator',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  EvaluationCriteriaId = 'evaluation_criteria_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  TemplateParameterId = 'template_parameter_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  Value = 'value'
}

export type Template_Parameter_Config_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Parameter_Config_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Parameter_Config_Set_Input>;
  where: Template_Parameter_Config_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Parameter_Config_Var_Pop_Fields = {
  __typename?: 'template_parameter_config_var_pop_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Var_Pop_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Parameter_Config_Var_Samp_Fields = {
  __typename?: 'template_parameter_config_var_samp_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Var_Samp_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Parameter_Config_Variance_Fields = {
  __typename?: 'template_parameter_config_variance_fields';
  evaluation_criteria_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_parameter_config" */
export type Template_Parameter_Config_Variance_Order_By = {
  evaluation_criteria_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "template_parameter" */
export enum Template_Parameter_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemplateParameterPkey = 'template_parameter_pkey',
  /** unique or primary key constraint on columns "template_id", "quality_parameter_id" */
  TemplateParameterQualityParameterIdTem_6f4c9b21Uniq = 'template_parameter_quality_parameter_id_tem_6f4c9b21_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Template_Parameter_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Template_Parameter_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Template_Parameter_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "template_parameter" */
export type Template_Parameter_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  observation_count?: InputMaybe<Scalars['Int']>;
  parent_template_parameter_id?: InputMaybe<Scalars['bigint']>;
  precision?: InputMaybe<Scalars['Int']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  sequence?: InputMaybe<Scalars['Int']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  weightage?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "template_parameter" */
export type Template_Parameter_Insert_Input = {
  configurations?: InputMaybe<Template_Parameter_Config_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  disable_config?: InputMaybe<Scalars['Boolean']>;
  evaluations?: InputMaybe<Result_Evaluation_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  observation_count?: InputMaybe<Scalars['Int']>;
  observations?: InputMaybe<Result_Observation_Arr_Rel_Insert_Input>;
  options?: InputMaybe<Scalars['_varchar']>;
  parent_template_parameter_id?: InputMaybe<Scalars['bigint']>;
  precision?: InputMaybe<Scalars['Int']>;
  quality_parameter?: InputMaybe<Quality_Parameter_Obj_Rel_Insert_Input>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  sample_observations?: InputMaybe<Sample_Observation_Arr_Rel_Insert_Input>;
  sequence?: InputMaybe<Scalars['Int']>;
  standard?: InputMaybe<Scalars['String']>;
  standards?: InputMaybe<Template_Parameter_Standard_Arr_Rel_Insert_Input>;
  template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
  weightage?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Template_Parameter_Max_Fields = {
  __typename?: 'template_parameter_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  observation_count?: Maybe<Scalars['Int']>;
  parent_template_parameter_id?: Maybe<Scalars['bigint']>;
  precision?: Maybe<Scalars['Int']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  sequence?: Maybe<Scalars['Int']>;
  standard?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
  weightage?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "template_parameter" */
export type Template_Parameter_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  standard?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Parameter_Min_Fields = {
  __typename?: 'template_parameter_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  observation_count?: Maybe<Scalars['Int']>;
  parent_template_parameter_id?: Maybe<Scalars['bigint']>;
  precision?: Maybe<Scalars['Int']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  sequence?: Maybe<Scalars['Int']>;
  standard?: Maybe<Scalars['String']>;
  template_id?: Maybe<Scalars['bigint']>;
  uid?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_from?: Maybe<Scalars['timestamptz']>;
  valid_till?: Maybe<Scalars['timestamptz']>;
  weightage?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "template_parameter" */
export type Template_Parameter_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  standard?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_parameter" */
export type Template_Parameter_Mutation_Response = {
  __typename?: 'template_parameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Parameter>;
};

/** input type for inserting object relation for remote table "template_parameter" */
export type Template_Parameter_Obj_Rel_Insert_Input = {
  data: Template_Parameter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_On_Conflict>;
};

/** on_conflict condition type for table "template_parameter" */
export type Template_Parameter_On_Conflict = {
  constraint: Template_Parameter_Constraint;
  update_columns?: Array<Template_Parameter_Update_Column>;
  where?: InputMaybe<Template_Parameter_Bool_Exp>;
};

/** Ordering options when selecting data from "template_parameter". */
export type Template_Parameter_Order_By = {
  configurations_aggregate?: InputMaybe<Template_Parameter_Config_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  disable_config?: InputMaybe<Order_By>;
  evaluations_aggregate?: InputMaybe<Result_Evaluation_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_mandatory?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  observations_aggregate?: InputMaybe<Result_Observation_Aggregate_Order_By>;
  options?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter?: InputMaybe<Quality_Parameter_Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sample_observations_aggregate?: InputMaybe<Sample_Observation_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
  standard?: InputMaybe<Order_By>;
  standards_aggregate?: InputMaybe<Template_Parameter_Standard_Aggregate_Order_By>;
  template?: InputMaybe<Template_Order_By>;
  template_id?: InputMaybe<Order_By>;
  uid?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_till?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_parameter */
export type Template_Parameter_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Template_Parameter_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "template_parameter" */
export enum Template_Parameter_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisableConfig = 'disable_config',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMandatory = 'is_mandatory',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObservationCount = 'observation_count',
  /** column name */
  Options = 'options',
  /** column name */
  ParentTemplateParameterId = 'parent_template_parameter_id',
  /** column name */
  Precision = 'precision',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  Standard = 'standard',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  Weightage = 'weightage'
}

/** input type for updating data in table "template_parameter" */
export type Template_Parameter_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  disable_config?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  observation_count?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['_varchar']>;
  parent_template_parameter_id?: InputMaybe<Scalars['bigint']>;
  precision?: InputMaybe<Scalars['Int']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  sequence?: InputMaybe<Scalars['Int']>;
  standard?: InputMaybe<Scalars['String']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
  weightage?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "template_parameter_standard" */
export type Template_Parameter_Standard = {
  __typename?: 'template_parameter_standard';
  /** An array relationship */
  attachments: Array<Template_Parameter_Standard_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Template_Parameter_Standard_Attachments_Aggregate;
  codename: Scalars['String'];
  description: Scalars['String'];
  /** An object relationship */
  group: Template_Parameter_Standard_Group;
  group_id: Scalars['bigint'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  remark: Scalars['String'];
  /** An object relationship */
  template_parameter: Template_Parameter;
  template_parameter_id: Scalars['bigint'];
};


/** columns and relationships of "template_parameter_standard" */
export type Template_Parameter_StandardAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};


/** columns and relationships of "template_parameter_standard" */
export type Template_Parameter_StandardAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};

/** aggregated selection of "template_parameter_standard" */
export type Template_Parameter_Standard_Aggregate = {
  __typename?: 'template_parameter_standard_aggregate';
  aggregate?: Maybe<Template_Parameter_Standard_Aggregate_Fields>;
  nodes: Array<Template_Parameter_Standard>;
};

/** aggregate fields of "template_parameter_standard" */
export type Template_Parameter_Standard_Aggregate_Fields = {
  __typename?: 'template_parameter_standard_aggregate_fields';
  avg?: Maybe<Template_Parameter_Standard_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Parameter_Standard_Max_Fields>;
  min?: Maybe<Template_Parameter_Standard_Min_Fields>;
  stddev?: Maybe<Template_Parameter_Standard_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Parameter_Standard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Parameter_Standard_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Parameter_Standard_Sum_Fields>;
  var_pop?: Maybe<Template_Parameter_Standard_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Parameter_Standard_Var_Samp_Fields>;
  variance?: Maybe<Template_Parameter_Standard_Variance_Fields>;
};


/** aggregate fields of "template_parameter_standard" */
export type Template_Parameter_Standard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_parameter_standard" */
export type Template_Parameter_Standard_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Parameter_Standard_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Parameter_Standard_Max_Order_By>;
  min?: InputMaybe<Template_Parameter_Standard_Min_Order_By>;
  stddev?: InputMaybe<Template_Parameter_Standard_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Parameter_Standard_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Parameter_Standard_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Parameter_Standard_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Parameter_Standard_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Parameter_Standard_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Parameter_Standard_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "template_parameter_standard" */
export type Template_Parameter_Standard_Arr_Rel_Insert_Input = {
  data: Array<Template_Parameter_Standard_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_Standard_On_Conflict>;
};

/** columns and relationships of "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments = {
  __typename?: 'template_parameter_standard_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Eagle_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  template_parameter_standard: Template_Parameter_Standard;
  templateparameterstandard_id: Scalars['bigint'];
};

/** aggregated selection of "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Aggregate = {
  __typename?: 'template_parameter_standard_attachments_aggregate';
  aggregate?: Maybe<Template_Parameter_Standard_Attachments_Aggregate_Fields>;
  nodes: Array<Template_Parameter_Standard_Attachments>;
};

/** aggregate fields of "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Aggregate_Fields = {
  __typename?: 'template_parameter_standard_attachments_aggregate_fields';
  avg?: Maybe<Template_Parameter_Standard_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Parameter_Standard_Attachments_Max_Fields>;
  min?: Maybe<Template_Parameter_Standard_Attachments_Min_Fields>;
  stddev?: Maybe<Template_Parameter_Standard_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Parameter_Standard_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Parameter_Standard_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Parameter_Standard_Attachments_Sum_Fields>;
  var_pop?: Maybe<Template_Parameter_Standard_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Parameter_Standard_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Template_Parameter_Standard_Attachments_Variance_Fields>;
};


/** aggregate fields of "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Parameter_Standard_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Parameter_Standard_Attachments_Max_Order_By>;
  min?: InputMaybe<Template_Parameter_Standard_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Template_Parameter_Standard_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Parameter_Standard_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Parameter_Standard_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Parameter_Standard_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Parameter_Standard_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Parameter_Standard_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Parameter_Standard_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Template_Parameter_Standard_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_Standard_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Parameter_Standard_Attachments_Avg_Fields = {
  __typename?: 'template_parameter_standard_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  templateparameterstandard_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_parameter_standard_attachments". All fields are combined with a logical 'AND'. */
export type Template_Parameter_Standard_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Parameter_Standard_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Eagle_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  template_parameter_standard?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
  templateparameterstandard_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_parameter_standard_attachments" */
export enum Template_Parameter_Standard_Attachments_Constraint {
  /** unique or primary key constraint on columns "templateparameterstandard_id", "media_id" */
  TemplateParameterStandTemplateparameterstandar_4b60fae7Uniq = 'template_parameter_stand_templateparameterstandar_4b60fae7_uniq',
  /** unique or primary key constraint on columns "id" */
  TemplateParameterStandardAttachmentsPkey = 'template_parameter_standard_attachments_pkey'
}

/** input type for incrementing numeric columns in table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  templateparameterstandard_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Eagle_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  template_parameter_standard?: InputMaybe<Template_Parameter_Standard_Obj_Rel_Insert_Input>;
  templateparameterstandard_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Parameter_Standard_Attachments_Max_Fields = {
  __typename?: 'template_parameter_standard_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  templateparameterstandard_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Parameter_Standard_Attachments_Min_Fields = {
  __typename?: 'template_parameter_standard_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  templateparameterstandard_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Mutation_Response = {
  __typename?: 'template_parameter_standard_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Parameter_Standard_Attachments>;
};

/** on_conflict condition type for table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_On_Conflict = {
  constraint: Template_Parameter_Standard_Attachments_Constraint;
  update_columns?: Array<Template_Parameter_Standard_Attachments_Update_Column>;
  where?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "template_parameter_standard_attachments". */
export type Template_Parameter_Standard_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Eagle_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  template_parameter_standard?: InputMaybe<Template_Parameter_Standard_Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_parameter_standard_attachments */
export type Template_Parameter_Standard_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_parameter_standard_attachments" */
export enum Template_Parameter_Standard_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TemplateparameterstandardId = 'templateparameterstandard_id'
}

/** input type for updating data in table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  templateparameterstandard_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Parameter_Standard_Attachments_Stddev_Fields = {
  __typename?: 'template_parameter_standard_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  templateparameterstandard_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Parameter_Standard_Attachments_Stddev_Pop_Fields = {
  __typename?: 'template_parameter_standard_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  templateparameterstandard_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Parameter_Standard_Attachments_Stddev_Samp_Fields = {
  __typename?: 'template_parameter_standard_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  templateparameterstandard_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Parameter_Standard_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Parameter_Standard_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  templateparameterstandard_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Parameter_Standard_Attachments_Sum_Fields = {
  __typename?: 'template_parameter_standard_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  templateparameterstandard_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** update columns of table "template_parameter_standard_attachments" */
export enum Template_Parameter_Standard_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TemplateparameterstandardId = 'templateparameterstandard_id'
}

export type Template_Parameter_Standard_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Parameter_Standard_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Parameter_Standard_Attachments_Set_Input>;
  where: Template_Parameter_Standard_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Parameter_Standard_Attachments_Var_Pop_Fields = {
  __typename?: 'template_parameter_standard_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  templateparameterstandard_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Parameter_Standard_Attachments_Var_Samp_Fields = {
  __typename?: 'template_parameter_standard_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  templateparameterstandard_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Parameter_Standard_Attachments_Variance_Fields = {
  __typename?: 'template_parameter_standard_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  templateparameterstandard_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_parameter_standard_attachments" */
export type Template_Parameter_Standard_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  templateparameterstandard_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Template_Parameter_Standard_Avg_Fields = {
  __typename?: 'template_parameter_standard_avg_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Avg_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_parameter_standard". All fields are combined with a logical 'AND'. */
export type Template_Parameter_Standard_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Parameter_Standard_Bool_Exp>>;
  _not?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Parameter_Standard_Bool_Exp>>;
  attachments?: InputMaybe<Template_Parameter_Standard_Attachments_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
  group_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  template_parameter?: InputMaybe<Template_Parameter_Bool_Exp>;
  template_parameter_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_parameter_standard" */
export enum Template_Parameter_Standard_Constraint {
  /** unique or primary key constraint on columns "codename" */
  TemplateParameterStandardCodenameKey = 'template_parameter_standard_codename_key',
  /** unique or primary key constraint on columns "id" */
  TemplateParameterStandardPkey = 'template_parameter_standard_pkey'
}

/** columns and relationships of "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group = {
  __typename?: 'template_parameter_standard_group';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  standards: Array<Template_Parameter_Standard>;
  /** An aggregate relationship */
  standards_aggregate: Template_Parameter_Standard_Aggregate;
};


/** columns and relationships of "template_parameter_standard_group" */
export type Template_Parameter_Standard_GroupStandardsArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};


/** columns and relationships of "template_parameter_standard_group" */
export type Template_Parameter_Standard_GroupStandards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Template_Parameter_Standard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Parameter_Standard_Order_By>>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};

/** aggregated selection of "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Aggregate = {
  __typename?: 'template_parameter_standard_group_aggregate';
  aggregate?: Maybe<Template_Parameter_Standard_Group_Aggregate_Fields>;
  nodes: Array<Template_Parameter_Standard_Group>;
};

/** aggregate fields of "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Aggregate_Fields = {
  __typename?: 'template_parameter_standard_group_aggregate_fields';
  avg?: Maybe<Template_Parameter_Standard_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Parameter_Standard_Group_Max_Fields>;
  min?: Maybe<Template_Parameter_Standard_Group_Min_Fields>;
  stddev?: Maybe<Template_Parameter_Standard_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Parameter_Standard_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Parameter_Standard_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Parameter_Standard_Group_Sum_Fields>;
  var_pop?: Maybe<Template_Parameter_Standard_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Parameter_Standard_Group_Var_Samp_Fields>;
  variance?: Maybe<Template_Parameter_Standard_Group_Variance_Fields>;
};


/** aggregate fields of "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Parameter_Standard_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Template_Parameter_Standard_Group_Avg_Fields = {
  __typename?: 'template_parameter_standard_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "template_parameter_standard_group". All fields are combined with a logical 'AND'. */
export type Template_Parameter_Standard_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Parameter_Standard_Group_Bool_Exp>>;
  _not?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Parameter_Standard_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  standards?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};

/** unique or primary key constraints on table "template_parameter_standard_group" */
export enum Template_Parameter_Standard_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  TemplateParameterStandardGroupCodenameKey = 'template_parameter_standard_group_codename_key',
  /** unique or primary key constraint on columns "id" */
  TemplateParameterStandardGroupPkey = 'template_parameter_standard_group_pkey'
}

/** input type for incrementing numeric columns in table "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  standards?: InputMaybe<Template_Parameter_Standard_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Template_Parameter_Standard_Group_Max_Fields = {
  __typename?: 'template_parameter_standard_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Template_Parameter_Standard_Group_Min_Fields = {
  __typename?: 'template_parameter_standard_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Mutation_Response = {
  __typename?: 'template_parameter_standard_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Parameter_Standard_Group>;
};

/** input type for inserting object relation for remote table "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Obj_Rel_Insert_Input = {
  data: Template_Parameter_Standard_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_Standard_Group_On_Conflict>;
};

/** on_conflict condition type for table "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_On_Conflict = {
  constraint: Template_Parameter_Standard_Group_Constraint;
  update_columns?: Array<Template_Parameter_Standard_Group_Update_Column>;
  where?: InputMaybe<Template_Parameter_Standard_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "template_parameter_standard_group". */
export type Template_Parameter_Standard_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  standards_aggregate?: InputMaybe<Template_Parameter_Standard_Aggregate_Order_By>;
};

/** primary key columns input for table: template_parameter_standard_group */
export type Template_Parameter_Standard_Group_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_parameter_standard_group" */
export enum Template_Parameter_Standard_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Template_Parameter_Standard_Group_Stddev_Fields = {
  __typename?: 'template_parameter_standard_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Template_Parameter_Standard_Group_Stddev_Pop_Fields = {
  __typename?: 'template_parameter_standard_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Template_Parameter_Standard_Group_Stddev_Samp_Fields = {
  __typename?: 'template_parameter_standard_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "template_parameter_standard_group" */
export type Template_Parameter_Standard_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Parameter_Standard_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Parameter_Standard_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Template_Parameter_Standard_Group_Sum_Fields = {
  __typename?: 'template_parameter_standard_group_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "template_parameter_standard_group" */
export enum Template_Parameter_Standard_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Template_Parameter_Standard_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Parameter_Standard_Group_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Parameter_Standard_Group_Set_Input>;
  where: Template_Parameter_Standard_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Parameter_Standard_Group_Var_Pop_Fields = {
  __typename?: 'template_parameter_standard_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Template_Parameter_Standard_Group_Var_Samp_Fields = {
  __typename?: 'template_parameter_standard_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Template_Parameter_Standard_Group_Variance_Fields = {
  __typename?: 'template_parameter_standard_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "template_parameter_standard" */
export type Template_Parameter_Standard_Inc_Input = {
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_parameter_standard" */
export type Template_Parameter_Standard_Insert_Input = {
  attachments?: InputMaybe<Template_Parameter_Standard_Attachments_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Template_Parameter_Standard_Group_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  template_parameter?: InputMaybe<Template_Parameter_Obj_Rel_Insert_Input>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Parameter_Standard_Max_Fields = {
  __typename?: 'template_parameter_standard_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Parameter_Standard_Min_Fields = {
  __typename?: 'template_parameter_standard_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_parameter_standard" */
export type Template_Parameter_Standard_Mutation_Response = {
  __typename?: 'template_parameter_standard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Parameter_Standard>;
};

/** input type for inserting object relation for remote table "template_parameter_standard" */
export type Template_Parameter_Standard_Obj_Rel_Insert_Input = {
  data: Template_Parameter_Standard_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Parameter_Standard_On_Conflict>;
};

/** on_conflict condition type for table "template_parameter_standard" */
export type Template_Parameter_Standard_On_Conflict = {
  constraint: Template_Parameter_Standard_Constraint;
  update_columns?: Array<Template_Parameter_Standard_Update_Column>;
  where?: InputMaybe<Template_Parameter_Standard_Bool_Exp>;
};

/** Ordering options when selecting data from "template_parameter_standard". */
export type Template_Parameter_Standard_Order_By = {
  attachments_aggregate?: InputMaybe<Template_Parameter_Standard_Attachments_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group?: InputMaybe<Template_Parameter_Standard_Group_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  template_parameter?: InputMaybe<Template_Parameter_Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_parameter_standard */
export type Template_Parameter_Standard_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_parameter_standard" */
export enum Template_Parameter_Standard_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Remark = 'remark',
  /** column name */
  TemplateParameterId = 'template_parameter_id'
}

/** input type for updating data in table "template_parameter_standard" */
export type Template_Parameter_Standard_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Parameter_Standard_Stddev_Fields = {
  __typename?: 'template_parameter_standard_stddev_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Stddev_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Parameter_Standard_Stddev_Pop_Fields = {
  __typename?: 'template_parameter_standard_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Stddev_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Parameter_Standard_Stddev_Samp_Fields = {
  __typename?: 'template_parameter_standard_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Stddev_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_parameter_standard" */
export type Template_Parameter_Standard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Parameter_Standard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Parameter_Standard_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  template_parameter_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Parameter_Standard_Sum_Fields = {
  __typename?: 'template_parameter_standard_sum_fields';
  group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  template_parameter_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Sum_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** update columns of table "template_parameter_standard" */
export enum Template_Parameter_Standard_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Remark = 'remark',
  /** column name */
  TemplateParameterId = 'template_parameter_id'
}

export type Template_Parameter_Standard_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Parameter_Standard_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Parameter_Standard_Set_Input>;
  where: Template_Parameter_Standard_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Parameter_Standard_Var_Pop_Fields = {
  __typename?: 'template_parameter_standard_var_pop_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Var_Pop_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Parameter_Standard_Var_Samp_Fields = {
  __typename?: 'template_parameter_standard_var_samp_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Var_Samp_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Parameter_Standard_Variance_Fields = {
  __typename?: 'template_parameter_standard_variance_fields';
  group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  template_parameter_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_parameter_standard" */
export type Template_Parameter_Standard_Variance_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  template_parameter_id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Template_Parameter_Stddev_Fields = {
  __typename?: 'template_parameter_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  observation_count?: Maybe<Scalars['Float']>;
  parent_template_parameter_id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weightage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_parameter" */
export type Template_Parameter_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Parameter_Stddev_Pop_Fields = {
  __typename?: 'template_parameter_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  observation_count?: Maybe<Scalars['Float']>;
  parent_template_parameter_id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weightage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_parameter" */
export type Template_Parameter_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Parameter_Stddev_Samp_Fields = {
  __typename?: 'template_parameter_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  observation_count?: Maybe<Scalars['Float']>;
  parent_template_parameter_id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weightage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_parameter" */
export type Template_Parameter_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_parameter" */
export type Template_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Parameter_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  disable_config?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  observation_count?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['_varchar']>;
  parent_template_parameter_id?: InputMaybe<Scalars['bigint']>;
  precision?: InputMaybe<Scalars['Int']>;
  quality_parameter_id?: InputMaybe<Scalars['bigint']>;
  sequence?: InputMaybe<Scalars['Int']>;
  standard?: InputMaybe<Scalars['String']>;
  template_id?: InputMaybe<Scalars['bigint']>;
  uid?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
  weightage?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Template_Parameter_Sum_Fields = {
  __typename?: 'template_parameter_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  observation_count?: Maybe<Scalars['Int']>;
  parent_template_parameter_id?: Maybe<Scalars['bigint']>;
  precision?: Maybe<Scalars['Int']>;
  quality_parameter_id?: Maybe<Scalars['bigint']>;
  sequence?: Maybe<Scalars['Int']>;
  template_id?: Maybe<Scalars['bigint']>;
  unit_id?: Maybe<Scalars['bigint']>;
  weightage?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "template_parameter" */
export type Template_Parameter_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** update columns of table "template_parameter" */
export enum Template_Parameter_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisableConfig = 'disable_config',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsMandatory = 'is_mandatory',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  ObservationCount = 'observation_count',
  /** column name */
  Options = 'options',
  /** column name */
  ParentTemplateParameterId = 'parent_template_parameter_id',
  /** column name */
  Precision = 'precision',
  /** column name */
  QualityParameterId = 'quality_parameter_id',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  Standard = 'standard',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Uid = 'uid',
  /** column name */
  UnitId = 'unit_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till',
  /** column name */
  Weightage = 'weightage'
}

export type Template_Parameter_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Template_Parameter_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Template_Parameter_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Template_Parameter_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Template_Parameter_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Parameter_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Template_Parameter_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Parameter_Set_Input>;
  where: Template_Parameter_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Parameter_Var_Pop_Fields = {
  __typename?: 'template_parameter_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  observation_count?: Maybe<Scalars['Float']>;
  parent_template_parameter_id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weightage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_parameter" */
export type Template_Parameter_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Parameter_Var_Samp_Fields = {
  __typename?: 'template_parameter_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  observation_count?: Maybe<Scalars['Float']>;
  parent_template_parameter_id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weightage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_parameter" */
export type Template_Parameter_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Parameter_Variance_Fields = {
  __typename?: 'template_parameter_variance_fields';
  id?: Maybe<Scalars['Float']>;
  observation_count?: Maybe<Scalars['Float']>;
  parent_template_parameter_id?: Maybe<Scalars['Float']>;
  precision?: Maybe<Scalars['Float']>;
  quality_parameter_id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
  unit_id?: Maybe<Scalars['Float']>;
  weightage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_parameter" */
export type Template_Parameter_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  observation_count?: InputMaybe<Order_By>;
  parent_template_parameter_id?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  quality_parameter_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  weightage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template */
export type Template_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Template_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "template_quality_stages" */
export type Template_Quality_Stages = {
  __typename?: 'template_quality_stages';
  id: Scalars['bigint'];
  /** An object relationship */
  quality_stage: Quality_Stage;
  qualitystage_id: Scalars['bigint'];
  /** An object relationship */
  template: Template;
  template_id: Scalars['bigint'];
};

/** aggregated selection of "template_quality_stages" */
export type Template_Quality_Stages_Aggregate = {
  __typename?: 'template_quality_stages_aggregate';
  aggregate?: Maybe<Template_Quality_Stages_Aggregate_Fields>;
  nodes: Array<Template_Quality_Stages>;
};

/** aggregate fields of "template_quality_stages" */
export type Template_Quality_Stages_Aggregate_Fields = {
  __typename?: 'template_quality_stages_aggregate_fields';
  avg?: Maybe<Template_Quality_Stages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Template_Quality_Stages_Max_Fields>;
  min?: Maybe<Template_Quality_Stages_Min_Fields>;
  stddev?: Maybe<Template_Quality_Stages_Stddev_Fields>;
  stddev_pop?: Maybe<Template_Quality_Stages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Template_Quality_Stages_Stddev_Samp_Fields>;
  sum?: Maybe<Template_Quality_Stages_Sum_Fields>;
  var_pop?: Maybe<Template_Quality_Stages_Var_Pop_Fields>;
  var_samp?: Maybe<Template_Quality_Stages_Var_Samp_Fields>;
  variance?: Maybe<Template_Quality_Stages_Variance_Fields>;
};


/** aggregate fields of "template_quality_stages" */
export type Template_Quality_Stages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Template_Quality_Stages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "template_quality_stages" */
export type Template_Quality_Stages_Aggregate_Order_By = {
  avg?: InputMaybe<Template_Quality_Stages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Template_Quality_Stages_Max_Order_By>;
  min?: InputMaybe<Template_Quality_Stages_Min_Order_By>;
  stddev?: InputMaybe<Template_Quality_Stages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Template_Quality_Stages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Template_Quality_Stages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Template_Quality_Stages_Sum_Order_By>;
  var_pop?: InputMaybe<Template_Quality_Stages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Template_Quality_Stages_Var_Samp_Order_By>;
  variance?: InputMaybe<Template_Quality_Stages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "template_quality_stages" */
export type Template_Quality_Stages_Arr_Rel_Insert_Input = {
  data: Array<Template_Quality_Stages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Template_Quality_Stages_On_Conflict>;
};

/** aggregate avg on columns */
export type Template_Quality_Stages_Avg_Fields = {
  __typename?: 'template_quality_stages_avg_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "template_quality_stages". All fields are combined with a logical 'AND'. */
export type Template_Quality_Stages_Bool_Exp = {
  _and?: InputMaybe<Array<Template_Quality_Stages_Bool_Exp>>;
  _not?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
  _or?: InputMaybe<Array<Template_Quality_Stages_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  quality_stage?: InputMaybe<Quality_Stage_Bool_Exp>;
  qualitystage_id?: InputMaybe<Bigint_Comparison_Exp>;
  template?: InputMaybe<Template_Bool_Exp>;
  template_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "template_quality_stages" */
export enum Template_Quality_Stages_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemplateQualityStagesPkey = 'template_quality_stages_pkey',
  /** unique or primary key constraint on columns "qualitystage_id", "template_id" */
  TemplateQualityStagesTemplateIdQualitystage_57fc6fd2Uniq = 'template_quality_stages_template_id_qualitystage_57fc6fd2_uniq'
}

/** input type for incrementing numeric columns in table "template_quality_stages" */
export type Template_Quality_Stages_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "template_quality_stages" */
export type Template_Quality_Stages_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  quality_stage?: InputMaybe<Quality_Stage_Obj_Rel_Insert_Input>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  template?: InputMaybe<Template_Obj_Rel_Insert_Input>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Template_Quality_Stages_Max_Fields = {
  __typename?: 'template_quality_stages_max_fields';
  id?: Maybe<Scalars['bigint']>;
  qualitystage_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Template_Quality_Stages_Min_Fields = {
  __typename?: 'template_quality_stages_min_fields';
  id?: Maybe<Scalars['bigint']>;
  qualitystage_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "template_quality_stages" */
export type Template_Quality_Stages_Mutation_Response = {
  __typename?: 'template_quality_stages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Template_Quality_Stages>;
};

/** on_conflict condition type for table "template_quality_stages" */
export type Template_Quality_Stages_On_Conflict = {
  constraint: Template_Quality_Stages_Constraint;
  update_columns?: Array<Template_Quality_Stages_Update_Column>;
  where?: InputMaybe<Template_Quality_Stages_Bool_Exp>;
};

/** Ordering options when selecting data from "template_quality_stages". */
export type Template_Quality_Stages_Order_By = {
  id?: InputMaybe<Order_By>;
  quality_stage?: InputMaybe<Quality_Stage_Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template?: InputMaybe<Template_Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: template_quality_stages */
export type Template_Quality_Stages_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "template_quality_stages" */
export enum Template_Quality_Stages_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualitystageId = 'qualitystage_id',
  /** column name */
  TemplateId = 'template_id'
}

/** input type for updating data in table "template_quality_stages" */
export type Template_Quality_Stages_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Template_Quality_Stages_Stddev_Fields = {
  __typename?: 'template_quality_stages_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Quality_Stages_Stddev_Pop_Fields = {
  __typename?: 'template_quality_stages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Quality_Stages_Stddev_Samp_Fields = {
  __typename?: 'template_quality_stages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template_quality_stages" */
export type Template_Quality_Stages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Quality_Stages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Quality_Stages_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  qualitystage_id?: InputMaybe<Scalars['bigint']>;
  template_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Template_Quality_Stages_Sum_Fields = {
  __typename?: 'template_quality_stages_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  qualitystage_id?: Maybe<Scalars['bigint']>;
  template_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** update columns of table "template_quality_stages" */
export enum Template_Quality_Stages_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QualitystageId = 'qualitystage_id',
  /** column name */
  TemplateId = 'template_id'
}

export type Template_Quality_Stages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Quality_Stages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Quality_Stages_Set_Input>;
  where: Template_Quality_Stages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Quality_Stages_Var_Pop_Fields = {
  __typename?: 'template_quality_stages_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Quality_Stages_Var_Samp_Fields = {
  __typename?: 'template_quality_stages_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Quality_Stages_Variance_Fields = {
  __typename?: 'template_quality_stages_variance_fields';
  id?: Maybe<Scalars['Float']>;
  qualitystage_id?: Maybe<Scalars['Float']>;
  template_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template_quality_stages" */
export type Template_Quality_Stages_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  qualitystage_id?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
};

/** select columns of table "template" */
export enum Template_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentNumber = 'document_number',
  /** column name */
  DocumentRevisionId = 'document_revision_id',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ParentTemplateId = 'parent_template_id',
  /** column name */
  QualityStageId = 'quality_stage_id',
  /** column name */
  SampleCount = 'sample_count',
  /** column name */
  TestForId = 'test_for_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till'
}

/** input type for updating data in table "template" */
export type Template_Set_Input = {
  brand_id?: InputMaybe<Scalars['bigint']>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  document_number?: InputMaybe<Scalars['String']>;
  document_revision_id?: InputMaybe<Scalars['bigint']>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['bigint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
  parent_template_id?: InputMaybe<Scalars['bigint']>;
  quality_stage_id?: InputMaybe<Scalars['bigint']>;
  sample_count?: InputMaybe<Scalars['Int']>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Template_Stddev_Fields = {
  __typename?: 'template_stddev_fields';
  brand_id?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  document_revision_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  parent_template_id?: Maybe<Scalars['Float']>;
  quality_stage_id?: Maybe<Scalars['Float']>;
  sample_count?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "template" */
export type Template_Stddev_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Template_Stddev_Pop_Fields = {
  __typename?: 'template_stddev_pop_fields';
  brand_id?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  document_revision_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  parent_template_id?: Maybe<Scalars['Float']>;
  quality_stage_id?: Maybe<Scalars['Float']>;
  sample_count?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "template" */
export type Template_Stddev_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Template_Stddev_Samp_Fields = {
  __typename?: 'template_stddev_samp_fields';
  brand_id?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  document_revision_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  parent_template_id?: Maybe<Scalars['Float']>;
  quality_stage_id?: Maybe<Scalars['Float']>;
  sample_count?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "template" */
export type Template_Stddev_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "template" */
export type Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Template_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['bigint']>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  created_in_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  document_number?: InputMaybe<Scalars['String']>;
  document_revision_id?: InputMaybe<Scalars['bigint']>;
  grade_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  market_id?: InputMaybe<Scalars['bigint']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_id?: InputMaybe<Scalars['bigint']>;
  parent_template_id?: InputMaybe<Scalars['bigint']>;
  quality_stage_id?: InputMaybe<Scalars['bigint']>;
  sample_count?: InputMaybe<Scalars['Int']>;
  test_for_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_till?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Template_Sum_Fields = {
  __typename?: 'template_sum_fields';
  brand_id?: Maybe<Scalars['bigint']>;
  category_id?: Maybe<Scalars['bigint']>;
  document_revision_id?: Maybe<Scalars['bigint']>;
  grade_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  market_id?: Maybe<Scalars['bigint']>;
  organisation_id?: Maybe<Scalars['bigint']>;
  parent_template_id?: Maybe<Scalars['bigint']>;
  quality_stage_id?: Maybe<Scalars['bigint']>;
  sample_count?: Maybe<Scalars['Int']>;
  test_for_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "template" */
export type Template_Sum_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** update columns of table "template" */
export enum Template_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentNumber = 'document_number',
  /** column name */
  DocumentRevisionId = 'document_revision_id',
  /** column name */
  GradeId = 'grade_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MarketId = 'market_id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ParentTemplateId = 'parent_template_id',
  /** column name */
  QualityStageId = 'quality_stage_id',
  /** column name */
  SampleCount = 'sample_count',
  /** column name */
  TestForId = 'test_for_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTill = 'valid_till'
}

export type Template_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Template_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Template_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Template_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Template_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Template_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Template_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Template_Set_Input>;
  where: Template_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Template_Var_Pop_Fields = {
  __typename?: 'template_var_pop_fields';
  brand_id?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  document_revision_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  parent_template_id?: Maybe<Scalars['Float']>;
  quality_stage_id?: Maybe<Scalars['Float']>;
  sample_count?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "template" */
export type Template_Var_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Template_Var_Samp_Fields = {
  __typename?: 'template_var_samp_fields';
  brand_id?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  document_revision_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  parent_template_id?: Maybe<Scalars['Float']>;
  quality_stage_id?: Maybe<Scalars['Float']>;
  sample_count?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "template" */
export type Template_Var_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Template_Variance_Fields = {
  __typename?: 'template_variance_fields';
  brand_id?: Maybe<Scalars['Float']>;
  category_id?: Maybe<Scalars['Float']>;
  document_revision_id?: Maybe<Scalars['Float']>;
  grade_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  market_id?: Maybe<Scalars['Float']>;
  organisation_id?: Maybe<Scalars['Float']>;
  parent_template_id?: Maybe<Scalars['Float']>;
  quality_stage_id?: Maybe<Scalars['Float']>;
  sample_count?: Maybe<Scalars['Float']>;
  test_for_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "template" */
export type Template_Variance_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  document_revision_id?: InputMaybe<Order_By>;
  grade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  market_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  parent_template_id?: InputMaybe<Order_By>;
  quality_stage_id?: InputMaybe<Order_By>;
  sample_count?: InputMaybe<Order_By>;
  test_for_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "trade" */
export type Trade = {
  __typename?: 'trade';
  /** An array relationship */
  action_logs: Array<Trade_Action_Log>;
  /** An array relationship */
  advance_payments: Array<Advance_Payment>;
  /** An aggregate relationship */
  advance_payments_aggregate: Advance_Payment_Aggregate;
  advance_po: Scalars['Boolean'];
  advance_summary?: Maybe<AdvanceSummaryType>;
  /** An array relationship */
  attachments: Array<Trade_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Trade_Attachments_Aggregate;
  /** An object relationship */
  buyer?: Maybe<Setu_Trade_Shared_Entity>;
  buyer_bifurcation?: Maybe<BuyerBifurcationType>;
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  buyer_expense_gst_auto_calculated: Scalars['Boolean'];
  /** An array relationship */
  buyer_gst_attachments: Array<Trade_Buyer_Gst_Attachments>;
  /** An aggregate relationship */
  buyer_gst_attachments_aggregate: Trade_Buyer_Gst_Attachments_Aggregate;
  buyer_hash?: Maybe<Scalars['String']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  buyer_plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  buyer_plot_crop_id?: Maybe<Scalars['bigint']>;
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_settlement_status?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  buyer_verification?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  commodity?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  commodity_variety?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  created_by: Array<Base_User>;
  created_by_id: Scalars['String'];
  /** An array relationship */
  credit_notes: Array<Credit_Note>;
  /** An aggregate relationship */
  credit_notes_aggregate: Credit_Note_Aggregate;
  /** An object relationship */
  current_status?: Maybe<Trade_Status>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  demand?: Maybe<Demand>;
  demand_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  department: Setu_Trade_Shared_Entity;
  department_id: Scalars['bigint'];
  direct_cost?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  expense_taxes: Array<Trade_Expense_Tax>;
  /** An aggregate relationship */
  expense_taxes_aggregate: Trade_Expense_Tax_Aggregate;
  /** An array relationship */
  expenses: Array<Expense>;
  /** An aggregate relationship */
  expenses_aggregate: Expense_Aggregate;
  expiry?: Maybe<Scalars['date']>;
  /** An object relationship */
  facilitator?: Maybe<Setu_Trade_Shared_Entity>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  has_advance_release_pending?: Maybe<Scalars['Boolean']>;
  has_verification_pending_advance?: Maybe<Scalars['Boolean']>;
  id: Scalars['bigint'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_id?: Maybe<Scalars['bigint']>;
  is_deviation_draft?: Maybe<Scalars['Boolean']>;
  is_intercompany_transaction: Scalars['Boolean'];
  is_multiple_commodity: Scalars['Boolean'];
  /** An array relationship */
  issuance_notes: Array<Issuance_Note>;
  /** An aggregate relationship */
  issuance_notes_aggregate: Issuance_Note_Aggregate;
  /** An object relationship */
  junior_officer?: Maybe<Setu_Trade_Shared_Entity>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  kind: Scalars['String'];
  material_kind?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  mis_date_1?: Maybe<Scalars['date']>;
  mode: Scalars['String'];
  offer_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  officer?: Maybe<Setu_Trade_Shared_Entity>;
  officer_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  over_draft?: Maybe<Over_Draft_Cw>;
  /** An object relationship */
  over_due_approval?: Maybe<Over_Due_Approval_Cw>;
  packaging: Scalars['String'];
  /** An object relationship */
  parent_trade?: Maybe<Trade>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  production_trade?: Maybe<Production_Trade>;
  production_trade_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  production_trade_item_storage_pickeds: Array<Production_Trade_Item_Storage_Picked>;
  /** An aggregate relationship */
  production_trade_item_storage_pickeds_aggregate: Production_Trade_Item_Storage_Picked_Aggregate;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  receipt?: Maybe<Receipt>;
  receipt_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  reverse_status_mode: Scalars['Boolean'];
  sales_value?: Maybe<Scalars['float8']>;
  /** An object relationship */
  seller?: Maybe<Setu_Trade_Shared_Entity>;
  seller_bifurcation?: Maybe<SellerBifurcationType>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_expense_amount?: Maybe<Scalars['float8']>;
  /** An array relationship */
  seller_gst_attachments: Array<Trade_Seller_Gst_Attachments>;
  /** An aggregate relationship */
  seller_gst_attachments_aggregate: Trade_Seller_Gst_Attachments_Aggregate;
  seller_hash?: Maybe<Scalars['String']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_payable?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  seller_remark?: Maybe<Scalars['String']>;
  seller_settlement_status?: Maybe<Scalars['String']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  seller_tnc?: Maybe<Scalars['String']>;
  seller_verification?: Maybe<Scalars['Boolean']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  status_processing: Scalars['Boolean'];
  /** An object relationship */
  storage_location?: Maybe<Storage_Location>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  storage_sub_location?: Maybe<Storage_Sub_Location>;
  storage_sub_location_id?: Maybe<Scalars['bigint']>;
  summary?: Maybe<TradeSummaryType>;
  supplier_charge?: Maybe<Scalars['float8']>;
  supplier_expense_gst_auto_calculated: Scalars['Boolean'];
  supplier_rate?: Maybe<Scalars['float8']>;
  /** An array relationship */
  taxes: Array<Trade_Taxes>;
  /** An aggregate relationship */
  taxes_aggregate: Trade_Taxes_Aggregate;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code: Scalars['String'];
  trade_amounts_counter: Scalars['Int'];
  /** An array relationship */
  trade_items: Array<Trade_Item>;
  /** An aggregate relationship */
  trade_items_aggregate: Trade_Item_Aggregate;
  /** An array relationship */
  trades: Array<Trade>;
  /** An aggregate relationship */
  trades_aggregate: Trade_Aggregate;
  /** An array relationship */
  transactions: Array<Transaction>;
  /** An aggregate relationship */
  transactions_aggregate: Transaction_Aggregate;
  /** An object relationship */
  trip?: Maybe<Setutrade_Trip>;
  trip_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  updated_by: Array<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  vehicle?: Maybe<Setu_Trade_Shared_Entity>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "trade" */
export type TradeAction_LogsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Action_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Action_Log_Order_By>>;
  where?: InputMaybe<Trade_Action_Log_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeAdvance_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeAdvance_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advance_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advance_Payment_Order_By>>;
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeBuyer_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeBuyer_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeCreated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Tradecreated_By>;
};


/** columns and relationships of "trade" */
export type TradeCredit_NotesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeCredit_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeExpense_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Expense_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Expense_Tax_Order_By>>;
  where?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeExpense_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Expense_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Expense_Tax_Order_By>>;
  where?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeExpensesArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expense_Order_By>>;
  where?: InputMaybe<Expense_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeIssuance_NotesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeIssuance_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Order_By>>;
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "trade" */
export type TradeProduction_Trade_Item_Storage_PickedsArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeProduction_Trade_Item_Storage_Pickeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Production_Trade_Item_Storage_Picked_Order_By>>;
  where?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeSeller_Gst_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeSeller_Gst_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTaxesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTaxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTrade_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTrade_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTradesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By>>;
  where?: InputMaybe<Trade_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeTransactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "trade" */
export type TradeUpdated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Tradeupdated_By>;
};

/** columns and relationships of "action_log" */
export type Trade_Action_Log = {
  __typename?: 'trade_action_log';
  action_flag: Scalars['String'];
  change_message: Scalars['String'];
  change_object?: Maybe<Scalars['jsonb']>;
  change_title: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  id: Scalars['bigint'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "action_log" */
export type Trade_Action_LogChange_ObjectArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** order by aggregate values of table "action_log" */
export type Trade_Action_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Action_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Action_Log_Max_Order_By>;
  min?: InputMaybe<Trade_Action_Log_Min_Order_By>;
  stddev?: InputMaybe<Trade_Action_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Action_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Action_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Action_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Action_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Action_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Action_Log_Variance_Order_By>;
};

/** order by avg() on columns of table "action_log" */
export type Trade_Action_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "action_log". All fields are combined with a logical 'AND'. */
export type Trade_Action_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Action_Log_Bool_Exp>>;
  _not?: InputMaybe<Trade_Action_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Action_Log_Bool_Exp>>;
  action_flag?: InputMaybe<String_Comparison_Exp>;
  change_message?: InputMaybe<String_Comparison_Exp>;
  change_object?: InputMaybe<Jsonb_Comparison_Exp>;
  change_title?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "action_log" */
export type Trade_Action_Log_Max_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_title?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "action_log" */
export type Trade_Action_Log_Min_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_title?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "action_log". */
export type Trade_Action_Log_Order_By = {
  action_flag?: InputMaybe<Order_By>;
  change_message?: InputMaybe<Order_By>;
  change_object?: InputMaybe<Order_By>;
  change_title?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** select columns of table "action_log" */
export enum Trade_Action_Log_Select_Column {
  /** column name */
  ActionFlag = 'action_flag',
  /** column name */
  ChangeMessage = 'change_message',
  /** column name */
  ChangeObject = 'change_object',
  /** column name */
  ChangeTitle = 'change_title',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** order by stddev() on columns of table "action_log" */
export type Trade_Action_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "action_log" */
export type Trade_Action_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "action_log" */
export type Trade_Action_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_action_log" */
export type Trade_Action_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Action_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Action_Log_Stream_Cursor_Value_Input = {
  action_flag?: InputMaybe<Scalars['String']>;
  change_message?: InputMaybe<Scalars['String']>;
  change_object?: InputMaybe<Scalars['jsonb']>;
  change_title?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "action_log" */
export type Trade_Action_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "action_log" */
export type Trade_Action_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "action_log" */
export type Trade_Action_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "action_log" */
export type Trade_Action_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "trade" */
export type Trade_Aggregate = {
  __typename?: 'trade_aggregate';
  aggregate?: Maybe<Trade_Aggregate_Fields>;
  nodes: Array<Trade>;
};

/** aggregate fields of "trade" */
export type Trade_Aggregate_Fields = {
  __typename?: 'trade_aggregate_fields';
  avg?: Maybe<Trade_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Max_Fields>;
  min?: Maybe<Trade_Min_Fields>;
  stddev?: Maybe<Trade_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Sum_Fields>;
  var_pop?: Maybe<Trade_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Var_Samp_Fields>;
  variance?: Maybe<Trade_Variance_Fields>;
};


/** aggregate fields of "trade" */
export type Trade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade" */
export type Trade_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Max_Order_By>;
  min?: InputMaybe<Trade_Min_Order_By>;
  stddev?: InputMaybe<Trade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade" */
export type Trade_Arr_Rel_Insert_Input = {
  data: Array<Trade_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};

/** columns and relationships of "trade_assessment" */
export type Trade_Assessment = {
  __typename?: 'trade_assessment';
  assessed_limit?: Maybe<Scalars['float8']>;
  credit_id: Scalars['bigint'];
  daily_average_sale?: Maybe<Scalars['float8']>;
  end_date: Scalars['date'];
  id: Scalars['bigint'];
  payment_cycle: Scalars['Int'];
  settled_trade_count?: Maybe<Scalars['Int']>;
  start_date: Scalars['date'];
  tenure: Scalars['Int'];
  total_sales?: Maybe<Scalars['float8']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "trade_assessment" */
export type Trade_Assessment_Aggregate = {
  __typename?: 'trade_assessment_aggregate';
  aggregate?: Maybe<Trade_Assessment_Aggregate_Fields>;
  nodes: Array<Trade_Assessment>;
};

/** aggregate fields of "trade_assessment" */
export type Trade_Assessment_Aggregate_Fields = {
  __typename?: 'trade_assessment_aggregate_fields';
  avg?: Maybe<Trade_Assessment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Assessment_Max_Fields>;
  min?: Maybe<Trade_Assessment_Min_Fields>;
  stddev?: Maybe<Trade_Assessment_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Assessment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Assessment_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Assessment_Sum_Fields>;
  var_pop?: Maybe<Trade_Assessment_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Assessment_Var_Samp_Fields>;
  variance?: Maybe<Trade_Assessment_Variance_Fields>;
};


/** aggregate fields of "trade_assessment" */
export type Trade_Assessment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Assessment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_assessment" */
export type Trade_Assessment_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Assessment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Assessment_Max_Order_By>;
  min?: InputMaybe<Trade_Assessment_Min_Order_By>;
  stddev?: InputMaybe<Trade_Assessment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Assessment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Assessment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Assessment_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Assessment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Assessment_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Assessment_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Trade_Assessment_Avg_Fields = {
  __typename?: 'trade_assessment_avg_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_assessment" */
export type Trade_Assessment_Avg_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_assessment". All fields are combined with a logical 'AND'. */
export type Trade_Assessment_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Assessment_Bool_Exp>>;
  _not?: InputMaybe<Trade_Assessment_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Assessment_Bool_Exp>>;
  assessed_limit?: InputMaybe<Float8_Comparison_Exp>;
  credit_id?: InputMaybe<Bigint_Comparison_Exp>;
  daily_average_sale?: InputMaybe<Float8_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_cycle?: InputMaybe<Int_Comparison_Exp>;
  settled_trade_count?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenure?: InputMaybe<Int_Comparison_Exp>;
  total_sales?: InputMaybe<Float8_Comparison_Exp>;
  trade_count?: InputMaybe<Int_Comparison_Exp>;
  unsettled_trade_count?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "trade_assessment_cw" */
export type Trade_Assessment_Cw = {
  __typename?: 'trade_assessment_cw';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id: Scalars['bigint'];
  daily_average_sale?: Maybe<Scalars['numeric']>;
  end_date: Scalars['date'];
  id: Scalars['bigint'];
  payment_cycle: Scalars['Int'];
  settled_trade_count?: Maybe<Scalars['Int']>;
  start_date: Scalars['date'];
  tenure: Scalars['Int'];
  total_sales?: Maybe<Scalars['numeric']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "trade_assessment_cw" */
export type Trade_Assessment_Cw_Aggregate = {
  __typename?: 'trade_assessment_cw_aggregate';
  aggregate?: Maybe<Trade_Assessment_Cw_Aggregate_Fields>;
  nodes: Array<Trade_Assessment_Cw>;
};

/** aggregate fields of "trade_assessment_cw" */
export type Trade_Assessment_Cw_Aggregate_Fields = {
  __typename?: 'trade_assessment_cw_aggregate_fields';
  avg?: Maybe<Trade_Assessment_Cw_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Assessment_Cw_Max_Fields>;
  min?: Maybe<Trade_Assessment_Cw_Min_Fields>;
  stddev?: Maybe<Trade_Assessment_Cw_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Assessment_Cw_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Assessment_Cw_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Assessment_Cw_Sum_Fields>;
  var_pop?: Maybe<Trade_Assessment_Cw_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Assessment_Cw_Var_Samp_Fields>;
  variance?: Maybe<Trade_Assessment_Cw_Variance_Fields>;
};


/** aggregate fields of "trade_assessment_cw" */
export type Trade_Assessment_Cw_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Assessment_Cw_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Assessment_Cw_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Assessment_Cw_Max_Order_By>;
  min?: InputMaybe<Trade_Assessment_Cw_Min_Order_By>;
  stddev?: InputMaybe<Trade_Assessment_Cw_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Assessment_Cw_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Assessment_Cw_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Assessment_Cw_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Assessment_Cw_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Assessment_Cw_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Assessment_Cw_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Trade_Assessment_Cw_Avg_Fields = {
  __typename?: 'trade_assessment_cw_avg_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Avg_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_assessment_cw". All fields are combined with a logical 'AND'. */
export type Trade_Assessment_Cw_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Assessment_Cw_Bool_Exp>>;
  _not?: InputMaybe<Trade_Assessment_Cw_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Assessment_Cw_Bool_Exp>>;
  assessed_limit?: InputMaybe<Numeric_Comparison_Exp>;
  credit_wallet_request_id?: InputMaybe<Bigint_Comparison_Exp>;
  daily_average_sale?: InputMaybe<Numeric_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  payment_cycle?: InputMaybe<Int_Comparison_Exp>;
  settled_trade_count?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenure?: InputMaybe<Int_Comparison_Exp>;
  total_sales?: InputMaybe<Numeric_Comparison_Exp>;
  trade_count?: InputMaybe<Int_Comparison_Exp>;
  unsettled_trade_count?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Trade_Assessment_Cw_Max_Fields = {
  __typename?: 'trade_assessment_cw_max_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  settled_trade_count?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['numeric']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Max_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Assessment_Cw_Min_Fields = {
  __typename?: 'trade_assessment_cw_min_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  settled_trade_count?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['numeric']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Min_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_assessment_cw". */
export type Trade_Assessment_Cw_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** select columns of table "trade_assessment_cw" */
export enum Trade_Assessment_Cw_Select_Column {
  /** column name */
  AssessedLimit = 'assessed_limit',
  /** column name */
  CreditWalletRequestId = 'credit_wallet_request_id',
  /** column name */
  DailyAverageSale = 'daily_average_sale',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCycle = 'payment_cycle',
  /** column name */
  SettledTradeCount = 'settled_trade_count',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Tenure = 'tenure',
  /** column name */
  TotalSales = 'total_sales',
  /** column name */
  TradeCount = 'trade_count',
  /** column name */
  UnsettledTradeCount = 'unsettled_trade_count'
}

/** aggregate stddev on columns */
export type Trade_Assessment_Cw_Stddev_Fields = {
  __typename?: 'trade_assessment_cw_stddev_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Stddev_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Assessment_Cw_Stddev_Pop_Fields = {
  __typename?: 'trade_assessment_cw_stddev_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Stddev_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Assessment_Cw_Stddev_Samp_Fields = {
  __typename?: 'trade_assessment_cw_stddev_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Stddev_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Assessment_Cw_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Assessment_Cw_Stream_Cursor_Value_Input = {
  assessed_limit?: InputMaybe<Scalars['numeric']>;
  credit_wallet_request_id?: InputMaybe<Scalars['bigint']>;
  daily_average_sale?: InputMaybe<Scalars['numeric']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  settled_trade_count?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenure?: InputMaybe<Scalars['Int']>;
  total_sales?: InputMaybe<Scalars['numeric']>;
  trade_count?: InputMaybe<Scalars['Int']>;
  unsettled_trade_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Trade_Assessment_Cw_Sum_Fields = {
  __typename?: 'trade_assessment_cw_sum_fields';
  assessed_limit?: Maybe<Scalars['numeric']>;
  credit_wallet_request_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  settled_trade_count?: Maybe<Scalars['Int']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['numeric']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Sum_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Trade_Assessment_Cw_Var_Pop_Fields = {
  __typename?: 'trade_assessment_cw_var_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Var_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Assessment_Cw_Var_Samp_Fields = {
  __typename?: 'trade_assessment_cw_var_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Var_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Assessment_Cw_Variance_Fields = {
  __typename?: 'trade_assessment_cw_variance_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_wallet_request_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_assessment_cw" */
export type Trade_Assessment_Cw_Variance_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_wallet_request_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Trade_Assessment_Max_Fields = {
  __typename?: 'trade_assessment_max_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  settled_trade_count?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['float8']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "trade_assessment" */
export type Trade_Assessment_Max_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Assessment_Min_Fields = {
  __typename?: 'trade_assessment_min_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  settled_trade_count?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['float8']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "trade_assessment" */
export type Trade_Assessment_Min_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_assessment". */
export type Trade_Assessment_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** select columns of table "trade_assessment" */
export enum Trade_Assessment_Select_Column {
  /** column name */
  AssessedLimit = 'assessed_limit',
  /** column name */
  CreditId = 'credit_id',
  /** column name */
  DailyAverageSale = 'daily_average_sale',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCycle = 'payment_cycle',
  /** column name */
  SettledTradeCount = 'settled_trade_count',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Tenure = 'tenure',
  /** column name */
  TotalSales = 'total_sales',
  /** column name */
  TradeCount = 'trade_count',
  /** column name */
  UnsettledTradeCount = 'unsettled_trade_count'
}

/** aggregate stddev on columns */
export type Trade_Assessment_Stddev_Fields = {
  __typename?: 'trade_assessment_stddev_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_assessment" */
export type Trade_Assessment_Stddev_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Assessment_Stddev_Pop_Fields = {
  __typename?: 'trade_assessment_stddev_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_assessment" */
export type Trade_Assessment_Stddev_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Assessment_Stddev_Samp_Fields = {
  __typename?: 'trade_assessment_stddev_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_assessment" */
export type Trade_Assessment_Stddev_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_assessment" */
export type Trade_Assessment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Assessment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Assessment_Stream_Cursor_Value_Input = {
  assessed_limit?: InputMaybe<Scalars['float8']>;
  credit_id?: InputMaybe<Scalars['bigint']>;
  daily_average_sale?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['bigint']>;
  payment_cycle?: InputMaybe<Scalars['Int']>;
  settled_trade_count?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenure?: InputMaybe<Scalars['Int']>;
  total_sales?: InputMaybe<Scalars['float8']>;
  trade_count?: InputMaybe<Scalars['Int']>;
  unsettled_trade_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Trade_Assessment_Sum_Fields = {
  __typename?: 'trade_assessment_sum_fields';
  assessed_limit?: Maybe<Scalars['float8']>;
  credit_id?: Maybe<Scalars['bigint']>;
  daily_average_sale?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['bigint']>;
  payment_cycle?: Maybe<Scalars['Int']>;
  settled_trade_count?: Maybe<Scalars['Int']>;
  tenure?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['float8']>;
  trade_count?: Maybe<Scalars['Int']>;
  unsettled_trade_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "trade_assessment" */
export type Trade_Assessment_Sum_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Trade_Assessment_Var_Pop_Fields = {
  __typename?: 'trade_assessment_var_pop_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_assessment" */
export type Trade_Assessment_Var_Pop_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Assessment_Var_Samp_Fields = {
  __typename?: 'trade_assessment_var_samp_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_assessment" */
export type Trade_Assessment_Var_Samp_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Assessment_Variance_Fields = {
  __typename?: 'trade_assessment_variance_fields';
  assessed_limit?: Maybe<Scalars['Float']>;
  credit_id?: Maybe<Scalars['Float']>;
  daily_average_sale?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_cycle?: Maybe<Scalars['Float']>;
  settled_trade_count?: Maybe<Scalars['Float']>;
  tenure?: Maybe<Scalars['Float']>;
  total_sales?: Maybe<Scalars['Float']>;
  trade_count?: Maybe<Scalars['Float']>;
  unsettled_trade_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_assessment" */
export type Trade_Assessment_Variance_Order_By = {
  assessed_limit?: InputMaybe<Order_By>;
  credit_id?: InputMaybe<Order_By>;
  daily_average_sale?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_cycle?: InputMaybe<Order_By>;
  settled_trade_count?: InputMaybe<Order_By>;
  tenure?: InputMaybe<Order_By>;
  total_sales?: InputMaybe<Order_By>;
  trade_count?: InputMaybe<Order_By>;
  unsettled_trade_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_attachments" */
export type Trade_Attachments = {
  __typename?: 'trade_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
};

/** aggregated selection of "trade_attachments" */
export type Trade_Attachments_Aggregate = {
  __typename?: 'trade_attachments_aggregate';
  aggregate?: Maybe<Trade_Attachments_Aggregate_Fields>;
  nodes: Array<Trade_Attachments>;
};

/** aggregate fields of "trade_attachments" */
export type Trade_Attachments_Aggregate_Fields = {
  __typename?: 'trade_attachments_aggregate_fields';
  avg?: Maybe<Trade_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Attachments_Max_Fields>;
  min?: Maybe<Trade_Attachments_Min_Fields>;
  stddev?: Maybe<Trade_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Attachments_Sum_Fields>;
  var_pop?: Maybe<Trade_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Trade_Attachments_Variance_Fields>;
};


/** aggregate fields of "trade_attachments" */
export type Trade_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_attachments" */
export type Trade_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Attachments_Max_Order_By>;
  min?: InputMaybe<Trade_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Trade_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_attachments" */
export type Trade_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Trade_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Attachments_Avg_Fields = {
  __typename?: 'trade_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_attachments" */
export type Trade_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_attachments". All fields are combined with a logical 'AND'. */
export type Trade_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Trade_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_attachments" */
export enum Trade_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeAttachmentsPkey = 'trade_attachments_pkey',
  /** unique or primary key constraint on columns "trade_id", "media_id" */
  TradeAttachmentsTradeIdMediaId_39bcf3c3Uniq = 'trade_attachments_trade_id_media_id_39bcf3c3_uniq'
}

/** input type for incrementing numeric columns in table "trade_attachments" */
export type Trade_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trade_attachments" */
export type Trade_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Setutrade_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Trade_Attachments_Max_Fields = {
  __typename?: 'trade_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_attachments" */
export type Trade_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Attachments_Min_Fields = {
  __typename?: 'trade_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_attachments" */
export type Trade_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_attachments" */
export type Trade_Attachments_Mutation_Response = {
  __typename?: 'trade_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Attachments>;
};

/** on_conflict condition type for table "trade_attachments" */
export type Trade_Attachments_On_Conflict = {
  constraint: Trade_Attachments_Constraint;
  update_columns?: Array<Trade_Attachments_Update_Column>;
  where?: InputMaybe<Trade_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_attachments". */
export type Trade_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_attachments */
export type Trade_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "trade_attachments" */
export enum Trade_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TradeId = 'trade_id'
}

/** input type for updating data in table "trade_attachments" */
export type Trade_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Trade_Attachments_Stddev_Fields = {
  __typename?: 'trade_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_attachments" */
export type Trade_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Attachments_Stddev_Pop_Fields = {
  __typename?: 'trade_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_attachments" */
export type Trade_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Attachments_Stddev_Samp_Fields = {
  __typename?: 'trade_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_attachments" */
export type Trade_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_attachments" */
export type Trade_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Attachments_Sum_Fields = {
  __typename?: 'trade_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_attachments" */
export type Trade_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** update columns of table "trade_attachments" */
export enum Trade_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TradeId = 'trade_id'
}

export type Trade_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Attachments_Set_Input>;
  where: Trade_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Attachments_Var_Pop_Fields = {
  __typename?: 'trade_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_attachments" */
export type Trade_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Attachments_Var_Samp_Fields = {
  __typename?: 'trade_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_attachments" */
export type Trade_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Attachments_Variance_Fields = {
  __typename?: 'trade_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_attachments" */
export type Trade_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Trade_Avg_Fields = {
  __typename?: 'trade_avg_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Float']>;
  buyer_plot_crop_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
  storage_sub_location_id?: Maybe<Scalars['Float']>;
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
  trip_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade" */
export type Trade_Avg_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade". All fields are combined with a logical 'AND'. */
export type Trade_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Bool_Exp>>;
  _not?: InputMaybe<Trade_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Bool_Exp>>;
  action_logs?: InputMaybe<Trade_Action_Log_Bool_Exp>;
  advance_payments?: InputMaybe<Advance_Payment_Bool_Exp>;
  advance_po?: InputMaybe<Boolean_Comparison_Exp>;
  attachments?: InputMaybe<Trade_Attachments_Bool_Exp>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_consent_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_expense_amount?: InputMaybe<Float8_Comparison_Exp>;
  buyer_expense_gst_auto_calculated?: InputMaybe<Boolean_Comparison_Exp>;
  buyer_gst_attachments?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
  buyer_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_payable_amount?: InputMaybe<Numeric_Comparison_Exp>;
  buyer_payable_amount_tax_incl?: InputMaybe<Numeric_Comparison_Exp>;
  buyer_plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  buyer_plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  buyer_remark?: InputMaybe<String_Comparison_Exp>;
  buyer_settlement_status?: InputMaybe<String_Comparison_Exp>;
  buyer_tnc?: InputMaybe<String_Comparison_Exp>;
  buyer_verification?: InputMaybe<Boolean_Comparison_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit_notes?: InputMaybe<Credit_Note_Bool_Exp>;
  current_status?: InputMaybe<Trade_Status_Bool_Exp>;
  current_status_id?: InputMaybe<String_Comparison_Exp>;
  deducted_amount?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity_kg?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity_remaining?: InputMaybe<Numeric_Comparison_Exp>;
  deducted_quantity_remaining_kg?: InputMaybe<Numeric_Comparison_Exp>;
  demand?: InputMaybe<Demand_Bool_Exp>;
  demand_id?: InputMaybe<Bigint_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  direct_cost?: InputMaybe<Float8_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  expense_amount?: InputMaybe<Numeric_Comparison_Exp>;
  expense_taxes?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
  expenses?: InputMaybe<Expense_Bool_Exp>;
  expiry?: InputMaybe<Date_Comparison_Exp>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  facilitator_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_deviation_draft?: InputMaybe<Boolean_Comparison_Exp>;
  is_intercompany_transaction?: InputMaybe<Boolean_Comparison_Exp>;
  is_multiple_commodity?: InputMaybe<Boolean_Comparison_Exp>;
  issuance_notes?: InputMaybe<Issuance_Note_Bool_Exp>;
  junior_officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  junior_officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  material_kind?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  mis_date_1?: InputMaybe<Date_Comparison_Exp>;
  mode?: InputMaybe<String_Comparison_Exp>;
  offer_id?: InputMaybe<Bigint_Comparison_Exp>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  officer_id?: InputMaybe<Bigint_Comparison_Exp>;
  over_draft?: InputMaybe<Over_Draft_Cw_Bool_Exp>;
  over_due_approval?: InputMaybe<Over_Due_Approval_Cw_Bool_Exp>;
  packaging?: InputMaybe<String_Comparison_Exp>;
  parent_trade?: InputMaybe<Trade_Bool_Exp>;
  parent_trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  production_trade?: InputMaybe<Production_Trade_Bool_Exp>;
  production_trade_id?: InputMaybe<Int_Comparison_Exp>;
  production_trade_item_storage_pickeds?: InputMaybe<Production_Trade_Item_Storage_Picked_Bool_Exp>;
  profit?: InputMaybe<Float8_Comparison_Exp>;
  purchase_value?: InputMaybe<Float8_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  receipt_id?: InputMaybe<Bigint_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  returned_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  returned_quantity_kg?: InputMaybe<Numeric_Comparison_Exp>;
  reverse_status_mode?: InputMaybe<Boolean_Comparison_Exp>;
  sales_value?: InputMaybe<Float8_Comparison_Exp>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  seller_consent_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_expense_amount?: InputMaybe<Float8_Comparison_Exp>;
  seller_gst_attachments?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
  seller_id?: InputMaybe<Bigint_Comparison_Exp>;
  seller_receivable_amount?: InputMaybe<Numeric_Comparison_Exp>;
  seller_receivable_amount_tax_incl?: InputMaybe<Numeric_Comparison_Exp>;
  seller_remark?: InputMaybe<String_Comparison_Exp>;
  seller_settlement_status?: InputMaybe<String_Comparison_Exp>;
  seller_tds?: InputMaybe<Float8_Comparison_Exp>;
  seller_tds_percentage?: InputMaybe<Float8_Comparison_Exp>;
  seller_tnc?: InputMaybe<String_Comparison_Exp>;
  seller_verification?: InputMaybe<Boolean_Comparison_Exp>;
  standard_deduction?: InputMaybe<Numeric_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status_processing?: InputMaybe<Boolean_Comparison_Exp>;
  storage_location?: InputMaybe<Storage_Location_Bool_Exp>;
  storage_location_id?: InputMaybe<Bigint_Comparison_Exp>;
  storage_sub_location?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
  storage_sub_location_id?: InputMaybe<Bigint_Comparison_Exp>;
  supplier_charge?: InputMaybe<Float8_Comparison_Exp>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Boolean_Comparison_Exp>;
  supplier_rate?: InputMaybe<Float8_Comparison_Exp>;
  taxes?: InputMaybe<Trade_Taxes_Bool_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_code?: InputMaybe<String_Comparison_Exp>;
  trade_amounts_counter?: InputMaybe<Int_Comparison_Exp>;
  trade_items?: InputMaybe<Trade_Item_Bool_Exp>;
  trades?: InputMaybe<Trade_Bool_Exp>;
  transactions?: InputMaybe<Transaction_Bool_Exp>;
  trip?: InputMaybe<Setutrade_Trip_Bool_Exp>;
  trip_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  vehicle_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments = {
  __typename?: 'trade_buyer_gst_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
};

/** aggregated selection of "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Aggregate = {
  __typename?: 'trade_buyer_gst_attachments_aggregate';
  aggregate?: Maybe<Trade_Buyer_Gst_Attachments_Aggregate_Fields>;
  nodes: Array<Trade_Buyer_Gst_Attachments>;
};

/** aggregate fields of "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Aggregate_Fields = {
  __typename?: 'trade_buyer_gst_attachments_aggregate_fields';
  avg?: Maybe<Trade_Buyer_Gst_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Buyer_Gst_Attachments_Max_Fields>;
  min?: Maybe<Trade_Buyer_Gst_Attachments_Min_Fields>;
  stddev?: Maybe<Trade_Buyer_Gst_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Buyer_Gst_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Buyer_Gst_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Buyer_Gst_Attachments_Sum_Fields>;
  var_pop?: Maybe<Trade_Buyer_Gst_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Buyer_Gst_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Trade_Buyer_Gst_Attachments_Variance_Fields>;
};


/** aggregate fields of "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Buyer_Gst_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Buyer_Gst_Attachments_Max_Order_By>;
  min?: InputMaybe<Trade_Buyer_Gst_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Trade_Buyer_Gst_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Buyer_Gst_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Buyer_Gst_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Buyer_Gst_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Buyer_Gst_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Buyer_Gst_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Buyer_Gst_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Trade_Buyer_Gst_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Buyer_Gst_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Buyer_Gst_Attachments_Avg_Fields = {
  __typename?: 'trade_buyer_gst_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_buyer_gst_attachments". All fields are combined with a logical 'AND'. */
export type Trade_Buyer_Gst_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Buyer_Gst_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_buyer_gst_attachments" */
export enum Trade_Buyer_Gst_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeBuyerGstAttachmentsPkey = 'trade_buyer_gst_attachments_pkey',
  /** unique or primary key constraint on columns "trade_id", "media_id" */
  TradeBuyerGstAttachmentsTradeIdMediaIdAc92c7dbUniq = 'trade_buyer_gst_attachments_trade_id_media_id_ac92c7db_uniq'
}

/** input type for incrementing numeric columns in table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Setutrade_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Trade_Buyer_Gst_Attachments_Max_Fields = {
  __typename?: 'trade_buyer_gst_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Buyer_Gst_Attachments_Min_Fields = {
  __typename?: 'trade_buyer_gst_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Mutation_Response = {
  __typename?: 'trade_buyer_gst_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Buyer_Gst_Attachments>;
};

/** on_conflict condition type for table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_On_Conflict = {
  constraint: Trade_Buyer_Gst_Attachments_Constraint;
  update_columns?: Array<Trade_Buyer_Gst_Attachments_Update_Column>;
  where?: InputMaybe<Trade_Buyer_Gst_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_buyer_gst_attachments". */
export type Trade_Buyer_Gst_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_buyer_gst_attachments */
export type Trade_Buyer_Gst_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "trade_buyer_gst_attachments" */
export enum Trade_Buyer_Gst_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TradeId = 'trade_id'
}

/** input type for updating data in table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Trade_Buyer_Gst_Attachments_Stddev_Fields = {
  __typename?: 'trade_buyer_gst_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Buyer_Gst_Attachments_Stddev_Pop_Fields = {
  __typename?: 'trade_buyer_gst_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Buyer_Gst_Attachments_Stddev_Samp_Fields = {
  __typename?: 'trade_buyer_gst_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Buyer_Gst_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Buyer_Gst_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Buyer_Gst_Attachments_Sum_Fields = {
  __typename?: 'trade_buyer_gst_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** update columns of table "trade_buyer_gst_attachments" */
export enum Trade_Buyer_Gst_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TradeId = 'trade_id'
}

export type Trade_Buyer_Gst_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Buyer_Gst_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Buyer_Gst_Attachments_Set_Input>;
  where: Trade_Buyer_Gst_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Buyer_Gst_Attachments_Var_Pop_Fields = {
  __typename?: 'trade_buyer_gst_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Buyer_Gst_Attachments_Var_Samp_Fields = {
  __typename?: 'trade_buyer_gst_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Buyer_Gst_Attachments_Variance_Fields = {
  __typename?: 'trade_buyer_gst_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_buyer_gst_attachments" */
export type Trade_Buyer_Gst_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "trade" */
export enum Trade_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradePkey = 'trade_pkey',
  /** unique or primary key constraint on columns "tracking_code" */
  TradeTrackingCodeKey = 'trade_tracking_code_key'
}

/** columns and relationships of "trade_expense_tax" */
export type Trade_Expense_Tax = {
  __typename?: 'trade_expense_tax';
  amount?: Maybe<Scalars['numeric']>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  percentage: Scalars['numeric'];
  role: Scalars['String'];
  tax_name: Scalars['String'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
};

/** aggregated selection of "trade_expense_tax" */
export type Trade_Expense_Tax_Aggregate = {
  __typename?: 'trade_expense_tax_aggregate';
  aggregate?: Maybe<Trade_Expense_Tax_Aggregate_Fields>;
  nodes: Array<Trade_Expense_Tax>;
};

/** aggregate fields of "trade_expense_tax" */
export type Trade_Expense_Tax_Aggregate_Fields = {
  __typename?: 'trade_expense_tax_aggregate_fields';
  avg?: Maybe<Trade_Expense_Tax_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Expense_Tax_Max_Fields>;
  min?: Maybe<Trade_Expense_Tax_Min_Fields>;
  stddev?: Maybe<Trade_Expense_Tax_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Expense_Tax_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Expense_Tax_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Expense_Tax_Sum_Fields>;
  var_pop?: Maybe<Trade_Expense_Tax_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Expense_Tax_Var_Samp_Fields>;
  variance?: Maybe<Trade_Expense_Tax_Variance_Fields>;
};


/** aggregate fields of "trade_expense_tax" */
export type Trade_Expense_Tax_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Expense_Tax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_expense_tax" */
export type Trade_Expense_Tax_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Expense_Tax_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Expense_Tax_Max_Order_By>;
  min?: InputMaybe<Trade_Expense_Tax_Min_Order_By>;
  stddev?: InputMaybe<Trade_Expense_Tax_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Expense_Tax_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Expense_Tax_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Expense_Tax_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Expense_Tax_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Expense_Tax_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Expense_Tax_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Trade_Expense_Tax_Avg_Fields = {
  __typename?: 'trade_expense_tax_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_expense_tax". All fields are combined with a logical 'AND'. */
export type Trade_Expense_Tax_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Expense_Tax_Bool_Exp>>;
  _not?: InputMaybe<Trade_Expense_Tax_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Expense_Tax_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  tax_name?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Trade_Expense_Tax_Max_Fields = {
  __typename?: 'trade_expense_tax_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['String']>;
  tax_name?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Expense_Tax_Min_Fields = {
  __typename?: 'trade_expense_tax_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['String']>;
  tax_name?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_expense_tax". */
export type Trade_Expense_Tax_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** select columns of table "trade_expense_tax" */
export enum Trade_Expense_Tax_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  Role = 'role',
  /** column name */
  TaxName = 'tax_name',
  /** column name */
  TradeId = 'trade_id'
}

/** aggregate stddev on columns */
export type Trade_Expense_Tax_Stddev_Fields = {
  __typename?: 'trade_expense_tax_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Expense_Tax_Stddev_Pop_Fields = {
  __typename?: 'trade_expense_tax_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Expense_Tax_Stddev_Samp_Fields = {
  __typename?: 'trade_expense_tax_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_expense_tax" */
export type Trade_Expense_Tax_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Expense_Tax_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Expense_Tax_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['String']>;
  tax_name?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Expense_Tax_Sum_Fields = {
  __typename?: 'trade_expense_tax_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  percentage?: Maybe<Scalars['numeric']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Trade_Expense_Tax_Var_Pop_Fields = {
  __typename?: 'trade_expense_tax_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Expense_Tax_Var_Samp_Fields = {
  __typename?: 'trade_expense_tax_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Expense_Tax_Variance_Fields = {
  __typename?: 'trade_expense_tax_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_expense_tax" */
export type Trade_Expense_Tax_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "trade" */
export type Trade_Inc_Input = {
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  demand_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_tds_percentage?: InputMaybe<Scalars['float8']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  storage_location_id?: InputMaybe<Scalars['bigint']>;
  storage_sub_location_id?: InputMaybe<Scalars['bigint']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trade" */
export type Trade_Insert_Input = {
  advance_payments?: InputMaybe<Advance_Payment_Arr_Rel_Insert_Input>;
  advance_po?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<Trade_Attachments_Arr_Rel_Insert_Input>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_gst_attachments?: InputMaybe<Trade_Buyer_Gst_Attachments_Arr_Rel_Insert_Input>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  buyer_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  buyer_remark?: InputMaybe<Scalars['String']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  credit_notes?: InputMaybe<Credit_Note_Arr_Rel_Insert_Input>;
  current_status_id?: InputMaybe<Scalars['String']>;
  demand_id?: InputMaybe<Scalars['bigint']>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expenses?: InputMaybe<Expense_Arr_Rel_Insert_Input>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_deviation_draft?: InputMaybe<Scalars['Boolean']>;
  junior_officer?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  material_kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  receipt?: InputMaybe<Receipt_Obj_Rel_Insert_Input>;
  remark?: InputMaybe<Scalars['String']>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_gst_attachments?: InputMaybe<Trade_Seller_Gst_Attachments_Arr_Rel_Insert_Input>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_remark?: InputMaybe<Scalars['String']>;
  seller_tds_percentage?: InputMaybe<Scalars['float8']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  storage_location_id?: InputMaybe<Scalars['bigint']>;
  storage_sub_location_id?: InputMaybe<Scalars['bigint']>;
  taxes?: InputMaybe<Trade_Taxes_Arr_Rel_Insert_Input>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
  trade_items?: InputMaybe<Trade_Item_Arr_Rel_Insert_Input>;
  trades?: InputMaybe<Trade_Arr_Rel_Insert_Input>;
  transactions?: InputMaybe<Transaction_Arr_Rel_Insert_Input>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems = {
  __typename?: 'trade_issuancenoteitems';
  amount: Scalars['numeric'];
  /** An array relationship */
  attachments: Array<Trade_Issuancenoteitems_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Trade_Issuancenoteitems_Attachments_Aggregate;
  /** An array relationship */
  children: Array<Trade_Issuancenoteitems>;
  /** An aggregate relationship */
  children_aggregate: Trade_Issuancenoteitems_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  input_value?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  issuance_note: Issuance_Note;
  issuance_note_id: Scalars['bigint'];
  /** An object relationship */
  parent_issuance_note_item?: Maybe<Trade_Issuancenoteitems>;
  parent_issuance_note_item_id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  /** An array relationship */
  taxes: Array<Issuance_Note_Item_Taxes>;
  /** An aggregate relationship */
  taxes_aggregate: Issuance_Note_Item_Taxes_Aggregate;
  /** An object relationship */
  trade_item?: Maybe<Trade_Item>;
  trade_item_id?: Maybe<Scalars['bigint']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "trade_issuancenoteitems" */
export type Trade_IssuancenoteitemsAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade_issuancenoteitems" */
export type Trade_IssuancenoteitemsAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade_issuancenoteitems" */
export type Trade_IssuancenoteitemsChildrenArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


/** columns and relationships of "trade_issuancenoteitems" */
export type Trade_IssuancenoteitemsChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


/** columns and relationships of "trade_issuancenoteitems" */
export type Trade_IssuancenoteitemsTaxesArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Item_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Item_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
};


/** columns and relationships of "trade_issuancenoteitems" */
export type Trade_IssuancenoteitemsTaxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issuance_Note_Item_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issuance_Note_Item_Taxes_Order_By>>;
  where?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
};

/** aggregated selection of "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Aggregate = {
  __typename?: 'trade_issuancenoteitems_aggregate';
  aggregate?: Maybe<Trade_Issuancenoteitems_Aggregate_Fields>;
  nodes: Array<Trade_Issuancenoteitems>;
};

/** aggregate fields of "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Aggregate_Fields = {
  __typename?: 'trade_issuancenoteitems_aggregate_fields';
  avg?: Maybe<Trade_Issuancenoteitems_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Issuancenoteitems_Max_Fields>;
  min?: Maybe<Trade_Issuancenoteitems_Min_Fields>;
  stddev?: Maybe<Trade_Issuancenoteitems_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Issuancenoteitems_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Issuancenoteitems_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Issuancenoteitems_Sum_Fields>;
  var_pop?: Maybe<Trade_Issuancenoteitems_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Issuancenoteitems_Var_Samp_Fields>;
  variance?: Maybe<Trade_Issuancenoteitems_Variance_Fields>;
};


/** aggregate fields of "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Issuancenoteitems_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Issuancenoteitems_Max_Order_By>;
  min?: InputMaybe<Trade_Issuancenoteitems_Min_Order_By>;
  stddev?: InputMaybe<Trade_Issuancenoteitems_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Issuancenoteitems_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Issuancenoteitems_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Issuancenoteitems_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Issuancenoteitems_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Issuancenoteitems_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Issuancenoteitems_Variance_Order_By>;
};

/** columns and relationships of "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments = {
  __typename?: 'trade_issuancenoteitems_attachments';
  id: Scalars['bigint'];
  issuancenoteitems_id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
};

/** aggregated selection of "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Aggregate = {
  __typename?: 'trade_issuancenoteitems_attachments_aggregate';
  aggregate?: Maybe<Trade_Issuancenoteitems_Attachments_Aggregate_Fields>;
  nodes: Array<Trade_Issuancenoteitems_Attachments>;
};

/** aggregate fields of "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Aggregate_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_aggregate_fields';
  avg?: Maybe<Trade_Issuancenoteitems_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Issuancenoteitems_Attachments_Max_Fields>;
  min?: Maybe<Trade_Issuancenoteitems_Attachments_Min_Fields>;
  stddev?: Maybe<Trade_Issuancenoteitems_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Issuancenoteitems_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Issuancenoteitems_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Issuancenoteitems_Attachments_Sum_Fields>;
  var_pop?: Maybe<Trade_Issuancenoteitems_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Issuancenoteitems_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Trade_Issuancenoteitems_Attachments_Variance_Fields>;
};


/** aggregate fields of "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Issuancenoteitems_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Issuancenoteitems_Attachments_Max_Order_By>;
  min?: InputMaybe<Trade_Issuancenoteitems_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Trade_Issuancenoteitems_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Issuancenoteitems_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Issuancenoteitems_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Issuancenoteitems_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Issuancenoteitems_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Issuancenoteitems_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Issuancenoteitems_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Trade_Issuancenoteitems_Attachments_Avg_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenoteitems_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_issuancenoteitems_attachments". All fields are combined with a logical 'AND'. */
export type Trade_Issuancenoteitems_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Issuancenoteitems_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  issuancenoteitems_id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Trade_Issuancenoteitems_Attachments_Max_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  issuancenoteitems_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Issuancenoteitems_Attachments_Min_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  issuancenoteitems_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_issuancenoteitems_attachments". */
export type Trade_Issuancenoteitems_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** select columns of table "trade_issuancenoteitems_attachments" */
export enum Trade_Issuancenoteitems_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IssuancenoteitemsId = 'issuancenoteitems_id',
  /** column name */
  MediaId = 'media_id'
}

/** aggregate stddev on columns */
export type Trade_Issuancenoteitems_Attachments_Stddev_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenoteitems_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Issuancenoteitems_Attachments_Stddev_Pop_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenoteitems_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Issuancenoteitems_Attachments_Stddev_Samp_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenoteitems_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Issuancenoteitems_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Issuancenoteitems_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  issuancenoteitems_id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Issuancenoteitems_Attachments_Sum_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  issuancenoteitems_id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Trade_Issuancenoteitems_Attachments_Var_Pop_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenoteitems_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Issuancenoteitems_Attachments_Var_Samp_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenoteitems_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Issuancenoteitems_Attachments_Variance_Fields = {
  __typename?: 'trade_issuancenoteitems_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  issuancenoteitems_id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_issuancenoteitems_attachments" */
export type Trade_Issuancenoteitems_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  issuancenoteitems_id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Trade_Issuancenoteitems_Avg_Fields = {
  __typename?: 'trade_issuancenoteitems_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_item_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_issuancenoteitems". All fields are combined with a logical 'AND'. */
export type Trade_Issuancenoteitems_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Issuancenoteitems_Bool_Exp>>;
  _not?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Issuancenoteitems_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  attachments?: InputMaybe<Trade_Issuancenoteitems_Attachments_Bool_Exp>;
  children?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  input_value?: InputMaybe<Numeric_Comparison_Exp>;
  issuance_note?: InputMaybe<Issuance_Note_Bool_Exp>;
  issuance_note_id?: InputMaybe<Bigint_Comparison_Exp>;
  parent_issuance_note_item?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
  parent_issuance_note_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  remarks?: InputMaybe<String_Comparison_Exp>;
  taxes?: InputMaybe<Issuance_Note_Item_Taxes_Bool_Exp>;
  trade_item?: InputMaybe<Trade_Item_Bool_Exp>;
  trade_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Trade_Issuancenoteitems_Max_Fields = {
  __typename?: 'trade_issuancenoteitems_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  input_value?: Maybe<Scalars['numeric']>;
  issuance_note_id?: Maybe<Scalars['bigint']>;
  parent_issuance_note_item_id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  trade_item_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Issuancenoteitems_Min_Fields = {
  __typename?: 'trade_issuancenoteitems_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  input_value?: Maybe<Scalars['numeric']>;
  issuance_note_id?: Maybe<Scalars['bigint']>;
  parent_issuance_note_item_id?: Maybe<Scalars['bigint']>;
  remarks?: Maybe<Scalars['String']>;
  trade_item_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_issuancenoteitems". */
export type Trade_Issuancenoteitems_Order_By = {
  amount?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Trade_Issuancenoteitems_Attachments_Aggregate_Order_By>;
  children_aggregate?: InputMaybe<Trade_Issuancenoteitems_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note?: InputMaybe<Issuance_Note_Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item?: InputMaybe<Trade_Issuancenoteitems_Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  remarks?: InputMaybe<Order_By>;
  taxes_aggregate?: InputMaybe<Issuance_Note_Item_Taxes_Aggregate_Order_By>;
  trade_item?: InputMaybe<Trade_Item_Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "trade_issuancenoteitems" */
export enum Trade_Issuancenoteitems_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InputValue = 'input_value',
  /** column name */
  IssuanceNoteId = 'issuance_note_id',
  /** column name */
  ParentIssuanceNoteItemId = 'parent_issuance_note_item_id',
  /** column name */
  Remarks = 'remarks',
  /** column name */
  TradeItemId = 'trade_item_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Trade_Issuancenoteitems_Stddev_Fields = {
  __typename?: 'trade_issuancenoteitems_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_item_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Issuancenoteitems_Stddev_Pop_Fields = {
  __typename?: 'trade_issuancenoteitems_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_item_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Issuancenoteitems_Stddev_Samp_Fields = {
  __typename?: 'trade_issuancenoteitems_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_item_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Issuancenoteitems_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Issuancenoteitems_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  input_value?: InputMaybe<Scalars['numeric']>;
  issuance_note_id?: InputMaybe<Scalars['bigint']>;
  parent_issuance_note_item_id?: InputMaybe<Scalars['bigint']>;
  remarks?: InputMaybe<Scalars['String']>;
  trade_item_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Trade_Issuancenoteitems_Sum_Fields = {
  __typename?: 'trade_issuancenoteitems_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  input_value?: Maybe<Scalars['numeric']>;
  issuance_note_id?: Maybe<Scalars['bigint']>;
  parent_issuance_note_item_id?: Maybe<Scalars['bigint']>;
  trade_item_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Trade_Issuancenoteitems_Var_Pop_Fields = {
  __typename?: 'trade_issuancenoteitems_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_item_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Issuancenoteitems_Var_Samp_Fields = {
  __typename?: 'trade_issuancenoteitems_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_item_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Issuancenoteitems_Variance_Fields = {
  __typename?: 'trade_issuancenoteitems_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  input_value?: Maybe<Scalars['Float']>;
  issuance_note_id?: Maybe<Scalars['Float']>;
  parent_issuance_note_item_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_issuancenoteitems" */
export type Trade_Issuancenoteitems_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_value?: InputMaybe<Order_By>;
  issuance_note_id?: InputMaybe<Order_By>;
  parent_issuance_note_item_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_item" */
export type Trade_Item = {
  __typename?: 'trade_item';
  amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  attachments: Array<Trade_Item_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Trade_Item_Attachments_Aggregate;
  batch_number?: Maybe<Scalars['String']>;
  buyer_gst_auto_calculated: Scalars['Boolean'];
  /** An object relationship */
  commodity?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  commodity_variety?: Maybe<Setu_Trade_Shared_Entity>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  currency: Setu_Trade_Shared_Entity;
  currency_id: Scalars['bigint'];
  daily_rate?: Maybe<Scalars['numeric']>;
  gate_pass?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An array relationship */
  issuance_note_items: Array<Trade_Issuancenoteitems>;
  /** An aggregate relationship */
  issuance_note_items_aggregate: Trade_Issuancenoteitems_Aggregate;
  /** An object relationship */
  packaging_unit?: Maybe<Setu_Trade_Shared_Entity>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  parent_trade_item_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  plot_crop?: Maybe<Setu_Trade_Shared_Entity>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  qc_rejection?: Maybe<Scalars['numeric']>;
  quantity: Scalars['numeric'];
  /** An object relationship */
  quantity_unit: Setu_Trade_Shared_Entity;
  quantity_unit_id: Scalars['bigint'];
  rate: Scalars['numeric'];
  /** An object relationship */
  rate_unit: Setu_Trade_Shared_Entity;
  rate_unit_id: Scalars['bigint'];
  /** An object relationship */
  result?: Maybe<Setu_Trade_Shared_Entity>;
  result_id?: Maybe<Scalars['bigint']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  supplier_gst_auto_calculated: Scalars['Boolean'];
  /** An array relationship */
  taxes: Array<Trade_Taxes>;
  /** An aggregate relationship */
  taxes_aggregate: Trade_Taxes_Aggregate;
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
  /** An object relationship */
  trade_item?: Maybe<Trade_Item>;
  /** An array relationship */
  trade_items: Array<Trade_Item>;
  /** An aggregate relationship */
  trade_items_aggregate: Trade_Item_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  variety_grade?: Maybe<Setu_Trade_Shared_Entity>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Attachments_Order_By>>;
  where?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemIssuance_Note_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemIssuance_Note_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Issuancenoteitems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Issuancenoteitems_Order_By>>;
  where?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemTaxesArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemTaxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Taxes_Order_By>>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemTrade_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};


/** columns and relationships of "trade_item" */
export type Trade_ItemTrade_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Item_Order_By>>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};

/** aggregated selection of "trade_item" */
export type Trade_Item_Aggregate = {
  __typename?: 'trade_item_aggregate';
  aggregate?: Maybe<Trade_Item_Aggregate_Fields>;
  nodes: Array<Trade_Item>;
};

/** aggregate fields of "trade_item" */
export type Trade_Item_Aggregate_Fields = {
  __typename?: 'trade_item_aggregate_fields';
  avg?: Maybe<Trade_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Item_Max_Fields>;
  min?: Maybe<Trade_Item_Min_Fields>;
  stddev?: Maybe<Trade_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Item_Sum_Fields>;
  var_pop?: Maybe<Trade_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Item_Var_Samp_Fields>;
  variance?: Maybe<Trade_Item_Variance_Fields>;
};


/** aggregate fields of "trade_item" */
export type Trade_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_item" */
export type Trade_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Item_Max_Order_By>;
  min?: InputMaybe<Trade_Item_Min_Order_By>;
  stddev?: InputMaybe<Trade_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Item_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_item" */
export type Trade_Item_Arr_Rel_Insert_Input = {
  data: Array<Trade_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Item_On_Conflict>;
};

/** columns and relationships of "trade_item_attachments" */
export type Trade_Item_Attachments = {
  __typename?: 'trade_item_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  trade_item: Trade_Item;
  tradeitem_id: Scalars['bigint'];
};

/** aggregated selection of "trade_item_attachments" */
export type Trade_Item_Attachments_Aggregate = {
  __typename?: 'trade_item_attachments_aggregate';
  aggregate?: Maybe<Trade_Item_Attachments_Aggregate_Fields>;
  nodes: Array<Trade_Item_Attachments>;
};

/** aggregate fields of "trade_item_attachments" */
export type Trade_Item_Attachments_Aggregate_Fields = {
  __typename?: 'trade_item_attachments_aggregate_fields';
  avg?: Maybe<Trade_Item_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Item_Attachments_Max_Fields>;
  min?: Maybe<Trade_Item_Attachments_Min_Fields>;
  stddev?: Maybe<Trade_Item_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Item_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Item_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Item_Attachments_Sum_Fields>;
  var_pop?: Maybe<Trade_Item_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Item_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Trade_Item_Attachments_Variance_Fields>;
};


/** aggregate fields of "trade_item_attachments" */
export type Trade_Item_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Item_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_item_attachments" */
export type Trade_Item_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Item_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Item_Attachments_Max_Order_By>;
  min?: InputMaybe<Trade_Item_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Trade_Item_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Item_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Item_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Item_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Item_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Item_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Item_Attachments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Trade_Item_Attachments_Avg_Fields = {
  __typename?: 'trade_item_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  tradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_item_attachments". All fields are combined with a logical 'AND'. */
export type Trade_Item_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Item_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Item_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade_item?: InputMaybe<Trade_Item_Bool_Exp>;
  tradeitem_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Trade_Item_Attachments_Max_Fields = {
  __typename?: 'trade_item_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  tradeitem_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Item_Attachments_Min_Fields = {
  __typename?: 'trade_item_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  tradeitem_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_item_attachments". */
export type Trade_Item_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_item?: InputMaybe<Trade_Item_Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** select columns of table "trade_item_attachments" */
export enum Trade_Item_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TradeitemId = 'tradeitem_id'
}

/** aggregate stddev on columns */
export type Trade_Item_Attachments_Stddev_Fields = {
  __typename?: 'trade_item_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  tradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Item_Attachments_Stddev_Pop_Fields = {
  __typename?: 'trade_item_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  tradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Item_Attachments_Stddev_Samp_Fields = {
  __typename?: 'trade_item_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  tradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_item_attachments" */
export type Trade_Item_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Item_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Item_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  tradeitem_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Item_Attachments_Sum_Fields = {
  __typename?: 'trade_item_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  tradeitem_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Trade_Item_Attachments_Var_Pop_Fields = {
  __typename?: 'trade_item_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  tradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Item_Attachments_Var_Samp_Fields = {
  __typename?: 'trade_item_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  tradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Item_Attachments_Variance_Fields = {
  __typename?: 'trade_item_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  tradeitem_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_item_attachments" */
export type Trade_Item_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  tradeitem_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Trade_Item_Avg_Fields = {
  __typename?: 'trade_item_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  daily_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  parent_trade_item_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  qc_rejection?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_item" */
export type Trade_Item_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_item". All fields are combined with a logical 'AND'. */
export type Trade_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Item_Bool_Exp>>;
  _not?: InputMaybe<Trade_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Item_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  attachments?: InputMaybe<Trade_Item_Attachments_Bool_Exp>;
  batch_number?: InputMaybe<String_Comparison_Exp>;
  buyer_gst_auto_calculated?: InputMaybe<Boolean_Comparison_Exp>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_id?: InputMaybe<Bigint_Comparison_Exp>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  commodity_variety_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  currency_id?: InputMaybe<Bigint_Comparison_Exp>;
  daily_rate?: InputMaybe<Numeric_Comparison_Exp>;
  gate_pass?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  issuance_note_items?: InputMaybe<Trade_Issuancenoteitems_Bool_Exp>;
  packaging_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  packaging_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  parent_trade_item_id?: InputMaybe<Bigint_Comparison_Exp>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  plot_crop_id?: InputMaybe<Bigint_Comparison_Exp>;
  qc_rejection?: InputMaybe<Numeric_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  quantity_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  rate_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  result?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  result_id?: InputMaybe<Bigint_Comparison_Exp>;
  returned_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  supplier_gst_auto_calculated?: InputMaybe<Boolean_Comparison_Exp>;
  taxes?: InputMaybe<Trade_Taxes_Bool_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade_item?: InputMaybe<Trade_Item_Bool_Exp>;
  trade_items?: InputMaybe<Trade_Item_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  variety_grade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_item" */
export enum Trade_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeItemPkey = 'trade_item_pkey'
}

/** input type for incrementing numeric columns in table "trade_item" */
export type Trade_Item_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  daily_rate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  parent_trade_item_id?: InputMaybe<Scalars['bigint']>;
  qc_rejection?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trade_item" */
export type Trade_Item_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  currency?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  daily_rate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  parent_trade_item_id?: InputMaybe<Scalars['bigint']>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  qc_rejection?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  result?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  result_id?: InputMaybe<Scalars['bigint']>;
  taxes?: InputMaybe<Trade_Taxes_Arr_Rel_Insert_Input>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  trade_item?: InputMaybe<Trade_Item_Obj_Rel_Insert_Input>;
  trade_items?: InputMaybe<Trade_Item_Arr_Rel_Insert_Input>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Trade_Item_Max_Fields = {
  __typename?: 'trade_item_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  batch_number?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['bigint']>;
  daily_rate?: Maybe<Scalars['numeric']>;
  gate_pass?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  parent_trade_item_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  qc_rejection?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_item" */
export type Trade_Item_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  batch_number?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  gate_pass?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Item_Min_Fields = {
  __typename?: 'trade_item_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  batch_number?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_id?: Maybe<Scalars['bigint']>;
  daily_rate?: Maybe<Scalars['numeric']>;
  gate_pass?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  parent_trade_item_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  qc_rejection?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  trade_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_item" */
export type Trade_Item_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  batch_number?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  gate_pass?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_item" */
export type Trade_Item_Mutation_Response = {
  __typename?: 'trade_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Item>;
};

/** input type for inserting object relation for remote table "trade_item" */
export type Trade_Item_Obj_Rel_Insert_Input = {
  data: Trade_Item_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Item_On_Conflict>;
};

/** on_conflict condition type for table "trade_item" */
export type Trade_Item_On_Conflict = {
  constraint: Trade_Item_Constraint;
  update_columns?: Array<Trade_Item_Update_Column>;
  where?: InputMaybe<Trade_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_item". */
export type Trade_Item_Order_By = {
  amount?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Trade_Item_Attachments_Aggregate_Order_By>;
  batch_number?: InputMaybe<Order_By>;
  buyer_gst_auto_calculated?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  gate_pass?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuance_note_items_aggregate?: InputMaybe<Trade_Issuancenoteitems_Aggregate_Order_By>;
  packaging_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  supplier_gst_auto_calculated?: InputMaybe<Order_By>;
  taxes_aggregate?: InputMaybe<Trade_Taxes_Aggregate_Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item?: InputMaybe<Trade_Item_Order_By>;
  trade_items_aggregate?: InputMaybe<Trade_Item_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_grade?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_item */
export type Trade_Item_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "trade_item" */
export enum Trade_Item_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BatchNumber = 'batch_number',
  /** column name */
  BuyerGstAutoCalculated = 'buyer_gst_auto_calculated',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  DailyRate = 'daily_rate',
  /** column name */
  GatePass = 'gate_pass',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingUnitId = 'packaging_unit_id',
  /** column name */
  ParentTradeItemId = 'parent_trade_item_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  QcRejection = 'qc_rejection',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateUnitId = 'rate_unit_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  ReturnedQuantity = 'returned_quantity',
  /** column name */
  SupplierGstAutoCalculated = 'supplier_gst_auto_calculated',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarietyGradeId = 'variety_grade_id'
}

/** input type for updating data in table "trade_item" */
export type Trade_Item_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  daily_rate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  parent_trade_item_id?: InputMaybe<Scalars['bigint']>;
  qc_rejection?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Trade_Item_Stddev_Fields = {
  __typename?: 'trade_item_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  daily_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  parent_trade_item_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  qc_rejection?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_item" */
export type Trade_Item_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Item_Stddev_Pop_Fields = {
  __typename?: 'trade_item_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  daily_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  parent_trade_item_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  qc_rejection?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_item" */
export type Trade_Item_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Item_Stddev_Samp_Fields = {
  __typename?: 'trade_item_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  daily_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  parent_trade_item_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  qc_rejection?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_item" */
export type Trade_Item_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_item" */
export type Trade_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Item_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  batch_number?: InputMaybe<Scalars['String']>;
  buyer_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_id?: InputMaybe<Scalars['bigint']>;
  daily_rate?: InputMaybe<Scalars['numeric']>;
  gate_pass?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  packaging_unit_id?: InputMaybe<Scalars['bigint']>;
  parent_trade_item_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  qc_rejection?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  quantity_unit_id?: InputMaybe<Scalars['bigint']>;
  rate?: InputMaybe<Scalars['numeric']>;
  rate_unit_id?: InputMaybe<Scalars['bigint']>;
  result_id?: InputMaybe<Scalars['bigint']>;
  returned_quantity?: InputMaybe<Scalars['numeric']>;
  supplier_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety_grade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Item_Sum_Fields = {
  __typename?: 'trade_item_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  currency_id?: Maybe<Scalars['bigint']>;
  daily_rate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  packaging_unit_id?: Maybe<Scalars['bigint']>;
  parent_trade_item_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  qc_rejection?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  quantity_unit_id?: Maybe<Scalars['bigint']>;
  rate?: Maybe<Scalars['numeric']>;
  rate_unit_id?: Maybe<Scalars['bigint']>;
  result_id?: Maybe<Scalars['bigint']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  trade_id?: Maybe<Scalars['bigint']>;
  variety_grade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_item" */
export type Trade_Item_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** update columns of table "trade_item" */
export enum Trade_Item_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CurrencyId = 'currency_id',
  /** column name */
  DailyRate = 'daily_rate',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingUnitId = 'packaging_unit_id',
  /** column name */
  ParentTradeItemId = 'parent_trade_item_id',
  /** column name */
  QcRejection = 'qc_rejection',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityUnitId = 'quantity_unit_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  RateUnitId = 'rate_unit_id',
  /** column name */
  ResultId = 'result_id',
  /** column name */
  VarietyGradeId = 'variety_grade_id'
}

export type Trade_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Item_Set_Input>;
  where: Trade_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Item_Var_Pop_Fields = {
  __typename?: 'trade_item_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  daily_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  parent_trade_item_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  qc_rejection?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_item" */
export type Trade_Item_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Item_Var_Samp_Fields = {
  __typename?: 'trade_item_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  daily_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  parent_trade_item_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  qc_rejection?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_item" */
export type Trade_Item_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Item_Variance_Fields = {
  __typename?: 'trade_item_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  currency_id?: Maybe<Scalars['Float']>;
  daily_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  packaging_unit_id?: Maybe<Scalars['Float']>;
  parent_trade_item_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  qc_rejection?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  quantity_unit_id?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  rate_unit_id?: Maybe<Scalars['Float']>;
  result_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  variety_grade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_item" */
export type Trade_Item_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  currency_id?: InputMaybe<Order_By>;
  daily_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_unit_id?: InputMaybe<Order_By>;
  parent_trade_item_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  qc_rejection?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantity_unit_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  rate_unit_id?: InputMaybe<Order_By>;
  result_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  variety_grade_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Trade_Max_Fields = {
  __typename?: 'trade_max_fields';
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  buyer_plot_crop_id?: Maybe<Scalars['bigint']>;
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_settlement_status?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  demand_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  direct_cost?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  material_kind?: Maybe<Scalars['String']>;
  mis_date_1?: Maybe<Scalars['date']>;
  mode?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['bigint']>;
  officer_id?: Maybe<Scalars['bigint']>;
  packaging?: Maybe<Scalars['String']>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  production_trade_id?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  sales_value?: Maybe<Scalars['float8']>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_expense_amount?: Maybe<Scalars['float8']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  seller_remark?: Maybe<Scalars['String']>;
  seller_settlement_status?: Maybe<Scalars['String']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  storage_sub_location_id?: Maybe<Scalars['bigint']>;
  supplier_charge?: Maybe<Scalars['float8']>;
  supplier_rate?: Maybe<Scalars['float8']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  trade_amounts_counter?: Maybe<Scalars['Int']>;
  trip_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade" */
export type Trade_Max_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  buyer_remark?: InputMaybe<Order_By>;
  buyer_settlement_status?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  mis_date_1?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_remark?: InputMaybe<Order_By>;
  seller_settlement_status?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Min_Fields = {
  __typename?: 'trade_min_fields';
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  buyer_plot_crop_id?: Maybe<Scalars['bigint']>;
  buyer_remark?: Maybe<Scalars['String']>;
  buyer_settlement_status?: Maybe<Scalars['String']>;
  buyer_tnc?: Maybe<Scalars['String']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  current_status_id?: Maybe<Scalars['String']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  demand_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  direct_cost?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['date']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  expiry?: Maybe<Scalars['date']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  kind?: Maybe<Scalars['String']>;
  material_kind?: Maybe<Scalars['String']>;
  mis_date_1?: Maybe<Scalars['date']>;
  mode?: Maybe<Scalars['String']>;
  offer_id?: Maybe<Scalars['bigint']>;
  officer_id?: Maybe<Scalars['bigint']>;
  packaging?: Maybe<Scalars['String']>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  production_trade_id?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  remark?: Maybe<Scalars['String']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  sales_value?: Maybe<Scalars['float8']>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_expense_amount?: Maybe<Scalars['float8']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  seller_remark?: Maybe<Scalars['String']>;
  seller_settlement_status?: Maybe<Scalars['String']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  seller_tnc?: Maybe<Scalars['String']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  start_date?: Maybe<Scalars['date']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  storage_sub_location_id?: Maybe<Scalars['bigint']>;
  supplier_charge?: Maybe<Scalars['float8']>;
  supplier_rate?: Maybe<Scalars['float8']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  tracking_code?: Maybe<Scalars['String']>;
  trade_amounts_counter?: Maybe<Scalars['Int']>;
  trip_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade" */
export type Trade_Min_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  buyer_remark?: InputMaybe<Order_By>;
  buyer_settlement_status?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  mis_date_1?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_remark?: InputMaybe<Order_By>;
  seller_settlement_status?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade" */
export type Trade_Mutation_Response = {
  __typename?: 'trade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade>;
};

/** input type for inserting object relation for remote table "trade" */
export type Trade_Obj_Rel_Insert_Input = {
  data: Trade_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_On_Conflict>;
};

/** on_conflict condition type for table "trade" */
export type Trade_On_Conflict = {
  constraint: Trade_Constraint;
  update_columns?: Array<Trade_Update_Column>;
  where?: InputMaybe<Trade_Bool_Exp>;
};

/** Ordering options when selecting data from "trade". */
export type Trade_Order_By = {
  action_logs_aggregate?: InputMaybe<Trade_Action_Log_Aggregate_Order_By>;
  advance_payments_aggregate?: InputMaybe<Advance_Payment_Aggregate_Order_By>;
  advance_po?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Trade_Attachments_Aggregate_Order_By>;
  buyer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_expense_gst_auto_calculated?: InputMaybe<Order_By>;
  buyer_gst_attachments_aggregate?: InputMaybe<Trade_Buyer_Gst_Attachments_Aggregate_Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  buyer_remark?: InputMaybe<Order_By>;
  buyer_settlement_status?: InputMaybe<Order_By>;
  buyer_tnc?: InputMaybe<Order_By>;
  buyer_verification?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_notes_aggregate?: InputMaybe<Credit_Note_Aggregate_Order_By>;
  current_status?: InputMaybe<Trade_Status_Order_By>;
  current_status_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand?: InputMaybe<Demand_Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  expense_taxes_aggregate?: InputMaybe<Trade_Expense_Tax_Aggregate_Order_By>;
  expenses_aggregate?: InputMaybe<Expense_Aggregate_Order_By>;
  expiry?: InputMaybe<Order_By>;
  facilitator?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  is_deviation_draft?: InputMaybe<Order_By>;
  is_intercompany_transaction?: InputMaybe<Order_By>;
  is_multiple_commodity?: InputMaybe<Order_By>;
  issuance_notes_aggregate?: InputMaybe<Issuance_Note_Aggregate_Order_By>;
  junior_officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  material_kind?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  mis_date_1?: InputMaybe<Order_By>;
  mode?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  officer_id?: InputMaybe<Order_By>;
  over_draft?: InputMaybe<Over_Draft_Cw_Order_By>;
  over_due_approval?: InputMaybe<Over_Due_Approval_Cw_Order_By>;
  packaging?: InputMaybe<Order_By>;
  parent_trade?: InputMaybe<Trade_Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade?: InputMaybe<Production_Trade_Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  production_trade_item_storage_pickeds_aggregate?: InputMaybe<Production_Trade_Item_Storage_Picked_Aggregate_Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  reverse_status_mode?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_gst_attachments_aggregate?: InputMaybe<Trade_Seller_Gst_Attachments_Aggregate_Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_remark?: InputMaybe<Order_By>;
  seller_settlement_status?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  seller_tnc?: InputMaybe<Order_By>;
  seller_verification?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status_processing?: InputMaybe<Order_By>;
  storage_location?: InputMaybe<Storage_Location_Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location?: InputMaybe<Storage_Sub_Location_Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  taxes_aggregate?: InputMaybe<Trade_Taxes_Aggregate_Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  tracking_code?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trade_items_aggregate?: InputMaybe<Trade_Item_Aggregate_Order_By>;
  trades_aggregate?: InputMaybe<Trade_Aggregate_Order_By>;
  transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  trip?: InputMaybe<Setutrade_Trip_Order_By>;
  trip_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade */
export type Trade_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "trade" */
export enum Trade_Select_Column {
  /** column name */
  AdvancePo = 'advance_po',
  /** column name */
  BuyerConsentId = 'buyer_consent_id',
  /** column name */
  BuyerExpenseAmount = 'buyer_expense_amount',
  /** column name */
  BuyerExpenseGstAutoCalculated = 'buyer_expense_gst_auto_calculated',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerPayableAmount = 'buyer_payable_amount',
  /** column name */
  BuyerPayableAmountTaxIncl = 'buyer_payable_amount_tax_incl',
  /** column name */
  BuyerPlotCropId = 'buyer_plot_crop_id',
  /** column name */
  BuyerRemark = 'buyer_remark',
  /** column name */
  BuyerSettlementStatus = 'buyer_settlement_status',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  BuyerVerification = 'buyer_verification',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CurrentStatusId = 'current_status_id',
  /** column name */
  DeductedAmount = 'deducted_amount',
  /** column name */
  DeductedQuantity = 'deducted_quantity',
  /** column name */
  DeductedQuantityKg = 'deducted_quantity_kg',
  /** column name */
  DeductedQuantityRemaining = 'deducted_quantity_remaining',
  /** column name */
  DeductedQuantityRemainingKg = 'deducted_quantity_remaining_kg',
  /** column name */
  DemandId = 'demand_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  DirectCost = 'direct_cost',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExpenseAmount = 'expense_amount',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsDeviationDraft = 'is_deviation_draft',
  /** column name */
  IsIntercompanyTransaction = 'is_intercompany_transaction',
  /** column name */
  IsMultipleCommodity = 'is_multiple_commodity',
  /** column name */
  JuniorOfficerId = 'junior_officer_id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialKind = 'material_kind',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MisDate_1 = 'mis_date_1',
  /** column name */
  Mode = 'mode',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfficerId = 'officer_id',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  ParentTradeId = 'parent_trade_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  ProductionTradeId = 'production_trade_id',
  /** column name */
  Profit = 'profit',
  /** column name */
  PurchaseValue = 'purchase_value',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  ReturnedQuantity = 'returned_quantity',
  /** column name */
  ReturnedQuantityKg = 'returned_quantity_kg',
  /** column name */
  ReverseStatusMode = 'reverse_status_mode',
  /** column name */
  SalesValue = 'sales_value',
  /** column name */
  SellerConsentId = 'seller_consent_id',
  /** column name */
  SellerExpenseAmount = 'seller_expense_amount',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerReceivableAmount = 'seller_receivable_amount',
  /** column name */
  SellerReceivableAmountTaxIncl = 'seller_receivable_amount_tax_incl',
  /** column name */
  SellerRemark = 'seller_remark',
  /** column name */
  SellerSettlementStatus = 'seller_settlement_status',
  /** column name */
  SellerTds = 'seller_tds',
  /** column name */
  SellerTdsPercentage = 'seller_tds_percentage',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  SellerVerification = 'seller_verification',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusProcessing = 'status_processing',
  /** column name */
  StorageLocationId = 'storage_location_id',
  /** column name */
  StorageSubLocationId = 'storage_sub_location_id',
  /** column name */
  SupplierCharge = 'supplier_charge',
  /** column name */
  SupplierExpenseGstAutoCalculated = 'supplier_expense_gst_auto_calculated',
  /** column name */
  SupplierRate = 'supplier_rate',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalQuantity = 'total_quantity',
  /** column name */
  TrackingCode = 'tracking_code',
  /** column name */
  TradeAmountsCounter = 'trade_amounts_counter',
  /** column name */
  TripId = 'trip_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** columns and relationships of "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments = {
  __typename?: 'trade_seller_gst_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  trade: Trade;
  trade_id: Scalars['bigint'];
};

/** aggregated selection of "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Aggregate = {
  __typename?: 'trade_seller_gst_attachments_aggregate';
  aggregate?: Maybe<Trade_Seller_Gst_Attachments_Aggregate_Fields>;
  nodes: Array<Trade_Seller_Gst_Attachments>;
};

/** aggregate fields of "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Aggregate_Fields = {
  __typename?: 'trade_seller_gst_attachments_aggregate_fields';
  avg?: Maybe<Trade_Seller_Gst_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Seller_Gst_Attachments_Max_Fields>;
  min?: Maybe<Trade_Seller_Gst_Attachments_Min_Fields>;
  stddev?: Maybe<Trade_Seller_Gst_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Seller_Gst_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Seller_Gst_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Seller_Gst_Attachments_Sum_Fields>;
  var_pop?: Maybe<Trade_Seller_Gst_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Seller_Gst_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Trade_Seller_Gst_Attachments_Variance_Fields>;
};


/** aggregate fields of "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Seller_Gst_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Seller_Gst_Attachments_Max_Order_By>;
  min?: InputMaybe<Trade_Seller_Gst_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Trade_Seller_Gst_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Seller_Gst_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Seller_Gst_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Seller_Gst_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Seller_Gst_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Seller_Gst_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Seller_Gst_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Trade_Seller_Gst_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Seller_Gst_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Seller_Gst_Attachments_Avg_Fields = {
  __typename?: 'trade_seller_gst_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_seller_gst_attachments". All fields are combined with a logical 'AND'. */
export type Trade_Seller_Gst_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Seller_Gst_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_seller_gst_attachments" */
export enum Trade_Seller_Gst_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  TradeSellerGstAttachmentsPkey = 'trade_seller_gst_attachments_pkey',
  /** unique or primary key constraint on columns "trade_id", "media_id" */
  TradeSellerGstAttachmentsTradeIdMediaId_7fceedf0Uniq = 'trade_seller_gst_attachments_trade_id_media_id_7fceedf0_uniq'
}

/** input type for incrementing numeric columns in table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Setutrade_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Trade_Seller_Gst_Attachments_Max_Fields = {
  __typename?: 'trade_seller_gst_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Seller_Gst_Attachments_Min_Fields = {
  __typename?: 'trade_seller_gst_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Mutation_Response = {
  __typename?: 'trade_seller_gst_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Seller_Gst_Attachments>;
};

/** on_conflict condition type for table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_On_Conflict = {
  constraint: Trade_Seller_Gst_Attachments_Constraint;
  update_columns?: Array<Trade_Seller_Gst_Attachments_Update_Column>;
  where?: InputMaybe<Trade_Seller_Gst_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_seller_gst_attachments". */
export type Trade_Seller_Gst_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_seller_gst_attachments */
export type Trade_Seller_Gst_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "trade_seller_gst_attachments" */
export enum Trade_Seller_Gst_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TradeId = 'trade_id'
}

/** input type for updating data in table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Trade_Seller_Gst_Attachments_Stddev_Fields = {
  __typename?: 'trade_seller_gst_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Seller_Gst_Attachments_Stddev_Pop_Fields = {
  __typename?: 'trade_seller_gst_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Seller_Gst_Attachments_Stddev_Samp_Fields = {
  __typename?: 'trade_seller_gst_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Seller_Gst_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Seller_Gst_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Seller_Gst_Attachments_Sum_Fields = {
  __typename?: 'trade_seller_gst_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** update columns of table "trade_seller_gst_attachments" */
export enum Trade_Seller_Gst_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TradeId = 'trade_id'
}

export type Trade_Seller_Gst_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Seller_Gst_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Seller_Gst_Attachments_Set_Input>;
  where: Trade_Seller_Gst_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Seller_Gst_Attachments_Var_Pop_Fields = {
  __typename?: 'trade_seller_gst_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Seller_Gst_Attachments_Var_Samp_Fields = {
  __typename?: 'trade_seller_gst_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Seller_Gst_Attachments_Variance_Fields = {
  __typename?: 'trade_seller_gst_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_seller_gst_attachments" */
export type Trade_Seller_Gst_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
};

/** input type for updating data in table "trade" */
export type Trade_Set_Input = {
  advance_po?: InputMaybe<Scalars['Boolean']>;
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  buyer_remark?: InputMaybe<Scalars['String']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  current_status_id?: InputMaybe<Scalars['String']>;
  demand_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  end_date?: InputMaybe<Scalars['date']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  is_deviation_draft?: InputMaybe<Scalars['Boolean']>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  material_kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_remark?: InputMaybe<Scalars['String']>;
  seller_tds_percentage?: InputMaybe<Scalars['float8']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  status_processing?: InputMaybe<Scalars['Boolean']>;
  storage_location_id?: InputMaybe<Scalars['bigint']>;
  storage_sub_location_id?: InputMaybe<Scalars['bigint']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "trade_status" */
export type Trade_Status = {
  __typename?: 'trade_status';
  category: Scalars['String'];
  /** An array relationship */
  childrens: Array<Trade_Status_Parents>;
  /** An aggregate relationship */
  childrens_aggregate: Trade_Status_Parents_Aggregate;
  /** An array relationship */
  departments: Array<Trade_Tradestatusaccess>;
  id: Scalars['String'];
  is_data_editable: Scalars['Boolean'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  parents: Array<Trade_Status_Parents>;
  /** An aggregate relationship */
  parents_aggregate: Trade_Status_Parents_Aggregate;
  sequence_no: Scalars['String'];
};


/** columns and relationships of "trade_status" */
export type Trade_StatusChildrensArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


/** columns and relationships of "trade_status" */
export type Trade_StatusChildrens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


/** columns and relationships of "trade_status" */
export type Trade_StatusDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Tradestatusaccess_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Tradestatusaccess_Order_By>>;
  where?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
};


/** columns and relationships of "trade_status" */
export type Trade_StatusMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "trade_status" */
export type Trade_StatusParentsArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};


/** columns and relationships of "trade_status" */
export type Trade_StatusParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Status_Parents_Order_By>>;
  where?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
};

/** aggregated selection of "trade_status" */
export type Trade_Status_Aggregate = {
  __typename?: 'trade_status_aggregate';
  aggregate?: Maybe<Trade_Status_Aggregate_Fields>;
  nodes: Array<Trade_Status>;
};

/** aggregate fields of "trade_status" */
export type Trade_Status_Aggregate_Fields = {
  __typename?: 'trade_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trade_Status_Max_Fields>;
  min?: Maybe<Trade_Status_Min_Fields>;
};


/** aggregate fields of "trade_status" */
export type Trade_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "trade_status". All fields are combined with a logical 'AND'. */
export type Trade_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Status_Bool_Exp>>;
  _not?: InputMaybe<Trade_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Status_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  childrens?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
  departments?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_data_editable?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  parents?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
  sequence_no?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Trade_Status_Max_Fields = {
  __typename?: 'trade_status_max_fields';
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Trade_Status_Min_Fields = {
  __typename?: 'trade_status_min_fields';
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sequence_no?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "trade_status". */
export type Trade_Status_Order_By = {
  category?: InputMaybe<Order_By>;
  childrens_aggregate?: InputMaybe<Trade_Status_Parents_Aggregate_Order_By>;
  departments_aggregate?: InputMaybe<Trade_Tradestatusaccess_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_data_editable?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  parents_aggregate?: InputMaybe<Trade_Status_Parents_Aggregate_Order_By>;
  sequence_no?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_status_parents" */
export type Trade_Status_Parents = {
  __typename?: 'trade_status_parents';
  /** An object relationship */
  children: Trade_Status;
  from_tradestatus_id: Scalars['String'];
  id: Scalars['bigint'];
  /** An object relationship */
  parent: Trade_Status;
  to_tradestatus_id: Scalars['String'];
};

/** aggregated selection of "trade_status_parents" */
export type Trade_Status_Parents_Aggregate = {
  __typename?: 'trade_status_parents_aggregate';
  aggregate?: Maybe<Trade_Status_Parents_Aggregate_Fields>;
  nodes: Array<Trade_Status_Parents>;
};

/** aggregate fields of "trade_status_parents" */
export type Trade_Status_Parents_Aggregate_Fields = {
  __typename?: 'trade_status_parents_aggregate_fields';
  avg?: Maybe<Trade_Status_Parents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Status_Parents_Max_Fields>;
  min?: Maybe<Trade_Status_Parents_Min_Fields>;
  stddev?: Maybe<Trade_Status_Parents_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Status_Parents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Status_Parents_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Status_Parents_Sum_Fields>;
  var_pop?: Maybe<Trade_Status_Parents_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Status_Parents_Var_Samp_Fields>;
  variance?: Maybe<Trade_Status_Parents_Variance_Fields>;
};


/** aggregate fields of "trade_status_parents" */
export type Trade_Status_Parents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Status_Parents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_status_parents" */
export type Trade_Status_Parents_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Status_Parents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Status_Parents_Max_Order_By>;
  min?: InputMaybe<Trade_Status_Parents_Min_Order_By>;
  stddev?: InputMaybe<Trade_Status_Parents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Status_Parents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Status_Parents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Status_Parents_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Status_Parents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Status_Parents_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Status_Parents_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Trade_Status_Parents_Avg_Fields = {
  __typename?: 'trade_status_parents_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_status_parents". All fields are combined with a logical 'AND'. */
export type Trade_Status_Parents_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Status_Parents_Bool_Exp>>;
  _not?: InputMaybe<Trade_Status_Parents_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Status_Parents_Bool_Exp>>;
  children?: InputMaybe<Trade_Status_Bool_Exp>;
  from_tradestatus_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parent?: InputMaybe<Trade_Status_Bool_Exp>;
  to_tradestatus_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Trade_Status_Parents_Max_Fields = {
  __typename?: 'trade_status_parents_max_fields';
  from_tradestatus_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  to_tradestatus_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Max_Order_By = {
  from_tradestatus_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_tradestatus_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Status_Parents_Min_Fields = {
  __typename?: 'trade_status_parents_min_fields';
  from_tradestatus_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  to_tradestatus_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Min_Order_By = {
  from_tradestatus_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_tradestatus_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_status_parents". */
export type Trade_Status_Parents_Order_By = {
  children?: InputMaybe<Trade_Status_Order_By>;
  from_tradestatus_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent?: InputMaybe<Trade_Status_Order_By>;
  to_tradestatus_id?: InputMaybe<Order_By>;
};

/** select columns of table "trade_status_parents" */
export enum Trade_Status_Parents_Select_Column {
  /** column name */
  FromTradestatusId = 'from_tradestatus_id',
  /** column name */
  Id = 'id',
  /** column name */
  ToTradestatusId = 'to_tradestatus_id'
}

/** aggregate stddev on columns */
export type Trade_Status_Parents_Stddev_Fields = {
  __typename?: 'trade_status_parents_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Status_Parents_Stddev_Pop_Fields = {
  __typename?: 'trade_status_parents_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Status_Parents_Stddev_Samp_Fields = {
  __typename?: 'trade_status_parents_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_status_parents" */
export type Trade_Status_Parents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Status_Parents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Status_Parents_Stream_Cursor_Value_Input = {
  from_tradestatus_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  to_tradestatus_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Trade_Status_Parents_Sum_Fields = {
  __typename?: 'trade_status_parents_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Trade_Status_Parents_Var_Pop_Fields = {
  __typename?: 'trade_status_parents_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Status_Parents_Var_Samp_Fields = {
  __typename?: 'trade_status_parents_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Status_Parents_Variance_Fields = {
  __typename?: 'trade_status_parents_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_status_parents" */
export type Trade_Status_Parents_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "trade_status" */
export enum Trade_Status_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Id = 'id',
  /** column name */
  IsDataEditable = 'is_data_editable',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SequenceNo = 'sequence_no'
}

/** Streaming cursor of the table "trade_status" */
export type Trade_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Status_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_data_editable?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  sequence_no?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Trade_Stddev_Fields = {
  __typename?: 'trade_stddev_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Float']>;
  buyer_plot_crop_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
  storage_sub_location_id?: Maybe<Scalars['Float']>;
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
  trip_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade" */
export type Trade_Stddev_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Stddev_Pop_Fields = {
  __typename?: 'trade_stddev_pop_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Float']>;
  buyer_plot_crop_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
  storage_sub_location_id?: Maybe<Scalars['Float']>;
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
  trip_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade" */
export type Trade_Stddev_Pop_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Stddev_Samp_Fields = {
  __typename?: 'trade_stddev_samp_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Float']>;
  buyer_plot_crop_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
  storage_sub_location_id?: Maybe<Scalars['Float']>;
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
  trip_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade" */
export type Trade_Stddev_Samp_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade" */
export type Trade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Stream_Cursor_Value_Input = {
  advance_po?: InputMaybe<Scalars['Boolean']>;
  buyer_consent_id?: InputMaybe<Scalars['bigint']>;
  buyer_expense_amount?: InputMaybe<Scalars['float8']>;
  buyer_expense_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  buyer_id?: InputMaybe<Scalars['bigint']>;
  buyer_payable_amount?: InputMaybe<Scalars['numeric']>;
  buyer_payable_amount_tax_incl?: InputMaybe<Scalars['numeric']>;
  buyer_plot_crop_id?: InputMaybe<Scalars['bigint']>;
  buyer_remark?: InputMaybe<Scalars['String']>;
  buyer_settlement_status?: InputMaybe<Scalars['String']>;
  buyer_tnc?: InputMaybe<Scalars['String']>;
  buyer_verification?: InputMaybe<Scalars['Boolean']>;
  commodity_id?: InputMaybe<Scalars['bigint']>;
  commodity_variety_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  current_status_id?: InputMaybe<Scalars['String']>;
  deducted_amount?: InputMaybe<Scalars['numeric']>;
  deducted_quantity?: InputMaybe<Scalars['numeric']>;
  deducted_quantity_kg?: InputMaybe<Scalars['numeric']>;
  deducted_quantity_remaining?: InputMaybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: InputMaybe<Scalars['numeric']>;
  demand_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  direct_cost?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['date']>;
  expense_amount?: InputMaybe<Scalars['numeric']>;
  expiry?: InputMaybe<Scalars['date']>;
  facilitator_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  is_deviation_draft?: InputMaybe<Scalars['Boolean']>;
  is_intercompany_transaction?: InputMaybe<Scalars['Boolean']>;
  is_multiple_commodity?: InputMaybe<Scalars['Boolean']>;
  junior_officer_id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<Scalars['String']>;
  material_kind?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  mis_date_1?: InputMaybe<Scalars['date']>;
  mode?: InputMaybe<Scalars['String']>;
  offer_id?: InputMaybe<Scalars['bigint']>;
  officer_id?: InputMaybe<Scalars['bigint']>;
  packaging?: InputMaybe<Scalars['String']>;
  parent_trade_id?: InputMaybe<Scalars['bigint']>;
  plot_crop_id?: InputMaybe<Scalars['bigint']>;
  production_trade_id?: InputMaybe<Scalars['Int']>;
  profit?: InputMaybe<Scalars['float8']>;
  purchase_value?: InputMaybe<Scalars['float8']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  returned_quantity?: InputMaybe<Scalars['numeric']>;
  returned_quantity_kg?: InputMaybe<Scalars['numeric']>;
  reverse_status_mode?: InputMaybe<Scalars['Boolean']>;
  sales_value?: InputMaybe<Scalars['float8']>;
  seller_consent_id?: InputMaybe<Scalars['bigint']>;
  seller_expense_amount?: InputMaybe<Scalars['float8']>;
  seller_id?: InputMaybe<Scalars['bigint']>;
  seller_receivable_amount?: InputMaybe<Scalars['numeric']>;
  seller_receivable_amount_tax_incl?: InputMaybe<Scalars['numeric']>;
  seller_remark?: InputMaybe<Scalars['String']>;
  seller_settlement_status?: InputMaybe<Scalars['String']>;
  seller_tds?: InputMaybe<Scalars['float8']>;
  seller_tds_percentage?: InputMaybe<Scalars['float8']>;
  seller_tnc?: InputMaybe<Scalars['String']>;
  seller_verification?: InputMaybe<Scalars['Boolean']>;
  standard_deduction?: InputMaybe<Scalars['numeric']>;
  start_date?: InputMaybe<Scalars['date']>;
  status_processing?: InputMaybe<Scalars['Boolean']>;
  storage_location_id?: InputMaybe<Scalars['bigint']>;
  storage_sub_location_id?: InputMaybe<Scalars['bigint']>;
  supplier_charge?: InputMaybe<Scalars['float8']>;
  supplier_expense_gst_auto_calculated?: InputMaybe<Scalars['Boolean']>;
  supplier_rate?: InputMaybe<Scalars['float8']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_quantity?: InputMaybe<Scalars['numeric']>;
  tracking_code?: InputMaybe<Scalars['String']>;
  trade_amounts_counter?: InputMaybe<Scalars['Int']>;
  trip_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  vehicle_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Sum_Fields = {
  __typename?: 'trade_sum_fields';
  buyer_consent_id?: Maybe<Scalars['bigint']>;
  buyer_expense_amount?: Maybe<Scalars['float8']>;
  buyer_id?: Maybe<Scalars['bigint']>;
  buyer_payable_amount?: Maybe<Scalars['numeric']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  buyer_plot_crop_id?: Maybe<Scalars['bigint']>;
  commodity_id?: Maybe<Scalars['bigint']>;
  commodity_variety_id?: Maybe<Scalars['bigint']>;
  deducted_amount?: Maybe<Scalars['numeric']>;
  deducted_quantity?: Maybe<Scalars['numeric']>;
  deducted_quantity_kg?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining?: Maybe<Scalars['numeric']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['numeric']>;
  demand_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  direct_cost?: Maybe<Scalars['float8']>;
  expense_amount?: Maybe<Scalars['numeric']>;
  facilitator_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  junior_officer_id?: Maybe<Scalars['bigint']>;
  offer_id?: Maybe<Scalars['bigint']>;
  officer_id?: Maybe<Scalars['bigint']>;
  parent_trade_id?: Maybe<Scalars['bigint']>;
  plot_crop_id?: Maybe<Scalars['bigint']>;
  production_trade_id?: Maybe<Scalars['Int']>;
  profit?: Maybe<Scalars['float8']>;
  purchase_value?: Maybe<Scalars['float8']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  returned_quantity?: Maybe<Scalars['numeric']>;
  returned_quantity_kg?: Maybe<Scalars['numeric']>;
  sales_value?: Maybe<Scalars['float8']>;
  seller_consent_id?: Maybe<Scalars['bigint']>;
  seller_expense_amount?: Maybe<Scalars['float8']>;
  seller_id?: Maybe<Scalars['bigint']>;
  seller_receivable_amount?: Maybe<Scalars['numeric']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['numeric']>;
  seller_tds?: Maybe<Scalars['float8']>;
  seller_tds_percentage?: Maybe<Scalars['float8']>;
  standard_deduction?: Maybe<Scalars['numeric']>;
  storage_location_id?: Maybe<Scalars['bigint']>;
  storage_sub_location_id?: Maybe<Scalars['bigint']>;
  supplier_charge?: Maybe<Scalars['float8']>;
  supplier_rate?: Maybe<Scalars['float8']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_quantity?: Maybe<Scalars['numeric']>;
  trade_amounts_counter?: Maybe<Scalars['Int']>;
  trip_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade" */
export type Trade_Sum_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_taxes" */
export type Trade_Taxes = {
  __typename?: 'trade_taxes';
  amount?: Maybe<Scalars['numeric']>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  percentage: Scalars['numeric'];
  role: Scalars['String'];
  tax_name: Scalars['String'];
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  trade_item?: Maybe<Trade_Item>;
  trade_item_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "trade_taxes" */
export type Trade_Taxes_Aggregate = {
  __typename?: 'trade_taxes_aggregate';
  aggregate?: Maybe<Trade_Taxes_Aggregate_Fields>;
  nodes: Array<Trade_Taxes>;
};

/** aggregate fields of "trade_taxes" */
export type Trade_Taxes_Aggregate_Fields = {
  __typename?: 'trade_taxes_aggregate_fields';
  avg?: Maybe<Trade_Taxes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trade_Taxes_Max_Fields>;
  min?: Maybe<Trade_Taxes_Min_Fields>;
  stddev?: Maybe<Trade_Taxes_Stddev_Fields>;
  stddev_pop?: Maybe<Trade_Taxes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trade_Taxes_Stddev_Samp_Fields>;
  sum?: Maybe<Trade_Taxes_Sum_Fields>;
  var_pop?: Maybe<Trade_Taxes_Var_Pop_Fields>;
  var_samp?: Maybe<Trade_Taxes_Var_Samp_Fields>;
  variance?: Maybe<Trade_Taxes_Variance_Fields>;
};


/** aggregate fields of "trade_taxes" */
export type Trade_Taxes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trade_Taxes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trade_taxes" */
export type Trade_Taxes_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Taxes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Taxes_Max_Order_By>;
  min?: InputMaybe<Trade_Taxes_Min_Order_By>;
  stddev?: InputMaybe<Trade_Taxes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Taxes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Taxes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Taxes_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Taxes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Taxes_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Taxes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trade_taxes" */
export type Trade_Taxes_Arr_Rel_Insert_Input = {
  data: Array<Trade_Taxes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trade_Taxes_On_Conflict>;
};

/** aggregate avg on columns */
export type Trade_Taxes_Avg_Fields = {
  __typename?: 'trade_taxes_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "trade_taxes" */
export type Trade_Taxes_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_taxes". All fields are combined with a logical 'AND'. */
export type Trade_Taxes_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Taxes_Bool_Exp>>;
  _not?: InputMaybe<Trade_Taxes_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Taxes_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Numeric_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  tax_name?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  trade_item?: InputMaybe<Trade_Item_Bool_Exp>;
  trade_item_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "trade_taxes" */
export enum Trade_Taxes_Constraint {
  /** unique or primary key constraint on columns "codename" */
  TradeTaxesCodenameKey = 'trade_taxes_codename_key',
  /** unique or primary key constraint on columns "id" */
  TradeTaxesPkey = 'trade_taxes_pkey'
}

/** input type for incrementing numeric columns in table "trade_taxes" */
export type Trade_Taxes_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "trade_taxes" */
export type Trade_Taxes_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['String']>;
  tax_name?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  trade_item?: InputMaybe<Trade_Item_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Trade_Taxes_Max_Fields = {
  __typename?: 'trade_taxes_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['String']>;
  tax_name?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  trade_item_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "trade_taxes" */
export type Trade_Taxes_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trade_Taxes_Min_Fields = {
  __typename?: 'trade_taxes_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['String']>;
  tax_name?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  trade_item_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "trade_taxes" */
export type Trade_Taxes_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trade_taxes" */
export type Trade_Taxes_Mutation_Response = {
  __typename?: 'trade_taxes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trade_Taxes>;
};

/** on_conflict condition type for table "trade_taxes" */
export type Trade_Taxes_On_Conflict = {
  constraint: Trade_Taxes_Constraint;
  update_columns?: Array<Trade_Taxes_Update_Column>;
  where?: InputMaybe<Trade_Taxes_Bool_Exp>;
};

/** Ordering options when selecting data from "trade_taxes". */
export type Trade_Taxes_Order_By = {
  amount?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  tax_name?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item?: InputMaybe<Trade_Item_Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trade_taxes */
export type Trade_Taxes_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "trade_taxes" */
export enum Trade_Taxes_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  Role = 'role',
  /** column name */
  TaxName = 'tax_name',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  TradeItemId = 'trade_item_id'
}

/** input type for updating data in table "trade_taxes" */
export type Trade_Taxes_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['String']>;
  tax_name?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Trade_Taxes_Stddev_Fields = {
  __typename?: 'trade_taxes_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "trade_taxes" */
export type Trade_Taxes_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trade_Taxes_Stddev_Pop_Fields = {
  __typename?: 'trade_taxes_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "trade_taxes" */
export type Trade_Taxes_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trade_Taxes_Stddev_Samp_Fields = {
  __typename?: 'trade_taxes_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "trade_taxes" */
export type Trade_Taxes_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_taxes" */
export type Trade_Taxes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Taxes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Taxes_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['String']>;
  tax_name?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  trade_item_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Trade_Taxes_Sum_Fields = {
  __typename?: 'trade_taxes_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  percentage?: Maybe<Scalars['numeric']>;
  trade_id?: Maybe<Scalars['bigint']>;
  trade_item_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "trade_taxes" */
export type Trade_Taxes_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** update columns of table "trade_taxes" */
export enum Trade_Taxes_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  Role = 'role',
  /** column name */
  TaxName = 'tax_name',
  /** column name */
  TradeId = 'trade_id'
}

export type Trade_Taxes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Taxes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Taxes_Set_Input>;
  where: Trade_Taxes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Taxes_Var_Pop_Fields = {
  __typename?: 'trade_taxes_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade_taxes" */
export type Trade_Taxes_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Taxes_Var_Samp_Fields = {
  __typename?: 'trade_taxes_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade_taxes" */
export type Trade_Taxes_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Taxes_Variance_Fields = {
  __typename?: 'trade_taxes_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  trade_item_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade_taxes" */
export type Trade_Taxes_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  trade_item_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess = {
  __typename?: 'trade_tradestatusaccess';
  /** An object relationship */
  department?: Maybe<Setu_Trade_Shared_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  status_id: Scalars['String'];
  /** An object relationship */
  trade_status: Trade_Status;
};

/** order by aggregate values of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Aggregate_Order_By = {
  avg?: InputMaybe<Trade_Tradestatusaccess_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trade_Tradestatusaccess_Max_Order_By>;
  min?: InputMaybe<Trade_Tradestatusaccess_Min_Order_By>;
  stddev?: InputMaybe<Trade_Tradestatusaccess_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trade_Tradestatusaccess_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trade_Tradestatusaccess_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trade_Tradestatusaccess_Sum_Order_By>;
  var_pop?: InputMaybe<Trade_Tradestatusaccess_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trade_Tradestatusaccess_Var_Samp_Order_By>;
  variance?: InputMaybe<Trade_Tradestatusaccess_Variance_Order_By>;
};

/** order by avg() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Avg_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trade_tradestatusaccess". All fields are combined with a logical 'AND'. */
export type Trade_Tradestatusaccess_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Tradestatusaccess_Bool_Exp>>;
  _not?: InputMaybe<Trade_Tradestatusaccess_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Tradestatusaccess_Bool_Exp>>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  status_id?: InputMaybe<String_Comparison_Exp>;
  trade_status?: InputMaybe<Trade_Status_Bool_Exp>;
};

/** order by max() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Max_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Min_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "trade_tradestatusaccess". */
export type Trade_Tradestatusaccess_Order_By = {
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  trade_status?: InputMaybe<Trade_Status_Order_By>;
};

/** select columns of table "trade_tradestatusaccess" */
export enum Trade_Tradestatusaccess_Select_Column {
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  Id = 'id',
  /** column name */
  StatusId = 'status_id'
}

/** order by stddev() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stddev_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stddev_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stddev_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Tradestatusaccess_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Tradestatusaccess_Stream_Cursor_Value_Input = {
  department_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  status_id?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Sum_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Var_Pop_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Var_Samp_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "trade_tradestatusaccess" */
export type Trade_Tradestatusaccess_Variance_Order_By = {
  department_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "trade_twiliomessages" */
export type Trade_Twiliomessages = {
  __typename?: 'trade_twiliomessages';
  created_at: Scalars['timestamptz'];
  id: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "trade_twiliomessages". All fields are combined with a logical 'AND'. */
export type Trade_Twiliomessages_Bool_Exp = {
  _and?: InputMaybe<Array<Trade_Twiliomessages_Bool_Exp>>;
  _not?: InputMaybe<Trade_Twiliomessages_Bool_Exp>;
  _or?: InputMaybe<Array<Trade_Twiliomessages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "trade_twiliomessages". */
export type Trade_Twiliomessages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "trade_twiliomessages" */
export enum Trade_Twiliomessages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "trade_twiliomessages" */
export type Trade_Twiliomessages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trade_Twiliomessages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trade_Twiliomessages_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "trade" */
export enum Trade_Update_Column {
  /** column name */
  AdvancePo = 'advance_po',
  /** column name */
  BuyerConsentId = 'buyer_consent_id',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  BuyerPlotCropId = 'buyer_plot_crop_id',
  /** column name */
  BuyerRemark = 'buyer_remark',
  /** column name */
  BuyerTnc = 'buyer_tnc',
  /** column name */
  CommodityId = 'commodity_id',
  /** column name */
  CommodityVarietyId = 'commodity_variety_id',
  /** column name */
  CurrentStatusId = 'current_status_id',
  /** column name */
  DemandId = 'demand_id',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Expiry = 'expiry',
  /** column name */
  FacilitatorId = 'facilitator_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsDeviationDraft = 'is_deviation_draft',
  /** column name */
  JuniorOfficerId = 'junior_officer_id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialKind = 'material_kind',
  /** column name */
  Mode = 'mode',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfficerId = 'officer_id',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  ParentTradeId = 'parent_trade_id',
  /** column name */
  PlotCropId = 'plot_crop_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SellerConsentId = 'seller_consent_id',
  /** column name */
  SellerId = 'seller_id',
  /** column name */
  SellerRemark = 'seller_remark',
  /** column name */
  SellerTdsPercentage = 'seller_tds_percentage',
  /** column name */
  SellerTnc = 'seller_tnc',
  /** column name */
  StandardDeduction = 'standard_deduction',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StatusProcessing = 'status_processing',
  /** column name */
  StorageLocationId = 'storage_location_id',
  /** column name */
  StorageSubLocationId = 'storage_sub_location_id',
  /** column name */
  TradeAmountsCounter = 'trade_amounts_counter',
  /** column name */
  VehicleId = 'vehicle_id'
}

export type Trade_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trade_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trade_Set_Input>;
  where: Trade_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trade_Var_Pop_Fields = {
  __typename?: 'trade_var_pop_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Float']>;
  buyer_plot_crop_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
  storage_sub_location_id?: Maybe<Scalars['Float']>;
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
  trip_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "trade" */
export type Trade_Var_Pop_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trade_Var_Samp_Fields = {
  __typename?: 'trade_var_samp_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Float']>;
  buyer_plot_crop_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
  storage_sub_location_id?: Maybe<Scalars['Float']>;
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
  trip_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "trade" */
export type Trade_Var_Samp_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trade_Variance_Fields = {
  __typename?: 'trade_variance_fields';
  buyer_consent_id?: Maybe<Scalars['Float']>;
  buyer_expense_amount?: Maybe<Scalars['Float']>;
  buyer_id?: Maybe<Scalars['Float']>;
  buyer_payable_amount?: Maybe<Scalars['Float']>;
  buyer_payable_amount_tax_incl?: Maybe<Scalars['Float']>;
  buyer_plot_crop_id?: Maybe<Scalars['Float']>;
  commodity_id?: Maybe<Scalars['Float']>;
  commodity_variety_id?: Maybe<Scalars['Float']>;
  deducted_amount?: Maybe<Scalars['Float']>;
  deducted_quantity?: Maybe<Scalars['Float']>;
  deducted_quantity_kg?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining?: Maybe<Scalars['Float']>;
  deducted_quantity_remaining_kg?: Maybe<Scalars['Float']>;
  demand_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  direct_cost?: Maybe<Scalars['Float']>;
  expense_amount?: Maybe<Scalars['Float']>;
  facilitator_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  junior_officer_id?: Maybe<Scalars['Float']>;
  offer_id?: Maybe<Scalars['Float']>;
  officer_id?: Maybe<Scalars['Float']>;
  parent_trade_id?: Maybe<Scalars['Float']>;
  plot_crop_id?: Maybe<Scalars['Float']>;
  production_trade_id?: Maybe<Scalars['Float']>;
  profit?: Maybe<Scalars['Float']>;
  purchase_value?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  returned_quantity?: Maybe<Scalars['Float']>;
  returned_quantity_kg?: Maybe<Scalars['Float']>;
  sales_value?: Maybe<Scalars['Float']>;
  seller_consent_id?: Maybe<Scalars['Float']>;
  seller_expense_amount?: Maybe<Scalars['Float']>;
  seller_id?: Maybe<Scalars['Float']>;
  seller_receivable_amount?: Maybe<Scalars['Float']>;
  seller_receivable_amount_tax_incl?: Maybe<Scalars['Float']>;
  seller_tds?: Maybe<Scalars['Float']>;
  seller_tds_percentage?: Maybe<Scalars['Float']>;
  standard_deduction?: Maybe<Scalars['Float']>;
  storage_location_id?: Maybe<Scalars['Float']>;
  storage_sub_location_id?: Maybe<Scalars['Float']>;
  supplier_charge?: Maybe<Scalars['Float']>;
  supplier_rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_quantity?: Maybe<Scalars['Float']>;
  trade_amounts_counter?: Maybe<Scalars['Float']>;
  trip_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "trade" */
export type Trade_Variance_Order_By = {
  buyer_consent_id?: InputMaybe<Order_By>;
  buyer_expense_amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  buyer_payable_amount?: InputMaybe<Order_By>;
  buyer_payable_amount_tax_incl?: InputMaybe<Order_By>;
  buyer_plot_crop_id?: InputMaybe<Order_By>;
  commodity_id?: InputMaybe<Order_By>;
  commodity_variety_id?: InputMaybe<Order_By>;
  deducted_amount?: InputMaybe<Order_By>;
  deducted_quantity?: InputMaybe<Order_By>;
  deducted_quantity_kg?: InputMaybe<Order_By>;
  deducted_quantity_remaining?: InputMaybe<Order_By>;
  deducted_quantity_remaining_kg?: InputMaybe<Order_By>;
  demand_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  direct_cost?: InputMaybe<Order_By>;
  expense_amount?: InputMaybe<Order_By>;
  facilitator_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  junior_officer_id?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  officer_id?: InputMaybe<Order_By>;
  parent_trade_id?: InputMaybe<Order_By>;
  plot_crop_id?: InputMaybe<Order_By>;
  production_trade_id?: InputMaybe<Order_By>;
  profit?: InputMaybe<Order_By>;
  purchase_value?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  returned_quantity?: InputMaybe<Order_By>;
  returned_quantity_kg?: InputMaybe<Order_By>;
  sales_value?: InputMaybe<Order_By>;
  seller_consent_id?: InputMaybe<Order_By>;
  seller_expense_amount?: InputMaybe<Order_By>;
  seller_id?: InputMaybe<Order_By>;
  seller_receivable_amount?: InputMaybe<Order_By>;
  seller_receivable_amount_tax_incl?: InputMaybe<Order_By>;
  seller_tds?: InputMaybe<Order_By>;
  seller_tds_percentage?: InputMaybe<Order_By>;
  standard_deduction?: InputMaybe<Order_By>;
  storage_location_id?: InputMaybe<Order_By>;
  storage_sub_location_id?: InputMaybe<Order_By>;
  supplier_charge?: InputMaybe<Order_By>;
  supplier_rate?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_quantity?: InputMaybe<Order_By>;
  trade_amounts_counter?: InputMaybe<Order_By>;
  trip_id?: InputMaybe<Order_By>;
  vehicle_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "transaction" */
export type Transaction = {
  __typename?: 'transaction';
  account_no?: Maybe<Scalars['String']>;
  /** An object relationship */
  advance_payment?: Maybe<Advance_Payment>;
  advance_payment_id?: Maybe<Scalars['bigint']>;
  amount: Scalars['float8'];
  /** An array relationship */
  attachments: Array<Transaction_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Transaction_Attachments_Aggregate;
  /** An object relationship */
  bank?: Maybe<Setu_Trade_Shared_Entity>;
  bank_id?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  child_transactions: Array<Transaction>;
  /** An aggregate relationship */
  child_transactions_aggregate: Transaction_Aggregate;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Base_User>;
  created_by_id: Scalars['String'];
  /** An object relationship */
  credit_transaction?: Maybe<Credit_Transaction>;
  date: Scalars['date'];
  /** An object relationship */
  department?: Maybe<Setu_Trade_Shared_Entity>;
  department_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  department_settlement?: Maybe<Department_Settlements>;
  department_settlement_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  mode: Transaction_Mode;
  mode_id: Scalars['bigint'];
  /** An object relationship */
  parent_transaction?: Maybe<Transaction>;
  parent_transaction_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  receipt?: Maybe<Receipt>;
  receipt_id?: Maybe<Scalars['bigint']>;
  ref?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  /** An object relationship */
  trade?: Maybe<Trade>;
  trade_id?: Maybe<Scalars['bigint']>;
  transaction_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Base_User>;
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_id?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "transaction" */
export type TransactionAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};


/** columns and relationships of "transaction" */
export type TransactionAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Attachments_Order_By>>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};


/** columns and relationships of "transaction" */
export type TransactionChild_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};


/** columns and relationships of "transaction" */
export type TransactionChild_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transaction_Order_By>>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

/** aggregated selection of "transaction" */
export type Transaction_Aggregate = {
  __typename?: 'transaction_aggregate';
  aggregate?: Maybe<Transaction_Aggregate_Fields>;
  nodes: Array<Transaction>;
};

/** aggregate fields of "transaction" */
export type Transaction_Aggregate_Fields = {
  __typename?: 'transaction_aggregate_fields';
  avg?: Maybe<Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transaction_Max_Fields>;
  min?: Maybe<Transaction_Min_Fields>;
  stddev?: Maybe<Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Transaction_Sum_Fields>;
  var_pop?: Maybe<Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Transaction_Var_Samp_Fields>;
  variance?: Maybe<Transaction_Variance_Fields>;
};


/** aggregate fields of "transaction" */
export type Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transaction" */
export type Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Max_Order_By>;
  min?: InputMaybe<Transaction_Min_Order_By>;
  stddev?: InputMaybe<Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Transaction_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transaction" */
export type Transaction_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transaction_On_Conflict>;
};

/** columns and relationships of "transaction_attachments" */
export type Transaction_Attachments = {
  __typename?: 'transaction_attachments';
  id: Scalars['bigint'];
  /** An object relationship */
  media: Setutrade_Media;
  media_id: Scalars['bigint'];
  /** An object relationship */
  transaction: Transaction;
  transaction_id: Scalars['bigint'];
};

/** aggregated selection of "transaction_attachments" */
export type Transaction_Attachments_Aggregate = {
  __typename?: 'transaction_attachments_aggregate';
  aggregate?: Maybe<Transaction_Attachments_Aggregate_Fields>;
  nodes: Array<Transaction_Attachments>;
};

/** aggregate fields of "transaction_attachments" */
export type Transaction_Attachments_Aggregate_Fields = {
  __typename?: 'transaction_attachments_aggregate_fields';
  avg?: Maybe<Transaction_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transaction_Attachments_Max_Fields>;
  min?: Maybe<Transaction_Attachments_Min_Fields>;
  stddev?: Maybe<Transaction_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Transaction_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transaction_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Transaction_Attachments_Sum_Fields>;
  var_pop?: Maybe<Transaction_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Transaction_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Transaction_Attachments_Variance_Fields>;
};


/** aggregate fields of "transaction_attachments" */
export type Transaction_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transaction_attachments" */
export type Transaction_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Transaction_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Attachments_Max_Order_By>;
  min?: InputMaybe<Transaction_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Transaction_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transaction_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transaction_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transaction_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Transaction_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transaction_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Transaction_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transaction_attachments" */
export type Transaction_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transaction_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Transaction_Attachments_Avg_Fields = {
  __typename?: 'transaction_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transaction_attachments". All fields are combined with a logical 'AND'. */
export type Transaction_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Attachments_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  media?: InputMaybe<Setutrade_Media_Bool_Exp>;
  media_id?: InputMaybe<Bigint_Comparison_Exp>;
  transaction?: InputMaybe<Transaction_Bool_Exp>;
  transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "transaction_attachments" */
export enum Transaction_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransactionAttachmentsPkey = 'transaction_attachments_pkey',
  /** unique or primary key constraint on columns "transaction_id", "media_id" */
  TransactionAttachmentsTransactionIdMediaIdC512e1baUniq = 'transaction_attachments_transaction_id_media_id_c512e1ba_uniq'
}

/** input type for incrementing numeric columns in table "transaction_attachments" */
export type Transaction_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "transaction_attachments" */
export type Transaction_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media?: InputMaybe<Setutrade_Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['bigint']>;
  transaction?: InputMaybe<Transaction_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Transaction_Attachments_Max_Fields = {
  __typename?: 'transaction_attachments_max_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Attachments_Min_Fields = {
  __typename?: 'transaction_attachments_min_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transaction_attachments" */
export type Transaction_Attachments_Mutation_Response = {
  __typename?: 'transaction_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction_Attachments>;
};

/** on_conflict condition type for table "transaction_attachments" */
export type Transaction_Attachments_On_Conflict = {
  constraint: Transaction_Attachments_Constraint;
  update_columns?: Array<Transaction_Attachments_Update_Column>;
  where?: InputMaybe<Transaction_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "transaction_attachments". */
export type Transaction_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Setutrade_Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Transaction_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transaction_attachments */
export type Transaction_Attachments_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "transaction_attachments" */
export enum Transaction_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TransactionId = 'transaction_id'
}

/** input type for updating data in table "transaction_attachments" */
export type Transaction_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Transaction_Attachments_Stddev_Fields = {
  __typename?: 'transaction_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transaction_Attachments_Stddev_Pop_Fields = {
  __typename?: 'transaction_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transaction_Attachments_Stddev_Samp_Fields = {
  __typename?: 'transaction_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transaction_attachments" */
export type Transaction_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transaction_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transaction_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  media_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Transaction_Attachments_Sum_Fields = {
  __typename?: 'transaction_attachments_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  media_id?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "transaction_attachments" */
export enum Transaction_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TransactionId = 'transaction_id'
}

export type Transaction_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transaction_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transaction_Attachments_Set_Input>;
  where: Transaction_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transaction_Attachments_Var_Pop_Fields = {
  __typename?: 'transaction_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transaction_Attachments_Var_Samp_Fields = {
  __typename?: 'transaction_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transaction_Attachments_Variance_Fields = {
  __typename?: 'transaction_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transaction_attachments" */
export type Transaction_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Transaction_Avg_Fields = {
  __typename?: 'transaction_avg_fields';
  advance_payment_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  bank_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  department_settlement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  mode_id?: Maybe<Scalars['Float']>;
  parent_transaction_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transaction" */
export type Transaction_Avg_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transaction". All fields are combined with a logical 'AND'. */
export type Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Bool_Exp>>;
  account_no?: InputMaybe<String_Comparison_Exp>;
  advance_payment?: InputMaybe<Advance_Payment_Bool_Exp>;
  advance_payment_id?: InputMaybe<Bigint_Comparison_Exp>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  attachments?: InputMaybe<Transaction_Attachments_Bool_Exp>;
  bank?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  bank_id?: InputMaybe<Bigint_Comparison_Exp>;
  child_transactions?: InputMaybe<Transaction_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  credit_transaction?: InputMaybe<Credit_Transaction_Bool_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  department_id?: InputMaybe<Bigint_Comparison_Exp>;
  department_settlement?: InputMaybe<Department_Settlements_Bool_Exp>;
  department_settlement_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_id?: InputMaybe<Bigint_Comparison_Exp>;
  mode?: InputMaybe<Transaction_Mode_Bool_Exp>;
  mode_id?: InputMaybe<Bigint_Comparison_Exp>;
  parent_transaction?: InputMaybe<Transaction_Bool_Exp>;
  parent_transaction_id?: InputMaybe<Bigint_Comparison_Exp>;
  receipt?: InputMaybe<Receipt_Bool_Exp>;
  receipt_id?: InputMaybe<Bigint_Comparison_Exp>;
  ref?: InputMaybe<String_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  trade?: InputMaybe<Trade_Bool_Exp>;
  trade_id?: InputMaybe<Bigint_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "transaction" */
export enum Transaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransactionPkey = 'transaction_pkey'
}

/** input type for incrementing numeric columns in table "transaction" */
export type Transaction_Inc_Input = {
  advance_payment_id?: InputMaybe<Scalars['bigint']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_id?: InputMaybe<Scalars['bigint']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  department_settlement_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  mode_id?: InputMaybe<Scalars['bigint']>;
  parent_transaction_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "transaction" */
export type Transaction_Insert_Input = {
  account_no?: InputMaybe<Scalars['String']>;
  advance_payment?: InputMaybe<Advance_Payment_Obj_Rel_Insert_Input>;
  advance_payment_id?: InputMaybe<Scalars['bigint']>;
  amount?: InputMaybe<Scalars['float8']>;
  attachments?: InputMaybe<Transaction_Attachments_Arr_Rel_Insert_Input>;
  bank?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  bank_id?: InputMaybe<Scalars['bigint']>;
  child_transactions?: InputMaybe<Transaction_Arr_Rel_Insert_Input>;
  date?: InputMaybe<Scalars['date']>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  department_id?: InputMaybe<Scalars['bigint']>;
  department_settlement?: InputMaybe<Department_Settlements_Obj_Rel_Insert_Input>;
  department_settlement_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  mode_id?: InputMaybe<Scalars['bigint']>;
  parent_transaction?: InputMaybe<Transaction_Obj_Rel_Insert_Input>;
  parent_transaction_id?: InputMaybe<Scalars['bigint']>;
  receipt?: InputMaybe<Receipt_Obj_Rel_Insert_Input>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<Trade_Obj_Rel_Insert_Input>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Transaction_Max_Fields = {
  __typename?: 'transaction_max_fields';
  account_no?: Maybe<Scalars['String']>;
  advance_payment_id?: Maybe<Scalars['bigint']>;
  amount?: Maybe<Scalars['float8']>;
  bank_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  department_id?: Maybe<Scalars['bigint']>;
  department_settlement_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  mode_id?: Maybe<Scalars['bigint']>;
  parent_transaction_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  ref?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "transaction" */
export type Transaction_Max_Order_By = {
  account_no?: InputMaybe<Order_By>;
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  ref?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Min_Fields = {
  __typename?: 'transaction_min_fields';
  account_no?: Maybe<Scalars['String']>;
  advance_payment_id?: Maybe<Scalars['bigint']>;
  amount?: Maybe<Scalars['float8']>;
  bank_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  department_id?: Maybe<Scalars['bigint']>;
  department_settlement_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  mode_id?: Maybe<Scalars['bigint']>;
  parent_transaction_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  ref?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  trade_id?: Maybe<Scalars['bigint']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "transaction" */
export type Transaction_Min_Order_By = {
  account_no?: InputMaybe<Order_By>;
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  ref?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transaction" */
export type Transaction_Mutation_Response = {
  __typename?: 'transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction>;
};

/** input type for inserting object relation for remote table "transaction" */
export type Transaction_Obj_Rel_Insert_Input = {
  data: Transaction_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transaction_On_Conflict>;
};

/** on_conflict condition type for table "transaction" */
export type Transaction_On_Conflict = {
  constraint: Transaction_Constraint;
  update_columns?: Array<Transaction_Update_Column>;
  where?: InputMaybe<Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "transaction". */
export type Transaction_Order_By = {
  account_no?: InputMaybe<Order_By>;
  advance_payment?: InputMaybe<Advance_Payment_Order_By>;
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Transaction_Attachments_Aggregate_Order_By>;
  bank?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  bank_id?: InputMaybe<Order_By>;
  child_transactions_aggregate?: InputMaybe<Transaction_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  credit_transaction?: InputMaybe<Credit_Transaction_Order_By>;
  date?: InputMaybe<Order_By>;
  department?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement?: InputMaybe<Department_Settlements_Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode?: InputMaybe<Transaction_Mode_Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction?: InputMaybe<Transaction_Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt?: InputMaybe<Receipt_Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  ref?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  trade?: InputMaybe<Trade_Order_By>;
  trade_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transaction */
export type Transaction_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "transaction" */
export enum Transaction_Select_Column {
  /** column name */
  AccountNo = 'account_no',
  /** column name */
  AdvancePaymentId = 'advance_payment_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Date = 'date',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  DepartmentSettlementId = 'department_settlement_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  ModeId = 'mode_id',
  /** column name */
  ParentTransactionId = 'parent_transaction_id',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  Ref = 'ref',
  /** column name */
  Remark = 'remark',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "transaction" */
export type Transaction_Set_Input = {
  account_no?: InputMaybe<Scalars['String']>;
  advance_payment_id?: InputMaybe<Scalars['bigint']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  department_settlement_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  mode_id?: InputMaybe<Scalars['bigint']>;
  parent_transaction_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  remark?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Transaction_Stddev_Fields = {
  __typename?: 'transaction_stddev_fields';
  advance_payment_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  bank_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  department_settlement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  mode_id?: Maybe<Scalars['Float']>;
  parent_transaction_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transaction" */
export type Transaction_Stddev_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transaction_Stddev_Pop_Fields = {
  __typename?: 'transaction_stddev_pop_fields';
  advance_payment_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  bank_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  department_settlement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  mode_id?: Maybe<Scalars['Float']>;
  parent_transaction_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transaction" */
export type Transaction_Stddev_Pop_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transaction_Stddev_Samp_Fields = {
  __typename?: 'transaction_stddev_samp_fields';
  advance_payment_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  bank_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  department_settlement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  mode_id?: Maybe<Scalars['Float']>;
  parent_transaction_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transaction" */
export type Transaction_Stddev_Samp_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transaction" */
export type Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transaction_Stream_Cursor_Value_Input = {
  account_no?: InputMaybe<Scalars['String']>;
  advance_payment_id?: InputMaybe<Scalars['bigint']>;
  amount?: InputMaybe<Scalars['float8']>;
  bank_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  department_id?: InputMaybe<Scalars['bigint']>;
  department_settlement_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  invoice_id?: InputMaybe<Scalars['bigint']>;
  mode_id?: InputMaybe<Scalars['bigint']>;
  parent_transaction_id?: InputMaybe<Scalars['bigint']>;
  receipt_id?: InputMaybe<Scalars['bigint']>;
  ref?: InputMaybe<Scalars['String']>;
  remark?: InputMaybe<Scalars['String']>;
  trade_id?: InputMaybe<Scalars['bigint']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Transaction_Sum_Fields = {
  __typename?: 'transaction_sum_fields';
  advance_payment_id?: Maybe<Scalars['bigint']>;
  amount?: Maybe<Scalars['float8']>;
  bank_id?: Maybe<Scalars['bigint']>;
  department_id?: Maybe<Scalars['bigint']>;
  department_settlement_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  invoice_id?: Maybe<Scalars['bigint']>;
  mode_id?: Maybe<Scalars['bigint']>;
  parent_transaction_id?: Maybe<Scalars['bigint']>;
  receipt_id?: Maybe<Scalars['bigint']>;
  trade_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "transaction" */
export type Transaction_Sum_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "transaction" */
export enum Transaction_Update_Column {
  /** column name */
  AccountNo = 'account_no',
  /** column name */
  AdvancePaymentId = 'advance_payment_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankId = 'bank_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Date = 'date',
  /** column name */
  DepartmentId = 'department_id',
  /** column name */
  DepartmentSettlementId = 'department_settlement_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  ModeId = 'mode_id',
  /** column name */
  ParentTransactionId = 'parent_transaction_id',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  TradeId = 'trade_id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

export type Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transaction_Set_Input>;
  where: Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transaction_Var_Pop_Fields = {
  __typename?: 'transaction_var_pop_fields';
  advance_payment_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  bank_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  department_settlement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  mode_id?: Maybe<Scalars['Float']>;
  parent_transaction_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transaction" */
export type Transaction_Var_Pop_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transaction_Var_Samp_Fields = {
  __typename?: 'transaction_var_samp_fields';
  advance_payment_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  bank_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  department_settlement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  mode_id?: Maybe<Scalars['Float']>;
  parent_transaction_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transaction" */
export type Transaction_Var_Samp_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transaction_Variance_Fields = {
  __typename?: 'transaction_variance_fields';
  advance_payment_id?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  bank_id?: Maybe<Scalars['Float']>;
  department_id?: Maybe<Scalars['Float']>;
  department_settlement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  invoice_id?: Maybe<Scalars['Float']>;
  mode_id?: Maybe<Scalars['Float']>;
  parent_transaction_id?: Maybe<Scalars['Float']>;
  receipt_id?: Maybe<Scalars['Float']>;
  trade_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transaction" */
export type Transaction_Variance_Order_By = {
  advance_payment_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  bank_id?: InputMaybe<Order_By>;
  department_id?: InputMaybe<Order_By>;
  department_settlement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  mode_id?: InputMaybe<Order_By>;
  parent_transaction_id?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  trade_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "transactions" */
export type Transactions = {
  __typename?: 'transactions';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  /** An array relationship */
  agreement_invoice_transactions: Array<Agreement_Invoice_Transaction>;
  /** An aggregate relationship */
  agreement_invoice_transactions_aggregate: Agreement_Invoice_Transaction_Aggregate;
  amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  attachments: Array<Transactions_Attachments>;
  /** An aggregate relationship */
  attachments_aggregate: Transactions_Attachments_Aggregate;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['Int'];
  ifsc?: Maybe<Scalars['String']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  payment_method: Payment_Method;
  payment_method_id: Scalars['Int'];
  /** An array relationship */
  shareholder_applications: Array<Shareholder_Applications>;
  /** An aggregate relationship */
  shareholder_applications_aggregate: Shareholder_Applications_Aggregate;
  transaction_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "transactions" */
export type TransactionsAgreement_Invoice_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


/** columns and relationships of "transactions" */
export type TransactionsAgreement_Invoice_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Invoice_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreement_Invoice_Transaction_Order_By>>;
  where?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
};


/** columns and relationships of "transactions" */
export type TransactionsAttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Attachments_Order_By>>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};


/** columns and relationships of "transactions" */
export type TransactionsAttachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transactions_Attachments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transactions_Attachments_Order_By>>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};


/** columns and relationships of "transactions" */
export type TransactionsShareholder_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};


/** columns and relationships of "transactions" */
export type TransactionsShareholder_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shareholder_Applications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shareholder_Applications_Order_By>>;
  where?: InputMaybe<Shareholder_Applications_Bool_Exp>;
};

/** aggregated selection of "transactions" */
export type Transactions_Aggregate = {
  __typename?: 'transactions_aggregate';
  aggregate?: Maybe<Transactions_Aggregate_Fields>;
  nodes: Array<Transactions>;
};

/** aggregate fields of "transactions" */
export type Transactions_Aggregate_Fields = {
  __typename?: 'transactions_aggregate_fields';
  avg?: Maybe<Transactions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transactions_Max_Fields>;
  min?: Maybe<Transactions_Min_Fields>;
  stddev?: Maybe<Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Transactions_Sum_Fields>;
  var_pop?: Maybe<Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Transactions_Var_Samp_Fields>;
  variance?: Maybe<Transactions_Variance_Fields>;
};


/** aggregate fields of "transactions" */
export type Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "transactions_attachments" */
export type Transactions_Attachments = {
  __typename?: 'transactions_attachments';
  id: Scalars['Int'];
  /** An object relationship */
  media: Media;
  media_id: Scalars['Int'];
  /** An object relationship */
  transaction: Transactions;
  transaction_id: Scalars['Int'];
};

/** aggregated selection of "transactions_attachments" */
export type Transactions_Attachments_Aggregate = {
  __typename?: 'transactions_attachments_aggregate';
  aggregate?: Maybe<Transactions_Attachments_Aggregate_Fields>;
  nodes: Array<Transactions_Attachments>;
};

/** aggregate fields of "transactions_attachments" */
export type Transactions_Attachments_Aggregate_Fields = {
  __typename?: 'transactions_attachments_aggregate_fields';
  avg?: Maybe<Transactions_Attachments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transactions_Attachments_Max_Fields>;
  min?: Maybe<Transactions_Attachments_Min_Fields>;
  stddev?: Maybe<Transactions_Attachments_Stddev_Fields>;
  stddev_pop?: Maybe<Transactions_Attachments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transactions_Attachments_Stddev_Samp_Fields>;
  sum?: Maybe<Transactions_Attachments_Sum_Fields>;
  var_pop?: Maybe<Transactions_Attachments_Var_Pop_Fields>;
  var_samp?: Maybe<Transactions_Attachments_Var_Samp_Fields>;
  variance?: Maybe<Transactions_Attachments_Variance_Fields>;
};


/** aggregate fields of "transactions_attachments" */
export type Transactions_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transactions_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transactions_attachments" */
export type Transactions_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Transactions_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transactions_Attachments_Max_Order_By>;
  min?: InputMaybe<Transactions_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Transactions_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transactions_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transactions_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transactions_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Transactions_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transactions_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Transactions_Attachments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transactions_attachments" */
export type Transactions_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Transactions_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transactions_Attachments_On_Conflict>;
};

/** aggregate avg on columns */
export type Transactions_Attachments_Avg_Fields = {
  __typename?: 'transactions_attachments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transactions_attachments". All fields are combined with a logical 'AND'. */
export type Transactions_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Transactions_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Transactions_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Transactions_Attachments_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media?: InputMaybe<Media_Bool_Exp>;
  media_id?: InputMaybe<Int_Comparison_Exp>;
  transaction?: InputMaybe<Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "transactions_attachments" */
export enum Transactions_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransactionsAttachmentsPkey = 'transactions_attachments_pkey',
  /** unique or primary key constraint on columns "transaction_id", "media_id" */
  TransactionsAttachmentsTransactionIdMediaId_24bc03f1Uniq = 'transactions_attachments_transaction_id_media_id_24bc03f1_uniq'
}

/** input type for incrementing numeric columns in table "transactions_attachments" */
export type Transactions_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "transactions_attachments" */
export type Transactions_Attachments_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  media_id?: InputMaybe<Scalars['Int']>;
  transaction?: InputMaybe<Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Transactions_Attachments_Max_Fields = {
  __typename?: 'transactions_attachments_max_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transactions_Attachments_Min_Fields = {
  __typename?: 'transactions_attachments_min_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transactions_attachments" */
export type Transactions_Attachments_Mutation_Response = {
  __typename?: 'transactions_attachments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transactions_Attachments>;
};

/** on_conflict condition type for table "transactions_attachments" */
export type Transactions_Attachments_On_Conflict = {
  constraint: Transactions_Attachments_Constraint;
  update_columns?: Array<Transactions_Attachments_Update_Column>;
  where?: InputMaybe<Transactions_Attachments_Bool_Exp>;
};

/** Ordering options when selecting data from "transactions_attachments". */
export type Transactions_Attachments_Order_By = {
  id?: InputMaybe<Order_By>;
  media?: InputMaybe<Media_Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transactions_attachments */
export type Transactions_Attachments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "transactions_attachments" */
export enum Transactions_Attachments_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TransactionId = 'transaction_id'
}

/** input type for updating data in table "transactions_attachments" */
export type Transactions_Attachments_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Transactions_Attachments_Stddev_Fields = {
  __typename?: 'transactions_attachments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transactions_Attachments_Stddev_Pop_Fields = {
  __typename?: 'transactions_attachments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transactions_Attachments_Stddev_Samp_Fields = {
  __typename?: 'transactions_attachments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transactions_attachments" */
export type Transactions_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transactions_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transactions_Attachments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Transactions_Attachments_Sum_Fields = {
  __typename?: 'transactions_attachments_sum_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "transactions_attachments" */
export enum Transactions_Attachments_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  TransactionId = 'transaction_id'
}

export type Transactions_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transactions_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transactions_Attachments_Set_Input>;
  where: Transactions_Attachments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transactions_Attachments_Var_Pop_Fields = {
  __typename?: 'transactions_attachments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transactions_Attachments_Var_Samp_Fields = {
  __typename?: 'transactions_attachments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transactions_Attachments_Variance_Fields = {
  __typename?: 'transactions_attachments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  transaction_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transactions_attachments" */
export type Transactions_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Transactions_Avg_Fields = {
  __typename?: 'transactions_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "transactions". All fields are combined with a logical 'AND'. */
export type Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Transactions_Bool_Exp>>;
  _not?: InputMaybe<Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Transactions_Bool_Exp>>;
  account_holder_name?: InputMaybe<String_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  agreement_invoice_transactions?: InputMaybe<Agreement_Invoice_Transaction_Bool_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  attachments?: InputMaybe<Transactions_Attachments_Bool_Exp>;
  bank_name?: InputMaybe<String_Comparison_Exp>;
  branch_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ifsc?: InputMaybe<String_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Method_Bool_Exp>;
  payment_method_id?: InputMaybe<Int_Comparison_Exp>;
  shareholder_applications?: InputMaybe<Shareholder_Applications_Bool_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "transactions" */
export enum Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransactionsPkey = 'transactions_pkey',
  /** unique or primary key constraint on columns "transaction_id" */
  TransactionsTransactionIdKey = 'transactions_transaction_id_key'
}

/** input type for incrementing numeric columns in table "transactions" */
export type Transactions_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "transactions" */
export type Transactions_Insert_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  agreement_invoice_transactions?: InputMaybe<Agreement_Invoice_Transaction_Arr_Rel_Insert_Input>;
  amount?: InputMaybe<Scalars['numeric']>;
  attachments?: InputMaybe<Transactions_Attachments_Arr_Rel_Insert_Input>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  payment_method?: InputMaybe<Payment_Method_Obj_Rel_Insert_Input>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  shareholder_applications?: InputMaybe<Shareholder_Applications_Arr_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Transactions_Max_Fields = {
  __typename?: 'transactions_max_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Transactions_Min_Fields = {
  __typename?: 'transactions_min_fields';
  account_holder_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  bank_name?: Maybe<Scalars['String']>;
  branch_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  ifsc?: Maybe<Scalars['String']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "transactions" */
export type Transactions_Mutation_Response = {
  __typename?: 'transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transactions>;
};

/** input type for inserting object relation for remote table "transactions" */
export type Transactions_Obj_Rel_Insert_Input = {
  data: Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transactions_On_Conflict>;
};

/** on_conflict condition type for table "transactions" */
export type Transactions_On_Conflict = {
  constraint: Transactions_Constraint;
  update_columns?: Array<Transactions_Update_Column>;
  where?: InputMaybe<Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "transactions". */
export type Transactions_Order_By = {
  account_holder_name?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  agreement_invoice_transactions_aggregate?: InputMaybe<Agreement_Invoice_Transaction_Aggregate_Order_By>;
  amount?: InputMaybe<Order_By>;
  attachments_aggregate?: InputMaybe<Transactions_Attachments_Aggregate_Order_By>;
  bank_name?: InputMaybe<Order_By>;
  branch_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ifsc?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Payment_Method_Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  shareholder_applications_aggregate?: InputMaybe<Shareholder_Applications_Aggregate_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transactions */
export type Transactions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "transactions" */
export enum Transactions_Select_Column {
  /** column name */
  AccountHolderName = 'account_holder_name',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Ifsc = 'ifsc',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "transactions" */
export type Transactions_Set_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Transactions_Stddev_Fields = {
  __typename?: 'transactions_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Transactions_Stddev_Pop_Fields = {
  __typename?: 'transactions_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Transactions_Stddev_Samp_Fields = {
  __typename?: 'transactions_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "transactions" */
export type Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transactions_Stream_Cursor_Value_Input = {
  account_holder_name?: InputMaybe<Scalars['String']>;
  account_number?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  bank_name?: InputMaybe<Scalars['String']>;
  branch_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  ifsc?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Transactions_Sum_Fields = {
  __typename?: 'transactions_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "transactions" */
export enum Transactions_Update_Column {
  /** column name */
  AccountHolderName = 'account_holder_name',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  Amount = 'amount',
  /** column name */
  BankName = 'bank_name',
  /** column name */
  BranchName = 'branch_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Ifsc = 'ifsc',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transactions_Set_Input>;
  where: Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transactions_Var_Pop_Fields = {
  __typename?: 'transactions_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Transactions_Var_Samp_Fields = {
  __typename?: 'transactions_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Transactions_Variance_Fields = {
  __typename?: 'transactions_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "transition" */
export type Transition = {
  __typename?: 'transition';
  alert: Scalars['Boolean'];
  /** An array relationship */
  allowed_groups: Array<Transition_Access>;
  /** An aggregate relationship */
  allowed_groups_aggregate: Transition_Access_Aggregate;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  display_name: Scalars['String'];
  /** An object relationship */
  from_state?: Maybe<State>;
  from_state_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  sequence: Scalars['String'];
  /** An object relationship */
  to_state: State;
  to_state_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  workflow: Workflow;
  workflow_id: Scalars['bigint'];
};


/** columns and relationships of "transition" */
export type TransitionAllowed_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Transition_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Access_Order_By>>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};


/** columns and relationships of "transition" */
export type TransitionAllowed_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Access_Order_By>>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};


/** columns and relationships of "transition" */
export type TransitionMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "transition" */
export type TransitionPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "transition_access" */
export type Transition_Access = {
  __typename?: 'transition_access';
  /** An object relationship */
  allowed_group: External_Entity;
  allowed_group_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An object relationship */
  transition: Transition;
  transition_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "transition_access" */
export type Transition_Access_Aggregate = {
  __typename?: 'transition_access_aggregate';
  aggregate?: Maybe<Transition_Access_Aggregate_Fields>;
  nodes: Array<Transition_Access>;
};

/** aggregate fields of "transition_access" */
export type Transition_Access_Aggregate_Fields = {
  __typename?: 'transition_access_aggregate_fields';
  avg?: Maybe<Transition_Access_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transition_Access_Max_Fields>;
  min?: Maybe<Transition_Access_Min_Fields>;
  stddev?: Maybe<Transition_Access_Stddev_Fields>;
  stddev_pop?: Maybe<Transition_Access_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transition_Access_Stddev_Samp_Fields>;
  sum?: Maybe<Transition_Access_Sum_Fields>;
  var_pop?: Maybe<Transition_Access_Var_Pop_Fields>;
  var_samp?: Maybe<Transition_Access_Var_Samp_Fields>;
  variance?: Maybe<Transition_Access_Variance_Fields>;
};


/** aggregate fields of "transition_access" */
export type Transition_Access_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transition_Access_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transition_access" */
export type Transition_Access_Aggregate_Order_By = {
  avg?: InputMaybe<Transition_Access_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transition_Access_Max_Order_By>;
  min?: InputMaybe<Transition_Access_Min_Order_By>;
  stddev?: InputMaybe<Transition_Access_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transition_Access_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transition_Access_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transition_Access_Sum_Order_By>;
  var_pop?: InputMaybe<Transition_Access_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transition_Access_Var_Samp_Order_By>;
  variance?: InputMaybe<Transition_Access_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transition_access" */
export type Transition_Access_Arr_Rel_Insert_Input = {
  data: Array<Transition_Access_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transition_Access_On_Conflict>;
};

/** aggregate avg on columns */
export type Transition_Access_Avg_Fields = {
  __typename?: 'transition_access_avg_fields';
  allowed_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transition_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transition_access" */
export type Transition_Access_Avg_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transition_access". All fields are combined with a logical 'AND'. */
export type Transition_Access_Bool_Exp = {
  _and?: InputMaybe<Array<Transition_Access_Bool_Exp>>;
  _not?: InputMaybe<Transition_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Transition_Access_Bool_Exp>>;
  allowed_group?: InputMaybe<External_Entity_Bool_Exp>;
  allowed_group_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  transition?: InputMaybe<Transition_Bool_Exp>;
  transition_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "transition_access" */
export enum Transition_Access_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransitionAccessPkey = 'transition_access_pkey',
  /** unique or primary key constraint on columns "allowed_group_id", "transition_id" */
  TransitionAccessTransitionIdAllowedGroupId_9f4e4079Uniq = 'transition_access_transition_id_allowed_group_id_9f4e4079_uniq'
}

/** input type for incrementing numeric columns in table "transition_access" */
export type Transition_Access_Inc_Input = {
  allowed_group_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  transition_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "transition_access" */
export type Transition_Access_Insert_Input = {
  allowed_group?: InputMaybe<External_Entity_Obj_Rel_Insert_Input>;
  allowed_group_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  transition?: InputMaybe<Transition_Obj_Rel_Insert_Input>;
  transition_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Transition_Access_Max_Fields = {
  __typename?: 'transition_access_max_fields';
  allowed_group_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  transition_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "transition_access" */
export type Transition_Access_Max_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transition_Access_Min_Fields = {
  __typename?: 'transition_access_min_fields';
  allowed_group_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  transition_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "transition_access" */
export type Transition_Access_Min_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transition_access" */
export type Transition_Access_Mutation_Response = {
  __typename?: 'transition_access_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transition_Access>;
};

/** on_conflict condition type for table "transition_access" */
export type Transition_Access_On_Conflict = {
  constraint: Transition_Access_Constraint;
  update_columns?: Array<Transition_Access_Update_Column>;
  where?: InputMaybe<Transition_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "transition_access". */
export type Transition_Access_Order_By = {
  allowed_group?: InputMaybe<External_Entity_Order_By>;
  allowed_group_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition?: InputMaybe<Transition_Order_By>;
  transition_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transition_access */
export type Transition_Access_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "transition_access" */
export enum Transition_Access_Select_Column {
  /** column name */
  AllowedGroupId = 'allowed_group_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransitionId = 'transition_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "transition_access" */
export type Transition_Access_Set_Input = {
  allowed_group_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  transition_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Transition_Access_Stddev_Fields = {
  __typename?: 'transition_access_stddev_fields';
  allowed_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transition_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transition_access" */
export type Transition_Access_Stddev_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transition_Access_Stddev_Pop_Fields = {
  __typename?: 'transition_access_stddev_pop_fields';
  allowed_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transition_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transition_access" */
export type Transition_Access_Stddev_Pop_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transition_Access_Stddev_Samp_Fields = {
  __typename?: 'transition_access_stddev_samp_fields';
  allowed_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transition_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transition_access" */
export type Transition_Access_Stddev_Samp_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transition_access" */
export type Transition_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transition_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transition_Access_Stream_Cursor_Value_Input = {
  allowed_group_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  transition_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Transition_Access_Sum_Fields = {
  __typename?: 'transition_access_sum_fields';
  allowed_group_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  transition_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "transition_access" */
export type Transition_Access_Sum_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** update columns of table "transition_access" */
export enum Transition_Access_Update_Column {
  /** column name */
  AllowedGroupId = 'allowed_group_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransitionId = 'transition_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Transition_Access_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transition_Access_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transition_Access_Set_Input>;
  where: Transition_Access_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transition_Access_Var_Pop_Fields = {
  __typename?: 'transition_access_var_pop_fields';
  allowed_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transition_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transition_access" */
export type Transition_Access_Var_Pop_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transition_Access_Var_Samp_Fields = {
  __typename?: 'transition_access_var_samp_fields';
  allowed_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transition_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transition_access" */
export type Transition_Access_Var_Samp_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transition_Access_Variance_Fields = {
  __typename?: 'transition_access_variance_fields';
  allowed_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  transition_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transition_access" */
export type Transition_Access_Variance_Order_By = {
  allowed_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transition_id?: InputMaybe<Order_By>;
};

/** aggregated selection of "transition" */
export type Transition_Aggregate = {
  __typename?: 'transition_aggregate';
  aggregate?: Maybe<Transition_Aggregate_Fields>;
  nodes: Array<Transition>;
};

/** aggregate fields of "transition" */
export type Transition_Aggregate_Fields = {
  __typename?: 'transition_aggregate_fields';
  avg?: Maybe<Transition_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transition_Max_Fields>;
  min?: Maybe<Transition_Min_Fields>;
  stddev?: Maybe<Transition_Stddev_Fields>;
  stddev_pop?: Maybe<Transition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transition_Stddev_Samp_Fields>;
  sum?: Maybe<Transition_Sum_Fields>;
  var_pop?: Maybe<Transition_Var_Pop_Fields>;
  var_samp?: Maybe<Transition_Var_Samp_Fields>;
  variance?: Maybe<Transition_Variance_Fields>;
};


/** aggregate fields of "transition" */
export type Transition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transition" */
export type Transition_Aggregate_Order_By = {
  avg?: InputMaybe<Transition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transition_Max_Order_By>;
  min?: InputMaybe<Transition_Min_Order_By>;
  stddev?: InputMaybe<Transition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transition_Sum_Order_By>;
  var_pop?: InputMaybe<Transition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transition_Var_Samp_Order_By>;
  variance?: InputMaybe<Transition_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transition_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "transition" */
export type Transition_Arr_Rel_Insert_Input = {
  data: Array<Transition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transition_On_Conflict>;
};

/** aggregate avg on columns */
export type Transition_Avg_Fields = {
  __typename?: 'transition_avg_fields';
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transition" */
export type Transition_Avg_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transition". All fields are combined with a logical 'AND'. */
export type Transition_Bool_Exp = {
  _and?: InputMaybe<Array<Transition_Bool_Exp>>;
  _not?: InputMaybe<Transition_Bool_Exp>;
  _or?: InputMaybe<Array<Transition_Bool_Exp>>;
  alert?: InputMaybe<Boolean_Comparison_Exp>;
  allowed_groups?: InputMaybe<Transition_Access_Bool_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  from_state?: InputMaybe<State_Bool_Exp>;
  from_state_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  sequence?: InputMaybe<String_Comparison_Exp>;
  to_state?: InputMaybe<State_Bool_Exp>;
  to_state_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  workflow?: InputMaybe<Workflow_Bool_Exp>;
  workflow_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "transition" */
export enum Transition_Constraint {
  /** unique or primary key constraint on columns "codename" */
  TransitionCodenameKey = 'transition_codename_key',
  /** unique or primary key constraint on columns "id" */
  TransitionPkey = 'transition_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transition_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transition_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transition_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "transition_history" */
export type Transition_History = {
  __typename?: 'transition_history';
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by: Array<Base_User>;
  created_by_id: Scalars['String'];
  device_details: Scalars['jsonb'];
  /** An object relationship */
  from_state?: Maybe<State>;
  from_state_id?: Maybe<Scalars['bigint']>;
  id: Scalars['bigint'];
  object_id: Scalars['Int'];
  /** An object relationship */
  to_state: State;
  to_state_id: Scalars['bigint'];
  /** An array relationship */
  transition_history_attributes: Array<Transition_History_Attribute>;
  /** An aggregate relationship */
  transition_history_attributes_aggregate: Transition_History_Attribute_Aggregate;
  transition_log: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
  user_log: Scalars['jsonb'];
  /** An object relationship */
  workflow: Workflow;
  workflow_id: Scalars['bigint'];
};


/** columns and relationships of "transition_history" */
export type Transition_HistoryCreated_ByArgs = {
  distinct_on?: InputMaybe<Array<Base_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_User_Order_By>>;
  where?: InputMaybe<Base_User_Bool_Exp_Remote_Rel_Transition_Historycreated_By>;
};


/** columns and relationships of "transition_history" */
export type Transition_HistoryDevice_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "transition_history" */
export type Transition_HistoryTransition_History_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Attribute_Order_By>>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};


/** columns and relationships of "transition_history" */
export type Transition_HistoryTransition_History_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Attribute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Attribute_Order_By>>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};


/** columns and relationships of "transition_history" */
export type Transition_HistoryTransition_LogArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "transition_history" */
export type Transition_HistoryUser_LogArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "transition_history" */
export type Transition_History_Aggregate = {
  __typename?: 'transition_history_aggregate';
  aggregate?: Maybe<Transition_History_Aggregate_Fields>;
  nodes: Array<Transition_History>;
};

/** aggregate fields of "transition_history" */
export type Transition_History_Aggregate_Fields = {
  __typename?: 'transition_history_aggregate_fields';
  avg?: Maybe<Transition_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transition_History_Max_Fields>;
  min?: Maybe<Transition_History_Min_Fields>;
  stddev?: Maybe<Transition_History_Stddev_Fields>;
  stddev_pop?: Maybe<Transition_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transition_History_Stddev_Samp_Fields>;
  sum?: Maybe<Transition_History_Sum_Fields>;
  var_pop?: Maybe<Transition_History_Var_Pop_Fields>;
  var_samp?: Maybe<Transition_History_Var_Samp_Fields>;
  variance?: Maybe<Transition_History_Variance_Fields>;
};


/** aggregate fields of "transition_history" */
export type Transition_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transition_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transition_history" */
export type Transition_History_Aggregate_Order_By = {
  avg?: InputMaybe<Transition_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transition_History_Max_Order_By>;
  min?: InputMaybe<Transition_History_Min_Order_By>;
  stddev?: InputMaybe<Transition_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transition_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transition_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transition_History_Sum_Order_By>;
  var_pop?: InputMaybe<Transition_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transition_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Transition_History_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transition_History_Append_Input = {
  device_details?: InputMaybe<Scalars['jsonb']>;
  transition_log?: InputMaybe<Scalars['jsonb']>;
  user_log?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "transition_history" */
export type Transition_History_Arr_Rel_Insert_Input = {
  data: Array<Transition_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transition_History_On_Conflict>;
};

/** columns and relationships of "transition_history_attribute" */
export type Transition_History_Attribute = {
  __typename?: 'transition_history_attribute';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  name: Scalars['String'];
  /** An object relationship */
  transition_history: Transition_History;
  transition_history_id: Scalars['bigint'];
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['String']>;
  value_kind: Scalars['String'];
};

/** aggregated selection of "transition_history_attribute" */
export type Transition_History_Attribute_Aggregate = {
  __typename?: 'transition_history_attribute_aggregate';
  aggregate?: Maybe<Transition_History_Attribute_Aggregate_Fields>;
  nodes: Array<Transition_History_Attribute>;
};

/** aggregate fields of "transition_history_attribute" */
export type Transition_History_Attribute_Aggregate_Fields = {
  __typename?: 'transition_history_attribute_aggregate_fields';
  avg?: Maybe<Transition_History_Attribute_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Transition_History_Attribute_Max_Fields>;
  min?: Maybe<Transition_History_Attribute_Min_Fields>;
  stddev?: Maybe<Transition_History_Attribute_Stddev_Fields>;
  stddev_pop?: Maybe<Transition_History_Attribute_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transition_History_Attribute_Stddev_Samp_Fields>;
  sum?: Maybe<Transition_History_Attribute_Sum_Fields>;
  var_pop?: Maybe<Transition_History_Attribute_Var_Pop_Fields>;
  var_samp?: Maybe<Transition_History_Attribute_Var_Samp_Fields>;
  variance?: Maybe<Transition_History_Attribute_Variance_Fields>;
};


/** aggregate fields of "transition_history_attribute" */
export type Transition_History_Attribute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transition_History_Attribute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "transition_history_attribute" */
export type Transition_History_Attribute_Aggregate_Order_By = {
  avg?: InputMaybe<Transition_History_Attribute_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transition_History_Attribute_Max_Order_By>;
  min?: InputMaybe<Transition_History_Attribute_Min_Order_By>;
  stddev?: InputMaybe<Transition_History_Attribute_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transition_History_Attribute_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transition_History_Attribute_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transition_History_Attribute_Sum_Order_By>;
  var_pop?: InputMaybe<Transition_History_Attribute_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transition_History_Attribute_Var_Samp_Order_By>;
  variance?: InputMaybe<Transition_History_Attribute_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "transition_history_attribute" */
export type Transition_History_Attribute_Arr_Rel_Insert_Input = {
  data: Array<Transition_History_Attribute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transition_History_Attribute_On_Conflict>;
};

/** aggregate avg on columns */
export type Transition_History_Attribute_Avg_Fields = {
  __typename?: 'transition_history_attribute_avg_fields';
  id?: Maybe<Scalars['Float']>;
  transition_history_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transition_history_attribute". All fields are combined with a logical 'AND'. */
export type Transition_History_Attribute_Bool_Exp = {
  _and?: InputMaybe<Array<Transition_History_Attribute_Bool_Exp>>;
  _not?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
  _or?: InputMaybe<Array<Transition_History_Attribute_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  transition_history?: InputMaybe<Transition_History_Bool_Exp>;
  transition_history_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  value_kind?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "transition_history_attribute" */
export enum Transition_History_Attribute_Constraint {
  /** unique or primary key constraint on columns "name", "transition_history_id" */
  TransitionHistoryAttriTransitionHistoryIdNa_4970358eUniq = 'transition_history_attri_transition_history_id_na_4970358e_uniq',
  /** unique or primary key constraint on columns "id" */
  TransitionHistoryAttributePkey = 'transition_history_attribute_pkey'
}

/** input type for incrementing numeric columns in table "transition_history_attribute" */
export type Transition_History_Attribute_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  transition_history_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "transition_history_attribute" */
export type Transition_History_Attribute_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  transition_history?: InputMaybe<Transition_History_Obj_Rel_Insert_Input>;
  transition_history_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
  value_kind?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Transition_History_Attribute_Max_Fields = {
  __typename?: 'transition_history_attribute_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  transition_history_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
  value_kind?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_kind?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transition_History_Attribute_Min_Fields = {
  __typename?: 'transition_history_attribute_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  transition_history_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
  value_kind?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_kind?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transition_history_attribute" */
export type Transition_History_Attribute_Mutation_Response = {
  __typename?: 'transition_history_attribute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transition_History_Attribute>;
};

/** on_conflict condition type for table "transition_history_attribute" */
export type Transition_History_Attribute_On_Conflict = {
  constraint: Transition_History_Attribute_Constraint;
  update_columns?: Array<Transition_History_Attribute_Update_Column>;
  where?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
};

/** Ordering options when selecting data from "transition_history_attribute". */
export type Transition_History_Attribute_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  transition_history?: InputMaybe<Transition_History_Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_kind?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transition_history_attribute */
export type Transition_History_Attribute_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "transition_history_attribute" */
export enum Transition_History_Attribute_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TransitionHistoryId = 'transition_history_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueKind = 'value_kind'
}

/** input type for updating data in table "transition_history_attribute" */
export type Transition_History_Attribute_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  transition_history_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
  value_kind?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Transition_History_Attribute_Stddev_Fields = {
  __typename?: 'transition_history_attribute_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  transition_history_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transition_History_Attribute_Stddev_Pop_Fields = {
  __typename?: 'transition_history_attribute_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  transition_history_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transition_History_Attribute_Stddev_Samp_Fields = {
  __typename?: 'transition_history_attribute_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  transition_history_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transition_history_attribute" */
export type Transition_History_Attribute_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transition_History_Attribute_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transition_History_Attribute_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  transition_history_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
  value_kind?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Transition_History_Attribute_Sum_Fields = {
  __typename?: 'transition_history_attribute_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  transition_history_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** update columns of table "transition_history_attribute" */
export enum Transition_History_Attribute_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TransitionHistoryId = 'transition_history_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value',
  /** column name */
  ValueKind = 'value_kind'
}

export type Transition_History_Attribute_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transition_History_Attribute_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transition_History_Attribute_Set_Input>;
  where: Transition_History_Attribute_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transition_History_Attribute_Var_Pop_Fields = {
  __typename?: 'transition_history_attribute_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  transition_history_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transition_History_Attribute_Var_Samp_Fields = {
  __typename?: 'transition_history_attribute_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  transition_history_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transition_History_Attribute_Variance_Fields = {
  __typename?: 'transition_history_attribute_variance_fields';
  id?: Maybe<Scalars['Float']>;
  transition_history_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transition_history_attribute" */
export type Transition_History_Attribute_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  transition_history_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Transition_History_Avg_Fields = {
  __typename?: 'transition_history_avg_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "transition_history" */
export type Transition_History_Avg_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transition_history". All fields are combined with a logical 'AND'. */
export type Transition_History_Bool_Exp = {
  _and?: InputMaybe<Array<Transition_History_Bool_Exp>>;
  _not?: InputMaybe<Transition_History_Bool_Exp>;
  _or?: InputMaybe<Array<Transition_History_Bool_Exp>>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  device_details?: InputMaybe<Jsonb_Comparison_Exp>;
  from_state?: InputMaybe<State_Bool_Exp>;
  from_state_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  object_id?: InputMaybe<Int_Comparison_Exp>;
  to_state?: InputMaybe<State_Bool_Exp>;
  to_state_id?: InputMaybe<Bigint_Comparison_Exp>;
  transition_history_attributes?: InputMaybe<Transition_History_Attribute_Bool_Exp>;
  transition_log?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
  user_log?: InputMaybe<Jsonb_Comparison_Exp>;
  workflow?: InputMaybe<Workflow_Bool_Exp>;
  workflow_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "transition_history" */
export enum Transition_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransitionHistoryPkey = 'transition_history_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transition_History_Delete_At_Path_Input = {
  device_details?: InputMaybe<Array<Scalars['String']>>;
  transition_log?: InputMaybe<Array<Scalars['String']>>;
  user_log?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transition_History_Delete_Elem_Input = {
  device_details?: InputMaybe<Scalars['Int']>;
  transition_log?: InputMaybe<Scalars['Int']>;
  user_log?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transition_History_Delete_Key_Input = {
  device_details?: InputMaybe<Scalars['String']>;
  transition_log?: InputMaybe<Scalars['String']>;
  user_log?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "transition_history" */
export type Transition_History_Inc_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "transition_history" */
export type Transition_History_Insert_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  device_details?: InputMaybe<Scalars['jsonb']>;
  from_state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  to_state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  transition_history_attributes?: InputMaybe<Transition_History_Attribute_Arr_Rel_Insert_Input>;
  transition_log?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_log?: InputMaybe<Scalars['jsonb']>;
  workflow?: InputMaybe<Workflow_Obj_Rel_Insert_Input>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Transition_History_Max_Fields = {
  __typename?: 'transition_history_max_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  from_state_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  object_id?: Maybe<Scalars['Int']>;
  to_state_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "transition_history" */
export type Transition_History_Max_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transition_History_Min_Fields = {
  __typename?: 'transition_history_min_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  from_state_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  object_id?: Maybe<Scalars['Int']>;
  to_state_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "transition_history" */
export type Transition_History_Min_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transition_history" */
export type Transition_History_Mutation_Response = {
  __typename?: 'transition_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transition_History>;
};

/** input type for inserting object relation for remote table "transition_history" */
export type Transition_History_Obj_Rel_Insert_Input = {
  data: Transition_History_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transition_History_On_Conflict>;
};

/** on_conflict condition type for table "transition_history" */
export type Transition_History_On_Conflict = {
  constraint: Transition_History_Constraint;
  update_columns?: Array<Transition_History_Update_Column>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};

/** Ordering options when selecting data from "transition_history". */
export type Transition_History_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  device_details?: InputMaybe<Order_By>;
  from_state?: InputMaybe<State_Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state?: InputMaybe<State_Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  transition_history_attributes_aggregate?: InputMaybe<Transition_History_Attribute_Aggregate_Order_By>;
  transition_log?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_log?: InputMaybe<Order_By>;
  workflow?: InputMaybe<Workflow_Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transition_history */
export type Transition_History_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transition_History_Prepend_Input = {
  device_details?: InputMaybe<Scalars['jsonb']>;
  transition_log?: InputMaybe<Scalars['jsonb']>;
  user_log?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "transition_history" */
export enum Transition_History_Select_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeviceDetails = 'device_details',
  /** column name */
  FromStateId = 'from_state_id',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  ToStateId = 'to_state_id',
  /** column name */
  TransitionLog = 'transition_log',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserLog = 'user_log',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "transition_history" */
export type Transition_History_Set_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  device_details?: InputMaybe<Scalars['jsonb']>;
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  transition_log?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_log?: InputMaybe<Scalars['jsonb']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Transition_History_Stddev_Fields = {
  __typename?: 'transition_history_stddev_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transition_history" */
export type Transition_History_Stddev_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transition_History_Stddev_Pop_Fields = {
  __typename?: 'transition_history_stddev_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transition_history" */
export type Transition_History_Stddev_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transition_History_Stddev_Samp_Fields = {
  __typename?: 'transition_history_stddev_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transition_history" */
export type Transition_History_Stddev_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transition_history" */
export type Transition_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transition_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transition_History_Stream_Cursor_Value_Input = {
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  device_details?: InputMaybe<Scalars['jsonb']>;
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  object_id?: InputMaybe<Scalars['Int']>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  transition_log?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  user_log?: InputMaybe<Scalars['jsonb']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Transition_History_Sum_Fields = {
  __typename?: 'transition_history_sum_fields';
  content_type_id?: Maybe<Scalars['Int']>;
  from_state_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  object_id?: Maybe<Scalars['Int']>;
  to_state_id?: Maybe<Scalars['bigint']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "transition_history" */
export type Transition_History_Sum_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** update columns of table "transition_history" */
export enum Transition_History_Update_Column {
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeviceDetails = 'device_details',
  /** column name */
  FromStateId = 'from_state_id',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  ToStateId = 'to_state_id',
  /** column name */
  TransitionLog = 'transition_log',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserLog = 'user_log',
  /** column name */
  WorkflowId = 'workflow_id'
}

export type Transition_History_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transition_History_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transition_History_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transition_History_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transition_History_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transition_History_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transition_History_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transition_History_Set_Input>;
  where: Transition_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transition_History_Var_Pop_Fields = {
  __typename?: 'transition_history_var_pop_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transition_history" */
export type Transition_History_Var_Pop_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transition_History_Var_Samp_Fields = {
  __typename?: 'transition_history_var_samp_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transition_history" */
export type Transition_History_Var_Samp_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transition_History_Variance_Fields = {
  __typename?: 'transition_history_variance_fields';
  content_type_id?: Maybe<Scalars['Float']>;
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  object_id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transition_history" */
export type Transition_History_Variance_Order_By = {
  content_type_id?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "transition" */
export type Transition_Inc_Input = {
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "transition" */
export type Transition_Insert_Input = {
  alert?: InputMaybe<Scalars['Boolean']>;
  allowed_groups?: InputMaybe<Transition_Access_Arr_Rel_Insert_Input>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  from_state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  sequence?: InputMaybe<Scalars['String']>;
  to_state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  workflow?: InputMaybe<Workflow_Obj_Rel_Insert_Input>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Transition_Max_Fields = {
  __typename?: 'transition_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  from_state_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  to_state_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "transition" */
export type Transition_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transition_Min_Fields = {
  __typename?: 'transition_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  from_state_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['String']>;
  to_state_id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "transition" */
export type Transition_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transition" */
export type Transition_Mutation_Response = {
  __typename?: 'transition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Transition>;
};

/** input type for inserting object relation for remote table "transition" */
export type Transition_Obj_Rel_Insert_Input = {
  data: Transition_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transition_On_Conflict>;
};

/** on_conflict condition type for table "transition" */
export type Transition_On_Conflict = {
  constraint: Transition_Constraint;
  update_columns?: Array<Transition_Update_Column>;
  where?: InputMaybe<Transition_Bool_Exp>;
};

/** Ordering options when selecting data from "transition". */
export type Transition_Order_By = {
  alert?: InputMaybe<Order_By>;
  allowed_groups_aggregate?: InputMaybe<Transition_Access_Aggregate_Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  from_state?: InputMaybe<State_Order_By>;
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  to_state?: InputMaybe<State_Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  workflow?: InputMaybe<Workflow_Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transition */
export type Transition_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transition_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "transition" */
export enum Transition_Select_Column {
  /** column name */
  Alert = 'alert',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FromStateId = 'from_state_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  ToStateId = 'to_state_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "transition" */
export type Transition_Set_Input = {
  alert?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  sequence?: InputMaybe<Scalars['String']>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Transition_Stddev_Fields = {
  __typename?: 'transition_stddev_fields';
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "transition" */
export type Transition_Stddev_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transition_Stddev_Pop_Fields = {
  __typename?: 'transition_stddev_pop_fields';
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "transition" */
export type Transition_Stddev_Pop_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transition_Stddev_Samp_Fields = {
  __typename?: 'transition_stddev_samp_fields';
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "transition" */
export type Transition_Stddev_Samp_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transition" */
export type Transition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transition_Stream_Cursor_Value_Input = {
  alert?: InputMaybe<Scalars['Boolean']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  from_state_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  sequence?: InputMaybe<Scalars['String']>;
  to_state_id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
  workflow_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Transition_Sum_Fields = {
  __typename?: 'transition_sum_fields';
  from_state_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  to_state_id?: Maybe<Scalars['bigint']>;
  workflow_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "transition" */
export type Transition_Sum_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** update columns of table "transition" */
export enum Transition_Update_Column {
  /** column name */
  Alert = 'alert',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FromStateId = 'from_state_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  ToStateId = 'to_state_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkflowId = 'workflow_id'
}

export type Transition_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transition_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transition_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transition_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transition_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Transition_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transition_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transition_Set_Input>;
  where: Transition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Transition_Var_Pop_Fields = {
  __typename?: 'transition_var_pop_fields';
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "transition" */
export type Transition_Var_Pop_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transition_Var_Samp_Fields = {
  __typename?: 'transition_var_samp_fields';
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "transition" */
export type Transition_Var_Samp_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transition_Variance_Fields = {
  __typename?: 'transition_variance_fields';
  from_state_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  to_state_id?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "transition" */
export type Transition_Variance_Order_By = {
  from_state_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  to_state_id?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "unit" */
export type Unit = {
  __typename?: 'unit';
  base_conversion: Scalars['numeric'];
  base_unit_id?: Maybe<Scalars['bigint']>;
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  measure_of?: Maybe<Unit_Measure>;
  measure_of_id?: Maybe<Scalars['bigint']>;
  name: Scalars['String'];
};

/** aggregated selection of "unit" */
export type Unit_Aggregate = {
  __typename?: 'unit_aggregate';
  aggregate?: Maybe<Unit_Aggregate_Fields>;
  nodes: Array<Unit>;
};

/** aggregate fields of "unit" */
export type Unit_Aggregate_Fields = {
  __typename?: 'unit_aggregate_fields';
  avg?: Maybe<Unit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unit_Max_Fields>;
  min?: Maybe<Unit_Min_Fields>;
  stddev?: Maybe<Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Sum_Fields>;
  var_pop?: Maybe<Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Var_Samp_Fields>;
  variance?: Maybe<Unit_Variance_Fields>;
};


/** aggregate fields of "unit" */
export type Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Unit_Avg_Fields = {
  __typename?: 'unit_avg_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "unit". All fields are combined with a logical 'AND'. */
export type Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Bool_Exp>>;
  _not?: InputMaybe<Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Bool_Exp>>;
  base_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  base_unit_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  measure_of?: InputMaybe<Unit_Measure_Bool_Exp>;
  measure_of_id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit" */
export enum Unit_Constraint {
  /** unique or primary key constraint on columns "codename" */
  UnitCodenameKey = 'unit_codename_key',
  /** unique or primary key constraint on columns "id" */
  UnitPkey = 'unit_pkey'
}

/** input type for incrementing numeric columns in table "unit" */
export type Unit_Inc_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  measure_of_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "unit" */
export type Unit_Insert_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of?: InputMaybe<Unit_Measure_Obj_Rel_Insert_Input>;
  measure_of_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Unit_Max_Fields = {
  __typename?: 'unit_max_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  measure_of_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** columns and relationships of "unit_measure" */
export type Unit_Measure = {
  __typename?: 'unit_measure';
  codename: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
};

/** aggregated selection of "unit_measure" */
export type Unit_Measure_Aggregate = {
  __typename?: 'unit_measure_aggregate';
  aggregate?: Maybe<Unit_Measure_Aggregate_Fields>;
  nodes: Array<Unit_Measure>;
};

/** aggregate fields of "unit_measure" */
export type Unit_Measure_Aggregate_Fields = {
  __typename?: 'unit_measure_aggregate_fields';
  avg?: Maybe<Unit_Measure_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unit_Measure_Max_Fields>;
  min?: Maybe<Unit_Measure_Min_Fields>;
  stddev?: Maybe<Unit_Measure_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Measure_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Measure_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Measure_Sum_Fields>;
  var_pop?: Maybe<Unit_Measure_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Measure_Var_Samp_Fields>;
  variance?: Maybe<Unit_Measure_Variance_Fields>;
};


/** aggregate fields of "unit_measure" */
export type Unit_Measure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Measure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Unit_Measure_Avg_Fields = {
  __typename?: 'unit_measure_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "unit_measure". All fields are combined with a logical 'AND'. */
export type Unit_Measure_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Measure_Bool_Exp>>;
  _not?: InputMaybe<Unit_Measure_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Measure_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit_measure" */
export enum Unit_Measure_Constraint {
  /** unique or primary key constraint on columns "codename" */
  UnitMeasureCodenameKey = 'unit_measure_codename_key',
  /** unique or primary key constraint on columns "id" */
  UnitMeasurePkey = 'unit_measure_pkey'
}

/** input type for incrementing numeric columns in table "unit_measure" */
export type Unit_Measure_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "unit_measure" */
export type Unit_Measure_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Unit_Measure_Max_Fields = {
  __typename?: 'unit_measure_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Unit_Measure_Min_Fields = {
  __typename?: 'unit_measure_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "unit_measure" */
export type Unit_Measure_Mutation_Response = {
  __typename?: 'unit_measure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit_Measure>;
};

/** input type for inserting object relation for remote table "unit_measure" */
export type Unit_Measure_Obj_Rel_Insert_Input = {
  data: Unit_Measure_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_Measure_On_Conflict>;
};

/** on_conflict condition type for table "unit_measure" */
export type Unit_Measure_On_Conflict = {
  constraint: Unit_Measure_Constraint;
  update_columns?: Array<Unit_Measure_Update_Column>;
  where?: InputMaybe<Unit_Measure_Bool_Exp>;
};

/** Ordering options when selecting data from "unit_measure". */
export type Unit_Measure_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit_measure */
export type Unit_Measure_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "unit_measure" */
export enum Unit_Measure_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "unit_measure" */
export type Unit_Measure_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Unit_Measure_Stddev_Fields = {
  __typename?: 'unit_measure_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Unit_Measure_Stddev_Pop_Fields = {
  __typename?: 'unit_measure_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Unit_Measure_Stddev_Samp_Fields = {
  __typename?: 'unit_measure_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "unit_measure" */
export type Unit_Measure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Measure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Measure_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Unit_Measure_Sum_Fields = {
  __typename?: 'unit_measure_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "unit_measure" */
export enum Unit_Measure_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name'
}

export type Unit_Measure_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unit_Measure_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Measure_Set_Input>;
  where: Unit_Measure_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unit_Measure_Var_Pop_Fields = {
  __typename?: 'unit_measure_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Unit_Measure_Var_Samp_Fields = {
  __typename?: 'unit_measure_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Unit_Measure_Variance_Fields = {
  __typename?: 'unit_measure_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Unit_Min_Fields = {
  __typename?: 'unit_min_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  measure_of_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "unit" */
export type Unit_Mutation_Response = {
  __typename?: 'unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit>;
};

/** input type for inserting object relation for remote table "unit" */
export type Unit_Obj_Rel_Insert_Input = {
  data: Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** on_conflict condition type for table "unit" */
export type Unit_On_Conflict = {
  constraint: Unit_Constraint;
  update_columns?: Array<Unit_Update_Column>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "unit". */
export type Unit_Order_By = {
  base_conversion?: InputMaybe<Order_By>;
  base_unit_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  measure_of?: InputMaybe<Unit_Measure_Order_By>;
  measure_of_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit */
export type Unit_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "unit" */
export enum Unit_Select_Column {
  /** column name */
  BaseConversion = 'base_conversion',
  /** column name */
  BaseUnitId = 'base_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "unit" */
export type Unit_Set_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Unit_Stddev_Fields = {
  __typename?: 'unit_stddev_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Unit_Stddev_Pop_Fields = {
  __typename?: 'unit_stddev_pop_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Unit_Stddev_Samp_Fields = {
  __typename?: 'unit_stddev_samp_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "unit" */
export type Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Stream_Cursor_Value_Input = {
  base_conversion?: InputMaybe<Scalars['numeric']>;
  base_unit_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  measure_of_id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Unit_Sum_Fields = {
  __typename?: 'unit_sum_fields';
  base_conversion?: Maybe<Scalars['numeric']>;
  base_unit_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  measure_of_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "unit" */
export enum Unit_Update_Column {
  /** column name */
  BaseConversion = 'base_conversion',
  /** column name */
  BaseUnitId = 'base_unit_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeasureOfId = 'measure_of_id',
  /** column name */
  Name = 'name'
}

export type Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Set_Input>;
  where: Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unit_Var_Pop_Fields = {
  __typename?: 'unit_var_pop_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Unit_Var_Samp_Fields = {
  __typename?: 'unit_var_samp_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Unit_Variance_Fields = {
  __typename?: 'unit_variance_fields';
  base_conversion?: Maybe<Scalars['Float']>;
  base_unit_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  measure_of_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "unregistered_user" */
export type Unregistered_User = {
  __typename?: 'unregistered_user';
  created_at: Scalars['timestamptz'];
  first_name: Scalars['String'];
  id: Scalars['bigint'];
  last_name?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Setu_Trade_Shared_Entity>;
  user_entity_id?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "unregistered_user" */
export type Unregistered_User_Aggregate = {
  __typename?: 'unregistered_user_aggregate';
  aggregate?: Maybe<Unregistered_User_Aggregate_Fields>;
  nodes: Array<Unregistered_User>;
};

/** aggregate fields of "unregistered_user" */
export type Unregistered_User_Aggregate_Fields = {
  __typename?: 'unregistered_user_aggregate_fields';
  avg?: Maybe<Unregistered_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unregistered_User_Max_Fields>;
  min?: Maybe<Unregistered_User_Min_Fields>;
  stddev?: Maybe<Unregistered_User_Stddev_Fields>;
  stddev_pop?: Maybe<Unregistered_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unregistered_User_Stddev_Samp_Fields>;
  sum?: Maybe<Unregistered_User_Sum_Fields>;
  var_pop?: Maybe<Unregistered_User_Var_Pop_Fields>;
  var_samp?: Maybe<Unregistered_User_Var_Samp_Fields>;
  variance?: Maybe<Unregistered_User_Variance_Fields>;
};


/** aggregate fields of "unregistered_user" */
export type Unregistered_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unregistered_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Unregistered_User_Avg_Fields = {
  __typename?: 'unregistered_user_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_entity_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "unregistered_user". All fields are combined with a logical 'AND'. */
export type Unregistered_User_Bool_Exp = {
  _and?: InputMaybe<Array<Unregistered_User_Bool_Exp>>;
  _not?: InputMaybe<Unregistered_User_Bool_Exp>;
  _or?: InputMaybe<Array<Unregistered_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
  user_entity_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "unregistered_user" */
export type Unregistered_User_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  user_entity_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Unregistered_User_Max_Fields = {
  __typename?: 'unregistered_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_entity_id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Unregistered_User_Min_Fields = {
  __typename?: 'unregistered_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  last_name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_entity_id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "unregistered_user" */
export type Unregistered_User_Mutation_Response = {
  __typename?: 'unregistered_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unregistered_User>;
};

/** Ordering options when selecting data from "unregistered_user". */
export type Unregistered_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Setu_Trade_Shared_Entity_Order_By>;
  user_entity_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unregistered_user */
export type Unregistered_User_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "unregistered_user" */
export enum Unregistered_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Number = 'number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEntityId = 'user_entity_id'
}

/** input type for updating data in table "unregistered_user" */
export type Unregistered_User_Set_Input = {
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  user_entity_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Unregistered_User_Stddev_Fields = {
  __typename?: 'unregistered_user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_entity_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Unregistered_User_Stddev_Pop_Fields = {
  __typename?: 'unregistered_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_entity_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Unregistered_User_Stddev_Samp_Fields = {
  __typename?: 'unregistered_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_entity_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "unregistered_user" */
export type Unregistered_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unregistered_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unregistered_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_entity_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Unregistered_User_Sum_Fields = {
  __typename?: 'unregistered_user_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  user_entity_id?: Maybe<Scalars['bigint']>;
};

export type Unregistered_User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unregistered_User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unregistered_User_Set_Input>;
  where: Unregistered_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unregistered_User_Var_Pop_Fields = {
  __typename?: 'unregistered_user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_entity_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Unregistered_User_Var_Samp_Fields = {
  __typename?: 'unregistered_user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_entity_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Unregistered_User_Variance_Fields = {
  __typename?: 'unregistered_user_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_entity_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "variety_agreement" */
export type Variety_Agreement = {
  __typename?: 'variety_agreement';
  /** An array relationship */
  agreement_co_owners: Array<Variety_Agreement_Agreement_Co_Owners>;
  /** An aggregate relationship */
  agreement_co_owners_aggregate: Variety_Agreement_Agreement_Co_Owners_Aggregate;
  agreement_id?: Maybe<Scalars['Int']>;
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  current_logs: Array<Workflow_Current_Logs>;
  /** An aggregate relationship */
  current_logs_aggregate: Workflow_Current_Logs_Aggregate;
  /** An object relationship */
  farmer: Base_User;
  farmer_id: Scalars['Int'];
  /** An array relationship */
  guarantor_agreements: Array<Variety_Agreement_Guarantor_Agreements>;
  /** An aggregate relationship */
  guarantor_agreements_aggregate: Variety_Agreement_Guarantor_Agreements_Aggregate;
  id: Scalars['Int'];
  /** An array relationship */
  logs: Array<Stage_Logs>;
  /** An aggregate relationship */
  logs_aggregate: Stage_Logs_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  sent_to_breeder?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementAgreement_Co_OwnersArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementAgreement_Co_Owners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementCurrent_LogsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementCurrent_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementGuarantor_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementGuarantor_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Order_By>>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementLogsArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stage_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stage_Logs_Order_By>>;
  where?: InputMaybe<Stage_Logs_Bool_Exp>;
};


/** columns and relationships of "variety_agreement" */
export type Variety_AgreementMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "variety_agreement" */
export type Variety_Agreement_Aggregate = {
  __typename?: 'variety_agreement_aggregate';
  aggregate?: Maybe<Variety_Agreement_Aggregate_Fields>;
  nodes: Array<Variety_Agreement>;
};

/** aggregate fields of "variety_agreement" */
export type Variety_Agreement_Aggregate_Fields = {
  __typename?: 'variety_agreement_aggregate_fields';
  avg?: Maybe<Variety_Agreement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Agreement_Max_Fields>;
  min?: Maybe<Variety_Agreement_Min_Fields>;
  stddev?: Maybe<Variety_Agreement_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Agreement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Agreement_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Agreement_Sum_Fields>;
  var_pop?: Maybe<Variety_Agreement_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Agreement_Var_Samp_Fields>;
  variance?: Maybe<Variety_Agreement_Variance_Fields>;
};


/** aggregate fields of "variety_agreement" */
export type Variety_Agreement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Agreement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners = {
  __typename?: 'variety_agreement_agreement_co_owners';
  /** An object relationship */
  agreement_co_owner: Agreement_Co_Owner;
  agreementcoowner_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  variety_agreement: Variety_Agreement;
  varietyagreement_id: Scalars['Int'];
};

/** aggregated selection of "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Aggregate = {
  __typename?: 'variety_agreement_agreement_co_owners_aggregate';
  aggregate?: Maybe<Variety_Agreement_Agreement_Co_Owners_Aggregate_Fields>;
  nodes: Array<Variety_Agreement_Agreement_Co_Owners>;
};

/** aggregate fields of "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Aggregate_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_aggregate_fields';
  avg?: Maybe<Variety_Agreement_Agreement_Co_Owners_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Agreement_Agreement_Co_Owners_Max_Fields>;
  min?: Maybe<Variety_Agreement_Agreement_Co_Owners_Min_Fields>;
  stddev?: Maybe<Variety_Agreement_Agreement_Co_Owners_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Agreement_Agreement_Co_Owners_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Agreement_Agreement_Co_Owners_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Agreement_Agreement_Co_Owners_Sum_Fields>;
  var_pop?: Maybe<Variety_Agreement_Agreement_Co_Owners_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Agreement_Agreement_Co_Owners_Var_Samp_Fields>;
  variance?: Maybe<Variety_Agreement_Agreement_Co_Owners_Variance_Fields>;
};


/** aggregate fields of "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Aggregate_Order_By = {
  avg?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Max_Order_By>;
  min?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Min_Order_By>;
  stddev?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Sum_Order_By>;
  var_pop?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Var_Samp_Order_By>;
  variance?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Arr_Rel_Insert_Input = {
  data: Array<Variety_Agreement_Agreement_Co_Owners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_On_Conflict>;
};

/** aggregate avg on columns */
export type Variety_Agreement_Agreement_Co_Owners_Avg_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_avg_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Avg_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variety_agreement_agreement_co_owners". All fields are combined with a logical 'AND'. */
export type Variety_Agreement_Agreement_Co_Owners_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>>;
  _not?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>>;
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Bool_Exp>;
  agreementcoowner_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  variety_agreement?: InputMaybe<Variety_Agreement_Bool_Exp>;
  varietyagreement_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_agreement_agreement_co_owners" */
export enum Variety_Agreement_Agreement_Co_Owners_Constraint {
  /** unique or primary key constraint on columns "agreementcoowner_id", "varietyagreement_id" */
  VarietyAgreementAgreemVarietyagreementIdAgre_6ce289fcUniq = 'variety_agreement_agreem_varietyagreement_id_agre_6ce289fc_uniq',
  /** unique or primary key constraint on columns "id" */
  VarietyAgreementAgreementCoOwnersPkey = 'variety_agreement_agreement_co_owners_pkey'
}

/** input type for incrementing numeric columns in table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Inc_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Insert_Input = {
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Obj_Rel_Insert_Input>;
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  variety_agreement?: InputMaybe<Variety_Agreement_Obj_Rel_Insert_Input>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Variety_Agreement_Agreement_Co_Owners_Max_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_max_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietyagreement_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Max_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variety_Agreement_Agreement_Co_Owners_Min_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_min_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietyagreement_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Min_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Mutation_Response = {
  __typename?: 'variety_agreement_agreement_co_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Agreement_Agreement_Co_Owners>;
};

/** on_conflict condition type for table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_On_Conflict = {
  constraint: Variety_Agreement_Agreement_Co_Owners_Constraint;
  update_columns?: Array<Variety_Agreement_Agreement_Co_Owners_Update_Column>;
  where?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_agreement_agreement_co_owners". */
export type Variety_Agreement_Agreement_Co_Owners_Order_By = {
  agreement_co_owner?: InputMaybe<Agreement_Co_Owner_Order_By>;
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  variety_agreement?: InputMaybe<Variety_Agreement_Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_agreement_agreement_co_owners */
export type Variety_Agreement_Agreement_Co_Owners_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "variety_agreement_agreement_co_owners" */
export enum Variety_Agreement_Agreement_Co_Owners_Select_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietyagreementId = 'varietyagreement_id'
}

/** input type for updating data in table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Set_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Variety_Agreement_Agreement_Co_Owners_Stddev_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_stddev_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Stddev_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variety_Agreement_Agreement_Co_Owners_Stddev_Pop_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_stddev_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Stddev_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variety_Agreement_Agreement_Co_Owners_Stddev_Samp_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_stddev_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Stddev_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Agreement_Agreement_Co_Owners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Agreement_Agreement_Co_Owners_Stream_Cursor_Value_Input = {
  agreementcoowner_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Variety_Agreement_Agreement_Co_Owners_Sum_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_sum_fields';
  agreementcoowner_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietyagreement_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Sum_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** update columns of table "variety_agreement_agreement_co_owners" */
export enum Variety_Agreement_Agreement_Co_Owners_Update_Column {
  /** column name */
  AgreementcoownerId = 'agreementcoowner_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietyagreementId = 'varietyagreement_id'
}

export type Variety_Agreement_Agreement_Co_Owners_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Set_Input>;
  where: Variety_Agreement_Agreement_Co_Owners_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Agreement_Agreement_Co_Owners_Var_Pop_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_var_pop_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Var_Pop_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variety_Agreement_Agreement_Co_Owners_Var_Samp_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_var_samp_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Var_Samp_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variety_Agreement_Agreement_Co_Owners_Variance_Fields = {
  __typename?: 'variety_agreement_agreement_co_owners_variance_fields';
  agreementcoowner_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "variety_agreement_agreement_co_owners" */
export type Variety_Agreement_Agreement_Co_Owners_Variance_Order_By = {
  agreementcoowner_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Variety_Agreement_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Variety_Agreement_Avg_Fields = {
  __typename?: 'variety_agreement_avg_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "variety_agreement". All fields are combined with a logical 'AND'. */
export type Variety_Agreement_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Agreement_Bool_Exp>>;
  _not?: InputMaybe<Variety_Agreement_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Agreement_Bool_Exp>>;
  agreement_co_owners?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Bool_Exp>;
  agreement_id?: InputMaybe<Int_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Int_Comparison_Exp>;
  created_in_id?: InputMaybe<Int_Comparison_Exp>;
  current_logs?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
  farmer?: InputMaybe<Base_User_Bool_Exp>;
  farmer_id?: InputMaybe<Int_Comparison_Exp>;
  guarantor_agreements?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logs?: InputMaybe<Stage_Logs_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  sent_to_breeder?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_agreement" */
export enum Variety_Agreement_Constraint {
  /** unique or primary key constraint on columns "agreement_id" */
  VarietyAgreementAgreementIdKey = 'variety_agreement_agreement_id_key',
  /** unique or primary key constraint on columns "codename" */
  VarietyAgreementCodenameKey = 'variety_agreement_codename_key',
  /** unique or primary key constraint on columns "id" */
  VarietyAgreementPkey = 'variety_agreement_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Variety_Agreement_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Variety_Agreement_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Variety_Agreement_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements = {
  __typename?: 'variety_agreement_guarantor_agreements';
  /** An object relationship */
  guarantor_agreement: Guarantor_Agreement;
  guarantoragreement_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  variety_agreement: Variety_Agreement;
  varietyagreement_id: Scalars['Int'];
};

/** aggregated selection of "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Aggregate = {
  __typename?: 'variety_agreement_guarantor_agreements_aggregate';
  aggregate?: Maybe<Variety_Agreement_Guarantor_Agreements_Aggregate_Fields>;
  nodes: Array<Variety_Agreement_Guarantor_Agreements>;
};

/** aggregate fields of "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Aggregate_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_aggregate_fields';
  avg?: Maybe<Variety_Agreement_Guarantor_Agreements_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Agreement_Guarantor_Agreements_Max_Fields>;
  min?: Maybe<Variety_Agreement_Guarantor_Agreements_Min_Fields>;
  stddev?: Maybe<Variety_Agreement_Guarantor_Agreements_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Agreement_Guarantor_Agreements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Agreement_Guarantor_Agreements_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Agreement_Guarantor_Agreements_Sum_Fields>;
  var_pop?: Maybe<Variety_Agreement_Guarantor_Agreements_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Agreement_Guarantor_Agreements_Var_Samp_Fields>;
  variance?: Maybe<Variety_Agreement_Guarantor_Agreements_Variance_Fields>;
};


/** aggregate fields of "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Aggregate_Order_By = {
  avg?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Max_Order_By>;
  min?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Min_Order_By>;
  stddev?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Sum_Order_By>;
  var_pop?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Var_Samp_Order_By>;
  variance?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Arr_Rel_Insert_Input = {
  data: Array<Variety_Agreement_Guarantor_Agreements_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Agreement_Guarantor_Agreements_On_Conflict>;
};

/** aggregate avg on columns */
export type Variety_Agreement_Guarantor_Agreements_Avg_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_avg_fields';
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Avg_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variety_agreement_guarantor_agreements". All fields are combined with a logical 'AND'. */
export type Variety_Agreement_Guarantor_Agreements_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Bool_Exp>>;
  _not?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Agreement_Guarantor_Agreements_Bool_Exp>>;
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Bool_Exp>;
  guarantoragreement_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  variety_agreement?: InputMaybe<Variety_Agreement_Bool_Exp>;
  varietyagreement_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_agreement_guarantor_agreements" */
export enum Variety_Agreement_Guarantor_Agreements_Constraint {
  /** unique or primary key constraint on columns "guarantoragreement_id", "varietyagreement_id" */
  VarietyAgreementGuaranVarietyagreementIdGuar_7a096983Uniq = 'variety_agreement_guaran_varietyagreement_id_guar_7a096983_uniq',
  /** unique or primary key constraint on columns "id" */
  VarietyAgreementGuarantorAgreementsPkey = 'variety_agreement_guarantor_agreements_pkey'
}

/** input type for incrementing numeric columns in table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Inc_Input = {
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Insert_Input = {
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Obj_Rel_Insert_Input>;
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  variety_agreement?: InputMaybe<Variety_Agreement_Obj_Rel_Insert_Input>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Variety_Agreement_Guarantor_Agreements_Max_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_max_fields';
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietyagreement_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Max_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variety_Agreement_Guarantor_Agreements_Min_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_min_fields';
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietyagreement_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Min_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Mutation_Response = {
  __typename?: 'variety_agreement_guarantor_agreements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Agreement_Guarantor_Agreements>;
};

/** on_conflict condition type for table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_On_Conflict = {
  constraint: Variety_Agreement_Guarantor_Agreements_Constraint;
  update_columns?: Array<Variety_Agreement_Guarantor_Agreements_Update_Column>;
  where?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_agreement_guarantor_agreements". */
export type Variety_Agreement_Guarantor_Agreements_Order_By = {
  guarantor_agreement?: InputMaybe<Guarantor_Agreement_Order_By>;
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  variety_agreement?: InputMaybe<Variety_Agreement_Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_agreement_guarantor_agreements */
export type Variety_Agreement_Guarantor_Agreements_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "variety_agreement_guarantor_agreements" */
export enum Variety_Agreement_Guarantor_Agreements_Select_Column {
  /** column name */
  GuarantoragreementId = 'guarantoragreement_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietyagreementId = 'varietyagreement_id'
}

/** input type for updating data in table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Set_Input = {
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Variety_Agreement_Guarantor_Agreements_Stddev_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_stddev_fields';
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Stddev_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variety_Agreement_Guarantor_Agreements_Stddev_Pop_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_stddev_pop_fields';
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Stddev_Pop_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variety_Agreement_Guarantor_Agreements_Stddev_Samp_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_stddev_samp_fields';
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Stddev_Samp_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Agreement_Guarantor_Agreements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Agreement_Guarantor_Agreements_Stream_Cursor_Value_Input = {
  guarantoragreement_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  varietyagreement_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Variety_Agreement_Guarantor_Agreements_Sum_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_sum_fields';
  guarantoragreement_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  varietyagreement_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Sum_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** update columns of table "variety_agreement_guarantor_agreements" */
export enum Variety_Agreement_Guarantor_Agreements_Update_Column {
  /** column name */
  GuarantoragreementId = 'guarantoragreement_id',
  /** column name */
  Id = 'id',
  /** column name */
  VarietyagreementId = 'varietyagreement_id'
}

export type Variety_Agreement_Guarantor_Agreements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Set_Input>;
  where: Variety_Agreement_Guarantor_Agreements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Agreement_Guarantor_Agreements_Var_Pop_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_var_pop_fields';
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Var_Pop_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variety_Agreement_Guarantor_Agreements_Var_Samp_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_var_samp_fields';
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Var_Samp_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variety_Agreement_Guarantor_Agreements_Variance_Fields = {
  __typename?: 'variety_agreement_guarantor_agreements_variance_fields';
  guarantoragreement_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  varietyagreement_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "variety_agreement_guarantor_agreements" */
export type Variety_Agreement_Guarantor_Agreements_Variance_Order_By = {
  guarantoragreement_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  varietyagreement_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "variety_agreement" */
export type Variety_Agreement_Inc_Input = {
  agreement_id?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_agreement" */
export type Variety_Agreement_Insert_Input = {
  agreement_co_owners?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Arr_Rel_Insert_Input>;
  agreement_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  current_logs?: InputMaybe<Workflow_Current_Logs_Arr_Rel_Insert_Input>;
  farmer?: InputMaybe<Base_User_Obj_Rel_Insert_Input>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  guarantor_agreements?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  logs?: InputMaybe<Stage_Logs_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  sent_to_breeder?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Variety_Agreement_Max_Fields = {
  __typename?: 'variety_agreement_max_fields';
  agreement_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Variety_Agreement_Min_Fields = {
  __typename?: 'variety_agreement_min_fields';
  agreement_id?: Maybe<Scalars['Int']>;
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "variety_agreement" */
export type Variety_Agreement_Mutation_Response = {
  __typename?: 'variety_agreement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Agreement>;
};

/** input type for inserting object relation for remote table "variety_agreement" */
export type Variety_Agreement_Obj_Rel_Insert_Input = {
  data: Variety_Agreement_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Agreement_On_Conflict>;
};

/** on_conflict condition type for table "variety_agreement" */
export type Variety_Agreement_On_Conflict = {
  constraint: Variety_Agreement_Constraint;
  update_columns?: Array<Variety_Agreement_Update_Column>;
  where?: InputMaybe<Variety_Agreement_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_agreement". */
export type Variety_Agreement_Order_By = {
  agreement_co_owners_aggregate?: InputMaybe<Variety_Agreement_Agreement_Co_Owners_Aggregate_Order_By>;
  agreement_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  created_in_id?: InputMaybe<Order_By>;
  current_logs_aggregate?: InputMaybe<Workflow_Current_Logs_Aggregate_Order_By>;
  farmer?: InputMaybe<Base_User_Order_By>;
  farmer_id?: InputMaybe<Order_By>;
  guarantor_agreements_aggregate?: InputMaybe<Variety_Agreement_Guarantor_Agreements_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Stage_Logs_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  sent_to_breeder?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_agreement */
export type Variety_Agreement_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Variety_Agreement_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "variety_agreement" */
export enum Variety_Agreement_Select_Column {
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SentToBreeder = 'sent_to_breeder',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "variety_agreement" */
export type Variety_Agreement_Set_Input = {
  agreement_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  sent_to_breeder?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Variety_Agreement_Stddev_Fields = {
  __typename?: 'variety_agreement_stddev_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Variety_Agreement_Stddev_Pop_Fields = {
  __typename?: 'variety_agreement_stddev_pop_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Variety_Agreement_Stddev_Samp_Fields = {
  __typename?: 'variety_agreement_stddev_samp_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "variety_agreement" */
export type Variety_Agreement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Agreement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Agreement_Stream_Cursor_Value_Input = {
  agreement_id?: InputMaybe<Scalars['Int']>;
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['Int']>;
  created_in_id?: InputMaybe<Scalars['Int']>;
  farmer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  sent_to_breeder?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Variety_Agreement_Sum_Fields = {
  __typename?: 'variety_agreement_sum_fields';
  agreement_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  created_in_id?: Maybe<Scalars['Int']>;
  farmer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "variety_agreement" */
export enum Variety_Agreement_Update_Column {
  /** column name */
  AgreementId = 'agreement_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CreatedInId = 'created_in_id',
  /** column name */
  FarmerId = 'farmer_id',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SentToBreeder = 'sent_to_breeder',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Variety_Agreement_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Variety_Agreement_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Variety_Agreement_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Variety_Agreement_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Variety_Agreement_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Agreement_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Variety_Agreement_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Agreement_Set_Input>;
  where: Variety_Agreement_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Agreement_Var_Pop_Fields = {
  __typename?: 'variety_agreement_var_pop_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Variety_Agreement_Var_Samp_Fields = {
  __typename?: 'variety_agreement_var_samp_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Variety_Agreement_Variance_Fields = {
  __typename?: 'variety_agreement_variance_fields';
  agreement_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  created_in_id?: Maybe<Scalars['Float']>;
  farmer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "variety_grade" */
export type Variety_Grade = {
  __typename?: 'variety_grade';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  /** An array relationship */
  photos: Array<Variety_Grade_Photos>;
  /** An aggregate relationship */
  photos_aggregate: Variety_Grade_Photos_Aggregate;
  short_name?: Maybe<Scalars['String']>;
  specifications: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  variety: Commodity_Variety;
  variety_id: Scalars['Int'];
};


/** columns and relationships of "variety_grade" */
export type Variety_GradePhotosArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};


/** columns and relationships of "variety_grade" */
export type Variety_GradePhotos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Variety_Grade_Photos_Order_By>>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};

/** aggregated selection of "variety_grade" */
export type Variety_Grade_Aggregate = {
  __typename?: 'variety_grade_aggregate';
  aggregate?: Maybe<Variety_Grade_Aggregate_Fields>;
  nodes: Array<Variety_Grade>;
};

/** aggregate fields of "variety_grade" */
export type Variety_Grade_Aggregate_Fields = {
  __typename?: 'variety_grade_aggregate_fields';
  avg?: Maybe<Variety_Grade_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Grade_Max_Fields>;
  min?: Maybe<Variety_Grade_Min_Fields>;
  stddev?: Maybe<Variety_Grade_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Grade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Grade_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Grade_Sum_Fields>;
  var_pop?: Maybe<Variety_Grade_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Grade_Var_Samp_Fields>;
  variance?: Maybe<Variety_Grade_Variance_Fields>;
};


/** aggregate fields of "variety_grade" */
export type Variety_Grade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Grade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "variety_grade" */
export type Variety_Grade_Aggregate_Order_By = {
  avg?: InputMaybe<Variety_Grade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variety_Grade_Max_Order_By>;
  min?: InputMaybe<Variety_Grade_Min_Order_By>;
  stddev?: InputMaybe<Variety_Grade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variety_Grade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variety_Grade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variety_Grade_Sum_Order_By>;
  var_pop?: InputMaybe<Variety_Grade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variety_Grade_Var_Samp_Order_By>;
  variance?: InputMaybe<Variety_Grade_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variety_grade" */
export type Variety_Grade_Arr_Rel_Insert_Input = {
  data: Array<Variety_Grade_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};

/** aggregate avg on columns */
export type Variety_Grade_Avg_Fields = {
  __typename?: 'variety_grade_avg_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "variety_grade" */
export type Variety_Grade_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variety_grade". All fields are combined with a logical 'AND'. */
export type Variety_Grade_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  _not?: InputMaybe<Variety_Grade_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photos?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  specifications?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variety?: InputMaybe<Commodity_Variety_Bool_Exp>;
  variety_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "variety_grade". All fields are combined with a logical 'AND'. */
export type Variety_Grade_Bool_Exp_Remote_Rel_Shared_Entityvariety_Grade = {
  _and?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  _not?: InputMaybe<Variety_Grade_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Grade_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp_Remote_Rel_Shared_Entityvariety_Grade>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photos?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  specifications?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variety?: InputMaybe<Commodity_Variety_Bool_Exp>;
  variety_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_grade" */
export enum Variety_Grade_Constraint {
  /** unique or primary key constraint on columns "codename" */
  VarietyGradeCodenameKey = 'variety_grade_codename_key',
  /** unique or primary key constraint on columns "name", "variety_id" */
  VarietyGradeNameVarietyId_66e65a93Uniq = 'variety_grade_name_variety_id_66e65a93_uniq',
  /** unique or primary key constraint on columns "id" */
  VarietyGradePkey = 'variety_grade_pkey'
}

/** input type for incrementing numeric columns in table "variety_grade" */
export type Variety_Grade_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_grade" */
export type Variety_Grade_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Variety_Grade_Photos_Arr_Rel_Insert_Input>;
  short_name?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety?: InputMaybe<Commodity_Variety_Obj_Rel_Insert_Input>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Variety_Grade_Max_Fields = {
  __typename?: 'variety_grade_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "variety_grade" */
export type Variety_Grade_Max_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  specifications?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variety_Grade_Min_Fields = {
  __typename?: 'variety_grade_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  variety_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "variety_grade" */
export type Variety_Grade_Min_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  specifications?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variety_grade" */
export type Variety_Grade_Mutation_Response = {
  __typename?: 'variety_grade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Grade>;
};

/** input type for inserting object relation for remote table "variety_grade" */
export type Variety_Grade_Obj_Rel_Insert_Input = {
  data: Variety_Grade_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Grade_On_Conflict>;
};

/** on_conflict condition type for table "variety_grade" */
export type Variety_Grade_On_Conflict = {
  constraint: Variety_Grade_Constraint;
  update_columns?: Array<Variety_Grade_Update_Column>;
  where?: InputMaybe<Variety_Grade_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_grade". */
export type Variety_Grade_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photos_aggregate?: InputMaybe<Variety_Grade_Photos_Aggregate_Order_By>;
  short_name?: InputMaybe<Order_By>;
  specifications?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variety?: InputMaybe<Commodity_Variety_Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "variety_grade_photos" */
export type Variety_Grade_Photos = {
  __typename?: 'variety_grade_photos';
  id: Scalars['Int'];
  media_id: Scalars['Int'];
  /** An object relationship */
  photo: Media;
  /** An object relationship */
  variety_grade: Variety_Grade;
  varietygrade_id: Scalars['Int'];
};

/** aggregated selection of "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate = {
  __typename?: 'variety_grade_photos_aggregate';
  aggregate?: Maybe<Variety_Grade_Photos_Aggregate_Fields>;
  nodes: Array<Variety_Grade_Photos>;
};

/** aggregate fields of "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate_Fields = {
  __typename?: 'variety_grade_photos_aggregate_fields';
  avg?: Maybe<Variety_Grade_Photos_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Grade_Photos_Max_Fields>;
  min?: Maybe<Variety_Grade_Photos_Min_Fields>;
  stddev?: Maybe<Variety_Grade_Photos_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Grade_Photos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Grade_Photos_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Grade_Photos_Sum_Fields>;
  var_pop?: Maybe<Variety_Grade_Photos_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Grade_Photos_Var_Samp_Fields>;
  variance?: Maybe<Variety_Grade_Photos_Variance_Fields>;
};


/** aggregate fields of "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Grade_Photos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "variety_grade_photos" */
export type Variety_Grade_Photos_Aggregate_Order_By = {
  avg?: InputMaybe<Variety_Grade_Photos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variety_Grade_Photos_Max_Order_By>;
  min?: InputMaybe<Variety_Grade_Photos_Min_Order_By>;
  stddev?: InputMaybe<Variety_Grade_Photos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variety_Grade_Photos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variety_Grade_Photos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variety_Grade_Photos_Sum_Order_By>;
  var_pop?: InputMaybe<Variety_Grade_Photos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variety_Grade_Photos_Var_Samp_Order_By>;
  variance?: InputMaybe<Variety_Grade_Photos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variety_grade_photos" */
export type Variety_Grade_Photos_Arr_Rel_Insert_Input = {
  data: Array<Variety_Grade_Photos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Grade_Photos_On_Conflict>;
};

/** aggregate avg on columns */
export type Variety_Grade_Photos_Avg_Fields = {
  __typename?: 'variety_grade_photos_avg_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variety_grade_photos". All fields are combined with a logical 'AND'. */
export type Variety_Grade_Photos_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Grade_Photos_Bool_Exp>>;
  _not?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Grade_Photos_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  media_id?: InputMaybe<Int_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  variety_grade?: InputMaybe<Variety_Grade_Bool_Exp>;
  varietygrade_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_grade_photos" */
export enum Variety_Grade_Photos_Constraint {
  /** unique or primary key constraint on columns "id" */
  VarietyGradePhotosPkey = 'variety_grade_photos_pkey',
  /** unique or primary key constraint on columns "media_id", "varietygrade_id" */
  VarietyGradePhotosVarietygradeIdMediaId_666d4e7fUniq = 'variety_grade_photos_varietygrade_id_media_id_666d4e7f_uniq'
}

/** input type for incrementing numeric columns in table "variety_grade_photos" */
export type Variety_Grade_Photos_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_grade_photos" */
export type Variety_Grade_Photos_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  variety_grade?: InputMaybe<Variety_Grade_Obj_Rel_Insert_Input>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Variety_Grade_Photos_Max_Fields = {
  __typename?: 'variety_grade_photos_max_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  varietygrade_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variety_Grade_Photos_Min_Fields = {
  __typename?: 'variety_grade_photos_min_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  varietygrade_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variety_grade_photos" */
export type Variety_Grade_Photos_Mutation_Response = {
  __typename?: 'variety_grade_photos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Grade_Photos>;
};

/** on_conflict condition type for table "variety_grade_photos" */
export type Variety_Grade_Photos_On_Conflict = {
  constraint: Variety_Grade_Photos_Constraint;
  update_columns?: Array<Variety_Grade_Photos_Update_Column>;
  where?: InputMaybe<Variety_Grade_Photos_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_grade_photos". */
export type Variety_Grade_Photos_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  variety_grade?: InputMaybe<Variety_Grade_Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_grade_photos */
export type Variety_Grade_Photos_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "variety_grade_photos" */
export enum Variety_Grade_Photos_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  VarietygradeId = 'varietygrade_id'
}

/** input type for updating data in table "variety_grade_photos" */
export type Variety_Grade_Photos_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Variety_Grade_Photos_Stddev_Fields = {
  __typename?: 'variety_grade_photos_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variety_Grade_Photos_Stddev_Pop_Fields = {
  __typename?: 'variety_grade_photos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variety_Grade_Photos_Stddev_Samp_Fields = {
  __typename?: 'variety_grade_photos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variety_grade_photos" */
export type Variety_Grade_Photos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Grade_Photos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Grade_Photos_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  media_id?: InputMaybe<Scalars['Int']>;
  varietygrade_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Variety_Grade_Photos_Sum_Fields = {
  __typename?: 'variety_grade_photos_sum_fields';
  id?: Maybe<Scalars['Int']>;
  media_id?: Maybe<Scalars['Int']>;
  varietygrade_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** update columns of table "variety_grade_photos" */
export enum Variety_Grade_Photos_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MediaId = 'media_id',
  /** column name */
  VarietygradeId = 'varietygrade_id'
}

export type Variety_Grade_Photos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Grade_Photos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Grade_Photos_Set_Input>;
  where: Variety_Grade_Photos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Grade_Photos_Var_Pop_Fields = {
  __typename?: 'variety_grade_photos_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variety_Grade_Photos_Var_Samp_Fields = {
  __typename?: 'variety_grade_photos_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variety_Grade_Photos_Variance_Fields = {
  __typename?: 'variety_grade_photos_variance_fields';
  id?: Maybe<Scalars['Float']>;
  media_id?: Maybe<Scalars['Float']>;
  varietygrade_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "variety_grade_photos" */
export type Variety_Grade_Photos_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  media_id?: InputMaybe<Order_By>;
  varietygrade_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_grade */
export type Variety_Grade_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "variety_grade" */
export enum Variety_Grade_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Specifications = 'specifications',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarietyId = 'variety_id'
}

/** input type for updating data in table "variety_grade" */
export type Variety_Grade_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Variety_Grade_Stddev_Fields = {
  __typename?: 'variety_grade_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "variety_grade" */
export type Variety_Grade_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variety_Grade_Stddev_Pop_Fields = {
  __typename?: 'variety_grade_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "variety_grade" */
export type Variety_Grade_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variety_Grade_Stddev_Samp_Fields = {
  __typename?: 'variety_grade_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "variety_grade" */
export type Variety_Grade_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variety_grade" */
export type Variety_Grade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Grade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Grade_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  specifications?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  variety_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Variety_Grade_Sum_Fields = {
  __typename?: 'variety_grade_sum_fields';
  id?: Maybe<Scalars['Int']>;
  variety_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "variety_grade" */
export type Variety_Grade_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** update columns of table "variety_grade" */
export enum Variety_Grade_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  Specifications = 'specifications',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VarietyId = 'variety_id'
}

export type Variety_Grade_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Grade_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Grade_Set_Input>;
  where: Variety_Grade_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Grade_Var_Pop_Fields = {
  __typename?: 'variety_grade_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "variety_grade" */
export type Variety_Grade_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variety_Grade_Var_Samp_Fields = {
  __typename?: 'variety_grade_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "variety_grade" */
export type Variety_Grade_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variety_Grade_Variance_Fields = {
  __typename?: 'variety_grade_variance_fields';
  id?: Maybe<Scalars['Float']>;
  variety_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "variety_grade" */
export type Variety_Grade_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  variety_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "variety_group" */
export type Variety_Group = {
  __typename?: 'variety_group';
  codename: Scalars['String'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Media>;
  photo_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  primary_varieties: Array<Commodity_Variety>;
  /** An aggregate relationship */
  primary_varieties_aggregate: Commodity_Variety_Aggregate;
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  secondary_varieties: Array<Commodity_Variety_Secondary_Groups>;
  /** An aggregate relationship */
  secondary_varieties_aggregate: Commodity_Variety_Secondary_Groups_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "variety_group" */
export type Variety_GroupMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupPrimary_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupPrimary_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Bool_Exp>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupSecondary_VarietiesArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};


/** columns and relationships of "variety_group" */
export type Variety_GroupSecondary_Varieties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Commodity_Variety_Secondary_Groups_Order_By>>;
  where?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
};

/** aggregated selection of "variety_group" */
export type Variety_Group_Aggregate = {
  __typename?: 'variety_group_aggregate';
  aggregate?: Maybe<Variety_Group_Aggregate_Fields>;
  nodes: Array<Variety_Group>;
};

/** aggregate fields of "variety_group" */
export type Variety_Group_Aggregate_Fields = {
  __typename?: 'variety_group_aggregate_fields';
  avg?: Maybe<Variety_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Variety_Group_Max_Fields>;
  min?: Maybe<Variety_Group_Min_Fields>;
  stddev?: Maybe<Variety_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Variety_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variety_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Variety_Group_Sum_Fields>;
  var_pop?: Maybe<Variety_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Variety_Group_Var_Samp_Fields>;
  variance?: Maybe<Variety_Group_Variance_Fields>;
};


/** aggregate fields of "variety_group" */
export type Variety_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variety_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Variety_Group_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Variety_Group_Avg_Fields = {
  __typename?: 'variety_group_avg_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "variety_group". All fields are combined with a logical 'AND'. */
export type Variety_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Variety_Group_Bool_Exp>>;
  _not?: InputMaybe<Variety_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Variety_Group_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<Media_Bool_Exp>;
  photo_id?: InputMaybe<Int_Comparison_Exp>;
  primary_varieties?: InputMaybe<Commodity_Variety_Bool_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  secondary_varieties?: InputMaybe<Commodity_Variety_Secondary_Groups_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "variety_group" */
export enum Variety_Group_Constraint {
  /** unique or primary key constraint on columns "codename" */
  VarietyGroupCodenameKey = 'variety_group_codename_key',
  /** unique or primary key constraint on columns "id" */
  VarietyGroupPkey = 'variety_group_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Variety_Group_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Variety_Group_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Variety_Group_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "variety_group" */
export type Variety_Group_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  photo_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "variety_group" */
export type Variety_Group_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Media_Obj_Rel_Insert_Input>;
  photo_id?: InputMaybe<Scalars['Int']>;
  primary_varieties?: InputMaybe<Commodity_Variety_Arr_Rel_Insert_Input>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  secondary_varieties?: InputMaybe<Commodity_Variety_Secondary_Groups_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Variety_Group_Max_Fields = {
  __typename?: 'variety_group_max_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Variety_Group_Min_Fields = {
  __typename?: 'variety_group_min_fields';
  codename?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photo_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "variety_group" */
export type Variety_Group_Mutation_Response = {
  __typename?: 'variety_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Variety_Group>;
};

/** input type for inserting object relation for remote table "variety_group" */
export type Variety_Group_Obj_Rel_Insert_Input = {
  data: Variety_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variety_Group_On_Conflict>;
};

/** on_conflict condition type for table "variety_group" */
export type Variety_Group_On_Conflict = {
  constraint: Variety_Group_Constraint;
  update_columns?: Array<Variety_Group_Update_Column>;
  where?: InputMaybe<Variety_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "variety_group". */
export type Variety_Group_Order_By = {
  codename?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  photo?: InputMaybe<Media_Order_By>;
  photo_id?: InputMaybe<Order_By>;
  primary_varieties_aggregate?: InputMaybe<Commodity_Variety_Aggregate_Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  secondary_varieties_aggregate?: InputMaybe<Commodity_Variety_Secondary_Groups_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variety_group */
export type Variety_Group_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Variety_Group_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "variety_group" */
export enum Variety_Group_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "variety_group" */
export type Variety_Group_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Variety_Group_Stddev_Fields = {
  __typename?: 'variety_group_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Variety_Group_Stddev_Pop_Fields = {
  __typename?: 'variety_group_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Variety_Group_Stddev_Samp_Fields = {
  __typename?: 'variety_group_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "variety_group" */
export type Variety_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variety_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variety_Group_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  photo_id?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Variety_Group_Sum_Fields = {
  __typename?: 'variety_group_sum_fields';
  id?: Maybe<Scalars['Int']>;
  photo_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "variety_group" */
export enum Variety_Group_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PhotoId = 'photo_id',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Variety_Group_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Variety_Group_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Variety_Group_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Variety_Group_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Variety_Group_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variety_Group_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Variety_Group_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variety_Group_Set_Input>;
  where: Variety_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variety_Group_Var_Pop_Fields = {
  __typename?: 'variety_group_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Variety_Group_Var_Samp_Fields = {
  __typename?: 'variety_group_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Variety_Group_Variance_Fields = {
  __typename?: 'variety_group_variance_fields';
  id?: Maybe<Scalars['Float']>;
  photo_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vt_core_tax" */
export type Vt_Core_Tax = {
  __typename?: 'vt_core_tax';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  percentage: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "vt_core_tax" */
export type Vt_Core_Tax_Aggregate = {
  __typename?: 'vt_core_tax_aggregate';
  aggregate?: Maybe<Vt_Core_Tax_Aggregate_Fields>;
  nodes: Array<Vt_Core_Tax>;
};

/** aggregate fields of "vt_core_tax" */
export type Vt_Core_Tax_Aggregate_Fields = {
  __typename?: 'vt_core_tax_aggregate_fields';
  avg?: Maybe<Vt_Core_Tax_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Vt_Core_Tax_Max_Fields>;
  min?: Maybe<Vt_Core_Tax_Min_Fields>;
  stddev?: Maybe<Vt_Core_Tax_Stddev_Fields>;
  stddev_pop?: Maybe<Vt_Core_Tax_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vt_Core_Tax_Stddev_Samp_Fields>;
  sum?: Maybe<Vt_Core_Tax_Sum_Fields>;
  var_pop?: Maybe<Vt_Core_Tax_Var_Pop_Fields>;
  var_samp?: Maybe<Vt_Core_Tax_Var_Samp_Fields>;
  variance?: Maybe<Vt_Core_Tax_Variance_Fields>;
};


/** aggregate fields of "vt_core_tax" */
export type Vt_Core_Tax_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vt_Core_Tax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Vt_Core_Tax_Avg_Fields = {
  __typename?: 'vt_core_tax_avg_fields';
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vt_core_tax". All fields are combined with a logical 'AND'. */
export type Vt_Core_Tax_Bool_Exp = {
  _and?: InputMaybe<Array<Vt_Core_Tax_Bool_Exp>>;
  _not?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
  _or?: InputMaybe<Array<Vt_Core_Tax_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  percentage?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "vt_core_tax" */
export enum Vt_Core_Tax_Constraint {
  /** unique or primary key constraint on columns "name", "percentage" */
  VtCoreTaxNamePercentage_9f977208Uniq = 'vt_core_tax_name_percentage_9f977208_uniq',
  /** unique or primary key constraint on columns "id" */
  VtCoreTaxPkey = 'vt_core_tax_pkey'
}

/** input type for incrementing numeric columns in table "vt_core_tax" */
export type Vt_Core_Tax_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "vt_core_tax" */
export type Vt_Core_Tax_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Vt_Core_Tax_Max_Fields = {
  __typename?: 'vt_core_tax_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Vt_Core_Tax_Min_Fields = {
  __typename?: 'vt_core_tax_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "vt_core_tax" */
export type Vt_Core_Tax_Mutation_Response = {
  __typename?: 'vt_core_tax_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vt_Core_Tax>;
};

/** input type for inserting object relation for remote table "vt_core_tax" */
export type Vt_Core_Tax_Obj_Rel_Insert_Input = {
  data: Vt_Core_Tax_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vt_Core_Tax_On_Conflict>;
};

/** on_conflict condition type for table "vt_core_tax" */
export type Vt_Core_Tax_On_Conflict = {
  constraint: Vt_Core_Tax_Constraint;
  update_columns?: Array<Vt_Core_Tax_Update_Column>;
  where?: InputMaybe<Vt_Core_Tax_Bool_Exp>;
};

/** Ordering options when selecting data from "vt_core_tax". */
export type Vt_Core_Tax_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  percentage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vt_core_tax */
export type Vt_Core_Tax_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "vt_core_tax" */
export enum Vt_Core_Tax_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "vt_core_tax" */
export type Vt_Core_Tax_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Vt_Core_Tax_Stddev_Fields = {
  __typename?: 'vt_core_tax_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Vt_Core_Tax_Stddev_Pop_Fields = {
  __typename?: 'vt_core_tax_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Vt_Core_Tax_Stddev_Samp_Fields = {
  __typename?: 'vt_core_tax_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vt_core_tax" */
export type Vt_Core_Tax_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vt_Core_Tax_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vt_Core_Tax_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Vt_Core_Tax_Sum_Fields = {
  __typename?: 'vt_core_tax_sum_fields';
  id?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['float8']>;
};

/** update columns of table "vt_core_tax" */
export enum Vt_Core_Tax_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Percentage = 'percentage',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Vt_Core_Tax_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vt_Core_Tax_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vt_Core_Tax_Set_Input>;
  where: Vt_Core_Tax_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vt_Core_Tax_Var_Pop_Fields = {
  __typename?: 'vt_core_tax_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Vt_Core_Tax_Var_Samp_Fields = {
  __typename?: 'vt_core_tax_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Vt_Core_Tax_Variance_Fields = {
  __typename?: 'vt_core_tax_variance_fields';
  id?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "weather_reference" */
export type Weather_Reference = {
  __typename?: 'weather_reference';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  field_weather_locations: Array<Field_Weather_Location>;
  /** An aggregate relationship */
  field_weather_locations_aggregate: Field_Weather_Location_Aggregate;
  geom: Scalars['geometry'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  last_activated_on?: Maybe<Scalars['date']>;
  name: Scalars['String'];
};


/** columns and relationships of "weather_reference" */
export type Weather_ReferenceField_Weather_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};


/** columns and relationships of "weather_reference" */
export type Weather_ReferenceField_Weather_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Weather_Location_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Weather_Location_Order_By>>;
  where?: InputMaybe<Field_Weather_Location_Bool_Exp>;
};

/** aggregated selection of "weather_reference" */
export type Weather_Reference_Aggregate = {
  __typename?: 'weather_reference_aggregate';
  aggregate?: Maybe<Weather_Reference_Aggregate_Fields>;
  nodes: Array<Weather_Reference>;
};

/** aggregate fields of "weather_reference" */
export type Weather_Reference_Aggregate_Fields = {
  __typename?: 'weather_reference_aggregate_fields';
  avg?: Maybe<Weather_Reference_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Weather_Reference_Max_Fields>;
  min?: Maybe<Weather_Reference_Min_Fields>;
  stddev?: Maybe<Weather_Reference_Stddev_Fields>;
  stddev_pop?: Maybe<Weather_Reference_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Weather_Reference_Stddev_Samp_Fields>;
  sum?: Maybe<Weather_Reference_Sum_Fields>;
  var_pop?: Maybe<Weather_Reference_Var_Pop_Fields>;
  var_samp?: Maybe<Weather_Reference_Var_Samp_Fields>;
  variance?: Maybe<Weather_Reference_Variance_Fields>;
};


/** aggregate fields of "weather_reference" */
export type Weather_Reference_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Weather_Reference_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Weather_Reference_Avg_Fields = {
  __typename?: 'weather_reference_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "weather_reference". All fields are combined with a logical 'AND'. */
export type Weather_Reference_Bool_Exp = {
  _and?: InputMaybe<Array<Weather_Reference_Bool_Exp>>;
  _not?: InputMaybe<Weather_Reference_Bool_Exp>;
  _or?: InputMaybe<Array<Weather_Reference_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Bool_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_activated_on?: InputMaybe<Date_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "weather_reference" */
export enum Weather_Reference_Constraint {
  /** unique or primary key constraint on columns "codename" */
  WeatherReferenceCodenameKey = 'weather_reference_codename_key',
  /** unique or primary key constraint on columns "geom" */
  WeatherReferenceGeomKey = 'weather_reference_geom_key',
  /** unique or primary key constraint on columns "id" */
  WeatherReferencePkey = 'weather_reference_pkey'
}

/** input type for incrementing numeric columns in table "weather_reference" */
export type Weather_Reference_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "weather_reference" */
export type Weather_Reference_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  field_weather_locations?: InputMaybe<Field_Weather_Location_Arr_Rel_Insert_Input>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_activated_on?: InputMaybe<Scalars['date']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Weather_Reference_Max_Fields = {
  __typename?: 'weather_reference_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_activated_on?: Maybe<Scalars['date']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Weather_Reference_Min_Fields = {
  __typename?: 'weather_reference_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_activated_on?: Maybe<Scalars['date']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "weather_reference" */
export type Weather_Reference_Mutation_Response = {
  __typename?: 'weather_reference_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Weather_Reference>;
};

/** input type for inserting object relation for remote table "weather_reference" */
export type Weather_Reference_Obj_Rel_Insert_Input = {
  data: Weather_Reference_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Weather_Reference_On_Conflict>;
};

/** on_conflict condition type for table "weather_reference" */
export type Weather_Reference_On_Conflict = {
  constraint: Weather_Reference_Constraint;
  update_columns?: Array<Weather_Reference_Update_Column>;
  where?: InputMaybe<Weather_Reference_Bool_Exp>;
};

/** Ordering options when selecting data from "weather_reference". */
export type Weather_Reference_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  field_weather_locations_aggregate?: InputMaybe<Field_Weather_Location_Aggregate_Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_activated_on?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: weather_reference */
export type Weather_Reference_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "weather_reference" */
export enum Weather_Reference_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastActivatedOn = 'last_activated_on',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "weather_reference" */
export type Weather_Reference_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_activated_on?: InputMaybe<Scalars['date']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Weather_Reference_Stddev_Fields = {
  __typename?: 'weather_reference_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Weather_Reference_Stddev_Pop_Fields = {
  __typename?: 'weather_reference_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Weather_Reference_Stddev_Samp_Fields = {
  __typename?: 'weather_reference_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "weather_reference" */
export type Weather_Reference_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weather_Reference_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weather_Reference_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  geom?: InputMaybe<Scalars['geometry']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_activated_on?: InputMaybe<Scalars['date']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Weather_Reference_Sum_Fields = {
  __typename?: 'weather_reference_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "weather_reference" */
export enum Weather_Reference_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastActivatedOn = 'last_activated_on',
  /** column name */
  Name = 'name'
}

export type Weather_Reference_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Weather_Reference_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weather_Reference_Set_Input>;
  where: Weather_Reference_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Weather_Reference_Var_Pop_Fields = {
  __typename?: 'weather_reference_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Weather_Reference_Var_Samp_Fields = {
  __typename?: 'weather_reference_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Weather_Reference_Variance_Fields = {
  __typename?: 'weather_reference_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "workflow" */
export type Workflow = {
  __typename?: 'workflow';
  alert: Scalars['Boolean'];
  category_id: Scalars['bigint'];
  codename: Scalars['String'];
  content_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['String'];
  description: Scalars['String'];
  /** An array relationship */
  entities: Array<Entity_State>;
  /** An aggregate relationship */
  entities_aggregate: Entity_State_Aggregate;
  id: Scalars['bigint'];
  /** An object relationship */
  initial_state: State;
  initial_state_id: Scalars['bigint'];
  is_active: Scalars['Boolean'];
  metadata: Scalars['jsonb'];
  name: Scalars['String'];
  private_metadata: Scalars['jsonb'];
  /** An array relationship */
  transition_logs: Array<Transition_History>;
  /** An aggregate relationship */
  transition_logs_aggregate: Transition_History_Aggregate;
  /** An array relationship */
  transitions: Array<Transition>;
  /** An aggregate relationship */
  transitions_aggregate: Transition_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "workflow" */
export type WorkflowEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


/** columns and relationships of "workflow" */
export type WorkflowEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Order_By>>;
  where?: InputMaybe<Entity_State_Bool_Exp>;
};


/** columns and relationships of "workflow" */
export type WorkflowMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow" */
export type WorkflowPrivate_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "workflow" */
export type WorkflowTransition_LogsArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "workflow" */
export type WorkflowTransition_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_History_Order_By>>;
  where?: InputMaybe<Transition_History_Bool_Exp>;
};


/** columns and relationships of "workflow" */
export type WorkflowTransitionsArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};


/** columns and relationships of "workflow" */
export type WorkflowTransitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transition_Order_By>>;
  where?: InputMaybe<Transition_Bool_Exp>;
};

/** aggregated selection of "workflow" */
export type Workflow_Aggregate = {
  __typename?: 'workflow_aggregate';
  aggregate?: Maybe<Workflow_Aggregate_Fields>;
  nodes: Array<Workflow>;
};

/** aggregate fields of "workflow" */
export type Workflow_Aggregate_Fields = {
  __typename?: 'workflow_aggregate_fields';
  avg?: Maybe<Workflow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Max_Fields>;
  min?: Maybe<Workflow_Min_Fields>;
  stddev?: Maybe<Workflow_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Sum_Fields>;
  var_pop?: Maybe<Workflow_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Variance_Fields>;
};


/** aggregate fields of "workflow" */
export type Workflow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow" */
export type Workflow_Aggregate_Order_By = {
  avg?: InputMaybe<Workflow_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Max_Order_By>;
  min?: InputMaybe<Workflow_Min_Order_By>;
  stddev?: InputMaybe<Workflow_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workflow_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workflow_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workflow_Sum_Order_By>;
  var_pop?: InputMaybe<Workflow_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workflow_Var_Samp_Order_By>;
  variance?: InputMaybe<Workflow_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "workflow" */
export type Workflow_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_On_Conflict>;
};

/** aggregate avg on columns */
export type Workflow_Avg_Fields = {
  __typename?: 'workflow_avg_fields';
  category_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_state_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workflow" */
export type Workflow_Avg_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workflow". All fields are combined with a logical 'AND'. */
export type Workflow_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Bool_Exp>>;
  alert?: InputMaybe<Boolean_Comparison_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  codename?: InputMaybe<String_Comparison_Exp>;
  content_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  entities?: InputMaybe<Entity_State_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  initial_state?: InputMaybe<State_Bool_Exp>;
  initial_state_id?: InputMaybe<Bigint_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  private_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  transition_logs?: InputMaybe<Transition_History_Bool_Exp>;
  transitions?: InputMaybe<Transition_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow" */
export enum Workflow_Constraint {
  /** unique or primary key constraint on columns "codename" */
  WorkflowCodenameKey = 'workflow_codename_key',
  /** unique or primary key constraint on columns "id" */
  WorkflowPkey = 'workflow_pkey'
}

/** columns and relationships of "workflow_current_logs" */
export type Workflow_Current_Logs = {
  __typename?: 'workflow_current_logs';
  created_at: Scalars['timestamptz'];
  entity_codename: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  log?: Maybe<Stage_Logs>;
  log_id?: Maybe<Scalars['Int']>;
  trigger_counter: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  workflow: Workflows;
  workflow_id: Scalars['Int'];
};

/** aggregated selection of "workflow_current_logs" */
export type Workflow_Current_Logs_Aggregate = {
  __typename?: 'workflow_current_logs_aggregate';
  aggregate?: Maybe<Workflow_Current_Logs_Aggregate_Fields>;
  nodes: Array<Workflow_Current_Logs>;
};

/** aggregate fields of "workflow_current_logs" */
export type Workflow_Current_Logs_Aggregate_Fields = {
  __typename?: 'workflow_current_logs_aggregate_fields';
  avg?: Maybe<Workflow_Current_Logs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Current_Logs_Max_Fields>;
  min?: Maybe<Workflow_Current_Logs_Min_Fields>;
  stddev?: Maybe<Workflow_Current_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Current_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Current_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Current_Logs_Sum_Fields>;
  var_pop?: Maybe<Workflow_Current_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Current_Logs_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Current_Logs_Variance_Fields>;
};


/** aggregate fields of "workflow_current_logs" */
export type Workflow_Current_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow_current_logs" */
export type Workflow_Current_Logs_Aggregate_Order_By = {
  avg?: InputMaybe<Workflow_Current_Logs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Current_Logs_Max_Order_By>;
  min?: InputMaybe<Workflow_Current_Logs_Min_Order_By>;
  stddev?: InputMaybe<Workflow_Current_Logs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workflow_Current_Logs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workflow_Current_Logs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workflow_Current_Logs_Sum_Order_By>;
  var_pop?: InputMaybe<Workflow_Current_Logs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workflow_Current_Logs_Var_Samp_Order_By>;
  variance?: InputMaybe<Workflow_Current_Logs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workflow_current_logs" */
export type Workflow_Current_Logs_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Current_Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_Current_Logs_On_Conflict>;
};

/** aggregate avg on columns */
export type Workflow_Current_Logs_Avg_Fields = {
  __typename?: 'workflow_current_logs_avg_fields';
  id?: Maybe<Scalars['Float']>;
  log_id?: Maybe<Scalars['Float']>;
  trigger_counter?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workflow_current_logs". All fields are combined with a logical 'AND'. */
export type Workflow_Current_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Current_Logs_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Current_Logs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_codename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  log?: InputMaybe<Stage_Logs_Bool_Exp>;
  log_id?: InputMaybe<Int_Comparison_Exp>;
  trigger_counter?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  workflow?: InputMaybe<Workflows_Bool_Exp>;
  workflow_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow_current_logs" */
export enum Workflow_Current_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkflowCurrentLogsPkey = 'workflow_current_logs_pkey',
  /** unique or primary key constraint on columns "workflow_id", "entity_codename" */
  WorkflowCurrentLogsWorkflowIdEntityCodename_93a1aa49Uniq = 'workflow_current_logs_workflow_id_entity_codename_93a1aa49_uniq'
}

/** input type for incrementing numeric columns in table "workflow_current_logs" */
export type Workflow_Current_Logs_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  log_id?: InputMaybe<Scalars['Int']>;
  trigger_counter?: InputMaybe<Scalars['Int']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow_current_logs" */
export type Workflow_Current_Logs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  log?: InputMaybe<Stage_Logs_Obj_Rel_Insert_Input>;
  log_id?: InputMaybe<Scalars['Int']>;
  trigger_counter?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow?: InputMaybe<Workflows_Obj_Rel_Insert_Input>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Workflow_Current_Logs_Max_Fields = {
  __typename?: 'workflow_current_logs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  entity_codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  log_id?: Maybe<Scalars['Int']>;
  trigger_counter?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Current_Logs_Min_Fields = {
  __typename?: 'workflow_current_logs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  entity_codename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  log_id?: Maybe<Scalars['Int']>;
  trigger_counter?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow_current_logs" */
export type Workflow_Current_Logs_Mutation_Response = {
  __typename?: 'workflow_current_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow_Current_Logs>;
};

/** on_conflict condition type for table "workflow_current_logs" */
export type Workflow_Current_Logs_On_Conflict = {
  constraint: Workflow_Current_Logs_Constraint;
  update_columns?: Array<Workflow_Current_Logs_Update_Column>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow_current_logs". */
export type Workflow_Current_Logs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_codename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  log?: InputMaybe<Stage_Logs_Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  workflow?: InputMaybe<Workflows_Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow_current_logs */
export type Workflow_Current_Logs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workflow_current_logs" */
export enum Workflow_Current_Logs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityCodename = 'entity_codename',
  /** column name */
  Id = 'id',
  /** column name */
  LogId = 'log_id',
  /** column name */
  TriggerCounter = 'trigger_counter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

/** input type for updating data in table "workflow_current_logs" */
export type Workflow_Current_Logs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  log_id?: InputMaybe<Scalars['Int']>;
  trigger_counter?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Workflow_Current_Logs_Stddev_Fields = {
  __typename?: 'workflow_current_logs_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  log_id?: Maybe<Scalars['Float']>;
  trigger_counter?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Current_Logs_Stddev_Pop_Fields = {
  __typename?: 'workflow_current_logs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  log_id?: Maybe<Scalars['Float']>;
  trigger_counter?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Current_Logs_Stddev_Samp_Fields = {
  __typename?: 'workflow_current_logs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  log_id?: Maybe<Scalars['Float']>;
  trigger_counter?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "workflow_current_logs" */
export type Workflow_Current_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Workflow_Current_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Workflow_Current_Logs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_codename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  log_id?: InputMaybe<Scalars['Int']>;
  trigger_counter?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workflow_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Workflow_Current_Logs_Sum_Fields = {
  __typename?: 'workflow_current_logs_sum_fields';
  id?: Maybe<Scalars['Int']>;
  log_id?: Maybe<Scalars['Int']>;
  trigger_counter?: Maybe<Scalars['Int']>;
  workflow_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** update columns of table "workflow_current_logs" */
export enum Workflow_Current_Logs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityCodename = 'entity_codename',
  /** column name */
  Id = 'id',
  /** column name */
  LogId = 'log_id',
  /** column name */
  TriggerCounter = 'trigger_counter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkflowId = 'workflow_id'
}

export type Workflow_Current_Logs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Workflow_Current_Logs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Workflow_Current_Logs_Set_Input>;
  where: Workflow_Current_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Workflow_Current_Logs_Var_Pop_Fields = {
  __typename?: 'workflow_current_logs_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  log_id?: Maybe<Scalars['Float']>;
  trigger_counter?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workflow_Current_Logs_Var_Samp_Fields = {
  __typename?: 'workflow_current_logs_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  log_id?: Maybe<Scalars['Float']>;
  trigger_counter?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workflow_Current_Logs_Variance_Fields = {
  __typename?: 'workflow_current_logs_variance_fields';
  id?: Maybe<Scalars['Float']>;
  log_id?: Maybe<Scalars['Float']>;
  trigger_counter?: Maybe<Scalars['Float']>;
  workflow_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workflow_current_logs" */
export type Workflow_Current_Logs_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  trigger_counter?: InputMaybe<Order_By>;
  workflow_id?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
  private_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
  private_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "workflow" */
export type Workflow_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  initial_state_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "workflow" */
export type Workflow_Insert_Input = {
  alert?: InputMaybe<Scalars['Boolean']>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  entities?: InputMaybe<Entity_State_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  initial_state?: InputMaybe<State_Obj_Rel_Insert_Input>;
  initial_state_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  transition_logs?: InputMaybe<Transition_History_Arr_Rel_Insert_Input>;
  transitions?: InputMaybe<Transition_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Workflow_Max_Fields = {
  __typename?: 'workflow_max_fields';
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  initial_state_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "workflow" */
export type Workflow_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Min_Fields = {
  __typename?: 'workflow_min_fields';
  category_id?: Maybe<Scalars['bigint']>;
  codename?: Maybe<Scalars['String']>;
  content_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  initial_state_id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "workflow" */
export type Workflow_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow" */
export type Workflow_Mutation_Response = {
  __typename?: 'workflow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow>;
};

/** input type for inserting object relation for remote table "workflow" */
export type Workflow_Obj_Rel_Insert_Input = {
  data: Workflow_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_On_Conflict>;
};

/** on_conflict condition type for table "workflow" */
export type Workflow_On_Conflict = {
  constraint: Workflow_Constraint;
  update_columns?: Array<Workflow_Update_Column>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow". */
export type Workflow_Order_By = {
  alert?: InputMaybe<Order_By>;
  category_id?: InputMaybe<Order_By>;
  codename?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  entities_aggregate?: InputMaybe<Entity_State_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state?: InputMaybe<State_Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  private_metadata?: InputMaybe<Order_By>;
  transition_logs_aggregate?: InputMaybe<Transition_History_Aggregate_Order_By>;
  transitions_aggregate?: InputMaybe<Transition_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow */
export type Workflow_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow" */
export enum Workflow_Select_Column {
  /** column name */
  Alert = 'alert',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InitialStateId = 'initial_state_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "workflow" */
export type Workflow_Set_Input = {
  alert?: InputMaybe<Scalars['Boolean']>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  initial_state_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Workflow_Stddev_Fields = {
  __typename?: 'workflow_stddev_fields';
  category_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_state_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workflow" */
export type Workflow_Stddev_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Stddev_Pop_Fields = {
  __typename?: 'workflow_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_state_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workflow" */
export type Workflow_Stddev_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Stddev_Samp_Fields = {
  __typename?: 'workflow_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_state_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workflow" */
export type Workflow_Stddev_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "workflow" */
export type Workflow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Workflow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Workflow_Stream_Cursor_Value_Input = {
  alert?: InputMaybe<Scalars['Boolean']>;
  category_id?: InputMaybe<Scalars['bigint']>;
  codename?: InputMaybe<Scalars['String']>;
  content_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  initial_state_id?: InputMaybe<Scalars['bigint']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  private_metadata?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Workflow_Sum_Fields = {
  __typename?: 'workflow_sum_fields';
  category_id?: Maybe<Scalars['bigint']>;
  content_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  initial_state_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "workflow" */
export type Workflow_Sum_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** update columns of table "workflow" */
export enum Workflow_Update_Column {
  /** column name */
  Alert = 'alert',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Codename = 'codename',
  /** column name */
  ContentTypeId = 'content_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InitialStateId = 'initial_state_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  PrivateMetadata = 'private_metadata',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Workflow_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Workflow_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Workflow_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Workflow_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Workflow_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Workflow_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Workflow_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Workflow_Set_Input>;
  where: Workflow_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Workflow_Var_Pop_Fields = {
  __typename?: 'workflow_var_pop_fields';
  category_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_state_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workflow" */
export type Workflow_Var_Pop_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workflow_Var_Samp_Fields = {
  __typename?: 'workflow_var_samp_fields';
  category_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_state_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workflow" */
export type Workflow_Var_Samp_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workflow_Variance_Fields = {
  __typename?: 'workflow_variance_fields';
  category_id?: Maybe<Scalars['Float']>;
  content_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  initial_state_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workflow" */
export type Workflow_Variance_Order_By = {
  category_id?: InputMaybe<Order_By>;
  content_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_state_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "workflows" */
export type Workflows = {
  __typename?: 'workflows';
  codename: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An array relationship */
  logs: Array<Workflow_Current_Logs>;
  /** An aggregate relationship */
  logs_aggregate: Workflow_Current_Logs_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  stages: Array<Stages>;
  /** An aggregate relationship */
  stages_aggregate: Stages_Aggregate;
};


/** columns and relationships of "workflows" */
export type WorkflowsLogsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


/** columns and relationships of "workflows" */
export type WorkflowsLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Current_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Current_Logs_Order_By>>;
  where?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
};


/** columns and relationships of "workflows" */
export type WorkflowsStagesArgs = {
  distinct_on?: InputMaybe<Array<Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Order_By>>;
  where?: InputMaybe<Stages_Bool_Exp>;
};


/** columns and relationships of "workflows" */
export type WorkflowsStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stages_Order_By>>;
  where?: InputMaybe<Stages_Bool_Exp>;
};

/** aggregated selection of "workflows" */
export type Workflows_Aggregate = {
  __typename?: 'workflows_aggregate';
  aggregate?: Maybe<Workflows_Aggregate_Fields>;
  nodes: Array<Workflows>;
};

/** aggregate fields of "workflows" */
export type Workflows_Aggregate_Fields = {
  __typename?: 'workflows_aggregate_fields';
  avg?: Maybe<Workflows_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflows_Max_Fields>;
  min?: Maybe<Workflows_Min_Fields>;
  stddev?: Maybe<Workflows_Stddev_Fields>;
  stddev_pop?: Maybe<Workflows_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflows_Stddev_Samp_Fields>;
  sum?: Maybe<Workflows_Sum_Fields>;
  var_pop?: Maybe<Workflows_Var_Pop_Fields>;
  var_samp?: Maybe<Workflows_Var_Samp_Fields>;
  variance?: Maybe<Workflows_Variance_Fields>;
};


/** aggregate fields of "workflows" */
export type Workflows_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Workflows_Avg_Fields = {
  __typename?: 'workflows_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "workflows". All fields are combined with a logical 'AND'. */
export type Workflows_Bool_Exp = {
  _and?: InputMaybe<Array<Workflows_Bool_Exp>>;
  _not?: InputMaybe<Workflows_Bool_Exp>;
  _or?: InputMaybe<Array<Workflows_Bool_Exp>>;
  codename?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logs?: InputMaybe<Workflow_Current_Logs_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stages?: InputMaybe<Stages_Bool_Exp>;
};

/** unique or primary key constraints on table "workflows" */
export enum Workflows_Constraint {
  /** unique or primary key constraint on columns "codename" */
  WorkflowsCodenameKey = 'workflows_codename_key',
  /** unique or primary key constraint on columns "id" */
  WorkflowsPkey = 'workflows_pkey'
}

/** input type for incrementing numeric columns in table "workflows" */
export type Workflows_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflows" */
export type Workflows_Insert_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  logs?: InputMaybe<Workflow_Current_Logs_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  stages?: InputMaybe<Stages_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Workflows_Max_Fields = {
  __typename?: 'workflows_max_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Workflows_Min_Fields = {
  __typename?: 'workflows_min_fields';
  codename?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "workflows" */
export type Workflows_Mutation_Response = {
  __typename?: 'workflows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflows>;
};

/** input type for inserting object relation for remote table "workflows" */
export type Workflows_Obj_Rel_Insert_Input = {
  data: Workflows_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflows_On_Conflict>;
};

/** on_conflict condition type for table "workflows" */
export type Workflows_On_Conflict = {
  constraint: Workflows_Constraint;
  update_columns?: Array<Workflows_Update_Column>;
  where?: InputMaybe<Workflows_Bool_Exp>;
};

/** Ordering options when selecting data from "workflows". */
export type Workflows_Order_By = {
  codename?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Workflow_Current_Logs_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  stages_aggregate?: InputMaybe<Stages_Aggregate_Order_By>;
};

/** primary key columns input for table: workflows */
export type Workflows_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workflows" */
export enum Workflows_Select_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workflows" */
export type Workflows_Set_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Workflows_Stddev_Fields = {
  __typename?: 'workflows_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Workflows_Stddev_Pop_Fields = {
  __typename?: 'workflows_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Workflows_Stddev_Samp_Fields = {
  __typename?: 'workflows_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "workflows" */
export type Workflows_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Workflows_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Workflows_Stream_Cursor_Value_Input = {
  codename?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Workflows_Sum_Fields = {
  __typename?: 'workflows_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "workflows" */
export enum Workflows_Update_Column {
  /** column name */
  Codename = 'codename',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Workflows_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Workflows_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Workflows_Set_Input>;
  where: Workflows_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Workflows_Var_Pop_Fields = {
  __typename?: 'workflows_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Workflows_Var_Samp_Fields = {
  __typename?: 'workflows_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Workflows_Variance_Fields = {
  __typename?: 'workflows_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type AgentLoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type AgentLoginMutation = { __typename?: 'mutation_root', agent_login?: { __typename?: 'AgentLogin', token: string, refresh_token: string, me?: { __typename?: 'BaseUserType', id: string, full_name?: string | null, agent?: { __typename?: 'AgentType', id: string, name: string, eid: string, current_department?: { __typename?: 'DepartmentType', id: string, name: string, codename: string } | null, organisation: { __typename?: 'OrganisationIdNameType', id?: number | null, codename?: string | null, uid?: string | null, name?: string | null } } | null } | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshTokenMutation = { __typename?: 'mutation_root', refresh_token?: { __typename?: 'Refresh', token: string, refresh_token: string } | null };

export type AuthenticatedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthenticatedUserQuery = { __typename?: 'query_root', me?: { __typename?: 'BaseUserType', id: string, permissions?: Array<string | null> | null, is_verified?: boolean | null, first_name: string, last_name: string, full_name?: string | null, email: string, number: string, agent?: { __typename?: 'AgentType', id: string, current_department?: { __typename?: 'DepartmentType', id: string, name: string, codename: string, address?: { __typename?: 'KiteAddressType', id: string, state_region?: { __typename?: 'VillageDataType', id: string, code?: string | null } | null } | null } | null, departments?: Array<{ __typename?: 'AgentDepartmentType', id: string, department?: { __typename?: 'DepartmentType', id: string, name: string, codename: string, address?: { __typename?: 'KiteAddressType', id: string, state_region?: { __typename?: 'VillageDataType', id: string, code?: string | null } | null } | null } | null } | null> | null, organisation: { __typename?: 'OrganisationIdNameType', id?: number | null, uid?: string | null, name?: string | null } } | null, photo?: { __typename?: 'MediaType', id: string, url: string } | null, current_department?: { __typename?: 'DepartmentType', id: string, name: string, codename: string, address?: { __typename?: 'KiteAddressType', id: string, state_region?: { __typename?: 'VillageDataType', id: string, code?: string | null } | null } | null } | null, companies: Array<{ __typename?: 'CompanyType', id: string, name: string, codename: string }> } | null };

export type AllGroupsQueryVariables = Exact<{
  where?: InputMaybe<Auth_Group_Bool_Exp>;
}>;


export type AllGroupsQuery = { __typename?: 'query_root', auth_group: Array<{ __typename?: 'auth_group', id: number, name: string, codename: string }> };

export type BaseUserDisplayFragFragment = { __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, is_blocked?: boolean | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null };

export type BaseUserFragFragment = { __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null };

export type UsersQueryVariables = Exact<{
  groups?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type UsersQuery = { __typename?: 'query_root', base_user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> };

export type AllUsersQueryVariables = Exact<{
  groups?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllUsersQuery = { __typename?: 'query_root', base_user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> };

export type UsersDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UsersDetailQuery = { __typename?: 'query_root', base_user_by_pk?: { __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null } | null };

export type SearchBaseUsersQueryVariables = Exact<{
  groups?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type SearchBaseUsersQuery = { __typename?: 'query_root', base_user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> };

export type SearchBaseUserIdQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type SearchBaseUserIdQuery = { __typename?: 'query_root', base_user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, reference_id: string }> };

export type CancelInvoicesMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type CancelInvoicesMutation = { __typename?: 'mutation_root', cancel_invoice?: { __typename?: 'CancelInvoiceMutation', success?: boolean | null } | null };

export type CreateCreditRequestMutationVariables = Exact<{
  input: CreateCreditWalletRequestInput;
}>;


export type CreateCreditRequestMutation = { __typename?: 'mutation_root', create_credit_wallet_request?: { __typename?: 'CreateCreditWalletRequestMutation', credit_wallet_request?: { __typename?: 'CreditWalletRequestType', id: string } | null } | null };

export type ApproveCreditRequestMutationVariables = Exact<{
  input: ApproveCreditWalletRequestInput;
}>;


export type ApproveCreditRequestMutation = { __typename?: 'mutation_root', approve_credit_wallet_request?: { __typename?: 'ApproveCreditWalletRequestMutation', credit_wallet?: { __typename?: 'CreditWalletType', id: string } | null } | null };

export type CreditWalletDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type CreditWalletDetailQuery = { __typename?: 'query_root', credit_wallet_request_by_pk?: { __typename?: 'credit_wallet_request', id: any, created_at: any, requested_validity: number, approved_start_date?: any | null, requested_credit_limit_factor: any, is_verified?: boolean | null, verified_on?: any | null, approved_end_date?: any | null, approved_total_amount?: any | null, requested_total_amount: any, approved_payment_cycle_days?: number | null, requested_payment_cycle_days: number, financial_year_assessment_cw: Array<{ __typename?: 'financial_year_assessment_cw', id: any, assessed_limit?: any | null, capital: any, current_assets: any, current_liabilities: any, fixed_assets: any, profit_loss: any, total_sales: any, year_id: any, attachment_id?: any | null, financial_year: { __typename?: 'financial_year_cw', name: string, id: any }, attachment?: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } | null }>, projection_assessment_cw: Array<{ __typename?: 'projection_assessment_cw', id: any, assessed_limit?: any | null, credit_wallet_request_id: any, daily_average_sale?: any | null, end_date: any, payment_cycle: number, start_date: any, tenure: number, total_sales?: any | null }>, trade_assessment_cw: Array<{ __typename?: 'trade_assessment_cw', assessed_limit?: any | null, credit_wallet_request_id: any, daily_average_sale?: any | null, end_date: any, id: any, payment_cycle: number, settled_trade_count?: number | null, start_date: any, tenure: number, trade_count?: number | null, unsettled_trade_count?: number | null, total_sales?: any | null }>, credit_wallet: { __typename?: 'credit_wallet', id: any, used_amount: any, remaining_amount: any, user: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id2?: string | null, name?: string | null, my_businesses: Array<{ __typename?: 'business', id: number }>, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> } } } | null };

export type CreditWalletSummaryQueryVariables = Exact<{
  input?: InputMaybe<CreditWalletSummaryAggregatedInput>;
}>;


export type CreditWalletSummaryQuery = { __typename?: 'query_root', credit_wallet_summary_aggregated?: { __typename?: 'CreditWalletSummaryAggregatedType', buyer_count?: number | null, total_credit_limit?: number | null, total_outstanding?: number | null, used_credit_hishob_patti?: number | null, available_credit_limit?: number | null, avg_overdue_days?: string | null } | null };

export type CreditWalletListingQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  created_from?: InputMaybe<Scalars['Date']>;
  created_to?: InputMaybe<Scalars['Date']>;
  verified_by?: InputMaybe<Scalars['ID']>;
}>;


export type CreditWalletListingQuery = { __typename?: 'query_root', credit_wallet_list?: { __typename?: 'CreditWalletListResponseType', total_records?: number | null, results?: Array<{ __typename?: 'CreditWalletListCustomType', id?: string | null, credit_wallet_id?: string | null, created_on?: any | null, verified_on?: any | null, validity?: number | null, validity_start_date?: any | null, validity_end_date?: any | null, credit_limit?: number | null, payment_cycle_days?: number | null, total_exposure?: number | null, actual_exposure?: number | null, shadow_exposure?: number | null, credit_limit_available?: number | null, last_transaction_date?: any | null, last_transaction_value?: number | null, overdue_amount?: number | null, avg_overdue_days?: string | null, deviation_amount_requested?: number | null, deviation_os_approved?: number | null, status?: string | null, status_metadata?: any | null, buyer?: { __typename?: 'UserCustomType', id?: string | null, name?: string | null } | null, credit_limit_approved_by?: { __typename?: 'UserCustomType', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type BuyerCreditWalletInfoSummaryQueryVariables = Exact<{
  userId: Scalars['ID'];
  tradeId?: InputMaybe<Scalars['ID']>;
  deptId?: InputMaybe<Scalars['ID']>;
}>;


export type BuyerCreditWalletInfoSummaryQuery = { __typename?: 'query_root', buyer_credit_wallet_info?: { __typename?: 'BuyerCreditWalletInfoType', department_settlement_total_amount?: number | null, department_settlement_settled_amount?: number | null, department_settlement_remaining_amount?: number | null, credit_limit?: number | null, total_exposure?: number | null, actual_exposure?: number | null, shadow_exposure?: number | null, credit_limit_available?: number | null, overdue_amount?: number | null, avg_overdue_days?: string | null, requested_overdue_approval_count?: number | null, last_overdue_approval_count?: number | null, used_overdraft?: number | null, requested_overdraft_count?: number | null, unsettled_overdraft_count?: number | null, parent_consumed?: number | null, current_trade_consumed?: number | null, dynamic_available?: number | null, overdraft_count?: number | null, overdue_count?: number | null, latest_verified_credit_wallet_request_id?: string | null, credit_wallet_id?: string | null } | null };

export type CreditRequestHistoryQueryVariables = Exact<{
  where?: InputMaybe<Credit_Request_Bool_Exp>;
  orderBy?: InputMaybe<Array<Credit_Request_Order_By> | Credit_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type CreditRequestHistoryQuery = { __typename?: 'query_root', credit_request: Array<{ __typename?: 'credit_request', id: any, created_at: any, requested_date: any, requested_total_amount: any, requested_validity: number, requested_payment_cycle_days: number, verified_on?: any | null, approved_total_amount?: any | null, approved_validity?: number | null, approved_end_date?: any | null, approved_payment_cycle_days?: number | null, requested_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, extra_data?: Array<{ __typename?: 'CreditRequestDetailType', verified_by_custom?: { __typename?: 'VerifiedByCustomType', name?: string | null } | null } | null> | null }>, credit_request_aggregate: { __typename?: 'credit_request_aggregate', aggregate?: { __typename?: 'credit_request_aggregate_fields', count: number } | null } };

export type CreditAggregateQueryVariables = Exact<{
  input: CreditSummaryAggregatedInput;
}>;


export type CreditAggregateQuery = { __typename?: 'query_root', credit_summary_aggregated?: { __typename?: 'CreditSummaryAggregatedType', buyer_count?: number | null, total_credit_limit?: number | null, total_outstanding?: number | null, used_credit_hishob_patti?: number | null, available_credit_limit?: number | null, avg_overdue_days?: string | null } | null };

export type CreditAnalyticsQueryVariables = Exact<{
  where?: InputMaybe<Credit_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  overDraftWhere?: InputMaybe<Over_Draft_Bool_Exp>;
}>;


export type CreditAnalyticsQuery = { __typename?: 'query_root', credit: Array<{ __typename?: 'credit', id: any, total_amount: any, used_amount: any, remaining_amount: any, devCount: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number, sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, over_drafts_aggregate: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, approved: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number, sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, requested: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number, sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, extra_data?: Array<{ __typename?: 'CreditCustomType', overdue_amount?: number | null, used_credit_hishob_patti?: number | null, used_credit_booking_patti?: number | null, avg_overdue_days?: string | null } | null> | null }> };

export type AllCreditsQueryVariables = Exact<{
  where?: InputMaybe<Credit_Bool_Exp>;
  orderBy?: InputMaybe<Array<Credit_Order_By> | Credit_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AllCreditsQuery = { __typename?: 'query_root', credit: Array<{ __typename?: 'credit', id: any, created_at: any, validity: number, metadata: any, start_date?: any | null, is_verified?: boolean | null, verified_on?: any | null, end_date?: any | null, total_amount: any, payment_cycle_days: number, used_amount: any, remaining_amount: any, approved: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number, sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, requested: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number, sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, verified_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, user: { __typename?: 'setu_trade_shared_entity', id: any, name: string, user: Array<{ __typename?: 'base_user', id: number, external_reference_id2?: string | null, number: string, name?: string | null }> }, status: { __typename?: 'credit_status', id: string, is_actionable: boolean, is_credit_active: boolean, metadata?: any | null }, extra_data?: Array<{ __typename?: 'CreditCustomType', used_credit_booking_patti?: number | null, used_credit_hishob_patti?: number | null, last_transaction_date?: any | null, last_transaction_value?: number | null, overdue_amount?: number | null, avg_overdue_days?: string | null } | null> | null }>, credit_aggregate: { __typename?: 'credit_aggregate', aggregate?: { __typename?: 'credit_aggregate_fields', count: number } | null } };

export type CreditsSummaryQueryVariables = Exact<{
  where?: InputMaybe<Credit_Bool_Exp>;
  orderBy?: InputMaybe<Array<Credit_Order_By> | Credit_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type CreditsSummaryQuery = { __typename?: 'query_root', credit: Array<{ __typename?: 'credit', id: any, created_at: any, validity: number, metadata: any, start_date?: any | null, is_verified?: boolean | null, verified_on?: any | null, end_date?: any | null, total_amount: any, payment_cycle_days: number, used_amount: any, remaining_amount: any, remark: Array<{ __typename?: 'credit_request', id: any, remark?: string | null }>, approved: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number, sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, requested: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number, sum?: { __typename?: 'over_draft_sum_fields', outstanding_amount?: any | null } | null } | null }, summary?: Array<{ __typename?: 'CreditSummaryType', avg_payment_settlement_days?: number | null, hishob_patti_count?: number | null, hishob_patti_settled_count?: number | null, hishob_patti_unsettled_count?: number | null, profit_loss?: number | null, total_hishob_patti_sale?: number | null, total_sales?: number | null } | null> | null, verified_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, user: { __typename?: 'setu_trade_shared_entity', id: any, name: string, user: Array<{ __typename?: 'base_user', id: number, external_reference_id2?: string | null, number: string, secondary_number: string, name?: string | null, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> }, extra_data?: Array<{ __typename?: 'CreditCustomType', avg_overdue_days?: string | null, last_transaction_value?: number | null, last_transaction_date?: any | null, overdue_amount?: number | null, used_credit_hishob_patti?: number | null, used_credit_booking_patti?: number | null } | null> | null, updated_by?: { __typename?: 'base_user', id: number, name?: string | null } | null, created_by?: { __typename?: 'base_user', id: number, reference_id: string, external_reference_id2?: string | null, name?: string | null } | null, status: { __typename?: 'credit_status', id: string, is_actionable: boolean, is_credit_active: boolean, metadata?: any | null } }>, credit_aggregate: { __typename?: 'credit_aggregate', aggregate?: { __typename?: 'credit_aggregate_fields', count: number } | null } };

export type CreditStatusQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type CreditStatusQuery = { __typename?: 'query_root', credit_by_pk?: { __typename?: 'credit', id: any, status: { __typename?: 'credit_status', id: string, is_actionable: boolean, is_credit_active: boolean, metadata?: any | null } } | null };

export type CreditDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type CreditDetailQuery = { __typename?: 'query_root', credit_by_pk?: { __typename?: 'credit', id: any, created_at: any, validity: number, start_date?: any | null, credit_limit_factor: any, is_verified?: boolean | null, verified_on?: any | null, end_date?: any | null, total_amount: any, payment_cycle_days: number, used_amount: any, remaining_amount: any, verified_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, summary?: Array<{ __typename?: 'CreditSummaryType', avg_payment_settlement_days?: number | null, hishob_patti_count?: number | null, hishob_patti_settled_count?: number | null, hishob_patti_unsettled_count?: number | null, profit_loss?: number | null, total_hishob_patti_sale?: number | null, total_sales?: number | null } | null> | null, user: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string, user: Array<{ __typename?: 'base_user', id: number, number: string, external_reference_id2?: string | null, name?: string | null, my_businesses: Array<{ __typename?: 'business', id: number }>, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string } }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null } | null }> }, extra_data?: Array<{ __typename?: 'CreditCustomType', avg_overdue_days?: string | null, last_transaction_value?: number | null, last_transaction_date?: any | null, overdue_amount?: number | null, used_credit_hishob_patti?: number | null, used_credit_booking_patti?: number | null } | null> | null, updated_by?: { __typename?: 'base_user', id: number, name?: string | null } | null, created_by?: { __typename?: 'base_user', id: number, reference_id: string, external_reference_id2?: string | null, name?: string | null } | null, status: { __typename?: 'credit_status', id: string, is_actionable: boolean, is_credit_active: boolean, metadata?: any | null }, financial_year_assessments: Array<{ __typename?: 'financial_year_assessment', id: any, assessed_limit?: any | null, capital: any, current_assets: any, current_liabilities: any, fixed_assets: any, profit_loss: any, total_sales: any, year_id: any, attachment_id?: any | null, year: { __typename?: 'financial_year', name: string, id: any }, attachment?: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } | null }>, projection_assessments: Array<{ __typename?: 'projection_assessment', id: any, assessed_limit?: any | null, credit_id: any, daily_average_sale?: any | null, end_date: any, payment_cycle: number, start_date: any, tenure: number, total_sales?: any | null }>, trade_assessments: Array<{ __typename?: 'trade_assessment', assessed_limit?: any | null, credit_id: any, daily_average_sale?: any | null, end_date: any, id: any, payment_cycle: number, settled_trade_count?: number | null, start_date: any, tenure: number, trade_count?: number | null, unsettled_trade_count?: number | null, total_sales?: any | null }> } | null };

export type AddUpdateCreditAssessmentMutationVariables = Exact<{
  input?: InputMaybe<AddUpdateCreditMutationInput>;
}>;


export type AddUpdateCreditAssessmentMutation = { __typename?: 'mutation_root', add_update_credit_assessment?: { __typename?: 'AddUpdateCreditMutation', credit?: { __typename?: 'CreditType', id: string } | null } | null };

export type ApproveCreditLimitMutationVariables = Exact<{
  input?: InputMaybe<ApproveCreditMutationInput>;
}>;


export type ApproveCreditLimitMutation = { __typename?: 'mutation_root', approve_credit?: { __typename?: 'ApproveCreditMutation', credit?: { __typename?: 'CreditType', id: string } | null } | null };

export type AllFinancialYearsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllFinancialYearsQuery = { __typename?: 'query_root', financial_year_cw: Array<{ __typename?: 'financial_year_cw', id: any, from_year: number, to_year: number, name: string }> };

export type InvoiceAggregateQueryVariables = Exact<{
  where?: InputMaybe<Invoice_Bool_Exp>;
}>;


export type InvoiceAggregateQuery = { __typename?: 'query_root', invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', sum?: { __typename?: 'invoice_sum_fields', deducted_amount?: any | null } | null } | null } };

export type CreateOverDraftMutationVariables = Exact<{
  tradeId: Scalars['ID'];
}>;


export type CreateOverDraftMutation = { __typename?: 'mutation_root', create_over_draft_request?: { __typename?: 'CreateOverDraftRequest', over_draft?: { __typename?: 'OverDraftType', id: string, amount: number } | null } | null };

export type AllCreditStatusQueryVariables = Exact<{
  where?: InputMaybe<Credit_Status_Bool_Exp>;
}>;


export type AllCreditStatusQuery = { __typename?: 'query_root', credit_status: Array<{ __typename?: 'credit_status', id: string }> };

export type UpdateCreditStatusMutationVariables = Exact<{
  input?: InputMaybe<ChangeCreditStatusInput>;
}>;


export type UpdateCreditStatusMutation = { __typename?: 'mutation_root', change_credit_status?: { __typename?: 'ChangeCreditStatus', credit?: { __typename?: 'CreditType', id: string } | null } | null };

export type TradeAssessmentDynamicQueryVariables = Exact<{
  input?: InputMaybe<TradeAssessmentDynamicInput>;
}>;


export type TradeAssessmentDynamicQuery = { __typename?: 'query_root', trade_assessment_dynamic?: { __typename?: 'TradeAssessmentDynamicType', trade_count?: number | null, settled_trade_count?: number | null, unsettled_trade_count?: number | null, total_sales?: number | null, daily_average_sale?: number | null, assessed_limit?: number | null } | null };

export type DemandEnquiriesQueryVariables = Exact<{
  where?: InputMaybe<Demand_Enquiries_Bool_Exp>;
  orderBy?: InputMaybe<Array<Demand_Enquiries_Order_By> | Demand_Enquiries_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type DemandEnquiriesQuery = { __typename?: 'query_root', demand_enquiries: Array<{ __typename?: 'demand_enquiries', id: any, status: string, created_at: any, updated_at: any, whatsapp_status: string, demand: { __typename?: 'demand', id: any, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_verified?: boolean | null, external_reference_id2?: string | null, name?: string | null, codename: string }> } | null, seller_external?: { __typename?: 'unregistered_user', id: any, first_name: string, last_name?: string | null, number: string, user?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', external_reference_id2?: string | null, is_verified?: boolean | null, name?: string | null, codename: string }> } | null } | null }>, demand_enquiries_aggregate: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null } };

export type DemandHeaderSummaryQueryVariables = Exact<{
  materialKind?: InputMaybe<Scalars['String']>;
}>;


export type DemandHeaderSummaryQuery = { __typename?: 'query_root', active_demand: { __typename?: 'demand_aggregate', aggregate?: { __typename?: 'demand_aggregate_fields', count: number } | null }, closed_demand: { __typename?: 'demand_aggregate', aggregate?: { __typename?: 'demand_aggregate_fields', count: number } | null }, total_seller_enquiries: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, total_seller_enquiries_actioned: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, total_seller_enquiries_pending: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null } };

export type DemandWhatsAppSummaryQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DemandWhatsAppSummaryQuery = { __typename?: 'query_root', demand_by_pk?: { __typename?: 'demand', id: any, messages_pending: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, messages_sent: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, messages_delivered: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, messages_read: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, total_enquiries: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null } } | null };

export type UpsertDemandMutationVariables = Exact<{
  input: UpsertDemandInput;
}>;


export type UpsertDemandMutation = { __typename?: 'mutation_root', add_update_demand?: { __typename?: 'AddUpdateDemandMutation', demand?: { __typename?: 'DemandType', id: string } | null } | null };

export type CloseDemandMutationVariables = Exact<{
  set?: InputMaybe<Demand_Set_Input>;
  where: Demand_Bool_Exp;
}>;


export type CloseDemandMutation = { __typename?: 'mutation_root', update_demand?: { __typename?: 'demand_mutation_response', affected_rows: number } | null };

export type DemandsListQueryVariables = Exact<{
  where?: InputMaybe<Demand_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Demand_Order_By> | Demand_Order_By>;
}>;


export type DemandsListQuery = { __typename?: 'query_root', demand: Array<{ __typename?: 'demand', id: any, created_at: any, status: string, rate: any, max_rate?: any | null, quantity: any, deducted_amount: any, total_amount: any, start_date_time: any, end_date_time: any, sauda_qty: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null }, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', full_name?: string | null, external_reference_id2?: string | null }> } | null, total_enuiry: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, successful_enuiry: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, trades_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null } }>, demand_aggregate: { __typename?: 'demand_aggregate', aggregate?: { __typename?: 'demand_aggregate_fields', count: number } | null } };

export type DemandCoreFragFragment = { __typename?: 'demand', id: any, status: string, created_at: any, material_kind?: string | null, mode: string, packaging: string, rate: any, max_rate?: any | null, quantity: any, total_amount: any, seller_source_kind: string, start_date_time: any, end_date_time: any, standard_deduction: any, deducted_amount: any, seller_tnc?: string | null, buyer_tnc?: string | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, jr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, sr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, commodity: Array<{ __typename?: 'commodity', id: number, crop_id?: number | null, codename: string, name: string }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, codename: string, name: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, attachments: Array<{ __typename?: 'demand_attachments', id: any, send_whatsapp: boolean, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }>, expenses: Array<{ __typename?: 'demand_expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, trade_qty_used: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null } };

export type DemandDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DemandDetailQuery = { __typename?: 'query_root', demand_by_pk?: { __typename?: 'demand', id: any, status: string, created_at: any, material_kind?: string | null, mode: string, packaging: string, rate: any, max_rate?: any | null, quantity: any, total_amount: any, seller_source_kind: string, start_date_time: any, end_date_time: any, standard_deduction: any, deducted_amount: any, seller_tnc?: string | null, buyer_tnc?: string | null, demand_seller_groups: Array<{ __typename?: 'demand_seller_groups', id: any, seller_groups: { __typename?: 'setu_trade_shared_entity', id: any, name: string, group_id?: any | null } }>, total_enquiries: { __typename?: 'demand_enquiries_aggregate', aggregate?: { __typename?: 'demand_enquiries_aggregate_fields', count: number } | null }, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, jr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, sr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, commodity: Array<{ __typename?: 'commodity', id: number, crop_id?: number | null, codename: string, name: string }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, codename: string, name: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, attachments: Array<{ __typename?: 'demand_attachments', id: any, send_whatsapp: boolean, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }>, expenses: Array<{ __typename?: 'demand_expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, trade_qty_used: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null } } | null };

export type DemandSellerDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
  sellerId: Scalars['bigint'];
}>;


export type DemandSellerDetailQuery = { __typename?: 'query_root', demand_by_pk?: { __typename?: 'demand', id: any, status: string, created_at: any, material_kind?: string | null, mode: string, packaging: string, rate: any, max_rate?: any | null, quantity: any, total_amount: any, seller_source_kind: string, start_date_time: any, end_date_time: any, standard_deduction: any, deducted_amount: any, seller_tnc?: string | null, buyer_tnc?: string | null, enquiries: Array<{ __typename?: 'demand_enquiries', id: any, status: string, created_at: any, updated_at: any, whatsapp_status: string, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null }>, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, jr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, sr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, commodity: Array<{ __typename?: 'commodity', id: number, crop_id?: number | null, codename: string, name: string }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, codename: string, name: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, attachments: Array<{ __typename?: 'demand_attachments', id: any, send_whatsapp: boolean, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }>, expenses: Array<{ __typename?: 'demand_expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, trade_qty_used: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null } } | null };

export type AllDepartmentsQueryVariables = Exact<{
  where?: InputMaybe<Department_Bool_Exp>;
}>;


export type AllDepartmentsQuery = { __typename?: 'query_root', department: Array<{ __typename?: 'department', name: string, display_name: string, abbreviation: string, primaryKey: number, id: string }> };

export type AllDepotsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllDepotsQuery = { __typename?: 'query_root', all_depots?: Array<{ __typename?: 'DepotGlType', id: string, name: string, codename: string } | null> | null };

export type ExpenseFragFragment = { __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } };

export type DeleteExpenseItemMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
}>;


export type DeleteExpenseItemMutation = { __typename?: 'mutation_root', delete_expense?: { __typename?: 'expense_mutation_response', returning: Array<{ __typename?: 'expense', id: any, trade?: { __typename?: 'trade', id: any, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }> } | null }> } | null };

export type FinalAnalyticsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']>;
  till?: InputMaybe<Scalars['Date']>;
  filters?: InputMaybe<AnalyticalQueryFilterInput>;
}>;


export type FinalAnalyticsQuery = { __typename?: 'query_root', final_analytics?: Array<{ __typename?: 'AnalyticalDepartmentType', id?: string | null, name?: string | null, reference_id?: string | null, trades?: Array<{ __typename?: 'AnalyticalTradeType', kind?: string | null, total_transactions?: number | null, total_quantity?: number | null, total_value?: number | null, unverified_transactions?: number | null, unverified_quantity?: number | null, unverified_value?: number | null, verified_transactions?: number | null, verified_quantity?: number | null, verified_value?: number | null, total_invoices?: number | null, invoice_quantity?: number | null, invoice_value?: number | null, pending_invoices?: number | null, total_inwards?: number | null, inward_quantity?: number | null, inward_value?: number | null, pending_inwards?: number | null, final_conversion_count?: number | null, final_conversion_pending_count?: number | null } | null> | null } | null> | null };

export type AllInvoicesQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Invoice_Select_Column> | Invoice_Select_Column>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
  where?: InputMaybe<Invoice_Bool_Exp>;
}>;


export type AllInvoicesQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: any, status_processing: boolean, tracking_code: string, total_amount?: any | null, total_quantity?: any | null, created_at: any, updated_at: any, current_status_id?: string | null, twilio_message?: { __typename?: 'trade_twiliomessages', id: string, status?: string | null } | null, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, credit: Array<{ __typename?: 'issuance_note', id: any, is_verified?: boolean | null }>, debit: Array<{ __typename?: 'issuance_note', id: any, is_verified?: boolean | null }>, created_by?: { __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, is_blocked?: boolean | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, is_blocked?: boolean | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null, unit: Array<{ __typename?: 'trade', id: any, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }> }>, trades: Array<{ __typename?: 'trade', id: any, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', returned_quantity?: any | null } | null } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, is_blocked?: boolean | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null }> }>, invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number } | null } };

export type AllInvoiceStatusesSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Invoice_Select_Column> | Invoice_Select_Column>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
  where?: InputMaybe<Invoice_Bool_Exp>;
}>;


export type AllInvoiceStatusesSubscription = { __typename?: 'subscription_root', invoice: Array<{ __typename?: 'invoice', id: any, current_status_id?: string | null, status_processing: boolean, twilio_message?: { __typename?: 'trade_twiliomessages', id: string, status?: string | null } | null }> };

export type GenerateInvoicesMutationVariables = Exact<{
  department_id?: InputMaybe<Scalars['ID']>;
  trade_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GenerateInvoicesMutation = { __typename?: 'mutation_root', generate_invoices?: { __typename?: 'GenerateInvoiceMutation', invoices?: Array<{ __typename?: 'InvoiceType', id: string } | null> | null } | null };

export type BulkUpdateInvoiceMutationVariables = Exact<{
  where: Invoice_Bool_Exp;
  set: Invoice_Set_Input;
}>;


export type BulkUpdateInvoiceMutation = { __typename?: 'mutation_root', update_invoice?: { __typename?: 'invoice_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'invoice', id: any, current_status_id?: string | null, status_processing: boolean }> } | null };

export type InvoicePreviewQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type InvoicePreviewQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename?: 'invoice', id: any, tracking_code: string, standard_deduction?: any | null, expense_amount?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, is_blocked?: boolean | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, trades: Array<{ __typename?: 'trade', id: any, supplier_charge?: any | null, total_quantity?: any | null, total_amount?: any | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, is_blocked?: boolean | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, amount?: any | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }> }> }> } | null };

export type AllInvoiceIssuanceNotesQueryVariables = Exact<{
  invoiceId: Scalars['bigint'];
}>;


export type AllInvoiceIssuanceNotesQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename: 'invoice', id: any, quantity_revised: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, buyer_credit: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, buyer_credit_pending: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, buyer_debit: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, buyer_debit_pending: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null } } | null };

export type InvoiceIssuanceNotesQueryVariables = Exact<{
  invoiceId: Scalars['bigint'];
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
  orderBy?: InputMaybe<Array<Issuance_Note_Order_By> | Issuance_Note_Order_By>;
}>;


export type InvoiceIssuanceNotesQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename?: 'invoice', id: any, total_amount?: any | null, buyer_payable?: number | null, created_at: any, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, trades: Array<{ __typename?: 'trade', id: any, receipt_id?: any | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, name: string, tax_name: string, role: string, percentage: any }>, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, returned_quantity?: any | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, taxes: Array<{ __typename?: 'trade_taxes', id: any, percentage: any, tax_name: string }> }> }>, issuance_notes: Array<{ __typename?: 'issuance_note', id: any, amount: any, created_at: any, created_by_id: string, is_verified?: boolean | null, kind: string, remarks?: string | null, type: string, input_value?: any | null, user_role: string, verification_remark?: string | null, verified_by_id?: string | null, verified_on?: any | null, taxes: Array<{ __typename?: 'issuance_note_taxes', id: any, amount?: any | null, name: string, tax_name: string, percentage: any }>, items: Array<{ __typename?: 'trade_issuancenoteitems', id: any, input_value?: any | null, amount: any, trade_item_id?: any | null, trade_item?: { __typename?: 'trade_item', id: any, rate: any, quantity: any, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } } | null, taxes: Array<{ __typename?: 'issuance_note_item_taxes', id: any, amount?: any | null, percentage: any, tax_name: string }> }>, attachments: Array<{ __typename?: 'issuance_note_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }> }>, issuance_notes_aggregate: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null } } | null };

export type InvoiceSettlementQueryVariables = Exact<{
  where?: InputMaybe<Invoice_Bool_Exp>;
  orderBy?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type InvoiceSettlementQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', created_at: any, id: any, remark?: string | null, current_status_id?: string | null, metadata?: any | null, buyer_settlement_status?: string | null, buyer_payable?: number | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, issuance_notes_aggregate: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, trades: Array<{ __typename?: 'trade', id: any, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }> }>, summary?: Array<{ __typename?: 'InvoiceSummaryType', buyer_credit_note_amount?: number | null, buyer_debit_note_amount?: number | null } | null> | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', full_name?: string | null, external_reference_id2?: string | null, number: string, secondary_number: string }> } | null, transactions_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null }, transactions: Array<{ __typename?: 'transaction', id: any, date: any, remark?: string | null, created_at: any }> }>, invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number, sum?: { __typename?: 'invoice_sum_fields', deducted_amount?: any | null } | null } | null } };

export type InvoiceSettlementSelectorQueryVariables = Exact<{
  where?: InputMaybe<Invoice_Bool_Exp>;
  orderBy?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type InvoiceSettlementSelectorQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', created_at: any, id: any, buyer_settlement_status?: string | null, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null }>, invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number, sum?: { __typename?: 'invoice_sum_fields', deducted_amount?: any | null } | null } | null } };

export type CreditInvoiceSettlementQueryVariables = Exact<{
  where?: InputMaybe<Invoice_Bool_Exp>;
  orderBy?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type CreditInvoiceSettlementQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', created_at: any, id: any, current_status_id?: string | null, buyer_payable?: number | null, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, summary?: Array<{ __typename?: 'InvoiceSummaryType', overdue_amount?: number | null, overdue_days?: number | null } | null> | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, transactions_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null }, transactions: Array<{ __typename?: 'transaction', id: any, date: any, remark?: string | null, created_at: any }> }>, invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number, sum?: { __typename?: 'invoice_sum_fields', deducted_amount?: any | null } | null } | null } };

export type InvoiceSettlementAggregateQueryVariables = Exact<{
  where?: InputMaybe<Invoice_Bool_Exp>;
  orderBy?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type InvoiceSettlementAggregateQuery = { __typename?: 'query_root', invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number } | null } };

export type InvoiceSummaryAggregateQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
  placedBy?: InputMaybe<Scalars['ID']>;
}>;


export type InvoiceSummaryAggregateQuery = { __typename?: 'query_root', invoice_summary_by_user?: { __typename?: 'InvoiceSummaryByUserType', department_settlement_total_amount?: number | null, department_settlement_settled_amount?: number | null, department_settlement_remaining_amount?: number | null, total_invoice_amount?: number | null, received_amount?: number | null, overdue_amount?: number | null, overdue_days?: number | null, payment_cleared_in_days?: number | null } | null };

export type InvoiceSettlementDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type InvoiceSettlementDetailQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename?: 'invoice', created_at: any, id: any, remark?: string | null, buyer_payable?: number | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string, reference_id: string }, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, pending_issuance_note_bool: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null }, summary?: Array<{ __typename?: 'InvoiceSummaryType', buyer_credit_note_amount?: number | null, buyer_debit_note_amount?: number | null } | null> | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null }> } | null, transactions_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null }, transactions: Array<{ __typename?: 'transaction', id: any, date: any, remark?: string | null, created_at: any, amount: any, transaction_id: string, parent_transaction?: { __typename?: 'transaction', id: any, transaction_id: string } | null, attachments: Array<{ __typename?: 'transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, mode: { __typename?: 'Transaction_mode', id: any, codename: string, name: string } }> } | null };

export type InvoiceSettlementDetailOverduesQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type InvoiceSettlementDetailOverduesQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename?: 'invoice', summary?: Array<{ __typename?: 'InvoiceSummaryType', overdue_amount?: number | null, overdue_days?: number | null } | null> | null } | null };

export type UpdateInvoiceSettlementPaymentMutationVariables = Exact<{
  id: Scalars['bigint'];
  object?: InputMaybe<Invoice_Set_Input>;
}>;


export type UpdateInvoiceSettlementPaymentMutation = { __typename?: 'mutation_root', update_invoice_by_pk?: { __typename?: 'invoice', id: any, remark?: string | null } | null };

export type InvoiceSettlementTransactionsQueryVariables = Exact<{
  dept: Scalars['ID'];
  user: Scalars['ID'];
  kind: DepartmentSettlementKind;
}>;


export type InvoiceSettlementTransactionsQuery = { __typename?: 'query_root', transactions_for_invoice_settlement?: Array<{ __typename?: 'TransactionType', id: string, transaction_id: string, amount: number, remaining_amount?: number | null } | null> | null };

export type MapInvoiceTransactionsMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  transactions: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  remark?: InputMaybe<Scalars['String']>;
}>;


export type MapInvoiceTransactionsMutation = { __typename?: 'mutation_root', map_invoice_transaction?: { __typename?: 'MapInvoiceTransactionMutation', invoice?: { __typename?: 'InvoiceType', id: string, invoice_transactions: Array<{ __typename?: 'TransactionType', id: string, amount: number }> } | null } | null };

export type BuyerOverAllOutstandingQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['bigint']>;
}>;


export type BuyerOverAllOutstandingQuery = { __typename?: 'query_root', credit_transaction_aggregate: { __typename?: 'credit_transaction_aggregate', aggregate?: { __typename?: 'credit_transaction_aggregate_fields', sum?: { __typename?: 'credit_transaction_sum_fields', outstanding_amount?: any | null } | null } | null } };

export type InvoiceSummaryAnalyticsQueryVariables = Exact<{
  createdById?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  createdFrom?: InputMaybe<Scalars['Date']>;
  createdTill?: InputMaybe<Scalars['Date']>;
  department?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  buyerReferenceId?: InputMaybe<Scalars['String']>;
}>;


export type InvoiceSummaryAnalyticsQuery = { __typename?: 'query_root', aggregate_invoice_summary?: { __typename?: 'AggregateInvoiceSummaryType', department_settlement_total_amount?: number | null, department_settlement_settled_amount?: number | null, department_settlement_remaining_amount?: number | null, total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null };

export type AddUpdateIssuanceNotesMutationVariables = Exact<{
  input?: InputMaybe<IssuanceNoteInput>;
}>;


export type AddUpdateIssuanceNotesMutation = { __typename?: 'mutation_root', add_update_issuance_note?: { __typename?: 'AddUpdateIssuanceNoteMutation', issuance_note?: { __typename?: 'IssuanceNoteType', id: string, amount: any, created_at: any, created_by_id: string, is_verified?: boolean | null, kind: TradeIssuanceNoteKindChoices, remarks?: string | null, type: TradeIssuanceNoteTypeChoices, input_value?: any | null, user_role: TradeIssuanceNoteUserRoleChoices, verification_remark?: string | null, verified_by_id?: string | null, verified_on?: any | null } | null } | null };

export type RecordTradeInvoiceReturnMutationVariables = Exact<{
  items: Array<InputMaybe<RecordReturnQuantityInput>> | InputMaybe<RecordReturnQuantityInput>;
}>;


export type RecordTradeInvoiceReturnMutation = { __typename?: 'mutation_root', record_trade_return?: { __typename?: 'RecordTradeReturnMutation', affected_rows?: number | null } | null };

export type TradeIssuanceNotesQueryVariables = Exact<{
  tradeId: Scalars['bigint'];
  where?: InputMaybe<Issuance_Note_Bool_Exp>;
  orderBy?: InputMaybe<Array<Issuance_Note_Order_By> | Issuance_Note_Order_By>;
}>;


export type TradeIssuanceNotesQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, total_amount?: any | null, seller_payable?: number | null, buyer_payable?: number | null, created_at: any, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, name: string, tax_name: string, role: string, percentage: any }>, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, returned_quantity?: any | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, taxes: Array<{ __typename?: 'trade_taxes', id: any, percentage: any, tax_name: string }> }>, issuance_notes: Array<{ __typename?: 'issuance_note', id: any, amount: any, created_at: any, created_by_id: string, is_verified?: boolean | null, kind: string, remarks?: string | null, type: string, input_value?: any | null, user_role: string, verification_remark?: string | null, verified_by_id?: string | null, verified_on?: any | null, items: Array<{ __typename?: 'trade_issuancenoteitems', id: any, input_value?: any | null, amount: any, trade_item_id?: any | null, taxes: Array<{ __typename?: 'issuance_note_item_taxes', id: any, amount?: any | null, percentage: any, tax_name: string }>, trade_item?: { __typename?: 'trade_item', id: any, rate: any, quantity: any, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } } | null, attachments: Array<{ __typename?: 'trade_issuancenoteitems_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }> }>, taxes: Array<{ __typename?: 'issuance_note_taxes', id: any, amount?: any | null, name: string, tax_name: string, percentage: any }>, attachments: Array<{ __typename?: 'issuance_note_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }> }> } | null };

export type AllTradeIssuanceNotesQueryVariables = Exact<{
  tradeId: Scalars['bigint'];
}>;


export type AllTradeIssuanceNotesQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, seller_credit: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, seller_credit_pending: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, seller_debit: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null }, seller_debit_pending: { __typename?: 'issuance_note_aggregate', aggregate?: { __typename?: 'issuance_note_aggregate_fields', count: number } | null } } | null };

export type TradeMetricsQueryVariables = Exact<{
  kind?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['bigint']>;
  parent?: InputMaybe<Bigint_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
}>;


export type TradeMetricsQuery = { __typename?: 'query_root', trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number, sum?: { __typename?: 'trade_sum_fields', total_amount?: any | null, total_quantity?: any | null, expense_amount?: any | null } | null } | null } };

export type MixAnalyticsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']>;
  till?: InputMaybe<Scalars['Date']>;
  filters?: InputMaybe<AnalyticalQueryFilterInput>;
}>;


export type MixAnalyticsQuery = { __typename?: 'query_root', mix_analytics?: Array<{ __typename?: 'AnalyticalDepartmentType', id?: string | null, name?: string | null, reference_id?: string | null, trades?: Array<{ __typename?: 'AnalyticalTradeType', kind?: string | null, total_transactions?: number | null, total_quantity?: number | null, total_value?: number | null, unverified_transactions?: number | null, unverified_quantity?: number | null, unverified_value?: number | null, verified_transactions?: number | null, verified_quantity?: number | null, verified_value?: number | null, final_conversion_count?: number | null, final_conversion_pending_count?: number | null } | null> | null } | null> | null };

export type OfferEnquiriesQueryVariables = Exact<{
  where?: InputMaybe<Offer_Enquiries_Bool_Exp>;
  orderBy?: InputMaybe<Array<Offer_Enquiries_Order_By> | Offer_Enquiries_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type OfferEnquiriesQuery = { __typename?: 'query_root', offer_enquiries: Array<{ __typename?: 'offer_enquiries', id: any, status: string, created_at: any, updated_at: any, whatsapp_status: string, offer: { __typename?: 'offers', id: any, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null }, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_verified?: boolean | null, external_reference_id2?: string | null, name?: string | null, codename: string }> } | null, buyer_external?: { __typename?: 'unregistered_user', id: any, first_name: string, last_name?: string | null, number: string, user?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', external_reference_id2?: string | null, is_verified?: boolean | null, name?: string | null, codename: string }> } | null } | null }>, offer_enquiries_aggregate: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null } };

export type OfferHeaderSummaryQueryVariables = Exact<{
  materialKind?: InputMaybe<Scalars['String']>;
}>;


export type OfferHeaderSummaryQuery = { __typename?: 'query_root', active_offer: { __typename?: 'offers_aggregate', aggregate?: { __typename?: 'offers_aggregate_fields', count: number } | null }, closed_offer: { __typename?: 'offers_aggregate', aggregate?: { __typename?: 'offers_aggregate_fields', count: number } | null }, total_buyer_enquiries: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, total_buyer_enquiries_actioned: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, total_buyer_enquiries_pending: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null } };

export type OfferWhatsAppSummaryQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type OfferWhatsAppSummaryQuery = { __typename?: 'query_root', offers_by_pk?: { __typename?: 'offers', id: any, messages_pending: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, messages_sent: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, messages_delivered: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, messages_read: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, total_enquiries: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null } } | null };

export type UpsertOfferMutationMutationVariables = Exact<{
  input: UpsertOfferInput;
}>;


export type UpsertOfferMutationMutation = { __typename?: 'mutation_root', add_update_offer?: { __typename?: 'AddUpdateOfferMutation', offer?: { __typename?: 'OfferType', id: string } | null } | null };

export type UseOfferStockForOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  tradeId: Scalars['ID'];
}>;


export type UseOfferStockForOrderMutation = { __typename?: 'mutation_root', use_offer_stock?: { __typename?: 'UseOfferStockMutation', offer?: { __typename?: 'OfferType', id: string } | null } | null };

export type CloseOfferMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type CloseOfferMutation = { __typename?: 'mutation_root', update_offer_status?: { __typename?: 'OfferUpdateStatus', offer?: { __typename?: 'OfferType', id: string } | null } | null };

export type OffersListQueryVariables = Exact<{
  where?: InputMaybe<Offers_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Offers_Order_By> | Offers_Order_By>;
}>;


export type OffersListQuery = { __typename?: 'query_root', offers: Array<{ __typename?: 'offers', id: any, created_at: any, status: string, rate: any, max_rate?: any | null, deducted_amount: any, total_amount: any, quantity: any, start_date_time: any, end_date_time: any, order_qty: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null }, hishob_qty: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', full_name?: string | null, external_reference_id2?: string | null }> } | null, total_enuiry: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, successful_enuiry: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null }>, offers_aggregate: { __typename?: 'offers_aggregate', aggregate?: { __typename?: 'offers_aggregate_fields', count: number } | null } };

export type OfferCoreFragFragment = { __typename?: 'offers', id: any, status: string, created_at: any, material_kind?: string | null, mode: string, rate: any, max_rate?: any | null, quantity: any, total_amount: any, buyer_source_kind: string, start_date_time: any, end_date_time: any, standard_deduction: any, deducted_amount: any, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, jr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, sr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, commodity: Array<{ __typename?: 'commodity', id: number, crop_id?: number | null, codename: string, name: string }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, codename: string, name: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, attachments: Array<{ __typename?: 'offer_attachments', id: any, send_whatsapp: boolean, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }>, expenses: Array<{ __typename?: 'offer_expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }> };

export type OfferDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type OfferDetailQuery = { __typename?: 'query_root', offers_by_pk?: { __typename?: 'offers', id: any, status: string, created_at: any, material_kind?: string | null, mode: string, rate: any, max_rate?: any | null, quantity: any, total_amount: any, buyer_source_kind: string, start_date_time: any, end_date_time: any, standard_deduction: any, deducted_amount: any, offers_buyer_groups: Array<{ __typename?: 'offers_buyer_groups', id: any, buyer_groups: { __typename?: 'setu_trade_shared_entity', id: any, name: string, group_id?: any | null } }>, total_enquiries: { __typename?: 'offer_enquiries_aggregate', aggregate?: { __typename?: 'offer_enquiries_aggregate_fields', count: number } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, jr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, sr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, commodity: Array<{ __typename?: 'commodity', id: number, crop_id?: number | null, codename: string, name: string }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, codename: string, name: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, attachments: Array<{ __typename?: 'offer_attachments', id: any, send_whatsapp: boolean, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }>, expenses: Array<{ __typename?: 'offer_expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }> } | null, offer_order_picked_aggregate: { __typename?: 'offer_order_picked_aggregate', aggregate?: { __typename?: 'offer_order_picked_aggregate_fields', sum?: { __typename?: 'offer_order_picked_sum_fields', quantity?: any | null } | null } | null } };

export type OfferBuyerDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
  buyerId: Scalars['bigint'];
}>;


export type OfferBuyerDetailQuery = { __typename?: 'query_root', offers_by_pk?: { __typename?: 'offers', id: any, status: string, created_at: any, material_kind?: string | null, mode: string, rate: any, max_rate?: any | null, quantity: any, total_amount: any, buyer_source_kind: string, start_date_time: any, end_date_time: any, standard_deduction: any, deducted_amount: any, trades: Array<{ __typename?: 'trade', id: any, kind: string }>, enquiries: Array<{ __typename?: 'offer_enquiries', id: any, status: string, created_at: any, updated_at: any, whatsapp_status: string, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null }>, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, jr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, sr_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, codename: string, name?: string | null }> } | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, commodity: Array<{ __typename?: 'commodity', id: number, crop_id?: number | null, codename: string, name: string }> }, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, codename: string, name: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> }, quantity_unit?: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, codename: string, name: string, base_conversion: any }> } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null, attachments: Array<{ __typename?: 'offer_attachments', id: any, send_whatsapp: boolean, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }>, expenses: Array<{ __typename?: 'offer_expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }> } | null, offer_order_picked_aggregate: { __typename?: 'offer_order_picked_aggregate', aggregate?: { __typename?: 'offer_order_picked_aggregate_fields', sum?: { __typename?: 'offer_order_picked_sum_fields', quantity?: any | null } | null } | null } };

export type OfferOrderListQueryVariables = Exact<{
  where?: InputMaybe<Offers_Bool_Exp>;
}>;


export type OfferOrderListQuery = { __typename?: 'query_root', offers: Array<{ __typename?: 'offers', id: any, trades: Array<{ __typename?: 'trade', id: any, kind: string, total_quantity?: any | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', full_name?: string | null }> } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', full_name?: string | null }> } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any }> }> }> };

export type AllPackingMaterialsSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPackingMaterialsSelectorQuery = { __typename?: 'query_root', all_packing_materials?: Array<{ __typename?: 'SKUPackingMaterialGlType', id: string, name: string, codename: string, type: PackingMaterialType } | null> | null };

export type PackagingOrderFieldsFragment = { __typename?: 'packaging_order', id: any, date: any, total_amount?: any | null, payment_status: string, total_amount_pending?: any | null, total_amount_paid?: any | null, transaction_number?: string | null, created_at: any, user?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, external_reference_id2?: string | null, name?: string | null }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, name: string, external_reference_id?: string | null }> } | null, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }>, packaging_order_items: Array<{ __typename?: 'packaging_order_item', id: any, packaging: { __typename?: 'packaging', id: any, name: string } }> };

export type PackingMaterialsQueryVariables = Exact<{
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packaging_Order_Order_By> | Packaging_Order_Order_By>;
}>;


export type PackingMaterialsQuery = { __typename?: 'query_root', packaging_order: Array<{ __typename?: 'packaging_order', id: any, date: any, total_amount?: any | null, payment_status: string, total_amount_pending?: any | null, total_amount_paid?: any | null, transaction_number?: string | null, created_at: any, user?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, external_reference_id2?: string | null, name?: string | null }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, name: string, external_reference_id?: string | null }> } | null, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }>, packaging_order_items: Array<{ __typename?: 'packaging_order_item', id: any, packaging: { __typename?: 'packaging', id: any, name: string } }> }>, packaging_order_aggregate: { __typename?: 'packaging_order_aggregate', aggregate?: { __typename?: 'packaging_order_aggregate_fields', count: number } | null } };

export type PackingMaterialByIdQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type PackingMaterialByIdQuery = { __typename?: 'query_root', packaging_order_by_pk?: { __typename?: 'packaging_order', id: any, date: any, total_amount?: any | null, payment_status: string, total_amount_pending?: any | null, total_amount_paid?: any | null, transaction_number?: string | null, created_at: any, packaging_order_items: Array<{ __typename?: 'packaging_order_item', id: any, rate: any, quantity: number, amount?: any | null, packaging: { __typename?: 'packaging', id: any, name: string } }>, payments: Array<{ __typename?: 'payment', id: any, date: any, mode: string, transaction_id: string, amount: any, account_number: string, acount_holder: string, ifsc_code: string, bank_name: string, branch_name: string, photo?: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } | null }>, user?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, external_reference_id2?: string | null, name?: string | null }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, name: string, external_reference_id?: string | null }> } | null, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> } | null };

export type ViewSapTransactionQueryVariables = Exact<{
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
}>;


export type ViewSapTransactionQuery = { __typename?: 'query_root', packaging_order: Array<{ __typename?: 'packaging_order', id: any, transaction_number?: string | null, transaction_attachment?: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } | null }> };

export type UserPackingQueryVariables = Exact<{
  where?: InputMaybe<Packaging_Order_Bool_Exp>;
}>;


export type UserPackingQuery = { __typename?: 'query_root', packaging_order: Array<{ __typename?: 'packaging_order', id: any, transaction_number?: string | null, payment_status: string, total_quantity?: number | null, total_amount?: any | null, total_amount_pending?: any | null, total_amount_paid?: any | null, packaging_order_items: Array<{ __typename?: 'packaging_order_item', id: any, quantity: number, rate: any, amount?: any | null, packaging: { __typename?: 'packaging', id: any, name: string, material_code: string } }> }> };

export type AddPackagingSapMutationVariables = Exact<{
  id: Scalars['bigint'];
  _set?: InputMaybe<Packaging_Order_Set_Input>;
}>;


export type AddPackagingSapMutation = { __typename?: 'mutation_root', update_packaging_order_by_pk?: { __typename?: 'packaging_order', id: any } | null };

export type InsertPackagingOrderMutationVariables = Exact<{
  input: Array<Packaging_Order_Insert_Input> | Packaging_Order_Insert_Input;
  on_conflict?: InputMaybe<Packaging_Order_On_Conflict>;
}>;


export type InsertPackagingOrderMutation = { __typename?: 'mutation_root', insert_packaging_order?: { __typename?: 'packaging_order_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'packaging_order', id: any }> } | null };

export type AdvanceSummaryDashboardQueryVariables = Exact<{
  department_id: Scalars['ID'];
  createdFrom?: InputMaybe<Scalars['Date']>;
  createdTill?: InputMaybe<Scalars['Date']>;
  sellerId?: InputMaybe<Scalars['ID']>;
}>;


export type AdvanceSummaryDashboardQuery = { __typename?: 'query_root', advance_summary_dashboard?: { __typename?: 'AdvanceSummaryDashboardType', trade_amount?: number | null, requested_advance_amount?: number | null, advance_status_pending?: number | null, released_advance_amount?: number | null, settled_amount?: number | null } | null };

export type ReceiptAdvanceSummaryDashboardQueryVariables = Exact<{
  department_id: Scalars['ID'];
  createdFrom?: InputMaybe<Scalars['Date']>;
  createdTill?: InputMaybe<Scalars['Date']>;
  sellerId?: InputMaybe<Scalars['ID']>;
}>;


export type ReceiptAdvanceSummaryDashboardQuery = { __typename?: 'query_root', advance_summary_dashboard_receipt?: { __typename?: 'AdvanceSummaryDashboardType', trade_amount?: number | null, requested_advance_amount?: number | null, advance_status_pending?: number | null, released_advance_amount?: number | null, settled_amount?: number | null } | null };

export type AllAdvancePaymentsQueryVariables = Exact<{
  where?: InputMaybe<Advance_Payment_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Advance_Payment_Order_By> | Advance_Payment_Order_By>;
}>;


export type AllAdvancePaymentsQuery = { __typename?: 'query_root', advance_payment: Array<{ __typename?: 'advance_payment', id: any, created_at: any, created_by_id: string, settlement_status: string, status: string, remark?: string | null, remaining_amount?: any | null, amount?: any | null, is_verified?: boolean | null, verified_on?: any | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, trade?: { __typename?: 'trade', id: any, kind: string, seller_payable?: number | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null }> } | null } | null, receipt?: { __typename?: 'receipt', id: any, kind: string, seller_payable?: number | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }> } | null } | null, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null }, transactions: Array<{ __typename?: 'transaction', id: any, parent_transaction_id?: any | null, remark?: string | null, date: any, amount: any, trade?: { __typename?: 'trade', id: any, receipt_id?: any | null } | null, attachments: Array<{ __typename?: 'transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }> }> }>, advance_payment_aggregate: { __typename?: 'advance_payment_aggregate', aggregate?: { __typename?: 'advance_payment_aggregate_fields', count: number } | null } };

export type AdvancePaymentDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type AdvancePaymentDetailQuery = { __typename?: 'query_root', advance_payment_by_pk?: { __typename?: 'advance_payment', id: any, created_at: any, created_by_id: string, remark?: string | null, amount?: any | null, is_verified?: boolean | null, status: string, settlement_status: string, trade?: { __typename?: 'trade', id: any, kind: string, seller_payable?: number | null, advance_summary?: { __typename?: 'AdvanceSummaryType', requested_advance?: number | null, released_advance?: number | null, seller_receivable_amount?: number | null, advance_used_in_current_trade?: number | null, advance_used_in_other_trades?: number | null, remaining_advance?: number | null } | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tds?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null, my_businesses: Array<{ __typename?: 'business', id: number, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }>, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }> } | null } | null, receipt?: { __typename?: 'receipt', id: any, kind: string, seller_payable?: number | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null, my_businesses: Array<{ __typename?: 'business', id: number, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }>, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }> } | null } | null, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null }, transactions: Array<{ __typename?: 'transaction', id: any, created_at: any, remark?: string | null, date: any, transaction_id: string, account_no?: string | null, amount: any, trade?: { __typename?: 'trade', id: any, kind: string } | null, receipt?: { __typename?: 'receipt', id: any, kind: string } | null, attachments: Array<{ __typename?: 'transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, advance_payment?: { __typename?: 'advance_payment', id: any, amount?: any | null, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string } } | null, mode: { __typename?: 'Transaction_mode', id: any, codename: string, name: string } }> } | null };

export type UpdateAdvancePaymentMutationVariables = Exact<{
  id: Scalars['bigint'];
  object?: InputMaybe<Advance_Payment_Set_Input>;
}>;


export type UpdateAdvancePaymentMutation = { __typename?: 'mutation_root', update_advance_payment_by_pk?: { __typename?: 'advance_payment', id: any, remark?: string | null } | null };

export type CloseAdvanceRequestMutationVariables = Exact<{
  advance_payment_id: Scalars['ID'];
}>;


export type CloseAdvanceRequestMutation = { __typename?: 'mutation_root', close_advance_payment?: { __typename?: 'CloseAdvancePaymentMutation', success?: boolean | null } | null };

export type DepartmentUserAdvancesQueryVariables = Exact<{
  filters?: InputMaybe<DepartmentUserAdvanceFilterInput>;
}>;


export type DepartmentUserAdvancesQuery = { __typename?: 'query_root', department_user_advances?: { __typename?: 'DepartmentUserAdvanceListWithSummaryType', summary?: { __typename?: 'DepartmentUserAdvanceAggregateSummaryType', total_requested_amount?: number | null, total_released_amount?: number | null, used_amount?: number | null, remaining_amount?: number | null, unreleased_amount?: number | null } | null, items?: Array<{ __typename?: 'DepartmentUserAdvanceType', id: string, codename: string, name: string, created_at: any, is_active: boolean, total_requested_amount?: any | null, total_released_amount?: any | null, used_amount?: any | null, remaining_amount?: any | null, unreleased_amount?: number | null, user: { __typename?: 'SharedEntityType', id: string, name: string, reference_id: string }, department: { __typename?: 'SharedEntityType', id: string, name: string } } | null> | null } | null };

export type CreateAdvanceTransactionMutationVariables = Exact<{
  input: AdvanceTransactionInput;
}>;


export type CreateAdvanceTransactionMutation = { __typename?: 'mutation_root', add_advance_transaction?: { __typename?: 'AddAdvanceTransactionMutation', transaction?: { __typename?: 'TransactionType', id: string } | null } | null };

export type ReceiptAdvancePaymentsQueryVariables = Exact<{
  receiptId: Scalars['bigint'];
}>;


export type ReceiptAdvancePaymentsQuery = { __typename?: 'query_root', advance_payment: Array<{ __typename?: 'advance_payment', id: any, created_at: any, amount?: any | null, remaining_amount?: any | null, is_verified?: boolean | null, verified_on?: any | null, status: string, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null }> };

export type SendAdvanceRequestMutationVariables = Exact<{
  advance_payment_ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type SendAdvanceRequestMutation = { __typename?: 'mutation_root', request_advance_payment?: { __typename?: 'RequestAdvancePaymentMutation', success?: boolean | null } | null };

export type MapTransactionsForTradesMutationVariables = Exact<{
  input: Array<InputMaybe<MapTradeTransactionManyInput>> | InputMaybe<MapTradeTransactionManyInput>;
}>;


export type MapTransactionsForTradesMutation = { __typename?: 'mutation_root', map_trade_transaction_many?: { __typename?: 'MapTradeTransactionManyMutation', trades?: Array<{ __typename?: 'TradeType', id: string } | null> | null } | null };

export type MapTransactionsForInvoicesMutationVariables = Exact<{
  input: Array<InputMaybe<MapInvoiceTransactionManyInput>> | InputMaybe<MapInvoiceTransactionManyInput>;
}>;


export type MapTransactionsForInvoicesMutation = { __typename?: 'mutation_root', map_invoice_transaction_many?: { __typename?: 'MapInvoiceTransactionManyMutation', invoices?: Array<{ __typename?: 'InvoiceType', id: string } | null> | null } | null };

export type MapTransactionsForReceiptsMutationVariables = Exact<{
  input: Array<InputMaybe<MapReceiptTransactionManyInput>> | InputMaybe<MapReceiptTransactionManyInput>;
}>;


export type MapTransactionsForReceiptsMutation = { __typename?: 'mutation_root', map_receipt_transaction_many?: { __typename?: 'MapReceiptTransactionManyMutation', receipts?: Array<{ __typename?: 'ReceiptType', id: string } | null> | null } | null };

export type NetPayableTradeListQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  orderBy?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type NetPayableTradeListQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', created_at: any, remark?: string | null, seller_tds?: any | null, id: any, kind: string, seller_payable?: number | null, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, tax_name: string, role: string }>, seller_bifurcation?: { __typename?: 'SellerBifurcationType', total?: number | null, advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tds?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, creditNote: Array<{ __typename?: 'issuance_note', id: any, amount: any }>, debitNote: Array<{ __typename?: 'issuance_note', id: any, amount: any }>, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }>, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }> } | null, transactions_aggregate: { __typename: 'transaction_aggregate', aggregate?: { __typename: 'transaction_aggregate_fields', sum?: { __typename: 'transaction_sum_fields', amount?: any | null } | null } | null }, transactions: Array<{ __typename: 'transaction', id: any, date: any, remark?: string | null, parent_transaction_id?: any | null, trade?: { __typename?: 'trade', id: any, receipt_id?: any | null } | null }>, advance_payments_aggregate: { __typename?: 'advance_payment_aggregate', aggregate?: { __typename?: 'advance_payment_aggregate_fields', sum?: { __typename?: 'advance_payment_sum_fields', amount?: any | null } | null } | null } }>, transaction_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null }, transaction: Array<{ __typename?: 'transaction', id: any, remark?: string | null }>, trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null } };

export type NetPayableTradeSelectorQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  orderBy?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type NetPayableTradeSelectorQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, created_at: any, seller_settlement_status?: string | null, has_advance_release_pending?: boolean | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', total?: number | null, advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tds?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null }>, trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null } };

export type NetPayableReceiptSelectorQueryVariables = Exact<{
  where?: InputMaybe<Receipt_Bool_Exp>;
  orderBy?: InputMaybe<Array<Receipt_Order_By> | Receipt_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type NetPayableReceiptSelectorQuery = { __typename?: 'query_root', receipt: Array<{ __typename?: 'receipt', id: any, created_at: any, seller_settlement_status?: string | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', total?: number | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tds?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null }>, receipt_aggregate: { __typename?: 'receipt_aggregate', aggregate?: { __typename?: 'receipt_aggregate_fields', count: number } | null } };

export type NetPayableTradeDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type NetPayableTradeDetailQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', created_at: any, remark?: string | null, id: any, kind: string, seller_payable?: number | null, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }>, seller_bifurcation?: { __typename?: 'SellerBifurcationType', total?: number | null, advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tds?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, creditNote: Array<{ __typename?: 'issuance_note', id: any, amount: any, created_at: any, kind: string, remarks?: string | null, type: string, input_value?: any | null }>, debitNote: Array<{ __typename?: 'issuance_note', id: any, amount: any, created_at: any, kind: string, remarks?: string | null, type: string, input_value?: any | null }>, pending_issuance_note_bool: Array<{ __typename?: 'issuance_note', id: any, is_verified?: boolean | null }>, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null, my_businesses: Array<{ __typename?: 'business', id: number, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }>, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }> } | null, transactions: Array<{ __typename?: 'transaction', id: any, remark?: string | null, created_at: any, date: any, transaction_id: string, account_no?: string | null, amount: any, attachments: Array<{ __typename?: 'transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, bank?: { __typename?: 'setu_trade_shared_entity', id: any, payment_detail?: { __typename?: 'payment_detail', id: number, account_number: string, bank_name: string, account_holder_name: string } | null } | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, receipt?: { __typename?: 'receipt', id: any, kind: string } | null, advance_payment?: { __typename?: 'advance_payment', id: any, amount?: any | null, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string } } | null, mode: { __typename?: 'Transaction_mode', id: any, codename: string, name: string } }>, advance_payments_aggregate: { __typename?: 'advance_payment_aggregate', aggregate?: { __typename?: 'advance_payment_aggregate_fields', sum?: { __typename?: 'advance_payment_sum_fields', amount?: any | null } | null } | null } } | null };

export type NetPayableTradeOverduesQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type NetPayableTradeOverduesQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, summary?: { __typename?: 'TradeSummaryType', overdue_days?: number | null, overdue_amount?: number | null } | null } | null };

export type NetPayableTradeAdvanceSummaryQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type NetPayableTradeAdvanceSummaryQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, advance_summary?: { __typename?: 'AdvanceSummaryType', advance_used_in_current_trade?: number | null, advance_used_in_other_trades?: number | null, released_advance?: number | null, remaining_advance?: number | null, requested_advance?: number | null, seller_receivable_amount?: number | null } | null } | null };

export type NetPayableReceiptAdvanceSummaryQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type NetPayableReceiptAdvanceSummaryQuery = { __typename?: 'query_root', receipt_by_pk?: { __typename?: 'receipt', id: any, advance_summary?: { __typename?: 'AdvanceSummaryType', advance_used_in_current_trade?: number | null, advance_used_in_other_trades?: number | null, released_advance?: number | null, remaining_advance?: number | null, requested_advance?: number | null, seller_receivable_amount?: number | null } | null } | null };

export type NetPayableReceiptListQueryVariables = Exact<{
  where?: InputMaybe<Receipt_Bool_Exp>;
  orderBy?: InputMaybe<Array<Receipt_Order_By> | Receipt_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type NetPayableReceiptListQuery = { __typename?: 'query_root', receipt: Array<{ __typename?: 'receipt', created_at: any, remark?: string | null, id: any, kind: string, seller_payable?: number | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', total?: number | null, advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tds?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }> } | null, transactions: Array<{ __typename: 'transaction', id: any, date: any, remark?: string | null }>, advance_payments_aggregate: { __typename?: 'advance_payment_aggregate', aggregate?: { __typename?: 'advance_payment_aggregate_fields', sum?: { __typename?: 'advance_payment_sum_fields', amount?: any | null } | null } | null } }>, receipt_aggregate: { __typename?: 'receipt_aggregate', aggregate?: { __typename?: 'receipt_aggregate_fields', count: number } | null } };

export type NetPayableReceiptDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type NetPayableReceiptDetailQuery = { __typename?: 'query_root', receipt_by_pk?: { __typename?: 'receipt', created_at: any, remark?: string | null, id: any, kind: string, seller_payable?: number | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id2?: string | null, my_businesses: Array<{ __typename?: 'business', id: number, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }>, payment_details?: Array<{ __typename?: 'PaymentDetailType', id: string, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'GeneralContentType', id: string, model: string }, method: { __typename?: 'PaymentMethodType', id: string, name: string } } | null> | null }> } | null, transactions: Array<{ __typename?: 'transaction', id: any, remark?: string | null, created_at: any, date: any, transaction_id: string, account_no?: string | null, amount: any, attachments: Array<{ __typename?: 'transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, bank?: { __typename?: 'setu_trade_shared_entity', id: any, payment_detail?: { __typename?: 'payment_detail', id: number, account_number: string, bank_name: string, account_holder_name: string } | null } | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, receipt?: { __typename?: 'receipt', id: any, kind: string } | null, advance_payment?: { __typename?: 'advance_payment', id: any, amount?: any | null, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string } } | null, mode: { __typename?: 'Transaction_mode', id: any, codename: string, name: string } }>, advance_payments_aggregate: { __typename?: 'advance_payment_aggregate', aggregate?: { __typename?: 'advance_payment_aggregate_fields', sum?: { __typename?: 'advance_payment_sum_fields', amount?: any | null } | null } | null } } | null, transaction_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null } };

export type UpdateTradeNetPaymentMutationVariables = Exact<{
  id: Scalars['bigint'];
  object?: InputMaybe<Trade_Set_Input>;
}>;


export type UpdateTradeNetPaymentMutation = { __typename?: 'mutation_root', update_trade_by_pk?: { __typename?: 'trade', id: any, remark?: string | null } | null };

export type UpdateReceiptNetPaymentMutationVariables = Exact<{
  id: Scalars['bigint'];
  object?: InputMaybe<Receipt_Set_Input>;
}>;


export type UpdateReceiptNetPaymentMutation = { __typename?: 'mutation_root', update_receipt_by_pk?: { __typename?: 'receipt', id: any, remark?: string | null } | null };

export type TradeSellerAnalyticsQueryVariables = Exact<{
  createdFrom?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tradeKinds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  createdTill?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
  sellerReferenceId?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['String']>;
}>;


export type TradeSellerAnalyticsQuery = { __typename?: 'query_root', aggregate_trade_seller_summary?: { __typename?: 'SellerBifurcationType', advance_remaining_amount?: number | null, total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null };

export type ReceiptSellerAnalyticsQueryVariables = Exact<{
  createdFrom?: InputMaybe<Scalars['Date']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tradeKinds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  createdTill?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
  sellerReferenceId?: InputMaybe<Scalars['String']>;
  createdById?: InputMaybe<Scalars['String']>;
}>;


export type ReceiptSellerAnalyticsQuery = { __typename?: 'query_root', aggregate_receipt_seller_summary?: { __typename?: 'SellerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, paid_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, seller_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, supplier_charge?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null };

export type AllPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPaymentMethodsQuery = { __typename?: 'query_root', Transaction_mode: Array<{ __typename?: 'Transaction_mode', id: any, name: string }> };

export type PlantSettlementQueryVariables = Exact<{
  where?: InputMaybe<Department_Settlements_Bool_Exp>;
  orderBy?: InputMaybe<Array<Department_Settlements_Order_By> | Department_Settlements_Order_By>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type PlantSettlementQuery = { __typename?: 'query_root', department_settlements: Array<{ __typename?: 'department_settlements', id: any, created_at: any, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, department: Array<{ __typename?: 'department', id: number, payment_details: Array<{ __typename?: 'department_payment_detail', id: number, payment_detail: { __typename?: 'payment_detail', id: number, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'django_content_type', id: number, model: string }, method: { __typename?: 'payment_method', id: number, name: string } } }> }> }, user?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, reference_id: string, external_reference_id2?: string | null }> } | null, transactions: Array<{ __typename?: 'transaction', id: any, bank_id?: any | null, remark?: string | null, transaction_id: string, amount: any, created_by_id: string, attachments: Array<{ __typename?: 'transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, child_transactions_aggregate: { __typename?: 'transaction_aggregate', aggregate?: { __typename?: 'transaction_aggregate_fields', sum?: { __typename?: 'transaction_sum_fields', amount?: any | null } | null } | null }, bank?: { __typename?: 'setu_trade_shared_entity', payment_detail?: { __typename?: 'payment_detail', id: number, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'django_content_type', id: number, model: string }, method: { __typename?: 'payment_method', id: number, name: string } } | null } | null, mode: { __typename?: 'Transaction_mode', id: any, name: string } }> }>, department_settlements_aggregate: { __typename?: 'department_settlements_aggregate', aggregate?: { __typename?: 'department_settlements_aggregate_fields', count: number } | null } };

export type InsertPlantSettlementMutationVariables = Exact<{
  object: Department_Settlements_Insert_Input;
}>;


export type InsertPlantSettlementMutation = { __typename?: 'mutation_root', insert_department_settlements_one?: { __typename?: 'department_settlements', id: any } | null };

export type DepartmentPaymentListQueryVariables = Exact<{
  where?: InputMaybe<Department_Bool_Exp>;
}>;


export type DepartmentPaymentListQuery = { __typename?: 'query_root', department: Array<{ __typename?: 'department', id: number, name: string, payment_details: Array<{ __typename?: 'department_payment_detail', id: number, payment_detail: { __typename?: 'payment_detail', id: number, account_holder_name: string, account_number: string, ifsc_code: string, bank_name: string, content_type: { __typename?: 'django_content_type', id: number, model: string }, method: { __typename?: 'payment_method', id: number, name: string } } }> }> };

export type SetPlantTransactionInactiveMutationVariables = Exact<{
  where: Department_Settlements_Bool_Exp;
}>;


export type SetPlantTransactionInactiveMutation = { __typename?: 'mutation_root', update_department_settlements?: { __typename?: 'department_settlements_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'department_settlements', id: any }> } | null };

export type AddUpdateProductionPlanningTradeMutationVariables = Exact<{
  input?: InputMaybe<ProductionTradeInput>;
}>;


export type AddUpdateProductionPlanningTradeMutation = { __typename?: 'mutation_root', add_update_production_planning_trade?: { __typename?: 'AddUpdateProductionTradePlanningMutation', production_trade: { __typename?: 'ProductionTradeType', id: string } } | null };

export type UpdateProductionStatusMutationVariables = Exact<{
  trade_id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type UpdateProductionStatusMutation = { __typename?: 'mutation_root', update_production_trade_status?: { __typename?: 'UpdateProductionTradeStatusMutation', production_trade: { __typename?: 'ProductionTradeType', id: string, status: TradeProductionTradeStatusChoices } } | null };

export type ProductionTradeDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProductionTradeDetailQuery = { __typename?: 'query_root', production_trade_by_pk?: { __typename?: 'production_trade', id: number, kind: string, start_datetime?: any | null, end_datetime?: any | null, status: string, mode: string, buyer_tnc?: string | null, created_at: any, is_verified?: boolean | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, order_trade_refs: Array<{ __typename?: 'production_trade_order_trade_refs', id: any, trade_id: any }>, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, depot?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, input: Array<{ __typename?: 'production_trade_item', id: any, available_quantity?: any | null, cost_per_unit?: any | null, final_quantity?: any | null, required_quantity?: any | null, total_cost?: any | null, kind: string, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string }> }, variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string }> } | null, attachments: Array<{ __typename?: 'production_trade_item_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string }> } | null, storage_picked: Array<{ __typename?: 'production_trade_item_storage_picked', id: number, trade_id: any, used_quantity?: any | null, weight_loss_quantity?: any | null, wastage_loss_quantity?: any | null, trade: { __typename?: 'trade', id: any, deducted_quantity_remaining?: any | null } }> }>, output: Array<{ __typename?: 'production_trade_item', id: any, available_quantity?: any | null, cost_per_unit?: any | null, final_quantity?: any | null, required_quantity?: any | null, total_cost?: any | null, kind: string, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string }> }, variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string }> } | null, attachments: Array<{ __typename?: 'production_trade_item_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string }> } | null }>, packagings: Array<{ __typename?: 'production_trade_item', id: any, available_quantity?: any | null, cost_per_unit?: any | null, final_quantity?: any | null, required_quantity?: any | null, total_cost?: any | null, kind: string, commodity: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string }> }, variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string }> } | null, attachments: Array<{ __typename?: 'production_trade_item_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }>, grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string }> } | null, storage_picked: Array<{ __typename?: 'production_trade_item_storage_picked', id: number, trade_id: any, used_quantity?: any | null, weight_loss_quantity?: any | null, wastage_loss_quantity?: any | null, trade: { __typename?: 'trade', id: any, deducted_quantity_remaining?: any | null } }> }> } | null };

export type ProductionTradesQueryVariables = Exact<{
  where?: InputMaybe<Production_Trade_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Production_Trade_Order_By> | Production_Trade_Order_By>;
}>;


export type ProductionTradesQuery = { __typename?: 'query_root', production_trade: Array<{ __typename?: 'production_trade', id: number, parent_trade_id?: number | null, is_verified?: boolean | null, status: string, buyer_tnc?: string | null, created_at: any, start_datetime?: any | null, end_datetime?: any | null, ref_storage_patti: Array<{ __typename?: 'production_trade_item', id: any, storage_picked: Array<{ __typename?: 'production_trade_item_storage_picked', id: number, trade_id: any }> }>, associated_trades: Array<{ __typename?: 'trade', id: any }>, order_trade_refs: Array<{ __typename?: 'production_trade_order_trade_refs', id: any, trade_id: any }>, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, external_reference_id?: string | null }> } | null, items: Array<{ __typename?: 'production_trade_item', id: any, required_quantity?: any | null, cost_per_unit?: any | null, total_cost?: any | null, commodity: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null }>, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, last_login?: any | null } | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null }> } | null, depot?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, expenses: Array<{ __typename?: 'expense', id: any, amount?: any | null }> }>, production_trade_aggregate: { __typename?: 'production_trade_aggregate', aggregate?: { __typename?: 'production_trade_aggregate_fields', count: number } | null } };

export type AddUpdateProductionFinalTradeMutationVariables = Exact<{
  input?: InputMaybe<ProductionFinalTradeInput>;
}>;


export type AddUpdateProductionFinalTradeMutation = { __typename?: 'mutation_root', add_update_production_final_trade?: { __typename?: 'AddUpdateProductionTradeFinalMutation', production_trade: { __typename?: 'ProductionTradeType', id: string } } | null };

export type ShiftProductionToStorageMutationVariables = Exact<{
  tradeId: Scalars['ID'];
}>;


export type ShiftProductionToStorageMutation = { __typename?: 'mutation_root', shift_production_trade_to_storage?: { __typename?: 'ProductionTradeToStorageMutation', production_trade: { __typename?: 'ProductionTradeType', id: string, associated_trades: Array<{ __typename?: 'TradeType', id: string }> } } | null };

export type ResultBaseFragFragment = { __typename?: 'result', id: any, name: string, codename: string, sample_id: any, sample: { __typename?: 'sample', id: any, sample_request_id: any }, template: { __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> }, evaluations: Array<{ __typename?: 'result_evaluation', value: any }>, observations: Array<{ __typename?: 'result_observation', id: any, template_parameter_id?: any | null, value: any, template_parameter?: { __typename?: 'template_parameter', id: any, quality_parameter_id: any } | null, sample_observation?: { __typename?: 'sample_observation', id: any, observation_number: number, attachments: Array<{ __typename?: 'sample_observation_attachments', id: any, media: { __typename?: 'eagle_media', id: any, url?: string | null, media_kind: string } }> } | null }> };

export type ResultOneQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type ResultOneQuery = { __typename?: 'query_root', result_by_pk?: { __typename?: 'result', id: any, name: string, codename: string, sample_id: any, sample: { __typename?: 'sample', id: any, sample_request_id: any }, template: { __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> }, evaluations: Array<{ __typename?: 'result_evaluation', value: any }>, observations: Array<{ __typename?: 'result_observation', id: any, template_parameter_id?: any | null, value: any, template_parameter?: { __typename?: 'template_parameter', id: any, quality_parameter_id: any } | null, sample_observation?: { __typename?: 'sample_observation', id: any, observation_number: number, attachments: Array<{ __typename?: 'sample_observation_attachments', id: any, media: { __typename?: 'eagle_media', id: any, url?: string | null, media_kind: string } }> } | null }> } | null };

export type DeleteSampleOneMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteSampleOneMutation = { __typename?: 'mutation_root', delete_sample_observation_attachments?: { __typename?: 'sample_observation_attachments_mutation_response', returning: Array<{ __typename?: 'sample_observation_attachments', id: any }> } | null, delete_sample_observation?: { __typename?: 'sample_observation_mutation_response', returning: Array<{ __typename?: 'sample_observation', id: any }> } | null, delete_result_evaluation?: { __typename?: 'result_evaluation_mutation_response', returning: Array<{ __typename?: 'result_evaluation', id: any }> } | null, delete_result?: { __typename?: 'result_mutation_response', returning: Array<{ __typename?: 'result', id: any }> } | null, delete_sample_by_pk?: { __typename?: 'sample', id: any } | null };

export type SubmitSampleObservationsMutationVariables = Exact<{
  input: SubmitObservationsInput;
}>;


export type SubmitSampleObservationsMutation = { __typename?: 'mutation_root', submit_observations?: { __typename?: 'SubmitObservations', sample?: { __typename?: 'SampleType', id: string, results: Array<{ __typename?: 'ResultType', id: string, name: string, codename: string }> } | null } | null };

export type DeleteSampleObservationMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteSampleObservationMutation = { __typename?: 'mutation_root', delete_sample_observation_by_pk?: { __typename?: 'sample_observation', id: any } | null };

export type TemplateBaseFragFragment = { __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> };

export type SoyaBeanTemplatesQueryVariables = Exact<{
  reference_id: Scalars['String'];
  entity_type?: InputMaybe<Scalars['String']>;
}>;


export type SoyaBeanTemplatesQuery = { __typename?: 'query_root', template: Array<{ __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> }> };

export type ReceiptDetailFragFragment = { __typename?: 'receipt', id: any, parent_receipt_id?: any | null, is_multiple_commodity: boolean, seller_receivable_amount?: any | null, seller_expense_amount?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, seller_tnc?: string | null, packaging: string, standard_deduction?: any | null, expense_amount?: any | null, buyer_tnc?: string | null, supplier_expense_gst_auto_calculated: boolean, buyer_expense_gst_auto_calculated: boolean, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, settled_by_advance_payment: Array<{ __typename?: 'transaction', id: any, ref?: string | null, amount: any, parent_transaction?: { __typename?: 'transaction', advance_payment?: { __typename?: 'advance_payment', id: any, receipt?: { __typename?: 'receipt', id: any, kind: string } | null } | null } | null }>, parent_receipt?: { __typename?: 'receipt', id: any, is_multiple_commodity: boolean } | null, twilio_message?: { __typename?: 'trade_twiliomessages', id: string, status?: string | null } | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, vehicle?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string } | null, editable_trades: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null }, hishob_patti_count: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, child_receipts: Array<{ __typename?: 'receipt', id: any }>, child_receipts_aggregate: { __typename?: 'receipt_aggregate', aggregate?: { __typename?: 'receipt_aggregate_fields', count: number } | null }, seller_gst_attachments: Array<{ __typename?: 'receipt_seller_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, advance_payments: Array<{ __typename?: 'advance_payment', id: any, amount?: any | null, bourn_by?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions: Array<{ __typename?: 'transaction', created_at: any, remark?: string | null, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, mode: { __typename?: 'Transaction_mode', name: string } }> }>, credit_notes: Array<{ __typename?: 'credit_note', id: any, amount?: any | null, remarks?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any }>, trades: Array<{ __typename?: 'trade', id: any, total_quantity?: any | null, total_amount?: any | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, attachments: Array<{ __typename?: 'trade_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null, etag?: string | null } }>, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, parent_trade_item_id?: any | null, total_amount?: any | null, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }>, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string }> } | null }> }> };

export type ReceiptDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type ReceiptDetailQuery = { __typename?: 'query_root', receipt_by_pk?: { __typename?: 'receipt', id: any, parent_receipt_id?: any | null, is_multiple_commodity: boolean, seller_receivable_amount?: any | null, seller_expense_amount?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, seller_tnc?: string | null, packaging: string, standard_deduction?: any | null, expense_amount?: any | null, buyer_tnc?: string | null, supplier_expense_gst_auto_calculated: boolean, buyer_expense_gst_auto_calculated: boolean, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, settled_by_advance_payment: Array<{ __typename?: 'transaction', id: any, ref?: string | null, amount: any, parent_transaction?: { __typename?: 'transaction', advance_payment?: { __typename?: 'advance_payment', id: any, receipt?: { __typename?: 'receipt', id: any, kind: string } | null } | null } | null }>, parent_receipt?: { __typename?: 'receipt', id: any, is_multiple_commodity: boolean } | null, twilio_message?: { __typename?: 'trade_twiliomessages', id: string, status?: string | null } | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, reference_id: string }, vehicle?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string } | null, editable_trades: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null }, hishob_patti_count: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, child_receipts: Array<{ __typename?: 'receipt', id: any }>, child_receipts_aggregate: { __typename?: 'receipt_aggregate', aggregate?: { __typename?: 'receipt_aggregate_fields', count: number } | null }, seller_gst_attachments: Array<{ __typename?: 'receipt_seller_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, advance_payments: Array<{ __typename?: 'advance_payment', id: any, amount?: any | null, bourn_by?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions: Array<{ __typename?: 'transaction', created_at: any, remark?: string | null, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, mode: { __typename?: 'Transaction_mode', name: string } }> }>, credit_notes: Array<{ __typename?: 'credit_note', id: any, amount?: any | null, remarks?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any }>, trades: Array<{ __typename?: 'trade', id: any, total_quantity?: any | null, total_amount?: any | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, attachments: Array<{ __typename?: 'trade_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null, etag?: string | null } }>, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, parent_trade_item_id?: any | null, total_amount?: any | null, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }>, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string }> } | null }> }> } | null, trade_expense_tax: Array<{ __typename?: 'trade_expense_tax', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }> };

export type AllReceiptsQueryVariables = Exact<{
  where?: InputMaybe<Receipt_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Receipt_Order_By> | Receipt_Order_By>;
}>;


export type AllReceiptsQuery = { __typename?: 'query_root', receipt: Array<{ __typename?: 'receipt', id: any, tracking_code: string, created_at: any, total_amount?: any | null, total_quantity?: any | null, kind: string, is_multiple_commodity: boolean, updated_at: any, twilio_message?: { __typename?: 'trade_twiliomessages', id: string, status?: string | null } | null, advance_payments: Array<{ __typename?: 'advance_payment', id: any, is_verified?: boolean | null, status: string }>, child_receipts_aggregate: { __typename?: 'receipt_aggregate', aggregate?: { __typename?: 'receipt_aggregate_fields', count: number } | null }, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, is_blocked?: boolean | null, number: string, external_reference_id?: string | null, current_address?: { __typename?: 'address', id: number, village?: string | null } | null }> } | null, trades: Array<{ __typename?: 'trade', id: any, deducted_quantity_remaining?: any | null, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }>, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, is_blocked?: boolean | null, full_name?: string | null, number: string, external_reference_id?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, current_address?: { __typename?: 'address', id: number, village?: string | null } | null }> } | null }>, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null } | null, hishob_patti_count: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null } }>, receipt_aggregate: { __typename?: 'receipt_aggregate', aggregate?: { __typename?: 'receipt_aggregate_fields', count: number } | null } };

export type AddUpdateReceiptMutationVariables = Exact<{
  input?: InputMaybe<ReceiptInput>;
}>;


export type AddUpdateReceiptMutation = { __typename?: 'mutation_root', add_update_receipt?: { __typename?: 'AddUpdateReceipt', receipt: { __typename?: 'ReceiptType', id: string } } | null };

export type ReceiptFinalTrades2MutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type ReceiptFinalTrades2Mutation = { __typename?: 'mutation_root', receipt_final_trades?: { __typename?: 'ReceiptFinalTradesMutation', affected_rows?: number | null } | null };

export type ReturnTransactionsMutationVariables = Exact<{
  transactionIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type ReturnTransactionsMutation = { __typename?: 'mutation_root', cancel_transaction?: { __typename?: 'CancelTransactionMutation', success?: boolean | null } | null };

export type KiteCommodityFragFragment = { __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null };

export type KiteCommodityVarietyFragFragment = { __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> };

export type AddUpdateSharedEntityMutationVariables = Exact<{
  reference_id?: InputMaybe<Scalars['String']>;
  group_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type AddUpdateSharedEntityMutation = { __typename?: 'mutation_root', insert_setu_trade_shared_entity_one?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string, group_name: string, seller_receivable_amount_current_year?: number | null } | null };

export type SellerReceivableAmountQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type SellerReceivableAmountQuery = { __typename?: 'query_root', setu_trade_shared_entity_by_pk?: { __typename?: 'setu_trade_shared_entity', id: any, seller_receivable_amount_current_year?: number | null } | null };

export type AllCommoditiesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllCommoditiesQuery = { __typename?: 'query_root', commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> };

export type AllPackagingCommoditiesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AllPackagingCommoditiesQuery = { __typename?: 'query_root', commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> };

export type AllVarietiesQueryVariables = Exact<{
  commodity_id?: InputMaybe<Scalars['Int']>;
}>;


export type AllVarietiesQuery = { __typename?: 'query_root', commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> };

export type AllPlotCropsQueryVariables = Exact<{
  farmer?: InputMaybe<Scalars['Int']>;
}>;


export type AllPlotCropsQuery = { __typename?: 'query_root', plot_crop: Array<{ __typename?: 'plot_crop', id: number, tag: string, name: string, codename: string, external_reference_id?: string | null }> };

export type AllVarietyGradesQueryVariables = Exact<{
  variety?: InputMaybe<Scalars['Int']>;
}>;


export type AllVarietyGradesQuery = { __typename?: 'query_root', variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> };

export type GetVarietyGradesSharedEntityQueryVariables = Exact<{
  where?: InputMaybe<Setu_Trade_Shared_Entity_Bool_Exp>;
}>;


export type GetVarietyGradesSharedEntityQuery = { __typename?: 'query_root', setu_trade_shared_entity: Array<{ __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number }> }> };

export type VarietyGradeDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type VarietyGradeDetailQuery = { __typename?: 'query_root', variety_grade_by_pk?: { __typename?: 'variety_grade', id: number, name: string, codename: string, variety: { __typename?: 'commodity_variety', id: number, name: string, codename: string, commodity: { __typename?: 'commodity', id: number, name: string, codename: string } } } | null };

export type AllSiUnitsQueryVariables = Exact<{
  type?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AllSiUnitsQuery = { __typename?: 'query_root', si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> };

export type UnitSiUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitSiUnitsQuery = { __typename?: 'query_root', si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> };

export type GetSharedEntityQueryVariables = Exact<{
  codename?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
}>;


export type GetSharedEntityQuery = { __typename?: 'query_root', setu_trade_shared_entity: Array<{ __typename?: 'setu_trade_shared_entity', id: any, name: string, department_config?: { __typename?: 'department_config', id: any, use_credit: boolean, seller_tds_percentage: any, seller_tds_amount: any } | null }> };

export type ExpenseParametersQueryVariables = Exact<{
  codename?: InputMaybe<Scalars['String']>;
}>;


export type ExpenseParametersQuery = { __typename?: 'query_root', expense_parameter: Array<{ __typename?: 'expense_parameter', id: any, name: string, codename: string }> };

export type PackingMaterialListQueryVariables = Exact<{ [key: string]: never; }>;


export type PackingMaterialListQuery = { __typename?: 'query_root', packaging: Array<{ __typename?: 'packaging', id: any, name: string, codename: string, material_code: string }> };

export type OrganisationPricingQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationPricingQuery = { __typename?: 'query_root', organisation_pricing?: { __typename?: 'OrganisationPricingGlType', id: string, supplier_rate: number, tax_percentage: number } | null };

export type StockStorageSummaryQueryVariables = Exact<{
  filters?: InputMaybe<StorageQueryFilterInput>;
  from?: InputMaybe<Scalars['Date']>;
  till?: InputMaybe<Scalars['Date']>;
}>;


export type StockStorageSummaryQuery = { __typename?: 'query_root', storage_summary?: { __typename?: 'StorageSummaryType', total_stock_items?: number | null, low_stock_items?: number | null, out_of_stock?: number | null, expiring_soon?: number | null, expired_stock?: number | null } | null };

export type StockManagementListQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']>;
  till?: InputMaybe<Scalars['Date']>;
  filter?: InputMaybe<StorageQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type StockManagementListQuery = { __typename?: 'query_root', storage_dashboard?: Array<{ __typename?: 'StorageCommoditySummaryType', actual_stock_kg?: number | null, virtual_stock_kg?: number | null, minimum_selling_quantity_kg?: number | null, last_updated?: any | null, total_opening_stock_kg?: number | null, total_consumed_stock_kg?: number | null, total_closing_stock_kg?: number | null, commodity?: { __typename?: 'SharedEntityType', id: string, name: string } | null, variety?: { __typename?: 'SharedEntityType', id: string, name: string } | null, grade?: { __typename?: 'SharedEntityType', id: string, name: string } | null, offers?: Array<{ __typename?: 'OfferType', id: string, created_at: any, quantity: number, total_amount: number } | null> | null, demands?: Array<{ __typename?: 'DemandType', id: string, created_at: any, quantity: number, total_amount: number } | null> | null, pattis?: Array<{ __typename?: 'StoragePattiType', id?: string | null, created_on?: any | null, patti_ref?: string | null, batch_number?: string | null, material?: string | null, storage_location?: string | null, ref_pattis?: string | null, opening_stock_kg?: number | null, consumed_stock_kg?: number | null, closing_stock_kg?: number | null, std_holding_days?: number | null, storage_status?: string | null, outward_actions?: Array<string | null> | null } | null> | null } | null> | null };

export type StockPattiListQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']>;
  till?: InputMaybe<Scalars['Date']>;
  filter?: InputMaybe<StorageQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type StockPattiListQuery = { __typename?: 'query_root', storage_dashboard?: Array<{ __typename?: 'StorageCommoditySummaryType', pattis?: Array<{ __typename?: 'StoragePattiType', id?: string | null } | null> | null } | null> | null };

export type RemainingStockQuantityQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
}>;


export type RemainingStockQuantityQuery = { __typename?: 'query_root', trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', deducted_quantity_remaining?: any | null } | null } | null, nodes: Array<{ __typename?: 'trade', id: any }> } };

export type AllStorageLocationAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStorageLocationAlertsQuery = { __typename?: 'query_root', all_storage_location_alerts?: Array<{ __typename?: 'StorageLocationAlertsType', icon?: number | null, message?: string | null, storage_location?: { __typename?: 'StorageLocationType', id: string, name: string, agreements: Array<{ __typename?: 'StorageLocationAgreementType', id: string, expiry_alert_days: number }> } | null } | null> | null };

export type AllStorageKindsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStorageKindsQuery = { __typename?: 'query_root', storage_location_kind: Array<{ __typename?: 'storage_location_kind', id: any, name: string }> };

export type StorageLocationSelectorQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type StorageLocationSelectorQuery = { __typename?: 'query_root', storage_location: Array<{ __typename?: 'storage_location', id: any, name: string, storage_location_agreements: Array<{ __typename?: 'storage_location_agreement', id: any, end_date: any }> }> };

export type StorageSubLocationSelectorQueryVariables = Exact<{
  where?: InputMaybe<Storage_Sub_Location_Bool_Exp>;
}>;


export type StorageSubLocationSelectorQuery = { __typename?: 'query_root', storage_sub_location: Array<{ __typename?: 'storage_sub_location', id: any, name: string }> };

export type AddUpdateStorageLocationsMutationVariables = Exact<{
  input: UpsertStorageLocationInput;
}>;


export type AddUpdateStorageLocationsMutation = { __typename?: 'mutation_root', add_update_storage_location?: { __typename?: 'AddUpdateStorageLocationMutation', storage_location?: { __typename?: 'StorageLocationType', id: string, name: string, codename: string } | null } | null };

export type AddUpdateAgreementTransactionsMutationVariables = Exact<{
  input: AgreementTransactionInput;
  agreementId: Scalars['ID'];
}>;


export type AddUpdateAgreementTransactionsMutation = { __typename?: 'mutation_root', add_update_agreement_transaction?: { __typename?: 'AddUpdateAgreementTransactionMutation', transaction_obj?: { __typename?: 'AgreementTransactionType', id: string, transaction_id: string, transaction_date: any, amount: number } | null } | null };

export type AllStorageLocationsQueryVariables = Exact<{
  filters?: InputMaybe<AllStorageLocationsFilterInput>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AllStorageLocationsQuery = { __typename?: 'query_root', all_storage_locations?: { __typename?: 'StorageLocationDashboardType', approved_storage_locations?: number | null, pending_storage_locations?: number | null, valid_agreement_storage_locations?: number | null, expiring_soon_agreement_storage_locations?: number | null, expired_agreement_storage_locations?: number | null, total_storage_locations?: number | null, storage_locations?: Array<{ __typename?: 'StorageLocationCustomListType', agreement_status?: string | null, trade_used_quantity_metric_ton?: number | null, total_capacity_quantity_metric_ton?: number | null, storage_location?: { __typename?: 'StorageLocationType', id: string, name: string, codename: string, address?: { __typename?: 'SetuTradeAddressType', id: string, name?: string | null, village?: string | null, raw_address?: string | null, pincode?: string | null, location?: string | null } | null, pocs: Array<{ __typename?: 'SharedEntityType', id: string, name: string }>, sub_locations: Array<{ __typename?: 'StorageSubLocationType', id: string, name: string, codename: string, capacity: number, kind: { __typename?: 'StorageLocationKindType', id: string, name: string }, capacity_unit: { __typename?: 'SharedEntityType', id: string, name: string } }> } | null, current_agreement?: { __typename?: 'StorageLocationAgreementType', id: string, is_active: boolean, created_at: any, is_verified?: boolean | null, start_date: any, end_date: any, lease_amount?: number | null, lease_tenure_kind?: StockStorageLocationAgreementLeaseTenureKindChoices | null, created_by?: { __typename?: 'UserCustomType', id?: string | null, name?: string | null } | null } | null, alerts?: Array<{ __typename?: 'StorageLocationAlertsType', icon?: number | null, title?: string | null, message?: string | null } | null> | null } | null> | null } | null };

export type StorageLocationDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type StorageLocationDetailQuery = { __typename?: 'query_root', storage_location_by_pk?: { __typename?: 'storage_location', id: any, name: string, codename: string, capacity: any, summary?: { __typename?: 'StorageLocationSummaryType', next_payment_date?: any | null } | null, pocs: Array<{ __typename?: 'storage_location_pocs', id: any, user: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }>, capacity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, trades_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', deducted_quantity_kg?: any | null } | null } | null }, storage_sub_locations: Array<{ __typename?: 'storage_sub_location', id: any, name: string, codename: string, capacity: any, capacity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, storage_location_kind: { __typename?: 'storage_location_kind', id: any, name: string }, trades_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', deducted_quantity_kg?: any | null } | null } | null } }>, address?: { __typename?: 'setu_trade_address', id: any, village?: string | null, taluka?: string | null, district?: string | null, state?: string | null, pincode?: string | null, location?: any | null, local_area?: string | null, country?: string | null, raw_address?: string | null } | null, pending_agreement: Array<{ __typename?: 'storage_location_agreement', id: any, name: string, ownership_kind: string, lease_amount?: any | null, lease_tenure_kind?: string | null, expiry_alert_days: number, is_verified?: boolean | null, is_active: boolean, start_date: any, end_date: any, tnc?: string | null, agreement_no?: string | null, description: string, agreement_transactions: Array<{ __typename?: 'agreement_transaction', id: any, amount: any, transaction_id: string, account_holder_name: string, account_number: string, bank_name: string, ifsc_code: string, mode_of_payment: string, transaction_date: any, attachments: Array<{ __typename?: 'agreement_transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }> }>, attachments: Array<{ __typename?: 'storage_location_agreement_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }> }>, current_agreement: Array<{ __typename?: 'storage_location_agreement', id: any, name: string, ownership_kind: string, lease_amount?: any | null, lease_tenure_kind?: string | null, expiry_alert_days: number, is_verified?: boolean | null, start_date: any, is_active: boolean, end_date: any, tnc?: string | null, agreement_no?: string | null, description: string, agreement_transactions: Array<{ __typename?: 'agreement_transaction', id: any, amount: any, transaction_id: string, account_holder_name: string, account_number: string, bank_name: string, ifsc_code: string, mode_of_payment: string, transaction_date: any, attachments: Array<{ __typename?: 'agreement_transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }> }>, attachments: Array<{ __typename?: 'storage_location_agreement_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }> }>, previous_agreements: Array<{ __typename?: 'storage_location_agreement', id: any, name: string, ownership_kind: string, lease_amount?: any | null, lease_tenure_kind?: string | null, expiry_alert_days: number, is_verified?: boolean | null, start_date: any, is_active: boolean, end_date: any, tnc?: string | null, agreement_no?: string | null, description: string, agreement_transactions: Array<{ __typename?: 'agreement_transaction', id: any, amount: any, transaction_id: string, account_holder_name: string, account_number: string, bank_name: string, ifsc_code: string, mode_of_payment: string, transaction_date: any, attachments: Array<{ __typename?: 'agreement_transaction_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null, kind: string } }> }>, attachments: Array<{ __typename?: 'storage_location_agreement_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, url?: string | null } }> }> } | null };

export type CreateExpensesTemplatesMutationVariables = Exact<{
  department: Scalars['Int'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  expenses: Array<InputMaybe<ExpensesConfigSchema>> | InputMaybe<ExpensesConfigSchema>;
}>;


export type CreateExpensesTemplatesMutation = { __typename?: 'mutation_root', create_expenses_config?: { __typename?: 'CreateExpenseConfigMutation', version?: number | null, department_id?: number | null, trade_kind?: string | null, trade_mode?: string | null, expenses_details?: Array<{ __typename?: 'OrganisationTradeExpensesTemplateSchema', expense_parameter?: string | null, kind?: string | null, buyer_charge?: any | null, seller_charge?: any | null } | null> | null } | null };

export type CreateTnCsConfigMutationVariables = Exact<{
  department: Scalars['Int'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  terms: Scalars['String'];
  party: Scalars['String'];
}>;


export type CreateTnCsConfigMutation = { __typename?: 'mutation_root', create_tnc_config?: { __typename?: 'CreateTNCConfigMutation', version?: number | null, trade_party?: string | null, conditions?: string | null } | null };

export type TemplateSelectorQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Template_Select_Column> | Template_Select_Column>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Template_Order_By> | Template_Order_By>;
  where?: InputMaybe<Template_Bool_Exp>;
}>;


export type TemplateSelectorQuery = { __typename?: 'query_root', template: Array<{ __typename?: 'template', id: any, name: string }> };

export type TimelineQueryVariables = Exact<{
  tradeId: Scalars['bigint'];
}>;


export type TimelineQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, tracking_code: string, total_amount?: any | null, action_logs: Array<{ __typename?: 'trade_action_log', id: any, created_at: any, change_object?: any | null, change_message: string, change_title: string, created_by?: { __typename?: 'base_user', id: number, full_name?: string | null } | null }>, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, current_address?: { __typename?: 'address', id: number, village?: string | null } | null }> } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, current_address?: { __typename?: 'address', id: number, village?: string | null } | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null } | null };

export type TradeTimeLineQueryVariables = Exact<{
  tradeId?: InputMaybe<Scalars['ID']>;
  productionTradeId?: InputMaybe<Scalars['ID']>;
}>;


export type TradeTimeLineQuery = { __typename?: 'query_root', trade_timeline?: Array<{ __typename?: 'TimelineItemSchema', sequence?: number | null, title?: string | null, msg?: string | null, date?: string | null, parent_trade_id?: string | null, is_current?: boolean | null, parent_trade_title?: string | null } | null> | null };

export type AdvancePayFragFragment = { __typename?: 'advance_payment', id: any, amount?: any | null, bourn_by?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions: Array<{ __typename?: 'transaction', created_at: any, remark?: string | null, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, mode: { __typename?: 'Transaction_mode', name: string } }> };

export type CreditNoteFragFragment = { __typename?: 'credit_note', id: any, amount?: any | null, remarks?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any };

export type TradeDetailFragFragment = { __typename?: 'trade', id: any, is_intercompany_transaction: boolean, tracking_code: string, advance_po: boolean, material_kind?: string | null, status_processing: boolean, receipt_id?: any | null, demand_id?: any | null, offer_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, supplier_charge?: any | null, seller_tds?: any | null, seller_tds_percentage?: any | null, buyer_expense_amount?: any | null, seller_expense_amount?: any | null, seller_payable?: number | null, buyer_payable?: number | null, deducted_quantity?: any | null, expense_amount?: any | null, is_multiple_commodity: boolean, supplier_expense_gst_auto_calculated: boolean, buyer_expense_gst_auto_calculated: boolean, status?: string | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, settled_by_advance_payment: Array<{ __typename?: 'transaction', id: any, ref?: string | null, amount: any, parent_transaction?: { __typename?: 'transaction', advance_payment?: { __typename?: 'advance_payment', id: any, trade?: { __typename?: 'trade', id: any, kind: string } | null } | null } | null }>, over_due_approval?: { __typename?: 'over_due_approval_cw', id: any } | null, over_draft?: { __typename?: 'over_draft_cw', id: any, status: string, logs: Array<{ __typename?: 'over_draft_log_cw', id: any, status: string, user?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null }> } | null, storage_location?: { __typename?: 'storage_location', id: any, name: string, codename: string, storage_location_agreements: Array<{ __typename?: 'storage_location_agreement', id: any, end_date: any }> } | null, storage_sub_location?: { __typename?: 'storage_sub_location', id: any, name: string, codename: string } | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, trip?: { __typename?: 'setutrade_trip', id: number } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, invoice?: { __typename?: 'invoice', id: any } | null, vehicle?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string } | null, trades: Array<{ __typename?: 'trade', id: any, kind: string, start_date?: any | null }>, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null, demand_id?: any | null, offer_id?: any | null, is_multiple_commodity: boolean, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, credits: Array<{ __typename?: 'credit', over_drafts_aggregate: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number } | null } }>, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, attachments: Array<{ __typename?: 'trade_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, etag?: string | null, url?: string | null, key: string, kind: string } }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', returned_quantity?: any | null } | null } | null }, trade_items: Array<{ __typename?: 'trade_item', id: any, batch_number?: string | null, quantity: any, rate: any, daily_rate?: any | null, supplier_gst_auto_calculated: boolean, buyer_gst_auto_calculated: boolean, total_amount?: any | null, result?: { __typename?: 'setu_trade_shared_entity', id: any, codename: string, result: Array<{ __typename?: 'result', id: any, name: string, codename: string, sample_id: any, sample: { __typename?: 'sample', id: any, sample_request_id: any }, template: { __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> }, evaluations: Array<{ __typename?: 'result_evaluation', value: any }>, observations: Array<{ __typename?: 'result_observation', id: any, template_parameter_id?: any | null, value: any, template_parameter?: { __typename?: 'template_parameter', id: any, quality_parameter_id: any } | null, sample_observation?: { __typename?: 'sample_observation', id: any, observation_number: number, attachments: Array<{ __typename?: 'sample_observation_attachments', id: any, media: { __typename?: 'eagle_media', id: any, url?: string | null, media_kind: string } }> } | null }> }> } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }> }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, advance_payments: Array<{ __typename?: 'advance_payment', id: any, amount?: any | null, bourn_by?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions: Array<{ __typename?: 'transaction', created_at: any, remark?: string | null, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, mode: { __typename?: 'Transaction_mode', name: string } }> }>, credit_notes: Array<{ __typename?: 'credit_note', id: any, amount?: any | null, remarks?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any }>, expense_taxes: Array<{ __typename?: 'trade_expense_tax', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }>, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }>, seller_gst_attachments: Array<{ __typename?: 'trade_seller_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }>, buyer_gst_attachments: Array<{ __typename?: 'trade_buyer_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }> };

export type TradeDetailFrag2Fragment = { __typename?: 'trade', id: any, tracking_code: string, advance_po: boolean, status_processing: boolean, receipt_id?: any | null, demand_id?: any | null, offer_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, supplier_charge?: any | null, seller_tds?: any | null, seller_tds_percentage?: any | null, buyer_expense_amount?: any | null, seller_expense_amount?: any | null, deducted_quantity?: any | null, expense_amount?: any | null, is_multiple_commodity: boolean, status?: string | null, over_draft?: { __typename?: 'over_draft_cw', id: any, status: string, logs: Array<{ __typename?: 'over_draft_log_cw', id: any, status: string, user?: { __typename?: 'setu_trade_shared_entity', name: string } | null }> } | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, trip?: { __typename?: 'setutrade_trip', id: number } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, invoice?: { __typename?: 'invoice', id: any } | null, vehicle?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string } | null, trades: Array<{ __typename?: 'trade', id: any, kind: string, start_date?: any | null }>, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null, demand_id?: any | null, offer_id?: any | null, is_multiple_commodity: boolean, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, credits: Array<{ __typename?: 'credit', over_drafts_aggregate: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number } | null } }>, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, attachments: Array<{ __typename?: 'trade_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, etag?: string | null, url?: string | null, key: string, kind: string } }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', returned_quantity?: any | null } | null } | null }, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, daily_rate?: any | null, supplier_gst_auto_calculated: boolean, buyer_gst_auto_calculated: boolean, total_amount?: any | null, result?: { __typename?: 'setu_trade_shared_entity', id: any, codename: string, result: Array<{ __typename?: 'result', id: any, name: string, codename: string, sample_id: any, sample: { __typename?: 'sample', id: any, sample_request_id: any }, template: { __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> }, evaluations: Array<{ __typename?: 'result_evaluation', value: any }>, observations: Array<{ __typename?: 'result_observation', id: any, template_parameter_id?: any | null, value: any, template_parameter?: { __typename?: 'template_parameter', id: any, quality_parameter_id: any } | null, sample_observation?: { __typename?: 'sample_observation', id: any, observation_number: number, attachments: Array<{ __typename?: 'sample_observation_attachments', id: any, media: { __typename?: 'eagle_media', id: any, url?: string | null, media_kind: string } }> } | null }> }> } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }> }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, advance_payments: Array<{ __typename?: 'advance_payment', id: any, amount?: any | null, bourn_by?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions: Array<{ __typename?: 'transaction', created_at: any, remark?: string | null, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, mode: { __typename?: 'Transaction_mode', name: string } }> }>, credit_notes: Array<{ __typename?: 'credit_note', id: any, amount?: any | null, remarks?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any }>, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }>, seller_gst_attachments: Array<{ __typename?: 'trade_seller_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }>, buyer_gst_attachments: Array<{ __typename?: 'trade_buyer_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }> };

export type TradeHashesQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type TradeHashesQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, seller_hash?: string | null, buyer_hash?: string | null } | null };

export type TradesHashesQueryVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type TradesHashesQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, seller_hash?: string | null, buyer_hash?: string | null }> };

export type AllTradeRequestsIdsQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
}>;


export type AllTradeRequestsIdsQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, kind: string, current_status_id?: string | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string } }> };

export type AllTradeRequestsQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
}>;


export type AllTradeRequestsQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, advance_po: boolean, status_processing: boolean, receipt_id?: any | null, tracking_code: string, created_at: any, kind: string, is_multiple_commodity: boolean, seller_verification?: boolean | null, buyer_verification?: boolean | null, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, deducted_quantity_remaining?: any | null, expense_amount?: any | null, standard_deduction?: any | null, current_status_id?: string | null, updated_at: any, action_logs: Array<{ __typename?: 'trade_action_log', id: any, change_message: string, created_by?: { __typename?: 'base_user', full_name?: string | null } | null }>, credit: Array<{ __typename?: 'issuance_note', id: any, is_verified?: boolean | null }>, debit: Array<{ __typename?: 'issuance_note', id: any, is_verified?: boolean | null }>, over_draft?: { __typename?: 'over_draft_cw', id: any, amount: any } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, trip?: { __typename?: 'setutrade_trip', id: number } | null, invoice?: { __typename?: 'invoice', id: any, current_status_id?: string | null } | null, parent_trade?: { __typename?: 'trade', id: any, demand_id?: any | null, offer_id?: any | null } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, current_address?: { __typename?: 'address', id: number, village?: string | null } | null }> } | null, trades_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null }, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, is_blocked?: boolean | null, full_name?: string | null, external_reference_id?: string | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, item_units: Array<{ __typename?: 'trade_item', id: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string } }>, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, amount?: any | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', quantity?: any | null, returned_quantity?: any | null } | null, avg?: { __typename?: 'trade_item_avg_fields', rate?: number | null } | null } | null }, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null }> }>, trade_statuses: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number, min?: { __typename?: 'trade_min_fields', current_status_id?: string | null } | null } | null }, trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null } };

export type TradeListSelectorQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
}>;


export type TradeListSelectorQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, advance_po: boolean, status_processing: boolean, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, deducted_quantity_remaining?: any | null, expense_amount?: any | null, standard_deduction?: any | null, supplier_charge?: any | null, current_status_id?: string | null, updated_at: any, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, buyer_bifurcation?: { __typename?: 'BuyerBifurcationType', total?: number | null, deducted_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_expense_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_debit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_credit_note_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, buyer_tax_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null, received_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, full_name?: string | null, number: string, is_blocked?: boolean | null, external_reference_id?: string | null }> } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, is_blocked?: boolean | null, full_name?: string | null, external_reference_id?: string | null }> } | null, item_units: Array<{ __typename?: 'trade_item', id: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string } }>, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, amount?: any | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }> }> }> };

export type AllTradeRequestsStatusSubscriptionVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
}>;


export type AllTradeRequestsStatusSubscription = { __typename?: 'subscription_root', trade: Array<{ __typename?: 'trade', id: any, current_status_id?: string | null, status_processing: boolean }> };

export type UpsertTradeMutationVariables = Exact<{
  input: TradeInput;
}>;


export type UpsertTradeMutation = { __typename?: 'mutation_root', add_update_trade?: { __typename?: 'AddUpdateTradeMutation', trade: { __typename?: 'TradeType', id: string } } | null };

export type UpdateTradeAttachmentsMutationVariables = Exact<{
  input: Trade_Insert_Input;
}>;


export type UpdateTradeAttachmentsMutation = { __typename?: 'mutation_root', insert_trade_one?: { __typename?: 'trade', id: any } | null };

export type BroadcastConsentMutationVariables = Exact<{
  trade_id: Scalars['ID'];
  send_to_buyer?: InputMaybe<Scalars['Boolean']>;
  send_to_seller?: InputMaybe<Scalars['Boolean']>;
}>;


export type BroadcastConsentMutation = { __typename?: 'mutation_root', broadcast_consents?: { __typename?: 'BroadcastConsents', buyer_status?: boolean | null, seller_status?: boolean | null } | null };

export type TradeDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type TradeDetailQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, is_intercompany_transaction: boolean, tracking_code: string, advance_po: boolean, material_kind?: string | null, status_processing: boolean, receipt_id?: any | null, demand_id?: any | null, offer_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, supplier_charge?: any | null, seller_tds?: any | null, seller_tds_percentage?: any | null, buyer_expense_amount?: any | null, seller_expense_amount?: any | null, seller_payable?: number | null, buyer_payable?: number | null, deducted_quantity?: any | null, expense_amount?: any | null, is_multiple_commodity: boolean, supplier_expense_gst_auto_calculated: boolean, buyer_expense_gst_auto_calculated: boolean, status?: string | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, settled_by_advance_payment: Array<{ __typename?: 'transaction', id: any, ref?: string | null, amount: any, parent_transaction?: { __typename?: 'transaction', advance_payment?: { __typename?: 'advance_payment', id: any, trade?: { __typename?: 'trade', id: any, kind: string } | null } | null } | null }>, over_due_approval?: { __typename?: 'over_due_approval_cw', id: any } | null, over_draft?: { __typename?: 'over_draft_cw', id: any, status: string, logs: Array<{ __typename?: 'over_draft_log_cw', id: any, status: string, user?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null }> } | null, storage_location?: { __typename?: 'storage_location', id: any, name: string, codename: string, storage_location_agreements: Array<{ __typename?: 'storage_location_agreement', id: any, end_date: any }> } | null, storage_sub_location?: { __typename?: 'storage_sub_location', id: any, name: string, codename: string } | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, trip?: { __typename?: 'setutrade_trip', id: number } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, invoice?: { __typename?: 'invoice', id: any } | null, vehicle?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string } | null, trades: Array<{ __typename?: 'trade', id: any, kind: string, start_date?: any | null }>, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null, demand_id?: any | null, offer_id?: any | null, is_multiple_commodity: boolean, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, credits: Array<{ __typename?: 'credit', over_drafts_aggregate: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number } | null } }>, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, attachments: Array<{ __typename?: 'trade_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, etag?: string | null, url?: string | null, key: string, kind: string } }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', returned_quantity?: any | null } | null } | null }, trade_items: Array<{ __typename?: 'trade_item', id: any, batch_number?: string | null, quantity: any, rate: any, daily_rate?: any | null, supplier_gst_auto_calculated: boolean, buyer_gst_auto_calculated: boolean, total_amount?: any | null, result?: { __typename?: 'setu_trade_shared_entity', id: any, codename: string, result: Array<{ __typename?: 'result', id: any, name: string, codename: string, sample_id: any, sample: { __typename?: 'sample', id: any, sample_request_id: any }, template: { __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> }, evaluations: Array<{ __typename?: 'result_evaluation', value: any }>, observations: Array<{ __typename?: 'result_observation', id: any, template_parameter_id?: any | null, value: any, template_parameter?: { __typename?: 'template_parameter', id: any, quality_parameter_id: any } | null, sample_observation?: { __typename?: 'sample_observation', id: any, observation_number: number, attachments: Array<{ __typename?: 'sample_observation_attachments', id: any, media: { __typename?: 'eagle_media', id: any, url?: string | null, media_kind: string } }> } | null }> }> } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }> }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, advance_payments: Array<{ __typename?: 'advance_payment', id: any, amount?: any | null, bourn_by?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions: Array<{ __typename?: 'transaction', created_at: any, remark?: string | null, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, mode: { __typename?: 'Transaction_mode', name: string } }> }>, credit_notes: Array<{ __typename?: 'credit_note', id: any, amount?: any | null, remarks?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any }>, expense_taxes: Array<{ __typename?: 'trade_expense_tax', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }>, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }>, seller_gst_attachments: Array<{ __typename?: 'trade_seller_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }>, buyer_gst_attachments: Array<{ __typename?: 'trade_buyer_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }> } | null };

export type UpdateTradeMutationVariables = Exact<{
  id: Scalars['bigint'];
  _set?: InputMaybe<Trade_Set_Input>;
}>;


export type UpdateTradeMutation = { __typename?: 'mutation_root', update_trade_by_pk?: { __typename?: 'trade', id: any, is_intercompany_transaction: boolean, tracking_code: string, advance_po: boolean, material_kind?: string | null, status_processing: boolean, receipt_id?: any | null, demand_id?: any | null, offer_id?: any | null, standard_deduction?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, packaging: string, seller_tnc?: string | null, buyer_tnc?: string | null, seller_verification?: boolean | null, buyer_verification?: boolean | null, mode: string, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, supplier_charge?: any | null, seller_tds?: any | null, seller_tds_percentage?: any | null, buyer_expense_amount?: any | null, seller_expense_amount?: any | null, seller_payable?: number | null, buyer_payable?: number | null, deducted_quantity?: any | null, expense_amount?: any | null, is_multiple_commodity: boolean, supplier_expense_gst_auto_calculated: boolean, buyer_expense_gst_auto_calculated: boolean, status?: string | null, seller_bifurcation?: { __typename?: 'SellerBifurcationType', advance_amount?: { __typename?: 'OperationValueType', op?: string | null, val?: number | null } | null } | null, settled_by_advance_payment: Array<{ __typename?: 'transaction', id: any, ref?: string | null, amount: any, parent_transaction?: { __typename?: 'transaction', advance_payment?: { __typename?: 'advance_payment', id: any, trade?: { __typename?: 'trade', id: any, kind: string } | null } | null } | null }>, over_due_approval?: { __typename?: 'over_due_approval_cw', id: any } | null, over_draft?: { __typename?: 'over_draft_cw', id: any, status: string, logs: Array<{ __typename?: 'over_draft_log_cw', id: any, status: string, user?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null }> } | null, storage_location?: { __typename?: 'storage_location', id: any, name: string, codename: string, storage_location_agreements: Array<{ __typename?: 'storage_location_agreement', id: any, end_date: any }> } | null, storage_sub_location?: { __typename?: 'storage_sub_location', id: any, name: string, codename: string } | null, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, trip?: { __typename?: 'setutrade_trip', id: number } | null, department: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, invoice?: { __typename?: 'invoice', id: any } | null, vehicle?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, codename: string } | null, trades: Array<{ __typename?: 'trade', id: any, kind: string, start_date?: any | null }>, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null, demand_id?: any | null, offer_id?: any | null, is_multiple_commodity: boolean, officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, junior_officer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, credits: Array<{ __typename?: 'credit', over_drafts_aggregate: { __typename?: 'over_draft_aggregate', aggregate?: { __typename?: 'over_draft_aggregate_fields', count: number } | null } }>, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, number: string, is_blocked?: boolean | null, external_reference_id?: string | null, is_verified?: boolean | null, created_at: any, codename: string, name?: string | null, photo?: { __typename?: 'media', id: number, url: string } | null, companies: Array<{ __typename?: 'base_user_companies', id: number, company: { __typename?: 'company', id: number, name: string, display_name: string, codename: string } }>, my_businesses: Array<{ __typename?: 'business', id: number }>, current_address?: { __typename?: 'address', id: number, raw_address?: string | null, state_region?: { __typename?: 'region', code?: string | null } | null } | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, facilitator?: { __typename?: 'setu_trade_shared_entity', id: any, facilitator: Array<{ __typename?: 'company', id: number, name: string, codename: string }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, attachments: Array<{ __typename?: 'trade_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, etag?: string | null, url?: string | null, key: string, kind: string } }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', returned_quantity?: any | null } | null } | null }, trade_items: Array<{ __typename?: 'trade_item', id: any, batch_number?: string | null, quantity: any, rate: any, daily_rate?: any | null, supplier_gst_auto_calculated: boolean, buyer_gst_auto_calculated: boolean, total_amount?: any | null, result?: { __typename?: 'setu_trade_shared_entity', id: any, codename: string, result: Array<{ __typename?: 'result', id: any, name: string, codename: string, sample_id: any, sample: { __typename?: 'sample', id: any, sample_request_id: any }, template: { __typename?: 'template', id: any, name: string, grade?: { __typename?: 'grade', id: any, name: string } | null, template_parameters: Array<{ __typename?: 'template_parameter', id: any, standard: string, weightage: any, observation_count: number, configurations: Array<{ __typename?: 'template_parameter_config', id: any, comparator: string, value: any, evaluation_criteria: { __typename?: 'evaluation_criteria', id: any, tag: { __typename?: 'evaluation_tag', id: any, name: string } } }>, quality_parameter: { __typename?: 'quality_parameter', id: any, name: string } }> }, evaluations: Array<{ __typename?: 'result_evaluation', value: any }>, observations: Array<{ __typename?: 'result_observation', id: any, template_parameter_id?: any | null, value: any, template_parameter?: { __typename?: 'template_parameter', id: any, quality_parameter_id: any } | null, sample_observation?: { __typename?: 'sample_observation', id: any, observation_number: number, attachments: Array<{ __typename?: 'sample_observation_attachments', id: any, media: { __typename?: 'eagle_media', id: any, url?: string | null, media_kind: string } }> } | null }> }> } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, commodity: Array<{ __typename?: 'commodity', id: number, name: string, codename: string, crop_id?: number | null }> } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, commodity_variety: Array<{ __typename?: 'commodity_variety', id: number, name: string, codename: string, crop_variety_id?: number | null, organisation_commodity_variety_configs: Array<{ __typename?: 'organisation_commodity_variety_config', id: number, commodity_variety_id?: number | null, taxes: Array<{ __typename?: 'organisation_commodity_variety_config_taxes', id: number, tax: { __typename?: 'vt_core_tax', id: number, name: string, percentage: any } }> }> }> } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, plot_crop: Array<{ __typename?: 'plot_crop', id: number, external_reference_id?: string | null, tag: string, name: string, codename: string }> } | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, variety_grade: Array<{ __typename?: 'variety_grade', id: number, name: string, codename: string }> } | null, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, si_unit: Array<{ __typename?: 'si_unit', id: number, name: string, codename: string, base_conversion: any }> }, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }> }>, expenses: Array<{ __typename?: 'expense', id: any, paid_by: string, kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, codename: string, name: string } }>, advance_payments: Array<{ __typename?: 'advance_payment', id: any, amount?: any | null, bourn_by?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any, parameter: { __typename?: 'advance_payment_parameters', id: any, name: string }, transactions: Array<{ __typename?: 'transaction', created_at: any, remark?: string | null, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, mode: { __typename?: 'Transaction_mode', name: string } }> }>, credit_notes: Array<{ __typename?: 'credit_note', id: any, amount?: any | null, remarks?: string | null, user_id?: any | null, is_verified?: boolean | null, created_at: any }>, expense_taxes: Array<{ __typename?: 'trade_expense_tax', id: any, amount?: any | null, role: string, percentage: any, tax_name: string }>, taxes: Array<{ __typename?: 'trade_taxes', id: any, amount?: any | null, percentage: any, role: string, tax_name: string }>, seller_gst_attachments: Array<{ __typename?: 'trade_seller_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }>, buyer_gst_attachments: Array<{ __typename?: 'trade_buyer_gst_attachments', id: any, media: { __typename?: 'setutrade_media', id: any, kind: string, url?: string | null } }> } | null };

export type IncrementTradeCounterMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type IncrementTradeCounterMutation = { __typename?: 'mutation_root', update_trade_by_pk?: { __typename?: 'trade', id: any, trade_amounts_counter: number } | null };

export type FinalTradeListQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['bigint']>;
}>;


export type FinalTradeListQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, kind: string, start_date?: any | null, demand_id?: any | null, offer_id?: any | null, parent_trade?: { __typename?: 'trade', id: any, kind: string, start_date?: any | null, demand_id?: any | null, offer_id?: any | null } | null, trades: Array<{ __typename?: 'trade', id: any, kind: string, start_date?: any | null }> }> };

export type BulkUpdateTradeMutationVariables = Exact<{
  where: Trade_Bool_Exp;
  set: Trade_Set_Input;
}>;


export type BulkUpdateTradeMutation = { __typename?: 'mutation_root', update_trade?: { __typename?: 'trade_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'trade', id: any, current_status_id?: string | null, status_processing: boolean }> } | null };

export type TradeAdvancePendingStatusQueryVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type TradeAdvancePendingStatusQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, current_status_id?: string | null, advance_payments: Array<{ __typename?: 'advance_payment', id: any, is_verified?: boolean | null }> }> };

export type BookingTradeSummaryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BookingTradeSummaryQuery = { __typename?: 'query_root', trade_grade_quantity_summary_report?: { __typename?: 'TradeGradeSummaryReportSchema', more_trade?: boolean | null, grade_summary?: Array<{ __typename?: 'TradeGradeSummarySchema', variety_grade_id?: number | null, remaining_quantity?: number | null, booked_quantity?: number | null, variety_grade_name?: string | null } | null> | null } | null };

export type ExpenseConfigVersionsQueryVariables = Exact<{
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
}>;


export type ExpenseConfigVersionsQuery = { __typename?: 'query_root', expense_config_versions?: Array<{ __typename?: 'OrganisationTradeExpensesVersionSchema', version_id?: number | null, name?: string | null, kind?: string | null, mode?: string | null } | null> | null };

export type AdancedPaymentParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdancedPaymentParametersQuery = { __typename?: 'query_root', advance_payment_parameters: Array<{ __typename?: 'advance_payment_parameters', id: any, name: string }> };

export type ExpenseConfigsQueryVariables = Exact<{
  version?: InputMaybe<Scalars['ID']>;
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
}>;


export type ExpenseConfigsQuery = { __typename?: 'query_root', expense_configs?: Array<{ __typename?: 'OrganisationTradeExpenseConfigType', id: string, paid_by?: string | null, kind?: string | null, value: any, expense_parameter: { __typename?: 'ExpenseParameterType', id: string, name: string } } | null> | null };

export type GradeQuantitySummaryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['bigint']>;
  grade?: InputMaybe<Scalars['String']>;
}>;


export type GradeQuantitySummaryQuery = { __typename?: 'query_root', booked_quantity: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', quantity?: any | null } | null } | null }, total_quantity: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', quantity?: any | null } | null } | null } };

export type TradeSelectorQueryVariables = Exact<{
  where?: InputMaybe<Trade_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trade_Order_By> | Trade_Order_By>;
}>;


export type TradeSelectorQuery = { __typename?: 'query_root', trade: Array<{ __typename?: 'trade', id: any, created_at: any, kind: string, total_amount?: any | null, total_quantity?: any | null, deducted_amount?: any | null, deducted_quantity?: any | null, expense_amount?: any | null, standard_deduction?: any | null, deducted_quantity_remaining?: any | null, updated_at: any, trades_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', sum?: { __typename?: 'trade_sum_fields', total_quantity?: any | null } | null } | null }, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, is_blocked?: boolean | null, full_name?: string | null, external_reference_id?: string | null }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, is_blocked?: boolean | null, full_name?: string | null, external_reference_id?: string | null }> } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, item_units: Array<{ __typename?: 'trade_item', id: any, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string, reference_id: string } }>, trade_items: Array<{ __typename?: 'trade_item', id: any, rate: any, quantity: any, amount?: any | null, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', quantity?: any | null } | null, avg?: { __typename?: 'trade_item_avg_fields', rate?: number | null } | null } | null } }>, trade_aggregate: { __typename?: 'trade_aggregate', aggregate?: { __typename?: 'trade_aggregate_fields', count: number } | null } };

export type DeleteSellerGstAttachmentsMutationVariables = Exact<{
  media_id: Array<Scalars['bigint']> | Scalars['bigint'];
  id: Scalars['Int'];
}>;


export type DeleteSellerGstAttachmentsMutation = { __typename?: 'mutation_root', delete_trade_seller_gst_attachments?: { __typename?: 'trade_seller_gst_attachments_mutation_response', returning: Array<{ __typename?: 'trade_seller_gst_attachments', id: any }> } | null, delete_media_by_pk?: { __typename?: 'media', id: number } | null };

export type DeleteBuyerGstAttachmentsMutationVariables = Exact<{
  media_id: Array<Scalars['bigint']> | Scalars['bigint'];
  id: Scalars['Int'];
}>;


export type DeleteBuyerGstAttachmentsMutation = { __typename?: 'mutation_root', delete_trade_buyer_gst_attachments?: { __typename?: 'trade_buyer_gst_attachments_mutation_response', returning: Array<{ __typename?: 'trade_buyer_gst_attachments', id: any }> } | null, delete_media_by_pk?: { __typename?: 'media', id: number } | null };

export type TradeStatusesQueryVariables = Exact<{
  where?: InputMaybe<Trade_Status_Bool_Exp>;
}>;


export type TradeStatusesQuery = { __typename?: 'query_root', trade_status: Array<{ __typename?: 'trade_status', id: string, category: string }> };

export type TncConfigVersionsQueryVariables = Exact<{
  department?: InputMaybe<Scalars['ID']>;
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
}>;


export type TncConfigVersionsQuery = { __typename?: 'query_root', trade_tnc_versions?: Array<{ __typename?: 'OrganisationTradeTNCsVersionSchema', name?: string | null, kind?: string | null, mode?: string | null, role?: string | null, id?: number | null } | null> | null };

export type TncConfigsQueryVariables = Exact<{
  version: Scalars['ID'];
  department: Scalars['ID'];
  kind: Scalars['String'];
  mode: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
}>;


export type TncConfigsQuery = { __typename?: 'query_root', trade_tnc_template_detail?: { __typename?: 'OrganisationTradeTNCsTemplateSchema', seller?: string | null, buyer?: string | null } | null };

export type InsertTransactionMutationVariables = Exact<{
  object: Transaction_Insert_Input;
  onConflict?: InputMaybe<Transaction_On_Conflict>;
}>;


export type InsertTransactionMutation = { __typename?: 'mutation_root', insert_transaction_one?: { __typename?: 'transaction', id: any, amount: any, trade_id?: any | null, mode_id: any, transaction_id: string, bank_id?: any | null } | null };

export type TransactionDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type TransactionDetailQuery = { __typename?: 'query_root', transaction_by_pk?: { __typename?: 'transaction', id: any, created_at: any, date: any, amount: any, transaction_id: string, account_no?: string | null, trade?: { __typename?: 'trade', id: any, kind: string } | null, advance_payment?: { __typename?: 'advance_payment', parameter: { __typename?: 'advance_payment_parameters', name: string } } | null, mode: { __typename?: 'Transaction_mode', name: string } } | null };

export type AllTripsQueryVariables = Exact<{
  where?: InputMaybe<Setutrade_Trip_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Setutrade_Trip_Order_By> | Setutrade_Trip_Order_By>;
}>;


export type AllTripsQuery = { __typename?: 'query_root', setutrade_trip: Array<{ __typename?: 'setutrade_trip', created_at: any, id: number, aggregator_name?: string | null, aggregator_number?: string | null, driver_name?: string | null, driver_number?: string | null, source_location_name?: string | null, destination_location_name?: string | null, estimated_date?: any | null, status: string, vehicle: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null }>, trades: Array<{ __typename?: 'trade', id: any, deducted_quantity?: any | null, deducted_amount?: any | null, buyer_payable?: number | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, user: Array<{ __typename?: 'base_user', id: number, reference_id: string, full_name?: string | null, external_reference_id2?: string | null }> } | null }> }>, setutrade_trip_aggregate: { __typename?: 'setutrade_trip_aggregate', aggregate?: { __typename?: 'setutrade_trip_aggregate_fields', count: number } | null } };

export type AddUpdateSetutradeTripMutationVariables = Exact<{
  input?: InputMaybe<TradeTripMutationInput>;
}>;


export type AddUpdateSetutradeTripMutation = { __typename?: 'mutation_root', add_update_setutrade_trip?: { __typename?: 'AddUpdateTripMutation', trip?: { __typename?: 'TripType', id: string, trades: Array<{ __typename?: 'TradeType', id: string }> } | null } | null };

export type TripTraderSummaryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type TripTraderSummaryQuery = { __typename?: 'query_root', trip_trader_summary?: Array<{ __typename?: 'TripTraderSummaryType', trade_count?: number | null, buyer_payable?: number | null, trader?: { __typename?: 'SharedEntityType', id: string, name: string } | null, commodities?: Array<{ __typename?: 'SharedEntityType', id: string, name: string } | null> | null, commodity_varieties?: Array<{ __typename?: 'SharedEntityType', id: string, name: string } | null> | null } | null> | null };

export type TripDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type TripDetailQuery = { __typename?: 'query_root', setutrade_trip_by_pk?: { __typename?: 'setutrade_trip', created_at: any, id: number, aggregator_name?: string | null, aggregator_number?: string | null, driver_name?: string | null, driver_number?: string | null, source_location_name?: string | null, destination_location_name?: string | null, estimated_date?: any | null, status: string, vehicle: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, created_by: Array<{ __typename?: 'base_user', id: number, full_name?: string | null }>, trades: Array<{ __typename?: 'trade', id: any, buyer_payable?: number | null, deducted_amount?: any | null, deducted_quantity?: any | null }> } | null };

export type UpdateTripMutationVariables = Exact<{
  set?: InputMaybe<Setutrade_Trip_Set_Input>;
  where: Setutrade_Trip_Bool_Exp;
}>;


export type UpdateTripMutation = { __typename?: 'mutation_root', update_setutrade_trip?: { __typename?: 'setutrade_trip_mutation_response', returning: Array<{ __typename?: 'setutrade_trip', id: number, status: string }> } | null };

export type AddSfCodeMutationVariables = Exact<{
  id: Scalars['bigint'];
  baseUserEntityId: Scalars['bigint'];
}>;


export type AddSfCodeMutation = { __typename?: 'mutation_root', update_unregistered_user_by_pk?: { __typename?: 'unregistered_user', id: any } | null };

export type AllUnRegisteredUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUnRegisteredUsersQuery = { __typename?: 'query_root', unregistered_user: Array<{ __typename: 'unregistered_user', id: any, first_name: string, last_name?: string | null, number: string }> };

export type AllUploaderListQueryVariables = Exact<{
  where?: InputMaybe<Django_Celery_Results_Taskresult_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Django_Celery_Results_Taskresult_Order_By> | Django_Celery_Results_Taskresult_Order_By>;
}>;


export type AllUploaderListQuery = { __typename?: 'query_root', django_celery_results_taskresult: Array<{ __typename?: 'django_celery_results_taskresult', id: number, task_id: string, task_name?: string | null, periodic_task_name?: string | null, task_kwargs?: string | null, result?: string | null, date_created: any, date_done: any }>, django_celery_results_taskresult_aggregate: { __typename?: 'django_celery_results_taskresult_aggregate', aggregate?: { __typename?: 'django_celery_results_taskresult_aggregate_fields', count: number } | null } };

export type UploaderDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UploaderDetailQuery = { __typename?: 'query_root', django_celery_results_taskresult_by_pk?: { __typename?: 'django_celery_results_taskresult', id: number, task_id: string, task_name?: string | null, periodic_task_name?: string | null, task_kwargs?: string | null, result?: string | null, date_created: any, date_done: any } | null };

export type AllVehiclesQueryVariables = Exact<{
  filter?: InputMaybe<VehicleGlInput>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type AllVehiclesQuery = { __typename?: 'query_root', all_vehicles?: Array<{ __typename?: 'VehicleGlType', id: string, name: string, codename: string, vehicle_type: { __typename?: 'VehicleTypeGlType', id: string, name: string } } | null> | null };

export type VehicleDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VehicleDetailQuery = { __typename?: 'query_root', vehicle_detail?: { __typename?: 'VehicleGlType', id: string, registration_number: string, driver?: { __typename?: 'BaseUserGlType', id: string, full_name?: string | null, number: string } | null, owner?: { __typename?: 'BaseUserGlType', id: string, full_name?: string | null, number: string } | null } | null };

export type PavtiTradeDetailQueryVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type PavtiTradeDetailQuery = { __typename?: 'query_root', trade_by_pk?: { __typename?: 'trade', id: any, created_at: any, tracking_code: string, kind: string, buyer_verification?: boolean | null, seller_verification?: boolean | null, packaging: string, standard_deduction?: any | null, total_amount?: any | null, start_date?: any | null, end_date?: any | null, expiry?: any | null, seller_tnc?: string | null, buyer_tnc?: string | null, created_by: Array<{ __typename?: 'base_user', full_name?: string | null, number: string }>, facilitator?: { __typename?: 'setu_trade_shared_entity', name: string } | null, plot_crop?: { __typename?: 'setu_trade_shared_entity', id: any, name: string, plot_crop: Array<{ __typename?: 'plot_crop', id: number, plot: { __typename?: 'plot', id: number, field: { __typename?: 'field', id: number, address?: { __typename?: 'address', id: number, raw_address?: string | null } | null } } }> } | null, seller?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, buyer?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, commodity_variety?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, trade_items: Array<{ __typename?: 'trade_item', id: any, quantity: any, rate: any, amount?: any | null, currency: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, variety_grade?: { __typename?: 'setu_trade_shared_entity', id: any, name: string } | null, quantity_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string }, rate_unit: { __typename?: 'setu_trade_shared_entity', id: any, name: string } }>, trade_items_aggregate: { __typename?: 'trade_item_aggregate', aggregate?: { __typename?: 'trade_item_aggregate_fields', sum?: { __typename?: 'trade_item_sum_fields', quantity?: any | null } | null } | null }, buyer_expenses: { __typename?: 'expense_aggregate', aggregate?: { __typename?: 'expense_aggregate_fields', sum?: { __typename?: 'expense_sum_fields', amount?: any | null } | null } | null, nodes: Array<{ __typename?: 'expense', kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> }, seller_expenses: { __typename?: 'expense_aggregate', aggregate?: { __typename?: 'expense_aggregate_fields', sum?: { __typename?: 'expense_sum_fields', amount?: any | null } | null } | null, nodes: Array<{ __typename?: 'expense', kind: string, value: any, amount?: any | null, expense_parameter: { __typename?: 'expense_parameter', id: any, name: string } }> } } | null };

export type TradeDetailsSubscriptionVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type TradeDetailsSubscription = { __typename?: 'subscription_root', trade_by_pk?: { __typename?: 'trade', id: any, seller_verification?: boolean | null, seller_remark?: string | null, buyer_verification?: boolean | null, buyer_remark?: string | null } | null };

export type UpdateTradeVerificationMutationVariables = Exact<{
  id: Scalars['bigint'];
  set?: InputMaybe<Trade_Set_Input>;
}>;


export type UpdateTradeVerificationMutation = { __typename?: 'mutation_root', update_trade_by_pk?: { __typename?: 'trade', id: any } | null };

export type GenerateTradeOtpMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type GenerateTradeOtpMutation = { __typename?: 'mutation_root', generate_trade_otp?: { __typename?: 'GenerateTradeOTP', status?: boolean | null } | null };

export type VerifyTradeOtpMutationVariables = Exact<{
  token: Scalars['String'];
  otp: Scalars['String'];
}>;


export type VerifyTradeOtpMutation = { __typename?: 'mutation_root', verify_trade_otp?: { __typename?: 'VerifyTradeOTP', token?: string | null, refresh_token?: string | null, refresh_expires_in?: number | null, payload?: any | null } | null };

export const BaseUserDisplayFragFragmentDoc = gql`
    fragment BaseUserDisplayFrag on base_user {
  id
  reference_id
  full_name
  is_blocked
  number
  external_reference_id
  photo {
    id
    url
  }
}
    `;
export const BaseUserFragFragmentDoc = gql`
    fragment BaseUserFrag on base_user {
  id
  codename: reference_id
  name: full_name
  number
  is_blocked
  external_reference_id
  is_verified
  photo {
    id
    url
  }
  created_at
  companies {
    id
    company {
      id
      name
      display_name
      codename
    }
  }
  my_businesses {
    id
  }
  current_address {
    id
    raw_address
    state_region {
      code
    }
  }
}
    `;
export const KiteCommodityVarietyFragFragmentDoc = gql`
    fragment KiteCommodityVarietyFrag on commodity_variety {
  id
  name
  codename
  crop_variety_id
  organisation_commodity_variety_configs {
    id
    commodity_variety_id
    taxes {
      id
      tax {
        id
        name
        percentage
      }
    }
  }
}
    `;
export const DemandCoreFragFragmentDoc = gql`
    fragment DemandCoreFrag on demand {
  id
  status
  created_at
  material_kind
  buyer {
    id
    user {
      ...BaseUserFrag
    }
  }
  facilitator {
    id
    facilitator {
      id
      name
      codename
    }
  }
  mode
  jr_officer {
    id
    user {
      id
      codename: reference_id
      name: full_name
    }
  }
  sr_officer {
    id
    user {
      id
      codename: reference_id
      name: full_name
    }
  }
  commodity {
    id
    name
    reference_id
    commodity {
      id
      crop_id
      codename
      name
    }
  }
  commodity_variety {
    id
    commodity_variety {
      ...KiteCommodityVarietyFrag
    }
  }
  variety_grade {
    id
    variety_grade {
      id
      codename
      name
    }
  }
  packaging
  rate_unit {
    id
    si_unit {
      id
      codename
      name
      base_conversion
    }
  }
  quantity_unit {
    id
    si_unit {
      id
      codename
      name
      base_conversion
    }
  }
  rate
  max_rate
  quantity
  total_amount
  seller_source_kind
  created_by {
    id
    full_name
  }
  start_date_time
  end_date_time
  standard_deduction
  deducted_amount
  attachments {
    id
    send_whatsapp
    media {
      id
      url
      kind
    }
  }
  seller_tnc
  buyer_tnc
  expenses {
    id
    paid_by
    expense_parameter {
      id
      codename
      name
    }
    kind
    value
    amount
  }
  trade_qty_used: trades_aggregate {
    aggregate {
      sum {
        total_quantity
      }
    }
  }
}
    ${BaseUserFragFragmentDoc}
${KiteCommodityVarietyFragFragmentDoc}`;
export const OfferCoreFragFragmentDoc = gql`
    fragment OfferCoreFrag on offers {
  id
  status
  created_at
  material_kind
  seller {
    id
    user {
      ...BaseUserFrag
    }
  }
  facilitator {
    id
    facilitator {
      id
      name
      codename
    }
  }
  mode
  jr_officer {
    id
    user {
      id
      codename: reference_id
      name: full_name
    }
  }
  sr_officer {
    id
    user {
      id
      codename: reference_id
      name: full_name
    }
  }
  commodity {
    id
    name
    reference_id
    commodity {
      id
      crop_id
      codename
      name
    }
  }
  commodity_variety {
    id
    commodity_variety {
      ...KiteCommodityVarietyFrag
    }
  }
  variety_grade {
    id
    variety_grade {
      id
      codename
      name
    }
  }
  rate_unit {
    id
    si_unit {
      id
      codename
      name
      base_conversion
    }
  }
  quantity_unit {
    id
    si_unit {
      id
      codename
      name
      base_conversion
    }
  }
  rate
  max_rate
  quantity
  total_amount
  buyer_source_kind
  created_by {
    id
    full_name
  }
  start_date_time
  end_date_time
  standard_deduction
  deducted_amount
  attachments: offer_attachments {
    id
    send_whatsapp
    media {
      id
      url
      kind
    }
  }
  expenses: offer_expenses {
    id
    paid_by
    expense_parameter {
      id
      codename
      name
    }
    kind
    value
    amount
  }
}
    ${BaseUserFragFragmentDoc}
${KiteCommodityVarietyFragFragmentDoc}`;
export const PackagingOrderFieldsFragmentDoc = gql`
    fragment PackagingOrderFields on packaging_order {
  id
  date
  user {
    id
    user {
      id
      name: full_name
      external_reference_id2
    }
  }
  plot_crop {
    id
    plot_crop {
      id
      name
      external_reference_id
    }
  }
  total_amount
  payment_status
  total_amount_pending
  total_amount_paid
  transaction_number
  created_by {
    id
    full_name
    photo {
      id
      url
    }
  }
  packaging_order_items {
    id
    packaging {
      id
      name
    }
  }
  created_at
}
    `;
export const ExpenseFragFragmentDoc = gql`
    fragment ExpenseFrag on expense {
  id
  paid_by
  expense_parameter {
    id
    codename
    name
  }
  kind
  value
  amount
}
    `;
export const AdvancePayFragFragmentDoc = gql`
    fragment AdvancePayFrag on advance_payment {
  id
  parameter {
    id
    name
  }
  transactions {
    created_at
    remark
    trade {
      id
      kind
    }
    date
    amount
    mode {
      name
    }
    transaction_id
    account_no
    amount
  }
  amount
  bourn_by
  user_id
  is_verified
  created_at
}
    `;
export const CreditNoteFragFragmentDoc = gql`
    fragment CreditNoteFrag on credit_note {
  id
  amount
  remarks
  user_id
  is_verified
  created_at
}
    `;
export const KiteCommodityFragFragmentDoc = gql`
    fragment KiteCommodityFrag on commodity {
  id
  name
  codename
  crop_id
}
    `;
export const ReceiptDetailFragFragmentDoc = gql`
    fragment ReceiptDetailFrag on receipt {
  id
  parent_receipt_id
  is_multiple_commodity
  settled_by_advance_payment: transactions(
    where: {ref: {_eq: "settled_by_advance_payment"}}
  ) {
    id
    ref
    amount
    parent_transaction {
      advance_payment {
        id
        receipt {
          id
          kind
        }
      }
    }
  }
  parent_receipt {
    id
    is_multiple_commodity
  }
  twilio_message {
    id
    status
  }
  officer {
    id
    user {
      ...BaseUserFrag
    }
  }
  junior_officer {
    id
    user {
      ...BaseUserFrag
    }
  }
  seller_receivable_amount
  seller_expense_amount
  department {
    id
    reference_id
  }
  vehicle {
    id
    name
    codename: reference_id
  }
  editable_trades: trades_aggregate(
    where: {current_status: {is_data_editable: {_eq: false}}}
  ) {
    aggregate {
      count
    }
  }
  hishob_patti_count: trades_aggregate(where: {kind: {_eq: "final"}}) {
    aggregate {
      count
    }
  }
  seller {
    id
    user {
      ...BaseUserFrag
    }
  }
  facilitator {
    id
    facilitator {
      id
      name
      codename
    }
  }
  child_receipts {
    id
  }
  child_receipts_aggregate {
    aggregate {
      count
    }
  }
  start_date
  end_date
  expiry
  seller_tnc
  packaging
  standard_deduction
  expense_amount
  buyer_tnc
  supplier_expense_gst_auto_calculated
  buyer_expense_gst_auto_calculated
  seller_gst_attachments {
    id
    media {
      id
      kind
      url
    }
  }
  mode
  kind
  expenses {
    ...ExpenseFrag
  }
  advance_payments {
    ...AdvancePayFrag
  }
  credit_notes {
    ...CreditNoteFrag
  }
  total_amount
  total_quantity
  deducted_amount
  deducted_quantity
  trades {
    id
    total_quantity
    total_amount
    buyer {
      id
      user {
        ...BaseUserFrag
      }
    }
    commodity {
      id
      commodity {
        ...KiteCommodityFrag
      }
    }
    commodity_variety {
      id
      commodity_variety {
        ...KiteCommodityVarietyFrag
      }
    }
    attachments {
      id
      media {
        id
        kind
        url
        etag
      }
    }
    trade_items {
      id
      quantity
      rate
      parent_trade_item_id
      total_amount: amount
      taxes(where: {role: {_eq: "seller"}}) {
        id
        amount
        percentage
        role
        tax_name
      }
      commodity {
        id
        commodity {
          ...KiteCommodityFrag
        }
      }
      commodity_variety {
        id
        commodity_variety {
          ...KiteCommodityVarietyFrag
        }
      }
      plot_crop {
        id
        plot_crop {
          id
          external_reference_id
          tag
          name
          codename
        }
      }
      quantity_unit {
        id
        si_unit {
          id
          name
          codename
          base_conversion
        }
      }
      variety_grade {
        id
        variety_grade {
          id
          name
        }
      }
    }
  }
}
    ${BaseUserFragFragmentDoc}
${ExpenseFragFragmentDoc}
${AdvancePayFragFragmentDoc}
${CreditNoteFragFragmentDoc}
${KiteCommodityFragFragmentDoc}
${KiteCommodityVarietyFragFragmentDoc}`;
export const TemplateBaseFragFragmentDoc = gql`
    fragment TemplateBaseFrag on template {
  id
  name
  grade {
    id
    name
  }
  template_parameters {
    id
    configurations(where: {evaluation_criteria: {tag: {name: {_eq: "fail"}}}}) {
      id
      comparator
      value
      evaluation_criteria {
        id
        tag {
          id
          name
        }
      }
    }
    quality_parameter {
      id
      name
    }
    standard
    weightage
    observation_count
  }
}
    `;
export const ResultBaseFragFragmentDoc = gql`
    fragment ResultBaseFrag on result {
  id
  name
  codename
  sample_id
  sample {
    id
    sample_request_id
  }
  template {
    ...TemplateBaseFrag
  }
  evaluations(
    where: {template_evaluation: {codename: {_eq: "51bb70e4-fc39-4a61-80ea-3636b44aa533"}}}
  ) {
    value
  }
  observations {
    id
    template_parameter_id
    template_parameter {
      id
      quality_parameter_id
    }
    value
    sample_observation: observation {
      id
      observation_number
      attachments {
        id
        media {
          id
          url
          media_kind
        }
      }
    }
  }
}
    ${TemplateBaseFragFragmentDoc}`;
export const TradeDetailFragFragmentDoc = gql`
    fragment TradeDetailFrag on trade {
  id
  status: current_status_id
  is_intercompany_transaction
  tracking_code
  advance_po
  material_kind
  seller_bifurcation {
    advance_amount {
      op
      val
    }
  }
  settled_by_advance_payment: transactions(
    where: {ref: {_eq: "settled_by_advance_payment"}}
  ) {
    id
    ref
    amount
    parent_transaction {
      advance_payment {
        id
        trade {
          id
          kind
        }
      }
    }
  }
  over_due_approval {
    id
  }
  over_draft {
    id
    status
    logs(order_by: {created_at: desc}, limit: 1) {
      id
      status
      user {
        id
        name
      }
    }
  }
  storage_location {
    id
    name
    codename
    storage_location_agreements(
      limit: 1
      where: {is_active: {_eq: true}, is_verified: {_eq: true}}
    ) {
      id
      end_date
    }
  }
  storage_sub_location {
    id
    name
    codename
  }
  officer {
    id
    user {
      ...BaseUserFrag
    }
  }
  junior_officer {
    id
    user {
      ...BaseUserFrag
    }
  }
  status_processing
  receipt_id
  trip {
    id
  }
  department {
    id
    name
    reference_id
  }
  invoice {
    id
  }
  vehicle {
    id
    name
    codename: reference_id
  }
  trades(
    where: {kind: {_in: ["final", "inward", "booking"]}}
    order_by: {created_at: desc_nulls_last}
  ) {
    id
    kind
    start_date
  }
  demand_id
  offer_id
  parent_trade {
    id
    kind
    start_date
    demand_id
    offer_id
    is_multiple_commodity
    officer {
      id
      user {
        ...BaseUserFrag
      }
    }
    junior_officer {
      id
      user {
        ...BaseUserFrag
      }
    }
  }
  buyer {
    id
    credits(where: {status_id: {_eq: "Active"}}) {
      over_drafts_aggregate(
        where: {status: {_nin: ["Deviation Approved", "Deviation Rejected"]}}
      ) {
        aggregate {
          count
        }
      }
    }
    user {
      ...BaseUserFrag
    }
  }
  seller {
    id
    user {
      ...BaseUserFrag
    }
  }
  commodity {
    id
    commodity {
      ...KiteCommodityFrag
    }
  }
  commodity_variety {
    id
    commodity_variety {
      ...KiteCommodityVarietyFrag
    }
  }
  facilitator {
    id
    facilitator {
      id
      name
      codename
    }
  }
  plot_crop {
    id
    plot_crop {
      id
      external_reference_id
      tag
      name
      codename
    }
  }
  attachments {
    id
    media {
      id
      etag
      url
      key
      kind
    }
  }
  standard_deduction
  start_date
  end_date
  expiry
  packaging
  seller_tnc
  buyer_tnc
  seller_verification
  buyer_verification
  mode
  kind
  total_amount
  total_quantity
  deducted_amount
  supplier_charge
  seller_tds
  seller_tds_percentage
  buyer_expense_amount
  seller_expense_amount
  seller_payable
  buyer_payable
  deducted_quantity
  expense_amount
  is_multiple_commodity
  trade_items_aggregate {
    aggregate {
      sum {
        returned_quantity
      }
    }
  }
  trade_items {
    id
    batch_number
    result {
      id
      codename
      result {
        ...ResultBaseFrag
      }
    }
    quantity
    quantity_unit {
      id
      si_unit {
        id
        name
        codename
        base_conversion
      }
    }
    commodity {
      id
      commodity {
        ...KiteCommodityFrag
      }
    }
    commodity_variety {
      id
      commodity_variety {
        ...KiteCommodityVarietyFrag
      }
    }
    plot_crop {
      id
      plot_crop {
        id
        external_reference_id
        tag
        name
        codename
      }
    }
    variety_grade {
      id
      variety_grade {
        id
        name
        codename
      }
    }
    rate
    total_amount: amount
    daily_rate
    rate_unit {
      id
      si_unit {
        id
        name
        codename
        base_conversion
      }
    }
    supplier_gst_auto_calculated
    buyer_gst_auto_calculated
    taxes {
      id
      amount
      role
      percentage
      tax_name
    }
  }
  expenses {
    ...ExpenseFrag
  }
  advance_payments {
    ...AdvancePayFrag
  }
  credit_notes {
    ...CreditNoteFrag
  }
  supplier_expense_gst_auto_calculated
  buyer_expense_gst_auto_calculated
  expense_taxes {
    id
    amount
    role
    percentage
    tax_name
  }
  taxes {
    id
    amount
    percentage
    role
    tax_name
  }
  seller_gst_attachments {
    id
    media {
      id
      kind
      url
    }
  }
  buyer_gst_attachments {
    id
    media {
      id
      kind
      url
    }
  }
}
    ${BaseUserFragFragmentDoc}
${KiteCommodityFragFragmentDoc}
${KiteCommodityVarietyFragFragmentDoc}
${ResultBaseFragFragmentDoc}
${ExpenseFragFragmentDoc}
${AdvancePayFragFragmentDoc}
${CreditNoteFragFragmentDoc}`;
export const TradeDetailFrag2FragmentDoc = gql`
    fragment TradeDetailFrag2 on trade {
  id
  status: current_status_id
  tracking_code
  advance_po
  over_draft {
    id
    status
    logs(order_by: {created_at: desc}, limit: 1) {
      id
      status
      user {
        name
      }
    }
  }
  officer {
    id
    user {
      ...BaseUserFrag
    }
  }
  junior_officer {
    id
    user {
      ...BaseUserFrag
    }
  }
  status_processing
  receipt_id
  trip {
    id
  }
  department {
    id
    name
    reference_id
  }
  invoice {
    id
  }
  vehicle {
    id
    name
    codename: reference_id
  }
  trades(
    where: {kind: {_in: ["final", "inward", "booking"]}}
    order_by: {created_at: desc_nulls_last}
  ) {
    id
    kind
    start_date
  }
  demand_id
  offer_id
  parent_trade {
    id
    kind
    start_date
    demand_id
    offer_id
    is_multiple_commodity
    officer {
      id
      user {
        ...BaseUserFrag
      }
    }
    junior_officer {
      id
      user {
        ...BaseUserFrag
      }
    }
  }
  buyer {
    id
    credits(where: {status_id: {_eq: "Active"}}) {
      over_drafts_aggregate(
        where: {status: {_nin: ["Deviation Approved", "Deviation Rejected"]}}
      ) {
        aggregate {
          count
        }
      }
    }
    user {
      ...BaseUserFrag
    }
  }
  seller {
    id
    user {
      ...BaseUserFrag
    }
  }
  commodity {
    id
    commodity {
      ...KiteCommodityFrag
    }
  }
  commodity_variety {
    id
    commodity_variety {
      ...KiteCommodityVarietyFrag
    }
  }
  facilitator {
    id
    facilitator {
      id
      name
      codename
    }
  }
  plot_crop {
    id
    plot_crop {
      id
      external_reference_id
      tag
      name
      codename
    }
  }
  attachments {
    id
    media {
      id
      etag
      url
      key
      kind
    }
  }
  standard_deduction
  start_date
  end_date
  expiry
  packaging
  seller_tnc
  buyer_tnc
  seller_verification
  buyer_verification
  mode
  kind
  total_amount
  total_quantity
  deducted_amount
  supplier_charge
  seller_tds
  seller_tds_percentage
  buyer_expense_amount
  seller_expense_amount
  deducted_quantity
  expense_amount
  is_multiple_commodity
  trade_items_aggregate {
    aggregate {
      sum {
        returned_quantity
      }
    }
  }
  trade_items {
    id
    result {
      id
      codename
      result {
        ...ResultBaseFrag
      }
    }
    quantity
    quantity_unit {
      id
      si_unit {
        id
        name
        codename
        base_conversion
      }
    }
    commodity {
      id
      commodity {
        ...KiteCommodityFrag
      }
    }
    commodity_variety {
      id
      commodity_variety {
        ...KiteCommodityVarietyFrag
      }
    }
    plot_crop {
      id
      plot_crop {
        id
        external_reference_id
        tag
        name
        codename
      }
    }
    variety_grade {
      id
      variety_grade {
        id
        name
        codename
      }
    }
    rate
    total_amount: amount
    daily_rate
    rate_unit {
      id
      si_unit {
        id
        name
        codename
        base_conversion
      }
    }
    supplier_gst_auto_calculated
    buyer_gst_auto_calculated
    taxes {
      id
      amount
      role
      percentage
      tax_name
    }
  }
  expenses {
    ...ExpenseFrag
  }
  advance_payments {
    ...AdvancePayFrag
  }
  credit_notes {
    ...CreditNoteFrag
  }
  taxes {
    id
    amount
    percentage
    role
    tax_name
  }
  seller_gst_attachments {
    id
    media {
      id
      kind
      url
    }
  }
  buyer_gst_attachments {
    id
    media {
      id
      kind
      url
    }
  }
}
    ${BaseUserFragFragmentDoc}
${KiteCommodityFragFragmentDoc}
${KiteCommodityVarietyFragFragmentDoc}
${ResultBaseFragFragmentDoc}
${ExpenseFragFragmentDoc}
${AdvancePayFragFragmentDoc}
${CreditNoteFragFragmentDoc}`;
export const AgentLoginDocument = gql`
    mutation AgentLogin($username: String!, $password: String!) {
  agent_login(username: $username, password: $password) {
    token
    refresh_token
    me {
      id
      full_name
      agent {
        id
        name
        current_department {
          id
          name
          codename
        }
        eid
        organisation {
          id
          codename
          uid
          name
        }
      }
    }
  }
}
    `;

export function useAgentLoginMutation() {
  return Urql.useMutation<AgentLoginMutation, AgentLoginMutationVariables>(AgentLoginDocument);
};
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refresh_token(refresh_token: $refreshToken) {
    token
    refresh_token
  }
}
    `;

export function useRefreshTokenMutation() {
  return Urql.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument);
};
export const AuthenticatedUserDocument = gql`
    query AuthenticatedUser {
  me {
    id
    permissions
    agent {
      id
      current_department {
        id
        name
        codename
        address {
          id
          state_region {
            id
            code
          }
        }
      }
      departments {
        id
        department {
          id
          name
          codename
          address {
            id
            state_region {
              id
              code
            }
          }
        }
      }
      organisation {
        id
        uid
        name
      }
    }
    is_verified
    first_name
    last_name
    full_name
    email
    number
    photo {
      id
      url
    }
    current_department {
      id
      name
      codename
      address {
        id
        state_region {
          id
          code
        }
      }
    }
    companies {
      id
      name
      codename
    }
  }
}
    `;

export function useAuthenticatedUserQuery(options?: Omit<Urql.UseQueryArgs<AuthenticatedUserQueryVariables>, 'query'>) {
  return Urql.useQuery<AuthenticatedUserQuery, AuthenticatedUserQueryVariables>({ query: AuthenticatedUserDocument, ...options });
};
export const AllGroupsDocument = gql`
    query AllGroups($where: auth_group_bool_exp) {
  auth_group(limit: 10, where: $where) {
    id
    name
    codename: name
  }
}
    `;

export function useAllGroupsQuery(options?: Omit<Urql.UseQueryArgs<AllGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllGroupsQuery, AllGroupsQueryVariables>({ query: AllGroupsDocument, ...options });
};
export const UsersDocument = gql`
    query Users($groups: [String!], $query: String) {
  base_user(
    where: {is_verified: {_eq: true}, groups: {group: {name: {_in: $groups}}}, _or: [{full_name: {_ilike: $query}}, {number: {_ilike: $query}}, {external_reference_id2: {_ilike: $query}}]}
    order_by: {full_name: asc_nulls_last}
    limit: 15
  ) {
    ...BaseUserFrag
  }
}
    ${BaseUserFragFragmentDoc}`;

export function useUsersQuery(options?: Omit<Urql.UseQueryArgs<UsersQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersQuery, UsersQueryVariables>({ query: UsersDocument, ...options });
};
export const AllUsersDocument = gql`
    query AllUsers($groups: [String!], $query: String) {
  base_user(
    where: {groups: {group: {name: {_in: $groups}}}, _or: [{full_name: {_ilike: $query}}, {number: {_ilike: $query}}, {external_reference_id2: {_ilike: $query}}]}
    order_by: {full_name: asc_nulls_last}
    limit: 15
  ) {
    ...BaseUserFrag
  }
}
    ${BaseUserFragFragmentDoc}`;

export function useAllUsersQuery(options?: Omit<Urql.UseQueryArgs<AllUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<AllUsersQuery, AllUsersQueryVariables>({ query: AllUsersDocument, ...options });
};
export const UsersDetailDocument = gql`
    query UsersDetail($id: Int!) {
  base_user_by_pk(id: $id) {
    ...BaseUserFrag
  }
}
    ${BaseUserFragFragmentDoc}`;

export function useUsersDetailQuery(options: Omit<Urql.UseQueryArgs<UsersDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersDetailQuery, UsersDetailQueryVariables>({ query: UsersDetailDocument, ...options });
};
export const SearchBaseUsersDocument = gql`
    query SearchBaseUsers($groups: [String!], $query: String) {
  base_user(
    where: {groups: {group: {name: {_in: $groups}}}, _or: [{full_name: {_ilike: $query}}, {number: {_ilike: $query}}, {external_reference_id2: {_ilike: $query}}]}
    order_by: {full_name: asc_nulls_last}
    limit: 15
  ) {
    ...BaseUserFrag
  }
}
    ${BaseUserFragFragmentDoc}`;

export function useSearchBaseUsersQuery(options?: Omit<Urql.UseQueryArgs<SearchBaseUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchBaseUsersQuery, SearchBaseUsersQueryVariables>({ query: SearchBaseUsersDocument, ...options });
};
export const SearchBaseUserIdDocument = gql`
    query SearchBaseUserId($query: String) {
  base_user(where: {_or: [{external_reference_id2: {_ilike: $query}}]}, limit: 1) {
    id
    full_name
    reference_id
  }
}
    `;

export function useSearchBaseUserIdQuery(options?: Omit<Urql.UseQueryArgs<SearchBaseUserIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchBaseUserIdQuery, SearchBaseUserIdQueryVariables>({ query: SearchBaseUserIdDocument, ...options });
};
export const CancelInvoicesDocument = gql`
    mutation CancelInvoices($invoiceId: ID!) {
  cancel_invoice(invoice_id: $invoiceId) {
    success
  }
}
    `;

export function useCancelInvoicesMutation() {
  return Urql.useMutation<CancelInvoicesMutation, CancelInvoicesMutationVariables>(CancelInvoicesDocument);
};
export const CreateCreditRequestDocument = gql`
    mutation CreateCreditRequest($input: CreateCreditWalletRequestInput!) {
  create_credit_wallet_request(input: $input) {
    credit_wallet_request {
      id
    }
  }
}
    `;

export function useCreateCreditRequestMutation() {
  return Urql.useMutation<CreateCreditRequestMutation, CreateCreditRequestMutationVariables>(CreateCreditRequestDocument);
};
export const ApproveCreditRequestDocument = gql`
    mutation ApproveCreditRequest($input: ApproveCreditWalletRequestInput!) {
  approve_credit_wallet_request(input: $input) {
    credit_wallet {
      id
    }
  }
}
    `;

export function useApproveCreditRequestMutation() {
  return Urql.useMutation<ApproveCreditRequestMutation, ApproveCreditRequestMutationVariables>(ApproveCreditRequestDocument);
};
export const CreditWalletDetailDocument = gql`
    query CreditWalletDetail($id: bigint!) {
  credit_wallet_request_by_pk(id: $id) {
    id
    created_at
    requested_validity
    approved_start_date
    requested_credit_limit_factor
    is_verified
    verified_on
    approved_end_date
    approved_total_amount
    requested_total_amount
    approved_payment_cycle_days
    requested_payment_cycle_days
    requested_total_amount
    financial_year_assessment_cw {
      id
      assessed_limit
      capital
      current_assets
      current_liabilities
      fixed_assets
      profit_loss
      total_sales
      year_id
      attachment_id
      financial_year {
        name
        id
      }
      attachment {
        id
        url
        kind
      }
    }
    projection_assessment_cw {
      id
      assessed_limit
      credit_wallet_request_id
      daily_average_sale
      end_date
      payment_cycle
      start_date
      tenure
      total_sales
    }
    trade_assessment_cw {
      assessed_limit
      credit_wallet_request_id
      daily_average_sale
      end_date
      id
      payment_cycle
      settled_trade_count
      start_date
      tenure
      trade_count
      unsettled_trade_count
      total_sales
    }
    credit_wallet {
      id
      used_amount
      remaining_amount
      user {
        id
        name
        codename
        user {
          id
          my_businesses {
            id
          }
          companies {
            id
            company {
              id
              name
              display_name
            }
          }
          name: full_name
          number
          external_reference_id2
          current_address {
            id
            raw_address
          }
        }
      }
    }
  }
}
    `;

export function useCreditWalletDetailQuery(options: Omit<Urql.UseQueryArgs<CreditWalletDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditWalletDetailQuery, CreditWalletDetailQueryVariables>({ query: CreditWalletDetailDocument, ...options });
};
export const CreditWalletSummaryDocument = gql`
    query CreditWalletSummary($input: CreditWalletSummaryAggregatedInput) {
  credit_wallet_summary_aggregated(input: $input) {
    buyer_count
    total_credit_limit
    total_outstanding
    used_credit_hishob_patti
    available_credit_limit
    avg_overdue_days
  }
}
    `;

export function useCreditWalletSummaryQuery(options?: Omit<Urql.UseQueryArgs<CreditWalletSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditWalletSummaryQuery, CreditWalletSummaryQueryVariables>({ query: CreditWalletSummaryDocument, ...options });
};
export const CreditWalletListingDocument = gql`
    query CreditWalletListing($limit: Int, $offset: Int, $search: String, $status: String, $created_from: Date, $created_to: Date, $verified_by: ID) {
  credit_wallet_list(
    limit: $limit
    offset: $offset
    search: $search
    status: $status
    created_from_date: $created_from
    created_to_date: $created_to
    verified_by_id: $verified_by
  ) {
    results {
      id
      credit_wallet_id
      created_on
      verified_on
      buyer {
        id
        name
      }
      credit_limit_approved_by {
        id
        name
      }
      validity
      validity_start_date
      validity_end_date
      credit_limit
      payment_cycle_days
      total_exposure
      actual_exposure
      shadow_exposure
      credit_limit_available
      last_transaction_date
      last_transaction_value
      overdue_amount
      avg_overdue_days
      deviation_amount_requested
      deviation_os_approved
      status
      status_metadata
    }
    total_records
  }
}
    `;

export function useCreditWalletListingQuery(options?: Omit<Urql.UseQueryArgs<CreditWalletListingQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditWalletListingQuery, CreditWalletListingQueryVariables>({ query: CreditWalletListingDocument, ...options });
};
export const BuyerCreditWalletInfoSummaryDocument = gql`
    query BuyerCreditWalletInfoSummary($userId: ID!, $tradeId: ID, $deptId: ID) {
  buyer_credit_wallet_info(
    user_id: $userId
    trade_id: $tradeId
    department_id: $deptId
  ) {
    department_settlement_total_amount
    department_settlement_settled_amount
    department_settlement_remaining_amount
    credit_limit
    total_exposure
    actual_exposure
    shadow_exposure
    credit_limit_available
    overdue_amount
    avg_overdue_days
    requested_overdue_approval_count
    last_overdue_approval_count
    used_overdraft
    requested_overdraft_count
    unsettled_overdraft_count
    parent_consumed
    current_trade_consumed
    dynamic_available
    overdraft_count
    overdue_count
    latest_verified_credit_wallet_request_id
    credit_wallet_id
  }
}
    `;

export function useBuyerCreditWalletInfoSummaryQuery(options: Omit<Urql.UseQueryArgs<BuyerCreditWalletInfoSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<BuyerCreditWalletInfoSummaryQuery, BuyerCreditWalletInfoSummaryQueryVariables>({ query: BuyerCreditWalletInfoSummaryDocument, ...options });
};
export const CreditRequestHistoryDocument = gql`
    query CreditRequestHistory($where: credit_request_bool_exp, $orderBy: [credit_request_order_by!], $limit: Int, $offset: Int) {
  credit_request(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    id
    requested_by {
      id
      full_name
    }
    created_at
    requested_date
    requested_total_amount
    requested_validity
    requested_payment_cycle_days
    extra_data {
      verified_by_custom {
        name
      }
    }
    verified_on
    approved_total_amount
    approved_validity
    approved_end_date
    approved_payment_cycle_days
  }
  credit_request_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useCreditRequestHistoryQuery(options?: Omit<Urql.UseQueryArgs<CreditRequestHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditRequestHistoryQuery, CreditRequestHistoryQueryVariables>({ query: CreditRequestHistoryDocument, ...options });
};
export const CreditAggregateDocument = gql`
    query CreditAggregate($input: CreditSummaryAggregatedInput!) {
  credit_summary_aggregated(input: $input) {
    buyer_count
    total_credit_limit
    total_outstanding
    used_credit_hishob_patti
    available_credit_limit
    avg_overdue_days
  }
}
    `;

export function useCreditAggregateQuery(options: Omit<Urql.UseQueryArgs<CreditAggregateQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditAggregateQuery, CreditAggregateQueryVariables>({ query: CreditAggregateDocument, ...options });
};
export const CreditAnalyticsDocument = gql`
    query CreditAnalytics($where: credit_bool_exp, $limit: Int, $overDraftWhere: over_draft_bool_exp) {
  credit(where: $where, limit: $limit) {
    id
    total_amount
    used_amount
    remaining_amount
    devCount: over_drafts_aggregate(where: $overDraftWhere) {
      aggregate {
        count
        sum {
          outstanding_amount
        }
      }
    }
    over_drafts_aggregate(where: {status: {_neq: "Deviation Rejected"}}) {
      aggregate {
        sum {
          outstanding_amount
        }
      }
    }
    approved: over_drafts_aggregate(where: {status: {_eq: "Deviation Approved"}}) {
      aggregate {
        count
        sum {
          outstanding_amount
        }
      }
    }
    requested: over_drafts_aggregate(
      where: {status: {_nin: ["Deviation Approved", "Deviation Rejected"]}}
    ) {
      aggregate {
        count
        sum {
          outstanding_amount
        }
      }
    }
    extra_data {
      overdue_amount
      used_credit_hishob_patti
      used_credit_booking_patti
      avg_overdue_days
    }
  }
}
    `;

export function useCreditAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<CreditAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditAnalyticsQuery, CreditAnalyticsQueryVariables>({ query: CreditAnalyticsDocument, ...options });
};
export const AllCreditsDocument = gql`
    query AllCredits($where: credit_bool_exp, $orderBy: [credit_order_by!], $limit: Int, $offset: Int) {
  credit(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    id
    created_at
    validity
    metadata
    start_date
    is_verified
    approved: over_drafts_aggregate(where: {status: {_eq: "Deviation Approved"}}) {
      aggregate {
        count
        sum {
          outstanding_amount
        }
      }
    }
    requested: over_drafts_aggregate(
      where: {status: {_nin: ["Deviation Approved", "Deviation Rejected"]}}
    ) {
      aggregate {
        count
        sum {
          outstanding_amount
        }
      }
    }
    verified_by {
      id
      full_name
    }
    verified_on
    user {
      id
      name
      user {
        id
        name: full_name
        external_reference_id2
        number
      }
    }
    end_date
    total_amount
    payment_cycle_days
    used_amount
    remaining_amount
    status {
      id
      is_actionable
      is_credit_active
      metadata
    }
    extra_data {
      used_credit_booking_patti
      used_credit_hishob_patti
      last_transaction_date
      last_transaction_value
      overdue_amount
      avg_overdue_days
    }
  }
  credit_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllCreditsQuery(options?: Omit<Urql.UseQueryArgs<AllCreditsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllCreditsQuery, AllCreditsQueryVariables>({ query: AllCreditsDocument, ...options });
};
export const CreditsSummaryDocument = gql`
    query CreditsSummary($where: credit_bool_exp, $orderBy: [credit_order_by!], $limit: Int, $offset: Int) {
  credit(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    id
    created_at
    validity
    metadata
    start_date
    is_verified
    remark: credit_requests(
      limit: 1
      where: {is_verified: {_eq: false}}
      order_by: {created_at: desc_nulls_last}
    ) {
      id
      remark
    }
    approved: over_drafts_aggregate(where: {status: {_eq: "Deviation Approved"}}) {
      aggregate {
        count
        sum {
          outstanding_amount
        }
      }
    }
    requested: over_drafts_aggregate(
      where: {status: {_nin: ["Deviation Approved", "Deviation Rejected"]}}
    ) {
      aggregate {
        count
        sum {
          outstanding_amount
        }
      }
    }
    summary {
      avg_payment_settlement_days
      hishob_patti_count
      hishob_patti_settled_count
      hishob_patti_unsettled_count
      profit_loss
      total_hishob_patti_sale
      total_sales
    }
    verified_by {
      id
      full_name
    }
    verified_on
    user {
      id
      name
      user {
        id
        name: full_name
        external_reference_id2
        number
        secondary_number
        current_address {
          id
          raw_address
        }
      }
    }
    extra_data {
      avg_overdue_days
      last_transaction_value
      last_transaction_date
      overdue_amount
      used_credit_hishob_patti
      used_credit_booking_patti
    }
    updated_by {
      id
      name: full_name
    }
    created_by {
      id
      name: full_name
      reference_id
      external_reference_id2
    }
    end_date
    total_amount
    payment_cycle_days
    used_amount
    remaining_amount
    status {
      id
      is_actionable
      is_credit_active
      metadata
    }
  }
  credit_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useCreditsSummaryQuery(options?: Omit<Urql.UseQueryArgs<CreditsSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditsSummaryQuery, CreditsSummaryQueryVariables>({ query: CreditsSummaryDocument, ...options });
};
export const CreditStatusDocument = gql`
    query CreditStatus($id: bigint!) {
  credit_by_pk(id: $id) {
    id
    status {
      id
      is_actionable
      is_credit_active
      metadata
    }
  }
}
    `;

export function useCreditStatusQuery(options: Omit<Urql.UseQueryArgs<CreditStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditStatusQuery, CreditStatusQueryVariables>({ query: CreditStatusDocument, ...options });
};
export const CreditDetailDocument = gql`
    query CreditDetail($id: bigint!) {
  credit_by_pk(id: $id) {
    id
    created_at
    validity
    start_date
    credit_limit_factor
    is_verified
    verified_by {
      id
      full_name
    }
    verified_on
    summary {
      avg_payment_settlement_days
      hishob_patti_count
      hishob_patti_settled_count
      hishob_patti_unsettled_count
      profit_loss
      total_hishob_patti_sale
      total_sales
    }
    user {
      id
      name
      codename
      user {
        id
        my_businesses {
          id
        }
        companies {
          id
          company {
            id
            name
            display_name
          }
        }
        name: full_name
        number
        external_reference_id2
        current_address {
          id
          raw_address
        }
      }
    }
    extra_data {
      avg_overdue_days
      last_transaction_value
      last_transaction_date
      overdue_amount
      used_credit_hishob_patti
      used_credit_booking_patti
    }
    updated_by {
      id
      name: full_name
    }
    created_by {
      id
      name: full_name
      reference_id
      external_reference_id2
    }
    end_date
    total_amount
    payment_cycle_days
    used_amount
    remaining_amount
    status {
      id
      is_actionable
      is_credit_active
      metadata
    }
    financial_year_assessments {
      id
      assessed_limit
      capital
      current_assets
      current_liabilities
      fixed_assets
      profit_loss
      total_sales
      year_id
      attachment_id
      year {
        name
        id
      }
      attachment {
        id
        url
        kind
      }
    }
    projection_assessments {
      id
      assessed_limit
      credit_id
      daily_average_sale
      end_date
      payment_cycle
      start_date
      tenure
      total_sales
    }
    trade_assessments {
      assessed_limit
      credit_id
      daily_average_sale
      end_date
      id
      payment_cycle
      settled_trade_count
      start_date
      tenure
      trade_count
      unsettled_trade_count
      total_sales
    }
  }
}
    `;

export function useCreditDetailQuery(options: Omit<Urql.UseQueryArgs<CreditDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditDetailQuery, CreditDetailQueryVariables>({ query: CreditDetailDocument, ...options });
};
export const AddUpdateCreditAssessmentDocument = gql`
    mutation AddUpdateCreditAssessment($input: AddUpdateCreditMutationInput) {
  add_update_credit_assessment(input: $input) {
    credit {
      id
    }
  }
}
    `;

export function useAddUpdateCreditAssessmentMutation() {
  return Urql.useMutation<AddUpdateCreditAssessmentMutation, AddUpdateCreditAssessmentMutationVariables>(AddUpdateCreditAssessmentDocument);
};
export const ApproveCreditLimitDocument = gql`
    mutation ApproveCreditLimit($input: ApproveCreditMutationInput) {
  approve_credit(input: $input) {
    credit {
      id
    }
  }
}
    `;

export function useApproveCreditLimitMutation() {
  return Urql.useMutation<ApproveCreditLimitMutation, ApproveCreditLimitMutationVariables>(ApproveCreditLimitDocument);
};
export const AllFinancialYearsDocument = gql`
    query AllFinancialYears($query: String) {
  financial_year_cw(
    order_by: {from_year: asc_nulls_last}
    where: {name: {_ilike: $query}}
  ) {
    id
    from_year
    to_year
    name
  }
}
    `;

export function useAllFinancialYearsQuery(options?: Omit<Urql.UseQueryArgs<AllFinancialYearsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllFinancialYearsQuery, AllFinancialYearsQueryVariables>({ query: AllFinancialYearsDocument, ...options });
};
export const InvoiceAggregateDocument = gql`
    query InvoiceAggregate($where: invoice_bool_exp) {
  invoice_aggregate(where: $where) {
    aggregate {
      sum {
        deducted_amount
      }
    }
  }
}
    `;

export function useInvoiceAggregateQuery(options?: Omit<Urql.UseQueryArgs<InvoiceAggregateQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceAggregateQuery, InvoiceAggregateQueryVariables>({ query: InvoiceAggregateDocument, ...options });
};
export const CreateOverDraftDocument = gql`
    mutation CreateOverDraft($tradeId: ID!) {
  create_over_draft_request(trade_id: $tradeId) {
    over_draft {
      id
      amount
    }
  }
}
    `;

export function useCreateOverDraftMutation() {
  return Urql.useMutation<CreateOverDraftMutation, CreateOverDraftMutationVariables>(CreateOverDraftDocument);
};
export const AllCreditStatusDocument = gql`
    query AllCreditStatus($where: credit_status_bool_exp) {
  credit_status(where: $where) {
    id
  }
}
    `;

export function useAllCreditStatusQuery(options?: Omit<Urql.UseQueryArgs<AllCreditStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<AllCreditStatusQuery, AllCreditStatusQueryVariables>({ query: AllCreditStatusDocument, ...options });
};
export const UpdateCreditStatusDocument = gql`
    mutation UpdateCreditStatus($input: ChangeCreditStatusInput) {
  change_credit_status(input: $input) {
    credit {
      id
    }
  }
}
    `;

export function useUpdateCreditStatusMutation() {
  return Urql.useMutation<UpdateCreditStatusMutation, UpdateCreditStatusMutationVariables>(UpdateCreditStatusDocument);
};
export const TradeAssessmentDynamicDocument = gql`
    query TradeAssessmentDynamic($input: TradeAssessmentDynamicInput) {
  trade_assessment_dynamic(input: $input) {
    trade_count
    settled_trade_count
    unsettled_trade_count
    total_sales
    daily_average_sale
    assessed_limit
  }
}
    `;

export function useTradeAssessmentDynamicQuery(options?: Omit<Urql.UseQueryArgs<TradeAssessmentDynamicQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeAssessmentDynamicQuery, TradeAssessmentDynamicQueryVariables>({ query: TradeAssessmentDynamicDocument, ...options });
};
export const DemandEnquiriesDocument = gql`
    query DemandEnquiries($where: demand_enquiries_bool_exp, $orderBy: [demand_enquiries_order_by!], $limit: Int, $offset: Int) {
  demand_enquiries(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    status
    created_at
    updated_at
    whatsapp_status
    demand {
      id
      created_by {
        id
        full_name
        photo {
          id
          url
        }
      }
    }
    seller {
      id
      user {
        id
        name: full_name
        number
        codename: reference_id
        is_verified
        external_reference_id2
      }
    }
    seller_external {
      id
      first_name
      last_name
      number
      user {
        id
        user {
          name: full_name
          codename: reference_id
          external_reference_id2
          is_verified
        }
      }
    }
  }
  demand_enquiries_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useDemandEnquiriesQuery(options?: Omit<Urql.UseQueryArgs<DemandEnquiriesQueryVariables>, 'query'>) {
  return Urql.useQuery<DemandEnquiriesQuery, DemandEnquiriesQueryVariables>({ query: DemandEnquiriesDocument, ...options });
};
export const DemandHeaderSummaryDocument = gql`
    query DemandHeaderSummary($materialKind: String) {
  active_demand: demand_aggregate(
    where: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}
  ) {
    aggregate {
      count
    }
  }
  closed_demand: demand_aggregate(
    where: {material_kind: {_eq: $materialKind}, status: {_in: ["closed"]}}
  ) {
    aggregate {
      count
    }
  }
  total_seller_enquiries: demand_enquiries_aggregate(
    where: {demand: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}}
  ) {
    aggregate {
      count
    }
  }
  total_seller_enquiries_actioned: demand_enquiries_aggregate(
    where: {whatsapp_status: {_in: ["Interested", "Not Interested"]}, demand: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}}
  ) {
    aggregate {
      count
    }
  }
  total_seller_enquiries_pending: demand_enquiries_aggregate(
    where: {whatsapp_status: {_nin: ["Interested", "Not Interested"]}, demand: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

export function useDemandHeaderSummaryQuery(options?: Omit<Urql.UseQueryArgs<DemandHeaderSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<DemandHeaderSummaryQuery, DemandHeaderSummaryQueryVariables>({ query: DemandHeaderSummaryDocument, ...options });
};
export const DemandWhatsAppSummaryDocument = gql`
    query DemandWhatsAppSummary($id: bigint!) {
  demand_by_pk(id: $id) {
    id
    messages_pending: enquiries_aggregate(
      where: {whatsapp_status: {_in: ["Not Sent"]}}
    ) {
      aggregate {
        count
      }
    }
    messages_sent: enquiries_aggregate(where: {whatsapp_status: {_in: ["Sent"]}}) {
      aggregate {
        count
      }
    }
    messages_delivered: enquiries_aggregate(
      where: {whatsapp_status: {_in: ["Delivered"]}}
    ) {
      aggregate {
        count
      }
    }
    messages_read: enquiries_aggregate(where: {whatsapp_status: {_in: ["Read"]}}) {
      aggregate {
        count
      }
    }
    total_enquiries: enquiries_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

export function useDemandWhatsAppSummaryQuery(options: Omit<Urql.UseQueryArgs<DemandWhatsAppSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<DemandWhatsAppSummaryQuery, DemandWhatsAppSummaryQueryVariables>({ query: DemandWhatsAppSummaryDocument, ...options });
};
export const UpsertDemandDocument = gql`
    mutation UpsertDemand($input: UpsertDemandInput!) {
  add_update_demand(input: $input) {
    demand {
      id
    }
  }
}
    `;

export function useUpsertDemandMutation() {
  return Urql.useMutation<UpsertDemandMutation, UpsertDemandMutationVariables>(UpsertDemandDocument);
};
export const CloseDemandDocument = gql`
    mutation CloseDemand($set: demand_set_input, $where: demand_bool_exp!) {
  update_demand(_set: $set, where: $where) {
    affected_rows
  }
}
    `;

export function useCloseDemandMutation() {
  return Urql.useMutation<CloseDemandMutation, CloseDemandMutationVariables>(CloseDemandDocument);
};
export const DemandsListDocument = gql`
    query DemandsList($where: demand_bool_exp, $limit: Int, $offset: Int, $orderBy: [demand_order_by!]) {
  demand(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    created_at
    status
    sauda_qty: trades_aggregate(where: {kind: {_eq: "pro_forma"}}) {
      aggregate {
        sum {
          total_quantity
        }
      }
    }
    buyer {
      id
      user {
        full_name
        external_reference_id2
      }
    }
    total_enuiry: enquiries_aggregate {
      aggregate {
        count
      }
    }
    successful_enuiry: enquiries_aggregate(where: {status: {_in: ["Hishob Patti"]}}) {
      aggregate {
        count
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    variety_grade {
      id
      name
    }
    rate_unit {
      id
      name
    }
    quantity_unit {
      id
      name
    }
    rate
    max_rate
    quantity
    deducted_amount
    total_amount
    start_date_time
    end_date_time
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    trades_aggregate {
      aggregate {
        sum {
          total_quantity
        }
      }
    }
  }
  demand_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useDemandsListQuery(options?: Omit<Urql.UseQueryArgs<DemandsListQueryVariables>, 'query'>) {
  return Urql.useQuery<DemandsListQuery, DemandsListQueryVariables>({ query: DemandsListDocument, ...options });
};
export const DemandDetailDocument = gql`
    query DemandDetail($id: bigint!) {
  demand_by_pk(id: $id) {
    ...DemandCoreFrag
    demand_seller_groups {
      id
      seller_groups {
        id
        name
        group_id
      }
    }
    total_enquiries: enquiries_aggregate {
      aggregate {
        count
      }
    }
  }
}
    ${DemandCoreFragFragmentDoc}`;

export function useDemandDetailQuery(options: Omit<Urql.UseQueryArgs<DemandDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<DemandDetailQuery, DemandDetailQueryVariables>({ query: DemandDetailDocument, ...options });
};
export const DemandSellerDetailDocument = gql`
    query DemandSellerDetail($id: bigint!, $sellerId: bigint!) {
  demand_by_pk(id: $id) {
    ...DemandCoreFrag
    enquiries(where: {seller_id: {_eq: $sellerId}}) {
      id
      status
      created_at
      updated_at
      whatsapp_status
      seller {
        id
        user {
          ...BaseUserFrag
        }
      }
    }
  }
}
    ${DemandCoreFragFragmentDoc}
${BaseUserFragFragmentDoc}`;

export function useDemandSellerDetailQuery(options: Omit<Urql.UseQueryArgs<DemandSellerDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<DemandSellerDetailQuery, DemandSellerDetailQueryVariables>({ query: DemandSellerDetailDocument, ...options });
};
export const AllDepartmentsDocument = gql`
    query AllDepartments($where: department_bool_exp) {
  department(where: $where, order_by: {name: asc_nulls_last}) {
    primaryKey: id
    name
    id: codename
    display_name
    abbreviation
  }
}
    `;

export function useAllDepartmentsQuery(options?: Omit<Urql.UseQueryArgs<AllDepartmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllDepartmentsQuery, AllDepartmentsQueryVariables>({ query: AllDepartmentsDocument, ...options });
};
export const AllDepotsDocument = gql`
    query AllDepots($query: String) {
  all_depots(query: $query, first: 10) {
    id
    name
    codename: name
  }
}
    `;

export function useAllDepotsQuery(options?: Omit<Urql.UseQueryArgs<AllDepotsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllDepotsQuery, AllDepotsQueryVariables>({ query: AllDepotsDocument, ...options });
};
export const DeleteExpenseItemDocument = gql`
    mutation DeleteExpenseItem($ids: [bigint!]) {
  delete_expense(where: {id: {_in: $ids}}) {
    returning {
      id
      trade {
        id
        expenses {
          ...ExpenseFrag
        }
      }
    }
  }
}
    ${ExpenseFragFragmentDoc}`;

export function useDeleteExpenseItemMutation() {
  return Urql.useMutation<DeleteExpenseItemMutation, DeleteExpenseItemMutationVariables>(DeleteExpenseItemDocument);
};
export const FinalAnalyticsDocument = gql`
    query FinalAnalytics($from: Date, $till: Date, $filters: AnalyticalQueryFilterInput) {
  final_analytics(from_date: $from, till_date: $till, filters: $filters) {
    id
    name
    reference_id
    trades {
      kind
      total_transactions
      total_quantity
      total_value
      unverified_transactions
      unverified_quantity
      unverified_value
      verified_transactions
      verified_quantity
      verified_value
      total_invoices
      invoice_quantity
      invoice_value
      pending_invoices
      total_inwards
      inward_quantity
      inward_value
      pending_inwards
      final_conversion_count
      final_conversion_pending_count
    }
  }
}
    `;

export function useFinalAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<FinalAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<FinalAnalyticsQuery, FinalAnalyticsQueryVariables>({ query: FinalAnalyticsDocument, ...options });
};
export const AllInvoicesDocument = gql`
    query AllInvoices($distinct_on: [invoice_select_column!], $limit: Int, $offset: Int, $order_by: [invoice_order_by!], $where: invoice_bool_exp) {
  invoice(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    twilio_message {
      id
      status
    }
    buyer_bifurcation {
      deducted_amount {
        op
        val
      }
      buyer_expense_amount {
        op
        val
      }
      buyer_expense_tax_amount {
        op
        val
      }
      buyer_debit_note_amount {
        op
        val
      }
      buyer_credit_note_amount {
        op
        val
      }
      buyer_tax_amount {
        op
        val
      }
      received_amount {
        op
        val
      }
      total
    }
    credit: issuance_notes(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "CREDIT"}}
      limit: 1
    ) {
      id
      is_verified
    }
    debit: issuance_notes(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "DEBIT"}}
      limit: 1
    ) {
      id
      is_verified
    }
    status_processing
    tracking_code
    total_amount
    total_quantity
    created_at
    updated_at
    current_status_id
    created_by {
      ...BaseUserDisplayFrag
    }
    buyer {
      id
      user {
        ...BaseUserDisplayFrag
      }
    }
    unit: trades(limit: 1) {
      id
      trade_items(limit: 1) {
        id
        quantity_unit {
          id
          name
        }
      }
    }
    trades {
      id
      trade_items_aggregate {
        aggregate {
          sum {
            returned_quantity
          }
        }
      }
      seller {
        id
        user {
          ...BaseUserDisplayFrag
        }
      }
    }
  }
  invoice_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${BaseUserDisplayFragFragmentDoc}`;

export function useAllInvoicesQuery(options?: Omit<Urql.UseQueryArgs<AllInvoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllInvoicesQuery, AllInvoicesQueryVariables>({ query: AllInvoicesDocument, ...options });
};
export const AllInvoiceStatusesDocument = gql`
    subscription AllInvoiceStatuses($distinct_on: [invoice_select_column!], $limit: Int, $offset: Int, $order_by: [invoice_order_by!], $where: invoice_bool_exp) {
  invoice(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    current_status_id
    status_processing
    twilio_message {
      id
      status
    }
  }
}
    `;

export function useAllInvoiceStatusesSubscription<TData = AllInvoiceStatusesSubscription>(options: Omit<Urql.UseSubscriptionArgs<AllInvoiceStatusesSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<AllInvoiceStatusesSubscription, TData>) {
  return Urql.useSubscription<AllInvoiceStatusesSubscription, TData, AllInvoiceStatusesSubscriptionVariables>({ query: AllInvoiceStatusesDocument, ...options }, handler);
};
export const GenerateInvoicesDocument = gql`
    mutation GenerateInvoices($department_id: ID, $trade_ids: [ID]) {
  generate_invoices(trade_ids: $trade_ids, department_id: $department_id) {
    invoices {
      id
    }
  }
}
    `;

export function useGenerateInvoicesMutation() {
  return Urql.useMutation<GenerateInvoicesMutation, GenerateInvoicesMutationVariables>(GenerateInvoicesDocument);
};
export const BulkUpdateInvoiceDocument = gql`
    mutation BulkUpdateInvoice($where: invoice_bool_exp!, $set: invoice_set_input!) {
  update_invoice(where: $where, _set: $set) {
    returning {
      id
      current_status_id
      status_processing
    }
    affected_rows
  }
}
    `;

export function useBulkUpdateInvoiceMutation() {
  return Urql.useMutation<BulkUpdateInvoiceMutation, BulkUpdateInvoiceMutationVariables>(BulkUpdateInvoiceDocument);
};
export const InvoicePreviewDocument = gql`
    query InvoicePreview($id: bigint!) {
  invoice_by_pk(id: $id) {
    id
    tracking_code
    standard_deduction
    expense_amount
    deducted_amount
    deducted_quantity
    buyer {
      id
      user {
        ...BaseUserDisplayFrag
      }
    }
    buyer_bifurcation {
      deducted_amount {
        op
        val
      }
      buyer_expense_amount {
        op
        val
      }
      buyer_expense_tax_amount {
        op
        val
      }
      buyer_debit_note_amount {
        op
        val
      }
      buyer_credit_note_amount {
        op
        val
      }
      buyer_tax_amount {
        op
        val
      }
      received_amount {
        op
        val
      }
      total
    }
    trades {
      id
      supplier_charge
      seller {
        id
        user {
          ...BaseUserDisplayFrag
        }
      }
      total_quantity
      total_amount
      trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
        id
        rate
        quantity
        amount
        commodity {
          id
          name
        }
        commodity_variety {
          id
          name
        }
        variety_grade {
          id
          name
        }
        quantity_unit {
          id
          name
        }
        rate_unit {
          id
          name
        }
        taxes(where: {role: {_eq: "buyer"}}) {
          id
          amount
          percentage
          role
          tax_name
        }
      }
    }
  }
}
    ${BaseUserDisplayFragFragmentDoc}`;

export function useInvoicePreviewQuery(options: Omit<Urql.UseQueryArgs<InvoicePreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicePreviewQuery, InvoicePreviewQueryVariables>({ query: InvoicePreviewDocument, ...options });
};
export const AllInvoiceIssuanceNotesDocument = gql`
    query AllInvoiceIssuanceNotes($invoiceId: bigint!) {
  invoice_by_pk(id: $invoiceId) {
    id
    quantity_revised: issuance_notes_aggregate(
      order_by: {created_at: desc_nulls_last}
      where: {kind: {_eq: "quantity"}}
    ) {
      aggregate {
        count
      }
    }
    buyer_credit: issuance_notes_aggregate(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "CREDIT"}, user_role: {_eq: "buyer"}, _or: [{is_verified: {_is_null: true}}, {is_verified: {_neq: false}}]}
    ) {
      aggregate {
        count
      }
    }
    buyer_credit_pending: issuance_notes_aggregate(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "CREDIT"}, user_role: {_eq: "buyer"}, is_verified: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    buyer_debit: issuance_notes_aggregate(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "DEBIT"}, user_role: {_eq: "buyer"}, _or: [{is_verified: {_is_null: true}}, {is_verified: {_neq: false}}]}
    ) {
      aggregate {
        count
      }
    }
    buyer_debit_pending: issuance_notes_aggregate(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "DEBIT"}, user_role: {_eq: "buyer"}, is_verified: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    __typename
  }
}
    `;

export function useAllInvoiceIssuanceNotesQuery(options: Omit<Urql.UseQueryArgs<AllInvoiceIssuanceNotesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllInvoiceIssuanceNotesQuery, AllInvoiceIssuanceNotesQueryVariables>({ query: AllInvoiceIssuanceNotesDocument, ...options });
};
export const InvoiceIssuanceNotesDocument = gql`
    query InvoiceIssuanceNotes($invoiceId: bigint!, $where: issuance_note_bool_exp, $orderBy: [issuance_note_order_by!]) {
  invoice_by_pk(id: $invoiceId) {
    id
    total_amount
    buyer {
      id
      name
    }
    buyer_payable
    buyer_bifurcation {
      deducted_amount {
        op
        val
      }
      total
    }
    created_at
    trades {
      id
      receipt_id
      seller {
        id
        name
      }
      commodity_variety {
        id
        name
      }
      taxes(where: {role: {_eq: "buyer"}}) {
        id
        amount
        name
        tax_name
        role
        percentage
      }
      trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
        id
        rate
        quantity
        returned_quantity
        commodity {
          id
          name
        }
        commodity_variety {
          id
          name
        }
        variety_grade {
          id
          name
        }
        quantity_unit {
          id
          name
        }
        taxes(where: {role: {_eq: "buyer"}}) {
          id
          percentage
          tax_name
        }
      }
    }
    issuance_notes(where: $where, order_by: $orderBy) {
      id
      amount
      created_at
      created_by_id
      is_verified
      kind
      remarks
      type
      input_value
      user_role
      verification_remark
      verified_by_id
      verified_on
      taxes {
        id
        amount
        name
        tax_name
        percentage
      }
      items {
        id
        input_value
        amount
        trade_item_id
        trade_item {
          id
          rate
          quantity
          commodity {
            id
            name
          }
          commodity_variety {
            id
            name
          }
          variety_grade {
            id
            name
          }
          quantity_unit {
            id
            name
          }
        }
        taxes {
          id
          amount
          percentage
          tax_name
        }
      }
      attachments {
        id
        media {
          id
          url
          kind
        }
      }
    }
    issuance_notes_aggregate(
      where: {_or: [{is_verified: {_is_null: true}}, {is_verified: {_neq: false}}], user_role: {_eq: "buyer"}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

export function useInvoiceIssuanceNotesQuery(options: Omit<Urql.UseQueryArgs<InvoiceIssuanceNotesQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceIssuanceNotesQuery, InvoiceIssuanceNotesQueryVariables>({ query: InvoiceIssuanceNotesDocument, ...options });
};
export const InvoiceSettlementDocument = gql`
    query InvoiceSettlement($where: invoice_bool_exp, $orderBy: [invoice_order_by!], $limit: Int, $offset: Int) {
  invoice(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    created_at
    id
    remark
    current_status_id
    metadata
    department {
      id
      name
    }
    issuance_notes_aggregate {
      aggregate {
        count
      }
    }
    buyer_settlement_status
    buyer_bifurcation {
      deducted_amount {
        op
        val
      }
      buyer_expense_amount {
        op
        val
      }
      buyer_expense_tax_amount {
        op
        val
      }
      buyer_debit_note_amount {
        op
        val
      }
      buyer_credit_note_amount {
        op
        val
      }
      buyer_tax_amount {
        op
        val
      }
      received_amount {
        op
        val
      }
      total
    }
    trades {
      id
      taxes(where: {role: {_eq: "buyer"}}) {
        id
        amount
        percentage
        role
        tax_name
      }
    }
    summary {
      buyer_credit_note_amount
      buyer_debit_note_amount
    }
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    buyer {
      id
      user {
        full_name
        external_reference_id2
        number
        secondary_number
      }
    }
    buyer_payable
    transactions_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
    transactions(limit: 1, order_by: {date: desc}) {
      id
      date
      remark
      created_at
    }
  }
  invoice_aggregate(where: $where) {
    aggregate {
      count
      sum {
        deducted_amount
      }
    }
  }
}
    `;

export function useInvoiceSettlementQuery(options?: Omit<Urql.UseQueryArgs<InvoiceSettlementQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSettlementQuery, InvoiceSettlementQueryVariables>({ query: InvoiceSettlementDocument, ...options });
};
export const InvoiceSettlementSelectorDocument = gql`
    query InvoiceSettlementSelector($where: invoice_bool_exp, $orderBy: [invoice_order_by!], $limit: Int, $offset: Int) {
  invoice(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    created_at
    id
    buyer_settlement_status
    buyer_bifurcation {
      total
      received_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
      buyer_expense_amount {
        op
        val
      }
      buyer_expense_tax_amount {
        op
        val
      }
      buyer_tax_amount {
        op
        val
      }
    }
  }
  invoice_aggregate(where: $where) {
    aggregate {
      count
      sum {
        deducted_amount
      }
    }
  }
}
    `;

export function useInvoiceSettlementSelectorQuery(options?: Omit<Urql.UseQueryArgs<InvoiceSettlementSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSettlementSelectorQuery, InvoiceSettlementSelectorQueryVariables>({ query: InvoiceSettlementSelectorDocument, ...options });
};
export const CreditInvoiceSettlementDocument = gql`
    query CreditInvoiceSettlement($where: invoice_bool_exp, $orderBy: [invoice_order_by!], $limit: Int, $offset: Int) {
  invoice(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    created_at
    id
    current_status_id
    buyer_bifurcation {
      total
      received_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
      buyer_expense_amount {
        op
        val
      }
      buyer_tax_amount {
        op
        val
      }
      buyer_expense_tax_amount {
        op
        val
      }
      buyer_debit_note_amount {
        op
        val
      }
      buyer_credit_note_amount {
        op
        val
      }
    }
    department {
      id
      name
    }
    summary {
      overdue_amount
      overdue_days
    }
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    buyer_payable
    transactions_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
    transactions(limit: 1, order_by: {date: desc}) {
      id
      date
      remark
      created_at
    }
  }
  invoice_aggregate(where: $where) {
    aggregate {
      count
      sum {
        deducted_amount
      }
    }
  }
}
    `;

export function useCreditInvoiceSettlementQuery(options?: Omit<Urql.UseQueryArgs<CreditInvoiceSettlementQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditInvoiceSettlementQuery, CreditInvoiceSettlementQueryVariables>({ query: CreditInvoiceSettlementDocument, ...options });
};
export const InvoiceSettlementAggregateDocument = gql`
    query InvoiceSettlementAggregate($where: invoice_bool_exp, $orderBy: [invoice_order_by!], $limit: Int, $offset: Int) {
  invoice_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useInvoiceSettlementAggregateQuery(options?: Omit<Urql.UseQueryArgs<InvoiceSettlementAggregateQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSettlementAggregateQuery, InvoiceSettlementAggregateQueryVariables>({ query: InvoiceSettlementAggregateDocument, ...options });
};
export const InvoiceSummaryAggregateDocument = gql`
    query InvoiceSummaryAggregate($userId: ID, $from: Date, $to: Date, $placedBy: ID) {
  invoice_summary_by_user(
    user_id: $userId
    from_date: $from
    placed_by: $placedBy
    till_date: $to
  ) {
    department_settlement_total_amount
    department_settlement_settled_amount
    department_settlement_remaining_amount
    total_invoice_amount
    received_amount
    overdue_amount
    overdue_days
    payment_cleared_in_days
  }
}
    `;

export function useInvoiceSummaryAggregateQuery(options?: Omit<Urql.UseQueryArgs<InvoiceSummaryAggregateQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSummaryAggregateQuery, InvoiceSummaryAggregateQueryVariables>({ query: InvoiceSummaryAggregateDocument, ...options });
};
export const InvoiceSettlementDetailDocument = gql`
    query InvoiceSettlementDetail($id: bigint!) {
  invoice_by_pk(id: $id) {
    created_at
    id
    remark
    department {
      id
      name
      codename
      reference_id
    }
    buyer_bifurcation {
      total
      received_amount {
        op
        val
      }
      buyer_credit_note_amount {
        op
        val
      }
      buyer_debit_note_amount {
        op
        val
      }
      buyer_expense_amount {
        op
        val
      }
      buyer_expense_tax_amount {
        op
        val
      }
      buyer_tax_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
    }
    pending_issuance_note_bool: trades_aggregate(
      where: {issuance_notes: {is_verified: {_is_null: true}}}
    ) {
      aggregate {
        count
      }
    }
    summary {
      buyer_credit_note_amount
      buyer_debit_note_amount
    }
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    buyer {
      id
      reference_id
      user {
        id
        full_name
        external_reference_id2
      }
    }
    buyer_payable
    transactions_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
    transactions(order_by: {date: desc}) {
      id
      date
      remark
      created_at
      amount
      parent_transaction {
        id
        transaction_id
      }
      transaction_id
      attachments {
        id
        media {
          id
          url
        }
      }
      mode {
        id
        codename
        name
      }
    }
  }
}
    `;

export function useInvoiceSettlementDetailQuery(options: Omit<Urql.UseQueryArgs<InvoiceSettlementDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSettlementDetailQuery, InvoiceSettlementDetailQueryVariables>({ query: InvoiceSettlementDetailDocument, ...options });
};
export const InvoiceSettlementDetailOverduesDocument = gql`
    query InvoiceSettlementDetailOverdues($id: bigint!) {
  invoice_by_pk(id: $id) {
    summary {
      overdue_amount
      overdue_days
    }
  }
}
    `;

export function useInvoiceSettlementDetailOverduesQuery(options: Omit<Urql.UseQueryArgs<InvoiceSettlementDetailOverduesQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSettlementDetailOverduesQuery, InvoiceSettlementDetailOverduesQueryVariables>({ query: InvoiceSettlementDetailOverduesDocument, ...options });
};
export const UpdateInvoiceSettlementPaymentDocument = gql`
    mutation UpdateInvoiceSettlementPayment($id: bigint!, $object: invoice_set_input) {
  update_invoice_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    remark
  }
}
    `;

export function useUpdateInvoiceSettlementPaymentMutation() {
  return Urql.useMutation<UpdateInvoiceSettlementPaymentMutation, UpdateInvoiceSettlementPaymentMutationVariables>(UpdateInvoiceSettlementPaymentDocument);
};
export const InvoiceSettlementTransactionsDocument = gql`
    query InvoiceSettlementTransactions($dept: ID!, $user: ID!, $kind: DepartmentSettlementKind!) {
  transactions_for_invoice_settlement(
    filters: {department_codename: $dept, user_ref: $user, department_settlement_kind: $kind}
  ) {
    id
    transaction_id
    amount
    remaining_amount
  }
}
    `;

export function useInvoiceSettlementTransactionsQuery(options: Omit<Urql.UseQueryArgs<InvoiceSettlementTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSettlementTransactionsQuery, InvoiceSettlementTransactionsQueryVariables>({ query: InvoiceSettlementTransactionsDocument, ...options });
};
export const MapInvoiceTransactionsDocument = gql`
    mutation MapInvoiceTransactions($invoiceId: ID!, $transactions: [ID]!, $remark: String) {
  map_invoice_transaction(
    invoice_id: $invoiceId
    transactions: $transactions
    remark: $remark
  ) {
    invoice {
      id
      invoice_transactions {
        id
        amount
      }
    }
  }
}
    `;

export function useMapInvoiceTransactionsMutation() {
  return Urql.useMutation<MapInvoiceTransactionsMutation, MapInvoiceTransactionsMutationVariables>(MapInvoiceTransactionsDocument);
};
export const BuyerOverAllOutstandingDocument = gql`
    query BuyerOverAllOutstanding($user_id: bigint) {
  credit_transaction_aggregate(where: {credit: {user_id: {_eq: $user_id}}}) {
    aggregate {
      sum {
        outstanding_amount
      }
    }
  }
}
    `;

export function useBuyerOverAllOutstandingQuery(options?: Omit<Urql.UseQueryArgs<BuyerOverAllOutstandingQueryVariables>, 'query'>) {
  return Urql.useQuery<BuyerOverAllOutstandingQuery, BuyerOverAllOutstandingQueryVariables>({ query: BuyerOverAllOutstandingDocument, ...options });
};
export const InvoiceSummaryAnalyticsDocument = gql`
    query InvoiceSummaryAnalytics($createdById: String, $search: String, $createdFrom: Date, $createdTill: Date, $department: [String], $buyerReferenceId: String) {
  aggregate_invoice_summary(
    created_from: $createdFrom
    created_till: $createdTill
    department_reference_id_list: $department
    buyer_reference_id: $buyerReferenceId
    created_by_id: $createdById
    search: $search
  ) {
    department_settlement_total_amount
    department_settlement_settled_amount
    department_settlement_remaining_amount
    deducted_amount {
      op
      val
    }
    buyer_expense_amount {
      op
      val
    }
    buyer_expense_tax_amount {
      op
      val
    }
    buyer_debit_note_amount {
      op
      val
    }
    buyer_credit_note_amount {
      op
      val
    }
    buyer_tax_amount {
      op
      val
    }
    received_amount {
      op
      val
    }
    total
  }
}
    `;

export function useInvoiceSummaryAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<InvoiceSummaryAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceSummaryAnalyticsQuery, InvoiceSummaryAnalyticsQueryVariables>({ query: InvoiceSummaryAnalyticsDocument, ...options });
};
export const AddUpdateIssuanceNotesDocument = gql`
    mutation AddUpdateIssuanceNotes($input: IssuanceNoteInput) {
  add_update_issuance_note(input: $input) {
    issuance_note {
      id
      amount
      created_at
      created_by_id
      is_verified
      kind
      remarks
      type
      input_value
      user_role
      verification_remark
      verified_by_id
      verified_on
    }
  }
}
    `;

export function useAddUpdateIssuanceNotesMutation() {
  return Urql.useMutation<AddUpdateIssuanceNotesMutation, AddUpdateIssuanceNotesMutationVariables>(AddUpdateIssuanceNotesDocument);
};
export const RecordTradeInvoiceReturnDocument = gql`
    mutation RecordTradeInvoiceReturn($items: [RecordReturnQuantityInput]!) {
  record_trade_return(items: $items) {
    affected_rows
  }
}
    `;

export function useRecordTradeInvoiceReturnMutation() {
  return Urql.useMutation<RecordTradeInvoiceReturnMutation, RecordTradeInvoiceReturnMutationVariables>(RecordTradeInvoiceReturnDocument);
};
export const TradeIssuanceNotesDocument = gql`
    query TradeIssuanceNotes($tradeId: bigint!, $where: issuance_note_bool_exp, $orderBy: [issuance_note_order_by!]) {
  trade_by_pk(id: $tradeId) {
    id
    total_amount
    buyer {
      id
      name
    }
    seller {
      id
      name
    }
    seller_bifurcation {
      total
      deducted_amount {
        op
        val
      }
    }
    buyer_bifurcation {
      total
      deducted_amount {
        op
        val
      }
    }
    commodity_variety {
      id
      name
    }
    seller_payable
    buyer_payable
    taxes(where: {role: {_eq: "seller"}}) {
      id
      amount
      name
      tax_name
      role
      percentage
    }
    created_at
    trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
      id
      rate
      quantity
      returned_quantity
      commodity {
        id
        name
      }
      commodity_variety {
        id
        name
      }
      variety_grade {
        id
        name
      }
      quantity_unit {
        id
        name
      }
      taxes(where: {role: {_eq: "seller"}}) {
        id
        percentage
        tax_name
      }
    }
    issuance_notes(where: $where, order_by: $orderBy) {
      id
      amount
      created_at
      items {
        id
        input_value
        amount
        trade_item_id
        taxes {
          id
          amount
          percentage
          tax_name
        }
        trade_item {
          id
          rate
          quantity
          commodity {
            id
            name
          }
          commodity_variety {
            id
            name
          }
          variety_grade {
            id
            name
          }
          quantity_unit {
            id
            name
          }
        }
        taxes {
          id
          amount
          percentage
          tax_name
        }
        attachments {
          id
          media {
            id
            url
          }
        }
      }
      created_by_id
      is_verified
      kind
      remarks
      type
      input_value
      user_role
      verification_remark
      verified_by_id
      verified_on
      taxes {
        id
        amount
        name
        tax_name
        percentage
      }
      attachments {
        id
        media {
          id
          url
          kind
        }
      }
    }
  }
}
    `;

export function useTradeIssuanceNotesQuery(options: Omit<Urql.UseQueryArgs<TradeIssuanceNotesQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeIssuanceNotesQuery, TradeIssuanceNotesQueryVariables>({ query: TradeIssuanceNotesDocument, ...options });
};
export const AllTradeIssuanceNotesDocument = gql`
    query AllTradeIssuanceNotes($tradeId: bigint!) {
  trade_by_pk(id: $tradeId) {
    id
    seller_credit: issuance_notes_aggregate(
      where: {type: {_eq: "CREDIT"}, user_role: {_eq: "seller"}, _or: [{is_verified: {_is_null: true}}, {is_verified: {_neq: false}}]}
    ) {
      aggregate {
        count
      }
    }
    seller_credit_pending: issuance_notes_aggregate(
      where: {type: {_eq: "CREDIT"}, user_role: {_eq: "seller"}, is_verified: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
    seller_debit: issuance_notes_aggregate(
      where: {type: {_eq: "DEBIT"}, user_role: {_eq: "seller"}, _or: [{is_verified: {_is_null: true}}, {is_verified: {_neq: false}}]}
    ) {
      aggregate {
        count
      }
    }
    seller_debit_pending: issuance_notes_aggregate(
      where: {type: {_eq: "DEBIT"}, user_role: {_eq: "seller"}, is_verified: {_is_null: true}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

export function useAllTradeIssuanceNotesQuery(options: Omit<Urql.UseQueryArgs<AllTradeIssuanceNotesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTradeIssuanceNotesQuery, AllTradeIssuanceNotesQueryVariables>({ query: AllTradeIssuanceNotesDocument, ...options });
};
export const TradeMetricsDocument = gql`
    query TradeMetrics($kind: String, $mode: String, $department: bigint, $parent: bigint_comparison_exp, $date: timestamptz_comparison_exp) {
  trade_aggregate(
    where: {kind: {_eq: $kind}, mode: {_eq: $mode}, department_id: {_eq: $department}, parent_trade_id: $parent, created_at: $date}
  ) {
    aggregate {
      count
      sum {
        total_amount
        total_quantity
        expense_amount
      }
    }
  }
}
    `;

export function useTradeMetricsQuery(options?: Omit<Urql.UseQueryArgs<TradeMetricsQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeMetricsQuery, TradeMetricsQueryVariables>({ query: TradeMetricsDocument, ...options });
};
export const MixAnalyticsDocument = gql`
    query MixAnalytics($from: Date, $till: Date, $filters: AnalyticalQueryFilterInput) {
  mix_analytics(from_date: $from, till_date: $till, filters: $filters) {
    id
    name
    reference_id
    trades {
      kind
      total_transactions
      total_quantity
      total_value
      unverified_transactions
      unverified_quantity
      unverified_value
      verified_transactions
      verified_quantity
      verified_value
      final_conversion_count
      final_conversion_pending_count
    }
  }
}
    `;

export function useMixAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<MixAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<MixAnalyticsQuery, MixAnalyticsQueryVariables>({ query: MixAnalyticsDocument, ...options });
};
export const OfferEnquiriesDocument = gql`
    query OfferEnquiries($where: offer_enquiries_bool_exp, $orderBy: [offer_enquiries_order_by!], $limit: Int, $offset: Int) {
  offer_enquiries(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    status
    created_at
    updated_at
    whatsapp_status
    offer {
      id
      created_by {
        id
        full_name
        photo {
          id
          url
        }
      }
    }
    buyer {
      id
      user {
        id
        name: full_name
        number
        is_verified
        codename: reference_id
        external_reference_id2
      }
    }
    buyer_external {
      id
      first_name
      last_name
      number
      user {
        id
        user {
          name: full_name
          codename: reference_id
          external_reference_id2
          is_verified
        }
      }
    }
  }
  offer_enquiries_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useOfferEnquiriesQuery(options?: Omit<Urql.UseQueryArgs<OfferEnquiriesQueryVariables>, 'query'>) {
  return Urql.useQuery<OfferEnquiriesQuery, OfferEnquiriesQueryVariables>({ query: OfferEnquiriesDocument, ...options });
};
export const OfferHeaderSummaryDocument = gql`
    query OfferHeaderSummary($materialKind: String) {
  active_offer: offers_aggregate(
    where: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}
  ) {
    aggregate {
      count
    }
  }
  closed_offer: offers_aggregate(
    where: {material_kind: {_eq: $materialKind}, status: {_in: ["closed"]}}
  ) {
    aggregate {
      count
    }
  }
  total_buyer_enquiries: offer_enquiries_aggregate(
    where: {offer: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}}
  ) {
    aggregate {
      count
    }
  }
  total_buyer_enquiries_actioned: offer_enquiries_aggregate(
    where: {whatsapp_status: {_in: ["Interested", "Not Interested"]}, offer: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}}
  ) {
    aggregate {
      count
    }
  }
  total_buyer_enquiries_pending: offer_enquiries_aggregate(
    where: {whatsapp_status: {_nin: ["Interested", "Not Interested"]}, offer: {material_kind: {_eq: $materialKind}, status: {_in: ["live", "created"]}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

export function useOfferHeaderSummaryQuery(options?: Omit<Urql.UseQueryArgs<OfferHeaderSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<OfferHeaderSummaryQuery, OfferHeaderSummaryQueryVariables>({ query: OfferHeaderSummaryDocument, ...options });
};
export const OfferWhatsAppSummaryDocument = gql`
    query OfferWhatsAppSummary($id: bigint!) {
  offers_by_pk(id: $id) {
    id
    messages_pending: offer_enquiries_aggregate(
      where: {whatsapp_status: {_in: ["Not Sent"]}}
    ) {
      aggregate {
        count
      }
    }
    messages_sent: offer_enquiries_aggregate(
      where: {whatsapp_status: {_in: ["Sent"]}}
    ) {
      aggregate {
        count
      }
    }
    messages_delivered: offer_enquiries_aggregate(
      where: {whatsapp_status: {_in: ["Delivered"]}}
    ) {
      aggregate {
        count
      }
    }
    messages_read: offer_enquiries_aggregate(
      where: {whatsapp_status: {_in: ["Read"]}}
    ) {
      aggregate {
        count
      }
    }
    total_enquiries: offer_enquiries_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

export function useOfferWhatsAppSummaryQuery(options: Omit<Urql.UseQueryArgs<OfferWhatsAppSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<OfferWhatsAppSummaryQuery, OfferWhatsAppSummaryQueryVariables>({ query: OfferWhatsAppSummaryDocument, ...options });
};
export const UpsertOfferMutationDocument = gql`
    mutation UpsertOfferMutation($input: UpsertOfferInput!) {
  add_update_offer(input: $input) {
    offer {
      id
    }
  }
}
    `;

export function useUpsertOfferMutationMutation() {
  return Urql.useMutation<UpsertOfferMutationMutation, UpsertOfferMutationMutationVariables>(UpsertOfferMutationDocument);
};
export const UseOfferStockForOrderDocument = gql`
    mutation UseOfferStockForOrder($id: ID!, $tradeId: ID!) {
  use_offer_stock(offer_id: $id, trade_id: $tradeId) {
    offer {
      id
    }
  }
}
    `;

export function useUseOfferStockForOrderMutation() {
  return Urql.useMutation<UseOfferStockForOrderMutation, UseOfferStockForOrderMutationVariables>(UseOfferStockForOrderDocument);
};
export const CloseOfferDocument = gql`
    mutation CloseOffer($id: ID!, $status: String!) {
  update_offer_status(id: $id, status: $status) {
    offer {
      id
    }
  }
}
    `;

export function useCloseOfferMutation() {
  return Urql.useMutation<CloseOfferMutation, CloseOfferMutationVariables>(CloseOfferDocument);
};
export const OffersListDocument = gql`
    query OffersList($where: offers_bool_exp, $limit: Int, $offset: Int, $orderBy: [offers_order_by!]) {
  offers(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    created_at
    status
    order_qty: trades_aggregate(where: {kind: {_eq: "order"}}) {
      aggregate {
        sum {
          total_quantity
        }
      }
    }
    hishob_qty: trades_aggregate(where: {kind: {_eq: "final"}}) {
      aggregate {
        sum {
          total_quantity
        }
      }
    }
    seller {
      id
      user {
        full_name
        external_reference_id2
      }
    }
    total_enuiry: offer_enquiries_aggregate {
      aggregate {
        count
      }
    }
    successful_enuiry: offer_enquiries_aggregate(
      where: {status: {_in: ["Hishob Patti"]}}
    ) {
      aggregate {
        count
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    variety_grade {
      id
      name
    }
    rate_unit {
      id
      name
    }
    quantity_unit {
      id
      name
    }
    rate
    max_rate
    deducted_amount
    total_amount
    quantity
    start_date_time
    end_date_time
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
  }
  offers_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useOffersListQuery(options?: Omit<Urql.UseQueryArgs<OffersListQueryVariables>, 'query'>) {
  return Urql.useQuery<OffersListQuery, OffersListQueryVariables>({ query: OffersListDocument, ...options });
};
export const OfferDetailDocument = gql`
    query OfferDetail($id: bigint!) {
  offers_by_pk(id: $id) {
    ...OfferCoreFrag
    offers_buyer_groups {
      id
      buyer_groups {
        id
        name
        group_id
      }
    }
    total_enquiries: offer_enquiries_aggregate {
      aggregate {
        count
      }
    }
  }
  offer_order_picked_aggregate(
    where: {offer_storage_picked: {offer_id: {_eq: $id}}}
  ) {
    aggregate {
      sum {
        quantity
      }
    }
  }
}
    ${OfferCoreFragFragmentDoc}`;

export function useOfferDetailQuery(options: Omit<Urql.UseQueryArgs<OfferDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<OfferDetailQuery, OfferDetailQueryVariables>({ query: OfferDetailDocument, ...options });
};
export const OfferBuyerDetailDocument = gql`
    query OfferBuyerDetail($id: bigint!, $buyerId: bigint!) {
  offers_by_pk(id: $id) {
    ...OfferCoreFrag
    trades(where: {kind: {_eq: "order"}}) {
      id
      kind
    }
    enquiries: offer_enquiries(where: {buyer_id: {_eq: $buyerId}}) {
      id
      status
      created_at
      updated_at
      whatsapp_status
      buyer {
        id
        user {
          ...BaseUserFrag
        }
      }
    }
  }
  offer_order_picked_aggregate(
    where: {offer_storage_picked: {offer_id: {_eq: $id}}}
  ) {
    aggregate {
      sum {
        quantity
      }
    }
  }
}
    ${OfferCoreFragFragmentDoc}
${BaseUserFragFragmentDoc}`;

export function useOfferBuyerDetailQuery(options: Omit<Urql.UseQueryArgs<OfferBuyerDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<OfferBuyerDetailQuery, OfferBuyerDetailQueryVariables>({ query: OfferBuyerDetailDocument, ...options });
};
export const OfferOrderListDocument = gql`
    query OfferOrderList($where: offers_bool_exp) {
  offers(where: $where) {
    id
    trades(where: {kind: {_eq: "order"}}) {
      id
      kind
      seller {
        id
        user {
          full_name
        }
      }
      buyer {
        id
        user {
          full_name
        }
      }
      total_quantity
      trade_items {
        id
        rate
        quantity
      }
    }
  }
}
    `;

export function useOfferOrderListQuery(options?: Omit<Urql.UseQueryArgs<OfferOrderListQueryVariables>, 'query'>) {
  return Urql.useQuery<OfferOrderListQuery, OfferOrderListQueryVariables>({ query: OfferOrderListDocument, ...options });
};
export const AllPackingMaterialsSelectorDocument = gql`
    query AllPackingMaterialsSelector {
  all_packing_materials(type_name: "") {
    id
    name
    codename
    type
  }
}
    `;

export function useAllPackingMaterialsSelectorQuery(options?: Omit<Urql.UseQueryArgs<AllPackingMaterialsSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<AllPackingMaterialsSelectorQuery, AllPackingMaterialsSelectorQueryVariables>({ query: AllPackingMaterialsSelectorDocument, ...options });
};
export const PackingMaterialsDocument = gql`
    query PackingMaterials($where: packaging_order_bool_exp, $limit: Int, $offset: Int, $order_by: [packaging_order_order_by!]) {
  packaging_order(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...PackagingOrderFields
  }
  packaging_order_aggregate {
    aggregate {
      count
    }
  }
}
    ${PackagingOrderFieldsFragmentDoc}`;

export function usePackingMaterialsQuery(options?: Omit<Urql.UseQueryArgs<PackingMaterialsQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingMaterialsQuery, PackingMaterialsQueryVariables>({ query: PackingMaterialsDocument, ...options });
};
export const PackingMaterialByIdDocument = gql`
    query PackingMaterialById($id: bigint!) {
  packaging_order_by_pk(id: $id) {
    ...PackagingOrderFields
    packaging_order_items {
      id
      rate
      quantity
      amount
    }
    payments {
      id
      date
      mode
      transaction_id
      amount
      account_number
      acount_holder
      photo {
        id
        kind
        url
      }
      ifsc_code
      bank_name
      branch_name
    }
  }
}
    ${PackagingOrderFieldsFragmentDoc}`;

export function usePackingMaterialByIdQuery(options: Omit<Urql.UseQueryArgs<PackingMaterialByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingMaterialByIdQuery, PackingMaterialByIdQueryVariables>({ query: PackingMaterialByIdDocument, ...options });
};
export const ViewSapTransactionDocument = gql`
    query ViewSapTransaction($where: packaging_order_bool_exp) {
  packaging_order(where: $where) {
    id
    transaction_number
    transaction_attachment {
      id
      url
      kind
    }
  }
}
    `;

export function useViewSapTransactionQuery(options?: Omit<Urql.UseQueryArgs<ViewSapTransactionQueryVariables>, 'query'>) {
  return Urql.useQuery<ViewSapTransactionQuery, ViewSapTransactionQueryVariables>({ query: ViewSapTransactionDocument, ...options });
};
export const UserPackingDocument = gql`
    query UserPacking($where: packaging_order_bool_exp) {
  packaging_order(where: $where) {
    id
    transaction_number
    payment_status
    total_quantity
    total_amount
    total_amount_pending
    total_amount_paid
    packaging_order_items {
      id
      packaging {
        id
        name
        material_code
      }
      quantity
      rate
      amount
    }
  }
}
    `;

export function useUserPackingQuery(options?: Omit<Urql.UseQueryArgs<UserPackingQueryVariables>, 'query'>) {
  return Urql.useQuery<UserPackingQuery, UserPackingQueryVariables>({ query: UserPackingDocument, ...options });
};
export const AddPackagingSapDocument = gql`
    mutation AddPackagingSap($id: bigint!, $_set: packaging_order_set_input) {
  update_packaging_order_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

export function useAddPackagingSapMutation() {
  return Urql.useMutation<AddPackagingSapMutation, AddPackagingSapMutationVariables>(AddPackagingSapDocument);
};
export const InsertPackagingOrderDocument = gql`
    mutation InsertPackagingOrder($input: [packaging_order_insert_input!]!, $on_conflict: packaging_order_on_conflict) {
  insert_packaging_order(on_conflict: $on_conflict, objects: $input) {
    affected_rows
    returning {
      id
    }
  }
}
    `;

export function useInsertPackagingOrderMutation() {
  return Urql.useMutation<InsertPackagingOrderMutation, InsertPackagingOrderMutationVariables>(InsertPackagingOrderDocument);
};
export const AdvanceSummaryDashboardDocument = gql`
    query AdvanceSummaryDashboard($department_id: ID!, $createdFrom: Date, $createdTill: Date, $sellerId: ID) {
  advance_summary_dashboard(
    department_id: $department_id
    created_from: $createdFrom
    created_till: $createdTill
    user_reference_id: $sellerId
  ) {
    trade_amount
    requested_advance_amount
    advance_status_pending
    released_advance_amount
    settled_amount
  }
}
    `;

export function useAdvanceSummaryDashboardQuery(options: Omit<Urql.UseQueryArgs<AdvanceSummaryDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<AdvanceSummaryDashboardQuery, AdvanceSummaryDashboardQueryVariables>({ query: AdvanceSummaryDashboardDocument, ...options });
};
export const ReceiptAdvanceSummaryDashboardDocument = gql`
    query ReceiptAdvanceSummaryDashboard($department_id: ID!, $createdFrom: Date, $createdTill: Date, $sellerId: ID) {
  advance_summary_dashboard_receipt(
    department_id: $department_id
    created_from: $createdFrom
    created_till: $createdTill
    user_reference_id: $sellerId
  ) {
    trade_amount
    requested_advance_amount
    advance_status_pending
    released_advance_amount
    settled_amount
  }
}
    `;

export function useReceiptAdvanceSummaryDashboardQuery(options: Omit<Urql.UseQueryArgs<ReceiptAdvanceSummaryDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<ReceiptAdvanceSummaryDashboardQuery, ReceiptAdvanceSummaryDashboardQueryVariables>({ query: ReceiptAdvanceSummaryDashboardDocument, ...options });
};
export const AllAdvancePaymentsDocument = gql`
    query AllAdvancePayments($where: advance_payment_bool_exp, $limit: Int, $offset: Int, $orderBy: [advance_payment_order_by!]) {
  advance_payment(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    created_at
    created_by_id
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    settlement_status
    status
    remark
    remaining_amount
    trade {
      id
      kind
      seller {
        id
        user {
          id
          full_name
          external_reference_id2
        }
      }
      seller_payable
    }
    receipt {
      id
      kind
      seller {
        id
        user {
          id
          full_name
          external_reference_id2
          payment_details {
            id
            account_holder_name
            account_number
            content_type {
              id
              model
            }
            ifsc_code
            method {
              id
              name
            }
            bank_name
          }
        }
      }
      seller_payable
    }
    parameter {
      id
      name
    }
    amount
    is_verified
    verified_on
    transactions_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
    transactions(order_by: {date: desc}) {
      id
      parent_transaction_id
      remark
      trade {
        id
        receipt_id
      }
      attachments {
        id
        media {
          id
          url
        }
      }
      date
      amount
      remark
    }
  }
  advance_payment_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllAdvancePaymentsQuery(options?: Omit<Urql.UseQueryArgs<AllAdvancePaymentsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllAdvancePaymentsQuery, AllAdvancePaymentsQueryVariables>({ query: AllAdvancePaymentsDocument, ...options });
};
export const AdvancePaymentDetailDocument = gql`
    query AdvancePaymentDetail($id: bigint!) {
  advance_payment_by_pk(id: $id) {
    id
    created_at
    created_by_id
    remark
    trade {
      id
      kind
      advance_summary {
        requested_advance
        released_advance
        seller_receivable_amount
        advance_used_in_current_trade
        advance_used_in_other_trades
        remaining_advance
      }
      seller_bifurcation {
        deducted_amount {
          op
          val
        }
        paid_amount {
          op
          val
        }
        seller_credit_note_amount {
          op
          val
        }
        seller_debit_note_amount {
          op
          val
        }
        seller_expense_amount {
          op
          val
        }
        seller_expense_tax_amount {
          op
          val
        }
        seller_tax_amount {
          op
          val
        }
        supplier_charge {
          op
          val
        }
        seller_tds {
          op
          val
        }
        total
      }
      seller {
        id
        user {
          id
          full_name
          external_reference_id2
          my_businesses(limit: 1) {
            id
            payment_details {
              id
              account_holder_name
              account_number
              content_type {
                id
                model
              }
              ifsc_code
              method {
                id
                name
              }
              bank_name
            }
          }
          payment_details {
            id
            account_holder_name
            account_number
            content_type {
              id
              model
            }
            ifsc_code
            method {
              id
              name
            }
            bank_name
          }
        }
      }
      seller_payable
    }
    receipt {
      id
      kind
      seller {
        id
        user {
          id
          full_name
          external_reference_id2
          my_businesses(limit: 1) {
            id
            payment_details {
              id
              account_holder_name
              account_number
              content_type {
                id
                model
              }
              ifsc_code
              method {
                id
                name
              }
              bank_name
            }
          }
          payment_details {
            id
            account_holder_name
            account_number
            content_type {
              id
              model
            }
            ifsc_code
            method {
              id
              name
            }
            bank_name
          }
        }
      }
      seller_payable
    }
    parameter {
      id
      name
    }
    amount
    is_verified
    status
    settlement_status
    transactions_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
    transactions(order_by: {date: desc}) {
      id
      created_at
      remark
      trade {
        id
        kind
      }
      receipt {
        id
        kind
      }
      attachments {
        id
        media {
          id
          url
        }
      }
      advance_payment {
        id
        amount
        parameter {
          id
          name
        }
      }
      date
      mode {
        id
        codename
        name
      }
      transaction_id
      account_no
      amount
    }
  }
}
    `;

export function useAdvancePaymentDetailQuery(options: Omit<Urql.UseQueryArgs<AdvancePaymentDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<AdvancePaymentDetailQuery, AdvancePaymentDetailQueryVariables>({ query: AdvancePaymentDetailDocument, ...options });
};
export const UpdateAdvancePaymentDocument = gql`
    mutation UpdateAdvancePayment($id: bigint!, $object: advance_payment_set_input) {
  update_advance_payment_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    remark
  }
}
    `;

export function useUpdateAdvancePaymentMutation() {
  return Urql.useMutation<UpdateAdvancePaymentMutation, UpdateAdvancePaymentMutationVariables>(UpdateAdvancePaymentDocument);
};
export const CloseAdvanceRequestDocument = gql`
    mutation CloseAdvanceRequest($advance_payment_id: ID!) {
  close_advance_payment(advance_payment_id: $advance_payment_id) {
    success
  }
}
    `;

export function useCloseAdvanceRequestMutation() {
  return Urql.useMutation<CloseAdvanceRequestMutation, CloseAdvanceRequestMutationVariables>(CloseAdvanceRequestDocument);
};
export const DepartmentUserAdvancesDocument = gql`
    query DepartmentUserAdvances($filters: DepartmentUserAdvanceFilterInput) {
  department_user_advances(filters: $filters) {
    summary {
      total_requested_amount
      total_released_amount
      used_amount
      remaining_amount
      unreleased_amount
    }
    items {
      id
      codename
      name
      created_at
      is_active
      total_requested_amount
      total_released_amount
      used_amount
      remaining_amount
      unreleased_amount
      user {
        id
        name
        reference_id
      }
      department {
        id
        name
      }
    }
  }
}
    `;

export function useDepartmentUserAdvancesQuery(options?: Omit<Urql.UseQueryArgs<DepartmentUserAdvancesQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentUserAdvancesQuery, DepartmentUserAdvancesQueryVariables>({ query: DepartmentUserAdvancesDocument, ...options });
};
export const CreateAdvanceTransactionDocument = gql`
    mutation CreateAdvanceTransaction($input: AdvanceTransactionInput!) {
  add_advance_transaction(input: $input) {
    transaction {
      id
    }
  }
}
    `;

export function useCreateAdvanceTransactionMutation() {
  return Urql.useMutation<CreateAdvanceTransactionMutation, CreateAdvanceTransactionMutationVariables>(CreateAdvanceTransactionDocument);
};
export const ReceiptAdvancePaymentsDocument = gql`
    query ReceiptAdvancePayments($receiptId: bigint!) {
  advance_payment(
    where: {receipt: {id: {_eq: $receiptId}}}
    order_by: {created_at: desc}
  ) {
    id
    created_at
    amount
    remaining_amount
    is_verified
    verified_on
    status
    parameter {
      id
      name
    }
    created_by {
      id
      full_name
    }
  }
}
    `;

export function useReceiptAdvancePaymentsQuery(options: Omit<Urql.UseQueryArgs<ReceiptAdvancePaymentsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReceiptAdvancePaymentsQuery, ReceiptAdvancePaymentsQueryVariables>({ query: ReceiptAdvancePaymentsDocument, ...options });
};
export const SendAdvanceRequestDocument = gql`
    mutation SendAdvanceRequest($advance_payment_ids: [ID]!) {
  request_advance_payment(advance_payment_ids: $advance_payment_ids) {
    success
  }
}
    `;

export function useSendAdvanceRequestMutation() {
  return Urql.useMutation<SendAdvanceRequestMutation, SendAdvanceRequestMutationVariables>(SendAdvanceRequestDocument);
};
export const MapTransactionsForTradesDocument = gql`
    mutation MapTransactionsForTrades($input: [MapTradeTransactionManyInput]!) {
  map_trade_transaction_many(inputs: $input) {
    trades {
      id
    }
  }
}
    `;

export function useMapTransactionsForTradesMutation() {
  return Urql.useMutation<MapTransactionsForTradesMutation, MapTransactionsForTradesMutationVariables>(MapTransactionsForTradesDocument);
};
export const MapTransactionsForInvoicesDocument = gql`
    mutation MapTransactionsForInvoices($input: [MapInvoiceTransactionManyInput]!) {
  map_invoice_transaction_many(inputs: $input) {
    invoices {
      id
    }
  }
}
    `;

export function useMapTransactionsForInvoicesMutation() {
  return Urql.useMutation<MapTransactionsForInvoicesMutation, MapTransactionsForInvoicesMutationVariables>(MapTransactionsForInvoicesDocument);
};
export const MapTransactionsForReceiptsDocument = gql`
    mutation MapTransactionsForReceipts($input: [MapReceiptTransactionManyInput]!) {
  map_receipt_transaction_many(inputs: $input) {
    receipts {
      id
    }
  }
}
    `;

export function useMapTransactionsForReceiptsMutation() {
  return Urql.useMutation<MapTransactionsForReceiptsMutation, MapTransactionsForReceiptsMutationVariables>(MapTransactionsForReceiptsDocument);
};
export const NetPayableTradeListDocument = gql`
    query NetPayableTradeList($where: trade_bool_exp, $orderBy: [trade_order_by!], $limit: Int, $offset: Int) {
  trade(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    created_at
    remark
    seller_tds
    taxes(where: {role: {_eq: "seller"}}) {
      id
      amount
      percentage
      tax_name
      role
    }
    seller_bifurcation {
      advance_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
      paid_amount {
        op
        val
      }
      seller_credit_note_amount {
        op
        val
      }
      seller_debit_note_amount {
        op
        val
      }
      seller_expense_amount {
        op
        val
      }
      seller_expense_tax_amount {
        op
        val
      }
      seller_tax_amount {
        op
        val
      }
      supplier_charge {
        op
        val
      }
      seller_tds {
        op
        val
      }
      total
    }
    creditNote: issuance_notes(
      where: {is_verified: {_eq: true}, user_role: {_eq: "seller"}, type: {_eq: "CREDIT"}}
    ) {
      id
      amount
    }
    debitNote: issuance_notes(
      where: {is_verified: {_eq: true}, user_role: {_eq: "seller"}, type: {_eq: "DEBIT"}}
    ) {
      id
      amount
    }
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    id
    kind
    seller {
      id
      user {
        id
        full_name
        external_reference_id2
        payment_details {
          id
          account_holder_name
          account_number
          content_type {
            id
            model
          }
          ifsc_code
          method {
            id
            name
          }
          bank_name
        }
      }
    }
    transactions_aggregate(
      where: {_or: [{ref: {_is_null: true}}, {ref: {_eq: "receipt_settlement"}}]}
    ) {
      aggregate {
        sum {
          amount
          __typename
        }
        __typename
      }
      __typename
    }
    transactions(
      where: {_or: [{ref: {_is_null: true}}, {ref: {_eq: "receipt_settlement"}}]}
    ) {
      id
      date
      remark
      parent_transaction_id
      trade {
        id
        receipt_id
      }
      __typename
    }
    seller_payable
    advance_payments_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
  }
  transaction_aggregate(
    where: {_or: [{ref: {_is_null: true}}, {ref: {_eq: "receipt_settlement"}}]}
  ) {
    aggregate {
      sum {
        amount
      }
    }
  }
  transaction(
    where: {_or: [{ref: {_is_null: true}}, {ref: {_eq: "receipt_settlement"}}]}
  ) {
    id
    remark
  }
  trade_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useNetPayableTradeListQuery(options?: Omit<Urql.UseQueryArgs<NetPayableTradeListQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableTradeListQuery, NetPayableTradeListQueryVariables>({ query: NetPayableTradeListDocument, ...options });
};
export const NetPayableTradeSelectorDocument = gql`
    query NetPayableTradeSelector($where: trade_bool_exp, $orderBy: [trade_order_by!], $limit: Int, $offset: Int) {
  trade(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    id
    created_at
    seller_settlement_status
    seller_bifurcation {
      total
      advance_amount {
        op
        val
      }
      paid_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
      supplier_charge {
        op
        val
      }
      seller_expense_amount {
        op
        val
      }
      seller_tds {
        op
        val
      }
      seller_expense_tax_amount {
        op
        val
      }
      seller_tax_amount {
        op
        val
      }
    }
    has_advance_release_pending
  }
  trade_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useNetPayableTradeSelectorQuery(options?: Omit<Urql.UseQueryArgs<NetPayableTradeSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableTradeSelectorQuery, NetPayableTradeSelectorQueryVariables>({ query: NetPayableTradeSelectorDocument, ...options });
};
export const NetPayableReceiptSelectorDocument = gql`
    query NetPayableReceiptSelector($where: receipt_bool_exp, $orderBy: [receipt_order_by!], $limit: Int, $offset: Int) {
  receipt(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    id
    created_at
    seller_settlement_status
    seller_bifurcation {
      total
      paid_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
      supplier_charge {
        op
        val
      }
      seller_expense_amount {
        op
        val
      }
      seller_tds {
        op
        val
      }
      seller_expense_tax_amount {
        op
        val
      }
      seller_tax_amount {
        op
        val
      }
    }
  }
  receipt_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useNetPayableReceiptSelectorQuery(options?: Omit<Urql.UseQueryArgs<NetPayableReceiptSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableReceiptSelectorQuery, NetPayableReceiptSelectorQueryVariables>({ query: NetPayableReceiptSelectorDocument, ...options });
};
export const NetPayableTradeDetailDocument = gql`
    query NetPayableTradeDetail($id: bigint!) {
  trade_by_pk(id: $id) {
    created_at
    remark
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    seller_bifurcation {
      advance_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
      paid_amount {
        op
        val
      }
      seller_credit_note_amount {
        op
        val
      }
      seller_debit_note_amount {
        op
        val
      }
      seller_expense_amount {
        op
        val
      }
      seller_expense_tax_amount {
        op
        val
      }
      seller_tax_amount {
        op
        val
      }
      supplier_charge {
        op
        val
      }
      seller_tds {
        op
        val
      }
      total
    }
    id
    kind
    creditNote: issuance_notes(
      where: {is_verified: {_eq: true}, user_role: {_eq: "seller"}, type: {_eq: "CREDIT"}}
    ) {
      id
      amount
      created_at
      kind
      remarks
      type
      input_value
    }
    debitNote: issuance_notes(
      where: {is_verified: {_eq: true}, user_role: {_eq: "seller"}, type: {_eq: "DEBIT"}}
    ) {
      id
      amount
      created_at
      kind
      remarks
      type
      input_value
    }
    pending_issuance_note_bool: issuance_notes(
      where: {is_verified: {_is_null: true}}
    ) {
      id
      is_verified
    }
    seller {
      id
      user {
        id
        full_name
        external_reference_id2
        my_businesses(limit: 1) {
          id
          payment_details {
            id
            account_holder_name
            account_number
            content_type {
              id
              model
            }
            ifsc_code
            method {
              id
              name
            }
            bank_name
          }
        }
        payment_details {
          id
          account_holder_name
          account_number
          content_type {
            id
            model
          }
          ifsc_code
          method {
            id
            name
          }
          bank_name
        }
      }
    }
    transactions(
      order_by: {date: desc}
      where: {_or: [{ref: {_is_null: true}}, {ref: {_eq: "receipt_settlement"}}]}
    ) {
      id
      remark
      attachments {
        id
        media {
          id
          url
        }
      }
      bank {
        id
        payment_detail {
          id
          account_number
          bank_name
          account_holder_name
        }
      }
      created_at
      trade {
        id
        kind
      }
      receipt {
        id
        kind
      }
      advance_payment {
        id
        amount
        parameter {
          id
          name
        }
      }
      date
      mode {
        id
        codename
        name
      }
      transaction_id
      account_no
      amount
    }
    seller_payable
    advance_payments_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
  }
}
    `;

export function useNetPayableTradeDetailQuery(options: Omit<Urql.UseQueryArgs<NetPayableTradeDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableTradeDetailQuery, NetPayableTradeDetailQueryVariables>({ query: NetPayableTradeDetailDocument, ...options });
};
export const NetPayableTradeOverduesDocument = gql`
    query NetPayableTradeOverdues($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    summary {
      overdue_days
      overdue_amount
    }
  }
}
    `;

export function useNetPayableTradeOverduesQuery(options: Omit<Urql.UseQueryArgs<NetPayableTradeOverduesQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableTradeOverduesQuery, NetPayableTradeOverduesQueryVariables>({ query: NetPayableTradeOverduesDocument, ...options });
};
export const NetPayableTradeAdvanceSummaryDocument = gql`
    query NetPayableTradeAdvanceSummary($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    advance_summary {
      advance_used_in_current_trade
      advance_used_in_other_trades
      released_advance
      remaining_advance
      requested_advance
      seller_receivable_amount
    }
  }
}
    `;

export function useNetPayableTradeAdvanceSummaryQuery(options: Omit<Urql.UseQueryArgs<NetPayableTradeAdvanceSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableTradeAdvanceSummaryQuery, NetPayableTradeAdvanceSummaryQueryVariables>({ query: NetPayableTradeAdvanceSummaryDocument, ...options });
};
export const NetPayableReceiptAdvanceSummaryDocument = gql`
    query NetPayableReceiptAdvanceSummary($id: bigint!) {
  receipt_by_pk(id: $id) {
    id
    advance_summary {
      advance_used_in_current_trade
      advance_used_in_other_trades
      released_advance
      remaining_advance
      requested_advance
      seller_receivable_amount
    }
  }
}
    `;

export function useNetPayableReceiptAdvanceSummaryQuery(options: Omit<Urql.UseQueryArgs<NetPayableReceiptAdvanceSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableReceiptAdvanceSummaryQuery, NetPayableReceiptAdvanceSummaryQueryVariables>({ query: NetPayableReceiptAdvanceSummaryDocument, ...options });
};
export const NetPayableReceiptListDocument = gql`
    query NetPayableReceiptList($where: receipt_bool_exp, $orderBy: [receipt_order_by!], $limit: Int, $offset: Int) {
  receipt(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    created_at
    remark
    seller_bifurcation {
      advance_amount {
        op
        val
      }
      deducted_amount {
        op
        val
      }
      paid_amount {
        op
        val
      }
      seller_credit_note_amount {
        op
        val
      }
      seller_debit_note_amount {
        op
        val
      }
      seller_expense_amount {
        op
        val
      }
      seller_expense_tax_amount {
        op
        val
      }
      seller_tax_amount {
        op
        val
      }
      supplier_charge {
        op
        val
      }
      seller_tds {
        op
        val
      }
      total
    }
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    id
    kind
    seller {
      id
      user {
        id
        full_name
        external_reference_id2
        payment_details {
          id
          account_holder_name
          account_number
          content_type {
            id
            model
          }
          ifsc_code
          method {
            id
            name
          }
          bank_name
        }
      }
    }
    transactions {
      id
      date
      remark
      __typename
    }
    seller_payable
    advance_payments_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
  }
  receipt_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useNetPayableReceiptListQuery(options?: Omit<Urql.UseQueryArgs<NetPayableReceiptListQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableReceiptListQuery, NetPayableReceiptListQueryVariables>({ query: NetPayableReceiptListDocument, ...options });
};
export const NetPayableReceiptDetailDocument = gql`
    query NetPayableReceiptDetail($id: bigint!) {
  receipt_by_pk(id: $id) {
    created_at
    remark
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    id
    kind
    seller {
      id
      user {
        id
        full_name
        external_reference_id2
        my_businesses(limit: 1) {
          id
          payment_details {
            id
            account_holder_name
            account_number
            content_type {
              id
              model
            }
            ifsc_code
            method {
              id
              name
            }
            bank_name
          }
        }
        payment_details {
          id
          account_holder_name
          account_number
          content_type {
            id
            model
          }
          ifsc_code
          method {
            id
            name
          }
          bank_name
        }
      }
    }
    transactions(order_by: {date: desc}) {
      id
      remark
      attachments {
        id
        media {
          id
          url
        }
      }
      bank {
        id
        payment_detail {
          id
          account_number
          bank_name
          account_holder_name
        }
      }
      created_at
      trade {
        id
        kind
      }
      receipt {
        id
        kind
      }
      advance_payment {
        id
        amount
        parameter {
          id
          name
        }
      }
      date
      mode {
        id
        codename
        name
      }
      transaction_id
      account_no
      amount
    }
    seller_payable
    advance_payments_aggregate {
      aggregate {
        sum {
          amount
        }
      }
    }
  }
  transaction_aggregate {
    aggregate {
      sum {
        amount
      }
    }
  }
}
    `;

export function useNetPayableReceiptDetailQuery(options: Omit<Urql.UseQueryArgs<NetPayableReceiptDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<NetPayableReceiptDetailQuery, NetPayableReceiptDetailQueryVariables>({ query: NetPayableReceiptDetailDocument, ...options });
};
export const UpdateTradeNetPaymentDocument = gql`
    mutation UpdateTradeNetPayment($id: bigint!, $object: trade_set_input) {
  update_trade_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    remark
  }
}
    `;

export function useUpdateTradeNetPaymentMutation() {
  return Urql.useMutation<UpdateTradeNetPaymentMutation, UpdateTradeNetPaymentMutationVariables>(UpdateTradeNetPaymentDocument);
};
export const UpdateReceiptNetPaymentDocument = gql`
    mutation UpdateReceiptNetPayment($id: bigint!, $object: receipt_set_input) {
  update_receipt_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    remark
  }
}
    `;

export function useUpdateReceiptNetPaymentMutation() {
  return Urql.useMutation<UpdateReceiptNetPaymentMutation, UpdateReceiptNetPaymentMutationVariables>(UpdateReceiptNetPaymentDocument);
};
export const TradeSellerAnalyticsDocument = gql`
    query TradeSellerAnalytics($createdFrom: Date, $departments: [String], $tradeKinds: [String], $createdTill: Date, $search: String, $sellerReferenceId: String, $createdById: String) {
  aggregate_trade_seller_summary(
    created_from: $createdFrom
    created_till: $createdTill
    search: $search
    seller_reference_id: $sellerReferenceId
    department_reference_id_list: $departments
    trade_kind_list: $tradeKinds
    created_by_id: $createdById
  ) {
    advance_remaining_amount
    deducted_amount {
      op
      val
    }
    paid_amount {
      op
      val
    }
    advance_amount {
      op
      val
    }
    seller_credit_note_amount {
      op
      val
    }
    seller_debit_note_amount {
      op
      val
    }
    seller_expense_amount {
      op
      val
    }
    seller_expense_tax_amount {
      op
      val
    }
    seller_tax_amount {
      op
      val
    }
    supplier_charge {
      op
      val
    }
    total
  }
}
    `;

export function useTradeSellerAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<TradeSellerAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeSellerAnalyticsQuery, TradeSellerAnalyticsQueryVariables>({ query: TradeSellerAnalyticsDocument, ...options });
};
export const ReceiptSellerAnalyticsDocument = gql`
    query ReceiptSellerAnalytics($createdFrom: Date, $departments: [String], $tradeKinds: [String], $createdTill: Date, $search: String, $sellerReferenceId: String, $createdById: String) {
  aggregate_receipt_seller_summary(
    created_from: $createdFrom
    created_till: $createdTill
    search: $search
    seller_reference_id: $sellerReferenceId
    department_reference_id_list: $departments
    trade_kind_list: $tradeKinds
    created_by_id: $createdById
  ) {
    deducted_amount {
      op
      val
    }
    paid_amount {
      op
      val
    }
    advance_amount {
      op
      val
    }
    seller_credit_note_amount {
      op
      val
    }
    seller_debit_note_amount {
      op
      val
    }
    seller_expense_amount {
      op
      val
    }
    seller_expense_tax_amount {
      op
      val
    }
    seller_tax_amount {
      op
      val
    }
    supplier_charge {
      op
      val
    }
    total
  }
}
    `;

export function useReceiptSellerAnalyticsQuery(options?: Omit<Urql.UseQueryArgs<ReceiptSellerAnalyticsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReceiptSellerAnalyticsQuery, ReceiptSellerAnalyticsQueryVariables>({ query: ReceiptSellerAnalyticsDocument, ...options });
};
export const AllPaymentMethodsDocument = gql`
    query AllPaymentMethods {
  Transaction_mode {
    id
    name
  }
}
    `;

export function useAllPaymentMethodsQuery(options?: Omit<Urql.UseQueryArgs<AllPaymentMethodsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllPaymentMethodsQuery, AllPaymentMethodsQueryVariables>({ query: AllPaymentMethodsDocument, ...options });
};
export const PlantSettlementDocument = gql`
    query PlantSettlement($where: department_settlements_bool_exp, $orderBy: [department_settlements_order_by!], $limit: Int, $offset: Int) {
  department_settlements(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    created_at
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    department {
      id
      name
      reference_id
      department {
        id
        payment_details {
          id
          payment_detail {
            id
            account_holder_name
            account_number
            content_type {
              id
              model
            }
            ifsc_code
            method {
              id
              name
            }
            bank_name
          }
        }
      }
    }
    user {
      id
      name
      user {
        id
        full_name
        reference_id
        external_reference_id2
      }
    }
    transactions {
      id
      bank_id
      remark
      attachments {
        id
        media {
          id
          url
        }
      }
      child_transactions_aggregate {
        aggregate {
          sum {
            amount
          }
        }
      }
      bank {
        payment_detail {
          id
          account_holder_name
          account_number
          content_type {
            id
            model
          }
          ifsc_code
          method {
            id
            name
          }
          bank_name
        }
      }
      mode {
        id
        name
      }
      transaction_id
      amount
      created_by_id
    }
  }
  department_settlements_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function usePlantSettlementQuery(options?: Omit<Urql.UseQueryArgs<PlantSettlementQueryVariables>, 'query'>) {
  return Urql.useQuery<PlantSettlementQuery, PlantSettlementQueryVariables>({ query: PlantSettlementDocument, ...options });
};
export const InsertPlantSettlementDocument = gql`
    mutation InsertPlantSettlement($object: department_settlements_insert_input!) {
  insert_department_settlements_one(object: $object) {
    id
  }
}
    `;

export function useInsertPlantSettlementMutation() {
  return Urql.useMutation<InsertPlantSettlementMutation, InsertPlantSettlementMutationVariables>(InsertPlantSettlementDocument);
};
export const DepartmentPaymentListDocument = gql`
    query DepartmentPaymentList($where: department_bool_exp) {
  department(where: $where) {
    id
    name
    payment_details(order_by: {priority: asc}) {
      id
      payment_detail {
        id
        account_holder_name
        account_number
        content_type {
          id
          model
        }
        ifsc_code
        method {
          id
          name
        }
        bank_name
      }
    }
  }
}
    `;

export function useDepartmentPaymentListQuery(options?: Omit<Urql.UseQueryArgs<DepartmentPaymentListQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentPaymentListQuery, DepartmentPaymentListQueryVariables>({ query: DepartmentPaymentListDocument, ...options });
};
export const SetPlantTransactionInactiveDocument = gql`
    mutation SetPlantTransactionInactive($where: department_settlements_bool_exp!) {
  update_department_settlements(_set: {is_active: false}, where: $where) {
    affected_rows
    returning {
      id
    }
  }
}
    `;

export function useSetPlantTransactionInactiveMutation() {
  return Urql.useMutation<SetPlantTransactionInactiveMutation, SetPlantTransactionInactiveMutationVariables>(SetPlantTransactionInactiveDocument);
};
export const AddUpdateProductionPlanningTradeDocument = gql`
    mutation AddUpdateProductionPlanningTrade($input: ProductionTradeInput) {
  add_update_production_planning_trade(input: $input) {
    production_trade {
      id
    }
  }
}
    `;

export function useAddUpdateProductionPlanningTradeMutation() {
  return Urql.useMutation<AddUpdateProductionPlanningTradeMutation, AddUpdateProductionPlanningTradeMutationVariables>(AddUpdateProductionPlanningTradeDocument);
};
export const UpdateProductionStatusDocument = gql`
    mutation UpdateProductionStatus($trade_id: ID!, $status: String!) {
  update_production_trade_status(trade_id: $trade_id, status: $status) {
    production_trade {
      id
      status
    }
  }
}
    `;

export function useUpdateProductionStatusMutation() {
  return Urql.useMutation<UpdateProductionStatusMutation, UpdateProductionStatusMutationVariables>(UpdateProductionStatusDocument);
};
export const ProductionTradeDetailDocument = gql`
    query ProductionTradeDetail($id: Int!) {
  production_trade_by_pk(id: $id) {
    id
    kind
    start_datetime
    end_datetime
    status
    officer {
      id
      user {
        ...BaseUserFrag
      }
    }
    mode
    order_trade_refs {
      id
      trade_id
    }
    buyer {
      id
      user {
        ...BaseUserFrag
      }
    }
    buyer_tnc
    created_at
    depot {
      id
      name
    }
    expenses {
      ...ExpenseFrag
    }
    facilitator {
      id
      user {
        ...BaseUserFrag
      }
    }
    is_verified
    input: items(where: {kind: {_eq: "input"}}) {
      id
      commodity {
        id
        commodity {
          id
          name
        }
      }
      variety {
        id
        commodity_variety {
          id
          name
        }
      }
      attachments {
        id
        media {
          id
          url
        }
      }
      available_quantity
      cost_per_unit
      final_quantity
      required_quantity
      total_cost
      grade {
        id
        variety_grade {
          id
          name
        }
      }
      storage_picked {
        id
        trade_id
        trade {
          id
          deducted_quantity_remaining
        }
        used_quantity
        weight_loss_quantity
        wastage_loss_quantity
      }
      kind
    }
    output: items(where: {kind: {_eq: "output"}}) {
      id
      commodity {
        id
        commodity {
          id
          name
        }
      }
      variety {
        id
        commodity_variety {
          id
          name
        }
      }
      attachments {
        id
        media {
          id
          url
        }
      }
      available_quantity
      cost_per_unit
      final_quantity
      required_quantity
      total_cost
      grade {
        id
        variety_grade {
          id
          name
        }
      }
      kind
    }
    packagings: items(where: {kind: {_eq: "packaging"}}) {
      id
      commodity {
        id
        commodity {
          id
          name
        }
      }
      variety {
        id
        commodity_variety {
          id
          name
        }
      }
      attachments {
        id
        media {
          id
          url
        }
      }
      available_quantity
      cost_per_unit
      final_quantity
      required_quantity
      total_cost
      grade {
        id
        variety_grade {
          id
          name
        }
      }
      storage_picked {
        id
        trade_id
        trade {
          id
          deducted_quantity_remaining
        }
        used_quantity
        weight_loss_quantity
        wastage_loss_quantity
      }
      kind
    }
  }
}
    ${BaseUserFragFragmentDoc}
${ExpenseFragFragmentDoc}`;

export function useProductionTradeDetailQuery(options: Omit<Urql.UseQueryArgs<ProductionTradeDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionTradeDetailQuery, ProductionTradeDetailQueryVariables>({ query: ProductionTradeDetailDocument, ...options });
};
export const ProductionTradesDocument = gql`
    query ProductionTrades($where: production_trade_bool_exp, $limit: Int, $offset: Int, $orderBy: [production_trade_order_by!]) {
  production_trade(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    parent_trade_id
    is_verified
    status
    ref_storage_patti: items(where: {kind: {_eq: "input"}}) {
      id
      storage_picked {
        id
        trade_id
      }
    }
    associated_trades {
      id
    }
    order_trade_refs {
      id
      trade_id
    }
    buyer {
      id
      user {
        id
        full_name
        external_reference_id
      }
    }
    items(where: {kind: {_eq: "output"}}) {
      id
      commodity {
        id
        name
      }
      variety {
        id
        name
      }
      grade {
        id
        name
      }
      required_quantity
      cost_per_unit
      total_cost
    }
    buyer_tnc
    created_at
    created_by {
      id
      full_name
      last_login
    }
    start_datetime
    end_datetime
    officer {
      id
      user {
        id
        full_name
      }
    }
    depot {
      id
      name
    }
    expenses {
      id
      amount
    }
  }
  production_trade_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useProductionTradesQuery(options?: Omit<Urql.UseQueryArgs<ProductionTradesQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionTradesQuery, ProductionTradesQueryVariables>({ query: ProductionTradesDocument, ...options });
};
export const AddUpdateProductionFinalTradeDocument = gql`
    mutation AddUpdateProductionFinalTrade($input: ProductionFinalTradeInput) {
  add_update_production_final_trade(input: $input) {
    production_trade {
      id
    }
  }
}
    `;

export function useAddUpdateProductionFinalTradeMutation() {
  return Urql.useMutation<AddUpdateProductionFinalTradeMutation, AddUpdateProductionFinalTradeMutationVariables>(AddUpdateProductionFinalTradeDocument);
};
export const ShiftProductionToStorageDocument = gql`
    mutation ShiftProductionToStorage($tradeId: ID!) {
  shift_production_trade_to_storage(trade_id: $tradeId) {
    production_trade {
      id
      associated_trades {
        id
      }
    }
  }
}
    `;

export function useShiftProductionToStorageMutation() {
  return Urql.useMutation<ShiftProductionToStorageMutation, ShiftProductionToStorageMutationVariables>(ShiftProductionToStorageDocument);
};
export const ResultOneDocument = gql`
    query ResultOne($id: bigint!) {
  result_by_pk(id: $id) {
    ...ResultBaseFrag
  }
}
    ${ResultBaseFragFragmentDoc}`;

export function useResultOneQuery(options: Omit<Urql.UseQueryArgs<ResultOneQueryVariables>, 'query'>) {
  return Urql.useQuery<ResultOneQuery, ResultOneQueryVariables>({ query: ResultOneDocument, ...options });
};
export const DeleteSampleOneDocument = gql`
    mutation DeleteSampleOne($id: bigint!) {
  delete_sample_observation_attachments(
    where: {sample_observation: {sample_id: {_eq: $id}}}
  ) {
    returning {
      id
    }
  }
  delete_sample_observation(where: {sample_id: {_eq: $id}}) {
    returning {
      id
    }
  }
  delete_result_evaluation(where: {result: {sample_id: {_eq: $id}}}) {
    returning {
      id
    }
  }
  delete_result(where: {sample_id: {_eq: $id}}) {
    returning {
      id
    }
  }
  delete_sample_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteSampleOneMutation() {
  return Urql.useMutation<DeleteSampleOneMutation, DeleteSampleOneMutationVariables>(DeleteSampleOneDocument);
};
export const SubmitSampleObservationsDocument = gql`
    mutation SubmitSampleObservations($input: SubmitObservationsInput!) {
  submit_observations(input: $input) {
    sample {
      id
      results {
        id
        name
        codename
      }
    }
  }
}
    `;

export function useSubmitSampleObservationsMutation() {
  return Urql.useMutation<SubmitSampleObservationsMutation, SubmitSampleObservationsMutationVariables>(SubmitSampleObservationsDocument);
};
export const DeleteSampleObservationDocument = gql`
    mutation DeleteSampleObservation($id: bigint!) {
  delete_sample_observation_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteSampleObservationMutation() {
  return Urql.useMutation<DeleteSampleObservationMutation, DeleteSampleObservationMutationVariables>(DeleteSampleObservationDocument);
};
export const SoyaBeanTemplatesDocument = gql`
    query SoyaBeanTemplates($reference_id: String!, $entity_type: String) {
  template(
    where: {is_active: {_eq: true}, quality_stage: {codename: {_eq: "b4bda282-4e1d-4753-b204-ad0f48f658e8"}}, test_for: {reference_id: {_eq: $reference_id}, entity_type: {_eq: $entity_type}}}
  ) {
    ...TemplateBaseFrag
  }
}
    ${TemplateBaseFragFragmentDoc}`;

export function useSoyaBeanTemplatesQuery(options: Omit<Urql.UseQueryArgs<SoyaBeanTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<SoyaBeanTemplatesQuery, SoyaBeanTemplatesQueryVariables>({ query: SoyaBeanTemplatesDocument, ...options });
};
export const ReceiptDetailDocument = gql`
    query ReceiptDetail($id: bigint!) {
  receipt_by_pk(id: $id) {
    ...ReceiptDetailFrag
  }
  trade_expense_tax(
    where: {trade: {receipt_id: {_eq: $id}}, role: {_eq: "seller"}}
  ) {
    id
    amount
    role
    percentage
    tax_name
  }
}
    ${ReceiptDetailFragFragmentDoc}`;

export function useReceiptDetailQuery(options: Omit<Urql.UseQueryArgs<ReceiptDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ReceiptDetailQuery, ReceiptDetailQueryVariables>({ query: ReceiptDetailDocument, ...options });
};
export const AllReceiptsDocument = gql`
    query AllReceipts($where: receipt_bool_exp, $limit: Int, $offset: Int, $order_by: [receipt_order_by!]) {
  receipt(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    twilio_message {
      id
      status
    }
    advance_payments {
      id
      is_verified
      status
    }
    tracking_code
    created_at
    total_amount
    total_quantity
    kind
    is_multiple_commodity
    child_receipts_aggregate {
      aggregate {
        count
      }
    }
    seller {
      id
      user {
        id
        full_name
        is_blocked
        number
        external_reference_id
        current_address {
          id
          village
        }
      }
    }
    trades {
      id
      deducted_quantity_remaining
      trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
        id
        rate
        commodity {
          id
          name
        }
        commodity_variety {
          id
          name
        }
        variety_grade {
          id
          name
        }
        quantity
        quantity_unit {
          id
          name
        }
        rate_unit {
          id
          name
        }
      }
      buyer {
        id
        user {
          id
          is_blocked
          full_name
          photo {
            id
            url
          }
          number
          external_reference_id
          current_address {
            id
            village
          }
        }
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    total_amount
    updated_at
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    hishob_patti_count: trades_aggregate(where: {kind: {_eq: "final"}}) {
      aggregate {
        count
      }
    }
  }
  receipt_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllReceiptsQuery(options?: Omit<Urql.UseQueryArgs<AllReceiptsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllReceiptsQuery, AllReceiptsQueryVariables>({ query: AllReceiptsDocument, ...options });
};
export const AddUpdateReceiptDocument = gql`
    mutation AddUpdateReceipt($input: ReceiptInput) {
  add_update_receipt(input: $input) {
    receipt {
      id
    }
  }
}
    `;

export function useAddUpdateReceiptMutation() {
  return Urql.useMutation<AddUpdateReceiptMutation, AddUpdateReceiptMutationVariables>(AddUpdateReceiptDocument);
};
export const ReceiptFinalTrades2Document = gql`
    mutation ReceiptFinalTrades2($ids: [ID]) {
  receipt_final_trades(receipt_ids: $ids) {
    affected_rows
  }
}
    `;

export function useReceiptFinalTrades2Mutation() {
  return Urql.useMutation<ReceiptFinalTrades2Mutation, ReceiptFinalTrades2MutationVariables>(ReceiptFinalTrades2Document);
};
export const ReturnTransactionsDocument = gql`
    mutation ReturnTransactions($transactionIds: [ID]!) {
  cancel_transaction(transaction_ids: $transactionIds) {
    success
  }
}
    `;

export function useReturnTransactionsMutation() {
  return Urql.useMutation<ReturnTransactionsMutation, ReturnTransactionsMutationVariables>(ReturnTransactionsDocument);
};
export const AddUpdateSharedEntityDocument = gql`
    mutation AddUpdateSharedEntity($reference_id: String, $group_name: String, $name: String) {
  insert_setu_trade_shared_entity_one(
    object: {reference_id: $reference_id, group_name: $group_name, name: $name}
    on_conflict: {constraint: shared_entity_group_name_reference_id_4db210e6_uniq, update_columns: [name]}
  ) {
    id
    name
    reference_id
    group_name
    seller_receivable_amount_current_year
  }
}
    `;

export function useAddUpdateSharedEntityMutation() {
  return Urql.useMutation<AddUpdateSharedEntityMutation, AddUpdateSharedEntityMutationVariables>(AddUpdateSharedEntityDocument);
};
export const SellerReceivableAmountDocument = gql`
    query SellerReceivableAmount($id: bigint!) {
  setu_trade_shared_entity_by_pk(id: $id) {
    id
    seller_receivable_amount_current_year
  }
}
    `;

export function useSellerReceivableAmountQuery(options: Omit<Urql.UseQueryArgs<SellerReceivableAmountQueryVariables>, 'query'>) {
  return Urql.useQuery<SellerReceivableAmountQuery, SellerReceivableAmountQueryVariables>({ query: SellerReceivableAmountDocument, ...options });
};
export const AllCommoditiesDocument = gql`
    query AllCommodities($query: String) {
  commodity(
    where: {name: {_ilike: $query}}
    order_by: {name: asc_nulls_last}
    limit: 10
  ) {
    ...KiteCommodityFrag
  }
}
    ${KiteCommodityFragFragmentDoc}`;

export function useAllCommoditiesQuery(options?: Omit<Urql.UseQueryArgs<AllCommoditiesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllCommoditiesQuery, AllCommoditiesQueryVariables>({ query: AllCommoditiesDocument, ...options });
};
export const AllPackagingCommoditiesDocument = gql`
    query AllPackagingCommodities($query: String) {
  commodity(
    where: {name: {_ilike: $query, _in: ["Primary Packaging Material", "Secondary Packaging Material"]}}
    order_by: {name: asc_nulls_last}
    limit: 10
  ) {
    ...KiteCommodityFrag
  }
}
    ${KiteCommodityFragFragmentDoc}`;

export function useAllPackagingCommoditiesQuery(options?: Omit<Urql.UseQueryArgs<AllPackagingCommoditiesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllPackagingCommoditiesQuery, AllPackagingCommoditiesQueryVariables>({ query: AllPackagingCommoditiesDocument, ...options });
};
export const AllVarietiesDocument = gql`
    query AllVarieties($commodity_id: Int) {
  commodity_variety(
    where: {commodity_id: {_eq: $commodity_id}}
    order_by: {name: asc_nulls_last}
  ) {
    ...KiteCommodityVarietyFrag
  }
}
    ${KiteCommodityVarietyFragFragmentDoc}`;

export function useAllVarietiesQuery(options?: Omit<Urql.UseQueryArgs<AllVarietiesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllVarietiesQuery, AllVarietiesQueryVariables>({ query: AllVarietiesDocument, ...options });
};
export const AllPlotCropsDocument = gql`
    query AllPlotCrops($farmer: Int) {
  plot_crop(where: {farmer_id: {_eq: $farmer}}, order_by: {name: asc_nulls_last}) {
    id
    tag
    name
    codename
    external_reference_id
  }
}
    `;

export function useAllPlotCropsQuery(options?: Omit<Urql.UseQueryArgs<AllPlotCropsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllPlotCropsQuery, AllPlotCropsQueryVariables>({ query: AllPlotCropsDocument, ...options });
};
export const AllVarietyGradesDocument = gql`
    query AllVarietyGrades($variety: Int) {
  variety_grade(
    where: {variety_id: {_eq: $variety}}
    order_by: {name: asc_nulls_last}
  ) {
    id
    name
    codename
  }
}
    `;

export function useAllVarietyGradesQuery(options?: Omit<Urql.UseQueryArgs<AllVarietyGradesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllVarietyGradesQuery, AllVarietyGradesQueryVariables>({ query: AllVarietyGradesDocument, ...options });
};
export const GetVarietyGradesSharedEntityDocument = gql`
    query getVarietyGradesSharedEntity($where: setu_trade_shared_entity_bool_exp) {
  setu_trade_shared_entity(where: $where) {
    id
    variety_grade {
      id
    }
  }
}
    `;

export function useGetVarietyGradesSharedEntityQuery(options?: Omit<Urql.UseQueryArgs<GetVarietyGradesSharedEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVarietyGradesSharedEntityQuery, GetVarietyGradesSharedEntityQueryVariables>({ query: GetVarietyGradesSharedEntityDocument, ...options });
};
export const VarietyGradeDetailDocument = gql`
    query VarietyGradeDetail($id: Int!) {
  variety_grade_by_pk(id: $id) {
    id
    name
    codename
    variety {
      id
      name
      codename
      commodity {
        id
        name
        codename
      }
    }
  }
}
    `;

export function useVarietyGradeDetailQuery(options: Omit<Urql.UseQueryArgs<VarietyGradeDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<VarietyGradeDetailQuery, VarietyGradeDetailQueryVariables>({ query: VarietyGradeDetailDocument, ...options });
};
export const AllSiUnitsDocument = gql`
    query AllSIUnits($type: [String!]) {
  si_unit(where: {measure_of: {name: {_in: $type}}}) {
    id
    name
    codename
    base_conversion
  }
}
    `;

export function useAllSiUnitsQuery(options?: Omit<Urql.UseQueryArgs<AllSiUnitsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllSiUnitsQuery, AllSiUnitsQueryVariables>({ query: AllSiUnitsDocument, ...options });
};
export const UnitSiUnitsDocument = gql`
    query UnitSIUnits {
  si_unit(where: {name: {_ilike: "Unit"}}) {
    id
    name
    codename
    base_conversion
  }
}
    `;

export function useUnitSiUnitsQuery(options?: Omit<Urql.UseQueryArgs<UnitSiUnitsQueryVariables>, 'query'>) {
  return Urql.useQuery<UnitSiUnitsQuery, UnitSiUnitsQueryVariables>({ query: UnitSiUnitsDocument, ...options });
};
export const GetSharedEntityDocument = gql`
    query getSharedEntity($codename: String, $group: String) {
  setu_trade_shared_entity(
    where: {reference_id: {_eq: $codename}, group_name: {_eq: $group}}
  ) {
    id
    name
    department_config {
      id
      use_credit
      seller_tds_percentage
      seller_tds_amount
    }
  }
}
    `;

export function useGetSharedEntityQuery(options?: Omit<Urql.UseQueryArgs<GetSharedEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSharedEntityQuery, GetSharedEntityQueryVariables>({ query: GetSharedEntityDocument, ...options });
};
export const ExpenseParametersDocument = gql`
    query ExpenseParameters($codename: String) {
  expense_parameter {
    id
    name
    codename
  }
}
    `;

export function useExpenseParametersQuery(options?: Omit<Urql.UseQueryArgs<ExpenseParametersQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseParametersQuery, ExpenseParametersQueryVariables>({ query: ExpenseParametersDocument, ...options });
};
export const PackingMaterialListDocument = gql`
    query PackingMaterialList {
  packaging {
    id
    name
    codename
    material_code
  }
}
    `;

export function usePackingMaterialListQuery(options?: Omit<Urql.UseQueryArgs<PackingMaterialListQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingMaterialListQuery, PackingMaterialListQueryVariables>({ query: PackingMaterialListDocument, ...options });
};
export const OrganisationPricingDocument = gql`
    query OrganisationPricing {
  organisation_pricing {
    id
    supplier_rate
    tax_percentage
  }
}
    `;

export function useOrganisationPricingQuery(options?: Omit<Urql.UseQueryArgs<OrganisationPricingQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganisationPricingQuery, OrganisationPricingQueryVariables>({ query: OrganisationPricingDocument, ...options });
};
export const StockStorageSummaryDocument = gql`
    query StockStorageSummary($filters: StorageQueryFilterInput, $from: Date, $till: Date) {
  storage_summary(filters: $filters, from_date: $from, till_date: $till) {
    total_stock_items
    low_stock_items
    out_of_stock
    expiring_soon
    expired_stock
  }
}
    `;

export function useStockStorageSummaryQuery(options?: Omit<Urql.UseQueryArgs<StockStorageSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<StockStorageSummaryQuery, StockStorageSummaryQueryVariables>({ query: StockStorageSummaryDocument, ...options });
};
export const StockManagementListDocument = gql`
    query StockManagementList($from: Date, $till: Date, $filter: StorageQueryFilterInput, $limit: Int, $offset: Int) {
  storage_dashboard(
    from_date: $from
    till_date: $till
    filters: $filter
    limit: $limit
    offset: $offset
  ) {
    commodity {
      id
      name
    }
    variety {
      id
      name
    }
    grade {
      id
      name
    }
    actual_stock_kg
    virtual_stock_kg
    minimum_selling_quantity_kg
    last_updated
    offers {
      id
      created_at
      quantity
      total_amount
    }
    demands {
      id
      created_at
      quantity
      total_amount
    }
    total_opening_stock_kg
    total_consumed_stock_kg
    total_closing_stock_kg
    pattis {
      id
      created_on
      patti_ref
      batch_number
      material
      storage_location
      ref_pattis
      opening_stock_kg
      consumed_stock_kg
      closing_stock_kg
      std_holding_days
      storage_status
      outward_actions
    }
  }
}
    `;

export function useStockManagementListQuery(options?: Omit<Urql.UseQueryArgs<StockManagementListQueryVariables>, 'query'>) {
  return Urql.useQuery<StockManagementListQuery, StockManagementListQueryVariables>({ query: StockManagementListDocument, ...options });
};
export const StockPattiListDocument = gql`
    query StockPattiList($from: Date, $till: Date, $filter: StorageQueryFilterInput, $limit: Int, $offset: Int) {
  storage_dashboard(
    from_date: $from
    till_date: $till
    filters: $filter
    limit: $limit
    offset: $offset
  ) {
    pattis {
      id
    }
  }
}
    `;

export function useStockPattiListQuery(options?: Omit<Urql.UseQueryArgs<StockPattiListQueryVariables>, 'query'>) {
  return Urql.useQuery<StockPattiListQuery, StockPattiListQueryVariables>({ query: StockPattiListDocument, ...options });
};
export const RemainingStockQuantityDocument = gql`
    query RemainingStockQuantity($where: trade_bool_exp) {
  trade_aggregate(where: $where) {
    aggregate {
      sum {
        deducted_quantity_remaining
      }
    }
    nodes {
      id
    }
  }
}
    `;

export function useRemainingStockQuantityQuery(options?: Omit<Urql.UseQueryArgs<RemainingStockQuantityQueryVariables>, 'query'>) {
  return Urql.useQuery<RemainingStockQuantityQuery, RemainingStockQuantityQueryVariables>({ query: RemainingStockQuantityDocument, ...options });
};
export const AllStorageLocationAlertsDocument = gql`
    query AllStorageLocationAlerts {
  all_storage_location_alerts {
    icon
    message
    storage_location {
      id
      name
      agreements {
        id
        expiry_alert_days
      }
    }
  }
}
    `;

export function useAllStorageLocationAlertsQuery(options?: Omit<Urql.UseQueryArgs<AllStorageLocationAlertsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllStorageLocationAlertsQuery, AllStorageLocationAlertsQueryVariables>({ query: AllStorageLocationAlertsDocument, ...options });
};
export const AllStorageKindsDocument = gql`
    query AllStorageKinds {
  storage_location_kind {
    id
    name
  }
}
    `;

export function useAllStorageKindsQuery(options?: Omit<Urql.UseQueryArgs<AllStorageKindsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllStorageKindsQuery, AllStorageKindsQueryVariables>({ query: AllStorageKindsDocument, ...options });
};
export const StorageLocationSelectorDocument = gql`
    query StorageLocationSelector($query: String) {
  storage_location(limit: 10, where: {name: {_ilike: $query}}) {
    id
    name
    storage_location_agreements(
      where: {is_active: {_eq: true}, is_verified: {_eq: true}}
      limit: 1
      order_by: {end_date: desc}
    ) {
      id
      end_date
    }
  }
}
    `;

export function useStorageLocationSelectorQuery(options?: Omit<Urql.UseQueryArgs<StorageLocationSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<StorageLocationSelectorQuery, StorageLocationSelectorQueryVariables>({ query: StorageLocationSelectorDocument, ...options });
};
export const StorageSubLocationSelectorDocument = gql`
    query StorageSubLocationSelector($where: storage_sub_location_bool_exp) {
  storage_sub_location(where: $where) {
    id
    name
  }
}
    `;

export function useStorageSubLocationSelectorQuery(options?: Omit<Urql.UseQueryArgs<StorageSubLocationSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<StorageSubLocationSelectorQuery, StorageSubLocationSelectorQueryVariables>({ query: StorageSubLocationSelectorDocument, ...options });
};
export const AddUpdateStorageLocationsDocument = gql`
    mutation AddUpdateStorageLocations($input: UpsertStorageLocationInput!) {
  add_update_storage_location(input: $input) {
    storage_location {
      id
      name
      codename
    }
  }
}
    `;

export function useAddUpdateStorageLocationsMutation() {
  return Urql.useMutation<AddUpdateStorageLocationsMutation, AddUpdateStorageLocationsMutationVariables>(AddUpdateStorageLocationsDocument);
};
export const AddUpdateAgreementTransactionsDocument = gql`
    mutation AddUpdateAgreementTransactions($input: AgreementTransactionInput!, $agreementId: ID!) {
  add_update_agreement_transaction(agreement_id: $agreementId, input: $input) {
    transaction_obj {
      id
      transaction_id
      transaction_date
      amount
    }
  }
}
    `;

export function useAddUpdateAgreementTransactionsMutation() {
  return Urql.useMutation<AddUpdateAgreementTransactionsMutation, AddUpdateAgreementTransactionsMutationVariables>(AddUpdateAgreementTransactionsDocument);
};
export const AllStorageLocationsDocument = gql`
    query AllStorageLocations($filters: AllStorageLocationsFilterInput, $search: String, $limit: Int, $offset: Int) {
  all_storage_locations(
    filters: $filters
    search: $search
    limit: $limit
    offset: $offset
  ) {
    approved_storage_locations
    pending_storage_locations
    valid_agreement_storage_locations
    expiring_soon_agreement_storage_locations
    expired_agreement_storage_locations
    total_storage_locations
    storage_locations {
      storage_location {
        id
        name
        codename
        address {
          id
          name
          village
          raw_address
          pincode
          location
        }
        pocs {
          id
          name
        }
        sub_locations {
          id
          name
          codename
          capacity
          kind {
            id
            name
          }
          capacity_unit {
            id
            name
          }
        }
      }
      agreement_status
      current_agreement {
        id
        is_active
        created_at
        is_verified
        start_date
        end_date
        lease_amount
        lease_tenure_kind
        created_by {
          id
          name
        }
      }
      alerts {
        icon
        title
        message
      }
      trade_used_quantity_metric_ton
      total_capacity_quantity_metric_ton
    }
  }
}
    `;

export function useAllStorageLocationsQuery(options?: Omit<Urql.UseQueryArgs<AllStorageLocationsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllStorageLocationsQuery, AllStorageLocationsQueryVariables>({ query: AllStorageLocationsDocument, ...options });
};
export const StorageLocationDetailDocument = gql`
    query StorageLocationDetail($id: bigint!) {
  storage_location_by_pk(id: $id) {
    id
    name
    codename
    capacity
    summary {
      next_payment_date
    }
    pocs {
      id
      user {
        id
        name
      }
    }
    capacity_unit {
      id
      name
    }
    trades_aggregate {
      aggregate {
        sum {
          deducted_quantity_kg
        }
      }
    }
    storage_sub_locations {
      id
      name
      codename
      capacity
      capacity_unit {
        id
        name
      }
      storage_location_kind {
        id
        name
      }
      trades_aggregate {
        aggregate {
          sum {
            deducted_quantity_kg
          }
        }
      }
    }
    address: setu_trade_address {
      id
      village
      taluka
      district
      state
      pincode
      location
      local_area
      country
      raw_address
    }
    pending_agreement: storage_location_agreements(
      where: {is_verified: {_is_null: true}}
      limit: 1
      order_by: {end_date: desc}
    ) {
      id
      name
      ownership_kind
      lease_amount
      lease_tenure_kind
      expiry_alert_days
      is_verified
      is_active
      start_date
      end_date
      tnc
      agreement_no
      description
      agreement_transactions {
        id
        amount
        transaction_id
        account_holder_name
        account_number
        bank_name
        ifsc_code
        mode_of_payment
        transaction_date
        attachments {
          id
          media {
            id
            url
            kind
          }
        }
      }
      attachments {
        id
        media {
          id
          url
        }
      }
    }
    current_agreement: storage_location_agreements(
      limit: 1
      order_by: {end_date: desc}
      where: {is_active: {_eq: true}, is_verified: {_eq: true}}
    ) {
      id
      name
      ownership_kind
      lease_amount
      lease_tenure_kind
      expiry_alert_days
      is_verified
      start_date
      is_active
      end_date
      tnc
      agreement_no
      description
      agreement_transactions {
        id
        amount
        transaction_id
        account_holder_name
        account_number
        bank_name
        ifsc_code
        mode_of_payment
        transaction_date
        attachments {
          id
          media {
            id
            url
            kind
          }
        }
      }
      attachments {
        id
        media {
          id
          url
        }
      }
    }
    previous_agreements: storage_location_agreements(
      where: {is_active: {_eq: false}, is_verified: {_eq: true}}
      order_by: {end_date: desc}
    ) {
      id
      name
      ownership_kind
      lease_amount
      lease_tenure_kind
      expiry_alert_days
      is_verified
      start_date
      is_active
      end_date
      tnc
      agreement_no
      description
      agreement_transactions {
        id
        amount
        transaction_id
        account_holder_name
        account_number
        bank_name
        ifsc_code
        mode_of_payment
        transaction_date
        attachments {
          id
          media {
            id
            url
            kind
          }
        }
      }
      attachments {
        id
        media {
          id
          url
        }
      }
    }
  }
}
    `;

export function useStorageLocationDetailQuery(options: Omit<Urql.UseQueryArgs<StorageLocationDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<StorageLocationDetailQuery, StorageLocationDetailQueryVariables>({ query: StorageLocationDetailDocument, ...options });
};
export const CreateExpensesTemplatesDocument = gql`
    mutation CreateExpensesTemplates($department: Int!, $kind: String!, $mode: String!, $expenses: [ExpensesConfigSchema]!) {
  create_expenses_config(
    department_id: $department
    trade_kind: $kind
    trade_mode: $mode
    expenses_config: $expenses
  ) {
    version
    department_id
    trade_kind
    trade_mode
    expenses_details {
      expense_parameter
      kind
      buyer_charge
      seller_charge
    }
  }
}
    `;

export function useCreateExpensesTemplatesMutation() {
  return Urql.useMutation<CreateExpensesTemplatesMutation, CreateExpensesTemplatesMutationVariables>(CreateExpensesTemplatesDocument);
};
export const CreateTnCsConfigDocument = gql`
    mutation CreateTNCsConfig($department: Int!, $kind: String!, $mode: String!, $terms: String!, $party: String!) {
  create_tnc_config(
    conditions: $terms
    trade_party: $party
    department_id: $department
    trade_kind: $kind
    trade_mode: $mode
  ) {
    version
    trade_party
    conditions
  }
}
    `;

export function useCreateTnCsConfigMutation() {
  return Urql.useMutation<CreateTnCsConfigMutation, CreateTnCsConfigMutationVariables>(CreateTnCsConfigDocument);
};
export const TemplateSelectorDocument = gql`
    query TemplateSelector($distinct_on: [template_select_column!], $limit: Int, $offset: Int, $order_by: [template_order_by!], $where: template_bool_exp) {
  template(
    distinct_on: $distinct_on
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    name
  }
}
    `;

export function useTemplateSelectorQuery(options?: Omit<Urql.UseQueryArgs<TemplateSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<TemplateSelectorQuery, TemplateSelectorQueryVariables>({ query: TemplateSelectorDocument, ...options });
};
export const TimelineDocument = gql`
    query Timeline($tradeId: bigint!) {
  trade_by_pk(id: $tradeId) {
    id
    action_logs {
      id
      created_at
      change_object
      change_message
      change_title
      created_by {
        id
        full_name
      }
    }
    tracking_code
    seller {
      id
      user {
        id
        full_name
        current_address {
          id
          village
        }
      }
    }
    buyer {
      id
      user {
        id
        full_name
        current_address {
          id
          village
        }
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    total_amount
  }
}
    `;

export function useTimelineQuery(options: Omit<Urql.UseQueryArgs<TimelineQueryVariables>, 'query'>) {
  return Urql.useQuery<TimelineQuery, TimelineQueryVariables>({ query: TimelineDocument, ...options });
};
export const TradeTimeLineDocument = gql`
    query TradeTimeLine($tradeId: ID, $productionTradeId: ID) {
  trade_timeline(trade_id: $tradeId, production_trade_id: $productionTradeId) {
    sequence
    title
    msg
    date
    parent_trade_id
    is_current
    parent_trade_title
  }
}
    `;

export function useTradeTimeLineQuery(options?: Omit<Urql.UseQueryArgs<TradeTimeLineQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeTimeLineQuery, TradeTimeLineQueryVariables>({ query: TradeTimeLineDocument, ...options });
};
export const TradeHashesDocument = gql`
    query TradeHashes($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    seller_hash
    buyer_hash
  }
}
    `;

export function useTradeHashesQuery(options: Omit<Urql.UseQueryArgs<TradeHashesQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeHashesQuery, TradeHashesQueryVariables>({ query: TradeHashesDocument, ...options });
};
export const TradesHashesDocument = gql`
    query TradesHashes($ids: [bigint!]!) {
  trade(where: {id: {_in: $ids}}) {
    id
    seller_hash
    buyer_hash
  }
}
    `;

export function useTradesHashesQuery(options: Omit<Urql.UseQueryArgs<TradesHashesQueryVariables>, 'query'>) {
  return Urql.useQuery<TradesHashesQuery, TradesHashesQueryVariables>({ query: TradesHashesDocument, ...options });
};
export const AllTradeRequestsIdsDocument = gql`
    query AllTradeRequestsIds($where: trade_bool_exp, $limit: Int, $offset: Int, $order_by: [trade_order_by!]) {
  trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    kind
    current_status_id
    department {
      id
      name
      reference_id
    }
  }
}
    `;

export function useAllTradeRequestsIdsQuery(options?: Omit<Urql.UseQueryArgs<AllTradeRequestsIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTradeRequestsIdsQuery, AllTradeRequestsIdsQueryVariables>({ query: AllTradeRequestsIdsDocument, ...options });
};
export const AllTradeRequestsDocument = gql`
    query AllTradeRequests($where: trade_bool_exp, $limit: Int, $offset: Int, $order_by: [trade_order_by!]) {
  trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    advance_po
    status_processing
    action_logs(where: {change_message: {_ilike: "Trade Confirmed"}}) {
      id
      change_message
      created_by {
        full_name
      }
    }
    credit: issuance_notes(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "CREDIT"}}
      limit: 1
    ) {
      id
      is_verified
    }
    debit: issuance_notes(
      order_by: {created_at: desc_nulls_last}
      where: {type: {_eq: "DEBIT"}}
      limit: 1
    ) {
      id
      is_verified
    }
    over_draft {
      id
      amount
    }
    department {
      id
      name
      reference_id
    }
    receipt_id
    trip {
      id
    }
    invoice {
      id
      current_status_id
    }
    parent_trade {
      id
      demand_id
      offer_id
    }
    tracking_code
    created_at
    kind
    is_multiple_commodity
    seller_verification
    buyer_verification
    total_amount
    total_quantity
    deducted_amount
    deducted_quantity
    deducted_quantity_remaining
    expense_amount
    standard_deduction
    seller {
      id
      user {
        id
        full_name
        number
        is_blocked
        external_reference_id
        current_address {
          id
          village
        }
      }
    }
    trades_aggregate {
      aggregate {
        sum {
          total_quantity
        }
      }
    }
    buyer {
      id
      user {
        id
        is_blocked
        full_name
        external_reference_id
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    item_units: trade_items(limit: 1) {
      id
      quantity_unit {
        id
        name
        reference_id
      }
      rate_unit {
        id
        name
        reference_id
      }
    }
    trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
      id
      rate
      commodity {
        id
        name
      }
      commodity_variety {
        id
        name
      }
      variety_grade {
        id
        name
      }
      quantity
      quantity_unit {
        id
        name
      }
      rate_unit {
        id
        name
      }
      amount
    }
    trade_items_aggregate {
      aggregate {
        sum {
          quantity
          returned_quantity
        }
        avg {
          rate
        }
      }
    }
    total_amount
    created_by {
      id
      full_name
      photo {
        id
        url
      }
    }
    current_status_id
    updated_at
  }
  trade_statuses: trade_aggregate(where: $where, distinct_on: [current_status_id]) {
    aggregate {
      count
      min {
        current_status_id
      }
    }
  }
  trade_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllTradeRequestsQuery(options?: Omit<Urql.UseQueryArgs<AllTradeRequestsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTradeRequestsQuery, AllTradeRequestsQueryVariables>({ query: AllTradeRequestsDocument, ...options });
};
export const TradeListSelectorDocument = gql`
    query TradeListSelector($where: trade_bool_exp, $limit: Int, $offset: Int, $order_by: [trade_order_by!]) {
  trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    advance_po
    status_processing
    department {
      id
      name
      reference_id
    }
    buyer_bifurcation {
      deducted_amount {
        op
        val
      }
      buyer_expense_amount {
        op
        val
      }
      buyer_expense_tax_amount {
        op
        val
      }
      buyer_debit_note_amount {
        op
        val
      }
      buyer_credit_note_amount {
        op
        val
      }
      buyer_tax_amount {
        op
        val
      }
      received_amount {
        op
        val
      }
      total
    }
    total_amount
    total_quantity
    deducted_amount
    deducted_quantity
    deducted_quantity_remaining
    expense_amount
    standard_deduction
    supplier_charge
    seller {
      id
      user {
        id
        full_name
        number
        is_blocked
        external_reference_id
      }
    }
    buyer {
      id
      user {
        id
        is_blocked
        full_name
        external_reference_id
      }
    }
    item_units: trade_items(limit: 1) {
      id
      quantity_unit {
        id
        name
        reference_id
      }
      rate_unit {
        id
        name
        reference_id
      }
    }
    trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
      id
      rate
      commodity {
        id
        name
      }
      commodity_variety {
        id
        name
      }
      variety_grade {
        id
        name
      }
      quantity
      amount
      taxes(where: {role: {_eq: "buyer"}}) {
        id
        amount
        percentage
        role
        tax_name
      }
    }
    total_amount
    current_status_id
    updated_at
  }
}
    `;

export function useTradeListSelectorQuery(options?: Omit<Urql.UseQueryArgs<TradeListSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeListSelectorQuery, TradeListSelectorQueryVariables>({ query: TradeListSelectorDocument, ...options });
};
export const AllTradeRequestsStatusDocument = gql`
    subscription AllTradeRequestsStatus($where: trade_bool_exp, $limit: Int, $offset: Int, $order_by: [trade_order_by!]) {
  trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    current_status_id
    status_processing
  }
}
    `;

export function useAllTradeRequestsStatusSubscription<TData = AllTradeRequestsStatusSubscription>(options: Omit<Urql.UseSubscriptionArgs<AllTradeRequestsStatusSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<AllTradeRequestsStatusSubscription, TData>) {
  return Urql.useSubscription<AllTradeRequestsStatusSubscription, TData, AllTradeRequestsStatusSubscriptionVariables>({ query: AllTradeRequestsStatusDocument, ...options }, handler);
};
export const UpsertTradeDocument = gql`
    mutation UpsertTrade($input: TradeInput!) {
  add_update_trade(input: $input) {
    trade {
      id
    }
  }
}
    `;

export function useUpsertTradeMutation() {
  return Urql.useMutation<UpsertTradeMutation, UpsertTradeMutationVariables>(UpsertTradeDocument);
};
export const UpdateTradeAttachmentsDocument = gql`
    mutation UpdateTradeAttachments($input: trade_insert_input!) {
  insert_trade_one(
    object: $input
    on_conflict: {constraint: trade_pkey, update_columns: [packaging]}
  ) {
    id
  }
}
    `;

export function useUpdateTradeAttachmentsMutation() {
  return Urql.useMutation<UpdateTradeAttachmentsMutation, UpdateTradeAttachmentsMutationVariables>(UpdateTradeAttachmentsDocument);
};
export const BroadcastConsentDocument = gql`
    mutation BroadcastConsent($trade_id: ID!, $send_to_buyer: Boolean, $send_to_seller: Boolean) {
  broadcast_consents(
    trade_id: $trade_id
    send_to_buyer: $send_to_buyer
    send_to_seller: $send_to_seller
  ) {
    buyer_status
    seller_status
  }
}
    `;

export function useBroadcastConsentMutation() {
  return Urql.useMutation<BroadcastConsentMutation, BroadcastConsentMutationVariables>(BroadcastConsentDocument);
};
export const TradeDetailDocument = gql`
    query TradeDetail($id: bigint!) {
  trade_by_pk(id: $id) {
    ...TradeDetailFrag
  }
}
    ${TradeDetailFragFragmentDoc}`;

export function useTradeDetailQuery(options: Omit<Urql.UseQueryArgs<TradeDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeDetailQuery, TradeDetailQueryVariables>({ query: TradeDetailDocument, ...options });
};
export const UpdateTradeDocument = gql`
    mutation UpdateTrade($id: bigint!, $_set: trade_set_input) {
  update_trade_by_pk(pk_columns: {id: $id}, _set: $_set) {
    ...TradeDetailFrag
  }
}
    ${TradeDetailFragFragmentDoc}`;

export function useUpdateTradeMutation() {
  return Urql.useMutation<UpdateTradeMutation, UpdateTradeMutationVariables>(UpdateTradeDocument);
};
export const IncrementTradeCounterDocument = gql`
    mutation IncrementTradeCounter($id: bigint!) {
  update_trade_by_pk(pk_columns: {id: $id}, _inc: {trade_amounts_counter: 1}) {
    id
    trade_amounts_counter
  }
}
    `;

export function useIncrementTradeCounterMutation() {
  return Urql.useMutation<IncrementTradeCounterMutation, IncrementTradeCounterMutationVariables>(IncrementTradeCounterDocument);
};
export const FinalTradeListDocument = gql`
    query FinalTradeList($parentId: bigint) {
  trade(
    where: {parent_trade_id: {_eq: $parentId}}
    order_by: {created_at: desc_nulls_last}
  ) {
    id
    kind
    parent_trade {
      id
      kind
      start_date
      demand_id
      offer_id
    }
    start_date
    demand_id
    offer_id
    trades {
      id
      kind
      start_date
    }
  }
}
    `;

export function useFinalTradeListQuery(options?: Omit<Urql.UseQueryArgs<FinalTradeListQueryVariables>, 'query'>) {
  return Urql.useQuery<FinalTradeListQuery, FinalTradeListQueryVariables>({ query: FinalTradeListDocument, ...options });
};
export const BulkUpdateTradeDocument = gql`
    mutation BulkUpdateTrade($where: trade_bool_exp!, $set: trade_set_input!) {
  update_trade(where: $where, _set: $set) {
    returning {
      id
      current_status_id
      status_processing
    }
    affected_rows
  }
}
    `;

export function useBulkUpdateTradeMutation() {
  return Urql.useMutation<BulkUpdateTradeMutation, BulkUpdateTradeMutationVariables>(BulkUpdateTradeDocument);
};
export const TradeAdvancePendingStatusDocument = gql`
    query TradeAdvancePendingStatus($ids: [bigint!]!) {
  trade(where: {id: {_in: $ids}}) {
    id
    current_status_id
    advance_payments {
      id
      is_verified
    }
  }
}
    `;

export function useTradeAdvancePendingStatusQuery(options: Omit<Urql.UseQueryArgs<TradeAdvancePendingStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeAdvancePendingStatusQuery, TradeAdvancePendingStatusQueryVariables>({ query: TradeAdvancePendingStatusDocument, ...options });
};
export const BookingTradeSummaryDocument = gql`
    query BookingTradeSummary($id: Int!) {
  trade_grade_quantity_summary_report(trade_id: $id) {
    more_trade
    grade_summary {
      variety_grade_id
      remaining_quantity
      booked_quantity
      variety_grade_name
    }
  }
}
    `;

export function useBookingTradeSummaryQuery(options: Omit<Urql.UseQueryArgs<BookingTradeSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<BookingTradeSummaryQuery, BookingTradeSummaryQueryVariables>({ query: BookingTradeSummaryDocument, ...options });
};
export const ExpenseConfigVersionsDocument = gql`
    query ExpenseConfigVersions($department: ID, $kind: String!, $mode: String!) {
  expense_config_versions(department: $department, kind: $kind, mode: $mode) {
    version_id
    name
    kind
    mode
  }
}
    `;

export function useExpenseConfigVersionsQuery(options: Omit<Urql.UseQueryArgs<ExpenseConfigVersionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseConfigVersionsQuery, ExpenseConfigVersionsQueryVariables>({ query: ExpenseConfigVersionsDocument, ...options });
};
export const AdancedPaymentParametersDocument = gql`
    query AdancedPaymentParameters {
  advance_payment_parameters {
    id
    name
  }
}
    `;

export function useAdancedPaymentParametersQuery(options?: Omit<Urql.UseQueryArgs<AdancedPaymentParametersQueryVariables>, 'query'>) {
  return Urql.useQuery<AdancedPaymentParametersQuery, AdancedPaymentParametersQueryVariables>({ query: AdancedPaymentParametersDocument, ...options });
};
export const ExpenseConfigsDocument = gql`
    query ExpenseConfigs($version: ID, $department: ID!, $kind: String!, $mode: String!) {
  expense_configs(
    version: $version
    department: $department
    kind: $kind
    mode: $mode
  ) {
    id
    paid_by
    expense_parameter {
      id
      name
    }
    kind
    value
  }
}
    `;

export function useExpenseConfigsQuery(options: Omit<Urql.UseQueryArgs<ExpenseConfigsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseConfigsQuery, ExpenseConfigsQueryVariables>({ query: ExpenseConfigsDocument, ...options });
};
export const GradeQuantitySummaryDocument = gql`
    query GradeQuantitySummary($id: bigint, $grade: String) {
  booked_quantity: trade_item_aggregate(
    where: {trade: {parent_trade_id: {_eq: $id}}, variety_grade: {codename: {_eq: $grade}}}
  ) {
    aggregate {
      sum {
        quantity
      }
    }
  }
  total_quantity: trade_item_aggregate(where: {trade_id: {_eq: 1182}}) {
    aggregate {
      sum {
        quantity
      }
    }
  }
}
    `;

export function useGradeQuantitySummaryQuery(options?: Omit<Urql.UseQueryArgs<GradeQuantitySummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<GradeQuantitySummaryQuery, GradeQuantitySummaryQueryVariables>({ query: GradeQuantitySummaryDocument, ...options });
};
export const TradeSelectorDocument = gql`
    query TradeSelector($where: trade_bool_exp, $limit: Int, $offset: Int, $order_by: [trade_order_by!]) {
  trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    created_at
    kind
    total_amount
    total_quantity
    deducted_amount
    deducted_quantity
    expense_amount
    standard_deduction
    deducted_quantity_remaining
    trades_aggregate {
      aggregate {
        sum {
          total_quantity
        }
      }
    }
    buyer {
      id
      user {
        id
        is_blocked
        full_name
        external_reference_id
      }
    }
    seller {
      id
      user {
        id
        is_blocked
        full_name
        external_reference_id
      }
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    item_units: trade_items(limit: 1) {
      id
      quantity_unit {
        id
        name
        reference_id
      }
      rate_unit {
        id
        name
        reference_id
      }
    }
    trade_items(order_by: {variety_grade: {name: asc_nulls_last}}) {
      id
      rate
      variety_grade {
        id
        name
      }
      quantity
      amount
    }
    trade_items_aggregate {
      aggregate {
        sum {
          quantity
        }
        avg {
          rate
        }
      }
    }
    total_amount
    updated_at
  }
  trade_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useTradeSelectorQuery(options?: Omit<Urql.UseQueryArgs<TradeSelectorQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeSelectorQuery, TradeSelectorQueryVariables>({ query: TradeSelectorDocument, ...options });
};
export const DeleteSellerGstAttachmentsDocument = gql`
    mutation DeleteSellerGstAttachments($media_id: [bigint!]!, $id: Int!) {
  delete_trade_seller_gst_attachments(where: {id: {_in: $media_id}}) {
    returning {
      id
    }
  }
  delete_media_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteSellerGstAttachmentsMutation() {
  return Urql.useMutation<DeleteSellerGstAttachmentsMutation, DeleteSellerGstAttachmentsMutationVariables>(DeleteSellerGstAttachmentsDocument);
};
export const DeleteBuyerGstAttachmentsDocument = gql`
    mutation DeleteBuyerGstAttachments($media_id: [bigint!]!, $id: Int!) {
  delete_trade_buyer_gst_attachments(where: {id: {_in: $media_id}}) {
    returning {
      id
    }
  }
  delete_media_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteBuyerGstAttachmentsMutation() {
  return Urql.useMutation<DeleteBuyerGstAttachmentsMutation, DeleteBuyerGstAttachmentsMutationVariables>(DeleteBuyerGstAttachmentsDocument);
};
export const TradeStatusesDocument = gql`
    query TradeStatuses($where: trade_status_bool_exp) {
  trade_status(order_by: {sequence_no: asc}, where: $where) {
    id
    category
  }
}
    `;

export function useTradeStatusesQuery(options?: Omit<Urql.UseQueryArgs<TradeStatusesQueryVariables>, 'query'>) {
  return Urql.useQuery<TradeStatusesQuery, TradeStatusesQueryVariables>({ query: TradeStatusesDocument, ...options });
};
export const TncConfigVersionsDocument = gql`
    query TncConfigVersions($department: ID, $kind: String!, $mode: String!, $role: String) {
  trade_tnc_versions(
    department: $department
    kind: $kind
    mode: $mode
    role: $role
  ) {
    id: version_id
    name
    kind
    mode
    role
  }
}
    `;

export function useTncConfigVersionsQuery(options: Omit<Urql.UseQueryArgs<TncConfigVersionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TncConfigVersionsQuery, TncConfigVersionsQueryVariables>({ query: TncConfigVersionsDocument, ...options });
};
export const TncConfigsDocument = gql`
    query TncConfigs($version: ID!, $department: ID!, $kind: String!, $mode: String!, $role: String) {
  trade_tnc_template_detail(
    version: $version
    department: $department
    kind: $kind
    mode: $mode
    role: $role
  ) {
    seller
    buyer
  }
}
    `;

export function useTncConfigsQuery(options: Omit<Urql.UseQueryArgs<TncConfigsQueryVariables>, 'query'>) {
  return Urql.useQuery<TncConfigsQuery, TncConfigsQueryVariables>({ query: TncConfigsDocument, ...options });
};
export const InsertTransactionDocument = gql`
    mutation InsertTransaction($object: transaction_insert_input!, $onConflict: transaction_on_conflict) {
  insert_transaction_one(object: $object, on_conflict: $onConflict) {
    id
    amount
    trade_id
    mode_id
    transaction_id
    bank_id
  }
}
    `;

export function useInsertTransactionMutation() {
  return Urql.useMutation<InsertTransactionMutation, InsertTransactionMutationVariables>(InsertTransactionDocument);
};
export const TransactionDetailDocument = gql`
    query TransactionDetail($id: bigint!) {
  transaction_by_pk(id: $id) {
    id
    created_at
    trade {
      id
      kind
    }
    advance_payment {
      parameter {
        name
      }
    }
    date
    amount
    mode {
      name
    }
    transaction_id
    account_no
    amount
  }
}
    `;

export function useTransactionDetailQuery(options: Omit<Urql.UseQueryArgs<TransactionDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<TransactionDetailQuery, TransactionDetailQueryVariables>({ query: TransactionDetailDocument, ...options });
};
export const AllTripsDocument = gql`
    query AllTrips($where: setutrade_trip_bool_exp, $limit: Int, $offset: Int, $orderBy: [setutrade_trip_order_by!]) {
  setutrade_trip(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    created_at
    id
    vehicle {
      id
      name
    }
    aggregator_name
    aggregator_number
    driver_name
    driver_number
    source_location_name
    destination_location_name
    estimated_date
    created_by {
      id
      full_name
    }
    status
    trades {
      id
      deducted_quantity
      commodity {
        id
        name
      }
      deducted_amount
      buyer_payable
      buyer {
        id
        user {
          id
          reference_id
          full_name
          external_reference_id2
        }
      }
    }
  }
  setutrade_trip_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllTripsQuery(options?: Omit<Urql.UseQueryArgs<AllTripsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTripsQuery, AllTripsQueryVariables>({ query: AllTripsDocument, ...options });
};
export const AddUpdateSetutradeTripDocument = gql`
    mutation AddUpdateSetutradeTrip($input: TradeTripMutationInput) {
  add_update_setutrade_trip(input: $input) {
    trip {
      id
      trades {
        id
      }
    }
  }
}
    `;

export function useAddUpdateSetutradeTripMutation() {
  return Urql.useMutation<AddUpdateSetutradeTripMutation, AddUpdateSetutradeTripMutationVariables>(AddUpdateSetutradeTripDocument);
};
export const TripTraderSummaryDocument = gql`
    query TripTraderSummary($id: ID) {
  trip_trader_summary(trip_id: $id) {
    trader {
      id
      name
    }
    commodities {
      id
      name
    }
    commodity_varieties {
      id
      name
    }
    trade_count
    buyer_payable
  }
}
    `;

export function useTripTraderSummaryQuery(options?: Omit<Urql.UseQueryArgs<TripTraderSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<TripTraderSummaryQuery, TripTraderSummaryQueryVariables>({ query: TripTraderSummaryDocument, ...options });
};
export const TripDetailDocument = gql`
    query TripDetail($id: Int!) {
  setutrade_trip_by_pk(id: $id) {
    created_at
    id
    vehicle {
      id
      name
    }
    aggregator_name
    aggregator_number
    driver_name
    driver_number
    source_location_name
    destination_location_name
    estimated_date
    created_by {
      id
      full_name
    }
    status
    trades {
      id
      buyer_payable
      deducted_amount
      deducted_quantity
    }
  }
}
    `;

export function useTripDetailQuery(options: Omit<Urql.UseQueryArgs<TripDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<TripDetailQuery, TripDetailQueryVariables>({ query: TripDetailDocument, ...options });
};
export const UpdateTripDocument = gql`
    mutation UpdateTrip($set: setutrade_trip_set_input, $where: setutrade_trip_bool_exp!) {
  update_setutrade_trip(_set: $set, where: $where) {
    returning {
      id
      status
    }
  }
}
    `;

export function useUpdateTripMutation() {
  return Urql.useMutation<UpdateTripMutation, UpdateTripMutationVariables>(UpdateTripDocument);
};
export const AddSfCodeDocument = gql`
    mutation AddSFCode($id: bigint!, $baseUserEntityId: bigint!) {
  update_unregistered_user_by_pk(
    pk_columns: {id: $id}
    _set: {user_entity_id: $baseUserEntityId}
  ) {
    id
  }
}
    `;

export function useAddSfCodeMutation() {
  return Urql.useMutation<AddSfCodeMutation, AddSfCodeMutationVariables>(AddSfCodeDocument);
};
export const AllUnRegisteredUsersDocument = gql`
    query AllUnRegisteredUsers {
  unregistered_user {
    id
    first_name
    last_name
    number
    __typename
  }
}
    `;

export function useAllUnRegisteredUsersQuery(options?: Omit<Urql.UseQueryArgs<AllUnRegisteredUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<AllUnRegisteredUsersQuery, AllUnRegisteredUsersQueryVariables>({ query: AllUnRegisteredUsersDocument, ...options });
};
export const AllUploaderListDocument = gql`
    query AllUploaderList($where: django_celery_results_taskresult_bool_exp, $limit: Int, $offset: Int, $orderBy: [django_celery_results_taskresult_order_by!]) {
  django_celery_results_taskresult(
    where: $where
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    task_id
    task_name
    periodic_task_name
    task_kwargs
    result
    date_created
    date_done
  }
  django_celery_results_taskresult_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

export function useAllUploaderListQuery(options?: Omit<Urql.UseQueryArgs<AllUploaderListQueryVariables>, 'query'>) {
  return Urql.useQuery<AllUploaderListQuery, AllUploaderListQueryVariables>({ query: AllUploaderListDocument, ...options });
};
export const UploaderDetailDocument = gql`
    query UploaderDetail($id: Int!) {
  django_celery_results_taskresult_by_pk(id: $id) {
    id
    task_id
    task_name
    periodic_task_name
    task_kwargs
    result
    date_created
    date_done
  }
}
    `;

export function useUploaderDetailQuery(options: Omit<Urql.UseQueryArgs<UploaderDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<UploaderDetailQuery, UploaderDetailQueryVariables>({ query: UploaderDetailDocument, ...options });
};
export const AllVehiclesDocument = gql`
    query AllVehicles($filter: VehicleGlInput, $first: Int, $query: String, $skip: Int) {
  all_vehicles(filter: $filter, first: $first, query: $query, skip: $skip) {
    id
    name: registration_number
    codename: registration_number
    vehicle_type {
      id
      name
    }
  }
}
    `;

export function useAllVehiclesQuery(options?: Omit<Urql.UseQueryArgs<AllVehiclesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllVehiclesQuery, AllVehiclesQueryVariables>({ query: AllVehiclesDocument, ...options });
};
export const VehicleDetailDocument = gql`
    query VehicleDetail($id: ID!) {
  vehicle_detail(id: $id) {
    id
    driver {
      id
      full_name
      number
    }
    owner {
      id
      full_name
      number
    }
    registration_number
  }
}
    `;

export function useVehicleDetailQuery(options: Omit<Urql.UseQueryArgs<VehicleDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<VehicleDetailQuery, VehicleDetailQueryVariables>({ query: VehicleDetailDocument, ...options });
};
export const PavtiTradeDetailDocument = gql`
    query PavtiTradeDetail($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    created_at
    tracking_code
    kind
    buyer_verification
    seller_verification
    created_by {
      full_name
      number
    }
    facilitator {
      name
    }
    plot_crop {
      id
      name
      plot_crop {
        id
        plot {
          id
          field {
            id
            address {
              id
              raw_address
            }
          }
        }
      }
    }
    seller {
      id
      name
    }
    buyer {
      id
      name
    }
    commodity {
      id
      name
    }
    commodity_variety {
      id
      name
    }
    packaging
    trade_items {
      id
      currency {
        id
        name
      }
      variety_grade {
        id
        name
      }
      quantity
      quantity_unit {
        id
        name
      }
      rate
      rate_unit {
        id
        name
      }
      amount
    }
    trade_items_aggregate {
      aggregate {
        sum {
          quantity
        }
      }
    }
    standard_deduction
    total_amount
    buyer_expenses: expenses_aggregate(where: {paid_by: {_eq: "buyer"}}) {
      aggregate {
        sum {
          amount
        }
      }
      nodes {
        expense_parameter {
          id
          name
        }
        kind
        value
        amount
      }
    }
    seller_expenses: expenses_aggregate(where: {paid_by: {_eq: "seller"}}) {
      aggregate {
        sum {
          amount
        }
      }
      nodes {
        expense_parameter {
          id
          name
        }
        kind
        value
        amount
      }
    }
    start_date
    end_date
    expiry
    seller_tnc
    buyer_tnc
  }
}
    `;

export function usePavtiTradeDetailQuery(options: Omit<Urql.UseQueryArgs<PavtiTradeDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<PavtiTradeDetailQuery, PavtiTradeDetailQueryVariables>({ query: PavtiTradeDetailDocument, ...options });
};
export const TradeDetailsDocument = gql`
    subscription TradeDetails($id: bigint!) {
  trade_by_pk(id: $id) {
    id
    seller_verification
    seller_remark
    buyer_verification
    buyer_remark
  }
}
    `;

export function useTradeDetailsSubscription<TData = TradeDetailsSubscription>(options: Omit<Urql.UseSubscriptionArgs<TradeDetailsSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<TradeDetailsSubscription, TData>) {
  return Urql.useSubscription<TradeDetailsSubscription, TData, TradeDetailsSubscriptionVariables>({ query: TradeDetailsDocument, ...options }, handler);
};
export const UpdateTradeVerificationDocument = gql`
    mutation UpdateTradeVerification($id: bigint!, $set: trade_set_input) {
  update_trade_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;

export function useUpdateTradeVerificationMutation() {
  return Urql.useMutation<UpdateTradeVerificationMutation, UpdateTradeVerificationMutationVariables>(UpdateTradeVerificationDocument);
};
export const GenerateTradeOtpDocument = gql`
    mutation GenerateTradeOTP($token: String!) {
  generate_trade_otp(token: $token) {
    status
  }
}
    `;

export function useGenerateTradeOtpMutation() {
  return Urql.useMutation<GenerateTradeOtpMutation, GenerateTradeOtpMutationVariables>(GenerateTradeOtpDocument);
};
export const VerifyTradeOtpDocument = gql`
    mutation VerifyTradeOTP($token: String!, $otp: String!) {
  verify_trade_otp(otp: $otp, token: $token) {
    token
    refresh_token
    refresh_expires_in
    payload
  }
}
    `;

export function useVerifyTradeOtpMutation() {
  return Urql.useMutation<VerifyTradeOtpMutation, VerifyTradeOtpMutationVariables>(VerifyTradeOtpDocument);
};